import * as React from "react";
import React__default, { useContext, useMemo as useMemo$1, forwardRef, Component, createContext, useState, Suspense, memo, useRef, useCallback, useEffect, Fragment, PureComponent, lazy, useId, isValidElement, useLayoutEffect as useLayoutEffect$1, createElement, Children, Profiler as Profiler$1, version, createRef, useSyncExternalStore, cloneElement } from "react";
import ReactDOM, { unstable_batchedUpdates, flushSync } from "react-dom";
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
function getAugmentedNamespace(o) {
  if (Object.prototype.hasOwnProperty.call(o, "__esModule")) return o;
  var i = o.default;
  if (typeof i == "function") {
    var g = function E() {
      var e = !1;
      try {
        e = this instanceof E;
      } catch {
      }
      return e ? Reflect.construct(i, arguments, this.constructor) : i.apply(this, arguments);
    };
    g.prototype = i.prototype;
  } else g = {};
  return Object.defineProperty(g, "__esModule", { value: !0 }), Object.keys(o).forEach(function(E) {
    var e = Object.getOwnPropertyDescriptor(o, E);
    Object.defineProperty(g, E, e.get ? e : {
      enumerable: !0,
      get: function() {
        return o[E];
      }
    });
  }), g;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var o = React__default, i = Symbol.for("react.element"), g = Symbol.for("react.fragment"), E = Object.prototype.hasOwnProperty, e = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, t = { key: !0, ref: !0, __self: !0, __source: !0 };
  function n(h, d, k) {
    var p, M = {}, H = null, f = null;
    k !== void 0 && (H = "" + k), d.key !== void 0 && (H = "" + d.key), d.ref !== void 0 && (f = d.ref);
    for (p in d) E.call(d, p) && !t.hasOwnProperty(p) && (M[p] = d[p]);
    if (h && h.defaultProps) for (p in d = h.defaultProps, d) M[p] === void 0 && (M[p] = d[p]);
    return { $$typeof: i, type: h, key: H, ref: f, props: M, _owner: e.current };
  }
  return reactJsxRuntime_production_min.Fragment = g, reactJsxRuntime_production_min.jsx = n, reactJsxRuntime_production_min.jsxs = n, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var o = React__default, i = Symbol.for("react.element"), g = Symbol.for("react.portal"), E = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), t = Symbol.for("react.profiler"), n = Symbol.for("react.provider"), h = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), k = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), M = Symbol.for("react.memo"), H = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), AA = Symbol.iterator, gA = "@@iterator";
    function IA(hA) {
      if (hA === null || typeof hA != "object")
        return null;
      var UA = AA && hA[AA] || hA[gA];
      return typeof UA == "function" ? UA : null;
    }
    var BA = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function CA(hA) {
      {
        for (var UA = arguments.length, jA = new Array(UA > 1 ? UA - 1 : 0), Ag = 1; Ag < UA; Ag++)
          jA[Ag - 1] = arguments[Ag];
        QA("error", hA, jA);
      }
    }
    function QA(hA, UA, jA) {
      {
        var Ag = BA.ReactDebugCurrentFrame, lg = Ag.getStackAddendum();
        lg !== "" && (UA += "%s", jA = jA.concat([lg]));
        var Dg = jA.map(function(og) {
          return String(og);
        });
        Dg.unshift("Warning: " + UA), Function.prototype.apply.call(console[hA], console, Dg);
      }
    }
    var iA = !1, EA = !1, oA = !1, eA = !1, GA = !1, cA;
    cA = Symbol.for("react.module.reference");
    function tA(hA) {
      return !!(typeof hA == "string" || typeof hA == "function" || hA === E || hA === t || GA || hA === e || hA === k || hA === p || eA || hA === f || iA || EA || oA || typeof hA == "object" && hA !== null && (hA.$$typeof === H || hA.$$typeof === M || hA.$$typeof === n || hA.$$typeof === h || hA.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      hA.$$typeof === cA || hA.getModuleId !== void 0));
    }
    function aA(hA, UA, jA) {
      var Ag = hA.displayName;
      if (Ag)
        return Ag;
      var lg = UA.displayName || UA.name || "";
      return lg !== "" ? jA + "(" + lg + ")" : jA;
    }
    function sA(hA) {
      return hA.displayName || "Context";
    }
    function DA(hA) {
      if (hA == null)
        return null;
      if (typeof hA.tag == "number" && CA("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof hA == "function")
        return hA.displayName || hA.name || null;
      if (typeof hA == "string")
        return hA;
      switch (hA) {
        case E:
          return "Fragment";
        case g:
          return "Portal";
        case t:
          return "Profiler";
        case e:
          return "StrictMode";
        case k:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof hA == "object")
        switch (hA.$$typeof) {
          case h:
            var UA = hA;
            return sA(UA) + ".Consumer";
          case n:
            var jA = hA;
            return sA(jA._context) + ".Provider";
          case d:
            return aA(hA, hA.render, "ForwardRef");
          case M:
            var Ag = hA.displayName || null;
            return Ag !== null ? Ag : DA(hA.type) || "Memo";
          case H: {
            var lg = hA, Dg = lg._payload, og = lg._init;
            try {
              return DA(og(Dg));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var rA = Object.assign, nA = 0, NA, pA, mA, XA, lA, kA, ZA;
    function wA() {
    }
    wA.__reactDisabledLog = !0;
    function LA() {
      {
        if (nA === 0) {
          NA = console.log, pA = console.info, mA = console.warn, XA = console.error, lA = console.group, kA = console.groupCollapsed, ZA = console.groupEnd;
          var hA = {
            configurable: !0,
            enumerable: !0,
            value: wA,
            writable: !0
          };
          Object.defineProperties(console, {
            info: hA,
            log: hA,
            warn: hA,
            error: hA,
            group: hA,
            groupCollapsed: hA,
            groupEnd: hA
          });
        }
        nA++;
      }
    }
    function fA() {
      {
        if (nA--, nA === 0) {
          var hA = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: rA({}, hA, {
              value: NA
            }),
            info: rA({}, hA, {
              value: pA
            }),
            warn: rA({}, hA, {
              value: mA
            }),
            error: rA({}, hA, {
              value: XA
            }),
            group: rA({}, hA, {
              value: lA
            }),
            groupCollapsed: rA({}, hA, {
              value: kA
            }),
            groupEnd: rA({}, hA, {
              value: ZA
            })
          });
        }
        nA < 0 && CA("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var dA = BA.ReactCurrentDispatcher, RA;
    function KA(hA, UA, jA) {
      {
        if (RA === void 0)
          try {
            throw Error();
          } catch (lg) {
            var Ag = lg.stack.trim().match(/\n( *(at )?)/);
            RA = Ag && Ag[1] || "";
          }
        return `
` + RA + hA;
      }
    }
    var xA = !1, MA;
    {
      var OA = typeof WeakMap == "function" ? WeakMap : Map;
      MA = new OA();
    }
    function SA(hA, UA) {
      if (!hA || xA)
        return "";
      {
        var jA = MA.get(hA);
        if (jA !== void 0)
          return jA;
      }
      var Ag;
      xA = !0;
      var lg = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Dg;
      Dg = dA.current, dA.current = null, LA();
      try {
        if (UA) {
          var og = function() {
            throw Error();
          };
          if (Object.defineProperty(og.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(og, []);
            } catch (bg) {
              Ag = bg;
            }
            Reflect.construct(hA, [], og);
          } else {
            try {
              og.call();
            } catch (bg) {
              Ag = bg;
            }
            hA.call(og.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bg) {
            Ag = bg;
          }
          hA();
        }
      } catch (bg) {
        if (bg && Ag && typeof bg.stack == "string") {
          for (var Eg = bg.stack.split(`
`), Fg = Ag.stack.split(`
`), rg = Eg.length - 1, dg = Fg.length - 1; rg >= 1 && dg >= 0 && Eg[rg] !== Fg[dg]; )
            dg--;
          for (; rg >= 1 && dg >= 0; rg--, dg--)
            if (Eg[rg] !== Fg[dg]) {
              if (rg !== 1 || dg !== 1)
                do
                  if (rg--, dg--, dg < 0 || Eg[rg] !== Fg[dg]) {
                    var ug = `
` + Eg[rg].replace(" at new ", " at ");
                    return hA.displayName && ug.includes("<anonymous>") && (ug = ug.replace("<anonymous>", hA.displayName)), typeof hA == "function" && MA.set(hA, ug), ug;
                  }
                while (rg >= 1 && dg >= 0);
              break;
            }
        }
      } finally {
        xA = !1, dA.current = Dg, fA(), Error.prepareStackTrace = lg;
      }
      var Wg = hA ? hA.displayName || hA.name : "", Hg = Wg ? KA(Wg) : "";
      return typeof hA == "function" && MA.set(hA, Hg), Hg;
    }
    function gg(hA, UA, jA) {
      return SA(hA, !1);
    }
    function WA(hA) {
      var UA = hA.prototype;
      return !!(UA && UA.isReactComponent);
    }
    function eg(hA, UA, jA) {
      if (hA == null)
        return "";
      if (typeof hA == "function")
        return SA(hA, WA(hA));
      if (typeof hA == "string")
        return KA(hA);
      switch (hA) {
        case k:
          return KA("Suspense");
        case p:
          return KA("SuspenseList");
      }
      if (typeof hA == "object")
        switch (hA.$$typeof) {
          case d:
            return gg(hA.render);
          case M:
            return eg(hA.type, UA, jA);
          case H: {
            var Ag = hA, lg = Ag._payload, Dg = Ag._init;
            try {
              return eg(Dg(lg), UA, jA);
            } catch {
            }
          }
        }
      return "";
    }
    var ig = Object.prototype.hasOwnProperty, $A = {}, ag = BA.ReactDebugCurrentFrame;
    function Ig(hA) {
      if (hA) {
        var UA = hA._owner, jA = eg(hA.type, hA._source, UA ? UA.type : null);
        ag.setExtraStackFrame(jA);
      } else
        ag.setExtraStackFrame(null);
    }
    function tg(hA, UA, jA, Ag, lg) {
      {
        var Dg = Function.call.bind(ig);
        for (var og in hA)
          if (Dg(hA, og)) {
            var Eg = void 0;
            try {
              if (typeof hA[og] != "function") {
                var Fg = Error((Ag || "React class") + ": " + jA + " type `" + og + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof hA[og] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Fg.name = "Invariant Violation", Fg;
              }
              Eg = hA[og](UA, og, Ag, jA, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (rg) {
              Eg = rg;
            }
            Eg && !(Eg instanceof Error) && (Ig(lg), CA("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ag || "React class", jA, og, typeof Eg), Ig(null)), Eg instanceof Error && !(Eg.message in $A) && ($A[Eg.message] = !0, Ig(lg), CA("Failed %s type: %s", jA, Eg.message), Ig(null));
          }
      }
    }
    var wg = Array.isArray;
    function hg(hA) {
      return wg(hA);
    }
    function Gg(hA) {
      {
        var UA = typeof Symbol == "function" && Symbol.toStringTag, jA = UA && hA[Symbol.toStringTag] || hA.constructor.name || "Object";
        return jA;
      }
    }
    function Ng(hA) {
      try {
        return Bg(hA), !1;
      } catch {
        return !0;
      }
    }
    function Bg(hA) {
      return "" + hA;
    }
    function bA(hA) {
      if (Ng(hA))
        return CA("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Gg(hA)), Bg(hA);
    }
    var HA = BA.ReactCurrentOwner, vA = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, zA, PA;
    function qA(hA) {
      if (ig.call(hA, "ref")) {
        var UA = Object.getOwnPropertyDescriptor(hA, "ref").get;
        if (UA && UA.isReactWarning)
          return !1;
      }
      return hA.ref !== void 0;
    }
    function _A(hA) {
      if (ig.call(hA, "key")) {
        var UA = Object.getOwnPropertyDescriptor(hA, "key").get;
        if (UA && UA.isReactWarning)
          return !1;
      }
      return hA.key !== void 0;
    }
    function VA(hA, UA) {
      typeof hA.ref == "string" && HA.current;
    }
    function yA(hA, UA) {
      {
        var jA = function() {
          zA || (zA = !0, CA("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", UA));
        };
        jA.isReactWarning = !0, Object.defineProperty(hA, "key", {
          get: jA,
          configurable: !0
        });
      }
    }
    function FA(hA, UA) {
      {
        var jA = function() {
          PA || (PA = !0, CA("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", UA));
        };
        jA.isReactWarning = !0, Object.defineProperty(hA, "ref", {
          get: jA,
          configurable: !0
        });
      }
    }
    var uA = function(hA, UA, jA, Ag, lg, Dg, og) {
      var Eg = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: i,
        // Built-in properties that belong on the element
        type: hA,
        key: UA,
        ref: jA,
        props: og,
        // Record the component responsible for creating this element.
        _owner: Dg
      };
      return Eg._store = {}, Object.defineProperty(Eg._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Eg, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ag
      }), Object.defineProperty(Eg, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: lg
      }), Object.freeze && (Object.freeze(Eg.props), Object.freeze(Eg)), Eg;
    };
    function JA(hA, UA, jA, Ag, lg) {
      {
        var Dg, og = {}, Eg = null, Fg = null;
        jA !== void 0 && (bA(jA), Eg = "" + jA), _A(UA) && (bA(UA.key), Eg = "" + UA.key), qA(UA) && (Fg = UA.ref, VA(UA, lg));
        for (Dg in UA)
          ig.call(UA, Dg) && !vA.hasOwnProperty(Dg) && (og[Dg] = UA[Dg]);
        if (hA && hA.defaultProps) {
          var rg = hA.defaultProps;
          for (Dg in rg)
            og[Dg] === void 0 && (og[Dg] = rg[Dg]);
        }
        if (Eg || Fg) {
          var dg = typeof hA == "function" ? hA.displayName || hA.name || "Unknown" : hA;
          Eg && yA(og, dg), Fg && FA(og, dg);
        }
        return uA(hA, Eg, Fg, lg, Ag, HA.current, og);
      }
    }
    var YA = BA.ReactCurrentOwner, TA = BA.ReactDebugCurrentFrame;
    function Qg(hA) {
      if (hA) {
        var UA = hA._owner, jA = eg(hA.type, hA._source, UA ? UA.type : null);
        TA.setExtraStackFrame(jA);
      } else
        TA.setExtraStackFrame(null);
    }
    var sg;
    sg = !1;
    function ng(hA) {
      return typeof hA == "object" && hA !== null && hA.$$typeof === i;
    }
    function Yg() {
      {
        if (YA.current) {
          var hA = DA(YA.current.type);
          if (hA)
            return `

Check the render method of \`` + hA + "`.";
        }
        return "";
      }
    }
    function Lg(hA) {
      return "";
    }
    var pg = {};
    function II(hA) {
      {
        var UA = Yg();
        if (!UA) {
          var jA = typeof hA == "string" ? hA : hA.displayName || hA.name;
          jA && (UA = `

Check the top-level render call using <` + jA + ">.");
        }
        return UA;
      }
    }
    function Jg(hA, UA) {
      {
        if (!hA._store || hA._store.validated || hA.key != null)
          return;
        hA._store.validated = !0;
        var jA = II(UA);
        if (pg[jA])
          return;
        pg[jA] = !0;
        var Ag = "";
        hA && hA._owner && hA._owner !== YA.current && (Ag = " It was passed a child from " + DA(hA._owner.type) + "."), Qg(hA), CA('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', jA, Ag), Qg(null);
      }
    }
    function CI(hA, UA) {
      {
        if (typeof hA != "object")
          return;
        if (hg(hA))
          for (var jA = 0; jA < hA.length; jA++) {
            var Ag = hA[jA];
            ng(Ag) && Jg(Ag, UA);
          }
        else if (ng(hA))
          hA._store && (hA._store.validated = !0);
        else if (hA) {
          var lg = IA(hA);
          if (typeof lg == "function" && lg !== hA.entries)
            for (var Dg = lg.call(hA), og; !(og = Dg.next()).done; )
              ng(og.value) && Jg(og.value, UA);
        }
      }
    }
    function BI(hA) {
      {
        var UA = hA.type;
        if (UA == null || typeof UA == "string")
          return;
        var jA;
        if (typeof UA == "function")
          jA = UA.propTypes;
        else if (typeof UA == "object" && (UA.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        UA.$$typeof === M))
          jA = UA.propTypes;
        else
          return;
        if (jA) {
          var Ag = DA(UA);
          tg(jA, hA.props, "prop", Ag, hA);
        } else if (UA.PropTypes !== void 0 && !sg) {
          sg = !0;
          var lg = DA(UA);
          CA("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", lg || "Unknown");
        }
        typeof UA.getDefaultProps == "function" && !UA.getDefaultProps.isReactClassApproved && CA("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function qg(hA) {
      {
        for (var UA = Object.keys(hA.props), jA = 0; jA < UA.length; jA++) {
          var Ag = UA[jA];
          if (Ag !== "children" && Ag !== "key") {
            Qg(hA), CA("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ag), Qg(null);
            break;
          }
        }
        hA.ref !== null && (Qg(hA), CA("Invalid attribute `ref` supplied to `React.Fragment`."), Qg(null));
      }
    }
    var QI = {};
    function vg(hA, UA, jA, Ag, lg, Dg) {
      {
        var og = tA(hA);
        if (!og) {
          var Eg = "";
          (hA === void 0 || typeof hA == "object" && hA !== null && Object.keys(hA).length === 0) && (Eg += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Fg = Lg();
          Fg ? Eg += Fg : Eg += Yg();
          var rg;
          hA === null ? rg = "null" : hg(hA) ? rg = "array" : hA !== void 0 && hA.$$typeof === i ? (rg = "<" + (DA(hA.type) || "Unknown") + " />", Eg = " Did you accidentally export a JSX literal instead of a component?") : rg = typeof hA, CA("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", rg, Eg);
        }
        var dg = JA(hA, UA, jA, lg, Dg);
        if (dg == null)
          return dg;
        if (og) {
          var ug = UA.children;
          if (ug !== void 0)
            if (Ag)
              if (hg(ug)) {
                for (var Wg = 0; Wg < ug.length; Wg++)
                  CI(ug[Wg], hA);
                Object.freeze && Object.freeze(ug);
              } else
                CA("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              CI(ug, hA);
        }
        if (ig.call(UA, "key")) {
          var Hg = DA(hA), bg = Object.keys(UA).filter(function(wI) {
            return wI !== "key";
          }), iI = bg.length > 0 ? "{key: someKey, " + bg.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!QI[Hg + iI]) {
            var sI = bg.length > 0 ? "{" + bg.join(": ..., ") + ": ...}" : "{}";
            CA(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, iI, Hg, sI, Hg), QI[Hg + iI] = !0;
          }
        }
        return hA === E ? qg(dg) : BI(dg), dg;
      }
    }
    function Cg(hA, UA, jA) {
      return vg(hA, UA, jA, !0);
    }
    function cg(hA, UA, jA) {
      return vg(hA, UA, jA, !1);
    }
    var yg = cg, kg = Cg;
    reactJsxRuntime_development.Fragment = E, reactJsxRuntime_development.jsx = yg, reactJsxRuntime_development.jsxs = kg;
  })()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime(), loglevel$3 = { exports: {} }, loglevel$2 = loglevel$3.exports, hasRequiredLoglevel$1;
function requireLoglevel$1() {
  return hasRequiredLoglevel$1 || (hasRequiredLoglevel$1 = 1, (function(o) {
    (function(i, g) {
      o.exports ? o.exports = g() : i.log = g();
    })(loglevel$2, function() {
      var i = function() {
      }, g = "undefined", E = typeof window !== g && typeof window.navigator !== g && /Trident\/|MSIE /.test(window.navigator.userAgent), e = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], t = {}, n = null;
      function h(gA, IA) {
        var BA = gA[IA];
        if (typeof BA.bind == "function")
          return BA.bind(gA);
        try {
          return Function.prototype.bind.call(BA, gA);
        } catch {
          return function() {
            return Function.prototype.apply.apply(BA, [gA, arguments]);
          };
        }
      }
      function d() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function k(gA) {
        return gA === "debug" && (gA = "log"), typeof console === g ? !1 : gA === "trace" && E ? d : console[gA] !== void 0 ? h(console, gA) : console.log !== void 0 ? h(console, "log") : i;
      }
      function p() {
        for (var gA = this.getLevel(), IA = 0; IA < e.length; IA++) {
          var BA = e[IA];
          this[BA] = IA < gA ? i : this.methodFactory(BA, gA, this.name);
        }
        if (this.log = this.debug, typeof console === g && gA < this.levels.SILENT)
          return "No console available for logging";
      }
      function M(gA) {
        return function() {
          typeof console !== g && (p.call(this), this[gA].apply(this, arguments));
        };
      }
      function H(gA, IA, BA) {
        return k(gA) || M.apply(this, arguments);
      }
      function f(gA, IA) {
        var BA = this, CA, QA, iA, EA = "loglevel";
        typeof gA == "string" ? EA += ":" + gA : typeof gA == "symbol" && (EA = void 0);
        function oA(aA) {
          var sA = (e[aA] || "silent").toUpperCase();
          if (!(typeof window === g || !EA)) {
            try {
              window.localStorage[EA] = sA;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(EA) + "=" + sA + ";";
            } catch {
            }
          }
        }
        function eA() {
          var aA;
          if (!(typeof window === g || !EA)) {
            try {
              aA = window.localStorage[EA];
            } catch {
            }
            if (typeof aA === g)
              try {
                var sA = window.document.cookie, DA = encodeURIComponent(EA), rA = sA.indexOf(DA + "=");
                rA !== -1 && (aA = /^([^;]+)/.exec(
                  sA.slice(rA + DA.length + 1)
                )[1]);
              } catch {
              }
            return BA.levels[aA] === void 0 && (aA = void 0), aA;
          }
        }
        function GA() {
          if (!(typeof window === g || !EA)) {
            try {
              window.localStorage.removeItem(EA);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(EA) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function cA(aA) {
          var sA = aA;
          if (typeof sA == "string" && BA.levels[sA.toUpperCase()] !== void 0 && (sA = BA.levels[sA.toUpperCase()]), typeof sA == "number" && sA >= 0 && sA <= BA.levels.SILENT)
            return sA;
          throw new TypeError("log.setLevel() called with invalid level: " + aA);
        }
        BA.name = gA, BA.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, BA.methodFactory = IA || H, BA.getLevel = function() {
          return iA ?? QA ?? CA;
        }, BA.setLevel = function(aA, sA) {
          return iA = cA(aA), sA !== !1 && oA(iA), p.call(BA);
        }, BA.setDefaultLevel = function(aA) {
          QA = cA(aA), eA() || BA.setLevel(aA, !1);
        }, BA.resetLevel = function() {
          iA = null, GA(), p.call(BA);
        }, BA.enableAll = function(aA) {
          BA.setLevel(BA.levels.TRACE, aA);
        }, BA.disableAll = function(aA) {
          BA.setLevel(BA.levels.SILENT, aA);
        }, BA.rebuild = function() {
          if (n !== BA && (CA = cA(n.getLevel())), p.call(BA), n === BA)
            for (var aA in t)
              t[aA].rebuild();
        }, CA = cA(
          n ? n.getLevel() : "WARN"
        );
        var tA = eA();
        tA != null && (iA = cA(tA)), p.call(BA);
      }
      n = new f(), n.getLogger = function(IA) {
        if (typeof IA != "symbol" && typeof IA != "string" || IA === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var BA = t[IA];
        return BA || (BA = t[IA] = new f(
          IA,
          n.methodFactory
        )), BA;
      };
      var AA = typeof window !== g ? window.log : void 0;
      return n.noConflict = function() {
        return typeof window !== g && window.log === n && (window.log = AA), n;
      }, n.getLoggers = function() {
        return t;
      }, n.default = n, n;
    });
  })(loglevel$3)), loglevel$3.exports;
}
var loglevelExports$1 = requireLoglevel$1();
const log = /* @__PURE__ */ getDefaultExportFromCjs(loglevelExports$1), StliteKernelContext = React__default.createContext(void 0), Provider$2 = StliteKernelContext.Provider;
function StliteKernelProvider(o) {
  const {
    children: i,
    kernel: g
  } = o, E = useMemo$1(() => ({
    kernel: g
  }), [g]);
  return jsxRuntimeExports.jsx(Provider$2, {
    value: E,
    children: i
  });
}
function useStliteKernel() {
  const o = useContext(StliteKernelContext);
  if (o == null)
    throw new Error("useStliteKernel() must be inside <StliteKernelProvider />");
  return o.kernel;
}
function sheetForTag(o) {
  if (o.sheet)
    return o.sheet;
  for (var i = 0; i < document.styleSheets.length; i++)
    if (document.styleSheets[i].ownerNode === o)
      return document.styleSheets[i];
}
function createStyleElement(o) {
  var i = document.createElement("style");
  return i.setAttribute("data-emotion", o.key), o.nonce !== void 0 && i.setAttribute("nonce", o.nonce), i.appendChild(document.createTextNode("")), i.setAttribute("data-s", ""), i;
}
var StyleSheet = /* @__PURE__ */ (function() {
  function o(g) {
    var E = this;
    this._insertTag = function(e) {
      var t;
      E.tags.length === 0 ? E.insertionPoint ? t = E.insertionPoint.nextSibling : E.prepend ? t = E.container.firstChild : t = E.before : t = E.tags[E.tags.length - 1].nextSibling, E.container.insertBefore(e, t), E.tags.push(e);
    }, this.isSpeedy = g.speedy === void 0 ? !0 : g.speedy, this.tags = [], this.ctr = 0, this.nonce = g.nonce, this.key = g.key, this.container = g.container, this.prepend = g.prepend, this.insertionPoint = g.insertionPoint, this.before = null;
  }
  var i = o.prototype;
  return i.hydrate = function(E) {
    E.forEach(this._insertTag);
  }, i.insert = function(E) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var e = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var t = sheetForTag(e);
      try {
        t.insertRule(E, t.cssRules.length);
      } catch {
      }
    } else
      e.appendChild(document.createTextNode(E));
    this.ctr++;
  }, i.flush = function() {
    this.tags.forEach(function(E) {
      var e;
      return (e = E.parentNode) == null ? void 0 : e.removeChild(E);
    }), this.tags = [], this.ctr = 0;
  }, o;
})(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign$1 = Object.assign;
function hash$1(o, i) {
  return charat(o, 0) ^ 45 ? (((i << 2 ^ charat(o, 0)) << 2 ^ charat(o, 1)) << 2 ^ charat(o, 2)) << 2 ^ charat(o, 3) : 0;
}
function trim(o) {
  return o.trim();
}
function match(o, i) {
  return (o = i.exec(o)) ? o[0] : o;
}
function replace$1(o, i, g) {
  return o.replace(i, g);
}
function indexof(o, i) {
  return o.indexOf(i);
}
function charat(o, i) {
  return o.charCodeAt(i) | 0;
}
function substr(o, i, g) {
  return o.slice(i, g);
}
function strlen(o) {
  return o.length;
}
function sizeof(o) {
  return o.length;
}
function append(o, i) {
  return i.push(o), o;
}
function combine(o, i) {
  return o.map(i).join("");
}
var line = 1, column = 1, length = 0, position$3 = 0, character = 0, characters = "";
function node$1(o, i, g, E, e, t, n) {
  return { value: o, root: i, parent: g, type: E, props: e, children: t, line, column, length: n, return: "" };
}
function copy(o, i) {
  return assign$1(node$1("", null, null, "", null, null, 0), o, { length: -o.length }, i);
}
function char() {
  return character;
}
function prev() {
  return character = position$3 > 0 ? charat(characters, --position$3) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position$3 < length ? charat(characters, position$3++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek$1() {
  return charat(characters, position$3);
}
function caret() {
  return position$3;
}
function slice(o, i) {
  return substr(characters, o, i);
}
function token(o) {
  switch (o) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(o) {
  return line = column = 1, length = strlen(characters = o), position$3 = 0, [];
}
function dealloc(o) {
  return characters = "", o;
}
function delimit(o) {
  return trim(slice(position$3 - 1, delimiter(o === 91 ? o + 2 : o === 40 ? o + 1 : o)));
}
function whitespace$1(o) {
  for (; (character = peek$1()) && character < 33; )
    next();
  return token(o) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(o, i) {
  for (; --i && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(o, caret() + (i < 6 && peek$1() == 32 && next() == 32));
}
function delimiter(o) {
  for (; next(); )
    switch (character) {
      // ] ) " '
      case o:
        return position$3;
      // " '
      case 34:
      case 39:
        o !== 34 && o !== 39 && delimiter(character);
        break;
      // (
      case 40:
        o === 41 && delimiter(o);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position$3;
}
function commenter(o, i) {
  for (; next() && o + character !== 57; )
    if (o + character === 84 && peek$1() === 47)
      break;
  return "/*" + slice(i, position$3 - 1) + "*" + from(o === 47 ? o : next());
}
function identifier(o) {
  for (; !token(peek$1()); )
    next();
  return slice(o, position$3);
}
function compile(o) {
  return dealloc(parse$3("", null, null, null, [""], o = alloc(o), 0, [0], o));
}
function parse$3(o, i, g, E, e, t, n, h, d) {
  for (var k = 0, p = 0, M = n, H = 0, f = 0, AA = 0, gA = 1, IA = 1, BA = 1, CA = 0, QA = "", iA = e, EA = t, oA = E, eA = QA; IA; )
    switch (AA = CA, CA = next()) {
      // (
      case 40:
        if (AA != 108 && charat(eA, M - 1) == 58) {
          indexof(eA += replace$1(delimit(CA), "&", "&\f"), "&\f") != -1 && (BA = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        eA += delimit(CA);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        eA += whitespace$1(AA);
        break;
      // \
      case 92:
        eA += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek$1()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), i, g), d);
            break;
          default:
            eA += "/";
        }
        break;
      // {
      case 123 * gA:
        h[k++] = strlen(eA) * BA;
      // } ; \0
      case 125 * gA:
      case 59:
      case 0:
        switch (CA) {
          // \0 }
          case 0:
          case 125:
            IA = 0;
          // ;
          case 59 + p:
            BA == -1 && (eA = replace$1(eA, /\f/g, "")), f > 0 && strlen(eA) - M && append(f > 32 ? declaration(eA + ";", E, g, M - 1) : declaration(replace$1(eA, " ", "") + ";", E, g, M - 2), d);
            break;
          // @ ;
          case 59:
            eA += ";";
          // { rule/at-rule
          default:
            if (append(oA = ruleset(eA, i, g, k, p, e, h, QA, iA = [], EA = [], M), t), CA === 123)
              if (p === 0)
                parse$3(eA, i, oA, oA, iA, t, M, h, EA);
              else
                switch (H === 99 && charat(eA, 3) === 110 ? 100 : H) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$3(o, oA, oA, E && append(ruleset(o, oA, oA, 0, 0, e, h, QA, e, iA = [], M), EA), e, EA, M, h, E ? iA : EA);
                    break;
                  default:
                    parse$3(eA, oA, oA, oA, [""], EA, 0, h, EA);
                }
        }
        k = p = f = 0, gA = BA = 1, QA = eA = "", M = n;
        break;
      // :
      case 58:
        M = 1 + strlen(eA), f = AA;
      default:
        if (gA < 1) {
          if (CA == 123)
            --gA;
          else if (CA == 125 && gA++ == 0 && prev() == 125)
            continue;
        }
        switch (eA += from(CA), CA * gA) {
          // &
          case 38:
            BA = p > 0 ? 1 : (eA += "\f", -1);
            break;
          // ,
          case 44:
            h[k++] = (strlen(eA) - 1) * BA, BA = 1;
            break;
          // @
          case 64:
            peek$1() === 45 && (eA += delimit(next())), H = peek$1(), p = M = strlen(QA = eA += identifier(caret())), CA++;
            break;
          // -
          case 45:
            AA === 45 && strlen(eA) == 2 && (gA = 0);
        }
    }
  return t;
}
function ruleset(o, i, g, E, e, t, n, h, d, k, p) {
  for (var M = e - 1, H = e === 0 ? t : [""], f = sizeof(H), AA = 0, gA = 0, IA = 0; AA < E; ++AA)
    for (var BA = 0, CA = substr(o, M + 1, M = abs(gA = n[AA])), QA = o; BA < f; ++BA)
      (QA = trim(gA > 0 ? H[BA] + " " + CA : replace$1(CA, /&\f/g, H[BA]))) && (d[IA++] = QA);
  return node$1(o, i, g, e === 0 ? RULESET : h, d, k, p);
}
function comment(o, i, g) {
  return node$1(o, i, g, COMMENT, from(char()), substr(o, 2, -2), 0);
}
function declaration(o, i, g, E) {
  return node$1(o, i, g, DECLARATION, substr(o, 0, E), substr(o, E + 1, -1), E);
}
function serialize$2(o, i) {
  for (var g = "", E = sizeof(o), e = 0; e < E; e++)
    g += i(o[e], e, o, i) || "";
  return g;
}
function stringify$2(o, i, g, E) {
  switch (o.type) {
    case LAYER:
      if (o.children.length) break;
    case IMPORT:
    case DECLARATION:
      return o.return = o.return || o.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return o.return = o.value + "{" + serialize$2(o.children, E) + "}";
    case RULESET:
      o.value = o.props.join(",");
  }
  return strlen(g = serialize$2(o.children, E)) ? o.return = o.value + "{" + g + "}" : "";
}
function middleware(o) {
  var i = sizeof(o);
  return function(g, E, e, t) {
    for (var n = "", h = 0; h < i; h++)
      n += o[h](g, E, e, t) || "";
    return n;
  };
}
function rulesheet(o) {
  return function(i) {
    i.root || (i = i.return) && o(i);
  };
}
var weakMemoize = function(i) {
  var g = /* @__PURE__ */ new WeakMap();
  return function(E) {
    if (g.has(E))
      return g.get(E);
    var e = i(E);
    return g.set(E, e), e;
  };
};
function memoize$1(o) {
  var i = /* @__PURE__ */ Object.create(null);
  return function(g) {
    return i[g] === void 0 && (i[g] = o(g)), i[g];
  };
}
var identifierWithPointTracking = function(i, g, E) {
  for (var e = 0, t = 0; e = t, t = peek$1(), e === 38 && t === 12 && (g[E] = 1), !token(t); )
    next();
  return slice(i, position$3);
}, toRules = function(i, g) {
  var E = -1, e = 44;
  do
    switch (token(e)) {
      case 0:
        e === 38 && peek$1() === 12 && (g[E] = 1), i[E] += identifierWithPointTracking(position$3 - 1, g, E);
        break;
      case 2:
        i[E] += delimit(e);
        break;
      case 4:
        if (e === 44) {
          i[++E] = peek$1() === 58 ? "&\f" : "", g[E] = i[E].length;
          break;
        }
      // fallthrough
      default:
        i[E] += from(e);
    }
  while (e = next());
  return i;
}, getRules = function(i, g) {
  return dealloc(toRules(alloc(i), g));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(i) {
  if (!(i.type !== "rule" || !i.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  i.length < 1)) {
    for (var g = i.value, E = i.parent, e = i.column === E.column && i.line === E.line; E.type !== "rule"; )
      if (E = E.parent, !E) return;
    if (!(i.props.length === 1 && g.charCodeAt(0) !== 58 && !fixedElements.get(E)) && !e) {
      fixedElements.set(i, !0);
      for (var t = [], n = getRules(g, t), h = E.props, d = 0, k = 0; d < n.length; d++)
        for (var p = 0; p < h.length; p++, k++)
          i.props[k] = t[d] ? n[d].replace(/&\f/g, h[p]) : h[p] + " " + n[d];
    }
  }
}, removeLabel = function(i) {
  if (i.type === "decl") {
    var g = i.value;
    // charcode for l
    g.charCodeAt(0) === 108 && // charcode for b
    g.charCodeAt(2) === 98 && (i.return = "", i.value = "");
  }
};
function prefix$1(o, i) {
  switch (hash$1(o, i)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + o + o;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + o + o;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + o + MOZ + o + MS + o + o;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + o + MS + o + o;
    // order
    case 6165:
      return WEBKIT + o + MS + "flex-" + o + o;
    // align-items
    case 5187:
      return WEBKIT + o + replace$1(o, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + o;
    // align-self
    case 5443:
      return WEBKIT + o + MS + "flex-item-" + replace$1(o, /flex-|-self/, "") + o;
    // align-content
    case 4675:
      return WEBKIT + o + MS + "flex-line-pack" + replace$1(o, /align-content|flex-|-self/, "") + o;
    // flex-shrink
    case 5548:
      return WEBKIT + o + MS + replace$1(o, "shrink", "negative") + o;
    // flex-basis
    case 5292:
      return WEBKIT + o + MS + replace$1(o, "basis", "preferred-size") + o;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace$1(o, "-grow", "") + WEBKIT + o + MS + replace$1(o, "grow", "positive") + o;
    // transition
    case 4554:
      return WEBKIT + replace$1(o, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + o;
    // cursor
    case 6187:
      return replace$1(replace$1(replace$1(o, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), o, "") + o;
    // background, background-image
    case 5495:
    case 3959:
      return replace$1(o, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace$1(replace$1(o, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + o + o;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(o, /(.+)-inline(.+)/, WEBKIT + "$1$2") + o;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(o) - 1 - i > 6) switch (charat(o, i + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(o, i + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace$1(o, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(o, i + 3) == 108 ? "$3" : "$2-$3")) + o;
        // (s)tretch
        case 115:
          return ~indexof(o, "stretch") ? prefix$1(replace$1(o, "stretch", "fill-available"), i) + o : o;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(o, i + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(o, strlen(o) - 3 - (~indexof(o, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace$1(o, ":", ":" + WEBKIT) + o;
        // (inline-)?fl(e)x
        case 101:
          return replace$1(o, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(o, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + o;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(o, i + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + o + MS + replace$1(o, /[svh]\w+-[tblr]{2}/, "tb") + o;
        // vertical-r(l)
        case 108:
          return WEBKIT + o + MS + replace$1(o, /[svh]\w+-[tblr]{2}/, "tb-rl") + o;
        // horizontal(-)tb
        case 45:
          return WEBKIT + o + MS + replace$1(o, /[svh]\w+-[tblr]{2}/, "lr") + o;
      }
      return WEBKIT + o + MS + o + o;
  }
  return o;
}
var prefixer = function(i, g, E, e) {
  if (i.length > -1 && !i.return) switch (i.type) {
    case DECLARATION:
      i.return = prefix$1(i.value, i.length);
      break;
    case KEYFRAMES:
      return serialize$2([copy(i, {
        value: replace$1(i.value, "@", "@" + WEBKIT)
      })], e);
    case RULESET:
      if (i.length) return combine(i.props, function(t) {
        switch (match(t, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return serialize$2([copy(i, {
              props: [replace$1(t, /:(read-\w+)/, ":" + MOZ + "$1")]
            })], e);
          // :placeholder
          case "::placeholder":
            return serialize$2([copy(i, {
              props: [replace$1(t, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
            }), copy(i, {
              props: [replace$1(t, /:(plac\w+)/, ":" + MOZ + "$1")]
            }), copy(i, {
              props: [replace$1(t, /:(plac\w+)/, MS + "input-$1")]
            })], e);
        }
        return "";
      });
  }
}, defaultStylisPlugins = [prefixer], createCache = function(i) {
  var g = i.key;
  if (g === "css") {
    var E = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(E, function(gA) {
      var IA = gA.getAttribute("data-emotion");
      IA.indexOf(" ") !== -1 && (document.head.appendChild(gA), gA.setAttribute("data-s", ""));
    });
  }
  var e = i.stylisPlugins || defaultStylisPlugins, t = {}, n, h = [];
  n = i.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + g + ' "]'),
    function(gA) {
      for (var IA = gA.getAttribute("data-emotion").split(" "), BA = 1; BA < IA.length; BA++)
        t[IA[BA]] = !0;
      h.push(gA);
    }
  );
  var d, k = [compat, removeLabel];
  {
    var p, M = [stringify$2, rulesheet(function(gA) {
      p.insert(gA);
    })], H = middleware(k.concat(e, M)), f = function(IA) {
      return serialize$2(compile(IA), H);
    };
    d = function(IA, BA, CA, QA) {
      p = CA, f(IA ? IA + "{" + BA.styles + "}" : BA.styles), QA && (AA.inserted[BA.name] = !0);
    };
  }
  var AA = {
    key: g,
    sheet: new StyleSheet({
      key: g,
      container: n,
      nonce: i.nonce,
      speedy: i.speedy,
      prepend: i.prepend,
      insertionPoint: i.insertionPoint
    }),
    nonce: i.nonce,
    inserted: t,
    registered: {},
    insert: d
  };
  return AA.sheet.hydrate(h), AA;
};
function _extends$C() {
  return _extends$C = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g) ({}).hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$C.apply(null, arguments);
}
var reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var o = typeof Symbol == "function" && Symbol.for, i = o ? Symbol.for("react.element") : 60103, g = o ? Symbol.for("react.portal") : 60106, E = o ? Symbol.for("react.fragment") : 60107, e = o ? Symbol.for("react.strict_mode") : 60108, t = o ? Symbol.for("react.profiler") : 60114, n = o ? Symbol.for("react.provider") : 60109, h = o ? Symbol.for("react.context") : 60110, d = o ? Symbol.for("react.async_mode") : 60111, k = o ? Symbol.for("react.concurrent_mode") : 60111, p = o ? Symbol.for("react.forward_ref") : 60112, M = o ? Symbol.for("react.suspense") : 60113, H = o ? Symbol.for("react.suspense_list") : 60120, f = o ? Symbol.for("react.memo") : 60115, AA = o ? Symbol.for("react.lazy") : 60116, gA = o ? Symbol.for("react.block") : 60121, IA = o ? Symbol.for("react.fundamental") : 60117, BA = o ? Symbol.for("react.responder") : 60118, CA = o ? Symbol.for("react.scope") : 60119;
  function QA(EA) {
    if (typeof EA == "object" && EA !== null) {
      var oA = EA.$$typeof;
      switch (oA) {
        case i:
          switch (EA = EA.type, EA) {
            case d:
            case k:
            case E:
            case t:
            case e:
            case M:
              return EA;
            default:
              switch (EA = EA && EA.$$typeof, EA) {
                case h:
                case p:
                case AA:
                case f:
                case n:
                  return EA;
                default:
                  return oA;
              }
          }
        case g:
          return oA;
      }
    }
  }
  function iA(EA) {
    return QA(EA) === k;
  }
  return reactIs_production_min$1.AsyncMode = d, reactIs_production_min$1.ConcurrentMode = k, reactIs_production_min$1.ContextConsumer = h, reactIs_production_min$1.ContextProvider = n, reactIs_production_min$1.Element = i, reactIs_production_min$1.ForwardRef = p, reactIs_production_min$1.Fragment = E, reactIs_production_min$1.Lazy = AA, reactIs_production_min$1.Memo = f, reactIs_production_min$1.Portal = g, reactIs_production_min$1.Profiler = t, reactIs_production_min$1.StrictMode = e, reactIs_production_min$1.Suspense = M, reactIs_production_min$1.isAsyncMode = function(EA) {
    return iA(EA) || QA(EA) === d;
  }, reactIs_production_min$1.isConcurrentMode = iA, reactIs_production_min$1.isContextConsumer = function(EA) {
    return QA(EA) === h;
  }, reactIs_production_min$1.isContextProvider = function(EA) {
    return QA(EA) === n;
  }, reactIs_production_min$1.isElement = function(EA) {
    return typeof EA == "object" && EA !== null && EA.$$typeof === i;
  }, reactIs_production_min$1.isForwardRef = function(EA) {
    return QA(EA) === p;
  }, reactIs_production_min$1.isFragment = function(EA) {
    return QA(EA) === E;
  }, reactIs_production_min$1.isLazy = function(EA) {
    return QA(EA) === AA;
  }, reactIs_production_min$1.isMemo = function(EA) {
    return QA(EA) === f;
  }, reactIs_production_min$1.isPortal = function(EA) {
    return QA(EA) === g;
  }, reactIs_production_min$1.isProfiler = function(EA) {
    return QA(EA) === t;
  }, reactIs_production_min$1.isStrictMode = function(EA) {
    return QA(EA) === e;
  }, reactIs_production_min$1.isSuspense = function(EA) {
    return QA(EA) === M;
  }, reactIs_production_min$1.isValidElementType = function(EA) {
    return typeof EA == "string" || typeof EA == "function" || EA === E || EA === k || EA === t || EA === e || EA === M || EA === H || typeof EA == "object" && EA !== null && (EA.$$typeof === AA || EA.$$typeof === f || EA.$$typeof === n || EA.$$typeof === h || EA.$$typeof === p || EA.$$typeof === IA || EA.$$typeof === BA || EA.$$typeof === CA || EA.$$typeof === gA);
  }, reactIs_production_min$1.typeOf = QA, reactIs_production_min$1;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var o = typeof Symbol == "function" && Symbol.for, i = o ? Symbol.for("react.element") : 60103, g = o ? Symbol.for("react.portal") : 60106, E = o ? Symbol.for("react.fragment") : 60107, e = o ? Symbol.for("react.strict_mode") : 60108, t = o ? Symbol.for("react.profiler") : 60114, n = o ? Symbol.for("react.provider") : 60109, h = o ? Symbol.for("react.context") : 60110, d = o ? Symbol.for("react.async_mode") : 60111, k = o ? Symbol.for("react.concurrent_mode") : 60111, p = o ? Symbol.for("react.forward_ref") : 60112, M = o ? Symbol.for("react.suspense") : 60113, H = o ? Symbol.for("react.suspense_list") : 60120, f = o ? Symbol.for("react.memo") : 60115, AA = o ? Symbol.for("react.lazy") : 60116, gA = o ? Symbol.for("react.block") : 60121, IA = o ? Symbol.for("react.fundamental") : 60117, BA = o ? Symbol.for("react.responder") : 60118, CA = o ? Symbol.for("react.scope") : 60119;
    function QA(SA) {
      return typeof SA == "string" || typeof SA == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      SA === E || SA === k || SA === t || SA === e || SA === M || SA === H || typeof SA == "object" && SA !== null && (SA.$$typeof === AA || SA.$$typeof === f || SA.$$typeof === n || SA.$$typeof === h || SA.$$typeof === p || SA.$$typeof === IA || SA.$$typeof === BA || SA.$$typeof === CA || SA.$$typeof === gA);
    }
    function iA(SA) {
      if (typeof SA == "object" && SA !== null) {
        var gg = SA.$$typeof;
        switch (gg) {
          case i:
            var WA = SA.type;
            switch (WA) {
              case d:
              case k:
              case E:
              case t:
              case e:
              case M:
                return WA;
              default:
                var eg = WA && WA.$$typeof;
                switch (eg) {
                  case h:
                  case p:
                  case AA:
                  case f:
                  case n:
                    return eg;
                  default:
                    return gg;
                }
            }
          case g:
            return gg;
        }
      }
    }
    var EA = d, oA = k, eA = h, GA = n, cA = i, tA = p, aA = E, sA = AA, DA = f, rA = g, nA = t, NA = e, pA = M, mA = !1;
    function XA(SA) {
      return mA || (mA = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), lA(SA) || iA(SA) === d;
    }
    function lA(SA) {
      return iA(SA) === k;
    }
    function kA(SA) {
      return iA(SA) === h;
    }
    function ZA(SA) {
      return iA(SA) === n;
    }
    function wA(SA) {
      return typeof SA == "object" && SA !== null && SA.$$typeof === i;
    }
    function LA(SA) {
      return iA(SA) === p;
    }
    function fA(SA) {
      return iA(SA) === E;
    }
    function dA(SA) {
      return iA(SA) === AA;
    }
    function RA(SA) {
      return iA(SA) === f;
    }
    function KA(SA) {
      return iA(SA) === g;
    }
    function xA(SA) {
      return iA(SA) === t;
    }
    function MA(SA) {
      return iA(SA) === e;
    }
    function OA(SA) {
      return iA(SA) === M;
    }
    reactIs_development$1.AsyncMode = EA, reactIs_development$1.ConcurrentMode = oA, reactIs_development$1.ContextConsumer = eA, reactIs_development$1.ContextProvider = GA, reactIs_development$1.Element = cA, reactIs_development$1.ForwardRef = tA, reactIs_development$1.Fragment = aA, reactIs_development$1.Lazy = sA, reactIs_development$1.Memo = DA, reactIs_development$1.Portal = rA, reactIs_development$1.Profiler = nA, reactIs_development$1.StrictMode = NA, reactIs_development$1.Suspense = pA, reactIs_development$1.isAsyncMode = XA, reactIs_development$1.isConcurrentMode = lA, reactIs_development$1.isContextConsumer = kA, reactIs_development$1.isContextProvider = ZA, reactIs_development$1.isElement = wA, reactIs_development$1.isForwardRef = LA, reactIs_development$1.isFragment = fA, reactIs_development$1.isLazy = dA, reactIs_development$1.isMemo = RA, reactIs_development$1.isPortal = KA, reactIs_development$1.isProfiler = xA, reactIs_development$1.isStrictMode = MA, reactIs_development$1.isSuspense = OA, reactIs_development$1.isValidElementType = QA, reactIs_development$1.typeOf = iA;
  })()), reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  return hasRequiredReactIs$1 || (hasRequiredReactIs$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
var hoistNonReactStatics_cjs, hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var o = requireReactIs$1(), i = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, g = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, E = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, e = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, t = {};
  t[o.ForwardRef] = E, t[o.Memo] = e;
  function n(AA) {
    return o.isMemo(AA) ? e : t[AA.$$typeof] || i;
  }
  var h = Object.defineProperty, d = Object.getOwnPropertyNames, k = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, M = Object.getPrototypeOf, H = Object.prototype;
  function f(AA, gA, IA) {
    if (typeof gA != "string") {
      if (H) {
        var BA = M(gA);
        BA && BA !== H && f(AA, BA, IA);
      }
      var CA = d(gA);
      k && (CA = CA.concat(k(gA)));
      for (var QA = n(AA), iA = n(gA), EA = 0; EA < CA.length; ++EA) {
        var oA = CA[EA];
        if (!g[oA] && !(IA && IA[oA]) && !(iA && iA[oA]) && !(QA && QA[oA])) {
          var eA = p(gA, oA);
          try {
            h(AA, oA, eA);
          } catch {
          }
        }
      }
    }
    return AA;
  }
  return hoistNonReactStatics_cjs = f, hoistNonReactStatics_cjs;
}
var hoistNonReactStatics_cjsExports = requireHoistNonReactStatics_cjs();
const hoistNonReactStatics = /* @__PURE__ */ getDefaultExportFromCjs(hoistNonReactStatics_cjsExports);
var isBrowser$2 = !0;
function getRegisteredStyles(o, i, g) {
  var E = "";
  return g.split(" ").forEach(function(e) {
    o[e] !== void 0 ? i.push(o[e] + ";") : e && (E += e + " ");
  }), E;
}
var registerStyles = function(i, g, E) {
  var e = i.key + "-" + g.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (E === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === !1) && i.registered[e] === void 0 && (i.registered[e] = g.styles);
}, insertStyles = function(i, g, E) {
  registerStyles(i, g, E);
  var e = i.key + "-" + g.name;
  if (i.inserted[g.name] === void 0) {
    var t = g;
    do
      i.insert(g === t ? "." + e : "", t, i.sheet, !0), t = t.next;
    while (t !== void 0);
  }
};
function murmur2(o) {
  for (var i = 0, g, E = 0, e = o.length; e >= 4; ++E, e -= 4)
    g = o.charCodeAt(E) & 255 | (o.charCodeAt(++E) & 255) << 8 | (o.charCodeAt(++E) & 255) << 16 | (o.charCodeAt(++E) & 255) << 24, g = /* Math.imul(k, m): */
    (g & 65535) * 1540483477 + ((g >>> 16) * 59797 << 16), g ^= /* k >>> r: */
    g >>> 24, i = /* Math.imul(k, m): */
    (g & 65535) * 1540483477 + ((g >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16);
  switch (e) {
    case 3:
      i ^= (o.charCodeAt(E + 2) & 255) << 16;
    case 2:
      i ^= (o.charCodeAt(E + 1) & 255) << 8;
    case 1:
      i ^= o.charCodeAt(E) & 255, i = /* Math.imul(h, m): */
      (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16);
  }
  return i ^= i >>> 13, i = /* Math.imul(h, m): */
  (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), ((i ^ i >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(i) {
  return i.charCodeAt(1) === 45;
}, isProcessableValue = function(i) {
  return i != null && typeof i != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$1(function(o) {
  return isCustomProperty(o) ? o : o.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(i, g) {
  switch (i) {
    case "animation":
    case "animationName":
      if (typeof g == "string")
        return g.replace(animationRegex, function(E, e, t) {
          return cursor$1 = {
            name: e,
            styles: t,
            next: cursor$1
          }, e;
        });
  }
  return unitlessKeys[i] !== 1 && !isCustomProperty(i) && typeof g == "number" && g !== 0 ? g + "px" : g;
};
function handleInterpolation(o, i, g) {
  if (g == null)
    return "";
  var E = g;
  if (E.__emotion_styles !== void 0)
    return E;
  switch (typeof g) {
    case "boolean":
      return "";
    case "object": {
      var e = g;
      if (e.anim === 1)
        return cursor$1 = {
          name: e.name,
          styles: e.styles,
          next: cursor$1
        }, e.name;
      var t = g;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            cursor$1 = {
              name: n.name,
              styles: n.styles,
              next: cursor$1
            }, n = n.next;
        var h = t.styles + ";";
        return h;
      }
      return createStringFromObject(o, i, g);
    }
    case "function": {
      if (o !== void 0) {
        var d = cursor$1, k = g(o);
        return cursor$1 = d, handleInterpolation(o, i, k);
      }
      break;
    }
  }
  var p = g;
  if (i == null)
    return p;
  var M = i[p];
  return M !== void 0 ? M : p;
}
function createStringFromObject(o, i, g) {
  var E = "";
  if (Array.isArray(g))
    for (var e = 0; e < g.length; e++)
      E += handleInterpolation(o, i, g[e]) + ";";
  else
    for (var t in g) {
      var n = g[t];
      if (typeof n != "object") {
        var h = n;
        i != null && i[h] !== void 0 ? E += t + "{" + i[h] + "}" : isProcessableValue(h) && (E += processStyleName(t) + ":" + processStyleValue(t, h) + ";");
      } else if (Array.isArray(n) && typeof n[0] == "string" && (i == null || i[n[0]] === void 0))
        for (var d = 0; d < n.length; d++)
          isProcessableValue(n[d]) && (E += processStyleName(t) + ":" + processStyleValue(t, n[d]) + ";");
      else {
        var k = handleInterpolation(o, i, n);
        switch (t) {
          case "animation":
          case "animationName": {
            E += processStyleName(t) + ":" + k + ";";
            break;
          }
          default:
            E += t + "{" + k + "}";
        }
      }
    }
  return E;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g, cursor$1;
function serializeStyles(o, i, g) {
  if (o.length === 1 && typeof o[0] == "object" && o[0] !== null && o[0].styles !== void 0)
    return o[0];
  var E = !0, e = "";
  cursor$1 = void 0;
  var t = o[0];
  if (t == null || t.raw === void 0)
    E = !1, e += handleInterpolation(g, i, t);
  else {
    var n = t;
    e += n[0];
  }
  for (var h = 1; h < o.length; h++)
    if (e += handleInterpolation(g, i, o[h]), E) {
      var d = t;
      e += d[h];
    }
  labelPattern.lastIndex = 0;
  for (var k = "", p; (p = labelPattern.exec(e)) !== null; )
    k += "-" + p[1];
  var M = murmur2(e) + k;
  return {
    name: M,
    styles: e,
    next: cursor$1
  };
}
var syncFallback = function(i) {
  return i();
}, useInsertionEffect = React.useInsertionEffect ? React.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect, EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
), CacheProvider = EmotionCacheContext.Provider, withEmotionCache = function(i) {
  return /* @__PURE__ */ forwardRef(function(g, E) {
    var e = useContext(EmotionCacheContext);
    return i(g, e, E);
  });
}, ThemeContext$2 = /* @__PURE__ */ React.createContext({}), useTheme = function() {
  return React.useContext(ThemeContext$2);
}, getTheme = function(i, g) {
  if (typeof g == "function") {
    var E = g(i);
    return E;
  }
  return _extends$C({}, i, g);
}, createCacheWithTheme = /* @__PURE__ */ weakMemoize(function(o) {
  return weakMemoize(function(i) {
    return getTheme(o, i);
  });
}), ThemeProvider$2 = function(i) {
  var g = React.useContext(ThemeContext$2);
  return i.theme !== g && (g = createCacheWithTheme(g)(i.theme)), /* @__PURE__ */ React.createElement(ThemeContext$2.Provider, {
    value: g
  }, i.children);
}, hasOwn = {}.hasOwnProperty, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps = function(i, g) {
  var E = {};
  for (var e in g)
    hasOwn.call(g, e) && (E[e] = g[e]);
  return E[typePropName] = i, E;
}, Insertion$2 = function(i) {
  var g = i.cache, E = i.serialized, e = i.isStringTag;
  return registerStyles(g, E, e), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(g, E, e);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(o, i, g) {
  var E = o.css;
  typeof E == "string" && i.registered[E] !== void 0 && (E = i.registered[E]);
  var e = o[typePropName], t = [E], n = "";
  typeof o.className == "string" ? n = getRegisteredStyles(i.registered, t, o.className) : o.className != null && (n = o.className + " ");
  var h = serializeStyles(t, void 0, React.useContext(ThemeContext$2));
  n += i.key + "-" + h.name;
  var d = {};
  for (var k in o)
    hasOwn.call(o, k) && k !== "css" && k !== typePropName && (d[k] = o[k]);
  return d.className = n, g && (d.ref = g), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$2, {
    cache: i,
    serialized: h,
    isStringTag: typeof e == "string"
  }), /* @__PURE__ */ React.createElement(e, d));
}), Emotion$1 = Emotion, jsx = function(i, g) {
  var E = arguments;
  if (g == null || !hasOwn.call(g, "css"))
    return React.createElement.apply(void 0, E);
  var e = E.length, t = new Array(e);
  t[0] = Emotion$1, t[1] = createEmotionProps(i, g);
  for (var n = 2; n < e; n++)
    t[n] = E[n];
  return React.createElement.apply(null, t);
};
(function(o) {
  var i;
  i || (i = o.JSX || (o.JSX = {}));
})(jsx || (jsx = {}));
var Global = /* @__PURE__ */ withEmotionCache(function(o, i) {
  var g = o.styles, E = serializeStyles([g], void 0, React.useContext(ThemeContext$2)), e = React.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var t = i.key + "-global", n = new i.sheet.constructor({
      key: t,
      nonce: i.sheet.nonce,
      container: i.sheet.container,
      speedy: i.sheet.isSpeedy
    }), h = !1, d = document.querySelector('style[data-emotion="' + t + " " + E.name + '"]');
    return i.sheet.tags.length && (n.before = i.sheet.tags[0]), d !== null && (h = !0, d.setAttribute("data-emotion", t), n.hydrate([d])), e.current = [n, h], function() {
      n.flush();
    };
  }, [i]), useInsertionEffectWithLayoutFallback(function() {
    var t = e.current, n = t[0], h = t[1];
    if (h) {
      t[1] = !1;
      return;
    }
    if (E.next !== void 0 && insertStyles(i, E.next, !0), n.tags.length) {
      var d = n.tags[n.tags.length - 1].nextElementSibling;
      n.before = d, n.flush();
    }
    i.insert("", E, n, !1);
  }, [i, E.name]), null;
});
function css() {
  for (var o = arguments.length, i = new Array(o), g = 0; g < o; g++)
    i[g] = arguments[g];
  return serializeStyles(i);
}
function keyframes() {
  var o = css.apply(void 0, arguments), i = "animation-" + o.name;
  return {
    name: i,
    styles: "@keyframes " + i + "{" + o.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var classnames$1 = function o(i) {
  for (var g = i.length, E = 0, e = ""; E < g; E++) {
    var t = i[E];
    if (t != null) {
      var n = void 0;
      switch (typeof t) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(t))
            n = o(t);
          else {
            n = "";
            for (var h in t)
              t[h] && h && (n && (n += " "), n += h);
          }
          break;
        }
        default:
          n = t;
      }
      n && (e && (e += " "), e += n);
    }
  }
  return e;
};
function merge$2(o, i, g) {
  var E = [], e = getRegisteredStyles(o, E, g);
  return E.length < 2 ? g : e + i(E);
}
var Insertion$1 = function(i) {
  var g = i.cache, E = i.serializedArr;
  return useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var e = 0; e < E.length; e++)
      insertStyles(g, E[e], !1);
  }), null;
}, ClassNames = /* @__PURE__ */ withEmotionCache(function(o, i) {
  var g = [], E = function() {
    for (var d = arguments.length, k = new Array(d), p = 0; p < d; p++)
      k[p] = arguments[p];
    var M = serializeStyles(k, i.registered);
    return g.push(M), registerStyles(i, M, !1), i.key + "-" + M.name;
  }, e = function() {
    for (var d = arguments.length, k = new Array(d), p = 0; p < d; p++)
      k[p] = arguments[p];
    return merge$2(i.registered, E, classnames$1(k));
  }, t = {
    css: E,
    cx: e,
    theme: React.useContext(ThemeContext$2)
  }, n = o.children(t);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: i,
    serializedArr: g
  }), n);
});
const FontFaceDeclaration = ({
  fontFaces: o
}) => {
  const i = o.map((g) => {
    const {
      family: E,
      weight: e,
      weightRange: t,
      url: n,
      style: h,
      unicodeRange: d
    } = g, k = t || e;
    return `
      @font-face {
        font-family: ${E};
        src: url(${n}) format("woff2");
        font-display: swap;
        ${h ? `font-style: ${h};` : ""}
        ${k ? `font-weight: ${k};` : ""}
        ${d ? `unicode-range: ${d};` : ""}
      }
    `;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: /* @__PURE__ */ css(i, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:FontFaceDeclaration;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") });
};
var reactFastCompare, hasRequiredReactFastCompare;
function requireReactFastCompare() {
  if (hasRequiredReactFastCompare) return reactFastCompare;
  hasRequiredReactFastCompare = 1;
  var o = typeof Element < "u", i = typeof Map == "function", g = typeof Set == "function", E = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var h, d, k;
      if (Array.isArray(t)) {
        if (h = t.length, h != n.length) return !1;
        for (d = h; d-- !== 0; )
          if (!e(t[d], n[d])) return !1;
        return !0;
      }
      var p;
      if (i && t instanceof Map && n instanceof Map) {
        if (t.size !== n.size) return !1;
        for (p = t.entries(); !(d = p.next()).done; )
          if (!n.has(d.value[0])) return !1;
        for (p = t.entries(); !(d = p.next()).done; )
          if (!e(d.value[1], n.get(d.value[0]))) return !1;
        return !0;
      }
      if (g && t instanceof Set && n instanceof Set) {
        if (t.size !== n.size) return !1;
        for (p = t.entries(); !(d = p.next()).done; )
          if (!n.has(d.value[0])) return !1;
        return !0;
      }
      if (E && ArrayBuffer.isView(t) && ArrayBuffer.isView(n)) {
        if (h = t.length, h != n.length) return !1;
        for (d = h; d-- !== 0; )
          if (t[d] !== n[d]) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf && typeof t.valueOf == "function" && typeof n.valueOf == "function") return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString && typeof t.toString == "function" && typeof n.toString == "function") return t.toString() === n.toString();
      if (k = Object.keys(t), h = k.length, h !== Object.keys(n).length) return !1;
      for (d = h; d-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, k[d])) return !1;
      if (o && t instanceof Element) return !1;
      for (d = h; d-- !== 0; )
        if (!((k[d] === "_owner" || k[d] === "__v" || k[d] === "__o") && t.$$typeof) && !e(t[k[d]], n[k[d]]))
          return !1;
      return !0;
    }
    return t !== t && n !== n;
  }
  return reactFastCompare = function(n, h) {
    try {
      return e(n, h);
    } catch (d) {
      if ((d.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw d;
    }
  }, reactFastCompare;
}
var reactFastCompareExports = requireReactFastCompare();
const fastCompare = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompareExports);
var browser, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  var o = function(i, g, E, e, t, n, h, d) {
    if (process.env.NODE_ENV !== "production" && g === void 0)
      throw new Error("invariant requires an error message argument");
    if (!i) {
      var k;
      if (g === void 0)
        k = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var p = [E, e, t, n, h, d], M = 0;
        k = new Error(
          g.replace(/%s/g, function() {
            return p[M++];
          })
        ), k.name = "Invariant Violation";
      }
      throw k.framesToPop = 1, k;
    }
  };
  return browser = o, browser;
}
var browserExports = requireBrowser();
const invariant = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var shallowequal, hasRequiredShallowequal;
function requireShallowequal() {
  return hasRequiredShallowequal || (hasRequiredShallowequal = 1, shallowequal = function(i, g, E, e) {
    var t = E ? E.call(e, i, g) : void 0;
    if (t !== void 0)
      return !!t;
    if (i === g)
      return !0;
    if (typeof i != "object" || !i || typeof g != "object" || !g)
      return !1;
    var n = Object.keys(i), h = Object.keys(g);
    if (n.length !== h.length)
      return !1;
    for (var d = Object.prototype.hasOwnProperty.bind(g), k = 0; k < n.length; k++) {
      var p = n[k];
      if (!d(p))
        return !1;
      var M = i[p], H = g[p];
      if (t = E ? E.call(e, M, H, p) : void 0, t === !1 || t === void 0 && M !== H)
        return !1;
    }
    return !0;
  }), shallowequal;
}
var shallowequalExports = requireShallowequal();
const shallowEqual = /* @__PURE__ */ getDefaultExportFromCjs(shallowequalExports);
var TAG_NAMES = /* @__PURE__ */ ((o) => (o.BASE = "base", o.BODY = "body", o.HEAD = "head", o.HTML = "html", o.LINK = "link", o.META = "meta", o.NOSCRIPT = "noscript", o.SCRIPT = "script", o.STYLE = "style", o.TITLE = "title", o.FRAGMENT = "Symbol(react.fragment)", o))(TAG_NAMES || {}), SEO_PRIORITY_TAGS = {
  link: { rel: ["amphtml", "canonical", "alternate"] },
  script: { type: ["application/ld+json"] },
  meta: {
    charset: "",
    name: ["generator", "robots", "description"],
    property: [
      "og:type",
      "og:title",
      "og:url",
      "og:image",
      "og:image:alt",
      "og:description",
      "twitter:url",
      "twitter:title",
      "twitter:description",
      "twitter:image",
      "twitter:image:alt",
      "twitter:card",
      "twitter:site"
    ]
  }
}, VALID_TAG_NAMES = Object.values(TAG_NAMES), REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
}, HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce(
  (o, [i, g]) => (o[g] = i, o),
  {}
), HELMET_ATTRIBUTE = "data-rh", HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate",
  PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
}, getInnermostProperty = (o, i) => {
  for (let g = o.length - 1; g >= 0; g -= 1) {
    const E = o[g];
    if (Object.prototype.hasOwnProperty.call(E, i))
      return E[i];
  }
  return null;
}, getTitleFromPropsList = (o) => {
  let i = getInnermostProperty(
    o,
    "title"
    /* TITLE */
  );
  const g = getInnermostProperty(o, HELMET_PROPS.TITLE_TEMPLATE);
  if (Array.isArray(i) && (i = i.join("")), g && i)
    return g.replace(/%s/g, () => i);
  const E = getInnermostProperty(o, HELMET_PROPS.DEFAULT_TITLE);
  return i || E || void 0;
}, getOnChangeClientState = (o) => getInnermostProperty(o, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (() => {
}), getAttributesFromPropsList = (o, i) => i.filter((g) => typeof g[o] < "u").map((g) => g[o]).reduce((g, E) => ({ ...g, ...E }), {}), getBaseTagFromPropsList = (o, i) => i.filter((g) => typeof g.base < "u").map((g) => g.base).reverse().reduce((g, E) => {
  if (!g.length) {
    const e = Object.keys(E);
    for (let t = 0; t < e.length; t += 1) {
      const h = e[t].toLowerCase();
      if (o.indexOf(h) !== -1 && E[h])
        return g.concat(E);
    }
  }
  return g;
}, []), warn = (o) => console && typeof console.warn == "function" && console.warn(o), getTagsFromPropsList = (o, i, g) => {
  const E = {};
  return g.filter((e) => Array.isArray(e[o]) ? !0 : (typeof e[o] < "u" && warn(
    `Helmet: ${o} should be of type "Array". Instead found type "${typeof e[o]}"`
  ), !1)).map((e) => e[o]).reverse().reduce((e, t) => {
    const n = {};
    t.filter((d) => {
      let k;
      const p = Object.keys(d);
      for (let H = 0; H < p.length; H += 1) {
        const f = p[H], AA = f.toLowerCase();
        i.indexOf(AA) !== -1 && !(k === "rel" && d[k].toLowerCase() === "canonical") && !(AA === "rel" && d[AA].toLowerCase() === "stylesheet") && (k = AA), i.indexOf(f) !== -1 && (f === "innerHTML" || f === "cssText" || f === "itemprop") && (k = f);
      }
      if (!k || !d[k])
        return !1;
      const M = d[k].toLowerCase();
      return E[k] || (E[k] = {}), n[k] || (n[k] = {}), E[k][M] ? !1 : (n[k][M] = !0, !0);
    }).reverse().forEach((d) => e.push(d));
    const h = Object.keys(n);
    for (let d = 0; d < h.length; d += 1) {
      const k = h[d], p = {
        ...E[k],
        ...n[k]
      };
      E[k] = p;
    }
    return e;
  }, []).reverse();
}, getAnyTrueFromPropsList = (o, i) => {
  if (Array.isArray(o) && o.length) {
    for (let g = 0; g < o.length; g += 1)
      if (o[g][i])
        return !0;
  }
  return !1;
}, reducePropsToState$1 = (o) => ({
  baseTag: getBaseTagFromPropsList([
    "href"
    /* HREF */
  ], o),
  bodyAttributes: getAttributesFromPropsList("bodyAttributes", o),
  defer: getInnermostProperty(o, HELMET_PROPS.DEFER),
  encode: getInnermostProperty(o, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
  htmlAttributes: getAttributesFromPropsList("htmlAttributes", o),
  linkTags: getTagsFromPropsList(
    "link",
    [
      "rel",
      "href"
      /* HREF */
    ],
    o
  ),
  metaTags: getTagsFromPropsList(
    "meta",
    [
      "name",
      "charset",
      "http-equiv",
      "property",
      "itemprop"
      /* ITEM_PROP */
    ],
    o
  ),
  noscriptTags: getTagsFromPropsList("noscript", [
    "innerHTML"
    /* INNER_HTML */
  ], o),
  onChangeClientState: getOnChangeClientState(o),
  scriptTags: getTagsFromPropsList(
    "script",
    [
      "src",
      "innerHTML"
      /* INNER_HTML */
    ],
    o
  ),
  styleTags: getTagsFromPropsList("style", [
    "cssText"
    /* CSS_TEXT */
  ], o),
  title: getTitleFromPropsList(o),
  titleAttributes: getAttributesFromPropsList("titleAttributes", o),
  prioritizeSeoTags: getAnyTrueFromPropsList(o, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
}), flattenArray = (o) => Array.isArray(o) ? o.join("") : o, checkIfPropsMatch = (o, i) => {
  const g = Object.keys(o);
  for (let E = 0; E < g.length; E += 1)
    if (i[g[E]] && i[g[E]].includes(o[g[E]]))
      return !0;
  return !1;
}, prioritizer = (o, i) => Array.isArray(o) ? o.reduce(
  (g, E) => (checkIfPropsMatch(E, i) ? g.priority.push(E) : g.default.push(E), g),
  { priority: [], default: [] }
) : { default: o, priority: [] }, without = (o, i) => ({
  ...o,
  [i]: void 0
}), SELF_CLOSING_TAGS = [
  "noscript",
  "script",
  "style"
  /* STYLE */
], encodeSpecialCharacters = (o, i = !0) => i === !1 ? String(o) : String(o).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;"), generateElementAttributesAsString = (o) => Object.keys(o).reduce((i, g) => {
  const E = typeof o[g] < "u" ? `${g}="${o[g]}"` : `${g}`;
  return i ? `${i} ${E}` : E;
}, ""), generateTitleAsString = (o, i, g, E) => {
  const e = generateElementAttributesAsString(g), t = flattenArray(i);
  return e ? `<${o} ${HELMET_ATTRIBUTE}="true" ${e}>${encodeSpecialCharacters(
    t,
    E
  )}</${o}>` : `<${o} ${HELMET_ATTRIBUTE}="true">${encodeSpecialCharacters(
    t,
    E
  )}</${o}>`;
}, generateTagsAsString = (o, i, g = !0) => i.reduce((E, e) => {
  const t = e, n = Object.keys(t).filter(
    (k) => !(k === "innerHTML" || k === "cssText")
  ).reduce((k, p) => {
    const M = typeof t[p] > "u" ? p : `${p}="${encodeSpecialCharacters(t[p], g)}"`;
    return k ? `${k} ${M}` : M;
  }, ""), h = t.innerHTML || t.cssText || "", d = SELF_CLOSING_TAGS.indexOf(o) === -1;
  return `${E}<${o} ${HELMET_ATTRIBUTE}="true" ${n}${d ? "/>" : `>${h}</${o}>`}`;
}, ""), convertElementAttributesToReactProps = (o, i = {}) => Object.keys(o).reduce((g, E) => {
  const e = REACT_TAG_MAP[E];
  return g[e || E] = o[E], g;
}, i), generateTitleAsReactComponent = (o, i, g) => {
  const E = {
    key: i,
    [HELMET_ATTRIBUTE]: !0
  }, e = convertElementAttributesToReactProps(g, E);
  return [React__default.createElement("title", e, i)];
}, generateTagsAsReactComponent = (o, i) => i.map((g, E) => {
  const e = {
    key: E,
    [HELMET_ATTRIBUTE]: !0
  };
  return Object.keys(g).forEach((t) => {
    const h = REACT_TAG_MAP[t] || t;
    if (h === "innerHTML" || h === "cssText") {
      const d = g.innerHTML || g.cssText;
      e.dangerouslySetInnerHTML = { __html: d };
    } else
      e[h] = g[t];
  }), React__default.createElement(o, e);
}), getMethodsForTag = (o, i, g = !0) => {
  switch (o) {
    case "title":
      return {
        toComponent: () => generateTitleAsReactComponent(o, i.title, i.titleAttributes),
        toString: () => generateTitleAsString(o, i.title, i.titleAttributes, g)
      };
    case "bodyAttributes":
    case "htmlAttributes":
      return {
        toComponent: () => convertElementAttributesToReactProps(i),
        toString: () => generateElementAttributesAsString(i)
      };
    default:
      return {
        toComponent: () => generateTagsAsReactComponent(o, i),
        toString: () => generateTagsAsString(o, i, g)
      };
  }
}, getPriorityMethods = ({ metaTags: o, linkTags: i, scriptTags: g, encode: E }) => {
  const e = prioritizer(o, SEO_PRIORITY_TAGS.meta), t = prioritizer(i, SEO_PRIORITY_TAGS.link), n = prioritizer(g, SEO_PRIORITY_TAGS.script);
  return {
    priorityMethods: {
      toComponent: () => [
        ...generateTagsAsReactComponent("meta", e.priority),
        ...generateTagsAsReactComponent("link", t.priority),
        ...generateTagsAsReactComponent("script", n.priority)
      ],
      toString: () => (
        // generate all the tags as strings and concatenate them
        `${getMethodsForTag("meta", e.priority, E)} ${getMethodsForTag(
          "link",
          t.priority,
          E
        )} ${getMethodsForTag("script", n.priority, E)}`
      )
    },
    metaTags: e.default,
    linkTags: t.default,
    scriptTags: n.default
  };
}, mapStateOnServer = (o) => {
  const {
    baseTag: i,
    bodyAttributes: g,
    encode: E = !0,
    htmlAttributes: e,
    noscriptTags: t,
    styleTags: n,
    title: h = "",
    titleAttributes: d,
    prioritizeSeoTags: k
  } = o;
  let { linkTags: p, metaTags: M, scriptTags: H } = o, f = {
    toComponent: () => {
    },
    toString: () => ""
  };
  return k && ({ priorityMethods: f, linkTags: p, metaTags: M, scriptTags: H } = getPriorityMethods(o)), {
    priority: f,
    base: getMethodsForTag("base", i, E),
    bodyAttributes: getMethodsForTag("bodyAttributes", g, E),
    htmlAttributes: getMethodsForTag("htmlAttributes", e, E),
    link: getMethodsForTag("link", p, E),
    meta: getMethodsForTag("meta", M, E),
    noscript: getMethodsForTag("noscript", t, E),
    script: getMethodsForTag("script", H, E),
    style: getMethodsForTag("style", n, E),
    title: getMethodsForTag("title", { title: h, titleAttributes: d }, E)
  };
}, server_default = mapStateOnServer, instances = [], isDocument = !!(typeof window < "u" && window.document && window.document.createElement), HelmetData = class {
  instances = [];
  canUseDOM = isDocument;
  context;
  value = {
    setHelmet: (o) => {
      this.context.helmet = o;
    },
    helmetInstances: {
      get: () => this.canUseDOM ? instances : this.instances,
      add: (o) => {
        (this.canUseDOM ? instances : this.instances).push(o);
      },
      remove: (o) => {
        const i = (this.canUseDOM ? instances : this.instances).indexOf(o);
        (this.canUseDOM ? instances : this.instances).splice(i, 1);
      }
    }
  };
  constructor(o, i) {
    this.context = o, this.canUseDOM = i || !1, i || (o.helmet = server_default({
      baseTag: [],
      bodyAttributes: {},
      htmlAttributes: {},
      linkTags: [],
      metaTags: [],
      noscriptTags: [],
      scriptTags: [],
      styleTags: [],
      title: "",
      titleAttributes: {}
    }));
  }
}, defaultValue = {}, Context = React__default.createContext(defaultValue), HelmetProvider = class GI extends Component {
  static canUseDOM = isDocument;
  helmetData;
  constructor(i) {
    super(i), this.helmetData = new HelmetData(this.props.context || {}, GI.canUseDOM);
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(Context.Provider, { value: this.helmetData.value }, this.props.children);
  }
}, updateTags = (o, i) => {
  const g = document.head || document.querySelector(
    "head"
    /* HEAD */
  ), E = g.querySelectorAll(`${o}[${HELMET_ATTRIBUTE}]`), e = [].slice.call(E), t = [];
  let n;
  return i && i.length && i.forEach((h) => {
    const d = document.createElement(o);
    for (const k in h)
      if (Object.prototype.hasOwnProperty.call(h, k))
        if (k === "innerHTML")
          d.innerHTML = h.innerHTML;
        else if (k === "cssText")
          d.styleSheet ? d.styleSheet.cssText = h.cssText : d.appendChild(document.createTextNode(h.cssText));
        else {
          const p = k, M = typeof h[p] > "u" ? "" : h[p];
          d.setAttribute(k, M);
        }
    d.setAttribute(HELMET_ATTRIBUTE, "true"), e.some((k, p) => (n = p, d.isEqualNode(k))) ? e.splice(n, 1) : t.push(d);
  }), e.forEach((h) => h.parentNode?.removeChild(h)), t.forEach((h) => g.appendChild(h)), {
    oldTags: e,
    newTags: t
  };
}, updateAttributes = (o, i) => {
  const g = document.getElementsByTagName(o)[0];
  if (!g)
    return;
  const E = g.getAttribute(HELMET_ATTRIBUTE), e = E ? E.split(",") : [], t = [...e], n = Object.keys(i);
  for (const h of n) {
    const d = i[h] || "";
    g.getAttribute(h) !== d && g.setAttribute(h, d), e.indexOf(h) === -1 && e.push(h);
    const k = t.indexOf(h);
    k !== -1 && t.splice(k, 1);
  }
  for (let h = t.length - 1; h >= 0; h -= 1)
    g.removeAttribute(t[h]);
  e.length === t.length ? g.removeAttribute(HELMET_ATTRIBUTE) : g.getAttribute(HELMET_ATTRIBUTE) !== n.join(",") && g.setAttribute(HELMET_ATTRIBUTE, n.join(","));
}, updateTitle = (o, i) => {
  typeof o < "u" && document.title !== o && (document.title = flattenArray(o)), updateAttributes("title", i);
}, commitTagChanges = (o, i) => {
  const {
    baseTag: g,
    bodyAttributes: E,
    htmlAttributes: e,
    linkTags: t,
    metaTags: n,
    noscriptTags: h,
    onChangeClientState: d,
    scriptTags: k,
    styleTags: p,
    title: M,
    titleAttributes: H
  } = o;
  updateAttributes("body", E), updateAttributes("html", e), updateTitle(M, H);
  const f = {
    baseTag: updateTags("base", g),
    linkTags: updateTags("link", t),
    metaTags: updateTags("meta", n),
    noscriptTags: updateTags("noscript", h),
    scriptTags: updateTags("script", k),
    styleTags: updateTags("style", p)
  }, AA = {}, gA = {};
  Object.keys(f).forEach((IA) => {
    const { newTags: BA, oldTags: CA } = f[IA];
    BA.length && (AA[IA] = BA), CA.length && (gA[IA] = f[IA].oldTags);
  }), i && i(), d(o, AA, gA);
}, _helmetCallback = null, handleStateChangeOnClient$1 = (o) => {
  _helmetCallback && cancelAnimationFrame(_helmetCallback), o.defer ? _helmetCallback = requestAnimationFrame(() => {
    commitTagChanges(o, () => {
      _helmetCallback = null;
    });
  }) : (commitTagChanges(o), _helmetCallback = null);
}, client_default = handleStateChangeOnClient$1, HelmetDispatcher = class extends Component {
  rendered = !1;
  shouldComponentUpdate(o) {
    return !shallowEqual(o, this.props);
  }
  componentDidUpdate() {
    this.emitChange();
  }
  componentWillUnmount() {
    const { helmetInstances: o } = this.props.context;
    o.remove(this), this.emitChange();
  }
  emitChange() {
    const { helmetInstances: o, setHelmet: i } = this.props.context;
    let g = null;
    const E = reducePropsToState$1(
      o.get().map((e) => {
        const t = { ...e.props };
        return delete t.context, t;
      })
    );
    HelmetProvider.canUseDOM ? client_default(E) : server_default && (g = server_default(E)), i(g);
  }
  // componentWillMount will be deprecated
  // for SSR, initialize on first render
  // constructor is also unsafe in StrictMode
  init() {
    if (this.rendered)
      return;
    this.rendered = !0;
    const { helmetInstances: o } = this.props.context;
    o.add(this), this.emitChange();
  }
  render() {
    return this.init(), null;
  }
}, Helmet = class extends Component {
  static defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
  };
  shouldComponentUpdate(o) {
    return !fastCompare(without(this.props, "helmetData"), without(o, "helmetData"));
  }
  mapNestedChildrenToProps(o, i) {
    if (!i)
      return null;
    switch (o.type) {
      case "script":
      case "noscript":
        return {
          innerHTML: i
        };
      case "style":
        return {
          cssText: i
        };
      default:
        throw new Error(
          `<${o.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`
        );
    }
  }
  flattenArrayTypeChildren(o, i, g, E) {
    return {
      ...i,
      [o.type]: [
        ...i[o.type] || [],
        {
          ...g,
          ...this.mapNestedChildrenToProps(o, E)
        }
      ]
    };
  }
  mapObjectTypeChildren(o, i, g, E) {
    switch (o.type) {
      case "title":
        return {
          ...i,
          [o.type]: E,
          titleAttributes: { ...g }
        };
      case "body":
        return {
          ...i,
          bodyAttributes: { ...g }
        };
      case "html":
        return {
          ...i,
          htmlAttributes: { ...g }
        };
      default:
        return {
          ...i,
          [o.type]: { ...g }
        };
    }
  }
  mapArrayTypeChildrenToProps(o, i) {
    let g = { ...i };
    return Object.keys(o).forEach((E) => {
      g = {
        ...g,
        [E]: o[E]
      };
    }), g;
  }
  warnOnInvalidChildren(o, i) {
    return invariant(
      VALID_TAG_NAMES.some((g) => o.type === g),
      typeof o.type == "function" ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : `Only elements types ${VALID_TAG_NAMES.join(
        ", "
      )} are allowed. Helmet does not support rendering <${o.type}> elements. Refer to our API for more information.`
    ), invariant(
      !i || typeof i == "string" || Array.isArray(i) && !i.some((g) => typeof g != "string"),
      `Helmet expects a string as a child of <${o.type}>. Did you forget to wrap your children in braces? ( <${o.type}>{\`\`}</${o.type}> ) Refer to our API for more information.`
    ), !0;
  }
  mapChildrenToProps(o, i) {
    let g = {};
    return React__default.Children.forEach(o, (E) => {
      if (!E || !E.props)
        return;
      const { children: e, ...t } = E.props, n = Object.keys(t).reduce((d, k) => (d[HTML_TAG_MAP[k] || k] = t[k], d), {});
      let { type: h } = E;
      switch (typeof h == "symbol" ? h = h.toString() : this.warnOnInvalidChildren(E, e), h) {
        case "Symbol(react.fragment)":
          i = this.mapChildrenToProps(e, i);
          break;
        case "link":
        case "meta":
        case "noscript":
        case "script":
        case "style":
          g = this.flattenArrayTypeChildren(
            E,
            g,
            n,
            e
          );
          break;
        default:
          i = this.mapObjectTypeChildren(E, i, n, e);
          break;
      }
    }), this.mapArrayTypeChildrenToProps(g, i);
  }
  render() {
    const { children: o, ...i } = this.props;
    let g = { ...i }, { helmetData: E } = i;
    if (o && (g = this.mapChildrenToProps(o, g)), E && !(E instanceof HelmetData)) {
      const e = E;
      E = new HelmetData(e.context, !0), delete g.helmetData;
    }
    return E ? /* @__PURE__ */ React__default.createElement(HelmetDispatcher, { ...g, context: E.value }) : /* @__PURE__ */ React__default.createElement(Context.Consumer, null, (e) => /* @__PURE__ */ React__default.createElement(HelmetDispatcher, { ...g, context: e }));
  }
};
const FontSources = ({
  fontSources: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Helmet, { children: Object.entries(o).map(([i, g]) => /* @__PURE__ */ jsxRuntimeExports.jsx("link", { id: i, rel: "stylesheet", href: g }, i)) });
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let o, i;
  const g = new Promise((E, e) => {
    o = E, i = e;
  });
  return {
    resolve: o,
    reject: i,
    promise: g
  };
});
function getCookie(o) {
  const i = document.cookie.match(`\\b${o}=([^;]*)\\b`);
  return i ? i[1] : void 0;
}
function localStorageAvailable() {
  const o = "testData";
  try {
    const {
      localStorage: i
    } = window;
    i.setItem(o, o), i.getItem(o), i.removeItem(o);
  } catch {
    return !1;
  }
  return !0;
}
function isValidAllowedOrigins(o) {
  return Array.isArray(o) && o.length > 0 && o.every((i) => typeof i == "string" && i.trim().length > 0);
}
function deepClone(o) {
  return typeof structuredClone == "function" ? structuredClone(o) : JSON.parse(JSON.stringify(o));
}
function deepFreeze(o) {
  return Object.freeze(o), Array.isArray(o) ? o.forEach((i) => {
    i !== null && typeof i == "object" && !Object.isFrozen(i) && deepFreeze(i);
  }) : Object.values(o).forEach((i) => {
    i !== null && typeof i == "object" && !Object.isFrozen(i) && deepFreeze(i);
  }), o;
}
const capturedConfig = (() => {
  const o = window.__streamlit;
  if (!o)
    return;
  const i = deepClone(o);
  return deepFreeze(i);
})(), StreamlitConfig = {
  get BACKEND_BASE_URL() {
    return capturedConfig?.BACKEND_BASE_URL;
  },
  get HOST_CONFIG_BASE_URL() {
    return capturedConfig?.HOST_CONFIG_BASE_URL;
  },
  get DOWNLOAD_ASSETS_BASE_URL() {
    return capturedConfig?.DOWNLOAD_ASSETS_BASE_URL;
  },
  get MAIN_PAGE_BASE_URL() {
    return capturedConfig?.MAIN_PAGE_BASE_URL;
  },
  get CUSTOM_COMPONENT_CLIENT_ID() {
    return capturedConfig?.CUSTOM_COMPONENT_CLIENT_ID;
  },
  get LIGHT_THEME() {
    return capturedConfig?.LIGHT_THEME;
  },
  get DARK_THEME() {
    return capturedConfig?.DARK_THEME;
  },
  get ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION() {
    return capturedConfig?.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION;
  },
  get HOST_CONFIG() {
    return capturedConfig?.HOST_CONFIG;
  }
};
function notNullOrUndefined(o) {
  return o != null;
}
function isNullOrUndefined(o) {
  return o == null;
}
const isLocalhost = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1", NO_SCRIPT_RUN_ID = "NO_SCRIPT_RUN_ID";
var indexMinimal$1 = {}, minimal$3 = {}, aspromise$1, hasRequiredAspromise$1;
function requireAspromise$1() {
  if (hasRequiredAspromise$1) return aspromise$1;
  hasRequiredAspromise$1 = 1, aspromise$1 = o;
  function o(i, g) {
    for (var E = new Array(arguments.length - 1), e = 0, t = 2, n = !0; t < arguments.length; )
      E[e++] = arguments[t++];
    return new Promise(function(d, k) {
      E[e] = function(M) {
        if (n)
          if (n = !1, M)
            k(M);
          else {
            for (var H = new Array(arguments.length - 1), f = 0; f < H.length; )
              H[f++] = arguments[f];
            d.apply(null, H);
          }
      };
      try {
        i.apply(g || null, E);
      } catch (p) {
        n && (n = !1, k(p));
      }
    });
  }
  return aspromise$1;
}
var base64$1 = {}, hasRequiredBase64$1;
function requireBase64$1() {
  return hasRequiredBase64$1 || (hasRequiredBase64$1 = 1, (function(o) {
    var i = o;
    i.length = function(h) {
      var d = h.length;
      if (!d)
        return 0;
      for (var k = 0; --d % 4 > 1 && h.charAt(d) === "="; )
        ++k;
      return Math.ceil(h.length * 3) / 4 - k;
    };
    for (var g = new Array(64), E = new Array(123), e = 0; e < 64; )
      E[g[e] = e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e - 59 | 43] = e++;
    i.encode = function(h, d, k) {
      for (var p = null, M = [], H = 0, f = 0, AA; d < k; ) {
        var gA = h[d++];
        switch (f) {
          case 0:
            M[H++] = g[gA >> 2], AA = (gA & 3) << 4, f = 1;
            break;
          case 1:
            M[H++] = g[AA | gA >> 4], AA = (gA & 15) << 2, f = 2;
            break;
          case 2:
            M[H++] = g[AA | gA >> 6], M[H++] = g[gA & 63], f = 0;
            break;
        }
        H > 8191 && ((p || (p = [])).push(String.fromCharCode.apply(String, M)), H = 0);
      }
      return f && (M[H++] = g[AA], M[H++] = 61, f === 1 && (M[H++] = 61)), p ? (H && p.push(String.fromCharCode.apply(String, M.slice(0, H))), p.join("")) : String.fromCharCode.apply(String, M.slice(0, H));
    };
    var t = "invalid encoding";
    i.decode = function(h, d, k) {
      for (var p = k, M = 0, H, f = 0; f < h.length; ) {
        var AA = h.charCodeAt(f++);
        if (AA === 61 && M > 1)
          break;
        if ((AA = E[AA]) === void 0)
          throw Error(t);
        switch (M) {
          case 0:
            H = AA, M = 1;
            break;
          case 1:
            d[k++] = H << 2 | (AA & 48) >> 4, H = AA, M = 2;
            break;
          case 2:
            d[k++] = (H & 15) << 4 | (AA & 60) >> 2, H = AA, M = 3;
            break;
          case 3:
            d[k++] = (H & 3) << 6 | AA, M = 0;
            break;
        }
      }
      if (M === 1)
        throw Error(t);
      return k - p;
    }, i.test = function(h) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(h);
    };
  })(base64$1)), base64$1;
}
var eventemitter$1, hasRequiredEventemitter$1;
function requireEventemitter$1() {
  if (hasRequiredEventemitter$1) return eventemitter$1;
  hasRequiredEventemitter$1 = 1, eventemitter$1 = o;
  function o() {
    this._listeners = {};
  }
  return o.prototype.on = function(g, E, e) {
    return (this._listeners[g] || (this._listeners[g] = [])).push({
      fn: E,
      ctx: e || this
    }), this;
  }, o.prototype.off = function(g, E) {
    if (g === void 0)
      this._listeners = {};
    else if (E === void 0)
      this._listeners[g] = [];
    else
      for (var e = this._listeners[g], t = 0; t < e.length; )
        e[t].fn === E ? e.splice(t, 1) : ++t;
    return this;
  }, o.prototype.emit = function(g) {
    var E = this._listeners[g];
    if (E) {
      for (var e = [], t = 1; t < arguments.length; )
        e.push(arguments[t++]);
      for (t = 0; t < E.length; )
        E[t].fn.apply(E[t++].ctx, e);
    }
    return this;
  }, eventemitter$1;
}
var float$1, hasRequiredFloat$1;
function requireFloat$1() {
  if (hasRequiredFloat$1) return float$1;
  hasRequiredFloat$1 = 1, float$1 = o(o);
  function o(t) {
    return typeof Float32Array < "u" ? (function() {
      var n = new Float32Array([-0]), h = new Uint8Array(n.buffer), d = h[3] === 128;
      function k(f, AA, gA) {
        n[0] = f, AA[gA] = h[0], AA[gA + 1] = h[1], AA[gA + 2] = h[2], AA[gA + 3] = h[3];
      }
      function p(f, AA, gA) {
        n[0] = f, AA[gA] = h[3], AA[gA + 1] = h[2], AA[gA + 2] = h[1], AA[gA + 3] = h[0];
      }
      t.writeFloatLE = d ? k : p, t.writeFloatBE = d ? p : k;
      function M(f, AA) {
        return h[0] = f[AA], h[1] = f[AA + 1], h[2] = f[AA + 2], h[3] = f[AA + 3], n[0];
      }
      function H(f, AA) {
        return h[3] = f[AA], h[2] = f[AA + 1], h[1] = f[AA + 2], h[0] = f[AA + 3], n[0];
      }
      t.readFloatLE = d ? M : H, t.readFloatBE = d ? H : M;
    })() : (function() {
      function n(d, k, p, M) {
        var H = k < 0 ? 1 : 0;
        if (H && (k = -k), k === 0)
          d(1 / k > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), p, M);
        else if (isNaN(k))
          d(2143289344, p, M);
        else if (k > 34028234663852886e22)
          d((H << 31 | 2139095040) >>> 0, p, M);
        else if (k < 11754943508222875e-54)
          d((H << 31 | Math.round(k / 1401298464324817e-60)) >>> 0, p, M);
        else {
          var f = Math.floor(Math.log(k) / Math.LN2), AA = Math.round(k * Math.pow(2, -f) * 8388608) & 8388607;
          d((H << 31 | f + 127 << 23 | AA) >>> 0, p, M);
        }
      }
      t.writeFloatLE = n.bind(null, i), t.writeFloatBE = n.bind(null, g);
      function h(d, k, p) {
        var M = d(k, p), H = (M >> 31) * 2 + 1, f = M >>> 23 & 255, AA = M & 8388607;
        return f === 255 ? AA ? NaN : H * (1 / 0) : f === 0 ? H * 1401298464324817e-60 * AA : H * Math.pow(2, f - 150) * (AA + 8388608);
      }
      t.readFloatLE = h.bind(null, E), t.readFloatBE = h.bind(null, e);
    })(), typeof Float64Array < "u" ? (function() {
      var n = new Float64Array([-0]), h = new Uint8Array(n.buffer), d = h[7] === 128;
      function k(f, AA, gA) {
        n[0] = f, AA[gA] = h[0], AA[gA + 1] = h[1], AA[gA + 2] = h[2], AA[gA + 3] = h[3], AA[gA + 4] = h[4], AA[gA + 5] = h[5], AA[gA + 6] = h[6], AA[gA + 7] = h[7];
      }
      function p(f, AA, gA) {
        n[0] = f, AA[gA] = h[7], AA[gA + 1] = h[6], AA[gA + 2] = h[5], AA[gA + 3] = h[4], AA[gA + 4] = h[3], AA[gA + 5] = h[2], AA[gA + 6] = h[1], AA[gA + 7] = h[0];
      }
      t.writeDoubleLE = d ? k : p, t.writeDoubleBE = d ? p : k;
      function M(f, AA) {
        return h[0] = f[AA], h[1] = f[AA + 1], h[2] = f[AA + 2], h[3] = f[AA + 3], h[4] = f[AA + 4], h[5] = f[AA + 5], h[6] = f[AA + 6], h[7] = f[AA + 7], n[0];
      }
      function H(f, AA) {
        return h[7] = f[AA], h[6] = f[AA + 1], h[5] = f[AA + 2], h[4] = f[AA + 3], h[3] = f[AA + 4], h[2] = f[AA + 5], h[1] = f[AA + 6], h[0] = f[AA + 7], n[0];
      }
      t.readDoubleLE = d ? M : H, t.readDoubleBE = d ? H : M;
    })() : (function() {
      function n(d, k, p, M, H, f) {
        var AA = M < 0 ? 1 : 0;
        if (AA && (M = -M), M === 0)
          d(0, H, f + k), d(1 / M > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), H, f + p);
        else if (isNaN(M))
          d(0, H, f + k), d(2146959360, H, f + p);
        else if (M > 17976931348623157e292)
          d(0, H, f + k), d((AA << 31 | 2146435072) >>> 0, H, f + p);
        else {
          var gA;
          if (M < 22250738585072014e-324)
            gA = M / 5e-324, d(gA >>> 0, H, f + k), d((AA << 31 | gA / 4294967296) >>> 0, H, f + p);
          else {
            var IA = Math.floor(Math.log(M) / Math.LN2);
            IA === 1024 && (IA = 1023), gA = M * Math.pow(2, -IA), d(gA * 4503599627370496 >>> 0, H, f + k), d((AA << 31 | IA + 1023 << 20 | gA * 1048576 & 1048575) >>> 0, H, f + p);
          }
        }
      }
      t.writeDoubleLE = n.bind(null, i, 0, 4), t.writeDoubleBE = n.bind(null, g, 4, 0);
      function h(d, k, p, M, H) {
        var f = d(M, H + k), AA = d(M, H + p), gA = (AA >> 31) * 2 + 1, IA = AA >>> 20 & 2047, BA = 4294967296 * (AA & 1048575) + f;
        return IA === 2047 ? BA ? NaN : gA * (1 / 0) : IA === 0 ? gA * 5e-324 * BA : gA * Math.pow(2, IA - 1075) * (BA + 4503599627370496);
      }
      t.readDoubleLE = h.bind(null, E, 0, 4), t.readDoubleBE = h.bind(null, e, 4, 0);
    })(), t;
  }
  function i(t, n, h) {
    n[h] = t & 255, n[h + 1] = t >>> 8 & 255, n[h + 2] = t >>> 16 & 255, n[h + 3] = t >>> 24;
  }
  function g(t, n, h) {
    n[h] = t >>> 24, n[h + 1] = t >>> 16 & 255, n[h + 2] = t >>> 8 & 255, n[h + 3] = t & 255;
  }
  function E(t, n) {
    return (t[n] | t[n + 1] << 8 | t[n + 2] << 16 | t[n + 3] << 24) >>> 0;
  }
  function e(t, n) {
    return (t[n] << 24 | t[n + 1] << 16 | t[n + 2] << 8 | t[n + 3]) >>> 0;
  }
  return float$1;
}
var inquire_1$1, hasRequiredInquire$1;
function requireInquire$1() {
  if (hasRequiredInquire$1) return inquire_1$1;
  hasRequiredInquire$1 = 1, inquire_1$1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (o) {
    }
    return null;
  }
  return inquire_1$1;
}
var utf8$1 = {}, hasRequiredUtf8$1;
function requireUtf8$1() {
  return hasRequiredUtf8$1 || (hasRequiredUtf8$1 = 1, (function(o) {
    var i = o;
    i.length = function(E) {
      for (var e = 0, t = 0, n = 0; n < E.length; ++n)
        t = E.charCodeAt(n), t < 128 ? e += 1 : t < 2048 ? e += 2 : (t & 64512) === 55296 && (E.charCodeAt(n + 1) & 64512) === 56320 ? (++n, e += 4) : e += 3;
      return e;
    }, i.read = function(E, e, t) {
      var n = t - e;
      if (n < 1)
        return "";
      for (var h = null, d = [], k = 0, p; e < t; )
        p = E[e++], p < 128 ? d[k++] = p : p > 191 && p < 224 ? d[k++] = (p & 31) << 6 | E[e++] & 63 : p > 239 && p < 365 ? (p = ((p & 7) << 18 | (E[e++] & 63) << 12 | (E[e++] & 63) << 6 | E[e++] & 63) - 65536, d[k++] = 55296 + (p >> 10), d[k++] = 56320 + (p & 1023)) : d[k++] = (p & 15) << 12 | (E[e++] & 63) << 6 | E[e++] & 63, k > 8191 && ((h || (h = [])).push(String.fromCharCode.apply(String, d)), k = 0);
      return h ? (k && h.push(String.fromCharCode.apply(String, d.slice(0, k))), h.join("")) : String.fromCharCode.apply(String, d.slice(0, k));
    }, i.write = function(E, e, t) {
      for (var n = t, h, d, k = 0; k < E.length; ++k)
        h = E.charCodeAt(k), h < 128 ? e[t++] = h : h < 2048 ? (e[t++] = h >> 6 | 192, e[t++] = h & 63 | 128) : (h & 64512) === 55296 && ((d = E.charCodeAt(k + 1)) & 64512) === 56320 ? (h = 65536 + ((h & 1023) << 10) + (d & 1023), ++k, e[t++] = h >> 18 | 240, e[t++] = h >> 12 & 63 | 128, e[t++] = h >> 6 & 63 | 128, e[t++] = h & 63 | 128) : (e[t++] = h >> 12 | 224, e[t++] = h >> 6 & 63 | 128, e[t++] = h & 63 | 128);
      return t - n;
    };
  })(utf8$1)), utf8$1;
}
var pool_1$1, hasRequiredPool$1;
function requirePool$1() {
  if (hasRequiredPool$1) return pool_1$1;
  hasRequiredPool$1 = 1, pool_1$1 = o;
  function o(i, g, E) {
    var e = E || 8192, t = e >>> 1, n = null, h = e;
    return function(k) {
      if (k < 1 || k > t)
        return i(k);
      h + k > e && (n = i(e), h = 0);
      var p = g.call(n, h, h += k);
      return h & 7 && (h = (h | 7) + 1), p;
    };
  }
  return pool_1$1;
}
var longbits$1, hasRequiredLongbits$1;
function requireLongbits$1() {
  if (hasRequiredLongbits$1) return longbits$1;
  hasRequiredLongbits$1 = 1, longbits$1 = i;
  var o = requireMinimal$3();
  function i(t, n) {
    this.lo = t >>> 0, this.hi = n >>> 0;
  }
  var g = i.zero = new i(0, 0);
  g.toNumber = function() {
    return 0;
  }, g.zzEncode = g.zzDecode = function() {
    return this;
  }, g.length = function() {
    return 1;
  };
  var E = i.zeroHash = "\0\0\0\0\0\0\0\0";
  i.fromNumber = function(n) {
    if (n === 0)
      return g;
    var h = n < 0;
    h && (n = -n);
    var d = n >>> 0, k = (n - d) / 4294967296 >>> 0;
    return h && (k = ~k >>> 0, d = ~d >>> 0, ++d > 4294967295 && (d = 0, ++k > 4294967295 && (k = 0))), new i(d, k);
  }, i.from = function(n) {
    if (typeof n == "number")
      return i.fromNumber(n);
    if (o.isString(n))
      if (o.Long)
        n = o.Long.fromString(n);
      else
        return i.fromNumber(parseInt(n, 10));
    return n.low || n.high ? new i(n.low >>> 0, n.high >>> 0) : g;
  }, i.prototype.toNumber = function(n) {
    if (!n && this.hi >>> 31) {
      var h = ~this.lo + 1 >>> 0, d = ~this.hi >>> 0;
      return h || (d = d + 1 >>> 0), -(h + d * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, i.prototype.toLong = function(n) {
    return o.Long ? new o.Long(this.lo | 0, this.hi | 0, !!n) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!n };
  };
  var e = String.prototype.charCodeAt;
  return i.fromHash = function(n) {
    return n === E ? g : new i(
      (e.call(n, 0) | e.call(n, 1) << 8 | e.call(n, 2) << 16 | e.call(n, 3) << 24) >>> 0,
      (e.call(n, 4) | e.call(n, 5) << 8 | e.call(n, 6) << 16 | e.call(n, 7) << 24) >>> 0
    );
  }, i.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, i.prototype.zzEncode = function() {
    var n = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ n) >>> 0, this.lo = (this.lo << 1 ^ n) >>> 0, this;
  }, i.prototype.zzDecode = function() {
    var n = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ n) >>> 0, this.hi = (this.hi >>> 1 ^ n) >>> 0, this;
  }, i.prototype.length = function() {
    var n = this.lo, h = (this.lo >>> 28 | this.hi << 4) >>> 0, d = this.hi >>> 24;
    return d === 0 ? h === 0 ? n < 16384 ? n < 128 ? 1 : 2 : n < 2097152 ? 3 : 4 : h < 16384 ? h < 128 ? 5 : 6 : h < 2097152 ? 7 : 8 : d < 128 ? 9 : 10;
  }, longbits$1;
}
var hasRequiredMinimal$3;
function requireMinimal$3() {
  return hasRequiredMinimal$3 || (hasRequiredMinimal$3 = 1, (function(o) {
    var i = o;
    i.asPromise = requireAspromise$1(), i.base64 = requireBase64$1(), i.EventEmitter = requireEventemitter$1(), i.float = requireFloat$1(), i.inquire = requireInquire$1(), i.utf8 = requireUtf8$1(), i.pool = requirePool$1(), i.LongBits = requireLongbits$1(), i.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), i.global = i.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || minimal$3, i.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), i.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), i.isInteger = Number.isInteger || /* istanbul ignore next */
    function(t) {
      return typeof t == "number" && isFinite(t) && Math.floor(t) === t;
    }, i.isString = function(t) {
      return typeof t == "string" || t instanceof String;
    }, i.isObject = function(t) {
      return t && typeof t == "object";
    }, i.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    i.isSet = function(t, n) {
      var h = t[n];
      return h != null && t.hasOwnProperty(n) ? typeof h != "object" || (Array.isArray(h) ? h.length : Object.keys(h).length) > 0 : !1;
    }, i.Buffer = (function() {
      try {
        var e = i.inquire("buffer").Buffer;
        return e.prototype.utf8Write ? e : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    })(), i._Buffer_from = null, i._Buffer_allocUnsafe = null, i.newBuffer = function(t) {
      return typeof t == "number" ? i.Buffer ? i._Buffer_allocUnsafe(t) : new i.Array(t) : i.Buffer ? i._Buffer_from(t) : typeof Uint8Array > "u" ? t : new Uint8Array(t);
    }, i.Array = typeof Uint8Array < "u" ? Uint8Array : Array, i.Long = /* istanbul ignore next */
    i.global.dcodeIO && /* istanbul ignore next */
    i.global.dcodeIO.Long || /* istanbul ignore next */
    i.global.Long || i.inquire("long"), i.key2Re = /^true|false|0|1$/, i.key32Re = /^-?(?:0|[1-9][0-9]*)$/, i.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, i.longToHash = function(t) {
      return t ? i.LongBits.from(t).toHash() : i.LongBits.zeroHash;
    }, i.longFromHash = function(t, n) {
      var h = i.LongBits.fromHash(t);
      return i.Long ? i.Long.fromBits(h.lo, h.hi, n) : h.toNumber(!!n);
    };
    function g(e, t, n) {
      for (var h = Object.keys(t), d = 0; d < h.length; ++d)
        (e[h[d]] === void 0 || !n) && (e[h[d]] = t[h[d]]);
      return e;
    }
    i.merge = g, i.lcFirst = function(t) {
      return t.charAt(0).toLowerCase() + t.substring(1);
    };
    function E(e) {
      function t(n, h) {
        if (!(this instanceof t))
          return new t(n, h);
        Object.defineProperty(this, "message", { get: function() {
          return n;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), h && g(this, h);
      }
      return t.prototype = Object.create(Error.prototype, {
        constructor: {
          value: t,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return e;
          },
          set: void 0,
          enumerable: !1,
          // configurable: false would accurately preserve the behavior of
          // the original, but I'm guessing that was not intentional.
          // For an actual error subclass, this property would
          // be configurable.
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), t;
    }
    i.newError = E, i.ProtocolError = E("ProtocolError"), i.oneOfGetter = function(t) {
      for (var n = {}, h = 0; h < t.length; ++h)
        n[t[h]] = 1;
      return function() {
        for (var d = Object.keys(this), k = d.length - 1; k > -1; --k)
          if (n[d[k]] === 1 && this[d[k]] !== void 0 && this[d[k]] !== null)
            return d[k];
      };
    }, i.oneOfSetter = function(t) {
      return function(n) {
        for (var h = 0; h < t.length; ++h)
          t[h] !== n && delete this[t[h]];
      };
    }, i.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, i._configure = function() {
      var e = i.Buffer;
      if (!e) {
        i._Buffer_from = i._Buffer_allocUnsafe = null;
        return;
      }
      i._Buffer_from = e.from !== Uint8Array.from && e.from || /* istanbul ignore next */
      function(n, h) {
        return new e(n, h);
      }, i._Buffer_allocUnsafe = e.allocUnsafe || /* istanbul ignore next */
      function(n) {
        return new e(n);
      };
    };
  })(minimal$3)), minimal$3;
}
var writer$1, hasRequiredWriter$1;
function requireWriter$1() {
  if (hasRequiredWriter$1) return writer$1;
  hasRequiredWriter$1 = 1, writer$1 = d;
  var o = requireMinimal$3(), i, g = o.LongBits, E = o.base64, e = o.utf8;
  function t(IA, BA, CA) {
    this.fn = IA, this.len = BA, this.next = void 0, this.val = CA;
  }
  function n() {
  }
  function h(IA) {
    this.head = IA.head, this.tail = IA.tail, this.len = IA.len, this.next = IA.states;
  }
  function d() {
    this.len = 0, this.head = new t(n, 0, 0), this.tail = this.head, this.states = null;
  }
  var k = function() {
    return o.Buffer ? function() {
      return (d.create = function() {
        return new i();
      })();
    } : function() {
      return new d();
    };
  };
  d.create = k(), d.alloc = function(BA) {
    return new o.Array(BA);
  }, o.Array !== Array && (d.alloc = o.pool(d.alloc, o.Array.prototype.subarray)), d.prototype._push = function(BA, CA, QA) {
    return this.tail = this.tail.next = new t(BA, CA, QA), this.len += CA, this;
  };
  function p(IA, BA, CA) {
    BA[CA] = IA & 255;
  }
  function M(IA, BA, CA) {
    for (; IA > 127; )
      BA[CA++] = IA & 127 | 128, IA >>>= 7;
    BA[CA] = IA;
  }
  function H(IA, BA) {
    this.len = IA, this.next = void 0, this.val = BA;
  }
  H.prototype = Object.create(t.prototype), H.prototype.fn = M, d.prototype.uint32 = function(BA) {
    return this.len += (this.tail = this.tail.next = new H(
      (BA = BA >>> 0) < 128 ? 1 : BA < 16384 ? 2 : BA < 2097152 ? 3 : BA < 268435456 ? 4 : 5,
      BA
    )).len, this;
  }, d.prototype.int32 = function(BA) {
    return BA < 0 ? this._push(f, 10, g.fromNumber(BA)) : this.uint32(BA);
  }, d.prototype.sint32 = function(BA) {
    return this.uint32((BA << 1 ^ BA >> 31) >>> 0);
  };
  function f(IA, BA, CA) {
    for (; IA.hi; )
      BA[CA++] = IA.lo & 127 | 128, IA.lo = (IA.lo >>> 7 | IA.hi << 25) >>> 0, IA.hi >>>= 7;
    for (; IA.lo > 127; )
      BA[CA++] = IA.lo & 127 | 128, IA.lo = IA.lo >>> 7;
    BA[CA++] = IA.lo;
  }
  d.prototype.uint64 = function(BA) {
    var CA = g.from(BA);
    return this._push(f, CA.length(), CA);
  }, d.prototype.int64 = d.prototype.uint64, d.prototype.sint64 = function(BA) {
    var CA = g.from(BA).zzEncode();
    return this._push(f, CA.length(), CA);
  }, d.prototype.bool = function(BA) {
    return this._push(p, 1, BA ? 1 : 0);
  };
  function AA(IA, BA, CA) {
    BA[CA] = IA & 255, BA[CA + 1] = IA >>> 8 & 255, BA[CA + 2] = IA >>> 16 & 255, BA[CA + 3] = IA >>> 24;
  }
  d.prototype.fixed32 = function(BA) {
    return this._push(AA, 4, BA >>> 0);
  }, d.prototype.sfixed32 = d.prototype.fixed32, d.prototype.fixed64 = function(BA) {
    var CA = g.from(BA);
    return this._push(AA, 4, CA.lo)._push(AA, 4, CA.hi);
  }, d.prototype.sfixed64 = d.prototype.fixed64, d.prototype.float = function(BA) {
    return this._push(o.float.writeFloatLE, 4, BA);
  }, d.prototype.double = function(BA) {
    return this._push(o.float.writeDoubleLE, 8, BA);
  };
  var gA = o.Array.prototype.set ? function(BA, CA, QA) {
    CA.set(BA, QA);
  } : function(BA, CA, QA) {
    for (var iA = 0; iA < BA.length; ++iA)
      CA[QA + iA] = BA[iA];
  };
  return d.prototype.bytes = function(BA) {
    var CA = BA.length >>> 0;
    if (!CA)
      return this._push(p, 1, 0);
    if (o.isString(BA)) {
      var QA = d.alloc(CA = E.length(BA));
      E.decode(BA, QA, 0), BA = QA;
    }
    return this.uint32(CA)._push(gA, CA, BA);
  }, d.prototype.string = function(BA) {
    var CA = e.length(BA);
    return CA ? this.uint32(CA)._push(e.write, CA, BA) : this._push(p, 1, 0);
  }, d.prototype.fork = function() {
    return this.states = new h(this), this.head = this.tail = new t(n, 0, 0), this.len = 0, this;
  }, d.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new t(n, 0, 0), this.len = 0), this;
  }, d.prototype.ldelim = function() {
    var BA = this.head, CA = this.tail, QA = this.len;
    return this.reset().uint32(QA), QA && (this.tail.next = BA.next, this.tail = CA, this.len += QA), this;
  }, d.prototype.finish = function() {
    for (var BA = this.head.next, CA = this.constructor.alloc(this.len), QA = 0; BA; )
      BA.fn(BA.val, CA, QA), QA += BA.len, BA = BA.next;
    return CA;
  }, d._configure = function(IA) {
    i = IA, d.create = k(), i._configure();
  }, writer$1;
}
var writer_buffer$1, hasRequiredWriter_buffer$1;
function requireWriter_buffer$1() {
  if (hasRequiredWriter_buffer$1) return writer_buffer$1;
  hasRequiredWriter_buffer$1 = 1, writer_buffer$1 = g;
  var o = requireWriter$1();
  (g.prototype = Object.create(o.prototype)).constructor = g;
  var i = requireMinimal$3();
  function g() {
    o.call(this);
  }
  g._configure = function() {
    g.alloc = i._Buffer_allocUnsafe, g.writeBytesBuffer = i.Buffer && i.Buffer.prototype instanceof Uint8Array && i.Buffer.prototype.set.name === "set" ? function(t, n, h) {
      n.set(t, h);
    } : function(t, n, h) {
      if (t.copy)
        t.copy(n, h, 0, t.length);
      else for (var d = 0; d < t.length; )
        n[h++] = t[d++];
    };
  }, g.prototype.bytes = function(t) {
    i.isString(t) && (t = i._Buffer_from(t, "base64"));
    var n = t.length >>> 0;
    return this.uint32(n), n && this._push(g.writeBytesBuffer, n, t), this;
  };
  function E(e, t, n) {
    e.length < 40 ? i.utf8.write(e, t, n) : t.utf8Write ? t.utf8Write(e, n) : t.write(e, n);
  }
  return g.prototype.string = function(t) {
    var n = i.Buffer.byteLength(t);
    return this.uint32(n), n && this._push(E, n, t), this;
  }, g._configure(), writer_buffer$1;
}
var reader$1, hasRequiredReader$1;
function requireReader$1() {
  if (hasRequiredReader$1) return reader$1;
  hasRequiredReader$1 = 1, reader$1 = t;
  var o = requireMinimal$3(), i, g = o.LongBits, E = o.utf8;
  function e(M, H) {
    return RangeError("index out of range: " + M.pos + " + " + (H || 1) + " > " + M.len);
  }
  function t(M) {
    this.buf = M, this.pos = 0, this.len = M.length;
  }
  var n = typeof Uint8Array < "u" ? function(H) {
    if (H instanceof Uint8Array || Array.isArray(H))
      return new t(H);
    throw Error("illegal buffer");
  } : function(H) {
    if (Array.isArray(H))
      return new t(H);
    throw Error("illegal buffer");
  }, h = function() {
    return o.Buffer ? function(f) {
      return (t.create = function(gA) {
        return o.Buffer.isBuffer(gA) ? new i(gA) : n(gA);
      })(f);
    } : n;
  };
  t.create = h(), t.prototype._slice = o.Array.prototype.subarray || /* istanbul ignore next */
  o.Array.prototype.slice, t.prototype.uint32 = /* @__PURE__ */ (function() {
    var H = 4294967295;
    return function() {
      if (H = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (H = (H | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (H = (H | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (H = (H | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (H = (H | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return H;
      if ((this.pos += 5) > this.len)
        throw this.pos = this.len, e(this, 10);
      return H;
    };
  })(), t.prototype.int32 = function() {
    return this.uint32() | 0;
  }, t.prototype.sint32 = function() {
    var H = this.uint32();
    return H >>> 1 ^ -(H & 1) | 0;
  };
  function d() {
    var M = new g(0, 0), H = 0;
    if (this.len - this.pos > 4) {
      for (; H < 4; ++H)
        if (M.lo = (M.lo | (this.buf[this.pos] & 127) << H * 7) >>> 0, this.buf[this.pos++] < 128)
          return M;
      if (M.lo = (M.lo | (this.buf[this.pos] & 127) << 28) >>> 0, M.hi = (M.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
        return M;
      H = 0;
    } else {
      for (; H < 3; ++H) {
        if (this.pos >= this.len)
          throw e(this);
        if (M.lo = (M.lo | (this.buf[this.pos] & 127) << H * 7) >>> 0, this.buf[this.pos++] < 128)
          return M;
      }
      return M.lo = (M.lo | (this.buf[this.pos++] & 127) << H * 7) >>> 0, M;
    }
    if (this.len - this.pos > 4) {
      for (; H < 5; ++H)
        if (M.hi = (M.hi | (this.buf[this.pos] & 127) << H * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return M;
    } else
      for (; H < 5; ++H) {
        if (this.pos >= this.len)
          throw e(this);
        if (M.hi = (M.hi | (this.buf[this.pos] & 127) << H * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return M;
      }
    throw Error("invalid varint encoding");
  }
  t.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function k(M, H) {
    return (M[H - 4] | M[H - 3] << 8 | M[H - 2] << 16 | M[H - 1] << 24) >>> 0;
  }
  t.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    return k(this.buf, this.pos += 4);
  }, t.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    return k(this.buf, this.pos += 4) | 0;
  };
  function p() {
    if (this.pos + 8 > this.len)
      throw e(this, 8);
    return new g(k(this.buf, this.pos += 4), k(this.buf, this.pos += 4));
  }
  return t.prototype.float = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    var H = o.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, H;
  }, t.prototype.double = function() {
    if (this.pos + 8 > this.len)
      throw e(this, 4);
    var H = o.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, H;
  }, t.prototype.bytes = function() {
    var H = this.uint32(), f = this.pos, AA = this.pos + H;
    if (AA > this.len)
      throw e(this, H);
    if (this.pos += H, Array.isArray(this.buf))
      return this.buf.slice(f, AA);
    if (f === AA) {
      var gA = o.Buffer;
      return gA ? gA.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, f, AA);
  }, t.prototype.string = function() {
    var H = this.bytes();
    return E.read(H, 0, H.length);
  }, t.prototype.skip = function(H) {
    if (typeof H == "number") {
      if (this.pos + H > this.len)
        throw e(this, H);
      this.pos += H;
    } else
      do
        if (this.pos >= this.len)
          throw e(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }, t.prototype.skipType = function(M) {
    switch (M) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (M = this.uint32() & 7) !== 4; )
          this.skipType(M);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + M + " at offset " + this.pos);
    }
    return this;
  }, t._configure = function(M) {
    i = M, t.create = h(), i._configure();
    var H = o.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    o.merge(t.prototype, {
      int64: function() {
        return d.call(this)[H](!1);
      },
      uint64: function() {
        return d.call(this)[H](!0);
      },
      sint64: function() {
        return d.call(this).zzDecode()[H](!1);
      },
      fixed64: function() {
        return p.call(this)[H](!0);
      },
      sfixed64: function() {
        return p.call(this)[H](!1);
      }
    });
  }, reader$1;
}
var reader_buffer$1, hasRequiredReader_buffer$1;
function requireReader_buffer$1() {
  if (hasRequiredReader_buffer$1) return reader_buffer$1;
  hasRequiredReader_buffer$1 = 1, reader_buffer$1 = g;
  var o = requireReader$1();
  (g.prototype = Object.create(o.prototype)).constructor = g;
  var i = requireMinimal$3();
  function g(E) {
    o.call(this, E);
  }
  return g._configure = function() {
    i.Buffer && (g.prototype._slice = i.Buffer.prototype.slice);
  }, g.prototype.string = function() {
    var e = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + e, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + e, this.len));
  }, g._configure(), reader_buffer$1;
}
var rpc$1 = {}, service$2, hasRequiredService$2;
function requireService$2() {
  if (hasRequiredService$2) return service$2;
  hasRequiredService$2 = 1, service$2 = i;
  var o = requireMinimal$3();
  (i.prototype = Object.create(o.EventEmitter.prototype)).constructor = i;
  function i(g, E, e) {
    if (typeof g != "function")
      throw TypeError("rpcImpl must be a function");
    o.EventEmitter.call(this), this.rpcImpl = g, this.requestDelimited = !!E, this.responseDelimited = !!e;
  }
  return i.prototype.rpcCall = function g(E, e, t, n, h) {
    if (!n)
      throw TypeError("request must be specified");
    var d = this;
    if (!h)
      return o.asPromise(g, d, E, e, t, n);
    if (!d.rpcImpl) {
      setTimeout(function() {
        h(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return d.rpcImpl(
        E,
        e[d.requestDelimited ? "encodeDelimited" : "encode"](n).finish(),
        function(p, M) {
          if (p)
            return d.emit("error", p, E), h(p);
          if (M === null) {
            d.end(
              /* endedByRPC */
              !0
            );
            return;
          }
          if (!(M instanceof t))
            try {
              M = t[d.responseDelimited ? "decodeDelimited" : "decode"](M);
            } catch (H) {
              return d.emit("error", H, E), h(H);
            }
          return d.emit("data", M, E), h(null, M);
        }
      );
    } catch (k) {
      d.emit("error", k, E), setTimeout(function() {
        h(k);
      }, 0);
      return;
    }
  }, i.prototype.end = function(E) {
    return this.rpcImpl && (E || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service$2;
}
var hasRequiredRpc$1;
function requireRpc$1() {
  return hasRequiredRpc$1 || (hasRequiredRpc$1 = 1, (function(o) {
    var i = o;
    i.Service = requireService$2();
  })(rpc$1)), rpc$1;
}
var roots$1, hasRequiredRoots$1;
function requireRoots$1() {
  return hasRequiredRoots$1 || (hasRequiredRoots$1 = 1, roots$1 = {}), roots$1;
}
var hasRequiredIndexMinimal$1;
function requireIndexMinimal$1() {
  return hasRequiredIndexMinimal$1 || (hasRequiredIndexMinimal$1 = 1, (function(o) {
    var i = o;
    i.build = "minimal", i.Writer = requireWriter$1(), i.BufferWriter = requireWriter_buffer$1(), i.Reader = requireReader$1(), i.BufferReader = requireReader_buffer$1(), i.util = requireMinimal$3(), i.rpc = requireRpc$1(), i.roots = requireRoots$1(), i.configure = g;
    function g() {
      i.util._configure(), i.Writer._configure(i.BufferWriter), i.Reader._configure(i.BufferReader);
    }
    g();
  })(indexMinimal$1)), indexMinimal$1;
}
var minimal$2, hasRequiredMinimal$2;
function requireMinimal$2() {
  return hasRequiredMinimal$2 || (hasRequiredMinimal$2 = 1, minimal$2 = requireIndexMinimal$1()), minimal$2;
}
var minimalExports$1 = requireMinimal$2();
const $Reader$1 = minimalExports$1.Reader, $Writer$1 = minimalExports$1.Writer, $util$1 = minimalExports$1.util, $root$1 = minimalExports$1.roots.default || (minimalExports$1.roots.default = {}), Alert = $root$1.Alert = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.body = "", o.prototype.format = 0, o.prototype.icon = "", o.prototype.widthConfig = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.format != null && Object.hasOwnProperty.call(g, "format") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.format), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.icon), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root$1.streamlit.WidthConfig.encode(g.widthConfig, E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Alert();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.body = g.string();
          break;
        }
        case 2: {
          n.format = g.int32();
          break;
        }
        case 3: {
          n.icon = g.string();
          break;
        }
        case 4: {
          n.widthConfig = $root$1.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Alert) return g;
    let E = new $root$1.Alert();
    switch (g.body != null && (E.body = String(g.body)), g.format) {
      default:
        if (typeof g.format == "number") {
          E.format = g.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        E.format = 0;
        break;
      case "ERROR":
      case 1:
        E.format = 1;
        break;
      case "WARNING":
      case 2:
        E.format = 2;
        break;
      case "INFO":
      case 3:
        E.format = 3;
        break;
      case "SUCCESS":
      case 4:
        E.format = 4;
        break;
    }
    if (g.icon != null && (E.icon = String(g.icon)), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
      E.widthConfig = $root$1.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.body = "", e.format = E.enums === String ? "UNUSED" : 0, e.icon = "", e.widthConfig = null), g.body != null && g.hasOwnProperty("body") && (e.body = g.body), g.format != null && g.hasOwnProperty("format") && (e.format = E.enums === String ? $root$1.Alert.Format[g.format] === void 0 ? g.format : $root$1.Alert.Format[g.format] : g.format), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (e.widthConfig = $root$1.streamlit.WidthConfig.toObject(g.widthConfig, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Alert";
  }, o.Format = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "UNUSED"] = 0, g[i[1] = "ERROR"] = 1, g[i[2] = "WARNING"] = 2, g[i[3] = "INFO"] = 3, g[i[4] = "SUCCESS"] = 4, g;
  })(), o;
})(), streamlit = $root$1.streamlit = (() => {
  const o = {};
  return o.WidthConfig = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.useStretch = null, i.prototype.useContent = null, i.prototype.pixelWidth = null, i.prototype.remWidth = null;
    let g;
    return Object.defineProperty(i.prototype, "widthSpec", { get: $util$1.oneOfGetter(g = ["useStretch", "useContent", "pixelWidth", "remWidth"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.useStretch != null && Object.hasOwnProperty.call(e, "useStretch") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.useStretch), e.useContent != null && Object.hasOwnProperty.call(e, "useContent") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContent), e.pixelWidth != null && Object.hasOwnProperty.call(e, "pixelWidth") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(e.pixelWidth), e.remWidth != null && Object.hasOwnProperty.call(e, "remWidth") && t.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(e.remWidth), t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.streamlit.WidthConfig();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.useStretch = e.bool();
            break;
          }
          case 2: {
            d.useContent = e.bool();
            break;
          }
          case 3: {
            d.pixelWidth = e.uint32();
            break;
          }
          case 4: {
            d.remWidth = e.float();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.streamlit.WidthConfig) return e;
      let t = new $root$1.streamlit.WidthConfig();
      return e.useStretch != null && (t.useStretch = !!e.useStretch), e.useContent != null && (t.useContent = !!e.useContent), e.pixelWidth != null && (t.pixelWidth = e.pixelWidth >>> 0), e.remWidth != null && (t.remWidth = Number(e.remWidth)), t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return e.useStretch != null && e.hasOwnProperty("useStretch") && (n.useStretch = e.useStretch, t.oneofs && (n.widthSpec = "useStretch")), e.useContent != null && e.hasOwnProperty("useContent") && (n.useContent = e.useContent, t.oneofs && (n.widthSpec = "useContent")), e.pixelWidth != null && e.hasOwnProperty("pixelWidth") && (n.pixelWidth = e.pixelWidth, t.oneofs && (n.widthSpec = "pixelWidth")), e.remWidth != null && e.hasOwnProperty("remWidth") && (n.remWidth = t.json && !isFinite(e.remWidth) ? String(e.remWidth) : e.remWidth, t.oneofs && (n.widthSpec = "remWidth")), n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.WidthConfig";
    }, i;
  })(), o.HeightConfig = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.useStretch = null, i.prototype.useContent = null, i.prototype.pixelHeight = null, i.prototype.remHeight = null;
    let g;
    return Object.defineProperty(i.prototype, "heightSpec", { get: $util$1.oneOfGetter(g = ["useStretch", "useContent", "pixelHeight", "remHeight"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.useStretch != null && Object.hasOwnProperty.call(e, "useStretch") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.useStretch), e.useContent != null && Object.hasOwnProperty.call(e, "useContent") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContent), e.pixelHeight != null && Object.hasOwnProperty.call(e, "pixelHeight") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(e.pixelHeight), e.remHeight != null && Object.hasOwnProperty.call(e, "remHeight") && t.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(e.remHeight), t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.streamlit.HeightConfig();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.useStretch = e.bool();
            break;
          }
          case 2: {
            d.useContent = e.bool();
            break;
          }
          case 3: {
            d.pixelHeight = e.uint32();
            break;
          }
          case 4: {
            d.remHeight = e.float();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.streamlit.HeightConfig) return e;
      let t = new $root$1.streamlit.HeightConfig();
      return e.useStretch != null && (t.useStretch = !!e.useStretch), e.useContent != null && (t.useContent = !!e.useContent), e.pixelHeight != null && (t.pixelHeight = e.pixelHeight >>> 0), e.remHeight != null && (t.remHeight = Number(e.remHeight)), t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return e.useStretch != null && e.hasOwnProperty("useStretch") && (n.useStretch = e.useStretch, t.oneofs && (n.heightSpec = "useStretch")), e.useContent != null && e.hasOwnProperty("useContent") && (n.useContent = e.useContent, t.oneofs && (n.heightSpec = "useContent")), e.pixelHeight != null && e.hasOwnProperty("pixelHeight") && (n.pixelHeight = e.pixelHeight, t.oneofs && (n.heightSpec = "pixelHeight")), e.remHeight != null && e.hasOwnProperty("remHeight") && (n.remHeight = t.json && !isFinite(e.remHeight) ? String(e.remHeight) : e.remHeight, t.oneofs && (n.heightSpec = "remHeight")), n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.HeightConfig";
    }, i;
  })(), o.GapSize = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "GAP_UNDEFINED"] = 0, g[i[1] = "SMALL"] = 1, g[i[2] = "MEDIUM"] = 2, g[i[3] = "LARGE"] = 3, g[i[4] = "NONE"] = 4, g[i[5] = "XXSMALL"] = 5, g[i[6] = "XSMALL"] = 6, g[i[7] = "XLARGE"] = 7, g[i[8] = "XXLARGE"] = 8, g;
  })(), o.GapConfig = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.gapSize = null;
    let g;
    return Object.defineProperty(i.prototype, "gapSpec", { get: $util$1.oneOfGetter(g = ["gapSize"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.gapSize != null && Object.hasOwnProperty.call(e, "gapSize") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.gapSize), t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.streamlit.GapConfig();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.gapSize = e.int32();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.streamlit.GapConfig) return e;
      let t = new $root$1.streamlit.GapConfig();
      switch (e.gapSize) {
        default:
          if (typeof e.gapSize == "number") {
            t.gapSize = e.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          t.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          t.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          t.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          t.gapSize = 3;
          break;
        case "NONE":
        case 4:
          t.gapSize = 4;
          break;
        case "XXSMALL":
        case 5:
          t.gapSize = 5;
          break;
        case "XSMALL":
        case 6:
          t.gapSize = 6;
          break;
        case "XLARGE":
        case 7:
          t.gapSize = 7;
          break;
        case "XXLARGE":
        case 8:
          t.gapSize = 8;
          break;
      }
      return t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return e.gapSize != null && e.hasOwnProperty("gapSize") && (n.gapSize = t.enums === String ? $root$1.streamlit.GapSize[e.gapSize] === void 0 ? e.gapSize : $root$1.streamlit.GapSize[e.gapSize] : e.gapSize, t.oneofs && (n.gapSpec = "gapSize")), n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.GapConfig";
    }, i;
  })(), o.ButtonLikeIconPosition = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "LEFT"] = 0, g[i[1] = "RIGHT"] = 1, g;
  })(), o.TextAlignmentConfig = (function() {
    function i(g) {
      if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.alignment = 0, i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer$1.create()), E.alignment != null && Object.hasOwnProperty.call(E, "alignment") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(E.alignment), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader$1 || (E = $Reader$1.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.streamlit.TextAlignmentConfig();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.alignment = E.int32();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root$1.streamlit.TextAlignmentConfig) return E;
      let e = new $root$1.streamlit.TextAlignmentConfig();
      switch (E.alignment) {
        default:
          if (typeof E.alignment == "number") {
            e.alignment = E.alignment;
            break;
          }
          break;
        case "UNSPECIFIED":
        case 0:
          e.alignment = 0;
          break;
        case "LEFT":
        case 1:
          e.alignment = 1;
          break;
        case "CENTER":
        case 2:
          e.alignment = 2;
          break;
        case "RIGHT":
        case 3:
          e.alignment = 3;
          break;
        case "JUSTIFY":
        case 4:
          e.alignment = 4;
          break;
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.alignment = e.enums === String ? "UNSPECIFIED" : 0), E.alignment != null && E.hasOwnProperty("alignment") && (t.alignment = e.enums === String ? $root$1.streamlit.TextAlignmentConfig.Alignment[E.alignment] === void 0 ? E.alignment : $root$1.streamlit.TextAlignmentConfig.Alignment[E.alignment] : E.alignment), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/streamlit.TextAlignmentConfig";
    }, i.Alignment = (function() {
      const g = {}, E = Object.create(g);
      return E[g[0] = "UNSPECIFIED"] = 0, E[g[1] = "LEFT"] = 1, E[g[2] = "CENTER"] = 2, E[g[3] = "RIGHT"] = 3, E[g[4] = "JUSTIFY"] = 4, E;
    })(), i;
  })(), o;
})();
$root$1.AppPage = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.pageScriptHash = "", o.prototype.pageName = "", o.prototype.icon = "", o.prototype.isDefault = !1, o.prototype.sectionHeader = "", o.prototype.urlPathname = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.pageScriptHash), g.pageName != null && Object.hasOwnProperty.call(g, "pageName") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.pageName), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.icon), g.isDefault != null && Object.hasOwnProperty.call(g, "isDefault") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.isDefault), g.sectionHeader != null && Object.hasOwnProperty.call(g, "sectionHeader") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.sectionHeader), g.urlPathname != null && Object.hasOwnProperty.call(g, "urlPathname") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.urlPathname), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.AppPage();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.pageScriptHash = g.string();
          break;
        }
        case 2: {
          n.pageName = g.string();
          break;
        }
        case 3: {
          n.icon = g.string();
          break;
        }
        case 4: {
          n.isDefault = g.bool();
          break;
        }
        case 5: {
          n.sectionHeader = g.string();
          break;
        }
        case 6: {
          n.urlPathname = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.AppPage) return g;
    let E = new $root$1.AppPage();
    return g.pageScriptHash != null && (E.pageScriptHash = String(g.pageScriptHash)), g.pageName != null && (E.pageName = String(g.pageName)), g.icon != null && (E.icon = String(g.icon)), g.isDefault != null && (E.isDefault = !!g.isDefault), g.sectionHeader != null && (E.sectionHeader = String(g.sectionHeader)), g.urlPathname != null && (E.urlPathname = String(g.urlPathname)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.pageScriptHash = "", e.pageName = "", e.icon = "", e.isDefault = !1, e.sectionHeader = "", e.urlPathname = ""), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = g.pageScriptHash), g.pageName != null && g.hasOwnProperty("pageName") && (e.pageName = g.pageName), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), g.isDefault != null && g.hasOwnProperty("isDefault") && (e.isDefault = g.isDefault), g.sectionHeader != null && g.hasOwnProperty("sectionHeader") && (e.sectionHeader = g.sectionHeader), g.urlPathname != null && g.hasOwnProperty("urlPathname") && (e.urlPathname = g.urlPathname), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AppPage";
  }, o;
})();
const Arrow$2 = $root$1.Arrow = (() => {
  function o(g) {
    if (this.columnOrder = [], this.selectionMode = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.data = $util$1.newBuffer([]), o.prototype.styler = null, o.prototype.width = 0, o.prototype.height = 0, o.prototype.useContainerWidth = !1, o.prototype.id = "", o.prototype.columns = "", o.prototype.editingMode = 0, o.prototype.disabled = !1, o.prototype.formId = "", o.prototype.columnOrder = $util$1.emptyArray, o.prototype.selectionMode = $util$1.emptyArray, o.prototype.rowHeight = null, o.prototype.borderMode = 0, o.prototype.placeholder = null;
  let i;
  return Object.defineProperty(o.prototype, "_rowHeight", { get: $util$1.oneOfGetter(i = ["rowHeight"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_placeholder", { get: $util$1.oneOfGetter(i = ["placeholder"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(E.data), E.styler != null && Object.hasOwnProperty.call(E, "styler") && $root$1.Styler.encode(E.styler, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.width != null && Object.hasOwnProperty.call(E, "width") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(E.width), E.height != null && Object.hasOwnProperty.call(E, "height") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(E.height), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.useContainerWidth), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.id), E.columns != null && Object.hasOwnProperty.call(E, "columns") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.columns), E.editingMode != null && Object.hasOwnProperty.call(E, "editingMode") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(E.editingMode), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.disabled), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.formId), E.columnOrder != null && E.columnOrder.length) for (let t = 0; t < E.columnOrder.length; ++t) e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.columnOrder[t]);
    if (E.selectionMode != null && E.selectionMode.length) {
      e.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork();
      for (let t = 0; t < E.selectionMode.length; ++t) e.int32(E.selectionMode[t]);
      e.ldelim();
    }
    return E.rowHeight != null && Object.hasOwnProperty.call(E, "rowHeight") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).uint32(E.rowHeight), E.borderMode != null && Object.hasOwnProperty.call(E, "borderMode") && e.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(E.borderMode), E.placeholder != null && Object.hasOwnProperty.call(E, "placeholder") && e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(E.placeholder), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Arrow();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.data = E.bytes();
          break;
        }
        case 2: {
          h.styler = $root$1.Styler.decode(E, E.uint32());
          break;
        }
        case 3: {
          h.width = E.uint32();
          break;
        }
        case 4: {
          h.height = E.uint32();
          break;
        }
        case 5: {
          h.useContainerWidth = E.bool();
          break;
        }
        case 6: {
          h.id = E.string();
          break;
        }
        case 7: {
          h.columns = E.string();
          break;
        }
        case 8: {
          h.editingMode = E.int32();
          break;
        }
        case 9: {
          h.disabled = E.bool();
          break;
        }
        case 10: {
          h.formId = E.string();
          break;
        }
        case 11: {
          h.columnOrder && h.columnOrder.length || (h.columnOrder = []), h.columnOrder.push(E.string());
          break;
        }
        case 12: {
          if (h.selectionMode && h.selectionMode.length || (h.selectionMode = []), (d & 7) === 2) {
            let k = E.uint32() + E.pos;
            for (; E.pos < k; ) h.selectionMode.push(E.int32());
          } else h.selectionMode.push(E.int32());
          break;
        }
        case 13: {
          h.rowHeight = E.uint32();
          break;
        }
        case 14: {
          h.borderMode = E.int32();
          break;
        }
        case 15: {
          h.placeholder = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Arrow) return E;
    let e = new $root$1.Arrow();
    if (E.data != null && (typeof E.data == "string" ? $util$1.base64.decode(E.data, e.data = $util$1.newBuffer($util$1.base64.length(E.data)), 0) : E.data.length >= 0 && (e.data = E.data)), E.styler != null) {
      if (typeof E.styler != "object") throw TypeError(".Arrow.styler: object expected");
      e.styler = $root$1.Styler.fromObject(E.styler);
    }
    switch (E.width != null && (e.width = E.width >>> 0), E.height != null && (e.height = E.height >>> 0), E.useContainerWidth != null && (e.useContainerWidth = !!E.useContainerWidth), E.id != null && (e.id = String(E.id)), E.columns != null && (e.columns = String(E.columns)), E.editingMode) {
      default:
        if (typeof E.editingMode == "number") {
          e.editingMode = E.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        e.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        e.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        e.editingMode = 2;
        break;
      case "ADD_ONLY":
      case 3:
        e.editingMode = 3;
        break;
      case "DELETE_ONLY":
      case 4:
        e.editingMode = 4;
        break;
    }
    if (E.disabled != null && (e.disabled = !!E.disabled), E.formId != null && (e.formId = String(E.formId)), E.columnOrder) {
      if (!Array.isArray(E.columnOrder)) throw TypeError(".Arrow.columnOrder: array expected");
      e.columnOrder = [];
      for (let t = 0; t < E.columnOrder.length; ++t) e.columnOrder[t] = String(E.columnOrder[t]);
    }
    if (E.selectionMode) {
      if (!Array.isArray(E.selectionMode)) throw TypeError(".Arrow.selectionMode: array expected");
      e.selectionMode = [];
      for (let t = 0; t < E.selectionMode.length; ++t) switch (E.selectionMode[t]) {
        default:
          if (typeof E.selectionMode[t] == "number") {
            e.selectionMode[t] = E.selectionMode[t];
            break;
          }
        case "SINGLE_ROW":
        case 0:
          e.selectionMode[t] = 0;
          break;
        case "MULTI_ROW":
        case 1:
          e.selectionMode[t] = 1;
          break;
        case "SINGLE_COLUMN":
        case 2:
          e.selectionMode[t] = 2;
          break;
        case "MULTI_COLUMN":
        case 3:
          e.selectionMode[t] = 3;
          break;
        case "SINGLE_CELL":
        case 4:
          e.selectionMode[t] = 4;
          break;
        case "MULTI_CELL":
        case 5:
          e.selectionMode[t] = 5;
          break;
      }
    }
    switch (E.rowHeight != null && (e.rowHeight = E.rowHeight >>> 0), E.borderMode) {
      default:
        if (typeof E.borderMode == "number") {
          e.borderMode = E.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        e.borderMode = 0;
        break;
      case "NONE":
      case 1:
        e.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        e.borderMode = 2;
        break;
    }
    return E.placeholder != null && (e.placeholder = String(E.placeholder)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.columnOrder = [], t.selectionMode = []), e.defaults && (e.bytes === String ? t.data = "" : (t.data = [], e.bytes !== Array && (t.data = $util$1.newBuffer(t.data))), t.styler = null, t.width = 0, t.height = 0, t.useContainerWidth = !1, t.id = "", t.columns = "", t.editingMode = e.enums === String ? "READ_ONLY" : 0, t.disabled = !1, t.formId = "", t.borderMode = e.enums === String ? "ALL" : 0), E.data != null && E.hasOwnProperty("data") && (t.data = e.bytes === String ? $util$1.base64.encode(E.data, 0, E.data.length) : e.bytes === Array ? Array.prototype.slice.call(E.data) : E.data), E.styler != null && E.hasOwnProperty("styler") && (t.styler = $root$1.Styler.toObject(E.styler, e)), E.width != null && E.hasOwnProperty("width") && (t.width = E.width), E.height != null && E.hasOwnProperty("height") && (t.height = E.height), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = E.useContainerWidth), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.columns != null && E.hasOwnProperty("columns") && (t.columns = E.columns), E.editingMode != null && E.hasOwnProperty("editingMode") && (t.editingMode = e.enums === String ? $root$1.Arrow.EditingMode[E.editingMode] === void 0 ? E.editingMode : $root$1.Arrow.EditingMode[E.editingMode] : E.editingMode), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.columnOrder && E.columnOrder.length) {
      t.columnOrder = [];
      for (let n = 0; n < E.columnOrder.length; ++n) t.columnOrder[n] = E.columnOrder[n];
    }
    if (E.selectionMode && E.selectionMode.length) {
      t.selectionMode = [];
      for (let n = 0; n < E.selectionMode.length; ++n) t.selectionMode[n] = e.enums === String ? $root$1.Arrow.SelectionMode[E.selectionMode[n]] === void 0 ? E.selectionMode[n] : $root$1.Arrow.SelectionMode[E.selectionMode[n]] : E.selectionMode[n];
    }
    return E.rowHeight != null && E.hasOwnProperty("rowHeight") && (t.rowHeight = E.rowHeight, e.oneofs && (t._rowHeight = "rowHeight")), E.borderMode != null && E.hasOwnProperty("borderMode") && (t.borderMode = e.enums === String ? $root$1.Arrow.BorderMode[E.borderMode] === void 0 ? E.borderMode : $root$1.Arrow.BorderMode[E.borderMode] : E.borderMode), E.placeholder != null && E.hasOwnProperty("placeholder") && (t.placeholder = E.placeholder, e.oneofs && (t._placeholder = "placeholder")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Arrow";
  }, o.EditingMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "READ_ONLY"] = 0, E[g[1] = "FIXED"] = 1, E[g[2] = "DYNAMIC"] = 2, E[g[3] = "ADD_ONLY"] = 3, E[g[4] = "DELETE_ONLY"] = 4, E;
  })(), o.SelectionMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "SINGLE_ROW"] = 0, E[g[1] = "MULTI_ROW"] = 1, E[g[2] = "SINGLE_COLUMN"] = 2, E[g[3] = "MULTI_COLUMN"] = 3, E[g[4] = "SINGLE_CELL"] = 4, E[g[5] = "MULTI_CELL"] = 5, E;
  })(), o.BorderMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "ALL"] = 0, E[g[1] = "NONE"] = 1, E[g[2] = "HORIZONTAL"] = 2, E;
  })(), o;
})();
$root$1.Styler = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.uuid = "", o.prototype.caption = "", o.prototype.styles = "", o.prototype.displayValues = $util$1.newBuffer([]), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.uuid != null && Object.hasOwnProperty.call(g, "uuid") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.uuid), g.caption != null && Object.hasOwnProperty.call(g, "caption") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.caption), g.styles != null && Object.hasOwnProperty.call(g, "styles") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.styles), g.displayValues != null && Object.hasOwnProperty.call(g, "displayValues") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(g.displayValues), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Styler();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.uuid = g.string();
          break;
        }
        case 2: {
          n.caption = g.string();
          break;
        }
        case 3: {
          n.styles = g.string();
          break;
        }
        case 4: {
          n.displayValues = g.bytes();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Styler) return g;
    let E = new $root$1.Styler();
    return g.uuid != null && (E.uuid = String(g.uuid)), g.caption != null && (E.caption = String(g.caption)), g.styles != null && (E.styles = String(g.styles)), g.displayValues != null && (typeof g.displayValues == "string" ? $util$1.base64.decode(g.displayValues, E.displayValues = $util$1.newBuffer($util$1.base64.length(g.displayValues)), 0) : g.displayValues.length >= 0 && (E.displayValues = g.displayValues)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.uuid = "", e.caption = "", e.styles = "", E.bytes === String ? e.displayValues = "" : (e.displayValues = [], E.bytes !== Array && (e.displayValues = $util$1.newBuffer(e.displayValues)))), g.uuid != null && g.hasOwnProperty("uuid") && (e.uuid = g.uuid), g.caption != null && g.hasOwnProperty("caption") && (e.caption = g.caption), g.styles != null && g.hasOwnProperty("styles") && (e.styles = g.styles), g.displayValues != null && g.hasOwnProperty("displayValues") && (e.displayValues = E.bytes === String ? $util$1.base64.encode(g.displayValues, 0, g.displayValues.length) : E.bytes === Array ? Array.prototype.slice.call(g.displayValues) : g.displayValues), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Styler";
  }, o;
})();
$root$1.ArrowData = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util$1.newBuffer([]), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(g.data), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ArrowData();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = g.bytes();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ArrowData) return g;
    let E = new $root$1.ArrowData();
    return g.data != null && (typeof g.data == "string" ? $util$1.base64.decode(g.data, E.data = $util$1.newBuffer($util$1.base64.length(g.data)), 0) : g.data.length >= 0 && (E.data = g.data)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (E.bytes === String ? e.data = "" : (e.data = [], E.bytes !== Array && (e.data = $util$1.newBuffer(e.data)))), g.data != null && g.hasOwnProperty("data") && (e.data = E.bytes === String ? $util$1.base64.encode(g.data, 0, g.data.length) : E.bytes === Array ? Array.prototype.slice.call(g.data) : g.data), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowData";
  }, o;
})();
$root$1.ArrowNamedDataSet = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.name = "", o.prototype.hasName = !1, o.prototype.data = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Arrow.encode(g.data, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.hasName != null && Object.hasOwnProperty.call(g, "hasName") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.hasName), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ArrowNamedDataSet();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.name = g.string();
          break;
        }
        case 3: {
          n.hasName = g.bool();
          break;
        }
        case 2: {
          n.data = $root$1.Arrow.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ArrowNamedDataSet) return g;
    let E = new $root$1.ArrowNamedDataSet();
    if (g.name != null && (E.name = String(g.name)), g.hasName != null && (E.hasName = !!g.hasName), g.data != null) {
      if (typeof g.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
      E.data = $root$1.Arrow.fromObject(g.data);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.name = "", e.data = null, e.hasName = !1), g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.Arrow.toObject(g.data, E)), g.hasName != null && g.hasOwnProperty("hasName") && (e.hasName = g.hasName), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowNamedDataSet";
  }, o;
})();
$root$1.ArrowVegaLiteChart = (() => {
  function o(i) {
    if (this.datasets = [], this.selectionMode = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.spec = "", o.prototype.data = null, o.prototype.datasets = $util$1.emptyArray, o.prototype.useContainerWidth = !1, o.prototype.theme = "", o.prototype.id = "", o.prototype.selectionMode = $util$1.emptyArray, o.prototype.formId = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.spec != null && Object.hasOwnProperty.call(g, "spec") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.spec), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Arrow.encode(g.data, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.datasets != null && g.datasets.length) for (let e = 0; e < g.datasets.length; ++e) $root$1.ArrowNamedDataSet.encode(g.datasets[e], E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    if (g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), g.theme != null && Object.hasOwnProperty.call(g, "theme") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.theme), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.id), g.selectionMode != null && g.selectionMode.length) for (let e = 0; e < g.selectionMode.length; ++e) E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.selectionMode[e]);
    return g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.formId), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ArrowVegaLiteChart();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.spec = g.string();
          break;
        }
        case 2: {
          n.data = $root$1.Arrow.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.datasets && n.datasets.length || (n.datasets = []), n.datasets.push($root$1.ArrowNamedDataSet.decode(g, g.uint32()));
          break;
        }
        case 5: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 6: {
          n.theme = g.string();
          break;
        }
        case 7: {
          n.id = g.string();
          break;
        }
        case 8: {
          n.selectionMode && n.selectionMode.length || (n.selectionMode = []), n.selectionMode.push(g.string());
          break;
        }
        case 9: {
          n.formId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ArrowVegaLiteChart) return g;
    let E = new $root$1.ArrowVegaLiteChart();
    if (g.spec != null && (E.spec = String(g.spec)), g.data != null) {
      if (typeof g.data != "object") throw TypeError(".ArrowVegaLiteChart.data: object expected");
      E.data = $root$1.Arrow.fromObject(g.data);
    }
    if (g.datasets) {
      if (!Array.isArray(g.datasets)) throw TypeError(".ArrowVegaLiteChart.datasets: array expected");
      E.datasets = [];
      for (let e = 0; e < g.datasets.length; ++e) {
        if (typeof g.datasets[e] != "object") throw TypeError(".ArrowVegaLiteChart.datasets: object expected");
        E.datasets[e] = $root$1.ArrowNamedDataSet.fromObject(g.datasets[e]);
      }
    }
    if (g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.theme != null && (E.theme = String(g.theme)), g.id != null && (E.id = String(g.id)), g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".ArrowVegaLiteChart.selectionMode: array expected");
      E.selectionMode = [];
      for (let e = 0; e < g.selectionMode.length; ++e) E.selectionMode[e] = String(g.selectionMode[e]);
    }
    return g.formId != null && (E.formId = String(g.formId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.datasets = [], e.selectionMode = []), E.defaults && (e.spec = "", e.data = null, e.useContainerWidth = !1, e.theme = "", e.id = "", e.formId = ""), g.spec != null && g.hasOwnProperty("spec") && (e.spec = g.spec), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.Arrow.toObject(g.data, E)), g.datasets && g.datasets.length) {
      e.datasets = [];
      for (let t = 0; t < g.datasets.length; ++t) e.datasets[t] = $root$1.ArrowNamedDataSet.toObject(g.datasets[t], E);
    }
    if (g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.theme != null && g.hasOwnProperty("theme") && (e.theme = g.theme), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.selectionMode && g.selectionMode.length) {
      e.selectionMode = [];
      for (let t = 0; t < g.selectionMode.length; ++t) e.selectionMode[t] = g.selectionMode[t];
    }
    return g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowVegaLiteChart";
  }, o;
})();
$root$1.Audio = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.url = "", o.prototype.startTime = 0, o.prototype.endTime = 0, o.prototype.loop = !1, o.prototype.autoplay = !1, o.prototype.id = "", o.prototype.widthConfig = null;
  let i;
  return Object.defineProperty(o.prototype, "_widthConfig", { get: $util$1.oneOfGetter(i = ["widthConfig"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.startTime != null && Object.hasOwnProperty.call(E, "startTime") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.startTime), E.url != null && Object.hasOwnProperty.call(E, "url") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.url), E.endTime != null && Object.hasOwnProperty.call(E, "endTime") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(E.endTime), E.loop != null && Object.hasOwnProperty.call(E, "loop") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.loop), E.autoplay != null && Object.hasOwnProperty.call(E, "autoplay") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.autoplay), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.id), E.widthConfig != null && Object.hasOwnProperty.call(E, "widthConfig") && $root$1.streamlit.WidthConfig.encode(E.widthConfig, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Audio();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 5: {
          h.url = E.string();
          break;
        }
        case 3: {
          h.startTime = E.int32();
          break;
        }
        case 6: {
          h.endTime = E.int32();
          break;
        }
        case 7: {
          h.loop = E.bool();
          break;
        }
        case 8: {
          h.autoplay = E.bool();
          break;
        }
        case 9: {
          h.id = E.string();
          break;
        }
        case 10: {
          h.widthConfig = $root$1.streamlit.WidthConfig.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Audio) return E;
    let e = new $root$1.Audio();
    if (E.url != null && (e.url = String(E.url)), E.startTime != null && (e.startTime = E.startTime | 0), E.endTime != null && (e.endTime = E.endTime | 0), E.loop != null && (e.loop = !!E.loop), E.autoplay != null && (e.autoplay = !!E.autoplay), E.id != null && (e.id = String(E.id)), E.widthConfig != null) {
      if (typeof E.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
      e.widthConfig = $root$1.streamlit.WidthConfig.fromObject(E.widthConfig);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.startTime = 0, t.url = "", t.endTime = 0, t.loop = !1, t.autoplay = !1, t.id = ""), E.startTime != null && E.hasOwnProperty("startTime") && (t.startTime = E.startTime), E.url != null && E.hasOwnProperty("url") && (t.url = E.url), E.endTime != null && E.hasOwnProperty("endTime") && (t.endTime = E.endTime), E.loop != null && E.hasOwnProperty("loop") && (t.loop = E.loop), E.autoplay != null && E.hasOwnProperty("autoplay") && (t.autoplay = E.autoplay), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.widthConfig != null && E.hasOwnProperty("widthConfig") && (t.widthConfig = $root$1.streamlit.WidthConfig.toObject(E.widthConfig, e), e.oneofs && (t._widthConfig = "widthConfig")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Audio";
  }, o;
})();
$root$1.AudioInput = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.sampleRate = null;
  let i;
  return Object.defineProperty(o.prototype, "_sampleRate", { get: $util$1.oneOfGetter(i = ["sampleRate"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.formId), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E.sampleRate != null && Object.hasOwnProperty.call(E, "sampleRate") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(E.sampleRate), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.AudioInput();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.help = E.string();
          break;
        }
        case 4: {
          h.formId = E.string();
          break;
        }
        case 5: {
          h.disabled = E.bool();
          break;
        }
        case 6: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 7: {
          h.sampleRate = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.AudioInput) return E;
    let e = new $root$1.AudioInput();
    if (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.help != null && (e.help = String(E.help)), E.formId != null && (e.formId = String(E.formId)), E.disabled != null && (e.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.sampleRate != null && (e.sampleRate = E.sampleRate | 0), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.help = "", t.formId = "", t.disabled = !1, t.labelVisibility = null), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), E.sampleRate != null && E.hasOwnProperty("sampleRate") && (t.sampleRate = E.sampleRate, e.oneofs && (t._sampleRate = "sampleRate")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/AudioInput";
  }, o;
})();
const LabelVisibilityMessage = $root$1.LabelVisibilityMessage = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.value = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.value), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.LabelVisibilityMessage();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.value = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.LabelVisibilityMessage) return g;
    let E = new $root$1.LabelVisibilityMessage();
    switch (g.value) {
      default:
        if (typeof g.value == "number") {
          E.value = g.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        E.value = 0;
        break;
      case "HIDDEN":
      case 1:
        E.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        E.value = 2;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.value = E.enums === String ? "VISIBLE" : 0), g.value != null && g.hasOwnProperty("value") && (e.value = E.enums === String ? $root$1.LabelVisibilityMessage.LabelVisibilityOptions[g.value] === void 0 ? g.value : $root$1.LabelVisibilityMessage.LabelVisibilityOptions[g.value] : g.value), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/LabelVisibilityMessage";
  }, o.LabelVisibilityOptions = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "VISIBLE"] = 0, g[i[1] = "HIDDEN"] = 1, g[i[2] = "COLLAPSED"] = 2, g;
  })(), o;
})();
$root$1.AuthRedirect = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.url = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.AuthRedirect();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.url = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.AuthRedirect) return g;
    let E = new $root$1.AuthRedirect();
    return g.url != null && (E.url = String(g.url)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.url = ""), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AuthRedirect";
  }, o;
})();
$root$1.AutoRerun = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.interval = 0, o.prototype.fragmentId = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.interval != null && Object.hasOwnProperty.call(g, "interval") && E.uint32(
      /* id 1, wireType 5 =*/
      13
    ).float(g.interval), g.fragmentId != null && Object.hasOwnProperty.call(g, "fragmentId") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.fragmentId), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.AutoRerun();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.interval = g.float();
          break;
        }
        case 2: {
          n.fragmentId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.AutoRerun) return g;
    let E = new $root$1.AutoRerun();
    return g.interval != null && (E.interval = Number(g.interval)), g.fragmentId != null && (E.fragmentId = String(g.fragmentId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.interval = 0, e.fragmentId = ""), g.interval != null && g.hasOwnProperty("interval") && (e.interval = E.json && !isFinite(g.interval) ? String(g.interval) : g.interval), g.fragmentId != null && g.hasOwnProperty("fragmentId") && (e.fragmentId = g.fragmentId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AutoRerun";
  }, o;
})();
const BackMsg = $root$1.BackMsg = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.clearCache = null, o.prototype.setRunOnSave = null, o.prototype.stopScript = null, o.prototype.rerunScript = null, o.prototype.loadGitInfo = null, o.prototype.debugDisconnectWebsocket = null, o.prototype.debugShutdownRuntime = null, o.prototype.fileUrlsRequest = null, o.prototype.appHeartbeat = null, o.prototype.deferredFileRequest = null, o.prototype.debugLastBackmsgId = "";
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat", "deferredFileRequest"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.clearCache != null && Object.hasOwnProperty.call(E, "clearCache") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.clearCache), E.setRunOnSave != null && Object.hasOwnProperty.call(E, "setRunOnSave") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.setRunOnSave), E.stopScript != null && Object.hasOwnProperty.call(E, "stopScript") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.stopScript), E.rerunScript != null && Object.hasOwnProperty.call(E, "rerunScript") && $root$1.ClientState.encode(E.rerunScript, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), E.loadGitInfo != null && Object.hasOwnProperty.call(E, "loadGitInfo") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(E.loadGitInfo), E.debugLastBackmsgId != null && Object.hasOwnProperty.call(E, "debugLastBackmsgId") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.debugLastBackmsgId), E.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(E, "debugDisconnectWebsocket") && e.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(E.debugDisconnectWebsocket), E.debugShutdownRuntime != null && Object.hasOwnProperty.call(E, "debugShutdownRuntime") && e.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(E.debugShutdownRuntime), E.fileUrlsRequest != null && Object.hasOwnProperty.call(E, "fileUrlsRequest") && $root$1.FileURLsRequest.encode(E.fileUrlsRequest, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), E.appHeartbeat != null && Object.hasOwnProperty.call(E, "appHeartbeat") && e.uint32(
      /* id 17, wireType 0 =*/
      136
    ).bool(E.appHeartbeat), E.deferredFileRequest != null && Object.hasOwnProperty.call(E, "deferredFileRequest") && $root$1.DeferredFileRequest.encode(E.deferredFileRequest, e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.BackMsg();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 5: {
          h.clearCache = E.bool();
          break;
        }
        case 6: {
          h.setRunOnSave = E.bool();
          break;
        }
        case 7: {
          h.stopScript = E.bool();
          break;
        }
        case 11: {
          h.rerunScript = $root$1.ClientState.decode(E, E.uint32());
          break;
        }
        case 12: {
          h.loadGitInfo = E.bool();
          break;
        }
        case 14: {
          h.debugDisconnectWebsocket = E.bool();
          break;
        }
        case 15: {
          h.debugShutdownRuntime = E.bool();
          break;
        }
        case 16: {
          h.fileUrlsRequest = $root$1.FileURLsRequest.decode(E, E.uint32());
          break;
        }
        case 17: {
          h.appHeartbeat = E.bool();
          break;
        }
        case 18: {
          h.deferredFileRequest = $root$1.DeferredFileRequest.decode(E, E.uint32());
          break;
        }
        case 13: {
          h.debugLastBackmsgId = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.BackMsg) return E;
    let e = new $root$1.BackMsg();
    if (E.clearCache != null && (e.clearCache = !!E.clearCache), E.setRunOnSave != null && (e.setRunOnSave = !!E.setRunOnSave), E.stopScript != null && (e.stopScript = !!E.stopScript), E.rerunScript != null) {
      if (typeof E.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
      e.rerunScript = $root$1.ClientState.fromObject(E.rerunScript);
    }
    if (E.loadGitInfo != null && (e.loadGitInfo = !!E.loadGitInfo), E.debugDisconnectWebsocket != null && (e.debugDisconnectWebsocket = !!E.debugDisconnectWebsocket), E.debugShutdownRuntime != null && (e.debugShutdownRuntime = !!E.debugShutdownRuntime), E.fileUrlsRequest != null) {
      if (typeof E.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      e.fileUrlsRequest = $root$1.FileURLsRequest.fromObject(E.fileUrlsRequest);
    }
    if (E.appHeartbeat != null && (e.appHeartbeat = !!E.appHeartbeat), E.deferredFileRequest != null) {
      if (typeof E.deferredFileRequest != "object") throw TypeError(".BackMsg.deferredFileRequest: object expected");
      e.deferredFileRequest = $root$1.DeferredFileRequest.fromObject(E.deferredFileRequest);
    }
    return E.debugLastBackmsgId != null && (e.debugLastBackmsgId = String(E.debugLastBackmsgId)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.debugLastBackmsgId = ""), E.clearCache != null && E.hasOwnProperty("clearCache") && (t.clearCache = E.clearCache, e.oneofs && (t.type = "clearCache")), E.setRunOnSave != null && E.hasOwnProperty("setRunOnSave") && (t.setRunOnSave = E.setRunOnSave, e.oneofs && (t.type = "setRunOnSave")), E.stopScript != null && E.hasOwnProperty("stopScript") && (t.stopScript = E.stopScript, e.oneofs && (t.type = "stopScript")), E.rerunScript != null && E.hasOwnProperty("rerunScript") && (t.rerunScript = $root$1.ClientState.toObject(E.rerunScript, e), e.oneofs && (t.type = "rerunScript")), E.loadGitInfo != null && E.hasOwnProperty("loadGitInfo") && (t.loadGitInfo = E.loadGitInfo, e.oneofs && (t.type = "loadGitInfo")), E.debugLastBackmsgId != null && E.hasOwnProperty("debugLastBackmsgId") && (t.debugLastBackmsgId = E.debugLastBackmsgId), E.debugDisconnectWebsocket != null && E.hasOwnProperty("debugDisconnectWebsocket") && (t.debugDisconnectWebsocket = E.debugDisconnectWebsocket, e.oneofs && (t.type = "debugDisconnectWebsocket")), E.debugShutdownRuntime != null && E.hasOwnProperty("debugShutdownRuntime") && (t.debugShutdownRuntime = E.debugShutdownRuntime, e.oneofs && (t.type = "debugShutdownRuntime")), E.fileUrlsRequest != null && E.hasOwnProperty("fileUrlsRequest") && (t.fileUrlsRequest = $root$1.FileURLsRequest.toObject(E.fileUrlsRequest, e), e.oneofs && (t.type = "fileUrlsRequest")), E.appHeartbeat != null && E.hasOwnProperty("appHeartbeat") && (t.appHeartbeat = E.appHeartbeat, e.oneofs && (t.type = "appHeartbeat")), E.deferredFileRequest != null && E.hasOwnProperty("deferredFileRequest") && (t.deferredFileRequest = $root$1.DeferredFileRequest.toObject(E.deferredFileRequest, e), e.oneofs && (t.type = "deferredFileRequest")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/BackMsg";
  }, o;
})();
$root$1.DeferredFileRequest = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.fileId = "", o.prototype.sessionId = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.fileId != null && Object.hasOwnProperty.call(g, "fileId") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.fileId), g.sessionId != null && Object.hasOwnProperty.call(g, "sessionId") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.sessionId), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DeferredFileRequest();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.fileId = g.string();
          break;
        }
        case 2: {
          n.sessionId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DeferredFileRequest) return g;
    let E = new $root$1.DeferredFileRequest();
    return g.fileId != null && (E.fileId = String(g.fileId)), g.sessionId != null && (E.sessionId = String(g.sessionId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.fileId = "", e.sessionId = ""), g.fileId != null && g.hasOwnProperty("fileId") && (e.fileId = g.fileId), g.sessionId != null && g.hasOwnProperty("sessionId") && (e.sessionId = g.sessionId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DeferredFileRequest";
  }, o;
})();
$root$1.ContextInfo = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.timezone = null, o.prototype.timezoneOffset = null, o.prototype.locale = null, o.prototype.url = null, o.prototype.isEmbedded = null, o.prototype.colorScheme = null;
  let i;
  return Object.defineProperty(o.prototype, "_timezone", { get: $util$1.oneOfGetter(i = ["timezone"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_timezoneOffset", { get: $util$1.oneOfGetter(i = ["timezoneOffset"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_locale", { get: $util$1.oneOfGetter(i = ["locale"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_url", { get: $util$1.oneOfGetter(i = ["url"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_isEmbedded", { get: $util$1.oneOfGetter(i = ["isEmbedded"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_colorScheme", { get: $util$1.oneOfGetter(i = ["colorScheme"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.timezone != null && Object.hasOwnProperty.call(E, "timezone") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.timezone), E.timezoneOffset != null && Object.hasOwnProperty.call(E, "timezoneOffset") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(E.timezoneOffset), E.locale != null && Object.hasOwnProperty.call(E, "locale") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.locale), E.url != null && Object.hasOwnProperty.call(E, "url") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.url), E.isEmbedded != null && Object.hasOwnProperty.call(E, "isEmbedded") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.isEmbedded), E.colorScheme != null && Object.hasOwnProperty.call(E, "colorScheme") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.colorScheme), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.ContextInfo();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.timezone = E.string();
          break;
        }
        case 2: {
          h.timezoneOffset = E.int32();
          break;
        }
        case 3: {
          h.locale = E.string();
          break;
        }
        case 4: {
          h.url = E.string();
          break;
        }
        case 5: {
          h.isEmbedded = E.bool();
          break;
        }
        case 6: {
          h.colorScheme = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.ContextInfo) return E;
    let e = new $root$1.ContextInfo();
    return E.timezone != null && (e.timezone = String(E.timezone)), E.timezoneOffset != null && (e.timezoneOffset = E.timezoneOffset | 0), E.locale != null && (e.locale = String(E.locale)), E.url != null && (e.url = String(E.url)), E.isEmbedded != null && (e.isEmbedded = !!E.isEmbedded), E.colorScheme != null && (e.colorScheme = String(E.colorScheme)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return E.timezone != null && E.hasOwnProperty("timezone") && (t.timezone = E.timezone, e.oneofs && (t._timezone = "timezone")), E.timezoneOffset != null && E.hasOwnProperty("timezoneOffset") && (t.timezoneOffset = E.timezoneOffset, e.oneofs && (t._timezoneOffset = "timezoneOffset")), E.locale != null && E.hasOwnProperty("locale") && (t.locale = E.locale, e.oneofs && (t._locale = "locale")), E.url != null && E.hasOwnProperty("url") && (t.url = E.url, e.oneofs && (t._url = "url")), E.isEmbedded != null && E.hasOwnProperty("isEmbedded") && (t.isEmbedded = E.isEmbedded, e.oneofs && (t._isEmbedded = "isEmbedded")), E.colorScheme != null && E.hasOwnProperty("colorScheme") && (t.colorScheme = E.colorScheme, e.oneofs && (t._colorScheme = "colorScheme")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ContextInfo";
  }, o;
})();
$root$1.ClientState = (() => {
  function o(i) {
    if (this.cachedMessageHashes = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.queryString = "", o.prototype.widgetStates = null, o.prototype.pageScriptHash = "", o.prototype.pageName = "", o.prototype.fragmentId = "", o.prototype.isAutoRerun = !1, o.prototype.cachedMessageHashes = $util$1.emptyArray, o.prototype.contextInfo = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.queryString != null && Object.hasOwnProperty.call(g, "queryString") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.queryString), g.widgetStates != null && Object.hasOwnProperty.call(g, "widgetStates") && $root$1.WidgetStates.encode(g.widgetStates, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.pageScriptHash), g.pageName != null && Object.hasOwnProperty.call(g, "pageName") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.pageName), g.fragmentId != null && Object.hasOwnProperty.call(g, "fragmentId") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.fragmentId), g.isAutoRerun != null && Object.hasOwnProperty.call(g, "isAutoRerun") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.isAutoRerun), g.cachedMessageHashes != null && g.cachedMessageHashes.length) for (let e = 0; e < g.cachedMessageHashes.length; ++e) E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.cachedMessageHashes[e]);
    return g.contextInfo != null && Object.hasOwnProperty.call(g, "contextInfo") && $root$1.ContextInfo.encode(g.contextInfo, E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ClientState();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.queryString = g.string();
          break;
        }
        case 2: {
          n.widgetStates = $root$1.WidgetStates.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.pageScriptHash = g.string();
          break;
        }
        case 4: {
          n.pageName = g.string();
          break;
        }
        case 5: {
          n.fragmentId = g.string();
          break;
        }
        case 6: {
          n.isAutoRerun = g.bool();
          break;
        }
        case 7: {
          n.cachedMessageHashes && n.cachedMessageHashes.length || (n.cachedMessageHashes = []), n.cachedMessageHashes.push(g.string());
          break;
        }
        case 8: {
          n.contextInfo = $root$1.ContextInfo.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ClientState) return g;
    let E = new $root$1.ClientState();
    if (g.queryString != null && (E.queryString = String(g.queryString)), g.widgetStates != null) {
      if (typeof g.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
      E.widgetStates = $root$1.WidgetStates.fromObject(g.widgetStates);
    }
    if (g.pageScriptHash != null && (E.pageScriptHash = String(g.pageScriptHash)), g.pageName != null && (E.pageName = String(g.pageName)), g.fragmentId != null && (E.fragmentId = String(g.fragmentId)), g.isAutoRerun != null && (E.isAutoRerun = !!g.isAutoRerun), g.cachedMessageHashes) {
      if (!Array.isArray(g.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
      E.cachedMessageHashes = [];
      for (let e = 0; e < g.cachedMessageHashes.length; ++e) E.cachedMessageHashes[e] = String(g.cachedMessageHashes[e]);
    }
    if (g.contextInfo != null) {
      if (typeof g.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
      E.contextInfo = $root$1.ContextInfo.fromObject(g.contextInfo);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.cachedMessageHashes = []), E.defaults && (e.queryString = "", e.widgetStates = null, e.pageScriptHash = "", e.pageName = "", e.fragmentId = "", e.isAutoRerun = !1, e.contextInfo = null), g.queryString != null && g.hasOwnProperty("queryString") && (e.queryString = g.queryString), g.widgetStates != null && g.hasOwnProperty("widgetStates") && (e.widgetStates = $root$1.WidgetStates.toObject(g.widgetStates, E)), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = g.pageScriptHash), g.pageName != null && g.hasOwnProperty("pageName") && (e.pageName = g.pageName), g.fragmentId != null && g.hasOwnProperty("fragmentId") && (e.fragmentId = g.fragmentId), g.isAutoRerun != null && g.hasOwnProperty("isAutoRerun") && (e.isAutoRerun = g.isAutoRerun), g.cachedMessageHashes && g.cachedMessageHashes.length) {
      e.cachedMessageHashes = [];
      for (let t = 0; t < g.cachedMessageHashes.length; ++t) e.cachedMessageHashes[t] = g.cachedMessageHashes[t];
    }
    return g.contextInfo != null && g.hasOwnProperty("contextInfo") && (e.contextInfo = $root$1.ContextInfo.toObject(g.contextInfo, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ClientState";
  }, o;
})();
const WidgetStates = $root$1.WidgetStates = (() => {
  function o(i) {
    if (this.widgets = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.widgets = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.widgets != null && g.widgets.length) for (let e = 0; e < g.widgets.length; ++e) $root$1.WidgetState.encode(g.widgets[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.WidgetStates();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.widgets && n.widgets.length || (n.widgets = []), n.widgets.push($root$1.WidgetState.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.WidgetStates) return g;
    let E = new $root$1.WidgetStates();
    if (g.widgets) {
      if (!Array.isArray(g.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
      E.widgets = [];
      for (let e = 0; e < g.widgets.length; ++e) {
        if (typeof g.widgets[e] != "object") throw TypeError(".WidgetStates.widgets: object expected");
        E.widgets[e] = $root$1.WidgetState.fromObject(g.widgets[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.widgets = []), g.widgets && g.widgets.length) {
      e.widgets = [];
      for (let t = 0; t < g.widgets.length; ++t) e.widgets[t] = $root$1.WidgetState.toObject(g.widgets[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/WidgetStates";
  }, o;
})(), WidgetState = $root$1.WidgetState = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.triggerValue = null, o.prototype.boolValue = null, o.prototype.doubleValue = null, o.prototype.intValue = null, o.prototype.stringValue = null, o.prototype.doubleArrayValue = null, o.prototype.intArrayValue = null, o.prototype.stringArrayValue = null, o.prototype.jsonValue = null, o.prototype.arrowValue = null, o.prototype.bytesValue = null, o.prototype.fileUploaderStateValue = null, o.prototype.stringTriggerValue = null, o.prototype.chatInputValue = null, o.prototype.jsonTriggerValue = null;
  let i;
  return Object.defineProperty(o.prototype, "value", { get: $util$1.oneOfGetter(i = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue", "jsonTriggerValue"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.triggerValue != null && Object.hasOwnProperty.call(E, "triggerValue") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.triggerValue), E.boolValue != null && Object.hasOwnProperty.call(E, "boolValue") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.boolValue), E.doubleValue != null && Object.hasOwnProperty.call(E, "doubleValue") && e.uint32(
      /* id 4, wireType 1 =*/
      33
    ).double(E.doubleValue), E.intValue != null && Object.hasOwnProperty.call(E, "intValue") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).sint64(E.intValue), E.stringValue != null && Object.hasOwnProperty.call(E, "stringValue") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.stringValue), E.doubleArrayValue != null && Object.hasOwnProperty.call(E, "doubleArrayValue") && $root$1.DoubleArray.encode(E.doubleArrayValue, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), E.intArrayValue != null && Object.hasOwnProperty.call(E, "intArrayValue") && $root$1.SInt64Array.encode(E.intArrayValue, e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), E.stringArrayValue != null && Object.hasOwnProperty.call(E, "stringArrayValue") && $root$1.StringArray.encode(E.stringArrayValue, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E.jsonValue != null && Object.hasOwnProperty.call(E, "jsonValue") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.jsonValue), E.arrowValue != null && Object.hasOwnProperty.call(E, "arrowValue") && $root$1.ArrowTable.encode(E.arrowValue, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), E.bytesValue != null && Object.hasOwnProperty.call(E, "bytesValue") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(E.bytesValue), E.fileUploaderStateValue != null && Object.hasOwnProperty.call(E, "fileUploaderStateValue") && $root$1.FileUploaderState.encode(E.fileUploaderStateValue, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), E.stringTriggerValue != null && Object.hasOwnProperty.call(E, "stringTriggerValue") && $root$1.StringTriggerValue.encode(E.stringTriggerValue, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), E.chatInputValue != null && Object.hasOwnProperty.call(E, "chatInputValue") && $root$1.ChatInputValue.encode(E.chatInputValue, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), E.jsonTriggerValue != null && Object.hasOwnProperty.call(E, "jsonTriggerValue") && e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(E.jsonTriggerValue), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.WidgetState();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.triggerValue = E.bool();
          break;
        }
        case 3: {
          h.boolValue = E.bool();
          break;
        }
        case 4: {
          h.doubleValue = E.double();
          break;
        }
        case 5: {
          h.intValue = E.sint64();
          break;
        }
        case 6: {
          h.stringValue = E.string();
          break;
        }
        case 7: {
          h.doubleArrayValue = $root$1.DoubleArray.decode(E, E.uint32());
          break;
        }
        case 8: {
          h.intArrayValue = $root$1.SInt64Array.decode(E, E.uint32());
          break;
        }
        case 9: {
          h.stringArrayValue = $root$1.StringArray.decode(E, E.uint32());
          break;
        }
        case 10: {
          h.jsonValue = E.string();
          break;
        }
        case 11: {
          h.arrowValue = $root$1.ArrowTable.decode(E, E.uint32());
          break;
        }
        case 12: {
          h.bytesValue = E.bytes();
          break;
        }
        case 13: {
          h.fileUploaderStateValue = $root$1.FileUploaderState.decode(E, E.uint32());
          break;
        }
        case 14: {
          h.stringTriggerValue = $root$1.StringTriggerValue.decode(E, E.uint32());
          break;
        }
        case 15: {
          h.chatInputValue = $root$1.ChatInputValue.decode(E, E.uint32());
          break;
        }
        case 16: {
          h.jsonTriggerValue = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.WidgetState) return E;
    let e = new $root$1.WidgetState();
    if (E.id != null && (e.id = String(E.id)), E.triggerValue != null && (e.triggerValue = !!E.triggerValue), E.boolValue != null && (e.boolValue = !!E.boolValue), E.doubleValue != null && (e.doubleValue = Number(E.doubleValue)), E.intValue != null && ($util$1.Long ? (e.intValue = $util$1.Long.fromValue(E.intValue)).unsigned = !1 : typeof E.intValue == "string" ? e.intValue = parseInt(E.intValue, 10) : typeof E.intValue == "number" ? e.intValue = E.intValue : typeof E.intValue == "object" && (e.intValue = new $util$1.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber())), E.stringValue != null && (e.stringValue = String(E.stringValue)), E.doubleArrayValue != null) {
      if (typeof E.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
      e.doubleArrayValue = $root$1.DoubleArray.fromObject(E.doubleArrayValue);
    }
    if (E.intArrayValue != null) {
      if (typeof E.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
      e.intArrayValue = $root$1.SInt64Array.fromObject(E.intArrayValue);
    }
    if (E.stringArrayValue != null) {
      if (typeof E.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
      e.stringArrayValue = $root$1.StringArray.fromObject(E.stringArrayValue);
    }
    if (E.jsonValue != null && (e.jsonValue = String(E.jsonValue)), E.arrowValue != null) {
      if (typeof E.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
      e.arrowValue = $root$1.ArrowTable.fromObject(E.arrowValue);
    }
    if (E.bytesValue != null && (typeof E.bytesValue == "string" ? $util$1.base64.decode(E.bytesValue, e.bytesValue = $util$1.newBuffer($util$1.base64.length(E.bytesValue)), 0) : E.bytesValue.length >= 0 && (e.bytesValue = E.bytesValue)), E.fileUploaderStateValue != null) {
      if (typeof E.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      e.fileUploaderStateValue = $root$1.FileUploaderState.fromObject(E.fileUploaderStateValue);
    }
    if (E.stringTriggerValue != null) {
      if (typeof E.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
      e.stringTriggerValue = $root$1.StringTriggerValue.fromObject(E.stringTriggerValue);
    }
    if (E.chatInputValue != null) {
      if (typeof E.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
      e.chatInputValue = $root$1.ChatInputValue.fromObject(E.chatInputValue);
    }
    return E.jsonTriggerValue != null && (e.jsonTriggerValue = String(E.jsonTriggerValue)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = ""), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.triggerValue != null && E.hasOwnProperty("triggerValue") && (t.triggerValue = E.triggerValue, e.oneofs && (t.value = "triggerValue")), E.boolValue != null && E.hasOwnProperty("boolValue") && (t.boolValue = E.boolValue, e.oneofs && (t.value = "boolValue")), E.doubleValue != null && E.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(E.doubleValue) ? String(E.doubleValue) : E.doubleValue, e.oneofs && (t.value = "doubleValue")), E.intValue != null && E.hasOwnProperty("intValue") && (typeof E.intValue == "number" ? t.intValue = e.longs === String ? String(E.intValue) : E.intValue : t.intValue = e.longs === String ? $util$1.Long.prototype.toString.call(E.intValue) : e.longs === Number ? new $util$1.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber() : E.intValue, e.oneofs && (t.value = "intValue")), E.stringValue != null && E.hasOwnProperty("stringValue") && (t.stringValue = E.stringValue, e.oneofs && (t.value = "stringValue")), E.doubleArrayValue != null && E.hasOwnProperty("doubleArrayValue") && (t.doubleArrayValue = $root$1.DoubleArray.toObject(E.doubleArrayValue, e), e.oneofs && (t.value = "doubleArrayValue")), E.intArrayValue != null && E.hasOwnProperty("intArrayValue") && (t.intArrayValue = $root$1.SInt64Array.toObject(E.intArrayValue, e), e.oneofs && (t.value = "intArrayValue")), E.stringArrayValue != null && E.hasOwnProperty("stringArrayValue") && (t.stringArrayValue = $root$1.StringArray.toObject(E.stringArrayValue, e), e.oneofs && (t.value = "stringArrayValue")), E.jsonValue != null && E.hasOwnProperty("jsonValue") && (t.jsonValue = E.jsonValue, e.oneofs && (t.value = "jsonValue")), E.arrowValue != null && E.hasOwnProperty("arrowValue") && (t.arrowValue = $root$1.ArrowTable.toObject(E.arrowValue, e), e.oneofs && (t.value = "arrowValue")), E.bytesValue != null && E.hasOwnProperty("bytesValue") && (t.bytesValue = e.bytes === String ? $util$1.base64.encode(E.bytesValue, 0, E.bytesValue.length) : e.bytes === Array ? Array.prototype.slice.call(E.bytesValue) : E.bytesValue, e.oneofs && (t.value = "bytesValue")), E.fileUploaderStateValue != null && E.hasOwnProperty("fileUploaderStateValue") && (t.fileUploaderStateValue = $root$1.FileUploaderState.toObject(E.fileUploaderStateValue, e), e.oneofs && (t.value = "fileUploaderStateValue")), E.stringTriggerValue != null && E.hasOwnProperty("stringTriggerValue") && (t.stringTriggerValue = $root$1.StringTriggerValue.toObject(E.stringTriggerValue, e), e.oneofs && (t.value = "stringTriggerValue")), E.chatInputValue != null && E.hasOwnProperty("chatInputValue") && (t.chatInputValue = $root$1.ChatInputValue.toObject(E.chatInputValue, e), e.oneofs && (t.value = "chatInputValue")), E.jsonTriggerValue != null && E.hasOwnProperty("jsonTriggerValue") && (t.jsonTriggerValue = E.jsonTriggerValue, e.oneofs && (t.value = "jsonTriggerValue")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/WidgetState";
  }, o;
})(), StringArray = $root$1.StringArray = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.data != null && g.data.length) for (let e = 0; e < g.data.length; ++e) E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.data[e]);
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.StringArray();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data && n.data.length || (n.data = []), n.data.push(g.string());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.StringArray) return g;
    let E = new $root$1.StringArray();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".StringArray.data: array expected");
      E.data = [];
      for (let e = 0; e < g.data.length; ++e) E.data[e] = String(g.data[e]);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.data = []), g.data && g.data.length) {
      e.data = [];
      for (let t = 0; t < g.data.length; ++t) e.data[t] = g.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/StringArray";
  }, o;
})(), DoubleArray = $root$1.DoubleArray = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.data != null && g.data.length) {
      E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < g.data.length; ++e) E.double(g.data[e]);
      E.ldelim();
    }
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DoubleArray();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          if (n.data && n.data.length || (n.data = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.data.push(g.double());
          } else n.data.push(g.double());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DoubleArray) return g;
    let E = new $root$1.DoubleArray();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".DoubleArray.data: array expected");
      E.data = [];
      for (let e = 0; e < g.data.length; ++e) E.data[e] = Number(g.data[e]);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.data = []), g.data && g.data.length) {
      e.data = [];
      for (let t = 0; t < g.data.length; ++t) e.data[t] = E.json && !isFinite(g.data[t]) ? String(g.data[t]) : g.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DoubleArray";
  }, o;
})();
$root$1.Int32Array = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.data != null && g.data.length) {
      E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < g.data.length; ++e) E.int32(g.data[e]);
      E.ldelim();
    }
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Int32Array();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          if (n.data && n.data.length || (n.data = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.data.push(g.int32());
          } else n.data.push(g.int32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Int32Array) return g;
    let E = new $root$1.Int32Array();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".Int32Array.data: array expected");
      E.data = [];
      for (let e = 0; e < g.data.length; ++e) E.data[e] = g.data[e] | 0;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.data = []), g.data && g.data.length) {
      e.data = [];
      for (let t = 0; t < g.data.length; ++t) e.data[t] = g.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Int32Array";
  }, o;
})();
$root$1.Int64Array = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.data != null && g.data.length) {
      E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < g.data.length; ++e) E.int64(g.data[e]);
      E.ldelim();
    }
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Int64Array();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          if (n.data && n.data.length || (n.data = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.data.push(g.int64());
          } else n.data.push(g.int64());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Int64Array) return g;
    let E = new $root$1.Int64Array();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".Int64Array.data: array expected");
      E.data = [];
      for (let e = 0; e < g.data.length; ++e) $util$1.Long ? (E.data[e] = $util$1.Long.fromValue(g.data[e])).unsigned = !1 : typeof g.data[e] == "string" ? E.data[e] = parseInt(g.data[e], 10) : typeof g.data[e] == "number" ? E.data[e] = g.data[e] : typeof g.data[e] == "object" && (E.data[e] = new $util$1.LongBits(g.data[e].low >>> 0, g.data[e].high >>> 0).toNumber());
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.data = []), g.data && g.data.length) {
      e.data = [];
      for (let t = 0; t < g.data.length; ++t) typeof g.data[t] == "number" ? e.data[t] = E.longs === String ? String(g.data[t]) : g.data[t] : e.data[t] = E.longs === String ? $util$1.Long.prototype.toString.call(g.data[t]) : E.longs === Number ? new $util$1.LongBits(g.data[t].low >>> 0, g.data[t].high >>> 0).toNumber() : g.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Int64Array";
  }, o;
})();
const SInt64Array = $root$1.SInt64Array = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.data != null && g.data.length) {
      E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < g.data.length; ++e) E.sint64(g.data[e]);
      E.ldelim();
    }
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.SInt64Array();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          if (n.data && n.data.length || (n.data = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.data.push(g.sint64());
          } else n.data.push(g.sint64());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.SInt64Array) return g;
    let E = new $root$1.SInt64Array();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".SInt64Array.data: array expected");
      E.data = [];
      for (let e = 0; e < g.data.length; ++e) $util$1.Long ? (E.data[e] = $util$1.Long.fromValue(g.data[e])).unsigned = !1 : typeof g.data[e] == "string" ? E.data[e] = parseInt(g.data[e], 10) : typeof g.data[e] == "number" ? E.data[e] = g.data[e] : typeof g.data[e] == "object" && (E.data[e] = new $util$1.LongBits(g.data[e].low >>> 0, g.data[e].high >>> 0).toNumber());
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.data = []), g.data && g.data.length) {
      e.data = [];
      for (let t = 0; t < g.data.length; ++t) typeof g.data[t] == "number" ? e.data[t] = E.longs === String ? String(g.data[t]) : g.data[t] : e.data[t] = E.longs === String ? $util$1.Long.prototype.toString.call(g.data[t]) : E.longs === Number ? new $util$1.LongBits(g.data[t].low >>> 0, g.data[t].high >>> 0).toNumber() : g.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SInt64Array";
  }, o;
})();
$root$1.UInt32Array = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.data != null && g.data.length) {
      E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < g.data.length; ++e) E.uint32(g.data[e]);
      E.ldelim();
    }
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.UInt32Array();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          if (n.data && n.data.length || (n.data = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.data.push(g.uint32());
          } else n.data.push(g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.UInt32Array) return g;
    let E = new $root$1.UInt32Array();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".UInt32Array.data: array expected");
      E.data = [];
      for (let e = 0; e < g.data.length; ++e) E.data[e] = g.data[e] >>> 0;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.data = []), g.data && g.data.length) {
      e.data = [];
      for (let t = 0; t < g.data.length; ++t) e.data[t] = g.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/UInt32Array";
  }, o;
})();
$root$1.StringTriggerValue = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.data = null;
  let i;
  return Object.defineProperty(o.prototype, "_data", { get: $util$1.oneOfGetter(i = ["data"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.data), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.StringTriggerValue();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.data = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.StringTriggerValue) return E;
    let e = new $root$1.StringTriggerValue();
    return E.data != null && (e.data = String(E.data)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return E.data != null && E.hasOwnProperty("data") && (t.data = E.data, e.oneofs && (t._data = "data")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/StringTriggerValue";
  }, o;
})();
$root$1.FileURLsRequest = (() => {
  function o(i) {
    if (this.fileNames = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.requestId = "", o.prototype.fileNames = $util$1.emptyArray, o.prototype.sessionId = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.requestId != null && Object.hasOwnProperty.call(g, "requestId") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.requestId), g.fileNames != null && g.fileNames.length) for (let e = 0; e < g.fileNames.length; ++e) E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.fileNames[e]);
    return g.sessionId != null && Object.hasOwnProperty.call(g, "sessionId") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.sessionId), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.FileURLsRequest();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.requestId = g.string();
          break;
        }
        case 2: {
          n.fileNames && n.fileNames.length || (n.fileNames = []), n.fileNames.push(g.string());
          break;
        }
        case 3: {
          n.sessionId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.FileURLsRequest) return g;
    let E = new $root$1.FileURLsRequest();
    if (g.requestId != null && (E.requestId = String(g.requestId)), g.fileNames) {
      if (!Array.isArray(g.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
      E.fileNames = [];
      for (let e = 0; e < g.fileNames.length; ++e) E.fileNames[e] = String(g.fileNames[e]);
    }
    return g.sessionId != null && (E.sessionId = String(g.sessionId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.fileNames = []), E.defaults && (e.requestId = "", e.sessionId = ""), g.requestId != null && g.hasOwnProperty("requestId") && (e.requestId = g.requestId), g.fileNames && g.fileNames.length) {
      e.fileNames = [];
      for (let t = 0; t < g.fileNames.length; ++t) e.fileNames[t] = g.fileNames[t];
    }
    return g.sessionId != null && g.hasOwnProperty("sessionId") && (e.sessionId = g.sessionId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileURLsRequest";
  }, o;
})();
$root$1.FileURLs = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.fileId = "", o.prototype.uploadUrl = "", o.prototype.deleteUrl = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.fileId != null && Object.hasOwnProperty.call(g, "fileId") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.fileId), g.uploadUrl != null && Object.hasOwnProperty.call(g, "uploadUrl") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.uploadUrl), g.deleteUrl != null && Object.hasOwnProperty.call(g, "deleteUrl") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.deleteUrl), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.FileURLs();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.fileId = g.string();
          break;
        }
        case 2: {
          n.uploadUrl = g.string();
          break;
        }
        case 3: {
          n.deleteUrl = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.FileURLs) return g;
    let E = new $root$1.FileURLs();
    return g.fileId != null && (E.fileId = String(g.fileId)), g.uploadUrl != null && (E.uploadUrl = String(g.uploadUrl)), g.deleteUrl != null && (E.deleteUrl = String(g.deleteUrl)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.fileId = "", e.uploadUrl = "", e.deleteUrl = ""), g.fileId != null && g.hasOwnProperty("fileId") && (e.fileId = g.fileId), g.uploadUrl != null && g.hasOwnProperty("uploadUrl") && (e.uploadUrl = g.uploadUrl), g.deleteUrl != null && g.hasOwnProperty("deleteUrl") && (e.deleteUrl = g.deleteUrl), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileURLs";
  }, o;
})();
$root$1.FileURLsResponse = (() => {
  function o(i) {
    if (this.fileUrls = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.responseId = "", o.prototype.fileUrls = $util$1.emptyArray, o.prototype.errorMsg = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.responseId != null && Object.hasOwnProperty.call(g, "responseId") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.responseId), g.fileUrls != null && g.fileUrls.length) for (let e = 0; e < g.fileUrls.length; ++e) $root$1.FileURLs.encode(g.fileUrls[e], E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g.errorMsg != null && Object.hasOwnProperty.call(g, "errorMsg") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.errorMsg), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.FileURLsResponse();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.responseId = g.string();
          break;
        }
        case 2: {
          n.fileUrls && n.fileUrls.length || (n.fileUrls = []), n.fileUrls.push($root$1.FileURLs.decode(g, g.uint32()));
          break;
        }
        case 3: {
          n.errorMsg = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.FileURLsResponse) return g;
    let E = new $root$1.FileURLsResponse();
    if (g.responseId != null && (E.responseId = String(g.responseId)), g.fileUrls) {
      if (!Array.isArray(g.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
      E.fileUrls = [];
      for (let e = 0; e < g.fileUrls.length; ++e) {
        if (typeof g.fileUrls[e] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
        E.fileUrls[e] = $root$1.FileURLs.fromObject(g.fileUrls[e]);
      }
    }
    return g.errorMsg != null && (E.errorMsg = String(g.errorMsg)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.fileUrls = []), E.defaults && (e.responseId = "", e.errorMsg = ""), g.responseId != null && g.hasOwnProperty("responseId") && (e.responseId = g.responseId), g.fileUrls && g.fileUrls.length) {
      e.fileUrls = [];
      for (let t = 0; t < g.fileUrls.length; ++t) e.fileUrls[t] = $root$1.FileURLs.toObject(g.fileUrls[t], E);
    }
    return g.errorMsg != null && g.hasOwnProperty("errorMsg") && (e.errorMsg = g.errorMsg), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileURLsResponse";
  }, o;
})();
const UploadedFileInfo = $root$1.UploadedFileInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.name = "", o.prototype.size = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, o.prototype.fileId = "", o.prototype.fileUrls = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(g.id), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.name), g.size != null && Object.hasOwnProperty.call(g, "size") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint64(g.size), g.fileId != null && Object.hasOwnProperty.call(g, "fileId") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.fileId), g.fileUrls != null && Object.hasOwnProperty.call(g, "fileUrls") && $root$1.FileURLs.encode(g.fileUrls, E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.UploadedFileInfo();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.sint64();
          break;
        }
        case 2: {
          n.name = g.string();
          break;
        }
        case 3: {
          n.size = g.uint64();
          break;
        }
        case 4: {
          n.fileId = g.string();
          break;
        }
        case 5: {
          n.fileUrls = $root$1.FileURLs.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.UploadedFileInfo) return g;
    let E = new $root$1.UploadedFileInfo();
    if (g.id != null && ($util$1.Long ? (E.id = $util$1.Long.fromValue(g.id)).unsigned = !1 : typeof g.id == "string" ? E.id = parseInt(g.id, 10) : typeof g.id == "number" ? E.id = g.id : typeof g.id == "object" && (E.id = new $util$1.LongBits(g.id.low >>> 0, g.id.high >>> 0).toNumber())), g.name != null && (E.name = String(g.name)), g.size != null && ($util$1.Long ? (E.size = $util$1.Long.fromValue(g.size)).unsigned = !0 : typeof g.size == "string" ? E.size = parseInt(g.size, 10) : typeof g.size == "number" ? E.size = g.size : typeof g.size == "object" && (E.size = new $util$1.LongBits(g.size.low >>> 0, g.size.high >>> 0).toNumber(!0))), g.fileId != null && (E.fileId = String(g.fileId)), g.fileUrls != null) {
      if (typeof g.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      E.fileUrls = $root$1.FileURLs.fromObject(g.fileUrls);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if (E.defaults) {
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.id = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.id = E.longs === String ? "0" : 0;
      if (e.name = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !0);
        e.size = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.size = E.longs === String ? "0" : 0;
      e.fileId = "", e.fileUrls = null;
    }
    return g.id != null && g.hasOwnProperty("id") && (typeof g.id == "number" ? e.id = E.longs === String ? String(g.id) : g.id : e.id = E.longs === String ? $util$1.Long.prototype.toString.call(g.id) : E.longs === Number ? new $util$1.LongBits(g.id.low >>> 0, g.id.high >>> 0).toNumber() : g.id), g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.size != null && g.hasOwnProperty("size") && (typeof g.size == "number" ? e.size = E.longs === String ? String(g.size) : g.size : e.size = E.longs === String ? $util$1.Long.prototype.toString.call(g.size) : E.longs === Number ? new $util$1.LongBits(g.size.low >>> 0, g.size.high >>> 0).toNumber(!0) : g.size), g.fileId != null && g.hasOwnProperty("fileId") && (e.fileId = g.fileId), g.fileUrls != null && g.hasOwnProperty("fileUrls") && (e.fileUrls = $root$1.FileURLs.toObject(g.fileUrls, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/UploadedFileInfo";
  }, o;
})(), FileUploaderState = $root$1.FileUploaderState = (() => {
  function o(i) {
    if (this.uploadedFileInfo = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.maxFileId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.uploadedFileInfo = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.maxFileId != null && Object.hasOwnProperty.call(g, "maxFileId") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(g.maxFileId), g.uploadedFileInfo != null && g.uploadedFileInfo.length) for (let e = 0; e < g.uploadedFileInfo.length; ++e) $root$1.UploadedFileInfo.encode(g.uploadedFileInfo[e], E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.FileUploaderState();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.maxFileId = g.sint64();
          break;
        }
        case 2: {
          n.uploadedFileInfo && n.uploadedFileInfo.length || (n.uploadedFileInfo = []), n.uploadedFileInfo.push($root$1.UploadedFileInfo.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.FileUploaderState) return g;
    let E = new $root$1.FileUploaderState();
    if (g.maxFileId != null && ($util$1.Long ? (E.maxFileId = $util$1.Long.fromValue(g.maxFileId)).unsigned = !1 : typeof g.maxFileId == "string" ? E.maxFileId = parseInt(g.maxFileId, 10) : typeof g.maxFileId == "number" ? E.maxFileId = g.maxFileId : typeof g.maxFileId == "object" && (E.maxFileId = new $util$1.LongBits(g.maxFileId.low >>> 0, g.maxFileId.high >>> 0).toNumber())), g.uploadedFileInfo) {
      if (!Array.isArray(g.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      E.uploadedFileInfo = [];
      for (let e = 0; e < g.uploadedFileInfo.length; ++e) {
        if (typeof g.uploadedFileInfo[e] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        E.uploadedFileInfo[e] = $root$1.UploadedFileInfo.fromObject(g.uploadedFileInfo[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.uploadedFileInfo = []), E.defaults) if ($util$1.Long) {
      let t = new $util$1.Long(0, 0, !1);
      e.maxFileId = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
    } else e.maxFileId = E.longs === String ? "0" : 0;
    if (g.maxFileId != null && g.hasOwnProperty("maxFileId") && (typeof g.maxFileId == "number" ? e.maxFileId = E.longs === String ? String(g.maxFileId) : g.maxFileId : e.maxFileId = E.longs === String ? $util$1.Long.prototype.toString.call(g.maxFileId) : E.longs === Number ? new $util$1.LongBits(g.maxFileId.low >>> 0, g.maxFileId.high >>> 0).toNumber() : g.maxFileId), g.uploadedFileInfo && g.uploadedFileInfo.length) {
      e.uploadedFileInfo = [];
      for (let t = 0; t < g.uploadedFileInfo.length; ++t) e.uploadedFileInfo[t] = $root$1.UploadedFileInfo.toObject(g.uploadedFileInfo[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileUploaderState";
  }, o;
})(), ChatInputValue = $root$1.ChatInputValue = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.data = null, o.prototype.fileUploaderState = null, o.prototype.audioFileInfo = null;
  let i;
  return Object.defineProperty(o.prototype, "_data", { get: $util$1.oneOfGetter(i = ["data"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_fileUploaderState", { get: $util$1.oneOfGetter(i = ["fileUploaderState"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_audioFileInfo", { get: $util$1.oneOfGetter(i = ["audioFileInfo"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.data), E.fileUploaderState != null && Object.hasOwnProperty.call(E, "fileUploaderState") && $root$1.FileUploaderState.encode(E.fileUploaderState, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.audioFileInfo != null && Object.hasOwnProperty.call(E, "audioFileInfo") && $root$1.UploadedFileInfo.encode(E.audioFileInfo, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.ChatInputValue();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.data = E.string();
          break;
        }
        case 2: {
          h.fileUploaderState = $root$1.FileUploaderState.decode(E, E.uint32());
          break;
        }
        case 3: {
          h.audioFileInfo = $root$1.UploadedFileInfo.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.ChatInputValue) return E;
    let e = new $root$1.ChatInputValue();
    if (E.data != null && (e.data = String(E.data)), E.fileUploaderState != null) {
      if (typeof E.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      e.fileUploaderState = $root$1.FileUploaderState.fromObject(E.fileUploaderState);
    }
    if (E.audioFileInfo != null) {
      if (typeof E.audioFileInfo != "object") throw TypeError(".ChatInputValue.audioFileInfo: object expected");
      e.audioFileInfo = $root$1.UploadedFileInfo.fromObject(E.audioFileInfo);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return E.data != null && E.hasOwnProperty("data") && (t.data = E.data, e.oneofs && (t._data = "data")), E.fileUploaderState != null && E.hasOwnProperty("fileUploaderState") && (t.fileUploaderState = $root$1.FileUploaderState.toObject(E.fileUploaderState, e), e.oneofs && (t._fileUploaderState = "fileUploaderState")), E.audioFileInfo != null && E.hasOwnProperty("audioFileInfo") && (t.audioFileInfo = $root$1.UploadedFileInfo.toObject(E.audioFileInfo, e), e.oneofs && (t._audioFileInfo = "audioFileInfo")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ChatInputValue";
  }, o;
})();
$root$1.ComponentInstance = (() => {
  function o(g) {
    if (this.specialArgs = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.jsonArgs = "", o.prototype.specialArgs = $util$1.emptyArray, o.prototype.componentName = "", o.prototype.url = "", o.prototype.formId = "", o.prototype.tabIndex = null;
  let i;
  return Object.defineProperty(o.prototype, "_tabIndex", { get: $util$1.oneOfGetter(i = ["tabIndex"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.jsonArgs != null && Object.hasOwnProperty.call(E, "jsonArgs") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.jsonArgs), E.specialArgs != null && E.specialArgs.length) for (let t = 0; t < E.specialArgs.length; ++t) $root$1.SpecialArg.encode(E.specialArgs[t], e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim();
    return E.componentName != null && Object.hasOwnProperty.call(E, "componentName") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.componentName), E.url != null && Object.hasOwnProperty.call(E, "url") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.url), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.formId), E.tabIndex != null && Object.hasOwnProperty.call(E, "tabIndex") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(E.tabIndex), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.ComponentInstance();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.jsonArgs = E.string();
          break;
        }
        case 3: {
          h.specialArgs && h.specialArgs.length || (h.specialArgs = []), h.specialArgs.push($root$1.SpecialArg.decode(E, E.uint32()));
          break;
        }
        case 4: {
          h.componentName = E.string();
          break;
        }
        case 5: {
          h.url = E.string();
          break;
        }
        case 6: {
          h.formId = E.string();
          break;
        }
        case 7: {
          h.tabIndex = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.ComponentInstance) return E;
    let e = new $root$1.ComponentInstance();
    if (E.id != null && (e.id = String(E.id)), E.jsonArgs != null && (e.jsonArgs = String(E.jsonArgs)), E.specialArgs) {
      if (!Array.isArray(E.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
      e.specialArgs = [];
      for (let t = 0; t < E.specialArgs.length; ++t) {
        if (typeof E.specialArgs[t] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
        e.specialArgs[t] = $root$1.SpecialArg.fromObject(E.specialArgs[t]);
      }
    }
    return E.componentName != null && (e.componentName = String(E.componentName)), E.url != null && (e.url = String(E.url)), E.formId != null && (e.formId = String(E.formId)), E.tabIndex != null && (e.tabIndex = E.tabIndex | 0), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.specialArgs = []), e.defaults && (t.id = "", t.jsonArgs = "", t.componentName = "", t.url = "", t.formId = ""), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.jsonArgs != null && E.hasOwnProperty("jsonArgs") && (t.jsonArgs = E.jsonArgs), E.specialArgs && E.specialArgs.length) {
      t.specialArgs = [];
      for (let n = 0; n < E.specialArgs.length; ++n) t.specialArgs[n] = $root$1.SpecialArg.toObject(E.specialArgs[n], e);
    }
    return E.componentName != null && E.hasOwnProperty("componentName") && (t.componentName = E.componentName), E.url != null && E.hasOwnProperty("url") && (t.url = E.url), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.tabIndex != null && E.hasOwnProperty("tabIndex") && (t.tabIndex = E.tabIndex, e.oneofs && (t._tabIndex = "tabIndex")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ComponentInstance";
  }, o;
})();
$root$1.SpecialArg = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.key = "", o.prototype.arrowDataframe = null, o.prototype.bytes = null;
  let i;
  return Object.defineProperty(o.prototype, "value", { get: $util$1.oneOfGetter(i = ["arrowDataframe", "bytes"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.key != null && Object.hasOwnProperty.call(E, "key") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.key), E.arrowDataframe != null && Object.hasOwnProperty.call(E, "arrowDataframe") && $root$1.ArrowDataframe.encode(E.arrowDataframe, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.bytes != null && Object.hasOwnProperty.call(E, "bytes") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(E.bytes), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.SpecialArg();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.key = E.string();
          break;
        }
        case 2: {
          h.arrowDataframe = $root$1.ArrowDataframe.decode(E, E.uint32());
          break;
        }
        case 3: {
          h.bytes = E.bytes();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.SpecialArg) return E;
    let e = new $root$1.SpecialArg();
    if (E.key != null && (e.key = String(E.key)), E.arrowDataframe != null) {
      if (typeof E.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
      e.arrowDataframe = $root$1.ArrowDataframe.fromObject(E.arrowDataframe);
    }
    return E.bytes != null && (typeof E.bytes == "string" ? $util$1.base64.decode(E.bytes, e.bytes = $util$1.newBuffer($util$1.base64.length(E.bytes)), 0) : E.bytes.length >= 0 && (e.bytes = E.bytes)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.key = ""), E.key != null && E.hasOwnProperty("key") && (t.key = E.key), E.arrowDataframe != null && E.hasOwnProperty("arrowDataframe") && (t.arrowDataframe = $root$1.ArrowDataframe.toObject(E.arrowDataframe, e), e.oneofs && (t.value = "arrowDataframe")), E.bytes != null && E.hasOwnProperty("bytes") && (t.bytes = e.bytes === String ? $util$1.base64.encode(E.bytes, 0, E.bytes.length) : e.bytes === Array ? Array.prototype.slice.call(E.bytes) : E.bytes, e.oneofs && (t.value = "bytes")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/SpecialArg";
  }, o;
})();
const ArrowDataframe = $root$1.ArrowDataframe = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.prototype.height = 0, o.prototype.width = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.ArrowTable.encode(g.data, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.height != null && Object.hasOwnProperty.call(g, "height") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(g.height), g.width != null && Object.hasOwnProperty.call(g, "width") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(g.width), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ArrowDataframe();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = $root$1.ArrowTable.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.height = g.uint32();
          break;
        }
        case 3: {
          n.width = g.uint32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ArrowDataframe) return g;
    let E = new $root$1.ArrowDataframe();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
      E.data = $root$1.ArrowTable.fromObject(g.data);
    }
    return g.height != null && (E.height = g.height >>> 0), g.width != null && (E.width = g.width >>> 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.data = null, e.height = 0, e.width = 0), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.ArrowTable.toObject(g.data, E)), g.height != null && g.hasOwnProperty("height") && (e.height = g.height), g.width != null && g.hasOwnProperty("width") && (e.width = g.width), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowDataframe";
  }, o;
})();
$root$1.ArrowTable = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util$1.newBuffer([]), o.prototype.index = $util$1.newBuffer([]), o.prototype.columns = $util$1.newBuffer([]), o.prototype.styler = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(g.data), g.index != null && Object.hasOwnProperty.call(g, "index") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).bytes(g.index), g.columns != null && Object.hasOwnProperty.call(g, "columns") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(g.columns), g.styler != null && Object.hasOwnProperty.call(g, "styler") && $root$1.ArrowTableStyler.encode(g.styler, E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ArrowTable();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = g.bytes();
          break;
        }
        case 2: {
          n.index = g.bytes();
          break;
        }
        case 3: {
          n.columns = g.bytes();
          break;
        }
        case 5: {
          n.styler = $root$1.ArrowTableStyler.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ArrowTable) return g;
    let E = new $root$1.ArrowTable();
    if (g.data != null && (typeof g.data == "string" ? $util$1.base64.decode(g.data, E.data = $util$1.newBuffer($util$1.base64.length(g.data)), 0) : g.data.length >= 0 && (E.data = g.data)), g.index != null && (typeof g.index == "string" ? $util$1.base64.decode(g.index, E.index = $util$1.newBuffer($util$1.base64.length(g.index)), 0) : g.index.length >= 0 && (E.index = g.index)), g.columns != null && (typeof g.columns == "string" ? $util$1.base64.decode(g.columns, E.columns = $util$1.newBuffer($util$1.base64.length(g.columns)), 0) : g.columns.length >= 0 && (E.columns = g.columns)), g.styler != null) {
      if (typeof g.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
      E.styler = $root$1.ArrowTableStyler.fromObject(g.styler);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (E.bytes === String ? e.data = "" : (e.data = [], E.bytes !== Array && (e.data = $util$1.newBuffer(e.data))), E.bytes === String ? e.index = "" : (e.index = [], E.bytes !== Array && (e.index = $util$1.newBuffer(e.index))), E.bytes === String ? e.columns = "" : (e.columns = [], E.bytes !== Array && (e.columns = $util$1.newBuffer(e.columns))), e.styler = null), g.data != null && g.hasOwnProperty("data") && (e.data = E.bytes === String ? $util$1.base64.encode(g.data, 0, g.data.length) : E.bytes === Array ? Array.prototype.slice.call(g.data) : g.data), g.index != null && g.hasOwnProperty("index") && (e.index = E.bytes === String ? $util$1.base64.encode(g.index, 0, g.index.length) : E.bytes === Array ? Array.prototype.slice.call(g.index) : g.index), g.columns != null && g.hasOwnProperty("columns") && (e.columns = E.bytes === String ? $util$1.base64.encode(g.columns, 0, g.columns.length) : E.bytes === Array ? Array.prototype.slice.call(g.columns) : g.columns), g.styler != null && g.hasOwnProperty("styler") && (e.styler = $root$1.ArrowTableStyler.toObject(g.styler, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowTable";
  }, o;
})();
$root$1.ArrowTableStyler = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.uuid = "", o.prototype.caption = "", o.prototype.styles = "", o.prototype.displayValues = $util$1.newBuffer([]), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.uuid != null && Object.hasOwnProperty.call(g, "uuid") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.uuid), g.caption != null && Object.hasOwnProperty.call(g, "caption") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.caption), g.styles != null && Object.hasOwnProperty.call(g, "styles") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.styles), g.displayValues != null && Object.hasOwnProperty.call(g, "displayValues") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(g.displayValues), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ArrowTableStyler();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.uuid = g.string();
          break;
        }
        case 2: {
          n.caption = g.string();
          break;
        }
        case 3: {
          n.styles = g.string();
          break;
        }
        case 4: {
          n.displayValues = g.bytes();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ArrowTableStyler) return g;
    let E = new $root$1.ArrowTableStyler();
    return g.uuid != null && (E.uuid = String(g.uuid)), g.caption != null && (E.caption = String(g.caption)), g.styles != null && (E.styles = String(g.styles)), g.displayValues != null && (typeof g.displayValues == "string" ? $util$1.base64.decode(g.displayValues, E.displayValues = $util$1.newBuffer($util$1.base64.length(g.displayValues)), 0) : g.displayValues.length >= 0 && (E.displayValues = g.displayValues)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.uuid = "", e.caption = "", e.styles = "", E.bytes === String ? e.displayValues = "" : (e.displayValues = [], E.bytes !== Array && (e.displayValues = $util$1.newBuffer(e.displayValues)))), g.uuid != null && g.hasOwnProperty("uuid") && (e.uuid = g.uuid), g.caption != null && g.hasOwnProperty("caption") && (e.caption = g.caption), g.styles != null && g.hasOwnProperty("styles") && (e.styles = g.styles), g.displayValues != null && g.hasOwnProperty("displayValues") && (e.displayValues = E.bytes === String ? $util$1.base64.encode(g.displayValues, 0, g.displayValues.length) : E.bytes === Array ? Array.prototype.slice.call(g.displayValues) : g.displayValues), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowTableStyler";
  }, o;
})();
$root$1.Balloons = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.show = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.show != null && Object.hasOwnProperty.call(g, "show") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.show), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Balloons();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 3: {
          n.show = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Balloons) return g;
    let E = new $root$1.Balloons();
    return g.show != null && (E.show = !!g.show), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.show = !1), g.show != null && g.hasOwnProperty("show") && (e.show = g.show), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Balloons";
  }, o;
})();
$root$1.MixedData = (() => {
  function o(i) {
    if (this.arrowBlobs = {}, i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.json = "", o.prototype.arrowBlobs = $util$1.emptyObject, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.json != null && Object.hasOwnProperty.call(g, "json") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.json), g.arrowBlobs != null && Object.hasOwnProperty.call(g, "arrowBlobs")) for (let e = Object.keys(g.arrowBlobs), t = 0; t < e.length; ++t)
      E.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork().uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e[t]), $root$1.ArrowData.encode(g.arrowBlobs[e[t]], E.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim().ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.MixedData(), h, d;
    for (; g.pos < t; ) {
      let k = g.uint32();
      if (k === e) break;
      switch (k >>> 3) {
        case 1: {
          n.json = g.string();
          break;
        }
        case 2: {
          n.arrowBlobs === $util$1.emptyObject && (n.arrowBlobs = {});
          let p = g.uint32() + g.pos;
          for (h = "", d = null; g.pos < p; ) {
            let M = g.uint32();
            switch (M >>> 3) {
              case 1:
                h = g.string();
                break;
              case 2:
                d = $root$1.ArrowData.decode(g, g.uint32());
                break;
              default:
                g.skipType(M & 7);
                break;
            }
          }
          n.arrowBlobs[h] = d;
          break;
        }
        default:
          g.skipType(k & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.MixedData) return g;
    let E = new $root$1.MixedData();
    if (g.json != null && (E.json = String(g.json)), g.arrowBlobs) {
      if (typeof g.arrowBlobs != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
      E.arrowBlobs = {};
      for (let e = Object.keys(g.arrowBlobs), t = 0; t < e.length; ++t) {
        if (typeof g.arrowBlobs[e[t]] != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
        E.arrowBlobs[e[t]] = $root$1.ArrowData.fromObject(g.arrowBlobs[e[t]]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    (E.objects || E.defaults) && (e.arrowBlobs = {}), E.defaults && (e.json = ""), g.json != null && g.hasOwnProperty("json") && (e.json = g.json);
    let t;
    if (g.arrowBlobs && (t = Object.keys(g.arrowBlobs)).length) {
      e.arrowBlobs = {};
      for (let n = 0; n < t.length; ++n) e.arrowBlobs[t[n]] = $root$1.ArrowData.toObject(g.arrowBlobs[t[n]], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/MixedData";
  }, o;
})();
$root$1.BidiComponent = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.componentName = "", o.prototype.jsContent = null, o.prototype.jsSourcePath = null, o.prototype.formId = "", o.prototype.htmlContent = null, o.prototype.cssContent = null, o.prototype.cssSourcePath = null, o.prototype.isolateStyles = !1, o.prototype.json = null, o.prototype.arrowData = null, o.prototype.bytes = null, o.prototype.mixed = null;
  let i;
  return Object.defineProperty(o.prototype, "_jsContent", { get: $util$1.oneOfGetter(i = ["jsContent"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_jsSourcePath", { get: $util$1.oneOfGetter(i = ["jsSourcePath"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_htmlContent", { get: $util$1.oneOfGetter(i = ["htmlContent"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_cssContent", { get: $util$1.oneOfGetter(i = ["cssContent"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_cssSourcePath", { get: $util$1.oneOfGetter(i = ["cssSourcePath"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "data", { get: $util$1.oneOfGetter(i = ["json", "arrowData", "bytes", "mixed"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.componentName != null && Object.hasOwnProperty.call(E, "componentName") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.componentName), E.jsContent != null && Object.hasOwnProperty.call(E, "jsContent") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.jsContent), E.jsSourcePath != null && Object.hasOwnProperty.call(E, "jsSourcePath") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.jsSourcePath), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.formId), E.htmlContent != null && Object.hasOwnProperty.call(E, "htmlContent") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.htmlContent), E.cssContent != null && Object.hasOwnProperty.call(E, "cssContent") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.cssContent), E.cssSourcePath != null && Object.hasOwnProperty.call(E, "cssSourcePath") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.cssSourcePath), E.isolateStyles != null && Object.hasOwnProperty.call(E, "isolateStyles") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.isolateStyles), E.json != null && Object.hasOwnProperty.call(E, "json") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.json), E.arrowData != null && Object.hasOwnProperty.call(E, "arrowData") && $root$1.ArrowData.encode(E.arrowData, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), E.bytes != null && Object.hasOwnProperty.call(E, "bytes") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(E.bytes), E.mixed != null && Object.hasOwnProperty.call(E, "mixed") && $root$1.MixedData.encode(E.mixed, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.BidiComponent();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.componentName = E.string();
          break;
        }
        case 3: {
          h.jsContent = E.string();
          break;
        }
        case 4: {
          h.jsSourcePath = E.string();
          break;
        }
        case 5: {
          h.formId = E.string();
          break;
        }
        case 6: {
          h.htmlContent = E.string();
          break;
        }
        case 7: {
          h.cssContent = E.string();
          break;
        }
        case 8: {
          h.cssSourcePath = E.string();
          break;
        }
        case 9: {
          h.isolateStyles = E.bool();
          break;
        }
        case 10: {
          h.json = E.string();
          break;
        }
        case 11: {
          h.arrowData = $root$1.ArrowData.decode(E, E.uint32());
          break;
        }
        case 12: {
          h.bytes = E.bytes();
          break;
        }
        case 13: {
          h.mixed = $root$1.MixedData.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.BidiComponent) return E;
    let e = new $root$1.BidiComponent();
    if (E.id != null && (e.id = String(E.id)), E.componentName != null && (e.componentName = String(E.componentName)), E.jsContent != null && (e.jsContent = String(E.jsContent)), E.jsSourcePath != null && (e.jsSourcePath = String(E.jsSourcePath)), E.formId != null && (e.formId = String(E.formId)), E.htmlContent != null && (e.htmlContent = String(E.htmlContent)), E.cssContent != null && (e.cssContent = String(E.cssContent)), E.cssSourcePath != null && (e.cssSourcePath = String(E.cssSourcePath)), E.isolateStyles != null && (e.isolateStyles = !!E.isolateStyles), E.json != null && (e.json = String(E.json)), E.arrowData != null) {
      if (typeof E.arrowData != "object") throw TypeError(".BidiComponent.arrowData: object expected");
      e.arrowData = $root$1.ArrowData.fromObject(E.arrowData);
    }
    if (E.bytes != null && (typeof E.bytes == "string" ? $util$1.base64.decode(E.bytes, e.bytes = $util$1.newBuffer($util$1.base64.length(E.bytes)), 0) : E.bytes.length >= 0 && (e.bytes = E.bytes)), E.mixed != null) {
      if (typeof E.mixed != "object") throw TypeError(".BidiComponent.mixed: object expected");
      e.mixed = $root$1.MixedData.fromObject(E.mixed);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.componentName = "", t.formId = "", t.isolateStyles = !1), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.componentName != null && E.hasOwnProperty("componentName") && (t.componentName = E.componentName), E.jsContent != null && E.hasOwnProperty("jsContent") && (t.jsContent = E.jsContent, e.oneofs && (t._jsContent = "jsContent")), E.jsSourcePath != null && E.hasOwnProperty("jsSourcePath") && (t.jsSourcePath = E.jsSourcePath, e.oneofs && (t._jsSourcePath = "jsSourcePath")), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.htmlContent != null && E.hasOwnProperty("htmlContent") && (t.htmlContent = E.htmlContent, e.oneofs && (t._htmlContent = "htmlContent")), E.cssContent != null && E.hasOwnProperty("cssContent") && (t.cssContent = E.cssContent, e.oneofs && (t._cssContent = "cssContent")), E.cssSourcePath != null && E.hasOwnProperty("cssSourcePath") && (t.cssSourcePath = E.cssSourcePath, e.oneofs && (t._cssSourcePath = "cssSourcePath")), E.isolateStyles != null && E.hasOwnProperty("isolateStyles") && (t.isolateStyles = E.isolateStyles), E.json != null && E.hasOwnProperty("json") && (t.json = E.json, e.oneofs && (t.data = "json")), E.arrowData != null && E.hasOwnProperty("arrowData") && (t.arrowData = $root$1.ArrowData.toObject(E.arrowData, e), e.oneofs && (t.data = "arrowData")), E.bytes != null && E.hasOwnProperty("bytes") && (t.bytes = e.bytes === String ? $util$1.base64.encode(E.bytes, 0, E.bytes.length) : e.bytes === Array ? Array.prototype.slice.call(E.bytes) : E.bytes, e.oneofs && (t.data = "bytes")), E.mixed != null && E.hasOwnProperty("mixed") && (t.mixed = $root$1.MixedData.toObject(E.mixed, e), e.oneofs && (t.data = "mixed")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/BidiComponent";
  }, o;
})();
const Block$1 = $root$1.Block = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.vertical = null, o.prototype.horizontal = null, o.prototype.column = null, o.prototype.expandable = null, o.prototype.form = null, o.prototype.tabContainer = null, o.prototype.tab = null, o.prototype.chatMessage = null, o.prototype.popover = null, o.prototype.dialog = null, o.prototype.flexContainer = null, o.prototype.allowEmpty = !1, o.prototype.id = null, o.prototype.heightConfig = null, o.prototype.widthConfig = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_id", { get: $util$1.oneOfGetter(i = ["id"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_heightConfig", { get: $util$1.oneOfGetter(i = ["heightConfig"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_widthConfig", { get: $util$1.oneOfGetter(i = ["widthConfig"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.vertical != null && Object.hasOwnProperty.call(E, "vertical") && $root$1.Block.Vertical.encode(E.vertical, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E.horizontal != null && Object.hasOwnProperty.call(E, "horizontal") && $root$1.Block.Horizontal.encode(E.horizontal, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.column != null && Object.hasOwnProperty.call(E, "column") && $root$1.Block.Column.encode(E.column, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E.expandable != null && Object.hasOwnProperty.call(E, "expandable") && $root$1.Block.Expandable.encode(E.expandable, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), E.form != null && Object.hasOwnProperty.call(E, "form") && $root$1.Block.Form.encode(E.form, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), E.tabContainer != null && Object.hasOwnProperty.call(E, "tabContainer") && $root$1.Block.TabContainer.encode(E.tabContainer, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E.tab != null && Object.hasOwnProperty.call(E, "tab") && $root$1.Block.Tab.encode(E.tab, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), E.allowEmpty != null && Object.hasOwnProperty.call(E, "allowEmpty") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.allowEmpty), E.chatMessage != null && Object.hasOwnProperty.call(E, "chatMessage") && $root$1.Block.ChatMessage.encode(E.chatMessage, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E.popover != null && Object.hasOwnProperty.call(E, "popover") && $root$1.Block.Popover.encode(E.popover, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), E.dialog != null && Object.hasOwnProperty.call(E, "dialog") && $root$1.Block.Dialog.encode(E.dialog, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(E.id), E.flexContainer != null && Object.hasOwnProperty.call(E, "flexContainer") && $root$1.Block.FlexContainer.encode(E.flexContainer, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), E.heightConfig != null && Object.hasOwnProperty.call(E, "heightConfig") && $root$1.streamlit.HeightConfig.encode(E.heightConfig, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), E.widthConfig != null && Object.hasOwnProperty.call(E, "widthConfig") && $root$1.streamlit.WidthConfig.encode(E.widthConfig, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Block();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.vertical = $root$1.Block.Vertical.decode(E, E.uint32());
          break;
        }
        case 2: {
          h.horizontal = $root$1.Block.Horizontal.decode(E, E.uint32());
          break;
        }
        case 3: {
          h.column = $root$1.Block.Column.decode(E, E.uint32());
          break;
        }
        case 4: {
          h.expandable = $root$1.Block.Expandable.decode(E, E.uint32());
          break;
        }
        case 5: {
          h.form = $root$1.Block.Form.decode(E, E.uint32());
          break;
        }
        case 6: {
          h.tabContainer = $root$1.Block.TabContainer.decode(E, E.uint32());
          break;
        }
        case 7: {
          h.tab = $root$1.Block.Tab.decode(E, E.uint32());
          break;
        }
        case 9: {
          h.chatMessage = $root$1.Block.ChatMessage.decode(E, E.uint32());
          break;
        }
        case 10: {
          h.popover = $root$1.Block.Popover.decode(E, E.uint32());
          break;
        }
        case 11: {
          h.dialog = $root$1.Block.Dialog.decode(E, E.uint32());
          break;
        }
        case 13: {
          h.flexContainer = $root$1.Block.FlexContainer.decode(E, E.uint32());
          break;
        }
        case 8: {
          h.allowEmpty = E.bool();
          break;
        }
        case 12: {
          h.id = E.string();
          break;
        }
        case 14: {
          h.heightConfig = $root$1.streamlit.HeightConfig.decode(E, E.uint32());
          break;
        }
        case 15: {
          h.widthConfig = $root$1.streamlit.WidthConfig.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Block) return E;
    let e = new $root$1.Block();
    if (E.vertical != null) {
      if (typeof E.vertical != "object") throw TypeError(".Block.vertical: object expected");
      e.vertical = $root$1.Block.Vertical.fromObject(E.vertical);
    }
    if (E.horizontal != null) {
      if (typeof E.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
      e.horizontal = $root$1.Block.Horizontal.fromObject(E.horizontal);
    }
    if (E.column != null) {
      if (typeof E.column != "object") throw TypeError(".Block.column: object expected");
      e.column = $root$1.Block.Column.fromObject(E.column);
    }
    if (E.expandable != null) {
      if (typeof E.expandable != "object") throw TypeError(".Block.expandable: object expected");
      e.expandable = $root$1.Block.Expandable.fromObject(E.expandable);
    }
    if (E.form != null) {
      if (typeof E.form != "object") throw TypeError(".Block.form: object expected");
      e.form = $root$1.Block.Form.fromObject(E.form);
    }
    if (E.tabContainer != null) {
      if (typeof E.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
      e.tabContainer = $root$1.Block.TabContainer.fromObject(E.tabContainer);
    }
    if (E.tab != null) {
      if (typeof E.tab != "object") throw TypeError(".Block.tab: object expected");
      e.tab = $root$1.Block.Tab.fromObject(E.tab);
    }
    if (E.chatMessage != null) {
      if (typeof E.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
      e.chatMessage = $root$1.Block.ChatMessage.fromObject(E.chatMessage);
    }
    if (E.popover != null) {
      if (typeof E.popover != "object") throw TypeError(".Block.popover: object expected");
      e.popover = $root$1.Block.Popover.fromObject(E.popover);
    }
    if (E.dialog != null) {
      if (typeof E.dialog != "object") throw TypeError(".Block.dialog: object expected");
      e.dialog = $root$1.Block.Dialog.fromObject(E.dialog);
    }
    if (E.flexContainer != null) {
      if (typeof E.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
      e.flexContainer = $root$1.Block.FlexContainer.fromObject(E.flexContainer);
    }
    if (E.allowEmpty != null && (e.allowEmpty = !!E.allowEmpty), E.id != null && (e.id = String(E.id)), E.heightConfig != null) {
      if (typeof E.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
      e.heightConfig = $root$1.streamlit.HeightConfig.fromObject(E.heightConfig);
    }
    if (E.widthConfig != null) {
      if (typeof E.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
      e.widthConfig = $root$1.streamlit.WidthConfig.fromObject(E.widthConfig);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.allowEmpty = !1), E.vertical != null && E.hasOwnProperty("vertical") && (t.vertical = $root$1.Block.Vertical.toObject(E.vertical, e), e.oneofs && (t.type = "vertical")), E.horizontal != null && E.hasOwnProperty("horizontal") && (t.horizontal = $root$1.Block.Horizontal.toObject(E.horizontal, e), e.oneofs && (t.type = "horizontal")), E.column != null && E.hasOwnProperty("column") && (t.column = $root$1.Block.Column.toObject(E.column, e), e.oneofs && (t.type = "column")), E.expandable != null && E.hasOwnProperty("expandable") && (t.expandable = $root$1.Block.Expandable.toObject(E.expandable, e), e.oneofs && (t.type = "expandable")), E.form != null && E.hasOwnProperty("form") && (t.form = $root$1.Block.Form.toObject(E.form, e), e.oneofs && (t.type = "form")), E.tabContainer != null && E.hasOwnProperty("tabContainer") && (t.tabContainer = $root$1.Block.TabContainer.toObject(E.tabContainer, e), e.oneofs && (t.type = "tabContainer")), E.tab != null && E.hasOwnProperty("tab") && (t.tab = $root$1.Block.Tab.toObject(E.tab, e), e.oneofs && (t.type = "tab")), E.allowEmpty != null && E.hasOwnProperty("allowEmpty") && (t.allowEmpty = E.allowEmpty), E.chatMessage != null && E.hasOwnProperty("chatMessage") && (t.chatMessage = $root$1.Block.ChatMessage.toObject(E.chatMessage, e), e.oneofs && (t.type = "chatMessage")), E.popover != null && E.hasOwnProperty("popover") && (t.popover = $root$1.Block.Popover.toObject(E.popover, e), e.oneofs && (t.type = "popover")), E.dialog != null && E.hasOwnProperty("dialog") && (t.dialog = $root$1.Block.Dialog.toObject(E.dialog, e), e.oneofs && (t.type = "dialog")), E.id != null && E.hasOwnProperty("id") && (t.id = E.id, e.oneofs && (t._id = "id")), E.flexContainer != null && E.hasOwnProperty("flexContainer") && (t.flexContainer = $root$1.Block.FlexContainer.toObject(E.flexContainer, e), e.oneofs && (t.type = "flexContainer")), E.heightConfig != null && E.hasOwnProperty("heightConfig") && (t.heightConfig = $root$1.streamlit.HeightConfig.toObject(E.heightConfig, e), e.oneofs && (t._heightConfig = "heightConfig")), E.widthConfig != null && E.hasOwnProperty("widthConfig") && (t.widthConfig = $root$1.streamlit.WidthConfig.toObject(E.widthConfig, e), e.oneofs && (t._widthConfig = "widthConfig")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Block";
  }, o.Vertical = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.border = !1, g.prototype.height = 0, g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.border), e.height != null && Object.hasOwnProperty.call(e, "height") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(e.height), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.Block.Vertical();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.border = e.bool();
            break;
          }
          case 2: {
            d.height = e.uint32();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.Block.Vertical) return e;
      let t = new $root$1.Block.Vertical();
      return e.border != null && (t.border = !!e.border), e.height != null && (t.height = e.height >>> 0), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.border = !1, n.height = 0), e.border != null && e.hasOwnProperty("border") && (n.border = e.border), e.height != null && e.hasOwnProperty("height") && (n.height = e.height), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Vertical";
    }, g;
  })(), o.Horizontal = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.gap = "", g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.gap != null && Object.hasOwnProperty.call(e, "gap") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.gap), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.Block.Horizontal();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.gap = e.string();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.Block.Horizontal) return e;
      let t = new $root$1.Block.Horizontal();
      return e.gap != null && (t.gap = String(e.gap)), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.gap = ""), e.gap != null && e.hasOwnProperty("gap") && (n.gap = e.gap), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Horizontal";
    }, g;
  })(), o.FlexContainer = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.border = !1, g.prototype.gapConfig = null, g.prototype.scale = 0, g.prototype.direction = 0, g.prototype.wrap = !1, g.prototype.justify = 0, g.prototype.align = 0, g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.border), e.gapConfig != null && Object.hasOwnProperty.call(e, "gapConfig") && $root$1.streamlit.GapConfig.encode(e.gapConfig, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.scale != null && Object.hasOwnProperty.call(e, "scale") && t.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(e.scale), e.direction != null && Object.hasOwnProperty.call(e, "direction") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(e.direction), e.wrap != null && Object.hasOwnProperty.call(e, "wrap") && t.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.wrap), e.justify != null && Object.hasOwnProperty.call(e, "justify") && t.uint32(
        /* id 7, wireType 0 =*/
        56
      ).int32(e.justify), e.align != null && Object.hasOwnProperty.call(e, "align") && t.uint32(
        /* id 8, wireType 0 =*/
        64
      ).int32(e.align), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.Block.FlexContainer();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.border = e.bool();
            break;
          }
          case 2: {
            d.gapConfig = $root$1.streamlit.GapConfig.decode(e, e.uint32());
            break;
          }
          case 3: {
            d.scale = e.float();
            break;
          }
          case 4: {
            d.direction = e.int32();
            break;
          }
          case 5: {
            d.wrap = e.bool();
            break;
          }
          case 7: {
            d.justify = e.int32();
            break;
          }
          case 8: {
            d.align = e.int32();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.Block.FlexContainer) return e;
      let t = new $root$1.Block.FlexContainer();
      if (e.border != null && (t.border = !!e.border), e.gapConfig != null) {
        if (typeof e.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        t.gapConfig = $root$1.streamlit.GapConfig.fromObject(e.gapConfig);
      }
      switch (e.scale != null && (t.scale = Number(e.scale)), e.direction) {
        default:
          if (typeof e.direction == "number") {
            t.direction = e.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          t.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          t.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          t.direction = 2;
          break;
      }
      switch (e.wrap != null && (t.wrap = !!e.wrap), e.justify) {
        default:
          if (typeof e.justify == "number") {
            t.justify = e.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          t.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          t.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          t.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          t.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          t.justify = 4;
          break;
      }
      switch (e.align) {
        default:
          if (typeof e.align == "number") {
            t.align = e.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          t.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          t.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          t.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          t.align = 3;
          break;
        case "STRETCH":
        case 4:
          t.align = 4;
          break;
      }
      return t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.border = !1, n.gapConfig = null, n.scale = 0, n.direction = t.enums === String ? "DIRECTION_UNDEFINED" : 0, n.wrap = !1, n.justify = t.enums === String ? "JUSTIFY_UNDEFINED" : 0, n.align = t.enums === String ? "ALIGN_UNDEFINED" : 0), e.border != null && e.hasOwnProperty("border") && (n.border = e.border), e.gapConfig != null && e.hasOwnProperty("gapConfig") && (n.gapConfig = $root$1.streamlit.GapConfig.toObject(e.gapConfig, t)), e.scale != null && e.hasOwnProperty("scale") && (n.scale = t.json && !isFinite(e.scale) ? String(e.scale) : e.scale), e.direction != null && e.hasOwnProperty("direction") && (n.direction = t.enums === String ? $root$1.Block.FlexContainer.Direction[e.direction] === void 0 ? e.direction : $root$1.Block.FlexContainer.Direction[e.direction] : e.direction), e.wrap != null && e.hasOwnProperty("wrap") && (n.wrap = e.wrap), e.justify != null && e.hasOwnProperty("justify") && (n.justify = t.enums === String ? $root$1.Block.FlexContainer.Justify[e.justify] === void 0 ? e.justify : $root$1.Block.FlexContainer.Justify[e.justify] : e.justify), e.align != null && e.hasOwnProperty("align") && (n.align = t.enums === String ? $root$1.Block.FlexContainer.Align[e.align] === void 0 ? e.align : $root$1.Block.FlexContainer.Align[e.align] : e.align), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.FlexContainer";
    }, g.Direction = (function() {
      const E = {}, e = Object.create(E);
      return e[E[0] = "DIRECTION_UNDEFINED"] = 0, e[E[1] = "VERTICAL"] = 1, e[E[2] = "HORIZONTAL"] = 2, e;
    })(), g.Justify = (function() {
      const E = {}, e = Object.create(E);
      return e[E[0] = "JUSTIFY_UNDEFINED"] = 0, e[E[1] = "JUSTIFY_START"] = 1, e[E[2] = "JUSTIFY_END"] = 2, e[E[3] = "JUSTIFY_CENTER"] = 3, e[E[4] = "SPACE_BETWEEN"] = 4, e;
    })(), g.Align = (function() {
      const E = {}, e = Object.create(E);
      return e[E[0] = "ALIGN_UNDEFINED"] = 0, e[E[1] = "ALIGN_START"] = 1, e[E[2] = "ALIGN_END"] = 2, e[E[3] = "ALIGN_CENTER"] = 3, e[E[4] = "STRETCH"] = 4, e;
    })(), g;
  })(), o.Column = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.weight = 0, g.prototype.gap = "", g.prototype.verticalAlignment = 0, g.prototype.showBorder = !1, g.prototype.gapConfig = null;
    let E;
    return Object.defineProperty(g.prototype, "_gapConfig", { get: $util$1.oneOfGetter(E = ["gapConfig"]), set: $util$1.oneOfSetter(E) }), g.create = function(t) {
      return new g(t);
    }, g.encode = function(t, n) {
      return n || (n = $Writer$1.create()), t.weight != null && Object.hasOwnProperty.call(t, "weight") && n.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(t.weight), t.gap != null && Object.hasOwnProperty.call(t, "gap") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.gap), t.verticalAlignment != null && Object.hasOwnProperty.call(t, "verticalAlignment") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(t.verticalAlignment), t.showBorder != null && Object.hasOwnProperty.call(t, "showBorder") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(t.showBorder), t.gapConfig != null && Object.hasOwnProperty.call(t, "gapConfig") && $root$1.streamlit.GapConfig.encode(t.gapConfig, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n;
    }, g.decode = function(t, n, h) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let d = n === void 0 ? t.len : t.pos + n, k = new $root$1.Block.Column();
      for (; t.pos < d; ) {
        let p = t.uint32();
        if (p === h) break;
        switch (p >>> 3) {
          case 1: {
            k.weight = t.double();
            break;
          }
          case 2: {
            k.gap = t.string();
            break;
          }
          case 3: {
            k.verticalAlignment = t.int32();
            break;
          }
          case 4: {
            k.showBorder = t.bool();
            break;
          }
          case 5: {
            k.gapConfig = $root$1.streamlit.GapConfig.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(p & 7);
            break;
        }
      }
      return k;
    }, g.fromObject = function(t) {
      if (t instanceof $root$1.Block.Column) return t;
      let n = new $root$1.Block.Column();
      switch (t.weight != null && (n.weight = Number(t.weight)), t.gap != null && (n.gap = String(t.gap)), t.verticalAlignment) {
        default:
          if (typeof t.verticalAlignment == "number") {
            n.verticalAlignment = t.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          n.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          n.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          n.verticalAlignment = 2;
          break;
      }
      if (t.showBorder != null && (n.showBorder = !!t.showBorder), t.gapConfig != null) {
        if (typeof t.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
        n.gapConfig = $root$1.streamlit.GapConfig.fromObject(t.gapConfig);
      }
      return n;
    }, g.toObject = function(t, n) {
      n || (n = {});
      let h = {};
      return n.defaults && (h.weight = 0, h.gap = "", h.verticalAlignment = n.enums === String ? "TOP" : 0, h.showBorder = !1), t.weight != null && t.hasOwnProperty("weight") && (h.weight = n.json && !isFinite(t.weight) ? String(t.weight) : t.weight), t.gap != null && t.hasOwnProperty("gap") && (h.gap = t.gap), t.verticalAlignment != null && t.hasOwnProperty("verticalAlignment") && (h.verticalAlignment = n.enums === String ? $root$1.Block.Column.VerticalAlignment[t.verticalAlignment] === void 0 ? t.verticalAlignment : $root$1.Block.Column.VerticalAlignment[t.verticalAlignment] : t.verticalAlignment), t.showBorder != null && t.hasOwnProperty("showBorder") && (h.showBorder = t.showBorder), t.gapConfig != null && t.hasOwnProperty("gapConfig") && (h.gapConfig = $root$1.streamlit.GapConfig.toObject(t.gapConfig, n), n.oneofs && (h._gapConfig = "gapConfig")), h;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/Block.Column";
    }, g.VerticalAlignment = (function() {
      const e = {}, t = Object.create(e);
      return t[e[0] = "TOP"] = 0, t[e[1] = "CENTER"] = 1, t[e[2] = "BOTTOM"] = 2, t;
    })(), g;
  })(), o.Expandable = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.label = "", g.prototype.expanded = null, g.prototype.icon = "";
    let E;
    return Object.defineProperty(g.prototype, "_expanded", { get: $util$1.oneOfGetter(E = ["expanded"]), set: $util$1.oneOfSetter(E) }), g.create = function(t) {
      return new g(t);
    }, g.encode = function(t, n) {
      return n || (n = $Writer$1.create()), t.label != null && Object.hasOwnProperty.call(t, "label") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.label), t.expanded != null && Object.hasOwnProperty.call(t, "expanded") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(t.expanded), t.icon != null && Object.hasOwnProperty.call(t, "icon") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.icon), n;
    }, g.decode = function(t, n, h) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let d = n === void 0 ? t.len : t.pos + n, k = new $root$1.Block.Expandable();
      for (; t.pos < d; ) {
        let p = t.uint32();
        if (p === h) break;
        switch (p >>> 3) {
          case 1: {
            k.label = t.string();
            break;
          }
          case 2: {
            k.expanded = t.bool();
            break;
          }
          case 3: {
            k.icon = t.string();
            break;
          }
          default:
            t.skipType(p & 7);
            break;
        }
      }
      return k;
    }, g.fromObject = function(t) {
      if (t instanceof $root$1.Block.Expandable) return t;
      let n = new $root$1.Block.Expandable();
      return t.label != null && (n.label = String(t.label)), t.expanded != null && (n.expanded = !!t.expanded), t.icon != null && (n.icon = String(t.icon)), n;
    }, g.toObject = function(t, n) {
      n || (n = {});
      let h = {};
      return n.defaults && (h.label = "", h.icon = ""), t.label != null && t.hasOwnProperty("label") && (h.label = t.label), t.expanded != null && t.hasOwnProperty("expanded") && (h.expanded = t.expanded, n.oneofs && (h._expanded = "expanded")), t.icon != null && t.hasOwnProperty("icon") && (h.icon = t.icon), h;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/Block.Expandable";
    }, g;
  })(), o.Dialog = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.title = "", g.prototype.dismissible = !1, g.prototype.width = 0, g.prototype.isOpen = null, g.prototype.id = "", g.prototype.icon = "";
    let E;
    return Object.defineProperty(g.prototype, "_isOpen", { get: $util$1.oneOfGetter(E = ["isOpen"]), set: $util$1.oneOfSetter(E) }), g.create = function(t) {
      return new g(t);
    }, g.encode = function(t, n) {
      return n || (n = $Writer$1.create()), t.title != null && Object.hasOwnProperty.call(t, "title") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.title), t.dismissible != null && Object.hasOwnProperty.call(t, "dismissible") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(t.dismissible), t.width != null && Object.hasOwnProperty.call(t, "width") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(t.width), t.isOpen != null && Object.hasOwnProperty.call(t, "isOpen") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(t.isOpen), t.id != null && Object.hasOwnProperty.call(t, "id") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(t.id), t.icon != null && Object.hasOwnProperty.call(t, "icon") && n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(t.icon), n;
    }, g.decode = function(t, n, h) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let d = n === void 0 ? t.len : t.pos + n, k = new $root$1.Block.Dialog();
      for (; t.pos < d; ) {
        let p = t.uint32();
        if (p === h) break;
        switch (p >>> 3) {
          case 1: {
            k.title = t.string();
            break;
          }
          case 2: {
            k.dismissible = t.bool();
            break;
          }
          case 3: {
            k.width = t.int32();
            break;
          }
          case 4: {
            k.isOpen = t.bool();
            break;
          }
          case 5: {
            k.id = t.string();
            break;
          }
          case 6: {
            k.icon = t.string();
            break;
          }
          default:
            t.skipType(p & 7);
            break;
        }
      }
      return k;
    }, g.fromObject = function(t) {
      if (t instanceof $root$1.Block.Dialog) return t;
      let n = new $root$1.Block.Dialog();
      switch (t.title != null && (n.title = String(t.title)), t.dismissible != null && (n.dismissible = !!t.dismissible), t.width) {
        default:
          if (typeof t.width == "number") {
            n.width = t.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          n.width = 0;
          break;
        case "LARGE":
        case 1:
          n.width = 1;
          break;
        case "MEDIUM":
        case 2:
          n.width = 2;
          break;
      }
      return t.isOpen != null && (n.isOpen = !!t.isOpen), t.id != null && (n.id = String(t.id)), t.icon != null && (n.icon = String(t.icon)), n;
    }, g.toObject = function(t, n) {
      n || (n = {});
      let h = {};
      return n.defaults && (h.title = "", h.dismissible = !1, h.width = n.enums === String ? "SMALL" : 0, h.id = "", h.icon = ""), t.title != null && t.hasOwnProperty("title") && (h.title = t.title), t.dismissible != null && t.hasOwnProperty("dismissible") && (h.dismissible = t.dismissible), t.width != null && t.hasOwnProperty("width") && (h.width = n.enums === String ? $root$1.Block.Dialog.DialogWidth[t.width] === void 0 ? t.width : $root$1.Block.Dialog.DialogWidth[t.width] : t.width), t.isOpen != null && t.hasOwnProperty("isOpen") && (h.isOpen = t.isOpen, n.oneofs && (h._isOpen = "isOpen")), t.id != null && t.hasOwnProperty("id") && (h.id = t.id), t.icon != null && t.hasOwnProperty("icon") && (h.icon = t.icon), h;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/Block.Dialog";
    }, g.DialogWidth = (function() {
      const e = {}, t = Object.create(e);
      return t[e[0] = "SMALL"] = 0, t[e[1] = "LARGE"] = 1, t[e[2] = "MEDIUM"] = 2, t;
    })(), g;
  })(), o.Form = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.formId = "", g.prototype.clearOnSubmit = !1, g.prototype.border = !1, g.prototype.enterToSubmit = !1, g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.formId), e.clearOnSubmit != null && Object.hasOwnProperty.call(e, "clearOnSubmit") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.clearOnSubmit), e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.border), e.enterToSubmit != null && Object.hasOwnProperty.call(e, "enterToSubmit") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.enterToSubmit), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.Block.Form();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.formId = e.string();
            break;
          }
          case 2: {
            d.clearOnSubmit = e.bool();
            break;
          }
          case 3: {
            d.border = e.bool();
            break;
          }
          case 4: {
            d.enterToSubmit = e.bool();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.Block.Form) return e;
      let t = new $root$1.Block.Form();
      return e.formId != null && (t.formId = String(e.formId)), e.clearOnSubmit != null && (t.clearOnSubmit = !!e.clearOnSubmit), e.border != null && (t.border = !!e.border), e.enterToSubmit != null && (t.enterToSubmit = !!e.enterToSubmit), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.formId = "", n.clearOnSubmit = !1, n.border = !1, n.enterToSubmit = !1), e.formId != null && e.hasOwnProperty("formId") && (n.formId = e.formId), e.clearOnSubmit != null && e.hasOwnProperty("clearOnSubmit") && (n.clearOnSubmit = e.clearOnSubmit), e.border != null && e.hasOwnProperty("border") && (n.border = e.border), e.enterToSubmit != null && e.hasOwnProperty("enterToSubmit") && (n.enterToSubmit = e.enterToSubmit), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Form";
    }, g;
  })(), o.TabContainer = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.defaultTabIndex = 0, g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.defaultTabIndex != null && Object.hasOwnProperty.call(e, "defaultTabIndex") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.defaultTabIndex), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.Block.TabContainer();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.defaultTabIndex = e.int32();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.Block.TabContainer) return e;
      let t = new $root$1.Block.TabContainer();
      return e.defaultTabIndex != null && (t.defaultTabIndex = e.defaultTabIndex | 0), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.defaultTabIndex = 0), e.defaultTabIndex != null && e.hasOwnProperty("defaultTabIndex") && (n.defaultTabIndex = e.defaultTabIndex), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.TabContainer";
    }, g;
  })(), o.Tab = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.label = "", g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.label), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.Block.Tab();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.label = e.string();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.Block.Tab) return e;
      let t = new $root$1.Block.Tab();
      return e.label != null && (t.label = String(e.label)), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.label = ""), e.label != null && e.hasOwnProperty("label") && (n.label = e.label), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Tab";
    }, g;
  })(), o.Popover = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.label = "", g.prototype.useContainerWidth = !1, g.prototype.help = "", g.prototype.disabled = !1, g.prototype.icon = "", g.prototype.type = "", g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.label), e.useContainerWidth != null && Object.hasOwnProperty.call(e, "useContainerWidth") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContainerWidth), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.help), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.disabled), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.icon), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(e.type), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.Block.Popover();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.label = e.string();
            break;
          }
          case 2: {
            d.useContainerWidth = e.bool();
            break;
          }
          case 3: {
            d.help = e.string();
            break;
          }
          case 4: {
            d.disabled = e.bool();
            break;
          }
          case 5: {
            d.icon = e.string();
            break;
          }
          case 6: {
            d.type = e.string();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.Block.Popover) return e;
      let t = new $root$1.Block.Popover();
      return e.label != null && (t.label = String(e.label)), e.useContainerWidth != null && (t.useContainerWidth = !!e.useContainerWidth), e.help != null && (t.help = String(e.help)), e.disabled != null && (t.disabled = !!e.disabled), e.icon != null && (t.icon = String(e.icon)), e.type != null && (t.type = String(e.type)), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.label = "", n.useContainerWidth = !1, n.help = "", n.disabled = !1, n.icon = "", n.type = ""), e.label != null && e.hasOwnProperty("label") && (n.label = e.label), e.useContainerWidth != null && e.hasOwnProperty("useContainerWidth") && (n.useContainerWidth = e.useContainerWidth), e.help != null && e.hasOwnProperty("help") && (n.help = e.help), e.disabled != null && e.hasOwnProperty("disabled") && (n.disabled = e.disabled), e.icon != null && e.hasOwnProperty("icon") && (n.icon = e.icon), e.type != null && e.hasOwnProperty("type") && (n.type = e.type), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Popover";
    }, g;
  })(), o.ChatMessage = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.name = "", g.prototype.avatar = "", g.prototype.avatarType = 0, g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.avatar != null && Object.hasOwnProperty.call(e, "avatar") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.avatar), e.avatarType != null && Object.hasOwnProperty.call(e, "avatarType") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.avatarType), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.Block.ChatMessage();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.name = e.string();
            break;
          }
          case 2: {
            d.avatar = e.string();
            break;
          }
          case 3: {
            d.avatarType = e.int32();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.Block.ChatMessage) return e;
      let t = new $root$1.Block.ChatMessage();
      switch (e.name != null && (t.name = String(e.name)), e.avatar != null && (t.avatar = String(e.avatar)), e.avatarType) {
        default:
          if (typeof e.avatarType == "number") {
            t.avatarType = e.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          t.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          t.avatarType = 1;
          break;
        case "ICON":
        case 2:
          t.avatarType = 2;
          break;
      }
      return t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.name = "", n.avatar = "", n.avatarType = t.enums === String ? "IMAGE" : 0), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), e.avatar != null && e.hasOwnProperty("avatar") && (n.avatar = e.avatar), e.avatarType != null && e.hasOwnProperty("avatarType") && (n.avatarType = t.enums === String ? $root$1.Block.ChatMessage.AvatarType[e.avatarType] === void 0 ? e.avatarType : $root$1.Block.ChatMessage.AvatarType[e.avatarType] : e.avatarType), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.ChatMessage";
    }, g.AvatarType = (function() {
      const E = {}, e = Object.create(E);
      return e[E[0] = "IMAGE"] = 0, e[E[1] = "EMOJI"] = 1, e[E[2] = "ICON"] = 2, e;
    })(), g;
  })(), o;
})();
$root$1.BokehChart = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.figure = "", o.prototype.useContainerWidth = !1, o.prototype.elementId = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.figure != null && Object.hasOwnProperty.call(g, "figure") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.figure), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.useContainerWidth), g.elementId != null && Object.hasOwnProperty.call(g, "elementId") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.elementId), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.BokehChart();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.figure = g.string();
          break;
        }
        case 2: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 3: {
          n.elementId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.BokehChart) return g;
    let E = new $root$1.BokehChart();
    return g.figure != null && (E.figure = String(g.figure)), g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.elementId != null && (E.elementId = String(g.elementId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.figure = "", e.useContainerWidth = !1, e.elementId = ""), g.figure != null && g.hasOwnProperty("figure") && (e.figure = g.figure), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.elementId != null && g.hasOwnProperty("elementId") && (e.elementId = g.elementId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BokehChart";
  }, o;
})();
$root$1.Button = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.isFormSubmitter = !1, o.prototype.type = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.icon = "", o.prototype.shortcut = "", o.prototype.iconPosition = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.isFormSubmitter != null && Object.hasOwnProperty.call(g, "isFormSubmitter") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.isFormSubmitter), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.type), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.useContainerWidth), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.icon), g.shortcut != null && Object.hasOwnProperty.call(g, "shortcut") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.shortcut), g.iconPosition != null && Object.hasOwnProperty.call(g, "iconPosition") && E.uint32(
      /* id 12, wireType 0 =*/
      96
    ).int32(g.iconPosition), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Button();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.bool();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.isFormSubmitter = g.bool();
          break;
        }
        case 7: {
          n.type = g.string();
          break;
        }
        case 8: {
          n.disabled = g.bool();
          break;
        }
        case 9: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 10: {
          n.icon = g.string();
          break;
        }
        case 11: {
          n.shortcut = g.string();
          break;
        }
        case 12: {
          n.iconPosition = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Button) return g;
    let E = new $root$1.Button();
    switch (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = !!g.default), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.isFormSubmitter != null && (E.isFormSubmitter = !!g.isFormSubmitter), g.type != null && (E.type = String(g.type)), g.disabled != null && (E.disabled = !!g.disabled), g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.icon != null && (E.icon = String(g.icon)), g.shortcut != null && (E.shortcut = String(g.shortcut)), g.iconPosition) {
      default:
        if (typeof g.iconPosition == "number") {
          E.iconPosition = g.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        E.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        E.iconPosition = 1;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.isFormSubmitter = !1, e.type = "", e.disabled = !1, e.useContainerWidth = !1, e.icon = "", e.shortcut = "", e.iconPosition = E.enums === String ? "LEFT" : 0), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.isFormSubmitter != null && g.hasOwnProperty("isFormSubmitter") && (e.isFormSubmitter = g.isFormSubmitter), g.type != null && g.hasOwnProperty("type") && (e.type = g.type), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), g.shortcut != null && g.hasOwnProperty("shortcut") && (e.shortcut = g.shortcut), g.iconPosition != null && g.hasOwnProperty("iconPosition") && (e.iconPosition = E.enums === String ? $root$1.streamlit.ButtonLikeIconPosition[g.iconPosition] === void 0 ? g.iconPosition : $root$1.streamlit.ButtonLikeIconPosition[g.iconPosition] : g.iconPosition), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Button";
  }, o;
})();
const ButtonGroup$1 = $root$1.ButtonGroup = (() => {
  function o(g) {
    if (this.options = [], this.default = [], this.value = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.options = $util$1.emptyArray, o.prototype.default = $util$1.emptyArray, o.prototype.disabled = !1, o.prototype.clickMode = 0, o.prototype.formId = "", o.prototype.value = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.selectionVisualization = 0, o.prototype.style = 0, o.prototype.label = "", o.prototype.labelVisibility = null, o.prototype.help = null;
  let i;
  return Object.defineProperty(o.prototype, "_help", { get: $util$1.oneOfGetter(i = ["help"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.options != null && E.options.length) for (let t = 0; t < E.options.length; ++t) $root$1.ButtonGroup.Option.encode(E.options[t], e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    if (E.default != null && E.default.length) {
      e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let t = 0; t < E.default.length; ++t) e.uint32(E.default[t]);
      e.ldelim();
    }
    if (E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.disabled), E.clickMode != null && Object.hasOwnProperty.call(E, "clickMode") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(E.clickMode), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.formId), E.value != null && E.value.length) {
      e.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let t = 0; t < E.value.length; ++t) e.uint32(E.value[t]);
      e.ldelim();
    }
    return E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.setValue), E.selectionVisualization != null && Object.hasOwnProperty.call(E, "selectionVisualization") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(E.selectionVisualization), E.style != null && Object.hasOwnProperty.call(E, "style") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(E.style), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.label), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.help), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.ButtonGroup();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.options && h.options.length || (h.options = []), h.options.push($root$1.ButtonGroup.Option.decode(E, E.uint32()));
          break;
        }
        case 3: {
          if (h.default && h.default.length || (h.default = []), (d & 7) === 2) {
            let k = E.uint32() + E.pos;
            for (; E.pos < k; ) h.default.push(E.uint32());
          } else h.default.push(E.uint32());
          break;
        }
        case 4: {
          h.disabled = E.bool();
          break;
        }
        case 5: {
          h.clickMode = E.int32();
          break;
        }
        case 6: {
          h.formId = E.string();
          break;
        }
        case 7: {
          if (h.value && h.value.length || (h.value = []), (d & 7) === 2) {
            let k = E.uint32() + E.pos;
            for (; E.pos < k; ) h.value.push(E.uint32());
          } else h.value.push(E.uint32());
          break;
        }
        case 8: {
          h.setValue = E.bool();
          break;
        }
        case 9: {
          h.selectionVisualization = E.int32();
          break;
        }
        case 10: {
          h.style = E.int32();
          break;
        }
        case 11: {
          h.label = E.string();
          break;
        }
        case 12: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 13: {
          h.help = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.ButtonGroup) return E;
    let e = new $root$1.ButtonGroup();
    if (E.id != null && (e.id = String(E.id)), E.options) {
      if (!Array.isArray(E.options)) throw TypeError(".ButtonGroup.options: array expected");
      e.options = [];
      for (let t = 0; t < E.options.length; ++t) {
        if (typeof E.options[t] != "object") throw TypeError(".ButtonGroup.options: object expected");
        e.options[t] = $root$1.ButtonGroup.Option.fromObject(E.options[t]);
      }
    }
    if (E.default) {
      if (!Array.isArray(E.default)) throw TypeError(".ButtonGroup.default: array expected");
      e.default = [];
      for (let t = 0; t < E.default.length; ++t) e.default[t] = E.default[t] >>> 0;
    }
    switch (E.disabled != null && (e.disabled = !!E.disabled), E.clickMode) {
      default:
        if (typeof E.clickMode == "number") {
          e.clickMode = E.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        e.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        e.clickMode = 1;
        break;
    }
    if (E.formId != null && (e.formId = String(E.formId)), E.value) {
      if (!Array.isArray(E.value)) throw TypeError(".ButtonGroup.value: array expected");
      e.value = [];
      for (let t = 0; t < E.value.length; ++t) e.value[t] = E.value[t] >>> 0;
    }
    switch (E.setValue != null && (e.setValue = !!E.setValue), E.selectionVisualization) {
      default:
        if (typeof E.selectionVisualization == "number") {
          e.selectionVisualization = E.selectionVisualization;
          break;
        }
        break;
      case "ONLY_SELECTED":
      case 0:
        e.selectionVisualization = 0;
        break;
      case "ALL_UP_TO_SELECTED":
      case 1:
        e.selectionVisualization = 1;
        break;
    }
    switch (E.style) {
      default:
        if (typeof E.style == "number") {
          e.style = E.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        e.style = 0;
        break;
      case "PILLS":
      case 1:
        e.style = 1;
        break;
      case "BORDERLESS":
      case 2:
        e.style = 2;
        break;
    }
    if (E.label != null && (e.label = String(E.label)), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.help != null && (e.help = String(E.help)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.options = [], t.default = [], t.value = []), e.defaults && (t.id = "", t.disabled = !1, t.clickMode = e.enums === String ? "SINGLE_SELECT" : 0, t.formId = "", t.setValue = !1, t.selectionVisualization = e.enums === String ? "ONLY_SELECTED" : 0, t.style = e.enums === String ? "SEGMENTED_CONTROL" : 0, t.label = "", t.labelVisibility = null), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.options && E.options.length) {
      t.options = [];
      for (let n = 0; n < E.options.length; ++n) t.options[n] = $root$1.ButtonGroup.Option.toObject(E.options[n], e);
    }
    if (E.default && E.default.length) {
      t.default = [];
      for (let n = 0; n < E.default.length; ++n) t.default[n] = E.default[n];
    }
    if (E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.clickMode != null && E.hasOwnProperty("clickMode") && (t.clickMode = e.enums === String ? $root$1.ButtonGroup.ClickMode[E.clickMode] === void 0 ? E.clickMode : $root$1.ButtonGroup.ClickMode[E.clickMode] : E.clickMode), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.value && E.value.length) {
      t.value = [];
      for (let n = 0; n < E.value.length; ++n) t.value[n] = E.value[n];
    }
    return E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.selectionVisualization != null && E.hasOwnProperty("selectionVisualization") && (t.selectionVisualization = e.enums === String ? $root$1.ButtonGroup.SelectionVisualization[E.selectionVisualization] === void 0 ? E.selectionVisualization : $root$1.ButtonGroup.SelectionVisualization[E.selectionVisualization] : E.selectionVisualization), E.style != null && E.hasOwnProperty("style") && (t.style = e.enums === String ? $root$1.ButtonGroup.Style[E.style] === void 0 ? E.style : $root$1.ButtonGroup.Style[E.style] : E.style), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), E.help != null && E.hasOwnProperty("help") && (t.help = E.help, e.oneofs && (t._help = "help")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ButtonGroup";
  }, o.ClickMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "SINGLE_SELECT"] = 0, E[g[1] = "MULTI_SELECT"] = 1, E;
  })(), o.Option = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.content = "", g.prototype.selectedContent = null, g.prototype.contentIcon = null, g.prototype.selectedContentIcon = null;
    let E;
    return Object.defineProperty(g.prototype, "_selectedContent", { get: $util$1.oneOfGetter(E = ["selectedContent"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(g.prototype, "_contentIcon", { get: $util$1.oneOfGetter(E = ["contentIcon"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(g.prototype, "_selectedContentIcon", { get: $util$1.oneOfGetter(E = ["selectedContentIcon"]), set: $util$1.oneOfSetter(E) }), g.create = function(t) {
      return new g(t);
    }, g.encode = function(t, n) {
      return n || (n = $Writer$1.create()), t.content != null && Object.hasOwnProperty.call(t, "content") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.content), t.selectedContent != null && Object.hasOwnProperty.call(t, "selectedContent") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.selectedContent), t.contentIcon != null && Object.hasOwnProperty.call(t, "contentIcon") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.contentIcon), t.selectedContentIcon != null && Object.hasOwnProperty.call(t, "selectedContentIcon") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(t.selectedContentIcon), n;
    }, g.decode = function(t, n, h) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let d = n === void 0 ? t.len : t.pos + n, k = new $root$1.ButtonGroup.Option();
      for (; t.pos < d; ) {
        let p = t.uint32();
        if (p === h) break;
        switch (p >>> 3) {
          case 1: {
            k.content = t.string();
            break;
          }
          case 2: {
            k.selectedContent = t.string();
            break;
          }
          case 3: {
            k.contentIcon = t.string();
            break;
          }
          case 4: {
            k.selectedContentIcon = t.string();
            break;
          }
          default:
            t.skipType(p & 7);
            break;
        }
      }
      return k;
    }, g.fromObject = function(t) {
      if (t instanceof $root$1.ButtonGroup.Option) return t;
      let n = new $root$1.ButtonGroup.Option();
      return t.content != null && (n.content = String(t.content)), t.selectedContent != null && (n.selectedContent = String(t.selectedContent)), t.contentIcon != null && (n.contentIcon = String(t.contentIcon)), t.selectedContentIcon != null && (n.selectedContentIcon = String(t.selectedContentIcon)), n;
    }, g.toObject = function(t, n) {
      n || (n = {});
      let h = {};
      return n.defaults && (h.content = ""), t.content != null && t.hasOwnProperty("content") && (h.content = t.content), t.selectedContent != null && t.hasOwnProperty("selectedContent") && (h.selectedContent = t.selectedContent, n.oneofs && (h._selectedContent = "selectedContent")), t.contentIcon != null && t.hasOwnProperty("contentIcon") && (h.contentIcon = t.contentIcon, n.oneofs && (h._contentIcon = "contentIcon")), t.selectedContentIcon != null && t.hasOwnProperty("selectedContentIcon") && (h.selectedContentIcon = t.selectedContentIcon, n.oneofs && (h._selectedContentIcon = "selectedContentIcon")), h;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/ButtonGroup.Option";
    }, g;
  })(), o.SelectionVisualization = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "ONLY_SELECTED"] = 0, E[g[1] = "ALL_UP_TO_SELECTED"] = 1, E;
  })(), o.Style = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "SEGMENTED_CONTROL"] = 0, E[g[1] = "PILLS"] = 1, E[g[2] = "BORDERLESS"] = 2, E;
  })(), o;
})();
$root$1.CameraInput = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.formId), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.CameraInput();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.help = g.string();
          break;
        }
        case 4: {
          n.formId = g.string();
          break;
        }
        case 5: {
          n.disabled = g.bool();
          break;
        }
        case 6: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.CameraInput) return g;
    let E = new $root$1.CameraInput();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
      E.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.disabled = !1, e.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CameraInput";
  }, o;
})();
const ChatInput$1 = $root$1.ChatInput = (() => {
  function o(g) {
    if (this.fileType = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.placeholder = "", o.prototype.maxChars = 0, o.prototype.disabled = !1, o.prototype.value = "", o.prototype.setValue = !1, o.prototype.default = "", o.prototype.position = 0, o.prototype.acceptFile = 0, o.prototype.fileType = $util$1.emptyArray, o.prototype.maxUploadSizeMb = 0, o.prototype.acceptAudio = !1, o.prototype.audioSampleRate = null;
  let i;
  return Object.defineProperty(o.prototype, "_audioSampleRate", { get: $util$1.oneOfGetter(i = ["audioSampleRate"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.placeholder != null && Object.hasOwnProperty.call(E, "placeholder") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.placeholder), E.maxChars != null && Object.hasOwnProperty.call(E, "maxChars") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(E.maxChars), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.disabled), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.setValue), E.default != null && Object.hasOwnProperty.call(E, "default") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.default), E.position != null && Object.hasOwnProperty.call(E, "position") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(E.position), E.acceptFile != null && Object.hasOwnProperty.call(E, "acceptFile") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(E.acceptFile), E.fileType != null && E.fileType.length) for (let t = 0; t < E.fileType.length; ++t) e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.fileType[t]);
    return E.maxUploadSizeMb != null && Object.hasOwnProperty.call(E, "maxUploadSizeMb") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(E.maxUploadSizeMb), E.acceptAudio != null && Object.hasOwnProperty.call(E, "acceptAudio") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(E.acceptAudio), E.audioSampleRate != null && Object.hasOwnProperty.call(E, "audioSampleRate") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(E.audioSampleRate), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.ChatInput();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.placeholder = E.string();
          break;
        }
        case 3: {
          h.maxChars = E.uint32();
          break;
        }
        case 4: {
          h.disabled = E.bool();
          break;
        }
        case 5: {
          h.value = E.string();
          break;
        }
        case 6: {
          h.setValue = E.bool();
          break;
        }
        case 7: {
          h.default = E.string();
          break;
        }
        case 8: {
          h.position = E.int32();
          break;
        }
        case 9: {
          h.acceptFile = E.int32();
          break;
        }
        case 10: {
          h.fileType && h.fileType.length || (h.fileType = []), h.fileType.push(E.string());
          break;
        }
        case 11: {
          h.maxUploadSizeMb = E.int32();
          break;
        }
        case 12: {
          h.acceptAudio = E.bool();
          break;
        }
        case 13: {
          h.audioSampleRate = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.ChatInput) return E;
    let e = new $root$1.ChatInput();
    switch (E.id != null && (e.id = String(E.id)), E.placeholder != null && (e.placeholder = String(E.placeholder)), E.maxChars != null && (e.maxChars = E.maxChars >>> 0), E.disabled != null && (e.disabled = !!E.disabled), E.value != null && (e.value = String(E.value)), E.setValue != null && (e.setValue = !!E.setValue), E.default != null && (e.default = String(E.default)), E.position) {
      default:
        if (typeof E.position == "number") {
          e.position = E.position;
          break;
        }
        break;
      case "BOTTOM":
      case 0:
        e.position = 0;
        break;
    }
    switch (E.acceptFile) {
      default:
        if (typeof E.acceptFile == "number") {
          e.acceptFile = E.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        e.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        e.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        e.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        e.acceptFile = 3;
        break;
    }
    if (E.fileType) {
      if (!Array.isArray(E.fileType)) throw TypeError(".ChatInput.fileType: array expected");
      e.fileType = [];
      for (let t = 0; t < E.fileType.length; ++t) e.fileType[t] = String(E.fileType[t]);
    }
    return E.maxUploadSizeMb != null && (e.maxUploadSizeMb = E.maxUploadSizeMb | 0), E.acceptAudio != null && (e.acceptAudio = !!E.acceptAudio), E.audioSampleRate != null && (e.audioSampleRate = E.audioSampleRate | 0), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.fileType = []), e.defaults && (t.id = "", t.placeholder = "", t.maxChars = 0, t.disabled = !1, t.value = "", t.setValue = !1, t.default = "", t.position = e.enums === String ? "BOTTOM" : 0, t.acceptFile = e.enums === String ? "NONE" : 0, t.maxUploadSizeMb = 0, t.acceptAudio = !1), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.placeholder != null && E.hasOwnProperty("placeholder") && (t.placeholder = E.placeholder), E.maxChars != null && E.hasOwnProperty("maxChars") && (t.maxChars = E.maxChars), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.value != null && E.hasOwnProperty("value") && (t.value = E.value), E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.default != null && E.hasOwnProperty("default") && (t.default = E.default), E.position != null && E.hasOwnProperty("position") && (t.position = e.enums === String ? $root$1.ChatInput.Position[E.position] === void 0 ? E.position : $root$1.ChatInput.Position[E.position] : E.position), E.acceptFile != null && E.hasOwnProperty("acceptFile") && (t.acceptFile = e.enums === String ? $root$1.ChatInput.AcceptFile[E.acceptFile] === void 0 ? E.acceptFile : $root$1.ChatInput.AcceptFile[E.acceptFile] : E.acceptFile), E.fileType && E.fileType.length) {
      t.fileType = [];
      for (let n = 0; n < E.fileType.length; ++n) t.fileType[n] = E.fileType[n];
    }
    return E.maxUploadSizeMb != null && E.hasOwnProperty("maxUploadSizeMb") && (t.maxUploadSizeMb = E.maxUploadSizeMb), E.acceptAudio != null && E.hasOwnProperty("acceptAudio") && (t.acceptAudio = E.acceptAudio), E.audioSampleRate != null && E.hasOwnProperty("audioSampleRate") && (t.audioSampleRate = E.audioSampleRate, e.oneofs && (t._audioSampleRate = "audioSampleRate")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ChatInput";
  }, o.Position = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "BOTTOM"] = 0, E;
  })(), o.AcceptFile = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "NONE"] = 0, E[g[1] = "SINGLE"] = 1, E[g[2] = "MULTIPLE"] = 2, E[g[3] = "DIRECTORY"] = 3, E;
  })(), o;
})(), Checkbox$1 = $root$1.Checkbox = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = !1, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.type = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(g.type), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Checkbox();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.bool();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.value = g.bool();
          break;
        }
        case 7: {
          n.setValue = g.bool();
          break;
        }
        case 8: {
          n.disabled = g.bool();
          break;
        }
        case 9: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.type = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Checkbox) return g;
    let E = new $root$1.Checkbox();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = !!g.default), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value != null && (E.value = !!g.value), g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
      E.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    switch (g.type) {
      default:
        if (typeof g.type == "number") {
          E.type = g.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        E.type = 0;
        break;
      case "TOGGLE":
      case 1:
        E.type = 1;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.value = !1, e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.type = E.enums === String ? "DEFAULT" : 0), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (e.value = g.value), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.type != null && g.hasOwnProperty("type") && (e.type = E.enums === String ? $root$1.Checkbox.StyleType[g.type] === void 0 ? g.type : $root$1.Checkbox.StyleType[g.type] : g.type), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Checkbox";
  }, o.StyleType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "DEFAULT"] = 0, g[i[1] = "TOGGLE"] = 1, g;
  })(), o;
})();
$root$1.Code = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.codeText = "", o.prototype.language = "", o.prototype.showLineNumbers = !1, o.prototype.wrapLines = !1, o.prototype.height = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.codeText != null && Object.hasOwnProperty.call(g, "codeText") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.codeText), g.language != null && Object.hasOwnProperty.call(g, "language") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.language), g.showLineNumbers != null && Object.hasOwnProperty.call(g, "showLineNumbers") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.showLineNumbers), g.wrapLines != null && Object.hasOwnProperty.call(g, "wrapLines") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.wrapLines), g.height != null && Object.hasOwnProperty.call(g, "height") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(g.height), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Code();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.codeText = g.string();
          break;
        }
        case 2: {
          n.language = g.string();
          break;
        }
        case 3: {
          n.showLineNumbers = g.bool();
          break;
        }
        case 4: {
          n.wrapLines = g.bool();
          break;
        }
        case 5: {
          n.height = g.uint32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Code) return g;
    let E = new $root$1.Code();
    return g.codeText != null && (E.codeText = String(g.codeText)), g.language != null && (E.language = String(g.language)), g.showLineNumbers != null && (E.showLineNumbers = !!g.showLineNumbers), g.wrapLines != null && (E.wrapLines = !!g.wrapLines), g.height != null && (E.height = g.height >>> 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.codeText = "", e.language = "", e.showLineNumbers = !1, e.wrapLines = !1, e.height = 0), g.codeText != null && g.hasOwnProperty("codeText") && (e.codeText = g.codeText), g.language != null && g.hasOwnProperty("language") && (e.language = g.language), g.showLineNumbers != null && g.hasOwnProperty("showLineNumbers") && (e.showLineNumbers = g.showLineNumbers), g.wrapLines != null && g.hasOwnProperty("wrapLines") && (e.wrapLines = g.wrapLines), g.height != null && g.hasOwnProperty("height") && (e.height = g.height), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Code";
  }, o;
})();
$root$1.ColorPicker = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.value = "", o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ColorPicker();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.string();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.value = g.string();
          break;
        }
        case 7: {
          n.setValue = g.bool();
          break;
        }
        case 8: {
          n.disabled = g.bool();
          break;
        }
        case 9: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ColorPicker) return g;
    let E = new $root$1.ColorPicker();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = String(g.default)), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value != null && (E.value = String(g.value)), g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
      E.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.default = "", e.help = "", e.formId = "", e.value = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (e.value = g.value), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ColorPicker";
  }, o;
})();
$root$1.DataFrame = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.prototype.index = null, o.prototype.columns = null, o.prototype.style = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Table.encode(g.data, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.index != null && Object.hasOwnProperty.call(g, "index") && $root$1.Index.encode(g.index, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.columns != null && Object.hasOwnProperty.call(g, "columns") && $root$1.Index.encode(g.columns, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.style != null && Object.hasOwnProperty.call(g, "style") && $root$1.TableStyle.encode(g.style, E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DataFrame();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = $root$1.Table.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.index = $root$1.Index.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.columns = $root$1.Index.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.style = $root$1.TableStyle.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DataFrame) return g;
    let E = new $root$1.DataFrame();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".DataFrame.data: object expected");
      E.data = $root$1.Table.fromObject(g.data);
    }
    if (g.index != null) {
      if (typeof g.index != "object") throw TypeError(".DataFrame.index: object expected");
      E.index = $root$1.Index.fromObject(g.index);
    }
    if (g.columns != null) {
      if (typeof g.columns != "object") throw TypeError(".DataFrame.columns: object expected");
      E.columns = $root$1.Index.fromObject(g.columns);
    }
    if (g.style != null) {
      if (typeof g.style != "object") throw TypeError(".DataFrame.style: object expected");
      E.style = $root$1.TableStyle.fromObject(g.style);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.data = null, e.index = null, e.columns = null, e.style = null), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.Table.toObject(g.data, E)), g.index != null && g.hasOwnProperty("index") && (e.index = $root$1.Index.toObject(g.index, E)), g.columns != null && g.hasOwnProperty("columns") && (e.columns = $root$1.Index.toObject(g.columns, E)), g.style != null && g.hasOwnProperty("style") && (e.style = $root$1.TableStyle.toObject(g.style, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DataFrame";
  }, o;
})();
$root$1.Index = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.plainIndex = null, o.prototype.rangeIndex = null, o.prototype.multiIndex = null, o.prototype.datetimeIndex = null, o.prototype.timedeltaIndex = null, o.prototype.int_64Index = null, o.prototype.float_64Index = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["plainIndex", "rangeIndex", "multiIndex", "datetimeIndex", "timedeltaIndex", "int_64Index", "float_64Index"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.plainIndex != null && Object.hasOwnProperty.call(E, "plainIndex") && $root$1.PlainIndex.encode(E.plainIndex, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E.rangeIndex != null && Object.hasOwnProperty.call(E, "rangeIndex") && $root$1.RangeIndex.encode(E.rangeIndex, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.multiIndex != null && Object.hasOwnProperty.call(E, "multiIndex") && $root$1.MultiIndex.encode(E.multiIndex, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), E.datetimeIndex != null && Object.hasOwnProperty.call(E, "datetimeIndex") && $root$1.DatetimeIndex.encode(E.datetimeIndex, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E.timedeltaIndex != null && Object.hasOwnProperty.call(E, "timedeltaIndex") && $root$1.TimedeltaIndex.encode(E.timedeltaIndex, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), E.int_64Index != null && Object.hasOwnProperty.call(E, "int_64Index") && $root$1.Int64Index.encode(E.int_64Index, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E.float_64Index != null && Object.hasOwnProperty.call(E, "float_64Index") && $root$1.Float64Index.encode(E.float_64Index, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Index();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.plainIndex = $root$1.PlainIndex.decode(E, E.uint32());
          break;
        }
        case 2: {
          h.rangeIndex = $root$1.RangeIndex.decode(E, E.uint32());
          break;
        }
        case 4: {
          h.multiIndex = $root$1.MultiIndex.decode(E, E.uint32());
          break;
        }
        case 6: {
          h.datetimeIndex = $root$1.DatetimeIndex.decode(E, E.uint32());
          break;
        }
        case 7: {
          h.timedeltaIndex = $root$1.TimedeltaIndex.decode(E, E.uint32());
          break;
        }
        case 9: {
          h.int_64Index = $root$1.Int64Index.decode(E, E.uint32());
          break;
        }
        case 11: {
          h.float_64Index = $root$1.Float64Index.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Index) return E;
    let e = new $root$1.Index();
    if (E.plainIndex != null) {
      if (typeof E.plainIndex != "object") throw TypeError(".Index.plainIndex: object expected");
      e.plainIndex = $root$1.PlainIndex.fromObject(E.plainIndex);
    }
    if (E.rangeIndex != null) {
      if (typeof E.rangeIndex != "object") throw TypeError(".Index.rangeIndex: object expected");
      e.rangeIndex = $root$1.RangeIndex.fromObject(E.rangeIndex);
    }
    if (E.multiIndex != null) {
      if (typeof E.multiIndex != "object") throw TypeError(".Index.multiIndex: object expected");
      e.multiIndex = $root$1.MultiIndex.fromObject(E.multiIndex);
    }
    if (E.datetimeIndex != null) {
      if (typeof E.datetimeIndex != "object") throw TypeError(".Index.datetimeIndex: object expected");
      e.datetimeIndex = $root$1.DatetimeIndex.fromObject(E.datetimeIndex);
    }
    if (E.timedeltaIndex != null) {
      if (typeof E.timedeltaIndex != "object") throw TypeError(".Index.timedeltaIndex: object expected");
      e.timedeltaIndex = $root$1.TimedeltaIndex.fromObject(E.timedeltaIndex);
    }
    if (E.int_64Index != null) {
      if (typeof E.int_64Index != "object") throw TypeError(".Index.int_64Index: object expected");
      e.int_64Index = $root$1.Int64Index.fromObject(E.int_64Index);
    }
    if (E.float_64Index != null) {
      if (typeof E.float_64Index != "object") throw TypeError(".Index.float_64Index: object expected");
      e.float_64Index = $root$1.Float64Index.fromObject(E.float_64Index);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return E.plainIndex != null && E.hasOwnProperty("plainIndex") && (t.plainIndex = $root$1.PlainIndex.toObject(E.plainIndex, e), e.oneofs && (t.type = "plainIndex")), E.rangeIndex != null && E.hasOwnProperty("rangeIndex") && (t.rangeIndex = $root$1.RangeIndex.toObject(E.rangeIndex, e), e.oneofs && (t.type = "rangeIndex")), E.multiIndex != null && E.hasOwnProperty("multiIndex") && (t.multiIndex = $root$1.MultiIndex.toObject(E.multiIndex, e), e.oneofs && (t.type = "multiIndex")), E.datetimeIndex != null && E.hasOwnProperty("datetimeIndex") && (t.datetimeIndex = $root$1.DatetimeIndex.toObject(E.datetimeIndex, e), e.oneofs && (t.type = "datetimeIndex")), E.timedeltaIndex != null && E.hasOwnProperty("timedeltaIndex") && (t.timedeltaIndex = $root$1.TimedeltaIndex.toObject(E.timedeltaIndex, e), e.oneofs && (t.type = "timedeltaIndex")), E.int_64Index != null && E.hasOwnProperty("int_64Index") && (t.int_64Index = $root$1.Int64Index.toObject(E.int_64Index, e), e.oneofs && (t.type = "int_64Index")), E.float_64Index != null && E.hasOwnProperty("float_64Index") && (t.float_64Index = $root$1.Float64Index.toObject(E.float_64Index, e), e.oneofs && (t.type = "float_64Index")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Index";
  }, o;
})();
$root$1.PlainIndex = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.AnyArray.encode(g.data, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.PlainIndex();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = $root$1.AnyArray.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.PlainIndex) return g;
    let E = new $root$1.PlainIndex();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".PlainIndex.data: object expected");
      E.data = $root$1.AnyArray.fromObject(g.data);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.data = null), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.AnyArray.toObject(g.data, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PlainIndex";
  }, o;
})();
$root$1.RangeIndex = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.start = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.stop = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.start != null && Object.hasOwnProperty.call(g, "start") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int64(g.start), g.stop != null && Object.hasOwnProperty.call(g, "stop") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(g.stop), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.RangeIndex();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.start = g.int64();
          break;
        }
        case 2: {
          n.stop = g.int64();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.RangeIndex) return g;
    let E = new $root$1.RangeIndex();
    return g.start != null && ($util$1.Long ? (E.start = $util$1.Long.fromValue(g.start)).unsigned = !1 : typeof g.start == "string" ? E.start = parseInt(g.start, 10) : typeof g.start == "number" ? E.start = g.start : typeof g.start == "object" && (E.start = new $util$1.LongBits(g.start.low >>> 0, g.start.high >>> 0).toNumber())), g.stop != null && ($util$1.Long ? (E.stop = $util$1.Long.fromValue(g.stop)).unsigned = !1 : typeof g.stop == "string" ? E.stop = parseInt(g.stop, 10) : typeof g.stop == "number" ? E.stop = g.stop : typeof g.stop == "object" && (E.stop = new $util$1.LongBits(g.stop.low >>> 0, g.stop.high >>> 0).toNumber())), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if (E.defaults) {
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.start = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.start = E.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.stop = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.stop = E.longs === String ? "0" : 0;
    }
    return g.start != null && g.hasOwnProperty("start") && (typeof g.start == "number" ? e.start = E.longs === String ? String(g.start) : g.start : e.start = E.longs === String ? $util$1.Long.prototype.toString.call(g.start) : E.longs === Number ? new $util$1.LongBits(g.start.low >>> 0, g.start.high >>> 0).toNumber() : g.start), g.stop != null && g.hasOwnProperty("stop") && (typeof g.stop == "number" ? e.stop = E.longs === String ? String(g.stop) : g.stop : e.stop = E.longs === String ? $util$1.Long.prototype.toString.call(g.stop) : E.longs === Number ? new $util$1.LongBits(g.stop.low >>> 0, g.stop.high >>> 0).toNumber() : g.stop), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/RangeIndex";
  }, o;
})();
$root$1.MultiIndex = (() => {
  function o(i) {
    if (this.levels = [], this.labels = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.levels = $util$1.emptyArray, o.prototype.labels = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.levels != null && g.levels.length) for (let e = 0; e < g.levels.length; ++e) $root$1.Index.encode(g.levels[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (g.labels != null && g.labels.length) for (let e = 0; e < g.labels.length; ++e) $root$1.Int32Array.encode(g.labels[e], E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.MultiIndex();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.levels && n.levels.length || (n.levels = []), n.levels.push($root$1.Index.decode(g, g.uint32()));
          break;
        }
        case 2: {
          n.labels && n.labels.length || (n.labels = []), n.labels.push($root$1.Int32Array.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.MultiIndex) return g;
    let E = new $root$1.MultiIndex();
    if (g.levels) {
      if (!Array.isArray(g.levels)) throw TypeError(".MultiIndex.levels: array expected");
      E.levels = [];
      for (let e = 0; e < g.levels.length; ++e) {
        if (typeof g.levels[e] != "object") throw TypeError(".MultiIndex.levels: object expected");
        E.levels[e] = $root$1.Index.fromObject(g.levels[e]);
      }
    }
    if (g.labels) {
      if (!Array.isArray(g.labels)) throw TypeError(".MultiIndex.labels: array expected");
      E.labels = [];
      for (let e = 0; e < g.labels.length; ++e) {
        if (typeof g.labels[e] != "object") throw TypeError(".MultiIndex.labels: object expected");
        E.labels[e] = $root$1.Int32Array.fromObject(g.labels[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.levels = [], e.labels = []), g.levels && g.levels.length) {
      e.levels = [];
      for (let t = 0; t < g.levels.length; ++t) e.levels[t] = $root$1.Index.toObject(g.levels[t], E);
    }
    if (g.labels && g.labels.length) {
      e.labels = [];
      for (let t = 0; t < g.labels.length; ++t) e.labels[t] = $root$1.Int32Array.toObject(g.labels[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/MultiIndex";
  }, o;
})();
$root$1.DatetimeIndex = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.StringArray.encode(g.data, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DatetimeIndex();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = $root$1.StringArray.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DatetimeIndex) return g;
    let E = new $root$1.DatetimeIndex();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".DatetimeIndex.data: object expected");
      E.data = $root$1.StringArray.fromObject(g.data);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.data = null), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.StringArray.toObject(g.data, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DatetimeIndex";
  }, o;
})();
$root$1.TimedeltaIndex = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Int64Array.encode(g.data, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.TimedeltaIndex();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = $root$1.Int64Array.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.TimedeltaIndex) return g;
    let E = new $root$1.TimedeltaIndex();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".TimedeltaIndex.data: object expected");
      E.data = $root$1.Int64Array.fromObject(g.data);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.data = null), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.Int64Array.toObject(g.data, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TimedeltaIndex";
  }, o;
})();
$root$1.Int64Index = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Int64Array.encode(g.data, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Int64Index();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = $root$1.Int64Array.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Int64Index) return g;
    let E = new $root$1.Int64Index();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".Int64Index.data: object expected");
      E.data = $root$1.Int64Array.fromObject(g.data);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.data = null), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.Int64Array.toObject(g.data, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Int64Index";
  }, o;
})();
$root$1.Float64Index = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.DoubleArray.encode(g.data, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Float64Index();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = $root$1.DoubleArray.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Float64Index) return g;
    let E = new $root$1.Float64Index();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".Float64Index.data: object expected");
      E.data = $root$1.DoubleArray.fromObject(g.data);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.data = null), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.DoubleArray.toObject(g.data, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Float64Index";
  }, o;
})();
$root$1.CSSStyle = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.property = "", o.prototype.value = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.property != null && Object.hasOwnProperty.call(g, "property") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.property), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.value), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.CSSStyle();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.property = g.string();
          break;
        }
        case 2: {
          n.value = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.CSSStyle) return g;
    let E = new $root$1.CSSStyle();
    return g.property != null && (E.property = String(g.property)), g.value != null && (E.value = String(g.value)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.property = "", e.value = ""), g.property != null && g.hasOwnProperty("property") && (e.property = g.property), g.value != null && g.hasOwnProperty("value") && (e.value = g.value), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CSSStyle";
  }, o;
})();
$root$1.CellStyle = (() => {
  function o(i) {
    if (this.css = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.css = $util$1.emptyArray, o.prototype.displayValue = "", o.prototype.hasDisplayValue = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.css != null && g.css.length) for (let e = 0; e < g.css.length; ++e) $root$1.CSSStyle.encode(g.css[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g.displayValue != null && Object.hasOwnProperty.call(g, "displayValue") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.displayValue), g.hasDisplayValue != null && Object.hasOwnProperty.call(g, "hasDisplayValue") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.hasDisplayValue), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.CellStyle();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.css && n.css.length || (n.css = []), n.css.push($root$1.CSSStyle.decode(g, g.uint32()));
          break;
        }
        case 2: {
          n.displayValue = g.string();
          break;
        }
        case 3: {
          n.hasDisplayValue = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.CellStyle) return g;
    let E = new $root$1.CellStyle();
    if (g.css) {
      if (!Array.isArray(g.css)) throw TypeError(".CellStyle.css: array expected");
      E.css = [];
      for (let e = 0; e < g.css.length; ++e) {
        if (typeof g.css[e] != "object") throw TypeError(".CellStyle.css: object expected");
        E.css[e] = $root$1.CSSStyle.fromObject(g.css[e]);
      }
    }
    return g.displayValue != null && (E.displayValue = String(g.displayValue)), g.hasDisplayValue != null && (E.hasDisplayValue = !!g.hasDisplayValue), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.css = []), E.defaults && (e.displayValue = "", e.hasDisplayValue = !1), g.css && g.css.length) {
      e.css = [];
      for (let t = 0; t < g.css.length; ++t) e.css[t] = $root$1.CSSStyle.toObject(g.css[t], E);
    }
    return g.displayValue != null && g.hasOwnProperty("displayValue") && (e.displayValue = g.displayValue), g.hasDisplayValue != null && g.hasOwnProperty("hasDisplayValue") && (e.hasDisplayValue = g.hasDisplayValue), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CellStyle";
  }, o;
})();
$root$1.CellStyleArray = (() => {
  function o(i) {
    if (this.styles = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.styles = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.styles != null && g.styles.length) for (let e = 0; e < g.styles.length; ++e) $root$1.CellStyle.encode(g.styles[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.CellStyleArray();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.styles && n.styles.length || (n.styles = []), n.styles.push($root$1.CellStyle.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.CellStyleArray) return g;
    let E = new $root$1.CellStyleArray();
    if (g.styles) {
      if (!Array.isArray(g.styles)) throw TypeError(".CellStyleArray.styles: array expected");
      E.styles = [];
      for (let e = 0; e < g.styles.length; ++e) {
        if (typeof g.styles[e] != "object") throw TypeError(".CellStyleArray.styles: object expected");
        E.styles[e] = $root$1.CellStyle.fromObject(g.styles[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.styles = []), g.styles && g.styles.length) {
      e.styles = [];
      for (let t = 0; t < g.styles.length; ++t) e.styles[t] = $root$1.CellStyle.toObject(g.styles[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CellStyleArray";
  }, o;
})();
$root$1.AnyArray = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.strings = null, o.prototype.doubles = null, o.prototype.int64s = null, o.prototype.datetimes = null, o.prototype.timedeltas = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["strings", "doubles", "int64s", "datetimes", "timedeltas"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.strings != null && Object.hasOwnProperty.call(E, "strings") && $root$1.StringArray.encode(E.strings, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E.doubles != null && Object.hasOwnProperty.call(E, "doubles") && $root$1.DoubleArray.encode(E.doubles, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.int64s != null && Object.hasOwnProperty.call(E, "int64s") && $root$1.Int64Array.encode(E.int64s, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E.datetimes != null && Object.hasOwnProperty.call(E, "datetimes") && $root$1.StringArray.encode(E.datetimes, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), E.timedeltas != null && Object.hasOwnProperty.call(E, "timedeltas") && $root$1.Int64Array.encode(E.timedeltas, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.AnyArray();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.strings = $root$1.StringArray.decode(E, E.uint32());
          break;
        }
        case 2: {
          h.doubles = $root$1.DoubleArray.decode(E, E.uint32());
          break;
        }
        case 3: {
          h.int64s = $root$1.Int64Array.decode(E, E.uint32());
          break;
        }
        case 4: {
          h.datetimes = $root$1.StringArray.decode(E, E.uint32());
          break;
        }
        case 5: {
          h.timedeltas = $root$1.Int64Array.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.AnyArray) return E;
    let e = new $root$1.AnyArray();
    if (E.strings != null) {
      if (typeof E.strings != "object") throw TypeError(".AnyArray.strings: object expected");
      e.strings = $root$1.StringArray.fromObject(E.strings);
    }
    if (E.doubles != null) {
      if (typeof E.doubles != "object") throw TypeError(".AnyArray.doubles: object expected");
      e.doubles = $root$1.DoubleArray.fromObject(E.doubles);
    }
    if (E.int64s != null) {
      if (typeof E.int64s != "object") throw TypeError(".AnyArray.int64s: object expected");
      e.int64s = $root$1.Int64Array.fromObject(E.int64s);
    }
    if (E.datetimes != null) {
      if (typeof E.datetimes != "object") throw TypeError(".AnyArray.datetimes: object expected");
      e.datetimes = $root$1.StringArray.fromObject(E.datetimes);
    }
    if (E.timedeltas != null) {
      if (typeof E.timedeltas != "object") throw TypeError(".AnyArray.timedeltas: object expected");
      e.timedeltas = $root$1.Int64Array.fromObject(E.timedeltas);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return E.strings != null && E.hasOwnProperty("strings") && (t.strings = $root$1.StringArray.toObject(E.strings, e), e.oneofs && (t.type = "strings")), E.doubles != null && E.hasOwnProperty("doubles") && (t.doubles = $root$1.DoubleArray.toObject(E.doubles, e), e.oneofs && (t.type = "doubles")), E.int64s != null && E.hasOwnProperty("int64s") && (t.int64s = $root$1.Int64Array.toObject(E.int64s, e), e.oneofs && (t.type = "int64s")), E.datetimes != null && E.hasOwnProperty("datetimes") && (t.datetimes = $root$1.StringArray.toObject(E.datetimes, e), e.oneofs && (t.type = "datetimes")), E.timedeltas != null && E.hasOwnProperty("timedeltas") && (t.timedeltas = $root$1.Int64Array.toObject(E.timedeltas, e), e.oneofs && (t.type = "timedeltas")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/AnyArray";
  }, o;
})();
$root$1.Table = (() => {
  function o(i) {
    if (this.cols = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.cols = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.cols != null && g.cols.length) for (let e = 0; e < g.cols.length; ++e) $root$1.AnyArray.encode(g.cols[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Table();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.cols && n.cols.length || (n.cols = []), n.cols.push($root$1.AnyArray.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Table) return g;
    let E = new $root$1.Table();
    if (g.cols) {
      if (!Array.isArray(g.cols)) throw TypeError(".Table.cols: array expected");
      E.cols = [];
      for (let e = 0; e < g.cols.length; ++e) {
        if (typeof g.cols[e] != "object") throw TypeError(".Table.cols: object expected");
        E.cols[e] = $root$1.AnyArray.fromObject(g.cols[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.cols = []), g.cols && g.cols.length) {
      e.cols = [];
      for (let t = 0; t < g.cols.length; ++t) e.cols[t] = $root$1.AnyArray.toObject(g.cols[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Table";
  }, o;
})();
$root$1.TableStyle = (() => {
  function o(i) {
    if (this.cols = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.cols = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.cols != null && g.cols.length) for (let e = 0; e < g.cols.length; ++e) $root$1.CellStyleArray.encode(g.cols[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.TableStyle();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.cols && n.cols.length || (n.cols = []), n.cols.push($root$1.CellStyleArray.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.TableStyle) return g;
    let E = new $root$1.TableStyle();
    if (g.cols) {
      if (!Array.isArray(g.cols)) throw TypeError(".TableStyle.cols: array expected");
      E.cols = [];
      for (let e = 0; e < g.cols.length; ++e) {
        if (typeof g.cols[e] != "object") throw TypeError(".TableStyle.cols: object expected");
        E.cols[e] = $root$1.CellStyleArray.fromObject(g.cols[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.cols = []), g.cols && g.cols.length) {
      e.cols = [];
      for (let t = 0; t < g.cols.length; ++t) e.cols[t] = $root$1.CellStyleArray.toObject(g.cols[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TableStyle";
  }, o;
})();
$root$1.DateInput = (() => {
  function o(i) {
    if (this.default = [], this.value = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util$1.emptyArray, o.prototype.min = "", o.prototype.max = "", o.prototype.isRange = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.format = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && g.default.length) for (let e = 0; e < g.default.length; ++e) E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default[e]);
    if (g.min != null && Object.hasOwnProperty.call(g, "min") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.min), g.max != null && Object.hasOwnProperty.call(g, "max") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.max), g.isRange != null && Object.hasOwnProperty.call(g, "isRange") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.isRange), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.formId), g.value != null && g.value.length) for (let e = 0; e < g.value.length; ++e) E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.value[e]);
    return g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.format != null && Object.hasOwnProperty.call(g, "format") && E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.format), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DateInput();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default && n.default.length || (n.default = []), n.default.push(g.string());
          break;
        }
        case 4: {
          n.min = g.string();
          break;
        }
        case 5: {
          n.max = g.string();
          break;
        }
        case 6: {
          n.isRange = g.bool();
          break;
        }
        case 7: {
          n.help = g.string();
          break;
        }
        case 8: {
          n.formId = g.string();
          break;
        }
        case 9: {
          n.value && n.value.length || (n.value = []), n.value.push(g.string());
          break;
        }
        case 10: {
          n.setValue = g.bool();
          break;
        }
        case 11: {
          n.disabled = g.bool();
          break;
        }
        case 12: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.format = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DateInput) return g;
    let E = new $root$1.DateInput();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".DateInput.default: array expected");
      E.default = [];
      for (let e = 0; e < g.default.length; ++e) E.default[e] = String(g.default[e]);
    }
    if (g.min != null && (E.min = String(g.min)), g.max != null && (E.max = String(g.max)), g.isRange != null && (E.isRange = !!g.isRange), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".DateInput.value: array expected");
      E.value = [];
      for (let e = 0; e < g.value.length; ++e) E.value[e] = String(g.value[e]);
    }
    if (g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
      E.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.format != null && (E.format = String(g.format)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.default = [], e.value = []), E.defaults && (e.id = "", e.label = "", e.min = "", e.max = "", e.isRange = !1, e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.format = ""), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default && g.default.length) {
      e.default = [];
      for (let t = 0; t < g.default.length; ++t) e.default[t] = g.default[t];
    }
    if (g.min != null && g.hasOwnProperty("min") && (e.min = g.min), g.max != null && g.hasOwnProperty("max") && (e.max = g.max), g.isRange != null && g.hasOwnProperty("isRange") && (e.isRange = g.isRange), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value && g.value.length) {
      e.value = [];
      for (let t = 0; t < g.value.length; ++t) e.value[t] = g.value[t];
    }
    return g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.format != null && g.hasOwnProperty("format") && (e.format = g.format), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DateInput";
  }, o;
})();
$root$1.DateTimeInput = (() => {
  function o(i) {
    if (this.default = [], this.value = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util$1.emptyArray, o.prototype.min = "", o.prototype.max = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.format = "", o.prototype.step = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.isRange = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && g.default.length) for (let e = 0; e < g.default.length; ++e) E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default[e]);
    if (g.min != null && Object.hasOwnProperty.call(g, "min") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.min), g.max != null && Object.hasOwnProperty.call(g, "max") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.max), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.formId), g.value != null && g.value.length) for (let e = 0; e < g.value.length; ++e) E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.value[e]);
    return g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.format != null && Object.hasOwnProperty.call(g, "format") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.format), g.step != null && Object.hasOwnProperty.call(g, "step") && E.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int64(g.step), g.isRange != null && Object.hasOwnProperty.call(g, "isRange") && E.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(g.isRange), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DateTimeInput();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default && n.default.length || (n.default = []), n.default.push(g.string());
          break;
        }
        case 4: {
          n.min = g.string();
          break;
        }
        case 5: {
          n.max = g.string();
          break;
        }
        case 6: {
          n.help = g.string();
          break;
        }
        case 7: {
          n.formId = g.string();
          break;
        }
        case 8: {
          n.value && n.value.length || (n.value = []), n.value.push(g.string());
          break;
        }
        case 9: {
          n.setValue = g.bool();
          break;
        }
        case 10: {
          n.disabled = g.bool();
          break;
        }
        case 11: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.format = g.string();
          break;
        }
        case 13: {
          n.step = g.int64();
          break;
        }
        case 14: {
          n.isRange = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DateTimeInput) return g;
    let E = new $root$1.DateTimeInput();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".DateTimeInput.default: array expected");
      E.default = [];
      for (let e = 0; e < g.default.length; ++e) E.default[e] = String(g.default[e]);
    }
    if (g.min != null && (E.min = String(g.min)), g.max != null && (E.max = String(g.max)), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".DateTimeInput.value: array expected");
      E.value = [];
      for (let e = 0; e < g.value.length; ++e) E.value[e] = String(g.value[e]);
    }
    if (g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".DateTimeInput.labelVisibility: object expected");
      E.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.format != null && (E.format = String(g.format)), g.step != null && ($util$1.Long ? (E.step = $util$1.Long.fromValue(g.step)).unsigned = !1 : typeof g.step == "string" ? E.step = parseInt(g.step, 10) : typeof g.step == "number" ? E.step = g.step : typeof g.step == "object" && (E.step = new $util$1.LongBits(g.step.low >>> 0, g.step.high >>> 0).toNumber())), g.isRange != null && (E.isRange = !!g.isRange), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.default = [], e.value = []), E.defaults) {
      if (e.id = "", e.label = "", e.min = "", e.max = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.format = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.step = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.step = E.longs === String ? "0" : 0;
      e.isRange = !1;
    }
    if (g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default && g.default.length) {
      e.default = [];
      for (let t = 0; t < g.default.length; ++t) e.default[t] = g.default[t];
    }
    if (g.min != null && g.hasOwnProperty("min") && (e.min = g.min), g.max != null && g.hasOwnProperty("max") && (e.max = g.max), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value && g.value.length) {
      e.value = [];
      for (let t = 0; t < g.value.length; ++t) e.value[t] = g.value[t];
    }
    return g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.format != null && g.hasOwnProperty("format") && (e.format = g.format), g.step != null && g.hasOwnProperty("step") && (typeof g.step == "number" ? e.step = E.longs === String ? String(g.step) : g.step : e.step = E.longs === String ? $util$1.Long.prototype.toString.call(g.step) : E.longs === Number ? new $util$1.LongBits(g.step.low >>> 0, g.step.high >>> 0).toNumber() : g.step), g.isRange != null && g.hasOwnProperty("isRange") && (e.isRange = g.isRange), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DateTimeInput";
  }, o;
})();
const DeckGlJsonChart$1 = $root$1.DeckGlJsonChart = (() => {
  function o(i) {
    if (this.selectionMode = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.json = "", o.prototype.tooltip = "", o.prototype.useContainerWidth = !1, o.prototype.id = "", o.prototype.mapboxToken = "", o.prototype.width = 0, o.prototype.height = 0, o.prototype.selectionMode = $util$1.emptyArray, o.prototype.formId = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.json != null && Object.hasOwnProperty.call(g, "json") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.json), g.tooltip != null && Object.hasOwnProperty.call(g, "tooltip") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.tooltip), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.useContainerWidth), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.id), g.mapboxToken != null && Object.hasOwnProperty.call(g, "mapboxToken") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.mapboxToken), g.width != null && Object.hasOwnProperty.call(g, "width") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).uint32(g.width), g.height != null && Object.hasOwnProperty.call(g, "height") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).uint32(g.height), g.selectionMode != null && g.selectionMode.length) {
      E.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let e = 0; e < g.selectionMode.length; ++e) E.int32(g.selectionMode[e]);
      E.ldelim();
    }
    return g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.formId), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DeckGlJsonChart();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.json = g.string();
          break;
        }
        case 2: {
          n.tooltip = g.string();
          break;
        }
        case 4: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 5: {
          n.id = g.string();
          break;
        }
        case 6: {
          n.mapboxToken = g.string();
          break;
        }
        case 7: {
          n.width = g.uint32();
          break;
        }
        case 8: {
          n.height = g.uint32();
          break;
        }
        case 9: {
          if (n.selectionMode && n.selectionMode.length || (n.selectionMode = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.selectionMode.push(g.int32());
          } else n.selectionMode.push(g.int32());
          break;
        }
        case 10: {
          n.formId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DeckGlJsonChart) return g;
    let E = new $root$1.DeckGlJsonChart();
    if (g.json != null && (E.json = String(g.json)), g.tooltip != null && (E.tooltip = String(g.tooltip)), g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.id != null && (E.id = String(g.id)), g.mapboxToken != null && (E.mapboxToken = String(g.mapboxToken)), g.width != null && (E.width = g.width >>> 0), g.height != null && (E.height = g.height >>> 0), g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      E.selectionMode = [];
      for (let e = 0; e < g.selectionMode.length; ++e) switch (g.selectionMode[e]) {
        default:
          if (typeof g.selectionMode[e] == "number") {
            E.selectionMode[e] = g.selectionMode[e];
            break;
          }
        case "SINGLE_OBJECT":
        case 0:
          E.selectionMode[e] = 0;
          break;
        case "MULTI_OBJECT":
        case 1:
          E.selectionMode[e] = 1;
          break;
      }
    }
    return g.formId != null && (E.formId = String(g.formId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.selectionMode = []), E.defaults && (e.json = "", e.tooltip = "", e.useContainerWidth = !1, e.id = "", e.mapboxToken = "", e.width = 0, e.height = 0, e.formId = ""), g.json != null && g.hasOwnProperty("json") && (e.json = g.json), g.tooltip != null && g.hasOwnProperty("tooltip") && (e.tooltip = g.tooltip), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.mapboxToken != null && g.hasOwnProperty("mapboxToken") && (e.mapboxToken = g.mapboxToken), g.width != null && g.hasOwnProperty("width") && (e.width = g.width), g.height != null && g.hasOwnProperty("height") && (e.height = g.height), g.selectionMode && g.selectionMode.length) {
      e.selectionMode = [];
      for (let t = 0; t < g.selectionMode.length; ++t) e.selectionMode[t] = E.enums === String ? $root$1.DeckGlJsonChart.SelectionMode[g.selectionMode[t]] === void 0 ? g.selectionMode[t] : $root$1.DeckGlJsonChart.SelectionMode[g.selectionMode[t]] : g.selectionMode[t];
    }
    return g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DeckGlJsonChart";
  }, o.SelectionMode = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "SINGLE_OBJECT"] = 0, g[i[1] = "MULTI_OBJECT"] = 1, g;
  })(), o;
})();
$root$1.Delta = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.newElement = null, o.prototype.addBlock = null, o.prototype.newTransient = null, o.prototype.addRows = null, o.prototype.arrowAddRows = null, o.prototype.fragmentId = "";
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["newElement", "addBlock", "newTransient", "addRows", "arrowAddRows"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.newElement != null && Object.hasOwnProperty.call(E, "newElement") && $root$1.Element.encode(E.newElement, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E.addRows != null && Object.hasOwnProperty.call(E, "addRows") && $root$1.NamedDataSet.encode(E.addRows, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), E.addBlock != null && Object.hasOwnProperty.call(E, "addBlock") && $root$1.Block.encode(E.addBlock, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E.arrowAddRows != null && Object.hasOwnProperty.call(E, "arrowAddRows") && $root$1.ArrowNamedDataSet.encode(E.arrowAddRows, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), E.fragmentId != null && Object.hasOwnProperty.call(E, "fragmentId") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.fragmentId), E.newTransient != null && Object.hasOwnProperty.call(E, "newTransient") && $root$1.Transient.encode(E.newTransient, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Delta();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 3: {
          h.newElement = $root$1.Element.decode(E, E.uint32());
          break;
        }
        case 6: {
          h.addBlock = $root$1.Block.decode(E, E.uint32());
          break;
        }
        case 9: {
          h.newTransient = $root$1.Transient.decode(E, E.uint32());
          break;
        }
        case 5: {
          h.addRows = $root$1.NamedDataSet.decode(E, E.uint32());
          break;
        }
        case 7: {
          h.arrowAddRows = $root$1.ArrowNamedDataSet.decode(E, E.uint32());
          break;
        }
        case 8: {
          h.fragmentId = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Delta) return E;
    let e = new $root$1.Delta();
    if (E.newElement != null) {
      if (typeof E.newElement != "object") throw TypeError(".Delta.newElement: object expected");
      e.newElement = $root$1.Element.fromObject(E.newElement);
    }
    if (E.addBlock != null) {
      if (typeof E.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
      e.addBlock = $root$1.Block.fromObject(E.addBlock);
    }
    if (E.newTransient != null) {
      if (typeof E.newTransient != "object") throw TypeError(".Delta.newTransient: object expected");
      e.newTransient = $root$1.Transient.fromObject(E.newTransient);
    }
    if (E.addRows != null) {
      if (typeof E.addRows != "object") throw TypeError(".Delta.addRows: object expected");
      e.addRows = $root$1.NamedDataSet.fromObject(E.addRows);
    }
    if (E.arrowAddRows != null) {
      if (typeof E.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
      e.arrowAddRows = $root$1.ArrowNamedDataSet.fromObject(E.arrowAddRows);
    }
    return E.fragmentId != null && (e.fragmentId = String(E.fragmentId)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.fragmentId = ""), E.newElement != null && E.hasOwnProperty("newElement") && (t.newElement = $root$1.Element.toObject(E.newElement, e), e.oneofs && (t.type = "newElement")), E.addRows != null && E.hasOwnProperty("addRows") && (t.addRows = $root$1.NamedDataSet.toObject(E.addRows, e), e.oneofs && (t.type = "addRows")), E.addBlock != null && E.hasOwnProperty("addBlock") && (t.addBlock = $root$1.Block.toObject(E.addBlock, e), e.oneofs && (t.type = "addBlock")), E.arrowAddRows != null && E.hasOwnProperty("arrowAddRows") && (t.arrowAddRows = $root$1.ArrowNamedDataSet.toObject(E.arrowAddRows, e), e.oneofs && (t.type = "arrowAddRows")), E.fragmentId != null && E.hasOwnProperty("fragmentId") && (t.fragmentId = E.fragmentId), E.newTransient != null && E.hasOwnProperty("newTransient") && (t.newTransient = $root$1.Transient.toObject(E.newTransient, e), e.oneofs && (t.type = "newTransient")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Delta";
  }, o;
})();
const Element$1 = $root$1.Element = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.heightConfig = null, o.prototype.widthConfig = null, o.prototype.textAlignmentConfig = null, o.prototype.alert = null, o.prototype.arrowDataFrame = null, o.prototype.arrowTable = null, o.prototype.arrowVegaLiteChart = null, o.prototype.audio = null, o.prototype.audioInput = null, o.prototype.balloons = null, o.prototype.bidiComponent = null, o.prototype.bokehChart = null, o.prototype.button = null, o.prototype.buttonGroup = null, o.prototype.downloadButton = null, o.prototype.cameraInput = null, o.prototype.chatInput = null, o.prototype.checkbox = null, o.prototype.colorPicker = null, o.prototype.componentInstance = null, o.prototype.dataFrame = null, o.prototype.table = null, o.prototype.dateInput = null, o.prototype.deckGlJsonChart = null, o.prototype.docString = null, o.prototype.empty = null, o.prototype.exception = null, o.prototype.favicon = null, o.prototype.fileUploader = null, o.prototype.graphvizChart = null, o.prototype.html = null, o.prototype.iframe = null, o.prototype.imgs = null, o.prototype.json = null, o.prototype.linkButton = null, o.prototype.markdown = null, o.prototype.metric = null, o.prototype.multiselect = null, o.prototype.numberInput = null, o.prototype.pageLink = null, o.prototype.plotlyChart = null, o.prototype.progress = null, o.prototype.radio = null, o.prototype.selectbox = null, o.prototype.skeleton = null, o.prototype.slider = null, o.prototype.snow = null, o.prototype.space = null, o.prototype.spinner = null, o.prototype.text = null, o.prototype.textArea = null, o.prototype.textInput = null, o.prototype.timeInput = null, o.prototype.dateTimeInput = null, o.prototype.toast = null, o.prototype.vegaLiteChart = null, o.prototype.video = null, o.prototype.heading = null, o.prototype.code = null;
  let i;
  return Object.defineProperty(o.prototype, "_heightConfig", { get: $util$1.oneOfGetter(i = ["heightConfig"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_widthConfig", { get: $util$1.oneOfGetter(i = ["widthConfig"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_textAlignmentConfig", { get: $util$1.oneOfGetter(i = ["textAlignmentConfig"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["alert", "arrowDataFrame", "arrowTable", "arrowVegaLiteChart", "audio", "audioInput", "balloons", "bidiComponent", "bokehChart", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dataFrame", "table", "dateInput", "deckGlJsonChart", "docString", "empty", "exception", "favicon", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "space", "spinner", "text", "textArea", "textInput", "timeInput", "dateTimeInput", "toast", "vegaLiteChart", "video", "heading", "code"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.text != null && Object.hasOwnProperty.call(E, "text") && $root$1.Text.encode(E.text, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E.empty != null && Object.hasOwnProperty.call(E, "empty") && $root$1.Empty.encode(E.empty, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.dataFrame != null && Object.hasOwnProperty.call(E, "dataFrame") && $root$1.DataFrame.encode(E.dataFrame, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E.progress != null && Object.hasOwnProperty.call(E, "progress") && $root$1.Progress.encode(E.progress, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), E.imgs != null && Object.hasOwnProperty.call(E, "imgs") && $root$1.ImageList.encode(E.imgs, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E.docString != null && Object.hasOwnProperty.call(E, "docString") && $root$1.DocString.encode(E.docString, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), E.exception != null && Object.hasOwnProperty.call(E, "exception") && $root$1.Exception.encode(E.exception, e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), E.vegaLiteChart != null && Object.hasOwnProperty.call(E, "vegaLiteChart") && $root$1.VegaLiteChart.encode(E.vegaLiteChart, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), E.table != null && Object.hasOwnProperty.call(E, "table") && $root$1.DataFrame.encode(E.table, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), E.balloons != null && Object.hasOwnProperty.call(E, "balloons") && $root$1.Balloons.encode(E.balloons, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), E.audio != null && Object.hasOwnProperty.call(E, "audio") && $root$1.Audio.encode(E.audio, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), E.video != null && Object.hasOwnProperty.call(E, "video") && $root$1.Video.encode(E.video, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), E.plotlyChart != null && Object.hasOwnProperty.call(E, "plotlyChart") && $root$1.PlotlyChart.encode(E.plotlyChart, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), E.bokehChart != null && Object.hasOwnProperty.call(E, "bokehChart") && $root$1.BokehChart.encode(E.bokehChart, e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).fork()).ldelim(), E.graphvizChart != null && Object.hasOwnProperty.call(E, "graphvizChart") && $root$1.GraphVizChart.encode(E.graphvizChart, e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), E.button != null && Object.hasOwnProperty.call(E, "button") && $root$1.Button.encode(E.button, e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), E.checkbox != null && Object.hasOwnProperty.call(E, "checkbox") && $root$1.Checkbox.encode(E.checkbox, e.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), E.slider != null && Object.hasOwnProperty.call(E, "slider") && $root$1.Slider.encode(E.slider, e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), E.textArea != null && Object.hasOwnProperty.call(E, "textArea") && $root$1.TextArea.encode(E.textArea, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), E.radio != null && Object.hasOwnProperty.call(E, "radio") && $root$1.Radio.encode(E.radio, e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), E.textInput != null && Object.hasOwnProperty.call(E, "textInput") && $root$1.TextInput.encode(E.textInput, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), E.selectbox != null && Object.hasOwnProperty.call(E, "selectbox") && $root$1.Selectbox.encode(E.selectbox, e.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), E.timeInput != null && Object.hasOwnProperty.call(E, "timeInput") && $root$1.TimeInput.encode(E.timeInput, e.uint32(
      /* id 26, wireType 2 =*/
      210
    ).fork()).ldelim(), E.dateInput != null && Object.hasOwnProperty.call(E, "dateInput") && $root$1.DateInput.encode(E.dateInput, e.uint32(
      /* id 27, wireType 2 =*/
      218
    ).fork()).ldelim(), E.multiselect != null && Object.hasOwnProperty.call(E, "multiselect") && $root$1.MultiSelect.encode(E.multiselect, e.uint32(
      /* id 28, wireType 2 =*/
      226
    ).fork()).ldelim(), E.markdown != null && Object.hasOwnProperty.call(E, "markdown") && $root$1.Markdown.encode(E.markdown, e.uint32(
      /* id 29, wireType 2 =*/
      234
    ).fork()).ldelim(), E.alert != null && Object.hasOwnProperty.call(E, "alert") && $root$1.Alert.encode(E.alert, e.uint32(
      /* id 30, wireType 2 =*/
      242
    ).fork()).ldelim(), E.json != null && Object.hasOwnProperty.call(E, "json") && $root$1.Json.encode(E.json, e.uint32(
      /* id 31, wireType 2 =*/
      250
    ).fork()).ldelim(), E.numberInput != null && Object.hasOwnProperty.call(E, "numberInput") && $root$1.NumberInput.encode(E.numberInput, e.uint32(
      /* id 32, wireType 2 =*/
      258
    ).fork()).ldelim(), E.fileUploader != null && Object.hasOwnProperty.call(E, "fileUploader") && $root$1.FileUploader.encode(E.fileUploader, e.uint32(
      /* id 33, wireType 2 =*/
      266
    ).fork()).ldelim(), E.deckGlJsonChart != null && Object.hasOwnProperty.call(E, "deckGlJsonChart") && $root$1.DeckGlJsonChart.encode(E.deckGlJsonChart, e.uint32(
      /* id 34, wireType 2 =*/
      274
    ).fork()).ldelim(), E.colorPicker != null && Object.hasOwnProperty.call(E, "colorPicker") && $root$1.ColorPicker.encode(E.colorPicker, e.uint32(
      /* id 35, wireType 2 =*/
      282
    ).fork()).ldelim(), E.favicon != null && Object.hasOwnProperty.call(E, "favicon") && $root$1.Favicon.encode(E.favicon, e.uint32(
      /* id 36, wireType 2 =*/
      290
    ).fork()).ldelim(), E.componentInstance != null && Object.hasOwnProperty.call(E, "componentInstance") && $root$1.ComponentInstance.encode(E.componentInstance, e.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim(), E.iframe != null && Object.hasOwnProperty.call(E, "iframe") && $root$1.IFrame.encode(E.iframe, e.uint32(
      /* id 38, wireType 2 =*/
      306
    ).fork()).ldelim(), E.arrowTable != null && Object.hasOwnProperty.call(E, "arrowTable") && $root$1.Arrow.encode(E.arrowTable, e.uint32(
      /* id 39, wireType 2 =*/
      314
    ).fork()).ldelim(), E.arrowDataFrame != null && Object.hasOwnProperty.call(E, "arrowDataFrame") && $root$1.Arrow.encode(E.arrowDataFrame, e.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), E.arrowVegaLiteChart != null && Object.hasOwnProperty.call(E, "arrowVegaLiteChart") && $root$1.ArrowVegaLiteChart.encode(E.arrowVegaLiteChart, e.uint32(
      /* id 41, wireType 2 =*/
      330
    ).fork()).ldelim(), E.metric != null && Object.hasOwnProperty.call(E, "metric") && $root$1.Metric.encode(E.metric, e.uint32(
      /* id 42, wireType 2 =*/
      338
    ).fork()).ldelim(), E.downloadButton != null && Object.hasOwnProperty.call(E, "downloadButton") && $root$1.DownloadButton.encode(E.downloadButton, e.uint32(
      /* id 43, wireType 2 =*/
      346
    ).fork()).ldelim(), E.spinner != null && Object.hasOwnProperty.call(E, "spinner") && $root$1.Spinner.encode(E.spinner, e.uint32(
      /* id 44, wireType 2 =*/
      354
    ).fork()).ldelim(), E.cameraInput != null && Object.hasOwnProperty.call(E, "cameraInput") && $root$1.CameraInput.encode(E.cameraInput, e.uint32(
      /* id 45, wireType 2 =*/
      362
    ).fork()).ldelim(), E.snow != null && Object.hasOwnProperty.call(E, "snow") && $root$1.Snow.encode(E.snow, e.uint32(
      /* id 46, wireType 2 =*/
      370
    ).fork()).ldelim(), E.heading != null && Object.hasOwnProperty.call(E, "heading") && $root$1.Heading.encode(E.heading, e.uint32(
      /* id 47, wireType 2 =*/
      378
    ).fork()).ldelim(), E.code != null && Object.hasOwnProperty.call(E, "code") && $root$1.Code.encode(E.code, e.uint32(
      /* id 48, wireType 2 =*/
      386
    ).fork()).ldelim(), E.chatInput != null && Object.hasOwnProperty.call(E, "chatInput") && $root$1.ChatInput.encode(E.chatInput, e.uint32(
      /* id 49, wireType 2 =*/
      394
    ).fork()).ldelim(), E.toast != null && Object.hasOwnProperty.call(E, "toast") && $root$1.Toast.encode(E.toast, e.uint32(
      /* id 50, wireType 2 =*/
      402
    ).fork()).ldelim(), E.linkButton != null && Object.hasOwnProperty.call(E, "linkButton") && $root$1.LinkButton.encode(E.linkButton, e.uint32(
      /* id 51, wireType 2 =*/
      410
    ).fork()).ldelim(), E.skeleton != null && Object.hasOwnProperty.call(E, "skeleton") && $root$1.Skeleton.encode(E.skeleton, e.uint32(
      /* id 52, wireType 2 =*/
      418
    ).fork()).ldelim(), E.pageLink != null && Object.hasOwnProperty.call(E, "pageLink") && $root$1.PageLink.encode(E.pageLink, e.uint32(
      /* id 53, wireType 2 =*/
      426
    ).fork()).ldelim(), E.html != null && Object.hasOwnProperty.call(E, "html") && $root$1.Html.encode(E.html, e.uint32(
      /* id 54, wireType 2 =*/
      434
    ).fork()).ldelim(), E.buttonGroup != null && Object.hasOwnProperty.call(E, "buttonGroup") && $root$1.ButtonGroup.encode(E.buttonGroup, e.uint32(
      /* id 55, wireType 2 =*/
      442
    ).fork()).ldelim(), E.audioInput != null && Object.hasOwnProperty.call(E, "audioInput") && $root$1.AudioInput.encode(E.audioInput, e.uint32(
      /* id 56, wireType 2 =*/
      450
    ).fork()).ldelim(), E.heightConfig != null && Object.hasOwnProperty.call(E, "heightConfig") && $root$1.streamlit.HeightConfig.encode(E.heightConfig, e.uint32(
      /* id 57, wireType 2 =*/
      458
    ).fork()).ldelim(), E.widthConfig != null && Object.hasOwnProperty.call(E, "widthConfig") && $root$1.streamlit.WidthConfig.encode(E.widthConfig, e.uint32(
      /* id 58, wireType 2 =*/
      466
    ).fork()).ldelim(), E.bidiComponent != null && Object.hasOwnProperty.call(E, "bidiComponent") && $root$1.BidiComponent.encode(E.bidiComponent, e.uint32(
      /* id 59, wireType 2 =*/
      474
    ).fork()).ldelim(), E.space != null && Object.hasOwnProperty.call(E, "space") && $root$1.Space.encode(E.space, e.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), E.textAlignmentConfig != null && Object.hasOwnProperty.call(E, "textAlignmentConfig") && $root$1.streamlit.TextAlignmentConfig.encode(E.textAlignmentConfig, e.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), E.dateTimeInput != null && Object.hasOwnProperty.call(E, "dateTimeInput") && $root$1.DateTimeInput.encode(E.dateTimeInput, e.uint32(
      /* id 62, wireType 2 =*/
      498
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Element();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 57: {
          h.heightConfig = $root$1.streamlit.HeightConfig.decode(E, E.uint32());
          break;
        }
        case 58: {
          h.widthConfig = $root$1.streamlit.WidthConfig.decode(E, E.uint32());
          break;
        }
        case 61: {
          h.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.decode(E, E.uint32());
          break;
        }
        case 30: {
          h.alert = $root$1.Alert.decode(E, E.uint32());
          break;
        }
        case 40: {
          h.arrowDataFrame = $root$1.Arrow.decode(E, E.uint32());
          break;
        }
        case 39: {
          h.arrowTable = $root$1.Arrow.decode(E, E.uint32());
          break;
        }
        case 41: {
          h.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.decode(E, E.uint32());
          break;
        }
        case 13: {
          h.audio = $root$1.Audio.decode(E, E.uint32());
          break;
        }
        case 56: {
          h.audioInput = $root$1.AudioInput.decode(E, E.uint32());
          break;
        }
        case 12: {
          h.balloons = $root$1.Balloons.decode(E, E.uint32());
          break;
        }
        case 59: {
          h.bidiComponent = $root$1.BidiComponent.decode(E, E.uint32());
          break;
        }
        case 17: {
          h.bokehChart = $root$1.BokehChart.decode(E, E.uint32());
          break;
        }
        case 19: {
          h.button = $root$1.Button.decode(E, E.uint32());
          break;
        }
        case 55: {
          h.buttonGroup = $root$1.ButtonGroup.decode(E, E.uint32());
          break;
        }
        case 43: {
          h.downloadButton = $root$1.DownloadButton.decode(E, E.uint32());
          break;
        }
        case 45: {
          h.cameraInput = $root$1.CameraInput.decode(E, E.uint32());
          break;
        }
        case 49: {
          h.chatInput = $root$1.ChatInput.decode(E, E.uint32());
          break;
        }
        case 20: {
          h.checkbox = $root$1.Checkbox.decode(E, E.uint32());
          break;
        }
        case 35: {
          h.colorPicker = $root$1.ColorPicker.decode(E, E.uint32());
          break;
        }
        case 37: {
          h.componentInstance = $root$1.ComponentInstance.decode(E, E.uint32());
          break;
        }
        case 3: {
          h.dataFrame = $root$1.DataFrame.decode(E, E.uint32());
          break;
        }
        case 11: {
          h.table = $root$1.DataFrame.decode(E, E.uint32());
          break;
        }
        case 27: {
          h.dateInput = $root$1.DateInput.decode(E, E.uint32());
          break;
        }
        case 34: {
          h.deckGlJsonChart = $root$1.DeckGlJsonChart.decode(E, E.uint32());
          break;
        }
        case 7: {
          h.docString = $root$1.DocString.decode(E, E.uint32());
          break;
        }
        case 2: {
          h.empty = $root$1.Empty.decode(E, E.uint32());
          break;
        }
        case 8: {
          h.exception = $root$1.Exception.decode(E, E.uint32());
          break;
        }
        case 36: {
          h.favicon = $root$1.Favicon.decode(E, E.uint32());
          break;
        }
        case 33: {
          h.fileUploader = $root$1.FileUploader.decode(E, E.uint32());
          break;
        }
        case 18: {
          h.graphvizChart = $root$1.GraphVizChart.decode(E, E.uint32());
          break;
        }
        case 54: {
          h.html = $root$1.Html.decode(E, E.uint32());
          break;
        }
        case 38: {
          h.iframe = $root$1.IFrame.decode(E, E.uint32());
          break;
        }
        case 6: {
          h.imgs = $root$1.ImageList.decode(E, E.uint32());
          break;
        }
        case 31: {
          h.json = $root$1.Json.decode(E, E.uint32());
          break;
        }
        case 51: {
          h.linkButton = $root$1.LinkButton.decode(E, E.uint32());
          break;
        }
        case 29: {
          h.markdown = $root$1.Markdown.decode(E, E.uint32());
          break;
        }
        case 42: {
          h.metric = $root$1.Metric.decode(E, E.uint32());
          break;
        }
        case 28: {
          h.multiselect = $root$1.MultiSelect.decode(E, E.uint32());
          break;
        }
        case 32: {
          h.numberInput = $root$1.NumberInput.decode(E, E.uint32());
          break;
        }
        case 53: {
          h.pageLink = $root$1.PageLink.decode(E, E.uint32());
          break;
        }
        case 16: {
          h.plotlyChart = $root$1.PlotlyChart.decode(E, E.uint32());
          break;
        }
        case 5: {
          h.progress = $root$1.Progress.decode(E, E.uint32());
          break;
        }
        case 23: {
          h.radio = $root$1.Radio.decode(E, E.uint32());
          break;
        }
        case 25: {
          h.selectbox = $root$1.Selectbox.decode(E, E.uint32());
          break;
        }
        case 52: {
          h.skeleton = $root$1.Skeleton.decode(E, E.uint32());
          break;
        }
        case 21: {
          h.slider = $root$1.Slider.decode(E, E.uint32());
          break;
        }
        case 46: {
          h.snow = $root$1.Snow.decode(E, E.uint32());
          break;
        }
        case 60: {
          h.space = $root$1.Space.decode(E, E.uint32());
          break;
        }
        case 44: {
          h.spinner = $root$1.Spinner.decode(E, E.uint32());
          break;
        }
        case 1: {
          h.text = $root$1.Text.decode(E, E.uint32());
          break;
        }
        case 22: {
          h.textArea = $root$1.TextArea.decode(E, E.uint32());
          break;
        }
        case 24: {
          h.textInput = $root$1.TextInput.decode(E, E.uint32());
          break;
        }
        case 26: {
          h.timeInput = $root$1.TimeInput.decode(E, E.uint32());
          break;
        }
        case 62: {
          h.dateTimeInput = $root$1.DateTimeInput.decode(E, E.uint32());
          break;
        }
        case 50: {
          h.toast = $root$1.Toast.decode(E, E.uint32());
          break;
        }
        case 10: {
          h.vegaLiteChart = $root$1.VegaLiteChart.decode(E, E.uint32());
          break;
        }
        case 14: {
          h.video = $root$1.Video.decode(E, E.uint32());
          break;
        }
        case 47: {
          h.heading = $root$1.Heading.decode(E, E.uint32());
          break;
        }
        case 48: {
          h.code = $root$1.Code.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Element) return E;
    let e = new $root$1.Element();
    if (E.heightConfig != null) {
      if (typeof E.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
      e.heightConfig = $root$1.streamlit.HeightConfig.fromObject(E.heightConfig);
    }
    if (E.widthConfig != null) {
      if (typeof E.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
      e.widthConfig = $root$1.streamlit.WidthConfig.fromObject(E.widthConfig);
    }
    if (E.textAlignmentConfig != null) {
      if (typeof E.textAlignmentConfig != "object") throw TypeError(".Element.textAlignmentConfig: object expected");
      e.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.fromObject(E.textAlignmentConfig);
    }
    if (E.alert != null) {
      if (typeof E.alert != "object") throw TypeError(".Element.alert: object expected");
      e.alert = $root$1.Alert.fromObject(E.alert);
    }
    if (E.arrowDataFrame != null) {
      if (typeof E.arrowDataFrame != "object") throw TypeError(".Element.arrowDataFrame: object expected");
      e.arrowDataFrame = $root$1.Arrow.fromObject(E.arrowDataFrame);
    }
    if (E.arrowTable != null) {
      if (typeof E.arrowTable != "object") throw TypeError(".Element.arrowTable: object expected");
      e.arrowTable = $root$1.Arrow.fromObject(E.arrowTable);
    }
    if (E.arrowVegaLiteChart != null) {
      if (typeof E.arrowVegaLiteChart != "object") throw TypeError(".Element.arrowVegaLiteChart: object expected");
      e.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.fromObject(E.arrowVegaLiteChart);
    }
    if (E.audio != null) {
      if (typeof E.audio != "object") throw TypeError(".Element.audio: object expected");
      e.audio = $root$1.Audio.fromObject(E.audio);
    }
    if (E.audioInput != null) {
      if (typeof E.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
      e.audioInput = $root$1.AudioInput.fromObject(E.audioInput);
    }
    if (E.balloons != null) {
      if (typeof E.balloons != "object") throw TypeError(".Element.balloons: object expected");
      e.balloons = $root$1.Balloons.fromObject(E.balloons);
    }
    if (E.bidiComponent != null) {
      if (typeof E.bidiComponent != "object") throw TypeError(".Element.bidiComponent: object expected");
      e.bidiComponent = $root$1.BidiComponent.fromObject(E.bidiComponent);
    }
    if (E.bokehChart != null) {
      if (typeof E.bokehChart != "object") throw TypeError(".Element.bokehChart: object expected");
      e.bokehChart = $root$1.BokehChart.fromObject(E.bokehChart);
    }
    if (E.button != null) {
      if (typeof E.button != "object") throw TypeError(".Element.button: object expected");
      e.button = $root$1.Button.fromObject(E.button);
    }
    if (E.buttonGroup != null) {
      if (typeof E.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
      e.buttonGroup = $root$1.ButtonGroup.fromObject(E.buttonGroup);
    }
    if (E.downloadButton != null) {
      if (typeof E.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
      e.downloadButton = $root$1.DownloadButton.fromObject(E.downloadButton);
    }
    if (E.cameraInput != null) {
      if (typeof E.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
      e.cameraInput = $root$1.CameraInput.fromObject(E.cameraInput);
    }
    if (E.chatInput != null) {
      if (typeof E.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
      e.chatInput = $root$1.ChatInput.fromObject(E.chatInput);
    }
    if (E.checkbox != null) {
      if (typeof E.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
      e.checkbox = $root$1.Checkbox.fromObject(E.checkbox);
    }
    if (E.colorPicker != null) {
      if (typeof E.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
      e.colorPicker = $root$1.ColorPicker.fromObject(E.colorPicker);
    }
    if (E.componentInstance != null) {
      if (typeof E.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
      e.componentInstance = $root$1.ComponentInstance.fromObject(E.componentInstance);
    }
    if (E.dataFrame != null) {
      if (typeof E.dataFrame != "object") throw TypeError(".Element.dataFrame: object expected");
      e.dataFrame = $root$1.DataFrame.fromObject(E.dataFrame);
    }
    if (E.table != null) {
      if (typeof E.table != "object") throw TypeError(".Element.table: object expected");
      e.table = $root$1.DataFrame.fromObject(E.table);
    }
    if (E.dateInput != null) {
      if (typeof E.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
      e.dateInput = $root$1.DateInput.fromObject(E.dateInput);
    }
    if (E.deckGlJsonChart != null) {
      if (typeof E.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
      e.deckGlJsonChart = $root$1.DeckGlJsonChart.fromObject(E.deckGlJsonChart);
    }
    if (E.docString != null) {
      if (typeof E.docString != "object") throw TypeError(".Element.docString: object expected");
      e.docString = $root$1.DocString.fromObject(E.docString);
    }
    if (E.empty != null) {
      if (typeof E.empty != "object") throw TypeError(".Element.empty: object expected");
      e.empty = $root$1.Empty.fromObject(E.empty);
    }
    if (E.exception != null) {
      if (typeof E.exception != "object") throw TypeError(".Element.exception: object expected");
      e.exception = $root$1.Exception.fromObject(E.exception);
    }
    if (E.favicon != null) {
      if (typeof E.favicon != "object") throw TypeError(".Element.favicon: object expected");
      e.favicon = $root$1.Favicon.fromObject(E.favicon);
    }
    if (E.fileUploader != null) {
      if (typeof E.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
      e.fileUploader = $root$1.FileUploader.fromObject(E.fileUploader);
    }
    if (E.graphvizChart != null) {
      if (typeof E.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
      e.graphvizChart = $root$1.GraphVizChart.fromObject(E.graphvizChart);
    }
    if (E.html != null) {
      if (typeof E.html != "object") throw TypeError(".Element.html: object expected");
      e.html = $root$1.Html.fromObject(E.html);
    }
    if (E.iframe != null) {
      if (typeof E.iframe != "object") throw TypeError(".Element.iframe: object expected");
      e.iframe = $root$1.IFrame.fromObject(E.iframe);
    }
    if (E.imgs != null) {
      if (typeof E.imgs != "object") throw TypeError(".Element.imgs: object expected");
      e.imgs = $root$1.ImageList.fromObject(E.imgs);
    }
    if (E.json != null) {
      if (typeof E.json != "object") throw TypeError(".Element.json: object expected");
      e.json = $root$1.Json.fromObject(E.json);
    }
    if (E.linkButton != null) {
      if (typeof E.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
      e.linkButton = $root$1.LinkButton.fromObject(E.linkButton);
    }
    if (E.markdown != null) {
      if (typeof E.markdown != "object") throw TypeError(".Element.markdown: object expected");
      e.markdown = $root$1.Markdown.fromObject(E.markdown);
    }
    if (E.metric != null) {
      if (typeof E.metric != "object") throw TypeError(".Element.metric: object expected");
      e.metric = $root$1.Metric.fromObject(E.metric);
    }
    if (E.multiselect != null) {
      if (typeof E.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
      e.multiselect = $root$1.MultiSelect.fromObject(E.multiselect);
    }
    if (E.numberInput != null) {
      if (typeof E.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
      e.numberInput = $root$1.NumberInput.fromObject(E.numberInput);
    }
    if (E.pageLink != null) {
      if (typeof E.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
      e.pageLink = $root$1.PageLink.fromObject(E.pageLink);
    }
    if (E.plotlyChart != null) {
      if (typeof E.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
      e.plotlyChart = $root$1.PlotlyChart.fromObject(E.plotlyChart);
    }
    if (E.progress != null) {
      if (typeof E.progress != "object") throw TypeError(".Element.progress: object expected");
      e.progress = $root$1.Progress.fromObject(E.progress);
    }
    if (E.radio != null) {
      if (typeof E.radio != "object") throw TypeError(".Element.radio: object expected");
      e.radio = $root$1.Radio.fromObject(E.radio);
    }
    if (E.selectbox != null) {
      if (typeof E.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
      e.selectbox = $root$1.Selectbox.fromObject(E.selectbox);
    }
    if (E.skeleton != null) {
      if (typeof E.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
      e.skeleton = $root$1.Skeleton.fromObject(E.skeleton);
    }
    if (E.slider != null) {
      if (typeof E.slider != "object") throw TypeError(".Element.slider: object expected");
      e.slider = $root$1.Slider.fromObject(E.slider);
    }
    if (E.snow != null) {
      if (typeof E.snow != "object") throw TypeError(".Element.snow: object expected");
      e.snow = $root$1.Snow.fromObject(E.snow);
    }
    if (E.space != null) {
      if (typeof E.space != "object") throw TypeError(".Element.space: object expected");
      e.space = $root$1.Space.fromObject(E.space);
    }
    if (E.spinner != null) {
      if (typeof E.spinner != "object") throw TypeError(".Element.spinner: object expected");
      e.spinner = $root$1.Spinner.fromObject(E.spinner);
    }
    if (E.text != null) {
      if (typeof E.text != "object") throw TypeError(".Element.text: object expected");
      e.text = $root$1.Text.fromObject(E.text);
    }
    if (E.textArea != null) {
      if (typeof E.textArea != "object") throw TypeError(".Element.textArea: object expected");
      e.textArea = $root$1.TextArea.fromObject(E.textArea);
    }
    if (E.textInput != null) {
      if (typeof E.textInput != "object") throw TypeError(".Element.textInput: object expected");
      e.textInput = $root$1.TextInput.fromObject(E.textInput);
    }
    if (E.timeInput != null) {
      if (typeof E.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
      e.timeInput = $root$1.TimeInput.fromObject(E.timeInput);
    }
    if (E.dateTimeInput != null) {
      if (typeof E.dateTimeInput != "object") throw TypeError(".Element.dateTimeInput: object expected");
      e.dateTimeInput = $root$1.DateTimeInput.fromObject(E.dateTimeInput);
    }
    if (E.toast != null) {
      if (typeof E.toast != "object") throw TypeError(".Element.toast: object expected");
      e.toast = $root$1.Toast.fromObject(E.toast);
    }
    if (E.vegaLiteChart != null) {
      if (typeof E.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
      e.vegaLiteChart = $root$1.VegaLiteChart.fromObject(E.vegaLiteChart);
    }
    if (E.video != null) {
      if (typeof E.video != "object") throw TypeError(".Element.video: object expected");
      e.video = $root$1.Video.fromObject(E.video);
    }
    if (E.heading != null) {
      if (typeof E.heading != "object") throw TypeError(".Element.heading: object expected");
      e.heading = $root$1.Heading.fromObject(E.heading);
    }
    if (E.code != null) {
      if (typeof E.code != "object") throw TypeError(".Element.code: object expected");
      e.code = $root$1.Code.fromObject(E.code);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return E.text != null && E.hasOwnProperty("text") && (t.text = $root$1.Text.toObject(E.text, e), e.oneofs && (t.type = "text")), E.empty != null && E.hasOwnProperty("empty") && (t.empty = $root$1.Empty.toObject(E.empty, e), e.oneofs && (t.type = "empty")), E.dataFrame != null && E.hasOwnProperty("dataFrame") && (t.dataFrame = $root$1.DataFrame.toObject(E.dataFrame, e), e.oneofs && (t.type = "dataFrame")), E.progress != null && E.hasOwnProperty("progress") && (t.progress = $root$1.Progress.toObject(E.progress, e), e.oneofs && (t.type = "progress")), E.imgs != null && E.hasOwnProperty("imgs") && (t.imgs = $root$1.ImageList.toObject(E.imgs, e), e.oneofs && (t.type = "imgs")), E.docString != null && E.hasOwnProperty("docString") && (t.docString = $root$1.DocString.toObject(E.docString, e), e.oneofs && (t.type = "docString")), E.exception != null && E.hasOwnProperty("exception") && (t.exception = $root$1.Exception.toObject(E.exception, e), e.oneofs && (t.type = "exception")), E.vegaLiteChart != null && E.hasOwnProperty("vegaLiteChart") && (t.vegaLiteChart = $root$1.VegaLiteChart.toObject(E.vegaLiteChart, e), e.oneofs && (t.type = "vegaLiteChart")), E.table != null && E.hasOwnProperty("table") && (t.table = $root$1.DataFrame.toObject(E.table, e), e.oneofs && (t.type = "table")), E.balloons != null && E.hasOwnProperty("balloons") && (t.balloons = $root$1.Balloons.toObject(E.balloons, e), e.oneofs && (t.type = "balloons")), E.audio != null && E.hasOwnProperty("audio") && (t.audio = $root$1.Audio.toObject(E.audio, e), e.oneofs && (t.type = "audio")), E.video != null && E.hasOwnProperty("video") && (t.video = $root$1.Video.toObject(E.video, e), e.oneofs && (t.type = "video")), E.plotlyChart != null && E.hasOwnProperty("plotlyChart") && (t.plotlyChart = $root$1.PlotlyChart.toObject(E.plotlyChart, e), e.oneofs && (t.type = "plotlyChart")), E.bokehChart != null && E.hasOwnProperty("bokehChart") && (t.bokehChart = $root$1.BokehChart.toObject(E.bokehChart, e), e.oneofs && (t.type = "bokehChart")), E.graphvizChart != null && E.hasOwnProperty("graphvizChart") && (t.graphvizChart = $root$1.GraphVizChart.toObject(E.graphvizChart, e), e.oneofs && (t.type = "graphvizChart")), E.button != null && E.hasOwnProperty("button") && (t.button = $root$1.Button.toObject(E.button, e), e.oneofs && (t.type = "button")), E.checkbox != null && E.hasOwnProperty("checkbox") && (t.checkbox = $root$1.Checkbox.toObject(E.checkbox, e), e.oneofs && (t.type = "checkbox")), E.slider != null && E.hasOwnProperty("slider") && (t.slider = $root$1.Slider.toObject(E.slider, e), e.oneofs && (t.type = "slider")), E.textArea != null && E.hasOwnProperty("textArea") && (t.textArea = $root$1.TextArea.toObject(E.textArea, e), e.oneofs && (t.type = "textArea")), E.radio != null && E.hasOwnProperty("radio") && (t.radio = $root$1.Radio.toObject(E.radio, e), e.oneofs && (t.type = "radio")), E.textInput != null && E.hasOwnProperty("textInput") && (t.textInput = $root$1.TextInput.toObject(E.textInput, e), e.oneofs && (t.type = "textInput")), E.selectbox != null && E.hasOwnProperty("selectbox") && (t.selectbox = $root$1.Selectbox.toObject(E.selectbox, e), e.oneofs && (t.type = "selectbox")), E.timeInput != null && E.hasOwnProperty("timeInput") && (t.timeInput = $root$1.TimeInput.toObject(E.timeInput, e), e.oneofs && (t.type = "timeInput")), E.dateInput != null && E.hasOwnProperty("dateInput") && (t.dateInput = $root$1.DateInput.toObject(E.dateInput, e), e.oneofs && (t.type = "dateInput")), E.multiselect != null && E.hasOwnProperty("multiselect") && (t.multiselect = $root$1.MultiSelect.toObject(E.multiselect, e), e.oneofs && (t.type = "multiselect")), E.markdown != null && E.hasOwnProperty("markdown") && (t.markdown = $root$1.Markdown.toObject(E.markdown, e), e.oneofs && (t.type = "markdown")), E.alert != null && E.hasOwnProperty("alert") && (t.alert = $root$1.Alert.toObject(E.alert, e), e.oneofs && (t.type = "alert")), E.json != null && E.hasOwnProperty("json") && (t.json = $root$1.Json.toObject(E.json, e), e.oneofs && (t.type = "json")), E.numberInput != null && E.hasOwnProperty("numberInput") && (t.numberInput = $root$1.NumberInput.toObject(E.numberInput, e), e.oneofs && (t.type = "numberInput")), E.fileUploader != null && E.hasOwnProperty("fileUploader") && (t.fileUploader = $root$1.FileUploader.toObject(E.fileUploader, e), e.oneofs && (t.type = "fileUploader")), E.deckGlJsonChart != null && E.hasOwnProperty("deckGlJsonChart") && (t.deckGlJsonChart = $root$1.DeckGlJsonChart.toObject(E.deckGlJsonChart, e), e.oneofs && (t.type = "deckGlJsonChart")), E.colorPicker != null && E.hasOwnProperty("colorPicker") && (t.colorPicker = $root$1.ColorPicker.toObject(E.colorPicker, e), e.oneofs && (t.type = "colorPicker")), E.favicon != null && E.hasOwnProperty("favicon") && (t.favicon = $root$1.Favicon.toObject(E.favicon, e), e.oneofs && (t.type = "favicon")), E.componentInstance != null && E.hasOwnProperty("componentInstance") && (t.componentInstance = $root$1.ComponentInstance.toObject(E.componentInstance, e), e.oneofs && (t.type = "componentInstance")), E.iframe != null && E.hasOwnProperty("iframe") && (t.iframe = $root$1.IFrame.toObject(E.iframe, e), e.oneofs && (t.type = "iframe")), E.arrowTable != null && E.hasOwnProperty("arrowTable") && (t.arrowTable = $root$1.Arrow.toObject(E.arrowTable, e), e.oneofs && (t.type = "arrowTable")), E.arrowDataFrame != null && E.hasOwnProperty("arrowDataFrame") && (t.arrowDataFrame = $root$1.Arrow.toObject(E.arrowDataFrame, e), e.oneofs && (t.type = "arrowDataFrame")), E.arrowVegaLiteChart != null && E.hasOwnProperty("arrowVegaLiteChart") && (t.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.toObject(E.arrowVegaLiteChart, e), e.oneofs && (t.type = "arrowVegaLiteChart")), E.metric != null && E.hasOwnProperty("metric") && (t.metric = $root$1.Metric.toObject(E.metric, e), e.oneofs && (t.type = "metric")), E.downloadButton != null && E.hasOwnProperty("downloadButton") && (t.downloadButton = $root$1.DownloadButton.toObject(E.downloadButton, e), e.oneofs && (t.type = "downloadButton")), E.spinner != null && E.hasOwnProperty("spinner") && (t.spinner = $root$1.Spinner.toObject(E.spinner, e), e.oneofs && (t.type = "spinner")), E.cameraInput != null && E.hasOwnProperty("cameraInput") && (t.cameraInput = $root$1.CameraInput.toObject(E.cameraInput, e), e.oneofs && (t.type = "cameraInput")), E.snow != null && E.hasOwnProperty("snow") && (t.snow = $root$1.Snow.toObject(E.snow, e), e.oneofs && (t.type = "snow")), E.heading != null && E.hasOwnProperty("heading") && (t.heading = $root$1.Heading.toObject(E.heading, e), e.oneofs && (t.type = "heading")), E.code != null && E.hasOwnProperty("code") && (t.code = $root$1.Code.toObject(E.code, e), e.oneofs && (t.type = "code")), E.chatInput != null && E.hasOwnProperty("chatInput") && (t.chatInput = $root$1.ChatInput.toObject(E.chatInput, e), e.oneofs && (t.type = "chatInput")), E.toast != null && E.hasOwnProperty("toast") && (t.toast = $root$1.Toast.toObject(E.toast, e), e.oneofs && (t.type = "toast")), E.linkButton != null && E.hasOwnProperty("linkButton") && (t.linkButton = $root$1.LinkButton.toObject(E.linkButton, e), e.oneofs && (t.type = "linkButton")), E.skeleton != null && E.hasOwnProperty("skeleton") && (t.skeleton = $root$1.Skeleton.toObject(E.skeleton, e), e.oneofs && (t.type = "skeleton")), E.pageLink != null && E.hasOwnProperty("pageLink") && (t.pageLink = $root$1.PageLink.toObject(E.pageLink, e), e.oneofs && (t.type = "pageLink")), E.html != null && E.hasOwnProperty("html") && (t.html = $root$1.Html.toObject(E.html, e), e.oneofs && (t.type = "html")), E.buttonGroup != null && E.hasOwnProperty("buttonGroup") && (t.buttonGroup = $root$1.ButtonGroup.toObject(E.buttonGroup, e), e.oneofs && (t.type = "buttonGroup")), E.audioInput != null && E.hasOwnProperty("audioInput") && (t.audioInput = $root$1.AudioInput.toObject(E.audioInput, e), e.oneofs && (t.type = "audioInput")), E.heightConfig != null && E.hasOwnProperty("heightConfig") && (t.heightConfig = $root$1.streamlit.HeightConfig.toObject(E.heightConfig, e), e.oneofs && (t._heightConfig = "heightConfig")), E.widthConfig != null && E.hasOwnProperty("widthConfig") && (t.widthConfig = $root$1.streamlit.WidthConfig.toObject(E.widthConfig, e), e.oneofs && (t._widthConfig = "widthConfig")), E.bidiComponent != null && E.hasOwnProperty("bidiComponent") && (t.bidiComponent = $root$1.BidiComponent.toObject(E.bidiComponent, e), e.oneofs && (t.type = "bidiComponent")), E.space != null && E.hasOwnProperty("space") && (t.space = $root$1.Space.toObject(E.space, e), e.oneofs && (t.type = "space")), E.textAlignmentConfig != null && E.hasOwnProperty("textAlignmentConfig") && (t.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.toObject(E.textAlignmentConfig, e), e.oneofs && (t._textAlignmentConfig = "textAlignmentConfig")), E.dateTimeInput != null && E.hasOwnProperty("dateTimeInput") && (t.dateTimeInput = $root$1.DateTimeInput.toObject(E.dateTimeInput, e), e.oneofs && (t.type = "dateTimeInput")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Element";
  }, o;
})();
$root$1.DownloadButton = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.url = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.type = "", o.prototype.icon = "", o.prototype.ignoreRerun = !1, o.prototype.deferredFileId = null, o.prototype.shortcut = "", o.prototype.iconPosition = 0;
  let i;
  return Object.defineProperty(o.prototype, "_deferredFileId", { get: $util$1.oneOfGetter(i = ["deferredFileId"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.default), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.formId), E.url != null && Object.hasOwnProperty.call(E, "url") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.url), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.disabled), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.useContainerWidth), E.type != null && Object.hasOwnProperty.call(E, "type") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.type), E.icon != null && Object.hasOwnProperty.call(E, "icon") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.icon), E.ignoreRerun != null && Object.hasOwnProperty.call(E, "ignoreRerun") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(E.ignoreRerun), E.deferredFileId != null && Object.hasOwnProperty.call(E, "deferredFileId") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(E.deferredFileId), E.shortcut != null && Object.hasOwnProperty.call(E, "shortcut") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.shortcut), E.iconPosition != null && Object.hasOwnProperty.call(E, "iconPosition") && e.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(E.iconPosition), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.DownloadButton();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.default = E.bool();
          break;
        }
        case 4: {
          h.help = E.string();
          break;
        }
        case 5: {
          h.formId = E.string();
          break;
        }
        case 6: {
          h.url = E.string();
          break;
        }
        case 7: {
          h.disabled = E.bool();
          break;
        }
        case 8: {
          h.useContainerWidth = E.bool();
          break;
        }
        case 9: {
          h.type = E.string();
          break;
        }
        case 10: {
          h.icon = E.string();
          break;
        }
        case 11: {
          h.ignoreRerun = E.bool();
          break;
        }
        case 12: {
          h.deferredFileId = E.string();
          break;
        }
        case 13: {
          h.shortcut = E.string();
          break;
        }
        case 14: {
          h.iconPosition = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.DownloadButton) return E;
    let e = new $root$1.DownloadButton();
    switch (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.default != null && (e.default = !!E.default), E.help != null && (e.help = String(E.help)), E.formId != null && (e.formId = String(E.formId)), E.url != null && (e.url = String(E.url)), E.disabled != null && (e.disabled = !!E.disabled), E.useContainerWidth != null && (e.useContainerWidth = !!E.useContainerWidth), E.type != null && (e.type = String(E.type)), E.icon != null && (e.icon = String(E.icon)), E.ignoreRerun != null && (e.ignoreRerun = !!E.ignoreRerun), E.deferredFileId != null && (e.deferredFileId = String(E.deferredFileId)), E.shortcut != null && (e.shortcut = String(E.shortcut)), E.iconPosition) {
      default:
        if (typeof E.iconPosition == "number") {
          e.iconPosition = E.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        e.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        e.iconPosition = 1;
        break;
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.default = !1, t.help = "", t.formId = "", t.url = "", t.disabled = !1, t.useContainerWidth = !1, t.type = "", t.icon = "", t.ignoreRerun = !1, t.shortcut = "", t.iconPosition = e.enums === String ? "LEFT" : 0), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.default != null && E.hasOwnProperty("default") && (t.default = E.default), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.url != null && E.hasOwnProperty("url") && (t.url = E.url), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = E.useContainerWidth), E.type != null && E.hasOwnProperty("type") && (t.type = E.type), E.icon != null && E.hasOwnProperty("icon") && (t.icon = E.icon), E.ignoreRerun != null && E.hasOwnProperty("ignoreRerun") && (t.ignoreRerun = E.ignoreRerun), E.deferredFileId != null && E.hasOwnProperty("deferredFileId") && (t.deferredFileId = E.deferredFileId, e.oneofs && (t._deferredFileId = "deferredFileId")), E.shortcut != null && E.hasOwnProperty("shortcut") && (t.shortcut = E.shortcut), E.iconPosition != null && E.hasOwnProperty("iconPosition") && (t.iconPosition = e.enums === String ? $root$1.streamlit.ButtonLikeIconPosition[E.iconPosition] === void 0 ? E.iconPosition : $root$1.streamlit.ButtonLikeIconPosition[E.iconPosition] : E.iconPosition), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DownloadButton";
  }, o;
})();
$root$1.DocString = (() => {
  function o(i) {
    if (this.members = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.docString = "", o.prototype.type = "", o.prototype.name = "", o.prototype.value = "", o.prototype.members = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.docString != null && Object.hasOwnProperty.call(g, "docString") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.docString), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.type), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.name), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.value), g.members != null && g.members.length) for (let e = 0; e < g.members.length; ++e) $root$1.Member.encode(g.members[e], E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DocString();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 3: {
          n.docString = g.string();
          break;
        }
        case 4: {
          n.type = g.string();
          break;
        }
        case 6: {
          n.name = g.string();
          break;
        }
        case 7: {
          n.value = g.string();
          break;
        }
        case 8: {
          n.members && n.members.length || (n.members = []), n.members.push($root$1.Member.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DocString) return g;
    let E = new $root$1.DocString();
    if (g.docString != null && (E.docString = String(g.docString)), g.type != null && (E.type = String(g.type)), g.name != null && (E.name = String(g.name)), g.value != null && (E.value = String(g.value)), g.members) {
      if (!Array.isArray(g.members)) throw TypeError(".DocString.members: array expected");
      E.members = [];
      for (let e = 0; e < g.members.length; ++e) {
        if (typeof g.members[e] != "object") throw TypeError(".DocString.members: object expected");
        E.members[e] = $root$1.Member.fromObject(g.members[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.members = []), E.defaults && (e.docString = "", e.type = "", e.name = "", e.value = ""), g.docString != null && g.hasOwnProperty("docString") && (e.docString = g.docString), g.type != null && g.hasOwnProperty("type") && (e.type = g.type), g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.value != null && g.hasOwnProperty("value") && (e.value = g.value), g.members && g.members.length) {
      e.members = [];
      for (let t = 0; t < g.members.length; ++t) e.members[t] = $root$1.Member.toObject(g.members[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DocString";
  }, o;
})();
$root$1.Member = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.name = "", o.prototype.type = "", o.prototype.value = null, o.prototype.docString = null;
  let i;
  return Object.defineProperty(o.prototype, "contents", { get: $util$1.oneOfGetter(i = ["value", "docString"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.name != null && Object.hasOwnProperty.call(E, "name") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.name), E.type != null && Object.hasOwnProperty.call(E, "type") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.type), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.value), E.docString != null && Object.hasOwnProperty.call(E, "docString") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.docString), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Member();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.name = E.string();
          break;
        }
        case 2: {
          h.type = E.string();
          break;
        }
        case 3: {
          h.value = E.string();
          break;
        }
        case 4: {
          h.docString = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Member) return E;
    let e = new $root$1.Member();
    return E.name != null && (e.name = String(E.name)), E.type != null && (e.type = String(E.type)), E.value != null && (e.value = String(E.value)), E.docString != null && (e.docString = String(E.docString)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.name = "", t.type = ""), E.name != null && E.hasOwnProperty("name") && (t.name = E.name), E.type != null && E.hasOwnProperty("type") && (t.type = E.type), E.value != null && E.hasOwnProperty("value") && (t.value = E.value, e.oneofs && (t.contents = "value")), E.docString != null && E.hasOwnProperty("docString") && (t.docString = E.docString, e.oneofs && (t.contents = "docString")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Member";
  }, o;
})();
$root$1.Empty = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Empty();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    return g instanceof $root$1.Empty ? g : new $root$1.Empty();
  }, o.toObject = function() {
    return {};
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Empty";
  }, o;
})();
$root$1.Exception = (() => {
  function o(i) {
    if (this.stackTrace = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.type = "", o.prototype.message = "", o.prototype.messageIsMarkdown = !1, o.prototype.stackTrace = $util$1.emptyArray, o.prototype.isWarning = !1, o.prototype.widthConfig = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.type), g.message != null && Object.hasOwnProperty.call(g, "message") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.message), g.stackTrace != null && g.stackTrace.length) for (let e = 0; e < g.stackTrace.length; ++e) E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.stackTrace[e]);
    return g.messageIsMarkdown != null && Object.hasOwnProperty.call(g, "messageIsMarkdown") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.messageIsMarkdown), g.isWarning != null && Object.hasOwnProperty.call(g, "isWarning") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.isWarning), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root$1.streamlit.WidthConfig.encode(g.widthConfig, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Exception();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.type = g.string();
          break;
        }
        case 2: {
          n.message = g.string();
          break;
        }
        case 4: {
          n.messageIsMarkdown = g.bool();
          break;
        }
        case 3: {
          n.stackTrace && n.stackTrace.length || (n.stackTrace = []), n.stackTrace.push(g.string());
          break;
        }
        case 5: {
          n.isWarning = g.bool();
          break;
        }
        case 6: {
          n.widthConfig = $root$1.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Exception) return g;
    let E = new $root$1.Exception();
    if (g.type != null && (E.type = String(g.type)), g.message != null && (E.message = String(g.message)), g.messageIsMarkdown != null && (E.messageIsMarkdown = !!g.messageIsMarkdown), g.stackTrace) {
      if (!Array.isArray(g.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
      E.stackTrace = [];
      for (let e = 0; e < g.stackTrace.length; ++e) E.stackTrace[e] = String(g.stackTrace[e]);
    }
    if (g.isWarning != null && (E.isWarning = !!g.isWarning), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
      E.widthConfig = $root$1.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.stackTrace = []), E.defaults && (e.type = "", e.message = "", e.messageIsMarkdown = !1, e.isWarning = !1, e.widthConfig = null), g.type != null && g.hasOwnProperty("type") && (e.type = g.type), g.message != null && g.hasOwnProperty("message") && (e.message = g.message), g.stackTrace && g.stackTrace.length) {
      e.stackTrace = [];
      for (let t = 0; t < g.stackTrace.length; ++t) e.stackTrace[t] = g.stackTrace[t];
    }
    return g.messageIsMarkdown != null && g.hasOwnProperty("messageIsMarkdown") && (e.messageIsMarkdown = g.messageIsMarkdown), g.isWarning != null && g.hasOwnProperty("isWarning") && (e.isWarning = g.isWarning), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (e.widthConfig = $root$1.streamlit.WidthConfig.toObject(g.widthConfig, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Exception";
  }, o;
})();
$root$1.Favicon = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.url = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Favicon();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.url = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Favicon) return g;
    let E = new $root$1.Favicon();
    return g.url != null && (E.url = String(g.url)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.url = ""), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Favicon";
  }, o;
})();
$root$1.FileUploader = (() => {
  function o(i) {
    if (this.type = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.type = $util$1.emptyArray, o.prototype.maxUploadSizeMb = 0, o.prototype.multipleFiles = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.acceptDirectory = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.type != null && g.type.length) for (let e = 0; e < g.type.length; ++e) E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.type[e]);
    return g.maxUploadSizeMb != null && Object.hasOwnProperty.call(g, "maxUploadSizeMb") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.maxUploadSizeMb), g.multipleFiles != null && Object.hasOwnProperty.call(g, "multipleFiles") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.multipleFiles), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.formId), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.acceptDirectory != null && Object.hasOwnProperty.call(g, "acceptDirectory") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.acceptDirectory), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.FileUploader();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.type && n.type.length || (n.type = []), n.type.push(g.string());
          break;
        }
        case 4: {
          n.maxUploadSizeMb = g.int32();
          break;
        }
        case 6: {
          n.multipleFiles = g.bool();
          break;
        }
        case 7: {
          n.help = g.string();
          break;
        }
        case 8: {
          n.formId = g.string();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.acceptDirectory = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.FileUploader) return g;
    let E = new $root$1.FileUploader();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.type) {
      if (!Array.isArray(g.type)) throw TypeError(".FileUploader.type: array expected");
      E.type = [];
      for (let e = 0; e < g.type.length; ++e) E.type[e] = String(g.type[e]);
    }
    if (g.maxUploadSizeMb != null && (E.maxUploadSizeMb = g.maxUploadSizeMb | 0), g.multipleFiles != null && (E.multipleFiles = !!g.multipleFiles), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
      E.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.acceptDirectory != null && (E.acceptDirectory = !!g.acceptDirectory), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.type = []), E.defaults && (e.id = "", e.label = "", e.maxUploadSizeMb = 0, e.multipleFiles = !1, e.help = "", e.formId = "", e.disabled = !1, e.labelVisibility = null, e.acceptDirectory = !1), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.type && g.type.length) {
      e.type = [];
      for (let t = 0; t < g.type.length; ++t) e.type[t] = g.type[t];
    }
    return g.maxUploadSizeMb != null && g.hasOwnProperty("maxUploadSizeMb") && (e.maxUploadSizeMb = g.maxUploadSizeMb), g.multipleFiles != null && g.hasOwnProperty("multipleFiles") && (e.multipleFiles = g.multipleFiles), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.acceptDirectory != null && g.hasOwnProperty("acceptDirectory") && (e.acceptDirectory = g.acceptDirectory), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileUploader";
  }, o;
})();
$root$1.GraphVizChart = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.spec = "", o.prototype.useContainerWidth = !1, o.prototype.elementId = "", o.prototype.engine = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.spec != null && Object.hasOwnProperty.call(g, "spec") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.spec), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.useContainerWidth), g.elementId != null && Object.hasOwnProperty.call(g, "elementId") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.elementId), g.engine != null && Object.hasOwnProperty.call(g, "engine") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.engine), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.GraphVizChart();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.spec = g.string();
          break;
        }
        case 4: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 5: {
          n.elementId = g.string();
          break;
        }
        case 6: {
          n.engine = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.GraphVizChart) return g;
    let E = new $root$1.GraphVizChart();
    return g.spec != null && (E.spec = String(g.spec)), g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.elementId != null && (E.elementId = String(g.elementId)), g.engine != null && (E.engine = String(g.engine)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.spec = "", e.useContainerWidth = !1, e.elementId = "", e.engine = ""), g.spec != null && g.hasOwnProperty("spec") && (e.spec = g.spec), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.elementId != null && g.hasOwnProperty("elementId") && (e.elementId = g.elementId), g.engine != null && g.hasOwnProperty("engine") && (e.engine = g.engine), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/GraphVizChart";
  }, o;
})();
$root$1.Html = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.body = "", o.prototype.unsafeAllowJavascript = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.unsafeAllowJavascript != null && Object.hasOwnProperty.call(g, "unsafeAllowJavascript") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.unsafeAllowJavascript), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Html();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.body = g.string();
          break;
        }
        case 2: {
          n.unsafeAllowJavascript = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Html) return g;
    let E = new $root$1.Html();
    return g.body != null && (E.body = String(g.body)), g.unsafeAllowJavascript != null && (E.unsafeAllowJavascript = !!g.unsafeAllowJavascript), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.body = "", e.unsafeAllowJavascript = !1), g.body != null && g.hasOwnProperty("body") && (e.body = g.body), g.unsafeAllowJavascript != null && g.hasOwnProperty("unsafeAllowJavascript") && (e.unsafeAllowJavascript = g.unsafeAllowJavascript), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Html";
  }, o;
})();
$root$1.IFrame = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.src = null, o.prototype.srcdoc = null, o.prototype.width = 0, o.prototype.hasWidth = !1, o.prototype.height = 0, o.prototype.scrolling = !1, o.prototype.tabIndex = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["src", "srcdoc"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_tabIndex", { get: $util$1.oneOfGetter(i = ["tabIndex"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.src != null && Object.hasOwnProperty.call(E, "src") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.src), E.srcdoc != null && Object.hasOwnProperty.call(E, "srcdoc") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.srcdoc), E.width != null && Object.hasOwnProperty.call(E, "width") && e.uint32(
      /* id 3, wireType 5 =*/
      29
    ).float(E.width), E.hasWidth != null && Object.hasOwnProperty.call(E, "hasWidth") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.hasWidth), E.height != null && Object.hasOwnProperty.call(E, "height") && e.uint32(
      /* id 5, wireType 5 =*/
      45
    ).float(E.height), E.scrolling != null && Object.hasOwnProperty.call(E, "scrolling") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.scrolling), E.tabIndex != null && Object.hasOwnProperty.call(E, "tabIndex") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(E.tabIndex), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.IFrame();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.src = E.string();
          break;
        }
        case 2: {
          h.srcdoc = E.string();
          break;
        }
        case 3: {
          h.width = E.float();
          break;
        }
        case 4: {
          h.hasWidth = E.bool();
          break;
        }
        case 5: {
          h.height = E.float();
          break;
        }
        case 7: {
          h.scrolling = E.bool();
          break;
        }
        case 8: {
          h.tabIndex = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.IFrame) return E;
    let e = new $root$1.IFrame();
    return E.src != null && (e.src = String(E.src)), E.srcdoc != null && (e.srcdoc = String(E.srcdoc)), E.width != null && (e.width = Number(E.width)), E.hasWidth != null && (e.hasWidth = !!E.hasWidth), E.height != null && (e.height = Number(E.height)), E.scrolling != null && (e.scrolling = !!E.scrolling), E.tabIndex != null && (e.tabIndex = E.tabIndex | 0), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.width = 0, t.hasWidth = !1, t.height = 0, t.scrolling = !1), E.src != null && E.hasOwnProperty("src") && (t.src = E.src, e.oneofs && (t.type = "src")), E.srcdoc != null && E.hasOwnProperty("srcdoc") && (t.srcdoc = E.srcdoc, e.oneofs && (t.type = "srcdoc")), E.width != null && E.hasOwnProperty("width") && (t.width = e.json && !isFinite(E.width) ? String(E.width) : E.width), E.hasWidth != null && E.hasOwnProperty("hasWidth") && (t.hasWidth = E.hasWidth), E.height != null && E.hasOwnProperty("height") && (t.height = e.json && !isFinite(E.height) ? String(E.height) : E.height), E.scrolling != null && E.hasOwnProperty("scrolling") && (t.scrolling = E.scrolling), E.tabIndex != null && E.hasOwnProperty("tabIndex") && (t.tabIndex = E.tabIndex, e.oneofs && (t._tabIndex = "tabIndex")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/IFrame";
  }, o;
})();
$root$1.Image = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.url = "", o.prototype.caption = "", o.prototype.markup = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.caption != null && Object.hasOwnProperty.call(g, "caption") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.caption), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.url), g.markup != null && Object.hasOwnProperty.call(g, "markup") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.markup), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Image();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 3: {
          n.url = g.string();
          break;
        }
        case 2: {
          n.caption = g.string();
          break;
        }
        case 4: {
          n.markup = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Image) return g;
    let E = new $root$1.Image();
    return g.url != null && (E.url = String(g.url)), g.caption != null && (E.caption = String(g.caption)), g.markup != null && (E.markup = String(g.markup)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.caption = "", e.url = "", e.markup = ""), g.caption != null && g.hasOwnProperty("caption") && (e.caption = g.caption), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), g.markup != null && g.hasOwnProperty("markup") && (e.markup = g.markup), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Image";
  }, o;
})();
$root$1.ImageList = (() => {
  function o(i) {
    if (this.imgs = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.imgs = $util$1.emptyArray, o.prototype.width = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.imgs != null && g.imgs.length) for (let e = 0; e < g.imgs.length; ++e) $root$1.Image.encode(g.imgs[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g.width != null && Object.hasOwnProperty.call(g, "width") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.width), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ImageList();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.imgs && n.imgs.length || (n.imgs = []), n.imgs.push($root$1.Image.decode(g, g.uint32()));
          break;
        }
        case 2: {
          n.width = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ImageList) return g;
    let E = new $root$1.ImageList();
    if (g.imgs) {
      if (!Array.isArray(g.imgs)) throw TypeError(".ImageList.imgs: array expected");
      E.imgs = [];
      for (let e = 0; e < g.imgs.length; ++e) {
        if (typeof g.imgs[e] != "object") throw TypeError(".ImageList.imgs: object expected");
        E.imgs[e] = $root$1.Image.fromObject(g.imgs[e]);
      }
    }
    return g.width != null && (E.width = g.width | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.imgs = []), E.defaults && (e.width = 0), g.imgs && g.imgs.length) {
      e.imgs = [];
      for (let t = 0; t < g.imgs.length; ++t) e.imgs[t] = $root$1.Image.toObject(g.imgs[t], E);
    }
    return g.width != null && g.hasOwnProperty("width") && (e.width = g.width), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ImageList";
  }, o;
})();
$root$1.Json = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.body = "", o.prototype.expanded = !1, o.prototype.maxExpandDepth = null;
  let i;
  return Object.defineProperty(o.prototype, "_maxExpandDepth", { get: $util$1.oneOfGetter(i = ["maxExpandDepth"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.body != null && Object.hasOwnProperty.call(E, "body") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.body), E.expanded != null && Object.hasOwnProperty.call(E, "expanded") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.expanded), E.maxExpandDepth != null && Object.hasOwnProperty.call(E, "maxExpandDepth") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.maxExpandDepth), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Json();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.body = E.string();
          break;
        }
        case 2: {
          h.expanded = E.bool();
          break;
        }
        case 3: {
          h.maxExpandDepth = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Json) return E;
    let e = new $root$1.Json();
    return E.body != null && (e.body = String(E.body)), E.expanded != null && (e.expanded = !!E.expanded), E.maxExpandDepth != null && (e.maxExpandDepth = E.maxExpandDepth | 0), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.body = "", t.expanded = !1), E.body != null && E.hasOwnProperty("body") && (t.body = E.body), E.expanded != null && E.hasOwnProperty("expanded") && (t.expanded = E.expanded), E.maxExpandDepth != null && E.hasOwnProperty("maxExpandDepth") && (t.maxExpandDepth = E.maxExpandDepth, e.oneofs && (t._maxExpandDepth = "maxExpandDepth")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Json";
  }, o;
})();
$root$1.LinkButton = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.url = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.type = "", o.prototype.icon = "", o.prototype.shortcut = "", o.prototype.iconPosition = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.url), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.disabled), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.useContainerWidth), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.type), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.icon), g.shortcut != null && Object.hasOwnProperty.call(g, "shortcut") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.shortcut), g.iconPosition != null && Object.hasOwnProperty.call(g, "iconPosition") && E.uint32(
      /* id 12, wireType 0 =*/
      96
    ).int32(g.iconPosition), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.LinkButton();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.url = g.string();
          break;
        }
        case 7: {
          n.disabled = g.bool();
          break;
        }
        case 8: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 9: {
          n.type = g.string();
          break;
        }
        case 10: {
          n.icon = g.string();
          break;
        }
        case 11: {
          n.shortcut = g.string();
          break;
        }
        case 12: {
          n.iconPosition = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.LinkButton) return g;
    let E = new $root$1.LinkButton();
    switch (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.help != null && (E.help = String(g.help)), g.url != null && (E.url = String(g.url)), g.disabled != null && (E.disabled = !!g.disabled), g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.type != null && (E.type = String(g.type)), g.icon != null && (E.icon = String(g.icon)), g.shortcut != null && (E.shortcut = String(g.shortcut)), g.iconPosition) {
      default:
        if (typeof g.iconPosition == "number") {
          E.iconPosition = g.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        E.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        E.iconPosition = 1;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.help = "", e.url = "", e.disabled = !1, e.useContainerWidth = !1, e.type = "", e.icon = "", e.shortcut = "", e.iconPosition = E.enums === String ? "LEFT" : 0), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.type != null && g.hasOwnProperty("type") && (e.type = g.type), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), g.shortcut != null && g.hasOwnProperty("shortcut") && (e.shortcut = g.shortcut), g.iconPosition != null && g.hasOwnProperty("iconPosition") && (e.iconPosition = E.enums === String ? $root$1.streamlit.ButtonLikeIconPosition[g.iconPosition] === void 0 ? g.iconPosition : $root$1.streamlit.ButtonLikeIconPosition[g.iconPosition] : g.iconPosition), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/LinkButton";
  }, o;
})();
const NumberInput$1 = $root$1.NumberInput = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.formId = "", o.prototype.format = "", o.prototype.hasMin = !1, o.prototype.hasMax = !1, o.prototype.dataType = 0, o.prototype.default = null, o.prototype.step = 0, o.prototype.min = 0, o.prototype.max = 0, o.prototype.help = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.placeholder = "", o.prototype.icon = "";
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(i = ["default"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(i = ["value"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.formId), E.format != null && Object.hasOwnProperty.call(E, "format") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.format), E.hasMin != null && Object.hasOwnProperty.call(E, "hasMin") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(E.hasMin), E.hasMax != null && Object.hasOwnProperty.call(E, "hasMax") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(E.hasMax), E.dataType != null && Object.hasOwnProperty.call(E, "dataType") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(E.dataType), E.default != null && Object.hasOwnProperty.call(E, "default") && e.uint32(
      /* id 14, wireType 1 =*/
      113
    ).double(E.default), E.step != null && Object.hasOwnProperty.call(E, "step") && e.uint32(
      /* id 15, wireType 1 =*/
      121
    ).double(E.step), E.min != null && Object.hasOwnProperty.call(E, "min") && e.uint32(
      /* id 16, wireType 1 =*/
      129
    ).double(E.min), E.max != null && Object.hasOwnProperty.call(E, "max") && e.uint32(
      /* id 17, wireType 1 =*/
      137
    ).double(E.max), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(E.help), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
      /* id 19, wireType 1 =*/
      153
    ).double(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 21, wireType 0 =*/
      168
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), E.placeholder != null && Object.hasOwnProperty.call(E, "placeholder") && e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).string(E.placeholder), E.icon != null && Object.hasOwnProperty.call(E, "icon") && e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).string(E.icon), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.NumberInput();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.formId = E.string();
          break;
        }
        case 8: {
          h.format = E.string();
          break;
        }
        case 11: {
          h.hasMin = E.bool();
          break;
        }
        case 12: {
          h.hasMax = E.bool();
          break;
        }
        case 13: {
          h.dataType = E.int32();
          break;
        }
        case 14: {
          h.default = E.double();
          break;
        }
        case 15: {
          h.step = E.double();
          break;
        }
        case 16: {
          h.min = E.double();
          break;
        }
        case 17: {
          h.max = E.double();
          break;
        }
        case 18: {
          h.help = E.string();
          break;
        }
        case 19: {
          h.value = E.double();
          break;
        }
        case 20: {
          h.setValue = E.bool();
          break;
        }
        case 21: {
          h.disabled = E.bool();
          break;
        }
        case 22: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 23: {
          h.placeholder = E.string();
          break;
        }
        case 24: {
          h.icon = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.NumberInput) return E;
    let e = new $root$1.NumberInput();
    switch (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.formId != null && (e.formId = String(E.formId)), E.format != null && (e.format = String(E.format)), E.hasMin != null && (e.hasMin = !!E.hasMin), E.hasMax != null && (e.hasMax = !!E.hasMax), E.dataType) {
      default:
        if (typeof E.dataType == "number") {
          e.dataType = E.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        e.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        e.dataType = 1;
        break;
    }
    if (E.default != null && (e.default = Number(E.default)), E.step != null && (e.step = Number(E.step)), E.min != null && (e.min = Number(E.min)), E.max != null && (e.max = Number(E.max)), E.help != null && (e.help = String(E.help)), E.value != null && (e.value = Number(E.value)), E.setValue != null && (e.setValue = !!E.setValue), E.disabled != null && (e.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.placeholder != null && (e.placeholder = String(E.placeholder)), E.icon != null && (e.icon = String(E.icon)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.formId = "", t.format = "", t.hasMin = !1, t.hasMax = !1, t.dataType = e.enums === String ? "INT" : 0, t.step = 0, t.min = 0, t.max = 0, t.help = "", t.setValue = !1, t.disabled = !1, t.labelVisibility = null, t.placeholder = "", t.icon = ""), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.format != null && E.hasOwnProperty("format") && (t.format = E.format), E.hasMin != null && E.hasOwnProperty("hasMin") && (t.hasMin = E.hasMin), E.hasMax != null && E.hasOwnProperty("hasMax") && (t.hasMax = E.hasMax), E.dataType != null && E.hasOwnProperty("dataType") && (t.dataType = e.enums === String ? $root$1.NumberInput.DataType[E.dataType] === void 0 ? E.dataType : $root$1.NumberInput.DataType[E.dataType] : E.dataType), E.default != null && E.hasOwnProperty("default") && (t.default = e.json && !isFinite(E.default) ? String(E.default) : E.default, e.oneofs && (t._default = "default")), E.step != null && E.hasOwnProperty("step") && (t.step = e.json && !isFinite(E.step) ? String(E.step) : E.step), E.min != null && E.hasOwnProperty("min") && (t.min = e.json && !isFinite(E.min) ? String(E.min) : E.min), E.max != null && E.hasOwnProperty("max") && (t.max = e.json && !isFinite(E.max) ? String(E.max) : E.max), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.value != null && E.hasOwnProperty("value") && (t.value = e.json && !isFinite(E.value) ? String(E.value) : E.value, e.oneofs && (t._value = "value")), E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), E.placeholder != null && E.hasOwnProperty("placeholder") && (t.placeholder = E.placeholder), E.icon != null && E.hasOwnProperty("icon") && (t.icon = E.icon), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/NumberInput";
  }, o.DataType = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "INT"] = 0, E[g[1] = "FLOAT"] = 1, E;
  })(), o;
})(), Markdown$3 = $root$1.Markdown = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.body = "", o.prototype.allowHtml = !1, o.prototype.isCaption = !1, o.prototype.elementType = 0, o.prototype.help = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.allowHtml != null && Object.hasOwnProperty.call(g, "allowHtml") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.allowHtml), g.isCaption != null && Object.hasOwnProperty.call(g, "isCaption") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.isCaption), g.elementType != null && Object.hasOwnProperty.call(g, "elementType") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.elementType), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Markdown();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.body = g.string();
          break;
        }
        case 2: {
          n.allowHtml = g.bool();
          break;
        }
        case 3: {
          n.isCaption = g.bool();
          break;
        }
        case 4: {
          n.elementType = g.int32();
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Markdown) return g;
    let E = new $root$1.Markdown();
    switch (g.body != null && (E.body = String(g.body)), g.allowHtml != null && (E.allowHtml = !!g.allowHtml), g.isCaption != null && (E.isCaption = !!g.isCaption), g.elementType) {
      default:
        if (typeof g.elementType == "number") {
          E.elementType = g.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        E.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        E.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        E.elementType = 2;
        break;
      case "CODE":
      case 3:
        E.elementType = 3;
        break;
      case "LATEX":
      case 4:
        E.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        E.elementType = 5;
        break;
    }
    return g.help != null && (E.help = String(g.help)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.body = "", e.allowHtml = !1, e.isCaption = !1, e.elementType = E.enums === String ? "UNSPECIFIED" : 0, e.help = ""), g.body != null && g.hasOwnProperty("body") && (e.body = g.body), g.allowHtml != null && g.hasOwnProperty("allowHtml") && (e.allowHtml = g.allowHtml), g.isCaption != null && g.hasOwnProperty("isCaption") && (e.isCaption = g.isCaption), g.elementType != null && g.hasOwnProperty("elementType") && (e.elementType = E.enums === String ? $root$1.Markdown.Type[g.elementType] === void 0 ? g.elementType : $root$1.Markdown.Type[g.elementType] : g.elementType), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Markdown";
  }, o.Type = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "UNSPECIFIED"] = 0, g[i[1] = "NATIVE"] = 1, g[i[2] = "CAPTION"] = 2, g[i[3] = "CODE"] = 3, g[i[4] = "LATEX"] = 4, g[i[5] = "DIVIDER"] = 5, g;
  })(), o;
})(), Metric$1 = $root$1.Metric = (() => {
  function o(i) {
    if (this.chartData = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.label = "", o.prototype.body = "", o.prototype.delta = "", o.prototype.direction = 0, o.prototype.color = 0, o.prototype.help = "", o.prototype.labelVisibility = null, o.prototype.showBorder = !1, o.prototype.chartData = $util$1.emptyArray, o.prototype.chartType = 0, o.prototype.format = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.label), g.body != null && Object.hasOwnProperty.call(g, "body") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.body), g.delta != null && Object.hasOwnProperty.call(g, "delta") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.delta), g.direction != null && Object.hasOwnProperty.call(g, "direction") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.direction), g.color != null && Object.hasOwnProperty.call(g, "color") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.color), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.showBorder != null && Object.hasOwnProperty.call(g, "showBorder") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.showBorder), g.chartData != null && g.chartData.length) {
      E.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let e = 0; e < g.chartData.length; ++e) E.double(g.chartData[e]);
      E.ldelim();
    }
    return g.chartType != null && Object.hasOwnProperty.call(g, "chartType") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(g.chartType), g.format != null && Object.hasOwnProperty.call(g, "format") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.format), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Metric();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.label = g.string();
          break;
        }
        case 2: {
          n.body = g.string();
          break;
        }
        case 3: {
          n.delta = g.string();
          break;
        }
        case 4: {
          n.direction = g.int32();
          break;
        }
        case 5: {
          n.color = g.int32();
          break;
        }
        case 6: {
          n.help = g.string();
          break;
        }
        case 7: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.showBorder = g.bool();
          break;
        }
        case 9: {
          if (n.chartData && n.chartData.length || (n.chartData = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.chartData.push(g.double());
          } else n.chartData.push(g.double());
          break;
        }
        case 10: {
          n.chartType = g.int32();
          break;
        }
        case 11: {
          n.format = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Metric) return g;
    let E = new $root$1.Metric();
    switch (g.label != null && (E.label = String(g.label)), g.body != null && (E.body = String(g.body)), g.delta != null && (E.delta = String(g.delta)), g.direction) {
      default:
        if (typeof g.direction == "number") {
          E.direction = g.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        E.direction = 0;
        break;
      case "UP":
      case 1:
        E.direction = 1;
        break;
      case "NONE":
      case 2:
        E.direction = 2;
        break;
    }
    switch (g.color) {
      default:
        if (typeof g.color == "number") {
          E.color = g.color;
          break;
        }
        break;
      case "RED":
      case 0:
        E.color = 0;
        break;
      case "GREEN":
      case 1:
        E.color = 1;
        break;
      case "GRAY":
      case 2:
        E.color = 2;
        break;
      case "ORANGE":
      case 3:
        E.color = 3;
        break;
      case "YELLOW":
      case 4:
        E.color = 4;
        break;
      case "BLUE":
      case 5:
        E.color = 5;
        break;
      case "VIOLET":
      case 6:
        E.color = 6;
        break;
      case "PRIMARY":
      case 7:
        E.color = 7;
        break;
    }
    if (g.help != null && (E.help = String(g.help)), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
      E.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    if (g.showBorder != null && (E.showBorder = !!g.showBorder), g.chartData) {
      if (!Array.isArray(g.chartData)) throw TypeError(".Metric.chartData: array expected");
      E.chartData = [];
      for (let e = 0; e < g.chartData.length; ++e) E.chartData[e] = Number(g.chartData[e]);
    }
    switch (g.chartType) {
      default:
        if (typeof g.chartType == "number") {
          E.chartType = g.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        E.chartType = 0;
        break;
      case "BAR":
      case 1:
        E.chartType = 1;
        break;
      case "AREA":
      case 2:
        E.chartType = 2;
        break;
    }
    return g.format != null && (E.format = String(g.format)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.chartData = []), E.defaults && (e.label = "", e.body = "", e.delta = "", e.direction = E.enums === String ? "DOWN" : 0, e.color = E.enums === String ? "RED" : 0, e.help = "", e.labelVisibility = null, e.showBorder = !1, e.chartType = E.enums === String ? "LINE" : 0, e.format = ""), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.body != null && g.hasOwnProperty("body") && (e.body = g.body), g.delta != null && g.hasOwnProperty("delta") && (e.delta = g.delta), g.direction != null && g.hasOwnProperty("direction") && (e.direction = E.enums === String ? $root$1.Metric.MetricDirection[g.direction] === void 0 ? g.direction : $root$1.Metric.MetricDirection[g.direction] : g.direction), g.color != null && g.hasOwnProperty("color") && (e.color = E.enums === String ? $root$1.Metric.MetricColor[g.color] === void 0 ? g.color : $root$1.Metric.MetricColor[g.color] : g.color), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.showBorder != null && g.hasOwnProperty("showBorder") && (e.showBorder = g.showBorder), g.chartData && g.chartData.length) {
      e.chartData = [];
      for (let t = 0; t < g.chartData.length; ++t) e.chartData[t] = E.json && !isFinite(g.chartData[t]) ? String(g.chartData[t]) : g.chartData[t];
    }
    return g.chartType != null && g.hasOwnProperty("chartType") && (e.chartType = E.enums === String ? $root$1.Metric.ChartType[g.chartType] === void 0 ? g.chartType : $root$1.Metric.ChartType[g.chartType] : g.chartType), g.format != null && g.hasOwnProperty("format") && (e.format = g.format), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Metric";
  }, o.MetricDirection = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "DOWN"] = 0, g[i[1] = "UP"] = 1, g[i[2] = "NONE"] = 2, g;
  })(), o.MetricColor = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "RED"] = 0, g[i[1] = "GREEN"] = 1, g[i[2] = "GRAY"] = 2, g[i[3] = "ORANGE"] = 3, g[i[4] = "YELLOW"] = 4, g[i[5] = "BLUE"] = 5, g[i[6] = "VIOLET"] = 6, g[i[7] = "PRIMARY"] = 7, g;
  })(), o.ChartType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "LINE"] = 0, g[i[1] = "BAR"] = 1, g[i[2] = "AREA"] = 2, g;
  })(), o;
})();
$root$1.MultiSelect = (() => {
  function o(g) {
    if (this.default = [], this.options = [], this.value = [], this.rawValues = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util$1.emptyArray, o.prototype.options = $util$1.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util$1.emptyArray, o.prototype.rawValues = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.maxSelections = 0, o.prototype.placeholder = "", o.prototype.acceptNewOptions = null;
  let i;
  return Object.defineProperty(o.prototype, "_acceptNewOptions", { get: $util$1.oneOfGetter(i = ["acceptNewOptions"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && E.default.length) {
      e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let t = 0; t < E.default.length; ++t) e.int32(E.default[t]);
      e.ldelim();
    }
    if (E.options != null && E.options.length) for (let t = 0; t < E.options.length; ++t) e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.options[t]);
    if (E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.formId), E.value != null && E.value.length) {
      e.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let t = 0; t < E.value.length; ++t) e.int32(E.value[t]);
      e.ldelim();
    }
    if (E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), E.maxSelections != null && Object.hasOwnProperty.call(E, "maxSelections") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(E.maxSelections), E.placeholder != null && Object.hasOwnProperty.call(E, "placeholder") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(E.placeholder), E.acceptNewOptions != null && Object.hasOwnProperty.call(E, "acceptNewOptions") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(E.acceptNewOptions), E.rawValues != null && E.rawValues.length) for (let t = 0; t < E.rawValues.length; ++t) e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(E.rawValues[t]);
    return e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.MultiSelect();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          if (h.default && h.default.length || (h.default = []), (d & 7) === 2) {
            let k = E.uint32() + E.pos;
            for (; E.pos < k; ) h.default.push(E.int32());
          } else h.default.push(E.int32());
          break;
        }
        case 4: {
          h.options && h.options.length || (h.options = []), h.options.push(E.string());
          break;
        }
        case 5: {
          h.help = E.string();
          break;
        }
        case 6: {
          h.formId = E.string();
          break;
        }
        case 7: {
          if (h.value && h.value.length || (h.value = []), (d & 7) === 2) {
            let k = E.uint32() + E.pos;
            for (; E.pos < k; ) h.value.push(E.int32());
          } else h.value.push(E.int32());
          break;
        }
        case 14: {
          h.rawValues && h.rawValues.length || (h.rawValues = []), h.rawValues.push(E.string());
          break;
        }
        case 8: {
          h.setValue = E.bool();
          break;
        }
        case 9: {
          h.disabled = E.bool();
          break;
        }
        case 10: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 11: {
          h.maxSelections = E.int32();
          break;
        }
        case 12: {
          h.placeholder = E.string();
          break;
        }
        case 13: {
          h.acceptNewOptions = E.bool();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.MultiSelect) return E;
    let e = new $root$1.MultiSelect();
    if (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.default) {
      if (!Array.isArray(E.default)) throw TypeError(".MultiSelect.default: array expected");
      e.default = [];
      for (let t = 0; t < E.default.length; ++t) e.default[t] = E.default[t] | 0;
    }
    if (E.options) {
      if (!Array.isArray(E.options)) throw TypeError(".MultiSelect.options: array expected");
      e.options = [];
      for (let t = 0; t < E.options.length; ++t) e.options[t] = String(E.options[t]);
    }
    if (E.help != null && (e.help = String(E.help)), E.formId != null && (e.formId = String(E.formId)), E.value) {
      if (!Array.isArray(E.value)) throw TypeError(".MultiSelect.value: array expected");
      e.value = [];
      for (let t = 0; t < E.value.length; ++t) e.value[t] = E.value[t] | 0;
    }
    if (E.rawValues) {
      if (!Array.isArray(E.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
      e.rawValues = [];
      for (let t = 0; t < E.rawValues.length; ++t) e.rawValues[t] = String(E.rawValues[t]);
    }
    if (E.setValue != null && (e.setValue = !!E.setValue), E.disabled != null && (e.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.maxSelections != null && (e.maxSelections = E.maxSelections | 0), E.placeholder != null && (e.placeholder = String(E.placeholder)), E.acceptNewOptions != null && (e.acceptNewOptions = !!E.acceptNewOptions), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.default = [], t.options = [], t.value = [], t.rawValues = []), e.defaults && (t.id = "", t.label = "", t.help = "", t.formId = "", t.setValue = !1, t.disabled = !1, t.labelVisibility = null, t.maxSelections = 0, t.placeholder = ""), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.default && E.default.length) {
      t.default = [];
      for (let n = 0; n < E.default.length; ++n) t.default[n] = E.default[n];
    }
    if (E.options && E.options.length) {
      t.options = [];
      for (let n = 0; n < E.options.length; ++n) t.options[n] = E.options[n];
    }
    if (E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.value && E.value.length) {
      t.value = [];
      for (let n = 0; n < E.value.length; ++n) t.value[n] = E.value[n];
    }
    if (E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), E.maxSelections != null && E.hasOwnProperty("maxSelections") && (t.maxSelections = E.maxSelections), E.placeholder != null && E.hasOwnProperty("placeholder") && (t.placeholder = E.placeholder), E.acceptNewOptions != null && E.hasOwnProperty("acceptNewOptions") && (t.acceptNewOptions = E.acceptNewOptions, e.oneofs && (t._acceptNewOptions = "acceptNewOptions")), E.rawValues && E.rawValues.length) {
      t.rawValues = [];
      for (let n = 0; n < E.rawValues.length; ++n) t.rawValues[n] = E.rawValues[n];
    }
    return t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/MultiSelect";
  }, o;
})();
$root$1.PageLink = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.page = "", o.prototype.label = "", o.prototype.icon = "", o.prototype.pageScriptHash = "", o.prototype.help = "", o.prototype.useContainerWidth = null, o.prototype.disabled = !1, o.prototype.external = !1, o.prototype.queryString = "", o.prototype.iconPosition = 0;
  let i;
  return Object.defineProperty(o.prototype, "_useContainerWidth", { get: $util$1.oneOfGetter(i = ["useContainerWidth"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.page != null && Object.hasOwnProperty.call(E, "page") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.page), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.icon != null && Object.hasOwnProperty.call(E, "icon") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.icon), E.pageScriptHash != null && Object.hasOwnProperty.call(E, "pageScriptHash") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.pageScriptHash), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.help), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.useContainerWidth), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.disabled), E.external != null && Object.hasOwnProperty.call(E, "external") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.external), E.queryString != null && Object.hasOwnProperty.call(E, "queryString") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.queryString), E.iconPosition != null && Object.hasOwnProperty.call(E, "iconPosition") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(E.iconPosition), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.PageLink();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.page = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.icon = E.string();
          break;
        }
        case 4: {
          h.pageScriptHash = E.string();
          break;
        }
        case 5: {
          h.help = E.string();
          break;
        }
        case 6: {
          h.useContainerWidth = E.bool();
          break;
        }
        case 7: {
          h.disabled = E.bool();
          break;
        }
        case 8: {
          h.external = E.bool();
          break;
        }
        case 9: {
          h.queryString = E.string();
          break;
        }
        case 10: {
          h.iconPosition = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.PageLink) return E;
    let e = new $root$1.PageLink();
    switch (E.page != null && (e.page = String(E.page)), E.label != null && (e.label = String(E.label)), E.icon != null && (e.icon = String(E.icon)), E.pageScriptHash != null && (e.pageScriptHash = String(E.pageScriptHash)), E.help != null && (e.help = String(E.help)), E.useContainerWidth != null && (e.useContainerWidth = !!E.useContainerWidth), E.disabled != null && (e.disabled = !!E.disabled), E.external != null && (e.external = !!E.external), E.queryString != null && (e.queryString = String(E.queryString)), E.iconPosition) {
      default:
        if (typeof E.iconPosition == "number") {
          e.iconPosition = E.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        e.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        e.iconPosition = 1;
        break;
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.page = "", t.label = "", t.icon = "", t.pageScriptHash = "", t.help = "", t.disabled = !1, t.external = !1, t.queryString = "", t.iconPosition = e.enums === String ? "LEFT" : 0), E.page != null && E.hasOwnProperty("page") && (t.page = E.page), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.icon != null && E.hasOwnProperty("icon") && (t.icon = E.icon), E.pageScriptHash != null && E.hasOwnProperty("pageScriptHash") && (t.pageScriptHash = E.pageScriptHash), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = E.useContainerWidth, e.oneofs && (t._useContainerWidth = "useContainerWidth")), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.external != null && E.hasOwnProperty("external") && (t.external = E.external), E.queryString != null && E.hasOwnProperty("queryString") && (t.queryString = E.queryString), E.iconPosition != null && E.hasOwnProperty("iconPosition") && (t.iconPosition = e.enums === String ? $root$1.streamlit.ButtonLikeIconPosition[E.iconPosition] === void 0 ? E.iconPosition : $root$1.streamlit.ButtonLikeIconPosition[E.iconPosition] : E.iconPosition), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PageLink";
  }, o;
})();
const PlotlyChart$1 = $root$1.PlotlyChart = (() => {
  function o(g) {
    if (this.selectionMode = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.useContainerWidth = !1, o.prototype.theme = "", o.prototype.id = "", o.prototype.selectionMode = $util$1.emptyArray, o.prototype.formId = "", o.prototype.spec = "", o.prototype.config = "", o.prototype.url = null, o.prototype.figure = null;
  let i;
  return Object.defineProperty(o.prototype, "chart", { get: $util$1.oneOfGetter(i = ["url", "figure"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.url != null && Object.hasOwnProperty.call(E, "url") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.url), E.figure != null && Object.hasOwnProperty.call(E, "figure") && $root$1.Figure.encode(E.figure, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.useContainerWidth), E.theme != null && Object.hasOwnProperty.call(E, "theme") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.theme), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.id), E.selectionMode != null && E.selectionMode.length) {
      e.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let t = 0; t < E.selectionMode.length; ++t) e.int32(E.selectionMode[t]);
      e.ldelim();
    }
    return E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.formId), E.spec != null && Object.hasOwnProperty.call(E, "spec") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.spec), E.config != null && Object.hasOwnProperty.call(E, "config") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.config), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.PlotlyChart();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 5: {
          h.useContainerWidth = E.bool();
          break;
        }
        case 6: {
          h.theme = E.string();
          break;
        }
        case 7: {
          h.id = E.string();
          break;
        }
        case 8: {
          if (h.selectionMode && h.selectionMode.length || (h.selectionMode = []), (d & 7) === 2) {
            let k = E.uint32() + E.pos;
            for (; E.pos < k; ) h.selectionMode.push(E.int32());
          } else h.selectionMode.push(E.int32());
          break;
        }
        case 9: {
          h.formId = E.string();
          break;
        }
        case 10: {
          h.spec = E.string();
          break;
        }
        case 11: {
          h.config = E.string();
          break;
        }
        case 1: {
          h.url = E.string();
          break;
        }
        case 2: {
          h.figure = $root$1.Figure.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.PlotlyChart) return E;
    let e = new $root$1.PlotlyChart();
    if (E.useContainerWidth != null && (e.useContainerWidth = !!E.useContainerWidth), E.theme != null && (e.theme = String(E.theme)), E.id != null && (e.id = String(E.id)), E.selectionMode) {
      if (!Array.isArray(E.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
      e.selectionMode = [];
      for (let t = 0; t < E.selectionMode.length; ++t) switch (E.selectionMode[t]) {
        default:
          if (typeof E.selectionMode[t] == "number") {
            e.selectionMode[t] = E.selectionMode[t];
            break;
          }
        case "POINTS":
        case 0:
          e.selectionMode[t] = 0;
          break;
        case "BOX":
        case 1:
          e.selectionMode[t] = 1;
          break;
        case "LASSO":
        case 2:
          e.selectionMode[t] = 2;
          break;
      }
    }
    if (E.formId != null && (e.formId = String(E.formId)), E.spec != null && (e.spec = String(E.spec)), E.config != null && (e.config = String(E.config)), E.url != null && (e.url = String(E.url)), E.figure != null) {
      if (typeof E.figure != "object") throw TypeError(".PlotlyChart.figure: object expected");
      e.figure = $root$1.Figure.fromObject(E.figure);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.selectionMode = []), e.defaults && (t.useContainerWidth = !1, t.theme = "", t.id = "", t.formId = "", t.spec = "", t.config = ""), E.url != null && E.hasOwnProperty("url") && (t.url = E.url, e.oneofs && (t.chart = "url")), E.figure != null && E.hasOwnProperty("figure") && (t.figure = $root$1.Figure.toObject(E.figure, e), e.oneofs && (t.chart = "figure")), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = E.useContainerWidth), E.theme != null && E.hasOwnProperty("theme") && (t.theme = E.theme), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.selectionMode && E.selectionMode.length) {
      t.selectionMode = [];
      for (let n = 0; n < E.selectionMode.length; ++n) t.selectionMode[n] = e.enums === String ? $root$1.PlotlyChart.SelectionMode[E.selectionMode[n]] === void 0 ? E.selectionMode[n] : $root$1.PlotlyChart.SelectionMode[E.selectionMode[n]] : E.selectionMode[n];
    }
    return E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.spec != null && E.hasOwnProperty("spec") && (t.spec = E.spec), E.config != null && E.hasOwnProperty("config") && (t.config = E.config), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PlotlyChart";
  }, o.SelectionMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "POINTS"] = 0, E[g[1] = "BOX"] = 1, E[g[2] = "LASSO"] = 2, E;
  })(), o;
})();
$root$1.Figure = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.spec = "", o.prototype.config = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.spec != null && Object.hasOwnProperty.call(g, "spec") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.spec), g.config != null && Object.hasOwnProperty.call(g, "config") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.config), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Figure();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.spec = g.string();
          break;
        }
        case 2: {
          n.config = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Figure) return g;
    let E = new $root$1.Figure();
    return g.spec != null && (E.spec = String(g.spec)), g.config != null && (E.config = String(g.config)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.spec = "", e.config = ""), g.spec != null && g.hasOwnProperty("spec") && (e.spec = g.spec), g.config != null && g.hasOwnProperty("config") && (e.config = g.config), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Figure";
  }, o;
})();
$root$1.Progress = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.value = 0, o.prototype.text = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(g.value), g.text != null && Object.hasOwnProperty.call(g, "text") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.text), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Progress();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.value = g.uint32();
          break;
        }
        case 2: {
          n.text = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Progress) return g;
    let E = new $root$1.Progress();
    return g.value != null && (E.value = g.value >>> 0), g.text != null && (E.text = String(g.text)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.value = 0, e.text = ""), g.value != null && g.hasOwnProperty("value") && (e.value = g.value), g.text != null && g.hasOwnProperty("text") && (e.text = g.text), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Progress";
  }, o;
})();
$root$1.Snow = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.show = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.show != null && Object.hasOwnProperty.call(g, "show") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.show), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Snow();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.show = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Snow) return g;
    let E = new $root$1.Snow();
    return g.show != null && (E.show = !!g.show), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.show = !1), g.show != null && g.hasOwnProperty("show") && (e.show = g.show), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Snow";
  }, o;
})();
$root$1.Spinner = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.text = "", o.prototype.cache = !1, o.prototype.showTime = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.text != null && Object.hasOwnProperty.call(g, "text") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.text), g.cache != null && Object.hasOwnProperty.call(g, "cache") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.cache), g.showTime != null && Object.hasOwnProperty.call(g, "showTime") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.showTime), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Spinner();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.text = g.string();
          break;
        }
        case 2: {
          n.cache = g.bool();
          break;
        }
        case 3: {
          n.showTime = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Spinner) return g;
    let E = new $root$1.Spinner();
    return g.text != null && (E.text = String(g.text)), g.cache != null && (E.cache = !!g.cache), g.showTime != null && (E.showTime = !!g.showTime), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.text = "", e.cache = !1, e.showTime = !1), g.text != null && g.hasOwnProperty("text") && (e.text = g.text), g.cache != null && g.hasOwnProperty("cache") && (e.cache = g.cache), g.showTime != null && g.hasOwnProperty("showTime") && (e.showTime = g.showTime), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Spinner";
  }, o;
})();
$root$1.Radio = (() => {
  function o(g) {
    if (this.options = [], this.captions = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.options = $util$1.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.rawValue = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.horizontal = !1, o.prototype.labelVisibility = null, o.prototype.captions = $util$1.emptyArray;
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(i = ["default"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(i = ["value"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_rawValue", { get: $util$1.oneOfGetter(i = ["rawValue"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.default), E.options != null && E.options.length) for (let t = 0; t < E.options.length; ++t) e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.options[t]);
    if (E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.formId), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.disabled), E.horizontal != null && Object.hasOwnProperty.call(E, "horizontal") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(E.horizontal), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), E.captions != null && E.captions.length) for (let t = 0; t < E.captions.length; ++t) e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(E.captions[t]);
    return E.rawValue != null && Object.hasOwnProperty.call(E, "rawValue") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.rawValue), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Radio();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.default = E.int32();
          break;
        }
        case 4: {
          h.options && h.options.length || (h.options = []), h.options.push(E.string());
          break;
        }
        case 5: {
          h.help = E.string();
          break;
        }
        case 6: {
          h.formId = E.string();
          break;
        }
        case 7: {
          h.value = E.int32();
          break;
        }
        case 13: {
          h.rawValue = E.string();
          break;
        }
        case 8: {
          h.setValue = E.bool();
          break;
        }
        case 9: {
          h.disabled = E.bool();
          break;
        }
        case 10: {
          h.horizontal = E.bool();
          break;
        }
        case 11: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 12: {
          h.captions && h.captions.length || (h.captions = []), h.captions.push(E.string());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Radio) return E;
    let e = new $root$1.Radio();
    if (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.default != null && (e.default = E.default | 0), E.options) {
      if (!Array.isArray(E.options)) throw TypeError(".Radio.options: array expected");
      e.options = [];
      for (let t = 0; t < E.options.length; ++t) e.options[t] = String(E.options[t]);
    }
    if (E.help != null && (e.help = String(E.help)), E.formId != null && (e.formId = String(E.formId)), E.value != null && (e.value = E.value | 0), E.rawValue != null && (e.rawValue = String(E.rawValue)), E.setValue != null && (e.setValue = !!E.setValue), E.disabled != null && (e.disabled = !!E.disabled), E.horizontal != null && (e.horizontal = !!E.horizontal), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    if (E.captions) {
      if (!Array.isArray(E.captions)) throw TypeError(".Radio.captions: array expected");
      e.captions = [];
      for (let t = 0; t < E.captions.length; ++t) e.captions[t] = String(E.captions[t]);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.options = [], t.captions = []), e.defaults && (t.id = "", t.label = "", t.help = "", t.formId = "", t.setValue = !1, t.disabled = !1, t.horizontal = !1, t.labelVisibility = null), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.default != null && E.hasOwnProperty("default") && (t.default = E.default, e.oneofs && (t._default = "default")), E.options && E.options.length) {
      t.options = [];
      for (let n = 0; n < E.options.length; ++n) t.options[n] = E.options[n];
    }
    if (E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.value != null && E.hasOwnProperty("value") && (t.value = E.value, e.oneofs && (t._value = "value")), E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.horizontal != null && E.hasOwnProperty("horizontal") && (t.horizontal = E.horizontal), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), E.captions && E.captions.length) {
      t.captions = [];
      for (let n = 0; n < E.captions.length; ++n) t.captions[n] = E.captions[n];
    }
    return E.rawValue != null && E.hasOwnProperty("rawValue") && (t.rawValue = E.rawValue, e.oneofs && (t._rawValue = "rawValue")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Radio";
  }, o;
})();
$root$1.Selectbox = (() => {
  function o(g) {
    if (this.options = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.options = $util$1.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.rawValue = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.placeholder = "", o.prototype.acceptNewOptions = null;
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(i = ["default"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(i = ["value"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_rawValue", { get: $util$1.oneOfGetter(i = ["rawValue"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_acceptNewOptions", { get: $util$1.oneOfGetter(i = ["acceptNewOptions"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.default), E.options != null && E.options.length) for (let t = 0; t < E.options.length; ++t) e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.options[t]);
    return E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.formId), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), E.placeholder != null && Object.hasOwnProperty.call(E, "placeholder") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.placeholder), E.acceptNewOptions != null && Object.hasOwnProperty.call(E, "acceptNewOptions") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(E.acceptNewOptions), E.rawValue != null && Object.hasOwnProperty.call(E, "rawValue") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.rawValue), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Selectbox();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.default = E.int32();
          break;
        }
        case 4: {
          h.options && h.options.length || (h.options = []), h.options.push(E.string());
          break;
        }
        case 5: {
          h.help = E.string();
          break;
        }
        case 6: {
          h.formId = E.string();
          break;
        }
        case 7: {
          h.value = E.int32();
          break;
        }
        case 13: {
          h.rawValue = E.string();
          break;
        }
        case 8: {
          h.setValue = E.bool();
          break;
        }
        case 9: {
          h.disabled = E.bool();
          break;
        }
        case 10: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 11: {
          h.placeholder = E.string();
          break;
        }
        case 12: {
          h.acceptNewOptions = E.bool();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Selectbox) return E;
    let e = new $root$1.Selectbox();
    if (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.default != null && (e.default = E.default | 0), E.options) {
      if (!Array.isArray(E.options)) throw TypeError(".Selectbox.options: array expected");
      e.options = [];
      for (let t = 0; t < E.options.length; ++t) e.options[t] = String(E.options[t]);
    }
    if (E.help != null && (e.help = String(E.help)), E.formId != null && (e.formId = String(E.formId)), E.value != null && (e.value = E.value | 0), E.rawValue != null && (e.rawValue = String(E.rawValue)), E.setValue != null && (e.setValue = !!E.setValue), E.disabled != null && (e.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.placeholder != null && (e.placeholder = String(E.placeholder)), E.acceptNewOptions != null && (e.acceptNewOptions = !!E.acceptNewOptions), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.options = []), e.defaults && (t.id = "", t.label = "", t.help = "", t.formId = "", t.setValue = !1, t.disabled = !1, t.labelVisibility = null, t.placeholder = ""), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.default != null && E.hasOwnProperty("default") && (t.default = E.default, e.oneofs && (t._default = "default")), E.options && E.options.length) {
      t.options = [];
      for (let n = 0; n < E.options.length; ++n) t.options[n] = E.options[n];
    }
    return E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.value != null && E.hasOwnProperty("value") && (t.value = E.value, e.oneofs && (t._value = "value")), E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), E.placeholder != null && E.hasOwnProperty("placeholder") && (t.placeholder = E.placeholder), E.acceptNewOptions != null && E.hasOwnProperty("acceptNewOptions") && (t.acceptNewOptions = E.acceptNewOptions, e.oneofs && (t._acceptNewOptions = "acceptNewOptions")), E.rawValue != null && E.hasOwnProperty("rawValue") && (t.rawValue = E.rawValue, e.oneofs && (t._rawValue = "rawValue")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Selectbox";
  }, o;
})();
const Skeleton$1 = $root$1.Skeleton = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.style = 0, o.prototype.height = null;
  let i;
  return Object.defineProperty(o.prototype, "_height", { get: $util$1.oneOfGetter(i = ["height"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.style != null && Object.hasOwnProperty.call(E, "style") && e.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(E.style), E.height != null && Object.hasOwnProperty.call(E, "height") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(E.height), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Skeleton();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.style = E.int32();
          break;
        }
        case 2: {
          h.height = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Skeleton) return E;
    let e = new $root$1.Skeleton();
    switch (E.style) {
      default:
        if (typeof E.style == "number") {
          e.style = E.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        e.style = 0;
        break;
      case "APP":
      case 1:
        e.style = 1;
        break;
    }
    return E.height != null && (e.height = E.height | 0), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.style = e.enums === String ? "ELEMENT" : 0), E.style != null && E.hasOwnProperty("style") && (t.style = e.enums === String ? $root$1.Skeleton.SkeletonStyle[E.style] === void 0 ? E.style : $root$1.Skeleton.SkeletonStyle[E.style] : E.style), E.height != null && E.hasOwnProperty("height") && (t.height = E.height, e.oneofs && (t._height = "height")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Skeleton";
  }, o.SkeletonStyle = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "ELEMENT"] = 0, E[g[1] = "APP"] = 1, E;
  })(), o;
})(), Slider$1 = $root$1.Slider = (() => {
  function o(i) {
    if (this.default = [], this.value = [], this.options = [], this.rawValue = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.formId = "", o.prototype.label = "", o.prototype.format = "", o.prototype.dataType = 0, o.prototype.default = $util$1.emptyArray, o.prototype.min = 0, o.prototype.max = 0, o.prototype.step = 0, o.prototype.value = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.options = $util$1.emptyArray, o.prototype.help = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.type = 0, o.prototype.rawValue = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.formId), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.label), g.format != null && Object.hasOwnProperty.call(g, "format") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.format), g.dataType != null && Object.hasOwnProperty.call(g, "dataType") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.dataType), g.default != null && g.default.length) {
      E.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork();
      for (let e = 0; e < g.default.length; ++e) E.double(g.default[e]);
      E.ldelim();
    }
    if (g.min != null && Object.hasOwnProperty.call(g, "min") && E.uint32(
      /* id 7, wireType 1 =*/
      57
    ).double(g.min), g.max != null && Object.hasOwnProperty.call(g, "max") && E.uint32(
      /* id 8, wireType 1 =*/
      65
    ).double(g.max), g.step != null && Object.hasOwnProperty.call(g, "step") && E.uint32(
      /* id 9, wireType 1 =*/
      73
    ).double(g.step), g.value != null && g.value.length) {
      E.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork();
      for (let e = 0; e < g.value.length; ++e) E.double(g.value[e]);
      E.ldelim();
    }
    if (g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.setValue), g.options != null && g.options.length) for (let e = 0; e < g.options.length; ++e) E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.options[e]);
    if (g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.help), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 17, wireType 0 =*/
      136
    ).int32(g.type), g.rawValue != null && g.rawValue.length) for (let e = 0; e < g.rawValue.length; ++e) E.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.rawValue[e]);
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Slider();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.formId = g.string();
          break;
        }
        case 3: {
          n.label = g.string();
          break;
        }
        case 4: {
          n.format = g.string();
          break;
        }
        case 5: {
          n.dataType = g.int32();
          break;
        }
        case 6: {
          if (n.default && n.default.length || (n.default = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.default.push(g.double());
          } else n.default.push(g.double());
          break;
        }
        case 7: {
          n.min = g.double();
          break;
        }
        case 8: {
          n.max = g.double();
          break;
        }
        case 9: {
          n.step = g.double();
          break;
        }
        case 10: {
          if (n.value && n.value.length || (n.value = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.value.push(g.double());
          } else n.value.push(g.double());
          break;
        }
        case 11: {
          n.setValue = g.bool();
          break;
        }
        case 13: {
          n.options && n.options.length || (n.options = []), n.options.push(g.string());
          break;
        }
        case 14: {
          n.help = g.string();
          break;
        }
        case 15: {
          n.disabled = g.bool();
          break;
        }
        case 16: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.type = g.int32();
          break;
        }
        case 18: {
          n.rawValue && n.rawValue.length || (n.rawValue = []), n.rawValue.push(g.string());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Slider) return g;
    let E = new $root$1.Slider();
    switch (g.id != null && (E.id = String(g.id)), g.formId != null && (E.formId = String(g.formId)), g.label != null && (E.label = String(g.label)), g.format != null && (E.format = String(g.format)), g.dataType) {
      default:
        if (typeof g.dataType == "number") {
          E.dataType = g.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        E.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        E.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        E.dataType = 2;
        break;
      case "DATE":
      case 3:
        E.dataType = 3;
        break;
      case "TIME":
      case 4:
        E.dataType = 4;
        break;
    }
    if (g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".Slider.default: array expected");
      E.default = [];
      for (let e = 0; e < g.default.length; ++e) E.default[e] = Number(g.default[e]);
    }
    if (g.min != null && (E.min = Number(g.min)), g.max != null && (E.max = Number(g.max)), g.step != null && (E.step = Number(g.step)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".Slider.value: array expected");
      E.value = [];
      for (let e = 0; e < g.value.length; ++e) E.value[e] = Number(g.value[e]);
    }
    if (g.setValue != null && (E.setValue = !!g.setValue), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".Slider.options: array expected");
      E.options = [];
      for (let e = 0; e < g.options.length; ++e) E.options[e] = String(g.options[e]);
    }
    if (g.help != null && (E.help = String(g.help)), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
      E.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    switch (g.type) {
      default:
        if (typeof g.type == "number") {
          E.type = g.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        E.type = 0;
        break;
      case "SLIDER":
      case 1:
        E.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        E.type = 2;
        break;
    }
    if (g.rawValue) {
      if (!Array.isArray(g.rawValue)) throw TypeError(".Slider.rawValue: array expected");
      E.rawValue = [];
      for (let e = 0; e < g.rawValue.length; ++e) E.rawValue[e] = String(g.rawValue[e]);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.default = [], e.value = [], e.options = [], e.rawValue = []), E.defaults && (e.id = "", e.formId = "", e.label = "", e.format = "", e.dataType = E.enums === String ? "INT" : 0, e.min = 0, e.max = 0, e.step = 0, e.setValue = !1, e.help = "", e.disabled = !1, e.labelVisibility = null, e.type = E.enums === String ? "UNSPECIFIED" : 0), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.format != null && g.hasOwnProperty("format") && (e.format = g.format), g.dataType != null && g.hasOwnProperty("dataType") && (e.dataType = E.enums === String ? $root$1.Slider.DataType[g.dataType] === void 0 ? g.dataType : $root$1.Slider.DataType[g.dataType] : g.dataType), g.default && g.default.length) {
      e.default = [];
      for (let t = 0; t < g.default.length; ++t) e.default[t] = E.json && !isFinite(g.default[t]) ? String(g.default[t]) : g.default[t];
    }
    if (g.min != null && g.hasOwnProperty("min") && (e.min = E.json && !isFinite(g.min) ? String(g.min) : g.min), g.max != null && g.hasOwnProperty("max") && (e.max = E.json && !isFinite(g.max) ? String(g.max) : g.max), g.step != null && g.hasOwnProperty("step") && (e.step = E.json && !isFinite(g.step) ? String(g.step) : g.step), g.value && g.value.length) {
      e.value = [];
      for (let t = 0; t < g.value.length; ++t) e.value[t] = E.json && !isFinite(g.value[t]) ? String(g.value[t]) : g.value[t];
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.options && g.options.length) {
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) e.options[t] = g.options[t];
    }
    if (g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.type != null && g.hasOwnProperty("type") && (e.type = E.enums === String ? $root$1.Slider.Type[g.type] === void 0 ? g.type : $root$1.Slider.Type[g.type] : g.type), g.rawValue && g.rawValue.length) {
      e.rawValue = [];
      for (let t = 0; t < g.rawValue.length; ++t) e.rawValue[t] = g.rawValue[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Slider";
  }, o.DataType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "INT"] = 0, g[i[1] = "FLOAT"] = 1, g[i[2] = "DATETIME"] = 2, g[i[3] = "DATE"] = 3, g[i[4] = "TIME"] = 4, g;
  })(), o.Type = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "UNSPECIFIED"] = 0, g[i[1] = "SLIDER"] = 1, g[i[2] = "SELECT_SLIDER"] = 2, g;
  })(), o;
})();
$root$1.Space = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Space();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    return g instanceof $root$1.Space ? g : new $root$1.Space();
  }, o.toObject = function() {
    return {};
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Space";
  }, o;
})();
$root$1.Text = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.body = "", o.prototype.help = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.help), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Text();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.body = g.string();
          break;
        }
        case 2: {
          n.help = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Text) return g;
    let E = new $root$1.Text();
    return g.body != null && (E.body = String(g.body)), g.help != null && (E.help = String(g.help)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.body = "", e.help = ""), g.body != null && g.hasOwnProperty("body") && (e.body = g.body), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Text";
  }, o;
})();
$root$1.TextArea = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.height = 0, o.prototype.maxChars = 0, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.placeholder = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null;
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(i = ["default"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(i = ["value"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.default), E.height != null && Object.hasOwnProperty.call(E, "height") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(E.height), E.maxChars != null && Object.hasOwnProperty.call(E, "maxChars") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(E.maxChars), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.formId), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.setValue), E.placeholder != null && Object.hasOwnProperty.call(E, "placeholder") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.placeholder), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.TextArea();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.default = E.string();
          break;
        }
        case 4: {
          h.height = E.uint32();
          break;
        }
        case 5: {
          h.maxChars = E.uint32();
          break;
        }
        case 6: {
          h.help = E.string();
          break;
        }
        case 7: {
          h.formId = E.string();
          break;
        }
        case 8: {
          h.value = E.string();
          break;
        }
        case 9: {
          h.setValue = E.bool();
          break;
        }
        case 10: {
          h.placeholder = E.string();
          break;
        }
        case 11: {
          h.disabled = E.bool();
          break;
        }
        case 12: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.TextArea) return E;
    let e = new $root$1.TextArea();
    if (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.default != null && (e.default = String(E.default)), E.height != null && (e.height = E.height >>> 0), E.maxChars != null && (e.maxChars = E.maxChars >>> 0), E.help != null && (e.help = String(E.help)), E.formId != null && (e.formId = String(E.formId)), E.value != null && (e.value = String(E.value)), E.setValue != null && (e.setValue = !!E.setValue), E.placeholder != null && (e.placeholder = String(E.placeholder)), E.disabled != null && (e.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.height = 0, t.maxChars = 0, t.help = "", t.formId = "", t.setValue = !1, t.placeholder = "", t.disabled = !1, t.labelVisibility = null), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.default != null && E.hasOwnProperty("default") && (t.default = E.default, e.oneofs && (t._default = "default")), E.height != null && E.hasOwnProperty("height") && (t.height = E.height), E.maxChars != null && E.hasOwnProperty("maxChars") && (t.maxChars = E.maxChars), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.value != null && E.hasOwnProperty("value") && (t.value = E.value, e.oneofs && (t._value = "value")), E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.placeholder != null && E.hasOwnProperty("placeholder") && (t.placeholder = E.placeholder), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/TextArea";
  }, o;
})();
const TextInput$1 = $root$1.TextInput = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.type = 0, o.prototype.maxChars = 0, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.autocomplete = "", o.prototype.placeholder = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.icon = "";
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(i = ["default"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(i = ["value"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.default), E.type != null && Object.hasOwnProperty.call(E, "type") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(E.type), E.maxChars != null && Object.hasOwnProperty.call(E, "maxChars") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(E.maxChars), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.formId), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.setValue), E.autocomplete != null && Object.hasOwnProperty.call(E, "autocomplete") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.autocomplete), E.placeholder != null && Object.hasOwnProperty.call(E, "placeholder") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.placeholder), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), E.icon != null && Object.hasOwnProperty.call(E, "icon") && e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(E.icon), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.TextInput();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.default = E.string();
          break;
        }
        case 4: {
          h.type = E.int32();
          break;
        }
        case 5: {
          h.maxChars = E.uint32();
          break;
        }
        case 6: {
          h.help = E.string();
          break;
        }
        case 7: {
          h.formId = E.string();
          break;
        }
        case 8: {
          h.value = E.string();
          break;
        }
        case 9: {
          h.setValue = E.bool();
          break;
        }
        case 10: {
          h.autocomplete = E.string();
          break;
        }
        case 11: {
          h.placeholder = E.string();
          break;
        }
        case 12: {
          h.disabled = E.bool();
          break;
        }
        case 13: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 14: {
          h.icon = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.TextInput) return E;
    let e = new $root$1.TextInput();
    switch (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.default != null && (e.default = String(E.default)), E.type) {
      default:
        if (typeof E.type == "number") {
          e.type = E.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        e.type = 0;
        break;
      case "PASSWORD":
      case 1:
        e.type = 1;
        break;
    }
    if (E.maxChars != null && (e.maxChars = E.maxChars >>> 0), E.help != null && (e.help = String(E.help)), E.formId != null && (e.formId = String(E.formId)), E.value != null && (e.value = String(E.value)), E.setValue != null && (e.setValue = !!E.setValue), E.autocomplete != null && (e.autocomplete = String(E.autocomplete)), E.placeholder != null && (e.placeholder = String(E.placeholder)), E.disabled != null && (e.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.icon != null && (e.icon = String(E.icon)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.type = e.enums === String ? "DEFAULT" : 0, t.maxChars = 0, t.help = "", t.formId = "", t.setValue = !1, t.autocomplete = "", t.placeholder = "", t.disabled = !1, t.labelVisibility = null, t.icon = ""), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.default != null && E.hasOwnProperty("default") && (t.default = E.default, e.oneofs && (t._default = "default")), E.type != null && E.hasOwnProperty("type") && (t.type = e.enums === String ? $root$1.TextInput.Type[E.type] === void 0 ? E.type : $root$1.TextInput.Type[E.type] : E.type), E.maxChars != null && E.hasOwnProperty("maxChars") && (t.maxChars = E.maxChars), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.value != null && E.hasOwnProperty("value") && (t.value = E.value, e.oneofs && (t._value = "value")), E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.autocomplete != null && E.hasOwnProperty("autocomplete") && (t.autocomplete = E.autocomplete), E.placeholder != null && E.hasOwnProperty("placeholder") && (t.placeholder = E.placeholder), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), E.icon != null && E.hasOwnProperty("icon") && (t.icon = E.icon), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/TextInput";
  }, o.Type = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "DEFAULT"] = 0, E[g[1] = "PASSWORD"] = 1, E;
  })(), o;
})();
$root$1.TimeInput = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.step = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0;
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(i = ["default"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(i = ["value"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.default), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.formId), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(E.labelVisibility, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E.step != null && Object.hasOwnProperty.call(E, "step") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int64(E.step), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.TimeInput();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.id = E.string();
          break;
        }
        case 2: {
          h.label = E.string();
          break;
        }
        case 3: {
          h.default = E.string();
          break;
        }
        case 4: {
          h.help = E.string();
          break;
        }
        case 5: {
          h.formId = E.string();
          break;
        }
        case 6: {
          h.value = E.string();
          break;
        }
        case 7: {
          h.setValue = E.bool();
          break;
        }
        case 8: {
          h.disabled = E.bool();
          break;
        }
        case 9: {
          h.labelVisibility = $root$1.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 10: {
          h.step = E.int64();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.TimeInput) return E;
    let e = new $root$1.TimeInput();
    if (E.id != null && (e.id = String(E.id)), E.label != null && (e.label = String(E.label)), E.default != null && (e.default = String(E.default)), E.help != null && (e.help = String(E.help)), E.formId != null && (e.formId = String(E.formId)), E.value != null && (e.value = String(E.value)), E.setValue != null && (e.setValue = !!E.setValue), E.disabled != null && (e.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.step != null && ($util$1.Long ? (e.step = $util$1.Long.fromValue(E.step)).unsigned = !1 : typeof E.step == "string" ? e.step = parseInt(E.step, 10) : typeof E.step == "number" ? e.step = E.step : typeof E.step == "object" && (e.step = new $util$1.LongBits(E.step.low >>> 0, E.step.high >>> 0).toNumber())), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if (e.defaults)
      if (t.id = "", t.label = "", t.help = "", t.formId = "", t.setValue = !1, t.disabled = !1, t.labelVisibility = null, $util$1.Long) {
        let n = new $util$1.Long(0, 0, !1);
        t.step = e.longs === String ? n.toString() : e.longs === Number ? n.toNumber() : n;
      } else t.step = e.longs === String ? "0" : 0;
    return E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.default != null && E.hasOwnProperty("default") && (t.default = E.default, e.oneofs && (t._default = "default")), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.value != null && E.hasOwnProperty("value") && (t.value = E.value, e.oneofs && (t._value = "value")), E.setValue != null && E.hasOwnProperty("setValue") && (t.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(E.labelVisibility, e)), E.step != null && E.hasOwnProperty("step") && (typeof E.step == "number" ? t.step = e.longs === String ? String(E.step) : E.step : t.step = e.longs === String ? $util$1.Long.prototype.toString.call(E.step) : e.longs === Number ? new $util$1.LongBits(E.step.low >>> 0, E.step.high >>> 0).toNumber() : E.step), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/TimeInput";
  }, o;
})();
$root$1.Toast = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.body = "", o.prototype.icon = "", o.prototype.duration = null;
  let i;
  return Object.defineProperty(o.prototype, "_duration", { get: $util$1.oneOfGetter(i = ["duration"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.body != null && Object.hasOwnProperty.call(E, "body") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.body), E.icon != null && Object.hasOwnProperty.call(E, "icon") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.icon), E.duration != null && Object.hasOwnProperty.call(E, "duration") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.duration), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Toast();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.body = E.string();
          break;
        }
        case 2: {
          h.icon = E.string();
          break;
        }
        case 3: {
          h.duration = E.int32();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Toast) return E;
    let e = new $root$1.Toast();
    return E.body != null && (e.body = String(E.body)), E.icon != null && (e.icon = String(E.icon)), E.duration != null && (e.duration = E.duration | 0), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.body = "", t.icon = ""), E.body != null && E.hasOwnProperty("body") && (t.body = E.body), E.icon != null && E.hasOwnProperty("icon") && (t.icon = E.icon), E.duration != null && E.hasOwnProperty("duration") && (t.duration = E.duration, e.oneofs && (t._duration = "duration")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Toast";
  }, o;
})();
$root$1.VegaLiteChart = (() => {
  function o(i) {
    if (this.datasets = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.spec = "", o.prototype.data = null, o.prototype.datasets = $util$1.emptyArray, o.prototype.useContainerWidth = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.spec != null && Object.hasOwnProperty.call(g, "spec") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.spec), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.DataFrame.encode(g.data, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.datasets != null && g.datasets.length) for (let e = 0; e < g.datasets.length; ++e) $root$1.NamedDataSet.encode(g.datasets[e], E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    return g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.VegaLiteChart();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.spec = g.string();
          break;
        }
        case 2: {
          n.data = $root$1.DataFrame.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.datasets && n.datasets.length || (n.datasets = []), n.datasets.push($root$1.NamedDataSet.decode(g, g.uint32()));
          break;
        }
        case 5: {
          n.useContainerWidth = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.VegaLiteChart) return g;
    let E = new $root$1.VegaLiteChart();
    if (g.spec != null && (E.spec = String(g.spec)), g.data != null) {
      if (typeof g.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
      E.data = $root$1.DataFrame.fromObject(g.data);
    }
    if (g.datasets) {
      if (!Array.isArray(g.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
      E.datasets = [];
      for (let e = 0; e < g.datasets.length; ++e) {
        if (typeof g.datasets[e] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
        E.datasets[e] = $root$1.NamedDataSet.fromObject(g.datasets[e]);
      }
    }
    return g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.datasets = []), E.defaults && (e.spec = "", e.data = null, e.useContainerWidth = !1), g.spec != null && g.hasOwnProperty("spec") && (e.spec = g.spec), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.DataFrame.toObject(g.data, E)), g.datasets && g.datasets.length) {
      e.datasets = [];
      for (let t = 0; t < g.datasets.length; ++t) e.datasets[t] = $root$1.NamedDataSet.toObject(g.datasets[t], E);
    }
    return g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/VegaLiteChart";
  }, o;
})();
$root$1.NamedDataSet = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.name = "", o.prototype.hasName = !1, o.prototype.data = null, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.DataFrame.encode(g.data, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.hasName != null && Object.hasOwnProperty.call(g, "hasName") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.hasName), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.NamedDataSet();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.name = g.string();
          break;
        }
        case 3: {
          n.hasName = g.bool();
          break;
        }
        case 2: {
          n.data = $root$1.DataFrame.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.NamedDataSet) return g;
    let E = new $root$1.NamedDataSet();
    if (g.name != null && (E.name = String(g.name)), g.hasName != null && (E.hasName = !!g.hasName), g.data != null) {
      if (typeof g.data != "object") throw TypeError(".NamedDataSet.data: object expected");
      E.data = $root$1.DataFrame.fromObject(g.data);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.name = "", e.data = null, e.hasName = !1), g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.data != null && g.hasOwnProperty("data") && (e.data = $root$1.DataFrame.toObject(g.data, E)), g.hasName != null && g.hasOwnProperty("hasName") && (e.hasName = g.hasName), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/NamedDataSet";
  }, o;
})();
$root$1.SubtitleTrack = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.label = "", o.prototype.url = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.label), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.url), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.SubtitleTrack();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.label = g.string();
          break;
        }
        case 2: {
          n.url = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.SubtitleTrack) return g;
    let E = new $root$1.SubtitleTrack();
    return g.label != null && (E.label = String(g.label)), g.url != null && (E.url = String(g.url)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.label = "", e.url = ""), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SubtitleTrack";
  }, o;
})();
const Video$1 = $root$1.Video = (() => {
  function o(g) {
    if (this.subtitles = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.url = "", o.prototype.startTime = 0, o.prototype.type = 0, o.prototype.subtitles = $util$1.emptyArray, o.prototype.endTime = 0, o.prototype.loop = !1, o.prototype.autoplay = !1, o.prototype.muted = !1, o.prototype.id = "", o.prototype.widthConfig = null;
  let i;
  return Object.defineProperty(o.prototype, "_widthConfig", { get: $util$1.oneOfGetter(i = ["widthConfig"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.startTime != null && Object.hasOwnProperty.call(E, "startTime") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.startTime), E.type != null && Object.hasOwnProperty.call(E, "type") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(E.type), E.url != null && Object.hasOwnProperty.call(E, "url") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.url), E.subtitles != null && E.subtitles.length) for (let t = 0; t < E.subtitles.length; ++t) $root$1.SubtitleTrack.encode(E.subtitles[t], e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim();
    return E.endTime != null && Object.hasOwnProperty.call(E, "endTime") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(E.endTime), E.loop != null && Object.hasOwnProperty.call(E, "loop") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.loop), E.autoplay != null && Object.hasOwnProperty.call(E, "autoplay") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(E.autoplay), E.muted != null && Object.hasOwnProperty.call(E, "muted") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(E.muted), E.id != null && Object.hasOwnProperty.call(E, "id") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(E.id), E.widthConfig != null && Object.hasOwnProperty.call(E, "widthConfig") && $root$1.streamlit.WidthConfig.encode(E.widthConfig, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.Video();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 6: {
          h.url = E.string();
          break;
        }
        case 3: {
          h.startTime = E.int32();
          break;
        }
        case 5: {
          h.type = E.int32();
          break;
        }
        case 7: {
          h.subtitles && h.subtitles.length || (h.subtitles = []), h.subtitles.push($root$1.SubtitleTrack.decode(E, E.uint32()));
          break;
        }
        case 8: {
          h.endTime = E.int32();
          break;
        }
        case 9: {
          h.loop = E.bool();
          break;
        }
        case 10: {
          h.autoplay = E.bool();
          break;
        }
        case 11: {
          h.muted = E.bool();
          break;
        }
        case 12: {
          h.id = E.string();
          break;
        }
        case 13: {
          h.widthConfig = $root$1.streamlit.WidthConfig.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.Video) return E;
    let e = new $root$1.Video();
    switch (E.url != null && (e.url = String(E.url)), E.startTime != null && (e.startTime = E.startTime | 0), E.type) {
      default:
        if (typeof E.type == "number") {
          e.type = E.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        e.type = 0;
        break;
      case "NATIVE":
      case 1:
        e.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        e.type = 2;
        break;
    }
    if (E.subtitles) {
      if (!Array.isArray(E.subtitles)) throw TypeError(".Video.subtitles: array expected");
      e.subtitles = [];
      for (let t = 0; t < E.subtitles.length; ++t) {
        if (typeof E.subtitles[t] != "object") throw TypeError(".Video.subtitles: object expected");
        e.subtitles[t] = $root$1.SubtitleTrack.fromObject(E.subtitles[t]);
      }
    }
    if (E.endTime != null && (e.endTime = E.endTime | 0), E.loop != null && (e.loop = !!E.loop), E.autoplay != null && (e.autoplay = !!E.autoplay), E.muted != null && (e.muted = !!E.muted), E.id != null && (e.id = String(E.id)), E.widthConfig != null) {
      if (typeof E.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
      e.widthConfig = $root$1.streamlit.WidthConfig.fromObject(E.widthConfig);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.subtitles = []), e.defaults && (t.startTime = 0, t.type = e.enums === String ? "UNUSED" : 0, t.url = "", t.endTime = 0, t.loop = !1, t.autoplay = !1, t.muted = !1, t.id = ""), E.startTime != null && E.hasOwnProperty("startTime") && (t.startTime = E.startTime), E.type != null && E.hasOwnProperty("type") && (t.type = e.enums === String ? $root$1.Video.Type[E.type] === void 0 ? E.type : $root$1.Video.Type[E.type] : E.type), E.url != null && E.hasOwnProperty("url") && (t.url = E.url), E.subtitles && E.subtitles.length) {
      t.subtitles = [];
      for (let n = 0; n < E.subtitles.length; ++n) t.subtitles[n] = $root$1.SubtitleTrack.toObject(E.subtitles[n], e);
    }
    return E.endTime != null && E.hasOwnProperty("endTime") && (t.endTime = E.endTime), E.loop != null && E.hasOwnProperty("loop") && (t.loop = E.loop), E.autoplay != null && E.hasOwnProperty("autoplay") && (t.autoplay = E.autoplay), E.muted != null && E.hasOwnProperty("muted") && (t.muted = E.muted), E.id != null && E.hasOwnProperty("id") && (t.id = E.id), E.widthConfig != null && E.hasOwnProperty("widthConfig") && (t.widthConfig = $root$1.streamlit.WidthConfig.toObject(E.widthConfig, e), e.oneofs && (t._widthConfig = "widthConfig")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Video";
  }, o.Type = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "UNUSED"] = 0, E[g[1] = "NATIVE"] = 1, E[g[2] = "YOUTUBE_IFRAME"] = 2, E;
  })(), o;
})();
$root$1.Heading = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.tag = "", o.prototype.anchor = "", o.prototype.body = "", o.prototype.help = "", o.prototype.hideAnchor = !1, o.prototype.divider = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.tag != null && Object.hasOwnProperty.call(g, "tag") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.tag), g.anchor != null && Object.hasOwnProperty.call(g, "anchor") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.anchor), g.body != null && Object.hasOwnProperty.call(g, "body") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.body), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.hideAnchor != null && Object.hasOwnProperty.call(g, "hideAnchor") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.hideAnchor), g.divider != null && Object.hasOwnProperty.call(g, "divider") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.divider), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Heading();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.tag = g.string();
          break;
        }
        case 2: {
          n.anchor = g.string();
          break;
        }
        case 3: {
          n.body = g.string();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 5: {
          n.hideAnchor = g.bool();
          break;
        }
        case 6: {
          n.divider = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Heading) return g;
    let E = new $root$1.Heading();
    return g.tag != null && (E.tag = String(g.tag)), g.anchor != null && (E.anchor = String(g.anchor)), g.body != null && (E.body = String(g.body)), g.help != null && (E.help = String(g.help)), g.hideAnchor != null && (E.hideAnchor = !!g.hideAnchor), g.divider != null && (E.divider = String(g.divider)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.tag = "", e.anchor = "", e.body = "", e.help = "", e.hideAnchor = !1, e.divider = ""), g.tag != null && g.hasOwnProperty("tag") && (e.tag = g.tag), g.anchor != null && g.hasOwnProperty("anchor") && (e.anchor = g.anchor), g.body != null && g.hasOwnProperty("body") && (e.body = g.body), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.hideAnchor != null && g.hasOwnProperty("hideAnchor") && (e.hideAnchor = g.hideAnchor), g.divider != null && g.hasOwnProperty("divider") && (e.divider = g.divider), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Heading";
  }, o;
})();
$root$1.Transient = (() => {
  function o(i) {
    if (this.elements = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.elements = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.elements != null && g.elements.length) for (let e = 0; e < g.elements.length; ++e) $root$1.Element.encode(g.elements[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Transient();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.elements && n.elements.length || (n.elements = []), n.elements.push($root$1.Element.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Transient) return g;
    let E = new $root$1.Transient();
    if (g.elements) {
      if (!Array.isArray(g.elements)) throw TypeError(".Transient.elements: array expected");
      E.elements = [];
      for (let e = 0; e < g.elements.length; ++e) {
        if (typeof g.elements[e] != "object") throw TypeError(".Transient.elements: object expected");
        E.elements[e] = $root$1.Element.fromObject(g.elements[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.elements = []), g.elements && g.elements.length) {
      e.elements = [];
      for (let t = 0; t < g.elements.length; ++t) e.elements[t] = $root$1.Element.toObject(g.elements[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Transient";
  }, o;
})();
const ForwardMsg = $root$1.ForwardMsg = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.hash = "", o.prototype.metadata = null, o.prototype.newSession = null, o.prototype.delta = null, o.prototype.pageInfoChanged = null, o.prototype.pageConfigChanged = null, o.prototype.scriptFinished = null, o.prototype.gitInfoChanged = null, o.prototype.pageProfile = null, o.prototype.sessionStatusChanged = null, o.prototype.sessionEvent = null, o.prototype.navigation = null, o.prototype.pageNotFound = null, o.prototype.pagesChanged = null, o.prototype.fileUrlsResponse = null, o.prototype.autoRerun = null, o.prototype.logo = null, o.prototype.authRedirect = null, o.prototype.parentMessage = null, o.prototype.refHash = null, o.prototype.deferredFileResponse = null, o.prototype.debugLastBackmsgId = "";
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "pagesChanged", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash", "deferredFileResponse"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.hash != null && Object.hasOwnProperty.call(E, "hash") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.hash), E.metadata != null && Object.hasOwnProperty.call(E, "metadata") && $root$1.ForwardMsgMetadata.encode(E.metadata, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.newSession != null && Object.hasOwnProperty.call(E, "newSession") && $root$1.NewSession.encode(E.newSession, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), E.delta != null && Object.hasOwnProperty.call(E, "delta") && $root$1.Delta.encode(E.delta, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), E.scriptFinished != null && Object.hasOwnProperty.call(E, "scriptFinished") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(E.scriptFinished), E.sessionStatusChanged != null && Object.hasOwnProperty.call(E, "sessionStatusChanged") && $root$1.SessionStatus.encode(E.sessionStatusChanged, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E.sessionEvent != null && Object.hasOwnProperty.call(E, "sessionEvent") && $root$1.SessionEvent.encode(E.sessionEvent, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), E.refHash != null && Object.hasOwnProperty.call(E, "refHash") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.refHash), E.pageInfoChanged != null && Object.hasOwnProperty.call(E, "pageInfoChanged") && $root$1.PageInfo.encode(E.pageInfoChanged, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), E.pageConfigChanged != null && Object.hasOwnProperty.call(E, "pageConfigChanged") && $root$1.PageConfig.encode(E.pageConfigChanged, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), E.gitInfoChanged != null && Object.hasOwnProperty.call(E, "gitInfoChanged") && $root$1.GitInfo.encode(E.gitInfoChanged, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), E.pageNotFound != null && Object.hasOwnProperty.call(E, "pageNotFound") && $root$1.PageNotFound.encode(E.pageNotFound, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), E.pagesChanged != null && Object.hasOwnProperty.call(E, "pagesChanged") && $root$1.PagesChanged.encode(E.pagesChanged, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), E.debugLastBackmsgId != null && Object.hasOwnProperty.call(E, "debugLastBackmsgId") && e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(E.debugLastBackmsgId), E.pageProfile != null && Object.hasOwnProperty.call(E, "pageProfile") && $root$1.PageProfile.encode(E.pageProfile, e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), E.fileUrlsResponse != null && Object.hasOwnProperty.call(E, "fileUrlsResponse") && $root$1.FileURLsResponse.encode(E.fileUrlsResponse, e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), E.parentMessage != null && Object.hasOwnProperty.call(E, "parentMessage") && $root$1.ParentMessage.encode(E.parentMessage, e.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), E.autoRerun != null && Object.hasOwnProperty.call(E, "autoRerun") && $root$1.AutoRerun.encode(E.autoRerun, e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), E.logo != null && Object.hasOwnProperty.call(E, "logo") && $root$1.Logo.encode(E.logo, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), E.navigation != null && Object.hasOwnProperty.call(E, "navigation") && $root$1.Navigation.encode(E.navigation, e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), E.authRedirect != null && Object.hasOwnProperty.call(E, "authRedirect") && $root$1.AuthRedirect.encode(E.authRedirect, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), E.deferredFileResponse != null && Object.hasOwnProperty.call(E, "deferredFileResponse") && $root$1.DeferredFileResponse.encode(E.deferredFileResponse, e.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.ForwardMsg();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.hash = E.string();
          break;
        }
        case 2: {
          h.metadata = $root$1.ForwardMsgMetadata.decode(E, E.uint32());
          break;
        }
        case 4: {
          h.newSession = $root$1.NewSession.decode(E, E.uint32());
          break;
        }
        case 5: {
          h.delta = $root$1.Delta.decode(E, E.uint32());
          break;
        }
        case 12: {
          h.pageInfoChanged = $root$1.PageInfo.decode(E, E.uint32());
          break;
        }
        case 13: {
          h.pageConfigChanged = $root$1.PageConfig.decode(E, E.uint32());
          break;
        }
        case 6: {
          h.scriptFinished = E.int32();
          break;
        }
        case 14: {
          h.gitInfoChanged = $root$1.GitInfo.decode(E, E.uint32());
          break;
        }
        case 18: {
          h.pageProfile = $root$1.PageProfile.decode(E, E.uint32());
          break;
        }
        case 9: {
          h.sessionStatusChanged = $root$1.SessionStatus.decode(E, E.uint32());
          break;
        }
        case 10: {
          h.sessionEvent = $root$1.SessionEvent.decode(E, E.uint32());
          break;
        }
        case 23: {
          h.navigation = $root$1.Navigation.decode(E, E.uint32());
          break;
        }
        case 15: {
          h.pageNotFound = $root$1.PageNotFound.decode(E, E.uint32());
          break;
        }
        case 16: {
          h.pagesChanged = $root$1.PagesChanged.decode(E, E.uint32());
          break;
        }
        case 19: {
          h.fileUrlsResponse = $root$1.FileURLsResponse.decode(E, E.uint32());
          break;
        }
        case 21: {
          h.autoRerun = $root$1.AutoRerun.decode(E, E.uint32());
          break;
        }
        case 22: {
          h.logo = $root$1.Logo.decode(E, E.uint32());
          break;
        }
        case 24: {
          h.authRedirect = $root$1.AuthRedirect.decode(E, E.uint32());
          break;
        }
        case 20: {
          h.parentMessage = $root$1.ParentMessage.decode(E, E.uint32());
          break;
        }
        case 11: {
          h.refHash = E.string();
          break;
        }
        case 25: {
          h.deferredFileResponse = $root$1.DeferredFileResponse.decode(E, E.uint32());
          break;
        }
        case 17: {
          h.debugLastBackmsgId = E.string();
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.ForwardMsg) return E;
    let e = new $root$1.ForwardMsg();
    if (E.hash != null && (e.hash = String(E.hash)), E.metadata != null) {
      if (typeof E.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
      e.metadata = $root$1.ForwardMsgMetadata.fromObject(E.metadata);
    }
    if (E.newSession != null) {
      if (typeof E.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
      e.newSession = $root$1.NewSession.fromObject(E.newSession);
    }
    if (E.delta != null) {
      if (typeof E.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
      e.delta = $root$1.Delta.fromObject(E.delta);
    }
    if (E.pageInfoChanged != null) {
      if (typeof E.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      e.pageInfoChanged = $root$1.PageInfo.fromObject(E.pageInfoChanged);
    }
    if (E.pageConfigChanged != null) {
      if (typeof E.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      e.pageConfigChanged = $root$1.PageConfig.fromObject(E.pageConfigChanged);
    }
    switch (E.scriptFinished) {
      default:
        if (typeof E.scriptFinished == "number") {
          e.scriptFinished = E.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        e.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        e.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        e.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        e.scriptFinished = 3;
        break;
    }
    if (E.gitInfoChanged != null) {
      if (typeof E.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      e.gitInfoChanged = $root$1.GitInfo.fromObject(E.gitInfoChanged);
    }
    if (E.pageProfile != null) {
      if (typeof E.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
      e.pageProfile = $root$1.PageProfile.fromObject(E.pageProfile);
    }
    if (E.sessionStatusChanged != null) {
      if (typeof E.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      e.sessionStatusChanged = $root$1.SessionStatus.fromObject(E.sessionStatusChanged);
    }
    if (E.sessionEvent != null) {
      if (typeof E.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
      e.sessionEvent = $root$1.SessionEvent.fromObject(E.sessionEvent);
    }
    if (E.navigation != null) {
      if (typeof E.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
      e.navigation = $root$1.Navigation.fromObject(E.navigation);
    }
    if (E.pageNotFound != null) {
      if (typeof E.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
      e.pageNotFound = $root$1.PageNotFound.fromObject(E.pageNotFound);
    }
    if (E.pagesChanged != null) {
      if (typeof E.pagesChanged != "object") throw TypeError(".ForwardMsg.pagesChanged: object expected");
      e.pagesChanged = $root$1.PagesChanged.fromObject(E.pagesChanged);
    }
    if (E.fileUrlsResponse != null) {
      if (typeof E.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      e.fileUrlsResponse = $root$1.FileURLsResponse.fromObject(E.fileUrlsResponse);
    }
    if (E.autoRerun != null) {
      if (typeof E.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
      e.autoRerun = $root$1.AutoRerun.fromObject(E.autoRerun);
    }
    if (E.logo != null) {
      if (typeof E.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
      e.logo = $root$1.Logo.fromObject(E.logo);
    }
    if (E.authRedirect != null) {
      if (typeof E.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
      e.authRedirect = $root$1.AuthRedirect.fromObject(E.authRedirect);
    }
    if (E.parentMessage != null) {
      if (typeof E.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
      e.parentMessage = $root$1.ParentMessage.fromObject(E.parentMessage);
    }
    if (E.refHash != null && (e.refHash = String(E.refHash)), E.deferredFileResponse != null) {
      if (typeof E.deferredFileResponse != "object") throw TypeError(".ForwardMsg.deferredFileResponse: object expected");
      e.deferredFileResponse = $root$1.DeferredFileResponse.fromObject(E.deferredFileResponse);
    }
    return E.debugLastBackmsgId != null && (e.debugLastBackmsgId = String(E.debugLastBackmsgId)), e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.hash = "", t.metadata = null, t.debugLastBackmsgId = ""), E.hash != null && E.hasOwnProperty("hash") && (t.hash = E.hash), E.metadata != null && E.hasOwnProperty("metadata") && (t.metadata = $root$1.ForwardMsgMetadata.toObject(E.metadata, e)), E.newSession != null && E.hasOwnProperty("newSession") && (t.newSession = $root$1.NewSession.toObject(E.newSession, e), e.oneofs && (t.type = "newSession")), E.delta != null && E.hasOwnProperty("delta") && (t.delta = $root$1.Delta.toObject(E.delta, e), e.oneofs && (t.type = "delta")), E.scriptFinished != null && E.hasOwnProperty("scriptFinished") && (t.scriptFinished = e.enums === String ? $root$1.ForwardMsg.ScriptFinishedStatus[E.scriptFinished] === void 0 ? E.scriptFinished : $root$1.ForwardMsg.ScriptFinishedStatus[E.scriptFinished] : E.scriptFinished, e.oneofs && (t.type = "scriptFinished")), E.sessionStatusChanged != null && E.hasOwnProperty("sessionStatusChanged") && (t.sessionStatusChanged = $root$1.SessionStatus.toObject(E.sessionStatusChanged, e), e.oneofs && (t.type = "sessionStatusChanged")), E.sessionEvent != null && E.hasOwnProperty("sessionEvent") && (t.sessionEvent = $root$1.SessionEvent.toObject(E.sessionEvent, e), e.oneofs && (t.type = "sessionEvent")), E.refHash != null && E.hasOwnProperty("refHash") && (t.refHash = E.refHash, e.oneofs && (t.type = "refHash")), E.pageInfoChanged != null && E.hasOwnProperty("pageInfoChanged") && (t.pageInfoChanged = $root$1.PageInfo.toObject(E.pageInfoChanged, e), e.oneofs && (t.type = "pageInfoChanged")), E.pageConfigChanged != null && E.hasOwnProperty("pageConfigChanged") && (t.pageConfigChanged = $root$1.PageConfig.toObject(E.pageConfigChanged, e), e.oneofs && (t.type = "pageConfigChanged")), E.gitInfoChanged != null && E.hasOwnProperty("gitInfoChanged") && (t.gitInfoChanged = $root$1.GitInfo.toObject(E.gitInfoChanged, e), e.oneofs && (t.type = "gitInfoChanged")), E.pageNotFound != null && E.hasOwnProperty("pageNotFound") && (t.pageNotFound = $root$1.PageNotFound.toObject(E.pageNotFound, e), e.oneofs && (t.type = "pageNotFound")), E.pagesChanged != null && E.hasOwnProperty("pagesChanged") && (t.pagesChanged = $root$1.PagesChanged.toObject(E.pagesChanged, e), e.oneofs && (t.type = "pagesChanged")), E.debugLastBackmsgId != null && E.hasOwnProperty("debugLastBackmsgId") && (t.debugLastBackmsgId = E.debugLastBackmsgId), E.pageProfile != null && E.hasOwnProperty("pageProfile") && (t.pageProfile = $root$1.PageProfile.toObject(E.pageProfile, e), e.oneofs && (t.type = "pageProfile")), E.fileUrlsResponse != null && E.hasOwnProperty("fileUrlsResponse") && (t.fileUrlsResponse = $root$1.FileURLsResponse.toObject(E.fileUrlsResponse, e), e.oneofs && (t.type = "fileUrlsResponse")), E.parentMessage != null && E.hasOwnProperty("parentMessage") && (t.parentMessage = $root$1.ParentMessage.toObject(E.parentMessage, e), e.oneofs && (t.type = "parentMessage")), E.autoRerun != null && E.hasOwnProperty("autoRerun") && (t.autoRerun = $root$1.AutoRerun.toObject(E.autoRerun, e), e.oneofs && (t.type = "autoRerun")), E.logo != null && E.hasOwnProperty("logo") && (t.logo = $root$1.Logo.toObject(E.logo, e), e.oneofs && (t.type = "logo")), E.navigation != null && E.hasOwnProperty("navigation") && (t.navigation = $root$1.Navigation.toObject(E.navigation, e), e.oneofs && (t.type = "navigation")), E.authRedirect != null && E.hasOwnProperty("authRedirect") && (t.authRedirect = $root$1.AuthRedirect.toObject(E.authRedirect, e), e.oneofs && (t.type = "authRedirect")), E.deferredFileResponse != null && E.hasOwnProperty("deferredFileResponse") && (t.deferredFileResponse = $root$1.DeferredFileResponse.toObject(E.deferredFileResponse, e), e.oneofs && (t.type = "deferredFileResponse")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ForwardMsg";
  }, o.ScriptFinishedStatus = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "FINISHED_SUCCESSFULLY"] = 0, E[g[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, E[g[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, E[g[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, E;
  })(), o;
})();
$root$1.DeferredFileResponse = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.fileId = "", o.prototype.url = "", o.prototype.errorMsg = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.fileId != null && Object.hasOwnProperty.call(g, "fileId") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.fileId), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.url), g.errorMsg != null && Object.hasOwnProperty.call(g, "errorMsg") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.errorMsg), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.DeferredFileResponse();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.fileId = g.string();
          break;
        }
        case 2: {
          n.url = g.string();
          break;
        }
        case 3: {
          n.errorMsg = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DeferredFileResponse) return g;
    let E = new $root$1.DeferredFileResponse();
    return g.fileId != null && (E.fileId = String(g.fileId)), g.url != null && (E.url = String(g.url)), g.errorMsg != null && (E.errorMsg = String(g.errorMsg)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.fileId = "", e.url = "", e.errorMsg = ""), g.fileId != null && g.hasOwnProperty("fileId") && (e.fileId = g.fileId), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), g.errorMsg != null && g.hasOwnProperty("errorMsg") && (e.errorMsg = g.errorMsg), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DeferredFileResponse";
  }, o;
})();
const ForwardMsgMetadata = $root$1.ForwardMsgMetadata = (() => {
  function o(i) {
    if (this.deltaPath = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.cacheable = !1, o.prototype.deltaPath = $util$1.emptyArray, o.prototype.elementDimensionSpec = null, o.prototype.activeScriptHash = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.cacheable != null && Object.hasOwnProperty.call(g, "cacheable") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.cacheable), g.deltaPath != null && g.deltaPath.length) {
      E.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork();
      for (let e = 0; e < g.deltaPath.length; ++e) E.uint32(g.deltaPath[e]);
      E.ldelim();
    }
    return g.elementDimensionSpec != null && Object.hasOwnProperty.call(g, "elementDimensionSpec") && $root$1.ElementDimensionSpec.encode(g.elementDimensionSpec, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.activeScriptHash != null && Object.hasOwnProperty.call(g, "activeScriptHash") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.activeScriptHash), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ForwardMsgMetadata();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.cacheable = g.bool();
          break;
        }
        case 2: {
          if (n.deltaPath && n.deltaPath.length || (n.deltaPath = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.deltaPath.push(g.uint32());
          } else n.deltaPath.push(g.uint32());
          break;
        }
        case 3: {
          n.elementDimensionSpec = $root$1.ElementDimensionSpec.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.activeScriptHash = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ForwardMsgMetadata) return g;
    let E = new $root$1.ForwardMsgMetadata();
    if (g.cacheable != null && (E.cacheable = !!g.cacheable), g.deltaPath) {
      if (!Array.isArray(g.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      E.deltaPath = [];
      for (let e = 0; e < g.deltaPath.length; ++e) E.deltaPath[e] = g.deltaPath[e] >>> 0;
    }
    if (g.elementDimensionSpec != null) {
      if (typeof g.elementDimensionSpec != "object") throw TypeError(".ForwardMsgMetadata.elementDimensionSpec: object expected");
      E.elementDimensionSpec = $root$1.ElementDimensionSpec.fromObject(g.elementDimensionSpec);
    }
    return g.activeScriptHash != null && (E.activeScriptHash = String(g.activeScriptHash)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.deltaPath = []), E.defaults && (e.cacheable = !1, e.elementDimensionSpec = null, e.activeScriptHash = ""), g.cacheable != null && g.hasOwnProperty("cacheable") && (e.cacheable = g.cacheable), g.deltaPath && g.deltaPath.length) {
      e.deltaPath = [];
      for (let t = 0; t < g.deltaPath.length; ++t) e.deltaPath[t] = g.deltaPath[t];
    }
    return g.elementDimensionSpec != null && g.hasOwnProperty("elementDimensionSpec") && (e.elementDimensionSpec = $root$1.ElementDimensionSpec.toObject(g.elementDimensionSpec, E)), g.activeScriptHash != null && g.hasOwnProperty("activeScriptHash") && (e.activeScriptHash = g.activeScriptHash), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ForwardMsgMetadata";
  }, o;
})();
$root$1.ElementDimensionSpec = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.width = 0, o.prototype.height = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.width != null && Object.hasOwnProperty.call(g, "width") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(g.width), g.height != null && Object.hasOwnProperty.call(g, "height") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(g.height), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ElementDimensionSpec();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.width = g.uint32();
          break;
        }
        case 2: {
          n.height = g.uint32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ElementDimensionSpec) return g;
    let E = new $root$1.ElementDimensionSpec();
    return g.width != null && (E.width = g.width >>> 0), g.height != null && (E.height = g.height >>> 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.width = 0, e.height = 0), g.width != null && g.hasOwnProperty("width") && (e.width = g.width), g.height != null && g.hasOwnProperty("height") && (e.height = g.height), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ElementDimensionSpec";
  }, o;
})();
$root$1.ForwardMsgList = (() => {
  function o(i) {
    if (this.messages = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.messages = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.messages != null && g.messages.length) for (let e = 0; e < g.messages.length; ++e) $root$1.ForwardMsg.encode(g.messages[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ForwardMsgList();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.messages && n.messages.length || (n.messages = []), n.messages.push($root$1.ForwardMsg.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ForwardMsgList) return g;
    let E = new $root$1.ForwardMsgList();
    if (g.messages) {
      if (!Array.isArray(g.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
      E.messages = [];
      for (let e = 0; e < g.messages.length; ++e) {
        if (typeof g.messages[e] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
        E.messages[e] = $root$1.ForwardMsg.fromObject(g.messages[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.messages = []), g.messages && g.messages.length) {
      e.messages = [];
      for (let t = 0; t < g.messages.length; ++t) e.messages[t] = $root$1.ForwardMsg.toObject(g.messages[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ForwardMsgList";
  }, o;
})();
const GitInfo = $root$1.GitInfo = (() => {
  function o(i) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.repository = "", o.prototype.branch = "", o.prototype.module = "", o.prototype.untrackedFiles = $util$1.emptyArray, o.prototype.uncommittedFiles = $util$1.emptyArray, o.prototype.state = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.repository != null && Object.hasOwnProperty.call(g, "repository") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.repository), g.branch != null && Object.hasOwnProperty.call(g, "branch") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.branch), g.module != null && Object.hasOwnProperty.call(g, "module") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.module), g.untrackedFiles != null && g.untrackedFiles.length) for (let e = 0; e < g.untrackedFiles.length; ++e) E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.untrackedFiles[e]);
    if (g.uncommittedFiles != null && g.uncommittedFiles.length) for (let e = 0; e < g.uncommittedFiles.length; ++e) E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.uncommittedFiles[e]);
    return g.state != null && Object.hasOwnProperty.call(g, "state") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.state), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.GitInfo();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.repository = g.string();
          break;
        }
        case 2: {
          n.branch = g.string();
          break;
        }
        case 3: {
          n.module = g.string();
          break;
        }
        case 4: {
          n.untrackedFiles && n.untrackedFiles.length || (n.untrackedFiles = []), n.untrackedFiles.push(g.string());
          break;
        }
        case 5: {
          n.uncommittedFiles && n.uncommittedFiles.length || (n.uncommittedFiles = []), n.uncommittedFiles.push(g.string());
          break;
        }
        case 6: {
          n.state = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.GitInfo) return g;
    let E = new $root$1.GitInfo();
    if (g.repository != null && (E.repository = String(g.repository)), g.branch != null && (E.branch = String(g.branch)), g.module != null && (E.module = String(g.module)), g.untrackedFiles) {
      if (!Array.isArray(g.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
      E.untrackedFiles = [];
      for (let e = 0; e < g.untrackedFiles.length; ++e) E.untrackedFiles[e] = String(g.untrackedFiles[e]);
    }
    if (g.uncommittedFiles) {
      if (!Array.isArray(g.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
      E.uncommittedFiles = [];
      for (let e = 0; e < g.uncommittedFiles.length; ++e) E.uncommittedFiles[e] = String(g.uncommittedFiles[e]);
    }
    switch (g.state) {
      default:
        if (typeof g.state == "number") {
          E.state = g.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        E.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        E.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        E.state = 2;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.untrackedFiles = [], e.uncommittedFiles = []), E.defaults && (e.repository = "", e.branch = "", e.module = "", e.state = E.enums === String ? "DEFAULT" : 0), g.repository != null && g.hasOwnProperty("repository") && (e.repository = g.repository), g.branch != null && g.hasOwnProperty("branch") && (e.branch = g.branch), g.module != null && g.hasOwnProperty("module") && (e.module = g.module), g.untrackedFiles && g.untrackedFiles.length) {
      e.untrackedFiles = [];
      for (let t = 0; t < g.untrackedFiles.length; ++t) e.untrackedFiles[t] = g.untrackedFiles[t];
    }
    if (g.uncommittedFiles && g.uncommittedFiles.length) {
      e.uncommittedFiles = [];
      for (let t = 0; t < g.uncommittedFiles.length; ++t) e.uncommittedFiles[t] = g.uncommittedFiles[t];
    }
    return g.state != null && g.hasOwnProperty("state") && (e.state = E.enums === String ? $root$1.GitInfo.GitStates[g.state] === void 0 ? g.state : $root$1.GitInfo.GitStates[g.state] : g.state), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/GitInfo";
  }, o.GitStates = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "DEFAULT"] = 0, g[i[1] = "HEAD_DETACHED"] = 1, g[i[2] = "AHEAD_OF_REMOTE"] = 2, g;
  })(), o;
})(), Logo = $root$1.Logo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.image = "", o.prototype.link = "", o.prototype.iconImage = "", o.prototype.size = "", o.prototype.imageType = 0, o.prototype.iconImageType = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.image != null && Object.hasOwnProperty.call(g, "image") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.image), g.link != null && Object.hasOwnProperty.call(g, "link") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.link), g.iconImage != null && Object.hasOwnProperty.call(g, "iconImage") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.iconImage), g.size != null && Object.hasOwnProperty.call(g, "size") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.size), g.imageType != null && Object.hasOwnProperty.call(g, "imageType") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.imageType), g.iconImageType != null && Object.hasOwnProperty.call(g, "iconImageType") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.iconImageType), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Logo();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.image = g.string();
          break;
        }
        case 2: {
          n.link = g.string();
          break;
        }
        case 3: {
          n.iconImage = g.string();
          break;
        }
        case 4: {
          n.size = g.string();
          break;
        }
        case 5: {
          n.imageType = g.int32();
          break;
        }
        case 6: {
          n.iconImageType = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Logo) return g;
    let E = new $root$1.Logo();
    switch (g.image != null && (E.image = String(g.image)), g.link != null && (E.link = String(g.link)), g.iconImage != null && (E.iconImage = String(g.iconImage)), g.size != null && (E.size = String(g.size)), g.imageType) {
      default:
        if (typeof g.imageType == "number") {
          E.imageType = g.imageType;
          break;
        }
        break;
      case "IMAGE":
      case 0:
        E.imageType = 0;
        break;
      case "EMOJI":
      case 1:
        E.imageType = 1;
        break;
      case "ICON":
      case 2:
        E.imageType = 2;
        break;
    }
    switch (g.iconImageType) {
      default:
        if (typeof g.iconImageType == "number") {
          E.iconImageType = g.iconImageType;
          break;
        }
        break;
      case "IMAGE":
      case 0:
        E.iconImageType = 0;
        break;
      case "EMOJI":
      case 1:
        E.iconImageType = 1;
        break;
      case "ICON":
      case 2:
        E.iconImageType = 2;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.image = "", e.link = "", e.iconImage = "", e.size = "", e.imageType = E.enums === String ? "IMAGE" : 0, e.iconImageType = E.enums === String ? "IMAGE" : 0), g.image != null && g.hasOwnProperty("image") && (e.image = g.image), g.link != null && g.hasOwnProperty("link") && (e.link = g.link), g.iconImage != null && g.hasOwnProperty("iconImage") && (e.iconImage = g.iconImage), g.size != null && g.hasOwnProperty("size") && (e.size = g.size), g.imageType != null && g.hasOwnProperty("imageType") && (e.imageType = E.enums === String ? $root$1.Logo.ImageType[g.imageType] === void 0 ? g.imageType : $root$1.Logo.ImageType[g.imageType] : g.imageType), g.iconImageType != null && g.hasOwnProperty("iconImageType") && (e.iconImageType = E.enums === String ? $root$1.Logo.ImageType[g.iconImageType] === void 0 ? g.iconImageType : $root$1.Logo.ImageType[g.iconImageType] : g.iconImageType), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Logo";
  }, o.ImageType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "IMAGE"] = 0, g[i[1] = "EMOJI"] = 1, g[i[2] = "ICON"] = 2, g;
  })(), o;
})(), Navigation = $root$1.Navigation = (() => {
  function o(i) {
    if (this.sections = [], this.appPages = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.sections = $util$1.emptyArray, o.prototype.appPages = $util$1.emptyArray, o.prototype.position = 0, o.prototype.pageScriptHash = "", o.prototype.expanded = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.sections != null && g.sections.length) for (let e = 0; e < g.sections.length; ++e) E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.sections[e]);
    if (g.appPages != null && g.appPages.length) for (let e = 0; e < g.appPages.length; ++e) $root$1.AppPage.encode(g.appPages[e], E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g.position != null && Object.hasOwnProperty.call(g, "position") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.position), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.pageScriptHash), g.expanded != null && Object.hasOwnProperty.call(g, "expanded") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.expanded), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Navigation();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.sections && n.sections.length || (n.sections = []), n.sections.push(g.string());
          break;
        }
        case 2: {
          n.appPages && n.appPages.length || (n.appPages = []), n.appPages.push($root$1.AppPage.decode(g, g.uint32()));
          break;
        }
        case 3: {
          n.position = g.int32();
          break;
        }
        case 4: {
          n.pageScriptHash = g.string();
          break;
        }
        case 5: {
          n.expanded = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Navigation) return g;
    let E = new $root$1.Navigation();
    if (g.sections) {
      if (!Array.isArray(g.sections)) throw TypeError(".Navigation.sections: array expected");
      E.sections = [];
      for (let e = 0; e < g.sections.length; ++e) E.sections[e] = String(g.sections[e]);
    }
    if (g.appPages) {
      if (!Array.isArray(g.appPages)) throw TypeError(".Navigation.appPages: array expected");
      E.appPages = [];
      for (let e = 0; e < g.appPages.length; ++e) {
        if (typeof g.appPages[e] != "object") throw TypeError(".Navigation.appPages: object expected");
        E.appPages[e] = $root$1.AppPage.fromObject(g.appPages[e]);
      }
    }
    switch (g.position) {
      default:
        if (typeof g.position == "number") {
          E.position = g.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        E.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        E.position = 1;
        break;
      case "TOP":
      case 2:
        E.position = 2;
        break;
    }
    return g.pageScriptHash != null && (E.pageScriptHash = String(g.pageScriptHash)), g.expanded != null && (E.expanded = !!g.expanded), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.sections = [], e.appPages = []), E.defaults && (e.position = E.enums === String ? "HIDDEN" : 0, e.pageScriptHash = "", e.expanded = !1), g.sections && g.sections.length) {
      e.sections = [];
      for (let t = 0; t < g.sections.length; ++t) e.sections[t] = g.sections[t];
    }
    if (g.appPages && g.appPages.length) {
      e.appPages = [];
      for (let t = 0; t < g.appPages.length; ++t) e.appPages[t] = $root$1.AppPage.toObject(g.appPages[t], E);
    }
    return g.position != null && g.hasOwnProperty("position") && (e.position = E.enums === String ? $root$1.Navigation.Position[g.position] === void 0 ? g.position : $root$1.Navigation.Position[g.position] : g.position), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = g.pageScriptHash), g.expanded != null && g.hasOwnProperty("expanded") && (e.expanded = g.expanded), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Navigation";
  }, o.Position = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "HIDDEN"] = 0, g[i[1] = "SIDEBAR"] = 1, g[i[2] = "TOP"] = 2, g;
  })(), o;
})();
$root$1.NewSession = (() => {
  function o(i) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.initialize = null, o.prototype.scriptRunId = "", o.prototype.name = "", o.prototype.mainScriptPath = "", o.prototype.config = null, o.prototype.customTheme = null, o.prototype.appPages = $util$1.emptyArray, o.prototype.pageScriptHash = "", o.prototype.fragmentIdsThisRun = $util$1.emptyArray, o.prototype.mainScriptHash = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.initialize != null && Object.hasOwnProperty.call(g, "initialize") && $root$1.Initialize.encode(g.initialize, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.scriptRunId != null && Object.hasOwnProperty.call(g, "scriptRunId") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.scriptRunId), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.name), g.mainScriptPath != null && Object.hasOwnProperty.call(g, "mainScriptPath") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.mainScriptPath), g.config != null && Object.hasOwnProperty.call(g, "config") && $root$1.Config.encode(g.config, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.customTheme != null && Object.hasOwnProperty.call(g, "customTheme") && $root$1.CustomThemeConfig.encode(g.customTheme, E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.appPages != null && g.appPages.length) for (let e = 0; e < g.appPages.length; ++e) $root$1.AppPage.encode(g.appPages[e], E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    if (g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.pageScriptHash), g.fragmentIdsThisRun != null && g.fragmentIdsThisRun.length) for (let e = 0; e < g.fragmentIdsThisRun.length; ++e) E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.fragmentIdsThisRun[e]);
    return g.mainScriptHash != null && Object.hasOwnProperty.call(g, "mainScriptHash") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.mainScriptHash), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.NewSession();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.initialize = $root$1.Initialize.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.scriptRunId = g.string();
          break;
        }
        case 3: {
          n.name = g.string();
          break;
        }
        case 4: {
          n.mainScriptPath = g.string();
          break;
        }
        case 6: {
          n.config = $root$1.Config.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.customTheme = $root$1.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.appPages && n.appPages.length || (n.appPages = []), n.appPages.push($root$1.AppPage.decode(g, g.uint32()));
          break;
        }
        case 9: {
          n.pageScriptHash = g.string();
          break;
        }
        case 10: {
          n.fragmentIdsThisRun && n.fragmentIdsThisRun.length || (n.fragmentIdsThisRun = []), n.fragmentIdsThisRun.push(g.string());
          break;
        }
        case 11: {
          n.mainScriptHash = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.NewSession) return g;
    let E = new $root$1.NewSession();
    if (g.initialize != null) {
      if (typeof g.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
      E.initialize = $root$1.Initialize.fromObject(g.initialize);
    }
    if (g.scriptRunId != null && (E.scriptRunId = String(g.scriptRunId)), g.name != null && (E.name = String(g.name)), g.mainScriptPath != null && (E.mainScriptPath = String(g.mainScriptPath)), g.config != null) {
      if (typeof g.config != "object") throw TypeError(".NewSession.config: object expected");
      E.config = $root$1.Config.fromObject(g.config);
    }
    if (g.customTheme != null) {
      if (typeof g.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
      E.customTheme = $root$1.CustomThemeConfig.fromObject(g.customTheme);
    }
    if (g.appPages) {
      if (!Array.isArray(g.appPages)) throw TypeError(".NewSession.appPages: array expected");
      E.appPages = [];
      for (let e = 0; e < g.appPages.length; ++e) {
        if (typeof g.appPages[e] != "object") throw TypeError(".NewSession.appPages: object expected");
        E.appPages[e] = $root$1.AppPage.fromObject(g.appPages[e]);
      }
    }
    if (g.pageScriptHash != null && (E.pageScriptHash = String(g.pageScriptHash)), g.fragmentIdsThisRun) {
      if (!Array.isArray(g.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      E.fragmentIdsThisRun = [];
      for (let e = 0; e < g.fragmentIdsThisRun.length; ++e) E.fragmentIdsThisRun[e] = String(g.fragmentIdsThisRun[e]);
    }
    return g.mainScriptHash != null && (E.mainScriptHash = String(g.mainScriptHash)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.appPages = [], e.fragmentIdsThisRun = []), E.defaults && (e.initialize = null, e.scriptRunId = "", e.name = "", e.mainScriptPath = "", e.config = null, e.customTheme = null, e.pageScriptHash = "", e.mainScriptHash = ""), g.initialize != null && g.hasOwnProperty("initialize") && (e.initialize = $root$1.Initialize.toObject(g.initialize, E)), g.scriptRunId != null && g.hasOwnProperty("scriptRunId") && (e.scriptRunId = g.scriptRunId), g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.mainScriptPath != null && g.hasOwnProperty("mainScriptPath") && (e.mainScriptPath = g.mainScriptPath), g.config != null && g.hasOwnProperty("config") && (e.config = $root$1.Config.toObject(g.config, E)), g.customTheme != null && g.hasOwnProperty("customTheme") && (e.customTheme = $root$1.CustomThemeConfig.toObject(g.customTheme, E)), g.appPages && g.appPages.length) {
      e.appPages = [];
      for (let t = 0; t < g.appPages.length; ++t) e.appPages[t] = $root$1.AppPage.toObject(g.appPages[t], E);
    }
    if (g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = g.pageScriptHash), g.fragmentIdsThisRun && g.fragmentIdsThisRun.length) {
      e.fragmentIdsThisRun = [];
      for (let t = 0; t < g.fragmentIdsThisRun.length; ++t) e.fragmentIdsThisRun[t] = g.fragmentIdsThisRun[t];
    }
    return g.mainScriptHash != null && g.hasOwnProperty("mainScriptHash") && (e.mainScriptHash = g.mainScriptHash), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/NewSession";
  }, o;
})();
$root$1.Initialize = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.userInfo = null, o.prototype.environmentInfo = null, o.prototype.sessionStatus = null, o.prototype.commandLine = "", o.prototype.sessionId = "", o.prototype.isHello = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.userInfo != null && Object.hasOwnProperty.call(g, "userInfo") && $root$1.UserInfo.encode(g.userInfo, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.environmentInfo != null && Object.hasOwnProperty.call(g, "environmentInfo") && $root$1.EnvironmentInfo.encode(g.environmentInfo, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.sessionStatus != null && Object.hasOwnProperty.call(g, "sessionStatus") && $root$1.SessionStatus.encode(g.sessionStatus, E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.commandLine != null && Object.hasOwnProperty.call(g, "commandLine") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.commandLine), g.sessionId != null && Object.hasOwnProperty.call(g, "sessionId") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.sessionId), g.isHello != null && Object.hasOwnProperty.call(g, "isHello") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.isHello), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Initialize();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.userInfo = $root$1.UserInfo.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.environmentInfo = $root$1.EnvironmentInfo.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.sessionStatus = $root$1.SessionStatus.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.commandLine = g.string();
          break;
        }
        case 6: {
          n.sessionId = g.string();
          break;
        }
        case 7: {
          n.isHello = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Initialize) return g;
    let E = new $root$1.Initialize();
    if (g.userInfo != null) {
      if (typeof g.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
      E.userInfo = $root$1.UserInfo.fromObject(g.userInfo);
    }
    if (g.environmentInfo != null) {
      if (typeof g.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
      E.environmentInfo = $root$1.EnvironmentInfo.fromObject(g.environmentInfo);
    }
    if (g.sessionStatus != null) {
      if (typeof g.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
      E.sessionStatus = $root$1.SessionStatus.fromObject(g.sessionStatus);
    }
    return g.commandLine != null && (E.commandLine = String(g.commandLine)), g.sessionId != null && (E.sessionId = String(g.sessionId)), g.isHello != null && (E.isHello = !!g.isHello), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.userInfo = null, e.environmentInfo = null, e.sessionStatus = null, e.commandLine = "", e.sessionId = "", e.isHello = !1), g.userInfo != null && g.hasOwnProperty("userInfo") && (e.userInfo = $root$1.UserInfo.toObject(g.userInfo, E)), g.environmentInfo != null && g.hasOwnProperty("environmentInfo") && (e.environmentInfo = $root$1.EnvironmentInfo.toObject(g.environmentInfo, E)), g.sessionStatus != null && g.hasOwnProperty("sessionStatus") && (e.sessionStatus = $root$1.SessionStatus.toObject(g.sessionStatus, E)), g.commandLine != null && g.hasOwnProperty("commandLine") && (e.commandLine = g.commandLine), g.sessionId != null && g.hasOwnProperty("sessionId") && (e.sessionId = g.sessionId), g.isHello != null && g.hasOwnProperty("isHello") && (e.isHello = g.isHello), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Initialize";
  }, o;
})();
const Config = $root$1.Config = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.gatherUsageStats = !1, o.prototype.maxCachedMessageAge = 0, o.prototype.mapboxToken = "", o.prototype.allowRunOnSave = !1, o.prototype.hideTopBar = !1, o.prototype.hideSidebarNav = !1, o.prototype.toolbarMode = 0, o.prototype.showErrorLinks = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.gatherUsageStats != null && Object.hasOwnProperty.call(g, "gatherUsageStats") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.gatherUsageStats), g.maxCachedMessageAge != null && Object.hasOwnProperty.call(g, "maxCachedMessageAge") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.maxCachedMessageAge), g.mapboxToken != null && Object.hasOwnProperty.call(g, "mapboxToken") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.mapboxToken), g.allowRunOnSave != null && Object.hasOwnProperty.call(g, "allowRunOnSave") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.allowRunOnSave), g.hideTopBar != null && Object.hasOwnProperty.call(g, "hideTopBar") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.hideTopBar), g.hideSidebarNav != null && Object.hasOwnProperty.call(g, "hideSidebarNav") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.hideSidebarNav), g.toolbarMode != null && Object.hasOwnProperty.call(g, "toolbarMode") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.toolbarMode), g.showErrorLinks != null && Object.hasOwnProperty.call(g, "showErrorLinks") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(g.showErrorLinks), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Config();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 2: {
          n.gatherUsageStats = g.bool();
          break;
        }
        case 3: {
          n.maxCachedMessageAge = g.int32();
          break;
        }
        case 4: {
          n.mapboxToken = g.string();
          break;
        }
        case 5: {
          n.allowRunOnSave = g.bool();
          break;
        }
        case 6: {
          n.hideTopBar = g.bool();
          break;
        }
        case 7: {
          n.hideSidebarNav = g.bool();
          break;
        }
        case 8: {
          n.toolbarMode = g.int32();
          break;
        }
        case 9: {
          n.showErrorLinks = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Config) return g;
    let E = new $root$1.Config();
    switch (g.gatherUsageStats != null && (E.gatherUsageStats = !!g.gatherUsageStats), g.maxCachedMessageAge != null && (E.maxCachedMessageAge = g.maxCachedMessageAge | 0), g.mapboxToken != null && (E.mapboxToken = String(g.mapboxToken)), g.allowRunOnSave != null && (E.allowRunOnSave = !!g.allowRunOnSave), g.hideTopBar != null && (E.hideTopBar = !!g.hideTopBar), g.hideSidebarNav != null && (E.hideSidebarNav = !!g.hideSidebarNav), g.toolbarMode) {
      default:
        if (typeof g.toolbarMode == "number") {
          E.toolbarMode = g.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        E.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        E.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        E.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        E.toolbarMode = 3;
        break;
    }
    switch (g.showErrorLinks) {
      default:
        if (typeof g.showErrorLinks == "number") {
          E.showErrorLinks = g.showErrorLinks;
          break;
        }
        break;
      case "SHOW_ERROR_LINKS_UNSPECIFIED":
      case 0:
        E.showErrorLinks = 0;
        break;
      case "SHOW_ERROR_LINKS_AUTO":
      case 1:
        E.showErrorLinks = 1;
        break;
      case "SHOW_ERROR_LINKS_TRUE":
      case 2:
        E.showErrorLinks = 2;
        break;
      case "SHOW_ERROR_LINKS_FALSE":
      case 3:
        E.showErrorLinks = 3;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.gatherUsageStats = !1, e.maxCachedMessageAge = 0, e.mapboxToken = "", e.allowRunOnSave = !1, e.hideTopBar = !1, e.hideSidebarNav = !1, e.toolbarMode = E.enums === String ? "AUTO" : 0, e.showErrorLinks = E.enums === String ? "SHOW_ERROR_LINKS_UNSPECIFIED" : 0), g.gatherUsageStats != null && g.hasOwnProperty("gatherUsageStats") && (e.gatherUsageStats = g.gatherUsageStats), g.maxCachedMessageAge != null && g.hasOwnProperty("maxCachedMessageAge") && (e.maxCachedMessageAge = g.maxCachedMessageAge), g.mapboxToken != null && g.hasOwnProperty("mapboxToken") && (e.mapboxToken = g.mapboxToken), g.allowRunOnSave != null && g.hasOwnProperty("allowRunOnSave") && (e.allowRunOnSave = g.allowRunOnSave), g.hideTopBar != null && g.hasOwnProperty("hideTopBar") && (e.hideTopBar = g.hideTopBar), g.hideSidebarNav != null && g.hasOwnProperty("hideSidebarNav") && (e.hideSidebarNav = g.hideSidebarNav), g.toolbarMode != null && g.hasOwnProperty("toolbarMode") && (e.toolbarMode = E.enums === String ? $root$1.Config.ToolbarMode[g.toolbarMode] === void 0 ? g.toolbarMode : $root$1.Config.ToolbarMode[g.toolbarMode] : g.toolbarMode), g.showErrorLinks != null && g.hasOwnProperty("showErrorLinks") && (e.showErrorLinks = E.enums === String ? $root$1.Config.ShowErrorLinks[g.showErrorLinks] === void 0 ? g.showErrorLinks : $root$1.Config.ShowErrorLinks[g.showErrorLinks] : g.showErrorLinks), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Config";
  }, o.ToolbarMode = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "AUTO"] = 0, g[i[1] = "DEVELOPER"] = 1, g[i[2] = "VIEWER"] = 2, g[i[3] = "MINIMAL"] = 3, g;
  })(), o.ShowErrorLinks = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "SHOW_ERROR_LINKS_UNSPECIFIED"] = 0, g[i[1] = "SHOW_ERROR_LINKS_AUTO"] = 1, g[i[2] = "SHOW_ERROR_LINKS_TRUE"] = 2, g[i[3] = "SHOW_ERROR_LINKS_FALSE"] = 3, g;
  })(), o;
})(), CustomThemeConfig = $root$1.CustomThemeConfig = (() => {
  function o(g) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], this.chartDivergingColors = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.primaryColor = "", o.prototype.secondaryBackgroundColor = "", o.prototype.backgroundColor = "", o.prototype.textColor = "", o.prototype.font = 0, o.prototype.base = 0, o.prototype.widgetBackgroundColor = "", o.prototype.widgetBorderColor = "", o.prototype.radii = null, o.prototype.headingFont = "", o.prototype.bodyFont = "", o.prototype.codeFont = "", o.prototype.fontFaces = $util$1.emptyArray, o.prototype.fontSources = $util$1.emptyArray, o.prototype.fontSizes = null, o.prototype.skeletonBackgroundColor = "", o.prototype.baseRadius = null, o.prototype.buttonRadius = null, o.prototype.borderColor = null, o.prototype.dataframeBorderColor = null, o.prototype.showWidgetBorder = null, o.prototype.linkColor = null, o.prototype.linkUnderline = null, o.prototype.baseFontSize = null, o.prototype.baseFontWeight = null, o.prototype.codeFontWeight = null, o.prototype.codeFontSize = null, o.prototype.headingFontSizes = $util$1.emptyArray, o.prototype.headingFontWeights = $util$1.emptyArray, o.prototype.showSidebarBorder = null, o.prototype.codeTextColor = null, o.prototype.codeBackgroundColor = null, o.prototype.dataframeHeaderBackgroundColor = null, o.prototype.chartCategoricalColors = $util$1.emptyArray, o.prototype.chartSequentialColors = $util$1.emptyArray, o.prototype.chartDivergingColors = $util$1.emptyArray, o.prototype.redColor = null, o.prototype.orangeColor = null, o.prototype.yellowColor = null, o.prototype.blueColor = null, o.prototype.greenColor = null, o.prototype.violetColor = null, o.prototype.grayColor = null, o.prototype.redBackgroundColor = null, o.prototype.orangeBackgroundColor = null, o.prototype.yellowBackgroundColor = null, o.prototype.blueBackgroundColor = null, o.prototype.greenBackgroundColor = null, o.prototype.violetBackgroundColor = null, o.prototype.grayBackgroundColor = null, o.prototype.redTextColor = null, o.prototype.orangeTextColor = null, o.prototype.yellowTextColor = null, o.prototype.blueTextColor = null, o.prototype.greenTextColor = null, o.prototype.violetTextColor = null, o.prototype.grayTextColor = null, o.prototype.sidebar = null, o.prototype.light = null, o.prototype.dark = null;
  let i;
  return Object.defineProperty(o.prototype, "_baseRadius", { get: $util$1.oneOfGetter(i = ["baseRadius"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_buttonRadius", { get: $util$1.oneOfGetter(i = ["buttonRadius"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_borderColor", { get: $util$1.oneOfGetter(i = ["borderColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_dataframeBorderColor", { get: $util$1.oneOfGetter(i = ["dataframeBorderColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_showWidgetBorder", { get: $util$1.oneOfGetter(i = ["showWidgetBorder"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_linkColor", { get: $util$1.oneOfGetter(i = ["linkColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_linkUnderline", { get: $util$1.oneOfGetter(i = ["linkUnderline"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_baseFontSize", { get: $util$1.oneOfGetter(i = ["baseFontSize"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_baseFontWeight", { get: $util$1.oneOfGetter(i = ["baseFontWeight"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_codeFontWeight", { get: $util$1.oneOfGetter(i = ["codeFontWeight"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_codeFontSize", { get: $util$1.oneOfGetter(i = ["codeFontSize"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_showSidebarBorder", { get: $util$1.oneOfGetter(i = ["showSidebarBorder"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_codeTextColor", { get: $util$1.oneOfGetter(i = ["codeTextColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_codeBackgroundColor", { get: $util$1.oneOfGetter(i = ["codeBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_dataframeHeaderBackgroundColor", { get: $util$1.oneOfGetter(i = ["dataframeHeaderBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_redColor", { get: $util$1.oneOfGetter(i = ["redColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_orangeColor", { get: $util$1.oneOfGetter(i = ["orangeColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_yellowColor", { get: $util$1.oneOfGetter(i = ["yellowColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_blueColor", { get: $util$1.oneOfGetter(i = ["blueColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_greenColor", { get: $util$1.oneOfGetter(i = ["greenColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_violetColor", { get: $util$1.oneOfGetter(i = ["violetColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_grayColor", { get: $util$1.oneOfGetter(i = ["grayColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_redBackgroundColor", { get: $util$1.oneOfGetter(i = ["redBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_orangeBackgroundColor", { get: $util$1.oneOfGetter(i = ["orangeBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_yellowBackgroundColor", { get: $util$1.oneOfGetter(i = ["yellowBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_blueBackgroundColor", { get: $util$1.oneOfGetter(i = ["blueBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_greenBackgroundColor", { get: $util$1.oneOfGetter(i = ["greenBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_violetBackgroundColor", { get: $util$1.oneOfGetter(i = ["violetBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_grayBackgroundColor", { get: $util$1.oneOfGetter(i = ["grayBackgroundColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_redTextColor", { get: $util$1.oneOfGetter(i = ["redTextColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_orangeTextColor", { get: $util$1.oneOfGetter(i = ["orangeTextColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_yellowTextColor", { get: $util$1.oneOfGetter(i = ["yellowTextColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_blueTextColor", { get: $util$1.oneOfGetter(i = ["blueTextColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_greenTextColor", { get: $util$1.oneOfGetter(i = ["greenTextColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_violetTextColor", { get: $util$1.oneOfGetter(i = ["violetTextColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_grayTextColor", { get: $util$1.oneOfGetter(i = ["grayTextColor"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_sidebar", { get: $util$1.oneOfGetter(i = ["sidebar"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_light", { get: $util$1.oneOfGetter(i = ["light"]), set: $util$1.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_dark", { get: $util$1.oneOfGetter(i = ["dark"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    if (e || (e = $Writer$1.create()), E.primaryColor != null && Object.hasOwnProperty.call(E, "primaryColor") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.primaryColor), E.secondaryBackgroundColor != null && Object.hasOwnProperty.call(E, "secondaryBackgroundColor") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.secondaryBackgroundColor), E.backgroundColor != null && Object.hasOwnProperty.call(E, "backgroundColor") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.backgroundColor), E.textColor != null && Object.hasOwnProperty.call(E, "textColor") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.textColor), E.font != null && Object.hasOwnProperty.call(E, "font") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(E.font), E.base != null && Object.hasOwnProperty.call(E, "base") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(E.base), E.widgetBackgroundColor != null && Object.hasOwnProperty.call(E, "widgetBackgroundColor") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.widgetBackgroundColor), E.widgetBorderColor != null && Object.hasOwnProperty.call(E, "widgetBorderColor") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.widgetBorderColor), E.radii != null && Object.hasOwnProperty.call(E, "radii") && $root$1.Radii.encode(E.radii, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E.headingFont != null && Object.hasOwnProperty.call(E, "headingFont") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(E.headingFont), E.bodyFont != null && Object.hasOwnProperty.call(E, "bodyFont") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.bodyFont), E.codeFont != null && Object.hasOwnProperty.call(E, "codeFont") && e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(E.codeFont), E.fontFaces != null && E.fontFaces.length) for (let t = 0; t < E.fontFaces.length; ++t) $root$1.FontFace.encode(E.fontFaces[t], e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim();
    if (E.fontSizes != null && Object.hasOwnProperty.call(E, "fontSizes") && $root$1.FontSizes.encode(E.fontSizes, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), E.skeletonBackgroundColor != null && Object.hasOwnProperty.call(E, "skeletonBackgroundColor") && e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(E.skeletonBackgroundColor), E.baseRadius != null && Object.hasOwnProperty.call(E, "baseRadius") && e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(E.baseRadius), E.borderColor != null && Object.hasOwnProperty.call(E, "borderColor") && e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(E.borderColor), E.showWidgetBorder != null && Object.hasOwnProperty.call(E, "showWidgetBorder") && e.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(E.showWidgetBorder), E.linkColor != null && Object.hasOwnProperty.call(E, "linkColor") && e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(E.linkColor), E.baseFontSize != null && Object.hasOwnProperty.call(E, "baseFontSize") && e.uint32(
      /* id 22, wireType 0 =*/
      176
    ).int32(E.baseFontSize), E.showSidebarBorder != null && Object.hasOwnProperty.call(E, "showSidebarBorder") && e.uint32(
      /* id 23, wireType 0 =*/
      184
    ).bool(E.showSidebarBorder), E.sidebar != null && Object.hasOwnProperty.call(E, "sidebar") && $root$1.CustomThemeConfig.encode(E.sidebar, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), E.codeBackgroundColor != null && Object.hasOwnProperty.call(E, "codeBackgroundColor") && e.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(E.codeBackgroundColor), E.buttonRadius != null && Object.hasOwnProperty.call(E, "buttonRadius") && e.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(E.buttonRadius), E.dataframeBorderColor != null && Object.hasOwnProperty.call(E, "dataframeBorderColor") && e.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(E.dataframeBorderColor), E.codeFontSize != null && Object.hasOwnProperty.call(E, "codeFontSize") && e.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(E.codeFontSize), E.linkUnderline != null && Object.hasOwnProperty.call(E, "linkUnderline") && e.uint32(
      /* id 29, wireType 0 =*/
      232
    ).bool(E.linkUnderline), E.baseFontWeight != null && Object.hasOwnProperty.call(E, "baseFontWeight") && e.uint32(
      /* id 30, wireType 0 =*/
      240
    ).int32(E.baseFontWeight), E.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(E, "dataframeHeaderBackgroundColor") && e.uint32(
      /* id 31, wireType 2 =*/
      250
    ).string(E.dataframeHeaderBackgroundColor), E.codeFontWeight != null && Object.hasOwnProperty.call(E, "codeFontWeight") && e.uint32(
      /* id 32, wireType 0 =*/
      256
    ).int32(E.codeFontWeight), E.chartCategoricalColors != null && E.chartCategoricalColors.length) for (let t = 0; t < E.chartCategoricalColors.length; ++t) e.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(E.chartCategoricalColors[t]);
    if (E.headingFontWeights != null && E.headingFontWeights.length) {
      e.uint32(
        /* id 34, wireType 2 =*/
        274
      ).fork();
      for (let t = 0; t < E.headingFontWeights.length; ++t) e.int32(E.headingFontWeights[t]);
      e.ldelim();
    }
    if (E.headingFontSizes != null && E.headingFontSizes.length) for (let t = 0; t < E.headingFontSizes.length; ++t) e.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(E.headingFontSizes[t]);
    if (E.chartSequentialColors != null && E.chartSequentialColors.length) for (let t = 0; t < E.chartSequentialColors.length; ++t) e.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(E.chartSequentialColors[t]);
    if (E.fontSources != null && E.fontSources.length) for (let t = 0; t < E.fontSources.length; ++t) $root$1.FontSource.encode(E.fontSources[t], e.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim();
    if (E.redColor != null && Object.hasOwnProperty.call(E, "redColor") && e.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(E.redColor), E.orangeColor != null && Object.hasOwnProperty.call(E, "orangeColor") && e.uint32(
      /* id 39, wireType 2 =*/
      314
    ).string(E.orangeColor), E.yellowColor != null && Object.hasOwnProperty.call(E, "yellowColor") && e.uint32(
      /* id 40, wireType 2 =*/
      322
    ).string(E.yellowColor), E.blueColor != null && Object.hasOwnProperty.call(E, "blueColor") && e.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(E.blueColor), E.greenColor != null && Object.hasOwnProperty.call(E, "greenColor") && e.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(E.greenColor), E.violetColor != null && Object.hasOwnProperty.call(E, "violetColor") && e.uint32(
      /* id 43, wireType 2 =*/
      346
    ).string(E.violetColor), E.grayColor != null && Object.hasOwnProperty.call(E, "grayColor") && e.uint32(
      /* id 44, wireType 2 =*/
      354
    ).string(E.grayColor), E.redBackgroundColor != null && Object.hasOwnProperty.call(E, "redBackgroundColor") && e.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(E.redBackgroundColor), E.orangeBackgroundColor != null && Object.hasOwnProperty.call(E, "orangeBackgroundColor") && e.uint32(
      /* id 46, wireType 2 =*/
      370
    ).string(E.orangeBackgroundColor), E.yellowBackgroundColor != null && Object.hasOwnProperty.call(E, "yellowBackgroundColor") && e.uint32(
      /* id 47, wireType 2 =*/
      378
    ).string(E.yellowBackgroundColor), E.blueBackgroundColor != null && Object.hasOwnProperty.call(E, "blueBackgroundColor") && e.uint32(
      /* id 48, wireType 2 =*/
      386
    ).string(E.blueBackgroundColor), E.greenBackgroundColor != null && Object.hasOwnProperty.call(E, "greenBackgroundColor") && e.uint32(
      /* id 49, wireType 2 =*/
      394
    ).string(E.greenBackgroundColor), E.violetBackgroundColor != null && Object.hasOwnProperty.call(E, "violetBackgroundColor") && e.uint32(
      /* id 50, wireType 2 =*/
      402
    ).string(E.violetBackgroundColor), E.grayBackgroundColor != null && Object.hasOwnProperty.call(E, "grayBackgroundColor") && e.uint32(
      /* id 51, wireType 2 =*/
      410
    ).string(E.grayBackgroundColor), E.redTextColor != null && Object.hasOwnProperty.call(E, "redTextColor") && e.uint32(
      /* id 52, wireType 2 =*/
      418
    ).string(E.redTextColor), E.orangeTextColor != null && Object.hasOwnProperty.call(E, "orangeTextColor") && e.uint32(
      /* id 53, wireType 2 =*/
      426
    ).string(E.orangeTextColor), E.yellowTextColor != null && Object.hasOwnProperty.call(E, "yellowTextColor") && e.uint32(
      /* id 54, wireType 2 =*/
      434
    ).string(E.yellowTextColor), E.blueTextColor != null && Object.hasOwnProperty.call(E, "blueTextColor") && e.uint32(
      /* id 55, wireType 2 =*/
      442
    ).string(E.blueTextColor), E.greenTextColor != null && Object.hasOwnProperty.call(E, "greenTextColor") && e.uint32(
      /* id 56, wireType 2 =*/
      450
    ).string(E.greenTextColor), E.violetTextColor != null && Object.hasOwnProperty.call(E, "violetTextColor") && e.uint32(
      /* id 57, wireType 2 =*/
      458
    ).string(E.violetTextColor), E.grayTextColor != null && Object.hasOwnProperty.call(E, "grayTextColor") && e.uint32(
      /* id 58, wireType 2 =*/
      466
    ).string(E.grayTextColor), E.codeTextColor != null && Object.hasOwnProperty.call(E, "codeTextColor") && e.uint32(
      /* id 59, wireType 2 =*/
      474
    ).string(E.codeTextColor), E.light != null && Object.hasOwnProperty.call(E, "light") && $root$1.CustomThemeConfig.encode(E.light, e.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), E.dark != null && Object.hasOwnProperty.call(E, "dark") && $root$1.CustomThemeConfig.encode(E.dark, e.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), E.chartDivergingColors != null && E.chartDivergingColors.length) for (let t = 0; t < E.chartDivergingColors.length; ++t) e.uint32(
      /* id 62, wireType 2 =*/
      498
    ).string(E.chartDivergingColors[t]);
    return e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.CustomThemeConfig();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.primaryColor = E.string();
          break;
        }
        case 2: {
          h.secondaryBackgroundColor = E.string();
          break;
        }
        case 3: {
          h.backgroundColor = E.string();
          break;
        }
        case 4: {
          h.textColor = E.string();
          break;
        }
        case 5: {
          h.font = E.int32();
          break;
        }
        case 6: {
          h.base = E.int32();
          break;
        }
        case 7: {
          h.widgetBackgroundColor = E.string();
          break;
        }
        case 8: {
          h.widgetBorderColor = E.string();
          break;
        }
        case 9: {
          h.radii = $root$1.Radii.decode(E, E.uint32());
          break;
        }
        case 12: {
          h.headingFont = E.string();
          break;
        }
        case 13: {
          h.bodyFont = E.string();
          break;
        }
        case 14: {
          h.codeFont = E.string();
          break;
        }
        case 15: {
          h.fontFaces && h.fontFaces.length || (h.fontFaces = []), h.fontFaces.push($root$1.FontFace.decode(E, E.uint32()));
          break;
        }
        case 37: {
          h.fontSources && h.fontSources.length || (h.fontSources = []), h.fontSources.push($root$1.FontSource.decode(E, E.uint32()));
          break;
        }
        case 16: {
          h.fontSizes = $root$1.FontSizes.decode(E, E.uint32());
          break;
        }
        case 17: {
          h.skeletonBackgroundColor = E.string();
          break;
        }
        case 18: {
          h.baseRadius = E.string();
          break;
        }
        case 26: {
          h.buttonRadius = E.string();
          break;
        }
        case 19: {
          h.borderColor = E.string();
          break;
        }
        case 27: {
          h.dataframeBorderColor = E.string();
          break;
        }
        case 20: {
          h.showWidgetBorder = E.bool();
          break;
        }
        case 21: {
          h.linkColor = E.string();
          break;
        }
        case 29: {
          h.linkUnderline = E.bool();
          break;
        }
        case 22: {
          h.baseFontSize = E.int32();
          break;
        }
        case 30: {
          h.baseFontWeight = E.int32();
          break;
        }
        case 32: {
          h.codeFontWeight = E.int32();
          break;
        }
        case 28: {
          h.codeFontSize = E.string();
          break;
        }
        case 35: {
          h.headingFontSizes && h.headingFontSizes.length || (h.headingFontSizes = []), h.headingFontSizes.push(E.string());
          break;
        }
        case 34: {
          if (h.headingFontWeights && h.headingFontWeights.length || (h.headingFontWeights = []), (d & 7) === 2) {
            let k = E.uint32() + E.pos;
            for (; E.pos < k; ) h.headingFontWeights.push(E.int32());
          } else h.headingFontWeights.push(E.int32());
          break;
        }
        case 23: {
          h.showSidebarBorder = E.bool();
          break;
        }
        case 59: {
          h.codeTextColor = E.string();
          break;
        }
        case 25: {
          h.codeBackgroundColor = E.string();
          break;
        }
        case 31: {
          h.dataframeHeaderBackgroundColor = E.string();
          break;
        }
        case 33: {
          h.chartCategoricalColors && h.chartCategoricalColors.length || (h.chartCategoricalColors = []), h.chartCategoricalColors.push(E.string());
          break;
        }
        case 36: {
          h.chartSequentialColors && h.chartSequentialColors.length || (h.chartSequentialColors = []), h.chartSequentialColors.push(E.string());
          break;
        }
        case 62: {
          h.chartDivergingColors && h.chartDivergingColors.length || (h.chartDivergingColors = []), h.chartDivergingColors.push(E.string());
          break;
        }
        case 38: {
          h.redColor = E.string();
          break;
        }
        case 39: {
          h.orangeColor = E.string();
          break;
        }
        case 40: {
          h.yellowColor = E.string();
          break;
        }
        case 41: {
          h.blueColor = E.string();
          break;
        }
        case 42: {
          h.greenColor = E.string();
          break;
        }
        case 43: {
          h.violetColor = E.string();
          break;
        }
        case 44: {
          h.grayColor = E.string();
          break;
        }
        case 45: {
          h.redBackgroundColor = E.string();
          break;
        }
        case 46: {
          h.orangeBackgroundColor = E.string();
          break;
        }
        case 47: {
          h.yellowBackgroundColor = E.string();
          break;
        }
        case 48: {
          h.blueBackgroundColor = E.string();
          break;
        }
        case 49: {
          h.greenBackgroundColor = E.string();
          break;
        }
        case 50: {
          h.violetBackgroundColor = E.string();
          break;
        }
        case 51: {
          h.grayBackgroundColor = E.string();
          break;
        }
        case 52: {
          h.redTextColor = E.string();
          break;
        }
        case 53: {
          h.orangeTextColor = E.string();
          break;
        }
        case 54: {
          h.yellowTextColor = E.string();
          break;
        }
        case 55: {
          h.blueTextColor = E.string();
          break;
        }
        case 56: {
          h.greenTextColor = E.string();
          break;
        }
        case 57: {
          h.violetTextColor = E.string();
          break;
        }
        case 58: {
          h.grayTextColor = E.string();
          break;
        }
        case 24: {
          h.sidebar = $root$1.CustomThemeConfig.decode(E, E.uint32());
          break;
        }
        case 60: {
          h.light = $root$1.CustomThemeConfig.decode(E, E.uint32());
          break;
        }
        case 61: {
          h.dark = $root$1.CustomThemeConfig.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.CustomThemeConfig) return E;
    let e = new $root$1.CustomThemeConfig();
    switch (E.primaryColor != null && (e.primaryColor = String(E.primaryColor)), E.secondaryBackgroundColor != null && (e.secondaryBackgroundColor = String(E.secondaryBackgroundColor)), E.backgroundColor != null && (e.backgroundColor = String(E.backgroundColor)), E.textColor != null && (e.textColor = String(E.textColor)), E.font) {
      default:
        if (typeof E.font == "number") {
          e.font = E.font;
          break;
        }
        break;
      case "SANS_SERIF":
      case 0:
        e.font = 0;
        break;
      case "SERIF":
      case 1:
        e.font = 1;
        break;
      case "MONOSPACE":
      case 2:
        e.font = 2;
        break;
    }
    switch (E.base) {
      default:
        if (typeof E.base == "number") {
          e.base = E.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        e.base = 0;
        break;
      case "DARK":
      case 1:
        e.base = 1;
        break;
    }
    if (E.widgetBackgroundColor != null && (e.widgetBackgroundColor = String(E.widgetBackgroundColor)), E.widgetBorderColor != null && (e.widgetBorderColor = String(E.widgetBorderColor)), E.radii != null) {
      if (typeof E.radii != "object") throw TypeError(".CustomThemeConfig.radii: object expected");
      e.radii = $root$1.Radii.fromObject(E.radii);
    }
    if (E.headingFont != null && (e.headingFont = String(E.headingFont)), E.bodyFont != null && (e.bodyFont = String(E.bodyFont)), E.codeFont != null && (e.codeFont = String(E.codeFont)), E.fontFaces) {
      if (!Array.isArray(E.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      e.fontFaces = [];
      for (let t = 0; t < E.fontFaces.length; ++t) {
        if (typeof E.fontFaces[t] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        e.fontFaces[t] = $root$1.FontFace.fromObject(E.fontFaces[t]);
      }
    }
    if (E.fontSources) {
      if (!Array.isArray(E.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
      e.fontSources = [];
      for (let t = 0; t < E.fontSources.length; ++t) {
        if (typeof E.fontSources[t] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
        e.fontSources[t] = $root$1.FontSource.fromObject(E.fontSources[t]);
      }
    }
    if (E.fontSizes != null) {
      if (typeof E.fontSizes != "object") throw TypeError(".CustomThemeConfig.fontSizes: object expected");
      e.fontSizes = $root$1.FontSizes.fromObject(E.fontSizes);
    }
    if (E.skeletonBackgroundColor != null && (e.skeletonBackgroundColor = String(E.skeletonBackgroundColor)), E.baseRadius != null && (e.baseRadius = String(E.baseRadius)), E.buttonRadius != null && (e.buttonRadius = String(E.buttonRadius)), E.borderColor != null && (e.borderColor = String(E.borderColor)), E.dataframeBorderColor != null && (e.dataframeBorderColor = String(E.dataframeBorderColor)), E.showWidgetBorder != null && (e.showWidgetBorder = !!E.showWidgetBorder), E.linkColor != null && (e.linkColor = String(E.linkColor)), E.linkUnderline != null && (e.linkUnderline = !!E.linkUnderline), E.baseFontSize != null && (e.baseFontSize = E.baseFontSize | 0), E.baseFontWeight != null && (e.baseFontWeight = E.baseFontWeight | 0), E.codeFontWeight != null && (e.codeFontWeight = E.codeFontWeight | 0), E.codeFontSize != null && (e.codeFontSize = String(E.codeFontSize)), E.headingFontSizes) {
      if (!Array.isArray(E.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      e.headingFontSizes = [];
      for (let t = 0; t < E.headingFontSizes.length; ++t) e.headingFontSizes[t] = String(E.headingFontSizes[t]);
    }
    if (E.headingFontWeights) {
      if (!Array.isArray(E.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      e.headingFontWeights = [];
      for (let t = 0; t < E.headingFontWeights.length; ++t) e.headingFontWeights[t] = E.headingFontWeights[t] | 0;
    }
    if (E.showSidebarBorder != null && (e.showSidebarBorder = !!E.showSidebarBorder), E.codeTextColor != null && (e.codeTextColor = String(E.codeTextColor)), E.codeBackgroundColor != null && (e.codeBackgroundColor = String(E.codeBackgroundColor)), E.dataframeHeaderBackgroundColor != null && (e.dataframeHeaderBackgroundColor = String(E.dataframeHeaderBackgroundColor)), E.chartCategoricalColors) {
      if (!Array.isArray(E.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      e.chartCategoricalColors = [];
      for (let t = 0; t < E.chartCategoricalColors.length; ++t) e.chartCategoricalColors[t] = String(E.chartCategoricalColors[t]);
    }
    if (E.chartSequentialColors) {
      if (!Array.isArray(E.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      e.chartSequentialColors = [];
      for (let t = 0; t < E.chartSequentialColors.length; ++t) e.chartSequentialColors[t] = String(E.chartSequentialColors[t]);
    }
    if (E.chartDivergingColors) {
      if (!Array.isArray(E.chartDivergingColors)) throw TypeError(".CustomThemeConfig.chartDivergingColors: array expected");
      e.chartDivergingColors = [];
      for (let t = 0; t < E.chartDivergingColors.length; ++t) e.chartDivergingColors[t] = String(E.chartDivergingColors[t]);
    }
    if (E.redColor != null && (e.redColor = String(E.redColor)), E.orangeColor != null && (e.orangeColor = String(E.orangeColor)), E.yellowColor != null && (e.yellowColor = String(E.yellowColor)), E.blueColor != null && (e.blueColor = String(E.blueColor)), E.greenColor != null && (e.greenColor = String(E.greenColor)), E.violetColor != null && (e.violetColor = String(E.violetColor)), E.grayColor != null && (e.grayColor = String(E.grayColor)), E.redBackgroundColor != null && (e.redBackgroundColor = String(E.redBackgroundColor)), E.orangeBackgroundColor != null && (e.orangeBackgroundColor = String(E.orangeBackgroundColor)), E.yellowBackgroundColor != null && (e.yellowBackgroundColor = String(E.yellowBackgroundColor)), E.blueBackgroundColor != null && (e.blueBackgroundColor = String(E.blueBackgroundColor)), E.greenBackgroundColor != null && (e.greenBackgroundColor = String(E.greenBackgroundColor)), E.violetBackgroundColor != null && (e.violetBackgroundColor = String(E.violetBackgroundColor)), E.grayBackgroundColor != null && (e.grayBackgroundColor = String(E.grayBackgroundColor)), E.redTextColor != null && (e.redTextColor = String(E.redTextColor)), E.orangeTextColor != null && (e.orangeTextColor = String(E.orangeTextColor)), E.yellowTextColor != null && (e.yellowTextColor = String(E.yellowTextColor)), E.blueTextColor != null && (e.blueTextColor = String(E.blueTextColor)), E.greenTextColor != null && (e.greenTextColor = String(E.greenTextColor)), E.violetTextColor != null && (e.violetTextColor = String(E.violetTextColor)), E.grayTextColor != null && (e.grayTextColor = String(E.grayTextColor)), E.sidebar != null) {
      if (typeof E.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
      e.sidebar = $root$1.CustomThemeConfig.fromObject(E.sidebar);
    }
    if (E.light != null) {
      if (typeof E.light != "object") throw TypeError(".CustomThemeConfig.light: object expected");
      e.light = $root$1.CustomThemeConfig.fromObject(E.light);
    }
    if (E.dark != null) {
      if (typeof E.dark != "object") throw TypeError(".CustomThemeConfig.dark: object expected");
      e.dark = $root$1.CustomThemeConfig.fromObject(E.dark);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.fontFaces = [], t.chartCategoricalColors = [], t.headingFontWeights = [], t.headingFontSizes = [], t.chartSequentialColors = [], t.fontSources = [], t.chartDivergingColors = []), e.defaults && (t.primaryColor = "", t.secondaryBackgroundColor = "", t.backgroundColor = "", t.textColor = "", t.font = e.enums === String ? "SANS_SERIF" : 0, t.base = e.enums === String ? "LIGHT" : 0, t.widgetBackgroundColor = "", t.widgetBorderColor = "", t.radii = null, t.headingFont = "", t.bodyFont = "", t.codeFont = "", t.fontSizes = null, t.skeletonBackgroundColor = ""), E.primaryColor != null && E.hasOwnProperty("primaryColor") && (t.primaryColor = E.primaryColor), E.secondaryBackgroundColor != null && E.hasOwnProperty("secondaryBackgroundColor") && (t.secondaryBackgroundColor = E.secondaryBackgroundColor), E.backgroundColor != null && E.hasOwnProperty("backgroundColor") && (t.backgroundColor = E.backgroundColor), E.textColor != null && E.hasOwnProperty("textColor") && (t.textColor = E.textColor), E.font != null && E.hasOwnProperty("font") && (t.font = e.enums === String ? $root$1.CustomThemeConfig.FontFamily[E.font] === void 0 ? E.font : $root$1.CustomThemeConfig.FontFamily[E.font] : E.font), E.base != null && E.hasOwnProperty("base") && (t.base = e.enums === String ? $root$1.CustomThemeConfig.BaseTheme[E.base] === void 0 ? E.base : $root$1.CustomThemeConfig.BaseTheme[E.base] : E.base), E.widgetBackgroundColor != null && E.hasOwnProperty("widgetBackgroundColor") && (t.widgetBackgroundColor = E.widgetBackgroundColor), E.widgetBorderColor != null && E.hasOwnProperty("widgetBorderColor") && (t.widgetBorderColor = E.widgetBorderColor), E.radii != null && E.hasOwnProperty("radii") && (t.radii = $root$1.Radii.toObject(E.radii, e)), E.headingFont != null && E.hasOwnProperty("headingFont") && (t.headingFont = E.headingFont), E.bodyFont != null && E.hasOwnProperty("bodyFont") && (t.bodyFont = E.bodyFont), E.codeFont != null && E.hasOwnProperty("codeFont") && (t.codeFont = E.codeFont), E.fontFaces && E.fontFaces.length) {
      t.fontFaces = [];
      for (let n = 0; n < E.fontFaces.length; ++n) t.fontFaces[n] = $root$1.FontFace.toObject(E.fontFaces[n], e);
    }
    if (E.fontSizes != null && E.hasOwnProperty("fontSizes") && (t.fontSizes = $root$1.FontSizes.toObject(E.fontSizes, e)), E.skeletonBackgroundColor != null && E.hasOwnProperty("skeletonBackgroundColor") && (t.skeletonBackgroundColor = E.skeletonBackgroundColor), E.baseRadius != null && E.hasOwnProperty("baseRadius") && (t.baseRadius = E.baseRadius, e.oneofs && (t._baseRadius = "baseRadius")), E.borderColor != null && E.hasOwnProperty("borderColor") && (t.borderColor = E.borderColor, e.oneofs && (t._borderColor = "borderColor")), E.showWidgetBorder != null && E.hasOwnProperty("showWidgetBorder") && (t.showWidgetBorder = E.showWidgetBorder, e.oneofs && (t._showWidgetBorder = "showWidgetBorder")), E.linkColor != null && E.hasOwnProperty("linkColor") && (t.linkColor = E.linkColor, e.oneofs && (t._linkColor = "linkColor")), E.baseFontSize != null && E.hasOwnProperty("baseFontSize") && (t.baseFontSize = E.baseFontSize, e.oneofs && (t._baseFontSize = "baseFontSize")), E.showSidebarBorder != null && E.hasOwnProperty("showSidebarBorder") && (t.showSidebarBorder = E.showSidebarBorder, e.oneofs && (t._showSidebarBorder = "showSidebarBorder")), E.sidebar != null && E.hasOwnProperty("sidebar") && (t.sidebar = $root$1.CustomThemeConfig.toObject(E.sidebar, e), e.oneofs && (t._sidebar = "sidebar")), E.codeBackgroundColor != null && E.hasOwnProperty("codeBackgroundColor") && (t.codeBackgroundColor = E.codeBackgroundColor, e.oneofs && (t._codeBackgroundColor = "codeBackgroundColor")), E.buttonRadius != null && E.hasOwnProperty("buttonRadius") && (t.buttonRadius = E.buttonRadius, e.oneofs && (t._buttonRadius = "buttonRadius")), E.dataframeBorderColor != null && E.hasOwnProperty("dataframeBorderColor") && (t.dataframeBorderColor = E.dataframeBorderColor, e.oneofs && (t._dataframeBorderColor = "dataframeBorderColor")), E.codeFontSize != null && E.hasOwnProperty("codeFontSize") && (t.codeFontSize = E.codeFontSize, e.oneofs && (t._codeFontSize = "codeFontSize")), E.linkUnderline != null && E.hasOwnProperty("linkUnderline") && (t.linkUnderline = E.linkUnderline, e.oneofs && (t._linkUnderline = "linkUnderline")), E.baseFontWeight != null && E.hasOwnProperty("baseFontWeight") && (t.baseFontWeight = E.baseFontWeight, e.oneofs && (t._baseFontWeight = "baseFontWeight")), E.dataframeHeaderBackgroundColor != null && E.hasOwnProperty("dataframeHeaderBackgroundColor") && (t.dataframeHeaderBackgroundColor = E.dataframeHeaderBackgroundColor, e.oneofs && (t._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), E.codeFontWeight != null && E.hasOwnProperty("codeFontWeight") && (t.codeFontWeight = E.codeFontWeight, e.oneofs && (t._codeFontWeight = "codeFontWeight")), E.chartCategoricalColors && E.chartCategoricalColors.length) {
      t.chartCategoricalColors = [];
      for (let n = 0; n < E.chartCategoricalColors.length; ++n) t.chartCategoricalColors[n] = E.chartCategoricalColors[n];
    }
    if (E.headingFontWeights && E.headingFontWeights.length) {
      t.headingFontWeights = [];
      for (let n = 0; n < E.headingFontWeights.length; ++n) t.headingFontWeights[n] = E.headingFontWeights[n];
    }
    if (E.headingFontSizes && E.headingFontSizes.length) {
      t.headingFontSizes = [];
      for (let n = 0; n < E.headingFontSizes.length; ++n) t.headingFontSizes[n] = E.headingFontSizes[n];
    }
    if (E.chartSequentialColors && E.chartSequentialColors.length) {
      t.chartSequentialColors = [];
      for (let n = 0; n < E.chartSequentialColors.length; ++n) t.chartSequentialColors[n] = E.chartSequentialColors[n];
    }
    if (E.fontSources && E.fontSources.length) {
      t.fontSources = [];
      for (let n = 0; n < E.fontSources.length; ++n) t.fontSources[n] = $root$1.FontSource.toObject(E.fontSources[n], e);
    }
    if (E.redColor != null && E.hasOwnProperty("redColor") && (t.redColor = E.redColor, e.oneofs && (t._redColor = "redColor")), E.orangeColor != null && E.hasOwnProperty("orangeColor") && (t.orangeColor = E.orangeColor, e.oneofs && (t._orangeColor = "orangeColor")), E.yellowColor != null && E.hasOwnProperty("yellowColor") && (t.yellowColor = E.yellowColor, e.oneofs && (t._yellowColor = "yellowColor")), E.blueColor != null && E.hasOwnProperty("blueColor") && (t.blueColor = E.blueColor, e.oneofs && (t._blueColor = "blueColor")), E.greenColor != null && E.hasOwnProperty("greenColor") && (t.greenColor = E.greenColor, e.oneofs && (t._greenColor = "greenColor")), E.violetColor != null && E.hasOwnProperty("violetColor") && (t.violetColor = E.violetColor, e.oneofs && (t._violetColor = "violetColor")), E.grayColor != null && E.hasOwnProperty("grayColor") && (t.grayColor = E.grayColor, e.oneofs && (t._grayColor = "grayColor")), E.redBackgroundColor != null && E.hasOwnProperty("redBackgroundColor") && (t.redBackgroundColor = E.redBackgroundColor, e.oneofs && (t._redBackgroundColor = "redBackgroundColor")), E.orangeBackgroundColor != null && E.hasOwnProperty("orangeBackgroundColor") && (t.orangeBackgroundColor = E.orangeBackgroundColor, e.oneofs && (t._orangeBackgroundColor = "orangeBackgroundColor")), E.yellowBackgroundColor != null && E.hasOwnProperty("yellowBackgroundColor") && (t.yellowBackgroundColor = E.yellowBackgroundColor, e.oneofs && (t._yellowBackgroundColor = "yellowBackgroundColor")), E.blueBackgroundColor != null && E.hasOwnProperty("blueBackgroundColor") && (t.blueBackgroundColor = E.blueBackgroundColor, e.oneofs && (t._blueBackgroundColor = "blueBackgroundColor")), E.greenBackgroundColor != null && E.hasOwnProperty("greenBackgroundColor") && (t.greenBackgroundColor = E.greenBackgroundColor, e.oneofs && (t._greenBackgroundColor = "greenBackgroundColor")), E.violetBackgroundColor != null && E.hasOwnProperty("violetBackgroundColor") && (t.violetBackgroundColor = E.violetBackgroundColor, e.oneofs && (t._violetBackgroundColor = "violetBackgroundColor")), E.grayBackgroundColor != null && E.hasOwnProperty("grayBackgroundColor") && (t.grayBackgroundColor = E.grayBackgroundColor, e.oneofs && (t._grayBackgroundColor = "grayBackgroundColor")), E.redTextColor != null && E.hasOwnProperty("redTextColor") && (t.redTextColor = E.redTextColor, e.oneofs && (t._redTextColor = "redTextColor")), E.orangeTextColor != null && E.hasOwnProperty("orangeTextColor") && (t.orangeTextColor = E.orangeTextColor, e.oneofs && (t._orangeTextColor = "orangeTextColor")), E.yellowTextColor != null && E.hasOwnProperty("yellowTextColor") && (t.yellowTextColor = E.yellowTextColor, e.oneofs && (t._yellowTextColor = "yellowTextColor")), E.blueTextColor != null && E.hasOwnProperty("blueTextColor") && (t.blueTextColor = E.blueTextColor, e.oneofs && (t._blueTextColor = "blueTextColor")), E.greenTextColor != null && E.hasOwnProperty("greenTextColor") && (t.greenTextColor = E.greenTextColor, e.oneofs && (t._greenTextColor = "greenTextColor")), E.violetTextColor != null && E.hasOwnProperty("violetTextColor") && (t.violetTextColor = E.violetTextColor, e.oneofs && (t._violetTextColor = "violetTextColor")), E.grayTextColor != null && E.hasOwnProperty("grayTextColor") && (t.grayTextColor = E.grayTextColor, e.oneofs && (t._grayTextColor = "grayTextColor")), E.codeTextColor != null && E.hasOwnProperty("codeTextColor") && (t.codeTextColor = E.codeTextColor, e.oneofs && (t._codeTextColor = "codeTextColor")), E.light != null && E.hasOwnProperty("light") && (t.light = $root$1.CustomThemeConfig.toObject(E.light, e), e.oneofs && (t._light = "light")), E.dark != null && E.hasOwnProperty("dark") && (t.dark = $root$1.CustomThemeConfig.toObject(E.dark, e), e.oneofs && (t._dark = "dark")), E.chartDivergingColors && E.chartDivergingColors.length) {
      t.chartDivergingColors = [];
      for (let n = 0; n < E.chartDivergingColors.length; ++n) t.chartDivergingColors[n] = E.chartDivergingColors[n];
    }
    return t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/CustomThemeConfig";
  }, o.BaseTheme = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "LIGHT"] = 0, E[g[1] = "DARK"] = 1, E;
  })(), o.FontFamily = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "SANS_SERIF"] = 0, E[g[1] = "SERIF"] = 1, E[g[2] = "MONOSPACE"] = 2, E;
  })(), o;
})();
$root$1.FontFace = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.url = "", o.prototype.family = "", o.prototype.weight = 0, o.prototype.weightRange = "", o.prototype.style = "", o.prototype.unicodeRange = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), g.family != null && Object.hasOwnProperty.call(g, "family") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.family), g.weight != null && Object.hasOwnProperty.call(g, "weight") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.weight), g.style != null && Object.hasOwnProperty.call(g, "style") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.style), g.weightRange != null && Object.hasOwnProperty.call(g, "weightRange") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.weightRange), g.unicodeRange != null && Object.hasOwnProperty.call(g, "unicodeRange") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.unicodeRange), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.FontFace();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.url = g.string();
          break;
        }
        case 2: {
          n.family = g.string();
          break;
        }
        case 3: {
          n.weight = g.int32();
          break;
        }
        case 5: {
          n.weightRange = g.string();
          break;
        }
        case 4: {
          n.style = g.string();
          break;
        }
        case 6: {
          n.unicodeRange = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.FontFace) return g;
    let E = new $root$1.FontFace();
    return g.url != null && (E.url = String(g.url)), g.family != null && (E.family = String(g.family)), g.weight != null && (E.weight = g.weight | 0), g.weightRange != null && (E.weightRange = String(g.weightRange)), g.style != null && (E.style = String(g.style)), g.unicodeRange != null && (E.unicodeRange = String(g.unicodeRange)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.url = "", e.family = "", e.weight = 0, e.style = "", e.weightRange = "", e.unicodeRange = ""), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), g.family != null && g.hasOwnProperty("family") && (e.family = g.family), g.weight != null && g.hasOwnProperty("weight") && (e.weight = g.weight), g.style != null && g.hasOwnProperty("style") && (e.style = g.style), g.weightRange != null && g.hasOwnProperty("weightRange") && (e.weightRange = g.weightRange), g.unicodeRange != null && g.hasOwnProperty("unicodeRange") && (e.unicodeRange = g.unicodeRange), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FontFace";
  }, o;
})();
$root$1.FontSource = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.configName = "", o.prototype.sourceUrl = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.configName != null && Object.hasOwnProperty.call(g, "configName") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.configName), g.sourceUrl != null && Object.hasOwnProperty.call(g, "sourceUrl") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.sourceUrl), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.FontSource();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.configName = g.string();
          break;
        }
        case 2: {
          n.sourceUrl = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.FontSource) return g;
    let E = new $root$1.FontSource();
    return g.configName != null && (E.configName = String(g.configName)), g.sourceUrl != null && (E.sourceUrl = String(g.sourceUrl)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.configName = "", e.sourceUrl = ""), g.configName != null && g.hasOwnProperty("configName") && (e.configName = g.configName), g.sourceUrl != null && g.hasOwnProperty("sourceUrl") && (e.sourceUrl = g.sourceUrl), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FontSource";
  }, o;
})();
$root$1.Radii = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.baseWidgetRadius = 0, o.prototype.checkboxRadius = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.baseWidgetRadius != null && Object.hasOwnProperty.call(g, "baseWidgetRadius") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.baseWidgetRadius), g.checkboxRadius != null && Object.hasOwnProperty.call(g, "checkboxRadius") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.checkboxRadius), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Radii();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.baseWidgetRadius = g.int32();
          break;
        }
        case 2: {
          n.checkboxRadius = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Radii) return g;
    let E = new $root$1.Radii();
    return g.baseWidgetRadius != null && (E.baseWidgetRadius = g.baseWidgetRadius | 0), g.checkboxRadius != null && (E.checkboxRadius = g.checkboxRadius | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.baseWidgetRadius = 0, e.checkboxRadius = 0), g.baseWidgetRadius != null && g.hasOwnProperty("baseWidgetRadius") && (e.baseWidgetRadius = g.baseWidgetRadius), g.checkboxRadius != null && g.hasOwnProperty("checkboxRadius") && (e.checkboxRadius = g.checkboxRadius), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Radii";
  }, o;
})();
$root$1.FontSizes = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.tinyFontSize = 0, o.prototype.smallFontSize = 0, o.prototype.baseFontSize = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.tinyFontSize != null && Object.hasOwnProperty.call(g, "tinyFontSize") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.tinyFontSize), g.smallFontSize != null && Object.hasOwnProperty.call(g, "smallFontSize") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.smallFontSize), g.baseFontSize != null && Object.hasOwnProperty.call(g, "baseFontSize") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.baseFontSize), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.FontSizes();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.tinyFontSize = g.int32();
          break;
        }
        case 2: {
          n.smallFontSize = g.int32();
          break;
        }
        case 3: {
          n.baseFontSize = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.FontSizes) return g;
    let E = new $root$1.FontSizes();
    return g.tinyFontSize != null && (E.tinyFontSize = g.tinyFontSize | 0), g.smallFontSize != null && (E.smallFontSize = g.smallFontSize | 0), g.baseFontSize != null && (E.baseFontSize = g.baseFontSize | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.tinyFontSize = 0, e.smallFontSize = 0, e.baseFontSize = 0), g.tinyFontSize != null && g.hasOwnProperty("tinyFontSize") && (e.tinyFontSize = g.tinyFontSize), g.smallFontSize != null && g.hasOwnProperty("smallFontSize") && (e.smallFontSize = g.smallFontSize), g.baseFontSize != null && g.hasOwnProperty("baseFontSize") && (e.baseFontSize = g.baseFontSize), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FontSizes";
  }, o;
})();
$root$1.UserInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.installationId = "", o.prototype.installationIdV3 = "", o.prototype.installationIdV4 = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.installationId != null && Object.hasOwnProperty.call(g, "installationId") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.installationId), g.installationIdV3 != null && Object.hasOwnProperty.call(g, "installationIdV3") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.installationIdV3), g.installationIdV4 != null && Object.hasOwnProperty.call(g, "installationIdV4") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.installationIdV4), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.UserInfo();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.installationId = g.string();
          break;
        }
        case 5: {
          n.installationIdV3 = g.string();
          break;
        }
        case 6: {
          n.installationIdV4 = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.UserInfo) return g;
    let E = new $root$1.UserInfo();
    return g.installationId != null && (E.installationId = String(g.installationId)), g.installationIdV3 != null && (E.installationIdV3 = String(g.installationIdV3)), g.installationIdV4 != null && (E.installationIdV4 = String(g.installationIdV4)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.installationId = "", e.installationIdV3 = "", e.installationIdV4 = ""), g.installationId != null && g.hasOwnProperty("installationId") && (e.installationId = g.installationId), g.installationIdV3 != null && g.hasOwnProperty("installationIdV3") && (e.installationIdV3 = g.installationIdV3), g.installationIdV4 != null && g.hasOwnProperty("installationIdV4") && (e.installationIdV4 = g.installationIdV4), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/UserInfo";
  }, o;
})();
$root$1.EnvironmentInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.streamlitVersion = "", o.prototype.pythonVersion = "", o.prototype.serverOs = "", o.prototype.hasDisplay = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.streamlitVersion != null && Object.hasOwnProperty.call(g, "streamlitVersion") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.streamlitVersion), g.pythonVersion != null && Object.hasOwnProperty.call(g, "pythonVersion") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.pythonVersion), g.serverOs != null && Object.hasOwnProperty.call(g, "serverOs") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.serverOs), g.hasDisplay != null && Object.hasOwnProperty.call(g, "hasDisplay") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.hasDisplay), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.EnvironmentInfo();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.streamlitVersion = g.string();
          break;
        }
        case 2: {
          n.pythonVersion = g.string();
          break;
        }
        case 3: {
          n.serverOs = g.string();
          break;
        }
        case 4: {
          n.hasDisplay = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.EnvironmentInfo) return g;
    let E = new $root$1.EnvironmentInfo();
    return g.streamlitVersion != null && (E.streamlitVersion = String(g.streamlitVersion)), g.pythonVersion != null && (E.pythonVersion = String(g.pythonVersion)), g.serverOs != null && (E.serverOs = String(g.serverOs)), g.hasDisplay != null && (E.hasDisplay = !!g.hasDisplay), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.streamlitVersion = "", e.pythonVersion = "", e.serverOs = "", e.hasDisplay = !1), g.streamlitVersion != null && g.hasOwnProperty("streamlitVersion") && (e.streamlitVersion = g.streamlitVersion), g.pythonVersion != null && g.hasOwnProperty("pythonVersion") && (e.pythonVersion = g.pythonVersion), g.serverOs != null && g.hasOwnProperty("serverOs") && (e.serverOs = g.serverOs), g.hasDisplay != null && g.hasOwnProperty("hasDisplay") && (e.hasDisplay = g.hasDisplay), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/EnvironmentInfo";
  }, o;
})();
$root$1.SessionStatus = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.runOnSave = !1, o.prototype.scriptIsRunning = !1, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.runOnSave != null && Object.hasOwnProperty.call(g, "runOnSave") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.runOnSave), g.scriptIsRunning != null && Object.hasOwnProperty.call(g, "scriptIsRunning") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.scriptIsRunning), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.SessionStatus();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.runOnSave = g.bool();
          break;
        }
        case 2: {
          n.scriptIsRunning = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.SessionStatus) return g;
    let E = new $root$1.SessionStatus();
    return g.runOnSave != null && (E.runOnSave = !!g.runOnSave), g.scriptIsRunning != null && (E.scriptIsRunning = !!g.scriptIsRunning), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.runOnSave = !1, e.scriptIsRunning = !1), g.runOnSave != null && g.hasOwnProperty("runOnSave") && (e.runOnSave = g.runOnSave), g.scriptIsRunning != null && g.hasOwnProperty("scriptIsRunning") && (e.scriptIsRunning = g.scriptIsRunning), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SessionStatus";
  }, o;
})();
const PageConfig = $root$1.PageConfig = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.title = "", o.prototype.favicon = "", o.prototype.layout = 0, o.prototype.initialSidebarState = 0, o.prototype.menuItems = null, o.prototype.initialSidebarWidth = null;
  let i;
  return Object.defineProperty(o.prototype, "_initialSidebarWidth", { get: $util$1.oneOfGetter(i = ["initialSidebarWidth"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.title != null && Object.hasOwnProperty.call(E, "title") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.title), E.favicon != null && Object.hasOwnProperty.call(E, "favicon") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.favicon), E.layout != null && Object.hasOwnProperty.call(E, "layout") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.layout), E.initialSidebarState != null && Object.hasOwnProperty.call(E, "initialSidebarState") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(E.initialSidebarState), E.menuItems != null && Object.hasOwnProperty.call(E, "menuItems") && $root$1.PageConfig.MenuItems.encode(E.menuItems, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), E.initialSidebarWidth != null && Object.hasOwnProperty.call(E, "initialSidebarWidth") && $root$1.PageConfig.SidebarWidthConfig.encode(E.initialSidebarWidth, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.PageConfig();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.title = E.string();
          break;
        }
        case 2: {
          h.favicon = E.string();
          break;
        }
        case 3: {
          h.layout = E.int32();
          break;
        }
        case 4: {
          h.initialSidebarState = E.int32();
          break;
        }
        case 5: {
          h.menuItems = $root$1.PageConfig.MenuItems.decode(E, E.uint32());
          break;
        }
        case 6: {
          h.initialSidebarWidth = $root$1.PageConfig.SidebarWidthConfig.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.PageConfig) return E;
    let e = new $root$1.PageConfig();
    switch (E.title != null && (e.title = String(E.title)), E.favicon != null && (e.favicon = String(E.favicon)), E.layout) {
      default:
        if (typeof E.layout == "number") {
          e.layout = E.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        e.layout = 0;
        break;
      case "WIDE":
      case 1:
        e.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        e.layout = 2;
        break;
    }
    switch (E.initialSidebarState) {
      default:
        if (typeof E.initialSidebarState == "number") {
          e.initialSidebarState = E.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        e.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        e.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        e.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        e.initialSidebarState = 3;
        break;
    }
    if (E.menuItems != null) {
      if (typeof E.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
      e.menuItems = $root$1.PageConfig.MenuItems.fromObject(E.menuItems);
    }
    if (E.initialSidebarWidth != null) {
      if (typeof E.initialSidebarWidth != "object") throw TypeError(".PageConfig.initialSidebarWidth: object expected");
      e.initialSidebarWidth = $root$1.PageConfig.SidebarWidthConfig.fromObject(E.initialSidebarWidth);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.title = "", t.favicon = "", t.layout = e.enums === String ? "CENTERED" : 0, t.initialSidebarState = e.enums === String ? "AUTO" : 0, t.menuItems = null), E.title != null && E.hasOwnProperty("title") && (t.title = E.title), E.favicon != null && E.hasOwnProperty("favicon") && (t.favicon = E.favicon), E.layout != null && E.hasOwnProperty("layout") && (t.layout = e.enums === String ? $root$1.PageConfig.Layout[E.layout] === void 0 ? E.layout : $root$1.PageConfig.Layout[E.layout] : E.layout), E.initialSidebarState != null && E.hasOwnProperty("initialSidebarState") && (t.initialSidebarState = e.enums === String ? $root$1.PageConfig.SidebarState[E.initialSidebarState] === void 0 ? E.initialSidebarState : $root$1.PageConfig.SidebarState[E.initialSidebarState] : E.initialSidebarState), E.menuItems != null && E.hasOwnProperty("menuItems") && (t.menuItems = $root$1.PageConfig.MenuItems.toObject(E.menuItems, e)), E.initialSidebarWidth != null && E.hasOwnProperty("initialSidebarWidth") && (t.initialSidebarWidth = $root$1.PageConfig.SidebarWidthConfig.toObject(E.initialSidebarWidth, e), e.oneofs && (t._initialSidebarWidth = "initialSidebarWidth")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PageConfig";
  }, o.MenuItems = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.getHelpUrl = "", g.prototype.hideGetHelp = !1, g.prototype.reportABugUrl = "", g.prototype.hideReportABug = !1, g.prototype.aboutSectionMd = "", g.prototype.clearAboutMd = !1, g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.getHelpUrl != null && Object.hasOwnProperty.call(e, "getHelpUrl") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.getHelpUrl), e.hideGetHelp != null && Object.hasOwnProperty.call(e, "hideGetHelp") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.hideGetHelp), e.reportABugUrl != null && Object.hasOwnProperty.call(e, "reportABugUrl") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.reportABugUrl), e.hideReportABug != null && Object.hasOwnProperty.call(e, "hideReportABug") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.hideReportABug), e.aboutSectionMd != null && Object.hasOwnProperty.call(e, "aboutSectionMd") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.aboutSectionMd), e.clearAboutMd != null && Object.hasOwnProperty.call(e, "clearAboutMd") && t.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(e.clearAboutMd), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.PageConfig.MenuItems();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.getHelpUrl = e.string();
            break;
          }
          case 2: {
            d.hideGetHelp = e.bool();
            break;
          }
          case 3: {
            d.reportABugUrl = e.string();
            break;
          }
          case 4: {
            d.hideReportABug = e.bool();
            break;
          }
          case 5: {
            d.aboutSectionMd = e.string();
            break;
          }
          case 6: {
            d.clearAboutMd = e.bool();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root$1.PageConfig.MenuItems) return e;
      let t = new $root$1.PageConfig.MenuItems();
      return e.getHelpUrl != null && (t.getHelpUrl = String(e.getHelpUrl)), e.hideGetHelp != null && (t.hideGetHelp = !!e.hideGetHelp), e.reportABugUrl != null && (t.reportABugUrl = String(e.reportABugUrl)), e.hideReportABug != null && (t.hideReportABug = !!e.hideReportABug), e.aboutSectionMd != null && (t.aboutSectionMd = String(e.aboutSectionMd)), e.clearAboutMd != null && (t.clearAboutMd = !!e.clearAboutMd), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.getHelpUrl = "", n.hideGetHelp = !1, n.reportABugUrl = "", n.hideReportABug = !1, n.aboutSectionMd = "", n.clearAboutMd = !1), e.getHelpUrl != null && e.hasOwnProperty("getHelpUrl") && (n.getHelpUrl = e.getHelpUrl), e.hideGetHelp != null && e.hasOwnProperty("hideGetHelp") && (n.hideGetHelp = e.hideGetHelp), e.reportABugUrl != null && e.hasOwnProperty("reportABugUrl") && (n.reportABugUrl = e.reportABugUrl), e.hideReportABug != null && e.hasOwnProperty("hideReportABug") && (n.hideReportABug = e.hideReportABug), e.aboutSectionMd != null && e.hasOwnProperty("aboutSectionMd") && (n.aboutSectionMd = e.aboutSectionMd), e.clearAboutMd != null && e.hasOwnProperty("clearAboutMd") && (n.clearAboutMd = e.clearAboutMd), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/PageConfig.MenuItems";
    }, g;
  })(), o.Layout = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "CENTERED"] = 0, E[g[1] = "WIDE"] = 1, E[g[2] = "LAYOUT_UNSET"] = 2, E;
  })(), o.SidebarState = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "AUTO"] = 0, E[g[1] = "EXPANDED"] = 1, E[g[2] = "COLLAPSED"] = 2, E[g[3] = "SIDEBAR_UNSET"] = 3, E;
  })(), o.SidebarWidthConfig = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.pixelWidth = null;
    let E;
    return Object.defineProperty(g.prototype, "widthSpec", { get: $util$1.oneOfGetter(E = ["pixelWidth"]), set: $util$1.oneOfSetter(E) }), g.create = function(t) {
      return new g(t);
    }, g.encode = function(t, n) {
      return n || (n = $Writer$1.create()), t.pixelWidth != null && Object.hasOwnProperty.call(t, "pixelWidth") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(t.pixelWidth), n;
    }, g.decode = function(t, n, h) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let d = n === void 0 ? t.len : t.pos + n, k = new $root$1.PageConfig.SidebarWidthConfig();
      for (; t.pos < d; ) {
        let p = t.uint32();
        if (p === h) break;
        switch (p >>> 3) {
          case 1: {
            k.pixelWidth = t.uint32();
            break;
          }
          default:
            t.skipType(p & 7);
            break;
        }
      }
      return k;
    }, g.fromObject = function(t) {
      if (t instanceof $root$1.PageConfig.SidebarWidthConfig) return t;
      let n = new $root$1.PageConfig.SidebarWidthConfig();
      return t.pixelWidth != null && (n.pixelWidth = t.pixelWidth >>> 0), n;
    }, g.toObject = function(t, n) {
      n || (n = {});
      let h = {};
      return t.pixelWidth != null && t.hasOwnProperty("pixelWidth") && (h.pixelWidth = t.pixelWidth, n.oneofs && (h.widthSpec = "pixelWidth")), h;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/PageConfig.SidebarWidthConfig";
    }, g;
  })(), o;
})();
$root$1.PageInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.queryString = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.queryString != null && Object.hasOwnProperty.call(g, "queryString") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.queryString), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.PageInfo();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.queryString = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.PageInfo) return g;
    let E = new $root$1.PageInfo();
    return g.queryString != null && (E.queryString = String(g.queryString)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.queryString = ""), g.queryString != null && g.hasOwnProperty("queryString") && (e.queryString = g.queryString), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageInfo";
  }, o;
})();
const PageProfile = $root$1.PageProfile = (() => {
  function o(i) {
    if (this.commands = [], this.config = [], this.attributions = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.commands = $util$1.emptyArray, o.prototype.execTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.prepTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.config = $util$1.emptyArray, o.prototype.uncaughtException = "", o.prototype.attributions = $util$1.emptyArray, o.prototype.os = "", o.prototype.timezone = "", o.prototype.headless = !1, o.prototype.isFragmentRun = !1, o.prototype.serverMode = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.commands != null && g.commands.length) for (let e = 0; e < g.commands.length; ++e) $root$1.Command.encode(g.commands[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (g.execTime != null && Object.hasOwnProperty.call(g, "execTime") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(g.execTime), g.prepTime != null && Object.hasOwnProperty.call(g, "prepTime") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int64(g.prepTime), g.config != null && g.config.length) for (let e = 0; e < g.config.length; ++e) E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.config[e]);
    if (g.uncaughtException != null && Object.hasOwnProperty.call(g, "uncaughtException") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.uncaughtException), g.attributions != null && g.attributions.length) for (let e = 0; e < g.attributions.length; ++e) E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.attributions[e]);
    return g.os != null && Object.hasOwnProperty.call(g, "os") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.os), g.timezone != null && Object.hasOwnProperty.call(g, "timezone") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.timezone), g.headless != null && Object.hasOwnProperty.call(g, "headless") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.headless), g.isFragmentRun != null && Object.hasOwnProperty.call(g, "isFragmentRun") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.isFragmentRun), g.serverMode != null && Object.hasOwnProperty.call(g, "serverMode") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.serverMode), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.PageProfile();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.commands && n.commands.length || (n.commands = []), n.commands.push($root$1.Command.decode(g, g.uint32()));
          break;
        }
        case 2: {
          n.execTime = g.int64();
          break;
        }
        case 3: {
          n.prepTime = g.int64();
          break;
        }
        case 5: {
          n.config && n.config.length || (n.config = []), n.config.push(g.string());
          break;
        }
        case 6: {
          n.uncaughtException = g.string();
          break;
        }
        case 7: {
          n.attributions && n.attributions.length || (n.attributions = []), n.attributions.push(g.string());
          break;
        }
        case 8: {
          n.os = g.string();
          break;
        }
        case 9: {
          n.timezone = g.string();
          break;
        }
        case 10: {
          n.headless = g.bool();
          break;
        }
        case 11: {
          n.isFragmentRun = g.bool();
          break;
        }
        case 12: {
          n.serverMode = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.PageProfile) return g;
    let E = new $root$1.PageProfile();
    if (g.commands) {
      if (!Array.isArray(g.commands)) throw TypeError(".PageProfile.commands: array expected");
      E.commands = [];
      for (let e = 0; e < g.commands.length; ++e) {
        if (typeof g.commands[e] != "object") throw TypeError(".PageProfile.commands: object expected");
        E.commands[e] = $root$1.Command.fromObject(g.commands[e]);
      }
    }
    if (g.execTime != null && ($util$1.Long ? (E.execTime = $util$1.Long.fromValue(g.execTime)).unsigned = !1 : typeof g.execTime == "string" ? E.execTime = parseInt(g.execTime, 10) : typeof g.execTime == "number" ? E.execTime = g.execTime : typeof g.execTime == "object" && (E.execTime = new $util$1.LongBits(g.execTime.low >>> 0, g.execTime.high >>> 0).toNumber())), g.prepTime != null && ($util$1.Long ? (E.prepTime = $util$1.Long.fromValue(g.prepTime)).unsigned = !1 : typeof g.prepTime == "string" ? E.prepTime = parseInt(g.prepTime, 10) : typeof g.prepTime == "number" ? E.prepTime = g.prepTime : typeof g.prepTime == "object" && (E.prepTime = new $util$1.LongBits(g.prepTime.low >>> 0, g.prepTime.high >>> 0).toNumber())), g.config) {
      if (!Array.isArray(g.config)) throw TypeError(".PageProfile.config: array expected");
      E.config = [];
      for (let e = 0; e < g.config.length; ++e) E.config[e] = String(g.config[e]);
    }
    if (g.uncaughtException != null && (E.uncaughtException = String(g.uncaughtException)), g.attributions) {
      if (!Array.isArray(g.attributions)) throw TypeError(".PageProfile.attributions: array expected");
      E.attributions = [];
      for (let e = 0; e < g.attributions.length; ++e) E.attributions[e] = String(g.attributions[e]);
    }
    return g.os != null && (E.os = String(g.os)), g.timezone != null && (E.timezone = String(g.timezone)), g.headless != null && (E.headless = !!g.headless), g.isFragmentRun != null && (E.isFragmentRun = !!g.isFragmentRun), g.serverMode != null && (E.serverMode = String(g.serverMode)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.commands = [], e.config = [], e.attributions = []), E.defaults) {
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.execTime = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.execTime = E.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.prepTime = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.prepTime = E.longs === String ? "0" : 0;
      e.uncaughtException = "", e.os = "", e.timezone = "", e.headless = !1, e.isFragmentRun = !1, e.serverMode = "";
    }
    if (g.commands && g.commands.length) {
      e.commands = [];
      for (let t = 0; t < g.commands.length; ++t) e.commands[t] = $root$1.Command.toObject(g.commands[t], E);
    }
    if (g.execTime != null && g.hasOwnProperty("execTime") && (typeof g.execTime == "number" ? e.execTime = E.longs === String ? String(g.execTime) : g.execTime : e.execTime = E.longs === String ? $util$1.Long.prototype.toString.call(g.execTime) : E.longs === Number ? new $util$1.LongBits(g.execTime.low >>> 0, g.execTime.high >>> 0).toNumber() : g.execTime), g.prepTime != null && g.hasOwnProperty("prepTime") && (typeof g.prepTime == "number" ? e.prepTime = E.longs === String ? String(g.prepTime) : g.prepTime : e.prepTime = E.longs === String ? $util$1.Long.prototype.toString.call(g.prepTime) : E.longs === Number ? new $util$1.LongBits(g.prepTime.low >>> 0, g.prepTime.high >>> 0).toNumber() : g.prepTime), g.config && g.config.length) {
      e.config = [];
      for (let t = 0; t < g.config.length; ++t) e.config[t] = g.config[t];
    }
    if (g.uncaughtException != null && g.hasOwnProperty("uncaughtException") && (e.uncaughtException = g.uncaughtException), g.attributions && g.attributions.length) {
      e.attributions = [];
      for (let t = 0; t < g.attributions.length; ++t) e.attributions[t] = g.attributions[t];
    }
    return g.os != null && g.hasOwnProperty("os") && (e.os = g.os), g.timezone != null && g.hasOwnProperty("timezone") && (e.timezone = g.timezone), g.headless != null && g.hasOwnProperty("headless") && (e.headless = g.headless), g.isFragmentRun != null && g.hasOwnProperty("isFragmentRun") && (e.isFragmentRun = g.isFragmentRun), g.serverMode != null && g.hasOwnProperty("serverMode") && (e.serverMode = g.serverMode), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageProfile";
  }, o;
})();
$root$1.Argument = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.k = "", o.prototype.t = "", o.prototype.m = "", o.prototype.p = 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.k != null && Object.hasOwnProperty.call(g, "k") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.k), g.t != null && Object.hasOwnProperty.call(g, "t") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.t), g.m != null && Object.hasOwnProperty.call(g, "m") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.m), g.p != null && Object.hasOwnProperty.call(g, "p") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.p), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Argument();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.k = g.string();
          break;
        }
        case 2: {
          n.t = g.string();
          break;
        }
        case 3: {
          n.m = g.string();
          break;
        }
        case 5: {
          n.p = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Argument) return g;
    let E = new $root$1.Argument();
    return g.k != null && (E.k = String(g.k)), g.t != null && (E.t = String(g.t)), g.m != null && (E.m = String(g.m)), g.p != null && (E.p = g.p | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.k = "", e.t = "", e.m = "", e.p = 0), g.k != null && g.hasOwnProperty("k") && (e.k = g.k), g.t != null && g.hasOwnProperty("t") && (e.t = g.t), g.m != null && g.hasOwnProperty("m") && (e.m = g.m), g.p != null && g.hasOwnProperty("p") && (e.p = g.p), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Argument";
  }, o;
})();
$root$1.Command = (() => {
  function o(i) {
    if (this.args = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.name = "", o.prototype.args = $util$1.emptyArray, o.prototype.time = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.args != null && g.args.length) for (let e = 0; e < g.args.length; ++e) $root$1.Argument.encode(g.args[e], E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g.time != null && Object.hasOwnProperty.call(g, "time") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int64(g.time), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.Command();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.name = g.string();
          break;
        }
        case 2: {
          n.args && n.args.length || (n.args = []), n.args.push($root$1.Argument.decode(g, g.uint32()));
          break;
        }
        case 4: {
          n.time = g.int64();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Command) return g;
    let E = new $root$1.Command();
    if (g.name != null && (E.name = String(g.name)), g.args) {
      if (!Array.isArray(g.args)) throw TypeError(".Command.args: array expected");
      E.args = [];
      for (let e = 0; e < g.args.length; ++e) {
        if (typeof g.args[e] != "object") throw TypeError(".Command.args: object expected");
        E.args[e] = $root$1.Argument.fromObject(g.args[e]);
      }
    }
    return g.time != null && ($util$1.Long ? (E.time = $util$1.Long.fromValue(g.time)).unsigned = !1 : typeof g.time == "string" ? E.time = parseInt(g.time, 10) : typeof g.time == "number" ? E.time = g.time : typeof g.time == "object" && (E.time = new $util$1.LongBits(g.time.low >>> 0, g.time.high >>> 0).toNumber())), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.args = []), E.defaults)
      if (e.name = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.time = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.time = E.longs === String ? "0" : 0;
    if (g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.args && g.args.length) {
      e.args = [];
      for (let t = 0; t < g.args.length; ++t) e.args[t] = $root$1.Argument.toObject(g.args[t], E);
    }
    return g.time != null && g.hasOwnProperty("time") && (typeof g.time == "number" ? e.time = E.longs === String ? String(g.time) : g.time : e.time = E.longs === String ? $util$1.Long.prototype.toString.call(g.time) : E.longs === Number ? new $util$1.LongBits(g.time.low >>> 0, g.time.high >>> 0).toNumber() : g.time), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Command";
  }, o;
})();
$root$1.PageNotFound = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.pageName = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.pageName != null && Object.hasOwnProperty.call(g, "pageName") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.pageName), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.PageNotFound();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.pageName = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.PageNotFound) return g;
    let E = new $root$1.PageNotFound();
    return g.pageName != null && (E.pageName = String(g.pageName)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.pageName = ""), g.pageName != null && g.hasOwnProperty("pageName") && (e.pageName = g.pageName), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageNotFound";
  }, o;
})();
$root$1.PagesChanged = (() => {
  function o(i) {
    if (this.appPages = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.appPages = $util$1.emptyArray, o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.appPages != null && g.appPages.length) for (let e = 0; e < g.appPages.length; ++e) $root$1.AppPage.encode(g.appPages[e], E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.PagesChanged();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.appPages && n.appPages.length || (n.appPages = []), n.appPages.push($root$1.AppPage.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.PagesChanged) return g;
    let E = new $root$1.PagesChanged();
    if (g.appPages) {
      if (!Array.isArray(g.appPages)) throw TypeError(".PagesChanged.appPages: array expected");
      E.appPages = [];
      for (let e = 0; e < g.appPages.length; ++e) {
        if (typeof g.appPages[e] != "object") throw TypeError(".PagesChanged.appPages: object expected");
        E.appPages[e] = $root$1.AppPage.fromObject(g.appPages[e]);
      }
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.appPages = []), g.appPages && g.appPages.length) {
      e.appPages = [];
      for (let t = 0; t < g.appPages.length; ++t) e.appPages[t] = $root$1.AppPage.toObject(g.appPages[t], E);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PagesChanged";
  }, o;
})();
$root$1.ParentMessage = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.message = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.message != null && Object.hasOwnProperty.call(g, "message") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.message), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.ParentMessage();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.message = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ParentMessage) return g;
    let E = new $root$1.ParentMessage();
    return g.message != null && (E.message = String(g.message)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.message = ""), g.message != null && g.hasOwnProperty("message") && (e.message = g.message), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ParentMessage";
  }, o;
})();
$root$1.SessionEvent = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.scriptChangedOnDisk = null, o.prototype.scriptWasManuallyStopped = null, o.prototype.scriptCompilationException = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(i = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]), set: $util$1.oneOfSetter(i) }), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, e) {
    return e || (e = $Writer$1.create()), E.scriptChangedOnDisk != null && Object.hasOwnProperty.call(E, "scriptChangedOnDisk") && e.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(E.scriptChangedOnDisk), E.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(E, "scriptWasManuallyStopped") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.scriptWasManuallyStopped), E.scriptCompilationException != null && Object.hasOwnProperty.call(E, "scriptCompilationException") && $root$1.Exception.encode(E.scriptCompilationException, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), e;
  }, o.decode = function(E, e, t) {
    E instanceof $Reader$1 || (E = $Reader$1.create(E));
    let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.SessionEvent();
    for (; E.pos < n; ) {
      let d = E.uint32();
      if (d === t) break;
      switch (d >>> 3) {
        case 1: {
          h.scriptChangedOnDisk = E.bool();
          break;
        }
        case 2: {
          h.scriptWasManuallyStopped = E.bool();
          break;
        }
        case 3: {
          h.scriptCompilationException = $root$1.Exception.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(d & 7);
          break;
      }
    }
    return h;
  }, o.fromObject = function(E) {
    if (E instanceof $root$1.SessionEvent) return E;
    let e = new $root$1.SessionEvent();
    if (E.scriptChangedOnDisk != null && (e.scriptChangedOnDisk = !!E.scriptChangedOnDisk), E.scriptWasManuallyStopped != null && (e.scriptWasManuallyStopped = !!E.scriptWasManuallyStopped), E.scriptCompilationException != null) {
      if (typeof E.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      e.scriptCompilationException = $root$1.Exception.fromObject(E.scriptCompilationException);
    }
    return e;
  }, o.toObject = function(E, e) {
    e || (e = {});
    let t = {};
    return E.scriptChangedOnDisk != null && E.hasOwnProperty("scriptChangedOnDisk") && (t.scriptChangedOnDisk = E.scriptChangedOnDisk, e.oneofs && (t.type = "scriptChangedOnDisk")), E.scriptWasManuallyStopped != null && E.hasOwnProperty("scriptWasManuallyStopped") && (t.scriptWasManuallyStopped = E.scriptWasManuallyStopped, e.oneofs && (t.type = "scriptWasManuallyStopped")), E.scriptCompilationException != null && E.hasOwnProperty("scriptCompilationException") && (t.scriptCompilationException = $root$1.Exception.toObject(E.scriptCompilationException, e), e.oneofs && (t.type = "scriptCompilationException")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/SessionEvent";
  }, o;
})();
const MetricsEvent = $root$1.MetricsEvent = (() => {
  function o(i) {
    if (this.commands = [], this.config = [], this.attributions = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.event = "", o.prototype.anonymousId = "", o.prototype.machineIdV3 = "", o.prototype.machineIdV4 = "", o.prototype.reportHash = "", o.prototype.dev = !1, o.prototype.source = "", o.prototype.streamlitVersion = "", o.prototype.isHello = !1, o.prototype.appId = "", o.prototype.sessionId = "", o.prototype.pythonVersion = "", o.prototype.serverOs = "", o.prototype.hasDisplay = !1, o.prototype.isWebdriver = !1, o.prototype.hostedAt = "", o.prototype.owner = "", o.prototype.repo = "", o.prototype.branch = "", o.prototype.mainModule = "", o.prototype.creatorId = "", o.prototype.contextPageUrl = "", o.prototype.contextPageTitle = "", o.prototype.contextPagePath = "", o.prototype.contextPageReferrer = "", o.prototype.contextPageSearch = "", o.prototype.contextLocale = "", o.prototype.contextUserAgent = "", o.prototype.label = "", o.prototype.commands = $util$1.emptyArray, o.prototype.execTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.prepTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.config = $util$1.emptyArray, o.prototype.uncaughtException = "", o.prototype.attributions = $util$1.emptyArray, o.prototype.os = "", o.prototype.timezone = "", o.prototype.headless = !1, o.prototype.isFragmentRun = !1, o.prototype.numPages = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.pageScriptHash = "", o.prototype.activeTheme = "", o.prototype.totalLoadTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.browserInfo = null, o.prototype.serverMode = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer$1.create()), g.event != null && Object.hasOwnProperty.call(g, "event") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.event), g.anonymousId != null && Object.hasOwnProperty.call(g, "anonymousId") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.anonymousId), g.machineIdV3 != null && Object.hasOwnProperty.call(g, "machineIdV3") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.machineIdV3), g.reportHash != null && Object.hasOwnProperty.call(g, "reportHash") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.reportHash), g.dev != null && Object.hasOwnProperty.call(g, "dev") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.dev), g.source != null && Object.hasOwnProperty.call(g, "source") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.source), g.streamlitVersion != null && Object.hasOwnProperty.call(g, "streamlitVersion") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.streamlitVersion), g.isHello != null && Object.hasOwnProperty.call(g, "isHello") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.isHello), g.hostedAt != null && Object.hasOwnProperty.call(g, "hostedAt") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.hostedAt), g.owner != null && Object.hasOwnProperty.call(g, "owner") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.owner), g.repo != null && Object.hasOwnProperty.call(g, "repo") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.repo), g.branch != null && Object.hasOwnProperty.call(g, "branch") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.branch), g.mainModule != null && Object.hasOwnProperty.call(g, "mainModule") && E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.mainModule), g.creatorId != null && Object.hasOwnProperty.call(g, "creatorId") && E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.creatorId), g.contextPageUrl != null && Object.hasOwnProperty.call(g, "contextPageUrl") && E.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(g.contextPageUrl), g.contextPageTitle != null && Object.hasOwnProperty.call(g, "contextPageTitle") && E.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(g.contextPageTitle), g.contextPagePath != null && Object.hasOwnProperty.call(g, "contextPagePath") && E.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(g.contextPagePath), g.contextPageReferrer != null && Object.hasOwnProperty.call(g, "contextPageReferrer") && E.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.contextPageReferrer), g.contextPageSearch != null && Object.hasOwnProperty.call(g, "contextPageSearch") && E.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(g.contextPageSearch), g.contextLocale != null && Object.hasOwnProperty.call(g, "contextLocale") && E.uint32(
      /* id 20, wireType 2 =*/
      162
    ).string(g.contextLocale), g.contextUserAgent != null && Object.hasOwnProperty.call(g, "contextUserAgent") && E.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(g.contextUserAgent), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 22, wireType 2 =*/
      178
    ).string(g.label), g.commands != null && g.commands.length) for (let e = 0; e < g.commands.length; ++e) $root$1.Command.encode(g.commands[e], E.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim();
    if (g.execTime != null && Object.hasOwnProperty.call(g, "execTime") && E.uint32(
      /* id 24, wireType 0 =*/
      192
    ).int64(g.execTime), g.prepTime != null && Object.hasOwnProperty.call(g, "prepTime") && E.uint32(
      /* id 25, wireType 0 =*/
      200
    ).int64(g.prepTime), g.config != null && g.config.length) for (let e = 0; e < g.config.length; ++e) E.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(g.config[e]);
    if (g.uncaughtException != null && Object.hasOwnProperty.call(g, "uncaughtException") && E.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(g.uncaughtException), g.attributions != null && g.attributions.length) for (let e = 0; e < g.attributions.length; ++e) E.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(g.attributions[e]);
    return g.os != null && Object.hasOwnProperty.call(g, "os") && E.uint32(
      /* id 29, wireType 2 =*/
      234
    ).string(g.os), g.timezone != null && Object.hasOwnProperty.call(g, "timezone") && E.uint32(
      /* id 30, wireType 2 =*/
      242
    ).string(g.timezone), g.headless != null && Object.hasOwnProperty.call(g, "headless") && E.uint32(
      /* id 31, wireType 0 =*/
      248
    ).bool(g.headless), g.isFragmentRun != null && Object.hasOwnProperty.call(g, "isFragmentRun") && E.uint32(
      /* id 32, wireType 0 =*/
      256
    ).bool(g.isFragmentRun), g.appId != null && Object.hasOwnProperty.call(g, "appId") && E.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(g.appId), g.numPages != null && Object.hasOwnProperty.call(g, "numPages") && E.uint32(
      /* id 34, wireType 0 =*/
      272
    ).int64(g.numPages), g.sessionId != null && Object.hasOwnProperty.call(g, "sessionId") && E.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(g.sessionId), g.pythonVersion != null && Object.hasOwnProperty.call(g, "pythonVersion") && E.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(g.pythonVersion), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && E.uint32(
      /* id 37, wireType 2 =*/
      298
    ).string(g.pageScriptHash), g.activeTheme != null && Object.hasOwnProperty.call(g, "activeTheme") && E.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(g.activeTheme), g.totalLoadTime != null && Object.hasOwnProperty.call(g, "totalLoadTime") && E.uint32(
      /* id 39, wireType 0 =*/
      312
    ).int64(g.totalLoadTime), g.browserInfo != null && Object.hasOwnProperty.call(g, "browserInfo") && $root$1.BrowserInfo.encode(g.browserInfo, E.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), g.machineIdV4 != null && Object.hasOwnProperty.call(g, "machineIdV4") && E.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(g.machineIdV4), g.serverOs != null && Object.hasOwnProperty.call(g, "serverOs") && E.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(g.serverOs), g.hasDisplay != null && Object.hasOwnProperty.call(g, "hasDisplay") && E.uint32(
      /* id 43, wireType 0 =*/
      344
    ).bool(g.hasDisplay), g.isWebdriver != null && Object.hasOwnProperty.call(g, "isWebdriver") && E.uint32(
      /* id 44, wireType 0 =*/
      352
    ).bool(g.isWebdriver), g.serverMode != null && Object.hasOwnProperty.call(g, "serverMode") && E.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(g.serverMode), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.MetricsEvent();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.event = g.string();
          break;
        }
        case 2: {
          n.anonymousId = g.string();
          break;
        }
        case 3: {
          n.machineIdV3 = g.string();
          break;
        }
        case 41: {
          n.machineIdV4 = g.string();
          break;
        }
        case 4: {
          n.reportHash = g.string();
          break;
        }
        case 5: {
          n.dev = g.bool();
          break;
        }
        case 6: {
          n.source = g.string();
          break;
        }
        case 7: {
          n.streamlitVersion = g.string();
          break;
        }
        case 8: {
          n.isHello = g.bool();
          break;
        }
        case 33: {
          n.appId = g.string();
          break;
        }
        case 35: {
          n.sessionId = g.string();
          break;
        }
        case 36: {
          n.pythonVersion = g.string();
          break;
        }
        case 42: {
          n.serverOs = g.string();
          break;
        }
        case 43: {
          n.hasDisplay = g.bool();
          break;
        }
        case 44: {
          n.isWebdriver = g.bool();
          break;
        }
        case 9: {
          n.hostedAt = g.string();
          break;
        }
        case 10: {
          n.owner = g.string();
          break;
        }
        case 11: {
          n.repo = g.string();
          break;
        }
        case 12: {
          n.branch = g.string();
          break;
        }
        case 13: {
          n.mainModule = g.string();
          break;
        }
        case 14: {
          n.creatorId = g.string();
          break;
        }
        case 15: {
          n.contextPageUrl = g.string();
          break;
        }
        case 16: {
          n.contextPageTitle = g.string();
          break;
        }
        case 17: {
          n.contextPagePath = g.string();
          break;
        }
        case 18: {
          n.contextPageReferrer = g.string();
          break;
        }
        case 19: {
          n.contextPageSearch = g.string();
          break;
        }
        case 20: {
          n.contextLocale = g.string();
          break;
        }
        case 21: {
          n.contextUserAgent = g.string();
          break;
        }
        case 22: {
          n.label = g.string();
          break;
        }
        case 23: {
          n.commands && n.commands.length || (n.commands = []), n.commands.push($root$1.Command.decode(g, g.uint32()));
          break;
        }
        case 24: {
          n.execTime = g.int64();
          break;
        }
        case 25: {
          n.prepTime = g.int64();
          break;
        }
        case 26: {
          n.config && n.config.length || (n.config = []), n.config.push(g.string());
          break;
        }
        case 27: {
          n.uncaughtException = g.string();
          break;
        }
        case 28: {
          n.attributions && n.attributions.length || (n.attributions = []), n.attributions.push(g.string());
          break;
        }
        case 29: {
          n.os = g.string();
          break;
        }
        case 30: {
          n.timezone = g.string();
          break;
        }
        case 31: {
          n.headless = g.bool();
          break;
        }
        case 32: {
          n.isFragmentRun = g.bool();
          break;
        }
        case 34: {
          n.numPages = g.int64();
          break;
        }
        case 37: {
          n.pageScriptHash = g.string();
          break;
        }
        case 38: {
          n.activeTheme = g.string();
          break;
        }
        case 39: {
          n.totalLoadTime = g.int64();
          break;
        }
        case 40: {
          n.browserInfo = $root$1.BrowserInfo.decode(g, g.uint32());
          break;
        }
        case 45: {
          n.serverMode = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.MetricsEvent) return g;
    let E = new $root$1.MetricsEvent();
    if (g.event != null && (E.event = String(g.event)), g.anonymousId != null && (E.anonymousId = String(g.anonymousId)), g.machineIdV3 != null && (E.machineIdV3 = String(g.machineIdV3)), g.machineIdV4 != null && (E.machineIdV4 = String(g.machineIdV4)), g.reportHash != null && (E.reportHash = String(g.reportHash)), g.dev != null && (E.dev = !!g.dev), g.source != null && (E.source = String(g.source)), g.streamlitVersion != null && (E.streamlitVersion = String(g.streamlitVersion)), g.isHello != null && (E.isHello = !!g.isHello), g.appId != null && (E.appId = String(g.appId)), g.sessionId != null && (E.sessionId = String(g.sessionId)), g.pythonVersion != null && (E.pythonVersion = String(g.pythonVersion)), g.serverOs != null && (E.serverOs = String(g.serverOs)), g.hasDisplay != null && (E.hasDisplay = !!g.hasDisplay), g.isWebdriver != null && (E.isWebdriver = !!g.isWebdriver), g.hostedAt != null && (E.hostedAt = String(g.hostedAt)), g.owner != null && (E.owner = String(g.owner)), g.repo != null && (E.repo = String(g.repo)), g.branch != null && (E.branch = String(g.branch)), g.mainModule != null && (E.mainModule = String(g.mainModule)), g.creatorId != null && (E.creatorId = String(g.creatorId)), g.contextPageUrl != null && (E.contextPageUrl = String(g.contextPageUrl)), g.contextPageTitle != null && (E.contextPageTitle = String(g.contextPageTitle)), g.contextPagePath != null && (E.contextPagePath = String(g.contextPagePath)), g.contextPageReferrer != null && (E.contextPageReferrer = String(g.contextPageReferrer)), g.contextPageSearch != null && (E.contextPageSearch = String(g.contextPageSearch)), g.contextLocale != null && (E.contextLocale = String(g.contextLocale)), g.contextUserAgent != null && (E.contextUserAgent = String(g.contextUserAgent)), g.label != null && (E.label = String(g.label)), g.commands) {
      if (!Array.isArray(g.commands)) throw TypeError(".MetricsEvent.commands: array expected");
      E.commands = [];
      for (let e = 0; e < g.commands.length; ++e) {
        if (typeof g.commands[e] != "object") throw TypeError(".MetricsEvent.commands: object expected");
        E.commands[e] = $root$1.Command.fromObject(g.commands[e]);
      }
    }
    if (g.execTime != null && ($util$1.Long ? (E.execTime = $util$1.Long.fromValue(g.execTime)).unsigned = !1 : typeof g.execTime == "string" ? E.execTime = parseInt(g.execTime, 10) : typeof g.execTime == "number" ? E.execTime = g.execTime : typeof g.execTime == "object" && (E.execTime = new $util$1.LongBits(g.execTime.low >>> 0, g.execTime.high >>> 0).toNumber())), g.prepTime != null && ($util$1.Long ? (E.prepTime = $util$1.Long.fromValue(g.prepTime)).unsigned = !1 : typeof g.prepTime == "string" ? E.prepTime = parseInt(g.prepTime, 10) : typeof g.prepTime == "number" ? E.prepTime = g.prepTime : typeof g.prepTime == "object" && (E.prepTime = new $util$1.LongBits(g.prepTime.low >>> 0, g.prepTime.high >>> 0).toNumber())), g.config) {
      if (!Array.isArray(g.config)) throw TypeError(".MetricsEvent.config: array expected");
      E.config = [];
      for (let e = 0; e < g.config.length; ++e) E.config[e] = String(g.config[e]);
    }
    if (g.uncaughtException != null && (E.uncaughtException = String(g.uncaughtException)), g.attributions) {
      if (!Array.isArray(g.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
      E.attributions = [];
      for (let e = 0; e < g.attributions.length; ++e) E.attributions[e] = String(g.attributions[e]);
    }
    if (g.os != null && (E.os = String(g.os)), g.timezone != null && (E.timezone = String(g.timezone)), g.headless != null && (E.headless = !!g.headless), g.isFragmentRun != null && (E.isFragmentRun = !!g.isFragmentRun), g.numPages != null && ($util$1.Long ? (E.numPages = $util$1.Long.fromValue(g.numPages)).unsigned = !1 : typeof g.numPages == "string" ? E.numPages = parseInt(g.numPages, 10) : typeof g.numPages == "number" ? E.numPages = g.numPages : typeof g.numPages == "object" && (E.numPages = new $util$1.LongBits(g.numPages.low >>> 0, g.numPages.high >>> 0).toNumber())), g.pageScriptHash != null && (E.pageScriptHash = String(g.pageScriptHash)), g.activeTheme != null && (E.activeTheme = String(g.activeTheme)), g.totalLoadTime != null && ($util$1.Long ? (E.totalLoadTime = $util$1.Long.fromValue(g.totalLoadTime)).unsigned = !1 : typeof g.totalLoadTime == "string" ? E.totalLoadTime = parseInt(g.totalLoadTime, 10) : typeof g.totalLoadTime == "number" ? E.totalLoadTime = g.totalLoadTime : typeof g.totalLoadTime == "object" && (E.totalLoadTime = new $util$1.LongBits(g.totalLoadTime.low >>> 0, g.totalLoadTime.high >>> 0).toNumber())), g.browserInfo != null) {
      if (typeof g.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
      E.browserInfo = $root$1.BrowserInfo.fromObject(g.browserInfo);
    }
    return g.serverMode != null && (E.serverMode = String(g.serverMode)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.commands = [], e.config = [], e.attributions = []), E.defaults) {
      if (e.event = "", e.anonymousId = "", e.machineIdV3 = "", e.reportHash = "", e.dev = !1, e.source = "", e.streamlitVersion = "", e.isHello = !1, e.hostedAt = "", e.owner = "", e.repo = "", e.branch = "", e.mainModule = "", e.creatorId = "", e.contextPageUrl = "", e.contextPageTitle = "", e.contextPagePath = "", e.contextPageReferrer = "", e.contextPageSearch = "", e.contextLocale = "", e.contextUserAgent = "", e.label = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.execTime = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.execTime = E.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.prepTime = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.prepTime = E.longs === String ? "0" : 0;
      if (e.uncaughtException = "", e.os = "", e.timezone = "", e.headless = !1, e.isFragmentRun = !1, e.appId = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.numPages = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.numPages = E.longs === String ? "0" : 0;
      if (e.sessionId = "", e.pythonVersion = "", e.pageScriptHash = "", e.activeTheme = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.totalLoadTime = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
      } else e.totalLoadTime = E.longs === String ? "0" : 0;
      e.browserInfo = null, e.machineIdV4 = "", e.serverOs = "", e.hasDisplay = !1, e.isWebdriver = !1, e.serverMode = "";
    }
    if (g.event != null && g.hasOwnProperty("event") && (e.event = g.event), g.anonymousId != null && g.hasOwnProperty("anonymousId") && (e.anonymousId = g.anonymousId), g.machineIdV3 != null && g.hasOwnProperty("machineIdV3") && (e.machineIdV3 = g.machineIdV3), g.reportHash != null && g.hasOwnProperty("reportHash") && (e.reportHash = g.reportHash), g.dev != null && g.hasOwnProperty("dev") && (e.dev = g.dev), g.source != null && g.hasOwnProperty("source") && (e.source = g.source), g.streamlitVersion != null && g.hasOwnProperty("streamlitVersion") && (e.streamlitVersion = g.streamlitVersion), g.isHello != null && g.hasOwnProperty("isHello") && (e.isHello = g.isHello), g.hostedAt != null && g.hasOwnProperty("hostedAt") && (e.hostedAt = g.hostedAt), g.owner != null && g.hasOwnProperty("owner") && (e.owner = g.owner), g.repo != null && g.hasOwnProperty("repo") && (e.repo = g.repo), g.branch != null && g.hasOwnProperty("branch") && (e.branch = g.branch), g.mainModule != null && g.hasOwnProperty("mainModule") && (e.mainModule = g.mainModule), g.creatorId != null && g.hasOwnProperty("creatorId") && (e.creatorId = g.creatorId), g.contextPageUrl != null && g.hasOwnProperty("contextPageUrl") && (e.contextPageUrl = g.contextPageUrl), g.contextPageTitle != null && g.hasOwnProperty("contextPageTitle") && (e.contextPageTitle = g.contextPageTitle), g.contextPagePath != null && g.hasOwnProperty("contextPagePath") && (e.contextPagePath = g.contextPagePath), g.contextPageReferrer != null && g.hasOwnProperty("contextPageReferrer") && (e.contextPageReferrer = g.contextPageReferrer), g.contextPageSearch != null && g.hasOwnProperty("contextPageSearch") && (e.contextPageSearch = g.contextPageSearch), g.contextLocale != null && g.hasOwnProperty("contextLocale") && (e.contextLocale = g.contextLocale), g.contextUserAgent != null && g.hasOwnProperty("contextUserAgent") && (e.contextUserAgent = g.contextUserAgent), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.commands && g.commands.length) {
      e.commands = [];
      for (let t = 0; t < g.commands.length; ++t) e.commands[t] = $root$1.Command.toObject(g.commands[t], E);
    }
    if (g.execTime != null && g.hasOwnProperty("execTime") && (typeof g.execTime == "number" ? e.execTime = E.longs === String ? String(g.execTime) : g.execTime : e.execTime = E.longs === String ? $util$1.Long.prototype.toString.call(g.execTime) : E.longs === Number ? new $util$1.LongBits(g.execTime.low >>> 0, g.execTime.high >>> 0).toNumber() : g.execTime), g.prepTime != null && g.hasOwnProperty("prepTime") && (typeof g.prepTime == "number" ? e.prepTime = E.longs === String ? String(g.prepTime) : g.prepTime : e.prepTime = E.longs === String ? $util$1.Long.prototype.toString.call(g.prepTime) : E.longs === Number ? new $util$1.LongBits(g.prepTime.low >>> 0, g.prepTime.high >>> 0).toNumber() : g.prepTime), g.config && g.config.length) {
      e.config = [];
      for (let t = 0; t < g.config.length; ++t) e.config[t] = g.config[t];
    }
    if (g.uncaughtException != null && g.hasOwnProperty("uncaughtException") && (e.uncaughtException = g.uncaughtException), g.attributions && g.attributions.length) {
      e.attributions = [];
      for (let t = 0; t < g.attributions.length; ++t) e.attributions[t] = g.attributions[t];
    }
    return g.os != null && g.hasOwnProperty("os") && (e.os = g.os), g.timezone != null && g.hasOwnProperty("timezone") && (e.timezone = g.timezone), g.headless != null && g.hasOwnProperty("headless") && (e.headless = g.headless), g.isFragmentRun != null && g.hasOwnProperty("isFragmentRun") && (e.isFragmentRun = g.isFragmentRun), g.appId != null && g.hasOwnProperty("appId") && (e.appId = g.appId), g.numPages != null && g.hasOwnProperty("numPages") && (typeof g.numPages == "number" ? e.numPages = E.longs === String ? String(g.numPages) : g.numPages : e.numPages = E.longs === String ? $util$1.Long.prototype.toString.call(g.numPages) : E.longs === Number ? new $util$1.LongBits(g.numPages.low >>> 0, g.numPages.high >>> 0).toNumber() : g.numPages), g.sessionId != null && g.hasOwnProperty("sessionId") && (e.sessionId = g.sessionId), g.pythonVersion != null && g.hasOwnProperty("pythonVersion") && (e.pythonVersion = g.pythonVersion), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = g.pageScriptHash), g.activeTheme != null && g.hasOwnProperty("activeTheme") && (e.activeTheme = g.activeTheme), g.totalLoadTime != null && g.hasOwnProperty("totalLoadTime") && (typeof g.totalLoadTime == "number" ? e.totalLoadTime = E.longs === String ? String(g.totalLoadTime) : g.totalLoadTime : e.totalLoadTime = E.longs === String ? $util$1.Long.prototype.toString.call(g.totalLoadTime) : E.longs === Number ? new $util$1.LongBits(g.totalLoadTime.low >>> 0, g.totalLoadTime.high >>> 0).toNumber() : g.totalLoadTime), g.browserInfo != null && g.hasOwnProperty("browserInfo") && (e.browserInfo = $root$1.BrowserInfo.toObject(g.browserInfo, E)), g.machineIdV4 != null && g.hasOwnProperty("machineIdV4") && (e.machineIdV4 = g.machineIdV4), g.serverOs != null && g.hasOwnProperty("serverOs") && (e.serverOs = g.serverOs), g.hasDisplay != null && g.hasOwnProperty("hasDisplay") && (e.hasDisplay = g.hasDisplay), g.isWebdriver != null && g.hasOwnProperty("isWebdriver") && (e.isWebdriver = g.isWebdriver), g.serverMode != null && g.hasOwnProperty("serverMode") && (e.serverMode = g.serverMode), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/MetricsEvent";
  }, o;
})();
$root$1.BrowserInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.browserName = "", o.prototype.browserVersion = "", o.prototype.deviceType = "", o.prototype.os = "", o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer$1.create()), g.browserName != null && Object.hasOwnProperty.call(g, "browserName") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.browserName), g.browserVersion != null && Object.hasOwnProperty.call(g, "browserVersion") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.browserVersion), g.deviceType != null && Object.hasOwnProperty.call(g, "deviceType") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.deviceType), g.os != null && Object.hasOwnProperty.call(g, "os") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.os), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root$1.BrowserInfo();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.browserName = g.string();
          break;
        }
        case 2: {
          n.browserVersion = g.string();
          break;
        }
        case 3: {
          n.deviceType = g.string();
          break;
        }
        case 4: {
          n.os = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.BrowserInfo) return g;
    let E = new $root$1.BrowserInfo();
    return g.browserName != null && (E.browserName = String(g.browserName)), g.browserVersion != null && (E.browserVersion = String(g.browserVersion)), g.deviceType != null && (E.deviceType = String(g.deviceType)), g.os != null && (E.os = String(g.os)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.browserName = "", e.browserVersion = "", e.deviceType = "", e.os = ""), g.browserName != null && g.hasOwnProperty("browserName") && (e.browserName = g.browserName), g.browserVersion != null && g.hasOwnProperty("browserVersion") && (e.browserVersion = g.browserVersion), g.deviceType != null && g.hasOwnProperty("deviceType") && (e.deviceType = g.deviceType), g.os != null && g.hasOwnProperty("os") && (e.os = g.os), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BrowserInfo";
  }, o;
})();
$root$1.openmetrics = (() => {
  const o = {};
  return o.MetricSet = (function() {
    function i(g) {
      if (this.metricFamilies = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.metricFamilies = $util$1.emptyArray, i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      if (e || (e = $Writer$1.create()), E.metricFamilies != null && E.metricFamilies.length) for (let t = 0; t < E.metricFamilies.length; ++t) $root$1.openmetrics.MetricFamily.encode(E.metricFamilies[t], e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader$1 || (E = $Reader$1.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.openmetrics.MetricSet();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.metricFamilies && h.metricFamilies.length || (h.metricFamilies = []), h.metricFamilies.push($root$1.openmetrics.MetricFamily.decode(E, E.uint32()));
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root$1.openmetrics.MetricSet) return E;
      let e = new $root$1.openmetrics.MetricSet();
      if (E.metricFamilies) {
        if (!Array.isArray(E.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        e.metricFamilies = [];
        for (let t = 0; t < E.metricFamilies.length; ++t) {
          if (typeof E.metricFamilies[t] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          e.metricFamilies[t] = $root$1.openmetrics.MetricFamily.fromObject(E.metricFamilies[t]);
        }
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.metricFamilies = []), E.metricFamilies && E.metricFamilies.length) {
        t.metricFamilies = [];
        for (let n = 0; n < E.metricFamilies.length; ++n) t.metricFamilies[n] = $root$1.openmetrics.MetricFamily.toObject(E.metricFamilies[n], e);
      }
      return t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.MetricSet";
    }, i;
  })(), o.MetricFamily = (function() {
    function i(g) {
      if (this.metrics = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.name = "", i.prototype.type = 0, i.prototype.unit = "", i.prototype.help = "", i.prototype.metrics = $util$1.emptyArray, i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      if (e || (e = $Writer$1.create()), E.name != null && Object.hasOwnProperty.call(E, "name") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(E.name), E.type != null && Object.hasOwnProperty.call(E, "type") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(E.type), E.unit != null && Object.hasOwnProperty.call(E, "unit") && e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(E.unit), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(E.help), E.metrics != null && E.metrics.length) for (let t = 0; t < E.metrics.length; ++t) $root$1.Metric.encode(E.metrics[t], e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader$1 || (E = $Reader$1.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.openmetrics.MetricFamily();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.name = E.string();
            break;
          }
          case 2: {
            h.type = E.int32();
            break;
          }
          case 3: {
            h.unit = E.string();
            break;
          }
          case 4: {
            h.help = E.string();
            break;
          }
          case 5: {
            h.metrics && h.metrics.length || (h.metrics = []), h.metrics.push($root$1.Metric.decode(E, E.uint32()));
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root$1.openmetrics.MetricFamily) return E;
      let e = new $root$1.openmetrics.MetricFamily();
      switch (E.name != null && (e.name = String(E.name)), E.type) {
        default:
          if (typeof E.type == "number") {
            e.type = E.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          e.type = 0;
          break;
        case "GAUGE":
        case 1:
          e.type = 1;
          break;
        case "COUNTER":
        case 2:
          e.type = 2;
          break;
        case "STATE_SET":
        case 3:
          e.type = 3;
          break;
        case "INFO":
        case 4:
          e.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          e.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          e.type = 6;
          break;
        case "SUMMARY":
        case 7:
          e.type = 7;
          break;
      }
      if (E.unit != null && (e.unit = String(E.unit)), E.help != null && (e.help = String(E.help)), E.metrics) {
        if (!Array.isArray(E.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        e.metrics = [];
        for (let t = 0; t < E.metrics.length; ++t) {
          if (typeof E.metrics[t] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          e.metrics[t] = $root$1.Metric.fromObject(E.metrics[t]);
        }
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.metrics = []), e.defaults && (t.name = "", t.type = e.enums === String ? "UNKNOWN" : 0, t.unit = "", t.help = ""), E.name != null && E.hasOwnProperty("name") && (t.name = E.name), E.type != null && E.hasOwnProperty("type") && (t.type = e.enums === String ? $root$1.openmetrics.MetricType[E.type] === void 0 ? E.type : $root$1.openmetrics.MetricType[E.type] : E.type), E.unit != null && E.hasOwnProperty("unit") && (t.unit = E.unit), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.metrics && E.metrics.length) {
        t.metrics = [];
        for (let n = 0; n < E.metrics.length; ++n) t.metrics[n] = $root$1.Metric.toObject(E.metrics[n], e);
      }
      return t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.MetricFamily";
    }, i;
  })(), o.MetricType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "UNKNOWN"] = 0, g[i[1] = "GAUGE"] = 1, g[i[2] = "COUNTER"] = 2, g[i[3] = "STATE_SET"] = 3, g[i[4] = "INFO"] = 4, g[i[5] = "HISTOGRAM"] = 5, g[i[6] = "GAUGE_HISTOGRAM"] = 6, g[i[7] = "SUMMARY"] = 7, g;
  })(), o.Metric = (function() {
    function i(g) {
      if (this.labels = [], this.metricPoints = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.labels = $util$1.emptyArray, i.prototype.metricPoints = $util$1.emptyArray, i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      if (e || (e = $Writer$1.create()), E.labels != null && E.labels.length) for (let t = 0; t < E.labels.length; ++t) $root$1.openmetrics.Label.encode(E.labels[t], e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      if (E.metricPoints != null && E.metricPoints.length) for (let t = 0; t < E.metricPoints.length; ++t) $root$1.openmetrics.MetricPoint.encode(E.metricPoints[t], e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim();
      return e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader$1 || (E = $Reader$1.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.openmetrics.Metric();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.labels && h.labels.length || (h.labels = []), h.labels.push($root$1.openmetrics.Label.decode(E, E.uint32()));
            break;
          }
          case 2: {
            h.metricPoints && h.metricPoints.length || (h.metricPoints = []), h.metricPoints.push($root$1.openmetrics.MetricPoint.decode(E, E.uint32()));
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root$1.openmetrics.Metric) return E;
      let e = new $root$1.openmetrics.Metric();
      if (E.labels) {
        if (!Array.isArray(E.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
        e.labels = [];
        for (let t = 0; t < E.labels.length; ++t) {
          if (typeof E.labels[t] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
          e.labels[t] = $root$1.openmetrics.Label.fromObject(E.labels[t]);
        }
      }
      if (E.metricPoints) {
        if (!Array.isArray(E.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        e.metricPoints = [];
        for (let t = 0; t < E.metricPoints.length; ++t) {
          if (typeof E.metricPoints[t] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          e.metricPoints[t] = $root$1.openmetrics.MetricPoint.fromObject(E.metricPoints[t]);
        }
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.labels = [], t.metricPoints = []), E.labels && E.labels.length) {
        t.labels = [];
        for (let n = 0; n < E.labels.length; ++n) t.labels[n] = $root$1.openmetrics.Label.toObject(E.labels[n], e);
      }
      if (E.metricPoints && E.metricPoints.length) {
        t.metricPoints = [];
        for (let n = 0; n < E.metricPoints.length; ++n) t.metricPoints[n] = $root$1.openmetrics.MetricPoint.toObject(E.metricPoints[n], e);
      }
      return t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.Metric";
    }, i;
  })(), o.Label = (function() {
    function i(g) {
      if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.name = "", i.prototype.value = "", i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer$1.create()), E.name != null && Object.hasOwnProperty.call(E, "name") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(E.name), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(E.value), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader$1 || (E = $Reader$1.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.openmetrics.Label();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.name = E.string();
            break;
          }
          case 2: {
            h.value = E.string();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root$1.openmetrics.Label) return E;
      let e = new $root$1.openmetrics.Label();
      return E.name != null && (e.name = String(E.name)), E.value != null && (e.value = String(E.value)), e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.name = "", t.value = ""), E.name != null && E.hasOwnProperty("name") && (t.name = E.name), E.value != null && E.hasOwnProperty("value") && (t.value = E.value), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.Label";
    }, i;
  })(), o.MetricPoint = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.unknownValue = null, i.prototype.gaugeValue = null, i.prototype.counterValue = null, i.prototype.histogramValue = null, i.prototype.stateSetValue = null, i.prototype.infoValue = null, i.prototype.summaryValue = null, i.prototype.timestamp = null;
    let g;
    return Object.defineProperty(i.prototype, "value", { get: $util$1.oneOfGetter(g = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.unknownValue != null && Object.hasOwnProperty.call(e, "unknownValue") && $root$1.openmetrics.UnknownValue.encode(e.unknownValue, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.gaugeValue != null && Object.hasOwnProperty.call(e, "gaugeValue") && $root$1.openmetrics.GaugeValue.encode(e.gaugeValue, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.counterValue != null && Object.hasOwnProperty.call(e, "counterValue") && $root$1.openmetrics.CounterValue.encode(e.counterValue, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), e.histogramValue != null && Object.hasOwnProperty.call(e, "histogramValue") && $root$1.openmetrics.HistogramValue.encode(e.histogramValue, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.stateSetValue != null && Object.hasOwnProperty.call(e, "stateSetValue") && $root$1.openmetrics.StateSetValue.encode(e.stateSetValue, t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), e.infoValue != null && Object.hasOwnProperty.call(e, "infoValue") && $root$1.openmetrics.InfoValue.encode(e.infoValue, t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), e.summaryValue != null && Object.hasOwnProperty.call(e, "summaryValue") && $root$1.openmetrics.SummaryValue.encode(e.summaryValue, t.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), e.timestamp != null && Object.hasOwnProperty.call(e, "timestamp") && $root$1.google.protobuf.Timestamp.encode(e.timestamp, t.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.openmetrics.MetricPoint();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.unknownValue = $root$1.openmetrics.UnknownValue.decode(e, e.uint32());
            break;
          }
          case 2: {
            d.gaugeValue = $root$1.openmetrics.GaugeValue.decode(e, e.uint32());
            break;
          }
          case 3: {
            d.counterValue = $root$1.openmetrics.CounterValue.decode(e, e.uint32());
            break;
          }
          case 4: {
            d.histogramValue = $root$1.openmetrics.HistogramValue.decode(e, e.uint32());
            break;
          }
          case 5: {
            d.stateSetValue = $root$1.openmetrics.StateSetValue.decode(e, e.uint32());
            break;
          }
          case 6: {
            d.infoValue = $root$1.openmetrics.InfoValue.decode(e, e.uint32());
            break;
          }
          case 7: {
            d.summaryValue = $root$1.openmetrics.SummaryValue.decode(e, e.uint32());
            break;
          }
          case 8: {
            d.timestamp = $root$1.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.MetricPoint) return e;
      let t = new $root$1.openmetrics.MetricPoint();
      if (e.unknownValue != null) {
        if (typeof e.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        t.unknownValue = $root$1.openmetrics.UnknownValue.fromObject(e.unknownValue);
      }
      if (e.gaugeValue != null) {
        if (typeof e.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        t.gaugeValue = $root$1.openmetrics.GaugeValue.fromObject(e.gaugeValue);
      }
      if (e.counterValue != null) {
        if (typeof e.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        t.counterValue = $root$1.openmetrics.CounterValue.fromObject(e.counterValue);
      }
      if (e.histogramValue != null) {
        if (typeof e.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        t.histogramValue = $root$1.openmetrics.HistogramValue.fromObject(e.histogramValue);
      }
      if (e.stateSetValue != null) {
        if (typeof e.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        t.stateSetValue = $root$1.openmetrics.StateSetValue.fromObject(e.stateSetValue);
      }
      if (e.infoValue != null) {
        if (typeof e.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        t.infoValue = $root$1.openmetrics.InfoValue.fromObject(e.infoValue);
      }
      if (e.summaryValue != null) {
        if (typeof e.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        t.summaryValue = $root$1.openmetrics.SummaryValue.fromObject(e.summaryValue);
      }
      if (e.timestamp != null) {
        if (typeof e.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        t.timestamp = $root$1.google.protobuf.Timestamp.fromObject(e.timestamp);
      }
      return t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.timestamp = null), e.unknownValue != null && e.hasOwnProperty("unknownValue") && (n.unknownValue = $root$1.openmetrics.UnknownValue.toObject(e.unknownValue, t), t.oneofs && (n.value = "unknownValue")), e.gaugeValue != null && e.hasOwnProperty("gaugeValue") && (n.gaugeValue = $root$1.openmetrics.GaugeValue.toObject(e.gaugeValue, t), t.oneofs && (n.value = "gaugeValue")), e.counterValue != null && e.hasOwnProperty("counterValue") && (n.counterValue = $root$1.openmetrics.CounterValue.toObject(e.counterValue, t), t.oneofs && (n.value = "counterValue")), e.histogramValue != null && e.hasOwnProperty("histogramValue") && (n.histogramValue = $root$1.openmetrics.HistogramValue.toObject(e.histogramValue, t), t.oneofs && (n.value = "histogramValue")), e.stateSetValue != null && e.hasOwnProperty("stateSetValue") && (n.stateSetValue = $root$1.openmetrics.StateSetValue.toObject(e.stateSetValue, t), t.oneofs && (n.value = "stateSetValue")), e.infoValue != null && e.hasOwnProperty("infoValue") && (n.infoValue = $root$1.openmetrics.InfoValue.toObject(e.infoValue, t), t.oneofs && (n.value = "infoValue")), e.summaryValue != null && e.hasOwnProperty("summaryValue") && (n.summaryValue = $root$1.openmetrics.SummaryValue.toObject(e.summaryValue, t), t.oneofs && (n.value = "summaryValue")), e.timestamp != null && e.hasOwnProperty("timestamp") && (n.timestamp = $root$1.google.protobuf.Timestamp.toObject(e.timestamp, t)), n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.MetricPoint";
    }, i;
  })(), o.UnknownValue = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null;
    let g;
    return Object.defineProperty(i.prototype, "value", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.openmetrics.UnknownValue();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.doubleValue = e.double();
            break;
          }
          case 2: {
            d.intValue = e.int64();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.UnknownValue) return e;
      let t = new $root$1.openmetrics.UnknownValue();
      return e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return e.doubleValue != null && e.hasOwnProperty("doubleValue") && (n.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (n.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? n.intValue = t.longs === String ? String(e.intValue) : e.intValue : n.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (n.value = "intValue")), n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.UnknownValue";
    }, i;
  })(), o.GaugeValue = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null;
    let g;
    return Object.defineProperty(i.prototype, "value", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.openmetrics.GaugeValue();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.doubleValue = e.double();
            break;
          }
          case 2: {
            d.intValue = e.int64();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.GaugeValue) return e;
      let t = new $root$1.openmetrics.GaugeValue();
      return e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return e.doubleValue != null && e.hasOwnProperty("doubleValue") && (n.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (n.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? n.intValue = t.longs === String ? String(e.intValue) : e.intValue : n.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (n.value = "intValue")), n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.GaugeValue";
    }, i;
  })(), o.CounterValue = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null, i.prototype.created = null, i.prototype.exemplar = null;
    let g;
    return Object.defineProperty(i.prototype, "total", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.intValue), e.created != null && Object.hasOwnProperty.call(e, "created") && $root$1.google.protobuf.Timestamp.encode(e.created, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), e.exemplar != null && Object.hasOwnProperty.call(e, "exemplar") && $root$1.openmetrics.Exemplar.encode(e.exemplar, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.openmetrics.CounterValue();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.doubleValue = e.double();
            break;
          }
          case 2: {
            d.intValue = e.uint64();
            break;
          }
          case 3: {
            d.created = $root$1.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 4: {
            d.exemplar = $root$1.openmetrics.Exemplar.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.CounterValue) return e;
      let t = new $root$1.openmetrics.CounterValue();
      if (e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !0 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
        t.created = $root$1.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.exemplar != null) {
        if (typeof e.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        t.exemplar = $root$1.openmetrics.Exemplar.fromObject(e.exemplar);
      }
      return t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.created = null, n.exemplar = null), e.doubleValue != null && e.hasOwnProperty("doubleValue") && (n.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (n.total = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? n.intValue = t.longs === String ? String(e.intValue) : e.intValue : n.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0) : e.intValue, t.oneofs && (n.total = "intValue")), e.created != null && e.hasOwnProperty("created") && (n.created = $root$1.google.protobuf.Timestamp.toObject(e.created, t)), e.exemplar != null && e.hasOwnProperty("exemplar") && (n.exemplar = $root$1.openmetrics.Exemplar.toObject(e.exemplar, t)), n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.CounterValue";
    }, i;
  })(), o.HistogramValue = (function() {
    function i(E) {
      if (this.buckets = [], E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null, i.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, i.prototype.created = null, i.prototype.buckets = $util$1.emptyArray;
    let g;
    return Object.defineProperty(i.prototype, "sum", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      if (t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.count), e.created != null && Object.hasOwnProperty.call(e, "created") && $root$1.google.protobuf.Timestamp.encode(e.created, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.buckets != null && e.buckets.length) for (let n = 0; n < e.buckets.length; ++n) $root$1.openmetrics.HistogramValue.Bucket.encode(e.buckets[n], t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.openmetrics.HistogramValue();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.doubleValue = e.double();
            break;
          }
          case 2: {
            d.intValue = e.int64();
            break;
          }
          case 3: {
            d.count = e.uint64();
            break;
          }
          case 4: {
            d.created = $root$1.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 5: {
            d.buckets && d.buckets.length || (d.buckets = []), d.buckets.push($root$1.openmetrics.HistogramValue.Bucket.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.HistogramValue) return e;
      let t = new $root$1.openmetrics.HistogramValue();
      if (e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && ($util$1.Long ? (t.count = $util$1.Long.fromValue(e.count)).unsigned = !0 : typeof e.count == "string" ? t.count = parseInt(e.count, 10) : typeof e.count == "number" ? t.count = e.count : typeof e.count == "object" && (t.count = new $util$1.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
        t.created = $root$1.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.buckets) {
        if (!Array.isArray(e.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        t.buckets = [];
        for (let n = 0; n < e.buckets.length; ++n) {
          if (typeof e.buckets[n] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          t.buckets[n] = $root$1.openmetrics.HistogramValue.Bucket.fromObject(e.buckets[n]);
        }
      }
      return t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.buckets = []), t.defaults) {
        if ($util$1.Long) {
          let h = new $util$1.Long(0, 0, !0);
          n.count = t.longs === String ? h.toString() : t.longs === Number ? h.toNumber() : h;
        } else n.count = t.longs === String ? "0" : 0;
        n.created = null;
      }
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (n.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (n.sum = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? n.intValue = t.longs === String ? String(e.intValue) : e.intValue : n.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (n.sum = "intValue")), e.count != null && e.hasOwnProperty("count") && (typeof e.count == "number" ? n.count = t.longs === String ? String(e.count) : e.count : n.count = t.longs === String ? $util$1.Long.prototype.toString.call(e.count) : t.longs === Number ? new $util$1.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && e.hasOwnProperty("created") && (n.created = $root$1.google.protobuf.Timestamp.toObject(e.created, t)), e.buckets && e.buckets.length) {
        n.buckets = [];
        for (let h = 0; h < e.buckets.length; ++h) n.buckets[h] = $root$1.openmetrics.HistogramValue.Bucket.toObject(e.buckets[h], t);
      }
      return n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue";
    }, i.Bucket = (function() {
      function E(e) {
        if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
      }
      return E.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, E.prototype.upperBound = 0, E.prototype.exemplar = null, E.create = function(t) {
        return new E(t);
      }, E.encode = function(t, n) {
        return n || (n = $Writer$1.create()), t.count != null && Object.hasOwnProperty.call(t, "count") && n.uint32(
          /* id 1, wireType 0 =*/
          8
        ).uint64(t.count), t.upperBound != null && Object.hasOwnProperty.call(t, "upperBound") && n.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(t.upperBound), t.exemplar != null && Object.hasOwnProperty.call(t, "exemplar") && $root$1.openmetrics.Exemplar.encode(t.exemplar, n.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim(), n;
      }, E.decode = function(t, n, h) {
        t instanceof $Reader$1 || (t = $Reader$1.create(t));
        let d = n === void 0 ? t.len : t.pos + n, k = new $root$1.openmetrics.HistogramValue.Bucket();
        for (; t.pos < d; ) {
          let p = t.uint32();
          if (p === h) break;
          switch (p >>> 3) {
            case 1: {
              k.count = t.uint64();
              break;
            }
            case 2: {
              k.upperBound = t.double();
              break;
            }
            case 3: {
              k.exemplar = $root$1.openmetrics.Exemplar.decode(t, t.uint32());
              break;
            }
            default:
              t.skipType(p & 7);
              break;
          }
        }
        return k;
      }, E.fromObject = function(t) {
        if (t instanceof $root$1.openmetrics.HistogramValue.Bucket) return t;
        let n = new $root$1.openmetrics.HistogramValue.Bucket();
        if (t.count != null && ($util$1.Long ? (n.count = $util$1.Long.fromValue(t.count)).unsigned = !0 : typeof t.count == "string" ? n.count = parseInt(t.count, 10) : typeof t.count == "number" ? n.count = t.count : typeof t.count == "object" && (n.count = new $util$1.LongBits(t.count.low >>> 0, t.count.high >>> 0).toNumber(!0))), t.upperBound != null && (n.upperBound = Number(t.upperBound)), t.exemplar != null) {
          if (typeof t.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          n.exemplar = $root$1.openmetrics.Exemplar.fromObject(t.exemplar);
        }
        return n;
      }, E.toObject = function(t, n) {
        n || (n = {});
        let h = {};
        if (n.defaults) {
          if ($util$1.Long) {
            let d = new $util$1.Long(0, 0, !0);
            h.count = n.longs === String ? d.toString() : n.longs === Number ? d.toNumber() : d;
          } else h.count = n.longs === String ? "0" : 0;
          h.upperBound = 0, h.exemplar = null;
        }
        return t.count != null && t.hasOwnProperty("count") && (typeof t.count == "number" ? h.count = n.longs === String ? String(t.count) : t.count : h.count = n.longs === String ? $util$1.Long.prototype.toString.call(t.count) : n.longs === Number ? new $util$1.LongBits(t.count.low >>> 0, t.count.high >>> 0).toNumber(!0) : t.count), t.upperBound != null && t.hasOwnProperty("upperBound") && (h.upperBound = n.json && !isFinite(t.upperBound) ? String(t.upperBound) : t.upperBound), t.exemplar != null && t.hasOwnProperty("exemplar") && (h.exemplar = $root$1.openmetrics.Exemplar.toObject(t.exemplar, n)), h;
      }, E.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, E.getTypeUrl = function(t) {
        return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.HistogramValue.Bucket";
      }, E;
    })(), i;
  })(), o.Exemplar = (function() {
    function i(g) {
      if (this.label = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.value = 0, i.prototype.timestamp = null, i.prototype.label = $util$1.emptyArray, i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      if (e || (e = $Writer$1.create()), E.value != null && Object.hasOwnProperty.call(E, "value") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(E.value), E.timestamp != null && Object.hasOwnProperty.call(E, "timestamp") && $root$1.google.protobuf.Timestamp.encode(E.timestamp, e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), E.label != null && E.label.length) for (let t = 0; t < E.label.length; ++t) $root$1.openmetrics.Label.encode(E.label[t], e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim();
      return e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader$1 || (E = $Reader$1.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.openmetrics.Exemplar();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.value = E.double();
            break;
          }
          case 2: {
            h.timestamp = $root$1.google.protobuf.Timestamp.decode(E, E.uint32());
            break;
          }
          case 3: {
            h.label && h.label.length || (h.label = []), h.label.push($root$1.openmetrics.Label.decode(E, E.uint32()));
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root$1.openmetrics.Exemplar) return E;
      let e = new $root$1.openmetrics.Exemplar();
      if (E.value != null && (e.value = Number(E.value)), E.timestamp != null) {
        if (typeof E.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        e.timestamp = $root$1.google.protobuf.Timestamp.fromObject(E.timestamp);
      }
      if (E.label) {
        if (!Array.isArray(E.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
        e.label = [];
        for (let t = 0; t < E.label.length; ++t) {
          if (typeof E.label[t] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
          e.label[t] = $root$1.openmetrics.Label.fromObject(E.label[t]);
        }
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.label = []), e.defaults && (t.value = 0, t.timestamp = null), E.value != null && E.hasOwnProperty("value") && (t.value = e.json && !isFinite(E.value) ? String(E.value) : E.value), E.timestamp != null && E.hasOwnProperty("timestamp") && (t.timestamp = $root$1.google.protobuf.Timestamp.toObject(E.timestamp, e)), E.label && E.label.length) {
        t.label = [];
        for (let n = 0; n < E.label.length; ++n) t.label[n] = $root$1.openmetrics.Label.toObject(E.label[n], e);
      }
      return t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.Exemplar";
    }, i;
  })(), o.StateSetValue = (function() {
    function i(g) {
      if (this.states = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.states = $util$1.emptyArray, i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      if (e || (e = $Writer$1.create()), E.states != null && E.states.length) for (let t = 0; t < E.states.length; ++t) $root$1.openmetrics.StateSetValue.State.encode(E.states[t], e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader$1 || (E = $Reader$1.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.openmetrics.StateSetValue();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.states && h.states.length || (h.states = []), h.states.push($root$1.openmetrics.StateSetValue.State.decode(E, E.uint32()));
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root$1.openmetrics.StateSetValue) return E;
      let e = new $root$1.openmetrics.StateSetValue();
      if (E.states) {
        if (!Array.isArray(E.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
        e.states = [];
        for (let t = 0; t < E.states.length; ++t) {
          if (typeof E.states[t] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
          e.states[t] = $root$1.openmetrics.StateSetValue.State.fromObject(E.states[t]);
        }
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.states = []), E.states && E.states.length) {
        t.states = [];
        for (let n = 0; n < E.states.length; ++n) t.states[n] = $root$1.openmetrics.StateSetValue.State.toObject(E.states[n], e);
      }
      return t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.StateSetValue";
    }, i.State = (function() {
      function g(E) {
        if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
      }
      return g.prototype.enabled = !1, g.prototype.name = "", g.create = function(e) {
        return new g(e);
      }, g.encode = function(e, t) {
        return t || (t = $Writer$1.create()), e.enabled != null && Object.hasOwnProperty.call(e, "enabled") && t.uint32(
          /* id 1, wireType 0 =*/
          8
        ).bool(e.enabled), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(e.name), t;
      }, g.decode = function(e, t, n) {
        e instanceof $Reader$1 || (e = $Reader$1.create(e));
        let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.openmetrics.StateSetValue.State();
        for (; e.pos < h; ) {
          let k = e.uint32();
          if (k === n) break;
          switch (k >>> 3) {
            case 1: {
              d.enabled = e.bool();
              break;
            }
            case 2: {
              d.name = e.string();
              break;
            }
            default:
              e.skipType(k & 7);
              break;
          }
        }
        return d;
      }, g.fromObject = function(e) {
        if (e instanceof $root$1.openmetrics.StateSetValue.State) return e;
        let t = new $root$1.openmetrics.StateSetValue.State();
        return e.enabled != null && (t.enabled = !!e.enabled), e.name != null && (t.name = String(e.name)), t;
      }, g.toObject = function(e, t) {
        t || (t = {});
        let n = {};
        return t.defaults && (n.enabled = !1, n.name = ""), e.enabled != null && e.hasOwnProperty("enabled") && (n.enabled = e.enabled), e.name != null && e.hasOwnProperty("name") && (n.name = e.name), n;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, g.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.StateSetValue.State";
      }, g;
    })(), i;
  })(), o.InfoValue = (function() {
    function i(g) {
      if (this.info = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.info = $util$1.emptyArray, i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      if (e || (e = $Writer$1.create()), E.info != null && E.info.length) for (let t = 0; t < E.info.length; ++t) $root$1.openmetrics.Label.encode(E.info[t], e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader$1 || (E = $Reader$1.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root$1.openmetrics.InfoValue();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.info && h.info.length || (h.info = []), h.info.push($root$1.openmetrics.Label.decode(E, E.uint32()));
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root$1.openmetrics.InfoValue) return E;
      let e = new $root$1.openmetrics.InfoValue();
      if (E.info) {
        if (!Array.isArray(E.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
        e.info = [];
        for (let t = 0; t < E.info.length; ++t) {
          if (typeof E.info[t] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
          e.info[t] = $root$1.openmetrics.Label.fromObject(E.info[t]);
        }
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.info = []), E.info && E.info.length) {
        t.info = [];
        for (let n = 0; n < E.info.length; ++n) t.info[n] = $root$1.openmetrics.Label.toObject(E.info[n], e);
      }
      return t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.InfoValue";
    }, i;
  })(), o.SummaryValue = (function() {
    function i(E) {
      if (this.quantile = [], E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null, i.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, i.prototype.created = null, i.prototype.quantile = $util$1.emptyArray;
    let g;
    return Object.defineProperty(i.prototype, "sum", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), i.create = function(e) {
      return new i(e);
    }, i.encode = function(e, t) {
      if (t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.count), e.created != null && Object.hasOwnProperty.call(e, "created") && $root$1.google.protobuf.Timestamp.encode(e.created, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.quantile != null && e.quantile.length) for (let n = 0; n < e.quantile.length; ++n) $root$1.openmetrics.SummaryValue.Quantile.encode(e.quantile[n], t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return t;
    }, i.decode = function(e, t, n) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.openmetrics.SummaryValue();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.doubleValue = e.double();
            break;
          }
          case 2: {
            d.intValue = e.int64();
            break;
          }
          case 3: {
            d.count = e.uint64();
            break;
          }
          case 4: {
            d.created = $root$1.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 5: {
            d.quantile && d.quantile.length || (d.quantile = []), d.quantile.push($root$1.openmetrics.SummaryValue.Quantile.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, i.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.SummaryValue) return e;
      let t = new $root$1.openmetrics.SummaryValue();
      if (e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && ($util$1.Long ? (t.count = $util$1.Long.fromValue(e.count)).unsigned = !0 : typeof e.count == "string" ? t.count = parseInt(e.count, 10) : typeof e.count == "number" ? t.count = e.count : typeof e.count == "object" && (t.count = new $util$1.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
        t.created = $root$1.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.quantile) {
        if (!Array.isArray(e.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        t.quantile = [];
        for (let n = 0; n < e.quantile.length; ++n) {
          if (typeof e.quantile[n] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          t.quantile[n] = $root$1.openmetrics.SummaryValue.Quantile.fromObject(e.quantile[n]);
        }
      }
      return t;
    }, i.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      if ((t.arrays || t.defaults) && (n.quantile = []), t.defaults) {
        if ($util$1.Long) {
          let h = new $util$1.Long(0, 0, !0);
          n.count = t.longs === String ? h.toString() : t.longs === Number ? h.toNumber() : h;
        } else n.count = t.longs === String ? "0" : 0;
        n.created = null;
      }
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (n.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (n.sum = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? n.intValue = t.longs === String ? String(e.intValue) : e.intValue : n.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (n.sum = "intValue")), e.count != null && e.hasOwnProperty("count") && (typeof e.count == "number" ? n.count = t.longs === String ? String(e.count) : e.count : n.count = t.longs === String ? $util$1.Long.prototype.toString.call(e.count) : t.longs === Number ? new $util$1.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && e.hasOwnProperty("created") && (n.created = $root$1.google.protobuf.Timestamp.toObject(e.created, t)), e.quantile && e.quantile.length) {
        n.quantile = [];
        for (let h = 0; h < e.quantile.length; ++h) n.quantile[h] = $root$1.openmetrics.SummaryValue.Quantile.toObject(e.quantile[h], t);
      }
      return n;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, i.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue";
    }, i.Quantile = (function() {
      function E(e) {
        if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
      }
      return E.prototype.quantile = 0, E.prototype.value = 0, E.create = function(t) {
        return new E(t);
      }, E.encode = function(t, n) {
        return n || (n = $Writer$1.create()), t.quantile != null && Object.hasOwnProperty.call(t, "quantile") && n.uint32(
          /* id 1, wireType 1 =*/
          9
        ).double(t.quantile), t.value != null && Object.hasOwnProperty.call(t, "value") && n.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(t.value), n;
      }, E.decode = function(t, n, h) {
        t instanceof $Reader$1 || (t = $Reader$1.create(t));
        let d = n === void 0 ? t.len : t.pos + n, k = new $root$1.openmetrics.SummaryValue.Quantile();
        for (; t.pos < d; ) {
          let p = t.uint32();
          if (p === h) break;
          switch (p >>> 3) {
            case 1: {
              k.quantile = t.double();
              break;
            }
            case 2: {
              k.value = t.double();
              break;
            }
            default:
              t.skipType(p & 7);
              break;
          }
        }
        return k;
      }, E.fromObject = function(t) {
        if (t instanceof $root$1.openmetrics.SummaryValue.Quantile) return t;
        let n = new $root$1.openmetrics.SummaryValue.Quantile();
        return t.quantile != null && (n.quantile = Number(t.quantile)), t.value != null && (n.value = Number(t.value)), n;
      }, E.toObject = function(t, n) {
        n || (n = {});
        let h = {};
        return n.defaults && (h.quantile = 0, h.value = 0), t.quantile != null && t.hasOwnProperty("quantile") && (h.quantile = n.json && !isFinite(t.quantile) ? String(t.quantile) : t.quantile), t.value != null && t.hasOwnProperty("value") && (h.value = n.json && !isFinite(t.value) ? String(t.value) : t.value), h;
      }, E.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, E.getTypeUrl = function(t) {
        return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.SummaryValue.Quantile";
      }, E;
    })(), i;
  })(), o;
})();
$root$1.google = (() => {
  const o = {};
  return o.protobuf = (function() {
    const i = {};
    return i.Timestamp = (function() {
      function g(E) {
        if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
      }
      return g.prototype.seconds = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, g.prototype.nanos = 0, g.create = function(e) {
        return new g(e);
      }, g.encode = function(e, t) {
        return t || (t = $Writer$1.create()), e.seconds != null && Object.hasOwnProperty.call(e, "seconds") && t.uint32(
          /* id 1, wireType 0 =*/
          8
        ).int64(e.seconds), e.nanos != null && Object.hasOwnProperty.call(e, "nanos") && t.uint32(
          /* id 2, wireType 0 =*/
          16
        ).int32(e.nanos), t;
      }, g.decode = function(e, t, n) {
        e instanceof $Reader$1 || (e = $Reader$1.create(e));
        let h = t === void 0 ? e.len : e.pos + t, d = new $root$1.google.protobuf.Timestamp();
        for (; e.pos < h; ) {
          let k = e.uint32();
          if (k === n) break;
          switch (k >>> 3) {
            case 1: {
              d.seconds = e.int64();
              break;
            }
            case 2: {
              d.nanos = e.int32();
              break;
            }
            default:
              e.skipType(k & 7);
              break;
          }
        }
        return d;
      }, g.fromObject = function(e) {
        if (e instanceof $root$1.google.protobuf.Timestamp) return e;
        let t = new $root$1.google.protobuf.Timestamp();
        return e.seconds != null && ($util$1.Long ? (t.seconds = $util$1.Long.fromValue(e.seconds)).unsigned = !1 : typeof e.seconds == "string" ? t.seconds = parseInt(e.seconds, 10) : typeof e.seconds == "number" ? t.seconds = e.seconds : typeof e.seconds == "object" && (t.seconds = new $util$1.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber())), e.nanos != null && (t.nanos = e.nanos | 0), t;
      }, g.toObject = function(e, t) {
        t || (t = {});
        let n = {};
        if (t.defaults) {
          if ($util$1.Long) {
            let h = new $util$1.Long(0, 0, !1);
            n.seconds = t.longs === String ? h.toString() : t.longs === Number ? h.toNumber() : h;
          } else n.seconds = t.longs === String ? "0" : 0;
          n.nanos = 0;
        }
        return e.seconds != null && e.hasOwnProperty("seconds") && (typeof e.seconds == "number" ? n.seconds = t.longs === String ? String(e.seconds) : e.seconds : n.seconds = t.longs === String ? $util$1.Long.prototype.toString.call(e.seconds) : t.longs === Number ? new $util$1.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber() : e.seconds), e.nanos != null && e.hasOwnProperty("nanos") && (n.nanos = e.nanos), n;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, g.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/google.protobuf.Timestamp";
      }, g;
    })(), i;
  })(), o;
})();
$root$1.RootContainer = (() => {
  const o = {}, i = Object.create(o);
  return i[o[0] = "MAIN"] = 0, i[o[1] = "SIDEBAR"] = 1, i[o[2] = "EVENT"] = 2, i[o[3] = "BOTTOM"] = 3, i;
})();
function ensureError(o) {
  return o instanceof Error ? o : new Error(`${o}`);
}
const handlePreserveConsecutiveUppercase = (o, i) => (o = o.replace(
  new RegExp("((?<![\\p{Uppercase_Letter}\\d])[\\p{Uppercase_Letter}\\d](?![\\p{Uppercase_Letter}\\d]))", "gu"),
  (g) => g.toLowerCase()
), o.replace(
  new RegExp("(?<!\\p{Uppercase_Letter})(\\p{Uppercase_Letter}+)(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
  (g, E, e) => E + i + e.toLowerCase()
));
function decamelize$1(o, {
  separator: i = "_",
  preserveConsecutiveUppercase: g = !1
} = {}) {
  if (!(typeof o == "string" && typeof i == "string"))
    throw new TypeError(
      "The `text` and `separator` arguments should be of type `string`"
    );
  if (o.length < 2)
    return g ? o : o.toLowerCase();
  const E = `$1${i}$2`, e = o.replace(
    new RegExp("([\\p{Lowercase_Letter}\\d])(\\p{Uppercase_Letter})", "gu"),
    E
  );
  return g ? handlePreserveConsecutiveUppercase(e, i) : e.replace(
    new RegExp("(\\p{Uppercase_Letter})(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
    E
  ).toLowerCase();
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$4 = freeGlobal || freeSelf || Function("return this")(), Symbol$1 = root$4.Symbol, objectProto$h = Object.prototype, hasOwnProperty$f = objectProto$h.hasOwnProperty, nativeObjectToString$1 = objectProto$h.toString, symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(o) {
  var i = hasOwnProperty$f.call(o, symToStringTag$1), g = o[symToStringTag$1];
  try {
    o[symToStringTag$1] = void 0;
    var E = !0;
  } catch {
  }
  var e = nativeObjectToString$1.call(o);
  return E && (i ? o[symToStringTag$1] = g : delete o[symToStringTag$1]), e;
}
var objectProto$g = Object.prototype, nativeObjectToString = objectProto$g.toString;
function objectToString(o) {
  return nativeObjectToString.call(o);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(o) {
  return o == null ? o === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(o) ? getRawTag(o) : objectToString(o);
}
function isObjectLike(o) {
  return o != null && typeof o == "object";
}
var symbolTag$3 = "[object Symbol]";
function isSymbol(o) {
  return typeof o == "symbol" || isObjectLike(o) && baseGetTag(o) == symbolTag$3;
}
function arrayMap(o, i) {
  for (var g = -1, E = o == null ? 0 : o.length, e = Array(E); ++g < E; )
    e[g] = i(o[g], g, o);
  return e;
}
var isArray$1 = Array.isArray, symbolProto$2 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
function baseToString(o) {
  if (typeof o == "string")
    return o;
  if (isArray$1(o))
    return arrayMap(o, baseToString) + "";
  if (isSymbol(o))
    return symbolToString ? symbolToString.call(o) : "";
  var i = o + "";
  return i == "0" && 1 / o == -1 / 0 ? "-0" : i;
}
var reWhitespace = /\s/;
function trimmedEndIndex(o) {
  for (var i = o.length; i-- && reWhitespace.test(o.charAt(i)); )
    ;
  return i;
}
var reTrimStart = /^\s+/;
function baseTrim(o) {
  return o && o.slice(0, trimmedEndIndex(o) + 1).replace(reTrimStart, "");
}
function isObject$3(o) {
  var i = typeof o;
  return o != null && (i == "object" || i == "function");
}
var NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber(o) {
  if (typeof o == "number")
    return o;
  if (isSymbol(o))
    return NAN;
  if (isObject$3(o)) {
    var i = typeof o.valueOf == "function" ? o.valueOf() : o;
    o = isObject$3(i) ? i + "" : i;
  }
  if (typeof o != "string")
    return o === 0 ? o : +o;
  o = baseTrim(o);
  var g = reIsBinary.test(o);
  return g || reIsOctal.test(o) ? freeParseInt(o.slice(2), g ? 2 : 8) : reIsBadHex.test(o) ? NAN : +o;
}
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite(o) {
  if (!o)
    return o === 0 ? o : 0;
  if (o = toNumber(o), o === INFINITY || o === -INFINITY) {
    var i = o < 0 ? -1 : 1;
    return i * MAX_INTEGER;
  }
  return o === o ? o : 0;
}
function toInteger(o) {
  var i = toFinite(o), g = i % 1;
  return i === i ? g ? i - g : i : 0;
}
function identity(o) {
  return o;
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$4(o) {
  if (!isObject$3(o))
    return !1;
  var i = baseGetTag(o);
  return i == funcTag$2 || i == genTag$1 || i == asyncTag || i == proxyTag;
}
var coreJsData = root$4["__core-js_shared__"], maskSrcKey = (function() {
  var o = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return o ? "Symbol(src)_1." + o : "";
})();
function isMasked(o) {
  return !!maskSrcKey && maskSrcKey in o;
}
var funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource(o) {
  if (o != null) {
    try {
      return funcToString$2.call(o);
    } catch {
    }
    try {
      return o + "";
    } catch {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$f = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$e = objectProto$f.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$e).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(o) {
  if (!isObject$3(o) || isMasked(o))
    return !1;
  var i = isFunction$4(o) ? reIsNative : reIsHostCtor;
  return i.test(toSource(o));
}
function getValue$1(o, i) {
  return o?.[i];
}
function getNative(o, i) {
  var g = getValue$1(o, i);
  return baseIsNative(g) ? g : void 0;
}
var WeakMap$1 = getNative(root$4, "WeakMap"), objectCreate = Object.create, baseCreate = /* @__PURE__ */ (function() {
  function o() {
  }
  return function(i) {
    if (!isObject$3(i))
      return {};
    if (objectCreate)
      return objectCreate(i);
    o.prototype = i;
    var g = new o();
    return o.prototype = void 0, g;
  };
})();
function apply(o, i, g) {
  switch (g.length) {
    case 0:
      return o.call(i);
    case 1:
      return o.call(i, g[0]);
    case 2:
      return o.call(i, g[0], g[1]);
    case 3:
      return o.call(i, g[0], g[1], g[2]);
  }
  return o.apply(i, g);
}
function copyArray(o, i) {
  var g = -1, E = o.length;
  for (i || (i = Array(E)); ++g < E; )
    i[g] = o[g];
  return i;
}
var HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut(o) {
  var i = 0, g = 0;
  return function() {
    var E = nativeNow(), e = HOT_SPAN - (E - g);
    if (g = E, e > 0) {
      if (++i >= HOT_COUNT)
        return arguments[0];
    } else
      i = 0;
    return o.apply(void 0, arguments);
  };
}
function constant(o) {
  return function() {
    return o;
  };
}
var defineProperty$1 = (function() {
  try {
    var o = getNative(Object, "defineProperty");
    return o({}, "", {}), o;
  } catch {
  }
})(), baseSetToString = defineProperty$1 ? function(o, i) {
  return defineProperty$1(o, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(i),
    writable: !0
  });
} : identity, setToString = shortOut(baseSetToString);
function arrayEach(o, i) {
  for (var g = -1, E = o == null ? 0 : o.length; ++g < E && i(o[g], g, o) !== !1; )
    ;
  return o;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(o, i) {
  var g = typeof o;
  return i = i ?? MAX_SAFE_INTEGER$1, !!i && (g == "number" || g != "symbol" && reIsUint.test(o)) && o > -1 && o % 1 == 0 && o < i;
}
function baseAssignValue(o, i, g) {
  i == "__proto__" && defineProperty$1 ? defineProperty$1(o, i, {
    configurable: !0,
    enumerable: !0,
    value: g,
    writable: !0
  }) : o[i] = g;
}
function eq(o, i) {
  return o === i || o !== o && i !== i;
}
var objectProto$e = Object.prototype, hasOwnProperty$d = objectProto$e.hasOwnProperty;
function assignValue(o, i, g) {
  var E = o[i];
  (!(hasOwnProperty$d.call(o, i) && eq(E, g)) || g === void 0 && !(i in o)) && baseAssignValue(o, i, g);
}
function copyObject(o, i, g, E) {
  var e = !g;
  g || (g = {});
  for (var t = -1, n = i.length; ++t < n; ) {
    var h = i[t], d = void 0;
    d === void 0 && (d = o[h]), e ? baseAssignValue(g, h, d) : assignValue(g, h, d);
  }
  return g;
}
var nativeMax$2 = Math.max;
function overRest(o, i, g) {
  return i = nativeMax$2(i === void 0 ? o.length - 1 : i, 0), function() {
    for (var E = arguments, e = -1, t = nativeMax$2(E.length - i, 0), n = Array(t); ++e < t; )
      n[e] = E[i + e];
    e = -1;
    for (var h = Array(i + 1); ++e < i; )
      h[e] = E[e];
    return h[i] = g(n), apply(o, this, h);
  };
}
function baseRest(o, i) {
  return setToString(overRest(o, i, identity), o + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(o) {
  return typeof o == "number" && o > -1 && o % 1 == 0 && o <= MAX_SAFE_INTEGER;
}
function isArrayLike(o) {
  return o != null && isLength(o.length) && !isFunction$4(o);
}
function isIterateeCall(o, i, g) {
  if (!isObject$3(g))
    return !1;
  var E = typeof i;
  return (E == "number" ? isArrayLike(g) && isIndex(i, g.length) : E == "string" && i in g) ? eq(g[i], o) : !1;
}
function createAssigner(o) {
  return baseRest(function(i, g) {
    var E = -1, e = g.length, t = e > 1 ? g[e - 1] : void 0, n = e > 2 ? g[2] : void 0;
    for (t = o.length > 3 && typeof t == "function" ? (e--, t) : void 0, n && isIterateeCall(g[0], g[1], n) && (t = e < 3 ? void 0 : t, e = 1), i = Object(i); ++E < e; ) {
      var h = g[E];
      h && o(i, h, E, t);
    }
    return i;
  });
}
var objectProto$d = Object.prototype;
function isPrototype(o) {
  var i = o && o.constructor, g = typeof i == "function" && i.prototype || objectProto$d;
  return o === g;
}
function baseTimes(o, i) {
  for (var g = -1, E = Array(o); ++g < o; )
    E[g] = i(g);
  return E;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(o) {
  return isObjectLike(o) && baseGetTag(o) == argsTag$3;
}
var objectProto$c = Object.prototype, hasOwnProperty$c = objectProto$c.hasOwnProperty, propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable, isArguments = baseIsArguments(/* @__PURE__ */ (function() {
  return arguments;
})()) ? baseIsArguments : function(o) {
  return isObjectLike(o) && hasOwnProperty$c.call(o, "callee") && !propertyIsEnumerable$1.call(o, "callee");
};
function stubFalse() {
  return !1;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$3 = moduleExports$2 ? root$4.Buffer : void 0, nativeIsBuffer = Buffer$3 ? Buffer$3.isBuffer : void 0, isBuffer = nativeIsBuffer || stubFalse, argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = !0;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = !1;
function baseIsTypedArray(o) {
  return isObjectLike(o) && isLength(o.length) && !!typedArrayTags[baseGetTag(o)];
}
function baseUnary(o) {
  return function(i) {
    return o(i);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, freeProcess = moduleExports$1 && freeGlobal.process, nodeUtil = (function() {
  try {
    var o = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    return o || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
})(), nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, objectProto$b = Object.prototype, hasOwnProperty$b = objectProto$b.hasOwnProperty;
function arrayLikeKeys(o, i) {
  var g = isArray$1(o), E = !g && isArguments(o), e = !g && !E && isBuffer(o), t = !g && !E && !e && isTypedArray(o), n = g || E || e || t, h = n ? baseTimes(o.length, String) : [], d = h.length;
  for (var k in o)
    (i || hasOwnProperty$b.call(o, k)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (k == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    e && (k == "offset" || k == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    t && (k == "buffer" || k == "byteLength" || k == "byteOffset") || // Skip index properties.
    isIndex(k, d))) && h.push(k);
  return h;
}
function overArg(o, i) {
  return function(g) {
    return o(i(g));
  };
}
var nativeKeys = overArg(Object.keys, Object), objectProto$a = Object.prototype, hasOwnProperty$a = objectProto$a.hasOwnProperty;
function baseKeys(o) {
  if (!isPrototype(o))
    return nativeKeys(o);
  var i = [];
  for (var g in Object(o))
    hasOwnProperty$a.call(o, g) && g != "constructor" && i.push(g);
  return i;
}
function keys$1(o) {
  return isArrayLike(o) ? arrayLikeKeys(o) : baseKeys(o);
}
function nativeKeysIn(o) {
  var i = [];
  if (o != null)
    for (var g in Object(o))
      i.push(g);
  return i;
}
var objectProto$9 = Object.prototype, hasOwnProperty$9 = objectProto$9.hasOwnProperty;
function baseKeysIn(o) {
  if (!isObject$3(o))
    return nativeKeysIn(o);
  var i = isPrototype(o), g = [];
  for (var E in o)
    E == "constructor" && (i || !hasOwnProperty$9.call(o, E)) || g.push(E);
  return g;
}
function keysIn(o) {
  return isArrayLike(o) ? arrayLikeKeys(o, !0) : baseKeysIn(o);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(o, i) {
  if (isArray$1(o))
    return !1;
  var g = typeof o;
  return g == "number" || g == "symbol" || g == "boolean" || o == null || isSymbol(o) ? !0 : reIsPlainProp.test(o) || !reIsDeepProp.test(o) || i != null && o in Object(i);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}
function hashDelete(o) {
  var i = this.has(o) && delete this.__data__[o];
  return this.size -= i ? 1 : 0, i;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$8 = Object.prototype, hasOwnProperty$8 = objectProto$8.hasOwnProperty;
function hashGet(o) {
  var i = this.__data__;
  if (nativeCreate) {
    var g = i[o];
    return g === HASH_UNDEFINED$2 ? void 0 : g;
  }
  return hasOwnProperty$8.call(i, o) ? i[o] : void 0;
}
var objectProto$7 = Object.prototype, hasOwnProperty$7 = objectProto$7.hasOwnProperty;
function hashHas(o) {
  var i = this.__data__;
  return nativeCreate ? i[o] !== void 0 : hasOwnProperty$7.call(i, o);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(o, i) {
  var g = this.__data__;
  return this.size += this.has(o) ? 0 : 1, g[o] = nativeCreate && i === void 0 ? HASH_UNDEFINED$1 : i, this;
}
function Hash(o) {
  var i = -1, g = o == null ? 0 : o.length;
  for (this.clear(); ++i < g; ) {
    var E = o[i];
    this.set(E[0], E[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
function assocIndexOf(o, i) {
  for (var g = o.length; g--; )
    if (eq(o[g][0], i))
      return g;
  return -1;
}
var arrayProto = Array.prototype, splice$1 = arrayProto.splice;
function listCacheDelete(o) {
  var i = this.__data__, g = assocIndexOf(i, o);
  if (g < 0)
    return !1;
  var E = i.length - 1;
  return g == E ? i.pop() : splice$1.call(i, g, 1), --this.size, !0;
}
function listCacheGet(o) {
  var i = this.__data__, g = assocIndexOf(i, o);
  return g < 0 ? void 0 : i[g][1];
}
function listCacheHas(o) {
  return assocIndexOf(this.__data__, o) > -1;
}
function listCacheSet(o, i) {
  var g = this.__data__, E = assocIndexOf(g, o);
  return E < 0 ? (++this.size, g.push([o, i])) : g[E][1] = i, this;
}
function ListCache(o) {
  var i = -1, g = o == null ? 0 : o.length;
  for (this.clear(); ++i < g; ) {
    var E = o[i];
    this.set(E[0], E[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$2 = getNative(root$4, "Map");
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$2 || ListCache)(),
    string: new Hash()
  };
}
function isKeyable(o) {
  var i = typeof o;
  return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? o !== "__proto__" : o === null;
}
function getMapData(o, i) {
  var g = o.__data__;
  return isKeyable(i) ? g[typeof i == "string" ? "string" : "hash"] : g.map;
}
function mapCacheDelete(o) {
  var i = getMapData(this, o).delete(o);
  return this.size -= i ? 1 : 0, i;
}
function mapCacheGet(o) {
  return getMapData(this, o).get(o);
}
function mapCacheHas(o) {
  return getMapData(this, o).has(o);
}
function mapCacheSet(o, i) {
  var g = getMapData(this, o), E = g.size;
  return g.set(o, i), this.size += g.size == E ? 0 : 1, this;
}
function MapCache(o) {
  var i = -1, g = o == null ? 0 : o.length;
  for (this.clear(); ++i < g; ) {
    var E = o[i];
    this.set(E[0], E[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize(o, i) {
  if (typeof o != "function" || i != null && typeof i != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  var g = function() {
    var E = arguments, e = i ? i.apply(this, E) : E[0], t = g.cache;
    if (t.has(e))
      return t.get(e);
    var n = o.apply(this, E);
    return g.cache = t.set(e, n) || t, n;
  };
  return g.cache = new (memoize.Cache || MapCache)(), g;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(o) {
  var i = memoize(o, function(E) {
    return g.size === MAX_MEMOIZE_SIZE && g.clear(), E;
  }), g = i.cache;
  return i;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(o) {
  var i = [];
  return o.charCodeAt(0) === 46 && i.push(""), o.replace(rePropName, function(g, E, e, t) {
    i.push(e ? t.replace(reEscapeChar, "$1") : E || g);
  }), i;
});
function toString$3(o) {
  return o == null ? "" : baseToString(o);
}
function castPath(o, i) {
  return isArray$1(o) ? o : isKey(o, i) ? [o] : stringToPath(toString$3(o));
}
function toKey(o) {
  if (typeof o == "string" || isSymbol(o))
    return o;
  var i = o + "";
  return i == "0" && 1 / o == -1 / 0 ? "-0" : i;
}
function baseGet(o, i) {
  i = castPath(i, o);
  for (var g = 0, E = i.length; o != null && g < E; )
    o = o[toKey(i[g++])];
  return g && g == E ? o : void 0;
}
function get$1(o, i, g) {
  var E = o == null ? void 0 : baseGet(o, i);
  return E === void 0 ? g : E;
}
function arrayPush(o, i) {
  for (var g = -1, E = i.length, e = o.length; ++g < E; )
    o[e + g] = i[g];
  return o;
}
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable(o) {
  return isArray$1(o) || isArguments(o) || !!(spreadableSymbol && o && o[spreadableSymbol]);
}
function baseFlatten(o, i, g, E, e) {
  var t = -1, n = o.length;
  for (g || (g = isFlattenable), e || (e = []); ++t < n; ) {
    var h = o[t];
    g(h) ? arrayPush(e, h) : e[e.length] = h;
  }
  return e;
}
function flatten(o) {
  var i = o == null ? 0 : o.length;
  return i ? baseFlatten(o) : [];
}
function flatRest(o) {
  return setToString(overRest(o, void 0, flatten), o + "");
}
var getPrototype = overArg(Object.getPrototypeOf, Object), objectTag$3 = "[object Object]", funcProto = Function.prototype, objectProto$6 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$6 = objectProto$6.hasOwnProperty, objectCtorString$1 = funcToString.call(Object);
function isPlainObject$3(o) {
  if (!isObjectLike(o) || baseGetTag(o) != objectTag$3)
    return !1;
  var i = getPrototype(o);
  if (i === null)
    return !0;
  var g = hasOwnProperty$6.call(i, "constructor") && i.constructor;
  return typeof g == "function" && g instanceof g && funcToString.call(g) == objectCtorString$1;
}
var FUNC_ERROR_TEXT = "Expected a function";
function before(o, i) {
  var g;
  if (typeof i != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return o = toInteger(o), function() {
    return --o > 0 && (g = i.apply(this, arguments)), o <= 1 && (i = void 0), g;
  };
}
function baseSlice(o, i, g) {
  var E = -1, e = o.length;
  i < 0 && (i = -i > e ? 0 : e + i), g = g > e ? e : g, g < 0 && (g += e), e = i > g ? 0 : g - i >>> 0, i >>>= 0;
  for (var t = Array(e); ++E < e; )
    t[E] = o[E + i];
  return t;
}
function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}
function stackDelete(o) {
  var i = this.__data__, g = i.delete(o);
  return this.size = i.size, g;
}
function stackGet(o) {
  return this.__data__.get(o);
}
function stackHas(o) {
  return this.__data__.has(o);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(o, i) {
  var g = this.__data__;
  if (g instanceof ListCache) {
    var E = g.__data__;
    if (!Map$2 || E.length < LARGE_ARRAY_SIZE - 1)
      return E.push([o, i]), this.size = ++g.size, this;
    g = this.__data__ = new MapCache(E);
  }
  return g.set(o, i), this.size = g.size, this;
}
function Stack(o) {
  var i = this.__data__ = new ListCache(o);
  this.size = i.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function baseAssign(o, i) {
  return o && copyObject(i, keys$1(i), o);
}
function baseAssignIn(o, i) {
  return o && copyObject(i, keysIn(i), o);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer$2 = moduleExports ? root$4.Buffer : void 0, allocUnsafe = Buffer$2 ? Buffer$2.allocUnsafe : void 0;
function cloneBuffer(o, i) {
  if (i)
    return o.slice();
  var g = o.length, E = allocUnsafe ? allocUnsafe(g) : new o.constructor(g);
  return o.copy(E), E;
}
function arrayFilter(o, i) {
  for (var g = -1, E = o == null ? 0 : o.length, e = 0, t = []; ++g < E; ) {
    var n = o[g];
    i(n, g, o) && (t[e++] = n);
  }
  return t;
}
function stubArray() {
  return [];
}
var objectProto$5 = Object.prototype, propertyIsEnumerable = objectProto$5.propertyIsEnumerable, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols$1 ? function(o) {
  return o == null ? [] : (o = Object(o), arrayFilter(nativeGetSymbols$1(o), function(i) {
    return propertyIsEnumerable.call(o, i);
  }));
} : stubArray;
function copySymbols(o, i) {
  return copyObject(o, getSymbols(o), i);
}
var nativeGetSymbols = Object.getOwnPropertySymbols, getSymbolsIn = nativeGetSymbols ? function(o) {
  for (var i = []; o; )
    arrayPush(i, getSymbols(o)), o = getPrototype(o);
  return i;
} : stubArray;
function copySymbolsIn(o, i) {
  return copyObject(o, getSymbolsIn(o), i);
}
function baseGetAllKeys(o, i, g) {
  var E = i(o);
  return isArray$1(o) ? E : arrayPush(E, g(o));
}
function getAllKeys(o) {
  return baseGetAllKeys(o, keys$1, getSymbols);
}
function getAllKeysIn(o) {
  return baseGetAllKeys(o, keysIn, getSymbolsIn);
}
var DataView$1 = getNative(root$4, "DataView"), Promise$1 = getNative(root$4, "Promise"), Set$1 = getNative(root$4, "Set"), mapTag$4 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$4 = "[object Set]", weakMapTag$1 = "[object WeakMap]", dataViewTag$3 = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag = baseGetTag;
(DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3 || Map$2 && getTag(new Map$2()) != mapTag$4 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$4 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) && (getTag = function(o) {
  var i = baseGetTag(o), g = i == objectTag$2 ? o.constructor : void 0, E = g ? toSource(g) : "";
  if (E)
    switch (E) {
      case dataViewCtorString:
        return dataViewTag$3;
      case mapCtorString:
        return mapTag$4;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag$4;
      case weakMapCtorString:
        return weakMapTag$1;
    }
  return i;
});
var objectProto$4 = Object.prototype, hasOwnProperty$5 = objectProto$4.hasOwnProperty;
function initCloneArray(o) {
  var i = o.length, g = new o.constructor(i);
  return i && typeof o[0] == "string" && hasOwnProperty$5.call(o, "index") && (g.index = o.index, g.input = o.input), g;
}
var Uint8Array$1 = root$4.Uint8Array;
function cloneArrayBuffer(o) {
  var i = new o.constructor(o.byteLength);
  return new Uint8Array$1(i).set(new Uint8Array$1(o)), i;
}
function cloneDataView(o, i) {
  var g = i ? cloneArrayBuffer(o.buffer) : o.buffer;
  return new o.constructor(g, o.byteOffset, o.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(o) {
  var i = new o.constructor(o.source, reFlags.exec(o));
  return i.lastIndex = o.lastIndex, i;
}
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(o) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(o)) : {};
}
function cloneTypedArray(o, i) {
  var g = i ? cloneArrayBuffer(o.buffer) : o.buffer;
  return new o.constructor(g, o.byteOffset, o.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(o, i, g) {
  var E = o.constructor;
  switch (i) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(o);
    case boolTag$2:
    case dateTag$2:
      return new E(+o);
    case dataViewTag$2:
      return cloneDataView(o, g);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(o, g);
    case mapTag$3:
      return new E();
    case numberTag$2:
    case stringTag$2:
      return new E(o);
    case regexpTag$2:
      return cloneRegExp(o);
    case setTag$3:
      return new E();
    case symbolTag$2:
      return cloneSymbol(o);
  }
}
function initCloneObject(o) {
  return typeof o.constructor == "function" && !isPrototype(o) ? baseCreate(getPrototype(o)) : {};
}
var mapTag$2 = "[object Map]";
function baseIsMap(o) {
  return isObjectLike(o) && getTag(o) == mapTag$2;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap, isMap$1 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap, setTag$2 = "[object Set]";
function baseIsSet(o) {
  return isObjectLike(o) && getTag(o) == setTag$2;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet, isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet, CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$2 = 4, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]", weakMapTag = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = !0;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = !1;
function baseClone(o, i, g, E, e, t) {
  var n, h = i & CLONE_DEEP_FLAG$2, d = i & CLONE_FLAT_FLAG$1, k = i & CLONE_SYMBOLS_FLAG$2;
  if (g && (n = e ? g(o, E, e, t) : g(o)), n !== void 0)
    return n;
  if (!isObject$3(o))
    return o;
  var p = isArray$1(o);
  if (p) {
    if (n = initCloneArray(o), !h)
      return copyArray(o, n);
  } else {
    var M = getTag(o), H = M == funcTag || M == genTag;
    if (isBuffer(o))
      return cloneBuffer(o, h);
    if (M == objectTag$1 || M == argsTag$1 || H && !e) {
      if (n = d || H ? {} : initCloneObject(o), !h)
        return d ? copySymbolsIn(o, baseAssignIn(n, o)) : copySymbols(o, baseAssign(n, o));
    } else {
      if (!cloneableTags[M])
        return e ? o : {};
      n = initCloneByTag(o, M, h);
    }
  }
  t || (t = new Stack());
  var f = t.get(o);
  if (f)
    return f;
  t.set(o, n), isSet$1(o) ? o.forEach(function(IA) {
    n.add(baseClone(IA, i, g, IA, o, t));
  }) : isMap$1(o) && o.forEach(function(IA, BA) {
    n.set(BA, baseClone(IA, i, g, BA, o, t));
  });
  var AA = k ? d ? getAllKeysIn : getAllKeys : d ? keysIn : keys$1, gA = p ? void 0 : AA(o);
  return arrayEach(gA || o, function(IA, BA) {
    gA && (BA = IA, IA = o[BA]), assignValue(n, BA, baseClone(IA, i, g, BA, o, t));
  }), n;
}
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(o) {
  return baseClone(o, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(o) {
  return this.__data__.set(o, HASH_UNDEFINED), this;
}
function setCacheHas(o) {
  return this.__data__.has(o);
}
function SetCache(o) {
  var i = -1, g = o == null ? 0 : o.length;
  for (this.__data__ = new MapCache(); ++i < g; )
    this.add(o[i]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(o, i) {
  for (var g = -1, E = o == null ? 0 : o.length; ++g < E; )
    if (i(o[g], g, o))
      return !0;
  return !1;
}
function cacheHas(o, i) {
  return o.has(i);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(o, i, g, E, e, t) {
  var n = g & COMPARE_PARTIAL_FLAG$5, h = o.length, d = i.length;
  if (h != d && !(n && d > h))
    return !1;
  var k = t.get(o), p = t.get(i);
  if (k && p)
    return k == i && p == o;
  var M = -1, H = !0, f = g & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (t.set(o, i), t.set(i, o); ++M < h; ) {
    var AA = o[M], gA = i[M];
    if (E)
      var IA = n ? E(gA, AA, M, i, o, t) : E(AA, gA, M, o, i, t);
    if (IA !== void 0) {
      if (IA)
        continue;
      H = !1;
      break;
    }
    if (f) {
      if (!arraySome(i, function(BA, CA) {
        if (!cacheHas(f, CA) && (AA === BA || e(AA, BA, g, E, t)))
          return f.push(CA);
      })) {
        H = !1;
        break;
      }
    } else if (!(AA === gA || e(AA, gA, g, E, t))) {
      H = !1;
      break;
    }
  }
  return t.delete(o), t.delete(i), H;
}
function mapToArray(o) {
  var i = -1, g = Array(o.size);
  return o.forEach(function(E, e) {
    g[++i] = [e, E];
  }), g;
}
function setToArray(o) {
  var i = -1, g = Array(o.size);
  return o.forEach(function(E) {
    g[++i] = E;
  }), g;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(o, i, g, E, e, t, n) {
  switch (g) {
    case dataViewTag:
      if (o.byteLength != i.byteLength || o.byteOffset != i.byteOffset)
        return !1;
      o = o.buffer, i = i.buffer;
    case arrayBufferTag:
      return !(o.byteLength != i.byteLength || !t(new Uint8Array$1(o), new Uint8Array$1(i)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+o, +i);
    case errorTag:
      return o.name == i.name && o.message == i.message;
    case regexpTag:
    case stringTag:
      return o == i + "";
    case mapTag:
      var h = mapToArray;
    case setTag:
      var d = E & COMPARE_PARTIAL_FLAG$4;
      if (h || (h = setToArray), o.size != i.size && !d)
        return !1;
      var k = n.get(o);
      if (k)
        return k == i;
      E |= COMPARE_UNORDERED_FLAG$2, n.set(o, i);
      var p = equalArrays(h(o), h(i), E, e, t, n);
      return n.delete(o), p;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(o) == symbolValueOf.call(i);
  }
  return !1;
}
var COMPARE_PARTIAL_FLAG$3 = 1, objectProto$3 = Object.prototype, hasOwnProperty$4 = objectProto$3.hasOwnProperty;
function equalObjects(o, i, g, E, e, t) {
  var n = g & COMPARE_PARTIAL_FLAG$3, h = getAllKeys(o), d = h.length, k = getAllKeys(i), p = k.length;
  if (d != p && !n)
    return !1;
  for (var M = d; M--; ) {
    var H = h[M];
    if (!(n ? H in i : hasOwnProperty$4.call(i, H)))
      return !1;
  }
  var f = t.get(o), AA = t.get(i);
  if (f && AA)
    return f == i && AA == o;
  var gA = !0;
  t.set(o, i), t.set(i, o);
  for (var IA = n; ++M < d; ) {
    H = h[M];
    var BA = o[H], CA = i[H];
    if (E)
      var QA = n ? E(CA, BA, H, i, o, t) : E(BA, CA, H, o, i, t);
    if (!(QA === void 0 ? BA === CA || e(BA, CA, g, E, t) : QA)) {
      gA = !1;
      break;
    }
    IA || (IA = H == "constructor");
  }
  if (gA && !IA) {
    var iA = o.constructor, EA = i.constructor;
    iA != EA && "constructor" in o && "constructor" in i && !(typeof iA == "function" && iA instanceof iA && typeof EA == "function" && EA instanceof EA) && (gA = !1);
  }
  return t.delete(o), t.delete(i), gA;
}
var COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto$2 = Object.prototype, hasOwnProperty$3 = objectProto$2.hasOwnProperty;
function baseIsEqualDeep(o, i, g, E, e, t) {
  var n = isArray$1(o), h = isArray$1(i), d = n ? arrayTag : getTag(o), k = h ? arrayTag : getTag(i);
  d = d == argsTag ? objectTag : d, k = k == argsTag ? objectTag : k;
  var p = d == objectTag, M = k == objectTag, H = d == k;
  if (H && isBuffer(o)) {
    if (!isBuffer(i))
      return !1;
    n = !0, p = !1;
  }
  if (H && !p)
    return t || (t = new Stack()), n || isTypedArray(o) ? equalArrays(o, i, g, E, e, t) : equalByTag(o, i, d, g, E, e, t);
  if (!(g & COMPARE_PARTIAL_FLAG$2)) {
    var f = p && hasOwnProperty$3.call(o, "__wrapped__"), AA = M && hasOwnProperty$3.call(i, "__wrapped__");
    if (f || AA) {
      var gA = f ? o.value() : o, IA = AA ? i.value() : i;
      return t || (t = new Stack()), e(gA, IA, g, E, t);
    }
  }
  return H ? (t || (t = new Stack()), equalObjects(o, i, g, E, e, t)) : !1;
}
function baseIsEqual(o, i, g, E, e) {
  return o === i ? !0 : o == null || i == null || !isObjectLike(o) && !isObjectLike(i) ? o !== o && i !== i : baseIsEqualDeep(o, i, g, E, baseIsEqual, e);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(o, i, g, E) {
  var e = g.length, t = e;
  if (o == null)
    return !t;
  for (o = Object(o); e--; ) {
    var n = g[e];
    if (n[2] ? n[1] !== o[n[0]] : !(n[0] in o))
      return !1;
  }
  for (; ++e < t; ) {
    n = g[e];
    var h = n[0], d = o[h], k = n[1];
    if (n[2]) {
      if (d === void 0 && !(h in o))
        return !1;
    } else {
      var p = new Stack(), M;
      if (!(M === void 0 ? baseIsEqual(k, d, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, E, p) : M))
        return !1;
    }
  }
  return !0;
}
function isStrictComparable(o) {
  return o === o && !isObject$3(o);
}
function getMatchData(o) {
  for (var i = keys$1(o), g = i.length; g--; ) {
    var E = i[g], e = o[E];
    i[g] = [E, e, isStrictComparable(e)];
  }
  return i;
}
function matchesStrictComparable(o, i) {
  return function(g) {
    return g == null ? !1 : g[o] === i && (i !== void 0 || o in Object(g));
  };
}
function baseMatches(o) {
  var i = getMatchData(o);
  return i.length == 1 && i[0][2] ? matchesStrictComparable(i[0][0], i[0][1]) : function(g) {
    return g === o || baseIsMatch(g, o, i);
  };
}
function baseHasIn(o, i) {
  return o != null && i in Object(o);
}
function hasPath(o, i, g) {
  i = castPath(i, o);
  for (var E = -1, e = i.length, t = !1; ++E < e; ) {
    var n = toKey(i[E]);
    if (!(t = o != null && g(o, n)))
      break;
    o = o[n];
  }
  return t || ++E != e ? t : (e = o == null ? 0 : o.length, !!e && isLength(e) && isIndex(n, e) && (isArray$1(o) || isArguments(o)));
}
function hasIn(o, i) {
  return o != null && hasPath(o, i, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(o, i) {
  return isKey(o) && isStrictComparable(i) ? matchesStrictComparable(toKey(o), i) : function(g) {
    var E = get$1(g, o);
    return E === void 0 && E === i ? hasIn(g, o) : baseIsEqual(i, E, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(o) {
  return function(i) {
    return i?.[o];
  };
}
function basePropertyDeep(o) {
  return function(i) {
    return baseGet(i, o);
  };
}
function property(o) {
  return isKey(o) ? baseProperty(toKey(o)) : basePropertyDeep(o);
}
function baseIteratee(o) {
  return typeof o == "function" ? o : o == null ? identity : typeof o == "object" ? isArray$1(o) ? baseMatchesProperty(o[0], o[1]) : baseMatches(o) : property(o);
}
function arrayAggregator(o, i, g, E) {
  for (var e = -1, t = o == null ? 0 : o.length; ++e < t; ) {
    var n = o[e];
    i(E, n, g(n), o);
  }
  return E;
}
function createBaseFor(o) {
  return function(i, g, E) {
    for (var e = -1, t = Object(i), n = E(i), h = n.length; h--; ) {
      var d = n[++e];
      if (g(t[d], d, t) === !1)
        break;
    }
    return i;
  };
}
var baseFor = createBaseFor();
function baseForOwn(o, i) {
  return o && baseFor(o, i, keys$1);
}
function createBaseEach(o, i) {
  return function(g, E) {
    if (g == null)
      return g;
    if (!isArrayLike(g))
      return o(g, E);
    for (var e = g.length, t = -1, n = Object(g); ++t < e && E(n[t], t, n) !== !1; )
      ;
    return g;
  };
}
var baseEach = createBaseEach(baseForOwn);
function baseAggregator(o, i, g, E) {
  return baseEach(o, function(e, t, n) {
    i(E, e, g(e), n);
  }), E;
}
function createAggregator(o, i) {
  return function(g, E) {
    var e = isArray$1(g) ? arrayAggregator : baseAggregator, t = i ? i() : {};
    return e(g, o, baseIteratee(E), t);
  };
}
function assignMergeValue(o, i, g) {
  (g !== void 0 && !eq(o[i], g) || g === void 0 && !(i in o)) && baseAssignValue(o, i, g);
}
function isArrayLikeObject(o) {
  return isObjectLike(o) && isArrayLike(o);
}
function safeGet(o, i) {
  if (!(i === "constructor" && typeof o[i] == "function") && i != "__proto__")
    return o[i];
}
function toPlainObject(o) {
  return copyObject(o, keysIn(o));
}
function baseMergeDeep(o, i, g, E, e, t, n) {
  var h = safeGet(o, g), d = safeGet(i, g), k = n.get(d);
  if (k) {
    assignMergeValue(o, g, k);
    return;
  }
  var p = t ? t(h, d, g + "", o, i, n) : void 0, M = p === void 0;
  if (M) {
    var H = isArray$1(d), f = !H && isBuffer(d), AA = !H && !f && isTypedArray(d);
    p = d, H || f || AA ? isArray$1(h) ? p = h : isArrayLikeObject(h) ? p = copyArray(h) : f ? (M = !1, p = cloneBuffer(d, !0)) : AA ? (M = !1, p = cloneTypedArray(d, !0)) : p = [] : isPlainObject$3(d) || isArguments(d) ? (p = h, isArguments(h) ? p = toPlainObject(h) : (!isObject$3(h) || isFunction$4(h)) && (p = initCloneObject(d))) : M = !1;
  }
  M && (n.set(d, p), e(p, d, E, t, n), n.delete(d)), assignMergeValue(o, g, p);
}
function baseMerge(o, i, g, E, e) {
  o !== i && baseFor(i, function(t, n) {
    if (e || (e = new Stack()), isObject$3(t))
      baseMergeDeep(o, i, n, g, baseMerge, E, e);
    else {
      var h = E ? E(safeGet(o, n), t, n + "", o, i, e) : void 0;
      h === void 0 && (h = t), assignMergeValue(o, n, h);
    }
  }, keysIn);
}
var mergeWith = createAssigner(function(o, i, g, E) {
  baseMerge(o, i, g, E);
});
function last(o) {
  var i = o == null ? 0 : o.length;
  return i ? o[i - 1] : void 0;
}
function baseMap(o, i) {
  var g = -1, E = isArrayLike(o) ? Array(o.length) : [];
  return baseEach(o, function(e, t, n) {
    E[++g] = i(e, t, n);
  }), E;
}
var objectProto$1 = Object.prototype, hasOwnProperty$2 = objectProto$1.hasOwnProperty, groupBy = createAggregator(function(o, i, g) {
  hasOwnProperty$2.call(o, g) ? o[g].push(i) : baseAssignValue(o, g, [i]);
});
function parent(o, i) {
  return i.length < 2 ? o : baseGet(o, baseSlice(i, 0, -1));
}
function isEqual$1(o, i) {
  return baseIsEqual(o, i);
}
var merge$1 = createAssigner(function(o, i, g) {
  baseMerge(o, i, g);
}), objectProto = Object.prototype, hasOwnProperty$1 = objectProto.hasOwnProperty;
function baseUnset(o, i) {
  i = castPath(i, o);
  var g = -1, E = i.length;
  if (!E)
    return !0;
  for (; ++g < E; ) {
    var e = toKey(i[g]);
    if (e === "__proto__" && !hasOwnProperty$1.call(o, "__proto__") || (e === "constructor" || e === "prototype") && g < E - 1)
      return !1;
  }
  var t = parent(o, i);
  return t == null || delete t[toKey(last(i))];
}
function customOmitClone(o) {
  return isPlainObject$3(o) ? void 0 : o;
}
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4, omit = flatRest(function(o, i) {
  var g = {};
  if (o == null)
    return g;
  var E = !1;
  i = arrayMap(i, function(t) {
    return t = castPath(t, o), E || (E = t.length > 1), t;
  }), copyObject(o, getAllKeysIn(o), g), E && (g = baseClone(g, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone));
  for (var e = i.length; e--; )
    baseUnset(g, i[e]);
  return g;
});
function baseSet(o, i, g, E) {
  if (!isObject$3(o))
    return o;
  i = castPath(i, o);
  for (var e = -1, t = i.length, n = t - 1, h = o; h != null && ++e < t; ) {
    var d = toKey(i[e]), k = g;
    if (d === "__proto__" || d === "constructor" || d === "prototype")
      return o;
    if (e != n) {
      var p = h[d];
      k = void 0, k === void 0 && (k = isObject$3(p) ? p : isIndex(i[e + 1]) ? [] : {});
    }
    assignValue(h, d, k), h = h[d];
  }
  return o;
}
function basePickBy(o, i, g) {
  for (var E = -1, e = i.length, t = {}; ++E < e; ) {
    var n = i[E], h = baseGet(o, n);
    g(h, n) && baseSet(t, castPath(n, o), h);
  }
  return t;
}
function once$1(o) {
  return before(2, o);
}
function baseSortBy(o, i) {
  var g = o.length;
  for (o.sort(i); g--; )
    o[g] = o[g].value;
  return o;
}
function compareAscending(o, i) {
  if (o !== i) {
    var g = o !== void 0, E = o === null, e = o === o, t = isSymbol(o), n = i !== void 0, h = i === null, d = i === i, k = isSymbol(i);
    if (!h && !k && !t && o > i || t && n && d && !h && !k || E && n && d || !g && d || !e)
      return 1;
    if (!E && !t && !k && o < i || k && g && e && !E && !t || h && g && e || !n && e || !d)
      return -1;
  }
  return 0;
}
function compareMultiple(o, i, g) {
  for (var E = -1, e = o.criteria, t = i.criteria, n = e.length, h = g.length; ++E < n; ) {
    var d = compareAscending(e[E], t[E]);
    if (d) {
      if (E >= h)
        return d;
      var k = g[E];
      return d * (k == "desc" ? -1 : 1);
    }
  }
  return o.index - i.index;
}
function baseOrderBy(o, i, g) {
  i.length ? i = arrayMap(i, function(t) {
    return isArray$1(t) ? function(n) {
      return baseGet(n, t.length === 1 ? t[0] : t);
    } : t;
  }) : i = [identity];
  var E = -1;
  i = arrayMap(i, baseUnary(baseIteratee));
  var e = baseMap(o, function(t, n, h) {
    var d = arrayMap(i, function(k) {
      return k(t);
    });
    return { criteria: d, index: ++E, value: t };
  });
  return baseSortBy(e, function(t, n) {
    return compareMultiple(t, n, g);
  });
}
function basePick(o, i) {
  return basePickBy(o, i, function(g, E) {
    return hasIn(o, E);
  });
}
var pick$1 = flatRest(function(o, i) {
  return o == null ? {} : basePick(o, i);
}), nativeCeil = Math.ceil, nativeMax$1 = Math.max;
function baseRange(o, i, g, E) {
  for (var e = -1, t = nativeMax$1(nativeCeil((i - o) / (g || 1)), 0), n = Array(t); t--; )
    n[++e] = o, o += g;
  return n;
}
function createRange(o) {
  return function(i, g, E) {
    return E && typeof E != "number" && isIterateeCall(i, g, E) && (g = E = void 0), i = toFinite(i), g === void 0 ? (g = i, i = 0) : g = toFinite(g), E = E === void 0 ? i < g ? 1 : -1 : toFinite(E), baseRange(i, g, E);
  };
}
var range$1 = createRange(), sortBy = baseRest(function(o, i) {
  if (o == null)
    return [];
  var g = i.length;
  return g > 1 && isIterateeCall(o, i[0], i[1]) ? i = [] : g > 2 && isIterateeCall(i[0], i[1], i[2]) && (i = [i[0]]), baseOrderBy(o, baseFlatten(i), []);
}), nativeMax = Math.max;
function unzip(o) {
  if (!(o && o.length))
    return [];
  var i = 0;
  return o = arrayFilter(o, function(g) {
    if (isArrayLikeObject(g))
      return i = nativeMax(g.length, i), !0;
  }), baseTimes(i, function(g) {
    return arrayMap(o, baseProperty(g));
  });
}
var zip$1 = baseRest(unzip), cuint = {}, uint32$1 = { exports: {} }, uint32 = uint32$1.exports, hasRequiredUint32;
function requireUint32() {
  return hasRequiredUint32 || (hasRequiredUint32 = 1, (function(o) {
    (function(i) {
      g(Math.pow(36, 5)), g(Math.pow(16, 7)), g(Math.pow(10, 9)), g(Math.pow(2, 30)), g(36), g(16), g(10), g(2);
      function g(n, h) {
        if (!(this instanceof g))
          return new g(n, h);
        if (this._low = 0, this._high = 0, this.remainder = null, typeof h > "u")
          return e.call(this, n);
        if (typeof n == "string")
          return t.call(this, n, h);
        E.call(this, n, h);
      }
      function E(n, h) {
        return this._low = n | 0, this._high = h | 0, this;
      }
      g.prototype.fromBits = E;
      function e(n) {
        return this._low = n & 65535, this._high = n >>> 16, this;
      }
      g.prototype.fromNumber = e;
      function t(n, h) {
        var d = parseInt(n, h || 10);
        return this._low = d & 65535, this._high = d >>> 16, this;
      }
      g.prototype.fromString = t, g.prototype.toNumber = function() {
        return this._high * 65536 + this._low;
      }, g.prototype.toString = function(n) {
        return this.toNumber().toString(n || 10);
      }, g.prototype.add = function(n) {
        var h = this._low + n._low, d = h >>> 16;
        return d += this._high + n._high, this._low = h & 65535, this._high = d & 65535, this;
      }, g.prototype.subtract = function(n) {
        return this.add(n.clone().negate());
      }, g.prototype.multiply = function(n) {
        var h = this._high, d = this._low, k = n._high, p = n._low, M, H;
        return H = d * p, M = H >>> 16, M += h * p, M &= 65535, M += d * k, this._low = H & 65535, this._high = M & 65535, this;
      }, g.prototype.div = function(n) {
        if (n._low == 0 && n._high == 0) throw Error("division by zero");
        if (n._high == 0 && n._low == 1)
          return this.remainder = new g(0), this;
        if (n.gt(this))
          return this.remainder = this.clone(), this._low = 0, this._high = 0, this;
        if (this.eq(n))
          return this.remainder = new g(0), this._low = 1, this._high = 0, this;
        for (var h = n.clone(), d = -1; !this.lt(h); )
          h.shiftLeft(1, !0), d++;
        for (this.remainder = this.clone(), this._low = 0, this._high = 0; d >= 0; d--)
          h.shiftRight(1), this.remainder.lt(h) || (this.remainder.subtract(h), d >= 16 ? this._high |= 1 << d - 16 : this._low |= 1 << d);
        return this;
      }, g.prototype.negate = function() {
        var n = (~this._low & 65535) + 1;
        return this._low = n & 65535, this._high = ~this._high + (n >>> 16) & 65535, this;
      }, g.prototype.equals = g.prototype.eq = function(n) {
        return this._low == n._low && this._high == n._high;
      }, g.prototype.greaterThan = g.prototype.gt = function(n) {
        return this._high > n._high ? !0 : this._high < n._high ? !1 : this._low > n._low;
      }, g.prototype.lessThan = g.prototype.lt = function(n) {
        return this._high < n._high ? !0 : this._high > n._high ? !1 : this._low < n._low;
      }, g.prototype.or = function(n) {
        return this._low |= n._low, this._high |= n._high, this;
      }, g.prototype.and = function(n) {
        return this._low &= n._low, this._high &= n._high, this;
      }, g.prototype.not = function() {
        return this._low = ~this._low & 65535, this._high = ~this._high & 65535, this;
      }, g.prototype.xor = function(n) {
        return this._low ^= n._low, this._high ^= n._high, this;
      }, g.prototype.shiftRight = g.prototype.shiftr = function(n) {
        return n > 16 ? (this._low = this._high >> n - 16, this._high = 0) : n == 16 ? (this._low = this._high, this._high = 0) : (this._low = this._low >> n | this._high << 16 - n & 65535, this._high >>= n), this;
      }, g.prototype.shiftLeft = g.prototype.shiftl = function(n, h) {
        return n > 16 ? (this._high = this._low << n - 16, this._low = 0, h || (this._high &= 65535)) : n == 16 ? (this._high = this._low, this._low = 0) : (this._high = this._high << n | this._low >> 16 - n, this._low = this._low << n & 65535, h || (this._high &= 65535)), this;
      }, g.prototype.rotateLeft = g.prototype.rotl = function(n) {
        var h = this._high << 16 | this._low;
        return h = h << n | h >>> 32 - n, this._low = h & 65535, this._high = h >>> 16, this;
      }, g.prototype.rotateRight = g.prototype.rotr = function(n) {
        var h = this._high << 16 | this._low;
        return h = h >>> n | h << 32 - n, this._low = h & 65535, this._high = h >>> 16, this;
      }, g.prototype.clone = function() {
        return new g(this._low, this._high);
      }, o.exports ? o.exports = g : i.UINT32 = g;
    })(uint32);
  })(uint32$1)), uint32$1.exports;
}
var uint64$1 = { exports: {} }, uint64 = uint64$1.exports, hasRequiredUint64;
function requireUint64() {
  return hasRequiredUint64 || (hasRequiredUint64 = 1, (function(o) {
    (function(i) {
      var g = {
        16: e(Math.pow(16, 5)),
        10: e(Math.pow(10, 5)),
        2: e(Math.pow(2, 5))
      }, E = {
        16: e(16),
        10: e(10),
        2: e(2)
      };
      function e(d, k, p, M) {
        if (!(this instanceof e))
          return new e(d, k, p, M);
        if (this.remainder = null, typeof d == "string")
          return h.call(this, d, k);
        if (typeof k > "u")
          return n.call(this, d);
        t.apply(this, arguments);
      }
      function t(d, k, p, M) {
        return typeof p > "u" ? (this._a00 = d & 65535, this._a16 = d >>> 16, this._a32 = k & 65535, this._a48 = k >>> 16, this) : (this._a00 = d | 0, this._a16 = k | 0, this._a32 = p | 0, this._a48 = M | 0, this);
      }
      e.prototype.fromBits = t;
      function n(d) {
        return this._a00 = d & 65535, this._a16 = d >>> 16, this._a32 = 0, this._a48 = 0, this;
      }
      e.prototype.fromNumber = n;
      function h(d, k) {
        k = k || 10, this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0;
        for (var p = g[k] || new e(Math.pow(k, 5)), M = 0, H = d.length; M < H; M += 5) {
          var f = Math.min(5, H - M), AA = parseInt(d.slice(M, M + f), k);
          this.multiply(
            f < 5 ? new e(Math.pow(k, f)) : p
          ).add(new e(AA));
        }
        return this;
      }
      e.prototype.fromString = h, e.prototype.toNumber = function() {
        return this._a16 * 65536 + this._a00;
      }, e.prototype.toString = function(d) {
        d = d || 10;
        var k = E[d] || new e(d);
        if (!this.gt(k)) return this.toNumber().toString(d);
        for (var p = this.clone(), M = new Array(64), H = 63; H >= 0 && (p.div(k), M[H] = p.remainder.toNumber().toString(d), !!p.gt(k)); H--)
          ;
        return M[H - 1] = p.toNumber().toString(d), M.join("");
      }, e.prototype.add = function(d) {
        var k = this._a00 + d._a00, p = k >>> 16;
        p += this._a16 + d._a16;
        var M = p >>> 16;
        M += this._a32 + d._a32;
        var H = M >>> 16;
        return H += this._a48 + d._a48, this._a00 = k & 65535, this._a16 = p & 65535, this._a32 = M & 65535, this._a48 = H & 65535, this;
      }, e.prototype.subtract = function(d) {
        return this.add(d.clone().negate());
      }, e.prototype.multiply = function(d) {
        var k = this._a00, p = this._a16, M = this._a32, H = this._a48, f = d._a00, AA = d._a16, gA = d._a32, IA = d._a48, BA = k * f, CA = BA >>> 16;
        CA += k * AA;
        var QA = CA >>> 16;
        CA &= 65535, CA += p * f, QA += CA >>> 16, QA += k * gA;
        var iA = QA >>> 16;
        return QA &= 65535, QA += p * AA, iA += QA >>> 16, QA &= 65535, QA += M * f, iA += QA >>> 16, iA += k * IA, iA &= 65535, iA += p * gA, iA &= 65535, iA += M * AA, iA &= 65535, iA += H * f, this._a00 = BA & 65535, this._a16 = CA & 65535, this._a32 = QA & 65535, this._a48 = iA & 65535, this;
      }, e.prototype.div = function(d) {
        if (d._a16 == 0 && d._a32 == 0 && d._a48 == 0) {
          if (d._a00 == 0) throw Error("division by zero");
          if (d._a00 == 1)
            return this.remainder = new e(0), this;
        }
        if (d.gt(this))
          return this.remainder = this.clone(), this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0, this;
        if (this.eq(d))
          return this.remainder = new e(0), this._a00 = 1, this._a16 = 0, this._a32 = 0, this._a48 = 0, this;
        for (var k = d.clone(), p = -1; !this.lt(k); )
          k.shiftLeft(1, !0), p++;
        for (this.remainder = this.clone(), this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0; p >= 0; p--)
          k.shiftRight(1), this.remainder.lt(k) || (this.remainder.subtract(k), p >= 48 ? this._a48 |= 1 << p - 48 : p >= 32 ? this._a32 |= 1 << p - 32 : p >= 16 ? this._a16 |= 1 << p - 16 : this._a00 |= 1 << p);
        return this;
      }, e.prototype.negate = function() {
        var d = (~this._a00 & 65535) + 1;
        return this._a00 = d & 65535, d = (~this._a16 & 65535) + (d >>> 16), this._a16 = d & 65535, d = (~this._a32 & 65535) + (d >>> 16), this._a32 = d & 65535, this._a48 = ~this._a48 + (d >>> 16) & 65535, this;
      }, e.prototype.equals = e.prototype.eq = function(d) {
        return this._a48 == d._a48 && this._a00 == d._a00 && this._a32 == d._a32 && this._a16 == d._a16;
      }, e.prototype.greaterThan = e.prototype.gt = function(d) {
        return this._a48 > d._a48 ? !0 : this._a48 < d._a48 ? !1 : this._a32 > d._a32 ? !0 : this._a32 < d._a32 ? !1 : this._a16 > d._a16 ? !0 : this._a16 < d._a16 ? !1 : this._a00 > d._a00;
      }, e.prototype.lessThan = e.prototype.lt = function(d) {
        return this._a48 < d._a48 ? !0 : this._a48 > d._a48 ? !1 : this._a32 < d._a32 ? !0 : this._a32 > d._a32 ? !1 : this._a16 < d._a16 ? !0 : this._a16 > d._a16 ? !1 : this._a00 < d._a00;
      }, e.prototype.or = function(d) {
        return this._a00 |= d._a00, this._a16 |= d._a16, this._a32 |= d._a32, this._a48 |= d._a48, this;
      }, e.prototype.and = function(d) {
        return this._a00 &= d._a00, this._a16 &= d._a16, this._a32 &= d._a32, this._a48 &= d._a48, this;
      }, e.prototype.xor = function(d) {
        return this._a00 ^= d._a00, this._a16 ^= d._a16, this._a32 ^= d._a32, this._a48 ^= d._a48, this;
      }, e.prototype.not = function() {
        return this._a00 = ~this._a00 & 65535, this._a16 = ~this._a16 & 65535, this._a32 = ~this._a32 & 65535, this._a48 = ~this._a48 & 65535, this;
      }, e.prototype.shiftRight = e.prototype.shiftr = function(d) {
        return d %= 64, d >= 48 ? (this._a00 = this._a48 >> d - 48, this._a16 = 0, this._a32 = 0, this._a48 = 0) : d >= 32 ? (d -= 32, this._a00 = (this._a32 >> d | this._a48 << 16 - d) & 65535, this._a16 = this._a48 >> d & 65535, this._a32 = 0, this._a48 = 0) : d >= 16 ? (d -= 16, this._a00 = (this._a16 >> d | this._a32 << 16 - d) & 65535, this._a16 = (this._a32 >> d | this._a48 << 16 - d) & 65535, this._a32 = this._a48 >> d & 65535, this._a48 = 0) : (this._a00 = (this._a00 >> d | this._a16 << 16 - d) & 65535, this._a16 = (this._a16 >> d | this._a32 << 16 - d) & 65535, this._a32 = (this._a32 >> d | this._a48 << 16 - d) & 65535, this._a48 = this._a48 >> d & 65535), this;
      }, e.prototype.shiftLeft = e.prototype.shiftl = function(d, k) {
        return d %= 64, d >= 48 ? (this._a48 = this._a00 << d - 48, this._a32 = 0, this._a16 = 0, this._a00 = 0) : d >= 32 ? (d -= 32, this._a48 = this._a16 << d | this._a00 >> 16 - d, this._a32 = this._a00 << d & 65535, this._a16 = 0, this._a00 = 0) : d >= 16 ? (d -= 16, this._a48 = this._a32 << d | this._a16 >> 16 - d, this._a32 = (this._a16 << d | this._a00 >> 16 - d) & 65535, this._a16 = this._a00 << d & 65535, this._a00 = 0) : (this._a48 = this._a48 << d | this._a32 >> 16 - d, this._a32 = (this._a32 << d | this._a16 >> 16 - d) & 65535, this._a16 = (this._a16 << d | this._a00 >> 16 - d) & 65535, this._a00 = this._a00 << d & 65535), k || (this._a48 &= 65535), this;
      }, e.prototype.rotateLeft = e.prototype.rotl = function(d) {
        if (d %= 64, d == 0) return this;
        if (d >= 32) {
          var k = this._a00;
          if (this._a00 = this._a32, this._a32 = k, k = this._a48, this._a48 = this._a16, this._a16 = k, d == 32) return this;
          d -= 32;
        }
        var p = this._a48 << 16 | this._a32, M = this._a16 << 16 | this._a00, H = p << d | M >>> 32 - d, f = M << d | p >>> 32 - d;
        return this._a00 = f & 65535, this._a16 = f >>> 16, this._a32 = H & 65535, this._a48 = H >>> 16, this;
      }, e.prototype.rotateRight = e.prototype.rotr = function(d) {
        if (d %= 64, d == 0) return this;
        if (d >= 32) {
          var k = this._a00;
          if (this._a00 = this._a32, this._a32 = k, k = this._a48, this._a48 = this._a16, this._a16 = k, d == 32) return this;
          d -= 32;
        }
        var p = this._a48 << 16 | this._a32, M = this._a16 << 16 | this._a00, H = p >>> d | M << 32 - d, f = M >>> d | p << 32 - d;
        return this._a00 = f & 65535, this._a16 = f >>> 16, this._a32 = H & 65535, this._a48 = H >>> 16, this;
      }, e.prototype.clone = function() {
        return new e(this._a00, this._a16, this._a32, this._a48);
      }, o.exports ? o.exports = e : i.UINT64 = e;
    })(uint64);
  })(uint64$1)), uint64$1.exports;
}
var hasRequiredCuint;
function requireCuint() {
  return hasRequiredCuint || (hasRequiredCuint = 1, cuint.UINT32 = requireUint32(), cuint.UINT64 = requireUint64()), cuint;
}
var xxhash$1, hasRequiredXxhash;
function requireXxhash() {
  if (hasRequiredXxhash) return xxhash$1;
  hasRequiredXxhash = 1;
  var o = requireCuint().UINT32;
  o.prototype.xxh_update = function(k, p) {
    var M = g._low, H = g._high, f, AA;
    AA = k * M, f = AA >>> 16, f += p * M, f &= 65535, f += k * H;
    var gA = this._low + (AA & 65535), IA = gA >>> 16;
    IA += this._high + (f & 65535);
    var BA = IA << 16 | gA & 65535;
    BA = BA << 13 | BA >>> 19, gA = BA & 65535, IA = BA >>> 16, M = i._low, H = i._high, AA = gA * M, f = AA >>> 16, f += IA * M, f &= 65535, f += gA * H, this._low = AA & 65535, this._high = f & 65535;
  };
  var i = o("2654435761"), g = o("2246822519"), E = o("3266489917"), e = o("668265263"), t = o("374761393");
  function n(k) {
    for (var p = [], M = 0, H = k.length; M < H; M++) {
      var f = k.charCodeAt(M);
      f < 128 ? p.push(f) : f < 2048 ? p.push(
        192 | f >> 6,
        128 | f & 63
      ) : f < 55296 || f >= 57344 ? p.push(
        224 | f >> 12,
        128 | f >> 6 & 63,
        128 | f & 63
      ) : (M++, f = 65536 + ((f & 1023) << 10 | k.charCodeAt(M) & 1023), p.push(
        240 | f >> 18,
        128 | f >> 12 & 63,
        128 | f >> 6 & 63,
        128 | f & 63
      ));
    }
    return new Uint8Array(p);
  }
  function h() {
    if (arguments.length == 2)
      return new h(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof h))
      return new h(arguments[0]);
    d.call(this, arguments[0]);
  }
  function d(k) {
    return this.seed = k instanceof o ? k.clone() : o(k), this.v1 = this.seed.clone().add(i).add(g), this.v2 = this.seed.clone().add(g), this.v3 = this.seed.clone(), this.v4 = this.seed.clone().subtract(i), this.total_len = 0, this.memsize = 0, this.memory = null, this;
  }
  return h.prototype.init = d, h.prototype.update = function(k) {
    var p = typeof k == "string", M;
    p && (k = n(k), p = !1, M = !0), typeof ArrayBuffer < "u" && k instanceof ArrayBuffer && (M = !0, k = new Uint8Array(k));
    var H = 0, f = k.length, AA = H + f;
    if (f == 0) return this;
    if (this.total_len += f, this.memsize == 0 && (p ? this.memory = "" : M ? this.memory = new Uint8Array(16) : this.memory = new Buffer(16)), this.memsize + f < 16)
      return p ? this.memory += k : M ? this.memory.set(k.subarray(0, f), this.memsize) : k.copy(this.memory, this.memsize, 0, f), this.memsize += f, this;
    if (this.memsize > 0) {
      p ? this.memory += k.slice(0, 16 - this.memsize) : M ? this.memory.set(k.subarray(0, 16 - this.memsize), this.memsize) : k.copy(this.memory, this.memsize, 0, 16 - this.memsize);
      var gA = 0;
      p ? (this.v1.xxh_update(
        this.memory.charCodeAt(gA + 1) << 8 | this.memory.charCodeAt(gA),
        this.memory.charCodeAt(gA + 3) << 8 | this.memory.charCodeAt(gA + 2)
      ), gA += 4, this.v2.xxh_update(
        this.memory.charCodeAt(gA + 1) << 8 | this.memory.charCodeAt(gA),
        this.memory.charCodeAt(gA + 3) << 8 | this.memory.charCodeAt(gA + 2)
      ), gA += 4, this.v3.xxh_update(
        this.memory.charCodeAt(gA + 1) << 8 | this.memory.charCodeAt(gA),
        this.memory.charCodeAt(gA + 3) << 8 | this.memory.charCodeAt(gA + 2)
      ), gA += 4, this.v4.xxh_update(
        this.memory.charCodeAt(gA + 1) << 8 | this.memory.charCodeAt(gA),
        this.memory.charCodeAt(gA + 3) << 8 | this.memory.charCodeAt(gA + 2)
      )) : (this.v1.xxh_update(
        this.memory[gA + 1] << 8 | this.memory[gA],
        this.memory[gA + 3] << 8 | this.memory[gA + 2]
      ), gA += 4, this.v2.xxh_update(
        this.memory[gA + 1] << 8 | this.memory[gA],
        this.memory[gA + 3] << 8 | this.memory[gA + 2]
      ), gA += 4, this.v3.xxh_update(
        this.memory[gA + 1] << 8 | this.memory[gA],
        this.memory[gA + 3] << 8 | this.memory[gA + 2]
      ), gA += 4, this.v4.xxh_update(
        this.memory[gA + 1] << 8 | this.memory[gA],
        this.memory[gA + 3] << 8 | this.memory[gA + 2]
      )), H += 16 - this.memsize, this.memsize = 0, p && (this.memory = "");
    }
    if (H <= AA - 16) {
      var IA = AA - 16;
      do
        p ? (this.v1.xxh_update(
          k.charCodeAt(H + 1) << 8 | k.charCodeAt(H),
          k.charCodeAt(H + 3) << 8 | k.charCodeAt(H + 2)
        ), H += 4, this.v2.xxh_update(
          k.charCodeAt(H + 1) << 8 | k.charCodeAt(H),
          k.charCodeAt(H + 3) << 8 | k.charCodeAt(H + 2)
        ), H += 4, this.v3.xxh_update(
          k.charCodeAt(H + 1) << 8 | k.charCodeAt(H),
          k.charCodeAt(H + 3) << 8 | k.charCodeAt(H + 2)
        ), H += 4, this.v4.xxh_update(
          k.charCodeAt(H + 1) << 8 | k.charCodeAt(H),
          k.charCodeAt(H + 3) << 8 | k.charCodeAt(H + 2)
        )) : (this.v1.xxh_update(
          k[H + 1] << 8 | k[H],
          k[H + 3] << 8 | k[H + 2]
        ), H += 4, this.v2.xxh_update(
          k[H + 1] << 8 | k[H],
          k[H + 3] << 8 | k[H + 2]
        ), H += 4, this.v3.xxh_update(
          k[H + 1] << 8 | k[H],
          k[H + 3] << 8 | k[H + 2]
        ), H += 4, this.v4.xxh_update(
          k[H + 1] << 8 | k[H],
          k[H + 3] << 8 | k[H + 2]
        )), H += 4;
      while (H <= IA);
    }
    return H < AA && (p ? this.memory += k.slice(H) : M ? this.memory.set(k.subarray(H, AA), this.memsize) : k.copy(this.memory, this.memsize, H, AA), this.memsize = AA - H), this;
  }, h.prototype.digest = function() {
    var k = this.memory, p = typeof k == "string", M = 0, H = this.memsize, f, AA, gA = new o();
    for (this.total_len >= 16 ? f = this.v1.rotl(1).add(this.v2.rotl(7).add(this.v3.rotl(12).add(this.v4.rotl(18)))) : f = this.seed.clone().add(t), f.add(gA.fromNumber(this.total_len)); M <= H - 4; )
      p ? gA.fromBits(
        k.charCodeAt(M + 1) << 8 | k.charCodeAt(M),
        k.charCodeAt(M + 3) << 8 | k.charCodeAt(M + 2)
      ) : gA.fromBits(
        k[M + 1] << 8 | k[M],
        k[M + 3] << 8 | k[M + 2]
      ), f.add(gA.multiply(E)).rotl(17).multiply(e), M += 4;
    for (; M < H; )
      gA.fromBits(p ? k.charCodeAt(M++) : k[M++], 0), f.add(gA.multiply(t)).rotl(11).multiply(i);
    return AA = f.clone().shiftRight(15), f.xor(AA).multiply(g), AA = f.clone().shiftRight(13), f.xor(AA).multiply(E), AA = f.clone().shiftRight(16), f.xor(AA), this.init(this.seed), f;
  }, xxhash$1 = h, xxhash$1;
}
var xxhash64, hasRequiredXxhash64;
function requireXxhash64() {
  if (hasRequiredXxhash64) return xxhash64;
  hasRequiredXxhash64 = 1;
  var o = requireCuint().UINT64, i = o("11400714785074694791"), g = o("14029467366897019727"), E = o("1609587929392839161"), e = o("9650029242287828579"), t = o("2870177450012600261");
  function n(k) {
    for (var p = [], M = 0, H = k.length; M < H; M++) {
      var f = k.charCodeAt(M);
      f < 128 ? p.push(f) : f < 2048 ? p.push(
        192 | f >> 6,
        128 | f & 63
      ) : f < 55296 || f >= 57344 ? p.push(
        224 | f >> 12,
        128 | f >> 6 & 63,
        128 | f & 63
      ) : (M++, f = 65536 + ((f & 1023) << 10 | k.charCodeAt(M) & 1023), p.push(
        240 | f >> 18,
        128 | f >> 12 & 63,
        128 | f >> 6 & 63,
        128 | f & 63
      ));
    }
    return new Uint8Array(p);
  }
  function h() {
    if (arguments.length == 2)
      return new h(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof h))
      return new h(arguments[0]);
    d.call(this, arguments[0]);
  }
  function d(k) {
    return this.seed = k instanceof o ? k.clone() : o(k), this.v1 = this.seed.clone().add(i).add(g), this.v2 = this.seed.clone().add(g), this.v3 = this.seed.clone(), this.v4 = this.seed.clone().subtract(i), this.total_len = 0, this.memsize = 0, this.memory = null, this;
  }
  return h.prototype.init = d, h.prototype.update = function(k) {
    var p = typeof k == "string", M;
    p && (k = n(k), p = !1, M = !0), typeof ArrayBuffer < "u" && k instanceof ArrayBuffer && (M = !0, k = new Uint8Array(k));
    var H = 0, f = k.length, AA = H + f;
    if (f == 0) return this;
    if (this.total_len += f, this.memsize == 0 && (p ? this.memory = "" : M ? this.memory = new Uint8Array(32) : this.memory = new Buffer(32)), this.memsize + f < 32)
      return p ? this.memory += k : M ? this.memory.set(k.subarray(0, f), this.memsize) : k.copy(this.memory, this.memsize, 0, f), this.memsize += f, this;
    if (this.memsize > 0) {
      p ? this.memory += k.slice(0, 32 - this.memsize) : M ? this.memory.set(k.subarray(0, 32 - this.memsize), this.memsize) : k.copy(this.memory, this.memsize, 0, 32 - this.memsize);
      var gA = 0;
      if (p) {
        var IA;
        IA = o(
          this.memory.charCodeAt(gA + 1) << 8 | this.memory.charCodeAt(gA),
          this.memory.charCodeAt(gA + 3) << 8 | this.memory.charCodeAt(gA + 2),
          this.memory.charCodeAt(gA + 5) << 8 | this.memory.charCodeAt(gA + 4),
          this.memory.charCodeAt(gA + 7) << 8 | this.memory.charCodeAt(gA + 6)
        ), this.v1.add(IA.multiply(g)).rotl(31).multiply(i), gA += 8, IA = o(
          this.memory.charCodeAt(gA + 1) << 8 | this.memory.charCodeAt(gA),
          this.memory.charCodeAt(gA + 3) << 8 | this.memory.charCodeAt(gA + 2),
          this.memory.charCodeAt(gA + 5) << 8 | this.memory.charCodeAt(gA + 4),
          this.memory.charCodeAt(gA + 7) << 8 | this.memory.charCodeAt(gA + 6)
        ), this.v2.add(IA.multiply(g)).rotl(31).multiply(i), gA += 8, IA = o(
          this.memory.charCodeAt(gA + 1) << 8 | this.memory.charCodeAt(gA),
          this.memory.charCodeAt(gA + 3) << 8 | this.memory.charCodeAt(gA + 2),
          this.memory.charCodeAt(gA + 5) << 8 | this.memory.charCodeAt(gA + 4),
          this.memory.charCodeAt(gA + 7) << 8 | this.memory.charCodeAt(gA + 6)
        ), this.v3.add(IA.multiply(g)).rotl(31).multiply(i), gA += 8, IA = o(
          this.memory.charCodeAt(gA + 1) << 8 | this.memory.charCodeAt(gA),
          this.memory.charCodeAt(gA + 3) << 8 | this.memory.charCodeAt(gA + 2),
          this.memory.charCodeAt(gA + 5) << 8 | this.memory.charCodeAt(gA + 4),
          this.memory.charCodeAt(gA + 7) << 8 | this.memory.charCodeAt(gA + 6)
        ), this.v4.add(IA.multiply(g)).rotl(31).multiply(i);
      } else {
        var IA;
        IA = o(
          this.memory[gA + 1] << 8 | this.memory[gA],
          this.memory[gA + 3] << 8 | this.memory[gA + 2],
          this.memory[gA + 5] << 8 | this.memory[gA + 4],
          this.memory[gA + 7] << 8 | this.memory[gA + 6]
        ), this.v1.add(IA.multiply(g)).rotl(31).multiply(i), gA += 8, IA = o(
          this.memory[gA + 1] << 8 | this.memory[gA],
          this.memory[gA + 3] << 8 | this.memory[gA + 2],
          this.memory[gA + 5] << 8 | this.memory[gA + 4],
          this.memory[gA + 7] << 8 | this.memory[gA + 6]
        ), this.v2.add(IA.multiply(g)).rotl(31).multiply(i), gA += 8, IA = o(
          this.memory[gA + 1] << 8 | this.memory[gA],
          this.memory[gA + 3] << 8 | this.memory[gA + 2],
          this.memory[gA + 5] << 8 | this.memory[gA + 4],
          this.memory[gA + 7] << 8 | this.memory[gA + 6]
        ), this.v3.add(IA.multiply(g)).rotl(31).multiply(i), gA += 8, IA = o(
          this.memory[gA + 1] << 8 | this.memory[gA],
          this.memory[gA + 3] << 8 | this.memory[gA + 2],
          this.memory[gA + 5] << 8 | this.memory[gA + 4],
          this.memory[gA + 7] << 8 | this.memory[gA + 6]
        ), this.v4.add(IA.multiply(g)).rotl(31).multiply(i);
      }
      H += 32 - this.memsize, this.memsize = 0, p && (this.memory = "");
    }
    if (H <= AA - 32) {
      var BA = AA - 32;
      do {
        if (p) {
          var IA;
          IA = o(
            k.charCodeAt(H + 1) << 8 | k.charCodeAt(H),
            k.charCodeAt(H + 3) << 8 | k.charCodeAt(H + 2),
            k.charCodeAt(H + 5) << 8 | k.charCodeAt(H + 4),
            k.charCodeAt(H + 7) << 8 | k.charCodeAt(H + 6)
          ), this.v1.add(IA.multiply(g)).rotl(31).multiply(i), H += 8, IA = o(
            k.charCodeAt(H + 1) << 8 | k.charCodeAt(H),
            k.charCodeAt(H + 3) << 8 | k.charCodeAt(H + 2),
            k.charCodeAt(H + 5) << 8 | k.charCodeAt(H + 4),
            k.charCodeAt(H + 7) << 8 | k.charCodeAt(H + 6)
          ), this.v2.add(IA.multiply(g)).rotl(31).multiply(i), H += 8, IA = o(
            k.charCodeAt(H + 1) << 8 | k.charCodeAt(H),
            k.charCodeAt(H + 3) << 8 | k.charCodeAt(H + 2),
            k.charCodeAt(H + 5) << 8 | k.charCodeAt(H + 4),
            k.charCodeAt(H + 7) << 8 | k.charCodeAt(H + 6)
          ), this.v3.add(IA.multiply(g)).rotl(31).multiply(i), H += 8, IA = o(
            k.charCodeAt(H + 1) << 8 | k.charCodeAt(H),
            k.charCodeAt(H + 3) << 8 | k.charCodeAt(H + 2),
            k.charCodeAt(H + 5) << 8 | k.charCodeAt(H + 4),
            k.charCodeAt(H + 7) << 8 | k.charCodeAt(H + 6)
          ), this.v4.add(IA.multiply(g)).rotl(31).multiply(i);
        } else {
          var IA;
          IA = o(
            k[H + 1] << 8 | k[H],
            k[H + 3] << 8 | k[H + 2],
            k[H + 5] << 8 | k[H + 4],
            k[H + 7] << 8 | k[H + 6]
          ), this.v1.add(IA.multiply(g)).rotl(31).multiply(i), H += 8, IA = o(
            k[H + 1] << 8 | k[H],
            k[H + 3] << 8 | k[H + 2],
            k[H + 5] << 8 | k[H + 4],
            k[H + 7] << 8 | k[H + 6]
          ), this.v2.add(IA.multiply(g)).rotl(31).multiply(i), H += 8, IA = o(
            k[H + 1] << 8 | k[H],
            k[H + 3] << 8 | k[H + 2],
            k[H + 5] << 8 | k[H + 4],
            k[H + 7] << 8 | k[H + 6]
          ), this.v3.add(IA.multiply(g)).rotl(31).multiply(i), H += 8, IA = o(
            k[H + 1] << 8 | k[H],
            k[H + 3] << 8 | k[H + 2],
            k[H + 5] << 8 | k[H + 4],
            k[H + 7] << 8 | k[H + 6]
          ), this.v4.add(IA.multiply(g)).rotl(31).multiply(i);
        }
        H += 8;
      } while (H <= BA);
    }
    return H < AA && (p ? this.memory += k.slice(H) : M ? this.memory.set(k.subarray(H, AA), this.memsize) : k.copy(this.memory, this.memsize, H, AA), this.memsize = AA - H), this;
  }, h.prototype.digest = function() {
    var k = this.memory, p = typeof k == "string", M = 0, H = this.memsize, f, AA, gA = new o();
    for (this.total_len >= 32 ? (f = this.v1.clone().rotl(1), f.add(this.v2.clone().rotl(7)), f.add(this.v3.clone().rotl(12)), f.add(this.v4.clone().rotl(18)), f.xor(this.v1.multiply(g).rotl(31).multiply(i)), f.multiply(i).add(e), f.xor(this.v2.multiply(g).rotl(31).multiply(i)), f.multiply(i).add(e), f.xor(this.v3.multiply(g).rotl(31).multiply(i)), f.multiply(i).add(e), f.xor(this.v4.multiply(g).rotl(31).multiply(i)), f.multiply(i).add(e)) : f = this.seed.clone().add(t), f.add(gA.fromNumber(this.total_len)); M <= H - 8; )
      p ? gA.fromBits(
        k.charCodeAt(M + 1) << 8 | k.charCodeAt(M),
        k.charCodeAt(M + 3) << 8 | k.charCodeAt(M + 2),
        k.charCodeAt(M + 5) << 8 | k.charCodeAt(M + 4),
        k.charCodeAt(M + 7) << 8 | k.charCodeAt(M + 6)
      ) : gA.fromBits(
        k[M + 1] << 8 | k[M],
        k[M + 3] << 8 | k[M + 2],
        k[M + 5] << 8 | k[M + 4],
        k[M + 7] << 8 | k[M + 6]
      ), gA.multiply(g).rotl(31).multiply(i), f.xor(gA).rotl(27).multiply(i).add(e), M += 8;
    for (M + 4 <= H && (p ? gA.fromBits(
      k.charCodeAt(M + 1) << 8 | k.charCodeAt(M),
      k.charCodeAt(M + 3) << 8 | k.charCodeAt(M + 2),
      0,
      0
    ) : gA.fromBits(
      k[M + 1] << 8 | k[M],
      k[M + 3] << 8 | k[M + 2],
      0,
      0
    ), f.xor(gA.multiply(i)).rotl(23).multiply(g).add(E), M += 4); M < H; )
      gA.fromBits(p ? k.charCodeAt(M++) : k[M++], 0, 0, 0), f.xor(gA.multiply(t)).rotl(11).multiply(i);
    return AA = f.clone().shiftRight(33), f.xor(AA).multiply(g), AA = f.clone().shiftRight(29), f.xor(AA).multiply(E), AA = f.clone().shiftRight(32), f.xor(AA), this.init(this.seed), f;
  }, xxhash64 = h, xxhash64;
}
var lib$1, hasRequiredLib$1;
function requireLib$1() {
  return hasRequiredLib$1 || (hasRequiredLib$1 = 1, lib$1 = {
    h32: requireXxhash(),
    h64: requireXxhash64()
  }), lib$1;
}
var libExports$1 = requireLib$1();
const xxhash = /* @__PURE__ */ getDefaultExportFromCjs(libExports$1), assertNever = (o) => {
  throw new Error(`Reached a branch with non-exhaustive item: ${o}`);
}, GENERATED_ELEMENT_ID_PREFIX = "$$ID";
function debounce$2(o, i) {
  let g;
  return (...E) => {
    g && clearTimeout(g), g = setTimeout(() => {
      i(...E), g = null;
    }, o);
  };
}
const EMBED_QUERY_PARAM_KEY = "embed", EMBED_OPTIONS_QUERY_PARAM_KEY = "embed_options", EMBED_SHOW_TOOLBAR = "show_toolbar", EMBED_SHOW_PADDING = "show_padding", EMBED_DISABLE_SCROLLING = "disable_scrolling", EMBED_LIGHT_THEME = "light_theme", EMBED_DARK_THEME = "dark_theme", EMBED_TRUE = "true", EMBED_HIDE_LOADING_SCREEN = "hide_loading_screen", EMBED_SHOW_LOADING_SCREEN_V1 = "show_loading_screen_v1", EMBED_SHOW_LOADING_SCREEN_V2 = "show_loading_screen_v2", EMBED_QUERY_PARAM_VALUES = [EMBED_SHOW_TOOLBAR, EMBED_SHOW_PADDING, EMBED_DISABLE_SCROLLING, EMBED_LIGHT_THEME, EMBED_DARK_THEME, EMBED_HIDE_LOADING_SCREEN, EMBED_SHOW_LOADING_SCREEN_V1, EMBED_SHOW_LOADING_SCREEN_V2, EMBED_TRUE];
var LoadingScreenType = /* @__PURE__ */ ((o) => (o[o.NONE = 0] = "NONE", o[o.V1 = 1] = "V1", o[o.V2 = 2] = "V2", o))(LoadingScreenType || {});
function getEmbedUrlParams(o) {
  const i = /* @__PURE__ */ new Set();
  return new URLSearchParams(window.location.search).forEach((E, e) => {
    e = e.toString().toLowerCase(), E = E.toString().toLowerCase(), e === o && EMBED_QUERY_PARAM_VALUES.includes(E) && i.add(E);
  }), i;
}
function preserveEmbedQueryParams() {
  if (!isEmbed())
    return "";
  const o = new URLSearchParams(window.location.search).getAll(EMBED_OPTIONS_QUERY_PARAM_KEY), i = [];
  return i.push([EMBED_QUERY_PARAM_KEY, EMBED_TRUE]), o.forEach((g) => {
    i.push([EMBED_OPTIONS_QUERY_PARAM_KEY, g]);
  }), new URLSearchParams(i).toString();
}
function getQueryString(o, i) {
  return o !== void 0 ? i ? o ? `${i}&${o}` : i : o : i;
}
function isEmbed() {
  return getEmbedUrlParams(EMBED_QUERY_PARAM_KEY).has(EMBED_TRUE);
}
function isToolbarDisplayed() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_SHOW_TOOLBAR);
}
function isScrollingHidden() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_DISABLE_SCROLLING);
}
function isPaddingDisplayed() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_SHOW_PADDING);
}
function isLightThemeInQueryParams() {
  return getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_LIGHT_THEME);
}
function isDarkThemeInQueryParams() {
  return getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_DARK_THEME);
}
function isInChildFrame() {
  return window.parent !== window;
}
function getUrl() {
  let o;
  try {
    isInChildFrame() && window.top ? o = window.top.location.href : o = document.location.href;
  } catch {
    o = document.location.href;
  }
  const i = new URL(o);
  return i.search = "", i.hash = "", i.toString();
}
function getScreencastTimestamp() {
  const o = /* @__PURE__ */ new Date(), i = o.getFullYear(), g = String(o.getMonth() + 1).padStart(2, "0"), E = String(o.getDate()).padStart(2, "0"), e = String(o.getHours()).padStart(2, "0"), t = String(o.getMinutes()).padStart(2, "0"), n = String(o.getSeconds()).padStart(2, "0");
  return `${i}-${g}-${E}-${e}-${t}-${n}`;
}
function getTimezone$1() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function getTimezoneOffset() {
  return (/* @__PURE__ */ new Date()).getTimezoneOffset();
}
function getLocaleLanguage() {
  return navigator.language;
}
function getLoadingScreenType() {
  const o = getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY);
  return o.has(EMBED_HIDE_LOADING_SCREEN) ? 0 : o.has(EMBED_SHOW_LOADING_SCREEN_V1) ? 1 : 2;
}
function makeElementWithInfoText(o) {
  return new Element$1({
    alert: {
      body: o,
      format: Alert.Format.INFO
    }
  });
}
function makeElementWithErrorText(o) {
  return new Element$1({
    alert: {
      body: o,
      format: Alert.Format.ERROR
    }
  });
}
function makeAppSkeletonElement() {
  return new Element$1({
    skeleton: {
      style: Skeleton$1.SkeletonStyle.APP
    }
  });
}
function hashString(o) {
  return xxhash.h32(o, 3735928559).toString(16);
}
function requireNonNull(o) {
  if (isNullOrUndefined(o))
    throw new Error("value is null");
  return o;
}
function notUndefined(o) {
  return o !== void 0;
}
function isFromMac() {
  return /Mac/i.test(navigator.platform);
}
function isFromWindows() {
  return /^Win/i.test(navigator.platform);
}
function setCookie(o, i, g) {
  const E = i ? g : /* @__PURE__ */ new Date(), e = E ? `expires=${E.toUTCString()};` : "";
  document.cookie = `${o}=${i};${e}path=/`;
}
function isValidElementId(o) {
  return o ? o.startsWith(GENERATED_ELEMENT_ID_PREFIX) && // There must be at least 3 parts: $$ID-<hash>-<userKey>
  o.split("-").length >= 3 : !1;
}
function getElementId(o) {
  const i = get$1(o, [requireNonNull(o.type), "id"]);
  if (i && isValidElementId(i))
    return i;
}
function isValidFormId(o) {
  return notNullOrUndefined(o) && o.length > 0;
}
function isInForm(o) {
  return isValidFormId(o.formId);
}
function getSelectPlaceholder(o, i, g, E = !1) {
  let e = !1;
  return o !== "" ? {
    placeholder: o,
    shouldDisable: e
  } : (i.length === 0 ? g ? o = E ? "Add options" : "Add an option" : (o = "No options to select", e = !0) : g ? o = E ? "Choose or add options" : "Choose or add an option" : o = E ? "Choose options" : "Choose an option", {
    placeholder: o,
    shouldDisable: e
  });
}
var LabelVisibilityOptions = /* @__PURE__ */ ((o) => (o[o.Visible = 0] = "Visible", o[o.Hidden = 1] = "Hidden", o[o.Collapsed = 2] = "Collapsed", o))(LabelVisibilityOptions || {});
function labelVisibilityProtoValueToEnum(o) {
  switch (o) {
    case LabelVisibilityMessage.LabelVisibilityOptions.VISIBLE:
      return 0;
    case LabelVisibilityMessage.LabelVisibilityOptions.HIDDEN:
      return 1;
    case LabelVisibilityMessage.LabelVisibilityOptions.COLLAPSED:
      return 2;
    default:
      return 0;
  }
}
var AcceptFileValue = /* @__PURE__ */ ((o) => (o[o.None = 0] = "None", o[o.Single = 1] = "Single", o[o.Multiple = 2] = "Multiple", o[o.Directory = 3] = "Directory", o))(AcceptFileValue || {});
function chatInputAcceptFileProtoValueToEnum(o) {
  switch (o) {
    case ChatInput$1.AcceptFile.NONE:
      return 0;
    case ChatInput$1.AcceptFile.SINGLE:
      return 1;
    case ChatInput$1.AcceptFile.MULTIPLE:
      return 2;
    case ChatInput$1.AcceptFile.DIRECTORY:
      return 3;
    default:
      return assertNever(o), 0;
  }
}
function findAnIFrameWithClassName(o, i) {
  for (let g = 0; g < o.length; g++) {
    const E = o[g].contentDocument;
    if (E && E.getElementsByClassName(i).length > 0)
      return o[g];
  }
  return null;
}
function canAccessIFrame(o) {
  try {
    if (o.contentWindow === null) return !1;
    const g = (o.contentDocument || o.contentWindow.document).body.innerHTML;
    return g !== null && g !== "";
  } catch {
    return !1;
  }
}
function getIFrameEnclosingApp(o) {
  if (!isInChildFrame())
    return null;
  const i = getEmbeddingIdClassName(o), g = 'iframe[title="streamlitApp"]';
  let E = window.document.querySelectorAll(g), e = findAnIFrameWithClassName(E, i);
  if (e && !canAccessIFrame(e))
    return null;
  if (e)
    return e;
  if (window.parent && (E = window.parent.document.querySelectorAll(g)), e = findAnIFrameWithClassName(E, i), e && !canAccessIFrame(e))
    return null;
  if (e)
    return e;
  let t = window.document.getElementsByTagName("iframe");
  return e = findAnIFrameWithClassName(t, i), e && !canAccessIFrame(e) ? null : e || (window.parent && (t = window.parent.document.getElementsByTagName("iframe")), e = findAnIFrameWithClassName(t, i), e && !canAccessIFrame(e) ? null : e);
}
function generateUID$2() {
  return Math.floor(Date.now() / 1e3).toString(36) + Math.random().toString(36).slice(-6);
}
function getEmbeddingIdClassName(o) {
  return `stAppEmbeddingId-${o}`;
}
function extractPageNameFromPathName(o, i) {
  return decodeURIComponent(o.replace(i, "").replace(new RegExp("^/?"), "").replace(new RegExp("/$"), ""));
}
function keysToSnakeCase(o) {
  return Object.keys(o).reduce(
    (i, g) => {
      const E = decamelize$1(g, {
        preserveConsecutiveUppercase: !0
      }).replace(".", "_");
      let e = o[g];
      return e && typeof e == "object" && !Array.isArray(e) && (e = keysToSnakeCase(e)), Array.isArray(e) && (e = e.map((t) => t !== null && typeof t == "object" ? keysToSnakeCase(t) : t)), i[E] = e, i;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    {}
  );
}
const MAX_HASH_LENGTH = 6;
class DebugVisitor {
  constructor(i = "", g = !0) {
    this.prefix = i, this.isLast = g;
  }
  visitBlockNode(i) {
    const g = this.isLast ? "└── " : "├── ", E = this.prefix + (this.isLast ? "    " : "│   ");
    let e = `${this.prefix}${g}BlockNode [${i.children.length} children]`;
    return i.scriptRunId !== NO_SCRIPT_RUN_ID && (e += ` (run: ${i.scriptRunId.substring(0, MAX_HASH_LENGTH)})`), e += `
`, i.children.forEach((t, n) => {
      const h = n === i.children.length - 1, d = new DebugVisitor(E, h);
      e += t.accept(d);
    }), e;
  }
  visitElementNode(i) {
    const g = this.isLast ? "└── " : "├── ";
    let E = `${this.prefix}${g}ElementNode [${i.element.type}]`;
    if (i.element.type === "text" && i.element.text?.body) {
      const e = i.element.text.body.length > 30 ? `${i.element.text.body.slice(0, 30)}...` : i.element.text.body;
      E += ` "${e}"`;
    }
    return i.scriptRunId !== NO_SCRIPT_RUN_ID && (E += ` (run: ${i.scriptRunId.substring(0, MAX_HASH_LENGTH)})`), i.fragmentId && (E += ` (fragment: ${i.fragmentId.substring(0, MAX_HASH_LENGTH)})`), E += ` (activeScriptHash: ${i.activeScriptHash.substring(0, MAX_HASH_LENGTH)})`, E += `
`, E;
  }
  visitTransientNode(i) {
    const g = this.isLast ? "└── " : "├── ", E = this.prefix + (this.isLast ? "    " : "│   ");
    let e = `${this.prefix}${g}TransientNode [${i.transientNodes.length} transient]`;
    if (i.scriptRunId !== NO_SCRIPT_RUN_ID && (e += ` (run: ${i.scriptRunId.substring(0, MAX_HASH_LENGTH)})`), e += `
`, i.anchor) {
      e += `${E}├── anchor:
`;
      const t = new DebugVisitor(E + "│   ", !0);
      e += i.anchor.accept(t);
    }
    return i.transientNodes.length > 0 && (e += `${E}└── transient nodes:
`, i.transientNodes.forEach((t, n) => {
      const h = n === i.transientNodes.length - 1, d = h ? "└── " : "├── ", k = E + "    " + (h ? "    " : "│   ");
      e += `${E}    ${d}:
`;
      const p = new DebugVisitor(k, !0);
      e += t.accept(p);
    })), e;
  }
  /**
   * Static helper method to generate debug output for any AppNode.
   */
  static generateDebugString(i, g = "", E = !0) {
    const e = new DebugVisitor(g, E);
    return i.accept(e);
  }
}
class TransientNode {
  constructor(i, g, E, e) {
    this.scriptRunId = i, this.anchor = g, this.transientNodes = E ?? [], this.deltaMsgReceivedAt = e ?? Date.now(), this.fragmentId = void 0, this.activeScriptHash = void 0;
  }
  /**
   * Updates the transient nodes by applying a function to each transient node.
   * If the function returns undefined, the transient node is removed from the list.
   * @param update - A function that takes an ElementNode and returns an ElementNode or undefined.
   * @returns A new array of transient nodes.
   */
  updateTransientNodes(i) {
    const g = [];
    return this.transientNodes.forEach((E) => {
      const e = i(E);
      e && g.push(e);
    }), g;
  }
  accept(i) {
    return i.visitTransientNode(this);
  }
  debug() {
    return this.accept(new DebugVisitor());
  }
  // Combine the information of the node with the updated information
  // of *this* node
  replaceTransientNodeWithSelf(i) {
    return !this.deltaMsgReceivedAt || !i.deltaMsgReceivedAt || this.deltaMsgReceivedAt >= i.deltaMsgReceivedAt ? new TransientNode(this.scriptRunId, this.anchor ?? i.anchor, this.transientNodes, this.deltaMsgReceivedAt) : i;
  }
}
class ClearStaleNodeVisitor {
  constructor(i, g, E) {
    this.currentScriptRunId = i, this.fragmentIdsThisRun = g ?? [], this.fragmentIdOfBlock = E;
  }
  get isFragmentRun() {
    return this.fragmentIdsThisRun.length > 0;
  }
  visitBlockNode(i) {
    let g = null;
    if (this.isFragmentRun) {
      if (this.fragmentIdOfBlock && i.scriptRunId !== this.currentScriptRunId)
        return;
      i.fragmentId && this.fragmentIdsThisRun.includes(i.fragmentId) && i.scriptRunId === this.currentScriptRunId && (g = new ClearStaleNodeVisitor(this.currentScriptRunId, this.fragmentIdsThisRun, i.fragmentId));
    } else if (i.scriptRunId !== this.currentScriptRunId)
      return;
    const E = [];
    let e = !1;
    return i.children.forEach((t) => {
      const n = t.accept(g ?? this);
      n !== t && (e = !0), n !== void 0 && E.push(n);
    }), e ? new BlockNode(i.activeScriptHash, E, i.deltaBlock, this.currentScriptRunId, i.fragmentId, i.deltaMsgReceivedAt) : i;
  }
  visitElementNode(i) {
    return this.isFragmentRun && (!i.fragmentId || !this.fragmentIdOfBlock || i.scriptRunId === this.currentScriptRunId) || i.scriptRunId === this.currentScriptRunId ? i : void 0;
  }
  visitTransientNode(i) {
    const g = i.anchor?.accept(this), E = i.updateTransientNodes((e) => e.accept(this));
    if (!(!g && E.length === 0))
      return E.length === 0 ? g : new TransientNode(i.scriptRunId, g, E, i.deltaMsgReceivedAt);
  }
}
class BlockNode {
  constructor(i, g, E, e, t, n) {
    this.activeScriptHash = i, this.children = g ?? [], this.deltaBlock = E ?? new Block$1({}), this.scriptRunId = e ?? NO_SCRIPT_RUN_ID, this.fragmentId = t, this.deltaMsgReceivedAt = n;
  }
  /** True if this Block has no children. */
  get isEmpty() {
    return this.children.length === 0;
  }
  replaceTransientNodeWithSelf(i) {
    if (i.scriptRunId !== this.scriptRunId)
      return this;
    if (i.transientNodes.length === 0)
      return this;
    const g = i.updateTransientNodes((E) => E.accept(new ClearStaleNodeVisitor(this.scriptRunId)));
    return g.length === 0 ? this : new TransientNode(this.scriptRunId, this, g, i.deltaMsgReceivedAt);
  }
  /**
   * Accept a visitor.
   * @param visitor - The visitor to accept.
   * @returns The result of the visitor's visitBlockNode method.
   * @example
   * const visitor = new DebugVisitor()
   * const result = blockNode.accept(visitor)
   * console.log(result)
   */
  accept(i) {
    return i.visitBlockNode(this);
  }
  /**
   * Returns a string representation of this BlockNode and its children,
   * primarily for debugging or logging purposes.
   *
   * @returns {string} A debug string describing the structure of this BlockNode.
   */
  debug() {
    return this.accept(new DebugVisitor());
  }
}
var NOTHING = Symbol.for("immer-nothing"), DRAFTABLE = Symbol.for("immer-draftable"), DRAFT_STATE = Symbol.for("immer-state"), errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(o) {
    return `The plugin for '${o}' has not been loaded into Immer. To enable the plugin, import and call \`enable${o}()\` when initializing your application.`;
  },
  function(o) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${o}'`;
  },
  "This object has been frozen and should not be mutated",
  function(o) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + o;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(o) {
    return `'current' expects a draft, got: ${o}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(o) {
    return `'original' expects a draft, got: ${o}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(o, ...i) {
  if (process.env.NODE_ENV !== "production") {
    const g = errors[o], E = isFunction$3(g) ? g.apply(null, i) : g;
    throw new Error(`[Immer] ${E}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${o}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var O$1 = Object, getPrototypeOf = O$1.getPrototypeOf, CONSTRUCTOR = "constructor", PROTOTYPE = "prototype", CONFIGURABLE = "configurable", ENUMERABLE = "enumerable", WRITABLE = "writable", VALUE = "value", isDraft = (o) => !!o && !!o[DRAFT_STATE];
function isDraftable(o) {
  return o ? isPlainObject$2(o) || isArray(o) || !!o[DRAFTABLE] || !!o[CONSTRUCTOR]?.[DRAFTABLE] || isMap(o) || isSet(o) : !1;
}
var objectCtorString = O$1[PROTOTYPE][CONSTRUCTOR].toString(), cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject$2(o) {
  if (!o || !isObjectish(o))
    return !1;
  const i = getPrototypeOf(o);
  if (i === null || i === O$1[PROTOTYPE])
    return !0;
  const g = O$1.hasOwnProperty.call(i, CONSTRUCTOR) && i[CONSTRUCTOR];
  if (g === Object)
    return !0;
  if (!isFunction$3(g))
    return !1;
  let E = cachedCtorStrings.get(g);
  return E === void 0 && (E = Function.toString.call(g), cachedCtorStrings.set(g, E)), E === objectCtorString;
}
function each$1(o, i, g = !0) {
  getArchtype(o) === 0 ? (g ? Reflect.ownKeys(o) : O$1.keys(o)).forEach((e) => {
    i(e, o[e], o);
  }) : o.forEach((E, e) => i(e, E, o));
}
function getArchtype(o) {
  const i = o[DRAFT_STATE];
  return i ? i.type_ : isArray(o) ? 1 : isMap(o) ? 2 : isSet(o) ? 3 : 0;
}
var has$1 = (o, i, g = getArchtype(o)) => g === 2 ? o.has(i) : O$1[PROTOTYPE].hasOwnProperty.call(o, i), get = (o, i, g = getArchtype(o)) => (
  // @ts-ignore
  g === 2 ? o.get(i) : o[i]
), set = (o, i, g, E = getArchtype(o)) => {
  E === 2 ? o.set(i, g) : E === 3 ? o.add(g) : o[i] = g;
};
function is(o, i) {
  return o === i ? o !== 0 || 1 / o === 1 / i : o !== o && i !== i;
}
var isArray = Array.isArray, isMap = (o) => o instanceof Map, isSet = (o) => o instanceof Set, isObjectish = (o) => typeof o == "object", isFunction$3 = (o) => typeof o == "function", isBoolean$1 = (o) => typeof o == "boolean";
function isArrayIndex(o) {
  const i = +o;
  return Number.isInteger(i) && String(i) === o;
}
var getProxyDraft = (o) => isObjectish(o) ? o?.[DRAFT_STATE] : null, latest = (o) => o.copy_ || o.base_, getValue = (o) => {
  const i = getProxyDraft(o);
  return i ? i.copy_ ?? i.base_ : o;
}, getFinalValue = (o) => o.modified_ ? o.copy_ : o.base_;
function shallowCopy(o, i) {
  if (isMap(o))
    return new Map(o);
  if (isSet(o))
    return new Set(o);
  if (isArray(o))
    return Array[PROTOTYPE].slice.call(o);
  const g = isPlainObject$2(o);
  if (i === !0 || i === "class_only" && !g) {
    const E = O$1.getOwnPropertyDescriptors(o);
    delete E[DRAFT_STATE];
    let e = Reflect.ownKeys(E);
    for (let t = 0; t < e.length; t++) {
      const n = e[t], h = E[n];
      h[WRITABLE] === !1 && (h[WRITABLE] = !0, h[CONFIGURABLE] = !0), (h.get || h.set) && (E[n] = {
        [CONFIGURABLE]: !0,
        [WRITABLE]: !0,
        // could live with !!desc.set as well here...
        [ENUMERABLE]: h[ENUMERABLE],
        [VALUE]: o[n]
      });
    }
    return O$1.create(getPrototypeOf(o), E);
  } else {
    const E = getPrototypeOf(o);
    if (E !== null && g)
      return { ...o };
    const e = O$1.create(E);
    return O$1.assign(e, o);
  }
}
function freeze(o, i = !1) {
  return isFrozen(o) || isDraft(o) || !isDraftable(o) || (getArchtype(o) > 1 && O$1.defineProperties(o, {
    set: dontMutateMethodOverride,
    add: dontMutateMethodOverride,
    clear: dontMutateMethodOverride,
    delete: dontMutateMethodOverride
  }), O$1.freeze(o), i && each$1(
    o,
    (g, E) => {
      freeze(E, !0);
    },
    !1
  )), o;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  [VALUE]: dontMutateFrozenCollections
};
function isFrozen(o) {
  return o === null || !isObjectish(o) ? !0 : O$1.isFrozen(o);
}
var PluginMapSet = "MapSet", PluginPatches = "Patches", PluginArrayMethods = "ArrayMethods", plugins$1 = {};
function getPlugin(o) {
  const i = plugins$1[o];
  return i || die(0, o), i;
}
var isPluginLoaded = (o) => !!plugins$1[o];
function loadPlugin(o, i) {
  plugins$1[o] || (plugins$1[o] = i);
}
var currentScope, getCurrentScope = () => currentScope, createScope = (o, i) => ({
  drafts_: [],
  parent_: o,
  immer_: i,
  // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.
  canAutoFreeze_: !0,
  unfinalizedDrafts_: 0,
  handledSet_: /* @__PURE__ */ new Set(),
  processedForPatches_: /* @__PURE__ */ new Set(),
  mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin(PluginMapSet) : void 0,
  arrayMethodsPlugin_: isPluginLoaded(PluginArrayMethods) ? getPlugin(PluginArrayMethods) : void 0
});
function usePatchesInScope(o, i) {
  i && (o.patchPlugin_ = getPlugin(PluginPatches), o.patches_ = [], o.inversePatches_ = [], o.patchListener_ = i);
}
function revokeScope(o) {
  leaveScope(o), o.drafts_.forEach(revokeDraft), o.drafts_ = null;
}
function leaveScope(o) {
  o === currentScope && (currentScope = o.parent_);
}
var enterScope = (o) => currentScope = createScope(currentScope, o);
function revokeDraft(o) {
  const i = o[DRAFT_STATE];
  i.type_ === 0 || i.type_ === 1 ? i.revoke_() : i.revoked_ = !0;
}
function processResult(o, i) {
  i.unfinalizedDrafts_ = i.drafts_.length;
  const g = i.drafts_[0];
  if (o !== void 0 && o !== g) {
    g[DRAFT_STATE].modified_ && (revokeScope(i), die(4)), isDraftable(o) && (o = finalize(i, o));
    const { patchPlugin_: e } = i;
    e && e.generateReplacementPatches_(
      g[DRAFT_STATE].base_,
      o,
      i
    );
  } else
    o = finalize(i, g);
  return maybeFreeze(i, o, !0), revokeScope(i), i.patches_ && i.patchListener_(i.patches_, i.inversePatches_), o !== NOTHING ? o : void 0;
}
function finalize(o, i) {
  if (isFrozen(i))
    return i;
  const g = i[DRAFT_STATE];
  if (!g)
    return handleValue(i, o.handledSet_, o);
  if (!isSameScope(g, o))
    return i;
  if (!g.modified_)
    return g.base_;
  if (!g.finalized_) {
    const { callbacks_: E } = g;
    if (E)
      for (; E.length > 0; )
        E.pop()(o);
    generatePatchesAndFinalize(g, o);
  }
  return g.copy_;
}
function maybeFreeze(o, i, g = !1) {
  !o.parent_ && o.immer_.autoFreeze_ && o.canAutoFreeze_ && freeze(i, g);
}
function markStateFinalized(o) {
  o.finalized_ = !0, o.scope_.unfinalizedDrafts_--;
}
var isSameScope = (o, i) => o.scope_ === i, EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(o, i, g, E) {
  const e = latest(o), t = o.type_;
  if (E !== void 0 && get(e, E, t) === i) {
    set(e, E, g, t);
    return;
  }
  if (!o.draftLocations_) {
    const h = o.draftLocations_ = /* @__PURE__ */ new Map();
    each$1(e, (d, k) => {
      if (isDraft(k)) {
        const p = h.get(k) || [];
        p.push(d), h.set(k, p);
      }
    });
  }
  const n = o.draftLocations_.get(i) ?? EMPTY_LOCATIONS_RESULT;
  for (const h of n)
    set(e, h, g, t);
}
function registerChildFinalizationCallback(o, i, g) {
  o.callbacks_.push(function(e) {
    const t = i;
    if (!t || !isSameScope(t, e))
      return;
    e.mapSetPlugin_?.fixSetContents(t);
    const n = getFinalValue(t);
    updateDraftInParent(o, t.draft_ ?? t, n, g), generatePatchesAndFinalize(t, e);
  });
}
function generatePatchesAndFinalize(o, i) {
  if (o.modified_ && !o.finalized_ && (o.type_ === 3 || o.type_ === 1 && o.allIndicesReassigned_ || (o.assigned_?.size ?? 0) > 0)) {
    const { patchPlugin_: E } = i;
    if (E) {
      const e = E.getPath(o);
      e && E.generatePatches_(o, e, i);
    }
    markStateFinalized(o);
  }
}
function handleCrossReference(o, i, g) {
  const { scope_: E } = o;
  if (isDraft(g)) {
    const e = g[DRAFT_STATE];
    isSameScope(e, E) && e.callbacks_.push(function() {
      prepareCopy(o);
      const n = getFinalValue(e);
      updateDraftInParent(o, g, n, i);
    });
  } else isDraftable(g) && o.callbacks_.push(function() {
    const t = latest(o);
    o.type_ === 3 ? t.has(g) && handleValue(g, E.handledSet_, E) : get(t, i, o.type_) === g && E.drafts_.length > 1 && (o.assigned_.get(i) ?? !1) === !0 && o.copy_ && handleValue(
      get(o.copy_, i, o.type_),
      E.handledSet_,
      E
    );
  });
}
function handleValue(o, i, g) {
  return !g.immer_.autoFreeze_ && g.unfinalizedDrafts_ < 1 || isDraft(o) || i.has(o) || !isDraftable(o) || isFrozen(o) || (i.add(o), each$1(o, (E, e) => {
    if (isDraft(e)) {
      const t = e[DRAFT_STATE];
      if (isSameScope(t, g)) {
        const n = getFinalValue(t);
        set(o, E, n, o.type_), markStateFinalized(t);
      }
    } else isDraftable(e) && handleValue(e, i, g);
  })), o;
}
function createProxyProxy(o, i) {
  const g = isArray(o), E = {
    type_: g ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: i ? i.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    // actually instantiated in `prepareCopy()`
    assigned_: void 0,
    // The parent draft state.
    parent_: i,
    // The base state.
    base_: o,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1,
    // `callbacks` actually gets assigned in `createProxy`
    callbacks_: void 0
  };
  let e = E, t = objectTraps;
  g && (e = [E], t = arrayTraps);
  const { revoke: n, proxy: h } = Proxy.revocable(e, t);
  return E.draft_ = h, E.revoke_ = n, [h, E];
}
var objectTraps = {
  get(o, i) {
    if (i === DRAFT_STATE)
      return o;
    let g = o.scope_.arrayMethodsPlugin_;
    const E = o.type_ === 1 && typeof i == "string";
    if (E && g?.isArrayOperationMethod(i))
      return g.createMethodInterceptor(o, i);
    const e = latest(o);
    if (!has$1(e, i, o.type_))
      return readPropFromProto(o, e, i);
    const t = e[i];
    if (o.finalized_ || !isDraftable(t) || E && o.operationMethod && g?.isMutatingArrayMethod(
      o.operationMethod
    ) && isArrayIndex(i))
      return t;
    if (t === peek(o.base_, i)) {
      prepareCopy(o);
      const n = o.type_ === 1 ? +i : i, h = createProxy(o.scope_, t, o, n);
      return o.copy_[n] = h;
    }
    return t;
  },
  has(o, i) {
    return i in latest(o);
  },
  ownKeys(o) {
    return Reflect.ownKeys(latest(o));
  },
  set(o, i, g) {
    const E = getDescriptorFromProto(latest(o), i);
    if (E?.set)
      return E.set.call(o.draft_, g), !0;
    if (!o.modified_) {
      const e = peek(latest(o), i), t = e?.[DRAFT_STATE];
      if (t && t.base_ === g)
        return o.copy_[i] = g, o.assigned_.set(i, !1), !0;
      if (is(g, e) && (g !== void 0 || has$1(o.base_, i, o.type_)))
        return !0;
      prepareCopy(o), markChanged(o);
    }
    return o.copy_[i] === g && // special case: handle new props with value 'undefined'
    (g !== void 0 || i in o.copy_) || // special case: NaN
    Number.isNaN(g) && Number.isNaN(o.copy_[i]) || (o.copy_[i] = g, o.assigned_.set(i, !0), handleCrossReference(o, i, g)), !0;
  },
  deleteProperty(o, i) {
    return prepareCopy(o), peek(o.base_, i) !== void 0 || i in o.base_ ? (o.assigned_.set(i, !1), markChanged(o)) : o.assigned_.delete(i), o.copy_ && delete o.copy_[i], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(o, i) {
    const g = latest(o), E = Reflect.getOwnPropertyDescriptor(g, i);
    return E && {
      [WRITABLE]: !0,
      [CONFIGURABLE]: o.type_ !== 1 || i !== "length",
      [ENUMERABLE]: E[ENUMERABLE],
      [VALUE]: g[i]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(o) {
    return getPrototypeOf(o.base_);
  },
  setPrototypeOf() {
    die(12);
  }
}, arrayTraps = {};
for (let o in objectTraps) {
  let i = objectTraps[o];
  arrayTraps[o] = function() {
    const g = arguments;
    return g[0] = g[0][0], i.apply(this, g);
  };
}
arrayTraps.deleteProperty = function(o, i) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(i)) && die(13), arrayTraps.set.call(this, o, i, void 0);
};
arrayTraps.set = function(o, i, g) {
  return process.env.NODE_ENV !== "production" && i !== "length" && isNaN(parseInt(i)) && die(14), objectTraps.set.call(this, o[0], i, g, o[0]);
};
function peek(o, i) {
  const g = o[DRAFT_STATE];
  return (g ? latest(g) : o)[i];
}
function readPropFromProto(o, i, g) {
  const E = getDescriptorFromProto(i, g);
  return E ? VALUE in E ? E[VALUE] : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    E.get?.call(o.draft_)
  ) : void 0;
}
function getDescriptorFromProto(o, i) {
  if (!(i in o))
    return;
  let g = getPrototypeOf(o);
  for (; g; ) {
    const E = Object.getOwnPropertyDescriptor(g, i);
    if (E)
      return E;
    g = getPrototypeOf(g);
  }
}
function markChanged(o) {
  o.modified_ || (o.modified_ = !0, o.parent_ && markChanged(o.parent_));
}
function prepareCopy(o) {
  o.copy_ || (o.assigned_ = /* @__PURE__ */ new Map(), o.copy_ = shallowCopy(
    o.base_,
    o.scope_.immer_.useStrictShallowCopy_
  ));
}
var Immer2 = class {
  constructor(o) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !1, this.produce = (i, g, E) => {
      if (isFunction$3(i) && !isFunction$3(g)) {
        const t = g;
        g = i;
        const n = this;
        return function(d = t, ...k) {
          return n.produce(d, (p) => g.call(this, p, ...k));
        };
      }
      isFunction$3(g) || die(6), E !== void 0 && !isFunction$3(E) && die(7);
      let e;
      if (isDraftable(i)) {
        const t = enterScope(this), n = createProxy(t, i, void 0);
        let h = !0;
        try {
          e = g(n), h = !1;
        } finally {
          h ? revokeScope(t) : leaveScope(t);
        }
        return usePatchesInScope(t, E), processResult(e, t);
      } else if (!i || !isObjectish(i)) {
        if (e = g(i), e === void 0 && (e = i), e === NOTHING && (e = void 0), this.autoFreeze_ && freeze(e, !0), E) {
          const t = [], n = [];
          getPlugin(PluginPatches).generateReplacementPatches_(i, e, {
            patches_: t,
            inversePatches_: n
          }), E(t, n);
        }
        return e;
      } else
        die(1, i);
    }, this.produceWithPatches = (i, g) => {
      if (isFunction$3(i))
        return (n, ...h) => this.produceWithPatches(n, (d) => i(d, ...h));
      let E, e;
      return [this.produce(i, g, (n, h) => {
        E = n, e = h;
      }), E, e];
    }, isBoolean$1(o?.autoFreeze) && this.setAutoFreeze(o.autoFreeze), isBoolean$1(o?.useStrictShallowCopy) && this.setUseStrictShallowCopy(o.useStrictShallowCopy), isBoolean$1(o?.useStrictIteration) && this.setUseStrictIteration(o.useStrictIteration);
  }
  createDraft(o) {
    isDraftable(o) || die(8), isDraft(o) && (o = current(o));
    const i = enterScope(this), g = createProxy(i, o, void 0);
    return g[DRAFT_STATE].isManual_ = !0, leaveScope(i), g;
  }
  finishDraft(o, i) {
    const g = o && o[DRAFT_STATE];
    (!g || !g.isManual_) && die(9);
    const { scope_: E } = g;
    return usePatchesInScope(E, i), processResult(void 0, E);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(o) {
    this.autoFreeze_ = o;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(o) {
    this.useStrictShallowCopy_ = o;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(o) {
    this.useStrictIteration_ = o;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(o, i) {
    let g;
    for (g = i.length - 1; g >= 0; g--) {
      const e = i[g];
      if (e.path.length === 0 && e.op === "replace") {
        o = e.value;
        break;
      }
    }
    g > -1 && (i = i.slice(g + 1));
    const E = getPlugin(PluginPatches).applyPatches_;
    return isDraft(o) ? E(o, i) : this.produce(
      o,
      (e) => E(e, i)
    );
  }
};
function createProxy(o, i, g, E) {
  const [e, t] = isMap(i) ? getPlugin(PluginMapSet).proxyMap_(i, g) : isSet(i) ? getPlugin(PluginMapSet).proxySet_(i, g) : createProxyProxy(i, g);
  return (g?.scope_ ?? getCurrentScope()).drafts_.push(e), t.callbacks_ = g?.callbacks_ ?? [], t.key_ = E, g && E !== void 0 ? registerChildFinalizationCallback(g, t, E) : t.callbacks_.push(function(d) {
    d.mapSetPlugin_?.fixSetContents(t);
    const { patchPlugin_: k } = d;
    t.modified_ && k && k.generatePatches_(t, [], d);
  }), e;
}
function current(o) {
  return isDraft(o) || die(10, o), currentImpl(o);
}
function currentImpl(o) {
  if (!isDraftable(o) || isFrozen(o))
    return o;
  const i = o[DRAFT_STATE];
  let g, E = !0;
  if (i) {
    if (!i.modified_)
      return i.base_;
    i.finalized_ = !0, g = shallowCopy(o, i.scope_.immer_.useStrictShallowCopy_), E = i.scope_.immer_.shouldUseStrictIteration();
  } else
    g = shallowCopy(o, !0);
  return each$1(
    g,
    (e, t) => {
      set(g, e, currentImpl(t));
    },
    E
  ), i && (i.finalized_ = !1), g;
}
function enablePatches() {
  process.env.NODE_ENV !== "production" && errors.push(
    'Sets cannot have "replace" patches.',
    function(AA) {
      return "Unsupported patch operation: " + AA;
    },
    function(AA) {
      return "Cannot apply patch, path doesn't resolve: " + AA;
    },
    "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  );
  function i(AA, gA = []) {
    if (AA.key_ !== void 0) {
      const IA = AA.parent_.copy_ ?? AA.parent_.base_, BA = getProxyDraft(get(IA, AA.key_)), CA = get(IA, AA.key_);
      if (CA === void 0 || CA !== AA.draft_ && CA !== AA.base_ && CA !== AA.copy_ || BA != null && BA.base_ !== AA.base_)
        return null;
      const QA = AA.parent_.type_ === 3;
      let iA;
      if (QA) {
        const EA = AA.parent_;
        iA = Array.from(EA.drafts_.keys()).indexOf(AA.key_);
      } else
        iA = AA.key_;
      if (!(QA && IA.size > iA || has$1(IA, iA)))
        return null;
      gA.push(iA);
    }
    if (AA.parent_)
      return i(AA.parent_, gA);
    gA.reverse();
    try {
      g(AA.copy_, gA);
    } catch {
      return null;
    }
    return gA;
  }
  function g(AA, gA) {
    let IA = AA;
    for (let BA = 0; BA < gA.length - 1; BA++) {
      const CA = gA[BA];
      if (IA = get(IA, CA), !isObjectish(IA) || IA === null)
        throw new Error(`Cannot resolve path at '${gA.join("/")}'`);
    }
    return IA;
  }
  const E = "replace", e = "add", t = "remove";
  function n(AA, gA, IA) {
    if (AA.scope_.processedForPatches_.has(AA))
      return;
    AA.scope_.processedForPatches_.add(AA);
    const { patches_: BA, inversePatches_: CA } = IA;
    switch (AA.type_) {
      case 0:
      case 2:
        return d(
          AA,
          gA,
          BA,
          CA
        );
      case 1:
        return h(
          AA,
          gA,
          BA,
          CA
        );
      case 3:
        return k(
          AA,
          gA,
          BA,
          CA
        );
    }
  }
  function h(AA, gA, IA, BA) {
    let { base_: CA, assigned_: QA } = AA, iA = AA.copy_;
    iA.length < CA.length && ([CA, iA] = [iA, CA], [IA, BA] = [BA, IA]);
    const EA = AA.allIndicesReassigned_ === !0;
    for (let oA = 0; oA < CA.length; oA++) {
      const eA = iA[oA], GA = CA[oA];
      if ((EA || QA?.get(oA.toString())) && eA !== GA) {
        const tA = eA?.[DRAFT_STATE];
        if (tA && tA.modified_)
          continue;
        const aA = gA.concat([oA]);
        IA.push({
          op: E,
          path: aA,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: f(eA)
        }), BA.push({
          op: E,
          path: aA,
          value: f(GA)
        });
      }
    }
    for (let oA = CA.length; oA < iA.length; oA++) {
      const eA = gA.concat([oA]);
      IA.push({
        op: e,
        path: eA,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: f(iA[oA])
      });
    }
    for (let oA = iA.length - 1; CA.length <= oA; --oA) {
      const eA = gA.concat([oA]);
      BA.push({
        op: t,
        path: eA
      });
    }
  }
  function d(AA, gA, IA, BA) {
    const { base_: CA, copy_: QA, type_: iA } = AA;
    each$1(AA.assigned_, (EA, oA) => {
      const eA = get(CA, EA, iA), GA = get(QA, EA, iA), cA = oA ? has$1(CA, EA) ? E : e : t;
      if (eA === GA && cA === E)
        return;
      const tA = gA.concat(EA);
      IA.push(
        cA === t ? { op: cA, path: tA } : { op: cA, path: tA, value: f(GA) }
      ), BA.push(
        cA === e ? { op: t, path: tA } : cA === t ? { op: e, path: tA, value: f(eA) } : { op: E, path: tA, value: f(eA) }
      );
    });
  }
  function k(AA, gA, IA, BA) {
    let { base_: CA, copy_: QA } = AA, iA = 0;
    CA.forEach((EA) => {
      if (!QA.has(EA)) {
        const oA = gA.concat([iA]);
        IA.push({
          op: t,
          path: oA,
          value: EA
        }), BA.unshift({
          op: e,
          path: oA,
          value: EA
        });
      }
      iA++;
    }), iA = 0, QA.forEach((EA) => {
      if (!CA.has(EA)) {
        const oA = gA.concat([iA]);
        IA.push({
          op: e,
          path: oA,
          value: EA
        }), BA.unshift({
          op: t,
          path: oA,
          value: EA
        });
      }
      iA++;
    });
  }
  function p(AA, gA, IA) {
    const { patches_: BA, inversePatches_: CA } = IA;
    BA.push({
      op: E,
      path: [],
      value: gA === NOTHING ? void 0 : gA
    }), CA.push({
      op: E,
      path: [],
      value: AA
    });
  }
  function M(AA, gA) {
    return gA.forEach((IA) => {
      const { path: BA, op: CA } = IA;
      let QA = AA;
      for (let eA = 0; eA < BA.length - 1; eA++) {
        const GA = getArchtype(QA);
        let cA = BA[eA];
        typeof cA != "string" && typeof cA != "number" && (cA = "" + cA), (GA === 0 || GA === 1) && (cA === "__proto__" || cA === CONSTRUCTOR) && die(19), isFunction$3(QA) && cA === PROTOTYPE && die(19), QA = get(QA, cA), isObjectish(QA) || die(18, BA.join("/"));
      }
      const iA = getArchtype(QA), EA = H(IA.value), oA = BA[BA.length - 1];
      switch (CA) {
        case E:
          switch (iA) {
            case 2:
              return QA.set(oA, EA);
            case 3:
              die(16);
            default:
              return QA[oA] = EA;
          }
        case e:
          switch (iA) {
            case 1:
              return oA === "-" ? QA.push(EA) : QA.splice(oA, 0, EA);
            case 2:
              return QA.set(oA, EA);
            case 3:
              return QA.add(EA);
            default:
              return QA[oA] = EA;
          }
        case t:
          switch (iA) {
            case 1:
              return QA.splice(oA, 1);
            case 2:
              return QA.delete(oA);
            case 3:
              return QA.delete(IA.value);
            default:
              return delete QA[oA];
          }
        default:
          die(17, CA);
      }
    }), AA;
  }
  function H(AA) {
    if (!isDraftable(AA))
      return AA;
    if (isArray(AA))
      return AA.map(H);
    if (isMap(AA))
      return new Map(
        Array.from(AA.entries()).map(([IA, BA]) => [IA, H(BA)])
      );
    if (isSet(AA))
      return new Set(Array.from(AA).map(H));
    const gA = Object.create(getPrototypeOf(AA));
    for (const IA in AA)
      gA[IA] = H(AA[IA]);
    return has$1(AA, DRAFTABLE) && (gA[DRAFTABLE] = AA[DRAFTABLE]), gA;
  }
  function f(AA) {
    return isDraft(AA) ? H(AA) : AA;
  }
  loadPlugin(PluginPatches, {
    applyPatches_: M,
    generatePatches_: n,
    generateReplacementPatches_: p,
    getPath: i
  });
}
function enableMapSet() {
  class o extends Map {
    constructor(k, p) {
      super(), this[DRAFT_STATE] = {
        type_: 2,
        parent_: p,
        scope_: p ? p.scope_ : getCurrentScope(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        assigned_: void 0,
        base_: k,
        draft_: this,
        isManual_: !1,
        revoked_: !1,
        callbacks_: []
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(k) {
      return latest(this[DRAFT_STATE]).has(k);
    }
    set(k, p) {
      const M = this[DRAFT_STATE];
      return n(M), (!latest(M).has(k) || latest(M).get(k) !== p) && (g(M), markChanged(M), M.assigned_.set(k, !0), M.copy_.set(k, p), M.assigned_.set(k, !0), handleCrossReference(M, k, p)), this;
    }
    delete(k) {
      if (!this.has(k))
        return !1;
      const p = this[DRAFT_STATE];
      return n(p), g(p), markChanged(p), p.base_.has(k) ? p.assigned_.set(k, !1) : p.assigned_.delete(k), p.copy_.delete(k), !0;
    }
    clear() {
      const k = this[DRAFT_STATE];
      n(k), latest(k).size && (g(k), markChanged(k), k.assigned_ = /* @__PURE__ */ new Map(), each$1(k.base_, (p) => {
        k.assigned_.set(p, !1);
      }), k.copy_.clear());
    }
    forEach(k, p) {
      const M = this[DRAFT_STATE];
      latest(M).forEach((H, f, AA) => {
        k.call(p, this.get(f), f, this);
      });
    }
    get(k) {
      const p = this[DRAFT_STATE];
      n(p);
      const M = latest(p).get(k);
      if (p.finalized_ || !isDraftable(M) || M !== p.base_.get(k))
        return M;
      const H = createProxy(p.scope_, M, p, k);
      return g(p), p.copy_.set(k, H), H;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const k = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const p = k.next();
          return p.done ? p : {
            done: !1,
            value: this.get(p.value)
          };
        }
      };
    }
    entries() {
      const k = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const p = k.next();
          if (p.done)
            return p;
          const M = this.get(p.value);
          return {
            done: !1,
            value: [p.value, M]
          };
        }
      };
    }
    [Symbol.iterator]() {
      return this.entries();
    }
  }
  function i(d, k) {
    const p = new o(d, k);
    return [p, p[DRAFT_STATE]];
  }
  function g(d) {
    d.copy_ || (d.assigned_ = /* @__PURE__ */ new Map(), d.copy_ = new Map(d.base_));
  }
  class E extends Set {
    constructor(k, p) {
      super(), this[DRAFT_STATE] = {
        type_: 3,
        parent_: p,
        scope_: p ? p.scope_ : getCurrentScope(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        base_: k,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: !1,
        isManual_: !1,
        assigned_: void 0,
        callbacks_: []
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(k) {
      const p = this[DRAFT_STATE];
      return n(p), p.copy_ ? !!(p.copy_.has(k) || p.drafts_.has(k) && p.copy_.has(p.drafts_.get(k))) : p.base_.has(k);
    }
    add(k) {
      const p = this[DRAFT_STATE];
      return n(p), this.has(k) || (t(p), markChanged(p), p.copy_.add(k), handleCrossReference(p, k, k)), this;
    }
    delete(k) {
      if (!this.has(k))
        return !1;
      const p = this[DRAFT_STATE];
      return n(p), t(p), markChanged(p), p.copy_.delete(k) || (p.drafts_.has(k) ? p.copy_.delete(p.drafts_.get(k)) : (
        /* istanbul ignore next */
        !1
      ));
    }
    clear() {
      const k = this[DRAFT_STATE];
      n(k), latest(k).size && (t(k), markChanged(k), k.copy_.clear());
    }
    values() {
      const k = this[DRAFT_STATE];
      return n(k), t(k), k.copy_.values();
    }
    entries() {
      const k = this[DRAFT_STATE];
      return n(k), t(k), k.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [Symbol.iterator]() {
      return this.values();
    }
    forEach(k, p) {
      const M = this.values();
      let H = M.next();
      for (; !H.done; )
        k.call(p, H.value, H.value, this), H = M.next();
    }
  }
  function e(d, k) {
    const p = new E(d, k);
    return [p, p[DRAFT_STATE]];
  }
  function t(d) {
    d.copy_ || (d.copy_ = /* @__PURE__ */ new Set(), d.base_.forEach((k) => {
      if (isDraftable(k)) {
        const p = createProxy(d.scope_, k, d, k);
        d.drafts_.set(k, p), d.copy_.add(p);
      } else
        d.copy_.add(k);
    }));
  }
  function n(d) {
    d.revoked_ && die(3, JSON.stringify(latest(d)));
  }
  function h(d) {
    if (d.type_ === 3 && d.copy_) {
      const k = new Set(d.copy_);
      d.copy_.clear(), k.forEach((p) => {
        d.copy_.add(getValue(p));
      });
    }
  }
  loadPlugin(PluginMapSet, { proxyMap_: i, proxySet_: e, fixSetContents: h });
}
var immer = new Immer2(), produce = immer.produce, __assign$2 = function() {
  return __assign$2 = Object.assign || function(i) {
    for (var g, E = 1, e = arguments.length; E < e; E++) {
      g = arguments[E];
      for (var t in g) Object.prototype.hasOwnProperty.call(g, t) && (i[t] = g[t]);
    }
    return i;
  }, __assign$2.apply(this, arguments);
};
function __awaiter(o, i, g, E) {
  function e(t) {
    return t instanceof g ? t : new g(function(n) {
      n(t);
    });
  }
  return new (g || (g = Promise))(function(t, n) {
    function h(p) {
      try {
        k(E.next(p));
      } catch (M) {
        n(M);
      }
    }
    function d(p) {
      try {
        k(E.throw(p));
      } catch (M) {
        n(M);
      }
    }
    function k(p) {
      p.done ? t(p.value) : e(p.value).then(h, d);
    }
    k((E = E.apply(o, i || [])).next());
  });
}
function __values(o) {
  var i = typeof Symbol == "function" && Symbol.iterator, g = i && o[i], E = 0;
  if (g) return g.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && E >= o.length && (o = void 0), { value: o && o[E++], done: !o };
    }
  };
  throw new TypeError(i ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await(o) {
  return this instanceof __await ? (this.v = o, this) : new __await(o);
}
function __asyncGenerator(o, i, g) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var E = g.apply(o, i || []), e, t = [];
  return e = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), h("next"), h("throw"), h("return", n), e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
  function n(f) {
    return function(AA) {
      return Promise.resolve(AA).then(f, M);
    };
  }
  function h(f, AA) {
    E[f] && (e[f] = function(gA) {
      return new Promise(function(IA, BA) {
        t.push([f, gA, IA, BA]) > 1 || d(f, gA);
      });
    }, AA && (e[f] = AA(e[f])));
  }
  function d(f, AA) {
    try {
      k(E[f](AA));
    } catch (gA) {
      H(t[0][3], gA);
    }
  }
  function k(f) {
    f.value instanceof __await ? Promise.resolve(f.value.v).then(p, M) : H(t[0][2], f);
  }
  function p(f) {
    d("next", f);
  }
  function M(f) {
    d("throw", f);
  }
  function H(f, AA) {
    f(AA), t.shift(), t.length && d(t[0][0], t[0][1]);
  }
}
function __asyncDelegator(o) {
  var i, g;
  return i = {}, E("next"), E("throw", function(e) {
    throw e;
  }), E("return"), i[Symbol.iterator] = function() {
    return this;
  }, i;
  function E(e, t) {
    i[e] = o[e] ? function(n) {
      return (g = !g) ? { value: __await(o[e](n)), done: !1 } : t ? t(n) : n;
    } : t;
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = o[Symbol.asyncIterator], g;
  return i ? i.call(o) : (o = typeof __values == "function" ? __values(o) : o[Symbol.iterator](), g = {}, E("next"), E("throw"), E("return"), g[Symbol.asyncIterator] = function() {
    return this;
  }, g);
  function E(t) {
    g[t] = o[t] && function(n) {
      return new Promise(function(h, d) {
        n = o[t](n), e(h, d, n.done, n.value);
      });
    };
  }
  function e(t, n, h, d) {
    Promise.resolve(d).then(function(k) {
      t({ value: k, done: h });
    }, n);
  }
}
typeof SuppressedError == "function" && SuppressedError;
const decoder = new TextDecoder("utf-8"), decodeUtf8 = decoder.decode.bind(decoder), encoder = new TextEncoder(), encodeUtf8 = (o) => encoder.encode(o), isNumber = (o) => typeof o == "number", isBoolean = (o) => typeof o == "boolean", isFunction$2 = (o) => typeof o == "function", isObject$2 = (o) => o != null && Object(o) === o, isPromise = (o) => isObject$2(o) && isFunction$2(o.then), isIterable = (o) => isObject$2(o) && isFunction$2(o[Symbol.iterator]), isAsyncIterable$1 = (o) => isObject$2(o) && isFunction$2(o[Symbol.asyncIterator]), isArrowJSON = (o) => isObject$2(o) && isObject$2(o.schema), isIteratorResult = (o) => isObject$2(o) && "done" in o && "value" in o, isFileHandle = (o) => isObject$2(o) && isFunction$2(o.stat) && isNumber(o.fd), isFetchResponse = (o) => isObject$2(o) && isReadableDOMStream(o.body), isReadableInterop = (o) => "_getDOMStream" in o && "_getNodeStream" in o, isReadableDOMStream = (o) => isObject$2(o) && isFunction$2(o.cancel) && isFunction$2(o.getReader) && !isReadableInterop(o), isReadableNodeStream = (o) => isObject$2(o) && isFunction$2(o.read) && isFunction$2(o.pipe) && isBoolean(o.readable) && !isReadableInterop(o), isFlatbuffersByteBuffer = (o) => isObject$2(o) && isFunction$2(o.clear) && isFunction$2(o.bytes) && isFunction$2(o.position) && isFunction$2(o.setPosition) && isFunction$2(o.capacity) && isFunction$2(o.getBufferIdentifier) && isFunction$2(o.createLong), SharedArrayBuf = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : ArrayBuffer;
function collapseContiguousByteRanges(o) {
  const i = o[0] ? [o[0]] : [];
  let g, E, e, t;
  for (let n, h, d = 0, k = 0, p = o.length; ++d < p; ) {
    if (n = i[k], h = o[d], !n || !h || n.buffer !== h.buffer || h.byteOffset < n.byteOffset) {
      h && (i[++k] = h);
      continue;
    }
    if ({ byteOffset: g, byteLength: e } = n, { byteOffset: E, byteLength: t } = h, g + e < E || E + t < g) {
      h && (i[++k] = h);
      continue;
    }
    i[k] = new Uint8Array(n.buffer, g, E - g + t);
  }
  return i;
}
function memcpy(o, i, g = 0, E = i.byteLength) {
  const e = o.byteLength, t = new Uint8Array(o.buffer, o.byteOffset, e), n = new Uint8Array(i.buffer, i.byteOffset, Math.min(E, e));
  return t.set(n, g), o;
}
function joinUint8Arrays(o, i) {
  const g = collapseContiguousByteRanges(o), E = g.reduce((p, M) => p + M.byteLength, 0);
  let e, t, n, h = 0, d = -1;
  const k = Math.min(i || Number.POSITIVE_INFINITY, E);
  for (const p = g.length; ++d < p; ) {
    if (e = g[d], t = e.subarray(0, Math.min(e.length, k - h)), k <= h + t.length) {
      t.length < e.length ? g[d] = e.subarray(t.length) : t.length === e.length && d++, n ? memcpy(n, t, h) : n = t;
      break;
    }
    memcpy(n || (n = new Uint8Array(k)), t, h), h += t.length;
  }
  return [n || new Uint8Array(0), g.slice(d), E - (n ? n.byteLength : 0)];
}
function toArrayBufferView(o, i) {
  let g = isIteratorResult(i) ? i.value : i;
  return g instanceof o ? o === Uint8Array ? new o(g.buffer, g.byteOffset, g.byteLength) : g : g ? (typeof g == "string" && (g = encodeUtf8(g)), g instanceof ArrayBuffer ? new o(g) : g instanceof SharedArrayBuf ? new o(g) : isFlatbuffersByteBuffer(g) ? toArrayBufferView(o, g.bytes()) : ArrayBuffer.isView(g) ? g.byteLength <= 0 ? new o(0) : new o(g.buffer, g.byteOffset, g.byteLength / o.BYTES_PER_ELEMENT) : o.from(g)) : new o(0);
}
const toInt8Array = (o) => toArrayBufferView(Int8Array, o), toInt16Array = (o) => toArrayBufferView(Int16Array, o), toInt32Array = (o) => toArrayBufferView(Int32Array, o), toBigInt64Array = (o) => toArrayBufferView(BigInt64Array, o), toUint8Array = (o) => toArrayBufferView(Uint8Array, o), toUint16Array = (o) => toArrayBufferView(Uint16Array, o), toUint32Array = (o) => toArrayBufferView(Uint32Array, o), toBigUint64Array = (o) => toArrayBufferView(BigUint64Array, o), toFloat32Array = (o) => toArrayBufferView(Float32Array, o), toFloat64Array = (o) => toArrayBufferView(Float64Array, o), toUint8ClampedArray = (o) => toArrayBufferView(Uint8ClampedArray, o), pump$1 = (o) => (o.next(), o);
function* toArrayBufferViewIterator(o, i) {
  const g = function* (e) {
    yield e;
  }, E = typeof i == "string" || ArrayBuffer.isView(i) || i instanceof ArrayBuffer || i instanceof SharedArrayBuf ? g(i) : isIterable(i) ? i : g(i);
  return yield* pump$1((function* (e) {
    let t = null;
    do
      t = e.next(yield toArrayBufferView(o, t));
    while (!t.done);
  })(E[Symbol.iterator]())), new o();
}
const toInt8ArrayIterator = (o) => toArrayBufferViewIterator(Int8Array, o), toInt16ArrayIterator = (o) => toArrayBufferViewIterator(Int16Array, o), toInt32ArrayIterator = (o) => toArrayBufferViewIterator(Int32Array, o), toUint8ArrayIterator = (o) => toArrayBufferViewIterator(Uint8Array, o), toUint16ArrayIterator = (o) => toArrayBufferViewIterator(Uint16Array, o), toUint32ArrayIterator = (o) => toArrayBufferViewIterator(Uint32Array, o), toFloat32ArrayIterator = (o) => toArrayBufferViewIterator(Float32Array, o), toFloat64ArrayIterator = (o) => toArrayBufferViewIterator(Float64Array, o), toUint8ClampedArrayIterator = (o) => toArrayBufferViewIterator(Uint8ClampedArray, o);
function toArrayBufferViewAsyncIterator(o, i) {
  return __asyncGenerator(this, arguments, function* () {
    if (isPromise(i))
      return yield __await(yield __await(yield* __asyncDelegator(__asyncValues(toArrayBufferViewAsyncIterator(o, yield __await(i))))));
    const E = function(n) {
      return __asyncGenerator(this, arguments, function* () {
        yield yield __await(yield __await(n));
      });
    }, e = function(n) {
      return __asyncGenerator(this, arguments, function* () {
        yield __await(yield* __asyncDelegator(__asyncValues(pump$1((function* (h) {
          let d = null;
          do
            d = h.next(yield d?.value);
          while (!d.done);
        })(n[Symbol.iterator]())))));
      });
    }, t = typeof i == "string" || ArrayBuffer.isView(i) || i instanceof ArrayBuffer || i instanceof SharedArrayBuf ? E(i) : isIterable(i) ? e(i) : isAsyncIterable$1(i) ? i : E(i);
    return yield __await(
      // otherwise if AsyncIterable, use it
      yield* __asyncDelegator(__asyncValues(pump$1((function(n) {
        return __asyncGenerator(this, arguments, function* () {
          let h = null;
          do
            h = yield __await(n.next(yield yield __await(toArrayBufferView(o, h))));
          while (!h.done);
        });
      })(t[Symbol.asyncIterator]()))))
    ), yield __await(new o());
  });
}
const toInt8ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Int8Array, o), toInt16ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Int16Array, o), toInt32ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Int32Array, o), toUint8ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Uint8Array, o), toUint16ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Uint16Array, o), toUint32ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Uint32Array, o), toFloat32ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Float32Array, o), toFloat64ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Float64Array, o), toUint8ClampedArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Uint8ClampedArray, o);
function rebaseValueOffsets(o, i, g) {
  if (o !== 0) {
    g = g.slice(0, i);
    for (let E = -1, e = g.length; ++E < e; )
      g[E] += o;
  }
  return g.subarray(0, i);
}
function compareArrayLike(o, i) {
  let g = 0;
  const E = o.length;
  if (E !== i.length)
    return !1;
  if (E > 0)
    do
      if (o[g] !== i[g])
        return !1;
    while (++g < E);
  return !0;
}
const util_buffer_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compareArrayLike,
  joinUint8Arrays,
  memcpy,
  rebaseValueOffsets,
  toArrayBufferView,
  toArrayBufferViewAsyncIterator,
  toArrayBufferViewIterator,
  toBigInt64Array,
  toBigUint64Array,
  toFloat32Array,
  toFloat32ArrayAsyncIterator,
  toFloat32ArrayIterator,
  toFloat64Array,
  toFloat64ArrayAsyncIterator,
  toFloat64ArrayIterator,
  toInt16Array,
  toInt16ArrayAsyncIterator,
  toInt16ArrayIterator,
  toInt32Array,
  toInt32ArrayAsyncIterator,
  toInt32ArrayIterator,
  toInt8Array,
  toInt8ArrayAsyncIterator,
  toInt8ArrayIterator,
  toUint16Array,
  toUint16ArrayAsyncIterator,
  toUint16ArrayIterator,
  toUint32Array,
  toUint32ArrayAsyncIterator,
  toUint32ArrayIterator,
  toUint8Array,
  toUint8ArrayAsyncIterator,
  toUint8ArrayIterator,
  toUint8ClampedArray,
  toUint8ClampedArrayAsyncIterator,
  toUint8ClampedArrayIterator
}, Symbol.toStringTag, { value: "Module" })), streamAdapters = {
  fromIterable(o) {
    return pump(fromIterable(o));
  },
  fromAsyncIterable(o) {
    return pump(fromAsyncIterable(o));
  },
  fromDOMStream(o) {
    return pump(fromDOMStream(o));
  },
  fromNodeStream(o) {
    return pump(fromNodeStream(o));
  },
  // @ts-ignore
  toDOMStream(o, i) {
    throw new Error('"toDOMStream" not available in this environment');
  },
  // @ts-ignore
  toNodeStream(o, i) {
    throw new Error('"toNodeStream" not available in this environment');
  }
}, pump = (o) => (o.next(), o);
function* fromIterable(o) {
  let i, g = !1, E = [], e, t, n, h = 0;
  function d() {
    return t === "peek" ? joinUint8Arrays(E, n)[0] : ([e, E, h] = joinUint8Arrays(E, n), e);
  }
  ({ cmd: t, size: n } = (yield null) || { cmd: "read", size: 0 });
  const k = toUint8ArrayIterator(o)[Symbol.iterator]();
  try {
    do
      if ({ done: i, value: e } = Number.isNaN(n - h) ? k.next() : k.next(n - h), !i && e.byteLength > 0 && (E.push(e), h += e.byteLength), i || n <= h)
        do
          ({ cmd: t, size: n } = yield d());
        while (n < h);
    while (!i);
  } catch (p) {
    g = !0, typeof k.throw == "function" && k.throw(p);
  } finally {
    g === !1 && typeof k.return == "function" && k.return(null);
  }
  return null;
}
function fromAsyncIterable(o) {
  return __asyncGenerator(this, arguments, function* () {
    let g, E = !1, e = [], t, n, h, d = 0;
    function k() {
      return n === "peek" ? joinUint8Arrays(e, h)[0] : ([t, e, d] = joinUint8Arrays(e, h), t);
    }
    ({ cmd: n, size: h } = (yield yield __await(null)) || { cmd: "read", size: 0 });
    const p = toUint8ArrayAsyncIterator(o)[Symbol.asyncIterator]();
    try {
      do
        if ({ done: g, value: t } = Number.isNaN(h - d) ? yield __await(p.next()) : yield __await(p.next(h - d)), !g && t.byteLength > 0 && (e.push(t), d += t.byteLength), g || h <= d)
          do
            ({ cmd: n, size: h } = yield yield __await(k()));
          while (h < d);
      while (!g);
    } catch (M) {
      E = !0, typeof p.throw == "function" && (yield __await(p.throw(M)));
    } finally {
      E === !1 && typeof p.return == "function" && (yield __await(p.return(new Uint8Array(0))));
    }
    return yield __await(null);
  });
}
function fromDOMStream(o) {
  return __asyncGenerator(this, arguments, function* () {
    let g = !1, E = !1, e = [], t, n, h, d = 0;
    function k() {
      return n === "peek" ? joinUint8Arrays(e, h)[0] : ([t, e, d] = joinUint8Arrays(e, h), t);
    }
    ({ cmd: n, size: h } = (yield yield __await(null)) || { cmd: "read", size: 0 });
    const p = new AdaptiveByteReader(o);
    try {
      do
        if ({ done: g, value: t } = Number.isNaN(h - d) ? yield __await(p.read()) : yield __await(p.read(h - d)), !g && t.byteLength > 0 && (e.push(toUint8Array(t)), d += t.byteLength), g || h <= d)
          do
            ({ cmd: n, size: h } = yield yield __await(k()));
          while (h < d);
      while (!g);
    } catch (M) {
      E = !0, yield __await(p.cancel(M));
    } finally {
      E === !1 ? yield __await(p.cancel()) : o.locked && p.releaseLock();
    }
    return yield __await(null);
  });
}
class AdaptiveByteReader {
  constructor(i) {
    this.source = i, this.reader = null, this.reader = this.source.getReader(), this.reader.closed.catch(() => {
    });
  }
  get closed() {
    return this.reader ? this.reader.closed.catch(() => {
    }) : Promise.resolve();
  }
  releaseLock() {
    this.reader && this.reader.releaseLock(), this.reader = null;
  }
  cancel(i) {
    return __awaiter(this, void 0, void 0, function* () {
      const { reader: g, source: E } = this;
      g && (yield g.cancel(i).catch(() => {
      })), E && E.locked && this.releaseLock();
    });
  }
  read(i) {
    return __awaiter(this, void 0, void 0, function* () {
      if (i === 0)
        return { done: this.reader == null, value: new Uint8Array(0) };
      const g = yield this.reader.read();
      return !g.done && (g.value = toUint8Array(g)), g;
    });
  }
}
const onEvent = (o, i) => {
  const g = (e) => E([i, e]);
  let E;
  return [i, g, new Promise((e) => (E = e) && o.once(i, g))];
};
function fromNodeStream(o) {
  return __asyncGenerator(this, arguments, function* () {
    const g = [];
    let E = "error", e = !1, t = null, n, h, d = 0, k = [], p;
    function M() {
      return n === "peek" ? joinUint8Arrays(k, h)[0] : ([p, k, d] = joinUint8Arrays(k, h), p);
    }
    if ({ cmd: n, size: h } = (yield yield __await(null)) || { cmd: "read", size: 0 }, o.isTTY)
      return yield yield __await(new Uint8Array(0)), yield __await(null);
    try {
      g[0] = onEvent(o, "end"), g[1] = onEvent(o, "error");
      do {
        if (g[2] = onEvent(o, "readable"), [E, t] = yield __await(Promise.race(g.map((f) => f[2]))), E === "error")
          break;
        if ((e = E === "end") || (Number.isFinite(h - d) ? (p = toUint8Array(o.read(h - d)), p.byteLength < h - d && (p = toUint8Array(o.read()))) : p = toUint8Array(o.read()), p.byteLength > 0 && (k.push(p), d += p.byteLength)), e || h <= d)
          do
            ({ cmd: n, size: h } = yield yield __await(M()));
          while (h < d);
      } while (!e);
    } finally {
      yield __await(H(g, E === "error" ? t : null));
    }
    return yield __await(null);
    function H(f, AA) {
      return p = k = null, new Promise((gA, IA) => {
        for (const [BA, CA] of f)
          o.off(BA, CA);
        try {
          const BA = o.destroy;
          BA && BA.call(o, AA), AA = void 0;
        } catch (BA) {
          AA = BA || AA;
        } finally {
          AA != null ? IA(AA) : gA();
        }
      });
    }
  });
}
var MetadataVersion;
(function(o) {
  o[o.V1 = 0] = "V1", o[o.V2 = 1] = "V2", o[o.V3 = 2] = "V3", o[o.V4 = 3] = "V4", o[o.V5 = 4] = "V5";
})(MetadataVersion || (MetadataVersion = {}));
var UnionMode;
(function(o) {
  o[o.Sparse = 0] = "Sparse", o[o.Dense = 1] = "Dense";
})(UnionMode || (UnionMode = {}));
var Precision;
(function(o) {
  o[o.HALF = 0] = "HALF", o[o.SINGLE = 1] = "SINGLE", o[o.DOUBLE = 2] = "DOUBLE";
})(Precision || (Precision = {}));
var DateUnit;
(function(o) {
  o[o.DAY = 0] = "DAY", o[o.MILLISECOND = 1] = "MILLISECOND";
})(DateUnit || (DateUnit = {}));
var TimeUnit;
(function(o) {
  o[o.SECOND = 0] = "SECOND", o[o.MILLISECOND = 1] = "MILLISECOND", o[o.MICROSECOND = 2] = "MICROSECOND", o[o.NANOSECOND = 3] = "NANOSECOND";
})(TimeUnit || (TimeUnit = {}));
var IntervalUnit;
(function(o) {
  o[o.YEAR_MONTH = 0] = "YEAR_MONTH", o[o.DAY_TIME = 1] = "DAY_TIME", o[o.MONTH_DAY_NANO = 2] = "MONTH_DAY_NANO";
})(IntervalUnit || (IntervalUnit = {}));
const SIZEOF_SHORT = 2, SIZEOF_INT = 4, FILE_IDENTIFIER_LENGTH = 4, SIZE_PREFIX_LENGTH = 4, int32 = new Int32Array(2), float32 = new Float32Array(int32.buffer), float64 = new Float64Array(int32.buffer), isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var Encoding;
(function(o) {
  o[o.UTF8_BYTES = 1] = "UTF8_BYTES", o[o.UTF16_STRING = 2] = "UTF16_STRING";
})(Encoding || (Encoding = {}));
let ByteBuffer$2 = class lI {
  /**
   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
   */
  constructor(i) {
    this.bytes_ = i, this.position_ = 0, this.text_decoder_ = new TextDecoder();
  }
  /**
   * Create and allocate a new ByteBuffer with a given size.
   */
  static allocate(i) {
    return new lI(new Uint8Array(i));
  }
  clear() {
    this.position_ = 0;
  }
  /**
   * Get the underlying `Uint8Array`.
   */
  bytes() {
    return this.bytes_;
  }
  /**
   * Get the buffer's position.
   */
  position() {
    return this.position_;
  }
  /**
   * Set the buffer's position.
   */
  setPosition(i) {
    this.position_ = i;
  }
  /**
   * Get the buffer's capacity.
   */
  capacity() {
    return this.bytes_.length;
  }
  readInt8(i) {
    return this.readUint8(i) << 24 >> 24;
  }
  readUint8(i) {
    return this.bytes_[i];
  }
  readInt16(i) {
    return this.readUint16(i) << 16 >> 16;
  }
  readUint16(i) {
    return this.bytes_[i] | this.bytes_[i + 1] << 8;
  }
  readInt32(i) {
    return this.bytes_[i] | this.bytes_[i + 1] << 8 | this.bytes_[i + 2] << 16 | this.bytes_[i + 3] << 24;
  }
  readUint32(i) {
    return this.readInt32(i) >>> 0;
  }
  readInt64(i) {
    return BigInt.asIntN(64, BigInt(this.readUint32(i)) + (BigInt(this.readUint32(i + 4)) << BigInt(32)));
  }
  readUint64(i) {
    return BigInt.asUintN(64, BigInt(this.readUint32(i)) + (BigInt(this.readUint32(i + 4)) << BigInt(32)));
  }
  readFloat32(i) {
    return int32[0] = this.readInt32(i), float32[0];
  }
  readFloat64(i) {
    return int32[isLittleEndian ? 0 : 1] = this.readInt32(i), int32[isLittleEndian ? 1 : 0] = this.readInt32(i + 4), float64[0];
  }
  writeInt8(i, g) {
    this.bytes_[i] = g;
  }
  writeUint8(i, g) {
    this.bytes_[i] = g;
  }
  writeInt16(i, g) {
    this.bytes_[i] = g, this.bytes_[i + 1] = g >> 8;
  }
  writeUint16(i, g) {
    this.bytes_[i] = g, this.bytes_[i + 1] = g >> 8;
  }
  writeInt32(i, g) {
    this.bytes_[i] = g, this.bytes_[i + 1] = g >> 8, this.bytes_[i + 2] = g >> 16, this.bytes_[i + 3] = g >> 24;
  }
  writeUint32(i, g) {
    this.bytes_[i] = g, this.bytes_[i + 1] = g >> 8, this.bytes_[i + 2] = g >> 16, this.bytes_[i + 3] = g >> 24;
  }
  writeInt64(i, g) {
    this.writeInt32(i, Number(BigInt.asIntN(32, g))), this.writeInt32(i + 4, Number(BigInt.asIntN(32, g >> BigInt(32))));
  }
  writeUint64(i, g) {
    this.writeUint32(i, Number(BigInt.asUintN(32, g))), this.writeUint32(i + 4, Number(BigInt.asUintN(32, g >> BigInt(32))));
  }
  writeFloat32(i, g) {
    float32[0] = g, this.writeInt32(i, int32[0]);
  }
  writeFloat64(i, g) {
    float64[0] = g, this.writeInt32(i, int32[isLittleEndian ? 0 : 1]), this.writeInt32(i + 4, int32[isLittleEndian ? 1 : 0]);
  }
  /**
   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
   * schema does not include a file_identifier (likely points at padding or the
   * start of a the root vtable).
   */
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH)
      throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    let i = "";
    for (let g = 0; g < FILE_IDENTIFIER_LENGTH; g++)
      i += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + g));
    return i;
  }
  /**
   * Look up a field in the vtable, return an offset into the object, or 0 if the
   * field is not present.
   */
  __offset(i, g) {
    const E = i - this.readInt32(i);
    return g < this.readInt16(E) ? this.readInt16(E + g) : 0;
  }
  /**
   * Initialize any Table-derived type to point to the union at the given offset.
   */
  __union(i, g) {
    return i.bb_pos = g + this.readInt32(g), i.bb = this, i;
  }
  /**
   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
   * This allocates a new string and converts to wide chars upon each access.
   *
   * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
   * "optionalEncoding" argument. This is useful for avoiding conversion when
   * the data will just be packaged back up in another FlatBuffer later on.
   *
   * @param offset
   * @param opt_encoding Defaults to UTF16_STRING
   */
  __string(i, g) {
    i += this.readInt32(i);
    const E = this.readInt32(i);
    i += SIZEOF_INT;
    const e = this.bytes_.subarray(i, i + E);
    return g === Encoding.UTF8_BYTES ? e : this.text_decoder_.decode(e);
  }
  /**
   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
   * if a string then return a new one
   *
   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
   * makes the behaviour of __union_with_string different compared to __union
   */
  __union_with_string(i, g) {
    return typeof i == "string" ? this.__string(g) : this.__union(i, g);
  }
  /**
   * Retrieve the relative offset stored at "offset"
   */
  __indirect(i) {
    return i + this.readInt32(i);
  }
  /**
   * Get the start of data of a vector whose offset is stored at "offset" in this object.
   */
  __vector(i) {
    return i + this.readInt32(i) + SIZEOF_INT;
  }
  /**
   * Get the length of a vector whose offset is stored at "offset" in this object.
   */
  __vector_len(i) {
    return this.readInt32(i + this.readInt32(i));
  }
  __has_identifier(i) {
    if (i.length != FILE_IDENTIFIER_LENGTH)
      throw new Error("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
    for (let g = 0; g < FILE_IDENTIFIER_LENGTH; g++)
      if (i.charCodeAt(g) != this.readInt8(this.position() + SIZEOF_INT + g))
        return !1;
    return !0;
  }
  /**
   * A helper function for generating list for obj api
   */
  createScalarList(i, g) {
    const E = [];
    for (let e = 0; e < g; ++e) {
      const t = i(e);
      t !== null && E.push(t);
    }
    return E;
  }
  /**
   * A helper function for generating list for obj api
   * @param listAccessor function that accepts an index and return data at that index
   * @param listLength listLength
   * @param res result list
   */
  createObjList(i, g) {
    const E = [];
    for (let e = 0; e < g; ++e) {
      const t = i(e);
      t !== null && E.push(t.unpack());
    }
    return E;
  }
}, Builder$2 = class nI {
  /**
   * Create a FlatBufferBuilder.
   */
  constructor(i) {
    this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null, this.text_encoder = new TextEncoder();
    let g;
    i ? g = i : g = 1024, this.bb = ByteBuffer$2.allocate(g), this.space = g;
  }
  clear() {
    this.bb.clear(), this.space = this.bb.capacity(), this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null;
  }
  /**
   * In order to save space, fields that are set to their default value
   * don't get serialized into the buffer. Forcing defaults provides a
   * way to manually disable this optimization.
   *
   * @param forceDefaults true always serializes default values
   */
  forceDefaults(i) {
    this.force_defaults = i;
  }
  /**
   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
   * called finish(). The actual data starts at the ByteBuffer's current position,
   * not necessarily at 0.
   */
  dataBuffer() {
    return this.bb;
  }
  /**
   * Get the bytes representing the FlatBuffer. Only call this after you've
   * called finish().
   */
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  /**
   * Prepare to write an element of `size` after `additional_bytes` have been
   * written, e.g. if you write a string, you need to align such the int length
   * field is aligned to 4 bytes, and the string data follows it directly. If all
   * you need to do is alignment, `additional_bytes` will be 0.
   *
   * @param size This is the of the new element to write
   * @param additional_bytes The padding size
   */
  prep(i, g) {
    i > this.minalign && (this.minalign = i);
    const E = ~(this.bb.capacity() - this.space + g) + 1 & i - 1;
    for (; this.space < E + i + g; ) {
      const e = this.bb.capacity();
      this.bb = nI.growByteBuffer(this.bb), this.space += this.bb.capacity() - e;
    }
    this.pad(E);
  }
  pad(i) {
    for (let g = 0; g < i; g++)
      this.bb.writeInt8(--this.space, 0);
  }
  writeInt8(i) {
    this.bb.writeInt8(this.space -= 1, i);
  }
  writeInt16(i) {
    this.bb.writeInt16(this.space -= 2, i);
  }
  writeInt32(i) {
    this.bb.writeInt32(this.space -= 4, i);
  }
  writeInt64(i) {
    this.bb.writeInt64(this.space -= 8, i);
  }
  writeFloat32(i) {
    this.bb.writeFloat32(this.space -= 4, i);
  }
  writeFloat64(i) {
    this.bb.writeFloat64(this.space -= 8, i);
  }
  /**
   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int8` to add the buffer.
   */
  addInt8(i) {
    this.prep(1, 0), this.writeInt8(i);
  }
  /**
   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int16` to add the buffer.
   */
  addInt16(i) {
    this.prep(2, 0), this.writeInt16(i);
  }
  /**
   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int32` to add the buffer.
   */
  addInt32(i) {
    this.prep(4, 0), this.writeInt32(i);
  }
  /**
   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int64` to add the buffer.
   */
  addInt64(i) {
    this.prep(8, 0), this.writeInt64(i);
  }
  /**
   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float32` to add the buffer.
   */
  addFloat32(i) {
    this.prep(4, 0), this.writeFloat32(i);
  }
  /**
   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float64` to add the buffer.
   */
  addFloat64(i) {
    this.prep(8, 0), this.writeFloat64(i);
  }
  addFieldInt8(i, g, E) {
    (this.force_defaults || g != E) && (this.addInt8(g), this.slot(i));
  }
  addFieldInt16(i, g, E) {
    (this.force_defaults || g != E) && (this.addInt16(g), this.slot(i));
  }
  addFieldInt32(i, g, E) {
    (this.force_defaults || g != E) && (this.addInt32(g), this.slot(i));
  }
  addFieldInt64(i, g, E) {
    (this.force_defaults || g !== E) && (this.addInt64(g), this.slot(i));
  }
  addFieldFloat32(i, g, E) {
    (this.force_defaults || g != E) && (this.addFloat32(g), this.slot(i));
  }
  addFieldFloat64(i, g, E) {
    (this.force_defaults || g != E) && (this.addFloat64(g), this.slot(i));
  }
  addFieldOffset(i, g, E) {
    (this.force_defaults || g != E) && (this.addOffset(g), this.slot(i));
  }
  /**
   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
   */
  addFieldStruct(i, g, E) {
    g != E && (this.nested(g), this.slot(i));
  }
  /**
   * Structures are always stored inline, they need to be created right
   * where they're used.  You'll get this assertion failure if you
   * created it elsewhere.
   */
  nested(i) {
    if (i != this.offset())
      throw new TypeError("FlatBuffers: struct must be serialized inline.");
  }
  /**
   * Should not be creating any other object, string or vector
   * while an object is being constructed
   */
  notNested() {
    if (this.isNested)
      throw new TypeError("FlatBuffers: object serialization must not be nested.");
  }
  /**
   * Set the current vtable at `voffset` to the current location in the buffer.
   */
  slot(i) {
    this.vtable !== null && (this.vtable[i] = this.offset());
  }
  /**
   * @returns Offset relative to the end of the buffer.
   */
  offset() {
    return this.bb.capacity() - this.space;
  }
  /**
   * Doubles the size of the backing ByteBuffer and copies the old data towards
   * the end of the new buffer (since we build the buffer backwards).
   *
   * @param bb The current buffer with the existing data
   * @returns A new byte buffer with the old data copied
   * to it. The data is located at the end of the buffer.
   *
   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
   * it a uint8Array we need to suppress the type check:
   * @suppress {checkTypes}
   */
  static growByteBuffer(i) {
    const g = i.capacity();
    if (g & 3221225472)
      throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    const E = g << 1, e = ByteBuffer$2.allocate(E);
    return e.setPosition(E - g), e.bytes().set(i.bytes(), E - g), e;
  }
  /**
   * Adds on offset, relative to where it will be written.
   *
   * @param offset The offset to add.
   */
  addOffset(i) {
    this.prep(SIZEOF_INT, 0), this.writeInt32(this.offset() - i + SIZEOF_INT);
  }
  /**
   * Start encoding a new object in the buffer.  Users will not usually need to
   * call this directly. The FlatBuffers compiler will generate helper methods
   * that call this method internally.
   */
  startObject(i) {
    this.notNested(), this.vtable == null && (this.vtable = []), this.vtable_in_use = i;
    for (let g = 0; g < i; g++)
      this.vtable[g] = 0;
    this.isNested = !0, this.object_start = this.offset();
  }
  /**
   * Finish off writing the object that is under construction.
   *
   * @returns The offset to the object inside `dataBuffer`
   */
  endObject() {
    if (this.vtable == null || !this.isNested)
      throw new Error("FlatBuffers: endObject called without startObject");
    this.addInt32(0);
    const i = this.offset();
    let g = this.vtable_in_use - 1;
    for (; g >= 0 && this.vtable[g] == 0; g--)
      ;
    const E = g + 1;
    for (; g >= 0; g--)
      this.addInt16(this.vtable[g] != 0 ? i - this.vtable[g] : 0);
    const e = 2;
    this.addInt16(i - this.object_start);
    const t = (E + e) * SIZEOF_SHORT;
    this.addInt16(t);
    let n = 0;
    const h = this.space;
    A: for (g = 0; g < this.vtables.length; g++) {
      const d = this.bb.capacity() - this.vtables[g];
      if (t == this.bb.readInt16(d)) {
        for (let k = SIZEOF_SHORT; k < t; k += SIZEOF_SHORT)
          if (this.bb.readInt16(h + k) != this.bb.readInt16(d + k))
            continue A;
        n = this.vtables[g];
        break;
      }
    }
    return n ? (this.space = this.bb.capacity() - i, this.bb.writeInt32(this.space, n - i)) : (this.vtables.push(this.offset()), this.bb.writeInt32(this.bb.capacity() - i, this.offset() - i)), this.isNested = !1, i;
  }
  /**
   * Finalize a buffer, poiting to the given `root_table`.
   */
  finish(i, g, E) {
    const e = E ? SIZE_PREFIX_LENGTH : 0;
    if (g) {
      const t = g;
      if (this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + e), t.length != FILE_IDENTIFIER_LENGTH)
        throw new TypeError("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
      for (let n = FILE_IDENTIFIER_LENGTH - 1; n >= 0; n--)
        this.writeInt8(t.charCodeAt(n));
    }
    this.prep(this.minalign, SIZEOF_INT + e), this.addOffset(i), e && this.addInt32(this.bb.capacity() - this.space), this.bb.setPosition(this.space);
  }
  /**
   * Finalize a size prefixed buffer, pointing to the given `root_table`.
   */
  finishSizePrefixed(i, g) {
    this.finish(i, g, !0);
  }
  /**
   * This checks a required field has been set in a given table that has
   * just been constructed.
   */
  requiredField(i, g) {
    const E = this.bb.capacity() - i, e = E - this.bb.readInt32(E);
    if (!(g < this.bb.readInt16(e) && this.bb.readInt16(e + g) != 0))
      throw new TypeError("FlatBuffers: field " + g + " must be set");
  }
  /**
   * Start a new array/vector of objects.  Users usually will not call
   * this directly. The FlatBuffers compiler will create a start/end
   * method for vector types in generated code.
   *
   * @param elem_size The size of each element in the array
   * @param num_elems The number of elements in the array
   * @param alignment The alignment of the array
   */
  startVector(i, g, E) {
    this.notNested(), this.vector_num_elems = g, this.prep(SIZEOF_INT, i * g), this.prep(E, i * g);
  }
  /**
   * Finish off the creation of an array and all its elements. The array must be
   * created with `startVector`.
   *
   * @returns The offset at which the newly created array
   * starts.
   */
  endVector() {
    return this.writeInt32(this.vector_num_elems), this.offset();
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If the string passed has
   * already been seen, we return the offset of the already written string
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createSharedString(i) {
    if (!i)
      return 0;
    if (this.string_maps || (this.string_maps = /* @__PURE__ */ new Map()), this.string_maps.has(i))
      return this.string_maps.get(i);
    const g = this.createString(i);
    return this.string_maps.set(i, g), g;
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createString(i) {
    if (i == null)
      return 0;
    let g;
    return i instanceof Uint8Array ? g = i : g = this.text_encoder.encode(i), this.addInt8(0), this.startVector(1, g.length, 1), this.bb.setPosition(this.space -= g.length), this.bb.bytes().set(g, this.space), this.endVector();
  }
  /**
   * Create a byte vector.
   *
   * @param v The bytes to add
   * @returns The offset in the buffer where the byte vector starts
   */
  createByteVector(i) {
    return i == null ? 0 : (this.startVector(1, i.length, 1), this.bb.setPosition(this.space -= i.length), this.bb.bytes().set(i, this.space), this.endVector());
  }
  /**
   * A helper function to pack an object
   *
   * @returns offset of obj
   */
  createObjectOffset(i) {
    return i === null ? 0 : typeof i == "string" ? this.createString(i) : i.pack(this);
  }
  /**
   * A helper function to pack a list of object
   *
   * @returns list of offsets of each non null object
   */
  createObjectOffsetList(i) {
    const g = [];
    for (let E = 0; E < i.length; ++E) {
      const e = i[E];
      if (e !== null)
        g.push(this.createObjectOffset(e));
      else
        throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
    }
    return g;
  }
  createStructOffsetList(i, g) {
    return g(this, i.length), this.createObjectOffsetList(i.slice().reverse()), this.endVector();
  }
};
var BodyCompressionMethod;
(function(o) {
  o[o.BUFFER = 0] = "BUFFER";
})(BodyCompressionMethod || (BodyCompressionMethod = {}));
var CompressionType;
(function(o) {
  o[o.LZ4_FRAME = 0] = "LZ4_FRAME", o[o.ZSTD = 1] = "ZSTD";
})(CompressionType || (CompressionType = {}));
let BodyCompression$1 = class Zg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsBodyCompression(i, g) {
    return (g || new Zg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsBodyCompression(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Zg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  /**
   * Compressor library.
   * For LZ4_FRAME, each compressed buffer must consist of a single frame.
   */
  codec() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt8(this.bb_pos + i) : CompressionType.LZ4_FRAME;
  }
  /**
   * Indicates the way the record batch body was compressed
   */
  method() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.readInt8(this.bb_pos + i) : BodyCompressionMethod.BUFFER;
  }
  static startBodyCompression(i) {
    i.startObject(2);
  }
  static addCodec(i, g) {
    i.addFieldInt8(0, g, CompressionType.LZ4_FRAME);
  }
  static addMethod(i, g) {
    i.addFieldInt8(1, g, BodyCompressionMethod.BUFFER);
  }
  static endBodyCompression(i) {
    return i.endObject();
  }
  static createBodyCompression(i, g, E) {
    return Zg.startBodyCompression(i), Zg.addCodec(i, g), Zg.addMethod(i, E), Zg.endBodyCompression(i);
  }
}, Buffer$1 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  /**
   * The relative offset into the shared memory page where the bytes for this
   * buffer starts
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The absolute length (in bytes) of the memory buffer. The memory is found
   * from offset (inclusive) to offset + length (non-inclusive). When building
   * messages using the encapsulated IPC message, padding bytes may be written
   * after a buffer, but such padding bytes do not need to be accounted for in
   * the size here.
   */
  length() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createBuffer(i, g, E) {
    return i.prep(8, 16), i.writeInt64(BigInt(E ?? 0)), i.writeInt64(BigInt(g ?? 0)), i.offset();
  }
}, FieldNode$1 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  /**
   * The number of value slots in the Arrow array at this level of a nested
   * tree
   */
  length() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The number of observed nulls. Fields with null_count == 0 may choose not
   * to write their physical validity bitmap out as a materialized buffer,
   * instead setting the length of the bitmap buffer to 0.
   */
  nullCount() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createFieldNode(i, g, E) {
    return i.prep(8, 16), i.writeInt64(BigInt(E ?? 0)), i.writeInt64(BigInt(g ?? 0)), i.offset();
  }
}, RecordBatch$3 = class oI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsRecordBatch(i, g) {
    return (g || new oI()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsRecordBatch(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new oI()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  /**
   * number of records / rows. The arrays in the batch should all have this
   * length
   */
  length() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt64(this.bb_pos + i) : BigInt("0");
  }
  /**
   * Nodes correspond to the pre-ordered flattened logical schema
   */
  nodes(i, g) {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? (g || new FieldNode$1()).__init(this.bb.__vector(this.bb_pos + E) + i * 16, this.bb) : null;
  }
  nodesLength() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  /**
   * Buffers correspond to the pre-ordered flattened buffer tree
   *
   * The number of buffers appended to this list depends on the schema. For
   * example, most primitive arrays will have 2 buffers, 1 for the validity
   * bitmap and 1 for the values. For struct arrays, there will only be a
   * single buffer for the validity (nulls) bitmap
   */
  buffers(i, g) {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? (g || new Buffer$1()).__init(this.bb.__vector(this.bb_pos + E) + i * 16, this.bb) : null;
  }
  buffersLength() {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  /**
   * Optional compression of the message body
   */
  compression(i) {
    const g = this.bb.__offset(this.bb_pos, 10);
    return g ? (i || new BodyCompression$1()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  static startRecordBatch(i) {
    i.startObject(4);
  }
  static addLength(i, g) {
    i.addFieldInt64(0, g, BigInt("0"));
  }
  static addNodes(i, g) {
    i.addFieldOffset(1, g, 0);
  }
  static startNodesVector(i, g) {
    i.startVector(16, g, 8);
  }
  static addBuffers(i, g) {
    i.addFieldOffset(2, g, 0);
  }
  static startBuffersVector(i, g) {
    i.startVector(16, g, 8);
  }
  static addCompression(i, g) {
    i.addFieldOffset(3, g, 0);
  }
  static endRecordBatch(i) {
    return i.endObject();
  }
}, DictionaryBatch$1 = class eI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsDictionaryBatch(i, g) {
    return (g || new eI()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsDictionaryBatch(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new eI()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  id() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt64(this.bb_pos + i) : BigInt("0");
  }
  data(i) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? (i || new RecordBatch$3()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  /**
   * If isDelta is true the values in the dictionary are to be appended to a
   * dictionary with the indicated id. If isDelta is false this dictionary
   * should replace the existing dictionary.
   */
  isDelta() {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? !!this.bb.readInt8(this.bb_pos + i) : !1;
  }
  static startDictionaryBatch(i) {
    i.startObject(3);
  }
  static addId(i, g) {
    i.addFieldInt64(0, g, BigInt("0"));
  }
  static addData(i, g) {
    i.addFieldOffset(1, g, 0);
  }
  static addIsDelta(i, g) {
    i.addFieldInt8(2, +g, 0);
  }
  static endDictionaryBatch(i) {
    return i.endObject();
  }
};
var Endianness;
(function(o) {
  o[o.Little = 0] = "Little", o[o.Big = 1] = "Big";
})(Endianness || (Endianness = {}));
var DictionaryKind;
(function(o) {
  o[o.DenseArray = 0] = "DenseArray";
})(DictionaryKind || (DictionaryKind = {}));
class Int {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsInt(i, g) {
    return (g || new Int()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsInt(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Int()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  bitWidth() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt32(this.bb_pos + i) : 0;
  }
  isSigned() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? !!this.bb.readInt8(this.bb_pos + i) : !1;
  }
  static startInt(i) {
    i.startObject(2);
  }
  static addBitWidth(i, g) {
    i.addFieldInt32(0, g, 0);
  }
  static addIsSigned(i, g) {
    i.addFieldInt8(1, +g, 0);
  }
  static endInt(i) {
    return i.endObject();
  }
  static createInt(i, g, E) {
    return Int.startInt(i), Int.addBitWidth(i, g), Int.addIsSigned(i, E), Int.endInt(i);
  }
}
class DictionaryEncoding {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsDictionaryEncoding(i, g) {
    return (g || new DictionaryEncoding()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsDictionaryEncoding(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new DictionaryEncoding()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  /**
   * The known dictionary id in the application where this data is used. In
   * the file or streaming formats, the dictionary ids are found in the
   * DictionaryBatch messages
   */
  id() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt64(this.bb_pos + i) : BigInt("0");
  }
  /**
   * The dictionary indices are constrained to be non-negative integers. If
   * this field is null, the indices must be signed int32. To maximize
   * cross-language compatibility and performance, implementations are
   * recommended to prefer signed integer types over unsigned integer types
   * and to avoid uint64 indices unless they are required by an application.
   */
  indexType(i) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? (i || new Int()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  /**
   * By default, dictionaries are not ordered, or the order does not have
   * semantic meaning. In some statistical, applications, dictionary-encoding
   * is used to represent ordered categorical data, and we provide a way to
   * preserve that metadata here
   */
  isOrdered() {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? !!this.bb.readInt8(this.bb_pos + i) : !1;
  }
  dictionaryKind() {
    const i = this.bb.__offset(this.bb_pos, 10);
    return i ? this.bb.readInt16(this.bb_pos + i) : DictionaryKind.DenseArray;
  }
  static startDictionaryEncoding(i) {
    i.startObject(4);
  }
  static addId(i, g) {
    i.addFieldInt64(0, g, BigInt("0"));
  }
  static addIndexType(i, g) {
    i.addFieldOffset(1, g, 0);
  }
  static addIsOrdered(i, g) {
    i.addFieldInt8(2, +g, 0);
  }
  static addDictionaryKind(i, g) {
    i.addFieldInt16(3, g, DictionaryKind.DenseArray);
  }
  static endDictionaryEncoding(i) {
    return i.endObject();
  }
}
class KeyValue {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsKeyValue(i, g) {
    return (g || new KeyValue()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsKeyValue(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new KeyValue()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  key(i) {
    const g = this.bb.__offset(this.bb_pos, 4);
    return g ? this.bb.__string(this.bb_pos + g, i) : null;
  }
  value(i) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? this.bb.__string(this.bb_pos + g, i) : null;
  }
  static startKeyValue(i) {
    i.startObject(2);
  }
  static addKey(i, g) {
    i.addFieldOffset(0, g, 0);
  }
  static addValue(i, g) {
    i.addFieldOffset(1, g, 0);
  }
  static endKeyValue(i) {
    return i.endObject();
  }
  static createKeyValue(i, g, E) {
    return KeyValue.startKeyValue(i), KeyValue.addKey(i, g), KeyValue.addValue(i, E), KeyValue.endKeyValue(i);
  }
}
let Binary$1 = class jg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsBinary(i, g) {
    return (g || new jg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsBinary(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new jg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static startBinary(i) {
    i.startObject(0);
  }
  static endBinary(i) {
    return i.endObject();
  }
  static createBinary(i) {
    return jg.startBinary(i), jg.endBinary(i);
  }
}, Bool$1 = class Tg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsBool(i, g) {
    return (g || new Tg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsBool(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Tg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static startBool(i) {
    i.startObject(0);
  }
  static endBool(i) {
    return i.endObject();
  }
  static createBool(i) {
    return Tg.startBool(i), Tg.endBool(i);
  }
}, Date$1 = class Kg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsDate(i, g) {
    return (g || new Kg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsDate(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Kg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  unit() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : DateUnit.MILLISECOND;
  }
  static startDate(i) {
    i.startObject(1);
  }
  static addUnit(i, g) {
    i.addFieldInt16(0, g, DateUnit.MILLISECOND);
  }
  static endDate(i) {
    return i.endObject();
  }
  static createDate(i, g) {
    return Kg.startDate(i), Kg.addUnit(i, g), Kg.endDate(i);
  }
}, Decimal$1 = class Sg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsDecimal(i, g) {
    return (g || new Sg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsDecimal(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Sg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  /**
   * Total number of decimal digits
   */
  precision() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt32(this.bb_pos + i) : 0;
  }
  /**
   * Number of digits after the decimal point "."
   */
  scale() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.readInt32(this.bb_pos + i) : 0;
  }
  /**
   * Number of bits per value. The only accepted widths are 128 and 256.
   * We use bitWidth for consistency with Int::bitWidth.
   */
  bitWidth() {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? this.bb.readInt32(this.bb_pos + i) : 128;
  }
  static startDecimal(i) {
    i.startObject(3);
  }
  static addPrecision(i, g) {
    i.addFieldInt32(0, g, 0);
  }
  static addScale(i, g) {
    i.addFieldInt32(1, g, 0);
  }
  static addBitWidth(i, g) {
    i.addFieldInt32(2, g, 128);
  }
  static endDecimal(i) {
    return i.endObject();
  }
  static createDecimal(i, g, E, e) {
    return Sg.startDecimal(i), Sg.addPrecision(i, g), Sg.addScale(i, E), Sg.addBitWidth(i, e), Sg.endDecimal(i);
  }
}, Duration$1 = class xg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsDuration(i, g) {
    return (g || new xg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsDuration(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new xg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  unit() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : TimeUnit.MILLISECOND;
  }
  static startDuration(i) {
    i.startObject(1);
  }
  static addUnit(i, g) {
    i.addFieldInt16(0, g, TimeUnit.MILLISECOND);
  }
  static endDuration(i) {
    return i.endObject();
  }
  static createDuration(i, g) {
    return xg.startDuration(i), xg.addUnit(i, g), xg.endDuration(i);
  }
}, FixedSizeBinary$1 = class fg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsFixedSizeBinary(i, g) {
    return (g || new fg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsFixedSizeBinary(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new fg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  /**
   * Number of bytes per value
   */
  byteWidth() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt32(this.bb_pos + i) : 0;
  }
  static startFixedSizeBinary(i) {
    i.startObject(1);
  }
  static addByteWidth(i, g) {
    i.addFieldInt32(0, g, 0);
  }
  static endFixedSizeBinary(i) {
    return i.endObject();
  }
  static createFixedSizeBinary(i, g) {
    return fg.startFixedSizeBinary(i), fg.addByteWidth(i, g), fg.endFixedSizeBinary(i);
  }
}, FixedSizeList$2 = class Vg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsFixedSizeList(i, g) {
    return (g || new Vg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsFixedSizeList(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Vg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  /**
   * Number of list items per value
   */
  listSize() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt32(this.bb_pos + i) : 0;
  }
  static startFixedSizeList(i) {
    i.startObject(1);
  }
  static addListSize(i, g) {
    i.addFieldInt32(0, g, 0);
  }
  static endFixedSizeList(i) {
    return i.endObject();
  }
  static createFixedSizeList(i, g) {
    return Vg.startFixedSizeList(i), Vg.addListSize(i, g), Vg.endFixedSizeList(i);
  }
};
class FloatingPoint {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsFloatingPoint(i, g) {
    return (g || new FloatingPoint()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsFloatingPoint(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new FloatingPoint()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  precision() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : Precision.HALF;
  }
  static startFloatingPoint(i) {
    i.startObject(1);
  }
  static addPrecision(i, g) {
    i.addFieldInt16(0, g, Precision.HALF);
  }
  static endFloatingPoint(i) {
    return i.endObject();
  }
  static createFloatingPoint(i, g) {
    return FloatingPoint.startFloatingPoint(i), FloatingPoint.addPrecision(i, g), FloatingPoint.endFloatingPoint(i);
  }
}
class Interval {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsInterval(i, g) {
    return (g || new Interval()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsInterval(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Interval()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  unit() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : IntervalUnit.YEAR_MONTH;
  }
  static startInterval(i) {
    i.startObject(1);
  }
  static addUnit(i, g) {
    i.addFieldInt16(0, g, IntervalUnit.YEAR_MONTH);
  }
  static endInterval(i) {
    return i.endObject();
  }
  static createInterval(i, g) {
    return Interval.startInterval(i), Interval.addUnit(i, g), Interval.endInterval(i);
  }
}
let LargeBinary$1 = class Og {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsLargeBinary(i, g) {
    return (g || new Og()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsLargeBinary(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Og()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static startLargeBinary(i) {
    i.startObject(0);
  }
  static endLargeBinary(i) {
    return i.endObject();
  }
  static createLargeBinary(i) {
    return Og.startLargeBinary(i), Og.endLargeBinary(i);
  }
}, LargeUtf8$1 = class zg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsLargeUtf8(i, g) {
    return (g || new zg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsLargeUtf8(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new zg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static startLargeUtf8(i) {
    i.startObject(0);
  }
  static endLargeUtf8(i) {
    return i.endObject();
  }
  static createLargeUtf8(i) {
    return zg.startLargeUtf8(i), zg.endLargeUtf8(i);
  }
}, List$1 = class Pg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsList(i, g) {
    return (g || new Pg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsList(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Pg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static startList(i) {
    i.startObject(0);
  }
  static endList(i) {
    return i.endObject();
  }
  static createList(i) {
    return Pg.startList(i), Pg.endList(i);
  }
}, Map$1 = class Xg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsMap(i, g) {
    return (g || new Xg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsMap(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Xg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  /**
   * Set to true if the keys within each value are sorted
   */
  keysSorted() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? !!this.bb.readInt8(this.bb_pos + i) : !1;
  }
  static startMap(i) {
    i.startObject(1);
  }
  static addKeysSorted(i, g) {
    i.addFieldInt8(0, +g, 0);
  }
  static endMap(i) {
    return i.endObject();
  }
  static createMap(i, g) {
    return Xg.startMap(i), Xg.addKeysSorted(i, g), Xg.endMap(i);
  }
}, Null$1 = class $g {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsNull(i, g) {
    return (g || new $g()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsNull(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new $g()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static startNull(i) {
    i.startObject(0);
  }
  static endNull(i) {
    return i.endObject();
  }
  static createNull(i) {
    return $g.startNull(i), $g.endNull(i);
  }
};
class Struct_ {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsStruct_(i, g) {
    return (g || new Struct_()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsStruct_(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Struct_()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static startStruct_(i) {
    i.startObject(0);
  }
  static endStruct_(i) {
    return i.endObject();
  }
  static createStruct_(i) {
    return Struct_.startStruct_(i), Struct_.endStruct_(i);
  }
}
class Time {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsTime(i, g) {
    return (g || new Time()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsTime(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Time()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  unit() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : TimeUnit.MILLISECOND;
  }
  bitWidth() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.readInt32(this.bb_pos + i) : 32;
  }
  static startTime(i) {
    i.startObject(2);
  }
  static addUnit(i, g) {
    i.addFieldInt16(0, g, TimeUnit.MILLISECOND);
  }
  static addBitWidth(i, g) {
    i.addFieldInt32(1, g, 32);
  }
  static endTime(i) {
    return i.endObject();
  }
  static createTime(i, g, E) {
    return Time.startTime(i), Time.addUnit(i, g), Time.addBitWidth(i, E), Time.endTime(i);
  }
}
class Timestamp {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsTimestamp(i, g) {
    return (g || new Timestamp()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsTimestamp(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Timestamp()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  unit() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : TimeUnit.SECOND;
  }
  timezone(i) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? this.bb.__string(this.bb_pos + g, i) : null;
  }
  static startTimestamp(i) {
    i.startObject(2);
  }
  static addUnit(i, g) {
    i.addFieldInt16(0, g, TimeUnit.SECOND);
  }
  static addTimezone(i, g) {
    i.addFieldOffset(1, g, 0);
  }
  static endTimestamp(i) {
    return i.endObject();
  }
  static createTimestamp(i, g, E) {
    return Timestamp.startTimestamp(i), Timestamp.addUnit(i, g), Timestamp.addTimezone(i, E), Timestamp.endTimestamp(i);
  }
}
class Union {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsUnion(i, g) {
    return (g || new Union()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsUnion(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Union()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  mode() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : UnionMode.Sparse;
  }
  typeIds(i) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? this.bb.readInt32(this.bb.__vector(this.bb_pos + g) + i * 4) : 0;
  }
  typeIdsLength() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  typeIdsArray() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + i), this.bb.__vector_len(this.bb_pos + i)) : null;
  }
  static startUnion(i) {
    i.startObject(2);
  }
  static addMode(i, g) {
    i.addFieldInt16(0, g, UnionMode.Sparse);
  }
  static addTypeIds(i, g) {
    i.addFieldOffset(1, g, 0);
  }
  static createTypeIdsVector(i, g) {
    i.startVector(4, g.length, 4);
    for (let E = g.length - 1; E >= 0; E--)
      i.addInt32(g[E]);
    return i.endVector();
  }
  static startTypeIdsVector(i, g) {
    i.startVector(4, g, 4);
  }
  static endUnion(i) {
    return i.endObject();
  }
  static createUnion(i, g, E) {
    return Union.startUnion(i), Union.addMode(i, g), Union.addTypeIds(i, E), Union.endUnion(i);
  }
}
let Utf8$1 = class AI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsUtf8(i, g) {
    return (g || new AI()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsUtf8(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new AI()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static startUtf8(i) {
    i.startObject(0);
  }
  static endUtf8(i) {
    return i.endObject();
  }
  static createUtf8(i) {
    return AI.startUtf8(i), AI.endUtf8(i);
  }
};
var Type$1;
(function(o) {
  o[o.NONE = 0] = "NONE", o[o.Null = 1] = "Null", o[o.Int = 2] = "Int", o[o.FloatingPoint = 3] = "FloatingPoint", o[o.Binary = 4] = "Binary", o[o.Utf8 = 5] = "Utf8", o[o.Bool = 6] = "Bool", o[o.Decimal = 7] = "Decimal", o[o.Date = 8] = "Date", o[o.Time = 9] = "Time", o[o.Timestamp = 10] = "Timestamp", o[o.Interval = 11] = "Interval", o[o.List = 12] = "List", o[o.Struct_ = 13] = "Struct_", o[o.Union = 14] = "Union", o[o.FixedSizeBinary = 15] = "FixedSizeBinary", o[o.FixedSizeList = 16] = "FixedSizeList", o[o.Map = 17] = "Map", o[o.Duration = 18] = "Duration", o[o.LargeBinary = 19] = "LargeBinary", o[o.LargeUtf8 = 20] = "LargeUtf8", o[o.LargeList = 21] = "LargeList", o[o.RunEndEncoded = 22] = "RunEndEncoded";
})(Type$1 || (Type$1 = {}));
let Field$1 = class EI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsField(i, g) {
    return (g || new EI()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsField(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new EI()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  name(i) {
    const g = this.bb.__offset(this.bb_pos, 4);
    return g ? this.bb.__string(this.bb_pos + g, i) : null;
  }
  /**
   * Whether or not this field can contain nulls. Should be true in general.
   */
  nullable() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? !!this.bb.readInt8(this.bb_pos + i) : !1;
  }
  typeType() {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? this.bb.readUint8(this.bb_pos + i) : Type$1.NONE;
  }
  /**
   * This is the type of the decoded value if the field is dictionary encoded.
   */
  type(i) {
    const g = this.bb.__offset(this.bb_pos, 10);
    return g ? this.bb.__union(i, this.bb_pos + g) : null;
  }
  /**
   * Present only if the field is dictionary encoded.
   */
  dictionary(i) {
    const g = this.bb.__offset(this.bb_pos, 12);
    return g ? (i || new DictionaryEncoding()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  /**
   * children apply only to nested data types like Struct, List and Union. For
   * primitive types children will have length 0.
   */
  children(i, g) {
    const E = this.bb.__offset(this.bb_pos, 14);
    return E ? (g || new EI()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + E) + i * 4), this.bb) : null;
  }
  childrenLength() {
    const i = this.bb.__offset(this.bb_pos, 14);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(i, g) {
    const E = this.bb.__offset(this.bb_pos, 16);
    return E ? (g || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + E) + i * 4), this.bb) : null;
  }
  customMetadataLength() {
    const i = this.bb.__offset(this.bb_pos, 16);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  static startField(i) {
    i.startObject(7);
  }
  static addName(i, g) {
    i.addFieldOffset(0, g, 0);
  }
  static addNullable(i, g) {
    i.addFieldInt8(1, +g, 0);
  }
  static addTypeType(i, g) {
    i.addFieldInt8(2, g, Type$1.NONE);
  }
  static addType(i, g) {
    i.addFieldOffset(3, g, 0);
  }
  static addDictionary(i, g) {
    i.addFieldOffset(4, g, 0);
  }
  static addChildren(i, g) {
    i.addFieldOffset(5, g, 0);
  }
  static createChildrenVector(i, g) {
    i.startVector(4, g.length, 4);
    for (let E = g.length - 1; E >= 0; E--)
      i.addOffset(g[E]);
    return i.endVector();
  }
  static startChildrenVector(i, g) {
    i.startVector(4, g, 4);
  }
  static addCustomMetadata(i, g) {
    i.addFieldOffset(6, g, 0);
  }
  static createCustomMetadataVector(i, g) {
    i.startVector(4, g.length, 4);
    for (let E = g.length - 1; E >= 0; E--)
      i.addOffset(g[E]);
    return i.endVector();
  }
  static startCustomMetadataVector(i, g) {
    i.startVector(4, g, 4);
  }
  static endField(i) {
    return i.endObject();
  }
}, Schema$3 = class Mg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsSchema(i, g) {
    return (g || new Mg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsSchema(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Mg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  /**
   * endianness of the buffer
   * it is Little Endian by default
   * if endianness doesn't match the underlying system then the vectors need to be converted
   */
  endianness() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : Endianness.Little;
  }
  fields(i, g) {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? (g || new Field$1()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + E) + i * 4), this.bb) : null;
  }
  fieldsLength() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  customMetadata(i, g) {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? (g || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + E) + i * 4), this.bb) : null;
  }
  customMetadataLength() {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  /**
   * Features used in the stream/file.
   */
  features(i) {
    const g = this.bb.__offset(this.bb_pos, 10);
    return g ? this.bb.readInt64(this.bb.__vector(this.bb_pos + g) + i * 8) : BigInt(0);
  }
  featuresLength() {
    const i = this.bb.__offset(this.bb_pos, 10);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  static startSchema(i) {
    i.startObject(4);
  }
  static addEndianness(i, g) {
    i.addFieldInt16(0, g, Endianness.Little);
  }
  static addFields(i, g) {
    i.addFieldOffset(1, g, 0);
  }
  static createFieldsVector(i, g) {
    i.startVector(4, g.length, 4);
    for (let E = g.length - 1; E >= 0; E--)
      i.addOffset(g[E]);
    return i.endVector();
  }
  static startFieldsVector(i, g) {
    i.startVector(4, g, 4);
  }
  static addCustomMetadata(i, g) {
    i.addFieldOffset(2, g, 0);
  }
  static createCustomMetadataVector(i, g) {
    i.startVector(4, g.length, 4);
    for (let E = g.length - 1; E >= 0; E--)
      i.addOffset(g[E]);
    return i.endVector();
  }
  static startCustomMetadataVector(i, g) {
    i.startVector(4, g, 4);
  }
  static addFeatures(i, g) {
    i.addFieldOffset(3, g, 0);
  }
  static createFeaturesVector(i, g) {
    i.startVector(8, g.length, 8);
    for (let E = g.length - 1; E >= 0; E--)
      i.addInt64(g[E]);
    return i.endVector();
  }
  static startFeaturesVector(i, g) {
    i.startVector(8, g, 8);
  }
  static endSchema(i) {
    return i.endObject();
  }
  static finishSchemaBuffer(i, g) {
    i.finish(g);
  }
  static finishSizePrefixedSchemaBuffer(i, g) {
    i.finish(g, void 0, !0);
  }
  static createSchema(i, g, E, e, t) {
    return Mg.startSchema(i), Mg.addEndianness(i, g), Mg.addFields(i, E), Mg.addCustomMetadata(i, e), Mg.addFeatures(i, t), Mg.endSchema(i);
  }
};
var MessageHeader;
(function(o) {
  o[o.NONE = 0] = "NONE", o[o.Schema = 1] = "Schema", o[o.DictionaryBatch = 2] = "DictionaryBatch", o[o.RecordBatch = 3] = "RecordBatch", o[o.Tensor = 4] = "Tensor", o[o.SparseTensor = 5] = "SparseTensor";
})(MessageHeader || (MessageHeader = {}));
var Type;
(function(o) {
  o[o.NONE = 0] = "NONE", o[o.Null = 1] = "Null", o[o.Int = 2] = "Int", o[o.Float = 3] = "Float", o[o.Binary = 4] = "Binary", o[o.Utf8 = 5] = "Utf8", o[o.Bool = 6] = "Bool", o[o.Decimal = 7] = "Decimal", o[o.Date = 8] = "Date", o[o.Time = 9] = "Time", o[o.Timestamp = 10] = "Timestamp", o[o.Interval = 11] = "Interval", o[o.List = 12] = "List", o[o.Struct = 13] = "Struct", o[o.Union = 14] = "Union", o[o.FixedSizeBinary = 15] = "FixedSizeBinary", o[o.FixedSizeList = 16] = "FixedSizeList", o[o.Map = 17] = "Map", o[o.Duration = 18] = "Duration", o[o.LargeBinary = 19] = "LargeBinary", o[o.LargeUtf8 = 20] = "LargeUtf8", o[o.Dictionary = -1] = "Dictionary", o[o.Int8 = -2] = "Int8", o[o.Int16 = -3] = "Int16", o[o.Int32 = -4] = "Int32", o[o.Int64 = -5] = "Int64", o[o.Uint8 = -6] = "Uint8", o[o.Uint16 = -7] = "Uint16", o[o.Uint32 = -8] = "Uint32", o[o.Uint64 = -9] = "Uint64", o[o.Float16 = -10] = "Float16", o[o.Float32 = -11] = "Float32", o[o.Float64 = -12] = "Float64", o[o.DateDay = -13] = "DateDay", o[o.DateMillisecond = -14] = "DateMillisecond", o[o.TimestampSecond = -15] = "TimestampSecond", o[o.TimestampMillisecond = -16] = "TimestampMillisecond", o[o.TimestampMicrosecond = -17] = "TimestampMicrosecond", o[o.TimestampNanosecond = -18] = "TimestampNanosecond", o[o.TimeSecond = -19] = "TimeSecond", o[o.TimeMillisecond = -20] = "TimeMillisecond", o[o.TimeMicrosecond = -21] = "TimeMicrosecond", o[o.TimeNanosecond = -22] = "TimeNanosecond", o[o.DenseUnion = -23] = "DenseUnion", o[o.SparseUnion = -24] = "SparseUnion", o[o.IntervalDayTime = -25] = "IntervalDayTime", o[o.IntervalYearMonth = -26] = "IntervalYearMonth", o[o.DurationSecond = -27] = "DurationSecond", o[o.DurationMillisecond = -28] = "DurationMillisecond", o[o.DurationMicrosecond = -29] = "DurationMicrosecond", o[o.DurationNanosecond = -30] = "DurationNanosecond", o[o.IntervalMonthDayNano = -31] = "IntervalMonthDayNano";
})(Type || (Type = {}));
var BufferType;
(function(o) {
  o[o.OFFSET = 0] = "OFFSET", o[o.DATA = 1] = "DATA", o[o.VALIDITY = 2] = "VALIDITY", o[o.TYPE = 3] = "TYPE";
})(BufferType || (BufferType = {}));
const undf = void 0;
function valueToString(o) {
  if (o === null)
    return "null";
  if (o === undf)
    return "undefined";
  switch (typeof o) {
    case "number":
      return `${o}`;
    case "bigint":
      return `${o}`;
    case "string":
      return `"${o}"`;
  }
  return typeof o[Symbol.toPrimitive] == "function" ? o[Symbol.toPrimitive]("string") : ArrayBuffer.isView(o) ? o instanceof BigInt64Array || o instanceof BigUint64Array ? `[${[...o].map((i) => valueToString(i))}]` : `[${o}]` : ArrayBuffer.isView(o) ? `[${o}]` : JSON.stringify(o, (i, g) => typeof g == "bigint" ? `${g}` : g);
}
const util_pretty_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  valueToString
}, Symbol.toStringTag, { value: "Module" }));
function bigIntToNumber(o) {
  if (typeof o == "bigint" && (o < Number.MIN_SAFE_INTEGER || o > Number.MAX_SAFE_INTEGER))
    throw new TypeError(`${o} is not safe to convert to a number.`);
  return Number(o);
}
function divideBigInts(o, i) {
  return bigIntToNumber(o / i) + bigIntToNumber(o % i) / bigIntToNumber(i);
}
const isArrowBigNumSymbol = Symbol.for("isArrowBigNum");
function BigNum(o, ...i) {
  return i.length === 0 ? Object.setPrototypeOf(toArrayBufferView(this.TypedArray, o), this.constructor.prototype) : Object.setPrototypeOf(new this.TypedArray(o, ...i), this.constructor.prototype);
}
BigNum.prototype[isArrowBigNumSymbol] = !0;
BigNum.prototype.toJSON = function() {
  return `"${bigNumToString(this)}"`;
};
BigNum.prototype.valueOf = function(o) {
  return bigNumToNumber(this, o);
};
BigNum.prototype.toString = function() {
  return bigNumToString(this);
};
BigNum.prototype[Symbol.toPrimitive] = function(o = "default") {
  switch (o) {
    case "number":
      return bigNumToNumber(this);
    case "string":
      return bigNumToString(this);
    case "default":
      return bigNumToBigInt(this);
  }
  return bigNumToString(this);
};
function SignedBigNum(...o) {
  return BigNum.apply(this, o);
}
function UnsignedBigNum(...o) {
  return BigNum.apply(this, o);
}
function DecimalBigNum(...o) {
  return BigNum.apply(this, o);
}
Object.setPrototypeOf(SignedBigNum.prototype, Object.create(Int32Array.prototype));
Object.setPrototypeOf(UnsignedBigNum.prototype, Object.create(Uint32Array.prototype));
Object.setPrototypeOf(DecimalBigNum.prototype, Object.create(Uint32Array.prototype));
Object.assign(SignedBigNum.prototype, BigNum.prototype, { constructor: SignedBigNum, signed: !0, TypedArray: Int32Array, BigIntArray: BigInt64Array });
Object.assign(UnsignedBigNum.prototype, BigNum.prototype, { constructor: UnsignedBigNum, signed: !1, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
Object.assign(DecimalBigNum.prototype, BigNum.prototype, { constructor: DecimalBigNum, signed: !0, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
const TWO_TO_THE_64 = BigInt(4294967296) * BigInt(4294967296), TWO_TO_THE_64_MINUS_1 = TWO_TO_THE_64 - BigInt(1);
function bigNumToNumber(o, i) {
  const { buffer: g, byteOffset: E, byteLength: e, signed: t } = o, n = new BigUint64Array(g, E, e / 8), h = t && n.at(-1) & BigInt(1) << BigInt(63);
  let d = BigInt(0), k = 0;
  if (h) {
    for (const p of n)
      d |= (p ^ TWO_TO_THE_64_MINUS_1) * (BigInt(1) << BigInt(64 * k++));
    d *= BigInt(-1), d -= BigInt(1);
  } else
    for (const p of n)
      d |= p * (BigInt(1) << BigInt(64 * k++));
  if (typeof i == "number" && i > 0) {
    const p = BigInt("1".padEnd(i + 1, "0")), M = d / p, H = h ? -(d % p) : d % p, f = bigIntToNumber(M), AA = `${H}`.padStart(i, "0");
    return +`${h && f === 0 ? "-" : ""}${f}.${AA}`;
  }
  return bigIntToNumber(d);
}
function bigNumToString(o) {
  if (o.byteLength === 8)
    return `${new o.BigIntArray(o.buffer, o.byteOffset, 1)[0]}`;
  if (!o.signed)
    return unsignedBigNumToString(o);
  let i = new Uint16Array(o.buffer, o.byteOffset, o.byteLength / 2);
  if (new Int16Array([i.at(-1)])[0] >= 0)
    return unsignedBigNumToString(o);
  i = i.slice();
  let E = 1;
  for (let t = 0; t < i.length; t++) {
    const n = i[t], h = ~n + E;
    i[t] = h, E &= n === 0 ? 1 : 0;
  }
  return `-${unsignedBigNumToString(i)}`;
}
function bigNumToBigInt(o) {
  return o.byteLength === 8 ? new o.BigIntArray(o.buffer, o.byteOffset, 1)[0] : bigNumToString(o);
}
function unsignedBigNumToString(o) {
  let i = "";
  const g = new Uint32Array(2);
  let E = new Uint16Array(o.buffer, o.byteOffset, o.byteLength / 2);
  const e = new Uint32Array((E = new Uint16Array(E).reverse()).buffer);
  let t = -1;
  const n = E.length - 1;
  do {
    for (g[0] = E[t = 0]; t < n; )
      E[t++] = g[1] = g[0] / 10, g[0] = (g[0] - g[1] * 10 << 16) + E[t];
    E[t] = g[1] = g[0] / 10, g[0] = g[0] - g[1] * 10, i = `${g[0]}${i}`;
  } while (e[0] || e[1] || e[2] || e[3]);
  return i ?? "0";
}
class BN {
  /** @nocollapse */
  static new(i, g) {
    switch (g) {
      case !0:
        return new SignedBigNum(i);
      case !1:
        return new UnsignedBigNum(i);
    }
    switch (i.constructor) {
      case Int8Array:
      case Int16Array:
      case Int32Array:
      case BigInt64Array:
        return new SignedBigNum(i);
    }
    return i.byteLength === 16 ? new DecimalBigNum(i) : new UnsignedBigNum(i);
  }
  /** @nocollapse */
  static signed(i) {
    return new SignedBigNum(i);
  }
  /** @nocollapse */
  static unsigned(i) {
    return new UnsignedBigNum(i);
  }
  /** @nocollapse */
  static decimal(i) {
    return new DecimalBigNum(i);
  }
  constructor(i, g) {
    return BN.new(i, g);
  }
}
const util_bn_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BN,
  bigNumToBigInt,
  bigNumToNumber,
  bigNumToString,
  isArrowBigNumSymbol
}, Symbol.toStringTag, { value: "Module" }));
var _a$4, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o$1, _p, _q, _r, _s, _t$1, _u, _v, _w, _x;
class DataType {
  /** @nocollapse */
  static isNull(i) {
    return i?.typeId === Type.Null;
  }
  /** @nocollapse */
  static isInt(i) {
    return i?.typeId === Type.Int;
  }
  /** @nocollapse */
  static isFloat(i) {
    return i?.typeId === Type.Float;
  }
  /** @nocollapse */
  static isBinary(i) {
    return i?.typeId === Type.Binary;
  }
  /** @nocollapse */
  static isLargeBinary(i) {
    return i?.typeId === Type.LargeBinary;
  }
  /** @nocollapse */
  static isUtf8(i) {
    return i?.typeId === Type.Utf8;
  }
  /** @nocollapse */
  static isLargeUtf8(i) {
    return i?.typeId === Type.LargeUtf8;
  }
  /** @nocollapse */
  static isBool(i) {
    return i?.typeId === Type.Bool;
  }
  /** @nocollapse */
  static isDecimal(i) {
    return i?.typeId === Type.Decimal;
  }
  /** @nocollapse */
  static isDate(i) {
    return i?.typeId === Type.Date;
  }
  /** @nocollapse */
  static isTime(i) {
    return i?.typeId === Type.Time;
  }
  /** @nocollapse */
  static isTimestamp(i) {
    return i?.typeId === Type.Timestamp;
  }
  /** @nocollapse */
  static isInterval(i) {
    return i?.typeId === Type.Interval;
  }
  /** @nocollapse */
  static isDuration(i) {
    return i?.typeId === Type.Duration;
  }
  /** @nocollapse */
  static isList(i) {
    return i?.typeId === Type.List;
  }
  /** @nocollapse */
  static isStruct(i) {
    return i?.typeId === Type.Struct;
  }
  /** @nocollapse */
  static isUnion(i) {
    return i?.typeId === Type.Union;
  }
  /** @nocollapse */
  static isFixedSizeBinary(i) {
    return i?.typeId === Type.FixedSizeBinary;
  }
  /** @nocollapse */
  static isFixedSizeList(i) {
    return i?.typeId === Type.FixedSizeList;
  }
  /** @nocollapse */
  static isMap(i) {
    return i?.typeId === Type.Map;
  }
  /** @nocollapse */
  static isDictionary(i) {
    return i?.typeId === Type.Dictionary;
  }
  /** @nocollapse */
  static isDenseUnion(i) {
    return DataType.isUnion(i) && i.mode === UnionMode.Dense;
  }
  /** @nocollapse */
  static isSparseUnion(i) {
    return DataType.isUnion(i) && i.mode === UnionMode.Sparse;
  }
  constructor(i) {
    this.typeId = i;
  }
}
_a$4 = Symbol.toStringTag;
DataType[_a$4] = ((o) => (o.children = null, o.ArrayType = Array, o.OffsetArrayType = Int32Array, o[Symbol.toStringTag] = "DataType"))(DataType.prototype);
class Null extends DataType {
  constructor() {
    super(Type.Null);
  }
  toString() {
    return "Null";
  }
}
_b = Symbol.toStringTag;
Null[_b] = ((o) => o[Symbol.toStringTag] = "Null")(Null.prototype);
class Int_ extends DataType {
  constructor(i, g) {
    super(Type.Int), this.isSigned = i, this.bitWidth = g;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 8:
        return this.isSigned ? Int8Array : Uint8Array;
      case 16:
        return this.isSigned ? Int16Array : Uint16Array;
      case 32:
        return this.isSigned ? Int32Array : Uint32Array;
      case 64:
        return this.isSigned ? BigInt64Array : BigUint64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `${this.isSigned ? "I" : "Ui"}nt${this.bitWidth}`;
  }
}
_c = Symbol.toStringTag;
Int_[_c] = ((o) => (o.isSigned = null, o.bitWidth = null, o[Symbol.toStringTag] = "Int"))(Int_.prototype);
class Int32 extends Int_ {
  constructor() {
    super(!0, 32);
  }
  get ArrayType() {
    return Int32Array;
  }
}
Object.defineProperty(Int32.prototype, "ArrayType", { value: Int32Array });
class Float extends DataType {
  constructor(i) {
    super(Type.Float), this.precision = i;
  }
  get ArrayType() {
    switch (this.precision) {
      case Precision.HALF:
        return Uint16Array;
      case Precision.SINGLE:
        return Float32Array;
      case Precision.DOUBLE:
        return Float64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `Float${this.precision << 5 || 16}`;
  }
}
_d = Symbol.toStringTag;
Float[_d] = ((o) => (o.precision = null, o[Symbol.toStringTag] = "Float"))(Float.prototype);
class Binary extends DataType {
  constructor() {
    super(Type.Binary);
  }
  toString() {
    return "Binary";
  }
}
_e = Symbol.toStringTag;
Binary[_e] = ((o) => (o.ArrayType = Uint8Array, o[Symbol.toStringTag] = "Binary"))(Binary.prototype);
class LargeBinary extends DataType {
  constructor() {
    super(Type.LargeBinary);
  }
  toString() {
    return "LargeBinary";
  }
}
_f = Symbol.toStringTag;
LargeBinary[_f] = ((o) => (o.ArrayType = Uint8Array, o.OffsetArrayType = BigInt64Array, o[Symbol.toStringTag] = "LargeBinary"))(LargeBinary.prototype);
class Utf8 extends DataType {
  constructor() {
    super(Type.Utf8);
  }
  toString() {
    return "Utf8";
  }
}
_g = Symbol.toStringTag;
Utf8[_g] = ((o) => (o.ArrayType = Uint8Array, o[Symbol.toStringTag] = "Utf8"))(Utf8.prototype);
class LargeUtf8 extends DataType {
  constructor() {
    super(Type.LargeUtf8);
  }
  toString() {
    return "LargeUtf8";
  }
}
_h = Symbol.toStringTag;
LargeUtf8[_h] = ((o) => (o.ArrayType = Uint8Array, o.OffsetArrayType = BigInt64Array, o[Symbol.toStringTag] = "LargeUtf8"))(LargeUtf8.prototype);
class Bool extends DataType {
  constructor() {
    super(Type.Bool);
  }
  toString() {
    return "Bool";
  }
}
_j = Symbol.toStringTag;
Bool[_j] = ((o) => (o.ArrayType = Uint8Array, o[Symbol.toStringTag] = "Bool"))(Bool.prototype);
class Decimal extends DataType {
  constructor(i, g, E = 128) {
    super(Type.Decimal), this.scale = i, this.precision = g, this.bitWidth = E;
  }
  toString() {
    return `Decimal[${this.precision}e${this.scale > 0 ? "+" : ""}${this.scale}]`;
  }
}
_k = Symbol.toStringTag;
Decimal[_k] = ((o) => (o.scale = null, o.precision = null, o.ArrayType = Uint32Array, o[Symbol.toStringTag] = "Decimal"))(Decimal.prototype);
class Date_ extends DataType {
  constructor(i) {
    super(Type.Date), this.unit = i;
  }
  toString() {
    return `Date${(this.unit + 1) * 32}<${DateUnit[this.unit]}>`;
  }
  get ArrayType() {
    return this.unit === DateUnit.DAY ? Int32Array : BigInt64Array;
  }
}
_l = Symbol.toStringTag;
Date_[_l] = ((o) => (o.unit = null, o[Symbol.toStringTag] = "Date"))(Date_.prototype);
class Time_ extends DataType {
  constructor(i, g) {
    super(Type.Time), this.unit = i, this.bitWidth = g;
  }
  toString() {
    return `Time${this.bitWidth}<${TimeUnit[this.unit]}>`;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 32:
        return Int32Array;
      case 64:
        return BigInt64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
}
_m = Symbol.toStringTag;
Time_[_m] = ((o) => (o.unit = null, o.bitWidth = null, o[Symbol.toStringTag] = "Time"))(Time_.prototype);
class Timestamp_ extends DataType {
  constructor(i, g) {
    super(Type.Timestamp), this.unit = i, this.timezone = g;
  }
  toString() {
    return `Timestamp<${TimeUnit[this.unit]}${this.timezone ? `, ${this.timezone}` : ""}>`;
  }
}
_o$1 = Symbol.toStringTag;
Timestamp_[_o$1] = ((o) => (o.unit = null, o.timezone = null, o.ArrayType = BigInt64Array, o[Symbol.toStringTag] = "Timestamp"))(Timestamp_.prototype);
class Interval_ extends DataType {
  constructor(i) {
    super(Type.Interval), this.unit = i;
  }
  toString() {
    return `Interval<${IntervalUnit[this.unit]}>`;
  }
}
_p = Symbol.toStringTag;
Interval_[_p] = ((o) => (o.unit = null, o.ArrayType = Int32Array, o[Symbol.toStringTag] = "Interval"))(Interval_.prototype);
class Duration extends DataType {
  constructor(i) {
    super(Type.Duration), this.unit = i;
  }
  toString() {
    return `Duration<${TimeUnit[this.unit]}>`;
  }
}
_q = Symbol.toStringTag;
Duration[_q] = ((o) => (o.unit = null, o.ArrayType = BigInt64Array, o[Symbol.toStringTag] = "Duration"))(Duration.prototype);
class List extends DataType {
  constructor(i) {
    super(Type.List), this.children = [i];
  }
  toString() {
    return `List<${this.valueType}>`;
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
}
_r = Symbol.toStringTag;
List[_r] = ((o) => (o.children = null, o[Symbol.toStringTag] = "List"))(List.prototype);
class Struct extends DataType {
  constructor(i) {
    super(Type.Struct), this.children = i;
  }
  toString() {
    return `Struct<{${this.children.map((i) => `${i.name}:${i.type}`).join(", ")}}>`;
  }
}
_s = Symbol.toStringTag;
Struct[_s] = ((o) => (o.children = null, o[Symbol.toStringTag] = "Struct"))(Struct.prototype);
class Union_ extends DataType {
  constructor(i, g, E) {
    super(Type.Union), this.mode = i, this.children = E, this.typeIds = g = Int32Array.from(g), this.typeIdToChildIndex = g.reduce((e, t, n) => (e[t] = n) && e || e, /* @__PURE__ */ Object.create(null));
  }
  toString() {
    return `${this[Symbol.toStringTag]}<${this.children.map((i) => `${i.type}`).join(" | ")}>`;
  }
}
_t$1 = Symbol.toStringTag;
Union_[_t$1] = ((o) => (o.mode = null, o.typeIds = null, o.children = null, o.typeIdToChildIndex = null, o.ArrayType = Int8Array, o[Symbol.toStringTag] = "Union"))(Union_.prototype);
class FixedSizeBinary extends DataType {
  constructor(i) {
    super(Type.FixedSizeBinary), this.byteWidth = i;
  }
  toString() {
    return `FixedSizeBinary[${this.byteWidth}]`;
  }
}
_u = Symbol.toStringTag;
FixedSizeBinary[_u] = ((o) => (o.byteWidth = null, o.ArrayType = Uint8Array, o[Symbol.toStringTag] = "FixedSizeBinary"))(FixedSizeBinary.prototype);
let FixedSizeList$1 = class extends DataType {
  constructor(i, g) {
    super(Type.FixedSizeList), this.listSize = i, this.children = [g];
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
  toString() {
    return `FixedSizeList[${this.listSize}]<${this.valueType}>`;
  }
};
_v = Symbol.toStringTag;
FixedSizeList$1[_v] = ((o) => (o.children = null, o.listSize = null, o[Symbol.toStringTag] = "FixedSizeList"))(FixedSizeList$1.prototype);
class Map_ extends DataType {
  constructor(i, g = !1) {
    var E, e, t;
    if (super(Type.Map), this.children = [i], this.keysSorted = g, i && (i.name = "entries", !((E = i?.type) === null || E === void 0) && E.children)) {
      const n = (e = i?.type) === null || e === void 0 ? void 0 : e.children[0];
      n && (n.name = "key");
      const h = (t = i?.type) === null || t === void 0 ? void 0 : t.children[1];
      h && (h.name = "value");
    }
  }
  get keyType() {
    return this.children[0].type.children[0].type;
  }
  get valueType() {
    return this.children[0].type.children[1].type;
  }
  get childType() {
    return this.children[0].type;
  }
  toString() {
    return `Map<{${this.children[0].type.children.map((i) => `${i.name}:${i.type}`).join(", ")}}>`;
  }
}
_w = Symbol.toStringTag;
Map_[_w] = ((o) => (o.children = null, o.keysSorted = null, o[Symbol.toStringTag] = "Map_"))(Map_.prototype);
const getId$1 = /* @__PURE__ */ ((o) => () => ++o)(-1);
class Dictionary extends DataType {
  constructor(i, g, E, e) {
    super(Type.Dictionary), this.indices = g, this.dictionary = i, this.isOrdered = e || !1, this.id = E == null ? getId$1() : bigIntToNumber(E);
  }
  get children() {
    return this.dictionary.children;
  }
  get valueType() {
    return this.dictionary;
  }
  get ArrayType() {
    return this.dictionary.ArrayType;
  }
  toString() {
    return `Dictionary<${this.indices}, ${this.dictionary}>`;
  }
}
_x = Symbol.toStringTag;
Dictionary[_x] = ((o) => (o.id = null, o.indices = null, o.isOrdered = null, o.dictionary = null, o[Symbol.toStringTag] = "Dictionary"))(Dictionary.prototype);
function strideForType(o) {
  const i = o;
  switch (o.typeId) {
    case Type.Decimal:
      return o.bitWidth / 32;
    case Type.Interval:
      return i.unit === IntervalUnit.MONTH_DAY_NANO ? 4 : 1 + i.unit;
    // case Type.Int: return 1 + +((t as Int_).bitWidth > 32);
    // case Type.Time: return 1 + +((t as Time_).bitWidth > 32);
    case Type.FixedSizeList:
      return i.listSize;
    case Type.FixedSizeBinary:
      return i.byteWidth;
    default:
      return 1;
  }
}
class Visitor {
  visitMany(i, ...g) {
    return i.map((E, e) => this.visit(E, ...g.map((t) => t[e])));
  }
  visit(...i) {
    return this.getVisitFn(i[0], !1).apply(this, i);
  }
  getVisitFn(i, g = !0) {
    return getVisitFn(this, i, g);
  }
  getVisitFnByTypeId(i, g = !0) {
    return getVisitFnByTypeId(this, i, g);
  }
  visitNull(i, ...g) {
    return null;
  }
  visitBool(i, ...g) {
    return null;
  }
  visitInt(i, ...g) {
    return null;
  }
  visitFloat(i, ...g) {
    return null;
  }
  visitUtf8(i, ...g) {
    return null;
  }
  visitLargeUtf8(i, ...g) {
    return null;
  }
  visitBinary(i, ...g) {
    return null;
  }
  visitLargeBinary(i, ...g) {
    return null;
  }
  visitFixedSizeBinary(i, ...g) {
    return null;
  }
  visitDate(i, ...g) {
    return null;
  }
  visitTimestamp(i, ...g) {
    return null;
  }
  visitTime(i, ...g) {
    return null;
  }
  visitDecimal(i, ...g) {
    return null;
  }
  visitList(i, ...g) {
    return null;
  }
  visitStruct(i, ...g) {
    return null;
  }
  visitUnion(i, ...g) {
    return null;
  }
  visitDictionary(i, ...g) {
    return null;
  }
  visitInterval(i, ...g) {
    return null;
  }
  visitDuration(i, ...g) {
    return null;
  }
  visitFixedSizeList(i, ...g) {
    return null;
  }
  visitMap(i, ...g) {
    return null;
  }
}
function getVisitFn(o, i, g = !0) {
  return typeof i == "number" ? getVisitFnByTypeId(o, i, g) : typeof i == "string" && i in Type ? getVisitFnByTypeId(o, Type[i], g) : i && i instanceof DataType ? getVisitFnByTypeId(o, inferDType(i), g) : i?.type && i.type instanceof DataType ? getVisitFnByTypeId(o, inferDType(i.type), g) : getVisitFnByTypeId(o, Type.NONE, g);
}
function getVisitFnByTypeId(o, i, g = !0) {
  let E = null;
  switch (i) {
    case Type.Null:
      E = o.visitNull;
      break;
    case Type.Bool:
      E = o.visitBool;
      break;
    case Type.Int:
      E = o.visitInt;
      break;
    case Type.Int8:
      E = o.visitInt8 || o.visitInt;
      break;
    case Type.Int16:
      E = o.visitInt16 || o.visitInt;
      break;
    case Type.Int32:
      E = o.visitInt32 || o.visitInt;
      break;
    case Type.Int64:
      E = o.visitInt64 || o.visitInt;
      break;
    case Type.Uint8:
      E = o.visitUint8 || o.visitInt;
      break;
    case Type.Uint16:
      E = o.visitUint16 || o.visitInt;
      break;
    case Type.Uint32:
      E = o.visitUint32 || o.visitInt;
      break;
    case Type.Uint64:
      E = o.visitUint64 || o.visitInt;
      break;
    case Type.Float:
      E = o.visitFloat;
      break;
    case Type.Float16:
      E = o.visitFloat16 || o.visitFloat;
      break;
    case Type.Float32:
      E = o.visitFloat32 || o.visitFloat;
      break;
    case Type.Float64:
      E = o.visitFloat64 || o.visitFloat;
      break;
    case Type.Utf8:
      E = o.visitUtf8;
      break;
    case Type.LargeUtf8:
      E = o.visitLargeUtf8;
      break;
    case Type.Binary:
      E = o.visitBinary;
      break;
    case Type.LargeBinary:
      E = o.visitLargeBinary;
      break;
    case Type.FixedSizeBinary:
      E = o.visitFixedSizeBinary;
      break;
    case Type.Date:
      E = o.visitDate;
      break;
    case Type.DateDay:
      E = o.visitDateDay || o.visitDate;
      break;
    case Type.DateMillisecond:
      E = o.visitDateMillisecond || o.visitDate;
      break;
    case Type.Timestamp:
      E = o.visitTimestamp;
      break;
    case Type.TimestampSecond:
      E = o.visitTimestampSecond || o.visitTimestamp;
      break;
    case Type.TimestampMillisecond:
      E = o.visitTimestampMillisecond || o.visitTimestamp;
      break;
    case Type.TimestampMicrosecond:
      E = o.visitTimestampMicrosecond || o.visitTimestamp;
      break;
    case Type.TimestampNanosecond:
      E = o.visitTimestampNanosecond || o.visitTimestamp;
      break;
    case Type.Time:
      E = o.visitTime;
      break;
    case Type.TimeSecond:
      E = o.visitTimeSecond || o.visitTime;
      break;
    case Type.TimeMillisecond:
      E = o.visitTimeMillisecond || o.visitTime;
      break;
    case Type.TimeMicrosecond:
      E = o.visitTimeMicrosecond || o.visitTime;
      break;
    case Type.TimeNanosecond:
      E = o.visitTimeNanosecond || o.visitTime;
      break;
    case Type.Decimal:
      E = o.visitDecimal;
      break;
    case Type.List:
      E = o.visitList;
      break;
    case Type.Struct:
      E = o.visitStruct;
      break;
    case Type.Union:
      E = o.visitUnion;
      break;
    case Type.DenseUnion:
      E = o.visitDenseUnion || o.visitUnion;
      break;
    case Type.SparseUnion:
      E = o.visitSparseUnion || o.visitUnion;
      break;
    case Type.Dictionary:
      E = o.visitDictionary;
      break;
    case Type.Interval:
      E = o.visitInterval;
      break;
    case Type.IntervalDayTime:
      E = o.visitIntervalDayTime || o.visitInterval;
      break;
    case Type.IntervalYearMonth:
      E = o.visitIntervalYearMonth || o.visitInterval;
      break;
    case Type.IntervalMonthDayNano:
      E = o.visitIntervalMonthDayNano || o.visitInterval;
      break;
    case Type.Duration:
      E = o.visitDuration;
      break;
    case Type.DurationSecond:
      E = o.visitDurationSecond || o.visitDuration;
      break;
    case Type.DurationMillisecond:
      E = o.visitDurationMillisecond || o.visitDuration;
      break;
    case Type.DurationMicrosecond:
      E = o.visitDurationMicrosecond || o.visitDuration;
      break;
    case Type.DurationNanosecond:
      E = o.visitDurationNanosecond || o.visitDuration;
      break;
    case Type.FixedSizeList:
      E = o.visitFixedSizeList;
      break;
    case Type.Map:
      E = o.visitMap;
      break;
  }
  if (typeof E == "function")
    return E;
  if (!g)
    return () => null;
  throw new Error(`Unrecognized type '${Type[i]}'`);
}
function inferDType(o) {
  switch (o.typeId) {
    case Type.Null:
      return Type.Null;
    case Type.Int: {
      const { bitWidth: i, isSigned: g } = o;
      switch (i) {
        case 8:
          return g ? Type.Int8 : Type.Uint8;
        case 16:
          return g ? Type.Int16 : Type.Uint16;
        case 32:
          return g ? Type.Int32 : Type.Uint32;
        case 64:
          return g ? Type.Int64 : Type.Uint64;
      }
      return Type.Int;
    }
    case Type.Float:
      switch (o.precision) {
        case Precision.HALF:
          return Type.Float16;
        case Precision.SINGLE:
          return Type.Float32;
        case Precision.DOUBLE:
          return Type.Float64;
      }
      return Type.Float;
    case Type.Binary:
      return Type.Binary;
    case Type.LargeBinary:
      return Type.LargeBinary;
    case Type.Utf8:
      return Type.Utf8;
    case Type.LargeUtf8:
      return Type.LargeUtf8;
    case Type.Bool:
      return Type.Bool;
    case Type.Decimal:
      return Type.Decimal;
    case Type.Time:
      switch (o.unit) {
        case TimeUnit.SECOND:
          return Type.TimeSecond;
        case TimeUnit.MILLISECOND:
          return Type.TimeMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.TimeMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.TimeNanosecond;
      }
      return Type.Time;
    case Type.Timestamp:
      switch (o.unit) {
        case TimeUnit.SECOND:
          return Type.TimestampSecond;
        case TimeUnit.MILLISECOND:
          return Type.TimestampMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.TimestampMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.TimestampNanosecond;
      }
      return Type.Timestamp;
    case Type.Date:
      switch (o.unit) {
        case DateUnit.DAY:
          return Type.DateDay;
        case DateUnit.MILLISECOND:
          return Type.DateMillisecond;
      }
      return Type.Date;
    case Type.Interval:
      switch (o.unit) {
        case IntervalUnit.DAY_TIME:
          return Type.IntervalDayTime;
        case IntervalUnit.YEAR_MONTH:
          return Type.IntervalYearMonth;
        case IntervalUnit.MONTH_DAY_NANO:
          return Type.IntervalMonthDayNano;
      }
      return Type.Interval;
    case Type.Duration:
      switch (o.unit) {
        case TimeUnit.SECOND:
          return Type.DurationSecond;
        case TimeUnit.MILLISECOND:
          return Type.DurationMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.DurationMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.DurationNanosecond;
      }
      return Type.Duration;
    case Type.Map:
      return Type.Map;
    case Type.List:
      return Type.List;
    case Type.Struct:
      return Type.Struct;
    case Type.Union:
      switch (o.mode) {
        case UnionMode.Dense:
          return Type.DenseUnion;
        case UnionMode.Sparse:
          return Type.SparseUnion;
      }
      return Type.Union;
    case Type.FixedSizeBinary:
      return Type.FixedSizeBinary;
    case Type.FixedSizeList:
      return Type.FixedSizeList;
    case Type.Dictionary:
      return Type.Dictionary;
  }
  throw new Error(`Unrecognized type '${Type[o.typeId]}'`);
}
Visitor.prototype.visitInt8 = null;
Visitor.prototype.visitInt16 = null;
Visitor.prototype.visitInt32 = null;
Visitor.prototype.visitInt64 = null;
Visitor.prototype.visitUint8 = null;
Visitor.prototype.visitUint16 = null;
Visitor.prototype.visitUint32 = null;
Visitor.prototype.visitUint64 = null;
Visitor.prototype.visitFloat16 = null;
Visitor.prototype.visitFloat32 = null;
Visitor.prototype.visitFloat64 = null;
Visitor.prototype.visitDateDay = null;
Visitor.prototype.visitDateMillisecond = null;
Visitor.prototype.visitTimestampSecond = null;
Visitor.prototype.visitTimestampMillisecond = null;
Visitor.prototype.visitTimestampMicrosecond = null;
Visitor.prototype.visitTimestampNanosecond = null;
Visitor.prototype.visitTimeSecond = null;
Visitor.prototype.visitTimeMillisecond = null;
Visitor.prototype.visitTimeMicrosecond = null;
Visitor.prototype.visitTimeNanosecond = null;
Visitor.prototype.visitDenseUnion = null;
Visitor.prototype.visitSparseUnion = null;
Visitor.prototype.visitIntervalDayTime = null;
Visitor.prototype.visitIntervalYearMonth = null;
Visitor.prototype.visitIntervalMonthDayNano = null;
Visitor.prototype.visitDuration = null;
Visitor.prototype.visitDurationSecond = null;
Visitor.prototype.visitDurationMillisecond = null;
Visitor.prototype.visitDurationMicrosecond = null;
Visitor.prototype.visitDurationNanosecond = null;
const f64 = new Float64Array(1), u32 = new Uint32Array(f64.buffer);
function uint16ToFloat64(o) {
  const i = (o & 31744) >> 10, g = (o & 1023) / 1024, E = Math.pow(-1, (o & 32768) >> 15);
  switch (i) {
    case 31:
      return E * (g ? Number.NaN : 1 / 0);
    case 0:
      return E * (g ? 6103515625e-14 * g : 0);
  }
  return E * Math.pow(2, i - 15) * (1 + g);
}
function float64ToUint16(o) {
  if (o !== o)
    return 32256;
  f64[0] = o;
  const i = (u32[1] & 2147483648) >> 16 & 65535;
  let g = u32[1] & 2146435072, E = 0;
  return g >= 1089470464 ? u32[0] > 0 ? g = 31744 : (g = (g & 2080374784) >> 16, E = (u32[1] & 1048575) >> 10) : g <= 1056964608 ? (E = 1048576 + (u32[1] & 1048575), E = 1048576 + (E << (g >> 20) - 998) >> 21, g = 0) : (g = g - 1056964608 >> 10, E = (u32[1] & 1048575) + 512 >> 10), i | g | E & 65535;
}
const util_math_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  float64ToUint16,
  uint16ToFloat64
}, Symbol.toStringTag, { value: "Module" }));
class SetVisitor extends Visitor {
}
function wrapSet(o) {
  return (i, g, E) => {
    if (i.setValid(g, E != null))
      return o(i, g, E);
  };
}
const setEpochMsToDays = (o, i, g) => {
  o[i] = Math.floor(g / 864e5);
}, setVariableWidthBytes = (o, i, g, E) => {
  if (g + 1 < i.length) {
    const e = bigIntToNumber(i[g]), t = bigIntToNumber(i[g + 1]);
    o.set(E.subarray(0, t - e), e);
  }
}, setBool$1 = ({ offset: o, values: i }, g, E) => {
  const e = o + g;
  E ? i[e >> 3] |= 1 << e % 8 : i[e >> 3] &= ~(1 << e % 8);
}, setInt = ({ values: o }, i, g) => {
  o[i] = g;
}, setFloat = ({ values: o }, i, g) => {
  o[i] = g;
}, setFloat16 = ({ values: o }, i, g) => {
  o[i] = float64ToUint16(g);
}, setAnyFloat = (o, i, g) => {
  switch (o.type.precision) {
    case Precision.HALF:
      return setFloat16(o, i, g);
    case Precision.SINGLE:
    case Precision.DOUBLE:
      return setFloat(o, i, g);
  }
}, setDateDay = ({ values: o }, i, g) => {
  setEpochMsToDays(o, i, g.valueOf());
}, setDateMillisecond = ({ values: o }, i, g) => {
  o[i] = BigInt(g);
}, setFixedSizeBinary = ({ stride: o, values: i }, g, E) => {
  i.set(E.subarray(0, o), o * g);
}, setBinary = ({ values: o, valueOffsets: i }, g, E) => setVariableWidthBytes(o, i, g, E), setUtf8 = ({ values: o, valueOffsets: i }, g, E) => setVariableWidthBytes(o, i, g, encodeUtf8(E)), setDate = (o, i, g) => {
  o.type.unit === DateUnit.DAY ? setDateDay(o, i, g) : setDateMillisecond(o, i, g);
}, setTimestampSecond = ({ values: o }, i, g) => {
  o[i] = BigInt(g / 1e3);
}, setTimestampMillisecond = ({ values: o }, i, g) => {
  o[i] = BigInt(g);
}, setTimestampMicrosecond = ({ values: o }, i, g) => {
  o[i] = BigInt(g * 1e3);
}, setTimestampNanosecond = ({ values: o }, i, g) => {
  o[i] = BigInt(g * 1e6);
}, setTimestamp = (o, i, g) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return setTimestampSecond(o, i, g);
    case TimeUnit.MILLISECOND:
      return setTimestampMillisecond(o, i, g);
    case TimeUnit.MICROSECOND:
      return setTimestampMicrosecond(o, i, g);
    case TimeUnit.NANOSECOND:
      return setTimestampNanosecond(o, i, g);
  }
}, setTimeSecond = ({ values: o }, i, g) => {
  o[i] = g;
}, setTimeMillisecond = ({ values: o }, i, g) => {
  o[i] = g;
}, setTimeMicrosecond = ({ values: o }, i, g) => {
  o[i] = g;
}, setTimeNanosecond = ({ values: o }, i, g) => {
  o[i] = g;
}, setTime = (o, i, g) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return setTimeSecond(o, i, g);
    case TimeUnit.MILLISECOND:
      return setTimeMillisecond(o, i, g);
    case TimeUnit.MICROSECOND:
      return setTimeMicrosecond(o, i, g);
    case TimeUnit.NANOSECOND:
      return setTimeNanosecond(o, i, g);
  }
}, setDecimal = ({ values: o, stride: i }, g, E) => {
  o.set(E.subarray(0, i), i * g);
}, setList = (o, i, g) => {
  const E = o.children[0], e = o.valueOffsets, t = instance$5.getVisitFn(E);
  if (Array.isArray(g))
    for (let n = -1, h = e[i], d = e[i + 1]; h < d; )
      t(E, h++, g[++n]);
  else
    for (let n = -1, h = e[i], d = e[i + 1]; h < d; )
      t(E, h++, g.get(++n));
}, setMap = (o, i, g) => {
  const E = o.children[0], { valueOffsets: e } = o, t = instance$5.getVisitFn(E);
  let { [i]: n, [i + 1]: h } = e;
  const d = g instanceof Map ? g.entries() : Object.entries(g);
  for (const k of d)
    if (t(E, n, k), ++n >= h)
      break;
}, _setStructArrayValue = (o, i) => (g, E, e, t) => E && g(E, o, i[t]), _setStructVectorValue = (o, i) => (g, E, e, t) => E && g(E, o, i.get(t)), _setStructMapValue = (o, i) => (g, E, e, t) => E && g(E, o, i.get(e.name)), _setStructObjectValue = (o, i) => (g, E, e, t) => E && g(E, o, i[e.name]), setStruct = (o, i, g) => {
  const E = o.type.children.map((t) => instance$5.getVisitFn(t.type)), e = g instanceof Map ? _setStructMapValue(i, g) : g instanceof Vector ? _setStructVectorValue(i, g) : Array.isArray(g) ? _setStructArrayValue(i, g) : _setStructObjectValue(i, g);
  o.type.children.forEach((t, n) => e(E[n], o.children[n], t, n));
}, setUnion = (o, i, g) => {
  o.type.mode === UnionMode.Dense ? setDenseUnion(o, i, g) : setSparseUnion(o, i, g);
}, setDenseUnion = (o, i, g) => {
  const E = o.type.typeIdToChildIndex[o.typeIds[i]], e = o.children[E];
  instance$5.visit(e, o.valueOffsets[i], g);
}, setSparseUnion = (o, i, g) => {
  const E = o.type.typeIdToChildIndex[o.typeIds[i]], e = o.children[E];
  instance$5.visit(e, i, g);
}, setDictionary = (o, i, g) => {
  var E;
  (E = o.dictionary) === null || E === void 0 || E.set(o.values[i], g);
}, setIntervalValue = (o, i, g) => {
  switch (o.type.unit) {
    case IntervalUnit.YEAR_MONTH:
      return setIntervalYearMonth(o, i, g);
    case IntervalUnit.DAY_TIME:
      return setIntervalDayTime(o, i, g);
    case IntervalUnit.MONTH_DAY_NANO:
      return setIntervalMonthDayNano(o, i, g);
  }
}, setIntervalDayTime = ({ values: o }, i, g) => {
  o.set(g.subarray(0, 2), 2 * i);
}, setIntervalYearMonth = ({ values: o }, i, g) => {
  o[i] = g[0] * 12 + g[1] % 12;
}, setIntervalMonthDayNano = ({ values: o, stride: i }, g, E) => {
  o.set(E.subarray(0, i), i * g);
}, setDurationSecond = ({ values: o }, i, g) => {
  o[i] = g;
}, setDurationMillisecond = ({ values: o }, i, g) => {
  o[i] = g;
}, setDurationMicrosecond = ({ values: o }, i, g) => {
  o[i] = g;
}, setDurationNanosecond = ({ values: o }, i, g) => {
  o[i] = g;
}, setDuration = (o, i, g) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return setDurationSecond(o, i, g);
    case TimeUnit.MILLISECOND:
      return setDurationMillisecond(o, i, g);
    case TimeUnit.MICROSECOND:
      return setDurationMicrosecond(o, i, g);
    case TimeUnit.NANOSECOND:
      return setDurationNanosecond(o, i, g);
  }
}, setFixedSizeList = (o, i, g) => {
  const { stride: E } = o, e = o.children[0], t = instance$5.getVisitFn(e);
  if (Array.isArray(g))
    for (let n = -1, h = i * E; ++n < E; )
      t(e, h + n, g[n]);
  else
    for (let n = -1, h = i * E; ++n < E; )
      t(e, h + n, g.get(n));
};
SetVisitor.prototype.visitBool = wrapSet(setBool$1);
SetVisitor.prototype.visitInt = wrapSet(setInt);
SetVisitor.prototype.visitInt8 = wrapSet(setInt);
SetVisitor.prototype.visitInt16 = wrapSet(setInt);
SetVisitor.prototype.visitInt32 = wrapSet(setInt);
SetVisitor.prototype.visitInt64 = wrapSet(setInt);
SetVisitor.prototype.visitUint8 = wrapSet(setInt);
SetVisitor.prototype.visitUint16 = wrapSet(setInt);
SetVisitor.prototype.visitUint32 = wrapSet(setInt);
SetVisitor.prototype.visitUint64 = wrapSet(setInt);
SetVisitor.prototype.visitFloat = wrapSet(setAnyFloat);
SetVisitor.prototype.visitFloat16 = wrapSet(setFloat16);
SetVisitor.prototype.visitFloat32 = wrapSet(setFloat);
SetVisitor.prototype.visitFloat64 = wrapSet(setFloat);
SetVisitor.prototype.visitUtf8 = wrapSet(setUtf8);
SetVisitor.prototype.visitLargeUtf8 = wrapSet(setUtf8);
SetVisitor.prototype.visitBinary = wrapSet(setBinary);
SetVisitor.prototype.visitLargeBinary = wrapSet(setBinary);
SetVisitor.prototype.visitFixedSizeBinary = wrapSet(setFixedSizeBinary);
SetVisitor.prototype.visitDate = wrapSet(setDate);
SetVisitor.prototype.visitDateDay = wrapSet(setDateDay);
SetVisitor.prototype.visitDateMillisecond = wrapSet(setDateMillisecond);
SetVisitor.prototype.visitTimestamp = wrapSet(setTimestamp);
SetVisitor.prototype.visitTimestampSecond = wrapSet(setTimestampSecond);
SetVisitor.prototype.visitTimestampMillisecond = wrapSet(setTimestampMillisecond);
SetVisitor.prototype.visitTimestampMicrosecond = wrapSet(setTimestampMicrosecond);
SetVisitor.prototype.visitTimestampNanosecond = wrapSet(setTimestampNanosecond);
SetVisitor.prototype.visitTime = wrapSet(setTime);
SetVisitor.prototype.visitTimeSecond = wrapSet(setTimeSecond);
SetVisitor.prototype.visitTimeMillisecond = wrapSet(setTimeMillisecond);
SetVisitor.prototype.visitTimeMicrosecond = wrapSet(setTimeMicrosecond);
SetVisitor.prototype.visitTimeNanosecond = wrapSet(setTimeNanosecond);
SetVisitor.prototype.visitDecimal = wrapSet(setDecimal);
SetVisitor.prototype.visitList = wrapSet(setList);
SetVisitor.prototype.visitStruct = wrapSet(setStruct);
SetVisitor.prototype.visitUnion = wrapSet(setUnion);
SetVisitor.prototype.visitDenseUnion = wrapSet(setDenseUnion);
SetVisitor.prototype.visitSparseUnion = wrapSet(setSparseUnion);
SetVisitor.prototype.visitDictionary = wrapSet(setDictionary);
SetVisitor.prototype.visitInterval = wrapSet(setIntervalValue);
SetVisitor.prototype.visitIntervalDayTime = wrapSet(setIntervalDayTime);
SetVisitor.prototype.visitIntervalYearMonth = wrapSet(setIntervalYearMonth);
SetVisitor.prototype.visitIntervalMonthDayNano = wrapSet(setIntervalMonthDayNano);
SetVisitor.prototype.visitDuration = wrapSet(setDuration);
SetVisitor.prototype.visitDurationSecond = wrapSet(setDurationSecond);
SetVisitor.prototype.visitDurationMillisecond = wrapSet(setDurationMillisecond);
SetVisitor.prototype.visitDurationMicrosecond = wrapSet(setDurationMicrosecond);
SetVisitor.prototype.visitDurationNanosecond = wrapSet(setDurationNanosecond);
SetVisitor.prototype.visitFixedSizeList = wrapSet(setFixedSizeList);
SetVisitor.prototype.visitMap = wrapSet(setMap);
const instance$5 = new SetVisitor(), kParent = Symbol.for("parent"), kRowIndex = Symbol.for("rowIndex");
class StructRow {
  constructor(i, g) {
    return this[kParent] = i, this[kRowIndex] = g, new Proxy(this, structRowProxyHandler);
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const i = this[kRowIndex], g = this[kParent], E = g.type.children, e = {};
    for (let t = -1, n = E.length; ++t < n; )
      e[E[t].name] = instance$4.visit(g.children[t], i);
    return e;
  }
  toString() {
    return `{${[...this].map(([i, g]) => `${valueToString(i)}: ${valueToString(g)}`).join(", ")}}`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
  [Symbol.iterator]() {
    return new StructRowIterator(this[kParent], this[kRowIndex]);
  }
}
class StructRowIterator {
  constructor(i, g) {
    this.childIndex = 0, this.children = i.children, this.rowIndex = g, this.childFields = i.type.children, this.numChildren = this.childFields.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const i = this.childIndex;
    return i < this.numChildren ? (this.childIndex = i + 1, {
      done: !1,
      value: [
        this.childFields[i].name,
        instance$4.visit(this.children[i], this.rowIndex)
      ]
    }) : { done: !0, value: null };
  }
}
Object.defineProperties(StructRow.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [kParent]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [kRowIndex]: { writable: !0, enumerable: !1, configurable: !1, value: -1 }
});
class StructRowProxyHandler {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(i) {
    return i[kParent].type.children.map((g) => g.name);
  }
  has(i, g) {
    return i[kParent].type.children.some((E) => E.name === g);
  }
  getOwnPropertyDescriptor(i, g) {
    if (i[kParent].type.children.some((E) => E.name === g))
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(i, g) {
    if (Reflect.has(i, g))
      return i[g];
    const E = i[kParent].type.children.findIndex((e) => e.name === g);
    if (E !== -1) {
      const e = instance$4.visit(i[kParent].children[E], i[kRowIndex]);
      return Reflect.set(i, g, e), e;
    }
  }
  set(i, g, E) {
    const e = i[kParent].type.children.findIndex((t) => t.name === g);
    return e !== -1 ? (instance$5.visit(i[kParent].children[e], i[kRowIndex], E), Reflect.set(i, g, E)) : Reflect.has(i, g) || typeof g == "symbol" ? Reflect.set(i, g, E) : !1;
  }
}
const structRowProxyHandler = new StructRowProxyHandler();
class GetVisitor extends Visitor {
}
function wrapGet(o) {
  return (i, g) => i.getValid(g) ? o(i, g) : null;
}
const epochDaysToMs = (o, i) => 864e5 * o[i], getNull = (o, i) => null, getVariableWidthBytes = (o, i, g) => {
  if (g + 1 >= i.length)
    return null;
  const E = bigIntToNumber(i[g]), e = bigIntToNumber(i[g + 1]);
  return o.subarray(E, e);
}, getBool$1 = ({ offset: o, values: i }, g) => {
  const E = o + g;
  return (i[E >> 3] & 1 << E % 8) !== 0;
}, getDateDay = ({ values: o }, i) => epochDaysToMs(o, i), getDateMillisecond = ({ values: o }, i) => bigIntToNumber(o[i]), getNumeric = ({ stride: o, values: i }, g) => i[o * g], getFloat16 = ({ stride: o, values: i }, g) => uint16ToFloat64(i[o * g]), getBigInts = ({ values: o }, i) => o[i], getFixedSizeBinary = ({ stride: o, values: i }, g) => i.subarray(o * g, o * (g + 1)), getBinary = ({ values: o, valueOffsets: i }, g) => getVariableWidthBytes(o, i, g), getUtf8 = ({ values: o, valueOffsets: i }, g) => {
  const E = getVariableWidthBytes(o, i, g);
  return E !== null ? decodeUtf8(E) : null;
}, getInt = ({ values: o }, i) => o[i], getFloat = ({ type: o, values: i }, g) => o.precision !== Precision.HALF ? i[g] : uint16ToFloat64(i[g]), getDate = (o, i) => o.type.unit === DateUnit.DAY ? getDateDay(o, i) : getDateMillisecond(o, i), getTimestampSecond = ({ values: o }, i) => 1e3 * bigIntToNumber(o[i]), getTimestampMillisecond = ({ values: o }, i) => bigIntToNumber(o[i]), getTimestampMicrosecond = ({ values: o }, i) => divideBigInts(o[i], BigInt(1e3)), getTimestampNanosecond = ({ values: o }, i) => divideBigInts(o[i], BigInt(1e6)), getTimestamp = (o, i) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return getTimestampSecond(o, i);
    case TimeUnit.MILLISECOND:
      return getTimestampMillisecond(o, i);
    case TimeUnit.MICROSECOND:
      return getTimestampMicrosecond(o, i);
    case TimeUnit.NANOSECOND:
      return getTimestampNanosecond(o, i);
  }
}, getTimeSecond = ({ values: o }, i) => o[i], getTimeMillisecond = ({ values: o }, i) => o[i], getTimeMicrosecond = ({ values: o }, i) => o[i], getTimeNanosecond = ({ values: o }, i) => o[i], getTime = (o, i) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return getTimeSecond(o, i);
    case TimeUnit.MILLISECOND:
      return getTimeMillisecond(o, i);
    case TimeUnit.MICROSECOND:
      return getTimeMicrosecond(o, i);
    case TimeUnit.NANOSECOND:
      return getTimeNanosecond(o, i);
  }
}, getDecimal = ({ values: o, stride: i }, g) => BN.decimal(o.subarray(i * g, i * (g + 1))), getList = (o, i) => {
  const { valueOffsets: g, stride: E, children: e } = o, { [i * E]: t, [i * E + 1]: n } = g, d = e[0].slice(t, n - t);
  return new Vector([d]);
}, getMap = (o, i) => {
  const { valueOffsets: g, children: E } = o, { [i]: e, [i + 1]: t } = g, n = E[0];
  return new MapRow(n.slice(e, t - e));
}, getStruct = (o, i) => new StructRow(o, i), getUnion = (o, i) => o.type.mode === UnionMode.Dense ? getDenseUnion(o, i) : getSparseUnion(o, i), getDenseUnion = (o, i) => {
  const g = o.type.typeIdToChildIndex[o.typeIds[i]], E = o.children[g];
  return instance$4.visit(E, o.valueOffsets[i]);
}, getSparseUnion = (o, i) => {
  const g = o.type.typeIdToChildIndex[o.typeIds[i]], E = o.children[g];
  return instance$4.visit(E, i);
}, getDictionary = (o, i) => {
  var g;
  return (g = o.dictionary) === null || g === void 0 ? void 0 : g.get(o.values[i]);
}, getInterval = (o, i) => o.type.unit === IntervalUnit.MONTH_DAY_NANO ? getIntervalMonthDayNano(o, i) : o.type.unit === IntervalUnit.DAY_TIME ? getIntervalDayTime(o, i) : getIntervalYearMonth(o, i), getIntervalDayTime = ({ values: o }, i) => o.subarray(2 * i, 2 * (i + 1)), getIntervalYearMonth = ({ values: o }, i) => {
  const g = o[i], E = new Int32Array(2);
  return E[0] = Math.trunc(g / 12), E[1] = Math.trunc(g % 12), E;
}, getIntervalMonthDayNano = ({ values: o }, i) => o.subarray(4 * i, 4 * (i + 1)), getDurationSecond = ({ values: o }, i) => o[i], getDurationMillisecond = ({ values: o }, i) => o[i], getDurationMicrosecond = ({ values: o }, i) => o[i], getDurationNanosecond = ({ values: o }, i) => o[i], getDuration = (o, i) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return getDurationSecond(o, i);
    case TimeUnit.MILLISECOND:
      return getDurationMillisecond(o, i);
    case TimeUnit.MICROSECOND:
      return getDurationMicrosecond(o, i);
    case TimeUnit.NANOSECOND:
      return getDurationNanosecond(o, i);
  }
}, getFixedSizeList = (o, i) => {
  const { stride: g, children: E } = o, t = E[0].slice(i * g, g);
  return new Vector([t]);
};
GetVisitor.prototype.visitNull = wrapGet(getNull);
GetVisitor.prototype.visitBool = wrapGet(getBool$1);
GetVisitor.prototype.visitInt = wrapGet(getInt);
GetVisitor.prototype.visitInt8 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt16 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt32 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt64 = wrapGet(getBigInts);
GetVisitor.prototype.visitUint8 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint16 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint32 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint64 = wrapGet(getBigInts);
GetVisitor.prototype.visitFloat = wrapGet(getFloat);
GetVisitor.prototype.visitFloat16 = wrapGet(getFloat16);
GetVisitor.prototype.visitFloat32 = wrapGet(getNumeric);
GetVisitor.prototype.visitFloat64 = wrapGet(getNumeric);
GetVisitor.prototype.visitUtf8 = wrapGet(getUtf8);
GetVisitor.prototype.visitLargeUtf8 = wrapGet(getUtf8);
GetVisitor.prototype.visitBinary = wrapGet(getBinary);
GetVisitor.prototype.visitLargeBinary = wrapGet(getBinary);
GetVisitor.prototype.visitFixedSizeBinary = wrapGet(getFixedSizeBinary);
GetVisitor.prototype.visitDate = wrapGet(getDate);
GetVisitor.prototype.visitDateDay = wrapGet(getDateDay);
GetVisitor.prototype.visitDateMillisecond = wrapGet(getDateMillisecond);
GetVisitor.prototype.visitTimestamp = wrapGet(getTimestamp);
GetVisitor.prototype.visitTimestampSecond = wrapGet(getTimestampSecond);
GetVisitor.prototype.visitTimestampMillisecond = wrapGet(getTimestampMillisecond);
GetVisitor.prototype.visitTimestampMicrosecond = wrapGet(getTimestampMicrosecond);
GetVisitor.prototype.visitTimestampNanosecond = wrapGet(getTimestampNanosecond);
GetVisitor.prototype.visitTime = wrapGet(getTime);
GetVisitor.prototype.visitTimeSecond = wrapGet(getTimeSecond);
GetVisitor.prototype.visitTimeMillisecond = wrapGet(getTimeMillisecond);
GetVisitor.prototype.visitTimeMicrosecond = wrapGet(getTimeMicrosecond);
GetVisitor.prototype.visitTimeNanosecond = wrapGet(getTimeNanosecond);
GetVisitor.prototype.visitDecimal = wrapGet(getDecimal);
GetVisitor.prototype.visitList = wrapGet(getList);
GetVisitor.prototype.visitStruct = wrapGet(getStruct);
GetVisitor.prototype.visitUnion = wrapGet(getUnion);
GetVisitor.prototype.visitDenseUnion = wrapGet(getDenseUnion);
GetVisitor.prototype.visitSparseUnion = wrapGet(getSparseUnion);
GetVisitor.prototype.visitDictionary = wrapGet(getDictionary);
GetVisitor.prototype.visitInterval = wrapGet(getInterval);
GetVisitor.prototype.visitIntervalDayTime = wrapGet(getIntervalDayTime);
GetVisitor.prototype.visitIntervalYearMonth = wrapGet(getIntervalYearMonth);
GetVisitor.prototype.visitIntervalMonthDayNano = wrapGet(getIntervalMonthDayNano);
GetVisitor.prototype.visitDuration = wrapGet(getDuration);
GetVisitor.prototype.visitDurationSecond = wrapGet(getDurationSecond);
GetVisitor.prototype.visitDurationMillisecond = wrapGet(getDurationMillisecond);
GetVisitor.prototype.visitDurationMicrosecond = wrapGet(getDurationMicrosecond);
GetVisitor.prototype.visitDurationNanosecond = wrapGet(getDurationNanosecond);
GetVisitor.prototype.visitFixedSizeList = wrapGet(getFixedSizeList);
GetVisitor.prototype.visitMap = wrapGet(getMap);
const instance$4 = new GetVisitor(), kKeys = Symbol.for("keys"), kVals = Symbol.for("vals"), kKeysAsStrings = Symbol.for("kKeysAsStrings"), _kKeysAsStrings = Symbol.for("_kKeysAsStrings");
class MapRow {
  constructor(i) {
    return this[kKeys] = new Vector([i.children[0]]).memoize(), this[kVals] = i.children[1], new Proxy(this, new MapRowProxyHandler());
  }
  /** @ignore */
  get [kKeysAsStrings]() {
    return this[_kKeysAsStrings] || (this[_kKeysAsStrings] = Array.from(this[kKeys].toArray(), String));
  }
  [Symbol.iterator]() {
    return new MapRowIterator(this[kKeys], this[kVals]);
  }
  get size() {
    return this[kKeys].length;
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const i = this[kKeys], g = this[kVals], E = {};
    for (let e = -1, t = i.length; ++e < t; )
      E[i.get(e)] = instance$4.visit(g, e);
    return E;
  }
  toString() {
    return `{${[...this].map(([i, g]) => `${valueToString(i)}: ${valueToString(g)}`).join(", ")}}`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
}
class MapRowIterator {
  constructor(i, g) {
    this.keys = i, this.vals = g, this.keyIndex = 0, this.numKeys = i.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const i = this.keyIndex;
    return i === this.numKeys ? { done: !0, value: null } : (this.keyIndex++, {
      done: !1,
      value: [
        this.keys.get(i),
        instance$4.visit(this.vals, i)
      ]
    });
  }
}
class MapRowProxyHandler {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(i) {
    return i[kKeysAsStrings];
  }
  has(i, g) {
    return i[kKeysAsStrings].includes(g);
  }
  getOwnPropertyDescriptor(i, g) {
    if (i[kKeysAsStrings].indexOf(g) !== -1)
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(i, g) {
    if (Reflect.has(i, g))
      return i[g];
    const E = i[kKeysAsStrings].indexOf(g);
    if (E !== -1) {
      const e = instance$4.visit(Reflect.get(i, kVals), E);
      return Reflect.set(i, g, e), e;
    }
  }
  set(i, g, E) {
    const e = i[kKeysAsStrings].indexOf(g);
    return e !== -1 ? (instance$5.visit(Reflect.get(i, kVals), e, E), Reflect.set(i, g, E)) : Reflect.has(i, g) ? Reflect.set(i, g, E) : !1;
  }
}
Object.defineProperties(MapRow.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [kKeys]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [kVals]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [_kKeysAsStrings]: { writable: !0, enumerable: !1, configurable: !1, value: null }
});
let tmp;
function clampRange(o, i, g, E) {
  const { length: e = 0 } = o;
  let t = typeof i != "number" ? 0 : i, n = typeof g != "number" ? e : g;
  return t < 0 && (t = (t % e + e) % e), n < 0 && (n = (n % e + e) % e), n < t && (tmp = t, t = n, n = tmp), n > e && (n = e), E ? E(o, t, n) : [t, n];
}
const wrapIndex = (o, i) => o < 0 ? i + o : o, isNaNFast = (o) => o !== o;
function createElementComparator(o) {
  if (typeof o !== "object" || o === null)
    return isNaNFast(o) ? isNaNFast : (g) => g === o;
  if (o instanceof Date) {
    const g = o.valueOf();
    return (E) => E instanceof Date ? E.valueOf() === g : !1;
  }
  return ArrayBuffer.isView(o) ? (g) => g ? compareArrayLike(o, g) : !1 : o instanceof Map ? createMapComparator(o) : Array.isArray(o) ? createArrayLikeComparator(o) : o instanceof Vector ? createVectorComparator(o) : createObjectComparator(o, !0);
}
function createArrayLikeComparator(o) {
  const i = [];
  for (let g = -1, E = o.length; ++g < E; )
    i[g] = createElementComparator(o[g]);
  return createSubElementsComparator(i);
}
function createMapComparator(o) {
  let i = -1;
  const g = [];
  for (const E of o.values())
    g[++i] = createElementComparator(E);
  return createSubElementsComparator(g);
}
function createVectorComparator(o) {
  const i = [];
  for (let g = -1, E = o.length; ++g < E; )
    i[g] = createElementComparator(o.get(g));
  return createSubElementsComparator(i);
}
function createObjectComparator(o, i = !1) {
  const g = Object.keys(o);
  if (!i && g.length === 0)
    return () => !1;
  const E = [];
  for (let e = -1, t = g.length; ++e < t; )
    E[e] = createElementComparator(o[g[e]]);
  return createSubElementsComparator(E, g);
}
function createSubElementsComparator(o, i) {
  return (g) => {
    if (!g || typeof g != "object")
      return !1;
    switch (g.constructor) {
      case Array:
        return compareArray$1(o, g);
      case Map:
        return compareObject(o, g, g.keys());
      case MapRow:
      case StructRow:
      case Object:
      case void 0:
        return compareObject(o, g, i || Object.keys(g));
    }
    return g instanceof Vector ? compareVector(o, g) : !1;
  };
}
function compareArray$1(o, i) {
  const g = o.length;
  if (i.length !== g)
    return !1;
  for (let E = -1; ++E < g; )
    if (!o[E](i[E]))
      return !1;
  return !0;
}
function compareVector(o, i) {
  const g = o.length;
  if (i.length !== g)
    return !1;
  for (let E = -1; ++E < g; )
    if (!o[E](i.get(E)))
      return !1;
  return !0;
}
function compareObject(o, i, g) {
  const E = g[Symbol.iterator](), e = i instanceof Map ? i.keys() : Object.keys(i)[Symbol.iterator](), t = i instanceof Map ? i.values() : Object.values(i)[Symbol.iterator]();
  let n = 0;
  const h = o.length;
  let d = t.next(), k = E.next(), p = e.next();
  for (; n < h && !k.done && !p.done && !d.done && !(k.value !== p.value || !o[n](d.value)); ++n, k = E.next(), p = e.next(), d = t.next())
    ;
  return n === h && k.done && p.done && d.done ? !0 : (E.return && E.return(), e.return && e.return(), t.return && t.return(), !1);
}
const util_vector_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clampRange,
  createElementComparator,
  wrapIndex
}, Symbol.toStringTag, { value: "Module" }));
function getBool(o, i, g, E) {
  return (g & 1 << E) !== 0;
}
function getBit(o, i, g, E) {
  return (g & 1 << E) >> E;
}
function setBool(o, i, g) {
  return g ? !!(o[i >> 3] |= 1 << i % 8) || !0 : !(o[i >> 3] &= ~(1 << i % 8)) && !1;
}
function truncateBitmap(o, i, g) {
  const E = g.byteLength + 7 & -8;
  if (o > 0 || g.byteLength < E) {
    const e = new Uint8Array(E);
    return e.set(o % 8 === 0 ? g.subarray(o >> 3) : (
      // Otherwise iterate each bit from the offset and return a new one
      packBools(new BitIterator(g, o, i, null, getBool)).subarray(0, E)
    )), e;
  }
  return g;
}
function packBools(o) {
  const i = [];
  let g = 0, E = 0, e = 0;
  for (const n of o)
    n && (e |= 1 << E), ++E === 8 && (i[g++] = e, e = E = 0);
  (g === 0 || E > 0) && (i[g++] = e);
  const t = new Uint8Array(i.length + 7 & -8);
  return t.set(i), t;
}
class BitIterator {
  constructor(i, g, E, e, t) {
    this.bytes = i, this.length = E, this.context = e, this.get = t, this.bit = g % 8, this.byteIndex = g >> 3, this.byte = i[this.byteIndex++], this.index = 0;
  }
  next() {
    return this.index < this.length ? (this.bit === 8 && (this.bit = 0, this.byte = this.bytes[this.byteIndex++]), {
      value: this.get(this.context, this.index++, this.byte, this.bit++)
    }) : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function popcnt_bit_range(o, i, g) {
  if (g - i <= 0)
    return 0;
  if (g - i < 8) {
    let t = 0;
    for (const n of new BitIterator(o, i, g - i, o, getBit))
      t += n;
    return t;
  }
  const E = g >> 3 << 3, e = i + (i % 8 === 0 ? 0 : 8 - i % 8);
  return (
    // Get the popcnt of bits between the left hand side, and the next highest multiple of 8
    popcnt_bit_range(o, i, e) + // Get the popcnt of bits between the right hand side, and the next lowest multiple of 8
    popcnt_bit_range(o, E, g) + // Get the popcnt of all bits between the left and right hand sides' multiples of 8
    popcnt_array(o, e >> 3, E - e >> 3)
  );
}
function popcnt_array(o, i, g) {
  let E = 0, e = Math.trunc(i);
  const t = new DataView(o.buffer, o.byteOffset, o.byteLength), n = g === void 0 ? o.byteLength : e + g;
  for (; n - e >= 4; )
    E += popcnt_uint32(t.getUint32(e)), e += 4;
  for (; n - e >= 2; )
    E += popcnt_uint32(t.getUint16(e)), e += 2;
  for (; n - e >= 1; )
    E += popcnt_uint32(t.getUint8(e)), e += 1;
  return E;
}
function popcnt_uint32(o) {
  let i = Math.trunc(o);
  return i = i - (i >>> 1 & 1431655765), i = (i & 858993459) + (i >>> 2 & 858993459), (i + (i >>> 4) & 252645135) * 16843009 >>> 24;
}
const util_bit_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BitIterator,
  getBit,
  getBool,
  packBools,
  popcnt_array,
  popcnt_bit_range,
  popcnt_uint32,
  setBool,
  truncateBitmap
}, Symbol.toStringTag, { value: "Module" })), kUnknownNullCount = -1;
class Data {
  get typeId() {
    return this.type.typeId;
  }
  get ArrayType() {
    return this.type.ArrayType;
  }
  get buffers() {
    return [this.valueOffsets, this.values, this.nullBitmap, this.typeIds];
  }
  get nullable() {
    if (this._nullCount !== 0) {
      const { type: i } = this;
      return DataType.isSparseUnion(i) ? this.children.some((g) => g.nullable) : DataType.isDenseUnion(i) ? this.children.some((g) => g.nullable) : this.nullBitmap && this.nullBitmap.byteLength > 0;
    }
    return !0;
  }
  get byteLength() {
    let i = 0;
    const { valueOffsets: g, values: E, nullBitmap: e, typeIds: t } = this;
    return g && (i += g.byteLength), E && (i += E.byteLength), e && (i += e.byteLength), t && (i += t.byteLength), this.children.reduce((n, h) => n + h.byteLength, i);
  }
  get nullCount() {
    if (DataType.isUnion(this.type))
      return this.children.reduce((E, e) => E + e.nullCount, 0);
    let i = this._nullCount, g;
    return i <= kUnknownNullCount && (g = this.nullBitmap) && (this._nullCount = i = g.length === 0 ? (
      // no null bitmap, so all values are valid
      0
    ) : this.length - popcnt_bit_range(g, this.offset, this.offset + this.length)), i;
  }
  constructor(i, g, E, e, t, n = [], h) {
    this.type = i, this.children = n, this.dictionary = h, this.offset = Math.floor(Math.max(g || 0, 0)), this.length = Math.floor(Math.max(E || 0, 0)), this._nullCount = Math.floor(Math.max(e || 0, -1));
    let d;
    t instanceof Data ? (this.stride = t.stride, this.values = t.values, this.typeIds = t.typeIds, this.nullBitmap = t.nullBitmap, this.valueOffsets = t.valueOffsets) : (this.stride = strideForType(i), t && ((d = t[0]) && (this.valueOffsets = d), (d = t[1]) && (this.values = d), (d = t[2]) && (this.nullBitmap = d), (d = t[3]) && (this.typeIds = d)));
  }
  getValid(i) {
    const { type: g } = this;
    if (DataType.isUnion(g)) {
      const E = g, e = this.children[E.typeIdToChildIndex[this.typeIds[i]]], t = E.mode === UnionMode.Dense ? this.valueOffsets[i] : i;
      return e.getValid(t);
    }
    if (this.nullable && this.nullCount > 0) {
      const E = this.offset + i;
      return (this.nullBitmap[E >> 3] & 1 << E % 8) !== 0;
    }
    return !0;
  }
  setValid(i, g) {
    let E;
    const { type: e } = this;
    if (DataType.isUnion(e)) {
      const t = e, n = this.children[t.typeIdToChildIndex[this.typeIds[i]]], h = t.mode === UnionMode.Dense ? this.valueOffsets[i] : i;
      E = n.getValid(h), n.setValid(h, g);
    } else {
      let { nullBitmap: t } = this;
      const { offset: n, length: h } = this, d = n + i, k = 1 << d % 8, p = d >> 3;
      (!t || t.byteLength <= p) && (t = new Uint8Array((n + h + 63 & -64) >> 3).fill(255), this.nullCount > 0 ? (t.set(truncateBitmap(n, h, this.nullBitmap), 0), Object.assign(this, { nullBitmap: t })) : Object.assign(this, { nullBitmap: t, _nullCount: 0 }));
      const M = t[p];
      E = (M & k) !== 0, t[p] = g ? M | k : M & ~k;
    }
    return E !== !!g && (this._nullCount = this.nullCount + (g ? -1 : 1)), g;
  }
  clone(i = this.type, g = this.offset, E = this.length, e = this._nullCount, t = this, n = this.children) {
    return new Data(i, g, E, e, t, n, this.dictionary);
  }
  slice(i, g) {
    const { stride: E, typeId: e, children: t } = this, n = +(this._nullCount === 0) - 1, h = e === 16 ? E : 1, d = this._sliceBuffers(i, g, E, e);
    return this.clone(
      this.type,
      this.offset + i,
      g,
      n,
      d,
      // Don't slice children if we have value offsets (the variable-width types)
      t.length === 0 || this.valueOffsets ? t : this._sliceChildren(t, h * i, h * g)
    );
  }
  _changeLengthAndBackfillNullBitmap(i) {
    if (this.typeId === Type.Null)
      return this.clone(this.type, 0, i, 0);
    const { length: g, nullCount: E } = this, e = new Uint8Array((i + 63 & -64) >> 3).fill(255, 0, g >> 3);
    e[g >> 3] = (1 << g - (g & -8)) - 1, E > 0 && e.set(truncateBitmap(this.offset, g, this.nullBitmap), 0);
    const t = this.buffers;
    return t[BufferType.VALIDITY] = e, this.clone(this.type, 0, i, E + (i - g), t);
  }
  _sliceBuffers(i, g, E, e) {
    let t;
    const { buffers: n } = this;
    return (t = n[BufferType.TYPE]) && (n[BufferType.TYPE] = t.subarray(i, i + g)), (t = n[BufferType.OFFSET]) && (n[BufferType.OFFSET] = t.subarray(i, i + g + 1)) || // Otherwise if no offsets, slice the data buffer. Don't slice the data vector for Booleans, since the offset goes by bits not bytes
    (t = n[BufferType.DATA]) && (n[BufferType.DATA] = e === 6 ? t : t.subarray(E * i, E * (i + g))), n;
  }
  _sliceChildren(i, g, E) {
    return i.map((e) => e.slice(g, E));
  }
}
Data.prototype.children = Object.freeze([]);
class MakeDataVisitor extends Visitor {
  visit(i) {
    return this.getVisitFn(i.type).call(this, i);
  }
  visitNull(i) {
    const { ["type"]: g, ["offset"]: E = 0, ["length"]: e = 0 } = i;
    return new Data(g, E, e, e);
  }
  visitBool(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length >> 3, ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitInt(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length, ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitFloat(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length, ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitUtf8(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.data), t = toUint8Array(i.nullBitmap), n = toInt32Array(i.valueOffsets), { ["length"]: h = n.length - 1, ["nullCount"]: d = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, h, d, [n, e, t]);
  }
  visitLargeUtf8(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.data), t = toUint8Array(i.nullBitmap), n = toBigInt64Array(i.valueOffsets), { ["length"]: h = n.length - 1, ["nullCount"]: d = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, h, d, [n, e, t]);
  }
  visitBinary(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.data), t = toUint8Array(i.nullBitmap), n = toInt32Array(i.valueOffsets), { ["length"]: h = n.length - 1, ["nullCount"]: d = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, h, d, [n, e, t]);
  }
  visitLargeBinary(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.data), t = toUint8Array(i.nullBitmap), n = toBigInt64Array(i.valueOffsets), { ["length"]: h = n.length - 1, ["nullCount"]: d = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, h, d, [n, e, t]);
  }
  visitFixedSizeBinary(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length / strideForType(g), ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitDate(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length / strideForType(g), ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitTimestamp(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length / strideForType(g), ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitTime(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length / strideForType(g), ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitDecimal(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length / strideForType(g), ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitList(i) {
    const { ["type"]: g, ["offset"]: E = 0, ["child"]: e } = i, t = toUint8Array(i.nullBitmap), n = toInt32Array(i.valueOffsets), { ["length"]: h = n.length - 1, ["nullCount"]: d = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, h, d, [n, void 0, t], [e]);
  }
  visitStruct(i) {
    const { ["type"]: g, ["offset"]: E = 0, ["children"]: e = [] } = i, t = toUint8Array(i.nullBitmap), { length: n = e.reduce((d, { length: k }) => Math.max(d, k), 0), nullCount: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, void 0, t], e);
  }
  visitUnion(i) {
    const { ["type"]: g, ["offset"]: E = 0, ["children"]: e = [] } = i, t = toArrayBufferView(g.ArrayType, i.typeIds), { ["length"]: n = t.length, ["nullCount"]: h = -1 } = i;
    if (DataType.isSparseUnion(g))
      return new Data(g, E, n, h, [void 0, void 0, void 0, t], e);
    const d = toInt32Array(i.valueOffsets);
    return new Data(g, E, n, h, [d, void 0, void 0, t], e);
  }
  visitDictionary(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.indices.ArrayType, i.data), { ["dictionary"]: n = new Vector([new MakeDataVisitor().visit({ type: g.dictionary })]) } = i, { ["length"]: h = t.length, ["nullCount"]: d = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, h, d, [void 0, t, e], [], n);
  }
  visitInterval(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length / strideForType(g), ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitDuration(i) {
    const { ["type"]: g, ["offset"]: E = 0 } = i, e = toUint8Array(i.nullBitmap), t = toArrayBufferView(g.ArrayType, i.data), { ["length"]: n = t.length, ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, t, e]);
  }
  visitFixedSizeList(i) {
    const { ["type"]: g, ["offset"]: E = 0, ["child"]: e = new MakeDataVisitor().visit({ type: g.valueType }) } = i, t = toUint8Array(i.nullBitmap), { ["length"]: n = e.length / strideForType(g), ["nullCount"]: h = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, n, h, [void 0, void 0, t], [e]);
  }
  visitMap(i) {
    const { ["type"]: g, ["offset"]: E = 0, ["child"]: e = new MakeDataVisitor().visit({ type: g.childType }) } = i, t = toUint8Array(i.nullBitmap), n = toInt32Array(i.valueOffsets), { ["length"]: h = n.length - 1, ["nullCount"]: d = i.nullBitmap ? -1 : 0 } = i;
    return new Data(g, E, h, d, [n, void 0, t], [e]);
  }
}
const makeDataVisitor = new MakeDataVisitor();
function makeData(o) {
  return makeDataVisitor.visit(o);
}
class ChunkedIterator {
  constructor(i = 0, g) {
    this.numChunks = i, this.getChunkIterator = g, this.chunkIndex = 0, this.chunkIterator = this.getChunkIterator(0);
  }
  next() {
    for (; this.chunkIndex < this.numChunks; ) {
      const i = this.chunkIterator.next();
      if (!i.done)
        return i;
      ++this.chunkIndex < this.numChunks && (this.chunkIterator = this.getChunkIterator(this.chunkIndex));
    }
    return { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function computeChunkNullable(o) {
  return o.some((i) => i.nullable);
}
function computeChunkNullCounts(o) {
  return o.reduce((i, g) => i + g.nullCount, 0);
}
function computeChunkOffsets(o) {
  return o.reduce((i, g, E) => (i[E + 1] = i[E] + g.length, i), new Uint32Array(o.length + 1));
}
function sliceChunks$1(o, i, g, E) {
  const e = [];
  for (let t = -1, n = o.length; ++t < n; ) {
    const h = o[t], d = i[t], { length: k } = h;
    if (d >= E)
      break;
    if (g >= d + k)
      continue;
    if (d >= g && d + k <= E) {
      e.push(h);
      continue;
    }
    const p = Math.max(0, g - d), M = Math.min(E - d, k);
    e.push(h.slice(p, M - p));
  }
  return e.length === 0 && e.push(o[0].slice(0, 0)), e;
}
function binarySearch(o, i, g, E) {
  let e = 0, t = 0, n = i.length - 1;
  do {
    if (e >= n - 1)
      return g < i[n] ? E(o, e, g - i[e]) : null;
    t = e + Math.trunc((n - e) * 0.5), g < i[t] ? n = t : e = t;
  } while (e < n);
}
function isChunkedValid(o, i) {
  return o.getValid(i);
}
function wrapChunkedCall1(o) {
  function i(g, E, e) {
    return o(g[E], e);
  }
  return function(g) {
    const E = this.data;
    return binarySearch(E, this._offsets, g, i);
  };
}
function wrapChunkedCall2(o) {
  let i;
  function g(E, e, t) {
    return o(E[e], t, i);
  }
  return function(E, e) {
    const t = this.data;
    i = e;
    const n = binarySearch(t, this._offsets, E, g);
    return i = void 0, n;
  };
}
function wrapChunkedIndexOf(o) {
  let i;
  function g(E, e, t) {
    let n = t, h = 0, d = 0;
    for (let k = e - 1, p = E.length; ++k < p; ) {
      const M = E[k];
      if (~(h = o(M, i, n)))
        return d + h;
      n = 0, d += M.length;
    }
    return -1;
  }
  return function(E, e) {
    i = E;
    const t = this.data, n = typeof e != "number" ? g(t, 0, 0) : binarySearch(t, this._offsets, e, g);
    return i = void 0, n;
  };
}
class IndexOfVisitor extends Visitor {
}
function nullIndexOf(o, i) {
  return i === null && o.length > 0 ? 0 : -1;
}
function indexOfNull(o, i) {
  const { nullBitmap: g } = o;
  if (!g || o.nullCount <= 0)
    return -1;
  let E = 0;
  for (const e of new BitIterator(g, o.offset + (i || 0), o.length, g, getBool)) {
    if (!e)
      return E;
    ++E;
  }
  return -1;
}
function indexOfValue(o, i, g) {
  if (i === void 0)
    return -1;
  if (i === null)
    switch (o.typeId) {
      // Unions don't have a nullBitmap of its own, so compare the `searchElement` to `get()`.
      case Type.Union:
        break;
      // Dictionaries do have a nullBitmap, but their dictionary could also have null elements.
      case Type.Dictionary:
        break;
      // All other types can iterate the null bitmap
      default:
        return indexOfNull(o, g);
    }
  const E = instance$4.getVisitFn(o), e = createElementComparator(i);
  for (let t = (g || 0) - 1, n = o.length; ++t < n; )
    if (e(E(o, t)))
      return t;
  return -1;
}
function indexOfUnion(o, i, g) {
  const E = instance$4.getVisitFn(o), e = createElementComparator(i);
  for (let t = (g || 0) - 1, n = o.length; ++t < n; )
    if (e(E(o, t)))
      return t;
  return -1;
}
IndexOfVisitor.prototype.visitNull = nullIndexOf;
IndexOfVisitor.prototype.visitBool = indexOfValue;
IndexOfVisitor.prototype.visitInt = indexOfValue;
IndexOfVisitor.prototype.visitInt8 = indexOfValue;
IndexOfVisitor.prototype.visitInt16 = indexOfValue;
IndexOfVisitor.prototype.visitInt32 = indexOfValue;
IndexOfVisitor.prototype.visitInt64 = indexOfValue;
IndexOfVisitor.prototype.visitUint8 = indexOfValue;
IndexOfVisitor.prototype.visitUint16 = indexOfValue;
IndexOfVisitor.prototype.visitUint32 = indexOfValue;
IndexOfVisitor.prototype.visitUint64 = indexOfValue;
IndexOfVisitor.prototype.visitFloat = indexOfValue;
IndexOfVisitor.prototype.visitFloat16 = indexOfValue;
IndexOfVisitor.prototype.visitFloat32 = indexOfValue;
IndexOfVisitor.prototype.visitFloat64 = indexOfValue;
IndexOfVisitor.prototype.visitUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitLargeUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitBinary = indexOfValue;
IndexOfVisitor.prototype.visitLargeBinary = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeBinary = indexOfValue;
IndexOfVisitor.prototype.visitDate = indexOfValue;
IndexOfVisitor.prototype.visitDateDay = indexOfValue;
IndexOfVisitor.prototype.visitDateMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestamp = indexOfValue;
IndexOfVisitor.prototype.visitTimestampSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitTime = indexOfValue;
IndexOfVisitor.prototype.visitTimeSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitDecimal = indexOfValue;
IndexOfVisitor.prototype.visitList = indexOfValue;
IndexOfVisitor.prototype.visitStruct = indexOfValue;
IndexOfVisitor.prototype.visitUnion = indexOfValue;
IndexOfVisitor.prototype.visitDenseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitSparseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitDictionary = indexOfValue;
IndexOfVisitor.prototype.visitInterval = indexOfValue;
IndexOfVisitor.prototype.visitIntervalDayTime = indexOfValue;
IndexOfVisitor.prototype.visitIntervalYearMonth = indexOfValue;
IndexOfVisitor.prototype.visitIntervalMonthDayNano = indexOfValue;
IndexOfVisitor.prototype.visitDuration = indexOfValue;
IndexOfVisitor.prototype.visitDurationSecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeList = indexOfValue;
IndexOfVisitor.prototype.visitMap = indexOfValue;
const instance$3 = new IndexOfVisitor();
class IteratorVisitor extends Visitor {
}
function vectorIterator(o) {
  const { type: i } = o;
  if (o.nullCount === 0 && o.stride === 1 && // Don't defer to native iterator for timestamps since Numbers are expected
  // (DataType.isTimestamp(type)) && type.unit === TimeUnit.MILLISECOND ||
  (DataType.isInt(i) && i.bitWidth !== 64 || DataType.isTime(i) && i.bitWidth !== 64 || DataType.isFloat(i) && i.precision !== Precision.HALF))
    return new ChunkedIterator(o.data.length, (E) => {
      const e = o.data[E];
      return e.values.subarray(0, e.length)[Symbol.iterator]();
    });
  let g = 0;
  return new ChunkedIterator(o.data.length, (E) => {
    const t = o.data[E].length, n = o.slice(g, g + t);
    return g += t, new VectorIterator(n);
  });
}
class VectorIterator {
  constructor(i) {
    this.vector = i, this.index = 0;
  }
  next() {
    return this.index < this.vector.length ? {
      value: this.vector.get(this.index++)
    } : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
IteratorVisitor.prototype.visitNull = vectorIterator;
IteratorVisitor.prototype.visitBool = vectorIterator;
IteratorVisitor.prototype.visitInt = vectorIterator;
IteratorVisitor.prototype.visitInt8 = vectorIterator;
IteratorVisitor.prototype.visitInt16 = vectorIterator;
IteratorVisitor.prototype.visitInt32 = vectorIterator;
IteratorVisitor.prototype.visitInt64 = vectorIterator;
IteratorVisitor.prototype.visitUint8 = vectorIterator;
IteratorVisitor.prototype.visitUint16 = vectorIterator;
IteratorVisitor.prototype.visitUint32 = vectorIterator;
IteratorVisitor.prototype.visitUint64 = vectorIterator;
IteratorVisitor.prototype.visitFloat = vectorIterator;
IteratorVisitor.prototype.visitFloat16 = vectorIterator;
IteratorVisitor.prototype.visitFloat32 = vectorIterator;
IteratorVisitor.prototype.visitFloat64 = vectorIterator;
IteratorVisitor.prototype.visitUtf8 = vectorIterator;
IteratorVisitor.prototype.visitLargeUtf8 = vectorIterator;
IteratorVisitor.prototype.visitBinary = vectorIterator;
IteratorVisitor.prototype.visitLargeBinary = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeBinary = vectorIterator;
IteratorVisitor.prototype.visitDate = vectorIterator;
IteratorVisitor.prototype.visitDateDay = vectorIterator;
IteratorVisitor.prototype.visitDateMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestamp = vectorIterator;
IteratorVisitor.prototype.visitTimestampSecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampNanosecond = vectorIterator;
IteratorVisitor.prototype.visitTime = vectorIterator;
IteratorVisitor.prototype.visitTimeSecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimeNanosecond = vectorIterator;
IteratorVisitor.prototype.visitDecimal = vectorIterator;
IteratorVisitor.prototype.visitList = vectorIterator;
IteratorVisitor.prototype.visitStruct = vectorIterator;
IteratorVisitor.prototype.visitUnion = vectorIterator;
IteratorVisitor.prototype.visitDenseUnion = vectorIterator;
IteratorVisitor.prototype.visitSparseUnion = vectorIterator;
IteratorVisitor.prototype.visitDictionary = vectorIterator;
IteratorVisitor.prototype.visitInterval = vectorIterator;
IteratorVisitor.prototype.visitIntervalDayTime = vectorIterator;
IteratorVisitor.prototype.visitIntervalYearMonth = vectorIterator;
IteratorVisitor.prototype.visitIntervalMonthDayNano = vectorIterator;
IteratorVisitor.prototype.visitDuration = vectorIterator;
IteratorVisitor.prototype.visitDurationSecond = vectorIterator;
IteratorVisitor.prototype.visitDurationMillisecond = vectorIterator;
IteratorVisitor.prototype.visitDurationMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitDurationNanosecond = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeList = vectorIterator;
IteratorVisitor.prototype.visitMap = vectorIterator;
const instance$2 = new IteratorVisitor();
var _a$3;
const visitorsByTypeId = {}, vectorPrototypesByTypeId = {};
class Vector {
  constructor(i) {
    var g, E, e;
    const t = i[0] instanceof Vector ? i.flatMap((h) => h.data) : i;
    if (t.length === 0 || t.some((h) => !(h instanceof Data)))
      throw new TypeError("Vector constructor expects an Array of Data instances.");
    const n = (g = t[0]) === null || g === void 0 ? void 0 : g.type;
    switch (t.length) {
      case 0:
        this._offsets = [0];
        break;
      case 1: {
        const { get: h, set: d, indexOf: k } = visitorsByTypeId[n.typeId], p = t[0];
        this.isValid = (M) => isChunkedValid(p, M), this.get = (M) => h(p, M), this.set = (M, H) => d(p, M, H), this.indexOf = (M) => k(p, M), this._offsets = [0, p.length];
        break;
      }
      default:
        Object.setPrototypeOf(this, vectorPrototypesByTypeId[n.typeId]), this._offsets = computeChunkOffsets(t);
        break;
    }
    this.data = t, this.type = n, this.stride = strideForType(n), this.numChildren = (e = (E = n.children) === null || E === void 0 ? void 0 : E.length) !== null && e !== void 0 ? e : 0, this.length = this._offsets.at(-1);
  }
  /**
   * The aggregate size (in bytes) of this Vector's buffers and/or child Vectors.
   */
  get byteLength() {
    return this.data.reduce((i, g) => i + g.byteLength, 0);
  }
  /**
   * Whether this Vector's elements can contain null values.
   */
  get nullable() {
    return computeChunkNullable(this.data);
  }
  /**
   * The number of null elements in this Vector.
   */
  get nullCount() {
    return computeChunkNullCounts(this.data);
  }
  /**
   * The Array or TypedArray constructor used for the JS representation
   *  of the element's values in {@link Vector.prototype.toArray `toArray()`}.
   */
  get ArrayType() {
    return this.type.ArrayType;
  }
  /**
   * The name that should be printed when the Vector is logged in a message.
   */
  get [Symbol.toStringTag]() {
    return `${this.VectorName}<${this.type[Symbol.toStringTag]}>`;
  }
  /**
   * The name of this Vector.
   */
  get VectorName() {
    return `${Type[this.type.typeId]}Vector`;
  }
  /**
   * Check whether an element is null.
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(i) {
    return !1;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(i) {
    return null;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read. A negative index will count back from the last element.
   */
  at(i) {
    return this.get(wrapIndex(i, this.length));
  }
  /**
   * Set an element value by position.
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(i, g) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(i, g) {
    return -1;
  }
  includes(i, g) {
    return this.indexOf(i, g) > -1;
  }
  /**
   * Iterator for the Vector's elements.
   */
  [Symbol.iterator]() {
    return instance$2.visit(this);
  }
  /**
   * Combines two or more Vectors of the same type.
   * @param others Additional Vectors to add to the end of this Vector.
   */
  concat(...i) {
    return new Vector(this.data.concat(i.flatMap((g) => g.data).flat(Number.POSITIVE_INFINITY)));
  }
  /**
   * Return a zero-copy sub-section of this Vector.
   * @param start The beginning of the specified portion of the Vector.
   * @param end The end of the specified portion of the Vector. This is exclusive of the element at the index 'end'.
   */
  slice(i, g) {
    return new Vector(clampRange(this, i, g, ({ data: E, _offsets: e }, t, n) => sliceChunks$1(E, e, t, n)));
  }
  toJSON() {
    return [...this];
  }
  /**
   * Return a JavaScript Array or TypedArray of the Vector's elements.
   *
   * @note If this Vector contains a single Data chunk and the Vector's type is a
   *  primitive numeric type corresponding to one of the JavaScript TypedArrays, this
   *  method returns a zero-copy slice of the underlying TypedArray values. If there's
   *  more than one chunk, the resulting TypedArray will be a copy of the data from each
   *  chunk's underlying TypedArray values.
   *
   * @returns An Array or TypedArray of the Vector's elements, based on the Vector's DataType.
   */
  toArray() {
    const { type: i, data: g, length: E, stride: e, ArrayType: t } = this;
    switch (i.typeId) {
      case Type.Int:
      case Type.Float:
      case Type.Decimal:
      case Type.Time:
      case Type.Timestamp:
        switch (g.length) {
          case 0:
            return new t();
          case 1:
            return g[0].values.subarray(0, E * e);
          default:
            return g.reduce((n, { values: h, length: d }) => (n.array.set(h.subarray(0, d * e), n.offset), n.offset += d * e, n), { array: new t(E * e), offset: 0 }).array;
        }
    }
    return [...this];
  }
  /**
   * Returns a string representation of the Vector.
   *
   * @returns A string representation of the Vector.
   */
  toString() {
    return `[${[...this].join(",")}]`;
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(i) {
    var g;
    return this.getChildAt((g = this.type.children) === null || g === void 0 ? void 0 : g.findIndex((E) => E.name === i));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(i) {
    return i > -1 && i < this.numChildren ? new Vector(this.data.map(({ children: g }) => g[i])) : null;
  }
  get isMemoized() {
    return DataType.isDictionary(this.type) ? this.data[0].dictionary.isMemoized : !1;
  }
  /**
   * Adds memoization to the Vector's {@link get} method. For dictionary
   * vectors, this method return a vector that memoizes only the dictionary
   * values.
   *
   * Memoization is very useful when decoding a value is expensive such as
   * Utf8. The memoization creates a cache of the size of the Vector and
   * therefore increases memory usage.
   *
   * @returns A new vector that memoizes calls to {@link get}.
   */
  memoize() {
    if (DataType.isDictionary(this.type)) {
      const i = new MemoizedVector(this.data[0].dictionary), g = this.data.map((E) => {
        const e = E.clone();
        return e.dictionary = i, e;
      });
      return new Vector(g);
    }
    return new MemoizedVector(this);
  }
  /**
   * Returns a vector without memoization of the {@link get} method. If this
   * vector is not memoized, this method returns this vector.
   *
   * @returns A new vector without memoization.
   */
  unmemoize() {
    if (DataType.isDictionary(this.type) && this.isMemoized) {
      const i = this.data[0].dictionary.unmemoize(), g = this.data.map((E) => {
        const e = E.clone();
        return e.dictionary = i, e;
      });
      return new Vector(g);
    }
    return this;
  }
}
_a$3 = Symbol.toStringTag;
Vector[_a$3] = ((o) => {
  o.type = DataType.prototype, o.data = [], o.length = 0, o.stride = 1, o.numChildren = 0, o._offsets = new Uint32Array([0]), o[Symbol.isConcatSpreadable] = !0;
  const i = Object.keys(Type).map((g) => Type[g]).filter((g) => typeof g == "number" && g !== Type.NONE);
  for (const g of i) {
    const E = instance$4.getVisitFnByTypeId(g), e = instance$5.getVisitFnByTypeId(g), t = instance$3.getVisitFnByTypeId(g);
    visitorsByTypeId[g] = { get: E, set: e, indexOf: t }, vectorPrototypesByTypeId[g] = Object.create(o, {
      isValid: { value: wrapChunkedCall1(isChunkedValid) },
      get: { value: wrapChunkedCall1(instance$4.getVisitFnByTypeId(g)) },
      set: { value: wrapChunkedCall2(instance$5.getVisitFnByTypeId(g)) },
      indexOf: { value: wrapChunkedIndexOf(instance$3.getVisitFnByTypeId(g)) }
    });
  }
  return "Vector";
})(Vector.prototype);
class MemoizedVector extends Vector {
  constructor(i) {
    super(i.data);
    const g = this.get, E = this.set, e = this.slice, t = new Array(this.length);
    Object.defineProperty(this, "get", {
      value(n) {
        const h = t[n];
        if (h !== void 0)
          return h;
        const d = g.call(this, n);
        return t[n] = d, d;
      }
    }), Object.defineProperty(this, "set", {
      value(n, h) {
        E.call(this, n, h), t[n] = h;
      }
    }), Object.defineProperty(this, "slice", {
      value: (n, h) => new MemoizedVector(e.call(this, n, h))
    }), Object.defineProperty(this, "isMemoized", { value: !0 }), Object.defineProperty(this, "unmemoize", {
      value: () => new Vector(this.data)
    }), Object.defineProperty(this, "memoize", {
      value: () => this
    });
  }
}
class Block {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  /**
   * Index to the start of the RecordBlock (note this is past the Message header)
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * Length of the metadata
   */
  metaDataLength() {
    return this.bb.readInt32(this.bb_pos + 8);
  }
  /**
   * Length of the data (this is aligned so there can be a gap between this and
   * the metadata).
   */
  bodyLength() {
    return this.bb.readInt64(this.bb_pos + 16);
  }
  static sizeOf() {
    return 24;
  }
  static createBlock(i, g, E, e) {
    return i.prep(8, 24), i.writeInt64(BigInt(e ?? 0)), i.pad(4), i.writeInt32(E), i.writeInt64(BigInt(g ?? 0)), i.offset();
  }
}
class Footer {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsFooter(i, g) {
    return (g || new Footer()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsFooter(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Footer()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  version() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : MetadataVersion.V1;
  }
  schema(i) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? (i || new Schema$3()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  dictionaries(i, g) {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? (g || new Block()).__init(this.bb.__vector(this.bb_pos + E) + i * 24, this.bb) : null;
  }
  dictionariesLength() {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  recordBatches(i, g) {
    const E = this.bb.__offset(this.bb_pos, 10);
    return E ? (g || new Block()).__init(this.bb.__vector(this.bb_pos + E) + i * 24, this.bb) : null;
  }
  recordBatchesLength() {
    const i = this.bb.__offset(this.bb_pos, 10);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(i, g) {
    const E = this.bb.__offset(this.bb_pos, 12);
    return E ? (g || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + E) + i * 4), this.bb) : null;
  }
  customMetadataLength() {
    const i = this.bb.__offset(this.bb_pos, 12);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  static startFooter(i) {
    i.startObject(5);
  }
  static addVersion(i, g) {
    i.addFieldInt16(0, g, MetadataVersion.V1);
  }
  static addSchema(i, g) {
    i.addFieldOffset(1, g, 0);
  }
  static addDictionaries(i, g) {
    i.addFieldOffset(2, g, 0);
  }
  static startDictionariesVector(i, g) {
    i.startVector(24, g, 8);
  }
  static addRecordBatches(i, g) {
    i.addFieldOffset(3, g, 0);
  }
  static startRecordBatchesVector(i, g) {
    i.startVector(24, g, 8);
  }
  static addCustomMetadata(i, g) {
    i.addFieldOffset(4, g, 0);
  }
  static createCustomMetadataVector(i, g) {
    i.startVector(4, g.length, 4);
    for (let E = g.length - 1; E >= 0; E--)
      i.addOffset(g[E]);
    return i.endVector();
  }
  static startCustomMetadataVector(i, g) {
    i.startVector(4, g, 4);
  }
  static endFooter(i) {
    return i.endObject();
  }
  static finishFooterBuffer(i, g) {
    i.finish(g);
  }
  static finishSizePrefixedFooterBuffer(i, g) {
    i.finish(g, void 0, !0);
  }
}
let Schema$2 = class Ug {
  constructor(i = [], g, E, e = MetadataVersion.V5) {
    this.fields = i || [], this.metadata = g || /* @__PURE__ */ new Map(), E || (E = generateDictionaryMap(this.fields)), this.dictionaries = E, this.metadataVersion = e;
  }
  get [Symbol.toStringTag]() {
    return "Schema";
  }
  get names() {
    return this.fields.map((i) => i.name);
  }
  toString() {
    return `Schema<{ ${this.fields.map((i, g) => `${g}: ${i}`).join(", ")} }>`;
  }
  /**
   * Construct a new Schema containing only specified fields.
   *
   * @param fieldNames Names of fields to keep.
   * @returns A new Schema of fields matching the specified names.
   */
  select(i) {
    const g = new Set(i), E = this.fields.filter((e) => g.has(e.name));
    return new Ug(E, this.metadata);
  }
  /**
   * Construct a new Schema containing only fields at the specified indices.
   *
   * @param fieldIndices Indices of fields to keep.
   * @returns A new Schema of fields at the specified indices.
   */
  selectAt(i) {
    const g = i.map((E) => this.fields[E]).filter(Boolean);
    return new Ug(g, this.metadata);
  }
  assign(...i) {
    const g = i[0] instanceof Ug ? i[0] : Array.isArray(i[0]) ? new Ug(i[0]) : new Ug(i), E = [...this.fields], e = mergeMaps(mergeMaps(/* @__PURE__ */ new Map(), this.metadata), g.metadata), t = g.fields.filter((h) => {
      const d = E.findIndex((k) => k.name === h.name);
      return ~d ? (E[d] = h.clone({
        metadata: mergeMaps(mergeMaps(/* @__PURE__ */ new Map(), E[d].metadata), h.metadata)
      })) && !1 : !0;
    }), n = generateDictionaryMap(t, /* @__PURE__ */ new Map());
    return new Ug([...E, ...t], e, new Map([...this.dictionaries, ...n]));
  }
};
Schema$2.prototype.fields = null;
Schema$2.prototype.metadata = null;
Schema$2.prototype.dictionaries = null;
class Field {
  /** @nocollapse */
  static new(...i) {
    let [g, E, e, t] = i;
    return i[0] && typeof i[0] == "object" && ({ name: g } = i[0], E === void 0 && (E = i[0].type), e === void 0 && (e = i[0].nullable), t === void 0 && (t = i[0].metadata)), new Field(`${g}`, E, e, t);
  }
  constructor(i, g, E = !1, e) {
    this.name = i, this.type = g, this.nullable = E, this.metadata = e || /* @__PURE__ */ new Map();
  }
  get typeId() {
    return this.type.typeId;
  }
  get [Symbol.toStringTag]() {
    return "Field";
  }
  toString() {
    return `${this.name}: ${this.type}`;
  }
  clone(...i) {
    let [g, E, e, t] = i;
    return !i[0] || typeof i[0] != "object" ? [g = this.name, E = this.type, e = this.nullable, t = this.metadata] = i : { name: g = this.name, type: E = this.type, nullable: e = this.nullable, metadata: t = this.metadata } = i[0], Field.new(g, E, e, t);
  }
}
Field.prototype.type = null;
Field.prototype.name = null;
Field.prototype.nullable = null;
Field.prototype.metadata = null;
function mergeMaps(o, i) {
  return new Map([...o || /* @__PURE__ */ new Map(), ...i || /* @__PURE__ */ new Map()]);
}
function generateDictionaryMap(o, i = /* @__PURE__ */ new Map()) {
  for (let g = -1, E = o.length; ++g < E; ) {
    const t = o[g].type;
    if (DataType.isDictionary(t)) {
      if (!i.has(t.id))
        i.set(t.id, t.dictionary);
      else if (i.get(t.id) !== t.dictionary)
        throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
    }
    t.children && t.children.length > 0 && generateDictionaryMap(t.children, i);
  }
  return i;
}
var Builder$1 = Builder$2, ByteBuffer$1 = ByteBuffer$2;
class Footer_ {
  /** @nocollapse */
  static decode(i) {
    i = new ByteBuffer$1(toUint8Array(i));
    const g = Footer.getRootAsFooter(i), E = Schema$2.decode(g.schema(), /* @__PURE__ */ new Map(), g.version());
    return new OffHeapFooter(E, g);
  }
  /** @nocollapse */
  static encode(i) {
    const g = new Builder$1(), E = Schema$2.encode(g, i.schema);
    Footer.startRecordBatchesVector(g, i.numRecordBatches);
    for (const n of [...i.recordBatches()].slice().reverse())
      FileBlock.encode(g, n);
    const e = g.endVector();
    Footer.startDictionariesVector(g, i.numDictionaries);
    for (const n of [...i.dictionaryBatches()].slice().reverse())
      FileBlock.encode(g, n);
    const t = g.endVector();
    return Footer.startFooter(g), Footer.addSchema(g, E), Footer.addVersion(g, MetadataVersion.V5), Footer.addRecordBatches(g, e), Footer.addDictionaries(g, t), Footer.finishFooterBuffer(g, Footer.endFooter(g)), g.asUint8Array();
  }
  get numRecordBatches() {
    return this._recordBatches.length;
  }
  get numDictionaries() {
    return this._dictionaryBatches.length;
  }
  constructor(i, g = MetadataVersion.V5, E, e) {
    this.schema = i, this.version = g, E && (this._recordBatches = E), e && (this._dictionaryBatches = e);
  }
  *recordBatches() {
    for (let i, g = -1, E = this.numRecordBatches; ++g < E; )
      (i = this.getRecordBatch(g)) && (yield i);
  }
  *dictionaryBatches() {
    for (let i, g = -1, E = this.numDictionaries; ++g < E; )
      (i = this.getDictionaryBatch(g)) && (yield i);
  }
  getRecordBatch(i) {
    return i >= 0 && i < this.numRecordBatches && this._recordBatches[i] || null;
  }
  getDictionaryBatch(i) {
    return i >= 0 && i < this.numDictionaries && this._dictionaryBatches[i] || null;
  }
}
class OffHeapFooter extends Footer_ {
  get numRecordBatches() {
    return this._footer.recordBatchesLength();
  }
  get numDictionaries() {
    return this._footer.dictionariesLength();
  }
  constructor(i, g) {
    super(i, g.version()), this._footer = g;
  }
  getRecordBatch(i) {
    if (i >= 0 && i < this.numRecordBatches) {
      const g = this._footer.recordBatches(i);
      if (g)
        return FileBlock.decode(g);
    }
    return null;
  }
  getDictionaryBatch(i) {
    if (i >= 0 && i < this.numDictionaries) {
      const g = this._footer.dictionaries(i);
      if (g)
        return FileBlock.decode(g);
    }
    return null;
  }
}
class FileBlock {
  /** @nocollapse */
  static decode(i) {
    return new FileBlock(i.metaDataLength(), i.bodyLength(), i.offset());
  }
  /** @nocollapse */
  static encode(i, g) {
    const { metaDataLength: E } = g, e = BigInt(g.offset), t = BigInt(g.bodyLength);
    return Block.createBlock(i, e, E, t);
  }
  constructor(i, g, E) {
    this.metaDataLength = i, this.offset = bigIntToNumber(E), this.bodyLength = bigIntToNumber(g);
  }
}
let Message$1 = class Rg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(i, g) {
    return this.bb_pos = i, this.bb = g, this;
  }
  static getRootAsMessage(i, g) {
    return (g || new Rg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  static getSizePrefixedRootAsMessage(i, g) {
    return i.setPosition(i.position() + SIZE_PREFIX_LENGTH), (g || new Rg()).__init(i.readInt32(i.position()) + i.position(), i);
  }
  version() {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readInt16(this.bb_pos + i) : MetadataVersion.V1;
  }
  headerType() {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.readUint8(this.bb_pos + i) : MessageHeader.NONE;
  }
  header(i) {
    const g = this.bb.__offset(this.bb_pos, 8);
    return g ? this.bb.__union(i, this.bb_pos + g) : null;
  }
  bodyLength() {
    const i = this.bb.__offset(this.bb_pos, 10);
    return i ? this.bb.readInt64(this.bb_pos + i) : BigInt("0");
  }
  customMetadata(i, g) {
    const E = this.bb.__offset(this.bb_pos, 12);
    return E ? (g || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + E) + i * 4), this.bb) : null;
  }
  customMetadataLength() {
    const i = this.bb.__offset(this.bb_pos, 12);
    return i ? this.bb.__vector_len(this.bb_pos + i) : 0;
  }
  static startMessage(i) {
    i.startObject(5);
  }
  static addVersion(i, g) {
    i.addFieldInt16(0, g, MetadataVersion.V1);
  }
  static addHeaderType(i, g) {
    i.addFieldInt8(1, g, MessageHeader.NONE);
  }
  static addHeader(i, g) {
    i.addFieldOffset(2, g, 0);
  }
  static addBodyLength(i, g) {
    i.addFieldInt64(3, g, BigInt("0"));
  }
  static addCustomMetadata(i, g) {
    i.addFieldOffset(4, g, 0);
  }
  static createCustomMetadataVector(i, g) {
    i.startVector(4, g.length, 4);
    for (let E = g.length - 1; E >= 0; E--)
      i.addOffset(g[E]);
    return i.endVector();
  }
  static startCustomMetadataVector(i, g) {
    i.startVector(4, g, 4);
  }
  static endMessage(i) {
    return i.endObject();
  }
  static finishMessageBuffer(i, g) {
    i.finish(g);
  }
  static finishSizePrefixedMessageBuffer(i, g) {
    i.finish(g, void 0, !0);
  }
  static createMessage(i, g, E, e, t, n) {
    return Rg.startMessage(i), Rg.addVersion(i, g), Rg.addHeaderType(i, E), Rg.addHeader(i, e), Rg.addBodyLength(i, t), Rg.addCustomMetadata(i, n), Rg.endMessage(i);
  }
};
class TypeAssembler extends Visitor {
  visit(i, g) {
    return i == null || g == null ? void 0 : super.visit(i, g);
  }
  visitNull(i, g) {
    return Null$1.startNull(g), Null$1.endNull(g);
  }
  visitInt(i, g) {
    return Int.startInt(g), Int.addBitWidth(g, i.bitWidth), Int.addIsSigned(g, i.isSigned), Int.endInt(g);
  }
  visitFloat(i, g) {
    return FloatingPoint.startFloatingPoint(g), FloatingPoint.addPrecision(g, i.precision), FloatingPoint.endFloatingPoint(g);
  }
  visitBinary(i, g) {
    return Binary$1.startBinary(g), Binary$1.endBinary(g);
  }
  visitLargeBinary(i, g) {
    return LargeBinary$1.startLargeBinary(g), LargeBinary$1.endLargeBinary(g);
  }
  visitBool(i, g) {
    return Bool$1.startBool(g), Bool$1.endBool(g);
  }
  visitUtf8(i, g) {
    return Utf8$1.startUtf8(g), Utf8$1.endUtf8(g);
  }
  visitLargeUtf8(i, g) {
    return LargeUtf8$1.startLargeUtf8(g), LargeUtf8$1.endLargeUtf8(g);
  }
  visitDecimal(i, g) {
    return Decimal$1.startDecimal(g), Decimal$1.addScale(g, i.scale), Decimal$1.addPrecision(g, i.precision), Decimal$1.addBitWidth(g, i.bitWidth), Decimal$1.endDecimal(g);
  }
  visitDate(i, g) {
    return Date$1.startDate(g), Date$1.addUnit(g, i.unit), Date$1.endDate(g);
  }
  visitTime(i, g) {
    return Time.startTime(g), Time.addUnit(g, i.unit), Time.addBitWidth(g, i.bitWidth), Time.endTime(g);
  }
  visitTimestamp(i, g) {
    const E = i.timezone && g.createString(i.timezone) || void 0;
    return Timestamp.startTimestamp(g), Timestamp.addUnit(g, i.unit), E !== void 0 && Timestamp.addTimezone(g, E), Timestamp.endTimestamp(g);
  }
  visitInterval(i, g) {
    return Interval.startInterval(g), Interval.addUnit(g, i.unit), Interval.endInterval(g);
  }
  visitDuration(i, g) {
    return Duration$1.startDuration(g), Duration$1.addUnit(g, i.unit), Duration$1.endDuration(g);
  }
  visitList(i, g) {
    return List$1.startList(g), List$1.endList(g);
  }
  visitStruct(i, g) {
    return Struct_.startStruct_(g), Struct_.endStruct_(g);
  }
  visitUnion(i, g) {
    Union.startTypeIdsVector(g, i.typeIds.length);
    const E = Union.createTypeIdsVector(g, i.typeIds);
    return Union.startUnion(g), Union.addMode(g, i.mode), Union.addTypeIds(g, E), Union.endUnion(g);
  }
  visitDictionary(i, g) {
    const E = this.visit(i.indices, g);
    return DictionaryEncoding.startDictionaryEncoding(g), DictionaryEncoding.addId(g, BigInt(i.id)), DictionaryEncoding.addIsOrdered(g, i.isOrdered), E !== void 0 && DictionaryEncoding.addIndexType(g, E), DictionaryEncoding.endDictionaryEncoding(g);
  }
  visitFixedSizeBinary(i, g) {
    return FixedSizeBinary$1.startFixedSizeBinary(g), FixedSizeBinary$1.addByteWidth(g, i.byteWidth), FixedSizeBinary$1.endFixedSizeBinary(g);
  }
  visitFixedSizeList(i, g) {
    return FixedSizeList$2.startFixedSizeList(g), FixedSizeList$2.addListSize(g, i.listSize), FixedSizeList$2.endFixedSizeList(g);
  }
  visitMap(i, g) {
    return Map$1.startMap(g), Map$1.addKeysSorted(g, i.keysSorted), Map$1.endMap(g);
  }
}
const instance$1 = new TypeAssembler();
function schemaFromJSON(o, i = /* @__PURE__ */ new Map()) {
  return new Schema$2(schemaFieldsFromJSON(o, i), customMetadataFromJSON(o.metadata), i);
}
function recordBatchFromJSON(o) {
  return new RecordBatch$2(o.count, fieldNodesFromJSON(o.columns), buffersFromJSON(o.columns), null);
}
function dictionaryBatchFromJSON(o) {
  return new DictionaryBatch(recordBatchFromJSON(o.data), o.id, o.isDelta);
}
function schemaFieldsFromJSON(o, i) {
  return (o.fields || []).filter(Boolean).map((g) => Field.fromJSON(g, i));
}
function fieldChildrenFromJSON(o, i) {
  return (o.children || []).filter(Boolean).map((g) => Field.fromJSON(g, i));
}
function fieldNodesFromJSON(o) {
  return (o || []).reduce((i, g) => [
    ...i,
    new FieldNode(g.count, nullCountFromJSON(g.VALIDITY)),
    ...fieldNodesFromJSON(g.children)
  ], []);
}
function buffersFromJSON(o, i = []) {
  for (let g = -1, E = (o || []).length; ++g < E; ) {
    const e = o[g];
    e.VALIDITY && i.push(new BufferRegion(i.length, e.VALIDITY.length)), e.TYPE_ID && i.push(new BufferRegion(i.length, e.TYPE_ID.length)), e.OFFSET && i.push(new BufferRegion(i.length, e.OFFSET.length)), e.DATA && i.push(new BufferRegion(i.length, e.DATA.length)), i = buffersFromJSON(e.children, i);
  }
  return i;
}
function nullCountFromJSON(o) {
  return (o || []).reduce((i, g) => i + +(g === 0), 0);
}
function fieldFromJSON(o, i) {
  let g, E, e, t, n, h;
  return !i || !(t = o.dictionary) ? (n = typeFromJSON(o, fieldChildrenFromJSON(o, i)), e = new Field(o.name, n, o.nullable, customMetadataFromJSON(o.metadata))) : i.has(g = t.id) ? (E = (E = t.indexType) ? indexTypeFromJSON(E) : new Int32(), h = new Dictionary(i.get(g), E, g, t.isOrdered), e = new Field(o.name, h, o.nullable, customMetadataFromJSON(o.metadata))) : (E = (E = t.indexType) ? indexTypeFromJSON(E) : new Int32(), i.set(g, n = typeFromJSON(o, fieldChildrenFromJSON(o, i))), h = new Dictionary(n, E, g, t.isOrdered), e = new Field(o.name, h, o.nullable, customMetadataFromJSON(o.metadata))), e || null;
}
function customMetadataFromJSON(o = []) {
  return new Map(o.map(({ key: i, value: g }) => [i, g]));
}
function indexTypeFromJSON(o) {
  return new Int_(o.isSigned, o.bitWidth);
}
function typeFromJSON(o, i) {
  const g = o.type.name;
  switch (g) {
    case "NONE":
      return new Null();
    case "null":
      return new Null();
    case "binary":
      return new Binary();
    case "largebinary":
      return new LargeBinary();
    case "utf8":
      return new Utf8();
    case "largeutf8":
      return new LargeUtf8();
    case "bool":
      return new Bool();
    case "list":
      return new List((i || [])[0]);
    case "struct":
      return new Struct(i || []);
    case "struct_":
      return new Struct(i || []);
  }
  switch (g) {
    case "int": {
      const E = o.type;
      return new Int_(E.isSigned, E.bitWidth);
    }
    case "floatingpoint": {
      const E = o.type;
      return new Float(Precision[E.precision]);
    }
    case "decimal": {
      const E = o.type;
      return new Decimal(E.scale, E.precision, E.bitWidth);
    }
    case "date": {
      const E = o.type;
      return new Date_(DateUnit[E.unit]);
    }
    case "time": {
      const E = o.type;
      return new Time_(TimeUnit[E.unit], E.bitWidth);
    }
    case "timestamp": {
      const E = o.type;
      return new Timestamp_(TimeUnit[E.unit], E.timezone);
    }
    case "interval": {
      const E = o.type;
      return new Interval_(IntervalUnit[E.unit]);
    }
    case "duration": {
      const E = o.type;
      return new Duration(TimeUnit[E.unit]);
    }
    case "union": {
      const E = o.type, [e, ...t] = (E.mode + "").toLowerCase(), n = e.toUpperCase() + t.join("");
      return new Union_(UnionMode[n], E.typeIds || [], i || []);
    }
    case "fixedsizebinary": {
      const E = o.type;
      return new FixedSizeBinary(E.byteWidth);
    }
    case "fixedsizelist": {
      const E = o.type;
      return new FixedSizeList$1(E.listSize, (i || [])[0]);
    }
    case "map": {
      const E = o.type;
      return new Map_((i || [])[0], E.keysSorted);
    }
  }
  throw new Error(`Unrecognized type: "${g}"`);
}
var Builder = Builder$2, ByteBuffer = ByteBuffer$2;
class Message {
  /** @nocollapse */
  static fromJSON(i, g) {
    const E = new Message(0, MetadataVersion.V5, g);
    return E._createHeader = messageHeaderFromJSON(i, g), E;
  }
  /** @nocollapse */
  static decode(i) {
    i = new ByteBuffer(toUint8Array(i));
    const g = Message$1.getRootAsMessage(i), E = g.bodyLength(), e = g.version(), t = g.headerType(), n = new Message(E, e, t);
    return n._createHeader = decodeMessageHeader(g, t), n;
  }
  /** @nocollapse */
  static encode(i) {
    const g = new Builder();
    let E = -1;
    return i.isSchema() ? E = Schema$2.encode(g, i.header()) : i.isRecordBatch() ? E = RecordBatch$2.encode(g, i.header()) : i.isDictionaryBatch() && (E = DictionaryBatch.encode(g, i.header())), Message$1.startMessage(g), Message$1.addVersion(g, MetadataVersion.V5), Message$1.addHeader(g, E), Message$1.addHeaderType(g, i.headerType), Message$1.addBodyLength(g, BigInt(i.bodyLength)), Message$1.finishMessageBuffer(g, Message$1.endMessage(g)), g.asUint8Array();
  }
  /** @nocollapse */
  static from(i, g = 0) {
    if (i instanceof Schema$2)
      return new Message(0, MetadataVersion.V5, MessageHeader.Schema, i);
    if (i instanceof RecordBatch$2)
      return new Message(g, MetadataVersion.V5, MessageHeader.RecordBatch, i);
    if (i instanceof DictionaryBatch)
      return new Message(g, MetadataVersion.V5, MessageHeader.DictionaryBatch, i);
    throw new Error(`Unrecognized Message header: ${i}`);
  }
  get type() {
    return this.headerType;
  }
  get version() {
    return this._version;
  }
  get headerType() {
    return this._headerType;
  }
  get compression() {
    return this._compression;
  }
  get bodyLength() {
    return this._bodyLength;
  }
  header() {
    return this._createHeader();
  }
  isSchema() {
    return this.headerType === MessageHeader.Schema;
  }
  isRecordBatch() {
    return this.headerType === MessageHeader.RecordBatch;
  }
  isDictionaryBatch() {
    return this.headerType === MessageHeader.DictionaryBatch;
  }
  constructor(i, g, E, e) {
    this._version = g, this._headerType = E, this.body = new Uint8Array(0), this._compression = e?.compression, e && (this._createHeader = () => e), this._bodyLength = bigIntToNumber(i);
  }
}
let RecordBatch$2 = class {
  get nodes() {
    return this._nodes;
  }
  get length() {
    return this._length;
  }
  get buffers() {
    return this._buffers;
  }
  get compression() {
    return this._compression;
  }
  constructor(i, g, E, e) {
    this._nodes = g, this._buffers = E, this._length = bigIntToNumber(i), this._compression = e;
  }
};
class DictionaryBatch {
  get id() {
    return this._id;
  }
  get data() {
    return this._data;
  }
  get isDelta() {
    return this._isDelta;
  }
  get length() {
    return this.data.length;
  }
  get nodes() {
    return this.data.nodes;
  }
  get buffers() {
    return this.data.buffers;
  }
  constructor(i, g, E = !1) {
    this._data = i, this._isDelta = E, this._id = bigIntToNumber(g);
  }
}
class BufferRegion {
  constructor(i, g) {
    this.offset = bigIntToNumber(i), this.length = bigIntToNumber(g);
  }
}
class FieldNode {
  constructor(i, g) {
    this.length = bigIntToNumber(i), this.nullCount = bigIntToNumber(g);
  }
}
class BodyCompression {
  constructor(i, g = BodyCompressionMethod.BUFFER) {
    this.type = i, this.method = g;
  }
}
function messageHeaderFromJSON(o, i) {
  return (() => {
    switch (i) {
      case MessageHeader.Schema:
        return Schema$2.fromJSON(o);
      case MessageHeader.RecordBatch:
        return RecordBatch$2.fromJSON(o);
      case MessageHeader.DictionaryBatch:
        return DictionaryBatch.fromJSON(o);
    }
    throw new Error(`Unrecognized Message type: { name: ${MessageHeader[i]}, type: ${i} }`);
  });
}
function decodeMessageHeader(o, i) {
  return (() => {
    switch (i) {
      case MessageHeader.Schema:
        return Schema$2.decode(o.header(new Schema$3()), /* @__PURE__ */ new Map(), o.version());
      case MessageHeader.RecordBatch:
        return RecordBatch$2.decode(o.header(new RecordBatch$3()), o.version());
      case MessageHeader.DictionaryBatch:
        return DictionaryBatch.decode(o.header(new DictionaryBatch$1()), o.version());
    }
    throw new Error(`Unrecognized Message type: { name: ${MessageHeader[i]}, type: ${i} }`);
  });
}
Field.encode = encodeField;
Field.decode = decodeField;
Field.fromJSON = fieldFromJSON;
Schema$2.encode = encodeSchema;
Schema$2.decode = decodeSchema;
Schema$2.fromJSON = schemaFromJSON;
RecordBatch$2.encode = encodeRecordBatch;
RecordBatch$2.decode = decodeRecordBatch;
RecordBatch$2.fromJSON = recordBatchFromJSON;
DictionaryBatch.encode = encodeDictionaryBatch;
DictionaryBatch.decode = decodeDictionaryBatch;
DictionaryBatch.fromJSON = dictionaryBatchFromJSON;
FieldNode.encode = encodeFieldNode;
FieldNode.decode = decodeFieldNode;
BufferRegion.encode = encodeBufferRegion;
BufferRegion.decode = decodeBufferRegion;
BodyCompression.encode = encodeBodyCompression;
BodyCompression.decode = decodeBodyCompression;
function decodeSchema(o, i = /* @__PURE__ */ new Map(), g = MetadataVersion.V5) {
  const E = decodeSchemaFields(o, i);
  return new Schema$2(E, decodeCustomMetadata(o), i, g);
}
function decodeRecordBatch(o, i = MetadataVersion.V5) {
  return new RecordBatch$2(o.length(), decodeFieldNodes(o), decodeBuffers(o, i), decodeBodyCompression(o.compression()));
}
function decodeDictionaryBatch(o, i = MetadataVersion.V5) {
  return new DictionaryBatch(RecordBatch$2.decode(o.data(), i), o.id(), o.isDelta());
}
function decodeBufferRegion(o) {
  return new BufferRegion(o.offset(), o.length());
}
function decodeFieldNode(o) {
  return new FieldNode(o.length(), o.nullCount());
}
function decodeFieldNodes(o) {
  const i = [];
  for (let g, E = -1, e = -1, t = o.nodesLength(); ++E < t; )
    (g = o.nodes(E)) && (i[++e] = FieldNode.decode(g));
  return i;
}
function decodeBuffers(o, i) {
  const g = [];
  for (let E, e = -1, t = -1, n = o.buffersLength(); ++e < n; )
    (E = o.buffers(e)) && (i < MetadataVersion.V4 && (E.bb_pos += 8 * (e + 1)), g[++t] = BufferRegion.decode(E));
  return g;
}
function decodeSchemaFields(o, i) {
  const g = [];
  for (let E, e = -1, t = -1, n = o.fieldsLength(); ++e < n; )
    (E = o.fields(e)) && (g[++t] = Field.decode(E, i));
  return g;
}
function decodeFieldChildren(o, i) {
  const g = [];
  for (let E, e = -1, t = -1, n = o.childrenLength(); ++e < n; )
    (E = o.children(e)) && (g[++t] = Field.decode(E, i));
  return g;
}
function decodeField(o, i) {
  let g, E, e, t, n, h;
  return !i || !(h = o.dictionary()) ? (e = decodeFieldType(o, decodeFieldChildren(o, i)), E = new Field(o.name(), e, o.nullable(), decodeCustomMetadata(o))) : i.has(g = bigIntToNumber(h.id())) ? (t = (t = h.indexType()) ? decodeIndexType(t) : new Int32(), n = new Dictionary(i.get(g), t, g, h.isOrdered()), E = new Field(o.name(), n, o.nullable(), decodeCustomMetadata(o))) : (t = (t = h.indexType()) ? decodeIndexType(t) : new Int32(), i.set(g, e = decodeFieldType(o, decodeFieldChildren(o, i))), n = new Dictionary(e, t, g, h.isOrdered()), E = new Field(o.name(), n, o.nullable(), decodeCustomMetadata(o))), E || null;
}
function decodeCustomMetadata(o) {
  const i = /* @__PURE__ */ new Map();
  if (o)
    for (let g, E, e = -1, t = Math.trunc(o.customMetadataLength()); ++e < t; )
      (g = o.customMetadata(e)) && (E = g.key()) != null && i.set(E, g.value());
  return i;
}
function decodeIndexType(o) {
  return new Int_(o.isSigned(), o.bitWidth());
}
function decodeFieldType(o, i) {
  const g = o.typeType();
  switch (g) {
    case Type$1.NONE:
      return new Null();
    case Type$1.Null:
      return new Null();
    case Type$1.Binary:
      return new Binary();
    case Type$1.LargeBinary:
      return new LargeBinary();
    case Type$1.Utf8:
      return new Utf8();
    case Type$1.LargeUtf8:
      return new LargeUtf8();
    case Type$1.Bool:
      return new Bool();
    case Type$1.List:
      return new List((i || [])[0]);
    case Type$1.Struct_:
      return new Struct(i || []);
  }
  switch (g) {
    case Type$1.Int: {
      const E = o.type(new Int());
      return new Int_(E.isSigned(), E.bitWidth());
    }
    case Type$1.FloatingPoint: {
      const E = o.type(new FloatingPoint());
      return new Float(E.precision());
    }
    case Type$1.Decimal: {
      const E = o.type(new Decimal$1());
      return new Decimal(E.scale(), E.precision(), E.bitWidth());
    }
    case Type$1.Date: {
      const E = o.type(new Date$1());
      return new Date_(E.unit());
    }
    case Type$1.Time: {
      const E = o.type(new Time());
      return new Time_(E.unit(), E.bitWidth());
    }
    case Type$1.Timestamp: {
      const E = o.type(new Timestamp());
      return new Timestamp_(E.unit(), E.timezone());
    }
    case Type$1.Interval: {
      const E = o.type(new Interval());
      return new Interval_(E.unit());
    }
    case Type$1.Duration: {
      const E = o.type(new Duration$1());
      return new Duration(E.unit());
    }
    case Type$1.Union: {
      const E = o.type(new Union());
      return new Union_(E.mode(), E.typeIdsArray() || [], i || []);
    }
    case Type$1.FixedSizeBinary: {
      const E = o.type(new FixedSizeBinary$1());
      return new FixedSizeBinary(E.byteWidth());
    }
    case Type$1.FixedSizeList: {
      const E = o.type(new FixedSizeList$2());
      return new FixedSizeList$1(E.listSize(), (i || [])[0]);
    }
    case Type$1.Map: {
      const E = o.type(new Map$1());
      return new Map_((i || [])[0], E.keysSorted());
    }
  }
  throw new Error(`Unrecognized type: "${Type$1[g]}" (${g})`);
}
function decodeBodyCompression(o) {
  return o ? new BodyCompression(o.codec(), o.method()) : null;
}
function encodeSchema(o, i) {
  const g = i.fields.map((t) => Field.encode(o, t));
  Schema$3.startFieldsVector(o, g.length);
  const E = Schema$3.createFieldsVector(o, g), e = i.metadata && i.metadata.size > 0 ? Schema$3.createCustomMetadataVector(o, [...i.metadata].map(([t, n]) => {
    const h = o.createString(`${t}`), d = o.createString(`${n}`);
    return KeyValue.startKeyValue(o), KeyValue.addKey(o, h), KeyValue.addValue(o, d), KeyValue.endKeyValue(o);
  })) : -1;
  return Schema$3.startSchema(o), Schema$3.addFields(o, E), Schema$3.addEndianness(o, platformIsLittleEndian ? Endianness.Little : Endianness.Big), e !== -1 && Schema$3.addCustomMetadata(o, e), Schema$3.endSchema(o);
}
function encodeField(o, i) {
  let g = -1, E = -1, e = -1;
  const t = i.type;
  let n = i.typeId;
  DataType.isDictionary(t) ? (n = t.dictionary.typeId, e = instance$1.visit(t, o), E = instance$1.visit(t.dictionary, o)) : E = instance$1.visit(t, o);
  const h = (t.children || []).map((p) => Field.encode(o, p)), d = Field$1.createChildrenVector(o, h), k = i.metadata && i.metadata.size > 0 ? Field$1.createCustomMetadataVector(o, [...i.metadata].map(([p, M]) => {
    const H = o.createString(`${p}`), f = o.createString(`${M}`);
    return KeyValue.startKeyValue(o), KeyValue.addKey(o, H), KeyValue.addValue(o, f), KeyValue.endKeyValue(o);
  })) : -1;
  return i.name && (g = o.createString(i.name)), Field$1.startField(o), Field$1.addType(o, E), Field$1.addTypeType(o, n), Field$1.addChildren(o, d), Field$1.addNullable(o, !!i.nullable), g !== -1 && Field$1.addName(o, g), e !== -1 && Field$1.addDictionary(o, e), k !== -1 && Field$1.addCustomMetadata(o, k), Field$1.endField(o);
}
function encodeRecordBatch(o, i) {
  const g = i.nodes || [], E = i.buffers || [];
  RecordBatch$3.startNodesVector(o, g.length);
  for (const h of g.slice().reverse())
    FieldNode.encode(o, h);
  const e = o.endVector();
  RecordBatch$3.startBuffersVector(o, E.length);
  for (const h of E.slice().reverse())
    BufferRegion.encode(o, h);
  const t = o.endVector();
  let n = null;
  return i.compression !== null && (n = encodeBodyCompression(o, i.compression)), RecordBatch$3.startRecordBatch(o), RecordBatch$3.addLength(o, BigInt(i.length)), RecordBatch$3.addNodes(o, e), RecordBatch$3.addBuffers(o, t), i.compression !== null && n && RecordBatch$3.addCompression(o, n), RecordBatch$3.endRecordBatch(o);
}
function encodeBodyCompression(o, i) {
  return BodyCompression$1.startBodyCompression(o), BodyCompression$1.addCodec(o, i.type), BodyCompression$1.addMethod(o, i.method), BodyCompression$1.endBodyCompression(o);
}
function encodeDictionaryBatch(o, i) {
  const g = RecordBatch$2.encode(o, i.data);
  return DictionaryBatch$1.startDictionaryBatch(o), DictionaryBatch$1.addId(o, BigInt(i.id)), DictionaryBatch$1.addIsDelta(o, i.isDelta), DictionaryBatch$1.addData(o, g), DictionaryBatch$1.endDictionaryBatch(o);
}
function encodeFieldNode(o, i) {
  return FieldNode$1.createFieldNode(o, BigInt(i.length), BigInt(i.nullCount));
}
function encodeBufferRegion(o, i) {
  return Buffer$1.createBuffer(o, BigInt(i.offset), BigInt(i.length));
}
const platformIsLittleEndian = (() => {
  const o = new ArrayBuffer(2);
  return new DataView(o).setInt16(
    0,
    256,
    !0
    /* littleEndian */
  ), new Int16Array(o)[0] === 256;
})(), ITERATOR_DONE = Object.freeze({ done: !0, value: void 0 });
class ArrowJSON {
  constructor(i) {
    this._json = i;
  }
  get schema() {
    return this._json.schema;
  }
  get batches() {
    return this._json.batches || [];
  }
  get dictionaries() {
    return this._json.dictionaries || [];
  }
}
class ReadableInterop {
  tee() {
    return this._getDOMStream().tee();
  }
  pipe(i, g) {
    return this._getNodeStream().pipe(i, g);
  }
  pipeTo(i, g) {
    return this._getDOMStream().pipeTo(i, g);
  }
  pipeThrough(i, g) {
    return this._getDOMStream().pipeThrough(i, g);
  }
  _getDOMStream() {
    return this._DOMStream || (this._DOMStream = this.toDOMStream());
  }
  _getNodeStream() {
    return this._nodeStream || (this._nodeStream = this.toNodeStream());
  }
}
class AsyncQueue extends ReadableInterop {
  constructor() {
    super(), this._values = [], this.resolvers = [], this._closedPromise = new Promise((i) => this._closedPromiseResolve = i);
  }
  get closed() {
    return this._closedPromise;
  }
  cancel(i) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.return(i);
    });
  }
  write(i) {
    this._ensureOpen() && (this.resolvers.length <= 0 ? this._values.push(i) : this.resolvers.shift().resolve({ done: !1, value: i }));
  }
  abort(i) {
    this._closedPromiseResolve && (this.resolvers.length <= 0 ? this._error = { error: i } : this.resolvers.shift().reject({ done: !0, value: i }));
  }
  close() {
    if (this._closedPromiseResolve) {
      const { resolvers: i } = this;
      for (; i.length > 0; )
        i.shift().resolve(ITERATOR_DONE);
      this._closedPromiseResolve(), this._closedPromiseResolve = void 0;
    }
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  toDOMStream(i) {
    return streamAdapters.toDOMStream(this._closedPromiseResolve || this._error ? this : this._values, i);
  }
  toNodeStream(i) {
    return streamAdapters.toNodeStream(this._closedPromiseResolve || this._error ? this : this._values, i);
  }
  throw(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.abort(i), ITERATOR_DONE;
    });
  }
  return(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), ITERATOR_DONE;
    });
  }
  read(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(i, "read")).value;
    });
  }
  peek(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(i, "peek")).value;
    });
  }
  next(...i) {
    return this._values.length > 0 ? Promise.resolve({ done: !1, value: this._values.shift() }) : this._error ? Promise.reject({ done: !0, value: this._error.error }) : this._closedPromiseResolve ? new Promise((g, E) => {
      this.resolvers.push({ resolve: g, reject: E });
    }) : Promise.resolve(ITERATOR_DONE);
  }
  _ensureOpen() {
    if (this._closedPromiseResolve)
      return !0;
    throw new Error("AsyncQueue is closed");
  }
}
class AsyncByteQueue extends AsyncQueue {
  write(i) {
    if ((i = toUint8Array(i)).byteLength > 0)
      return super.write(i);
  }
  toString(i = !1) {
    return i ? decodeUtf8(this.toUint8Array(!0)) : this.toUint8Array(!1).then(decodeUtf8);
  }
  toUint8Array(i = !1) {
    return i ? joinUint8Arrays(this._values)[0] : __awaiter(this, void 0, void 0, function* () {
      var g, E, e, t;
      const n = [];
      let h = 0;
      try {
        for (var d = !0, k = __asyncValues(this), p; p = yield k.next(), g = p.done, !g; d = !0) {
          t = p.value, d = !1;
          const M = t;
          n.push(M), h += M.byteLength;
        }
      } catch (M) {
        E = { error: M };
      } finally {
        try {
          !d && !g && (e = k.return) && (yield e.call(k));
        } finally {
          if (E) throw E.error;
        }
      }
      return joinUint8Arrays(n, h)[0];
    });
  }
}
class ByteStream {
  constructor(i) {
    i && (this.source = new ByteStreamSource(streamAdapters.fromIterable(i)));
  }
  [Symbol.iterator]() {
    return this;
  }
  next(i) {
    return this.source.next(i);
  }
  throw(i) {
    return this.source.throw(i);
  }
  return(i) {
    return this.source.return(i);
  }
  peek(i) {
    return this.source.peek(i);
  }
  read(i) {
    return this.source.read(i);
  }
}
class AsyncByteStream {
  constructor(i) {
    i instanceof AsyncByteStream ? this.source = i.source : i instanceof AsyncByteQueue ? this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(i)) : isReadableNodeStream(i) ? this.source = new AsyncByteStreamSource(streamAdapters.fromNodeStream(i)) : isReadableDOMStream(i) ? this.source = new AsyncByteStreamSource(streamAdapters.fromDOMStream(i)) : isFetchResponse(i) ? this.source = new AsyncByteStreamSource(streamAdapters.fromDOMStream(i.body)) : isIterable(i) ? this.source = new AsyncByteStreamSource(streamAdapters.fromIterable(i)) : isPromise(i) ? this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(i)) : isAsyncIterable$1(i) && (this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(i)));
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next(i) {
    return this.source.next(i);
  }
  throw(i) {
    return this.source.throw(i);
  }
  return(i) {
    return this.source.return(i);
  }
  get closed() {
    return this.source.closed;
  }
  cancel(i) {
    return this.source.cancel(i);
  }
  peek(i) {
    return this.source.peek(i);
  }
  read(i) {
    return this.source.read(i);
  }
}
class ByteStreamSource {
  constructor(i) {
    this.source = i;
  }
  cancel(i) {
    this.return(i);
  }
  peek(i) {
    return this.next(i, "peek").value;
  }
  read(i) {
    return this.next(i, "read").value;
  }
  next(i, g = "read") {
    return this.source.next({ cmd: g, size: i });
  }
  throw(i) {
    return Object.create(this.source.throw && this.source.throw(i) || ITERATOR_DONE);
  }
  return(i) {
    return Object.create(this.source.return && this.source.return(i) || ITERATOR_DONE);
  }
}
class AsyncByteStreamSource {
  constructor(i) {
    this.source = i, this._closedPromise = new Promise((g) => this._closedPromiseResolve = g);
  }
  cancel(i) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.return(i);
    });
  }
  get closed() {
    return this._closedPromise;
  }
  read(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(i, "read")).value;
    });
  }
  peek(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(i, "peek")).value;
    });
  }
  next(i) {
    return __awaiter(this, arguments, void 0, function* (g, E = "read") {
      return yield this.source.next({ cmd: E, size: g });
    });
  }
  throw(i) {
    return __awaiter(this, void 0, void 0, function* () {
      const g = this.source.throw && (yield this.source.throw(i)) || ITERATOR_DONE;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(g);
    });
  }
  return(i) {
    return __awaiter(this, void 0, void 0, function* () {
      const g = this.source.return && (yield this.source.return(i)) || ITERATOR_DONE;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(g);
    });
  }
}
class RandomAccessFile extends ByteStream {
  constructor(i, g) {
    super(), this.position = 0, this.buffer = toUint8Array(i), this.size = g === void 0 ? this.buffer.byteLength : g;
  }
  readInt32(i) {
    const { buffer: g, byteOffset: E } = this.readAt(i, 4);
    return new DataView(g, E).getInt32(0, !0);
  }
  seek(i) {
    return this.position = Math.min(i, this.size), i < this.size;
  }
  read(i) {
    const { buffer: g, size: E, position: e } = this;
    return g && e < E ? (typeof i != "number" && (i = Number.POSITIVE_INFINITY), this.position = Math.min(E, e + Math.min(E - e, i)), g.subarray(e, this.position)) : null;
  }
  readAt(i, g) {
    const E = this.buffer, e = Math.min(this.size, i + g);
    return E ? E.subarray(i, e) : new Uint8Array(g);
  }
  close() {
    this.buffer && (this.buffer = null);
  }
  throw(i) {
    return this.close(), { done: !0, value: i };
  }
  return(i) {
    return this.close(), { done: !0, value: i };
  }
}
class AsyncRandomAccessFile extends AsyncByteStream {
  constructor(i, g) {
    super(), this.position = 0, this._handle = i, typeof g == "number" ? this.size = g : this._pending = __awaiter(this, void 0, void 0, function* () {
      this.size = (yield i.stat()).size, delete this._pending;
    });
  }
  readInt32(i) {
    return __awaiter(this, void 0, void 0, function* () {
      const { buffer: g, byteOffset: E } = yield this.readAt(i, 4);
      return new DataView(g, E).getInt32(0, !0);
    });
  }
  seek(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._pending && (yield this._pending), this.position = Math.min(i, this.size), i < this.size;
    });
  }
  read(i) {
    return __awaiter(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: g, size: E, position: e } = this;
      if (g && e < E) {
        typeof i != "number" && (i = Number.POSITIVE_INFINITY);
        let t = e, n = 0, h = 0;
        const d = Math.min(E, t + Math.min(E - t, i)), k = new Uint8Array(Math.max(0, (this.position = d) - t));
        for (; (t += h) < d && (n += h) < k.byteLength; )
          ({ bytesRead: h } = yield g.read(k, n, k.byteLength - n, t));
        return k;
      }
      return null;
    });
  }
  readAt(i, g) {
    return __awaiter(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: E, size: e } = this;
      if (E && i + g < e) {
        const t = Math.min(e, i + g), n = new Uint8Array(t - i);
        return (yield E.read(n, 0, g, i)).buffer;
      }
      return new Uint8Array(g);
    });
  }
  close() {
    return __awaiter(this, void 0, void 0, function* () {
      const i = this._handle;
      this._handle = null, i && (yield i.close());
    });
  }
  throw(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: i };
    });
  }
  return(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: i };
    });
  }
}
const carryBit16 = 65536;
function intAsHex(o) {
  return o < 0 && (o = 4294967295 + o + 1), `0x${o.toString(16)}`;
}
const kInt32DecimalDigits = 8, kPowersOfTen = [
  1,
  10,
  100,
  1e3,
  1e4,
  1e5,
  1e6,
  1e7,
  1e8
];
class BaseInt64 {
  constructor(i) {
    this.buffer = i;
  }
  high() {
    return this.buffer[1];
  }
  low() {
    return this.buffer[0];
  }
  _times(i) {
    const g = new Uint32Array([
      this.buffer[1] >>> 16,
      this.buffer[1] & 65535,
      this.buffer[0] >>> 16,
      this.buffer[0] & 65535
    ]), E = new Uint32Array([
      i.buffer[1] >>> 16,
      i.buffer[1] & 65535,
      i.buffer[0] >>> 16,
      i.buffer[0] & 65535
    ]);
    let e = g[3] * E[3];
    this.buffer[0] = e & 65535;
    let t = e >>> 16;
    return e = g[2] * E[3], t += e, e = g[3] * E[2] >>> 0, t += e, this.buffer[0] += t << 16, this.buffer[1] = t >>> 0 < e ? carryBit16 : 0, this.buffer[1] += t >>> 16, this.buffer[1] += g[1] * E[3] + g[2] * E[2] + g[3] * E[1], this.buffer[1] += g[0] * E[3] + g[1] * E[2] + g[2] * E[1] + g[3] * E[0] << 16, this;
  }
  _plus(i) {
    const g = this.buffer[0] + i.buffer[0] >>> 0;
    this.buffer[1] += i.buffer[1], g < this.buffer[0] >>> 0 && ++this.buffer[1], this.buffer[0] = g;
  }
  lessThan(i) {
    return this.buffer[1] < i.buffer[1] || this.buffer[1] === i.buffer[1] && this.buffer[0] < i.buffer[0];
  }
  equals(i) {
    return this.buffer[1] === i.buffer[1] && this.buffer[0] == i.buffer[0];
  }
  greaterThan(i) {
    return i.lessThan(this);
  }
  hex() {
    return `${intAsHex(this.buffer[1])} ${intAsHex(this.buffer[0])}`;
  }
}
class Uint64 extends BaseInt64 {
  times(i) {
    return this._times(i), this;
  }
  plus(i) {
    return this._plus(i), this;
  }
  /** @nocollapse */
  static from(i, g = new Uint32Array(2)) {
    return Uint64.fromString(typeof i == "string" ? i : i.toString(), g);
  }
  /** @nocollapse */
  static fromNumber(i, g = new Uint32Array(2)) {
    return Uint64.fromString(i.toString(), g);
  }
  /** @nocollapse */
  static fromString(i, g = new Uint32Array(2)) {
    const E = i.length, e = new Uint64(g);
    for (let t = 0; t < E; ) {
      const n = kInt32DecimalDigits < E - t ? kInt32DecimalDigits : E - t, h = new Uint64(new Uint32Array([Number.parseInt(i.slice(t, t + n), 10), 0])), d = new Uint64(new Uint32Array([kPowersOfTen[n], 0]));
      e.times(d), e.plus(h), t += n;
    }
    return e;
  }
  /** @nocollapse */
  static convertArray(i) {
    const g = new Uint32Array(i.length * 2);
    for (let E = -1, e = i.length; ++E < e; )
      Uint64.from(i[E], new Uint32Array(g.buffer, g.byteOffset + 2 * E * 4, 2));
    return g;
  }
  /** @nocollapse */
  static multiply(i, g) {
    return new Uint64(new Uint32Array(i.buffer)).times(g);
  }
  /** @nocollapse */
  static add(i, g) {
    return new Uint64(new Uint32Array(i.buffer)).plus(g);
  }
}
class Int64 extends BaseInt64 {
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[0] == 0 && ++this.buffer[1], this;
  }
  times(i) {
    return this._times(i), this;
  }
  plus(i) {
    return this._plus(i), this;
  }
  lessThan(i) {
    const g = this.buffer[1] << 0, E = i.buffer[1] << 0;
    return g < E || g === E && this.buffer[0] < i.buffer[0];
  }
  /** @nocollapse */
  static from(i, g = new Uint32Array(2)) {
    return Int64.fromString(typeof i == "string" ? i : i.toString(), g);
  }
  /** @nocollapse */
  static fromNumber(i, g = new Uint32Array(2)) {
    return Int64.fromString(i.toString(), g);
  }
  /** @nocollapse */
  static fromString(i, g = new Uint32Array(2)) {
    const E = i.startsWith("-"), e = i.length, t = new Int64(g);
    for (let n = E ? 1 : 0; n < e; ) {
      const h = kInt32DecimalDigits < e - n ? kInt32DecimalDigits : e - n, d = new Int64(new Uint32Array([Number.parseInt(i.slice(n, n + h), 10), 0])), k = new Int64(new Uint32Array([kPowersOfTen[h], 0]));
      t.times(k), t.plus(d), n += h;
    }
    return E ? t.negate() : t;
  }
  /** @nocollapse */
  static convertArray(i) {
    const g = new Uint32Array(i.length * 2);
    for (let E = -1, e = i.length; ++E < e; )
      Int64.from(i[E], new Uint32Array(g.buffer, g.byteOffset + 2 * E * 4, 2));
    return g;
  }
  /** @nocollapse */
  static multiply(i, g) {
    return new Int64(new Uint32Array(i.buffer)).times(g);
  }
  /** @nocollapse */
  static add(i, g) {
    return new Int64(new Uint32Array(i.buffer)).plus(g);
  }
}
class Int128 {
  constructor(i) {
    this.buffer = i;
  }
  high() {
    return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2));
  }
  low() {
    return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset, 2));
  }
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[2] = ~this.buffer[2], this.buffer[3] = ~this.buffer[3], this.buffer[0] == 0 && ++this.buffer[1], this.buffer[1] == 0 && ++this.buffer[2], this.buffer[2] == 0 && ++this.buffer[3], this;
  }
  times(i) {
    const g = new Uint64(new Uint32Array([this.buffer[3], 0])), E = new Uint64(new Uint32Array([this.buffer[2], 0])), e = new Uint64(new Uint32Array([this.buffer[1], 0])), t = new Uint64(new Uint32Array([this.buffer[0], 0])), n = new Uint64(new Uint32Array([i.buffer[3], 0])), h = new Uint64(new Uint32Array([i.buffer[2], 0])), d = new Uint64(new Uint32Array([i.buffer[1], 0])), k = new Uint64(new Uint32Array([i.buffer[0], 0]));
    let p = Uint64.multiply(t, k);
    this.buffer[0] = p.low();
    const M = new Uint64(new Uint32Array([p.high(), 0]));
    return p = Uint64.multiply(e, k), M.plus(p), p = Uint64.multiply(t, d), M.plus(p), this.buffer[1] = M.low(), this.buffer[3] = M.lessThan(p) ? 1 : 0, this.buffer[2] = M.high(), new Uint64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2)).plus(Uint64.multiply(E, k)).plus(Uint64.multiply(e, d)).plus(Uint64.multiply(t, h)), this.buffer[3] += Uint64.multiply(g, k).plus(Uint64.multiply(E, d)).plus(Uint64.multiply(e, h)).plus(Uint64.multiply(t, n)).low(), this;
  }
  plus(i) {
    const g = new Uint32Array(4);
    return g[3] = this.buffer[3] + i.buffer[3] >>> 0, g[2] = this.buffer[2] + i.buffer[2] >>> 0, g[1] = this.buffer[1] + i.buffer[1] >>> 0, g[0] = this.buffer[0] + i.buffer[0] >>> 0, g[0] < this.buffer[0] >>> 0 && ++g[1], g[1] < this.buffer[1] >>> 0 && ++g[2], g[2] < this.buffer[2] >>> 0 && ++g[3], this.buffer[3] = g[3], this.buffer[2] = g[2], this.buffer[1] = g[1], this.buffer[0] = g[0], this;
  }
  hex() {
    return `${intAsHex(this.buffer[3])} ${intAsHex(this.buffer[2])} ${intAsHex(this.buffer[1])} ${intAsHex(this.buffer[0])}`;
  }
  /** @nocollapse */
  static multiply(i, g) {
    return new Int128(new Uint32Array(i.buffer)).times(g);
  }
  /** @nocollapse */
  static add(i, g) {
    return new Int128(new Uint32Array(i.buffer)).plus(g);
  }
  /** @nocollapse */
  static from(i, g = new Uint32Array(4)) {
    return Int128.fromString(typeof i == "string" ? i : i.toString(), g);
  }
  /** @nocollapse */
  static fromNumber(i, g = new Uint32Array(4)) {
    return Int128.fromString(i.toString(), g);
  }
  /** @nocollapse */
  static fromString(i, g = new Uint32Array(4)) {
    const E = i.startsWith("-"), e = i.length, t = new Int128(g);
    for (let n = E ? 1 : 0; n < e; ) {
      const h = kInt32DecimalDigits < e - n ? kInt32DecimalDigits : e - n, d = new Int128(new Uint32Array([Number.parseInt(i.slice(n, n + h), 10), 0, 0, 0])), k = new Int128(new Uint32Array([kPowersOfTen[h], 0, 0, 0]));
      t.times(k), t.plus(d), n += h;
    }
    return E ? t.negate() : t;
  }
  /** @nocollapse */
  static convertArray(i) {
    const g = new Uint32Array(i.length * 4);
    for (let E = -1, e = i.length; ++E < e; )
      Int128.from(i[E], new Uint32Array(g.buffer, g.byteOffset + 16 * E, 4));
    return g;
  }
}
const util_int_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseInt64,
  Int128,
  Int64,
  Uint64
}, Symbol.toStringTag, { value: "Module" }));
function toIntervalDayTimeInt32Array(o) {
  var i, g;
  const E = o.length, e = new Int32Array(E * 2);
  for (let t = 0, n = 0; t < E; t++) {
    const h = o[t];
    e[n++] = (i = h.days) !== null && i !== void 0 ? i : 0, e[n++] = (g = h.milliseconds) !== null && g !== void 0 ? g : 0;
  }
  return e;
}
function toIntervalMonthDayNanoInt32Array(o) {
  var i, g;
  const E = o.length, e = new Int32Array(E * 4);
  for (let t = 0, n = 0; t < E; t++) {
    const h = o[t];
    e[n++] = (i = h.months) !== null && i !== void 0 ? i : 0, e[n++] = (g = h.days) !== null && g !== void 0 ? g : 0;
    const d = h.nanoseconds;
    d ? (e[n++] = Number(BigInt(d) & BigInt(4294967295)), e[n++] = Number(BigInt(d) >> BigInt(32))) : n += 2;
  }
  return e;
}
function toIntervalDayTimeObjects(o) {
  const i = o.length, g = new Array(i / 2);
  for (let E = 0, e = 0; E < i; E += 2)
    g[e++] = {
      days: o[E],
      milliseconds: o[E + 1]
    };
  return g;
}
function toIntervalMonthDayNanoObjects(o, i) {
  const g = o.length, E = new Array(g / 4);
  for (let e = 0, t = 0; e < g; e += 4) {
    const n = BigInt(o[e + 3]) << BigInt(32) | BigInt(o[e + 2] >>> 0);
    E[t++] = {
      months: o[e],
      days: o[e + 1],
      nanoseconds: i ? `${n}` : n
    };
  }
  return E;
}
const util_interval_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  toIntervalDayTimeInt32Array,
  toIntervalDayTimeObjects,
  toIntervalMonthDayNanoInt32Array,
  toIntervalMonthDayNanoObjects
}, Symbol.toStringTag, { value: "Module" }));
class VectorLoader extends Visitor {
  constructor(i, g, E, e, t = MetadataVersion.V5) {
    super(), this.nodesIndex = -1, this.buffersIndex = -1, this.bytes = i, this.nodes = g, this.buffers = E, this.dictionaries = e, this.metadataVersion = t;
  }
  visit(i) {
    return super.visit(i instanceof Field ? i.type : i);
  }
  visitNull(i, { length: g } = this.nextFieldNode()) {
    return makeData({ type: i, length: g });
  }
  visitBool(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitInt(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitFloat(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitUtf8(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), valueOffsets: this.readOffsets(i), data: this.readData(i) });
  }
  visitLargeUtf8(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), valueOffsets: this.readOffsets(i), data: this.readData(i) });
  }
  visitBinary(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), valueOffsets: this.readOffsets(i), data: this.readData(i) });
  }
  visitLargeBinary(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), valueOffsets: this.readOffsets(i), data: this.readData(i) });
  }
  visitFixedSizeBinary(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitDate(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitTimestamp(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitTime(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitDecimal(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitList(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), valueOffsets: this.readOffsets(i), child: this.visit(i.children[0]) });
  }
  visitStruct(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), children: this.visitMany(i.children) });
  }
  visitUnion(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return this.metadataVersion < MetadataVersion.V5 && this.readNullBitmap(i, E), i.mode === UnionMode.Sparse ? this.visitSparseUnion(i, { length: g, nullCount: E }) : this.visitDenseUnion(i, { length: g, nullCount: E });
  }
  visitDenseUnion(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, typeIds: this.readTypeIds(i), valueOffsets: this.readOffsets(i), children: this.visitMany(i.children) });
  }
  visitSparseUnion(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, typeIds: this.readTypeIds(i), children: this.visitMany(i.children) });
  }
  visitDictionary(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i.indices), dictionary: this.readDictionary(i) });
  }
  visitInterval(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitDuration(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), data: this.readData(i) });
  }
  visitFixedSizeList(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), child: this.visit(i.children[0]) });
  }
  visitMap(i, { length: g, nullCount: E } = this.nextFieldNode()) {
    return makeData({ type: i, length: g, nullCount: E, nullBitmap: this.readNullBitmap(i, E), valueOffsets: this.readOffsets(i), child: this.visit(i.children[0]) });
  }
  nextFieldNode() {
    return this.nodes[++this.nodesIndex];
  }
  nextBufferRange() {
    return this.buffers[++this.buffersIndex];
  }
  readNullBitmap(i, g, E = this.nextBufferRange()) {
    return g > 0 && this.readData(i, E) || new Uint8Array(0);
  }
  readOffsets(i, g) {
    return this.readData(i, g);
  }
  readTypeIds(i, g) {
    return this.readData(i, g);
  }
  readData(i, { length: g, offset: E } = this.nextBufferRange()) {
    return this.bytes.subarray(E, E + g);
  }
  readDictionary(i) {
    return this.dictionaries.get(i.id);
  }
}
class JSONVectorLoader extends VectorLoader {
  constructor(i, g, E, e, t) {
    super(new Uint8Array(0), g, E, e, t), this.sources = i;
  }
  readNullBitmap(i, g, { offset: E } = this.nextBufferRange()) {
    return g <= 0 ? new Uint8Array(0) : packBools(this.sources[E]);
  }
  readOffsets(i, { offset: g } = this.nextBufferRange()) {
    return toArrayBufferView(Uint8Array, toArrayBufferView(i.OffsetArrayType, this.sources[g]));
  }
  readTypeIds(i, { offset: g } = this.nextBufferRange()) {
    return toArrayBufferView(Uint8Array, toArrayBufferView(i.ArrayType, this.sources[g]));
  }
  readData(i, { offset: g } = this.nextBufferRange()) {
    const { sources: E } = this;
    if (DataType.isTimestamp(i))
      return toArrayBufferView(Uint8Array, Int64.convertArray(E[g]));
    if ((DataType.isInt(i) || DataType.isTime(i)) && i.bitWidth === 64 || DataType.isDuration(i))
      return toArrayBufferView(Uint8Array, Int64.convertArray(E[g]));
    if (DataType.isDate(i) && i.unit === DateUnit.MILLISECOND)
      return toArrayBufferView(Uint8Array, Int64.convertArray(E[g]));
    if (DataType.isDecimal(i))
      return toArrayBufferView(Uint8Array, Int128.convertArray(E[g]));
    if (DataType.isBinary(i) || DataType.isLargeBinary(i) || DataType.isFixedSizeBinary(i))
      return binaryDataFromJSON(E[g]);
    if (DataType.isBool(i))
      return packBools(E[g]);
    if (DataType.isUtf8(i) || DataType.isLargeUtf8(i))
      return encodeUtf8(E[g].join(""));
    if (DataType.isInterval(i))
      switch (i.unit) {
        case IntervalUnit.DAY_TIME:
          return toIntervalDayTimeInt32Array(E[g]);
        case IntervalUnit.MONTH_DAY_NANO:
          return toIntervalMonthDayNanoInt32Array(E[g]);
      }
    return toArrayBufferView(Uint8Array, toArrayBufferView(i.ArrayType, E[g].map((e) => +e)));
  }
}
function binaryDataFromJSON(o) {
  const i = o.join(""), g = new Uint8Array(i.length / 2);
  for (let E = 0; E < i.length; E += 2)
    g[E >> 1] = Number.parseInt(i.slice(E, E + 2), 16);
  return g;
}
class CompressedVectorLoader extends VectorLoader {
  constructor(i, g, E, e, t) {
    super(new Uint8Array(0), g, E, e, t), this.bodyChunks = i;
  }
  readData(i, g = this.nextBufferRange()) {
    return this.bodyChunks[this.buffersIndex];
  }
}
class TypeComparator extends Visitor {
  compareSchemas(i, g) {
    return i === g || g instanceof i.constructor && this.compareManyFields(i.fields, g.fields);
  }
  compareManyFields(i, g) {
    return i === g || Array.isArray(i) && Array.isArray(g) && i.length === g.length && i.every((E, e) => this.compareFields(E, g[e]));
  }
  compareFields(i, g) {
    return i === g || g instanceof i.constructor && i.name === g.name && i.nullable === g.nullable && this.visit(i.type, g.type);
  }
}
function compareConstructor(o, i) {
  return i instanceof o.constructor;
}
function compareAny(o, i) {
  return o === i || compareConstructor(o, i);
}
function compareInt(o, i) {
  return o === i || compareConstructor(o, i) && o.bitWidth === i.bitWidth && o.isSigned === i.isSigned;
}
function compareFloat(o, i) {
  return o === i || compareConstructor(o, i) && o.precision === i.precision;
}
function compareFixedSizeBinary(o, i) {
  return o === i || compareConstructor(o, i) && o.byteWidth === i.byteWidth;
}
function compareDate(o, i) {
  return o === i || compareConstructor(o, i) && o.unit === i.unit;
}
function compareTimestamp(o, i) {
  return o === i || compareConstructor(o, i) && o.unit === i.unit && o.timezone === i.timezone;
}
function compareTime(o, i) {
  return o === i || compareConstructor(o, i) && o.unit === i.unit && o.bitWidth === i.bitWidth;
}
function compareList(o, i) {
  return o === i || compareConstructor(o, i) && o.children.length === i.children.length && instance.compareManyFields(o.children, i.children);
}
function compareStruct(o, i) {
  return o === i || compareConstructor(o, i) && o.children.length === i.children.length && instance.compareManyFields(o.children, i.children);
}
function compareUnion(o, i) {
  return o === i || compareConstructor(o, i) && o.mode === i.mode && o.typeIds.every((g, E) => g === i.typeIds[E]) && instance.compareManyFields(o.children, i.children);
}
function compareDictionary(o, i) {
  return o === i || compareConstructor(o, i) && o.id === i.id && o.isOrdered === i.isOrdered && instance.visit(o.indices, i.indices) && instance.visit(o.dictionary, i.dictionary);
}
function compareInterval(o, i) {
  return o === i || compareConstructor(o, i) && o.unit === i.unit;
}
function compareDuration(o, i) {
  return o === i || compareConstructor(o, i) && o.unit === i.unit;
}
function compareFixedSizeList(o, i) {
  return o === i || compareConstructor(o, i) && o.listSize === i.listSize && o.children.length === i.children.length && instance.compareManyFields(o.children, i.children);
}
function compareMap(o, i) {
  return o === i || compareConstructor(o, i) && o.keysSorted === i.keysSorted && o.children.length === i.children.length && instance.compareManyFields(o.children, i.children);
}
TypeComparator.prototype.visitNull = compareAny;
TypeComparator.prototype.visitBool = compareAny;
TypeComparator.prototype.visitInt = compareInt;
TypeComparator.prototype.visitInt8 = compareInt;
TypeComparator.prototype.visitInt16 = compareInt;
TypeComparator.prototype.visitInt32 = compareInt;
TypeComparator.prototype.visitInt64 = compareInt;
TypeComparator.prototype.visitUint8 = compareInt;
TypeComparator.prototype.visitUint16 = compareInt;
TypeComparator.prototype.visitUint32 = compareInt;
TypeComparator.prototype.visitUint64 = compareInt;
TypeComparator.prototype.visitFloat = compareFloat;
TypeComparator.prototype.visitFloat16 = compareFloat;
TypeComparator.prototype.visitFloat32 = compareFloat;
TypeComparator.prototype.visitFloat64 = compareFloat;
TypeComparator.prototype.visitUtf8 = compareAny;
TypeComparator.prototype.visitLargeUtf8 = compareAny;
TypeComparator.prototype.visitBinary = compareAny;
TypeComparator.prototype.visitLargeBinary = compareAny;
TypeComparator.prototype.visitFixedSizeBinary = compareFixedSizeBinary;
TypeComparator.prototype.visitDate = compareDate;
TypeComparator.prototype.visitDateDay = compareDate;
TypeComparator.prototype.visitDateMillisecond = compareDate;
TypeComparator.prototype.visitTimestamp = compareTimestamp;
TypeComparator.prototype.visitTimestampSecond = compareTimestamp;
TypeComparator.prototype.visitTimestampMillisecond = compareTimestamp;
TypeComparator.prototype.visitTimestampMicrosecond = compareTimestamp;
TypeComparator.prototype.visitTimestampNanosecond = compareTimestamp;
TypeComparator.prototype.visitTime = compareTime;
TypeComparator.prototype.visitTimeSecond = compareTime;
TypeComparator.prototype.visitTimeMillisecond = compareTime;
TypeComparator.prototype.visitTimeMicrosecond = compareTime;
TypeComparator.prototype.visitTimeNanosecond = compareTime;
TypeComparator.prototype.visitDecimal = compareAny;
TypeComparator.prototype.visitList = compareList;
TypeComparator.prototype.visitStruct = compareStruct;
TypeComparator.prototype.visitUnion = compareUnion;
TypeComparator.prototype.visitDenseUnion = compareUnion;
TypeComparator.prototype.visitSparseUnion = compareUnion;
TypeComparator.prototype.visitDictionary = compareDictionary;
TypeComparator.prototype.visitInterval = compareInterval;
TypeComparator.prototype.visitIntervalDayTime = compareInterval;
TypeComparator.prototype.visitIntervalYearMonth = compareInterval;
TypeComparator.prototype.visitIntervalMonthDayNano = compareInterval;
TypeComparator.prototype.visitDuration = compareDuration;
TypeComparator.prototype.visitDurationSecond = compareDuration;
TypeComparator.prototype.visitDurationMillisecond = compareDuration;
TypeComparator.prototype.visitDurationMicrosecond = compareDuration;
TypeComparator.prototype.visitDurationNanosecond = compareDuration;
TypeComparator.prototype.visitFixedSizeList = compareFixedSizeList;
TypeComparator.prototype.visitMap = compareMap;
const instance = new TypeComparator();
function compareSchemas(o, i) {
  return instance.compareSchemas(o, i);
}
function compareFields(o, i) {
  return instance.compareFields(o, i);
}
function compareTypes(o, i) {
  return instance.visit(o, i);
}
function distributeVectorsIntoRecordBatches(o, i) {
  return uniformlyDistributeChunksAcrossRecordBatches(o, i.map((g) => g.data.concat()));
}
function uniformlyDistributeChunksAcrossRecordBatches(o, i) {
  const g = [...o.fields], E = [], e = { numBatches: i.reduce((M, H) => Math.max(M, H.length), 0) };
  let t = 0, n = 0, h = -1;
  const d = i.length;
  let k, p = [];
  for (; e.numBatches-- > 0; ) {
    for (n = Number.POSITIVE_INFINITY, h = -1; ++h < d; )
      p[h] = k = i[h].shift(), n = Math.min(n, k ? k.length : n);
    Number.isFinite(n) && (p = distributeChildren(g, n, p, i, e), n > 0 && (E[t++] = makeData({
      type: new Struct(g),
      length: n,
      nullCount: 0,
      children: p.slice()
    })));
  }
  return [
    o = o.assign(g),
    E.map((M) => new RecordBatch$1(o, M))
  ];
}
function distributeChildren(o, i, g, E, e) {
  var t;
  const n = (i + 63 & -64) >> 3;
  for (let h = -1, d = E.length; ++h < d; ) {
    const k = g[h], p = k?.length;
    if (p >= i)
      p === i ? g[h] = k : (g[h] = k.slice(0, i), e.numBatches = Math.max(e.numBatches, E[h].unshift(k.slice(i, p - i))));
    else {
      const M = o[h];
      o[h] = M.clone({ nullable: !0 }), g[h] = (t = k?._changeLengthAndBackfillNullBitmap(i)) !== null && t !== void 0 ? t : makeData({
        type: M.type,
        length: i,
        nullCount: i,
        nullBitmap: new Uint8Array(n)
      });
    }
  }
  return g;
}
var _a$2;
let Table$1 = class mg {
  constructor(...i) {
    var g, E;
    if (i.length === 0)
      return this.batches = [], this.schema = new Schema$2([]), this._offsets = [0], this;
    let e, t;
    i[0] instanceof Schema$2 && (e = i.shift()), i.at(-1) instanceof Uint32Array && (t = i.pop());
    const n = (d) => {
      if (d) {
        if (d instanceof RecordBatch$1)
          return [d];
        if (d instanceof mg)
          return d.batches;
        if (d instanceof Data) {
          if (d.type instanceof Struct)
            return [new RecordBatch$1(new Schema$2(d.type.children), d)];
        } else {
          if (Array.isArray(d))
            return d.flatMap((k) => n(k));
          if (typeof d[Symbol.iterator] == "function")
            return [...d].flatMap((k) => n(k));
          if (typeof d == "object") {
            const k = Object.keys(d), p = k.map((f) => new Vector([d[f]])), M = e ?? new Schema$2(k.map((f, AA) => new Field(String(f), p[AA].type, p[AA].nullable))), [, H] = distributeVectorsIntoRecordBatches(M, p);
            return H.length === 0 ? [new RecordBatch$1(d)] : H;
          }
        }
      }
      return [];
    }, h = i.flatMap((d) => n(d));
    if (e = (E = e ?? ((g = h[0]) === null || g === void 0 ? void 0 : g.schema)) !== null && E !== void 0 ? E : new Schema$2([]), !(e instanceof Schema$2))
      throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
    for (const d of h) {
      if (!(d instanceof RecordBatch$1))
        throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
      if (!compareSchemas(e, d.schema))
        throw new TypeError("Table and inner RecordBatch schemas must be equivalent.");
    }
    this.schema = e, this.batches = h, this._offsets = t ?? computeChunkOffsets(this.data);
  }
  /**
   * The contiguous {@link RecordBatch `RecordBatch`} chunks of the Table rows.
   */
  get data() {
    return this.batches.map(({ data: i }) => i);
  }
  /**
   * The number of columns in this Table.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this Table.
   */
  get numRows() {
    return this.data.reduce((i, g) => i + g.length, 0);
  }
  /**
   * The number of null rows in this Table.
   */
  get nullCount() {
    return this._nullCount === -1 && (this._nullCount = computeChunkNullCounts(this.data)), this._nullCount;
  }
  /**
   * Check whether an element is null.
   *
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(i) {
    return !1;
  }
  /**
   * Get an element value by position.
   *
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(i) {
    return null;
  }
  /**
    * Get an element value by position.
    * @param index The index of the element to read. A negative index will count back from the last element.
    */
  // @ts-ignore
  at(i) {
    return this.get(wrapIndex(i, this.numRows));
  }
  /**
   * Set an element value by position.
   *
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(i, g) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   *
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(i, g) {
    return -1;
  }
  /**
   * Iterator for rows in this Table.
   */
  [Symbol.iterator]() {
    return this.batches.length > 0 ? instance$2.visit(new Vector(this.data)) : new Array(0)[Symbol.iterator]();
  }
  /**
   * Return a JavaScript Array of the Table rows.
   *
   * @returns An Array of Table rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Returns a string representation of the Table rows.
   *
   * @returns A string representation of the Table rows.
   */
  toString() {
    return `[
  ${this.toArray().join(`,
  `)}
]`;
  }
  /**
   * Combines two or more Tables of the same schema.
   *
   * @param others Additional Tables to add to the end of this Tables.
   */
  concat(...i) {
    const g = this.schema, E = this.data.concat(i.flatMap(({ data: e }) => e));
    return new mg(g, E.map((e) => new RecordBatch$1(g, e)));
  }
  /**
   * Return a zero-copy sub-section of this Table.
   *
   * @param begin The beginning of the specified portion of the Table.
   * @param end The end of the specified portion of the Table. This is exclusive of the element at the index 'end'.
   */
  slice(i, g) {
    const E = this.schema;
    [i, g] = clampRange({ length: this.numRows }, i, g);
    const e = sliceChunks$1(this.data, this._offsets, i, g);
    return new mg(E, e.map((t) => new RecordBatch$1(E, t)));
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   *
   * @param name The name of the child to retrieve.
   */
  getChild(i) {
    return this.getChildAt(this.schema.fields.findIndex((g) => g.name === i));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   *
   * @param index The index of the child to retrieve.
   */
  getChildAt(i) {
    if (i > -1 && i < this.schema.fields.length) {
      const g = this.data.map((E) => E.children[i]);
      if (g.length === 0) {
        const { type: E } = this.schema.fields[i], e = makeData({ type: E, length: 0, nullCount: 0 });
        g.push(e._changeLengthAndBackfillNullBitmap(this.numRows));
      }
      return new Vector(g);
    }
    return null;
  }
  /**
   * Sets a child Vector by name.
   *
   * @param name The name of the child to overwrite.
   * @returns A new Table with the supplied child for the specified name.
   */
  setChild(i, g) {
    var E;
    return this.setChildAt((E = this.schema.fields) === null || E === void 0 ? void 0 : E.findIndex((e) => e.name === i), g);
  }
  setChildAt(i, g) {
    let E = this.schema, e = [...this.batches];
    if (i > -1 && i < this.numCols) {
      g || (g = new Vector([makeData({ type: new Null(), length: this.numRows })]));
      const t = E.fields.slice(), n = t[i].clone({ type: g.type }), h = this.schema.fields.map((d, k) => this.getChildAt(k));
      [t[i], h[i]] = [n, g], [E, e] = distributeVectorsIntoRecordBatches(E, h);
    }
    return new mg(E, e);
  }
  /**
   * Construct a new Table containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new Table of columns matching the specified names.
   */
  select(i) {
    const g = this.schema.fields.reduce((E, e, t) => E.set(e.name, t), /* @__PURE__ */ new Map());
    return this.selectAt(i.map((E) => g.get(E)).filter((E) => E > -1));
  }
  /**
   * Construct a new Table containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new Table of columns at the specified indices.
   */
  selectAt(i) {
    const g = this.schema.selectAt(i), E = this.batches.map((e) => e.selectAt(i));
    return new mg(g, E);
  }
  assign(i) {
    const g = this.schema.fields, [E, e] = i.schema.fields.reduce((h, d, k) => {
      const [p, M] = h, H = g.findIndex((f) => f.name === d.name);
      return ~H ? M[H] = k : p.push(k), h;
    }, [[], []]), t = this.schema.assign(i.schema), n = [
      ...g.map((h, d) => [d, e[d]]).map(([h, d]) => d === void 0 ? this.getChildAt(h) : i.getChildAt(d)),
      ...E.map((h) => i.getChildAt(h))
    ].filter(Boolean);
    return new mg(...distributeVectorsIntoRecordBatches(t, n));
  }
};
_a$2 = Symbol.toStringTag;
Table$1[_a$2] = ((o) => (o.schema = null, o.batches = [], o._offsets = new Uint32Array([0]), o._nullCount = -1, o[Symbol.isConcatSpreadable] = !0, o.isValid = wrapChunkedCall1(isChunkedValid), o.get = wrapChunkedCall1(instance$4.getVisitFn(Type.Struct)), o.set = wrapChunkedCall2(instance$5.getVisitFn(Type.Struct)), o.indexOf = wrapChunkedIndexOf(instance$3.getVisitFn(Type.Struct)), "Table"))(Table$1.prototype);
var _a$1;
let RecordBatch$1 = class gI {
  constructor(...i) {
    switch (i.length) {
      case 2: {
        if ([this.schema] = i, !(this.schema instanceof Schema$2))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        if ([
          ,
          this.data = makeData({
            nullCount: 0,
            type: new Struct(this.schema.fields),
            children: this.schema.fields.map((g) => makeData({ type: g.type, nullCount: 0 }))
          })
        ] = i, !(this.data instanceof Data))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        [this.schema, this.data] = ensureSameLengthData(this.schema, this.data.children);
        break;
      }
      case 1: {
        const [g] = i, { fields: E, children: e, length: t } = Object.keys(g).reduce((d, k, p) => (d.children[p] = g[k], d.length = Math.max(d.length, g[k].length), d.fields[p] = Field.new({ name: k, type: g[k].type, nullable: !0 }), d), {
          length: 0,
          fields: new Array(),
          children: new Array()
        }), n = new Schema$2(E), h = makeData({ type: new Struct(E), length: t, children: e, nullCount: 0 });
        [this.schema, this.data] = ensureSameLengthData(n, h.children, t);
        break;
      }
      default:
        throw new TypeError("RecordBatch constructor expects an Object mapping names to child Data, or a [Schema, Data] pair.");
    }
  }
  get dictionaries() {
    return this._dictionaries || (this._dictionaries = collectDictionaries(this.schema.fields, this.data.children));
  }
  /**
   * The number of columns in this RecordBatch.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this RecordBatch.
   */
  get numRows() {
    return this.data.length;
  }
  /**
   * The number of null rows in this RecordBatch.
   */
  get nullCount() {
    return this.data.nullCount;
  }
  /**
   * Check whether an row is null.
   * @param index The index at which to read the validity bitmap.
   */
  isValid(i) {
    return this.data.getValid(i);
  }
  /**
   * Get a row by position.
   * @param index The index of the row to read.
   */
  get(i) {
    return instance$4.visit(this.data, i);
  }
  /**
    * Get a row value by position.
    * @param index The index of the row to read. A negative index will count back from the last row.
    */
  at(i) {
    return this.get(wrapIndex(i, this.numRows));
  }
  /**
   * Set a row by position.
   * @param index The index of the row to write.
   * @param value The value to set.
   */
  set(i, g) {
    return instance$5.visit(this.data, i, g);
  }
  /**
   * Retrieve the index of the first occurrence of a row in an RecordBatch.
   * @param element The row to locate in the RecordBatch.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  indexOf(i, g) {
    return instance$3.visit(this.data, i, g);
  }
  /**
   * Iterator for rows in this RecordBatch.
   */
  [Symbol.iterator]() {
    return instance$2.visit(new Vector([this.data]));
  }
  /**
   * Return a JavaScript Array of the RecordBatch rows.
   * @returns An Array of RecordBatch rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Combines two or more RecordBatch of the same schema.
   * @param others Additional RecordBatch to add to the end of this RecordBatch.
   */
  concat(...i) {
    return new Table$1(this.schema, [this, ...i]);
  }
  /**
   * Return a zero-copy sub-section of this RecordBatch.
   * @param start The beginning of the specified portion of the RecordBatch.
   * @param end The end of the specified portion of the RecordBatch. This is exclusive of the row at the index 'end'.
   */
  slice(i, g) {
    const [E] = new Vector([this.data]).slice(i, g).data;
    return new gI(this.schema, E);
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(i) {
    var g;
    return this.getChildAt((g = this.schema.fields) === null || g === void 0 ? void 0 : g.findIndex((E) => E.name === i));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(i) {
    return i > -1 && i < this.schema.fields.length ? new Vector([this.data.children[i]]) : null;
  }
  /**
   * Sets a child Vector by name.
   * @param name The name of the child to overwrite.
   * @returns A new RecordBatch with the new child for the specified name.
   */
  setChild(i, g) {
    var E;
    return this.setChildAt((E = this.schema.fields) === null || E === void 0 ? void 0 : E.findIndex((e) => e.name === i), g);
  }
  setChildAt(i, g) {
    let E = this.schema, e = this.data;
    if (i > -1 && i < this.numCols) {
      g || (g = new Vector([makeData({ type: new Null(), length: this.numRows })]));
      const t = E.fields.slice(), n = e.children.slice(), h = t[i].clone({ type: g.type });
      [t[i], n[i]] = [h, g.data[0]], E = new Schema$2(t, new Map(this.schema.metadata)), e = makeData({ type: new Struct(t), children: n });
    }
    return new gI(E, e);
  }
  /**
   * Construct a new RecordBatch containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new RecordBatch of columns matching the specified names.
   */
  select(i) {
    const g = this.schema.select(i), E = new Struct(g.fields), e = [];
    for (const t of i) {
      const n = this.schema.fields.findIndex((h) => h.name === t);
      ~n && (e[n] = this.data.children[n]);
    }
    return new gI(g, makeData({ type: E, length: this.numRows, children: e }));
  }
  /**
   * Construct a new RecordBatch containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new RecordBatch of columns matching at the specified indices.
   */
  selectAt(i) {
    const g = this.schema.selectAt(i), E = i.map((t) => this.data.children[t]).filter(Boolean), e = makeData({ type: new Struct(g.fields), length: this.numRows, children: E });
    return new gI(g, e);
  }
};
_a$1 = Symbol.toStringTag;
RecordBatch$1[_a$1] = ((o) => (o._nullCount = -1, o[Symbol.isConcatSpreadable] = !0, "RecordBatch"))(RecordBatch$1.prototype);
function ensureSameLengthData(o, i, g = i.reduce((E, e) => Math.max(E, e.length), 0)) {
  var E;
  const e = [...o.fields], t = [...i], n = (g + 63 & -64) >> 3;
  for (const [h, d] of o.fields.entries()) {
    const k = i[h];
    (!k || k.length !== g) && (e[h] = d.clone({ nullable: !0 }), t[h] = (E = k?._changeLengthAndBackfillNullBitmap(g)) !== null && E !== void 0 ? E : makeData({
      type: d.type,
      length: g,
      nullCount: g,
      nullBitmap: new Uint8Array(n)
    }));
  }
  return [
    o.assign(e),
    makeData({ type: new Struct(e), length: g, children: t })
  ];
}
function collectDictionaries(o, i, g = /* @__PURE__ */ new Map()) {
  var E, e;
  if (((E = o?.length) !== null && E !== void 0 ? E : 0) > 0 && o?.length === i?.length)
    for (let t = -1, n = o.length; ++t < n; ) {
      const { type: h } = o[t], d = i[t];
      for (const k of [d, ...((e = d?.dictionary) === null || e === void 0 ? void 0 : e.data) || []])
        collectDictionaries(h.children, k?.children, g);
      if (DataType.isDictionary(h)) {
        const { id: k } = h;
        if (!g.has(k))
          d?.dictionary && g.set(k, d.dictionary);
        else if (g.get(k) !== d.dictionary)
          throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
      }
    }
  return g;
}
class _InternalEmptyPlaceholderRecordBatch extends RecordBatch$1 {
  constructor(i) {
    const g = i.fields.map((e) => makeData({ type: e.type })), E = makeData({ type: new Struct(i.fields), nullCount: 0, children: g });
    super(i, E);
  }
}
const invalidMessageType = (o) => `Expected ${MessageHeader[o]} Message in stream, but was null or length 0.`, nullMessage = (o) => `Header pointer of flatbuffer-encoded ${MessageHeader[o]} Message is null or length 0.`, invalidMessageMetadata = (o, i) => `Expected to read ${o} metadata bytes, but only read ${i}.`, invalidMessageBodyLength = (o, i) => `Expected to read ${o} bytes for message body, but only read ${i}.`;
class MessageReader {
  constructor(i) {
    this.source = i instanceof ByteStream ? i : new ByteStream(i);
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    let i;
    return (i = this.readMetadataLength()).done || i.value === -1 && (i = this.readMetadataLength()).done || (i = this.readMetadata(i.value)).done ? ITERATOR_DONE : i;
  }
  throw(i) {
    return this.source.throw(i);
  }
  return(i) {
    return this.source.return(i);
  }
  readMessage(i) {
    let g;
    if ((g = this.next()).done)
      return null;
    if (i != null && g.value.headerType !== i)
      throw new Error(invalidMessageType(i));
    return g.value;
  }
  readMessageBody(i) {
    if (i <= 0)
      return new Uint8Array(0);
    const g = toUint8Array(this.source.read(i));
    if (g.byteLength < i)
      throw new Error(invalidMessageBodyLength(i, g.byteLength));
    return (
      /* 1. */
      g.byteOffset % 8 === 0 && /* 2. */
      g.byteOffset + g.byteLength <= g.buffer.byteLength ? g : g.slice()
    );
  }
  readSchema(i = !1) {
    const g = MessageHeader.Schema, E = this.readMessage(g), e = E?.header();
    if (i && !e)
      throw new Error(nullMessage(g));
    return e;
  }
  readMetadataLength() {
    const i = this.source.read(PADDING), g = i && new ByteBuffer$2(i), E = g?.readInt32(0) || 0;
    return { done: E === 0, value: E };
  }
  readMetadata(i) {
    const g = this.source.read(i);
    if (!g)
      return ITERATOR_DONE;
    if (g.byteLength < i)
      throw new Error(invalidMessageMetadata(i, g.byteLength));
    return { done: !1, value: Message.decode(g) };
  }
}
class AsyncMessageReader {
  constructor(i, g) {
    this.source = i instanceof AsyncByteStream ? i : isFileHandle(i) ? new AsyncRandomAccessFile(i, g) : new AsyncByteStream(i);
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next() {
    return __awaiter(this, void 0, void 0, function* () {
      let i;
      return (i = yield this.readMetadataLength()).done || i.value === -1 && (i = yield this.readMetadataLength()).done || (i = yield this.readMetadata(i.value)).done ? ITERATOR_DONE : i;
    });
  }
  throw(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.source.throw(i);
    });
  }
  return(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.source.return(i);
    });
  }
  readMessage(i) {
    return __awaiter(this, void 0, void 0, function* () {
      let g;
      if ((g = yield this.next()).done)
        return null;
      if (i != null && g.value.headerType !== i)
        throw new Error(invalidMessageType(i));
      return g.value;
    });
  }
  readMessageBody(i) {
    return __awaiter(this, void 0, void 0, function* () {
      if (i <= 0)
        return new Uint8Array(0);
      const g = toUint8Array(yield this.source.read(i));
      if (g.byteLength < i)
        throw new Error(invalidMessageBodyLength(i, g.byteLength));
      return (
        /* 1. */
        g.byteOffset % 8 === 0 && /* 2. */
        g.byteOffset + g.byteLength <= g.buffer.byteLength ? g : g.slice()
      );
    });
  }
  readSchema() {
    return __awaiter(this, arguments, void 0, function* (i = !1) {
      const g = MessageHeader.Schema, E = yield this.readMessage(g), e = E?.header();
      if (i && !e)
        throw new Error(nullMessage(g));
      return e;
    });
  }
  readMetadataLength() {
    return __awaiter(this, void 0, void 0, function* () {
      const i = yield this.source.read(PADDING), g = i && new ByteBuffer$2(i), E = g?.readInt32(0) || 0;
      return { done: E === 0, value: E };
    });
  }
  readMetadata(i) {
    return __awaiter(this, void 0, void 0, function* () {
      const g = yield this.source.read(i);
      if (!g)
        return ITERATOR_DONE;
      if (g.byteLength < i)
        throw new Error(invalidMessageMetadata(i, g.byteLength));
      return { done: !1, value: Message.decode(g) };
    });
  }
}
class JSONMessageReader extends MessageReader {
  constructor(i) {
    super(new Uint8Array(0)), this._schema = !1, this._body = [], this._batchIndex = 0, this._dictionaryIndex = 0, this._json = i instanceof ArrowJSON ? i : new ArrowJSON(i);
  }
  next() {
    const { _json: i } = this;
    if (!this._schema)
      return this._schema = !0, { done: !1, value: Message.fromJSON(i.schema, MessageHeader.Schema) };
    if (this._dictionaryIndex < i.dictionaries.length) {
      const g = i.dictionaries[this._dictionaryIndex++];
      return this._body = g.data.columns, { done: !1, value: Message.fromJSON(g, MessageHeader.DictionaryBatch) };
    }
    if (this._batchIndex < i.batches.length) {
      const g = i.batches[this._batchIndex++];
      return this._body = g.columns, { done: !1, value: Message.fromJSON(g, MessageHeader.RecordBatch) };
    }
    return this._body = [], ITERATOR_DONE;
  }
  readMessageBody(i) {
    return g(this._body);
    function g(E) {
      return (E || []).reduce((e, t) => [
        ...e,
        ...t.VALIDITY && [t.VALIDITY] || [],
        ...t.TYPE_ID && [t.TYPE_ID] || [],
        ...t.OFFSET && [t.OFFSET] || [],
        ...t.DATA && [t.DATA] || [],
        ...g(t.children)
      ], []);
    }
  }
  readMessage(i) {
    let g;
    if ((g = this.next()).done)
      return null;
    if (i != null && g.value.headerType !== i)
      throw new Error(invalidMessageType(i));
    return g.value;
  }
  readSchema() {
    const i = MessageHeader.Schema, g = this.readMessage(i), E = g?.header();
    if (!g || !E)
      throw new Error(nullMessage(i));
    return E;
  }
}
const PADDING = 4, MAGIC_STR = "ARROW1", MAGIC = new Uint8Array(MAGIC_STR.length);
for (let o = 0; o < MAGIC_STR.length; o += 1)
  MAGIC[o] = MAGIC_STR.codePointAt(o);
function checkForMagicArrowString(o, i = 0) {
  for (let g = -1, E = MAGIC.length; ++g < E; )
    if (MAGIC[g] !== o[i + g])
      return !1;
  return !0;
}
const magicLength = MAGIC.length, magicAndPadding = magicLength + PADDING, magicX2AndPadding = magicLength * 2 + PADDING;
class Lz4FrameValidator {
  constructor() {
    this.LZ4_FRAME_MAGIC = new Uint8Array([4, 34, 77, 24]), this.MIN_HEADER_LENGTH = 7;
  }
  isValidCodecEncode(i) {
    const g = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8]), E = i.encode(g);
    return this._isValidCompressed(E);
  }
  _isValidCompressed(i) {
    return this._hasMinimumLength(i) && this._hasValidMagicNumber(i) && this._hasValidVersion(i);
  }
  _hasMinimumLength(i) {
    return i.length >= this.MIN_HEADER_LENGTH;
  }
  _hasValidMagicNumber(i) {
    return this.LZ4_FRAME_MAGIC.every((g, E) => i[E] === g);
  }
  _hasValidVersion(i) {
    return (i[4] & 192) >> 6 === 1;
  }
}
class ZstdValidator {
  constructor() {
    this.ZSTD_MAGIC = new Uint8Array([40, 181, 47, 253]), this.MIN_HEADER_LENGTH = 6;
  }
  isValidCodecEncode(i) {
    const g = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8]), E = i.encode(g);
    return this._isValidCompressed(E);
  }
  _isValidCompressed(i) {
    return this._hasMinimumLength(i) && this._hasValidMagicNumber(i);
  }
  _hasMinimumLength(i) {
    return i.length >= this.MIN_HEADER_LENGTH;
  }
  _hasValidMagicNumber(i) {
    return this.ZSTD_MAGIC.every((g, E) => i[E] === g);
  }
}
const compressionValidators = {
  [CompressionType.LZ4_FRAME]: new Lz4FrameValidator(),
  [CompressionType.ZSTD]: new ZstdValidator()
};
class _CompressionRegistry {
  constructor() {
    this.registry = {};
  }
  set(i, g) {
    if (g?.encode && typeof g.encode == "function" && !compressionValidators[i].isValidCodecEncode(g))
      throw new Error(`Encoder for ${CompressionType[i]} is not valid.`);
    this.registry[i] = g;
  }
  get(i) {
    var g;
    return ((g = this.registry) === null || g === void 0 ? void 0 : g[i]) || null;
  }
}
const compressionRegistry = new _CompressionRegistry(), LENGTH_NO_COMPRESSED_DATA = -1, COMPRESS_LENGTH_PREFIX = 8;
class RecordBatchReader extends ReadableInterop {
  constructor(i) {
    super(), this._impl = i;
  }
  get closed() {
    return this._impl.closed;
  }
  get schema() {
    return this._impl.schema;
  }
  get autoDestroy() {
    return this._impl.autoDestroy;
  }
  get dictionaries() {
    return this._impl.dictionaries;
  }
  get numDictionaries() {
    return this._impl.numDictionaries;
  }
  get numRecordBatches() {
    return this._impl.numRecordBatches;
  }
  get footer() {
    return this._impl.isFile() ? this._impl.footer : null;
  }
  isSync() {
    return this._impl.isSync();
  }
  isAsync() {
    return this._impl.isAsync();
  }
  isFile() {
    return this._impl.isFile();
  }
  isStream() {
    return this._impl.isStream();
  }
  next() {
    return this._impl.next();
  }
  throw(i) {
    return this._impl.throw(i);
  }
  return(i) {
    return this._impl.return(i);
  }
  cancel() {
    return this._impl.cancel();
  }
  reset(i) {
    return this._impl.reset(i), this._DOMStream = void 0, this._nodeStream = void 0, this;
  }
  open(i) {
    const g = this._impl.open(i);
    return isPromise(g) ? g.then(() => this) : this;
  }
  readRecordBatch(i) {
    return this._impl.isFile() ? this._impl.readRecordBatch(i) : null;
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
  toDOMStream() {
    return streamAdapters.toDOMStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this });
  }
  toNodeStream() {
    return streamAdapters.toNodeStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this }, { objectMode: !0 });
  }
  /** @nocollapse */
  // @ts-ignore
  static throughNode(i) {
    throw new Error('"throughNode" not available in this environment');
  }
  /** @nocollapse */
  static throughDOM(i, g) {
    throw new Error('"throughDOM" not available in this environment');
  }
  /** @nocollapse */
  static from(i) {
    return i instanceof RecordBatchReader ? i : isArrowJSON(i) ? fromArrowJSON(i) : isFileHandle(i) ? fromFileHandle(i) : isPromise(i) ? __awaiter(this, void 0, void 0, function* () {
      return yield RecordBatchReader.from(yield i);
    }) : isFetchResponse(i) || isReadableDOMStream(i) || isReadableNodeStream(i) || isAsyncIterable$1(i) ? fromAsyncByteStream(new AsyncByteStream(i)) : fromByteStream(new ByteStream(i));
  }
  /** @nocollapse */
  static readAll(i) {
    return i instanceof RecordBatchReader ? i.isSync() ? readAllSync(i) : readAllAsync(i) : isArrowJSON(i) || ArrayBuffer.isView(i) || isIterable(i) || isIteratorResult(i) ? readAllSync(i) : readAllAsync(i);
  }
}
class RecordBatchStreamReader extends RecordBatchReader {
  constructor(i) {
    super(i), this._impl = i;
  }
  readAll() {
    return [...this];
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return __asyncGenerator(this, arguments, function* () {
      yield __await(yield* __asyncDelegator(__asyncValues(this[Symbol.iterator]())));
    });
  }
}
class AsyncRecordBatchStreamReader extends RecordBatchReader {
  constructor(i) {
    super(i), this._impl = i;
  }
  readAll() {
    return __awaiter(this, void 0, void 0, function* () {
      var i, g, E, e;
      const t = new Array();
      try {
        for (var n = !0, h = __asyncValues(this), d; d = yield h.next(), i = d.done, !i; n = !0) {
          e = d.value, n = !1;
          const k = e;
          t.push(k);
        }
      } catch (k) {
        g = { error: k };
      } finally {
        try {
          !n && !i && (E = h.return) && (yield E.call(h));
        } finally {
          if (g) throw g.error;
        }
      }
      return t;
    });
  }
  [Symbol.iterator]() {
    throw new Error("AsyncRecordBatchStreamReader is not Iterable");
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
}
class RecordBatchFileReader extends RecordBatchStreamReader {
  constructor(i) {
    super(i), this._impl = i;
  }
}
class AsyncRecordBatchFileReader extends AsyncRecordBatchStreamReader {
  constructor(i) {
    super(i), this._impl = i;
  }
}
class RecordBatchReaderImpl {
  get numDictionaries() {
    return this._dictionaryIndex;
  }
  get numRecordBatches() {
    return this._recordBatchIndex;
  }
  constructor(i = /* @__PURE__ */ new Map()) {
    this.closed = !1, this.autoDestroy = !0, this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.dictionaries = i;
  }
  isSync() {
    return !1;
  }
  isAsync() {
    return !1;
  }
  isFile() {
    return !1;
  }
  isStream() {
    return !1;
  }
  reset(i) {
    return this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.schema = i, this.dictionaries = /* @__PURE__ */ new Map(), this;
  }
  _loadRecordBatch(i, g) {
    let E;
    if (i.compression != null) {
      const t = compressionRegistry.get(i.compression.type);
      if (t?.decode && typeof t.decode == "function") {
        const { decommpressedBody: n, buffers: h } = this._decompressBuffers(i, g, t);
        E = this._loadCompressedVectors(i, n, this.schema.fields), i = new RecordBatch$2(i.length, i.nodes, h, null);
      } else
        throw new Error("Record batch is compressed but codec not found");
    } else
      E = this._loadVectors(i, g, this.schema.fields);
    const e = makeData({ type: new Struct(this.schema.fields), length: i.length, children: E });
    return new RecordBatch$1(this.schema, e);
  }
  _loadDictionaryBatch(i, g) {
    const { id: E, isDelta: e } = i, { dictionaries: t, schema: n } = this, h = t.get(E), d = n.dictionaries.get(E);
    let k;
    if (i.data.compression != null) {
      const p = compressionRegistry.get(i.data.compression.type);
      if (p?.decode && typeof p.decode == "function") {
        const { decommpressedBody: M, buffers: H } = this._decompressBuffers(i.data, g, p);
        k = this._loadCompressedVectors(i.data, M, [d]), i = new DictionaryBatch(new RecordBatch$2(i.data.length, i.data.nodes, H, null), E, e);
      } else
        throw new Error("Dictionary batch is compressed but codec not found");
    } else
      k = this._loadVectors(i.data, g, [d]);
    return (h && e ? h.concat(new Vector(k)) : new Vector(k)).memoize();
  }
  _loadVectors(i, g, E) {
    return new VectorLoader(g, i.nodes, i.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(E);
  }
  _loadCompressedVectors(i, g, E) {
    return new CompressedVectorLoader(g, i.nodes, i.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(E);
  }
  _decompressBuffers(i, g, E) {
    const e = [], t = [];
    let n = 0;
    for (const { offset: h, length: d } of i.buffers) {
      if (d === 0) {
        e.push(new Uint8Array(0)), t.push(new BufferRegion(n, 0));
        continue;
      }
      const k = new ByteBuffer$2(g.subarray(h, h + d)), p = bigIntToNumber(k.readInt64(0)), M = k.bytes().subarray(COMPRESS_LENGTH_PREFIX), H = p === LENGTH_NO_COMPRESSED_DATA ? M : E.decode(M);
      e.push(H);
      const f = (n + 7 & -8) - n;
      n += f, t.push(new BufferRegion(n, H.length)), n += H.length;
    }
    return {
      decommpressedBody: e,
      buffers: t
    };
  }
}
class RecordBatchStreamReaderImpl extends RecordBatchReaderImpl {
  constructor(i, g) {
    super(g), this._reader = isArrowJSON(i) ? new JSONMessageReader(this._handle = i) : new MessageReader(this._handle = i);
  }
  isSync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.iterator]() {
    return this;
  }
  cancel() {
    !this.closed && (this.closed = !0) && (this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
  }
  open(i) {
    return this.closed || (this.autoDestroy = shouldAutoDestroy(this, i), this.schema || (this.schema = this._reader.readSchema()) || this.cancel()), this;
  }
  throw(i) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.throw(i) : ITERATOR_DONE;
  }
  return(i) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.return(i) : ITERATOR_DONE;
  }
  next() {
    if (this.closed)
      return ITERATOR_DONE;
    let i;
    const { _reader: g } = this;
    for (; i = this._readNextMessageAndValidate(); )
      if (i.isSchema())
        this.reset(i.header());
      else if (i.isRecordBatch()) {
        this._recordBatchIndex++;
        const E = i.header(), e = g.readMessageBody(i.bodyLength);
        return { done: !1, value: this._loadRecordBatch(E, e) };
      } else if (i.isDictionaryBatch()) {
        this._dictionaryIndex++;
        const E = i.header(), e = g.readMessageBody(i.bodyLength), t = this._loadDictionaryBatch(E, e);
        this.dictionaries.set(E.id, t);
      }
    return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new _InternalEmptyPlaceholderRecordBatch(this.schema) }) : this.return();
  }
  _readNextMessageAndValidate(i) {
    return this._reader.readMessage(i);
  }
}
class AsyncRecordBatchStreamReaderImpl extends RecordBatchReaderImpl {
  constructor(i, g) {
    super(g), this._reader = new AsyncMessageReader(this._handle = i);
  }
  isAsync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  cancel() {
    return __awaiter(this, void 0, void 0, function* () {
      !this.closed && (this.closed = !0) && (yield this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
    });
  }
  open(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.closed || (this.autoDestroy = shouldAutoDestroy(this, i), this.schema || (this.schema = yield this._reader.readSchema()) || (yield this.cancel())), this;
    });
  }
  throw(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.throw(i) : ITERATOR_DONE;
    });
  }
  return(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.return(i) : ITERATOR_DONE;
    });
  }
  next() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.closed)
        return ITERATOR_DONE;
      let i;
      const { _reader: g } = this;
      for (; i = yield this._readNextMessageAndValidate(); )
        if (i.isSchema())
          yield this.reset(i.header());
        else if (i.isRecordBatch()) {
          this._recordBatchIndex++;
          const E = i.header(), e = yield g.readMessageBody(i.bodyLength);
          return { done: !1, value: this._loadRecordBatch(E, e) };
        } else if (i.isDictionaryBatch()) {
          this._dictionaryIndex++;
          const E = i.header(), e = yield g.readMessageBody(i.bodyLength), t = this._loadDictionaryBatch(E, e);
          this.dictionaries.set(E.id, t);
        }
      return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new _InternalEmptyPlaceholderRecordBatch(this.schema) }) : yield this.return();
    });
  }
  _readNextMessageAndValidate(i) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this._reader.readMessage(i);
    });
  }
}
class RecordBatchFileReaderImpl extends RecordBatchStreamReaderImpl {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(i, g) {
    super(i instanceof RandomAccessFile ? i : new RandomAccessFile(i), g);
  }
  isSync() {
    return !0;
  }
  isFile() {
    return !0;
  }
  open(i) {
    if (!this.closed && !this._footer) {
      this.schema = (this._footer = this._readFooter()).schema;
      for (const g of this._footer.dictionaryBatches())
        g && this._readDictionaryBatch(this._dictionaryIndex++);
    }
    return super.open(i);
  }
  readRecordBatch(i) {
    var g;
    if (this.closed)
      return null;
    this._footer || this.open();
    const E = (g = this._footer) === null || g === void 0 ? void 0 : g.getRecordBatch(i);
    if (E && this._handle.seek(E.offset)) {
      const e = this._reader.readMessage(MessageHeader.RecordBatch);
      if (e?.isRecordBatch()) {
        const t = e.header(), n = this._reader.readMessageBody(e.bodyLength);
        return this._loadRecordBatch(t, n);
      }
    }
    return null;
  }
  _readDictionaryBatch(i) {
    var g;
    const E = (g = this._footer) === null || g === void 0 ? void 0 : g.getDictionaryBatch(i);
    if (E && this._handle.seek(E.offset)) {
      const e = this._reader.readMessage(MessageHeader.DictionaryBatch);
      if (e?.isDictionaryBatch()) {
        const t = e.header(), n = this._reader.readMessageBody(e.bodyLength), h = this._loadDictionaryBatch(t, n);
        this.dictionaries.set(t.id, h);
      }
    }
  }
  _readFooter() {
    const { _handle: i } = this, g = i.size - magicAndPadding, E = i.readInt32(g), e = i.readAt(g - E, E);
    return Footer_.decode(e);
  }
  _readNextMessageAndValidate(i) {
    var g;
    if (this._footer || this.open(), this._footer && this._recordBatchIndex < this.numRecordBatches) {
      const E = (g = this._footer) === null || g === void 0 ? void 0 : g.getRecordBatch(this._recordBatchIndex);
      if (E && this._handle.seek(E.offset))
        return this._reader.readMessage(i);
    }
    return null;
  }
}
class AsyncRecordBatchFileReaderImpl extends AsyncRecordBatchStreamReaderImpl {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(i, ...g) {
    const E = typeof g[0] != "number" ? g.shift() : void 0, e = g[0] instanceof Map ? g.shift() : void 0;
    super(i instanceof AsyncRandomAccessFile ? i : new AsyncRandomAccessFile(i, E), e);
  }
  isFile() {
    return !0;
  }
  isAsync() {
    return !0;
  }
  open(i) {
    const g = Object.create(null, {
      open: { get: () => super.open }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.closed && !this._footer) {
        this.schema = (this._footer = yield this._readFooter()).schema;
        for (const E of this._footer.dictionaryBatches())
          E && (yield this._readDictionaryBatch(this._dictionaryIndex++));
      }
      return yield g.open.call(this, i);
    });
  }
  readRecordBatch(i) {
    return __awaiter(this, void 0, void 0, function* () {
      var g;
      if (this.closed)
        return null;
      this._footer || (yield this.open());
      const E = (g = this._footer) === null || g === void 0 ? void 0 : g.getRecordBatch(i);
      if (E && (yield this._handle.seek(E.offset))) {
        const e = yield this._reader.readMessage(MessageHeader.RecordBatch);
        if (e?.isRecordBatch()) {
          const t = e.header(), n = yield this._reader.readMessageBody(e.bodyLength);
          return this._loadRecordBatch(t, n);
        }
      }
      return null;
    });
  }
  _readDictionaryBatch(i) {
    return __awaiter(this, void 0, void 0, function* () {
      var g;
      const E = (g = this._footer) === null || g === void 0 ? void 0 : g.getDictionaryBatch(i);
      if (E && (yield this._handle.seek(E.offset))) {
        const e = yield this._reader.readMessage(MessageHeader.DictionaryBatch);
        if (e?.isDictionaryBatch()) {
          const t = e.header(), n = yield this._reader.readMessageBody(e.bodyLength), h = this._loadDictionaryBatch(t, n);
          this.dictionaries.set(t.id, h);
        }
      }
    });
  }
  _readFooter() {
    return __awaiter(this, void 0, void 0, function* () {
      const { _handle: i } = this;
      i._pending && (yield i._pending);
      const g = i.size - magicAndPadding, E = yield i.readInt32(g), e = yield i.readAt(g - E, E);
      return Footer_.decode(e);
    });
  }
  _readNextMessageAndValidate(i) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._footer || (yield this.open()), this._footer && this._recordBatchIndex < this.numRecordBatches) {
        const g = this._footer.getRecordBatch(this._recordBatchIndex);
        if (g && (yield this._handle.seek(g.offset)))
          return yield this._reader.readMessage(i);
      }
      return null;
    });
  }
}
class RecordBatchJSONReaderImpl extends RecordBatchStreamReaderImpl {
  constructor(i, g) {
    super(i, g);
  }
  _loadVectors(i, g, E) {
    return new JSONVectorLoader(g, i.nodes, i.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(E);
  }
}
function shouldAutoDestroy(o, i) {
  return i && typeof i.autoDestroy == "boolean" ? i.autoDestroy : o.autoDestroy;
}
function* readAllSync(o) {
  const i = RecordBatchReader.from(o);
  try {
    if (!i.open({ autoDestroy: !1 }).closed)
      do
        yield i;
      while (!i.reset().open().closed);
  } finally {
    i.cancel();
  }
}
function readAllAsync(o) {
  return __asyncGenerator(this, arguments, function* () {
    const g = yield __await(RecordBatchReader.from(o));
    try {
      if (!(yield __await(g.open({ autoDestroy: !1 }))).closed)
        do
          yield yield __await(g);
        while (!(yield __await(g.reset().open())).closed);
    } finally {
      yield __await(g.cancel());
    }
  });
}
function fromArrowJSON(o) {
  return new RecordBatchStreamReader(new RecordBatchJSONReaderImpl(o));
}
function fromByteStream(o) {
  const i = o.peek(magicLength + 7 & -8);
  return i && i.byteLength >= 4 ? checkForMagicArrowString(i) ? new RecordBatchFileReader(new RecordBatchFileReaderImpl(o.read())) : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl(o)) : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl((function* () {
  })()));
}
function fromAsyncByteStream(o) {
  return __awaiter(this, void 0, void 0, function* () {
    const i = yield o.peek(magicLength + 7 & -8);
    return i && i.byteLength >= 4 ? checkForMagicArrowString(i) ? new RecordBatchFileReader(new RecordBatchFileReaderImpl(yield o.read())) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(o)) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl((function() {
      return __asyncGenerator(this, arguments, function* () {
      });
    })()));
  });
}
function fromFileHandle(o) {
  return __awaiter(this, void 0, void 0, function* () {
    const { size: i } = yield o.stat(), g = new AsyncRandomAccessFile(o, i);
    return i >= magicX2AndPadding && checkForMagicArrowString(yield g.readAt(0, magicLength + 7 & -8)) ? new AsyncRecordBatchFileReader(new AsyncRecordBatchFileReaderImpl(g)) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(g));
  });
}
function tableFromIPC(o) {
  const i = RecordBatchReader.from(o);
  return isPromise(i) ? i.then((g) => tableFromIPC(g)) : i.isAsync() ? i.readAll().then((g) => new Table$1(g)) : new Table$1(i.readAll());
}
const PandasRangeIndexType = "range";
var DataFrameCellType = /* @__PURE__ */ ((o) => (o.INDEX = "index", o.DATA = "data", o))(DataFrameCellType || {});
function convertVectorToList(o) {
  const i = [];
  for (let g = 0; g < o.length; g++)
    i.push(o.get(g));
  return i;
}
function getPandasTypeName(o) {
  return isNullOrUndefined(o.pandasType) ? void 0 : (o.pandasType.pandas_type === "object" ? o.pandasType.numpy_type : o.pandasType.pandas_type).toLowerCase().trim();
}
function getTimezone(o) {
  return o.arrowField?.type?.timezone ?? o.pandasType?.metadata?.timezone;
}
function isIntegerType(o) {
  if (isNullOrUndefined(o))
    return !1;
  const i = getPandasTypeName(o) ?? "";
  return (
    // Period types are integers with an extra extension name
    DataType.isInt(o.arrowField.type) && !isPeriodType(o) || i.startsWith("int") && !isIntervalType(o) || isRangeIndexType(o) || isUnsignedIntegerType(o)
  );
}
function isUnsignedIntegerType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isInt(o.arrowField.type) && o.arrowField.type.isSigned === !1 || (getPandasTypeName(o)?.startsWith("uint") ?? !1);
}
function isFloatType(o) {
  return isNullOrUndefined(o) ? !1 : (DataType.isFloat(o.arrowField.type) || getPandasTypeName(o)?.startsWith("float")) ?? !1;
}
function isDecimalType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isDecimal(o.arrowField.type) || getPandasTypeName(o) === "decimal";
}
function isNumericType(o) {
  return isNullOrUndefined(o) ? !1 : isIntegerType(o) || isFloatType(o) || isDecimalType(o);
}
function isBooleanType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isBool(o.arrowField.type) || getPandasTypeName(o) === "bool";
}
function isDurationType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isDuration(o.arrowField.type) || (getPandasTypeName(o)?.startsWith("timedelta") ?? !1);
}
function isPeriodType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isInt(o.arrowField.type) && o.arrowField.metadata.get("ARROW:extension:name") === "period" || (getPandasTypeName(o)?.startsWith("period") ?? !1);
}
function isDatetimeType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isTimestamp(o.arrowField.type) || (getPandasTypeName(o)?.startsWith("datetime") ?? !1);
}
function isDateType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isDate(o.arrowField.type) || getPandasTypeName(o) === "date";
}
function isTimeType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isTime(o.arrowField.type) || getPandasTypeName(o) === "time";
}
function isCategoricalType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isDictionary(o.arrowField.type) || getPandasTypeName(o) === "categorical";
}
function isListType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isList(o.arrowField.type) || DataType.isFixedSizeList(o.arrowField.type) || (getPandasTypeName(o)?.startsWith("list") ?? !1);
}
function isObjectType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isStruct(o.arrowField.type) || DataType.isMap(o.arrowField.type) || getPandasTypeName(o) === "object";
}
function isBytesType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isBinary(o.arrowField.type) || DataType.isLargeBinary(o.arrowField.type) || getPandasTypeName(o) === "bytes";
}
function isStringType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isUtf8(o.arrowField.type) || DataType.isLargeUtf8(o.arrowField.type) || ["unicode", "large_string[pyarrow]"].includes(getPandasTypeName(o) ?? "");
}
function isEmptyType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isNull(o.arrowField.type) || getPandasTypeName(o) === "empty";
}
function isIntervalType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isStruct(o.arrowField.type) && o.arrowField.metadata.get("ARROW:extension:name") === "interval" || (getPandasTypeName(o)?.startsWith("interval") ?? !1);
}
function isRangeIndexType(o) {
  return isNullOrUndefined(o) ? !1 : getPandasTypeName(o) === PandasRangeIndexType;
}
function sameDataTypes(o, i) {
  return o.every((g, E) => g.pandasType?.pandas_type === i[E]?.pandasType?.pandas_type);
}
function sameIndexTypes(o, i) {
  return o.length !== i.length ? !1 : o.every((g, E) => E < i.length && getPandasTypeName(g) === getPandasTypeName(i[E]));
}
function concatIndexes(o, i, g, E) {
  if (g.length === 0)
    return o;
  if (o.length === 0)
    return g;
  if (!sameIndexTypes(i, E)) {
    const t = E.map((h) => getPandasTypeName(h)), n = i.map((h) => getPandasTypeName(h));
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
index signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(t)}\`
but was expecting \`${JSON.stringify(n)}\`.
`);
  }
  if (i.length === 0)
    throw new Error("There was an error while parsing index types.");
  if (isRangeIndexType(i[0])) {
    const {
      step: t,
      stop: n
    } = i[0].pandasType?.metadata;
    g = [range$1(
      n,
      // End is not inclusive
      n + g[0].length * t,
      t
    )];
  }
  return zip$1(o, g).map((t) => t[0].concat(t[1]));
}
function concatData(o, i, g, E) {
  if (g.numCols === 0)
    return o;
  if (o.numCols === 0)
    return g;
  if (!sameDataTypes(i, E)) {
    const t = E.map((h) => h.pandasType?.pandas_type), n = i.map((h) => h.pandasType?.pandas_type);
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
data signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(t)}\`
but was expecting \`${JSON.stringify(n)}\`.
`);
  }
  const e = g.selectAt(range$1(0, o.numCols));
  return o.concat(e);
}
function concatTypes(o, i, g, E) {
  const e = concatIndexTypes(o, g), t = concatDataTypes(i, E);
  return {
    indexTypes: e,
    dataTypes: t
  };
}
function concatIndexTypes(o, i) {
  if (i.length === 0)
    return o;
  if (o.length === 0)
    return i;
  if (!sameIndexTypes(o, i)) {
    const g = i.map((e) => getPandasTypeName(e)), E = o.map((e) => getPandasTypeName(e));
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
index signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(g)}\`
but was expecting \`${JSON.stringify(E)}\`.
`);
  }
  return o.map((g) => {
    if (isRangeIndexType(g) && g.pandasType) {
      const {
        stop: E,
        step: e
      } = g.pandasType.metadata, {
        start: t,
        stop: n,
        step: h
      } = i[0].pandasType?.metadata, d = (n - t) / h, k = E + d * e;
      return {
        ...g,
        pandasType: {
          ...g.pandasType,
          metadata: {
            ...g.pandasType.metadata,
            stop: k
          }
        }
      };
    }
    return g;
  });
}
function concatDataTypes(o, i) {
  return o.length === 0 ? i : o;
}
function concat(o, i, g, E, e, t, n, h) {
  const d = concatIndexes(g, i, n, t), k = concatData(E, o, h, e), {
    indexTypes: p,
    dataTypes: M
  } = concatTypes(i, o, t, e);
  return {
    index: d,
    data: k,
    indexTypes: p,
    dataTypes: M
  };
}
let wasm;
const heap = new Array(128).fill(void 0);
heap.push(void 0, null, !0, !1);
let heap_next = heap.length;
function addHeapObject(o) {
  heap_next === heap.length && heap.push(heap.length + 1);
  const i = heap_next;
  return heap_next = heap[i], heap[i] = o, i;
}
function getObject(o) {
  return heap[o];
}
function dropObject(o) {
  o < 132 || (heap[o] = heap_next, heap_next = o);
}
function takeObject(o) {
  const i = getObject(o);
  return dropObject(o), i;
}
const cachedTextDecoder = typeof TextDecoder < "u" ? new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }) : { decode: () => {
  throw Error("TextDecoder not available");
} };
typeof TextDecoder < "u" && cachedTextDecoder.decode();
let cachedUint8Memory0 = null;
function getUint8Memory0() {
  return (cachedUint8Memory0 === null || cachedUint8Memory0.byteLength === 0) && (cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer)), cachedUint8Memory0;
}
function getStringFromWasm0(o, i) {
  return o = o >>> 0, cachedTextDecoder.decode(getUint8Memory0().subarray(o, o + i));
}
function isLikeNone(o) {
  return o == null;
}
let cachedFloat64Memory0 = null;
function getFloat64Memory0() {
  return (cachedFloat64Memory0 === null || cachedFloat64Memory0.byteLength === 0) && (cachedFloat64Memory0 = new Float64Array(wasm.memory.buffer)), cachedFloat64Memory0;
}
let cachedInt32Memory0 = null;
function getInt32Memory0() {
  return (cachedInt32Memory0 === null || cachedInt32Memory0.byteLength === 0) && (cachedInt32Memory0 = new Int32Array(wasm.memory.buffer)), cachedInt32Memory0;
}
let WASM_VECTOR_LEN = 0;
const cachedTextEncoder = typeof TextEncoder < "u" ? new TextEncoder("utf-8") : { encode: () => {
  throw Error("TextEncoder not available");
} }, encodeString = typeof cachedTextEncoder.encodeInto == "function" ? function(o, i) {
  return cachedTextEncoder.encodeInto(o, i);
} : function(o, i) {
  const g = cachedTextEncoder.encode(o);
  return i.set(g), {
    read: o.length,
    written: g.length
  };
};
function passStringToWasm0(o, i, g) {
  if (g === void 0) {
    const h = cachedTextEncoder.encode(o), d = i(h.length, 1) >>> 0;
    return getUint8Memory0().subarray(d, d + h.length).set(h), WASM_VECTOR_LEN = h.length, d;
  }
  let E = o.length, e = i(E, 1) >>> 0;
  const t = getUint8Memory0();
  let n = 0;
  for (; n < E; n++) {
    const h = o.charCodeAt(n);
    if (h > 127) break;
    t[e + n] = h;
  }
  if (n !== E) {
    n !== 0 && (o = o.slice(n)), e = g(e, E, E = n + o.length * 3, 1) >>> 0;
    const h = getUint8Memory0().subarray(e + n, e + E), d = encodeString(o, h);
    n += d.written, e = g(e, E, n, 1) >>> 0;
  }
  return WASM_VECTOR_LEN = n, e;
}
let cachedBigInt64Memory0 = null;
function getBigInt64Memory0() {
  return (cachedBigInt64Memory0 === null || cachedBigInt64Memory0.byteLength === 0) && (cachedBigInt64Memory0 = new BigInt64Array(wasm.memory.buffer)), cachedBigInt64Memory0;
}
function debugString(o) {
  const i = typeof o;
  if (i == "number" || i == "boolean" || o == null)
    return `${o}`;
  if (i == "string")
    return `"${o}"`;
  if (i == "symbol") {
    const e = o.description;
    return e == null ? "Symbol" : `Symbol(${e})`;
  }
  if (i == "function") {
    const e = o.name;
    return typeof e == "string" && e.length > 0 ? `Function(${e})` : "Function";
  }
  if (Array.isArray(o)) {
    const e = o.length;
    let t = "[";
    e > 0 && (t += debugString(o[0]));
    for (let n = 1; n < e; n++)
      t += ", " + debugString(o[n]);
    return t += "]", t;
  }
  const g = /\[object ([^\]]+)\]/.exec(toString.call(o));
  let E;
  if (g.length > 1)
    E = g[1];
  else
    return toString.call(o);
  if (E == "Object")
    try {
      return "Object(" + JSON.stringify(o) + ")";
    } catch {
      return "Object";
    }
  return o instanceof Error ? `${o.name}: ${o.message}
${o.stack}` : E;
}
const CLOSURE_DTORS = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => {
  wasm.__wbindgen_export_2.get(o.dtor)(o.a, o.b);
});
function makeMutClosure(o, i, g, E) {
  const e = { a: o, b: i, cnt: 1, dtor: g }, t = (...n) => {
    e.cnt++;
    const h = e.a;
    e.a = 0;
    try {
      return E(h, e.b, ...n);
    } finally {
      --e.cnt === 0 ? (wasm.__wbindgen_export_2.get(e.dtor)(h, e.b), CLOSURE_DTORS.unregister(e)) : e.a = h;
    }
  };
  return t.original = e, CLOSURE_DTORS.register(t, e, e), t;
}
function __wbg_adapter_50(o, i, g) {
  wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h1de40baa0df51db0(o, i, addHeapObject(g));
}
function passArray8ToWasm0(o, i) {
  const g = i(o.length * 1, 1) >>> 0;
  return getUint8Memory0().set(o, g / 1), WASM_VECTOR_LEN = o.length, g;
}
function readParquet(o, i) {
  try {
    const t = wasm.__wbindgen_add_to_stack_pointer(-16), n = passArray8ToWasm0(o, wasm.__wbindgen_malloc), h = WASM_VECTOR_LEN;
    wasm.readParquet(t, n, h, isLikeNone(i) ? 0 : addHeapObject(i));
    var g = getInt32Memory0()[t / 4 + 0], E = getInt32Memory0()[t / 4 + 1], e = getInt32Memory0()[t / 4 + 2];
    if (e)
      throw takeObject(E);
    return Table.__wrap(g);
  } finally {
    wasm.__wbindgen_add_to_stack_pointer(16);
  }
}
function _assertClass(o, i) {
  if (!(o instanceof i))
    throw new Error(`expected instance of ${i.name}`);
  return o.ptr;
}
function getArrayU8FromWasm0(o, i) {
  return o = o >>> 0, getUint8Memory0().subarray(o / 1, o / 1 + i);
}
let cachedUint32Memory0 = null;
function getUint32Memory0() {
  return (cachedUint32Memory0 === null || cachedUint32Memory0.byteLength === 0) && (cachedUint32Memory0 = new Uint32Array(wasm.memory.buffer)), cachedUint32Memory0;
}
function getArrayJsValueFromWasm0(o, i) {
  o = o >>> 0;
  const E = getUint32Memory0().subarray(o / 4, o / 4 + i), e = [];
  for (let t = 0; t < E.length; t++)
    e.push(takeObject(E[t]));
  return e;
}
function handleError(o, i) {
  try {
    return o.apply(this, i);
  } catch (g) {
    wasm.__wbindgen_exn_store(addHeapObject(g));
  }
}
function getArrayU32FromWasm0(o, i) {
  return o = o >>> 0, getUint32Memory0().subarray(o / 4, o / 4 + i);
}
function __wbg_adapter_285(o, i, g, E) {
  wasm.wasm_bindgen__convert__closures__invoke2_mut__h26b6dc7d05b06fdf(o, i, addHeapObject(g), addHeapObject(E));
}
const ColumnChunkMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_columnchunkmetadata_free(o >>> 0));
class ColumnChunkMetaData {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(ColumnChunkMetaData.prototype);
    return g.__wbg_ptr = i, ColumnChunkMetaDataFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ColumnChunkMetaDataFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_columnchunkmetadata_free(i);
  }
  /**
  * File where the column chunk is stored.
  *
  * If not set, assumed to belong to the same file as the metadata.
  * This path is relative to the current file.
  * @returns {string | undefined}
  */
  filePath() {
    try {
      const E = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_filePath(E, this.__wbg_ptr);
      var i = getInt32Memory0()[E / 4 + 0], g = getInt32Memory0()[E / 4 + 1];
      let e;
      return i !== 0 && (e = getStringFromWasm0(i, g).slice(), wasm.__wbindgen_free(i, g * 1, 1)), e;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Byte offset in `file_path()`.
  * @returns {bigint}
  */
  fileOffset() {
    return wasm.columnchunkmetadata_fileOffset(this.__wbg_ptr);
  }
  /**
  * Path (or identifier) of this column.
  * @returns {(string)[]}
  */
  columnPath() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_columnPath(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getArrayJsValueFromWasm0(i, g).slice();
      return wasm.__wbindgen_free(i, g * 4, 4), E;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * All encodings used for this column.
  * @returns {any[]}
  */
  encodings() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_encodings(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getArrayJsValueFromWasm0(i, g).slice();
      return wasm.__wbindgen_free(i, g * 4, 4), E;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Total number of values in this column chunk.
  * @returns {number}
  */
  numValues() {
    return wasm.columnchunkmetadata_numValues(this.__wbg_ptr);
  }
  /**
  * Compression for this column.
  * @returns {Compression}
  */
  compression() {
    return wasm.columnchunkmetadata_compression(this.__wbg_ptr);
  }
  /**
  * Returns the total compressed data size of this column chunk.
  * @returns {number}
  */
  compressedSize() {
    return wasm.columnchunkmetadata_compressedSize(this.__wbg_ptr);
  }
  /**
  * Returns the total uncompressed data size of this column chunk.
  * @returns {number}
  */
  uncompressedSize() {
    return wasm.columnchunkmetadata_uncompressedSize(this.__wbg_ptr);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_ffiarrowarray_free(o >>> 0));
const FFIArrowSchemaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_ffiarrowschema_free(o >>> 0));
class FFIArrowSchema {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(FFIArrowSchema.prototype);
    return g.__wbg_ptr = i, FFIArrowSchemaFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFIArrowSchemaFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_ffiarrowschema_free(i);
  }
  /**
  * Access the pointer to the
  * [`ArrowSchema`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `Field` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  addr() {
    return wasm.ffiarrowschema_addr(this.__wbg_ptr) >>> 0;
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_ffidata_free(o >>> 0));
const FFIRecordBatchFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_ffirecordbatch_free(o >>> 0));
class FFIRecordBatch {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(FFIRecordBatch.prototype);
    return g.__wbg_ptr = i, FFIRecordBatchFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFIRecordBatchFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_ffirecordbatch_free(i);
  }
  /**
  * Access the pointer to the
  * [`ArrowArray`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `RecordBatch` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  arrayAddr() {
    return wasm.ffirecordbatch_arrayAddr(this.__wbg_ptr) >>> 0;
  }
  /**
  * Access the pointer to the
  * [`ArrowSchema`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `Field` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  schemaAddr() {
    return wasm.ffirecordbatch_schemaAddr(this.__wbg_ptr) >>> 0;
  }
}
const FFITableFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_ffitable_free(o >>> 0));
class FFITable {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(FFITable.prototype);
    return g.__wbg_ptr = i, FFITableFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFITableFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_ffitable_free(i);
  }
  /**
  * Get the total number of record batches in the table
  * @returns {number}
  */
  numBatches() {
    return wasm.ffitable_numBatches(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the pointer to one ArrowSchema FFI struct
  * @returns {number}
  */
  schemaAddr() {
    return wasm.ffitable_schemaAddr(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the pointer to one ArrowArray FFI struct for a given chunk index and column index
  *
  * Access the pointer to one
  * [`ArrowArray`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct representing one of the internal `RecordBatch`es. This can be viewed or copied (without serialization) to an Arrow JS `RecordBatch` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import * as arrow from "apache-arrow";
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmTable: FFITable = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * const jsBatches: arrow.RecordBatch[] = []
  * for (let i = 0; i < wasmTable.numBatches(); i++) {
  *   // Pass `true` to copy arrays across the boundary instead of creating views.
  *   const jsRecordBatch = parseRecordBatch(
  *     wasmMemory.buffer,
  *     wasmTable.arrayAddr(i),
  *     wasmTable.schemaAddr(),
  *     true
  *   );
  *   jsBatches.push(jsRecordBatch);
  * }
  * const jsTable = new arrow.Table(jsBatches);
  * ```
  *
  * @param chunk number The chunk index to use
  * @returns number pointer to an ArrowArray FFI struct in Wasm memory
  * @param {number} chunk
  * @returns {number}
  */
  arrayAddr(i) {
    return wasm.ffitable_arrayAddr(this.__wbg_ptr, i) >>> 0;
  }
  /**
  * @returns {Uint32Array}
  */
  arrayAddrs() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.ffitable_arrayAddrs(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getArrayU32FromWasm0(i, g).slice();
      return wasm.__wbindgen_free(i, g * 4, 4), E;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  */
  drop() {
    const i = this.__destroy_into_raw();
    wasm.ffitable_drop(i);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_ffivector_free(o >>> 0));
const FileMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_filemetadata_free(o >>> 0));
class FileMetaData {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(FileMetaData.prototype);
    return g.__wbg_ptr = i, FileMetaDataFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FileMetaDataFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_filemetadata_free(i);
  }
  /**
  * Returns version of this file.
  * @returns {number}
  */
  version() {
    return wasm.filemetadata_version(this.__wbg_ptr);
  }
  /**
  * Returns number of rows in the file.
  * @returns {number}
  */
  numRows() {
    return wasm.filemetadata_numRows(this.__wbg_ptr);
  }
  /**
  * String message for application that wrote this file.
  *
  * This should have the following format:
  * `<application> version <application version> (build <application build hash>)`.
  *
  * ```shell
  * parquet-mr version 1.8.0 (build 0fda28af84b9746396014ad6a415b90592a98b3b)
  * ```
  * @returns {string | undefined}
  */
  createdBy() {
    try {
      const E = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.filemetadata_createdBy(E, this.__wbg_ptr);
      var i = getInt32Memory0()[E / 4 + 0], g = getInt32Memory0()[E / 4 + 1];
      let e;
      return i !== 0 && (e = getStringFromWasm0(i, g).slice(), wasm.__wbindgen_free(i, g * 1, 1)), e;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns key_value_metadata of this file.
  * @returns {Map<any, any>}
  */
  keyValueMetadata() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.filemetadata_keyValueMetadata(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getInt32Memory0()[e / 4 + 2];
      if (E)
        throw takeObject(g);
      return takeObject(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_intounderlyingbytesource_free(o >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_intounderlyingsink_free(o >>> 0));
const IntoUnderlyingSourceFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_intounderlyingsource_free(o >>> 0));
class IntoUnderlyingSource {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(IntoUnderlyingSource.prototype);
    return g.__wbg_ptr = i, IntoUnderlyingSourceFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, IntoUnderlyingSourceFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_intounderlyingsource_free(i);
  }
  /**
  * @param {ReadableStreamDefaultController} controller
  * @returns {Promise<any>}
  */
  pull(i) {
    const g = wasm.intounderlyingsource_pull(this.__wbg_ptr, addHeapObject(i));
    return takeObject(g);
  }
  /**
  */
  cancel() {
    const i = this.__destroy_into_raw();
    wasm.intounderlyingsource_cancel(i);
  }
}
const ParquetFileFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_parquetfile_free(o >>> 0));
class ParquetFile {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(ParquetFile.prototype);
    return g.__wbg_ptr = i, ParquetFileFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ParquetFileFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_parquetfile_free(i);
  }
  /**
  * Construct a ParquetFile from a new URL.
  *
  * @param options The options to pass into `object-store`'s [`parse_url_opts`][parse_url_opts]
  *
  * [parse_url_opts]: https://docs.rs/object_store/latest/object_store/fn.parse_url_opts.html
  * @param {string} url
  * @param {Map<any, any> | undefined} [options]
  * @returns {Promise<ParquetFile>}
  */
  static fromUrl(i, g) {
    const E = passStringToWasm0(i, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), e = WASM_VECTOR_LEN, t = wasm.parquetfile_fromUrl(E, e, isLikeNone(g) ? 0 : addHeapObject(g));
    return takeObject(t);
  }
  /**
  * Construct a ParquetFile from a new [Blob] or [File] handle.
  *
  * [Blob]: https://developer.mozilla.org/en-US/docs/Web/API/Blob
  * [File]: https://developer.mozilla.org/en-US/docs/Web/API/File
  *
  * Safety: Do not use this in a multi-threaded environment,
  * (transitively depends on `!Send` `web_sys::Blob`)
  * @param {Blob} handle
  * @returns {Promise<ParquetFile>}
  */
  static fromFile(i) {
    const g = wasm.parquetfile_fromFile(addHeapObject(i));
    return takeObject(g);
  }
  /**
  * @returns {ParquetMetaData}
  */
  metadata() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.parquetfile_metadata(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getInt32Memory0()[e / 4 + 2];
      if (E)
        throw takeObject(g);
      return ParquetMetaData.__wrap(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Read from the Parquet file in an async fashion.
  *
  * @param options
  *
  *    Options for reading Parquet data. Optional keys include:
  *
  *    - `batchSize`: The number of rows in each batch. If not provided, the upstream parquet
  *           default is 1024.
  *    - `rowGroups`: Only read data from the provided row group indexes.
  *    - `limit`: Provide a limit to the number of rows to be read.
  *    - `offset`: Provide an offset to skip over the given number of rows.
  *    - `columns`: The column names from the file to read.
  * @param {ReaderOptions | undefined} [options]
  * @returns {Promise<Table>}
  */
  read(i) {
    const g = wasm.parquetfile_read(this.__wbg_ptr, isLikeNone(i) ? 0 : addHeapObject(i));
    return takeObject(g);
  }
  /**
  * Create a readable stream of record batches.
  *
  * Each item in the stream will be a {@linkcode RecordBatch}.
  *
  * @param options
  *
  *    Options for reading Parquet data. Optional keys include:
  *
  *    - `batchSize`: The number of rows in each batch. If not provided, the upstream parquet
  *           default is 1024.
  *    - `rowGroups`: Only read data from the provided row group indexes.
  *    - `limit`: Provide a limit to the number of rows to be read.
  *    - `offset`: Provide an offset to skip over the given number of rows.
  *    - `columns`: The column names from the file to read.
  *    - `concurrency`: The number of concurrent requests to make
  * @param {ReaderOptions | undefined} [options]
  * @returns {Promise<ReadableStream>}
  */
  stream(i) {
    const g = wasm.parquetfile_stream(this.__wbg_ptr, isLikeNone(i) ? 0 : addHeapObject(i));
    return takeObject(g);
  }
}
const ParquetMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_parquetmetadata_free(o >>> 0));
class ParquetMetaData {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(ParquetMetaData.prototype);
    return g.__wbg_ptr = i, ParquetMetaDataFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ParquetMetaDataFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_parquetmetadata_free(i);
  }
  /**
  * Returns file metadata as reference.
  * @returns {FileMetaData}
  */
  fileMetadata() {
    const i = wasm.parquetmetadata_fileMetadata(this.__wbg_ptr);
    return FileMetaData.__wrap(i);
  }
  /**
  * Returns number of row groups in this file.
  * @returns {number}
  */
  numRowGroups() {
    return wasm.parquetmetadata_numRowGroups(this.__wbg_ptr) >>> 0;
  }
  /**
  * Returns row group metadata for `i`th position.
  * Position should be less than number of row groups `num_row_groups`.
  * @param {number} i
  * @returns {RowGroupMetaData}
  */
  rowGroup(i) {
    const g = wasm.parquetmetadata_rowGroup(this.__wbg_ptr, i);
    return RowGroupMetaData.__wrap(g);
  }
  /**
  * Returns row group metadata for all row groups
  * @returns {(RowGroupMetaData)[]}
  */
  rowGroups() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.parquetmetadata_rowGroups(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getArrayJsValueFromWasm0(i, g).slice();
      return wasm.__wbindgen_free(i, g * 4, 4), E;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const RecordBatchFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_recordbatch_free(o >>> 0));
class RecordBatch {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(RecordBatch.prototype);
    return g.__wbg_ptr = i, RecordBatchFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, RecordBatchFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_recordbatch_free(i);
  }
  /**
  * The number of rows in this RecordBatch.
  * @returns {number}
  */
  get numRows() {
    return wasm.recordbatch_numRows(this.__wbg_ptr) >>> 0;
  }
  /**
  * The number of columns in this RecordBatch.
  * @returns {number}
  */
  get numColumns() {
    return wasm.recordbatch_numColumns(this.__wbg_ptr) >>> 0;
  }
  /**
  * The {@linkcode Schema} of this RecordBatch.
  * @returns {Schema}
  */
  get schema() {
    const i = wasm.recordbatch_schema(this.__wbg_ptr);
    return Schema$1.__wrap(i);
  }
  /**
  * Export this RecordBatch to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does not consume** the RecordBatch, so you must remember to call {@linkcode
  * RecordBatch.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFIRecordBatch}
  */
  toFFI() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_toFFI(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getInt32Memory0()[e / 4 + 2];
      if (E)
        throw takeObject(g);
      return FFIRecordBatch.__wrap(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this RecordBatch to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the RecordBatch, so the original RecordBatch will be
  * inaccessible after this call. You must still call {@linkcode FFIRecordBatch.free} after
  * you've finished using the FFIRecordBatch.
  * @returns {FFIRecordBatch}
  */
  intoFFI() {
    try {
      const e = this.__destroy_into_raw(), t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_intoFFI(t, e);
      var i = getInt32Memory0()[t / 4 + 0], g = getInt32Memory0()[t / 4 + 1], E = getInt32Memory0()[t / 4 + 2];
      if (E)
        throw takeObject(g);
      return FFIRecordBatch.__wrap(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this RecordBatch and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const n = this.__destroy_into_raw(), h = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_intoIPCStream(h, n);
      var i = getInt32Memory0()[h / 4 + 0], g = getInt32Memory0()[h / 4 + 1], E = getInt32Memory0()[h / 4 + 2], e = getInt32Memory0()[h / 4 + 3];
      if (e)
        throw takeObject(E);
      var t = getArrayU8FromWasm0(i, g).slice();
      return wasm.__wbindgen_free(i, g * 1, 1), t;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Override the schema of this [`RecordBatch`]
  *
  * Returns an error if `schema` is not a superset of the current schema
  * as determined by [`Schema::contains`]
  * @param {Schema} schema
  * @returns {RecordBatch}
  */
  withSchema(i) {
    try {
      const n = wasm.__wbindgen_add_to_stack_pointer(-16);
      _assertClass(i, Schema$1);
      var g = i.__destroy_into_raw();
      wasm.recordbatch_withSchema(n, this.__wbg_ptr, g);
      var E = getInt32Memory0()[n / 4 + 0], e = getInt32Memory0()[n / 4 + 1], t = getInt32Memory0()[n / 4 + 2];
      if (t)
        throw takeObject(e);
      return RecordBatch.__wrap(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Return a new RecordBatch where each column is sliced
  * according to `offset` and `length`
  * @param {number} offset
  * @param {number} length
  * @returns {RecordBatch}
  */
  slice(i, g) {
    const E = wasm.recordbatch_slice(this.__wbg_ptr, i, g);
    return RecordBatch.__wrap(E);
  }
  /**
  * Returns the total number of bytes of memory occupied physically by this batch.
  * @returns {number}
  */
  getArrayMemorySize() {
    return wasm.recordbatch_getArrayMemorySize(this.__wbg_ptr) >>> 0;
  }
}
const RowGroupMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_rowgroupmetadata_free(o >>> 0));
class RowGroupMetaData {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(RowGroupMetaData.prototype);
    return g.__wbg_ptr = i, RowGroupMetaDataFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, RowGroupMetaDataFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_rowgroupmetadata_free(i);
  }
  /**
  * Number of columns in this row group.
  * @returns {number}
  */
  numColumns() {
    return wasm.rowgroupmetadata_numColumns(this.__wbg_ptr) >>> 0;
  }
  /**
  * Returns column chunk metadata for `i`th column.
  * @param {number} i
  * @returns {ColumnChunkMetaData}
  */
  column(i) {
    const g = wasm.rowgroupmetadata_column(this.__wbg_ptr, i);
    return ColumnChunkMetaData.__wrap(g);
  }
  /**
  * Returns column chunk metadata for all columns
  * @returns {(ColumnChunkMetaData)[]}
  */
  columns() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.rowgroupmetadata_columns(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getArrayJsValueFromWasm0(i, g).slice();
      return wasm.__wbindgen_free(i, g * 4, 4), E;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Number of rows in this row group.
  * @returns {number}
  */
  numRows() {
    return wasm.rowgroupmetadata_numRows(this.__wbg_ptr);
  }
  /**
  * Total byte size of all uncompressed column data in this row group.
  * @returns {number}
  */
  totalByteSize() {
    return wasm.rowgroupmetadata_totalByteSize(this.__wbg_ptr);
  }
  /**
  * Total size of all compressed column data in this row group.
  * @returns {number}
  */
  compressedSize() {
    return wasm.rowgroupmetadata_compressedSize(this.__wbg_ptr);
  }
}
const SchemaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_schema_free(o >>> 0));
let Schema$1 = class tI {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(tI.prototype);
    return g.__wbg_ptr = i, SchemaFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, SchemaFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_schema_free(i);
  }
  /**
  * Export this schema to an FFIArrowSchema object, which can be read with arrow-js-ffi.
  *
  * This method **does not consume** the Schema, so you must remember to call {@linkcode
  * Schema.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFIArrowSchema}
  */
  toFFI() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_toFFI(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getInt32Memory0()[e / 4 + 2];
      if (E)
        throw takeObject(g);
      return FFIArrowSchema.__wrap(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the Table, so the original Table will be
  * inaccessible after this call. You must still call {@linkcode FFITable.free} after
  * you've finished using the FFITable.
  * @returns {FFIArrowSchema}
  */
  intoFFI() {
    try {
      const e = this.__destroy_into_raw(), t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_intoFFI(t, e);
      var i = getInt32Memory0()[t / 4 + 0], g = getInt32Memory0()[t / 4 + 1], E = getInt32Memory0()[t / 4 + 2];
      if (E)
        throw takeObject(g);
      return FFIArrowSchema.__wrap(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this schema and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const n = this.__destroy_into_raw(), h = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_intoIPCStream(h, n);
      var i = getInt32Memory0()[h / 4 + 0], g = getInt32Memory0()[h / 4 + 1], E = getInt32Memory0()[h / 4 + 2], e = getInt32Memory0()[h / 4 + 3];
      if (e)
        throw takeObject(E);
      var t = getArrayU8FromWasm0(i, g).slice();
      return wasm.__wbindgen_free(i, g * 1, 1), t;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Sets the metadata of this `Schema` to be `metadata` and returns a new object
  * @param {SchemaMetadata} metadata
  * @returns {Schema}
  */
  withMetadata(i) {
    try {
      const t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_withMetadata(t, this.__wbg_ptr, addHeapObject(i));
      var g = getInt32Memory0()[t / 4 + 0], E = getInt32Memory0()[t / 4 + 1], e = getInt32Memory0()[t / 4 + 2];
      if (e)
        throw takeObject(E);
      return tI.__wrap(g);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Find the index of the column with the given name.
  * @param {string} name
  * @returns {number}
  */
  indexOf(i) {
    try {
      const t = wasm.__wbindgen_add_to_stack_pointer(-16), n = passStringToWasm0(i, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), h = WASM_VECTOR_LEN;
      wasm.schema_indexOf(t, this.__wbg_ptr, n, h);
      var g = getInt32Memory0()[t / 4 + 0], E = getInt32Memory0()[t / 4 + 1], e = getInt32Memory0()[t / 4 + 2];
      if (e)
        throw takeObject(E);
      return g >>> 0;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns an immutable reference to the Map of custom metadata key-value pairs.
  * @returns {SchemaMetadata}
  */
  metadata() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_metadata(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getInt32Memory0()[e / 4 + 2];
      if (E)
        throw takeObject(g);
      return takeObject(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
};
const TableFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_table_free(o >>> 0));
class Table {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(Table.prototype);
    return g.__wbg_ptr = i, TableFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, TableFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_table_free(i);
  }
  /**
  * Access the Table's {@linkcode Schema}.
  * @returns {Schema}
  */
  get schema() {
    const i = wasm.table_schema(this.__wbg_ptr);
    return Schema$1.__wrap(i);
  }
  /**
  * The number of batches in the Table
  * @returns {number}
  */
  get numBatches() {
    return wasm.table_numBatches(this.__wbg_ptr) >>> 0;
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does not consume** the Table, so you must remember to call {@linkcode
  * Table.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFITable}
  */
  toFFI() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_toFFI(e, this.__wbg_ptr);
      var i = getInt32Memory0()[e / 4 + 0], g = getInt32Memory0()[e / 4 + 1], E = getInt32Memory0()[e / 4 + 2];
      if (E)
        throw takeObject(g);
      return FFITable.__wrap(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the Table, so the original Table will be
  * inaccessible after this call. You must still call {@linkcode FFITable.free} after
  * you've finished using the FFITable.
  * @returns {FFITable}
  */
  intoFFI() {
    try {
      const e = this.__destroy_into_raw(), t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_intoFFI(t, e);
      var i = getInt32Memory0()[t / 4 + 0], g = getInt32Memory0()[t / 4 + 1], E = getInt32Memory0()[t / 4 + 2];
      if (E)
        throw takeObject(g);
      return FFITable.__wrap(i);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this table and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const n = this.__destroy_into_raw(), h = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_intoIPCStream(h, n);
      var i = getInt32Memory0()[h / 4 + 0], g = getInt32Memory0()[h / 4 + 1], E = getInt32Memory0()[h / 4 + 2], e = getInt32Memory0()[h / 4 + 3];
      if (e)
        throw takeObject(E);
      var t = getArrayU8FromWasm0(i, g).slice();
      return wasm.__wbindgen_free(i, g * 1, 1), t;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Create a table from an Arrow IPC Stream buffer
  * @param {Uint8Array} buf
  * @returns {Table}
  */
  static fromIPCStream(i) {
    try {
      const t = wasm.__wbindgen_add_to_stack_pointer(-16), n = passArray8ToWasm0(i, wasm.__wbindgen_malloc), h = WASM_VECTOR_LEN;
      wasm.table_fromIPCStream(t, n, h);
      var g = getInt32Memory0()[t / 4 + 0], E = getInt32Memory0()[t / 4 + 1], e = getInt32Memory0()[t / 4 + 2];
      if (e)
        throw takeObject(E);
      return Table.__wrap(g);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns the total number of bytes of memory occupied physically by all batches in this
  * table.
  * @returns {number}
  */
  getArrayMemorySize() {
    return wasm.table_getArrayMemorySize(this.__wbg_ptr) >>> 0;
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_wasmgetoptions_free(o >>> 0));
const WasmObjectMetaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_wasmobjectmeta_free(o >>> 0));
class WasmObjectMeta {
  static __wrap(i) {
    i = i >>> 0;
    const g = Object.create(WasmObjectMeta.prototype);
    return g.__wbg_ptr = i, WasmObjectMetaFinalization.register(g, g.__wbg_ptr, g), g;
  }
  toJSON() {
    return {
      location: this.location,
      last_modified: this.last_modified,
      size: this.size,
      e_tag: this.e_tag,
      version: this.version
    };
  }
  toString() {
    return JSON.stringify(this);
  }
  __destroy_into_raw() {
    const i = this.__wbg_ptr;
    return this.__wbg_ptr = 0, WasmObjectMetaFinalization.unregister(this), i;
  }
  free() {
    const i = this.__destroy_into_raw();
    wasm.__wbg_wasmobjectmeta_free(i);
  }
  /**
  * The full path to the object
  * @returns {string}
  */
  get location() {
    let i, g;
    try {
      const t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_location(t, this.__wbg_ptr);
      var E = getInt32Memory0()[t / 4 + 0], e = getInt32Memory0()[t / 4 + 1];
      return i = E, g = e, getStringFromWasm0(E, e);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16), wasm.__wbindgen_free(i, g, 1);
    }
  }
  /**
  * The full path to the object
  * @param {string} arg0
  */
  set location(i) {
    const g = passStringToWasm0(i, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), E = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_location(this.__wbg_ptr, g, E);
  }
  /**
  * The last modified time
  * @returns {Date}
  */
  get last_modified() {
    const i = wasm.__wbg_get_wasmobjectmeta_last_modified(this.__wbg_ptr);
    return takeObject(i);
  }
  /**
  * The last modified time
  * @param {Date} arg0
  */
  set last_modified(i) {
    wasm.__wbg_set_wasmobjectmeta_last_modified(this.__wbg_ptr, addHeapObject(i));
  }
  /**
  * The size in bytes of the object
  * @returns {number}
  */
  get size() {
    return wasm.__wbg_get_wasmobjectmeta_size(this.__wbg_ptr) >>> 0;
  }
  /**
  * The size in bytes of the object
  * @param {number} arg0
  */
  set size(i) {
    wasm.__wbg_set_wasmobjectmeta_size(this.__wbg_ptr, i);
  }
  /**
  * The unique identifier for the object
  *
  * <https://datatracker.ietf.org/doc/html/rfc9110#name-etag>
  * @returns {string | undefined}
  */
  get e_tag() {
    try {
      const E = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_e_tag(E, this.__wbg_ptr);
      var i = getInt32Memory0()[E / 4 + 0], g = getInt32Memory0()[E / 4 + 1];
      let e;
      return i !== 0 && (e = getStringFromWasm0(i, g).slice(), wasm.__wbindgen_free(i, g * 1, 1)), e;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * The unique identifier for the object
  *
  * <https://datatracker.ietf.org/doc/html/rfc9110#name-etag>
  * @param {string | undefined} [arg0]
  */
  set e_tag(i) {
    var g = isLikeNone(i) ? 0 : passStringToWasm0(i, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), E = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_e_tag(this.__wbg_ptr, g, E);
  }
  /**
  * A version indicator for this object
  * @returns {string | undefined}
  */
  get version() {
    try {
      const E = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_version(E, this.__wbg_ptr);
      var i = getInt32Memory0()[E / 4 + 0], g = getInt32Memory0()[E / 4 + 1];
      let e;
      return i !== 0 && (e = getStringFromWasm0(i, g).slice(), wasm.__wbindgen_free(i, g * 1, 1)), e;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * A version indicator for this object
  * @param {string | undefined} [arg0]
  */
  set version(i) {
    var g = isLikeNone(i) ? 0 : passStringToWasm0(i, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), E = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_version(this.__wbg_ptr, g, E);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_wasmobjectstore_free(o >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_writerproperties_free(o >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_writerpropertiesbuilder_free(o >>> 0));
async function __wbg_load(o, i) {
  if (typeof Response == "function" && o instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming == "function")
      try {
        return await WebAssembly.instantiateStreaming(o, i);
      } catch (E) {
        if (o.headers.get("Content-Type") != "application/wasm")
          console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", E);
        else
          throw E;
      }
    const g = await o.arrayBuffer();
    return await WebAssembly.instantiate(g, i);
  } else {
    const g = await WebAssembly.instantiate(o, i);
    return g instanceof WebAssembly.Instance ? { instance: g, module: o } : g;
  }
}
function __wbg_get_imports() {
  const o = {};
  return o.wbg = {}, o.wbg.__wbindgen_number_new = function(i) {
    return addHeapObject(i);
  }, o.wbg.__wbg_columnchunkmetadata_new = function(i) {
    const g = ColumnChunkMetaData.__wrap(i);
    return addHeapObject(g);
  }, o.wbg.__wbg_rowgroupmetadata_new = function(i) {
    const g = RowGroupMetaData.__wrap(i);
    return addHeapObject(g);
  }, o.wbg.__wbg_parquetfile_new = function(i) {
    const g = ParquetFile.__wrap(i);
    return addHeapObject(g);
  }, o.wbg.__wbindgen_object_drop_ref = function(i) {
    takeObject(i);
  }, o.wbg.__wbindgen_object_clone_ref = function(i) {
    const g = getObject(i);
    return addHeapObject(g);
  }, o.wbg.__wbindgen_error_new = function(i, g) {
    const E = new Error(getStringFromWasm0(i, g));
    return addHeapObject(E);
  }, o.wbg.__wbindgen_is_undefined = function(i) {
    return getObject(i) === void 0;
  }, o.wbg.__wbindgen_in = function(i, g) {
    return getObject(i) in getObject(g);
  }, o.wbg.__wbindgen_is_bigint = function(i) {
    return typeof getObject(i) == "bigint";
  }, o.wbg.__wbindgen_bigint_from_u64 = function(i) {
    const g = BigInt.asUintN(64, i);
    return addHeapObject(g);
  }, o.wbg.__wbindgen_jsval_eq = function(i, g) {
    return getObject(i) === getObject(g);
  }, o.wbg.__wbindgen_is_object = function(i) {
    const g = getObject(i);
    return typeof g == "object" && g !== null;
  }, o.wbg.__wbindgen_string_new = function(i, g) {
    const E = getStringFromWasm0(i, g);
    return addHeapObject(E);
  }, o.wbg.__wbindgen_number_get = function(i, g) {
    const E = getObject(g), e = typeof E == "number" ? E : void 0;
    getFloat64Memory0()[i / 8 + 1] = isLikeNone(e) ? 0 : e, getInt32Memory0()[i / 4 + 0] = !isLikeNone(e);
  }, o.wbg.__wbg_fetch_1db5b0ae726d68b5 = function(i) {
    const g = fetch(getObject(i));
    return addHeapObject(g);
  }, o.wbg.__wbg_wasmobjectmeta_new = function(i) {
    const g = WasmObjectMeta.__wrap(i);
    return addHeapObject(g);
  }, o.wbg.__wbindgen_string_get = function(i, g) {
    const E = getObject(g), e = typeof E == "string" ? E : void 0;
    var t = isLikeNone(e) ? 0 : passStringToWasm0(e, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), n = WASM_VECTOR_LEN;
    getInt32Memory0()[i / 4 + 1] = n, getInt32Memory0()[i / 4 + 0] = t;
  }, o.wbg.__wbg_fetch_bc7c8e27076a5c84 = function(i) {
    const g = fetch(getObject(i));
    return addHeapObject(g);
  }, o.wbg.__wbg_done_2ffa852272310e47 = function(i) {
    return getObject(i).done;
  }, o.wbg.__wbg_value_9f6eeb1e2aab8d96 = function(i) {
    const g = getObject(i).value;
    return addHeapObject(g);
  }, o.wbg.__wbg_newwithintounderlyingsource_a03a82aa1bbbb292 = function(i, g) {
    const E = new ReadableStream(IntoUnderlyingSource.__wrap(i), takeObject(g));
    return addHeapObject(E);
  }, o.wbg.__wbg_getReader_ab94afcb5cb7689a = function() {
    return handleError(function(i) {
      const g = getObject(i).getReader();
      return addHeapObject(g);
    }, arguments);
  }, o.wbg.__wbg_sethighWaterMark_ea50ed3ec2143088 = function(i, g) {
    getObject(i).highWaterMark = g;
  }, o.wbg.__wbg_recordbatch_new = function(i) {
    const g = RecordBatch.__wrap(i);
    return addHeapObject(g);
  }, o.wbg.__wbg_table_new = function(i) {
    const g = Table.__wrap(i);
    return addHeapObject(g);
  }, o.wbg.__wbindgen_jsval_loose_eq = function(i, g) {
    return getObject(i) == getObject(g);
  }, o.wbg.__wbindgen_boolean_get = function(i) {
    const g = getObject(i);
    return typeof g == "boolean" ? g ? 1 : 0 : 2;
  }, o.wbg.__wbindgen_as_number = function(i) {
    return +getObject(i);
  }, o.wbg.__wbg_String_b9412f8799faab3e = function(i, g) {
    const E = String(getObject(g)), e = passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), t = WASM_VECTOR_LEN;
    getInt32Memory0()[i / 4 + 1] = t, getInt32Memory0()[i / 4 + 0] = e;
  }, o.wbg.__wbg_getwithrefkey_edc2c8960f0f1191 = function(i, g) {
    const E = getObject(i)[getObject(g)];
    return addHeapObject(E);
  }, o.wbg.__wbg_set_f975102236d3c502 = function(i, g, E) {
    getObject(i)[takeObject(g)] = takeObject(E);
  }, o.wbg.__wbindgen_cb_drop = function(i) {
    const g = takeObject(i).original;
    return g.cnt-- == 1 ? (g.a = 0, !0) : !1;
  }, o.wbg.__wbg_queueMicrotask_481971b0d87f3dd4 = function(i) {
    queueMicrotask(getObject(i));
  }, o.wbg.__wbg_queueMicrotask_3cbae2ec6b6cd3d6 = function(i) {
    const g = getObject(i).queueMicrotask;
    return addHeapObject(g);
  }, o.wbg.__wbindgen_is_function = function(i) {
    return typeof getObject(i) == "function";
  }, o.wbg.__wbg_fetch_921fad6ef9e883dd = function(i, g) {
    const E = getObject(i).fetch(getObject(g));
    return addHeapObject(E);
  }, o.wbg.__wbg_new_ab6fd82b10560829 = function() {
    return handleError(function() {
      const i = new Headers();
      return addHeapObject(i);
    }, arguments);
  }, o.wbg.__wbg_append_7bfcb4937d1d5e29 = function() {
    return handleError(function(i, g, E, e, t) {
      getObject(i).append(getStringFromWasm0(g, E), getStringFromWasm0(e, t));
    }, arguments);
  }, o.wbg.__wbg_close_a994f9425dab445c = function() {
    return handleError(function(i) {
      getObject(i).close();
    }, arguments);
  }, o.wbg.__wbg_enqueue_ea194723156c0cc2 = function() {
    return handleError(function(i, g) {
      getObject(i).enqueue(getObject(g));
    }, arguments);
  }, o.wbg.__wbg_size_9c7e57fbd4f0f4b5 = function(i) {
    return getObject(i).size;
  }, o.wbg.__wbg_arrayBuffer_307ddd1bd1d04e23 = function(i) {
    const g = getObject(i).arrayBuffer();
    return addHeapObject(g);
  }, o.wbg.__wbg_slice_1991e6e71a6587f3 = function() {
    return handleError(function(i, g, E) {
      const e = getObject(i).slice(g, E);
      return addHeapObject(e);
    }, arguments);
  }, o.wbg.__wbg_read_e7d0f8a49be01d86 = function(i) {
    const g = getObject(i).read();
    return addHeapObject(g);
  }, o.wbg.__wbg_releaseLock_5c49db976c08b864 = function(i) {
    getObject(i).releaseLock();
  }, o.wbg.__wbg_cancel_6ee33d4006737aef = function(i) {
    const g = getObject(i).cancel();
    return addHeapObject(g);
  }, o.wbg.__wbg_byobRequest_72fca99f9c32c193 = function(i) {
    const g = getObject(i).byobRequest;
    return isLikeNone(g) ? 0 : addHeapObject(g);
  }, o.wbg.__wbg_close_184931724d961ccc = function() {
    return handleError(function(i) {
      getObject(i).close();
    }, arguments);
  }, o.wbg.__wbg_instanceof_Response_849eb93e75734b6e = function(i) {
    let g;
    try {
      g = getObject(i) instanceof Response;
    } catch {
      g = !1;
    }
    return g;
  }, o.wbg.__wbg_url_5f6dc4009ac5f99d = function(i, g) {
    const E = getObject(g).url, e = passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), t = WASM_VECTOR_LEN;
    getInt32Memory0()[i / 4 + 1] = t, getInt32Memory0()[i / 4 + 0] = e;
  }, o.wbg.__wbg_status_61a01141acd3cf74 = function(i) {
    return getObject(i).status;
  }, o.wbg.__wbg_headers_9620bfada380764a = function(i) {
    const g = getObject(i).headers;
    return addHeapObject(g);
  }, o.wbg.__wbg_body_9545a94f397829db = function(i) {
    const g = getObject(i).body;
    return isLikeNone(g) ? 0 : addHeapObject(g);
  }, o.wbg.__wbg_arrayBuffer_29931d52c7206b02 = function() {
    return handleError(function(i) {
      const g = getObject(i).arrayBuffer();
      return addHeapObject(g);
    }, arguments);
  }, o.wbg.__wbg_signal_a61f78a3478fd9bc = function(i) {
    const g = getObject(i).signal;
    return addHeapObject(g);
  }, o.wbg.__wbg_new_0d76b0581eca6298 = function() {
    return handleError(function() {
      const i = new AbortController();
      return addHeapObject(i);
    }, arguments);
  }, o.wbg.__wbg_abort_2aa7521d5690750e = function(i) {
    getObject(i).abort();
  }, o.wbg.__wbg_view_7f0ce470793a340f = function(i) {
    const g = getObject(i).view;
    return isLikeNone(g) ? 0 : addHeapObject(g);
  }, o.wbg.__wbg_respond_b1a43b2e3a06d525 = function() {
    return handleError(function(i, g) {
      getObject(i).respond(g >>> 0);
    }, arguments);
  }, o.wbg.__wbg_newwithstrandinit_3fd6fba4083ff2d0 = function() {
    return handleError(function(i, g, E) {
      const e = new Request(getStringFromWasm0(i, g), getObject(E));
      return addHeapObject(e);
    }, arguments);
  }, o.wbg.__wbg_get_bd8e338fbd5f5cc8 = function(i, g) {
    const E = getObject(i)[g >>> 0];
    return addHeapObject(E);
  }, o.wbg.__wbg_length_cd7af8117672b8b8 = function(i) {
    return getObject(i).length;
  }, o.wbg.__wbg_newnoargs_e258087cd0daa0ea = function(i, g) {
    const E = new Function(getStringFromWasm0(i, g));
    return addHeapObject(E);
  }, o.wbg.__wbg_new_d9bc3a0147634640 = function() {
    return addHeapObject(/* @__PURE__ */ new Map());
  }, o.wbg.__wbg_next_40fc327bfc8770e6 = function(i) {
    const g = getObject(i).next;
    return addHeapObject(g);
  }, o.wbg.__wbg_next_196c84450b364254 = function() {
    return handleError(function(i) {
      const g = getObject(i).next();
      return addHeapObject(g);
    }, arguments);
  }, o.wbg.__wbg_done_298b57d23c0fc80c = function(i) {
    return getObject(i).done;
  }, o.wbg.__wbg_value_d93c65011f51a456 = function(i) {
    const g = getObject(i).value;
    return addHeapObject(g);
  }, o.wbg.__wbg_iterator_2cee6dadfd956dfa = function() {
    return addHeapObject(Symbol.iterator);
  }, o.wbg.__wbg_get_e3c254076557e348 = function() {
    return handleError(function(i, g) {
      const E = Reflect.get(getObject(i), getObject(g));
      return addHeapObject(E);
    }, arguments);
  }, o.wbg.__wbg_call_27c0f87801dedf93 = function() {
    return handleError(function(i, g) {
      const E = getObject(i).call(getObject(g));
      return addHeapObject(E);
    }, arguments);
  }, o.wbg.__wbg_new_72fb9a18b5ae2624 = function() {
    const i = new Object();
    return addHeapObject(i);
  }, o.wbg.__wbindgen_is_string = function(i) {
    return typeof getObject(i) == "string";
  }, o.wbg.__wbg_self_ce0dbfc45cf2f5be = function() {
    return handleError(function() {
      const i = self.self;
      return addHeapObject(i);
    }, arguments);
  }, o.wbg.__wbg_window_c6fb939a7f436783 = function() {
    return handleError(function() {
      const i = window.window;
      return addHeapObject(i);
    }, arguments);
  }, o.wbg.__wbg_globalThis_d1e6af4856ba331b = function() {
    return handleError(function() {
      const i = globalThis.globalThis;
      return addHeapObject(i);
    }, arguments);
  }, o.wbg.__wbg_global_207b558942527489 = function() {
    return handleError(function() {
      const i = global.global;
      return addHeapObject(i);
    }, arguments);
  }, o.wbg.__wbg_isArray_2ab64d95e09ea0ae = function(i) {
    return Array.isArray(getObject(i));
  }, o.wbg.__wbg_instanceof_ArrayBuffer_836825be07d4c9d2 = function(i) {
    let g;
    try {
      g = getObject(i) instanceof ArrayBuffer;
    } catch {
      g = !1;
    }
    return g;
  }, o.wbg.__wbg_new_28c511d9baebfa89 = function(i, g) {
    const E = new Error(getStringFromWasm0(i, g));
    return addHeapObject(E);
  }, o.wbg.__wbg_call_b3ca7c6051f9bec1 = function() {
    return handleError(function(i, g, E) {
      const e = getObject(i).call(getObject(g), getObject(E));
      return addHeapObject(e);
    }, arguments);
  }, o.wbg.__wbg_set_8417257aaedc936b = function(i, g, E) {
    const e = getObject(i).set(getObject(g), getObject(E));
    return addHeapObject(e);
  }, o.wbg.__wbg_isSafeInteger_f7b04ef02296c4d2 = function(i) {
    return Number.isSafeInteger(getObject(i));
  }, o.wbg.__wbg_new_cf3ec55744a78578 = function(i) {
    const g = new Date(getObject(i));
    return addHeapObject(g);
  }, o.wbg.__wbg_entries_95cc2c823b285a09 = function(i) {
    const g = Object.entries(getObject(i));
    return addHeapObject(g);
  }, o.wbg.__wbg_new_81740750da40724f = function(i, g) {
    try {
      var E = { a: i, b: g }, e = (n, h) => {
        const d = E.a;
        E.a = 0;
        try {
          return __wbg_adapter_285(d, E.b, n, h);
        } finally {
          E.a = d;
        }
      };
      const t = new Promise(e);
      return addHeapObject(t);
    } finally {
      E.a = E.b = 0;
    }
  }, o.wbg.__wbg_resolve_b0083a7967828ec8 = function(i) {
    const g = Promise.resolve(getObject(i));
    return addHeapObject(g);
  }, o.wbg.__wbg_catch_0260e338d10f79ae = function(i, g) {
    const E = getObject(i).catch(getObject(g));
    return addHeapObject(E);
  }, o.wbg.__wbg_then_0c86a60e8fcfe9f6 = function(i, g) {
    const E = getObject(i).then(getObject(g));
    return addHeapObject(E);
  }, o.wbg.__wbg_then_a73caa9a87991566 = function(i, g, E) {
    const e = getObject(i).then(getObject(g), getObject(E));
    return addHeapObject(e);
  }, o.wbg.__wbg_buffer_12d079cc21e14bdb = function(i) {
    const g = getObject(i).buffer;
    return addHeapObject(g);
  }, o.wbg.__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb = function(i, g, E) {
    const e = new Uint8Array(getObject(i), g >>> 0, E >>> 0);
    return addHeapObject(e);
  }, o.wbg.__wbg_new_63b92bc8671ed464 = function(i) {
    const g = new Uint8Array(getObject(i));
    return addHeapObject(g);
  }, o.wbg.__wbg_set_a47bac70306a19a7 = function(i, g, E) {
    getObject(i).set(getObject(g), E >>> 0);
  }, o.wbg.__wbg_length_c20a40f15020d68a = function(i) {
    return getObject(i).length;
  }, o.wbg.__wbg_instanceof_Uint8Array_2b3bbecd033d19f6 = function(i) {
    let g;
    try {
      g = getObject(i) instanceof Uint8Array;
    } catch {
      g = !1;
    }
    return g;
  }, o.wbg.__wbg_newwithlength_e9b4878cebadb3d3 = function(i) {
    const g = new Uint8Array(i >>> 0);
    return addHeapObject(g);
  }, o.wbg.__wbg_newwithbyteoffset_27c6424791adc775 = function(i, g) {
    const E = new Uint8Array(getObject(i), g >>> 0);
    return addHeapObject(E);
  }, o.wbg.__wbg_buffer_dd7f74bc60f1faab = function(i) {
    const g = getObject(i).buffer;
    return addHeapObject(g);
  }, o.wbg.__wbg_byteLength_58f7b4fab1919d44 = function(i) {
    return getObject(i).byteLength;
  }, o.wbg.__wbg_byteOffset_81d60f7392524f62 = function(i) {
    return getObject(i).byteOffset;
  }, o.wbg.__wbg_stringify_8887fe74e1c50d81 = function() {
    return handleError(function(i) {
      const g = JSON.stringify(getObject(i));
      return addHeapObject(g);
    }, arguments);
  }, o.wbg.__wbg_has_0af94d20077affa2 = function() {
    return handleError(function(i, g) {
      return Reflect.has(getObject(i), getObject(g));
    }, arguments);
  }, o.wbg.__wbg_set_1f9b04f170055d33 = function() {
    return handleError(function(i, g, E) {
      return Reflect.set(getObject(i), getObject(g), getObject(E));
    }, arguments);
  }, o.wbg.__wbindgen_bigint_get_as_i64 = function(i, g) {
    const E = getObject(g), e = typeof E == "bigint" ? E : void 0;
    getBigInt64Memory0()[i / 8 + 1] = isLikeNone(e) ? BigInt(0) : e, getInt32Memory0()[i / 4 + 0] = !isLikeNone(e);
  }, o.wbg.__wbindgen_debug_string = function(i, g) {
    const E = debugString(getObject(g)), e = passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), t = WASM_VECTOR_LEN;
    getInt32Memory0()[i / 4 + 1] = t, getInt32Memory0()[i / 4 + 0] = e;
  }, o.wbg.__wbindgen_throw = function(i, g) {
    throw new Error(getStringFromWasm0(i, g));
  }, o.wbg.__wbindgen_memory = function() {
    const i = wasm.memory;
    return addHeapObject(i);
  }, o.wbg.__wbindgen_function_table = function() {
    const i = wasm.__wbindgen_export_2;
    return addHeapObject(i);
  }, o.wbg.__wbindgen_closure_wrapper13295 = function(i, g, E) {
    const e = makeMutClosure(i, g, 3248, __wbg_adapter_50);
    return addHeapObject(e);
  }, o;
}
function __wbg_finalize_init(o, i) {
  return wasm = o.exports, __wbg_init.__wbindgen_wasm_module = i, cachedBigInt64Memory0 = null, cachedFloat64Memory0 = null, cachedInt32Memory0 = null, cachedUint32Memory0 = null, cachedUint8Memory0 = null, wasm;
}
async function __wbg_init(o) {
  if (wasm !== void 0) return wasm;
  typeof o > "u" && (o = new URL("./assets/1b1a876c211e4f13.wasm", import.meta.url));
  const i = __wbg_get_imports();
  (typeof o == "string" || typeof Request == "function" && o instanceof Request || typeof URL == "function" && o instanceof URL) && (o = fetch(o));
  const { instance: g, module: E } = await __wbg_load(await o, i);
  return __wbg_finalize_init(g, E);
}
__wbg_init();
function isPandasRangeIndex(o) {
  return typeof o == "object" && o.kind === "range";
}
function parsePandasSchema(o) {
  const i = o.schema.metadata.get("pandas");
  if (!isNullOrUndefined(i))
    return JSON.parse(i);
}
function parsePandasIndexData(o, i) {
  return i ? i.index_columns.map((g) => {
    if (isPandasRangeIndex(g)) {
      const {
        start: e,
        stop: t,
        step: n
      } = g;
      return range$1(e, t, n);
    }
    const E = o.getChild(g);
    return E instanceof Vector && E.type instanceof Null ? null : E;
  }).filter((g) => g !== null) : [];
}
function parseHeaderName(o, i) {
  if (i === 1)
    return [o];
  try {
    return JSON.parse(o.trim().replace(/^\(/, "[").replace(/\)$/, "]").replace(/'/g, '"'));
  } catch {
    return [...Array(i - 1).fill(""), o];
  }
}
function parseColumnNames(o, i, g) {
  const E = i.concat(o);
  return unzip(E.map((e) => e.arrowField.name.startsWith("__index_level_") ? "" : e.arrowField.name).map((e) => (
    // If DataFrame `columns` has multi-level indexing, the length of
    // `column_indexes` will show how many levels there are.
    parseHeaderName(e, g?.column_indexes.length ?? 1)
  )));
}
function parseData(o, i) {
  const g = o.numRows, E = i.length;
  if (g === 0 || E === 0)
    return o.select([]);
  const e = i.map((t) => t.arrowField.name);
  return o.select(e);
}
function parsePandasIndexColumnTypes(o, i, g) {
  return i ? i.index_columns.map((e) => {
    if (isPandasRangeIndex(e)) {
      const n = e.name || "";
      return {
        type: DataFrameCellType.INDEX,
        arrowField: new Field(n, new Int_(!0, 64), !0),
        pandasType: {
          field_name: n,
          name: n,
          pandas_type: PandasRangeIndexType,
          numpy_type: PandasRangeIndexType,
          metadata: e
        }
      };
    }
    const t = o.fields.find((n) => n.name === e);
    if (!t)
      throw new Error(`Index field ${e} not found in arrow schema`);
    return {
      type: DataFrameCellType.INDEX,
      arrowField: t,
      pandasType: i.columns.find((n) => n.field_name === e),
      categoricalOptions: g[t.name]
    };
  }) : [];
}
function parseDataColumnTypes(o, i, g) {
  return o.fields.filter((t) => i ? !i.index_columns.includes(t.name) : !0).map((t) => ({
    type: DataFrameCellType.DATA,
    arrowField: t,
    pandasType: i?.columns.find((n) => n.field_name === t.name),
    categoricalOptions: g[t.name]
  }));
}
function parseCategoricalOptionsForColumns(o) {
  const i = {};
  return o.schema.fields.forEach((g, E) => {
    if (g.type instanceof Dictionary) {
      const e = o.getChildAt(E)?.data[0]?.dictionary;
      notNullOrUndefined(e) && (i[g.name] = convertVectorToList(e));
    }
  }), i;
}
function parseArrowIpcBytes(o) {
  const i = tableFromIPC(o && readParquet(o).intoIPCStream()), g = i.schema, E = parsePandasSchema(i), e = parseCategoricalOptionsForColumns(i), t = parsePandasIndexColumnTypes(g, E, e), n = parseDataColumnTypes(g, E, e), h = parseData(i, n), d = parsePandasIndexData(i, E), k = parseColumnNames(n, t, E);
  return {
    pandasIndexData: d,
    data: h,
    columnNames: k,
    pandasIndexColumnTypes: t,
    dataColumnTypes: n
  };
}
var _a;
_a = DRAFTABLE;
class Quiver {
  constructor(i) {
    this[_a] = !0;
    const {
      pandasIndexData: g,
      columnNames: E,
      data: e,
      dataColumnTypes: t,
      pandasIndexColumnTypes: n
    } = parseArrowIpcBytes(i.data), h = i.styler ? parseStyler(i.styler) : void 0;
    this._pandasIndexData = g, this._columnNames = E, this._data = e, this._dataColumnTypes = t, this._pandasIndexColumnTypes = n, this._styler = h, this._num_bytes = i.data?.length ?? 0, this._columnTypes = this._pandasIndexColumnTypes.concat(this._dataColumnTypes);
  }
  /** Matrix of column names of the index- & data-columns.
   *
   * This is a matrix to support multi-level headers.
   * Index columns only exist if the DataFrame was created based on a Pandas DataFrame.
   */
  get columnNames() {
    return this._columnNames;
  }
  /** List of column types for every index- & data-column. */
  get columnTypes() {
    return this._columnTypes;
  }
  /** Pandas Styler data. This will only be defined if the user styled the dataframe
   * via Pandas Styler.
   */
  get styler() {
    return this._styler;
  }
  /** Dimensions of the DataFrame. */
  get dimensions() {
    const i = this._pandasIndexColumnTypes.length || 0, g = this._columnNames.length || 1, E = this._data.numRows || 0, e = this._dataColumnTypes.length || 0, t = g + E, n = i + e;
    return {
      numHeaderRows: g,
      numIndexColumns: i,
      numDataRows: E,
      numDataColumns: e,
      numRows: t,
      numColumns: n
    };
  }
  /**
   * A hash that identifies the underlying data.
   *
   * This hash is based on various descriptive information
   * but is not 100% guaranteed to be unique.
   */
  get hash() {
    const i = [this.dimensions.numColumns, this.dimensions.numDataColumns, this.dimensions.numDataRows, this.dimensions.numIndexColumns, this.dimensions.numHeaderRows, this.dimensions.numRows, this._num_bytes, this._columnNames];
    return hashString(i.join("-"));
  }
  /** Return a single cell from an (Pandas) index- or data-column of the DataFrame.
   *
   * @param rowIndex - The row index of the cell (0 is the first data or index row excluding header rows)
   * @param columnIndex - The column index of the cell (0 is the first data or index column)
   * @returns The cell's content, type, and field.
   */
  getCell(i, g) {
    const {
      numIndexColumns: E,
      numDataRows: e,
      numColumns: t
    } = this.dimensions;
    if (i < 0 || i >= e)
      throw new Error(`Row index is out of range: ${i}`);
    if (g < 0 || g >= t)
      throw new Error(`Column index is out of range: ${g}`);
    if (g < E) {
      const p = this._pandasIndexColumnTypes[g], M = this.getIndexValue(i, g);
      return {
        type: DataFrameCellType.INDEX,
        content: M,
        contentType: p,
        field: p.arrowField
      };
    }
    const h = g - E, d = this._dataColumnTypes[h], k = this.getDataValue(i, h);
    return {
      type: DataFrameCellType.DATA,
      content: k,
      contentType: d,
      field: d.arrowField
    };
  }
  /** Get the raw value of an index cell.
   *
   * Index columns only exist if the DataFrame was created based on a Pandas DataFrame.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getIndexValue(i, g) {
    const E = this._pandasIndexData[g];
    return E instanceof Vector ? E.get(i) : E[i];
  }
  /** Get the raw value of a data cell. */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getDataValue(i, g) {
    return this._data.getChildAt(g)?.get(i);
  }
  /**
   * Add the contents of another table (data + indexes) to this table.
   * Extra columns will not be created.
   */
  addRows(i) {
    if (this.styler || i.styler)
      throw new Error("\nUnsupported operation. `add_rows()` does not support Pandas Styler objects.\n\nIf you do not need the Styler's styles, try passing the `.data` attribute of\nthe Styler object instead to concatenate just the underlying dataframe.\n\nFor example:\n```\nst.add_rows(my_styler.data)\n```\n");
    if (i.dimensions.numDataRows === 0)
      return produce(this, (n) => n);
    if (this.dimensions.numDataRows === 0)
      return produce(i, (n) => n);
    const {
      index: g,
      data: E,
      indexTypes: e,
      dataTypes: t
    } = concat(this._dataColumnTypes, this._pandasIndexColumnTypes, this._pandasIndexData, this._data, i._dataColumnTypes, i._pandasIndexColumnTypes, i._pandasIndexData, i._data);
    return produce(this, (n) => {
      n._pandasIndexData = g, n._data = E, n._pandasIndexColumnTypes = e, n._dataColumnTypes = t, n._columnTypes = e.concat(t);
    });
  }
}
function parseStyler(o) {
  return {
    uuid: o.uuid,
    caption: o.caption,
    cssStyles: o.styles,
    cssId: o.uuid ? `T_${o.uuid}` : void 0,
    // Recursively create a new Quiver instance for Styler's display values.
    // This values will be used for rendering the DataFrame, while the original values
    // will be used for sorting, etc.
    displayValues: new Quiver({
      data: o.displayValues
    })
  };
}
class ElementNode {
  /** Create a new ElementNode. */
  constructor(i, g, E, e, t) {
    this.element = i, this.metadata = g, this.scriptRunId = E, this.activeScriptHash = e, this.fragmentId = t;
  }
  get quiverElement() {
    if (this.lazyQuiverElement !== void 0)
      return this.lazyQuiverElement;
    if (this.element.type !== "arrowTable" && this.element.type !== "arrowDataFrame")
      throw new Error(`elementType '${this.element.type}' is not a valid Quiver element!`);
    const i = new Quiver(this.element[this.element.type]);
    return this.lazyQuiverElement = i, i;
  }
  get vegaLiteChartElement() {
    if (this.lazyVegaLiteChartElement !== void 0)
      return this.lazyVegaLiteChartElement;
    if (this.element.type !== "arrowVegaLiteChart")
      throw new Error(`elementType '${this.element.type}' is not a valid VegaLiteChartElement!`);
    const i = this.element.arrowVegaLiteChart, g = i.data ? new Quiver(i.data) : null, E = i.datasets.length > 0 ? wrapDatasets(i.datasets) : [], e = {
      data: g,
      spec: i.spec,
      datasets: E,
      useContainerWidth: i.useContainerWidth,
      vegaLiteTheme: i.theme,
      id: i.id,
      selectionMode: i.selectionMode,
      formId: i.formId
    };
    return this.lazyVegaLiteChartElement = e, e;
  }
  arrowAddRows(i, g) {
    const E = this.element.type, e = new ElementNode(this.element, this.metadata, g, this.activeScriptHash, this.fragmentId);
    switch (E) {
      case "arrowTable":
      case "arrowDataFrame": {
        e.lazyQuiverElement = ElementNode.quiverAddRowsHelper(this.quiverElement, i);
        break;
      }
      case "arrowVegaLiteChart": {
        e.lazyVegaLiteChartElement = ElementNode.vegaLiteChartAddRowsHelper(this.vegaLiteChartElement, i);
        break;
      }
      default:
        throw new Error(`elementType '${this.element.type}' is not a valid arrowAddRows target!`);
    }
    return e;
  }
  static quiverAddRowsHelper(i, g) {
    if (g.hasName)
      throw new Error("Add rows cannot be used with a named dataset for this element.");
    const E = new Quiver(g.data);
    return i.addRows(E);
  }
  static vegaLiteChartAddRowsHelper(i, g) {
    const E = g.hasName ? g.name : null, e = new Quiver(g.data);
    return produce(i, (t) => {
      const n = getNamedDataSet(t.datasets, E);
      n ? n.data = n.data.addRows(e) : t.data = t.data ? t.data.addRows(e) : e;
    });
  }
  /**
   * Accept a visitor.
   * @param visitor - The visitor to accept.
   * @returns The result of the visitor's visitElementNode method.
   * @example
   * const visitor = new DebugVisitor()
   * const result = elementNode.accept(visitor)
   * console.log(result)
   */
  accept(i) {
    return i.visitElementNode(this);
  }
  /**
   * Returns a string representation of this ElementNode for debugging purposes.
   * This method can be used to log or inspect the state of the node.
   *
   * @returns {string} A debug string describing this node.
   */
  debug() {
    return this.accept(new DebugVisitor());
  }
  replaceTransientNodeWithSelf(i) {
    if (i.scriptRunId !== this.scriptRunId)
      return this;
    if (i.transientNodes.length === 0)
      return this;
    const g = i.updateTransientNodes((E) => (
      // All transient nodes should be ElementNodes
      E.accept(new ClearStaleNodeVisitor(this.scriptRunId))
    ));
    return g.length === 0 ? this : new TransientNode(this.scriptRunId, this, g, i.deltaMsgReceivedAt);
  }
}
function getNamedDataSet(o, i) {
  return o.length === 1 ? o[0] : o.find((g) => g.hasName && g.name === i);
}
function wrapDatasets(o) {
  return o.map((i) => ({
    hasName: i.hasName,
    name: i.name,
    data: new Quiver(i.data)
  }));
}
class ClearTransientNodesVisitor {
  constructor(i) {
    this.fragmentIdsThisRun = i ?? [];
  }
  visitBlockNode(i) {
    if (
      // There are fragment IDs this run, and this block is not one of them
      this.fragmentIdsThisRun.length > 0 && i.fragmentId && !this.fragmentIdsThisRun.includes(i.fragmentId)
    )
      return i;
    const g = [];
    let E = !1;
    return i.children.forEach((e) => {
      const t = e.accept(this);
      t !== e && (E = !0), t !== void 0 && g.push(t);
    }), E ? new BlockNode(i.activeScriptHash, g, i.deltaBlock, i.scriptRunId, i.fragmentId, i.deltaMsgReceivedAt) : i;
  }
  visitElementNode(i) {
    return i;
  }
  visitTransientNode(i) {
    return i.anchor;
  }
}
class ElementsSetVisitor {
  constructor() {
    this.elements = /* @__PURE__ */ new Set();
  }
  visitElementNode(i) {
    return this.elements.add(i.element), this.elements;
  }
  visitBlockNode(i) {
    for (const g of i.children)
      g.accept(this);
    return this.elements;
  }
  visitTransientNode(i) {
    return i.transientNodes.forEach((g) => {
      g.accept(this);
    }), i.anchor?.accept(this), this.elements;
  }
  /**
   * Static convenience method to collect all elements from a node tree.
   */
  static collectElements(i) {
    const g = new ElementsSetVisitor();
    return i.accept(g), g.elements;
  }
}
class FilterMainScriptElementsVisitor {
  constructor(i) {
    this.mainScriptHash = i;
  }
  visitElementNode(i) {
    if (i.activeScriptHash === this.mainScriptHash)
      return i;
  }
  visitBlockNode(i) {
    if (i.activeScriptHash !== this.mainScriptHash)
      return;
    let g = !1;
    const E = [];
    for (const e of i.children) {
      const t = e.accept(this);
      t !== e && (g = !0), t !== void 0 && E.push(t);
    }
    return g ? new BlockNode(i.activeScriptHash, E, i.deltaBlock, i.scriptRunId, i.fragmentId, i.deltaMsgReceivedAt) : i;
  }
  visitTransientNode(i) {
    const g = i.anchor?.accept(this), E = i.updateTransientNodes((e) => e.accept(this));
    if (!(!g && E.length === 0))
      return E.length === 0 ? g : new TransientNode(i.scriptRunId, g, E, i.deltaMsgReceivedAt);
  }
  /**
   * Static convenience method to filter a node tree based on mainScriptHash.
   */
  static filterNode(i, g) {
    const E = new FilterMainScriptElementsVisitor(g);
    return i.accept(E);
  }
}
class GetNodeByDeltaPathVisitor {
  constructor(i) {
    this.deltaPath = i;
  }
  visitElementNode(i) {
  }
  visitBlockNode(i) {
    if (this.deltaPath.length === 0)
      return;
    const [g, ...E] = this.deltaPath;
    if (g < 0 || g >= i.children.length)
      return;
    if (E.length === 0)
      return i.children[g];
    const e = new GetNodeByDeltaPathVisitor(E);
    return i.children[g].accept(e);
  }
  visitTransientNode(i) {
    return this.deltaPath.length === 0 ? i.anchor : i.anchor?.accept(this);
  }
  /**
   * Static convenience method to get a node at a delta path.
   */
  static getNodeAtPath(i, g) {
    const E = new GetNodeByDeltaPathVisitor(g);
    return i.accept(E);
  }
}
class SetNodeByDeltaPathVisitor {
  constructor(i, g, E) {
    this.deltaPath = i, this.nodeToSet = g, this.scriptRunId = E;
  }
  visitElementNode(i) {
    if (this.deltaPath.length > 0)
      throw new Error("'setIn' cannot be called on an ElementNode");
    return this.nodeToSet instanceof TransientNode && !this.nodeToSet.anchor ? new TransientNode(this.nodeToSet.scriptRunId, i, this.nodeToSet.transientNodes, this.nodeToSet.deltaMsgReceivedAt) : this.nodeToSet;
  }
  visitTransientNode(i) {
    if (this.deltaPath.length === 0)
      return this.nodeToSet.replaceTransientNodeWithSelf(i);
    if (i.anchor) {
      const g = i.anchor.accept(this);
      return new TransientNode(i.scriptRunId, g, i.transientNodes, i.deltaMsgReceivedAt);
    }
    throw new Error("TransientNode has no anchor to set node at");
  }
  visitBlockNode(i) {
    if (this.deltaPath.length === 0)
      return this.nodeToSet instanceof TransientNode && !this.nodeToSet.anchor ? new TransientNode(this.nodeToSet.scriptRunId, i, this.nodeToSet.transientNodes, this.nodeToSet.deltaMsgReceivedAt) : this.nodeToSet;
    const [g, ...E] = this.deltaPath;
    if (g < 0 || g > i.children.length)
      throw new Error(`Bad delta path index ${g} (should be between [0, ${i.children.length}])`);
    let e = [];
    const t = new SetNodeByDeltaPathVisitor(E, this.nodeToSet, this.scriptRunId);
    if (i.children[g]) {
      let n = 0;
      for (; n < i.children.length; ) {
        const h = i.children[n];
        if (n !== g) {
          e.push(h), n++;
          continue;
        }
        const d = h.accept(t);
        !(h instanceof TransientNode) && d instanceof TransientNode && d.anchor !== h ? (e.push(d), e.push(h)) : e.push(d), n++;
      }
    } else {
      if (E.length > 0)
        throw new Error("Cannot set a node at a delta path");
      e = i.children.slice(), e[g] = this.nodeToSet;
    }
    return new BlockNode(i.activeScriptHash, e, i.deltaBlock, this.scriptRunId, i.fragmentId, i.deltaMsgReceivedAt);
  }
  /**
   * Static convenience method to set a node at a delta path.
   */
  static setNodeAtPath(i, g, E, e) {
    const t = new SetNodeByDeltaPathVisitor(g, E, e);
    return i.accept(t);
  }
}
class AppRoot {
  /**
   * Create an empty AppRoot with a placeholder "skeleton" element.
   * @param mainScriptHash - The hash of the main script that creates this AppRoot.
   * @param isInitialRender - Whether this is the initial render.
   * @param sidebarElements - The elements to add to the sidebar (this was a relic
   * of MPA V1 to maintain the sidebar from flickering, we don't use it anymore).
   * @param logo - The logo to add to the app.
   * @returns A new AppRoot with the given parameters.
   */
  static empty(i = "", g = !0, E, e) {
    const t = [];
    let n;
    switch (getLoadingScreenType()) {
      case LoadingScreenType.NONE:
        break;
      case LoadingScreenType.V1:
        g && (n = makeElementWithInfoText("Please wait..."));
        break;
      default:
        n = makeAppSkeletonElement();
        break;
    }
    n && t.push(new ElementNode(n, ForwardMsgMetadata.create({}), NO_SCRIPT_RUN_ID, i));
    const h = new BlockNode(i, t, new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), d = E || new BlockNode(i, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), k = new BlockNode(i, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), p = new BlockNode(i, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), M = e ? {
      logo: e,
      activeScriptHash: i,
      scriptRunId: NO_SCRIPT_RUN_ID
    } : null;
    return new AppRoot(i, new BlockNode(i, [h, d, k, p]), M);
  }
  constructor(i, g, E = null) {
    if (this.mainScriptHash = i, this.root = g, this.appLogo = E, this.root.children.length !== 4 || isNullOrUndefined(this.main) || isNullOrUndefined(this.sidebar) || isNullOrUndefined(this.event) || isNullOrUndefined(this.bottom))
      throw new Error(`Invalid root node children! ${g}`);
  }
  get main() {
    const [i] = this.root.children;
    return i;
  }
  get sidebar() {
    const [, i] = this.root.children;
    return i;
  }
  get event() {
    const [, , i] = this.root.children;
    return i;
  }
  get bottom() {
    const [, , , i] = this.root.children;
    return i;
  }
  get logo() {
    return this.appLogo?.logo ?? null;
  }
  appRootWithLogo(i, g) {
    return new AppRoot(this.mainScriptHash, this.root, {
      logo: i,
      ...g
    });
  }
  applyDelta(i, g, E) {
    const {
      deltaPath: e,
      activeScriptHash: t
    } = E;
    switch (g.type) {
      case "newElement": {
        const n = g.newElement;
        return this.addElement(e, i, n, E, t, g.fragmentId);
      }
      case "addBlock": {
        const n = Date.now();
        return this.addBlock(e, g.addBlock, i, t, g.fragmentId, n);
      }
      case "newTransient": {
        const n = g.newTransient;
        return this.addTransient(e, i, n, E, t, g.fragmentId);
      }
      case "arrowAddRows":
        try {
          return this.arrowAddRows(e, g.arrowAddRows, i);
        } catch (n) {
          const h = makeElementWithErrorText(ensureError(n).message);
          return this.addElement(e, i, h, E, t);
        }
      default:
        throw new Error(`Unrecognized deltaType: '${g.type}'`);
    }
  }
  ensureBlockNode(i, g = this.mainScriptHash) {
    return i ?? new BlockNode(g);
  }
  /**
   * Clears all nodes that are not associated with the mainScriptHash.
   * @param mainScriptHash - The hash of the main script.
   * @returns A new AppRoot with the filtered nodes.
   */
  filterMainScriptElements(i) {
    const g = this.main.scriptRunId, E = new FilterMainScriptElementsVisitor(i), e = this.root.children.map((n) => this.ensureBlockNode(n.accept(E), i)), t = this.appLogo?.activeScriptHash === i ? this.appLogo : null;
    return new AppRoot(i, new BlockNode(i, e, new Block$1({
      allowEmpty: !0
    }), g), t);
  }
  clearStaleNodes(i, g) {
    const E = new ClearStaleNodeVisitor(i, g), e = this.root.children.map((h) => this.ensureBlockNode(h.accept(E))), n = g && g.length > 0 || this.appLogo?.scriptRunId === i ? this.appLogo : null;
    return new AppRoot(this.mainScriptHash, new BlockNode(this.mainScriptHash, e, new Block$1({
      allowEmpty: !0
    }), i), n);
  }
  clearTransientNodes(i) {
    const g = new ClearTransientNodesVisitor(i), E = this.root.children.map((e) => this.ensureBlockNode(e.accept(g)));
    return new AppRoot(this.mainScriptHash, new BlockNode(this.mainScriptHash, E, new Block$1({
      allowEmpty: !0
    }), this.main.scriptRunId), this.appLogo);
  }
  /** Return a Set containing all Elements in the tree. */
  getElements() {
    const i = new ElementsSetVisitor();
    return this.main.accept(i), this.sidebar.accept(i), this.event.accept(i), this.bottom.accept(i), i.elements;
  }
  addElement(i, g, E, e, t, n) {
    const h = new ElementNode(E, e, g, t, n);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, i, h, g), this.appLogo);
  }
  addBlock(i, g, E, e, t, n) {
    const h = GetNodeByDeltaPathVisitor.getNodeAtPath(this.root, i);
    let d = [];
    h instanceof BlockNode && h.deltaBlock.type === g.type && (g.dialog && h.deltaBlock.dialog && g.id !== h.deltaBlock.id || (d = h.children));
    const k = new BlockNode(e, d, g, E, t, n);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, i, k, E), this.appLogo);
  }
  addTransient(i, g, E, e, t, n, h) {
    const d = new TransientNode(
      g,
      void 0,
      // We do not have an anchor yet
      E.elements.map((k) => new ElementNode(k, e, g, t, n)),
      h
    );
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, i, d, g), this.appLogo);
  }
  arrowAddRows(i, g, E) {
    const e = GetNodeByDeltaPathVisitor.getNodeAtPath(this.root, i);
    if (isNullOrUndefined(e) || !(e instanceof ElementNode))
      throw new Error(`Can't arrowAddRows: invalid deltaPath: ${i}`);
    const t = e.arrowAddRows(g, E);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, i, t, E), this.appLogo);
  }
  getChildName(i) {
    switch (i) {
      case this.main:
        return "main";
      case this.sidebar:
        return "sidebar";
      case this.event:
        return "event";
      case this.bottom:
        return "bottom";
      default:
        return "unknown";
    }
  }
  /**
   * Returns a string representation of the AppRoot structure for debugging purposes.
   * This method traverses the AppRoot tree and outputs a formatted string
   * showing the hierarchy of its child nodes.
   *
   * @returns {string} A formatted string representing the AppRoot structure.
   */
  debug() {
    let i = `AppRoot
`;
    return this.root.children.forEach((g, E) => {
      const e = E === this.root.children.length - 1, t = this.getChildName(g), n = e ? "└── " : "├── ", h = e ? "    " : "│   ";
      i += `${n}${t}:
`;
      const d = new DebugVisitor(h, !0);
      i += g.accept(d);
    }), i;
  }
}
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, (function(o) {
    (function() {
      var i = {}.hasOwnProperty;
      function g() {
        for (var t = "", n = 0; n < arguments.length; n++) {
          var h = arguments[n];
          h && (t = e(t, E(h)));
        }
        return t;
      }
      function E(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return g.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var n = "";
        for (var h in t)
          i.call(t, h) && t[h] && (n = e(n, h));
        return n;
      }
      function e(t, n) {
        return n ? t ? t + " " + n : t + n : t;
      }
      o.exports ? (g.default = g, o.exports = g) : window.classNames = g;
    })();
  })(classnames)), classnames.exports;
}
var classnamesExports = requireClassnames();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var Direction = /* @__PURE__ */ ((o) => (o.HORIZONTAL = "row", o.VERTICAL = "column", o))(Direction || {});
function getDirectionOfBlock(o) {
  return o.flexContainer ? o.flexContainer.direction == Block$1.FlexContainer.Direction.HORIZONTAL ? "row" : "column" : o.vertical ? "column" : o.horizontal ? "row" : "column";
}
function shouldWidthStretch(o) {
  return !!(o?.useStretch || o?.pixelWidth);
}
function shouldHeightStretch(o) {
  return !!(o?.useStretch || o?.pixelHeight);
}
const alignmentMap = {
  [streamlit.TextAlignmentConfig.Alignment.LEFT]: "left",
  [streamlit.TextAlignmentConfig.Alignment.CENTER]: "center",
  [streamlit.TextAlignmentConfig.Alignment.RIGHT]: "right",
  [streamlit.TextAlignmentConfig.Alignment.JUSTIFY]: "justify",
  [streamlit.TextAlignmentConfig.Alignment.UNSPECIFIED]: "left"
};
function getTextAlignmentStyle(o) {
  if (o?.alignment)
    return alignmentMap[o.alignment] || "left";
}
const FlexContext = createContext(null);
FlexContext.displayName = "FlexContext";
const FlexContextProvider = ({
  children: o,
  direction: i,
  isRoot: g,
  parentWidth: E,
  hasContentWidth: e = !1,
  hasFixedWidth: t = !1,
  parentContext: n = null
}) => {
  const h = useMemo$1(() => {
    const d = i === Direction.HORIZONTAL;
    let k;
    return e ? k = !0 : t ? k = !1 : k = n?.isInContentWidthContainer ?? !1, {
      direction: i,
      isInHorizontalLayout: d,
      isInRoot: g ?? !1,
      parentWidth: E,
      isInContentWidthContainer: k
    };
  }, [i, g, E, e, t, n]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContext.Provider, { value: h, children: o });
};
function guard(o, i, g) {
  return Math.min(Math.max(o, g), i);
}
class ColorError extends Error {
  constructor(i) {
    super(`Failed to parse color: "${i}"`);
  }
}
var ColorError$1 = ColorError;
function parseToRgba(o) {
  if (typeof o != "string") throw new ColorError$1(o);
  if (o.trim().toLowerCase() === "transparent") return [0, 0, 0, 0];
  let i = o.trim();
  i = namedColorRegex.test(o) ? nameToHex(o) : o;
  const g = reducedHexRegex.exec(i);
  if (g) {
    const n = Array.from(g).slice(1);
    return [...n.slice(0, 3).map((h) => parseInt(r$2(h, 2), 16)), parseInt(r$2(n[3] || "f", 2), 16) / 255];
  }
  const E = hexRegex.exec(i);
  if (E) {
    const n = Array.from(E).slice(1);
    return [...n.slice(0, 3).map((h) => parseInt(h, 16)), parseInt(n[3] || "ff", 16) / 255];
  }
  const e = rgbaRegex.exec(i);
  if (e) {
    const n = Array.from(e).slice(1);
    return [...n.slice(0, 3).map((h) => parseInt(h, 10)), parseFloat(n[3] || "1")];
  }
  const t = hslaRegex.exec(i);
  if (t) {
    const [n, h, d, k] = Array.from(t).slice(1).map(parseFloat);
    if (guard(0, 100, h) !== h) throw new ColorError$1(o);
    if (guard(0, 100, d) !== d) throw new ColorError$1(o);
    return [...hslToRgb(n, h, d), Number.isNaN(k) ? 1 : k];
  }
  throw new ColorError$1(o);
}
function hash(o) {
  let i = 5381, g = o.length;
  for (; g; )
    i = i * 33 ^ o.charCodeAt(--g);
  return (i >>> 0) % 2341;
}
const colorToInt = (o) => parseInt(o.replace(/_/g, ""), 36), compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((o, i) => {
  const g = colorToInt(i.substring(0, 3)), E = colorToInt(i.substring(3)).toString(16);
  let e = "";
  for (let t = 0; t < 6 - E.length; t++)
    e += "0";
  return o[g] = `${e}${E}`, o;
}, {});
function nameToHex(o) {
  const i = o.toLowerCase().trim(), g = compressedColorMap[hash(i)];
  if (!g) throw new ColorError$1(o);
  return `#${g}`;
}
const r$2 = (o, i) => Array.from(Array(i)).map(() => o).join(""), reducedHexRegex = new RegExp(`^#${r$2("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), hexRegex = new RegExp(`^#${r$2("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r$2(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, namedColorRegex = /^[a-z]+$/i, roundColor = (o) => Math.round(o * 255), hslToRgb = (o, i, g) => {
  let E = g / 100;
  if (i === 0)
    return [E, E, E].map(roundColor);
  const e = (o % 360 + 360) % 360 / 60, t = (1 - Math.abs(2 * E - 1)) * (i / 100), n = t * (1 - Math.abs(e % 2 - 1));
  let h = 0, d = 0, k = 0;
  e >= 0 && e < 1 ? (h = t, d = n) : e >= 1 && e < 2 ? (h = n, d = t) : e >= 2 && e < 3 ? (d = t, k = n) : e >= 3 && e < 4 ? (d = n, k = t) : e >= 4 && e < 5 ? (h = n, k = t) : e >= 5 && e < 6 && (h = t, k = n);
  const p = E - t / 2, M = h + p, H = d + p, f = k + p;
  return [M, H, f].map(roundColor);
};
function parseToHsla(o) {
  const [i, g, E, e] = parseToRgba(o).map((M, H) => (
    // 3rd index is alpha channel which is already normalized
    H === 3 ? M : M / 255
  )), t = Math.max(i, g, E), n = Math.min(i, g, E), h = (t + n) / 2;
  if (t === n) return [0, 0, h, e];
  const d = t - n, k = h > 0.5 ? d / (2 - t - n) : d / (t + n);
  return [60 * (i === t ? (g - E) / d + (g < E ? 6 : 0) : g === t ? (E - i) / d + 2 : (i - g) / d + 4), k, h, e];
}
function hsla(o, i, g, E) {
  return `hsla(${(o % 360).toFixed()}, ${guard(0, 100, i * 100).toFixed()}%, ${guard(0, 100, g * 100).toFixed()}%, ${parseFloat(guard(0, 1, E).toFixed(3))})`;
}
function darken(o, i) {
  const [g, E, e, t] = parseToHsla(o);
  return hsla(g, E, e - i, t);
}
function getLuminance(o) {
  if (o === "transparent") return 0;
  function i(t) {
    const n = t / 255;
    return n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  }
  const [g, E, e] = parseToRgba(o);
  return 0.2126 * i(g) + 0.7152 * i(E) + 0.0722 * i(e);
}
function rgba$1(o, i, g, E) {
  return `rgba(${guard(0, 255, o).toFixed()}, ${guard(0, 255, i).toFixed()}, ${guard(0, 255, g).toFixed()}, ${parseFloat(guard(0, 1, E).toFixed(3))})`;
}
function mix$1(o, i, g) {
  const E = (EA, oA) => (
    // 3rd index is alpha channel which is already normalized
    oA === 3 ? EA : EA / 255
  ), [e, t, n, h] = parseToRgba(o).map(E), [d, k, p, M] = parseToRgba(i).map(E), H = M - h, f = g * 2 - 1, gA = ((f * H === -1 ? f : f + H / (1 + f * H)) + 1) / 2, IA = 1 - gA, BA = (e * IA + d * gA) * 255, CA = (t * IA + k * gA) * 255, QA = (n * IA + p * gA) * 255, iA = M * g + h * (1 - g);
  return rgba$1(BA, CA, QA, iA);
}
function lighten(o, i) {
  return darken(o, -i);
}
function transparentize(o, i) {
  const [g, E, e, t] = parseToRgba(o);
  return rgba$1(g, E, e, t - i);
}
function toHex(o) {
  const [i, g, E, e] = parseToRgba(o);
  let t = (n) => {
    const h = guard(0, 255, n).toString(16);
    return h.length === 1 ? `0${h}` : h;
  };
  return `#${t(i)}${t(g)}${t(E)}${e < 1 ? t(Math.round(e * 255)) : ""}`;
}
var colors$3 = {
  white: "#FFFFFF",
  gray50: "#F6F6F6",
  gray100: "#EEEEEE",
  gray200: "#E2E2E2",
  gray300: "#CBCBCB",
  gray400: "#AFAFAF",
  gray500: "#6B6B6B",
  gray600: "#545454",
  gray700: "#333333",
  gray800: "#1F1F1F",
  gray900: "#141414",
  black: "#000000",
  platinum400: "#8EA3AD",
  red50: "#FFEFED",
  red100: "#FED7D2",
  red200: "#F1998E",
  red300: "#E85C4A",
  red400: "#E11900",
  red500: "#AB1300",
  red600: "#870F00",
  red700: "#5A0A00",
  orange200: "#FABDA5",
  orange300: "#FA9269",
  orange400: "#FF6937",
  orange500: "#C14F29",
  orange600: "#9A3F21",
  orange700: "#672A16",
  yellow50: "#FFFAF0",
  yellow100: "#FFF2D9",
  yellow200: "#FFE3AC",
  yellow300: "#FFCF70",
  yellow400: "#FFC043",
  yellow500: "#BC8B2C",
  yellow600: "#996F00",
  yellow700: "#674D1B",
  green50: "#E6F2ED",
  green100: "#ADDEC9",
  green200: "#66D19E",
  green300: "#06C167",
  green400: "#048848",
  green500: "#03703C",
  green600: "#03582F",
  green700: "#10462D",
  blue50: "#EFF3FE",
  blue100: "#D4E2FC",
  blue200: "#A0BFF8",
  blue300: "#5B91F5",
  blue400: "#276EF1",
  blue500: "#1E54B7",
  blue600: "#174291",
  blue700: "#102C60",
  cobalt400: "#0E1FC1",
  purple200: "#C1B4E2",
  purple300: "#957FCE",
  purple400: "#7356BF",
  purple500: "#574191",
  purple600: "#453473",
  purple700: "#2E224C",
  brown200: "#D2BBB0",
  brown300: "#B18977",
  brown400: "#99644C",
  brown500: "#744C3A",
  brown600: "#5C3C2E",
  brown700: "#3D281E"
}, lightColorTokens = {
  // Primary Palette
  primaryA: colors$3.black,
  primaryB: colors$3.white,
  primary: colors$3.black,
  primary50: colors$3.gray50,
  primary100: colors$3.gray100,
  primary200: colors$3.gray200,
  primary300: colors$3.gray300,
  primary400: colors$3.gray400,
  primary500: colors$3.gray500,
  primary600: colors$3.gray600,
  primary700: colors$3.gray700,
  // Accent Palette
  accent: colors$3.blue400,
  accent50: colors$3.blue50,
  accent100: colors$3.blue100,
  accent200: colors$3.blue200,
  accent300: colors$3.blue300,
  accent400: colors$3.blue400,
  accent500: colors$3.blue500,
  accent600: colors$3.blue600,
  accent700: colors$3.blue700,
  // Negative Palette
  negative: colors$3.red400,
  negative50: colors$3.red50,
  negative100: colors$3.red100,
  negative200: colors$3.red200,
  negative300: colors$3.red300,
  negative400: colors$3.red400,
  negative500: colors$3.red500,
  negative600: colors$3.red600,
  negative700: colors$3.red700,
  // Warning Palette
  warning: colors$3.yellow400,
  warning50: colors$3.yellow50,
  warning100: colors$3.yellow100,
  warning200: colors$3.yellow200,
  warning300: colors$3.yellow300,
  warning400: colors$3.yellow400,
  warning500: colors$3.yellow500,
  warning600: colors$3.yellow600,
  warning700: colors$3.yellow700,
  // Positive Palette
  positive: colors$3.green500,
  positive50: colors$3.green50,
  positive100: colors$3.green100,
  positive200: colors$3.green200,
  positive300: colors$3.green300,
  positive400: colors$3.green400,
  positive500: colors$3.green500,
  positive600: colors$3.green600,
  positive700: colors$3.green700,
  // Monochrome Palette
  white: colors$3.white,
  black: colors$3.black,
  mono100: colors$3.white,
  mono200: colors$3.gray50,
  mono300: colors$3.gray100,
  mono400: colors$3.gray200,
  mono500: colors$3.gray300,
  mono600: colors$3.gray400,
  mono700: colors$3.gray500,
  mono800: colors$3.gray600,
  mono900: colors$3.gray700,
  mono1000: colors$3.black,
  // Rating Palette,
  ratingInactiveFill: colors$3.gray100,
  ratingStroke: colors$3.gray300
};
function hexToRgb() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "1", g = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  o = o.replace(g, function(e, t, n, h) {
    return t + t + n + n + h + h;
  });
  var E = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(o);
  return E ? "rgba(".concat(parseInt(E[1], 16), ", ").concat(parseInt(E[2], 16), ", ").concat(parseInt(E[3], 16), ", ").concat(i, ")") : null;
}
var ellipsisText = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  wordWrap: "normal"
};
function expandBorderStyles(o) {
  return {
    borderTopWidth: o.borderWidth,
    borderTopStyle: o.borderStyle,
    borderTopColor: o.borderColor,
    borderBottomWidth: o.borderWidth,
    borderBottomStyle: o.borderStyle,
    borderBottomColor: o.borderColor,
    borderLeftWidth: o.borderWidth,
    borderLeftStyle: o.borderStyle,
    borderLeftColor: o.borderColor,
    borderRightWidth: o.borderWidth,
    borderRightStyle: o.borderStyle,
    borderRightColor: o.borderColor
  };
}
function ownKeys$y(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$w(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$y(Object(g), !0).forEach(function(E) {
      _defineProperty$F(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$y(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$F(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
const getSemanticColorTokens = (function() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lightColorTokens, i = {
    // Background
    backgroundPrimary: o.primaryB,
    backgroundSecondary: colors$3.gray50,
    backgroundTertiary: colors$3.gray100,
    backgroundInversePrimary: o.primaryA,
    backgroundInverseSecondary: colors$3.gray800,
    // Content
    contentPrimary: o.primaryA,
    contentSecondary: colors$3.gray600,
    contentTertiary: colors$3.gray500,
    contentInversePrimary: o.primaryB,
    contentInverseSecondary: colors$3.gray300,
    contentInverseTertiary: colors$3.gray400,
    // Border
    borderOpaque: colors$3.gray200,
    borderTransparent: hexToRgb(o.primaryA, "0.08"),
    borderSelected: o.primaryA,
    borderInverseOpaque: colors$3.gray700,
    borderInverseTransparent: hexToRgb(o.primaryB, "0.2"),
    borderInverseSelected: o.primaryB
  }, g = {
    // Backgrounds
    backgroundStateDisabled: colors$3.gray50,
    backgroundOverlayDark: hexToRgb(colors$3.black, "0.3"),
    backgroundOverlayLight: hexToRgb(colors$3.black, "0.08"),
    backgroundOverlayArt: hexToRgb(colors$3.black, "0.00"),
    backgroundAccent: o.accent,
    backgroundNegative: o.negative,
    backgroundWarning: o.warning,
    backgroundPositive: colors$3.green400,
    backgroundLightAccent: colors$3.blue50,
    backgroundLightNegative: colors$3.red50,
    backgroundLightWarning: colors$3.yellow50,
    backgroundLightPositive: colors$3.green50,
    backgroundAlwaysDark: colors$3.black,
    backgroundAlwaysLight: colors$3.white,
    // Content
    contentStateDisabled: colors$3.gray400,
    contentAccent: o.accent,
    contentOnColor: colors$3.white,
    contentOnColorInverse: colors$3.black,
    contentNegative: o.negative,
    contentWarning: colors$3.yellow600,
    contentPositive: colors$3.green400,
    // Border
    borderStateDisabled: colors$3.gray50,
    borderAccent: colors$3.blue400,
    borderAccentLight: colors$3.blue200,
    borderNegative: colors$3.red200,
    borderWarning: colors$3.yellow200,
    borderPositive: colors$3.green200,
    // Programs
    safety: colors$3.blue400,
    eatsGreen400: colors$3.green400,
    freightBlue400: colors$3.cobalt400,
    jumpRed400: colors$3.red400,
    rewardsTier1: colors$3.blue400,
    rewardsTier2: colors$3.yellow400,
    rewardsTier3: colors$3.platinum400,
    rewardsTier4: colors$3.black,
    membership: colors$3.yellow600
  };
  return _objectSpread$w(_objectSpread$w({}, i), g);
});
var tagHoverBackground = "rgba(0, 0, 0, 0.08)";
const getComponentColorTokens = (function() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lightColorTokens;
  return {
    bannerActionLowInfo: o.accent100,
    bannerActionLowNegative: o.negative100,
    bannerActionLowPositive: o.positive100,
    bannerActionLowWarning: o.warning200,
    bannerActionHighInfo: o.accent500,
    bannerActionHighNegative: o.negative500,
    bannerActionHighPositive: o.positive500,
    bannerActionHighWarning: o.warning200,
    // Buttons
    buttonPrimaryFill: o.primary,
    buttonPrimaryText: o.white,
    buttonPrimaryHover: o.primary700,
    buttonPrimaryActive: o.primary600,
    buttonPrimarySelectedFill: o.primary600,
    buttonPrimarySelectedText: o.white,
    buttonPrimarySpinnerForeground: o.accent,
    buttonPrimarySpinnerBackground: o.primaryB,
    buttonSecondaryFill: o.primary100,
    buttonSecondaryText: o.primary,
    buttonSecondaryHover: o.primary200,
    buttonSecondaryActive: o.primary300,
    buttonSecondarySelectedFill: o.primary300,
    buttonSecondarySelectedText: o.primary,
    buttonSecondarySpinnerForeground: o.accent,
    buttonSecondarySpinnerBackground: o.primaryB,
    buttonTertiaryFill: "transparent",
    buttonTertiaryText: o.primary,
    buttonTertiaryHover: o.primary50,
    buttonTertiaryActive: o.primary100,
    buttonTertiarySelectedFill: o.primary100,
    buttonTertiarySelectedText: o.primary,
    buttonTertiaryDisabledActiveFill: o.primary50,
    buttonTertiaryDisabledActiveText: o.mono600,
    buttonTertiarySpinnerForeground: o.accent,
    buttonTertiarySpinnerBackground: o.primary100,
    buttonDisabledFill: o.mono200,
    buttonDisabledText: o.mono600,
    buttonDisabledActiveFill: o.mono700,
    buttonDisabledActiveText: o.mono100,
    buttonDisabledSpinnerForeground: o.mono600,
    buttonDisabledSpinnerBackground: o.mono400,
    // Breadcrumbs
    breadcrumbsText: o.black,
    breadcrumbsSeparatorFill: o.mono700,
    // Datepicker
    calendarBackground: o.mono100,
    calendarForeground: o.mono1000,
    calendarForegroundDisabled: o.mono500,
    calendarHeaderBackground: o.white,
    calendarHeaderForeground: o.primary,
    calendarHeaderBackgroundActive: o.primary700,
    calendarHeaderForegroundDisabled: o.primary500,
    calendarDayForegroundPseudoSelected: o.mono1000,
    calendarDayBackgroundPseudoSelectedHighlighted: o.primary200,
    calendarDayForegroundPseudoSelectedHighlighted: o.mono1000,
    calendarDayBackgroundSelected: o.primary,
    calendarDayForegroundSelected: o.white,
    calendarDayBackgroundSelectedHighlighted: o.primary,
    calendarDayForegroundSelectedHighlighted: o.white,
    // Combobox
    comboboxListItemFocus: o.mono200,
    comboboxListItemHover: o.mono300,
    // FileUploader
    fileUploaderBackgroundColor: o.mono200,
    fileUploaderBackgroundColorActive: o.primary50,
    fileUploaderBorderColorActive: o.primary,
    fileUploaderBorderColorDefault: o.mono500,
    fileUploaderMessageColor: o.mono800,
    // Links
    linkText: o.primary,
    linkVisited: o.primary700,
    linkHover: o.primary600,
    linkActive: o.primary500,
    // List
    listHeaderFill: o.white,
    listBodyFill: o.white,
    // ProgressSteps
    progressStepsCompletedText: o.white,
    progressStepsCompletedFill: o.primary,
    progressStepsActiveText: o.white,
    progressStepsActiveFill: o.primary,
    // Toggle
    toggleFill: o.white,
    toggleFillChecked: o.primary,
    toggleFillDisabled: o.mono600,
    toggleTrackFill: o.mono400,
    toggleTrackFillDisabled: o.mono300,
    // Tick
    tickFill: o.mono100,
    tickFillHover: o.mono200,
    tickFillActive: o.mono300,
    tickFillSelected: o.primary,
    tickFillSelectedHover: o.primary700,
    tickFillSelectedHoverActive: o.primary600,
    tickFillError: o.negative50,
    tickFillErrorHover: o.negative100,
    tickFillErrorHoverActive: o.negative200,
    tickFillErrorSelected: o.negative400,
    tickFillErrorSelectedHover: o.negative500,
    tickFillErrorSelectedHoverActive: o.negative600,
    tickFillDisabled: o.mono600,
    tickBorder: o.mono700,
    tickBorderError: o.negative400,
    tickMarkFill: o.white,
    tickMarkFillError: o.white,
    tickMarkFillDisabled: o.mono100,
    // Slider/Toggle
    sliderTrackFill: "transparent",
    sliderHandleFill: o.primaryA,
    sliderHandleFillDisabled: o.primary400,
    sliderHandleInnerFill: o.primaryA,
    sliderTrackFillHover: o.mono500,
    sliderTrackFillActive: o.mono600,
    sliderTrackFillDisabled: o.mono300,
    sliderHandleInnerFillDisabled: o.mono400,
    sliderHandleInnerFillSelectedHover: o.primary,
    sliderHandleInnerFillSelectedActive: o.primary500,
    // Inputs
    inputBorder: o.mono300,
    inputFill: o.mono300,
    inputFillError: o.negative50,
    inputFillDisabled: o.mono200,
    inputFillActive: o.mono200,
    inputFillPositive: o.positive50,
    inputTextDisabled: o.mono600,
    inputBorderError: o.negative200,
    inputBorderPositive: o.positive200,
    inputEnhancerFill: o.mono300,
    inputEnhancerFillDisabled: o.mono300,
    inputEnhancerTextDisabled: o.mono600,
    inputPlaceholder: o.mono700,
    inputPlaceholderDisabled: o.mono600,
    // Menu
    menuFill: o.mono100,
    menuFillHover: o.mono200,
    menuFontDefault: o.mono800,
    menuFontDisabled: o.mono500,
    menuFontHighlighted: o.mono1000,
    menuFontSelected: o.mono1000,
    // Modal
    modalCloseColor: o.mono1000,
    modalCloseColorHover: o.mono800,
    modalCloseColorFocus: o.mono800,
    // Tab
    tabBarFill: o.mono200,
    tabColor: o.mono800,
    // Notification
    notificationInfoBackground: o.accent50,
    notificationInfoText: o.primaryA,
    notificationPositiveBackground: o.positive50,
    notificationPositiveText: o.primaryA,
    notificationWarningBackground: o.warning50,
    notificationWarningText: o.primaryA,
    notificationNegativeBackground: o.negative50,
    notificationNegativeText: o.primaryA,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: "100",
    tagSolidFontRampUnit: "0",
    tagSolidRampUnit: "400",
    tagOutlinedFontRampUnit: "400",
    tagOutlinedRampUnit: "200",
    // Deprecated
    tagSolidHoverRampUnit: "50",
    tagSolidActiveRampUnit: "100",
    tagSolidDisabledRampUnit: "50",
    tagSolidFontHoverRampUnit: "500",
    tagLightRampUnit: "50",
    tagLightHoverRampUnit: "100",
    tagLightActiveRampUnit: "100",
    tagLightFontRampUnit: "500",
    tagLightFontHoverRampUnit: "500",
    tagOutlinedHoverRampUnit: "50",
    tagOutlinedActiveRampUnit: "0",
    tagOutlinedFontHoverRampUnit: "400",
    // Neutral
    tagNeutralFontDisabled: o.mono600,
    tagNeutralOutlinedDisabled: o.mono400,
    tagNeutralSolidFont: o.white,
    tagNeutralSolidBackground: o.black,
    tagNeutralOutlinedBackground: o.mono600,
    tagNeutralOutlinedFont: o.black,
    // Deprecated
    tagNeutralSolidHover: o.mono300,
    tagNeutralSolidActive: o.mono400,
    tagNeutralSolidDisabled: o.mono200,
    tagNeutralSolidFontHover: o.mono900,
    tagNeutralLightBackground: o.mono300,
    tagNeutralLightHover: o.mono300,
    tagNeutralLightActive: o.mono400,
    tagNeutralLightDisabled: o.mono200,
    tagNeutralLightFont: o.mono900,
    tagNeutralLightFontHover: o.mono900,
    tagNeutralOutlinedActive: o.mono900,
    tagNeutralOutlinedFontHover: o.mono800,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryFontDisabled: o.primary400,
    tagPrimaryOutlinedDisabled: o.primary200,
    tagPrimarySolidFont: o.white,
    tagPrimarySolidBackground: o.primary,
    tagPrimaryOutlinedFontHover: o.primary,
    tagPrimaryOutlinedFont: o.primary,
    // Deprecated
    tagPrimarySolidHover: o.primary100,
    tagPrimarySolidActive: o.primary200,
    tagPrimarySolidDisabled: o.primary50,
    tagPrimarySolidFontHover: o.primary700,
    tagPrimaryLightBackground: o.primary50,
    tagPrimaryLightHover: o.primary100,
    tagPrimaryLightActive: o.primary100,
    tagPrimaryLightDisabled: o.primary50,
    tagPrimaryLightFont: o.primary500,
    tagPrimaryLightFontHover: o.primary500,
    tagPrimaryOutlinedActive: o.primary600,
    tagPrimaryOutlinedHover: tagHoverBackground,
    tagPrimaryOutlinedBackground: o.primary400,
    // Accent
    tagAccentFontDisabled: o.accent200,
    tagAccentOutlinedDisabled: o.accent200,
    tagAccentSolidFont: o.white,
    tagAccentSolidBackground: o.accent400,
    tagAccentOutlinedBackground: o.accent200,
    tagAccentOutlinedFont: o.accent400,
    // Deprecated
    tagAccentSolidHover: o.accent50,
    tagAccentSolidActive: o.accent100,
    tagAccentSolidDisabled: o.accent50,
    tagAccentSolidFontHover: o.accent500,
    tagAccentLightBackground: o.accent50,
    tagAccentLightHover: o.accent100,
    tagAccentLightActive: o.accent100,
    tagAccentLightDisabled: o.accent50,
    tagAccentLightFont: o.accent500,
    tagAccentLightFontHover: o.accent500,
    tagAccentOutlinedActive: o.accent600,
    tagAccentOutlinedFontHover: o.accent400,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveFontDisabled: o.positive200,
    tagPositiveOutlinedDisabled: o.positive200,
    tagPositiveSolidFont: o.white,
    tagPositiveSolidBackground: o.positive400,
    tagPositiveOutlinedBackground: o.positive200,
    tagPositiveOutlinedFont: o.positive400,
    // Deprecated
    tagPositiveSolidHover: o.positive50,
    tagPositiveSolidActive: o.positive100,
    tagPositiveSolidDisabled: o.positive50,
    tagPositiveSolidFontHover: o.positive500,
    tagPositiveLightBackground: o.positive50,
    tagPositiveLightHover: o.positive100,
    tagPositiveLightActive: o.positive100,
    tagPositiveLightDisabled: o.positive50,
    tagPositiveLightFont: o.positive500,
    tagPositiveLightFontHover: o.positive500,
    tagPositiveOutlinedActive: o.positive600,
    tagPositiveOutlinedFontHover: o.positive400,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningFontDisabled: o.warning300,
    tagWarningOutlinedDisabled: o.warning300,
    tagWarningSolidFont: o.warning700,
    tagWarningSolidBackground: o.warning400,
    tagWarningOutlinedBackground: o.warning300,
    tagWarningOutlinedFont: o.warning600,
    // Deprecated
    tagWarningSolidHover: o.warning50,
    tagWarningSolidActive: o.warning100,
    tagWarningSolidDisabled: o.warning50,
    tagWarningSolidFontHover: o.warning500,
    tagWarningLightBackground: o.warning50,
    tagWarningLightHover: o.warning100,
    tagWarningLightActive: o.warning100,
    tagWarningLightDisabled: o.warning50,
    tagWarningLightFont: o.warning500,
    tagWarningLightFontHover: o.warning500,
    tagWarningOutlinedActive: o.warning600,
    tagWarningOutlinedFontHover: o.warning600,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeFontDisabled: o.negative200,
    tagNegativeOutlinedDisabled: o.negative200,
    tagNegativeSolidFont: o.white,
    tagNegativeSolidBackground: o.negative400,
    tagNegativeOutlinedBackground: o.negative200,
    tagNegativeOutlinedFont: o.negative400,
    // Deprecated
    tagNegativeSolidHover: o.negative50,
    tagNegativeSolidActive: o.negative100,
    tagNegativeSolidDisabled: o.negative50,
    tagNegativeSolidFontHover: o.negative500,
    tagNegativeLightBackground: o.negative50,
    tagNegativeLightHover: o.negative100,
    tagNegativeLightActive: o.negative100,
    tagNegativeLightDisabled: o.negative50,
    tagNegativeLightFont: o.negative500,
    tagNegativeLightFontHover: o.negative500,
    tagNegativeOutlinedActive: o.negative600,
    tagNegativeOutlinedFontHover: o.negative400,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: o.mono100,
    tableBackground: o.mono100,
    tableStripedBackground: o.mono200,
    tableFilter: o.mono600,
    tableFilterHeading: o.mono700,
    tableFilterBackground: o.mono100,
    tableFilterFooterBackground: o.mono200,
    // Toast
    toastText: o.white,
    toastPrimaryText: o.white,
    toastInfoBackground: o.accent400,
    toastInfoText: o.white,
    toastPositiveBackground: o.positive400,
    toastPositiveText: o.white,
    toastWarningBackground: o.warning400,
    toastWarningText: o.black,
    toastNegativeBackground: o.negative400,
    toastNegativeText: o.white,
    // Spinner
    spinnerTrackFill: o.mono900,
    // Progress bar
    progressbarTrackFill: o.mono900,
    // Tooltip
    tooltipBackground: o.mono900,
    tooltipText: o.mono100
  };
});
var borders = {
  border100: {
    borderColor: "hsla(0, 0%, 0%, 0.04)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border200: {
    borderColor: "hsla(0, 0%, 0%, 0.08)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border300: {
    borderColor: "hsla(0, 0%, 0%, 0.12)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border400: {
    borderColor: "hsla(0, 0%, 0%, 0.16)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border500: {
    borderColor: "hsla(0, 0%, 0%, 0.2)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border600: {
    borderColor: "hsla(0, 0%, 0%, 0.24)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  radius100: "2px",
  radius200: "4px",
  radius300: "8px",
  radius400: "12px",
  radius500: "16px",
  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: !0,
  /** Button, ButtonGroup */
  buttonBorderRadiusMini: "4px",
  buttonBorderRadius: "8px",
  /** Checkbox */
  checkboxBorderRadius: "0px",
  /** Input, Select, Textarea */
  inputBorderRadiusMini: "4px",
  inputBorderRadius: "8px",
  /** Popover, Menu, Tooltip */
  popoverBorderRadius: "8px",
  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: "0px",
  /** Tag */
  tagBorderRadius: "24px"
}, lighting = {
  shadow400: "0 1px 4px hsla(0, 0%, 0%, 0.16)",
  shadow500: "0 2px 8px hsla(0, 0%, 0%, 0.16)",
  shadow600: "0 4px 16px hsla(0, 0%, 0%, 0.16)",
  shadow700: "0 8px 24px hsla(0, 0%, 0%, 0.16)",
  overlay0: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0)",
  overlay100: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.04)",
  overlay200: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.08)",
  overlay300: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.12)",
  overlay400: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.16)",
  overlay500: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.2)",
  overlay600: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.24)",
  shallowAbove: "0px -4px 16px rgba(0, 0, 0, 0.12)",
  shallowBelow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
  deepAbove: "0px -16px 48px rgba(0, 0, 0, 0.22)",
  deepBelow: "0px 16px 48px rgba(0, 0, 0, 0.22)"
};
function ownKeys$x(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$v(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$x(Object(g), !0).forEach(function(E) {
      _defineProperty$E(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$x(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$E(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var defaultFontTokens = {
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
}, monoFontFamily = '"Lucida Console", Monaco, monospace';
const getTypography = (function() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultFontTokens, i = {
    fontFamily: o.primaryFontFamily,
    fontSize: "12px",
    fontWeight: "normal",
    lineHeight: "20px"
  }, g = {
    fontFamily: o.primaryFontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px"
  }, E = {
    fontFamily: o.primaryFontFamily,
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: "20px"
  }, e = {
    fontFamily: o.primaryFontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "16px"
  }, t = {
    fontFamily: o.primaryFontFamily,
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "24px"
  }, n = {
    fontFamily: o.primaryFontFamily,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "20px"
  }, h = {
    fontFamily: o.primaryFontFamily,
    fontSize: "18px",
    fontWeight: "normal",
    lineHeight: "28px"
  }, d = {
    fontFamily: o.primaryFontFamily,
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "24px"
  }, k = {
    fontFamily: o.primaryFontFamily,
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "28px"
  }, p = {
    fontFamily: o.primaryFontFamily,
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px"
  }, M = {
    fontFamily: o.primaryFontFamily,
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: "36px"
  }, H = {
    fontFamily: o.primaryFontFamily,
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "40px"
  }, f = {
    fontFamily: o.primaryFontFamily,
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "44px"
  }, AA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "52px"
  }, gA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "44px"
  }, IA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "44px",
    fontWeight: 700,
    lineHeight: "52px"
  }, BA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "52px",
    fontWeight: 700,
    lineHeight: "64px"
  }, CA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "96px",
    fontWeight: 700,
    lineHeight: "112px"
  };
  return {
    font100: i,
    font150: g,
    font200: E,
    font250: e,
    font300: t,
    font350: n,
    font400: h,
    font450: d,
    font550: k,
    font650: p,
    font750: M,
    font850: H,
    font950: f,
    font1050: AA,
    font1150: gA,
    font1250: IA,
    font1350: BA,
    font1450: CA,
    ParagraphXSmall: i,
    ParagraphSmall: E,
    ParagraphMedium: t,
    ParagraphLarge: h,
    LabelXSmall: g,
    LabelSmall: e,
    LabelMedium: n,
    LabelLarge: d,
    HeadingXSmall: k,
    HeadingSmall: p,
    HeadingMedium: M,
    HeadingLarge: H,
    HeadingXLarge: f,
    HeadingXXLarge: AA,
    DisplayXSmall: gA,
    DisplaySmall: IA,
    DisplayMedium: BA,
    DisplayLarge: CA,
    MonoParagraphXSmall: _objectSpread$v(_objectSpread$v({}, i), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphSmall: _objectSpread$v(_objectSpread$v({}, E), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphMedium: _objectSpread$v(_objectSpread$v({}, t), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphLarge: _objectSpread$v(_objectSpread$v({}, h), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelXSmall: _objectSpread$v(_objectSpread$v({}, g), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelSmall: _objectSpread$v(_objectSpread$v({}, e), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelMedium: _objectSpread$v(_objectSpread$v({}, n), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelLarge: _objectSpread$v(_objectSpread$v({}, d), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXSmall: _objectSpread$v(_objectSpread$v({}, k), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingSmall: _objectSpread$v(_objectSpread$v({}, p), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingMedium: _objectSpread$v(_objectSpread$v({}, M), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingLarge: _objectSpread$v(_objectSpread$v({}, H), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXLarge: _objectSpread$v(_objectSpread$v({}, f), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXXLarge: _objectSpread$v(_objectSpread$v({}, AA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayXSmall: _objectSpread$v(_objectSpread$v({}, gA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplaySmall: _objectSpread$v(_objectSpread$v({}, IA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayMedium: _objectSpread$v(_objectSpread$v({}, BA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayLarge: _objectSpread$v(_objectSpread$v({}, CA), {}, {
      fontFamily: monoFontFamily
    })
  };
});
var animation = {
  timing100: "100ms",
  timing200: "200ms",
  timing300: "300ms",
  timing400: "400ms",
  timing500: "500ms",
  timing600: "600ms",
  timing700: "700ms",
  timing800: "800ms",
  timing900: "900ms",
  timing1000: "1000ms",
  easeInCurve: "cubic-bezier(.8, .2, .6, 1)",
  easeOutCurve: "cubic-bezier(.2, .8, .4, 1)",
  easeInOutCurve: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeInQuinticCurve: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  easeOutQuinticCurve: "cubic-bezier(0.23, 1, 0.32, 1)",
  easeInOutQuinticCurve: "cubic-bezier(0.86, 0, 0.07, 1)",
  linearCurve: "cubic-bezier(0, 0, 1, 1)"
}, breakpoints$1 = {
  small: 320,
  medium: 600,
  large: 1136
}, grid$1 = {
  columns: [4, 8, 12],
  gutters: [16, 36, 36],
  margins: [16, 36, 64],
  gaps: 0,
  unit: "px",
  maxWidth: 1280
}, getMediaQuery = function o(i) {
  return "@media screen and (min-width: ".concat(i, "px)");
}, mediaQuery = {
  small: getMediaQuery(breakpoints$1.small),
  medium: getMediaQuery(breakpoints$1.medium),
  large: getMediaQuery(breakpoints$1.large)
}, sizing$1 = {
  scale0: "2px",
  scale100: "4px",
  scale200: "6px",
  scale300: "8px",
  scale400: "10px",
  scale500: "12px",
  scale550: "14px",
  scale600: "16px",
  scale650: "18px",
  scale700: "20px",
  scale750: "22px",
  scale800: "24px",
  scale850: "28px",
  scale900: "32px",
  scale950: "36px",
  scale1000: "40px",
  scale1200: "48px",
  scale1400: "56px",
  scale1600: "64px",
  scale2400: "96px",
  scale3200: "128px",
  scale4800: "192px"
};
function ownKeys$w(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$u(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$w(Object(g), !0).forEach(function(E) {
      _defineProperty$D(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$w(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$D(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var LightTheme = {
  name: "light-theme",
  colors: _objectSpread$u(_objectSpread$u(_objectSpread$u({}, lightColorTokens), getComponentColorTokens()), getSemanticColorTokens()),
  animation,
  breakpoints: breakpoints$1,
  borders,
  direction: "auto",
  grid: grid$1,
  lighting,
  mediaQuery,
  sizing: sizing$1,
  typography: getTypography(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2e3
  }
};
function _typeof$l(o) {
  "@babel/helpers - typeof";
  return _typeof$l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$l(o);
}
function deepMerge$1(o) {
  o = o || {};
  for (var i = arguments.length <= 1 ? 0 : arguments.length - 1, g, E, e = 0; e < i; e++) {
    g = (e + 1 < 1 || arguments.length <= e + 1 ? void 0 : arguments[e + 1]) || {};
    for (var t in g)
      _typeof$l(g[t]) !== void 0 && (E = g[t], isCloneable(E) ? o[t] = deepMerge$1(
        /* eslint-disable-next-line no-mixed-operators */
        o[t] || Array.isArray(E) && [] || {},
        E
      ) : o[t] = E);
  }
  return o;
}
function isCloneable(o) {
  return Array.isArray(o) || {}.toString.call(o) == "[object Object]";
}
var darkColorTokens = {
  // Primary Palette
  primaryA: colors$3.gray200,
  primaryB: colors$3.gray900,
  primary: colors$3.white,
  primary50: colors$3.gray50,
  primary100: colors$3.gray100,
  primary200: colors$3.gray200,
  primary300: colors$3.gray300,
  primary400: colors$3.gray400,
  primary500: colors$3.gray500,
  primary600: colors$3.gray600,
  primary700: colors$3.gray700,
  // Accent Palette
  accent: colors$3.blue400,
  accent50: colors$3.blue50,
  accent100: colors$3.blue100,
  accent200: colors$3.blue200,
  accent300: colors$3.blue300,
  accent400: colors$3.blue400,
  accent500: colors$3.blue500,
  accent600: colors$3.blue600,
  accent700: colors$3.blue700,
  // Negative Palette
  negative: colors$3.red500,
  negative50: colors$3.red50,
  negative100: colors$3.red100,
  negative200: colors$3.red200,
  negative300: colors$3.red300,
  negative400: colors$3.red400,
  negative500: colors$3.red500,
  negative600: colors$3.red600,
  negative700: colors$3.red700,
  // Warning Palette
  warning: colors$3.yellow500,
  warning50: colors$3.yellow50,
  warning100: colors$3.yellow100,
  warning200: colors$3.yellow200,
  warning300: colors$3.yellow300,
  warning400: colors$3.yellow400,
  warning500: colors$3.yellow500,
  warning600: colors$3.yellow600,
  warning700: colors$3.yellow700,
  // Positive Palette
  positive: colors$3.green400,
  positive50: colors$3.green50,
  positive100: colors$3.green100,
  positive200: colors$3.green200,
  positive300: colors$3.green300,
  positive400: colors$3.green400,
  positive500: colors$3.green500,
  positive600: colors$3.green600,
  positive700: colors$3.green700,
  // Monochrome Palette
  white: colors$3.white,
  black: colors$3.black,
  mono100: colors$3.gray300,
  mono200: colors$3.gray400,
  mono300: colors$3.gray500,
  mono400: colors$3.gray600,
  mono500: colors$3.gray700,
  // mono600 and mono900 are not in official brand tokens atm
  mono600: "#292929",
  mono700: "#1F1F1F",
  mono800: "#141414",
  mono900: "#111111",
  mono1000: colors$3.black,
  // Rating Palette,
  ratingInactiveFill: colors$3.gray500,
  ratingStroke: colors$3.gray700
}, _excluded$q = ["primaryFontFamily"];
function ownKeys$v(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$t(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$v(Object(g), !0).forEach(function(E) {
      _defineProperty$C(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$v(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$C(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function _objectWithoutProperties$s(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$s(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$s(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function createLightTheme() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0, g = o.primaryFontFamily, E = _objectWithoutProperties$s(o, _excluded$q), e = _objectSpread$t(_objectSpread$t({}, lightColorTokens), E), t = {
    animation,
    borders,
    breakpoints: breakpoints$1,
    colors: _objectSpread$t(_objectSpread$t(_objectSpread$t({}, e), getComponentColorTokens(e)), getSemanticColorTokens(e)),
    direction: "auto",
    grid: grid$1,
    lighting,
    mediaQuery,
    sizing: sizing$1,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: g ? getTypography({
      primaryFontFamily: g
    }) : getTypography(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2e3
    }
  };
  return deepMerge$1(t, i);
}
function ownKeys$u(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$s(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$u(Object(g), !0).forEach(function(E) {
      _defineProperty$B(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$u(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$B(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var primitives$1 = _objectSpread$s(_objectSpread$s({}, darkColorTokens), defaultFontTokens);
function ownKeys$t(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$r(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$t(Object(g), !0).forEach(function(E) {
      _defineProperty$A(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$t(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$A(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var primitives = _objectSpread$r(_objectSpread$r({}, lightColorTokens), defaultFontTokens), ThemeContext$1 = /* @__PURE__ */ React.createContext(LightTheme), ThemeProvider$1 = function o(i) {
  var g = i.theme, E = i.children;
  return /* @__PURE__ */ React.createElement(ThemeContext$1.Provider, {
    value: g
  }, E);
};
function driver(o, i) {
  const g = renderDeclarativeRules(o, i);
  return i.renderStyle(g);
}
function getInitialStyle() {
  return {};
}
function renderDeclarativeRules(o, i) {
  for (const g in o) {
    const E = o[g];
    if (g === "animationName" && typeof E != "string") {
      o.animationName = i.renderKeyframes(E);
      continue;
    }
    if (g === "fontFamily" && typeof E != "string")
      if (Array.isArray(E)) {
        let e = "";
        for (const t of E)
          typeof t == "object" ? e += `${i.renderFontFace(t)},` : typeof t == "string" && (e += `${t},`);
        o.fontFamily = e.slice(0, -1);
        continue;
      } else {
        if (E === void 0)
          continue;
        o.fontFamily = i.renderFontFace(E);
        continue;
      }
    typeof E == "object" && E !== null && renderDeclarativeRules(E, i);
  }
  return o;
}
function addDebugMetadata(o, i) {
  const {
    stack: g,
    stacktrace: E,
    message: e
  } = new Error("stacktrace source");
  o.debug = {
    stackInfo: {
      stack: g,
      stacktrace: E,
      message: e
    },
    stackIndex: i
  };
}
const setupDevtoolsExtension = () => {
  const o = {}, i = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), E = (e) => {
    const t = {};
    if (typeof e != "string")
      return t;
    if (g.has(e)) {
      t.styles = g.get(e);
      const n = e.split(" ");
      if (n.length) {
        const h = {};
        n.forEach((d) => {
          h[d] = o[d];
        }), t.classes = h;
      }
      if (i.has(e)) {
        const h = i.get(e);
        t.extends = h;
      }
      return t;
    }
  };
  window.__STYLETRON_DEVTOOLS__ = {
    atomicMap: o,
    extensionsMap: i,
    stylesMap: g,
    getStyles: E
  };
};
function _extends$B() {
  return _extends$B = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$B.apply(this, arguments);
}
const noopEngine = {
  renderStyle: () => "",
  renderKeyframes: () => "",
  renderFontFace: () => ""
}, StyletronContext = /* @__PURE__ */ React.createContext(noopEngine), HydrationContext = /* @__PURE__ */ React.createContext(!1), DebugEngineContext = /* @__PURE__ */ React.createContext(void 0);
class DevProvider extends React.Component {
  constructor(i) {
    super(i), this.state = {
      hydrating: !!i.debugAfterHydration
    };
  }
  componentDidMount() {
    this.state.hydrating === !0 && this.setState({
      hydrating: !1
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(StyletronContext.Provider, {
      value: this.props.value
    }, /* @__PURE__ */ React.createElement(DebugEngineContext.Provider, {
      value: this.props.debug
    }, /* @__PURE__ */ React.createElement(HydrationContext.Provider, {
      value: this.state.hydrating
    }, this.props.children)));
  }
}
const Provider$1 = process.env.NODE_ENV !== "production" ? DevProvider : StyletronContext.Provider;
process.env.NODE_ENV !== "production" && !window.__STYLETRON_DEVTOOLS__ && setupDevtoolsExtension();
function checkNoopEngine(o) {
  process.env.NODE_ENV !== "test" && o === noopEngine && // eslint-disable-next-line no-console
  console.warn(process.env.NODE_ENV !== "production" ? `
Styletron has been switched to a no-op (test) mode.

A Styletron styled component was rendered, but no Styletron engine instance was provided in React context.

Did you forget to provide a Styletron engine instance to React context via using the Styletron provider component?

Note: Providers and Consumers must come from the exact same React.createContext call to work.
If your app has multiple instances of the "styletron-react" package in your node_module tree,
your Provider may be coming from a different React.createContext call, which means the styled components
will not recieve the provided engine instance. This scenario can arise, for example, when using "npm link".
` : "Styletron Provider is not set up. Defaulting to no-op.");
}
function useStyletron$1() {
  const o = React.useContext(StyletronContext), i = React.useContext(DebugEngineContext), g = React.useContext(HydrationContext);
  checkNoopEngine(o);
  const E = React.useRef(""), e = React.useRef([]);
  return [function(n) {
    const h = driver(n, o);
    if (process.env.NODE_ENV === "production")
      return h;
    const {
      stack: d,
      message: k
    } = new Error("stacktrace source"), p = [i, g];
    return (e.current[0] !== p[0] || e.current[1] !== p[1]) && (i && !g && (E.current = i.debug({
      stackInfo: {
        stack: d,
        message: k
      },
      stackIndex: 1
    })), e.current = p), E.current ? `${E.current} ${h}` : h;
  }];
}
function createStyled$1({
  getInitialStyle: o,
  driver: i,
  wrapper: g
}) {
  function E(e, t) {
    process.env.NODE_ENV !== "production" && e.__STYLETRON__ && (console.warn("It appears you are passing a styled component into `styled`."), console.warn("For composition with existing styled components, use `withStyle` or `withTransform` instead."));
    const n = {
      reducers: [],
      base: e,
      driver: i,
      getInitialStyle: o,
      wrapper: g
    };
    return process.env.NODE_ENV !== "production" && addDebugMetadata(n, 2), createStyledElementComponent(autoComposeShallow(n, t));
  }
  return E;
}
const withStyleDeep = (o, i) => {
  const g = o.__STYLETRON__;
  return process.env.NODE_ENV !== "production" && (g || console.warn("The first parameter to `withStyle` must be a styled component (without extra wrappers).")), process.env.NODE_ENV !== "production" ? (addDebugMetadata(g, 2), createStyledElementComponent(addExtension(autoComposeDeep(g, i), o, i))) : createStyledElementComponent(autoComposeDeep(g, i));
}, withStyle$1 = withStyleDeep, withWrapper$1 = (o, i) => {
  const g = o.__STYLETRON__;
  process.env.NODE_ENV !== "production" && (g || console.warn("The first parameter to `withWrapper` must be a styled component (without extra wrappers)."));
  const E = {
    getInitialStyle: g.getInitialStyle,
    base: g.base,
    driver: g.driver,
    wrapper: i,
    reducers: g.reducers
  };
  return process.env.NODE_ENV !== "production" && addDebugMetadata(E, 2), createStyledElementComponent(E);
};
function autoComposeShallow(o, i) {
  return typeof i == "function" ? dynamicComposeShallow(o, i) : staticComposeShallow(o, i);
}
function addExtension(o, i, g) {
  return {
    ...o,
    ext: {
      with: g,
      name: i.displayName,
      base: i.__STYLETRON__.base,
      getInitialStyle: i.__STYLETRON__.reducers.length ? i.__STYLETRON__.reducers[0].reducer : i.__STYLETRON__.getInitialStyle
    }
  };
}
function autoComposeDeep(o, i) {
  return typeof i == "function" ? dynamicComposeDeep(o, i) : staticComposeDeep(o, i);
}
function staticComposeShallow(o, i) {
  return composeStatic(o, createShallowMergeReducer(i));
}
function staticComposeDeep(o, i) {
  return composeStatic(o, createDeepMergeReducer(i));
}
function dynamicComposeShallow(o, i) {
  return composeDynamic(o, (g, E) => shallowMerge(g, i(E)));
}
function dynamicComposeDeep(o, i) {
  return composeDynamic(o, (g, E) => deepMerge(g, i(E)));
}
function createShallowMergeReducer(o) {
  return {
    reducer: (i) => shallowMerge(i, o),
    assignmentCommutative: !0,
    factory: createShallowMergeReducer,
    style: o
  };
}
function createDeepMergeReducer(o) {
  return {
    reducer: (i) => deepMerge(i, o),
    assignmentCommutative: !0,
    factory: createDeepMergeReducer,
    style: o
  };
}
function composeStatic(o, i) {
  if (o.reducers.length === 0) {
    const g = i.reducer(o.getInitialStyle()), E = {
      reducers: o.reducers,
      base: o.base,
      driver: o.driver,
      wrapper: o.wrapper,
      getInitialStyle: () => g
    };
    return process.env.NODE_ENV !== "production" && (E.debug = o.debug), E;
  } else {
    const g = o.reducers[0];
    if (g.assignmentCommutative === !0 && i.assignmentCommutative === !0) {
      const E = i.reducer(g.style), e = {
        getInitialStyle: o.getInitialStyle,
        base: o.base,
        driver: o.driver,
        wrapper: o.wrapper,
        reducers: [g.factory(E)].concat(o.reducers.slice(1))
      };
      return process.env.NODE_ENV !== "production" && (e.debug = o.debug), e;
    }
    return composeDynamic(o, i.reducer);
  }
}
function composeDynamic(o, i) {
  const g = {
    getInitialStyle: o.getInitialStyle,
    base: o.base,
    driver: o.driver,
    wrapper: o.wrapper,
    // @ts-ignore
    reducers: [{
      assignmentCommutative: !1,
      reducer: i
    }].concat(o.reducers)
  };
  return process.env.NODE_ENV !== "production" && (g.debug = o.debug), g;
}
function createStyledElementComponent(o) {
  const {
    reducers: i,
    base: g,
    driver: E,
    wrapper: e,
    getInitialStyle: t,
    ext: n
  } = o;
  if (process.env.NODE_ENV !== "production") {
    var h, d;
    o.debug && (h = o.debug.stackInfo, d = o.debug.stackIndex);
  }
  if (process.env.NODE_ENV !== "production")
    var k;
  const M = e(/* @__PURE__ */ React.forwardRef((H, f) => {
    const AA = React.useContext(StyletronContext), gA = React.useContext(DebugEngineContext), IA = React.useContext(HydrationContext);
    checkNoopEngine(AA);
    const BA = omitPrefixedKeys(H);
    let CA = resolveStyle(t, i, H);
    H.$style && (typeof H.$style == "function" ? CA = deepMerge(CA, H.$style(H)) : CA = deepMerge(CA, H.$style));
    const QA = E(CA, AA), iA = H.$as ? H.$as : g;
    if (BA.className = H.className ? `${H.className} ${QA}` : QA, process.env.NODE_ENV !== "production" && gA && !IA) {
      k || (k = gA.debug({
        stackInfo: h,
        stackIndex: d
      }));
      const EA = `${k} ${BA.className}`;
      BA.className = EA;
    }
    return process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && (window.__STYLETRON_DEVTOOLS__.stylesMap.set(BA.className, CA), n && window.__STYLETRON_DEVTOOLS__.extensionsMap.set(BA.className, {
      base: n.base,
      displayName: n.name,
      initialStyles: n.getInitialStyle({}, H),
      styleOverrides: typeof n.with == "function" ? n.with(H) : n.with
    })), H.$ref && console.warn("The prop `$ref` has been deprecated. Use `ref` instead. Refs are now forwarded with React.forwardRef."), /* @__PURE__ */ React.createElement(iA, _extends$B({}, BA, {
      ref: f || H.$ref
    }));
  }));
  if (M.__STYLETRON__ = {
    base: g,
    reducers: i,
    driver: E,
    wrapper: e,
    getInitialStyle: t
  }, process.env.NODE_ENV !== "production") {
    let H;
    typeof g == "string" ? H = g : g.displayName ? H = g.displayName : g.name ? H = g.name : H = "Unknown", M.displayName = `Styled(${H})`;
  }
  return M;
}
function resolveStyle(o, i, g) {
  let E = o(), e = i.length;
  for (; e--; ) {
    const t = i[e].reducer;
    E = t(E, g);
  }
  return E;
}
function isObject$1(o) {
  return typeof o == "object" && o !== null;
}
function omitPrefixedKeys(o) {
  const i = {};
  for (const g in o)
    g[0] !== "$" && (i[g] = o[g]);
  return i;
}
function deepMerge(o, i) {
  const g = assign({}, o);
  for (const E in i) {
    const e = i[E];
    isObject$1(e) && isObject$1(o[E]) ? g[E] = deepMerge(o[E], e) : g[E] = e;
  }
  return g;
}
function shallowMerge(o, i) {
  return assign(assign({}, o), i);
}
function assign(o, i) {
  for (const g in i)
    o[g] = i[g];
  return o;
}
function ownKeys$s(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$q(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$s(Object(g), !0).forEach(function(E) {
      _defineProperty$z(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$s(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$z(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function _slicedToArray$n(o, i) {
  return _arrayWithHoles$m(o) || _iterableToArrayLimit$m(o, i) || _unsupportedIterableToArray$m(o, i) || _nonIterableRest$m();
}
function _nonIterableRest$m() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$m(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$m(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$m(o, i);
  }
}
function _arrayLikeToArray$m(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$m(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$m(o) {
  if (Array.isArray(o)) return o;
}
function _extends$A() {
  return _extends$A = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$A.apply(this, arguments);
}
var wrapper = function o(i) {
  return /* @__PURE__ */ React.forwardRef(function(g, E) {
    return /* @__PURE__ */ React.createElement(ThemeContext$1.Consumer, null, function(e) {
      return /* @__PURE__ */ React.createElement(i, _extends$A({
        ref: E
      }, g, {
        $theme: e
      }));
    });
  });
};
function createThemedStyled() {
  return createStyled$1({
    wrapper,
    getInitialStyle,
    driver
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  });
}
var styled = createThemedStyled();
function createThemedWithStyle() {
  return withStyle$1;
}
var withStyle = createThemedWithStyle();
function createThemedUseStyletron() {
  return function() {
    var o = React.useContext(ThemeContext$1), i = useStyletron$1(), g = _slicedToArray$n(i, 1), E = g[0];
    return [E, o];
  };
}
var useStyletron = createThemedUseStyletron();
function withWrapper(o, i) {
  return withWrapper$1(o, function(g) {
    return /* @__PURE__ */ React.forwardRef(function(E, e) {
      return /* @__PURE__ */ React.createElement(ThemeContext$1.Consumer, null, function(t) {
        return (
          // @ts-ignore
          i(g)(_objectSpread$q(_objectSpread$q({
            ref: e
          }, E), {}, {
            $theme: t
          }))
        );
      });
    });
  });
}
var locale$b = {
  collapse: "Collapse",
  expand: "Expand"
}, locale$a = {
  ariaLabel: "Breadcrumbs navigation"
}, locale$9 = {
  ariaLabel: "Select a date.",
  ariaLabelRange: "Select a date range.",
  ariaLabelCalendar: "Calendar.",
  ariaRoleDescriptionCalendarMonth: "Calendar month",
  previousMonth: "Previous month.",
  nextMonth: "Next month.",
  pastWeek: "Past Week",
  pastMonth: "Past Month",
  pastThreeMonths: "Past 3 Months",
  pastSixMonths: "Past 6 Months",
  pastYear: "Past Year",
  pastTwoYears: "Past 2 Years",
  screenReaderMessageInput: "Press the down arrow key to interact with the calendar and select a date. Press the escape button to close the calendar.",
  selectedDate: "Selected date is ${date}.",
  selectedDateRange: "Selected date range is from ${startDate} to ${endDate}.",
  selectSecondDatePrompt: "Select the second date.",
  quickSelectLabel: "Choose a date range",
  quickSelectAriaLabel: "Choose a date range",
  quickSelectPlaceholder: "None",
  timeSelectEndLabel: "End time",
  timeSelectStartLabel: "Start time",
  timePickerAriaLabel12Hour: "Select a time, 12-hour format.",
  timePickerAriaLabel24Hour: "Select a time, 24-hour format.",
  timezonePickerAriaLabel: "Select a timezone.",
  selectedStartDateLabel: "Selected start date.",
  selectedEndDateLabel: "Selected end date.",
  dateNotAvailableLabel: "Not available.",
  dateAvailableLabel: "It's available.",
  selectedLabel: "Selected.",
  chooseLabel: "Choose"
}, locale$8 = {
  emptyState: "No rows match the filter criteria defined. Please remove one or more filters to view more data.",
  loadingState: "Loading rows.",
  searchAriaLabel: "Search by text",
  filterAdd: "Add Filter",
  filterExclude: "Exclude",
  filterApply: "Apply",
  filterExcludeRange: "Exclude range",
  filterExcludeValue: "Exclude value",
  filterAppliedTo: "filter applied to",
  optionsLabel: "Select column to filter by",
  optionsSearch: "Search for a column to filter by...",
  optionsEmpty: "No columns available.",
  categoricalFilterSelectAll: "Select All",
  categoricalFilterSelectClear: "Clear",
  categoricalFilterEmpty: "No categories found",
  datetimeFilterRange: "Range",
  datetimeFilterRangeDatetime: "Date, Time",
  datetimeFilterRangeDate: "Date",
  datetimeFilterRangeTime: "Time",
  datetimeFilterCategorical: "Categorical",
  datetimeFilterCategoricalWeekday: "Weekday",
  datetimeFilterCategoricalMonth: "Month",
  datetimeFilterCategoricalQuarter: "Quarter",
  datetimeFilterCategoricalHalf: "Half",
  datetimeFilterCategoricalFirstHalf: "H1",
  datetimeFilterCategoricalSecondHalf: "H2",
  datetimeFilterCategoricalYear: "Year",
  numericalFilterRange: "Range",
  numericalFilterSingleValue: "Single Value",
  booleanFilterTrue: "true",
  booleanFilterFalse: "false",
  booleanColumnTrueShort: "T",
  booleanColumnFalseShort: "F",
  selectRow: "Select row",
  selectAllRows: "Select all rows"
}, locale$7 = {
  ariaLabel: "button group"
}, locale$6 = {
  dropFilesToUpload: "Drop files here to upload...",
  or: "",
  browseFiles: "Browse files",
  retry: "Retry Upload",
  cancel: "Cancel"
}, locale$5 = {
  noResultsMsg: "No results",
  parentMenuItemAriaLabel: "You are currently at an item that opens a nested listbox. Press right arrow to enter that element and left arrow to return."
}, locale$4 = {
  close: "Close"
}, locale$3 = {
  close: "Close"
}, locale$2 = {
  prev: "Prev",
  next: "Next",
  preposition: "of"
}, locale$1 = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: "No results found",
  placeholder: "Select...",
  create: "Create"
}, locale = {
  close: "Close"
}, en_US = {
  accordion: locale$b,
  breadcrumbs: locale$a,
  datepicker: locale$9,
  datatable: locale$8,
  buttongroup: locale$7,
  fileuploader: locale$6,
  menu: locale$5,
  modal: locale$4,
  drawer: locale$3,
  pagination: locale$2,
  select: locale$1,
  toast: locale
}, LocaleContext = /* @__PURE__ */ React.createContext(en_US), generateUID$1 = function() {
  var o = 1, i = /* @__PURE__ */ new WeakMap(), g = function(E, e) {
    return typeof E == "number" || typeof E == "string" ? e ? "idx-".concat(e) : "val-".concat(E) : i.has(E) ? "uid" + i.get(E) : (i.set(E, o++), g(E));
  };
  return g;
}, createSource = function(o) {
  return o === void 0 && (o = ""), {
    value: 1,
    prefix: o,
    uid: generateUID$1()
  };
}, counter = createSource(), source = React.createContext(createSource()), getId = function(o) {
  return o.value++;
}, getPrefix = function(o) {
  return o ? o.prefix : "";
}, __extends$1 = /* @__PURE__ */ (function() {
  var o = function(i, g) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, e) {
      E.__proto__ = e;
    } || function(E, e) {
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && (E[t] = e[t]);
    }, o(i, g);
  };
  return function(i, g) {
    if (typeof g != "function" && g !== null)
      throw new TypeError("Class extends value " + String(g) + " is not a constructor or null");
    o(i, g);
    function E() {
      this.constructor = i;
    }
    i.prototype = g === null ? Object.create(g) : (E.prototype = g.prototype, new E());
  };
})(), prefixId = function(o, i, g) {
  var E = i + o;
  return String(g ? g(E) : E);
}, UID = (
  /** @class */
  (function(o) {
    __extends$1(i, o);
    function i() {
      var g = o !== null && o.apply(this, arguments) || this;
      return g.state = {
        quartz: g.props.idSource || counter,
        prefix: getPrefix(g.props.idSource),
        id: getId(g.props.idSource || counter)
      }, g.uid = function(E) {
        return prefixId(g.state.id + "-" + g.state.quartz.uid(E), g.state.prefix, g.props.name);
      }, g;
    }
    return i.prototype.render = function() {
      var g = this.props, E = g.children, e = g.name, t = this.state, n = t.id, h = t.prefix;
      return E(prefixId(n, h, e), this.uid);
    }, i;
  })(React.Component)
), generateUID = function(o) {
  var i = o || counter, g = getPrefix(i), E = getId(i), e = g + E, t = function(n) {
    return e + i.uid(n);
  };
  return { uid: e, gen: t };
}, useUIDState = function() {
  if (process.env.NODE_ENV !== "production" && !("useContext" in React))
    throw new Error("Hooks API requires React 16.8+");
  var o = useContext(source), i = useState(function() {
    return generateUID(o);
  })[0];
  return i;
}, useUID = function() {
  var o = useUIDState().uid;
  return o;
}, useUIDSeed = function() {
  var o = useUIDState().gen;
  return o;
}, UIDReset = function(o) {
  var i = o.children, g = o.prefix, E = g === void 0 ? "" : g, e = useState(function() {
    return createSource(E);
  })[0];
  return React.createElement(source.Provider, { value: e }, i);
}, UIDConsumer = function(o) {
  var i = o.name, g = o.children;
  return React.createElement(source.Consumer, null, function(E) {
    return React.createElement(UID, { name: i, idSource: E, children: g });
  });
}, reactIsExports$1 = requireReactIs$1();
function _extends$z() {
  return _extends$z = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$z.apply(this, arguments);
}
function ownKeys$r(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$p(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$r(Object(g), !0).forEach(function(E) {
      _defineProperty$y(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$r(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$y(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function _typeof$k(o) {
  "@babel/helpers - typeof";
  return _typeof$k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$k(o);
}
function getOverride(o) {
  return reactIsExports$1.isValidElementType(o) ? o : o && _typeof$k(o) === "object" ? o.component : o;
}
function getOverrideProps(o) {
  return o && _typeof$k(o) === "object" ? _typeof$k(o.props) === "object" ? _objectSpread$p(_objectSpread$p({}, o.props), {}, {
    $style: o.style
  }) : {
    $style: o.style
  } : {};
}
function toObjectOverride(o) {
  return reactIsExports$1.isValidElementType(o) ? {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: o
  } : o || {};
}
function getOverrides(o, i) {
  var g = getOverride(o) || i;
  if (o && _typeof$k(o) === "object" && typeof o.props == "function") {
    process.env.NODE_ENV !== "production" && console.warn("baseui:Overrides Props as a function will be removed in the next major version. Override the whole component instead. See https://baseweb.design/guides/understanding-overrides/#override-the-entire-subcomponent");
    var E = /* @__PURE__ */ React.forwardRef(function(t, n) {
      var h = o.props(t), d = getOverrideProps(_objectSpread$p(_objectSpread$p({}, o), {}, {
        props: h
      }));
      return /* @__PURE__ */ React.createElement(g, _extends$z({
        ref: n
      }, d));
    });
    return E.displayName = g.displayName, [E, {}];
  }
  var e = getOverrideProps(o);
  return [g, e];
}
function mergeOverrides() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = Object.assign({}, o, i), E = Object.keys(g);
  return E.reduce(function(e, t) {
    return e[t] = mergeOverride(toObjectOverride(o[t]), toObjectOverride(i[t])), e;
  }, {});
}
function mergeOverride(o, i) {
  var g = _objectSpread$p(_objectSpread$p({}, o), i);
  return o.props && i.props && (g.props = mergeConfigurationOverrides(o.props, i.props)), o.style && i.style && (g.style = mergeConfigurationOverrides(o.style, i.style)), g;
}
function mergeConfigurationOverrides(o, i) {
  return _typeof$k(o) === "object" && _typeof$k(i) === "object" ? deepMerge$1({}, o, i) : function() {
    return deepMerge$1({}, typeof o == "function" ? o.apply(void 0, arguments) : o, typeof i == "function" ? i.apply(void 0, arguments) : i);
  };
}
var initialized = !1, hadKeyboardEvent = !0, inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function focusTriggersKeyboardModality(o) {
  var i = o.type, g = o.tagName;
  return !!(g === "INPUT" && inputTypesWhitelist[i] && !o.readOnly || g === "TEXTAREA" && !o.readOnly || o.isContentEditable);
}
function handleKeyDown(o) {
  o.metaKey || o.altKey || o.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState;
}
function prepare(o) {
  o.addEventListener("keydown", handleKeyDown, !0), o.addEventListener("mousedown", handlePointerDown, !0), o.addEventListener("pointerdown", handlePointerDown, !0), o.addEventListener("touchstart", handlePointerDown, !0), o.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(o) {
  try {
    return o.target.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(o.target);
}
function initFocusVisible(o) {
  !initialized && o != null && (initialized = !0, prepare(o.ownerDocument));
}
var forkFocus = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function o(i, g) {
    return function(E) {
      typeof i.onFocus == "function" && i.onFocus(E), g(E);
    };
  }
), forkBlur = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function o(i, g) {
    return function(E) {
      typeof i.onBlur == "function" && i.onBlur(E), g(E);
    };
  }
);
function _typeof$j(o) {
  "@babel/helpers - typeof";
  return _typeof$j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$j(o);
}
function _extends$y() {
  return _extends$y = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$y.apply(this, arguments);
}
function _slicedToArray$m(o, i) {
  return _arrayWithHoles$l(o) || _iterableToArrayLimit$l(o, i) || _unsupportedIterableToArray$l(o, i) || _nonIterableRest$l();
}
function _nonIterableRest$l() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$l(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$l(o) {
  if (Array.isArray(o)) return o;
}
function _toConsumableArray$3(o) {
  return _arrayWithoutHoles$3(o) || _iterableToArray$3(o) || _unsupportedIterableToArray$l(o) || _nonIterableSpread$3();
}
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$l(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$l(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$l(o, i);
  }
}
function _iterableToArray$3(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function _arrayWithoutHoles$3(o) {
  if (Array.isArray(o)) return _arrayLikeToArray$l(o);
}
function _arrayLikeToArray$l(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _classCallCheck$g(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$g(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$g(o, i, g) {
  return i && _defineProperties$g(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$g(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$h(o, i);
}
function _setPrototypeOf$h(o, i) {
  return _setPrototypeOf$h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$h(o, i);
}
function _createSuper$g(o) {
  var i = _isNativeReflectConstruct$g();
  return function() {
    var E = _getPrototypeOf$g(o), e;
    if (i) {
      var t = _getPrototypeOf$g(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$g(this, e);
  };
}
function _possibleConstructorReturn$g(o, i) {
  if (i && (_typeof$j(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$h(o);
}
function _assertThisInitialized$h(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$g() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$g(o) {
  return _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$g(o);
}
function _defineProperty$x(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var StyledAppContainer = styled("div", {});
StyledAppContainer.displayName = "StyledAppContainer";
var StyledLayersContainer = styled("div", {});
StyledLayersContainer.displayName = "StyledLayersContainer";
function defaultEventHandlerFn() {
  process.env.NODE_ENV !== "production" && console.warn("`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information");
}
var LayersContext = /* @__PURE__ */ React.createContext({
  addEscapeHandler: defaultEventHandlerFn,
  removeEscapeHandler: defaultEventHandlerFn,
  addKeyDownHandler: defaultEventHandlerFn,
  removeKeyDownHandler: defaultEventHandlerFn,
  addKeyUpHandler: defaultEventHandlerFn,
  removeKeyUpHandler: defaultEventHandlerFn,
  addKeyPressHandler: defaultEventHandlerFn,
  removeKeyPressHandler: defaultEventHandlerFn,
  addDocClickHandler: defaultEventHandlerFn,
  removeDocClickHandler: defaultEventHandlerFn,
  host: void 0,
  zIndex: void 0
}), Provider = LayersContext.Provider, Consumer = LayersContext.Consumer, LayersManager = /* @__PURE__ */ (function(o) {
  _inherits$g(g, o);
  var i = _createSuper$g(g);
  function g(E) {
    var e;
    return _classCallCheck$g(this, g), e = i.call(this, E), _defineProperty$x(_assertThisInitialized$h(e), "host", /* @__PURE__ */ React.createRef()), _defineProperty$x(_assertThisInitialized$h(e), "containerRef", /* @__PURE__ */ React.createRef()), _defineProperty$x(_assertThisInitialized$h(e), "onDocumentClick", function(t) {
      var n = e.state.docClickHandlers[e.state.docClickHandlers.length - 1];
      n && n(t);
    }), _defineProperty$x(_assertThisInitialized$h(e), "onKeyDown", function(t) {
      var n = e.state.keyDownHandlers[e.state.keyDownHandlers.length - 1];
      n && n(t);
    }), _defineProperty$x(_assertThisInitialized$h(e), "onKeyUp", function(t) {
      if (t.key === "Escape") {
        var n = e.state.escapeKeyHandlers[e.state.escapeKeyHandlers.length - 1];
        n && n();
      }
      var h = e.state.keyUpHandlers[e.state.keyUpHandlers.length - 1];
      h && h(t);
    }), _defineProperty$x(_assertThisInitialized$h(e), "onKeyPress", function(t) {
      var n = e.state.keyPressHandlers[e.state.keyPressHandlers.length - 1];
      n && n(t);
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddEscapeHandler", function(t) {
      e.setState(function(n) {
        return {
          escapeKeyHandlers: [].concat(_toConsumableArray$3(n.escapeKeyHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveEscapeHandler", function(t) {
      e.setState(function(n) {
        return {
          escapeKeyHandlers: n.escapeKeyHandlers.filter(function(h) {
            return h !== t;
          })
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddKeyDownHandler", function(t) {
      e.setState(function(n) {
        return {
          keyDownHandlers: [].concat(_toConsumableArray$3(n.keyDownHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveKeyDownHandler", function(t) {
      e.setState(function(n) {
        return {
          keyDownHandlers: n.keyDownHandlers.filter(function(h) {
            return h !== t;
          })
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddKeyUpHandler", function(t) {
      e.setState(function(n) {
        return {
          keyUpHandlers: [].concat(_toConsumableArray$3(n.keyUpHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveKeyUpHandler", function(t) {
      e.setState(function(n) {
        return {
          keyUpHandlers: n.keyUpHandlers.filter(function(h) {
            return h !== t;
          })
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddKeyPressHandler", function(t) {
      e.setState(function(n) {
        return {
          keyPressHandlers: [].concat(_toConsumableArray$3(n.keyPressHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveKeyPressHandler", function(t) {
      e.setState(function(n) {
        return {
          keyPressHandlers: n.keyPressHandlers.filter(function(h) {
            return h !== t;
          })
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddDocClickHandler", function(t) {
      e.setState(function(n) {
        return {
          docClickHandlers: [].concat(_toConsumableArray$3(n.docClickHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveDocClickHandler", function(t) {
      e.setState(function(n) {
        return {
          docClickHandlers: n.docClickHandlers.filter(function(h) {
            return h !== t;
          })
        };
      });
    }), e.state = {
      escapeKeyHandlers: [],
      keyDownHandlers: [],
      keyUpHandlers: [],
      keyPressHandlers: [],
      docClickHandlers: []
    }, e;
  }
  return _createClass$g(g, [{
    key: "componentDidMount",
    value: function() {
      this.forceUpdate(), initFocusVisible(this.containerRef.current), typeof document < "u" && (document.addEventListener("keydown", this.onKeyDown), document.addEventListener("keyup", this.onKeyUp), document.addEventListener("keypress", this.onKeyPress), document.addEventListener("mousedown", this.onDocumentClick));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      typeof document < "u" && (document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("keyup", this.onKeyUp), document.removeEventListener("keypress", this.onKeyPress), document.removeEventListener("mousedown", this.onDocumentClick));
    }
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.props.overrides, n = t === void 0 ? {} : t, h = getOverrides(n.AppContainer, StyledAppContainer), d = _slicedToArray$m(h, 2), k = d[0], p = d[1], M = getOverrides(n.LayersContainer, StyledLayersContainer), H = _slicedToArray$m(M, 2), f = H[0], AA = H[1];
      return /* @__PURE__ */ React.createElement(Consumer, null, function(gA) {
        var IA = gA.host;
        return process.env.NODE_ENV !== "production" && IA !== void 0 && console.warn("There is a LayersManager already exists in your application. It is not recommended to have more than one LayersManager in an application."), /* @__PURE__ */ React.createElement(Provider, {
          value: {
            host: IA || e.host.current,
            zIndex: e.props.zIndex,
            addEscapeHandler: e.onAddEscapeHandler,
            removeEscapeHandler: e.onRemoveEscapeHandler,
            addKeyDownHandler: e.onAddKeyDownHandler,
            removeKeyDownHandler: e.onRemoveKeyDownHandler,
            addKeyUpHandler: e.onAddKeyUpHandler,
            removeKeyUpHandler: e.onRemoveKeyUpHandler,
            addKeyPressHandler: e.onAddKeyPressHandler,
            removeKeyPressHandler: e.onRemoveKeyPressHandler,
            addDocClickHandler: e.onAddDocClickHandler,
            removeDocClickHandler: e.onRemoveDocClickHandler
          }
        }, /* @__PURE__ */ React.createElement(k, _extends$y({}, p, {
          ref: e.containerRef
        }), e.props.children), /* @__PURE__ */ React.createElement(f, _extends$y({}, AA, {
          ref: e.host
        })));
      });
    }
  }]), g;
})(React.Component);
function _typeof$i(o) {
  "@babel/helpers - typeof";
  return _typeof$i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$i(o);
}
function _extends$x() {
  return _extends$x = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$x.apply(this, arguments);
}
function _classCallCheck$f(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$f(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$f(o, i, g) {
  return i && _defineProperties$f(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$f(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$g(o, i);
}
function _setPrototypeOf$g(o, i) {
  return _setPrototypeOf$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$g(o, i);
}
function _createSuper$f(o) {
  var i = _isNativeReflectConstruct$f();
  return function() {
    var E = _getPrototypeOf$f(o), e;
    if (i) {
      var t = _getPrototypeOf$f(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$f(this, e);
  };
}
function _possibleConstructorReturn$f(o, i) {
  if (i && (_typeof$i(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$g(o);
}
function _assertThisInitialized$g(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$f() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$f(o) {
  return _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$f(o);
}
function _defineProperty$w(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var Container = styled("div", function(o) {
  var i = o.$zIndex;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: i || null
  };
});
Container.displayName = "Container";
var LayerComponent = /* @__PURE__ */ (function(o) {
  _inherits$f(g, o);
  var i = _createSuper$f(g);
  function g() {
    var E;
    _classCallCheck$f(this, g);
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = i.call.apply(i, [this].concat(t)), _defineProperty$w(_assertThisInitialized$g(E), "state", {
      container: null
    }), _defineProperty$w(_assertThisInitialized$g(E), "onEscape", function() {
      E.props.onEscape && E.props.onEscape();
    }), _defineProperty$w(_assertThisInitialized$g(E), "onKeyDown", function(h) {
      E.props.onKeyDown && E.props.onKeyDown(h);
    }), _defineProperty$w(_assertThisInitialized$g(E), "onKeyUp", function(h) {
      E.props.onKeyUp && E.props.onKeyUp(h);
    }), _defineProperty$w(_assertThisInitialized$g(E), "onKeyPress", function(h) {
      E.props.onKeyPress && E.props.onKeyPress(h);
    }), _defineProperty$w(_assertThisInitialized$g(E), "onDocumentClick", function(h) {
      E.props.onDocumentClick && E.props.onDocumentClick(h);
    }), E;
  }
  return _createClass$f(g, [{
    key: "componentDidMount",
    value: function() {
      this.context.addEscapeHandler(this.onEscape), this.context.addKeyDownHandler(this.onKeyDown), this.context.addKeyUpHandler(this.onKeyUp), this.context.addKeyPressHandler(this.onKeyPress), this.props.isHoverLayer || this.context.addDocClickHandler(this.onDocumentClick);
      var e = this.props, t = e.onMount, n = e.mountNode, h = e.host;
      if (n) {
        t && t();
        return;
      }
      var d = h !== void 0;
      process.env.NODE_ENV !== "production" && (d || console.warn("`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information"));
      var k = d ? h : document.body;
      k && this.addContainer(k);
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      var t = this.props, n = t.host, h = t.mountNode;
      h || (n && n !== e.host && e.host === null && this.addContainer(n), e.isHoverLayer != this.props.isHoverLayer && (this.props.isHoverLayer ? this.context.removeDocClickHandler(this.onDocumentClick) : this.context.addDocClickHandler(this.onDocumentClick)));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.context.removeEscapeHandler(this.onEscape), this.context.removeKeyDownHandler(this.onKeyDown), this.context.removeKeyUpHandler(this.onKeyUp), this.context.removeKeyPressHandler(this.onKeyPress), this.context.removeDocClickHandler(this.onDocumentClick), this.props.onUnmount && this.props.onUnmount();
      var e = this.props.host, t = this.state.container;
      e && t && e.contains(t) && e.removeChild(t);
    }
  }, {
    key: "addContainer",
    value: function(e) {
      var t = this.props, n = t.index, h = t.mountNode, d = t.onMount;
      if (!h && e) {
        var k = e.ownerDocument.createElement("div"), p = typeof n == "number" ? e.children[n] : null;
        p ? e.insertBefore(k, p) : e.appendChild(k), this.setState({
          container: k
        }, function() {
          d && d();
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var e = this.state.container, t = this.props, n = t.children, h = t.mountNode, d = t.zIndex, k = d ? /* @__PURE__ */ React.createElement(Container, {
        $zIndex: d
      }, n) : n;
      return typeof document < "u" ? h ? /* @__PURE__ */ ReactDOM.createPortal(k, h) : e ? /* @__PURE__ */ ReactDOM.createPortal(k, e) : null : null;
    }
  }]), g;
})(React.Component);
_defineProperty$w(LayerComponent, "contextType", LayersContext);
function Layer(o) {
  return /* @__PURE__ */ React.createElement(Consumer, null, function(i) {
    var g = i.host, E = i.zIndex;
    return /* @__PURE__ */ React.createElement(LayerComponent, _extends$x({}, o, {
      host: g,
      zIndex: E
    }));
  });
}
var isBrowser$1 = typeof window < "u" && typeof document < "u" && typeof navigator < "u", timeoutDuration = (function() {
  for (var o = ["Edge", "Trident", "Firefox"], i = 0; i < o.length; i += 1)
    if (isBrowser$1 && navigator.userAgent.indexOf(o[i]) >= 0)
      return 1;
  return 0;
})();
function microtaskDebounce(o) {
  var i = !1;
  return function() {
    i || (i = !0, window.Promise.resolve().then(function() {
      i = !1, o();
    }));
  };
}
function taskDebounce(o) {
  var i = !1;
  return function() {
    i || (i = !0, setTimeout(function() {
      i = !1, o();
    }, timeoutDuration));
  };
}
var supportsMicroTasks = isBrowser$1 && window.Promise, debounce$1 = supportsMicroTasks ? microtaskDebounce : taskDebounce;
function isFunction$1(o) {
  var i = {};
  return o && i.toString.call(o) === "[object Function]";
}
function getStyleComputedProperty(o, i) {
  if (o.nodeType !== 1)
    return [];
  var g = o.ownerDocument.defaultView, E = g.getComputedStyle(o, null);
  return i ? E[i] : E;
}
function getParentNode$1(o) {
  return o.nodeName === "HTML" ? o : o.parentNode || o.host;
}
function getScrollParent(o) {
  if (!o)
    return document.body;
  switch (o.nodeName) {
    case "HTML":
    case "BODY":
      return o.ownerDocument.body;
    case "#document":
      return o.body;
  }
  var i = getStyleComputedProperty(o), g = i.overflow, E = i.overflowX, e = i.overflowY;
  return /(auto|scroll|overlay)/.test(g + e + E) ? o : getScrollParent(getParentNode$1(o));
}
function getReferenceNode(o) {
  return o && o.referenceNode ? o.referenceNode : o;
}
var isIE11 = isBrowser$1 && !!(window.MSInputMethodContext && document.documentMode), isIE10 = isBrowser$1 && /MSIE 10/.test(navigator.userAgent);
function isIE(o) {
  return o === 11 ? isIE11 : o === 10 ? isIE10 : isIE11 || isIE10;
}
function getOffsetParent(o) {
  if (!o)
    return document.documentElement;
  for (var i = isIE(10) ? document.body : null, g = o.offsetParent || null; g === i && o.nextElementSibling; )
    g = (o = o.nextElementSibling).offsetParent;
  var E = g && g.nodeName;
  return !E || E === "BODY" || E === "HTML" ? o ? o.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(g.nodeName) !== -1 && getStyleComputedProperty(g, "position") === "static" ? getOffsetParent(g) : g;
}
function isOffsetContainer(o) {
  var i = o.nodeName;
  return i === "BODY" ? !1 : i === "HTML" || getOffsetParent(o.firstElementChild) === o;
}
function getRoot(o) {
  return o.parentNode !== null ? getRoot(o.parentNode) : o;
}
function findCommonOffsetParent(o, i) {
  if (!o || !o.nodeType || !i || !i.nodeType)
    return document.documentElement;
  var g = o.compareDocumentPosition(i) & Node.DOCUMENT_POSITION_FOLLOWING, E = g ? o : i, e = g ? i : o, t = document.createRange();
  t.setStart(E, 0), t.setEnd(e, 0);
  var n = t.commonAncestorContainer;
  if (o !== n && i !== n || E.contains(e))
    return isOffsetContainer(n) ? n : getOffsetParent(n);
  var h = getRoot(o);
  return h.host ? findCommonOffsetParent(h.host, i) : findCommonOffsetParent(o, getRoot(i).host);
}
function getScroll(o) {
  var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", g = i === "top" ? "scrollTop" : "scrollLeft", E = o.nodeName;
  if (E === "BODY" || E === "HTML") {
    var e = o.ownerDocument.documentElement, t = o.ownerDocument.scrollingElement || e;
    return t[g];
  }
  return o[g];
}
function includeScroll(o, i) {
  var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, E = getScroll(i, "top"), e = getScroll(i, "left"), t = g ? -1 : 1;
  return o.top += E * t, o.bottom += E * t, o.left += e * t, o.right += e * t, o;
}
function getBordersSize$1(o, i) {
  var g = i === "x" ? "Left" : "Top", E = g === "Left" ? "Right" : "Bottom";
  return parseFloat(o["border" + g + "Width"]) + parseFloat(o["border" + E + "Width"]);
}
function getSize(o, i, g, E) {
  return Math.max(i["offset" + o], i["scroll" + o], g["client" + o], g["offset" + o], g["scroll" + o], isIE(10) ? parseInt(g["offset" + o]) + parseInt(E["margin" + (o === "Height" ? "Top" : "Left")]) + parseInt(E["margin" + (o === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(o) {
  var i = o.body, g = o.documentElement, E = isIE(10) && getComputedStyle(g);
  return {
    height: getSize("Height", i, g, E),
    width: getSize("Width", i, g, E)
  };
}
var classCallCheck = function(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}, createClass = /* @__PURE__ */ (function() {
  function o(i, g) {
    for (var E = 0; E < g.length; E++) {
      var e = g[E];
      e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(i, e.key, e);
    }
  }
  return function(i, g, E) {
    return g && o(i.prototype, g), E && o(i, E), i;
  };
})(), defineProperty = function(o, i, g) {
  return i in o ? Object.defineProperty(o, i, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[i] = g, o;
}, _extends$w = Object.assign || function(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i];
    for (var E in g)
      Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
  }
  return o;
};
function getClientRect(o) {
  return _extends$w({}, o, {
    right: o.left + o.width,
    bottom: o.top + o.height
  });
}
function getBoundingClientRect(o) {
  var i = {};
  try {
    if (isIE(10)) {
      i = o.getBoundingClientRect();
      var g = getScroll(o, "top"), E = getScroll(o, "left");
      i.top += g, i.left += E, i.bottom += g, i.right += E;
    } else
      i = o.getBoundingClientRect();
  } catch {
  }
  var e = {
    left: i.left,
    top: i.top,
    width: i.right - i.left,
    height: i.bottom - i.top
  }, t = o.nodeName === "HTML" ? getWindowSizes(o.ownerDocument) : {}, n = t.width || o.clientWidth || e.width, h = t.height || o.clientHeight || e.height, d = o.offsetWidth - n, k = o.offsetHeight - h;
  if (d || k) {
    var p = getStyleComputedProperty(o);
    d -= getBordersSize$1(p, "x"), k -= getBordersSize$1(p, "y"), e.width -= d, e.height -= k;
  }
  return getClientRect(e);
}
function getOffsetRectRelativeToArbitraryNode(o, i) {
  var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, E = isIE(10), e = i.nodeName === "HTML", t = getBoundingClientRect(o), n = getBoundingClientRect(i), h = getScrollParent(o), d = getStyleComputedProperty(i), k = parseFloat(d.borderTopWidth), p = parseFloat(d.borderLeftWidth);
  g && e && (n.top = Math.max(n.top, 0), n.left = Math.max(n.left, 0));
  var M = getClientRect({
    top: t.top - n.top - k,
    left: t.left - n.left - p,
    width: t.width,
    height: t.height
  });
  if (M.marginTop = 0, M.marginLeft = 0, !E && e) {
    var H = parseFloat(d.marginTop), f = parseFloat(d.marginLeft);
    M.top -= k - H, M.bottom -= k - H, M.left -= p - f, M.right -= p - f, M.marginTop = H, M.marginLeft = f;
  }
  return (E && !g ? i.contains(h) : i === h && h.nodeName !== "BODY") && (M = includeScroll(M, i)), M;
}
function getViewportOffsetRectRelativeToArtbitraryNode(o) {
  var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = o.ownerDocument.documentElement, E = getOffsetRectRelativeToArbitraryNode(o, g), e = Math.max(g.clientWidth, window.innerWidth || 0), t = Math.max(g.clientHeight, window.innerHeight || 0), n = i ? 0 : getScroll(g), h = i ? 0 : getScroll(g, "left"), d = {
    top: n - E.top + E.marginTop,
    left: h - E.left + E.marginLeft,
    width: e,
    height: t
  };
  return getClientRect(d);
}
function isFixed$1(o) {
  var i = o.nodeName;
  if (i === "BODY" || i === "HTML")
    return !1;
  if (getStyleComputedProperty(o, "position") === "fixed")
    return !0;
  var g = getParentNode$1(o);
  return g ? isFixed$1(g) : !1;
}
function getFixedPositionOffsetParent(o) {
  if (!o || !o.parentElement || isIE())
    return document.documentElement;
  for (var i = o.parentElement; i && getStyleComputedProperty(i, "transform") === "none"; )
    i = i.parentElement;
  return i || document.documentElement;
}
function getBoundaries(o, i, g, E) {
  var e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, t = { top: 0, left: 0 }, n = e ? getFixedPositionOffsetParent(o) : findCommonOffsetParent(o, getReferenceNode(i));
  if (E === "viewport")
    t = getViewportOffsetRectRelativeToArtbitraryNode(n, e);
  else {
    var h = void 0;
    E === "scrollParent" ? (h = getScrollParent(getParentNode$1(i)), h.nodeName === "BODY" && (h = o.ownerDocument.documentElement)) : E === "window" ? h = o.ownerDocument.documentElement : h = E;
    var d = getOffsetRectRelativeToArbitraryNode(h, n, e);
    if (h.nodeName === "HTML" && !isFixed$1(n)) {
      var k = getWindowSizes(o.ownerDocument), p = k.height, M = k.width;
      t.top += d.top - d.marginTop, t.bottom = p + d.top, t.left += d.left - d.marginLeft, t.right = M + d.left;
    } else
      t = d;
  }
  g = g || 0;
  var H = typeof g == "number";
  return t.left += H ? g : g.left || 0, t.top += H ? g : g.top || 0, t.right -= H ? g : g.right || 0, t.bottom -= H ? g : g.bottom || 0, t;
}
function getArea(o) {
  var i = o.width, g = o.height;
  return i * g;
}
function computeAutoPlacement(o, i, g, E, e) {
  var t = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (o.indexOf("auto") === -1)
    return o;
  var n = getBoundaries(g, E, t, e), h = {
    top: {
      width: n.width,
      height: i.top - n.top
    },
    right: {
      width: n.right - i.right,
      height: n.height
    },
    bottom: {
      width: n.width,
      height: n.bottom - i.bottom
    },
    left: {
      width: i.left - n.left,
      height: n.height
    }
  }, d = Object.keys(h).map(function(H) {
    return _extends$w({
      key: H
    }, h[H], {
      area: getArea(h[H])
    });
  }).sort(function(H, f) {
    return f.area - H.area;
  }), k = d.filter(function(H) {
    var f = H.width, AA = H.height;
    return f >= g.clientWidth && AA >= g.clientHeight;
  }), p = k.length > 0 ? k[0].key : d[0].key, M = o.split("-")[1];
  return p + (M ? "-" + M : "");
}
function getReferenceOffsets(o, i, g) {
  var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, e = E ? getFixedPositionOffsetParent(i) : findCommonOffsetParent(i, getReferenceNode(g));
  return getOffsetRectRelativeToArbitraryNode(g, e, E);
}
function getOuterSizes(o) {
  var i = o.ownerDocument.defaultView, g = i.getComputedStyle(o), E = parseFloat(g.marginTop || 0) + parseFloat(g.marginBottom || 0), e = parseFloat(g.marginLeft || 0) + parseFloat(g.marginRight || 0), t = {
    width: o.offsetWidth + e,
    height: o.offsetHeight + E
  };
  return t;
}
function getOppositePlacement(o) {
  var i = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return o.replace(/left|right|bottom|top/g, function(g) {
    return i[g];
  });
}
function getPopperOffsets(o, i, g) {
  g = g.split("-")[0];
  var E = getOuterSizes(o), e = {
    width: E.width,
    height: E.height
  }, t = ["right", "left"].indexOf(g) !== -1, n = t ? "top" : "left", h = t ? "left" : "top", d = t ? "height" : "width", k = t ? "width" : "height";
  return e[n] = i[n] + i[d] / 2 - E[d] / 2, g === h ? e[h] = i[h] - E[k] : e[h] = i[getOppositePlacement(h)], e;
}
function find$2(o, i) {
  return Array.prototype.find ? o.find(i) : o.filter(i)[0];
}
function findIndex$1(o, i, g) {
  if (Array.prototype.findIndex)
    return o.findIndex(function(e) {
      return e[i] === g;
    });
  var E = find$2(o, function(e) {
    return e[i] === g;
  });
  return o.indexOf(E);
}
function runModifiers(o, i, g) {
  var E = g === void 0 ? o : o.slice(0, findIndex$1(o, "name", g));
  return E.forEach(function(e) {
    e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var t = e.function || e.fn;
    e.enabled && isFunction$1(t) && (i.offsets.popper = getClientRect(i.offsets.popper), i.offsets.reference = getClientRect(i.offsets.reference), i = t(i, e));
  }), i;
}
function update() {
  if (!this.state.isDestroyed) {
    var o = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    o.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed), o.placement = computeAutoPlacement(this.options.placement, o.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), o.originalPlacement = o.placement, o.positionFixed = this.options.positionFixed, o.offsets.popper = getPopperOffsets(this.popper, o.offsets.reference, o.placement), o.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", o = runModifiers(this.modifiers, o), this.state.isCreated ? this.options.onUpdate(o) : (this.state.isCreated = !0, this.options.onCreate(o));
  }
}
function isModifierEnabled(o, i) {
  return o.some(function(g) {
    var E = g.name, e = g.enabled;
    return e && E === i;
  });
}
function getSupportedPropertyName(o) {
  for (var i = [!1, "ms", "Webkit", "Moz", "O"], g = o.charAt(0).toUpperCase() + o.slice(1), E = 0; E < i.length; E++) {
    var e = i[E], t = e ? "" + e + g : o;
    if (typeof document.body.style[t] < "u")
      return t;
  }
  return null;
}
function destroy() {
  return this.state.isDestroyed = !0, isModifierEnabled(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[getSupportedPropertyName("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function getWindow(o) {
  var i = o.ownerDocument;
  return i ? i.defaultView : window;
}
function attachToScrollParents(o, i, g, E) {
  var e = o.nodeName === "BODY", t = e ? o.ownerDocument.defaultView : o;
  t.addEventListener(i, g, { passive: !0 }), e || attachToScrollParents(getScrollParent(t.parentNode), i, g, E), E.push(t);
}
function setupEventListeners(o, i, g, E) {
  g.updateBound = E, getWindow(o).addEventListener("resize", g.updateBound, { passive: !0 });
  var e = getScrollParent(o);
  return attachToScrollParents(e, "scroll", g.updateBound, g.scrollParents), g.scrollElement = e, g.eventsEnabled = !0, g;
}
function enableEventListeners() {
  this.state.eventsEnabled || (this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate));
}
function removeEventListeners(o, i) {
  return getWindow(o).removeEventListener("resize", i.updateBound), i.scrollParents.forEach(function(g) {
    g.removeEventListener("scroll", i.updateBound);
  }), i.updateBound = null, i.scrollParents = [], i.scrollElement = null, i.eventsEnabled = !1, i;
}
function disableEventListeners() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = removeEventListeners(this.reference, this.state));
}
function isNumeric(o) {
  return o !== "" && !isNaN(parseFloat(o)) && isFinite(o);
}
function setStyles(o, i) {
  Object.keys(i).forEach(function(g) {
    var E = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(g) !== -1 && isNumeric(i[g]) && (E = "px"), o.style[g] = i[g] + E;
  });
}
function setAttributes(o, i) {
  Object.keys(i).forEach(function(g) {
    var E = i[g];
    E !== !1 ? o.setAttribute(g, i[g]) : o.removeAttribute(g);
  });
}
function applyStyle(o) {
  return setStyles(o.instance.popper, o.styles), setAttributes(o.instance.popper, o.attributes), o.arrowElement && Object.keys(o.arrowStyles).length && setStyles(o.arrowElement, o.arrowStyles), o;
}
function applyStyleOnLoad(o, i, g, E, e) {
  var t = getReferenceOffsets(e, i, o, g.positionFixed), n = computeAutoPlacement(g.placement, t, i, o, g.modifiers.flip.boundariesElement, g.modifiers.flip.padding);
  return i.setAttribute("x-placement", n), setStyles(i, { position: g.positionFixed ? "fixed" : "absolute" }), g;
}
function getRoundedOffsets(o, i) {
  var g = o.offsets, E = g.popper, e = g.reference, t = Math.round, n = Math.floor, h = function(BA) {
    return BA;
  }, d = t(e.width), k = t(E.width), p = ["left", "right"].indexOf(o.placement) !== -1, M = o.placement.indexOf("-") !== -1, H = d % 2 === k % 2, f = d % 2 === 1 && k % 2 === 1, AA = i ? p || M || H ? t : n : h, gA = i ? t : h;
  return {
    left: AA(f && !M && i ? E.left - 1 : E.left),
    top: gA(E.top),
    bottom: gA(E.bottom),
    right: AA(E.right)
  };
}
var isFirefox = isBrowser$1 && /Firefox/i.test(navigator.userAgent);
function computeStyle(o, i) {
  var g = i.x, E = i.y, e = o.offsets.popper, t = find$2(o.instance.modifiers, function(QA) {
    return QA.name === "applyStyle";
  }).gpuAcceleration;
  t !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var n = t !== void 0 ? t : i.gpuAcceleration, h = getOffsetParent(o.instance.popper), d = getBoundingClientRect(h), k = {
    position: e.position
  }, p = getRoundedOffsets(o, window.devicePixelRatio < 2 || !isFirefox), M = g === "bottom" ? "top" : "bottom", H = E === "right" ? "left" : "right", f = getSupportedPropertyName("transform"), AA = void 0, gA = void 0;
  if (M === "bottom" ? h.nodeName === "HTML" ? gA = -h.clientHeight + p.bottom : gA = -d.height + p.bottom : gA = p.top, H === "right" ? h.nodeName === "HTML" ? AA = -h.clientWidth + p.right : AA = -d.width + p.right : AA = p.left, n && f)
    k[f] = "translate3d(" + AA + "px, " + gA + "px, 0)", k[M] = 0, k[H] = 0, k.willChange = "transform";
  else {
    var IA = M === "bottom" ? -1 : 1, BA = H === "right" ? -1 : 1;
    k[M] = gA * IA, k[H] = AA * BA, k.willChange = M + ", " + H;
  }
  var CA = {
    "x-placement": o.placement
  };
  return o.attributes = _extends$w({}, CA, o.attributes), o.styles = _extends$w({}, k, o.styles), o.arrowStyles = _extends$w({}, o.offsets.arrow, o.arrowStyles), o;
}
function isModifierRequired(o, i, g) {
  var E = find$2(o, function(h) {
    var d = h.name;
    return d === i;
  }), e = !!E && o.some(function(h) {
    return h.name === g && h.enabled && h.order < E.order;
  });
  if (!e) {
    var t = "`" + i + "`", n = "`" + g + "`";
    console.warn(n + " modifier is required by " + t + " modifier in order to work, be sure to include it before " + t + "!");
  }
  return e;
}
function arrow(o, i) {
  var g;
  if (!isModifierRequired(o.instance.modifiers, "arrow", "keepTogether"))
    return o;
  var E = i.element;
  if (typeof E == "string") {
    if (E = o.instance.popper.querySelector(E), !E)
      return o;
  } else if (!o.instance.popper.contains(E))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), o;
  var e = o.placement.split("-")[0], t = o.offsets, n = t.popper, h = t.reference, d = ["left", "right"].indexOf(e) !== -1, k = d ? "height" : "width", p = d ? "Top" : "Left", M = p.toLowerCase(), H = d ? "left" : "top", f = d ? "bottom" : "right", AA = getOuterSizes(E)[k];
  h[f] - AA < n[M] && (o.offsets.popper[M] -= n[M] - (h[f] - AA)), h[M] + AA > n[f] && (o.offsets.popper[M] += h[M] + AA - n[f]), o.offsets.popper = getClientRect(o.offsets.popper);
  var gA = h[M] + h[k] / 2 - AA / 2, IA = getStyleComputedProperty(o.instance.popper), BA = parseFloat(IA["margin" + p]), CA = parseFloat(IA["border" + p + "Width"]), QA = gA - o.offsets.popper[M] - BA - CA;
  return QA = Math.max(Math.min(n[k] - AA, QA), 0), o.arrowElement = E, o.offsets.arrow = (g = {}, defineProperty(g, M, Math.round(QA)), defineProperty(g, H, ""), g), o;
}
function getOppositeVariation(o) {
  return o === "end" ? "start" : o === "start" ? "end" : o;
}
var placements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], validPlacements = placements.slice(3);
function clockwise(o) {
  var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = validPlacements.indexOf(o), E = validPlacements.slice(g + 1).concat(validPlacements.slice(0, g));
  return i ? E.reverse() : E;
}
var BEHAVIORS = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function flip(o, i) {
  if (isModifierEnabled(o.instance.modifiers, "inner") || o.flipped && o.placement === o.originalPlacement)
    return o;
  var g = getBoundaries(o.instance.popper, o.instance.reference, i.padding, i.boundariesElement, o.positionFixed), E = o.placement.split("-")[0], e = getOppositePlacement(E), t = o.placement.split("-")[1] || "", n = [];
  switch (i.behavior) {
    case BEHAVIORS.FLIP:
      n = [E, e];
      break;
    case BEHAVIORS.CLOCKWISE:
      n = clockwise(E);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      n = clockwise(E, !0);
      break;
    default:
      n = i.behavior;
  }
  return n.forEach(function(h, d) {
    if (E !== h || n.length === d + 1)
      return o;
    E = o.placement.split("-")[0], e = getOppositePlacement(E);
    var k = o.offsets.popper, p = o.offsets.reference, M = Math.floor, H = E === "left" && M(k.right) > M(p.left) || E === "right" && M(k.left) < M(p.right) || E === "top" && M(k.bottom) > M(p.top) || E === "bottom" && M(k.top) < M(p.bottom), f = M(k.left) < M(g.left), AA = M(k.right) > M(g.right), gA = M(k.top) < M(g.top), IA = M(k.bottom) > M(g.bottom), BA = E === "left" && f || E === "right" && AA || E === "top" && gA || E === "bottom" && IA, CA = ["top", "bottom"].indexOf(E) !== -1, QA = !!i.flipVariations && (CA && t === "start" && f || CA && t === "end" && AA || !CA && t === "start" && gA || !CA && t === "end" && IA), iA = !!i.flipVariationsByContent && (CA && t === "start" && AA || CA && t === "end" && f || !CA && t === "start" && IA || !CA && t === "end" && gA), EA = QA || iA;
    (H || BA || EA) && (o.flipped = !0, (H || BA) && (E = n[d + 1]), EA && (t = getOppositeVariation(t)), o.placement = E + (t ? "-" + t : ""), o.offsets.popper = _extends$w({}, o.offsets.popper, getPopperOffsets(o.instance.popper, o.offsets.reference, o.placement)), o = runModifiers(o.instance.modifiers, o, "flip"));
  }), o;
}
function keepTogether(o) {
  var i = o.offsets, g = i.popper, E = i.reference, e = o.placement.split("-")[0], t = Math.floor, n = ["top", "bottom"].indexOf(e) !== -1, h = n ? "right" : "bottom", d = n ? "left" : "top", k = n ? "width" : "height";
  return g[h] < t(E[d]) && (o.offsets.popper[d] = t(E[d]) - g[k]), g[d] > t(E[h]) && (o.offsets.popper[d] = t(E[h])), o;
}
function toValue(o, i, g, E) {
  var e = o.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), t = +e[1], n = e[2];
  if (!t)
    return o;
  if (n.indexOf("%") === 0) {
    var h = void 0;
    switch (n) {
      case "%p":
        h = g;
        break;
      case "%":
      case "%r":
      default:
        h = E;
    }
    var d = getClientRect(h);
    return d[i] / 100 * t;
  } else if (n === "vh" || n === "vw") {
    var k = void 0;
    return n === "vh" ? k = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : k = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), k / 100 * t;
  } else
    return t;
}
function parseOffset(o, i, g, E) {
  var e = [0, 0], t = ["right", "left"].indexOf(E) !== -1, n = o.split(/(\+|\-)/).map(function(p) {
    return p.trim();
  }), h = n.indexOf(find$2(n, function(p) {
    return p.search(/,|\s/) !== -1;
  }));
  n[h] && n[h].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var d = /\s*,\s*|\s+/, k = h !== -1 ? [n.slice(0, h).concat([n[h].split(d)[0]]), [n[h].split(d)[1]].concat(n.slice(h + 1))] : [n];
  return k = k.map(function(p, M) {
    var H = (M === 1 ? !t : t) ? "height" : "width", f = !1;
    return p.reduce(function(AA, gA) {
      return AA[AA.length - 1] === "" && ["+", "-"].indexOf(gA) !== -1 ? (AA[AA.length - 1] = gA, f = !0, AA) : f ? (AA[AA.length - 1] += gA, f = !1, AA) : AA.concat(gA);
    }, []).map(function(AA) {
      return toValue(AA, H, i, g);
    });
  }), k.forEach(function(p, M) {
    p.forEach(function(H, f) {
      isNumeric(H) && (e[M] += H * (p[f - 1] === "-" ? -1 : 1));
    });
  }), e;
}
function offset(o, i) {
  var g = i.offset, E = o.placement, e = o.offsets, t = e.popper, n = e.reference, h = E.split("-")[0], d = void 0;
  return isNumeric(+g) ? d = [+g, 0] : d = parseOffset(g, t, n, h), h === "left" ? (t.top += d[0], t.left -= d[1]) : h === "right" ? (t.top += d[0], t.left += d[1]) : h === "top" ? (t.left += d[0], t.top -= d[1]) : h === "bottom" && (t.left += d[0], t.top += d[1]), o.popper = t, o;
}
function preventOverflow(o, i) {
  var g = i.boundariesElement || getOffsetParent(o.instance.popper);
  o.instance.reference === g && (g = getOffsetParent(g));
  var E = getSupportedPropertyName("transform"), e = o.instance.popper.style, t = e.top, n = e.left, h = e[E];
  e.top = "", e.left = "", e[E] = "";
  var d = getBoundaries(o.instance.popper, o.instance.reference, i.padding, g, o.positionFixed);
  e.top = t, e.left = n, e[E] = h, i.boundaries = d;
  var k = i.priority, p = o.offsets.popper, M = {
    primary: function(f) {
      var AA = p[f];
      return p[f] < d[f] && !i.escapeWithReference && (AA = Math.max(p[f], d[f])), defineProperty({}, f, AA);
    },
    secondary: function(f) {
      var AA = f === "right" ? "left" : "top", gA = p[AA];
      return p[f] > d[f] && !i.escapeWithReference && (gA = Math.min(p[AA], d[f] - (f === "right" ? p.width : p.height))), defineProperty({}, AA, gA);
    }
  };
  return k.forEach(function(H) {
    var f = ["left", "top"].indexOf(H) !== -1 ? "primary" : "secondary";
    p = _extends$w({}, p, M[f](H));
  }), o.offsets.popper = p, o;
}
function shift(o) {
  var i = o.placement, g = i.split("-")[0], E = i.split("-")[1];
  if (E) {
    var e = o.offsets, t = e.reference, n = e.popper, h = ["bottom", "top"].indexOf(g) !== -1, d = h ? "left" : "top", k = h ? "width" : "height", p = {
      start: defineProperty({}, d, t[d]),
      end: defineProperty({}, d, t[d] + t[k] - n[k])
    };
    o.offsets.popper = _extends$w({}, n, p[E]);
  }
  return o;
}
function hide(o) {
  if (!isModifierRequired(o.instance.modifiers, "hide", "preventOverflow"))
    return o;
  var i = o.offsets.reference, g = find$2(o.instance.modifiers, function(E) {
    return E.name === "preventOverflow";
  }).boundaries;
  if (i.bottom < g.top || i.left > g.right || i.top > g.bottom || i.right < g.left) {
    if (o.hide === !0)
      return o;
    o.hide = !0, o.attributes["x-out-of-boundaries"] = "";
  } else {
    if (o.hide === !1)
      return o;
    o.hide = !1, o.attributes["x-out-of-boundaries"] = !1;
  }
  return o;
}
function inner(o) {
  var i = o.placement, g = i.split("-")[0], E = o.offsets, e = E.popper, t = E.reference, n = ["left", "right"].indexOf(g) !== -1, h = ["top", "left"].indexOf(g) === -1;
  return e[n ? "left" : "top"] = t[g] - (h ? e[n ? "width" : "height"] : 0), o.placement = getOppositePlacement(i), o.offsets.popper = getClientRect(e), o;
}
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function o() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function o() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers
}, Popper = (function() {
  function o(i, g) {
    var E = this, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    classCallCheck(this, o), this.scheduleUpdate = function() {
      return requestAnimationFrame(E.update);
    }, this.update = debounce$1(this.update.bind(this)), this.options = _extends$w({}, o.Defaults, e), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = i && i.jquery ? i[0] : i, this.popper = g && g.jquery ? g[0] : g, this.options.modifiers = {}, Object.keys(_extends$w({}, o.Defaults.modifiers, e.modifiers)).forEach(function(n) {
      E.options.modifiers[n] = _extends$w({}, o.Defaults.modifiers[n] || {}, e.modifiers ? e.modifiers[n] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(n) {
      return _extends$w({
        name: n
      }, E.options.modifiers[n]);
    }).sort(function(n, h) {
      return n.order - h.order;
    }), this.modifiers.forEach(function(n) {
      n.enabled && isFunction$1(n.onLoad) && n.onLoad(E.reference, E.popper, E.options, n, E.state);
    }), this.update();
    var t = this.options.eventsEnabled;
    t && this.enableEventListeners(), this.state.eventsEnabled = t;
  }
  return createClass(o, [{
    key: "update",
    value: function() {
      return update.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return destroy.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return enableEventListeners.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), o;
})();
Popper.Utils = (typeof window < "u" ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
function toPopperPlacement(o) {
  return o.replace(/(Top|Left)$/, "-start").replace(/(Right|Bottom)$/, "-end");
}
function parsePopperOffset(o) {
  return {
    top: Math.floor(o.top || 0),
    left: Math.floor(o.left || 0)
  };
}
var TETHER_PLACEMENT = {
  auto: "auto"
};
function _typeof$h(o) {
  "@babel/helpers - typeof";
  return _typeof$h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$h(o);
}
var _excluded$p = ["modifiers"];
function ownKeys$q(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$o(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$q(Object(g), !0).forEach(function(E) {
      _defineProperty$v(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$q(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _objectWithoutProperties$r(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$r(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$r(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _classCallCheck$e(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$e(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$e(o, i, g) {
  return i && _defineProperties$e(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$e(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$f(o, i);
}
function _setPrototypeOf$f(o, i) {
  return _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$f(o, i);
}
function _createSuper$e(o) {
  var i = _isNativeReflectConstruct$e();
  return function() {
    var E = _getPrototypeOf$e(o), e;
    if (i) {
      var t = _getPrototypeOf$e(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$e(this, e);
  };
}
function _possibleConstructorReturn$e(o, i) {
  if (i && (_typeof$h(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$f(o);
}
function _assertThisInitialized$f(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$e(o) {
  return _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$e(o);
}
function _defineProperty$v(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var Tether = /* @__PURE__ */ (function(o) {
  _inherits$e(g, o);
  var i = _createSuper$e(g);
  function g() {
    var E;
    _classCallCheck$e(this, g);
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = i.call.apply(i, [this].concat(t)), _defineProperty$v(_assertThisInitialized$f(E), "popper", void 0), _defineProperty$v(_assertThisInitialized$f(E), "popperHeight", 0), _defineProperty$v(_assertThisInitialized$f(E), "popperWidth", 0), _defineProperty$v(_assertThisInitialized$f(E), "anchorHeight", 0), _defineProperty$v(_assertThisInitialized$f(E), "anchorWidth", 0), _defineProperty$v(_assertThisInitialized$f(E), "state", {
      isMounted: !1
    }), _defineProperty$v(_assertThisInitialized$f(E), "onPopperUpdate", function(h) {
      var d = {
        popper: parsePopperOffset(h.offsets.popper),
        arrow: h.offsets.arrow ? parsePopperOffset(h.offsets.arrow) : {
          top: 0,
          left: 0
        }
      };
      E.props.onPopperUpdate(d, h);
    }), E;
  }
  return _createClass$e(g, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      if (this.props.anchorRef) {
        var n = this.props.anchorRef.getBoundingClientRect(), h = n.height, d = n.width;
        (this.anchorHeight !== h || this.anchorWidth !== d) && (this.anchorHeight = h, this.anchorWidth = d, this.popper && this.popper.scheduleUpdate());
      }
      if (this.props.popperRef) {
        var k = this.props.popperRef.getBoundingClientRect(), p = k.height, M = k.width;
        (this.popperHeight !== p || this.popperWidth !== M) && (this.popperHeight = p, this.popperWidth = M, this.popper && this.popper.scheduleUpdate()), this.state.isMounted !== t.isMounted && (this.props.anchorRef ? this.initializePopper() : process.env.NODE_ENV !== "production" && console.warn(`[baseui][TetherBehavior] ref has not been passed to the Popper's anchor element.
              See how to pass the ref to an anchor element in the Popover example
              https://baseweb.design/components/popover/#anchor-ref-handling-example`));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyPopover();
    }
  }, {
    key: "initializePopper",
    value: function() {
      var e = this.props, t = e.placement, n = e.popperOptions, h = n.modifiers, d = _objectWithoutProperties$r(n, _excluded$p);
      !this.props.anchorRef || !this.props.popperRef || (this.popper = new Popper(this.props.anchorRef, this.props.popperRef, _objectSpread$o({
        // Recommended placement (popper may ignore if it causes a viewport overflow, etc)
        placement: toPopperPlacement(t),
        modifiers: _objectSpread$o({
          // Passing the arrow ref will measure the arrow when calculating styles
          arrow: {
            element: this.props.arrowRef,
            enabled: !!this.props.arrowRef
          },
          computeStyle: {
            // Make popper use top/left instead of transform translate, this is because
            // we use transform for animations and we dont want them to conflict
            gpuAcceleration: !1
          },
          applyStyle: {
            // Disable default styling modifier, we'll apply styles on our own
            enabled: !1
          },
          applyReactStyle: {
            enabled: !0,
            fn: this.onPopperUpdate,
            order: 900
          },
          preventOverflow: {
            enabled: !0
          }
        }, h)
      }, d)));
    }
  }, {
    key: "destroyPopover",
    value: function() {
      this.popper && (this.popper.destroy(), delete this.popper);
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children || null;
    }
  }]), g;
})(React.Component);
_defineProperty$v(Tether, "defaultProps", {
  anchorRef: null,
  onPopperUpdate: function o() {
    return null;
  },
  placement: TETHER_PLACEMENT.auto,
  popperRef: null,
  popperOptions: {}
});
var BaseProvider = function o(i) {
  var g = i.children, E = i.overrides, e = i.theme, t = i.zIndex;
  return /* @__PURE__ */ React.createElement(LayersManager, {
    zIndex: t,
    overrides: E
  }, /* @__PURE__ */ React.createElement(UIDReset, {
    prefix: "bui"
  }, /* @__PURE__ */ React.createElement(ThemeProvider$1, {
    theme: e
  }, g)));
};
const createBaseUiThemePrimitives = (o, i) => {
  const {
    colors: g,
    genericFonts: E
  } = i;
  return {
    ...o,
    primaryFontFamily: E.bodyFont,
    primary100: g.primary,
    primary200: g.primary,
    primary300: g.primary,
    primary400: g.primary,
    primary500: g.primary,
    primary600: g.primary,
    primary700: g.primary,
    // Override gray values based on what is actually used in BaseWeb, and the
    // way we want it to match our theme originating from Bootstrap.
    mono100: g.bgColor,
    // Popup menu
    mono200: g.secondaryBg,
    // Text input, text area, selectbox
    mono300: g.gray30,
    // Disabled widget background
    mono400: g.gray30,
    // Slider track
    mono500: g.gray60,
    // Clicked checkbox and radio
    mono600: g.fadedText40,
    // Disabled widget text
    mono700: g.gray60,
    // Unselected checkbox and radio
    mono800: g.bodyText,
    // Selectbox text
    mono900: g.bodyText,
    // Not used, but just in case.
    mono1000: g.black
  };
}, createBaseUiThemeOverrides = (o) => {
  const {
    inSidebar: i,
    colors: g,
    genericFonts: E,
    fontSizes: e,
    lineHeights: t,
    radii: n
  } = o, h = {
    fontFamily: E.bodyFont,
    fontSize: e.md,
    fontSizeSm: e.sm,
    fontWeight: "normal",
    lineHeight: t.base,
    lineHeightTight: t.tight
  }, d = g.secondaryBg, k = i ? g.secondaryBg : g.bgColor, p = i ? g.bgColor : g.secondaryBg;
  return {
    borders: {
      // Override borders that are declared from literals in
      // https://github.com/uber/baseweb/blob/master/src/themes/shared/borders.ts
      radius100: n.default,
      radius200: n.default,
      radius300: n.default,
      radius400: n.default,
      radius500: n.default,
      /** Datepicker (Range), Progress Bar, Slider, Tag */
      useRoundedCorners: !0,
      /** Button, ButtonGroup */
      buttonBorderRadiusMini: n.md,
      // Unused today.
      buttonBorderRadius: n.default,
      /** Checkbox */
      checkboxBorderRadius: `min(${n.md}, ${n.maxCheckbox})`,
      /** Input, Select, Textarea */
      inputBorderRadiusMini: n.md,
      // Unused today.
      inputBorderRadius: n.default,
      /** Popover, Menu, Tooltip */
      popoverBorderRadius: n.default,
      /** Card, Datepicker, Modal, Toast, Notification */
      surfaceBorderRadius: n.default,
      /** Tag */
      tagBorderRadius: n.md
    },
    typography: {
      // Here we override some fonts that are used in widgets. We don't care
      // about the ones that are not used.
      font100: {},
      font150: {
        ...h
      },
      // Popup menus
      font200: {},
      font250: {},
      font300: {
        ...h
      },
      // Popup menus
      font350: {
        ...h
      },
      // Checkbox
      font400: {
        ...h
      },
      // Textinput, textarea, selectboxes
      font450: {
        ...h
      },
      // Radio
      font460: {
        ...h
      },
      // Calendar header buttons
      font470: {
        ...h
      },
      // Button
      font500: {
        ...h
      },
      // Selected items in selectbox
      font600: {},
      LabelXSmall: {
        ...h
      },
      LabelSmall: {
        ...h
      },
      LabelMedium: {
        ...h
      },
      LabelLarge: {
        ...h
      },
      ParagraphSmall: {
        ...h
      }
    },
    colors: {
      white: g.white,
      black: g.black,
      primary: g.primary,
      primaryA: g.primary,
      backgroundPrimary: g.bgColor,
      backgroundSecondary: d,
      backgroundTertiary: g.bgColor,
      borderOpaque: g.darkenedBgMix25,
      accent: transparentize(g.primary, 0.5),
      tagPrimarySolidBackground: g.primary,
      tagPrimaryFontDisabled: g.fadedText40,
      tagPrimaryOutlinedDisabled: g.transparent,
      borderSelected: g.primary,
      contentPrimary: g.bodyText,
      inputPlaceholder: g.fadedText60,
      tickFillDisabled: g.fadedText40,
      tickMarkFill: g.gray20,
      tickFillSelected: g.primary,
      datepickerBackground: k,
      calendarBackground: k,
      calendarForeground: g.bodyText,
      calendarDayForegroundPseudoSelected: g.bodyText,
      calendarHeaderBackground: p,
      calendarHeaderBackgroundActive: p,
      calendarHeaderForeground: g.bodyText,
      calendarHeaderForegroundDisabled: g.gray40,
      calendarDayBackgroundSelected: g.primary,
      calendarDayBackgroundSelectedHighlighted: g.primary,
      calendarDayForegroundSelected: g.white,
      calendarDayForegroundSelectedHighlighted: g.white,
      calendarDayForegroundPseudoSelectedHighlighted: g.bodyText,
      menuFontHighlighted: g.bodyText,
      menuFontSelected: g.bodyText,
      modalCloseColor: g.bodyText,
      notificationInfoBackground: g.blueBackgroundColor,
      notificationInfoText: g.blueTextColor,
      notificationPositiveBackground: g.greenBackgroundColor,
      notificationPositiveText: g.greenTextColor,
      notificationWarningBackground: g.yellowBackgroundColor,
      notificationWarningText: g.yellowTextColor,
      notificationNegativeBackground: g.redBackgroundColor,
      notificationNegativeText: g.redTextColor,
      progressbarTrackFill: d,
      // mono100 overrides
      tickFill: g.lightenedBg05,
      // Checkbox and Radio
      tickMarkFillDisabled: g.lightenedBg05,
      // We want menuFill to always use bgColor. But when in sidebar, bgColor and secondaryBg are
      // swapped! So here we unswap them.
      menuFill: k,
      // mono200 overrides
      buttonDisabledFill: g.lightenedBg05,
      tickFillHover: d,
      inputFillDisabled: d,
      inputFillActive: d,
      // mono300 overrides
      toggleTrackFillDisabled: d,
      tickFillActive: d,
      sliderTrackFillDisabled: d,
      inputBorder: g.widgetBorderColor || d,
      inputFill: d,
      inputEnhanceFill: d,
      inputEnhancerFillDisabled: d,
      // mono400 overrides
      buttonDisabledSpinnerBackground: g.gray40,
      toggleTrackFill: g.gray40,
      sliderTrackFill: g.gray40,
      sliderHandleInnerFill: g.gray40,
      sliderHandleInnerFillDisabled: g.gray40
    }
  };
}, createBaseUiTheme = (o, i = primitives) => createLightTheme(createBaseUiThemePrimitives(i, o), createBaseUiThemeOverrides(o)), computeDerivedColors = (o) => {
  const {
    bodyText: i,
    secondaryBg: g,
    bgColor: E
  } = o, e = getLuminance(E) > 0.5, t = transparentize(i, 0.9), n = transparentize(i, 0.8), h = transparentize(i, 0.7), d = transparentize(i, 0.6), k = transparentize(i, 0.4), p = mix$1(E, g, 0.5), M = e ? darken(p, 0.3) : lighten(p, 0.6), H = transparentize(M, 0.75), f = transparentize(M, 0.85), AA = lighten(E, 0.025);
  return {
    fadedText05: t,
    fadedText10: n,
    fadedText20: h,
    fadedText40: d,
    fadedText60: k,
    bgMix: p,
    darkenedBgMix100: M,
    darkenedBgMix25: H,
    darkenedBgMix15: f,
    lightenedBg05: AA
  };
};
function _isLightBackground(o) {
  return getLuminance(o) > 0.5;
}
function hasLightBackgroundColor(o) {
  return _isLightBackground(o.colors.bgColor);
}
const createEmotionColors = (o) => {
  const i = computeDerivedColors(o), g = defaultCategoricalColorsArray(o), E = defaultSequentialColorsArray(o), e = defaultDivergingColorsArray(o);
  return {
    ...o,
    ...i,
    link: o.blueTextColor,
    codeTextColor: o.greenTextColor,
    codeBackgroundColor: i.bgMix,
    borderColor: i.fadedText10,
    borderColorLight: i.fadedText05,
    dataframeBorderColor: i.fadedText05,
    dataframeHeaderBackgroundColor: i.bgMix,
    headingColor: o.bodyText,
    chartCategoricalColors: g,
    chartSequentialColors: E,
    chartDivergingColors: e
  };
};
function getDividerColors(o) {
  const {
    redColor: i,
    orangeColor: g,
    yellowColor: E,
    blueColor: e,
    greenColor: t,
    violetColor: n,
    grayColor: h
  } = o.colors;
  return {
    red: i,
    orange: g,
    yellow: E,
    blue: e,
    green: t,
    violet: n,
    gray: h,
    grey: h,
    rainbow: `linear-gradient(to right, ${i}, ${g}, ${E}, ${t}, ${e}, ${n})`
  };
}
function getMarkdownBgColors(o) {
  const i = hasLightBackgroundColor(o), g = o.colors;
  return {
    redbg: g.redBackgroundColor,
    orangebg: g.orangeBackgroundColor,
    yellowbg: g.yellowBackgroundColor,
    bluebg: g.blueBackgroundColor,
    greenbg: g.greenBackgroundColor,
    violetbg: g.violetBackgroundColor,
    purplebg: transparentize(g[i ? "purple90" : "purple80"], i ? 0.9 : 0.7),
    graybg: g.grayBackgroundColor,
    primarybg: transparentize(g.primary, i ? 0.9 : 0.7)
  };
}
function getMarkdownTextColors(o) {
  const i = hasLightBackgroundColor(o), g = o.colors, E = g.primary, e = g.redTextColor, t = g.orangeTextColor, n = g.yellowTextColor, h = g.blueTextColor, d = g.greenTextColor, k = g.violetTextColor, p = i ? g.purple100 : g.purple80, M = g.grayTextColor;
  return {
    red: e,
    orange: t,
    yellow: n,
    green: d,
    blue: h,
    violet: k,
    purple: p,
    gray: M,
    primary: E
  };
}
function getGray70(o) {
  return hasLightBackgroundColor(o) ? o.colors.gray70 : o.colors.gray30;
}
function getGray30(o) {
  return hasLightBackgroundColor(o) ? o.colors.gray30 : o.colors.gray85;
}
function getGray90(o) {
  return hasLightBackgroundColor(o) ? o.colors.gray90 : o.colors.gray10;
}
function getBlue80(o) {
  return hasLightBackgroundColor(o) ? o.colors.blue80 : o.colors.blue40;
}
function getBlueArrayAsc(o) {
  return [o.blue10, o.blue20, o.blue30, o.blue40, o.blue50, o.blue60, o.blue70, o.blue80, o.blue90, o.blue100];
}
function getBlueArrayDesc(o) {
  return [o.blue100, o.blue90, o.blue80, o.blue70, o.blue60, o.blue50, o.blue40, o.blue30, o.blue20, o.blue10];
}
function defaultDivergingColorsArray(o) {
  return [o.red100, o.red90, o.red70, o.red50, o.red30, o.blue30, o.blue50, o.blue70, o.blue90, o.blue100];
}
function defaultSequentialColorsArray(o) {
  return _isLightBackground(o.bgColor) ? getBlueArrayAsc(o) : getBlueArrayDesc(o);
}
function defaultCategoricalColorsArray(o) {
  return _isLightBackground(o.bgColor) ? [o.blue80, o.blue40, o.red80, o.red40, o.blueGreen80, o.green40, o.orange80, o.orange50, o.purple80, o.gray40] : [o.blue40, o.blue80, o.red40, o.red80, o.green40, o.blueGreen80, o.orange50, o.orange80, o.purple80, o.gray40];
}
function getDecreasingRed(o) {
  return hasLightBackgroundColor(o) ? o.colors.red80 : o.colors.red40;
}
function getIncreasingGreen(o) {
  return hasLightBackgroundColor(o) ? o.colors.blueGreen80 : o.colors.green40;
}
const elevationShadows$1 = {
  tooltip: "0px 1px 4px rgba(0, 0, 0, 0.16)",
  popover: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  toolbar: "1px 2px 8px rgba(0, 0, 0, 0.08)",
  sidebar: "-2rem 0 2rem 2rem rgba(0, 0, 0, 0.16)",
  none: "none"
}, elevationShadows = {
  tooltip: "0px 1px 4px rgba(0, 0, 0, 0.4)",
  popover: "0px 4px 16px rgba(0, 0, 0, 0.7)",
  toolbar: "1px 2px 8px rgba(0, 0, 0, 0.2)",
  sidebar: "-2rem 0 2rem 2rem rgba(0, 0, 0, 0.4)",
  none: "none"
}, sizes = {
  full: "100%",
  headerHeight: "3.75rem",
  // Old header height to avoid addtl cascading visual/snapshot changes
  fullScreenHeaderHeight: "2.875rem",
  sidebarTopSpace: "6rem",
  toastWidth: "21rem",
  // Use px here since we want to keep the width the same
  // regardless of the root font size.
  contentMaxWidth: "736px",
  maxChartTooltipWidth: "30rem",
  // Used for checkboxes, radio, and toggles:
  checkbox: "1rem",
  borderWidth: "1px",
  // Used for checkboxes/toggle
  smallElementHeight: "1.5rem",
  // min height used for most input widgets
  minElementHeight: "2.5rem",
  // min height for larger input widgets like text area and audio input
  largestElementHeight: "4.25rem",
  smallLogoHeight: "1.25rem",
  defaultLogoHeight: "1.5rem",
  largeLogoHeight: "2rem",
  sliderThumb: "0.75rem",
  wideSidePadding: "5rem",
  headerDecorationHeight: "0.125rem",
  appRunningMen: "1.6rem",
  appStatusMaxWidth: "20rem",
  spinnerSize: "1.375rem",
  spinnerThickness: "0.125rem",
  tabHeight: "2.5rem",
  // Min width used for popover and dialog:
  minPopupWidth: "20rem",
  maxTooltipHeight: "18.75rem",
  chatAvatarSize: "2rem",
  // Used for the clear icon used by some Input elements
  clearIconSize: "1.5em",
  numberInputControlsWidth: "2rem",
  emptyDropdownHeight: "5.625rem",
  dropdownItemHeight: "2.5rem",
  maxDropdownHeight: "18.75rem",
  appDefaultBottomPadding: "3.5rem",
  defaultMapHeight: "31.25rem",
  defaultChartHeight: "21.875rem",
  defaultChartWidth: "25rem",
  // The minimum width of the menu (used for the dataframe column menu)
  minMenuWidth: "8rem",
  minChatInputFileListHeight: "3rem",
  chatInputFileIconSize: "2.25rem",
  headerItemHeight: "1.75rem",
  headerRightContentMaxWidth: "12.5rem",
  chatInputTextareaMinHeight: "1.5rem",
  chatInputPrimaryButtonSize: "2rem",
  // Offset to vertically center button with textarea text in simple mode
  // (3px margin the bottom with flex-end to center by default but keep it at the bottom)
  chatInputButtonVerticalOffset: "0.1875rem",
  dialogLargeWidth: "80rem",
  defaultStrokeWidth: 2.25,
  metricStrokeWidth: 2,
  // Default for box-shadow focus ring width
  focusRingWidth: "0.2rem"
}, createShadows = (o) => {
  const g = getLuminance(o.bgColor) > 0.5 ? elevationShadows$1 : elevationShadows, E = sizes.focusRingWidth;
  return {
    ...g,
    // Primary focus ring - buttons, checkboxes, sliders, inputs
    focusRing: `0 0 0 ${E} ${transparentize(o.primary, 0.5)}`,
    // Subtle focus ring - CodeBlock copy button
    focusRingSubtle: `0 0 0 ${E} ${transparentize(o.darkenedBgMix25, 0.5)}`,
    // Solid outline focus ring - FileUploader dropzone
    focusRingOutline: `0 0 0 1px ${o.primary}`,
    // Muted focus ring - header link buttons
    focusRingMuted: `0 0 0 ${E} ${transparentize(o.gray90, 0.8)}`
  };
}, breakpoints = {
  // This value is used to determine whether we should hide/show the "Please enter to apply" in all widgets.
  hideWidgetDetails: "11.25rem",
  // 180px at 16px base
  // This value is used to determine whether we should hide/show the - and + buttons in st.number_input.
  hideNumberInputControls: "7.5rem",
  // 120px at 16px base
  sm: "576px",
  columns: "640px",
  md: "768px"
}, colors$2 = {
  transparent: "transparent",
  black: "#000000",
  white: "#ffffff",
  gray10: "#fafafa",
  gray20: "#f0f2f6",
  gray30: "#e6eaf1",
  gray40: "#d5dae5",
  gray50: "#bfc5d3",
  gray60: "#a3a8b8",
  gray70: "#808495",
  gray80: "#555867",
  gray85: "#31333F",
  gray90: "#262730",
  gray100: "#0e1117",
  red10: "#fff0f0",
  red20: "#ffdede",
  red30: "#ffc7c7",
  red40: "#ffabab",
  red50: "#ff8c8c",
  red60: "#ff6c6c",
  red70: "#ff4b4b",
  red80: "#ff2b2b",
  red90: "#bd4043",
  red100: "#7d353b",
  orange10: "#fffae8",
  orange20: "#fff6d0",
  orange30: "#ffecb0",
  orange40: "#ffe08e",
  orange50: "#ffd16a",
  orange60: "#ffbd45",
  orange70: "#ffa421",
  orange80: "#ff8700",
  orange90: "#ed6f13",
  orange95: "#e2660c",
  orange100: "#d95a00",
  yellow10: "#ffffe1",
  yellow20: "#ffffc2",
  yellow30: "#ffffa0",
  yellow40: "#ffff7d",
  yellow50: "#ffff59",
  yellow60: "#fff835",
  yellow65: "#ffff12",
  yellow70: "#ffe312",
  yellow80: "#faca2b",
  yellow90: "#edbb16",
  yellow100: "#dea816",
  yellow110: "#916e10",
  yellow115: "#926c05",
  green10: "#dffde9",
  green20: "#c0fcd3",
  green30: "#9ef6bb",
  green40: "#7defa1",
  green50: "#5ce488",
  green60: "#3dd56d",
  green70: "#21c354",
  green80: "#09ab3b",
  green90: "#158237",
  green100: "#177233",
  blueGreen10: "#dcfffb",
  blueGreen20: "#bafff7",
  blueGreen30: "#93ffee",
  blueGreen40: "#6bfde3",
  blueGreen50: "#45f4d5",
  blueGreen60: "#20e7c5",
  blueGreen70: "#00d4b1",
  blueGreen80: "#29b09d",
  blueGreen90: "#2c867c",
  blueGreen100: "#246e69",
  lightBlue10: "#e0feff",
  lightBlue20: "#bffdff",
  lightBlue30: "#9af8ff",
  lightBlue40: "#73efff",
  lightBlue50: "#4be4ff",
  lightBlue60: "#24d4ff",
  lightBlue70: "#00c0f2",
  lightBlue80: "#00a4d4",
  lightBlue90: "#0d8cb5",
  lightBlue100: "#15799e",
  blue10: "#e4f5ff",
  blue20: "#c7ebff",
  blue30: "#a6dcff",
  blue40: "#83c9ff",
  blue50: "#60b4ff",
  blue60: "#3d9df3",
  blue65: "#1c83ff",
  blue70: "#1c83e1",
  blue80: "#0068c9",
  blue90: "#0054a3",
  blue100: "#004280",
  purple10: "#f5ebff",
  purple20: "#ebd6ff",
  purple30: "#dbbbff",
  purple40: "#c89dff",
  purple50: "#b27eff",
  purple60: "#9a5dff",
  purple70: "#803df5",
  purple80: "#6d3fc0",
  purple90: "#583f84",
  purple100: "#3f3163"
}, iconSizes = {
  xs: "0.5rem",
  sm: "0.75rem",
  md: "0.9rem",
  base: "1rem",
  lg: "1.25rem",
  xl: "1.5rem",
  twoXL: "1.8rem",
  threeXL: "2.3rem"
}, radii = {
  md: "0.25rem",
  // This is the default radius used in most elements:
  default: "0.5rem",
  xl: "0.75rem",
  xxl: "1rem",
  // Radius specific to buttons (enables buttonRadius config):
  button: "0.5rem",
  // Chat input enforces a more rounded look:
  chatInput: "1.25rem",
  // Ensures that the element is fully rounded:
  full: "9999px",
  // The maximum radius for checkboxes to still be recognizable as a checkbox:
  maxCheckbox: "0.35rem"
}, spacing = {
  px: "1px",
  none: "0",
  threeXS: "0.125rem",
  // 2px
  twoXS: "0.25rem",
  // 4px
  xs: "0.375rem",
  // 6px
  sm: "0.5rem",
  // 8px
  md: "0.75rem",
  // 12px
  lg: "1rem",
  // 16px
  xl: "1.25rem",
  // 20px
  twoXL: "1.5rem",
  // 24px
  threeXL: "2rem",
  // 32px
  fourXL: "4rem",
  // 64px
  fiveXL: "6rem",
  // 96px
  sixXL: "8rem"
  // 128px
}, fonts = {
  sansSerif: '"Source Sans", sans-serif',
  monospace: '"Source Code Pro", monospace',
  serif: '"Source Serif", serif',
  materialIcons: "Material Symbols Rounded"
}, genericFonts = {
  bodyFont: fonts.sansSerif,
  codeFont: fonts.monospace,
  headingFont: fonts.sansSerif,
  iconFont: fonts.materialIcons
}, fontSizes = {
  // baseFontSize equals to md, but in pixels (this value can also be configured by the user)
  // The baseFontSize should only be used in global styles.
  baseFontSize: 16,
  twoSm: "0.75rem",
  sm: "0.875rem",
  md: "1rem",
  mdLg: "1.125rem",
  lg: "1.25rem",
  xl: "1.5rem",
  twoXL: "1.75rem",
  threeXL: "2.25rem",
  fourXL: "2.75rem",
  codeFontSize: "0.875rem",
  // Inline code font size as em value for proper scaling w/ headers, captions,
  // sidebar, etc.
  inlineCodeFontSize: "0.75em",
  // Header font sizes - unaffected by baseFontSize, configured via headingFontSizes
  h1FontSize: "2.75rem",
  h2FontSize: "2.25rem",
  h3FontSize: "1.75rem",
  h4FontSize: "1.5rem",
  h5FontSize: "1.25rem",
  h6FontSize: "1rem"
}, fontWeights = {
  normal: 400,
  semiBold: 500,
  bold: 600,
  extrabold: 700,
  // codeFontWeight separately configurable
  code: 400,
  codeBold: 600,
  codeExtraBold: 700,
  // baseFontWeight config does not affect headers
  // defaults set here for h1-h6
  h1FontWeight: 700,
  h2FontWeight: 600,
  h3FontWeight: 600,
  h4FontWeight: 600,
  h5FontWeight: 600,
  h6FontWeight: 600
}, lineHeights = {
  none: 1,
  headings: 1.2,
  tight: 1.25,
  inputWidget: 1.4,
  small: 1.5,
  base: 1.6,
  menuItem: 2
}, sidebar = 100, menuButton = sidebar + 10, balloons = 1e6, header = balloons - 10, bottom = sidebar - 1, sidebarMobile = balloons - 5, fullscreenWrapper = balloons + 50, headerDecoration = balloons - 1, popup = fullscreenWrapper + 10, tablePortal = fullscreenWrapper + 60, cacheSpinner = sidebar + 1, toast = popup + 1, zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  // this is used if we want to ensure that an element
  // is shown above the parent elements.
  priority: 1,
  sidebar,
  menuButton,
  balloons,
  header,
  sidebarMobile,
  popup,
  fullscreenWrapper,
  tablePortal,
  bottom,
  cacheSpinner,
  toast,
  headerDecoration
}, requiredThemeColors = {
  bgColor: colors$2.white,
  secondaryBg: colors$2.gray20,
  bodyText: colors$2.gray85,
  primary: colors$2.red70,
  secondary: colors$2.blue70,
  // Used in progress bar
  // Default main theme colors (light theme)
  redColor: colors$2.red70,
  orangeColor: colors$2.orange70,
  yellowColor: colors$2.yellow80,
  blueColor: colors$2.blue70,
  greenColor: colors$2.green70,
  violetColor: colors$2.purple70,
  grayColor: colors$2.gray60,
  // Default background theme colors (light theme)
  redBackgroundColor: transparentize(colors$2.red80, 0.9),
  orangeBackgroundColor: transparentize(colors$2.orange70, 0.9),
  yellowBackgroundColor: transparentize(colors$2.yellow65, 0.9),
  blueBackgroundColor: transparentize(colors$2.blue65, 0.9),
  greenBackgroundColor: transparentize(colors$2.green70, 0.9),
  violetBackgroundColor: transparentize(colors$2.purple60, 0.9),
  grayBackgroundColor: transparentize(colors$2.gray85, 0.9),
  // Default text theme colors (light theme)
  redTextColor: colors$2.red90,
  orangeTextColor: colors$2.orange95,
  yellowTextColor: colors$2.yellow115,
  blueTextColor: colors$2.blue90,
  greenTextColor: colors$2.green90,
  violetTextColor: colors$2.purple90,
  grayTextColor: transparentize(colors$2.gray85, 0.4)
}, optionalThemeColors = {}, themeColors = {
  ...colors$2,
  ...requiredThemeColors,
  ...optionalThemeColors
}, colors$1 = createEmotionColors(themeColors), shadows$1 = createShadows(colors$1), emotionBaseTheme = {
  inSidebar: !1,
  showSidebarBorder: !1,
  linkUnderline: !0,
  breakpoints,
  colors: colors$1,
  fonts,
  fontSizes,
  fontWeights,
  genericFonts,
  iconSizes,
  lineHeights,
  radii,
  shadows: shadows$1,
  sizes,
  spacing,
  zIndices
}, genericColors = {
  ...colors$2,
  bgColor: colors$2.gray100,
  bodyText: colors$2.gray10,
  primary: colors$2.red70,
  secondaryBg: colors$2.gray90,
  // Default main theme colors (dark theme)
  redColor: colors$2.red80,
  orangeColor: colors$2.orange80,
  yellowColor: colors$2.yellow70,
  blueColor: colors$2.blue80,
  greenColor: colors$2.green80,
  violetColor: colors$2.purple70,
  grayColor: colors$2.gray80,
  // Default background theme colors (dark theme)
  redBackgroundColor: transparentize(colors$2.red60, 0.8),
  orangeBackgroundColor: transparentize(colors$2.orange80, 0.8),
  yellowBackgroundColor: transparentize(colors$2.yellow65, 0.8),
  blueBackgroundColor: transparentize(colors$2.blue60, 0.8),
  greenBackgroundColor: transparentize(colors$2.green60, 0.8),
  violetBackgroundColor: transparentize(colors$2.purple60, 0.8),
  grayBackgroundColor: transparentize(colors$2.gray70, 0.8),
  // Default text theme colors (dark theme)
  redTextColor: colors$2.red60,
  orangeTextColor: colors$2.orange60,
  yellowTextColor: colors$2.yellow20,
  blueTextColor: colors$2.blue60,
  greenTextColor: colors$2.green50,
  violetTextColor: colors$2.purple50,
  grayTextColor: transparentize(colors$2.gray10, 0.4)
}, colors = createEmotionColors({
  ...emotionBaseTheme.colors,
  ...genericColors
}), shadows = createShadows(colors), emotionDarkTheme = {
  ...emotionBaseTheme,
  inSidebar: !1,
  colors,
  shadows
}, emotionLightTheme = {
  ...emotionBaseTheme,
  inSidebar: !1
}, baseuiLightTheme = createBaseUiTheme(emotionLightTheme, primitives), baseuiDarkTheme = createBaseUiTheme(emotionDarkTheme, primitives$1), STALE_TRANSITION_PARAMS = "1s ease-in 0.5s", STALE_STYLES = {
  opacity: 0.33,
  transition: `opacity ${STALE_TRANSITION_PARAMS}`
}, baseTheme = {
  name: "base",
  emotion: emotionBaseTheme,
  basewebTheme: baseuiLightTheme,
  primitives
}, darkTheme = {
  name: "Dark",
  emotion: emotionDarkTheme,
  basewebTheme: baseuiDarkTheme,
  primitives: primitives$1
}, lightTheme = {
  name: "Light",
  emotion: emotionLightTheme,
  basewebTheme: baseuiLightTheme,
  primitives
}, CACHED_THEME_VERSION = 2, CACHED_THEME_BASE_KEY = `stActiveTheme-${window.location.pathname}`, LocalStore = {
  CACHED_THEME_VERSION,
  CACHED_THEME_BASE_KEY,
  ACTIVE_THEME: `${CACHED_THEME_BASE_KEY}-v${CACHED_THEME_VERSION}`
}, AUTO_THEME_NAME = "Use system setting", CUSTOM_THEME_NAME = "Custom Theme", CUSTOM_THEME_LIGHT_NAME = "Custom Theme Light", CUSTOM_THEME_DARK_NAME = "Custom Theme Dark", CUSTOM_THEME_AUTO_NAME = "Custom Theme Auto", LOG$d = loglevelExports$1.getLogger("theme:utils");
function sortThemeInputKeys(o) {
  if (o == null)
    return o;
  if (Array.isArray(o))
    return o.map((i) => sortThemeInputKeys(i));
  if (typeof o == "object") {
    const i = {};
    return Object.keys(o).sort().forEach((g) => {
      i[g] = sortThemeInputKeys(o[g]);
    }), i;
  }
  return o;
}
function mergeTheme(o, i) {
  if (i && isObject$3(i)) {
    const g = new CustomThemeConfig(i);
    return createTheme(o.name, g, o);
  }
  return o;
}
const getMergedLightTheme = once$1(() => mergeTheme(lightTheme, StreamlitConfig.LIGHT_THEME)), getMergedDarkTheme = once$1(() => mergeTheme(darkTheme, StreamlitConfig.DARK_THEME)), getSystemThemePreference = () => window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", getSystemTheme = () => getSystemThemePreference() === "dark" ? getMergedDarkTheme() : getMergedLightTheme(), createAutoTheme = () => ({
  ...getSystemTheme(),
  name: AUTO_THEME_NAME
}), createPresetThemes = () => [createAutoTheme(), getMergedLightTheme(), getMergedDarkTheme()], isPresetTheme = (o) => createPresetThemes().map((g) => g.name).includes(o.name), bgColorToBaseString = (o) => o === void 0 || getLuminance(o) > 0.5 ? "light" : "dark", isColor = (o) => {
  const i = new Option().style;
  return i.color = o, i.color !== "";
}, roundFontSizeToNearestEighth = (o) => Math.round(o * 8) / 8, parseFont = (o, i = fonts.sansSerif) => {
  const g = o.trim();
  if (!g)
    return i;
  const E = {
    "sans-serif": fonts.sansSerif,
    serif: fonts.serif,
    monospace: fonts.monospace
  }, e = g.toLowerCase().replaceAll(" ", "-");
  return e in E ? E[e] : `${g}, ${i}`;
}, parseColor = (o, i, g = !1) => {
  if (isColor(o))
    return o;
  if (isColor(`#${o}`))
    return `#${o}`;
  if (i.toLowerCase().includes("color")) {
    const e = g ? "theme.sidebar" : "theme";
    LOG$d.warn(`Invalid color passed for ${i} in ${e}: "${o}"`);
  }
}, resolveBgColor = (o, i, g, E) => o || (i ? transparentize(i, E ? 0.9 : 0.8) : g), resolveTextColor = (o, i, g, E) => o || (i ? E ? darken(i, 0.15) : lighten(i, 0.15) : g), setBackgroundColors = (o, i) => {
  const g = {
    ...o
  }, E = {
    redBackgroundColor: {
      main: i.redColor,
      background: i.redBackgroundColor
    },
    orangeBackgroundColor: {
      main: i.orangeColor,
      background: i.orangeBackgroundColor
    },
    yellowBackgroundColor: {
      main: i.yellowColor,
      background: i.yellowBackgroundColor
    },
    blueBackgroundColor: {
      main: i.blueColor,
      background: i.blueBackgroundColor
    },
    greenBackgroundColor: {
      main: i.greenColor,
      background: i.greenBackgroundColor
    },
    violetBackgroundColor: {
      main: i.violetColor,
      background: i.violetBackgroundColor
    },
    grayBackgroundColor: {
      main: i.grayColor,
      background: i.grayBackgroundColor
    }
  }, e = getLuminance(g.bgColor) > 0.5;
  return Object.entries(E).forEach(([t, {
    main: n,
    background: h
  }]) => {
    const d = t;
    g[d] = resolveBgColor(h, n, o[d], e);
  }), g;
}, setTextColors = (o, i) => {
  const g = {
    ...o
  }, E = {
    redTextColor: {
      main: i.redColor,
      text: i.redTextColor
    },
    orangeTextColor: {
      main: i.orangeColor,
      text: i.orangeTextColor
    },
    yellowTextColor: {
      main: i.yellowColor,
      text: i.yellowTextColor
    },
    blueTextColor: {
      main: i.blueColor,
      text: i.blueTextColor
    },
    greenTextColor: {
      main: i.greenColor,
      text: i.greenTextColor
    },
    violetTextColor: {
      main: i.violetColor,
      text: i.violetTextColor
    },
    grayTextColor: {
      main: i.grayColor,
      text: i.grayTextColor
    }
  }, e = getLuminance(g.bgColor) > 0.5;
  return Object.entries(E).forEach(([t, {
    main: n,
    text: h
  }]) => {
    const d = t;
    g[d] = resolveTextColor(h, n, o[d], e);
  }), g;
}, parseRadius = (o) => {
  let i = "rem", g;
  const E = o.trim().toLowerCase();
  return E === "none" ? g = 0 : E === "small" ? g = 0.35 : E === "medium" ? g = 0.5 : E === "large" ? g = 1 : E === "full" ? g = 1.4 : E.endsWith("rem") ? g = parseFloat(E) : E.endsWith("px") ? (g = parseFloat(E), i = "px") : isNaN(parseFloat(E)) || (g = parseFloat(E), i = "px"), [g, i];
}, parseFontSize = (o, i, g) => {
  const E = g ? "theme.sidebar" : "theme";
  if (typeof i == "string") {
    const e = i.trim().toLowerCase(), t = parseFloat(e);
    if (t && (e.endsWith("rem") || e.endsWith("px")))
      return e;
    if (t.toString() === e)
      return `${e}px`;
  }
  LOG$d.warn(`Invalid size passed for ${o} in ${E}: ${i}. Falling back to default ${o}.`);
}, isValidFontWeight = (o, i, g, E, e) => {
  const t = e ? "theme.sidebar" : "theme";
  if (notNullOrUndefined(i)) {
    const n = Number.isInteger(i), h = i % 100 === 0, d = i >= g && i <= E;
    return !n || !h || !d ? (LOG$d.warn(`Invalid ${o}: ${i} in ${t}. The ${o} must be an integer ${g}-${E}, and an increment of 100. Falling back to default font weight.`), !1) : !0;
  }
  return !1;
}, convertHeadingFontSizeToRem = (o, i, g, E) => {
  const e = parseFontSize(o, i, E);
  if (e?.endsWith("rem"))
    return e;
  if (e?.endsWith("px"))
    return `${parseFloat(e) / g}rem`;
}, setHeadingFontSizes = (o, i, g, E) => {
  const e = {
    ...o
  };
  return E && E.forEach((t, n) => {
    const h = `h${n + 1}FontSize`, d = convertHeadingFontSizeToRem(`${h} in headingFontSizes`, t, g, i);
    d && (e[h] = d);
  }), e;
}, setFontWeights = (o, i, g, E, e) => {
  const t = {
    ...o,
    // Override default h1FontWeight for sidebar to 600
    // Default for main theme set in typography (700)
    h1FontWeight: i ? 600 : o.h1FontWeight
  };
  return g && isValidFontWeight("baseFontWeight", g, 100, 600) && (t.normal = g, t.semiBold = g + 100, t.bold = g + 200, t.extrabold = g + 300, t.code = g, t.codeBold = g + 200, t.codeExtraBold = g + 300), E && isValidFontWeight("codeFontWeight", E, 100, 600) && (t.code = E, t.codeBold = E + 200, t.codeExtraBold = E + 300), e && e.forEach((n, h) => {
    const d = `h${h + 1}FontWeight`;
    isValidFontWeight(`${d} in headingFontWeights`, n, 100, 900, i) && (t[d] = n);
  }), t;
}, validateChartColors = (o, i) => i.map((g) => parseColor(g, o)).filter((g) => g !== void 0), createEmotionTheme = (o, i = baseTheme) => {
  const {
    colors: g,
    genericFonts: E,
    inSidebar: e
  } = i.emotion, {
    baseFontSize: t,
    baseFontWeight: n,
    baseRadius: h,
    buttonRadius: d,
    codeFontSize: k,
    codeFontWeight: p,
    showWidgetBorder: M,
    headingFont: H,
    headingFontSizes: f,
    headingFontWeights: AA,
    bodyFont: gA,
    codeFont: IA,
    showSidebarBorder: BA,
    linkUnderline: CA,
    // Since chart color configs passed as array, handle separate from parsedColors
    chartCategoricalColors: QA,
    chartSequentialColors: iA,
    chartDivergingColors: EA,
    ...oA
  } = o, eA = Object.entries(oA).reduce((MA, [OA, SA]) => {
    const gg = parseColor(SA, OA, e);
    return gg && (MA[OA] = gg), MA;
  }, {}), {
    secondaryBackgroundColor: GA,
    backgroundColor: cA,
    primaryColor: tA,
    textColor: aA,
    dataframeBorderColor: sA,
    dataframeHeaderBackgroundColor: DA,
    widgetBorderColor: rA,
    borderColor: nA,
    linkColor: NA,
    codeTextColor: pA,
    codeBackgroundColor: mA,
    redColor: XA,
    orangeColor: lA,
    yellowColor: kA,
    blueColor: ZA,
    greenColor: wA,
    violetColor: LA,
    grayColor: fA
  } = eA, dA = {
    ...g,
    primary: tA ?? g.primary,
    bodyText: aA ?? g.bodyText,
    secondaryBg: GA ?? g.secondaryBg,
    bgColor: cA ?? g.bgColor,
    // Main theme colors
    redColor: XA ?? g.redColor,
    orangeColor: lA ?? g.orangeColor,
    yellowColor: kA ?? g.yellowColor,
    blueColor: ZA ?? g.blueColor,
    greenColor: wA ?? g.greenColor,
    violetColor: LA ?? g.violetColor,
    grayColor: fA ?? g.grayColor,
    // Secondary color is not yet configurable. Set secondary color to primary color
    // by default for all custom themes.
    secondary: tA ?? g.primary
  }, RA = {
    colors: {
      ...createEmotionColors(dA)
    },
    showSidebarBorder: BA ?? i.emotion.showSidebarBorder,
    linkUnderline: CA ?? i.emotion.linkUnderline,
    // Copy over the default values for the other configurable theme properties
    radii: {
      ...i.emotion.radii
    },
    fontSizes: {
      ...i.emotion.fontSizes
    },
    fontWeights: {
      ...i.emotion.fontWeights
    }
  };
  if (RA.colors.codeBackgroundColor = mA ?? g.codeBackgroundColor, RA.colors.dataframeHeaderBackgroundColor = DA ?? g.dataframeHeaderBackgroundColor, notNullOrUndefined(nA)) {
    RA.colors.borderColor = nA;
    const MA = transparentize(nA, 0.55);
    RA.colors.borderColorLight = MA, RA.colors.dataframeBorderColor = MA;
  }
  if (notNullOrUndefined(sA) && (RA.colors.dataframeBorderColor = sA), (M || rA) && (RA.colors.widgetBorderColor = rA || RA.colors.borderColor), RA.colors = setBackgroundColors(RA.colors, eA), RA.colors = setTextColors(RA.colors, eA), RA.colors.link = NA ?? RA.colors.blueTextColor, RA.colors.codeTextColor = pA ?? RA.colors.greenTextColor, notNullOrUndefined(QA) && QA.length > 0) {
    const MA = validateChartColors("chartCategoricalColors", QA);
    MA.length > 0 && (RA.colors.chartCategoricalColors = MA);
  }
  if (notNullOrUndefined(iA) && iA.length > 0) {
    const MA = validateChartColors("chartSequentialColors", iA);
    MA.length === 10 ? RA.colors.chartSequentialColors = MA : LOG$d.warn(`Invalid chartSequentialColors: ${iA.toString()}. Falling back to default chartSequentialColors.`);
  }
  if (notNullOrUndefined(EA) && EA.length > 0) {
    const MA = validateChartColors("chartDivergingColors", EA);
    MA.length === 10 ? RA.colors.chartDivergingColors = MA : LOG$d.warn(`Invalid chartDivergingColors: ${EA.toString()}. Falling back to default chartDivergingColors.`);
  }
  if (notNullOrUndefined(h)) {
    const [MA, OA] = parseRadius(h);
    if (notNullOrUndefined(MA) && !isNaN(MA)) {
      const SA = addCssUnit(MA, OA);
      RA.radii.default = SA, RA.radii.button = SA, RA.radii.md = addCssUnit(roundToTwoDecimals(MA * 0.5), OA), RA.radii.xl = addCssUnit(roundToTwoDecimals(MA * 1.5), OA), RA.radii.xxl = addCssUnit(roundToTwoDecimals(MA * 2), OA);
    } else
      LOG$d.warn(`Invalid base radius: ${h}. Falling back to default base radius.`);
  }
  if (notNullOrUndefined(d)) {
    const [MA, OA] = parseRadius(d);
    notNullOrUndefined(MA) && !isNaN(MA) ? RA.radii.button = addCssUnit(MA, OA) : LOG$d.warn(`Invalid button radius: ${d}. Falling back to default button radius.`);
  }
  if (t && t > 0 && (RA.fontSizes.baseFontSize = t), k) {
    const MA = parseFontSize("codeFontSize", k, e);
    MA && (RA.fontSizes.codeFontSize = MA);
  }
  RA.fontSizes = setHeadingFontSizes(RA.fontSizes, e, RA.fontSizes.baseFontSize, f), RA.fontWeights = setFontWeights(i.emotion.fontWeights, e, n, p, AA);
  const KA = {
    // Default values for the generic fonts
    ...E,
    // Override properties if configured
    bodyFont: gA ? parseFont(gA, fonts.sansSerif) : E.bodyFont,
    codeFont: IA ? parseFont(IA, fonts.monospace) : E.codeFont,
    headingFont: H ? parseFont(H, fonts.sansSerif) : E.headingFont
  };
  gA && !H && (KA.headingFont = parseFont(gA, fonts.sansSerif));
  const xA = createShadows(RA.colors);
  return {
    ...i.emotion,
    genericFonts: KA,
    ...RA,
    shadows: xA
  };
}, toThemeInput = (o) => {
  const {
    colors: i
  } = o;
  return {
    primaryColor: i.primary,
    backgroundColor: i.bgColor,
    secondaryBackgroundColor: i.secondaryBg,
    textColor: i.bodyText,
    bodyFont: o.genericFonts.bodyFont
  };
}, toExportedTheme = (o) => {
  const {
    colors: i
  } = o, g = toThemeInput(o);
  return {
    primaryColor: g.primaryColor,
    backgroundColor: g.backgroundColor,
    secondaryBackgroundColor: g.secondaryBackgroundColor,
    textColor: g.textColor,
    bodyFont: g.bodyFont,
    base: bgColorToBaseString(g.backgroundColor),
    ...computeDerivedColors(i)
  };
}, completeThemeInput = (o, i) => new CustomThemeConfig({
  ...toThemeInput(i.emotion),
  ...o
}), createTheme = (o, i, g, E = !1) => {
  let e;
  g ? e = completeThemeInput(i, g) : i.base === CustomThemeConfig.BaseTheme.DARK ? e = completeThemeInput(i, darkTheme) : e = completeThemeInput(i, lightTheme);
  const t = e.backgroundColor, n = merge$1(cloneDeep(g || (getLuminance(t) > 0.5 ? lightTheme : darkTheme)), {
    emotion: {
      inSidebar: E
    }
  }), h = createEmotionTheme(e, n), d = cloneDeep(createBaseUiTheme(h, n.primitives));
  return {
    ...n,
    name: o,
    emotion: h,
    basewebTheme: d,
    themeInput: i
  };
}, deleteOldCachedThemes = () => {
  const {
    CACHED_THEME_VERSION: o,
    CACHED_THEME_BASE_KEY: i
  } = LocalStore, {
    localStorage: g
  } = window;
  g.removeItem("stActiveTheme"), g.removeItem(i);
  for (let E = 1; E < o; E++)
    g.removeItem(`${i}-v${E}`);
}, getThemeSelectionFromThemeConfig = (o) => o.name === AUTO_THEME_NAME || o.name === CUSTOM_THEME_AUTO_NAME ? "System" : o.name === lightTheme.name || o.name === CUSTOM_THEME_LIGHT_NAME ? "Light" : o.name === darkTheme.name || o.name === CUSTOM_THEME_DARK_NAME ? "Dark" : (o.name === CUSTOM_THEME_NAME, "System"), isThemeSelection = (o) => o === "System" || o === "Light" || o === "Dark", getCachedThemeSelection = () => {
  if (!localStorageAvailable())
    return null;
  deleteOldCachedThemes();
  const o = window.localStorage.getItem(LocalStore.ACTIVE_THEME);
  if (!o)
    return null;
  const i = JSON.parse(o);
  return isThemeSelection(i) ? i : null;
}, setCachedThemeSelection = (o) => {
  if (!localStorageAvailable() || (deleteOldCachedThemes(), isLightThemeInQueryParams() || isDarkThemeInQueryParams()))
    return;
  const i = getThemeSelectionFromThemeConfig(o);
  window.localStorage.setItem(LocalStore.ACTIVE_THEME, JSON.stringify(i));
}, getHostSpecifiedThemeOnly = () => isLightThemeInQueryParams() ? getMergedLightTheme() : isDarkThemeInQueryParams() ? getMergedDarkTheme() : null, getHostSpecifiedTheme = () => getHostSpecifiedThemeOnly() ?? createAutoTheme(), getDefaultTheme = () => {
  const o = getHostSpecifiedThemeOnly();
  if (o)
    return o;
  const i = getCachedThemeSelection();
  return i === "Light" ? getMergedLightTheme() : i === "Dark" ? getMergedDarkTheme() : createAutoTheme();
}, whiteSpace = /\s+/;
function computeSpacingStyle(o, i) {
  return o === "" ? "" : o.split(whiteSpace).map((g) => g === "0" ? i.spacing.none : g in i.spacing ? i.spacing[g] : (LOG$d.error(`Invalid spacing value: ${g}`), i.spacing.none)).join(" ");
}
function addCssUnit(o, i) {
  return `${o}${i}`;
}
function roundToTwoDecimals(o) {
  return parseFloat(o.toFixed(2));
}
function blend(o, i) {
  if (i === void 0) return o;
  const [g, E, e, t] = parseToRgba(o);
  if (t === 1) return o;
  const [n, h, d, k] = parseToRgba(i), p = t + k * (1 - t), M = Math.round((t * g + k * n * (1 - t)) / p), H = Math.round((t * E + k * h * (1 - t)) / p), f = Math.round((t * e + k * d * (1 - t)) / p);
  return toHex(`rgba(${M}, ${H}, ${f}, ${p})`);
}
const convertRemToPx = (o) => (
  // TODO(lukasmasuch): We might want to somehow cache this value at some point.
  // However, I did experimented with the performance of calling this, and
  // it seems not like a big deal to call it many times.
  parseFloat(o.replace(/rem$/, "")) * // We fallback to 16px if the fontSize is not defined (should only happen in tests)
  (parseFloat(getComputedStyle(document.documentElement).fontSize) || 16)
), skipProtobufDefaults = (o, i) => {
  if (i === "" || i === null || Array.isArray(i) && i.length === 0)
    return o;
}, handleSectionInheritance = (o, i) => {
  const g = i === "light", E = g ? CustomThemeConfig.BaseTheme.LIGHT : CustomThemeConfig.BaseTheme.DARK, {
    light: e,
    dark: t,
    sidebar: n,
    ...h
  } = o, d = g ? e : t, {
    sidebar: k,
    ...p
  } = d || {}, M = mergeWith(
    {},
    h,
    // Common theme properties from themeInput
    p,
    // Variant-specific theme overrides (without sidebar)
    {
      base: E
    },
    // Set base last to override any base from commonTheme/variantTheme
    skipProtobufDefaults
  );
  return (n || k) && (M.sidebar = mergeWith({}, n, k, skipProtobufDefaults)), M;
}, hasThemeSectionConfigs = (o) => {
  if (!o)
    return !1;
  const i = (g) => g == null ? !1 : Array.isArray(g) ? g.length > 0 : typeof g == "object" ? Object.values(g).some(i) : !0;
  return Object.values(o).some(i);
}, createCustomThemes = (o) => {
  const i = hasThemeSectionConfigs(o.light), g = hasThemeSectionConfigs(o.dark), E = [];
  if (i || g) {
    const e = handleSectionInheritance(o, "light"), t = {
      ...createTheme(CUSTOM_THEME_LIGHT_NAME, e),
      displayName: "Light"
    }, n = handleSectionInheritance(o, "dark"), h = {
      ...createTheme(CUSTOM_THEME_DARK_NAME, n),
      displayName: "Dark"
    }, k = {
      ...getSystemThemePreference() === "dark" ? h : t,
      displayName: AUTO_THEME_NAME,
      name: CUSTOM_THEME_AUTO_NAME
    };
    E.push(t, h, k);
  } else {
    const e = createTheme(CUSTOM_THEME_NAME, o);
    E.push(e);
  }
  return E;
}, setSidebarHeadingFontSizes = (o) => merge$1([], ["1.5rem", "1.25rem", "1.125rem", "1rem", "0.875rem", "0.75rem"], o || []), createSidebarTheme = (o) => {
  const i = o.themeInput?.sidebar, {
    bgColor: g,
    secondaryBg: E
  } = o.emotion.colors, e = i?.backgroundColor || E, t = i?.secondaryBackgroundColor || g, n = setSidebarHeadingFontSizes(i?.headingFontSizes);
  let h = getLuminance(e) > 0.5 ? CustomThemeConfig.BaseTheme.LIGHT : CustomThemeConfig.BaseTheme.DARK;
  o.name === CUSTOM_THEME_LIGHT_NAME ? h = CustomThemeConfig.BaseTheme.LIGHT : o.name === CUSTOM_THEME_DARK_NAME && (h = CustomThemeConfig.BaseTheme.DARK);
  const d = mergeWith(
    {},
    o.themeInput,
    // Use the theme props from the main theme as basis
    i,
    // Merge sidebar configs
    {
      // Explicit overrides that should always be applied
      base: h,
      backgroundColor: e,
      secondaryBackgroundColor: t,
      headingFontSizes: n
    },
    skipProtobufDefaults
  );
  return createTheme(
    "Sidebar",
    d,
    void 0,
    // Creating a new theme from scratch
    !0
    // inSidebar
  );
}, mapCachedThemeSelectionToAvailableTheme = (o, i) => {
  if (!o)
    return null;
  const g = {
    System: [CUSTOM_THEME_AUTO_NAME, AUTO_THEME_NAME, CUSTOM_THEME_NAME],
    Light: [CUSTOM_THEME_LIGHT_NAME, lightTheme.name],
    Dark: [CUSTOM_THEME_DARK_NAME, darkTheme.name]
  };
  for (const E of g[o]) {
    const e = i.find((t) => t.name === E);
    if (e)
      return e;
  }
  return null;
}, getPreferredTheme = (o) => {
  const i = getHostSpecifiedThemeOnly(), E = (i ? getThemeSelectionFromThemeConfig(i) : null) ?? getCachedThemeSelection();
  return mapCachedThemeSelectionToAvailableTheme(E, o);
}, isPositiveNumber = (o) => typeof o == "number" && o >= 0 && !isNaN(o), isNonZeroPositiveNumber = (o) => typeof o == "number" && o > 0 && !isNaN(o), getWidth = (o, i) => {
  if (i?.useContainerWidth)
    return {
      type: "stretch"
      /* STRETCH */
    };
  const g = o.widthConfig?.useStretch || i?.widthConfig?.useStretch, E = o?.widthConfig?.useContent || i?.widthConfig?.useContent, e = o?.widthConfig?.pixelWidth || i?.widthConfig?.pixelWidth || o.widthConfig?.pixelWidth === 0, t = o.widthConfig?.remWidth;
  return g ? {
    type: "stretch"
    /* STRETCH */
  } : E ? {
    type: "content"
    /* CONTENT */
  } : t && isPositiveNumber(o.widthConfig?.remWidth) ? {
    type: "rem",
    rem: o.widthConfig.remWidth
  } : e && isPositiveNumber(o.widthConfig?.pixelWidth) ? {
    type: "pixel",
    pixels: o.widthConfig.pixelWidth
  } : e && isPositiveNumber(i?.widthConfig?.pixelWidth) ? {
    type: "pixel",
    pixels: i.widthConfig.pixelWidth
  } : isNonZeroPositiveNumber(i?.width) && !o.widthConfig ? {
    type: "pixel",
    pixels: i.width
  } : {
    type: "auto"
    /* AUTO */
  };
}, getHeight = (o, i) => {
  const g = !!o.heightConfig?.useStretch, E = !!o.heightConfig?.useContent, e = !!o.heightConfig?.pixelHeight || o.heightConfig?.pixelHeight === 0, t = o.heightConfig?.remHeight;
  return g ? {
    type: "stretch"
    /* STRETCH */
  } : E ? {
    type: "content"
    /* CONTENT */
  } : t && isPositiveNumber(o.heightConfig?.remHeight) ? {
    type: "rem",
    rem: o.heightConfig.remHeight
  } : e && isPositiveNumber(o.heightConfig?.pixelHeight) ? {
    type: "pixel",
    pixels: o.heightConfig.pixelHeight
  } : isNonZeroPositiveNumber(i?.height) && !o.heightConfig ? {
    type: "pixel",
    pixels: i.height
  } : {
    type: "auto"
    /* AUTO */
  };
}, getFlex = (o, i, g, E) => {
  if (g === Direction.HORIZONTAL)
    switch (o.type) {
      case "pixel":
        return `0 0 ${o.pixels}px`;
      case "rem":
        return `0 0 ${o.rem}rem`;
      case "content":
        return "0 0 fit-content";
      case "stretch":
        return `1 1 ${E ?? "fit-content"}`;
      case "auto":
        return;
      default:
        assertNever(o);
    }
  else if (g === Direction.VERTICAL)
    switch (i.type) {
      case "pixel":
        return `0 0 ${i.pixels}px`;
      case "rem":
        return `0 0 ${i.rem}rem`;
      case "content":
      case "stretch":
      case "auto":
        return;
      default:
        assertNever(i);
    }
}, getDirection = (o) => o?.direction, calculateMinWidthWithParentConstraint = (o, i, g = 32) => {
  if (i === void 0 || o === void 0 || o === "fit-content")
    return o;
  const E = convertRemToPx(o);
  return i < E && i > g ? `${i - g}px` : o;
}, useLayoutStyles = ({
  element: o,
  subElement: i,
  styleOverrides: g,
  minStretchBehavior: E
}) => {
  const e = useContext(FlexContext);
  return useMemo$1(() => {
    if (!o)
      return {
        width: "auto",
        height: "auto",
        overflow: "visible"
      };
    const n = getWidth(o, i);
    let h, d;
    switch (n.type) {
      case "stretch":
        h = "100%";
        break;
      case "rem":
        h = `${n.rem}rem`;
        break;
      case "pixel":
        h = `${n.pixels}px`;
        break;
      case "content":
        h = "fit-content";
        break;
      case "auto":
        h = "auto";
        break;
      default:
        assertNever(n);
    }
    const k = getDirection(e);
    e?.isInContentWidthContainer && n.type === "stretch" && E !== void 0 && (d = calculateMinWidthWithParentConstraint(E, e?.parentWidth));
    const p = getHeight(o, i);
    let M, H = "visible";
    switch (p.type) {
      case "stretch":
        M = "100%";
        break;
      case "content":
        M = "auto";
        break;
      case "rem":
        M = `${p.rem}rem`;
        break;
      case "pixel":
        M = `${p.pixels}px`, H = "auto";
        break;
      case "auto":
        M = "auto";
        break;
      default:
        assertNever(p);
    }
    const f = getFlex(n, p, k, E), AA = getTextAlignmentStyle("textAlignmentConfig" in o ? o.textAlignmentConfig : void 0);
    return {
      ...{
        width: h,
        height: M,
        overflow: H,
        flex: f,
        minWidth: d,
        textAlign: AA
      },
      ...g
    };
  }, [o, i, g, e, E]);
};
var ScriptRunState = /* @__PURE__ */ ((o) => (o.NOT_RUNNING = "notRunning", o.RUNNING = "running", o.RERUN_REQUESTED = "rerunRequested", o.STOP_REQUESTED = "stopRequested", o.COMPILATION_ERROR = "compilationError", o))(ScriptRunState || {});
const ScriptRunContext = createContext({
  scriptRunState: ScriptRunState.NOT_RUNNING,
  scriptRunId: "<null>",
  fragmentIdsThisRun: []
});
ScriptRunContext.displayName = "ScriptRunContext";
var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid$1 = /* @__PURE__ */ memoize$1(
  function(o) {
    return reactPropsRegex$1.test(o) || o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110 && o.charCodeAt(2) < 91;
  }
  /* Z+1 */
), testOmitPropsOnStringTag = isPropValid$1, testOmitPropsOnComponent = function o(i) {
  return i !== "theme";
}, getDefaultShouldForwardProp = function o(i) {
  return typeof i == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  i.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function o(i, g, E) {
  var e;
  if (g) {
    var t = g.shouldForwardProp;
    e = i.__emotion_forwardProp && t ? function(n) {
      return i.__emotion_forwardProp(n) && t(n);
    } : t;
  }
  return typeof e != "function" && E && (e = i.__emotion_forwardProp), e;
}, Insertion = function o(i) {
  var g = i.cache, E = i.serialized, e = i.isStringTag;
  return registerStyles(g, E, e), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(g, E, e);
  }), null;
}, createStyled = function o(i, g) {
  var E = i.__emotion_real === i, e = E && i.__emotion_base || i, t, n;
  g !== void 0 && (t = g.label, n = g.target);
  var h = composeShouldForwardProps(i, g, E), d = h || getDefaultShouldForwardProp(e), k = !d("as");
  return function() {
    var p = arguments, M = E && i.__emotion_styles !== void 0 ? i.__emotion_styles.slice(0) : [];
    if (t !== void 0 && M.push("label:" + t + ";"), p[0] == null || p[0].raw === void 0)
      M.push.apply(M, p);
    else {
      var H = p[0];
      M.push(H[0]);
      for (var f = p.length, AA = 1; AA < f; AA++)
        M.push(p[AA], H[AA]);
    }
    var gA = withEmotionCache(function(IA, BA, CA) {
      var QA = k && IA.as || e, iA = "", EA = [], oA = IA;
      if (IA.theme == null) {
        oA = {};
        for (var eA in IA)
          oA[eA] = IA[eA];
        oA.theme = React.useContext(ThemeContext$2);
      }
      typeof IA.className == "string" ? iA = getRegisteredStyles(BA.registered, EA, IA.className) : IA.className != null && (iA = IA.className + " ");
      var GA = serializeStyles(M.concat(EA), BA.registered, oA);
      iA += BA.key + "-" + GA.name, n !== void 0 && (iA += " " + n);
      var cA = k && h === void 0 ? getDefaultShouldForwardProp(QA) : d, tA = {};
      for (var aA in IA)
        k && aA === "as" || cA(aA) && (tA[aA] = IA[aA]);
      return tA.className = iA, CA && (tA.ref = CA), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
        cache: BA,
        serialized: GA,
        isStringTag: typeof QA == "string"
      }), /* @__PURE__ */ React.createElement(QA, tA));
    });
    return gA.displayName = t !== void 0 ? t : "Styled(" + (typeof e == "string" ? e : e.displayName || e.name || "Component") + ")", gA.defaultProps = i.defaultProps, gA.__emotion_real = gA, gA.__emotion_base = e, gA.__emotion_styles = M, gA.__emotion_forwardProp = h, Object.defineProperty(gA, "toString", {
      value: function() {
        return "." + n;
      }
    }), gA.withComponent = function(IA, BA) {
      var CA = o(IA, _extends$C({}, g, BA, {
        shouldForwardProp: composeShouldForwardProps(gA, BA, !0)
      }));
      return CA.apply(void 0, M);
    }, gA;
  };
}, reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$1(
  function(o) {
    return reactPropsRegex.test(o) || o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110 && o.charCodeAt(2) < 91;
  }
  /* Z+1 */
), SIZE$3 = {
  medium: "medium"
}, spin = {
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
}, StyledSpinner = styled("i", function(o) {
  var i = o.$theme, g = o.$color, E = g === void 0 ? i.colors.contentAccent : g, e = o.$borderWidth, t = o.$size, n = t === void 0 ? SIZE$3.medium : t, h = {
    large: i.sizing.scale300,
    medium: i.sizing.scale100,
    small: i.sizing.scale0
  }[e || n], d = {
    large: i.sizing.scale1000,
    medium: i.sizing.scale900,
    small: i.sizing.scale800
  }[n];
  return h || (h = i.sizing[e], h || (h = "".concat(parseInt(e), "px"))), d || (d = i.sizing[n], d || (d = "".concat(parseInt(n), "px"))), {
    display: "block",
    animationName: spin,
    animationDuration: i.animation.timing1000,
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderRadius: "50%",
    borderTopColor: E,
    borderRightColor: i.colors.backgroundTertiary,
    borderBottomColor: i.colors.backgroundTertiary,
    borderLeftColor: i.colors.backgroundTertiary,
    borderLeftWidth: h,
    borderRightWidth: h,
    borderTopWidth: h,
    borderBottomWidth: h,
    width: d,
    height: d,
    cursor: "wait"
  };
});
StyledSpinner.displayName = "StyledSpinner";
StyledSpinner.displayName = "StyledSpinner";
function _EMOTION_STRINGIFIED_CSS_ERROR__$g() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledSpinnerIcon = /* @__PURE__ */ createStyled(StyledSpinner, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (o) => isPropValid(o) && !["size"].includes(o),
  target: "eyeqlp54"
} : {
  shouldForwardProp: (o) => isPropValid(o) && !["size"].includes(o),
  target: "eyeqlp54",
  label: "StyledSpinnerIcon"
})(({
  size: o = "lg",
  margin: i = "",
  padding: g = "",
  theme: E
}) => {
  const e = `calc(${E.iconSizes[o]} * 0.80)`;
  return {
    width: e,
    height: e,
    fontSize: e,
    justifyContent: "center",
    margin: computeSpacingStyle(i, E),
    padding: computeSpacingStyle(g, E),
    borderColor: E.colors.fadedText10,
    borderTopColor: E.colors.bodyText,
    borderWidth: E.sizes.spinnerThickness,
    flexGrow: 0,
    flexShrink: 0
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (o) => isPropValid(o) && !["size", "as"].includes(o),
  target: "eyeqlp53"
} : {
  shouldForwardProp: (o) => isPropValid(o) && !["size", "as"].includes(o),
  target: "eyeqlp53",
  label: "StyledIcon"
})(({
  color: o,
  size: i,
  margin: g,
  padding: E,
  theme: e
}) => ({
  color: o || "inherit",
  fill: "currentColor",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: e.iconSizes[i],
  width: e.iconSizes[i],
  height: e.iconSizes[i],
  margin: computeSpacingStyle(g, e),
  padding: computeSpacingStyle(E, e),
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDynamicIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp52"
} : {
  target: "eyeqlp52",
  label: "StyledDynamicIcon"
})(({
  size: o = "lg",
  margin: i = "",
  padding: g = "",
  theme: E
}) => ({
  fill: "currentColor",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: E.iconSizes[o],
  width: E.iconSizes[o],
  height: E.iconSizes[o],
  margin: computeSpacingStyle(i, E),
  padding: computeSpacingStyle(g, E),
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledImageIcon = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp51"
} : {
  target: "eyeqlp51",
  label: "StyledImageIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
}), StyledEmojiIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp50"
} : {
  target: "eyeqlp50",
  label: "StyledEmojiIcon"
})(({
  size: o,
  margin: i,
  padding: g,
  theme: E,
  color: e
}) => {
  const t = `calc(${E.iconSizes[o]} * 0.90)`;
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: t,
    width: t,
    height: t,
    margin: computeSpacingStyle(i, E),
    padding: computeSpacingStyle(g, E),
    color: e
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getDefaultProps$1 = ({
  size: o,
  margin: i,
  padding: g,
  color: E
}) => ({
  size: o || "md",
  margin: i || "",
  padding: g || "",
  color: E || void 0
}), Icon$2 = ({
  content: o,
  color: i,
  size: g,
  margin: E,
  padding: e,
  testid: t
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIcon, { as: o, "aria-hidden": "true", "data-testid": t, ...getDefaultProps$1({
  size: g,
  margin: E,
  padding: e,
  color: i
}) }), EmojiIcon = ({
  size: o,
  margin: i,
  padding: g,
  children: E,
  color: e,
  testid: t
}) => (typeof E == "string" && (E = E.replace(/^emoji:/, "")), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEmojiIcon, { "data-testid": t || "stIconEmoji", "aria-hidden": "true", ...getDefaultProps$1({
  size: o,
  margin: i,
  padding: g,
  color: e
}), children: E })), StyledMaterialIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16edly10"
} : {
  target: "e16edly10",
  label: "StyledMaterialIcon"
})(({
  size: o,
  margin: i,
  padding: g,
  theme: E,
  color: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  color: e,
  fontSize: E.iconSizes[o],
  width: E.iconSizes[o],
  height: E.iconSizes[o],
  margin: computeSpacingStyle(i, E),
  padding: computeSpacingStyle(g, E),
  userSelect: "none",
  fontFamily: E.genericFonts.iconFont,
  fontWeight: E.fontWeights.normal,
  fontStyle: "normal",
  lineHeight: E.lineHeights.none,
  letterSpacing: "normal",
  textTransform: "none",
  whiteSpace: "nowrap",
  wordWrap: "normal",
  direction: "ltr",
  fontFeatureSettings: "liga",
  MozFontFeatureSettings: "liga",
  WebkitFontFeatureSettings: "liga",
  WebkitFontSmoothing: "antialiased"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getDefaultProps = ({
  size: o,
  margin: i,
  padding: g,
  color: E
}) => ({
  size: o || "md",
  margin: i || "",
  padding: g || "",
  color: E || "inherit"
}), MaterialFontIcon = ({
  iconName: o,
  ...i
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  StyledMaterialIcon,
  {
    ...getDefaultProps(i),
    "data-testid": i.testid || "stIconMaterial",
    translate: "no",
    children: o
  }
);
function parseIconPackEntry(o) {
  const i = o.match(/^:(.+)\/(.+):$/);
  if (i === null)
    return {
      pack: "emoji",
      icon: o
    };
  const g = i[1], E = i[2];
  return {
    pack: g,
    icon: E
  };
}
function isMaterialIcon(o) {
  if (!o)
    return !1;
  const i = parseIconPackEntry(o);
  return i.pack === "material" && i.icon !== "";
}
function getFilledStarIconSrc() {
  return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTg2MF84NDMpIj48cGF0aCBkPSJNOS45OTk5NCAxNC4zOTE2TDEzLjQ1ODMgMTYuNDgzM0MxNC4wOTE2IDE2Ljg2NjYgMTQuODY2NiAxNi4zIDE0LjY5OTkgMTUuNTgzM0wxMy43ODMzIDExLjY1TDE2Ljg0MTYgOC45OTk5N0MxNy4zOTk5IDguNTE2NjMgMTcuMDk5OSA3LjU5OTk3IDE2LjM2NjYgNy41NDE2M0wxMi4zNDE2IDcuMTk5OTdMMTAuNzY2NiAzLjQ4MzNDMTAuNDgzMyAyLjgwODMgOS41MTY2MSAyLjgwODMgOS4yMzMyNyAzLjQ4MzNMNy42NTgyNyA3LjE5MTYzTDMuNjMzMjcgNy41MzMzQzIuODk5OTQgNy41OTE2MyAyLjU5OTk0IDguNTA4MyAzLjE1ODI3IDguOTkxNjNMNi4yMTY2MSAxMS42NDE2TDUuMjk5OTQgMTUuNTc1QzUuMTMzMjcgMTYuMjkxNiA1LjkwODI3IDE2Ljg1ODMgNi41NDE2MSAxNi40NzVMOS45OTk5NCAxNC4zOTE2WiIgZmlsbD0iI0ZBQ0EyQiIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzE4NjBfODQzIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIi8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";
}
const DynamicIconDispatcher = ({
  iconValue: o,
  ...i
}) => {
  if (o === "spinner")
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...i, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinnerIcon, { "data-testid": i.testid || "stSpinnerIcon", ...i }) });
  const {
    pack: g,
    icon: E
  } = parseIconPackEntry(o);
  switch (g) {
    case "material":
      switch (E) {
        case "star_filled":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...i, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledImageIcon, { src: getFilledStarIconSrc(), "data-testid": i.testid || "stImageIcon" }) });
        default:
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...i, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MaterialFontIcon, { pack: g, iconName: E, ...i }) });
      }
    case "emoji":
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...i, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmojiIcon, { ...i, children: E }) });
  }
}, DynamicIcon = (o) => /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...o, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmojiIcon, { ...o, children: " " }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIconDispatcher, { ...o }) }, o.iconValue), LibConfigContext = createContext({
  locale: window.navigator.language,
  // Selected libConfig properties:
  mapboxToken: void 0,
  enforceDownloadInNewTab: void 0,
  resourceCrossOriginMode: void 0,
  showErrorLinks: Config.ShowErrorLinks.SHOW_ERROR_LINKS_AUTO
});
LibConfigContext.displayName = "LibConfigContext";
var Pe = Object.defineProperty, a$1 = (o, i) => Pe(o, "name", { value: i, configurable: !0 }), P$1 = class {
  type = 3;
  name = "";
  prefix = "";
  value = "";
  suffix = "";
  modifier = 3;
  constructor(i, g, E, e, t, n) {
    this.type = i, this.name = g, this.prefix = E, this.value = e, this.suffix = t, this.modifier = n;
  }
  hasCustomName() {
    return this.name !== "" && typeof this.name != "number";
  }
};
a$1(P$1, "Part");
var Re = /[$_\p{ID_Start}]/u, Ee = /[$_\u200C\u200D\p{ID_Continue}]/u, v = ".*";
function Oe(o, i) {
  return (i ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(o);
}
a$1(Oe, "isASCII");
function D(o, i = !1) {
  let g = [], E = 0;
  for (; E < o.length; ) {
    let e = o[E], t = a$1(function(n) {
      if (!i) throw new TypeError(n);
      g.push({ type: "INVALID_CHAR", index: E, value: o[E++] });
    }, "ErrorOrInvalid");
    if (e === "*") {
      g.push({ type: "ASTERISK", index: E, value: o[E++] });
      continue;
    }
    if (e === "+" || e === "?") {
      g.push({ type: "OTHER_MODIFIER", index: E, value: o[E++] });
      continue;
    }
    if (e === "\\") {
      g.push({ type: "ESCAPED_CHAR", index: E++, value: o[E++] });
      continue;
    }
    if (e === "{") {
      g.push({ type: "OPEN", index: E, value: o[E++] });
      continue;
    }
    if (e === "}") {
      g.push({ type: "CLOSE", index: E, value: o[E++] });
      continue;
    }
    if (e === ":") {
      let n = "", h = E + 1;
      for (; h < o.length; ) {
        let d = o.substr(h, 1);
        if (h === E + 1 && Re.test(d) || h !== E + 1 && Ee.test(d)) {
          n += o[h++];
          continue;
        }
        break;
      }
      if (!n) {
        t(`Missing parameter name at ${E}`);
        continue;
      }
      g.push({ type: "NAME", index: E, value: n }), E = h;
      continue;
    }
    if (e === "(") {
      let n = 1, h = "", d = E + 1, k = !1;
      if (o[d] === "?") {
        t(`Pattern cannot start with "?" at ${d}`);
        continue;
      }
      for (; d < o.length; ) {
        if (!Oe(o[d], !1)) {
          t(`Invalid character '${o[d]}' at ${d}.`), k = !0;
          break;
        }
        if (o[d] === "\\") {
          h += o[d++] + o[d++];
          continue;
        }
        if (o[d] === ")") {
          if (n--, n === 0) {
            d++;
            break;
          }
        } else if (o[d] === "(" && (n++, o[d + 1] !== "?")) {
          t(`Capturing groups are not allowed at ${d}`), k = !0;
          break;
        }
        h += o[d++];
      }
      if (k) continue;
      if (n) {
        t(`Unbalanced pattern at ${E}`);
        continue;
      }
      if (!h) {
        t(`Missing pattern at ${E}`);
        continue;
      }
      g.push({ type: "REGEX", index: E, value: h }), E = d;
      continue;
    }
    g.push({ type: "CHAR", index: E, value: o[E++] });
  }
  return g.push({ type: "END", index: E, value: "" }), g;
}
a$1(D, "lexer");
function F$1(o, i = {}) {
  let g = D(o);
  i.delimiter ??= "/#?", i.prefixes ??= "./";
  let E = `[^${x(i.delimiter)}]+?`, e = [], t = 0, n = 0, h = /* @__PURE__ */ new Set(), d = a$1((CA) => {
    if (n < g.length && g[n].type === CA) return g[n++].value;
  }, "tryConsume"), k = a$1(() => d("OTHER_MODIFIER") ?? d("ASTERISK"), "tryConsumeModifier"), p = a$1((CA) => {
    let QA = d(CA);
    if (QA !== void 0) return QA;
    let { type: iA, index: EA } = g[n];
    throw new TypeError(`Unexpected ${iA} at ${EA}, expected ${CA}`);
  }, "mustConsume"), M = a$1(() => {
    let CA = "", QA;
    for (; QA = d("CHAR") ?? d("ESCAPED_CHAR"); ) CA += QA;
    return CA;
  }, "consumeText"), H = a$1((CA) => CA, "DefaultEncodePart"), f = i.encodePart || H, AA = "", gA = a$1((CA) => {
    AA += CA;
  }, "appendToPendingFixedValue"), IA = a$1(() => {
    AA.length && (e.push(new P$1(3, "", "", f(AA), "", 3)), AA = "");
  }, "maybeAddPartFromPendingFixedValue"), BA = a$1((CA, QA, iA, EA, oA) => {
    let eA = 3;
    switch (oA) {
      case "?":
        eA = 1;
        break;
      case "*":
        eA = 0;
        break;
      case "+":
        eA = 2;
        break;
    }
    if (!QA && !iA && eA === 3) {
      gA(CA);
      return;
    }
    if (IA(), !QA && !iA) {
      if (!CA) return;
      e.push(new P$1(3, "", "", f(CA), "", eA));
      return;
    }
    let GA;
    iA ? iA === "*" ? GA = v : GA = iA : GA = E;
    let cA = 2;
    GA === E ? (cA = 1, GA = "") : GA === v && (cA = 0, GA = "");
    let tA;
    if (QA ? tA = QA : iA && (tA = t++), h.has(tA)) throw new TypeError(`Duplicate name '${tA}'.`);
    h.add(tA), e.push(new P$1(cA, tA, f(CA), GA, f(EA), eA));
  }, "addPart");
  for (; n < g.length; ) {
    let CA = d("CHAR"), QA = d("NAME"), iA = d("REGEX");
    if (!QA && !iA && (iA = d("ASTERISK")), QA || iA) {
      let oA = CA ?? "";
      i.prefixes.indexOf(oA) === -1 && (gA(oA), oA = ""), IA();
      let eA = k();
      BA(oA, QA, iA, "", eA);
      continue;
    }
    let EA = CA ?? d("ESCAPED_CHAR");
    if (EA) {
      gA(EA);
      continue;
    }
    if (d("OPEN")) {
      let oA = M(), eA = d("NAME"), GA = d("REGEX");
      !eA && !GA && (GA = d("ASTERISK"));
      let cA = M();
      p("CLOSE");
      let tA = k();
      BA(oA, eA, GA, cA, tA);
      continue;
    }
    IA(), p("END");
  }
  return e;
}
a$1(F$1, "parse");
function x(o) {
  return o.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
a$1(x, "escapeString");
function B$1(o) {
  return o && o.ignoreCase ? "ui" : "u";
}
a$1(B$1, "flags");
function q(o, i, g) {
  return W$1(F$1(o, g), i, g);
}
a$1(q, "stringToRegexp");
function T(o) {
  switch (o) {
    case 0:
      return "*";
    case 1:
      return "?";
    case 2:
      return "+";
    case 3:
      return "";
  }
}
a$1(T, "modifierToString");
function W$1(o, i, g = {}) {
  g.delimiter ??= "/#?", g.prefixes ??= "./", g.sensitive ??= !1, g.strict ??= !1, g.end ??= !0, g.start ??= !0, g.endsWith = "";
  let E = g.start ? "^" : "";
  for (let h of o) {
    if (h.type === 3) {
      h.modifier === 3 ? E += x(h.value) : E += `(?:${x(h.value)})${T(h.modifier)}`;
      continue;
    }
    i && i.push(h.name);
    let d = `[^${x(g.delimiter)}]+?`, k = h.value;
    if (h.type === 1 ? k = d : h.type === 0 && (k = v), !h.prefix.length && !h.suffix.length) {
      h.modifier === 3 || h.modifier === 1 ? E += `(${k})${T(h.modifier)}` : E += `((?:${k})${T(h.modifier)})`;
      continue;
    }
    if (h.modifier === 3 || h.modifier === 1) {
      E += `(?:${x(h.prefix)}(${k})${x(h.suffix)})`, E += T(h.modifier);
      continue;
    }
    E += `(?:${x(h.prefix)}`, E += `((?:${k})(?:`, E += x(h.suffix), E += x(h.prefix), E += `(?:${k}))*)${x(h.suffix)})`, h.modifier === 0 && (E += "?");
  }
  let e = `[${x(g.endsWith)}]|$`, t = `[${x(g.delimiter)}]`;
  if (g.end) return g.strict || (E += `${t}?`), g.endsWith.length ? E += `(?=${e})` : E += "$", new RegExp(E, B$1(g));
  g.strict || (E += `(?:${t}(?=${e}))?`);
  let n = !1;
  if (o.length) {
    let h = o[o.length - 1];
    h.type === 3 && h.modifier === 3 && (n = g.delimiter.indexOf(h) > -1);
  }
  return n || (E += `(?=${t}|${e})`), new RegExp(E, B$1(g));
}
a$1(W$1, "partsToRegexp");
var b = { delimiter: "", prefixes: "", sensitive: !0, strict: !0 }, J$1 = { delimiter: ".", prefixes: "", sensitive: !0, strict: !0 }, Q$1 = { delimiter: "/", prefixes: "/", sensitive: !0, strict: !0 };
function ee(o, i) {
  return o.length ? o[0] === "/" ? !0 : !i || o.length < 2 ? !1 : (o[0] == "\\" || o[0] == "{") && o[1] == "/" : !1;
}
a$1(ee, "isAbsolutePathname");
function te(o, i) {
  return o.startsWith(i) ? o.substring(i.length, o.length) : o;
}
a$1(te, "maybeStripPrefix");
function ke(o, i) {
  return o.endsWith(i) ? o.substr(0, o.length - i.length) : o;
}
a$1(ke, "maybeStripSuffix");
function _$1(o) {
  return !o || o.length < 2 ? !1 : o[0] === "[" || (o[0] === "\\" || o[0] === "{") && o[1] === "[";
}
a$1(_$1, "treatAsIPv6Hostname");
var re$1 = ["ftp", "file", "http", "https", "ws", "wss"];
function U$1(o) {
  if (!o) return !0;
  for (let i of re$1) if (o.test(i)) return !0;
  return !1;
}
a$1(U$1, "isSpecialScheme");
function ne(o, i) {
  if (o = te(o, "#"), i || o === "") return o;
  let g = new URL("https://example.com");
  return g.hash = o, g.hash ? g.hash.substring(1, g.hash.length) : "";
}
a$1(ne, "canonicalizeHash");
function se(o, i) {
  if (o = te(o, "?"), i || o === "") return o;
  let g = new URL("https://example.com");
  return g.search = o, g.search ? g.search.substring(1, g.search.length) : "";
}
a$1(se, "canonicalizeSearch");
function ie(o, i) {
  return i || o === "" ? o : _$1(o) ? K$1(o) : j(o);
}
a$1(ie, "canonicalizeHostname");
function ae(o, i) {
  if (i || o === "") return o;
  let g = new URL("https://example.com");
  return g.password = o, g.password;
}
a$1(ae, "canonicalizePassword");
function oe(o, i) {
  if (i || o === "") return o;
  let g = new URL("https://example.com");
  return g.username = o, g.username;
}
a$1(oe, "canonicalizeUsername");
function ce(o, i, g) {
  if (g || o === "") return o;
  if (i && !re$1.includes(i)) return new URL(`${i}:${o}`).pathname;
  let E = o[0] == "/";
  return o = new URL(E ? o : "/-" + o, "https://example.com").pathname, E || (o = o.substring(2, o.length)), o;
}
a$1(ce, "canonicalizePathname");
function le(o, i, g) {
  return z$1(i) === o && (o = ""), g || o === "" ? o : G$1(o);
}
a$1(le, "canonicalizePort");
function fe(o, i) {
  return o = ke(o, ":"), i || o === "" ? o : w$1(o);
}
a$1(fe, "canonicalizeProtocol");
function z$1(o) {
  switch (o) {
    case "ws":
    case "http":
      return "80";
    case "wws":
    case "https":
      return "443";
    case "ftp":
      return "21";
    default:
      return "";
  }
}
a$1(z$1, "defaultPortForProtocol");
function w$1(o) {
  if (o === "") return o;
  if (/^[-+.A-Za-z0-9]*$/.test(o)) return o.toLowerCase();
  throw new TypeError(`Invalid protocol '${o}'.`);
}
a$1(w$1, "protocolEncodeCallback");
function he(o) {
  if (o === "") return o;
  let i = new URL("https://example.com");
  return i.username = o, i.username;
}
a$1(he, "usernameEncodeCallback");
function ue(o) {
  if (o === "") return o;
  let i = new URL("https://example.com");
  return i.password = o, i.password;
}
a$1(ue, "passwordEncodeCallback");
function j(o) {
  if (o === "") return o;
  if (/[\t\n\r #%/:<>?@[\]^\\|]/g.test(o)) throw new TypeError(`Invalid hostname '${o}'`);
  let i = new URL("https://example.com");
  return i.hostname = o, i.hostname;
}
a$1(j, "hostnameEncodeCallback");
function K$1(o) {
  if (o === "") return o;
  if (/[^0-9a-fA-F[\]:]/g.test(o)) throw new TypeError(`Invalid IPv6 hostname '${o}'`);
  return o.toLowerCase();
}
a$1(K$1, "ipv6HostnameEncodeCallback");
function G$1(o) {
  if (o === "" || /^[0-9]*$/.test(o) && parseInt(o) <= 65535) return o;
  throw new TypeError(`Invalid port '${o}'.`);
}
a$1(G$1, "portEncodeCallback");
function de(o) {
  if (o === "") return o;
  let i = new URL("https://example.com");
  return i.pathname = o[0] !== "/" ? "/-" + o : o, o[0] !== "/" ? i.pathname.substring(2, i.pathname.length) : i.pathname;
}
a$1(de, "standardURLPathnameEncodeCallback");
function pe(o) {
  return o === "" ? o : new URL(`data:${o}`).pathname;
}
a$1(pe, "pathURLPathnameEncodeCallback");
function ge(o) {
  if (o === "") return o;
  let i = new URL("https://example.com");
  return i.search = o, i.search.substring(1, i.search.length);
}
a$1(ge, "searchEncodeCallback");
function me(o) {
  if (o === "") return o;
  let i = new URL("https://example.com");
  return i.hash = o, i.hash.substring(1, i.hash.length);
}
a$1(me, "hashEncodeCallback");
var C = class {
  #Q;
  #C = [];
  #g = {};
  #A = 0;
  #B = 1;
  #e = 0;
  #i = 0;
  #G = 0;
  #l = 0;
  #n = !1;
  constructor(o) {
    this.#Q = o;
  }
  get result() {
    return this.#g;
  }
  parse() {
    for (this.#C = D(this.#Q, !0); this.#A < this.#C.length; this.#A += this.#B) {
      if (this.#B = 1, this.#C[this.#A].type === "END") {
        if (this.#i === 0) {
          this.#r(), this.#t() ? this.#I(9, 1) : this.#c() ? this.#I(8, 1) : this.#I(7, 0);
          continue;
        } else if (this.#i === 2) {
          this.#a(5);
          continue;
        }
        this.#I(10, 0);
        break;
      }
      if (this.#G > 0) if (this.#k()) this.#G -= 1;
      else continue;
      if (this.#b()) {
        this.#G += 1;
        continue;
      }
      switch (this.#i) {
        case 0:
          this.#h() && this.#a(1);
          break;
        case 1:
          if (this.#h()) {
            this.#Y();
            let o = 7, i = 1;
            this.#y() ? (o = 2, i = 3) : this.#n && (o = 2), this.#I(o, i);
          }
          break;
        case 2:
          this.#s() ? this.#a(3) : (this.#w() || this.#c() || this.#t()) && this.#a(5);
          break;
        case 3:
          this.#d() ? this.#I(4, 1) : this.#s() && this.#I(5, 1);
          break;
        case 4:
          this.#s() && this.#I(5, 1);
          break;
        case 5:
          this.#u() ? this.#l += 1 : this.#R() && (this.#l -= 1), this.#F() && !this.#l ? this.#I(6, 1) : this.#w() ? this.#I(7, 0) : this.#c() ? this.#I(8, 1) : this.#t() && this.#I(9, 1);
          break;
        case 6:
          this.#w() ? this.#I(7, 0) : this.#c() ? this.#I(8, 1) : this.#t() && this.#I(9, 1);
          break;
        case 7:
          this.#c() ? this.#I(8, 1) : this.#t() && this.#I(9, 1);
          break;
        case 8:
          this.#t() && this.#I(9, 1);
          break;
      }
    }
    this.#g.hostname !== void 0 && this.#g.port === void 0 && (this.#g.port = "");
  }
  #I(o, i) {
    switch (this.#i) {
      case 0:
        break;
      case 1:
        this.#g.protocol = this.#o();
        break;
      case 2:
        break;
      case 3:
        this.#g.username = this.#o();
        break;
      case 4:
        this.#g.password = this.#o();
        break;
      case 5:
        this.#g.hostname = this.#o();
        break;
      case 6:
        this.#g.port = this.#o();
        break;
      case 7:
        this.#g.pathname = this.#o();
        break;
      case 8:
        this.#g.search = this.#o();
        break;
      case 9:
        this.#g.hash = this.#o();
        break;
    }
    this.#i !== 0 && o !== 10 && ([1, 2, 3, 4].includes(this.#i) && [6, 7, 8, 9].includes(o) && (this.#g.hostname ??= ""), [1, 2, 3, 4, 5, 6].includes(this.#i) && [8, 9].includes(o) && (this.#g.pathname ??= this.#n ? "/" : ""), [1, 2, 3, 4, 5, 6, 7].includes(this.#i) && o === 9 && (this.#g.search ??= "")), this.#N(o, i);
  }
  #N(o, i) {
    this.#i = o, this.#e = this.#A + i, this.#A += i, this.#B = 0;
  }
  #r() {
    this.#A = this.#e, this.#B = 0;
  }
  #a(o) {
    this.#r(), this.#i = o;
  }
  #D(o) {
    return o < 0 && (o = this.#C.length - o), o < this.#C.length ? this.#C[o] : this.#C[this.#C.length - 1];
  }
  #E(o, i) {
    let g = this.#D(o);
    return g.value === i && (g.type === "CHAR" || g.type === "ESCAPED_CHAR" || g.type === "INVALID_CHAR");
  }
  #h() {
    return this.#E(this.#A, ":");
  }
  #y() {
    return this.#E(this.#A + 1, "/") && this.#E(this.#A + 2, "/");
  }
  #s() {
    return this.#E(this.#A, "@");
  }
  #d() {
    return this.#E(this.#A, ":");
  }
  #F() {
    return this.#E(this.#A, ":");
  }
  #w() {
    return this.#E(this.#A, "/");
  }
  #c() {
    if (this.#E(this.#A, "?")) return !0;
    if (this.#C[this.#A].value !== "?") return !1;
    let o = this.#D(this.#A - 1);
    return o.type !== "NAME" && o.type !== "REGEX" && o.type !== "CLOSE" && o.type !== "ASTERISK";
  }
  #t() {
    return this.#E(this.#A, "#");
  }
  #b() {
    return this.#C[this.#A].type == "OPEN";
  }
  #k() {
    return this.#C[this.#A].type == "CLOSE";
  }
  #u() {
    return this.#E(this.#A, "[");
  }
  #R() {
    return this.#E(this.#A, "]");
  }
  #o() {
    let o = this.#C[this.#A], i = this.#D(this.#e).index;
    return this.#Q.substring(i, o.index);
  }
  #Y() {
    let o = {};
    Object.assign(o, b), o.encodePart = w$1;
    let i = q(this.#o(), void 0, o);
    this.#n = U$1(i);
  }
};
a$1(C, "Parser");
var V$1 = ["protocol", "username", "password", "hostname", "port", "pathname", "search", "hash"], O = "*";
function Se(o, i) {
  if (typeof o != "string") throw new TypeError("parameter 1 is not of type 'string'.");
  let g = new URL(o, i);
  return { protocol: g.protocol.substring(0, g.protocol.length - 1), username: g.username, password: g.password, hostname: g.hostname, port: g.port, pathname: g.pathname, search: g.search !== "" ? g.search.substring(1, g.search.length) : void 0, hash: g.hash !== "" ? g.hash.substring(1, g.hash.length) : void 0 };
}
a$1(Se, "extractValues");
function R(o, i) {
  return i ? I$1(o) : o;
}
a$1(R, "processBaseURLString");
function L$2(o, i, g) {
  let E;
  if (typeof i.baseURL == "string") try {
    E = new URL(i.baseURL), i.protocol === void 0 && (o.protocol = R(E.protocol.substring(0, E.protocol.length - 1), g)), !g && i.protocol === void 0 && i.hostname === void 0 && i.port === void 0 && i.username === void 0 && (o.username = R(E.username, g)), !g && i.protocol === void 0 && i.hostname === void 0 && i.port === void 0 && i.username === void 0 && i.password === void 0 && (o.password = R(E.password, g)), i.protocol === void 0 && i.hostname === void 0 && (o.hostname = R(E.hostname, g)), i.protocol === void 0 && i.hostname === void 0 && i.port === void 0 && (o.port = R(E.port, g)), i.protocol === void 0 && i.hostname === void 0 && i.port === void 0 && i.pathname === void 0 && (o.pathname = R(E.pathname, g)), i.protocol === void 0 && i.hostname === void 0 && i.port === void 0 && i.pathname === void 0 && i.search === void 0 && (o.search = R(E.search.substring(1, E.search.length), g)), i.protocol === void 0 && i.hostname === void 0 && i.port === void 0 && i.pathname === void 0 && i.search === void 0 && i.hash === void 0 && (o.hash = R(E.hash.substring(1, E.hash.length), g));
  } catch {
    throw new TypeError(`invalid baseURL '${i.baseURL}'.`);
  }
  if (typeof i.protocol == "string" && (o.protocol = fe(i.protocol, g)), typeof i.username == "string" && (o.username = oe(i.username, g)), typeof i.password == "string" && (o.password = ae(i.password, g)), typeof i.hostname == "string" && (o.hostname = ie(i.hostname, g)), typeof i.port == "string" && (o.port = le(i.port, o.protocol, g)), typeof i.pathname == "string") {
    if (o.pathname = i.pathname, E && !ee(o.pathname, g)) {
      let e = E.pathname.lastIndexOf("/");
      e >= 0 && (o.pathname = R(E.pathname.substring(0, e + 1), g) + o.pathname);
    }
    o.pathname = ce(o.pathname, o.protocol, g);
  }
  return typeof i.search == "string" && (o.search = se(i.search, g)), typeof i.hash == "string" && (o.hash = ne(i.hash, g)), o;
}
a$1(L$2, "applyInit");
function I$1(o) {
  return o.replace(/([+*?:{}()\\])/g, "\\$1");
}
a$1(I$1, "escapePatternString");
function Te(o) {
  return o.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
a$1(Te, "escapeRegexpString");
function Ae(o, i) {
  i.delimiter ??= "/#?", i.prefixes ??= "./", i.sensitive ??= !1, i.strict ??= !1, i.end ??= !0, i.start ??= !0, i.endsWith = "";
  let g = ".*", E = `[^${Te(i.delimiter)}]+?`, e = /[$_\u200C\u200D\p{ID_Continue}]/u, t = "";
  for (let n = 0; n < o.length; ++n) {
    let h = o[n];
    if (h.type === 3) {
      if (h.modifier === 3) {
        t += I$1(h.value);
        continue;
      }
      t += `{${I$1(h.value)}}${T(h.modifier)}`;
      continue;
    }
    let d = h.hasCustomName(), k = !!h.suffix.length || !!h.prefix.length && (h.prefix.length !== 1 || !i.prefixes.includes(h.prefix)), p = n > 0 ? o[n - 1] : null, M = n < o.length - 1 ? o[n + 1] : null;
    if (!k && d && h.type === 1 && h.modifier === 3 && M && !M.prefix.length && !M.suffix.length) if (M.type === 3) {
      let H = M.value.length > 0 ? M.value[0] : "";
      k = e.test(H);
    } else k = !M.hasCustomName();
    if (!k && !h.prefix.length && p && p.type === 3) {
      let H = p.value[p.value.length - 1];
      k = i.prefixes.includes(H);
    }
    k && (t += "{"), t += I$1(h.prefix), d && (t += `:${h.name}`), h.type === 2 ? t += `(${h.value})` : h.type === 1 ? d || (t += `(${E})`) : h.type === 0 && (!d && (!p || p.type === 3 || p.modifier !== 3 || k || h.prefix !== "") ? t += "*" : t += `(${g})`), h.type === 1 && d && h.suffix.length && e.test(h.suffix[0]) && (t += "\\"), t += I$1(h.suffix), k && (t += "}"), h.modifier !== 3 && (t += T(h.modifier));
  }
  return t;
}
a$1(Ae, "partsToPattern");
var Y = class {
  #Q;
  #C = {};
  #g = {};
  #A = {};
  #B = {};
  #e = !1;
  constructor(o = {}, i, g) {
    try {
      let E;
      if (typeof i == "string" ? E = i : g = i, typeof o == "string") {
        let h = new C(o);
        if (h.parse(), o = h.result, E === void 0 && typeof o.protocol != "string") throw new TypeError("A base URL must be provided for a relative constructor string.");
        o.baseURL = E;
      } else {
        if (!o || typeof o != "object") throw new TypeError("parameter 1 is not of type 'string' and cannot convert to dictionary.");
        if (E) throw new TypeError("parameter 1 is not of type 'string'.");
      }
      typeof g > "u" && (g = { ignoreCase: !1 });
      let e = { ignoreCase: g.ignoreCase === !0 }, t = { pathname: O, protocol: O, username: O, password: O, hostname: O, port: O, search: O, hash: O };
      this.#Q = L$2(t, o, !0), z$1(this.#Q.protocol) === this.#Q.port && (this.#Q.port = "");
      let n;
      for (n of V$1) {
        if (!(n in this.#Q)) continue;
        let h = {}, d = this.#Q[n];
        switch (this.#g[n] = [], n) {
          case "protocol":
            Object.assign(h, b), h.encodePart = w$1;
            break;
          case "username":
            Object.assign(h, b), h.encodePart = he;
            break;
          case "password":
            Object.assign(h, b), h.encodePart = ue;
            break;
          case "hostname":
            Object.assign(h, J$1), _$1(d) ? h.encodePart = K$1 : h.encodePart = j;
            break;
          case "port":
            Object.assign(h, b), h.encodePart = G$1;
            break;
          case "pathname":
            U$1(this.#C.protocol) ? (Object.assign(h, Q$1, e), h.encodePart = de) : (Object.assign(h, b, e), h.encodePart = pe);
            break;
          case "search":
            Object.assign(h, b, e), h.encodePart = ge;
            break;
          case "hash":
            Object.assign(h, b, e), h.encodePart = me;
            break;
        }
        try {
          this.#B[n] = F$1(d, h), this.#C[n] = W$1(this.#B[n], this.#g[n], h), this.#A[n] = Ae(this.#B[n], h), this.#e = this.#e || this.#B[n].some((k) => k.type === 2);
        } catch {
          throw new TypeError(`invalid ${n} pattern '${this.#Q[n]}'.`);
        }
      }
    } catch (E) {
      throw new TypeError(`Failed to construct 'URLPattern': ${E.message}`);
    }
  }
  get [Symbol.toStringTag]() {
    return "URLPattern";
  }
  test(o = {}, i) {
    let g = { pathname: "", protocol: "", username: "", password: "", hostname: "", port: "", search: "", hash: "" };
    if (typeof o != "string" && i) throw new TypeError("parameter 1 is not of type 'string'.");
    if (typeof o > "u") return !1;
    try {
      typeof o == "object" ? g = L$2(g, o, !1) : g = L$2(g, Se(o, i), !1);
    } catch {
      return !1;
    }
    let E;
    for (E of V$1) if (!this.#C[E].exec(g[E])) return !1;
    return !0;
  }
  exec(o = {}, i) {
    let g = { pathname: "", protocol: "", username: "", password: "", hostname: "", port: "", search: "", hash: "" };
    if (typeof o != "string" && i) throw new TypeError("parameter 1 is not of type 'string'.");
    if (typeof o > "u") return;
    try {
      typeof o == "object" ? g = L$2(g, o, !1) : g = L$2(g, Se(o, i), !1);
    } catch {
      return null;
    }
    let E = {};
    i ? E.inputs = [o, i] : E.inputs = [o];
    let e;
    for (e of V$1) {
      let t = this.#C[e].exec(g[e]);
      if (!t) return null;
      let n = {};
      for (let [h, d] of this.#g[e].entries()) if (typeof d == "string" || typeof d == "number") {
        let k = t[h + 1];
        n[d] = k;
      }
      E[e] = { input: g[e] ?? "", groups: n };
    }
    return E;
  }
  static compareComponent(o, i, g) {
    let E = a$1((h, d) => {
      for (let k of ["type", "modifier", "prefix", "value", "suffix"]) {
        if (h[k] < d[k]) return -1;
        if (h[k] !== d[k])
          return 1;
      }
      return 0;
    }, "comparePart"), e = new P$1(3, "", "", "", "", 3), t = new P$1(0, "", "", "", "", 3), n = a$1((h, d) => {
      let k = 0;
      for (; k < Math.min(h.length, d.length); ++k) {
        let p = E(h[k], d[k]);
        if (p) return p;
      }
      return h.length === d.length ? 0 : E(h[k] ?? e, d[k] ?? e);
    }, "comparePartList");
    return !i.#A[o] && !g.#A[o] ? 0 : i.#A[o] && !g.#A[o] ? n(i.#B[o], [t]) : !i.#A[o] && g.#A[o] ? n([t], g.#B[o]) : n(i.#B[o], g.#B[o]);
  }
  get protocol() {
    return this.#A.protocol;
  }
  get username() {
    return this.#A.username;
  }
  get password() {
    return this.#A.password;
  }
  get hostname() {
    return this.#A.hostname;
  }
  get port() {
    return this.#A.port;
  }
  get pathname() {
    return this.#A.pathname;
  }
  get search() {
    return this.#A.search;
  }
  get hash() {
    return this.#A.hash;
  }
  get hasRegExpGroups() {
    return this.#e;
  }
};
a$1(Y, "URLPattern");
globalThis.URLPattern || (globalThis.URLPattern = Y);
function isValidOrigin(o, i) {
  let g, E, e;
  try {
    g = new URLPattern(o), E = new URLPattern({
      protocol: g.protocol,
      hostname: g.hostname
    }), e = new URL(i);
  } catch {
    return !1;
  }
  return e.hostname === "localhost" && E.test(e) ? !0 : g.test(e);
}
function getCrossOriginAttribute(o, i) {
  if (i)
    try {
      const g = new URL(i);
      return StreamlitConfig.BACKEND_BASE_URL && g.origin === new URL(StreamlitConfig.BACKEND_BASE_URL).origin ? o : void 0;
    } catch {
      return StreamlitConfig.BACKEND_BASE_URL ? o : void 0;
    }
}
const useCrossOriginAttribute = (o) => {
  const {
    resourceCrossOriginMode: i
  } = useContext(LibConfigContext);
  if (o)
    return getCrossOriginAttribute(i, o);
}, useEmotionTheme = () => useTheme(), StyledChatMessageContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq4"
} : {
  target: "eeusbqq4",
  label: "StyledChatMessageContainer"
})(({
  theme: o,
  background: i
}) => {
  const g = hasLightBackgroundColor(o);
  return {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    gap: o.spacing.sm,
    padding: o.spacing.lg,
    paddingRight: i ? o.spacing.lg : 0,
    borderRadius: o.radii.default,
    ...i ? {
      backgroundColor: transparentize(g ? o.colors.gray20 : o.colors.gray90, 0.5)
    } : {}
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMessageContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq3"
} : {
  target: "eeusbqq3",
  label: "StyledMessageContent"
})(({
  theme: o
}) => ({
  color: o.colors.bodyText,
  margin: "auto",
  flexGrow: 1,
  // Ensure the size of the message has an interpreted width as
  // the amount defined by flex layout and disregard its contents
  // they will handle their overflow.
  //
  // Unintuitively, setting the min width to 0 tells the browser
  // that it can shrink past the content's width to the desired size.
  // https://makandracards.com/makandra/66994-css-flex-and-min-width
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarBackground = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq2"
} : {
  target: "eeusbqq2",
  label: "StyledAvatarBackground"
})(({
  theme: o
}) => {
  const i = hasLightBackgroundColor(o);
  return {
    display: "flex",
    border: `${o.sizes.borderWidth} solid ${i ? o.colors.gray40 : o.colors.gray85}`,
    backgroundColor: i ? o.colors.white : o.colors.gray100,
    color: i ? o.colors.gray90 : o.colors.white,
    lineHeight: o.lineHeights.none,
    fontSize: o.fontSizes.md,
    // Ensure the avatar always respects the width/height
    flexShrink: 0,
    width: o.sizes.chatAvatarSize,
    height: o.sizes.chatAvatarSize,
    borderRadius: o.radii.default,
    alignItems: "center",
    justifyContent: "center"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9DaGF0TWVzc2FnZS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0RHNDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9DaGF0TWVzc2FnZS9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUgfSBmcm9tIFwiY29sb3Iya1wiXG5cbmltcG9ydCB7IGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZENoYXRNZXNzYWdlQ29udGFpbmVyUHJvcHMge1xuICBiYWNrZ3JvdW5kOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDaGF0TWVzc2FnZUNvbnRhaW5lciA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkQ2hhdE1lc3NhZ2VDb250YWluZXJQcm9wcz4oKHsgdGhlbWUsIGJhY2tncm91bmQgfSkgPT4ge1xuICAgIGNvbnN0IGxpZ2h0VGhlbWUgPSBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcbiAgICByZXR1cm4ge1xuICAgICAgd2lkdGg6IFwiMTAwJVwiLFxuICAgICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImZsZXgtc3RhcnRcIixcbiAgICAgIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICAgIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgICBwYWRkaW5nUmlnaHQ6IGJhY2tncm91bmQgPyB0aGVtZS5zcGFjaW5nLmxnIDogMCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAgIC4uLihiYWNrZ3JvdW5kXG4gICAgICAgID8ge1xuICAgICAgICAgICAgYmFja2dyb3VuZENvbG9yOiBsaWdodFRoZW1lXG4gICAgICAgICAgICAgID8gdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmdyYXkyMCwgMC41KVxuICAgICAgICAgICAgICA6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5ncmF5OTAsIDAuNSksXG4gICAgICAgICAgfVxuICAgICAgICA6IHt9KSxcbiAgICB9XG4gIH0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZXNzYWdlQ29udGVudCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgbWFyZ2luOiBcImF1dG9cIixcbiAgZmxleEdyb3c6IDEsXG4gIC8vIEVuc3VyZSB0aGUgc2l6ZSBvZiB0aGUgbWVzc2FnZSBoYXMgYW4gaW50ZXJwcmV0ZWQgd2lkdGggYXNcbiAgLy8gdGhlIGFtb3VudCBkZWZpbmVkIGJ5IGZsZXggbGF5b3V0IGFuZCBkaXNyZWdhcmQgaXRzIGNvbnRlbnRzXG4gIC8vIHRoZXkgd2lsbCBoYW5kbGUgdGhlaXIgb3ZlcmZsb3cuXG4gIC8vXG4gIC8vIFVuaW50dWl0aXZlbHksIHNldHRpbmcgdGhlIG1pbiB3aWR0aCB0byAwIHRlbGxzIHRoZSBicm93c2VyXG4gIC8vIHRoYXQgaXQgY2FuIHNocmluayBwYXN0IHRoZSBjb250ZW50J3Mgd2lkdGggdG8gdGhlIGRlc2lyZWQgc2l6ZS5cbiAgLy8gaHR0cHM6Ly9tYWthbmRyYWNhcmRzLmNvbS9tYWthbmRyYS82Njk5NC1jc3MtZmxleC1hbmQtbWluLXdpZHRoXG4gIG1pbldpZHRoOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBdmF0YXJCYWNrZ3JvdW5kID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGxpZ2h0VGhlbWUgPSBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcbiAgcmV0dXJuIHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke1xuICAgICAgbGlnaHRUaGVtZSA/IHRoZW1lLmNvbG9ycy5ncmF5NDAgOiB0aGVtZS5jb2xvcnMuZ3JheTg1XG4gICAgfWAsXG4gICAgYmFja2dyb3VuZENvbG9yOiBsaWdodFRoZW1lID8gdGhlbWUuY29sb3JzLndoaXRlIDogdGhlbWUuY29sb3JzLmdyYXkxMDAsXG4gICAgY29sb3I6IGxpZ2h0VGhlbWUgPyB0aGVtZS5jb2xvcnMuZ3JheTkwIDogdGhlbWUuY29sb3JzLndoaXRlLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5tZCxcbiAgICAvLyBFbnN1cmUgdGhlIGF2YXRhciBhbHdheXMgcmVzcGVjdHMgdGhlIHdpZHRoL2hlaWdodFxuICAgIGZsZXhTaHJpbms6IDAsXG4gICAgd2lkdGg6IHRoZW1lLnNpemVzLmNoYXRBdmF0YXJTaXplLFxuICAgIGhlaWdodDogdGhlbWUuc2l6ZXMuY2hhdEF2YXRhclNpemUsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkQXZhdGFySWNvblByb3BzIHtcbiAgYmFja2dyb3VuZDogc3RyaW5nXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBdmF0YXJJY29uID0gc3R5bGVkLmRpdjxTdHlsZWRBdmF0YXJJY29uUHJvcHM+KFxuICAoeyB0aGVtZSwgYmFja2dyb3VuZCB9KSA9PiB7XG4gICAgY29uc3QgbGlnaHRUaGVtZSA9IGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yKHRoZW1lKVxuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgIHdpZHRoOiB0aGVtZS5zaXplcy5jaGF0QXZhdGFyU2l6ZSxcbiAgICAgIGhlaWdodDogdGhlbWUuc2l6ZXMuY2hhdEF2YXRhclNpemUsXG4gICAgICAvLyBFbnN1cmUgdGhlIGF2YXRhciBhbHdheXMgcmVzcGVjdHMgdGhlIHdpZHRoL2hlaWdodFxuICAgICAgZmxleFNocmluazogMCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogYmFja2dyb3VuZCxcbiAgICAgIGNvbG9yOiBsaWdodFRoZW1lID8gdGhlbWUuY29sb3JzLndoaXRlIDogdGhlbWUuY29sb3JzLmdyYXkxMDAsXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBdmF0YXJJbWFnZSA9IHN0eWxlZC5pbWcoKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIHdpZHRoOiB0aGVtZS5zaXplcy5jaGF0QXZhdGFyU2l6ZSxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmNoYXRBdmF0YXJTaXplLFxuICAgIC8vIEVuc3VyZSB0aGUgYXZhdGFyIGFsd2F5cyByZXNwZWN0cyB0aGUgd2lkdGgvaGVpZ2h0XG4gICAgZmxleFNocmluazogMCxcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgb2JqZWN0Rml0OiBcImNvdmVyXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gIH1cbn0pXG4iXX0= */"), StyledAvatarIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq1"
} : {
  target: "eeusbqq1",
  label: "StyledAvatarIcon"
})(({
  theme: o,
  background: i
}) => {
  const g = hasLightBackgroundColor(o);
  return {
    display: "flex",
    width: o.sizes.chatAvatarSize,
    height: o.sizes.chatAvatarSize,
    // Ensure the avatar always respects the width/height
    flexShrink: 0,
    borderRadius: o.radii.default,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: i,
    color: g ? o.colors.white : o.colors.gray100
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarImage = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq0"
} : {
  target: "eeusbqq0",
  label: "StyledAvatarImage"
})(({
  theme: o
}) => ({
  width: o.sizes.chatAvatarSize,
  height: o.sizes.chatAvatarSize,
  // Ensure the avatar always respects the width/height
  flexShrink: 0,
  borderRadius: o.radii.default,
  objectFit: "cover",
  display: "flex"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ChatMessageAvatar(o) {
  const {
    avatar: i,
    avatarType: g,
    name: E,
    endpoints: e
  } = o, t = useEmotionTheme(), n = useCrossOriginAttribute(i);
  if (i)
    switch (g) {
      case void 0:
        break;
      case Block$1.ChatMessage.AvatarType.IMAGE:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarImage, { src: e.buildMediaURL(i), alt: `${E} avatar`, crossOrigin: n });
      case Block$1.ChatMessage.AvatarType.EMOJI:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { children: i });
      case Block$1.ChatMessage.AvatarType.ICON:
        if (i === "user")
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarIcon, { "data-testid": "stChatMessageAvatarUser", background: t.colors.redColor, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/face:" }) });
        if (i === "assistant")
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarIcon, { "data-testid": "stChatMessageAvatarAssistant", background: t.colors.orangeColor, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/smart_toy:" }) });
        if (i.startsWith(":material"))
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { "data-testid": "stChatMessageAvatarCustom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: i, color: t.colors.bodyText }) });
    }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { children: E ? E.charAt(0).toUpperCase() : "🧑‍💻" });
}
const ChatMessage = ({
  endpoints: o,
  element: i,
  children: g
}) => {
  const {
    avatar: E,
    avatarType: e,
    name: t
  } = i;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledChatMessageContainer, { className: "stChatMessage", "data-testid": "stChatMessage", background: ["user", "human"].includes(t.toLowerCase()), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatMessageAvatar, { name: t, avatar: E, avatarType: e, endpoints: o }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMessageContent, { "data-testid": "stChatMessageContent", "aria-label": `Chat message from ${t}`, children: g })
  ] });
}, ChatMessage$1 = memo(ChatMessage), IsDialogContext = createContext(!1);
IsDialogContext.displayName = "IsDialogContext";
function _objectWithoutPropertiesLoose$q(o, i) {
  if (o == null) return {};
  var g = {};
  for (var E in o) if ({}.hasOwnProperty.call(o, E)) {
    if (i.indexOf(E) !== -1) continue;
    g[E] = o[E];
  }
  return g;
}
var propTypes$1 = { exports: {} };
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var o = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
  function E(t) {
    if (t == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(t);
  }
  function e() {
    try {
      if (!Object.assign)
        return !1;
      var t = new String("abc");
      if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5")
        return !1;
      for (var n = {}, h = 0; h < 10; h++)
        n["_" + String.fromCharCode(h)] = h;
      var d = Object.getOwnPropertyNames(n).map(function(p) {
        return n[p];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var k = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        k[p] = p;
      }), Object.keys(Object.assign({}, k)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = e() ? Object.assign : function(t, n) {
    for (var h, d = E(t), k, p = 1; p < arguments.length; p++) {
      h = Object(arguments[p]);
      for (var M in h)
        i.call(h, M) && (d[M] = h[M]);
      if (o) {
        k = o(h);
        for (var H = 0; H < k.length; H++)
          g.call(h, k[H]) && (d[k[H]] = h[k[H]]);
      }
    }
    return d;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var o = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = o, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var o = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var i = /* @__PURE__ */ requireReactPropTypesSecret(), g = {}, E = /* @__PURE__ */ requireHas();
    o = function(t) {
      var n = "Warning: " + t;
      typeof console < "u" && console.error(n);
      try {
        throw new Error(n);
      } catch {
      }
    };
  }
  function e(t, n, h, d, k) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in t)
        if (E(t, p)) {
          var M;
          try {
            if (typeof t[p] != "function") {
              var H = Error(
                (d || "React class") + ": " + h + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw H.name = "Invariant Violation", H;
            }
            M = t[p](n, p, d, h, null, i);
          } catch (AA) {
            M = AA;
          }
          if (M && !(M instanceof Error) && o(
            (d || "React class") + ": type specification of " + h + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof M + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), M instanceof Error && !(M.message in g)) {
            g[M.message] = !0;
            var f = k ? k() : "";
            o(
              "Failed " + h + " type: " + M.message + (f ?? "")
            );
          }
        }
    }
  }
  return e.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (g = {});
  }, checkPropTypes_1 = e, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var o = requireReactIs$1(), i = requireObjectAssign(), g = /* @__PURE__ */ requireReactPropTypesSecret(), E = /* @__PURE__ */ requireHas(), e = /* @__PURE__ */ requireCheckPropTypes(), t = function() {
  };
  process.env.NODE_ENV !== "production" && (t = function(h) {
    var d = "Warning: " + h;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function n() {
    return null;
  }
  return factoryWithTypeCheckers = function(h, d) {
    var k = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function M(lA) {
      var kA = lA && (k && lA[k] || lA[p]);
      if (typeof kA == "function")
        return kA;
    }
    var H = "<<anonymous>>", f = {
      array: BA("array"),
      bigint: BA("bigint"),
      bool: BA("boolean"),
      func: BA("function"),
      number: BA("number"),
      object: BA("object"),
      string: BA("string"),
      symbol: BA("symbol"),
      any: CA(),
      arrayOf: QA,
      element: iA(),
      elementType: EA(),
      instanceOf: oA,
      node: tA(),
      objectOf: GA,
      oneOf: eA,
      oneOfType: cA,
      shape: sA,
      exact: DA
    };
    function AA(lA, kA) {
      return lA === kA ? lA !== 0 || 1 / lA === 1 / kA : lA !== lA && kA !== kA;
    }
    function gA(lA, kA) {
      this.message = lA, this.data = kA && typeof kA == "object" ? kA : {}, this.stack = "";
    }
    gA.prototype = Error.prototype;
    function IA(lA) {
      if (process.env.NODE_ENV !== "production")
        var kA = {}, ZA = 0;
      function wA(fA, dA, RA, KA, xA, MA, OA) {
        if (KA = KA || H, MA = MA || RA, OA !== g) {
          if (d) {
            var SA = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw SA.name = "Invariant Violation", SA;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var gg = KA + ":" + RA;
            !kA[gg] && // Avoid spamming the console because they are often not actionable except for lib authors
            ZA < 3 && (t(
              "You are manually calling a React.PropTypes validation function for the `" + MA + "` prop on `" + KA + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), kA[gg] = !0, ZA++);
          }
        }
        return dA[RA] == null ? fA ? dA[RA] === null ? new gA("The " + xA + " `" + MA + "` is marked as required " + ("in `" + KA + "`, but its value is `null`.")) : new gA("The " + xA + " `" + MA + "` is marked as required in " + ("`" + KA + "`, but its value is `undefined`.")) : null : lA(dA, RA, KA, xA, MA);
      }
      var LA = wA.bind(null, !1);
      return LA.isRequired = wA.bind(null, !0), LA;
    }
    function BA(lA) {
      function kA(ZA, wA, LA, fA, dA, RA) {
        var KA = ZA[wA], xA = NA(KA);
        if (xA !== lA) {
          var MA = pA(KA);
          return new gA(
            "Invalid " + fA + " `" + dA + "` of type " + ("`" + MA + "` supplied to `" + LA + "`, expected ") + ("`" + lA + "`."),
            { expectedType: lA }
          );
        }
        return null;
      }
      return IA(kA);
    }
    function CA() {
      return IA(n);
    }
    function QA(lA) {
      function kA(ZA, wA, LA, fA, dA) {
        if (typeof lA != "function")
          return new gA("Property `" + dA + "` of component `" + LA + "` has invalid PropType notation inside arrayOf.");
        var RA = ZA[wA];
        if (!Array.isArray(RA)) {
          var KA = NA(RA);
          return new gA("Invalid " + fA + " `" + dA + "` of type " + ("`" + KA + "` supplied to `" + LA + "`, expected an array."));
        }
        for (var xA = 0; xA < RA.length; xA++) {
          var MA = lA(RA, xA, LA, fA, dA + "[" + xA + "]", g);
          if (MA instanceof Error)
            return MA;
        }
        return null;
      }
      return IA(kA);
    }
    function iA() {
      function lA(kA, ZA, wA, LA, fA) {
        var dA = kA[ZA];
        if (!h(dA)) {
          var RA = NA(dA);
          return new gA("Invalid " + LA + " `" + fA + "` of type " + ("`" + RA + "` supplied to `" + wA + "`, expected a single ReactElement."));
        }
        return null;
      }
      return IA(lA);
    }
    function EA() {
      function lA(kA, ZA, wA, LA, fA) {
        var dA = kA[ZA];
        if (!o.isValidElementType(dA)) {
          var RA = NA(dA);
          return new gA("Invalid " + LA + " `" + fA + "` of type " + ("`" + RA + "` supplied to `" + wA + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return IA(lA);
    }
    function oA(lA) {
      function kA(ZA, wA, LA, fA, dA) {
        if (!(ZA[wA] instanceof lA)) {
          var RA = lA.name || H, KA = XA(ZA[wA]);
          return new gA("Invalid " + fA + " `" + dA + "` of type " + ("`" + KA + "` supplied to `" + LA + "`, expected ") + ("instance of `" + RA + "`."));
        }
        return null;
      }
      return IA(kA);
    }
    function eA(lA) {
      if (!Array.isArray(lA))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? t(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : t("Invalid argument supplied to oneOf, expected an array.")), n;
      function kA(ZA, wA, LA, fA, dA) {
        for (var RA = ZA[wA], KA = 0; KA < lA.length; KA++)
          if (AA(RA, lA[KA]))
            return null;
        var xA = JSON.stringify(lA, function(OA, SA) {
          var gg = pA(SA);
          return gg === "symbol" ? String(SA) : SA;
        });
        return new gA("Invalid " + fA + " `" + dA + "` of value `" + String(RA) + "` " + ("supplied to `" + LA + "`, expected one of " + xA + "."));
      }
      return IA(kA);
    }
    function GA(lA) {
      function kA(ZA, wA, LA, fA, dA) {
        if (typeof lA != "function")
          return new gA("Property `" + dA + "` of component `" + LA + "` has invalid PropType notation inside objectOf.");
        var RA = ZA[wA], KA = NA(RA);
        if (KA !== "object")
          return new gA("Invalid " + fA + " `" + dA + "` of type " + ("`" + KA + "` supplied to `" + LA + "`, expected an object."));
        for (var xA in RA)
          if (E(RA, xA)) {
            var MA = lA(RA, xA, LA, fA, dA + "." + xA, g);
            if (MA instanceof Error)
              return MA;
          }
        return null;
      }
      return IA(kA);
    }
    function cA(lA) {
      if (!Array.isArray(lA))
        return process.env.NODE_ENV !== "production" && t("Invalid argument supplied to oneOfType, expected an instance of array."), n;
      for (var kA = 0; kA < lA.length; kA++) {
        var ZA = lA[kA];
        if (typeof ZA != "function")
          return t(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + mA(ZA) + " at index " + kA + "."
          ), n;
      }
      function wA(LA, fA, dA, RA, KA) {
        for (var xA = [], MA = 0; MA < lA.length; MA++) {
          var OA = lA[MA], SA = OA(LA, fA, dA, RA, KA, g);
          if (SA == null)
            return null;
          SA.data && E(SA.data, "expectedType") && xA.push(SA.data.expectedType);
        }
        var gg = xA.length > 0 ? ", expected one of type [" + xA.join(", ") + "]" : "";
        return new gA("Invalid " + RA + " `" + KA + "` supplied to " + ("`" + dA + "`" + gg + "."));
      }
      return IA(wA);
    }
    function tA() {
      function lA(kA, ZA, wA, LA, fA) {
        return rA(kA[ZA]) ? null : new gA("Invalid " + LA + " `" + fA + "` supplied to " + ("`" + wA + "`, expected a ReactNode."));
      }
      return IA(lA);
    }
    function aA(lA, kA, ZA, wA, LA) {
      return new gA(
        (lA || "React class") + ": " + kA + " type `" + ZA + "." + wA + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + LA + "`."
      );
    }
    function sA(lA) {
      function kA(ZA, wA, LA, fA, dA) {
        var RA = ZA[wA], KA = NA(RA);
        if (KA !== "object")
          return new gA("Invalid " + fA + " `" + dA + "` of type `" + KA + "` " + ("supplied to `" + LA + "`, expected `object`."));
        for (var xA in lA) {
          var MA = lA[xA];
          if (typeof MA != "function")
            return aA(LA, fA, dA, xA, pA(MA));
          var OA = MA(RA, xA, LA, fA, dA + "." + xA, g);
          if (OA)
            return OA;
        }
        return null;
      }
      return IA(kA);
    }
    function DA(lA) {
      function kA(ZA, wA, LA, fA, dA) {
        var RA = ZA[wA], KA = NA(RA);
        if (KA !== "object")
          return new gA("Invalid " + fA + " `" + dA + "` of type `" + KA + "` " + ("supplied to `" + LA + "`, expected `object`."));
        var xA = i({}, ZA[wA], lA);
        for (var MA in xA) {
          var OA = lA[MA];
          if (E(lA, MA) && typeof OA != "function")
            return aA(LA, fA, dA, MA, pA(OA));
          if (!OA)
            return new gA(
              "Invalid " + fA + " `" + dA + "` key `" + MA + "` supplied to `" + LA + "`.\nBad object: " + JSON.stringify(ZA[wA], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(lA), null, "  ")
            );
          var SA = OA(RA, MA, LA, fA, dA + "." + MA, g);
          if (SA)
            return SA;
        }
        return null;
      }
      return IA(kA);
    }
    function rA(lA) {
      switch (typeof lA) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !lA;
        case "object":
          if (Array.isArray(lA))
            return lA.every(rA);
          if (lA === null || h(lA))
            return !0;
          var kA = M(lA);
          if (kA) {
            var ZA = kA.call(lA), wA;
            if (kA !== lA.entries) {
              for (; !(wA = ZA.next()).done; )
                if (!rA(wA.value))
                  return !1;
            } else
              for (; !(wA = ZA.next()).done; ) {
                var LA = wA.value;
                if (LA && !rA(LA[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function nA(lA, kA) {
      return lA === "symbol" ? !0 : kA ? kA["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && kA instanceof Symbol : !1;
    }
    function NA(lA) {
      var kA = typeof lA;
      return Array.isArray(lA) ? "array" : lA instanceof RegExp ? "object" : nA(kA, lA) ? "symbol" : kA;
    }
    function pA(lA) {
      if (typeof lA > "u" || lA === null)
        return "" + lA;
      var kA = NA(lA);
      if (kA === "object") {
        if (lA instanceof Date)
          return "date";
        if (lA instanceof RegExp)
          return "regexp";
      }
      return kA;
    }
    function mA(lA) {
      var kA = pA(lA);
      switch (kA) {
        case "array":
        case "object":
          return "an " + kA;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + kA;
        default:
          return kA;
      }
    }
    function XA(lA) {
      return !lA.constructor || !lA.constructor.name ? H : lA.constructor.name;
    }
    return f.checkPropTypes = e, f.resetWarningCache = e.resetWarningCache, f.PropTypes = f, f;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var o = /* @__PURE__ */ requireReactPropTypesSecret();
  function i() {
  }
  function g() {
  }
  return g.resetWarningCache = i, factoryWithThrowingShims = function() {
    function E(n, h, d, k, p, M) {
      if (M !== o) {
        var H = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw H.name = "Invariant Violation", H;
      }
    }
    E.isRequired = E;
    function e() {
      return E;
    }
    var t = {
      array: E,
      bigint: E,
      bool: E,
      func: E,
      number: E,
      object: E,
      string: E,
      symbol: E,
      any: E,
      arrayOf: e,
      element: E,
      elementType: E,
      instanceOf: e,
      node: E,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: g,
      resetWarningCache: i
    };
    return t.PropTypes = t, t;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes$1.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var o = requireReactIs$1(), i = !0;
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(o.isElement, i);
  } else
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes$1.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var FOCUS_GROUP = "data-focus-lock", FOCUS_DISABLED = "data-focus-lock-disabled", FOCUS_ALLOW = "data-no-focus-lock", FOCUS_AUTO = "data-autofocus-inside", FOCUS_NO_AUTOFOCUS = "data-no-autofocus";
function assignRef(o, i) {
  return typeof o == "function" ? o(i) : o && (o.current = i), o;
}
function useCallbackRef(o, i) {
  var g = useState(function() {
    return {
      // value
      value: o,
      // last callback
      callback: i,
      // "memoized" public interface
      facade: {
        get current() {
          return g.value;
        },
        set current(E) {
          var e = g.value;
          e !== E && (g.value = E, g.callback(E, e));
        }
      }
    };
  })[0];
  return g.callback = i, g.facade;
}
var useIsomorphicLayoutEffect = typeof window < "u" ? React.useLayoutEffect : React.useEffect, currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(o, i) {
  var g = useCallbackRef(null, function(E) {
    return o.forEach(function(e) {
      return assignRef(e, E);
    });
  });
  return useIsomorphicLayoutEffect(function() {
    var E = currentValues.get(g);
    if (E) {
      var e = new Set(E), t = new Set(o), n = g.current;
      e.forEach(function(h) {
        t.has(h) || assignRef(h, null);
      }), t.forEach(function(h) {
        e.has(h) || assignRef(h, n);
      });
    }
    currentValues.set(g, o);
  }, [o]), g;
}
var hiddenGuard = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && PropTypes.node;
function ItoI(o) {
  return o;
}
function innerCreateMedium(o, i) {
  i === void 0 && (i = ItoI);
  var g = [], E = !1, e = {
    read: function() {
      if (E)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return g.length ? g[g.length - 1] : o;
    },
    useMedium: function(t) {
      var n = i(t, E);
      return g.push(n), function() {
        g = g.filter(function(h) {
          return h !== n;
        });
      };
    },
    assignSyncMedium: function(t) {
      for (E = !0; g.length; ) {
        var n = g;
        g = [], n.forEach(t);
      }
      g = {
        push: function(h) {
          return t(h);
        },
        filter: function() {
          return g;
        }
      };
    },
    assignMedium: function(t) {
      E = !0;
      var n = [];
      if (g.length) {
        var h = g;
        g = [], h.forEach(t), n = g;
      }
      var d = function() {
        var p = n;
        n = [], p.forEach(t);
      }, k = function() {
        return Promise.resolve().then(d);
      };
      k(), g = {
        push: function(p) {
          n.push(p), k();
        },
        filter: function(p) {
          return n = n.filter(p), g;
        }
      };
    }
  };
  return e;
}
function createMedium(o, i) {
  return i === void 0 && (i = ItoI), innerCreateMedium(o, i);
}
function createSidecarMedium(o) {
  o === void 0 && (o = {});
  var i = innerCreateMedium(null);
  return i.options = __assign$2({ async: !0, ssr: !1 }, o), i;
}
var mediumFocus = createMedium({}, function(o) {
  var i = o.target, g = o.currentTarget;
  return {
    target: i,
    currentTarget: g
  };
}), mediumBlur = createMedium(), mediumEffect = createMedium(), mediumSidecar = createSidecarMedium({
  async: !0,
  ssr: typeof document < "u"
}), focusScope = /* @__PURE__ */ createContext(void 0), emptyArray = [], FocusLock = /* @__PURE__ */ forwardRef(function o(i, g) {
  var E, e = useState(), t = e[0], n = e[1], h = useRef(), d = useRef(!1), k = useRef(null), p = useState({}), M = p[1], H = i.children, f = i.disabled, AA = f === void 0 ? !1 : f, gA = i.noFocusGuards, IA = gA === void 0 ? !1 : gA, BA = i.persistentFocus, CA = BA === void 0 ? !1 : BA, QA = i.crossFrame, iA = QA === void 0 ? !0 : QA, EA = i.autoFocus, oA = EA === void 0 ? !0 : EA, eA = i.allowTextSelection, GA = i.group, cA = i.className, tA = i.whiteList, aA = i.hasPositiveIndices, sA = i.shards, DA = sA === void 0 ? emptyArray : sA, rA = i.as, nA = rA === void 0 ? "div" : rA, NA = i.lockProps, pA = NA === void 0 ? {} : NA, mA = i.sideCar, XA = i.returnFocus, lA = XA === void 0 ? !1 : XA, kA = i.focusOptions, ZA = i.onActivation, wA = i.onDeactivation, LA = useState({}), fA = LA[0], dA = useCallback(function($A) {
    var ag = $A.captureFocusRestore;
    if (!k.current) {
      var Ig, tg = (Ig = document) == null ? void 0 : Ig.activeElement;
      k.current = tg, tg !== document.body && (k.current = ag(tg));
    }
    h.current && ZA && ZA(h.current), d.current = !0, M();
  }, [ZA]), RA = useCallback(function() {
    d.current = !1, wA && wA(h.current), M();
  }, [wA]), KA = useCallback(function($A) {
    var ag = k.current;
    if (ag) {
      var Ig = (typeof ag == "function" ? ag() : ag) || document.body, tg = typeof lA == "function" ? lA(Ig) : lA;
      if (tg) {
        var wg = typeof tg == "object" ? tg : void 0;
        k.current = null, $A ? Promise.resolve().then(function() {
          return Ig.focus(wg);
        }) : Ig.focus(wg);
      }
    }
  }, [lA]), xA = useCallback(function($A) {
    d.current && mediumFocus.useMedium($A);
  }, []), MA = mediumBlur.useMedium, OA = useCallback(function($A) {
    h.current !== $A && (h.current = $A, n($A));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof eA < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), useEffect(function() {
    !h.current && typeof nA != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var SA = _extends$C((E = {}, E[FOCUS_DISABLED] = AA && "disabled", E[FOCUS_GROUP] = GA, E), pA), gg = IA !== !0, WA = gg && IA !== "tail", eg = useMergeRefs([g, OA]), ig = useMemo$1(function() {
    return {
      observed: h,
      shards: DA,
      enabled: !AA,
      active: d.current
    };
  }, [AA, d.current, DA, t]);
  return /* @__PURE__ */ React__default.createElement(Fragment, null, gg && [
    /* @__PURE__ */ React__default.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: AA ? -1 : 0,
      style: hiddenGuard
    }),
    aA ? /* @__PURE__ */ React__default.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: AA ? -1 : 1,
      style: hiddenGuard
    }) : null
  ], !AA && /* @__PURE__ */ React__default.createElement(mA, {
    id: fA,
    sideCar: mediumSidecar,
    observed: t,
    disabled: AA,
    persistentFocus: CA,
    crossFrame: iA,
    autoFocus: oA,
    whiteList: tA,
    shards: DA,
    onActivation: dA,
    onDeactivation: RA,
    returnFocus: KA,
    focusOptions: kA,
    noFocusGuards: IA
  }), /* @__PURE__ */ React__default.createElement(nA, _extends$C({
    ref: eg
  }, SA, {
    className: cA,
    onBlur: MA,
    onFocus: xA
  }), /* @__PURE__ */ React__default.createElement(focusScope.Provider, {
    value: ig
  }, H)), WA && /* @__PURE__ */ React__default.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: AA ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypesExports.node,
  disabled: propTypesExports.bool,
  returnFocus: propTypesExports.oneOfType([propTypesExports.bool, propTypesExports.object, propTypesExports.func]),
  focusOptions: propTypesExports.object,
  noFocusGuards: propTypesExports.bool,
  hasPositiveIndices: propTypesExports.bool,
  allowTextSelection: propTypesExports.bool,
  autoFocus: propTypesExports.bool,
  persistentFocus: propTypesExports.bool,
  crossFrame: propTypesExports.bool,
  group: propTypesExports.string,
  className: propTypesExports.string,
  whiteList: propTypesExports.func,
  shards: propTypesExports.arrayOf(propTypesExports.any),
  as: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.func, propTypesExports.object]),
  lockProps: propTypesExports.object,
  onActivation: propTypesExports.func,
  onDeactivation: propTypesExports.func,
  sideCar: propTypesExports.any.isRequired
} : {};
function _setPrototypeOf$e(o, i) {
  return _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, E) {
    return g.__proto__ = E, g;
  }, _setPrototypeOf$e(o, i);
}
function _inheritsLoose(o, i) {
  o.prototype = Object.create(i.prototype), o.prototype.constructor = o, _setPrototypeOf$e(o, i);
}
function _typeof$g(o) {
  "@babel/helpers - typeof";
  return _typeof$g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$g(o);
}
function toPrimitive$2(o, i) {
  if (_typeof$g(o) != "object" || !o) return o;
  var g = o[Symbol.toPrimitive];
  if (g !== void 0) {
    var E = g.call(o, i);
    if (_typeof$g(E) != "object") return E;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (i === "string" ? String : Number)(o);
}
function toPropertyKey$2(o) {
  var i = toPrimitive$2(o, "string");
  return _typeof$g(i) == "symbol" ? i : i + "";
}
function _defineProperty$u(o, i, g) {
  return (i = toPropertyKey$2(i)) in o ? Object.defineProperty(o, i, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[i] = g, o;
}
function withSideEffect(o, i) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof o != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof i != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function g(E) {
    return E.displayName || E.name || "Component";
  }
  return function(e) {
    if (process.env.NODE_ENV !== "production" && typeof e != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var t = [], n;
    function h() {
      n = o(t.map(function(k) {
        return k.props;
      })), i(n);
    }
    var d = /* @__PURE__ */ (function(k) {
      _inheritsLoose(p, k);
      function p() {
        return k.apply(this, arguments) || this;
      }
      p.peek = function() {
        return n;
      };
      var M = p.prototype;
      return M.componentDidMount = function() {
        t.push(this), h();
      }, M.componentDidUpdate = function() {
        h();
      }, M.componentWillUnmount = function() {
        var f = t.indexOf(this);
        t.splice(f, 1), h();
      }, M.render = function() {
        return /* @__PURE__ */ React__default.createElement(e, this.props);
      }, p;
    })(PureComponent);
    return _defineProperty$u(d, "displayName", "SideEffect(" + g(e) + ")"), d;
  };
}
var toArray$2 = function(o) {
  for (var i = Array(o.length), g = 0; g < o.length; ++g)
    i[g] = o[g];
  return i;
}, asArray = function(o) {
  return Array.isArray(o) ? o : [o];
}, getFirst = function(o) {
  return Array.isArray(o) ? o[0] : o;
}, isElementHidden = function(o) {
  if (o.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var i = window.getComputedStyle(o, null);
  return !i || !i.getPropertyValue ? !1 : i.getPropertyValue("display") === "none" || i.getPropertyValue("visibility") === "hidden";
}, getParentNode = function(o) {
  return o.parentNode && o.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    o.parentNode.host
  ) : o.parentNode;
}, isTopNode = function(o) {
  return o === document || o && o.nodeType === Node.DOCUMENT_NODE;
}, isInert = function(o) {
  return o.hasAttribute("inert");
}, isVisibleUncached = function(o, i) {
  return !o || isTopNode(o) || !isElementHidden(o) && !isInert(o) && i(getParentNode(o));
}, isVisibleCached = function(o, i) {
  var g = o.get(i);
  if (g !== void 0)
    return g;
  var E = isVisibleUncached(i, isVisibleCached.bind(void 0, o));
  return o.set(i, E), E;
}, isAutoFocusAllowedUncached = function(o, i) {
  return o && !isTopNode(o) ? isAutoFocusAllowed(o) ? i(getParentNode(o)) : !1 : !0;
}, isAutoFocusAllowedCached = function(o, i) {
  var g = o.get(i);
  if (g !== void 0)
    return g;
  var E = isAutoFocusAllowedUncached(i, isAutoFocusAllowedCached.bind(void 0, o));
  return o.set(i, E), E;
}, getDataset = function(o) {
  return o.dataset;
}, isHTMLButtonElement = function(o) {
  return o.tagName === "BUTTON";
}, isHTMLInputElement = function(o) {
  return o.tagName === "INPUT";
}, isRadioElement = function(o) {
  return isHTMLInputElement(o) && o.type === "radio";
}, notHiddenInput = function(o) {
  return !((isHTMLInputElement(o) || isHTMLButtonElement(o)) && (o.type === "hidden" || o.disabled));
}, isAutoFocusAllowed = function(o) {
  var i = o.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![!0, "true", ""].includes(i);
}, isGuard = function(o) {
  var i;
  return !!(o && (!((i = getDataset(o)) === null || i === void 0) && i.focusGuard));
}, isNotAGuard = function(o) {
  return !isGuard(o);
}, isDefined = function(o) {
  return !!o;
}, tabSort = function(o, i) {
  var g = Math.max(0, o.tabIndex), E = Math.max(0, i.tabIndex), e = g - E, t = o.index - i.index;
  if (e) {
    if (!g)
      return 1;
    if (!E)
      return -1;
  }
  return e || t;
}, getTabIndex = function(o) {
  return o.tabIndex < 0 && !o.hasAttribute("tabindex") ? 0 : o.tabIndex;
}, orderByTabIndex = function(o, i, g) {
  return toArray$2(o).map(function(E, e) {
    var t = getTabIndex(E);
    return {
      node: E,
      index: e,
      tabIndex: g && t === -1 ? (E.dataset || {}).focusGuard ? 0 : -1 : t
    };
  }).filter(function(E) {
    return !i || E.tabIndex >= 0;
  }).sort(tabSort);
}, tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], queryTabbables = tabbables.join(","), queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]"), getFocusablesWithShadowDom = function(o, i) {
  return toArray$2((o.shadowRoot || o).children).reduce(function(g, E) {
    return g.concat(E.matches(i ? queryGuardTabbables : queryTabbables) ? [E] : [], getFocusablesWithShadowDom(E));
  }, []);
}, getFocusablesWithIFrame = function(o, i) {
  var g;
  return o instanceof HTMLIFrameElement && (!((g = o.contentDocument) === null || g === void 0) && g.body) ? getFocusables([o.contentDocument.body], i) : [o];
}, getFocusables = function(o, i) {
  return o.reduce(function(g, E) {
    var e, t = getFocusablesWithShadowDom(E, i), n = (e = []).concat.apply(e, t.map(function(h) {
      return getFocusablesWithIFrame(h, i);
    }));
    return g.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      n,
      // add if node is tabbable itself
      E.parentNode ? toArray$2(E.parentNode.querySelectorAll(queryTabbables)).filter(function(h) {
        return h === E;
      }) : []
    );
  }, []);
}, getParentAutofocusables = function(o) {
  var i = o.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray$2(i).map(function(g) {
    return getFocusables([g]);
  }).reduce(function(g, E) {
    return g.concat(E);
  }, []);
}, filterFocusable = function(o, i) {
  return toArray$2(o).filter(function(g) {
    return isVisibleCached(i, g);
  }).filter(function(g) {
    return notHiddenInput(g);
  });
}, filterAutoFocusable = function(o, i) {
  return i === void 0 && (i = /* @__PURE__ */ new Map()), toArray$2(o).filter(function(g) {
    return isAutoFocusAllowedCached(i, g);
  });
}, getTabbableNodes = function(o, i, g) {
  return orderByTabIndex(filterFocusable(getFocusables(o, g), i), !0, g);
}, getFocusableNodes = function(o, i) {
  return orderByTabIndex(filterFocusable(getFocusables(o), i), !1);
}, parentAutofocusables = function(o, i) {
  return filterFocusable(getParentAutofocusables(o), i);
}, contains = function(o, i) {
  return o.shadowRoot ? contains(o.shadowRoot, i) : Object.getPrototypeOf(o).contains !== void 0 && Object.getPrototypeOf(o).contains.call(o, i) ? !0 : toArray$2(o.children).some(function(g) {
    var E;
    if (g instanceof HTMLIFrameElement) {
      var e = (E = g.contentDocument) === null || E === void 0 ? void 0 : E.body;
      return e ? contains(e, i) : !1;
    }
    return contains(g, i);
  });
}, filterNested = function(o) {
  for (var i = /* @__PURE__ */ new Set(), g = o.length, E = 0; E < g; E += 1)
    for (var e = E + 1; e < g; e += 1) {
      var t = o[E].compareDocumentPosition(o[e]);
      (t & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && i.add(e), (t & Node.DOCUMENT_POSITION_CONTAINS) > 0 && i.add(E);
    }
  return o.filter(function(n, h) {
    return !i.has(h);
  });
}, getTopParent = function(o) {
  return o.parentNode ? getTopParent(o.parentNode) : o;
}, getAllAffectedNodes = function(o) {
  var i = asArray(o);
  return i.filter(Boolean).reduce(function(g, E) {
    var e = E.getAttribute(FOCUS_GROUP);
    return g.push.apply(g, e ? filterNested(toArray$2(getTopParent(E).querySelectorAll("[".concat(FOCUS_GROUP, '="').concat(e, '"]:not([').concat(FOCUS_DISABLED, '="disabled"])')))) : [E]), g;
  }, []);
}, safeProbe = function(o) {
  try {
    return o();
  } catch {
    return;
  }
}, getActiveElement = function(o) {
  if (o === void 0 && (o = document), !(!o || !o.activeElement)) {
    var i = o.activeElement;
    return i.shadowRoot ? getActiveElement(i.shadowRoot) : i instanceof HTMLIFrameElement && safeProbe(function() {
      return i.contentWindow.document;
    }) ? getActiveElement(i.contentWindow.document) : i;
  }
}, focusInFrame = function(o, i) {
  return o === i;
}, focusInsideIframe = function(o, i) {
  return !!toArray$2(o.querySelectorAll("iframe")).some(function(g) {
    return focusInFrame(g, i);
  });
}, focusInside = function(o, i) {
  return i === void 0 && (i = getActiveElement(getFirst(o).ownerDocument)), !i || i.dataset && i.dataset.focusGuard ? !1 : getAllAffectedNodes(o).some(function(g) {
    return contains(g, i) || focusInsideIframe(g, i);
  });
}, focusIsHidden = function(o) {
  o === void 0 && (o = document);
  var i = getActiveElement(o);
  return i ? toArray$2(o.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function(g) {
    return contains(g, i);
  }) : !1;
}, findSelectedRadio = function(o, i) {
  return i.filter(isRadioElement).filter(function(g) {
    return g.name === o.name;
  }).filter(function(g) {
    return g.checked;
  })[0] || o;
}, correctNode = function(o, i) {
  return isRadioElement(o) && o.name ? findSelectedRadio(o, i) : o;
}, correctNodes = function(o) {
  var i = /* @__PURE__ */ new Set();
  return o.forEach(function(g) {
    return i.add(correctNode(g, o));
  }), o.filter(function(g) {
    return i.has(g);
  });
}, pickFirstFocus = function(o) {
  return o[0] && o.length > 1 ? correctNode(o[0], o) : o[0];
}, pickFocusable = function(o, i) {
  return o.indexOf(correctNode(i, o));
}, NEW_FOCUS = "NEW_FOCUS", newFocus = function(o, i, g, E, e) {
  var t = o.length, n = o[0], h = o[t - 1], d = isGuard(E);
  if (!(E && o.indexOf(E) >= 0)) {
    var k = E !== void 0 ? g.indexOf(E) : -1, p = e ? g.indexOf(e) : k, M = e ? o.indexOf(e) : -1;
    if (k === -1)
      return M !== -1 ? M : NEW_FOCUS;
    if (M === -1)
      return NEW_FOCUS;
    var H = k - p, f = g.indexOf(n), AA = g.indexOf(h), gA = correctNodes(g), IA = E !== void 0 ? gA.indexOf(E) : -1, BA = e ? gA.indexOf(e) : IA, CA = gA.filter(function(GA) {
      return GA.tabIndex >= 0;
    }), QA = E !== void 0 ? CA.indexOf(E) : -1, iA = e ? CA.indexOf(e) : QA, EA = QA >= 0 && iA >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      iA - QA
    ) : (
      // or else measure in focusable space
      BA - IA
    );
    if (!H && M >= 0 || i.length === 0)
      return M;
    var oA = pickFocusable(o, i[0]), eA = pickFocusable(o, i[i.length - 1]);
    if (k <= f && d && Math.abs(H) > 1)
      return eA;
    if (k >= AA && d && Math.abs(H) > 1)
      return oA;
    if (H && Math.abs(EA) > 1)
      return M;
    if (k <= f)
      return eA;
    if (k > AA)
      return oA;
    if (H)
      return Math.abs(H) > 1 ? M : (t + M + H) % t;
  }
}, findAutoFocused = function(o) {
  return function(i) {
    var g, E = (g = getDataset(i)) === null || g === void 0 ? void 0 : g.autofocus;
    return (
      // @ts-expect-error
      i.autofocus || //
      E !== void 0 && E !== "false" || //
      o.indexOf(i) >= 0
    );
  };
}, pickAutofocus = function(o, i, g) {
  var E = o.map(function(t) {
    var n = t.node;
    return n;
  }), e = filterAutoFocusable(E.filter(findAutoFocused(g)));
  return e && e.length ? pickFirstFocus(e) : pickFirstFocus(filterAutoFocusable(i));
}, getParents = function(o, i) {
  return i === void 0 && (i = []), i.push(o), o.parentNode && getParents(o.parentNode.host || o.parentNode, i), i;
}, getCommonParent = function(o, i) {
  for (var g = getParents(o), E = getParents(i), e = 0; e < g.length; e += 1) {
    var t = g[e];
    if (E.indexOf(t) >= 0)
      return t;
  }
  return !1;
}, getTopCommonParent = function(o, i, g) {
  var E = asArray(o), e = asArray(i), t = E[0], n = !1;
  return e.filter(Boolean).forEach(function(h) {
    n = getCommonParent(n || h, h) || n, g.filter(Boolean).forEach(function(d) {
      var k = getCommonParent(t, d);
      k && (!n || contains(k, n) ? n = k : n = getCommonParent(k, n));
    });
  }), n;
}, allParentAutofocusables = function(o, i) {
  return o.reduce(function(g, E) {
    return g.concat(parentAutofocusables(E, i));
  }, []);
}, reorderNodes = function(o, i) {
  var g = /* @__PURE__ */ new Map();
  return i.forEach(function(E) {
    return g.set(E.node, E);
  }), o.map(function(E) {
    return g.get(E);
  }).filter(isDefined);
}, focusSolver = function(o, i) {
  var g = getActiveElement(asArray(o).length > 0 ? document : getFirst(o).ownerDocument), E = getAllAffectedNodes(o).filter(isNotAGuard), e = getTopCommonParent(g || o, o, E), t = /* @__PURE__ */ new Map(), n = getFocusableNodes(E, t), h = n.filter(function(AA) {
    var gA = AA.node;
    return isNotAGuard(gA);
  });
  if (h[0]) {
    var d = getFocusableNodes([e], t).map(function(AA) {
      var gA = AA.node;
      return gA;
    }), k = reorderNodes(d, h), p = k.map(function(AA) {
      var gA = AA.node;
      return gA;
    }), M = k.filter(function(AA) {
      var gA = AA.tabIndex;
      return gA >= 0;
    }).map(function(AA) {
      var gA = AA.node;
      return gA;
    }), H = newFocus(p, M, d, g, i);
    if (H === NEW_FOCUS) {
      var f = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        pickAutofocus(n, M, allParentAutofocusables(E, t)) || pickAutofocus(n, p, allParentAutofocusables(E, t))
      );
      if (f)
        return { node: f };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return H === void 0 ? H : k[H];
  }
}, expandFocusableNodes = function(o) {
  var i = getAllAffectedNodes(o).filter(isNotAGuard), g = getTopCommonParent(o, o, i), E = orderByTabIndex(getFocusables([g], !0), !0, !0), e = getFocusables(i, !1);
  return E.map(function(t) {
    var n = t.node, h = t.index;
    return {
      node: n,
      index: h,
      lockItem: e.indexOf(n) >= 0,
      guard: isGuard(n)
    };
  });
}, focusOn = function(o, i) {
  o && ("focus" in o && o.focus(i), "contentWindow" in o && o.contentWindow && o.contentWindow.focus());
}, guardCount = 0, lockDisabled = !1, moveFocusInside = function(o, i, g) {
  g === void 0 && (g = {});
  var E = focusSolver(o, i);
  if (!lockDisabled && E) {
    if (guardCount > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), lockDisabled = !0, setTimeout(function() {
        lockDisabled = !1;
      }, 1);
      return;
    }
    guardCount++, focusOn(E.node, g.focusOptions), guardCount--;
  }
};
function weakRef(o) {
  if (!o)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return o || null;
    };
  var i = o ? new WeakRef(o) : null;
  return function() {
    return i?.deref() || null;
  };
}
var recordElementLocation = function(o) {
  if (!o)
    return null;
  for (var i = [], g = o; g && g !== document.body; )
    i.push({
      current: weakRef(g),
      parent: weakRef(g.parentElement),
      left: weakRef(g.previousElementSibling),
      right: weakRef(g.nextElementSibling)
    }), g = g.parentElement;
  return {
    element: weakRef(o),
    stack: i,
    ownerDocument: o.ownerDocument
  };
}, restoreFocusTo = function(o) {
  var i, g, E, e, t;
  if (o)
    for (var n = o.stack, h = o.ownerDocument, d = /* @__PURE__ */ new Map(), k = 0, p = n; k < p.length; k++) {
      var M = p[k], H = (i = M.parent) === null || i === void 0 ? void 0 : i.call(M);
      if (H && h.contains(H)) {
        for (var f = (g = M.left) === null || g === void 0 ? void 0 : g.call(M), AA = M.current(), gA = H.contains(AA) ? AA : void 0, IA = (E = M.right) === null || E === void 0 ? void 0 : E.call(M), BA = getTabbableNodes([H], d), CA = (
          // that is element itself
          (t = (e = gA ?? f?.nextElementSibling) !== null && e !== void 0 ? e : (
            // or somebody to the right, still close enough
            IA
          )) !== null && t !== void 0 ? t : (
            // or somebody to the left, something?
            f
          )
        ); CA; ) {
          for (var QA = 0, iA = BA; QA < iA.length; QA++) {
            var EA = iA[QA];
            if (CA?.contains(EA.node))
              return EA.node;
          }
          CA = CA.nextElementSibling;
        }
        if (BA.length)
          return BA[0].node;
      }
    }
}, captureFocusRestore = function(o) {
  var i = recordElementLocation(o);
  return function() {
    return restoreFocusTo(i);
  };
}, getRelativeFocusable = function(o, i, g) {
  if (!o || !i)
    return console.error("no element or scope given"), {};
  var E = asArray(i);
  if (E.every(function(n) {
    return !contains(n, o);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var e = g ? getTabbableNodes(E, /* @__PURE__ */ new Map()) : getFocusableNodes(E, /* @__PURE__ */ new Map()), t = e.findIndex(function(n) {
    var h = n.node;
    return h === o;
  });
  if (t !== -1)
    return {
      prev: e[t - 1],
      next: e[t + 1],
      first: e[0],
      last: e[e.length - 1]
    };
}, getBoundary = function(o, i) {
  var g = i ? getTabbableNodes(asArray(o), /* @__PURE__ */ new Map()) : getFocusableNodes(asArray(o), /* @__PURE__ */ new Map());
  return {
    first: g[0],
    last: g[g.length - 1]
  };
}, defaultOptions$1 = function(o) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, o);
}, moveFocus = function(o, i, g) {
  i === void 0 && (i = {});
  var E = defaultOptions$1(i), e = getRelativeFocusable(o, E.scope, E.onlyTabbable);
  if (e) {
    var t = g(e, E.cycle);
    t && focusOn(t.node, E.focusOptions);
  }
}, focusNextElement = function(o, i) {
  i === void 0 && (i = {}), moveFocus(o, i, function(g, E) {
    var e = g.next, t = g.first;
    return e || E && t;
  });
}, focusPrevElement = function(o, i) {
  i === void 0 && (i = {}), moveFocus(o, i, function(g, E) {
    var e = g.prev, t = g.last;
    return e || E && t;
  });
}, pickBoundary = function(o, i, g) {
  var E, e = getBoundary(o, (E = i.onlyTabbable) !== null && E !== void 0 ? E : !0), t = e[g];
  t && focusOn(t.node, i.focusOptions);
}, focusFirstElement = function(o, i) {
  i === void 0 && (i = {}), pickBoundary(o, i, "first");
}, focusLastElement = function(o, i) {
  i === void 0 && (i = {}), pickBoundary(o, i, "last");
};
function deferAction(o) {
  setTimeout(o, 1);
}
var inlineProp = function o(i, g) {
  var E = {};
  return E[i] = g, E;
}, extractRef = function o(i) {
  return i && "current" in i ? i.current : i;
}, focusOnBody = function o() {
  return document && document.activeElement === document.body;
}, isFreeFocus = function o() {
  return focusOnBody() || focusIsHidden();
}, lastActiveTrap = null, lastActiveFocus = null, tryRestoreFocus = function o() {
  return null;
}, lastPortaledElement = null, focusWasOutsideWindow = !1, windowFocused = !1, defaultWhitelist = function o() {
  return !0;
}, focusWhitelisted = function o(i) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(i);
}, recordPortal = function o(i, g) {
  lastPortaledElement = {
    observerNode: i,
    portaledElement: g
  };
}, focusIsPortaledPair = function o(i) {
  return lastPortaledElement && lastPortaledElement.portaledElement === i;
};
function autoGuard(o, i, g, E) {
  var e = null, t = o;
  do {
    var n = E[t];
    if (n.guard)
      n.node.dataset.focusAutoGuard && (e = n);
    else if (n.lockItem) {
      if (t !== o)
        return;
      e = null;
    } else
      break;
  } while ((t += g) !== i);
  e && (e.node.tabIndex = 0);
}
var focusWasOutside = function o(i) {
  return i ? !!focusWasOutsideWindow : focusWasOutsideWindow === "meanwhile";
}, checkInHost = function o(i, g, E) {
  return g && (g.host === i && (!g.activeElement || E.contains(g.activeElement)) || g.parentNode && o(i, g.parentNode, E));
}, withinHost = function o(i, g) {
  return g.some(function(E) {
    return checkInHost(i, E, E);
  });
}, getNodeFocusables = function o(i) {
  return getFocusableNodes(i, /* @__PURE__ */ new Map());
}, isNotFocusable = function o(i) {
  return !getNodeFocusables([i.parentNode]).some(function(g) {
    return g.node === i;
  });
}, activateTrap = function o() {
  var i = !1;
  if (lastActiveTrap) {
    var g = lastActiveTrap, E = g.observed, e = g.persistentFocus, t = g.autoFocus, n = g.shards, h = g.crossFrame, d = g.focusOptions, k = g.noFocusGuards, p = E || lastPortaledElement && lastPortaledElement.portaledElement;
    if (focusOnBody() && lastActiveFocus && lastActiveFocus !== document.body && (!document.body.contains(lastActiveFocus) || isNotFocusable(lastActiveFocus))) {
      var M = tryRestoreFocus();
      M && M.focus();
    }
    var H = document && document.activeElement;
    if (p) {
      var f = [p].concat(n.map(extractRef).filter(Boolean)), AA = function() {
        if (!focusWasOutside(h) || !k || !lastActiveFocus || windowFocused)
          return !1;
        var QA = getNodeFocusables(f), iA = QA.findIndex(function(EA) {
          var oA = EA.node;
          return oA === lastActiveFocus;
        });
        return iA === 0 || iA === QA.length - 1;
      };
      if ((!H || focusWhitelisted(H)) && (e || AA() || !isFreeFocus() || !lastActiveFocus && t) && (p && !(focusInside(f) || H && withinHost(H, f) || focusIsPortaledPair(H)) && (document && !lastActiveFocus && H && !t ? (H.blur && H.blur(), document.body.focus()) : (i = moveFocusInside(f, lastActiveFocus, {
        focusOptions: d
      }), lastPortaledElement = {})), lastActiveFocus = document && document.activeElement, lastActiveFocus !== document.body && (tryRestoreFocus = captureFocusRestore(lastActiveFocus)), focusWasOutsideWindow = !1), document && H !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var gA = document && document.activeElement, IA = expandFocusableNodes(f), BA = IA.map(function(CA) {
          var QA = CA.node;
          return QA;
        }).indexOf(gA);
        BA > -1 && (IA.filter(function(CA) {
          var QA = CA.guard, iA = CA.node;
          return QA && iA.dataset.focusAutoGuard;
        }).forEach(function(CA) {
          var QA = CA.node;
          return QA.removeAttribute("tabIndex");
        }), autoGuard(BA, IA.length, 1, IA), autoGuard(BA, -1, -1, IA));
      }
    }
  }
  return i;
}, onTrap = function o(i) {
  activateTrap() && i && (i.stopPropagation(), i.preventDefault());
}, onBlur = function o() {
  return deferAction(activateTrap);
}, onFocus = function o(i) {
  var g = i.target, E = i.currentTarget;
  E.contains(g) || recordPortal(E, g);
}, FocusWatcher = function o() {
  return null;
};
process.env.NODE_ENV !== "production" && PropTypes.node.isRequired;
var onWindowFocus = function o() {
  windowFocused = !0;
}, onWindowBlur = function o() {
  windowFocused = !1, focusWasOutsideWindow = "just", deferAction(function() {
    focusWasOutsideWindow = "meanwhile";
  });
}, attachHandler = function o() {
  document.addEventListener("focusin", onTrap), document.addEventListener("focusout", onBlur), window.addEventListener("focus", onWindowFocus), window.addEventListener("blur", onWindowBlur);
}, detachHandler = function o() {
  document.removeEventListener("focusin", onTrap), document.removeEventListener("focusout", onBlur), window.removeEventListener("focus", onWindowFocus), window.removeEventListener("blur", onWindowBlur);
};
function reducePropsToState(o) {
  return o.filter(function(i) {
    var g = i.disabled;
    return !g;
  });
}
var focusLockAPI = {
  moveFocusInside,
  focusInside,
  focusNextElement,
  focusPrevElement,
  focusFirstElement,
  focusLastElement,
  captureFocusRestore
};
function handleStateChangeOnClient(o) {
  var i = o.slice(-1)[0];
  i && !lastActiveTrap && attachHandler();
  var g = lastActiveTrap, E = g && i && i.id === g.id;
  lastActiveTrap = i, g && !E && (g.onDeactivation(), o.filter(function(e) {
    var t = e.id;
    return t === g.id;
  }).length || g.returnFocus(!i)), i ? (lastActiveFocus = null, (!E || g.observed !== i.observed) && i.onActivation(focusLockAPI), activateTrap(), deferAction(activateTrap)) : (detachHandler(), lastActiveFocus = null);
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function(o) {
  return o(focusLockAPI);
});
const FocusTrap = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);
var FocusLockCombination = /* @__PURE__ */ forwardRef(function o(i, g) {
  return /* @__PURE__ */ React__default.createElement(FocusLock, _extends$C({
    sideCar: FocusTrap,
    ref: g
  }, i));
}), _ref = FocusLock.propTypes || {};
_ref.sideCar;
var propTypes = _objectWithoutPropertiesLoose$q(_ref, ["sideCar"]);
FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
var useFocusInside = function o(i) {
  useEffect(function() {
    var g = !0;
    return mediumEffect.useMedium(function(E) {
      var e = i && i.current;
      g && e && (E.focusInside(e) || E.moveFocusInside(e, null));
    }), function() {
      g = !1;
    };
  }, [i]);
};
function MoveFocusInside(o) {
  var i = o.disabled, g = i === void 0 ? !1 : i, E = o.className, e = o.children, t = useRef(null);
  return useFocusInside(g ? void 0 : t), /* @__PURE__ */ React__default.createElement("div", _extends$C({}, inlineProp(FOCUS_AUTO, !g), {
    ref: t,
    className: E
  }), e);
}
MoveFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};
var SIZE$2 = {
  default: "default",
  full: "full",
  auto: "auto"
}, SIZE_WIDTHS = {
  default: "500px",
  full: "100%",
  auto: "auto"
}, ROLE = {
  dialog: "dialog"
}, CLOSE_SOURCE = {
  closeButton: "closeButton",
  backdrop: "backdrop",
  escape: "escape"
};
function ownKeys$p(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$n(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$p(Object(g), !0).forEach(function(E) {
      _defineProperty$t(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$p(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$t(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function getSizeStyles(o) {
  var i = {
    maxWidth: "100%",
    width: null
  };
  return typeof o == "number" ? i.width = "".concat(o, "px") : SIZE$2[o] ? i.width = SIZE_WIDTHS[o] : typeof o == "string" && (i.width = o), o === SIZE$2.full && (i.alignSelf = "stretch"), i;
}
var Root$3 = styled("div", function(o) {
  var i = o.$isOpen;
  return {
    position: "fixed",
    overflow: "auto",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    pointerEvents: i ? "auto" : "none"
  };
});
Root$3.displayName = "Root";
Root$3.displayName = "Root";
var DialogContainer = styled("div", function(o) {
  var i = o.$animate, g = o.$isOpen, E = o.$isVisible, e = o.$theme, t = {
    transitionProperty: "opacity",
    transitionDuration: e.animation.timing400,
    transitionTimingFunction: e.animation.easeOutCurve
  };
  return _objectSpread$n({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100%",
    userSelect: "none",
    pointerEvents: "auto",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    // Remove grey highlight
    WebkitTapHighlightColor: "transparent",
    opacity: E && g ? 1 : 0
  }, i ? t : null);
});
DialogContainer.displayName = "DialogContainer";
DialogContainer.displayName = "DialogContainer";
var Dialog$2 = styled("div", function(o) {
  var i = o.$animate, g = o.$isOpen, E = o.$isVisible, e = o.$size, t = o.$theme;
  return _objectSpread$n(_objectSpread$n(_objectSpread$n({
    position: "relative",
    backgroundColor: t.colors.backgroundPrimary,
    borderTopLeftRadius: t.borders.radius500,
    borderTopRightRadius: t.borders.radius500,
    borderBottomRightRadius: t.borders.radius500,
    borderBottomLeftRadius: t.borders.radius500,
    marginLeft: t.sizing.scale600,
    marginTop: t.sizing.scale600,
    marginRight: t.sizing.scale600,
    marginBottom: t.sizing.scale600
  }, getSizeStyles(e)), {}, {
    // Animation
    opacity: E && g ? 1 : 0,
    transform: E ? "translateY(0)" : "translateY(20px)"
  }, i ? {
    transitionProperty: "opacity, transform",
    transitionDuration: t.animation.timing400,
    transitionTimingFunction: t.animation.easeOutCurve
  } : null), {}, {
    // Reset interactivity properties set by container
    userSelect: "text",
    pointerEvents: g ? "all" : "none",
    // We move focus to the modal, but we don't want the blue outline style
    ":focus": {
      outline: "none"
    }
  });
});
Dialog$2.displayName = "Dialog";
Dialog$2.displayName = "Dialog";
var Close = styled("button", function(o) {
  var i, g = o.$theme, E = o.$isFocusVisible, e = g.direction === "rtl" ? "left" : "right";
  return i = {
    // Reset button styles
    background: "transparent",
    outline: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    // colors
    color: g.colors.modalCloseColor,
    transitionProperty: "color, border-color",
    transitionDuration: g.animation.timing200,
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderTopColor: "transparent",
    borderBottomColor: "transparent",
    ":hover": {
      color: g.colors.modalCloseColorHover
    },
    ":focus": {
      outline: E ? "3px solid ".concat(g.colors.accent) : "none"
    },
    // Positioning
    position: "absolute",
    top: g.sizing.scale500
  }, _defineProperty$t(i, e, g.sizing.scale500), _defineProperty$t(i, "width", g.sizing.scale800), _defineProperty$t(i, "height", g.sizing.scale800), _defineProperty$t(i, "display", "flex"), _defineProperty$t(i, "justifyContent", "center"), _defineProperty$t(i, "alignItems", "center"), _defineProperty$t(i, "cursor", "pointer"), i;
});
Close.displayName = "Close";
Close.displayName = "Close";
var ModalHeader$1 = styled("div", function(o) {
  var i, g = o.$theme, E = g.direction === "rtl" ? "marginRight" : "marginLeft", e = g.direction === "rtl" ? "marginLeft" : "marginRight";
  return _objectSpread$n(_objectSpread$n({}, g.typography.font550), {}, (i = {
    color: g.colors.contentPrimary,
    marginTop: g.sizing.scale900,
    marginBottom: g.sizing.scale600
  }, _defineProperty$t(i, E, g.sizing.scale800), _defineProperty$t(i, e, g.sizing.scale900), i));
});
ModalHeader$1.displayName = "ModalHeader";
ModalHeader$1.displayName = "ModalHeader";
var ModalBody$2 = styled("div", function(o) {
  var i = o.$theme;
  return _objectSpread$n(_objectSpread$n({}, i.typography.font200), {}, {
    color: i.colors.contentSecondary,
    marginTop: i.sizing.scale600,
    marginLeft: i.sizing.scale800,
    marginRight: i.sizing.scale800,
    marginBottom: i.sizing.scale700
  });
});
ModalBody$2.displayName = "ModalBody";
ModalBody$2.displayName = "ModalBody";
var ModalFooter$1 = styled("div", function(o) {
  var i = o.$theme;
  return _objectSpread$n(_objectSpread$n({}, i.typography.font200), {}, {
    marginTop: i.sizing.scale700,
    marginLeft: i.sizing.scale800,
    marginRight: i.sizing.scale800,
    paddingTop: i.sizing.scale500,
    paddingBottom: i.sizing.scale500,
    textAlign: i.direction === "rtl" ? "left" : "right"
  });
});
ModalFooter$1.displayName = "ModalFooter";
ModalFooter$1.displayName = "ModalFooter";
function CloseIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    style: {
      stroke: "currentColor"
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M9 1L5 5M1 9L5 5M5 5L1 1M5 5L9 9",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
}
function _typeof$f(o) {
  "@babel/helpers - typeof";
  return _typeof$f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$f(o);
}
function _extends$v() {
  return _extends$v = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$v.apply(this, arguments);
}
function _slicedToArray$l(o, i) {
  return _arrayWithHoles$k(o) || _iterableToArrayLimit$k(o, i) || _unsupportedIterableToArray$k(o, i) || _nonIterableRest$k();
}
function _nonIterableRest$k() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$k(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$k(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$k(o, i);
  }
}
function _arrayLikeToArray$k(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$k(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$k(o) {
  if (Array.isArray(o)) return o;
}
function _classCallCheck$d(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$d(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$d(o, i, g) {
  return i && _defineProperties$d(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$d(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$d(o, i);
}
function _setPrototypeOf$d(o, i) {
  return _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$d(o, i);
}
function _createSuper$d(o) {
  var i = _isNativeReflectConstruct$d();
  return function() {
    var E = _getPrototypeOf$d(o), e;
    if (i) {
      var t = _getPrototypeOf$d(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$d(this, e);
  };
}
function _possibleConstructorReturn$d(o, i) {
  if (i && (_typeof$f(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$e(o);
}
function _assertThisInitialized$e(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$d() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$d(o) {
  return _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$d(o);
}
function _defineProperty$s(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var Modal$1 = /* @__PURE__ */ (function(o) {
  _inherits$d(g, o);
  var i = _createSuper$d(g);
  function g() {
    var E;
    _classCallCheck$d(this, g);
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = i.call.apply(i, [this].concat(t)), _defineProperty$s(_assertThisInitialized$e(E), "animateOutTimer", void 0), _defineProperty$s(_assertThisInitialized$e(E), "animateStartTimer", void 0), _defineProperty$s(_assertThisInitialized$e(E), "dialogContainerRef", /* @__PURE__ */ React.createRef()), _defineProperty$s(_assertThisInitialized$e(E), "lastFocus", null), _defineProperty$s(_assertThisInitialized$e(E), "lastMountNodeOverflowStyle", null), _defineProperty$s(_assertThisInitialized$e(E), "rootRef", /* @__PURE__ */ React.createRef()), _defineProperty$s(_assertThisInitialized$e(E), "state", {
      isVisible: !1,
      mounted: !1,
      isFocusVisible: !1
    }), _defineProperty$s(_assertThisInitialized$e(E), "handleFocus", function(h) {
      isFocusVisible(h) && E.setState({
        isFocusVisible: !0
      });
    }), _defineProperty$s(_assertThisInitialized$e(E), "handleBlur", function(h) {
      E.state.isFocusVisible !== !1 && E.setState({
        isFocusVisible: !1
      });
    }), _defineProperty$s(_assertThisInitialized$e(E), "onEscape", function() {
      E.props.closeable && E.triggerClose(CLOSE_SOURCE.escape);
    }), _defineProperty$s(_assertThisInitialized$e(E), "onDocumentClick", function(h) {
      h.target && h.target instanceof HTMLElement && h.target.contains(E.dialogContainerRef.current) && E.onBackdropClick();
    }), _defineProperty$s(_assertThisInitialized$e(E), "onBackdropClick", function() {
      E.props.closeable && E.triggerClose(CLOSE_SOURCE.backdrop);
    }), _defineProperty$s(_assertThisInitialized$e(E), "onCloseClick", function() {
      E.triggerClose(CLOSE_SOURCE.closeButton);
    }), _defineProperty$s(_assertThisInitialized$e(E), "animateOutComplete", function() {
      E.setState({
        isVisible: !1
      });
    }), E;
  }
  return _createClass$d(g, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        mounted: !0
      }), process.env.NODE_ENV !== "production" && this.props.closable && console.warn("The property `closable` is not supported on the Modal. Did you mean `closeable`?");
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.resetMountNodeScroll(), this.clearTimers();
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      var n = this.props.isOpen;
      // If isOpen is changing *or* we just mounted and modal should be open
      (n !== e.isOpen || n && this.state.mounted && !t.mounted) && (n ? this.didOpen() : this.didClose());
    }
  }, {
    key: "disableMountNodeScroll",
    value: function() {
      var e = this.getMountNode();
      this.lastMountNodeOverflowStyle = e.style.overflow || "", e.style.overflow = "hidden";
    }
  }, {
    key: "resetMountNodeScroll",
    value: function() {
      var e = this.getMountNode(), t = this.lastMountNodeOverflowStyle;
      e && t !== null && (e.style.overflow === "hidden" && (e.style.overflow = t || ""), this.lastMountNodeOverflowStyle = null);
    }
  }, {
    key: "clearTimers",
    value: function() {
      this.animateOutTimer && clearTimeout(this.animateOutTimer), this.animateStartTimer && cancelAnimationFrame(this.animateStartTimer);
    }
  }, {
    key: "didOpen",
    value: function() {
      var e = this, t = this.rootRef.current;
      t && (t.scrollTop = 0), this.clearTimers(), this.disableMountNodeScroll(), this.animateStartTimer = requestAnimationFrame(function() {
        e.setState({
          isVisible: !0
        });
      });
    }
  }, {
    key: "didClose",
    value: function() {
      this.resetMountNodeScroll(), this.animateOutTimer = setTimeout(this.animateOutComplete, 500);
    }
  }, {
    key: "triggerClose",
    value: function(e) {
      this.props.onClose && e && this.props.onClose({
        closeSource: e
      });
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.animate, n = e.isOpen, h = e.size, d = e.role, k = e.closeable;
      return {
        $animate: t,
        $isVisible: this.state.isVisible,
        $isOpen: !!n,
        $size: h,
        $role: d,
        $closeable: !!k,
        $isFocusVisible: this.state.isFocusVisible
      };
    }
  }, {
    key: "getMountNode",
    value: function() {
      var e = this.props.mountNode;
      return e || document.body;
    }
  }, {
    key: "getChildren",
    value: function() {
      var e = this.props.children;
      return typeof e == "function" ? e() : e;
    }
  }, {
    key: "renderModal",
    value: function() {
      var e = this, t = this.props, n = t.overrides, h = n === void 0 ? {} : n, d = t.closeable, k = t.role, p = t.autoFocus, M = t.focusLock, H = t.returnFocus, f = h.Root, AA = h.Dialog, gA = h.DialogContainer, IA = h.Close, BA = getOverrides(f, Root$3), CA = _slicedToArray$l(BA, 2), QA = CA[0], iA = CA[1], EA = getOverrides(gA, DialogContainer), oA = _slicedToArray$l(EA, 2), eA = oA[0], GA = oA[1], cA = getOverrides(AA, Dialog$2), tA = _slicedToArray$l(cA, 2), aA = tA[0], sA = tA[1], DA = getOverrides(IA, Close), rA = _slicedToArray$l(DA, 2), nA = rA[0], NA = rA[1], pA = this.getSharedProps(), mA = this.getChildren();
      return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(XA) {
        return /* @__PURE__ */ React.createElement(FocusLockCombination, {
          disabled: !M,
          crossFrame: !1,
          returnFocus: H,
          autoFocus: p
        }, /* @__PURE__ */ React.createElement(QA, _extends$v({
          "data-baseweb": "modal",
          ref: e.rootRef
        }, pA, iA), /* @__PURE__ */ React.createElement(
          eA,
          _extends$v({
            ref: e.dialogContainerRef
          }, pA, GA),
          /* @__PURE__ */ React.createElement(aA, _extends$v({
            tabIndex: -1,
            "aria-modal": !0,
            "aria-label": "dialog",
            role: k
          }, pA, sA), mA, d ? /* @__PURE__ */ React.createElement(nA, _extends$v({
            "aria-label": XA.modal.close,
            onClick: e.onCloseClick
          }, pA, NA, {
            onFocus: forkFocus(NA, e.handleFocus),
            onBlur: forkBlur(NA, e.handleBlur)
          }), /* @__PURE__ */ React.createElement(CloseIcon, null)) : null)
        )));
      });
    }
  }, {
    key: "render",
    value: function() {
      return !this.state.mounted || !this.props.isOpen && !this.state.isVisible ? null : /* @__PURE__ */ React.createElement(Layer, {
        onEscape: this.onEscape,
        onDocumentClick: this.onDocumentClick,
        mountNode: this.props.mountNode
      }, this.renderModal());
    }
  }]), g;
})(React.Component);
_defineProperty$s(Modal$1, "defaultProps", {
  animate: !0,
  autoFocus: !0,
  focusLock: !0,
  returnFocus: !0,
  closeable: !0,
  name: "dialog",
  isOpen: !1,
  overrides: {},
  role: ROLE.dialog,
  size: SIZE$2.default
});
var BaseButtonKind = /* @__PURE__ */ ((o) => (o.PRIMARY = "primary", o.SECONDARY = "secondary", o.TERTIARY = "tertiary", o.GHOST = "ghost", o.BORDERLESS_ICON = "borderlessIcon", o.BORDERLESS_ICON_ACTIVE = "borderlessIconActive", o.MINIMAL = "minimal", o.PRIMARY_FORM_SUBMIT = "primaryFormSubmit", o.SECONDARY_FORM_SUBMIT = "secondaryFormSubmit", o.TERTIARY_FORM_SUBMIT = "tertiaryFormSubmit", o.HEADER_BUTTON = "header", o.HEADER_NO_PADDING = "headerNoPadding", o.ELEMENT_TOOLBAR = "elementToolbar", o.PILLS = "pills", o.PILLS_ACTIVE = "pillsActive", o.SEGMENTED_CONTROL = "segmented_control", o.SEGMENTED_CONTROL_ACTIVE = "segmented_controlActive", o))(BaseButtonKind || {}), BaseButtonSize = /* @__PURE__ */ ((o) => (o.XSMALL = "xsmall", o.SMALL = "small", o.MEDIUM = "medium", o.LARGE = "large", o))(BaseButtonSize || {});
function getSizeStyle(o, i) {
  switch (o) {
    case "xsmall":
      return {
        padding: `${i.spacing.twoXS} ${i.spacing.sm}`,
        fontSize: i.fontSizes.sm
      };
    case "small":
      return {
        padding: `${i.spacing.twoXS} ${i.spacing.md}`
      };
    case "large":
      return {
        padding: `${i.spacing.md} ${i.spacing.md}`
      };
    default:
      return {
        padding: `${i.spacing.xs} ${i.spacing.md}`
      };
  }
}
const StyledBaseButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc24"
} : {
  target: "ef3psqc24",
  label: "StyledBaseButton"
})(({
  containerWidth: o,
  size: i,
  theme: g
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: g.fontWeights.normal,
  padding: `${g.spacing.xs} ${g.spacing.md}`,
  borderRadius: g.radii.button,
  minHeight: g.sizes.minElementHeight,
  margin: g.spacing.none,
  lineHeight: g.lineHeights.base,
  textTransform: "none",
  fontSize: "inherit",
  fontFamily: "inherit",
  color: "inherit",
  width: o ? "100%" : "auto",
  cursor: "pointer",
  userSelect: "none",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    // When focus-visible (e.g. if the button was focused via keyboard navigation)
    // we use the hover style of the respective button type (see below) and
    // additionally show a colored focus ring
    boxShadow: g.shadows.focusRing
  },
  ...getSizeStyle(i, g)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPrimaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc23"
} : {
  target: "ef3psqc23",
  label: "StyledPrimaryButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.primary,
  color: o.colors.white,
  border: `${o.sizes.borderWidth} solid ${o.colors.primary}`,
  "&:hover, &:focus-visible": {
    backgroundColor: darken(o.colors.primary, 0.15),
    borderColor: darken(o.colors.primary, 0.15)
  },
  "&:active": {
    backgroundColor: o.colors.primary,
    // Keep the border darker when clicked so that the button looks "pressed"
    borderColor: darken(o.colors.primary, 0.15)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.transparent,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc22"
} : {
  target: "ef3psqc22",
  label: "StyledSecondaryButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.lightenedBg05,
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  "&:hover, &:focus-visible": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: o.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.transparent,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTertiaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc21"
} : {
  target: "ef3psqc21",
  label: "StyledTertiaryButton"
})(({
  theme: o
}) => ({
  padding: o.spacing.none,
  backgroundColor: o.colors.transparent,
  border: "none",
  "&:hover, &:focus-visible": {
    color: o.colors.primary
  },
  "&:hover:not(:disabled), &:focus-visible:not(:disabled)": {
    // Also make colored text have the primary color on hover. Since text color is
    // applied as an inline style we need to use !important to override it.
    // Note that we're not doing this when disabled. We should probably do that as
    // well but we don't do it anywhere else.
    "span.stMarkdownColoredText": {
      color: "inherit !important"
    }
  },
  "&:active": {
    color: darken(o.colors.primary, 0.25)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: o.colors.transparent,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtS29DIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nTXV0ZWQsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledGhostButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc20"
} : {
  target: "ef3psqc20",
  label: "StyledGhostButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.transparent,
  border: `${o.sizes.borderWidth} solid ${o.colors.transparent}`,
  "&:hover, &:focus-visible": {
    borderColor: o.colors.transparent,
    color: o.colors.primary
  },
  "&:active": {
    color: o.colors.primary,
    borderColor: o.colors.transparent,
    backgroundColor: o.colors.transparent
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: o.colors.gray30,
    borderColor: o.colors.transparent,
    color: o.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMinimalButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc19"
} : {
  target: "ef3psqc19",
  label: "StyledMinimalButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.transparent,
  border: "none",
  boxShadow: "none",
  padding: o.spacing.none,
  "&:hover, &:active, &:focus-visible": {
    color: o.colors.primary
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPrimaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledPrimaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc18"
} : {
  target: "ef3psqc18",
  label: "StyledPrimaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledSecondaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc17"
} : {
  target: "ef3psqc17",
  label: "StyledSecondaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTertiaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledTertiaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc16"
} : {
  target: "ef3psqc16",
  label: "StyledTertiaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2TzhDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nTXV0ZWQsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledButtonGroupBaseButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc15"
} : {
  target: "ef3psqc15",
  label: "StyledButtonGroupBaseButton"
})(({
  theme: o
}) => ({
  background: o.colors.bgColor,
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  fontSize: o.fontSizes.sm,
  lineHeight: o.lineHeights.base,
  fontWeight: o.fontWeights.normal,
  height: o.sizes.largeLogoHeight,
  minHeight: o.sizes.largeLogoHeight,
  maxWidth: o.sizes.contentMaxWidth,
  // show pills with long text in single line and use ellipsis for overflow
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:hover, &:focus-visible": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.transparent,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  },
  "& div": {
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  "& p": {
    textOverflow: "ellipsis",
    overflow: "hidden"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPillsButton = /* @__PURE__ */ createStyled(StyledButtonGroupBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc14"
} : {
  target: "ef3psqc14",
  label: "StyledPillsButton"
})(({
  theme: o,
  containerWidth: i
}) => ({
  borderRadius: o.radii.full,
  padding: `${o.spacing.twoXS} ${o.spacing.md}`,
  // When containerWidth is true, the buttons will stretch to fill the container.
  flex: i ? "1 1 fit-content" : ""
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPillsButtonActive = /* @__PURE__ */ createStyled(StyledPillsButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc13"
} : {
  target: "ef3psqc13",
  label: "StyledPillsButtonActive"
})(({
  theme: o
}) => ({
  backgroundColor: transparentize(o.colors.primary, 0.9),
  borderColor: o.colors.primary,
  color: o.colors.primary,
  "&:hover, &:focus-visible": {
    backgroundColor: transparentize(o.colors.primary, 0.8),
    borderColor: o.colors.primary,
    color: o.colors.primary
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.fadedText05,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSegmentedControlButton = /* @__PURE__ */ createStyled(StyledButtonGroupBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc12"
} : {
  target: "ef3psqc12",
  label: "StyledSegmentedControlButton"
})(({
  theme: o,
  containerWidth: i
}) => ({
  padding: `${o.spacing.twoXS} ${o.spacing.lg}`,
  borderRadius: "0",
  // When containerWidth is true, the buttons will stretch to fill the container.
  flex: i ? "1 1 fit-content" : "",
  maxWidth: "100%",
  marginRight: `-${o.sizes.borderWidth}`,
  // Add negative margin to overlap borders
  "&:first-child": {
    borderTopLeftRadius: o.radii.button,
    borderBottomLeftRadius: o.radii.button
  },
  "&:last-child": {
    borderTopRightRadius: o.radii.button,
    borderBottomRightRadius: o.radii.button,
    marginRight: o.spacing.none
    // Reset margin for the last child
  },
  "&:focus-visible": {
    // Make sure the focus ring isn't below the previous/next button.
    zIndex: o.zIndices.priority
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3VDRDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nTXV0ZWQsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledSegmentedControlButtonActive = /* @__PURE__ */ createStyled(StyledSegmentedControlButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc11"
} : {
  target: "ef3psqc11",
  label: "StyledSegmentedControlButtonActive"
})(({
  theme: o
}) => ({
  backgroundColor: transparentize(o.colors.primary, 0.9),
  borderColor: o.colors.primary,
  color: o.colors.primary,
  zIndex: o.zIndices.priority,
  "&:hover, &:focus-visible": {
    backgroundColor: transparentize(o.colors.primary, 0.8)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.fadedText05,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc10"
} : {
  target: "ef3psqc10",
  label: "StyledHeaderButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.transparent,
  border: "none",
  padding: `0 ${o.spacing.sm}`,
  fontSize: o.fontSizes.sm,
  marginLeft: o.spacing.threeXS,
  marginRight: o.spacing.threeXS,
  lineHeight: o.lineHeights.none,
  minWidth: o.sizes.headerItemHeight,
  minHeight: o.sizes.headerItemHeight,
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: o.shadows.focusRingMuted
  },
  "&:hover": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: o.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: o.colors.gray30,
    borderColor: o.colors.transparent,
    color: o.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderNoPaddingButton = /* @__PURE__ */ createStyled(StyledHeaderButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc9"
} : {
  target: "ef3psqc9",
  label: "StyledHeaderNoPaddingButton"
})(() => ({
  padding: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0WTJDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nTXV0ZWQsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledBorderlessIconButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc8"
} : {
  target: "ef3psqc8",
  label: "StyledBorderlessIconButton"
})(({
  size: o,
  theme: i
}) => {
  const g = {
    xsmall: i.spacing.threeXS,
    small: i.spacing.twoXS,
    medium: i.spacing.md,
    large: i.spacing.lg
  };
  return {
    backgroundColor: i.colors.transparent,
    color: i.colors.fadedText60,
    padding: g[o],
    marginLeft: i.spacing.none,
    marginRight: i.spacing.none,
    // Keeps the buttons from stacking when in containerWidth mode.
    // These buttons should stay together and not stretch to fill the container.
    flex: "0 0 fit-content",
    border: "none",
    display: "flex",
    minHeight: "unset",
    "&:focus": {
      boxShadow: "none",
      outline: "none"
    },
    "&:hover": {
      color: i.colors.bodyText
    },
    "&:disabled, &:disabled:hover, &:disabled:active": {
      color: i.colors.fadedText10,
      cursor: "not-allowed",
      // For image content
      img: {
        opacity: 0.4
      }
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFvWjBDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nTXV0ZWQsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledBorderlessIconButtonActive = /* @__PURE__ */ createStyled(StyledBorderlessIconButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc7"
} : {
  target: "ef3psqc7",
  label: "StyledBorderlessIconButtonActive"
})(({
  theme: o
}) => ({
  color: o.colors.bodyText,
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: o.colors.fadedText40
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipNormal = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc6"
} : {
  target: "ef3psqc6",
  label: "StyledTooltipNormal"
})(({
  theme: o
}) => ({
  display: "block",
  [`@media (max-width: ${o.breakpoints.sm})`]: {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipMobile = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc5"
} : {
  target: "ef3psqc5",
  label: "StyledTooltipMobile"
})(({
  theme: o
}) => ({
  display: "none",
  [`@media (max-width: ${o.breakpoints.sm})`]: {
    display: "block"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElementToolbarButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc4"
} : {
  target: "ef3psqc4",
  label: "StyledElementToolbarButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.transparent,
  border: "none",
  padding: o.spacing.twoXS,
  fontSize: o.fontSizes.twoSm,
  marginLeft: o.spacing.none,
  marginRight: o.spacing.none,
  display: "flex",
  gap: o.spacing.xs,
  alignItems: "center",
  minHeight: "unset",
  // line height should be the same as the icon size
  lineHeight: o.iconSizes.md,
  width: "auto",
  "&:focus": {
    outline: "none",
    border: "none",
    boxShadow: "none"
  },
  "&:focus-visible": {
    outline: "none",
    border: "none",
    boxShadow: "none",
    backgroundColor: o.colors.darkenedBgMix25
  },
  "&:hover": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: o.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: o.colors.gray30,
    borderColor: o.colors.transparent,
    color: o.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonGroup = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc3"
} : {
  target: "ef3psqc3",
  label: "StyledButtonGroup"
})(({
  containerWidth: o
}) => ({
  width: o ? "100%" : "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonLabel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc2"
} : {
  target: "ef3psqc2",
  label: "StyledButtonLabel"
})(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonMainLabel = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc1"
} : {
  target: "ef3psqc1",
  label: "StyledButtonMainLabel"
})(({
  theme: o
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: o.spacing.sm,
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonShortcut = /* @__PURE__ */ createStyled("kbd", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc0"
} : {
  target: "ef3psqc0",
  label: "StyledButtonShortcut"
})(({
  theme: o
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  fontSize: o.fontSizes.sm,
  opacity: 0.6,
  fontFamily: "inherit",
  lineHeight: o.lineHeights.tight,
  letterSpacing: "0.01em"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function BaseButton(o) {
  const {
    kind: i,
    size: g,
    disabled: E,
    onClick: e,
    containerWidth: t,
    children: n,
    autoFocus: h
  } = o;
  let d = StyledPrimaryButton;
  return i === BaseButtonKind.SECONDARY ? d = StyledSecondaryButton : i === BaseButtonKind.TERTIARY ? d = StyledTertiaryButton : i === BaseButtonKind.GHOST ? d = StyledGhostButton : i === BaseButtonKind.PILLS ? d = StyledPillsButton : i === BaseButtonKind.PILLS_ACTIVE ? d = StyledPillsButtonActive : i === BaseButtonKind.SEGMENTED_CONTROL ? d = StyledSegmentedControlButton : i === BaseButtonKind.SEGMENTED_CONTROL_ACTIVE ? d = StyledSegmentedControlButtonActive : i === BaseButtonKind.BORDERLESS_ICON ? d = StyledBorderlessIconButton : i === BaseButtonKind.BORDERLESS_ICON_ACTIVE ? d = StyledBorderlessIconButtonActive : i === BaseButtonKind.MINIMAL ? d = StyledMinimalButton : i === BaseButtonKind.PRIMARY_FORM_SUBMIT ? d = StyledPrimaryFormSubmitButton : i === BaseButtonKind.SECONDARY_FORM_SUBMIT ? d = StyledSecondaryFormSubmitButton : i === BaseButtonKind.TERTIARY_FORM_SUBMIT ? d = StyledTertiaryFormSubmitButton : i === BaseButtonKind.HEADER_BUTTON ? d = StyledHeaderButton : i === BaseButtonKind.HEADER_NO_PADDING ? d = StyledHeaderNoPaddingButton : i === BaseButtonKind.ELEMENT_TOOLBAR && (d = StyledElementToolbarButton), /* @__PURE__ */ jsxRuntimeExports.jsx(d, { kind: i, size: g ?? BaseButtonSize.MEDIUM, containerWidth: t || !1, disabled: E || !1, onClick: e || (() => {
  }), autoFocus: h || !1, "data-testid": o["data-testid"] ?? `stBaseButton-${i}`, "aria-label": o["aria-label"] ?? "", children: n });
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$f() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo22"
} : {
  target: "e1gc5fo22",
  label: "StyledWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "87mhkc",
  styles: "display:table;table-layout:fixed;width:100%"
} : {
  name: "87mhkc",
  styles: "display:table;table-layout:fixed;width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
}), StyledEllipsizedDiv = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo21"
} : {
  target: "e1gc5fo21",
  label: "StyledEllipsizedDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "sy3zga",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:table-cell"
} : {
  name: "sy3zga",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:table-cell/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
}), StyledTooltipContentWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo20"
} : {
  target: "e1gc5fo20",
  label: "StyledTooltipContentWrapper"
})(({
  theme: o
}) => ({
  boxSizing: "border-box",
  fontSize: `${o.fontSizes.sm}`,
  maxWidth: `calc(${o.sizes.contentMaxWidth} - 2 * ${o.spacing.threeXL})`,
  maxHeight: o.sizes.maxTooltipHeight,
  overflow: "auto",
  padding: `${o.spacing.xs} ${o.spacing.md}`,
  [`@media (max-width: ${o.breakpoints.sm})`]: {
    maxWidth: `calc(100% - ${o.spacing.threeXL})`
  },
  img: {
    maxWidth: "100%"
  },
  "*": {
    fontSize: o.fontSizes.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var PLACEMENT$1 = {
  auto: "auto",
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  rightTop: "rightTop",
  right: "right",
  rightBottom: "rightBottom",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft",
  leftBottom: "leftBottom",
  left: "left",
  leftTop: "leftTop"
}, TRIGGER_TYPE = {
  click: "click",
  hover: "hover"
}, STATE_CHANGE_TYPE$1 = {
  open: "open",
  close: "close"
}, ACCESSIBILITY_TYPE = {
  none: "none",
  menu: "menu",
  tooltip: "tooltip"
}, POPOVER_MARGIN = 8, ARROW_SIZE = 6, ANIMATE_OUT_TIME = 0, ANIMATE_IN_TIME = 20, ARROW_WIDTH = Math.ceil(Math.sqrt(Math.pow(ARROW_SIZE * 2, 2) / 2));
function _typeof$e(o) {
  "@babel/helpers - typeof";
  return _typeof$e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$e(o);
}
function ownKeys$o(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$m(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$o(Object(g), !0).forEach(function(E) {
      _defineProperty$r(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$o(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _classCallCheck$c(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$c(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$c(o, i, g) {
  return i && _defineProperties$c(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$c(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$c(o, i);
}
function _setPrototypeOf$c(o, i) {
  return _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$c(o, i);
}
function _createSuper$c(o) {
  var i = _isNativeReflectConstruct$c();
  return function() {
    var E = _getPrototypeOf$c(o), e;
    if (i) {
      var t = _getPrototypeOf$c(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$c(this, e);
  };
}
function _possibleConstructorReturn$c(o, i) {
  if (i && (_typeof$e(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$d(o);
}
function _assertThisInitialized$d(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$c() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$c(o) {
  return _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$c(o);
}
function _defineProperty$r(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var defaultStateReducer = function o(i, g) {
  return g;
}, StatefulContainer$1 = /* @__PURE__ */ (function(o) {
  _inherits$c(g, o);
  var i = _createSuper$c(g);
  function g() {
    var E;
    _classCallCheck$c(this, g);
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = i.call.apply(i, [this].concat(t)), _defineProperty$r(_assertThisInitialized$d(E), "state", _objectSpread$m({
      isOpen: !1
    }, E.props.initialState)), _defineProperty$r(_assertThisInitialized$d(E), "onBlur", function(h) {
      E.props.onBlur && E.props.onBlur(h), !(E.props.focusLock || E.props.autoFocus) && E.close();
    }), _defineProperty$r(_assertThisInitialized$d(E), "onClick", function(h) {
      E.props.onClick && E.props.onClick(h), E.state.isOpen ? E.close() : E.open();
    }), _defineProperty$r(_assertThisInitialized$d(E), "onClickOutside", function() {
      E.close();
    }), _defineProperty$r(_assertThisInitialized$d(E), "onEsc", function() {
      E.close();
    }), _defineProperty$r(_assertThisInitialized$d(E), "onFocus", function(h) {
      E.props.onFocus && E.props.onFocus(h), isFocusVisible(h) && E.open();
    }), _defineProperty$r(_assertThisInitialized$d(E), "onMouseEnter", function(h) {
      E.props.onMouseEnter && E.props.onMouseEnter(h), E.open();
    }), _defineProperty$r(_assertThisInitialized$d(E), "onMouseLeave", function(h) {
      E.props.onMouseLeave && E.props.onMouseLeave(h), E.close();
    }), _defineProperty$r(_assertThisInitialized$d(E), "onContentClose", function() {
      E.close();
    }), _defineProperty$r(_assertThisInitialized$d(E), "renderContent", function() {
      var h = E.props.content;
      return typeof h == "function" ? h({
        close: E.onContentClose
      }) : h;
    }), E;
  }
  return _createClass$c(g, [{
    key: "open",
    value: function() {
      this.internalSetState(STATE_CHANGE_TYPE$1.open, {
        isOpen: !0
      }), this.props.onOpen && this.props.onOpen();
    }
  }, {
    key: "close",
    value: function() {
      this.internalSetState(STATE_CHANGE_TYPE$1.close, {
        isOpen: !1
      }), this.props.onClose && this.props.onClose();
    }
  }, {
    key: "internalSetState",
    value: function(e, t) {
      var n = this.props.stateReducer;
      if (typeof n != "function") {
        this.setState(t);
        return;
      }
      this.setState(function(h) {
        return n(e, t, h);
      });
    }
    /**
     * If user passed a content render prop, we want to give them a
     * callback to close the Popover. This is useful in any case where
     * a dev wants to manually close the popover based on some action.
     *
     * One simple example is a Popover with a "Dismiss" button in it:
     * <StatefulPopover content={({close}) => <button onClick={close}>Dismiss</button>}>
     *  Click me
     * </StatefulPopover>
     */
  }, {
    key: "render",
    value: function() {
      var e = this.props, t = e.accessibilityType, n = e.autoFocus, h = e.animateOutTime, d = e.dismissOnClickOutside, k = e.dismissOnEsc, p = e.focusLock, M = e.ignoreBoundary, H = e.mountNode, f = e.onBlur, AA = e.onClick, gA = e.onFocus, IA = e.onMouseEnter, BA = e.onMouseLeave, CA = e.onMouseEnterDelay, QA = e.onMouseLeaveDelay, iA = e.overrides, EA = e.placement, oA = e.popperOptions, eA = e.renderAll, GA = e.returnFocus, cA = e.showArrow, tA = e.triggerType, aA = e.popoverMargin, sA = e.focusOptions, DA = {
        accessibilityType: t,
        animateOutTime: h,
        autoFocus: n,
        content: this.renderContent,
        focusLock: p,
        ignoreBoundary: M,
        isOpen: this.state.isOpen,
        mountNode: H,
        onBlur: f,
        onClick: AA,
        onFocus: gA,
        onMouseEnter: IA,
        onMouseLeave: BA,
        onMouseEnterDelay: CA,
        onMouseLeaveDelay: QA,
        overrides: iA,
        placement: EA,
        popperOptions: oA,
        renderAll: eA,
        returnFocus: GA,
        showArrow: cA,
        triggerType: tA,
        popoverMargin: aA,
        focusOptions: sA
      };
      return d && (DA.onClickOutside = this.onClickOutside), k && (DA.onEsc = this.onEsc), tA === TRIGGER_TYPE.hover ? (DA.onBlur = this.onBlur, DA.onFocus = this.onFocus, DA.onMouseEnter = this.onMouseEnter, DA.onMouseLeave = this.onMouseLeave) : DA.onClick = this.onClick, this.props.children(DA);
    }
  }]), g;
})(React.Component);
_defineProperty$r(StatefulContainer$1, "defaultProps", {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT$1.auto,
  popperOptions: {},
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: !0,
  dismissOnEsc: !0,
  stateReducer: defaultStateReducer,
  popoverMargin: POPOVER_MARGIN
});
function ownKeys$n(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$l(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$n(Object(g), !0).forEach(function(E) {
      _defineProperty$q(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$n(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$q(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function _slicedToArray$k(o, i) {
  return _arrayWithHoles$j(o) || _iterableToArrayLimit$j(o, i) || _unsupportedIterableToArray$j(o, i) || _nonIterableRest$j();
}
function _nonIterableRest$j() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$j(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$j(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$j(o, i);
  }
}
function _arrayLikeToArray$j(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$j(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$j(o) {
  if (Array.isArray(o)) return o;
}
var OPPOSITE_POSITIONS = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
function getOppositePosition(o) {
  return OPPOSITE_POSITIONS[o];
}
function isVerticalPosition(o) {
  return o === "top" || o === "bottom";
}
function capitalize(o) {
  return o.charAt(0).toUpperCase() + o.slice(1);
}
function fromPopperPlacement(o) {
  var i = o.replace(/(top|bottom)-start$/, "$1Left").replace(/(top|bottom)-end$/, "$1Right").replace(/(left|right)-start$/, "$1Top").replace(/(left|right)-end$/, "$1Bottom");
  return PLACEMENT$1[i] || null;
}
function splitPlacement(o) {
  var i = o.match(/^([a-z]+)([A-Z][a-z]+)?/) || [];
  return i.slice(1, 3).filter(Boolean).map(function(g) {
    return g.toLowerCase();
  });
}
function getPopoverMarginStyles(o, i, g) {
  var E = splitPlacement(i), e = _slicedToArray$k(E, 1), t = e[0], n = getOppositePosition(t);
  if (!n)
    return null;
  var h = "margin".concat(capitalize(n));
  return _defineProperty$q({}, h, "".concat(o + g, "px"));
}
function getStartPosition(o, i, g, E) {
  o = _objectSpread$l({}, o);
  var e = splitPlacement(i), t = _slicedToArray$k(e, 1), n = t[0], h = (g > 0 ? g : E) * 2;
  return isVerticalPosition(n) ? o.top += n === "top" ? h : -h : o.left += n === "left" ? h : -h, "translate3d(".concat(o.left, "px, ").concat(o.top, "px, 0)");
}
function getEndPosition(o) {
  return "translate3d(".concat(o.left, "px, ").concat(o.top, "px, 0)");
}
function getArrowPositionStyles(o, i) {
  var g, E = splitPlacement(i), e = _slicedToArray$k(E, 1), t = e[0], n = getOppositePosition(t);
  if (!n)
    return null;
  var h = isVerticalPosition(t) ? "left" : "top";
  return g = {}, _defineProperty$q(g, h, "".concat(o[h], "px")), _defineProperty$q(g, n, "-".concat(ARROW_SIZE - 2, "px")), g;
}
function ownKeys$m(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$k(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$m(Object(g), !0).forEach(function(E) {
      _defineProperty$p(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$m(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$p(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function getBodyStyles(o) {
  var i = o.$animationDuration, g = o.$isOpen, E = o.$isAnimating, e = o.$placement, t = o.$popoverOffset, n = o.$showArrow, h = o.$theme, d = o.$popoverMargin, k = o.$isHoverTrigger;
  return _objectSpread$k(_objectSpread$k({
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: h.colors.backgroundTertiary,
    borderTopLeftRadius: h.borders.popoverBorderRadius,
    borderTopRightRadius: h.borders.popoverBorderRadius,
    borderBottomRightRadius: h.borders.popoverBorderRadius,
    borderBottomLeftRadius: h.borders.popoverBorderRadius,
    boxShadow: h.lighting.shadow600,
    transitionProperty: "opacity,transform",
    transitionDuration: E ? g ? "0.1s" : "".concat(i, "ms") : "0s",
    transitionTimingFunction: g ? h.animation.easeOutCurve : h.animation.easeInCurve,
    opacity: E && g ? 1 : 0,
    transform: E && g ? getEndPosition(t) : getStartPosition(t, e, n ? ARROW_SIZE : 0, d)
  }, getPopoverMarginStyles(n ? ARROW_SIZE : 0, e, d)), k ? {
    animationDuration: ".1s",
    animationName: {
      "0%": {
        pointerEvents: "none"
      },
      "99%": {
        pointerEvents: "none"
      },
      "100%": {
        pointerEvents: "auto"
      }
    }
  } : {});
}
var Body$3 = styled("div", getBodyStyles);
Body$3.displayName = "Body";
Body$3.displayName = "Body";
function getArrowStyles(o) {
  var i = o.$arrowOffset, g = o.$placement, E = o.$theme;
  return _objectSpread$k({
    backgroundColor: E.colors.backgroundTertiary,
    boxShadow: E.lighting.shadow600,
    width: "".concat(ARROW_WIDTH, "px"),
    height: "".concat(ARROW_WIDTH, "px"),
    transform: "rotate(45deg)",
    position: "absolute"
  }, getArrowPositionStyles(i, g));
}
var Arrow$1 = styled("div", getArrowStyles);
Arrow$1.displayName = "Arrow";
Arrow$1.displayName = "Arrow";
function getInnerStyles(o) {
  var i = o.$theme;
  return {
    backgroundColor: i.colors.backgroundTertiary,
    borderTopLeftRadius: i.borders.popoverBorderRadius,
    borderTopRightRadius: i.borders.popoverBorderRadius,
    borderBottomRightRadius: i.borders.popoverBorderRadius,
    borderBottomLeftRadius: i.borders.popoverBorderRadius,
    color: i.colors.contentPrimary,
    position: "relative"
  };
}
var Inner$1 = styled("div", getInnerStyles);
Inner$1.displayName = "Inner";
Inner$1.displayName = "Inner";
var Padding = styled("div", {
  paddingLeft: "12px",
  paddingTop: "12px",
  paddingRight: "12px",
  paddingBottom: "12px"
});
Padding.displayName = "Padding";
Padding.displayName = "Padding";
var Hidden = styled("div", {
  display: "none"
});
Hidden.displayName = "Hidden";
Hidden.displayName = "Hidden";
var baseDefaultProps$1 = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  focusLock: !1,
  autoFocus: !0,
  returnFocus: !0,
  // Remove the `ignoreBoundary` prop in the next major version
  // and have it replaced with the TetherBehavior props overrides
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT$1.auto,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  renderAll: !1
};
function ownKeys$l(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$j(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$l(Object(g), !0).forEach(function(E) {
      _defineProperty$o(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$l(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _extends$u() {
  return _extends$u = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$u.apply(this, arguments);
}
function _typeof$d(o) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$d(o);
}
function _classCallCheck$b(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$b(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$b(o, i, g) {
  return i && _defineProperties$b(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$b(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$b(o, i);
}
function _setPrototypeOf$b(o, i) {
  return _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$b(o, i);
}
function _createSuper$b(o) {
  var i = _isNativeReflectConstruct$b();
  return function() {
    var E = _getPrototypeOf$b(o), e;
    if (i) {
      var t = _getPrototypeOf$b(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$b(this, e);
  };
}
function _possibleConstructorReturn$b(o, i) {
  if (i && (_typeof$d(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$c(o);
}
function _assertThisInitialized$c(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$b() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$b(o) {
  return _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$b(o);
}
function _defineProperty$o(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var PopoverInner = /* @__PURE__ */ (function(o) {
  _inherits$b(g, o);
  var i = _createSuper$b(g);
  function g() {
    var E;
    _classCallCheck$b(this, g);
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = i.call.apply(i, [this].concat(t)), _defineProperty$o(_assertThisInitialized$c(E), "animateInTimer", void 0), _defineProperty$o(_assertThisInitialized$c(E), "animateOutTimer", void 0), _defineProperty$o(_assertThisInitialized$c(E), "animateOutCompleteTimer", void 0), _defineProperty$o(_assertThisInitialized$c(E), "onMouseEnterTimer", void 0), _defineProperty$o(_assertThisInitialized$c(E), "onMouseLeaveTimer", void 0), _defineProperty$o(_assertThisInitialized$c(E), "anchorRef", /* @__PURE__ */ React.createRef()), _defineProperty$o(_assertThisInitialized$c(E), "popperRef", /* @__PURE__ */ React.createRef()), _defineProperty$o(_assertThisInitialized$c(E), "arrowRef", /* @__PURE__ */ React.createRef()), _defineProperty$o(_assertThisInitialized$c(E), "state", E.getDefaultState(E.props)), _defineProperty$o(_assertThisInitialized$c(E), "animateIn", function() {
      E.props.isOpen && E.setState({
        isAnimating: !0
      });
    }), _defineProperty$o(_assertThisInitialized$c(E), "animateOut", function() {
      E.props.isOpen || (E.setState({
        isAnimating: !0
      }), E.animateOutCompleteTimer = setTimeout(function() {
        E.setState({
          isAnimating: !1,
          // Reset to ideal placement specified in props
          placement: E.props.placement
        });
      }, E.props.animateOutTime || ANIMATE_OUT_TIME));
    }), _defineProperty$o(_assertThisInitialized$c(E), "onAnchorClick", function(h) {
      E.props.onClick && E.props.onClick(h);
    }), _defineProperty$o(_assertThisInitialized$c(E), "onAnchorMouseEnter", function(h) {
      E.onMouseLeaveTimer && clearTimeout(E.onMouseLeaveTimer), E.triggerOnMouseEnterWithDelay(h);
    }), _defineProperty$o(_assertThisInitialized$c(E), "onAnchorMouseLeave", function(h) {
      E.onMouseEnterTimer && clearTimeout(E.onMouseEnterTimer), E.triggerOnMouseLeaveWithDelay(h);
    }), _defineProperty$o(_assertThisInitialized$c(E), "onPopoverMouseEnter", function() {
      E.onMouseLeaveTimer && clearTimeout(E.onMouseLeaveTimer);
    }), _defineProperty$o(_assertThisInitialized$c(E), "onPopoverMouseLeave", function(h) {
      E.triggerOnMouseLeaveWithDelay(h);
    }), _defineProperty$o(_assertThisInitialized$c(E), "onPopperUpdate", function(h, d) {
      var k = fromPopperPlacement(d.placement) || PLACEMENT$1.top;
      return E.setState({
        arrowOffset: h.arrow,
        popoverOffset: h.popper,
        placement: k
      }), E.animateInTimer = setTimeout(E.animateIn, ANIMATE_IN_TIME), d;
    }), _defineProperty$o(_assertThisInitialized$c(E), "triggerOnMouseLeave", function(h) {
      E.props.onMouseLeave && E.props.onMouseLeave(h);
    }), _defineProperty$o(_assertThisInitialized$c(E), "triggerOnMouseEnter", function(h) {
      E.props.onMouseEnter && E.props.onMouseEnter(h);
    }), _defineProperty$o(_assertThisInitialized$c(E), "onDocumentClick", function(h) {
      var d = h.composedPath ? h.composedPath()[0] : h.target, k = E.popperRef.current, p = E.anchorRef.current;
      !k || k === d || d instanceof Node && k.contains(d) || !p || p === d || d instanceof Node && p.contains(d) || E.props.onClickOutside && E.props.onClickOutside(h);
    }), E;
  }
  return _createClass$b(g, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      this.init(e, t), this.props.accessibilityType !== ACCESSIBILITY_TYPE.tooltip && this.props.autoFocus && !this.state.autoFocusAfterPositioning && this.popperRef.current !== null && this.popperRef.current.getBoundingClientRect().top > 0 && this.setState({
        autoFocusAfterPositioning: !0
      }), process.env.NODE_ENV !== "production" && (this.anchorRef.current || console.warn(`[baseui][Popover] ref has not been passed to the Popper's anchor element.
              See how to pass the ref to an anchor element in the Popover example
              https://baseweb.design/components/popover/#anchor-ref-handling-example`));
    }
  }, {
    key: "init",
    value: function(e, t) {
      if (this.props.isOpen !== e.isOpen || this.state.isMounted !== t.isMounted || this.state.isLayerMounted !== t.isLayerMounted) {
        if (this.props.isOpen && this.state.isLayerMounted) {
          this.clearTimers();
          return;
        }
        if (!this.props.isOpen && e.isOpen) {
          this.animateOutTimer = setTimeout(this.animateOut, 20);
          return;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimers();
    }
  }, {
    key: "getDefaultState",
    value: function(e) {
      return {
        isAnimating: !1,
        arrowOffset: {
          left: 0,
          top: 0
        },
        popoverOffset: {
          left: 0,
          top: 0
        },
        placement: e.placement,
        isMounted: !1,
        isLayerMounted: !1,
        autoFocusAfterPositioning: !1
      };
    }
  }, {
    key: "clearTimers",
    value: function() {
      [this.animateInTimer, this.animateOutTimer, this.animateOutCompleteTimer, this.onMouseEnterTimer, this.onMouseLeaveTimer].forEach(function(e) {
        e && clearTimeout(e);
      });
    }
  }, {
    key: "triggerOnMouseLeaveWithDelay",
    value: function(e) {
      var t = this, n = this.props.onMouseLeaveDelay;
      if (n) {
        this.onMouseLeaveTimer = setTimeout(function() {
          return t.triggerOnMouseLeave(e);
        }, n);
        return;
      }
      this.triggerOnMouseLeave(e);
    }
  }, {
    key: "triggerOnMouseEnterWithDelay",
    value: function(e) {
      var t = this, n = this.props.onMouseEnterDelay;
      if (n) {
        this.onMouseEnterTimer = setTimeout(function() {
          return t.triggerOnMouseEnter(e);
        }, n);
        return;
      }
      this.triggerOnMouseEnter(e);
    }
  }, {
    key: "isClickTrigger",
    value: function() {
      return this.props.triggerType === TRIGGER_TYPE.click;
    }
  }, {
    key: "isHoverTrigger",
    value: function() {
      return this.props.triggerType === TRIGGER_TYPE.hover;
    }
  }, {
    key: "isAccessibilityTypeMenu",
    value: function() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.menu;
    }
  }, {
    key: "isAccessibilityTypeTooltip",
    value: function() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.tooltip;
    }
  }, {
    key: "getAnchorIdAttr",
    value: function() {
      var e = this.getPopoverIdAttr();
      return e ? "".concat(e, "__anchor") : null;
    }
  }, {
    key: "getPopoverIdAttr",
    value: function() {
      return this.props.id || null;
    }
  }, {
    key: "getAnchorProps",
    value: function() {
      var e = this.props.isOpen, t = {
        ref: this.anchorRef
      }, n = this.getPopoverIdAttr();
      if (this.isAccessibilityTypeMenu()) {
        var h = this.isClickTrigger() ? "aria-controls" : "aria-owns";
        t[h] = e ? n : null, t["aria-haspopup"] = !0, t["aria-expanded"] = !!e;
      } else this.isAccessibilityTypeTooltip() && (t.id = this.getAnchorIdAttr(), t["aria-describedby"] = e ? n : null);
      return this.isHoverTrigger() ? (t.onMouseEnter = this.onAnchorMouseEnter, t.onMouseLeave = this.onAnchorMouseLeave, t.onBlur = this.props.onBlur, t.onFocus = this.props.onFocus) : t.onClick = this.onAnchorClick, t;
    }
  }, {
    key: "getPopoverBodyProps",
    value: function() {
      var e = {}, t = this.getPopoverIdAttr();
      return this.isAccessibilityTypeMenu() ? e.id = t : this.isAccessibilityTypeTooltip() && (e.id = t, e.role = "tooltip"), this.isHoverTrigger() && (e.onMouseEnter = this.onPopoverMouseEnter, e.onMouseLeave = this.onPopoverMouseLeave), e;
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.isOpen, n = e.showArrow, h = e.popoverMargin, d = h === void 0 ? POPOVER_MARGIN : h, k = this.state, p = k.isAnimating, M = k.arrowOffset, H = k.popoverOffset, f = k.placement;
      return {
        $showArrow: !!n,
        $arrowOffset: M,
        $popoverOffset: H,
        $placement: f,
        $isAnimating: p,
        $animationDuration: this.props.animateOutTime || ANIMATE_OUT_TIME,
        $isOpen: t,
        $popoverMargin: d,
        $isHoverTrigger: this.isHoverTrigger()
      };
    }
  }, {
    key: "getAnchorFromChildren",
    value: function() {
      var e = this.props.children, t = React.Children.toArray(e);
      return t.length !== 1 && console.error("[baseui] Exactly 1 child must be passed to Popover/Tooltip, found ".concat(t.length, " children")), t[0];
    }
  }, {
    key: "renderAnchor",
    value: function() {
      var e = this.getAnchorFromChildren();
      if (!e)
        return null;
      var t = /* @__PURE__ */ React.isValidElement(e), n = this.getAnchorProps();
      return _typeof$d(e) === "object" && t ? /* @__PURE__ */ React.cloneElement(e, n) : /* @__PURE__ */ React.createElement("span", _extends$u({
        key: "popover-anchor"
      }, n), e);
    }
  }, {
    key: "renderPopover",
    value: function(e) {
      var t = this.props, n = t.showArrow, h = t.overrides, d = h === void 0 ? {} : h, k = d.Arrow, p = d.Body, M = d.Inner, H = getOverride(k) || Arrow$1, f = getOverride(p) || Body$3, AA = getOverride(M) || Inner$1, gA = this.getSharedProps(), IA = this.getPopoverBodyProps();
      return /* @__PURE__ */ React.createElement(f, _extends$u({
        key: "popover-body",
        ref: this.popperRef,
        "data-baseweb": this.props["data-baseweb"] || "popover"
      }, IA, gA, getOverrideProps(p)), n ? /* @__PURE__ */ React.createElement(H, _extends$u({
        key: "popover-arrow",
        ref: this.arrowRef
      }, gA, getOverrideProps(k))) : null, /* @__PURE__ */ React.createElement(AA, _extends$u({}, gA, getOverrideProps(M)), e));
    }
  }, {
    key: "renderContent",
    value: function() {
      var e = this.props.content;
      return typeof e == "function" ? e() : e;
    }
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.state.isMounted && (this.props.isOpen || this.state.isAnimating), n = [this.renderAnchor()], h = t || this.props.renderAll ? this.renderContent() : null, d = {
        modifiers: {
          preventOverflow: {
            enabled: !this.props.ignoreBoundary,
            padding: 0
          }
        }
      };
      return h && (t ? n.push(/* @__PURE__ */ React.createElement(Layer, {
        key: "new-layer",
        mountNode: this.props.mountNode,
        onEscape: this.props.onEsc,
        onDocumentClick: this.isHoverTrigger() ? void 0 : this.onDocumentClick,
        isHoverLayer: this.isHoverTrigger(),
        onMount: function() {
          return e.setState({
            isLayerMounted: !0
          });
        },
        onUnmount: function() {
          return e.setState({
            isLayerMounted: !1
          });
        }
      }, /* @__PURE__ */ React.createElement(Tether, {
        anchorRef: this.anchorRef.current,
        arrowRef: this.arrowRef.current,
        popperRef: this.popperRef.current,
        popperOptions: _objectSpread$j(_objectSpread$j({}, d), this.props.popperOptions),
        onPopperUpdate: this.onPopperUpdate,
        placement: this.state.placement
      }, this.props.focusLock && this.props.accessibilityType !== ACCESSIBILITY_TYPE.tooltip ? /* @__PURE__ */ React.createElement(FocusLockCombination, {
        disabled: !this.props.focusLock,
        noFocusGuards: !1,
        returnFocus: !this.isHoverTrigger() && this.props.returnFocus,
        autoFocus: this.state.autoFocusAfterPositioning,
        crossFrame: !1,
        focusOptions: this.props.focusOptions
      }, this.renderPopover(h)) : /* @__PURE__ */ React.createElement(MoveFocusInside, {
        disabled: !this.props.autoFocus || !this.state.autoFocusAfterPositioning
      }, this.renderPopover(h))))) : n.push(/* @__PURE__ */ React.createElement(Hidden, {
        key: "hidden-layer"
      }, h))), n;
    }
  }]), g;
})(React.Component);
_defineProperty$o(PopoverInner, "defaultProps", baseDefaultProps$1);
var Popover$2 = function o(i) {
  var g = i.innerRef, E = useUID();
  return /* @__PURE__ */ React.createElement(PopoverInner, _extends$u({
    id: i.id || E,
    ref: g
  }, i));
};
Popover$2.defaultProps = baseDefaultProps$1;
var _excluded$o = ["children"];
function _objectWithoutProperties$q(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$p(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$p(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function StatefulPopover(o) {
  var i = o.children, g = _objectWithoutProperties$q(o, _excluded$o);
  return /* @__PURE__ */ React.createElement(StatefulContainer$1, g, function(E) {
    return /* @__PURE__ */ React.createElement(Popover$2, E, i);
  });
}
StatefulPopover.defaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT$1.auto,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: !0,
  dismissOnEsc: !0,
  stateReducer: function o(i, g) {
    return g;
  },
  popoverMargin: POPOVER_MARGIN
};
var baseDefaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.tooltip,
  focusLock: !1,
  autoFocus: !1,
  returnFocus: !1,
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  overrides: {},
  placement: PLACEMENT$1.auto,
  popoverMargin: 0,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.hover,
  renderAll: !1
};
function _typeof$c(o) {
  "@babel/helpers - typeof";
  return _typeof$c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$c(o);
}
function ownKeys$k(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$i(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$k(Object(g), !0).forEach(function(E) {
      _defineProperty$n(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$k(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _classCallCheck$a(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$a(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$a(o, i, g) {
  return i && _defineProperties$a(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$a(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$a(o, i);
}
function _setPrototypeOf$a(o, i) {
  return _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$a(o, i);
}
function _createSuper$a(o) {
  var i = _isNativeReflectConstruct$a();
  return function() {
    var E = _getPrototypeOf$a(o), e;
    if (i) {
      var t = _getPrototypeOf$a(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$a(this, e);
  };
}
function _possibleConstructorReturn$a(o, i) {
  if (i && (_typeof$c(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$b(o);
}
function _assertThisInitialized$b(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$a() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$a(o) {
  return _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$a(o);
}
function _defineProperty$n(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var StatefulContainer = /* @__PURE__ */ (function(o) {
  _inherits$a(g, o);
  var i = _createSuper$a(g);
  function g() {
    return _classCallCheck$a(this, g), i.apply(this, arguments);
  }
  return _createClass$a(g, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ React.createElement(StatefulContainer$1, this.props);
    }
  }]), g;
})(React.Component);
_defineProperty$n(StatefulContainer, "defaultProps", _objectSpread$i({}, baseDefaultProps));
function ownKeys$j(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$h(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$j(Object(g), !0).forEach(function(E) {
      _defineProperty$m(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$j(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$m(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var Body$2 = styled("div", function(o) {
  return _objectSpread$h(_objectSpread$h({}, getBodyStyles(o)), {}, {
    backgroundColor: o.$theme.colors.tooltipBackground,
    borderTopLeftRadius: o.$theme.borders.radius300,
    borderTopRightRadius: o.$theme.borders.radius300,
    borderBottomRightRadius: o.$theme.borders.radius300,
    borderBottomLeftRadius: o.$theme.borders.radius300,
    boxShadow: o.$theme.lighting.shadow400,
    color: o.$theme.colors.tooltipText,
    // Reset transition property to opacity only, and static transform
    transitionProperty: "opacity",
    transform: getEndPosition(o.$popoverOffset)
  });
});
Body$2.displayName = "Body";
Body$2.displayName = "Body";
var Inner = styled("div", function(o) {
  return _objectSpread$h(_objectSpread$h(_objectSpread$h({}, getInnerStyles(o)), {}, {
    backgroundColor: o.$theme.colors.tooltipBackground,
    borderTopLeftRadius: o.$theme.borders.radius300,
    borderTopRightRadius: o.$theme.borders.radius300,
    borderBottomRightRadius: o.$theme.borders.radius300,
    borderBottomLeftRadius: o.$theme.borders.radius300,
    paddingTop: o.$theme.sizing.scale300,
    paddingBottom: o.$theme.sizing.scale300,
    paddingLeft: o.$theme.sizing.scale600,
    paddingRight: o.$theme.sizing.scale600
  }, o.$theme.typography.font150), {}, {
    color: o.$theme.colors.tooltipText
  });
});
Inner.displayName = "Inner";
Inner.displayName = "Inner";
var Arrow = styled("div", function(o) {
  return _objectSpread$h(_objectSpread$h({}, getArrowStyles(o)), {}, {
    backgroundColor: o.$theme.colors.tooltipBackground
  });
});
Arrow.displayName = "Arrow";
Arrow.displayName = "Arrow";
function _typeof$b(o) {
  "@babel/helpers - typeof";
  return _typeof$b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$b(o);
}
function ownKeys$i(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$g(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$i(Object(g), !0).forEach(function(E) {
      _defineProperty$l(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$i(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _extends$t() {
  return _extends$t = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$t.apply(this, arguments);
}
function _classCallCheck$9(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$9(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$9(o, i, g) {
  return i && _defineProperties$9(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$9(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$9(o, i);
}
function _setPrototypeOf$9(o, i) {
  return _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$9(o, i);
}
function _createSuper$9(o) {
  var i = _isNativeReflectConstruct$9();
  return function() {
    var E = _getPrototypeOf$9(o), e;
    if (i) {
      var t = _getPrototypeOf$9(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$9(this, e);
  };
}
function _possibleConstructorReturn$9(o, i) {
  if (i && (_typeof$b(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$a(o);
}
function _assertThisInitialized$a(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$9() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$9(o) {
  return _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$9(o);
}
function _defineProperty$l(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var Tooltip$2 = /* @__PURE__ */ (function(o) {
  _inherits$9(g, o);
  var i = _createSuper$9(g);
  function g() {
    return _classCallCheck$9(this, g), i.apply(this, arguments);
  }
  return _createClass$9(g, [{
    key: "render",
    value: function() {
      var e = mergeOverrides({
        Arrow,
        Body: Body$2,
        Inner
      }, this.props.overrides);
      return /* @__PURE__ */ React.createElement(Popover$2, _extends$t({
        autoFocus: !1,
        "data-baseweb": "tooltip"
      }, this.props, {
        overrides: e
      }));
    }
  }]), g;
})(React.Component);
_defineProperty$l(Tooltip$2, "defaultProps", _objectSpread$g({}, baseDefaultProps));
var _excluded$n = ["children"];
function _objectWithoutProperties$p(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$o(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$o(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function StatefulTooltip(o) {
  var i = o.children, g = _objectWithoutProperties$p(o, _excluded$n);
  return /* @__PURE__ */ React.createElement(StatefulContainer, g, function(E) {
    return /* @__PURE__ */ React.createElement(Tooltip$2, E, i);
  });
}
StatefulTooltip.defaultProps = StatefulContainer.defaultProps;
function useTooltipMeasurementSideEffect(o, i) {
  const {
    innerWidth: g
  } = useWindowDimensionsContext();
  useEffect(() => {
    const E = o?.parentElement;
    if (!E)
      return;
    (async () => {
      const t = () => {
        const H = E.getBoundingClientRect();
        return H.x !== 0 || H.y !== 0 ? H : null;
      };
      let n = null, h = 0;
      const d = 5;
      for (; !n && h < d; )
        n = t(), n || (h++, await new Promise((H) => requestAnimationFrame(H)));
      n || (n = E.getBoundingClientRect());
      const k = n.x, p = k + n.width - g, M = E.parentElement;
      if (p > 0 && M) {
        const H = new DOMMatrix(
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          window.getComputedStyle(M)?.transform
        );
        M.style.transform = `translate3d(${H.e - p}px, ${H.f}px, 0px)`;
      }
      k < 0 && (E.style.left = `${-k}px`);
    })();
  }, [o, i, g]);
}
var Placement = /* @__PURE__ */ ((o) => (o.AUTO = "auto", o.TOP_LEFT = "topLeft", o.TOP = "top", o.TOP_RIGHT = "topRight", o.RIGHT_TOP = "rightTop", o.RIGHT = "right", o.RIGHT_BOTTOM = "rightBottom", o.BOTTOM_RIGHT = "bottomRight", o.BOTTOM = "bottom", o.BOTTOM_LEFT = "bottomLeft", o.LEFT_BOTTOM = "leftBottom", o.LEFT = "left", o.LEFT_TOP = "leftTop", o))(Placement || {});
const generateDefaultTooltipOverrides = (o, i) => {
  const {
    colors: g,
    fontSizes: E,
    radii: e,
    fontWeights: t
  } = o;
  return {
    Body: {
      style: {
        // This is annoying, but a bunch of warnings get logged when the
        // shorthand version `borderRadius` is used here since the long
        // names are used by BaseWeb and mixing the two is apparently
        // bad :(
        borderTopLeftRadius: e.default,
        borderTopRightRadius: e.default,
        borderBottomLeftRadius: e.default,
        borderBottomRightRadius: e.default,
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        backgroundColor: "transparent"
      }
    },
    Inner: {
      style: {
        backgroundColor: hasLightBackgroundColor(o) ? g.bgColor : g.secondaryBg,
        color: g.bodyText,
        fontSize: E.sm,
        fontWeight: t.normal,
        // See the long comment about `borderRadius`. The same applies here
        // to `padding`.
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important"
      },
      // overrides prop replaces tooltip subcomponent overrides
      ...i
    }
  };
};
function Tooltip({
  content: o,
  placement: i,
  children: g,
  inline: E,
  style: e,
  onMouseEnterDelay: t,
  overrides: n,
  containerWidth: h,
  error: d
}) {
  const k = useEmotionTheme(), [p, M] = useState(null), [H, f] = useState(!1), AA = useRef(null), gA = useCallback(() => {
    f(!0);
  }, []), IA = useCallback(() => {
    f(!1), AA.current = null;
  }, []);
  useEffect(() => () => {
    AA.current = null;
  }, []);
  const BA = useCallback((iA) => {
    if (iA.key !== "Escape" || !H)
      return;
    const EA = iA.currentTarget, oA = EA.ownerDocument?.activeElement;
    oA instanceof HTMLElement && EA.contains(oA) && (AA.current?.(), iA.preventDefault(), iA.stopPropagation());
  }, [H]);
  useTooltipMeasurementSideEffect(p, H);
  const CA = generateDefaultTooltipOverrides(k, n), QA = useCallback(({
    close: iA
  }) => (AA.current = iA, /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipContentWrapper, { className: d ? "stTooltipErrorContent" : "stTooltipContent", "data-testid": d ? "stTooltipErrorContent" : "stTooltipContent", ref: M, children: o })), [o, d, M]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulTooltip, { onOpen: gA, onClose: IA, content: o ? QA : null, placement: PLACEMENT$1[i], accessibilityType: ACCESSIBILITY_TYPE.tooltip, showArrow: !1, popoverMargin: 10, onMouseEnterDelay: t, overrides: CA, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: E ? "flex-end" : "",
    width: h ? "100%" : "auto",
    ...e
  }, onKeyDownCapture: BA, "data-testid": d ? "stTooltipErrorHoverTarget" : "stTooltipHoverTarget", className: d ? "stTooltipErrorHoverTarget" : "stTooltipHoverTarget", children: g }) });
}
const Tooltip$1 = memo(Tooltip);
function OverflowTooltip({
  content: o,
  placement: i,
  children: g,
  inline: E,
  style: e
}) {
  const t = useRef(null), [n, h] = useState(!1);
  return useEffect(() => {
    const d = t?.current ? (
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      t.current.offsetWidth < t.current.scrollWidth
    ) : !1;
    d !== n && h(d);
  }, [g, n]), /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: n ? o : "", placement: i, inline: E, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEllipsizedDiv, { ref: t, style: e, children: g }) }) });
}
const StyledTooltipTriggerButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "ewgb6653"
} : {
  target: "ewgb6653",
  label: "StyledTooltipTriggerButton"
})(({
  theme: o
}) => ({
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  color: "inherit",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 0,
  cursor: "help",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: o.shadows.focusRing,
    borderRadius: o.radii.default
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvVG9vbHRpcEljb24vc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0IwQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL1Rvb2x0aXBJY29uL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwVHJpZ2dlckJ1dHRvbiA9IHN0eWxlZC5idXR0b24oKHsgdGhlbWUgfSkgPT4gKHtcbiAgYmFja2dyb3VuZDogXCJub25lXCIsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIHBhZGRpbmc6IDAsXG4gIG1hcmdpbjogMCxcbiAgY29sb3I6IFwiaW5oZXJpdFwiLFxuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGxpbmVIZWlnaHQ6IDAsXG4gIGN1cnNvcjogXCJoZWxwXCIsXG5cbiAgXCImOmZvY3VzXCI6IHtcbiAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgfSxcbiAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmcsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICB9LFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWRUb29sdGlwSWNvbldyYXBwZXJQcm9wcyB7XG4gIGlzTGF0ZXg/OiBib29sZWFuXG59XG5cbmludGVyZmFjZSBTdHlsZWRMYWJlbEhlbHBXcmFwcGVyUHJvcHMge1xuICBpc0xhdGV4PzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcEljb25XcmFwcGVyID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRUb29sdGlwSWNvbldyYXBwZXJQcm9wcz4oKHsgaXNMYXRleCwgdGhlbWUgfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIG1hcmdpblRvcDogaXNMYXRleCA/IHRoZW1lLnNwYWNpbmcubWQgOiBcIjBcIixcblxuICAgIC8vIFRoZSB0b29sdGlwIGhvdmVyIHRhcmdldCB3cmFwcyB0aGUgdHJpZ2dlciBmb3IgYWNjZXNzaWJpbGl0eS5cbiAgICAvLyBPbmx5IHN0eWxlIFRvb2x0aXBJY29uJ3MgZGVmYXVsdCB0cmlnZ2VyIGdseXBoIChIZWxwQ2lyY2xlSWNvbikuXG4gICAgLy8gVG9vbHRpcEljb24gaXMgYWxzbyB1c2VkIGFzIGEgd3JhcHBlciBhcm91bmQgYXJiaXRyYXJ5IHRyaWdnZXJzIChlLmcuIGFcbiAgICAvLyBidXR0b24gd2l0aCBpdHMgb3duIEljb24pLiBUaG9zZSB0cmlnZ2VycyBzaG91bGQga2VlcCB0aGVpciBvd24gc3R5bGluZy5cbiAgICBcIiYgLnN0VG9vbHRpcEhvdmVyVGFyZ2V0IHN2Zy5pY29uXCI6IHtcbiAgICAgIHN0cm9rZTogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgICAgc3Ryb2tlV2lkdGg6IHRoZW1lLnNpemVzLmRlZmF1bHRTdHJva2VXaWR0aCxcbiAgICB9LFxuICB9KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZExhYmVsSGVscFdyYXBwZXIgPSBzdHlsZWQuZGl2PFN0eWxlZExhYmVsSGVscFdyYXBwZXJQcm9wcz4oXG4gICh7IGlzTGF0ZXggfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBmbGV4RGlyZWN0aW9uOiBcInJvd1wiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgdmlzaWJpbGl0eTogXCJ2aXNpYmxlXCIsXG4gICAgLy8gRm9yIExhVGVYLCB1c2UgZml0LWNvbnRlbnQgdG8ga2VlcCBpY29uIGNsb3NlLCBidXQgY29uc3RyYWluIHdpdGggbWF4V2lkdGhcbiAgICAvLyBzbyBsb25nIGZvcm11bGFzIGNhbiBzY3JvbGwuIENlbnRlciB1c2luZyBtYXJnaW4taW5saW5lOiBhdXRvXG4gICAgd2lkdGg6IGlzTGF0ZXggPyBcImZpdC1jb250ZW50XCIgOiBcIjEwMCVcIixcbiAgICAuLi4oaXNMYXRleCA/IHsgbWF4V2lkdGg6IFwiMTAwJVwiLCBtYXJnaW5JbmxpbmU6IFwiYXV0b1wiIH0gOiB7fSksXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMYWJlbEhlbHBJbmxpbmUgPSBzdHlsZWQubGFiZWwoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy54cyxcbiAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG59KSlcbiJdfQ== */"), StyledTooltipIconWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ewgb6652"
} : {
  target: "ewgb6652",
  label: "StyledTooltipIconWrapper"
})(({
  isLatex: o,
  theme: i
}) => ({
  display: "flex",
  alignItems: "center",
  marginTop: o ? i.spacing.md : "0",
  // The tooltip hover target wraps the trigger for accessibility.
  // Only style TooltipIcon's default trigger glyph (HelpCircleIcon).
  // TooltipIcon is also used as a wrapper around arbitrary triggers (e.g. a
  // button with its own Icon). Those triggers should keep their own styling.
  "& .stTooltipHoverTarget svg.icon": {
    stroke: i.colors.fadedText60,
    strokeWidth: i.sizes.defaultStrokeWidth
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabelHelpWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ewgb6651"
} : {
  target: "ewgb6651",
  label: "StyledLabelHelpWrapper"
})(({
  isLatex: o
}) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  visibility: "visible",
  // For LaTeX, use fit-content to keep icon close, but constrain with maxWidth
  // so long formulas can scroll. Center using margin-inline: auto
  width: o ? "fit-content" : "100%",
  ...o ? {
    maxWidth: "100%",
    marginInline: "auto"
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabelHelpInline = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "ewgb6650"
} : {
  target: "ewgb6650",
  label: "StyledLabelHelpInline"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.xs,
  position: "relative",
  display: "flex",
  flexDirection: "row"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function _extends$s() {
  return _extends$s = Object.assign || function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$s.apply(this, arguments);
}
function _objectWithoutProperties$o(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$n(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$n(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
var Check = forwardRef(function(o, i) {
  var g = o.color, E = g === void 0 ? "currentColor" : g, e = o.size, t = e === void 0 ? 24 : e, n = _objectWithoutProperties$o(o, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$s({
    ref: i,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: E,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, n), /* @__PURE__ */ React__default.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
});
Check.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Check.displayName = "Check";
function _extends$r() {
  return _extends$r = Object.assign || function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$r.apply(this, arguments);
}
function _objectWithoutProperties$n(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$m(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$m(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
var Copy = forwardRef(function(o, i) {
  var g = o.color, E = g === void 0 ? "currentColor" : g, e = o.size, t = e === void 0 ? 24 : e, n = _objectWithoutProperties$n(o, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$r({
    ref: i,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: E,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, n), /* @__PURE__ */ React__default.createElement("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  }));
});
Copy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Copy.displayName = "Copy";
function _extends$q() {
  return _extends$q = Object.assign || function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$q.apply(this, arguments);
}
function _objectWithoutProperties$m(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$l(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$l(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
var HelpCircle = forwardRef(function(o, i) {
  var g = o.color, E = g === void 0 ? "currentColor" : g, e = o.size, t = e === void 0 ? 24 : e, n = _objectWithoutProperties$m(o, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$q({
    ref: i,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: E,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, n), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /* @__PURE__ */ React__default.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
HelpCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
HelpCircle.displayName = "HelpCircle";
function _extends$p() {
  return _extends$p = Object.assign || function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$p.apply(this, arguments);
}
function _objectWithoutProperties$l(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$k(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$k(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
var Link2 = forwardRef(function(o, i) {
  var g = o.color, E = g === void 0 ? "currentColor" : g, e = o.size, t = e === void 0 ? 24 : e, n = _objectWithoutProperties$l(o, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$p({
    ref: i,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: E,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, n), /* @__PURE__ */ React__default.createElement("path", {
    d: "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
  }), /* @__PURE__ */ React__default.createElement("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
});
Link2.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Link2.displayName = "Link2";
function escapeStringRegexp$1(o) {
  if (typeof o != "string")
    throw new TypeError("Expected a string");
  return o.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const replacements = [
  // German umlauts
  ["ß", "ss"],
  ["ẞ", "Ss"],
  ["ä", "ae"],
  ["Ä", "Ae"],
  ["ö", "oe"],
  ["Ö", "Oe"],
  ["ü", "ue"],
  ["Ü", "Ue"],
  // Latin
  ["À", "A"],
  ["Á", "A"],
  ["Â", "A"],
  ["Ã", "A"],
  ["Ä", "Ae"],
  ["Å", "A"],
  ["Æ", "AE"],
  ["Ç", "C"],
  ["È", "E"],
  ["É", "E"],
  ["Ê", "E"],
  ["Ë", "E"],
  ["Ə", "A"],
  // Azerbaijani schwa
  ["Ì", "I"],
  ["Í", "I"],
  ["Î", "I"],
  ["Ï", "I"],
  ["Ð", "D"],
  ["Ñ", "N"],
  ["Ò", "O"],
  ["Ó", "O"],
  ["Ô", "O"],
  ["Õ", "O"],
  ["Ö", "Oe"],
  ["Ō", "O"],
  ["Ő", "O"],
  ["Ø", "O"],
  ["Œ", "OE"],
  // French ligature
  ["Ù", "U"],
  ["Ú", "U"],
  ["Û", "U"],
  ["Ü", "Ue"],
  ["Ű", "U"],
  ["Ý", "Y"],
  ["Þ", "TH"],
  ["ß", "ss"],
  ["à", "a"],
  ["á", "a"],
  ["â", "a"],
  ["ã", "a"],
  ["ä", "ae"],
  ["å", "a"],
  ["æ", "ae"],
  ["ç", "c"],
  ["è", "e"],
  ["é", "e"],
  ["ê", "e"],
  ["ë", "e"],
  ["ə", "a"],
  // Azerbaijani schwa
  ["ì", "i"],
  ["í", "i"],
  ["î", "i"],
  ["ï", "i"],
  ["ð", "d"],
  ["ñ", "n"],
  ["ò", "o"],
  ["ó", "o"],
  ["ô", "o"],
  ["õ", "o"],
  ["ö", "oe"],
  ["ō", "o"],
  ["ő", "o"],
  ["ø", "o"],
  ["œ", "oe"],
  // French ligature
  ["ù", "u"],
  ["ú", "u"],
  ["û", "u"],
  ["ü", "ue"],
  ["ű", "u"],
  ["ý", "y"],
  ["þ", "th"],
  ["ÿ", "y"],
  // Vietnamese
  ["à", "a"],
  ["À", "A"],
  ["á", "a"],
  ["Á", "A"],
  ["â", "a"],
  ["Â", "A"],
  ["ã", "a"],
  ["Ã", "A"],
  ["è", "e"],
  ["È", "E"],
  ["é", "e"],
  ["É", "E"],
  ["ê", "e"],
  ["Ê", "E"],
  ["ì", "i"],
  ["Ì", "I"],
  ["í", "i"],
  ["Í", "I"],
  ["ò", "o"],
  ["Ò", "O"],
  ["ó", "o"],
  ["Ó", "O"],
  ["ô", "o"],
  ["Ô", "O"],
  ["õ", "o"],
  ["Õ", "O"],
  ["ù", "u"],
  ["Ù", "U"],
  ["ú", "u"],
  ["Ú", "U"],
  ["ý", "y"],
  ["Ý", "Y"],
  ["ă", "a"],
  ["Ă", "A"],
  ["Đ", "D"],
  ["đ", "d"],
  ["ĩ", "i"],
  ["Ĩ", "I"],
  ["ũ", "u"],
  ["Ũ", "U"],
  ["ơ", "o"],
  ["Ơ", "O"],
  ["ư", "u"],
  ["Ư", "U"],
  ["ạ", "a"],
  ["Ạ", "A"],
  ["ả", "a"],
  ["Ả", "A"],
  ["ấ", "a"],
  ["Ấ", "A"],
  ["ầ", "a"],
  ["Ầ", "A"],
  ["ẩ", "a"],
  ["Ẩ", "A"],
  ["ẫ", "a"],
  ["Ẫ", "A"],
  ["ậ", "a"],
  ["Ậ", "A"],
  ["ắ", "a"],
  ["Ắ", "A"],
  ["ằ", "a"],
  ["Ằ", "A"],
  ["ẳ", "a"],
  ["Ẳ", "A"],
  ["ẵ", "a"],
  ["Ẵ", "A"],
  ["ặ", "a"],
  ["Ặ", "A"],
  ["ẹ", "e"],
  ["Ẹ", "E"],
  ["ẻ", "e"],
  ["Ẻ", "E"],
  ["ẽ", "e"],
  ["Ẽ", "E"],
  ["ế", "e"],
  ["Ế", "E"],
  ["ề", "e"],
  ["Ề", "E"],
  ["ể", "e"],
  ["Ể", "E"],
  ["ễ", "e"],
  ["Ễ", "E"],
  ["ệ", "e"],
  ["Ệ", "E"],
  ["ỉ", "i"],
  ["Ỉ", "I"],
  ["ị", "i"],
  ["Ị", "I"],
  ["ọ", "o"],
  ["Ọ", "O"],
  ["ỏ", "o"],
  ["Ỏ", "O"],
  ["ố", "o"],
  ["Ố", "O"],
  ["ồ", "o"],
  ["Ồ", "O"],
  ["ổ", "o"],
  ["Ổ", "O"],
  ["ỗ", "o"],
  ["Ỗ", "O"],
  ["ộ", "o"],
  ["Ộ", "O"],
  ["ớ", "o"],
  ["Ớ", "O"],
  ["ờ", "o"],
  ["Ờ", "O"],
  ["ở", "o"],
  ["Ở", "O"],
  ["ỡ", "o"],
  ["Ỡ", "O"],
  ["ợ", "o"],
  ["Ợ", "O"],
  ["ụ", "u"],
  ["Ụ", "U"],
  ["ủ", "u"],
  ["Ủ", "U"],
  ["ứ", "u"],
  ["Ứ", "U"],
  ["ừ", "u"],
  ["Ừ", "U"],
  ["ử", "u"],
  ["Ử", "U"],
  ["ữ", "u"],
  ["Ữ", "U"],
  ["ự", "u"],
  ["Ự", "U"],
  ["ỳ", "y"],
  ["Ỳ", "Y"],
  ["ỵ", "y"],
  ["Ỵ", "Y"],
  ["ỷ", "y"],
  ["Ỷ", "Y"],
  ["ỹ", "y"],
  ["Ỹ", "Y"],
  // Arabic
  ["ء", "e"],
  ["آ", "a"],
  ["أ", "a"],
  ["ؤ", "w"],
  ["إ", "a"],
  ["ئ", "y"],
  ["ا", "a"],
  ["ب", "b"],
  ["ة", "t"],
  ["ت", "t"],
  ["ث", "th"],
  ["ج", "j"],
  ["ح", "h"],
  ["خ", "kh"],
  ["د", "d"],
  ["ذ", "dh"],
  ["ر", "r"],
  ["ز", "z"],
  ["س", "s"],
  ["ش", "sh"],
  ["ص", "s"],
  ["ض", "d"],
  ["ط", "t"],
  ["ظ", "z"],
  ["ع", "e"],
  ["غ", "gh"],
  ["ـ", "_"],
  ["ف", "f"],
  ["ق", "q"],
  ["ك", "k"],
  ["ل", "l"],
  ["م", "m"],
  ["ن", "n"],
  ["ه", "h"],
  ["و", "w"],
  ["ى", "a"],
  ["ي", "y"],
  ["َ‎", "a"],
  ["ُ", "u"],
  ["ِ‎", "i"],
  ["٠", "0"],
  ["١", "1"],
  ["٢", "2"],
  ["٣", "3"],
  ["٤", "4"],
  ["٥", "5"],
  ["٦", "6"],
  ["٧", "7"],
  ["٨", "8"],
  ["٩", "9"],
  // Persian / Farsi
  ["چ", "ch"],
  ["ک", "k"],
  ["گ", "g"],
  ["پ", "p"],
  ["ژ", "zh"],
  ["ی", "y"],
  ["۰", "0"],
  ["۱", "1"],
  ["۲", "2"],
  ["۳", "3"],
  ["۴", "4"],
  ["۵", "5"],
  ["۶", "6"],
  ["۷", "7"],
  ["۸", "8"],
  ["۹", "9"],
  // Pashto
  ["ټ", "p"],
  ["ځ", "z"],
  ["څ", "c"],
  ["ډ", "d"],
  ["ﺫ", "d"],
  ["ﺭ", "r"],
  ["ړ", "r"],
  ["ﺯ", "z"],
  ["ږ", "g"],
  ["ښ", "x"],
  ["ګ", "g"],
  ["ڼ", "n"],
  ["ۀ", "e"],
  ["ې", "e"],
  ["ۍ", "ai"],
  // Urdu
  ["ٹ", "t"],
  ["ڈ", "d"],
  ["ڑ", "r"],
  ["ں", "n"],
  ["ہ", "h"],
  ["ھ", "h"],
  ["ے", "e"],
  // Russian
  ["А", "A"],
  ["а", "a"],
  ["Б", "B"],
  ["б", "b"],
  ["В", "V"],
  ["в", "v"],
  ["Г", "G"],
  ["г", "g"],
  ["Д", "D"],
  ["д", "d"],
  ["ъе", "ye"],
  ["Ъе", "Ye"],
  ["ъЕ", "yE"],
  ["ЪЕ", "YE"],
  ["Е", "E"],
  ["е", "e"],
  ["Ё", "Yo"],
  ["ё", "yo"],
  ["Ж", "Zh"],
  ["ж", "zh"],
  ["З", "Z"],
  ["з", "z"],
  ["И", "I"],
  ["и", "i"],
  ["ый", "iy"],
  ["Ый", "Iy"],
  ["ЫЙ", "IY"],
  ["ыЙ", "iY"],
  ["Й", "Y"],
  ["й", "y"],
  ["К", "K"],
  ["к", "k"],
  ["Л", "L"],
  ["л", "l"],
  ["М", "M"],
  ["м", "m"],
  ["Н", "N"],
  ["н", "n"],
  ["О", "O"],
  ["о", "o"],
  ["П", "P"],
  ["п", "p"],
  ["Р", "R"],
  ["р", "r"],
  ["С", "S"],
  ["с", "s"],
  ["Т", "T"],
  ["т", "t"],
  ["У", "U"],
  ["у", "u"],
  ["Ф", "F"],
  ["ф", "f"],
  ["Х", "Kh"],
  ["х", "kh"],
  ["Ц", "Ts"],
  ["ц", "ts"],
  ["Ч", "Ch"],
  ["ч", "ch"],
  ["Ш", "Sh"],
  ["ш", "sh"],
  ["Щ", "Sch"],
  ["щ", "sch"],
  ["Ъ", ""],
  ["ъ", ""],
  ["Ы", "Y"],
  ["ы", "y"],
  ["Ь", ""],
  ["ь", ""],
  ["Э", "E"],
  ["э", "e"],
  ["Ю", "Yu"],
  ["ю", "yu"],
  ["Я", "Ya"],
  ["я", "ya"],
  // Romanian
  ["ă", "a"],
  ["Ă", "A"],
  ["ș", "s"],
  ["Ș", "S"],
  ["ț", "t"],
  ["Ț", "T"],
  ["ţ", "t"],
  ["Ţ", "T"],
  // Turkish
  ["ş", "s"],
  ["Ş", "S"],
  ["ç", "c"],
  ["Ç", "C"],
  ["ğ", "g"],
  ["Ğ", "G"],
  ["ı", "i"],
  ["İ", "I"],
  // Armenian
  ["ա", "a"],
  ["Ա", "A"],
  ["բ", "b"],
  ["Բ", "B"],
  ["գ", "g"],
  ["Գ", "G"],
  ["դ", "d"],
  ["Դ", "D"],
  ["ե", "ye"],
  ["Ե", "Ye"],
  ["զ", "z"],
  ["Զ", "Z"],
  ["է", "e"],
  ["Է", "E"],
  ["ը", "y"],
  ["Ը", "Y"],
  ["թ", "t"],
  ["Թ", "T"],
  ["ժ", "zh"],
  ["Ժ", "Zh"],
  ["ի", "i"],
  ["Ի", "I"],
  ["լ", "l"],
  ["Լ", "L"],
  ["խ", "kh"],
  ["Խ", "Kh"],
  ["ծ", "ts"],
  ["Ծ", "Ts"],
  ["կ", "k"],
  ["Կ", "K"],
  ["հ", "h"],
  ["Հ", "H"],
  ["ձ", "dz"],
  ["Ձ", "Dz"],
  ["ղ", "gh"],
  ["Ղ", "Gh"],
  ["ճ", "tch"],
  ["Ճ", "Tch"],
  ["մ", "m"],
  ["Մ", "M"],
  ["յ", "y"],
  ["Յ", "Y"],
  ["ն", "n"],
  ["Ն", "N"],
  ["շ", "sh"],
  ["Շ", "Sh"],
  // NOTE: Longer Armenian sequences must come before shorter ones
  ["ու", "u"],
  ["ՈՒ", "U"],
  ["Ու", "U"],
  ["ո", "vo"],
  ["Ո", "Vo"],
  ["չ", "ch"],
  ["Չ", "Ch"],
  ["պ", "p"],
  ["Պ", "P"],
  ["ջ", "j"],
  ["Ջ", "J"],
  ["ռ", "r"],
  ["Ռ", "R"],
  ["ս", "s"],
  ["Ս", "S"],
  ["վ", "v"],
  ["Վ", "V"],
  ["տ", "t"],
  ["Տ", "T"],
  ["ր", "r"],
  ["Ր", "R"],
  ["ց", "c"],
  ["Ց", "C"],
  ["փ", "p"],
  ["Փ", "P"],
  ["ք", "q"],
  ["Ք", "Q"],
  ["օ", "o"],
  ["Օ", "O"],
  ["ֆ", "f"],
  ["Ֆ", "F"],
  ["և", "yev"],
  // Georgian
  ["ა", "a"],
  ["ბ", "b"],
  ["გ", "g"],
  ["დ", "d"],
  ["ე", "e"],
  ["ვ", "v"],
  ["ზ", "z"],
  ["თ", "t"],
  ["ი", "i"],
  ["კ", "k"],
  ["ლ", "l"],
  ["მ", "m"],
  ["ნ", "n"],
  ["ო", "o"],
  ["პ", "p"],
  ["ჟ", "zh"],
  ["რ", "r"],
  ["ს", "s"],
  ["ტ", "t"],
  ["უ", "u"],
  ["ფ", "ph"],
  ["ქ", "q"],
  ["ღ", "gh"],
  ["ყ", "k"],
  ["შ", "sh"],
  ["ჩ", "ch"],
  ["ც", "ts"],
  ["ძ", "dz"],
  ["წ", "ts"],
  ["ჭ", "tch"],
  ["ხ", "kh"],
  ["ჯ", "j"],
  ["ჰ", "h"],
  // Czech
  ["č", "c"],
  ["ď", "d"],
  ["ě", "e"],
  ["ň", "n"],
  ["ř", "r"],
  ["š", "s"],
  ["ť", "t"],
  ["ů", "u"],
  ["ž", "z"],
  ["Č", "C"],
  ["Ď", "D"],
  ["Ě", "E"],
  ["Ň", "N"],
  ["Ř", "R"],
  ["Š", "S"],
  ["Ť", "T"],
  ["Ů", "U"],
  ["Ž", "Z"],
  // Dhivehi
  ["ހ", "h"],
  ["ށ", "sh"],
  ["ނ", "n"],
  ["ރ", "r"],
  ["ބ", "b"],
  ["ޅ", "lh"],
  ["ކ", "k"],
  ["އ", "a"],
  ["ވ", "v"],
  ["މ", "m"],
  ["ފ", "f"],
  ["ދ", "dh"],
  ["ތ", "th"],
  ["ލ", "l"],
  ["ގ", "g"],
  ["ޏ", "gn"],
  ["ސ", "s"],
  ["ޑ", "d"],
  ["ޒ", "z"],
  ["ޓ", "t"],
  ["ޔ", "y"],
  ["ޕ", "p"],
  ["ޖ", "j"],
  ["ޗ", "ch"],
  ["ޘ", "tt"],
  ["ޙ", "hh"],
  ["ޚ", "kh"],
  ["ޛ", "th"],
  ["ޜ", "z"],
  ["ޝ", "sh"],
  ["ޞ", "s"],
  ["ޟ", "d"],
  ["ޠ", "t"],
  ["ޡ", "z"],
  ["ޢ", "a"],
  ["ޣ", "gh"],
  ["ޤ", "q"],
  ["ޥ", "w"],
  ["ަ", "a"],
  ["ާ", "aa"],
  ["ި", "i"],
  ["ީ", "ee"],
  ["ު", "u"],
  ["ޫ", "oo"],
  ["ެ", "e"],
  ["ޭ", "ey"],
  ["ޮ", "o"],
  ["ޯ", "oa"],
  ["ް", ""],
  // Greek
  ["α", "a"],
  ["β", "v"],
  ["γ", "g"],
  ["δ", "d"],
  ["ε", "e"],
  ["ζ", "z"],
  ["η", "i"],
  ["θ", "th"],
  ["ι", "i"],
  ["κ", "k"],
  ["λ", "l"],
  ["μ", "m"],
  ["ν", "n"],
  ["ξ", "ks"],
  ["ο", "o"],
  ["π", "p"],
  ["ρ", "r"],
  ["σ", "s"],
  ["τ", "t"],
  ["υ", "y"],
  ["φ", "f"],
  ["χ", "x"],
  ["ψ", "ps"],
  ["ω", "o"],
  ["ά", "a"],
  ["έ", "e"],
  ["ί", "i"],
  ["ό", "o"],
  ["ύ", "y"],
  ["ή", "i"],
  ["ώ", "o"],
  ["ς", "s"],
  ["ϊ", "i"],
  ["ΰ", "y"],
  ["ϋ", "y"],
  ["ΐ", "i"],
  ["Α", "A"],
  ["Β", "B"],
  ["Γ", "G"],
  ["Δ", "D"],
  ["Ε", "E"],
  ["Ζ", "Z"],
  ["Η", "I"],
  ["Θ", "TH"],
  ["Ι", "I"],
  ["Κ", "K"],
  ["Λ", "L"],
  ["Μ", "M"],
  ["Ν", "N"],
  ["Ξ", "KS"],
  ["Ο", "O"],
  ["Π", "P"],
  ["Ρ", "R"],
  ["Σ", "S"],
  ["Τ", "T"],
  ["Υ", "Y"],
  ["Φ", "F"],
  ["Χ", "X"],
  ["Ψ", "PS"],
  ["Ω", "O"],
  ["Ά", "A"],
  ["Έ", "E"],
  ["Ί", "I"],
  ["Ό", "O"],
  ["Ύ", "Y"],
  ["Ή", "I"],
  ["Ώ", "O"],
  ["Ϊ", "I"],
  ["Ϋ", "Y"],
  // Disabled as it conflicts with German and Latin.
  // Hungarian
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ö', 'o'],
  // ['Ö', 'O'],
  // ['ü', 'u'],
  // ['Ü', 'U'],
  // ['ű', 'u'],
  // ['Ű', 'U'],
  // Latvian
  ["ā", "a"],
  ["ē", "e"],
  ["ģ", "g"],
  ["ī", "i"],
  ["ķ", "k"],
  ["ļ", "l"],
  ["ņ", "n"],
  ["ū", "u"],
  ["Ā", "A"],
  ["Ē", "E"],
  ["Ģ", "G"],
  ["Ī", "I"],
  ["Ķ", "K"],
  ["Ļ", "L"],
  ["Ņ", "N"],
  ["Ū", "U"],
  ["č", "c"],
  ["š", "s"],
  ["ž", "z"],
  ["Č", "C"],
  ["Š", "S"],
  ["Ž", "Z"],
  // Lithuanian
  ["ą", "a"],
  ["č", "c"],
  ["ę", "e"],
  ["ė", "e"],
  ["į", "i"],
  ["š", "s"],
  ["ų", "u"],
  ["ū", "u"],
  ["ž", "z"],
  ["Ą", "A"],
  ["Č", "C"],
  ["Ę", "E"],
  ["Ė", "E"],
  ["Į", "I"],
  ["Š", "S"],
  ["Ų", "U"],
  ["Ū", "U"],
  // Macedonian
  ["Ќ", "Kj"],
  ["ќ", "kj"],
  ["Љ", "Lj"],
  ["љ", "lj"],
  ["Њ", "Nj"],
  ["њ", "nj"],
  ["Тс", "Ts"],
  ["тс", "ts"],
  // Polish
  ["ą", "a"],
  ["ć", "c"],
  ["ę", "e"],
  ["ł", "l"],
  ["ń", "n"],
  ["ś", "s"],
  ["ź", "z"],
  ["ż", "z"],
  ["Ą", "A"],
  ["Ć", "C"],
  ["Ę", "E"],
  ["Ł", "L"],
  ["Ń", "N"],
  ["Ś", "S"],
  ["Ź", "Z"],
  ["Ż", "Z"],
  // Disabled as it conflicts with Vietnamese.
  // Serbian
  // ['љ', 'lj'],
  // ['њ', 'nj'],
  // ['Љ', 'Lj'],
  // ['Њ', 'Nj'],
  // ['đ', 'dj'],
  // ['Đ', 'Dj'],
  // ['ђ', 'dj'],
  // ['ј', 'j'],
  // ['ћ', 'c'],
  // ['џ', 'dz'],
  // ['Ђ', 'Dj'],
  // ['Ј', 'j'],
  // ['Ћ', 'C'],
  // ['Џ', 'Dz'],
  // Disabled as it conflicts with German and Latin.
  // Slovak
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ľ', 'l'],
  // ['ĺ', 'l'],
  // ['ŕ', 'r'],
  // ['Ľ', 'L'],
  // ['Ĺ', 'L'],
  // ['Ŕ', 'R'],
  // Disabled as it conflicts with German and Latin.
  // Swedish
  // ['å', 'o'],
  // ['Å', 'o'],
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ë', 'e'],
  // ['Ë', 'E'],
  // ['ö', 'o'],
  // ['Ö', 'O'],
  // Ukrainian
  ["Є", "Ye"],
  ["І", "I"],
  ["Ї", "Yi"],
  ["Ґ", "G"],
  ["є", "ye"],
  ["і", "i"],
  ["ї", "yi"],
  ["ґ", "g"],
  // Dutch
  ["Ĳ", "IJ"],
  ["ĳ", "ij"],
  // Danish
  // ['Æ', 'Ae'],
  // ['Ø', 'Oe'],
  // ['Å', 'Aa'],
  // ['æ', 'ae'],
  // ['ø', 'oe'],
  // ['å', 'aa']
  // Currencies
  ["¢", "c"],
  ["¥", "Y"],
  ["߿", "b"],
  ["৳", "t"],
  ["૱", "Bo"],
  ["฿", "B"],
  ["₠", "CE"],
  ["₡", "C"],
  ["₢", "Cr"],
  ["₣", "F"],
  ["₥", "m"],
  ["₦", "N"],
  ["₧", "Pt"],
  ["₨", "Rs"],
  ["₩", "W"],
  ["₫", "s"],
  ["€", "E"],
  ["₭", "K"],
  ["₮", "T"],
  ["₯", "Dp"],
  ["₰", "S"],
  ["₱", "P"],
  ["₲", "G"],
  ["₳", "A"],
  ["₴", "S"],
  ["₵", "C"],
  ["₶", "tt"],
  ["₷", "S"],
  ["₸", "T"],
  ["₹", "R"],
  ["₺", "L"],
  ["₽", "P"],
  ["₿", "B"],
  ["﹩", "$"],
  ["￠", "c"],
  ["￥", "Y"],
  ["￦", "W"],
  // Latin
  ["𝐀", "A"],
  ["𝐁", "B"],
  ["𝐂", "C"],
  ["𝐃", "D"],
  ["𝐄", "E"],
  ["𝐅", "F"],
  ["𝐆", "G"],
  ["𝐇", "H"],
  ["𝐈", "I"],
  ["𝐉", "J"],
  ["𝐊", "K"],
  ["𝐋", "L"],
  ["𝐌", "M"],
  ["𝐍", "N"],
  ["𝐎", "O"],
  ["𝐏", "P"],
  ["𝐐", "Q"],
  ["𝐑", "R"],
  ["𝐒", "S"],
  ["𝐓", "T"],
  ["𝐔", "U"],
  ["𝐕", "V"],
  ["𝐖", "W"],
  ["𝐗", "X"],
  ["𝐘", "Y"],
  ["𝐙", "Z"],
  ["𝐚", "a"],
  ["𝐛", "b"],
  ["𝐜", "c"],
  ["𝐝", "d"],
  ["𝐞", "e"],
  ["𝐟", "f"],
  ["𝐠", "g"],
  ["𝐡", "h"],
  ["𝐢", "i"],
  ["𝐣", "j"],
  ["𝐤", "k"],
  ["𝐥", "l"],
  ["𝐦", "m"],
  ["𝐧", "n"],
  ["𝐨", "o"],
  ["𝐩", "p"],
  ["𝐪", "q"],
  ["𝐫", "r"],
  ["𝐬", "s"],
  ["𝐭", "t"],
  ["𝐮", "u"],
  ["𝐯", "v"],
  ["𝐰", "w"],
  ["𝐱", "x"],
  ["𝐲", "y"],
  ["𝐳", "z"],
  ["𝐴", "A"],
  ["𝐵", "B"],
  ["𝐶", "C"],
  ["𝐷", "D"],
  ["𝐸", "E"],
  ["𝐹", "F"],
  ["𝐺", "G"],
  ["𝐻", "H"],
  ["𝐼", "I"],
  ["𝐽", "J"],
  ["𝐾", "K"],
  ["𝐿", "L"],
  ["𝑀", "M"],
  ["𝑁", "N"],
  ["𝑂", "O"],
  ["𝑃", "P"],
  ["𝑄", "Q"],
  ["𝑅", "R"],
  ["𝑆", "S"],
  ["𝑇", "T"],
  ["𝑈", "U"],
  ["𝑉", "V"],
  ["𝑊", "W"],
  ["𝑋", "X"],
  ["𝑌", "Y"],
  ["𝑍", "Z"],
  ["𝑎", "a"],
  ["𝑏", "b"],
  ["𝑐", "c"],
  ["𝑑", "d"],
  ["𝑒", "e"],
  ["𝑓", "f"],
  ["𝑔", "g"],
  ["𝑖", "i"],
  ["𝑗", "j"],
  ["𝑘", "k"],
  ["𝑙", "l"],
  ["𝑚", "m"],
  ["𝑛", "n"],
  ["𝑜", "o"],
  ["𝑝", "p"],
  ["𝑞", "q"],
  ["𝑟", "r"],
  ["𝑠", "s"],
  ["𝑡", "t"],
  ["𝑢", "u"],
  ["𝑣", "v"],
  ["𝑤", "w"],
  ["𝑥", "x"],
  ["𝑦", "y"],
  ["𝑧", "z"],
  ["𝑨", "A"],
  ["𝑩", "B"],
  ["𝑪", "C"],
  ["𝑫", "D"],
  ["𝑬", "E"],
  ["𝑭", "F"],
  ["𝑮", "G"],
  ["𝑯", "H"],
  ["𝑰", "I"],
  ["𝑱", "J"],
  ["𝑲", "K"],
  ["𝑳", "L"],
  ["𝑴", "M"],
  ["𝑵", "N"],
  ["𝑶", "O"],
  ["𝑷", "P"],
  ["𝑸", "Q"],
  ["𝑹", "R"],
  ["𝑺", "S"],
  ["𝑻", "T"],
  ["𝑼", "U"],
  ["𝑽", "V"],
  ["𝑾", "W"],
  ["𝑿", "X"],
  ["𝒀", "Y"],
  ["𝒁", "Z"],
  ["𝒂", "a"],
  ["𝒃", "b"],
  ["𝒄", "c"],
  ["𝒅", "d"],
  ["𝒆", "e"],
  ["𝒇", "f"],
  ["𝒈", "g"],
  ["𝒉", "h"],
  ["𝒊", "i"],
  ["𝒋", "j"],
  ["𝒌", "k"],
  ["𝒍", "l"],
  ["𝒎", "m"],
  ["𝒏", "n"],
  ["𝒐", "o"],
  ["𝒑", "p"],
  ["𝒒", "q"],
  ["𝒓", "r"],
  ["𝒔", "s"],
  ["𝒕", "t"],
  ["𝒖", "u"],
  ["𝒗", "v"],
  ["𝒘", "w"],
  ["𝒙", "x"],
  ["𝒚", "y"],
  ["𝒛", "z"],
  ["𝒜", "A"],
  ["𝒞", "C"],
  ["𝒟", "D"],
  ["𝒢", "g"],
  ["𝒥", "J"],
  ["𝒦", "K"],
  ["𝒩", "N"],
  ["𝒪", "O"],
  ["𝒫", "P"],
  ["𝒬", "Q"],
  ["𝒮", "S"],
  ["𝒯", "T"],
  ["𝒰", "U"],
  ["𝒱", "V"],
  ["𝒲", "W"],
  ["𝒳", "X"],
  ["𝒴", "Y"],
  ["𝒵", "Z"],
  ["𝒶", "a"],
  ["𝒷", "b"],
  ["𝒸", "c"],
  ["𝒹", "d"],
  ["𝒻", "f"],
  ["𝒽", "h"],
  ["𝒾", "i"],
  ["𝒿", "j"],
  ["𝓀", "k"],
  ["𝓁", "l"],
  ["𝓂", "m"],
  ["𝓃", "n"],
  ["𝓅", "p"],
  ["𝓆", "q"],
  ["𝓇", "r"],
  ["𝓈", "s"],
  ["𝓉", "t"],
  ["𝓊", "u"],
  ["𝓋", "v"],
  ["𝓌", "w"],
  ["𝓍", "x"],
  ["𝓎", "y"],
  ["𝓏", "z"],
  ["𝓐", "A"],
  ["𝓑", "B"],
  ["𝓒", "C"],
  ["𝓓", "D"],
  ["𝓔", "E"],
  ["𝓕", "F"],
  ["𝓖", "G"],
  ["𝓗", "H"],
  ["𝓘", "I"],
  ["𝓙", "J"],
  ["𝓚", "K"],
  ["𝓛", "L"],
  ["𝓜", "M"],
  ["𝓝", "N"],
  ["𝓞", "O"],
  ["𝓟", "P"],
  ["𝓠", "Q"],
  ["𝓡", "R"],
  ["𝓢", "S"],
  ["𝓣", "T"],
  ["𝓤", "U"],
  ["𝓥", "V"],
  ["𝓦", "W"],
  ["𝓧", "X"],
  ["𝓨", "Y"],
  ["𝓩", "Z"],
  ["𝓪", "a"],
  ["𝓫", "b"],
  ["𝓬", "c"],
  ["𝓭", "d"],
  ["𝓮", "e"],
  ["𝓯", "f"],
  ["𝓰", "g"],
  ["𝓱", "h"],
  ["𝓲", "i"],
  ["𝓳", "j"],
  ["𝓴", "k"],
  ["𝓵", "l"],
  ["𝓶", "m"],
  ["𝓷", "n"],
  ["𝓸", "o"],
  ["𝓹", "p"],
  ["𝓺", "q"],
  ["𝓻", "r"],
  ["𝓼", "s"],
  ["𝓽", "t"],
  ["𝓾", "u"],
  ["𝓿", "v"],
  ["𝔀", "w"],
  ["𝔁", "x"],
  ["𝔂", "y"],
  ["𝔃", "z"],
  ["𝔄", "A"],
  ["𝔅", "B"],
  ["𝔇", "D"],
  ["𝔈", "E"],
  ["𝔉", "F"],
  ["𝔊", "G"],
  ["𝔍", "J"],
  ["𝔎", "K"],
  ["𝔏", "L"],
  ["𝔐", "M"],
  ["𝔑", "N"],
  ["𝔒", "O"],
  ["𝔓", "P"],
  ["𝔔", "Q"],
  ["𝔖", "S"],
  ["𝔗", "T"],
  ["𝔘", "U"],
  ["𝔙", "V"],
  ["𝔚", "W"],
  ["𝔛", "X"],
  ["𝔜", "Y"],
  ["𝔞", "a"],
  ["𝔟", "b"],
  ["𝔠", "c"],
  ["𝔡", "d"],
  ["𝔢", "e"],
  ["𝔣", "f"],
  ["𝔤", "g"],
  ["𝔥", "h"],
  ["𝔦", "i"],
  ["𝔧", "j"],
  ["𝔨", "k"],
  ["𝔩", "l"],
  ["𝔪", "m"],
  ["𝔫", "n"],
  ["𝔬", "o"],
  ["𝔭", "p"],
  ["𝔮", "q"],
  ["𝔯", "r"],
  ["𝔰", "s"],
  ["𝔱", "t"],
  ["𝔲", "u"],
  ["𝔳", "v"],
  ["𝔴", "w"],
  ["𝔵", "x"],
  ["𝔶", "y"],
  ["𝔷", "z"],
  ["𝔸", "A"],
  ["𝔹", "B"],
  ["𝔻", "D"],
  ["𝔼", "E"],
  ["𝔽", "F"],
  ["𝔾", "G"],
  ["𝕀", "I"],
  ["𝕁", "J"],
  ["𝕂", "K"],
  ["𝕃", "L"],
  ["𝕄", "M"],
  ["𝕆", "O"],
  ["𝕊", "S"],
  ["𝕋", "T"],
  ["𝕌", "U"],
  ["𝕍", "V"],
  ["𝕎", "W"],
  ["𝕏", "X"],
  ["𝕐", "Y"],
  ["𝕒", "a"],
  ["𝕓", "b"],
  ["𝕔", "c"],
  ["𝕕", "d"],
  ["𝕖", "e"],
  ["𝕗", "f"],
  ["𝕘", "g"],
  ["𝕙", "h"],
  ["𝕚", "i"],
  ["𝕛", "j"],
  ["𝕜", "k"],
  ["𝕝", "l"],
  ["𝕞", "m"],
  ["𝕟", "n"],
  ["𝕠", "o"],
  ["𝕡", "p"],
  ["𝕢", "q"],
  ["𝕣", "r"],
  ["𝕤", "s"],
  ["𝕥", "t"],
  ["𝕦", "u"],
  ["𝕧", "v"],
  ["𝕨", "w"],
  ["𝕩", "x"],
  ["𝕪", "y"],
  ["𝕫", "z"],
  ["𝕬", "A"],
  ["𝕭", "B"],
  ["𝕮", "C"],
  ["𝕯", "D"],
  ["𝕰", "E"],
  ["𝕱", "F"],
  ["𝕲", "G"],
  ["𝕳", "H"],
  ["𝕴", "I"],
  ["𝕵", "J"],
  ["𝕶", "K"],
  ["𝕷", "L"],
  ["𝕸", "M"],
  ["𝕹", "N"],
  ["𝕺", "O"],
  ["𝕻", "P"],
  ["𝕼", "Q"],
  ["𝕽", "R"],
  ["𝕾", "S"],
  ["𝕿", "T"],
  ["𝖀", "U"],
  ["𝖁", "V"],
  ["𝖂", "W"],
  ["𝖃", "X"],
  ["𝖄", "Y"],
  ["𝖅", "Z"],
  ["𝖆", "a"],
  ["𝖇", "b"],
  ["𝖈", "c"],
  ["𝖉", "d"],
  ["𝖊", "e"],
  ["𝖋", "f"],
  ["𝖌", "g"],
  ["𝖍", "h"],
  ["𝖎", "i"],
  ["𝖏", "j"],
  ["𝖐", "k"],
  ["𝖑", "l"],
  ["𝖒", "m"],
  ["𝖓", "n"],
  ["𝖔", "o"],
  ["𝖕", "p"],
  ["𝖖", "q"],
  ["𝖗", "r"],
  ["𝖘", "s"],
  ["𝖙", "t"],
  ["𝖚", "u"],
  ["𝖛", "v"],
  ["𝖜", "w"],
  ["𝖝", "x"],
  ["𝖞", "y"],
  ["𝖟", "z"],
  ["𝖠", "A"],
  ["𝖡", "B"],
  ["𝖢", "C"],
  ["𝖣", "D"],
  ["𝖤", "E"],
  ["𝖥", "F"],
  ["𝖦", "G"],
  ["𝖧", "H"],
  ["𝖨", "I"],
  ["𝖩", "J"],
  ["𝖪", "K"],
  ["𝖫", "L"],
  ["𝖬", "M"],
  ["𝖭", "N"],
  ["𝖮", "O"],
  ["𝖯", "P"],
  ["𝖰", "Q"],
  ["𝖱", "R"],
  ["𝖲", "S"],
  ["𝖳", "T"],
  ["𝖴", "U"],
  ["𝖵", "V"],
  ["𝖶", "W"],
  ["𝖷", "X"],
  ["𝖸", "Y"],
  ["𝖹", "Z"],
  ["𝖺", "a"],
  ["𝖻", "b"],
  ["𝖼", "c"],
  ["𝖽", "d"],
  ["𝖾", "e"],
  ["𝖿", "f"],
  ["𝗀", "g"],
  ["𝗁", "h"],
  ["𝗂", "i"],
  ["𝗃", "j"],
  ["𝗄", "k"],
  ["𝗅", "l"],
  ["𝗆", "m"],
  ["𝗇", "n"],
  ["𝗈", "o"],
  ["𝗉", "p"],
  ["𝗊", "q"],
  ["𝗋", "r"],
  ["𝗌", "s"],
  ["𝗍", "t"],
  ["𝗎", "u"],
  ["𝗏", "v"],
  ["𝗐", "w"],
  ["𝗑", "x"],
  ["𝗒", "y"],
  ["𝗓", "z"],
  ["𝗔", "A"],
  ["𝗕", "B"],
  ["𝗖", "C"],
  ["𝗗", "D"],
  ["𝗘", "E"],
  ["𝗙", "F"],
  ["𝗚", "G"],
  ["𝗛", "H"],
  ["𝗜", "I"],
  ["𝗝", "J"],
  ["𝗞", "K"],
  ["𝗟", "L"],
  ["𝗠", "M"],
  ["𝗡", "N"],
  ["𝗢", "O"],
  ["𝗣", "P"],
  ["𝗤", "Q"],
  ["𝗥", "R"],
  ["𝗦", "S"],
  ["𝗧", "T"],
  ["𝗨", "U"],
  ["𝗩", "V"],
  ["𝗪", "W"],
  ["𝗫", "X"],
  ["𝗬", "Y"],
  ["𝗭", "Z"],
  ["𝗮", "a"],
  ["𝗯", "b"],
  ["𝗰", "c"],
  ["𝗱", "d"],
  ["𝗲", "e"],
  ["𝗳", "f"],
  ["𝗴", "g"],
  ["𝗵", "h"],
  ["𝗶", "i"],
  ["𝗷", "j"],
  ["𝗸", "k"],
  ["𝗹", "l"],
  ["𝗺", "m"],
  ["𝗻", "n"],
  ["𝗼", "o"],
  ["𝗽", "p"],
  ["𝗾", "q"],
  ["𝗿", "r"],
  ["𝘀", "s"],
  ["𝘁", "t"],
  ["𝘂", "u"],
  ["𝘃", "v"],
  ["𝘄", "w"],
  ["𝘅", "x"],
  ["𝘆", "y"],
  ["𝘇", "z"],
  ["𝘈", "A"],
  ["𝘉", "B"],
  ["𝘊", "C"],
  ["𝘋", "D"],
  ["𝘌", "E"],
  ["𝘍", "F"],
  ["𝘎", "G"],
  ["𝘏", "H"],
  ["𝘐", "I"],
  ["𝘑", "J"],
  ["𝘒", "K"],
  ["𝘓", "L"],
  ["𝘔", "M"],
  ["𝘕", "N"],
  ["𝘖", "O"],
  ["𝘗", "P"],
  ["𝘘", "Q"],
  ["𝘙", "R"],
  ["𝘚", "S"],
  ["𝘛", "T"],
  ["𝘜", "U"],
  ["𝘝", "V"],
  ["𝘞", "W"],
  ["𝘟", "X"],
  ["𝘠", "Y"],
  ["𝘡", "Z"],
  ["𝘢", "a"],
  ["𝘣", "b"],
  ["𝘤", "c"],
  ["𝘥", "d"],
  ["𝘦", "e"],
  ["𝘧", "f"],
  ["𝘨", "g"],
  ["𝘩", "h"],
  ["𝘪", "i"],
  ["𝘫", "j"],
  ["𝘬", "k"],
  ["𝘭", "l"],
  ["𝘮", "m"],
  ["𝘯", "n"],
  ["𝘰", "o"],
  ["𝘱", "p"],
  ["𝘲", "q"],
  ["𝘳", "r"],
  ["𝘴", "s"],
  ["𝘵", "t"],
  ["𝘶", "u"],
  ["𝘷", "v"],
  ["𝘸", "w"],
  ["𝘹", "x"],
  ["𝘺", "y"],
  ["𝘻", "z"],
  ["𝘼", "A"],
  ["𝘽", "B"],
  ["𝘾", "C"],
  ["𝘿", "D"],
  ["𝙀", "E"],
  ["𝙁", "F"],
  ["𝙂", "G"],
  ["𝙃", "H"],
  ["𝙄", "I"],
  ["𝙅", "J"],
  ["𝙆", "K"],
  ["𝙇", "L"],
  ["𝙈", "M"],
  ["𝙉", "N"],
  ["𝙊", "O"],
  ["𝙋", "P"],
  ["𝙌", "Q"],
  ["𝙍", "R"],
  ["𝙎", "S"],
  ["𝙏", "T"],
  ["𝙐", "U"],
  ["𝙑", "V"],
  ["𝙒", "W"],
  ["𝙓", "X"],
  ["𝙔", "Y"],
  ["𝙕", "Z"],
  ["𝙖", "a"],
  ["𝙗", "b"],
  ["𝙘", "c"],
  ["𝙙", "d"],
  ["𝙚", "e"],
  ["𝙛", "f"],
  ["𝙜", "g"],
  ["𝙝", "h"],
  ["𝙞", "i"],
  ["𝙟", "j"],
  ["𝙠", "k"],
  ["𝙡", "l"],
  ["𝙢", "m"],
  ["𝙣", "n"],
  ["𝙤", "o"],
  ["𝙥", "p"],
  ["𝙦", "q"],
  ["𝙧", "r"],
  ["𝙨", "s"],
  ["𝙩", "t"],
  ["𝙪", "u"],
  ["𝙫", "v"],
  ["𝙬", "w"],
  ["𝙭", "x"],
  ["𝙮", "y"],
  ["𝙯", "z"],
  ["𝙰", "A"],
  ["𝙱", "B"],
  ["𝙲", "C"],
  ["𝙳", "D"],
  ["𝙴", "E"],
  ["𝙵", "F"],
  ["𝙶", "G"],
  ["𝙷", "H"],
  ["𝙸", "I"],
  ["𝙹", "J"],
  ["𝙺", "K"],
  ["𝙻", "L"],
  ["𝙼", "M"],
  ["𝙽", "N"],
  ["𝙾", "O"],
  ["𝙿", "P"],
  ["𝚀", "Q"],
  ["𝚁", "R"],
  ["𝚂", "S"],
  ["𝚃", "T"],
  ["𝚄", "U"],
  ["𝚅", "V"],
  ["𝚆", "W"],
  ["𝚇", "X"],
  ["𝚈", "Y"],
  ["𝚉", "Z"],
  ["𝚊", "a"],
  ["𝚋", "b"],
  ["𝚌", "c"],
  ["𝚍", "d"],
  ["𝚎", "e"],
  ["𝚏", "f"],
  ["𝚐", "g"],
  ["𝚑", "h"],
  ["𝚒", "i"],
  ["𝚓", "j"],
  ["𝚔", "k"],
  ["𝚕", "l"],
  ["𝚖", "m"],
  ["𝚗", "n"],
  ["𝚘", "o"],
  ["𝚙", "p"],
  ["𝚚", "q"],
  ["𝚛", "r"],
  ["𝚜", "s"],
  ["𝚝", "t"],
  ["𝚞", "u"],
  ["𝚟", "v"],
  ["𝚠", "w"],
  ["𝚡", "x"],
  ["𝚢", "y"],
  ["𝚣", "z"],
  // Dotless letters
  ["𝚤", "l"],
  ["𝚥", "j"],
  // Greek
  ["𝛢", "A"],
  ["𝛣", "B"],
  ["𝛤", "G"],
  ["𝛥", "D"],
  ["𝛦", "E"],
  ["𝛧", "Z"],
  ["𝛨", "I"],
  ["𝛩", "TH"],
  ["𝛪", "I"],
  ["𝛫", "K"],
  ["𝛬", "L"],
  ["𝛭", "M"],
  ["𝛮", "N"],
  ["𝛯", "KS"],
  ["𝛰", "O"],
  ["𝛱", "P"],
  ["𝛲", "R"],
  ["𝛳", "TH"],
  ["𝛴", "S"],
  ["𝛵", "T"],
  ["𝛶", "Y"],
  ["𝛷", "F"],
  ["𝛸", "x"],
  ["𝛹", "PS"],
  ["𝛺", "O"],
  ["𝛻", "D"],
  ["𝛼", "a"],
  ["𝛽", "b"],
  ["𝛾", "g"],
  ["𝛿", "d"],
  ["𝜀", "e"],
  ["𝜁", "z"],
  ["𝜂", "i"],
  ["𝜃", "th"],
  ["𝜄", "i"],
  ["𝜅", "k"],
  ["𝜆", "l"],
  ["𝜇", "m"],
  ["𝜈", "n"],
  ["𝜉", "ks"],
  ["𝜊", "o"],
  ["𝜋", "p"],
  ["𝜌", "r"],
  ["𝜍", "s"],
  ["𝜎", "s"],
  ["𝜏", "t"],
  ["𝜐", "y"],
  ["𝜑", "f"],
  ["𝜒", "x"],
  ["𝜓", "ps"],
  ["𝜔", "o"],
  ["𝜕", "d"],
  ["𝜖", "E"],
  ["𝜗", "TH"],
  ["𝜘", "K"],
  ["𝜙", "f"],
  ["𝜚", "r"],
  ["𝜛", "p"],
  ["𝜜", "A"],
  ["𝜝", "V"],
  ["𝜞", "G"],
  ["𝜟", "D"],
  ["𝜠", "E"],
  ["𝜡", "Z"],
  ["𝜢", "I"],
  ["𝜣", "TH"],
  ["𝜤", "I"],
  ["𝜥", "K"],
  ["𝜦", "L"],
  ["𝜧", "M"],
  ["𝜨", "N"],
  ["𝜩", "KS"],
  ["𝜪", "O"],
  ["𝜫", "P"],
  ["𝜬", "S"],
  ["𝜭", "TH"],
  ["𝜮", "S"],
  ["𝜯", "T"],
  ["𝜰", "Y"],
  ["𝜱", "F"],
  ["𝜲", "X"],
  ["𝜳", "PS"],
  ["𝜴", "O"],
  ["𝜵", "D"],
  ["𝜶", "a"],
  ["𝜷", "v"],
  ["𝜸", "g"],
  ["𝜹", "d"],
  ["𝜺", "e"],
  ["𝜻", "z"],
  ["𝜼", "i"],
  ["𝜽", "th"],
  ["𝜾", "i"],
  ["𝜿", "k"],
  ["𝝀", "l"],
  ["𝝁", "m"],
  ["𝝂", "n"],
  ["𝝃", "ks"],
  ["𝝄", "o"],
  ["𝝅", "p"],
  ["𝝆", "r"],
  ["𝝇", "s"],
  ["𝝈", "s"],
  ["𝝉", "t"],
  ["𝝊", "y"],
  ["𝝋", "f"],
  ["𝝌", "x"],
  ["𝝍", "ps"],
  ["𝝎", "o"],
  ["𝝏", "a"],
  ["𝝐", "e"],
  ["𝝑", "i"],
  ["𝝒", "k"],
  ["𝝓", "f"],
  ["𝝔", "r"],
  ["𝝕", "p"],
  ["𝝖", "A"],
  ["𝝗", "B"],
  ["𝝘", "G"],
  ["𝝙", "D"],
  ["𝝚", "E"],
  ["𝝛", "Z"],
  ["𝝜", "I"],
  ["𝝝", "TH"],
  ["𝝞", "I"],
  ["𝝟", "K"],
  ["𝝠", "L"],
  ["𝝡", "M"],
  ["𝝢", "N"],
  ["𝝣", "KS"],
  ["𝝤", "O"],
  ["𝝥", "P"],
  ["𝝦", "R"],
  ["𝝧", "TH"],
  ["𝝨", "S"],
  ["𝝩", "T"],
  ["𝝪", "Y"],
  ["𝝫", "F"],
  ["𝝬", "X"],
  ["𝝭", "PS"],
  ["𝝮", "O"],
  ["𝝯", "D"],
  ["𝝰", "a"],
  ["𝝱", "v"],
  ["𝝲", "g"],
  ["𝝳", "d"],
  ["𝝴", "e"],
  ["𝝵", "z"],
  ["𝝶", "i"],
  ["𝝷", "th"],
  ["𝝸", "i"],
  ["𝝹", "k"],
  ["𝝺", "l"],
  ["𝝻", "m"],
  ["𝝼", "n"],
  ["𝝽", "ks"],
  ["𝝾", "o"],
  ["𝝿", "p"],
  ["𝞀", "r"],
  ["𝞁", "s"],
  ["𝞂", "s"],
  ["𝞃", "t"],
  ["𝞄", "y"],
  ["𝞅", "f"],
  ["𝞆", "x"],
  ["𝞇", "ps"],
  ["𝞈", "o"],
  ["𝞉", "a"],
  ["𝞊", "e"],
  ["𝞋", "i"],
  ["𝞌", "k"],
  ["𝞍", "f"],
  ["𝞎", "r"],
  ["𝞏", "p"],
  ["𝞐", "A"],
  ["𝞑", "V"],
  ["𝞒", "G"],
  ["𝞓", "D"],
  ["𝞔", "E"],
  ["𝞕", "Z"],
  ["𝞖", "I"],
  ["𝞗", "TH"],
  ["𝞘", "I"],
  ["𝞙", "K"],
  ["𝞚", "L"],
  ["𝞛", "M"],
  ["𝞜", "N"],
  ["𝞝", "KS"],
  ["𝞞", "O"],
  ["𝞟", "P"],
  ["𝞠", "S"],
  ["𝞡", "TH"],
  ["𝞢", "S"],
  ["𝞣", "T"],
  ["𝞤", "Y"],
  ["𝞥", "F"],
  ["𝞦", "X"],
  ["𝞧", "PS"],
  ["𝞨", "O"],
  ["𝞩", "D"],
  ["𝞪", "av"],
  ["𝞫", "g"],
  ["𝞬", "d"],
  ["𝞭", "e"],
  ["𝞮", "z"],
  ["𝞯", "i"],
  ["𝞰", "i"],
  ["𝞱", "th"],
  ["𝞲", "i"],
  ["𝞳", "k"],
  ["𝞴", "l"],
  ["𝞵", "m"],
  ["𝞶", "n"],
  ["𝞷", "ks"],
  ["𝞸", "o"],
  ["𝞹", "p"],
  ["𝞺", "r"],
  ["𝞻", "s"],
  ["𝞼", "s"],
  ["𝞽", "t"],
  ["𝞾", "y"],
  ["𝞿", "f"],
  ["𝟀", "x"],
  ["𝟁", "ps"],
  ["𝟂", "o"],
  ["𝟃", "a"],
  ["𝟄", "e"],
  ["𝟅", "i"],
  ["𝟆", "k"],
  ["𝟇", "f"],
  ["𝟈", "r"],
  ["𝟉", "p"],
  ["𝟊", "F"],
  ["𝟋", "f"],
  ["⒜", "(a)"],
  ["⒝", "(b)"],
  ["⒞", "(c)"],
  ["⒟", "(d)"],
  ["⒠", "(e)"],
  ["⒡", "(f)"],
  ["⒢", "(g)"],
  ["⒣", "(h)"],
  ["⒤", "(i)"],
  ["⒥", "(j)"],
  ["⒦", "(k)"],
  ["⒧", "(l)"],
  ["⒨", "(m)"],
  ["⒩", "(n)"],
  ["⒪", "(o)"],
  ["⒫", "(p)"],
  ["⒬", "(q)"],
  ["⒭", "(r)"],
  ["⒮", "(s)"],
  ["⒯", "(t)"],
  ["⒰", "(u)"],
  ["⒱", "(v)"],
  ["⒲", "(w)"],
  ["⒳", "(x)"],
  ["⒴", "(y)"],
  ["⒵", "(z)"],
  ["Ⓐ", "(A)"],
  ["Ⓑ", "(B)"],
  ["Ⓒ", "(C)"],
  ["Ⓓ", "(D)"],
  ["Ⓔ", "(E)"],
  ["Ⓕ", "(F)"],
  ["Ⓖ", "(G)"],
  ["Ⓗ", "(H)"],
  ["Ⓘ", "(I)"],
  ["Ⓙ", "(J)"],
  ["Ⓚ", "(K)"],
  ["Ⓛ", "(L)"],
  ["Ⓝ", "(N)"],
  ["Ⓞ", "(O)"],
  ["Ⓟ", "(P)"],
  ["Ⓠ", "(Q)"],
  ["Ⓡ", "(R)"],
  ["Ⓢ", "(S)"],
  ["Ⓣ", "(T)"],
  ["Ⓤ", "(U)"],
  ["Ⓥ", "(V)"],
  ["Ⓦ", "(W)"],
  ["Ⓧ", "(X)"],
  ["Ⓨ", "(Y)"],
  ["Ⓩ", "(Z)"],
  ["ⓐ", "(a)"],
  ["ⓑ", "(b)"],
  ["ⓒ", "(c)"],
  ["ⓓ", "(d)"],
  ["ⓔ", "(e)"],
  ["ⓕ", "(f)"],
  ["ⓖ", "(g)"],
  ["ⓗ", "(h)"],
  ["ⓘ", "(i)"],
  ["ⓙ", "(j)"],
  ["ⓚ", "(k)"],
  ["ⓛ", "(l)"],
  ["ⓜ", "(m)"],
  ["ⓝ", "(n)"],
  ["ⓞ", "(o)"],
  ["ⓟ", "(p)"],
  ["ⓠ", "(q)"],
  ["ⓡ", "(r)"],
  ["ⓢ", "(s)"],
  ["ⓣ", "(t)"],
  ["ⓤ", "(u)"],
  ["ⓥ", "(v)"],
  ["ⓦ", "(w)"],
  ["ⓧ", "(x)"],
  ["ⓨ", "(y)"],
  ["ⓩ", "(z)"],
  // Maltese
  ["Ċ", "C"],
  ["ċ", "c"],
  ["Ġ", "G"],
  ["ġ", "g"],
  ["Ħ", "H"],
  ["ħ", "h"],
  ["Ż", "Z"],
  ["ż", "z"],
  // Numbers
  ["𝟎", "0"],
  ["𝟏", "1"],
  ["𝟐", "2"],
  ["𝟑", "3"],
  ["𝟒", "4"],
  ["𝟓", "5"],
  ["𝟔", "6"],
  ["𝟕", "7"],
  ["𝟖", "8"],
  ["𝟗", "9"],
  ["𝟘", "0"],
  ["𝟙", "1"],
  ["𝟚", "2"],
  ["𝟛", "3"],
  ["𝟜", "4"],
  ["𝟝", "5"],
  ["𝟞", "6"],
  ["𝟟", "7"],
  ["𝟠", "8"],
  ["𝟡", "9"],
  ["𝟢", "0"],
  ["𝟣", "1"],
  ["𝟤", "2"],
  ["𝟥", "3"],
  ["𝟦", "4"],
  ["𝟧", "5"],
  ["𝟨", "6"],
  ["𝟩", "7"],
  ["𝟪", "8"],
  ["𝟫", "9"],
  ["𝟬", "0"],
  ["𝟭", "1"],
  ["𝟮", "2"],
  ["𝟯", "3"],
  ["𝟰", "4"],
  ["𝟱", "5"],
  ["𝟲", "6"],
  ["𝟳", "7"],
  ["𝟴", "8"],
  ["𝟵", "9"],
  ["𝟶", "0"],
  ["𝟷", "1"],
  ["𝟸", "2"],
  ["𝟹", "3"],
  ["𝟺", "4"],
  ["𝟻", "5"],
  ["𝟼", "6"],
  ["𝟽", "7"],
  ["𝟾", "8"],
  ["𝟿", "9"],
  ["①", "1"],
  ["②", "2"],
  ["③", "3"],
  ["④", "4"],
  ["⑤", "5"],
  ["⑥", "6"],
  ["⑦", "7"],
  ["⑧", "8"],
  ["⑨", "9"],
  ["⑩", "10"],
  ["⑪", "11"],
  ["⑫", "12"],
  ["⑬", "13"],
  ["⑭", "14"],
  ["⑮", "15"],
  ["⑯", "16"],
  ["⑰", "17"],
  ["⑱", "18"],
  ["⑲", "19"],
  ["⑳", "20"],
  ["⑴", "1"],
  ["⑵", "2"],
  ["⑶", "3"],
  ["⑷", "4"],
  ["⑸", "5"],
  ["⑹", "6"],
  ["⑺", "7"],
  ["⑻", "8"],
  ["⑼", "9"],
  ["⑽", "10"],
  ["⑾", "11"],
  ["⑿", "12"],
  ["⒀", "13"],
  ["⒁", "14"],
  ["⒂", "15"],
  ["⒃", "16"],
  ["⒄", "17"],
  ["⒅", "18"],
  ["⒆", "19"],
  ["⒇", "20"],
  ["⒈", "1."],
  ["⒉", "2."],
  ["⒊", "3."],
  ["⒋", "4."],
  ["⒌", "5."],
  ["⒍", "6."],
  ["⒎", "7."],
  ["⒏", "8."],
  ["⒐", "9."],
  ["⒑", "10."],
  ["⒒", "11."],
  ["⒓", "12."],
  ["⒔", "13."],
  ["⒕", "14."],
  ["⒖", "15."],
  ["⒗", "16."],
  ["⒘", "17."],
  ["⒙", "18."],
  ["⒚", "19."],
  ["⒛", "20."],
  ["⓪", "0"],
  ["⓫", "11"],
  ["⓬", "12"],
  ["⓭", "13"],
  ["⓮", "14"],
  ["⓯", "15"],
  ["⓰", "16"],
  ["⓱", "17"],
  ["⓲", "18"],
  ["⓳", "19"],
  ["⓴", "20"],
  ["⓵", "1"],
  ["⓶", "2"],
  ["⓷", "3"],
  ["⓸", "4"],
  ["⓹", "5"],
  ["⓺", "6"],
  ["⓻", "7"],
  ["⓼", "8"],
  ["⓽", "9"],
  ["⓾", "10"],
  ["⓿", "0"],
  // Punctuation
  ["🙰", "&"],
  ["🙱", "&"],
  ["🙲", "&"],
  ["🙳", "&"],
  ["🙴", "&"],
  ["🙵", "&"],
  ["🙶", '"'],
  ["🙷", '"'],
  ["🙸", '"'],
  ["‽", "?!"],
  ["🙹", "?!"],
  ["🙺", "?!"],
  ["🙻", "?!"],
  ["🙼", "/"],
  ["🙽", "\\"],
  // Alchemy
  ["🜇", "AR"],
  ["🜈", "V"],
  ["🜉", "V"],
  ["🜆", "VR"],
  ["🜅", "VF"],
  ["🜩", "2"],
  ["🜪", "5"],
  ["🝡", "f"],
  ["🝢", "W"],
  ["🝣", "U"],
  ["🝧", "V"],
  ["🝨", "T"],
  ["🝪", "V"],
  ["🝫", "MB"],
  ["🝬", "VB"],
  ["🝲", "3B"],
  ["🝳", "3B"],
  // Emojis
  ["💯", "100"],
  ["🔙", "BACK"],
  ["🔚", "END"],
  ["🔛", "ON!"],
  ["🔜", "SOON"],
  ["🔝", "TOP"],
  ["🔞", "18"],
  ["🔤", "abc"],
  ["🔠", "ABCD"],
  ["🔡", "abcd"],
  ["🔢", "1234"],
  ["🔣", "T&@%"],
  ["#️⃣", "#"],
  ["*️⃣", "*"],
  ["0️⃣", "0"],
  ["1️⃣", "1"],
  ["2️⃣", "2"],
  ["3️⃣", "3"],
  ["4️⃣", "4"],
  ["5️⃣", "5"],
  ["6️⃣", "6"],
  ["7️⃣", "7"],
  ["8️⃣", "8"],
  ["9️⃣", "9"],
  ["🔟", "10"],
  ["🅰️", "A"],
  ["🅱️", "B"],
  ["🆎", "AB"],
  ["🆑", "CL"],
  ["🅾️", "O"],
  ["🅿", "P"],
  ["🆘", "SOS"],
  ["🅲", "C"],
  ["🅳", "D"],
  ["🅴", "E"],
  ["🅵", "F"],
  ["🅶", "G"],
  ["🅷", "H"],
  ["🅸", "I"],
  ["🅹", "J"],
  ["🅺", "K"],
  ["🅻", "L"],
  ["🅼", "M"],
  ["🅽", "N"],
  ["🆀", "Q"],
  ["🆁", "R"],
  ["🆂", "S"],
  ["🆃", "T"],
  ["🆄", "U"],
  ["🆅", "V"],
  ["🆆", "W"],
  ["🆇", "X"],
  ["🆈", "Y"],
  ["🆉", "Z"],
  // Dashes not covered by Dash_Punctuation category
  ["−", "-"],
  // U+2212 Minus Sign (Mathematical Operators category)
  ["⁓", "-"]
  // U+2053 Swung Dash (Other_Punctuation category)
], builtinReplacements = new Map(replacements), danishNorwegianReplacements = [
  ["æ", "ae"],
  ["Æ", "Ae"],
  ["ø", "oe"],
  ["Ø", "Oe"],
  ["å", "aa"],
  ["Å", "Aa"]
], localeReplacements = {
  // Swedish
  sv: [
    ["ä", "a"],
    ["Ä", "A"],
    ["ö", "o"],
    ["Ö", "O"],
    ["å", "a"],
    ["Å", "A"]
  ],
  // Danish
  da: danishNorwegianReplacements,
  // Norwegian Bokmål
  nb: danishNorwegianReplacements,
  // German
  de: [
    ["ä", "ae"],
    ["Ä", "Ae"],
    ["ö", "oe"],
    ["Ö", "Oe"],
    ["ü", "ue"],
    ["Ü", "Ue"],
    ["ß", "ss"],
    ["ẞ", "Ss"]
  ],
  // Turkish
  tr: [
    ["â", "a"],
    ["Â", "A"],
    ["ö", "o"],
    ["Ö", "O"],
    ["ü", "u"],
    ["Ü", "U"]
  ],
  // Hungarian
  hu: [
    ["ű", "u"],
    ["Ű", "U"],
    ["ö", "o"],
    ["Ö", "O"],
    ["ü", "u"],
    ["Ü", "U"],
    ["á", "a"],
    ["Á", "A"],
    ["é", "e"],
    ["É", "E"],
    ["í", "i"],
    ["Í", "I"],
    ["ó", "o"],
    ["Ó", "O"],
    ["ú", "u"],
    ["Ú", "U"]
  ],
  // Serbian
  sr: [
    ["ђ", "dj"],
    ["Ђ", "Dj"],
    ["џ", "dz"],
    ["Џ", "Dz"],
    ["љ", "lj"],
    ["Љ", "Lj"],
    ["њ", "nj"],
    ["Њ", "Nj"],
    ["ћ", "c"],
    ["Ћ", "C"],
    ["ч", "ch"],
    ["Ч", "Ch"],
    ["ш", "sh"],
    ["Ш", "Sh"],
    ["ж", "zh"],
    ["Ж", "Zh"]
  ]
};
for (const o of Object.keys(localeReplacements))
  localeReplacements[o] = new Map(localeReplacements[o]);
const doCustomReplacements = (o, i) => {
  for (const [g, E] of i)
    o = o.replaceAll(g, E);
  return o;
}, getLocaleReplacements = (o) => {
  if (!o)
    return;
  const i = o.toLowerCase().replace(/^no(-|$)/, "nb$1");
  return localeReplacements[i] || localeReplacements[i.split("-")[0]] || void 0;
};
function transliterate(o, i) {
  if (typeof o != "string")
    throw new TypeError(`Expected a string, got \`${typeof o}\``);
  i = {
    customReplacements: [],
    ...i
  };
  const g = getLocaleReplacements(i.locale);
  let E = builtinReplacements;
  const e = i.customReplacements.length > 0 || i.customReplacements.size > 0;
  if (g || e) {
    if (E = new Map(builtinReplacements), g)
      for (const [t, n] of g)
        E.set(t, n);
    for (const [t, n] of i.customReplacements)
      E.set(t, n);
  }
  return o = o.normalize(), o = doCustomReplacements(o, E), o = o.normalize("NFD").replaceAll(new RegExp("\\p{Diacritic}", "gu"), "").normalize(), o = o.replaceAll(new RegExp("\\p{Dash_Punctuation}", "gu"), "-"), o;
}
const overridableReplacements = [
  ["&", " and "],
  ["🦄", " unicorn "],
  ["♥", " love "]
], decamelize = (o) => o.replaceAll(/([A-Z]{2,})(\d+)/g, "$1 $2").replaceAll(/([a-z\d]+)([A-Z]{2,})/g, "$1 $2").replaceAll(/([a-z\d])([A-Z])/g, "$1 $2").replaceAll(/([A-Z]+)([A-Z][a-rt-z\d]+)/g, "$1 $2"), removeMootSeparators = (o, i) => {
  const g = escapeStringRegexp$1(i);
  return o.replaceAll(new RegExp(`(?:${g}){2,}`, "g"), i).replaceAll(new RegExp(`^(?:${g})|(?:${g})$`, "g"), "");
}, buildPatternSlug = (o) => {
  let i = String.raw`a-z\d`;
  if (i += o.lowercase ? "" : "A-Z", o.transliterate === !1 && (i += String.raw`\p{L}\p{N}`), o.preserveCharacters.length > 0)
    for (const E of o.preserveCharacters) {
      if (E === o.separator)
        throw new Error(`The separator character \`${o.separator}\` cannot be included in preserved characters: ${o.preserveCharacters}`);
      i += escapeStringRegexp$1(E);
    }
  const g = o.transliterate ? "g" : "gu";
  return new RegExp(`[^${i}]+`, g);
};
function slugify(o, i) {
  if (typeof o != "string")
    throw new TypeError(`Expected a string, got \`${typeof o}\``);
  i = {
    separator: "-",
    lowercase: !0,
    decamelize: !0,
    customReplacements: [],
    preserveLeadingUnderscore: !1,
    preserveTrailingDash: !1,
    preserveCharacters: [],
    transliterate: !0,
    ...i
  };
  const g = i.preserveLeadingUnderscore && o.startsWith("_"), E = i.preserveTrailingDash && o.endsWith("-");
  if (i.transliterate) {
    const t = new Map([
      ...overridableReplacements,
      ...i.customReplacements
    ]);
    o = transliterate(o, { customReplacements: t, locale: i.locale });
  } else if (i.customReplacements.length > 0)
    for (const [t, n] of i.customReplacements)
      o = o.replaceAll(t, n);
  i.decamelize && (o = decamelize(o));
  const e = buildPatternSlug(i);
  return i.lowercase && (o = i.locale ? o.toLocaleLowerCase(i.locale) : o.toLowerCase()), o = o.replaceAll(/([a-zA-Z\d]+)['\u2019]([ts])(\s|$)/g, "$1$2$3"), o = o.replace(e, i.separator), o = o.replaceAll("\\", ""), i.separator && (o = removeMootSeparators(o, i.separator)), g && (o = `_${o}`), E && (o = `${o}-`), o;
}
function escapeStringRegexp(o) {
  if (typeof o != "string")
    throw new TypeError("Expected a string");
  return o.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(o) {
    if (o == null)
      return ok$1;
    if (typeof o == "function")
      return castFactory(o);
    if (typeof o == "object")
      return Array.isArray(o) ? anyFactory(o) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        propertiesFactory(
          /** @type {Props} */
          o
        )
      );
    if (typeof o == "string")
      return typeFactory(o);
    throw new Error("Expected function, string, or object as test");
  })
);
function anyFactory(o) {
  const i = [];
  let g = -1;
  for (; ++g < o.length; )
    i[g] = convert(o[g]);
  return castFactory(E);
  function E(...e) {
    let t = -1;
    for (; ++t < i.length; )
      if (i[t].apply(this, e)) return !0;
    return !1;
  }
}
function propertiesFactory(o) {
  const i = (
    /** @type {Record<string, unknown>} */
    o
  );
  return castFactory(g);
  function g(E) {
    const e = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      E
    );
    let t;
    for (t in o)
      if (e[t] !== i[t]) return !1;
    return !0;
  }
}
function typeFactory(o) {
  return castFactory(i);
  function i(g) {
    return g && g.type === o;
  }
}
function castFactory(o) {
  return i;
  function i(g, E, e) {
    return !!(looksLikeANode(g) && o.call(
      this,
      g,
      typeof E == "number" ? E : void 0,
      e || void 0
    ));
  }
}
function ok$1() {
  return !0;
}
function looksLikeANode(o) {
  return o !== null && typeof o == "object" && "type" in o;
}
function color(o) {
  return o;
}
const empty$2 = [], CONTINUE = !0, EXIT = !1, SKIP = "skip";
function visitParents(o, i, g, E) {
  let e;
  typeof i == "function" && typeof g != "function" ? (E = g, g = i) : e = i;
  const t = convert(e), n = E ? -1 : 1;
  h(o, void 0, [])();
  function h(d, k, p) {
    const M = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof M.type == "string") {
      const f = (
        // `hast`
        typeof M.tagName == "string" ? M.tagName : (
          // `xast`
          typeof M.name == "string" ? M.name : void 0
        )
      );
      Object.defineProperty(H, "name", {
        value: "node (" + (d.type + (f ? "<" + f + ">" : "")) + ")"
      });
    }
    return H;
    function H() {
      let f = empty$2, AA, gA, IA;
      if ((!i || t(d, k, p[p.length - 1] || void 0)) && (f = toResult(g(d, p)), f[0] === EXIT))
        return f;
      if ("children" in d && d.children) {
        const BA = (
          /** @type {UnistParent} */
          d
        );
        if (BA.children && f[0] !== SKIP)
          for (gA = (E ? BA.children.length : -1) + n, IA = p.concat(BA); gA > -1 && gA < BA.children.length; ) {
            const CA = BA.children[gA];
            if (AA = h(CA, gA, IA)(), AA[0] === EXIT)
              return AA;
            gA = typeof AA[1] == "number" ? AA[1] : gA + n;
          }
      }
      return f;
    }
  }
}
function toResult(o) {
  return Array.isArray(o) ? o : typeof o == "number" ? [CONTINUE, o] : o == null ? empty$2 : [o];
}
function findAndReplace(o, i, g) {
  const e = convert((g || {}).ignore || []), t = toPairs(i);
  let n = -1;
  for (; ++n < t.length; )
    visitParents(o, "text", h);
  function h(k, p) {
    let M = -1, H;
    for (; ++M < p.length; ) {
      const f = p[M], AA = H ? H.children : void 0;
      if (e(
        f,
        AA ? AA.indexOf(f) : void 0,
        H
      ))
        return;
      H = f;
    }
    if (H)
      return d(k, p);
  }
  function d(k, p) {
    const M = p[p.length - 1], H = t[n][0], f = t[n][1];
    let AA = 0;
    const IA = M.children.indexOf(k);
    let BA = !1, CA = [];
    H.lastIndex = 0;
    let QA = H.exec(k.value);
    for (; QA; ) {
      const iA = QA.index, EA = {
        index: QA.index,
        input: QA.input,
        stack: [...p, k]
      };
      let oA = f(...QA, EA);
      if (typeof oA == "string" && (oA = oA.length > 0 ? { type: "text", value: oA } : void 0), oA === !1 ? H.lastIndex = iA + 1 : (AA !== iA && CA.push({
        type: "text",
        value: k.value.slice(AA, iA)
      }), Array.isArray(oA) ? CA.push(...oA) : oA && CA.push(oA), AA = iA + QA[0].length, BA = !0), !H.global)
        break;
      QA = H.exec(k.value);
    }
    return BA ? (AA < k.value.length && CA.push({ type: "text", value: k.value.slice(AA) }), M.children.splice(IA, 1, ...CA)) : CA = [k], IA + CA.length;
  }
}
function toPairs(o) {
  const i = [];
  if (!Array.isArray(o))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const g = !o[0] || Array.isArray(o[0]) ? o : [o];
  let E = -1;
  for (; ++E < g.length; ) {
    const e = g[E];
    i.push([toExpression(e[0]), toFunction(e[1])]);
  }
  return i;
}
function toExpression(o) {
  return typeof o == "string" ? new RegExp(escapeStringRegexp(o), "g") : o;
}
function toFunction(o) {
  return typeof o == "function" ? o : function() {
    return o;
  };
}
function ok() {
}
function unreachable() {
}
function parse$2(o) {
  const i = [], g = String(o || "");
  let E = g.indexOf(","), e = 0, t = !1;
  for (; !t; ) {
    E === -1 && (E = g.length, t = !0);
    const n = g.slice(e, E).trim();
    (n || !t) && i.push(n), e = E + 1, E = g.indexOf(",", e);
  }
  return i;
}
function stringify$1(o, i) {
  const g = {};
  return (o[o.length - 1] === "" ? [...o, ""] : o).join(
    (g.padRight ? " " : "") + "," + (g.padLeft === !1 ? "" : " ")
  ).trim();
}
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, emptyOptions$5 = {};
function name(o, i) {
  return (emptyOptions$5.jsx ? nameReJsx : nameRe).test(o);
}
const re = /[ \t\n\f\r]/g;
function whitespace(o) {
  return typeof o == "object" ? o.type === "text" ? empty$1(o.value) : !1 : empty$1(o);
}
function empty$1(o) {
  return o.replace(re, "") === "";
}
class Schema {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(i, g, E) {
    this.normal = g, this.property = i, E && (this.space = E);
  }
}
Schema.prototype.normal = {};
Schema.prototype.property = {};
Schema.prototype.space = void 0;
function merge(o, i) {
  const g = {}, E = {};
  for (const e of o)
    Object.assign(g, e.property), Object.assign(E, e.normal);
  return new Schema(g, E, i);
}
function normalize$1(o) {
  return o.toLowerCase();
}
class Info {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(i, g) {
    this.attribute = g, this.property = i;
  }
}
Info.prototype.attribute = "";
Info.prototype.booleanish = !1;
Info.prototype.boolean = !1;
Info.prototype.commaOrSpaceSeparated = !1;
Info.prototype.commaSeparated = !1;
Info.prototype.defined = !1;
Info.prototype.mustUseProperty = !1;
Info.prototype.number = !1;
Info.prototype.overloadedBoolean = !1;
Info.prototype.property = "";
Info.prototype.spaceSeparated = !1;
Info.prototype.space = void 0;
let powers = 0;
const boolean = increment(), booleanish = increment(), overloadedBoolean = increment(), number = increment(), spaceSeparated = increment(), commaSeparated = increment(), commaOrSpaceSeparated = increment();
function increment() {
  return 2 ** ++powers;
}
const types$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean,
  booleanish,
  commaOrSpaceSeparated,
  commaSeparated,
  number,
  overloadedBoolean,
  spaceSeparated
}, Symbol.toStringTag, { value: "Module" })), checks = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(types$1)
);
class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(i, g, E, e) {
    let t = -1;
    if (super(i, g), mark$1(this, "space", e), typeof E == "number")
      for (; ++t < checks.length; ) {
        const n = checks[t];
        mark$1(this, checks[t], (E & types$1[n]) === types$1[n]);
      }
  }
}
DefinedInfo.prototype.defined = !0;
function mark$1(o, i, g) {
  g && (o[i] = g);
}
function create(o) {
  const i = {}, g = {};
  for (const [E, e] of Object.entries(o.properties)) {
    const t = new DefinedInfo(
      E,
      o.transform(o.attributes || {}, E),
      e,
      o.space
    );
    o.mustUseProperty && o.mustUseProperty.includes(E) && (t.mustUseProperty = !0), i[E] = t, g[normalize$1(E)] = E, g[normalize$1(t.attribute)] = E;
  }
  return new Schema(i, g, o.space);
}
const aria = create({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  },
  transform(o, i) {
    return i === "role" ? i : "aria-" + i.slice(4).toLowerCase();
  }
});
function caseSensitiveTransform(o, i) {
  return i in o ? o[i] : i;
}
function caseInsensitiveTransform(o, i) {
  return caseSensitiveTransform(o, i.toLowerCase());
}
const html$3 = create({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: overloadedBoolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number,
    // `<img>` and `<object>`
    leftMargin: number,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number,
    // `<body>`
    marginWidth: number,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: caseInsensitiveTransform
}), svg$1 = create({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: caseSensitiveTransform
}), xlink = create({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(o, i) {
    return "xlink:" + i.slice(5).toLowerCase();
  }
}), xmlns = create({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: caseInsensitiveTransform
}), xml = create({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(o, i) {
    return "xml:" + i.slice(3).toLowerCase();
  }
}), hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, cap$1 = /[A-Z]/g, dash = /-[a-z]/g, valid = /^data[-\w.:]+$/i;
function find$1(o, i) {
  const g = normalize$1(i);
  let E = i, e = Info;
  if (g in o.normal)
    return o.property[o.normal[g]];
  if (g.length > 4 && g.slice(0, 4) === "data" && valid.test(i)) {
    if (i.charAt(4) === "-") {
      const t = i.slice(5).replace(dash, camelcase);
      E = "data" + t.charAt(0).toUpperCase() + t.slice(1);
    } else {
      const t = i.slice(4);
      if (!dash.test(t)) {
        let n = t.replace(cap$1, kebab);
        n.charAt(0) !== "-" && (n = "-" + n), i = "data" + n;
      }
    }
    e = DefinedInfo;
  }
  return new e(E, i);
}
function kebab(o) {
  return "-" + o.toLowerCase();
}
function camelcase(o) {
  return o.charAt(1).toUpperCase();
}
const html$2 = merge([aria, html$3, xlink, xmlns, xml], "html"), svg = merge([aria, svg$1, xlink, xmlns, xml], "svg");
function parse$1(o) {
  const i = String(o || "").trim();
  return i ? i.split(/[ \t\n\r\f]+/g) : [];
}
function stringify(o) {
  return o.join(" ").trim();
}
var cjs$2 = {}, cjs$1, hasRequiredCjs$2;
function requireCjs$2() {
  if (hasRequiredCjs$2) return cjs$1;
  hasRequiredCjs$2 = 1;
  var o = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, i = /\n/g, g = /^\s*/, E = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, e = /^:\s*/, t = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, n = /^[;\s]*/, h = /^\s+|\s+$/g, d = `
`, k = "/", p = "*", M = "", H = "comment", f = "declaration";
  function AA(IA, BA) {
    if (typeof IA != "string")
      throw new TypeError("First argument must be a string");
    if (!IA) return [];
    BA = BA || {};
    var CA = 1, QA = 1;
    function iA(rA) {
      var nA = rA.match(i);
      nA && (CA += nA.length);
      var NA = rA.lastIndexOf(d);
      QA = ~NA ? rA.length - NA : QA + rA.length;
    }
    function EA() {
      var rA = { line: CA, column: QA };
      return function(nA) {
        return nA.position = new oA(rA), cA(), nA;
      };
    }
    function oA(rA) {
      this.start = rA, this.end = { line: CA, column: QA }, this.source = BA.source;
    }
    oA.prototype.content = IA;
    function eA(rA) {
      var nA = new Error(
        BA.source + ":" + CA + ":" + QA + ": " + rA
      );
      if (nA.reason = rA, nA.filename = BA.source, nA.line = CA, nA.column = QA, nA.source = IA, !BA.silent) throw nA;
    }
    function GA(rA) {
      var nA = rA.exec(IA);
      if (nA) {
        var NA = nA[0];
        return iA(NA), IA = IA.slice(NA.length), nA;
      }
    }
    function cA() {
      GA(g);
    }
    function tA(rA) {
      var nA;
      for (rA = rA || []; nA = aA(); )
        nA !== !1 && rA.push(nA);
      return rA;
    }
    function aA() {
      var rA = EA();
      if (!(k != IA.charAt(0) || p != IA.charAt(1))) {
        for (var nA = 2; M != IA.charAt(nA) && (p != IA.charAt(nA) || k != IA.charAt(nA + 1)); )
          ++nA;
        if (nA += 2, M === IA.charAt(nA - 1))
          return eA("End of comment missing");
        var NA = IA.slice(2, nA - 2);
        return QA += 2, iA(NA), IA = IA.slice(nA), QA += 2, rA({
          type: H,
          comment: NA
        });
      }
    }
    function sA() {
      var rA = EA(), nA = GA(E);
      if (nA) {
        if (aA(), !GA(e)) return eA("property missing ':'");
        var NA = GA(t), pA = rA({
          type: f,
          property: gA(nA[0].replace(o, M)),
          value: NA ? gA(NA[0].replace(o, M)) : M
        });
        return GA(n), pA;
      }
    }
    function DA() {
      var rA = [];
      tA(rA);
      for (var nA; nA = sA(); )
        nA !== !1 && (rA.push(nA), tA(rA));
      return rA;
    }
    return cA(), DA();
  }
  function gA(IA) {
    return IA ? IA.replace(h, M) : M;
  }
  return cjs$1 = AA, cjs$1;
}
var hasRequiredCjs$1;
function requireCjs$1() {
  if (hasRequiredCjs$1) return cjs$2;
  hasRequiredCjs$1 = 1;
  var o = cjs$2 && cjs$2.__importDefault || function(E) {
    return E && E.__esModule ? E : { default: E };
  };
  Object.defineProperty(cjs$2, "__esModule", { value: !0 }), cjs$2.default = g;
  const i = o(requireCjs$2());
  function g(E, e) {
    let t = null;
    if (!E || typeof E != "string")
      return t;
    const n = (0, i.default)(E), h = typeof e == "function";
    return n.forEach((d) => {
      if (d.type !== "declaration")
        return;
      const { property: k, value: p } = d;
      h ? e(k, p, d) : p && (t = t || {}, t[k] = p);
    }), t;
  }
  return cjs$2;
}
var utilities = {}, hasRequiredUtilities;
function requireUtilities() {
  if (hasRequiredUtilities) return utilities;
  hasRequiredUtilities = 1, Object.defineProperty(utilities, "__esModule", { value: !0 }), utilities.camelCase = void 0;
  var o = /^--[a-zA-Z0-9_-]+$/, i = /-([a-z])/g, g = /^[^-]+$/, E = /^-(webkit|moz|ms|o|khtml)-/, e = /^-(ms)-/, t = function(k) {
    return !k || g.test(k) || o.test(k);
  }, n = function(k, p) {
    return p.toUpperCase();
  }, h = function(k, p) {
    return "".concat(p, "-");
  }, d = function(k, p) {
    return p === void 0 && (p = {}), t(k) ? k : (k = k.toLowerCase(), p.reactCompat ? k = k.replace(e, h) : k = k.replace(E, h), k.replace(i, n));
  };
  return utilities.camelCase = d, utilities;
}
var cjs, hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs;
  hasRequiredCjs = 1;
  var o = cjs && cjs.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  }, i = o(requireCjs$1()), g = requireUtilities();
  function E(e, t) {
    var n = {};
    return !e || typeof e != "string" || (0, i.default)(e, function(h, d) {
      h && d && (n[(0, g.camelCase)(h, t)] = d);
    }), n;
  }
  return E.default = E, cjs = E, cjs;
}
var cjsExports = requireCjs();
const styleToJs = /* @__PURE__ */ getDefaultExportFromCjs(cjsExports), pointEnd = point$2("end"), pointStart = point$2("start");
function point$2(o) {
  return i;
  function i(g) {
    const E = g && g.position && g.position[o] || {};
    if (typeof E.line == "number" && E.line > 0 && typeof E.column == "number" && E.column > 0)
      return {
        line: E.line,
        column: E.column,
        offset: typeof E.offset == "number" && E.offset > -1 ? E.offset : void 0
      };
  }
}
function position$2(o) {
  const i = pointStart(o), g = pointEnd(o);
  if (i && g)
    return { start: i, end: g };
}
function stringifyPosition(o) {
  return !o || typeof o != "object" ? "" : "position" in o || "type" in o ? position$1(o.position) : "start" in o || "end" in o ? position$1(o) : "line" in o || "column" in o ? point$1(o) : "";
}
function point$1(o) {
  return index$1(o && o.line) + ":" + index$1(o && o.column);
}
function position$1(o) {
  return point$1(o && o.start) + "-" + point$1(o && o.end);
}
function index$1(o) {
  return o && typeof o == "number" ? o : 1;
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(i, g, E) {
    super(), typeof g == "string" && (E = g, g = void 0);
    let e = "", t = {}, n = !1;
    if (g && ("line" in g && "column" in g ? t = { place: g } : "start" in g && "end" in g ? t = { place: g } : "type" in g ? t = {
      ancestors: [g],
      place: g.position
    } : t = { ...g }), typeof i == "string" ? e = i : !t.cause && i && (n = !0, e = i.message, t.cause = i), !t.ruleId && !t.source && typeof E == "string") {
      const d = E.indexOf(":");
      d === -1 ? t.ruleId = E : (t.source = E.slice(0, d), t.ruleId = E.slice(d + 1));
    }
    if (!t.place && t.ancestors && t.ancestors) {
      const d = t.ancestors[t.ancestors.length - 1];
      d && (t.place = d.position);
    }
    const h = t.place && "start" in t.place ? t.place.start : t.place;
    this.ancestors = t.ancestors || void 0, this.cause = t.cause || void 0, this.column = h ? h.column : void 0, this.fatal = void 0, this.file = "", this.message = e, this.line = h ? h.line : void 0, this.name = stringifyPosition(t.place) || "1:1", this.place = t.place || void 0, this.reason = this.message, this.ruleId = t.ruleId || void 0, this.source = t.source || void 0, this.stack = n && t.cause && typeof t.cause.stack == "string" ? t.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const own$4 = {}.hasOwnProperty, emptyMap = /* @__PURE__ */ new Map(), cap = /[A-Z]/g, tableElements = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), tableCellElement = /* @__PURE__ */ new Set(["td", "th"]), docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function toJsxRuntime(o, i) {
  if (!i || i.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const g = i.filePath || void 0;
  let E;
  if (i.development) {
    if (typeof i.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    E = developmentCreate(g, i.jsxDEV);
  } else {
    if (typeof i.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof i.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    E = productionCreate(g, i.jsx, i.jsxs);
  }
  const e = {
    Fragment: i.Fragment,
    ancestors: [],
    components: i.components || {},
    create: E,
    elementAttributeNameCase: i.elementAttributeNameCase || "react",
    evaluater: i.createEvaluater ? i.createEvaluater() : void 0,
    filePath: g,
    ignoreInvalidStyle: i.ignoreInvalidStyle || !1,
    passKeys: i.passKeys !== !1,
    passNode: i.passNode || !1,
    schema: i.space === "svg" ? svg : html$2,
    stylePropertyNameCase: i.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: i.tableCellAlignToStyle !== !1
  }, t = one$1(e, o, void 0);
  return t && typeof t != "string" ? t : e.create(
    o,
    e.Fragment,
    { children: t || void 0 },
    void 0
  );
}
function one$1(o, i, g) {
  if (i.type === "element")
    return element$1(o, i, g);
  if (i.type === "mdxFlowExpression" || i.type === "mdxTextExpression")
    return mdxExpression(o, i);
  if (i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement")
    return mdxJsxElement(o, i, g);
  if (i.type === "mdxjsEsm")
    return mdxEsm(o, i);
  if (i.type === "root")
    return root$3(o, i, g);
  if (i.type === "text")
    return text$6(o, i);
}
function element$1(o, i, g) {
  const E = o.schema;
  let e = E;
  i.tagName.toLowerCase() === "svg" && E.space === "html" && (e = svg, o.schema = e), o.ancestors.push(i);
  const t = findComponentFromName(o, i.tagName, !1), n = createElementProps(o, i);
  let h = createChildren(o, i);
  return tableElements.has(i.tagName) && (h = h.filter(function(d) {
    return typeof d == "string" ? !whitespace(d) : !0;
  })), addNode(o, n, t, i), addChildren(n, h), o.ancestors.pop(), o.schema = E, o.create(i, t, n, g);
}
function mdxExpression(o, i) {
  if (i.data && i.data.estree && o.evaluater) {
    const E = i.data.estree.body[0];
    return E.type, /** @type {Child | undefined} */
    o.evaluater.evaluateExpression(E.expression);
  }
  crashEstree(o, i.position);
}
function mdxEsm(o, i) {
  if (i.data && i.data.estree && o.evaluater)
    return (
      /** @type {Child | undefined} */
      o.evaluater.evaluateProgram(i.data.estree)
    );
  crashEstree(o, i.position);
}
function mdxJsxElement(o, i, g) {
  const E = o.schema;
  let e = E;
  i.name === "svg" && E.space === "html" && (e = svg, o.schema = e), o.ancestors.push(i);
  const t = i.name === null ? o.Fragment : findComponentFromName(o, i.name, !0), n = createJsxElementProps(o, i), h = createChildren(o, i);
  return addNode(o, n, t, i), addChildren(n, h), o.ancestors.pop(), o.schema = E, o.create(i, t, n, g);
}
function root$3(o, i, g) {
  const E = {};
  return addChildren(E, createChildren(o, i)), o.create(i, o.Fragment, E, g);
}
function text$6(o, i) {
  return i.value;
}
function addNode(o, i, g, E) {
  typeof g != "string" && g !== o.Fragment && o.passNode && (i.node = E);
}
function addChildren(o, i) {
  if (i.length > 0) {
    const g = i.length > 1 ? i : i[0];
    g && (o.children = g);
  }
}
function productionCreate(o, i, g) {
  return E;
  function E(e, t, n, h) {
    const k = Array.isArray(n.children) ? g : i;
    return h ? k(t, n, h) : k(t, n);
  }
}
function developmentCreate(o, i) {
  return g;
  function g(E, e, t, n) {
    const h = Array.isArray(t.children), d = pointStart(E);
    return i(
      e,
      t,
      n,
      h,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: o,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function createElementProps(o, i) {
  const g = {};
  let E, e;
  for (e in i.properties)
    if (e !== "children" && own$4.call(i.properties, e)) {
      const t = createProperty(o, e, i.properties[e]);
      if (t) {
        const [n, h] = t;
        o.tableCellAlignToStyle && n === "align" && typeof h == "string" && tableCellElement.has(i.tagName) ? E = h : g[n] = h;
      }
    }
  if (E) {
    const t = (
      /** @type {Style} */
      g.style || (g.style = {})
    );
    t[o.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = E;
  }
  return g;
}
function createJsxElementProps(o, i) {
  const g = {};
  for (const E of i.attributes)
    if (E.type === "mdxJsxExpressionAttribute")
      if (E.data && E.data.estree && o.evaluater) {
        const t = E.data.estree.body[0];
        t.type;
        const n = t.expression;
        n.type;
        const h = n.properties[0];
        h.type, Object.assign(
          g,
          o.evaluater.evaluateExpression(h.argument)
        );
      } else
        crashEstree(o, i.position);
    else {
      const e = E.name;
      let t;
      if (E.value && typeof E.value == "object")
        if (E.value.data && E.value.data.estree && o.evaluater) {
          const h = E.value.data.estree.body[0];
          h.type, t = o.evaluater.evaluateExpression(h.expression);
        } else
          crashEstree(o, i.position);
      else
        t = E.value === null ? !0 : E.value;
      g[e] = /** @type {Props[keyof Props]} */
      t;
    }
  return g;
}
function createChildren(o, i) {
  const g = [];
  let E = -1;
  const e = o.passKeys ? /* @__PURE__ */ new Map() : emptyMap;
  for (; ++E < i.children.length; ) {
    const t = i.children[E];
    let n;
    if (o.passKeys) {
      const d = t.type === "element" ? t.tagName : t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement" ? t.name : void 0;
      if (d) {
        const k = e.get(d) || 0;
        n = d + "-" + k, e.set(d, k + 1);
      }
    }
    const h = one$1(o, t, n);
    h !== void 0 && g.push(h);
  }
  return g;
}
function createProperty(o, i, g) {
  const E = find$1(o.schema, i);
  if (!(g == null || typeof g == "number" && Number.isNaN(g))) {
    if (Array.isArray(g) && (g = E.commaSeparated ? stringify$1(g) : stringify(g)), E.property === "style") {
      let e = typeof g == "object" ? g : parseStyle(o, String(g));
      return o.stylePropertyNameCase === "css" && (e = transformStylesToCssCasing(e)), ["style", e];
    }
    return [
      o.elementAttributeNameCase === "react" && E.space ? hastToReact[E.property] || E.property : E.attribute,
      g
    ];
  }
}
function parseStyle(o, i) {
  try {
    return styleToJs(i, { reactCompat: !0 });
  } catch (g) {
    if (o.ignoreInvalidStyle)
      return {};
    const E = (
      /** @type {Error} */
      g
    ), e = new VFileMessage("Cannot parse `style` attribute", {
      ancestors: o.ancestors,
      cause: E,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw e.file = o.filePath || void 0, e.url = docs + "#cannot-parse-style-attribute", e;
  }
}
function findComponentFromName(o, i, g) {
  let E;
  if (!g)
    E = { type: "Literal", value: i };
  else if (i.includes(".")) {
    const e = i.split(".");
    let t = -1, n;
    for (; ++t < e.length; ) {
      const h = name(e[t]) ? { type: "Identifier", name: e[t] } : { type: "Literal", value: e[t] };
      n = n ? {
        type: "MemberExpression",
        object: n,
        property: h,
        computed: !!(t && h.type === "Literal"),
        optional: !1
      } : h;
    }
    E = n;
  } else
    E = name(i) && !/^[a-z]/.test(i) ? { type: "Identifier", name: i } : { type: "Literal", value: i };
  if (E.type === "Literal") {
    const e = (
      /** @type {string | number} */
      E.value
    );
    return own$4.call(o.components, e) ? o.components[e] : e;
  }
  if (o.evaluater)
    return o.evaluater.evaluateExpression(E);
  crashEstree(o);
}
function crashEstree(o, i) {
  const g = new VFileMessage(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: o.ancestors,
      place: i,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw g.file = o.filePath || void 0, g.url = docs + "#cannot-handle-mdx-estrees-without-createevaluater", g;
}
function transformStylesToCssCasing(o) {
  const i = {};
  let g;
  for (g in o)
    own$4.call(o, g) && (i[transformStyleToCssCasing(g)] = o[g]);
  return i;
}
function transformStyleToCssCasing(o) {
  let i = o.replace(cap, toDash);
  return i.slice(0, 3) === "ms-" && (i = "-" + i), i;
}
function toDash(o) {
  return "-" + o.toLowerCase();
}
const urlAttributes = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, emptyOptions$4 = {};
function toString$2(o, i) {
  const g = emptyOptions$4, E = typeof g.includeImageAlt == "boolean" ? g.includeImageAlt : !0, e = typeof g.includeHtml == "boolean" ? g.includeHtml : !0;
  return one(o, E, e);
}
function one(o, i, g) {
  if (node(o)) {
    if ("value" in o)
      return o.type === "html" && !g ? "" : o.value;
    if (i && "alt" in o && o.alt)
      return o.alt;
    if ("children" in o)
      return all(o.children, i, g);
  }
  return Array.isArray(o) ? all(o, i, g) : "";
}
function all(o, i, g) {
  const E = [];
  let e = -1;
  for (; ++e < o.length; )
    E[e] = one(o[e], i, g);
  return E.join("");
}
function node(o) {
  return !!(o && typeof o == "object");
}
const element = document.createElement("i");
function decodeNamedCharacterReference(o) {
  const i = "&" + o + ";";
  element.innerHTML = i;
  const g = element.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    g.charCodeAt(g.length - 1) === 59 && o !== "semi" || g === i ? !1 : g
  );
}
function splice(o, i, g, E) {
  const e = o.length;
  let t = 0, n;
  if (i < 0 ? i = -i > e ? 0 : e + i : i = i > e ? e : i, g = g > 0 ? g : 0, E.length < 1e4)
    n = Array.from(E), n.unshift(i, g), o.splice(...n);
  else
    for (g && o.splice(i, g); t < E.length; )
      n = E.slice(t, t + 1e4), n.unshift(i, 0), o.splice(...n), t += 1e4, i += 1e4;
}
function push(o, i) {
  return o.length > 0 ? (splice(o, o.length, 0, i), o) : i;
}
const hasOwnProperty = {}.hasOwnProperty;
function combineExtensions(o) {
  const i = {};
  let g = -1;
  for (; ++g < o.length; )
    syntaxExtension(i, o[g]);
  return i;
}
function syntaxExtension(o, i) {
  let g;
  for (g in i) {
    const e = (hasOwnProperty.call(o, g) ? o[g] : void 0) || (o[g] = {}), t = i[g];
    let n;
    if (t)
      for (n in t) {
        hasOwnProperty.call(e, n) || (e[n] = []);
        const h = t[n];
        constructs(
          // @ts-expect-error Looks like a list.
          e[n],
          Array.isArray(h) ? h : h ? [h] : []
        );
      }
  }
}
function constructs(o, i) {
  let g = -1;
  const E = [];
  for (; ++g < i.length; )
    (i[g].add === "after" ? o : E).push(i[g]);
  splice(o, 0, 0, E);
}
function decodeNumericCharacterReference(o, i) {
  const g = Number.parseInt(o, i);
  return (
    // C0 except for HT, LF, FF, CR, space.
    g < 9 || g === 11 || g > 13 && g < 32 || // Control character (DEL) of C0, and C1 controls.
    g > 126 && g < 160 || // Lone high surrogates and low surrogates.
    g > 55295 && g < 57344 || // Noncharacters.
    g > 64975 && g < 65008 || /* eslint-disable no-bitwise */
    (g & 65535) === 65535 || (g & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    g > 1114111 ? "�" : String.fromCodePoint(g)
  );
}
function normalizeIdentifier(o) {
  return o.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha = regexCheck(/[A-Za-z]/), asciiAlphanumeric = regexCheck(/[\dA-Za-z]/), asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(o) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    o !== null && (o < 32 || o === 127)
  );
}
const asciiDigit = regexCheck(/\d/), asciiHexDigit = regexCheck(/[\dA-Fa-f]/), asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(o) {
  return o !== null && o < -2;
}
function markdownLineEndingOrSpace(o) {
  return o !== null && (o < 0 || o === 32);
}
function markdownSpace(o) {
  return o === -2 || o === -1 || o === 32;
}
const unicodePunctuation = regexCheck(new RegExp("\\p{P}|\\p{S}", "u")), unicodeWhitespace = regexCheck(/\s/);
function regexCheck(o) {
  return i;
  function i(g) {
    return g !== null && g > -1 && o.test(String.fromCharCode(g));
  }
}
function normalizeUri(o) {
  const i = [];
  let g = -1, E = 0, e = 0;
  for (; ++g < o.length; ) {
    const t = o.charCodeAt(g);
    let n = "";
    if (t === 37 && asciiAlphanumeric(o.charCodeAt(g + 1)) && asciiAlphanumeric(o.charCodeAt(g + 2)))
      e = 2;
    else if (t < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(t)) || (n = String.fromCharCode(t));
    else if (t > 55295 && t < 57344) {
      const h = o.charCodeAt(g + 1);
      t < 56320 && h > 56319 && h < 57344 ? (n = String.fromCharCode(t, h), e = 1) : n = "�";
    } else
      n = String.fromCharCode(t);
    n && (i.push(o.slice(E, g), encodeURIComponent(n)), E = g + e + 1, n = ""), e && (g += e, e = 0);
  }
  return i.join("") + o.slice(E);
}
function factorySpace(o, i, g, E) {
  const e = E ? E - 1 : Number.POSITIVE_INFINITY;
  let t = 0;
  return n;
  function n(d) {
    return markdownSpace(d) ? (o.enter(g), h(d)) : i(d);
  }
  function h(d) {
    return markdownSpace(d) && t++ < e ? (o.consume(d), h) : (o.exit(g), i(d));
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(o) {
  const i = o.attempt(this.parser.constructs.contentInitial, E, e);
  let g;
  return i;
  function E(h) {
    if (h === null) {
      o.consume(h);
      return;
    }
    return o.enter("lineEnding"), o.consume(h), o.exit("lineEnding"), factorySpace(o, i, "linePrefix");
  }
  function e(h) {
    return o.enter("paragraph"), t(h);
  }
  function t(h) {
    const d = o.enter("chunkText", {
      contentType: "text",
      previous: g
    });
    return g && (g.next = d), g = d, n(h);
  }
  function n(h) {
    if (h === null) {
      o.exit("chunkText"), o.exit("paragraph"), o.consume(h);
      return;
    }
    return markdownLineEnding(h) ? (o.consume(h), o.exit("chunkText"), t) : (o.consume(h), n);
  }
}
const document$2 = {
  tokenize: initializeDocument
}, containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(o) {
  const i = this, g = [];
  let E = 0, e, t, n;
  return h;
  function h(QA) {
    if (E < g.length) {
      const iA = g[E];
      return i.containerState = iA[1], o.attempt(iA[0].continuation, d, k)(QA);
    }
    return k(QA);
  }
  function d(QA) {
    if (E++, i.containerState._closeFlow) {
      i.containerState._closeFlow = void 0, e && CA();
      const iA = i.events.length;
      let EA = iA, oA;
      for (; EA--; )
        if (i.events[EA][0] === "exit" && i.events[EA][1].type === "chunkFlow") {
          oA = i.events[EA][1].end;
          break;
        }
      BA(E);
      let eA = iA;
      for (; eA < i.events.length; )
        i.events[eA][1].end = {
          ...oA
        }, eA++;
      return splice(i.events, EA + 1, 0, i.events.slice(iA)), i.events.length = eA, k(QA);
    }
    return h(QA);
  }
  function k(QA) {
    if (E === g.length) {
      if (!e)
        return H(QA);
      if (e.currentConstruct && e.currentConstruct.concrete)
        return AA(QA);
      i.interrupt = !!(e.currentConstruct && !e._gfmTableDynamicInterruptHack);
    }
    return i.containerState = {}, o.check(containerConstruct, p, M)(QA);
  }
  function p(QA) {
    return e && CA(), BA(E), H(QA);
  }
  function M(QA) {
    return i.parser.lazy[i.now().line] = E !== g.length, n = i.now().offset, AA(QA);
  }
  function H(QA) {
    return i.containerState = {}, o.attempt(containerConstruct, f, AA)(QA);
  }
  function f(QA) {
    return E++, g.push([i.currentConstruct, i.containerState]), H(QA);
  }
  function AA(QA) {
    if (QA === null) {
      e && CA(), BA(0), o.consume(QA);
      return;
    }
    return e = e || i.parser.flow(i.now()), o.enter("chunkFlow", {
      _tokenizer: e,
      contentType: "flow",
      previous: t
    }), gA(QA);
  }
  function gA(QA) {
    if (QA === null) {
      IA(o.exit("chunkFlow"), !0), BA(0), o.consume(QA);
      return;
    }
    return markdownLineEnding(QA) ? (o.consume(QA), IA(o.exit("chunkFlow")), E = 0, i.interrupt = void 0, h) : (o.consume(QA), gA);
  }
  function IA(QA, iA) {
    const EA = i.sliceStream(QA);
    if (iA && EA.push(null), QA.previous = t, t && (t.next = QA), t = QA, e.defineSkip(QA.start), e.write(EA), i.parser.lazy[QA.start.line]) {
      let oA = e.events.length;
      for (; oA--; )
        if (
          // The token starts before the line ending…
          e.events[oA][1].start.offset < n && // …and either is not ended yet…
          (!e.events[oA][1].end || // …or ends after it.
          e.events[oA][1].end.offset > n)
        )
          return;
      const eA = i.events.length;
      let GA = eA, cA, tA;
      for (; GA--; )
        if (i.events[GA][0] === "exit" && i.events[GA][1].type === "chunkFlow") {
          if (cA) {
            tA = i.events[GA][1].end;
            break;
          }
          cA = !0;
        }
      for (BA(E), oA = eA; oA < i.events.length; )
        i.events[oA][1].end = {
          ...tA
        }, oA++;
      splice(i.events, GA + 1, 0, i.events.slice(eA)), i.events.length = oA;
    }
  }
  function BA(QA) {
    let iA = g.length;
    for (; iA-- > QA; ) {
      const EA = g[iA];
      i.containerState = EA[1], EA[0].exit.call(i, o);
    }
    g.length = QA;
  }
  function CA() {
    e.write([null]), t = void 0, e = void 0, i.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(o, i, g) {
  return factorySpace(o, o.attempt(this.parser.constructs.document, i, g), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function classifyCharacter(o) {
  if (o === null || markdownLineEndingOrSpace(o) || unicodeWhitespace(o))
    return 1;
  if (unicodePunctuation(o))
    return 2;
}
function resolveAll(o, i, g) {
  const E = [];
  let e = -1;
  for (; ++e < o.length; ) {
    const t = o[e].resolveAll;
    t && !E.includes(t) && (i = t(i, g), E.push(t));
  }
  return i;
}
const attention = {
  name: "attention",
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};
function resolveAllAttention(o, i) {
  let g = -1, E, e, t, n, h, d, k, p;
  for (; ++g < o.length; )
    if (o[g][0] === "enter" && o[g][1].type === "attentionSequence" && o[g][1]._close) {
      for (E = g; E--; )
        if (o[E][0] === "exit" && o[E][1].type === "attentionSequence" && o[E][1]._open && // If the markers are the same:
        i.sliceSerialize(o[E][1]).charCodeAt(0) === i.sliceSerialize(o[g][1]).charCodeAt(0)) {
          if ((o[E][1]._close || o[g][1]._open) && (o[g][1].end.offset - o[g][1].start.offset) % 3 && !((o[E][1].end.offset - o[E][1].start.offset + o[g][1].end.offset - o[g][1].start.offset) % 3))
            continue;
          d = o[E][1].end.offset - o[E][1].start.offset > 1 && o[g][1].end.offset - o[g][1].start.offset > 1 ? 2 : 1;
          const M = {
            ...o[E][1].end
          }, H = {
            ...o[g][1].start
          };
          movePoint(M, -d), movePoint(H, d), n = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: M,
            end: {
              ...o[E][1].end
            }
          }, h = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...o[g][1].start
            },
            end: H
          }, t = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...o[E][1].end
            },
            end: {
              ...o[g][1].start
            }
          }, e = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...n.start
            },
            end: {
              ...h.end
            }
          }, o[E][1].end = {
            ...n.start
          }, o[g][1].start = {
            ...h.end
          }, k = [], o[E][1].end.offset - o[E][1].start.offset && (k = push(k, [["enter", o[E][1], i], ["exit", o[E][1], i]])), k = push(k, [["enter", e, i], ["enter", n, i], ["exit", n, i], ["enter", t, i]]), k = push(k, resolveAll(i.parser.constructs.insideSpan.null, o.slice(E + 1, g), i)), k = push(k, [["exit", t, i], ["enter", h, i], ["exit", h, i], ["exit", e, i]]), o[g][1].end.offset - o[g][1].start.offset ? (p = 2, k = push(k, [["enter", o[g][1], i], ["exit", o[g][1], i]])) : p = 0, splice(o, E - 1, g - E + 3, k), g = E + k.length - p - 2;
          break;
        }
    }
  for (g = -1; ++g < o.length; )
    o[g][1].type === "attentionSequence" && (o[g][1].type = "data");
  return o;
}
function tokenizeAttention(o, i) {
  const g = this.parser.constructs.attentionMarkers.null, E = this.previous, e = classifyCharacter(E);
  let t;
  return n;
  function n(d) {
    return t = d, o.enter("attentionSequence"), h(d);
  }
  function h(d) {
    if (d === t)
      return o.consume(d), h;
    const k = o.exit("attentionSequence"), p = classifyCharacter(d), M = !p || p === 2 && e || g.includes(d), H = !e || e === 2 && p || g.includes(E);
    return k._open = !!(t === 42 ? M : M && (e || !H)), k._close = !!(t === 42 ? H : H && (p || !M)), i(d);
  }
}
function movePoint(o, i) {
  o.column += i, o.offset += i, o._bufferIndex += i;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(o, i, g) {
  let E = 0;
  return e;
  function e(f) {
    return o.enter("autolink"), o.enter("autolinkMarker"), o.consume(f), o.exit("autolinkMarker"), o.enter("autolinkProtocol"), t;
  }
  function t(f) {
    return asciiAlpha(f) ? (o.consume(f), n) : f === 64 ? g(f) : k(f);
  }
  function n(f) {
    return f === 43 || f === 45 || f === 46 || asciiAlphanumeric(f) ? (E = 1, h(f)) : k(f);
  }
  function h(f) {
    return f === 58 ? (o.consume(f), E = 0, d) : (f === 43 || f === 45 || f === 46 || asciiAlphanumeric(f)) && E++ < 32 ? (o.consume(f), h) : (E = 0, k(f));
  }
  function d(f) {
    return f === 62 ? (o.exit("autolinkProtocol"), o.enter("autolinkMarker"), o.consume(f), o.exit("autolinkMarker"), o.exit("autolink"), i) : f === null || f === 32 || f === 60 || asciiControl(f) ? g(f) : (o.consume(f), d);
  }
  function k(f) {
    return f === 64 ? (o.consume(f), p) : asciiAtext(f) ? (o.consume(f), k) : g(f);
  }
  function p(f) {
    return asciiAlphanumeric(f) ? M(f) : g(f);
  }
  function M(f) {
    return f === 46 ? (o.consume(f), E = 0, p) : f === 62 ? (o.exit("autolinkProtocol").type = "autolinkEmail", o.enter("autolinkMarker"), o.consume(f), o.exit("autolinkMarker"), o.exit("autolink"), i) : H(f);
  }
  function H(f) {
    if ((f === 45 || asciiAlphanumeric(f)) && E++ < 63) {
      const AA = f === 45 ? H : M;
      return o.consume(f), AA;
    }
    return g(f);
  }
}
const blankLine = {
  partial: !0,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(o, i, g) {
  return E;
  function E(t) {
    return markdownSpace(t) ? factorySpace(o, e, "linePrefix")(t) : e(t);
  }
  function e(t) {
    return t === null || markdownLineEnding(t) ? i(t) : g(t);
  }
}
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit: exit$2,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    if (n === 62) {
      const h = E.containerState;
      return h.open || (o.enter("blockQuote", {
        _container: !0
      }), h.open = !0), o.enter("blockQuotePrefix"), o.enter("blockQuoteMarker"), o.consume(n), o.exit("blockQuoteMarker"), t;
    }
    return g(n);
  }
  function t(n) {
    return markdownSpace(n) ? (o.enter("blockQuotePrefixWhitespace"), o.consume(n), o.exit("blockQuotePrefixWhitespace"), o.exit("blockQuotePrefix"), i) : (o.exit("blockQuotePrefix"), i(n));
  }
}
function tokenizeBlockQuoteContinuation(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return markdownSpace(n) ? factorySpace(o, t, "linePrefix", E.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(n) : t(n);
  }
  function t(n) {
    return o.attempt(blockQuote, i, g)(n);
  }
}
function exit$2(o) {
  o.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(o, i, g) {
  return E;
  function E(t) {
    return o.enter("characterEscape"), o.enter("escapeMarker"), o.consume(t), o.exit("escapeMarker"), e;
  }
  function e(t) {
    return asciiPunctuation(t) ? (o.enter("characterEscapeValue"), o.consume(t), o.exit("characterEscapeValue"), o.exit("characterEscape"), i) : g(t);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(o, i, g) {
  const E = this;
  let e = 0, t, n;
  return h;
  function h(M) {
    return o.enter("characterReference"), o.enter("characterReferenceMarker"), o.consume(M), o.exit("characterReferenceMarker"), d;
  }
  function d(M) {
    return M === 35 ? (o.enter("characterReferenceMarkerNumeric"), o.consume(M), o.exit("characterReferenceMarkerNumeric"), k) : (o.enter("characterReferenceValue"), t = 31, n = asciiAlphanumeric, p(M));
  }
  function k(M) {
    return M === 88 || M === 120 ? (o.enter("characterReferenceMarkerHexadecimal"), o.consume(M), o.exit("characterReferenceMarkerHexadecimal"), o.enter("characterReferenceValue"), t = 6, n = asciiHexDigit, p) : (o.enter("characterReferenceValue"), t = 7, n = asciiDigit, p(M));
  }
  function p(M) {
    if (M === 59 && e) {
      const H = o.exit("characterReferenceValue");
      return n === asciiAlphanumeric && !decodeNamedCharacterReference(E.sliceSerialize(H)) ? g(M) : (o.enter("characterReferenceMarker"), o.consume(M), o.exit("characterReferenceMarker"), o.exit("characterReference"), i);
    }
    return n(M) && e++ < t ? (o.consume(M), p) : g(M);
  }
}
const nonLazyContinuation$1 = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuation$1
}, codeFenced = {
  concrete: !0,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(o, i, g) {
  const E = this, e = {
    partial: !0,
    tokenize: EA
  };
  let t = 0, n = 0, h;
  return d;
  function d(oA) {
    return k(oA);
  }
  function k(oA) {
    const eA = E.events[E.events.length - 1];
    return t = eA && eA[1].type === "linePrefix" ? eA[2].sliceSerialize(eA[1], !0).length : 0, h = oA, o.enter("codeFenced"), o.enter("codeFencedFence"), o.enter("codeFencedFenceSequence"), p(oA);
  }
  function p(oA) {
    return oA === h ? (n++, o.consume(oA), p) : n < 3 ? g(oA) : (o.exit("codeFencedFenceSequence"), markdownSpace(oA) ? factorySpace(o, M, "whitespace")(oA) : M(oA));
  }
  function M(oA) {
    return oA === null || markdownLineEnding(oA) ? (o.exit("codeFencedFence"), E.interrupt ? i(oA) : o.check(nonLazyContinuation$1, gA, iA)(oA)) : (o.enter("codeFencedFenceInfo"), o.enter("chunkString", {
      contentType: "string"
    }), H(oA));
  }
  function H(oA) {
    return oA === null || markdownLineEnding(oA) ? (o.exit("chunkString"), o.exit("codeFencedFenceInfo"), M(oA)) : markdownSpace(oA) ? (o.exit("chunkString"), o.exit("codeFencedFenceInfo"), factorySpace(o, f, "whitespace")(oA)) : oA === 96 && oA === h ? g(oA) : (o.consume(oA), H);
  }
  function f(oA) {
    return oA === null || markdownLineEnding(oA) ? M(oA) : (o.enter("codeFencedFenceMeta"), o.enter("chunkString", {
      contentType: "string"
    }), AA(oA));
  }
  function AA(oA) {
    return oA === null || markdownLineEnding(oA) ? (o.exit("chunkString"), o.exit("codeFencedFenceMeta"), M(oA)) : oA === 96 && oA === h ? g(oA) : (o.consume(oA), AA);
  }
  function gA(oA) {
    return o.attempt(e, iA, IA)(oA);
  }
  function IA(oA) {
    return o.enter("lineEnding"), o.consume(oA), o.exit("lineEnding"), BA;
  }
  function BA(oA) {
    return t > 0 && markdownSpace(oA) ? factorySpace(o, CA, "linePrefix", t + 1)(oA) : CA(oA);
  }
  function CA(oA) {
    return oA === null || markdownLineEnding(oA) ? o.check(nonLazyContinuation$1, gA, iA)(oA) : (o.enter("codeFlowValue"), QA(oA));
  }
  function QA(oA) {
    return oA === null || markdownLineEnding(oA) ? (o.exit("codeFlowValue"), CA(oA)) : (o.consume(oA), QA);
  }
  function iA(oA) {
    return o.exit("codeFenced"), i(oA);
  }
  function EA(oA, eA, GA) {
    let cA = 0;
    return tA;
    function tA(nA) {
      return oA.enter("lineEnding"), oA.consume(nA), oA.exit("lineEnding"), aA;
    }
    function aA(nA) {
      return oA.enter("codeFencedFence"), markdownSpace(nA) ? factorySpace(oA, sA, "linePrefix", E.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(nA) : sA(nA);
    }
    function sA(nA) {
      return nA === h ? (oA.enter("codeFencedFenceSequence"), DA(nA)) : GA(nA);
    }
    function DA(nA) {
      return nA === h ? (cA++, oA.consume(nA), DA) : cA >= n ? (oA.exit("codeFencedFenceSequence"), markdownSpace(nA) ? factorySpace(oA, rA, "whitespace")(nA) : rA(nA)) : GA(nA);
    }
    function rA(nA) {
      return nA === null || markdownLineEnding(nA) ? (oA.exit("codeFencedFence"), eA(nA)) : GA(nA);
    }
  }
}
function tokenizeNonLazyContinuation$1(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return n === null ? g(n) : (o.enter("lineEnding"), o.consume(n), o.exit("lineEnding"), t);
  }
  function t(n) {
    return E.parser.lazy[E.now().line] ? g(n) : i(n);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
}, furtherStart = {
  partial: !0,
  tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(o, i, g) {
  const E = this;
  return e;
  function e(k) {
    return o.enter("codeIndented"), factorySpace(o, t, "linePrefix", 5)(k);
  }
  function t(k) {
    const p = E.events[E.events.length - 1];
    return p && p[1].type === "linePrefix" && p[2].sliceSerialize(p[1], !0).length >= 4 ? n(k) : g(k);
  }
  function n(k) {
    return k === null ? d(k) : markdownLineEnding(k) ? o.attempt(furtherStart, n, d)(k) : (o.enter("codeFlowValue"), h(k));
  }
  function h(k) {
    return k === null || markdownLineEnding(k) ? (o.exit("codeFlowValue"), n(k)) : (o.consume(k), h);
  }
  function d(k) {
    return o.exit("codeIndented"), i(k);
  }
}
function tokenizeFurtherStart(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return E.parser.lazy[E.now().line] ? g(n) : markdownLineEnding(n) ? (o.enter("lineEnding"), o.consume(n), o.exit("lineEnding"), e) : factorySpace(o, t, "linePrefix", 5)(n);
  }
  function t(n) {
    const h = E.events[E.events.length - 1];
    return h && h[1].type === "linePrefix" && h[2].sliceSerialize(h[1], !0).length >= 4 ? i(n) : markdownLineEnding(n) ? e(n) : g(n);
  }
}
const codeText = {
  name: "codeText",
  previous: previous$3,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};
function resolveCodeText(o) {
  let i = o.length - 4, g = 3, E, e;
  if ((o[g][1].type === "lineEnding" || o[g][1].type === "space") && (o[i][1].type === "lineEnding" || o[i][1].type === "space")) {
    for (E = g; ++E < i; )
      if (o[E][1].type === "codeTextData") {
        o[g][1].type = "codeTextPadding", o[i][1].type = "codeTextPadding", g += 2, i -= 2;
        break;
      }
  }
  for (E = g - 1, i++; ++E <= i; )
    e === void 0 ? E !== i && o[E][1].type !== "lineEnding" && (e = E) : (E === i || o[E][1].type === "lineEnding") && (o[e][1].type = "codeTextData", E !== e + 2 && (o[e][1].end = o[E - 1][1].end, o.splice(e + 2, E - e - 2), i -= E - e - 2, E = e + 2), e = void 0);
  return o;
}
function previous$3(o) {
  return o !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(o, i, g) {
  let E = 0, e, t;
  return n;
  function n(M) {
    return o.enter("codeText"), o.enter("codeTextSequence"), h(M);
  }
  function h(M) {
    return M === 96 ? (o.consume(M), E++, h) : (o.exit("codeTextSequence"), d(M));
  }
  function d(M) {
    return M === null ? g(M) : M === 32 ? (o.enter("space"), o.consume(M), o.exit("space"), d) : M === 96 ? (t = o.enter("codeTextSequence"), e = 0, p(M)) : markdownLineEnding(M) ? (o.enter("lineEnding"), o.consume(M), o.exit("lineEnding"), d) : (o.enter("codeTextData"), k(M));
  }
  function k(M) {
    return M === null || M === 32 || M === 96 || markdownLineEnding(M) ? (o.exit("codeTextData"), d(M)) : (o.consume(M), k);
  }
  function p(M) {
    return M === 96 ? (o.consume(M), e++, p) : e === E ? (o.exit("codeTextSequence"), o.exit("codeText"), i(M)) : (t.type = "codeTextData", k(M));
  }
}
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(i) {
    this.left = i ? [...i] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(i) {
    if (i < 0 || i >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + i + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return i < this.left.length ? this.left[i] : this.right[this.right.length - i + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(i, g) {
    const E = g ?? Number.POSITIVE_INFINITY;
    return E < this.left.length ? this.left.slice(i, E) : i > this.left.length ? this.right.slice(this.right.length - E + this.left.length, this.right.length - i + this.left.length).reverse() : this.left.slice(i).concat(this.right.slice(this.right.length - E + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(i, g, E) {
    const e = g || 0;
    this.setCursor(Math.trunc(i));
    const t = this.right.splice(this.right.length - e, Number.POSITIVE_INFINITY);
    return E && chunkedPush(this.left, E), t.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(i) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(i);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(i) {
    this.setCursor(Number.POSITIVE_INFINITY), chunkedPush(this.left, i);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(i) {
    this.setCursor(0), this.right.push(i);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(i) {
    this.setCursor(0), chunkedPush(this.right, i.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(i) {
    if (!(i === this.left.length || i > this.left.length && this.right.length === 0 || i < 0 && this.left.length === 0))
      if (i < this.left.length) {
        const g = this.left.splice(i, Number.POSITIVE_INFINITY);
        chunkedPush(this.right, g.reverse());
      } else {
        const g = this.right.splice(this.left.length + this.right.length - i, Number.POSITIVE_INFINITY);
        chunkedPush(this.left, g.reverse());
      }
  }
}
function chunkedPush(o, i) {
  let g = 0;
  if (i.length < 1e4)
    o.push(...i);
  else
    for (; g < i.length; )
      o.push(...i.slice(g, g + 1e4)), g += 1e4;
}
function subtokenize(o) {
  const i = {};
  let g = -1, E, e, t, n, h, d, k;
  const p = new SpliceBuffer(o);
  for (; ++g < p.length; ) {
    for (; g in i; )
      g = i[g];
    if (E = p.get(g), g && E[1].type === "chunkFlow" && p.get(g - 1)[1].type === "listItemPrefix" && (d = E[1]._tokenizer.events, t = 0, t < d.length && d[t][1].type === "lineEndingBlank" && (t += 2), t < d.length && d[t][1].type === "content"))
      for (; ++t < d.length && d[t][1].type !== "content"; )
        d[t][1].type === "chunkText" && (d[t][1]._isInFirstContentOfListItem = !0, t++);
    if (E[0] === "enter")
      E[1].contentType && (Object.assign(i, subcontent(p, g)), g = i[g], k = !0);
    else if (E[1]._container) {
      for (t = g, e = void 0; t--; )
        if (n = p.get(t), n[1].type === "lineEnding" || n[1].type === "lineEndingBlank")
          n[0] === "enter" && (e && (p.get(e)[1].type = "lineEndingBlank"), n[1].type = "lineEnding", e = t);
        else if (!(n[1].type === "linePrefix" || n[1].type === "listItemIndent")) break;
      e && (E[1].end = {
        ...p.get(e)[1].start
      }, h = p.slice(e, g), h.unshift(E), p.splice(e, g - e + 1, h));
    }
  }
  return splice(o, 0, Number.POSITIVE_INFINITY, p.slice(0)), !k;
}
function subcontent(o, i) {
  const g = o.get(i)[1], E = o.get(i)[2];
  let e = i - 1;
  const t = [];
  let n = g._tokenizer;
  n || (n = E.parser[g.contentType](g.start), g._contentTypeTextTrailing && (n._contentTypeTextTrailing = !0));
  const h = n.events, d = [], k = {};
  let p, M, H = -1, f = g, AA = 0, gA = 0;
  const IA = [gA];
  for (; f; ) {
    for (; o.get(++e)[1] !== f; )
      ;
    t.push(e), f._tokenizer || (p = E.sliceStream(f), f.next || p.push(null), M && n.defineSkip(f.start), f._isInFirstContentOfListItem && (n._gfmTasklistFirstContentOfListItem = !0), n.write(p), f._isInFirstContentOfListItem && (n._gfmTasklistFirstContentOfListItem = void 0)), M = f, f = f.next;
  }
  for (f = g; ++H < h.length; )
    // Find a void token that includes a break.
    h[H][0] === "exit" && h[H - 1][0] === "enter" && h[H][1].type === h[H - 1][1].type && h[H][1].start.line !== h[H][1].end.line && (gA = H + 1, IA.push(gA), f._tokenizer = void 0, f.previous = void 0, f = f.next);
  for (n.events = [], f ? (f._tokenizer = void 0, f.previous = void 0) : IA.pop(), H = IA.length; H--; ) {
    const BA = h.slice(IA[H], IA[H + 1]), CA = t.pop();
    d.push([CA, CA + BA.length - 1]), o.splice(CA, 2, BA);
  }
  for (d.reverse(), H = -1; ++H < d.length; )
    k[AA + d[H][0]] = AA + d[H][1], AA += d[H][1] - d[H][0] - 1;
  return k;
}
const content = {
  resolve: resolveContent,
  tokenize: tokenizeContent
}, continuationConstruct = {
  partial: !0,
  tokenize: tokenizeContinuation
};
function resolveContent(o) {
  return subtokenize(o), o;
}
function tokenizeContent(o, i) {
  let g;
  return E;
  function E(h) {
    return o.enter("content"), g = o.enter("chunkContent", {
      contentType: "content"
    }), e(h);
  }
  function e(h) {
    return h === null ? t(h) : markdownLineEnding(h) ? o.check(continuationConstruct, n, t)(h) : (o.consume(h), e);
  }
  function t(h) {
    return o.exit("chunkContent"), o.exit("content"), i(h);
  }
  function n(h) {
    return o.consume(h), o.exit("chunkContent"), g.next = o.enter("chunkContent", {
      contentType: "content",
      previous: g
    }), g = g.next, e;
  }
}
function tokenizeContinuation(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return o.exit("chunkContent"), o.enter("lineEnding"), o.consume(n), o.exit("lineEnding"), factorySpace(o, t, "linePrefix");
  }
  function t(n) {
    if (n === null || markdownLineEnding(n))
      return g(n);
    const h = E.events[E.events.length - 1];
    return !E.parser.constructs.disable.null.includes("codeIndented") && h && h[1].type === "linePrefix" && h[2].sliceSerialize(h[1], !0).length >= 4 ? i(n) : o.interrupt(E.parser.constructs.flow, g, i)(n);
  }
}
function factoryDestination(o, i, g, E, e, t, n, h, d) {
  const k = d || Number.POSITIVE_INFINITY;
  let p = 0;
  return M;
  function M(BA) {
    return BA === 60 ? (o.enter(E), o.enter(e), o.enter(t), o.consume(BA), o.exit(t), H) : BA === null || BA === 32 || BA === 41 || asciiControl(BA) ? g(BA) : (o.enter(E), o.enter(n), o.enter(h), o.enter("chunkString", {
      contentType: "string"
    }), gA(BA));
  }
  function H(BA) {
    return BA === 62 ? (o.enter(t), o.consume(BA), o.exit(t), o.exit(e), o.exit(E), i) : (o.enter(h), o.enter("chunkString", {
      contentType: "string"
    }), f(BA));
  }
  function f(BA) {
    return BA === 62 ? (o.exit("chunkString"), o.exit(h), H(BA)) : BA === null || BA === 60 || markdownLineEnding(BA) ? g(BA) : (o.consume(BA), BA === 92 ? AA : f);
  }
  function AA(BA) {
    return BA === 60 || BA === 62 || BA === 92 ? (o.consume(BA), f) : f(BA);
  }
  function gA(BA) {
    return !p && (BA === null || BA === 41 || markdownLineEndingOrSpace(BA)) ? (o.exit("chunkString"), o.exit(h), o.exit(n), o.exit(E), i(BA)) : p < k && BA === 40 ? (o.consume(BA), p++, gA) : BA === 41 ? (o.consume(BA), p--, gA) : BA === null || BA === 32 || BA === 40 || asciiControl(BA) ? g(BA) : (o.consume(BA), BA === 92 ? IA : gA);
  }
  function IA(BA) {
    return BA === 40 || BA === 41 || BA === 92 ? (o.consume(BA), gA) : gA(BA);
  }
}
function factoryLabel$1(o, i, g, E, e, t) {
  const n = this;
  let h = 0, d;
  return k;
  function k(f) {
    return o.enter(E), o.enter(e), o.consume(f), o.exit(e), o.enter(t), p;
  }
  function p(f) {
    return h > 999 || f === null || f === 91 || f === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    f === 94 && !h && "_hiddenFootnoteSupport" in n.parser.constructs ? g(f) : f === 93 ? (o.exit(t), o.enter(e), o.consume(f), o.exit(e), o.exit(E), i) : markdownLineEnding(f) ? (o.enter("lineEnding"), o.consume(f), o.exit("lineEnding"), p) : (o.enter("chunkString", {
      contentType: "string"
    }), M(f));
  }
  function M(f) {
    return f === null || f === 91 || f === 93 || markdownLineEnding(f) || h++ > 999 ? (o.exit("chunkString"), p(f)) : (o.consume(f), d || (d = !markdownSpace(f)), f === 92 ? H : M);
  }
  function H(f) {
    return f === 91 || f === 92 || f === 93 ? (o.consume(f), h++, M) : M(f);
  }
}
function factoryTitle(o, i, g, E, e, t) {
  let n;
  return h;
  function h(H) {
    return H === 34 || H === 39 || H === 40 ? (o.enter(E), o.enter(e), o.consume(H), o.exit(e), n = H === 40 ? 41 : H, d) : g(H);
  }
  function d(H) {
    return H === n ? (o.enter(e), o.consume(H), o.exit(e), o.exit(E), i) : (o.enter(t), k(H));
  }
  function k(H) {
    return H === n ? (o.exit(t), d(n)) : H === null ? g(H) : markdownLineEnding(H) ? (o.enter("lineEnding"), o.consume(H), o.exit("lineEnding"), factorySpace(o, k, "linePrefix")) : (o.enter("chunkString", {
      contentType: "string"
    }), p(H));
  }
  function p(H) {
    return H === n || H === null || markdownLineEnding(H) ? (o.exit("chunkString"), k(H)) : (o.consume(H), H === 92 ? M : p);
  }
  function M(H) {
    return H === n || H === 92 ? (o.consume(H), p) : p(H);
  }
}
function factoryWhitespace(o, i) {
  let g;
  return E;
  function E(e) {
    return markdownLineEnding(e) ? (o.enter("lineEnding"), o.consume(e), o.exit("lineEnding"), g = !0, E) : markdownSpace(e) ? factorySpace(o, E, g ? "linePrefix" : "lineSuffix")(e) : i(e);
  }
}
const definition$1 = {
  name: "definition",
  tokenize: tokenizeDefinition
}, titleBefore = {
  partial: !0,
  tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(o, i, g) {
  const E = this;
  let e;
  return t;
  function t(f) {
    return o.enter("definition"), n(f);
  }
  function n(f) {
    return factoryLabel$1.call(
      E,
      o,
      h,
      // Note: we don’t need to reset the way `markdown-rs` does.
      g,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(f);
  }
  function h(f) {
    return e = normalizeIdentifier(E.sliceSerialize(E.events[E.events.length - 1][1]).slice(1, -1)), f === 58 ? (o.enter("definitionMarker"), o.consume(f), o.exit("definitionMarker"), d) : g(f);
  }
  function d(f) {
    return markdownLineEndingOrSpace(f) ? factoryWhitespace(o, k)(f) : k(f);
  }
  function k(f) {
    return factoryDestination(
      o,
      p,
      // Note: we don’t need to reset the way `markdown-rs` does.
      g,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(f);
  }
  function p(f) {
    return o.attempt(titleBefore, M, M)(f);
  }
  function M(f) {
    return markdownSpace(f) ? factorySpace(o, H, "whitespace")(f) : H(f);
  }
  function H(f) {
    return f === null || markdownLineEnding(f) ? (o.exit("definition"), E.parser.defined.push(e), i(f)) : g(f);
  }
}
function tokenizeTitleBefore(o, i, g) {
  return E;
  function E(h) {
    return markdownLineEndingOrSpace(h) ? factoryWhitespace(o, e)(h) : g(h);
  }
  function e(h) {
    return factoryTitle(o, t, g, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(h);
  }
  function t(h) {
    return markdownSpace(h) ? factorySpace(o, n, "whitespace")(h) : n(h);
  }
  function n(h) {
    return h === null || markdownLineEnding(h) ? i(h) : g(h);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(o, i, g) {
  return E;
  function E(t) {
    return o.enter("hardBreakEscape"), o.consume(t), e;
  }
  function e(t) {
    return markdownLineEnding(t) ? (o.exit("hardBreakEscape"), i(t)) : g(t);
  }
}
const headingAtx = {
  name: "headingAtx",
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(o, i) {
  let g = o.length - 2, E = 3, e, t;
  return o[E][1].type === "whitespace" && (E += 2), g - 2 > E && o[g][1].type === "whitespace" && (g -= 2), o[g][1].type === "atxHeadingSequence" && (E === g - 1 || g - 4 > E && o[g - 2][1].type === "whitespace") && (g -= E + 1 === g ? 2 : 4), g > E && (e = {
    type: "atxHeadingText",
    start: o[E][1].start,
    end: o[g][1].end
  }, t = {
    type: "chunkText",
    start: o[E][1].start,
    end: o[g][1].end,
    contentType: "text"
  }, splice(o, E, g - E + 1, [["enter", e, i], ["enter", t, i], ["exit", t, i], ["exit", e, i]])), o;
}
function tokenizeHeadingAtx(o, i, g) {
  let E = 0;
  return e;
  function e(p) {
    return o.enter("atxHeading"), t(p);
  }
  function t(p) {
    return o.enter("atxHeadingSequence"), n(p);
  }
  function n(p) {
    return p === 35 && E++ < 6 ? (o.consume(p), n) : p === null || markdownLineEndingOrSpace(p) ? (o.exit("atxHeadingSequence"), h(p)) : g(p);
  }
  function h(p) {
    return p === 35 ? (o.enter("atxHeadingSequence"), d(p)) : p === null || markdownLineEnding(p) ? (o.exit("atxHeading"), i(p)) : markdownSpace(p) ? factorySpace(o, h, "whitespace")(p) : (o.enter("atxHeadingText"), k(p));
  }
  function d(p) {
    return p === 35 ? (o.consume(p), d) : (o.exit("atxHeadingSequence"), h(p));
  }
  function k(p) {
    return p === null || p === 35 || markdownLineEndingOrSpace(p) ? (o.exit("atxHeadingText"), h(p)) : (o.consume(p), k);
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], htmlRawNames = ["pre", "script", "style", "textarea"], htmlFlow = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
}, blankLineBefore = {
  partial: !0,
  tokenize: tokenizeBlankLineBefore
}, nonLazyContinuationStart = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(o) {
  let i = o.length;
  for (; i-- && !(o[i][0] === "enter" && o[i][1].type === "htmlFlow"); )
    ;
  return i > 1 && o[i - 2][1].type === "linePrefix" && (o[i][1].start = o[i - 2][1].start, o[i + 1][1].start = o[i - 2][1].start, o.splice(i - 2, 2)), o;
}
function tokenizeHtmlFlow(o, i, g) {
  const E = this;
  let e, t, n, h, d;
  return k;
  function k(wA) {
    return p(wA);
  }
  function p(wA) {
    return o.enter("htmlFlow"), o.enter("htmlFlowData"), o.consume(wA), M;
  }
  function M(wA) {
    return wA === 33 ? (o.consume(wA), H) : wA === 47 ? (o.consume(wA), t = !0, gA) : wA === 63 ? (o.consume(wA), e = 3, E.interrupt ? i : lA) : asciiAlpha(wA) ? (o.consume(wA), n = String.fromCharCode(wA), IA) : g(wA);
  }
  function H(wA) {
    return wA === 45 ? (o.consume(wA), e = 2, f) : wA === 91 ? (o.consume(wA), e = 5, h = 0, AA) : asciiAlpha(wA) ? (o.consume(wA), e = 4, E.interrupt ? i : lA) : g(wA);
  }
  function f(wA) {
    return wA === 45 ? (o.consume(wA), E.interrupt ? i : lA) : g(wA);
  }
  function AA(wA) {
    const LA = "CDATA[";
    return wA === LA.charCodeAt(h++) ? (o.consume(wA), h === LA.length ? E.interrupt ? i : sA : AA) : g(wA);
  }
  function gA(wA) {
    return asciiAlpha(wA) ? (o.consume(wA), n = String.fromCharCode(wA), IA) : g(wA);
  }
  function IA(wA) {
    if (wA === null || wA === 47 || wA === 62 || markdownLineEndingOrSpace(wA)) {
      const LA = wA === 47, fA = n.toLowerCase();
      return !LA && !t && htmlRawNames.includes(fA) ? (e = 1, E.interrupt ? i(wA) : sA(wA)) : htmlBlockNames.includes(n.toLowerCase()) ? (e = 6, LA ? (o.consume(wA), BA) : E.interrupt ? i(wA) : sA(wA)) : (e = 7, E.interrupt && !E.parser.lazy[E.now().line] ? g(wA) : t ? CA(wA) : QA(wA));
    }
    return wA === 45 || asciiAlphanumeric(wA) ? (o.consume(wA), n += String.fromCharCode(wA), IA) : g(wA);
  }
  function BA(wA) {
    return wA === 62 ? (o.consume(wA), E.interrupt ? i : sA) : g(wA);
  }
  function CA(wA) {
    return markdownSpace(wA) ? (o.consume(wA), CA) : tA(wA);
  }
  function QA(wA) {
    return wA === 47 ? (o.consume(wA), tA) : wA === 58 || wA === 95 || asciiAlpha(wA) ? (o.consume(wA), iA) : markdownSpace(wA) ? (o.consume(wA), QA) : tA(wA);
  }
  function iA(wA) {
    return wA === 45 || wA === 46 || wA === 58 || wA === 95 || asciiAlphanumeric(wA) ? (o.consume(wA), iA) : EA(wA);
  }
  function EA(wA) {
    return wA === 61 ? (o.consume(wA), oA) : markdownSpace(wA) ? (o.consume(wA), EA) : QA(wA);
  }
  function oA(wA) {
    return wA === null || wA === 60 || wA === 61 || wA === 62 || wA === 96 ? g(wA) : wA === 34 || wA === 39 ? (o.consume(wA), d = wA, eA) : markdownSpace(wA) ? (o.consume(wA), oA) : GA(wA);
  }
  function eA(wA) {
    return wA === d ? (o.consume(wA), d = null, cA) : wA === null || markdownLineEnding(wA) ? g(wA) : (o.consume(wA), eA);
  }
  function GA(wA) {
    return wA === null || wA === 34 || wA === 39 || wA === 47 || wA === 60 || wA === 61 || wA === 62 || wA === 96 || markdownLineEndingOrSpace(wA) ? EA(wA) : (o.consume(wA), GA);
  }
  function cA(wA) {
    return wA === 47 || wA === 62 || markdownSpace(wA) ? QA(wA) : g(wA);
  }
  function tA(wA) {
    return wA === 62 ? (o.consume(wA), aA) : g(wA);
  }
  function aA(wA) {
    return wA === null || markdownLineEnding(wA) ? sA(wA) : markdownSpace(wA) ? (o.consume(wA), aA) : g(wA);
  }
  function sA(wA) {
    return wA === 45 && e === 2 ? (o.consume(wA), NA) : wA === 60 && e === 1 ? (o.consume(wA), pA) : wA === 62 && e === 4 ? (o.consume(wA), kA) : wA === 63 && e === 3 ? (o.consume(wA), lA) : wA === 93 && e === 5 ? (o.consume(wA), XA) : markdownLineEnding(wA) && (e === 6 || e === 7) ? (o.exit("htmlFlowData"), o.check(blankLineBefore, ZA, DA)(wA)) : wA === null || markdownLineEnding(wA) ? (o.exit("htmlFlowData"), DA(wA)) : (o.consume(wA), sA);
  }
  function DA(wA) {
    return o.check(nonLazyContinuationStart, rA, ZA)(wA);
  }
  function rA(wA) {
    return o.enter("lineEnding"), o.consume(wA), o.exit("lineEnding"), nA;
  }
  function nA(wA) {
    return wA === null || markdownLineEnding(wA) ? DA(wA) : (o.enter("htmlFlowData"), sA(wA));
  }
  function NA(wA) {
    return wA === 45 ? (o.consume(wA), lA) : sA(wA);
  }
  function pA(wA) {
    return wA === 47 ? (o.consume(wA), n = "", mA) : sA(wA);
  }
  function mA(wA) {
    if (wA === 62) {
      const LA = n.toLowerCase();
      return htmlRawNames.includes(LA) ? (o.consume(wA), kA) : sA(wA);
    }
    return asciiAlpha(wA) && n.length < 8 ? (o.consume(wA), n += String.fromCharCode(wA), mA) : sA(wA);
  }
  function XA(wA) {
    return wA === 93 ? (o.consume(wA), lA) : sA(wA);
  }
  function lA(wA) {
    return wA === 62 ? (o.consume(wA), kA) : wA === 45 && e === 2 ? (o.consume(wA), lA) : sA(wA);
  }
  function kA(wA) {
    return wA === null || markdownLineEnding(wA) ? (o.exit("htmlFlowData"), ZA(wA)) : (o.consume(wA), kA);
  }
  function ZA(wA) {
    return o.exit("htmlFlow"), i(wA);
  }
}
function tokenizeNonLazyContinuationStart(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return markdownLineEnding(n) ? (o.enter("lineEnding"), o.consume(n), o.exit("lineEnding"), t) : g(n);
  }
  function t(n) {
    return E.parser.lazy[E.now().line] ? g(n) : i(n);
  }
}
function tokenizeBlankLineBefore(o, i, g) {
  return E;
  function E(e) {
    return o.enter("lineEnding"), o.consume(e), o.exit("lineEnding"), o.attempt(blankLine, i, g);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(o, i, g) {
  const E = this;
  let e, t, n;
  return h;
  function h(lA) {
    return o.enter("htmlText"), o.enter("htmlTextData"), o.consume(lA), d;
  }
  function d(lA) {
    return lA === 33 ? (o.consume(lA), k) : lA === 47 ? (o.consume(lA), EA) : lA === 63 ? (o.consume(lA), QA) : asciiAlpha(lA) ? (o.consume(lA), GA) : g(lA);
  }
  function k(lA) {
    return lA === 45 ? (o.consume(lA), p) : lA === 91 ? (o.consume(lA), t = 0, AA) : asciiAlpha(lA) ? (o.consume(lA), CA) : g(lA);
  }
  function p(lA) {
    return lA === 45 ? (o.consume(lA), f) : g(lA);
  }
  function M(lA) {
    return lA === null ? g(lA) : lA === 45 ? (o.consume(lA), H) : markdownLineEnding(lA) ? (n = M, pA(lA)) : (o.consume(lA), M);
  }
  function H(lA) {
    return lA === 45 ? (o.consume(lA), f) : M(lA);
  }
  function f(lA) {
    return lA === 62 ? NA(lA) : lA === 45 ? H(lA) : M(lA);
  }
  function AA(lA) {
    const kA = "CDATA[";
    return lA === kA.charCodeAt(t++) ? (o.consume(lA), t === kA.length ? gA : AA) : g(lA);
  }
  function gA(lA) {
    return lA === null ? g(lA) : lA === 93 ? (o.consume(lA), IA) : markdownLineEnding(lA) ? (n = gA, pA(lA)) : (o.consume(lA), gA);
  }
  function IA(lA) {
    return lA === 93 ? (o.consume(lA), BA) : gA(lA);
  }
  function BA(lA) {
    return lA === 62 ? NA(lA) : lA === 93 ? (o.consume(lA), BA) : gA(lA);
  }
  function CA(lA) {
    return lA === null || lA === 62 ? NA(lA) : markdownLineEnding(lA) ? (n = CA, pA(lA)) : (o.consume(lA), CA);
  }
  function QA(lA) {
    return lA === null ? g(lA) : lA === 63 ? (o.consume(lA), iA) : markdownLineEnding(lA) ? (n = QA, pA(lA)) : (o.consume(lA), QA);
  }
  function iA(lA) {
    return lA === 62 ? NA(lA) : QA(lA);
  }
  function EA(lA) {
    return asciiAlpha(lA) ? (o.consume(lA), oA) : g(lA);
  }
  function oA(lA) {
    return lA === 45 || asciiAlphanumeric(lA) ? (o.consume(lA), oA) : eA(lA);
  }
  function eA(lA) {
    return markdownLineEnding(lA) ? (n = eA, pA(lA)) : markdownSpace(lA) ? (o.consume(lA), eA) : NA(lA);
  }
  function GA(lA) {
    return lA === 45 || asciiAlphanumeric(lA) ? (o.consume(lA), GA) : lA === 47 || lA === 62 || markdownLineEndingOrSpace(lA) ? cA(lA) : g(lA);
  }
  function cA(lA) {
    return lA === 47 ? (o.consume(lA), NA) : lA === 58 || lA === 95 || asciiAlpha(lA) ? (o.consume(lA), tA) : markdownLineEnding(lA) ? (n = cA, pA(lA)) : markdownSpace(lA) ? (o.consume(lA), cA) : NA(lA);
  }
  function tA(lA) {
    return lA === 45 || lA === 46 || lA === 58 || lA === 95 || asciiAlphanumeric(lA) ? (o.consume(lA), tA) : aA(lA);
  }
  function aA(lA) {
    return lA === 61 ? (o.consume(lA), sA) : markdownLineEnding(lA) ? (n = aA, pA(lA)) : markdownSpace(lA) ? (o.consume(lA), aA) : cA(lA);
  }
  function sA(lA) {
    return lA === null || lA === 60 || lA === 61 || lA === 62 || lA === 96 ? g(lA) : lA === 34 || lA === 39 ? (o.consume(lA), e = lA, DA) : markdownLineEnding(lA) ? (n = sA, pA(lA)) : markdownSpace(lA) ? (o.consume(lA), sA) : (o.consume(lA), rA);
  }
  function DA(lA) {
    return lA === e ? (o.consume(lA), e = void 0, nA) : lA === null ? g(lA) : markdownLineEnding(lA) ? (n = DA, pA(lA)) : (o.consume(lA), DA);
  }
  function rA(lA) {
    return lA === null || lA === 34 || lA === 39 || lA === 60 || lA === 61 || lA === 96 ? g(lA) : lA === 47 || lA === 62 || markdownLineEndingOrSpace(lA) ? cA(lA) : (o.consume(lA), rA);
  }
  function nA(lA) {
    return lA === 47 || lA === 62 || markdownLineEndingOrSpace(lA) ? cA(lA) : g(lA);
  }
  function NA(lA) {
    return lA === 62 ? (o.consume(lA), o.exit("htmlTextData"), o.exit("htmlText"), i) : g(lA);
  }
  function pA(lA) {
    return o.exit("htmlTextData"), o.enter("lineEnding"), o.consume(lA), o.exit("lineEnding"), mA;
  }
  function mA(lA) {
    return markdownSpace(lA) ? factorySpace(o, XA, "linePrefix", E.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(lA) : XA(lA);
  }
  function XA(lA) {
    return o.enter("htmlTextData"), n(lA);
  }
}
const labelEnd = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
}, resourceConstruct = {
  tokenize: tokenizeResource
}, referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
}, referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(o) {
  let i = -1;
  const g = [];
  for (; ++i < o.length; ) {
    const E = o[i][1];
    if (g.push(o[i]), E.type === "labelImage" || E.type === "labelLink" || E.type === "labelEnd") {
      const e = E.type === "labelImage" ? 4 : 2;
      E.type = "data", i += e;
    }
  }
  return o.length !== g.length && splice(o, 0, o.length, g), o;
}
function resolveToLabelEnd(o, i) {
  let g = o.length, E = 0, e, t, n, h;
  for (; g--; )
    if (e = o[g][1], t) {
      if (e.type === "link" || e.type === "labelLink" && e._inactive)
        break;
      o[g][0] === "enter" && e.type === "labelLink" && (e._inactive = !0);
    } else if (n) {
      if (o[g][0] === "enter" && (e.type === "labelImage" || e.type === "labelLink") && !e._balanced && (t = g, e.type !== "labelLink")) {
        E = 2;
        break;
      }
    } else e.type === "labelEnd" && (n = g);
  const d = {
    type: o[t][1].type === "labelLink" ? "link" : "image",
    start: {
      ...o[t][1].start
    },
    end: {
      ...o[o.length - 1][1].end
    }
  }, k = {
    type: "label",
    start: {
      ...o[t][1].start
    },
    end: {
      ...o[n][1].end
    }
  }, p = {
    type: "labelText",
    start: {
      ...o[t + E + 2][1].end
    },
    end: {
      ...o[n - 2][1].start
    }
  };
  return h = [["enter", d, i], ["enter", k, i]], h = push(h, o.slice(t + 1, t + E + 3)), h = push(h, [["enter", p, i]]), h = push(h, resolveAll(i.parser.constructs.insideSpan.null, o.slice(t + E + 4, n - 3), i)), h = push(h, [["exit", p, i], o[n - 2], o[n - 1], ["exit", k, i]]), h = push(h, o.slice(n + 1)), h = push(h, [["exit", d, i]]), splice(o, t, o.length, h), o;
}
function tokenizeLabelEnd(o, i, g) {
  const E = this;
  let e = E.events.length, t, n;
  for (; e--; )
    if ((E.events[e][1].type === "labelImage" || E.events[e][1].type === "labelLink") && !E.events[e][1]._balanced) {
      t = E.events[e][1];
      break;
    }
  return h;
  function h(H) {
    return t ? t._inactive ? M(H) : (n = E.parser.defined.includes(normalizeIdentifier(E.sliceSerialize({
      start: t.end,
      end: E.now()
    }))), o.enter("labelEnd"), o.enter("labelMarker"), o.consume(H), o.exit("labelMarker"), o.exit("labelEnd"), d) : g(H);
  }
  function d(H) {
    return H === 40 ? o.attempt(resourceConstruct, p, n ? p : M)(H) : H === 91 ? o.attempt(referenceFullConstruct, p, n ? k : M)(H) : n ? p(H) : M(H);
  }
  function k(H) {
    return o.attempt(referenceCollapsedConstruct, p, M)(H);
  }
  function p(H) {
    return i(H);
  }
  function M(H) {
    return t._balanced = !0, g(H);
  }
}
function tokenizeResource(o, i, g) {
  return E;
  function E(M) {
    return o.enter("resource"), o.enter("resourceMarker"), o.consume(M), o.exit("resourceMarker"), e;
  }
  function e(M) {
    return markdownLineEndingOrSpace(M) ? factoryWhitespace(o, t)(M) : t(M);
  }
  function t(M) {
    return M === 41 ? p(M) : factoryDestination(o, n, h, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(M);
  }
  function n(M) {
    return markdownLineEndingOrSpace(M) ? factoryWhitespace(o, d)(M) : p(M);
  }
  function h(M) {
    return g(M);
  }
  function d(M) {
    return M === 34 || M === 39 || M === 40 ? factoryTitle(o, k, g, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(M) : p(M);
  }
  function k(M) {
    return markdownLineEndingOrSpace(M) ? factoryWhitespace(o, p)(M) : p(M);
  }
  function p(M) {
    return M === 41 ? (o.enter("resourceMarker"), o.consume(M), o.exit("resourceMarker"), o.exit("resource"), i) : g(M);
  }
}
function tokenizeReferenceFull(o, i, g) {
  const E = this;
  return e;
  function e(h) {
    return factoryLabel$1.call(E, o, t, n, "reference", "referenceMarker", "referenceString")(h);
  }
  function t(h) {
    return E.parser.defined.includes(normalizeIdentifier(E.sliceSerialize(E.events[E.events.length - 1][1]).slice(1, -1))) ? i(h) : g(h);
  }
  function n(h) {
    return g(h);
  }
}
function tokenizeReferenceCollapsed(o, i, g) {
  return E;
  function E(t) {
    return o.enter("reference"), o.enter("referenceMarker"), o.consume(t), o.exit("referenceMarker"), e;
  }
  function e(t) {
    return t === 93 ? (o.enter("referenceMarker"), o.consume(t), o.exit("referenceMarker"), o.exit("reference"), i) : g(t);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(o, i, g) {
  const E = this;
  return e;
  function e(h) {
    return o.enter("labelImage"), o.enter("labelImageMarker"), o.consume(h), o.exit("labelImageMarker"), t;
  }
  function t(h) {
    return h === 91 ? (o.enter("labelMarker"), o.consume(h), o.exit("labelMarker"), o.exit("labelImage"), n) : g(h);
  }
  function n(h) {
    return h === 94 && "_hiddenFootnoteSupport" in E.parser.constructs ? g(h) : i(h);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return o.enter("labelLink"), o.enter("labelMarker"), o.consume(n), o.exit("labelMarker"), o.exit("labelLink"), t;
  }
  function t(n) {
    return n === 94 && "_hiddenFootnoteSupport" in E.parser.constructs ? g(n) : i(n);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(o, i) {
  return g;
  function g(E) {
    return o.enter("lineEnding"), o.consume(E), o.exit("lineEnding"), factorySpace(o, i, "linePrefix");
  }
}
const thematicBreak$2 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(o, i, g) {
  let E = 0, e;
  return t;
  function t(k) {
    return o.enter("thematicBreak"), n(k);
  }
  function n(k) {
    return e = k, h(k);
  }
  function h(k) {
    return k === e ? (o.enter("thematicBreakSequence"), d(k)) : E >= 3 && (k === null || markdownLineEnding(k)) ? (o.exit("thematicBreak"), i(k)) : g(k);
  }
  function d(k) {
    return k === e ? (o.consume(k), E++, d) : (o.exit("thematicBreakSequence"), markdownSpace(k) ? factorySpace(o, h, "whitespace")(k) : h(k));
  }
}
const list$2 = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: "list",
  tokenize: tokenizeListStart
}, listItemPrefixWhitespaceConstruct = {
  partial: !0,
  tokenize: tokenizeListItemPrefixWhitespace
}, indentConstruct = {
  partial: !0,
  tokenize: tokenizeIndent$1
};
function tokenizeListStart(o, i, g) {
  const E = this, e = E.events[E.events.length - 1];
  let t = e && e[1].type === "linePrefix" ? e[2].sliceSerialize(e[1], !0).length : 0, n = 0;
  return h;
  function h(f) {
    const AA = E.containerState.type || (f === 42 || f === 43 || f === 45 ? "listUnordered" : "listOrdered");
    if (AA === "listUnordered" ? !E.containerState.marker || f === E.containerState.marker : asciiDigit(f)) {
      if (E.containerState.type || (E.containerState.type = AA, o.enter(AA, {
        _container: !0
      })), AA === "listUnordered")
        return o.enter("listItemPrefix"), f === 42 || f === 45 ? o.check(thematicBreak$2, g, k)(f) : k(f);
      if (!E.interrupt || f === 49)
        return o.enter("listItemPrefix"), o.enter("listItemValue"), d(f);
    }
    return g(f);
  }
  function d(f) {
    return asciiDigit(f) && ++n < 10 ? (o.consume(f), d) : (!E.interrupt || n < 2) && (E.containerState.marker ? f === E.containerState.marker : f === 41 || f === 46) ? (o.exit("listItemValue"), k(f)) : g(f);
  }
  function k(f) {
    return o.enter("listItemMarker"), o.consume(f), o.exit("listItemMarker"), E.containerState.marker = E.containerState.marker || f, o.check(
      blankLine,
      // Can’t be empty when interrupting.
      E.interrupt ? g : p,
      o.attempt(listItemPrefixWhitespaceConstruct, H, M)
    );
  }
  function p(f) {
    return E.containerState.initialBlankLine = !0, t++, H(f);
  }
  function M(f) {
    return markdownSpace(f) ? (o.enter("listItemPrefixWhitespace"), o.consume(f), o.exit("listItemPrefixWhitespace"), H) : g(f);
  }
  function H(f) {
    return E.containerState.size = t + E.sliceSerialize(o.exit("listItemPrefix"), !0).length, i(f);
  }
}
function tokenizeListContinuation(o, i, g) {
  const E = this;
  return E.containerState._closeFlow = void 0, o.check(blankLine, e, t);
  function e(h) {
    return E.containerState.furtherBlankLines = E.containerState.furtherBlankLines || E.containerState.initialBlankLine, factorySpace(o, i, "listItemIndent", E.containerState.size + 1)(h);
  }
  function t(h) {
    return E.containerState.furtherBlankLines || !markdownSpace(h) ? (E.containerState.furtherBlankLines = void 0, E.containerState.initialBlankLine = void 0, n(h)) : (E.containerState.furtherBlankLines = void 0, E.containerState.initialBlankLine = void 0, o.attempt(indentConstruct, i, n)(h));
  }
  function n(h) {
    return E.containerState._closeFlow = !0, E.interrupt = void 0, factorySpace(o, o.attempt(list$2, i, g), "linePrefix", E.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(h);
  }
}
function tokenizeIndent$1(o, i, g) {
  const E = this;
  return factorySpace(o, e, "listItemIndent", E.containerState.size + 1);
  function e(t) {
    const n = E.events[E.events.length - 1];
    return n && n[1].type === "listItemIndent" && n[2].sliceSerialize(n[1], !0).length === E.containerState.size ? i(t) : g(t);
  }
}
function tokenizeListEnd(o) {
  o.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(o, i, g) {
  const E = this;
  return factorySpace(o, e, "listItemPrefixWhitespace", E.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function e(t) {
    const n = E.events[E.events.length - 1];
    return !markdownSpace(t) && n && n[1].type === "listItemPrefixWhitespace" ? i(t) : g(t);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(o, i) {
  let g = o.length, E, e, t;
  for (; g--; )
    if (o[g][0] === "enter") {
      if (o[g][1].type === "content") {
        E = g;
        break;
      }
      o[g][1].type === "paragraph" && (e = g);
    } else
      o[g][1].type === "content" && o.splice(g, 1), !t && o[g][1].type === "definition" && (t = g);
  const n = {
    type: "setextHeading",
    start: {
      ...o[E][1].start
    },
    end: {
      ...o[o.length - 1][1].end
    }
  };
  return o[e][1].type = "setextHeadingText", t ? (o.splice(e, 0, ["enter", n, i]), o.splice(t + 1, 0, ["exit", o[E][1], i]), o[E][1].end = {
    ...o[t][1].end
  }) : o[E][1] = n, o.push(["exit", n, i]), o;
}
function tokenizeSetextUnderline(o, i, g) {
  const E = this;
  let e;
  return t;
  function t(k) {
    let p = E.events.length, M;
    for (; p--; )
      if (E.events[p][1].type !== "lineEnding" && E.events[p][1].type !== "linePrefix" && E.events[p][1].type !== "content") {
        M = E.events[p][1].type === "paragraph";
        break;
      }
    return !E.parser.lazy[E.now().line] && (E.interrupt || M) ? (o.enter("setextHeadingLine"), e = k, n(k)) : g(k);
  }
  function n(k) {
    return o.enter("setextHeadingLineSequence"), h(k);
  }
  function h(k) {
    return k === e ? (o.consume(k), h) : (o.exit("setextHeadingLineSequence"), markdownSpace(k) ? factorySpace(o, d, "lineSuffix")(k) : d(k));
  }
  function d(k) {
    return k === null || markdownLineEnding(k) ? (o.exit("setextHeadingLine"), i(k)) : g(k);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(o) {
  const i = this, g = o.attempt(
    // Try to parse a blank line.
    blankLine,
    E,
    // Try to parse initial flow (essentially, only code).
    o.attempt(this.parser.constructs.flowInitial, e, factorySpace(o, o.attempt(this.parser.constructs.flow, e, o.attempt(content, e)), "linePrefix"))
  );
  return g;
  function E(t) {
    if (t === null) {
      o.consume(t);
      return;
    }
    return o.enter("lineEndingBlank"), o.consume(t), o.exit("lineEndingBlank"), i.currentConstruct = void 0, g;
  }
  function e(t) {
    if (t === null) {
      o.consume(t);
      return;
    }
    return o.enter("lineEnding"), o.consume(t), o.exit("lineEnding"), i.currentConstruct = void 0, g;
  }
}
const resolver = {
  resolveAll: createResolver()
}, string$1 = initializeFactory("string"), text$5 = initializeFactory("text");
function initializeFactory(o) {
  return {
    resolveAll: createResolver(o === "text" ? resolveAllLineSuffixes : void 0),
    tokenize: i
  };
  function i(g) {
    const E = this, e = this.parser.constructs[o], t = g.attempt(e, n, h);
    return n;
    function n(p) {
      return k(p) ? t(p) : h(p);
    }
    function h(p) {
      if (p === null) {
        g.consume(p);
        return;
      }
      return g.enter("data"), g.consume(p), d;
    }
    function d(p) {
      return k(p) ? (g.exit("data"), t(p)) : (g.consume(p), d);
    }
    function k(p) {
      if (p === null)
        return !0;
      const M = e[p];
      let H = -1;
      if (M)
        for (; ++H < M.length; ) {
          const f = M[H];
          if (!f.previous || f.previous.call(E, E.previous))
            return !0;
        }
      return !1;
    }
  }
}
function createResolver(o) {
  return i;
  function i(g, E) {
    let e = -1, t;
    for (; ++e <= g.length; )
      t === void 0 ? g[e] && g[e][1].type === "data" && (t = e, e++) : (!g[e] || g[e][1].type !== "data") && (e !== t + 2 && (g[t][1].end = g[e - 1][1].end, g.splice(t + 2, e - t - 2), e = t + 2), t = void 0);
    return o ? o(g, E) : g;
  }
}
function resolveAllLineSuffixes(o, i) {
  let g = 0;
  for (; ++g <= o.length; )
    if ((g === o.length || o[g][1].type === "lineEnding") && o[g - 1][1].type === "data") {
      const E = o[g - 1][1], e = i.sliceStream(E);
      let t = e.length, n = -1, h = 0, d;
      for (; t--; ) {
        const k = e[t];
        if (typeof k == "string") {
          for (n = k.length; k.charCodeAt(n - 1) === 32; )
            h++, n--;
          if (n) break;
          n = -1;
        } else if (k === -2)
          d = !0, h++;
        else if (k !== -1) {
          t++;
          break;
        }
      }
      if (i._contentTypeTextTrailing && g === o.length && (h = 0), h) {
        const k = {
          type: g === o.length || d || h < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: t ? n : E.start._bufferIndex + n,
            _index: E.start._index + t,
            line: E.end.line,
            column: E.end.column - h,
            offset: E.end.offset - h
          },
          end: {
            ...E.end
          }
        };
        E.end = {
          ...k.start
        }, E.start.offset === E.end.offset ? Object.assign(E, k) : (o.splice(g, 0, ["enter", k, i], ["exit", k, i]), g += 2);
      }
      g++;
    }
  return o;
}
const document$1 = {
  42: list$2,
  43: list$2,
  45: list$2,
  48: list$2,
  49: list$2,
  50: list$2,
  51: list$2,
  52: list$2,
  53: list$2,
  54: list$2,
  55: list$2,
  56: list$2,
  57: list$2,
  62: blockQuote
}, contentInitial = {
  91: definition$1
}, flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  32: codeIndented
}, flow = {
  35: headingAtx,
  42: thematicBreak$2,
  45: [setextUnderline, thematicBreak$2],
  60: htmlFlow,
  61: setextUnderline,
  95: thematicBreak$2,
  96: codeFenced,
  126: codeFenced
}, string = {
  38: characterReference,
  92: characterEscape
}, text$4 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  33: labelStartImage,
  38: characterReference,
  42: attention,
  60: [autolink, htmlText],
  91: labelStartLink,
  92: [hardBreakEscape, characterEscape],
  93: labelEnd,
  95: attention,
  96: codeText
}, insideSpan = {
  null: [attention, resolver]
}, attentionMarkers = {
  null: [42, 95]
}, disable = {
  null: []
}, defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string,
  text: text$4
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer(o, i, g) {
  let E = {
    _bufferIndex: -1,
    _index: 0,
    line: g && g.line || 1,
    column: g && g.column || 1,
    offset: g && g.offset || 0
  };
  const e = {}, t = [];
  let n = [], h = [];
  const d = {
    attempt: eA(EA),
    check: eA(oA),
    consume: CA,
    enter: QA,
    exit: iA,
    interrupt: eA(oA, {
      interrupt: !0
    })
  }, k = {
    code: null,
    containerState: {},
    defineSkip: gA,
    events: [],
    now: AA,
    parser: o,
    previous: null,
    sliceSerialize: H,
    sliceStream: f,
    write: M
  };
  let p = i.tokenize.call(k, d);
  return i.resolveAll && t.push(i), k;
  function M(aA) {
    return n = push(n, aA), IA(), n[n.length - 1] !== null ? [] : (GA(i, 0), k.events = resolveAll(t, k.events, k), k.events);
  }
  function H(aA, sA) {
    return serializeChunks(f(aA), sA);
  }
  function f(aA) {
    return sliceChunks(n, aA);
  }
  function AA() {
    const {
      _bufferIndex: aA,
      _index: sA,
      line: DA,
      column: rA,
      offset: nA
    } = E;
    return {
      _bufferIndex: aA,
      _index: sA,
      line: DA,
      column: rA,
      offset: nA
    };
  }
  function gA(aA) {
    e[aA.line] = aA.column, tA();
  }
  function IA() {
    let aA;
    for (; E._index < n.length; ) {
      const sA = n[E._index];
      if (typeof sA == "string")
        for (aA = E._index, E._bufferIndex < 0 && (E._bufferIndex = 0); E._index === aA && E._bufferIndex < sA.length; )
          BA(sA.charCodeAt(E._bufferIndex));
      else
        BA(sA);
    }
  }
  function BA(aA) {
    p = p(aA);
  }
  function CA(aA) {
    markdownLineEnding(aA) ? (E.line++, E.column = 1, E.offset += aA === -3 ? 2 : 1, tA()) : aA !== -1 && (E.column++, E.offset++), E._bufferIndex < 0 ? E._index++ : (E._bufferIndex++, E._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    n[E._index].length && (E._bufferIndex = -1, E._index++)), k.previous = aA;
  }
  function QA(aA, sA) {
    const DA = sA || {};
    return DA.type = aA, DA.start = AA(), k.events.push(["enter", DA, k]), h.push(DA), DA;
  }
  function iA(aA) {
    const sA = h.pop();
    return sA.end = AA(), k.events.push(["exit", sA, k]), sA;
  }
  function EA(aA, sA) {
    GA(aA, sA.from);
  }
  function oA(aA, sA) {
    sA.restore();
  }
  function eA(aA, sA) {
    return DA;
    function DA(rA, nA, NA) {
      let pA, mA, XA, lA;
      return Array.isArray(rA) ? (
        /* c8 ignore next 1 */
        ZA(rA)
      ) : "tokenize" in rA ? (
        // Looks like a construct.
        ZA([
          /** @type {Construct} */
          rA
        ])
      ) : kA(rA);
      function kA(dA) {
        return RA;
        function RA(KA) {
          const xA = KA !== null && dA[KA], MA = KA !== null && dA.null, OA = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(xA) ? xA : xA ? [xA] : [],
            ...Array.isArray(MA) ? MA : MA ? [MA] : []
          ];
          return ZA(OA)(KA);
        }
      }
      function ZA(dA) {
        return pA = dA, mA = 0, dA.length === 0 ? NA : wA(dA[mA]);
      }
      function wA(dA) {
        return RA;
        function RA(KA) {
          return lA = cA(), XA = dA, dA.partial || (k.currentConstruct = dA), dA.name && k.parser.constructs.disable.null.includes(dA.name) ? fA() : dA.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            sA ? Object.assign(Object.create(k), sA) : k,
            d,
            LA,
            fA
          )(KA);
        }
      }
      function LA(dA) {
        return aA(XA, lA), nA;
      }
      function fA(dA) {
        return lA.restore(), ++mA < pA.length ? wA(pA[mA]) : NA;
      }
    }
  }
  function GA(aA, sA) {
    aA.resolveAll && !t.includes(aA) && t.push(aA), aA.resolve && splice(k.events, sA, k.events.length - sA, aA.resolve(k.events.slice(sA), k)), aA.resolveTo && (k.events = aA.resolveTo(k.events, k));
  }
  function cA() {
    const aA = AA(), sA = k.previous, DA = k.currentConstruct, rA = k.events.length, nA = Array.from(h);
    return {
      from: rA,
      restore: NA
    };
    function NA() {
      E = aA, k.previous = sA, k.currentConstruct = DA, k.events.length = rA, h = nA, tA();
    }
  }
  function tA() {
    E.line in e && E.column < 2 && (E.column = e[E.line], E.offset += e[E.line] - 1);
  }
}
function sliceChunks(o, i) {
  const g = i.start._index, E = i.start._bufferIndex, e = i.end._index, t = i.end._bufferIndex;
  let n;
  if (g === e)
    n = [o[g].slice(E, t)];
  else {
    if (n = o.slice(g, e), E > -1) {
      const h = n[0];
      typeof h == "string" ? n[0] = h.slice(E) : n.shift();
    }
    t > 0 && n.push(o[e].slice(0, t));
  }
  return n;
}
function serializeChunks(o, i) {
  let g = -1;
  const E = [];
  let e;
  for (; ++g < o.length; ) {
    const t = o[g];
    let n;
    if (typeof t == "string")
      n = t;
    else switch (t) {
      case -5: {
        n = "\r";
        break;
      }
      case -4: {
        n = `
`;
        break;
      }
      case -3: {
        n = `\r
`;
        break;
      }
      case -2: {
        n = i ? " " : "	";
        break;
      }
      case -1: {
        if (!i && e) continue;
        n = " ";
        break;
      }
      default:
        n = String.fromCharCode(t);
    }
    e = t === -2, E.push(n);
  }
  return E.join("");
}
function parse(o) {
  const E = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      combineExtensions([defaultConstructs, ...(o || {}).extensions || []])
    ),
    content: e(content$1),
    defined: [],
    document: e(document$2),
    flow: e(flow$1),
    lazy: {},
    string: e(string$1),
    text: e(text$5)
  };
  return E;
  function e(t) {
    return n;
    function n(h) {
      return createTokenizer(E, t, h);
    }
  }
}
function postprocess(o) {
  for (; !subtokenize(o); )
    ;
  return o;
}
const search = /[\0\t\n\r]/g;
function preprocess() {
  let o = 1, i = "", g = !0, E;
  return e;
  function e(t, n, h) {
    const d = [];
    let k, p, M, H, f;
    for (t = i + (typeof t == "string" ? t.toString() : new TextDecoder(n || void 0).decode(t)), M = 0, i = "", g && (t.charCodeAt(0) === 65279 && M++, g = void 0); M < t.length; ) {
      if (search.lastIndex = M, k = search.exec(t), H = k && k.index !== void 0 ? k.index : t.length, f = t.charCodeAt(H), !k) {
        i = t.slice(M);
        break;
      }
      if (f === 10 && M === H && E)
        d.push(-3), E = void 0;
      else
        switch (E && (d.push(-5), E = void 0), M < H && (d.push(t.slice(M, H)), o += H - M), f) {
          case 0: {
            d.push(65533), o++;
            break;
          }
          case 9: {
            for (p = Math.ceil(o / 4) * 4, d.push(-2); o++ < p; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), o = 1;
            break;
          }
          default:
            E = !0, o = 1;
        }
      M = H + 1;
    }
    return h && (E && d.push(-5), i && d.push(i), d.push(null)), d;
  }
}
const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function decodeString(o) {
  return o.replace(characterEscapeOrReference, decode);
}
function decode(o, i, g) {
  if (i)
    return i;
  if (g.charCodeAt(0) === 35) {
    const e = g.charCodeAt(1), t = e === 120 || e === 88;
    return decodeNumericCharacterReference(g.slice(t ? 2 : 1), t ? 16 : 10);
  }
  return decodeNamedCharacterReference(g) || o;
}
const own$3 = {}.hasOwnProperty;
function fromMarkdown(o, i, g) {
  return typeof i != "string" && (g = i, i = void 0), compiler(g)(postprocess(parse(g).document().write(preprocess()(o, i, !0))));
}
function compiler(o) {
  const i = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: t(Ig),
      autolinkProtocol: cA,
      autolinkEmail: cA,
      atxHeading: t(eg),
      blockQuote: t(MA),
      characterEscape: cA,
      characterReference: cA,
      codeFenced: t(OA),
      codeFencedFenceInfo: n,
      codeFencedFenceMeta: n,
      codeIndented: t(OA, n),
      codeText: t(SA, n),
      codeTextData: cA,
      data: cA,
      codeFlowValue: cA,
      definition: t(gg),
      definitionDestinationString: n,
      definitionLabelString: n,
      definitionTitleString: n,
      emphasis: t(WA),
      hardBreakEscape: t(ig),
      hardBreakTrailing: t(ig),
      htmlFlow: t($A, n),
      htmlFlowData: cA,
      htmlText: t($A, n),
      htmlTextData: cA,
      image: t(ag),
      label: n,
      link: t(Ig),
      listItem: t(wg),
      listItemValue: H,
      listOrdered: t(tg, M),
      listUnordered: t(tg),
      paragraph: t(hg),
      reference: wA,
      referenceString: n,
      resourceDestinationString: n,
      resourceTitleString: n,
      setextHeading: t(eg),
      strong: t(Gg),
      thematicBreak: t(Bg)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: EA,
      autolink: d(),
      autolinkEmail: xA,
      autolinkProtocol: KA,
      blockQuote: d(),
      characterEscapeValue: tA,
      characterReferenceMarkerHexadecimal: fA,
      characterReferenceMarkerNumeric: fA,
      characterReferenceValue: dA,
      characterReference: RA,
      codeFenced: d(IA),
      codeFencedFence: gA,
      codeFencedFenceInfo: f,
      codeFencedFenceMeta: AA,
      codeFlowValue: tA,
      codeIndented: d(BA),
      codeText: d(nA),
      codeTextData: tA,
      data: tA,
      definition: d(),
      definitionDestinationString: iA,
      definitionLabelString: CA,
      definitionTitleString: QA,
      emphasis: d(),
      hardBreakEscape: d(sA),
      hardBreakTrailing: d(sA),
      htmlFlow: d(DA),
      htmlFlowData: tA,
      htmlText: d(rA),
      htmlTextData: tA,
      image: d(pA),
      label: XA,
      labelText: mA,
      lineEnding: aA,
      link: d(NA),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: LA,
      resourceDestinationString: lA,
      resourceTitleString: kA,
      resource: ZA,
      setextHeading: d(GA),
      setextHeadingLineSequence: eA,
      setextHeadingText: oA,
      strong: d(),
      thematicBreak: d()
    }
  };
  configure(i, (o || {}).mdastExtensions || []);
  const g = {};
  return E;
  function E(bA) {
    let HA = {
      type: "root",
      children: []
    };
    const vA = {
      stack: [HA],
      tokenStack: [],
      config: i,
      enter: h,
      exit: k,
      buffer: n,
      resume: p,
      data: g
    }, zA = [];
    let PA = -1;
    for (; ++PA < bA.length; )
      if (bA[PA][1].type === "listOrdered" || bA[PA][1].type === "listUnordered")
        if (bA[PA][0] === "enter")
          zA.push(PA);
        else {
          const qA = zA.pop();
          PA = e(bA, qA, PA);
        }
    for (PA = -1; ++PA < bA.length; ) {
      const qA = i[bA[PA][0]];
      own$3.call(qA, bA[PA][1].type) && qA[bA[PA][1].type].call(Object.assign({
        sliceSerialize: bA[PA][2].sliceSerialize
      }, vA), bA[PA][1]);
    }
    if (vA.tokenStack.length > 0) {
      const qA = vA.tokenStack[vA.tokenStack.length - 1];
      (qA[1] || defaultOnError).call(vA, void 0, qA[0]);
    }
    for (HA.position = {
      start: point(bA.length > 0 ? bA[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point(bA.length > 0 ? bA[bA.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, PA = -1; ++PA < i.transforms.length; )
      HA = i.transforms[PA](HA) || HA;
    return HA;
  }
  function e(bA, HA, vA) {
    let zA = HA - 1, PA = -1, qA = !1, _A, VA, yA, FA;
    for (; ++zA <= vA; ) {
      const uA = bA[zA];
      switch (uA[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          uA[0] === "enter" ? PA++ : PA--, FA = void 0;
          break;
        }
        case "lineEndingBlank": {
          uA[0] === "enter" && (_A && !FA && !PA && !yA && (yA = zA), FA = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          FA = void 0;
      }
      if (!PA && uA[0] === "enter" && uA[1].type === "listItemPrefix" || PA === -1 && uA[0] === "exit" && (uA[1].type === "listUnordered" || uA[1].type === "listOrdered")) {
        if (_A) {
          let JA = zA;
          for (VA = void 0; JA--; ) {
            const YA = bA[JA];
            if (YA[1].type === "lineEnding" || YA[1].type === "lineEndingBlank") {
              if (YA[0] === "exit") continue;
              VA && (bA[VA][1].type = "lineEndingBlank", qA = !0), YA[1].type = "lineEnding", VA = JA;
            } else if (!(YA[1].type === "linePrefix" || YA[1].type === "blockQuotePrefix" || YA[1].type === "blockQuotePrefixWhitespace" || YA[1].type === "blockQuoteMarker" || YA[1].type === "listItemIndent")) break;
          }
          yA && (!VA || yA < VA) && (_A._spread = !0), _A.end = Object.assign({}, VA ? bA[VA][1].start : uA[1].end), bA.splice(VA || zA, 0, ["exit", _A, uA[2]]), zA++, vA++;
        }
        if (uA[1].type === "listItemPrefix") {
          const JA = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, uA[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          _A = JA, bA.splice(zA, 0, ["enter", JA, uA[2]]), zA++, vA++, yA = void 0, FA = !0;
        }
      }
    }
    return bA[HA][1]._spread = qA, vA;
  }
  function t(bA, HA) {
    return vA;
    function vA(zA) {
      h.call(this, bA(zA), zA), HA && HA.call(this, zA);
    }
  }
  function n() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function h(bA, HA, vA) {
    this.stack[this.stack.length - 1].children.push(bA), this.stack.push(bA), this.tokenStack.push([HA, vA || void 0]), bA.position = {
      start: point(HA.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(bA) {
    return HA;
    function HA(vA) {
      bA && bA.call(this, vA), k.call(this, vA);
    }
  }
  function k(bA, HA) {
    const vA = this.stack.pop(), zA = this.tokenStack.pop();
    if (zA)
      zA[0].type !== bA.type && (HA ? HA.call(this, bA, zA[0]) : (zA[1] || defaultOnError).call(this, bA, zA[0]));
    else throw new Error("Cannot close `" + bA.type + "` (" + stringifyPosition({
      start: bA.start,
      end: bA.end
    }) + "): it’s not open");
    vA.position.end = point(bA.end);
  }
  function p() {
    return toString$2(this.stack.pop());
  }
  function M() {
    this.data.expectingFirstListItemValue = !0;
  }
  function H(bA) {
    if (this.data.expectingFirstListItemValue) {
      const HA = this.stack[this.stack.length - 2];
      HA.start = Number.parseInt(this.sliceSerialize(bA), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function f() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.lang = bA;
  }
  function AA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.meta = bA;
  }
  function gA() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function IA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.value = bA.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function BA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.value = bA.replace(/(\r?\n|\r)$/g, "");
  }
  function CA(bA) {
    const HA = this.resume(), vA = this.stack[this.stack.length - 1];
    vA.label = HA, vA.identifier = normalizeIdentifier(this.sliceSerialize(bA)).toLowerCase();
  }
  function QA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.title = bA;
  }
  function iA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.url = bA;
  }
  function EA(bA) {
    const HA = this.stack[this.stack.length - 1];
    if (!HA.depth) {
      const vA = this.sliceSerialize(bA).length;
      HA.depth = vA;
    }
  }
  function oA() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function eA(bA) {
    const HA = this.stack[this.stack.length - 1];
    HA.depth = this.sliceSerialize(bA).codePointAt(0) === 61 ? 1 : 2;
  }
  function GA() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function cA(bA) {
    const vA = this.stack[this.stack.length - 1].children;
    let zA = vA[vA.length - 1];
    (!zA || zA.type !== "text") && (zA = Ng(), zA.position = {
      start: point(bA.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, vA.push(zA)), this.stack.push(zA);
  }
  function tA(bA) {
    const HA = this.stack.pop();
    HA.value += this.sliceSerialize(bA), HA.position.end = point(bA.end);
  }
  function aA(bA) {
    const HA = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const vA = HA.children[HA.children.length - 1];
      vA.position.end = point(bA.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && i.canContainEols.includes(HA.type) && (cA.call(this, bA), tA.call(this, bA));
  }
  function sA() {
    this.data.atHardBreak = !0;
  }
  function DA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.value = bA;
  }
  function rA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.value = bA;
  }
  function nA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.value = bA;
  }
  function NA() {
    const bA = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const HA = this.data.referenceType || "shortcut";
      bA.type += "Reference", bA.referenceType = HA, delete bA.url, delete bA.title;
    } else
      delete bA.identifier, delete bA.label;
    this.data.referenceType = void 0;
  }
  function pA() {
    const bA = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const HA = this.data.referenceType || "shortcut";
      bA.type += "Reference", bA.referenceType = HA, delete bA.url, delete bA.title;
    } else
      delete bA.identifier, delete bA.label;
    this.data.referenceType = void 0;
  }
  function mA(bA) {
    const HA = this.sliceSerialize(bA), vA = this.stack[this.stack.length - 2];
    vA.label = decodeString(HA), vA.identifier = normalizeIdentifier(HA).toLowerCase();
  }
  function XA() {
    const bA = this.stack[this.stack.length - 1], HA = this.resume(), vA = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, vA.type === "link") {
      const zA = bA.children;
      vA.children = zA;
    } else
      vA.alt = HA;
  }
  function lA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.url = bA;
  }
  function kA() {
    const bA = this.resume(), HA = this.stack[this.stack.length - 1];
    HA.title = bA;
  }
  function ZA() {
    this.data.inReference = void 0;
  }
  function wA() {
    this.data.referenceType = "collapsed";
  }
  function LA(bA) {
    const HA = this.resume(), vA = this.stack[this.stack.length - 1];
    vA.label = HA, vA.identifier = normalizeIdentifier(this.sliceSerialize(bA)).toLowerCase(), this.data.referenceType = "full";
  }
  function fA(bA) {
    this.data.characterReferenceType = bA.type;
  }
  function dA(bA) {
    const HA = this.sliceSerialize(bA), vA = this.data.characterReferenceType;
    let zA;
    vA ? (zA = decodeNumericCharacterReference(HA, vA === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : zA = decodeNamedCharacterReference(HA);
    const PA = this.stack[this.stack.length - 1];
    PA.value += zA;
  }
  function RA(bA) {
    const HA = this.stack.pop();
    HA.position.end = point(bA.end);
  }
  function KA(bA) {
    tA.call(this, bA);
    const HA = this.stack[this.stack.length - 1];
    HA.url = this.sliceSerialize(bA);
  }
  function xA(bA) {
    tA.call(this, bA);
    const HA = this.stack[this.stack.length - 1];
    HA.url = "mailto:" + this.sliceSerialize(bA);
  }
  function MA() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function OA() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function SA() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function gg() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function WA() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function eg() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ig() {
    return {
      type: "break"
    };
  }
  function $A() {
    return {
      type: "html",
      value: ""
    };
  }
  function ag() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ig() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function tg(bA) {
    return {
      type: "list",
      ordered: bA.type === "listOrdered",
      start: null,
      spread: bA._spread,
      children: []
    };
  }
  function wg(bA) {
    return {
      type: "listItem",
      spread: bA._spread,
      checked: null,
      children: []
    };
  }
  function hg() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Gg() {
    return {
      type: "strong",
      children: []
    };
  }
  function Ng() {
    return {
      type: "text",
      value: ""
    };
  }
  function Bg() {
    return {
      type: "thematicBreak"
    };
  }
}
function point(o) {
  return {
    line: o.line,
    column: o.column,
    offset: o.offset
  };
}
function configure(o, i) {
  let g = -1;
  for (; ++g < i.length; ) {
    const E = i[g];
    Array.isArray(E) ? configure(o, E) : extension(o, E);
  }
}
function extension(o, i) {
  let g;
  for (g in i)
    if (own$3.call(i, g))
      switch (g) {
        case "canContainEols": {
          const E = i[g];
          E && o[g].push(...E);
          break;
        }
        case "transforms": {
          const E = i[g];
          E && o[g].push(...E);
          break;
        }
        case "enter":
        case "exit": {
          const E = i[g];
          E && Object.assign(o[g], E);
          break;
        }
      }
}
function defaultOnError(o, i) {
  throw o ? new Error("Cannot close `" + o.type + "` (" + stringifyPosition({
    start: o.start,
    end: o.end
  }) + "): a different token (`" + i.type + "`, " + stringifyPosition({
    start: i.start,
    end: i.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + i.type + "`, " + stringifyPosition({
    start: i.start,
    end: i.end
  }) + ") is still open");
}
function remarkParse(o) {
  const i = this;
  i.parser = g;
  function g(E) {
    return fromMarkdown(E, {
      ...i.data("settings"),
      ...o,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: i.data("micromarkExtensions") || [],
      mdastExtensions: i.data("fromMarkdownExtensions") || []
    });
  }
}
function blockquote$1(o, i) {
  const g = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: o.wrap(o.all(i), !0)
  };
  return o.patch(i, g), o.applyData(i, g);
}
function hardBreak$1(o, i) {
  const g = { type: "element", tagName: "br", properties: {}, children: [] };
  return o.patch(i, g), [o.applyData(i, g), { type: "text", value: `
` }];
}
function code$3(o, i) {
  const g = i.value ? i.value + `
` : "", E = {};
  i.lang && (E.className = ["language-" + i.lang]);
  let e = {
    type: "element",
    tagName: "code",
    properties: E,
    children: [{ type: "text", value: g }]
  };
  return i.meta && (e.data = { meta: i.meta }), o.patch(i, e), e = o.applyData(i, e), e = { type: "element", tagName: "pre", properties: {}, children: [e] }, o.patch(i, e), e;
}
function strikethrough(o, i) {
  const g = {
    type: "element",
    tagName: "del",
    properties: {},
    children: o.all(i)
  };
  return o.patch(i, g), o.applyData(i, g);
}
function emphasis$1(o, i) {
  const g = {
    type: "element",
    tagName: "em",
    properties: {},
    children: o.all(i)
  };
  return o.patch(i, g), o.applyData(i, g);
}
function footnoteReference$1(o, i) {
  const g = typeof o.options.clobberPrefix == "string" ? o.options.clobberPrefix : "user-content-", E = String(i.identifier).toUpperCase(), e = normalizeUri(E.toLowerCase()), t = o.footnoteOrder.indexOf(E);
  let n, h = o.footnoteCounts.get(E);
  h === void 0 ? (h = 0, o.footnoteOrder.push(E), n = o.footnoteOrder.length) : n = t + 1, h += 1, o.footnoteCounts.set(E, h);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + g + "fn-" + e,
      id: g + "fnref-" + e + (h > 1 ? "-" + h : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(n) }]
  };
  o.patch(i, d);
  const k = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return o.patch(i, k), o.applyData(i, k);
}
function heading$1(o, i) {
  const g = {
    type: "element",
    tagName: "h" + i.depth,
    properties: {},
    children: o.all(i)
  };
  return o.patch(i, g), o.applyData(i, g);
}
function html$1(o, i) {
  if (o.options.allowDangerousHtml) {
    const g = { type: "raw", value: i.value };
    return o.patch(i, g), o.applyData(i, g);
  }
}
function revert(o, i) {
  const g = i.referenceType;
  let E = "]";
  if (g === "collapsed" ? E += "[]" : g === "full" && (E += "[" + (i.label || i.identifier) + "]"), i.type === "imageReference")
    return [{ type: "text", value: "![" + i.alt + E }];
  const e = o.all(i), t = e[0];
  t && t.type === "text" ? t.value = "[" + t.value : e.unshift({ type: "text", value: "[" });
  const n = e[e.length - 1];
  return n && n.type === "text" ? n.value += E : e.push({ type: "text", value: E }), e;
}
function imageReference$1(o, i) {
  const g = String(i.identifier).toUpperCase(), E = o.definitionById.get(g);
  if (!E)
    return revert(o, i);
  const e = { src: normalizeUri(E.url || ""), alt: i.alt };
  E.title !== null && E.title !== void 0 && (e.title = E.title);
  const t = { type: "element", tagName: "img", properties: e, children: [] };
  return o.patch(i, t), o.applyData(i, t);
}
function image$1(o, i) {
  const g = { src: normalizeUri(i.url) };
  i.alt !== null && i.alt !== void 0 && (g.alt = i.alt), i.title !== null && i.title !== void 0 && (g.title = i.title);
  const E = { type: "element", tagName: "img", properties: g, children: [] };
  return o.patch(i, E), o.applyData(i, E);
}
function inlineCode$1(o, i) {
  const g = { type: "text", value: i.value.replace(/\r?\n|\r/g, " ") };
  o.patch(i, g);
  const E = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [g]
  };
  return o.patch(i, E), o.applyData(i, E);
}
function linkReference$1(o, i) {
  const g = String(i.identifier).toUpperCase(), E = o.definitionById.get(g);
  if (!E)
    return revert(o, i);
  const e = { href: normalizeUri(E.url || "") };
  E.title !== null && E.title !== void 0 && (e.title = E.title);
  const t = {
    type: "element",
    tagName: "a",
    properties: e,
    children: o.all(i)
  };
  return o.patch(i, t), o.applyData(i, t);
}
function link$1(o, i) {
  const g = { href: normalizeUri(i.url) };
  i.title !== null && i.title !== void 0 && (g.title = i.title);
  const E = {
    type: "element",
    tagName: "a",
    properties: g,
    children: o.all(i)
  };
  return o.patch(i, E), o.applyData(i, E);
}
function listItem$1(o, i, g) {
  const E = o.all(i), e = g ? listLoose(g) : listItemLoose(i), t = {}, n = [];
  if (typeof i.checked == "boolean") {
    const p = E[0];
    let M;
    p && p.type === "element" && p.tagName === "p" ? M = p : (M = { type: "element", tagName: "p", properties: {}, children: [] }, E.unshift(M)), M.children.length > 0 && M.children.unshift({ type: "text", value: " " }), M.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: i.checked, disabled: !0 },
      children: []
    }), t.className = ["task-list-item"];
  }
  let h = -1;
  for (; ++h < E.length; ) {
    const p = E[h];
    (e || h !== 0 || p.type !== "element" || p.tagName !== "p") && n.push({ type: "text", value: `
` }), p.type === "element" && p.tagName === "p" && !e ? n.push(...p.children) : n.push(p);
  }
  const d = E[E.length - 1];
  d && (e || d.type !== "element" || d.tagName !== "p") && n.push({ type: "text", value: `
` });
  const k = { type: "element", tagName: "li", properties: t, children: n };
  return o.patch(i, k), o.applyData(i, k);
}
function listLoose(o) {
  let i = !1;
  if (o.type === "list") {
    i = o.spread || !1;
    const g = o.children;
    let E = -1;
    for (; !i && ++E < g.length; )
      i = listItemLoose(g[E]);
  }
  return i;
}
function listItemLoose(o) {
  const i = o.spread;
  return i ?? o.children.length > 1;
}
function list$1(o, i) {
  const g = {}, E = o.all(i);
  let e = -1;
  for (typeof i.start == "number" && i.start !== 1 && (g.start = i.start); ++e < E.length; ) {
    const n = E[e];
    if (n.type === "element" && n.tagName === "li" && n.properties && Array.isArray(n.properties.className) && n.properties.className.includes("task-list-item")) {
      g.className = ["contains-task-list"];
      break;
    }
  }
  const t = {
    type: "element",
    tagName: i.ordered ? "ol" : "ul",
    properties: g,
    children: o.wrap(E, !0)
  };
  return o.patch(i, t), o.applyData(i, t);
}
function paragraph$1(o, i) {
  const g = {
    type: "element",
    tagName: "p",
    properties: {},
    children: o.all(i)
  };
  return o.patch(i, g), o.applyData(i, g);
}
function root$2(o, i) {
  const g = { type: "root", children: o.wrap(o.all(i)) };
  return o.patch(i, g), o.applyData(i, g);
}
function strong$1(o, i) {
  const g = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: o.all(i)
  };
  return o.patch(i, g), o.applyData(i, g);
}
function table(o, i) {
  const g = o.all(i), E = g.shift(), e = [];
  if (E) {
    const n = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: o.wrap([E], !0)
    };
    o.patch(i.children[0], n), e.push(n);
  }
  if (g.length > 0) {
    const n = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: o.wrap(g, !0)
    }, h = pointStart(i.children[1]), d = pointEnd(i.children[i.children.length - 1]);
    h && d && (n.position = { start: h, end: d }), e.push(n);
  }
  const t = {
    type: "element",
    tagName: "table",
    properties: {},
    children: o.wrap(e, !0)
  };
  return o.patch(i, t), o.applyData(i, t);
}
function tableRow(o, i, g) {
  const E = g ? g.children : void 0, t = (E ? E.indexOf(i) : 1) === 0 ? "th" : "td", n = g && g.type === "table" ? g.align : void 0, h = n ? n.length : i.children.length;
  let d = -1;
  const k = [];
  for (; ++d < h; ) {
    const M = i.children[d], H = {}, f = n ? n[d] : void 0;
    f && (H.align = f);
    let AA = { type: "element", tagName: t, properties: H, children: [] };
    M && (AA.children = o.all(M), o.patch(M, AA), AA = o.applyData(M, AA)), k.push(AA);
  }
  const p = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: o.wrap(k, !0)
  };
  return o.patch(i, p), o.applyData(i, p);
}
function tableCell(o, i) {
  const g = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: o.all(i)
  };
  return o.patch(i, g), o.applyData(i, g);
}
const tab = 9, space = 32;
function trimLines(o) {
  const i = String(o), g = /\r?\n|\r/g;
  let E = g.exec(i), e = 0;
  const t = [];
  for (; E; )
    t.push(
      trimLine(i.slice(e, E.index), e > 0, !0),
      E[0]
    ), e = E.index + E[0].length, E = g.exec(i);
  return t.push(trimLine(i.slice(e), e > 0, !1)), t.join("");
}
function trimLine(o, i, g) {
  let E = 0, e = o.length;
  if (i) {
    let t = o.codePointAt(E);
    for (; t === tab || t === space; )
      E++, t = o.codePointAt(E);
  }
  if (g) {
    let t = o.codePointAt(e - 1);
    for (; t === tab || t === space; )
      e--, t = o.codePointAt(e - 1);
  }
  return e > E ? o.slice(E, e) : "";
}
function text$3(o, i) {
  const g = { type: "text", value: trimLines(String(i.value)) };
  return o.patch(i, g), o.applyData(i, g);
}
function thematicBreak$1(o, i) {
  const g = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return o.patch(i, g), o.applyData(i, g);
}
const handlers = {
  blockquote: blockquote$1,
  break: hardBreak$1,
  code: code$3,
  delete: strikethrough,
  emphasis: emphasis$1,
  footnoteReference: footnoteReference$1,
  heading: heading$1,
  html: html$1,
  imageReference: imageReference$1,
  image: image$1,
  inlineCode: inlineCode$1,
  linkReference: linkReference$1,
  link: link$1,
  listItem: listItem$1,
  list: list$1,
  paragraph: paragraph$1,
  // @ts-expect-error: root is different, but hard to type.
  root: root$2,
  strong: strong$1,
  table,
  tableCell,
  tableRow,
  text: text$3,
  thematicBreak: thematicBreak$1,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
}
const VOID = -1, PRIMITIVE = 0, ARRAY = 1, OBJECT = 2, DATE = 3, REGEXP = 4, MAP = 5, SET = 6, ERROR = 7, BIGINT = 8, env = typeof self == "object" ? self : globalThis, deserializer = (o, i) => {
  const g = (e, t) => (o.set(t, e), e), E = (e) => {
    if (o.has(e))
      return o.get(e);
    const [t, n] = i[e];
    switch (t) {
      case PRIMITIVE:
      case VOID:
        return g(n, e);
      case ARRAY: {
        const h = g([], e);
        for (const d of n)
          h.push(E(d));
        return h;
      }
      case OBJECT: {
        const h = g({}, e);
        for (const [d, k] of n)
          h[E(d)] = E(k);
        return h;
      }
      case DATE:
        return g(new Date(n), e);
      case REGEXP: {
        const { source: h, flags: d } = n;
        return g(new RegExp(h, d), e);
      }
      case MAP: {
        const h = g(/* @__PURE__ */ new Map(), e);
        for (const [d, k] of n)
          h.set(E(d), E(k));
        return h;
      }
      case SET: {
        const h = g(/* @__PURE__ */ new Set(), e);
        for (const d of n)
          h.add(E(d));
        return h;
      }
      case ERROR: {
        const { name: h, message: d } = n;
        return g(new env[h](d), e);
      }
      case BIGINT:
        return g(BigInt(n), e);
      case "BigInt":
        return g(Object(BigInt(n)), e);
      case "ArrayBuffer":
        return g(new Uint8Array(n).buffer, n);
      case "DataView": {
        const { buffer: h } = new Uint8Array(n);
        return g(new DataView(h), n);
      }
    }
    return g(new env[t](n), e);
  };
  return E;
}, deserialize = (o) => deserializer(/* @__PURE__ */ new Map(), o)(0), EMPTY = "", { toString: toString$1 } = {}, { keys } = Object, typeOf = (o) => {
  const i = typeof o;
  if (i !== "object" || !o)
    return [PRIMITIVE, i];
  const g = toString$1.call(o).slice(8, -1);
  switch (g) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
    case "DataView":
      return [ARRAY, g];
  }
  return g.includes("Array") ? [ARRAY, g] : g.includes("Error") ? [ERROR, g] : [OBJECT, g];
}, shouldSkip = ([o, i]) => o === PRIMITIVE && (i === "function" || i === "symbol"), serializer = (o, i, g, E) => {
  const e = (n, h) => {
    const d = E.push(n) - 1;
    return g.set(h, d), d;
  }, t = (n) => {
    if (g.has(n))
      return g.get(n);
    let [h, d] = typeOf(n);
    switch (h) {
      case PRIMITIVE: {
        let p = n;
        switch (d) {
          case "bigint":
            h = BIGINT, p = n.toString();
            break;
          case "function":
          case "symbol":
            if (o)
              throw new TypeError("unable to serialize " + d);
            p = null;
            break;
          case "undefined":
            return e([VOID], n);
        }
        return e([h, p], n);
      }
      case ARRAY: {
        if (d) {
          let H = n;
          return d === "DataView" ? H = new Uint8Array(n.buffer) : d === "ArrayBuffer" && (H = new Uint8Array(n)), e([d, [...H]], n);
        }
        const p = [], M = e([h, p], n);
        for (const H of n)
          p.push(t(H));
        return M;
      }
      case OBJECT: {
        if (d)
          switch (d) {
            case "BigInt":
              return e([d, n.toString()], n);
            case "Boolean":
            case "Number":
            case "String":
              return e([d, n.valueOf()], n);
          }
        if (i && "toJSON" in n)
          return t(n.toJSON());
        const p = [], M = e([h, p], n);
        for (const H of keys(n))
          (o || !shouldSkip(typeOf(n[H]))) && p.push([t(H), t(n[H])]);
        return M;
      }
      case DATE:
        return e([h, n.toISOString()], n);
      case REGEXP: {
        const { source: p, flags: M } = n;
        return e([h, { source: p, flags: M }], n);
      }
      case MAP: {
        const p = [], M = e([h, p], n);
        for (const [H, f] of n)
          (o || !(shouldSkip(typeOf(H)) || shouldSkip(typeOf(f)))) && p.push([t(H), t(f)]);
        return M;
      }
      case SET: {
        const p = [], M = e([h, p], n);
        for (const H of n)
          (o || !shouldSkip(typeOf(H))) && p.push(t(H));
        return M;
      }
    }
    const { message: k } = n;
    return e([h, { name: d, message: k }], n);
  };
  return t;
}, serialize$1 = (o, { json: i, lossy: g } = {}) => {
  const E = [];
  return serializer(!(i || g), !!i, /* @__PURE__ */ new Map(), E)(o), E;
}, structuredClone$1 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (o, i) => i && ("json" in i || "lossy" in i) ? deserialize(serialize$1(o, i)) : structuredClone(o)
) : (o, i) => deserialize(serialize$1(o, i));
function defaultFootnoteBackContent(o, i) {
  const g = [{ type: "text", value: "↩" }];
  return i > 1 && g.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(i) }]
  }), g;
}
function defaultFootnoteBackLabel(o, i) {
  return "Back to reference " + (o + 1) + (i > 1 ? "-" + i : "");
}
function footer(o) {
  const i = typeof o.options.clobberPrefix == "string" ? o.options.clobberPrefix : "user-content-", g = o.options.footnoteBackContent || defaultFootnoteBackContent, E = o.options.footnoteBackLabel || defaultFootnoteBackLabel, e = o.options.footnoteLabel || "Footnotes", t = o.options.footnoteLabelTagName || "h2", n = o.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, h = [];
  let d = -1;
  for (; ++d < o.footnoteOrder.length; ) {
    const k = o.footnoteById.get(
      o.footnoteOrder[d]
    );
    if (!k)
      continue;
    const p = o.all(k), M = String(k.identifier).toUpperCase(), H = normalizeUri(M.toLowerCase());
    let f = 0;
    const AA = [], gA = o.footnoteCounts.get(M);
    for (; gA !== void 0 && ++f <= gA; ) {
      AA.length > 0 && AA.push({ type: "text", value: " " });
      let CA = typeof g == "string" ? g : g(d, f);
      typeof CA == "string" && (CA = { type: "text", value: CA }), AA.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + i + "fnref-" + H + (f > 1 ? "-" + f : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof E == "string" ? E : E(d, f),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(CA) ? CA : [CA]
      });
    }
    const IA = p[p.length - 1];
    if (IA && IA.type === "element" && IA.tagName === "p") {
      const CA = IA.children[IA.children.length - 1];
      CA && CA.type === "text" ? CA.value += " " : IA.children.push({ type: "text", value: " " }), IA.children.push(...AA);
    } else
      p.push(...AA);
    const BA = {
      type: "element",
      tagName: "li",
      properties: { id: i + "fn-" + H },
      children: o.wrap(p, !0)
    };
    o.patch(k, BA), h.push(BA);
  }
  if (h.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: t,
          properties: {
            ...structuredClone$1(n),
            id: "footnote-label"
          },
          children: [{ type: "text", value: e }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: o.wrap(h, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function visit$3(o, i, g, E) {
  let e, t, n;
  typeof i == "function" && typeof g != "function" ? (t = void 0, n = i, e = g) : (t = i, n = g, e = E), visitParents(o, t, h, e);
  function h(d, k) {
    const p = k[k.length - 1], M = p ? p.children.indexOf(d) : void 0;
    return n(d, M, p);
  }
}
const own$2 = {}.hasOwnProperty, emptyOptions$3 = {};
function createState(o, i) {
  const g = i || emptyOptions$3, E = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = { ...handlers, ...g.handlers }, h = {
    all: k,
    applyData,
    definitionById: E,
    footnoteById: e,
    footnoteCounts: t,
    footnoteOrder: [],
    handlers: n,
    one: d,
    options: g,
    patch,
    wrap: wrap$1
  };
  return visit$3(o, function(p) {
    if (p.type === "definition" || p.type === "footnoteDefinition") {
      const M = p.type === "definition" ? E : e, H = String(p.identifier).toUpperCase();
      M.has(H) || M.set(H, p);
    }
  }), h;
  function d(p, M) {
    const H = p.type, f = h.handlers[H];
    if (own$2.call(h.handlers, H) && f)
      return f(h, p, M);
    if (h.options.passThrough && h.options.passThrough.includes(H)) {
      if ("children" in p) {
        const { children: gA, ...IA } = p, BA = structuredClone$1(IA);
        return BA.children = h.all(p), BA;
      }
      return structuredClone$1(p);
    }
    return (h.options.unknownHandler || defaultUnknownHandler)(h, p, M);
  }
  function k(p) {
    const M = [];
    if ("children" in p) {
      const H = p.children;
      let f = -1;
      for (; ++f < H.length; ) {
        const AA = h.one(H[f], p);
        if (AA) {
          if (f && H[f - 1].type === "break" && (!Array.isArray(AA) && AA.type === "text" && (AA.value = trimMarkdownSpaceStart(AA.value)), !Array.isArray(AA) && AA.type === "element")) {
            const gA = AA.children[0];
            gA && gA.type === "text" && (gA.value = trimMarkdownSpaceStart(gA.value));
          }
          Array.isArray(AA) ? M.push(...AA) : M.push(AA);
        }
      }
    }
    return M;
  }
}
function patch(o, i) {
  o.position && (i.position = position$2(o));
}
function applyData(o, i) {
  let g = i;
  if (o && o.data) {
    const E = o.data.hName, e = o.data.hChildren, t = o.data.hProperties;
    if (typeof E == "string")
      if (g.type === "element")
        g.tagName = E;
      else {
        const n = "children" in g ? g.children : [g];
        g = { type: "element", tagName: E, properties: {}, children: n };
      }
    g.type === "element" && t && Object.assign(g.properties, structuredClone$1(t)), "children" in g && g.children && e !== null && e !== void 0 && (g.children = e);
  }
  return g;
}
function defaultUnknownHandler(o, i) {
  const g = i.data || {}, E = "value" in i && !(own$2.call(g, "hProperties") || own$2.call(g, "hChildren")) ? { type: "text", value: i.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: o.all(i)
  };
  return o.patch(i, E), o.applyData(i, E);
}
function wrap$1(o, i) {
  const g = [];
  let E = -1;
  for (i && g.push({ type: "text", value: `
` }); ++E < o.length; )
    E && g.push({ type: "text", value: `
` }), g.push(o[E]);
  return i && o.length > 0 && g.push({ type: "text", value: `
` }), g;
}
function trimMarkdownSpaceStart(o) {
  let i = 0, g = o.charCodeAt(i);
  for (; g === 9 || g === 32; )
    i++, g = o.charCodeAt(i);
  return o.slice(i);
}
function toHast(o, i) {
  const g = createState(o, i), E = g.one(o, void 0), e = footer(g), t = Array.isArray(E) ? { type: "root", children: E } : E || { type: "root", children: [] };
  return e && t.children.push({ type: "text", value: `
` }, e), t;
}
function remarkRehype(o, i) {
  return o && "run" in o ? async function(g, E) {
    const e = (
      /** @type {HastRoot} */
      toHast(g, { file: E, ...i })
    );
    await o.run(e, E);
  } : function(g, E) {
    return (
      /** @type {HastRoot} */
      toHast(g, { file: E, ...o || i })
    );
  };
}
function bail(o) {
  if (o)
    throw o;
}
var extend$1, hasRequiredExtend;
function requireExtend() {
  if (hasRequiredExtend) return extend$1;
  hasRequiredExtend = 1;
  var o = Object.prototype.hasOwnProperty, i = Object.prototype.toString, g = Object.defineProperty, E = Object.getOwnPropertyDescriptor, e = function(k) {
    return typeof Array.isArray == "function" ? Array.isArray(k) : i.call(k) === "[object Array]";
  }, t = function(k) {
    if (!k || i.call(k) !== "[object Object]")
      return !1;
    var p = o.call(k, "constructor"), M = k.constructor && k.constructor.prototype && o.call(k.constructor.prototype, "isPrototypeOf");
    if (k.constructor && !p && !M)
      return !1;
    var H;
    for (H in k)
      ;
    return typeof H > "u" || o.call(k, H);
  }, n = function(k, p) {
    g && p.name === "__proto__" ? g(k, p.name, {
      enumerable: !0,
      configurable: !0,
      value: p.newValue,
      writable: !0
    }) : k[p.name] = p.newValue;
  }, h = function(k, p) {
    if (p === "__proto__")
      if (o.call(k, p)) {
        if (E)
          return E(k, p).value;
      } else return;
    return k[p];
  };
  return extend$1 = function d() {
    var k, p, M, H, f, AA, gA = arguments[0], IA = 1, BA = arguments.length, CA = !1;
    for (typeof gA == "boolean" && (CA = gA, gA = arguments[1] || {}, IA = 2), (gA == null || typeof gA != "object" && typeof gA != "function") && (gA = {}); IA < BA; ++IA)
      if (k = arguments[IA], k != null)
        for (p in k)
          M = h(gA, p), H = h(k, p), gA !== H && (CA && H && (t(H) || (f = e(H))) ? (f ? (f = !1, AA = M && e(M) ? M : []) : AA = M && t(M) ? M : {}, n(gA, { name: p, newValue: d(CA, AA, H) })) : typeof H < "u" && n(gA, { name: p, newValue: H }));
    return gA;
  }, extend$1;
}
var extendExports = requireExtend();
const extend = /* @__PURE__ */ getDefaultExportFromCjs(extendExports);
function isPlainObject$1(o) {
  if (typeof o != "object" || o === null)
    return !1;
  const i = Object.getPrototypeOf(o);
  return (i === null || i === Object.prototype || Object.getPrototypeOf(i) === null) && !(Symbol.toStringTag in o) && !(Symbol.iterator in o);
}
function trough() {
  const o = [], i = { run: g, use: E };
  return i;
  function g(...e) {
    let t = -1;
    const n = e.pop();
    if (typeof n != "function")
      throw new TypeError("Expected function as last argument, not " + n);
    h(null, ...e);
    function h(d, ...k) {
      const p = o[++t];
      let M = -1;
      if (d) {
        n(d);
        return;
      }
      for (; ++M < e.length; )
        (k[M] === null || k[M] === void 0) && (k[M] = e[M]);
      e = k, p ? wrap(p, h)(...k) : n(null, ...k);
    }
  }
  function E(e) {
    if (typeof e != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + e
      );
    return o.push(e), i;
  }
}
function wrap(o, i) {
  let g;
  return E;
  function E(...n) {
    const h = o.length > n.length;
    let d;
    h && n.push(e);
    try {
      d = o.apply(this, n);
    } catch (k) {
      const p = (
        /** @type {Error} */
        k
      );
      if (h && g)
        throw p;
      return e(p);
    }
    h || (d && d.then && typeof d.then == "function" ? d.then(t, e) : d instanceof Error ? e(d) : t(d));
  }
  function e(n, ...h) {
    g || (g = !0, i(n, ...h));
  }
  function t(n) {
    e(null, n);
  }
}
const minpath = { basename, dirname, extname, join, sep: "/" };
function basename(o, i) {
  if (i !== void 0 && typeof i != "string")
    throw new TypeError('"ext" argument must be a string');
  assertPath$1(o);
  let g = 0, E = -1, e = o.length, t;
  if (i === void 0 || i.length === 0 || i.length > o.length) {
    for (; e--; )
      if (o.codePointAt(e) === 47) {
        if (t) {
          g = e + 1;
          break;
        }
      } else E < 0 && (t = !0, E = e + 1);
    return E < 0 ? "" : o.slice(g, E);
  }
  if (i === o)
    return "";
  let n = -1, h = i.length - 1;
  for (; e--; )
    if (o.codePointAt(e) === 47) {
      if (t) {
        g = e + 1;
        break;
      }
    } else
      n < 0 && (t = !0, n = e + 1), h > -1 && (o.codePointAt(e) === i.codePointAt(h--) ? h < 0 && (E = e) : (h = -1, E = n));
  return g === E ? E = n : E < 0 && (E = o.length), o.slice(g, E);
}
function dirname(o) {
  if (assertPath$1(o), o.length === 0)
    return ".";
  let i = -1, g = o.length, E;
  for (; --g; )
    if (o.codePointAt(g) === 47) {
      if (E) {
        i = g;
        break;
      }
    } else E || (E = !0);
  return i < 0 ? o.codePointAt(0) === 47 ? "/" : "." : i === 1 && o.codePointAt(0) === 47 ? "//" : o.slice(0, i);
}
function extname(o) {
  assertPath$1(o);
  let i = o.length, g = -1, E = 0, e = -1, t = 0, n;
  for (; i--; ) {
    const h = o.codePointAt(i);
    if (h === 47) {
      if (n) {
        E = i + 1;
        break;
      }
      continue;
    }
    g < 0 && (n = !0, g = i + 1), h === 46 ? e < 0 ? e = i : t !== 1 && (t = 1) : e > -1 && (t = -1);
  }
  return e < 0 || g < 0 || // We saw a non-dot character immediately before the dot.
  t === 0 || // The (right-most) trimmed path component is exactly `..`.
  t === 1 && e === g - 1 && e === E + 1 ? "" : o.slice(e, g);
}
function join(...o) {
  let i = -1, g;
  for (; ++i < o.length; )
    assertPath$1(o[i]), o[i] && (g = g === void 0 ? o[i] : g + "/" + o[i]);
  return g === void 0 ? "." : normalize(g);
}
function normalize(o) {
  assertPath$1(o);
  const i = o.codePointAt(0) === 47;
  let g = normalizeString(o, !i);
  return g.length === 0 && !i && (g = "."), g.length > 0 && o.codePointAt(o.length - 1) === 47 && (g += "/"), i ? "/" + g : g;
}
function normalizeString(o, i) {
  let g = "", E = 0, e = -1, t = 0, n = -1, h, d;
  for (; ++n <= o.length; ) {
    if (n < o.length)
      h = o.codePointAt(n);
    else {
      if (h === 47)
        break;
      h = 47;
    }
    if (h === 47) {
      if (!(e === n - 1 || t === 1)) if (e !== n - 1 && t === 2) {
        if (g.length < 2 || E !== 2 || g.codePointAt(g.length - 1) !== 46 || g.codePointAt(g.length - 2) !== 46) {
          if (g.length > 2) {
            if (d = g.lastIndexOf("/"), d !== g.length - 1) {
              d < 0 ? (g = "", E = 0) : (g = g.slice(0, d), E = g.length - 1 - g.lastIndexOf("/")), e = n, t = 0;
              continue;
            }
          } else if (g.length > 0) {
            g = "", E = 0, e = n, t = 0;
            continue;
          }
        }
        i && (g = g.length > 0 ? g + "/.." : "..", E = 2);
      } else
        g.length > 0 ? g += "/" + o.slice(e + 1, n) : g = o.slice(e + 1, n), E = n - e - 1;
      e = n, t = 0;
    } else h === 46 && t > -1 ? t++ : t = -1;
  }
  return g;
}
function assertPath$1(o) {
  if (typeof o != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(o)
    );
}
const minproc = { cwd };
function cwd() {
  return "/";
}
function isUrl(o) {
  return !!(o !== null && typeof o == "object" && "href" in o && o.href && "protocol" in o && o.protocol && // @ts-expect-error: indexing is fine.
  o.auth === void 0);
}
function urlToPath(o) {
  if (typeof o == "string")
    o = new URL(o);
  else if (!isUrl(o)) {
    const i = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + o + "`"
    );
    throw i.code = "ERR_INVALID_ARG_TYPE", i;
  }
  if (o.protocol !== "file:") {
    const i = new TypeError("The URL must be of scheme file");
    throw i.code = "ERR_INVALID_URL_SCHEME", i;
  }
  return getPathFromURLPosix(o);
}
function getPathFromURLPosix(o) {
  if (o.hostname !== "") {
    const E = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw E.code = "ERR_INVALID_FILE_URL_HOST", E;
  }
  const i = o.pathname;
  let g = -1;
  for (; ++g < i.length; )
    if (i.codePointAt(g) === 37 && i.codePointAt(g + 1) === 50) {
      const E = i.codePointAt(g + 2);
      if (E === 70 || E === 102) {
        const e = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw e.code = "ERR_INVALID_FILE_URL_PATH", e;
      }
    }
  return decodeURIComponent(i);
}
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(i) {
    let g;
    i ? isUrl(i) ? g = { path: i } : typeof i == "string" || isUint8Array$1(i) ? g = { value: i } : g = i : g = {}, this.cwd = "cwd" in g ? "" : minproc.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let E = -1;
    for (; ++E < order.length; ) {
      const t = order[E];
      t in g && g[t] !== void 0 && g[t] !== null && (this[t] = t === "history" ? [...g[t]] : g[t]);
    }
    let e;
    for (e in g)
      order.includes(e) || (this[e] = g[e]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(i) {
    assertNonEmpty(i, "basename"), assertPart(i, "basename"), this.path = minpath.join(this.dirname || "", i);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(i) {
    assertPath(this.basename, "dirname"), this.path = minpath.join(i || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(i) {
    if (assertPart(i, "extname"), assertPath(this.dirname, "extname"), i) {
      if (i.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (i.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = minpath.join(this.dirname, this.stem + (i || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(i) {
    isUrl(i) && (i = urlToPath(i)), assertNonEmpty(i, "path"), this.path !== i && this.history.push(i);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(i) {
    assertNonEmpty(i, "stem"), assertPart(i, "stem"), this.path = minpath.join(this.dirname || "", i + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(i, g, E) {
    const e = this.message(i, g, E);
    throw e.fatal = !0, e;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(i, g, E) {
    const e = this.message(i, g, E);
    return e.fatal = void 0, e;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(i, g, E) {
    const e = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      i,
      g,
      E
    );
    return this.path && (e.name = this.path + ":" + e.name, e.file = this.path), e.fatal = !1, this.messages.push(e), e;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(i) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(i || void 0).decode(this.value);
  }
}
function assertPart(o, i) {
  if (o && o.includes(minpath.sep))
    throw new Error(
      "`" + i + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
}
function assertNonEmpty(o, i) {
  if (!o)
    throw new Error("`" + i + "` cannot be empty");
}
function assertPath(o, i) {
  if (!o)
    throw new Error("Setting `" + i + "` requires `path` to be set too");
}
function isUint8Array$1(o) {
  return !!(o && typeof o == "object" && "byteLength" in o && "byteOffset" in o);
}
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(o) {
    const E = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), e = E[o], t = function() {
      return e.apply(t, arguments);
    };
    return Object.setPrototypeOf(t, E), t;
  })
), own$1 = {}.hasOwnProperty;
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const i = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor()
    );
    let g = -1;
    for (; ++g < this.attachers.length; ) {
      const E = this.attachers[g];
      i.use(...E);
    }
    return i.data(extend(!0, {}, this.namespace)), i;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(i, g) {
    return typeof i == "string" ? arguments.length === 2 ? (assertUnfrozen("data", this.frozen), this.namespace[i] = g, this) : own$1.call(this.namespace, i) && this.namespace[i] || void 0 : i ? (assertUnfrozen("data", this.frozen), this.namespace = i, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const i = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [g, ...E] = this.attachers[this.freezeIndex];
      if (E[0] === !1)
        continue;
      E[0] === !0 && (E[0] = void 0);
      const e = g.call(i, ...E);
      typeof e == "function" && this.transformers.use(e);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(i) {
    this.freeze();
    const g = vfile(i), E = this.parser || this.Parser;
    return assertParser("parse", E), E(String(g), g);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(i, g) {
    const E = this;
    return this.freeze(), assertParser("process", this.parser || this.Parser), assertCompiler("process", this.compiler || this.Compiler), g ? e(void 0, g) : new Promise(e);
    function e(t, n) {
      const h = vfile(i), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        E.parse(h)
      );
      E.run(d, h, function(p, M, H) {
        if (p || !M || !H)
          return k(p);
        const f = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          M
        ), AA = E.stringify(f, H);
        looksLikeAValue(AA) ? H.value = AA : H.result = AA, k(
          p,
          /** @type {VFileWithOutput<CompileResult>} */
          H
        );
      });
      function k(p, M) {
        p || !M ? n(p) : t ? t(M) : g(void 0, M);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(i) {
    let g = !1, E;
    return this.freeze(), assertParser("processSync", this.parser || this.Parser), assertCompiler("processSync", this.compiler || this.Compiler), this.process(i, e), assertDone("processSync", "process", g), E;
    function e(t, n) {
      g = !0, bail(t), E = n;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(i, g, E) {
    assertNode(i), this.freeze();
    const e = this.transformers;
    return !E && typeof g == "function" && (E = g, g = void 0), E ? t(void 0, E) : new Promise(t);
    function t(n, h) {
      const d = vfile(g);
      e.run(i, d, k);
      function k(p, M, H) {
        const f = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          M || i
        );
        p ? h(p) : n ? n(f) : E(void 0, f, H);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(i, g) {
    let E = !1, e;
    return this.run(i, g, t), assertDone("runSync", "run", E), e;
    function t(n, h) {
      bail(n), e = h, E = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(i, g) {
    this.freeze();
    const E = vfile(g), e = this.compiler || this.Compiler;
    return assertCompiler("stringify", e), assertNode(i), e(i, E);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(i, ...g) {
    const E = this.attachers, e = this.namespace;
    if (assertUnfrozen("use", this.frozen), i != null) if (typeof i == "function")
      d(i, g);
    else if (typeof i == "object")
      Array.isArray(i) ? h(i) : n(i);
    else
      throw new TypeError("Expected usable value, not `" + i + "`");
    return this;
    function t(k) {
      if (typeof k == "function")
        d(k, []);
      else if (typeof k == "object")
        if (Array.isArray(k)) {
          const [p, ...M] = (
            /** @type {PluginTuple<Array<unknown>>} */
            k
          );
          d(p, M);
        } else
          n(k);
      else
        throw new TypeError("Expected usable value, not `" + k + "`");
    }
    function n(k) {
      if (!("plugins" in k) && !("settings" in k))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      h(k.plugins), k.settings && (e.settings = extend(!0, e.settings, k.settings));
    }
    function h(k) {
      let p = -1;
      if (k != null) if (Array.isArray(k))
        for (; ++p < k.length; ) {
          const M = k[p];
          t(M);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + k + "`");
    }
    function d(k, p) {
      let M = -1, H = -1;
      for (; ++M < E.length; )
        if (E[M][0] === k) {
          H = M;
          break;
        }
      if (H === -1)
        E.push([k, ...p]);
      else if (p.length > 0) {
        let [f, ...AA] = p;
        const gA = E[H][1];
        isPlainObject$1(gA) && isPlainObject$1(f) && (f = extend(!0, gA, f)), E[H] = [k, f, ...AA];
      }
    }
  }
}
const unified = new Processor().freeze();
function assertParser(o, i) {
  if (typeof i != "function")
    throw new TypeError("Cannot `" + o + "` without `parser`");
}
function assertCompiler(o, i) {
  if (typeof i != "function")
    throw new TypeError("Cannot `" + o + "` without `compiler`");
}
function assertUnfrozen(o, i) {
  if (i)
    throw new Error(
      "Cannot call `" + o + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function assertNode(o) {
  if (!isPlainObject$1(o) || typeof o.type != "string")
    throw new TypeError("Expected node, got `" + o + "`");
}
function assertDone(o, i, g) {
  if (!g)
    throw new Error(
      "`" + o + "` finished async. Use `" + i + "` instead"
    );
}
function vfile(o) {
  return looksLikeAVFile(o) ? o : new VFile(o);
}
function looksLikeAVFile(o) {
  return !!(o && typeof o == "object" && "message" in o && "messages" in o);
}
function looksLikeAValue(o) {
  return typeof o == "string" || isUint8Array(o);
}
function isUint8Array(o) {
  return !!(o && typeof o == "object" && "byteLength" in o && "byteOffset" in o);
}
function visit$2(o, i, g, E) {
  let e, t, n;
  typeof i == "function" && typeof g != "function" ? (t = void 0, n = i, e = g) : (t = i, n = g, e = E), visitParents(o, t, h, e);
  function h(d, k) {
    const p = k[k.length - 1], M = p ? p.children.indexOf(d) : void 0;
    return n(d, M, p);
  }
}
const changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", emptyPlugins = [], emptyRemarkRehypeOptions = { allowDangerousHtml: !0 }, safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i, deprecations = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Markdown$2(o) {
  const i = createProcessor(o), g = createFile(o);
  return post(i.runSync(i.parse(g), g), o);
}
function createProcessor(o) {
  const i = o.rehypePlugins || emptyPlugins, g = o.remarkPlugins || emptyPlugins, E = o.remarkRehypeOptions ? { ...o.remarkRehypeOptions, ...emptyRemarkRehypeOptions } : emptyRemarkRehypeOptions;
  return unified().use(remarkParse).use(g).use(remarkRehype, E).use(i);
}
function createFile(o) {
  const i = o.children || "", g = new VFile();
  return typeof i == "string" && (g.value = i), g;
}
function post(o, i) {
  const g = i.allowedElements, E = i.allowElement, e = i.components, t = i.disallowedElements, n = i.skipHtml, h = i.unwrapDisallowed, d = i.urlTransform || defaultUrlTransform;
  for (const p of deprecations)
    Object.hasOwn(i, p.from) && ("" + p.from + (p.to ? "use `" + p.to + "` instead" : "remove it") + changelog + p.id, void 0);
  return visit$2(o, k), toJsxRuntime(o, {
    Fragment: jsxRuntimeExports.Fragment,
    components: e,
    ignoreInvalidStyle: !0,
    jsx: jsxRuntimeExports.jsx,
    jsxs: jsxRuntimeExports.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function k(p, M, H) {
    if (p.type === "raw" && H && typeof M == "number")
      return n ? H.children.splice(M, 1) : H.children[M] = { type: "text", value: p.value }, M;
    if (p.type === "element") {
      let f;
      for (f in urlAttributes)
        if (Object.hasOwn(urlAttributes, f) && Object.hasOwn(p.properties, f)) {
          const AA = p.properties[f], gA = urlAttributes[f];
          (gA === null || gA.includes(p.tagName)) && (p.properties[f] = d(String(AA || ""), f, p));
        }
    }
    if (p.type === "element") {
      let f = g ? !g.includes(p.tagName) : t ? t.includes(p.tagName) : !1;
      if (!f && E && typeof M == "number" && (f = !E(p, M, H)), f && H && typeof M == "number")
        return h && p.children ? H.children.splice(M, 1, ...p.children) : H.children.splice(M, 1), M;
    }
  }
}
function defaultUrlTransform(o) {
  const i = o.indexOf(":"), g = o.indexOf("?"), E = o.indexOf("#"), e = o.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    i === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    e !== -1 && i > e || g !== -1 && i > g || E !== -1 && i > E || // It is a protocol, it should be allowed.
    safeProtocol.test(o.slice(0, i)) ? o : ""
  );
}
function ccount(o, i) {
  const g = String(o);
  if (typeof i != "string")
    throw new TypeError("Expected character");
  let E = 0, e = g.indexOf(i);
  for (; e !== -1; )
    E++, e = g.indexOf(i, e + i.length);
  return E;
}
const characterEntitiesLegacy = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], characterReferenceInvalid = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function isDecimal(o) {
  const i = typeof o == "string" ? o.charCodeAt(0) : o;
  return i >= 48 && i <= 57;
}
function isHexadecimal(o) {
  const i = typeof o == "string" ? o.charCodeAt(0) : o;
  return i >= 97 && i <= 102 || i >= 65 && i <= 70 || i >= 48 && i <= 57;
}
function isAlphabetical(o) {
  const i = typeof o == "string" ? o.charCodeAt(0) : o;
  return i >= 97 && i <= 122 || i >= 65 && i <= 90;
}
function isAlphanumerical(o) {
  return isAlphabetical(o) || isDecimal(o);
}
const messages = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function parseEntities(o, i) {
  const g = i || {}, E = typeof g.additional == "string" ? g.additional.charCodeAt(0) : g.additional, e = [];
  let t = 0, n = -1, h = "", d, k;
  g.position && ("start" in g.position || "indent" in g.position ? (k = g.position.indent, d = g.position.start) : d = g.position);
  let p = (d ? d.line : 0) || 1, M = (d ? d.column : 0) || 1, H = AA(), f;
  for (t--; ++t <= o.length; )
    if (f === 10 && (M = (k ? k[n] : 0) || 1), f = o.charCodeAt(t), f === 38) {
      const BA = o.charCodeAt(t + 1);
      if (BA === 9 || BA === 10 || BA === 12 || BA === 32 || BA === 38 || BA === 60 || Number.isNaN(BA) || E && BA === E) {
        h += String.fromCharCode(f), M++;
        continue;
      }
      const CA = t + 1;
      let QA = CA, iA = CA, EA;
      if (BA === 35) {
        iA = ++QA;
        const DA = o.charCodeAt(iA);
        DA === 88 || DA === 120 ? (EA = "hexadecimal", iA = ++QA) : EA = "decimal";
      } else
        EA = "named";
      let oA = "", eA = "", GA = "";
      const cA = EA === "named" ? isAlphanumerical : EA === "decimal" ? isDecimal : isHexadecimal;
      for (iA--; ++iA <= o.length; ) {
        const DA = o.charCodeAt(iA);
        if (!cA(DA))
          break;
        GA += String.fromCharCode(DA), EA === "named" && characterEntitiesLegacy.includes(GA) && (oA = GA, eA = decodeNamedCharacterReference(GA));
      }
      let tA = o.charCodeAt(iA) === 59;
      if (tA) {
        iA++;
        const DA = EA === "named" ? decodeNamedCharacterReference(GA) : !1;
        DA && (oA = GA, eA = DA);
      }
      let aA = 1 + iA - CA, sA = "";
      if (!(!tA && g.nonTerminated === !1)) if (!GA)
        EA !== "named" && gA(4, aA);
      else if (EA === "named") {
        if (tA && !eA)
          gA(5, 1);
        else if (oA !== GA && (iA = QA + oA.length, aA = 1 + iA - QA, tA = !1), !tA) {
          const DA = oA ? 1 : 3;
          if (g.attribute) {
            const rA = o.charCodeAt(iA);
            rA === 61 ? (gA(DA, aA), eA = "") : isAlphanumerical(rA) ? eA = "" : gA(DA, aA);
          } else
            gA(DA, aA);
        }
        sA = eA;
      } else {
        tA || gA(2, aA);
        let DA = Number.parseInt(
          GA,
          EA === "hexadecimal" ? 16 : 10
        );
        if (prohibited(DA))
          gA(7, aA), sA = "�";
        else if (DA in characterReferenceInvalid)
          gA(6, aA), sA = characterReferenceInvalid[DA];
        else {
          let rA = "";
          disallowed(DA) && gA(6, aA), DA > 65535 && (DA -= 65536, rA += String.fromCharCode(
            DA >>> 10 | 55296
          ), DA = 56320 | DA & 1023), sA = rA + String.fromCharCode(DA);
        }
      }
      if (sA) {
        IA(), H = AA(), t = iA - 1, M += iA - CA + 1, e.push(sA);
        const DA = AA();
        DA.offset++, g.reference && g.reference.call(
          g.referenceContext || void 0,
          sA,
          { start: H, end: DA },
          o.slice(CA - 1, iA)
        ), H = DA;
      } else
        GA = o.slice(CA - 1, iA), h += GA, M += GA.length, t = iA - 1;
    } else
      f === 10 && (p++, n++, M = 0), Number.isNaN(f) ? IA() : (h += String.fromCharCode(f), M++);
  return e.join("");
  function AA() {
    return {
      line: p,
      column: M,
      offset: t + ((d ? d.offset : 0) || 0)
    };
  }
  function gA(BA, CA) {
    let QA;
    g.warning && (QA = AA(), QA.column += CA, QA.offset += CA, g.warning.call(
      g.warningContext || void 0,
      messages[BA],
      QA,
      BA
    ));
  }
  function IA() {
    h && (e.push(h), g.text && g.text.call(g.textContext || void 0, h, {
      start: H,
      end: AA()
    }), h = "");
  }
}
function prohibited(o) {
  return o >= 55296 && o <= 57343 || o > 1114111;
}
function disallowed(o) {
  return o >= 1 && o <= 8 || o === 11 || o >= 13 && o <= 31 || o >= 127 && o <= 159 || o >= 64976 && o <= 65007 || (o & 65535) === 65535 || (o & 65535) === 65534;
}
const defaultSubsetRegex = /["&'<>`]/g, surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, controlCharactersRegex = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g, subsetToRegexCache = /* @__PURE__ */ new WeakMap();
function core(o, i) {
  if (o = o.replace(
    i.subset ? charactersToExpressionCached(i.subset) : defaultSubsetRegex,
    E
  ), i.subset || i.escapeOnly)
    return o;
  return o.replace(surrogatePairsRegex, g).replace(controlCharactersRegex, E);
  function g(e, t, n) {
    return i.format(
      (e.charCodeAt(0) - 55296) * 1024 + e.charCodeAt(1) - 56320 + 65536,
      n.charCodeAt(t + 2),
      i
    );
  }
  function E(e, t, n) {
    return i.format(
      e.charCodeAt(0),
      n.charCodeAt(t + 1),
      i
    );
  }
}
function charactersToExpressionCached(o) {
  let i = subsetToRegexCache.get(o);
  return i || (i = charactersToExpression(o), subsetToRegexCache.set(o, i)), i;
}
function charactersToExpression(o) {
  const i = [];
  let g = -1;
  for (; ++g < o.length; )
    i.push(o[g].replace(regexEscapeRegex, "\\$&"));
  return new RegExp("(?:" + i.join("|") + ")", "g");
}
function formatBasic(o) {
  return "&#x" + o.toString(16).toUpperCase() + ";";
}
function stringifyEntitiesLight(o, i) {
  return core(o, Object.assign({ format: formatBasic }, i));
}
const own = {}.hasOwnProperty, emptyOptions$2 = {}, shortcut = /^[^\t\n\r "#'.<=>`}]+$/, unquoted = /^[^\t\n\r "'<=>`}]+$/;
function directiveFromMarkdown() {
  return {
    canContainEols: ["textDirective"],
    enter: {
      directiveContainer: enterContainer,
      directiveContainerAttributes: enterAttributes,
      directiveContainerLabel: enterContainerLabel,
      directiveLeaf: enterLeaf,
      directiveLeafAttributes: enterAttributes,
      directiveText: enterText,
      directiveTextAttributes: enterAttributes
    },
    exit: {
      directiveContainer: exit$1,
      directiveContainerAttributeClassValue: exitAttributeClassValue,
      directiveContainerAttributeIdValue: exitAttributeIdValue,
      directiveContainerAttributeName: exitAttributeName,
      directiveContainerAttributeValue: exitAttributeValue,
      directiveContainerAttributes: exitAttributes,
      directiveContainerLabel: exitContainerLabel,
      directiveContainerName: exitName,
      directiveLeaf: exit$1,
      directiveLeafAttributeClassValue: exitAttributeClassValue,
      directiveLeafAttributeIdValue: exitAttributeIdValue,
      directiveLeafAttributeName: exitAttributeName,
      directiveLeafAttributeValue: exitAttributeValue,
      directiveLeafAttributes: exitAttributes,
      directiveLeafName: exitName,
      directiveText: exit$1,
      directiveTextAttributeClassValue: exitAttributeClassValue,
      directiveTextAttributeIdValue: exitAttributeIdValue,
      directiveTextAttributeName: exitAttributeName,
      directiveTextAttributeValue: exitAttributeValue,
      directiveTextAttributes: exitAttributes,
      directiveTextName: exitName
    }
  };
}
function directiveToMarkdown(o) {
  const i = emptyOptions$2;
  if (i.quote !== '"' && i.quote !== "'" && i.quote !== null && i.quote !== void 0)
    throw new Error(
      "Invalid quote `" + i.quote + "`, expected `'` or `\"`"
    );
  return g.peek = peekDirective, {
    handlers: {
      containerDirective: g,
      leafDirective: g,
      textDirective: g
    },
    unsafe: [
      {
        character: "\r",
        inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
      },
      {
        character: `
`,
        inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
      },
      {
        before: "[^:]",
        character: ":",
        after: "[A-Za-z]",
        inConstruct: ["phrasing"]
      },
      { atBreak: !0, character: ":", after: ":" }
    ]
  };
  function g(t, n, h, d) {
    const k = h.createTracker(d), p = fence(t), M = h.enter(t.type);
    let H = k.move(p + (t.name || "")), f;
    if (t.type === "containerDirective") {
      const AA = (t.children || [])[0];
      f = inlineDirectiveLabel(AA) ? AA : void 0;
    } else
      f = t;
    if (f && f.children && f.children.length > 0) {
      const AA = h.enter("label"), gA = `${t.type}Label`, IA = h.enter(gA);
      H += k.move("["), H += k.move(
        h.containerPhrasing(f, {
          ...k.current(),
          before: H,
          after: "]"
        })
      ), H += k.move("]"), IA(), AA();
    }
    if (H += k.move(E(t, h)), t.type === "containerDirective") {
      const AA = (t.children || [])[0];
      let gA = t;
      inlineDirectiveLabel(AA) && (gA = Object.assign({}, t, { children: t.children.slice(1) })), gA && gA.children && gA.children.length > 0 && (H += k.move(`
`), H += k.move(h.containerFlow(gA, k.current()))), H += k.move(`
` + p);
    }
    return M(), H;
  }
  function E(t, n) {
    const h = t.attributes || {}, d = [];
    let k, p, M, H;
    for (H in h)
      if (own.call(h, H) && h[H] !== void 0 && h[H] !== null) {
        const f = String(h[H]);
        if (H === "id")
          M = i.preferShortcut !== !1 && shortcut.test(f) ? "#" + f : e("id", f, t, n);
        else if (H === "class") {
          const AA = f.split(/[\t\n\r ]+/g), gA = [], IA = [];
          let BA = -1;
          for (; ++BA < AA.length; )
            (i.preferShortcut !== !1 && shortcut.test(AA[BA]) ? IA : gA).push(AA[BA]);
          k = gA.length > 0 ? e("class", gA.join(" "), t, n) : "", p = IA.length > 0 ? "." + IA.join(".") : "";
        } else
          d.push(e(H, f, t, n));
      }
    return k && d.unshift(k), p && d.unshift(p), M && d.unshift(M), d.length > 0 ? "{" + d.join(" ") + "}" : "";
  }
  function e(t, n, h, d) {
    if (i.collapseEmptyAttributes !== !1 && !n) return t;
    if (i.preferUnquoted && unquoted.test(n))
      return t + "=" + n;
    const k = i.quote || d.options.quote || '"', p = k === '"' ? "'" : '"', M = i.quoteSmart && ccount(n, k) > ccount(n, p) ? p : k, H = h.type === "textDirective" ? [M] : [M, `
`, "\r"];
    return t + "=" + M + stringifyEntitiesLight(n, { subset: H }) + M;
  }
}
function enterContainer(o) {
  enter.call(this, "containerDirective", o);
}
function enterLeaf(o) {
  enter.call(this, "leafDirective", o);
}
function enterText(o) {
  enter.call(this, "textDirective", o);
}
function enter(o, i) {
  this.enter({ type: o, name: "", attributes: {}, children: [] }, i);
}
function exitName(o) {
  const i = this.stack[this.stack.length - 1];
  i.type === "containerDirective" || i.type === "leafDirective" || i.type, i.name = this.sliceSerialize(o);
}
function enterContainerLabel(o) {
  this.enter(
    { type: "paragraph", data: { directiveLabel: !0 }, children: [] },
    o
  );
}
function exitContainerLabel(o) {
  this.exit(o);
}
function enterAttributes() {
  this.data.directiveAttributes = [], this.buffer();
}
function exitAttributeIdValue(o) {
  this.data.directiveAttributes.push([
    "id",
    parseEntities(this.sliceSerialize(o), { attribute: !0 })
  ]);
}
function exitAttributeClassValue(o) {
  this.data.directiveAttributes.push([
    "class",
    parseEntities(this.sliceSerialize(o), { attribute: !0 })
  ]);
}
function exitAttributeValue(o) {
  const i = this.data.directiveAttributes;
  i[i.length - 1][1] = parseEntities(this.sliceSerialize(o), {
    attribute: !0
  });
}
function exitAttributeName(o) {
  this.data.directiveAttributes.push([this.sliceSerialize(o), ""]);
}
function exitAttributes() {
  const o = this.data.directiveAttributes, i = {};
  let g = -1;
  for (; ++g < o.length; ) {
    const e = o[g];
    e[0] === "class" && i.class ? i.class += " " + e[1] : i[e[0]] = e[1];
  }
  this.data.directiveAttributes = void 0, this.resume();
  const E = this.stack[this.stack.length - 1];
  E.type === "containerDirective" || E.type === "leafDirective" || E.type, E.attributes = i;
}
function exit$1(o) {
  this.exit(o);
}
function peekDirective() {
  return ":";
}
function inlineDirectiveLabel(o) {
  return !!(o && o.type === "paragraph" && o.data && o.data.directiveLabel);
}
function fence(o) {
  let i = 0;
  return o.type === "containerDirective" ? (visitParents(o, function(g, E) {
    if (g.type === "containerDirective") {
      let e = E.length, t = 0;
      for (; e--; )
        E[e].type === "containerDirective" && t++;
      t > i && (i = t);
    }
  }), i += 3) : o.type === "leafDirective" ? i = 2 : i = 1, ":".repeat(i);
}
function factoryAttributes(o, i, g, E, e, t, n, h, d, k, p, M, H, f, AA) {
  let gA, IA;
  return BA;
  function BA(nA) {
    return o.enter(E), o.enter(e), o.consume(nA), o.exit(e), CA;
  }
  function CA(nA) {
    return nA === 35 ? (gA = n, QA(nA)) : nA === 46 ? (gA = h, QA(nA)) : AA && markdownSpace(nA) ? factorySpace(o, CA, "whitespace")(nA) : !AA && markdownLineEndingOrSpace(nA) ? factoryWhitespace(o, CA)(nA) : nA === null || markdownLineEnding(nA) || unicodeWhitespace(nA) || unicodePunctuation(nA) && nA !== 45 && nA !== 95 ? rA(nA) : (o.enter(t), o.enter(d), o.consume(nA), oA);
  }
  function QA(nA) {
    const NA = (
      /** @type {TokenType} */
      gA + "Marker"
    );
    return o.enter(t), o.enter(gA), o.enter(NA), o.consume(nA), o.exit(NA), iA;
  }
  function iA(nA) {
    if (nA === null || nA === 34 || nA === 35 || nA === 39 || nA === 46 || nA === 60 || nA === 61 || nA === 62 || nA === 96 || nA === 125 || markdownLineEndingOrSpace(nA))
      return g(nA);
    const NA = (
      /** @type {TokenType} */
      gA + "Value"
    );
    return o.enter(NA), o.consume(nA), EA;
  }
  function EA(nA) {
    if (nA === null || nA === 34 || nA === 39 || nA === 60 || nA === 61 || nA === 62 || nA === 96)
      return g(nA);
    if (nA === 35 || nA === 46 || nA === 125 || markdownLineEndingOrSpace(nA)) {
      const NA = (
        /** @type {TokenType} */
        gA + "Value"
      );
      return o.exit(NA), o.exit(gA), o.exit(t), CA(nA);
    }
    return o.consume(nA), EA;
  }
  function oA(nA) {
    return nA === null || markdownLineEnding(nA) || unicodeWhitespace(nA) || unicodePunctuation(nA) && nA !== 45 && nA !== 46 && nA !== 58 && nA !== 95 ? (o.exit(d), AA && markdownSpace(nA) ? factorySpace(o, eA, "whitespace")(nA) : !AA && markdownLineEndingOrSpace(nA) ? factoryWhitespace(o, eA)(nA) : eA(nA)) : (o.consume(nA), oA);
  }
  function eA(nA) {
    return nA === 61 ? (o.enter(k), o.consume(nA), o.exit(k), GA) : (o.exit(t), CA(nA));
  }
  function GA(nA) {
    return nA === null || nA === 60 || nA === 61 || nA === 62 || nA === 96 || nA === 125 || AA && markdownLineEnding(nA) ? g(nA) : nA === 34 || nA === 39 ? (o.enter(p), o.enter(H), o.consume(nA), o.exit(H), IA = nA, tA) : AA && markdownSpace(nA) ? factorySpace(o, GA, "whitespace")(nA) : !AA && markdownLineEndingOrSpace(nA) ? factoryWhitespace(o, GA)(nA) : (o.enter(M), o.enter(f), o.consume(nA), IA = void 0, cA);
  }
  function cA(nA) {
    return nA === null || nA === 34 || nA === 39 || nA === 60 || nA === 61 || nA === 62 || nA === 96 ? g(nA) : nA === 125 || markdownLineEndingOrSpace(nA) ? (o.exit(f), o.exit(M), o.exit(t), CA(nA)) : (o.consume(nA), cA);
  }
  function tA(nA) {
    return nA === IA ? (o.enter(H), o.consume(nA), o.exit(H), o.exit(p), o.exit(t), DA) : (o.enter(M), aA(nA));
  }
  function aA(nA) {
    return nA === IA ? (o.exit(M), tA(nA)) : nA === null ? g(nA) : markdownLineEnding(nA) ? AA ? g(nA) : factoryWhitespace(o, aA)(nA) : (o.enter(f), o.consume(nA), sA);
  }
  function sA(nA) {
    return nA === IA || nA === null || markdownLineEnding(nA) ? (o.exit(f), aA(nA)) : (o.consume(nA), sA);
  }
  function DA(nA) {
    return nA === 125 || markdownLineEndingOrSpace(nA) ? CA(nA) : rA(nA);
  }
  function rA(nA) {
    return nA === 125 ? (o.enter(e), o.consume(nA), o.exit(e), o.exit(E), i) : g(nA);
  }
}
function factoryLabel(o, i, g, E, e, t, n) {
  let h = 0, d = 0, k;
  return p;
  function p(IA) {
    return o.enter(E), o.enter(e), o.consume(IA), o.exit(e), M;
  }
  function M(IA) {
    return IA === 93 ? (o.enter(e), o.consume(IA), o.exit(e), o.exit(E), i) : (o.enter(t), H(IA));
  }
  function H(IA) {
    if (IA === 93 && !d)
      return gA(IA);
    const BA = o.enter("chunkText", {
      _contentTypeTextTrailing: !0,
      contentType: "text",
      previous: k
    });
    return k && (k.next = BA), k = BA, f(IA);
  }
  function f(IA) {
    return IA === null || h > 999 || IA === 91 && ++d > 32 ? g(IA) : IA === 93 && !d-- ? (o.exit("chunkText"), gA(IA)) : markdownLineEnding(IA) ? n ? g(IA) : (o.consume(IA), o.exit("chunkText"), H) : (o.consume(IA), IA === 92 ? AA : f);
  }
  function AA(IA) {
    return IA === 91 || IA === 92 || IA === 93 ? (o.consume(IA), h++, f) : f(IA);
  }
  function gA(IA) {
    return o.exit(t), o.enter(e), o.consume(IA), o.exit(e), o.exit(E), i;
  }
}
function factoryName(o, i, g, E) {
  const e = this;
  return t;
  function t(h) {
    return h === null || markdownLineEnding(h) || unicodePunctuation(h) || unicodeWhitespace(h) ? g(h) : (o.enter(E), o.consume(h), n);
  }
  function n(h) {
    return h === null || markdownLineEnding(h) || unicodeWhitespace(h) || unicodePunctuation(h) && h !== 45 && h !== 95 ? (o.exit(E), e.previous === 45 || e.previous === 95 ? g(h) : i(h)) : (o.consume(h), n);
  }
}
const directiveContainer = {
  tokenize: tokenizeDirectiveContainer,
  concrete: !0
}, label$2 = {
  tokenize: tokenizeLabel$2,
  partial: !0
}, attributes$2 = {
  tokenize: tokenizeAttributes$2,
  partial: !0
}, nonLazyLine = {
  tokenize: tokenizeNonLazyLine,
  partial: !0
};
function tokenizeDirectiveContainer(o, i, g) {
  const E = this, e = E.events[E.events.length - 1], t = e && e[1].type === "linePrefix" ? e[2].sliceSerialize(e[1], !0).length : 0;
  let n = 0, h;
  return d;
  function d(cA) {
    return o.enter("directiveContainer"), o.enter("directiveContainerFence"), o.enter("directiveContainerSequence"), k(cA);
  }
  function k(cA) {
    return cA === 58 ? (o.consume(cA), n++, k) : n < 3 ? g(cA) : (o.exit("directiveContainerSequence"), factoryName.call(E, o, p, g, "directiveContainerName")(cA));
  }
  function p(cA) {
    return cA === 91 ? o.attempt(label$2, M, M)(cA) : M(cA);
  }
  function M(cA) {
    return cA === 123 ? o.attempt(attributes$2, H, H)(cA) : H(cA);
  }
  function H(cA) {
    return factorySpace(o, f, "whitespace")(cA);
  }
  function f(cA) {
    return o.exit("directiveContainerFence"), cA === null ? eA(cA) : markdownLineEnding(cA) ? E.interrupt ? i(cA) : o.attempt(nonLazyLine, AA, eA)(cA) : g(cA);
  }
  function AA(cA) {
    return cA === null ? eA(cA) : markdownLineEnding(cA) ? o.check(nonLazyLine, QA, eA)(cA) : (o.enter("directiveContainerContent"), gA(cA));
  }
  function gA(cA) {
    return o.attempt({
      tokenize: GA,
      partial: !0
    }, oA, t ? factorySpace(o, IA, "linePrefix", t + 1) : IA)(cA);
  }
  function IA(cA) {
    return cA === null ? oA(cA) : markdownLineEnding(cA) ? o.check(nonLazyLine, CA, oA)(cA) : CA(cA);
  }
  function BA(cA) {
    if (cA === null) {
      const tA = o.exit("chunkDocument");
      return E.parser.lazy[tA.start.line] = !1, oA(cA);
    }
    return markdownLineEnding(cA) ? o.check(nonLazyLine, iA, EA)(cA) : (o.consume(cA), BA);
  }
  function CA(cA) {
    const tA = o.enter("chunkDocument", {
      contentType: "document",
      previous: h
    });
    return h && (h.next = tA), h = tA, BA(cA);
  }
  function QA(cA) {
    return o.enter("directiveContainerContent"), gA(cA);
  }
  function iA(cA) {
    o.consume(cA);
    const tA = o.exit("chunkDocument");
    return E.parser.lazy[tA.start.line] = !1, gA;
  }
  function EA(cA) {
    const tA = o.exit("chunkDocument");
    return E.parser.lazy[tA.start.line] = !1, oA(cA);
  }
  function oA(cA) {
    return o.exit("directiveContainerContent"), eA(cA);
  }
  function eA(cA) {
    return o.exit("directiveContainer"), i(cA);
  }
  function GA(cA, tA, aA) {
    let sA = 0;
    return factorySpace(cA, DA, "linePrefix", E.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function DA(NA) {
      return cA.enter("directiveContainerFence"), cA.enter("directiveContainerSequence"), rA(NA);
    }
    function rA(NA) {
      return NA === 58 ? (cA.consume(NA), sA++, rA) : sA < n ? aA(NA) : (cA.exit("directiveContainerSequence"), factorySpace(cA, nA, "whitespace")(NA));
    }
    function nA(NA) {
      return NA === null || markdownLineEnding(NA) ? (cA.exit("directiveContainerFence"), tA(NA)) : aA(NA);
    }
  }
}
function tokenizeLabel$2(o, i, g) {
  return factoryLabel(o, i, g, "directiveContainerLabel", "directiveContainerLabelMarker", "directiveContainerLabelString", !0);
}
function tokenizeAttributes$2(o, i, g) {
  return factoryAttributes(o, i, g, "directiveContainerAttributes", "directiveContainerAttributesMarker", "directiveContainerAttribute", "directiveContainerAttributeId", "directiveContainerAttributeClass", "directiveContainerAttributeName", "directiveContainerAttributeInitializerMarker", "directiveContainerAttributeValueLiteral", "directiveContainerAttributeValue", "directiveContainerAttributeValueMarker", "directiveContainerAttributeValueData", !0);
}
function tokenizeNonLazyLine(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return o.enter("lineEnding"), o.consume(n), o.exit("lineEnding"), t;
  }
  function t(n) {
    return E.parser.lazy[E.now().line] ? g(n) : i(n);
  }
}
const directiveLeaf = {
  tokenize: tokenizeDirectiveLeaf
}, label$1 = {
  tokenize: tokenizeLabel$1,
  partial: !0
}, attributes$1 = {
  tokenize: tokenizeAttributes$1,
  partial: !0
};
function tokenizeDirectiveLeaf(o, i, g) {
  const E = this;
  return e;
  function e(p) {
    return o.enter("directiveLeaf"), o.enter("directiveLeafSequence"), o.consume(p), t;
  }
  function t(p) {
    return p === 58 ? (o.consume(p), o.exit("directiveLeafSequence"), factoryName.call(E, o, n, g, "directiveLeafName")) : g(p);
  }
  function n(p) {
    return p === 91 ? o.attempt(label$1, h, h)(p) : h(p);
  }
  function h(p) {
    return p === 123 ? o.attempt(attributes$1, d, d)(p) : d(p);
  }
  function d(p) {
    return factorySpace(o, k, "whitespace")(p);
  }
  function k(p) {
    return p === null || markdownLineEnding(p) ? (o.exit("directiveLeaf"), i(p)) : g(p);
  }
}
function tokenizeLabel$1(o, i, g) {
  return factoryLabel(o, i, g, "directiveLeafLabel", "directiveLeafLabelMarker", "directiveLeafLabelString", !0);
}
function tokenizeAttributes$1(o, i, g) {
  return factoryAttributes(o, i, g, "directiveLeafAttributes", "directiveLeafAttributesMarker", "directiveLeafAttribute", "directiveLeafAttributeId", "directiveLeafAttributeClass", "directiveLeafAttributeName", "directiveLeafAttributeInitializerMarker", "directiveLeafAttributeValueLiteral", "directiveLeafAttributeValue", "directiveLeafAttributeValueMarker", "directiveLeafAttributeValueData", !0);
}
const directiveText = {
  tokenize: tokenizeDirectiveText,
  previous: previous$2
}, label = {
  tokenize: tokenizeLabel,
  partial: !0
}, attributes = {
  tokenize: tokenizeAttributes,
  partial: !0
};
function previous$2(o) {
  return o !== 58 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeDirectiveText(o, i, g) {
  const E = this;
  return e;
  function e(d) {
    return o.enter("directiveText"), o.enter("directiveTextMarker"), o.consume(d), o.exit("directiveTextMarker"), factoryName.call(E, o, t, g, "directiveTextName");
  }
  function t(d) {
    return d === 58 ? g(d) : d === 91 ? o.attempt(label, n, n)(d) : n(d);
  }
  function n(d) {
    return d === 123 ? o.attempt(attributes, h, h)(d) : h(d);
  }
  function h(d) {
    return o.exit("directiveText"), i(d);
  }
}
function tokenizeLabel(o, i, g) {
  return factoryLabel(o, i, g, "directiveTextLabel", "directiveTextLabelMarker", "directiveTextLabelString");
}
function tokenizeAttributes(o, i, g) {
  return factoryAttributes(o, i, g, "directiveTextAttributes", "directiveTextAttributesMarker", "directiveTextAttribute", "directiveTextAttributeId", "directiveTextAttributeClass", "directiveTextAttributeName", "directiveTextAttributeInitializerMarker", "directiveTextAttributeValueLiteral", "directiveTextAttributeValue", "directiveTextAttributeValueMarker", "directiveTextAttributeValueData");
}
function directive() {
  return {
    text: {
      58: directiveText
    },
    flow: {
      58: [directiveContainer, directiveLeaf]
    }
  };
}
function remarkDirective() {
  const i = /** @type {Processor<Root>} */ this.data(), g = i.micromarkExtensions || (i.micromarkExtensions = []), E = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), e = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  g.push(directive()), E.push(directiveFromMarkdown()), e.push(directiveToMarkdown());
}
const inConstruct = "phrasing", notInConstruct = ["autolink", "link", "image", "label"];
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  };
}
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct,
        notInConstruct
      }
    ]
  };
}
function enterLiteralAutolink(o) {
  this.enter({ type: "link", title: null, url: "", children: [] }, o);
}
function enterLiteralAutolinkValue(o) {
  this.config.enter.autolinkProtocol.call(this, o);
}
function exitLiteralAutolinkHttp(o) {
  this.config.exit.autolinkProtocol.call(this, o);
}
function exitLiteralAutolinkWww(o) {
  this.config.exit.data.call(this, o);
  const i = this.stack[this.stack.length - 1];
  i.type, i.url = "http://" + this.sliceSerialize(o);
}
function exitLiteralAutolinkEmail(o) {
  this.config.exit.autolinkEmail.call(this, o);
}
function exitLiteralAutolink(o) {
  this.exit(o);
}
function transformGfmAutolinkLiterals(o) {
  findAndReplace(
    o,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), findEmail]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function findUrl(o, i, g, E, e) {
  let t = "";
  if (!previous$1(e) || (/^w/i.test(i) && (g = i + g, i = "", t = "http://"), !isCorrectDomain(g)))
    return !1;
  const n = splitUrl(g + E);
  if (!n[0]) return !1;
  const h = {
    type: "link",
    title: null,
    url: t + i + n[0],
    children: [{ type: "text", value: i + n[0] }]
  };
  return n[1] ? [h, { type: "text", value: n[1] }] : h;
}
function findEmail(o, i, g, E) {
  return (
    // Not an expected previous character.
    !previous$1(E, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(g) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + i + "@" + g,
      children: [{ type: "text", value: i + "@" + g }]
    }
  );
}
function isCorrectDomain(o) {
  const i = o.split(".");
  return !(i.length < 2 || i[i.length - 1] && (/_/.test(i[i.length - 1]) || !/[a-zA-Z\d]/.test(i[i.length - 1])) || i[i.length - 2] && (/_/.test(i[i.length - 2]) || !/[a-zA-Z\d]/.test(i[i.length - 2])));
}
function splitUrl(o) {
  const i = /[!"&'),.:;<>?\]}]+$/.exec(o);
  if (!i)
    return [o, void 0];
  o = o.slice(0, i.index);
  let g = i[0], E = g.indexOf(")");
  const e = ccount(o, "(");
  let t = ccount(o, ")");
  for (; E !== -1 && e > t; )
    o += g.slice(0, E + 1), g = g.slice(E + 1), E = g.indexOf(")"), t++;
  return [o, g];
}
function previous$1(o, i) {
  const g = o.input.charCodeAt(o.index - 1);
  return (o.index === 0 || unicodeWhitespace(g) || unicodePunctuation(g)) && // If it’s an email, the previous character should not be a slash.
  (!i || g !== 47);
}
footnoteReference.peek = footnoteReferencePeek;
function enterFootnoteCallString() {
  this.buffer();
}
function enterFootnoteCall(o) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, o);
}
function enterFootnoteDefinitionLabelString() {
  this.buffer();
}
function enterFootnoteDefinition(o) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    o
  );
}
function exitFootnoteCallString(o) {
  const i = this.resume(), g = this.stack[this.stack.length - 1];
  g.type, g.identifier = normalizeIdentifier(
    this.sliceSerialize(o)
  ).toLowerCase(), g.label = i;
}
function exitFootnoteCall(o) {
  this.exit(o);
}
function exitFootnoteDefinitionLabelString(o) {
  const i = this.resume(), g = this.stack[this.stack.length - 1];
  g.type, g.identifier = normalizeIdentifier(
    this.sliceSerialize(o)
  ).toLowerCase(), g.label = i;
}
function exitFootnoteDefinition(o) {
  this.exit(o);
}
function footnoteReferencePeek() {
  return "[";
}
function footnoteReference(o, i, g, E) {
  const e = g.createTracker(E);
  let t = e.move("[^");
  const n = g.enter("footnoteReference"), h = g.enter("reference");
  return t += e.move(
    g.safe(g.associationId(o), { after: "]", before: t })
  ), h(), n(), t += e.move("]"), t;
}
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteCallString: enterFootnoteCallString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: enterFootnoteDefinition
    },
    exit: {
      gfmFootnoteCallString: exitFootnoteCallString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: exitFootnoteDefinition
    }
  };
}
function gfmFootnoteToMarkdown(o) {
  let i = !1;
  return o && o.firstLineBlank && (i = !0), {
    handlers: { footnoteDefinition: g, footnoteReference },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function g(E, e, t, n) {
    const h = t.createTracker(n);
    let d = h.move("[^");
    const k = t.enter("footnoteDefinition"), p = t.enter("label");
    return d += h.move(
      t.safe(t.associationId(E), { before: d, after: "]" })
    ), p(), d += h.move("]:"), E.children && E.children.length > 0 && (h.shift(4), d += h.move(
      (i ? `
` : " ") + t.indentLines(
        t.containerFlow(E, h.current()),
        i ? mapAll : mapExceptFirst
      )
    )), k(), d;
  }
}
function mapExceptFirst(o, i, g) {
  return i === 0 ? o : mapAll(o, i, g);
}
function mapAll(o, i, g) {
  return (g ? "" : "    ") + o;
}
const constructsWithoutStrikethrough = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
handleDelete.peek = peekDelete;
function gfmStrikethroughFromMarkdown() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: enterStrikethrough },
    exit: { strikethrough: exitStrikethrough }
  };
}
function gfmStrikethroughToMarkdown() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: constructsWithoutStrikethrough
      }
    ],
    handlers: { delete: handleDelete }
  };
}
function enterStrikethrough(o) {
  this.enter({ type: "delete", children: [] }, o);
}
function exitStrikethrough(o) {
  this.exit(o);
}
function handleDelete(o, i, g, E) {
  const e = g.createTracker(E), t = g.enter("strikethrough");
  let n = e.move("~~");
  return n += g.containerPhrasing(o, {
    ...e.current(),
    before: n,
    after: "~"
  }), n += e.move("~~"), t(), n;
}
function peekDelete() {
  return "~";
}
function defaultStringLength(o) {
  return o.length;
}
function markdownTable(o, i) {
  const g = i || {}, E = (g.align || []).concat(), e = g.stringLength || defaultStringLength, t = [], n = [], h = [], d = [];
  let k = 0, p = -1;
  for (; ++p < o.length; ) {
    const gA = [], IA = [];
    let BA = -1;
    for (o[p].length > k && (k = o[p].length); ++BA < o[p].length; ) {
      const CA = serialize(o[p][BA]);
      if (g.alignDelimiters !== !1) {
        const QA = e(CA);
        IA[BA] = QA, (d[BA] === void 0 || QA > d[BA]) && (d[BA] = QA);
      }
      gA.push(CA);
    }
    n[p] = gA, h[p] = IA;
  }
  let M = -1;
  if (typeof E == "object" && "length" in E)
    for (; ++M < k; )
      t[M] = toAlignment(E[M]);
  else {
    const gA = toAlignment(E);
    for (; ++M < k; )
      t[M] = gA;
  }
  M = -1;
  const H = [], f = [];
  for (; ++M < k; ) {
    const gA = t[M];
    let IA = "", BA = "";
    gA === 99 ? (IA = ":", BA = ":") : gA === 108 ? IA = ":" : gA === 114 && (BA = ":");
    let CA = g.alignDelimiters === !1 ? 1 : Math.max(
      1,
      d[M] - IA.length - BA.length
    );
    const QA = IA + "-".repeat(CA) + BA;
    g.alignDelimiters !== !1 && (CA = IA.length + CA + BA.length, CA > d[M] && (d[M] = CA), f[M] = CA), H[M] = QA;
  }
  n.splice(1, 0, H), h.splice(1, 0, f), p = -1;
  const AA = [];
  for (; ++p < n.length; ) {
    const gA = n[p], IA = h[p];
    M = -1;
    const BA = [];
    for (; ++M < k; ) {
      const CA = gA[M] || "";
      let QA = "", iA = "";
      if (g.alignDelimiters !== !1) {
        const EA = d[M] - (IA[M] || 0), oA = t[M];
        oA === 114 ? QA = " ".repeat(EA) : oA === 99 ? EA % 2 ? (QA = " ".repeat(EA / 2 + 0.5), iA = " ".repeat(EA / 2 - 0.5)) : (QA = " ".repeat(EA / 2), iA = QA) : iA = " ".repeat(EA);
      }
      g.delimiterStart !== !1 && !M && BA.push("|"), g.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(g.alignDelimiters === !1 && CA === "") && (g.delimiterStart !== !1 || M) && BA.push(" "), g.alignDelimiters !== !1 && BA.push(QA), BA.push(CA), g.alignDelimiters !== !1 && BA.push(iA), g.padding !== !1 && BA.push(" "), (g.delimiterEnd !== !1 || M !== k - 1) && BA.push("|");
    }
    AA.push(
      g.delimiterEnd === !1 ? BA.join("").replace(/ +$/, "") : BA.join("")
    );
  }
  return AA.join(`
`);
}
function serialize(o) {
  return o == null ? "" : String(o);
}
function toAlignment(o) {
  const i = typeof o == "string" ? o.codePointAt(0) : 0;
  return i === 67 || i === 99 ? 99 : i === 76 || i === 108 ? 108 : i === 82 || i === 114 ? 114 : 0;
}
function blockquote(o, i, g, E) {
  const e = g.enter("blockquote"), t = g.createTracker(E);
  t.move("> "), t.shift(2);
  const n = g.indentLines(
    g.containerFlow(o, t.current()),
    map$2
  );
  return e(), n;
}
function map$2(o, i, g) {
  return ">" + (g ? "" : " ") + o;
}
function patternInScope(o, i) {
  return listInScope(o, i.inConstruct, !0) && !listInScope(o, i.notInConstruct, !1);
}
function listInScope(o, i, g) {
  if (typeof i == "string" && (i = [i]), !i || i.length === 0)
    return g;
  let E = -1;
  for (; ++E < i.length; )
    if (o.includes(i[E]))
      return !0;
  return !1;
}
function hardBreak(o, i, g, E) {
  let e = -1;
  for (; ++e < g.unsafe.length; )
    if (g.unsafe[e].character === `
` && patternInScope(g.stack, g.unsafe[e]))
      return /[ \t]/.test(E.before) ? "" : " ";
  return `\\
`;
}
function longestStreak(o, i) {
  const g = String(o);
  let E = g.indexOf(i), e = E, t = 0, n = 0;
  if (typeof i != "string")
    throw new TypeError("Expected substring");
  for (; E !== -1; )
    E === e ? ++t > n && (n = t) : t = 1, e = E + i.length, E = g.indexOf(i, e);
  return n;
}
function formatCodeAsIndented(o, i) {
  return !!(i.options.fences === !1 && o.value && // If there’s no info…
  !o.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(o.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(o.value));
}
function checkFence(o) {
  const i = o.options.fence || "`";
  if (i !== "`" && i !== "~")
    throw new Error(
      "Cannot serialize code with `" + i + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return i;
}
function code$2(o, i, g, E) {
  const e = checkFence(g), t = o.value || "", n = e === "`" ? "GraveAccent" : "Tilde";
  if (formatCodeAsIndented(o, g)) {
    const M = g.enter("codeIndented"), H = g.indentLines(t, map$1);
    return M(), H;
  }
  const h = g.createTracker(E), d = e.repeat(Math.max(longestStreak(t, e) + 1, 3)), k = g.enter("codeFenced");
  let p = h.move(d);
  if (o.lang) {
    const M = g.enter(`codeFencedLang${n}`);
    p += h.move(
      g.safe(o.lang, {
        before: p,
        after: " ",
        encode: ["`"],
        ...h.current()
      })
    ), M();
  }
  if (o.lang && o.meta) {
    const M = g.enter(`codeFencedMeta${n}`);
    p += h.move(" "), p += h.move(
      g.safe(o.meta, {
        before: p,
        after: `
`,
        encode: ["`"],
        ...h.current()
      })
    ), M();
  }
  return p += h.move(`
`), t && (p += h.move(t + `
`)), p += h.move(d), k(), p;
}
function map$1(o, i, g) {
  return (g ? "" : "    ") + o;
}
function checkQuote(o) {
  const i = o.options.quote || '"';
  if (i !== '"' && i !== "'")
    throw new Error(
      "Cannot serialize title with `" + i + "` for `options.quote`, expected `\"`, or `'`"
    );
  return i;
}
function definition(o, i, g, E) {
  const e = checkQuote(g), t = e === '"' ? "Quote" : "Apostrophe", n = g.enter("definition");
  let h = g.enter("label");
  const d = g.createTracker(E);
  let k = d.move("[");
  return k += d.move(
    g.safe(g.associationId(o), {
      before: k,
      after: "]",
      ...d.current()
    })
  ), k += d.move("]: "), h(), // If there’s no url, or…
  !o.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(o.url) ? (h = g.enter("destinationLiteral"), k += d.move("<"), k += d.move(
    g.safe(o.url, { before: k, after: ">", ...d.current() })
  ), k += d.move(">")) : (h = g.enter("destinationRaw"), k += d.move(
    g.safe(o.url, {
      before: k,
      after: o.title ? " " : `
`,
      ...d.current()
    })
  )), h(), o.title && (h = g.enter(`title${t}`), k += d.move(" " + e), k += d.move(
    g.safe(o.title, {
      before: k,
      after: e,
      ...d.current()
    })
  ), k += d.move(e), h()), n(), k;
}
function checkEmphasis(o) {
  const i = o.options.emphasis || "*";
  if (i !== "*" && i !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + i + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return i;
}
function encodeCharacterReference(o) {
  return "&#x" + o.toString(16).toUpperCase() + ";";
}
function encodeInfo(o, i, g) {
  const E = classifyCharacter(o), e = classifyCharacter(i);
  return E === void 0 ? e === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    g === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : e === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : E === 1 ? e === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : e === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : e === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : e === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
emphasis.peek = emphasisPeek;
function emphasis(o, i, g, E) {
  const e = checkEmphasis(g), t = g.enter("emphasis"), n = g.createTracker(E), h = n.move(e);
  let d = n.move(
    g.containerPhrasing(o, {
      after: e,
      before: h,
      ...n.current()
    })
  );
  const k = d.charCodeAt(0), p = encodeInfo(
    E.before.charCodeAt(E.before.length - 1),
    k,
    e
  );
  p.inside && (d = encodeCharacterReference(k) + d.slice(1));
  const M = d.charCodeAt(d.length - 1), H = encodeInfo(E.after.charCodeAt(0), M, e);
  H.inside && (d = d.slice(0, -1) + encodeCharacterReference(M));
  const f = n.move(e);
  return t(), g.attentionEncodeSurroundingInfo = {
    after: H.outside,
    before: p.outside
  }, h + d + f;
}
function emphasisPeek(o, i, g) {
  return g.options.emphasis || "*";
}
function visit$1(o, i, g, E) {
  let e, t, n;
  typeof i == "function" && typeof g != "function" ? (t = void 0, n = i, e = g) : (t = i, n = g, e = E), visitParents(o, t, h, e);
  function h(d, k) {
    const p = k[k.length - 1], M = p ? p.children.indexOf(d) : void 0;
    return n(d, M, p);
  }
}
function formatHeadingAsSetext(o, i) {
  let g = !1;
  return visit$1(o, function(E) {
    if ("value" in E && /\r?\n|\r/.test(E.value) || E.type === "break")
      return g = !0, EXIT;
  }), !!((!o.depth || o.depth < 3) && toString$2(o) && (i.options.setext || g));
}
function heading(o, i, g, E) {
  const e = Math.max(Math.min(6, o.depth || 1), 1), t = g.createTracker(E);
  if (formatHeadingAsSetext(o, g)) {
    const p = g.enter("headingSetext"), M = g.enter("phrasing"), H = g.containerPhrasing(o, {
      ...t.current(),
      before: `
`,
      after: `
`
    });
    return M(), p(), H + `
` + (e === 1 ? "=" : "-").repeat(
      // The whole size…
      H.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(H.lastIndexOf("\r"), H.lastIndexOf(`
`)) + 1)
    );
  }
  const n = "#".repeat(e), h = g.enter("headingAtx"), d = g.enter("phrasing");
  t.move(n + " ");
  let k = g.containerPhrasing(o, {
    before: "# ",
    after: `
`,
    ...t.current()
  });
  return /^[\t ]/.test(k) && (k = encodeCharacterReference(k.charCodeAt(0)) + k.slice(1)), k = k ? n + " " + k : n, g.options.closeAtx && (k += " " + n), d(), h(), k;
}
html.peek = htmlPeek;
function html(o) {
  return o.value || "";
}
function htmlPeek() {
  return "<";
}
image.peek = imagePeek;
function image(o, i, g, E) {
  const e = checkQuote(g), t = e === '"' ? "Quote" : "Apostrophe", n = g.enter("image");
  let h = g.enter("label");
  const d = g.createTracker(E);
  let k = d.move("![");
  return k += d.move(
    g.safe(o.alt, { before: k, after: "]", ...d.current() })
  ), k += d.move("]("), h(), // If there’s no url but there is a title…
  !o.url && o.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(o.url) ? (h = g.enter("destinationLiteral"), k += d.move("<"), k += d.move(
    g.safe(o.url, { before: k, after: ">", ...d.current() })
  ), k += d.move(">")) : (h = g.enter("destinationRaw"), k += d.move(
    g.safe(o.url, {
      before: k,
      after: o.title ? " " : ")",
      ...d.current()
    })
  )), h(), o.title && (h = g.enter(`title${t}`), k += d.move(" " + e), k += d.move(
    g.safe(o.title, {
      before: k,
      after: e,
      ...d.current()
    })
  ), k += d.move(e), h()), k += d.move(")"), n(), k;
}
function imagePeek() {
  return "!";
}
imageReference.peek = imageReferencePeek;
function imageReference(o, i, g, E) {
  const e = o.referenceType, t = g.enter("imageReference");
  let n = g.enter("label");
  const h = g.createTracker(E);
  let d = h.move("![");
  const k = g.safe(o.alt, {
    before: d,
    after: "]",
    ...h.current()
  });
  d += h.move(k + "]["), n();
  const p = g.stack;
  g.stack = [], n = g.enter("reference");
  const M = g.safe(g.associationId(o), {
    before: d,
    after: "]",
    ...h.current()
  });
  return n(), g.stack = p, t(), e === "full" || !k || k !== M ? d += h.move(M + "]") : e === "shortcut" ? d = d.slice(0, -1) : d += h.move("]"), d;
}
function imageReferencePeek() {
  return "!";
}
inlineCode.peek = inlineCodePeek;
function inlineCode(o, i, g) {
  let E = o.value || "", e = "`", t = -1;
  for (; new RegExp("(^|[^`])" + e + "([^`]|$)").test(E); )
    e += "`";
  for (/[^ \r\n]/.test(E) && (/^[ \r\n]/.test(E) && /[ \r\n]$/.test(E) || /^`|`$/.test(E)) && (E = " " + E + " "); ++t < g.unsafe.length; ) {
    const n = g.unsafe[t], h = g.compilePattern(n);
    let d;
    if (n.atBreak)
      for (; d = h.exec(E); ) {
        let k = d.index;
        E.charCodeAt(k) === 10 && E.charCodeAt(k - 1) === 13 && k--, E = E.slice(0, k) + " " + E.slice(d.index + 1);
      }
  }
  return e + E + e;
}
function inlineCodePeek() {
  return "`";
}
function formatLinkAsAutolink(o, i) {
  const g = toString$2(o);
  return !!(!i.options.resourceLink && // If there’s a url…
  o.url && // And there’s a no title…
  !o.title && // And the content of `node` is a single text node…
  o.children && o.children.length === 1 && o.children[0].type === "text" && // And if the url is the same as the content…
  (g === o.url || "mailto:" + g === o.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(o.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(o.url));
}
link.peek = linkPeek;
function link(o, i, g, E) {
  const e = checkQuote(g), t = e === '"' ? "Quote" : "Apostrophe", n = g.createTracker(E);
  let h, d;
  if (formatLinkAsAutolink(o, g)) {
    const p = g.stack;
    g.stack = [], h = g.enter("autolink");
    let M = n.move("<");
    return M += n.move(
      g.containerPhrasing(o, {
        before: M,
        after: ">",
        ...n.current()
      })
    ), M += n.move(">"), h(), g.stack = p, M;
  }
  h = g.enter("link"), d = g.enter("label");
  let k = n.move("[");
  return k += n.move(
    g.containerPhrasing(o, {
      before: k,
      after: "](",
      ...n.current()
    })
  ), k += n.move("]("), d(), // If there’s no url but there is a title…
  !o.url && o.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(o.url) ? (d = g.enter("destinationLiteral"), k += n.move("<"), k += n.move(
    g.safe(o.url, { before: k, after: ">", ...n.current() })
  ), k += n.move(">")) : (d = g.enter("destinationRaw"), k += n.move(
    g.safe(o.url, {
      before: k,
      after: o.title ? " " : ")",
      ...n.current()
    })
  )), d(), o.title && (d = g.enter(`title${t}`), k += n.move(" " + e), k += n.move(
    g.safe(o.title, {
      before: k,
      after: e,
      ...n.current()
    })
  ), k += n.move(e), d()), k += n.move(")"), h(), k;
}
function linkPeek(o, i, g) {
  return formatLinkAsAutolink(o, g) ? "<" : "[";
}
linkReference.peek = linkReferencePeek;
function linkReference(o, i, g, E) {
  const e = o.referenceType, t = g.enter("linkReference");
  let n = g.enter("label");
  const h = g.createTracker(E);
  let d = h.move("[");
  const k = g.containerPhrasing(o, {
    before: d,
    after: "]",
    ...h.current()
  });
  d += h.move(k + "]["), n();
  const p = g.stack;
  g.stack = [], n = g.enter("reference");
  const M = g.safe(g.associationId(o), {
    before: d,
    after: "]",
    ...h.current()
  });
  return n(), g.stack = p, t(), e === "full" || !k || k !== M ? d += h.move(M + "]") : e === "shortcut" ? d = d.slice(0, -1) : d += h.move("]"), d;
}
function linkReferencePeek() {
  return "[";
}
function checkBullet(o) {
  const i = o.options.bullet || "*";
  if (i !== "*" && i !== "+" && i !== "-")
    throw new Error(
      "Cannot serialize items with `" + i + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return i;
}
function checkBulletOther(o) {
  const i = checkBullet(o), g = o.options.bulletOther;
  if (!g)
    return i === "*" ? "-" : "*";
  if (g !== "*" && g !== "+" && g !== "-")
    throw new Error(
      "Cannot serialize items with `" + g + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (g === i)
    throw new Error(
      "Expected `bullet` (`" + i + "`) and `bulletOther` (`" + g + "`) to be different"
    );
  return g;
}
function checkBulletOrdered(o) {
  const i = o.options.bulletOrdered || ".";
  if (i !== "." && i !== ")")
    throw new Error(
      "Cannot serialize items with `" + i + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return i;
}
function checkRule(o) {
  const i = o.options.rule || "*";
  if (i !== "*" && i !== "-" && i !== "_")
    throw new Error(
      "Cannot serialize rules with `" + i + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return i;
}
function list(o, i, g, E) {
  const e = g.enter("list"), t = g.bulletCurrent;
  let n = o.ordered ? checkBulletOrdered(g) : checkBullet(g);
  const h = o.ordered ? n === "." ? ")" : "." : checkBulletOther(g);
  let d = i && g.bulletLastUsed ? n === g.bulletLastUsed : !1;
  if (!o.ordered) {
    const p = o.children ? o.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (n === "*" || n === "-") && // Empty first list item:
      p && (!p.children || !p.children[0]) && // Directly in two other list items:
      g.stack[g.stack.length - 1] === "list" && g.stack[g.stack.length - 2] === "listItem" && g.stack[g.stack.length - 3] === "list" && g.stack[g.stack.length - 4] === "listItem" && // That are each the first child.
      g.indexStack[g.indexStack.length - 1] === 0 && g.indexStack[g.indexStack.length - 2] === 0 && g.indexStack[g.indexStack.length - 3] === 0 && (d = !0), checkRule(g) === n && p
    ) {
      let M = -1;
      for (; ++M < o.children.length; ) {
        const H = o.children[M];
        if (H && H.type === "listItem" && H.children && H.children[0] && H.children[0].type === "thematicBreak") {
          d = !0;
          break;
        }
      }
    }
  }
  d && (n = h), g.bulletCurrent = n;
  const k = g.containerFlow(o, E);
  return g.bulletLastUsed = n, g.bulletCurrent = t, e(), k;
}
function checkListItemIndent(o) {
  const i = o.options.listItemIndent || "one";
  if (i !== "tab" && i !== "one" && i !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + i + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return i;
}
function listItem(o, i, g, E) {
  const e = checkListItemIndent(g);
  let t = g.bulletCurrent || checkBullet(g);
  i && i.type === "list" && i.ordered && (t = (typeof i.start == "number" && i.start > -1 ? i.start : 1) + (g.options.incrementListMarker === !1 ? 0 : i.children.indexOf(o)) + t);
  let n = t.length + 1;
  (e === "tab" || e === "mixed" && (i && i.type === "list" && i.spread || o.spread)) && (n = Math.ceil(n / 4) * 4);
  const h = g.createTracker(E);
  h.move(t + " ".repeat(n - t.length)), h.shift(n);
  const d = g.enter("listItem"), k = g.indentLines(
    g.containerFlow(o, h.current()),
    p
  );
  return d(), k;
  function p(M, H, f) {
    return H ? (f ? "" : " ".repeat(n)) + M : (f ? t : t + " ".repeat(n - t.length)) + M;
  }
}
function paragraph(o, i, g, E) {
  const e = g.enter("paragraph"), t = g.enter("phrasing"), n = g.containerPhrasing(o, E);
  return t(), e(), n;
}
const phrasing = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  convert([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function root$1(o, i, g, E) {
  return (o.children.some(function(n) {
    return phrasing(n);
  }) ? g.containerPhrasing : g.containerFlow).call(g, o, E);
}
function checkStrong(o) {
  const i = o.options.strong || "*";
  if (i !== "*" && i !== "_")
    throw new Error(
      "Cannot serialize strong with `" + i + "` for `options.strong`, expected `*`, or `_`"
    );
  return i;
}
strong.peek = strongPeek;
function strong(o, i, g, E) {
  const e = checkStrong(g), t = g.enter("strong"), n = g.createTracker(E), h = n.move(e + e);
  let d = n.move(
    g.containerPhrasing(o, {
      after: e,
      before: h,
      ...n.current()
    })
  );
  const k = d.charCodeAt(0), p = encodeInfo(
    E.before.charCodeAt(E.before.length - 1),
    k,
    e
  );
  p.inside && (d = encodeCharacterReference(k) + d.slice(1));
  const M = d.charCodeAt(d.length - 1), H = encodeInfo(E.after.charCodeAt(0), M, e);
  H.inside && (d = d.slice(0, -1) + encodeCharacterReference(M));
  const f = n.move(e + e);
  return t(), g.attentionEncodeSurroundingInfo = {
    after: H.outside,
    before: p.outside
  }, h + d + f;
}
function strongPeek(o, i, g) {
  return g.options.strong || "*";
}
function text$2(o, i, g, E) {
  return g.safe(o.value, E);
}
function checkRuleRepetition(o) {
  const i = o.options.ruleRepetition || 3;
  if (i < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + i + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return i;
}
function thematicBreak(o, i, g) {
  const E = (checkRule(g) + (g.options.ruleSpaces ? " " : "")).repeat(checkRuleRepetition(g));
  return g.options.ruleSpaces ? E.slice(0, -1) : E;
}
const handle = {
  blockquote,
  break: hardBreak,
  code: code$2,
  definition,
  emphasis,
  hardBreak,
  heading,
  html,
  image,
  imageReference,
  inlineCode,
  link,
  linkReference,
  list,
  listItem,
  paragraph,
  root: root$1,
  strong,
  text: text$2,
  thematicBreak
};
function gfmTableFromMarkdown() {
  return {
    enter: {
      table: enterTable,
      tableData: enterCell,
      tableHeader: enterCell,
      tableRow: enterRow
    },
    exit: {
      codeText: exitCodeText,
      table: exitTable,
      tableData: exit,
      tableHeader: exit,
      tableRow: exit
    }
  };
}
function enterTable(o) {
  const i = o._align;
  this.enter(
    {
      type: "table",
      align: i.map(function(g) {
        return g === "none" ? null : g;
      }),
      children: []
    },
    o
  ), this.data.inTable = !0;
}
function exitTable(o) {
  this.exit(o), this.data.inTable = void 0;
}
function enterRow(o) {
  this.enter({ type: "tableRow", children: [] }, o);
}
function exit(o) {
  this.exit(o);
}
function enterCell(o) {
  this.enter({ type: "tableCell", children: [] }, o);
}
function exitCodeText(o) {
  let i = this.resume();
  this.data.inTable && (i = i.replace(/\\([\\|])/g, replace));
  const g = this.stack[this.stack.length - 1];
  g.type, g.value = i, this.exit(o);
}
function replace(o, i) {
  return i === "|" ? i : o;
}
function gfmTableToMarkdown(o) {
  const i = o || {}, g = i.tableCellPadding, E = i.tablePipeAlign, e = i.stringLength, t = g ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: H,
      table: n,
      tableCell: d,
      tableRow: h
    }
  };
  function n(f, AA, gA, IA) {
    return k(p(f, gA, IA), f.align);
  }
  function h(f, AA, gA, IA) {
    const BA = M(f, gA, IA), CA = k([BA]);
    return CA.slice(0, CA.indexOf(`
`));
  }
  function d(f, AA, gA, IA) {
    const BA = gA.enter("tableCell"), CA = gA.enter("phrasing"), QA = gA.containerPhrasing(f, {
      ...IA,
      before: t,
      after: t
    });
    return CA(), BA(), QA;
  }
  function k(f, AA) {
    return markdownTable(f, {
      align: AA,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: E,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: g,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: e
    });
  }
  function p(f, AA, gA) {
    const IA = f.children;
    let BA = -1;
    const CA = [], QA = AA.enter("table");
    for (; ++BA < IA.length; )
      CA[BA] = M(IA[BA], AA, gA);
    return QA(), CA;
  }
  function M(f, AA, gA) {
    const IA = f.children;
    let BA = -1;
    const CA = [], QA = AA.enter("tableRow");
    for (; ++BA < IA.length; )
      CA[BA] = d(IA[BA], f, AA, gA);
    return QA(), CA;
  }
  function H(f, AA, gA) {
    let IA = handle.inlineCode(f, AA, gA);
    return gA.stack.includes("tableCell") && (IA = IA.replace(/\|/g, "\\$&")), IA;
  }
}
function gfmTaskListItemFromMarkdown() {
  return {
    exit: {
      taskListCheckValueChecked: exitCheck,
      taskListCheckValueUnchecked: exitCheck,
      paragraph: exitParagraphWithTaskListItem
    }
  };
}
function gfmTaskListItemToMarkdown() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: listItemWithTaskListItem }
  };
}
function exitCheck(o) {
  const i = this.stack[this.stack.length - 2];
  i.type, i.checked = o.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(o) {
  const i = this.stack[this.stack.length - 2];
  if (i && i.type === "listItem" && typeof i.checked == "boolean") {
    const g = this.stack[this.stack.length - 1];
    g.type;
    const E = g.children[0];
    if (E && E.type === "text") {
      const e = i.children;
      let t = -1, n;
      for (; ++t < e.length; ) {
        const h = e[t];
        if (h.type === "paragraph") {
          n = h;
          break;
        }
      }
      n === g && (E.value = E.value.slice(1), E.value.length === 0 ? g.children.shift() : g.position && E.position && typeof E.position.start.offset == "number" && (E.position.start.column++, E.position.start.offset++, g.position.start = Object.assign({}, E.position.start)));
    }
  }
  this.exit(o);
}
function listItemWithTaskListItem(o, i, g, E) {
  const e = o.children[0], t = typeof o.checked == "boolean" && e && e.type === "paragraph", n = "[" + (o.checked ? "x" : " ") + "] ", h = g.createTracker(E);
  t && h.move(n);
  let d = handle.listItem(o, i, g, {
    ...E,
    ...h.current()
  });
  return t && (d = d.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, k)), d;
  function k(p) {
    return p + n;
  }
}
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ];
}
function gfmToMarkdown(o) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(o),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(o),
      gfmTaskListItemToMarkdown()
    ]
  };
}
const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: !0
}, domain = {
  tokenize: tokenizeDomain,
  partial: !0
}, path$2 = {
  tokenize: tokenizePath,
  partial: !0
}, trail = {
  tokenize: tokenizeTrail,
  partial: !0
}, emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: !0
}, wwwAutolink = {
  name: "wwwAutolink",
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
}, protocolAutolink = {
  name: "protocolAutolink",
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
}, emailAutolink = {
  name: "emailAutolink",
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
}, text$1 = {};
function gfmAutolinkLiteral() {
  return {
    text: text$1
  };
}
let code$1 = 48;
for (; code$1 < 123; )
  text$1[code$1] = emailAutolink, code$1++, code$1 === 58 ? code$1 = 65 : code$1 === 91 && (code$1 = 97);
text$1[43] = emailAutolink;
text$1[45] = emailAutolink;
text$1[46] = emailAutolink;
text$1[95] = emailAutolink;
text$1[72] = [emailAutolink, protocolAutolink];
text$1[104] = [emailAutolink, protocolAutolink];
text$1[87] = [emailAutolink, wwwAutolink];
text$1[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(o, i, g) {
  const E = this;
  let e, t;
  return n;
  function n(M) {
    return !gfmAtext(M) || !previousEmail.call(E, E.previous) || previousUnbalanced(E.events) ? g(M) : (o.enter("literalAutolink"), o.enter("literalAutolinkEmail"), h(M));
  }
  function h(M) {
    return gfmAtext(M) ? (o.consume(M), h) : M === 64 ? (o.consume(M), d) : g(M);
  }
  function d(M) {
    return M === 46 ? o.check(emailDomainDotTrail, p, k)(M) : M === 45 || M === 95 || asciiAlphanumeric(M) ? (t = !0, o.consume(M), d) : p(M);
  }
  function k(M) {
    return o.consume(M), e = !0, d;
  }
  function p(M) {
    return t && e && asciiAlpha(E.previous) ? (o.exit("literalAutolinkEmail"), o.exit("literalAutolink"), i(M)) : g(M);
  }
}
function tokenizeWwwAutolink(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return n !== 87 && n !== 119 || !previousWww.call(E, E.previous) || previousUnbalanced(E.events) ? g(n) : (o.enter("literalAutolink"), o.enter("literalAutolinkWww"), o.check(wwwPrefix, o.attempt(domain, o.attempt(path$2, t), g), g)(n));
  }
  function t(n) {
    return o.exit("literalAutolinkWww"), o.exit("literalAutolink"), i(n);
  }
}
function tokenizeProtocolAutolink(o, i, g) {
  const E = this;
  let e = "", t = !1;
  return n;
  function n(M) {
    return (M === 72 || M === 104) && previousProtocol.call(E, E.previous) && !previousUnbalanced(E.events) ? (o.enter("literalAutolink"), o.enter("literalAutolinkHttp"), e += String.fromCodePoint(M), o.consume(M), h) : g(M);
  }
  function h(M) {
    if (asciiAlpha(M) && e.length < 5)
      return e += String.fromCodePoint(M), o.consume(M), h;
    if (M === 58) {
      const H = e.toLowerCase();
      if (H === "http" || H === "https")
        return o.consume(M), d;
    }
    return g(M);
  }
  function d(M) {
    return M === 47 ? (o.consume(M), t ? k : (t = !0, d)) : g(M);
  }
  function k(M) {
    return M === null || asciiControl(M) || markdownLineEndingOrSpace(M) || unicodeWhitespace(M) || unicodePunctuation(M) ? g(M) : o.attempt(domain, o.attempt(path$2, p), g)(M);
  }
  function p(M) {
    return o.exit("literalAutolinkHttp"), o.exit("literalAutolink"), i(M);
  }
}
function tokenizeWwwPrefix(o, i, g) {
  let E = 0;
  return e;
  function e(n) {
    return (n === 87 || n === 119) && E < 3 ? (E++, o.consume(n), e) : n === 46 && E === 3 ? (o.consume(n), t) : g(n);
  }
  function t(n) {
    return n === null ? g(n) : i(n);
  }
}
function tokenizeDomain(o, i, g) {
  let E, e, t;
  return n;
  function n(k) {
    return k === 46 || k === 95 ? o.check(trail, d, h)(k) : k === null || markdownLineEndingOrSpace(k) || unicodeWhitespace(k) || k !== 45 && unicodePunctuation(k) ? d(k) : (t = !0, o.consume(k), n);
  }
  function h(k) {
    return k === 95 ? E = !0 : (e = E, E = void 0), o.consume(k), n;
  }
  function d(k) {
    return e || E || !t ? g(k) : i(k);
  }
}
function tokenizePath(o, i) {
  let g = 0, E = 0;
  return e;
  function e(n) {
    return n === 40 ? (g++, o.consume(n), e) : n === 41 && E < g ? t(n) : n === 33 || n === 34 || n === 38 || n === 39 || n === 41 || n === 42 || n === 44 || n === 46 || n === 58 || n === 59 || n === 60 || n === 63 || n === 93 || n === 95 || n === 126 ? o.check(trail, i, t)(n) : n === null || markdownLineEndingOrSpace(n) || unicodeWhitespace(n) ? i(n) : (o.consume(n), e);
  }
  function t(n) {
    return n === 41 && E++, o.consume(n), e;
  }
}
function tokenizeTrail(o, i, g) {
  return E;
  function E(h) {
    return h === 33 || h === 34 || h === 39 || h === 41 || h === 42 || h === 44 || h === 46 || h === 58 || h === 59 || h === 63 || h === 95 || h === 126 ? (o.consume(h), E) : h === 38 ? (o.consume(h), t) : h === 93 ? (o.consume(h), e) : (
      // `<` is an end.
      h === 60 || // So is whitespace.
      h === null || markdownLineEndingOrSpace(h) || unicodeWhitespace(h) ? i(h) : g(h)
    );
  }
  function e(h) {
    return h === null || h === 40 || h === 91 || markdownLineEndingOrSpace(h) || unicodeWhitespace(h) ? i(h) : E(h);
  }
  function t(h) {
    return asciiAlpha(h) ? n(h) : g(h);
  }
  function n(h) {
    return h === 59 ? (o.consume(h), E) : asciiAlpha(h) ? (o.consume(h), n) : g(h);
  }
}
function tokenizeEmailDomainDotTrail(o, i, g) {
  return E;
  function E(t) {
    return o.consume(t), e;
  }
  function e(t) {
    return asciiAlphanumeric(t) ? g(t) : i(t);
  }
}
function previousWww(o) {
  return o === null || o === 40 || o === 42 || o === 95 || o === 91 || o === 93 || o === 126 || markdownLineEndingOrSpace(o);
}
function previousProtocol(o) {
  return !asciiAlpha(o);
}
function previousEmail(o) {
  return !(o === 47 || gfmAtext(o));
}
function gfmAtext(o) {
  return o === 43 || o === 45 || o === 46 || o === 95 || asciiAlphanumeric(o);
}
function previousUnbalanced(o) {
  let i = o.length, g = !1;
  for (; i--; ) {
    const E = o[i][1];
    if ((E.type === "labelLink" || E.type === "labelImage") && !E._balanced) {
      g = !0;
      break;
    }
    if (E._gfmAutolinkLiteralWalkedInto) {
      g = !1;
      break;
    }
  }
  return o.length > 0 && !g && (o[o.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), g;
}
const indent = {
  tokenize: tokenizeIndent,
  partial: !0
};
function gfmFootnote() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: tokenizeGfmFootnoteCall
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}
function tokenizePotentialGfmFootnoteCall(o, i, g) {
  const E = this;
  let e = E.events.length;
  const t = E.parser.gfmFootnotes || (E.parser.gfmFootnotes = []);
  let n;
  for (; e--; ) {
    const d = E.events[e][1];
    if (d.type === "labelImage") {
      n = d;
      break;
    }
    if (d.type === "gfmFootnoteCall" || d.type === "labelLink" || d.type === "label" || d.type === "image" || d.type === "link")
      break;
  }
  return h;
  function h(d) {
    if (!n || !n._balanced)
      return g(d);
    const k = normalizeIdentifier(E.sliceSerialize({
      start: n.end,
      end: E.now()
    }));
    return k.codePointAt(0) !== 94 || !t.includes(k.slice(1)) ? g(d) : (o.enter("gfmFootnoteCallLabelMarker"), o.consume(d), o.exit("gfmFootnoteCallLabelMarker"), i(d));
  }
}
function resolveToPotentialGfmFootnoteCall(o, i) {
  let g = o.length;
  for (; g--; )
    if (o[g][1].type === "labelImage" && o[g][0] === "enter") {
      o[g][1];
      break;
    }
  o[g + 1][1].type = "data", o[g + 3][1].type = "gfmFootnoteCallLabelMarker";
  const E = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, o[g + 3][1].start),
    end: Object.assign({}, o[o.length - 1][1].end)
  }, e = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, o[g + 3][1].end),
    end: Object.assign({}, o[g + 3][1].end)
  };
  e.end.column++, e.end.offset++, e.end._bufferIndex++;
  const t = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, e.end),
    end: Object.assign({}, o[o.length - 1][1].start)
  }, n = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, t.start),
    end: Object.assign({}, t.end)
  }, h = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    o[g + 1],
    o[g + 2],
    ["enter", E, i],
    // The `[`
    o[g + 3],
    o[g + 4],
    // The `^`.
    ["enter", e, i],
    ["exit", e, i],
    // Everything in between.
    ["enter", t, i],
    ["enter", n, i],
    ["exit", n, i],
    ["exit", t, i],
    // The ending (`]`, properly parsed and labelled).
    o[o.length - 2],
    o[o.length - 1],
    ["exit", E, i]
  ];
  return o.splice(g, o.length - g + 1, ...h), o;
}
function tokenizeGfmFootnoteCall(o, i, g) {
  const E = this, e = E.parser.gfmFootnotes || (E.parser.gfmFootnotes = []);
  let t = 0, n;
  return h;
  function h(M) {
    return o.enter("gfmFootnoteCall"), o.enter("gfmFootnoteCallLabelMarker"), o.consume(M), o.exit("gfmFootnoteCallLabelMarker"), d;
  }
  function d(M) {
    return M !== 94 ? g(M) : (o.enter("gfmFootnoteCallMarker"), o.consume(M), o.exit("gfmFootnoteCallMarker"), o.enter("gfmFootnoteCallString"), o.enter("chunkString").contentType = "string", k);
  }
  function k(M) {
    if (
      // Too long.
      t > 999 || // Closing brace with nothing.
      M === 93 && !n || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      M === null || M === 91 || markdownLineEndingOrSpace(M)
    )
      return g(M);
    if (M === 93) {
      o.exit("chunkString");
      const H = o.exit("gfmFootnoteCallString");
      return e.includes(normalizeIdentifier(E.sliceSerialize(H))) ? (o.enter("gfmFootnoteCallLabelMarker"), o.consume(M), o.exit("gfmFootnoteCallLabelMarker"), o.exit("gfmFootnoteCall"), i) : g(M);
    }
    return markdownLineEndingOrSpace(M) || (n = !0), t++, o.consume(M), M === 92 ? p : k;
  }
  function p(M) {
    return M === 91 || M === 92 || M === 93 ? (o.consume(M), t++, k) : k(M);
  }
}
function tokenizeDefinitionStart(o, i, g) {
  const E = this, e = E.parser.gfmFootnotes || (E.parser.gfmFootnotes = []);
  let t, n = 0, h;
  return d;
  function d(AA) {
    return o.enter("gfmFootnoteDefinition")._container = !0, o.enter("gfmFootnoteDefinitionLabel"), o.enter("gfmFootnoteDefinitionLabelMarker"), o.consume(AA), o.exit("gfmFootnoteDefinitionLabelMarker"), k;
  }
  function k(AA) {
    return AA === 94 ? (o.enter("gfmFootnoteDefinitionMarker"), o.consume(AA), o.exit("gfmFootnoteDefinitionMarker"), o.enter("gfmFootnoteDefinitionLabelString"), o.enter("chunkString").contentType = "string", p) : g(AA);
  }
  function p(AA) {
    if (
      // Too long.
      n > 999 || // Closing brace with nothing.
      AA === 93 && !h || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      AA === null || AA === 91 || markdownLineEndingOrSpace(AA)
    )
      return g(AA);
    if (AA === 93) {
      o.exit("chunkString");
      const gA = o.exit("gfmFootnoteDefinitionLabelString");
      return t = normalizeIdentifier(E.sliceSerialize(gA)), o.enter("gfmFootnoteDefinitionLabelMarker"), o.consume(AA), o.exit("gfmFootnoteDefinitionLabelMarker"), o.exit("gfmFootnoteDefinitionLabel"), H;
    }
    return markdownLineEndingOrSpace(AA) || (h = !0), n++, o.consume(AA), AA === 92 ? M : p;
  }
  function M(AA) {
    return AA === 91 || AA === 92 || AA === 93 ? (o.consume(AA), n++, p) : p(AA);
  }
  function H(AA) {
    return AA === 58 ? (o.enter("definitionMarker"), o.consume(AA), o.exit("definitionMarker"), e.includes(t) || e.push(t), factorySpace(o, f, "gfmFootnoteDefinitionWhitespace")) : g(AA);
  }
  function f(AA) {
    return i(AA);
  }
}
function tokenizeDefinitionContinuation(o, i, g) {
  return o.check(blankLine, i, o.attempt(indent, i, g));
}
function gfmFootnoteDefinitionEnd(o) {
  o.exit("gfmFootnoteDefinition");
}
function tokenizeIndent(o, i, g) {
  const E = this;
  return factorySpace(o, e, "gfmFootnoteDefinitionIndent", 5);
  function e(t) {
    const n = E.events[E.events.length - 1];
    return n && n[1].type === "gfmFootnoteDefinitionIndent" && n[2].sliceSerialize(n[1], !0).length === 4 ? i(t) : g(t);
  }
}
function gfmStrikethrough(o) {
  let g = (o || {}).singleTilde;
  const E = {
    name: "strikethrough",
    tokenize: t,
    resolveAll: e
  };
  return g == null && (g = !0), {
    text: {
      126: E
    },
    insideSpan: {
      null: [E]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function e(n, h) {
    let d = -1;
    for (; ++d < n.length; )
      if (n[d][0] === "enter" && n[d][1].type === "strikethroughSequenceTemporary" && n[d][1]._close) {
        let k = d;
        for (; k--; )
          if (n[k][0] === "exit" && n[k][1].type === "strikethroughSequenceTemporary" && n[k][1]._open && // If the sizes are the same:
          n[d][1].end.offset - n[d][1].start.offset === n[k][1].end.offset - n[k][1].start.offset) {
            n[d][1].type = "strikethroughSequence", n[k][1].type = "strikethroughSequence";
            const p = {
              type: "strikethrough",
              start: Object.assign({}, n[k][1].start),
              end: Object.assign({}, n[d][1].end)
            }, M = {
              type: "strikethroughText",
              start: Object.assign({}, n[k][1].end),
              end: Object.assign({}, n[d][1].start)
            }, H = [["enter", p, h], ["enter", n[k][1], h], ["exit", n[k][1], h], ["enter", M, h]], f = h.parser.constructs.insideSpan.null;
            f && splice(H, H.length, 0, resolveAll(f, n.slice(k + 1, d), h)), splice(H, H.length, 0, [["exit", M, h], ["enter", n[d][1], h], ["exit", n[d][1], h], ["exit", p, h]]), splice(n, k - 1, d - k + 3, H), d = k + H.length - 2;
            break;
          }
      }
    for (d = -1; ++d < n.length; )
      n[d][1].type === "strikethroughSequenceTemporary" && (n[d][1].type = "data");
    return n;
  }
  function t(n, h, d) {
    const k = this.previous, p = this.events;
    let M = 0;
    return H;
    function H(AA) {
      return k === 126 && p[p.length - 1][1].type !== "characterEscape" ? d(AA) : (n.enter("strikethroughSequenceTemporary"), f(AA));
    }
    function f(AA) {
      const gA = classifyCharacter(k);
      if (AA === 126)
        return M > 1 ? d(AA) : (n.consume(AA), M++, f);
      if (M < 2 && !g) return d(AA);
      const IA = n.exit("strikethroughSequenceTemporary"), BA = classifyCharacter(AA);
      return IA._open = !BA || BA === 2 && !!gA, IA._close = !gA || gA === 2 && !!BA, h(AA);
    }
  }
}
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(i, g, E) {
    addImplementation(this, i, g, E);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(i) {
    if (this.map.sort(function(t, n) {
      return t[0] - n[0];
    }), this.map.length === 0)
      return;
    let g = this.map.length;
    const E = [];
    for (; g > 0; )
      g -= 1, E.push(i.slice(this.map[g][0] + this.map[g][1]), this.map[g][2]), i.length = this.map[g][0];
    E.push(i.slice()), i.length = 0;
    let e = E.pop();
    for (; e; ) {
      for (const t of e)
        i.push(t);
      e = E.pop();
    }
    this.map.length = 0;
  }
}
function addImplementation(o, i, g, E) {
  let e = 0;
  if (!(g === 0 && E.length === 0)) {
    for (; e < o.map.length; ) {
      if (o.map[e][0] === i) {
        o.map[e][1] += g, o.map[e][2].push(...E);
        return;
      }
      e += 1;
    }
    o.map.push([i, g, E]);
  }
}
function gfmTableAlign(o, i) {
  let g = !1;
  const E = [];
  for (; i < o.length; ) {
    const e = o[i];
    if (g) {
      if (e[0] === "enter")
        e[1].type === "tableContent" && E.push(o[i + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (e[1].type === "tableContent") {
        if (o[i - 1][1].type === "tableDelimiterMarker") {
          const t = E.length - 1;
          E[t] = E[t] === "left" ? "center" : "right";
        }
      } else if (e[1].type === "tableDelimiterRow")
        break;
    } else e[0] === "enter" && e[1].type === "tableDelimiterRow" && (g = !0);
    i += 1;
  }
  return E;
}
function gfmTable() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: tokenizeTable,
        resolveAll: resolveTable
      }
    }
  };
}
function tokenizeTable(o, i, g) {
  const E = this;
  let e = 0, t = 0, n;
  return h;
  function h(tA) {
    let aA = E.events.length - 1;
    for (; aA > -1; ) {
      const rA = E.events[aA][1].type;
      if (rA === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      rA === "linePrefix") aA--;
      else break;
    }
    const sA = aA > -1 ? E.events[aA][1].type : null, DA = sA === "tableHead" || sA === "tableRow" ? oA : d;
    return DA === oA && E.parser.lazy[E.now().line] ? g(tA) : DA(tA);
  }
  function d(tA) {
    return o.enter("tableHead"), o.enter("tableRow"), k(tA);
  }
  function k(tA) {
    return tA === 124 || (n = !0, t += 1), p(tA);
  }
  function p(tA) {
    return tA === null ? g(tA) : markdownLineEnding(tA) ? t > 1 ? (t = 0, E.interrupt = !0, o.exit("tableRow"), o.enter("lineEnding"), o.consume(tA), o.exit("lineEnding"), f) : g(tA) : markdownSpace(tA) ? factorySpace(o, p, "whitespace")(tA) : (t += 1, n && (n = !1, e += 1), tA === 124 ? (o.enter("tableCellDivider"), o.consume(tA), o.exit("tableCellDivider"), n = !0, p) : (o.enter("data"), M(tA)));
  }
  function M(tA) {
    return tA === null || tA === 124 || markdownLineEndingOrSpace(tA) ? (o.exit("data"), p(tA)) : (o.consume(tA), tA === 92 ? H : M);
  }
  function H(tA) {
    return tA === 92 || tA === 124 ? (o.consume(tA), M) : M(tA);
  }
  function f(tA) {
    return E.interrupt = !1, E.parser.lazy[E.now().line] ? g(tA) : (o.enter("tableDelimiterRow"), n = !1, markdownSpace(tA) ? factorySpace(o, AA, "linePrefix", E.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(tA) : AA(tA));
  }
  function AA(tA) {
    return tA === 45 || tA === 58 ? IA(tA) : tA === 124 ? (n = !0, o.enter("tableCellDivider"), o.consume(tA), o.exit("tableCellDivider"), gA) : EA(tA);
  }
  function gA(tA) {
    return markdownSpace(tA) ? factorySpace(o, IA, "whitespace")(tA) : IA(tA);
  }
  function IA(tA) {
    return tA === 58 ? (t += 1, n = !0, o.enter("tableDelimiterMarker"), o.consume(tA), o.exit("tableDelimiterMarker"), BA) : tA === 45 ? (t += 1, BA(tA)) : tA === null || markdownLineEnding(tA) ? iA(tA) : EA(tA);
  }
  function BA(tA) {
    return tA === 45 ? (o.enter("tableDelimiterFiller"), CA(tA)) : EA(tA);
  }
  function CA(tA) {
    return tA === 45 ? (o.consume(tA), CA) : tA === 58 ? (n = !0, o.exit("tableDelimiterFiller"), o.enter("tableDelimiterMarker"), o.consume(tA), o.exit("tableDelimiterMarker"), QA) : (o.exit("tableDelimiterFiller"), QA(tA));
  }
  function QA(tA) {
    return markdownSpace(tA) ? factorySpace(o, iA, "whitespace")(tA) : iA(tA);
  }
  function iA(tA) {
    return tA === 124 ? AA(tA) : tA === null || markdownLineEnding(tA) ? !n || e !== t ? EA(tA) : (o.exit("tableDelimiterRow"), o.exit("tableHead"), i(tA)) : EA(tA);
  }
  function EA(tA) {
    return g(tA);
  }
  function oA(tA) {
    return o.enter("tableRow"), eA(tA);
  }
  function eA(tA) {
    return tA === 124 ? (o.enter("tableCellDivider"), o.consume(tA), o.exit("tableCellDivider"), eA) : tA === null || markdownLineEnding(tA) ? (o.exit("tableRow"), i(tA)) : markdownSpace(tA) ? factorySpace(o, eA, "whitespace")(tA) : (o.enter("data"), GA(tA));
  }
  function GA(tA) {
    return tA === null || tA === 124 || markdownLineEndingOrSpace(tA) ? (o.exit("data"), eA(tA)) : (o.consume(tA), tA === 92 ? cA : GA);
  }
  function cA(tA) {
    return tA === 92 || tA === 124 ? (o.consume(tA), GA) : GA(tA);
  }
}
function resolveTable(o, i) {
  let g = -1, E = !0, e = 0, t = [0, 0, 0, 0], n = [0, 0, 0, 0], h = !1, d = 0, k, p, M;
  const H = new EditMap();
  for (; ++g < o.length; ) {
    const f = o[g], AA = f[1];
    f[0] === "enter" ? AA.type === "tableHead" ? (h = !1, d !== 0 && (flushTableEnd(H, i, d, k, p), p = void 0, d = 0), k = {
      type: "table",
      start: Object.assign({}, AA.start),
      // Note: correct end is set later.
      end: Object.assign({}, AA.end)
    }, H.add(g, 0, [["enter", k, i]])) : AA.type === "tableRow" || AA.type === "tableDelimiterRow" ? (E = !0, M = void 0, t = [0, 0, 0, 0], n = [0, g + 1, 0, 0], h && (h = !1, p = {
      type: "tableBody",
      start: Object.assign({}, AA.start),
      // Note: correct end is set later.
      end: Object.assign({}, AA.end)
    }, H.add(g, 0, [["enter", p, i]])), e = AA.type === "tableDelimiterRow" ? 2 : p ? 3 : 1) : e && (AA.type === "data" || AA.type === "tableDelimiterMarker" || AA.type === "tableDelimiterFiller") ? (E = !1, n[2] === 0 && (t[1] !== 0 && (n[0] = n[1], M = flushCell(H, i, t, e, void 0, M), t = [0, 0, 0, 0]), n[2] = g)) : AA.type === "tableCellDivider" && (E ? E = !1 : (t[1] !== 0 && (n[0] = n[1], M = flushCell(H, i, t, e, void 0, M)), t = n, n = [t[1], g, 0, 0])) : AA.type === "tableHead" ? (h = !0, d = g) : AA.type === "tableRow" || AA.type === "tableDelimiterRow" ? (d = g, t[1] !== 0 ? (n[0] = n[1], M = flushCell(H, i, t, e, g, M)) : n[1] !== 0 && (M = flushCell(H, i, n, e, g, M)), e = 0) : e && (AA.type === "data" || AA.type === "tableDelimiterMarker" || AA.type === "tableDelimiterFiller") && (n[3] = g);
  }
  for (d !== 0 && flushTableEnd(H, i, d, k, p), H.consume(i.events), g = -1; ++g < i.events.length; ) {
    const f = i.events[g];
    f[0] === "enter" && f[1].type === "table" && (f[1]._align = gfmTableAlign(i.events, g));
  }
  return o;
}
function flushCell(o, i, g, E, e, t) {
  const n = E === 1 ? "tableHeader" : E === 2 ? "tableDelimiter" : "tableData", h = "tableContent";
  g[0] !== 0 && (t.end = Object.assign({}, getPoint(i.events, g[0])), o.add(g[0], 0, [["exit", t, i]]));
  const d = getPoint(i.events, g[1]);
  if (t = {
    type: n,
    start: Object.assign({}, d),
    // Note: correct end is set later.
    end: Object.assign({}, d)
  }, o.add(g[1], 0, [["enter", t, i]]), g[2] !== 0) {
    const k = getPoint(i.events, g[2]), p = getPoint(i.events, g[3]), M = {
      type: h,
      start: Object.assign({}, k),
      end: Object.assign({}, p)
    };
    if (o.add(g[2], 0, [["enter", M, i]]), E !== 2) {
      const H = i.events[g[2]], f = i.events[g[3]];
      if (H[1].end = Object.assign({}, f[1].end), H[1].type = "chunkText", H[1].contentType = "text", g[3] > g[2] + 1) {
        const AA = g[2] + 1, gA = g[3] - g[2] - 1;
        o.add(AA, gA, []);
      }
    }
    o.add(g[3] + 1, 0, [["exit", M, i]]);
  }
  return e !== void 0 && (t.end = Object.assign({}, getPoint(i.events, e)), o.add(e, 0, [["exit", t, i]]), t = void 0), t;
}
function flushTableEnd(o, i, g, E, e) {
  const t = [], n = getPoint(i.events, g);
  e && (e.end = Object.assign({}, n), t.push(["exit", e, i])), E.end = Object.assign({}, n), t.push(["exit", E, i]), o.add(g + 1, 0, t);
}
function getPoint(o, i) {
  const g = o[i], E = g[0] === "enter" ? "start" : "end";
  return g[1][E];
}
const tasklistCheck = {
  name: "tasklistCheck",
  tokenize: tokenizeTasklistCheck
};
function gfmTaskListItem() {
  return {
    text: {
      91: tasklistCheck
    }
  };
}
function tokenizeTasklistCheck(o, i, g) {
  const E = this;
  return e;
  function e(d) {
    return (
      // Exit if there’s stuff before.
      E.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !E._gfmTasklistFirstContentOfListItem ? g(d) : (o.enter("taskListCheck"), o.enter("taskListCheckMarker"), o.consume(d), o.exit("taskListCheckMarker"), t)
    );
  }
  function t(d) {
    return markdownLineEndingOrSpace(d) ? (o.enter("taskListCheckValueUnchecked"), o.consume(d), o.exit("taskListCheckValueUnchecked"), n) : d === 88 || d === 120 ? (o.enter("taskListCheckValueChecked"), o.consume(d), o.exit("taskListCheckValueChecked"), n) : g(d);
  }
  function n(d) {
    return d === 93 ? (o.enter("taskListCheckMarker"), o.consume(d), o.exit("taskListCheckMarker"), o.exit("taskListCheck"), h) : g(d);
  }
  function h(d) {
    return markdownLineEnding(d) ? i(d) : markdownSpace(d) ? o.check({
      tokenize: spaceThenNonSpace
    }, i, g)(d) : g(d);
  }
}
function spaceThenNonSpace(o, i, g) {
  return factorySpace(o, E, "whitespace");
  function E(e) {
    return e === null ? g(e) : i(e);
  }
}
function gfm(o) {
  return combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(o),
    gfmTable(),
    gfmTaskListItem()
  ]);
}
const emptyOptions$1 = {};
function remarkGfm(o) {
  const i = (
    /** @type {Processor<Root>} */
    this
  ), g = o || emptyOptions$1, E = i.data(), e = E.micromarkExtensions || (E.micromarkExtensions = []), t = E.fromMarkdownExtensions || (E.fromMarkdownExtensions = []), n = E.toMarkdownExtensions || (E.toMarkdownExtensions = []);
  e.push(gfm(g)), t.push(gfmFromMarkdown()), n.push(gfmToMarkdown(g));
}
function mathFromMarkdown() {
  return {
    enter: {
      mathFlow: o,
      mathFlowFenceMeta: i,
      mathText: t
    },
    exit: {
      mathFlow: e,
      mathFlowFence: E,
      mathFlowFenceMeta: g,
      mathFlowValue: h,
      mathText: n,
      mathTextData: h
    }
  };
  function o(d) {
    const k = {
      type: "element",
      tagName: "code",
      properties: { className: ["language-math", "math-display"] },
      children: []
    };
    this.enter(
      {
        type: "math",
        meta: null,
        value: "",
        data: { hName: "pre", hChildren: [k] }
      },
      d
    );
  }
  function i() {
    this.buffer();
  }
  function g() {
    const d = this.resume(), k = this.stack[this.stack.length - 1];
    k.type, k.meta = d;
  }
  function E() {
    this.data.mathFlowInside || (this.buffer(), this.data.mathFlowInside = !0);
  }
  function e(d) {
    const k = this.resume().replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), p = this.stack[this.stack.length - 1];
    p.type, this.exit(d), p.value = k;
    const M = (
      /** @type {HastElement} */
      p.data.hChildren[0]
    );
    M.type, M.tagName, M.children.push({ type: "text", value: k }), this.data.mathFlowInside = void 0;
  }
  function t(d) {
    this.enter(
      {
        type: "inlineMath",
        value: "",
        data: {
          hName: "code",
          hProperties: { className: ["language-math", "math-inline"] },
          hChildren: []
        }
      },
      d
    ), this.buffer();
  }
  function n(d) {
    const k = this.resume(), p = this.stack[this.stack.length - 1];
    p.type, this.exit(d), p.value = k, /** @type {Array<HastElementContent>} */
    // @ts-expect-error: we defined it in `enterMathFlow`.
    p.data.hChildren.push({ type: "text", value: k });
  }
  function h(d) {
    this.config.enter.data.call(this, d), this.config.exit.data.call(this, d);
  }
}
function mathToMarkdown(o) {
  let i = (o || {}).singleDollarTextMath;
  return i == null && (i = !0), E.peek = e, {
    unsafe: [
      { character: "\r", inConstruct: "mathFlowMeta" },
      { character: `
`, inConstruct: "mathFlowMeta" },
      {
        character: "$",
        after: i ? void 0 : "\\$",
        inConstruct: "phrasing"
      },
      { character: "$", inConstruct: "mathFlowMeta" },
      { atBreak: !0, character: "$", after: "\\$" }
    ],
    handlers: { math: g, inlineMath: E }
  };
  function g(t, n, h, d) {
    const k = t.value || "", p = h.createTracker(d), M = "$".repeat(Math.max(longestStreak(k, "$") + 1, 2)), H = h.enter("mathFlow");
    let f = p.move(M);
    if (t.meta) {
      const AA = h.enter("mathFlowMeta");
      f += p.move(
        h.safe(t.meta, {
          after: `
`,
          before: f,
          encode: ["$"],
          ...p.current()
        })
      ), AA();
    }
    return f += p.move(`
`), k && (f += p.move(k + `
`)), f += p.move(M), H(), f;
  }
  function E(t, n, h) {
    let d = t.value || "", k = 1;
    for (i || k++; new RegExp("(^|[^$])" + "\\$".repeat(k) + "([^$]|$)").test(d); )
      k++;
    const p = "$".repeat(k);
    // Contains non-space.
    /[^ \r\n]/.test(d) && // Starts with space and ends with space.
    (/^[ \r\n]/.test(d) && /[ \r\n]$/.test(d) || // Starts or ends with dollar.
    /^\$|\$$/.test(d)) && (d = " " + d + " ");
    let M = -1;
    for (; ++M < h.unsafe.length; ) {
      const H = h.unsafe[M];
      if (!H.atBreak) continue;
      const f = h.compilePattern(H);
      let AA;
      for (; AA = f.exec(d); ) {
        let gA = AA.index;
        d.codePointAt(gA) === 10 && d.codePointAt(gA - 1) === 13 && gA--, d = d.slice(0, gA) + " " + d.slice(AA.index + 1);
      }
    }
    return p + d + p;
  }
  function e() {
    return "$";
  }
}
const mathFlow = {
  tokenize: tokenizeMathFenced,
  concrete: !0,
  name: "mathFlow"
}, nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: !0
};
function tokenizeMathFenced(o, i, g) {
  const E = this, e = E.events[E.events.length - 1], t = e && e[1].type === "linePrefix" ? e[2].sliceSerialize(e[1], !0).length : 0;
  let n = 0;
  return h;
  function h(CA) {
    return o.enter("mathFlow"), o.enter("mathFlowFence"), o.enter("mathFlowFenceSequence"), d(CA);
  }
  function d(CA) {
    return CA === 36 ? (o.consume(CA), n++, d) : n < 2 ? g(CA) : (o.exit("mathFlowFenceSequence"), factorySpace(o, k, "whitespace")(CA));
  }
  function k(CA) {
    return CA === null || markdownLineEnding(CA) ? M(CA) : (o.enter("mathFlowFenceMeta"), o.enter("chunkString", {
      contentType: "string"
    }), p(CA));
  }
  function p(CA) {
    return CA === null || markdownLineEnding(CA) ? (o.exit("chunkString"), o.exit("mathFlowFenceMeta"), M(CA)) : CA === 36 ? g(CA) : (o.consume(CA), p);
  }
  function M(CA) {
    return o.exit("mathFlowFence"), E.interrupt ? i(CA) : o.attempt(nonLazyContinuation, H, IA)(CA);
  }
  function H(CA) {
    return o.attempt({
      tokenize: BA,
      partial: !0
    }, IA, f)(CA);
  }
  function f(CA) {
    return (t ? factorySpace(o, AA, "linePrefix", t + 1) : AA)(CA);
  }
  function AA(CA) {
    return CA === null ? IA(CA) : markdownLineEnding(CA) ? o.attempt(nonLazyContinuation, H, IA)(CA) : (o.enter("mathFlowValue"), gA(CA));
  }
  function gA(CA) {
    return CA === null || markdownLineEnding(CA) ? (o.exit("mathFlowValue"), AA(CA)) : (o.consume(CA), gA);
  }
  function IA(CA) {
    return o.exit("mathFlow"), i(CA);
  }
  function BA(CA, QA, iA) {
    let EA = 0;
    return factorySpace(CA, oA, "linePrefix", E.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function oA(cA) {
      return CA.enter("mathFlowFence"), CA.enter("mathFlowFenceSequence"), eA(cA);
    }
    function eA(cA) {
      return cA === 36 ? (EA++, CA.consume(cA), eA) : EA < n ? iA(cA) : (CA.exit("mathFlowFenceSequence"), factorySpace(CA, GA, "whitespace")(cA));
    }
    function GA(cA) {
      return cA === null || markdownLineEnding(cA) ? (CA.exit("mathFlowFence"), QA(cA)) : iA(cA);
    }
  }
}
function tokenizeNonLazyContinuation(o, i, g) {
  const E = this;
  return e;
  function e(n) {
    return n === null ? i(n) : (o.enter("lineEnding"), o.consume(n), o.exit("lineEnding"), t);
  }
  function t(n) {
    return E.parser.lazy[E.now().line] ? g(n) : i(n);
  }
}
function mathText(o) {
  let g = (o || {}).singleDollarTextMath;
  return g == null && (g = !0), {
    tokenize: E,
    resolve: resolveMathText,
    previous,
    name: "mathText"
  };
  function E(e, t, n) {
    let h = 0, d, k;
    return p;
    function p(gA) {
      return e.enter("mathText"), e.enter("mathTextSequence"), M(gA);
    }
    function M(gA) {
      return gA === 36 ? (e.consume(gA), h++, M) : h < 2 && !g ? n(gA) : (e.exit("mathTextSequence"), H(gA));
    }
    function H(gA) {
      return gA === null ? n(gA) : gA === 36 ? (k = e.enter("mathTextSequence"), d = 0, AA(gA)) : gA === 32 ? (e.enter("space"), e.consume(gA), e.exit("space"), H) : markdownLineEnding(gA) ? (e.enter("lineEnding"), e.consume(gA), e.exit("lineEnding"), H) : (e.enter("mathTextData"), f(gA));
    }
    function f(gA) {
      return gA === null || gA === 32 || gA === 36 || markdownLineEnding(gA) ? (e.exit("mathTextData"), H(gA)) : (e.consume(gA), f);
    }
    function AA(gA) {
      return gA === 36 ? (e.consume(gA), d++, AA) : d === h ? (e.exit("mathTextSequence"), e.exit("mathText"), t(gA)) : (k.type = "mathTextData", f(gA));
    }
  }
}
function resolveMathText(o) {
  let i = o.length - 4, g = 3, E, e;
  if ((o[g][1].type === "lineEnding" || o[g][1].type === "space") && (o[i][1].type === "lineEnding" || o[i][1].type === "space")) {
    for (E = g; ++E < i; )
      if (o[E][1].type === "mathTextData") {
        o[i][1].type = "mathTextPadding", o[g][1].type = "mathTextPadding", g += 2, i -= 2;
        break;
      }
  }
  for (E = g - 1, i++; ++E <= i; )
    e === void 0 ? E !== i && o[E][1].type !== "lineEnding" && (e = E) : (E === i || o[E][1].type === "lineEnding") && (o[e][1].type = "mathTextData", E !== e + 2 && (o[e][1].end = o[E - 1][1].end, o.splice(e + 2, E - e - 2), i -= E - e - 2, E = e + 2), e = void 0);
  return o;
}
function previous(o) {
  return o !== 36 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function math(o) {
  return {
    flow: {
      36: mathFlow
    },
    text: {
      36: mathText(o)
    }
  };
}
const emptyOptions = {};
function remarkMath(o) {
  const i = (
    /** @type {Processor} */
    this
  ), g = o || emptyOptions, E = i.data(), e = E.micromarkExtensions || (E.micromarkExtensions = []), t = E.fromMarkdownExtensions || (E.fromMarkdownExtensions = []), n = E.toMarkdownExtensions || (E.toMarkdownExtensions = []);
  e.push(math(g)), t.push(mathFromMarkdown()), n.push(mathToMarkdown(g));
}
function visit(o, i, g, E) {
  let e, t, n;
  typeof i == "function" && typeof g != "function" ? (t = void 0, n = i, e = g) : (t = i, n = g, e = E), visitParents(o, t, h, e);
  function h(d, k) {
    const p = k[k.length - 1], M = p ? p.children.indexOf(d) : void 0;
    return n(d, M, p);
  }
}
const streamlitLogo = "data:image/svg+xml,%3csvg%20width='301'%20height='165'%20viewBox='0%200%20301%20165'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M150.731%20101.547L98.1387%2073.7471L6.84674%2025.4969C6.7634%2025.4136%206.59674%2025.4136%206.51341%2025.4136C3.18007%2023.8303%20-0.236608%2027.1636%201.0134%2030.497L47.5302%20149.139L47.5385%20149.164C47.5885%20149.281%2047.6302%20149.397%2047.6802%20149.514C49.5885%20153.939%2053.7552%20156.672%2058.2886%20157.747C58.6719%20157.831%2058.9461%20157.906%2059.4064%20157.998C59.8645%20158.1%2060.5052%20158.239%2061.0552%20158.281C61.1469%20158.289%2061.2302%20158.289%2061.3219%20158.297H61.3886C61.4552%20158.306%2061.5219%20158.306%2061.5886%20158.314H61.6802C61.7386%20158.322%2061.8052%20158.322%2061.8636%20158.322H61.9719C62.0386%20158.331%2062.1052%20158.331%2062.1719%20158.331V158.331C121.084%20164.754%20180.519%20164.754%20239.431%20158.331V158.331C240.139%20158.331%20240.831%20158.297%20241.497%20158.231C241.714%20158.206%20241.922%20158.181%20242.131%20158.156C242.156%20158.147%20242.189%20158.147%20242.214%20158.139C242.356%20158.122%20242.497%20158.097%20242.639%20158.072C242.847%20158.047%20243.056%20158.006%20243.264%20157.964C243.681%20157.872%20243.87%20157.806%20244.436%20157.611C245.001%20157.417%20245.94%20157.077%20246.527%20156.794C247.115%20156.511%20247.522%20156.239%20248.014%20155.931C248.622%20155.547%20249.201%20155.155%20249.788%20154.715C250.041%20154.521%20250.214%20154.397%20250.397%20154.222L250.297%20154.164L150.731%20101.547Z'%20fill='%23FF4B4B'/%3e%3cpath%20d='M294.766%2025.4981H294.683L203.357%2073.7483L254.124%20149.357L300.524%2030.4981V30.3315C301.691%2026.8314%20298.108%2023.6648%20294.766%2025.4981'%20fill='%237D353B'/%3e%3cpath%20d='M155.598%202.55572C153.264%20-0.852624%20148.181%20-0.852624%20145.931%202.55572L98.1389%2073.7477L150.731%20101.548L250.398%20154.222C251.024%20153.609%20251.526%20153.012%20252.056%20152.381C252.806%20151.456%20253.506%20150.465%20254.123%20149.356L203.356%2073.7477L155.598%202.55572Z'%20fill='%23BD4043'/%3e%3c/svg%3e", IsSidebarContext = createContext(!1);
IsSidebarContext.displayName = "IsSidebarContext";
const codeLink = {
  // Streamline the style when inside anchors to avoid broken underline and more
  "a > &": {
    color: "inherit"
  }
}, StyledInlineCode = /* @__PURE__ */ createStyled("code", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz5"
} : {
  target: "e1ycw9pz5",
  label: "StyledInlineCode"
})(({
  theme: o
}) => ({
  padding: "0.2em 0.4em",
  overflowWrap: "break-word",
  whiteSpace: "pre-wrap",
  margin: 0,
  borderRadius: o.radii.md,
  background: o.colors.codeBackgroundColor,
  color: o.colors.codeTextColor,
  fontFamily: o.genericFonts.codeFont,
  // Use em here so that it works correctly within headers, captions,
  // sidebar, etc.
  fontSize: o.fontSizes.inlineCodeFontSize,
  fontWeight: o.fontWeights.code,
  ...codeLink
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), codeBlockStyle = (o, i) => ({
  background: "transparent",
  border: 0,
  color: "inherit",
  display: "inline",
  fontFamily: o.genericFonts.codeFont,
  fontSize: o.fontSizes.codeFontSize,
  fontWeight: o.fontWeights.code,
  lineHeight: "inherit",
  margin: 0,
  overflowX: "auto",
  padding: 0,
  whiteSpace: i ? "pre-wrap" : "pre",
  overflowWrap: i ? "break-word" : "normal",
  ...codeLink
}), StyledCode = /* @__PURE__ */ createStyled("code", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz4"
} : {
  target: "e1ycw9pz4",
  label: "StyledCode"
})(({
  theme: o,
  wrapLines: i
}) => ({
  ...codeBlockStyle(o, i)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPre = /* @__PURE__ */ createStyled("pre", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz3"
} : {
  target: "e1ycw9pz3",
  label: "StyledPre"
})(({
  theme: o,
  wrapLines: i
}) => ({
  height: "100%",
  background: o.colors.codeBackgroundColor,
  borderRadius: o.radii.default,
  color: o.colors.bodyText,
  fontSize: o.fontSizes.twoSm,
  fontFamily: o.genericFonts.codeFont,
  display: "block",
  // Remove browser default top margin
  margin: 0,
  // Disable auto-hiding scrollbar in legacy Edge to avoid overlap,
  // making it impossible to interact with the content
  msOverflowStyle: "scrollbar",
  // Don't allow content to break outside
  overflow: "auto",
  // Add padding around the code
  padding: o.spacing.lg,
  // Add padding to the right to account for the copy button
  paddingRight: o.iconSizes.threeXL,
  code: {
    ...codeBlockStyle(o, i)
  },
  // The token can consist of many lines, e.g. a triple-quote string, so
  // we need to make sure that the color is not overwritten.
  ".comment.linenumber": {
    color: o.colors.fadedText40,
    fontSize: o.fontSizes.twoSm,
    // Center-align number vertically, or they'll be positioned differently when
    // wrapLines=true. Even with this change, though, the position is still ~2px
    // off.
    // NOTE: The alignSelf below only apply applies when wrapLines=true, because
    // that option wraps this element in a flex container.
    alignSelf: "center",
    // Override the default token's min-width, to ensure it fits 3-digit lines
    minWidth: `${o.spacing.threeXL} !important`
  },
  ".token.comment, .token.prolog, .token.doctype, .token.cdata": {
    color: o.colors.gray70
  },
  ".token.punctuation": {
    color: o.colors.gray70
  },
  ".namespace": {
    opacity: 0.7
  },
  ".token.attr-name, .token.property, .token.variable": {
    color: o.colors.lightBlue80
  },
  ".token.boolean, .token.constant, .token.symbol": {
    color: o.colors.green70
  },
  ".token.number, .token.regex": {
    color: o.colors.blueGreen80
  },
  ".token.string, .token.char, .token.attr-value": {
    color: o.colors.green80
  },
  ".token.operator, .token.entity": {
    color: o.colors.orange90
  },
  ".token.url": {
    color: o.colors.purple80
  },
  ".token.decorator, .token.atrule": {
    color: o.colors.orange90
  },
  ".token.keyword, .token.tag": {
    color: o.colors.blue70
  },
  ".token.function, .token.class-name, .token.selector": {
    color: o.colors.blue70,
    fontWeight: o.fontWeights.codeExtraBold
  },
  ".token.important": {
    color: o.colors.red70,
    fontWeight: o.fontWeights.codeExtraBold
  },
  ".token.comment": {
    color: o.colors.gray70,
    fontStyle: "italic"
  },
  ".token.italic": {
    fontStyle: "italic"
  },
  ".token.entity": {
    cursor: "help"
  },
  /**
   * Diff syntax highlighting
   */
  ".token.deleted.line, .token.deleted.prefix": {
    color: o.colors.red70
  },
  ".token.inserted.line, .token.inserted.prefix": {
    color: o.colors.green70
  },
  ".token.unchanged.line": {
    color: o.colors.gray70
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCopyButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz2"
} : {
  target: "e1ycw9pz2",
  label: "StyledCopyButtonContainer"
})(({
  theme: o
}) => ({
  opacity: 0,
  padding: `${o.spacing.sm} ${o.spacing.sm} 0 0`,
  top: 0,
  right: 0,
  position: "absolute",
  width: "100%",
  height: "100%",
  backgroundColor: o.colors.transparent,
  zIndex: o.zIndices.sidebar + 1,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  transition: "opacity 300ms 150ms",
  pointerEvents: "none"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCodeBlock = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz1"
} : {
  target: "e1ycw9pz1",
  label: "StyledCodeBlock"
})(({
  theme: o
}) => ({
  height: "100%",
  position: "relative",
  marginLeft: o.spacing.none,
  marginRight: o.spacing.none,
  marginTop: o.spacing.none,
  marginBottom: void 0,
  "&:hover": {
    [`${StyledCopyButtonContainer}`]: {
      opacity: 1
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCopyButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz0"
} : {
  target: "e1ycw9pz0",
  label: "StyledCopyButton"
})(({
  theme: o
}) => ({
  pointerEvents: "auto",
  height: o.iconSizes.threeXL,
  width: o.iconSizes.threeXL,
  padding: o.spacing.none,
  border: "none",
  backgroundColor: o.colors.transparent,
  color: o.colors.fadedText60,
  transform: "scale(0)",
  top: 0,
  right: 0,
  // Show button on container hover
  [`${StyledCodeBlock}:hover &`]: {
    opacity: 1,
    transform: "scale(1)",
    outline: "none",
    transition: "none"
  },
  // Show button on its own hover/focus states
  "&:hover, &:focus, &:active, &:focus-visible": {
    opacity: 1,
    transform: "scale(1)",
    outline: "none",
    transition: "none",
    borderRadius: o.radii.md
  },
  "&:hover": {
    color: o.colors.bodyText,
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    color: o.colors.bodyText,
    backgroundColor: o.colors.darkenedBgMix25
  },
  // Accessible focus ring when keyboard focusing the button
  "&:focus-visible": {
    boxShadow: o.shadows.focusRingSubtle
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMk9nQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvQ29kZUJsb2NrL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCB7IENTU09iamVjdCwgVGhlbWUgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuY29uc3QgY29kZUxpbms6IENTU09iamVjdCA9IHtcbiAgLy8gU3RyZWFtbGluZSB0aGUgc3R5bGUgd2hlbiBpbnNpZGUgYW5jaG9ycyB0byBhdm9pZCBicm9rZW4gdW5kZXJsaW5lIGFuZCBtb3JlXG4gIFwiYSA+ICZcIjoge1xuICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgfSxcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZElubGluZUNvZGUgPSBzdHlsZWQuY29kZSgoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nOiBcIjAuMmVtIDAuNGVtXCIsXG4gIG92ZXJmbG93V3JhcDogXCJicmVhay13b3JkXCIsXG4gIHdoaXRlU3BhY2U6IFwicHJlLXdyYXBcIixcbiAgbWFyZ2luOiAwLFxuICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLm1kLFxuICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuY29kZUJhY2tncm91bmRDb2xvcixcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5jb2RlVGV4dENvbG9yLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIC8vIFVzZSBlbSBoZXJlIHNvIHRoYXQgaXQgd29ya3MgY29ycmVjdGx5IHdpdGhpbiBoZWFkZXJzLCBjYXB0aW9ucyxcbiAgLy8gc2lkZWJhciwgZXRjLlxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmlubGluZUNvZGVGb250U2l6ZSxcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZSxcblxuICAuLi5jb2RlTGluayxcbn0pKVxuXG50eXBlIFN0eWxlZENvZGVQcm9wcyA9IHtcbiAgd3JhcExpbmVzOiBib29sZWFuXG59XG5cbmNvbnN0IGNvZGVCbG9ja1N0eWxlID0gKFxuICB0aGVtZTogVGhlbWUsXG4gIHdyYXBMaW5lczogU3R5bGVkQ29kZVByb3BzW1wid3JhcExpbmVzXCJdXG4pOiBDU1NPYmplY3QgPT4gKHtcbiAgYmFja2dyb3VuZDogXCJ0cmFuc3BhcmVudFwiLFxuICBib3JkZXI6IDAsXG4gIGNvbG9yOiBcImluaGVyaXRcIixcbiAgZGlzcGxheTogXCJpbmxpbmVcIixcbiAgZm9udEZhbWlseTogdGhlbWUuZ2VuZXJpY0ZvbnRzLmNvZGVGb250LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZSxcbiAgbGluZUhlaWdodDogXCJpbmhlcml0XCIsXG4gIG1hcmdpbjogMCxcbiAgb3ZlcmZsb3dYOiBcImF1dG9cIixcbiAgcGFkZGluZzogMCxcbiAgd2hpdGVTcGFjZTogd3JhcExpbmVzID8gXCJwcmUtd3JhcFwiIDogXCJwcmVcIixcbiAgb3ZlcmZsb3dXcmFwOiB3cmFwTGluZXMgPyBcImJyZWFrLXdvcmRcIiA6IFwibm9ybWFsXCIsXG4gIC4uLmNvZGVMaW5rLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvZGUgPSBzdHlsZWQuY29kZTxTdHlsZWRDb2RlUHJvcHM+KFxuICAoeyB0aGVtZSwgd3JhcExpbmVzIH0pID0+ICh7XG4gICAgLi4uY29kZUJsb2NrU3R5bGUodGhlbWUsIHdyYXBMaW5lcyksXG4gIH0pXG4pXG5cbi8qXG4gIFRoaXMgaXMgdGhlIGRlZmF1bHQgcHJpc20uanMgdGhlbWUgZm9yIEphdmFTY3JpcHQsIENTUyBhbmQgSFRNTCwgYnV0XG4gIHN0cmlwcGVkIG9mIGV2ZXJ5dGhpbmcgZXhjZXB0IGZvciB0b2tlbiBzdHlsaW5nLlxuXG4gIFNlZSBodHRwczovL3ByaXNtanMuY29tL2Rvd25sb2FkLmh0bWwjdGhlbWVzPXByaXNtJmxhbmd1YWdlcz1tYXJrdXArY3NzK2NsaWtlK2phdmFzY3JpcHRcbiovXG5leHBvcnQgY29uc3QgU3R5bGVkUHJlID0gc3R5bGVkLnByZTxTdHlsZWRDb2RlUHJvcHM+KFxuICAoeyB0aGVtZSwgd3JhcExpbmVzIH0pID0+ICh7XG4gICAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuY29kZUJhY2tncm91bmRDb2xvcixcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICAgIGZvbnRGYW1pbHk6IHRoZW1lLmdlbmVyaWNGb250cy5jb2RlRm9udCxcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgLy8gUmVtb3ZlIGJyb3dzZXIgZGVmYXVsdCB0b3AgbWFyZ2luXG4gICAgbWFyZ2luOiAwLFxuICAgIC8vIERpc2FibGUgYXV0by1oaWRpbmcgc2Nyb2xsYmFyIGluIGxlZ2FjeSBFZGdlIHRvIGF2b2lkIG92ZXJsYXAsXG4gICAgLy8gbWFraW5nIGl0IGltcG9zc2libGUgdG8gaW50ZXJhY3Qgd2l0aCB0aGUgY29udGVudFxuICAgIG1zT3ZlcmZsb3dTdHlsZTogXCJzY3JvbGxiYXJcIixcblxuICAgIC8vIERvbid0IGFsbG93IGNvbnRlbnQgdG8gYnJlYWsgb3V0c2lkZVxuICAgIG92ZXJmbG93OiBcImF1dG9cIixcblxuICAgIC8vIEFkZCBwYWRkaW5nIGFyb3VuZCB0aGUgY29kZVxuICAgIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgLy8gQWRkIHBhZGRpbmcgdG8gdGhlIHJpZ2h0IHRvIGFjY291bnQgZm9yIHRoZSBjb3B5IGJ1dHRvblxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuaWNvblNpemVzLnRocmVlWEwsXG5cbiAgICBjb2RlOiB7IC4uLmNvZGVCbG9ja1N0eWxlKHRoZW1lLCB3cmFwTGluZXMpIH0sXG5cbiAgICAvLyBUaGUgdG9rZW4gY2FuIGNvbnNpc3Qgb2YgbWFueSBsaW5lcywgZS5nLiBhIHRyaXBsZS1xdW90ZSBzdHJpbmcsIHNvXG4gICAgLy8gd2UgbmVlZCB0byBtYWtlIHN1cmUgdGhhdCB0aGUgY29sb3IgaXMgbm90IG92ZXJ3cml0dGVuLlxuICAgIFwiLmNvbW1lbnQubGluZW51bWJlclwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy50d29TbSxcblxuICAgICAgLy8gQ2VudGVyLWFsaWduIG51bWJlciB2ZXJ0aWNhbGx5LCBvciB0aGV5J2xsIGJlIHBvc2l0aW9uZWQgZGlmZmVyZW50bHkgd2hlblxuICAgICAgLy8gd3JhcExpbmVzPXRydWUuIEV2ZW4gd2l0aCB0aGlzIGNoYW5nZSwgdGhvdWdoLCB0aGUgcG9zaXRpb24gaXMgc3RpbGwgfjJweFxuICAgICAgLy8gb2ZmLlxuICAgICAgLy8gTk9URTogVGhlIGFsaWduU2VsZiBiZWxvdyBvbmx5IGFwcGx5IGFwcGxpZXMgd2hlbiB3cmFwTGluZXM9dHJ1ZSwgYmVjYXVzZVxuICAgICAgLy8gdGhhdCBvcHRpb24gd3JhcHMgdGhpcyBlbGVtZW50IGluIGEgZmxleCBjb250YWluZXIuXG4gICAgICBhbGlnblNlbGY6IFwiY2VudGVyXCIsXG5cbiAgICAgIC8vIE92ZXJyaWRlIHRoZSBkZWZhdWx0IHRva2VuJ3MgbWluLXdpZHRoLCB0byBlbnN1cmUgaXQgZml0cyAzLWRpZ2l0IGxpbmVzXG4gICAgICBtaW5XaWR0aDogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhMfSAhaW1wb3J0YW50YCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uY29tbWVudCwgLnRva2VuLnByb2xvZywgLnRva2VuLmRvY3R5cGUsIC50b2tlbi5jZGF0YVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk3MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4ucHVuY3R1YXRpb25cIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NzAsXG4gICAgfSxcblxuICAgIFwiLm5hbWVzcGFjZVwiOiB7XG4gICAgICBvcGFjaXR5OiAwLjcsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmF0dHItbmFtZSwgLnRva2VuLnByb3BlcnR5LCAudG9rZW4udmFyaWFibGVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5saWdodEJsdWU4MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uYm9vbGVhbiwgLnRva2VuLmNvbnN0YW50LCAudG9rZW4uc3ltYm9sXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JlZW43MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4ubnVtYmVyLCAudG9rZW4ucmVnZXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ibHVlR3JlZW44MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uc3RyaW5nLCAudG9rZW4uY2hhciwgLnRva2VuLmF0dHItdmFsdWVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmVlbjgwLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5vcGVyYXRvciwgLnRva2VuLmVudGl0eVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLm9yYW5nZTkwLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi51cmxcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wdXJwbGU4MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uZGVjb3JhdG9yLCAudG9rZW4uYXRydWxlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMub3JhbmdlOTAsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmtleXdvcmQsIC50b2tlbi50YWdcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ibHVlNzAsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmZ1bmN0aW9uLCAudG9rZW4uY2xhc3MtbmFtZSwgLnRva2VuLnNlbGVjdG9yXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYmx1ZTcwLFxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZUV4dHJhQm9sZCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uaW1wb3J0YW50XCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucmVkNzAsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlRXh0cmFCb2xkLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5jb21tZW50XCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTcwLFxuICAgICAgZm9udFN0eWxlOiBcIml0YWxpY1wiLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5pdGFsaWNcIjoge1xuICAgICAgZm9udFN0eWxlOiBcIml0YWxpY1wiLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5lbnRpdHlcIjoge1xuICAgICAgY3Vyc29yOiBcImhlbHBcIixcbiAgICB9LFxuXG4gICAgLyoqXG4gICAgICogRGlmZiBzeW50YXggaGlnaGxpZ2h0aW5nXG4gICAgICovXG4gICAgXCIudG9rZW4uZGVsZXRlZC5saW5lLCAudG9rZW4uZGVsZXRlZC5wcmVmaXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5yZWQ3MCxcbiAgICB9LFxuICAgIFwiLnRva2VuLmluc2VydGVkLmxpbmUsIC50b2tlbi5pbnNlcnRlZC5wcmVmaXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmVlbjcwLFxuICAgIH0sXG4gICAgXCIudG9rZW4udW5jaGFuZ2VkLmxpbmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NzAsXG4gICAgfSxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvcHlCdXR0b25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG9wYWNpdHk6IDAsXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5zbX0gMCAwYCxcbiAgdG9wOiAwLFxuICByaWdodDogMCxcbiAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBoZWlnaHQ6IFwiMTAwJVwiLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5zaWRlYmFyICsgMSxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImZsZXgtZW5kXCIsXG4gIGFsaWduSXRlbXM6IFwiZmxleC1zdGFydFwiLFxuICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMzAwbXMgMTUwbXNcIixcbiAgcG9pbnRlckV2ZW50czogXCJub25lXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvZGVCbG9jayA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgbWFyZ2luQm90dG9tOiB1bmRlZmluZWQsXG5cbiAgXCImOmhvdmVyXCI6IHtcbiAgICBbYCR7U3R5bGVkQ29weUJ1dHRvbkNvbnRhaW5lcn1gXToge1xuICAgICAgb3BhY2l0eTogMSxcbiAgICB9LFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb3B5QnV0dG9uID0gc3R5bGVkLmJ1dHRvbigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb2ludGVyRXZlbnRzOiBcImF1dG9cIixcbiAgaGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMudGhyZWVYTCxcbiAgd2lkdGg6IHRoZW1lLmljb25TaXplcy50aHJlZVhMLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICB0cmFuc2Zvcm06IFwic2NhbGUoMClcIixcbiAgdG9wOiAwLFxuICByaWdodDogMCxcblxuICAvLyBTaG93IGJ1dHRvbiBvbiBjb250YWluZXIgaG92ZXJcbiAgW2Ake1N0eWxlZENvZGVCbG9ja306aG92ZXIgJmBdOiB7XG4gICAgb3BhY2l0eTogMSxcbiAgICB0cmFuc2Zvcm06IFwic2NhbGUoMSlcIixcbiAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB0cmFuc2l0aW9uOiBcIm5vbmVcIixcbiAgfSxcblxuICAvLyBTaG93IGJ1dHRvbiBvbiBpdHMgb3duIGhvdmVyL2ZvY3VzIHN0YXRlc1xuICBcIiY6aG92ZXIsICY6Zm9jdXMsICY6YWN0aXZlLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIG9wYWNpdHk6IDEsXG4gICAgdHJhbnNmb3JtOiBcInNjYWxlKDEpXCIsXG4gICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgdHJhbnNpdGlvbjogXCJub25lXCIsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZCxcbiAgfSxcblxuICBcIiY6aG92ZXJcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICB9LFxuXG4gIC8vIEFjY2Vzc2libGUgZm9jdXMgcmluZyB3aGVuIGtleWJvYXJkIGZvY3VzaW5nIHRoZSBidXR0b25cbiAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmdTdWJ0bGUsXG4gIH0sXG59KSlcbiJdfQ== */"), pulseAnimation = keyframes`
  0%, 100% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }
`, ANIMATION_STYLES = {
  animationDuration: "750ms",
  animationName: pulseAnimation,
  animationTimingFunction: "ease-in",
  animationDirection: "normal",
  animationIterationCount: "infinite"
}, StyledSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o4"
} : {
  target: "e1lmee1o4",
  label: "StyledSkeleton"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), TitleSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o3"
} : {
  target: "e1lmee1o3",
  label: "TitleSkeleton"
})(({
  theme: o
}) => ({
  height: o.fontSizes.fourXL,
  width: `calc(${o.sizes.contentMaxWidth} * 0.37)`,
  // Picked because it looks good.
  maxWidth: "75%",
  // Picked because it looks good.
  background: o.colors.darkenedBgMix15,
  borderRadius: o.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ParagraphSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o2"
} : {
  target: "e1lmee1o2",
  label: "ParagraphSkeleton"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: o.spacing.sm
  // Picked because it looks good.
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), TextLineSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o1"
} : {
  target: "e1lmee1o1",
  label: "TextLineSkeleton"
})(({
  theme: o,
  width: i
}) => ({
  height: o.fontSizes.md,
  width: i,
  background: o.colors.darkenedBgMix15,
  borderRadius: o.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SquareSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o0"
} : {
  target: "e1lmee1o0",
  label: "SquareSkeleton"
})(({
  theme: o,
  height: i,
  width: g
}) => ({
  height: i ?? o.fontSizes.fourXL,
  width: g ?? "100%",
  background: o.colors.darkenedBgMix15,
  borderRadius: o.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SHOW_DELAY_MS = 500, RawAppSkeleton = () => {
  const [o, i] = useState(!1);
  return useEffect(() => {
    const g = setTimeout(() => {
      i(!0);
    }, SHOW_DELAY_MS);
    return () => {
      clearTimeout(g);
    };
  }, []), o ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSkeleton, { className: "stAppSkeleton", "data-testid": "stAppSkeleton", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TitleSkeleton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ParagraphSkeleton, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "98%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "100%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "96%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "65%" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SquareSkeleton, { width: "75%", height: "9rem" })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, AppSkeleton = memo(RawAppSkeleton), RawSkeleton = ({
  element: o
}) => o.style == Skeleton$1.SkeletonStyle.APP ? /* @__PURE__ */ jsxRuntimeExports.jsx(AppSkeleton, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(SquareSkeleton, { className: "stSkeleton", "data-testid": "stSkeleton", height: o?.height ? o.height + "px" : void 0 }), Skeleton = memo(RawSkeleton);
var KIND$1 = Object.freeze({
  info: "info",
  positive: "positive",
  warning: "warning",
  negative: "negative"
}), TYPE$1 = Object.freeze({
  inline: "inline",
  toast: "toast"
}), PLACEMENT = Object.freeze({
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft"
});
function getSvgStyles$1(o) {
  var i = o.$theme, g = o.$size, E = o.$color, e = i.sizing.scale600;
  g && (i.sizing[g] ? e = i.sizing[g] : typeof g == "number" ? e = "".concat(g, "px") : e = g);
  var t = "currentColor";
  return E && (i.colors[E] ? t = i.colors[E] : t = E), {
    display: "inline-block",
    fill: t,
    color: t,
    height: e,
    width: e
  };
}
var Svg = styled("svg", getSvgStyles$1);
Svg.displayName = "Svg";
Svg.displayName = "Svg";
function _objectDestructuringEmpty(o) {
  if (o == null) throw new TypeError("Cannot destructure undefined");
}
function ownKeys$h(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$f(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$h(Object(g), !0).forEach(function(E) {
      _defineProperty$k(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$h(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$k(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function getBackgroundColor$1(o, i, g) {
  var E, e = i === TYPE$1.inline;
  return (E = {}, _defineProperty$k(E, KIND$1.info, e ? g.colors.notificationInfoBackground : g.colors.toastInfoBackground), _defineProperty$k(E, KIND$1.positive, e ? g.colors.notificationPositiveBackground : g.colors.toastPositiveBackground), _defineProperty$k(E, KIND$1.warning, e ? g.colors.notificationWarningBackground : g.colors.toastWarningBackground), _defineProperty$k(E, KIND$1.negative, e ? g.colors.notificationNegativeBackground : g.colors.toastNegativeBackground), E)[o];
}
function getFontColor$1(o, i, g) {
  var E, e = i === TYPE$1.inline;
  if (e) {
    var t;
    return (t = {}, _defineProperty$k(t, KIND$1.info, g.colors.notificationInfoText), _defineProperty$k(t, KIND$1.positive, g.colors.notificationPositiveText), _defineProperty$k(t, KIND$1.warning, g.colors.notificationWarningText), _defineProperty$k(t, KIND$1.negative, g.colors.notificationNegativeText), t)[o];
  }
  return (E = {}, _defineProperty$k(E, KIND$1.info, g.colors.toastInfoText), _defineProperty$k(E, KIND$1.positive, g.colors.toastPositiveText), _defineProperty$k(E, KIND$1.warning, g.colors.toastWarningText), _defineProperty$k(E, KIND$1.negative, g.colors.toastNegativeText), E)[o];
}
function getPlacement(o) {
  switch (o) {
    case PLACEMENT.topLeft:
      return {
        top: 0,
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT.top:
      return {
        top: 0,
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT.topRight:
      return {
        top: 0,
        alignItems: "flex-end",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT.bottomRight:
      return {
        bottom: 0,
        alignItems: "flex-end",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
    case PLACEMENT.bottom:
      return {
        bottom: 0,
        alignItems: "center",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
    case PLACEMENT.bottomLeft:
      return {
        bottom: 0,
        alignItems: "flex-start",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
  }
}
var Root$2 = styled("div", function(o) {
  var i = o.$placement, g = o.$theme;
  return _objectSpread$f({
    pointerEvents: "none",
    position: "fixed",
    right: 0,
    left: 0,
    display: "flex",
    marginTop: g.sizing.scale300,
    marginBottom: g.sizing.scale300,
    marginLeft: g.sizing.scale600,
    marginRight: g.sizing.scale600
  }, getPlacement(i));
});
Root$2.displayName = "Root";
Root$2.displayName = "Root";
var InnerContainer = styled(
  "div",
  // eslint-disable-next-line no-empty-pattern
  function(o) {
    return _objectDestructuringEmpty(o), {};
  }
);
InnerContainer.displayName = "InnerContainer";
InnerContainer.displayName = "InnerContainer";
var Body$1 = styled("div", function(o) {
  var i = o.$isVisible, g = o.$kind, E = o.$type, e = o.$theme, t = E === TYPE$1.inline;
  return _objectSpread$f(_objectSpread$f({}, e.typography.font300), {}, {
    pointerEvents: "auto",
    color: getFontColor$1(g, E, e),
    height: "auto",
    width: "288px",
    paddingTop: e.sizing.scale600,
    paddingRight: e.sizing.scale600,
    paddingBottom: e.sizing.scale600,
    paddingLeft: e.sizing.scale600,
    marginTop: e.sizing.scale300,
    marginBottom: e.sizing.scale300,
    backgroundColor: getBackgroundColor$1(g, E, e) || e.colors.accent,
    borderTopLeftRadius: e.borders.radius400,
    borderTopRightRadius: e.borders.radius400,
    borderBottomRightRadius: e.borders.radius400,
    borderBottomLeftRadius: e.borders.radius400,
    boxShadow: t ? "none" : e.lighting.shadow600,
    opacity: i ? 1 : 0,
    transitionProperty: "all",
    transitionDuration: e.animation.timing200,
    transitionTimingFunction: e.animation.easeInOutCurve,
    display: "flex",
    justifyContent: "space-between"
  });
});
Body$1.displayName = "Body";
Body$1.displayName = "Body";
var CloseIconSvg = styled("svg", function(o) {
  var i = o.$theme, g = o.$size, E = o.$color, e = o.$isFocusVisible;
  return _objectSpread$f(_objectSpread$f({}, getSvgStyles$1({
    $theme: i,
    $size: g,
    $color: E
  })), {}, {
    cursor: "pointer",
    width: g || "16px",
    flexShrink: 0,
    outline: e ? "3px solid ".concat(i.colors.accent) : "none"
  });
});
CloseIconSvg.displayName = "CloseIconSvg";
CloseIconSvg.displayName = "CloseIconSvg";
function omitDollarPrefixedKeys(o) {
  var i = {};
  for (var g in o)
    g[0] !== "$" && (i[g] = o[g]);
  return i;
}
var _excluded$m = ["children", "title", "size", "color", "overrides"];
function _extends$o() {
  return _extends$o = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$o.apply(this, arguments);
}
function ownKeys$g(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$e(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$g(Object(g), !0).forEach(function(E) {
      _defineProperty$j(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$g(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$j(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function _slicedToArray$j(o, i) {
  return _arrayWithHoles$i(o) || _iterableToArrayLimit$i(o, i) || _unsupportedIterableToArray$i(o, i) || _nonIterableRest$i();
}
function _nonIterableRest$i() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$i(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$i(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$i(o, i);
  }
}
function _arrayLikeToArray$i(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$i(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$i(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$k(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$j(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$j(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
var Icon = function o(i, g) {
  var E = i.children, e = i.title, t = i.size, n = i.color, h = i.overrides, d = h === void 0 ? {} : h, k = _objectWithoutProperties$k(i, _excluded$m), p = getOverrides(d.Svg, Svg), M = _slicedToArray$j(p, 2), H = M[0], f = M[1], AA = H.__STYLETRON__ ? _objectSpread$e(_objectSpread$e({
    title: e,
    $color: n,
    $size: t
  }, k), f) : _objectSpread$e(_objectSpread$e({
    title: e,
    color: n,
    size: t
  }, omitDollarPrefixedKeys(k)), omitDollarPrefixedKeys(f));
  return /* @__PURE__ */ React.createElement(H, _extends$o({
    "data-baseweb": "icon",
    ref: g
  }, AA), e ? /* @__PURE__ */ React.createElement("title", null, e) : null, E);
};
const Icon$1 = /* @__PURE__ */ React.forwardRef(Icon);
var _excluded$l = ["title", "size", "color", "overrides"];
function _extends$n() {
  return _extends$n = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$n.apply(this, arguments);
}
function _objectWithoutProperties$j(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$i(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$i(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _slicedToArray$i(o, i) {
  return _arrayWithHoles$h(o) || _iterableToArrayLimit$h(o, i) || _unsupportedIterableToArray$h(o, i) || _nonIterableRest$h();
}
function _nonIterableRest$h() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$h(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$h(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$h(o, i);
  }
}
function _arrayLikeToArray$h(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$h(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$h(o) {
  if (Array.isArray(o)) return o;
}
function Delete(o, i) {
  var g = useStyletron(), E = _slicedToArray$i(g, 2), e = E[1], t = o.title, n = t === void 0 ? "Delete" : t, h = o.size, d = o.color, k = o.overrides, p = k === void 0 ? {} : k, M = _objectWithoutProperties$j(o, _excluded$l), H = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.Delete ? e.icons.Delete : null
    },
    p && p.Svg ? toObjectOverride(p.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$n({
    viewBox: "0 0 24 24",
    ref: i,
    title: n,
    size: h,
    color: d,
    overrides: {
      Svg: H
    }
  }, M), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z"
  }));
}
const DeleteIcon = /* @__PURE__ */ React.forwardRef(Delete);
function _typeof$a(o) {
  "@babel/helpers - typeof";
  return _typeof$a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$a(o);
}
function _extends$m() {
  return _extends$m = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$m.apply(this, arguments);
}
function _slicedToArray$h(o, i) {
  return _arrayWithHoles$g(o) || _iterableToArrayLimit$g(o, i) || _unsupportedIterableToArray$g(o, i) || _nonIterableRest$g();
}
function _nonIterableRest$g() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$g(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$g(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$g(o, i);
  }
}
function _arrayLikeToArray$g(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$g(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$g(o) {
  if (Array.isArray(o)) return o;
}
function _classCallCheck$8(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$8(o, i, g) {
  return i && _defineProperties$8(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$8(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$8(o, i);
}
function _setPrototypeOf$8(o, i) {
  return _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$8(o, i);
}
function _createSuper$8(o) {
  var i = _isNativeReflectConstruct$8();
  return function() {
    var E = _getPrototypeOf$8(o), e;
    if (i) {
      var t = _getPrototypeOf$8(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$8(this, e);
  };
}
function _possibleConstructorReturn$8(o, i) {
  if (i && (_typeof$a(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$9(o);
}
function _assertThisInitialized$9(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$8() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$8(o) {
  return _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$8(o);
}
function _defineProperty$i(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var Toast$1 = /* @__PURE__ */ (function(o) {
  _inherits$8(g, o);
  var i = _createSuper$8(g);
  function g(E) {
    var e;
    return _classCallCheck$8(this, g), e = i.call(this, E), _defineProperty$i(_assertThisInitialized$9(e), "autoHideTimeout", void 0), _defineProperty$i(_assertThisInitialized$9(e), "animateInTimer", void 0), _defineProperty$i(_assertThisInitialized$9(e), "animateOutCompleteTimer", void 0), _defineProperty$i(_assertThisInitialized$9(e), "closeRef", void 0), _defineProperty$i(_assertThisInitialized$9(e), "previouslyFocusedElement", void 0), _defineProperty$i(_assertThisInitialized$9(e), "state", {
      isVisible: !1,
      isRendered: !0,
      isFocusVisible: !1
    }), _defineProperty$i(_assertThisInitialized$9(e), "handleFocus", function(t) {
      isFocusVisible(t) && e.setState({
        isFocusVisible: !0
      });
    }), _defineProperty$i(_assertThisInitialized$9(e), "handleBlur", function(t) {
      e.state.isFocusVisible !== !1 && e.setState({
        isFocusVisible: !1
      });
    }), _defineProperty$i(_assertThisInitialized$9(e), "animateIn", function() {
      e.animateInTimer = setTimeout(function() {
        e.setState({
          isVisible: !0
        });
      }, 0);
    }), _defineProperty$i(_assertThisInitialized$9(e), "animateOut", function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      e.setState({
        isVisible: !1
      }), e.animateOutCompleteTimer = setTimeout(function() {
        e.setState({
          isRendered: !1
        }), t();
      }, 600);
    }), _defineProperty$i(_assertThisInitialized$9(e), "dismiss", function() {
      e.animateOut(e.props.onClose), e.props.autoFocus && e.previouslyFocusedElement && e.previouslyFocusedElement.focus();
    }), _defineProperty$i(_assertThisInitialized$9(e), "onFocus", function(t) {
      e.state.isVisible && (clearTimeout(e.autoHideTimeout), clearTimeout(e.animateOutCompleteTimer), typeof e.props.onFocus == "function" && e.props.onFocus(t));
    }), _defineProperty$i(_assertThisInitialized$9(e), "onMouseEnter", function(t) {
      e.state.isVisible && (clearTimeout(e.autoHideTimeout), clearTimeout(e.animateOutCompleteTimer), typeof e.props.onMouseEnter == "function" && e.props.onMouseEnter(t));
    }), _defineProperty$i(_assertThisInitialized$9(e), "onBlur", function(t) {
      e.startTimeout(), typeof e.props.onBlur == "function" && e.props.onBlur(t);
    }), _defineProperty$i(_assertThisInitialized$9(e), "onMouseLeave", function(t) {
      e.startTimeout(), typeof e.props.onMouseLeave == "function" && e.props.onMouseLeave(t);
    }), e.closeRef = /* @__PURE__ */ React.createRef(), e.previouslyFocusedElement = null, e;
  }
  return _createClass$8(g, [{
    key: "componentDidMount",
    value: function() {
      this.animateIn(), this.startTimeout(), typeof document < "u" && this.props.autoFocus && this.closeRef && this.closeRef.current && this.closeRef.current.focus && typeof this.closeRef.current.focus == "function" && (this.previouslyFocusedElement = document.activeElement, this.closeRef.current.focus(), this.setState({
        isFocusVisible: !0
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      (this.props.autoHideDuration !== e.autoHideDuration || this.props.__updated !== e.__updated) && this.startTimeout();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimeout();
    }
  }, {
    key: "startTimeout",
    value: function() {
      this.props.autoHideDuration && (this.autoHideTimeout && clearTimeout(this.autoHideTimeout), this.autoHideTimeout = setTimeout(this.dismiss, this.props.autoHideDuration));
    }
  }, {
    key: "clearTimeout",
    value: (function(E) {
      function e() {
        return E.apply(this, arguments);
      }
      return e.toString = function() {
        return E.toString();
      }, e;
    })(function() {
      [this.autoHideTimeout, this.animateInTimer, this.animateOutCompleteTimer].forEach(function(E) {
        E && clearTimeout(E);
      });
    })
  }, {
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.kind, n = e.notificationType, h = e.closeable, d = this.state, k = d.isRendered, p = d.isVisible;
      return {
        $kind: t,
        $type: n,
        $closeable: h,
        $isRendered: k,
        $isVisible: p
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.props, n = t.children, h = t.closeable, d = this.state.isRendered, k = this.props.overrides, p = k.Body, M = k.CloseIcon, H = k.InnerContainer, f = getOverrides(p, Body$1), AA = _slicedToArray$h(f, 2), gA = AA[0], IA = AA[1], BA = getOverrides(H, InnerContainer), CA = _slicedToArray$h(BA, 2), QA = CA[0], iA = CA[1], EA = getOverrides(M, CloseIconSvg), oA = _slicedToArray$h(EA, 2), eA = oA[0], GA = oA[1], cA = mergeOverrides({
        Svg: {
          component: eA
        }
      }, {
        Svg: M
      }), tA = this.getSharedProps();
      return d ? /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(aA) {
        return /* @__PURE__ */ React.createElement(gA, _extends$m({
          role: "alert",
          "data-baseweb": e.props["data-baseweb"] || "toast"
        }, tA, IA, {
          // the properties below have to go after overrides
          onBlur: e.onBlur,
          onFocus: e.onFocus,
          onMouseEnter: e.onMouseEnter,
          onMouseLeave: e.onMouseLeave
        }), /* @__PURE__ */ React.createElement(QA, _extends$m({}, tA, iA), typeof n == "function" ? n({
          dismiss: e.dismiss
        }) : n), h ? /* @__PURE__ */ React.createElement(DeleteIcon, _extends$m({
          ref: e.closeRef,
          role: "button",
          tabIndex: 0,
          $isFocusVisible: e.state.isFocusVisible,
          onClick: e.dismiss,
          onKeyPress: function(DA) {
            DA.key === "Enter" && e.dismiss();
          },
          title: aA.toast.close
        }, tA, GA, {
          onFocus: forkFocus(GA, e.handleFocus),
          onBlur: forkBlur(GA, e.handleBlur),
          overrides: cA
        })) : null);
      }) : null;
    }
  }]), g;
})(React.Component);
_defineProperty$i(Toast$1, "defaultProps", {
  autoFocus: !1,
  autoHideDuration: 0,
  closeable: !0,
  kind: KIND$1.info,
  notificationType: TYPE$1.toast,
  // Do we need a separate handler for
  // when a notification dismisses automatically
  onClose: function o() {
  },
  onBlur: function o() {
  },
  onFocus: function o() {
  },
  onMouseEnter: function o() {
  },
  onMouseLeave: function o() {
  },
  overrides: {}
});
function _typeof$9(o) {
  "@babel/helpers - typeof";
  return _typeof$9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$9(o);
}
var _excluded$k = ["onClose", "children", "key"];
function _slicedToArray$g(o, i) {
  return _arrayWithHoles$f(o) || _iterableToArrayLimit$f(o, i) || _unsupportedIterableToArray$f(o, i) || _nonIterableRest$f();
}
function _nonIterableRest$f() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$f(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$f(o) {
  if (Array.isArray(o)) return o;
}
function _extends$l() {
  return _extends$l = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$l.apply(this, arguments);
}
function _objectWithoutProperties$i(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$h(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$h(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _toConsumableArray$2(o) {
  return _arrayWithoutHoles$2(o) || _iterableToArray$2(o) || _unsupportedIterableToArray$f(o) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$f(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$f(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$f(o, i);
  }
}
function _iterableToArray$2(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function _arrayWithoutHoles$2(o) {
  if (Array.isArray(o)) return _arrayLikeToArray$f(o);
}
function _arrayLikeToArray$f(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function ownKeys$f(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$d(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$f(Object(g), !0).forEach(function(E) {
      _defineProperty$h(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$f(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _classCallCheck$7(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$7(o, i, g) {
  return i && _defineProperties$7(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$7(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$7(o, i);
}
function _setPrototypeOf$7(o, i) {
  return _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$7(o, i);
}
function _createSuper$7(o) {
  var i = _isNativeReflectConstruct$7();
  return function() {
    var E = _getPrototypeOf$7(o), e;
    if (i) {
      var t = _getPrototypeOf$7(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$7(this, e);
  };
}
function _possibleConstructorReturn$7(o, i) {
  if (i && (_typeof$9(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$8(o);
}
function _assertThisInitialized$8(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$7() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$7(o) {
  return _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$7(o);
}
function _defineProperty$h(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var toasterRef, ToasterContainer = /* @__PURE__ */ (function(o) {
  _inherits$7(g, o);
  var i = _createSuper$7(g);
  function g(E) {
    var e;
    return _classCallCheck$7(this, g), e = i.call(this, E), _defineProperty$h(_assertThisInitialized$8(e), "state", {
      isMounted: !1,
      toasts: []
    }), _defineProperty$h(_assertThisInitialized$8(e), "dismissHandlers", {}), _defineProperty$h(_assertThisInitialized$8(e), "toastId", 0), _defineProperty$h(_assertThisInitialized$8(e), "getToastProps", function(t) {
      var n = e.props, h = n.autoFocus, d = n.autoHideDuration, k = n.closeable, p = t.key || "toast-".concat(e.toastId++);
      return _objectSpread$d(_objectSpread$d({
        autoFocus: h,
        autoHideDuration: d,
        closeable: k
      }, t), {}, {
        key: p
      });
    }), _defineProperty$h(_assertThisInitialized$8(e), "show", function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (e.state.toasts.map(function(h) {
        return h.key;
      }).includes(t.key))
        return e.update(t.key, t), t.key;
      var n = e.getToastProps(t);
      return e.setState(function(h) {
        var d = h.toasts;
        return {
          toasts: [].concat(_toConsumableArray$2(d), [n])
        };
      }), n.key;
    }), _defineProperty$h(_assertThisInitialized$8(e), "update", function(t, n) {
      e.setState(function(h) {
        var d = h.toasts, k = d.map(function(p) {
          if (p.key === t) {
            var M = _objectSpread$d(_objectSpread$d(_objectSpread$d({}, p), e.getToastProps(_objectSpread$d({
              autoHideDuration: p.autoHideDuration
            }, n))), {}, {
              key: t
            }, e.props.resetAutoHideTimerOnUpdate ? {
              __updated: (+p.__updated || 0) + 1
            } : {});
            return M;
          }
          return p;
        });
        return {
          toasts: k
        };
      });
    }), _defineProperty$h(_assertThisInitialized$8(e), "dismiss", function(t) {
      e.dismissHandlers[t] && e.dismissHandlers[t]();
    }), _defineProperty$h(_assertThisInitialized$8(e), "clearAll", function() {
      Object.keys(e.dismissHandlers).forEach(function(t) {
        e.dismissHandlers[t]();
      });
    }), _defineProperty$h(_assertThisInitialized$8(e), "clear", function(t) {
      t === void 0 ? e.clearAll() : e.dismiss(t);
    }), _defineProperty$h(_assertThisInitialized$8(e), "internalOnClose", function(t) {
      delete e.dismissHandlers[t], e.setState(function(n) {
        var h = n.toasts;
        return {
          toasts: h.filter(function(d) {
            return d.key !== t;
          })
        };
      });
    }), _defineProperty$h(_assertThisInitialized$8(e), "getOnCloseHandler", function(t, n) {
      return function() {
        e.internalOnClose(t), typeof n == "function" && n();
      };
    }), _defineProperty$h(_assertThisInitialized$8(e), "renderToast", function(t) {
      var n = t.onClose, h = t.children, d = t.key, k = _objectWithoutProperties$i(t, _excluded$k), p = e.props.overrides, M = p.ToastBody, H = p.ToastCloseIcon, f = p.ToastInnerContainer, AA = mergeOverrides({
        Body: Body$1,
        CloseIcon: CloseIconSvg,
        InnerContainer
      }, {
        Body: M || {},
        CloseIcon: H || {},
        InnerContainer: f || {}
      }), gA = mergeOverrides(AA, t.overrides);
      return /* @__PURE__ */ React.createElement(Toast$1, _extends$l({}, k, {
        overrides: gA,
        key: d,
        onClose: e.getOnCloseHandler(d, n)
      }), function(IA) {
        var BA = IA.dismiss;
        return e.dismissHandlers[d] = BA, h;
      });
    }), _defineProperty$h(_assertThisInitialized$8(e), "getSharedProps", function() {
      var t = e.props.placement;
      return {
        $placement: t
      };
    }), toasterRef = _assertThisInitialized$8(e), e;
  }
  return _createClass$7(g, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "render",
    value: function() {
      for (var e = this.getSharedProps(), t = this.props.overrides.Root, n = getOverrides(t, Root$2), h = _slicedToArray$g(n, 2), d = h[0], k = h[1], p = this.state.toasts.length, M = [], H = p - 1; H >= 0; H--)
        M.push(this.renderToast(this.state.toasts[H]));
      var f = /* @__PURE__ */ React.createElement(d, _extends$l({
        "data-baseweb": "toaster"
      }, e, k), M);
      return this.state.isMounted ? /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.usePortal && typeof document < "u" && document.body ? /* @__PURE__ */ ReactDOM.createPortal(f, document.body) : f, this.props.children) : /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.children);
    }
  }]), g;
})(React.Component);
_defineProperty$h(ToasterContainer, "defaultProps", {
  autoFocus: !1,
  autoHideDuration: 0,
  children: null,
  closeable: !0,
  overrides: {},
  placement: PLACEMENT.top,
  resetAutoHideTimerOnUpdate: !0,
  usePortal: !0
});
var toaster = {
  getRef: function o() {
    return toasterRef;
  },
  show: function o(i) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = this.getRef();
    if (E)
      return E.show(_objectSpread$d(_objectSpread$d({}, g), {}, {
        children: i
      }));
    if (process.env.NODE_ENV !== "production")
      throw new Error("Please make sure to add the ToasterContainer to your application, and it is mounted, before adding toasts! You can find more information here: https://baseweb.design/components/toast");
  },
  info: function o(i) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(i, _objectSpread$d(_objectSpread$d({}, g), {}, {
      kind: KIND$1.info
    }));
  },
  positive: function o(i) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(i, _objectSpread$d(_objectSpread$d({}, g), {}, {
      kind: KIND$1.positive
    }));
  },
  warning: function o(i) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(i, _objectSpread$d(_objectSpread$d({}, g), {}, {
      kind: KIND$1.warning
    }));
  },
  negative: function o(i) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(i, _objectSpread$d(_objectSpread$d({}, g), {}, {
      kind: KIND$1.negative
    }));
  },
  update: function o(i, g) {
    var E = this.getRef();
    E ? E.update(i, g) : process.env.NODE_ENV !== "production" && console.error("No ToasterContainer is mounted yet.");
  },
  clear: function o(i) {
    var g = this.getRef();
    g ? g.clear(i) : process.env.NODE_ENV !== "production" && console.error("No ToasterContainer is mounted yet.");
  }
};
function _typeof$8(o) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$8(o);
}
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$k.apply(this, arguments);
}
function _classCallCheck$6(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$6(o, i, g) {
  return i && _defineProperties$6(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$6(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$6(o, i);
}
function _setPrototypeOf$6(o, i) {
  return _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$6(o, i);
}
function _createSuper$6(o) {
  var i = _isNativeReflectConstruct$6();
  return function() {
    var E = _getPrototypeOf$6(o), e;
    if (i) {
      var t = _getPrototypeOf$6(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$6(this, e);
  };
}
function _possibleConstructorReturn$6(o, i) {
  if (i && (_typeof$8(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$7(o);
}
function _assertThisInitialized$7(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$6() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$6(o) {
  return _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$6(o);
}
function _defineProperty$g(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var Notification = /* @__PURE__ */ (function(o) {
  _inherits$6(g, o);
  var i = _createSuper$6(g);
  function g() {
    return _classCallCheck$6(this, g), i.apply(this, arguments);
  }
  return _createClass$6(g, [{
    key: "render",
    value: function() {
      var e = mergeOverrides({
        Body: {
          style: function(n) {
            var h = n.$theme;
            return {
              marginTop: h.sizing.scale600,
              marginRight: h.sizing.scale600,
              marginBottom: h.sizing.scale600,
              marginLeft: h.sizing.scale600
            };
          }
        }
      }, this.props.overrides);
      return /* @__PURE__ */ React.createElement(Toast$1, _extends$k({
        "data-baseweb": "notification"
      }, this.props, {
        overrides: e
      }));
    }
  }]), g;
})(React.Component);
_defineProperty$g(Notification, "defaultProps", {
  notificationType: TYPE$1.inline,
  closeable: !1
});
const StyledAlertContent$1 = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e4pi9i0"
} : {
  target: "e1e4pi9i0",
  label: "StyledAlertContent"
})(({
  theme: o
}) => ({
  pre: {
    backgroundColor: o.colors.transparent,
    paddingTop: o.spacing.lg,
    paddingBottom: o.spacing.lg,
    paddingRight: o.spacing.lg,
    paddingLeft: o.spacing.lg,
    border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
    "pre, code": {
      backgroundColor: o.colors.transparent,
      color: "inherit"
    }
  },
  code: {
    backgroundColor: o.colors.transparent,
    padding: o.spacing.none
  },
  "pre, code": {
    color: "inherit"
  },
  a: {
    color: "inherit",
    textDecoration: "underline"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var Kind = /* @__PURE__ */ ((o) => (o.ERROR = "error", o.INFO = "info", o.SUCCESS = "success", o.WARNING = "warning", o))(Kind || {});
function getNotificationKind(o) {
  switch (o) {
    case "error":
      return KIND$1.negative;
    case "info":
      return KIND$1.info;
    case "success":
      return KIND$1.positive;
    case "warning":
      return KIND$1.warning;
    default:
      throw new Error(`Unexpected alert type: ${o}`);
  }
}
function AlertContainer({
  kind: o,
  width: i,
  children: g
}) {
  const E = useEmotionTheme(), e = o.charAt(0).toUpperCase() + o.slice(1);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Notification, { kind: getNotificationKind(o), overrides: {
    Body: {
      style: {
        fontWeight: E.fontWeights.normal,
        marginTop: E.spacing.none,
        marginBottom: E.spacing.none,
        marginLeft: E.spacing.none,
        marginRight: E.spacing.none,
        width: i ? i.toString() : void 0,
        border: 0,
        borderTopRightRadius: E.radii.default,
        borderBottomRightRadius: E.radii.default,
        borderTopLeftRadius: E.radii.default,
        borderBottomLeftRadius: E.radii.default,
        paddingTop: E.spacing.lg,
        paddingBottom: E.spacing.lg,
        paddingRight: E.spacing.lg,
        paddingLeft: E.spacing.lg
      },
      props: {
        "data-testid": "stAlertContainer",
        className: "stAlertContainer"
      }
    },
    InnerContainer: {
      style: {
        width: "100%",
        lineHeight: E.lineHeights.small
      }
    }
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAlertContent$1, { "data-testid": `stAlertContent${e}`, children: g }) });
}
const StyledStackTrace = /* @__PURE__ */ createStyled("pre", process.env.NODE_ENV === "production" ? {
  target: "e1ixn3a01"
} : {
  target: "e1ixn3a01",
  label: "StyledStackTrace"
})(({
  theme: o
}) => ({
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  color: "inherit",
  fontSize: o.fontSizes.codeFontSize,
  fontFamily: o.genericFonts.codeFont,
  fontWeight: o.fontWeights.code,
  backgroundColor: o.colors.transparent,
  overflowX: "auto",
  margin: 0,
  borderRadius: o.radii.default,
  padding: o.spacing.lg,
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorName = /* @__PURE__ */ createStyled("strong", process.env.NODE_ENV === "production" ? {
  target: "e1ixn3a00"
} : {
  target: "e1ixn3a00",
  label: "StyledErrorName"
})(({
  theme: o
}) => ({
  fontWeight: o.fontWeights.codeBold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ErrorElement(o) {
  const {
    name: i,
    message: g,
    stack: E,
    width: e
  } = o, t = E ? E.split(`
`) : [];
  t.shift();
  const n = t.map((h) => h.trim()).join(`
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AlertContainer, { kind: Kind.ERROR, width: e, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledErrorName, { children: [
      i,
      ": "
    ] }),
    g,
    E ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTrace, { "data-testid": "stErrorElementStack", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: n }) }) : null
  ] });
}
const LOG$c = loglevelExports$1.getLogger("ErrorBoundary"), cI = class cI extends PureComponent {
  constructor() {
    super(...arguments), this.state = {
      error: null
    }, this.componentDidCatch = (i) => {
      LOG$c.error(`${i.name}: ${i.message}
${i.stack}`);
    };
  }
  render() {
    const {
      error: i
    } = this.state;
    return i ? i.name === "ChunkLoadError" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { width: this.props.width, name: "Network issue", message: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Cannot load Streamlit frontend code. This can happen when you update Streamlit while a Streamlit app is running.",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "To fix this, simply reload this app by pressing",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "F5" }),
      ",",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "Ctrl+R" }),
      ", or",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "Cmd+R" }),
      ".",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "If the error persists, try force-clearing your browser's cache as described",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://en.wikipedia.org/wiki/Wikipedia:Bypass_your_cache#Cache_clearing_and_disabling", rel: "noopener noreferrer", target: "_blank", children: "here" })
    ] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { width: this.props.width, name: i.name, message: i.message, stack: i.stack }) : this.props.children;
  }
};
cI.getDerivedStateFromError = (i) => ({
  error: i
});
let ErrorBoundary = cI;
function _EMOTION_STRINGIFIED_CSS_ERROR__$e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function convertRemToEm(o) {
  return o.replace(/rem$/, "em");
}
function sharedMarkdownStyle(o) {
  return {
    a: {
      color: o.colors.link,
      textDecoration: o.linkUnderline ? "underline" : "none",
      "&:focus": {
        outline: "none",
        // Fallback for environments without :focus-visible support:
        boxShadow: o.shadows.focusRing,
        borderRadius: o.radii.default
      },
      // In browsers that support :focus-visible, avoid showing the focus ring on
      // mouse focus (while still keeping the fallback behavior in others).
      "&:focus:not(:focus-visible)": {
        boxShadow: o.shadows.none
      },
      "&:focus-visible": {
        boxShadow: o.shadows.focusRing,
        borderRadius: o.radii.default
      }
    }
  };
}
function convertFontSizes(o, i, g) {
  if (i) {
    const E = roundFontSizeToNearestEighth(parseFloat(o) * 0.65), e = `${Math.max(E, 0.75)}rem`;
    return g ? convertRemToEm(e) : e;
  }
  return g ? convertRemToEm(o) : o;
}
function getMarkdownHeadingDefinitions(o, i, g) {
  return {
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: o.genericFonts.headingFont,
      lineHeight: o.lineHeights.headings,
      margin: 0,
      color: "inherit"
    },
    h1: {
      fontSize: convertFontSizes(o.fontSizes.h1FontSize, i, g),
      fontWeight: o.fontWeights.h1FontWeight,
      padding: `${o.spacing.xl} 0 ${o.spacing.lg} 0`
    },
    "h1 b, h1 strong": {
      // Per Pull Request #9395, setting text to bold in headers
      // should NOT change its font-weight
      fontWeight: o.fontWeights.h1FontWeight
    },
    "h2, h3": {
      letterSpacing: "-0.005em"
    },
    h2: {
      fontSize: convertFontSizes(o.fontSizes.h2FontSize, i, g),
      fontWeight: o.fontWeights.h2FontWeight,
      padding: `${o.spacing.lg} 0 ${o.spacing.lg} 0`
    },
    h3: {
      fontSize: convertFontSizes(o.fontSizes.h3FontSize, i, g),
      fontWeight: o.fontWeights.h3FontWeight,
      padding: `${o.spacing.md} 0 ${o.spacing.lg} 0`
    },
    h4: {
      fontSize: convertFontSizes(o.fontSizes.h4FontSize, i, g),
      fontWeight: o.fontWeights.h4FontWeight,
      padding: `${o.spacing.sm} 0 ${o.spacing.lg} 0`
    },
    h5: {
      fontSize: convertFontSizes(o.fontSizes.h5FontSize, i, g),
      fontWeight: o.fontWeights.h5FontWeight,
      padding: `${o.spacing.xs} 0 ${o.spacing.lg} 0`
    },
    h6: {
      fontSize: convertFontSizes(o.fontSizes.h6FontSize, i, g),
      fontWeight: o.fontWeights.h6FontWeight,
      padding: `${o.spacing.twoXS} 0 ${o.spacing.lg} 0`
    }
  };
}
const StyledStreamlitMarkdown = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr6"
} : {
  target: "e1nzilvr6",
  label: "StyledStreamlitMarkdown"
})(({
  theme: o,
  isCaption: i,
  isInDialog: g,
  isLabel: E,
  inheritFont: e,
  boldLabel: t,
  largerLabel: n,
  isToast: h
}) => {
  const d = E && !n || h || i;
  return {
    fontFamily: e ? "inherit" : o.genericFonts.bodyFont,
    fontSize: e ? "inherit" : d ? o.fontSizes.sm : o.fontSizes.md,
    marginBottom: E ? "" : `-${o.spacing.lg}`,
    opacity: i ? 0.6 : void 0,
    color: "inherit",
    // Always respect the width of the parent container:
    maxWidth: "100%",
    width: E ? "" : "100%",
    // Break long words to prevent them from overflowing the container:
    overflowWrap: "break-word",
    ...sharedMarkdownStyle(o),
    ...getMarkdownHeadingDefinitions(o, g, i),
    // This is required so that long Latex formulas in `st.latex` are scrollable
    // when `help` is set (see below).
    "&:has(.katex-display)": {
      overflowX: "hidden"
    },
    p: {
      wordBreak: "break-word",
      marginBottom: E ? o.spacing.none : "",
      fontWeight: e ? "inherit" : t ? o.fontWeights.bold : "",
      marginTop: o.spacing.none,
      marginLeft: o.spacing.none,
      marginRight: o.spacing.none
    },
    img: {
      // Images in markdown should never be wider
      // than the content area.
      maxWidth: "100%",
      // In labels, widgets should never be taller than the text.
      maxHeight: E ? "1em" : void 0,
      verticalAlign: "middle",
      // Ensure that images are not distorted:
      objectFit: "scale-down"
    },
    li: {
      margin: "0.2em 0 0.2em 1.15em",
      padding: "0 0 0 0.3em"
    },
    "li.task-list-item": {
      listStyleType: "none",
      padding: "0",
      marginLeft: "0",
      "input[type='checkbox']": {
        verticalAlign: "middle",
        margin: "0 0.35em 0.1em 0"
      }
    },
    // Handles quotes:
    blockquote: {
      margin: "1em 0 1em 0",
      padding: "0 0 0 0.75em",
      borderLeft: `0.15em solid ${o.colors.borderColor}`,
      opacity: 0.6
    },
    "b, strong": {
      fontWeight: o.fontWeights.bold
    },
    // Issue #11976: Handle bolded inline code
    "b code, strong code": {
      fontWeight: o.fontWeights.codeBold
    },
    // Handles the horizontal divider:
    hr: {
      margin: "2em 0",
      padding: 0,
      // Reset Firefox's gray color:
      color: "inherit",
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
      // Set correct height and prevent the size attribute
      // to make the hr look like an input field:
      "&:not([size])": {
        height: o.sizes.borderWidth
      }
    },
    table: {
      display: "table",
      // Prevent double borders
      borderCollapse: "collapse",
      marginBottom: o.spacing.lg
    },
    tr: {
      borderTop: `${o.sizes.borderWidth} solid ${o.colors.dataframeBorderColor}`
    },
    th: {
      // TODO: check whether this should be adjusted
      // defaults to font-weight: "bold" (700)
      textAlign: "inherit"
    },
    "th, td": {
      padding: `${o.spacing.xs} ${o.spacing.md}`,
      border: `${o.sizes.borderWidth} solid ${o.colors.dataframeBorderColor}`
    },
    "span.stMarkdownColoredBackground": {
      borderRadius: o.radii.md,
      padding: `${o.spacing.threeXS} ${o.spacing.twoXS}`,
      margin: o.spacing.none,
      boxDecorationBreak: "clone"
    },
    "span.stMarkdownBadge": {
      borderRadius: o.radii.md,
      // Since we're using inline-block below, we're not using vertical padding here,
      // because inline-block already makes the element look a bit taller.
      padding: `0 ${o.spacing.twoXS}`,
      // Add a small margin to separate it a bit from other text.
      margin: `0 ${o.spacing.px}`,
      // Make badges not wrap and ellipsize them if they are too long for the
      // parent container.
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      display: "inline-block",
      verticalAlign: "middle"
    },
    "p, ol, ul, dl, li": {
      fontSize: "inherit"
    },
    "& > ul, & > ol": {
      display: "block",
      width: "fit-content",
      textAlign: "left"
    },
    // Ensure nested lists stay as block elements
    "li > ul, li > ol": {
      display: "block"
    },
    // Allow long Latex formulas that are not inline (i.e. either from `st.latex`
    // or in their own paragraph inside `st.markdown`) to scroll horizontally.
    ".katex-display": {
      overflowX: "auto",
      overflowY: "hidden"
    },
    ".katex": {
      fontWeight: o.fontWeights.normal
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLinkIcon = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr5"
} : {
  target: "e1nzilvr5",
  label: "StyledLinkIcon"
})(({
  theme: o
}) => ({
  // center icon
  lineHeight: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: 0,
  pointerEvents: "none",
  transition: "opacity 150ms ease-in-out",
  svg: {
    // same color as the tooltip-icon
    stroke: o.colors.fadedText60,
    strokeWidth: o.sizes.defaultStrokeWidth
  },
  "&:hover svg": {
    stroke: o.colors.bodyText
  },
  "&:focus-visible": {
    opacity: 1,
    pointerEvents: "auto"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeadingWithActionElements = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr4"
} : {
  target: "e1nzilvr4",
  label: "StyledHeadingWithActionElements"
})(({
  theme: o
}) => ({
  "h1, h2, h3, h4, h5, h6, span": {
    scrollMarginTop: o.sizes.headerHeight
  },
  ...sharedMarkdownStyle(o),
  // break-word & pretty makes most headings break in a nicer way than break-all while still
  // preventing overflowing of the container to the side. Long headings without whitespaces or hyphens might still look weird
  wordBreak: "break-word",
  textWrap: "pretty",
  // Show link icon when hovering or when focus is within the heading container.
  // We use opacity instead of visibility so the link remains in the tab order.
  "&:hover, &:focus-within": {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    [StyledLinkIcon]: {
      opacity: 1,
      pointerEvents: "auto"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeadingActionElements = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr3"
} : {
  target: "e1nzilvr3",
  label: "StyledHeadingActionElements"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.sm,
  display: "inline-flex",
  gap: o.spacing.sm,
  verticalAlign: "middle",
  "& > *": {
    // remove margins of inner elements as they are wrapped in a container that applies the margin
    marginLeft: "0 !important"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderDivider = /* @__PURE__ */ createStyled("hr", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr2"
} : {
  target: "e1nzilvr2",
  label: "StyledHeaderDivider"
})(({
  theme: o,
  rainbow: i,
  color: g
}) => ({
  // Height needs to be !important due to globalStyles.tsx hr height override - line #170
  height: `${o.spacing.threeXS} !important`,
  marginTop: o.spacing.sm,
  marginBottom: o.spacing.none,
  border: "none",
  borderRadius: o.radii.full,
  ...i ? {
    background: g
  } : {
    backgroundColor: g
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPreWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr1"
} : {
  target: "e1nzilvr1",
  label: "StyledPreWrapper"
})(({
  theme: o
}) => ({
  // Set spacing between pre-elements inside of markdown similar to our gap spacing between elements
  marginBottom: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHelpIconWrapper = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr0"
} : {
  target: "e1nzilvr0",
  label: "StyledHelpIconWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s36o2q",
  styles: "display:inline-block;vertical-align:middle;transform:translateY(-0.1em)"
} : {
  name: "s36o2q",
  styles: "display:inline-block;vertical-align:middle;transform:translateY(-0.1em)/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
}), LOAD_FAILED = Symbol("plugin_load_failed"), pluginCache = {
  katex: null,
  raw: null,
  emoji: null
}, loadingPromises = {
  katex: null,
  raw: null,
  emoji: null
}, loadKatexPlugin = () => import("./index-fq7FP83F.js"), loadKatexStyles = once$1(() => {
  Promise.resolve().then(() => katex_min);
}), loadRehypeRaw = () => import("./index-BGonBBIg.js"), loadRemarkEmoji = () => import("./index-D14rOcPj.js");
function isLoadedPlugin(o) {
  return o !== null && o !== LOAD_FAILED;
}
function extractPlugin(o, i) {
  const g = [];
  let E = o, e = 0;
  for (; E && typeof E == "object" && "default" in E && e < 5; ) {
    const t = E.default;
    if (g.push(t), t === E)
      break;
    E = t, e += 1;
  }
  g.push(o);
  for (const t of g)
    if (typeof t == "function")
      return t;
  return console.warn(`[StreamlitMarkdown] Failed to load ${i} plugin`), LOAD_FAILED;
}
function wrapRehypePlugin(o, i) {
  return (g) => {
    const E = o(g);
    return (e, t) => {
      if (!e)
        return e;
      try {
        return E(e, t);
      } catch (n) {
        return console.error(`[StreamlitMarkdown] ${i} crashed while transforming`, n), e;
      }
    };
  };
}
function wrapRemarkPlugin(o, i) {
  return (g) => {
    const E = o(g);
    return (e, t) => {
      if (!e)
        return e;
      try {
        return E(e, t);
      } catch (n) {
        return console.error(`[StreamlitMarkdown] ${i} crashed while transforming`, n), e;
      }
    };
  };
}
function useLazyPlugin(o) {
  const {
    key: i,
    needed: g,
    load: E,
    pluginName: e,
    onBeforeLoad: t
  } = o, n = g ? pluginCache[i] : null, [h, d] = useState(null);
  return useEffect(() => {
    if (!g || n || h)
      return;
    const k = loadingPromises[i];
    if (k) {
      let H = !1;
      return k.then((f) => {
        H || d(() => f);
      }), () => {
        H = !0;
      };
    }
    t?.();
    let p = !1;
    const M = E().then((H) => extractPlugin(H, e)).then((H) => (pluginCache[i] = H, p || d(() => H), H)).catch(() => {
      const H = LOAD_FAILED;
      return pluginCache[i] = H, p || d(() => H), H;
    }).finally(() => {
      loadingPromises[i] = null;
    });
    return loadingPromises[i] = M, () => {
      p = !0;
    };
  }, [g, n, h, i, E, e, t]), g ? n ?? h : null;
}
const StreamlitSyntaxHighlighter$1 = lazy(() => import("./StreamlitSyntaxHighlighter-DGQw-z1T.js"));
function containsEmojiShortcodes(o) {
  return /:(?!material\/|streamlit:)[\w+-][\w_+-]*:/.test(o);
}
function containsMathSyntax(o) {
  return new RegExp("\\$\\$[\\s\\S]+?\\$\\$|\\$(?!\\s)[^$\\n]+?(?<!\\s)\\$").test(o);
}
var Tags = /* @__PURE__ */ ((o) => (o.H1 = "h1", o.H2 = "h2", o.H3 = "h3", o))(Tags || {});
function rehypeSetCodeInlineProperty() {
  return (o) => {
    visit(o, "element", (i, g, E) => {
      i.tagName === "code" && (E?.type === "element" && E.tagName === "pre" ? i.properties = {
        ...i.properties,
        inline: !1
      } : i.properties = {
        ...i.properties,
        inline: !0
      });
    });
  };
}
function createAnchorFromText(o) {
  if (!o)
    return "";
  const i = slugify(o);
  return i.length > 0 ? i : xxhash.h32(o, 43981).toString(16);
}
function transformLinkUri(o) {
  return o;
}
const scrollNodeIntoView = once$1((o) => {
  o.scrollIntoView(!0);
}), HeaderActionElements = ({
  elementId: o,
  help: i,
  hideAnchor: g
}) => {
  const E = useEmotionTheme();
  return !i && g ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeadingActionElements, { "data-testid": "stHeaderActionElements", children: [
    i && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: i }),
    o && !g && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLinkIcon, { href: `#${o}`, "aria-label": "Link to heading", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link2,
      {
        size: convertRemToPx(E.iconSizes.base),
        "aria-hidden": "true"
      }
    ) })
  ] });
}, HeadingWithActionElements = ({
  tag: o,
  anchor: i,
  help: g,
  hideAnchor: E,
  children: e,
  tagProps: t
}) => {
  const n = useContext(IsSidebarContext), h = useContext(IsDialogContext), [d, k] = useState(i), p = useCallback((iA) => {
    if (iA === null)
      return;
    const EA = i || createAnchorFromText(iA.textContent);
    k(EA);
    const oA = window.location.hash.slice(1);
    oA && oA === EA && scrollNodeIntoView(iA);
  }, [i]), M = n || h, H = /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderActionElements, { elementId: d, help: g, hideAnchor: E || M }), f = useId(), AA = g || d && !E && !M ? f : void 0, gA = d ? {
    id: d
  } : {}, IA = AA ? {
    "aria-labelledby": AA
  } : {}, BA = {
    ...M ? {} : {
      ref: p,
      ...gA
    },
    ...IA
  }, CA = o, QA = /* @__PURE__ */ jsxRuntimeExports.jsxs(CA, { ...t, ...BA, children: [
    AA ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { id: AA, children: e }) : e,
    H
  ] });
  return M ? QA : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeadingWithActionElements, { "data-testid": "stHeadingWithActionElements", children: QA });
}, CustomHeading = ({
  node: o,
  children: i,
  ...g
}) => {
  const E = g["data-anchor"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(HeadingWithActionElements, { tag: o.tagName, anchor: E, tagProps: g, children: i });
}, CustomCodeTag = ({
  inline: o,
  className: i,
  children: g,
  ...E
}) => {
  const e = /language-(\w+)/.exec(i || ""), t = String(g ?? "").replace(/^\n/, "").replace(/\n$/, ""), n = e?.[1] || "";
  return o ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { className: i, ...omit(E, "node"), children: g }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
    style: Skeleton$1.SkeletonStyle.ELEMENT
  }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter$1, { language: n, showLineNumbers: !1, children: t }) }) });
}, CustomPreTag = ({
  children: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPreWrapper, { "data-testid": "stMarkdownPre", children: o }), CustomMediaTag = ({
  node: o,
  ...i
}) => {
  const g = useCrossOriginAttribute(i.src), E = o.tagName, e = {
    ...i,
    crossOrigin: g
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(E, { ...e });
}, HelpTextContext = createContext(void 0);
HelpTextContext.displayName = "HelpTextContext";
const CustomHelpIcon = ({
  children: o
}) => {
  const g = useContext(HelpTextContext) || (typeof o == "string" ? o : "");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHelpIconWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: g }) });
}, BASE_RENDERERS = {
  pre: CustomPreTag,
  code: CustomCodeTag,
  h1: CustomHeading,
  h2: CustomHeading,
  h3: CustomHeading,
  h4: CustomHeading,
  h5: CustomHeading,
  h6: CustomHeading,
  img: CustomMediaTag,
  video: CustomMediaTag,
  audio: CustomMediaTag,
  "streamlit-help-icon": CustomHelpIcon
};
function createColorMapping(o) {
  const {
    red: i,
    orange: g,
    yellow: E,
    green: e,
    blue: t,
    violet: n,
    purple: h,
    gray: d,
    primary: k
  } = getMarkdownTextColors(o), {
    redbg: p,
    orangebg: M,
    yellowbg: H,
    greenbg: f,
    bluebg: AA,
    violetbg: gA,
    purplebg: IA,
    graybg: BA,
    primarybg: CA
  } = getMarkdownBgColors(o);
  return new Map(Object.entries({
    red: `color: ${i}`,
    orange: `color: ${g}`,
    yellow: `color: ${E}`,
    blue: `color: ${t}`,
    green: `color: ${e}`,
    violet: `color: ${n}`,
    gray: `color: ${d}`,
    grey: `color: ${d}`,
    primary: `color: ${k}`,
    // Gradient from red, orange, yellow, green, blue, violet, purple
    rainbow: `color: transparent; background-clip: text; -webkit-background-clip: text; background-image: linear-gradient(to right,
        ${i}, ${g}, ${E}, ${e}, ${t}, ${n}, ${h});`,
    "red-background": `background-color: ${p}`,
    "orange-background": `background-color: ${M}`,
    "yellow-background": `background-color: ${H}`,
    "blue-background": `background-color: ${AA}`,
    "green-background": `background-color: ${f}`,
    "violet-background": `background-color: ${gA}`,
    "gray-background": `background-color: ${BA}`,
    "grey-background": `background-color: ${BA}`,
    "primary-background": `background-color: ${CA}`,
    // Gradient from red, orange, yellow, green, blue, violet, purple
    "rainbow-background": `background: linear-gradient(to right,
        ${p}, ${M}, ${H}, ${f}, ${AA}, ${gA}, ${IA});`
  }));
}
function createRemarkHelpIcon() {
  return () => (o) => (visit(o, "textDirective", (i, g, E) => {
    if (String(i.name) === "help") {
      const t = i.data || (i.data = {});
      t.hName = "streamlit-help-icon", t.hProperties = t.hProperties || {};
      return;
    }
  }), o);
}
function createRemarkColoringAndSmall(o, i) {
  return () => (g) => (visit(g, "textDirective", (E, e, t) => {
    const n = String(E.name);
    if (n === "small") {
      const d = E.data || (E.data = {});
      d.hName = "span", d.hProperties = d.hProperties || {}, d.hProperties.style = `font-size: ${o.fontSizes.sm};`;
      return;
    }
    const h = n.match(/^(.+)-badge$/);
    if (h && i.has(h[1])) {
      const d = h[1];
      if (d === "rainbow")
        return;
      const k = i.get(d), p = i.get(`${d}-background`);
      if (k && p) {
        const M = E.data || (E.data = {});
        M.hName = "span", M.hProperties = M.hProperties || {}, M.hProperties.className = "stMarkdownBadge", M.hProperties.style = `${p}; ${k}; font-size: ${o.fontSizes.sm};`;
        return;
      }
    }
    if (i.has(n)) {
      const d = E.data || (E.data = {}), k = i.get(n);
      d.hName = "span", d.hProperties = d.hProperties || {}, d.hProperties.style = k, d.hProperties.className = "stMarkdownColoredText", k && (/background-color:/.test(k) || /background:/.test(k)) && (d.hProperties.className = "stMarkdownColoredBackground");
      return;
    }
  }), g);
}
function createRemarkUnsupportedDirectivesCleanup() {
  return () => (o) => (visit(o, "textDirective", (i, g, E) => {
    if (!i.data?.hName && E && g !== void 0) {
      const e = {
        type: "text",
        value: `:${i.name}`
      };
      E.children[g] = e;
    }
  }), o);
}
function createRemarkMaterialIcons(o) {
  return () => (i) => {
    function g(E, e) {
      return {
        type: "text",
        value: E,
        data: {
          hName: "span",
          hProperties: {
            role: "img",
            ariaLabel: e + " icon",
            // Prevent the icon text from being translated
            // this would break the icon display in the UI.
            // https://github.com/streamlit/streamlit/issues/10168
            translate: "no",
            // We need to use string-style CSS here so that it works
            // correctly with the rehype-raw plugin.
            style: `
            display: inline-block;
            font-family: ${o.genericFonts.iconFont};
            font-weight: ${o.fontWeights.normal};
            user-select: none;
            vertical-align: bottom;
            white-space: nowrap;
            word-wrap: normal;
            `
          },
          hChildren: [{
            type: "text",
            value: e
          }]
        }
      };
    }
    return findAndReplace(i, [[/:material_(\w+):/g, g]]), i;
  };
}
function createRemarkStreamlitLogo() {
  return () => (o) => {
    function i() {
      return {
        type: "text",
        value: "",
        data: {
          hName: "img",
          hProperties: {
            src: streamlitLogo,
            alt: "Streamlit logo",
            // We need to use string-style CSS here so that it works
            // correctly with the rehype-raw plugin.
            // The base of the Streamlit logo is curved, so move it down a bit to
            // make it look aligned with the text.
            style: "display: inline-block; user-select: none; height: 0.75em; vertical-align: baseline; margin-bottom: -0.05ex;"
          }
        }
      };
    }
    return findAndReplace(o, [[/:streamlit:/g, i]]), o;
  };
}
function createRemarkTypographicalSymbols() {
  return () => (o) => (visit(o, (i, g, E) => {
    if (!(E && (E.type === "link" || E.type === "linkReference")) && i.type === "text" && i.value) {
      const e = [[/(^|\s)<->(\s|$)/g, "$1↔$2"], [/(^|\s)->(\s|$)/g, "$1→$2"], [/(^|\s)<-(\s|$)/g, "$1←$2"], [/(^|\s)--(\s|$)/g, "$1—$2"], [/(^|\s)>=(\s|$)/g, "$1≥$2"], [/(^|\s)<=(\s|$)/g, "$1≤$2"], [/(^|\s)~=(\s|$)/g, "$1≈$2"]];
      let t = i.value;
      for (const [n, h] of e)
        t = t.replace(n, h);
      t !== i.value && (i.value = t);
    }
  }), o);
}
const BASE_REMARK_PLUGINS = [remarkMath, remarkGfm, remarkDirective, createRemarkHelpIcon(), createRemarkStreamlitLogo(), createRemarkTypographicalSymbols()], LABEL_DISALLOWED_ELEMENTS = [
  // Restricts table elements, headings, unordered/ordered lists, task lists, horizontal rules, & blockquotes
  // Note that images are allowed but have a max height equal to the text height
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "ul",
  "ol",
  "li",
  "input",
  "hr",
  "blockquote"
], LINKS_DISALLOWED_ELEMENTS = [...LABEL_DISALLOWED_ELEMENTS, "a"];
function LinkWithTargetBlank(o) {
  const {
    href: i
  } = o;
  if (i?.startsWith("#")) {
    const {
      children: h,
      ...d
    } = o;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { ...omit(d, "node"), children: h });
  }
  const {
    title: g,
    children: E,
    target: e,
    rel: t,
    ...n
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: i, title: g, target: e || "_blank", rel: t || "noopener noreferrer", ...omit(n, "node"), children: E });
}
const RenderedMarkdown = memo(function o({
  allowHTML: i,
  source: g,
  overrideComponents: E,
  isLabel: e,
  disableLinks: t,
  helpText: n
}) {
  const h = useEmotionTheme(), d = useMemo$1(() => containsMathSyntax(g), [g]), k = useMemo$1(() => containsEmojiShortcodes(g), [g]), p = useLazyPlugin({
    key: "katex",
    needed: d,
    load: loadKatexPlugin,
    pluginName: "rehype-katex",
    onBeforeLoad: loadKatexStyles
  }), M = useLazyPlugin({
    key: "raw",
    needed: i,
    load: loadRehypeRaw,
    pluginName: "rehype-raw"
  }), H = useLazyPlugin({
    key: "emoji",
    needed: k,
    load: loadRemarkEmoji,
    pluginName: "remark-emoji"
  }), f = useMemo$1(() => createColorMapping(h), [h]), AA = useMemo$1(() => isLoadedPlugin(p) ? wrapRehypePlugin(p, "rehype-katex") : null, [p]), gA = useMemo$1(() => isLoadedPlugin(M) ? wrapRehypePlugin(M, "rehype-raw") : null, [M]), IA = useMemo$1(() => isLoadedPlugin(H) ? (
    // Cast needed: unified's Plugin type is more complex than our RemarkPluginFactory wrapper
    wrapRemarkPlugin(H, "remark-emoji")
  ) : null, [H]), BA = useMemo$1(() => {
    const eA = [...BASE_REMARK_PLUGINS, createRemarkColoringAndSmall(h, f), createRemarkMaterialIcons(h)];
    return k && IA && eA.push(IA), eA.push(createRemarkUnsupportedDirectivesCleanup()), eA;
  }, [h, f, k, IA]), CA = useMemo$1(() => {
    const eA = [];
    return d && AA && eA.push(AA), i && gA && eA.push(gA), eA.push(rehypeSetCodeInlineProperty), eA;
  }, [i, d, AA, gA]), QA = useMemo$1(() => ({
    ...BASE_RENDERERS,
    a: LinkWithTargetBlank,
    ...E || {}
  }), [E]), iA = useMemo$1(() => g.replaceAll(":material/", ":material_"), [g]), EA = useMemo$1(() => e ? t ? LINKS_DISALLOWED_ELEMENTS : LABEL_DISALLOWED_ELEMENTS : [], [e, t]);
  return d && p === null || i && M === null || k && H === null ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
    style: Skeleton$1.SkeletonStyle.ELEMENT
  }) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(HelpTextContext.Provider, { value: n, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Markdown$2,
    {
      remarkPlugins: BA,
      rehypePlugins: CA,
      components: QA,
      urlTransform: transformLinkUri,
      disallowedElements: EA,
      unwrapDisallowed: !0,
      children: iA
    }
  ) }) });
}), StreamlitMarkdown = ({
  source: o,
  allowHTML: i,
  style: g,
  isCaption: E,
  isLabel: e,
  boldLabel: t,
  largerLabel: n,
  disableLinks: h,
  isToast: d,
  inheritFont: k,
  helpText: p
}) => {
  const M = useContext(IsDialogContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStreamlitMarkdown, { isCaption: !!E, isInDialog: M, isLabel: e, inheritFont: k, boldLabel: t, largerLabel: n, isToast: d, style: g, "data-testid": E ? "stCaptionContainer" : "stMarkdownContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(RenderedMarkdown, { source: o, allowHTML: i, isLabel: e, disableLinks: h, helpText: p }) });
}, StreamlitMarkdown$1 = memo(StreamlitMarkdown);
function TooltipIcon(o) {
  const {
    placement: i = Placement.AUTO,
    isLatex: g = !1,
    content: E,
    markdownProps: e,
    onMouseEnterDelay: t,
    containerWidth: n = !1
  } = o, h = useEmotionTheme(), d = (p) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipTriggerButton, { type: "button", "aria-label": p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    HelpCircle,
    {
      className: "icon",
      "aria-hidden": "true",
      focusable: "false",
      size: convertRemToPx(h.iconSizes.base)
    }
  ) }), k = () => {
    if ("children" in o)
      return isValidElement(o.children) ? o.children : d("Help");
    const p = o.ariaLabel.trim();
    return p.length ? d(p) : d("Help");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipIconWrapper, { className: "stTooltipIcon", "data-testid": "stTooltipIcon", isLatex: g, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { style: {
    fontSize: h.fontSizes.sm
  }, source: E, allowHTML: !1, ...e || {} }), placement: i, onMouseEnterDelay: t, inline: !0, containerWidth: n, children: k() }) });
}
function getHelpTooltipAriaLabel(o) {
  const i = o?.trim(), g = i ? i.replace(/\s+/g, " ") : null;
  return g ? `Help for ${g}` : "Help";
}
const InlineTooltipIcon = ({
  placement: o = Placement.TOP_RIGHT,
  isLatex: i = !1,
  content: g,
  markdownProps: E,
  onMouseEnterDelay: e,
  containerWidth: t,
  ariaLabel: n = "Help"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpInline, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { placement: o, isLatex: i, content: g, markdownProps: E, onMouseEnterDelay: e, containerWidth: t, ariaLabel: n }) });
function BaseButtonTooltip({
  children: o,
  help: i,
  placement: g,
  containerWidth: E
}) {
  return i ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipNormal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: i, placement: g || Placement.TOP, containerWidth: E, children: o }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipMobile, { children: o })
  ] }) : o;
}
const isff = typeof navigator < "u" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1;
function addEvent(o, i, g, E) {
  o.addEventListener ? o.addEventListener(i, g, E) : o.attachEvent && o.attachEvent("on".concat(i), g);
}
function removeEvent(o, i, g, E) {
  o.removeEventListener ? o.removeEventListener(i, g, E) : o.detachEvent && o.detachEvent("on".concat(i), g);
}
function getMods(o, i) {
  const g = i.slice(0, i.length - 1);
  for (let E = 0; E < g.length; E++) g[E] = o[g[E].toLowerCase()];
  return g;
}
function getKeys(o) {
  typeof o != "string" && (o = ""), o = o.replace(/\s/g, "");
  const i = o.split(",");
  let g = i.lastIndexOf("");
  for (; g >= 0; )
    i[g - 1] += ",", i.splice(g, 1), g = i.lastIndexOf("");
  return i;
}
function compareArray(o, i) {
  const g = o.length >= i.length ? o : i, E = o.length >= i.length ? i : o;
  let e = !0;
  for (let t = 0; t < g.length; t++)
    E.indexOf(g[t]) === -1 && (e = !1);
  return e;
}
const _keyMap = {
  backspace: 8,
  "⌫": 8,
  tab: 9,
  clear: 12,
  enter: 13,
  "↩": 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  /// https://w3c.github.io/uievents/#events-keyboard-key-location
  arrowup: 38,
  arrowdown: 40,
  arrowleft: 37,
  arrowright: 39,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": isff ? 173 : 189,
  "=": isff ? 61 : 187,
  ";": isff ? 59 : 186,
  "'": 222,
  "{": 219,
  "}": 221,
  "[": 219,
  "]": 221,
  "\\": 220
}, _modifier = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  meta: 91,
  command: 91
}, modifierMap = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, _mods = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, _handlers = {};
for (let o = 1; o < 20; o++)
  _keyMap["f".concat(o)] = 111 + o;
let _downKeys = [], winListendFocus = null, _scope = "all";
const elementEventMap = /* @__PURE__ */ new Map(), code = (o) => _keyMap[o.toLowerCase()] || _modifier[o.toLowerCase()] || o.toUpperCase().charCodeAt(0), getKey = (o) => Object.keys(_keyMap).find((i) => _keyMap[i] === o), getModifier = (o) => Object.keys(_modifier).find((i) => _modifier[i] === o);
function setScope(o) {
  _scope = o || "all";
}
function getScope() {
  return _scope || "all";
}
function getPressedKeyCodes() {
  return _downKeys.slice(0);
}
function getPressedKeyString() {
  return _downKeys.map((o) => getKey(o) || getModifier(o) || String.fromCharCode(o));
}
function getAllKeyCodes() {
  const o = [];
  return Object.keys(_handlers).forEach((i) => {
    _handlers[i].forEach((g) => {
      let {
        key: E,
        scope: e,
        mods: t,
        shortcut: n
      } = g;
      o.push({
        scope: e,
        shortcut: n,
        mods: t,
        keys: E.split("+").map((h) => code(h))
      });
    });
  }), o;
}
function filter$2(o) {
  const i = o.target || o.srcElement, {
    tagName: g
  } = i;
  let E = !0;
  const e = g === "INPUT" && !["checkbox", "radio", "range", "button", "file", "reset", "submit", "color"].includes(i.type);
  return (i.isContentEditable || (e || g === "TEXTAREA" || g === "SELECT") && !i.readOnly) && (E = !1), E;
}
function isPressed(o) {
  return typeof o == "string" && (o = code(o)), _downKeys.indexOf(o) !== -1;
}
function deleteScope(o, i) {
  let g, E;
  o || (o = getScope());
  for (const e in _handlers)
    if (Object.prototype.hasOwnProperty.call(_handlers, e))
      for (g = _handlers[e], E = 0; E < g.length; )
        g[E].scope === o ? g.splice(E, 1).forEach((n) => {
          let {
            element: h
          } = n;
          return removeKeyEvent(h);
        }) : E++;
  getScope() === o && setScope(i || "all");
}
function clearModifier(o) {
  let i = o.keyCode || o.which || o.charCode;
  o.key && o.key.toLowerCase() === "capslock" && (i = code(o.key));
  const g = _downKeys.indexOf(i);
  if (g >= 0 && _downKeys.splice(g, 1), o.key && o.key.toLowerCase() === "meta" && _downKeys.splice(0, _downKeys.length), (i === 93 || i === 224) && (i = 91), i in _mods) {
    _mods[i] = !1;
    for (const E in _modifier) _modifier[E] === i && (hotkeys[E] = !1);
  }
}
function unbind(o) {
  if (typeof o > "u")
    Object.keys(_handlers).forEach((e) => {
      Array.isArray(_handlers[e]) && _handlers[e].forEach((t) => eachUnbind(t)), delete _handlers[e];
    }), removeKeyEvent(null);
  else if (Array.isArray(o))
    o.forEach((e) => {
      e.key && eachUnbind(e);
    });
  else if (typeof o == "object")
    o.key && eachUnbind(o);
  else if (typeof o == "string") {
    for (var i = arguments.length, g = new Array(i > 1 ? i - 1 : 0), E = 1; E < i; E++)
      g[E - 1] = arguments[E];
    let [e, t] = g;
    typeof e == "function" && (t = e, e = ""), eachUnbind({
      key: o,
      scope: e,
      method: t,
      splitKey: "+"
    });
  }
}
const eachUnbind = (o) => {
  let {
    key: i,
    scope: g,
    method: E,
    splitKey: e = "+"
  } = o;
  getKeys(i).forEach((n) => {
    const h = n.split(e), d = h.length, k = h[d - 1], p = k === "*" ? "*" : code(k);
    if (!_handlers[p]) return;
    g || (g = getScope());
    const M = d > 1 ? getMods(_modifier, h) : [], H = [];
    _handlers[p] = _handlers[p].filter((f) => {
      const gA = (E ? f.method === E : !0) && f.scope === g && compareArray(f.mods, M);
      return gA && H.push(f.element), !gA;
    }), H.forEach((f) => removeKeyEvent(f));
  });
};
function eventHandler(o, i, g, E) {
  if (i.element !== E)
    return;
  let e;
  if (i.scope === g || i.scope === "all") {
    e = i.mods.length > 0;
    for (const t in _mods)
      Object.prototype.hasOwnProperty.call(_mods, t) && (!_mods[t] && i.mods.indexOf(+t) > -1 || _mods[t] && i.mods.indexOf(+t) === -1) && (e = !1);
    (i.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || e || i.shortcut === "*") && (i.keys = [], i.keys = i.keys.concat(_downKeys), i.method(o, i) === !1 && (o.preventDefault ? o.preventDefault() : o.returnValue = !1, o.stopPropagation && o.stopPropagation(), o.cancelBubble && (o.cancelBubble = !0)));
  }
}
function dispatch(o, i) {
  const g = _handlers["*"];
  let E = o.keyCode || o.which || o.charCode;
  if (o.key && o.key.toLowerCase() === "capslock" || !hotkeys.filter.call(this, o)) return;
  if ((E === 93 || E === 224) && (E = 91), _downKeys.indexOf(E) === -1 && E !== 229 && _downKeys.push(E), ["metaKey", "ctrlKey", "altKey", "shiftKey"].forEach((h) => {
    const d = modifierMap[h];
    o[h] && _downKeys.indexOf(d) === -1 ? _downKeys.push(d) : !o[h] && _downKeys.indexOf(d) > -1 ? _downKeys.splice(_downKeys.indexOf(d), 1) : h === "metaKey" && o[h] && (_downKeys = _downKeys.filter((k) => k in modifierMap || k === E));
  }), E in _mods) {
    _mods[E] = !0;
    for (const h in _modifier)
      if (Object.prototype.hasOwnProperty.call(_modifier, h)) {
        const d = modifierMap[_modifier[h]];
        hotkeys[h] = o[d];
      }
    if (!g) return;
  }
  for (const h in _mods)
    Object.prototype.hasOwnProperty.call(_mods, h) && (_mods[h] = o[modifierMap[h]]);
  o.getModifierState && !(o.altKey && !o.ctrlKey) && o.getModifierState("AltGraph") && (_downKeys.indexOf(17) === -1 && _downKeys.push(17), _downKeys.indexOf(18) === -1 && _downKeys.push(18), _mods[17] = !0, _mods[18] = !0);
  const e = getScope();
  if (g)
    for (let h = 0; h < g.length; h++)
      g[h].scope === e && (o.type === "keydown" && g[h].keydown || o.type === "keyup" && g[h].keyup) && eventHandler(o, g[h], e, i);
  if (!(E in _handlers)) return;
  const t = _handlers[E], n = t.length;
  for (let h = 0; h < n; h++)
    if ((o.type === "keydown" && t[h].keydown || o.type === "keyup" && t[h].keyup) && t[h].key) {
      const d = t[h], {
        splitKey: k
      } = d, p = d.key.split(k), M = [];
      for (let H = 0; H < p.length; H++)
        M.push(code(p[H]));
      M.sort().join("") === _downKeys.sort().join("") && eventHandler(o, d, e, i);
    }
}
function hotkeys(o, i, g) {
  _downKeys = [];
  const E = getKeys(o);
  let e = [], t = "all", n = document, h = 0, d = !1, k = !0, p = "+", M = !1, H = !1;
  for (g === void 0 && typeof i == "function" && (g = i), Object.prototype.toString.call(i) === "[object Object]" && (i.scope && (t = i.scope), i.element && (n = i.element), i.keyup && (d = i.keyup), i.keydown !== void 0 && (k = i.keydown), i.capture !== void 0 && (M = i.capture), typeof i.splitKey == "string" && (p = i.splitKey), i.single === !0 && (H = !0)), typeof i == "string" && (t = i), H && unbind(o, t); h < E.length; h++)
    o = E[h].split(p), e = [], o.length > 1 && (e = getMods(_modifier, o)), o = o[o.length - 1], o = o === "*" ? "*" : code(o), o in _handlers || (_handlers[o] = []), _handlers[o].push({
      keyup: d,
      keydown: k,
      scope: t,
      mods: e,
      shortcut: E[h],
      method: g,
      key: E[h],
      splitKey: p,
      element: n
    });
  if (typeof n < "u" && window) {
    if (!elementEventMap.has(n)) {
      const f = function() {
        let gA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        return dispatch(gA, n);
      }, AA = function() {
        let gA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        dispatch(gA, n), clearModifier(gA);
      };
      elementEventMap.set(n, {
        keydownListener: f,
        keyupListenr: AA,
        capture: M
      }), addEvent(n, "keydown", f, M), addEvent(n, "keyup", AA, M);
    }
    if (!winListendFocus) {
      const f = () => {
        _downKeys = [];
      };
      winListendFocus = {
        listener: f,
        capture: M
      }, addEvent(window, "focus", f, M);
    }
  }
}
function trigger(o) {
  let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
  Object.keys(_handlers).forEach((g) => {
    _handlers[g].filter((e) => e.scope === i && e.shortcut === o).forEach((e) => {
      e && e.method && e.method();
    });
  });
}
function removeKeyEvent(o) {
  const i = Object.values(_handlers).flat();
  if (i.findIndex((E) => {
    let {
      element: e
    } = E;
    return e === o;
  }) < 0) {
    const {
      keydownListener: E,
      keyupListenr: e,
      capture: t
    } = elementEventMap.get(o) || {};
    E && e && (removeEvent(o, "keyup", e, t), removeEvent(o, "keydown", E, t), elementEventMap.delete(o));
  }
  if ((i.length <= 0 || elementEventMap.size <= 0) && (Object.keys(elementEventMap).forEach((e) => {
    const {
      keydownListener: t,
      keyupListenr: n,
      capture: h
    } = elementEventMap.get(e) || {};
    t && n && (removeEvent(e, "keyup", n, h), removeEvent(e, "keydown", t, h), elementEventMap.delete(e));
  }), elementEventMap.clear(), Object.keys(_handlers).forEach((e) => delete _handlers[e]), winListendFocus)) {
    const {
      listener: e,
      capture: t
    } = winListendFocus;
    removeEvent(window, "focus", e, t), winListendFocus = null;
  }
}
const _api = {
  getPressedKeyString,
  setScope,
  getScope,
  deleteScope,
  getPressedKeyCodes,
  getAllKeyCodes,
  isPressed,
  filter: filter$2,
  trigger,
  unbind,
  keyMap: _keyMap,
  modifier: _modifier,
  modifierMap
};
for (const o in _api)
  Object.prototype.hasOwnProperty.call(_api, o) && (hotkeys[o] = _api[o]);
if (typeof window < "u") {
  const o = window.hotkeys;
  hotkeys.noConflict = (i) => (i && window.hotkeys === hotkeys && (window.hotkeys = o), hotkeys), window.hotkeys = hotkeys;
}
const EDITABLE_TAGS = /* @__PURE__ */ new Set(["INPUT", "TEXTAREA", "SELECT"]), MODIFIER_TOKENS = /* @__PURE__ */ new Set(["ctrl", "cmd", "alt", "shift", "mod"]), SYSTEM_MODIFIERS = /* @__PURE__ */ new Set(["ctrl", "cmd", "alt", "mod"]), MODIFIER_ORDER = ["ctrl", "cmd", "alt", "shift", "mod"], MODIFIER_DISPLAY = {
  ctrl: "Ctrl",
  cmd: "⌘",
  alt: "Alt",
  shift: "Shift",
  mod: "Mod"
  // Placeholder, will be replaced by getModifierLabel
}, KEY_DISPLAY = {
  enter: "Enter",
  space: "Space",
  tab: "Tab",
  escape: "Esc",
  backspace: "Backspace",
  delete: "Delete",
  home: "Home",
  end: "End",
  pageup: "PageUp",
  pagedown: "PageDown",
  left: "←",
  right: "→",
  up: "↑",
  down: "↓"
}, NAVIGATION_KEYS = /* @__PURE__ */ new Set(["left", "right", "up", "down", "home", "end", "pageup", "pagedown", "backspace", "delete"]);
let filterConfigured = !1;
function getEditableEventTarget(o) {
  const i = o.composedPath?.();
  if (i?.length) {
    for (const E of i) {
      const e = E;
      if (e?.tagName && (EDITABLE_TAGS.has(e.tagName) || // Some environments (e.g. jsdom) expose contentEditable primarily via
      // the attribute, so we explicitly check both the property and the
      // attribute to reliably detect editable hosts.
      e.isContentEditable || e.getAttribute("contenteditable") === "true"))
        return e;
    }
    return null;
  }
  const g = o.target || o.srcElement;
  return g?.tagName && (EDITABLE_TAGS.has(g.tagName) || g.isContentEditable || g.getAttribute("contenteditable") === "true") ? g : null;
}
function isKeyboardEventFromEditableTarget(o) {
  return o ? !!getEditableEventTarget(o) : !1;
}
function ensureHotkeysFilterConfigured() {
  filterConfigured || (hotkeys.filter = (o) => {
    if (!getEditableEventTarget(o) || o.key === "Escape" || o.ctrlKey || o.metaKey || o.altKey)
      return !0;
    if (o.shiftKey) {
      const g = o.key ?? "";
      if (g.length > 1 && !/^[a-z0-9]$/i.test(g))
        return !0;
    }
    return !1;
  }, filterConfigured = !0);
}
function parseShortcutString(o) {
  if (!o)
    return;
  const i = o.split("+").map((e) => e.trim().toLowerCase()).filter(Boolean);
  if (i.length === 0)
    return;
  let g;
  for (let e = i.length - 1; e >= 0; e -= 1) {
    const t = i[e];
    if (!MODIFIER_TOKENS.has(t)) {
      g = t;
      break;
    }
  }
  const E = i.some((e) => SYSTEM_MODIFIERS.has(e));
  return {
    tokens: i,
    baseKey: g,
    hasSystemModifier: E
  };
}
function shouldBlockShortcutInInput(o, i) {
  if (!getEditableEventTarget(i) || o.hasSystemModifier)
    return !1;
  const E = o.baseKey;
  return !!(!E || E.length === 1 && /^[a-z0-9]$/i.test(E) || E === "space" || E === "tab" || E === "enter" || NAVIGATION_KEYS.has(E));
}
function toHotkeysSequenceFromTokens(o) {
  return o.map((i) => i === "cmd" ? "command" : i).join("+");
}
function buildSequences(o) {
  if (!o)
    return [];
  const {
    tokens: i
  } = o, E = isFromMac() ? "cmd" : "ctrl", e = i.map((n) => n === "cmd" || n === "ctrl" || n === "mod" ? E : n), t = Array.from(new Set(e));
  return [toHotkeysSequenceFromTokens(t)];
}
function getModifierLabel(o, i) {
  return o === "cmd" || o === "ctrl" || o === "mod" ? i ? MODIFIER_DISPLAY.cmd : MODIFIER_DISPLAY.ctrl : o === "alt" && i ? "⌥" : MODIFIER_DISPLAY[o];
}
function getKeyLabel(o) {
  return KEY_DISPLAY[o] ? KEY_DISPLAY[o] : (o.length === 1 || o.startsWith("f") && /^\d+$/.test(o.slice(1)), o.toUpperCase());
}
function formatShortcutForDisplay(o, i) {
  const g = parseShortcutString(o);
  if (!g)
    return;
  const E = i?.isMac ?? !1, e = [];
  if (MODIFIER_ORDER.forEach((t) => {
    if (g.tokens.includes(t)) {
      const n = getModifierLabel(t, E);
      n && e.push(n);
    }
  }), g.baseKey && e.push(getKeyLabel(g.baseKey)), e.length !== 0)
    return e.join(" + ");
}
function useRegisterShortcut({
  shortcut: o,
  disabled: i = !1,
  onActivate: g
}) {
  const E = useMemo$1(() => parseShortcutString(o), [o]), e = useMemo$1(() => buildSequences(E), [E]);
  useEffect(() => {
    if (!E || e.length === 0 || i)
      return;
    const t = (n, h) => {
      i || shouldBlockShortcutInInput(E, n) || (n.preventDefault(), g());
    };
    return e.forEach((n) => {
      hotkeys(n, t);
    }), () => {
      e.forEach((n) => {
        hotkeys.unbind(n, t);
      });
    };
  }, [E, e, i, g]);
}
const DynamicButtonLabel = ({
  icon: o,
  label: i,
  iconSize: g,
  useSmallerFont: E = !1,
  iconPosition: e = "left",
  shortcut: t
}) => {
  const n = useMemo$1(() => formatShortcutForDisplay(t, {
    isMac: isFromMac()
  }), [t]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButtonLabel, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButtonMainLabel, { "data-has-shortcut": !!n, children: [
    o && e === "left" && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: g ?? "lg", iconValue: o }),
    i && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: i, allowHTML: !1, isLabel: !0, largerLabel: !E, disableLinks: !0 }),
    o && e === "right" && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: g ?? "lg", iconValue: o }),
    n && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButtonShortcut, { "aria-label": `Shortcut ${n}`, children: n })
  ] }) });
}, StyledModalButton = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e18cebhv0"
} : {
  target: "e18cebhv0",
  label: "StyledModalButton"
})(({
  theme: o
}) => ({
  marginRight: o.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvTW9kYWwvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL01vZGFsL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNb2RhbEJ1dHRvbiA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxufSkpXG4iXX0= */");
function ModalHeader({
  children: o,
  overrides: i
}) {
  const {
    genericFonts: g,
    fontSizes: E,
    spacing: e,
    fontWeights: t,
    lineHeights: n
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader$1, { style: {
    marginTop: e.none,
    marginLeft: e.none,
    marginRight: e.none,
    marginBottom: e.none,
    paddingTop: e.twoXL,
    paddingRight: e.twoXL,
    paddingBottom: e.md,
    paddingLeft: e.twoXL,
    fontFamily: g.bodyFont,
    fontSize: E.xl,
    fontWeight: t.bold,
    margin: e.none,
    lineHeight: n.small,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    maxHeight: "80vh",
    flexDirection: "row",
    ...i
  }, children: o });
}
function ModalBody$1({
  children: o
}) {
  const {
    colors: i,
    fontSizes: g,
    spacing: E
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$2, { style: {
    marginTop: E.none,
    marginLeft: E.none,
    marginRight: E.none,
    marginBottom: E.none,
    paddingTop: E.md,
    paddingRight: E.twoXL,
    paddingBottom: E.twoXL,
    paddingLeft: E.twoXL,
    color: i.bodyText,
    fontSize: g.md
  }, children: o });
}
function ModalFooter({
  children: o
}) {
  const {
    spacing: i
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter$1, { style: {
    marginTop: i.none,
    marginLeft: i.none,
    marginRight: i.none,
    marginBottom: i.none,
    paddingTop: i.md,
    paddingRight: i.md,
    paddingBottom: i.md,
    paddingLeft: i.md
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: o }) });
}
const ModalButton = (o) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledModalButton, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...o }) });
function calculateModalSize(o, i, g, E) {
  return o === "large" && E ? E : o === "medium" && i && g ? `calc(${i} + ${g})` : o === "auto" ? SIZE$2.auto : SIZE$2.default;
}
function Modal(o) {
  const {
    spacing: i,
    radii: g,
    colors: E,
    sizes: e
  } = useEmotionTheme(), t = {
    Root: {
      style: {
        background: E.darkenedBgMix25
      },
      props: {
        className: "stDialog",
        "data-testid": "stDialog"
      }
    },
    DialogContainer: {
      style: {
        alignItems: "start",
        paddingTop: i.threeXL
      }
    },
    Dialog: {
      style: {
        borderBottomRightRadius: g.xxl,
        borderBottomLeftRadius: g.xxl,
        borderTopRightRadius: g.xxl,
        borderTopLeftRadius: g.xxl,
        // make sure the modal is not too small on mobile
        minWidth: e.minPopupWidth
      }
    },
    Close: {
      style: {
        top: `calc(${i.twoXL} + ${i.xs})`,
        // Trying to center the button on the available space.
        right: i.twoXL
      }
    }
  }, n = calculateModalSize(o.size, e.contentMaxWidth, i.lg, e.dialogLargeWidth), h = merge$1(t, o.overrides), d = {
    ...o,
    size: n
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal$1, { ...d, overrides: h });
}
const StyledDialogTitle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eh5ke331"
} : {
  target: "eh5ke331",
  label: "StyledDialogTitle"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  gap: o.spacing.sm,
  // Add right margin to prevent overlap with close button
  marginRight: o.spacing.threeXL
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9EaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dUaXRsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgLy8gQWRkIHJpZ2h0IG1hcmdpbiB0byBwcmV2ZW50IG92ZXJsYXAgd2l0aCBjbG9zZSBidXR0b25cbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYTCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRGlhbG9nSWNvbiA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBmbGV4U2hyaW5rOiAwLFxufSkpXG4iXX0= */"), StyledDialogIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eh5ke330"
} : {
  target: "eh5ke330",
  label: "StyledDialogIcon"
})(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9EaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEJnQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dUaXRsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgLy8gQWRkIHJpZ2h0IG1hcmdpbiB0byBwcmV2ZW50IG92ZXJsYXAgd2l0aCBjbG9zZSBidXR0b25cbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYTCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRGlhbG9nSWNvbiA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBmbGV4U2hyaW5rOiAwLFxufSkpXG4iXX0= */");
function mapDialogWidthToModalSize(o) {
  switch (o) {
    case Block$1.Dialog.DialogWidth.MEDIUM:
      return "medium";
    case Block$1.Dialog.DialogWidth.LARGE:
      return "large";
    case Block$1.Dialog.DialogWidth.SMALL:
      return "default";
    default:
      return assertNever(o), "default";
  }
}
const Dialog = ({
  element: o,
  deltaMsgReceivedAt: i,
  children: g,
  widgetMgr: E,
  fragmentId: e
}) => {
  const {
    title: t,
    dismissible: n,
    width: h,
    isOpen: d,
    id: k,
    icon: p
  } = o, [M, H] = useState(!1);
  useEffect(() => {
    notNullOrUndefined(d) && H(d);
  }, [d, i]);
  const f = useCallback(() => {
    H(!1), k && E && E.setTriggerValue(
      {
        id: k,
        formId: ""
      },
      // WidgetInfo object - dialogs are not compatible with forms
      {
        fromUi: !0
      },
      e
    );
  }, [k, E, e]), AA = useCallback((gA) => {
    if (M && gA.key.toLowerCase() === "r" && !o.dismissible) {
      const IA = gA.target;
      if (IA && (IA.isContentEditable || IA.tagName === "INPUT" || IA.tagName === "TEXTAREA" || IA.tagName === "SELECT"))
        return;
      gA.preventDefault(), gA.stopPropagation();
    }
  }, [M, o.dismissible]);
  return useEffect(() => {
    if (M && !o.dismissible)
      return document.addEventListener("keydown", AA, !0), () => {
        document.removeEventListener("keydown", AA, !0);
      };
  }, [M, o.dismissible, AA]), M ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, closeable: n, onClose: f, size: mapDialogWidthToModalSize(h), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogTitle, { children: [
      p && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDialogIcon, { "data-testid": "stDialogIcon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: p, size: "lg" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: t, allowHTML: !1, isLabel: !0, inheritFont: !0 })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: g })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
function DialogWithProvider(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IsDialogContext.Provider, { value: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog, { ...o }) });
}
const Dialog$1 = memo(DialogWithProvider);
function _EMOTION_STRINGIFIED_CSS_ERROR__$d() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledExpandableContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx5"
} : {
  target: "eqpbllx5",
  label: "StyledExpandableContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9FeHBhbmRlci9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5QnlDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9FeHBhbmRlci9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5pbXBvcnQgeyBTVEFMRV9TVFlMRVMsIFNUQUxFX1RSQU5TSVRJT05fUEFSQU1TIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZEV4cGFuZGFibGVDb250YWluZXJQcm9wcyB7XG4gIGVtcHR5OiBib29sZWFuXG4gIGRpc2FibGVkOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeHBhbmRhYmxlQ29udGFpbmVyID0gc3R5bGVkLmRpdih7XG4gIHdpZHRoOiBcIjEwMCVcIixcbn0pXG5pbnRlcmZhY2UgU3R5bGVkRGV0YWlsc1Byb3BzIHtcbiAgaXNTdGFsZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgQk9SREVSX1NJWkUgPSAxIC8vIHB4XG5leHBvcnQgY29uc3QgU3R5bGVkRGV0YWlscyA9IHN0eWxlZC5kZXRhaWxzPFN0eWxlZERldGFpbHNQcm9wcz4oXG4gICh7IGlzU3RhbGUsIHRoZW1lIH0pID0+ICh7XG4gICAgbWFyZ2luQm90dG9tOiAwLFxuICAgIG1hcmdpblRvcDogMCxcbiAgICB3aWR0aDogXCIxMDAlXCIsXG4gICAgYm9yZGVyU3R5bGU6IFwic29saWRcIixcbiAgICBib3JkZXJXaWR0aDogdGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGgsXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgLi4uKGlzU3RhbGVcbiAgICAgID8ge1xuICAgICAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3JMaWdodCxcbiAgICAgICAgICB0cmFuc2l0aW9uOiBgYm9yZGVyICR7U1RBTEVfVFJBTlNJVElPTl9QQVJBTVN9YCxcbiAgICAgICAgfVxuICAgICAgOiB7fSksXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdW1tYXJ5SGVhZGluZyA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBmbGV4R3JvdzogMSxcbiAgbWluV2lkdGg6IDAsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdW1tYXJ5TGFiZWxXcmFwcGVyID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIGZsZXhHcm93OiAxLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbn0pXG5cbmludGVyZmFjZSBTdHlsZWRTdW1tYXJ5UHJvcHMge1xuICBpc1N0YWxlOiBib29sZWFuXG4gIGV4cGFuZGVkOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdW1tYXJ5ID0gc3R5bGVkLnN1bW1hcnk8U3R5bGVkU3VtbWFyeVByb3BzPihcbiAgKHsgdGhlbWUsIGlzU3RhbGUsIGV4cGFuZGVkIH0pID0+ICh7XG4gICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICB3aWR0aDogXCIxMDAlXCIsXG4gICAgLy8gUHJldmVudCBjaGV2cm9uL3VzZXIgaWNvbiBmcm9tIG92ZXJsYXBwaW5nIGNvbnRlbnQgYnkgZW5zdXJpbmdcbiAgICAvLyBjaGlsZHJlbiBjYW4gc2hyaW5rIGFuZCB0aGUgc3VtbWFyeSBjYW4gY2xpcCBleGNlc3MgaW5saW5lIG92ZXJmbG93LlxuICAgIG1pbldpZHRoOiAwLFxuICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmcsXG4gICAgfSxcbiAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcubWQsXG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIHBhZGRpbmdUb3A6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgcGFkZGluZ0JvdHRvbTogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBtaW5IZWlnaHQ6IGBjYWxjKCR7dGhlbWUuc2l6ZXMubWluRWxlbWVudEhlaWdodH0gLSAyICogJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0pYCxcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgbGlzdFN0eWxlVHlwZTogXCJub25lXCIsXG4gICAgXCImOjotd2Via2l0LWRldGFpbHMtbWFya2VyXCI6IHtcbiAgICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgYmFja2dyb3VuZENvbG9yOiBleHBhbmRlZCA/IHRoZW1lLmNvbG9ycy5iZ01peCA6IFwidHJhbnNwYXJlbnRcIixcbiAgICAvLyBXaGVuIGV4cGFuZGVkLCBvbmx5IHJvdW5kIHRoZSB0b3AgY29ybmVyc1xuICAgIGJvcmRlclJhZGl1czogZXhwYW5kZWRcbiAgICAgID8gYCR7dGhlbWUucmFkaWkuZGVmYXVsdH0gJHt0aGVtZS5yYWRpaS5kZWZhdWx0fSAwIDBgXG4gICAgICA6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgLy8gQW5pbWF0ZSBib3JkZXItcmFkaXVzIGNoYW5nZXMgd2hlbiBleHBhbmRpbmcvY29sbGFwc2luZyB0byBtYXRjaCB0aGUgYW5pbWF0aW9uIG9mXG4gICAgLy8gdGhlIGV4cGFuZGVyIGNvbnRlbnQuIFVzZSBhIGRlbGF5IHdoZW4gY29sbGFwc2luZyBiZWNhdXNlIHRoZSBjb250ZW50IGZpcnN0IG5lZWRzXG4gICAgLy8gdG8gc2xpZGUgdXAuXG4gICAgdHJhbnNpdGlvbjogZXhwYW5kZWRcbiAgICAgID8gYGJvcmRlci1yYWRpdXMgMjAwbXMgY3ViaWMtYmV6aWVyKDAuMjMsIDEsIDAuMzIsIDEpLCBiYWNrZ3JvdW5kLWNvbG9yIDE1MG1zIGVhc2VgXG4gICAgICA6IGBib3JkZXItcmFkaXVzIDIwMG1zIGN1YmljLWJlemllcigwLjIzLCAxLCAwLjMyLCAxKSAzMDBtcywgYmFja2dyb3VuZC1jb2xvciAxNTBtcyBlYXNlYCxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIC4uLihpc1N0YWxlICYmIFNUQUxFX1NUWUxFUyksXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREZXRhaWxzUGFuZWwgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubGcsXG4gIGJvcmRlclRvcDogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG59KSlcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), BORDER_SIZE = 1, StyledDetails = /* @__PURE__ */ createStyled("details", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx4"
} : {
  target: "eqpbllx4",
  label: "StyledDetails"
})(({
  isStale: o,
  theme: i
}) => ({
  marginBottom: 0,
  marginTop: 0,
  width: "100%",
  borderStyle: "solid",
  borderWidth: i.sizes.borderWidth,
  borderColor: i.colors.borderColor,
  borderRadius: i.radii.default,
  ...o ? {
    borderColor: i.colors.borderColorLight,
    transition: `border ${STALE_TRANSITION_PARAMS}`
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9FeHBhbmRlci9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQzZCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9FeHBhbmRlci9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5pbXBvcnQgeyBTVEFMRV9TVFlMRVMsIFNUQUxFX1RSQU5TSVRJT05fUEFSQU1TIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZEV4cGFuZGFibGVDb250YWluZXJQcm9wcyB7XG4gIGVtcHR5OiBib29sZWFuXG4gIGRpc2FibGVkOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeHBhbmRhYmxlQ29udGFpbmVyID0gc3R5bGVkLmRpdih7XG4gIHdpZHRoOiBcIjEwMCVcIixcbn0pXG5pbnRlcmZhY2UgU3R5bGVkRGV0YWlsc1Byb3BzIHtcbiAgaXNTdGFsZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgQk9SREVSX1NJWkUgPSAxIC8vIHB4XG5leHBvcnQgY29uc3QgU3R5bGVkRGV0YWlscyA9IHN0eWxlZC5kZXRhaWxzPFN0eWxlZERldGFpbHNQcm9wcz4oXG4gICh7IGlzU3RhbGUsIHRoZW1lIH0pID0+ICh7XG4gICAgbWFyZ2luQm90dG9tOiAwLFxuICAgIG1hcmdpblRvcDogMCxcbiAgICB3aWR0aDogXCIxMDAlXCIsXG4gICAgYm9yZGVyU3R5bGU6IFwic29saWRcIixcbiAgICBib3JkZXJXaWR0aDogdGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGgsXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgLi4uKGlzU3RhbGVcbiAgICAgID8ge1xuICAgICAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3JMaWdodCxcbiAgICAgICAgICB0cmFuc2l0aW9uOiBgYm9yZGVyICR7U1RBTEVfVFJBTlNJVElPTl9QQVJBTVN9YCxcbiAgICAgICAgfVxuICAgICAgOiB7fSksXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdW1tYXJ5SGVhZGluZyA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBmbGV4R3JvdzogMSxcbiAgbWluV2lkdGg6IDAsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdW1tYXJ5TGFiZWxXcmFwcGVyID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIGZsZXhHcm93OiAxLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbn0pXG5cbmludGVyZmFjZSBTdHlsZWRTdW1tYXJ5UHJvcHMge1xuICBpc1N0YWxlOiBib29sZWFuXG4gIGV4cGFuZGVkOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdW1tYXJ5ID0gc3R5bGVkLnN1bW1hcnk8U3R5bGVkU3VtbWFyeVByb3BzPihcbiAgKHsgdGhlbWUsIGlzU3RhbGUsIGV4cGFuZGVkIH0pID0+ICh7XG4gICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICB3aWR0aDogXCIxMDAlXCIsXG4gICAgLy8gUHJldmVudCBjaGV2cm9uL3VzZXIgaWNvbiBmcm9tIG92ZXJsYXBwaW5nIGNvbnRlbnQgYnkgZW5zdXJpbmdcbiAgICAvLyBjaGlsZHJlbiBjYW4gc2hyaW5rIGFuZCB0aGUgc3VtbWFyeSBjYW4gY2xpcCBleGNlc3MgaW5saW5lIG92ZXJmbG93LlxuICAgIG1pbldpZHRoOiAwLFxuICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmcsXG4gICAgfSxcbiAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcubWQsXG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIHBhZGRpbmdUb3A6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgcGFkZGluZ0JvdHRvbTogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBtaW5IZWlnaHQ6IGBjYWxjKCR7dGhlbWUuc2l6ZXMubWluRWxlbWVudEhlaWdodH0gLSAyICogJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0pYCxcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgbGlzdFN0eWxlVHlwZTogXCJub25lXCIsXG4gICAgXCImOjotd2Via2l0LWRldGFpbHMtbWFya2VyXCI6IHtcbiAgICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgYmFja2dyb3VuZENvbG9yOiBleHBhbmRlZCA/IHRoZW1lLmNvbG9ycy5iZ01peCA6IFwidHJhbnNwYXJlbnRcIixcbiAgICAvLyBXaGVuIGV4cGFuZGVkLCBvbmx5IHJvdW5kIHRoZSB0b3AgY29ybmVyc1xuICAgIGJvcmRlclJhZGl1czogZXhwYW5kZWRcbiAgICAgID8gYCR7dGhlbWUucmFkaWkuZGVmYXVsdH0gJHt0aGVtZS5yYWRpaS5kZWZhdWx0fSAwIDBgXG4gICAgICA6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgLy8gQW5pbWF0ZSBib3JkZXItcmFkaXVzIGNoYW5nZXMgd2hlbiBleHBhbmRpbmcvY29sbGFwc2luZyB0byBtYXRjaCB0aGUgYW5pbWF0aW9uIG9mXG4gICAgLy8gdGhlIGV4cGFuZGVyIGNvbnRlbnQuIFVzZSBhIGRlbGF5IHdoZW4gY29sbGFwc2luZyBiZWNhdXNlIHRoZSBjb250ZW50IGZpcnN0IG5lZWRzXG4gICAgLy8gdG8gc2xpZGUgdXAuXG4gICAgdHJhbnNpdGlvbjogZXhwYW5kZWRcbiAgICAgID8gYGJvcmRlci1yYWRpdXMgMjAwbXMgY3ViaWMtYmV6aWVyKDAuMjMsIDEsIDAuMzIsIDEpLCBiYWNrZ3JvdW5kLWNvbG9yIDE1MG1zIGVhc2VgXG4gICAgICA6IGBib3JkZXItcmFkaXVzIDIwMG1zIGN1YmljLWJlemllcigwLjIzLCAxLCAwLjMyLCAxKSAzMDBtcywgYmFja2dyb3VuZC1jb2xvciAxNTBtcyBlYXNlYCxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIC4uLihpc1N0YWxlICYmIFNUQUxFX1NUWUxFUyksXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREZXRhaWxzUGFuZWwgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubGcsXG4gIGJvcmRlclRvcDogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG59KSlcbiJdfQ== */"), StyledSummaryHeading = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx3"
} : {
  target: "eqpbllx3",
  label: "StyledSummaryHeading"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  flexGrow: 1,
  minWidth: 0,
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  gap: o.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSummaryLabelWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx2"
} : {
  target: "eqpbllx2",
  label: "StyledSummaryLabelWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "xomnir",
  styles: "display:flex;width:100%;flex-grow:1;overflow:hidden"
} : {
  name: "xomnir",
  styles: "display:flex;width:100%;flex-grow:1;overflow:hidden/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), StyledSummary = /* @__PURE__ */ createStyled("summary", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx1"
} : {
  target: "eqpbllx1",
  label: "StyledSummary"
})(({
  theme: o,
  isStale: i,
  expanded: g
}) => ({
  position: "relative",
  display: "flex",
  width: "100%",
  // Prevent chevron/user icon from overlapping content by ensuring
  // children can shrink and the summary can clip excess inline overflow.
  minWidth: 0,
  overflow: "hidden",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: o.shadows.focusRing
  },
  fontSize: "inherit",
  paddingLeft: o.spacing.md,
  paddingRight: o.spacing.md,
  paddingTop: o.spacing.twoXS,
  paddingBottom: o.spacing.twoXS,
  minHeight: `calc(${o.sizes.minElementHeight} - 2 * ${o.sizes.borderWidth})`,
  alignItems: "center",
  cursor: "pointer",
  listStyleType: "none",
  "&::-webkit-details-marker": {
    display: "none"
  },
  backgroundColor: g ? o.colors.bgMix : "transparent",
  // When expanded, only round the top corners
  borderRadius: g ? `${o.radii.default} ${o.radii.default} 0 0` : o.radii.default,
  // Animate border-radius changes when expanding/collapsing to match the animation of
  // the expander content. Use a delay when collapsing because the content first needs
  // to slide up.
  transition: g ? "border-radius 200ms cubic-bezier(0.23, 1, 0.32, 1), background-color 150ms ease" : "border-radius 200ms cubic-bezier(0.23, 1, 0.32, 1) 300ms, background-color 150ms ease",
  "&:hover, &:focus-visible": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: o.colors.darkenedBgMix25
  },
  ...i && STALE_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDetailsPanel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx0"
} : {
  target: "eqpbllx0",
  label: "StyledDetailsPanel"
})(({
  theme: o
}) => ({
  padding: o.spacing.lg,
  borderTop: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ExpanderIcon = (o) => {
  const {
    icon: i
  } = o, g = {
    ":material/check:": "stExpanderIconCheck",
    ":material/error:": "stExpanderIconError",
    spinner: "stExpanderIconSpinner"
  };
  return i ? /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: i, testid: g[i] || "stExpanderIcon" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, Expander = ({
  element: o,
  isStale: i,
  children: g
}) => {
  const {
    label: E,
    expanded: e
  } = o, [t, n] = useState(e || !1), [h, d] = useState(!1), k = useRef(null), p = useRef(null), M = useRef(null), H = useRef(null), f = useRef(null);
  useEffect(() => {
    notNullOrUndefined(e) && (n(e), k.current && (k.current.open = e));
  }, [E, e]);
  const AA = (EA) => {
    k.current && (k.current.open = EA, M.current = null, k.current.style.height = "", k.current.style.overflow = "");
  }, gA = (EA, oA, eA) => {
    const GA = eA > oA;
    M.current && (M.current.cancel(), H.current && (clearTimeout(H.current), H.current = null));
    const cA = EA.animate({
      height: [`${oA}px`, `${eA}px`]
    }, {
      duration: 500,
      easing: "cubic-bezier(0.23, 1, 0.32, 1)"
    });
    cA.addEventListener("finish", () => AA(GA)), M.current = cA;
  }, IA = (EA) => {
    EA.preventDefault(), n(!t);
    const oA = k.current;
    if (!oA || !p.current)
      return;
    oA.style.overflow = "hidden";
    const eA = oA.getBoundingClientRect().height, GA = p.current.getBoundingClientRect().height;
    t ? gA(oA, eA, GA + 2 * BORDER_SIZE) : (oA.style.height = `${eA}px`, oA.open = !0, window.requestAnimationFrame(() => {
      gA(
        oA,
        eA,
        GA + 2 * BORDER_SIZE + 5
        // Arbitrary size of 5px
      ), H.current = setTimeout(() => {
        if (!f.current)
          return;
        const cA = (
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          f.current.getBoundingClientRect().height
        );
        gA(oA, eA, GA + cA + 2 * BORDER_SIZE);
      }, 100);
    }));
  }, BA = () => {
    d(!0);
  }, CA = () => {
    d(!1);
  }, QA = !o.icon || h, iA = o.icon && !h;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExpandableContainer, { className: "stExpander", "data-testid": "stExpander", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDetails, { isStale: i, ref: k, onMouseEnter: BA, onMouseLeave: CA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSummary, { onClick: IA, ref: p, isStale: i, expanded: t, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSummaryHeading, { children: [
      QA && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: t ? ":material/keyboard_arrow_down:" : ":material/keyboard_arrow_right:", size: "lg" }),
      iA && /* @__PURE__ */ jsxRuntimeExports.jsx(ExpanderIcon, { icon: o.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSummaryLabelWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: E, allowHTML: !1, isLabel: !0, largerLabel: !0 }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDetailsPanel, { "data-testid": "stExpanderDetails", ref: f, children: g })
  ] }) });
}, Expander$1 = memo(Expander), Box = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "epl6yf30"
} : {
  target: "epl6yf30",
  label: "Box"
})(({
  width: o = "100%",
  height: i
}) => ({
  width: o,
  height: i
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getBorderColor = (o, i) => {
  let g = o.widgetBorderColor ?? o.secondaryBg;
  return i && (g = o.primary), g;
}, useResizeObserver = (o, i = []) => {
  const g = useRef(null), [E, e] = useState([]), t = useCallback(() => {
    if (!g.current)
      return [];
    const n = g.current.getBoundingClientRect();
    return o.map((h) => n[h]);
  }, [o]);
  return useEffect(() => {
    if (!g.current)
      return;
    e(t());
    let n;
    const h = new ResizeObserver(() => {
      n = window.requestAnimationFrame(() => {
        e(t());
      });
    });
    return h.observe(g.current), () => {
      h.disconnect(), n && cancelAnimationFrame(n);
    };
  }, [o, t, ...i]), {
    values: E,
    elementRef: g
  };
}, useCalculatedDimensions = (o = [], i = -1) => {
  const {
    values: [g, E],
    elementRef: e
  } = useResizeObserver(useMemo$1(() => ["width", "height"], []), o);
  return {
    width: g || i,
    height: E || i,
    elementRef: e
  };
}, StyledPopoverLabelContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1pbrot51"
} : {
  target: "e1pbrot51",
  label: "StyledPopoverLabelContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  gap: o.spacing.threeXS,
  // This is a hacky way to offset the "padding" of the expansion svg
  // icon. Reason is that we want to use the same padding to the right side
  // as the text on the left side. The alternative would be to overwrite the
  // right padding of the button, which would also be hacky and involve slightly
  // more logic.
  // If the padding of the icon changes, this value needs to be adjusted.
  // Also, if we want to apply the same adjustment for other elements, we should
  // consider putting this into a theme variable or creating a shared styled component.
  // The SVG icon we are using seems to have an internal padding of around 25%.
  marginRight: `calc(-${o.iconSizes.lg} * 0.25)`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Qb3BvdmVyL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCMkMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL1BvcG92ZXIvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBvcG92ZXJMYWJlbENvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAvLyBUaGlzIGlzIGEgaGFja3kgd2F5IHRvIG9mZnNldCB0aGUgXCJwYWRkaW5nXCIgb2YgdGhlIGV4cGFuc2lvbiBzdmdcbiAgLy8gaWNvbi4gUmVhc29uIGlzIHRoYXQgd2Ugd2FudCB0byB1c2UgdGhlIHNhbWUgcGFkZGluZyB0byB0aGUgcmlnaHQgc2lkZVxuICAvLyBhcyB0aGUgdGV4dCBvbiB0aGUgbGVmdCBzaWRlLiBUaGUgYWx0ZXJuYXRpdmUgd291bGQgYmUgdG8gb3ZlcndyaXRlIHRoZVxuICAvLyByaWdodCBwYWRkaW5nIG9mIHRoZSBidXR0b24sIHdoaWNoIHdvdWxkIGFsc28gYmUgaGFja3kgYW5kIGludm9sdmUgc2xpZ2h0bHlcbiAgLy8gbW9yZSBsb2dpYy5cbiAgLy8gSWYgdGhlIHBhZGRpbmcgb2YgdGhlIGljb24gY2hhbmdlcywgdGhpcyB2YWx1ZSBuZWVkcyB0byBiZSBhZGp1c3RlZC5cbiAgLy8gQWxzbywgaWYgd2Ugd2FudCB0byBhcHBseSB0aGUgc2FtZSBhZGp1c3RtZW50IGZvciBvdGhlciBlbGVtZW50cywgd2Ugc2hvdWxkXG4gIC8vIGNvbnNpZGVyIHB1dHRpbmcgdGhpcyBpbnRvIGEgdGhlbWUgdmFyaWFibGUgb3IgY3JlYXRpbmcgYSBzaGFyZWQgc3R5bGVkIGNvbXBvbmVudC5cbiAgLy8gVGhlIFNWRyBpY29uIHdlIGFyZSB1c2luZyBzZWVtcyB0byBoYXZlIGFuIGludGVybmFsIHBhZGRpbmcgb2YgYXJvdW5kIDI1JS5cbiAgbWFyZ2luUmlnaHQ6IGBjYWxjKC0ke3RoZW1lLmljb25TaXplcy5sZ30gKiAwLjI1KWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBvcG92ZXJFeHBhbnNpb25JY29uID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIC8vIFNtYWxsIGhhY2sgdG8gYmV0dGVyIGFsaWduIHRoZSBleHBhbnNpb24gaWNvbiB3aXRoIHRoZSBsYWJlbC5cbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG59KSlcbiJdfQ== */"), StyledPopoverExpansionIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1pbrot50"
} : {
  target: "e1pbrot50",
  label: "StyledPopoverExpansionIcon"
})(({
  theme: o
}) => ({
  display: "inline-flex",
  // Small hack to better align the expansion icon with the label.
  marginTop: o.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Popover = ({
  element: o,
  empty: i,
  children: g,
  stretchWidth: E
}) => {
  const [e, t] = useState(!1), n = useContext(IsSidebarContext), h = useEmotionTheme(), {
    width: d,
    elementRef: k
  } = useCalculatedDimensions();
  let p = BaseButtonKind.SECONDARY;
  return o.type === "primary" ? p = BaseButtonKind.PRIMARY : o.type === "tertiary" && (p = BaseButtonKind.TERTIARY), /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { "data-testid": "stPopover", className: "stPopover", ref: k, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover$2,
    {
      triggerType: TRIGGER_TYPE.click,
      placement: PLACEMENT$1.bottomLeft,
      content: () => g,
      isOpen: e,
      onClickOutside: () => t(!1),
      onClick: () => e ? t(!1) : void 0,
      onEsc: () => t(!1),
      ignoreBoundary: n,
      renderAll: !0,
      overrides: {
        Body: {
          props: {
            "data-testid": "stPopoverBody"
          },
          style: () => ({
            marginRight: h.spacing.lg,
            marginBottom: h.spacing.lg,
            maxHeight: "70vh",
            overflow: "auto",
            maxWidth: `calc(${h.sizes.contentMaxWidth} - 2*${h.spacing.lg})`,
            minWidth: E ? (
              // If width="stretch", we use the container width as minimum:
              `${Math.max(d, 160)}px`
            ) : h.sizes.minPopupWidth,
            [`@media (max-width: ${h.breakpoints.sm})`]: {
              maxWidth: `calc(100% - ${h.spacing.threeXL})`
            },
            borderTopLeftRadius: h.radii.xl,
            borderTopRightRadius: h.radii.xl,
            borderBottomRightRadius: h.radii.xl,
            borderBottomLeftRadius: h.radii.xl,
            borderLeftWidth: h.sizes.borderWidth,
            borderRightWidth: h.sizes.borderWidth,
            borderTopWidth: h.sizes.borderWidth,
            borderBottomWidth: h.sizes.borderWidth,
            paddingRight: `calc(${h.spacing.twoXL} - ${h.sizes.borderWidth})`,
            // 1px to account for border.
            paddingLeft: `calc(${h.spacing.twoXL} - ${h.sizes.borderWidth})`,
            paddingBottom: `calc(${h.spacing.twoXL} - ${h.sizes.borderWidth})`,
            paddingTop: `calc(${h.spacing.twoXL} - ${h.sizes.borderWidth})`,
            borderLeftStyle: "solid",
            borderRightStyle: "solid",
            borderTopStyle: "solid",
            borderBottomStyle: "solid",
            borderLeftColor: h.colors.borderColor,
            borderRightColor: h.colors.borderColor,
            borderTopColor: h.colors.borderColor,
            borderBottomColor: h.colors.borderColor,
            boxShadow: h.shadows.popover
          })
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButtonTooltip, { help: o.help, containerWidth: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { "data-testid": "stPopoverButton", kind: p, size: BaseButtonSize.SMALL, disabled: i || o.disabled, containerWidth: !0, onClick: () => t(!e), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledPopoverLabelContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicButtonLabel, { icon: o.icon, label: o.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPopoverExpansionIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: e ? ":material/expand_less:" : ":material/expand_more:", size: "lg" }) })
      ] }) }) }) })
    }
  ) });
}, Popover$1 = memo(Popover);
var ORIENTATION = {
  vertical: "vertical",
  horizontal: "horizontal"
}, FILL = {
  fixed: "fixed",
  intrinsic: "intrinsic"
}, getTabId = function o(i, g) {
  return "tabs-".concat(i, "-tab-").concat(g);
}, getTabPanelId = function o(i, g) {
  return "tabs-".concat(i, "-tabpanel-").concat(g);
}, isHorizontal = function o(i) {
  return i === ORIENTATION.horizontal;
}, isVertical = function o(i) {
  return i === ORIENTATION.vertical;
}, isRTL = function o(i) {
  return i === "rtl";
}, isIntrinsic = function o(i) {
  return i === FILL.intrinsic;
}, isFixed = function o(i) {
  return i === FILL.fixed;
};
function ownKeys$e(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$c(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$e(Object(g), !0).forEach(function(E) {
      _defineProperty$f(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$e(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$f(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var StyledRoot$1 = styled("div", function(o) {
  o.$theme;
  var i = o.$orientation, g = i === void 0 ? ORIENTATION.horizontal : i, E = {
    // Creates a stacking context so we can use z-index on the TabHighlight
    // without affecting anything outside of this element.
    transform: "scale(1)"
  };
  return isVertical(g) && (E.display = "flex"), E;
});
StyledRoot$1.displayName = "StyledRoot";
StyledRoot$1.displayName = "StyledRoot";
var StyledTabBar = styled("div", function(o) {
  var i = o.$hasEndEnhancer, g = o.$orientation;
  return i || !isHorizontal(g) ? {
    display: "flex"
  } : {};
});
StyledTabBar.displayName = "StyledTabBar";
StyledTabBar.displayName = "StyledTabBar";
var StyledTabList = styled("div", function(o) {
  var i = o.$theme, g = o.$fill, E = g === void 0 ? FILL.intrinsic : g, e = o.$orientation, t = e === void 0 ? ORIENTATION.horizontal : e, n = {
    position: "relative",
    display: "flex",
    flexWrap: "nowrap",
    flexGrow: 1
  };
  return isHorizontal(t) ? (n.flexDirection = "row", n.paddingBottom = "5px", n.marginBottom = "-5px") : (n.flexDirection = "column", isRTL(i.direction) ? (n.paddingLeft = "5px", n.marginLeft = "-5px") : (n.paddingRight = "5px", n.marginRight = "-5px")), isIntrinsic(E) && (n["::-webkit-scrollbar"] = {
    display: "none"
  }, n["-ms-overflow-style"] = "none", n.scrollbarWidth = "none", isHorizontal(t) ? n.overflowX = "scroll" : n.overflowY = "scroll"), n;
});
StyledTabList.displayName = "StyledTabList";
StyledTabList.displayName = "StyledTabList";
var StyledTab = styled("button", function(o) {
  var i = o.$theme, g = o.$orientation, E = g === void 0 ? ORIENTATION.horizontal : g, e = o.$fill, t = e === void 0 ? FILL.intrinsic : e, n = o.$focusVisible, h = n === void 0 ? !1 : n;
  o.$isActive;
  var d = _objectSpread$c({
    cursor: "pointer",
    WebkitAppearance: "none",
    marginLeft: "0",
    marginRight: "0",
    marginTop: "0",
    marginBottom: "0",
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    paddingLeft: i.sizing.scale600,
    paddingTop: i.sizing.scale600,
    paddingRight: i.sizing.scale600,
    paddingBottom: i.sizing.scale600,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    color: i.colors.contentPrimary,
    background: i.colors.backgroundPrimary,
    transitionProperty: "background",
    transitionDuration: i.animation.timing200,
    transitionTimingFunction: i.animation.linearCurve,
    outline: "none",
    outlineOffset: "-3px",
    ":disabled": {
      cursor: "not-allowed",
      color: i.colors.contentStateDisabled
    },
    ":hover": {
      background: i.colors.backgroundSecondary
    },
    ":disabled:hover": {
      background: "none"
    }
  }, i.typography.LabelSmall);
  return h && (d.outline = "3px solid ".concat(i.colors.accent)), isFixed(t) && (d.flexGrow = 1, d.flexBasis = 0), isHorizontal(E) ? d.justifyContent = "center" : d.justifyContent = "flex-end", d;
});
StyledTab.displayName = "StyledTab";
StyledTab.displayName = "StyledTab";
var StyledEndEnhancerContainer = styled("div", function(o) {
  var i = o.$theme, g = i.direction === "rtl" ? "marginRight" : "marginLeft";
  return _defineProperty$f({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, g, i.sizing.scale600);
});
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
var StyledArtworkContainer = styled("div", function(o) {
  var i = o.$theme;
  o.$orientation;
  var g = {
    display: "flex"
  };
  return isRTL(i.direction) ? g.marginLeft = i.sizing.scale300 : g.marginRight = i.sizing.scale300, g;
});
StyledArtworkContainer.displayName = "StyledArtworkContainer";
StyledArtworkContainer.displayName = "StyledArtworkContainer";
var StyledTabBorder = styled("div", function(o) {
  var i = o.$theme, g = o.$orientation, E = g === void 0 ? ORIENTATION.horizontal : g, e = {
    backgroundColor: i.colors.borderOpaque,
    position: "relative"
  };
  return isHorizontal(E) ? e.height = "5px" : e.width = "5px", e;
});
StyledTabBorder.displayName = "StyledTabBorder";
StyledTabBorder.displayName = "StyledTabBorder";
var StyledTabHighlight = styled("div", function(o) {
  var i = o.$theme, g = o.$orientation, E = g === void 0 ? ORIENTATION.horizontal : g, e = o.$length, t = e === void 0 ? 0 : e, n = o.$distance, h = n === void 0 ? 0 : n, d = o.$animate, k = d === void 0 ? !1 : d, p = {
    backgroundColor: i.colors.borderSelected,
    position: "absolute",
    zIndex: 1
  };
  return isHorizontal(E) ? (p.bottom = "0px", p.left = "0px", p.height = "5px", p.width = "".concat(t, "px"), p.transform = "translateX(".concat(h, "px)")) : (p.transform = "translateY(".concat(h, "px)"), p.width = "5px", p.height = "".concat(t, "px"), isRTL(i.direction) ? p.left = "0px" : p.right = "0px"), k && (p.transitionProperty = "all", p.transitionDuration = i.animation.timing400, p.transitionTimingFunction = i.animation.easeInOutQuinticCurve), p;
});
StyledTabHighlight.displayName = "StyledTabHighlight";
StyledTabHighlight.displayName = "StyledTabHighlight";
var StyledTabPanel = styled("div", function(o) {
  var i = o.$theme, g = o.$pad, E = g === void 0 ? !0 : g, e = {
    flexGrow: 1,
    // only used in vertical orientation
    outline: "none"
  };
  return E && (e.paddingTop = i.sizing.scale600, e.paddingRight = i.sizing.scale600, e.paddingBottom = i.sizing.scale600, e.paddingLeft = i.sizing.scale600), e;
});
StyledTabPanel.displayName = "StyledTabPanel";
StyledTabPanel.displayName = "StyledTabPanel";
var _excluded$j = ["childKey", "childIndex", "activeKey", "orientation", "activeTabRef", "updateHighlight", "parseKeyDown", "activateOnFocus", "uid", "disabled", "sharedStylingProps", "onChange"], _excluded2$4 = ["artwork", "overrides", "tabRef", "onClick", "title"], _excluded3$1 = ["childKey", "childIndex", "activeKey", "uid", "sharedStylingProps", "renderAll"];
function ownKeys$d(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$b(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$d(Object(g), !0).forEach(function(E) {
      _defineProperty$e(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$d(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$e(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function _toConsumableArray$1(o) {
  return _arrayWithoutHoles$1(o) || _iterableToArray$1(o) || _unsupportedIterableToArray$e(o) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function _arrayWithoutHoles$1(o) {
  if (Array.isArray(o)) return _arrayLikeToArray$e(o);
}
function _objectWithoutProperties$h(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$g(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$g(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$j.apply(this, arguments);
}
function _slicedToArray$f(o, i) {
  return _arrayWithHoles$e(o) || _iterableToArrayLimit$e(o, i) || _unsupportedIterableToArray$e(o, i) || _nonIterableRest$e();
}
function _nonIterableRest$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$e(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$e(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$e(o, i);
  }
}
function _arrayLikeToArray$e(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$e(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$e(o) {
  if (Array.isArray(o)) return o;
}
var KEYBOARD_ACTION = {
  next: "next",
  previous: "previous"
}, getLayoutParams = function o(i, g) {
  return i ? isVertical(g) ? {
    length: i.clientHeight,
    distance: i.offsetTop
  } : {
    length: i.clientWidth,
    distance: i.offsetLeft
  } : {
    length: 0,
    distance: 0
  };
}, scrollParentToCentreTarget = function o(i) {
  var g = i.parentNode.getBoundingClientRect(), E = g.x, e = g.y, t = g.width, n = g.height, h = i.getBoundingClientRect(), d = h.x, k = h.y, p = h.width, M = h.height, H = {
    x: d - E + p / 2,
    y: k - e + M / 2
  }, f = i.parentNode, AA = f.scrollLeft, gA = f.scrollTop, IA = {
    x: AA + H.x - t / 2,
    y: gA + H.y - n / 2
  };
  i.parentNode.scroll(IA.x, IA.y);
};
function RenderEnhancer(o) {
  var i = o.Enhancer;
  return typeof i == "string" ? i : reactIsExports$1.isValidElementType(i) ? /* @__PURE__ */ React.createElement(i, null) : i;
}
function Tabs$2(o) {
  var i = o.activeKey, g = i === void 0 ? "0" : i, E = o.disabled, e = E === void 0 ? !1 : E, t = o.children, n = o.fill, h = n === void 0 ? FILL.intrinsic : n, d = o.activateOnFocus, k = d === void 0 ? !0 : d, p = o.onChange, M = o.orientation, H = M === void 0 ? ORIENTATION.horizontal : M, f = o.overrides, AA = f === void 0 ? {} : f, gA = o.renderAll, IA = gA === void 0 ? !1 : gA, BA = o.uid, CA = BA === void 0 ? null : BA, QA = o.endEnhancer, iA = useUID(), EA = CA || iA, oA = AA.Root, eA = AA.TabList, GA = AA.TabHighlight, cA = AA.TabBorder, tA = getOverrides(oA, StyledRoot$1), aA = _slicedToArray$f(tA, 2), sA = aA[0], DA = aA[1], rA = getOverrides(eA, StyledTabList), nA = _slicedToArray$f(rA, 2), NA = nA[0], pA = nA[1], mA = getOverrides(GA, StyledTabHighlight), XA = _slicedToArray$f(mA, 2), lA = XA[0], kA = XA[1], ZA = getOverrides(cA, StyledTabBorder), wA = _slicedToArray$f(ZA, 2), LA = wA[0], fA = wA[1], dA = getOverrides(AA.EndEnhancerContainer, StyledEndEnhancerContainer), RA = _slicedToArray$f(dA, 2), KA = RA[0], xA = RA[1], MA = React.useState(0), OA = _slicedToArray$f(MA, 2), SA = OA[0], gg = OA[1];
  React.useEffect(function() {
    gg(SA + 1);
  }, [g]);
  var WA = React.useRef(), eg = React.useState({
    length: 0,
    distance: 0
  }), ig = _slicedToArray$f(eg, 2), $A = ig[0], ag = ig[1], Ig = React.useCallback(function() {
    WA.current && ag(getLayoutParams(WA.current, H));
  }, [WA.current, H]);
  React.useEffect(Ig, [WA.current, H]), React.useEffect(function() {
    WA.current && (isHorizontal(H) ? (
      // @ts-expect-error todo(flow->ts) maybe parentElement?
      WA.current.parentNode.scrollWidth > // @ts-expect-error todo(flow->ts) maybe parentElement?
      WA.current.parentNode.clientWidth
    ) : (
      // @ts-expect-error todo(flow->ts) maybe parentElement?
      WA.current.parentNode.scrollHeight > // @ts-expect-error todo(flow->ts) maybe parentElement?
      WA.current.parentNode.clientHeight
    )) && (SA > 1 ? WA.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    }) : scrollParentToCentreTarget(WA.current));
  }, [WA.current]);
  var tg = {
    $orientation: H,
    $fill: h
  }, wg = useStyletron(), hg = _slicedToArray$f(wg, 2), Gg = hg[1], Ng = React.useCallback(function(Bg) {
    if (isHorizontal(H))
      if (isRTL(Gg.direction))
        switch (Bg.keyCode) {
          case 39:
            return KEYBOARD_ACTION.previous;
          case 37:
            return KEYBOARD_ACTION.next;
          default:
            return null;
        }
      else
        switch (Bg.keyCode) {
          case 37:
            return KEYBOARD_ACTION.previous;
          case 39:
            return KEYBOARD_ACTION.next;
          default:
            return null;
        }
    else
      switch (Bg.keyCode) {
        case 38:
          return KEYBOARD_ACTION.previous;
        case 40:
          return KEYBOARD_ACTION.next;
        default:
          return null;
      }
  }, [H, Gg.direction]);
  return /* @__PURE__ */ React.createElement(sA, _extends$j({}, tg, DA), /* @__PURE__ */ React.createElement(StyledTabBar, {
    $hasEndEnhancer: !!QA,
    $orientation: H
  }, /* @__PURE__ */ React.createElement(NA, _extends$j({
    "data-baseweb": "tab-list",
    role: "tablist",
    "aria-orientation": H
  }, tg, pA), React.Children.map(t, function(Bg, bA) {
    if (Bg)
      return /* @__PURE__ */ React.createElement(InternalTab, _extends$j({
        childKey: Bg.key,
        childIndex: bA,
        activeKey: g,
        orientation: H,
        activeTabRef: WA,
        updateHighlight: Ig,
        parseKeyDown: Ng,
        activateOnFocus: k,
        uid: EA,
        disabled: e,
        sharedStylingProps: tg,
        onChange: p
      }, Bg.props));
  }), /* @__PURE__ */ React.createElement(lA, _extends$j({
    "data-baseweb": "tab-highlight",
    $length: $A.length,
    $distance: $A.distance,
    $animate: SA > 1,
    "aria-hidden": "true",
    role: "presentation"
  }, tg, kA))), H === ORIENTATION.horizontal && QA !== null && QA !== void 0 && /* @__PURE__ */ React.createElement(KA, _extends$j({}, xA, {
    $orientation: H
  }), /* @__PURE__ */ React.createElement(RenderEnhancer, {
    Enhancer: QA
  }))), /* @__PURE__ */ React.createElement(LA, _extends$j({
    "data-baseweb": "tab-border",
    "aria-hidden": "true",
    role: "presentation"
  }, tg, fA)), React.Children.map(t, function(Bg, bA) {
    if (Bg)
      return /* @__PURE__ */ React.createElement(InternalTabPanel, _extends$j({
        childKey: Bg.key,
        childIndex: bA,
        activeKey: g,
        uid: EA,
        sharedStylingProps: tg,
        renderAll: IA
      }, Bg.props));
  }));
}
function InternalTab(o) {
  var i = o.childKey, g = o.childIndex, E = o.activeKey, e = o.orientation, t = o.activeTabRef, n = o.updateHighlight, h = o.parseKeyDown, d = o.activateOnFocus, k = o.uid, p = o.disabled, M = o.sharedStylingProps, H = o.onChange, f = _objectWithoutProperties$h(o, _excluded$j), AA = i || String(g), gA = AA == E, IA = f.artwork, BA = f.overrides, CA = BA === void 0 ? {} : BA, QA = f.tabRef, iA = f.onClick, EA = f.title, oA = _objectWithoutProperties$h(f, _excluded2$4), eA = React.useRef();
  React.useImperativeHandle(QA, function() {
    return gA ? t.current : eA.current;
  });
  var GA = React.useRef({
    length: 0,
    distance: 0
  });
  React.useEffect(function() {
    GA.current = getLayoutParams(gA ? t.current : eA.current, e);
  }), React.useEffect(function() {
    if (window.ResizeObserver) {
      var dA = new window.ResizeObserver(function(RA) {
        if (RA[0] && RA[0].target) {
          var KA = getLayoutParams(RA[0].target, e);
          (KA.length !== GA.current.length || KA.distance !== GA.current.distance) && n();
        }
      });
      return dA.observe(gA ? t.current : eA.current), function() {
        dA.disconnect();
      };
    }
  }, [E, e]), React.useEffect(n, [EA]);
  var cA = CA.Tab, tA = CA.ArtworkContainer, aA = getOverrides(cA, StyledTab), sA = _slicedToArray$f(aA, 2), DA = sA[0], rA = sA[1], nA = getOverrides(tA, StyledArtworkContainer), NA = _slicedToArray$f(nA, 2), pA = NA[0], mA = NA[1], XA = React.useState(!1), lA = _slicedToArray$f(XA, 2), kA = lA[0], ZA = lA[1], wA = React.useCallback(function(dA) {
    isFocusVisible(dA) && ZA(!0);
  }, []), LA = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function(dA) {
      kA !== !1 && ZA(!1);
    },
    [kA]
  ), fA = React.useCallback(function(dA) {
    var RA = _toConsumableArray$1(dA.target.parentNode.childNodes).filter(function(OA) {
      return !OA.disabled && OA.getAttribute("role") === "tab";
    });
    if (RA.length !== 1) {
      var KA = RA.indexOf(dA.target), xA = h(dA);
      if (xA) {
        var MA;
        xA === KEYBOARD_ACTION.previous ? RA[KA - 1] ? MA = RA[KA - 1] : MA = RA[RA.length - 1] : xA === KEYBOARD_ACTION.next && (RA[KA + 1] ? MA = RA[KA + 1] : MA = RA[0]), MA && (MA.focus(), d && MA.click()), isVertical(e) && dA.preventDefault();
      }
    }
  });
  return /* @__PURE__ */ React.createElement(DA, _extends$j({
    "data-baseweb": "tab",
    key: AA,
    id: getTabId(k, AA),
    role: "tab",
    onKeyDown: fA,
    "aria-selected": gA,
    "aria-controls": getTabPanelId(k, AA),
    tabIndex: gA ? "0" : "-1",
    ref: gA ? t : eA,
    disabled: !gA && p,
    type: "button",
    $focusVisible: kA,
    $isActive: gA
  }, M, oA, rA, {
    onClick: function(RA) {
      typeof H == "function" && H({
        activeKey: AA
      }), typeof iA == "function" && iA(RA);
    },
    onFocus: forkFocus(_objectSpread$b(_objectSpread$b({}, oA), rA), wA),
    onBlur: forkBlur(_objectSpread$b(_objectSpread$b({}, oA), rA), LA)
  }), IA ? /* @__PURE__ */ React.createElement(pA, _extends$j({
    "data-baseweb": "artwork-container"
  }, M, mA), /* @__PURE__ */ React.createElement(IA, {
    size: 20,
    color: "contentPrimary"
  })) : null, EA || AA);
}
function InternalTabPanel(o) {
  var i = o.childKey, g = o.childIndex, E = o.activeKey, e = o.uid, t = o.sharedStylingProps, n = o.renderAll, h = _objectWithoutProperties$h(o, _excluded3$1), d = i || String(g), k = d == E, p = h.overrides, M = p === void 0 ? {} : p, H = h.children, f = M.TabPanel, AA = getOverrides(f, StyledTabPanel), gA = _slicedToArray$f(AA, 2), IA = gA[0], BA = gA[1];
  return /* @__PURE__ */ React.createElement(IA, _extends$j({
    "data-baseweb": "tab-panel",
    key: d,
    role: "tabpanel",
    id: getTabPanelId(e, d),
    "aria-labelledby": getTabId(e, d),
    hidden: !k
  }, t, BA), k || n ? H : null);
}
function Tab(o) {
  return null;
}
function getClassnamePrefix(o) {
  return o === Direction.HORIZONTAL ? "stHorizontalBlock" : "stVerticalBlock";
}
function shouldComponentBeEnabled(o, i) {
  return o !== "empty" || i !== ScriptRunState.RUNNING;
}
function isElementStale(o, i, g, E) {
  return i === ScriptRunState.RERUN_REQUESTED ? !0 : i === ScriptRunState.RUNNING ? E?.length ? !!(o.fragmentId && E.includes(o.fragmentId) && o.scriptRunId !== g) : o.scriptRunId !== g : !1;
}
function isComponentStale(o, i, g, E, e) {
  return !o || isElementStale(i, g, E, e);
}
function assignDividerColor(o, i) {
  const g = getDividerColors(i), E = Object.keys(g), {
    blue: e,
    green: t,
    orange: n,
    red: h,
    violet: d,
    yellow: k
  } = g, p = {
    blue: e,
    green: t,
    orange: n,
    red: h,
    violet: d,
    yellow: k
  }, M = Object.keys(p);
  let H = 0;
  for (const f of ElementsSetVisitor.collectElements(o)) {
    const AA = f.heading?.divider;
    if (f.type === "heading" && AA)
      if (AA === "auto") {
        const gA = M[H];
        f.heading.divider = p[gA], H += 1, H === M.length && (H = 0);
      } else E.includes(AA) && (f.heading.divider = g[AA]);
  }
}
function convertKeyToClassName(o) {
  return o ? "st-key-" + o.trim().replace(/[^a-zA-Z0-9_-]/g, "-") : "";
}
function getKeyFromId(o) {
  if (!o || !isValidElementId(o))
    return;
  const g = o.split("-").slice(2).join("-");
  return g === "None" ? void 0 : g;
}
function backwardsCompatibleColumnGapSize(o) {
  if (o.gapConfig?.gapSize)
    return o.gapConfig.gapSize;
  if (o.gap) {
    if (o.gap === "small")
      return streamlit.GapSize.SMALL;
    if (o.gap === "medium")
      return streamlit.GapSize.MEDIUM;
    if (o.gap === "large")
      return streamlit.GapSize.LARGE;
  }
  return streamlit.GapSize.SMALL;
}
function checkFlexContainerBackwardsCompatibile(o) {
  return !!(o.flexContainer || o.vertical || o.horizontal);
}
function getActivateScrollToBottomBackwardsCompatible(o) {
  return !!((o.deltaBlock.heightConfig?.pixelHeight || // This is deprecated, but we have some integrations that
  // cache messages so we are keeping this here to make sure the
  // frontend is backwards compatible with the old messages.
  o.deltaBlock.vertical?.height) && o.children.some((g) => g instanceof BlockNode && g.deltaBlock.type === "chatMessage"));
}
function getBorderBackwardsCompatible(o) {
  return o.flexContainer?.border || o.vertical?.border || !1;
}
const StyledTabContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "esjhkag0"
} : {
  target: "esjhkag0",
  label: "StyledTabContainer"
})(({
  theme: o,
  isOverflowing: i,
  tabHeight: g,
  width: E,
  flex: e
}) => ({
  ...i ? {
    position: "relative",
    "::after": {
      content: '" "',
      position: "absolute",
      zIndex: o.zIndices.priority,
      top: 0,
      right: 0,
      pointerEvents: "none",
      backgroundImage: `linear-gradient(to right, ${transparentize(o.colors.bgColor, 1)}, ${o.colors.bgColor})`,
      width: o.spacing.lg,
      height: g
    }
  } : {},
  ...E && {
    width: E
  },
  ...e && {
    flex: e
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9UYWJzL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBCa0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL1RhYnMvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSBcImNvbG9yMmtcIlxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZFRhYkNvbnRhaW5lclByb3BzIHtcbiAgaXNPdmVyZmxvd2luZzogYm9vbGVhblxuICB0YWJIZWlnaHQ6IHN0cmluZ1xuICB3aWR0aDogUmVhY3QuQ1NTUHJvcGVydGllc1tcIndpZHRoXCJdXG4gIGZsZXg6IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJmbGV4XCJdXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUYWJDb250YWluZXIgPSBzdHlsZWQuZGl2PFN0eWxlZFRhYkNvbnRhaW5lclByb3BzPihcbiAgKHsgdGhlbWUsIGlzT3ZlcmZsb3dpbmcsIHRhYkhlaWdodCwgd2lkdGgsIGZsZXggfSkgPT4gKHtcbiAgICAuLi4oaXNPdmVyZmxvd2luZ1xuICAgICAgPyB7XG4gICAgICAgICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICAgICAgICBcIjo6YWZ0ZXJcIjoge1xuICAgICAgICAgICAgY29udGVudDogYFwiIFwiYCxcbiAgICAgICAgICAgIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gICAgICAgICAgICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLnByaW9yaXR5LFxuICAgICAgICAgICAgdG9wOiAwLFxuICAgICAgICAgICAgcmlnaHQ6IDAsXG4gICAgICAgICAgICBwb2ludGVyRXZlbnRzOiBcIm5vbmVcIixcbiAgICAgICAgICAgIGJhY2tncm91bmRJbWFnZTogYGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgJHt0cmFuc3BhcmVudGl6ZShcbiAgICAgICAgICAgICAgdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gICAgICAgICAgICAgIDFcbiAgICAgICAgICAgICl9LCAke3RoZW1lLmNvbG9ycy5iZ0NvbG9yfSlgLFxuICAgICAgICAgICAgd2lkdGg6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgICAgICAgICBoZWlnaHQ6IHRhYkhlaWdodCxcbiAgICAgICAgICB9LFxuICAgICAgICB9XG4gICAgICA6IHt9KSxcbiAgICAuLi4od2lkdGggJiYge1xuICAgICAgd2lkdGgsXG4gICAgfSksXG4gICAgLi4uKGZsZXggJiYge1xuICAgICAgZmxleCxcbiAgICB9KSxcbiAgfSlcbilcbiJdfQ== */");
function Tabs(o) {
  const {
    widgetsDisabled: i,
    node: g,
    isStale: E,
    width: e,
    flex: t
  } = o, {
    scriptRunState: n,
    scriptRunId: h,
    fragmentIdsThisRun: d
  } = useContext(ScriptRunContext), k = g.deltaBlock?.tabContainer?.defaultTabIndex ?? 0;
  let p = [];
  const [M, H] = useState(k), [f, AA] = useState(() => g.children[k]?.deltaBlock?.tab?.label ?? "0"), gA = useRef(null), IA = useEmotionTheme(), [BA, CA] = useState(!1);
  useEffect(() => {
    p.indexOf(f) === -1 && (H(k), AA(p[k]));
  }, [p]), useEffect(() => {
    if (gA.current) {
      const {
        scrollWidth: oA,
        clientWidth: eA
      } = gA.current;
      CA(oA > eA);
    }
    const EA = p.indexOf(f);
    EA !== -1 ? (H(EA), AA(p[EA])) : (H(k), AA(p[k]));
  }, [g.children.length]);
  const QA = IA.sizes.tabHeight, iA = IA.spacing.threeXS;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTabContainer, { className: "stTabs", "data-testid": "stTabs", isOverflowing: BA, tabHeight: QA, width: e, flex: t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tabs$2,
    {
      activateOnFocus: !0,
      activeKey: M,
      onChange: ({
        activeKey: EA
      }) => {
        H(EA), AA(p[EA]);
      },
      renderAll: !0,
      overrides: {
        TabHighlight: {
          style: () => ({
            backgroundColor: IA.colors.primary,
            height: iA
          })
        },
        TabBorder: {
          style: () => ({
            backgroundColor: IA.colors.borderColorLight,
            height: iA
          })
        },
        TabList: {
          props: {
            ref: gA
          },
          style: () => ({
            gap: IA.spacing.lg,
            marginBottom: `-${iA}`,
            paddingBottom: iA,
            overflowY: "hidden",
            ...E && STALE_STYLES
          })
        },
        Root: {
          style: () => ({
            // resetting transform to fix full screen wrapper
            transform: "none"
          })
        }
      },
      children: g.children.map((EA, oA) => {
        oA === 0 && (p = []);
        const eA = isElementStale(EA, n, h, d), GA = {
          ...o,
          isStale: E || eA,
          widgetsDisabled: i,
          node: EA
        };
        let cA = oA.toString();
        GA.node.deltaBlock?.tab?.label && (cA = GA.node.deltaBlock.tab.label), p[oA] = cA;
        const tA = M.toString() === oA.toString(), aA = oA === g.children.length - 1;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          Tab,
          {
            "data-testid": "stTab",
            title: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: cA, allowHTML: !1, isLabel: !0 }),
            disabled: !E && eA,
            overrides: {
              TabPanel: {
                style: () => ({
                  paddingLeft: IA.spacing.none,
                  paddingRight: IA.spacing.none,
                  paddingBottom: IA.spacing.none,
                  paddingTop: IA.spacing.lg
                })
              },
              Tab: {
                style: () => ({
                  height: QA,
                  whiteSpace: "nowrap",
                  paddingLeft: IA.spacing.none,
                  paddingRight: IA.spacing.none,
                  paddingTop: IA.spacing.none,
                  paddingBottom: IA.spacing.none,
                  fontSize: IA.fontSizes.sm,
                  background: "transparent",
                  color: IA.colors.bodyText,
                  ":focus": {
                    outline: "none",
                    color: IA.colors.primary,
                    background: "none"
                  },
                  ":hover": {
                    color: IA.colors.primary,
                    background: "none"
                  },
                  ...tA ? {
                    color: IA.colors.primary
                  } : {},
                  // Add minimal required padding to hide the overscroll gradient
                  // This is calculated based on the width of the gradient (spacing.lg)
                  ...BA && aA ? {
                    paddingRight: `calc(${IA.spacing.lg} * 0.6)`
                  } : {},
                  // Apply stale effect if only this specific
                  // tab is stale but not the entire tab container.
                  ...!E && eA && STALE_STYLES
                })
              }
            },
            children: o.renderTabContent(GA)
          },
          oA
        );
      })
    }
  ) });
}
const Tabs$1 = memo(Tabs), FormsContext = createContext(null);
FormsContext.displayName = "FormsContext";
const useRequiredContext = (o) => {
  const i = useContext(o);
  if (i == null)
    throw new Error(`useRequiredContext: ${o.displayName ?? "context"} not found`);
  return i;
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$c() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledFormSubmitContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by2"
} : {
  target: "e10yg2by2",
  label: "StyledFormSubmitContent"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
}), StyledForm = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by1"
} : {
  target: "e10yg2by1",
  label: "StyledForm"
})(({
  theme: o,
  border: i,
  overflow: g
}) => ({
  ...i && {
    border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
    borderRadius: o.radii.default,
    padding: `calc(${o.spacing.lg} - ${o.sizes.borderWidth})`
  },
  width: "100%",
  height: "100%",
  overflow: g
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by0"
} : {
  target: "e10yg2by0",
  label: "StyledErrorContainer"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAlertContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1eexb541"
} : {
  target: "e1eexb541",
  label: "StyledAlertContent"
})(({
  theme: o
}) => ({
  display: "flex",
  gap: o.spacing.sm,
  width: "100%",
  [`${StyledCodeBlock} code`]: {
    paddingRight: o.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9BbGVydEVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9Ca0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0FsZXJ0RWxlbWVudC9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgU3R5bGVkQ29kZUJsb2NrIH0gZnJvbSBcIn5saWIvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHNcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWxlcnRDb250ZW50ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogXCIxMDAlXCIsXG5cbiAgW2Ake1N0eWxlZENvZGVCbG9ja30gY29kZWBdOiB7XG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBbGVydEljb24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIHRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxufSkpXG4iXX0= */"), StyledAlertIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1eexb540"
} : {
  target: "e1eexb540",
  label: "StyledAlertIcon"
})(({
  theme: o
}) => ({
  position: "relative",
  top: o.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9BbGVydEVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQThCK0IiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0FsZXJ0RWxlbWVudC9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgU3R5bGVkQ29kZUJsb2NrIH0gZnJvbSBcIn5saWIvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHNcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWxlcnRDb250ZW50ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogXCIxMDAlXCIsXG5cbiAgW2Ake1N0eWxlZENvZGVCbG9ja30gY29kZWBdOiB7XG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBbGVydEljb24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIHRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxufSkpXG4iXX0= */");
function AlertElement({
  icon: o,
  body: i,
  kind: g
}) {
  const E = useEmotionTheme(), e = {
    // Fix issue #6394 - Need to account for icon size (iconSizes.lg) + gap when icon present
    width: o ? `calc(100% - (${E.iconSizes.lg} + ${E.spacing.sm}))` : "100%"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stAlert", "data-testid": "stAlert", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainer, { kind: g, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAlertContent, { children: [
    o && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAlertIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: o, size: "lg", testid: "stAlertDynamicIcon" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: i, allowHTML: !1, style: e })
  ] }) }) });
}
const AlertElement$1 = memo(AlertElement);
function getAlertElementKind(o) {
  switch (o) {
    case Alert.Format.ERROR:
      return Kind.ERROR;
    case Alert.Format.INFO:
      return Kind.INFO;
    case Alert.Format.SUCCESS:
      return Kind.SUCCESS;
    case Alert.Format.WARNING:
      return Kind.WARNING;
    default:
      throw new Error(`Unexpected alert type: ${o}`);
  }
}
const MISSING_SUBMIT_BUTTON_WARNING = `**Missing Submit Button**

This form has no submit button, which means that user interactions will never be sent to your Streamlit app.

To create a submit button, use the \`st.form_submit_button()\` function.

For more information, refer to the [documentation for forms](https://docs.streamlit.io/develop/api-reference/execution-flow/st.form).`;
function Form(o) {
  const {
    formId: i,
    widgetMgr: g,
    children: E,
    clearOnSubmit: e,
    enterToSubmit: t,
    border: n,
    overflow: h
  } = o, {
    formsData: d
  } = useRequiredContext(FormsContext), k = d.submitButtons.get(i), p = k !== void 0 && k.length > 0, {
    scriptRunState: M
  } = useContext(ScriptRunContext), H = M === ScriptRunState.NOT_RUNNING;
  useEffect(() => {
    g.setFormSubmitBehaviors(i, e, t);
  }, [g, i, e, t]);
  const [f, AA] = useState(!1);
  p && f ? AA(!1) : !p && !f && H && AA(!0);
  let gA;
  return f && (gA = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledErrorContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { body: MISSING_SUBMIT_BUTTON_WARNING, kind: Kind.ERROR }) })), /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledForm, { className: "stForm", "data-testid": "stForm", border: n, overflow: h, children: [
    E,
    gA
  ] });
}
const Form$1 = memo(Form);
function squareStepper(o, i) {
  const g = Math.sign(i - o), E = Math.sqrt(Math.abs(i - o)), e = o + E * g;
  return g > 0 ? Math.min(i, e) : Math.max(i, e);
}
function step(o, i, g, E) {
  let e = o;
  for (let t = 0; t < E; t++)
    e = g(e, i);
  return e;
}
function useScrollAnimation(o, i, g, E) {
  const e = useRef(0), t = useCallback((h, d, k = Date.now()) => {
    cancelAnimationFrame(e.current), e.current = requestAnimationFrame(() => {
      if (o) {
        const p = o.scrollHeight - o.offsetHeight;
        let M = step(h, p, squareStepper, (Date.now() - k) / 5);
        Math.abs(p - M) < 1.5 && (M = p), o.scrollTop = M, p === M ? i() : t(h, d + 1, k);
      }
    });
  }, [e, i, o]), n = useCallback(() => {
    cancelAnimationFrame(e.current), i();
  }, [i]);
  useLayoutEffect$1(() => {
    if (!(!o || !g || !E))
      return t(o.scrollTop, 1), o ? (o.addEventListener("pointerdown", n, {
        passive: !0
      }), o.addEventListener("wheel", n, {
        passive: !0
      }), () => {
        o.removeEventListener("pointerdown", n), o.removeEventListener("wheel", n), cancelAnimationFrame(e.current);
      }) : () => cancelAnimationFrame(e.current);
  }, [t, e, n, o, g, E]);
}
function debounce(o, i) {
  let g = 0, E = null;
  return (...e) => {
    const t = Date.now();
    t - g > i ? (o(...e), g = t) : (E && clearTimeout(E), E = setTimeout(() => {
      o(...e), g = Date.now();
    }, Math.max(0, i - t + g)));
  };
}
const DEFAULT_DEBOUNCE_MS = 100;
function useScrollSpy(o, i, g) {
  const E = useRef(i), e = useMemo$1(() => (
    // eslint-disable-next-line react-hooks/refs -- TODO: Do not access ref during render
    debounce((n) => {
      E.current(n);
    }, DEFAULT_DEBOUNCE_MS)
  ), [E]), t = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    (n) => {
      n.timeStampLow = Date.now(), e(n);
    },
    [e]
  );
  useLayoutEffect$1(() => !o || !g ? () => {
  } : (o.addEventListener("scroll", t, {
    passive: !0
  }), t({
    target: o
  }), () => o.removeEventListener("scroll", t)), [t, o, g]);
}
function useStateRef(o) {
  const [i, g] = useState(o), E = useRef(o);
  return E.current = i, [i, g, E];
}
const DEFAULT_BOTTOM_THRESHOLD = 1, SCROLL_DECISION_DURATION = 34, MIN_CHECK_INTERVAL = 17;
function setImmediateInterval(o, i) {
  return o(), setInterval(o, i);
}
function isAtBottom({
  scrollHeight: o,
  offsetHeight: i,
  scrollTop: g
}) {
  return o - g - i < DEFAULT_BOTTOM_THRESHOLD;
}
function useScrollToBottom(o) {
  const i = useRef(null), [g, E, e] = useStateRef(!1), [t, n, h] = useStateRef(!0);
  useEffect(() => {
    E(!0);
  }, [E]);
  const d = useRef(0), k = useRef(0), p = useRef(0), M = useCallback(() => {
    d.current = Date.now(), h.current || E(!1), n(!1);
  }, [d, h, n, E]), H = useCallback(({
    timeStampLow: f
  }) => {
    const {
      current: AA
    } = i, gA = h.current;
    if (f <= d.current || !AA)
      return;
    const IA = isAtBottom(AA), {
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      offsetHeight: BA,
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      scrollHeight: CA
    } = AA, {
      current: QA
    } = k, {
      current: iA
    } = p, EA = BA !== QA, oA = CA !== iA;
    if (EA && (k.current = BA), oA && (p.current = CA), !EA && !oA) {
      const eA = gA || IA;
      e.current !== eA && E(eA);
    } else e.current && (n(!0), E(!0));
  }, [d, k, p, h, e, n, E]);
  return useEffect(() => {
    if (i.current && o) {
      let f = 0;
      const AA = setImmediateInterval(() => {
        const {
          current: gA
        } = i, IA = h.current;
        e.current && gA ? isAtBottom(gA) ? f = 0 : f ? Date.now() - f > SCROLL_DECISION_DURATION && (IA || (n(!0), E(!0)), f = 0) : f = Date.now() : gA && // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
        gA.scrollHeight <= gA.offsetHeight && !e.current && E(!0);
      }, MIN_CHECK_INTERVAL);
      return () => clearInterval(AA);
    }
  }, [i, g, t, h, e, E, n, o]), useEffect(() => {
    const f = i.current;
    if (f && o) {
      const AA = () => {
        p.current = f.scrollHeight;
      };
      return f.addEventListener("focus", AA, {
        capture: !0,
        passive: !0
      }), () => {
        f.removeEventListener("focus", AA, {
          capture: !0
        });
      };
    }
  }, [i, o]), useScrollSpy(i.current, H, o), useScrollAnimation(
    // eslint-disable-next-line react-hooks/refs -- TODO: Do not access ref during render
    i.current,
    M,
    t,
    o
  ), i;
}
const Maybe = memo(function o({
  children: i
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: i });
}, (o, i) => !(o.enable || i.enable)), ViewStateContext = createContext({
  isFullScreen: !1,
  setFullScreen: () => {
  }
});
ViewStateContext.displayName = "ViewStateContext";
const StyledDocSummary = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn10"
} : {
  target: "ejycmjn10",
  label: "StyledDocSummary"
})(({
  theme: o
}) => ({
  "& > *": {
    marginRight: o.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocName = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn9"
} : {
  target: "ejycmjn9",
  label: "StyledDocName"
})(({
  theme: o
}) => ({
  fontWeight: o.fontWeights.codeBold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocType = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn8"
} : {
  target: "ejycmjn8",
  label: "StyledDocType"
})(({
  theme: o
}) => ({
  color: o.colors.codeTextColor
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocValue = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn7"
} : {
  target: "ejycmjn7",
  label: "StyledDocValue"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn6"
} : {
  target: "ejycmjn6",
  label: "StyledDocContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: o.radii.default,
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  fontFamily: o.genericFonts.codeFont,
  fontSize: o.fontSizes.codeFontSize,
  fontWeight: o.fontWeights.code
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocHeader = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn5"
} : {
  target: "ejycmjn5",
  label: "StyledDocHeader"
})(({
  theme: o
}) => ({
  padding: `${o.spacing.sm} ${o.spacing.lg}`,
  backgroundColor: o.colors.bgMix,
  borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  // Add rounded corners to the top of the container to prevent the background
  // color from bleeding into the surrounding area.
  borderTopLeftRadius: o.radii.default,
  borderTopRightRadius: o.radii.default,
  fontSize: o.fontSizes.codeFontSize,
  overflow: "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocString = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn4"
} : {
  target: "ejycmjn4",
  label: "StyledDocString"
})(({
  theme: o
}) => ({
  whiteSpace: "pre",
  overflow: "auto",
  maxHeight: "30.5rem",
  // The extra 0.5rem is to show a little of the overflowing line.
  padding: `${o.spacing.sm} ${o.spacing.lg}`,
  fontSize: o.fontSizes.codeFontSize,
  "&:not(:last-child)": {
    borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersTable = /* @__PURE__ */ createStyled("table", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn3"
} : {
  target: "ejycmjn3",
  label: "StyledMembersTable"
})(({
  theme: o
}) => ({
  width: "100%",
  fontSize: o.fontSizes.codeFontSize,
  backgroundColor: o.colors.bgMix,
  tableLayout: "fixed",
  // Fix table to container's boundaries.
  borderCollapse: "collapse",
  // Add rounded corners to the bottom of the table to match container
  borderBottomLeftRadius: o.radii.default,
  borderBottomRightRadius: o.radii.default
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Eb2NTdHJpbmcvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0VrQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRG9jU3RyaW5nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdW1tYXJ5ID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY05hbWUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlQm9sZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVHlwZSA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuY29kZVRleHRDb2xvcixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVmFsdWUgPSBzdHlsZWQuc3BhbigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NDb250YWluZXIgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NIZWFkZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgYm9yZGVyQm90dG9tOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgLy8gQWRkIHJvdW5kZWQgY29ybmVycyB0byB0aGUgdG9wIG9mIHRoZSBjb250YWluZXIgdG8gcHJldmVudCB0aGUgYmFja2dyb3VuZFxuICAvLyBjb2xvciBmcm9tIGJsZWVkaW5nIGludG8gdGhlIHN1cnJvdW5kaW5nIGFyZWEuXG4gIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdHJpbmcgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHdoaXRlU3BhY2U6IFwicHJlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgbWF4SGVpZ2h0OiBcIjMwLjVyZW1cIiwgLy8gVGhlIGV4dHJhIDAuNXJlbSBpcyB0byBzaG93IGEgbGl0dGxlIG9mIHRoZSBvdmVyZmxvd2luZyBsaW5lLlxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG5cbiAgXCImOm5vdCg6bGFzdC1jaGlsZClcIjoge1xuICAgIGJvcmRlckJvdHRvbTogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNUYWJsZSA9IHN0eWxlZC50YWJsZSgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCIxMDAlXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgdGFibGVMYXlvdXQ6IFwiZml4ZWRcIiwgLy8gRml4IHRhYmxlIHRvIGNvbnRhaW5lcidzIGJvdW5kYXJpZXMuXG4gIGJvcmRlckNvbGxhcHNlOiBcImNvbGxhcHNlXCIsXG4gIC8vIEFkZCByb3VuZGVkIGNvcm5lcnMgdG8gdGhlIGJvdHRvbSBvZiB0aGUgdGFibGUgdG8gbWF0Y2ggY29udGFpbmVyXG4gIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlckJvdHRvbVJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzUm93ID0gc3R5bGVkLnRyKCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiJjpub3QoOmxhc3QtY2hpbGQpXCI6IHtcbiAgICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzU3VtbWFyeUNlbGwgPSBzdHlsZWQudGQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2lkdGg6IFwiMzAlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG5cbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNEZXRhaWxzQ2VsbCA9IHN0eWxlZC50ZCgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCI3MCVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbn0pKVxuIl19 */"), StyledMembersRow = /* @__PURE__ */ createStyled("tr", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn2"
} : {
  target: "ejycmjn2",
  label: "StyledMembersRow"
})(({
  theme: o
}) => ({
  "&:not(:last-child)": {
    borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersSummaryCell = /* @__PURE__ */ createStyled("td", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn1"
} : {
  target: "ejycmjn1",
  label: "StyledMembersSummaryCell"
})(({
  theme: o
}) => ({
  width: "30%",
  overflow: "auto",
  padding: `${o.spacing.sm} ${o.spacing.lg}`,
  "& > *": {
    marginRight: o.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersDetailsCell = /* @__PURE__ */ createStyled("td", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn0"
} : {
  target: "ejycmjn0",
  label: "StyledMembersDetailsCell"
})(({
  theme: o
}) => ({
  width: "70%",
  overflow: "auto",
  padding: `${o.spacing.sm} ${o.spacing.lg}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Eb2NTdHJpbmcvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0Z3QyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRG9jU3RyaW5nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdW1tYXJ5ID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY05hbWUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlQm9sZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVHlwZSA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuY29kZVRleHRDb2xvcixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVmFsdWUgPSBzdHlsZWQuc3BhbigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NDb250YWluZXIgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NIZWFkZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgYm9yZGVyQm90dG9tOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgLy8gQWRkIHJvdW5kZWQgY29ybmVycyB0byB0aGUgdG9wIG9mIHRoZSBjb250YWluZXIgdG8gcHJldmVudCB0aGUgYmFja2dyb3VuZFxuICAvLyBjb2xvciBmcm9tIGJsZWVkaW5nIGludG8gdGhlIHN1cnJvdW5kaW5nIGFyZWEuXG4gIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdHJpbmcgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHdoaXRlU3BhY2U6IFwicHJlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgbWF4SGVpZ2h0OiBcIjMwLjVyZW1cIiwgLy8gVGhlIGV4dHJhIDAuNXJlbSBpcyB0byBzaG93IGEgbGl0dGxlIG9mIHRoZSBvdmVyZmxvd2luZyBsaW5lLlxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG5cbiAgXCImOm5vdCg6bGFzdC1jaGlsZClcIjoge1xuICAgIGJvcmRlckJvdHRvbTogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNUYWJsZSA9IHN0eWxlZC50YWJsZSgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCIxMDAlXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgdGFibGVMYXlvdXQ6IFwiZml4ZWRcIiwgLy8gRml4IHRhYmxlIHRvIGNvbnRhaW5lcidzIGJvdW5kYXJpZXMuXG4gIGJvcmRlckNvbGxhcHNlOiBcImNvbGxhcHNlXCIsXG4gIC8vIEFkZCByb3VuZGVkIGNvcm5lcnMgdG8gdGhlIGJvdHRvbSBvZiB0aGUgdGFibGUgdG8gbWF0Y2ggY29udGFpbmVyXG4gIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlckJvdHRvbVJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzUm93ID0gc3R5bGVkLnRyKCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiJjpub3QoOmxhc3QtY2hpbGQpXCI6IHtcbiAgICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzU3VtbWFyeUNlbGwgPSBzdHlsZWQudGQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2lkdGg6IFwiMzAlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG5cbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNEZXRhaWxzQ2VsbCA9IHN0eWxlZC50ZCgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCI3MCVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbn0pKVxuIl19 */");
function DocString({
  element: o
}) {
  const {
    name: i,
    type: g,
    value: E,
    docString: e,
    members: t
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDocContainer, { className: "stHelp", "data-testid": "stHelp", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDocSummary, { children: [
      i ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocName, { "data-testid": "stHelpName", children: i }) : null,
      g ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocType, { "data-testid": "stHelpType", children: g }) : null,
      E ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpValue", children: E }) : null
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocString, { "data-testid": "stHelpDoc", children: e || "No docs available" }),
    t.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMembersTable, { "data-testid": "stHelpMembersTable", children: t.map((n) => /* @__PURE__ */ jsxRuntimeExports.jsx(Member, { member: n }, n.name)) }) : null
  ] });
}
function Member({
  member: o
}) {
  const {
    name: i,
    type: g,
    value: E,
    docString: e
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMembersRow, { "data-testid": "stHelpMember", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMembersSummaryCell, { children: [
      i ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocName, { "data-testid": "stHelpMemberDocName", children: i }) : null,
      g ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocType, { "data-testid": "stHelpMemberDocType", children: g }) : null
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMembersDetailsCell, { children: E ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpMemberDocValue", children: E }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpMemberDocString", children: e || "No docs available" }) })
  ] });
}
const DocString$1 = memo(DocString);
function useTimeout(o, i) {
  const g = useRef(null), E = useRef(o);
  useEffect(() => {
    E.current = o;
  }, [o]);
  const e = useCallback(() => {
    g.current && (clearTimeout(g.current), g.current = null), i !== null && (g.current = setTimeout(() => {
      E.current();
    }, i));
  }, [i]);
  useEffect(() => (e(), () => {
    g.current && (clearTimeout(g.current), g.current = null);
  }), [e]);
  const t = useCallback(() => {
    g.current && (clearTimeout(g.current), g.current = null);
  }, []), n = useCallback(() => {
    e();
  }, [e]);
  return {
    clear: t,
    restart: n
  };
}
const LOG$b = loglevelExports$1.getLogger("useCopyToClipboard"), useCopyToClipboard = ({
  timeout: o = 2e3
} = {}) => {
  const [i, g] = useState(!1), {
    restart: E
  } = useTimeout(useCallback(() => {
    g(!1);
  }, []), i ? o : null), e = useCallback((n) => {
    (async () => {
      try {
        await navigator.clipboard.writeText(n), g(!0), E();
      } catch (d) {
        LOG$b.error("Failed to copy text to clipboard:", d), g(!1);
      }
    })();
  }, [E]);
  return {
    isCopied: i,
    copyToClipboard: e,
    label: i ? "Copied" : "Copy to clipboard"
  };
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$b() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledStackTraceRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv7"
} : {
  target: "e1dl0tyv7",
  label: "StyledStackTraceRow"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.sm,
  "&:first-of-type": {
    marginTop: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9FeGNlcHRpb25FbGVtZW50L3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCbUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0V4Y2VwdGlvbkVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2VSb3cgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgXCImOmZpcnN0LW9mLXR5cGVcIjoge1xuICAgIG1hcmdpblRvcDogMCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVzc2FnZVR5cGUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdGFja1RyYWNlVGl0bGUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5zbSxcbn0pKVxuXG4vLyBUaGlzIGV4dHJhIGRpdiBtYWtlcyBzdXJlIHRoYXQgd2UgYWxzbyBoYXZlIGEgcGFkZGluZyBvbiB0aGUgcmlnaHQgc2lkZSBvZiB0aGUgc3RhY2tcbi8vIHRyYWNlIHdoZW4gc2Nyb2xsZWQgdG8gdGhlIHJpZ2h0LlxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2VDb250ZW50ID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWJsb2NrXCIsXG4gIG1pbldpZHRoOiBcIjEwMCVcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25NZXNzYWdlID0gc3R5bGVkLmRpdih7XG4gIHdvcmRXcmFwOiBcImJyZWFrLXdvcmRcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25MaW5rcyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5tZCxcbiAganVzdGlmeUNvbnRlbnQ6IFwiZmxleC1lbmRcIixcbiAgdW5kZXJsaW5lOiB0cnVlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25Db3B5QnV0dG9uID0gc3R5bGVkLmJ1dHRvbih7XG4gIGFsbDogXCJ1bnNldFwiLFxuICBmb250OiBcImluaGVyaXRcIixcbiAgdGV4dERlY29yYXRpb246IFwidW5kZXJsaW5lXCIsXG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRXhjZXB0aW9uV3JhcHBlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5sZyxcbn0pKVxuIl19 */"), StyledMessageType = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv6"
} : {
  target: "e1dl0tyv6",
  label: "StyledMessageType"
})(({
  theme: o
}) => ({
  fontWeight: o.fontWeights.bold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9FeGNlcHRpb25FbGVtZW50L3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCaUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0V4Y2VwdGlvbkVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2VSb3cgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgXCImOmZpcnN0LW9mLXR5cGVcIjoge1xuICAgIG1hcmdpblRvcDogMCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVzc2FnZVR5cGUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdGFja1RyYWNlVGl0bGUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5zbSxcbn0pKVxuXG4vLyBUaGlzIGV4dHJhIGRpdiBtYWtlcyBzdXJlIHRoYXQgd2UgYWxzbyBoYXZlIGEgcGFkZGluZyBvbiB0aGUgcmlnaHQgc2lkZSBvZiB0aGUgc3RhY2tcbi8vIHRyYWNlIHdoZW4gc2Nyb2xsZWQgdG8gdGhlIHJpZ2h0LlxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2VDb250ZW50ID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWJsb2NrXCIsXG4gIG1pbldpZHRoOiBcIjEwMCVcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25NZXNzYWdlID0gc3R5bGVkLmRpdih7XG4gIHdvcmRXcmFwOiBcImJyZWFrLXdvcmRcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25MaW5rcyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5tZCxcbiAganVzdGlmeUNvbnRlbnQ6IFwiZmxleC1lbmRcIixcbiAgdW5kZXJsaW5lOiB0cnVlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25Db3B5QnV0dG9uID0gc3R5bGVkLmJ1dHRvbih7XG4gIGFsbDogXCJ1bnNldFwiLFxuICBmb250OiBcImluaGVyaXRcIixcbiAgdGV4dERlY29yYXRpb246IFwidW5kZXJsaW5lXCIsXG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRXhjZXB0aW9uV3JhcHBlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5sZyxcbn0pKVxuIl19 */"), StyledStackTraceTitle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv5"
} : {
  target: "e1dl0tyv5",
  label: "StyledStackTraceTitle"
})(({
  theme: o
}) => ({
  marginBottom: o.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStackTraceContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv4"
} : {
  target: "e1dl0tyv4",
  label: "StyledStackTraceContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1flqko7",
  styles: "display:inline-block;min-width:100%"
} : {
  name: "1flqko7",
  styles: "display:inline-block;min-width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionMessage = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv3"
} : {
  target: "e1dl0tyv3",
  label: "StyledExceptionMessage"
})(process.env.NODE_ENV === "production" ? {
  name: "10s3lzp",
  styles: "word-wrap:break-word"
} : {
  name: "10s3lzp",
  styles: "word-wrap:break-word/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionLinks = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv2"
} : {
  target: "e1dl0tyv2",
  label: "StyledExceptionLinks"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.sm,
  display: "flex",
  gap: o.spacing.md,
  justifyContent: "flex-end",
  underline: !0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledExceptionCopyButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv1"
} : {
  target: "e1dl0tyv1",
  label: "StyledExceptionCopyButton"
})(process.env.NODE_ENV === "production" ? {
  name: "x9hjea",
  styles: "all:unset;font:inherit;text-decoration:underline"
} : {
  name: "x9hjea",
  styles: "all:unset;font:inherit;text-decoration:underline/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9FeGNlcHRpb25FbGVtZW50L3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9EeUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0V4Y2VwdGlvbkVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2VSb3cgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgXCImOmZpcnN0LW9mLXR5cGVcIjoge1xuICAgIG1hcmdpblRvcDogMCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVzc2FnZVR5cGUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdGFja1RyYWNlVGl0bGUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5zbSxcbn0pKVxuXG4vLyBUaGlzIGV4dHJhIGRpdiBtYWtlcyBzdXJlIHRoYXQgd2UgYWxzbyBoYXZlIGEgcGFkZGluZyBvbiB0aGUgcmlnaHQgc2lkZSBvZiB0aGUgc3RhY2tcbi8vIHRyYWNlIHdoZW4gc2Nyb2xsZWQgdG8gdGhlIHJpZ2h0LlxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2VDb250ZW50ID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWJsb2NrXCIsXG4gIG1pbldpZHRoOiBcIjEwMCVcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25NZXNzYWdlID0gc3R5bGVkLmRpdih7XG4gIHdvcmRXcmFwOiBcImJyZWFrLXdvcmRcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25MaW5rcyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5tZCxcbiAganVzdGlmeUNvbnRlbnQ6IFwiZmxleC1lbmRcIixcbiAgdW5kZXJsaW5lOiB0cnVlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25Db3B5QnV0dG9uID0gc3R5bGVkLmJ1dHRvbih7XG4gIGFsbDogXCJ1bnNldFwiLFxuICBmb250OiBcImluaGVyaXRcIixcbiAgdGV4dERlY29yYXRpb246IFwidW5kZXJsaW5lXCIsXG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRXhjZXB0aW9uV3JhcHBlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5sZyxcbn0pKVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv0"
} : {
  target: "e1dl0tyv0",
  label: "StyledExceptionWrapper"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
loglevelExports$1.getLogger("ExceptionElement");
function isNonEmptyString(o) {
  return notNullOrUndefined(o) && o !== "";
}
function ExceptionMessage({
  type: o,
  message: i,
  messageIsMarkdown: g
}) {
  if (g) {
    let E = i ?? "";
    return o.length !== 0 && (E = `**${o}**: ${E}`), /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: E, allowHTML: !1 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMessageType, { children: o }),
    o.length !== 0 && ": ",
    isNonEmptyString(i) ? i : null
  ] });
}
function StackTrace({
  stackTrace: o
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTraceTitle, { children: "Traceback:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTrace, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTraceContent, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: o.map((i, g) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      StyledStackTraceRow,
      {
        "data-testid": "stExceptionTraceRow",
        children: i
      },
      g
    )) }) }) })
  ] });
}
function ExceptionElement({
  element: o
}) {
  const {
    showErrorLinks: i = Config.ShowErrorLinks.SHOW_ERROR_LINKS_AUTO
  } = useContext(LibConfigContext), g = i === Config.ShowErrorLinks.SHOW_ERROR_LINKS_TRUE || i === Config.ShowErrorLinks.SHOW_ERROR_LINKS_AUTO && isLocalhost(), E = `${o.type}: ${o.message}`, e = `${E}

${o.stackTrace?.join(`
`)}`, t = `https://www.google.com/search?q=${encodeURIComponent(E)}`, n = `https://chatgpt.com/?q=${encodeURIComponent(e)}`, {
    copyToClipboard: h
  } = useCopyToClipboard(), d = useCallback(() => {
    h(e);
  }, [h, e]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stException", "data-testid": "stException", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainer, { kind: o.isWarning ? Kind.WARNING : Kind.ERROR, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledExceptionWrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExceptionMessage, { "data-testid": "stExceptionMessage", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ExceptionMessage, { type: o.type, message: o.message, messageIsMarkdown: o.messageIsMarkdown }) }),
    o.stackTrace && o.stackTrace.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(StackTrace, { stackTrace: o.stackTrace }) : null,
    g && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledExceptionLinks, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExceptionCopyButton, { onClick: d, children: "Copy" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: t, target: "_blank", rel: "noopener noreferrer", children: "Ask Google" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: n, target: "_blank", rel: "noopener noreferrer", children: "Ask ChatGPT" })
    ] })
  ] }) }) });
}
const ExceptionElement$1 = memo(ExceptionElement), SINGLE_BADGE_REGEX = /^:\w+-badge\[((?:\\.|[^\]\\])*)\]$/;
function Markdown({
  element: o
}) {
  const {
    allowHtml: i,
    body: g,
    elementType: E,
    help: e,
    isCaption: t
  } = o, n = E === Markdown$3.Type.LATEX, h = E === Markdown$3.Type.NATIVE && SINGLE_BADGE_REGEX.test(g.trim());
  let d;
  if (e && h)
    d = /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButtonTooltip, { help: e, containerWidth: !1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: t, source: g, allowHTML: i }) });
  else if (e && n)
    d = /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledLabelHelpWrapper, { isLatex: n, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: t, source: g, allowHTML: i }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: e, isLatex: n })
    ] });
  else {
    const k = e ? `${g} :help[]` : g;
    d = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpWrapper, { isLatex: n, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: t, source: k, allowHTML: i, helpText: e }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stMarkdown", "data-testid": "stMarkdown", children: d });
}
const Markdown$1 = memo(Markdown), StyledText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "exotz4b1"
} : {
  target: "exotz4b1",
  label: "StyledText"
})(({
  theme: o
}) => ({
  fontFamily: o.genericFonts.bodyFont,
  color: o.colors.bodyText,
  whiteSpace: "pre-line",
  whiteSpaceCollapse: "preserve",
  wordBreak: "break-word",
  display: "inline-block",
  verticalAlign: "middle",
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledInlineHelpIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "exotz4b0"
} : {
  target: "exotz4b0",
  label: "StyledInlineHelpIcon"
})(({
  theme: o
}) => ({
  display: "inline-block",
  verticalAlign: "middle",
  marginLeft: o.spacing.twoXS,
  // Fine-tune vertical positioning for perfect visual centering
  transform: "translateY(-0.05em)"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function TextElement({
  element: o
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpWrapper, { className: "stText", "data-testid": "stText", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledText, { children: [
    o.body,
    o.help && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineHelpIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: o.help }) })
  ] }) });
}
const TextElement$1 = memo(TextElement), katex_min = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
function makeMarkdownHeading(o, i) {
  switch (o.toLowerCase()) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H1:
      return `# ${i}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H2:
      return `## ${i}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H3:
      return `### ${i}`;
    default:
      throw new Error(`Unrecognized tag for header: ${o}`);
  }
}
const OVERRIDE_COMPONENTS = {
  p: Fragment,
  h1: Fragment,
  h2: Fragment,
  h3: Fragment,
  h4: Fragment,
  h5: Fragment,
  h6: Fragment
};
function Heading(o) {
  const {
    element: i
  } = o, {
    tag: g,
    anchor: E,
    body: e,
    help: t,
    hideAnchor: n,
    divider: h
  } = i, d = useContext(IsDialogContext), [k, ...p] = e.split(`
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "stHeading", "data-testid": "stHeading", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledStreamlitMarkdown, { isCaption: !1, isInDialog: d, "data-testid": "stMarkdownContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HeadingWithActionElements, { anchor: E, help: t, hideAnchor: n, tag: g, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        RenderedMarkdown,
        {
          allowHTML: !1,
          source: makeMarkdownHeading(g, k),
          overrideComponents: OVERRIDE_COMPONENTS
        }
      ) }),
      p.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(RenderedMarkdown, { source: p.join(`
`), allowHTML: !1 })
    ] }),
    h && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderDivider, { "data-testid": "stHeadingDivider", rainbow: h.includes("linear"), color: h })
  ] });
}
const StyledCheckbox$1 = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "edwcd611"
} : {
  target: "edwcd611",
  label: "StyledCheckbox"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  minHeight: o.sizes.smallElementHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "edwcd610"
} : {
  target: "edwcd610",
  label: "StyledContent"
})(({
  visibility: o
}) => ({
  display: o === LabelVisibilityOptions.Collapsed ? "none" : "flex",
  visibility: o === LabelVisibilityOptions.Hidden ? "hidden" : "visible",
  verticalAlign: "middle",
  flexDirection: "row",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function _EMOTION_STRINGIFIED_CSS_ERROR__$a() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function translateGapWidth(o, i) {
  switch (o) {
    case streamlit.GapSize.XXSMALL:
      return i.spacing.twoXS;
    case streamlit.GapSize.XSMALL:
      return i.spacing.sm;
    case streamlit.GapSize.SMALL:
      return i.spacing.lg;
    case streamlit.GapSize.MEDIUM:
      return i.spacing.threeXL;
    case streamlit.GapSize.LARGE:
      return i.spacing.fourXL;
    case streamlit.GapSize.XLARGE:
      return i.spacing.fiveXL;
    case streamlit.GapSize.XXLARGE:
      return i.spacing.sixXL;
    case streamlit.GapSize.NONE:
      return i.spacing.none;
    default:
      return i.spacing.lg;
  }
}
const StyledSpace = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn4"
} : {
  target: "e1f1d6gn4",
  label: "StyledSpace"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
}), GLOBAL_ELEMENTS = ["balloons", "snow"], StyledElementContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn3"
} : {
  target: "e1f1d6gn3",
  label: "StyledElementContainer"
})(({
  theme: o,
  isStale: i,
  width: g,
  height: E,
  elementType: e,
  overflow: t,
  flex: n,
  minWidth: h,
  textAlign: d
}) => ({
  width: g,
  height: E,
  textAlign: d,
  maxWidth: "100%",
  // Important so that individual elements don't take up too much space
  // in horizontal layouts. Particularly when an element uses the full screen wrapper.
  // Some components support zero width (e.g. iframe).
  minWidth: g === "0px" ? 0 : h ?? "1rem",
  // Allows to have absolutely-positioned nodes inside app elements, like
  // floating buttons.
  position: "relative",
  overflow: t,
  flex: n,
  "@media print": {
    overflow: "visible"
  },
  ":has(> .stCacheSpinner)": {
    height: o.spacing.none,
    overflow: "visible",
    visibility: "visible",
    marginBottom: `-${o.spacing.lg}`,
    zIndex: o.zIndices.cacheSpinner
  },
  ":has(> .stPageLink)": {
    marginTop: `-${o.spacing.xs}`,
    marginBottom: `-${o.spacing.xs}`
  },
  ...i && e !== "skeleton" && STALE_STYLES,
  ...e === "empty" ? {
    // Use display: none for empty elements to avoid the flexbox gap.
    display: "none"
  } : {},
  ...e === "space" ? {
    // Space elements should have minimal cross-axis dimensions.
    // The FlexContext logic in StyledElementContainerLayoutWrapper handles
    // the primary dimension (width for horizontal, height for vertical).
    minWidth: 0,
    minHeight: 0
  } : {},
  ...GLOBAL_ELEMENTS.includes(e) ? {
    // Global elements are rendered in their delta position, but they
    // are not part of the flexbox layout. We apply a negative margin
    // to remove the flexbox gap. display: none does not work for these,
    // since they needs to be visible.
    marginBottom: `-${o.spacing.lg}`
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn2"
} : {
  target: "e1f1d6gn2",
  label: "StyledColumn"
})(({
  theme: o,
  weight: i,
  gap: g,
  showBorder: E,
  verticalAlignment: e
}) => {
  const {
    VerticalAlignment: t
  } = Block$1.Column, n = i * 100, h = translateGapWidth(g, o), d = h === o.spacing.none ? `${n}%` : `calc(${n}% - ${h})`;
  return {
    // Calculate width based on percentage, but fill all available space,
    // e.g. if it overflows to next row.
    width: d,
    flex: `1 1 ${d}`,
    [`@media (max-width: ${o.breakpoints.columns})`]: {
      minWidth: `calc(100% - ${o.spacing.twoXL})`
    },
    ...e === t.BOTTOM && {
      marginTop: "auto",
      // Add margin to the first checkbox/toggle within the column to align it
      // better with other input widgets.
      [`& ${StyledElementContainer}:last-of-type > ${StyledCheckbox$1}`]: {
        marginBottom: o.spacing.sm
      }
    },
    ...e === t.TOP && {
      // Add margin to the first checkbox/toggle within the column to align it
      // better with other input widgets.
      [`& ${StyledElementContainer}:first-of-type > ${StyledCheckbox$1}`]: {
        marginTop: o.spacing.sm
      }
    },
    ...e === t.CENTER && {
      marginTop: "auto",
      marginBottom: "auto"
    },
    ...E && {
      border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
      borderRadius: o.radii.default,
      padding: `calc(${o.spacing.lg} - ${o.sizes.borderWidth})`
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getAlignItems = (o) => {
  switch (o) {
    case Block$1.FlexContainer.Align.ALIGN_START:
      return "start";
    case Block$1.FlexContainer.Align.ALIGN_CENTER:
      return "center";
    case Block$1.FlexContainer.Align.ALIGN_END:
      return "end";
    case Block$1.FlexContainer.Align.STRETCH:
      return "stretch";
    case Block$1.FlexContainer.Align.ALIGN_UNDEFINED:
    case void 0:
    case null:
      return "stretch";
    default:
      assertNever(o);
  }
}, getJustifyContent = (o) => {
  switch (o) {
    case Block$1.FlexContainer.Justify.JUSTIFY_START:
      return "start";
    case Block$1.FlexContainer.Justify.JUSTIFY_CENTER:
      return "center";
    case Block$1.FlexContainer.Justify.JUSTIFY_END:
      return "end";
    case Block$1.FlexContainer.Justify.SPACE_BETWEEN:
      return "space-between";
    case Block$1.FlexContainer.Justify.JUSTIFY_UNDEFINED:
    case void 0:
    case null:
      return "start";
    default:
      assertNever(o);
  }
}, StyledFlexContainerBlock = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn1"
} : {
  target: "e1f1d6gn1",
  label: "StyledFlexContainerBlock"
})(({
  theme: o,
  direction: i,
  gap: g,
  flex: E,
  $wrap: e,
  height: t,
  border: n,
  align: h,
  justify: d,
  overflow: k
}) => {
  let p;
  return g !== void 0 && (p = translateGapWidth(g, o)), {
    display: "flex",
    gap: p,
    width: "100%",
    maxWidth: "100%",
    height: t ?? "auto",
    minWidth: "1rem",
    flexDirection: i,
    flex: E,
    alignItems: getAlignItems(h),
    justifyContent: getJustifyContent(d),
    flexWrap: e ? "wrap" : "nowrap",
    ...n && {
      border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
      borderRadius: o.radii.default,
      padding: `calc(${o.spacing.lg} - ${o.sizes.borderWidth})`
    },
    overflow: k
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9jb3JlL0Jsb2NrL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQThQRSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvY29yZS9CbG9jay9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBDU1NQcm9wZXJ0aWVzIH0gZnJvbSBcInJlYWN0XCJcblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgQmxvY2sgYXMgQmxvY2tQcm90bywgc3RyZWFtbGl0IH0gZnJvbSBcIkBzdHJlYW1saXQvcHJvdG9idWZcIlxuXG5pbXBvcnQgeyBTdHlsZWRDaGVja2JveCB9IGZyb20gXCJ+bGliL2NvbXBvbmVudHMvd2lkZ2V0cy9DaGVja2JveC9zdHlsZWQtY29tcG9uZW50c1wiXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIFNUQUxFX1NUWUxFUyB9IGZyb20gXCJ+bGliL3RoZW1lXCJcbmltcG9ydCB7IGFzc2VydE5ldmVyIH0gZnJvbSBcIn5saWIvdXRpbC9hc3NlcnROZXZlclwiXG5cbmZ1bmN0aW9uIHRyYW5zbGF0ZUdhcFdpZHRoKFxuICBnYXA6IHN0cmVhbWxpdC5HYXBTaXplIHwgdW5kZWZpbmVkLFxuICB0aGVtZTogRW1vdGlvblRoZW1lXG4pOiBzdHJpbmcge1xuICBzd2l0Y2ggKGdhcCkge1xuICAgIGNhc2Ugc3RyZWFtbGl0LkdhcFNpemUuWFhTTUFMTDpcbiAgICAgIHJldHVybiB0aGVtZS5zcGFjaW5nLnR3b1hTXG4gICAgY2FzZSBzdHJlYW1saXQuR2FwU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4gdGhlbWUuc3BhY2luZy5zbVxuICAgIGNhc2Ugc3RyZWFtbGl0LkdhcFNpemUuU01BTEw6XG4gICAgICByZXR1cm4gdGhlbWUuc3BhY2luZy5sZ1xuICAgIGNhc2Ugc3RyZWFtbGl0LkdhcFNpemUuTUVESVVNOlxuICAgICAgcmV0dXJuIHRoZW1lLnNwYWNpbmcudGhyZWVYTFxuICAgIGNhc2Ugc3RyZWFtbGl0LkdhcFNpemUuTEFSR0U6XG4gICAgICByZXR1cm4gdGhlbWUuc3BhY2luZy5mb3VyWExcbiAgICBjYXNlIHN0cmVhbWxpdC5HYXBTaXplLlhMQVJHRTpcbiAgICAgIHJldHVybiB0aGVtZS5zcGFjaW5nLmZpdmVYTFxuICAgIGNhc2Ugc3RyZWFtbGl0LkdhcFNpemUuWFhMQVJHRTpcbiAgICAgIHJldHVybiB0aGVtZS5zcGFjaW5nLnNpeFhMXG4gICAgY2FzZSBzdHJlYW1saXQuR2FwU2l6ZS5OT05FOlxuICAgICAgcmV0dXJuIHRoZW1lLnNwYWNpbmcubm9uZVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gdGhlbWUuc3BhY2luZy5sZ1xuICB9XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkRWxlbWVudENvbnRhaW5lclByb3BzIHtcbiAgaXNTdGFsZTogYm9vbGVhblxuICB3aWR0aDogUmVhY3QuQ1NTUHJvcGVydGllc1tcIndpZHRoXCJdXG4gIGhlaWdodDogUmVhY3QuQ1NTUHJvcGVydGllc1tcImhlaWdodFwiXVxuICBlbGVtZW50VHlwZTogc3RyaW5nXG4gIG92ZXJmbG93OiBSZWFjdC5DU1NQcm9wZXJ0aWVzW1wib3ZlcmZsb3dcIl1cbiAgZmxleD86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJmbGV4XCJdXG4gIG1pbldpZHRoPzogUmVhY3QuQ1NTUHJvcGVydGllc1tcIm1pbldpZHRoXCJdXG4gIHRleHRBbGlnbj86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJ0ZXh0QWxpZ25cIl1cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNwYWNlID0gc3R5bGVkLmRpdih7XG4gIC8vIFN0eWxpbmcgaXMgaGFuZGxlZCBpbiBTdHlsZWRFbGVtZW50Q29udGFpbmVyTGF5b3V0V3JhcHBlci5cbiAgLy8gU3BhY2UgY29tcG9uZW50IHNob3VsZCBmaWxsIHRoZSBjb250YWluZXIuXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgaGVpZ2h0OiBcIjEwMCVcIixcbn0pXG5cbmNvbnN0IEdMT0JBTF9FTEVNRU5UUyA9IFtcImJhbGxvb25zXCIsIFwic25vd1wiXVxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRDb250YWluZXIgPSBzdHlsZWQuZGl2PFN0eWxlZEVsZW1lbnRDb250YWluZXJQcm9wcz4oXG4gICh7XG4gICAgdGhlbWUsXG4gICAgaXNTdGFsZSxcbiAgICB3aWR0aCxcbiAgICBoZWlnaHQsXG4gICAgZWxlbWVudFR5cGUsXG4gICAgb3ZlcmZsb3csXG4gICAgZmxleCxcbiAgICBtaW5XaWR0aCxcbiAgICB0ZXh0QWxpZ24sXG4gIH0pID0+ICh7XG4gICAgd2lkdGgsXG4gICAgaGVpZ2h0LFxuICAgIHRleHRBbGlnbixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgLy8gSW1wb3J0YW50IHNvIHRoYXQgaW5kaXZpZHVhbCBlbGVtZW50cyBkb24ndCB0YWtlIHVwIHRvbyBtdWNoIHNwYWNlXG4gICAgLy8gaW4gaG9yaXpvbnRhbCBsYXlvdXRzLiBQYXJ0aWN1bGFybHkgd2hlbiBhbiBlbGVtZW50IHVzZXMgdGhlIGZ1bGwgc2NyZWVuIHdyYXBwZXIuXG4gICAgLy8gU29tZSBjb21wb25lbnRzIHN1cHBvcnQgemVybyB3aWR0aCAoZS5nLiBpZnJhbWUpLlxuICAgIG1pbldpZHRoOiB3aWR0aCA9PT0gXCIwcHhcIiA/IDAgOiAobWluV2lkdGggPz8gXCIxcmVtXCIpLFxuICAgIC8vIEFsbG93cyB0byBoYXZlIGFic29sdXRlbHktcG9zaXRpb25lZCBub2RlcyBpbnNpZGUgYXBwIGVsZW1lbnRzLCBsaWtlXG4gICAgLy8gZmxvYXRpbmcgYnV0dG9ucy5cbiAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICAgIG92ZXJmbG93LFxuICAgIGZsZXgsXG5cbiAgICBcIkBtZWRpYSBwcmludFwiOiB7XG4gICAgICBvdmVyZmxvdzogXCJ2aXNpYmxlXCIsXG4gICAgfSxcblxuICAgIFwiOmhhcyg+IC5zdENhY2hlU3Bpbm5lcilcIjoge1xuICAgICAgaGVpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBvdmVyZmxvdzogXCJ2aXNpYmxlXCIsXG4gICAgICB2aXNpYmlsaXR5OiBcInZpc2libGVcIixcbiAgICAgIG1hcmdpbkJvdHRvbTogYC0ke3RoZW1lLnNwYWNpbmcubGd9YCxcbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMuY2FjaGVTcGlubmVyLFxuICAgIH0sXG5cbiAgICBcIjpoYXMoPiAuc3RQYWdlTGluaylcIjoge1xuICAgICAgbWFyZ2luVG9wOiBgLSR7dGhlbWUuc3BhY2luZy54c31gLFxuICAgICAgbWFyZ2luQm90dG9tOiBgLSR7dGhlbWUuc3BhY2luZy54c31gLFxuICAgIH0sXG5cbiAgICAuLi4oaXNTdGFsZSAmJiBlbGVtZW50VHlwZSAhPT0gXCJza2VsZXRvblwiICYmIFNUQUxFX1NUWUxFUyksXG4gICAgLi4uKGVsZW1lbnRUeXBlID09PSBcImVtcHR5XCJcbiAgICAgID8ge1xuICAgICAgICAgIC8vIFVzZSBkaXNwbGF5OiBub25lIGZvciBlbXB0eSBlbGVtZW50cyB0byBhdm9pZCB0aGUgZmxleGJveCBnYXAuXG4gICAgICAgICAgZGlzcGxheTogXCJub25lXCIsXG4gICAgICAgIH1cbiAgICAgIDoge30pLFxuICAgIC4uLihlbGVtZW50VHlwZSA9PT0gXCJzcGFjZVwiXG4gICAgICA/IHtcbiAgICAgICAgICAvLyBTcGFjZSBlbGVtZW50cyBzaG91bGQgaGF2ZSBtaW5pbWFsIGNyb3NzLWF4aXMgZGltZW5zaW9ucy5cbiAgICAgICAgICAvLyBUaGUgRmxleENvbnRleHQgbG9naWMgaW4gU3R5bGVkRWxlbWVudENvbnRhaW5lckxheW91dFdyYXBwZXIgaGFuZGxlc1xuICAgICAgICAgIC8vIHRoZSBwcmltYXJ5IGRpbWVuc2lvbiAod2lkdGggZm9yIGhvcml6b250YWwsIGhlaWdodCBmb3IgdmVydGljYWwpLlxuICAgICAgICAgIG1pbldpZHRoOiAwLFxuICAgICAgICAgIG1pbkhlaWdodDogMCxcbiAgICAgICAgfVxuICAgICAgOiB7fSksXG4gICAgLi4uKEdMT0JBTF9FTEVNRU5UUy5pbmNsdWRlcyhlbGVtZW50VHlwZSlcbiAgICAgID8ge1xuICAgICAgICAgIC8vIEdsb2JhbCBlbGVtZW50cyBhcmUgcmVuZGVyZWQgaW4gdGhlaXIgZGVsdGEgcG9zaXRpb24sIGJ1dCB0aGV5XG4gICAgICAgICAgLy8gYXJlIG5vdCBwYXJ0IG9mIHRoZSBmbGV4Ym94IGxheW91dC4gV2UgYXBwbHkgYSBuZWdhdGl2ZSBtYXJnaW5cbiAgICAgICAgICAvLyB0byByZW1vdmUgdGhlIGZsZXhib3ggZ2FwLiBkaXNwbGF5OiBub25lIGRvZXMgbm90IHdvcmsgZm9yIHRoZXNlLFxuICAgICAgICAgIC8vIHNpbmNlIHRoZXkgbmVlZHMgdG8gYmUgdmlzaWJsZS5cbiAgICAgICAgICBtYXJnaW5Cb3R0b206IGAtJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgICAgIH1cbiAgICAgIDoge30pLFxuICB9KVxuKVxuXG5pbnRlcmZhY2UgU3R5bGVkQ29sdW1uUHJvcHMge1xuICB3ZWlnaHQ6IG51bWJlclxuICBnYXA6IHN0cmVhbWxpdC5HYXBTaXplIHwgdW5kZWZpbmVkXG4gIHNob3dCb3JkZXI6IGJvb2xlYW5cbiAgdmVydGljYWxBbGlnbm1lbnQ/OiBCbG9ja1Byb3RvLkNvbHVtbi5WZXJ0aWNhbEFsaWdubWVudFxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQ29sdW1uID0gc3R5bGVkLmRpdjxTdHlsZWRDb2x1bW5Qcm9wcz4oXG4gICh7IHRoZW1lLCB3ZWlnaHQsIGdhcCwgc2hvd0JvcmRlciwgdmVydGljYWxBbGlnbm1lbnQgfSkgPT4ge1xuICAgIGNvbnN0IHsgVmVydGljYWxBbGlnbm1lbnQgfSA9IEJsb2NrUHJvdG8uQ29sdW1uXG4gICAgY29uc3QgcGVyY2VudGFnZSA9IHdlaWdodCAqIDEwMFxuICAgIGNvbnN0IGdhcFdpZHRoID0gdHJhbnNsYXRlR2FwV2lkdGgoZ2FwLCB0aGVtZSlcbiAgICBjb25zdCB3aWR0aCA9XG4gICAgICBnYXBXaWR0aCA9PT0gdGhlbWUuc3BhY2luZy5ub25lXG4gICAgICAgID8gYCR7cGVyY2VudGFnZX0lYFxuICAgICAgICA6IGBjYWxjKCR7cGVyY2VudGFnZX0lIC0gJHtnYXBXaWR0aH0pYFxuXG4gICAgcmV0dXJuIHtcbiAgICAgIC8vIENhbGN1bGF0ZSB3aWR0aCBiYXNlZCBvbiBwZXJjZW50YWdlLCBidXQgZmlsbCBhbGwgYXZhaWxhYmxlIHNwYWNlLFxuICAgICAgLy8gZS5nLiBpZiBpdCBvdmVyZmxvd3MgdG8gbmV4dCByb3cuXG4gICAgICB3aWR0aCxcbiAgICAgIGZsZXg6IGAxIDEgJHt3aWR0aH1gLFxuXG4gICAgICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLmNvbHVtbnN9KWBdOiB7XG4gICAgICAgIG1pbldpZHRoOiBgY2FsYygxMDAlIC0gJHt0aGVtZS5zcGFjaW5nLnR3b1hMfSlgLFxuICAgICAgfSxcbiAgICAgIC4uLih2ZXJ0aWNhbEFsaWdubWVudCA9PT0gVmVydGljYWxBbGlnbm1lbnQuQk9UVE9NICYmIHtcbiAgICAgICAgbWFyZ2luVG9wOiBcImF1dG9cIixcbiAgICAgICAgLy8gQWRkIG1hcmdpbiB0byB0aGUgZmlyc3QgY2hlY2tib3gvdG9nZ2xlIHdpdGhpbiB0aGUgY29sdW1uIHRvIGFsaWduIGl0XG4gICAgICAgIC8vIGJldHRlciB3aXRoIG90aGVyIGlucHV0IHdpZGdldHMuXG4gICAgICAgIFtgJiAke1N0eWxlZEVsZW1lbnRDb250YWluZXJ9Omxhc3Qtb2YtdHlwZSA+ICR7U3R5bGVkQ2hlY2tib3h9YF06IHtcbiAgICAgICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgICAgIH0sXG4gICAgICB9KSxcbiAgICAgIC4uLih2ZXJ0aWNhbEFsaWdubWVudCA9PT0gVmVydGljYWxBbGlnbm1lbnQuVE9QICYmIHtcbiAgICAgICAgLy8gQWRkIG1hcmdpbiB0byB0aGUgZmlyc3QgY2hlY2tib3gvdG9nZ2xlIHdpdGhpbiB0aGUgY29sdW1uIHRvIGFsaWduIGl0XG4gICAgICAgIC8vIGJldHRlciB3aXRoIG90aGVyIGlucHV0IHdpZGdldHMuXG4gICAgICAgIFtgJiAke1N0eWxlZEVsZW1lbnRDb250YWluZXJ9OmZpcnN0LW9mLXR5cGUgPiAke1N0eWxlZENoZWNrYm94fWBdOiB7XG4gICAgICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgICB9LFxuICAgICAgfSksXG4gICAgICAuLi4odmVydGljYWxBbGlnbm1lbnQgPT09IFZlcnRpY2FsQWxpZ25tZW50LkNFTlRFUiAmJiB7XG4gICAgICAgIG1hcmdpblRvcDogXCJhdXRvXCIsXG4gICAgICAgIG1hcmdpbkJvdHRvbTogXCJhdXRvXCIsXG4gICAgICB9KSxcbiAgICAgIC4uLihzaG93Qm9yZGVyICYmIHtcbiAgICAgICAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgICAgICBwYWRkaW5nOiBgY2FsYygke3RoZW1lLnNwYWNpbmcubGd9IC0gJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0pYCxcbiAgICAgIH0pLFxuICAgIH1cbiAgfVxuKVxuXG5jb25zdCBnZXRBbGlnbkl0ZW1zID0gKFxuICBhbGlnbjogQmxvY2tQcm90by5GbGV4Q29udGFpbmVyLkFsaWduIHwgdW5kZWZpbmVkIHwgbnVsbFxuKTogQ1NTUHJvcGVydGllc1tcImFsaWduSXRlbXNcIl0gPT4ge1xuICBzd2l0Y2ggKGFsaWduKSB7XG4gICAgY2FzZSBCbG9ja1Byb3RvLkZsZXhDb250YWluZXIuQWxpZ24uQUxJR05fU1RBUlQ6XG4gICAgICByZXR1cm4gXCJzdGFydFwiXG4gICAgY2FzZSBCbG9ja1Byb3RvLkZsZXhDb250YWluZXIuQWxpZ24uQUxJR05fQ0VOVEVSOlxuICAgICAgcmV0dXJuIFwiY2VudGVyXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5BbGlnbi5BTElHTl9FTkQ6XG4gICAgICByZXR1cm4gXCJlbmRcIlxuICAgIGNhc2UgQmxvY2tQcm90by5GbGV4Q29udGFpbmVyLkFsaWduLlNUUkVUQ0g6XG4gICAgICByZXR1cm4gXCJzdHJldGNoXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5BbGlnbi5BTElHTl9VTkRFRklORUQ6XG4gICAgY2FzZSB1bmRlZmluZWQ6XG4gICAgY2FzZSBudWxsOlxuICAgICAgcmV0dXJuIFwic3RyZXRjaFwiXG4gICAgZGVmYXVsdDpcbiAgICAgIGFzc2VydE5ldmVyKGFsaWduKVxuICB9XG59XG5cbmNvbnN0IGdldEp1c3RpZnlDb250ZW50ID0gKFxuICBqdXN0aWZ5OiBCbG9ja1Byb3RvLkZsZXhDb250YWluZXIuSnVzdGlmeSB8IHVuZGVmaW5lZCB8IG51bGxcbik6IENTU1Byb3BlcnRpZXNbXCJqdXN0aWZ5Q29udGVudFwiXSA9PiB7XG4gIHN3aXRjaCAoanVzdGlmeSkge1xuICAgIGNhc2UgQmxvY2tQcm90by5GbGV4Q29udGFpbmVyLkp1c3RpZnkuSlVTVElGWV9TVEFSVDpcbiAgICAgIHJldHVybiBcInN0YXJ0XCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5LkpVU1RJRllfQ0VOVEVSOlxuICAgICAgcmV0dXJuIFwiY2VudGVyXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5LkpVU1RJRllfRU5EOlxuICAgICAgcmV0dXJuIFwiZW5kXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5LlNQQUNFX0JFVFdFRU46XG4gICAgICByZXR1cm4gXCJzcGFjZS1iZXR3ZWVuXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5LkpVU1RJRllfVU5ERUZJTkVEOlxuICAgIGNhc2UgdW5kZWZpbmVkOlxuICAgIGNhc2UgbnVsbDpcbiAgICAgIHJldHVybiBcInN0YXJ0XCJcbiAgICBkZWZhdWx0OlxuICAgICAgYXNzZXJ0TmV2ZXIoanVzdGlmeSlcbiAgfVxufVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZEZsZXhDb250YWluZXJCbG9ja1Byb3BzIHtcbiAgZGlyZWN0aW9uOiBSZWFjdC5DU1NQcm9wZXJ0aWVzW1wiZmxleERpcmVjdGlvblwiXVxuICBnYXA/OiBzdHJlYW1saXQuR2FwU2l6ZSB8IHVuZGVmaW5lZFxuICBmbGV4PzogUmVhY3QuQ1NTUHJvcGVydGllc1tcImZsZXhcIl1cbiAgLy8gVGhpcyBtYXJrcyB0aGUgcHJvcCBhcyBhIHRyYW5zaWVudCBwcm9wZXJ0eSBzbyBpdCBpc1xuICAvLyBub3QgcGFzc2VkIHRvIHRoZSBET00uIEl0IG92ZXJsYXBzIHdpdGggYSB2YWxpZCBhdHRyaWJ1dGVcbiAgLy8gc28gcGFzc2luZyBpdCB0byB0aGUgRE9NIHdpbGwgY2F1c2UgYW4gZXJyb3IgaW4gdGhlIGNvbnNvbGUuXG4gICR3cmFwPzogYm9vbGVhblxuICBoZWlnaHQ/OiBSZWFjdC5DU1NQcm9wZXJ0aWVzW1wiaGVpZ2h0XCJdXG4gIGJvcmRlcjogYm9vbGVhblxuICBhbGlnbj86IEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5BbGlnbiB8IG51bGxcbiAganVzdGlmeT86IEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5IHwgbnVsbFxuICBvdmVyZmxvdz86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJvdmVyZmxvd1wiXVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRmxleENvbnRhaW5lckJsb2NrID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRGbGV4Q29udGFpbmVyQmxvY2tQcm9wcz4oXG4gICAgKHtcbiAgICAgIHRoZW1lLFxuICAgICAgZGlyZWN0aW9uLFxuICAgICAgZ2FwLFxuICAgICAgZmxleCxcbiAgICAgICR3cmFwLFxuICAgICAgaGVpZ2h0LFxuICAgICAgYm9yZGVyLFxuICAgICAgYWxpZ24sXG4gICAgICBqdXN0aWZ5LFxuICAgICAgb3ZlcmZsb3csXG4gICAgfSkgPT4ge1xuICAgICAgbGV0IGdhcFdpZHRoXG4gICAgICBpZiAoZ2FwICE9PSB1bmRlZmluZWQpIHtcbiAgICAgICAgZ2FwV2lkdGggPSB0cmFuc2xhdGVHYXBXaWR0aChnYXAsIHRoZW1lKVxuICAgICAgfVxuXG4gICAgICByZXR1cm4ge1xuICAgICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgICAgZ2FwOiBnYXBXaWR0aCxcbiAgICAgICAgd2lkdGg6IFwiMTAwJVwiLFxuICAgICAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgICAgIGhlaWdodDogaGVpZ2h0ID8/IFwiYXV0b1wiLFxuICAgICAgICBtaW5XaWR0aDogXCIxcmVtXCIsXG4gICAgICAgIGZsZXhEaXJlY3Rpb246IGRpcmVjdGlvbixcbiAgICAgICAgZmxleCxcbiAgICAgICAgYWxpZ25JdGVtczogZ2V0QWxpZ25JdGVtcyhhbGlnbiksXG4gICAgICAgIGp1c3RpZnlDb250ZW50OiBnZXRKdXN0aWZ5Q29udGVudChqdXN0aWZ5KSxcbiAgICAgICAgZmxleFdyYXA6ICR3cmFwID8gXCJ3cmFwXCIgOiBcIm5vd3JhcFwiLFxuICAgICAgICAuLi4oYm9yZGVyICYmIHtcbiAgICAgICAgICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAgICAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAgICAgICBwYWRkaW5nOiBgY2FsYygke3RoZW1lLnNwYWNpbmcubGd9IC0gJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0pYCxcbiAgICAgICAgfSksXG4gICAgICAgIG92ZXJmbG93LFxuICAgICAgfVxuICAgIH1cbiAgKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZExheW91dFdyYXBwZXJQcm9wcyB7XG4gIHdpZHRoPzogUmVhY3QuQ1NTUHJvcGVydGllc1tcIndpZHRoXCJdXG4gIGhlaWdodD86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJoZWlnaHRcIl1cbiAgZmxleD86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJmbGV4XCJdXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMYXlvdXRXcmFwcGVyID0gc3R5bGVkLmRpdjxTdHlsZWRMYXlvdXRXcmFwcGVyUHJvcHM+KFxuICAoeyB3aWR0aCwgaGVpZ2h0LCBmbGV4IH0pID0+ICh7XG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgLy8gVGhpcyBzaG91bGRuJ3QgbWF0dGVyIHNpbmNlIHRoaXMgaXMgYSB3cmFwcGVyIGFuZCBzaG91bGQgb25seSBoYXZlIG9uZSBjaGlsZC5cbiAgICAvLyBIb3dldmVyLCBhZGRpbmcgaXQgaGVyZSB0byBiZSBleHBsaWNpdC5cbiAgICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICAgIHdpZHRoLFxuICAgIG1heFdpZHRoOiBcIjEwMCVcIixcbiAgICBtaW5XaWR0aDogXCIxcmVtXCIsXG4gICAgaGVpZ2h0LFxuICAgIGZsZXgsXG4gIH0pXG4pXG4iXX0= */"), StyledLayoutWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn0"
} : {
  target: "e1f1d6gn0",
  label: "StyledLayoutWrapper"
})(({
  width: o,
  height: i,
  flex: g
}) => ({
  display: "flex",
  // This shouldn't matter since this is a wrapper and should only have one child.
  // However, adding it here to be explicit.
  flexDirection: "column",
  width: o,
  maxWidth: "100%",
  minWidth: "1rem",
  height: i,
  flex: g
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), LARGE_STRETCH_BEHAVIOR$1 = [
  "graphvizChart",
  "arrowVegaLiteChart",
  "deckGlJsonChart",
  "plotlyChart",
  "docString",
  "arrowDataFrame",
  "json",
  "audioInput",
  "fileUploader",
  "cameraInput",
  "audio",
  "video",
  "code",
  // also includes st.echo
  "buttonGroup",
  "iframe"
], MEDIUM_STRETCH_BEHAVIOR$1 = [
  "dateInput",
  "radio",
  "slider",
  // also includes st.select_slider
  "textArea",
  "progress",
  "multiselect",
  "selectbox",
  "timeInput",
  "numberInput",
  "textInput"
], WIDTH_STRETCH_OVERRIDE = [
  // Because of how width is handled for custom components, we need the
  // element wrapper to be full width.
  "componentInstance",
  // Without this style, the skeleton width relies on the flex container that
  // wraps the page contents having align-items: stretch. There was a regression
  // where this default was changed. It is more robust to ensure that the skeleton
  // has this width.
  "skeleton"
], VISIBLE_OVERFLOW_OVERRIDE = [
  // TODO(lwilby): Some elements need overflow to be visible in webkit. Will investigate
  // if we can remove this custom handling in future layouts work.
  "iframe",
  "arrowDataFrame",
  "deckGlJsonChart",
  "arrowVegaLiteChart",
  "graphvizChart"
], StyledElementContainerLayoutWrapper = ({
  node: o,
  ...i
}) => {
  const {
    isInHorizontalLayout: g,
    isInRoot: E
  } = useRequiredContext(FlexContext);
  let e;
  LARGE_STRETCH_BEHAVIOR$1.includes(o.element.type ?? "") ? e = "14rem" : MEDIUM_STRETCH_BEHAVIOR$1.includes(o.element.type ?? "") && (e = "8rem"), o.element.type === "buttonGroup" && o.element.buttonGroup?.style === ButtonGroup$1.Style.BORDERLESS && (e = "fit-content");
  const t = useMemo$1(() => {
    const h = {};
    if (WIDTH_STRETCH_OVERRIDE.includes(o.element.type ?? "") && (h.width = "100%"), VISIBLE_OVERFLOW_OVERRIDE.includes(o.element.type ?? "") && (h.overflow = "visible"), o.element.type === "textArea")
      return o.element.heightConfig?.useStretch ? {
        height: "100%",
        flex: "1 1 8rem"
      } : g ? {
        height: "auto"
      } : {
        height: "auto",
        // Content height text area in vertical layout cannot have flex.
        flex: ""
      };
    if (o.element.type === "arrowVegaLiteChart")
      return o.element.widthConfig?.useContent && E && (h.width = "100%"), g && !o.element.widthConfig && (h.flex = "1 1 14rem"), h;
    if (o.element.type === "arrowDataFrame")
      return o.element.widthConfig?.useContent && E && (h.width = "100%"), h;
    if (o.element.type === "imgs") {
      const d = !o.element.widthConfig || o.element.widthConfig.useStretch;
      h.width = d ? "100%" : "auto";
    }
    return h;
  }, [o.element.type, o.element.heightConfig?.useStretch, g, E, o.element.widthConfig]);
  let n = useLayoutStyles({
    element: o.element,
    subElement: o.element?.type && o.element[o.element.type] || void 0,
    styleOverrides: t,
    minStretchBehavior: e
  });
  return o.element.type === "space" && (g ? n = {
    ...n,
    height: "auto"
  } : n = {
    ...n,
    width: "auto"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledElementContainer, { ...i, ...n });
}, ArrowTable = lazy(() => import("./index-D84OIlAi.js")), ArrowVegaLiteChart = lazy(() => import("./index-Bm88VBqW.js")), Audio = lazy(() => import("./index-C65a4izB.js")), Balloons = lazy(() => import("./index-CH1Ghdrs.js")), DeckGlJsonChart = lazy(() => import("./index-BPlXHDRz.js")), GraphVizChart = lazy(() => import("./index-CgINsD29.js")), Html = lazy(() => import("./index-DzHYkbyJ.js")), IFrame = lazy(() => import("./index--HL2iAm-.js")), ImageList = lazy(() => import("./index-fKqQTR-V.js")), Json = lazy(() => import("./index-CrpT6xoG.js")), LinkButton = lazy(() => import("./index-B4HGX4j4.js")), Metric = lazy(() => import("./index-dgQjqW57.js")), PageLink = lazy(() => import("./index-Cm-PaPIi.js")), PlotlyChart = lazy(() => import("./index-wPDGTxpi.js")), Progress = lazy(() => import("./index-eOOLWIye.js")), Snow = lazy(() => import("./index-DeuG9gFr.js")), Spinner = lazy(() => import("./index-DGPusmQF.js")), StreamlitSyntaxHighlighter = lazy(() => import("./StreamlitSyntaxHighlighter-DGQw-z1T.js")), Toast = lazy(() => import("./index-XX_Dosb-.js")), Video = lazy(() => import("./index-C7jBmyzJ.js")), AudioInput = lazy(() => import("./index-hdfaKcNI.js")), ArrowDataFrame = lazy(() => import("./index-D253bW7v.js")), Button = lazy(() => import("./index-FcUH12I0.js")), ButtonGroup = lazy(() => import("./index-LNnefQ9f.js")), ComponentInstance = lazy(() => import("./index-DliZ_MYb.js").then((o) => ({
  default: o.ComponentInstance
}))), CameraInput = lazy(() => import("./index-Bhl5Sdv5.js")), ChatInput = lazy(() => import("./index-B5fJ0nKN.js")), Checkbox = lazy(() => import("./index-Dltt2h_I.js")), ColorPicker = lazy(() => import("./index-CMoresYm.js")), DateInput = lazy(() => import("./index-BiSLrhVO.js")), DateTimeInput = lazy(() => import("./index-FDsa3i_z.js")), DownloadButton = lazy(() => import("./index-B57f6kDk.js")), FileUploader = lazy(() => import("./index-CENlrsHe.js")), FormSubmitContent = lazy(() => import("./index-DEWQX2iw.js").then((o) => ({
  default: o.FormSubmitContent
}))), Multiselect = lazy(() => import("./index-BneKltfF.js")), NumberInput = lazy(() => import("./index-DwByjaD9.js")), Radio = lazy(() => import("./index-Br3TsFx0.js")), Selectbox$1 = lazy(() => import("./index-DB_chK2o.js")), Slider = lazy(() => import("./index-Ce05BKKC.js")), TextArea = lazy(() => import("./index-CNb_K-Hm.js")), TextInput = lazy(() => import("./index-qFtI4hWp.js")), TimeInput = lazy(() => import("./index-D_8IUYy7.js")), BidiComponent = lazy(() => import("./index-D8nAgbXA.js"));
function hideIfStale(o, i) {
  return o ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : i;
}
const RawElementNodeRenderer = (o) => {
  const {
    node: i
  } = o;
  if (!i)
    throw new Error("ElementNode not found.");
  const g = {
    disableFullscreenMode: o.disableFullscreenMode,
    widthConfig: i.element.widthConfig,
    heightConfig: i.element.heightConfig
  }, E = {
    ...g,
    widgetMgr: o.widgetMgr,
    disabled: o.widgetsDisabled,
    fragmentId: i.fragmentId,
    componentRegistry: o.componentRegistry
  };
  switch (i.element.type) {
    case "alert": {
      const e = i.element.alert;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { icon: e.icon, body: e.body, kind: getAlertElementKind(e.format), ...g });
    }
    case "arrowTable": {
      const e = i.element.arrowTable;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowTable, { element: e, data: i.quiverElement, ...g });
    }
    case "audio":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Audio, { element: i.element.audio, endpoints: o.endpoints, ...g, elementMgr: o.widgetMgr });
    case "balloons":
      return hideIfStale(o.isStale, /* @__PURE__ */ jsxRuntimeExports.jsx(Balloons, { scriptRunId: i.scriptRunId }));
    case "code": {
      const e = i.element.code;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter, { language: e.language, showLineNumbers: e.showLineNumbers, wrapLines: e.wrapLines, children: e.codeText });
    }
    case "deckGlJsonChart": {
      const e = i.element.deckGlJsonChart;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        DeckGlJsonChart,
        {
          element: e,
          ...E
        },
        e.id || void 0
      );
    }
    case "docString":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DocString$1, { element: i.element.docString, ...g });
    case "empty":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stEmpty", "data-testid": "stEmpty" });
    case "exception":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ExceptionElement$1, { element: i.element.exception, ...g });
    case "graphvizChart":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(GraphVizChart, { element: i.element.graphvizChart, ...g });
    case "heading":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { element: i.element.heading, ...g });
    case "iframe":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(IFrame, { element: i.element.iframe, ...g });
    case "imgs":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ImageList, { element: i.element.imgs, endpoints: o.endpoints, ...g });
    case "json":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Json, { element: i.element.json, ...g });
    case "markdown":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown$1, { element: i.element.markdown, ...g });
    case "metric":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Metric, { element: i.element.metric, ...g });
    case "html":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Html, { element: i.element.html, ...g });
    case "pageLink": {
      const e = i.element.pageLink, t = E.disabled || e.disabled;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PageLink, { element: e, disabled: t, ...g });
    }
    case "progress":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Progress, { element: i.element.progress, ...g });
    case "skeleton":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: i.element.skeleton });
    case "snow":
      return hideIfStale(o.isStale, /* @__PURE__ */ jsxRuntimeExports.jsx(Snow, { scriptRunId: i.scriptRunId }));
    case "space":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpace, { className: "stSpace", "data-testid": "stSpace" });
    case "spinner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { element: i.element.spinner, ...g });
    case "text":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(TextElement$1, { element: i.element.text, ...g });
    case "video":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Video, { element: i.element.video, endpoints: o.endpoints, ...g, elementMgr: o.widgetMgr });
    // Events:
    case "toast": {
      const e = i.element.toast;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Toast,
        {
          element: e,
          ...g
        },
        i.scriptRunId
      );
    }
    // Widgets:
    case "arrowDataFrame": {
      const e = i.element.arrowDataFrame;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowDataFrame,
        {
          element: e,
          data: i.quiverElement,
          ...E
        },
        e.id || void 0
      );
    }
    case "arrowVegaLiteChart": {
      const e = i.vegaLiteChartElement;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowVegaLiteChart,
        {
          element: e,
          ...E
        },
        e.id || void 0
      );
    }
    case "audioInput": {
      const e = i.element.audioInput;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(AudioInput, { uploadClient: o.uploadClient, element: e, ...E }, e.id);
    }
    case "button": {
      const e = i.element.button;
      return E.disabled = E.disabled || e.disabled, e.isFormSubmitter ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormSubmitContent, { element: e, ...E }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { element: e, ...E });
    }
    case "buttonGroup": {
      const e = i.element.buttonGroup;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup, { element: e, ...E }, e.id);
    }
    case "downloadButton": {
      const e = i.element.downloadButton;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(DownloadButton, { endpoints: o.endpoints, element: e, ...E }, e.id);
    }
    case "cameraInput": {
      const e = i.element.cameraInput;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(CameraInput, { element: e, uploadClient: o.uploadClient, ...E }, e.id);
    }
    case "chatInput": {
      const e = i.element.chatInput;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ChatInput, { element: e, uploadClient: o.uploadClient, ...E }, e.id);
    }
    case "checkbox": {
      const e = i.element.checkbox;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { element: e, ...E }, e.id);
    }
    case "colorPicker": {
      const e = i.element.colorPicker;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ColorPicker, { element: e, ...E }, e.id);
    }
    case "componentInstance":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentInstance, { element: i.element.componentInstance, ...E });
    case "dateInput": {
      const e = i.element.dateInput;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(DateInput, { element: e, ...E }, e.id);
    }
    case "fileUploader": {
      const e = i.element.fileUploader;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(FileUploader, { element: e, uploadClient: o.uploadClient, ...E }, e.id);
    }
    case "linkButton": {
      const e = i.element.linkButton;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, { element: e, ...g });
    }
    case "multiselect": {
      const e = i.element.multiselect;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Multiselect, { element: e, ...E }, e.id);
    }
    case "numberInput": {
      const e = i.element.numberInput;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInput, { element: e, ...E }, e.id);
    }
    case "plotlyChart": {
      const e = i.element.plotlyChart;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PlotlyChart, { element: e, ...E }, e.id);
    }
    case "radio": {
      const e = i.element.radio;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { element: e, ...E }, e.id);
    }
    case "selectbox": {
      const e = i.element.selectbox;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Selectbox$1, { element: e, ...E }, e.id);
    }
    case "slider": {
      const e = i.element.slider;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Slider, { element: e, ...E }, e.id);
    }
    case "textArea": {
      const e = i.element.textArea;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TextArea, { element: e, outerElement: i.element, ...E }, e.id);
    }
    case "textInput": {
      const e = i.element.textInput;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { element: e, ...E }, e.id);
    }
    case "dateTimeInput": {
      const e = i.element.dateTimeInput;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(DateTimeInput, { element: e, ...E }, e.id);
    }
    case "timeInput": {
      const e = i.element.timeInput;
      return E.disabled = E.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TimeInput, { element: e, ...E }, e.id);
    }
    case "bidiComponent": {
      const e = i.element.bidiComponent;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BidiComponent, { element: e, ...E }, e.id);
    }
    default:
      throw new Error(`Unrecognized Element type ${i.element.type}`);
  }
}, ElementNodeRenderer = (o) => {
  const {
    isFullScreen: i
  } = useContext(ViewStateContext), {
    scriptRunState: g,
    scriptRunId: E,
    fragmentIdsThisRun: e
  } = useContext(ScriptRunContext), {
    node: t
  } = o, n = t.element.type || "", h = shouldComponentBeEnabled(n, g), d = isComponentStale(h, t, g, E, e), k = getElementId(t.element), p = getKeyFromId(k);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Maybe, { enable: h, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledElementContainerLayoutWrapper,
    {
      className: classNames("stElementContainer", "element-container", convertKeyToClassName(p)),
      "data-testid": "stElementContainer",
      "data-stale": d,
      isStale: d && !i,
      elementType: n,
      node: t,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
        style: Skeleton$1.SkeletonStyle.ELEMENT
      }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(RawElementNodeRenderer, { ...o, isStale: d }) }) })
    }
  ) });
};
class RenderNodeVisitor {
  constructor(i, g) {
    this.props = i, this.elementKeyOverride = g, this.elementKeySet = /* @__PURE__ */ new Set(), this.reactElements = [], this.index = 0, this.transientElementCount = 0;
  }
  getCurrentKey(i) {
    return this.elementKeyOverride || i || this.index.toString();
  }
  conformToArray(i) {
    return i ? Array.isArray(i) ? i : [i] : [];
  }
  visitBlockNode(i) {
    const g = {
      ...this.props,
      node: i
    }, E = this.getCurrentKey();
    this.index += 1;
    const e = /* @__PURE__ */ jsxRuntimeExports.jsx(BlockNodeRenderer, { ...g }, E);
    return this.reactElements.push(e), e;
  }
  visitTransientNode(i) {
    const g = [];
    i.transientNodes.forEach((e) => {
      const t = this.getCurrentKey(`transient-${this.transientElementCount}`);
      this.transientElementCount += 1;
      const n = e.accept(new RenderNodeVisitor(this.props, t));
      g.push(...this.conformToArray(n));
    }), this.reactElements.push(...g);
    const E = i.anchor?.accept(this);
    return g.push(...this.conformToArray(E)), g;
  }
  visitElementNode(i) {
    const g = {
      ...this.props,
      node: i
    }, E = this.getCurrentKey(getElementId(i.element));
    if (this.index += 1, this.elementKeySet.has(E))
      return null;
    this.elementKeySet.add(E);
    const e = /* @__PURE__ */ jsxRuntimeExports.jsx(ElementNodeRenderer, { ...g }, E);
    return this.reactElements.push(e), e;
  }
  /**
   * Convenience method to render all children of a block as React elements.
   *
   * This is the primary entry point for rendering - it creates a visitor,
   * traverses all children, and returns the accumulated React elements.
   *
   * @param props - Block props containing the node to render
   * @param disableFullscreenMode - Whether to disable fullscreen mode for elements
   * @returns Array of React elements ready to render (may include nulls for duplicates)
   *
   * @example
   * const ChildRenderer = (props) => {
   *   return <>{RenderNodeVisitor.collectReactElements(props, false)}</>
   * }
   */
  static collectReactElements(i) {
    if (!i.node.children)
      return [];
    const g = new RenderNodeVisitor(i);
    return i.node.children.forEach((E) => E.accept(g)), g.reactElements;
  }
}
const ChildRenderer = (o) => (assignDividerColor(o.node, useEmotionTheme()), /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: RenderNodeVisitor.collectReactElements(o) })), getLayoutSubElement = (o) => {
  const i = o.type, g = i ? o[i] : void 0;
  if (!g || typeof g != "object") return;
  const E = g, e = {
    useContainerWidth: E.useContainerWidth,
    height: E.height,
    width: E.width,
    widthConfig: E.widthConfig
  };
  if (!(e.useContainerWidth === void 0 && e.height === void 0 && e.width === void 0 && e.widthConfig === void 0))
    return e;
}, ContainerContentsWrapper = (o) => {
  const i = useContext(FlexContext), g = {
    direction: Direction.VERTICAL,
    flex: 1,
    gap: streamlit.GapSize.SMALL,
    height: o.height,
    // eslint-disable-next-line streamlit-custom/no-hardcoded-theme-values
    border: !1
  }, E = getKeyFromId(o.node.deltaBlock.id);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContextProvider, { direction: Direction.VERTICAL, isRoot: o.isRoot, parentContext: i, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFlexContainerBlock, { ...g, className: classNames(getClassnamePrefix(Direction.VERTICAL), convertKeyToClassName(E)), "data-testid": getClassnamePrefix(Direction.VERTICAL), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildRenderer, { ...o }) }) });
}, FlexBoxContainer = (o) => {
  const i = getDirectionOfBlock(o.node.deltaBlock), g = useContext(FlexContext), E = getActivateScrollToBottomBackwardsCompatible(o.node), e = useScrollToBottom(E), t = useLayoutStyles({
    element: o.node.deltaBlock,
    subElement: getLayoutSubElement(o.node.deltaBlock)
  }), n = {
    gap: (
      // This is backwards compatible with old proto messages since previously
      // the gap size was defaulted to small.
      o.node.deltaBlock.flexContainer?.gapConfig?.gapSize ?? streamlit.GapSize.SMALL
    ),
    direction: i,
    // This is also backwards compatible since previously wrap was not added
    // to the flex container.
    $wrap: o.node.deltaBlock.flexContainer?.wrap ?? !1,
    overflow: t.overflow,
    border: getBorderBackwardsCompatible(o.node.deltaBlock),
    // We need the height on the container for scrolling.
    height: t.height,
    // Flex properties are set on the LayoutWrapper.
    flex: "1",
    align: o.node.deltaBlock.flexContainer?.align,
    justify: o.node.deltaBlock.flexContainer?.justify
  }, h = getKeyFromId(o.node.deltaBlock.id), d = o.node.deltaBlock.widthConfig?.pixelWidth ?? void 0, k = o.node.deltaBlock.widthConfig?.useContent ?? !1, p = (o.node.deltaBlock.widthConfig?.pixelWidth ?? 0) > 0 || (o.node.deltaBlock.widthConfig?.remWidth ?? 0) > 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContextProvider, { direction: i, parentWidth: d, hasContentWidth: k, hasFixedWidth: p, parentContext: g, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFlexContainerBlock, { ...n, className: classNames(getClassnamePrefix(i), convertKeyToClassName(h)), "data-testid": getClassnamePrefix(i), ref: e, "data-test-scroll-behavior": E ? "scroll-to-bottom" : "normal", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildRenderer, { ...o }) }) });
}, LARGE_STRETCH_BEHAVIOR = ["tabContainer"], MEDIUM_STRETCH_BEHAVIOR = ["chatInput"], BlockNodeRenderer = (o) => {
  const {
    node: i
  } = o, {
    scriptRunState: g,
    scriptRunId: E,
    fragmentIdsThisRun: e
  } = useContext(ScriptRunContext);
  let t;
  LARGE_STRETCH_BEHAVIOR.includes(i.deltaBlock.type ?? "") ? t = "14rem" : MEDIUM_STRETCH_BEHAVIOR.includes(i.deltaBlock.type ?? "") ? t = "8rem" : i.deltaBlock.type === "chatMessage" ? i.isEmpty && (t = "8rem") : (i.deltaBlock.type === "flexContainer" || i.deltaBlock.column || i.deltaBlock.expandable) && (i.isEmpty || (t = "8rem"));
  const n = useLayoutStyles({
    element: i.deltaBlock,
    subElement: getLayoutSubElement(i.deltaBlock),
    minStretchBehavior: t
  });
  if (i.isEmpty && !i.deltaBlock.allowEmpty)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  const h = shouldComponentBeEnabled("", g), d = isComponentStale(h, i, g, E, e), k = {
    ...o,
    node: i
  }, p = o.disableFullscreenMode || notNullOrUndefined(i.deltaBlock.dialog) || notNullOrUndefined(i.deltaBlock.popover);
  let M;
  const H = /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { ...k, disableFullscreenMode: p, height: "100%" });
  if (checkFlexContainerBackwardsCompatibile(i.deltaBlock) && (M = /* @__PURE__ */ jsxRuntimeExports.jsx(FlexBoxContainer, { ...k })), i.deltaBlock.dialog)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog$1, { element: i.deltaBlock.dialog, deltaMsgReceivedAt: i.deltaMsgReceivedAt, widgetMgr: o.widgetMgr, fragmentId: i.fragmentId, children: H });
  if (i.deltaBlock.expandable && (M = /* @__PURE__ */ jsxRuntimeExports.jsx(Expander$1, { isStale: d, element: i.deltaBlock.expandable, children: H })), i.deltaBlock.popover && (M = /* @__PURE__ */ jsxRuntimeExports.jsx(Popover$1, { empty: i.isEmpty, element: i.deltaBlock.popover, stretchWidth: shouldWidthStretch(i.deltaBlock.widthConfig), children: H })), i.deltaBlock.type === "form") {
    const {
      formId: f,
      clearOnSubmit: AA,
      enterToSubmit: gA,
      border: IA
    } = i.deltaBlock.form;
    M = /* @__PURE__ */ jsxRuntimeExports.jsx(Form$1, { formId: f, clearOnSubmit: AA, enterToSubmit: gA, widgetMgr: o.widgetMgr, border: IA, overflow: n.overflow, children: H });
  }
  if (i.deltaBlock.chatMessage && (M = /* @__PURE__ */ jsxRuntimeExports.jsx(ChatMessage$1, { element: i.deltaBlock.chatMessage, endpoints: o.endpoints, children: H })), i.deltaBlock.column)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledColumn, { weight: i.deltaBlock.column.weight ?? 0, gap: backwardsCompatibleColumnGapSize(i.deltaBlock.column), verticalAlignment: i.deltaBlock.column.verticalAlignment ?? void 0, showBorder: i.deltaBlock.column.showBorder ?? !1, className: "stColumn", "data-testid": "stColumn", children: H });
  if (i.deltaBlock.tabContainer) {
    const AA = {
      ...k,
      isStale: d,
      renderTabContent: (gA) => /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { ...gA, height: "auto" }),
      width: n.width,
      flex: n.flex
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs$1, { ...AA });
  }
  return M ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLayoutWrapper, { "data-testid": "stLayoutWrapper", ...n, children: M }) : H;
}, DownloadContext = createContext({
  requestDeferredFile: void 0
});
DownloadContext.displayName = "DownloadContext";
const NavigationContext = createContext({
  pageLinkBaseUrl: "",
  currentPageScriptHash: "",
  onPageChange: () => {
  },
  navSections: [],
  appPages: []
});
NavigationContext.displayName = "NavigationContext";
process.env.NODE_ENV;
const StyledDataFrameOverlay = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1v116lc1"
} : {
  target: "e1v116lc1",
  label: "StyledDataFrameOverlay"
})(({
  theme: o
}) => ({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: o.zIndices.tablePortal,
  lineHeight: "100%",
  ...!hasLightBackgroundColor(o) && {
    "& input[type='date'], & input[type='time'], & input[type='datetime-local']": {
      "&::-webkit-calendar-picker-indicator": {
        filter: "brightness(0) invert(1)",
        opacity: 1
      }
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorMessage = /* @__PURE__ */ createStyled("small", process.env.NODE_ENV === "production" ? {
  target: "e1v116lc0"
} : {
  target: "e1v116lc0",
  label: "StyledErrorMessage"
})(({
  theme: o
}) => ({
  color: o.colors.redTextColor,
  fontSize: o.fontSizes.sm,
  marginTop: o.spacing.twoXS,
  display: "block"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), PortalContext = createContext(null);
PortalContext.displayName = "PortalContext";
const PortalProvider = ({
  children: o
}) => {
  const i = useRef(null), g = useCallback(() => i.current, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalContext.Provider, { value: g, children: [
    o,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDataFrameOverlay, { "data-testid": "portal", id: "portal", ref: i })
  ] });
}, SidebarConfigContext = createContext({
  initialSidebarState: PageConfig.SidebarState.AUTO,
  appLogo: null,
  sidebarChevronDownshift: 0,
  expandSidebarNav: !1,
  hideSidebarNav: !1
});
SidebarConfigContext.displayName = "SidebarConfigContext";
const ThemeContext = createContext({
  activeTheme: getDefaultTheme(),
  setTheme: () => {
  },
  availableThemes: []
});
ThemeContext.displayName = "ThemeContext";
function ThemeProvider({
  theme: o,
  baseuiTheme: i,
  children: g
}) {
  return (
    // Type error coming from BaseUI "property children doesn't exist"
    // @ts-expect-error
    /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, { theme: i || baseuiLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, { theme: o, children: g }) })
  );
}
const CopyButton = ({
  text: o
}) => {
  const i = useEmotionTheme(), g = useRef(null), {
    isCopied: E,
    copyToClipboard: e,
    label: t
  } = useCopyToClipboard(), n = useCallback(() => {
    e(o);
  }, [e, o]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCopyButton, { "data-testid": "stCodeCopyButton", title: t, "aria-label": t, type: "button", ref: g, onClick: n, children: E ? /* @__PURE__ */ jsxRuntimeExports.jsx(Check, { size: convertRemToPx(i.iconSizes.base) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Copy, { size: convertRemToPx(i.iconSizes.base) }) });
}, CopyButton$1 = memo(CopyButton);
function StreamlitErrorCodeBlock({
  children: o
}) {
  const i = typeof o == "string" && o.trim().length > 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCodeBlock, { className: "stErrorCodeBlock", "data-testid": "stErrorCodeBlock", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPre, { wrapLines: !1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: o }) }),
    i && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCopyButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopyButton$1, { text: o }) })
  ] });
}
const StreamlitErrorCodeBlock$1 = memo(StreamlitErrorCodeBlock);
function iconToUrl(o) {
  const i = /^:(.+)\/(.+):$/, g = o.match(i);
  return g === null ? "" : `https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsrounded/${g[2]}/default/24px.svg`;
}
function handleFavicon(o, i, g) {
  const E = (n) => {
    overwriteFavicon(n), i({
      type: "SET_PAGE_FAVICON",
      favicon: n
    });
  };
  if (o.startsWith(":material")) {
    E(iconToUrl(o));
    return;
  }
  const e = "emoji:";
  if (o.startsWith(e)) {
    const n = o.substring(e.length), h = createEmojiDataUrl(n);
    E(h);
    return;
  }
  /^:[a-zA-Z0-9_+-]+:$/.test(o) ? convertShortcodeToEmoji(o).then((n) => {
    E(n ? createEmojiDataUrl(n) : g.buildMediaURL(o));
  }).catch(() => {
    E(g.buildMediaURL(o));
  }) : E(g.buildMediaURL(o));
}
function createEmojiDataUrl(o) {
  return `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>${o}</text></svg>`;
}
function overwriteFavicon(o) {
  const i = document.querySelector("link[rel='shortcut icon']");
  i && (i.href = o);
}
async function convertShortcodeToEmoji(o) {
  const i = await import("./index-KjVX1110.js"), g = o.replace(/-/g, "_"), E = i.get(g);
  return E && E !== g && i.has(E) ? E : "";
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$9() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledWidgetLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn3"
} : {
  target: "e1y5xkzn3",
  label: "StyledWidgetLabel"
})(({
  disabled: o,
  labelVisibility: i,
  theme: g
}) => ({
  fontSize: g.fontSizes.sm,
  color: o ? g.colors.fadedText40 : g.colors.bodyText,
  display: i === LabelVisibilityOptions.Collapsed ? "none" : "flex",
  visibility: i === LabelVisibilityOptions.Hidden ? "hidden" : "visible",
  marginBottom: g.spacing.twoXS,
  height: "auto",
  minHeight: g.fontSizes.xl,
  verticalAlign: "middle",
  flexDirection: "row",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledWidgetLabelHelp = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn2"
} : {
  target: "e1y5xkzn2",
  label: "StyledWidgetLabelHelp"
})(process.env.NODE_ENV === "production" ? {
  name: "1h97c9v",
  styles: "display:flex;flex-direction:row;justify-content:flex-end;flex:1"
} : {
  name: "1h97c9v",
  styles: "display:flex;flex-direction:row;justify-content:flex-end;flex:1/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy93aWRnZXRzL0Jhc2VXaWRnZXQvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0NxQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvd2lkZ2V0cy9CYXNlV2lkZ2V0L3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmltcG9ydCB7IExhYmVsVmlzaWJpbGl0eU9wdGlvbnMgfSBmcm9tIFwifmxpYi91dGlsL3V0aWxzXCJcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRXaWRnZXRQcm9wcyB7XG4gIGRpc2FibGVkPzogYm9vbGVhbiB8IG51bGxcbiAgbGFiZWxWaXNpYmlsaXR5PzogTGFiZWxWaXNpYmlsaXR5T3B0aW9uc1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkV2lkZ2V0TGFiZWwgPSBzdHlsZWQubGFiZWw8U3R5bGVkV2lkZ2V0UHJvcHM+KFxuICAoeyBkaXNhYmxlZCwgbGFiZWxWaXNpYmlsaXR5LCB0aGVtZSB9KSA9PiAoe1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgY29sb3I6IGRpc2FibGVkID8gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwIDogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIGRpc3BsYXk6XG4gICAgICBsYWJlbFZpc2liaWxpdHkgPT09IExhYmVsVmlzaWJpbGl0eU9wdGlvbnMuQ29sbGFwc2VkID8gXCJub25lXCIgOiBcImZsZXhcIixcbiAgICB2aXNpYmlsaXR5OlxuICAgICAgbGFiZWxWaXNpYmlsaXR5ID09PSBMYWJlbFZpc2liaWxpdHlPcHRpb25zLkhpZGRlbiA/IFwiaGlkZGVuXCIgOiBcInZpc2libGVcIixcbiAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgaGVpZ2h0OiBcImF1dG9cIixcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLmZvbnRTaXplcy54bCxcbiAgICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgfSlcbilcblxuLyoqXG4gKiBAZGVwcmVjYXRlZCBQbGVhc2UgdXRpbGl6ZSBgV2lkZ2V0TGFiZWxIZWxwSWNvbmAgaW5zdGVhZCBvZiB1c2luZyB0aGlzXG4gKiBkaXJlY3RseSBpbiBvcmRlciB0byBzdXBwb3J0IGExMXkgYmVzdCBwcmFjdGljZXMgYW5kIGtlZXAgYmVoYXZpb3IgY29uc2lzdGVudFxuICogYWNyb3NzIHdpZGdldHMuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRXaWRnZXRMYWJlbEhlbHAgPSBzdHlsZWQuZGl2KHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImZsZXgtZW5kXCIsXG4gIGZsZXg6IDEsXG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkV2lkZ2V0SW5zdHJ1Y3Rpb25zID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgdGV4dEFsaWduOiBcInJpZ2h0XCIsXG4gIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gIGJvdHRvbTogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICByaWdodDogYGNhbGMoJHt0aGVtZS5mb250U2l6ZXMubWRMZ30gKiAwLjUpYCxcbn0pKVxuXG4vKipcbiAqIEBkZXByZWNhdGVkIFBsZWFzZSB1dGlsaXplIGBXaWRnZXRMYWJlbEhlbHBJY29uSW5saW5lYCBpbnN0ZWFkIG9mIHVzaW5nIHRoaXNcbiAqIGRpcmVjdGx5IGluIG9yZGVyIHRvIHN1cHBvcnQgYTExeSBiZXN0IHByYWN0aWNlcyBhbmQga2VlcCBiZWhhdmlvciBjb25zaXN0ZW50XG4gKiBhY3Jvc3Mgd2lkZ2V0cy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFdpZGdldExhYmVsSGVscElubGluZSA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcueHMsXG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcInJvd1wiLFxufSkpXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
}), StyledWidgetInstructions = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn1"
} : {
  target: "e1y5xkzn1",
  label: "StyledWidgetInstructions"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.twoSm,
  color: o.colors.fadedText60,
  margin: o.spacing.none,
  textAlign: "right",
  position: "absolute",
  bottom: o.spacing.threeXS,
  right: `calc(${o.fontSizes.mdLg} * 0.5)`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledWidgetLabelHelpInline = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn0"
} : {
  target: "e1y5xkzn0",
  label: "StyledWidgetLabelHelpInline"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.xs,
  position: "relative",
  display: "flex",
  flexDirection: "row"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function WidgetLabel({
  label: o,
  children: i,
  disabled: g,
  labelVisibility: E,
  htmlFor: e
}) {
  return isNullOrUndefined(o) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledWidgetLabel, { "data-testid": "stWidgetLabel", disabled: g, labelVisibility: E, htmlFor: e, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: o, allowHTML: !1, isLabel: !0 }) }),
    i
  ] });
}
function WidgetLabelHelpIcon({
  content: o,
  label: i,
  ariaLabel: g,
  placement: E = Placement.TOP_RIGHT,
  isLatex: e,
  markdownProps: t,
  onMouseEnterDelay: n,
  containerWidth: h
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWidgetLabelHelp, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: o, placement: E, isLatex: e, markdownProps: t, onMouseEnterDelay: n, containerWidth: h, ariaLabel: g ?? getHelpTooltipAriaLabel(i) }) });
}
const arrayComparator = (o, i) => o.length !== i.length ? !1 : o.every((g, E) => Object.is(g, i[E])), useExecuteWhenChanged = (o, i, g = arrayComparator) => {
  const [E, e] = useState(i);
  g(E, i) || (e(i), o());
};
var _excluded$i = ["title", "size", "color", "overrides"];
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$i.apply(this, arguments);
}
function _objectWithoutProperties$g(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$f(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$f(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _slicedToArray$e(o, i) {
  return _arrayWithHoles$d(o) || _iterableToArrayLimit$d(o, i) || _unsupportedIterableToArray$d(o, i) || _nonIterableRest$d();
}
function _nonIterableRest$d() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$d(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$d(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$d(o, i);
  }
}
function _arrayLikeToArray$d(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$d(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$d(o) {
  if (Array.isArray(o)) return o;
}
function ChevronDown(o, i) {
  var g = useStyletron(), E = _slicedToArray$e(g, 2), e = E[1], t = o.title, n = t === void 0 ? "Down" : t, h = o.size, d = o.color, k = o.overrides, p = k === void 0 ? {} : k, M = _objectWithoutProperties$g(o, _excluded$i), H = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.ChevronDown ? e.icons.ChevronDown : null
    },
    p && p.Svg ? toObjectOverride(p.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$i({
    viewBox: "0 0 24 24",
    ref: i,
    title: n,
    size: h,
    color: d,
    overrides: {
      Svg: H
    }
  }, M), /* @__PURE__ */ React.createElement("path", {
    transform: "rotate(270, 12, 12)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071L13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L11.4142 12L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12Z"
  }));
}
const ChevronDown$1 = /* @__PURE__ */ React.forwardRef(ChevronDown);
var _excluded$h = ["title", "size", "color", "overrides"];
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$h.apply(this, arguments);
}
function _objectWithoutProperties$f(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$e(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$e(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _slicedToArray$d(o, i) {
  return _arrayWithHoles$c(o) || _iterableToArrayLimit$c(o, i) || _unsupportedIterableToArray$c(o, i) || _nonIterableRest$c();
}
function _nonIterableRest$c() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$c(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$c(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$c(o, i);
  }
}
function _arrayLikeToArray$c(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$c(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$c(o) {
  if (Array.isArray(o)) return o;
}
function DeleteAlt(o, i) {
  var g = useStyletron(), E = _slicedToArray$d(g, 2), e = E[1], t = o.title, n = t === void 0 ? "Delete Alt" : t, h = o.size, d = o.color, k = o.overrides, p = k === void 0 ? {} : k, M = _objectWithoutProperties$f(o, _excluded$h), H = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.DeleteAlt ? e.icons.DeleteAlt : null
    },
    p && p.Svg ? toObjectOverride(p.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$h({
    viewBox: "0 0 24 24",
    ref: i,
    title: n,
    size: h,
    color: d,
    overrides: {
      Svg: H
    }
  }, M), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58173 16.4183 4 12 4C7.58173 4 4 7.58173 4 12C4 16.4183 7.58173 20 12 20ZM10.0303 8.96967C9.73743 8.67679 9.26257 8.67679 8.96967 8.96967C8.67676 9.26257 8.67676 9.73743 8.96967 10.0303L10.9393 12L8.96967 13.9697C8.67676 14.2626 8.67676 14.7374 8.96967 15.0303C9.26257 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L13.0607 12L15.0303 10.0303C15.3232 9.73743 15.3232 9.26257 15.0303 8.96967C14.7374 8.67679 14.2626 8.67679 13.9697 8.96967L12 10.9393L10.0303 8.96967Z"
  }));
}
const DeleteAlt$1 = /* @__PURE__ */ React.forwardRef(DeleteAlt);
var _excluded$g = ["title", "size", "color", "overrides"];
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$g.apply(this, arguments);
}
function _objectWithoutProperties$e(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$d(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$d(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _slicedToArray$c(o, i) {
  return _arrayWithHoles$b(o) || _iterableToArrayLimit$b(o, i) || _unsupportedIterableToArray$b(o, i) || _nonIterableRest$b();
}
function _nonIterableRest$b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$b(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$b(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$b(o, i);
  }
}
function _arrayLikeToArray$b(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$b(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$b(o) {
  if (Array.isArray(o)) return o;
}
function Search(o, i) {
  var g = useStyletron(), E = _slicedToArray$c(g, 2), e = E[1], t = o.title, n = t === void 0 ? "Search" : t, h = o.size, d = o.color, k = o.overrides, p = k === void 0 ? {} : k, M = _objectWithoutProperties$e(o, _excluded$g), H = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.Search ? e.icons.Search : null
    },
    p && p.Svg ? toObjectOverride(p.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$g({
    viewBox: "0 0 24 24",
    ref: i,
    title: n,
    size: h,
    color: d,
    overrides: {
      Svg: H
    }
  }, M), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C8.79086 6 7 7.79086 7 10C7 12.2091 8.79086 14 11 14C13.2091 14 15 12.2091 15 10C15 7.79086 13.2091 6 11 6ZM5 10C5 6.68629 7.68629 4 11 4C14.3137 4 17 6.68629 17 10C17 11.2958 16.5892 12.4957 15.8907 13.4765L19.7071 17.2929C20.0976 17.6834 20.0976 18.3166 19.7071 18.7071C19.3166 19.0976 18.6834 19.0976 18.2929 18.7071L14.4765 14.8907C13.4957 15.5892 12.2958 16 11 16C7.68629 16 5 13.3137 5 10Z"
  }));
}
const SearchIconComponent = /* @__PURE__ */ React.forwardRef(Search);
var _excluded$f = ["title", "size", "color", "overrides"];
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$f.apply(this, arguments);
}
function _objectWithoutProperties$d(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$c(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$c(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _slicedToArray$b(o, i) {
  return _arrayWithHoles$a(o) || _iterableToArrayLimit$a(o, i) || _unsupportedIterableToArray$a(o, i) || _nonIterableRest$a();
}
function _nonIterableRest$a() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$a(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$a(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$a(o, i);
  }
}
function _arrayLikeToArray$a(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$a(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$a(o) {
  if (Array.isArray(o)) return o;
}
function TriangleDown(o, i) {
  var g = useStyletron(), E = _slicedToArray$b(g, 2), e = E[1], t = o.title, n = t === void 0 ? "Triangle Down" : t, h = o.size, d = o.color, k = o.overrides, p = k === void 0 ? {} : k, M = _objectWithoutProperties$d(o, _excluded$f), H = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.TriangleDown ? e.icons.TriangleDown : null
    },
    p && p.Svg ? toObjectOverride(p.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$f({
    viewBox: "0 0 24 24",
    ref: i,
    title: n,
    size: h,
    color: d,
    overrides: {
      Svg: H
    }
  }, M), /* @__PURE__ */ React.createElement("path", {
    d: "M12.7071 15.2929L17.1464 10.8536C17.4614 10.5386 17.2383 10 16.7929 10L7.20711 10C6.76165 10 6.53857 10.5386 6.85355 10.8536L11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929Z"
  }));
}
const TriangleDownIcon = /* @__PURE__ */ React.forwardRef(TriangleDown);
var CUSTOM_INPUT_TYPE = {
  textarea: "textarea"
}, ADJOINED = {
  none: "none",
  left: "left",
  right: "right",
  both: "both"
}, SIZE$1 = {
  mini: "mini",
  default: "default",
  compact: "compact",
  large: "large"
}, ENHANCER_POSITION = {
  start: "start",
  end: "end"
}, TYPE = {
  select: "select",
  search: "search"
}, STATE_CHANGE_TYPE = Object.freeze({
  select: "select",
  remove: "remove",
  clear: "clear"
}), STATE_CHANGE_TYPES = {
  click: "click",
  moveUp: "moveUp",
  moveDown: "moveDown",
  mouseEnter: "mouseEnter",
  focus: "focus",
  reset: "reset",
  character: "character",
  enter: "enter"
}, KEY_STRINGS = {
  ArrowUp: "ArrowUp",
  ArrowDown: "ArrowDown",
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
  Enter: "Enter",
  Home: "Home",
  End: "End"
}, OPTION_LIST_SIZE = {
  default: "default",
  compact: "compact"
}, _excluded$e = ["item"];
function _objectWithoutProperties$c(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$b(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$b(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function ownKeys$c(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$a(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$c(Object(g), !0).forEach(function(E) {
      _defineProperty$d(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$c(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$d(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var StyledList = styled("ul", function(o) {
  var i = o.$theme, g = o.$isFocusVisible;
  return {
    backgroundColor: i.colors.menuFill,
    position: "relative",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: i.sizing.scale300,
    paddingBottom: i.sizing.scale300,
    paddingLeft: 0,
    paddingRight: 0,
    borderTopLeftRadius: i.borders.popoverBorderRadius,
    borderTopRightRadius: i.borders.popoverBorderRadius,
    borderBottomRightRadius: i.borders.popoverBorderRadius,
    borderBottomLeftRadius: i.borders.popoverBorderRadius,
    boxShadow: i.lighting.shadow600,
    overflow: "auto",
    ":focus": {
      outline: g ? "3px solid ".concat(i.colors.accent) : "none"
    }
  };
});
StyledList.displayName = "StyledList";
StyledList.displayName = "StyledList";
function getFontColor(o) {
  return o.$disabled ? o.$theme.colors.menuFontDisabled : o.$isHighlighted && o.$isFocused ? o.$theme.colors.menuFontHighlighted : o.$isHighlighted && !o.$isFocused ? o.$theme.colors.menuFontSelected : o.$theme.colors.menuFontDefault;
}
function getBackgroundColor(o) {
  return o.$disabled ? "transparent" : o.$isHighlighted ? o.$theme.colors.menuFillHover : "transparent";
}
var StyledEmptyState = styled("li", function(o) {
  var i = o.$theme, g = o.$size;
  return _objectSpread$a(_objectSpread$a({}, g === OPTION_LIST_SIZE.compact ? i.typography.font100 : i.typography.font200), {}, {
    position: "relative",
    display: "block",
    color: i.colors.menuFontDisabled,
    textAlign: "center",
    cursor: "not-allowed",
    backgroundColor: "transparent",
    marginBottom: 0,
    paddingTop: i.sizing.scale800,
    paddingBottom: i.sizing.scale800,
    paddingRight: i.sizing.scale800,
    paddingLeft: i.sizing.scale800
  });
});
StyledEmptyState.displayName = "StyledEmptyState";
StyledEmptyState.displayName = "StyledEmptyState";
var StyledOptgroupHeader = styled("li", function(o) {
  var i = o.$theme.sizing.scale300, g = o.$theme.sizing.scale200;
  return _objectSpread$a(_objectSpread$a({}, o.$theme.typography.font250), {}, {
    color: o.$theme.colors.contentPrimary,
    paddingTop: g,
    paddingBottom: g,
    paddingRight: i,
    paddingLeft: i
  });
});
StyledOptgroupHeader.displayName = "StyledOptgroupHeader";
StyledOptgroupHeader.displayName = "StyledOptgroupHeader";
var StyledListItemAnchor = styled("a", function(o) {
  return {
    display: "block",
    color: getFontColor(o)
  };
});
StyledListItemAnchor.displayName = "StyledListItemAnchor";
StyledListItemAnchor.displayName = "StyledListItemAnchor";
var StyledListItemElement = styled("li", function(o) {
  var i = o.$disabled, g = o.$theme, E = o.$size;
  return _objectSpread$a(_objectSpread$a({}, E === OPTION_LIST_SIZE.compact ? g.typography.font100 : g.typography.font200), {}, {
    boxSizing: "border-box",
    position: "relative",
    display: "block",
    color: getFontColor(o),
    cursor: i ? "not-allowed" : "pointer",
    backgroundColor: getBackgroundColor(o),
    transitionProperty: "color, background-color",
    transitionDuration: g.animation.timing200,
    transitionTimingFunction: g.animation.easeOutCurve,
    marginBottom: 0,
    paddingTop: E === OPTION_LIST_SIZE.compact ? g.sizing.scale100 : g.sizing.scale300,
    paddingBottom: E === OPTION_LIST_SIZE.compact ? g.sizing.scale100 : g.sizing.scale300,
    paddingRight: E === OPTION_LIST_SIZE.compact ? g.sizing.scale900 : g.sizing.scale600,
    paddingLeft: E === OPTION_LIST_SIZE.compact ? g.sizing.scale900 : g.sizing.scale600,
    ":focus": {
      outline: "none"
    }
  });
});
StyledListItemElement.displayName = "StyledListItemElement";
StyledListItemElement.displayName = "StyledListItemElement";
var StyledListItem = withWrapper(StyledListItemElement, function(o) {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (function(g) {
      g.item;
      var E = _objectWithoutProperties$c(g, _excluded$e);
      return /* @__PURE__ */ React.createElement(o, E);
    })
  );
}), StyledListItemProfile = styled("li", function(o) {
  var i = o.$theme;
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: i.sizing.scale300,
    paddingBottom: i.sizing.scale300,
    paddingRight: i.sizing.scale800,
    paddingLeft: i.sizing.scale800,
    transitionProperty: "color, background-color",
    transitionDuration: i.animation.timing200,
    transitionTimingFunction: i.animation.easeOutCurve,
    ":hover": {
      backgroundColor: i.colors.menuFillHover
    }
  };
});
StyledListItemProfile.displayName = "StyledListItemProfile";
StyledListItemProfile.displayName = "StyledListItemProfile";
var StyledProfileImgContainer = styled("div", {
  width: "60px",
  height: "60px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
StyledProfileImgContainer.displayName = "StyledProfileImgContainer";
StyledProfileImgContainer.displayName = "StyledProfileImgContainer";
var StyledProfileImg = styled("img", {
  width: "100%",
  height: "100%",
  borderTopLeftRadius: "50%",
  borderTopRightRadius: "50%",
  borderBottomRightRadius: "50%",
  borderBottomLeftRadius: "50%"
});
StyledProfileImg.displayName = "StyledProfileImg";
StyledProfileImg.displayName = "StyledProfileImg";
var StyledProfileLabelsContainer = styled("div", function(o) {
  var i = o.$theme, g = i.direction, E = i.sizing;
  return _objectSpread$a({
    alignSelf: g === "rtl" ? "flex-end" : "flex-start",
    display: "flex",
    flexDirection: "column"
  }, g === "rtl" ? {
    marginRight: E.scale600
  } : {
    marginLeft: E.scale600
  });
});
StyledProfileLabelsContainer.displayName = "StyledProfileLabelsContainer";
StyledProfileLabelsContainer.displayName = "StyledProfileLabelsContainer";
var StyledProfileTitle = styled("h6", function(o) {
  var i = o.$theme;
  return _objectSpread$a(_objectSpread$a({}, i.typography.font350), {}, {
    color: i.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileTitle.displayName = "StyledProfileTitle";
StyledProfileTitle.displayName = "StyledProfileTitle";
var StyledProfileSubtitle = styled("p", function(o) {
  var i = o.$theme;
  return _objectSpread$a(_objectSpread$a({}, i.typography.font200), {}, {
    color: i.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileSubtitle.displayName = "StyledProfileSubtitle";
StyledProfileSubtitle.displayName = "StyledProfileSubtitle";
var StyledProfileBody = styled("p", function(o) {
  var i = o.$theme;
  return _objectSpread$a(_objectSpread$a({}, i.typography.font100), {}, {
    color: i.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileBody.displayName = "StyledProfileBody";
StyledProfileBody.displayName = "StyledProfileBody";
var StyledMenuDivider$1 = styled("li", function(o) {
  var i = o.$theme;
  return {
    color: i.colors.contentPrimary,
    borderBottomWidth: i.borders.border300.borderWidth,
    borderBottomStyle: i.borders.border300.borderStyle,
    borderBottomColor: i.borders.border300.borderColor,
    marginTop: i.sizing.scale100,
    marginBottom: i.sizing.scale100,
    marginLeft: i.sizing.scale500,
    marginRight: i.sizing.scale500,
    listStyle: "none",
    height: 0
  };
});
StyledMenuDivider$1.displayName = "StyledMenuDivider";
StyledProfileBody.displayName = "StyledMenuDivider";
var NestedMenuContext = /* @__PURE__ */ React.createContext({
  addMenuToNesting: function o() {
  },
  removeMenuFromNesting: function o() {
  },
  // @ts-expect-error todo(flow->ts): incorrect default value
  getParentMenu: function o() {
  },
  // @ts-expect-error todo(flow->ts): incorrect default value
  getChildMenu: function o() {
  },
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function o() {
    return !1;
  },
  mountRef: {
    current: null
  }
});
function _extends$e() {
  return _extends$e = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$e.apply(this, arguments);
}
function _slicedToArray$a(o, i) {
  return _arrayWithHoles$9(o) || _iterableToArrayLimit$9(o, i) || _unsupportedIterableToArray$9(o, i) || _nonIterableRest$9();
}
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$9(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$9(o, i);
  }
}
function _arrayLikeToArray$9(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$9(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$9(o) {
  if (Array.isArray(o)) return o;
}
var MaybeChildMenu = function o(i) {
  if (!i.getChildMenu)
    return i.children;
  var g = i.getChildMenu(i.item);
  if (!g)
    return i.children;
  var E = i.overrides, e = E === void 0 ? {} : E, t = getOverrides(e.ChildMenuPopover, Popover$2), n = _slicedToArray$a(t, 2), h = n[0], d = n[1];
  return /* @__PURE__ */ React.createElement(NestedMenuContext.Consumer, null, function(k) {
    return /* @__PURE__ */ React.createElement(h, _extends$e({
      focusLock: !1,
      autoFocus: !1,
      isOpen: i.isOpen,
      renderAll: i.renderAll,
      content: g,
      ignoreBoundary: !0,
      mountNode: k.mountRef.current ? k.mountRef.current : void 0,
      onClick: i.onClick,
      onMouseEnterDelay: 30,
      onMouseLeaveDelay: 30,
      onEsc: i.resetParentMenu,
      placement: "rightTop"
    }, d, {
      overrides: mergeOverrides({
        Body: {
          props: {
            // Trap tabbing when focused on a child menu. Popover mounts the element at the end of
            // the html body by default. If a user was to tab to the next element it would navigate
            // to elements not within the immediate area surrounding the menu.
            onKeyDown: function(M) {
              M.keyCode === 9 && M.preventDefault();
            }
          }
        }
      }, d.overrides)
    }), i.children);
  });
}, _excluded$d = ["getChildMenu", "getItemLabel", "item", "onClick", "onMouseEnter", "overrides", "renderHrefAsAnchor", "resetMenu", "size", "$isHighlighted", "renderAll"];
function ownKeys$b(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$9(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$b(Object(g), !0).forEach(function(E) {
      _defineProperty$c(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$b(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$c(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$d.apply(this, arguments);
}
function _slicedToArray$9(o, i) {
  return _arrayWithHoles$8(o) || _iterableToArrayLimit$8(o, i) || _unsupportedIterableToArray$8(o, i) || _nonIterableRest$8();
}
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$8(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$8(o, i);
  }
}
function _arrayLikeToArray$8(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$8(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$8(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$b(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$a(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$a(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function OptionList(o, i) {
  var g = o.getChildMenu, E = o.getItemLabel, e = E === void 0 ? function(rA) {
    return rA ? rA.label : "";
  } : E, t = o.item, n = o.onClick, h = n === void 0 ? function() {
  } : n, d = o.onMouseEnter, k = d === void 0 ? function() {
  } : d, p = o.overrides, M = p === void 0 ? {} : p, H = o.renderHrefAsAnchor, f = H === void 0 ? !0 : H, AA = o.resetMenu, gA = AA === void 0 ? function() {
  } : AA, IA = o.size, BA = IA === void 0 ? OPTION_LIST_SIZE.default : IA, CA = o.$isHighlighted, QA = o.renderAll, iA = _objectWithoutProperties$b(o, _excluded$d), EA = getOverrides(M.ListItem, StyledListItem), oA = _slicedToArray$9(EA, 2), eA = oA[0], GA = oA[1], cA = getOverrides(M.ListItemAnchor, StyledListItemAnchor), tA = _slicedToArray$9(cA, 2), aA = tA[0], sA = tA[1], DA = function(nA) {
    return nA.href && f ? /* @__PURE__ */ React.createElement(aA, _extends$d({
      $item: nA,
      href: nA.href
    }, sA), e(nA)) : /* @__PURE__ */ React.createElement(React.Fragment, null, e(nA));
  };
  return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(rA) {
    return /* @__PURE__ */ React.createElement(MaybeChildMenu, {
      getChildMenu: g,
      isOpen: !!CA,
      item: t,
      resetParentMenu: gA,
      renderAll: QA,
      onClick: h,
      overrides: M
    }, /* @__PURE__ */ React.createElement(eA, _extends$d({
      ref: i,
      "aria-label": g && g(t) ? rA.menu.parentMenuItemAriaLabel : null,
      item: t,
      onClick: h,
      onMouseEnter: k,
      $size: BA,
      $isHighlighted: CA
    }, iA, GA), DA(_objectSpread$9({
      isHighlighted: CA
    }, t))));
  });
}
function areEqualShallow(o, i) {
  if (!o || !i) return !1;
  for (var g in o)
    if (o[g] !== i[g])
      return !1;
  return !0;
}
function compare(o, i) {
  return o.$isHighlighted === i.$isHighlighted && o.$isFocused === i.$isFocused && areEqualShallow(o.item, i.item) && areEqualShallow(o.overrides, i.overrides) && o.size === i.size && o.getItemLabel === i.getItemLabel && o.getChildMenu === i.getChildMenu && o.resetMenu === i.resetMenu;
}
var forwarded = /* @__PURE__ */ React.forwardRef(OptionList);
forwarded.displayName = "OptionList";
const OptionList$1 = /* @__PURE__ */ React.memo(forwarded, compare);
var _excluded$c = ["disabled", "isFocused", "isHighlighted", "resetMenu"];
function _objectWithoutProperties$a(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$9(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$9(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$c.apply(this, arguments);
}
function _slicedToArray$8(o, i) {
  return _arrayWithHoles$7(o) || _iterableToArrayLimit$7(o, i) || _unsupportedIterableToArray$7(o, i) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$7(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$7(o, i);
  }
}
function _arrayLikeToArray$7(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$7(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$7(o) {
  if (Array.isArray(o)) return o;
}
function Menu(o) {
  var i = o.overrides, g = i === void 0 ? {} : i, E = o["aria-label"], e = E === void 0 ? "Menu" : E, t = o.rootRef, n = t === void 0 ? /* @__PURE__ */ React.createRef() : t, h = o.focusMenu, d = h === void 0 ? function() {
  } : h, k = o.unfocusMenu, p = k === void 0 ? function() {
  } : k, M = o.handleMouseLeave, H = M === void 0 ? function() {
  } : M, f = o.handleKeyDown, AA = f === void 0 ? function(gg) {
  } : f, gA = o.renderAll, IA = gA === void 0 ? !1 : gA, BA = React.useState(!1), CA = _slicedToArray$8(BA, 2), QA = CA[0], iA = CA[1], EA = function(WA) {
    isFocusVisible(WA) && iA(!0);
  }, oA = function(WA) {
    QA !== !1 && iA(!1);
  }, eA = getOverrides(g.List, StyledList), GA = _slicedToArray$8(eA, 2), cA = GA[0], tA = GA[1], aA = getOverrides(g.Option, OptionList$1), sA = _slicedToArray$8(aA, 2), DA = sA[0], rA = sA[1], nA = getOverrides(g.EmptyState, StyledEmptyState), NA = _slicedToArray$8(nA, 2), pA = NA[0], mA = NA[1], XA = getOverrides(g.OptgroupHeader, StyledOptgroupHeader), lA = _slicedToArray$8(XA, 2), kA = lA[0], ZA = lA[1], wA = getOverrides(g.MenuDivider, StyledMenuDivider$1), LA = _slicedToArray$8(wA, 2), fA = LA[0], dA = LA[1], RA = Array.isArray(o.items) ? {
    __ungrouped: o.items
  } : o.items, KA = Object.keys(RA), xA = KA.reduce(function(gg, WA) {
    var eg = _slicedToArray$8(gg, 2), ig = eg[0], $A = eg[1];
    WA !== "__ungrouped" && ig.push(/* @__PURE__ */ React.createElement(kA, _extends$c({
      key: WA
    }, ZA), WA));
    var ag = RA[WA].map(function(Ig, tg) {
      $A = $A + 1;
      var wg = o.getRequiredItemProps, hg = wg === void 0 ? function(PA, qA) {
        return {};
      } : wg;
      if (Ig.divider === !0)
        return /* @__PURE__ */ React.createElement(fA, dA);
      var Gg = hg(Ig, $A), Ng = Gg.disabled, Bg = Gg.isFocused, bA = Gg.isHighlighted, HA = Gg.resetMenu, vA = HA === void 0 ? function() {
      } : HA, zA = _objectWithoutProperties$a(Gg, _excluded$c);
      return /* @__PURE__ */ React.createElement(DA, _extends$c({
        renderAll: IA,
        key: $A,
        item: Ig,
        overrides: o.overrides,
        resetMenu: vA,
        role: "option",
        $disabled: Ng,
        $isFocused: Bg,
        $isHighlighted: bA,
        "aria-disabled": Ng,
        "aria-selected": bA && Bg
      }, zA, rA));
    });
    return [ig.concat(ag), $A];
  }, [[], -1]), MA = _slicedToArray$8(xA, 1), OA = MA[0], SA = KA.every(function(gg) {
    return !RA[gg].length;
  });
  return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(gg) {
    return /* @__PURE__ */ React.createElement(cA, _extends$c({
      "aria-activedescendant": o.activedescendantId || null,
      role: "listbox",
      "aria-label": e,
      ref: n,
      onMouseEnter: d,
      onMouseLeave: H,
      onMouseOver: d,
      onFocus: forkFocus({
        onFocus: d
      }, EA),
      onBlur: forkBlur({
        onBlur: p
      }, oA),
      onKeyDown: function(eg) {
        o.isFocused && AA(eg);
      },
      tabIndex: 0,
      "data-baseweb": "menu",
      $isFocusVisible: QA
    }, tA), SA ? /* @__PURE__ */ React.createElement(pA, _extends$c({
      "aria-live": "polite",
      "aria-atomic": !0
    }, mA), o.noResultsMsg || gg.menu.noResultsMsg) : OA);
  });
}
function scrollItemIntoView(o, i, g, E) {
  var e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "auto";
  if (o) {
    var t = o.getBoundingClientRect(), n = i.getBoundingClientRect();
    if (t.bottom > n.bottom)
      if (E)
        i.scrollTop = i.scrollHeight - n.height;
      else {
        var h = o.offsetTop + t.height;
        i.scrollTop = h - (e === "center" ? Math.round((n.height + t.height) / 2) : n.height);
      }
    else t.top < n.top && (g ? i.scrollTop = 0 : i.scrollTop = o.offsetTop - (e === "center" ? Math.round((n.height - t.height) / 2) : 0));
  }
}
function _typeof$7(o) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$7(o);
}
var _excluded$b = ["disabled"], _excluded2$3 = ["initialState", "stateReducer", "children", "onItemSelect", "addMenuToNesting", "removeMenuFromNesting", "getParentMenu", "getChildMenu", "forceHighlight"];
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$b.apply(this, arguments);
}
function _objectWithoutProperties$9(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$8(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$8(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function ownKeys$a(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$8(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$a(Object(g), !0).forEach(function(E) {
      _defineProperty$b(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$a(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _classCallCheck$5(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$5(o, i, g) {
  return i && _defineProperties$5(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$5(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$5(o, i);
}
function _setPrototypeOf$5(o, i) {
  return _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$5(o, i);
}
function _createSuper$5(o) {
  var i = _isNativeReflectConstruct$5();
  return function() {
    var E = _getPrototypeOf$5(o), e;
    if (i) {
      var t = _getPrototypeOf$5(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$5(this, e);
  };
}
function _possibleConstructorReturn$5(o, i) {
  if (i && (_typeof$7(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$6(o);
}
function _assertThisInitialized$6(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$5(o) {
  return _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$5(o);
}
function _defineProperty$b(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var DEFAULT_PROPS = {
  // keeping it in defaultProps to satisfy Flow
  initialState: {
    // We start the index at -1 to indicate that no highlighting exists initially
    highlightedIndex: -1,
    isFocused: !1
  },
  typeAhead: !0,
  keyboardControlNode: {
    current: null
  },
  stateReducer: function(o, i) {
    return i;
  },
  onItemSelect: function o() {
  },
  getRequiredItemProps: function o() {
    return {};
  },
  children: function o() {
    return null;
  },
  // from nested-menus context
  addMenuToNesting: function o() {
  },
  removeMenuFromNesting: function o() {
  },
  getParentMenu: function o() {
  },
  getChildMenu: function o() {
  },
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function o() {
    return !1;
  },
  forceHighlight: !1
}, MenuStatefulContainerInner = /* @__PURE__ */ (function(o) {
  _inherits$5(g, o);
  var i = _createSuper$5(g);
  function g() {
    var E;
    _classCallCheck$5(this, g);
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = i.call.apply(i, [this].concat(t)), _defineProperty$b(_assertThisInitialized$6(E), "state", _objectSpread$8(_objectSpread$8({}, E.constructor.defaultProps.initialState), E.props.initialState)), _defineProperty$b(_assertThisInitialized$6(E), "rootRef", /* @__PURE__ */ React.createRef()), _defineProperty$b(_assertThisInitialized$6(E), "keyboardControlNode", E.props.keyboardControlNode.current), _defineProperty$b(_assertThisInitialized$6(E), "refList", []), _defineProperty$b(_assertThisInitialized$6(E), "optionIds", []), _defineProperty$b(_assertThisInitialized$6(E), "typeAheadChars", ""), _defineProperty$b(_assertThisInitialized$6(E), "typeAheadTimeOut", null), _defineProperty$b(_assertThisInitialized$6(E), "onKeyDown", function(h) {
      switch (h.key) {
        case KEY_STRINGS.ArrowUp:
        case KEY_STRINGS.ArrowDown:
        case KEY_STRINGS.ArrowLeft:
        case KEY_STRINGS.ArrowRight:
        case KEY_STRINGS.Home:
        case KEY_STRINGS.End:
          E.handleArrowKey(h);
          break;
        case KEY_STRINGS.Enter:
          if (h.keyCode === 229)
            break;
          E.handleEnterKey(h);
          break;
        default:
          E.props.typeAhead && (clearTimeout(E.typeAheadTimeOut), E.handleAlphaDown(h));
          break;
      }
    }), _defineProperty$b(_assertThisInitialized$6(E), "handleAlphaDown", function(h) {
      var d = E.props.rootRef ? E.props.rootRef : E.rootRef, k = E.state.highlightedIndex;
      E.typeAheadChars += h.key, E.typeAheadTimeOut = setTimeout(function() {
        E.typeAheadChars = "";
      }, 500);
      var p = k, M = E.getItems();
      if (!(M.length === 0 || !("label" in M[0]))) {
        for (var H = !0, f = 0; f < M.length; f++) {
          var AA = M[f].label;
          if (AA && AA.toUpperCase && AA.toUpperCase().indexOf(E.typeAheadChars.toUpperCase()) === 0) {
            p = f, H = !1;
            break;
          }
        }
        if (H)
          for (var gA = 0; gA < M.length; gA++) {
            var IA = M[gA].label;
            if (IA && IA.toUpperCase && IA.toUpperCase().indexOf(E.typeAheadChars.toUpperCase()) > 0) {
              p = gA;
              break;
            }
          }
        E.internalSetState(STATE_CHANGE_TYPES.character, {
          highlightedIndex: p
        }), E.refList[p] && scrollItemIntoView(E.refList[p].current, d.current, p === 0, p === M.length - 1);
      }
    }), _defineProperty$b(_assertThisInitialized$6(E), "handleArrowKey", function(h) {
      var d = E.props.rootRef ? E.props.rootRef : E.rootRef, k = E.state.highlightedIndex, p = k;
      if (h.key === KEY_STRINGS.ArrowUp)
        h.preventDefault(), p = Math.max(0, k - 1), E.internalSetState(STATE_CHANGE_TYPES.moveUp, {
          highlightedIndex: p
        });
      else if (h.key === KEY_STRINGS.ArrowDown)
        h.preventDefault(), p = Math.min(k + 1, E.getItems().length - 1), E.internalSetState(STATE_CHANGE_TYPES.moveDown, {
          highlightedIndex: p
        });
      else if (h.key === KEY_STRINGS.Home)
        h.preventDefault(), p = 0, E.internalSetState(STATE_CHANGE_TYPES.moveUp, {
          highlightedIndex: p
        });
      else if (h.key === KEY_STRINGS.End)
        h.preventDefault(), p = E.getItems().length - 1, E.internalSetState(STATE_CHANGE_TYPES.moveDown, {
          highlightedIndex: p
        });
      else if (h.key === KEY_STRINGS.ArrowLeft) {
        if (E.props.getParentMenu) {
          var M = E.props.getParentMenu(d);
          M && M.current && M.current.focus();
        }
      } else if (h.key === KEY_STRINGS.ArrowRight && E.props.getChildMenu) {
        var H = E.props.getChildMenu(d);
        H && H.current && H.current.focus();
      }
      E.refList[p] && scrollItemIntoView(E.refList[p].current, d.current, p === 0, p === E.getItems().length - 1);
    }), _defineProperty$b(_assertThisInitialized$6(E), "handleEnterKey", function(h) {
      var d = E.props.onItemSelect, k = E.state.highlightedIndex, p = E.getItems();
      p[k] && d && !p[k].disabled && (h.preventDefault(), d({
        item: p[k],
        event: h
      }));
    }), _defineProperty$b(_assertThisInitialized$6(E), "handleItemClick", function(h, d, k) {
      E.props.onItemSelect && !d.disabled && (E.props.onItemSelect({
        item: d,
        event: k
      }), E.internalSetState(STATE_CHANGE_TYPES.click, {
        highlightedIndex: h,
        activedescendantId: E.optionIds[h]
      }));
    }), _defineProperty$b(_assertThisInitialized$6(E), "handleMouseEnter", function(h) {
      E.internalSetState(STATE_CHANGE_TYPES.mouseEnter, {
        highlightedIndex: h,
        activedescendantId: E.optionIds[h]
      });
    }), _defineProperty$b(_assertThisInitialized$6(E), "handleMouseLeave", function(h) {
    }), _defineProperty$b(_assertThisInitialized$6(E), "getRequiredItemProps", function(h, d) {
      var k = E.refList[d];
      k || (k = /* @__PURE__ */ React.createRef(), E.refList[d] = k, E.optionIds[d] = E.props.uidSeed(d));
      var p = E.props.getRequiredItemProps(h, d), M = p.disabled, H = _objectWithoutProperties$9(p, _excluded$b), f = typeof M == "boolean" ? M : !!h.disabled;
      return _objectSpread$8(_objectSpread$8({
        id: H.id || E.optionIds[d],
        disabled: f,
        ref: k,
        isFocused: E.state.isFocused,
        isHighlighted: E.state.highlightedIndex === d,
        resetMenu: E.resetMenu
      }, f ? {} : {
        onClick: E.handleItemClick.bind(_assertThisInitialized$6(E), d, h),
        onMouseEnter: E.handleMouseEnter.bind(_assertThisInitialized$6(E), d)
      }), H);
    }), _defineProperty$b(_assertThisInitialized$6(E), "focusMenu", function(h) {
      var d = E.props.rootRef ? E.props.rootRef : E.rootRef;
      !E.state.isFocused && d.current && // @ts-expect-error
      d.current.contains(h.target) && (E.state.highlightedIndex < 0 ? E.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !0,
        highlightedIndex: 0
      }) : E.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !0
      }), d.current.focus());
    }), _defineProperty$b(_assertThisInitialized$6(E), "unfocusMenu", function() {
      E.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !1
      });
    }), _defineProperty$b(_assertThisInitialized$6(E), "resetMenu", function() {
      E.internalSetState(STATE_CHANGE_TYPES.reset, {
        isFocused: !1,
        highlightedIndex: -1,
        activedescendantId: null
      });
    }), E;
  }
  return _createClass$5(g, [{
    key: "getItems",
    value: function() {
      var e = this;
      if (Array.isArray(this.props.items))
        return this.props.items;
      var t = Object.keys(this.props.items);
      return t.reduce(function(n, h) {
        return n.concat(e.props.items[h]);
      }, []);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var e = this.props.rootRef ? this.props.rootRef : this.rootRef;
      typeof document < "u" && (e.current && this.state.highlightedIndex > -1 && this.refList[this.state.highlightedIndex] && scrollItemIntoView(this.refList[this.state.highlightedIndex].current, e.current, this.state.highlightedIndex === 0, this.state.highlightedIndex === this.getItems().length - 1, "center"), this.state.isFocused && this.keyboardControlNode && this.keyboardControlNode.addEventListener("keydown", this.onKeyDown)), this.props.addMenuToNesting && this.props.addMenuToNesting(e);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var e = this.props.rootRef ? this.props.rootRef : this.rootRef;
      typeof document < "u" && this.keyboardControlNode && this.keyboardControlNode.removeEventListener("keydown", this.onKeyDown), this.props.removeMenuFromNesting && this.props.removeMenuFromNesting(e);
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      typeof document < "u" && (!t.isFocused && this.state.isFocused ? this.keyboardControlNode && this.keyboardControlNode.addEventListener("keydown", this.onKeyDown) : t.isFocused && !this.state.isFocused && this.keyboardControlNode && this.keyboardControlNode.removeEventListener("keydown", this.onKeyDown));
      var n = this.getItems().length;
      this.props.forceHighlight && this.state.highlightedIndex === -1 && n > 0 && this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: 0
      }), n === 0 && this.state.highlightedIndex !== -1 ? this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: -1
      }) : this.state.highlightedIndex >= n && this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: 0
      }), this.props.isNestedMenuVisible && this.props.nestedMenuHoverIndex !== e.nestedMenuHoverIndex && !this.props.isNestedMenuVisible(this.rootRef) && !this.props.forceHighlight && this.setState({
        highlightedIndex: -1
      });
    }
    // One array to hold all list item refs
  }, {
    key: "internalSetState",
    value: (
      // Internal set state function that will also invoke stateReducer
      function(e, t) {
        var n = this.props.stateReducer;
        this.props.onActiveDescendantChange && typeof t.highlightedIndex == "number" && this.state.highlightedIndex !== t.highlightedIndex && this.props.onActiveDescendantChange(this.optionIds[t.highlightedIndex]), this.setState(n(e, t, this.state));
      }
    )
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.props;
      t.initialState, t.stateReducer, t.children, t.onItemSelect, t.addMenuToNesting, t.removeMenuFromNesting, t.getParentMenu, t.getChildMenu, t.forceHighlight;
      var n = _objectWithoutProperties$9(t, _excluded2$3);
      return this.props.children(_objectSpread$8(_objectSpread$8({}, n), {}, {
        rootRef: this.props.rootRef ? this.props.rootRef : this.rootRef,
        activedescendantId: this.optionIds[this.state.highlightedIndex],
        getRequiredItemProps: function(d, k) {
          return e.getRequiredItemProps(d, k);
        },
        handleMouseLeave: this.handleMouseLeave,
        highlightedIndex: this.state.highlightedIndex,
        isFocused: this.state.isFocused,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        handleKeyDown: this.props.keyboardControlNode.current ? function(h) {
        } : this.onKeyDown,
        focusMenu: this.focusMenu,
        unfocusMenu: this.unfocusMenu
      }));
    }
  }]), g;
})(React.Component);
_defineProperty$b(MenuStatefulContainerInner, "defaultProps", DEFAULT_PROPS);
var MenuStatefulContainer = function o(i) {
  return /* @__PURE__ */ React.createElement(MenuStatefulContainerInner, _extends$b({
    uidSeed: useUIDSeed()
  }, i));
};
MenuStatefulContainer.defaultProps = DEFAULT_PROPS;
function _typeof$6(o) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$6(o);
}
var _excluded$a = ["overrides"];
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$a.apply(this, arguments);
}
function _objectWithoutProperties$8(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$7(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$7(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _classCallCheck$4(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$4(o, i, g) {
  return i && _defineProperties$4(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$4(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$4(o, i);
}
function _setPrototypeOf$4(o, i) {
  return _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$4(o, i);
}
function _createSuper$4(o) {
  var i = _isNativeReflectConstruct$4();
  return function() {
    var E = _getPrototypeOf$4(o), e;
    if (i) {
      var t = _getPrototypeOf$4(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$4(this, e);
  };
}
function _possibleConstructorReturn$4(o, i) {
  if (i && (_typeof$6(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$5(o);
}
function _assertThisInitialized$5(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$4(o) {
  return _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$4(o);
}
var StatefulMenu = /* @__PURE__ */ (function(o) {
  _inherits$4(g, o);
  var i = _createSuper$4(g);
  function g() {
    return _classCallCheck$4(this, g), i.apply(this, arguments);
  }
  return _createClass$4(g, [{
    key: "render",
    value: function() {
      var e = this.props, t = e.overrides, n = _objectWithoutProperties$8(e, _excluded$a);
      return /* @__PURE__ */ React.createElement(NestedMenuContext.Consumer, null, function(h) {
        return (
          //$FlowExpectedError[cannot-spread-inexact]
          /* @__PURE__ */ React.createElement(MenuStatefulContainer, _extends$a({}, h, n), function(d) {
            return /* @__PURE__ */ React.createElement(Menu, _extends$a({}, d, {
              overrides: t
            }));
          })
        );
      });
    }
  }]), g;
})(React.PureComponent);
function ownKeys$9(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$7(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$9(Object(g), !0).forEach(function(E) {
      _defineProperty$a(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$9(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$a(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function getFont() {
  var o, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SIZE$1.default, g = arguments.length > 1 ? arguments[1] : void 0;
  return (o = {}, _defineProperty$a(o, SIZE$1.mini, g.font100), _defineProperty$a(o, SIZE$1.compact, g.font200), _defineProperty$a(o, SIZE$1.default, g.font300), _defineProperty$a(o, SIZE$1.large, g.font400), o)[i];
}
function getBorderRadius(o, i) {
  var g = i.inputBorderRadius;
  return o === SIZE$1.mini && (g = i.inputBorderRadiusMini), {
    borderTopLeftRadius: g,
    borderBottomLeftRadius: g,
    borderTopRightRadius: g,
    borderBottomRightRadius: g
  };
}
function getControlPadding(o) {
  var i, g, E, e, t, n = o.$theme, h = o.$theme.sizing, d = o.$size, k = d === void 0 ? SIZE$1.default : d, p = o.$type, M = o.$multi, H = o.$isEmpty, f = p === TYPE.search, AA = f ? "calc(".concat(h.scale1000, " - ").concat(h.scale0, ")") : h.scale400, gA = n.direction === "rtl" ? "paddingRight" : "paddingLeft", IA = n.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return (t = {}, _defineProperty$a(t, SIZE$1.mini, (i = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: M && !H ? 0 : h.scale100,
    paddingBottom: M && !H ? 0 : h.scale100
  }, _defineProperty$a(i, gA, M && !H ? "calc(".concat(AA, " - ").concat(h.scale0, ")") : AA), _defineProperty$a(i, IA, "0"), i)), _defineProperty$a(t, SIZE$1.compact, (g = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: M && !H ? "calc(".concat(h.scale100, " - ").concat(h.scale0, ")") : h.scale200,
    paddingBottom: M && !H ? "calc(".concat(h.scale100, " - ").concat(h.scale0, ")") : h.scale200
  }, _defineProperty$a(g, gA, M && !H ? "calc(".concat(AA, " - ").concat(h.scale0, ")") : AA), _defineProperty$a(g, IA, "0"), g)), _defineProperty$a(t, SIZE$1.default, (E = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: M && !H ? "calc(".concat(h.scale400, " - ").concat(h.scale0, ")") : h.scale400,
    paddingBottom: M && !H ? "calc(".concat(h.scale400, " - ").concat(h.scale0, ")") : h.scale400
  }, _defineProperty$a(E, gA, M && !H ? "calc(".concat(AA, " + ").concat(h.scale0, ")") : AA), _defineProperty$a(E, IA, 0), E)), _defineProperty$a(t, SIZE$1.large, (e = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: M && !H ? "calc(".concat(h.scale600, " - ").concat(h.scale0, ")") : h.scale550,
    paddingBottom: M && !H ? "calc(".concat(h.scale600, " - ").concat(h.scale0, ")") : h.scale550
  }, _defineProperty$a(e, gA, M && !H ? "calc(".concat(AA, " - ").concat(h.scale0, ")") : AA), _defineProperty$a(e, IA, 0), e)), t)[k];
}
var StyledDropdownContainer = styled("div", function(o) {
  return {
    width: "".concat(String(o.$width), "px")
  };
});
StyledDropdownContainer.displayName = "StyledDropdownContainer";
StyledDropdownContainer.displayName = "StyledDropdownContainer";
var StyledDropdown = StyledList, StyledDropdownListItem = StyledListItem, StyledOptionContent = styled("div", function(o) {
  var i = o.$isHighlighted, g = o.$selected, E = o.$disabled, e = o.$theme;
  return {
    cursor: E ? "not-allowed" : "pointer",
    color: g && !i ? e.colors.menuFontSelected : null,
    fontWeight: g ? "bold" : "normal"
  };
});
StyledOptionContent.displayName = "StyledOptionContent";
StyledOptionContent.displayName = "StyledOptionContent";
var StyledRoot = styled("div", function(o) {
  var i = o.$theme.typography, g = o.$size;
  return _objectSpread$7(_objectSpread$7({}, getFont(g, i)), {}, {
    boxSizing: "border-box",
    position: "relative",
    width: "100%"
  });
});
StyledRoot.displayName = "StyledRoot";
StyledRoot.displayName = "StyledRoot";
function getControlContainerColors(o, i, g, E, e, t) {
  return o ? {
    color: t.inputTextDisabled,
    borderLeftColor: t.inputFillDisabled,
    borderRightColor: t.inputFillDisabled,
    borderTopColor: t.inputFillDisabled,
    borderBottomColor: t.inputFillDisabled,
    backgroundColor: t.inputFillDisabled
  } : i || g ? {
    color: t.contentPrimary,
    borderLeftColor: t.borderSelected,
    borderRightColor: t.borderSelected,
    borderTopColor: t.borderSelected,
    borderBottomColor: t.borderSelected,
    backgroundColor: t.inputFillActive
  } : e ? {
    color: t.contentPrimary,
    borderLeftColor: t.inputBorderError,
    borderRightColor: t.inputBorderError,
    borderTopColor: t.inputBorderError,
    borderBottomColor: t.inputBorderError,
    backgroundColor: t.inputFillError
  } : E ? {
    color: t.contentPrimary,
    borderLeftColor: t.inputBorderPositive,
    borderRightColor: t.inputBorderPositive,
    borderTopColor: t.inputBorderPositive,
    borderBottomColor: t.inputBorderPositive,
    backgroundColor: t.inputFillPositive
  } : {
    color: t.contentPrimary,
    borderLeftColor: t.inputBorder,
    borderRightColor: t.inputBorder,
    borderTopColor: t.inputBorder,
    borderBottomColor: t.inputBorder,
    backgroundColor: t.inputFill
  };
}
var StyledControlContainer = styled("div", function(o) {
  var i = o.$disabled, g = o.$error, E = o.$positive, e = o.$isFocused, t = o.$isPseudoFocused, n = o.$type, h = o.$searchable, d = o.$size, k = o.$theme, p = k.borders, M = k.colors, H = k.animation;
  return _objectSpread$7(_objectSpread$7({}, getBorderRadius(d, p)), {}, {
    boxSizing: "border-box",
    overflow: "hidden",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    cursor: i ? "not-allowed" : h || n === TYPE.search ? "text" : "pointer",
    borderLeftWidth: "2px",
    borderRightWidth: "2px",
    borderTopWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    transitionProperty: "border, box-shadow, background-color",
    transitionDuration: H.timing200,
    transitionTimingFunction: H.easeOutCurve
  }, getControlContainerColors(i, e, t, E, g, M));
});
StyledControlContainer.displayName = "StyledControlContainer";
StyledControlContainer.displayName = "StyledControlContainer";
var StyledValueContainer = styled("div", function(o) {
  var i = getControlPadding(o);
  return _objectSpread$7({
    boxSizing: "border-box",
    position: "relative",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "0%",
    display: "flex",
    alignItems: "center",
    flexWrap: o.$multi ? "wrap" : "nowrap",
    overflow: "hidden"
  }, i);
});
StyledValueContainer.displayName = "StyledValueContainer";
StyledValueContainer.displayName = "StyledValueContainer";
var StyledPlaceholder = styled("div", function(o) {
  var i = o.$disabled, g = o.$theme.colors;
  return {
    color: i ? g.inputPlaceholderDisabled : g.inputPlaceholder,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
});
StyledPlaceholder.displayName = "StyledPlaceholder";
StyledPlaceholder.displayName = "StyledPlaceholder";
var StyledSingleValue = styled("div", function(o) {
  var i, g = o.$searchable, E = o.$size, e = o.$theme, t = o.$theme.typography, n = getFont(E, t), h = e.direction === "rtl" ? "marginRight" : "marginLeft";
  return _objectSpread$7((i = {
    lineHeight: g ? "inherit" : n.lineHeight,
    boxSizing: "border-box"
  }, _defineProperty$a(i, h, e.sizing.scale0), _defineProperty$a(i, "height", "100%"), _defineProperty$a(i, "maxWidth", "100%"), i), ellipsisText);
});
StyledSingleValue.displayName = "StyledSingleValue";
StyledSingleValue.displayName = "StyledSingleValue";
var StyledInputContainer = styled("div", function(o) {
  var i = o.$size, g = o.$searchable, E = o.$theme, e = E.typography, t = E.sizing, n = o.$isEmpty, h = getFont(i, e);
  return {
    position: "relative",
    display: "inline-block",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    boxShadow: "none",
    boxSizing: "border-box",
    outline: "none",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: n ? 0 : t.scale0,
    marginRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    height: String(g ? "auto" : h.lineHeight),
    maxHeight: String(h.lineHeight)
  };
});
StyledInputContainer.displayName = "StyledInputContainer";
StyledInputContainer.displayName = "StyledInputContainer";
var StyledInput = styled("input", function(o) {
  var i = o.$theme, g = i.colors, E = i.typography, e = o.$size, t = o.$searchable, n = o.$width;
  return _objectSpread$7(_objectSpread$7({}, getFont(e, E)), {}, {
    color: g.contentPrimary,
    boxSizing: "content-box",
    width: t ? n || "100%" : "1px",
    maxWidth: "100%",
    background: "transparent",
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    boxShadow: "none",
    display: "inline-block",
    outline: "none",
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0"
  });
});
StyledInput.displayName = "StyledInput";
StyledInput.displayName = "StyledInput";
var StyledInputSizer = styled("div", function(o) {
  var i, g = o.$size, E = o.$theme, e = o.$theme.typography, t = E.direction === "rtl" ? "right" : "left";
  return _objectSpread$7(_objectSpread$7({}, getFont(g, e)), {}, (i = {
    position: "absolute",
    top: 0
  }, _defineProperty$a(i, t, 0), _defineProperty$a(i, "visibility", "hidden"), _defineProperty$a(i, "height", 0), _defineProperty$a(i, "overflow", "scroll"), _defineProperty$a(i, "whiteSpace", "pre"), i));
});
StyledInputSizer.displayName = "StyledInputSizer";
StyledInputSizer.displayName = "StyledInputSizer";
var StyledIconsContainer = styled("div", function(o) {
  var i = o.$theme, g = o.$theme.sizing, E = i.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return _defineProperty$a({
    boxSizing: "border-box",
    position: "relative",
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    alignSelf: "stretch"
  }, E, g.scale500);
});
StyledIconsContainer.displayName = "StyledIconsContainer";
StyledIconsContainer.displayName = "StyledIconsContainer";
function getSvgStyles(o) {
  var i = o.$theme;
  return {
    display: "inline-block",
    fill: "currentColor",
    color: "currentColor",
    height: i.sizing.scale600,
    width: i.sizing.scale600
  };
}
var StyledSelectArrow = styled("svg", function(o) {
  var i, g = o.$theme, E = o.$disabled, e = o.$size, t = g.colors, n = (i = {}, _defineProperty$a(i, SIZE$1.mini, 16), _defineProperty$a(i, SIZE$1.compact, 16), _defineProperty$a(i, SIZE$1.default, 20), _defineProperty$a(i, SIZE$1.large, 24), i), h = n[SIZE$1.default];
  return e && (h = n[e]), _objectSpread$7(_objectSpread$7({}, getSvgStyles({
    $theme: g
  })), {}, {
    color: E ? t.inputTextDisabled : t.contentPrimary,
    cursor: E ? "not-allowed" : "pointer",
    height: "".concat(h, "px"),
    width: "".concat(h, "px")
  });
});
StyledSelectArrow.displayName = "StyledSelectArrow";
StyledSelectArrow.displayName = "StyledSelectArrow";
var StyledClearIcon = styled("svg", function(o) {
  var i, g = o.$theme, E = o.$size, e = g.colors, t = (i = {}, _defineProperty$a(i, SIZE$1.mini, 15), _defineProperty$a(i, SIZE$1.compact, 15), _defineProperty$a(i, SIZE$1.default, 18), _defineProperty$a(i, SIZE$1.large, 22), i), n = t[SIZE$1.default];
  return E && (n = t[E]), _objectSpread$7(_objectSpread$7({}, getSvgStyles({
    $theme: g
  })), {}, {
    color: e.contentPrimary,
    cursor: "pointer",
    height: "".concat(n, "px"),
    width: "".concat(n, "px")
  });
});
StyledClearIcon.displayName = "StyledClearIcon";
StyledClearIcon.displayName = "StyledClearIcon";
var StyledLoadingIndicator = withStyle(StyledSpinner, function(o) {
  var i = o.$theme;
  return {
    borderTopWidth: "2px",
    borderRightWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftWidth: "2px",
    borderRightColor: i.colors.borderOpaque,
    borderBottomColor: i.colors.borderOpaque,
    borderLeftColor: i.colors.borderOpaque,
    width: "16px",
    height: "16px"
  };
});
StyledLoadingIndicator.displayName = "StyledLoadingIndicator";
StyledLoadingIndicator.displayName = "StyledLoadingIndicator";
var StyledSearchIconContainer = styled("div", function(o) {
  var i, g = o.$disabled, E = o.$theme, e = E.colors, t = E.sizing, n = E.direction === "rtl" ? "right" : "left";
  return _objectSpread$7(_objectSpread$7({}, getSvgStyles(o)), {}, (i = {
    color: g ? e.inputTextDisabled : e.contentPrimary,
    cursor: g ? "not-allowed" : "pointer",
    position: "absolute",
    top: 0
  }, _defineProperty$a(i, n, t.scale500), _defineProperty$a(i, "display", "flex"), _defineProperty$a(i, "alignItems", "center"), _defineProperty$a(i, "height", "100%"), i));
});
StyledSearchIconContainer.displayName = "StyledSearchIconContainer";
StyledSearchIconContainer.displayName = "StyledSearchIconContainer";
function _typeof$5(o) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$5(o);
}
var _excluded$9 = ["overrides", "inputRef"];
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$9.apply(this, arguments);
}
function ownKeys$8(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$6(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$8(Object(g), !0).forEach(function(E) {
      _defineProperty$9(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$8(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _slicedToArray$7(o, i) {
  return _arrayWithHoles$6(o) || _iterableToArrayLimit$6(o, i) || _unsupportedIterableToArray$6(o, i) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$6(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$6(o, i);
  }
}
function _arrayLikeToArray$6(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$6(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$6(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$7(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$6(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$6(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _classCallCheck$3(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$3(o, i, g) {
  return i && _defineProperties$3(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$3(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$3(o, i);
}
function _setPrototypeOf$3(o, i) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$3(o, i);
}
function _createSuper$3(o) {
  var i = _isNativeReflectConstruct$3();
  return function() {
    var E = _getPrototypeOf$3(o), e;
    if (i) {
      var t = _getPrototypeOf$3(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$3(this, e);
  };
}
function _possibleConstructorReturn$3(o, i) {
  if (i && (_typeof$5(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(o);
}
function _assertThisInitialized$4(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$3(o) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$3(o);
}
function _defineProperty$9(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var AutosizeInput = /* @__PURE__ */ (function(o) {
  _inherits$3(g, o);
  var i = _createSuper$3(g);
  function g() {
    var E;
    _classCallCheck$3(this, g);
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = i.call.apply(i, [this].concat(t)), _defineProperty$9(_assertThisInitialized$4(E), "mounted", void 0), _defineProperty$9(_assertThisInitialized$4(E), "sizer", void 0), _defineProperty$9(_assertThisInitialized$4(E), "state", {
      inputWidth: 5
    }), _defineProperty$9(_assertThisInitialized$4(E), "sizerRef", function(h) {
      E.sizer = h;
    }), E;
  }
  return _createClass$3(g, [{
    key: "componentDidMount",
    value: function() {
      this.mounted = !0, this.updateInputWidth();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      this.updateInputWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
    }
  }, {
    key: "updateInputWidth",
    value: function() {
      if (!(!this.mounted || !this.sizer || typeof this.sizer.scrollWidth > "u")) {
        var e = this.sizer.scrollWidth + 2;
        e !== this.state.inputWidth && this.sizer.scrollWidth !== this.state.inputWidth && this.setState({
          inputWidth: e
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, t = e.overrides, n = t === void 0 ? {} : t, h = e.inputRef, d = _objectWithoutProperties$7(e, _excluded$9), k = getOverrides(n.Input, StyledInput), p = _slicedToArray$7(k, 2), M = p[0], H = p[1], f = [this.props.defaultValue, this.props.value, ""].reduce(function(gA, IA) {
        return gA ?? IA;
      }), AA = _objectSpread$6(_objectSpread$6({}, d), {}, {
        $width: "".concat(this.state.inputWidth, "px")
      });
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(M, _extends$9({}, AA, {
        ref: h
      }, H)), /* @__PURE__ */ React.createElement(StyledInputSizer, {
        $size: this.props.$size,
        ref: this.sizerRef,
        $style: H.$style ? H.$style : null
      }, f));
    }
  }]), g;
})(React.Component);
_defineProperty$9(AutosizeInput, "defaultProps", {
  inputRef: /* @__PURE__ */ React.createRef(),
  value: "",
  overrides: {}
});
function ownKeys$7(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$5(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$7(Object(g), !0).forEach(function(E) {
      _defineProperty$8(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$7(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$8(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var escapeRegExp = function o(i) {
  return i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}, isValid = function o(i) {
  return typeof i < "u" && i !== null && i !== "";
}, defaultProps$1 = {
  filterOption: null,
  ignoreCase: !0,
  labelKey: "label",
  matchPos: "any",
  matchProp: "any",
  trimFilter: !0,
  valueKey: "value"
}, filterOptions = function o(i, g, E, e) {
  var t = _objectSpread$5(_objectSpread$5({}, defaultProps$1), e);
  t.ignoreCase && (g = g.toLowerCase()), t.trimFilter && (g = g.trim());
  var n = (E || []).reduce(function(d, k) {
    return d.add(k[t.valueKey]), d;
  }, /* @__PURE__ */ new Set()), h = new RegExp("".concat(t.matchPos === "start" ? "^" : "").concat(escapeRegExp(g)), t.ignoreCase ? "i" : "");
  return i.filter(function(d) {
    if (n.has(d[t.valueKey])) return !1;
    if (t.filterOption) return t.filterOption.call(void 0, d, g);
    if (!g) return !0;
    var k = d[t.valueKey], p = d[t.labelKey], M = isValid(k), H = isValid(p);
    if (!M && !H)
      return !1;
    var f = M ? String(k) : null, AA = H ? String(p) : null;
    return f && t.matchProp !== "label" && h.test(f) || AA && t.matchProp !== "value" && h.test(AA);
  });
}, defaultProps = {
  "aria-label": null,
  "aria-describedby": null,
  "aria-errormessage": null,
  "aria-labelledby": null,
  autoFocus: !1,
  backspaceRemoves: !0,
  clearable: !0,
  closeOnSelect: !0,
  creatable: !1,
  deleteRemoves: !0,
  disabled: !1,
  error: !1,
  positive: !1,
  escapeClearsValue: !0,
  filterOptions,
  filterOutSelected: !0,
  getOptionLabel: null,
  getValueLabel: null,
  ignoreCase: !0,
  isLoading: !1,
  labelKey: "label",
  maxDropdownHeight: "40vh",
  multi: !1,
  onBlur: function o() {
  },
  onBlurResetsInput: !0,
  onChange: function o() {
  },
  onFocus: function o() {
  },
  onInputChange: function o() {
  },
  onCloseResetsInput: !0,
  onSelectResetsInput: !0,
  onOpen: null,
  onClose: null,
  openOnClick: !0,
  startOpen: !1,
  options: [],
  overrides: {},
  required: !1,
  searchable: !0,
  size: SIZE$1.default,
  type: TYPE.select,
  value: [],
  valueKey: "id"
};
function _typeof$4(o) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$4(o);
}
var _excluded$8 = ["overrides"];
function ownKeys$6(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$4(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$6(Object(g), !0).forEach(function(E) {
      _defineProperty$7(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$6(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _objectWithoutProperties$6(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$5(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$5(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$8.apply(this, arguments);
}
function _slicedToArray$6(o, i) {
  return _arrayWithHoles$5(o) || _iterableToArrayLimit$5(o, i) || _unsupportedIterableToArray$5(o, i) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$5(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$5(o, i);
  }
}
function _arrayLikeToArray$5(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$5(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$5(o) {
  if (Array.isArray(o)) return o;
}
function _classCallCheck$2(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$2(o, i, g) {
  return i && _defineProperties$2(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$2(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$2(o, i);
}
function _setPrototypeOf$2(o, i) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$2(o, i);
}
function _createSuper$2(o) {
  var i = _isNativeReflectConstruct$2();
  return function() {
    var E = _getPrototypeOf$2(o), e;
    if (i) {
      var t = _getPrototypeOf$2(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$2(this, e);
  };
}
function _possibleConstructorReturn$2(o, i) {
  if (i && (_typeof$4(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(o);
}
function _assertThisInitialized$3(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$2(o) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$2(o);
}
function _defineProperty$7(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function groupOptions(o) {
  return o.reduce(function(i, g) {
    return g.__optgroup ? (i[g.__optgroup] || (i[g.__optgroup] = []), i[g.__optgroup].push(g)) : i.__ungrouped.push(g), i;
  }, {
    __ungrouped: []
  });
}
var SelectDropdown = /* @__PURE__ */ (function(o) {
  _inherits$2(g, o);
  var i = _createSuper$2(g);
  function g() {
    var E;
    _classCallCheck$2(this, g);
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = i.call.apply(i, [this].concat(t)), _defineProperty$7(_assertThisInitialized$3(E), "getItemLabel", function(h) {
      var d = E.props, k = d.getOptionLabel, p = d.overrides, M = p === void 0 ? {} : p, H = d.value, f = d.valueKey, AA = getOverrides(M.OptionContent, StyledOptionContent), gA = _slicedToArray$6(AA, 2), IA = gA[0], BA = gA[1], CA;
      Array.isArray(H) ? CA = !!H.find(function(iA) {
        return iA && iA[f] === h[f];
      }) : CA = H[f] === h[f];
      var QA = {
        $selected: CA,
        $disabled: h.disabled,
        $isHighlighted: h.isHighlighted
      };
      return /* @__PURE__ */ React.createElement(IA, _extends$8({
        "aria-readonly": h.disabled,
        "aria-selected": CA,
        key: h[f]
      }, E.getSharedProps(), QA, BA), k({
        option: h,
        optionState: QA
      }));
    }), _defineProperty$7(_assertThisInitialized$3(E), "onMouseDown", function(h) {
      h.nativeEvent.stopImmediatePropagation();
    }), _defineProperty$7(_assertThisInitialized$3(E), "getHighlightedIndex", function() {
      var h = E.props, d = h.value, k = h.options, p = h.valueKey, M = {};
      if (Array.isArray(d) && d.length > 0 ? M = d[0] : d instanceof Array || (M = d), Object.keys(M).length > 0) {
        var H = k.findIndex(function(f) {
          return f && f[p] === M[p];
        });
        return H === -1 ? 0 : H;
      }
      return 0;
    }), E;
  }
  return _createClass$2(g, [{
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.error, n = e.isLoading, h = e.multi, d = e.required, k = e.size, p = e.searchable, M = e.type, H = e.width;
      return {
        $error: t,
        $isLoading: n,
        $multi: h,
        $required: d,
        $searchable: p,
        $size: k,
        $type: M,
        $width: H
      };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.props, n = t.maxDropdownHeight, h = t.multi, d = t.noResultsMsg, k = t.onItemSelect, p = t.options, M = p === void 0 ? [] : p, H = t.overrides, f = H === void 0 ? {} : H, AA = t.size, gA = getOverrides(f.DropdownContainer, StyledDropdownContainer), IA = _slicedToArray$6(gA, 2), BA = IA[0], CA = IA[1], QA = getOverrides(f.DropdownListItem, StyledDropdownListItem), iA = _slicedToArray$6(QA, 2), EA = iA[0], oA = iA[1], eA = getOverrides(f.StatefulMenu, StatefulMenu), GA = _slicedToArray$6(eA, 2), cA = GA[0], tA = GA[1], aA = tA.overrides, sA = aA === void 0 ? {} : aA, DA = _objectWithoutProperties$6(tA, _excluded$8), rA = this.getHighlightedIndex(), nA = groupOptions(M);
      return /* @__PURE__ */ React.createElement(BA, _extends$8({
        "data-no-focus-lock": !0,
        ref: this.props.innerRef
      }, this.getSharedProps(), CA), /* @__PURE__ */ React.createElement(cA, _extends$8({
        noResultsMsg: d,
        onActiveDescendantChange: function(pA) {
          e.props.onActiveDescendantChange && e.props.onActiveDescendantChange(pA);
        },
        onItemSelect: k,
        items: nA,
        size: AA,
        initialState: {
          isFocused: !0,
          highlightedIndex: rA
        },
        typeAhead: !1,
        keyboardControlNode: this.props.keyboardControlNode,
        forceHighlight: !0,
        overrides: mergeOverrides({
          List: {
            component: StyledDropdown,
            style: function(pA) {
              return {
                maxHeight: pA.$maxHeight || null
              };
            },
            props: {
              id: this.props.id ? this.props.id : null,
              $maxHeight: n,
              "aria-multiselectable": h
            }
          },
          Option: {
            props: {
              getItemLabel: this.getItemLabel,
              // figure out why the onClick handler is not
              // triggered without this temporary fix
              onMouseDown: this.onMouseDown,
              overrides: {
                ListItem: {
                  component: EA,
                  props: _objectSpread$4(_objectSpread$4({}, oA), {}, {
                    role: "option"
                  }),
                  // slightly hacky way to handle the list item style overrides
                  // since the menu component doesn't provide a top level overrides for it
                  style: oA.$style
                }
              },
              renderHrefAsAnchor: !1
            }
          }
        }, _objectSpread$4({
          List: f.Dropdown || {},
          Option: f.DropdownOption || {}
        }, sA))
      }, DA)));
    }
  }]), g;
})(React.Component);
function ownKeys$5(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$3(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$5(Object(g), !0).forEach(function(E) {
      _defineProperty$6(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$5(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$6(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function groupedOptionsToArray(o) {
  return Object.keys(o).reduce(function(i, g) {
    var E = o[g];
    return i.concat(E.map(function(e) {
      return _objectSpread$3(_objectSpread$3({}, e), {}, {
        __optgroup: g
      });
    }));
  }, []);
}
function normalizeOptions(o) {
  return o ? Array.isArray(o) ? o : groupedOptionsToArray(o) : [];
}
var expandValue = function o(i, g) {
  if (!g.options) return i;
  for (var E = normalizeOptions(g.options), e = 0; e < E.length; e++)
    if (String(E[e][g.valueKey]) === String(i[g.valueKey]))
      return E[e];
  return i;
};
function _typeof$3(o) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$3(o);
}
var _excluded$7 = ["$size"], _excluded2$2 = ["$size"];
function _objectWithoutProperties$5(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$4(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$4(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$7.apply(this, arguments);
}
function _slicedToArray$5(o, i) {
  return _arrayWithHoles$4(o) || _iterableToArrayLimit$4(o, i) || _unsupportedIterableToArray$4(o, i) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$4(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$4(o) {
  if (Array.isArray(o)) return o;
}
function _toConsumableArray(o) {
  return _arrayWithoutHoles(o) || _iterableToArray(o) || _unsupportedIterableToArray$4(o) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$4(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$4(o, i);
  }
}
function _iterableToArray(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function _arrayWithoutHoles(o) {
  if (Array.isArray(o)) return _arrayLikeToArray$4(o);
}
function _arrayLikeToArray$4(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _classCallCheck$1(o, i) {
  if (!(o instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, E.key, E);
  }
}
function _createClass$1(o, i, g) {
  return i && _defineProperties$1(o.prototype, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$1(o, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), i && _setPrototypeOf$1(o, i);
}
function _setPrototypeOf$1(o, i) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, e) {
    return E.__proto__ = e, E;
  }, _setPrototypeOf$1(o, i);
}
function _createSuper$1(o) {
  var i = _isNativeReflectConstruct$1();
  return function() {
    var E = _getPrototypeOf$1(o), e;
    if (i) {
      var t = _getPrototypeOf$1(this).constructor;
      e = Reflect.construct(E, arguments, t);
    } else
      e = E.apply(this, arguments);
    return _possibleConstructorReturn$1(this, e);
  };
}
function _possibleConstructorReturn$1(o, i) {
  if (i && (_typeof$3(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(o);
}
function _assertThisInitialized$2(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$1(o) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$1(o);
}
function _defineProperty$5(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function Noop() {
  return null;
}
var isClick = function o(i) {
  return i.type === "click";
}, isLeftClick = function o(i) {
  return i.button !== null && i.button !== void 0 && i.button === 0;
}, containsNode = function o(i, g) {
  if (typeof document < "u")
    return g && i && i.contains(g);
};
function isInteractive(o, i) {
  if (o instanceof Element)
    for (var g = o; g && g !== i; ) {
      var E = g.getAttribute("role");
      if (E === "button" || E === "link")
        return !0;
      g.tagName && (g = g.parentElement);
    }
  return !1;
}
var Select$1 = /* @__PURE__ */ (function(o) {
  _inherits$1(g, o);
  var i = _createSuper$1(g);
  function g(E) {
    var e;
    return _classCallCheck$1(this, g), e = i.call(this, E), _defineProperty$5(_assertThisInitialized$2(e), "anchor", /* @__PURE__ */ React.createRef()), _defineProperty$5(_assertThisInitialized$2(e), "dropdown", /* @__PURE__ */ React.createRef()), _defineProperty$5(_assertThisInitialized$2(e), "input", void 0), _defineProperty$5(_assertThisInitialized$2(e), "dragging", void 0), _defineProperty$5(_assertThisInitialized$2(e), "focusAfterClear", void 0), _defineProperty$5(_assertThisInitialized$2(e), "openAfterFocus", void 0), _defineProperty$5(_assertThisInitialized$2(e), "justSelected", void 0), _defineProperty$5(_assertThisInitialized$2(e), "options", []), _defineProperty$5(_assertThisInitialized$2(e), "state", {
      activeDescendant: null,
      inputValue: "",
      isFocused: !1,
      isOpen: e.props.startOpen,
      isPseudoFocused: !1
    }), _defineProperty$5(_assertThisInitialized$2(e), "isItMounted", !1), _defineProperty$5(_assertThisInitialized$2(e), "handleTouchOutside", function(t) {
      containsNode(e.dropdown.current, t.target) || containsNode(e.anchor.current, t.target) || e.closeMenu();
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleTouchMove", function() {
      return e.dragging = !0;
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleTouchStart", function() {
      return e.dragging = !1;
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleTouchEnd", function(t) {
      e.dragging || e.handleClick(t);
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleClick", function(t) {
      if (!(e.props.disabled || !isClick(t) && !isLeftClick(t))) {
        if (t.target === e.input) {
          e.state.isFocused || (e.openAfterFocus = e.props.openOnClick, e.focus()), e.state.isOpen || e.setState({
            isOpen: !0,
            isFocused: !0,
            isPseudoFocused: !1
          });
          return;
        }
        if (!(e.input && isInteractive(t.target, e.input))) {
          if (!e.props.searchable) {
            e.focus(), e.state.isOpen ? e.setState({
              isOpen: !1,
              isFocused: !1
            }) : e.setState({
              isOpen: !0,
              isFocused: !0
            });
            return;
          }
          e.state.isFocused ? (e.focus(), e.input && (e.input.value = ""), e.setState(function(n) {
            return {
              isOpen: !e.focusAfterClear && !n.isOpen,
              isPseudoFocused: !1
            };
          }), e.focusAfterClear = !1) : (e.focusAfterClear = !1, e.openAfterFocus = e.props.openOnClick, e.focus());
        }
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleInputFocus", function(t) {
      if (!e.props.disabled) {
        e.props.onFocus && e.props.onFocus(t);
        var n = e.state.isOpen || e.openAfterFocus;
        n = !e.focusAfterClear && n, e.setState({
          isFocused: !0,
          isOpen: !!n
        }), e.focusAfterClear = !1, e.openAfterFocus = !1;
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleBlur", function(t) {
      if (t.relatedTarget) {
        if (containsNode(e.anchor.current, t.relatedTarget) || containsNode(e.dropdown.current, t.relatedTarget))
          return;
      } else if (containsNode(e.anchor.current, t.target))
        return;
      e.props.onBlur && e.props.onBlur(t), e.isItMounted && e.setState({
        isFocused: !1,
        isOpen: !1,
        isPseudoFocused: !1,
        inputValue: e.props.onBlurResetsInput ? "" : e.state.inputValue
      });
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleClickOutside", function(t) {
      if (e.justSelected) {
        e.justSelected = !1;
        return;
      }
      if (!containsNode(e.dropdown.current, t.target)) {
        var n = e.state.isFocused || e.state.isPseudoFocused;
        n && !containsNode(e.anchor.current, t.target) && e.handleBlur(t);
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleInputChange", function(t) {
      var n = t.target.value;
      e.setState({
        inputValue: n,
        isOpen: !0,
        isPseudoFocused: !1
      }), e.props.onInputChange && e.props.onInputChange(t);
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleKeyDown", function(t) {
      if (!e.props.disabled)
        switch (t.keyCode) {
          case 8:
            !e.state.inputValue && e.props.backspaceRemoves && (t.preventDefault(), e.backspaceValue());
            break;
          case 9:
            e.setState(function(n) {
              return {
                isPseudoFocused: !1,
                isFocused: !1,
                isOpen: !1,
                inputValue: !e.props.onCloseResetsInput || !e.props.onBlurResetsInput ? n.inputValue : ""
              };
            });
            break;
          case 27:
            !e.state.isOpen && e.props.clearable && e.props.escapeClearsValue && (e.clearValue(t), e.setState({
              isFocused: !1,
              isPseudoFocused: !1
            }));
            break;
          case 32:
            if (e.props.searchable)
              break;
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 38:
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 40:
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 33:
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 34:
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 35:
            if (t.shiftKey)
              break;
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 36:
            if (t.shiftKey)
              break;
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 46:
            !e.state.inputValue && e.props.deleteRemoves && (t.preventDefault(), e.popValue());
            break;
        }
    }), _defineProperty$5(_assertThisInitialized$2(e), "getOptionLabel", function(t, n) {
      var h = n.option;
      return h.isCreatable ? "".concat(t.select.create, " “").concat(h[e.props.labelKey], "”") : h[e.props.labelKey];
    }), _defineProperty$5(_assertThisInitialized$2(e), "getValueLabel", function(t) {
      var n = t.option;
      return n[e.props.labelKey];
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleActiveDescendantChange", function(t) {
      t ? e.setState({
        activeDescendant: t
      }) : e.setState({
        activeDescendant: null
      });
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleInputRef", function(t) {
      e.input = t, typeof e.props.inputRef == "function" ? e.props.inputRef(t) : e.props.inputRef && (e.props.inputRef.current = t), e.props.controlRef && typeof e.props.controlRef == "function" && e.props.controlRef(t);
    }), _defineProperty$5(_assertThisInitialized$2(e), "selectValue", function(t) {
      var n = t.item;
      if (!n.disabled) {
        e.justSelected = !0;
        var h = e.props.onSelectResetsInput ? "" : e.state.inputValue;
        e.props.multi ? e.setState({
          inputValue: h,
          isOpen: !e.props.closeOnSelect
        }, function() {
          var d = e.props.value;
          d.some(function(k) {
            return k[e.props.valueKey] === n[e.props.valueKey];
          }) ? e.removeValue(n) : e.addValue(n);
        }) : (e.focus(), e.setState({
          inputValue: h,
          isOpen: !e.props.closeOnSelect,
          isFocused: !0,
          isPseudoFocused: !1
        }, function() {
          e.setValue([n], n, STATE_CHANGE_TYPE.select);
        }));
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "addValue", function(t) {
      var n = _toConsumableArray(e.props.value);
      e.setValue(n.concat(t), t, STATE_CHANGE_TYPE.select);
    }), _defineProperty$5(_assertThisInitialized$2(e), "backspaceValue", function() {
      var t = e.popValue();
      if (t) {
        var n = e.props.value.length, h = e.props.getValueLabel || e.getValueLabel, d = h({
          option: t,
          index: n - 1
        });
        if (!e.props.backspaceClearsInputValue && typeof d == "string") {
          var k = d.slice(0, -1);
          e.setState({
            inputValue: k,
            isOpen: !0
          });
        }
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "popValue", function() {
      var t = _toConsumableArray(e.props.value), n = t.length;
      if (n && t[n - 1].clearableValue !== !1) {
        var h = t.pop();
        return e.setValue(t, h, STATE_CHANGE_TYPE.remove), h;
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "removeValue", function(t) {
      var n = _toConsumableArray(e.props.value);
      e.setValue(n.filter(function(h) {
        return h[e.props.valueKey] !== t[e.props.valueKey];
      }), t, STATE_CHANGE_TYPE.remove), e.focus();
    }), _defineProperty$5(_assertThisInitialized$2(e), "clearValue", function(t) {
      if (!(isClick(t) && !isLeftClick(t))) {
        if (e.props.value) {
          var n = e.props.value.filter(function(h) {
            return h.clearableValue === !1;
          });
          e.setValue(n, null, STATE_CHANGE_TYPE.clear);
        }
        e.setState({
          inputValue: "",
          isOpen: !1
        }), e.focus(), e.focusAfterClear = !0;
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "shouldShowPlaceholder", function() {
      return !(e.state.inputValue || e.props.value && e.props.value.length);
    }), _defineProperty$5(_assertThisInitialized$2(e), "shouldShowValue", function() {
      return !e.state.inputValue;
    }), e.options = normalizeOptions(E.options), e;
  }
  return _createClass$1(g, [{
    key: "componentDidMount",
    value: function() {
      this.props.autoFocus && this.focus(), this.isItMounted = !0;
      var e = this.props.controlRef;
      e && typeof e != "function" && (e.current = {
        setDropdownOpen: this.handleDropdownOpen.bind(this),
        setInputValue: this.handleSetInputValue.bind(this),
        setInputFocus: this.handleSetInputFocus.bind(this),
        setInputBlur: this.handleSetInputBlur.bind(this),
        // `focus` & `blur` below are for backwards compatibility and may be removed. Use setInputFocus and setInputBlur instead.
        focus: this.handleSetInputFocus.bind(this),
        blur: this.handleSetInputBlur.bind(this)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      var n = this;
      typeof document < "u" && (t.isOpen !== this.state.isOpen && (this.state.isOpen ? (this.props.onOpen && this.props.onOpen(), document.addEventListener("touchstart", this.handleTouchOutside)) : (this.props.onClose && this.props.onClose(), document.removeEventListener("touchstart", this.handleTouchOutside))), !t.isFocused && this.state.isFocused && setTimeout(function() {
        return document.addEventListener("click", n.handleClickOutside);
      }, 0));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      typeof document < "u" && (document.removeEventListener("touchstart", this.handleTouchOutside), document.removeEventListener("click", this.handleClickOutside)), this.isItMounted = !1;
    }
  }, {
    key: "focus",
    value: function() {
      this.input && this.input.focus();
    }
  }, {
    key: "handleDropdownOpen",
    value: function(e) {
      this.setState({
        isOpen: e
      });
    }
  }, {
    key: "handleSetInputValue",
    value: function(e) {
      this.setState({
        inputValue: e
      });
    }
  }, {
    key: "handleSetInputFocus",
    value: function() {
      this.input.focus();
    }
  }, {
    key: "handleSetInputBlur",
    value: function() {
      this.input.blur();
    }
    // Handle touch outside on mobile to dismiss menu, ensures that the
    // touch target is not within the anchor DOM node.
  }, {
    key: "closeMenu",
    value: function() {
      this.props.onCloseResetsInput ? this.setState({
        inputValue: "",
        isOpen: !1,
        isPseudoFocused: this.state.isFocused && !this.props.multi
      }) : this.setState({
        isOpen: !1,
        isPseudoFocused: this.state.isFocused && !this.props.multi
      });
    }
  }, {
    key: "getValueArray",
    value: (
      /**
       * Extends the value into an array from the given options
       */
      function(e) {
        var t = this;
        if (!Array.isArray(e)) {
          if (e == null) return [];
          e = [e];
        }
        return e.map(function(n) {
          return expandValue(n, t.props);
        });
      }
    )
  }, {
    key: "setValue",
    value: function(e, t, n) {
      this.props.onChange && this.props.onChange({
        value: e,
        option: t,
        type: n
      });
    }
  }, {
    key: "renderLoading",
    value: function() {
      if (this.props.isLoading) {
        var e = this.props.overrides, t = e === void 0 ? {} : e, n = getOverrides(t.LoadingIndicator, StyledLoadingIndicator), h = _slicedToArray$5(n, 2), d = h[0], k = h[1];
        return /* @__PURE__ */ React.createElement(d, _extends$7({
          role: "status"
        }, k), /* @__PURE__ */ React.createElement("span", {
          style: {
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
            whiteSpace: "nowrap",
            border: 0
          }
        }, "Loading"));
      }
    }
  }, {
    key: "renderValue",
    value: function(e) {
      var t = this, n = this.props.overrides, h = n === void 0 ? {} : n, d = this.getSharedProps(), k = this.props.getValueLabel || this.getValueLabel, p = this.props.valueComponent || Noop;
      if (!e.length)
        return null;
      if (this.props.multi)
        return e.map(function(M, H) {
          var f = d.$disabled || M.clearableValue === !1;
          return /* @__PURE__ */ React.createElement(p, _extends$7({
            value: M,
            key: "value-".concat(H, "-").concat(M[t.props.valueKey]),
            removeValue: function() {
              return t.removeValue(M);
            },
            disabled: f,
            overrides: {
              Tag: h.Tag,
              MultiValue: h.MultiValue
            }
          }, d, {
            $disabled: f
          }), k({
            option: M,
            index: H
          }));
        });
      if (this.shouldShowValue())
        return /* @__PURE__ */ React.createElement(p, _extends$7({
          value: e[0][this.props.valueKey],
          disabled: this.props.disabled,
          overrides: {
            SingleValue: h.SingleValue
          }
        }, d), k({
          option: e[0]
        }));
    }
  }, {
    key: "renderInput",
    value: function(e) {
      var t = this, n = this.props.overrides, h = n === void 0 ? {} : n, d = getOverrides(h.InputContainer, StyledInputContainer), k = _slicedToArray$5(d, 2), p = k[0], M = k[1], H = this.getSharedProps(), f = this.state.isOpen, AA = this.getValueArray(this.props.value).map(function(BA) {
        return BA[t.props.labelKey];
      }).join(", "), gA = AA.length ? "Selected ".concat(AA, ". ") : "", IA = "".concat(gA).concat(this.props["aria-label"] || "");
      return this.props.searchable ? /* @__PURE__ */ React.createElement(p, _extends$7({}, H, M), /* @__PURE__ */ React.createElement(AutosizeInput, _extends$7({
        "aria-activedescendant": this.state.activeDescendant,
        "aria-autocomplete": "list",
        "aria-controls": this.state.isOpen ? e : null,
        "aria-describedby": this.props["aria-describedby"],
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-disabled": this.props.disabled || null,
        "aria-expanded": f,
        "aria-haspopup": "listbox",
        "aria-label": IA,
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": this.props.required || null,
        disabled: this.props.disabled || null,
        id: this.props.id || null,
        inputRef: this.handleInputRef,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        overrides: {
          Input: h.Input
        },
        required: this.props.required && !this.props.value.length || null,
        role: "combobox",
        value: this.state.inputValue,
        tabIndex: 0
      }, H))) : /* @__PURE__ */ React.createElement(p, _extends$7({
        "aria-activedescendant": this.state.activeDescendant,
        "aria-describedby": this.props["aria-describedby"],
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-disabled": this.props.disabled,
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-owns": this.state.isOpen ? e : null,
        "aria-required": this.props.required || null,
        onFocus: this.handleInputFocus,
        tabIndex: 0
      }, H, M), /* @__PURE__ */ React.createElement("input", _extends$7({
        "aria-hidden": !0,
        id: this.props.id || null,
        ref: this.handleInputRef,
        style: {
          opacity: 0,
          width: 0,
          overflow: "hidden",
          border: "none",
          padding: 0
        },
        tabIndex: -1
      }, h.Input ? h.Input.props ? (
        // $FlowExpectedError[not-an-object]
        h.Input.props
      ) : {} : {})));
    }
  }, {
    key: "renderClear",
    value: function() {
      var e, t = !!(this.props.value && this.props.value.length || this.state.inputValue);
      if (!(!this.props.clearable || this.props.disabled || this.props.isLoading || !t)) {
        var n = this.getSharedProps();
        n.$size;
        var h = _objectWithoutProperties$5(n, _excluded$7), d = this.props.overrides, k = d === void 0 ? {} : d, p = getOverrides(k.ClearIcon, DeleteAlt$1), M = _slicedToArray$5(p, 2), H = M[0], f = M[1], AA = this.props.multi ? "Clear all" : "Clear value", gA = (e = {}, _defineProperty$5(e, SIZE$1.mini, 15), _defineProperty$5(e, SIZE$1.compact, 15), _defineProperty$5(e, SIZE$1.default, 18), _defineProperty$5(e, SIZE$1.large, 22), e);
        return /* @__PURE__ */ React.createElement(H, _extends$7({
          title: AA,
          "aria-label": AA,
          onClick: this.clearValue,
          role: "button",
          size: gA[this.props.size] || gA[SIZE$1.default]
        }, h, f));
      }
    }
  }, {
    key: "renderArrow",
    value: function() {
      var e;
      if (this.props.type !== TYPE.select)
        return null;
      var t = this.getSharedProps();
      t.$size;
      var n = _objectWithoutProperties$5(t, _excluded2$2), h = this.props.overrides, d = h === void 0 ? {} : h, k = getOverrides(d.SelectArrow, TriangleDownIcon), p = _slicedToArray$5(k, 2), M = p[0], H = p[1];
      H.overrides = mergeOverrides({
        Svg: {
          style: function(gA) {
            var IA = gA.$theme, BA = gA.$disabled;
            return {
              color: BA ? IA.colors.inputTextDisabled : IA.colors.contentPrimary
            };
          }
        }
      }, H.overrides);
      var f = (e = {}, _defineProperty$5(e, SIZE$1.mini, 16), _defineProperty$5(e, SIZE$1.compact, 16), _defineProperty$5(e, SIZE$1.default, 20), _defineProperty$5(e, SIZE$1.large, 24), e);
      return /* @__PURE__ */ React.createElement(M, _extends$7({
        size: f[this.props.size] || f[SIZE$1.default],
        title: "open"
      }, n, H));
    }
  }, {
    key: "renderSearch",
    value: function() {
      if (this.props.type !== TYPE.search)
        return null;
      var e = this.props.overrides, t = e === void 0 ? {} : e, n = getOverrides(t.SearchIconContainer, StyledSearchIconContainer), h = _slicedToArray$5(n, 2), d = h[0], k = h[1], p = getOverrides(t.SearchIcon, SearchIconComponent), M = _slicedToArray$5(p, 2), H = M[0], f = M[1], AA = this.getSharedProps();
      return /* @__PURE__ */ React.createElement(d, _extends$7({}, AA, k), /* @__PURE__ */ React.createElement(H, _extends$7({
        size: 16,
        title: "search"
      }, AA, f)));
    }
  }, {
    key: "filterOptions",
    value: function(e) {
      var t = this, n = this.state.inputValue.trim();
      this.props.filterOptions && (this.options = this.props.filterOptions(this.options, n, e, {
        valueKey: this.props.valueKey,
        labelKey: this.props.labelKey
      }));
      var h = this.props.ignoreCase ? function(k) {
        return k[t.props.labelKey].toLowerCase() !== n.toLowerCase().trim();
      } : function(k) {
        return k[t.props.labelKey] !== n.trim();
      };
      if (n && this.props.creatable && this.options.concat(this.props.value).every(h)) {
        var d;
        this.options.push((d = {
          id: n
        }, _defineProperty$5(d, this.props.labelKey, n), _defineProperty$5(d, this.props.valueKey, n), _defineProperty$5(d, "isCreatable", !0), d));
      }
      return this.options;
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.clearable, n = e.creatable, h = e.disabled, d = e.error, k = e.positive, p = e.isLoading, M = e.multi, H = e.required, f = e.size, AA = e.searchable, gA = e.type, IA = e.value, BA = this.state, CA = BA.isOpen, QA = BA.isFocused, iA = BA.isPseudoFocused;
      return {
        $clearable: t,
        $creatable: n,
        $disabled: h,
        $error: d,
        $positive: k,
        $isFocused: QA,
        $isLoading: p,
        $isOpen: CA,
        $isPseudoFocused: iA,
        $multi: M,
        $required: H,
        $searchable: AA,
        $size: f,
        $type: gA,
        $isEmpty: !this.getValueArray(IA).length
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this;
      this.options = normalizeOptions(this.props.options);
      var t = this.props, n = t.overrides, h = n === void 0 ? {} : n, d = t.type, k = t.multi, p = t.noResultsMsg, M = t.value, H = t.filterOutSelected;
      process.env.NODE_ENV !== "production" && M && !Array.isArray(M) && console.warn("The Select component expects an array as the value prop. For more information, please visit the docs at https://baseweb.design/components/select/");
      var f = getOverrides(h.Root, StyledRoot), AA = _slicedToArray$5(f, 2), gA = AA[0], IA = AA[1], BA = getOverrides(h.ControlContainer, StyledControlContainer), CA = _slicedToArray$5(BA, 2), QA = CA[0], iA = CA[1], EA = getOverrides(h.ValueContainer, StyledValueContainer), oA = _slicedToArray$5(EA, 2), eA = oA[0], GA = oA[1], cA = getOverrides(h.IconsContainer, StyledIconsContainer), tA = _slicedToArray$5(cA, 2), aA = tA[0], sA = tA[1], DA = getOverrides(h.Popover, Popover$2), rA = _slicedToArray$5(DA, 2), nA = rA[0], NA = rA[1], pA = getOverrides(h.Placeholder, StyledPlaceholder), mA = _slicedToArray$5(pA, 2), XA = mA[0], lA = mA[1], kA = this.getSharedProps(), ZA = this.getValueArray(M), wA = this.filterOptions(k && H ? ZA : null), LA = this.state.isOpen;
      return kA.$isOpen = LA, process.env.NODE_ENV !== "production" && this.props.error && this.props.positive && console.warn("[Select] `error` and `positive` are both set to `true`. `error` will take precedence but this may not be what you want."), /* @__PURE__ */ React.createElement(UIDConsumer, null, function(fA) {
        return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(dA) {
          return /* @__PURE__ */ React.createElement(
            nA,
            _extends$7({
              innerRef: function(KA) {
                KA && (e.anchor = KA.anchorRef);
              },
              accessibilityType: ACCESSIBILITY_TYPE.none,
              autoFocus: !1,
              focusLock: !1,
              mountNode: e.props.mountNode,
              onEsc: function() {
                return e.closeMenu();
              },
              isOpen: LA,
              popoverMargin: 0,
              content: function() {
                var KA = {
                  error: e.props.error,
                  positive: e.props.positive,
                  getOptionLabel: e.props.getOptionLabel || e.getOptionLabel.bind(e, dA),
                  id: fA,
                  isLoading: e.props.isLoading,
                  labelKey: e.props.labelKey,
                  maxDropdownHeight: e.props.maxDropdownHeight,
                  multi: k,
                  noResultsMsg: p,
                  onActiveDescendantChange: e.handleActiveDescendantChange,
                  onItemSelect: e.selectValue,
                  options: wA,
                  overrides: h,
                  required: e.props.required,
                  searchable: e.props.searchable,
                  size: e.props.size,
                  type: d,
                  value: ZA,
                  valueKey: e.props.valueKey,
                  width: e.anchor.current ? e.anchor.current.clientWidth : null,
                  keyboardControlNode: e.anchor
                };
                return /* @__PURE__ */ React.createElement(SelectDropdown, _extends$7({
                  innerRef: e.dropdown
                }, KA));
              },
              placement: PLACEMENT$1.bottom
            }, NA),
            /* @__PURE__ */ React.createElement(gA, _extends$7({
              onBlur: e.handleBlur,
              "data-baseweb": "select"
            }, kA, IA), /* @__PURE__ */ React.createElement(QA, _extends$7({
              onKeyDown: e.handleKeyDown,
              onClick: e.handleClick,
              onTouchEnd: e.handleTouchEnd,
              onTouchMove: e.handleTouchMove,
              onTouchStart: e.handleTouchStart
            }, kA, iA), d === TYPE.search ? e.renderSearch() : null, /* @__PURE__ */ React.createElement(eA, _extends$7({}, kA, GA), e.renderValue(ZA), e.renderInput(fA), e.shouldShowPlaceholder() ? /* @__PURE__ */ React.createElement(XA, _extends$7({}, kA, lA), typeof e.props.placeholder < "u" ? e.props.placeholder : dA.select.placeholder) : null), /* @__PURE__ */ React.createElement(aA, _extends$7({}, kA, sA), e.renderLoading(), e.renderClear(), d === TYPE.select ? e.renderArrow() : null)))
          );
        });
      });
    }
  }]), g;
})(React.Component);
_defineProperty$5(Select$1, "defaultProps", defaultProps);
var tint$1 = { exports: {} }, _curry = { exports: {} }, hasRequired_curry;
function require_curry() {
  return hasRequired_curry || (hasRequired_curry = 1, (function(o, i) {
    i.__esModule = !0, i.default = E;
    function g(e, t, n) {
      return function() {
        var d = n.concat(Array.prototype.slice.call(arguments));
        return d.length >= t ? e.apply(this, d) : g(e, t, d);
      };
    }
    function E(e) {
      return g(e, e.length, []);
    }
    o.exports = i.default;
  })(_curry, _curry.exports)), _curry.exports;
}
var mix = { exports: {} }, rgba = { exports: {} }, parseToRgb = { exports: {} }, _hslToRgb = { exports: {} }, hasRequired_hslToRgb;
function require_hslToRgb() {
  return hasRequired_hslToRgb || (hasRequired_hslToRgb = 1, (function(o, i) {
    i.__esModule = !0, i.default = void 0;
    function g(n) {
      return Math.round(n * 255);
    }
    function E(n, h, d) {
      return g(n) + "," + g(h) + "," + g(d);
    }
    function e(n, h, d, k) {
      if (k === void 0 && (k = E), h === 0)
        return k(d, d, d);
      var p = (n % 360 + 360) % 360 / 60, M = (1 - Math.abs(2 * d - 1)) * h, H = M * (1 - Math.abs(p % 2 - 1)), f = 0, AA = 0, gA = 0;
      p >= 0 && p < 1 ? (f = M, AA = H) : p >= 1 && p < 2 ? (f = H, AA = M) : p >= 2 && p < 3 ? (AA = M, gA = H) : p >= 3 && p < 4 ? (AA = H, gA = M) : p >= 4 && p < 5 ? (f = H, gA = M) : p >= 5 && p < 6 && (f = M, gA = H);
      var IA = d - M / 2, BA = f + IA, CA = AA + IA, QA = gA + IA;
      return k(BA, CA, QA);
    }
    var t = e;
    i.default = t, o.exports = i.default;
  })(_hslToRgb, _hslToRgb.exports)), _hslToRgb.exports;
}
var _nameToHex = { exports: {} }, hasRequired_nameToHex;
function require_nameToHex() {
  return hasRequired_nameToHex || (hasRequired_nameToHex = 1, (function(o, i) {
    i.__esModule = !0, i.default = void 0;
    var g = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "639",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    };
    function E(t) {
      if (typeof t != "string") return t;
      var n = t.toLowerCase();
      return g[n] ? "#" + g[n] : t;
    }
    var e = E;
    i.default = e, o.exports = i.default;
  })(_nameToHex, _nameToHex.exports)), _nameToHex.exports;
}
var _errors = { exports: {} }, hasRequired_errors;
function require_errors() {
  return hasRequired_errors || (hasRequired_errors = 1, (function(o, i) {
    i.__esModule = !0, i.default = void 0;
    function g(f) {
      if (f === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return f;
    }
    function E(f, AA) {
      f.prototype = Object.create(AA.prototype), f.prototype.constructor = f, d(f, AA);
    }
    function e(f) {
      var AA = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
      return e = function(IA) {
        if (IA === null || !h(IA)) return IA;
        if (typeof IA != "function")
          throw new TypeError("Super expression must either be null or a function");
        if (typeof AA < "u") {
          if (AA.has(IA)) return AA.get(IA);
          AA.set(IA, BA);
        }
        function BA() {
          return t(IA, arguments, k(this).constructor);
        }
        return BA.prototype = Object.create(IA.prototype, { constructor: { value: BA, enumerable: !1, writable: !0, configurable: !0 } }), d(BA, IA);
      }, e(f);
    }
    function t(f, AA, gA) {
      return n() ? t = Reflect.construct : t = function(BA, CA, QA) {
        var iA = [null];
        iA.push.apply(iA, CA);
        var EA = Function.bind.apply(BA, iA), oA = new EA();
        return QA && d(oA, QA.prototype), oA;
      }, t.apply(null, arguments);
    }
    function n() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function h(f) {
      return Function.toString.call(f).indexOf("[native code]") !== -1;
    }
    function d(f, AA) {
      return d = Object.setPrototypeOf || function(IA, BA) {
        return IA.__proto__ = BA, IA;
      }, d(f, AA);
    }
    function k(f) {
      return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(gA) {
        return gA.__proto__ || Object.getPrototypeOf(gA);
      }, k(f);
    }
    var p = {
      1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
      2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
      3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
      4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
      5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
      6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
      7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
      8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
      9: `Please provide a number of steps to the modularScale helper.

`,
      10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
      11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
      12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
      13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
      14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
      15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
      16: `You must provide a template to this method.

`,
      17: `You passed an unsupported selector state to this method.

`,
      18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
      19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
      20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
      21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      23: `fontFace expects a name of a font-family.

`,
      24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
      25: `fontFace expects localFonts to be an array.

`,
      26: `fontFace expects fileFormats to be an array.

`,
      27: `radialGradient requries at least 2 color-stops to properly render.

`,
      28: `Please supply a filename to retinaImage() as the first argument.

`,
      29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
      30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
      32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
      33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
      34: `borderRadius expects a radius value as a string or number as the second argument.

`,
      35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
      36: `Property must be a string value.

`,
      37: `Syntax Error at %s.

`,
      38: `Formula contains a function that needs parentheses at %s.

`,
      39: `Formula is missing closing parenthesis at %s.

`,
      40: `Formula has too many closing parentheses at %s.

`,
      41: `All values in a formula must have the same unit or be unitless.

`,
      42: `Please provide a number of steps to the modularScale helper.

`,
      43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
      44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
      45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
      46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
      47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
      48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
      49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
      50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
      51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
      52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
      53: `fontFace expects localFonts to be an array.

`,
      54: `fontFace expects fileFormats to be an array.

`,
      55: `fontFace expects a name of a font-family.

`,
      56: `linearGradient requries at least 2 color-stops to properly render.

`,
      57: `radialGradient requries at least 2 color-stops to properly render.

`,
      58: `Please supply a filename to retinaImage() as the first argument.

`,
      59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
      60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      61: `Property must be a string value.

`,
      62: `borderRadius expects a radius value as a string or number as the second argument.

`,
      63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
      64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
      65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
      66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
      67: `You must provide a template to this method.

`,
      68: `You passed an unsupported selector state to this method.

`,
      69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
      70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
      71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
      72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
      73: `Please provide a valid CSS variable.

`,
      74: `CSS variable not found.

`,
      75: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.
`
    };
    function M() {
      for (var f = arguments.length, AA = new Array(f), gA = 0; gA < f; gA++)
        AA[gA] = arguments[gA];
      var IA = AA[0], BA = [], CA;
      for (CA = 1; CA < AA.length; CA += 1)
        BA.push(AA[CA]);
      return BA.forEach(function(QA) {
        IA = IA.replace(/%[a-z]/, QA);
      }), IA;
    }
    var H = /* @__PURE__ */ (function(f) {
      E(AA, f);
      function AA(gA) {
        var IA;
        if (process.env.NODE_ENV === "production")
          IA = f.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + gA + " for more information.") || this;
        else {
          for (var BA = arguments.length, CA = new Array(BA > 1 ? BA - 1 : 0), QA = 1; QA < BA; QA++)
            CA[QA - 1] = arguments[QA];
          IA = f.call(this, M.apply(void 0, [p[gA]].concat(CA))) || this;
        }
        return g(IA);
      }
      return AA;
    })(/* @__PURE__ */ e(Error));
    i.default = H, o.exports = i.default;
  })(_errors, _errors.exports)), _errors.exports;
}
var hasRequiredParseToRgb;
function requireParseToRgb() {
  return hasRequiredParseToRgb || (hasRequiredParseToRgb = 1, (function(o, i) {
    i.__esModule = !0, i.default = AA;
    var g = /* @__PURE__ */ t(/* @__PURE__ */ require_hslToRgb()), E = /* @__PURE__ */ t(/* @__PURE__ */ require_nameToHex()), e = /* @__PURE__ */ t(/* @__PURE__ */ require_errors());
    function t(gA) {
      return gA && gA.__esModule ? gA : { default: gA };
    }
    var n = /^#[a-fA-F0-9]{6}$/, h = /^#[a-fA-F0-9]{8}$/, d = /^#[a-fA-F0-9]{3}$/, k = /^#[a-fA-F0-9]{4}$/, p = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i, M = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i, H = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, f = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
    function AA(gA) {
      if (typeof gA != "string")
        throw new e.default(3);
      var IA = (0, E.default)(gA);
      if (IA.match(n))
        return {
          red: parseInt("" + IA[1] + IA[2], 16),
          green: parseInt("" + IA[3] + IA[4], 16),
          blue: parseInt("" + IA[5] + IA[6], 16)
        };
      if (IA.match(h)) {
        var BA = parseFloat((parseInt("" + IA[7] + IA[8], 16) / 255).toFixed(2));
        return {
          red: parseInt("" + IA[1] + IA[2], 16),
          green: parseInt("" + IA[3] + IA[4], 16),
          blue: parseInt("" + IA[5] + IA[6], 16),
          alpha: BA
        };
      }
      if (IA.match(d))
        return {
          red: parseInt("" + IA[1] + IA[1], 16),
          green: parseInt("" + IA[2] + IA[2], 16),
          blue: parseInt("" + IA[3] + IA[3], 16)
        };
      if (IA.match(k)) {
        var CA = parseFloat((parseInt("" + IA[4] + IA[4], 16) / 255).toFixed(2));
        return {
          red: parseInt("" + IA[1] + IA[1], 16),
          green: parseInt("" + IA[2] + IA[2], 16),
          blue: parseInt("" + IA[3] + IA[3], 16),
          alpha: CA
        };
      }
      var QA = p.exec(IA);
      if (QA)
        return {
          red: parseInt("" + QA[1], 10),
          green: parseInt("" + QA[2], 10),
          blue: parseInt("" + QA[3], 10)
        };
      var iA = M.exec(IA.substring(0, 50));
      if (iA)
        return {
          red: parseInt("" + iA[1], 10),
          green: parseInt("" + iA[2], 10),
          blue: parseInt("" + iA[3], 10),
          alpha: parseFloat("" + iA[4])
        };
      var EA = H.exec(IA);
      if (EA) {
        var oA = parseInt("" + EA[1], 10), eA = parseInt("" + EA[2], 10) / 100, GA = parseInt("" + EA[3], 10) / 100, cA = "rgb(" + (0, g.default)(oA, eA, GA) + ")", tA = p.exec(cA);
        if (!tA)
          throw new e.default(4, IA, cA);
        return {
          red: parseInt("" + tA[1], 10),
          green: parseInt("" + tA[2], 10),
          blue: parseInt("" + tA[3], 10)
        };
      }
      var aA = f.exec(IA.substring(0, 50));
      if (aA) {
        var sA = parseInt("" + aA[1], 10), DA = parseInt("" + aA[2], 10) / 100, rA = parseInt("" + aA[3], 10) / 100, nA = "rgb(" + (0, g.default)(sA, DA, rA) + ")", NA = p.exec(nA);
        if (!NA)
          throw new e.default(4, IA, nA);
        return {
          red: parseInt("" + NA[1], 10),
          green: parseInt("" + NA[2], 10),
          blue: parseInt("" + NA[3], 10),
          alpha: parseFloat("" + aA[4])
        };
      }
      throw new e.default(5);
    }
    o.exports = i.default;
  })(parseToRgb, parseToRgb.exports)), parseToRgb.exports;
}
var rgb = { exports: {} }, _reduceHexValue = { exports: {} }, hasRequired_reduceHexValue;
function require_reduceHexValue() {
  return hasRequired_reduceHexValue || (hasRequired_reduceHexValue = 1, (function(o, i) {
    i.__esModule = !0, i.default = void 0;
    var g = function(t) {
      return t.length === 7 && t[1] === t[2] && t[3] === t[4] && t[5] === t[6] ? "#" + t[1] + t[3] + t[5] : t;
    }, E = g;
    i.default = E, o.exports = i.default;
  })(_reduceHexValue, _reduceHexValue.exports)), _reduceHexValue.exports;
}
var _numberToHex = { exports: {} }, hasRequired_numberToHex;
function require_numberToHex() {
  return hasRequired_numberToHex || (hasRequired_numberToHex = 1, (function(o, i) {
    i.__esModule = !0, i.default = void 0;
    function g(e) {
      var t = e.toString(16);
      return t.length === 1 ? "0" + t : t;
    }
    var E = g;
    i.default = E, o.exports = i.default;
  })(_numberToHex, _numberToHex.exports)), _numberToHex.exports;
}
var hasRequiredRgb;
function requireRgb() {
  return hasRequiredRgb || (hasRequiredRgb = 1, (function(o, i) {
    i.__esModule = !0, i.default = n;
    var g = /* @__PURE__ */ t(/* @__PURE__ */ require_reduceHexValue()), E = /* @__PURE__ */ t(/* @__PURE__ */ require_numberToHex()), e = /* @__PURE__ */ t(/* @__PURE__ */ require_errors());
    function t(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function n(h, d, k) {
      if (typeof h == "number" && typeof d == "number" && typeof k == "number")
        return (0, g.default)("#" + (0, E.default)(h) + (0, E.default)(d) + (0, E.default)(k));
      if (typeof h == "object" && d === void 0 && k === void 0)
        return (0, g.default)("#" + (0, E.default)(h.red) + (0, E.default)(h.green) + (0, E.default)(h.blue));
      throw new e.default(6);
    }
    o.exports = i.default;
  })(rgb, rgb.exports)), rgb.exports;
}
var hasRequiredRgba;
function requireRgba() {
  return hasRequiredRgba || (hasRequiredRgba = 1, (function(o, i) {
    i.__esModule = !0, i.default = n;
    var g = /* @__PURE__ */ t(/* @__PURE__ */ requireParseToRgb()), E = /* @__PURE__ */ t(/* @__PURE__ */ requireRgb()), e = /* @__PURE__ */ t(/* @__PURE__ */ require_errors());
    function t(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function n(h, d, k, p) {
      if (typeof h == "string" && typeof d == "number") {
        var M = (0, g.default)(h);
        return "rgba(" + M.red + "," + M.green + "," + M.blue + "," + d + ")";
      } else {
        if (typeof h == "number" && typeof d == "number" && typeof k == "number" && typeof p == "number")
          return p >= 1 ? (0, E.default)(h, d, k) : "rgba(" + h + "," + d + "," + k + "," + p + ")";
        if (typeof h == "object" && d === void 0 && k === void 0 && p === void 0)
          return h.alpha >= 1 ? (0, E.default)(h.red, h.green, h.blue) : "rgba(" + h.red + "," + h.green + "," + h.blue + "," + h.alpha + ")";
      }
      throw new e.default(7);
    }
    o.exports = i.default;
  })(rgba, rgba.exports)), rgba.exports;
}
var hasRequiredMix;
function requireMix() {
  return hasRequiredMix || (hasRequiredMix = 1, (function(o, i) {
    i.__esModule = !0, i.default = void 0;
    var g = /* @__PURE__ */ t(/* @__PURE__ */ require_curry()), E = /* @__PURE__ */ t(/* @__PURE__ */ requireRgba()), e = /* @__PURE__ */ t(/* @__PURE__ */ requireParseToRgb());
    function t(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n() {
      return n = Object.assign || function(p) {
        for (var M = 1; M < arguments.length; M++) {
          var H = arguments[M];
          for (var f in H)
            Object.prototype.hasOwnProperty.call(H, f) && (p[f] = H[f]);
        }
        return p;
      }, n.apply(this, arguments);
    }
    function h(p, M, H) {
      if (M === "transparent") return H;
      if (H === "transparent") return M;
      if (p === 0) return H;
      var f = (0, e.default)(M), AA = n({}, f, {
        alpha: typeof f.alpha == "number" ? f.alpha : 1
      }), gA = (0, e.default)(H), IA = n({}, gA, {
        alpha: typeof gA.alpha == "number" ? gA.alpha : 1
      }), BA = AA.alpha - IA.alpha, CA = parseFloat(p) * 2 - 1, QA = CA * BA === -1 ? CA : CA + BA, iA = 1 + CA * BA, EA = (QA / iA + 1) / 2, oA = 1 - EA, eA = {
        red: Math.floor(AA.red * EA + IA.red * oA),
        green: Math.floor(AA.green * EA + IA.green * oA),
        blue: Math.floor(AA.blue * EA + IA.blue * oA),
        alpha: AA.alpha * (parseFloat(p) / 1) + IA.alpha * (1 - parseFloat(p) / 1)
      };
      return (0, E.default)(eA);
    }
    var d = /* @__PURE__ */ (0, g.default)(h), k = d;
    i.default = k, o.exports = i.default;
  })(mix, mix.exports)), mix.exports;
}
var hasRequiredTint;
function requireTint() {
  return hasRequiredTint || (hasRequiredTint = 1, (function(o, i) {
    i.__esModule = !0, i.default = void 0;
    var g = /* @__PURE__ */ e(/* @__PURE__ */ require_curry()), E = /* @__PURE__ */ e(/* @__PURE__ */ requireMix());
    function e(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function t(d, k) {
      return k === "transparent" ? k : (0, E.default)(parseFloat(d), "rgb(255, 255, 255)", k);
    }
    var n = /* @__PURE__ */ (0, g.default)(t), h = n;
    i.default = h, o.exports = i.default;
  })(tint$1, tint$1.exports)), tint$1.exports;
}
var tintExports = /* @__PURE__ */ requireTint();
const tint = /* @__PURE__ */ getDefaultExportFromCjs(tintExports);
var shade$1 = { exports: {} }, hasRequiredShade;
function requireShade() {
  return hasRequiredShade || (hasRequiredShade = 1, (function(o, i) {
    i.__esModule = !0, i.default = void 0;
    var g = /* @__PURE__ */ e(/* @__PURE__ */ require_curry()), E = /* @__PURE__ */ e(/* @__PURE__ */ requireMix());
    function e(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function t(d, k) {
      return k === "transparent" ? k : (0, E.default)(parseFloat(d), "rgb(0, 0, 0)", k);
    }
    var n = /* @__PURE__ */ (0, g.default)(t), h = n;
    i.default = h, o.exports = i.default;
  })(shade$1, shade$1.exports)), shade$1.exports;
}
var shadeExports = /* @__PURE__ */ requireShade();
const shade = /* @__PURE__ */ getDefaultExportFromCjs(shadeExports);
var SIZE = {
  small: "small",
  medium: "medium",
  large: "large"
}, VARIANT = Object.freeze({
  solid: "solid",
  light: "light",
  outlined: "outlined"
}), KIND = {
  custom: "custom",
  // semantic
  neutral: "neutral",
  primary: "primary",
  accent: "accent",
  positive: "positive",
  warning: "warning",
  negative: "negative",
  // primitive
  black: "black",
  blue: "blue",
  green: "green",
  red: "red",
  yellow: "yellow",
  orange: "orange",
  purple: "purple",
  brown: "brown"
}, _neutralColorStates, _primaryColorStates, _accentColorStates, _positiveColorStates, _warningColorStates, _negativeColorStates, _orangeColorStates, _purpleColorStates, _brownColorStates, _customColorStates, _colorMap;
function ownKeys$4(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$2(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(g), !0).forEach(function(E) {
      _defineProperty$4(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$4(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty$4(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function customOnRamp(o, i) {
  switch (i) {
    case "0":
      return "white";
    case "50":
      return tint(0.8, o);
    case "100":
      return tint(0.6, o);
    case "200":
      return tint(0.4, o);
    case "300":
      return tint(0.2, o);
    case "400":
      return o;
    case "500":
      return shade(0.2, o);
    case "600":
      return shade(0.4, o);
    case "700":
      return shade(0.6, o);
    case "800":
      return shade(0.8, o);
    case "1000":
      return "black";
    default:
      return o;
  }
}
var COLOR_STATE = {
  disabled: "disabled",
  solid: "solid",
  outline: "outline"
}, pick = function o(i, g, E) {
  return i.name && i.name.includes("dark") ? E : g;
}, neutralColorStates = (_neutralColorStates = {}, _defineProperty$4(_neutralColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: o.colors.tagNeutralFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagNeutralOutlinedDisabled
  };
}), _defineProperty$4(_neutralColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: o.colors.tagNeutralSolidFont,
    backgroundColor: o.colors.tagNeutralSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_neutralColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: o.colors.tagNeutralOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagNeutralOutlinedBackground
  };
}), _neutralColorStates), primaryColorStates = (_primaryColorStates = {}, _defineProperty$4(_primaryColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: o.colors.tagPrimaryFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagPrimaryOutlinedDisabled
  };
}), _defineProperty$4(_primaryColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: o.colors.tagPrimarySolidFont,
    backgroundColor: o.colors.tagPrimarySolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_primaryColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: o.colors.tagPrimaryOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagPrimaryOutlinedBackground
  };
}), _primaryColorStates), accentColorStates = (_accentColorStates = {}, _defineProperty$4(_accentColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: o.colors.tagAccentFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagAccentOutlinedDisabled
  };
}), _defineProperty$4(_accentColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: o.colors.tagAccentSolidFont,
    backgroundColor: o.colors.tagAccentSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_accentColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: o.colors.tagAccentOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagAccentOutlinedBackground
  };
}), _accentColorStates), positiveColorStates = (_positiveColorStates = {}, _defineProperty$4(_positiveColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: o.colors.tagPositiveFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagPositiveOutlinedDisabled
  };
}), _defineProperty$4(_positiveColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: o.colors.tagPositiveSolidFont,
    backgroundColor: o.colors.tagPositiveSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_positiveColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: o.colors.tagPositiveOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagPositiveOutlinedBackground
  };
}), _positiveColorStates), warningColorStates = (_warningColorStates = {}, _defineProperty$4(_warningColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: o.colors.tagWarningFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagWarningOutlinedDisabled
  };
}), _defineProperty$4(_warningColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: o.colors.tagWarningSolidFont,
    backgroundColor: o.colors.tagWarningSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_warningColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: o.colors.tagWarningOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagWarningOutlinedBackground
  };
}), _warningColorStates), negativeColorStates = (_negativeColorStates = {}, _defineProperty$4(_negativeColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: o.colors.tagNegativeFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagNegativeOutlinedDisabled
  };
}), _defineProperty$4(_negativeColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: o.colors.tagNegativeSolidFont,
    backgroundColor: o.colors.tagNegativeSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_negativeColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: o.colors.tagNegativeOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagNegativeOutlinedBackground
  };
}), _negativeColorStates), orangeColorStates = (_orangeColorStates = {}, _defineProperty$4(_orangeColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: pick(o, colors$3.orange200, colors$3.orange600),
    backgroundColor: null,
    borderColor: pick(o, colors$3.orange200, colors$3.orange700)
  };
}), _defineProperty$4(_orangeColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: colors$3.white,
    backgroundColor: pick(o, colors$3.orange400, colors$3.orange500),
    borderColor: null
  };
}), _defineProperty$4(_orangeColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: pick(o, colors$3.orange400, colors$3.orange300),
    backgroundColor: null,
    borderColor: pick(o, colors$3.orange200, colors$3.orange500)
  };
}), _orangeColorStates), purpleColorStates = (_purpleColorStates = {}, _defineProperty$4(_purpleColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: pick(o, colors$3.purple200, colors$3.purple600),
    backgroundColor: null,
    borderColor: pick(o, colors$3.purple200, colors$3.purple700)
  };
}), _defineProperty$4(_purpleColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: colors$3.white,
    backgroundColor: pick(o, colors$3.purple400, colors$3.purple500),
    borderColor: null
  };
}), _defineProperty$4(_purpleColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: pick(o, colors$3.purple400, colors$3.purple300),
    backgroundColor: null,
    borderColor: pick(o, colors$3.purple200, colors$3.purple500)
  };
}), _purpleColorStates), brownColorStates = (_brownColorStates = {}, _defineProperty$4(_brownColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: pick(o, colors$3.brown200, colors$3.brown600),
    backgroundColor: null,
    borderColor: pick(o, colors$3.brown200, colors$3.brown700)
  };
}), _defineProperty$4(_brownColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: colors$3.white,
    backgroundColor: pick(o, colors$3.brown400, colors$3.brown500),
    borderColor: null
  };
}), _defineProperty$4(_brownColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: pick(o, colors$3.brown400, colors$3.brown300),
    backgroundColor: null,
    borderColor: pick(o, colors$3.brown200, colors$3.brown500)
  };
}), _brownColorStates), customColorStates = (_customColorStates = {}, _defineProperty$4(_customColorStates, COLOR_STATE.disabled, function(o, i) {
  return {
    color: customOnRamp(i, o.colors.tagFontDisabledRampUnit),
    backgroundColor: null,
    borderColor: customOnRamp(i, o.colors.tagSolidDisabledRampUnit)
  };
}), _defineProperty$4(_customColorStates, COLOR_STATE.solid, function(o, i) {
  return {
    color: customOnRamp(i, o.colors.tagSolidFontRampUnit),
    backgroundColor: customOnRamp(i, o.colors.tagSolidRampUnit),
    borderColor: null
  };
}), _defineProperty$4(_customColorStates, COLOR_STATE.outline, function(o, i) {
  return {
    color: customOnRamp(i, o.colors.tagOutlinedFontRampUnit),
    backgroundColor: null,
    borderColor: customOnRamp(i, o.colors.tagOutlinedRampUnit)
  };
}), _customColorStates), colorMap = (_colorMap = {}, _defineProperty$4(_colorMap, KIND.neutral, neutralColorStates), _defineProperty$4(_colorMap, KIND.primary, primaryColorStates), _defineProperty$4(_colorMap, KIND.accent, accentColorStates), _defineProperty$4(_colorMap, KIND.positive, positiveColorStates), _defineProperty$4(_colorMap, KIND.warning, warningColorStates), _defineProperty$4(_colorMap, KIND.negative, negativeColorStates), _defineProperty$4(_colorMap, KIND.black, primaryColorStates), _defineProperty$4(_colorMap, KIND.blue, accentColorStates), _defineProperty$4(_colorMap, KIND.green, positiveColorStates), _defineProperty$4(_colorMap, KIND.red, negativeColorStates), _defineProperty$4(_colorMap, KIND.yellow, warningColorStates), _defineProperty$4(_colorMap, KIND.orange, orangeColorStates), _defineProperty$4(_colorMap, KIND.purple, purpleColorStates), _defineProperty$4(_colorMap, KIND.brown, brownColorStates), _defineProperty$4(_colorMap, KIND.custom, customColorStates), _colorMap), getColorStateFromProps = function o(i) {
  return i.$disabled ? COLOR_STATE.disabled : i.$variant === VARIANT.solid ? COLOR_STATE.solid : COLOR_STATE.outline;
}, Action$1 = styled("span", function(o) {
  var i, g, E = o.$theme, e = o.$disabled, t = o.$size, n = t === void 0 ? SIZE.small : t, h = E.direction === "rtl" ? "borderBottomLeftRadius" : "borderBottomRightRadius", d = E.direction === "rtl" ? "borderTopLeftRadius" : "borderTopRightRadius", k = E.direction === "rtl" ? "marginRight" : "marginLeft";
  return g = {
    alignItems: "center"
  }, _defineProperty$4(g, h, E.borders.useRoundedCorners ? E.borders.radius400 : 0), _defineProperty$4(g, d, E.borders.useRoundedCorners ? E.borders.radius400 : 0), _defineProperty$4(g, "cursor", e ? "not-allowed" : "pointer"), _defineProperty$4(g, "display", "flex"), _defineProperty$4(g, k, (i = {}, _defineProperty$4(i, SIZE.small, "8px"), _defineProperty$4(i, SIZE.medium, "12px"), _defineProperty$4(i, SIZE.large, "16px"), i)[n]), _defineProperty$4(g, "outline", "none"), _defineProperty$4(g, "transitionProperty", "all"), _defineProperty$4(g, "transitionDuration", "background-color"), _defineProperty$4(g, "transitionTimingFunction", E.animation.easeOutCurve), g;
});
Action$1.displayName = "Action";
Action$1.displayName = "Action";
var StartEnhancerContainer = styled("div", function(o) {
  var i = o.$theme, g = o.$size, E = g === void 0 ? SIZE.small : g, e = i.sizing.scale300;
  E === SIZE.medium ? e = i.sizing.scale400 : E === SIZE.large && (e = i.sizing.scale600);
  var t = i.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return _defineProperty$4({
    alignItems: "center",
    display: "flex"
  }, t, e);
});
StartEnhancerContainer.displayName = "StartEnhancerContainer";
StartEnhancerContainer.displayName = "StartEnhancerContainer";
var Text = styled("span", function(o) {
  var i = o.$theme;
  return {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: o.$theme.sizing.scale3200,
    order: i.direction === "rtl" ? 1 : 0
  };
});
Text.displayName = "Text";
Text.displayName = "Text";
var Root$1 = styled("span", function(o) {
  var i, g, E, e = o.$theme, t = o.$kind, n = t === void 0 ? KIND.primary : t, h = o.$clickable, d = o.$variant, k = o.$disabled, p = o.$closeable, M = o.$isFocusVisible, H = o.$color, f = o.$size, AA = f === void 0 ? SIZE.small : f, gA = e.borders.tagBorderRadius, IA = (i = {}, _defineProperty$4(i, SIZE.small, e.sizing.scale300), _defineProperty$4(i, SIZE.medium, e.sizing.scale500), _defineProperty$4(i, SIZE.large, e.sizing.scale600), i)[AA], BA = !k && d === VARIANT.solid ? 0 : "2px", CA = colorMap[n][getColorStateFromProps(o)](e, H), QA = CA.color, iA = CA.backgroundColor, EA = CA.borderColor;
  return _objectSpread$2(_objectSpread$2({}, (g = {}, _defineProperty$4(g, SIZE.small, e.typography.LabelSmall), _defineProperty$4(g, SIZE.medium, e.typography.LabelMedium), _defineProperty$4(g, SIZE.large, e.typography.LabelLarge), g)[AA]), {}, {
    alignItems: "center",
    color: QA,
    backgroundColor: iA,
    borderLeftColor: EA,
    borderRightColor: EA,
    borderTopColor: EA,
    borderBottomColor: EA,
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftWidth: BA,
    borderRightWidth: BA,
    borderTopWidth: BA,
    borderBottomWidth: BA,
    borderTopLeftRadius: gA,
    borderTopRightRadius: gA,
    borderBottomRightRadius: gA,
    borderBottomLeftRadius: gA,
    boxSizing: "border-box",
    cursor: k ? "not-allowed" : h ? "pointer" : "default",
    display: "inline-flex",
    height: (E = {}, _defineProperty$4(E, SIZE.small, "24px"), _defineProperty$4(E, SIZE.medium, "32px"), _defineProperty$4(E, SIZE.large, "40px"), E)[AA],
    justifyContent: "space-between",
    marginTop: "5px",
    marginBottom: "5px",
    marginLeft: "5px",
    marginRight: "5px",
    paddingTop: e.sizing.scale0,
    paddingBottom: e.sizing.scale0,
    paddingLeft: IA,
    paddingRight: IA,
    outline: "none",
    ":hover": k || !h ? {} : {
      boxShadow: "inset 0px 0px 100px ".concat(pick(e, "rgba(0, 0, 0, 0.08)", "rgba(255, 255, 255, 0.2)"))
    },
    ":focus": k || !h && !p ? {} : {
      boxShadow: M ? "0 0 0 3px ".concat(n === KIND.accent ? e.colors.primaryA : e.colors.accent) : "none"
    }
  });
});
Root$1.displayName = "Root";
Root$1.displayName = "Root";
function _typeof$2(o) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$2(o);
}
var JOINABLE_TYPES = /* @__PURE__ */ new Set(["string", "number"]);
function getTextFromChildren(o) {
  var i = React.Children.toArray(o).filter(function(E) {
    return E != null;
  });
  if (!i.length)
    return null;
  var g = i.every(function(E) {
    return JOINABLE_TYPES.has(_typeof$2(E));
  });
  return g ? i.join("") : null;
}
function _defineProperty$3(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
function _slicedToArray$4(o, i) {
  return _arrayWithHoles$3(o) || _iterableToArrayLimit$3(o, i) || _unsupportedIterableToArray$3(o, i) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$3(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$3(o, i);
  }
}
function _arrayLikeToArray$3(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$3(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$3(o) {
  if (Array.isArray(o)) return o;
}
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$6.apply(this, arguments);
}
var ModifiedViewBoxDeleteIcon = function o(i) {
  return /* @__PURE__ */ React.createElement(DeleteIcon, _extends$6({
    viewBox: "5 5 13.186 13.186"
  }, i));
}, Tag = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g, E = o.children, e = o.closeable, t = e === void 0 ? !0 : e, n = o.color, h = o.size, d = h === void 0 ? SIZE.small : h, k = o.disabled, p = k === void 0 ? !1 : k, M = o.isFocused, H = M === void 0 ? !1 : M, f = o.isHovered, AA = f === void 0 ? !1 : f, gA = o.kind, IA = gA === void 0 ? KIND.primary : gA, BA = o.onActionClick, CA = BA === void 0 ? function(PA) {
  } : BA, QA = o.onActionKeyDown, iA = QA === void 0 ? function(PA) {
  } : QA, EA = o.onClick, oA = EA === void 0 ? null : EA, eA = o.onKeyDown, GA = eA === void 0 ? null : eA, cA = o.overrides, tA = cA === void 0 ? {} : cA, aA = o.startEnhancer, sA = o.title, DA = o.variant, rA = DA === void 0 ? VARIANT.light : DA, nA = React.useState(!1), NA = _slicedToArray$4(nA, 2), pA = NA[0], mA = NA[1];
  function XA(PA) {
    isFocusVisible(PA) && mA(!0);
  }
  function lA(PA) {
    pA !== !1 && mA(!1);
  }
  function kA(PA) {
    if (PA.currentTarget === PA.target) {
      var qA = PA.key;
      oA && qA === "Enter" && oA(PA), t && (qA === "Backspace" || qA === "Delete") && (CA(PA), iA(PA)), GA && GA(PA);
    }
  }
  var ZA = getOverrides(tA.Root, Root$1), wA = _slicedToArray$4(ZA, 2), LA = wA[0], fA = wA[1], dA = getOverrides(tA.Action, Action$1), RA = _slicedToArray$4(dA, 2), KA = RA[0], xA = RA[1], MA = getOverrides(tA.ActionIcon, ModifiedViewBoxDeleteIcon), OA = _slicedToArray$4(MA, 2), SA = OA[0], gg = OA[1], WA = getOverrides(tA.StartEnhancerContainer, StartEnhancerContainer), eg = _slicedToArray$4(WA, 2), ig = eg[0], $A = eg[1], ag = getOverrides(tA.Text, Text), Ig = _slicedToArray$4(ag, 2), tg = Ig[0], wg = Ig[1], hg = typeof oA == "function", Gg = p ? {} : {
    onClick: oA,
    onKeyDown: kA
  }, Ng = p ? {} : {
    onClick: function(qA) {
      qA.stopPropagation(), CA(qA);
    }
  }, Bg = {
    $clickable: hg,
    $closeable: t,
    $color: n,
    $disabled: p,
    $isFocused: H,
    $isHovered: AA,
    $kind: IA,
    $variant: rA,
    $isFocusVisible: pA,
    $size: d
  }, bA = sA || getTextFromChildren(E), HA = (hg || t) && !p, vA = (g = {}, _defineProperty$3(g, SIZE.small, 12), _defineProperty$3(g, SIZE.medium, 16), _defineProperty$3(g, SIZE.large, 20), g)[d], zA = aA;
  return /* @__PURE__ */ React.createElement(
    LA,
    _extends$6({
      ref: i,
      "data-baseweb": "tag",
      "aria-label": HA && t ? "".concat(typeof E == "string" ? "".concat(E, ", ") : "", "close by backspace") : null,
      "aria-disabled": p ? !0 : null,
      role: HA ? "button" : null,
      tabIndex: HA ? 0 : null
    }, Gg, Bg, fA, {
      onFocus: forkFocus(fA, XA),
      onBlur: forkBlur(fA, lA)
    }),
    zA && // @ts-expect-error todo(flow->ts) it is not expected to be a number
    zA !== 0 && /* @__PURE__ */ React.createElement(ig, $A, /* @__PURE__ */ React.createElement(zA, null)),
    /* @__PURE__ */ React.createElement(tg, _extends$6({
      title: bA
    }, wg), E),
    t ? /* @__PURE__ */ React.createElement(KA, _extends$6({
      "aria-hidden": !0,
      role: "presentation"
    }, Ng, Bg, xA), /* @__PURE__ */ React.createElement(SA, _extends$6({
      size: vA
    }, gg))) : null
  );
});
Tag.displayName = "Tag";
var _excluded$6 = ["overrides", "removeValue"];
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$5.apply(this, arguments);
}
function _slicedToArray$3(o, i) {
  return _arrayWithHoles$2(o) || _iterableToArrayLimit$2(o, i) || _unsupportedIterableToArray$2(o, i) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$2(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$2(o, i);
  }
}
function _arrayLikeToArray$2(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$2(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$2(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$4(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$3(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$3(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function MultiValue(o) {
  var i = o.overrides, g = i === void 0 ? {} : i, E = o.removeValue, e = _objectWithoutProperties$4(o, _excluded$6), t = getOverrides(g.Tag || g.MultiValue, Tag), n = _slicedToArray$3(t, 2), h = n[0], d = n[1];
  return /* @__PURE__ */ React.createElement(h, _extends$5({
    variant: VARIANT.solid,
    overrides: {
      Root: {
        style: function(p) {
          var M = p.$theme.sizing;
          return {
            marginRight: M.scale0,
            marginBottom: M.scale0,
            marginLeft: M.scale0,
            marginTop: M.scale0
          };
        }
      }
    },
    onActionClick: E
  }, e, d), o.children);
}
var _excluded$5 = ["overrides"];
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$4.apply(this, arguments);
}
function _slicedToArray$2(o, i) {
  return _arrayWithHoles$1(o) || _iterableToArrayLimit$1(o, i) || _unsupportedIterableToArray$1(o, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$1(o, i);
    var g = Object.prototype.toString.call(o).slice(8, -1);
    if (g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set") return Array.from(o);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$1(o, i);
  }
}
function _arrayLikeToArray$1(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = new Array(i); g < i; g++)
    E[g] = o[g];
  return E;
}
function _iterableToArrayLimit$1(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E = [], e = !0, t = !1, n, h;
    try {
      for (g = g.call(o); !(e = (n = g.next()).done) && (E.push(n.value), !(i && E.length === i)); e = !0)
        ;
    } catch (d) {
      t = !0, h = d;
    } finally {
      try {
        !e && g.return != null && g.return();
      } finally {
        if (t) throw h;
      }
    }
    return E;
  }
}
function _arrayWithHoles$1(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$3(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose$2(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$2(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function Value(o) {
  var i = o.overrides, g = i === void 0 ? {} : i, E = _objectWithoutProperties$3(o, _excluded$5), e = getOverrides(g.SingleValue, StyledSingleValue), t = _slicedToArray$2(e, 2), n = t[0], h = t[1];
  return /* @__PURE__ */ React.createElement(n, _extends$4({}, E, h), o.children);
}
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$3.apply(this, arguments);
}
function Select(o) {
  return /* @__PURE__ */ React.createElement(Select$1, _extends$3({}, o, {
    valueComponent: o.multi ? MultiValue : Value
  }));
}
function _assertThisInitialized$1(o) {
  if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
var safeIsNaN = Number.isNaN || function o(i) {
  return typeof i == "number" && i !== i;
};
function isEqual(o, i) {
  return !!(o === i || safeIsNaN(o) && safeIsNaN(i));
}
function areInputsEqual(o, i) {
  if (o.length !== i.length)
    return !1;
  for (var g = 0; g < o.length; g++)
    if (!isEqual(o[g], i[g]))
      return !1;
  return !0;
}
function memoizeOne(o, i) {
  i === void 0 && (i = areInputsEqual);
  var g, E = [], e, t = !1;
  function n() {
    for (var h = [], d = 0; d < arguments.length; d++)
      h[d] = arguments[d];
    return t && g === this && i(h, E) || (e = o.apply(this, h), t = !0, g = this, E = h), e;
  }
  return n;
}
var hasNativePerformanceNow = typeof performance == "object" && typeof performance.now == "function", now = hasNativePerformanceNow ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function cancelTimeout(o) {
  cancelAnimationFrame(o.id);
}
function requestTimeout(o, i) {
  var g = now();
  function E() {
    now() - g >= i ? o.call(null) : e.id = requestAnimationFrame(E);
  }
  var e = {
    id: requestAnimationFrame(E)
  };
  return e;
}
var size = -1;
function getScrollbarSize(o) {
  if (o === void 0 && (o = !1), size === -1 || o) {
    var i = document.createElement("div"), g = i.style;
    g.width = "50px", g.height = "50px", g.overflow = "scroll", document.body.appendChild(i), size = i.offsetWidth - i.clientWidth, document.body.removeChild(i);
  }
  return size;
}
var cachedRTLResult = null;
function getRTLOffsetType(o) {
  if (o === void 0 && (o = !1), cachedRTLResult === null || o) {
    var i = document.createElement("div"), g = i.style;
    g.width = "50px", g.height = "50px", g.overflow = "scroll", g.direction = "rtl";
    var E = document.createElement("div"), e = E.style;
    return e.width = "100px", e.height = "100px", i.appendChild(E), document.body.appendChild(i), i.scrollLeft > 0 ? cachedRTLResult = "positive-descending" : (i.scrollLeft = 1, i.scrollLeft === 0 ? cachedRTLResult = "negative" : cachedRTLResult = "positive-ascending"), document.body.removeChild(i), cachedRTLResult;
  }
  return cachedRTLResult;
}
process.env.NODE_ENV;
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150, defaultItemKey$1 = function o(i, g) {
  return i;
}, devWarningsDirection = null, devWarningsTagName$1 = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (devWarningsDirection = /* @__PURE__ */ new WeakSet(), devWarningsTagName$1 = /* @__PURE__ */ new WeakSet());
function createListComponent(o) {
  var i, g = o.getItemOffset, E = o.getEstimatedTotalSize, e = o.getItemSize, t = o.getOffsetForIndexAndAlignment, n = o.getStartIndexForOffset, h = o.getStopIndexForStartIndex, d = o.initInstanceProps, k = o.shouldResetStyleCacheOnItemSizeChange, p = o.validateProps;
  return i = /* @__PURE__ */ (function(M) {
    _inheritsLoose(H, M);
    function H(AA) {
      var gA;
      return gA = M.call(this, AA) || this, gA._instanceProps = d(gA.props, _assertThisInitialized$1(gA)), gA._outerRef = void 0, gA._resetIsScrollingTimeoutId = null, gA.state = {
        instance: _assertThisInitialized$1(gA),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof gA.props.initialScrollOffset == "number" ? gA.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, gA._callOnItemsRendered = void 0, gA._callOnItemsRendered = memoizeOne(function(IA, BA, CA, QA) {
        return gA.props.onItemsRendered({
          overscanStartIndex: IA,
          overscanStopIndex: BA,
          visibleStartIndex: CA,
          visibleStopIndex: QA
        });
      }), gA._callOnScroll = void 0, gA._callOnScroll = memoizeOne(function(IA, BA, CA) {
        return gA.props.onScroll({
          scrollDirection: IA,
          scrollOffset: BA,
          scrollUpdateWasRequested: CA
        });
      }), gA._getItemStyle = void 0, gA._getItemStyle = function(IA) {
        var BA = gA.props, CA = BA.direction, QA = BA.itemSize, iA = BA.layout, EA = gA._getItemStyleCache(k && QA, k && iA, k && CA), oA;
        if (EA.hasOwnProperty(IA))
          oA = EA[IA];
        else {
          var eA = g(gA.props, IA, gA._instanceProps), GA = e(gA.props, IA, gA._instanceProps), cA = CA === "horizontal" || iA === "horizontal", tA = CA === "rtl", aA = cA ? eA : 0;
          EA[IA] = oA = {
            position: "absolute",
            left: tA ? void 0 : aA,
            right: tA ? aA : void 0,
            top: cA ? 0 : eA,
            height: cA ? "100%" : GA,
            width: cA ? GA : "100%"
          };
        }
        return oA;
      }, gA._getItemStyleCache = void 0, gA._getItemStyleCache = memoizeOne(function(IA, BA, CA) {
        return {};
      }), gA._onScrollHorizontal = function(IA) {
        var BA = IA.currentTarget, CA = BA.clientWidth, QA = BA.scrollLeft, iA = BA.scrollWidth;
        gA.setState(function(EA) {
          if (EA.scrollOffset === QA)
            return null;
          var oA = gA.props.direction, eA = QA;
          if (oA === "rtl")
            switch (getRTLOffsetType()) {
              case "negative":
                eA = -QA;
                break;
              case "positive-descending":
                eA = iA - CA - QA;
                break;
            }
          return eA = Math.max(0, Math.min(eA, iA - CA)), {
            isScrolling: !0,
            scrollDirection: EA.scrollOffset < eA ? "forward" : "backward",
            scrollOffset: eA,
            scrollUpdateWasRequested: !1
          };
        }, gA._resetIsScrollingDebounced);
      }, gA._onScrollVertical = function(IA) {
        var BA = IA.currentTarget, CA = BA.clientHeight, QA = BA.scrollHeight, iA = BA.scrollTop;
        gA.setState(function(EA) {
          if (EA.scrollOffset === iA)
            return null;
          var oA = Math.max(0, Math.min(iA, QA - CA));
          return {
            isScrolling: !0,
            scrollDirection: EA.scrollOffset < oA ? "forward" : "backward",
            scrollOffset: oA,
            scrollUpdateWasRequested: !1
          };
        }, gA._resetIsScrollingDebounced);
      }, gA._outerRefSetter = function(IA) {
        var BA = gA.props.outerRef;
        gA._outerRef = IA, typeof BA == "function" ? BA(IA) : BA != null && typeof BA == "object" && BA.hasOwnProperty("current") && (BA.current = IA);
      }, gA._resetIsScrollingDebounced = function() {
        gA._resetIsScrollingTimeoutId !== null && cancelTimeout(gA._resetIsScrollingTimeoutId), gA._resetIsScrollingTimeoutId = requestTimeout(gA._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      }, gA._resetIsScrolling = function() {
        gA._resetIsScrollingTimeoutId = null, gA.setState({
          isScrolling: !1
        }, function() {
          gA._getItemStyleCache(-1, null);
        });
      }, gA;
    }
    H.getDerivedStateFromProps = function(gA, IA) {
      return validateSharedProps$1(gA, IA), p(gA), null;
    };
    var f = H.prototype;
    return f.scrollTo = function(gA) {
      gA = Math.max(0, gA), this.setState(function(IA) {
        return IA.scrollOffset === gA ? null : {
          scrollDirection: IA.scrollOffset < gA ? "forward" : "backward",
          scrollOffset: gA,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, f.scrollToItem = function(gA, IA) {
      IA === void 0 && (IA = "auto");
      var BA = this.props, CA = BA.itemCount, QA = BA.layout, iA = this.state.scrollOffset;
      gA = Math.max(0, Math.min(gA, CA - 1));
      var EA = 0;
      if (this._outerRef) {
        var oA = this._outerRef;
        QA === "vertical" ? EA = oA.scrollWidth > oA.clientWidth ? getScrollbarSize() : 0 : EA = oA.scrollHeight > oA.clientHeight ? getScrollbarSize() : 0;
      }
      this.scrollTo(t(this.props, gA, IA, iA, this._instanceProps, EA));
    }, f.componentDidMount = function() {
      var gA = this.props, IA = gA.direction, BA = gA.initialScrollOffset, CA = gA.layout;
      if (typeof BA == "number" && this._outerRef != null) {
        var QA = this._outerRef;
        IA === "horizontal" || CA === "horizontal" ? QA.scrollLeft = BA : QA.scrollTop = BA;
      }
      this._callPropsCallbacks();
    }, f.componentDidUpdate = function() {
      var gA = this.props, IA = gA.direction, BA = gA.layout, CA = this.state, QA = CA.scrollOffset, iA = CA.scrollUpdateWasRequested;
      if (iA && this._outerRef != null) {
        var EA = this._outerRef;
        if (IA === "horizontal" || BA === "horizontal")
          if (IA === "rtl")
            switch (getRTLOffsetType()) {
              case "negative":
                EA.scrollLeft = -QA;
                break;
              case "positive-ascending":
                EA.scrollLeft = QA;
                break;
              default:
                var oA = EA.clientWidth, eA = EA.scrollWidth;
                EA.scrollLeft = eA - oA - QA;
                break;
            }
          else
            EA.scrollLeft = QA;
        else
          EA.scrollTop = QA;
      }
      this._callPropsCallbacks();
    }, f.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && cancelTimeout(this._resetIsScrollingTimeoutId);
    }, f.render = function() {
      var gA = this.props, IA = gA.children, BA = gA.className, CA = gA.direction, QA = gA.height, iA = gA.innerRef, EA = gA.innerElementType, oA = gA.innerTagName, eA = gA.itemCount, GA = gA.itemData, cA = gA.itemKey, tA = cA === void 0 ? defaultItemKey$1 : cA, aA = gA.layout, sA = gA.outerElementType, DA = gA.outerTagName, rA = gA.style, nA = gA.useIsScrolling, NA = gA.width, pA = this.state.isScrolling, mA = CA === "horizontal" || aA === "horizontal", XA = mA ? this._onScrollHorizontal : this._onScrollVertical, lA = this._getRangeToRender(), kA = lA[0], ZA = lA[1], wA = [];
      if (eA > 0)
        for (var LA = kA; LA <= ZA; LA++)
          wA.push(createElement(IA, {
            data: GA,
            key: tA(LA, GA),
            index: LA,
            isScrolling: nA ? pA : void 0,
            style: this._getItemStyle(LA)
          }));
      var fA = E(this.props, this._instanceProps);
      return createElement(sA || DA || "div", {
        className: BA,
        onScroll: XA,
        ref: this._outerRefSetter,
        style: _extends$C({
          position: "relative",
          height: QA,
          width: NA,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: CA
        }, rA)
      }, createElement(EA || oA || "div", {
        children: wA,
        ref: iA,
        style: {
          height: mA ? "100%" : fA,
          pointerEvents: pA ? "none" : void 0,
          width: mA ? fA : "100%"
        }
      }));
    }, f._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var gA = this.props.itemCount;
        if (gA > 0) {
          var IA = this._getRangeToRender(), BA = IA[0], CA = IA[1], QA = IA[2], iA = IA[3];
          this._callOnItemsRendered(BA, CA, QA, iA);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var EA = this.state, oA = EA.scrollDirection, eA = EA.scrollOffset, GA = EA.scrollUpdateWasRequested;
        this._callOnScroll(oA, eA, GA);
      }
    }, f._getRangeToRender = function() {
      var gA = this.props, IA = gA.itemCount, BA = gA.overscanCount, CA = this.state, QA = CA.isScrolling, iA = CA.scrollDirection, EA = CA.scrollOffset;
      if (IA === 0)
        return [0, 0, 0, 0];
      var oA = n(this.props, EA, this._instanceProps), eA = h(this.props, oA, EA, this._instanceProps), GA = !QA || iA === "backward" ? Math.max(1, BA) : 1, cA = !QA || iA === "forward" ? Math.max(1, BA) : 1;
      return [Math.max(0, oA - GA), Math.max(0, Math.min(IA - 1, eA + cA)), oA, eA];
    }, H;
  })(PureComponent), i.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, i;
}
var validateSharedProps$1 = function o(i, g) {
  var E = i.children, e = i.direction, t = i.height, n = i.layout, h = i.innerTagName, d = i.outerTagName, k = i.width, p = g.instance;
  if (process.env.NODE_ENV !== "production") {
    (h != null || d != null) && devWarningsTagName$1 && !devWarningsTagName$1.has(p) && (devWarningsTagName$1.add(p), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var M = e === "horizontal" || n === "horizontal";
    switch (e) {
      case "horizontal":
      case "vertical":
        devWarningsDirection && !devWarningsDirection.has(p) && (devWarningsDirection.add(p), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + e + '" was specified.'));
    }
    switch (n) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + n + '" was specified.'));
    }
    if (E == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (E === null ? "null" : typeof E) + '" was specified.'));
    if (M && typeof k != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (k === null ? "null" : typeof k) + '" was specified.'));
    if (!M && typeof t != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (t === null ? "null" : typeof t) + '" was specified.'));
  }
}, FixedSizeList = /* @__PURE__ */ createListComponent({
  getItemOffset: function o(i, g) {
    var E = i.itemSize;
    return g * E;
  },
  getItemSize: function o(i, g) {
    var E = i.itemSize;
    return E;
  },
  getEstimatedTotalSize: function o(i) {
    var g = i.itemCount, E = i.itemSize;
    return E * g;
  },
  getOffsetForIndexAndAlignment: function o(i, g, E, e, t, n) {
    var h = i.direction, d = i.height, k = i.itemCount, p = i.itemSize, M = i.layout, H = i.width, f = h === "horizontal" || M === "horizontal", AA = f ? H : d, gA = Math.max(0, k * p - AA), IA = Math.min(gA, g * p), BA = Math.max(0, g * p - AA + p + n);
    switch (E === "smart" && (e >= BA - AA && e <= IA + AA ? E = "auto" : E = "center"), E) {
      case "start":
        return IA;
      case "end":
        return BA;
      case "center": {
        var CA = Math.round(BA + (IA - BA) / 2);
        return CA < Math.ceil(AA / 2) ? 0 : CA > gA + Math.floor(AA / 2) ? gA : CA;
      }
      case "auto":
      default:
        return e >= BA && e <= IA ? e : e < BA ? BA : IA;
    }
  },
  getStartIndexForOffset: function o(i, g) {
    var E = i.itemCount, e = i.itemSize;
    return Math.max(0, Math.min(E - 1, Math.floor(g / e)));
  },
  getStopIndexForStartIndex: function o(i, g, E) {
    var e = i.direction, t = i.height, n = i.itemCount, h = i.itemSize, d = i.layout, k = i.width, p = e === "horizontal" || d === "horizontal", M = g * h, H = p ? k : t, f = Math.ceil((H + E - M) / h);
    return Math.max(0, Math.min(
      n - 1,
      g + f - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function o(i) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function o(i) {
    var g = i.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof g != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (g === null ? "null" : typeof g) + '" was specified.'));
  }
});
const ThemedStyledDropdownListItem = /* @__PURE__ */ createStyled(StyledDropdownListItem, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: isPropValid,
  target: "e1811lun0"
} : {
  shouldForwardProp: isPropValid,
  target: "e1811lun0",
  label: "ThemedStyledDropdownListItem"
})(({
  theme: o,
  $isHighlighted: i
}) => ({
  display: "flex",
  alignItems: "center",
  paddingTop: o.spacing.none,
  paddingBottom: o.spacing.none,
  paddingLeft: o.spacing.lg,
  paddingRight: o.spacing.lg,
  background: i ? o.colors.darkenedBgMix15 : void 0,
  fontWeight: o.fontWeights.normal,
  // Override the default itemSize set on the component's JSX
  // on mobile, so we can make list items taller and scrollable
  [`@media (max-width: ${o.breakpoints.md})`]: {
    minHeight: o.sizes.dropdownItemHeight,
    height: "auto !important"
  },
  "&:hover, &:active, &:focus-visible": {
    background: o.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvRHJvcGRvd24vc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0I0QyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL0Ryb3Bkb3duL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBpc1Byb3BWYWxpZCBmcm9tIFwiQGVtb3Rpb24vaXMtcHJvcC12YWxpZFwiXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgU3R5bGVkRHJvcGRvd25MaXN0SXRlbSB9IGZyb20gXCJiYXNldWkvc2VsZWN0XCJcblxuZXhwb3J0IGNvbnN0IFRoZW1lZFN0eWxlZERyb3Bkb3duTGlzdEl0ZW0gPSBzdHlsZWQoU3R5bGVkRHJvcGRvd25MaXN0SXRlbSwge1xuICBzaG91bGRGb3J3YXJkUHJvcDogaXNQcm9wVmFsaWQsXG59KSgoeyB0aGVtZSwgJGlzSGlnaGxpZ2h0ZWQgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdCb3R0b206IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICBwYWRkaW5nUmlnaHQ6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgYmFja2dyb3VuZDogJGlzSGlnaGxpZ2h0ZWQgPyB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1IDogdW5kZWZpbmVkLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcblxuICAgIC8vIE92ZXJyaWRlIHRoZSBkZWZhdWx0IGl0ZW1TaXplIHNldCBvbiB0aGUgY29tcG9uZW50J3MgSlNYXG4gICAgLy8gb24gbW9iaWxlLCBzbyB3ZSBjYW4gbWFrZSBsaXN0IGl0ZW1zIHRhbGxlciBhbmQgc2Nyb2xsYWJsZVxuICAgIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMubWR9KWBdOiB7XG4gICAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmRyb3Bkb3duSXRlbUhlaWdodCxcbiAgICAgIGhlaWdodDogXCJhdXRvICFpbXBvcnRhbnRcIixcbiAgICB9LFxuICAgIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH1cbn0pXG4iXX0= */");
function FixedSizeListItem(o) {
  const {
    data: i,
    index: g,
    style: E
  } = o, {
    item: e,
    overrides: t,
    ...n
  } = i[g].props, h = e.isCreatable ? `Add: ${e.label}` : e.label;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedStyledDropdownListItem, { style: E, ...n, children: /* @__PURE__ */ jsxRuntimeExports.jsx(OverflowTooltip, { content: h, placement: Placement.AUTO, children: h }) }, e.value);
}
const VirtualDropdown = forwardRef((o, i) => {
  const g = useEmotionTheme(), E = Children.toArray(o.children);
  if (!E[0]?.props.item) {
    const t = E[0] ? E[0].props : {};
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledList, { $style: {
      height: g.sizes.emptyDropdownHeight,
      paddingBottom: g.spacing.none,
      paddingTop: g.spacing.none,
      paddingLeft: g.spacing.none,
      paddingRight: g.spacing.none,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // Somehow this adds an additional shadow, even though we already have
      // one on the popover, so we need to remove it here.
      boxShadow: "none"
    }, ref: i, "data-testid": "stSelectboxVirtualDropdownEmpty", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEmptyState, { $style: {
      paddingBottom: g.spacing.none,
      paddingTop: g.spacing.none,
      paddingLeft: g.spacing.none,
      paddingRight: g.spacing.none,
      color: g.colors.fadedText60
    }, ...t }) });
  }
  const e = Math.min(convertRemToPx(g.sizes.maxDropdownHeight), E.length * convertRemToPx(g.sizes.dropdownItemHeight));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledList, { ref: i, $style: {
    paddingTop: 0,
    paddingBottom: 0,
    // Somehow this adds an additional shadow, even though we already have
    // one on the popover, so we need to remove it here.
    boxShadow: "none"
  }, "data-testid": "stSelectboxVirtualDropdown", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FixedSizeList, { width: "100%", height: e, itemCount: E.length, itemData: E, itemKey: (t, n) => {
    const {
      id: h,
      value: d
    } = n[t].props.item;
    return h ?? d;
  }, itemSize: convertRemToPx(g.sizes.dropdownItemHeight), children: FixedSizeListItem }) });
});
VirtualDropdown.displayName = "VirtualDropdown";
const SCORE_MIN = -1 / 0, SCORE_MAX = 1 / 0, SCORE_GAP_LEADING = -5e-3, SCORE_GAP_TRAILING = -5e-3, SCORE_GAP_INNER = -0.01, SCORE_MATCH_CONSECUTIVE = 1, SCORE_MATCH_SLASH = 0.9, SCORE_MATCH_WORD = 0.8, SCORE_MATCH_CAPITAL = 0.7, SCORE_MATCH_DOT = 0.6;
function islower(o) {
  return o.toLowerCase() === o;
}
function isupper(o) {
  return o.toUpperCase() === o;
}
function precomputeBonus(o) {
  const i = o.length, g = new Array(i);
  let E = "/";
  for (let e = 0; e < i; e++) {
    const t = o[e];
    E === "/" ? g[e] = SCORE_MATCH_SLASH : E === "-" || E === "_" || E === " " ? g[e] = SCORE_MATCH_WORD : E === "." ? g[e] = SCORE_MATCH_DOT : islower(E) && isupper(t) ? g[e] = SCORE_MATCH_CAPITAL : g[e] = 0, E = t;
  }
  return g;
}
function compute(o, i, g, E, e = !1) {
  const t = o.length, n = i.length, h = e ? o : o.toLowerCase(), d = e ? i : i.toLowerCase(), k = precomputeBonus(i);
  for (let p = 0; p < t; p++) {
    g[p] = new Array(n), E[p] = new Array(n);
    let M = SCORE_MIN;
    const H = p === t - 1 ? SCORE_GAP_TRAILING : SCORE_GAP_INNER;
    for (let f = 0; f < n; f++)
      if (h[p] === d[f]) {
        let AA = SCORE_MIN;
        p ? f && (AA = Math.max(
          E[p - 1][f - 1] + k[f],
          /* consecutive match, doesn't stack with matchBonus */
          g[p - 1][f - 1] + SCORE_MATCH_CONSECUTIVE
        )) : AA = f * SCORE_GAP_LEADING + k[f], g[p][f] = AA, E[p][f] = M = Math.max(AA, M + H);
      } else
        g[p][f] = SCORE_MIN, E[p][f] = M = M + H;
  }
}
function score(o, i, g = !1) {
  const E = o.length, e = i.length;
  if (!E || !e) return SCORE_MIN;
  if (o === i || !g && e === E)
    return SCORE_MAX;
  if (e > 1024)
    return SCORE_MIN;
  const t = new Array(E), n = new Array(E);
  return compute(o, i, t, n, g), n[E - 1][e - 1];
}
function hasMatch(o, i) {
  o = o.toLowerCase(), i = i.toLowerCase();
  const g = o.length;
  for (let E = 0, e = 0; E < g; E += 1)
    if (e = i.indexOf(o[E], e) + 1, e === 0) return !1;
  return !0;
}
function fuzzyFilterSelectOptions(o, i) {
  if (!i)
    return o;
  const g = o.filter((E) => hasMatch(i, E.label));
  return sortBy(
    g,
    // Use the negative score to sort the list in a stable manner
    // This ensures highest score is first
    (E) => -score(i, E.label)
  );
}
var uaParser$1 = { exports: {} }, uaParser = uaParser$1.exports, hasRequiredUaParser;
function requireUaParser() {
  return hasRequiredUaParser || (hasRequiredUaParser = 1, (function(o, i) {
    (function(g, E) {
      var e = "1.0.41", t = "", n = "?", h = "function", d = "undefined", k = "object", p = "string", M = "major", H = "model", f = "name", AA = "type", gA = "vendor", IA = "version", BA = "architecture", CA = "console", QA = "mobile", iA = "tablet", EA = "smarttv", oA = "wearable", eA = "embedded", GA = 500, cA = "Amazon", tA = "Apple", aA = "ASUS", sA = "BlackBerry", DA = "Browser", rA = "Chrome", nA = "Edge", NA = "Firefox", pA = "Google", mA = "Honor", XA = "Huawei", lA = "Lenovo", kA = "LG", ZA = "Microsoft", wA = "Motorola", LA = "Nvidia", fA = "OnePlus", dA = "Opera", RA = "OPPO", KA = "Samsung", xA = "Sharp", MA = "Sony", OA = "Xiaomi", SA = "Zebra", gg = "Facebook", WA = "Chromium OS", eg = "Mac OS", ig = " Browser", $A = function(qA, _A) {
        var VA = {};
        for (var yA in qA)
          _A[yA] && _A[yA].length % 2 === 0 ? VA[yA] = _A[yA].concat(qA[yA]) : VA[yA] = qA[yA];
        return VA;
      }, ag = function(qA) {
        for (var _A = {}, VA = 0; VA < qA.length; VA++)
          _A[qA[VA].toUpperCase()] = qA[VA];
        return _A;
      }, Ig = function(qA, _A) {
        return typeof qA === p ? tg(_A).indexOf(tg(qA)) !== -1 : !1;
      }, tg = function(qA) {
        return qA.toLowerCase();
      }, wg = function(qA) {
        return typeof qA === p ? qA.replace(/[^\d\.]/g, t).split(".")[0] : E;
      }, hg = function(qA, _A) {
        if (typeof qA === p)
          return qA = qA.replace(/^\s\s*/, t), typeof _A === d ? qA : qA.substring(0, GA);
      }, Gg = function(qA, _A) {
        for (var VA = 0, yA, FA, uA, JA, YA, TA; VA < _A.length && !YA; ) {
          var Qg = _A[VA], sg = _A[VA + 1];
          for (yA = FA = 0; yA < Qg.length && !YA && Qg[yA]; )
            if (YA = Qg[yA++].exec(qA), YA)
              for (uA = 0; uA < sg.length; uA++)
                TA = YA[++FA], JA = sg[uA], typeof JA === k && JA.length > 0 ? JA.length === 2 ? typeof JA[1] == h ? this[JA[0]] = JA[1].call(this, TA) : this[JA[0]] = JA[1] : JA.length === 3 ? typeof JA[1] === h && !(JA[1].exec && JA[1].test) ? this[JA[0]] = TA ? JA[1].call(this, TA, JA[2]) : E : this[JA[0]] = TA ? TA.replace(JA[1], JA[2]) : E : JA.length === 4 && (this[JA[0]] = TA ? JA[3].call(this, TA.replace(JA[1], JA[2])) : E) : this[JA] = TA || E;
          VA += 2;
        }
      }, Ng = function(qA, _A) {
        for (var VA in _A)
          if (typeof _A[VA] === k && _A[VA].length > 0) {
            for (var yA = 0; yA < _A[VA].length; yA++)
              if (Ig(_A[VA][yA], qA))
                return VA === n ? E : VA;
          } else if (Ig(_A[VA], qA))
            return VA === n ? E : VA;
        return _A.hasOwnProperty("*") ? _A["*"] : qA;
      }, Bg = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }, bA = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        "8.1": "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      }, HA = {
        browser: [
          [
            /\b(?:crmo|crios)\/([\w\.]+)/i
            // Chrome for Android/iOS
          ],
          [IA, [f, "Chrome"]],
          [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
            // Microsoft Edge
          ],
          [IA, [f, "Edge"]],
          [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            // Opera
          ],
          [f, IA],
          [
            /opios[\/ ]+([\w\.]+)/i
            // Opera mini on iphone >= 8.0
          ],
          [IA, [f, dA + " Mini"]],
          [
            /\bop(?:rg)?x\/([\w\.]+)/i
            // Opera GX
          ],
          [IA, [f, dA + " GX"]],
          [
            /\bopr\/([\w\.]+)/i
            // Opera Webkit
          ],
          [IA, [f, dA]],
          [
            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            // Baidu
          ],
          [IA, [f, "Baidu"]],
          [
            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            // Maxthon
          ],
          [IA, [f, "Maxthon"]],
          [
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
            // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Internet Explorer
            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
            /(heytap|ovi|115)browser\/([\d\.]+)/i,
            // HeyTap/Ovi/115
            /(weibo)__([\d\.]+)/i
            // Weibo
          ],
          [f, IA],
          [
            /quark(?:pc)?\/([-\w\.]+)/i
            // Quark
          ],
          [IA, [f, "Quark"]],
          [
            /\bddg\/([\w\.]+)/i
            // DuckDuckGo
          ],
          [IA, [f, "DuckDuckGo"]],
          [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            // UCBrowser
          ],
          [IA, [f, "UC" + DA]],
          [
            /microm.+\bqbcore\/([\w\.]+)/i,
            // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i
            // WeChat
          ],
          [IA, [f, "WeChat"]],
          [
            /konqueror\/([\w\.]+)/i
            // Konqueror
          ],
          [IA, [f, "Konqueror"]],
          [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            // IE11
          ],
          [IA, [f, "IE"]],
          [
            /ya(?:search)?browser\/([\w\.]+)/i
            // Yandex
          ],
          [IA, [f, "Yandex"]],
          [
            /slbrowser\/([\w\.]+)/i
            // Smart Lenovo Browser
          ],
          [IA, [f, "Smart Lenovo " + DA]],
          [
            /(avast|avg)\/([\w\.]+)/i
            // Avast/AVG Secure Browser
          ],
          [[f, /(.+)/, "$1 Secure " + DA], IA],
          [
            /\bfocus\/([\w\.]+)/i
            // Firefox Focus
          ],
          [IA, [f, NA + " Focus"]],
          [
            /\bopt\/([\w\.]+)/i
            // Opera Touch
          ],
          [IA, [f, dA + " Touch"]],
          [
            /coc_coc\w+\/([\w\.]+)/i
            // Coc Coc Browser
          ],
          [IA, [f, "Coc Coc"]],
          [
            /dolfin\/([\w\.]+)/i
            // Dolphin
          ],
          [IA, [f, "Dolphin"]],
          [
            /coast\/([\w\.]+)/i
            // Opera Coast
          ],
          [IA, [f, dA + " Coast"]],
          [
            /miuibrowser\/([\w\.]+)/i
            // MIUI Browser
          ],
          [IA, [f, "MIUI" + ig]],
          [
            /fxios\/([\w\.-]+)/i
            // Firefox for iOS
          ],
          [IA, [f, NA]],
          [
            /\bqihoobrowser\/?([\w\.]*)/i
            // 360
          ],
          [IA, [f, "360"]],
          [
            /\b(qq)\/([\w\.]+)/i
            // QQ
          ],
          [[f, /(.+)/, "$1Browser"], IA],
          [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
          ],
          [[f, /(.+)/, "$1" + ig], IA],
          [
            // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
            /samsungbrowser\/([\w\.]+)/i
            // Samsung Internet
          ],
          [IA, [f, KA + " Internet"]],
          [
            /metasr[\/ ]?([\d\.]+)/i
            // Sogou Explorer
          ],
          [IA, [f, "Sogou Explorer"]],
          [
            /(sogou)mo\w+\/([\d\.]+)/i
            // Sogou Mobile
          ],
          [[f, "Sogou Mobile"], IA],
          [
            /(electron)\/([\w\.]+) safari/i,
            // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            // Tesla
            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            // QQ/2345
          ],
          [f, IA],
          [
            /(lbbrowser|rekonq)/i,
            // LieBao Browser/Rekonq
            /\[(linkedin)app\]/i
            // LinkedIn App for iOS & Android
          ],
          [f],
          [
            /ome\/([\w\.]+) \w* ?(iron) saf/i,
            // Iron
            /ome\/([\w\.]+).+qihu (360)[es]e/i
            // 360
          ],
          [IA, f],
          [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            // Facebook App for iOS & Android
          ],
          [[f, gg], IA],
          [
            /(Klarna)\/([\w\.]+)/i,
            // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            // Naver InApp
            /(daum)apps[\/ ]([\w\.]+)/i,
            // Daum App
            /safari (line)\/([\w\.]+)/i,
            // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,
            // Line App for Android
            /(alipay)client\/([\w\.]+)/i,
            // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
            // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            // Chromium/Instagram/Snapchat
          ],
          [f, IA],
          [
            /\bgsa\/([\w\.]+) .*safari\//i
            // Google Search Appliance on iOS
          ],
          [IA, [f, "GSA"]],
          [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            // TikTok
          ],
          [IA, [f, "TikTok"]],
          [
            /headlesschrome(?:\/([\w\.]+)| )/i
            // Chrome Headless
          ],
          [IA, [f, rA + " Headless"]],
          [
            / wv\).+(chrome)\/([\w\.]+)/i
            // Chrome WebView
          ],
          [[f, rA + " WebView"], IA],
          [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            // Android Browser
          ],
          [IA, [f, "Android " + DA]],
          [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            // Chrome/OmniWeb/Arora/Tizen/Nokia
          ],
          [f, IA],
          [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            // Mobile Safari
          ],
          [IA, [f, "Mobile Safari"]],
          [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            // Safari & Safari Mobile
          ],
          [IA, f],
          [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            // Safari < 3.0
          ],
          [f, [IA, Ng, Bg]],
          [
            /(webkit|khtml)\/([\w\.]+)/i
          ],
          [f, IA],
          [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
            // Netscape
          ],
          [[f, "Netscape"], IA],
          [
            /(wolvic|librewolf)\/([\w\.]+)/i
            // Wolvic/LibreWolf
          ],
          [f, IA],
          [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
            // Firefox Reality
          ],
          [IA, [f, NA + " Reality"]],
          [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            // Flow
            /(swiftfox)/i,
            // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Mozilla
            // Other
            /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
            /\b(links) \(([\w\.]+)/i
            // Links
          ],
          [f, [IA, /_/g, "."]],
          [
            /(cobalt)\/([\w\.]+)/i
            // Cobalt
          ],
          [f, [IA, /master.|lts./, ""]]
        ],
        cpu: [
          [
            /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            // AMD64 (x64)
          ],
          [[BA, "amd64"]],
          [
            /(ia32(?=;))/i,
            // IA32 (quicktime)
            /\b((i[346]|x)86)(pc)?\b/i
            // IA32 (x86)
          ],
          [[BA, "ia32"]],
          [
            /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            // ARM64
          ],
          [[BA, "arm64"]],
          [
            /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            // ARMHF
          ],
          [[BA, "armhf"]],
          [
            // PocketPC mistakenly identified as PowerPC
            /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
          ],
          [[BA, "arm"]],
          [
            /((ppc|powerpc)(64)?)( mac|;|\))/i
            // PowerPC
          ],
          [[BA, /ower/, t, tg]],
          [
            / sun4\w[;\)]/i
            // SPARC
          ],
          [[BA, "sparc"]],
          [
            /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ],
          [[BA, tg]]
        ],
        device: [
          [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
          ],
          [H, [gA, KA], [AA, iA]],
          [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
          ],
          [H, [gA, KA], [AA, QA]],
          [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            // iPod/iPhone
          ],
          [H, [gA, tA], [AA, QA]],
          [
            /\((ipad);[-\w\),; ]+apple/i,
            // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
          ],
          [H, [gA, tA], [AA, iA]],
          [
            /(macintosh);/i
          ],
          [H, [gA, tA]],
          [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
          ],
          [H, [gA, xA], [AA, QA]],
          [
            // Honor
            /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
          ],
          [H, [gA, mA], [AA, iA]],
          [
            /honor([-\w ]+)[;\)]/i
          ],
          [H, [gA, mA], [AA, QA]],
          [
            // Huawei
            /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
          ],
          [H, [gA, XA], [AA, iA]],
          [
            /(?:huawei)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
          ],
          [H, [gA, XA], [AA, QA]],
          [
            // Xiaomi
            /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
            /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            // Mi Pad tablets
          ],
          [[H, /_/g, " "], [gA, OA], [AA, iA]],
          [
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
            // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,
            // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
            // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
            // Xiaomi Mi
            / ([\w ]+) miui\/v?\d/i
          ],
          [[H, /_/g, " "], [gA, OA], [AA, QA]],
          [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
          ],
          [H, [gA, RA], [AA, QA]],
          [
            /\b(opd2(\d{3}a?))(?: bui|\))/i
          ],
          [H, [gA, Ng, { OnePlus: ["304", "403", "203"], "*": RA }], [AA, iA]],
          [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
          ],
          [H, [gA, "Vivo"], [AA, QA]],
          [
            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
          ],
          [H, [gA, "Realme"], [AA, QA]],
          [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
          ],
          [H, [gA, wA], [AA, QA]],
          [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
          ],
          [H, [gA, wA], [AA, iA]],
          [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
          ],
          [H, [gA, kA], [AA, iA]],
          [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
            /\blg-?([\d\w]+) bui/i
          ],
          [H, [gA, kA], [AA, QA]],
          [
            // Lenovo
            /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
            /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
          ],
          [H, [gA, lA], [AA, iA]],
          [
            // Nokia
            /(nokia) (t[12][01])/i
          ],
          [gA, H, [AA, iA]],
          [
            /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
            /nokia[-_ ]?(([-\w\. ]*))/i
          ],
          [[H, /_/g, " "], [AA, QA], [gA, "Nokia"]],
          [
            // Google
            /(pixel (c|tablet))\b/i
            // Google Pixel C/Tablet
          ],
          [H, [gA, pA], [AA, iA]],
          [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            // Google Pixel
          ],
          [H, [gA, pA], [AA, QA]],
          [
            // Sony
            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
          ],
          [H, [gA, MA], [AA, QA]],
          [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
          ],
          [[H, "Xperia Tablet"], [gA, MA], [AA, iA]],
          [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
          ],
          [H, [gA, fA], [AA, QA]],
          [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
            // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i
            // Kindle Fire HD
          ],
          [H, [gA, cA], [AA, iA]],
          [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            // Fire Phone
          ],
          [[H, /(.+)/g, "Fire Phone $1"], [gA, cA], [AA, QA]],
          [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
            // BlackBerry PlayBook
          ],
          [H, gA, [AA, iA]],
          [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
            // BlackBerry 10
          ],
          [H, [gA, sA], [AA, QA]],
          [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
          ],
          [H, [gA, aA], [AA, iA]],
          [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
          ],
          [H, [gA, aA], [AA, QA]],
          [
            // HTC
            /(nexus 9)/i
            // HTC Nexus 9
          ],
          [H, [gA, "HTC"], [AA, iA]],
          [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // HTC
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
          ],
          [gA, [H, /_/g, " "], [AA, QA]],
          [
            // TCL
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
          ],
          [H, [gA, "TCL"], [AA, iA]],
          [
            // itel
            /(itel) ((\w+))/i
          ],
          [[gA, tg], H, [AA, Ng, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
          [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
          ],
          [H, [gA, "Acer"], [AA, iA]],
          [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
          ],
          [H, [gA, "Meizu"], [AA, QA]],
          [
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
          ],
          [H, [gA, "Ulefone"], [AA, QA]],
          [
            // Energizer
            /; (energy ?\w+)(?: bui|\))/i,
            /; energizer ([\w ]+)(?: bui|\))/i
          ],
          [H, [gA, "Energizer"], [AA, QA]],
          [
            // Cat
            /; cat (b35);/i,
            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
          ],
          [H, [gA, "Cat"], [AA, QA]],
          [
            // Smartfren
            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
          ],
          [H, [gA, "Smartfren"], [AA, QA]],
          [
            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
          ],
          [H, [gA, "Nothing"], [AA, QA]],
          [
            // Archos
            /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
            /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
          ],
          [H, [gA, "Archos"], [AA, iA]],
          [
            /archos ([\w ]+)( b|\))/i,
            /; (ac[3-6]\d\w{2,8})( b|\))/i
          ],
          [H, [gA, "Archos"], [AA, QA]],
          [
            // MIXED
            /(imo) (tab \w+)/i,
            // IMO
            /(infinix) (x1101b?)/i
            // Infinix XPad
          ],
          [gA, H, [AA, iA]],
          [
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
            /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
            // HMD/IMO
            /(hp) ([\w ]+\w)/i,
            // HP iPAQ
            /(microsoft); (lumia[\w ]+)/i,
            // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
            // Lenovo
            /(oppo) ?([\w ]+) bui/i
            // OPPO
          ],
          [gA, H, [AA, QA]],
          [
            /(kobo)\s(ereader|touch)/i,
            // Kobo
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            // HP TouchPad
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(nook)[\w ]+build\/(\w+)/i,
            // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,
            // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,
            // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i
            // Vodafone
          ],
          [gA, H, [AA, iA]],
          [
            /(surface duo)/i
            // Surface Duo
          ],
          [H, [gA, ZA], [AA, iA]],
          [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
            // Fairphone
          ],
          [H, [gA, "Fairphone"], [AA, QA]],
          [
            /(u304aa)/i
            // AT&T
          ],
          [H, [gA, "AT&T"], [AA, QA]],
          [
            /\bsie-(\w*)/i
            // Siemens
          ],
          [H, [gA, "Siemens"], [AA, QA]],
          [
            /\b(rct\w+) b/i
            // RCA Tablets
          ],
          [H, [gA, "RCA"], [AA, iA]],
          [
            /\b(venue[\d ]{2,7}) b/i
            // Dell Venue Tablets
          ],
          [H, [gA, "Dell"], [AA, iA]],
          [
            /\b(q(?:mv|ta)\w+) b/i
            // Verizon Tablet
          ],
          [H, [gA, "Verizon"], [AA, iA]],
          [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            // Barnes & Noble Tablet
          ],
          [H, [gA, "Barnes & Noble"], [AA, iA]],
          [
            /\b(tm\d{3}\w+) b/i
          ],
          [H, [gA, "NuVision"], [AA, iA]],
          [
            /\b(k88) b/i
            // ZTE K Series Tablet
          ],
          [H, [gA, "ZTE"], [AA, iA]],
          [
            /\b(nx\d{3}j) b/i
            // ZTE Nubia
          ],
          [H, [gA, "ZTE"], [AA, QA]],
          [
            /\b(gen\d{3}) b.+49h/i
            // Swiss GEN Mobile
          ],
          [H, [gA, "Swiss"], [AA, QA]],
          [
            /\b(zur\d{3}) b/i
            // Swiss ZUR Tablet
          ],
          [H, [gA, "Swiss"], [AA, iA]],
          [
            /\b((zeki)?tb.*\b) b/i
            // Zeki Tablets
          ],
          [H, [gA, "Zeki"], [AA, iA]],
          [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            // Dragon Touch Tablet
          ],
          [[gA, "Dragon Touch"], H, [AA, iA]],
          [
            /\b(ns-?\w{0,9}) b/i
            // Insignia Tablets
          ],
          [H, [gA, "Insignia"], [AA, iA]],
          [
            /\b((nxa|next)-?\w{0,9}) b/i
            // NextBook Tablets
          ],
          [H, [gA, "NextBook"], [AA, iA]],
          [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            // Voice Xtreme Phones
          ],
          [[gA, "Voice"], H, [AA, QA]],
          [
            /\b(lvtel\-)?(v1[12]) b/i
            // LvTel Phones
          ],
          [[gA, "LvTel"], H, [AA, QA]],
          [
            /\b(ph-1) /i
            // Essential PH-1
          ],
          [H, [gA, "Essential"], [AA, QA]],
          [
            /\b(v(100md|700na|7011|917g).*\b) b/i
            // Envizen Tablets
          ],
          [H, [gA, "Envizen"], [AA, iA]],
          [
            /\b(trio[-\w\. ]+) b/i
            // MachSpeed Tablets
          ],
          [H, [gA, "MachSpeed"], [AA, iA]],
          [
            /\btu_(1491) b/i
            // Rotor Tablets
          ],
          [H, [gA, "Rotor"], [AA, iA]],
          [
            /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            // Nvidia Tablets
          ],
          [H, [gA, LA], [AA, iA]],
          [
            /(sprint) (\w+)/i
            // Sprint Phones
          ],
          [gA, H, [AA, QA]],
          [
            /(kin\.[onetw]{3})/i
            // Microsoft Kin
          ],
          [[H, /\./g, " "], [gA, ZA], [AA, QA]],
          [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            // Zebra
          ],
          [H, [gA, SA], [AA, iA]],
          [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
          ],
          [H, [gA, SA], [AA, QA]],
          [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
            // Samsung
          ],
          [gA, [AA, EA]],
          [
            /hbbtv.+maple;(\d+)/i
          ],
          [[H, /^/, "SmartTV"], [gA, KA], [AA, EA]],
          [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            // LG SmartTV
          ],
          [[gA, kA], [AA, EA]],
          [
            /(apple) ?tv/i
            // Apple TV
          ],
          [gA, [H, tA + " TV"], [AA, EA]],
          [
            /crkey/i
            // Google Chromecast
          ],
          [[H, rA + "cast"], [gA, pA], [AA, EA]],
          [
            /droid.+aft(\w+)( bui|\))/i
            // Fire TV
          ],
          [H, [gA, cA], [AA, EA]],
          [
            /(shield \w+ tv)/i
            // Nvidia Shield TV
          ],
          [H, [gA, LA], [AA, EA]],
          [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
            // Sharp
          ],
          [H, [gA, xA], [AA, EA]],
          [
            /(bravia[\w ]+)( bui|\))/i
            // Sony
          ],
          [H, [gA, MA], [AA, EA]],
          [
            /(mi(tv|box)-?\w+) bui/i
            // Xiaomi
          ],
          [H, [gA, OA], [AA, EA]],
          [
            /Hbbtv.*(technisat) (.*);/i
            // TechniSAT
          ],
          [gA, H, [AA, EA]],
          [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            // HbbTV devices
          ],
          [[gA, hg], [H, hg], [AA, EA]],
          [
            // SmartTV from Unidentified Vendors
            /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
          ],
          [H, [AA, EA]],
          [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          ],
          [[AA, EA]],
          [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            // Ouya
            /(nintendo) ([wids3utch]+)/i
            // Nintendo
          ],
          [gA, H, [AA, CA]],
          [
            /droid.+; (shield)( bui|\))/i
            // Nvidia Portable
          ],
          [H, [gA, LA], [AA, CA]],
          [
            /(playstation \w+)/i
            // Playstation
          ],
          [H, [gA, MA], [AA, CA]],
          [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            // Microsoft Xbox
          ],
          [H, [gA, ZA], [AA, CA]],
          [
            ///////////////////
            // WEARABLES
            ///////////////////
            /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            // Samsung Galaxy Watch
          ],
          [H, [gA, KA], [AA, oA]],
          [
            /((pebble))app/i,
            // Pebble
            /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            // Asus ZenWatch / LG Watch / Pixel Watch
          ],
          [gA, H, [AA, oA]],
          [
            /(ow(?:19|20)?we?[1-3]{1,3})/i
            // Oppo Watch
          ],
          [H, [gA, RA], [AA, oA]],
          [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            // Apple Watch
          ],
          [H, [gA, tA], [AA, oA]],
          [
            /(opwwe\d{3})/i
            // OnePlus Watch
          ],
          [H, [gA, fA], [AA, oA]],
          [
            /(moto 360)/i
            // Motorola 360
          ],
          [H, [gA, wA], [AA, oA]],
          [
            /(smartwatch 3)/i
            // Sony SmartWatch
          ],
          [H, [gA, MA], [AA, oA]],
          [
            /(g watch r)/i
            // LG G Watch R
          ],
          [H, [gA, kA], [AA, oA]],
          [
            /droid.+; (wt63?0{2,3})\)/i
          ],
          [H, [gA, SA], [AA, oA]],
          [
            ///////////////////
            // XR
            ///////////////////
            /droid.+; (glass) \d/i
            // Google Glass
          ],
          [H, [gA, pA], [AA, oA]],
          [
            /(pico) (4|neo3(?: link|pro)?)/i
            // Pico
          ],
          [gA, H, [AA, oA]],
          [
            /; (quest( \d| pro)?)/i
            // Oculus Quest
          ],
          [H, [gA, gg], [AA, oA]],
          [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            // Tesla
          ],
          [gA, [AA, eA]],
          [
            /(aeobc)\b/i
            // Echo Dot
          ],
          [H, [gA, cA], [AA, eA]],
          [
            /(homepod).+mac os/i
            // Apple HomePod
          ],
          [H, [gA, tA], [AA, eA]],
          [
            /windows iot/i
          ],
          [[AA, eA]],
          [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            // Android Phones from Unidentified Vendors
          ],
          [H, [AA, QA]],
          [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            // Android Tablets from Unidentified Vendors
          ],
          [H, [AA, iA]],
          [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            // Unidentifiable Tablet
          ],
          [[AA, iA]],
          [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            // Unidentifiable Mobile
          ],
          [[AA, QA]],
          [
            /droid .+?; ([\w\. -]+)( bui|\))/i
            // Generic Android Device
          ],
          [H, [gA, "Generic"]]
        ],
        engine: [
          [
            /windows.+ edge\/([\w\.]+)/i
            // EdgeHTML
          ],
          [IA, [f, nA + "HTML"]],
          [
            /(arkweb)\/([\w\.]+)/i
            // ArkWeb
          ],
          [f, IA],
          [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            // Blink
          ],
          [IA, [f, "Blink"]],
          [
            /(presto)\/([\w\.]+)/i,
            // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
            /ekioh(flow)\/([\w\.]+)/i,
            // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            // iCab
            /\b(libweb)/i
            // LibWeb
          ],
          [f, IA],
          [
            /ladybird\//i
          ],
          [[f, "LibWeb"]],
          [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
            // Gecko
          ],
          [IA, f]
        ],
        os: [
          [
            // Windows
            /microsoft (windows) (vista|xp)/i
            // Windows (iTunes)
          ],
          [f, IA],
          [
            /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            // Windows Phone
          ],
          [f, [IA, Ng, bA]],
          [
            /windows nt 6\.2; (arm)/i,
            // Windows RT
            /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
          ],
          [[IA, Ng, bA], [f, "Windows"]],
          [
            // iOS/macOS
            /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
            // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
          ],
          [[IA, /_/g, "."], [f, "iOS"]],
          [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            // Mac OS
          ],
          [[f, eg], [IA, /_/g, "."]],
          [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            // Android-x86/HarmonyOS
          ],
          [IA, f],
          [
            /(ubuntu) ([\w\.]+) like android/i
            // Ubuntu Touch
          ],
          [[f, /(.+)/, "$1 Touch"], IA],
          [
            // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
            /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
          ],
          [f, IA],
          [
            /\(bb(10);/i
            // BlackBerry 10
          ],
          [IA, [f, sA]],
          [
            /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            // Symbian
          ],
          [IA, [f, "Symbian"]],
          [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            // Firefox OS
          ],
          [IA, [f, NA + " OS"]],
          [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            // WebOS
          ],
          [IA, [f, "webOS"]],
          [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            // watchOS
          ],
          [IA, [f, "watchOS"]],
          [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
            // Google Chromecast
          ],
          [IA, [f, rA + "cast"]],
          [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            // Chromium OS
          ],
          [[f, WA], IA],
          [
            // Smart TVs
            /panasonic;(viera)/i,
            // Panasonic Viera
            /(netrange)mmh/i,
            // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // NetTV
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,
            // Microsoft Xbox (360, One, X, S, Series X, Series S)
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,
            // Mint
            /(mageia|vectorlinux)[; ]/i,
            // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
            // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,
            // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i
            // Haiku
          ],
          [f, IA],
          [
            /(sunos) ?([\w\.\d]*)/i
            // Solaris
          ],
          [[f, "Solaris"], IA],
          [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i
            // UNIX
          ],
          [f, IA]
        ]
      }, vA = function(qA, _A) {
        if (typeof qA === k && (_A = qA, qA = E), !(this instanceof vA))
          return new vA(qA, _A).getResult();
        var VA = typeof g !== d && g.navigator ? g.navigator : E, yA = qA || (VA && VA.userAgent ? VA.userAgent : t), FA = VA && VA.userAgentData ? VA.userAgentData : E, uA = _A ? $A(HA, _A) : HA, JA = VA && VA.userAgent == yA;
        return this.getBrowser = function() {
          var YA = {};
          return YA[f] = E, YA[IA] = E, Gg.call(YA, yA, uA.browser), YA[M] = wg(YA[IA]), JA && VA && VA.brave && typeof VA.brave.isBrave == h && (YA[f] = "Brave"), YA;
        }, this.getCPU = function() {
          var YA = {};
          return YA[BA] = E, Gg.call(YA, yA, uA.cpu), YA;
        }, this.getDevice = function() {
          var YA = {};
          return YA[gA] = E, YA[H] = E, YA[AA] = E, Gg.call(YA, yA, uA.device), JA && !YA[AA] && FA && FA.mobile && (YA[AA] = QA), JA && YA[H] == "Macintosh" && VA && typeof VA.standalone !== d && VA.maxTouchPoints && VA.maxTouchPoints > 2 && (YA[H] = "iPad", YA[AA] = iA), YA;
        }, this.getEngine = function() {
          var YA = {};
          return YA[f] = E, YA[IA] = E, Gg.call(YA, yA, uA.engine), YA;
        }, this.getOS = function() {
          var YA = {};
          return YA[f] = E, YA[IA] = E, Gg.call(YA, yA, uA.os), JA && !YA[f] && FA && FA.platform && FA.platform != "Unknown" && (YA[f] = FA.platform.replace(/chrome os/i, WA).replace(/macos/i, eg)), YA;
        }, this.getResult = function() {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function() {
          return yA;
        }, this.setUA = function(YA) {
          return yA = typeof YA === p && YA.length > GA ? hg(YA, GA) : YA, this;
        }, this.setUA(yA), this;
      };
      vA.VERSION = e, vA.BROWSER = ag([f, IA, M]), vA.CPU = ag([BA]), vA.DEVICE = ag([H, gA, AA, CA, QA, EA, iA, oA, eA]), vA.ENGINE = vA.OS = ag([f, IA]), o.exports && (i = o.exports = vA), i.UAParser = vA;
      var zA = typeof g !== d && (g.jQuery || g.Zepto);
      if (zA && !zA.ua) {
        var PA = new vA();
        zA.ua = PA.getResult(), zA.ua.get = function() {
          return PA.getUA();
        }, zA.ua.set = function(qA) {
          PA.setUA(qA);
          var _A = PA.getResult();
          for (var VA in _A)
            zA.ua[VA] = _A[VA];
        };
      }
    })(typeof window == "object" ? window : uaParser);
  })(uaParser$1, uaParser$1.exports)), uaParser$1.exports;
}
var uaParserExports = requireUaParser();
const UAParser = /* @__PURE__ */ getDefaultExportFromCjs(uaParserExports), parser = new UAParser();
function isMobile() {
  return parser.getResult().device.type === "mobile";
}
function useSelectCommon(o) {
  const {
    options: i,
    isMulti: g,
    acceptNewOptions: E,
    placeholderInput: e
  } = o, t = useMemo$1(() => i.map((f, AA) => ({
    label: f,
    value: f,
    // We are using an id because if multiple options are equal,
    // we have observed weird UI glitches
    id: `${f}_${AA}`
  })), [i]), {
    placeholder: n,
    shouldDisable: h
  } = useMemo$1(() => getSelectPlaceholder(e, i, E, g), [E, g, i, e]), d = i.length > 10, k = isMobile() && !d && !E ? "readonly" : null, p = useMemo$1(() => (f) => isNullOrUndefined(f) ? [] : [{
    label: f,
    value: f
  }], []), M = useMemo$1(() => (f) => f.map((AA) => ({
    label: AA,
    value: AA
  })), []), H = useMemo$1(() => (f) => (AA, gA) => {
    const IA = Array.isArray(f) ? (
      // We need to manually filter for previously selected options here
      AA.filter((BA) => !f.includes(BA.value))
    ) : AA;
    return fuzzyFilterSelectOptions(IA, gA);
  }, []);
  return {
    selectOptions: t,
    placeholder: n,
    disabled: h,
    inputReadOnly: k,
    valueToUiSingle: p,
    valuesToUiMulti: M,
    createFilterOptions: H
  };
}
const Selectbox = ({
  disabled: o,
  value: i,
  onChange: g,
  options: E,
  label: e,
  labelVisibility: t,
  help: n,
  placeholder: h,
  clearable: d,
  acceptNewOptions: k
}) => {
  const p = useEmotionTheme(), M = useContext(IsSidebarContext), [H, f] = useState(i), AA = useRef(H);
  useExecuteWhenChanged(() => {
    f(i), AA.current = null;
  }, [i]);
  const gA = useCallback((aA) => {
    if (aA.type === "remove") {
      AA.current = aA.option?.value, f(null);
      return;
    }
    if (AA.current = null, aA.type === "clear") {
      f(null), g(null);
      return;
    }
    const [sA] = aA.value;
    f(sA.value), g(sA.value);
  }, [g]), IA = useCallback(() => {
    AA.current !== null && f(AA.current);
  }, []), BA = E, {
    placeholder: CA,
    disabled: QA,
    selectOptions: iA,
    inputReadOnly: EA,
    valueToUiSingle: oA,
    createFilterOptions: eA
  } = useSelectCommon({
    options: BA,
    isMulti: !1,
    acceptNewOptions: k,
    placeholderInput: h
  }), GA = o || QA, cA = useMemo$1(() => eA(), [eA]), tA = oA(H);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "stSelectbox", "data-testid": "stSelectbox", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(WidgetLabel, { label: e, labelVisibility: t, disabled: GA, children: n && /* @__PURE__ */ jsxRuntimeExports.jsx(WidgetLabelHelpIcon, { content: n, label: e }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { creatable: k, disabled: GA, labelKey: "label", "aria-label": e || "", onChange: gA, onBlur: IA, options: iA, filterOptions: cA, clearable: d || !1, escapeClearsValue: d || !1, value: tA, valueKey: "value", placeholder: CA, ignoreCase: !1, overrides: {
      Root: {
        style: () => ({
          lineHeight: p.lineHeights.inputWidget,
          fontWeight: p.fontWeights.normal
        })
      },
      Dropdown: {
        component: VirtualDropdown
      },
      ClearIcon: {
        props: {
          overrides: {
            Svg: {
              style: {
                color: p.colors.grayTextColor,
                // Setting this width and height makes the clear-icon align with dropdown arrows
                padding: p.spacing.threeXS,
                height: p.sizes.clearIconSize,
                width: p.sizes.clearIconSize,
                ":hover": {
                  fill: p.colors.bodyText
                }
              }
            }
          }
        }
      },
      ControlContainer: {
        style: ({
          $isFocused: aA
        }) => {
          const sA = getBorderColor(p.colors, aA);
          return {
            height: p.sizes.minElementHeight,
            // Baseweb requires long-hand props, short-hand leads to weird bugs & warnings.
            borderLeftWidth: p.sizes.borderWidth,
            borderRightWidth: p.sizes.borderWidth,
            borderTopWidth: p.sizes.borderWidth,
            borderBottomWidth: p.sizes.borderWidth,
            borderTopColor: sA,
            borderRightColor: sA,
            borderBottomColor: sA,
            borderLeftColor: sA
          };
        }
      },
      IconsContainer: {
        style: () => ({
          paddingRight: p.spacing.sm
        })
      },
      Placeholder: {
        style: () => ({
          color: GA ? p.colors.fadedText40 : p.colors.fadedText60
        })
      },
      ValueContainer: {
        style: () => ({
          // Baseweb requires long-hand props, short-hand leads to weird bugs & warnings.
          paddingRight: p.spacing.sm,
          paddingLeft: p.spacing.md,
          paddingBottom: p.spacing.sm,
          paddingTop: p.spacing.sm
        })
      },
      Input: {
        props: {
          readOnly: EA
        },
        style: () => ({
          lineHeight: p.lineHeights.inputWidget
        })
      },
      // Nudge the dropdown menu by 1px so the focus state doesn't get cut off
      Popover: {
        props: {
          ignoreBoundary: M,
          overrides: {
            Body: {
              style: () => ({
                marginTop: p.spacing.px
              })
            }
          }
        }
      },
      SingleValue: {
        style: () => ({
          // remove margin from select value so that there is no jumpb, e.g. when pressing backspace on a selected option and removing a character.
          marginLeft: p.spacing.none
        })
      },
      SelectArrow: {
        component: ChevronDown$1,
        props: {
          style: {
            ...GA && {
              cursor: "not-allowed"
            }
          },
          overrides: {
            Svg: {
              style: () => ({
                width: p.iconSizes.xl,
                height: p.iconSizes.xl
              })
            }
          }
        }
      }
    } })
  ] });
}, UISelectbox = memo(Selectbox);
class CircularBuffer {
  /**
   * Creates an instance of CircularBuffer.
   * @param {number} size - The size of the buffer.
   */
  constructor(i) {
    this._buffer = new Array(i), this._size = i, this._index = 0, this._wrappedCount = 0;
  }
  /**
   * Adds a value to the buffer.
   * @param {T} value - The value to add to the buffer.
   */
  push(i) {
    this._buffer[this._index] = i, this._index = (this._index + 1) % this._size, this._index === 0 && (this._wrappedCount = this._wrappedCount + 1);
  }
  /**
   * Gets the current state of the buffer.
   * @returns {readonly T[]} The buffer array.
   */
  get buffer() {
    return this._buffer;
  }
  /**
   * Gets the total number of entries written to the buffer.
   * @returns {number} The total number of written entries.
   */
  get totalWrittenEntries() {
    return this._wrappedCount * this._size + this._index;
  }
}
const handleRender = (o, i, g, E, e, t) => {
  window.__streamlit_profiles__ = window.__streamlit_profiles__ || {}, window.__streamlit_profiles__[o] = window.__streamlit_profiles__[o] || // Use a CircularBuffer to limit the number of profiles stored in memory to
  // prevent any potential memory leaks.
  // 1000 is an arbitrary number that should be enough to store more than
  // enough entries for debugging purposes without consuming too much memory.
  new CircularBuffer(1e3), window.__streamlit_profiles__[o].push({
    phase: i,
    actualDuration: g,
    baseDuration: E,
    startTime: e,
    commitTime: t
  });
}, Profiler = ({
  id: o,
  children: i
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler$1, { id: o, onRender: handleRender, children: i }), WindowDimensionsContext = createContext(null);
WindowDimensionsContext.displayName = "WindowDimensionsContext";
const useWindowDimensions = () => {
  const o = useEmotionTheme(), [i, g] = useState({
    fullWidth: 0,
    fullHeight: 0,
    innerWidth: 0,
    innerHeight: 0
  }), E = useCallback(() => {
    const t = convertRemToPx(o.spacing.md), n = convertRemToPx(o.sizes.fullScreenHeaderHeight), {
      innerWidth: h,
      innerHeight: d
    } = window;
    return {
      fullWidth: h - t * 2,
      // Left and right
      fullHeight: d - (t + n),
      // Bottom and Top
      innerWidth: h,
      innerHeight: d
    };
  }, [o.sizes.fullScreenHeaderHeight, o.spacing.md]), e = useCallback(() => {
    g(E());
  }, [E]);
  return useEffect(() => (window.addEventListener("resize", e), () => {
    window.removeEventListener("resize", e);
  }), [e]), useLayoutEffect$1(() => {
    e();
  }, [e]), i;
}, WindowDimensionsProvider = ({
  children: o
}) => {
  const i = useWindowDimensions();
  if (useContext(WindowDimensionsContext))
    throw new Error("WindowDimensionsProvider should only be used once per app. If you need to read window dimensions, utilize `useWindowDimensionsContext()` instead.");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WindowDimensionsContext.Provider, { value: i, children: o });
}, useWindowDimensionsContext = () => useRequiredContext(WindowDimensionsContext);
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, loglevel$1 = { exports: {} }, loglevel = loglevel$1.exports, hasRequiredLoglevel;
function requireLoglevel() {
  return hasRequiredLoglevel || (hasRequiredLoglevel = 1, (function(o) {
    (function(i, g) {
      o.exports ? o.exports = g() : i.log = g();
    })(loglevel, function() {
      var i = function() {
      }, g = "undefined", E = typeof window !== g && typeof window.navigator !== g && /Trident\/|MSIE /.test(window.navigator.userAgent), e = ["trace", "debug", "info", "warn", "error"], t = {}, n = null;
      function h(gA, IA) {
        var BA = gA[IA];
        if (typeof BA.bind == "function") return BA.bind(gA);
        try {
          return Function.prototype.bind.call(BA, gA);
        } catch {
          return function() {
            return Function.prototype.apply.apply(BA, [gA, arguments]);
          };
        }
      }
      function d() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function k(gA) {
        return gA === "debug" && (gA = "log"), typeof console === g ? !1 : gA === "trace" && E ? d : console[gA] !== void 0 ? h(console, gA) : console.log !== void 0 ? h(console, "log") : i;
      }
      function p() {
        for (var gA = this.getLevel(), IA = 0; IA < e.length; IA++) {
          var BA = e[IA];
          this[BA] = IA < gA ? i : this.methodFactory(BA, gA, this.name);
        }
        if (this.log = this.debug, typeof console === g && gA < this.levels.SILENT) return "No console available for logging";
      }
      function M(gA) {
        return function() {
          typeof console !== g && (p.call(this), this[gA].apply(this, arguments));
        };
      }
      function H(gA, IA, BA) {
        return k(gA) || M.apply(this, arguments);
      }
      function f(gA, IA) {
        var BA = this, CA, QA, iA, EA = "loglevel";
        typeof gA == "string" ? EA += ":" + gA : typeof gA == "symbol" && (EA = void 0);
        function oA(aA) {
          var sA = (e[aA] || "silent").toUpperCase();
          if (!(typeof window === g || !EA)) {
            try {
              window.localStorage[EA] = sA;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(EA) + "=" + sA + ";";
            } catch {
            }
          }
        }
        function eA() {
          var aA;
          if (!(typeof window === g || !EA)) {
            try {
              aA = window.localStorage[EA];
            } catch {
            }
            if (typeof aA === g) try {
              var sA = window.document.cookie, DA = encodeURIComponent(EA), rA = sA.indexOf(DA + "=");
              rA !== -1 && (aA = /^([^;]+)/.exec(sA.slice(rA + DA.length + 1))[1]);
            } catch {
            }
            return BA.levels[aA] === void 0 && (aA = void 0), aA;
          }
        }
        function GA() {
          if (!(typeof window === g || !EA)) {
            try {
              window.localStorage.removeItem(EA);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(EA) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function cA(aA) {
          var sA = aA;
          if (typeof sA == "string" && BA.levels[sA.toUpperCase()] !== void 0 && (sA = BA.levels[sA.toUpperCase()]), typeof sA == "number" && sA >= 0 && sA <= BA.levels.SILENT) return sA;
          throw new TypeError("log.setLevel() called with invalid level: " + aA);
        }
        BA.name = gA, BA.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 }, BA.methodFactory = IA || H, BA.getLevel = function() {
          return iA ?? QA ?? CA;
        }, BA.setLevel = function(aA, sA) {
          return iA = cA(aA), sA !== !1 && oA(iA), p.call(BA);
        }, BA.setDefaultLevel = function(aA) {
          QA = cA(aA), eA() || BA.setLevel(aA, !1);
        }, BA.resetLevel = function() {
          iA = null, GA(), p.call(BA);
        }, BA.enableAll = function(aA) {
          BA.setLevel(BA.levels.TRACE, aA);
        }, BA.disableAll = function(aA) {
          BA.setLevel(BA.levels.SILENT, aA);
        }, BA.rebuild = function() {
          if (n !== BA && (CA = cA(n.getLevel())), p.call(BA), n === BA) for (var aA in t) t[aA].rebuild();
        }, CA = cA(n ? n.getLevel() : "WARN");
        var tA = eA();
        tA != null && (iA = cA(tA)), p.call(BA);
      }
      n = new f(), n.getLogger = function(gA) {
        if (typeof gA != "symbol" && typeof gA != "string" || gA === "") throw new TypeError("You must supply a name when creating a logger.");
        var IA = t[gA];
        return IA || (IA = t[gA] = new f(gA, n.methodFactory)), IA;
      };
      var AA = typeof window !== g ? window.log : void 0;
      return n.noConflict = function() {
        return typeof window !== g && window.log === n && (window.log = AA), n;
      }, n.getLoggers = function() {
        return t;
      }, n.default = n, n;
    });
  })(loglevel$1)), loglevel$1.exports;
}
var loglevelExports = requireLoglevel(), ConnectionState$1 = /* @__PURE__ */ ((o) => (o.CONNECTED = "CONNECTED", o.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", o.INITIAL = "INITIAL", o.PINGING_SERVER = "PINGING_SERVER", o.CONNECTING = "CONNECTING", o.STATIC_CONNECTING = "STATIC_CONNECTING", o.STATIC_CONNECTED = "STATIC_CONNECTED", o))(ConnectionState$1 || {}), indexMinimal = {}, minimal$1 = {}, aspromise, hasRequiredAspromise;
function requireAspromise() {
  if (hasRequiredAspromise) return aspromise;
  hasRequiredAspromise = 1, aspromise = o;
  function o(i, g) {
    for (var E = new Array(arguments.length - 1), e = 0, t = 2, n = !0; t < arguments.length; ) E[e++] = arguments[t++];
    return new Promise(function(h, d) {
      E[e] = function(k) {
        if (n) if (n = !1, k) d(k);
        else {
          for (var p = new Array(arguments.length - 1), M = 0; M < p.length; ) p[M++] = arguments[M];
          h.apply(null, p);
        }
      };
      try {
        i.apply(g || null, E);
      } catch (k) {
        n && (n = !1, d(k));
      }
    });
  }
  return aspromise;
}
var base64 = {}, hasRequiredBase64;
function requireBase64() {
  return hasRequiredBase64 || (hasRequiredBase64 = 1, (function(o) {
    var i = o;
    i.length = function(n) {
      var h = n.length;
      if (!h) return 0;
      for (var d = 0; --h % 4 > 1 && n.charAt(h) === "="; ) ++d;
      return Math.ceil(n.length * 3) / 4 - d;
    };
    for (var g = new Array(64), E = new Array(123), e = 0; e < 64; ) E[g[e] = e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e - 59 | 43] = e++;
    i.encode = function(n, h, d) {
      for (var k = null, p = [], M = 0, H = 0, f; h < d; ) {
        var AA = n[h++];
        switch (H) {
          case 0:
            p[M++] = g[AA >> 2], f = (AA & 3) << 4, H = 1;
            break;
          case 1:
            p[M++] = g[f | AA >> 4], f = (AA & 15) << 2, H = 2;
            break;
          case 2:
            p[M++] = g[f | AA >> 6], p[M++] = g[AA & 63], H = 0;
            break;
        }
        M > 8191 && ((k || (k = [])).push(String.fromCharCode.apply(String, p)), M = 0);
      }
      return H && (p[M++] = g[f], p[M++] = 61, H === 1 && (p[M++] = 61)), k ? (M && k.push(String.fromCharCode.apply(String, p.slice(0, M))), k.join("")) : String.fromCharCode.apply(String, p.slice(0, M));
    };
    var t = "invalid encoding";
    i.decode = function(n, h, d) {
      for (var k = d, p = 0, M, H = 0; H < n.length; ) {
        var f = n.charCodeAt(H++);
        if (f === 61 && p > 1) break;
        if ((f = E[f]) === void 0) throw Error(t);
        switch (p) {
          case 0:
            M = f, p = 1;
            break;
          case 1:
            h[d++] = M << 2 | (f & 48) >> 4, M = f, p = 2;
            break;
          case 2:
            h[d++] = (M & 15) << 4 | (f & 60) >> 2, M = f, p = 3;
            break;
          case 3:
            h[d++] = (M & 3) << 6 | f, p = 0;
            break;
        }
      }
      if (p === 1) throw Error(t);
      return d - k;
    }, i.test = function(n) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(n);
    };
  })(base64)), base64;
}
var eventemitter, hasRequiredEventemitter;
function requireEventemitter() {
  if (hasRequiredEventemitter) return eventemitter;
  hasRequiredEventemitter = 1, eventemitter = o;
  function o() {
    this._listeners = {};
  }
  return o.prototype.on = function(i, g, E) {
    return (this._listeners[i] || (this._listeners[i] = [])).push({ fn: g, ctx: E || this }), this;
  }, o.prototype.off = function(i, g) {
    if (i === void 0) this._listeners = {};
    else if (g === void 0) this._listeners[i] = [];
    else for (var E = this._listeners[i], e = 0; e < E.length; ) E[e].fn === g ? E.splice(e, 1) : ++e;
    return this;
  }, o.prototype.emit = function(i) {
    var g = this._listeners[i];
    if (g) {
      for (var E = [], e = 1; e < arguments.length; ) E.push(arguments[e++]);
      for (e = 0; e < g.length; ) g[e].fn.apply(g[e++].ctx, E);
    }
    return this;
  }, eventemitter;
}
var float, hasRequiredFloat;
function requireFloat() {
  if (hasRequiredFloat) return float;
  hasRequiredFloat = 1, float = o(o);
  function o(t) {
    return typeof Float32Array < "u" ? (function() {
      var n = new Float32Array([-0]), h = new Uint8Array(n.buffer), d = h[3] === 128;
      function k(f, AA, gA) {
        n[0] = f, AA[gA] = h[0], AA[gA + 1] = h[1], AA[gA + 2] = h[2], AA[gA + 3] = h[3];
      }
      function p(f, AA, gA) {
        n[0] = f, AA[gA] = h[3], AA[gA + 1] = h[2], AA[gA + 2] = h[1], AA[gA + 3] = h[0];
      }
      t.writeFloatLE = d ? k : p, t.writeFloatBE = d ? p : k;
      function M(f, AA) {
        return h[0] = f[AA], h[1] = f[AA + 1], h[2] = f[AA + 2], h[3] = f[AA + 3], n[0];
      }
      function H(f, AA) {
        return h[3] = f[AA], h[2] = f[AA + 1], h[1] = f[AA + 2], h[0] = f[AA + 3], n[0];
      }
      t.readFloatLE = d ? M : H, t.readFloatBE = d ? H : M;
    })() : (function() {
      function n(d, k, p, M) {
        var H = k < 0 ? 1 : 0;
        if (H && (k = -k), k === 0) d(1 / k > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), p, M);
        else if (isNaN(k)) d(2143289344, p, M);
        else if (k > 34028234663852886e22) d((H << 31 | 2139095040) >>> 0, p, M);
        else if (k < 11754943508222875e-54) d((H << 31 | Math.round(k / 1401298464324817e-60)) >>> 0, p, M);
        else {
          var f = Math.floor(Math.log(k) / Math.LN2), AA = Math.round(k * Math.pow(2, -f) * 8388608) & 8388607;
          d((H << 31 | f + 127 << 23 | AA) >>> 0, p, M);
        }
      }
      t.writeFloatLE = n.bind(null, i), t.writeFloatBE = n.bind(null, g);
      function h(d, k, p) {
        var M = d(k, p), H = (M >> 31) * 2 + 1, f = M >>> 23 & 255, AA = M & 8388607;
        return f === 255 ? AA ? NaN : H * (1 / 0) : f === 0 ? H * 1401298464324817e-60 * AA : H * Math.pow(2, f - 150) * (AA + 8388608);
      }
      t.readFloatLE = h.bind(null, E), t.readFloatBE = h.bind(null, e);
    })(), typeof Float64Array < "u" ? (function() {
      var n = new Float64Array([-0]), h = new Uint8Array(n.buffer), d = h[7] === 128;
      function k(f, AA, gA) {
        n[0] = f, AA[gA] = h[0], AA[gA + 1] = h[1], AA[gA + 2] = h[2], AA[gA + 3] = h[3], AA[gA + 4] = h[4], AA[gA + 5] = h[5], AA[gA + 6] = h[6], AA[gA + 7] = h[7];
      }
      function p(f, AA, gA) {
        n[0] = f, AA[gA] = h[7], AA[gA + 1] = h[6], AA[gA + 2] = h[5], AA[gA + 3] = h[4], AA[gA + 4] = h[3], AA[gA + 5] = h[2], AA[gA + 6] = h[1], AA[gA + 7] = h[0];
      }
      t.writeDoubleLE = d ? k : p, t.writeDoubleBE = d ? p : k;
      function M(f, AA) {
        return h[0] = f[AA], h[1] = f[AA + 1], h[2] = f[AA + 2], h[3] = f[AA + 3], h[4] = f[AA + 4], h[5] = f[AA + 5], h[6] = f[AA + 6], h[7] = f[AA + 7], n[0];
      }
      function H(f, AA) {
        return h[7] = f[AA], h[6] = f[AA + 1], h[5] = f[AA + 2], h[4] = f[AA + 3], h[3] = f[AA + 4], h[2] = f[AA + 5], h[1] = f[AA + 6], h[0] = f[AA + 7], n[0];
      }
      t.readDoubleLE = d ? M : H, t.readDoubleBE = d ? H : M;
    })() : (function() {
      function n(d, k, p, M, H, f) {
        var AA = M < 0 ? 1 : 0;
        if (AA && (M = -M), M === 0) d(0, H, f + k), d(1 / M > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), H, f + p);
        else if (isNaN(M)) d(0, H, f + k), d(2146959360, H, f + p);
        else if (M > 17976931348623157e292) d(0, H, f + k), d((AA << 31 | 2146435072) >>> 0, H, f + p);
        else {
          var gA;
          if (M < 22250738585072014e-324) gA = M / 5e-324, d(gA >>> 0, H, f + k), d((AA << 31 | gA / 4294967296) >>> 0, H, f + p);
          else {
            var IA = Math.floor(Math.log(M) / Math.LN2);
            IA === 1024 && (IA = 1023), gA = M * Math.pow(2, -IA), d(gA * 4503599627370496 >>> 0, H, f + k), d((AA << 31 | IA + 1023 << 20 | gA * 1048576 & 1048575) >>> 0, H, f + p);
          }
        }
      }
      t.writeDoubleLE = n.bind(null, i, 0, 4), t.writeDoubleBE = n.bind(null, g, 4, 0);
      function h(d, k, p, M, H) {
        var f = d(M, H + k), AA = d(M, H + p), gA = (AA >> 31) * 2 + 1, IA = AA >>> 20 & 2047, BA = 4294967296 * (AA & 1048575) + f;
        return IA === 2047 ? BA ? NaN : gA * (1 / 0) : IA === 0 ? gA * 5e-324 * BA : gA * Math.pow(2, IA - 1075) * (BA + 4503599627370496);
      }
      t.readDoubleLE = h.bind(null, E, 0, 4), t.readDoubleBE = h.bind(null, e, 4, 0);
    })(), t;
  }
  function i(t, n, h) {
    n[h] = t & 255, n[h + 1] = t >>> 8 & 255, n[h + 2] = t >>> 16 & 255, n[h + 3] = t >>> 24;
  }
  function g(t, n, h) {
    n[h] = t >>> 24, n[h + 1] = t >>> 16 & 255, n[h + 2] = t >>> 8 & 255, n[h + 3] = t & 255;
  }
  function E(t, n) {
    return (t[n] | t[n + 1] << 8 | t[n + 2] << 16 | t[n + 3] << 24) >>> 0;
  }
  function e(t, n) {
    return (t[n] << 24 | t[n + 1] << 16 | t[n + 2] << 8 | t[n + 3]) >>> 0;
  }
  return float;
}
var inquire_1, hasRequiredInquire;
function requireInquire() {
  if (hasRequiredInquire) return inquire_1;
  hasRequiredInquire = 1, inquire_1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (o) {
    }
    return null;
  }
  return inquire_1;
}
var utf8 = {}, hasRequiredUtf8;
function requireUtf8() {
  return hasRequiredUtf8 || (hasRequiredUtf8 = 1, (function(o) {
    var i = o;
    i.length = function(g) {
      for (var E = 0, e = 0, t = 0; t < g.length; ++t) e = g.charCodeAt(t), e < 128 ? E += 1 : e < 2048 ? E += 2 : (e & 64512) === 55296 && (g.charCodeAt(t + 1) & 64512) === 56320 ? (++t, E += 4) : E += 3;
      return E;
    }, i.read = function(g, E, e) {
      var t = e - E;
      if (t < 1) return "";
      for (var n = null, h = [], d = 0, k; E < e; ) k = g[E++], k < 128 ? h[d++] = k : k > 191 && k < 224 ? h[d++] = (k & 31) << 6 | g[E++] & 63 : k > 239 && k < 365 ? (k = ((k & 7) << 18 | (g[E++] & 63) << 12 | (g[E++] & 63) << 6 | g[E++] & 63) - 65536, h[d++] = 55296 + (k >> 10), h[d++] = 56320 + (k & 1023)) : h[d++] = (k & 15) << 12 | (g[E++] & 63) << 6 | g[E++] & 63, d > 8191 && ((n || (n = [])).push(String.fromCharCode.apply(String, h)), d = 0);
      return n ? (d && n.push(String.fromCharCode.apply(String, h.slice(0, d))), n.join("")) : String.fromCharCode.apply(String, h.slice(0, d));
    }, i.write = function(g, E, e) {
      for (var t = e, n, h, d = 0; d < g.length; ++d) n = g.charCodeAt(d), n < 128 ? E[e++] = n : n < 2048 ? (E[e++] = n >> 6 | 192, E[e++] = n & 63 | 128) : (n & 64512) === 55296 && ((h = g.charCodeAt(d + 1)) & 64512) === 56320 ? (n = 65536 + ((n & 1023) << 10) + (h & 1023), ++d, E[e++] = n >> 18 | 240, E[e++] = n >> 12 & 63 | 128, E[e++] = n >> 6 & 63 | 128, E[e++] = n & 63 | 128) : (E[e++] = n >> 12 | 224, E[e++] = n >> 6 & 63 | 128, E[e++] = n & 63 | 128);
      return e - t;
    };
  })(utf8)), utf8;
}
var pool_1, hasRequiredPool;
function requirePool() {
  if (hasRequiredPool) return pool_1;
  hasRequiredPool = 1, pool_1 = o;
  function o(i, g, E) {
    var e = E || 8192, t = e >>> 1, n = null, h = e;
    return function(d) {
      if (d < 1 || d > t) return i(d);
      h + d > e && (n = i(e), h = 0);
      var k = g.call(n, h, h += d);
      return h & 7 && (h = (h | 7) + 1), k;
    };
  }
  return pool_1;
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits) return longbits;
  hasRequiredLongbits = 1, longbits = i;
  var o = requireMinimal$1();
  function i(t, n) {
    this.lo = t >>> 0, this.hi = n >>> 0;
  }
  var g = i.zero = new i(0, 0);
  g.toNumber = function() {
    return 0;
  }, g.zzEncode = g.zzDecode = function() {
    return this;
  }, g.length = function() {
    return 1;
  };
  var E = i.zeroHash = "\0\0\0\0\0\0\0\0";
  i.fromNumber = function(t) {
    if (t === 0) return g;
    var n = t < 0;
    n && (t = -t);
    var h = t >>> 0, d = (t - h) / 4294967296 >>> 0;
    return n && (d = ~d >>> 0, h = ~h >>> 0, ++h > 4294967295 && (h = 0, ++d > 4294967295 && (d = 0))), new i(h, d);
  }, i.from = function(t) {
    if (typeof t == "number") return i.fromNumber(t);
    if (o.isString(t)) if (o.Long) t = o.Long.fromString(t);
    else return i.fromNumber(parseInt(t, 10));
    return t.low || t.high ? new i(t.low >>> 0, t.high >>> 0) : g;
  }, i.prototype.toNumber = function(t) {
    if (!t && this.hi >>> 31) {
      var n = ~this.lo + 1 >>> 0, h = ~this.hi >>> 0;
      return n || (h = h + 1 >>> 0), -(n + h * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, i.prototype.toLong = function(t) {
    return o.Long ? new o.Long(this.lo | 0, this.hi | 0, !!t) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!t };
  };
  var e = String.prototype.charCodeAt;
  return i.fromHash = function(t) {
    return t === E ? g : new i((e.call(t, 0) | e.call(t, 1) << 8 | e.call(t, 2) << 16 | e.call(t, 3) << 24) >>> 0, (e.call(t, 4) | e.call(t, 5) << 8 | e.call(t, 6) << 16 | e.call(t, 7) << 24) >>> 0);
  }, i.prototype.toHash = function() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
  }, i.prototype.zzEncode = function() {
    var t = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ t) >>> 0, this.lo = (this.lo << 1 ^ t) >>> 0, this;
  }, i.prototype.zzDecode = function() {
    var t = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ t) >>> 0, this.hi = (this.hi >>> 1 ^ t) >>> 0, this;
  }, i.prototype.length = function() {
    var t = this.lo, n = (this.lo >>> 28 | this.hi << 4) >>> 0, h = this.hi >>> 24;
    return h === 0 ? n === 0 ? t < 16384 ? t < 128 ? 1 : 2 : t < 2097152 ? 3 : 4 : n < 16384 ? n < 128 ? 5 : 6 : n < 2097152 ? 7 : 8 : h < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, (function(o) {
    var i = o;
    i.asPromise = requireAspromise(), i.base64 = requireBase64(), i.EventEmitter = requireEventemitter(), i.float = requireFloat(), i.inquire = requireInquire(), i.utf8 = requireUtf8(), i.pool = requirePool(), i.LongBits = requireLongbits(), i.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), i.global = i.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || minimal$1, i.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), i.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), i.isInteger = Number.isInteger || /* istanbul ignore next */
    function(e) {
      return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
    }, i.isString = function(e) {
      return typeof e == "string" || e instanceof String;
    }, i.isObject = function(e) {
      return e && typeof e == "object";
    }, i.isset = /**
    * Checks if a property on a message is considered to be present.
    * @param {Object} obj Plain object or message instance
    * @param {string} prop Property name
    * @returns {boolean} `true` if considered to be present, otherwise `false`
    */
    i.isSet = function(e, t) {
      var n = e[t];
      return n != null && e.hasOwnProperty(t) ? typeof n != "object" || (Array.isArray(n) ? n.length : Object.keys(n).length) > 0 : !1;
    }, i.Buffer = (function() {
      try {
        var e = i.inquire("buffer").Buffer;
        return e.prototype.utf8Write ? e : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    })(), i._Buffer_from = null, i._Buffer_allocUnsafe = null, i.newBuffer = function(e) {
      return typeof e == "number" ? i.Buffer ? i._Buffer_allocUnsafe(e) : new i.Array(e) : i.Buffer ? i._Buffer_from(e) : typeof Uint8Array > "u" ? e : new Uint8Array(e);
    }, i.Array = typeof Uint8Array < "u" ? Uint8Array : Array, i.Long = /* istanbul ignore next */
    i.global.dcodeIO && /* istanbul ignore next */
    i.global.dcodeIO.Long || /* istanbul ignore next */
    i.global.Long || i.inquire("long"), i.key2Re = /^true|false|0|1$/, i.key32Re = /^-?(?:0|[1-9][0-9]*)$/, i.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, i.longToHash = function(e) {
      return e ? i.LongBits.from(e).toHash() : i.LongBits.zeroHash;
    }, i.longFromHash = function(e, t) {
      var n = i.LongBits.fromHash(e);
      return i.Long ? i.Long.fromBits(n.lo, n.hi, t) : n.toNumber(!!t);
    };
    function g(e, t, n) {
      for (var h = Object.keys(t), d = 0; d < h.length; ++d) (e[h[d]] === void 0 || !n) && (e[h[d]] = t[h[d]]);
      return e;
    }
    i.merge = g, i.lcFirst = function(e) {
      return e.charAt(0).toLowerCase() + e.substring(1);
    };
    function E(e) {
      function t(n, h) {
        if (!(this instanceof t)) return new t(n, h);
        Object.defineProperty(this, "message", { get: function() {
          return n;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), h && g(this, h);
      }
      return t.prototype = Object.create(Error.prototype, { constructor: { value: t, writable: !0, enumerable: !1, configurable: !0 }, name: {
        get: function() {
          return e;
        },
        set: void 0,
        enumerable: !1,
        // configurable: false would accurately preserve the behavior of
        // the original, but I'm guessing that was not intentional.
        // For an actual error subclass, this property would
        // be configurable.
        configurable: !0
      }, toString: { value: function() {
        return this.name + ": " + this.message;
      }, writable: !0, enumerable: !1, configurable: !0 } }), t;
    }
    i.newError = E, i.ProtocolError = E("ProtocolError"), i.oneOfGetter = function(e) {
      for (var t = {}, n = 0; n < e.length; ++n) t[e[n]] = 1;
      return function() {
        for (var h = Object.keys(this), d = h.length - 1; d > -1; --d) if (t[h[d]] === 1 && this[h[d]] !== void 0 && this[h[d]] !== null) return h[d];
      };
    }, i.oneOfSetter = function(e) {
      return function(t) {
        for (var n = 0; n < e.length; ++n) e[n] !== t && delete this[e[n]];
      };
    }, i.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }, i._configure = function() {
      var e = i.Buffer;
      if (!e) {
        i._Buffer_from = i._Buffer_allocUnsafe = null;
        return;
      }
      i._Buffer_from = e.from !== Uint8Array.from && e.from || /* istanbul ignore next */
      function(t, n) {
        return new e(t, n);
      }, i._Buffer_allocUnsafe = e.allocUnsafe || /* istanbul ignore next */
      function(t) {
        return new e(t);
      };
    };
  })(minimal$1)), minimal$1;
}
var writer, hasRequiredWriter;
function requireWriter() {
  if (hasRequiredWriter) return writer;
  hasRequiredWriter = 1, writer = d;
  var o = requireMinimal$1(), i, g = o.LongBits, E = o.base64, e = o.utf8;
  function t(IA, BA, CA) {
    this.fn = IA, this.len = BA, this.next = void 0, this.val = CA;
  }
  function n() {
  }
  function h(IA) {
    this.head = IA.head, this.tail = IA.tail, this.len = IA.len, this.next = IA.states;
  }
  function d() {
    this.len = 0, this.head = new t(n, 0, 0), this.tail = this.head, this.states = null;
  }
  var k = function() {
    return o.Buffer ? function() {
      return (d.create = function() {
        return new i();
      })();
    } : function() {
      return new d();
    };
  };
  d.create = k(), d.alloc = function(IA) {
    return new o.Array(IA);
  }, o.Array !== Array && (d.alloc = o.pool(d.alloc, o.Array.prototype.subarray)), d.prototype._push = function(IA, BA, CA) {
    return this.tail = this.tail.next = new t(IA, BA, CA), this.len += BA, this;
  };
  function p(IA, BA, CA) {
    BA[CA] = IA & 255;
  }
  function M(IA, BA, CA) {
    for (; IA > 127; ) BA[CA++] = IA & 127 | 128, IA >>>= 7;
    BA[CA] = IA;
  }
  function H(IA, BA) {
    this.len = IA, this.next = void 0, this.val = BA;
  }
  H.prototype = Object.create(t.prototype), H.prototype.fn = M, d.prototype.uint32 = function(IA) {
    return this.len += (this.tail = this.tail.next = new H((IA = IA >>> 0) < 128 ? 1 : IA < 16384 ? 2 : IA < 2097152 ? 3 : IA < 268435456 ? 4 : 5, IA)).len, this;
  }, d.prototype.int32 = function(IA) {
    return IA < 0 ? this._push(f, 10, g.fromNumber(IA)) : this.uint32(IA);
  }, d.prototype.sint32 = function(IA) {
    return this.uint32((IA << 1 ^ IA >> 31) >>> 0);
  };
  function f(IA, BA, CA) {
    for (; IA.hi; ) BA[CA++] = IA.lo & 127 | 128, IA.lo = (IA.lo >>> 7 | IA.hi << 25) >>> 0, IA.hi >>>= 7;
    for (; IA.lo > 127; ) BA[CA++] = IA.lo & 127 | 128, IA.lo = IA.lo >>> 7;
    BA[CA++] = IA.lo;
  }
  d.prototype.uint64 = function(IA) {
    var BA = g.from(IA);
    return this._push(f, BA.length(), BA);
  }, d.prototype.int64 = d.prototype.uint64, d.prototype.sint64 = function(IA) {
    var BA = g.from(IA).zzEncode();
    return this._push(f, BA.length(), BA);
  }, d.prototype.bool = function(IA) {
    return this._push(p, 1, IA ? 1 : 0);
  };
  function AA(IA, BA, CA) {
    BA[CA] = IA & 255, BA[CA + 1] = IA >>> 8 & 255, BA[CA + 2] = IA >>> 16 & 255, BA[CA + 3] = IA >>> 24;
  }
  d.prototype.fixed32 = function(IA) {
    return this._push(AA, 4, IA >>> 0);
  }, d.prototype.sfixed32 = d.prototype.fixed32, d.prototype.fixed64 = function(IA) {
    var BA = g.from(IA);
    return this._push(AA, 4, BA.lo)._push(AA, 4, BA.hi);
  }, d.prototype.sfixed64 = d.prototype.fixed64, d.prototype.float = function(IA) {
    return this._push(o.float.writeFloatLE, 4, IA);
  }, d.prototype.double = function(IA) {
    return this._push(o.float.writeDoubleLE, 8, IA);
  };
  var gA = o.Array.prototype.set ? function(IA, BA, CA) {
    BA.set(IA, CA);
  } : function(IA, BA, CA) {
    for (var QA = 0; QA < IA.length; ++QA) BA[CA + QA] = IA[QA];
  };
  return d.prototype.bytes = function(IA) {
    var BA = IA.length >>> 0;
    if (!BA) return this._push(p, 1, 0);
    if (o.isString(IA)) {
      var CA = d.alloc(BA = E.length(IA));
      E.decode(IA, CA, 0), IA = CA;
    }
    return this.uint32(BA)._push(gA, BA, IA);
  }, d.prototype.string = function(IA) {
    var BA = e.length(IA);
    return BA ? this.uint32(BA)._push(e.write, BA, IA) : this._push(p, 1, 0);
  }, d.prototype.fork = function() {
    return this.states = new h(this), this.head = this.tail = new t(n, 0, 0), this.len = 0, this;
  }, d.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new t(n, 0, 0), this.len = 0), this;
  }, d.prototype.ldelim = function() {
    var IA = this.head, BA = this.tail, CA = this.len;
    return this.reset().uint32(CA), CA && (this.tail.next = IA.next, this.tail = BA, this.len += CA), this;
  }, d.prototype.finish = function() {
    for (var IA = this.head.next, BA = this.constructor.alloc(this.len), CA = 0; IA; ) IA.fn(IA.val, BA, CA), CA += IA.len, IA = IA.next;
    return BA;
  }, d._configure = function(IA) {
    i = IA, d.create = k(), i._configure();
  }, writer;
}
var writer_buffer, hasRequiredWriter_buffer;
function requireWriter_buffer() {
  if (hasRequiredWriter_buffer) return writer_buffer;
  hasRequiredWriter_buffer = 1, writer_buffer = g;
  var o = requireWriter();
  (g.prototype = Object.create(o.prototype)).constructor = g;
  var i = requireMinimal$1();
  function g() {
    o.call(this);
  }
  g._configure = function() {
    g.alloc = i._Buffer_allocUnsafe, g.writeBytesBuffer = i.Buffer && i.Buffer.prototype instanceof Uint8Array && i.Buffer.prototype.set.name === "set" ? function(e, t, n) {
      t.set(e, n);
    } : function(e, t, n) {
      if (e.copy) e.copy(t, n, 0, e.length);
      else for (var h = 0; h < e.length; ) t[n++] = e[h++];
    };
  }, g.prototype.bytes = function(e) {
    i.isString(e) && (e = i._Buffer_from(e, "base64"));
    var t = e.length >>> 0;
    return this.uint32(t), t && this._push(g.writeBytesBuffer, t, e), this;
  };
  function E(e, t, n) {
    e.length < 40 ? i.utf8.write(e, t, n) : t.utf8Write ? t.utf8Write(e, n) : t.write(e, n);
  }
  return g.prototype.string = function(e) {
    var t = i.Buffer.byteLength(e);
    return this.uint32(t), t && this._push(E, t, e), this;
  }, g._configure(), writer_buffer;
}
var reader, hasRequiredReader;
function requireReader() {
  if (hasRequiredReader) return reader;
  hasRequiredReader = 1, reader = t;
  var o = requireMinimal$1(), i, g = o.LongBits, E = o.utf8;
  function e(M, H) {
    return RangeError("index out of range: " + M.pos + " + " + (H || 1) + " > " + M.len);
  }
  function t(M) {
    this.buf = M, this.pos = 0, this.len = M.length;
  }
  var n = typeof Uint8Array < "u" ? function(M) {
    if (M instanceof Uint8Array || Array.isArray(M)) return new t(M);
    throw Error("illegal buffer");
  } : function(M) {
    if (Array.isArray(M)) return new t(M);
    throw Error("illegal buffer");
  }, h = function() {
    return o.Buffer ? function(M) {
      return (t.create = function(H) {
        return o.Buffer.isBuffer(H) ? new i(H) : n(H);
      })(M);
    } : n;
  };
  t.create = h(), t.prototype._slice = o.Array.prototype.subarray || /* istanbul ignore next */
  o.Array.prototype.slice, t.prototype.uint32 = /* @__PURE__ */ (function() {
    var M = 4294967295;
    return function() {
      if (M = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (M = (M | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return M;
      if ((this.pos += 5) > this.len) throw this.pos = this.len, e(this, 10);
      return M;
    };
  })(), t.prototype.int32 = function() {
    return this.uint32() | 0;
  }, t.prototype.sint32 = function() {
    var M = this.uint32();
    return M >>> 1 ^ -(M & 1) | 0;
  };
  function d() {
    var M = new g(0, 0), H = 0;
    if (this.len - this.pos > 4) {
      for (; H < 4; ++H) if (M.lo = (M.lo | (this.buf[this.pos] & 127) << H * 7) >>> 0, this.buf[this.pos++] < 128) return M;
      if (M.lo = (M.lo | (this.buf[this.pos] & 127) << 28) >>> 0, M.hi = (M.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128) return M;
      H = 0;
    } else {
      for (; H < 3; ++H) {
        if (this.pos >= this.len) throw e(this);
        if (M.lo = (M.lo | (this.buf[this.pos] & 127) << H * 7) >>> 0, this.buf[this.pos++] < 128) return M;
      }
      return M.lo = (M.lo | (this.buf[this.pos++] & 127) << H * 7) >>> 0, M;
    }
    if (this.len - this.pos > 4) {
      for (; H < 5; ++H) if (M.hi = (M.hi | (this.buf[this.pos] & 127) << H * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return M;
    } else for (; H < 5; ++H) {
      if (this.pos >= this.len) throw e(this);
      if (M.hi = (M.hi | (this.buf[this.pos] & 127) << H * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return M;
    }
    throw Error("invalid varint encoding");
  }
  t.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function k(M, H) {
    return (M[H - 4] | M[H - 3] << 8 | M[H - 2] << 16 | M[H - 1] << 24) >>> 0;
  }
  t.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len) throw e(this, 4);
    return k(this.buf, this.pos += 4);
  }, t.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len) throw e(this, 4);
    return k(this.buf, this.pos += 4) | 0;
  };
  function p() {
    if (this.pos + 8 > this.len) throw e(this, 8);
    return new g(k(this.buf, this.pos += 4), k(this.buf, this.pos += 4));
  }
  return t.prototype.float = function() {
    if (this.pos + 4 > this.len) throw e(this, 4);
    var M = o.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, M;
  }, t.prototype.double = function() {
    if (this.pos + 8 > this.len) throw e(this, 4);
    var M = o.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, M;
  }, t.prototype.bytes = function() {
    var M = this.uint32(), H = this.pos, f = this.pos + M;
    if (f > this.len) throw e(this, M);
    if (this.pos += M, Array.isArray(this.buf)) return this.buf.slice(H, f);
    if (H === f) {
      var AA = o.Buffer;
      return AA ? AA.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, H, f);
  }, t.prototype.string = function() {
    var M = this.bytes();
    return E.read(M, 0, M.length);
  }, t.prototype.skip = function(M) {
    if (typeof M == "number") {
      if (this.pos + M > this.len) throw e(this, M);
      this.pos += M;
    } else do
      if (this.pos >= this.len) throw e(this);
    while (this.buf[this.pos++] & 128);
    return this;
  }, t.prototype.skipType = function(M) {
    switch (M) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (M = this.uint32() & 7) !== 4; ) this.skipType(M);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + M + " at offset " + this.pos);
    }
    return this;
  }, t._configure = function(M) {
    i = M, t.create = h(), i._configure();
    var H = o.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    o.merge(t.prototype, { int64: function() {
      return d.call(this)[H](!1);
    }, uint64: function() {
      return d.call(this)[H](!0);
    }, sint64: function() {
      return d.call(this).zzDecode()[H](!1);
    }, fixed64: function() {
      return p.call(this)[H](!0);
    }, sfixed64: function() {
      return p.call(this)[H](!1);
    } });
  }, reader;
}
var reader_buffer, hasRequiredReader_buffer;
function requireReader_buffer() {
  if (hasRequiredReader_buffer) return reader_buffer;
  hasRequiredReader_buffer = 1, reader_buffer = g;
  var o = requireReader();
  (g.prototype = Object.create(o.prototype)).constructor = g;
  var i = requireMinimal$1();
  function g(E) {
    o.call(this, E);
  }
  return g._configure = function() {
    i.Buffer && (g.prototype._slice = i.Buffer.prototype.slice);
  }, g.prototype.string = function() {
    var E = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + E, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + E, this.len));
  }, g._configure(), reader_buffer;
}
var rpc = {}, service$1, hasRequiredService$1;
function requireService$1() {
  if (hasRequiredService$1) return service$1;
  hasRequiredService$1 = 1, service$1 = i;
  var o = requireMinimal$1();
  (i.prototype = Object.create(o.EventEmitter.prototype)).constructor = i;
  function i(g, E, e) {
    if (typeof g != "function") throw TypeError("rpcImpl must be a function");
    o.EventEmitter.call(this), this.rpcImpl = g, this.requestDelimited = !!E, this.responseDelimited = !!e;
  }
  return i.prototype.rpcCall = function g(E, e, t, n, h) {
    if (!n) throw TypeError("request must be specified");
    var d = this;
    if (!h) return o.asPromise(g, d, E, e, t, n);
    if (!d.rpcImpl) {
      setTimeout(function() {
        h(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return d.rpcImpl(E, e[d.requestDelimited ? "encodeDelimited" : "encode"](n).finish(), function(k, p) {
        if (k) return d.emit("error", k, E), h(k);
        if (p === null) {
          d.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(p instanceof t)) try {
          p = t[d.responseDelimited ? "decodeDelimited" : "decode"](p);
        } catch (M) {
          return d.emit("error", M, E), h(M);
        }
        return d.emit("data", p, E), h(null, p);
      });
    } catch (k) {
      d.emit("error", k, E), setTimeout(function() {
        h(k);
      }, 0);
      return;
    }
  }, i.prototype.end = function(g) {
    return this.rpcImpl && (g || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service$1;
}
var hasRequiredRpc;
function requireRpc() {
  return hasRequiredRpc || (hasRequiredRpc = 1, (function(o) {
    var i = o;
    i.Service = requireService$1();
  })(rpc)), rpc;
}
var roots, hasRequiredRoots;
function requireRoots() {
  return hasRequiredRoots || (hasRequiredRoots = 1, roots = {}), roots;
}
var hasRequiredIndexMinimal;
function requireIndexMinimal() {
  return hasRequiredIndexMinimal || (hasRequiredIndexMinimal = 1, (function(o) {
    var i = o;
    i.build = "minimal", i.Writer = requireWriter(), i.BufferWriter = requireWriter_buffer(), i.Reader = requireReader(), i.BufferReader = requireReader_buffer(), i.util = requireMinimal$1(), i.rpc = requireRpc(), i.roots = requireRoots(), i.configure = g;
    function g() {
      i.util._configure(), i.Writer._configure(i.BufferWriter), i.Reader._configure(i.BufferReader);
    }
    g();
  })(indexMinimal)), indexMinimal;
}
var minimal, hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, minimal = requireIndexMinimal()), minimal;
}
var minimalExports = requireMinimal();
const $Reader = minimalExports.Reader, $Writer = minimalExports.Writer, $util = minimalExports.util, $root = minimalExports.roots.default || (minimalExports.roots.default = {});
$root.Alert = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.body = "", o.prototype.format = 0, o.prototype.icon = "", o.prototype.widthConfig = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.body != null && Object.hasOwnProperty.call(i, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.body), i.format != null && Object.hasOwnProperty.call(i, "format") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(i.format), i.icon != null && Object.hasOwnProperty.call(i, "icon") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.icon), i.widthConfig != null && Object.hasOwnProperty.call(i, "widthConfig") && $root.streamlit.WidthConfig.encode(i.widthConfig, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Alert();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.body = i.string();
          break;
        }
        case 2: {
          t.format = i.int32();
          break;
        }
        case 3: {
          t.icon = i.string();
          break;
        }
        case 4: {
          t.widthConfig = $root.streamlit.WidthConfig.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Alert) return i;
    let g = new $root.Alert();
    switch (i.body != null && (g.body = String(i.body)), i.format) {
      default:
        if (typeof i.format == "number") {
          g.format = i.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        g.format = 0;
        break;
      case "ERROR":
      case 1:
        g.format = 1;
        break;
      case "WARNING":
      case 2:
        g.format = 2;
        break;
      case "INFO":
      case 3:
        g.format = 3;
        break;
      case "SUCCESS":
      case 4:
        g.format = 4;
        break;
    }
    if (i.icon != null && (g.icon = String(i.icon)), i.widthConfig != null) {
      if (typeof i.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
      g.widthConfig = $root.streamlit.WidthConfig.fromObject(i.widthConfig);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.body = "", E.format = g.enums === String ? "UNUSED" : 0, E.icon = "", E.widthConfig = null), i.body != null && i.hasOwnProperty("body") && (E.body = i.body), i.format != null && i.hasOwnProperty("format") && (E.format = g.enums === String ? $root.Alert.Format[i.format] === void 0 ? i.format : $root.Alert.Format[i.format] : i.format), i.icon != null && i.hasOwnProperty("icon") && (E.icon = i.icon), i.widthConfig != null && i.hasOwnProperty("widthConfig") && (E.widthConfig = $root.streamlit.WidthConfig.toObject(i.widthConfig, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Alert";
  }, o.Format = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "UNUSED"] = 0, g[i[1] = "ERROR"] = 1, g[i[2] = "WARNING"] = 2, g[i[3] = "INFO"] = 3, g[i[4] = "SUCCESS"] = 4, g;
  })(), o;
})();
$root.streamlit = (() => {
  const o = {};
  return o.WidthConfig = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.useStretch = null, i.prototype.useContent = null, i.prototype.pixelWidth = null, i.prototype.remWidth = null;
    let g;
    return Object.defineProperty(i.prototype, "widthSpec", { get: $util.oneOfGetter(g = ["useStretch", "useContent", "pixelWidth", "remWidth"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer.create()), E.useStretch != null && Object.hasOwnProperty.call(E, "useStretch") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(E.useStretch), E.useContent != null && Object.hasOwnProperty.call(E, "useContent") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(E.useContent), E.pixelWidth != null && Object.hasOwnProperty.call(E, "pixelWidth") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(E.pixelWidth), E.remWidth != null && Object.hasOwnProperty.call(E, "remWidth") && e.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(E.remWidth), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.streamlit.WidthConfig();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.useStretch = E.bool();
            break;
          }
          case 2: {
            h.useContent = E.bool();
            break;
          }
          case 3: {
            h.pixelWidth = E.uint32();
            break;
          }
          case 4: {
            h.remWidth = E.float();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.streamlit.WidthConfig) return E;
      let e = new $root.streamlit.WidthConfig();
      return E.useStretch != null && (e.useStretch = !!E.useStretch), E.useContent != null && (e.useContent = !!E.useContent), E.pixelWidth != null && (e.pixelWidth = E.pixelWidth >>> 0), E.remWidth != null && (e.remWidth = Number(E.remWidth)), e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return E.useStretch != null && E.hasOwnProperty("useStretch") && (t.useStretch = E.useStretch, e.oneofs && (t.widthSpec = "useStretch")), E.useContent != null && E.hasOwnProperty("useContent") && (t.useContent = E.useContent, e.oneofs && (t.widthSpec = "useContent")), E.pixelWidth != null && E.hasOwnProperty("pixelWidth") && (t.pixelWidth = E.pixelWidth, e.oneofs && (t.widthSpec = "pixelWidth")), E.remWidth != null && E.hasOwnProperty("remWidth") && (t.remWidth = e.json && !isFinite(E.remWidth) ? String(E.remWidth) : E.remWidth, e.oneofs && (t.widthSpec = "remWidth")), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/streamlit.WidthConfig";
    }, i;
  })(), o.HeightConfig = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.useStretch = null, i.prototype.useContent = null, i.prototype.pixelHeight = null, i.prototype.remHeight = null;
    let g;
    return Object.defineProperty(i.prototype, "heightSpec", { get: $util.oneOfGetter(g = ["useStretch", "useContent", "pixelHeight", "remHeight"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer.create()), E.useStretch != null && Object.hasOwnProperty.call(E, "useStretch") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(E.useStretch), E.useContent != null && Object.hasOwnProperty.call(E, "useContent") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(E.useContent), E.pixelHeight != null && Object.hasOwnProperty.call(E, "pixelHeight") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(E.pixelHeight), E.remHeight != null && Object.hasOwnProperty.call(E, "remHeight") && e.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(E.remHeight), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.streamlit.HeightConfig();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.useStretch = E.bool();
            break;
          }
          case 2: {
            h.useContent = E.bool();
            break;
          }
          case 3: {
            h.pixelHeight = E.uint32();
            break;
          }
          case 4: {
            h.remHeight = E.float();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.streamlit.HeightConfig) return E;
      let e = new $root.streamlit.HeightConfig();
      return E.useStretch != null && (e.useStretch = !!E.useStretch), E.useContent != null && (e.useContent = !!E.useContent), E.pixelHeight != null && (e.pixelHeight = E.pixelHeight >>> 0), E.remHeight != null && (e.remHeight = Number(E.remHeight)), e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return E.useStretch != null && E.hasOwnProperty("useStretch") && (t.useStretch = E.useStretch, e.oneofs && (t.heightSpec = "useStretch")), E.useContent != null && E.hasOwnProperty("useContent") && (t.useContent = E.useContent, e.oneofs && (t.heightSpec = "useContent")), E.pixelHeight != null && E.hasOwnProperty("pixelHeight") && (t.pixelHeight = E.pixelHeight, e.oneofs && (t.heightSpec = "pixelHeight")), E.remHeight != null && E.hasOwnProperty("remHeight") && (t.remHeight = e.json && !isFinite(E.remHeight) ? String(E.remHeight) : E.remHeight, e.oneofs && (t.heightSpec = "remHeight")), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/streamlit.HeightConfig";
    }, i;
  })(), o.GapSize = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "GAP_UNDEFINED"] = 0, g[i[1] = "SMALL"] = 1, g[i[2] = "MEDIUM"] = 2, g[i[3] = "LARGE"] = 3, g[i[4] = "NONE"] = 4, g[i[5] = "XXSMALL"] = 5, g[i[6] = "XSMALL"] = 6, g[i[7] = "XLARGE"] = 7, g[i[8] = "XXLARGE"] = 8, g;
  })(), o.GapConfig = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.gapSize = null;
    let g;
    return Object.defineProperty(i.prototype, "gapSpec", { get: $util.oneOfGetter(g = ["gapSize"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer.create()), E.gapSize != null && Object.hasOwnProperty.call(E, "gapSize") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(E.gapSize), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.streamlit.GapConfig();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        d >>> 3 === 1 ? h.gapSize = E.int32() : E.skipType(d & 7);
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.streamlit.GapConfig) return E;
      let e = new $root.streamlit.GapConfig();
      switch (E.gapSize) {
        default:
          if (typeof E.gapSize == "number") {
            e.gapSize = E.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          e.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          e.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          e.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          e.gapSize = 3;
          break;
        case "NONE":
        case 4:
          e.gapSize = 4;
          break;
        case "XXSMALL":
        case 5:
          e.gapSize = 5;
          break;
        case "XSMALL":
        case 6:
          e.gapSize = 6;
          break;
        case "XLARGE":
        case 7:
          e.gapSize = 7;
          break;
        case "XXLARGE":
        case 8:
          e.gapSize = 8;
          break;
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return E.gapSize != null && E.hasOwnProperty("gapSize") && (t.gapSize = e.enums === String ? $root.streamlit.GapSize[E.gapSize] === void 0 ? E.gapSize : $root.streamlit.GapSize[E.gapSize] : E.gapSize, e.oneofs && (t.gapSpec = "gapSize")), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/streamlit.GapConfig";
    }, i;
  })(), o.ButtonLikeIconPosition = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "LEFT"] = 0, g[i[1] = "RIGHT"] = 1, g;
  })(), o.TextAlignmentConfig = (function() {
    function i(g) {
      if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.alignment = 0, i.create = function(g) {
      return new i(g);
    }, i.encode = function(g, E) {
      return E || (E = $Writer.create()), g.alignment != null && Object.hasOwnProperty.call(g, "alignment") && E.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(g.alignment), E;
    }, i.decode = function(g, E, e) {
      g instanceof $Reader || (g = $Reader.create(g));
      let t = E === void 0 ? g.len : g.pos + E, n = new $root.streamlit.TextAlignmentConfig();
      for (; g.pos < t; ) {
        let h = g.uint32();
        if (h === e) break;
        h >>> 3 === 1 ? n.alignment = g.int32() : g.skipType(h & 7);
      }
      return n;
    }, i.fromObject = function(g) {
      if (g instanceof $root.streamlit.TextAlignmentConfig) return g;
      let E = new $root.streamlit.TextAlignmentConfig();
      switch (g.alignment) {
        default:
          if (typeof g.alignment == "number") {
            E.alignment = g.alignment;
            break;
          }
          break;
        case "UNSPECIFIED":
        case 0:
          E.alignment = 0;
          break;
        case "LEFT":
        case 1:
          E.alignment = 1;
          break;
        case "CENTER":
        case 2:
          E.alignment = 2;
          break;
        case "RIGHT":
        case 3:
          E.alignment = 3;
          break;
        case "JUSTIFY":
        case 4:
          E.alignment = 4;
          break;
      }
      return E;
    }, i.toObject = function(g, E) {
      E || (E = {});
      let e = {};
      return E.defaults && (e.alignment = E.enums === String ? "UNSPECIFIED" : 0), g.alignment != null && g.hasOwnProperty("alignment") && (e.alignment = E.enums === String ? $root.streamlit.TextAlignmentConfig.Alignment[g.alignment] === void 0 ? g.alignment : $root.streamlit.TextAlignmentConfig.Alignment[g.alignment] : g.alignment), e;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/streamlit.TextAlignmentConfig";
    }, i.Alignment = (function() {
      const g = {}, E = Object.create(g);
      return E[g[0] = "UNSPECIFIED"] = 0, E[g[1] = "LEFT"] = 1, E[g[2] = "CENTER"] = 2, E[g[3] = "RIGHT"] = 3, E[g[4] = "JUSTIFY"] = 4, E;
    })(), i;
  })(), o;
})();
$root.AppPage = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.pageScriptHash = "", o.prototype.pageName = "", o.prototype.icon = "", o.prototype.isDefault = !1, o.prototype.sectionHeader = "", o.prototype.urlPathname = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.pageScriptHash != null && Object.hasOwnProperty.call(i, "pageScriptHash") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.pageScriptHash), i.pageName != null && Object.hasOwnProperty.call(i, "pageName") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.pageName), i.icon != null && Object.hasOwnProperty.call(i, "icon") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.icon), i.isDefault != null && Object.hasOwnProperty.call(i, "isDefault") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(i.isDefault), i.sectionHeader != null && Object.hasOwnProperty.call(i, "sectionHeader") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.sectionHeader), i.urlPathname != null && Object.hasOwnProperty.call(i, "urlPathname") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.urlPathname), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.AppPage();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.pageScriptHash = i.string();
          break;
        }
        case 2: {
          t.pageName = i.string();
          break;
        }
        case 3: {
          t.icon = i.string();
          break;
        }
        case 4: {
          t.isDefault = i.bool();
          break;
        }
        case 5: {
          t.sectionHeader = i.string();
          break;
        }
        case 6: {
          t.urlPathname = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.AppPage) return i;
    let g = new $root.AppPage();
    return i.pageScriptHash != null && (g.pageScriptHash = String(i.pageScriptHash)), i.pageName != null && (g.pageName = String(i.pageName)), i.icon != null && (g.icon = String(i.icon)), i.isDefault != null && (g.isDefault = !!i.isDefault), i.sectionHeader != null && (g.sectionHeader = String(i.sectionHeader)), i.urlPathname != null && (g.urlPathname = String(i.urlPathname)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.pageScriptHash = "", E.pageName = "", E.icon = "", E.isDefault = !1, E.sectionHeader = "", E.urlPathname = ""), i.pageScriptHash != null && i.hasOwnProperty("pageScriptHash") && (E.pageScriptHash = i.pageScriptHash), i.pageName != null && i.hasOwnProperty("pageName") && (E.pageName = i.pageName), i.icon != null && i.hasOwnProperty("icon") && (E.icon = i.icon), i.isDefault != null && i.hasOwnProperty("isDefault") && (E.isDefault = i.isDefault), i.sectionHeader != null && i.hasOwnProperty("sectionHeader") && (E.sectionHeader = i.sectionHeader), i.urlPathname != null && i.hasOwnProperty("urlPathname") && (E.urlPathname = i.urlPathname), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/AppPage";
  }, o;
})();
$root.Arrow = (() => {
  function o(g) {
    if (this.columnOrder = [], this.selectionMode = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.data = $util.newBuffer([]), o.prototype.styler = null, o.prototype.width = 0, o.prototype.height = 0, o.prototype.useContainerWidth = !1, o.prototype.id = "", o.prototype.columns = "", o.prototype.editingMode = 0, o.prototype.disabled = !1, o.prototype.formId = "", o.prototype.columnOrder = $util.emptyArray, o.prototype.selectionMode = $util.emptyArray, o.prototype.rowHeight = null, o.prototype.borderMode = 0, o.prototype.placeholder = null;
  let i;
  return Object.defineProperty(o.prototype, "_rowHeight", { get: $util.oneOfGetter(i = ["rowHeight"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_placeholder", { get: $util.oneOfGetter(i = ["placeholder"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(g.data), g.styler != null && Object.hasOwnProperty.call(g, "styler") && $root.Styler.encode(g.styler, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.width != null && Object.hasOwnProperty.call(g, "width") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(g.width), g.height != null && Object.hasOwnProperty.call(g, "height") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(g.height), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.id), g.columns != null && Object.hasOwnProperty.call(g, "columns") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.columns), g.editingMode != null && Object.hasOwnProperty.call(g, "editingMode") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.editingMode), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.formId), g.columnOrder != null && g.columnOrder.length) for (let e = 0; e < g.columnOrder.length; ++e) E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.columnOrder[e]);
    if (g.selectionMode != null && g.selectionMode.length) {
      E.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork();
      for (let e = 0; e < g.selectionMode.length; ++e) E.int32(g.selectionMode[e]);
      E.ldelim();
    }
    return g.rowHeight != null && Object.hasOwnProperty.call(g, "rowHeight") && E.uint32(
      /* id 13, wireType 0 =*/
      104
    ).uint32(g.rowHeight), g.borderMode != null && Object.hasOwnProperty.call(g, "borderMode") && E.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(g.borderMode), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && E.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(g.placeholder), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Arrow();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = g.bytes();
          break;
        }
        case 2: {
          n.styler = $root.Styler.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.width = g.uint32();
          break;
        }
        case 4: {
          n.height = g.uint32();
          break;
        }
        case 5: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 6: {
          n.id = g.string();
          break;
        }
        case 7: {
          n.columns = g.string();
          break;
        }
        case 8: {
          n.editingMode = g.int32();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.formId = g.string();
          break;
        }
        case 11: {
          n.columnOrder && n.columnOrder.length || (n.columnOrder = []), n.columnOrder.push(g.string());
          break;
        }
        case 12: {
          if (n.selectionMode && n.selectionMode.length || (n.selectionMode = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.selectionMode.push(g.int32());
          } else n.selectionMode.push(g.int32());
          break;
        }
        case 13: {
          n.rowHeight = g.uint32();
          break;
        }
        case 14: {
          n.borderMode = g.int32();
          break;
        }
        case 15: {
          n.placeholder = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Arrow) return g;
    let E = new $root.Arrow();
    if (g.data != null && (typeof g.data == "string" ? $util.base64.decode(g.data, E.data = $util.newBuffer($util.base64.length(g.data)), 0) : g.data.length >= 0 && (E.data = g.data)), g.styler != null) {
      if (typeof g.styler != "object") throw TypeError(".Arrow.styler: object expected");
      E.styler = $root.Styler.fromObject(g.styler);
    }
    switch (g.width != null && (E.width = g.width >>> 0), g.height != null && (E.height = g.height >>> 0), g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.id != null && (E.id = String(g.id)), g.columns != null && (E.columns = String(g.columns)), g.editingMode) {
      default:
        if (typeof g.editingMode == "number") {
          E.editingMode = g.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        E.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        E.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        E.editingMode = 2;
        break;
      case "ADD_ONLY":
      case 3:
        E.editingMode = 3;
        break;
      case "DELETE_ONLY":
      case 4:
        E.editingMode = 4;
        break;
    }
    if (g.disabled != null && (E.disabled = !!g.disabled), g.formId != null && (E.formId = String(g.formId)), g.columnOrder) {
      if (!Array.isArray(g.columnOrder)) throw TypeError(".Arrow.columnOrder: array expected");
      E.columnOrder = [];
      for (let e = 0; e < g.columnOrder.length; ++e) E.columnOrder[e] = String(g.columnOrder[e]);
    }
    if (g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".Arrow.selectionMode: array expected");
      E.selectionMode = [];
      for (let e = 0; e < g.selectionMode.length; ++e) switch (g.selectionMode[e]) {
        default:
          if (typeof g.selectionMode[e] == "number") {
            E.selectionMode[e] = g.selectionMode[e];
            break;
          }
        case "SINGLE_ROW":
        case 0:
          E.selectionMode[e] = 0;
          break;
        case "MULTI_ROW":
        case 1:
          E.selectionMode[e] = 1;
          break;
        case "SINGLE_COLUMN":
        case 2:
          E.selectionMode[e] = 2;
          break;
        case "MULTI_COLUMN":
        case 3:
          E.selectionMode[e] = 3;
          break;
        case "SINGLE_CELL":
        case 4:
          E.selectionMode[e] = 4;
          break;
        case "MULTI_CELL":
        case 5:
          E.selectionMode[e] = 5;
          break;
      }
    }
    switch (g.rowHeight != null && (E.rowHeight = g.rowHeight >>> 0), g.borderMode) {
      default:
        if (typeof g.borderMode == "number") {
          E.borderMode = g.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        E.borderMode = 0;
        break;
      case "NONE":
      case 1:
        E.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        E.borderMode = 2;
        break;
    }
    return g.placeholder != null && (E.placeholder = String(g.placeholder)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.columnOrder = [], e.selectionMode = []), E.defaults && (E.bytes === String ? e.data = "" : (e.data = [], E.bytes !== Array && (e.data = $util.newBuffer(e.data))), e.styler = null, e.width = 0, e.height = 0, e.useContainerWidth = !1, e.id = "", e.columns = "", e.editingMode = E.enums === String ? "READ_ONLY" : 0, e.disabled = !1, e.formId = "", e.borderMode = E.enums === String ? "ALL" : 0), g.data != null && g.hasOwnProperty("data") && (e.data = E.bytes === String ? $util.base64.encode(g.data, 0, g.data.length) : E.bytes === Array ? Array.prototype.slice.call(g.data) : g.data), g.styler != null && g.hasOwnProperty("styler") && (e.styler = $root.Styler.toObject(g.styler, E)), g.width != null && g.hasOwnProperty("width") && (e.width = g.width), g.height != null && g.hasOwnProperty("height") && (e.height = g.height), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.columns != null && g.hasOwnProperty("columns") && (e.columns = g.columns), g.editingMode != null && g.hasOwnProperty("editingMode") && (e.editingMode = E.enums === String ? $root.Arrow.EditingMode[g.editingMode] === void 0 ? g.editingMode : $root.Arrow.EditingMode[g.editingMode] : g.editingMode), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.columnOrder && g.columnOrder.length) {
      e.columnOrder = [];
      for (let t = 0; t < g.columnOrder.length; ++t) e.columnOrder[t] = g.columnOrder[t];
    }
    if (g.selectionMode && g.selectionMode.length) {
      e.selectionMode = [];
      for (let t = 0; t < g.selectionMode.length; ++t) e.selectionMode[t] = E.enums === String ? $root.Arrow.SelectionMode[g.selectionMode[t]] === void 0 ? g.selectionMode[t] : $root.Arrow.SelectionMode[g.selectionMode[t]] : g.selectionMode[t];
    }
    return g.rowHeight != null && g.hasOwnProperty("rowHeight") && (e.rowHeight = g.rowHeight, E.oneofs && (e._rowHeight = "rowHeight")), g.borderMode != null && g.hasOwnProperty("borderMode") && (e.borderMode = E.enums === String ? $root.Arrow.BorderMode[g.borderMode] === void 0 ? g.borderMode : $root.Arrow.BorderMode[g.borderMode] : g.borderMode), g.placeholder != null && g.hasOwnProperty("placeholder") && (e.placeholder = g.placeholder, E.oneofs && (e._placeholder = "placeholder")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Arrow";
  }, o.EditingMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "READ_ONLY"] = 0, E[g[1] = "FIXED"] = 1, E[g[2] = "DYNAMIC"] = 2, E[g[3] = "ADD_ONLY"] = 3, E[g[4] = "DELETE_ONLY"] = 4, E;
  })(), o.SelectionMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "SINGLE_ROW"] = 0, E[g[1] = "MULTI_ROW"] = 1, E[g[2] = "SINGLE_COLUMN"] = 2, E[g[3] = "MULTI_COLUMN"] = 3, E[g[4] = "SINGLE_CELL"] = 4, E[g[5] = "MULTI_CELL"] = 5, E;
  })(), o.BorderMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "ALL"] = 0, E[g[1] = "NONE"] = 1, E[g[2] = "HORIZONTAL"] = 2, E;
  })(), o;
})();
$root.Styler = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.uuid = "", o.prototype.caption = "", o.prototype.styles = "", o.prototype.displayValues = $util.newBuffer([]), o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.uuid != null && Object.hasOwnProperty.call(i, "uuid") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.uuid), i.caption != null && Object.hasOwnProperty.call(i, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.caption), i.styles != null && Object.hasOwnProperty.call(i, "styles") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.styles), i.displayValues != null && Object.hasOwnProperty.call(i, "displayValues") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(i.displayValues), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Styler();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.uuid = i.string();
          break;
        }
        case 2: {
          t.caption = i.string();
          break;
        }
        case 3: {
          t.styles = i.string();
          break;
        }
        case 4: {
          t.displayValues = i.bytes();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Styler) return i;
    let g = new $root.Styler();
    return i.uuid != null && (g.uuid = String(i.uuid)), i.caption != null && (g.caption = String(i.caption)), i.styles != null && (g.styles = String(i.styles)), i.displayValues != null && (typeof i.displayValues == "string" ? $util.base64.decode(i.displayValues, g.displayValues = $util.newBuffer($util.base64.length(i.displayValues)), 0) : i.displayValues.length >= 0 && (g.displayValues = i.displayValues)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.uuid = "", E.caption = "", E.styles = "", g.bytes === String ? E.displayValues = "" : (E.displayValues = [], g.bytes !== Array && (E.displayValues = $util.newBuffer(E.displayValues)))), i.uuid != null && i.hasOwnProperty("uuid") && (E.uuid = i.uuid), i.caption != null && i.hasOwnProperty("caption") && (E.caption = i.caption), i.styles != null && i.hasOwnProperty("styles") && (E.styles = i.styles), i.displayValues != null && i.hasOwnProperty("displayValues") && (E.displayValues = g.bytes === String ? $util.base64.encode(i.displayValues, 0, i.displayValues.length) : g.bytes === Array ? Array.prototype.slice.call(i.displayValues) : i.displayValues), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Styler";
  }, o;
})();
$root.ArrowData = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util.newBuffer([]), o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(i.data), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ArrowData();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.data = i.bytes() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ArrowData) return i;
    let g = new $root.ArrowData();
    return i.data != null && (typeof i.data == "string" ? $util.base64.decode(i.data, g.data = $util.newBuffer($util.base64.length(i.data)), 0) : i.data.length >= 0 && (g.data = i.data)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (g.bytes === String ? E.data = "" : (E.data = [], g.bytes !== Array && (E.data = $util.newBuffer(E.data)))), i.data != null && i.hasOwnProperty("data") && (E.data = g.bytes === String ? $util.base64.encode(i.data, 0, i.data.length) : g.bytes === Array ? Array.prototype.slice.call(i.data) : i.data), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ArrowData";
  }, o;
})();
$root.ArrowNamedDataSet = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.name = "", o.prototype.hasName = !1, o.prototype.data = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.name != null && Object.hasOwnProperty.call(i, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.name), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.Arrow.encode(i.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), i.hasName != null && Object.hasOwnProperty.call(i, "hasName") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.hasName), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ArrowNamedDataSet();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.name = i.string();
          break;
        }
        case 3: {
          t.hasName = i.bool();
          break;
        }
        case 2: {
          t.data = $root.Arrow.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ArrowNamedDataSet) return i;
    let g = new $root.ArrowNamedDataSet();
    if (i.name != null && (g.name = String(i.name)), i.hasName != null && (g.hasName = !!i.hasName), i.data != null) {
      if (typeof i.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
      g.data = $root.Arrow.fromObject(i.data);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.name = "", E.data = null, E.hasName = !1), i.name != null && i.hasOwnProperty("name") && (E.name = i.name), i.data != null && i.hasOwnProperty("data") && (E.data = $root.Arrow.toObject(i.data, g)), i.hasName != null && i.hasOwnProperty("hasName") && (E.hasName = i.hasName), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ArrowNamedDataSet";
  }, o;
})();
$root.ArrowVegaLiteChart = (() => {
  function o(i) {
    if (this.datasets = [], this.selectionMode = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.spec = "", o.prototype.data = null, o.prototype.datasets = $util.emptyArray, o.prototype.useContainerWidth = !1, o.prototype.theme = "", o.prototype.id = "", o.prototype.selectionMode = $util.emptyArray, o.prototype.formId = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.spec != null && Object.hasOwnProperty.call(i, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.spec), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.Arrow.encode(i.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), i.datasets != null && i.datasets.length) for (let E = 0; E < i.datasets.length; ++E) $root.ArrowNamedDataSet.encode(i.datasets[E], g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    if (i.useContainerWidth != null && Object.hasOwnProperty.call(i, "useContainerWidth") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(i.useContainerWidth), i.theme != null && Object.hasOwnProperty.call(i, "theme") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.theme), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.id), i.selectionMode != null && i.selectionMode.length) for (let E = 0; E < i.selectionMode.length; ++E) g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(i.selectionMode[E]);
    return i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(i.formId), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ArrowVegaLiteChart();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.spec = i.string();
          break;
        }
        case 2: {
          t.data = $root.Arrow.decode(i, i.uint32());
          break;
        }
        case 4: {
          t.datasets && t.datasets.length || (t.datasets = []), t.datasets.push($root.ArrowNamedDataSet.decode(i, i.uint32()));
          break;
        }
        case 5: {
          t.useContainerWidth = i.bool();
          break;
        }
        case 6: {
          t.theme = i.string();
          break;
        }
        case 7: {
          t.id = i.string();
          break;
        }
        case 8: {
          t.selectionMode && t.selectionMode.length || (t.selectionMode = []), t.selectionMode.push(i.string());
          break;
        }
        case 9: {
          t.formId = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ArrowVegaLiteChart) return i;
    let g = new $root.ArrowVegaLiteChart();
    if (i.spec != null && (g.spec = String(i.spec)), i.data != null) {
      if (typeof i.data != "object") throw TypeError(".ArrowVegaLiteChart.data: object expected");
      g.data = $root.Arrow.fromObject(i.data);
    }
    if (i.datasets) {
      if (!Array.isArray(i.datasets)) throw TypeError(".ArrowVegaLiteChart.datasets: array expected");
      g.datasets = [];
      for (let E = 0; E < i.datasets.length; ++E) {
        if (typeof i.datasets[E] != "object") throw TypeError(".ArrowVegaLiteChart.datasets: object expected");
        g.datasets[E] = $root.ArrowNamedDataSet.fromObject(i.datasets[E]);
      }
    }
    if (i.useContainerWidth != null && (g.useContainerWidth = !!i.useContainerWidth), i.theme != null && (g.theme = String(i.theme)), i.id != null && (g.id = String(i.id)), i.selectionMode) {
      if (!Array.isArray(i.selectionMode)) throw TypeError(".ArrowVegaLiteChart.selectionMode: array expected");
      g.selectionMode = [];
      for (let E = 0; E < i.selectionMode.length; ++E) g.selectionMode[E] = String(i.selectionMode[E]);
    }
    return i.formId != null && (g.formId = String(i.formId)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.datasets = [], E.selectionMode = []), g.defaults && (E.spec = "", E.data = null, E.useContainerWidth = !1, E.theme = "", E.id = "", E.formId = ""), i.spec != null && i.hasOwnProperty("spec") && (E.spec = i.spec), i.data != null && i.hasOwnProperty("data") && (E.data = $root.Arrow.toObject(i.data, g)), i.datasets && i.datasets.length) {
      E.datasets = [];
      for (let e = 0; e < i.datasets.length; ++e) E.datasets[e] = $root.ArrowNamedDataSet.toObject(i.datasets[e], g);
    }
    if (i.useContainerWidth != null && i.hasOwnProperty("useContainerWidth") && (E.useContainerWidth = i.useContainerWidth), i.theme != null && i.hasOwnProperty("theme") && (E.theme = i.theme), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.selectionMode && i.selectionMode.length) {
      E.selectionMode = [];
      for (let e = 0; e < i.selectionMode.length; ++e) E.selectionMode[e] = i.selectionMode[e];
    }
    return i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ArrowVegaLiteChart";
  }, o;
})();
$root.Audio = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.url = "", o.prototype.startTime = 0, o.prototype.endTime = 0, o.prototype.loop = !1, o.prototype.autoplay = !1, o.prototype.id = "", o.prototype.widthConfig = null;
  let i;
  return Object.defineProperty(o.prototype, "_widthConfig", { get: $util.oneOfGetter(i = ["widthConfig"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.startTime != null && Object.hasOwnProperty.call(g, "startTime") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.startTime), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.url), g.endTime != null && Object.hasOwnProperty.call(g, "endTime") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.endTime), g.loop != null && Object.hasOwnProperty.call(g, "loop") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.loop), g.autoplay != null && Object.hasOwnProperty.call(g, "autoplay") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.autoplay), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.id), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root.streamlit.WidthConfig.encode(g.widthConfig, E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Audio();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 5: {
          n.url = g.string();
          break;
        }
        case 3: {
          n.startTime = g.int32();
          break;
        }
        case 6: {
          n.endTime = g.int32();
          break;
        }
        case 7: {
          n.loop = g.bool();
          break;
        }
        case 8: {
          n.autoplay = g.bool();
          break;
        }
        case 9: {
          n.id = g.string();
          break;
        }
        case 10: {
          n.widthConfig = $root.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Audio) return g;
    let E = new $root.Audio();
    if (g.url != null && (E.url = String(g.url)), g.startTime != null && (E.startTime = g.startTime | 0), g.endTime != null && (E.endTime = g.endTime | 0), g.loop != null && (E.loop = !!g.loop), g.autoplay != null && (E.autoplay = !!g.autoplay), g.id != null && (E.id = String(g.id)), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
      E.widthConfig = $root.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.startTime = 0, e.url = "", e.endTime = 0, e.loop = !1, e.autoplay = !1, e.id = ""), g.startTime != null && g.hasOwnProperty("startTime") && (e.startTime = g.startTime), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), g.endTime != null && g.hasOwnProperty("endTime") && (e.endTime = g.endTime), g.loop != null && g.hasOwnProperty("loop") && (e.loop = g.loop), g.autoplay != null && g.hasOwnProperty("autoplay") && (e.autoplay = g.autoplay), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(g.widthConfig, E), E.oneofs && (e._widthConfig = "widthConfig")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Audio";
  }, o;
})();
$root.AudioInput = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.sampleRate = null;
  let i;
  return Object.defineProperty(o.prototype, "_sampleRate", { get: $util.oneOfGetter(i = ["sampleRate"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.formId), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.sampleRate != null && Object.hasOwnProperty.call(g, "sampleRate") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.sampleRate), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.AudioInput();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.help = g.string();
          break;
        }
        case 4: {
          n.formId = g.string();
          break;
        }
        case 5: {
          n.disabled = g.bool();
          break;
        }
        case 6: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.sampleRate = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.AudioInput) return g;
    let E = new $root.AudioInput();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.sampleRate != null && (E.sampleRate = g.sampleRate | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.disabled = !1, e.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.sampleRate != null && g.hasOwnProperty("sampleRate") && (e.sampleRate = g.sampleRate, E.oneofs && (e._sampleRate = "sampleRate")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AudioInput";
  }, o;
})();
$root.LabelVisibilityMessage = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.value = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.value != null && Object.hasOwnProperty.call(i, "value") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(i.value), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.LabelVisibilityMessage();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.value = i.int32() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.LabelVisibilityMessage) return i;
    let g = new $root.LabelVisibilityMessage();
    switch (i.value) {
      default:
        if (typeof i.value == "number") {
          g.value = i.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        g.value = 0;
        break;
      case "HIDDEN":
      case 1:
        g.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        g.value = 2;
        break;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.value = g.enums === String ? "VISIBLE" : 0), i.value != null && i.hasOwnProperty("value") && (E.value = g.enums === String ? $root.LabelVisibilityMessage.LabelVisibilityOptions[i.value] === void 0 ? i.value : $root.LabelVisibilityMessage.LabelVisibilityOptions[i.value] : i.value), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/LabelVisibilityMessage";
  }, o.LabelVisibilityOptions = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "VISIBLE"] = 0, g[i[1] = "HIDDEN"] = 1, g[i[2] = "COLLAPSED"] = 2, g;
  })(), o;
})();
$root.AuthRedirect = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.url = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.url != null && Object.hasOwnProperty.call(i, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.url), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.AuthRedirect();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.url = i.string() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.AuthRedirect) return i;
    let g = new $root.AuthRedirect();
    return i.url != null && (g.url = String(i.url)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.url = ""), i.url != null && i.hasOwnProperty("url") && (E.url = i.url), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/AuthRedirect";
  }, o;
})();
$root.AutoRerun = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.interval = 0, o.prototype.fragmentId = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.interval != null && Object.hasOwnProperty.call(i, "interval") && g.uint32(
      /* id 1, wireType 5 =*/
      13
    ).float(i.interval), i.fragmentId != null && Object.hasOwnProperty.call(i, "fragmentId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.fragmentId), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.AutoRerun();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.interval = i.float();
          break;
        }
        case 2: {
          t.fragmentId = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.AutoRerun) return i;
    let g = new $root.AutoRerun();
    return i.interval != null && (g.interval = Number(i.interval)), i.fragmentId != null && (g.fragmentId = String(i.fragmentId)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.interval = 0, E.fragmentId = ""), i.interval != null && i.hasOwnProperty("interval") && (E.interval = g.json && !isFinite(i.interval) ? String(i.interval) : i.interval), i.fragmentId != null && i.hasOwnProperty("fragmentId") && (E.fragmentId = i.fragmentId), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/AutoRerun";
  }, o;
})();
$root.BackMsg = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.clearCache = null, o.prototype.setRunOnSave = null, o.prototype.stopScript = null, o.prototype.rerunScript = null, o.prototype.loadGitInfo = null, o.prototype.debugDisconnectWebsocket = null, o.prototype.debugShutdownRuntime = null, o.prototype.fileUrlsRequest = null, o.prototype.appHeartbeat = null, o.prototype.deferredFileRequest = null, o.prototype.debugLastBackmsgId = "";
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat", "deferredFileRequest"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.clearCache != null && Object.hasOwnProperty.call(g, "clearCache") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.clearCache), g.setRunOnSave != null && Object.hasOwnProperty.call(g, "setRunOnSave") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.setRunOnSave), g.stopScript != null && Object.hasOwnProperty.call(g, "stopScript") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.stopScript), g.rerunScript != null && Object.hasOwnProperty.call(g, "rerunScript") && $root.ClientState.encode(g.rerunScript, E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.loadGitInfo != null && Object.hasOwnProperty.call(g, "loadGitInfo") && E.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.loadGitInfo), g.debugLastBackmsgId != null && Object.hasOwnProperty.call(g, "debugLastBackmsgId") && E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.debugLastBackmsgId), g.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(g, "debugDisconnectWebsocket") && E.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(g.debugDisconnectWebsocket), g.debugShutdownRuntime != null && Object.hasOwnProperty.call(g, "debugShutdownRuntime") && E.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(g.debugShutdownRuntime), g.fileUrlsRequest != null && Object.hasOwnProperty.call(g, "fileUrlsRequest") && $root.FileURLsRequest.encode(g.fileUrlsRequest, E.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.appHeartbeat != null && Object.hasOwnProperty.call(g, "appHeartbeat") && E.uint32(
      /* id 17, wireType 0 =*/
      136
    ).bool(g.appHeartbeat), g.deferredFileRequest != null && Object.hasOwnProperty.call(g, "deferredFileRequest") && $root.DeferredFileRequest.encode(g.deferredFileRequest, E.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.BackMsg();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 5: {
          n.clearCache = g.bool();
          break;
        }
        case 6: {
          n.setRunOnSave = g.bool();
          break;
        }
        case 7: {
          n.stopScript = g.bool();
          break;
        }
        case 11: {
          n.rerunScript = $root.ClientState.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.loadGitInfo = g.bool();
          break;
        }
        case 14: {
          n.debugDisconnectWebsocket = g.bool();
          break;
        }
        case 15: {
          n.debugShutdownRuntime = g.bool();
          break;
        }
        case 16: {
          n.fileUrlsRequest = $root.FileURLsRequest.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.appHeartbeat = g.bool();
          break;
        }
        case 18: {
          n.deferredFileRequest = $root.DeferredFileRequest.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.debugLastBackmsgId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.BackMsg) return g;
    let E = new $root.BackMsg();
    if (g.clearCache != null && (E.clearCache = !!g.clearCache), g.setRunOnSave != null && (E.setRunOnSave = !!g.setRunOnSave), g.stopScript != null && (E.stopScript = !!g.stopScript), g.rerunScript != null) {
      if (typeof g.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
      E.rerunScript = $root.ClientState.fromObject(g.rerunScript);
    }
    if (g.loadGitInfo != null && (E.loadGitInfo = !!g.loadGitInfo), g.debugDisconnectWebsocket != null && (E.debugDisconnectWebsocket = !!g.debugDisconnectWebsocket), g.debugShutdownRuntime != null && (E.debugShutdownRuntime = !!g.debugShutdownRuntime), g.fileUrlsRequest != null) {
      if (typeof g.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      E.fileUrlsRequest = $root.FileURLsRequest.fromObject(g.fileUrlsRequest);
    }
    if (g.appHeartbeat != null && (E.appHeartbeat = !!g.appHeartbeat), g.deferredFileRequest != null) {
      if (typeof g.deferredFileRequest != "object") throw TypeError(".BackMsg.deferredFileRequest: object expected");
      E.deferredFileRequest = $root.DeferredFileRequest.fromObject(g.deferredFileRequest);
    }
    return g.debugLastBackmsgId != null && (E.debugLastBackmsgId = String(g.debugLastBackmsgId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.debugLastBackmsgId = ""), g.clearCache != null && g.hasOwnProperty("clearCache") && (e.clearCache = g.clearCache, E.oneofs && (e.type = "clearCache")), g.setRunOnSave != null && g.hasOwnProperty("setRunOnSave") && (e.setRunOnSave = g.setRunOnSave, E.oneofs && (e.type = "setRunOnSave")), g.stopScript != null && g.hasOwnProperty("stopScript") && (e.stopScript = g.stopScript, E.oneofs && (e.type = "stopScript")), g.rerunScript != null && g.hasOwnProperty("rerunScript") && (e.rerunScript = $root.ClientState.toObject(g.rerunScript, E), E.oneofs && (e.type = "rerunScript")), g.loadGitInfo != null && g.hasOwnProperty("loadGitInfo") && (e.loadGitInfo = g.loadGitInfo, E.oneofs && (e.type = "loadGitInfo")), g.debugLastBackmsgId != null && g.hasOwnProperty("debugLastBackmsgId") && (e.debugLastBackmsgId = g.debugLastBackmsgId), g.debugDisconnectWebsocket != null && g.hasOwnProperty("debugDisconnectWebsocket") && (e.debugDisconnectWebsocket = g.debugDisconnectWebsocket, E.oneofs && (e.type = "debugDisconnectWebsocket")), g.debugShutdownRuntime != null && g.hasOwnProperty("debugShutdownRuntime") && (e.debugShutdownRuntime = g.debugShutdownRuntime, E.oneofs && (e.type = "debugShutdownRuntime")), g.fileUrlsRequest != null && g.hasOwnProperty("fileUrlsRequest") && (e.fileUrlsRequest = $root.FileURLsRequest.toObject(g.fileUrlsRequest, E), E.oneofs && (e.type = "fileUrlsRequest")), g.appHeartbeat != null && g.hasOwnProperty("appHeartbeat") && (e.appHeartbeat = g.appHeartbeat, E.oneofs && (e.type = "appHeartbeat")), g.deferredFileRequest != null && g.hasOwnProperty("deferredFileRequest") && (e.deferredFileRequest = $root.DeferredFileRequest.toObject(g.deferredFileRequest, E), E.oneofs && (e.type = "deferredFileRequest")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BackMsg";
  }, o;
})();
$root.DeferredFileRequest = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.fileId = "", o.prototype.sessionId = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.fileId != null && Object.hasOwnProperty.call(i, "fileId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.fileId), i.sessionId != null && Object.hasOwnProperty.call(i, "sessionId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.sessionId), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DeferredFileRequest();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.fileId = i.string();
          break;
        }
        case 2: {
          t.sessionId = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DeferredFileRequest) return i;
    let g = new $root.DeferredFileRequest();
    return i.fileId != null && (g.fileId = String(i.fileId)), i.sessionId != null && (g.sessionId = String(i.sessionId)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.fileId = "", E.sessionId = ""), i.fileId != null && i.hasOwnProperty("fileId") && (E.fileId = i.fileId), i.sessionId != null && i.hasOwnProperty("sessionId") && (E.sessionId = i.sessionId), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DeferredFileRequest";
  }, o;
})();
$root.ContextInfo = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.timezone = null, o.prototype.timezoneOffset = null, o.prototype.locale = null, o.prototype.url = null, o.prototype.isEmbedded = null, o.prototype.colorScheme = null;
  let i;
  return Object.defineProperty(o.prototype, "_timezone", { get: $util.oneOfGetter(i = ["timezone"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_timezoneOffset", { get: $util.oneOfGetter(i = ["timezoneOffset"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_locale", { get: $util.oneOfGetter(i = ["locale"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_url", { get: $util.oneOfGetter(i = ["url"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_isEmbedded", { get: $util.oneOfGetter(i = ["isEmbedded"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_colorScheme", { get: $util.oneOfGetter(i = ["colorScheme"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.timezone != null && Object.hasOwnProperty.call(g, "timezone") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.timezone), g.timezoneOffset != null && Object.hasOwnProperty.call(g, "timezoneOffset") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.timezoneOffset), g.locale != null && Object.hasOwnProperty.call(g, "locale") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.locale), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.url), g.isEmbedded != null && Object.hasOwnProperty.call(g, "isEmbedded") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.isEmbedded), g.colorScheme != null && Object.hasOwnProperty.call(g, "colorScheme") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.colorScheme), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.ContextInfo();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.timezone = g.string();
          break;
        }
        case 2: {
          n.timezoneOffset = g.int32();
          break;
        }
        case 3: {
          n.locale = g.string();
          break;
        }
        case 4: {
          n.url = g.string();
          break;
        }
        case 5: {
          n.isEmbedded = g.bool();
          break;
        }
        case 6: {
          n.colorScheme = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.ContextInfo) return g;
    let E = new $root.ContextInfo();
    return g.timezone != null && (E.timezone = String(g.timezone)), g.timezoneOffset != null && (E.timezoneOffset = g.timezoneOffset | 0), g.locale != null && (E.locale = String(g.locale)), g.url != null && (E.url = String(g.url)), g.isEmbedded != null && (E.isEmbedded = !!g.isEmbedded), g.colorScheme != null && (E.colorScheme = String(g.colorScheme)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return g.timezone != null && g.hasOwnProperty("timezone") && (e.timezone = g.timezone, E.oneofs && (e._timezone = "timezone")), g.timezoneOffset != null && g.hasOwnProperty("timezoneOffset") && (e.timezoneOffset = g.timezoneOffset, E.oneofs && (e._timezoneOffset = "timezoneOffset")), g.locale != null && g.hasOwnProperty("locale") && (e.locale = g.locale, E.oneofs && (e._locale = "locale")), g.url != null && g.hasOwnProperty("url") && (e.url = g.url, E.oneofs && (e._url = "url")), g.isEmbedded != null && g.hasOwnProperty("isEmbedded") && (e.isEmbedded = g.isEmbedded, E.oneofs && (e._isEmbedded = "isEmbedded")), g.colorScheme != null && g.hasOwnProperty("colorScheme") && (e.colorScheme = g.colorScheme, E.oneofs && (e._colorScheme = "colorScheme")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ContextInfo";
  }, o;
})();
$root.ClientState = (() => {
  function o(i) {
    if (this.cachedMessageHashes = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.queryString = "", o.prototype.widgetStates = null, o.prototype.pageScriptHash = "", o.prototype.pageName = "", o.prototype.fragmentId = "", o.prototype.isAutoRerun = !1, o.prototype.cachedMessageHashes = $util.emptyArray, o.prototype.contextInfo = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.queryString != null && Object.hasOwnProperty.call(i, "queryString") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.queryString), i.widgetStates != null && Object.hasOwnProperty.call(i, "widgetStates") && $root.WidgetStates.encode(i.widgetStates, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), i.pageScriptHash != null && Object.hasOwnProperty.call(i, "pageScriptHash") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.pageScriptHash), i.pageName != null && Object.hasOwnProperty.call(i, "pageName") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.pageName), i.fragmentId != null && Object.hasOwnProperty.call(i, "fragmentId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.fragmentId), i.isAutoRerun != null && Object.hasOwnProperty.call(i, "isAutoRerun") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(i.isAutoRerun), i.cachedMessageHashes != null && i.cachedMessageHashes.length) for (let E = 0; E < i.cachedMessageHashes.length; ++E) g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.cachedMessageHashes[E]);
    return i.contextInfo != null && Object.hasOwnProperty.call(i, "contextInfo") && $root.ContextInfo.encode(i.contextInfo, g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ClientState();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.queryString = i.string();
          break;
        }
        case 2: {
          t.widgetStates = $root.WidgetStates.decode(i, i.uint32());
          break;
        }
        case 3: {
          t.pageScriptHash = i.string();
          break;
        }
        case 4: {
          t.pageName = i.string();
          break;
        }
        case 5: {
          t.fragmentId = i.string();
          break;
        }
        case 6: {
          t.isAutoRerun = i.bool();
          break;
        }
        case 7: {
          t.cachedMessageHashes && t.cachedMessageHashes.length || (t.cachedMessageHashes = []), t.cachedMessageHashes.push(i.string());
          break;
        }
        case 8: {
          t.contextInfo = $root.ContextInfo.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ClientState) return i;
    let g = new $root.ClientState();
    if (i.queryString != null && (g.queryString = String(i.queryString)), i.widgetStates != null) {
      if (typeof i.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
      g.widgetStates = $root.WidgetStates.fromObject(i.widgetStates);
    }
    if (i.pageScriptHash != null && (g.pageScriptHash = String(i.pageScriptHash)), i.pageName != null && (g.pageName = String(i.pageName)), i.fragmentId != null && (g.fragmentId = String(i.fragmentId)), i.isAutoRerun != null && (g.isAutoRerun = !!i.isAutoRerun), i.cachedMessageHashes) {
      if (!Array.isArray(i.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
      g.cachedMessageHashes = [];
      for (let E = 0; E < i.cachedMessageHashes.length; ++E) g.cachedMessageHashes[E] = String(i.cachedMessageHashes[E]);
    }
    if (i.contextInfo != null) {
      if (typeof i.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
      g.contextInfo = $root.ContextInfo.fromObject(i.contextInfo);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.cachedMessageHashes = []), g.defaults && (E.queryString = "", E.widgetStates = null, E.pageScriptHash = "", E.pageName = "", E.fragmentId = "", E.isAutoRerun = !1, E.contextInfo = null), i.queryString != null && i.hasOwnProperty("queryString") && (E.queryString = i.queryString), i.widgetStates != null && i.hasOwnProperty("widgetStates") && (E.widgetStates = $root.WidgetStates.toObject(i.widgetStates, g)), i.pageScriptHash != null && i.hasOwnProperty("pageScriptHash") && (E.pageScriptHash = i.pageScriptHash), i.pageName != null && i.hasOwnProperty("pageName") && (E.pageName = i.pageName), i.fragmentId != null && i.hasOwnProperty("fragmentId") && (E.fragmentId = i.fragmentId), i.isAutoRerun != null && i.hasOwnProperty("isAutoRerun") && (E.isAutoRerun = i.isAutoRerun), i.cachedMessageHashes && i.cachedMessageHashes.length) {
      E.cachedMessageHashes = [];
      for (let e = 0; e < i.cachedMessageHashes.length; ++e) E.cachedMessageHashes[e] = i.cachedMessageHashes[e];
    }
    return i.contextInfo != null && i.hasOwnProperty("contextInfo") && (E.contextInfo = $root.ContextInfo.toObject(i.contextInfo, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ClientState";
  }, o;
})();
$root.WidgetStates = (() => {
  function o(i) {
    if (this.widgets = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.widgets = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.widgets != null && i.widgets.length) for (let E = 0; E < i.widgets.length; ++E) $root.WidgetState.encode(i.widgets[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.WidgetStates();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? (t.widgets && t.widgets.length || (t.widgets = []), t.widgets.push($root.WidgetState.decode(i, i.uint32()))) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.WidgetStates) return i;
    let g = new $root.WidgetStates();
    if (i.widgets) {
      if (!Array.isArray(i.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
      g.widgets = [];
      for (let E = 0; E < i.widgets.length; ++E) {
        if (typeof i.widgets[E] != "object") throw TypeError(".WidgetStates.widgets: object expected");
        g.widgets[E] = $root.WidgetState.fromObject(i.widgets[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.widgets = []), i.widgets && i.widgets.length) {
      E.widgets = [];
      for (let e = 0; e < i.widgets.length; ++e) E.widgets[e] = $root.WidgetState.toObject(i.widgets[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/WidgetStates";
  }, o;
})();
$root.WidgetState = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.triggerValue = null, o.prototype.boolValue = null, o.prototype.doubleValue = null, o.prototype.intValue = null, o.prototype.stringValue = null, o.prototype.doubleArrayValue = null, o.prototype.intArrayValue = null, o.prototype.stringArrayValue = null, o.prototype.jsonValue = null, o.prototype.arrowValue = null, o.prototype.bytesValue = null, o.prototype.fileUploaderStateValue = null, o.prototype.stringTriggerValue = null, o.prototype.chatInputValue = null, o.prototype.jsonTriggerValue = null;
  let i;
  return Object.defineProperty(o.prototype, "value", { get: $util.oneOfGetter(i = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue", "jsonTriggerValue"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.triggerValue != null && Object.hasOwnProperty.call(g, "triggerValue") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.triggerValue), g.boolValue != null && Object.hasOwnProperty.call(g, "boolValue") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.boolValue), g.doubleValue != null && Object.hasOwnProperty.call(g, "doubleValue") && E.uint32(
      /* id 4, wireType 1 =*/
      33
    ).double(g.doubleValue), g.intValue != null && Object.hasOwnProperty.call(g, "intValue") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).sint64(g.intValue), g.stringValue != null && Object.hasOwnProperty.call(g, "stringValue") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.stringValue), g.doubleArrayValue != null && Object.hasOwnProperty.call(g, "doubleArrayValue") && $root.DoubleArray.encode(g.doubleArrayValue, E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.intArrayValue != null && Object.hasOwnProperty.call(g, "intArrayValue") && $root.SInt64Array.encode(g.intArrayValue, E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g.stringArrayValue != null && Object.hasOwnProperty.call(g, "stringArrayValue") && $root.StringArray.encode(g.stringArrayValue, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.jsonValue != null && Object.hasOwnProperty.call(g, "jsonValue") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.jsonValue), g.arrowValue != null && Object.hasOwnProperty.call(g, "arrowValue") && $root.ArrowTable.encode(g.arrowValue, E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.bytesValue != null && Object.hasOwnProperty.call(g, "bytesValue") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(g.bytesValue), g.fileUploaderStateValue != null && Object.hasOwnProperty.call(g, "fileUploaderStateValue") && $root.FileUploaderState.encode(g.fileUploaderStateValue, E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.stringTriggerValue != null && Object.hasOwnProperty.call(g, "stringTriggerValue") && $root.StringTriggerValue.encode(g.stringTriggerValue, E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.chatInputValue != null && Object.hasOwnProperty.call(g, "chatInputValue") && $root.ChatInputValue.encode(g.chatInputValue, E.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), g.jsonTriggerValue != null && Object.hasOwnProperty.call(g, "jsonTriggerValue") && E.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(g.jsonTriggerValue), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.WidgetState();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.triggerValue = g.bool();
          break;
        }
        case 3: {
          n.boolValue = g.bool();
          break;
        }
        case 4: {
          n.doubleValue = g.double();
          break;
        }
        case 5: {
          n.intValue = g.sint64();
          break;
        }
        case 6: {
          n.stringValue = g.string();
          break;
        }
        case 7: {
          n.doubleArrayValue = $root.DoubleArray.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.intArrayValue = $root.SInt64Array.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.stringArrayValue = $root.StringArray.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.jsonValue = g.string();
          break;
        }
        case 11: {
          n.arrowValue = $root.ArrowTable.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.bytesValue = g.bytes();
          break;
        }
        case 13: {
          n.fileUploaderStateValue = $root.FileUploaderState.decode(g, g.uint32());
          break;
        }
        case 14: {
          n.stringTriggerValue = $root.StringTriggerValue.decode(g, g.uint32());
          break;
        }
        case 15: {
          n.chatInputValue = $root.ChatInputValue.decode(g, g.uint32());
          break;
        }
        case 16: {
          n.jsonTriggerValue = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.WidgetState) return g;
    let E = new $root.WidgetState();
    if (g.id != null && (E.id = String(g.id)), g.triggerValue != null && (E.triggerValue = !!g.triggerValue), g.boolValue != null && (E.boolValue = !!g.boolValue), g.doubleValue != null && (E.doubleValue = Number(g.doubleValue)), g.intValue != null && ($util.Long ? (E.intValue = $util.Long.fromValue(g.intValue)).unsigned = !1 : typeof g.intValue == "string" ? E.intValue = parseInt(g.intValue, 10) : typeof g.intValue == "number" ? E.intValue = g.intValue : typeof g.intValue == "object" && (E.intValue = new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber())), g.stringValue != null && (E.stringValue = String(g.stringValue)), g.doubleArrayValue != null) {
      if (typeof g.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
      E.doubleArrayValue = $root.DoubleArray.fromObject(g.doubleArrayValue);
    }
    if (g.intArrayValue != null) {
      if (typeof g.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
      E.intArrayValue = $root.SInt64Array.fromObject(g.intArrayValue);
    }
    if (g.stringArrayValue != null) {
      if (typeof g.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
      E.stringArrayValue = $root.StringArray.fromObject(g.stringArrayValue);
    }
    if (g.jsonValue != null && (E.jsonValue = String(g.jsonValue)), g.arrowValue != null) {
      if (typeof g.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
      E.arrowValue = $root.ArrowTable.fromObject(g.arrowValue);
    }
    if (g.bytesValue != null && (typeof g.bytesValue == "string" ? $util.base64.decode(g.bytesValue, E.bytesValue = $util.newBuffer($util.base64.length(g.bytesValue)), 0) : g.bytesValue.length >= 0 && (E.bytesValue = g.bytesValue)), g.fileUploaderStateValue != null) {
      if (typeof g.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      E.fileUploaderStateValue = $root.FileUploaderState.fromObject(g.fileUploaderStateValue);
    }
    if (g.stringTriggerValue != null) {
      if (typeof g.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
      E.stringTriggerValue = $root.StringTriggerValue.fromObject(g.stringTriggerValue);
    }
    if (g.chatInputValue != null) {
      if (typeof g.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
      E.chatInputValue = $root.ChatInputValue.fromObject(g.chatInputValue);
    }
    return g.jsonTriggerValue != null && (E.jsonTriggerValue = String(g.jsonTriggerValue)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = ""), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.triggerValue != null && g.hasOwnProperty("triggerValue") && (e.triggerValue = g.triggerValue, E.oneofs && (e.value = "triggerValue")), g.boolValue != null && g.hasOwnProperty("boolValue") && (e.boolValue = g.boolValue, E.oneofs && (e.value = "boolValue")), g.doubleValue != null && g.hasOwnProperty("doubleValue") && (e.doubleValue = E.json && !isFinite(g.doubleValue) ? String(g.doubleValue) : g.doubleValue, E.oneofs && (e.value = "doubleValue")), g.intValue != null && g.hasOwnProperty("intValue") && (typeof g.intValue == "number" ? e.intValue = E.longs === String ? String(g.intValue) : g.intValue : e.intValue = E.longs === String ? $util.Long.prototype.toString.call(g.intValue) : E.longs === Number ? new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber() : g.intValue, E.oneofs && (e.value = "intValue")), g.stringValue != null && g.hasOwnProperty("stringValue") && (e.stringValue = g.stringValue, E.oneofs && (e.value = "stringValue")), g.doubleArrayValue != null && g.hasOwnProperty("doubleArrayValue") && (e.doubleArrayValue = $root.DoubleArray.toObject(g.doubleArrayValue, E), E.oneofs && (e.value = "doubleArrayValue")), g.intArrayValue != null && g.hasOwnProperty("intArrayValue") && (e.intArrayValue = $root.SInt64Array.toObject(g.intArrayValue, E), E.oneofs && (e.value = "intArrayValue")), g.stringArrayValue != null && g.hasOwnProperty("stringArrayValue") && (e.stringArrayValue = $root.StringArray.toObject(g.stringArrayValue, E), E.oneofs && (e.value = "stringArrayValue")), g.jsonValue != null && g.hasOwnProperty("jsonValue") && (e.jsonValue = g.jsonValue, E.oneofs && (e.value = "jsonValue")), g.arrowValue != null && g.hasOwnProperty("arrowValue") && (e.arrowValue = $root.ArrowTable.toObject(g.arrowValue, E), E.oneofs && (e.value = "arrowValue")), g.bytesValue != null && g.hasOwnProperty("bytesValue") && (e.bytesValue = E.bytes === String ? $util.base64.encode(g.bytesValue, 0, g.bytesValue.length) : E.bytes === Array ? Array.prototype.slice.call(g.bytesValue) : g.bytesValue, E.oneofs && (e.value = "bytesValue")), g.fileUploaderStateValue != null && g.hasOwnProperty("fileUploaderStateValue") && (e.fileUploaderStateValue = $root.FileUploaderState.toObject(g.fileUploaderStateValue, E), E.oneofs && (e.value = "fileUploaderStateValue")), g.stringTriggerValue != null && g.hasOwnProperty("stringTriggerValue") && (e.stringTriggerValue = $root.StringTriggerValue.toObject(g.stringTriggerValue, E), E.oneofs && (e.value = "stringTriggerValue")), g.chatInputValue != null && g.hasOwnProperty("chatInputValue") && (e.chatInputValue = $root.ChatInputValue.toObject(g.chatInputValue, E), E.oneofs && (e.value = "chatInputValue")), g.jsonTriggerValue != null && g.hasOwnProperty("jsonTriggerValue") && (e.jsonTriggerValue = g.jsonTriggerValue, E.oneofs && (e.value = "jsonTriggerValue")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/WidgetState";
  }, o;
})();
$root.StringArray = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.data != null && i.data.length) for (let E = 0; E < i.data.length; ++E) g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.data[E]);
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.StringArray();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? (t.data && t.data.length || (t.data = []), t.data.push(i.string())) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.StringArray) return i;
    let g = new $root.StringArray();
    if (i.data) {
      if (!Array.isArray(i.data)) throw TypeError(".StringArray.data: array expected");
      g.data = [];
      for (let E = 0; E < i.data.length; ++E) g.data[E] = String(i.data[E]);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.data = []), i.data && i.data.length) {
      E.data = [];
      for (let e = 0; e < i.data.length; ++e) E.data[e] = i.data[e];
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/StringArray";
  }, o;
})();
$root.DoubleArray = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.data != null && i.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let E = 0; E < i.data.length; ++E) g.double(i.data[E]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DoubleArray();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.data.push(i.double());
          } else t.data.push(i.double());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DoubleArray) return i;
    let g = new $root.DoubleArray();
    if (i.data) {
      if (!Array.isArray(i.data)) throw TypeError(".DoubleArray.data: array expected");
      g.data = [];
      for (let E = 0; E < i.data.length; ++E) g.data[E] = Number(i.data[E]);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.data = []), i.data && i.data.length) {
      E.data = [];
      for (let e = 0; e < i.data.length; ++e) E.data[e] = g.json && !isFinite(i.data[e]) ? String(i.data[e]) : i.data[e];
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DoubleArray";
  }, o;
})();
$root.Int32Array = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.data != null && i.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let E = 0; E < i.data.length; ++E) g.int32(i.data[E]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Int32Array();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.data.push(i.int32());
          } else t.data.push(i.int32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Int32Array) return i;
    let g = new $root.Int32Array();
    if (i.data) {
      if (!Array.isArray(i.data)) throw TypeError(".Int32Array.data: array expected");
      g.data = [];
      for (let E = 0; E < i.data.length; ++E) g.data[E] = i.data[E] | 0;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.data = []), i.data && i.data.length) {
      E.data = [];
      for (let e = 0; e < i.data.length; ++e) E.data[e] = i.data[e];
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Int32Array";
  }, o;
})();
$root.Int64Array = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.data != null && i.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let E = 0; E < i.data.length; ++E) g.int64(i.data[E]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Int64Array();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.data.push(i.int64());
          } else t.data.push(i.int64());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Int64Array) return i;
    let g = new $root.Int64Array();
    if (i.data) {
      if (!Array.isArray(i.data)) throw TypeError(".Int64Array.data: array expected");
      g.data = [];
      for (let E = 0; E < i.data.length; ++E) $util.Long ? (g.data[E] = $util.Long.fromValue(i.data[E])).unsigned = !1 : typeof i.data[E] == "string" ? g.data[E] = parseInt(i.data[E], 10) : typeof i.data[E] == "number" ? g.data[E] = i.data[E] : typeof i.data[E] == "object" && (g.data[E] = new $util.LongBits(i.data[E].low >>> 0, i.data[E].high >>> 0).toNumber());
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.data = []), i.data && i.data.length) {
      E.data = [];
      for (let e = 0; e < i.data.length; ++e) typeof i.data[e] == "number" ? E.data[e] = g.longs === String ? String(i.data[e]) : i.data[e] : E.data[e] = g.longs === String ? $util.Long.prototype.toString.call(i.data[e]) : g.longs === Number ? new $util.LongBits(i.data[e].low >>> 0, i.data[e].high >>> 0).toNumber() : i.data[e];
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Int64Array";
  }, o;
})();
$root.SInt64Array = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.data != null && i.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let E = 0; E < i.data.length; ++E) g.sint64(i.data[E]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.SInt64Array();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.data.push(i.sint64());
          } else t.data.push(i.sint64());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.SInt64Array) return i;
    let g = new $root.SInt64Array();
    if (i.data) {
      if (!Array.isArray(i.data)) throw TypeError(".SInt64Array.data: array expected");
      g.data = [];
      for (let E = 0; E < i.data.length; ++E) $util.Long ? (g.data[E] = $util.Long.fromValue(i.data[E])).unsigned = !1 : typeof i.data[E] == "string" ? g.data[E] = parseInt(i.data[E], 10) : typeof i.data[E] == "number" ? g.data[E] = i.data[E] : typeof i.data[E] == "object" && (g.data[E] = new $util.LongBits(i.data[E].low >>> 0, i.data[E].high >>> 0).toNumber());
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.data = []), i.data && i.data.length) {
      E.data = [];
      for (let e = 0; e < i.data.length; ++e) typeof i.data[e] == "number" ? E.data[e] = g.longs === String ? String(i.data[e]) : i.data[e] : E.data[e] = g.longs === String ? $util.Long.prototype.toString.call(i.data[e]) : g.longs === Number ? new $util.LongBits(i.data[e].low >>> 0, i.data[e].high >>> 0).toNumber() : i.data[e];
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/SInt64Array";
  }, o;
})();
$root.UInt32Array = (() => {
  function o(i) {
    if (this.data = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.data != null && i.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let E = 0; E < i.data.length; ++E) g.uint32(i.data[E]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.UInt32Array();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.data.push(i.uint32());
          } else t.data.push(i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.UInt32Array) return i;
    let g = new $root.UInt32Array();
    if (i.data) {
      if (!Array.isArray(i.data)) throw TypeError(".UInt32Array.data: array expected");
      g.data = [];
      for (let E = 0; E < i.data.length; ++E) g.data[E] = i.data[E] >>> 0;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.data = []), i.data && i.data.length) {
      E.data = [];
      for (let e = 0; e < i.data.length; ++e) E.data[e] = i.data[e];
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/UInt32Array";
  }, o;
})();
$root.StringTriggerValue = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.data = null;
  let i;
  return Object.defineProperty(o.prototype, "_data", { get: $util.oneOfGetter(i = ["data"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.data), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.StringTriggerValue();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      h >>> 3 === 1 ? n.data = g.string() : g.skipType(h & 7);
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.StringTriggerValue) return g;
    let E = new $root.StringTriggerValue();
    return g.data != null && (E.data = String(g.data)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return g.data != null && g.hasOwnProperty("data") && (e.data = g.data, E.oneofs && (e._data = "data")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/StringTriggerValue";
  }, o;
})();
$root.FileURLsRequest = (() => {
  function o(i) {
    if (this.fileNames = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.requestId = "", o.prototype.fileNames = $util.emptyArray, o.prototype.sessionId = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.requestId != null && Object.hasOwnProperty.call(i, "requestId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.requestId), i.fileNames != null && i.fileNames.length) for (let E = 0; E < i.fileNames.length; ++E) g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.fileNames[E]);
    return i.sessionId != null && Object.hasOwnProperty.call(i, "sessionId") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.sessionId), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.FileURLsRequest();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.requestId = i.string();
          break;
        }
        case 2: {
          t.fileNames && t.fileNames.length || (t.fileNames = []), t.fileNames.push(i.string());
          break;
        }
        case 3: {
          t.sessionId = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.FileURLsRequest) return i;
    let g = new $root.FileURLsRequest();
    if (i.requestId != null && (g.requestId = String(i.requestId)), i.fileNames) {
      if (!Array.isArray(i.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
      g.fileNames = [];
      for (let E = 0; E < i.fileNames.length; ++E) g.fileNames[E] = String(i.fileNames[E]);
    }
    return i.sessionId != null && (g.sessionId = String(i.sessionId)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.fileNames = []), g.defaults && (E.requestId = "", E.sessionId = ""), i.requestId != null && i.hasOwnProperty("requestId") && (E.requestId = i.requestId), i.fileNames && i.fileNames.length) {
      E.fileNames = [];
      for (let e = 0; e < i.fileNames.length; ++e) E.fileNames[e] = i.fileNames[e];
    }
    return i.sessionId != null && i.hasOwnProperty("sessionId") && (E.sessionId = i.sessionId), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/FileURLsRequest";
  }, o;
})();
$root.FileURLs = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.fileId = "", o.prototype.uploadUrl = "", o.prototype.deleteUrl = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.fileId != null && Object.hasOwnProperty.call(i, "fileId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.fileId), i.uploadUrl != null && Object.hasOwnProperty.call(i, "uploadUrl") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.uploadUrl), i.deleteUrl != null && Object.hasOwnProperty.call(i, "deleteUrl") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.deleteUrl), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.FileURLs();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.fileId = i.string();
          break;
        }
        case 2: {
          t.uploadUrl = i.string();
          break;
        }
        case 3: {
          t.deleteUrl = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.FileURLs) return i;
    let g = new $root.FileURLs();
    return i.fileId != null && (g.fileId = String(i.fileId)), i.uploadUrl != null && (g.uploadUrl = String(i.uploadUrl)), i.deleteUrl != null && (g.deleteUrl = String(i.deleteUrl)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.fileId = "", E.uploadUrl = "", E.deleteUrl = ""), i.fileId != null && i.hasOwnProperty("fileId") && (E.fileId = i.fileId), i.uploadUrl != null && i.hasOwnProperty("uploadUrl") && (E.uploadUrl = i.uploadUrl), i.deleteUrl != null && i.hasOwnProperty("deleteUrl") && (E.deleteUrl = i.deleteUrl), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/FileURLs";
  }, o;
})();
$root.FileURLsResponse = (() => {
  function o(i) {
    if (this.fileUrls = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.responseId = "", o.prototype.fileUrls = $util.emptyArray, o.prototype.errorMsg = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.responseId != null && Object.hasOwnProperty.call(i, "responseId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.responseId), i.fileUrls != null && i.fileUrls.length) for (let E = 0; E < i.fileUrls.length; ++E) $root.FileURLs.encode(i.fileUrls[E], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return i.errorMsg != null && Object.hasOwnProperty.call(i, "errorMsg") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.errorMsg), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.FileURLsResponse();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.responseId = i.string();
          break;
        }
        case 2: {
          t.fileUrls && t.fileUrls.length || (t.fileUrls = []), t.fileUrls.push($root.FileURLs.decode(i, i.uint32()));
          break;
        }
        case 3: {
          t.errorMsg = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.FileURLsResponse) return i;
    let g = new $root.FileURLsResponse();
    if (i.responseId != null && (g.responseId = String(i.responseId)), i.fileUrls) {
      if (!Array.isArray(i.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
      g.fileUrls = [];
      for (let E = 0; E < i.fileUrls.length; ++E) {
        if (typeof i.fileUrls[E] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
        g.fileUrls[E] = $root.FileURLs.fromObject(i.fileUrls[E]);
      }
    }
    return i.errorMsg != null && (g.errorMsg = String(i.errorMsg)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.fileUrls = []), g.defaults && (E.responseId = "", E.errorMsg = ""), i.responseId != null && i.hasOwnProperty("responseId") && (E.responseId = i.responseId), i.fileUrls && i.fileUrls.length) {
      E.fileUrls = [];
      for (let e = 0; e < i.fileUrls.length; ++e) E.fileUrls[e] = $root.FileURLs.toObject(i.fileUrls[e], g);
    }
    return i.errorMsg != null && i.hasOwnProperty("errorMsg") && (E.errorMsg = i.errorMsg), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/FileURLsResponse";
  }, o;
})();
$root.UploadedFileInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.name = "", o.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.prototype.fileId = "", o.prototype.fileUrls = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(i.id), i.name != null && Object.hasOwnProperty.call(i, "name") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.name), i.size != null && Object.hasOwnProperty.call(i, "size") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint64(i.size), i.fileId != null && Object.hasOwnProperty.call(i, "fileId") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.fileId), i.fileUrls != null && Object.hasOwnProperty.call(i, "fileUrls") && $root.FileURLs.encode(i.fileUrls, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.UploadedFileInfo();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.sint64();
          break;
        }
        case 2: {
          t.name = i.string();
          break;
        }
        case 3: {
          t.size = i.uint64();
          break;
        }
        case 4: {
          t.fileId = i.string();
          break;
        }
        case 5: {
          t.fileUrls = $root.FileURLs.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.UploadedFileInfo) return i;
    let g = new $root.UploadedFileInfo();
    if (i.id != null && ($util.Long ? (g.id = $util.Long.fromValue(i.id)).unsigned = !1 : typeof i.id == "string" ? g.id = parseInt(i.id, 10) : typeof i.id == "number" ? g.id = i.id : typeof i.id == "object" && (g.id = new $util.LongBits(i.id.low >>> 0, i.id.high >>> 0).toNumber())), i.name != null && (g.name = String(i.name)), i.size != null && ($util.Long ? (g.size = $util.Long.fromValue(i.size)).unsigned = !0 : typeof i.size == "string" ? g.size = parseInt(i.size, 10) : typeof i.size == "number" ? g.size = i.size : typeof i.size == "object" && (g.size = new $util.LongBits(i.size.low >>> 0, i.size.high >>> 0).toNumber(!0))), i.fileId != null && (g.fileId = String(i.fileId)), i.fileUrls != null) {
      if (typeof i.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      g.fileUrls = $root.FileURLs.fromObject(i.fileUrls);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if (g.defaults) {
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.id = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.id = g.longs === String ? "0" : 0;
      if (E.name = "", $util.Long) {
        let e = new $util.Long(0, 0, !0);
        E.size = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.size = g.longs === String ? "0" : 0;
      E.fileId = "", E.fileUrls = null;
    }
    return i.id != null && i.hasOwnProperty("id") && (typeof i.id == "number" ? E.id = g.longs === String ? String(i.id) : i.id : E.id = g.longs === String ? $util.Long.prototype.toString.call(i.id) : g.longs === Number ? new $util.LongBits(i.id.low >>> 0, i.id.high >>> 0).toNumber() : i.id), i.name != null && i.hasOwnProperty("name") && (E.name = i.name), i.size != null && i.hasOwnProperty("size") && (typeof i.size == "number" ? E.size = g.longs === String ? String(i.size) : i.size : E.size = g.longs === String ? $util.Long.prototype.toString.call(i.size) : g.longs === Number ? new $util.LongBits(i.size.low >>> 0, i.size.high >>> 0).toNumber(!0) : i.size), i.fileId != null && i.hasOwnProperty("fileId") && (E.fileId = i.fileId), i.fileUrls != null && i.hasOwnProperty("fileUrls") && (E.fileUrls = $root.FileURLs.toObject(i.fileUrls, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/UploadedFileInfo";
  }, o;
})();
$root.FileUploaderState = (() => {
  function o(i) {
    if (this.uploadedFileInfo = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.maxFileId = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.uploadedFileInfo = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.maxFileId != null && Object.hasOwnProperty.call(i, "maxFileId") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(i.maxFileId), i.uploadedFileInfo != null && i.uploadedFileInfo.length) for (let E = 0; E < i.uploadedFileInfo.length; ++E) $root.UploadedFileInfo.encode(i.uploadedFileInfo[E], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.FileUploaderState();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.maxFileId = i.sint64();
          break;
        }
        case 2: {
          t.uploadedFileInfo && t.uploadedFileInfo.length || (t.uploadedFileInfo = []), t.uploadedFileInfo.push($root.UploadedFileInfo.decode(i, i.uint32()));
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.FileUploaderState) return i;
    let g = new $root.FileUploaderState();
    if (i.maxFileId != null && ($util.Long ? (g.maxFileId = $util.Long.fromValue(i.maxFileId)).unsigned = !1 : typeof i.maxFileId == "string" ? g.maxFileId = parseInt(i.maxFileId, 10) : typeof i.maxFileId == "number" ? g.maxFileId = i.maxFileId : typeof i.maxFileId == "object" && (g.maxFileId = new $util.LongBits(i.maxFileId.low >>> 0, i.maxFileId.high >>> 0).toNumber())), i.uploadedFileInfo) {
      if (!Array.isArray(i.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      g.uploadedFileInfo = [];
      for (let E = 0; E < i.uploadedFileInfo.length; ++E) {
        if (typeof i.uploadedFileInfo[E] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        g.uploadedFileInfo[E] = $root.UploadedFileInfo.fromObject(i.uploadedFileInfo[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.uploadedFileInfo = []), g.defaults) if ($util.Long) {
      let e = new $util.Long(0, 0, !1);
      E.maxFileId = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
    } else E.maxFileId = g.longs === String ? "0" : 0;
    if (i.maxFileId != null && i.hasOwnProperty("maxFileId") && (typeof i.maxFileId == "number" ? E.maxFileId = g.longs === String ? String(i.maxFileId) : i.maxFileId : E.maxFileId = g.longs === String ? $util.Long.prototype.toString.call(i.maxFileId) : g.longs === Number ? new $util.LongBits(i.maxFileId.low >>> 0, i.maxFileId.high >>> 0).toNumber() : i.maxFileId), i.uploadedFileInfo && i.uploadedFileInfo.length) {
      E.uploadedFileInfo = [];
      for (let e = 0; e < i.uploadedFileInfo.length; ++e) E.uploadedFileInfo[e] = $root.UploadedFileInfo.toObject(i.uploadedFileInfo[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/FileUploaderState";
  }, o;
})();
$root.ChatInputValue = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.data = null, o.prototype.fileUploaderState = null, o.prototype.audioFileInfo = null;
  let i;
  return Object.defineProperty(o.prototype, "_data", { get: $util.oneOfGetter(i = ["data"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_fileUploaderState", { get: $util.oneOfGetter(i = ["fileUploaderState"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_audioFileInfo", { get: $util.oneOfGetter(i = ["audioFileInfo"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.data), g.fileUploaderState != null && Object.hasOwnProperty.call(g, "fileUploaderState") && $root.FileUploaderState.encode(g.fileUploaderState, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.audioFileInfo != null && Object.hasOwnProperty.call(g, "audioFileInfo") && $root.UploadedFileInfo.encode(g.audioFileInfo, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.ChatInputValue();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.data = g.string();
          break;
        }
        case 2: {
          n.fileUploaderState = $root.FileUploaderState.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.audioFileInfo = $root.UploadedFileInfo.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.ChatInputValue) return g;
    let E = new $root.ChatInputValue();
    if (g.data != null && (E.data = String(g.data)), g.fileUploaderState != null) {
      if (typeof g.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      E.fileUploaderState = $root.FileUploaderState.fromObject(g.fileUploaderState);
    }
    if (g.audioFileInfo != null) {
      if (typeof g.audioFileInfo != "object") throw TypeError(".ChatInputValue.audioFileInfo: object expected");
      E.audioFileInfo = $root.UploadedFileInfo.fromObject(g.audioFileInfo);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return g.data != null && g.hasOwnProperty("data") && (e.data = g.data, E.oneofs && (e._data = "data")), g.fileUploaderState != null && g.hasOwnProperty("fileUploaderState") && (e.fileUploaderState = $root.FileUploaderState.toObject(g.fileUploaderState, E), E.oneofs && (e._fileUploaderState = "fileUploaderState")), g.audioFileInfo != null && g.hasOwnProperty("audioFileInfo") && (e.audioFileInfo = $root.UploadedFileInfo.toObject(g.audioFileInfo, E), E.oneofs && (e._audioFileInfo = "audioFileInfo")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ChatInputValue";
  }, o;
})();
$root.ComponentInstance = (() => {
  function o(g) {
    if (this.specialArgs = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.jsonArgs = "", o.prototype.specialArgs = $util.emptyArray, o.prototype.componentName = "", o.prototype.url = "", o.prototype.formId = "", o.prototype.tabIndex = null;
  let i;
  return Object.defineProperty(o.prototype, "_tabIndex", { get: $util.oneOfGetter(i = ["tabIndex"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.jsonArgs != null && Object.hasOwnProperty.call(g, "jsonArgs") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.jsonArgs), g.specialArgs != null && g.specialArgs.length) for (let e = 0; e < g.specialArgs.length; ++e) $root.SpecialArg.encode(g.specialArgs[e], E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim();
    return g.componentName != null && Object.hasOwnProperty.call(g, "componentName") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.componentName), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.url), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.tabIndex != null && Object.hasOwnProperty.call(g, "tabIndex") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.tabIndex), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.ComponentInstance();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.jsonArgs = g.string();
          break;
        }
        case 3: {
          n.specialArgs && n.specialArgs.length || (n.specialArgs = []), n.specialArgs.push($root.SpecialArg.decode(g, g.uint32()));
          break;
        }
        case 4: {
          n.componentName = g.string();
          break;
        }
        case 5: {
          n.url = g.string();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          n.tabIndex = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.ComponentInstance) return g;
    let E = new $root.ComponentInstance();
    if (g.id != null && (E.id = String(g.id)), g.jsonArgs != null && (E.jsonArgs = String(g.jsonArgs)), g.specialArgs) {
      if (!Array.isArray(g.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
      E.specialArgs = [];
      for (let e = 0; e < g.specialArgs.length; ++e) {
        if (typeof g.specialArgs[e] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
        E.specialArgs[e] = $root.SpecialArg.fromObject(g.specialArgs[e]);
      }
    }
    return g.componentName != null && (E.componentName = String(g.componentName)), g.url != null && (E.url = String(g.url)), g.formId != null && (E.formId = String(g.formId)), g.tabIndex != null && (E.tabIndex = g.tabIndex | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.specialArgs = []), E.defaults && (e.id = "", e.jsonArgs = "", e.componentName = "", e.url = "", e.formId = ""), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.jsonArgs != null && g.hasOwnProperty("jsonArgs") && (e.jsonArgs = g.jsonArgs), g.specialArgs && g.specialArgs.length) {
      e.specialArgs = [];
      for (let t = 0; t < g.specialArgs.length; ++t) e.specialArgs[t] = $root.SpecialArg.toObject(g.specialArgs[t], E);
    }
    return g.componentName != null && g.hasOwnProperty("componentName") && (e.componentName = g.componentName), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.tabIndex != null && g.hasOwnProperty("tabIndex") && (e.tabIndex = g.tabIndex, E.oneofs && (e._tabIndex = "tabIndex")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ComponentInstance";
  }, o;
})();
$root.SpecialArg = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.key = "", o.prototype.arrowDataframe = null, o.prototype.bytes = null;
  let i;
  return Object.defineProperty(o.prototype, "value", { get: $util.oneOfGetter(i = ["arrowDataframe", "bytes"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.key != null && Object.hasOwnProperty.call(g, "key") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.key), g.arrowDataframe != null && Object.hasOwnProperty.call(g, "arrowDataframe") && $root.ArrowDataframe.encode(g.arrowDataframe, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.bytes != null && Object.hasOwnProperty.call(g, "bytes") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(g.bytes), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.SpecialArg();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.key = g.string();
          break;
        }
        case 2: {
          n.arrowDataframe = $root.ArrowDataframe.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.bytes = g.bytes();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.SpecialArg) return g;
    let E = new $root.SpecialArg();
    if (g.key != null && (E.key = String(g.key)), g.arrowDataframe != null) {
      if (typeof g.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
      E.arrowDataframe = $root.ArrowDataframe.fromObject(g.arrowDataframe);
    }
    return g.bytes != null && (typeof g.bytes == "string" ? $util.base64.decode(g.bytes, E.bytes = $util.newBuffer($util.base64.length(g.bytes)), 0) : g.bytes.length >= 0 && (E.bytes = g.bytes)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.key = ""), g.key != null && g.hasOwnProperty("key") && (e.key = g.key), g.arrowDataframe != null && g.hasOwnProperty("arrowDataframe") && (e.arrowDataframe = $root.ArrowDataframe.toObject(g.arrowDataframe, E), E.oneofs && (e.value = "arrowDataframe")), g.bytes != null && g.hasOwnProperty("bytes") && (e.bytes = E.bytes === String ? $util.base64.encode(g.bytes, 0, g.bytes.length) : E.bytes === Array ? Array.prototype.slice.call(g.bytes) : g.bytes, E.oneofs && (e.value = "bytes")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SpecialArg";
  }, o;
})();
$root.ArrowDataframe = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.prototype.height = 0, o.prototype.width = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.ArrowTable.encode(i.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), i.height != null && Object.hasOwnProperty.call(i, "height") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(i.height), i.width != null && Object.hasOwnProperty.call(i, "width") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(i.width), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ArrowDataframe();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.data = $root.ArrowTable.decode(i, i.uint32());
          break;
        }
        case 2: {
          t.height = i.uint32();
          break;
        }
        case 3: {
          t.width = i.uint32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ArrowDataframe) return i;
    let g = new $root.ArrowDataframe();
    if (i.data != null) {
      if (typeof i.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
      g.data = $root.ArrowTable.fromObject(i.data);
    }
    return i.height != null && (g.height = i.height >>> 0), i.width != null && (g.width = i.width >>> 0), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.data = null, E.height = 0, E.width = 0), i.data != null && i.hasOwnProperty("data") && (E.data = $root.ArrowTable.toObject(i.data, g)), i.height != null && i.hasOwnProperty("height") && (E.height = i.height), i.width != null && i.hasOwnProperty("width") && (E.width = i.width), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ArrowDataframe";
  }, o;
})();
$root.ArrowTable = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = $util.newBuffer([]), o.prototype.index = $util.newBuffer([]), o.prototype.columns = $util.newBuffer([]), o.prototype.styler = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(i.data), i.index != null && Object.hasOwnProperty.call(i, "index") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).bytes(i.index), i.columns != null && Object.hasOwnProperty.call(i, "columns") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(i.columns), i.styler != null && Object.hasOwnProperty.call(i, "styler") && $root.ArrowTableStyler.encode(i.styler, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ArrowTable();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.data = i.bytes();
          break;
        }
        case 2: {
          t.index = i.bytes();
          break;
        }
        case 3: {
          t.columns = i.bytes();
          break;
        }
        case 5: {
          t.styler = $root.ArrowTableStyler.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ArrowTable) return i;
    let g = new $root.ArrowTable();
    if (i.data != null && (typeof i.data == "string" ? $util.base64.decode(i.data, g.data = $util.newBuffer($util.base64.length(i.data)), 0) : i.data.length >= 0 && (g.data = i.data)), i.index != null && (typeof i.index == "string" ? $util.base64.decode(i.index, g.index = $util.newBuffer($util.base64.length(i.index)), 0) : i.index.length >= 0 && (g.index = i.index)), i.columns != null && (typeof i.columns == "string" ? $util.base64.decode(i.columns, g.columns = $util.newBuffer($util.base64.length(i.columns)), 0) : i.columns.length >= 0 && (g.columns = i.columns)), i.styler != null) {
      if (typeof i.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
      g.styler = $root.ArrowTableStyler.fromObject(i.styler);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (g.bytes === String ? E.data = "" : (E.data = [], g.bytes !== Array && (E.data = $util.newBuffer(E.data))), g.bytes === String ? E.index = "" : (E.index = [], g.bytes !== Array && (E.index = $util.newBuffer(E.index))), g.bytes === String ? E.columns = "" : (E.columns = [], g.bytes !== Array && (E.columns = $util.newBuffer(E.columns))), E.styler = null), i.data != null && i.hasOwnProperty("data") && (E.data = g.bytes === String ? $util.base64.encode(i.data, 0, i.data.length) : g.bytes === Array ? Array.prototype.slice.call(i.data) : i.data), i.index != null && i.hasOwnProperty("index") && (E.index = g.bytes === String ? $util.base64.encode(i.index, 0, i.index.length) : g.bytes === Array ? Array.prototype.slice.call(i.index) : i.index), i.columns != null && i.hasOwnProperty("columns") && (E.columns = g.bytes === String ? $util.base64.encode(i.columns, 0, i.columns.length) : g.bytes === Array ? Array.prototype.slice.call(i.columns) : i.columns), i.styler != null && i.hasOwnProperty("styler") && (E.styler = $root.ArrowTableStyler.toObject(i.styler, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ArrowTable";
  }, o;
})();
$root.ArrowTableStyler = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.uuid = "", o.prototype.caption = "", o.prototype.styles = "", o.prototype.displayValues = $util.newBuffer([]), o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.uuid != null && Object.hasOwnProperty.call(i, "uuid") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.uuid), i.caption != null && Object.hasOwnProperty.call(i, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.caption), i.styles != null && Object.hasOwnProperty.call(i, "styles") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.styles), i.displayValues != null && Object.hasOwnProperty.call(i, "displayValues") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(i.displayValues), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ArrowTableStyler();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.uuid = i.string();
          break;
        }
        case 2: {
          t.caption = i.string();
          break;
        }
        case 3: {
          t.styles = i.string();
          break;
        }
        case 4: {
          t.displayValues = i.bytes();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ArrowTableStyler) return i;
    let g = new $root.ArrowTableStyler();
    return i.uuid != null && (g.uuid = String(i.uuid)), i.caption != null && (g.caption = String(i.caption)), i.styles != null && (g.styles = String(i.styles)), i.displayValues != null && (typeof i.displayValues == "string" ? $util.base64.decode(i.displayValues, g.displayValues = $util.newBuffer($util.base64.length(i.displayValues)), 0) : i.displayValues.length >= 0 && (g.displayValues = i.displayValues)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.uuid = "", E.caption = "", E.styles = "", g.bytes === String ? E.displayValues = "" : (E.displayValues = [], g.bytes !== Array && (E.displayValues = $util.newBuffer(E.displayValues)))), i.uuid != null && i.hasOwnProperty("uuid") && (E.uuid = i.uuid), i.caption != null && i.hasOwnProperty("caption") && (E.caption = i.caption), i.styles != null && i.hasOwnProperty("styles") && (E.styles = i.styles), i.displayValues != null && i.hasOwnProperty("displayValues") && (E.displayValues = g.bytes === String ? $util.base64.encode(i.displayValues, 0, i.displayValues.length) : g.bytes === Array ? Array.prototype.slice.call(i.displayValues) : i.displayValues), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ArrowTableStyler";
  }, o;
})();
$root.Balloons = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.show = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.show != null && Object.hasOwnProperty.call(i, "show") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.show), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Balloons();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 3 ? t.show = i.bool() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Balloons) return i;
    let g = new $root.Balloons();
    return i.show != null && (g.show = !!i.show), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.show = !1), i.show != null && i.hasOwnProperty("show") && (E.show = i.show), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Balloons";
  }, o;
})();
$root.MixedData = (() => {
  function o(i) {
    if (this.arrowBlobs = {}, i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.json = "", o.prototype.arrowBlobs = $util.emptyObject, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.json != null && Object.hasOwnProperty.call(i, "json") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.json), i.arrowBlobs != null && Object.hasOwnProperty.call(i, "arrowBlobs")) for (let E = Object.keys(i.arrowBlobs), e = 0; e < E.length; ++e) g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork().uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E[e]), $root.ArrowData.encode(i.arrowBlobs[E[e]], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim().ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.MixedData(), n, h;
    for (; i.pos < e; ) {
      let d = i.uint32();
      if (d === E) break;
      switch (d >>> 3) {
        case 1: {
          t.json = i.string();
          break;
        }
        case 2: {
          t.arrowBlobs === $util.emptyObject && (t.arrowBlobs = {});
          let k = i.uint32() + i.pos;
          for (n = "", h = null; i.pos < k; ) {
            let p = i.uint32();
            switch (p >>> 3) {
              case 1:
                n = i.string();
                break;
              case 2:
                h = $root.ArrowData.decode(i, i.uint32());
                break;
              default:
                i.skipType(p & 7);
                break;
            }
          }
          t.arrowBlobs[n] = h;
          break;
        }
        default:
          i.skipType(d & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.MixedData) return i;
    let g = new $root.MixedData();
    if (i.json != null && (g.json = String(i.json)), i.arrowBlobs) {
      if (typeof i.arrowBlobs != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
      g.arrowBlobs = {};
      for (let E = Object.keys(i.arrowBlobs), e = 0; e < E.length; ++e) {
        if (typeof i.arrowBlobs[E[e]] != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
        g.arrowBlobs[E[e]] = $root.ArrowData.fromObject(i.arrowBlobs[E[e]]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    (g.objects || g.defaults) && (E.arrowBlobs = {}), g.defaults && (E.json = ""), i.json != null && i.hasOwnProperty("json") && (E.json = i.json);
    let e;
    if (i.arrowBlobs && (e = Object.keys(i.arrowBlobs)).length) {
      E.arrowBlobs = {};
      for (let t = 0; t < e.length; ++t) E.arrowBlobs[e[t]] = $root.ArrowData.toObject(i.arrowBlobs[e[t]], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/MixedData";
  }, o;
})();
$root.BidiComponent = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.componentName = "", o.prototype.jsContent = null, o.prototype.jsSourcePath = null, o.prototype.formId = "", o.prototype.htmlContent = null, o.prototype.cssContent = null, o.prototype.cssSourcePath = null, o.prototype.isolateStyles = !1, o.prototype.json = null, o.prototype.arrowData = null, o.prototype.bytes = null, o.prototype.mixed = null;
  let i;
  return Object.defineProperty(o.prototype, "_jsContent", { get: $util.oneOfGetter(i = ["jsContent"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_jsSourcePath", { get: $util.oneOfGetter(i = ["jsSourcePath"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_htmlContent", { get: $util.oneOfGetter(i = ["htmlContent"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_cssContent", { get: $util.oneOfGetter(i = ["cssContent"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_cssSourcePath", { get: $util.oneOfGetter(i = ["cssSourcePath"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "data", { get: $util.oneOfGetter(i = ["json", "arrowData", "bytes", "mixed"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.componentName != null && Object.hasOwnProperty.call(g, "componentName") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.componentName), g.jsContent != null && Object.hasOwnProperty.call(g, "jsContent") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.jsContent), g.jsSourcePath != null && Object.hasOwnProperty.call(g, "jsSourcePath") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.jsSourcePath), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.htmlContent != null && Object.hasOwnProperty.call(g, "htmlContent") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.htmlContent), g.cssContent != null && Object.hasOwnProperty.call(g, "cssContent") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.cssContent), g.cssSourcePath != null && Object.hasOwnProperty.call(g, "cssSourcePath") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.cssSourcePath), g.isolateStyles != null && Object.hasOwnProperty.call(g, "isolateStyles") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.isolateStyles), g.json != null && Object.hasOwnProperty.call(g, "json") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.json), g.arrowData != null && Object.hasOwnProperty.call(g, "arrowData") && $root.ArrowData.encode(g.arrowData, E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.bytes != null && Object.hasOwnProperty.call(g, "bytes") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(g.bytes), g.mixed != null && Object.hasOwnProperty.call(g, "mixed") && $root.MixedData.encode(g.mixed, E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.BidiComponent();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.componentName = g.string();
          break;
        }
        case 3: {
          n.jsContent = g.string();
          break;
        }
        case 4: {
          n.jsSourcePath = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.htmlContent = g.string();
          break;
        }
        case 7: {
          n.cssContent = g.string();
          break;
        }
        case 8: {
          n.cssSourcePath = g.string();
          break;
        }
        case 9: {
          n.isolateStyles = g.bool();
          break;
        }
        case 10: {
          n.json = g.string();
          break;
        }
        case 11: {
          n.arrowData = $root.ArrowData.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.bytes = g.bytes();
          break;
        }
        case 13: {
          n.mixed = $root.MixedData.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.BidiComponent) return g;
    let E = new $root.BidiComponent();
    if (g.id != null && (E.id = String(g.id)), g.componentName != null && (E.componentName = String(g.componentName)), g.jsContent != null && (E.jsContent = String(g.jsContent)), g.jsSourcePath != null && (E.jsSourcePath = String(g.jsSourcePath)), g.formId != null && (E.formId = String(g.formId)), g.htmlContent != null && (E.htmlContent = String(g.htmlContent)), g.cssContent != null && (E.cssContent = String(g.cssContent)), g.cssSourcePath != null && (E.cssSourcePath = String(g.cssSourcePath)), g.isolateStyles != null && (E.isolateStyles = !!g.isolateStyles), g.json != null && (E.json = String(g.json)), g.arrowData != null) {
      if (typeof g.arrowData != "object") throw TypeError(".BidiComponent.arrowData: object expected");
      E.arrowData = $root.ArrowData.fromObject(g.arrowData);
    }
    if (g.bytes != null && (typeof g.bytes == "string" ? $util.base64.decode(g.bytes, E.bytes = $util.newBuffer($util.base64.length(g.bytes)), 0) : g.bytes.length >= 0 && (E.bytes = g.bytes)), g.mixed != null) {
      if (typeof g.mixed != "object") throw TypeError(".BidiComponent.mixed: object expected");
      E.mixed = $root.MixedData.fromObject(g.mixed);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.componentName = "", e.formId = "", e.isolateStyles = !1), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.componentName != null && g.hasOwnProperty("componentName") && (e.componentName = g.componentName), g.jsContent != null && g.hasOwnProperty("jsContent") && (e.jsContent = g.jsContent, E.oneofs && (e._jsContent = "jsContent")), g.jsSourcePath != null && g.hasOwnProperty("jsSourcePath") && (e.jsSourcePath = g.jsSourcePath, E.oneofs && (e._jsSourcePath = "jsSourcePath")), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.htmlContent != null && g.hasOwnProperty("htmlContent") && (e.htmlContent = g.htmlContent, E.oneofs && (e._htmlContent = "htmlContent")), g.cssContent != null && g.hasOwnProperty("cssContent") && (e.cssContent = g.cssContent, E.oneofs && (e._cssContent = "cssContent")), g.cssSourcePath != null && g.hasOwnProperty("cssSourcePath") && (e.cssSourcePath = g.cssSourcePath, E.oneofs && (e._cssSourcePath = "cssSourcePath")), g.isolateStyles != null && g.hasOwnProperty("isolateStyles") && (e.isolateStyles = g.isolateStyles), g.json != null && g.hasOwnProperty("json") && (e.json = g.json, E.oneofs && (e.data = "json")), g.arrowData != null && g.hasOwnProperty("arrowData") && (e.arrowData = $root.ArrowData.toObject(g.arrowData, E), E.oneofs && (e.data = "arrowData")), g.bytes != null && g.hasOwnProperty("bytes") && (e.bytes = E.bytes === String ? $util.base64.encode(g.bytes, 0, g.bytes.length) : E.bytes === Array ? Array.prototype.slice.call(g.bytes) : g.bytes, E.oneofs && (e.data = "bytes")), g.mixed != null && g.hasOwnProperty("mixed") && (e.mixed = $root.MixedData.toObject(g.mixed, E), E.oneofs && (e.data = "mixed")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BidiComponent";
  }, o;
})();
$root.Block = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.vertical = null, o.prototype.horizontal = null, o.prototype.column = null, o.prototype.expandable = null, o.prototype.form = null, o.prototype.tabContainer = null, o.prototype.tab = null, o.prototype.chatMessage = null, o.prototype.popover = null, o.prototype.dialog = null, o.prototype.flexContainer = null, o.prototype.allowEmpty = !1, o.prototype.id = null, o.prototype.heightConfig = null, o.prototype.widthConfig = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_id", { get: $util.oneOfGetter(i = ["id"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_heightConfig", { get: $util.oneOfGetter(i = ["heightConfig"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_widthConfig", { get: $util.oneOfGetter(i = ["widthConfig"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.vertical != null && Object.hasOwnProperty.call(g, "vertical") && $root.Block.Vertical.encode(g.vertical, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.horizontal != null && Object.hasOwnProperty.call(g, "horizontal") && $root.Block.Horizontal.encode(g.horizontal, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.column != null && Object.hasOwnProperty.call(g, "column") && $root.Block.Column.encode(g.column, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.expandable != null && Object.hasOwnProperty.call(g, "expandable") && $root.Block.Expandable.encode(g.expandable, E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.form != null && Object.hasOwnProperty.call(g, "form") && $root.Block.Form.encode(g.form, E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.tabContainer != null && Object.hasOwnProperty.call(g, "tabContainer") && $root.Block.TabContainer.encode(g.tabContainer, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.tab != null && Object.hasOwnProperty.call(g, "tab") && $root.Block.Tab.encode(g.tab, E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.allowEmpty != null && Object.hasOwnProperty.call(g, "allowEmpty") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.allowEmpty), g.chatMessage != null && Object.hasOwnProperty.call(g, "chatMessage") && $root.Block.ChatMessage.encode(g.chatMessage, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.popover != null && Object.hasOwnProperty.call(g, "popover") && $root.Block.Popover.encode(g.popover, E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.dialog != null && Object.hasOwnProperty.call(g, "dialog") && $root.Block.Dialog.encode(g.dialog, E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.id), g.flexContainer != null && Object.hasOwnProperty.call(g, "flexContainer") && $root.Block.FlexContainer.encode(g.flexContainer, E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.heightConfig != null && Object.hasOwnProperty.call(g, "heightConfig") && $root.streamlit.HeightConfig.encode(g.heightConfig, E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root.streamlit.WidthConfig.encode(g.widthConfig, E.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Block();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.vertical = $root.Block.Vertical.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.horizontal = $root.Block.Horizontal.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.column = $root.Block.Column.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.expandable = $root.Block.Expandable.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.form = $root.Block.Form.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.tabContainer = $root.Block.TabContainer.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.tab = $root.Block.Tab.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.chatMessage = $root.Block.ChatMessage.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.popover = $root.Block.Popover.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.dialog = $root.Block.Dialog.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.flexContainer = $root.Block.FlexContainer.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.allowEmpty = g.bool();
          break;
        }
        case 12: {
          n.id = g.string();
          break;
        }
        case 14: {
          n.heightConfig = $root.streamlit.HeightConfig.decode(g, g.uint32());
          break;
        }
        case 15: {
          n.widthConfig = $root.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Block) return g;
    let E = new $root.Block();
    if (g.vertical != null) {
      if (typeof g.vertical != "object") throw TypeError(".Block.vertical: object expected");
      E.vertical = $root.Block.Vertical.fromObject(g.vertical);
    }
    if (g.horizontal != null) {
      if (typeof g.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
      E.horizontal = $root.Block.Horizontal.fromObject(g.horizontal);
    }
    if (g.column != null) {
      if (typeof g.column != "object") throw TypeError(".Block.column: object expected");
      E.column = $root.Block.Column.fromObject(g.column);
    }
    if (g.expandable != null) {
      if (typeof g.expandable != "object") throw TypeError(".Block.expandable: object expected");
      E.expandable = $root.Block.Expandable.fromObject(g.expandable);
    }
    if (g.form != null) {
      if (typeof g.form != "object") throw TypeError(".Block.form: object expected");
      E.form = $root.Block.Form.fromObject(g.form);
    }
    if (g.tabContainer != null) {
      if (typeof g.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
      E.tabContainer = $root.Block.TabContainer.fromObject(g.tabContainer);
    }
    if (g.tab != null) {
      if (typeof g.tab != "object") throw TypeError(".Block.tab: object expected");
      E.tab = $root.Block.Tab.fromObject(g.tab);
    }
    if (g.chatMessage != null) {
      if (typeof g.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
      E.chatMessage = $root.Block.ChatMessage.fromObject(g.chatMessage);
    }
    if (g.popover != null) {
      if (typeof g.popover != "object") throw TypeError(".Block.popover: object expected");
      E.popover = $root.Block.Popover.fromObject(g.popover);
    }
    if (g.dialog != null) {
      if (typeof g.dialog != "object") throw TypeError(".Block.dialog: object expected");
      E.dialog = $root.Block.Dialog.fromObject(g.dialog);
    }
    if (g.flexContainer != null) {
      if (typeof g.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
      E.flexContainer = $root.Block.FlexContainer.fromObject(g.flexContainer);
    }
    if (g.allowEmpty != null && (E.allowEmpty = !!g.allowEmpty), g.id != null && (E.id = String(g.id)), g.heightConfig != null) {
      if (typeof g.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
      E.heightConfig = $root.streamlit.HeightConfig.fromObject(g.heightConfig);
    }
    if (g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
      E.widthConfig = $root.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.allowEmpty = !1), g.vertical != null && g.hasOwnProperty("vertical") && (e.vertical = $root.Block.Vertical.toObject(g.vertical, E), E.oneofs && (e.type = "vertical")), g.horizontal != null && g.hasOwnProperty("horizontal") && (e.horizontal = $root.Block.Horizontal.toObject(g.horizontal, E), E.oneofs && (e.type = "horizontal")), g.column != null && g.hasOwnProperty("column") && (e.column = $root.Block.Column.toObject(g.column, E), E.oneofs && (e.type = "column")), g.expandable != null && g.hasOwnProperty("expandable") && (e.expandable = $root.Block.Expandable.toObject(g.expandable, E), E.oneofs && (e.type = "expandable")), g.form != null && g.hasOwnProperty("form") && (e.form = $root.Block.Form.toObject(g.form, E), E.oneofs && (e.type = "form")), g.tabContainer != null && g.hasOwnProperty("tabContainer") && (e.tabContainer = $root.Block.TabContainer.toObject(g.tabContainer, E), E.oneofs && (e.type = "tabContainer")), g.tab != null && g.hasOwnProperty("tab") && (e.tab = $root.Block.Tab.toObject(g.tab, E), E.oneofs && (e.type = "tab")), g.allowEmpty != null && g.hasOwnProperty("allowEmpty") && (e.allowEmpty = g.allowEmpty), g.chatMessage != null && g.hasOwnProperty("chatMessage") && (e.chatMessage = $root.Block.ChatMessage.toObject(g.chatMessage, E), E.oneofs && (e.type = "chatMessage")), g.popover != null && g.hasOwnProperty("popover") && (e.popover = $root.Block.Popover.toObject(g.popover, E), E.oneofs && (e.type = "popover")), g.dialog != null && g.hasOwnProperty("dialog") && (e.dialog = $root.Block.Dialog.toObject(g.dialog, E), E.oneofs && (e.type = "dialog")), g.id != null && g.hasOwnProperty("id") && (e.id = g.id, E.oneofs && (e._id = "id")), g.flexContainer != null && g.hasOwnProperty("flexContainer") && (e.flexContainer = $root.Block.FlexContainer.toObject(g.flexContainer, E), E.oneofs && (e.type = "flexContainer")), g.heightConfig != null && g.hasOwnProperty("heightConfig") && (e.heightConfig = $root.streamlit.HeightConfig.toObject(g.heightConfig, E), E.oneofs && (e._heightConfig = "heightConfig")), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(g.widthConfig, E), E.oneofs && (e._widthConfig = "widthConfig")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Block";
  }, o.Vertical = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.border = !1, g.prototype.height = 0, g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.border != null && Object.hasOwnProperty.call(E, "border") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(E.border), E.height != null && Object.hasOwnProperty.call(E, "height") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(E.height), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.Block.Vertical();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.border = E.bool();
            break;
          }
          case 2: {
            h.height = E.uint32();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.Block.Vertical) return E;
      let e = new $root.Block.Vertical();
      return E.border != null && (e.border = !!E.border), E.height != null && (e.height = E.height >>> 0), e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.border = !1, t.height = 0), E.border != null && E.hasOwnProperty("border") && (t.border = E.border), E.height != null && E.hasOwnProperty("height") && (t.height = E.height), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/Block.Vertical";
    }, g;
  })(), o.Horizontal = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.gap = "", g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.gap != null && Object.hasOwnProperty.call(E, "gap") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(E.gap), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.Block.Horizontal();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        d >>> 3 === 1 ? h.gap = E.string() : E.skipType(d & 7);
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.Block.Horizontal) return E;
      let e = new $root.Block.Horizontal();
      return E.gap != null && (e.gap = String(E.gap)), e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.gap = ""), E.gap != null && E.hasOwnProperty("gap") && (t.gap = E.gap), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/Block.Horizontal";
    }, g;
  })(), o.FlexContainer = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.border = !1, g.prototype.gapConfig = null, g.prototype.scale = 0, g.prototype.direction = 0, g.prototype.wrap = !1, g.prototype.justify = 0, g.prototype.align = 0, g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.border != null && Object.hasOwnProperty.call(E, "border") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(E.border), E.gapConfig != null && Object.hasOwnProperty.call(E, "gapConfig") && $root.streamlit.GapConfig.encode(E.gapConfig, e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), E.scale != null && Object.hasOwnProperty.call(E, "scale") && e.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(E.scale), E.direction != null && Object.hasOwnProperty.call(E, "direction") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(E.direction), E.wrap != null && Object.hasOwnProperty.call(E, "wrap") && e.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(E.wrap), E.justify != null && Object.hasOwnProperty.call(E, "justify") && e.uint32(
        /* id 7, wireType 0 =*/
        56
      ).int32(E.justify), E.align != null && Object.hasOwnProperty.call(E, "align") && e.uint32(
        /* id 8, wireType 0 =*/
        64
      ).int32(E.align), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.Block.FlexContainer();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.border = E.bool();
            break;
          }
          case 2: {
            h.gapConfig = $root.streamlit.GapConfig.decode(E, E.uint32());
            break;
          }
          case 3: {
            h.scale = E.float();
            break;
          }
          case 4: {
            h.direction = E.int32();
            break;
          }
          case 5: {
            h.wrap = E.bool();
            break;
          }
          case 7: {
            h.justify = E.int32();
            break;
          }
          case 8: {
            h.align = E.int32();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.Block.FlexContainer) return E;
      let e = new $root.Block.FlexContainer();
      if (E.border != null && (e.border = !!E.border), E.gapConfig != null) {
        if (typeof E.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        e.gapConfig = $root.streamlit.GapConfig.fromObject(E.gapConfig);
      }
      switch (E.scale != null && (e.scale = Number(E.scale)), E.direction) {
        default:
          if (typeof E.direction == "number") {
            e.direction = E.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          e.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          e.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          e.direction = 2;
          break;
      }
      switch (E.wrap != null && (e.wrap = !!E.wrap), E.justify) {
        default:
          if (typeof E.justify == "number") {
            e.justify = E.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          e.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          e.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          e.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          e.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          e.justify = 4;
          break;
      }
      switch (E.align) {
        default:
          if (typeof E.align == "number") {
            e.align = E.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          e.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          e.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          e.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          e.align = 3;
          break;
        case "STRETCH":
        case 4:
          e.align = 4;
          break;
      }
      return e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.border = !1, t.gapConfig = null, t.scale = 0, t.direction = e.enums === String ? "DIRECTION_UNDEFINED" : 0, t.wrap = !1, t.justify = e.enums === String ? "JUSTIFY_UNDEFINED" : 0, t.align = e.enums === String ? "ALIGN_UNDEFINED" : 0), E.border != null && E.hasOwnProperty("border") && (t.border = E.border), E.gapConfig != null && E.hasOwnProperty("gapConfig") && (t.gapConfig = $root.streamlit.GapConfig.toObject(E.gapConfig, e)), E.scale != null && E.hasOwnProperty("scale") && (t.scale = e.json && !isFinite(E.scale) ? String(E.scale) : E.scale), E.direction != null && E.hasOwnProperty("direction") && (t.direction = e.enums === String ? $root.Block.FlexContainer.Direction[E.direction] === void 0 ? E.direction : $root.Block.FlexContainer.Direction[E.direction] : E.direction), E.wrap != null && E.hasOwnProperty("wrap") && (t.wrap = E.wrap), E.justify != null && E.hasOwnProperty("justify") && (t.justify = e.enums === String ? $root.Block.FlexContainer.Justify[E.justify] === void 0 ? E.justify : $root.Block.FlexContainer.Justify[E.justify] : E.justify), E.align != null && E.hasOwnProperty("align") && (t.align = e.enums === String ? $root.Block.FlexContainer.Align[E.align] === void 0 ? E.align : $root.Block.FlexContainer.Align[E.align] : E.align), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/Block.FlexContainer";
    }, g.Direction = (function() {
      const E = {}, e = Object.create(E);
      return e[E[0] = "DIRECTION_UNDEFINED"] = 0, e[E[1] = "VERTICAL"] = 1, e[E[2] = "HORIZONTAL"] = 2, e;
    })(), g.Justify = (function() {
      const E = {}, e = Object.create(E);
      return e[E[0] = "JUSTIFY_UNDEFINED"] = 0, e[E[1] = "JUSTIFY_START"] = 1, e[E[2] = "JUSTIFY_END"] = 2, e[E[3] = "JUSTIFY_CENTER"] = 3, e[E[4] = "SPACE_BETWEEN"] = 4, e;
    })(), g.Align = (function() {
      const E = {}, e = Object.create(E);
      return e[E[0] = "ALIGN_UNDEFINED"] = 0, e[E[1] = "ALIGN_START"] = 1, e[E[2] = "ALIGN_END"] = 2, e[E[3] = "ALIGN_CENTER"] = 3, e[E[4] = "STRETCH"] = 4, e;
    })(), g;
  })(), o.Column = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.weight = 0, g.prototype.gap = "", g.prototype.verticalAlignment = 0, g.prototype.showBorder = !1, g.prototype.gapConfig = null;
    let E;
    return Object.defineProperty(g.prototype, "_gapConfig", { get: $util.oneOfGetter(E = ["gapConfig"]), set: $util.oneOfSetter(E) }), g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer.create()), e.weight != null && Object.hasOwnProperty.call(e, "weight") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.weight), e.gap != null && Object.hasOwnProperty.call(e, "gap") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.gap), e.verticalAlignment != null && Object.hasOwnProperty.call(e, "verticalAlignment") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.verticalAlignment), e.showBorder != null && Object.hasOwnProperty.call(e, "showBorder") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.showBorder), e.gapConfig != null && Object.hasOwnProperty.call(e, "gapConfig") && $root.streamlit.GapConfig.encode(e.gapConfig, t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root.Block.Column();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.weight = e.double();
            break;
          }
          case 2: {
            d.gap = e.string();
            break;
          }
          case 3: {
            d.verticalAlignment = e.int32();
            break;
          }
          case 4: {
            d.showBorder = e.bool();
            break;
          }
          case 5: {
            d.gapConfig = $root.streamlit.GapConfig.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root.Block.Column) return e;
      let t = new $root.Block.Column();
      switch (e.weight != null && (t.weight = Number(e.weight)), e.gap != null && (t.gap = String(e.gap)), e.verticalAlignment) {
        default:
          if (typeof e.verticalAlignment == "number") {
            t.verticalAlignment = e.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          t.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          t.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          t.verticalAlignment = 2;
          break;
      }
      if (e.showBorder != null && (t.showBorder = !!e.showBorder), e.gapConfig != null) {
        if (typeof e.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
        t.gapConfig = $root.streamlit.GapConfig.fromObject(e.gapConfig);
      }
      return t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.weight = 0, n.gap = "", n.verticalAlignment = t.enums === String ? "TOP" : 0, n.showBorder = !1), e.weight != null && e.hasOwnProperty("weight") && (n.weight = t.json && !isFinite(e.weight) ? String(e.weight) : e.weight), e.gap != null && e.hasOwnProperty("gap") && (n.gap = e.gap), e.verticalAlignment != null && e.hasOwnProperty("verticalAlignment") && (n.verticalAlignment = t.enums === String ? $root.Block.Column.VerticalAlignment[e.verticalAlignment] === void 0 ? e.verticalAlignment : $root.Block.Column.VerticalAlignment[e.verticalAlignment] : e.verticalAlignment), e.showBorder != null && e.hasOwnProperty("showBorder") && (n.showBorder = e.showBorder), e.gapConfig != null && e.hasOwnProperty("gapConfig") && (n.gapConfig = $root.streamlit.GapConfig.toObject(e.gapConfig, t), t.oneofs && (n._gapConfig = "gapConfig")), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Column";
    }, g.VerticalAlignment = (function() {
      const e = {}, t = Object.create(e);
      return t[e[0] = "TOP"] = 0, t[e[1] = "CENTER"] = 1, t[e[2] = "BOTTOM"] = 2, t;
    })(), g;
  })(), o.Expandable = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.label = "", g.prototype.expanded = null, g.prototype.icon = "";
    let E;
    return Object.defineProperty(g.prototype, "_expanded", { get: $util.oneOfGetter(E = ["expanded"]), set: $util.oneOfSetter(E) }), g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer.create()), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.label), e.expanded != null && Object.hasOwnProperty.call(e, "expanded") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.expanded), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.icon), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root.Block.Expandable();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.label = e.string();
            break;
          }
          case 2: {
            d.expanded = e.bool();
            break;
          }
          case 3: {
            d.icon = e.string();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root.Block.Expandable) return e;
      let t = new $root.Block.Expandable();
      return e.label != null && (t.label = String(e.label)), e.expanded != null && (t.expanded = !!e.expanded), e.icon != null && (t.icon = String(e.icon)), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.label = "", n.icon = ""), e.label != null && e.hasOwnProperty("label") && (n.label = e.label), e.expanded != null && e.hasOwnProperty("expanded") && (n.expanded = e.expanded, t.oneofs && (n._expanded = "expanded")), e.icon != null && e.hasOwnProperty("icon") && (n.icon = e.icon), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Expandable";
    }, g;
  })(), o.Dialog = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.title = "", g.prototype.dismissible = !1, g.prototype.width = 0, g.prototype.isOpen = null, g.prototype.id = "", g.prototype.icon = "";
    let E;
    return Object.defineProperty(g.prototype, "_isOpen", { get: $util.oneOfGetter(E = ["isOpen"]), set: $util.oneOfSetter(E) }), g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer.create()), e.title != null && Object.hasOwnProperty.call(e, "title") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.title), e.dismissible != null && Object.hasOwnProperty.call(e, "dismissible") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.dismissible), e.width != null && Object.hasOwnProperty.call(e, "width") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.width), e.isOpen != null && Object.hasOwnProperty.call(e, "isOpen") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.isOpen), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.id), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(e.icon), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root.Block.Dialog();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.title = e.string();
            break;
          }
          case 2: {
            d.dismissible = e.bool();
            break;
          }
          case 3: {
            d.width = e.int32();
            break;
          }
          case 4: {
            d.isOpen = e.bool();
            break;
          }
          case 5: {
            d.id = e.string();
            break;
          }
          case 6: {
            d.icon = e.string();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root.Block.Dialog) return e;
      let t = new $root.Block.Dialog();
      switch (e.title != null && (t.title = String(e.title)), e.dismissible != null && (t.dismissible = !!e.dismissible), e.width) {
        default:
          if (typeof e.width == "number") {
            t.width = e.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          t.width = 0;
          break;
        case "LARGE":
        case 1:
          t.width = 1;
          break;
        case "MEDIUM":
        case 2:
          t.width = 2;
          break;
      }
      return e.isOpen != null && (t.isOpen = !!e.isOpen), e.id != null && (t.id = String(e.id)), e.icon != null && (t.icon = String(e.icon)), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.title = "", n.dismissible = !1, n.width = t.enums === String ? "SMALL" : 0, n.id = "", n.icon = ""), e.title != null && e.hasOwnProperty("title") && (n.title = e.title), e.dismissible != null && e.hasOwnProperty("dismissible") && (n.dismissible = e.dismissible), e.width != null && e.hasOwnProperty("width") && (n.width = t.enums === String ? $root.Block.Dialog.DialogWidth[e.width] === void 0 ? e.width : $root.Block.Dialog.DialogWidth[e.width] : e.width), e.isOpen != null && e.hasOwnProperty("isOpen") && (n.isOpen = e.isOpen, t.oneofs && (n._isOpen = "isOpen")), e.id != null && e.hasOwnProperty("id") && (n.id = e.id), e.icon != null && e.hasOwnProperty("icon") && (n.icon = e.icon), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Dialog";
    }, g.DialogWidth = (function() {
      const e = {}, t = Object.create(e);
      return t[e[0] = "SMALL"] = 0, t[e[1] = "LARGE"] = 1, t[e[2] = "MEDIUM"] = 2, t;
    })(), g;
  })(), o.Form = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.formId = "", g.prototype.clearOnSubmit = !1, g.prototype.border = !1, g.prototype.enterToSubmit = !1, g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.formId != null && Object.hasOwnProperty.call(E, "formId") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(E.formId), E.clearOnSubmit != null && Object.hasOwnProperty.call(E, "clearOnSubmit") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(E.clearOnSubmit), E.border != null && Object.hasOwnProperty.call(E, "border") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(E.border), E.enterToSubmit != null && Object.hasOwnProperty.call(E, "enterToSubmit") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(E.enterToSubmit), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.Block.Form();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.formId = E.string();
            break;
          }
          case 2: {
            h.clearOnSubmit = E.bool();
            break;
          }
          case 3: {
            h.border = E.bool();
            break;
          }
          case 4: {
            h.enterToSubmit = E.bool();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.Block.Form) return E;
      let e = new $root.Block.Form();
      return E.formId != null && (e.formId = String(E.formId)), E.clearOnSubmit != null && (e.clearOnSubmit = !!E.clearOnSubmit), E.border != null && (e.border = !!E.border), E.enterToSubmit != null && (e.enterToSubmit = !!E.enterToSubmit), e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.formId = "", t.clearOnSubmit = !1, t.border = !1, t.enterToSubmit = !1), E.formId != null && E.hasOwnProperty("formId") && (t.formId = E.formId), E.clearOnSubmit != null && E.hasOwnProperty("clearOnSubmit") && (t.clearOnSubmit = E.clearOnSubmit), E.border != null && E.hasOwnProperty("border") && (t.border = E.border), E.enterToSubmit != null && E.hasOwnProperty("enterToSubmit") && (t.enterToSubmit = E.enterToSubmit), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/Block.Form";
    }, g;
  })(), o.TabContainer = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.defaultTabIndex = 0, g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.defaultTabIndex != null && Object.hasOwnProperty.call(E, "defaultTabIndex") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(E.defaultTabIndex), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.Block.TabContainer();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        d >>> 3 === 1 ? h.defaultTabIndex = E.int32() : E.skipType(d & 7);
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.Block.TabContainer) return E;
      let e = new $root.Block.TabContainer();
      return E.defaultTabIndex != null && (e.defaultTabIndex = E.defaultTabIndex | 0), e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.defaultTabIndex = 0), E.defaultTabIndex != null && E.hasOwnProperty("defaultTabIndex") && (t.defaultTabIndex = E.defaultTabIndex), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/Block.TabContainer";
    }, g;
  })(), o.Tab = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.label = "", g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(E.label), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.Block.Tab();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        d >>> 3 === 1 ? h.label = E.string() : E.skipType(d & 7);
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.Block.Tab) return E;
      let e = new $root.Block.Tab();
      return E.label != null && (e.label = String(E.label)), e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.label = ""), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/Block.Tab";
    }, g;
  })(), o.Popover = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.label = "", g.prototype.useContainerWidth = !1, g.prototype.help = "", g.prototype.disabled = !1, g.prototype.icon = "", g.prototype.type = "", g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.label != null && Object.hasOwnProperty.call(E, "label") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(E.label), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(E.useContainerWidth), E.help != null && Object.hasOwnProperty.call(E, "help") && e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(E.help), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(E.disabled), E.icon != null && Object.hasOwnProperty.call(E, "icon") && e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(E.icon), E.type != null && Object.hasOwnProperty.call(E, "type") && e.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(E.type), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.Block.Popover();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.label = E.string();
            break;
          }
          case 2: {
            h.useContainerWidth = E.bool();
            break;
          }
          case 3: {
            h.help = E.string();
            break;
          }
          case 4: {
            h.disabled = E.bool();
            break;
          }
          case 5: {
            h.icon = E.string();
            break;
          }
          case 6: {
            h.type = E.string();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.Block.Popover) return E;
      let e = new $root.Block.Popover();
      return E.label != null && (e.label = String(E.label)), E.useContainerWidth != null && (e.useContainerWidth = !!E.useContainerWidth), E.help != null && (e.help = String(E.help)), E.disabled != null && (e.disabled = !!E.disabled), E.icon != null && (e.icon = String(E.icon)), E.type != null && (e.type = String(E.type)), e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.label = "", t.useContainerWidth = !1, t.help = "", t.disabled = !1, t.icon = "", t.type = ""), E.label != null && E.hasOwnProperty("label") && (t.label = E.label), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = E.useContainerWidth), E.help != null && E.hasOwnProperty("help") && (t.help = E.help), E.disabled != null && E.hasOwnProperty("disabled") && (t.disabled = E.disabled), E.icon != null && E.hasOwnProperty("icon") && (t.icon = E.icon), E.type != null && E.hasOwnProperty("type") && (t.type = E.type), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/Block.Popover";
    }, g;
  })(), o.ChatMessage = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.name = "", g.prototype.avatar = "", g.prototype.avatarType = 0, g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.name != null && Object.hasOwnProperty.call(E, "name") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(E.name), E.avatar != null && Object.hasOwnProperty.call(E, "avatar") && e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(E.avatar), E.avatarType != null && Object.hasOwnProperty.call(E, "avatarType") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(E.avatarType), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.Block.ChatMessage();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.name = E.string();
            break;
          }
          case 2: {
            h.avatar = E.string();
            break;
          }
          case 3: {
            h.avatarType = E.int32();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.Block.ChatMessage) return E;
      let e = new $root.Block.ChatMessage();
      switch (E.name != null && (e.name = String(E.name)), E.avatar != null && (e.avatar = String(E.avatar)), E.avatarType) {
        default:
          if (typeof E.avatarType == "number") {
            e.avatarType = E.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          e.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          e.avatarType = 1;
          break;
        case "ICON":
        case 2:
          e.avatarType = 2;
          break;
      }
      return e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.name = "", t.avatar = "", t.avatarType = e.enums === String ? "IMAGE" : 0), E.name != null && E.hasOwnProperty("name") && (t.name = E.name), E.avatar != null && E.hasOwnProperty("avatar") && (t.avatar = E.avatar), E.avatarType != null && E.hasOwnProperty("avatarType") && (t.avatarType = e.enums === String ? $root.Block.ChatMessage.AvatarType[E.avatarType] === void 0 ? E.avatarType : $root.Block.ChatMessage.AvatarType[E.avatarType] : E.avatarType), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/Block.ChatMessage";
    }, g.AvatarType = (function() {
      const E = {}, e = Object.create(E);
      return e[E[0] = "IMAGE"] = 0, e[E[1] = "EMOJI"] = 1, e[E[2] = "ICON"] = 2, e;
    })(), g;
  })(), o;
})();
$root.BokehChart = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.figure = "", o.prototype.useContainerWidth = !1, o.prototype.elementId = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.figure != null && Object.hasOwnProperty.call(i, "figure") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.figure), i.useContainerWidth != null && Object.hasOwnProperty.call(i, "useContainerWidth") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(i.useContainerWidth), i.elementId != null && Object.hasOwnProperty.call(i, "elementId") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.elementId), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.BokehChart();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.figure = i.string();
          break;
        }
        case 2: {
          t.useContainerWidth = i.bool();
          break;
        }
        case 3: {
          t.elementId = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.BokehChart) return i;
    let g = new $root.BokehChart();
    return i.figure != null && (g.figure = String(i.figure)), i.useContainerWidth != null && (g.useContainerWidth = !!i.useContainerWidth), i.elementId != null && (g.elementId = String(i.elementId)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.figure = "", E.useContainerWidth = !1, E.elementId = ""), i.figure != null && i.hasOwnProperty("figure") && (E.figure = i.figure), i.useContainerWidth != null && i.hasOwnProperty("useContainerWidth") && (E.useContainerWidth = i.useContainerWidth), i.elementId != null && i.hasOwnProperty("elementId") && (E.elementId = i.elementId), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/BokehChart";
  }, o;
})();
$root.Button = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.isFormSubmitter = !1, o.prototype.type = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.icon = "", o.prototype.shortcut = "", o.prototype.iconPosition = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.label), i.default != null && Object.hasOwnProperty.call(i, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.default), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.help), i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.formId), i.isFormSubmitter != null && Object.hasOwnProperty.call(i, "isFormSubmitter") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(i.isFormSubmitter), i.type != null && Object.hasOwnProperty.call(i, "type") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.type), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(i.disabled), i.useContainerWidth != null && Object.hasOwnProperty.call(i, "useContainerWidth") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(i.useContainerWidth), i.icon != null && Object.hasOwnProperty.call(i, "icon") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(i.icon), i.shortcut != null && Object.hasOwnProperty.call(i, "shortcut") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(i.shortcut), i.iconPosition != null && Object.hasOwnProperty.call(i, "iconPosition") && g.uint32(
      /* id 12, wireType 0 =*/
      96
    ).int32(i.iconPosition), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Button();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.label = i.string();
          break;
        }
        case 3: {
          t.default = i.bool();
          break;
        }
        case 4: {
          t.help = i.string();
          break;
        }
        case 5: {
          t.formId = i.string();
          break;
        }
        case 6: {
          t.isFormSubmitter = i.bool();
          break;
        }
        case 7: {
          t.type = i.string();
          break;
        }
        case 8: {
          t.disabled = i.bool();
          break;
        }
        case 9: {
          t.useContainerWidth = i.bool();
          break;
        }
        case 10: {
          t.icon = i.string();
          break;
        }
        case 11: {
          t.shortcut = i.string();
          break;
        }
        case 12: {
          t.iconPosition = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Button) return i;
    let g = new $root.Button();
    switch (i.id != null && (g.id = String(i.id)), i.label != null && (g.label = String(i.label)), i.default != null && (g.default = !!i.default), i.help != null && (g.help = String(i.help)), i.formId != null && (g.formId = String(i.formId)), i.isFormSubmitter != null && (g.isFormSubmitter = !!i.isFormSubmitter), i.type != null && (g.type = String(i.type)), i.disabled != null && (g.disabled = !!i.disabled), i.useContainerWidth != null && (g.useContainerWidth = !!i.useContainerWidth), i.icon != null && (g.icon = String(i.icon)), i.shortcut != null && (g.shortcut = String(i.shortcut)), i.iconPosition) {
      default:
        if (typeof i.iconPosition == "number") {
          g.iconPosition = i.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        g.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        g.iconPosition = 1;
        break;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.id = "", E.label = "", E.default = !1, E.help = "", E.formId = "", E.isFormSubmitter = !1, E.type = "", E.disabled = !1, E.useContainerWidth = !1, E.icon = "", E.shortcut = "", E.iconPosition = g.enums === String ? "LEFT" : 0), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.default != null && i.hasOwnProperty("default") && (E.default = i.default), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), i.isFormSubmitter != null && i.hasOwnProperty("isFormSubmitter") && (E.isFormSubmitter = i.isFormSubmitter), i.type != null && i.hasOwnProperty("type") && (E.type = i.type), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.useContainerWidth != null && i.hasOwnProperty("useContainerWidth") && (E.useContainerWidth = i.useContainerWidth), i.icon != null && i.hasOwnProperty("icon") && (E.icon = i.icon), i.shortcut != null && i.hasOwnProperty("shortcut") && (E.shortcut = i.shortcut), i.iconPosition != null && i.hasOwnProperty("iconPosition") && (E.iconPosition = g.enums === String ? $root.streamlit.ButtonLikeIconPosition[i.iconPosition] === void 0 ? i.iconPosition : $root.streamlit.ButtonLikeIconPosition[i.iconPosition] : i.iconPosition), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Button";
  }, o;
})();
$root.ButtonGroup = (() => {
  function o(g) {
    if (this.options = [], this.default = [], this.value = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.options = $util.emptyArray, o.prototype.default = $util.emptyArray, o.prototype.disabled = !1, o.prototype.clickMode = 0, o.prototype.formId = "", o.prototype.value = $util.emptyArray, o.prototype.setValue = !1, o.prototype.selectionVisualization = 0, o.prototype.style = 0, o.prototype.label = "", o.prototype.labelVisibility = null, o.prototype.help = null;
  let i;
  return Object.defineProperty(o.prototype, "_help", { get: $util.oneOfGetter(i = ["help"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.options != null && g.options.length) for (let e = 0; e < g.options.length; ++e) $root.ButtonGroup.Option.encode(g.options[e], E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    if (g.default != null && g.default.length) {
      E.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let e = 0; e < g.default.length; ++e) E.uint32(g.default[e]);
      E.ldelim();
    }
    if (g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.disabled), g.clickMode != null && Object.hasOwnProperty.call(g, "clickMode") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.clickMode), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && g.value.length) {
      E.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let e = 0; e < g.value.length; ++e) E.uint32(g.value[e]);
      E.ldelim();
    }
    return g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.selectionVisualization != null && Object.hasOwnProperty.call(g, "selectionVisualization") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(g.selectionVisualization), g.style != null && Object.hasOwnProperty.call(g, "style") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(g.style), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.label), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.help), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.ButtonGroup();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.options && n.options.length || (n.options = []), n.options.push($root.ButtonGroup.Option.decode(g, g.uint32()));
          break;
        }
        case 3: {
          if (n.default && n.default.length || (n.default = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.default.push(g.uint32());
          } else n.default.push(g.uint32());
          break;
        }
        case 4: {
          n.disabled = g.bool();
          break;
        }
        case 5: {
          n.clickMode = g.int32();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          if (n.value && n.value.length || (n.value = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.value.push(g.uint32());
          } else n.value.push(g.uint32());
          break;
        }
        case 8: {
          n.setValue = g.bool();
          break;
        }
        case 9: {
          n.selectionVisualization = g.int32();
          break;
        }
        case 10: {
          n.style = g.int32();
          break;
        }
        case 11: {
          n.label = g.string();
          break;
        }
        case 12: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.help = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.ButtonGroup) return g;
    let E = new $root.ButtonGroup();
    if (g.id != null && (E.id = String(g.id)), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".ButtonGroup.options: array expected");
      E.options = [];
      for (let e = 0; e < g.options.length; ++e) {
        if (typeof g.options[e] != "object") throw TypeError(".ButtonGroup.options: object expected");
        E.options[e] = $root.ButtonGroup.Option.fromObject(g.options[e]);
      }
    }
    if (g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".ButtonGroup.default: array expected");
      E.default = [];
      for (let e = 0; e < g.default.length; ++e) E.default[e] = g.default[e] >>> 0;
    }
    switch (g.disabled != null && (E.disabled = !!g.disabled), g.clickMode) {
      default:
        if (typeof g.clickMode == "number") {
          E.clickMode = g.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        E.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        E.clickMode = 1;
        break;
    }
    if (g.formId != null && (E.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".ButtonGroup.value: array expected");
      E.value = [];
      for (let e = 0; e < g.value.length; ++e) E.value[e] = g.value[e] >>> 0;
    }
    switch (g.setValue != null && (E.setValue = !!g.setValue), g.selectionVisualization) {
      default:
        if (typeof g.selectionVisualization == "number") {
          E.selectionVisualization = g.selectionVisualization;
          break;
        }
        break;
      case "ONLY_SELECTED":
      case 0:
        E.selectionVisualization = 0;
        break;
      case "ALL_UP_TO_SELECTED":
      case 1:
        E.selectionVisualization = 1;
        break;
    }
    switch (g.style) {
      default:
        if (typeof g.style == "number") {
          E.style = g.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        E.style = 0;
        break;
      case "PILLS":
      case 1:
        E.style = 1;
        break;
      case "BORDERLESS":
      case 2:
        E.style = 2;
        break;
    }
    if (g.label != null && (E.label = String(g.label)), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.help != null && (E.help = String(g.help)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.options = [], e.default = [], e.value = []), E.defaults && (e.id = "", e.disabled = !1, e.clickMode = E.enums === String ? "SINGLE_SELECT" : 0, e.formId = "", e.setValue = !1, e.selectionVisualization = E.enums === String ? "ONLY_SELECTED" : 0, e.style = E.enums === String ? "SEGMENTED_CONTROL" : 0, e.label = "", e.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.options && g.options.length) {
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) e.options[t] = $root.ButtonGroup.Option.toObject(g.options[t], E);
    }
    if (g.default && g.default.length) {
      e.default = [];
      for (let t = 0; t < g.default.length; ++t) e.default[t] = g.default[t];
    }
    if (g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.clickMode != null && g.hasOwnProperty("clickMode") && (e.clickMode = E.enums === String ? $root.ButtonGroup.ClickMode[g.clickMode] === void 0 ? g.clickMode : $root.ButtonGroup.ClickMode[g.clickMode] : g.clickMode), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value && g.value.length) {
      e.value = [];
      for (let t = 0; t < g.value.length; ++t) e.value[t] = g.value[t];
    }
    return g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.selectionVisualization != null && g.hasOwnProperty("selectionVisualization") && (e.selectionVisualization = E.enums === String ? $root.ButtonGroup.SelectionVisualization[g.selectionVisualization] === void 0 ? g.selectionVisualization : $root.ButtonGroup.SelectionVisualization[g.selectionVisualization] : g.selectionVisualization), g.style != null && g.hasOwnProperty("style") && (e.style = E.enums === String ? $root.ButtonGroup.Style[g.style] === void 0 ? g.style : $root.ButtonGroup.Style[g.style] : g.style), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.help != null && g.hasOwnProperty("help") && (e.help = g.help, E.oneofs && (e._help = "help")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ButtonGroup";
  }, o.ClickMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "SINGLE_SELECT"] = 0, E[g[1] = "MULTI_SELECT"] = 1, E;
  })(), o.Option = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.content = "", g.prototype.selectedContent = null, g.prototype.contentIcon = null, g.prototype.selectedContentIcon = null;
    let E;
    return Object.defineProperty(g.prototype, "_selectedContent", { get: $util.oneOfGetter(E = ["selectedContent"]), set: $util.oneOfSetter(E) }), Object.defineProperty(g.prototype, "_contentIcon", { get: $util.oneOfGetter(E = ["contentIcon"]), set: $util.oneOfSetter(E) }), Object.defineProperty(g.prototype, "_selectedContentIcon", { get: $util.oneOfGetter(E = ["selectedContentIcon"]), set: $util.oneOfSetter(E) }), g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer.create()), e.content != null && Object.hasOwnProperty.call(e, "content") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.content), e.selectedContent != null && Object.hasOwnProperty.call(e, "selectedContent") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.selectedContent), e.contentIcon != null && Object.hasOwnProperty.call(e, "contentIcon") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.contentIcon), e.selectedContentIcon != null && Object.hasOwnProperty.call(e, "selectedContentIcon") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.selectedContentIcon), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root.ButtonGroup.Option();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.content = e.string();
            break;
          }
          case 2: {
            d.selectedContent = e.string();
            break;
          }
          case 3: {
            d.contentIcon = e.string();
            break;
          }
          case 4: {
            d.selectedContentIcon = e.string();
            break;
          }
          default:
            e.skipType(k & 7);
            break;
        }
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root.ButtonGroup.Option) return e;
      let t = new $root.ButtonGroup.Option();
      return e.content != null && (t.content = String(e.content)), e.selectedContent != null && (t.selectedContent = String(e.selectedContent)), e.contentIcon != null && (t.contentIcon = String(e.contentIcon)), e.selectedContentIcon != null && (t.selectedContentIcon = String(e.selectedContentIcon)), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return t.defaults && (n.content = ""), e.content != null && e.hasOwnProperty("content") && (n.content = e.content), e.selectedContent != null && e.hasOwnProperty("selectedContent") && (n.selectedContent = e.selectedContent, t.oneofs && (n._selectedContent = "selectedContent")), e.contentIcon != null && e.hasOwnProperty("contentIcon") && (n.contentIcon = e.contentIcon, t.oneofs && (n._contentIcon = "contentIcon")), e.selectedContentIcon != null && e.hasOwnProperty("selectedContentIcon") && (n.selectedContentIcon = e.selectedContentIcon, t.oneofs && (n._selectedContentIcon = "selectedContentIcon")), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/ButtonGroup.Option";
    }, g;
  })(), o.SelectionVisualization = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "ONLY_SELECTED"] = 0, E[g[1] = "ALL_UP_TO_SELECTED"] = 1, E;
  })(), o.Style = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "SEGMENTED_CONTROL"] = 0, E[g[1] = "PILLS"] = 1, E[g[2] = "BORDERLESS"] = 2, E;
  })(), o;
})();
$root.CameraInput = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.label), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.help), i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.formId), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(i.disabled), i.labelVisibility != null && Object.hasOwnProperty.call(i, "labelVisibility") && $root.LabelVisibilityMessage.encode(i.labelVisibility, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.CameraInput();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.label = i.string();
          break;
        }
        case 3: {
          t.help = i.string();
          break;
        }
        case 4: {
          t.formId = i.string();
          break;
        }
        case 5: {
          t.disabled = i.bool();
          break;
        }
        case 6: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.CameraInput) return i;
    let g = new $root.CameraInput();
    if (i.id != null && (g.id = String(i.id)), i.label != null && (g.label = String(i.label)), i.help != null && (g.help = String(i.help)), i.formId != null && (g.formId = String(i.formId)), i.disabled != null && (g.disabled = !!i.disabled), i.labelVisibility != null) {
      if (typeof i.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(i.labelVisibility);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.id = "", E.label = "", E.help = "", E.formId = "", E.disabled = !1, E.labelVisibility = null), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.labelVisibility != null && i.hasOwnProperty("labelVisibility") && (E.labelVisibility = $root.LabelVisibilityMessage.toObject(i.labelVisibility, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/CameraInput";
  }, o;
})();
$root.ChatInput = (() => {
  function o(g) {
    if (this.fileType = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.placeholder = "", o.prototype.maxChars = 0, o.prototype.disabled = !1, o.prototype.value = "", o.prototype.setValue = !1, o.prototype.default = "", o.prototype.position = 0, o.prototype.acceptFile = 0, o.prototype.fileType = $util.emptyArray, o.prototype.maxUploadSizeMb = 0, o.prototype.acceptAudio = !1, o.prototype.audioSampleRate = null;
  let i;
  return Object.defineProperty(o.prototype, "_audioSampleRate", { get: $util.oneOfGetter(i = ["audioSampleRate"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.placeholder), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(g.maxChars), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.disabled), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.setValue), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.default), g.position != null && Object.hasOwnProperty.call(g, "position") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.position), g.acceptFile != null && Object.hasOwnProperty.call(g, "acceptFile") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(g.acceptFile), g.fileType != null && g.fileType.length) for (let e = 0; e < g.fileType.length; ++e) E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.fileType[e]);
    return g.maxUploadSizeMb != null && Object.hasOwnProperty.call(g, "maxUploadSizeMb") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(g.maxUploadSizeMb), g.acceptAudio != null && Object.hasOwnProperty.call(g, "acceptAudio") && E.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.acceptAudio), g.audioSampleRate != null && Object.hasOwnProperty.call(g, "audioSampleRate") && E.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(g.audioSampleRate), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.ChatInput();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.placeholder = g.string();
          break;
        }
        case 3: {
          n.maxChars = g.uint32();
          break;
        }
        case 4: {
          n.disabled = g.bool();
          break;
        }
        case 5: {
          n.value = g.string();
          break;
        }
        case 6: {
          n.setValue = g.bool();
          break;
        }
        case 7: {
          n.default = g.string();
          break;
        }
        case 8: {
          n.position = g.int32();
          break;
        }
        case 9: {
          n.acceptFile = g.int32();
          break;
        }
        case 10: {
          n.fileType && n.fileType.length || (n.fileType = []), n.fileType.push(g.string());
          break;
        }
        case 11: {
          n.maxUploadSizeMb = g.int32();
          break;
        }
        case 12: {
          n.acceptAudio = g.bool();
          break;
        }
        case 13: {
          n.audioSampleRate = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.ChatInput) return g;
    let E = new $root.ChatInput();
    switch (g.id != null && (E.id = String(g.id)), g.placeholder != null && (E.placeholder = String(g.placeholder)), g.maxChars != null && (E.maxChars = g.maxChars >>> 0), g.disabled != null && (E.disabled = !!g.disabled), g.value != null && (E.value = String(g.value)), g.setValue != null && (E.setValue = !!g.setValue), g.default != null && (E.default = String(g.default)), g.position) {
      default:
        if (typeof g.position == "number") {
          E.position = g.position;
          break;
        }
        break;
      case "BOTTOM":
      case 0:
        E.position = 0;
        break;
    }
    switch (g.acceptFile) {
      default:
        if (typeof g.acceptFile == "number") {
          E.acceptFile = g.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        E.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        E.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        E.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        E.acceptFile = 3;
        break;
    }
    if (g.fileType) {
      if (!Array.isArray(g.fileType)) throw TypeError(".ChatInput.fileType: array expected");
      E.fileType = [];
      for (let e = 0; e < g.fileType.length; ++e) E.fileType[e] = String(g.fileType[e]);
    }
    return g.maxUploadSizeMb != null && (E.maxUploadSizeMb = g.maxUploadSizeMb | 0), g.acceptAudio != null && (E.acceptAudio = !!g.acceptAudio), g.audioSampleRate != null && (E.audioSampleRate = g.audioSampleRate | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.fileType = []), E.defaults && (e.id = "", e.placeholder = "", e.maxChars = 0, e.disabled = !1, e.value = "", e.setValue = !1, e.default = "", e.position = E.enums === String ? "BOTTOM" : 0, e.acceptFile = E.enums === String ? "NONE" : 0, e.maxUploadSizeMb = 0, e.acceptAudio = !1), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.placeholder != null && g.hasOwnProperty("placeholder") && (e.placeholder = g.placeholder), g.maxChars != null && g.hasOwnProperty("maxChars") && (e.maxChars = g.maxChars), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.value != null && g.hasOwnProperty("value") && (e.value = g.value), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.default != null && g.hasOwnProperty("default") && (e.default = g.default), g.position != null && g.hasOwnProperty("position") && (e.position = E.enums === String ? $root.ChatInput.Position[g.position] === void 0 ? g.position : $root.ChatInput.Position[g.position] : g.position), g.acceptFile != null && g.hasOwnProperty("acceptFile") && (e.acceptFile = E.enums === String ? $root.ChatInput.AcceptFile[g.acceptFile] === void 0 ? g.acceptFile : $root.ChatInput.AcceptFile[g.acceptFile] : g.acceptFile), g.fileType && g.fileType.length) {
      e.fileType = [];
      for (let t = 0; t < g.fileType.length; ++t) e.fileType[t] = g.fileType[t];
    }
    return g.maxUploadSizeMb != null && g.hasOwnProperty("maxUploadSizeMb") && (e.maxUploadSizeMb = g.maxUploadSizeMb), g.acceptAudio != null && g.hasOwnProperty("acceptAudio") && (e.acceptAudio = g.acceptAudio), g.audioSampleRate != null && g.hasOwnProperty("audioSampleRate") && (e.audioSampleRate = g.audioSampleRate, E.oneofs && (e._audioSampleRate = "audioSampleRate")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ChatInput";
  }, o.Position = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "BOTTOM"] = 0, E;
  })(), o.AcceptFile = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "NONE"] = 0, E[g[1] = "SINGLE"] = 1, E[g[2] = "MULTIPLE"] = 2, E[g[3] = "DIRECTORY"] = 3, E;
  })(), o;
})();
$root.Checkbox = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = !1, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.type = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.label), i.default != null && Object.hasOwnProperty.call(i, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.default), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.help), i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.formId), i.value != null && Object.hasOwnProperty.call(i, "value") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(i.value), i.setValue != null && Object.hasOwnProperty.call(i, "setValue") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(i.setValue), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(i.disabled), i.labelVisibility != null && Object.hasOwnProperty.call(i, "labelVisibility") && $root.LabelVisibilityMessage.encode(i.labelVisibility, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), i.type != null && Object.hasOwnProperty.call(i, "type") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(i.type), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Checkbox();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.label = i.string();
          break;
        }
        case 3: {
          t.default = i.bool();
          break;
        }
        case 4: {
          t.help = i.string();
          break;
        }
        case 5: {
          t.formId = i.string();
          break;
        }
        case 6: {
          t.value = i.bool();
          break;
        }
        case 7: {
          t.setValue = i.bool();
          break;
        }
        case 8: {
          t.disabled = i.bool();
          break;
        }
        case 9: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(i, i.uint32());
          break;
        }
        case 10: {
          t.type = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Checkbox) return i;
    let g = new $root.Checkbox();
    if (i.id != null && (g.id = String(i.id)), i.label != null && (g.label = String(i.label)), i.default != null && (g.default = !!i.default), i.help != null && (g.help = String(i.help)), i.formId != null && (g.formId = String(i.formId)), i.value != null && (g.value = !!i.value), i.setValue != null && (g.setValue = !!i.setValue), i.disabled != null && (g.disabled = !!i.disabled), i.labelVisibility != null) {
      if (typeof i.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(i.labelVisibility);
    }
    switch (i.type) {
      default:
        if (typeof i.type == "number") {
          g.type = i.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        g.type = 0;
        break;
      case "TOGGLE":
      case 1:
        g.type = 1;
        break;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.id = "", E.label = "", E.default = !1, E.help = "", E.formId = "", E.value = !1, E.setValue = !1, E.disabled = !1, E.labelVisibility = null, E.type = g.enums === String ? "DEFAULT" : 0), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.default != null && i.hasOwnProperty("default") && (E.default = i.default), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), i.value != null && i.hasOwnProperty("value") && (E.value = i.value), i.setValue != null && i.hasOwnProperty("setValue") && (E.setValue = i.setValue), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.labelVisibility != null && i.hasOwnProperty("labelVisibility") && (E.labelVisibility = $root.LabelVisibilityMessage.toObject(i.labelVisibility, g)), i.type != null && i.hasOwnProperty("type") && (E.type = g.enums === String ? $root.Checkbox.StyleType[i.type] === void 0 ? i.type : $root.Checkbox.StyleType[i.type] : i.type), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Checkbox";
  }, o.StyleType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "DEFAULT"] = 0, g[i[1] = "TOGGLE"] = 1, g;
  })(), o;
})();
$root.Code = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.codeText = "", o.prototype.language = "", o.prototype.showLineNumbers = !1, o.prototype.wrapLines = !1, o.prototype.height = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.codeText != null && Object.hasOwnProperty.call(i, "codeText") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.codeText), i.language != null && Object.hasOwnProperty.call(i, "language") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.language), i.showLineNumbers != null && Object.hasOwnProperty.call(i, "showLineNumbers") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.showLineNumbers), i.wrapLines != null && Object.hasOwnProperty.call(i, "wrapLines") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(i.wrapLines), i.height != null && Object.hasOwnProperty.call(i, "height") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(i.height), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Code();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.codeText = i.string();
          break;
        }
        case 2: {
          t.language = i.string();
          break;
        }
        case 3: {
          t.showLineNumbers = i.bool();
          break;
        }
        case 4: {
          t.wrapLines = i.bool();
          break;
        }
        case 5: {
          t.height = i.uint32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Code) return i;
    let g = new $root.Code();
    return i.codeText != null && (g.codeText = String(i.codeText)), i.language != null && (g.language = String(i.language)), i.showLineNumbers != null && (g.showLineNumbers = !!i.showLineNumbers), i.wrapLines != null && (g.wrapLines = !!i.wrapLines), i.height != null && (g.height = i.height >>> 0), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.codeText = "", E.language = "", E.showLineNumbers = !1, E.wrapLines = !1, E.height = 0), i.codeText != null && i.hasOwnProperty("codeText") && (E.codeText = i.codeText), i.language != null && i.hasOwnProperty("language") && (E.language = i.language), i.showLineNumbers != null && i.hasOwnProperty("showLineNumbers") && (E.showLineNumbers = i.showLineNumbers), i.wrapLines != null && i.hasOwnProperty("wrapLines") && (E.wrapLines = i.wrapLines), i.height != null && i.hasOwnProperty("height") && (E.height = i.height), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Code";
  }, o;
})();
$root.ColorPicker = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.value = "", o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.label), i.default != null && Object.hasOwnProperty.call(i, "default") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.default), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.help), i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.formId), i.value != null && Object.hasOwnProperty.call(i, "value") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.value), i.setValue != null && Object.hasOwnProperty.call(i, "setValue") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(i.setValue), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(i.disabled), i.labelVisibility != null && Object.hasOwnProperty.call(i, "labelVisibility") && $root.LabelVisibilityMessage.encode(i.labelVisibility, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ColorPicker();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.label = i.string();
          break;
        }
        case 3: {
          t.default = i.string();
          break;
        }
        case 4: {
          t.help = i.string();
          break;
        }
        case 5: {
          t.formId = i.string();
          break;
        }
        case 6: {
          t.value = i.string();
          break;
        }
        case 7: {
          t.setValue = i.bool();
          break;
        }
        case 8: {
          t.disabled = i.bool();
          break;
        }
        case 9: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ColorPicker) return i;
    let g = new $root.ColorPicker();
    if (i.id != null && (g.id = String(i.id)), i.label != null && (g.label = String(i.label)), i.default != null && (g.default = String(i.default)), i.help != null && (g.help = String(i.help)), i.formId != null && (g.formId = String(i.formId)), i.value != null && (g.value = String(i.value)), i.setValue != null && (g.setValue = !!i.setValue), i.disabled != null && (g.disabled = !!i.disabled), i.labelVisibility != null) {
      if (typeof i.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(i.labelVisibility);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.id = "", E.label = "", E.default = "", E.help = "", E.formId = "", E.value = "", E.setValue = !1, E.disabled = !1, E.labelVisibility = null), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.default != null && i.hasOwnProperty("default") && (E.default = i.default), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), i.value != null && i.hasOwnProperty("value") && (E.value = i.value), i.setValue != null && i.hasOwnProperty("setValue") && (E.setValue = i.setValue), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.labelVisibility != null && i.hasOwnProperty("labelVisibility") && (E.labelVisibility = $root.LabelVisibilityMessage.toObject(i.labelVisibility, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ColorPicker";
  }, o;
})();
$root.DataFrame = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.prototype.index = null, o.prototype.columns = null, o.prototype.style = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.Table.encode(i.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), i.index != null && Object.hasOwnProperty.call(i, "index") && $root.Index.encode(i.index, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), i.columns != null && Object.hasOwnProperty.call(i, "columns") && $root.Index.encode(i.columns, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), i.style != null && Object.hasOwnProperty.call(i, "style") && $root.TableStyle.encode(i.style, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DataFrame();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.data = $root.Table.decode(i, i.uint32());
          break;
        }
        case 2: {
          t.index = $root.Index.decode(i, i.uint32());
          break;
        }
        case 3: {
          t.columns = $root.Index.decode(i, i.uint32());
          break;
        }
        case 4: {
          t.style = $root.TableStyle.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DataFrame) return i;
    let g = new $root.DataFrame();
    if (i.data != null) {
      if (typeof i.data != "object") throw TypeError(".DataFrame.data: object expected");
      g.data = $root.Table.fromObject(i.data);
    }
    if (i.index != null) {
      if (typeof i.index != "object") throw TypeError(".DataFrame.index: object expected");
      g.index = $root.Index.fromObject(i.index);
    }
    if (i.columns != null) {
      if (typeof i.columns != "object") throw TypeError(".DataFrame.columns: object expected");
      g.columns = $root.Index.fromObject(i.columns);
    }
    if (i.style != null) {
      if (typeof i.style != "object") throw TypeError(".DataFrame.style: object expected");
      g.style = $root.TableStyle.fromObject(i.style);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.data = null, E.index = null, E.columns = null, E.style = null), i.data != null && i.hasOwnProperty("data") && (E.data = $root.Table.toObject(i.data, g)), i.index != null && i.hasOwnProperty("index") && (E.index = $root.Index.toObject(i.index, g)), i.columns != null && i.hasOwnProperty("columns") && (E.columns = $root.Index.toObject(i.columns, g)), i.style != null && i.hasOwnProperty("style") && (E.style = $root.TableStyle.toObject(i.style, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DataFrame";
  }, o;
})();
$root.Index = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.plainIndex = null, o.prototype.rangeIndex = null, o.prototype.multiIndex = null, o.prototype.datetimeIndex = null, o.prototype.timedeltaIndex = null, o.prototype.int_64Index = null, o.prototype.float_64Index = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["plainIndex", "rangeIndex", "multiIndex", "datetimeIndex", "timedeltaIndex", "int_64Index", "float_64Index"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.plainIndex != null && Object.hasOwnProperty.call(g, "plainIndex") && $root.PlainIndex.encode(g.plainIndex, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.rangeIndex != null && Object.hasOwnProperty.call(g, "rangeIndex") && $root.RangeIndex.encode(g.rangeIndex, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.multiIndex != null && Object.hasOwnProperty.call(g, "multiIndex") && $root.MultiIndex.encode(g.multiIndex, E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.datetimeIndex != null && Object.hasOwnProperty.call(g, "datetimeIndex") && $root.DatetimeIndex.encode(g.datetimeIndex, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.timedeltaIndex != null && Object.hasOwnProperty.call(g, "timedeltaIndex") && $root.TimedeltaIndex.encode(g.timedeltaIndex, E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.int_64Index != null && Object.hasOwnProperty.call(g, "int_64Index") && $root.Int64Index.encode(g.int_64Index, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.float_64Index != null && Object.hasOwnProperty.call(g, "float_64Index") && $root.Float64Index.encode(g.float_64Index, E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Index();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.plainIndex = $root.PlainIndex.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.rangeIndex = $root.RangeIndex.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.multiIndex = $root.MultiIndex.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.datetimeIndex = $root.DatetimeIndex.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.timedeltaIndex = $root.TimedeltaIndex.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.int_64Index = $root.Int64Index.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.float_64Index = $root.Float64Index.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Index) return g;
    let E = new $root.Index();
    if (g.plainIndex != null) {
      if (typeof g.plainIndex != "object") throw TypeError(".Index.plainIndex: object expected");
      E.plainIndex = $root.PlainIndex.fromObject(g.plainIndex);
    }
    if (g.rangeIndex != null) {
      if (typeof g.rangeIndex != "object") throw TypeError(".Index.rangeIndex: object expected");
      E.rangeIndex = $root.RangeIndex.fromObject(g.rangeIndex);
    }
    if (g.multiIndex != null) {
      if (typeof g.multiIndex != "object") throw TypeError(".Index.multiIndex: object expected");
      E.multiIndex = $root.MultiIndex.fromObject(g.multiIndex);
    }
    if (g.datetimeIndex != null) {
      if (typeof g.datetimeIndex != "object") throw TypeError(".Index.datetimeIndex: object expected");
      E.datetimeIndex = $root.DatetimeIndex.fromObject(g.datetimeIndex);
    }
    if (g.timedeltaIndex != null) {
      if (typeof g.timedeltaIndex != "object") throw TypeError(".Index.timedeltaIndex: object expected");
      E.timedeltaIndex = $root.TimedeltaIndex.fromObject(g.timedeltaIndex);
    }
    if (g.int_64Index != null) {
      if (typeof g.int_64Index != "object") throw TypeError(".Index.int_64Index: object expected");
      E.int_64Index = $root.Int64Index.fromObject(g.int_64Index);
    }
    if (g.float_64Index != null) {
      if (typeof g.float_64Index != "object") throw TypeError(".Index.float_64Index: object expected");
      E.float_64Index = $root.Float64Index.fromObject(g.float_64Index);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return g.plainIndex != null && g.hasOwnProperty("plainIndex") && (e.plainIndex = $root.PlainIndex.toObject(g.plainIndex, E), E.oneofs && (e.type = "plainIndex")), g.rangeIndex != null && g.hasOwnProperty("rangeIndex") && (e.rangeIndex = $root.RangeIndex.toObject(g.rangeIndex, E), E.oneofs && (e.type = "rangeIndex")), g.multiIndex != null && g.hasOwnProperty("multiIndex") && (e.multiIndex = $root.MultiIndex.toObject(g.multiIndex, E), E.oneofs && (e.type = "multiIndex")), g.datetimeIndex != null && g.hasOwnProperty("datetimeIndex") && (e.datetimeIndex = $root.DatetimeIndex.toObject(g.datetimeIndex, E), E.oneofs && (e.type = "datetimeIndex")), g.timedeltaIndex != null && g.hasOwnProperty("timedeltaIndex") && (e.timedeltaIndex = $root.TimedeltaIndex.toObject(g.timedeltaIndex, E), E.oneofs && (e.type = "timedeltaIndex")), g.int_64Index != null && g.hasOwnProperty("int_64Index") && (e.int_64Index = $root.Int64Index.toObject(g.int_64Index, E), E.oneofs && (e.type = "int_64Index")), g.float_64Index != null && g.hasOwnProperty("float_64Index") && (e.float_64Index = $root.Float64Index.toObject(g.float_64Index, E), E.oneofs && (e.type = "float_64Index")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Index";
  }, o;
})();
$root.PlainIndex = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.AnyArray.encode(i.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.PlainIndex();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.data = $root.AnyArray.decode(i, i.uint32()) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.PlainIndex) return i;
    let g = new $root.PlainIndex();
    if (i.data != null) {
      if (typeof i.data != "object") throw TypeError(".PlainIndex.data: object expected");
      g.data = $root.AnyArray.fromObject(i.data);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.data = null), i.data != null && i.hasOwnProperty("data") && (E.data = $root.AnyArray.toObject(i.data, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/PlainIndex";
  }, o;
})();
$root.RangeIndex = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.start = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.stop = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.start != null && Object.hasOwnProperty.call(i, "start") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int64(i.start), i.stop != null && Object.hasOwnProperty.call(i, "stop") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(i.stop), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.RangeIndex();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.start = i.int64();
          break;
        }
        case 2: {
          t.stop = i.int64();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.RangeIndex) return i;
    let g = new $root.RangeIndex();
    return i.start != null && ($util.Long ? (g.start = $util.Long.fromValue(i.start)).unsigned = !1 : typeof i.start == "string" ? g.start = parseInt(i.start, 10) : typeof i.start == "number" ? g.start = i.start : typeof i.start == "object" && (g.start = new $util.LongBits(i.start.low >>> 0, i.start.high >>> 0).toNumber())), i.stop != null && ($util.Long ? (g.stop = $util.Long.fromValue(i.stop)).unsigned = !1 : typeof i.stop == "string" ? g.stop = parseInt(i.stop, 10) : typeof i.stop == "number" ? g.stop = i.stop : typeof i.stop == "object" && (g.stop = new $util.LongBits(i.stop.low >>> 0, i.stop.high >>> 0).toNumber())), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if (g.defaults) {
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.start = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.start = g.longs === String ? "0" : 0;
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.stop = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.stop = g.longs === String ? "0" : 0;
    }
    return i.start != null && i.hasOwnProperty("start") && (typeof i.start == "number" ? E.start = g.longs === String ? String(i.start) : i.start : E.start = g.longs === String ? $util.Long.prototype.toString.call(i.start) : g.longs === Number ? new $util.LongBits(i.start.low >>> 0, i.start.high >>> 0).toNumber() : i.start), i.stop != null && i.hasOwnProperty("stop") && (typeof i.stop == "number" ? E.stop = g.longs === String ? String(i.stop) : i.stop : E.stop = g.longs === String ? $util.Long.prototype.toString.call(i.stop) : g.longs === Number ? new $util.LongBits(i.stop.low >>> 0, i.stop.high >>> 0).toNumber() : i.stop), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/RangeIndex";
  }, o;
})();
$root.MultiIndex = (() => {
  function o(i) {
    if (this.levels = [], this.labels = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.levels = $util.emptyArray, o.prototype.labels = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.levels != null && i.levels.length) for (let E = 0; E < i.levels.length; ++E) $root.Index.encode(i.levels[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (i.labels != null && i.labels.length) for (let E = 0; E < i.labels.length; ++E) $root.Int32Array.encode(i.labels[E], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.MultiIndex();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.levels && t.levels.length || (t.levels = []), t.levels.push($root.Index.decode(i, i.uint32()));
          break;
        }
        case 2: {
          t.labels && t.labels.length || (t.labels = []), t.labels.push($root.Int32Array.decode(i, i.uint32()));
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.MultiIndex) return i;
    let g = new $root.MultiIndex();
    if (i.levels) {
      if (!Array.isArray(i.levels)) throw TypeError(".MultiIndex.levels: array expected");
      g.levels = [];
      for (let E = 0; E < i.levels.length; ++E) {
        if (typeof i.levels[E] != "object") throw TypeError(".MultiIndex.levels: object expected");
        g.levels[E] = $root.Index.fromObject(i.levels[E]);
      }
    }
    if (i.labels) {
      if (!Array.isArray(i.labels)) throw TypeError(".MultiIndex.labels: array expected");
      g.labels = [];
      for (let E = 0; E < i.labels.length; ++E) {
        if (typeof i.labels[E] != "object") throw TypeError(".MultiIndex.labels: object expected");
        g.labels[E] = $root.Int32Array.fromObject(i.labels[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.levels = [], E.labels = []), i.levels && i.levels.length) {
      E.levels = [];
      for (let e = 0; e < i.levels.length; ++e) E.levels[e] = $root.Index.toObject(i.levels[e], g);
    }
    if (i.labels && i.labels.length) {
      E.labels = [];
      for (let e = 0; e < i.labels.length; ++e) E.labels[e] = $root.Int32Array.toObject(i.labels[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/MultiIndex";
  }, o;
})();
$root.DatetimeIndex = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.StringArray.encode(i.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DatetimeIndex();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.data = $root.StringArray.decode(i, i.uint32()) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DatetimeIndex) return i;
    let g = new $root.DatetimeIndex();
    if (i.data != null) {
      if (typeof i.data != "object") throw TypeError(".DatetimeIndex.data: object expected");
      g.data = $root.StringArray.fromObject(i.data);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.data = null), i.data != null && i.hasOwnProperty("data") && (E.data = $root.StringArray.toObject(i.data, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DatetimeIndex";
  }, o;
})();
$root.TimedeltaIndex = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.Int64Array.encode(i.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.TimedeltaIndex();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.data = $root.Int64Array.decode(i, i.uint32()) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.TimedeltaIndex) return i;
    let g = new $root.TimedeltaIndex();
    if (i.data != null) {
      if (typeof i.data != "object") throw TypeError(".TimedeltaIndex.data: object expected");
      g.data = $root.Int64Array.fromObject(i.data);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.data = null), i.data != null && i.hasOwnProperty("data") && (E.data = $root.Int64Array.toObject(i.data, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/TimedeltaIndex";
  }, o;
})();
$root.Int64Index = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.Int64Array.encode(i.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Int64Index();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.data = $root.Int64Array.decode(i, i.uint32()) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Int64Index) return i;
    let g = new $root.Int64Index();
    if (i.data != null) {
      if (typeof i.data != "object") throw TypeError(".Int64Index.data: object expected");
      g.data = $root.Int64Array.fromObject(i.data);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.data = null), i.data != null && i.hasOwnProperty("data") && (E.data = $root.Int64Array.toObject(i.data, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Int64Index";
  }, o;
})();
$root.Float64Index = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.data = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.DoubleArray.encode(i.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Float64Index();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.data = $root.DoubleArray.decode(i, i.uint32()) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Float64Index) return i;
    let g = new $root.Float64Index();
    if (i.data != null) {
      if (typeof i.data != "object") throw TypeError(".Float64Index.data: object expected");
      g.data = $root.DoubleArray.fromObject(i.data);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.data = null), i.data != null && i.hasOwnProperty("data") && (E.data = $root.DoubleArray.toObject(i.data, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Float64Index";
  }, o;
})();
$root.CSSStyle = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.property = "", o.prototype.value = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.property != null && Object.hasOwnProperty.call(i, "property") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.property), i.value != null && Object.hasOwnProperty.call(i, "value") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.value), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.CSSStyle();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.property = i.string();
          break;
        }
        case 2: {
          t.value = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.CSSStyle) return i;
    let g = new $root.CSSStyle();
    return i.property != null && (g.property = String(i.property)), i.value != null && (g.value = String(i.value)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.property = "", E.value = ""), i.property != null && i.hasOwnProperty("property") && (E.property = i.property), i.value != null && i.hasOwnProperty("value") && (E.value = i.value), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/CSSStyle";
  }, o;
})();
$root.CellStyle = (() => {
  function o(i) {
    if (this.css = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.css = $util.emptyArray, o.prototype.displayValue = "", o.prototype.hasDisplayValue = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.css != null && i.css.length) for (let E = 0; E < i.css.length; ++E) $root.CSSStyle.encode(i.css[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return i.displayValue != null && Object.hasOwnProperty.call(i, "displayValue") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.displayValue), i.hasDisplayValue != null && Object.hasOwnProperty.call(i, "hasDisplayValue") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.hasDisplayValue), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.CellStyle();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.css && t.css.length || (t.css = []), t.css.push($root.CSSStyle.decode(i, i.uint32()));
          break;
        }
        case 2: {
          t.displayValue = i.string();
          break;
        }
        case 3: {
          t.hasDisplayValue = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.CellStyle) return i;
    let g = new $root.CellStyle();
    if (i.css) {
      if (!Array.isArray(i.css)) throw TypeError(".CellStyle.css: array expected");
      g.css = [];
      for (let E = 0; E < i.css.length; ++E) {
        if (typeof i.css[E] != "object") throw TypeError(".CellStyle.css: object expected");
        g.css[E] = $root.CSSStyle.fromObject(i.css[E]);
      }
    }
    return i.displayValue != null && (g.displayValue = String(i.displayValue)), i.hasDisplayValue != null && (g.hasDisplayValue = !!i.hasDisplayValue), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.css = []), g.defaults && (E.displayValue = "", E.hasDisplayValue = !1), i.css && i.css.length) {
      E.css = [];
      for (let e = 0; e < i.css.length; ++e) E.css[e] = $root.CSSStyle.toObject(i.css[e], g);
    }
    return i.displayValue != null && i.hasOwnProperty("displayValue") && (E.displayValue = i.displayValue), i.hasDisplayValue != null && i.hasOwnProperty("hasDisplayValue") && (E.hasDisplayValue = i.hasDisplayValue), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/CellStyle";
  }, o;
})();
$root.CellStyleArray = (() => {
  function o(i) {
    if (this.styles = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.styles = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.styles != null && i.styles.length) for (let E = 0; E < i.styles.length; ++E) $root.CellStyle.encode(i.styles[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.CellStyleArray();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? (t.styles && t.styles.length || (t.styles = []), t.styles.push($root.CellStyle.decode(i, i.uint32()))) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.CellStyleArray) return i;
    let g = new $root.CellStyleArray();
    if (i.styles) {
      if (!Array.isArray(i.styles)) throw TypeError(".CellStyleArray.styles: array expected");
      g.styles = [];
      for (let E = 0; E < i.styles.length; ++E) {
        if (typeof i.styles[E] != "object") throw TypeError(".CellStyleArray.styles: object expected");
        g.styles[E] = $root.CellStyle.fromObject(i.styles[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.styles = []), i.styles && i.styles.length) {
      E.styles = [];
      for (let e = 0; e < i.styles.length; ++e) E.styles[e] = $root.CellStyle.toObject(i.styles[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/CellStyleArray";
  }, o;
})();
$root.AnyArray = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.strings = null, o.prototype.doubles = null, o.prototype.int64s = null, o.prototype.datetimes = null, o.prototype.timedeltas = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["strings", "doubles", "int64s", "datetimes", "timedeltas"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.strings != null && Object.hasOwnProperty.call(g, "strings") && $root.StringArray.encode(g.strings, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.doubles != null && Object.hasOwnProperty.call(g, "doubles") && $root.DoubleArray.encode(g.doubles, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.int64s != null && Object.hasOwnProperty.call(g, "int64s") && $root.Int64Array.encode(g.int64s, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.datetimes != null && Object.hasOwnProperty.call(g, "datetimes") && $root.StringArray.encode(g.datetimes, E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.timedeltas != null && Object.hasOwnProperty.call(g, "timedeltas") && $root.Int64Array.encode(g.timedeltas, E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.AnyArray();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.strings = $root.StringArray.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.doubles = $root.DoubleArray.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.int64s = $root.Int64Array.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.datetimes = $root.StringArray.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.timedeltas = $root.Int64Array.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.AnyArray) return g;
    let E = new $root.AnyArray();
    if (g.strings != null) {
      if (typeof g.strings != "object") throw TypeError(".AnyArray.strings: object expected");
      E.strings = $root.StringArray.fromObject(g.strings);
    }
    if (g.doubles != null) {
      if (typeof g.doubles != "object") throw TypeError(".AnyArray.doubles: object expected");
      E.doubles = $root.DoubleArray.fromObject(g.doubles);
    }
    if (g.int64s != null) {
      if (typeof g.int64s != "object") throw TypeError(".AnyArray.int64s: object expected");
      E.int64s = $root.Int64Array.fromObject(g.int64s);
    }
    if (g.datetimes != null) {
      if (typeof g.datetimes != "object") throw TypeError(".AnyArray.datetimes: object expected");
      E.datetimes = $root.StringArray.fromObject(g.datetimes);
    }
    if (g.timedeltas != null) {
      if (typeof g.timedeltas != "object") throw TypeError(".AnyArray.timedeltas: object expected");
      E.timedeltas = $root.Int64Array.fromObject(g.timedeltas);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return g.strings != null && g.hasOwnProperty("strings") && (e.strings = $root.StringArray.toObject(g.strings, E), E.oneofs && (e.type = "strings")), g.doubles != null && g.hasOwnProperty("doubles") && (e.doubles = $root.DoubleArray.toObject(g.doubles, E), E.oneofs && (e.type = "doubles")), g.int64s != null && g.hasOwnProperty("int64s") && (e.int64s = $root.Int64Array.toObject(g.int64s, E), E.oneofs && (e.type = "int64s")), g.datetimes != null && g.hasOwnProperty("datetimes") && (e.datetimes = $root.StringArray.toObject(g.datetimes, E), E.oneofs && (e.type = "datetimes")), g.timedeltas != null && g.hasOwnProperty("timedeltas") && (e.timedeltas = $root.Int64Array.toObject(g.timedeltas, E), E.oneofs && (e.type = "timedeltas")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AnyArray";
  }, o;
})();
$root.Table = (() => {
  function o(i) {
    if (this.cols = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.cols = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.cols != null && i.cols.length) for (let E = 0; E < i.cols.length; ++E) $root.AnyArray.encode(i.cols[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Table();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? (t.cols && t.cols.length || (t.cols = []), t.cols.push($root.AnyArray.decode(i, i.uint32()))) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Table) return i;
    let g = new $root.Table();
    if (i.cols) {
      if (!Array.isArray(i.cols)) throw TypeError(".Table.cols: array expected");
      g.cols = [];
      for (let E = 0; E < i.cols.length; ++E) {
        if (typeof i.cols[E] != "object") throw TypeError(".Table.cols: object expected");
        g.cols[E] = $root.AnyArray.fromObject(i.cols[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.cols = []), i.cols && i.cols.length) {
      E.cols = [];
      for (let e = 0; e < i.cols.length; ++e) E.cols[e] = $root.AnyArray.toObject(i.cols[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Table";
  }, o;
})();
$root.TableStyle = (() => {
  function o(i) {
    if (this.cols = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.cols = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.cols != null && i.cols.length) for (let E = 0; E < i.cols.length; ++E) $root.CellStyleArray.encode(i.cols[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.TableStyle();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? (t.cols && t.cols.length || (t.cols = []), t.cols.push($root.CellStyleArray.decode(i, i.uint32()))) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.TableStyle) return i;
    let g = new $root.TableStyle();
    if (i.cols) {
      if (!Array.isArray(i.cols)) throw TypeError(".TableStyle.cols: array expected");
      g.cols = [];
      for (let E = 0; E < i.cols.length; ++E) {
        if (typeof i.cols[E] != "object") throw TypeError(".TableStyle.cols: object expected");
        g.cols[E] = $root.CellStyleArray.fromObject(i.cols[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.cols = []), i.cols && i.cols.length) {
      E.cols = [];
      for (let e = 0; e < i.cols.length; ++e) E.cols[e] = $root.CellStyleArray.toObject(i.cols[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/TableStyle";
  }, o;
})();
$root.DateInput = (() => {
  function o(i) {
    if (this.default = [], this.value = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util.emptyArray, o.prototype.min = "", o.prototype.max = "", o.prototype.isRange = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.format = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.label), i.default != null && i.default.length) for (let E = 0; E < i.default.length; ++E) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.default[E]);
    if (i.min != null && Object.hasOwnProperty.call(i, "min") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.min), i.max != null && Object.hasOwnProperty.call(i, "max") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.max), i.isRange != null && Object.hasOwnProperty.call(i, "isRange") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(i.isRange), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.help), i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(i.formId), i.value != null && i.value.length) for (let E = 0; E < i.value.length; ++E) g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(i.value[E]);
    return i.setValue != null && Object.hasOwnProperty.call(i, "setValue") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(i.setValue), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(i.disabled), i.labelVisibility != null && Object.hasOwnProperty.call(i, "labelVisibility") && $root.LabelVisibilityMessage.encode(i.labelVisibility, g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), i.format != null && Object.hasOwnProperty.call(i, "format") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(i.format), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DateInput();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.label = i.string();
          break;
        }
        case 3: {
          t.default && t.default.length || (t.default = []), t.default.push(i.string());
          break;
        }
        case 4: {
          t.min = i.string();
          break;
        }
        case 5: {
          t.max = i.string();
          break;
        }
        case 6: {
          t.isRange = i.bool();
          break;
        }
        case 7: {
          t.help = i.string();
          break;
        }
        case 8: {
          t.formId = i.string();
          break;
        }
        case 9: {
          t.value && t.value.length || (t.value = []), t.value.push(i.string());
          break;
        }
        case 10: {
          t.setValue = i.bool();
          break;
        }
        case 11: {
          t.disabled = i.bool();
          break;
        }
        case 12: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(i, i.uint32());
          break;
        }
        case 13: {
          t.format = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DateInput) return i;
    let g = new $root.DateInput();
    if (i.id != null && (g.id = String(i.id)), i.label != null && (g.label = String(i.label)), i.default) {
      if (!Array.isArray(i.default)) throw TypeError(".DateInput.default: array expected");
      g.default = [];
      for (let E = 0; E < i.default.length; ++E) g.default[E] = String(i.default[E]);
    }
    if (i.min != null && (g.min = String(i.min)), i.max != null && (g.max = String(i.max)), i.isRange != null && (g.isRange = !!i.isRange), i.help != null && (g.help = String(i.help)), i.formId != null && (g.formId = String(i.formId)), i.value) {
      if (!Array.isArray(i.value)) throw TypeError(".DateInput.value: array expected");
      g.value = [];
      for (let E = 0; E < i.value.length; ++E) g.value[E] = String(i.value[E]);
    }
    if (i.setValue != null && (g.setValue = !!i.setValue), i.disabled != null && (g.disabled = !!i.disabled), i.labelVisibility != null) {
      if (typeof i.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(i.labelVisibility);
    }
    return i.format != null && (g.format = String(i.format)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.default = [], E.value = []), g.defaults && (E.id = "", E.label = "", E.min = "", E.max = "", E.isRange = !1, E.help = "", E.formId = "", E.setValue = !1, E.disabled = !1, E.labelVisibility = null, E.format = ""), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.default && i.default.length) {
      E.default = [];
      for (let e = 0; e < i.default.length; ++e) E.default[e] = i.default[e];
    }
    if (i.min != null && i.hasOwnProperty("min") && (E.min = i.min), i.max != null && i.hasOwnProperty("max") && (E.max = i.max), i.isRange != null && i.hasOwnProperty("isRange") && (E.isRange = i.isRange), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), i.value && i.value.length) {
      E.value = [];
      for (let e = 0; e < i.value.length; ++e) E.value[e] = i.value[e];
    }
    return i.setValue != null && i.hasOwnProperty("setValue") && (E.setValue = i.setValue), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.labelVisibility != null && i.hasOwnProperty("labelVisibility") && (E.labelVisibility = $root.LabelVisibilityMessage.toObject(i.labelVisibility, g)), i.format != null && i.hasOwnProperty("format") && (E.format = i.format), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DateInput";
  }, o;
})();
$root.DateTimeInput = (() => {
  function o(i) {
    if (this.default = [], this.value = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util.emptyArray, o.prototype.min = "", o.prototype.max = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.format = "", o.prototype.step = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.isRange = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.label), i.default != null && i.default.length) for (let E = 0; E < i.default.length; ++E) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.default[E]);
    if (i.min != null && Object.hasOwnProperty.call(i, "min") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.min), i.max != null && Object.hasOwnProperty.call(i, "max") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.max), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.help), i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.formId), i.value != null && i.value.length) for (let E = 0; E < i.value.length; ++E) g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(i.value[E]);
    return i.setValue != null && Object.hasOwnProperty.call(i, "setValue") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(i.setValue), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(i.disabled), i.labelVisibility != null && Object.hasOwnProperty.call(i, "labelVisibility") && $root.LabelVisibilityMessage.encode(i.labelVisibility, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), i.format != null && Object.hasOwnProperty.call(i, "format") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(i.format), i.step != null && Object.hasOwnProperty.call(i, "step") && g.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int64(i.step), i.isRange != null && Object.hasOwnProperty.call(i, "isRange") && g.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(i.isRange), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DateTimeInput();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.label = i.string();
          break;
        }
        case 3: {
          t.default && t.default.length || (t.default = []), t.default.push(i.string());
          break;
        }
        case 4: {
          t.min = i.string();
          break;
        }
        case 5: {
          t.max = i.string();
          break;
        }
        case 6: {
          t.help = i.string();
          break;
        }
        case 7: {
          t.formId = i.string();
          break;
        }
        case 8: {
          t.value && t.value.length || (t.value = []), t.value.push(i.string());
          break;
        }
        case 9: {
          t.setValue = i.bool();
          break;
        }
        case 10: {
          t.disabled = i.bool();
          break;
        }
        case 11: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(i, i.uint32());
          break;
        }
        case 12: {
          t.format = i.string();
          break;
        }
        case 13: {
          t.step = i.int64();
          break;
        }
        case 14: {
          t.isRange = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DateTimeInput) return i;
    let g = new $root.DateTimeInput();
    if (i.id != null && (g.id = String(i.id)), i.label != null && (g.label = String(i.label)), i.default) {
      if (!Array.isArray(i.default)) throw TypeError(".DateTimeInput.default: array expected");
      g.default = [];
      for (let E = 0; E < i.default.length; ++E) g.default[E] = String(i.default[E]);
    }
    if (i.min != null && (g.min = String(i.min)), i.max != null && (g.max = String(i.max)), i.help != null && (g.help = String(i.help)), i.formId != null && (g.formId = String(i.formId)), i.value) {
      if (!Array.isArray(i.value)) throw TypeError(".DateTimeInput.value: array expected");
      g.value = [];
      for (let E = 0; E < i.value.length; ++E) g.value[E] = String(i.value[E]);
    }
    if (i.setValue != null && (g.setValue = !!i.setValue), i.disabled != null && (g.disabled = !!i.disabled), i.labelVisibility != null) {
      if (typeof i.labelVisibility != "object") throw TypeError(".DateTimeInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(i.labelVisibility);
    }
    return i.format != null && (g.format = String(i.format)), i.step != null && ($util.Long ? (g.step = $util.Long.fromValue(i.step)).unsigned = !1 : typeof i.step == "string" ? g.step = parseInt(i.step, 10) : typeof i.step == "number" ? g.step = i.step : typeof i.step == "object" && (g.step = new $util.LongBits(i.step.low >>> 0, i.step.high >>> 0).toNumber())), i.isRange != null && (g.isRange = !!i.isRange), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.default = [], E.value = []), g.defaults) {
      if (E.id = "", E.label = "", E.min = "", E.max = "", E.help = "", E.formId = "", E.setValue = !1, E.disabled = !1, E.labelVisibility = null, E.format = "", $util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.step = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.step = g.longs === String ? "0" : 0;
      E.isRange = !1;
    }
    if (i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.default && i.default.length) {
      E.default = [];
      for (let e = 0; e < i.default.length; ++e) E.default[e] = i.default[e];
    }
    if (i.min != null && i.hasOwnProperty("min") && (E.min = i.min), i.max != null && i.hasOwnProperty("max") && (E.max = i.max), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), i.value && i.value.length) {
      E.value = [];
      for (let e = 0; e < i.value.length; ++e) E.value[e] = i.value[e];
    }
    return i.setValue != null && i.hasOwnProperty("setValue") && (E.setValue = i.setValue), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.labelVisibility != null && i.hasOwnProperty("labelVisibility") && (E.labelVisibility = $root.LabelVisibilityMessage.toObject(i.labelVisibility, g)), i.format != null && i.hasOwnProperty("format") && (E.format = i.format), i.step != null && i.hasOwnProperty("step") && (typeof i.step == "number" ? E.step = g.longs === String ? String(i.step) : i.step : E.step = g.longs === String ? $util.Long.prototype.toString.call(i.step) : g.longs === Number ? new $util.LongBits(i.step.low >>> 0, i.step.high >>> 0).toNumber() : i.step), i.isRange != null && i.hasOwnProperty("isRange") && (E.isRange = i.isRange), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DateTimeInput";
  }, o;
})();
$root.DeckGlJsonChart = (() => {
  function o(i) {
    if (this.selectionMode = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.json = "", o.prototype.tooltip = "", o.prototype.useContainerWidth = !1, o.prototype.id = "", o.prototype.mapboxToken = "", o.prototype.width = 0, o.prototype.height = 0, o.prototype.selectionMode = $util.emptyArray, o.prototype.formId = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.json != null && Object.hasOwnProperty.call(i, "json") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.json), i.tooltip != null && Object.hasOwnProperty.call(i, "tooltip") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.tooltip), i.useContainerWidth != null && Object.hasOwnProperty.call(i, "useContainerWidth") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(i.useContainerWidth), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.id), i.mapboxToken != null && Object.hasOwnProperty.call(i, "mapboxToken") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.mapboxToken), i.width != null && Object.hasOwnProperty.call(i, "width") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).uint32(i.width), i.height != null && Object.hasOwnProperty.call(i, "height") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).uint32(i.height), i.selectionMode != null && i.selectionMode.length) {
      g.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let E = 0; E < i.selectionMode.length; ++E) g.int32(i.selectionMode[E]);
      g.ldelim();
    }
    return i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(i.formId), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DeckGlJsonChart();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.json = i.string();
          break;
        }
        case 2: {
          t.tooltip = i.string();
          break;
        }
        case 4: {
          t.useContainerWidth = i.bool();
          break;
        }
        case 5: {
          t.id = i.string();
          break;
        }
        case 6: {
          t.mapboxToken = i.string();
          break;
        }
        case 7: {
          t.width = i.uint32();
          break;
        }
        case 8: {
          t.height = i.uint32();
          break;
        }
        case 9: {
          if (t.selectionMode && t.selectionMode.length || (t.selectionMode = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.selectionMode.push(i.int32());
          } else t.selectionMode.push(i.int32());
          break;
        }
        case 10: {
          t.formId = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DeckGlJsonChart) return i;
    let g = new $root.DeckGlJsonChart();
    if (i.json != null && (g.json = String(i.json)), i.tooltip != null && (g.tooltip = String(i.tooltip)), i.useContainerWidth != null && (g.useContainerWidth = !!i.useContainerWidth), i.id != null && (g.id = String(i.id)), i.mapboxToken != null && (g.mapboxToken = String(i.mapboxToken)), i.width != null && (g.width = i.width >>> 0), i.height != null && (g.height = i.height >>> 0), i.selectionMode) {
      if (!Array.isArray(i.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      g.selectionMode = [];
      for (let E = 0; E < i.selectionMode.length; ++E) switch (i.selectionMode[E]) {
        default:
          if (typeof i.selectionMode[E] == "number") {
            g.selectionMode[E] = i.selectionMode[E];
            break;
          }
        case "SINGLE_OBJECT":
        case 0:
          g.selectionMode[E] = 0;
          break;
        case "MULTI_OBJECT":
        case 1:
          g.selectionMode[E] = 1;
          break;
      }
    }
    return i.formId != null && (g.formId = String(i.formId)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.selectionMode = []), g.defaults && (E.json = "", E.tooltip = "", E.useContainerWidth = !1, E.id = "", E.mapboxToken = "", E.width = 0, E.height = 0, E.formId = ""), i.json != null && i.hasOwnProperty("json") && (E.json = i.json), i.tooltip != null && i.hasOwnProperty("tooltip") && (E.tooltip = i.tooltip), i.useContainerWidth != null && i.hasOwnProperty("useContainerWidth") && (E.useContainerWidth = i.useContainerWidth), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.mapboxToken != null && i.hasOwnProperty("mapboxToken") && (E.mapboxToken = i.mapboxToken), i.width != null && i.hasOwnProperty("width") && (E.width = i.width), i.height != null && i.hasOwnProperty("height") && (E.height = i.height), i.selectionMode && i.selectionMode.length) {
      E.selectionMode = [];
      for (let e = 0; e < i.selectionMode.length; ++e) E.selectionMode[e] = g.enums === String ? $root.DeckGlJsonChart.SelectionMode[i.selectionMode[e]] === void 0 ? i.selectionMode[e] : $root.DeckGlJsonChart.SelectionMode[i.selectionMode[e]] : i.selectionMode[e];
    }
    return i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DeckGlJsonChart";
  }, o.SelectionMode = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "SINGLE_OBJECT"] = 0, g[i[1] = "MULTI_OBJECT"] = 1, g;
  })(), o;
})();
$root.Delta = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.newElement = null, o.prototype.addBlock = null, o.prototype.newTransient = null, o.prototype.addRows = null, o.prototype.arrowAddRows = null, o.prototype.fragmentId = "";
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["newElement", "addBlock", "newTransient", "addRows", "arrowAddRows"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.newElement != null && Object.hasOwnProperty.call(g, "newElement") && $root.Element.encode(g.newElement, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.addRows != null && Object.hasOwnProperty.call(g, "addRows") && $root.NamedDataSet.encode(g.addRows, E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.addBlock != null && Object.hasOwnProperty.call(g, "addBlock") && $root.Block.encode(g.addBlock, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.arrowAddRows != null && Object.hasOwnProperty.call(g, "arrowAddRows") && $root.ArrowNamedDataSet.encode(g.arrowAddRows, E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.fragmentId != null && Object.hasOwnProperty.call(g, "fragmentId") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.fragmentId), g.newTransient != null && Object.hasOwnProperty.call(g, "newTransient") && $root.Transient.encode(g.newTransient, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Delta();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 3: {
          n.newElement = $root.Element.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.addBlock = $root.Block.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.newTransient = $root.Transient.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.addRows = $root.NamedDataSet.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.arrowAddRows = $root.ArrowNamedDataSet.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.fragmentId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Delta) return g;
    let E = new $root.Delta();
    if (g.newElement != null) {
      if (typeof g.newElement != "object") throw TypeError(".Delta.newElement: object expected");
      E.newElement = $root.Element.fromObject(g.newElement);
    }
    if (g.addBlock != null) {
      if (typeof g.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
      E.addBlock = $root.Block.fromObject(g.addBlock);
    }
    if (g.newTransient != null) {
      if (typeof g.newTransient != "object") throw TypeError(".Delta.newTransient: object expected");
      E.newTransient = $root.Transient.fromObject(g.newTransient);
    }
    if (g.addRows != null) {
      if (typeof g.addRows != "object") throw TypeError(".Delta.addRows: object expected");
      E.addRows = $root.NamedDataSet.fromObject(g.addRows);
    }
    if (g.arrowAddRows != null) {
      if (typeof g.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
      E.arrowAddRows = $root.ArrowNamedDataSet.fromObject(g.arrowAddRows);
    }
    return g.fragmentId != null && (E.fragmentId = String(g.fragmentId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.fragmentId = ""), g.newElement != null && g.hasOwnProperty("newElement") && (e.newElement = $root.Element.toObject(g.newElement, E), E.oneofs && (e.type = "newElement")), g.addRows != null && g.hasOwnProperty("addRows") && (e.addRows = $root.NamedDataSet.toObject(g.addRows, E), E.oneofs && (e.type = "addRows")), g.addBlock != null && g.hasOwnProperty("addBlock") && (e.addBlock = $root.Block.toObject(g.addBlock, E), E.oneofs && (e.type = "addBlock")), g.arrowAddRows != null && g.hasOwnProperty("arrowAddRows") && (e.arrowAddRows = $root.ArrowNamedDataSet.toObject(g.arrowAddRows, E), E.oneofs && (e.type = "arrowAddRows")), g.fragmentId != null && g.hasOwnProperty("fragmentId") && (e.fragmentId = g.fragmentId), g.newTransient != null && g.hasOwnProperty("newTransient") && (e.newTransient = $root.Transient.toObject(g.newTransient, E), E.oneofs && (e.type = "newTransient")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Delta";
  }, o;
})();
$root.Element = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.heightConfig = null, o.prototype.widthConfig = null, o.prototype.textAlignmentConfig = null, o.prototype.alert = null, o.prototype.arrowDataFrame = null, o.prototype.arrowTable = null, o.prototype.arrowVegaLiteChart = null, o.prototype.audio = null, o.prototype.audioInput = null, o.prototype.balloons = null, o.prototype.bidiComponent = null, o.prototype.bokehChart = null, o.prototype.button = null, o.prototype.buttonGroup = null, o.prototype.downloadButton = null, o.prototype.cameraInput = null, o.prototype.chatInput = null, o.prototype.checkbox = null, o.prototype.colorPicker = null, o.prototype.componentInstance = null, o.prototype.dataFrame = null, o.prototype.table = null, o.prototype.dateInput = null, o.prototype.deckGlJsonChart = null, o.prototype.docString = null, o.prototype.empty = null, o.prototype.exception = null, o.prototype.favicon = null, o.prototype.fileUploader = null, o.prototype.graphvizChart = null, o.prototype.html = null, o.prototype.iframe = null, o.prototype.imgs = null, o.prototype.json = null, o.prototype.linkButton = null, o.prototype.markdown = null, o.prototype.metric = null, o.prototype.multiselect = null, o.prototype.numberInput = null, o.prototype.pageLink = null, o.prototype.plotlyChart = null, o.prototype.progress = null, o.prototype.radio = null, o.prototype.selectbox = null, o.prototype.skeleton = null, o.prototype.slider = null, o.prototype.snow = null, o.prototype.space = null, o.prototype.spinner = null, o.prototype.text = null, o.prototype.textArea = null, o.prototype.textInput = null, o.prototype.timeInput = null, o.prototype.dateTimeInput = null, o.prototype.toast = null, o.prototype.vegaLiteChart = null, o.prototype.video = null, o.prototype.heading = null, o.prototype.code = null;
  let i;
  return Object.defineProperty(o.prototype, "_heightConfig", { get: $util.oneOfGetter(i = ["heightConfig"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_widthConfig", { get: $util.oneOfGetter(i = ["widthConfig"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_textAlignmentConfig", { get: $util.oneOfGetter(i = ["textAlignmentConfig"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["alert", "arrowDataFrame", "arrowTable", "arrowVegaLiteChart", "audio", "audioInput", "balloons", "bidiComponent", "bokehChart", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dataFrame", "table", "dateInput", "deckGlJsonChart", "docString", "empty", "exception", "favicon", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "space", "spinner", "text", "textArea", "textInput", "timeInput", "dateTimeInput", "toast", "vegaLiteChart", "video", "heading", "code"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.text != null && Object.hasOwnProperty.call(g, "text") && $root.Text.encode(g.text, E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.empty != null && Object.hasOwnProperty.call(g, "empty") && $root.Empty.encode(g.empty, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.dataFrame != null && Object.hasOwnProperty.call(g, "dataFrame") && $root.DataFrame.encode(g.dataFrame, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.progress != null && Object.hasOwnProperty.call(g, "progress") && $root.Progress.encode(g.progress, E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.imgs != null && Object.hasOwnProperty.call(g, "imgs") && $root.ImageList.encode(g.imgs, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.docString != null && Object.hasOwnProperty.call(g, "docString") && $root.DocString.encode(g.docString, E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.exception != null && Object.hasOwnProperty.call(g, "exception") && $root.Exception.encode(g.exception, E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g.vegaLiteChart != null && Object.hasOwnProperty.call(g, "vegaLiteChart") && $root.VegaLiteChart.encode(g.vegaLiteChart, E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.table != null && Object.hasOwnProperty.call(g, "table") && $root.DataFrame.encode(g.table, E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.balloons != null && Object.hasOwnProperty.call(g, "balloons") && $root.Balloons.encode(g.balloons, E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.audio != null && Object.hasOwnProperty.call(g, "audio") && $root.Audio.encode(g.audio, E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.video != null && Object.hasOwnProperty.call(g, "video") && $root.Video.encode(g.video, E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.plotlyChart != null && Object.hasOwnProperty.call(g, "plotlyChart") && $root.PlotlyChart.encode(g.plotlyChart, E.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.bokehChart != null && Object.hasOwnProperty.call(g, "bokehChart") && $root.BokehChart.encode(g.bokehChart, E.uint32(
      /* id 17, wireType 2 =*/
      138
    ).fork()).ldelim(), g.graphvizChart != null && Object.hasOwnProperty.call(g, "graphvizChart") && $root.GraphVizChart.encode(g.graphvizChart, E.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), g.button != null && Object.hasOwnProperty.call(g, "button") && $root.Button.encode(g.button, E.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), g.checkbox != null && Object.hasOwnProperty.call(g, "checkbox") && $root.Checkbox.encode(g.checkbox, E.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), g.slider != null && Object.hasOwnProperty.call(g, "slider") && $root.Slider.encode(g.slider, E.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), g.textArea != null && Object.hasOwnProperty.call(g, "textArea") && $root.TextArea.encode(g.textArea, E.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.radio != null && Object.hasOwnProperty.call(g, "radio") && $root.Radio.encode(g.radio, E.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), g.textInput != null && Object.hasOwnProperty.call(g, "textInput") && $root.TextInput.encode(g.textInput, E.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), g.selectbox != null && Object.hasOwnProperty.call(g, "selectbox") && $root.Selectbox.encode(g.selectbox, E.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), g.timeInput != null && Object.hasOwnProperty.call(g, "timeInput") && $root.TimeInput.encode(g.timeInput, E.uint32(
      /* id 26, wireType 2 =*/
      210
    ).fork()).ldelim(), g.dateInput != null && Object.hasOwnProperty.call(g, "dateInput") && $root.DateInput.encode(g.dateInput, E.uint32(
      /* id 27, wireType 2 =*/
      218
    ).fork()).ldelim(), g.multiselect != null && Object.hasOwnProperty.call(g, "multiselect") && $root.MultiSelect.encode(g.multiselect, E.uint32(
      /* id 28, wireType 2 =*/
      226
    ).fork()).ldelim(), g.markdown != null && Object.hasOwnProperty.call(g, "markdown") && $root.Markdown.encode(g.markdown, E.uint32(
      /* id 29, wireType 2 =*/
      234
    ).fork()).ldelim(), g.alert != null && Object.hasOwnProperty.call(g, "alert") && $root.Alert.encode(g.alert, E.uint32(
      /* id 30, wireType 2 =*/
      242
    ).fork()).ldelim(), g.json != null && Object.hasOwnProperty.call(g, "json") && $root.Json.encode(g.json, E.uint32(
      /* id 31, wireType 2 =*/
      250
    ).fork()).ldelim(), g.numberInput != null && Object.hasOwnProperty.call(g, "numberInput") && $root.NumberInput.encode(g.numberInput, E.uint32(
      /* id 32, wireType 2 =*/
      258
    ).fork()).ldelim(), g.fileUploader != null && Object.hasOwnProperty.call(g, "fileUploader") && $root.FileUploader.encode(g.fileUploader, E.uint32(
      /* id 33, wireType 2 =*/
      266
    ).fork()).ldelim(), g.deckGlJsonChart != null && Object.hasOwnProperty.call(g, "deckGlJsonChart") && $root.DeckGlJsonChart.encode(g.deckGlJsonChart, E.uint32(
      /* id 34, wireType 2 =*/
      274
    ).fork()).ldelim(), g.colorPicker != null && Object.hasOwnProperty.call(g, "colorPicker") && $root.ColorPicker.encode(g.colorPicker, E.uint32(
      /* id 35, wireType 2 =*/
      282
    ).fork()).ldelim(), g.favicon != null && Object.hasOwnProperty.call(g, "favicon") && $root.Favicon.encode(g.favicon, E.uint32(
      /* id 36, wireType 2 =*/
      290
    ).fork()).ldelim(), g.componentInstance != null && Object.hasOwnProperty.call(g, "componentInstance") && $root.ComponentInstance.encode(g.componentInstance, E.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim(), g.iframe != null && Object.hasOwnProperty.call(g, "iframe") && $root.IFrame.encode(g.iframe, E.uint32(
      /* id 38, wireType 2 =*/
      306
    ).fork()).ldelim(), g.arrowTable != null && Object.hasOwnProperty.call(g, "arrowTable") && $root.Arrow.encode(g.arrowTable, E.uint32(
      /* id 39, wireType 2 =*/
      314
    ).fork()).ldelim(), g.arrowDataFrame != null && Object.hasOwnProperty.call(g, "arrowDataFrame") && $root.Arrow.encode(g.arrowDataFrame, E.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), g.arrowVegaLiteChart != null && Object.hasOwnProperty.call(g, "arrowVegaLiteChart") && $root.ArrowVegaLiteChart.encode(g.arrowVegaLiteChart, E.uint32(
      /* id 41, wireType 2 =*/
      330
    ).fork()).ldelim(), g.metric != null && Object.hasOwnProperty.call(g, "metric") && $root.Metric.encode(g.metric, E.uint32(
      /* id 42, wireType 2 =*/
      338
    ).fork()).ldelim(), g.downloadButton != null && Object.hasOwnProperty.call(g, "downloadButton") && $root.DownloadButton.encode(g.downloadButton, E.uint32(
      /* id 43, wireType 2 =*/
      346
    ).fork()).ldelim(), g.spinner != null && Object.hasOwnProperty.call(g, "spinner") && $root.Spinner.encode(g.spinner, E.uint32(
      /* id 44, wireType 2 =*/
      354
    ).fork()).ldelim(), g.cameraInput != null && Object.hasOwnProperty.call(g, "cameraInput") && $root.CameraInput.encode(g.cameraInput, E.uint32(
      /* id 45, wireType 2 =*/
      362
    ).fork()).ldelim(), g.snow != null && Object.hasOwnProperty.call(g, "snow") && $root.Snow.encode(g.snow, E.uint32(
      /* id 46, wireType 2 =*/
      370
    ).fork()).ldelim(), g.heading != null && Object.hasOwnProperty.call(g, "heading") && $root.Heading.encode(g.heading, E.uint32(
      /* id 47, wireType 2 =*/
      378
    ).fork()).ldelim(), g.code != null && Object.hasOwnProperty.call(g, "code") && $root.Code.encode(g.code, E.uint32(
      /* id 48, wireType 2 =*/
      386
    ).fork()).ldelim(), g.chatInput != null && Object.hasOwnProperty.call(g, "chatInput") && $root.ChatInput.encode(g.chatInput, E.uint32(
      /* id 49, wireType 2 =*/
      394
    ).fork()).ldelim(), g.toast != null && Object.hasOwnProperty.call(g, "toast") && $root.Toast.encode(g.toast, E.uint32(
      /* id 50, wireType 2 =*/
      402
    ).fork()).ldelim(), g.linkButton != null && Object.hasOwnProperty.call(g, "linkButton") && $root.LinkButton.encode(g.linkButton, E.uint32(
      /* id 51, wireType 2 =*/
      410
    ).fork()).ldelim(), g.skeleton != null && Object.hasOwnProperty.call(g, "skeleton") && $root.Skeleton.encode(g.skeleton, E.uint32(
      /* id 52, wireType 2 =*/
      418
    ).fork()).ldelim(), g.pageLink != null && Object.hasOwnProperty.call(g, "pageLink") && $root.PageLink.encode(g.pageLink, E.uint32(
      /* id 53, wireType 2 =*/
      426
    ).fork()).ldelim(), g.html != null && Object.hasOwnProperty.call(g, "html") && $root.Html.encode(g.html, E.uint32(
      /* id 54, wireType 2 =*/
      434
    ).fork()).ldelim(), g.buttonGroup != null && Object.hasOwnProperty.call(g, "buttonGroup") && $root.ButtonGroup.encode(g.buttonGroup, E.uint32(
      /* id 55, wireType 2 =*/
      442
    ).fork()).ldelim(), g.audioInput != null && Object.hasOwnProperty.call(g, "audioInput") && $root.AudioInput.encode(g.audioInput, E.uint32(
      /* id 56, wireType 2 =*/
      450
    ).fork()).ldelim(), g.heightConfig != null && Object.hasOwnProperty.call(g, "heightConfig") && $root.streamlit.HeightConfig.encode(g.heightConfig, E.uint32(
      /* id 57, wireType 2 =*/
      458
    ).fork()).ldelim(), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root.streamlit.WidthConfig.encode(g.widthConfig, E.uint32(
      /* id 58, wireType 2 =*/
      466
    ).fork()).ldelim(), g.bidiComponent != null && Object.hasOwnProperty.call(g, "bidiComponent") && $root.BidiComponent.encode(g.bidiComponent, E.uint32(
      /* id 59, wireType 2 =*/
      474
    ).fork()).ldelim(), g.space != null && Object.hasOwnProperty.call(g, "space") && $root.Space.encode(g.space, E.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), g.textAlignmentConfig != null && Object.hasOwnProperty.call(g, "textAlignmentConfig") && $root.streamlit.TextAlignmentConfig.encode(g.textAlignmentConfig, E.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), g.dateTimeInput != null && Object.hasOwnProperty.call(g, "dateTimeInput") && $root.DateTimeInput.encode(g.dateTimeInput, E.uint32(
      /* id 62, wireType 2 =*/
      498
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Element();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 57: {
          n.heightConfig = $root.streamlit.HeightConfig.decode(g, g.uint32());
          break;
        }
        case 58: {
          n.widthConfig = $root.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        case 61: {
          n.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.decode(g, g.uint32());
          break;
        }
        case 30: {
          n.alert = $root.Alert.decode(g, g.uint32());
          break;
        }
        case 40: {
          n.arrowDataFrame = $root.Arrow.decode(g, g.uint32());
          break;
        }
        case 39: {
          n.arrowTable = $root.Arrow.decode(g, g.uint32());
          break;
        }
        case 41: {
          n.arrowVegaLiteChart = $root.ArrowVegaLiteChart.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.audio = $root.Audio.decode(g, g.uint32());
          break;
        }
        case 56: {
          n.audioInput = $root.AudioInput.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.balloons = $root.Balloons.decode(g, g.uint32());
          break;
        }
        case 59: {
          n.bidiComponent = $root.BidiComponent.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.bokehChart = $root.BokehChart.decode(g, g.uint32());
          break;
        }
        case 19: {
          n.button = $root.Button.decode(g, g.uint32());
          break;
        }
        case 55: {
          n.buttonGroup = $root.ButtonGroup.decode(g, g.uint32());
          break;
        }
        case 43: {
          n.downloadButton = $root.DownloadButton.decode(g, g.uint32());
          break;
        }
        case 45: {
          n.cameraInput = $root.CameraInput.decode(g, g.uint32());
          break;
        }
        case 49: {
          n.chatInput = $root.ChatInput.decode(g, g.uint32());
          break;
        }
        case 20: {
          n.checkbox = $root.Checkbox.decode(g, g.uint32());
          break;
        }
        case 35: {
          n.colorPicker = $root.ColorPicker.decode(g, g.uint32());
          break;
        }
        case 37: {
          n.componentInstance = $root.ComponentInstance.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.dataFrame = $root.DataFrame.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.table = $root.DataFrame.decode(g, g.uint32());
          break;
        }
        case 27: {
          n.dateInput = $root.DateInput.decode(g, g.uint32());
          break;
        }
        case 34: {
          n.deckGlJsonChart = $root.DeckGlJsonChart.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.docString = $root.DocString.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.empty = $root.Empty.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.exception = $root.Exception.decode(g, g.uint32());
          break;
        }
        case 36: {
          n.favicon = $root.Favicon.decode(g, g.uint32());
          break;
        }
        case 33: {
          n.fileUploader = $root.FileUploader.decode(g, g.uint32());
          break;
        }
        case 18: {
          n.graphvizChart = $root.GraphVizChart.decode(g, g.uint32());
          break;
        }
        case 54: {
          n.html = $root.Html.decode(g, g.uint32());
          break;
        }
        case 38: {
          n.iframe = $root.IFrame.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.imgs = $root.ImageList.decode(g, g.uint32());
          break;
        }
        case 31: {
          n.json = $root.Json.decode(g, g.uint32());
          break;
        }
        case 51: {
          n.linkButton = $root.LinkButton.decode(g, g.uint32());
          break;
        }
        case 29: {
          n.markdown = $root.Markdown.decode(g, g.uint32());
          break;
        }
        case 42: {
          n.metric = $root.Metric.decode(g, g.uint32());
          break;
        }
        case 28: {
          n.multiselect = $root.MultiSelect.decode(g, g.uint32());
          break;
        }
        case 32: {
          n.numberInput = $root.NumberInput.decode(g, g.uint32());
          break;
        }
        case 53: {
          n.pageLink = $root.PageLink.decode(g, g.uint32());
          break;
        }
        case 16: {
          n.plotlyChart = $root.PlotlyChart.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.progress = $root.Progress.decode(g, g.uint32());
          break;
        }
        case 23: {
          n.radio = $root.Radio.decode(g, g.uint32());
          break;
        }
        case 25: {
          n.selectbox = $root.Selectbox.decode(g, g.uint32());
          break;
        }
        case 52: {
          n.skeleton = $root.Skeleton.decode(g, g.uint32());
          break;
        }
        case 21: {
          n.slider = $root.Slider.decode(g, g.uint32());
          break;
        }
        case 46: {
          n.snow = $root.Snow.decode(g, g.uint32());
          break;
        }
        case 60: {
          n.space = $root.Space.decode(g, g.uint32());
          break;
        }
        case 44: {
          n.spinner = $root.Spinner.decode(g, g.uint32());
          break;
        }
        case 1: {
          n.text = $root.Text.decode(g, g.uint32());
          break;
        }
        case 22: {
          n.textArea = $root.TextArea.decode(g, g.uint32());
          break;
        }
        case 24: {
          n.textInput = $root.TextInput.decode(g, g.uint32());
          break;
        }
        case 26: {
          n.timeInput = $root.TimeInput.decode(g, g.uint32());
          break;
        }
        case 62: {
          n.dateTimeInput = $root.DateTimeInput.decode(g, g.uint32());
          break;
        }
        case 50: {
          n.toast = $root.Toast.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.vegaLiteChart = $root.VegaLiteChart.decode(g, g.uint32());
          break;
        }
        case 14: {
          n.video = $root.Video.decode(g, g.uint32());
          break;
        }
        case 47: {
          n.heading = $root.Heading.decode(g, g.uint32());
          break;
        }
        case 48: {
          n.code = $root.Code.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Element) return g;
    let E = new $root.Element();
    if (g.heightConfig != null) {
      if (typeof g.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
      E.heightConfig = $root.streamlit.HeightConfig.fromObject(g.heightConfig);
    }
    if (g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
      E.widthConfig = $root.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    if (g.textAlignmentConfig != null) {
      if (typeof g.textAlignmentConfig != "object") throw TypeError(".Element.textAlignmentConfig: object expected");
      E.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.fromObject(g.textAlignmentConfig);
    }
    if (g.alert != null) {
      if (typeof g.alert != "object") throw TypeError(".Element.alert: object expected");
      E.alert = $root.Alert.fromObject(g.alert);
    }
    if (g.arrowDataFrame != null) {
      if (typeof g.arrowDataFrame != "object") throw TypeError(".Element.arrowDataFrame: object expected");
      E.arrowDataFrame = $root.Arrow.fromObject(g.arrowDataFrame);
    }
    if (g.arrowTable != null) {
      if (typeof g.arrowTable != "object") throw TypeError(".Element.arrowTable: object expected");
      E.arrowTable = $root.Arrow.fromObject(g.arrowTable);
    }
    if (g.arrowVegaLiteChart != null) {
      if (typeof g.arrowVegaLiteChart != "object") throw TypeError(".Element.arrowVegaLiteChart: object expected");
      E.arrowVegaLiteChart = $root.ArrowVegaLiteChart.fromObject(g.arrowVegaLiteChart);
    }
    if (g.audio != null) {
      if (typeof g.audio != "object") throw TypeError(".Element.audio: object expected");
      E.audio = $root.Audio.fromObject(g.audio);
    }
    if (g.audioInput != null) {
      if (typeof g.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
      E.audioInput = $root.AudioInput.fromObject(g.audioInput);
    }
    if (g.balloons != null) {
      if (typeof g.balloons != "object") throw TypeError(".Element.balloons: object expected");
      E.balloons = $root.Balloons.fromObject(g.balloons);
    }
    if (g.bidiComponent != null) {
      if (typeof g.bidiComponent != "object") throw TypeError(".Element.bidiComponent: object expected");
      E.bidiComponent = $root.BidiComponent.fromObject(g.bidiComponent);
    }
    if (g.bokehChart != null) {
      if (typeof g.bokehChart != "object") throw TypeError(".Element.bokehChart: object expected");
      E.bokehChart = $root.BokehChart.fromObject(g.bokehChart);
    }
    if (g.button != null) {
      if (typeof g.button != "object") throw TypeError(".Element.button: object expected");
      E.button = $root.Button.fromObject(g.button);
    }
    if (g.buttonGroup != null) {
      if (typeof g.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
      E.buttonGroup = $root.ButtonGroup.fromObject(g.buttonGroup);
    }
    if (g.downloadButton != null) {
      if (typeof g.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
      E.downloadButton = $root.DownloadButton.fromObject(g.downloadButton);
    }
    if (g.cameraInput != null) {
      if (typeof g.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
      E.cameraInput = $root.CameraInput.fromObject(g.cameraInput);
    }
    if (g.chatInput != null) {
      if (typeof g.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
      E.chatInput = $root.ChatInput.fromObject(g.chatInput);
    }
    if (g.checkbox != null) {
      if (typeof g.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
      E.checkbox = $root.Checkbox.fromObject(g.checkbox);
    }
    if (g.colorPicker != null) {
      if (typeof g.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
      E.colorPicker = $root.ColorPicker.fromObject(g.colorPicker);
    }
    if (g.componentInstance != null) {
      if (typeof g.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
      E.componentInstance = $root.ComponentInstance.fromObject(g.componentInstance);
    }
    if (g.dataFrame != null) {
      if (typeof g.dataFrame != "object") throw TypeError(".Element.dataFrame: object expected");
      E.dataFrame = $root.DataFrame.fromObject(g.dataFrame);
    }
    if (g.table != null) {
      if (typeof g.table != "object") throw TypeError(".Element.table: object expected");
      E.table = $root.DataFrame.fromObject(g.table);
    }
    if (g.dateInput != null) {
      if (typeof g.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
      E.dateInput = $root.DateInput.fromObject(g.dateInput);
    }
    if (g.deckGlJsonChart != null) {
      if (typeof g.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
      E.deckGlJsonChart = $root.DeckGlJsonChart.fromObject(g.deckGlJsonChart);
    }
    if (g.docString != null) {
      if (typeof g.docString != "object") throw TypeError(".Element.docString: object expected");
      E.docString = $root.DocString.fromObject(g.docString);
    }
    if (g.empty != null) {
      if (typeof g.empty != "object") throw TypeError(".Element.empty: object expected");
      E.empty = $root.Empty.fromObject(g.empty);
    }
    if (g.exception != null) {
      if (typeof g.exception != "object") throw TypeError(".Element.exception: object expected");
      E.exception = $root.Exception.fromObject(g.exception);
    }
    if (g.favicon != null) {
      if (typeof g.favicon != "object") throw TypeError(".Element.favicon: object expected");
      E.favicon = $root.Favicon.fromObject(g.favicon);
    }
    if (g.fileUploader != null) {
      if (typeof g.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
      E.fileUploader = $root.FileUploader.fromObject(g.fileUploader);
    }
    if (g.graphvizChart != null) {
      if (typeof g.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
      E.graphvizChart = $root.GraphVizChart.fromObject(g.graphvizChart);
    }
    if (g.html != null) {
      if (typeof g.html != "object") throw TypeError(".Element.html: object expected");
      E.html = $root.Html.fromObject(g.html);
    }
    if (g.iframe != null) {
      if (typeof g.iframe != "object") throw TypeError(".Element.iframe: object expected");
      E.iframe = $root.IFrame.fromObject(g.iframe);
    }
    if (g.imgs != null) {
      if (typeof g.imgs != "object") throw TypeError(".Element.imgs: object expected");
      E.imgs = $root.ImageList.fromObject(g.imgs);
    }
    if (g.json != null) {
      if (typeof g.json != "object") throw TypeError(".Element.json: object expected");
      E.json = $root.Json.fromObject(g.json);
    }
    if (g.linkButton != null) {
      if (typeof g.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
      E.linkButton = $root.LinkButton.fromObject(g.linkButton);
    }
    if (g.markdown != null) {
      if (typeof g.markdown != "object") throw TypeError(".Element.markdown: object expected");
      E.markdown = $root.Markdown.fromObject(g.markdown);
    }
    if (g.metric != null) {
      if (typeof g.metric != "object") throw TypeError(".Element.metric: object expected");
      E.metric = $root.Metric.fromObject(g.metric);
    }
    if (g.multiselect != null) {
      if (typeof g.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
      E.multiselect = $root.MultiSelect.fromObject(g.multiselect);
    }
    if (g.numberInput != null) {
      if (typeof g.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
      E.numberInput = $root.NumberInput.fromObject(g.numberInput);
    }
    if (g.pageLink != null) {
      if (typeof g.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
      E.pageLink = $root.PageLink.fromObject(g.pageLink);
    }
    if (g.plotlyChart != null) {
      if (typeof g.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
      E.plotlyChart = $root.PlotlyChart.fromObject(g.plotlyChart);
    }
    if (g.progress != null) {
      if (typeof g.progress != "object") throw TypeError(".Element.progress: object expected");
      E.progress = $root.Progress.fromObject(g.progress);
    }
    if (g.radio != null) {
      if (typeof g.radio != "object") throw TypeError(".Element.radio: object expected");
      E.radio = $root.Radio.fromObject(g.radio);
    }
    if (g.selectbox != null) {
      if (typeof g.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
      E.selectbox = $root.Selectbox.fromObject(g.selectbox);
    }
    if (g.skeleton != null) {
      if (typeof g.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
      E.skeleton = $root.Skeleton.fromObject(g.skeleton);
    }
    if (g.slider != null) {
      if (typeof g.slider != "object") throw TypeError(".Element.slider: object expected");
      E.slider = $root.Slider.fromObject(g.slider);
    }
    if (g.snow != null) {
      if (typeof g.snow != "object") throw TypeError(".Element.snow: object expected");
      E.snow = $root.Snow.fromObject(g.snow);
    }
    if (g.space != null) {
      if (typeof g.space != "object") throw TypeError(".Element.space: object expected");
      E.space = $root.Space.fromObject(g.space);
    }
    if (g.spinner != null) {
      if (typeof g.spinner != "object") throw TypeError(".Element.spinner: object expected");
      E.spinner = $root.Spinner.fromObject(g.spinner);
    }
    if (g.text != null) {
      if (typeof g.text != "object") throw TypeError(".Element.text: object expected");
      E.text = $root.Text.fromObject(g.text);
    }
    if (g.textArea != null) {
      if (typeof g.textArea != "object") throw TypeError(".Element.textArea: object expected");
      E.textArea = $root.TextArea.fromObject(g.textArea);
    }
    if (g.textInput != null) {
      if (typeof g.textInput != "object") throw TypeError(".Element.textInput: object expected");
      E.textInput = $root.TextInput.fromObject(g.textInput);
    }
    if (g.timeInput != null) {
      if (typeof g.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
      E.timeInput = $root.TimeInput.fromObject(g.timeInput);
    }
    if (g.dateTimeInput != null) {
      if (typeof g.dateTimeInput != "object") throw TypeError(".Element.dateTimeInput: object expected");
      E.dateTimeInput = $root.DateTimeInput.fromObject(g.dateTimeInput);
    }
    if (g.toast != null) {
      if (typeof g.toast != "object") throw TypeError(".Element.toast: object expected");
      E.toast = $root.Toast.fromObject(g.toast);
    }
    if (g.vegaLiteChart != null) {
      if (typeof g.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
      E.vegaLiteChart = $root.VegaLiteChart.fromObject(g.vegaLiteChart);
    }
    if (g.video != null) {
      if (typeof g.video != "object") throw TypeError(".Element.video: object expected");
      E.video = $root.Video.fromObject(g.video);
    }
    if (g.heading != null) {
      if (typeof g.heading != "object") throw TypeError(".Element.heading: object expected");
      E.heading = $root.Heading.fromObject(g.heading);
    }
    if (g.code != null) {
      if (typeof g.code != "object") throw TypeError(".Element.code: object expected");
      E.code = $root.Code.fromObject(g.code);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return g.text != null && g.hasOwnProperty("text") && (e.text = $root.Text.toObject(g.text, E), E.oneofs && (e.type = "text")), g.empty != null && g.hasOwnProperty("empty") && (e.empty = $root.Empty.toObject(g.empty, E), E.oneofs && (e.type = "empty")), g.dataFrame != null && g.hasOwnProperty("dataFrame") && (e.dataFrame = $root.DataFrame.toObject(g.dataFrame, E), E.oneofs && (e.type = "dataFrame")), g.progress != null && g.hasOwnProperty("progress") && (e.progress = $root.Progress.toObject(g.progress, E), E.oneofs && (e.type = "progress")), g.imgs != null && g.hasOwnProperty("imgs") && (e.imgs = $root.ImageList.toObject(g.imgs, E), E.oneofs && (e.type = "imgs")), g.docString != null && g.hasOwnProperty("docString") && (e.docString = $root.DocString.toObject(g.docString, E), E.oneofs && (e.type = "docString")), g.exception != null && g.hasOwnProperty("exception") && (e.exception = $root.Exception.toObject(g.exception, E), E.oneofs && (e.type = "exception")), g.vegaLiteChart != null && g.hasOwnProperty("vegaLiteChart") && (e.vegaLiteChart = $root.VegaLiteChart.toObject(g.vegaLiteChart, E), E.oneofs && (e.type = "vegaLiteChart")), g.table != null && g.hasOwnProperty("table") && (e.table = $root.DataFrame.toObject(g.table, E), E.oneofs && (e.type = "table")), g.balloons != null && g.hasOwnProperty("balloons") && (e.balloons = $root.Balloons.toObject(g.balloons, E), E.oneofs && (e.type = "balloons")), g.audio != null && g.hasOwnProperty("audio") && (e.audio = $root.Audio.toObject(g.audio, E), E.oneofs && (e.type = "audio")), g.video != null && g.hasOwnProperty("video") && (e.video = $root.Video.toObject(g.video, E), E.oneofs && (e.type = "video")), g.plotlyChart != null && g.hasOwnProperty("plotlyChart") && (e.plotlyChart = $root.PlotlyChart.toObject(g.plotlyChart, E), E.oneofs && (e.type = "plotlyChart")), g.bokehChart != null && g.hasOwnProperty("bokehChart") && (e.bokehChart = $root.BokehChart.toObject(g.bokehChart, E), E.oneofs && (e.type = "bokehChart")), g.graphvizChart != null && g.hasOwnProperty("graphvizChart") && (e.graphvizChart = $root.GraphVizChart.toObject(g.graphvizChart, E), E.oneofs && (e.type = "graphvizChart")), g.button != null && g.hasOwnProperty("button") && (e.button = $root.Button.toObject(g.button, E), E.oneofs && (e.type = "button")), g.checkbox != null && g.hasOwnProperty("checkbox") && (e.checkbox = $root.Checkbox.toObject(g.checkbox, E), E.oneofs && (e.type = "checkbox")), g.slider != null && g.hasOwnProperty("slider") && (e.slider = $root.Slider.toObject(g.slider, E), E.oneofs && (e.type = "slider")), g.textArea != null && g.hasOwnProperty("textArea") && (e.textArea = $root.TextArea.toObject(g.textArea, E), E.oneofs && (e.type = "textArea")), g.radio != null && g.hasOwnProperty("radio") && (e.radio = $root.Radio.toObject(g.radio, E), E.oneofs && (e.type = "radio")), g.textInput != null && g.hasOwnProperty("textInput") && (e.textInput = $root.TextInput.toObject(g.textInput, E), E.oneofs && (e.type = "textInput")), g.selectbox != null && g.hasOwnProperty("selectbox") && (e.selectbox = $root.Selectbox.toObject(g.selectbox, E), E.oneofs && (e.type = "selectbox")), g.timeInput != null && g.hasOwnProperty("timeInput") && (e.timeInput = $root.TimeInput.toObject(g.timeInput, E), E.oneofs && (e.type = "timeInput")), g.dateInput != null && g.hasOwnProperty("dateInput") && (e.dateInput = $root.DateInput.toObject(g.dateInput, E), E.oneofs && (e.type = "dateInput")), g.multiselect != null && g.hasOwnProperty("multiselect") && (e.multiselect = $root.MultiSelect.toObject(g.multiselect, E), E.oneofs && (e.type = "multiselect")), g.markdown != null && g.hasOwnProperty("markdown") && (e.markdown = $root.Markdown.toObject(g.markdown, E), E.oneofs && (e.type = "markdown")), g.alert != null && g.hasOwnProperty("alert") && (e.alert = $root.Alert.toObject(g.alert, E), E.oneofs && (e.type = "alert")), g.json != null && g.hasOwnProperty("json") && (e.json = $root.Json.toObject(g.json, E), E.oneofs && (e.type = "json")), g.numberInput != null && g.hasOwnProperty("numberInput") && (e.numberInput = $root.NumberInput.toObject(g.numberInput, E), E.oneofs && (e.type = "numberInput")), g.fileUploader != null && g.hasOwnProperty("fileUploader") && (e.fileUploader = $root.FileUploader.toObject(g.fileUploader, E), E.oneofs && (e.type = "fileUploader")), g.deckGlJsonChart != null && g.hasOwnProperty("deckGlJsonChart") && (e.deckGlJsonChart = $root.DeckGlJsonChart.toObject(g.deckGlJsonChart, E), E.oneofs && (e.type = "deckGlJsonChart")), g.colorPicker != null && g.hasOwnProperty("colorPicker") && (e.colorPicker = $root.ColorPicker.toObject(g.colorPicker, E), E.oneofs && (e.type = "colorPicker")), g.favicon != null && g.hasOwnProperty("favicon") && (e.favicon = $root.Favicon.toObject(g.favicon, E), E.oneofs && (e.type = "favicon")), g.componentInstance != null && g.hasOwnProperty("componentInstance") && (e.componentInstance = $root.ComponentInstance.toObject(g.componentInstance, E), E.oneofs && (e.type = "componentInstance")), g.iframe != null && g.hasOwnProperty("iframe") && (e.iframe = $root.IFrame.toObject(g.iframe, E), E.oneofs && (e.type = "iframe")), g.arrowTable != null && g.hasOwnProperty("arrowTable") && (e.arrowTable = $root.Arrow.toObject(g.arrowTable, E), E.oneofs && (e.type = "arrowTable")), g.arrowDataFrame != null && g.hasOwnProperty("arrowDataFrame") && (e.arrowDataFrame = $root.Arrow.toObject(g.arrowDataFrame, E), E.oneofs && (e.type = "arrowDataFrame")), g.arrowVegaLiteChart != null && g.hasOwnProperty("arrowVegaLiteChart") && (e.arrowVegaLiteChart = $root.ArrowVegaLiteChart.toObject(g.arrowVegaLiteChart, E), E.oneofs && (e.type = "arrowVegaLiteChart")), g.metric != null && g.hasOwnProperty("metric") && (e.metric = $root.Metric.toObject(g.metric, E), E.oneofs && (e.type = "metric")), g.downloadButton != null && g.hasOwnProperty("downloadButton") && (e.downloadButton = $root.DownloadButton.toObject(g.downloadButton, E), E.oneofs && (e.type = "downloadButton")), g.spinner != null && g.hasOwnProperty("spinner") && (e.spinner = $root.Spinner.toObject(g.spinner, E), E.oneofs && (e.type = "spinner")), g.cameraInput != null && g.hasOwnProperty("cameraInput") && (e.cameraInput = $root.CameraInput.toObject(g.cameraInput, E), E.oneofs && (e.type = "cameraInput")), g.snow != null && g.hasOwnProperty("snow") && (e.snow = $root.Snow.toObject(g.snow, E), E.oneofs && (e.type = "snow")), g.heading != null && g.hasOwnProperty("heading") && (e.heading = $root.Heading.toObject(g.heading, E), E.oneofs && (e.type = "heading")), g.code != null && g.hasOwnProperty("code") && (e.code = $root.Code.toObject(g.code, E), E.oneofs && (e.type = "code")), g.chatInput != null && g.hasOwnProperty("chatInput") && (e.chatInput = $root.ChatInput.toObject(g.chatInput, E), E.oneofs && (e.type = "chatInput")), g.toast != null && g.hasOwnProperty("toast") && (e.toast = $root.Toast.toObject(g.toast, E), E.oneofs && (e.type = "toast")), g.linkButton != null && g.hasOwnProperty("linkButton") && (e.linkButton = $root.LinkButton.toObject(g.linkButton, E), E.oneofs && (e.type = "linkButton")), g.skeleton != null && g.hasOwnProperty("skeleton") && (e.skeleton = $root.Skeleton.toObject(g.skeleton, E), E.oneofs && (e.type = "skeleton")), g.pageLink != null && g.hasOwnProperty("pageLink") && (e.pageLink = $root.PageLink.toObject(g.pageLink, E), E.oneofs && (e.type = "pageLink")), g.html != null && g.hasOwnProperty("html") && (e.html = $root.Html.toObject(g.html, E), E.oneofs && (e.type = "html")), g.buttonGroup != null && g.hasOwnProperty("buttonGroup") && (e.buttonGroup = $root.ButtonGroup.toObject(g.buttonGroup, E), E.oneofs && (e.type = "buttonGroup")), g.audioInput != null && g.hasOwnProperty("audioInput") && (e.audioInput = $root.AudioInput.toObject(g.audioInput, E), E.oneofs && (e.type = "audioInput")), g.heightConfig != null && g.hasOwnProperty("heightConfig") && (e.heightConfig = $root.streamlit.HeightConfig.toObject(g.heightConfig, E), E.oneofs && (e._heightConfig = "heightConfig")), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(g.widthConfig, E), E.oneofs && (e._widthConfig = "widthConfig")), g.bidiComponent != null && g.hasOwnProperty("bidiComponent") && (e.bidiComponent = $root.BidiComponent.toObject(g.bidiComponent, E), E.oneofs && (e.type = "bidiComponent")), g.space != null && g.hasOwnProperty("space") && (e.space = $root.Space.toObject(g.space, E), E.oneofs && (e.type = "space")), g.textAlignmentConfig != null && g.hasOwnProperty("textAlignmentConfig") && (e.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.toObject(g.textAlignmentConfig, E), E.oneofs && (e._textAlignmentConfig = "textAlignmentConfig")), g.dateTimeInput != null && g.hasOwnProperty("dateTimeInput") && (e.dateTimeInput = $root.DateTimeInput.toObject(g.dateTimeInput, E), E.oneofs && (e.type = "dateTimeInput")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Element";
  }, o;
})();
$root.DownloadButton = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.url = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.type = "", o.prototype.icon = "", o.prototype.ignoreRerun = !1, o.prototype.deferredFileId = null, o.prototype.shortcut = "", o.prototype.iconPosition = 0;
  let i;
  return Object.defineProperty(o.prototype, "_deferredFileId", { get: $util.oneOfGetter(i = ["deferredFileId"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.url), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.disabled), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.useContainerWidth), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.type), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.icon), g.ignoreRerun != null && Object.hasOwnProperty.call(g, "ignoreRerun") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.ignoreRerun), g.deferredFileId != null && Object.hasOwnProperty.call(g, "deferredFileId") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.deferredFileId), g.shortcut != null && Object.hasOwnProperty.call(g, "shortcut") && E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.shortcut), g.iconPosition != null && Object.hasOwnProperty.call(g, "iconPosition") && E.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(g.iconPosition), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.DownloadButton();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.bool();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.url = g.string();
          break;
        }
        case 7: {
          n.disabled = g.bool();
          break;
        }
        case 8: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 9: {
          n.type = g.string();
          break;
        }
        case 10: {
          n.icon = g.string();
          break;
        }
        case 11: {
          n.ignoreRerun = g.bool();
          break;
        }
        case 12: {
          n.deferredFileId = g.string();
          break;
        }
        case 13: {
          n.shortcut = g.string();
          break;
        }
        case 14: {
          n.iconPosition = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.DownloadButton) return g;
    let E = new $root.DownloadButton();
    switch (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = !!g.default), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.url != null && (E.url = String(g.url)), g.disabled != null && (E.disabled = !!g.disabled), g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.type != null && (E.type = String(g.type)), g.icon != null && (E.icon = String(g.icon)), g.ignoreRerun != null && (E.ignoreRerun = !!g.ignoreRerun), g.deferredFileId != null && (E.deferredFileId = String(g.deferredFileId)), g.shortcut != null && (E.shortcut = String(g.shortcut)), g.iconPosition) {
      default:
        if (typeof g.iconPosition == "number") {
          E.iconPosition = g.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        E.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        E.iconPosition = 1;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.url = "", e.disabled = !1, e.useContainerWidth = !1, e.type = "", e.icon = "", e.ignoreRerun = !1, e.shortcut = "", e.iconPosition = E.enums === String ? "LEFT" : 0), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.type != null && g.hasOwnProperty("type") && (e.type = g.type), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), g.ignoreRerun != null && g.hasOwnProperty("ignoreRerun") && (e.ignoreRerun = g.ignoreRerun), g.deferredFileId != null && g.hasOwnProperty("deferredFileId") && (e.deferredFileId = g.deferredFileId, E.oneofs && (e._deferredFileId = "deferredFileId")), g.shortcut != null && g.hasOwnProperty("shortcut") && (e.shortcut = g.shortcut), g.iconPosition != null && g.hasOwnProperty("iconPosition") && (e.iconPosition = E.enums === String ? $root.streamlit.ButtonLikeIconPosition[g.iconPosition] === void 0 ? g.iconPosition : $root.streamlit.ButtonLikeIconPosition[g.iconPosition] : g.iconPosition), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DownloadButton";
  }, o;
})();
$root.DocString = (() => {
  function o(i) {
    if (this.members = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.docString = "", o.prototype.type = "", o.prototype.name = "", o.prototype.value = "", o.prototype.members = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.docString != null && Object.hasOwnProperty.call(i, "docString") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.docString), i.type != null && Object.hasOwnProperty.call(i, "type") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.type), i.name != null && Object.hasOwnProperty.call(i, "name") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.name), i.value != null && Object.hasOwnProperty.call(i, "value") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.value), i.members != null && i.members.length) for (let E = 0; E < i.members.length; ++E) $root.Member.encode(i.members[E], g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DocString();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 3: {
          t.docString = i.string();
          break;
        }
        case 4: {
          t.type = i.string();
          break;
        }
        case 6: {
          t.name = i.string();
          break;
        }
        case 7: {
          t.value = i.string();
          break;
        }
        case 8: {
          t.members && t.members.length || (t.members = []), t.members.push($root.Member.decode(i, i.uint32()));
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DocString) return i;
    let g = new $root.DocString();
    if (i.docString != null && (g.docString = String(i.docString)), i.type != null && (g.type = String(i.type)), i.name != null && (g.name = String(i.name)), i.value != null && (g.value = String(i.value)), i.members) {
      if (!Array.isArray(i.members)) throw TypeError(".DocString.members: array expected");
      g.members = [];
      for (let E = 0; E < i.members.length; ++E) {
        if (typeof i.members[E] != "object") throw TypeError(".DocString.members: object expected");
        g.members[E] = $root.Member.fromObject(i.members[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.members = []), g.defaults && (E.docString = "", E.type = "", E.name = "", E.value = ""), i.docString != null && i.hasOwnProperty("docString") && (E.docString = i.docString), i.type != null && i.hasOwnProperty("type") && (E.type = i.type), i.name != null && i.hasOwnProperty("name") && (E.name = i.name), i.value != null && i.hasOwnProperty("value") && (E.value = i.value), i.members && i.members.length) {
      E.members = [];
      for (let e = 0; e < i.members.length; ++e) E.members[e] = $root.Member.toObject(i.members[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DocString";
  }, o;
})();
$root.Member = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.name = "", o.prototype.type = "", o.prototype.value = null, o.prototype.docString = null;
  let i;
  return Object.defineProperty(o.prototype, "contents", { get: $util.oneOfGetter(i = ["value", "docString"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.type), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.value), g.docString != null && Object.hasOwnProperty.call(g, "docString") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.docString), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Member();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.name = g.string();
          break;
        }
        case 2: {
          n.type = g.string();
          break;
        }
        case 3: {
          n.value = g.string();
          break;
        }
        case 4: {
          n.docString = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Member) return g;
    let E = new $root.Member();
    return g.name != null && (E.name = String(g.name)), g.type != null && (E.type = String(g.type)), g.value != null && (E.value = String(g.value)), g.docString != null && (E.docString = String(g.docString)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.name = "", e.type = ""), g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.type != null && g.hasOwnProperty("type") && (e.type = g.type), g.value != null && g.hasOwnProperty("value") && (e.value = g.value, E.oneofs && (e.contents = "value")), g.docString != null && g.hasOwnProperty("docString") && (e.docString = g.docString, E.oneofs && (e.contents = "docString")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Member";
  }, o;
})();
$root.Empty = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Empty();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    return i instanceof $root.Empty ? i : new $root.Empty();
  }, o.toObject = function() {
    return {};
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Empty";
  }, o;
})();
$root.Exception = (() => {
  function o(i) {
    if (this.stackTrace = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.type = "", o.prototype.message = "", o.prototype.messageIsMarkdown = !1, o.prototype.stackTrace = $util.emptyArray, o.prototype.isWarning = !1, o.prototype.widthConfig = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.type != null && Object.hasOwnProperty.call(i, "type") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.type), i.message != null && Object.hasOwnProperty.call(i, "message") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.message), i.stackTrace != null && i.stackTrace.length) for (let E = 0; E < i.stackTrace.length; ++E) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.stackTrace[E]);
    return i.messageIsMarkdown != null && Object.hasOwnProperty.call(i, "messageIsMarkdown") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(i.messageIsMarkdown), i.isWarning != null && Object.hasOwnProperty.call(i, "isWarning") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(i.isWarning), i.widthConfig != null && Object.hasOwnProperty.call(i, "widthConfig") && $root.streamlit.WidthConfig.encode(i.widthConfig, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Exception();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.type = i.string();
          break;
        }
        case 2: {
          t.message = i.string();
          break;
        }
        case 4: {
          t.messageIsMarkdown = i.bool();
          break;
        }
        case 3: {
          t.stackTrace && t.stackTrace.length || (t.stackTrace = []), t.stackTrace.push(i.string());
          break;
        }
        case 5: {
          t.isWarning = i.bool();
          break;
        }
        case 6: {
          t.widthConfig = $root.streamlit.WidthConfig.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Exception) return i;
    let g = new $root.Exception();
    if (i.type != null && (g.type = String(i.type)), i.message != null && (g.message = String(i.message)), i.messageIsMarkdown != null && (g.messageIsMarkdown = !!i.messageIsMarkdown), i.stackTrace) {
      if (!Array.isArray(i.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
      g.stackTrace = [];
      for (let E = 0; E < i.stackTrace.length; ++E) g.stackTrace[E] = String(i.stackTrace[E]);
    }
    if (i.isWarning != null && (g.isWarning = !!i.isWarning), i.widthConfig != null) {
      if (typeof i.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
      g.widthConfig = $root.streamlit.WidthConfig.fromObject(i.widthConfig);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.stackTrace = []), g.defaults && (E.type = "", E.message = "", E.messageIsMarkdown = !1, E.isWarning = !1, E.widthConfig = null), i.type != null && i.hasOwnProperty("type") && (E.type = i.type), i.message != null && i.hasOwnProperty("message") && (E.message = i.message), i.stackTrace && i.stackTrace.length) {
      E.stackTrace = [];
      for (let e = 0; e < i.stackTrace.length; ++e) E.stackTrace[e] = i.stackTrace[e];
    }
    return i.messageIsMarkdown != null && i.hasOwnProperty("messageIsMarkdown") && (E.messageIsMarkdown = i.messageIsMarkdown), i.isWarning != null && i.hasOwnProperty("isWarning") && (E.isWarning = i.isWarning), i.widthConfig != null && i.hasOwnProperty("widthConfig") && (E.widthConfig = $root.streamlit.WidthConfig.toObject(i.widthConfig, g)), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Exception";
  }, o;
})();
$root.Favicon = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.url = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.url != null && Object.hasOwnProperty.call(i, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.url), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Favicon();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.url = i.string() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Favicon) return i;
    let g = new $root.Favicon();
    return i.url != null && (g.url = String(i.url)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.url = ""), i.url != null && i.hasOwnProperty("url") && (E.url = i.url), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Favicon";
  }, o;
})();
$root.FileUploader = (() => {
  function o(i) {
    if (this.type = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.type = $util.emptyArray, o.prototype.maxUploadSizeMb = 0, o.prototype.multipleFiles = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.acceptDirectory = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.label), i.type != null && i.type.length) for (let E = 0; E < i.type.length; ++E) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.type[E]);
    return i.maxUploadSizeMb != null && Object.hasOwnProperty.call(i, "maxUploadSizeMb") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(i.maxUploadSizeMb), i.multipleFiles != null && Object.hasOwnProperty.call(i, "multipleFiles") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(i.multipleFiles), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.help), i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(i.formId), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(i.disabled), i.labelVisibility != null && Object.hasOwnProperty.call(i, "labelVisibility") && $root.LabelVisibilityMessage.encode(i.labelVisibility, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), i.acceptDirectory != null && Object.hasOwnProperty.call(i, "acceptDirectory") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(i.acceptDirectory), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.FileUploader();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.label = i.string();
          break;
        }
        case 3: {
          t.type && t.type.length || (t.type = []), t.type.push(i.string());
          break;
        }
        case 4: {
          t.maxUploadSizeMb = i.int32();
          break;
        }
        case 6: {
          t.multipleFiles = i.bool();
          break;
        }
        case 7: {
          t.help = i.string();
          break;
        }
        case 8: {
          t.formId = i.string();
          break;
        }
        case 9: {
          t.disabled = i.bool();
          break;
        }
        case 10: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(i, i.uint32());
          break;
        }
        case 11: {
          t.acceptDirectory = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.FileUploader) return i;
    let g = new $root.FileUploader();
    if (i.id != null && (g.id = String(i.id)), i.label != null && (g.label = String(i.label)), i.type) {
      if (!Array.isArray(i.type)) throw TypeError(".FileUploader.type: array expected");
      g.type = [];
      for (let E = 0; E < i.type.length; ++E) g.type[E] = String(i.type[E]);
    }
    if (i.maxUploadSizeMb != null && (g.maxUploadSizeMb = i.maxUploadSizeMb | 0), i.multipleFiles != null && (g.multipleFiles = !!i.multipleFiles), i.help != null && (g.help = String(i.help)), i.formId != null && (g.formId = String(i.formId)), i.disabled != null && (g.disabled = !!i.disabled), i.labelVisibility != null) {
      if (typeof i.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(i.labelVisibility);
    }
    return i.acceptDirectory != null && (g.acceptDirectory = !!i.acceptDirectory), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.type = []), g.defaults && (E.id = "", E.label = "", E.maxUploadSizeMb = 0, E.multipleFiles = !1, E.help = "", E.formId = "", E.disabled = !1, E.labelVisibility = null, E.acceptDirectory = !1), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.type && i.type.length) {
      E.type = [];
      for (let e = 0; e < i.type.length; ++e) E.type[e] = i.type[e];
    }
    return i.maxUploadSizeMb != null && i.hasOwnProperty("maxUploadSizeMb") && (E.maxUploadSizeMb = i.maxUploadSizeMb), i.multipleFiles != null && i.hasOwnProperty("multipleFiles") && (E.multipleFiles = i.multipleFiles), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.labelVisibility != null && i.hasOwnProperty("labelVisibility") && (E.labelVisibility = $root.LabelVisibilityMessage.toObject(i.labelVisibility, g)), i.acceptDirectory != null && i.hasOwnProperty("acceptDirectory") && (E.acceptDirectory = i.acceptDirectory), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/FileUploader";
  }, o;
})();
$root.GraphVizChart = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.spec = "", o.prototype.useContainerWidth = !1, o.prototype.elementId = "", o.prototype.engine = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.spec != null && Object.hasOwnProperty.call(i, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.spec), i.useContainerWidth != null && Object.hasOwnProperty.call(i, "useContainerWidth") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(i.useContainerWidth), i.elementId != null && Object.hasOwnProperty.call(i, "elementId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.elementId), i.engine != null && Object.hasOwnProperty.call(i, "engine") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.engine), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.GraphVizChart();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.spec = i.string();
          break;
        }
        case 4: {
          t.useContainerWidth = i.bool();
          break;
        }
        case 5: {
          t.elementId = i.string();
          break;
        }
        case 6: {
          t.engine = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.GraphVizChart) return i;
    let g = new $root.GraphVizChart();
    return i.spec != null && (g.spec = String(i.spec)), i.useContainerWidth != null && (g.useContainerWidth = !!i.useContainerWidth), i.elementId != null && (g.elementId = String(i.elementId)), i.engine != null && (g.engine = String(i.engine)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.spec = "", E.useContainerWidth = !1, E.elementId = "", E.engine = ""), i.spec != null && i.hasOwnProperty("spec") && (E.spec = i.spec), i.useContainerWidth != null && i.hasOwnProperty("useContainerWidth") && (E.useContainerWidth = i.useContainerWidth), i.elementId != null && i.hasOwnProperty("elementId") && (E.elementId = i.elementId), i.engine != null && i.hasOwnProperty("engine") && (E.engine = i.engine), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/GraphVizChart";
  }, o;
})();
$root.Html = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.body = "", o.prototype.unsafeAllowJavascript = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.body != null && Object.hasOwnProperty.call(i, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.body), i.unsafeAllowJavascript != null && Object.hasOwnProperty.call(i, "unsafeAllowJavascript") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(i.unsafeAllowJavascript), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Html();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.body = i.string();
          break;
        }
        case 2: {
          t.unsafeAllowJavascript = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Html) return i;
    let g = new $root.Html();
    return i.body != null && (g.body = String(i.body)), i.unsafeAllowJavascript != null && (g.unsafeAllowJavascript = !!i.unsafeAllowJavascript), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.body = "", E.unsafeAllowJavascript = !1), i.body != null && i.hasOwnProperty("body") && (E.body = i.body), i.unsafeAllowJavascript != null && i.hasOwnProperty("unsafeAllowJavascript") && (E.unsafeAllowJavascript = i.unsafeAllowJavascript), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Html";
  }, o;
})();
$root.IFrame = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.src = null, o.prototype.srcdoc = null, o.prototype.width = 0, o.prototype.hasWidth = !1, o.prototype.height = 0, o.prototype.scrolling = !1, o.prototype.tabIndex = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["src", "srcdoc"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_tabIndex", { get: $util.oneOfGetter(i = ["tabIndex"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.src != null && Object.hasOwnProperty.call(g, "src") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.src), g.srcdoc != null && Object.hasOwnProperty.call(g, "srcdoc") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.srcdoc), g.width != null && Object.hasOwnProperty.call(g, "width") && E.uint32(
      /* id 3, wireType 5 =*/
      29
    ).float(g.width), g.hasWidth != null && Object.hasOwnProperty.call(g, "hasWidth") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.hasWidth), g.height != null && Object.hasOwnProperty.call(g, "height") && E.uint32(
      /* id 5, wireType 5 =*/
      45
    ).float(g.height), g.scrolling != null && Object.hasOwnProperty.call(g, "scrolling") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.scrolling), g.tabIndex != null && Object.hasOwnProperty.call(g, "tabIndex") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.tabIndex), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.IFrame();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.src = g.string();
          break;
        }
        case 2: {
          n.srcdoc = g.string();
          break;
        }
        case 3: {
          n.width = g.float();
          break;
        }
        case 4: {
          n.hasWidth = g.bool();
          break;
        }
        case 5: {
          n.height = g.float();
          break;
        }
        case 7: {
          n.scrolling = g.bool();
          break;
        }
        case 8: {
          n.tabIndex = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.IFrame) return g;
    let E = new $root.IFrame();
    return g.src != null && (E.src = String(g.src)), g.srcdoc != null && (E.srcdoc = String(g.srcdoc)), g.width != null && (E.width = Number(g.width)), g.hasWidth != null && (E.hasWidth = !!g.hasWidth), g.height != null && (E.height = Number(g.height)), g.scrolling != null && (E.scrolling = !!g.scrolling), g.tabIndex != null && (E.tabIndex = g.tabIndex | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.width = 0, e.hasWidth = !1, e.height = 0, e.scrolling = !1), g.src != null && g.hasOwnProperty("src") && (e.src = g.src, E.oneofs && (e.type = "src")), g.srcdoc != null && g.hasOwnProperty("srcdoc") && (e.srcdoc = g.srcdoc, E.oneofs && (e.type = "srcdoc")), g.width != null && g.hasOwnProperty("width") && (e.width = E.json && !isFinite(g.width) ? String(g.width) : g.width), g.hasWidth != null && g.hasOwnProperty("hasWidth") && (e.hasWidth = g.hasWidth), g.height != null && g.hasOwnProperty("height") && (e.height = E.json && !isFinite(g.height) ? String(g.height) : g.height), g.scrolling != null && g.hasOwnProperty("scrolling") && (e.scrolling = g.scrolling), g.tabIndex != null && g.hasOwnProperty("tabIndex") && (e.tabIndex = g.tabIndex, E.oneofs && (e._tabIndex = "tabIndex")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/IFrame";
  }, o;
})();
$root.Image = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.url = "", o.prototype.caption = "", o.prototype.markup = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.caption != null && Object.hasOwnProperty.call(i, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.caption), i.url != null && Object.hasOwnProperty.call(i, "url") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.url), i.markup != null && Object.hasOwnProperty.call(i, "markup") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.markup), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Image();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 3: {
          t.url = i.string();
          break;
        }
        case 2: {
          t.caption = i.string();
          break;
        }
        case 4: {
          t.markup = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Image) return i;
    let g = new $root.Image();
    return i.url != null && (g.url = String(i.url)), i.caption != null && (g.caption = String(i.caption)), i.markup != null && (g.markup = String(i.markup)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.caption = "", E.url = "", E.markup = ""), i.caption != null && i.hasOwnProperty("caption") && (E.caption = i.caption), i.url != null && i.hasOwnProperty("url") && (E.url = i.url), i.markup != null && i.hasOwnProperty("markup") && (E.markup = i.markup), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Image";
  }, o;
})();
$root.ImageList = (() => {
  function o(i) {
    if (this.imgs = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.imgs = $util.emptyArray, o.prototype.width = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.imgs != null && i.imgs.length) for (let E = 0; E < i.imgs.length; ++E) $root.Image.encode(i.imgs[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return i.width != null && Object.hasOwnProperty.call(i, "width") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(i.width), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ImageList();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.imgs && t.imgs.length || (t.imgs = []), t.imgs.push($root.Image.decode(i, i.uint32()));
          break;
        }
        case 2: {
          t.width = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ImageList) return i;
    let g = new $root.ImageList();
    if (i.imgs) {
      if (!Array.isArray(i.imgs)) throw TypeError(".ImageList.imgs: array expected");
      g.imgs = [];
      for (let E = 0; E < i.imgs.length; ++E) {
        if (typeof i.imgs[E] != "object") throw TypeError(".ImageList.imgs: object expected");
        g.imgs[E] = $root.Image.fromObject(i.imgs[E]);
      }
    }
    return i.width != null && (g.width = i.width | 0), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.imgs = []), g.defaults && (E.width = 0), i.imgs && i.imgs.length) {
      E.imgs = [];
      for (let e = 0; e < i.imgs.length; ++e) E.imgs[e] = $root.Image.toObject(i.imgs[e], g);
    }
    return i.width != null && i.hasOwnProperty("width") && (E.width = i.width), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ImageList";
  }, o;
})();
$root.Json = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.body = "", o.prototype.expanded = !1, o.prototype.maxExpandDepth = null;
  let i;
  return Object.defineProperty(o.prototype, "_maxExpandDepth", { get: $util.oneOfGetter(i = ["maxExpandDepth"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.expanded != null && Object.hasOwnProperty.call(g, "expanded") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.expanded), g.maxExpandDepth != null && Object.hasOwnProperty.call(g, "maxExpandDepth") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.maxExpandDepth), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Json();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.body = g.string();
          break;
        }
        case 2: {
          n.expanded = g.bool();
          break;
        }
        case 3: {
          n.maxExpandDepth = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Json) return g;
    let E = new $root.Json();
    return g.body != null && (E.body = String(g.body)), g.expanded != null && (E.expanded = !!g.expanded), g.maxExpandDepth != null && (E.maxExpandDepth = g.maxExpandDepth | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.body = "", e.expanded = !1), g.body != null && g.hasOwnProperty("body") && (e.body = g.body), g.expanded != null && g.hasOwnProperty("expanded") && (e.expanded = g.expanded), g.maxExpandDepth != null && g.hasOwnProperty("maxExpandDepth") && (e.maxExpandDepth = g.maxExpandDepth, E.oneofs && (e._maxExpandDepth = "maxExpandDepth")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Json";
  }, o;
})();
$root.LinkButton = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.url = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.type = "", o.prototype.icon = "", o.prototype.shortcut = "", o.prototype.iconPosition = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.label), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.help), i.url != null && Object.hasOwnProperty.call(i, "url") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.url), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(i.disabled), i.useContainerWidth != null && Object.hasOwnProperty.call(i, "useContainerWidth") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(i.useContainerWidth), i.type != null && Object.hasOwnProperty.call(i, "type") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(i.type), i.icon != null && Object.hasOwnProperty.call(i, "icon") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(i.icon), i.shortcut != null && Object.hasOwnProperty.call(i, "shortcut") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(i.shortcut), i.iconPosition != null && Object.hasOwnProperty.call(i, "iconPosition") && g.uint32(
      /* id 12, wireType 0 =*/
      96
    ).int32(i.iconPosition), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.LinkButton();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.label = i.string();
          break;
        }
        case 4: {
          t.help = i.string();
          break;
        }
        case 6: {
          t.url = i.string();
          break;
        }
        case 7: {
          t.disabled = i.bool();
          break;
        }
        case 8: {
          t.useContainerWidth = i.bool();
          break;
        }
        case 9: {
          t.type = i.string();
          break;
        }
        case 10: {
          t.icon = i.string();
          break;
        }
        case 11: {
          t.shortcut = i.string();
          break;
        }
        case 12: {
          t.iconPosition = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.LinkButton) return i;
    let g = new $root.LinkButton();
    switch (i.id != null && (g.id = String(i.id)), i.label != null && (g.label = String(i.label)), i.help != null && (g.help = String(i.help)), i.url != null && (g.url = String(i.url)), i.disabled != null && (g.disabled = !!i.disabled), i.useContainerWidth != null && (g.useContainerWidth = !!i.useContainerWidth), i.type != null && (g.type = String(i.type)), i.icon != null && (g.icon = String(i.icon)), i.shortcut != null && (g.shortcut = String(i.shortcut)), i.iconPosition) {
      default:
        if (typeof i.iconPosition == "number") {
          g.iconPosition = i.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        g.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        g.iconPosition = 1;
        break;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.id = "", E.label = "", E.help = "", E.url = "", E.disabled = !1, E.useContainerWidth = !1, E.type = "", E.icon = "", E.shortcut = "", E.iconPosition = g.enums === String ? "LEFT" : 0), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.url != null && i.hasOwnProperty("url") && (E.url = i.url), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.useContainerWidth != null && i.hasOwnProperty("useContainerWidth") && (E.useContainerWidth = i.useContainerWidth), i.type != null && i.hasOwnProperty("type") && (E.type = i.type), i.icon != null && i.hasOwnProperty("icon") && (E.icon = i.icon), i.shortcut != null && i.hasOwnProperty("shortcut") && (E.shortcut = i.shortcut), i.iconPosition != null && i.hasOwnProperty("iconPosition") && (E.iconPosition = g.enums === String ? $root.streamlit.ButtonLikeIconPosition[i.iconPosition] === void 0 ? i.iconPosition : $root.streamlit.ButtonLikeIconPosition[i.iconPosition] : i.iconPosition), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/LinkButton";
  }, o;
})();
$root.NumberInput = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.formId = "", o.prototype.format = "", o.prototype.hasMin = !1, o.prototype.hasMax = !1, o.prototype.dataType = 0, o.prototype.default = null, o.prototype.step = 0, o.prototype.min = 0, o.prototype.max = 0, o.prototype.help = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.placeholder = "", o.prototype.icon = "";
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(i = ["default"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(i = ["value"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.formId), g.format != null && Object.hasOwnProperty.call(g, "format") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.format), g.hasMin != null && Object.hasOwnProperty.call(g, "hasMin") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.hasMin), g.hasMax != null && Object.hasOwnProperty.call(g, "hasMax") && E.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.hasMax), g.dataType != null && Object.hasOwnProperty.call(g, "dataType") && E.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(g.dataType), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 14, wireType 1 =*/
      113
    ).double(g.default), g.step != null && Object.hasOwnProperty.call(g, "step") && E.uint32(
      /* id 15, wireType 1 =*/
      121
    ).double(g.step), g.min != null && Object.hasOwnProperty.call(g, "min") && E.uint32(
      /* id 16, wireType 1 =*/
      129
    ).double(g.min), g.max != null && Object.hasOwnProperty.call(g, "max") && E.uint32(
      /* id 17, wireType 1 =*/
      137
    ).double(g.max), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.help), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 19, wireType 1 =*/
      153
    ).double(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 21, wireType 0 =*/
      168
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && E.uint32(
      /* id 23, wireType 2 =*/
      186
    ).string(g.placeholder), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 24, wireType 2 =*/
      194
    ).string(g.icon), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.NumberInput();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.formId = g.string();
          break;
        }
        case 8: {
          n.format = g.string();
          break;
        }
        case 11: {
          n.hasMin = g.bool();
          break;
        }
        case 12: {
          n.hasMax = g.bool();
          break;
        }
        case 13: {
          n.dataType = g.int32();
          break;
        }
        case 14: {
          n.default = g.double();
          break;
        }
        case 15: {
          n.step = g.double();
          break;
        }
        case 16: {
          n.min = g.double();
          break;
        }
        case 17: {
          n.max = g.double();
          break;
        }
        case 18: {
          n.help = g.string();
          break;
        }
        case 19: {
          n.value = g.double();
          break;
        }
        case 20: {
          n.setValue = g.bool();
          break;
        }
        case 21: {
          n.disabled = g.bool();
          break;
        }
        case 22: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 23: {
          n.placeholder = g.string();
          break;
        }
        case 24: {
          n.icon = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.NumberInput) return g;
    let E = new $root.NumberInput();
    switch (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.formId != null && (E.formId = String(g.formId)), g.format != null && (E.format = String(g.format)), g.hasMin != null && (E.hasMin = !!g.hasMin), g.hasMax != null && (E.hasMax = !!g.hasMax), g.dataType) {
      default:
        if (typeof g.dataType == "number") {
          E.dataType = g.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        E.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        E.dataType = 1;
        break;
    }
    if (g.default != null && (E.default = Number(g.default)), g.step != null && (E.step = Number(g.step)), g.min != null && (E.min = Number(g.min)), g.max != null && (E.max = Number(g.max)), g.help != null && (E.help = String(g.help)), g.value != null && (E.value = Number(g.value)), g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.placeholder != null && (E.placeholder = String(g.placeholder)), g.icon != null && (E.icon = String(g.icon)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.formId = "", e.format = "", e.hasMin = !1, e.hasMax = !1, e.dataType = E.enums === String ? "INT" : 0, e.step = 0, e.min = 0, e.max = 0, e.help = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.placeholder = "", e.icon = ""), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.format != null && g.hasOwnProperty("format") && (e.format = g.format), g.hasMin != null && g.hasOwnProperty("hasMin") && (e.hasMin = g.hasMin), g.hasMax != null && g.hasOwnProperty("hasMax") && (e.hasMax = g.hasMax), g.dataType != null && g.hasOwnProperty("dataType") && (e.dataType = E.enums === String ? $root.NumberInput.DataType[g.dataType] === void 0 ? g.dataType : $root.NumberInput.DataType[g.dataType] : g.dataType), g.default != null && g.hasOwnProperty("default") && (e.default = E.json && !isFinite(g.default) ? String(g.default) : g.default, E.oneofs && (e._default = "default")), g.step != null && g.hasOwnProperty("step") && (e.step = E.json && !isFinite(g.step) ? String(g.step) : g.step), g.min != null && g.hasOwnProperty("min") && (e.min = E.json && !isFinite(g.min) ? String(g.min) : g.min), g.max != null && g.hasOwnProperty("max") && (e.max = E.json && !isFinite(g.max) ? String(g.max) : g.max), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.value != null && g.hasOwnProperty("value") && (e.value = E.json && !isFinite(g.value) ? String(g.value) : g.value, E.oneofs && (e._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.placeholder != null && g.hasOwnProperty("placeholder") && (e.placeholder = g.placeholder), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/NumberInput";
  }, o.DataType = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "INT"] = 0, E[g[1] = "FLOAT"] = 1, E;
  })(), o;
})();
$root.Markdown = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.body = "", o.prototype.allowHtml = !1, o.prototype.isCaption = !1, o.prototype.elementType = 0, o.prototype.help = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.body != null && Object.hasOwnProperty.call(i, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.body), i.allowHtml != null && Object.hasOwnProperty.call(i, "allowHtml") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(i.allowHtml), i.isCaption != null && Object.hasOwnProperty.call(i, "isCaption") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.isCaption), i.elementType != null && Object.hasOwnProperty.call(i, "elementType") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(i.elementType), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.help), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Markdown();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.body = i.string();
          break;
        }
        case 2: {
          t.allowHtml = i.bool();
          break;
        }
        case 3: {
          t.isCaption = i.bool();
          break;
        }
        case 4: {
          t.elementType = i.int32();
          break;
        }
        case 5: {
          t.help = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Markdown) return i;
    let g = new $root.Markdown();
    switch (i.body != null && (g.body = String(i.body)), i.allowHtml != null && (g.allowHtml = !!i.allowHtml), i.isCaption != null && (g.isCaption = !!i.isCaption), i.elementType) {
      default:
        if (typeof i.elementType == "number") {
          g.elementType = i.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        g.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        g.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        g.elementType = 2;
        break;
      case "CODE":
      case 3:
        g.elementType = 3;
        break;
      case "LATEX":
      case 4:
        g.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        g.elementType = 5;
        break;
    }
    return i.help != null && (g.help = String(i.help)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.body = "", E.allowHtml = !1, E.isCaption = !1, E.elementType = g.enums === String ? "UNSPECIFIED" : 0, E.help = ""), i.body != null && i.hasOwnProperty("body") && (E.body = i.body), i.allowHtml != null && i.hasOwnProperty("allowHtml") && (E.allowHtml = i.allowHtml), i.isCaption != null && i.hasOwnProperty("isCaption") && (E.isCaption = i.isCaption), i.elementType != null && i.hasOwnProperty("elementType") && (E.elementType = g.enums === String ? $root.Markdown.Type[i.elementType] === void 0 ? i.elementType : $root.Markdown.Type[i.elementType] : i.elementType), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Markdown";
  }, o.Type = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "UNSPECIFIED"] = 0, g[i[1] = "NATIVE"] = 1, g[i[2] = "CAPTION"] = 2, g[i[3] = "CODE"] = 3, g[i[4] = "LATEX"] = 4, g[i[5] = "DIVIDER"] = 5, g;
  })(), o;
})();
$root.Metric = (() => {
  function o(i) {
    if (this.chartData = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.label = "", o.prototype.body = "", o.prototype.delta = "", o.prototype.direction = 0, o.prototype.color = 0, o.prototype.help = "", o.prototype.labelVisibility = null, o.prototype.showBorder = !1, o.prototype.chartData = $util.emptyArray, o.prototype.chartType = 0, o.prototype.format = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.label), i.body != null && Object.hasOwnProperty.call(i, "body") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.body), i.delta != null && Object.hasOwnProperty.call(i, "delta") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.delta), i.direction != null && Object.hasOwnProperty.call(i, "direction") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(i.direction), i.color != null && Object.hasOwnProperty.call(i, "color") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(i.color), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.help), i.labelVisibility != null && Object.hasOwnProperty.call(i, "labelVisibility") && $root.LabelVisibilityMessage.encode(i.labelVisibility, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), i.showBorder != null && Object.hasOwnProperty.call(i, "showBorder") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(i.showBorder), i.chartData != null && i.chartData.length) {
      g.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let E = 0; E < i.chartData.length; ++E) g.double(i.chartData[E]);
      g.ldelim();
    }
    return i.chartType != null && Object.hasOwnProperty.call(i, "chartType") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(i.chartType), i.format != null && Object.hasOwnProperty.call(i, "format") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(i.format), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Metric();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.label = i.string();
          break;
        }
        case 2: {
          t.body = i.string();
          break;
        }
        case 3: {
          t.delta = i.string();
          break;
        }
        case 4: {
          t.direction = i.int32();
          break;
        }
        case 5: {
          t.color = i.int32();
          break;
        }
        case 6: {
          t.help = i.string();
          break;
        }
        case 7: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(i, i.uint32());
          break;
        }
        case 8: {
          t.showBorder = i.bool();
          break;
        }
        case 9: {
          if (t.chartData && t.chartData.length || (t.chartData = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.chartData.push(i.double());
          } else t.chartData.push(i.double());
          break;
        }
        case 10: {
          t.chartType = i.int32();
          break;
        }
        case 11: {
          t.format = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Metric) return i;
    let g = new $root.Metric();
    switch (i.label != null && (g.label = String(i.label)), i.body != null && (g.body = String(i.body)), i.delta != null && (g.delta = String(i.delta)), i.direction) {
      default:
        if (typeof i.direction == "number") {
          g.direction = i.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        g.direction = 0;
        break;
      case "UP":
      case 1:
        g.direction = 1;
        break;
      case "NONE":
      case 2:
        g.direction = 2;
        break;
    }
    switch (i.color) {
      default:
        if (typeof i.color == "number") {
          g.color = i.color;
          break;
        }
        break;
      case "RED":
      case 0:
        g.color = 0;
        break;
      case "GREEN":
      case 1:
        g.color = 1;
        break;
      case "GRAY":
      case 2:
        g.color = 2;
        break;
      case "ORANGE":
      case 3:
        g.color = 3;
        break;
      case "YELLOW":
      case 4:
        g.color = 4;
        break;
      case "BLUE":
      case 5:
        g.color = 5;
        break;
      case "VIOLET":
      case 6:
        g.color = 6;
        break;
      case "PRIMARY":
      case 7:
        g.color = 7;
        break;
    }
    if (i.help != null && (g.help = String(i.help)), i.labelVisibility != null) {
      if (typeof i.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(i.labelVisibility);
    }
    if (i.showBorder != null && (g.showBorder = !!i.showBorder), i.chartData) {
      if (!Array.isArray(i.chartData)) throw TypeError(".Metric.chartData: array expected");
      g.chartData = [];
      for (let E = 0; E < i.chartData.length; ++E) g.chartData[E] = Number(i.chartData[E]);
    }
    switch (i.chartType) {
      default:
        if (typeof i.chartType == "number") {
          g.chartType = i.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        g.chartType = 0;
        break;
      case "BAR":
      case 1:
        g.chartType = 1;
        break;
      case "AREA":
      case 2:
        g.chartType = 2;
        break;
    }
    return i.format != null && (g.format = String(i.format)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.chartData = []), g.defaults && (E.label = "", E.body = "", E.delta = "", E.direction = g.enums === String ? "DOWN" : 0, E.color = g.enums === String ? "RED" : 0, E.help = "", E.labelVisibility = null, E.showBorder = !1, E.chartType = g.enums === String ? "LINE" : 0, E.format = ""), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.body != null && i.hasOwnProperty("body") && (E.body = i.body), i.delta != null && i.hasOwnProperty("delta") && (E.delta = i.delta), i.direction != null && i.hasOwnProperty("direction") && (E.direction = g.enums === String ? $root.Metric.MetricDirection[i.direction] === void 0 ? i.direction : $root.Metric.MetricDirection[i.direction] : i.direction), i.color != null && i.hasOwnProperty("color") && (E.color = g.enums === String ? $root.Metric.MetricColor[i.color] === void 0 ? i.color : $root.Metric.MetricColor[i.color] : i.color), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.labelVisibility != null && i.hasOwnProperty("labelVisibility") && (E.labelVisibility = $root.LabelVisibilityMessage.toObject(i.labelVisibility, g)), i.showBorder != null && i.hasOwnProperty("showBorder") && (E.showBorder = i.showBorder), i.chartData && i.chartData.length) {
      E.chartData = [];
      for (let e = 0; e < i.chartData.length; ++e) E.chartData[e] = g.json && !isFinite(i.chartData[e]) ? String(i.chartData[e]) : i.chartData[e];
    }
    return i.chartType != null && i.hasOwnProperty("chartType") && (E.chartType = g.enums === String ? $root.Metric.ChartType[i.chartType] === void 0 ? i.chartType : $root.Metric.ChartType[i.chartType] : i.chartType), i.format != null && i.hasOwnProperty("format") && (E.format = i.format), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Metric";
  }, o.MetricDirection = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "DOWN"] = 0, g[i[1] = "UP"] = 1, g[i[2] = "NONE"] = 2, g;
  })(), o.MetricColor = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "RED"] = 0, g[i[1] = "GREEN"] = 1, g[i[2] = "GRAY"] = 2, g[i[3] = "ORANGE"] = 3, g[i[4] = "YELLOW"] = 4, g[i[5] = "BLUE"] = 5, g[i[6] = "VIOLET"] = 6, g[i[7] = "PRIMARY"] = 7, g;
  })(), o.ChartType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "LINE"] = 0, g[i[1] = "BAR"] = 1, g[i[2] = "AREA"] = 2, g;
  })(), o;
})();
$root.MultiSelect = (() => {
  function o(g) {
    if (this.default = [], this.options = [], this.value = [], this.rawValues = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util.emptyArray, o.prototype.options = $util.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util.emptyArray, o.prototype.rawValues = $util.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.maxSelections = 0, o.prototype.placeholder = "", o.prototype.acceptNewOptions = null;
  let i;
  return Object.defineProperty(o.prototype, "_acceptNewOptions", { get: $util.oneOfGetter(i = ["acceptNewOptions"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && g.default.length) {
      E.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let e = 0; e < g.default.length; ++e) E.int32(g.default[e]);
      E.ldelim();
    }
    if (g.options != null && g.options.length) for (let e = 0; e < g.options.length; ++e) E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[e]);
    if (g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && g.value.length) {
      E.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let e = 0; e < g.value.length; ++e) E.int32(g.value[e]);
      E.ldelim();
    }
    if (g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.maxSelections != null && Object.hasOwnProperty.call(g, "maxSelections") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(g.maxSelections), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.placeholder), g.acceptNewOptions != null && Object.hasOwnProperty.call(g, "acceptNewOptions") && E.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(g.acceptNewOptions), g.rawValues != null && g.rawValues.length) for (let e = 0; e < g.rawValues.length; ++e) E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.rawValues[e]);
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.MultiSelect();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          if (n.default && n.default.length || (n.default = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.default.push(g.int32());
          } else n.default.push(g.int32());
          break;
        }
        case 4: {
          n.options && n.options.length || (n.options = []), n.options.push(g.string());
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          if (n.value && n.value.length || (n.value = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.value.push(g.int32());
          } else n.value.push(g.int32());
          break;
        }
        case 14: {
          n.rawValues && n.rawValues.length || (n.rawValues = []), n.rawValues.push(g.string());
          break;
        }
        case 8: {
          n.setValue = g.bool();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.maxSelections = g.int32();
          break;
        }
        case 12: {
          n.placeholder = g.string();
          break;
        }
        case 13: {
          n.acceptNewOptions = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.MultiSelect) return g;
    let E = new $root.MultiSelect();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".MultiSelect.default: array expected");
      E.default = [];
      for (let e = 0; e < g.default.length; ++e) E.default[e] = g.default[e] | 0;
    }
    if (g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".MultiSelect.options: array expected");
      E.options = [];
      for (let e = 0; e < g.options.length; ++e) E.options[e] = String(g.options[e]);
    }
    if (g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".MultiSelect.value: array expected");
      E.value = [];
      for (let e = 0; e < g.value.length; ++e) E.value[e] = g.value[e] | 0;
    }
    if (g.rawValues) {
      if (!Array.isArray(g.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
      E.rawValues = [];
      for (let e = 0; e < g.rawValues.length; ++e) E.rawValues[e] = String(g.rawValues[e]);
    }
    if (g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.maxSelections != null && (E.maxSelections = g.maxSelections | 0), g.placeholder != null && (E.placeholder = String(g.placeholder)), g.acceptNewOptions != null && (E.acceptNewOptions = !!g.acceptNewOptions), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.default = [], e.options = [], e.value = [], e.rawValues = []), E.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.maxSelections = 0, e.placeholder = ""), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default && g.default.length) {
      e.default = [];
      for (let t = 0; t < g.default.length; ++t) e.default[t] = g.default[t];
    }
    if (g.options && g.options.length) {
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) e.options[t] = g.options[t];
    }
    if (g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value && g.value.length) {
      e.value = [];
      for (let t = 0; t < g.value.length; ++t) e.value[t] = g.value[t];
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.maxSelections != null && g.hasOwnProperty("maxSelections") && (e.maxSelections = g.maxSelections), g.placeholder != null && g.hasOwnProperty("placeholder") && (e.placeholder = g.placeholder), g.acceptNewOptions != null && g.hasOwnProperty("acceptNewOptions") && (e.acceptNewOptions = g.acceptNewOptions, E.oneofs && (e._acceptNewOptions = "acceptNewOptions")), g.rawValues && g.rawValues.length) {
      e.rawValues = [];
      for (let t = 0; t < g.rawValues.length; ++t) e.rawValues[t] = g.rawValues[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/MultiSelect";
  }, o;
})();
$root.PageLink = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.page = "", o.prototype.label = "", o.prototype.icon = "", o.prototype.pageScriptHash = "", o.prototype.help = "", o.prototype.useContainerWidth = null, o.prototype.disabled = !1, o.prototype.external = !1, o.prototype.queryString = "", o.prototype.iconPosition = 0;
  let i;
  return Object.defineProperty(o.prototype, "_useContainerWidth", { get: $util.oneOfGetter(i = ["useContainerWidth"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.page != null && Object.hasOwnProperty.call(g, "page") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.page), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.icon), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.pageScriptHash), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.useContainerWidth), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.disabled), g.external != null && Object.hasOwnProperty.call(g, "external") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.external), g.queryString != null && Object.hasOwnProperty.call(g, "queryString") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.queryString), g.iconPosition != null && Object.hasOwnProperty.call(g, "iconPosition") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(g.iconPosition), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.PageLink();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.page = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.icon = g.string();
          break;
        }
        case 4: {
          n.pageScriptHash = g.string();
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 7: {
          n.disabled = g.bool();
          break;
        }
        case 8: {
          n.external = g.bool();
          break;
        }
        case 9: {
          n.queryString = g.string();
          break;
        }
        case 10: {
          n.iconPosition = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.PageLink) return g;
    let E = new $root.PageLink();
    switch (g.page != null && (E.page = String(g.page)), g.label != null && (E.label = String(g.label)), g.icon != null && (E.icon = String(g.icon)), g.pageScriptHash != null && (E.pageScriptHash = String(g.pageScriptHash)), g.help != null && (E.help = String(g.help)), g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.disabled != null && (E.disabled = !!g.disabled), g.external != null && (E.external = !!g.external), g.queryString != null && (E.queryString = String(g.queryString)), g.iconPosition) {
      default:
        if (typeof g.iconPosition == "number") {
          E.iconPosition = g.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        E.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        E.iconPosition = 1;
        break;
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.page = "", e.label = "", e.icon = "", e.pageScriptHash = "", e.help = "", e.disabled = !1, e.external = !1, e.queryString = "", e.iconPosition = E.enums === String ? "LEFT" : 0), g.page != null && g.hasOwnProperty("page") && (e.page = g.page), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = g.pageScriptHash), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth, E.oneofs && (e._useContainerWidth = "useContainerWidth")), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.external != null && g.hasOwnProperty("external") && (e.external = g.external), g.queryString != null && g.hasOwnProperty("queryString") && (e.queryString = g.queryString), g.iconPosition != null && g.hasOwnProperty("iconPosition") && (e.iconPosition = E.enums === String ? $root.streamlit.ButtonLikeIconPosition[g.iconPosition] === void 0 ? g.iconPosition : $root.streamlit.ButtonLikeIconPosition[g.iconPosition] : g.iconPosition), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageLink";
  }, o;
})();
$root.PlotlyChart = (() => {
  function o(g) {
    if (this.selectionMode = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.useContainerWidth = !1, o.prototype.theme = "", o.prototype.id = "", o.prototype.selectionMode = $util.emptyArray, o.prototype.formId = "", o.prototype.spec = "", o.prototype.config = "", o.prototype.url = null, o.prototype.figure = null;
  let i;
  return Object.defineProperty(o.prototype, "chart", { get: $util.oneOfGetter(i = ["url", "figure"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), g.figure != null && Object.hasOwnProperty.call(g, "figure") && $root.Figure.encode(g.figure, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), g.theme != null && Object.hasOwnProperty.call(g, "theme") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.theme), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.id), g.selectionMode != null && g.selectionMode.length) {
      E.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let e = 0; e < g.selectionMode.length; ++e) E.int32(g.selectionMode[e]);
      E.ldelim();
    }
    return g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.formId), g.spec != null && Object.hasOwnProperty.call(g, "spec") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.spec), g.config != null && Object.hasOwnProperty.call(g, "config") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.config), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.PlotlyChart();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 5: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 6: {
          n.theme = g.string();
          break;
        }
        case 7: {
          n.id = g.string();
          break;
        }
        case 8: {
          if (n.selectionMode && n.selectionMode.length || (n.selectionMode = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.selectionMode.push(g.int32());
          } else n.selectionMode.push(g.int32());
          break;
        }
        case 9: {
          n.formId = g.string();
          break;
        }
        case 10: {
          n.spec = g.string();
          break;
        }
        case 11: {
          n.config = g.string();
          break;
        }
        case 1: {
          n.url = g.string();
          break;
        }
        case 2: {
          n.figure = $root.Figure.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.PlotlyChart) return g;
    let E = new $root.PlotlyChart();
    if (g.useContainerWidth != null && (E.useContainerWidth = !!g.useContainerWidth), g.theme != null && (E.theme = String(g.theme)), g.id != null && (E.id = String(g.id)), g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
      E.selectionMode = [];
      for (let e = 0; e < g.selectionMode.length; ++e) switch (g.selectionMode[e]) {
        default:
          if (typeof g.selectionMode[e] == "number") {
            E.selectionMode[e] = g.selectionMode[e];
            break;
          }
        case "POINTS":
        case 0:
          E.selectionMode[e] = 0;
          break;
        case "BOX":
        case 1:
          E.selectionMode[e] = 1;
          break;
        case "LASSO":
        case 2:
          E.selectionMode[e] = 2;
          break;
      }
    }
    if (g.formId != null && (E.formId = String(g.formId)), g.spec != null && (E.spec = String(g.spec)), g.config != null && (E.config = String(g.config)), g.url != null && (E.url = String(g.url)), g.figure != null) {
      if (typeof g.figure != "object") throw TypeError(".PlotlyChart.figure: object expected");
      E.figure = $root.Figure.fromObject(g.figure);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.selectionMode = []), E.defaults && (e.useContainerWidth = !1, e.theme = "", e.id = "", e.formId = "", e.spec = "", e.config = ""), g.url != null && g.hasOwnProperty("url") && (e.url = g.url, E.oneofs && (e.chart = "url")), g.figure != null && g.hasOwnProperty("figure") && (e.figure = $root.Figure.toObject(g.figure, E), E.oneofs && (e.chart = "figure")), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = g.useContainerWidth), g.theme != null && g.hasOwnProperty("theme") && (e.theme = g.theme), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.selectionMode && g.selectionMode.length) {
      e.selectionMode = [];
      for (let t = 0; t < g.selectionMode.length; ++t) e.selectionMode[t] = E.enums === String ? $root.PlotlyChart.SelectionMode[g.selectionMode[t]] === void 0 ? g.selectionMode[t] : $root.PlotlyChart.SelectionMode[g.selectionMode[t]] : g.selectionMode[t];
    }
    return g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.spec != null && g.hasOwnProperty("spec") && (e.spec = g.spec), g.config != null && g.hasOwnProperty("config") && (e.config = g.config), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PlotlyChart";
  }, o.SelectionMode = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "POINTS"] = 0, E[g[1] = "BOX"] = 1, E[g[2] = "LASSO"] = 2, E;
  })(), o;
})();
$root.Figure = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.spec = "", o.prototype.config = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.spec != null && Object.hasOwnProperty.call(i, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.spec), i.config != null && Object.hasOwnProperty.call(i, "config") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.config), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Figure();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.spec = i.string();
          break;
        }
        case 2: {
          t.config = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Figure) return i;
    let g = new $root.Figure();
    return i.spec != null && (g.spec = String(i.spec)), i.config != null && (g.config = String(i.config)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.spec = "", E.config = ""), i.spec != null && i.hasOwnProperty("spec") && (E.spec = i.spec), i.config != null && i.hasOwnProperty("config") && (E.config = i.config), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Figure";
  }, o;
})();
$root.Progress = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.value = 0, o.prototype.text = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.value != null && Object.hasOwnProperty.call(i, "value") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(i.value), i.text != null && Object.hasOwnProperty.call(i, "text") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.text), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Progress();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.value = i.uint32();
          break;
        }
        case 2: {
          t.text = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Progress) return i;
    let g = new $root.Progress();
    return i.value != null && (g.value = i.value >>> 0), i.text != null && (g.text = String(i.text)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.value = 0, E.text = ""), i.value != null && i.hasOwnProperty("value") && (E.value = i.value), i.text != null && i.hasOwnProperty("text") && (E.text = i.text), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Progress";
  }, o;
})();
$root.Snow = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.show = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.show != null && Object.hasOwnProperty.call(i, "show") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(i.show), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Snow();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.show = i.bool() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Snow) return i;
    let g = new $root.Snow();
    return i.show != null && (g.show = !!i.show), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.show = !1), i.show != null && i.hasOwnProperty("show") && (E.show = i.show), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Snow";
  }, o;
})();
$root.Spinner = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.text = "", o.prototype.cache = !1, o.prototype.showTime = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.text != null && Object.hasOwnProperty.call(i, "text") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.text), i.cache != null && Object.hasOwnProperty.call(i, "cache") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(i.cache), i.showTime != null && Object.hasOwnProperty.call(i, "showTime") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.showTime), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Spinner();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.text = i.string();
          break;
        }
        case 2: {
          t.cache = i.bool();
          break;
        }
        case 3: {
          t.showTime = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Spinner) return i;
    let g = new $root.Spinner();
    return i.text != null && (g.text = String(i.text)), i.cache != null && (g.cache = !!i.cache), i.showTime != null && (g.showTime = !!i.showTime), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.text = "", E.cache = !1, E.showTime = !1), i.text != null && i.hasOwnProperty("text") && (E.text = i.text), i.cache != null && i.hasOwnProperty("cache") && (E.cache = i.cache), i.showTime != null && i.hasOwnProperty("showTime") && (E.showTime = i.showTime), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Spinner";
  }, o;
})();
$root.Radio = (() => {
  function o(g) {
    if (this.options = [], this.captions = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.options = $util.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.rawValue = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.horizontal = !1, o.prototype.labelVisibility = null, o.prototype.captions = $util.emptyArray;
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(i = ["default"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(i = ["value"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_rawValue", { get: $util.oneOfGetter(i = ["rawValue"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.default), g.options != null && g.options.length) for (let e = 0; e < g.options.length; ++e) E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[e]);
    if (g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.horizontal != null && Object.hasOwnProperty.call(g, "horizontal") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.horizontal), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.captions != null && g.captions.length) for (let e = 0; e < g.captions.length; ++e) E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.captions[e]);
    return g.rawValue != null && Object.hasOwnProperty.call(g, "rawValue") && E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.rawValue), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Radio();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.int32();
          break;
        }
        case 4: {
          n.options && n.options.length || (n.options = []), n.options.push(g.string());
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          n.value = g.int32();
          break;
        }
        case 13: {
          n.rawValue = g.string();
          break;
        }
        case 8: {
          n.setValue = g.bool();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.horizontal = g.bool();
          break;
        }
        case 11: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.captions && n.captions.length || (n.captions = []), n.captions.push(g.string());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Radio) return g;
    let E = new $root.Radio();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = g.default | 0), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".Radio.options: array expected");
      E.options = [];
      for (let e = 0; e < g.options.length; ++e) E.options[e] = String(g.options[e]);
    }
    if (g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value != null && (E.value = g.value | 0), g.rawValue != null && (E.rawValue = String(g.rawValue)), g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.horizontal != null && (E.horizontal = !!g.horizontal), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    if (g.captions) {
      if (!Array.isArray(g.captions)) throw TypeError(".Radio.captions: array expected");
      E.captions = [];
      for (let e = 0; e < g.captions.length; ++e) E.captions[e] = String(g.captions[e]);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.options = [], e.captions = []), E.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.horizontal = !1, e.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default, E.oneofs && (e._default = "default")), g.options && g.options.length) {
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) e.options[t] = g.options[t];
    }
    if (g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (e.value = g.value, E.oneofs && (e._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.horizontal != null && g.hasOwnProperty("horizontal") && (e.horizontal = g.horizontal), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.captions && g.captions.length) {
      e.captions = [];
      for (let t = 0; t < g.captions.length; ++t) e.captions[t] = g.captions[t];
    }
    return g.rawValue != null && g.hasOwnProperty("rawValue") && (e.rawValue = g.rawValue, E.oneofs && (e._rawValue = "rawValue")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Radio";
  }, o;
})();
$root.Selectbox = (() => {
  function o(g) {
    if (this.options = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.options = $util.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.rawValue = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.placeholder = "", o.prototype.acceptNewOptions = null;
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(i = ["default"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(i = ["value"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_rawValue", { get: $util.oneOfGetter(i = ["rawValue"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_acceptNewOptions", { get: $util.oneOfGetter(i = ["acceptNewOptions"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.default), g.options != null && g.options.length) for (let e = 0; e < g.options.length; ++e) E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[e]);
    return g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.placeholder), g.acceptNewOptions != null && Object.hasOwnProperty.call(g, "acceptNewOptions") && E.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.acceptNewOptions), g.rawValue != null && Object.hasOwnProperty.call(g, "rawValue") && E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.rawValue), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Selectbox();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.int32();
          break;
        }
        case 4: {
          n.options && n.options.length || (n.options = []), n.options.push(g.string());
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          n.value = g.int32();
          break;
        }
        case 13: {
          n.rawValue = g.string();
          break;
        }
        case 8: {
          n.setValue = g.bool();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.placeholder = g.string();
          break;
        }
        case 12: {
          n.acceptNewOptions = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Selectbox) return g;
    let E = new $root.Selectbox();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = g.default | 0), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".Selectbox.options: array expected");
      E.options = [];
      for (let e = 0; e < g.options.length; ++e) E.options[e] = String(g.options[e]);
    }
    if (g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value != null && (E.value = g.value | 0), g.rawValue != null && (E.rawValue = String(g.rawValue)), g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.placeholder != null && (E.placeholder = String(g.placeholder)), g.acceptNewOptions != null && (E.acceptNewOptions = !!g.acceptNewOptions), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.options = []), E.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.placeholder = ""), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default, E.oneofs && (e._default = "default")), g.options && g.options.length) {
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) e.options[t] = g.options[t];
    }
    return g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (e.value = g.value, E.oneofs && (e._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.placeholder != null && g.hasOwnProperty("placeholder") && (e.placeholder = g.placeholder), g.acceptNewOptions != null && g.hasOwnProperty("acceptNewOptions") && (e.acceptNewOptions = g.acceptNewOptions, E.oneofs && (e._acceptNewOptions = "acceptNewOptions")), g.rawValue != null && g.hasOwnProperty("rawValue") && (e.rawValue = g.rawValue, E.oneofs && (e._rawValue = "rawValue")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Selectbox";
  }, o;
})();
$root.Skeleton = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.style = 0, o.prototype.height = null;
  let i;
  return Object.defineProperty(o.prototype, "_height", { get: $util.oneOfGetter(i = ["height"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.style != null && Object.hasOwnProperty.call(g, "style") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.style), g.height != null && Object.hasOwnProperty.call(g, "height") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.height), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Skeleton();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.style = g.int32();
          break;
        }
        case 2: {
          n.height = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Skeleton) return g;
    let E = new $root.Skeleton();
    switch (g.style) {
      default:
        if (typeof g.style == "number") {
          E.style = g.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        E.style = 0;
        break;
      case "APP":
      case 1:
        E.style = 1;
        break;
    }
    return g.height != null && (E.height = g.height | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.style = E.enums === String ? "ELEMENT" : 0), g.style != null && g.hasOwnProperty("style") && (e.style = E.enums === String ? $root.Skeleton.SkeletonStyle[g.style] === void 0 ? g.style : $root.Skeleton.SkeletonStyle[g.style] : g.style), g.height != null && g.hasOwnProperty("height") && (e.height = g.height, E.oneofs && (e._height = "height")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Skeleton";
  }, o.SkeletonStyle = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "ELEMENT"] = 0, E[g[1] = "APP"] = 1, E;
  })(), o;
})();
$root.Slider = (() => {
  function o(i) {
    if (this.default = [], this.value = [], this.options = [], this.rawValue = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.id = "", o.prototype.formId = "", o.prototype.label = "", o.prototype.format = "", o.prototype.dataType = 0, o.prototype.default = $util.emptyArray, o.prototype.min = 0, o.prototype.max = 0, o.prototype.step = 0, o.prototype.value = $util.emptyArray, o.prototype.setValue = !1, o.prototype.options = $util.emptyArray, o.prototype.help = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.type = 0, o.prototype.rawValue = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.id != null && Object.hasOwnProperty.call(i, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.id), i.formId != null && Object.hasOwnProperty.call(i, "formId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.formId), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.label), i.format != null && Object.hasOwnProperty.call(i, "format") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.format), i.dataType != null && Object.hasOwnProperty.call(i, "dataType") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(i.dataType), i.default != null && i.default.length) {
      g.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork();
      for (let E = 0; E < i.default.length; ++E) g.double(i.default[E]);
      g.ldelim();
    }
    if (i.min != null && Object.hasOwnProperty.call(i, "min") && g.uint32(
      /* id 7, wireType 1 =*/
      57
    ).double(i.min), i.max != null && Object.hasOwnProperty.call(i, "max") && g.uint32(
      /* id 8, wireType 1 =*/
      65
    ).double(i.max), i.step != null && Object.hasOwnProperty.call(i, "step") && g.uint32(
      /* id 9, wireType 1 =*/
      73
    ).double(i.step), i.value != null && i.value.length) {
      g.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork();
      for (let E = 0; E < i.value.length; ++E) g.double(i.value[E]);
      g.ldelim();
    }
    if (i.setValue != null && Object.hasOwnProperty.call(i, "setValue") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(i.setValue), i.options != null && i.options.length) for (let E = 0; E < i.options.length; ++E) g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(i.options[E]);
    if (i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(i.help), i.disabled != null && Object.hasOwnProperty.call(i, "disabled") && g.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(i.disabled), i.labelVisibility != null && Object.hasOwnProperty.call(i, "labelVisibility") && $root.LabelVisibilityMessage.encode(i.labelVisibility, g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), i.type != null && Object.hasOwnProperty.call(i, "type") && g.uint32(
      /* id 17, wireType 0 =*/
      136
    ).int32(i.type), i.rawValue != null && i.rawValue.length) for (let E = 0; E < i.rawValue.length; ++E) g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(i.rawValue[E]);
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Slider();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.id = i.string();
          break;
        }
        case 2: {
          t.formId = i.string();
          break;
        }
        case 3: {
          t.label = i.string();
          break;
        }
        case 4: {
          t.format = i.string();
          break;
        }
        case 5: {
          t.dataType = i.int32();
          break;
        }
        case 6: {
          if (t.default && t.default.length || (t.default = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.default.push(i.double());
          } else t.default.push(i.double());
          break;
        }
        case 7: {
          t.min = i.double();
          break;
        }
        case 8: {
          t.max = i.double();
          break;
        }
        case 9: {
          t.step = i.double();
          break;
        }
        case 10: {
          if (t.value && t.value.length || (t.value = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.value.push(i.double());
          } else t.value.push(i.double());
          break;
        }
        case 11: {
          t.setValue = i.bool();
          break;
        }
        case 13: {
          t.options && t.options.length || (t.options = []), t.options.push(i.string());
          break;
        }
        case 14: {
          t.help = i.string();
          break;
        }
        case 15: {
          t.disabled = i.bool();
          break;
        }
        case 16: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(i, i.uint32());
          break;
        }
        case 17: {
          t.type = i.int32();
          break;
        }
        case 18: {
          t.rawValue && t.rawValue.length || (t.rawValue = []), t.rawValue.push(i.string());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Slider) return i;
    let g = new $root.Slider();
    switch (i.id != null && (g.id = String(i.id)), i.formId != null && (g.formId = String(i.formId)), i.label != null && (g.label = String(i.label)), i.format != null && (g.format = String(i.format)), i.dataType) {
      default:
        if (typeof i.dataType == "number") {
          g.dataType = i.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        g.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        g.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        g.dataType = 2;
        break;
      case "DATE":
      case 3:
        g.dataType = 3;
        break;
      case "TIME":
      case 4:
        g.dataType = 4;
        break;
    }
    if (i.default) {
      if (!Array.isArray(i.default)) throw TypeError(".Slider.default: array expected");
      g.default = [];
      for (let E = 0; E < i.default.length; ++E) g.default[E] = Number(i.default[E]);
    }
    if (i.min != null && (g.min = Number(i.min)), i.max != null && (g.max = Number(i.max)), i.step != null && (g.step = Number(i.step)), i.value) {
      if (!Array.isArray(i.value)) throw TypeError(".Slider.value: array expected");
      g.value = [];
      for (let E = 0; E < i.value.length; ++E) g.value[E] = Number(i.value[E]);
    }
    if (i.setValue != null && (g.setValue = !!i.setValue), i.options) {
      if (!Array.isArray(i.options)) throw TypeError(".Slider.options: array expected");
      g.options = [];
      for (let E = 0; E < i.options.length; ++E) g.options[E] = String(i.options[E]);
    }
    if (i.help != null && (g.help = String(i.help)), i.disabled != null && (g.disabled = !!i.disabled), i.labelVisibility != null) {
      if (typeof i.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(i.labelVisibility);
    }
    switch (i.type) {
      default:
        if (typeof i.type == "number") {
          g.type = i.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        g.type = 0;
        break;
      case "SLIDER":
      case 1:
        g.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        g.type = 2;
        break;
    }
    if (i.rawValue) {
      if (!Array.isArray(i.rawValue)) throw TypeError(".Slider.rawValue: array expected");
      g.rawValue = [];
      for (let E = 0; E < i.rawValue.length; ++E) g.rawValue[E] = String(i.rawValue[E]);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.default = [], E.value = [], E.options = [], E.rawValue = []), g.defaults && (E.id = "", E.formId = "", E.label = "", E.format = "", E.dataType = g.enums === String ? "INT" : 0, E.min = 0, E.max = 0, E.step = 0, E.setValue = !1, E.help = "", E.disabled = !1, E.labelVisibility = null, E.type = g.enums === String ? "UNSPECIFIED" : 0), i.id != null && i.hasOwnProperty("id") && (E.id = i.id), i.formId != null && i.hasOwnProperty("formId") && (E.formId = i.formId), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.format != null && i.hasOwnProperty("format") && (E.format = i.format), i.dataType != null && i.hasOwnProperty("dataType") && (E.dataType = g.enums === String ? $root.Slider.DataType[i.dataType] === void 0 ? i.dataType : $root.Slider.DataType[i.dataType] : i.dataType), i.default && i.default.length) {
      E.default = [];
      for (let e = 0; e < i.default.length; ++e) E.default[e] = g.json && !isFinite(i.default[e]) ? String(i.default[e]) : i.default[e];
    }
    if (i.min != null && i.hasOwnProperty("min") && (E.min = g.json && !isFinite(i.min) ? String(i.min) : i.min), i.max != null && i.hasOwnProperty("max") && (E.max = g.json && !isFinite(i.max) ? String(i.max) : i.max), i.step != null && i.hasOwnProperty("step") && (E.step = g.json && !isFinite(i.step) ? String(i.step) : i.step), i.value && i.value.length) {
      E.value = [];
      for (let e = 0; e < i.value.length; ++e) E.value[e] = g.json && !isFinite(i.value[e]) ? String(i.value[e]) : i.value[e];
    }
    if (i.setValue != null && i.hasOwnProperty("setValue") && (E.setValue = i.setValue), i.options && i.options.length) {
      E.options = [];
      for (let e = 0; e < i.options.length; ++e) E.options[e] = i.options[e];
    }
    if (i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.disabled != null && i.hasOwnProperty("disabled") && (E.disabled = i.disabled), i.labelVisibility != null && i.hasOwnProperty("labelVisibility") && (E.labelVisibility = $root.LabelVisibilityMessage.toObject(i.labelVisibility, g)), i.type != null && i.hasOwnProperty("type") && (E.type = g.enums === String ? $root.Slider.Type[i.type] === void 0 ? i.type : $root.Slider.Type[i.type] : i.type), i.rawValue && i.rawValue.length) {
      E.rawValue = [];
      for (let e = 0; e < i.rawValue.length; ++e) E.rawValue[e] = i.rawValue[e];
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Slider";
  }, o.DataType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "INT"] = 0, g[i[1] = "FLOAT"] = 1, g[i[2] = "DATETIME"] = 2, g[i[3] = "DATE"] = 3, g[i[4] = "TIME"] = 4, g;
  })(), o.Type = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "UNSPECIFIED"] = 0, g[i[1] = "SLIDER"] = 1, g[i[2] = "SELECT_SLIDER"] = 2, g;
  })(), o;
})();
$root.Space = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Space();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    return i instanceof $root.Space ? i : new $root.Space();
  }, o.toObject = function() {
    return {};
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Space";
  }, o;
})();
$root.Text = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.body = "", o.prototype.help = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.body != null && Object.hasOwnProperty.call(i, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.body), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.help), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Text();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.body = i.string();
          break;
        }
        case 2: {
          t.help = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Text) return i;
    let g = new $root.Text();
    return i.body != null && (g.body = String(i.body)), i.help != null && (g.help = String(i.help)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.body = "", E.help = ""), i.body != null && i.hasOwnProperty("body") && (E.body = i.body), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Text";
  }, o;
})();
$root.TextArea = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.height = 0, o.prototype.maxChars = 0, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.placeholder = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null;
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(i = ["default"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(i = ["value"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.height != null && Object.hasOwnProperty.call(g, "height") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(g.height), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(g.maxChars), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.setValue), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.placeholder), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.TextArea();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.string();
          break;
        }
        case 4: {
          n.height = g.uint32();
          break;
        }
        case 5: {
          n.maxChars = g.uint32();
          break;
        }
        case 6: {
          n.help = g.string();
          break;
        }
        case 7: {
          n.formId = g.string();
          break;
        }
        case 8: {
          n.value = g.string();
          break;
        }
        case 9: {
          n.setValue = g.bool();
          break;
        }
        case 10: {
          n.placeholder = g.string();
          break;
        }
        case 11: {
          n.disabled = g.bool();
          break;
        }
        case 12: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.TextArea) return g;
    let E = new $root.TextArea();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = String(g.default)), g.height != null && (E.height = g.height >>> 0), g.maxChars != null && (E.maxChars = g.maxChars >>> 0), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value != null && (E.value = String(g.value)), g.setValue != null && (E.setValue = !!g.setValue), g.placeholder != null && (E.placeholder = String(g.placeholder)), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.height = 0, e.maxChars = 0, e.help = "", e.formId = "", e.setValue = !1, e.placeholder = "", e.disabled = !1, e.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default, E.oneofs && (e._default = "default")), g.height != null && g.hasOwnProperty("height") && (e.height = g.height), g.maxChars != null && g.hasOwnProperty("maxChars") && (e.maxChars = g.maxChars), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (e.value = g.value, E.oneofs && (e._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.placeholder != null && g.hasOwnProperty("placeholder") && (e.placeholder = g.placeholder), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TextArea";
  }, o;
})();
$root.TextInput = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.type = 0, o.prototype.maxChars = 0, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.autocomplete = "", o.prototype.placeholder = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.icon = "";
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(i = ["default"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(i = ["value"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.type), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(g.maxChars), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.setValue), g.autocomplete != null && Object.hasOwnProperty.call(g, "autocomplete") && E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.autocomplete), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.placeholder), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.icon), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.TextInput();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.string();
          break;
        }
        case 4: {
          n.type = g.int32();
          break;
        }
        case 5: {
          n.maxChars = g.uint32();
          break;
        }
        case 6: {
          n.help = g.string();
          break;
        }
        case 7: {
          n.formId = g.string();
          break;
        }
        case 8: {
          n.value = g.string();
          break;
        }
        case 9: {
          n.setValue = g.bool();
          break;
        }
        case 10: {
          n.autocomplete = g.string();
          break;
        }
        case 11: {
          n.placeholder = g.string();
          break;
        }
        case 12: {
          n.disabled = g.bool();
          break;
        }
        case 13: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 14: {
          n.icon = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.TextInput) return g;
    let E = new $root.TextInput();
    switch (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = String(g.default)), g.type) {
      default:
        if (typeof g.type == "number") {
          E.type = g.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        E.type = 0;
        break;
      case "PASSWORD":
      case 1:
        E.type = 1;
        break;
    }
    if (g.maxChars != null && (E.maxChars = g.maxChars >>> 0), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value != null && (E.value = String(g.value)), g.setValue != null && (E.setValue = !!g.setValue), g.autocomplete != null && (E.autocomplete = String(g.autocomplete)), g.placeholder != null && (E.placeholder = String(g.placeholder)), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.icon != null && (E.icon = String(g.icon)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.id = "", e.label = "", e.type = E.enums === String ? "DEFAULT" : 0, e.maxChars = 0, e.help = "", e.formId = "", e.setValue = !1, e.autocomplete = "", e.placeholder = "", e.disabled = !1, e.labelVisibility = null, e.icon = ""), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default, E.oneofs && (e._default = "default")), g.type != null && g.hasOwnProperty("type") && (e.type = E.enums === String ? $root.TextInput.Type[g.type] === void 0 ? g.type : $root.TextInput.Type[g.type] : g.type), g.maxChars != null && g.hasOwnProperty("maxChars") && (e.maxChars = g.maxChars), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (e.value = g.value, E.oneofs && (e._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.autocomplete != null && g.hasOwnProperty("autocomplete") && (e.autocomplete = g.autocomplete), g.placeholder != null && g.hasOwnProperty("placeholder") && (e.placeholder = g.placeholder), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TextInput";
  }, o.Type = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "DEFAULT"] = 0, E[g[1] = "PASSWORD"] = 1, E;
  })(), o;
})();
$root.TimeInput = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.step = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0;
  let i;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(i = ["default"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(i = ["value"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && E.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.step != null && Object.hasOwnProperty.call(g, "step") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int64(g.step), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.TimeInput();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.string();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.value = g.string();
          break;
        }
        case 7: {
          n.setValue = g.bool();
          break;
        }
        case 8: {
          n.disabled = g.bool();
          break;
        }
        case 9: {
          n.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.step = g.int64();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.TimeInput) return g;
    let E = new $root.TimeInput();
    if (g.id != null && (E.id = String(g.id)), g.label != null && (E.label = String(g.label)), g.default != null && (E.default = String(g.default)), g.help != null && (E.help = String(g.help)), g.formId != null && (E.formId = String(g.formId)), g.value != null && (E.value = String(g.value)), g.setValue != null && (E.setValue = !!g.setValue), g.disabled != null && (E.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
      E.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.step != null && ($util.Long ? (E.step = $util.Long.fromValue(g.step)).unsigned = !1 : typeof g.step == "string" ? E.step = parseInt(g.step, 10) : typeof g.step == "number" ? E.step = g.step : typeof g.step == "object" && (E.step = new $util.LongBits(g.step.low >>> 0, g.step.high >>> 0).toNumber())), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if (E.defaults) if (e.id = "", e.label = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, $util.Long) {
      let t = new $util.Long(0, 0, !1);
      e.step = E.longs === String ? t.toString() : E.longs === Number ? t.toNumber() : t;
    } else e.step = E.longs === String ? "0" : 0;
    return g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.label != null && g.hasOwnProperty("label") && (e.label = g.label), g.default != null && g.hasOwnProperty("default") && (e.default = g.default, E.oneofs && (e._default = "default")), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (e.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (e.value = g.value, E.oneofs && (e._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (e.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (e.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, E)), g.step != null && g.hasOwnProperty("step") && (typeof g.step == "number" ? e.step = E.longs === String ? String(g.step) : g.step : e.step = E.longs === String ? $util.Long.prototype.toString.call(g.step) : E.longs === Number ? new $util.LongBits(g.step.low >>> 0, g.step.high >>> 0).toNumber() : g.step), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TimeInput";
  }, o;
})();
$root.Toast = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.body = "", o.prototype.icon = "", o.prototype.duration = null;
  let i;
  return Object.defineProperty(o.prototype, "_duration", { get: $util.oneOfGetter(i = ["duration"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.icon != null && Object.hasOwnProperty.call(g, "icon") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.icon), g.duration != null && Object.hasOwnProperty.call(g, "duration") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.duration), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Toast();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.body = g.string();
          break;
        }
        case 2: {
          n.icon = g.string();
          break;
        }
        case 3: {
          n.duration = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Toast) return g;
    let E = new $root.Toast();
    return g.body != null && (E.body = String(g.body)), g.icon != null && (E.icon = String(g.icon)), g.duration != null && (E.duration = g.duration | 0), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.body = "", e.icon = ""), g.body != null && g.hasOwnProperty("body") && (e.body = g.body), g.icon != null && g.hasOwnProperty("icon") && (e.icon = g.icon), g.duration != null && g.hasOwnProperty("duration") && (e.duration = g.duration, E.oneofs && (e._duration = "duration")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Toast";
  }, o;
})();
$root.VegaLiteChart = (() => {
  function o(i) {
    if (this.datasets = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.spec = "", o.prototype.data = null, o.prototype.datasets = $util.emptyArray, o.prototype.useContainerWidth = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.spec != null && Object.hasOwnProperty.call(i, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.spec), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.DataFrame.encode(i.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), i.datasets != null && i.datasets.length) for (let E = 0; E < i.datasets.length; ++E) $root.NamedDataSet.encode(i.datasets[E], g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    return i.useContainerWidth != null && Object.hasOwnProperty.call(i, "useContainerWidth") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(i.useContainerWidth), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.VegaLiteChart();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.spec = i.string();
          break;
        }
        case 2: {
          t.data = $root.DataFrame.decode(i, i.uint32());
          break;
        }
        case 4: {
          t.datasets && t.datasets.length || (t.datasets = []), t.datasets.push($root.NamedDataSet.decode(i, i.uint32()));
          break;
        }
        case 5: {
          t.useContainerWidth = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.VegaLiteChart) return i;
    let g = new $root.VegaLiteChart();
    if (i.spec != null && (g.spec = String(i.spec)), i.data != null) {
      if (typeof i.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
      g.data = $root.DataFrame.fromObject(i.data);
    }
    if (i.datasets) {
      if (!Array.isArray(i.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
      g.datasets = [];
      for (let E = 0; E < i.datasets.length; ++E) {
        if (typeof i.datasets[E] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
        g.datasets[E] = $root.NamedDataSet.fromObject(i.datasets[E]);
      }
    }
    return i.useContainerWidth != null && (g.useContainerWidth = !!i.useContainerWidth), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.datasets = []), g.defaults && (E.spec = "", E.data = null, E.useContainerWidth = !1), i.spec != null && i.hasOwnProperty("spec") && (E.spec = i.spec), i.data != null && i.hasOwnProperty("data") && (E.data = $root.DataFrame.toObject(i.data, g)), i.datasets && i.datasets.length) {
      E.datasets = [];
      for (let e = 0; e < i.datasets.length; ++e) E.datasets[e] = $root.NamedDataSet.toObject(i.datasets[e], g);
    }
    return i.useContainerWidth != null && i.hasOwnProperty("useContainerWidth") && (E.useContainerWidth = i.useContainerWidth), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/VegaLiteChart";
  }, o;
})();
$root.NamedDataSet = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.name = "", o.prototype.hasName = !1, o.prototype.data = null, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.name != null && Object.hasOwnProperty.call(i, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.name), i.data != null && Object.hasOwnProperty.call(i, "data") && $root.DataFrame.encode(i.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), i.hasName != null && Object.hasOwnProperty.call(i, "hasName") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(i.hasName), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.NamedDataSet();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.name = i.string();
          break;
        }
        case 3: {
          t.hasName = i.bool();
          break;
        }
        case 2: {
          t.data = $root.DataFrame.decode(i, i.uint32());
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.NamedDataSet) return i;
    let g = new $root.NamedDataSet();
    if (i.name != null && (g.name = String(i.name)), i.hasName != null && (g.hasName = !!i.hasName), i.data != null) {
      if (typeof i.data != "object") throw TypeError(".NamedDataSet.data: object expected");
      g.data = $root.DataFrame.fromObject(i.data);
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.name = "", E.data = null, E.hasName = !1), i.name != null && i.hasOwnProperty("name") && (E.name = i.name), i.data != null && i.hasOwnProperty("data") && (E.data = $root.DataFrame.toObject(i.data, g)), i.hasName != null && i.hasOwnProperty("hasName") && (E.hasName = i.hasName), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/NamedDataSet";
  }, o;
})();
$root.SubtitleTrack = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.label = "", o.prototype.url = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.label), i.url != null && Object.hasOwnProperty.call(i, "url") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.url), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.SubtitleTrack();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.label = i.string();
          break;
        }
        case 2: {
          t.url = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.SubtitleTrack) return i;
    let g = new $root.SubtitleTrack();
    return i.label != null && (g.label = String(i.label)), i.url != null && (g.url = String(i.url)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.label = "", E.url = ""), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.url != null && i.hasOwnProperty("url") && (E.url = i.url), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/SubtitleTrack";
  }, o;
})();
$root.Video = (() => {
  function o(g) {
    if (this.subtitles = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.url = "", o.prototype.startTime = 0, o.prototype.type = 0, o.prototype.subtitles = $util.emptyArray, o.prototype.endTime = 0, o.prototype.loop = !1, o.prototype.autoplay = !1, o.prototype.muted = !1, o.prototype.id = "", o.prototype.widthConfig = null;
  let i;
  return Object.defineProperty(o.prototype, "_widthConfig", { get: $util.oneOfGetter(i = ["widthConfig"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.startTime != null && Object.hasOwnProperty.call(g, "startTime") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.startTime), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.type), g.url != null && Object.hasOwnProperty.call(g, "url") && E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.url), g.subtitles != null && g.subtitles.length) for (let e = 0; e < g.subtitles.length; ++e) $root.SubtitleTrack.encode(g.subtitles[e], E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim();
    return g.endTime != null && Object.hasOwnProperty.call(g, "endTime") && E.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.endTime), g.loop != null && Object.hasOwnProperty.call(g, "loop") && E.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.loop), g.autoplay != null && Object.hasOwnProperty.call(g, "autoplay") && E.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.autoplay), g.muted != null && Object.hasOwnProperty.call(g, "muted") && E.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.muted), g.id != null && Object.hasOwnProperty.call(g, "id") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.id), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root.streamlit.WidthConfig.encode(g.widthConfig, E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.Video();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 6: {
          n.url = g.string();
          break;
        }
        case 3: {
          n.startTime = g.int32();
          break;
        }
        case 5: {
          n.type = g.int32();
          break;
        }
        case 7: {
          n.subtitles && n.subtitles.length || (n.subtitles = []), n.subtitles.push($root.SubtitleTrack.decode(g, g.uint32()));
          break;
        }
        case 8: {
          n.endTime = g.int32();
          break;
        }
        case 9: {
          n.loop = g.bool();
          break;
        }
        case 10: {
          n.autoplay = g.bool();
          break;
        }
        case 11: {
          n.muted = g.bool();
          break;
        }
        case 12: {
          n.id = g.string();
          break;
        }
        case 13: {
          n.widthConfig = $root.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.Video) return g;
    let E = new $root.Video();
    switch (g.url != null && (E.url = String(g.url)), g.startTime != null && (E.startTime = g.startTime | 0), g.type) {
      default:
        if (typeof g.type == "number") {
          E.type = g.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        E.type = 0;
        break;
      case "NATIVE":
      case 1:
        E.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        E.type = 2;
        break;
    }
    if (g.subtitles) {
      if (!Array.isArray(g.subtitles)) throw TypeError(".Video.subtitles: array expected");
      E.subtitles = [];
      for (let e = 0; e < g.subtitles.length; ++e) {
        if (typeof g.subtitles[e] != "object") throw TypeError(".Video.subtitles: object expected");
        E.subtitles[e] = $root.SubtitleTrack.fromObject(g.subtitles[e]);
      }
    }
    if (g.endTime != null && (E.endTime = g.endTime | 0), g.loop != null && (E.loop = !!g.loop), g.autoplay != null && (E.autoplay = !!g.autoplay), g.muted != null && (E.muted = !!g.muted), g.id != null && (E.id = String(g.id)), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
      E.widthConfig = $root.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.subtitles = []), E.defaults && (e.startTime = 0, e.type = E.enums === String ? "UNUSED" : 0, e.url = "", e.endTime = 0, e.loop = !1, e.autoplay = !1, e.muted = !1, e.id = ""), g.startTime != null && g.hasOwnProperty("startTime") && (e.startTime = g.startTime), g.type != null && g.hasOwnProperty("type") && (e.type = E.enums === String ? $root.Video.Type[g.type] === void 0 ? g.type : $root.Video.Type[g.type] : g.type), g.url != null && g.hasOwnProperty("url") && (e.url = g.url), g.subtitles && g.subtitles.length) {
      e.subtitles = [];
      for (let t = 0; t < g.subtitles.length; ++t) e.subtitles[t] = $root.SubtitleTrack.toObject(g.subtitles[t], E);
    }
    return g.endTime != null && g.hasOwnProperty("endTime") && (e.endTime = g.endTime), g.loop != null && g.hasOwnProperty("loop") && (e.loop = g.loop), g.autoplay != null && g.hasOwnProperty("autoplay") && (e.autoplay = g.autoplay), g.muted != null && g.hasOwnProperty("muted") && (e.muted = g.muted), g.id != null && g.hasOwnProperty("id") && (e.id = g.id), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(g.widthConfig, E), E.oneofs && (e._widthConfig = "widthConfig")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Video";
  }, o.Type = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "UNUSED"] = 0, E[g[1] = "NATIVE"] = 1, E[g[2] = "YOUTUBE_IFRAME"] = 2, E;
  })(), o;
})();
$root.Heading = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.tag = "", o.prototype.anchor = "", o.prototype.body = "", o.prototype.help = "", o.prototype.hideAnchor = !1, o.prototype.divider = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.tag != null && Object.hasOwnProperty.call(i, "tag") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.tag), i.anchor != null && Object.hasOwnProperty.call(i, "anchor") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.anchor), i.body != null && Object.hasOwnProperty.call(i, "body") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.body), i.help != null && Object.hasOwnProperty.call(i, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.help), i.hideAnchor != null && Object.hasOwnProperty.call(i, "hideAnchor") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(i.hideAnchor), i.divider != null && Object.hasOwnProperty.call(i, "divider") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.divider), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Heading();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.tag = i.string();
          break;
        }
        case 2: {
          t.anchor = i.string();
          break;
        }
        case 3: {
          t.body = i.string();
          break;
        }
        case 4: {
          t.help = i.string();
          break;
        }
        case 5: {
          t.hideAnchor = i.bool();
          break;
        }
        case 6: {
          t.divider = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Heading) return i;
    let g = new $root.Heading();
    return i.tag != null && (g.tag = String(i.tag)), i.anchor != null && (g.anchor = String(i.anchor)), i.body != null && (g.body = String(i.body)), i.help != null && (g.help = String(i.help)), i.hideAnchor != null && (g.hideAnchor = !!i.hideAnchor), i.divider != null && (g.divider = String(i.divider)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.tag = "", E.anchor = "", E.body = "", E.help = "", E.hideAnchor = !1, E.divider = ""), i.tag != null && i.hasOwnProperty("tag") && (E.tag = i.tag), i.anchor != null && i.hasOwnProperty("anchor") && (E.anchor = i.anchor), i.body != null && i.hasOwnProperty("body") && (E.body = i.body), i.help != null && i.hasOwnProperty("help") && (E.help = i.help), i.hideAnchor != null && i.hasOwnProperty("hideAnchor") && (E.hideAnchor = i.hideAnchor), i.divider != null && i.hasOwnProperty("divider") && (E.divider = i.divider), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Heading";
  }, o;
})();
$root.Transient = (() => {
  function o(i) {
    if (this.elements = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.elements = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.elements != null && i.elements.length) for (let E = 0; E < i.elements.length; ++E) $root.Element.encode(i.elements[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Transient();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? (t.elements && t.elements.length || (t.elements = []), t.elements.push($root.Element.decode(i, i.uint32()))) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Transient) return i;
    let g = new $root.Transient();
    if (i.elements) {
      if (!Array.isArray(i.elements)) throw TypeError(".Transient.elements: array expected");
      g.elements = [];
      for (let E = 0; E < i.elements.length; ++E) {
        if (typeof i.elements[E] != "object") throw TypeError(".Transient.elements: object expected");
        g.elements[E] = $root.Element.fromObject(i.elements[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.elements = []), i.elements && i.elements.length) {
      E.elements = [];
      for (let e = 0; e < i.elements.length; ++e) E.elements[e] = $root.Element.toObject(i.elements[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Transient";
  }, o;
})();
$root.ForwardMsg = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.hash = "", o.prototype.metadata = null, o.prototype.newSession = null, o.prototype.delta = null, o.prototype.pageInfoChanged = null, o.prototype.pageConfigChanged = null, o.prototype.scriptFinished = null, o.prototype.gitInfoChanged = null, o.prototype.pageProfile = null, o.prototype.sessionStatusChanged = null, o.prototype.sessionEvent = null, o.prototype.navigation = null, o.prototype.pageNotFound = null, o.prototype.pagesChanged = null, o.prototype.fileUrlsResponse = null, o.prototype.autoRerun = null, o.prototype.logo = null, o.prototype.authRedirect = null, o.prototype.parentMessage = null, o.prototype.refHash = null, o.prototype.deferredFileResponse = null, o.prototype.debugLastBackmsgId = "";
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "pagesChanged", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash", "deferredFileResponse"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.hash != null && Object.hasOwnProperty.call(g, "hash") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.hash), g.metadata != null && Object.hasOwnProperty.call(g, "metadata") && $root.ForwardMsgMetadata.encode(g.metadata, E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.newSession != null && Object.hasOwnProperty.call(g, "newSession") && $root.NewSession.encode(g.newSession, E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.delta != null && Object.hasOwnProperty.call(g, "delta") && $root.Delta.encode(g.delta, E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.scriptFinished != null && Object.hasOwnProperty.call(g, "scriptFinished") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.scriptFinished), g.sessionStatusChanged != null && Object.hasOwnProperty.call(g, "sessionStatusChanged") && $root.SessionStatus.encode(g.sessionStatusChanged, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.sessionEvent != null && Object.hasOwnProperty.call(g, "sessionEvent") && $root.SessionEvent.encode(g.sessionEvent, E.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.refHash != null && Object.hasOwnProperty.call(g, "refHash") && E.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.refHash), g.pageInfoChanged != null && Object.hasOwnProperty.call(g, "pageInfoChanged") && $root.PageInfo.encode(g.pageInfoChanged, E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.pageConfigChanged != null && Object.hasOwnProperty.call(g, "pageConfigChanged") && $root.PageConfig.encode(g.pageConfigChanged, E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.gitInfoChanged != null && Object.hasOwnProperty.call(g, "gitInfoChanged") && $root.GitInfo.encode(g.gitInfoChanged, E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.pageNotFound != null && Object.hasOwnProperty.call(g, "pageNotFound") && $root.PageNotFound.encode(g.pageNotFound, E.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), g.pagesChanged != null && Object.hasOwnProperty.call(g, "pagesChanged") && $root.PagesChanged.encode(g.pagesChanged, E.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.debugLastBackmsgId != null && Object.hasOwnProperty.call(g, "debugLastBackmsgId") && E.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(g.debugLastBackmsgId), g.pageProfile != null && Object.hasOwnProperty.call(g, "pageProfile") && $root.PageProfile.encode(g.pageProfile, E.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), g.fileUrlsResponse != null && Object.hasOwnProperty.call(g, "fileUrlsResponse") && $root.FileURLsResponse.encode(g.fileUrlsResponse, E.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), g.parentMessage != null && Object.hasOwnProperty.call(g, "parentMessage") && $root.ParentMessage.encode(g.parentMessage, E.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), g.autoRerun != null && Object.hasOwnProperty.call(g, "autoRerun") && $root.AutoRerun.encode(g.autoRerun, E.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), g.logo != null && Object.hasOwnProperty.call(g, "logo") && $root.Logo.encode(g.logo, E.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.navigation != null && Object.hasOwnProperty.call(g, "navigation") && $root.Navigation.encode(g.navigation, E.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), g.authRedirect != null && Object.hasOwnProperty.call(g, "authRedirect") && $root.AuthRedirect.encode(g.authRedirect, E.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), g.deferredFileResponse != null && Object.hasOwnProperty.call(g, "deferredFileResponse") && $root.DeferredFileResponse.encode(g.deferredFileResponse, E.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.ForwardMsg();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.hash = g.string();
          break;
        }
        case 2: {
          n.metadata = $root.ForwardMsgMetadata.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.newSession = $root.NewSession.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.delta = $root.Delta.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.pageInfoChanged = $root.PageInfo.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.pageConfigChanged = $root.PageConfig.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.scriptFinished = g.int32();
          break;
        }
        case 14: {
          n.gitInfoChanged = $root.GitInfo.decode(g, g.uint32());
          break;
        }
        case 18: {
          n.pageProfile = $root.PageProfile.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.sessionStatusChanged = $root.SessionStatus.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.sessionEvent = $root.SessionEvent.decode(g, g.uint32());
          break;
        }
        case 23: {
          n.navigation = $root.Navigation.decode(g, g.uint32());
          break;
        }
        case 15: {
          n.pageNotFound = $root.PageNotFound.decode(g, g.uint32());
          break;
        }
        case 16: {
          n.pagesChanged = $root.PagesChanged.decode(g, g.uint32());
          break;
        }
        case 19: {
          n.fileUrlsResponse = $root.FileURLsResponse.decode(g, g.uint32());
          break;
        }
        case 21: {
          n.autoRerun = $root.AutoRerun.decode(g, g.uint32());
          break;
        }
        case 22: {
          n.logo = $root.Logo.decode(g, g.uint32());
          break;
        }
        case 24: {
          n.authRedirect = $root.AuthRedirect.decode(g, g.uint32());
          break;
        }
        case 20: {
          n.parentMessage = $root.ParentMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.refHash = g.string();
          break;
        }
        case 25: {
          n.deferredFileResponse = $root.DeferredFileResponse.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.debugLastBackmsgId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.ForwardMsg) return g;
    let E = new $root.ForwardMsg();
    if (g.hash != null && (E.hash = String(g.hash)), g.metadata != null) {
      if (typeof g.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
      E.metadata = $root.ForwardMsgMetadata.fromObject(g.metadata);
    }
    if (g.newSession != null) {
      if (typeof g.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
      E.newSession = $root.NewSession.fromObject(g.newSession);
    }
    if (g.delta != null) {
      if (typeof g.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
      E.delta = $root.Delta.fromObject(g.delta);
    }
    if (g.pageInfoChanged != null) {
      if (typeof g.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      E.pageInfoChanged = $root.PageInfo.fromObject(g.pageInfoChanged);
    }
    if (g.pageConfigChanged != null) {
      if (typeof g.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      E.pageConfigChanged = $root.PageConfig.fromObject(g.pageConfigChanged);
    }
    switch (g.scriptFinished) {
      default:
        if (typeof g.scriptFinished == "number") {
          E.scriptFinished = g.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        E.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        E.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        E.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        E.scriptFinished = 3;
        break;
    }
    if (g.gitInfoChanged != null) {
      if (typeof g.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      E.gitInfoChanged = $root.GitInfo.fromObject(g.gitInfoChanged);
    }
    if (g.pageProfile != null) {
      if (typeof g.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
      E.pageProfile = $root.PageProfile.fromObject(g.pageProfile);
    }
    if (g.sessionStatusChanged != null) {
      if (typeof g.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      E.sessionStatusChanged = $root.SessionStatus.fromObject(g.sessionStatusChanged);
    }
    if (g.sessionEvent != null) {
      if (typeof g.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
      E.sessionEvent = $root.SessionEvent.fromObject(g.sessionEvent);
    }
    if (g.navigation != null) {
      if (typeof g.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
      E.navigation = $root.Navigation.fromObject(g.navigation);
    }
    if (g.pageNotFound != null) {
      if (typeof g.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
      E.pageNotFound = $root.PageNotFound.fromObject(g.pageNotFound);
    }
    if (g.pagesChanged != null) {
      if (typeof g.pagesChanged != "object") throw TypeError(".ForwardMsg.pagesChanged: object expected");
      E.pagesChanged = $root.PagesChanged.fromObject(g.pagesChanged);
    }
    if (g.fileUrlsResponse != null) {
      if (typeof g.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      E.fileUrlsResponse = $root.FileURLsResponse.fromObject(g.fileUrlsResponse);
    }
    if (g.autoRerun != null) {
      if (typeof g.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
      E.autoRerun = $root.AutoRerun.fromObject(g.autoRerun);
    }
    if (g.logo != null) {
      if (typeof g.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
      E.logo = $root.Logo.fromObject(g.logo);
    }
    if (g.authRedirect != null) {
      if (typeof g.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
      E.authRedirect = $root.AuthRedirect.fromObject(g.authRedirect);
    }
    if (g.parentMessage != null) {
      if (typeof g.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
      E.parentMessage = $root.ParentMessage.fromObject(g.parentMessage);
    }
    if (g.refHash != null && (E.refHash = String(g.refHash)), g.deferredFileResponse != null) {
      if (typeof g.deferredFileResponse != "object") throw TypeError(".ForwardMsg.deferredFileResponse: object expected");
      E.deferredFileResponse = $root.DeferredFileResponse.fromObject(g.deferredFileResponse);
    }
    return g.debugLastBackmsgId != null && (E.debugLastBackmsgId = String(g.debugLastBackmsgId)), E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.hash = "", e.metadata = null, e.debugLastBackmsgId = ""), g.hash != null && g.hasOwnProperty("hash") && (e.hash = g.hash), g.metadata != null && g.hasOwnProperty("metadata") && (e.metadata = $root.ForwardMsgMetadata.toObject(g.metadata, E)), g.newSession != null && g.hasOwnProperty("newSession") && (e.newSession = $root.NewSession.toObject(g.newSession, E), E.oneofs && (e.type = "newSession")), g.delta != null && g.hasOwnProperty("delta") && (e.delta = $root.Delta.toObject(g.delta, E), E.oneofs && (e.type = "delta")), g.scriptFinished != null && g.hasOwnProperty("scriptFinished") && (e.scriptFinished = E.enums === String ? $root.ForwardMsg.ScriptFinishedStatus[g.scriptFinished] === void 0 ? g.scriptFinished : $root.ForwardMsg.ScriptFinishedStatus[g.scriptFinished] : g.scriptFinished, E.oneofs && (e.type = "scriptFinished")), g.sessionStatusChanged != null && g.hasOwnProperty("sessionStatusChanged") && (e.sessionStatusChanged = $root.SessionStatus.toObject(g.sessionStatusChanged, E), E.oneofs && (e.type = "sessionStatusChanged")), g.sessionEvent != null && g.hasOwnProperty("sessionEvent") && (e.sessionEvent = $root.SessionEvent.toObject(g.sessionEvent, E), E.oneofs && (e.type = "sessionEvent")), g.refHash != null && g.hasOwnProperty("refHash") && (e.refHash = g.refHash, E.oneofs && (e.type = "refHash")), g.pageInfoChanged != null && g.hasOwnProperty("pageInfoChanged") && (e.pageInfoChanged = $root.PageInfo.toObject(g.pageInfoChanged, E), E.oneofs && (e.type = "pageInfoChanged")), g.pageConfigChanged != null && g.hasOwnProperty("pageConfigChanged") && (e.pageConfigChanged = $root.PageConfig.toObject(g.pageConfigChanged, E), E.oneofs && (e.type = "pageConfigChanged")), g.gitInfoChanged != null && g.hasOwnProperty("gitInfoChanged") && (e.gitInfoChanged = $root.GitInfo.toObject(g.gitInfoChanged, E), E.oneofs && (e.type = "gitInfoChanged")), g.pageNotFound != null && g.hasOwnProperty("pageNotFound") && (e.pageNotFound = $root.PageNotFound.toObject(g.pageNotFound, E), E.oneofs && (e.type = "pageNotFound")), g.pagesChanged != null && g.hasOwnProperty("pagesChanged") && (e.pagesChanged = $root.PagesChanged.toObject(g.pagesChanged, E), E.oneofs && (e.type = "pagesChanged")), g.debugLastBackmsgId != null && g.hasOwnProperty("debugLastBackmsgId") && (e.debugLastBackmsgId = g.debugLastBackmsgId), g.pageProfile != null && g.hasOwnProperty("pageProfile") && (e.pageProfile = $root.PageProfile.toObject(g.pageProfile, E), E.oneofs && (e.type = "pageProfile")), g.fileUrlsResponse != null && g.hasOwnProperty("fileUrlsResponse") && (e.fileUrlsResponse = $root.FileURLsResponse.toObject(g.fileUrlsResponse, E), E.oneofs && (e.type = "fileUrlsResponse")), g.parentMessage != null && g.hasOwnProperty("parentMessage") && (e.parentMessage = $root.ParentMessage.toObject(g.parentMessage, E), E.oneofs && (e.type = "parentMessage")), g.autoRerun != null && g.hasOwnProperty("autoRerun") && (e.autoRerun = $root.AutoRerun.toObject(g.autoRerun, E), E.oneofs && (e.type = "autoRerun")), g.logo != null && g.hasOwnProperty("logo") && (e.logo = $root.Logo.toObject(g.logo, E), E.oneofs && (e.type = "logo")), g.navigation != null && g.hasOwnProperty("navigation") && (e.navigation = $root.Navigation.toObject(g.navigation, E), E.oneofs && (e.type = "navigation")), g.authRedirect != null && g.hasOwnProperty("authRedirect") && (e.authRedirect = $root.AuthRedirect.toObject(g.authRedirect, E), E.oneofs && (e.type = "authRedirect")), g.deferredFileResponse != null && g.hasOwnProperty("deferredFileResponse") && (e.deferredFileResponse = $root.DeferredFileResponse.toObject(g.deferredFileResponse, E), E.oneofs && (e.type = "deferredFileResponse")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ForwardMsg";
  }, o.ScriptFinishedStatus = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "FINISHED_SUCCESSFULLY"] = 0, E[g[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, E[g[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, E[g[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, E;
  })(), o;
})();
$root.DeferredFileResponse = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.fileId = "", o.prototype.url = "", o.prototype.errorMsg = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.fileId != null && Object.hasOwnProperty.call(i, "fileId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.fileId), i.url != null && Object.hasOwnProperty.call(i, "url") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.url), i.errorMsg != null && Object.hasOwnProperty.call(i, "errorMsg") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.errorMsg), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.DeferredFileResponse();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.fileId = i.string();
          break;
        }
        case 2: {
          t.url = i.string();
          break;
        }
        case 3: {
          t.errorMsg = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.DeferredFileResponse) return i;
    let g = new $root.DeferredFileResponse();
    return i.fileId != null && (g.fileId = String(i.fileId)), i.url != null && (g.url = String(i.url)), i.errorMsg != null && (g.errorMsg = String(i.errorMsg)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.fileId = "", E.url = "", E.errorMsg = ""), i.fileId != null && i.hasOwnProperty("fileId") && (E.fileId = i.fileId), i.url != null && i.hasOwnProperty("url") && (E.url = i.url), i.errorMsg != null && i.hasOwnProperty("errorMsg") && (E.errorMsg = i.errorMsg), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/DeferredFileResponse";
  }, o;
})();
$root.ForwardMsgMetadata = (() => {
  function o(i) {
    if (this.deltaPath = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.cacheable = !1, o.prototype.deltaPath = $util.emptyArray, o.prototype.elementDimensionSpec = null, o.prototype.activeScriptHash = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.cacheable != null && Object.hasOwnProperty.call(i, "cacheable") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(i.cacheable), i.deltaPath != null && i.deltaPath.length) {
      g.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork();
      for (let E = 0; E < i.deltaPath.length; ++E) g.uint32(i.deltaPath[E]);
      g.ldelim();
    }
    return i.elementDimensionSpec != null && Object.hasOwnProperty.call(i, "elementDimensionSpec") && $root.ElementDimensionSpec.encode(i.elementDimensionSpec, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), i.activeScriptHash != null && Object.hasOwnProperty.call(i, "activeScriptHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.activeScriptHash), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ForwardMsgMetadata();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.cacheable = i.bool();
          break;
        }
        case 2: {
          if (t.deltaPath && t.deltaPath.length || (t.deltaPath = []), (n & 7) === 2) {
            let h = i.uint32() + i.pos;
            for (; i.pos < h; ) t.deltaPath.push(i.uint32());
          } else t.deltaPath.push(i.uint32());
          break;
        }
        case 3: {
          t.elementDimensionSpec = $root.ElementDimensionSpec.decode(i, i.uint32());
          break;
        }
        case 4: {
          t.activeScriptHash = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ForwardMsgMetadata) return i;
    let g = new $root.ForwardMsgMetadata();
    if (i.cacheable != null && (g.cacheable = !!i.cacheable), i.deltaPath) {
      if (!Array.isArray(i.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      g.deltaPath = [];
      for (let E = 0; E < i.deltaPath.length; ++E) g.deltaPath[E] = i.deltaPath[E] >>> 0;
    }
    if (i.elementDimensionSpec != null) {
      if (typeof i.elementDimensionSpec != "object") throw TypeError(".ForwardMsgMetadata.elementDimensionSpec: object expected");
      g.elementDimensionSpec = $root.ElementDimensionSpec.fromObject(i.elementDimensionSpec);
    }
    return i.activeScriptHash != null && (g.activeScriptHash = String(i.activeScriptHash)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.deltaPath = []), g.defaults && (E.cacheable = !1, E.elementDimensionSpec = null, E.activeScriptHash = ""), i.cacheable != null && i.hasOwnProperty("cacheable") && (E.cacheable = i.cacheable), i.deltaPath && i.deltaPath.length) {
      E.deltaPath = [];
      for (let e = 0; e < i.deltaPath.length; ++e) E.deltaPath[e] = i.deltaPath[e];
    }
    return i.elementDimensionSpec != null && i.hasOwnProperty("elementDimensionSpec") && (E.elementDimensionSpec = $root.ElementDimensionSpec.toObject(i.elementDimensionSpec, g)), i.activeScriptHash != null && i.hasOwnProperty("activeScriptHash") && (E.activeScriptHash = i.activeScriptHash), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ForwardMsgMetadata";
  }, o;
})();
$root.ElementDimensionSpec = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.width = 0, o.prototype.height = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.width != null && Object.hasOwnProperty.call(i, "width") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(i.width), i.height != null && Object.hasOwnProperty.call(i, "height") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(i.height), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ElementDimensionSpec();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.width = i.uint32();
          break;
        }
        case 2: {
          t.height = i.uint32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ElementDimensionSpec) return i;
    let g = new $root.ElementDimensionSpec();
    return i.width != null && (g.width = i.width >>> 0), i.height != null && (g.height = i.height >>> 0), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.width = 0, E.height = 0), i.width != null && i.hasOwnProperty("width") && (E.width = i.width), i.height != null && i.hasOwnProperty("height") && (E.height = i.height), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ElementDimensionSpec";
  }, o;
})();
$root.ForwardMsgList = (() => {
  function o(i) {
    if (this.messages = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.messages = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.messages != null && i.messages.length) for (let E = 0; E < i.messages.length; ++E) $root.ForwardMsg.encode(i.messages[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ForwardMsgList();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? (t.messages && t.messages.length || (t.messages = []), t.messages.push($root.ForwardMsg.decode(i, i.uint32()))) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ForwardMsgList) return i;
    let g = new $root.ForwardMsgList();
    if (i.messages) {
      if (!Array.isArray(i.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
      g.messages = [];
      for (let E = 0; E < i.messages.length; ++E) {
        if (typeof i.messages[E] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
        g.messages[E] = $root.ForwardMsg.fromObject(i.messages[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.messages = []), i.messages && i.messages.length) {
      E.messages = [];
      for (let e = 0; e < i.messages.length; ++e) E.messages[e] = $root.ForwardMsg.toObject(i.messages[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ForwardMsgList";
  }, o;
})();
$root.GitInfo = (() => {
  function o(i) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.repository = "", o.prototype.branch = "", o.prototype.module = "", o.prototype.untrackedFiles = $util.emptyArray, o.prototype.uncommittedFiles = $util.emptyArray, o.prototype.state = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.repository != null && Object.hasOwnProperty.call(i, "repository") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.repository), i.branch != null && Object.hasOwnProperty.call(i, "branch") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.branch), i.module != null && Object.hasOwnProperty.call(i, "module") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.module), i.untrackedFiles != null && i.untrackedFiles.length) for (let E = 0; E < i.untrackedFiles.length; ++E) g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.untrackedFiles[E]);
    if (i.uncommittedFiles != null && i.uncommittedFiles.length) for (let E = 0; E < i.uncommittedFiles.length; ++E) g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.uncommittedFiles[E]);
    return i.state != null && Object.hasOwnProperty.call(i, "state") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(i.state), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.GitInfo();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.repository = i.string();
          break;
        }
        case 2: {
          t.branch = i.string();
          break;
        }
        case 3: {
          t.module = i.string();
          break;
        }
        case 4: {
          t.untrackedFiles && t.untrackedFiles.length || (t.untrackedFiles = []), t.untrackedFiles.push(i.string());
          break;
        }
        case 5: {
          t.uncommittedFiles && t.uncommittedFiles.length || (t.uncommittedFiles = []), t.uncommittedFiles.push(i.string());
          break;
        }
        case 6: {
          t.state = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.GitInfo) return i;
    let g = new $root.GitInfo();
    if (i.repository != null && (g.repository = String(i.repository)), i.branch != null && (g.branch = String(i.branch)), i.module != null && (g.module = String(i.module)), i.untrackedFiles) {
      if (!Array.isArray(i.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
      g.untrackedFiles = [];
      for (let E = 0; E < i.untrackedFiles.length; ++E) g.untrackedFiles[E] = String(i.untrackedFiles[E]);
    }
    if (i.uncommittedFiles) {
      if (!Array.isArray(i.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
      g.uncommittedFiles = [];
      for (let E = 0; E < i.uncommittedFiles.length; ++E) g.uncommittedFiles[E] = String(i.uncommittedFiles[E]);
    }
    switch (i.state) {
      default:
        if (typeof i.state == "number") {
          g.state = i.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        g.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        g.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        g.state = 2;
        break;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.untrackedFiles = [], E.uncommittedFiles = []), g.defaults && (E.repository = "", E.branch = "", E.module = "", E.state = g.enums === String ? "DEFAULT" : 0), i.repository != null && i.hasOwnProperty("repository") && (E.repository = i.repository), i.branch != null && i.hasOwnProperty("branch") && (E.branch = i.branch), i.module != null && i.hasOwnProperty("module") && (E.module = i.module), i.untrackedFiles && i.untrackedFiles.length) {
      E.untrackedFiles = [];
      for (let e = 0; e < i.untrackedFiles.length; ++e) E.untrackedFiles[e] = i.untrackedFiles[e];
    }
    if (i.uncommittedFiles && i.uncommittedFiles.length) {
      E.uncommittedFiles = [];
      for (let e = 0; e < i.uncommittedFiles.length; ++e) E.uncommittedFiles[e] = i.uncommittedFiles[e];
    }
    return i.state != null && i.hasOwnProperty("state") && (E.state = g.enums === String ? $root.GitInfo.GitStates[i.state] === void 0 ? i.state : $root.GitInfo.GitStates[i.state] : i.state), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/GitInfo";
  }, o.GitStates = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "DEFAULT"] = 0, g[i[1] = "HEAD_DETACHED"] = 1, g[i[2] = "AHEAD_OF_REMOTE"] = 2, g;
  })(), o;
})();
$root.Logo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.image = "", o.prototype.link = "", o.prototype.iconImage = "", o.prototype.size = "", o.prototype.imageType = 0, o.prototype.iconImageType = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.image != null && Object.hasOwnProperty.call(i, "image") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.image), i.link != null && Object.hasOwnProperty.call(i, "link") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.link), i.iconImage != null && Object.hasOwnProperty.call(i, "iconImage") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.iconImage), i.size != null && Object.hasOwnProperty.call(i, "size") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.size), i.imageType != null && Object.hasOwnProperty.call(i, "imageType") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(i.imageType), i.iconImageType != null && Object.hasOwnProperty.call(i, "iconImageType") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(i.iconImageType), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Logo();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.image = i.string();
          break;
        }
        case 2: {
          t.link = i.string();
          break;
        }
        case 3: {
          t.iconImage = i.string();
          break;
        }
        case 4: {
          t.size = i.string();
          break;
        }
        case 5: {
          t.imageType = i.int32();
          break;
        }
        case 6: {
          t.iconImageType = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Logo) return i;
    let g = new $root.Logo();
    switch (i.image != null && (g.image = String(i.image)), i.link != null && (g.link = String(i.link)), i.iconImage != null && (g.iconImage = String(i.iconImage)), i.size != null && (g.size = String(i.size)), i.imageType) {
      default:
        if (typeof i.imageType == "number") {
          g.imageType = i.imageType;
          break;
        }
        break;
      case "IMAGE":
      case 0:
        g.imageType = 0;
        break;
      case "EMOJI":
      case 1:
        g.imageType = 1;
        break;
      case "ICON":
      case 2:
        g.imageType = 2;
        break;
    }
    switch (i.iconImageType) {
      default:
        if (typeof i.iconImageType == "number") {
          g.iconImageType = i.iconImageType;
          break;
        }
        break;
      case "IMAGE":
      case 0:
        g.iconImageType = 0;
        break;
      case "EMOJI":
      case 1:
        g.iconImageType = 1;
        break;
      case "ICON":
      case 2:
        g.iconImageType = 2;
        break;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.image = "", E.link = "", E.iconImage = "", E.size = "", E.imageType = g.enums === String ? "IMAGE" : 0, E.iconImageType = g.enums === String ? "IMAGE" : 0), i.image != null && i.hasOwnProperty("image") && (E.image = i.image), i.link != null && i.hasOwnProperty("link") && (E.link = i.link), i.iconImage != null && i.hasOwnProperty("iconImage") && (E.iconImage = i.iconImage), i.size != null && i.hasOwnProperty("size") && (E.size = i.size), i.imageType != null && i.hasOwnProperty("imageType") && (E.imageType = g.enums === String ? $root.Logo.ImageType[i.imageType] === void 0 ? i.imageType : $root.Logo.ImageType[i.imageType] : i.imageType), i.iconImageType != null && i.hasOwnProperty("iconImageType") && (E.iconImageType = g.enums === String ? $root.Logo.ImageType[i.iconImageType] === void 0 ? i.iconImageType : $root.Logo.ImageType[i.iconImageType] : i.iconImageType), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Logo";
  }, o.ImageType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "IMAGE"] = 0, g[i[1] = "EMOJI"] = 1, g[i[2] = "ICON"] = 2, g;
  })(), o;
})();
$root.Navigation = (() => {
  function o(i) {
    if (this.sections = [], this.appPages = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.sections = $util.emptyArray, o.prototype.appPages = $util.emptyArray, o.prototype.position = 0, o.prototype.pageScriptHash = "", o.prototype.expanded = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.sections != null && i.sections.length) for (let E = 0; E < i.sections.length; ++E) g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.sections[E]);
    if (i.appPages != null && i.appPages.length) for (let E = 0; E < i.appPages.length; ++E) $root.AppPage.encode(i.appPages[E], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return i.position != null && Object.hasOwnProperty.call(i, "position") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(i.position), i.pageScriptHash != null && Object.hasOwnProperty.call(i, "pageScriptHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.pageScriptHash), i.expanded != null && Object.hasOwnProperty.call(i, "expanded") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(i.expanded), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Navigation();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.sections && t.sections.length || (t.sections = []), t.sections.push(i.string());
          break;
        }
        case 2: {
          t.appPages && t.appPages.length || (t.appPages = []), t.appPages.push($root.AppPage.decode(i, i.uint32()));
          break;
        }
        case 3: {
          t.position = i.int32();
          break;
        }
        case 4: {
          t.pageScriptHash = i.string();
          break;
        }
        case 5: {
          t.expanded = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Navigation) return i;
    let g = new $root.Navigation();
    if (i.sections) {
      if (!Array.isArray(i.sections)) throw TypeError(".Navigation.sections: array expected");
      g.sections = [];
      for (let E = 0; E < i.sections.length; ++E) g.sections[E] = String(i.sections[E]);
    }
    if (i.appPages) {
      if (!Array.isArray(i.appPages)) throw TypeError(".Navigation.appPages: array expected");
      g.appPages = [];
      for (let E = 0; E < i.appPages.length; ++E) {
        if (typeof i.appPages[E] != "object") throw TypeError(".Navigation.appPages: object expected");
        g.appPages[E] = $root.AppPage.fromObject(i.appPages[E]);
      }
    }
    switch (i.position) {
      default:
        if (typeof i.position == "number") {
          g.position = i.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        g.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        g.position = 1;
        break;
      case "TOP":
      case 2:
        g.position = 2;
        break;
    }
    return i.pageScriptHash != null && (g.pageScriptHash = String(i.pageScriptHash)), i.expanded != null && (g.expanded = !!i.expanded), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.sections = [], E.appPages = []), g.defaults && (E.position = g.enums === String ? "HIDDEN" : 0, E.pageScriptHash = "", E.expanded = !1), i.sections && i.sections.length) {
      E.sections = [];
      for (let e = 0; e < i.sections.length; ++e) E.sections[e] = i.sections[e];
    }
    if (i.appPages && i.appPages.length) {
      E.appPages = [];
      for (let e = 0; e < i.appPages.length; ++e) E.appPages[e] = $root.AppPage.toObject(i.appPages[e], g);
    }
    return i.position != null && i.hasOwnProperty("position") && (E.position = g.enums === String ? $root.Navigation.Position[i.position] === void 0 ? i.position : $root.Navigation.Position[i.position] : i.position), i.pageScriptHash != null && i.hasOwnProperty("pageScriptHash") && (E.pageScriptHash = i.pageScriptHash), i.expanded != null && i.hasOwnProperty("expanded") && (E.expanded = i.expanded), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Navigation";
  }, o.Position = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "HIDDEN"] = 0, g[i[1] = "SIDEBAR"] = 1, g[i[2] = "TOP"] = 2, g;
  })(), o;
})();
$root.NewSession = (() => {
  function o(i) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.initialize = null, o.prototype.scriptRunId = "", o.prototype.name = "", o.prototype.mainScriptPath = "", o.prototype.config = null, o.prototype.customTheme = null, o.prototype.appPages = $util.emptyArray, o.prototype.pageScriptHash = "", o.prototype.fragmentIdsThisRun = $util.emptyArray, o.prototype.mainScriptHash = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.initialize != null && Object.hasOwnProperty.call(i, "initialize") && $root.Initialize.encode(i.initialize, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), i.scriptRunId != null && Object.hasOwnProperty.call(i, "scriptRunId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.scriptRunId), i.name != null && Object.hasOwnProperty.call(i, "name") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.name), i.mainScriptPath != null && Object.hasOwnProperty.call(i, "mainScriptPath") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.mainScriptPath), i.config != null && Object.hasOwnProperty.call(i, "config") && $root.Config.encode(i.config, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), i.customTheme != null && Object.hasOwnProperty.call(i, "customTheme") && $root.CustomThemeConfig.encode(i.customTheme, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), i.appPages != null && i.appPages.length) for (let E = 0; E < i.appPages.length; ++E) $root.AppPage.encode(i.appPages[E], g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    if (i.pageScriptHash != null && Object.hasOwnProperty.call(i, "pageScriptHash") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(i.pageScriptHash), i.fragmentIdsThisRun != null && i.fragmentIdsThisRun.length) for (let E = 0; E < i.fragmentIdsThisRun.length; ++E) g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(i.fragmentIdsThisRun[E]);
    return i.mainScriptHash != null && Object.hasOwnProperty.call(i, "mainScriptHash") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(i.mainScriptHash), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.NewSession();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.initialize = $root.Initialize.decode(i, i.uint32());
          break;
        }
        case 2: {
          t.scriptRunId = i.string();
          break;
        }
        case 3: {
          t.name = i.string();
          break;
        }
        case 4: {
          t.mainScriptPath = i.string();
          break;
        }
        case 6: {
          t.config = $root.Config.decode(i, i.uint32());
          break;
        }
        case 7: {
          t.customTheme = $root.CustomThemeConfig.decode(i, i.uint32());
          break;
        }
        case 8: {
          t.appPages && t.appPages.length || (t.appPages = []), t.appPages.push($root.AppPage.decode(i, i.uint32()));
          break;
        }
        case 9: {
          t.pageScriptHash = i.string();
          break;
        }
        case 10: {
          t.fragmentIdsThisRun && t.fragmentIdsThisRun.length || (t.fragmentIdsThisRun = []), t.fragmentIdsThisRun.push(i.string());
          break;
        }
        case 11: {
          t.mainScriptHash = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.NewSession) return i;
    let g = new $root.NewSession();
    if (i.initialize != null) {
      if (typeof i.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
      g.initialize = $root.Initialize.fromObject(i.initialize);
    }
    if (i.scriptRunId != null && (g.scriptRunId = String(i.scriptRunId)), i.name != null && (g.name = String(i.name)), i.mainScriptPath != null && (g.mainScriptPath = String(i.mainScriptPath)), i.config != null) {
      if (typeof i.config != "object") throw TypeError(".NewSession.config: object expected");
      g.config = $root.Config.fromObject(i.config);
    }
    if (i.customTheme != null) {
      if (typeof i.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
      g.customTheme = $root.CustomThemeConfig.fromObject(i.customTheme);
    }
    if (i.appPages) {
      if (!Array.isArray(i.appPages)) throw TypeError(".NewSession.appPages: array expected");
      g.appPages = [];
      for (let E = 0; E < i.appPages.length; ++E) {
        if (typeof i.appPages[E] != "object") throw TypeError(".NewSession.appPages: object expected");
        g.appPages[E] = $root.AppPage.fromObject(i.appPages[E]);
      }
    }
    if (i.pageScriptHash != null && (g.pageScriptHash = String(i.pageScriptHash)), i.fragmentIdsThisRun) {
      if (!Array.isArray(i.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      g.fragmentIdsThisRun = [];
      for (let E = 0; E < i.fragmentIdsThisRun.length; ++E) g.fragmentIdsThisRun[E] = String(i.fragmentIdsThisRun[E]);
    }
    return i.mainScriptHash != null && (g.mainScriptHash = String(i.mainScriptHash)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.appPages = [], E.fragmentIdsThisRun = []), g.defaults && (E.initialize = null, E.scriptRunId = "", E.name = "", E.mainScriptPath = "", E.config = null, E.customTheme = null, E.pageScriptHash = "", E.mainScriptHash = ""), i.initialize != null && i.hasOwnProperty("initialize") && (E.initialize = $root.Initialize.toObject(i.initialize, g)), i.scriptRunId != null && i.hasOwnProperty("scriptRunId") && (E.scriptRunId = i.scriptRunId), i.name != null && i.hasOwnProperty("name") && (E.name = i.name), i.mainScriptPath != null && i.hasOwnProperty("mainScriptPath") && (E.mainScriptPath = i.mainScriptPath), i.config != null && i.hasOwnProperty("config") && (E.config = $root.Config.toObject(i.config, g)), i.customTheme != null && i.hasOwnProperty("customTheme") && (E.customTheme = $root.CustomThemeConfig.toObject(i.customTheme, g)), i.appPages && i.appPages.length) {
      E.appPages = [];
      for (let e = 0; e < i.appPages.length; ++e) E.appPages[e] = $root.AppPage.toObject(i.appPages[e], g);
    }
    if (i.pageScriptHash != null && i.hasOwnProperty("pageScriptHash") && (E.pageScriptHash = i.pageScriptHash), i.fragmentIdsThisRun && i.fragmentIdsThisRun.length) {
      E.fragmentIdsThisRun = [];
      for (let e = 0; e < i.fragmentIdsThisRun.length; ++e) E.fragmentIdsThisRun[e] = i.fragmentIdsThisRun[e];
    }
    return i.mainScriptHash != null && i.hasOwnProperty("mainScriptHash") && (E.mainScriptHash = i.mainScriptHash), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/NewSession";
  }, o;
})();
$root.Initialize = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.userInfo = null, o.prototype.environmentInfo = null, o.prototype.sessionStatus = null, o.prototype.commandLine = "", o.prototype.sessionId = "", o.prototype.isHello = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.userInfo != null && Object.hasOwnProperty.call(i, "userInfo") && $root.UserInfo.encode(i.userInfo, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), i.environmentInfo != null && Object.hasOwnProperty.call(i, "environmentInfo") && $root.EnvironmentInfo.encode(i.environmentInfo, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), i.sessionStatus != null && Object.hasOwnProperty.call(i, "sessionStatus") && $root.SessionStatus.encode(i.sessionStatus, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), i.commandLine != null && Object.hasOwnProperty.call(i, "commandLine") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.commandLine), i.sessionId != null && Object.hasOwnProperty.call(i, "sessionId") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.sessionId), i.isHello != null && Object.hasOwnProperty.call(i, "isHello") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(i.isHello), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Initialize();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.userInfo = $root.UserInfo.decode(i, i.uint32());
          break;
        }
        case 3: {
          t.environmentInfo = $root.EnvironmentInfo.decode(i, i.uint32());
          break;
        }
        case 4: {
          t.sessionStatus = $root.SessionStatus.decode(i, i.uint32());
          break;
        }
        case 5: {
          t.commandLine = i.string();
          break;
        }
        case 6: {
          t.sessionId = i.string();
          break;
        }
        case 7: {
          t.isHello = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Initialize) return i;
    let g = new $root.Initialize();
    if (i.userInfo != null) {
      if (typeof i.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
      g.userInfo = $root.UserInfo.fromObject(i.userInfo);
    }
    if (i.environmentInfo != null) {
      if (typeof i.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
      g.environmentInfo = $root.EnvironmentInfo.fromObject(i.environmentInfo);
    }
    if (i.sessionStatus != null) {
      if (typeof i.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
      g.sessionStatus = $root.SessionStatus.fromObject(i.sessionStatus);
    }
    return i.commandLine != null && (g.commandLine = String(i.commandLine)), i.sessionId != null && (g.sessionId = String(i.sessionId)), i.isHello != null && (g.isHello = !!i.isHello), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.userInfo = null, E.environmentInfo = null, E.sessionStatus = null, E.commandLine = "", E.sessionId = "", E.isHello = !1), i.userInfo != null && i.hasOwnProperty("userInfo") && (E.userInfo = $root.UserInfo.toObject(i.userInfo, g)), i.environmentInfo != null && i.hasOwnProperty("environmentInfo") && (E.environmentInfo = $root.EnvironmentInfo.toObject(i.environmentInfo, g)), i.sessionStatus != null && i.hasOwnProperty("sessionStatus") && (E.sessionStatus = $root.SessionStatus.toObject(i.sessionStatus, g)), i.commandLine != null && i.hasOwnProperty("commandLine") && (E.commandLine = i.commandLine), i.sessionId != null && i.hasOwnProperty("sessionId") && (E.sessionId = i.sessionId), i.isHello != null && i.hasOwnProperty("isHello") && (E.isHello = i.isHello), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Initialize";
  }, o;
})();
$root.Config = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.gatherUsageStats = !1, o.prototype.maxCachedMessageAge = 0, o.prototype.mapboxToken = "", o.prototype.allowRunOnSave = !1, o.prototype.hideTopBar = !1, o.prototype.hideSidebarNav = !1, o.prototype.toolbarMode = 0, o.prototype.showErrorLinks = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.gatherUsageStats != null && Object.hasOwnProperty.call(i, "gatherUsageStats") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(i.gatherUsageStats), i.maxCachedMessageAge != null && Object.hasOwnProperty.call(i, "maxCachedMessageAge") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(i.maxCachedMessageAge), i.mapboxToken != null && Object.hasOwnProperty.call(i, "mapboxToken") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.mapboxToken), i.allowRunOnSave != null && Object.hasOwnProperty.call(i, "allowRunOnSave") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(i.allowRunOnSave), i.hideTopBar != null && Object.hasOwnProperty.call(i, "hideTopBar") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(i.hideTopBar), i.hideSidebarNav != null && Object.hasOwnProperty.call(i, "hideSidebarNav") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(i.hideSidebarNav), i.toolbarMode != null && Object.hasOwnProperty.call(i, "toolbarMode") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(i.toolbarMode), i.showErrorLinks != null && Object.hasOwnProperty.call(i, "showErrorLinks") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(i.showErrorLinks), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Config();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 2: {
          t.gatherUsageStats = i.bool();
          break;
        }
        case 3: {
          t.maxCachedMessageAge = i.int32();
          break;
        }
        case 4: {
          t.mapboxToken = i.string();
          break;
        }
        case 5: {
          t.allowRunOnSave = i.bool();
          break;
        }
        case 6: {
          t.hideTopBar = i.bool();
          break;
        }
        case 7: {
          t.hideSidebarNav = i.bool();
          break;
        }
        case 8: {
          t.toolbarMode = i.int32();
          break;
        }
        case 9: {
          t.showErrorLinks = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Config) return i;
    let g = new $root.Config();
    switch (i.gatherUsageStats != null && (g.gatherUsageStats = !!i.gatherUsageStats), i.maxCachedMessageAge != null && (g.maxCachedMessageAge = i.maxCachedMessageAge | 0), i.mapboxToken != null && (g.mapboxToken = String(i.mapboxToken)), i.allowRunOnSave != null && (g.allowRunOnSave = !!i.allowRunOnSave), i.hideTopBar != null && (g.hideTopBar = !!i.hideTopBar), i.hideSidebarNav != null && (g.hideSidebarNav = !!i.hideSidebarNav), i.toolbarMode) {
      default:
        if (typeof i.toolbarMode == "number") {
          g.toolbarMode = i.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        g.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        g.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        g.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        g.toolbarMode = 3;
        break;
    }
    switch (i.showErrorLinks) {
      default:
        if (typeof i.showErrorLinks == "number") {
          g.showErrorLinks = i.showErrorLinks;
          break;
        }
        break;
      case "SHOW_ERROR_LINKS_UNSPECIFIED":
      case 0:
        g.showErrorLinks = 0;
        break;
      case "SHOW_ERROR_LINKS_AUTO":
      case 1:
        g.showErrorLinks = 1;
        break;
      case "SHOW_ERROR_LINKS_TRUE":
      case 2:
        g.showErrorLinks = 2;
        break;
      case "SHOW_ERROR_LINKS_FALSE":
      case 3:
        g.showErrorLinks = 3;
        break;
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.gatherUsageStats = !1, E.maxCachedMessageAge = 0, E.mapboxToken = "", E.allowRunOnSave = !1, E.hideTopBar = !1, E.hideSidebarNav = !1, E.toolbarMode = g.enums === String ? "AUTO" : 0, E.showErrorLinks = g.enums === String ? "SHOW_ERROR_LINKS_UNSPECIFIED" : 0), i.gatherUsageStats != null && i.hasOwnProperty("gatherUsageStats") && (E.gatherUsageStats = i.gatherUsageStats), i.maxCachedMessageAge != null && i.hasOwnProperty("maxCachedMessageAge") && (E.maxCachedMessageAge = i.maxCachedMessageAge), i.mapboxToken != null && i.hasOwnProperty("mapboxToken") && (E.mapboxToken = i.mapboxToken), i.allowRunOnSave != null && i.hasOwnProperty("allowRunOnSave") && (E.allowRunOnSave = i.allowRunOnSave), i.hideTopBar != null && i.hasOwnProperty("hideTopBar") && (E.hideTopBar = i.hideTopBar), i.hideSidebarNav != null && i.hasOwnProperty("hideSidebarNav") && (E.hideSidebarNav = i.hideSidebarNav), i.toolbarMode != null && i.hasOwnProperty("toolbarMode") && (E.toolbarMode = g.enums === String ? $root.Config.ToolbarMode[i.toolbarMode] === void 0 ? i.toolbarMode : $root.Config.ToolbarMode[i.toolbarMode] : i.toolbarMode), i.showErrorLinks != null && i.hasOwnProperty("showErrorLinks") && (E.showErrorLinks = g.enums === String ? $root.Config.ShowErrorLinks[i.showErrorLinks] === void 0 ? i.showErrorLinks : $root.Config.ShowErrorLinks[i.showErrorLinks] : i.showErrorLinks), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Config";
  }, o.ToolbarMode = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "AUTO"] = 0, g[i[1] = "DEVELOPER"] = 1, g[i[2] = "VIEWER"] = 2, g[i[3] = "MINIMAL"] = 3, g;
  })(), o.ShowErrorLinks = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "SHOW_ERROR_LINKS_UNSPECIFIED"] = 0, g[i[1] = "SHOW_ERROR_LINKS_AUTO"] = 1, g[i[2] = "SHOW_ERROR_LINKS_TRUE"] = 2, g[i[3] = "SHOW_ERROR_LINKS_FALSE"] = 3, g;
  })(), o;
})();
$root.CustomThemeConfig = (() => {
  function o(g) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], this.chartDivergingColors = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.primaryColor = "", o.prototype.secondaryBackgroundColor = "", o.prototype.backgroundColor = "", o.prototype.textColor = "", o.prototype.font = 0, o.prototype.base = 0, o.prototype.widgetBackgroundColor = "", o.prototype.widgetBorderColor = "", o.prototype.radii = null, o.prototype.headingFont = "", o.prototype.bodyFont = "", o.prototype.codeFont = "", o.prototype.fontFaces = $util.emptyArray, o.prototype.fontSources = $util.emptyArray, o.prototype.fontSizes = null, o.prototype.skeletonBackgroundColor = "", o.prototype.baseRadius = null, o.prototype.buttonRadius = null, o.prototype.borderColor = null, o.prototype.dataframeBorderColor = null, o.prototype.showWidgetBorder = null, o.prototype.linkColor = null, o.prototype.linkUnderline = null, o.prototype.baseFontSize = null, o.prototype.baseFontWeight = null, o.prototype.codeFontWeight = null, o.prototype.codeFontSize = null, o.prototype.headingFontSizes = $util.emptyArray, o.prototype.headingFontWeights = $util.emptyArray, o.prototype.showSidebarBorder = null, o.prototype.codeTextColor = null, o.prototype.codeBackgroundColor = null, o.prototype.dataframeHeaderBackgroundColor = null, o.prototype.chartCategoricalColors = $util.emptyArray, o.prototype.chartSequentialColors = $util.emptyArray, o.prototype.chartDivergingColors = $util.emptyArray, o.prototype.redColor = null, o.prototype.orangeColor = null, o.prototype.yellowColor = null, o.prototype.blueColor = null, o.prototype.greenColor = null, o.prototype.violetColor = null, o.prototype.grayColor = null, o.prototype.redBackgroundColor = null, o.prototype.orangeBackgroundColor = null, o.prototype.yellowBackgroundColor = null, o.prototype.blueBackgroundColor = null, o.prototype.greenBackgroundColor = null, o.prototype.violetBackgroundColor = null, o.prototype.grayBackgroundColor = null, o.prototype.redTextColor = null, o.prototype.orangeTextColor = null, o.prototype.yellowTextColor = null, o.prototype.blueTextColor = null, o.prototype.greenTextColor = null, o.prototype.violetTextColor = null, o.prototype.grayTextColor = null, o.prototype.sidebar = null, o.prototype.light = null, o.prototype.dark = null;
  let i;
  return Object.defineProperty(o.prototype, "_baseRadius", { get: $util.oneOfGetter(i = ["baseRadius"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_buttonRadius", { get: $util.oneOfGetter(i = ["buttonRadius"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_borderColor", { get: $util.oneOfGetter(i = ["borderColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_dataframeBorderColor", { get: $util.oneOfGetter(i = ["dataframeBorderColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_showWidgetBorder", { get: $util.oneOfGetter(i = ["showWidgetBorder"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_linkColor", { get: $util.oneOfGetter(i = ["linkColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_linkUnderline", { get: $util.oneOfGetter(i = ["linkUnderline"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_baseFontSize", { get: $util.oneOfGetter(i = ["baseFontSize"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_baseFontWeight", { get: $util.oneOfGetter(i = ["baseFontWeight"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_codeFontWeight", { get: $util.oneOfGetter(i = ["codeFontWeight"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_codeFontSize", { get: $util.oneOfGetter(i = ["codeFontSize"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_showSidebarBorder", { get: $util.oneOfGetter(i = ["showSidebarBorder"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_codeTextColor", { get: $util.oneOfGetter(i = ["codeTextColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_codeBackgroundColor", { get: $util.oneOfGetter(i = ["codeBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_dataframeHeaderBackgroundColor", { get: $util.oneOfGetter(i = ["dataframeHeaderBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_redColor", { get: $util.oneOfGetter(i = ["redColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_orangeColor", { get: $util.oneOfGetter(i = ["orangeColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_yellowColor", { get: $util.oneOfGetter(i = ["yellowColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_blueColor", { get: $util.oneOfGetter(i = ["blueColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_greenColor", { get: $util.oneOfGetter(i = ["greenColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_violetColor", { get: $util.oneOfGetter(i = ["violetColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_grayColor", { get: $util.oneOfGetter(i = ["grayColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_redBackgroundColor", { get: $util.oneOfGetter(i = ["redBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_orangeBackgroundColor", { get: $util.oneOfGetter(i = ["orangeBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_yellowBackgroundColor", { get: $util.oneOfGetter(i = ["yellowBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_blueBackgroundColor", { get: $util.oneOfGetter(i = ["blueBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_greenBackgroundColor", { get: $util.oneOfGetter(i = ["greenBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_violetBackgroundColor", { get: $util.oneOfGetter(i = ["violetBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_grayBackgroundColor", { get: $util.oneOfGetter(i = ["grayBackgroundColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_redTextColor", { get: $util.oneOfGetter(i = ["redTextColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_orangeTextColor", { get: $util.oneOfGetter(i = ["orangeTextColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_yellowTextColor", { get: $util.oneOfGetter(i = ["yellowTextColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_blueTextColor", { get: $util.oneOfGetter(i = ["blueTextColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_greenTextColor", { get: $util.oneOfGetter(i = ["greenTextColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_violetTextColor", { get: $util.oneOfGetter(i = ["violetTextColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_grayTextColor", { get: $util.oneOfGetter(i = ["grayTextColor"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_sidebar", { get: $util.oneOfGetter(i = ["sidebar"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_light", { get: $util.oneOfGetter(i = ["light"]), set: $util.oneOfSetter(i) }), Object.defineProperty(o.prototype, "_dark", { get: $util.oneOfGetter(i = ["dark"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    if (E || (E = $Writer.create()), g.primaryColor != null && Object.hasOwnProperty.call(g, "primaryColor") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.primaryColor), g.secondaryBackgroundColor != null && Object.hasOwnProperty.call(g, "secondaryBackgroundColor") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.secondaryBackgroundColor), g.backgroundColor != null && Object.hasOwnProperty.call(g, "backgroundColor") && E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.backgroundColor), g.textColor != null && Object.hasOwnProperty.call(g, "textColor") && E.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.textColor), g.font != null && Object.hasOwnProperty.call(g, "font") && E.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.font), g.base != null && Object.hasOwnProperty.call(g, "base") && E.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.base), g.widgetBackgroundColor != null && Object.hasOwnProperty.call(g, "widgetBackgroundColor") && E.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.widgetBackgroundColor), g.widgetBorderColor != null && Object.hasOwnProperty.call(g, "widgetBorderColor") && E.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.widgetBorderColor), g.radii != null && Object.hasOwnProperty.call(g, "radii") && $root.Radii.encode(g.radii, E.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.headingFont != null && Object.hasOwnProperty.call(g, "headingFont") && E.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.headingFont), g.bodyFont != null && Object.hasOwnProperty.call(g, "bodyFont") && E.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.bodyFont), g.codeFont != null && Object.hasOwnProperty.call(g, "codeFont") && E.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.codeFont), g.fontFaces != null && g.fontFaces.length) for (let e = 0; e < g.fontFaces.length; ++e) $root.FontFace.encode(g.fontFaces[e], E.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim();
    if (g.fontSizes != null && Object.hasOwnProperty.call(g, "fontSizes") && $root.FontSizes.encode(g.fontSizes, E.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.skeletonBackgroundColor != null && Object.hasOwnProperty.call(g, "skeletonBackgroundColor") && E.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(g.skeletonBackgroundColor), g.baseRadius != null && Object.hasOwnProperty.call(g, "baseRadius") && E.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.baseRadius), g.borderColor != null && Object.hasOwnProperty.call(g, "borderColor") && E.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(g.borderColor), g.showWidgetBorder != null && Object.hasOwnProperty.call(g, "showWidgetBorder") && E.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(g.showWidgetBorder), g.linkColor != null && Object.hasOwnProperty.call(g, "linkColor") && E.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(g.linkColor), g.baseFontSize != null && Object.hasOwnProperty.call(g, "baseFontSize") && E.uint32(
      /* id 22, wireType 0 =*/
      176
    ).int32(g.baseFontSize), g.showSidebarBorder != null && Object.hasOwnProperty.call(g, "showSidebarBorder") && E.uint32(
      /* id 23, wireType 0 =*/
      184
    ).bool(g.showSidebarBorder), g.sidebar != null && Object.hasOwnProperty.call(g, "sidebar") && $root.CustomThemeConfig.encode(g.sidebar, E.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), g.codeBackgroundColor != null && Object.hasOwnProperty.call(g, "codeBackgroundColor") && E.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(g.codeBackgroundColor), g.buttonRadius != null && Object.hasOwnProperty.call(g, "buttonRadius") && E.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(g.buttonRadius), g.dataframeBorderColor != null && Object.hasOwnProperty.call(g, "dataframeBorderColor") && E.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(g.dataframeBorderColor), g.codeFontSize != null && Object.hasOwnProperty.call(g, "codeFontSize") && E.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(g.codeFontSize), g.linkUnderline != null && Object.hasOwnProperty.call(g, "linkUnderline") && E.uint32(
      /* id 29, wireType 0 =*/
      232
    ).bool(g.linkUnderline), g.baseFontWeight != null && Object.hasOwnProperty.call(g, "baseFontWeight") && E.uint32(
      /* id 30, wireType 0 =*/
      240
    ).int32(g.baseFontWeight), g.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(g, "dataframeHeaderBackgroundColor") && E.uint32(
      /* id 31, wireType 2 =*/
      250
    ).string(g.dataframeHeaderBackgroundColor), g.codeFontWeight != null && Object.hasOwnProperty.call(g, "codeFontWeight") && E.uint32(
      /* id 32, wireType 0 =*/
      256
    ).int32(g.codeFontWeight), g.chartCategoricalColors != null && g.chartCategoricalColors.length) for (let e = 0; e < g.chartCategoricalColors.length; ++e) E.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(g.chartCategoricalColors[e]);
    if (g.headingFontWeights != null && g.headingFontWeights.length) {
      E.uint32(
        /* id 34, wireType 2 =*/
        274
      ).fork();
      for (let e = 0; e < g.headingFontWeights.length; ++e) E.int32(g.headingFontWeights[e]);
      E.ldelim();
    }
    if (g.headingFontSizes != null && g.headingFontSizes.length) for (let e = 0; e < g.headingFontSizes.length; ++e) E.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(g.headingFontSizes[e]);
    if (g.chartSequentialColors != null && g.chartSequentialColors.length) for (let e = 0; e < g.chartSequentialColors.length; ++e) E.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(g.chartSequentialColors[e]);
    if (g.fontSources != null && g.fontSources.length) for (let e = 0; e < g.fontSources.length; ++e) $root.FontSource.encode(g.fontSources[e], E.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim();
    if (g.redColor != null && Object.hasOwnProperty.call(g, "redColor") && E.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(g.redColor), g.orangeColor != null && Object.hasOwnProperty.call(g, "orangeColor") && E.uint32(
      /* id 39, wireType 2 =*/
      314
    ).string(g.orangeColor), g.yellowColor != null && Object.hasOwnProperty.call(g, "yellowColor") && E.uint32(
      /* id 40, wireType 2 =*/
      322
    ).string(g.yellowColor), g.blueColor != null && Object.hasOwnProperty.call(g, "blueColor") && E.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(g.blueColor), g.greenColor != null && Object.hasOwnProperty.call(g, "greenColor") && E.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(g.greenColor), g.violetColor != null && Object.hasOwnProperty.call(g, "violetColor") && E.uint32(
      /* id 43, wireType 2 =*/
      346
    ).string(g.violetColor), g.grayColor != null && Object.hasOwnProperty.call(g, "grayColor") && E.uint32(
      /* id 44, wireType 2 =*/
      354
    ).string(g.grayColor), g.redBackgroundColor != null && Object.hasOwnProperty.call(g, "redBackgroundColor") && E.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(g.redBackgroundColor), g.orangeBackgroundColor != null && Object.hasOwnProperty.call(g, "orangeBackgroundColor") && E.uint32(
      /* id 46, wireType 2 =*/
      370
    ).string(g.orangeBackgroundColor), g.yellowBackgroundColor != null && Object.hasOwnProperty.call(g, "yellowBackgroundColor") && E.uint32(
      /* id 47, wireType 2 =*/
      378
    ).string(g.yellowBackgroundColor), g.blueBackgroundColor != null && Object.hasOwnProperty.call(g, "blueBackgroundColor") && E.uint32(
      /* id 48, wireType 2 =*/
      386
    ).string(g.blueBackgroundColor), g.greenBackgroundColor != null && Object.hasOwnProperty.call(g, "greenBackgroundColor") && E.uint32(
      /* id 49, wireType 2 =*/
      394
    ).string(g.greenBackgroundColor), g.violetBackgroundColor != null && Object.hasOwnProperty.call(g, "violetBackgroundColor") && E.uint32(
      /* id 50, wireType 2 =*/
      402
    ).string(g.violetBackgroundColor), g.grayBackgroundColor != null && Object.hasOwnProperty.call(g, "grayBackgroundColor") && E.uint32(
      /* id 51, wireType 2 =*/
      410
    ).string(g.grayBackgroundColor), g.redTextColor != null && Object.hasOwnProperty.call(g, "redTextColor") && E.uint32(
      /* id 52, wireType 2 =*/
      418
    ).string(g.redTextColor), g.orangeTextColor != null && Object.hasOwnProperty.call(g, "orangeTextColor") && E.uint32(
      /* id 53, wireType 2 =*/
      426
    ).string(g.orangeTextColor), g.yellowTextColor != null && Object.hasOwnProperty.call(g, "yellowTextColor") && E.uint32(
      /* id 54, wireType 2 =*/
      434
    ).string(g.yellowTextColor), g.blueTextColor != null && Object.hasOwnProperty.call(g, "blueTextColor") && E.uint32(
      /* id 55, wireType 2 =*/
      442
    ).string(g.blueTextColor), g.greenTextColor != null && Object.hasOwnProperty.call(g, "greenTextColor") && E.uint32(
      /* id 56, wireType 2 =*/
      450
    ).string(g.greenTextColor), g.violetTextColor != null && Object.hasOwnProperty.call(g, "violetTextColor") && E.uint32(
      /* id 57, wireType 2 =*/
      458
    ).string(g.violetTextColor), g.grayTextColor != null && Object.hasOwnProperty.call(g, "grayTextColor") && E.uint32(
      /* id 58, wireType 2 =*/
      466
    ).string(g.grayTextColor), g.codeTextColor != null && Object.hasOwnProperty.call(g, "codeTextColor") && E.uint32(
      /* id 59, wireType 2 =*/
      474
    ).string(g.codeTextColor), g.light != null && Object.hasOwnProperty.call(g, "light") && $root.CustomThemeConfig.encode(g.light, E.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), g.dark != null && Object.hasOwnProperty.call(g, "dark") && $root.CustomThemeConfig.encode(g.dark, E.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), g.chartDivergingColors != null && g.chartDivergingColors.length) for (let e = 0; e < g.chartDivergingColors.length; ++e) E.uint32(
      /* id 62, wireType 2 =*/
      498
    ).string(g.chartDivergingColors[e]);
    return E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.CustomThemeConfig();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.primaryColor = g.string();
          break;
        }
        case 2: {
          n.secondaryBackgroundColor = g.string();
          break;
        }
        case 3: {
          n.backgroundColor = g.string();
          break;
        }
        case 4: {
          n.textColor = g.string();
          break;
        }
        case 5: {
          n.font = g.int32();
          break;
        }
        case 6: {
          n.base = g.int32();
          break;
        }
        case 7: {
          n.widgetBackgroundColor = g.string();
          break;
        }
        case 8: {
          n.widgetBorderColor = g.string();
          break;
        }
        case 9: {
          n.radii = $root.Radii.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.headingFont = g.string();
          break;
        }
        case 13: {
          n.bodyFont = g.string();
          break;
        }
        case 14: {
          n.codeFont = g.string();
          break;
        }
        case 15: {
          n.fontFaces && n.fontFaces.length || (n.fontFaces = []), n.fontFaces.push($root.FontFace.decode(g, g.uint32()));
          break;
        }
        case 37: {
          n.fontSources && n.fontSources.length || (n.fontSources = []), n.fontSources.push($root.FontSource.decode(g, g.uint32()));
          break;
        }
        case 16: {
          n.fontSizes = $root.FontSizes.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.skeletonBackgroundColor = g.string();
          break;
        }
        case 18: {
          n.baseRadius = g.string();
          break;
        }
        case 26: {
          n.buttonRadius = g.string();
          break;
        }
        case 19: {
          n.borderColor = g.string();
          break;
        }
        case 27: {
          n.dataframeBorderColor = g.string();
          break;
        }
        case 20: {
          n.showWidgetBorder = g.bool();
          break;
        }
        case 21: {
          n.linkColor = g.string();
          break;
        }
        case 29: {
          n.linkUnderline = g.bool();
          break;
        }
        case 22: {
          n.baseFontSize = g.int32();
          break;
        }
        case 30: {
          n.baseFontWeight = g.int32();
          break;
        }
        case 32: {
          n.codeFontWeight = g.int32();
          break;
        }
        case 28: {
          n.codeFontSize = g.string();
          break;
        }
        case 35: {
          n.headingFontSizes && n.headingFontSizes.length || (n.headingFontSizes = []), n.headingFontSizes.push(g.string());
          break;
        }
        case 34: {
          if (n.headingFontWeights && n.headingFontWeights.length || (n.headingFontWeights = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.headingFontWeights.push(g.int32());
          } else n.headingFontWeights.push(g.int32());
          break;
        }
        case 23: {
          n.showSidebarBorder = g.bool();
          break;
        }
        case 59: {
          n.codeTextColor = g.string();
          break;
        }
        case 25: {
          n.codeBackgroundColor = g.string();
          break;
        }
        case 31: {
          n.dataframeHeaderBackgroundColor = g.string();
          break;
        }
        case 33: {
          n.chartCategoricalColors && n.chartCategoricalColors.length || (n.chartCategoricalColors = []), n.chartCategoricalColors.push(g.string());
          break;
        }
        case 36: {
          n.chartSequentialColors && n.chartSequentialColors.length || (n.chartSequentialColors = []), n.chartSequentialColors.push(g.string());
          break;
        }
        case 62: {
          n.chartDivergingColors && n.chartDivergingColors.length || (n.chartDivergingColors = []), n.chartDivergingColors.push(g.string());
          break;
        }
        case 38: {
          n.redColor = g.string();
          break;
        }
        case 39: {
          n.orangeColor = g.string();
          break;
        }
        case 40: {
          n.yellowColor = g.string();
          break;
        }
        case 41: {
          n.blueColor = g.string();
          break;
        }
        case 42: {
          n.greenColor = g.string();
          break;
        }
        case 43: {
          n.violetColor = g.string();
          break;
        }
        case 44: {
          n.grayColor = g.string();
          break;
        }
        case 45: {
          n.redBackgroundColor = g.string();
          break;
        }
        case 46: {
          n.orangeBackgroundColor = g.string();
          break;
        }
        case 47: {
          n.yellowBackgroundColor = g.string();
          break;
        }
        case 48: {
          n.blueBackgroundColor = g.string();
          break;
        }
        case 49: {
          n.greenBackgroundColor = g.string();
          break;
        }
        case 50: {
          n.violetBackgroundColor = g.string();
          break;
        }
        case 51: {
          n.grayBackgroundColor = g.string();
          break;
        }
        case 52: {
          n.redTextColor = g.string();
          break;
        }
        case 53: {
          n.orangeTextColor = g.string();
          break;
        }
        case 54: {
          n.yellowTextColor = g.string();
          break;
        }
        case 55: {
          n.blueTextColor = g.string();
          break;
        }
        case 56: {
          n.greenTextColor = g.string();
          break;
        }
        case 57: {
          n.violetTextColor = g.string();
          break;
        }
        case 58: {
          n.grayTextColor = g.string();
          break;
        }
        case 24: {
          n.sidebar = $root.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        case 60: {
          n.light = $root.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        case 61: {
          n.dark = $root.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.CustomThemeConfig) return g;
    let E = new $root.CustomThemeConfig();
    switch (g.primaryColor != null && (E.primaryColor = String(g.primaryColor)), g.secondaryBackgroundColor != null && (E.secondaryBackgroundColor = String(g.secondaryBackgroundColor)), g.backgroundColor != null && (E.backgroundColor = String(g.backgroundColor)), g.textColor != null && (E.textColor = String(g.textColor)), g.font) {
      default:
        if (typeof g.font == "number") {
          E.font = g.font;
          break;
        }
        break;
      case "SANS_SERIF":
      case 0:
        E.font = 0;
        break;
      case "SERIF":
      case 1:
        E.font = 1;
        break;
      case "MONOSPACE":
      case 2:
        E.font = 2;
        break;
    }
    switch (g.base) {
      default:
        if (typeof g.base == "number") {
          E.base = g.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        E.base = 0;
        break;
      case "DARK":
      case 1:
        E.base = 1;
        break;
    }
    if (g.widgetBackgroundColor != null && (E.widgetBackgroundColor = String(g.widgetBackgroundColor)), g.widgetBorderColor != null && (E.widgetBorderColor = String(g.widgetBorderColor)), g.radii != null) {
      if (typeof g.radii != "object") throw TypeError(".CustomThemeConfig.radii: object expected");
      E.radii = $root.Radii.fromObject(g.radii);
    }
    if (g.headingFont != null && (E.headingFont = String(g.headingFont)), g.bodyFont != null && (E.bodyFont = String(g.bodyFont)), g.codeFont != null && (E.codeFont = String(g.codeFont)), g.fontFaces) {
      if (!Array.isArray(g.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      E.fontFaces = [];
      for (let e = 0; e < g.fontFaces.length; ++e) {
        if (typeof g.fontFaces[e] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        E.fontFaces[e] = $root.FontFace.fromObject(g.fontFaces[e]);
      }
    }
    if (g.fontSources) {
      if (!Array.isArray(g.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
      E.fontSources = [];
      for (let e = 0; e < g.fontSources.length; ++e) {
        if (typeof g.fontSources[e] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
        E.fontSources[e] = $root.FontSource.fromObject(g.fontSources[e]);
      }
    }
    if (g.fontSizes != null) {
      if (typeof g.fontSizes != "object") throw TypeError(".CustomThemeConfig.fontSizes: object expected");
      E.fontSizes = $root.FontSizes.fromObject(g.fontSizes);
    }
    if (g.skeletonBackgroundColor != null && (E.skeletonBackgroundColor = String(g.skeletonBackgroundColor)), g.baseRadius != null && (E.baseRadius = String(g.baseRadius)), g.buttonRadius != null && (E.buttonRadius = String(g.buttonRadius)), g.borderColor != null && (E.borderColor = String(g.borderColor)), g.dataframeBorderColor != null && (E.dataframeBorderColor = String(g.dataframeBorderColor)), g.showWidgetBorder != null && (E.showWidgetBorder = !!g.showWidgetBorder), g.linkColor != null && (E.linkColor = String(g.linkColor)), g.linkUnderline != null && (E.linkUnderline = !!g.linkUnderline), g.baseFontSize != null && (E.baseFontSize = g.baseFontSize | 0), g.baseFontWeight != null && (E.baseFontWeight = g.baseFontWeight | 0), g.codeFontWeight != null && (E.codeFontWeight = g.codeFontWeight | 0), g.codeFontSize != null && (E.codeFontSize = String(g.codeFontSize)), g.headingFontSizes) {
      if (!Array.isArray(g.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      E.headingFontSizes = [];
      for (let e = 0; e < g.headingFontSizes.length; ++e) E.headingFontSizes[e] = String(g.headingFontSizes[e]);
    }
    if (g.headingFontWeights) {
      if (!Array.isArray(g.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      E.headingFontWeights = [];
      for (let e = 0; e < g.headingFontWeights.length; ++e) E.headingFontWeights[e] = g.headingFontWeights[e] | 0;
    }
    if (g.showSidebarBorder != null && (E.showSidebarBorder = !!g.showSidebarBorder), g.codeTextColor != null && (E.codeTextColor = String(g.codeTextColor)), g.codeBackgroundColor != null && (E.codeBackgroundColor = String(g.codeBackgroundColor)), g.dataframeHeaderBackgroundColor != null && (E.dataframeHeaderBackgroundColor = String(g.dataframeHeaderBackgroundColor)), g.chartCategoricalColors) {
      if (!Array.isArray(g.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      E.chartCategoricalColors = [];
      for (let e = 0; e < g.chartCategoricalColors.length; ++e) E.chartCategoricalColors[e] = String(g.chartCategoricalColors[e]);
    }
    if (g.chartSequentialColors) {
      if (!Array.isArray(g.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      E.chartSequentialColors = [];
      for (let e = 0; e < g.chartSequentialColors.length; ++e) E.chartSequentialColors[e] = String(g.chartSequentialColors[e]);
    }
    if (g.chartDivergingColors) {
      if (!Array.isArray(g.chartDivergingColors)) throw TypeError(".CustomThemeConfig.chartDivergingColors: array expected");
      E.chartDivergingColors = [];
      for (let e = 0; e < g.chartDivergingColors.length; ++e) E.chartDivergingColors[e] = String(g.chartDivergingColors[e]);
    }
    if (g.redColor != null && (E.redColor = String(g.redColor)), g.orangeColor != null && (E.orangeColor = String(g.orangeColor)), g.yellowColor != null && (E.yellowColor = String(g.yellowColor)), g.blueColor != null && (E.blueColor = String(g.blueColor)), g.greenColor != null && (E.greenColor = String(g.greenColor)), g.violetColor != null && (E.violetColor = String(g.violetColor)), g.grayColor != null && (E.grayColor = String(g.grayColor)), g.redBackgroundColor != null && (E.redBackgroundColor = String(g.redBackgroundColor)), g.orangeBackgroundColor != null && (E.orangeBackgroundColor = String(g.orangeBackgroundColor)), g.yellowBackgroundColor != null && (E.yellowBackgroundColor = String(g.yellowBackgroundColor)), g.blueBackgroundColor != null && (E.blueBackgroundColor = String(g.blueBackgroundColor)), g.greenBackgroundColor != null && (E.greenBackgroundColor = String(g.greenBackgroundColor)), g.violetBackgroundColor != null && (E.violetBackgroundColor = String(g.violetBackgroundColor)), g.grayBackgroundColor != null && (E.grayBackgroundColor = String(g.grayBackgroundColor)), g.redTextColor != null && (E.redTextColor = String(g.redTextColor)), g.orangeTextColor != null && (E.orangeTextColor = String(g.orangeTextColor)), g.yellowTextColor != null && (E.yellowTextColor = String(g.yellowTextColor)), g.blueTextColor != null && (E.blueTextColor = String(g.blueTextColor)), g.greenTextColor != null && (E.greenTextColor = String(g.greenTextColor)), g.violetTextColor != null && (E.violetTextColor = String(g.violetTextColor)), g.grayTextColor != null && (E.grayTextColor = String(g.grayTextColor)), g.sidebar != null) {
      if (typeof g.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
      E.sidebar = $root.CustomThemeConfig.fromObject(g.sidebar);
    }
    if (g.light != null) {
      if (typeof g.light != "object") throw TypeError(".CustomThemeConfig.light: object expected");
      E.light = $root.CustomThemeConfig.fromObject(g.light);
    }
    if (g.dark != null) {
      if (typeof g.dark != "object") throw TypeError(".CustomThemeConfig.dark: object expected");
      E.dark = $root.CustomThemeConfig.fromObject(g.dark);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    if ((E.arrays || E.defaults) && (e.fontFaces = [], e.chartCategoricalColors = [], e.headingFontWeights = [], e.headingFontSizes = [], e.chartSequentialColors = [], e.fontSources = [], e.chartDivergingColors = []), E.defaults && (e.primaryColor = "", e.secondaryBackgroundColor = "", e.backgroundColor = "", e.textColor = "", e.font = E.enums === String ? "SANS_SERIF" : 0, e.base = E.enums === String ? "LIGHT" : 0, e.widgetBackgroundColor = "", e.widgetBorderColor = "", e.radii = null, e.headingFont = "", e.bodyFont = "", e.codeFont = "", e.fontSizes = null, e.skeletonBackgroundColor = ""), g.primaryColor != null && g.hasOwnProperty("primaryColor") && (e.primaryColor = g.primaryColor), g.secondaryBackgroundColor != null && g.hasOwnProperty("secondaryBackgroundColor") && (e.secondaryBackgroundColor = g.secondaryBackgroundColor), g.backgroundColor != null && g.hasOwnProperty("backgroundColor") && (e.backgroundColor = g.backgroundColor), g.textColor != null && g.hasOwnProperty("textColor") && (e.textColor = g.textColor), g.font != null && g.hasOwnProperty("font") && (e.font = E.enums === String ? $root.CustomThemeConfig.FontFamily[g.font] === void 0 ? g.font : $root.CustomThemeConfig.FontFamily[g.font] : g.font), g.base != null && g.hasOwnProperty("base") && (e.base = E.enums === String ? $root.CustomThemeConfig.BaseTheme[g.base] === void 0 ? g.base : $root.CustomThemeConfig.BaseTheme[g.base] : g.base), g.widgetBackgroundColor != null && g.hasOwnProperty("widgetBackgroundColor") && (e.widgetBackgroundColor = g.widgetBackgroundColor), g.widgetBorderColor != null && g.hasOwnProperty("widgetBorderColor") && (e.widgetBorderColor = g.widgetBorderColor), g.radii != null && g.hasOwnProperty("radii") && (e.radii = $root.Radii.toObject(g.radii, E)), g.headingFont != null && g.hasOwnProperty("headingFont") && (e.headingFont = g.headingFont), g.bodyFont != null && g.hasOwnProperty("bodyFont") && (e.bodyFont = g.bodyFont), g.codeFont != null && g.hasOwnProperty("codeFont") && (e.codeFont = g.codeFont), g.fontFaces && g.fontFaces.length) {
      e.fontFaces = [];
      for (let t = 0; t < g.fontFaces.length; ++t) e.fontFaces[t] = $root.FontFace.toObject(g.fontFaces[t], E);
    }
    if (g.fontSizes != null && g.hasOwnProperty("fontSizes") && (e.fontSizes = $root.FontSizes.toObject(g.fontSizes, E)), g.skeletonBackgroundColor != null && g.hasOwnProperty("skeletonBackgroundColor") && (e.skeletonBackgroundColor = g.skeletonBackgroundColor), g.baseRadius != null && g.hasOwnProperty("baseRadius") && (e.baseRadius = g.baseRadius, E.oneofs && (e._baseRadius = "baseRadius")), g.borderColor != null && g.hasOwnProperty("borderColor") && (e.borderColor = g.borderColor, E.oneofs && (e._borderColor = "borderColor")), g.showWidgetBorder != null && g.hasOwnProperty("showWidgetBorder") && (e.showWidgetBorder = g.showWidgetBorder, E.oneofs && (e._showWidgetBorder = "showWidgetBorder")), g.linkColor != null && g.hasOwnProperty("linkColor") && (e.linkColor = g.linkColor, E.oneofs && (e._linkColor = "linkColor")), g.baseFontSize != null && g.hasOwnProperty("baseFontSize") && (e.baseFontSize = g.baseFontSize, E.oneofs && (e._baseFontSize = "baseFontSize")), g.showSidebarBorder != null && g.hasOwnProperty("showSidebarBorder") && (e.showSidebarBorder = g.showSidebarBorder, E.oneofs && (e._showSidebarBorder = "showSidebarBorder")), g.sidebar != null && g.hasOwnProperty("sidebar") && (e.sidebar = $root.CustomThemeConfig.toObject(g.sidebar, E), E.oneofs && (e._sidebar = "sidebar")), g.codeBackgroundColor != null && g.hasOwnProperty("codeBackgroundColor") && (e.codeBackgroundColor = g.codeBackgroundColor, E.oneofs && (e._codeBackgroundColor = "codeBackgroundColor")), g.buttonRadius != null && g.hasOwnProperty("buttonRadius") && (e.buttonRadius = g.buttonRadius, E.oneofs && (e._buttonRadius = "buttonRadius")), g.dataframeBorderColor != null && g.hasOwnProperty("dataframeBorderColor") && (e.dataframeBorderColor = g.dataframeBorderColor, E.oneofs && (e._dataframeBorderColor = "dataframeBorderColor")), g.codeFontSize != null && g.hasOwnProperty("codeFontSize") && (e.codeFontSize = g.codeFontSize, E.oneofs && (e._codeFontSize = "codeFontSize")), g.linkUnderline != null && g.hasOwnProperty("linkUnderline") && (e.linkUnderline = g.linkUnderline, E.oneofs && (e._linkUnderline = "linkUnderline")), g.baseFontWeight != null && g.hasOwnProperty("baseFontWeight") && (e.baseFontWeight = g.baseFontWeight, E.oneofs && (e._baseFontWeight = "baseFontWeight")), g.dataframeHeaderBackgroundColor != null && g.hasOwnProperty("dataframeHeaderBackgroundColor") && (e.dataframeHeaderBackgroundColor = g.dataframeHeaderBackgroundColor, E.oneofs && (e._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), g.codeFontWeight != null && g.hasOwnProperty("codeFontWeight") && (e.codeFontWeight = g.codeFontWeight, E.oneofs && (e._codeFontWeight = "codeFontWeight")), g.chartCategoricalColors && g.chartCategoricalColors.length) {
      e.chartCategoricalColors = [];
      for (let t = 0; t < g.chartCategoricalColors.length; ++t) e.chartCategoricalColors[t] = g.chartCategoricalColors[t];
    }
    if (g.headingFontWeights && g.headingFontWeights.length) {
      e.headingFontWeights = [];
      for (let t = 0; t < g.headingFontWeights.length; ++t) e.headingFontWeights[t] = g.headingFontWeights[t];
    }
    if (g.headingFontSizes && g.headingFontSizes.length) {
      e.headingFontSizes = [];
      for (let t = 0; t < g.headingFontSizes.length; ++t) e.headingFontSizes[t] = g.headingFontSizes[t];
    }
    if (g.chartSequentialColors && g.chartSequentialColors.length) {
      e.chartSequentialColors = [];
      for (let t = 0; t < g.chartSequentialColors.length; ++t) e.chartSequentialColors[t] = g.chartSequentialColors[t];
    }
    if (g.fontSources && g.fontSources.length) {
      e.fontSources = [];
      for (let t = 0; t < g.fontSources.length; ++t) e.fontSources[t] = $root.FontSource.toObject(g.fontSources[t], E);
    }
    if (g.redColor != null && g.hasOwnProperty("redColor") && (e.redColor = g.redColor, E.oneofs && (e._redColor = "redColor")), g.orangeColor != null && g.hasOwnProperty("orangeColor") && (e.orangeColor = g.orangeColor, E.oneofs && (e._orangeColor = "orangeColor")), g.yellowColor != null && g.hasOwnProperty("yellowColor") && (e.yellowColor = g.yellowColor, E.oneofs && (e._yellowColor = "yellowColor")), g.blueColor != null && g.hasOwnProperty("blueColor") && (e.blueColor = g.blueColor, E.oneofs && (e._blueColor = "blueColor")), g.greenColor != null && g.hasOwnProperty("greenColor") && (e.greenColor = g.greenColor, E.oneofs && (e._greenColor = "greenColor")), g.violetColor != null && g.hasOwnProperty("violetColor") && (e.violetColor = g.violetColor, E.oneofs && (e._violetColor = "violetColor")), g.grayColor != null && g.hasOwnProperty("grayColor") && (e.grayColor = g.grayColor, E.oneofs && (e._grayColor = "grayColor")), g.redBackgroundColor != null && g.hasOwnProperty("redBackgroundColor") && (e.redBackgroundColor = g.redBackgroundColor, E.oneofs && (e._redBackgroundColor = "redBackgroundColor")), g.orangeBackgroundColor != null && g.hasOwnProperty("orangeBackgroundColor") && (e.orangeBackgroundColor = g.orangeBackgroundColor, E.oneofs && (e._orangeBackgroundColor = "orangeBackgroundColor")), g.yellowBackgroundColor != null && g.hasOwnProperty("yellowBackgroundColor") && (e.yellowBackgroundColor = g.yellowBackgroundColor, E.oneofs && (e._yellowBackgroundColor = "yellowBackgroundColor")), g.blueBackgroundColor != null && g.hasOwnProperty("blueBackgroundColor") && (e.blueBackgroundColor = g.blueBackgroundColor, E.oneofs && (e._blueBackgroundColor = "blueBackgroundColor")), g.greenBackgroundColor != null && g.hasOwnProperty("greenBackgroundColor") && (e.greenBackgroundColor = g.greenBackgroundColor, E.oneofs && (e._greenBackgroundColor = "greenBackgroundColor")), g.violetBackgroundColor != null && g.hasOwnProperty("violetBackgroundColor") && (e.violetBackgroundColor = g.violetBackgroundColor, E.oneofs && (e._violetBackgroundColor = "violetBackgroundColor")), g.grayBackgroundColor != null && g.hasOwnProperty("grayBackgroundColor") && (e.grayBackgroundColor = g.grayBackgroundColor, E.oneofs && (e._grayBackgroundColor = "grayBackgroundColor")), g.redTextColor != null && g.hasOwnProperty("redTextColor") && (e.redTextColor = g.redTextColor, E.oneofs && (e._redTextColor = "redTextColor")), g.orangeTextColor != null && g.hasOwnProperty("orangeTextColor") && (e.orangeTextColor = g.orangeTextColor, E.oneofs && (e._orangeTextColor = "orangeTextColor")), g.yellowTextColor != null && g.hasOwnProperty("yellowTextColor") && (e.yellowTextColor = g.yellowTextColor, E.oneofs && (e._yellowTextColor = "yellowTextColor")), g.blueTextColor != null && g.hasOwnProperty("blueTextColor") && (e.blueTextColor = g.blueTextColor, E.oneofs && (e._blueTextColor = "blueTextColor")), g.greenTextColor != null && g.hasOwnProperty("greenTextColor") && (e.greenTextColor = g.greenTextColor, E.oneofs && (e._greenTextColor = "greenTextColor")), g.violetTextColor != null && g.hasOwnProperty("violetTextColor") && (e.violetTextColor = g.violetTextColor, E.oneofs && (e._violetTextColor = "violetTextColor")), g.grayTextColor != null && g.hasOwnProperty("grayTextColor") && (e.grayTextColor = g.grayTextColor, E.oneofs && (e._grayTextColor = "grayTextColor")), g.codeTextColor != null && g.hasOwnProperty("codeTextColor") && (e.codeTextColor = g.codeTextColor, E.oneofs && (e._codeTextColor = "codeTextColor")), g.light != null && g.hasOwnProperty("light") && (e.light = $root.CustomThemeConfig.toObject(g.light, E), E.oneofs && (e._light = "light")), g.dark != null && g.hasOwnProperty("dark") && (e.dark = $root.CustomThemeConfig.toObject(g.dark, E), E.oneofs && (e._dark = "dark")), g.chartDivergingColors && g.chartDivergingColors.length) {
      e.chartDivergingColors = [];
      for (let t = 0; t < g.chartDivergingColors.length; ++t) e.chartDivergingColors[t] = g.chartDivergingColors[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CustomThemeConfig";
  }, o.BaseTheme = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "LIGHT"] = 0, E[g[1] = "DARK"] = 1, E;
  })(), o.FontFamily = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "SANS_SERIF"] = 0, E[g[1] = "SERIF"] = 1, E[g[2] = "MONOSPACE"] = 2, E;
  })(), o;
})();
$root.FontFace = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.url = "", o.prototype.family = "", o.prototype.weight = 0, o.prototype.weightRange = "", o.prototype.style = "", o.prototype.unicodeRange = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.url != null && Object.hasOwnProperty.call(i, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.url), i.family != null && Object.hasOwnProperty.call(i, "family") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.family), i.weight != null && Object.hasOwnProperty.call(i, "weight") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(i.weight), i.style != null && Object.hasOwnProperty.call(i, "style") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.style), i.weightRange != null && Object.hasOwnProperty.call(i, "weightRange") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.weightRange), i.unicodeRange != null && Object.hasOwnProperty.call(i, "unicodeRange") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.unicodeRange), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.FontFace();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.url = i.string();
          break;
        }
        case 2: {
          t.family = i.string();
          break;
        }
        case 3: {
          t.weight = i.int32();
          break;
        }
        case 5: {
          t.weightRange = i.string();
          break;
        }
        case 4: {
          t.style = i.string();
          break;
        }
        case 6: {
          t.unicodeRange = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.FontFace) return i;
    let g = new $root.FontFace();
    return i.url != null && (g.url = String(i.url)), i.family != null && (g.family = String(i.family)), i.weight != null && (g.weight = i.weight | 0), i.weightRange != null && (g.weightRange = String(i.weightRange)), i.style != null && (g.style = String(i.style)), i.unicodeRange != null && (g.unicodeRange = String(i.unicodeRange)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.url = "", E.family = "", E.weight = 0, E.style = "", E.weightRange = "", E.unicodeRange = ""), i.url != null && i.hasOwnProperty("url") && (E.url = i.url), i.family != null && i.hasOwnProperty("family") && (E.family = i.family), i.weight != null && i.hasOwnProperty("weight") && (E.weight = i.weight), i.style != null && i.hasOwnProperty("style") && (E.style = i.style), i.weightRange != null && i.hasOwnProperty("weightRange") && (E.weightRange = i.weightRange), i.unicodeRange != null && i.hasOwnProperty("unicodeRange") && (E.unicodeRange = i.unicodeRange), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/FontFace";
  }, o;
})();
$root.FontSource = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.configName = "", o.prototype.sourceUrl = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.configName != null && Object.hasOwnProperty.call(i, "configName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.configName), i.sourceUrl != null && Object.hasOwnProperty.call(i, "sourceUrl") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.sourceUrl), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.FontSource();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.configName = i.string();
          break;
        }
        case 2: {
          t.sourceUrl = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.FontSource) return i;
    let g = new $root.FontSource();
    return i.configName != null && (g.configName = String(i.configName)), i.sourceUrl != null && (g.sourceUrl = String(i.sourceUrl)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.configName = "", E.sourceUrl = ""), i.configName != null && i.hasOwnProperty("configName") && (E.configName = i.configName), i.sourceUrl != null && i.hasOwnProperty("sourceUrl") && (E.sourceUrl = i.sourceUrl), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/FontSource";
  }, o;
})();
$root.Radii = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.baseWidgetRadius = 0, o.prototype.checkboxRadius = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.baseWidgetRadius != null && Object.hasOwnProperty.call(i, "baseWidgetRadius") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(i.baseWidgetRadius), i.checkboxRadius != null && Object.hasOwnProperty.call(i, "checkboxRadius") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(i.checkboxRadius), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Radii();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.baseWidgetRadius = i.int32();
          break;
        }
        case 2: {
          t.checkboxRadius = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Radii) return i;
    let g = new $root.Radii();
    return i.baseWidgetRadius != null && (g.baseWidgetRadius = i.baseWidgetRadius | 0), i.checkboxRadius != null && (g.checkboxRadius = i.checkboxRadius | 0), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.baseWidgetRadius = 0, E.checkboxRadius = 0), i.baseWidgetRadius != null && i.hasOwnProperty("baseWidgetRadius") && (E.baseWidgetRadius = i.baseWidgetRadius), i.checkboxRadius != null && i.hasOwnProperty("checkboxRadius") && (E.checkboxRadius = i.checkboxRadius), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Radii";
  }, o;
})();
$root.FontSizes = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.tinyFontSize = 0, o.prototype.smallFontSize = 0, o.prototype.baseFontSize = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.tinyFontSize != null && Object.hasOwnProperty.call(i, "tinyFontSize") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(i.tinyFontSize), i.smallFontSize != null && Object.hasOwnProperty.call(i, "smallFontSize") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(i.smallFontSize), i.baseFontSize != null && Object.hasOwnProperty.call(i, "baseFontSize") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(i.baseFontSize), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.FontSizes();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.tinyFontSize = i.int32();
          break;
        }
        case 2: {
          t.smallFontSize = i.int32();
          break;
        }
        case 3: {
          t.baseFontSize = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.FontSizes) return i;
    let g = new $root.FontSizes();
    return i.tinyFontSize != null && (g.tinyFontSize = i.tinyFontSize | 0), i.smallFontSize != null && (g.smallFontSize = i.smallFontSize | 0), i.baseFontSize != null && (g.baseFontSize = i.baseFontSize | 0), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.tinyFontSize = 0, E.smallFontSize = 0, E.baseFontSize = 0), i.tinyFontSize != null && i.hasOwnProperty("tinyFontSize") && (E.tinyFontSize = i.tinyFontSize), i.smallFontSize != null && i.hasOwnProperty("smallFontSize") && (E.smallFontSize = i.smallFontSize), i.baseFontSize != null && i.hasOwnProperty("baseFontSize") && (E.baseFontSize = i.baseFontSize), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/FontSizes";
  }, o;
})();
$root.UserInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.installationId = "", o.prototype.installationIdV3 = "", o.prototype.installationIdV4 = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.installationId != null && Object.hasOwnProperty.call(i, "installationId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.installationId), i.installationIdV3 != null && Object.hasOwnProperty.call(i, "installationIdV3") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.installationIdV3), i.installationIdV4 != null && Object.hasOwnProperty.call(i, "installationIdV4") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.installationIdV4), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.UserInfo();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.installationId = i.string();
          break;
        }
        case 5: {
          t.installationIdV3 = i.string();
          break;
        }
        case 6: {
          t.installationIdV4 = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.UserInfo) return i;
    let g = new $root.UserInfo();
    return i.installationId != null && (g.installationId = String(i.installationId)), i.installationIdV3 != null && (g.installationIdV3 = String(i.installationIdV3)), i.installationIdV4 != null && (g.installationIdV4 = String(i.installationIdV4)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.installationId = "", E.installationIdV3 = "", E.installationIdV4 = ""), i.installationId != null && i.hasOwnProperty("installationId") && (E.installationId = i.installationId), i.installationIdV3 != null && i.hasOwnProperty("installationIdV3") && (E.installationIdV3 = i.installationIdV3), i.installationIdV4 != null && i.hasOwnProperty("installationIdV4") && (E.installationIdV4 = i.installationIdV4), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/UserInfo";
  }, o;
})();
$root.EnvironmentInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.streamlitVersion = "", o.prototype.pythonVersion = "", o.prototype.serverOs = "", o.prototype.hasDisplay = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.streamlitVersion != null && Object.hasOwnProperty.call(i, "streamlitVersion") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.streamlitVersion), i.pythonVersion != null && Object.hasOwnProperty.call(i, "pythonVersion") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.pythonVersion), i.serverOs != null && Object.hasOwnProperty.call(i, "serverOs") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.serverOs), i.hasDisplay != null && Object.hasOwnProperty.call(i, "hasDisplay") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(i.hasDisplay), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.EnvironmentInfo();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.streamlitVersion = i.string();
          break;
        }
        case 2: {
          t.pythonVersion = i.string();
          break;
        }
        case 3: {
          t.serverOs = i.string();
          break;
        }
        case 4: {
          t.hasDisplay = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.EnvironmentInfo) return i;
    let g = new $root.EnvironmentInfo();
    return i.streamlitVersion != null && (g.streamlitVersion = String(i.streamlitVersion)), i.pythonVersion != null && (g.pythonVersion = String(i.pythonVersion)), i.serverOs != null && (g.serverOs = String(i.serverOs)), i.hasDisplay != null && (g.hasDisplay = !!i.hasDisplay), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.streamlitVersion = "", E.pythonVersion = "", E.serverOs = "", E.hasDisplay = !1), i.streamlitVersion != null && i.hasOwnProperty("streamlitVersion") && (E.streamlitVersion = i.streamlitVersion), i.pythonVersion != null && i.hasOwnProperty("pythonVersion") && (E.pythonVersion = i.pythonVersion), i.serverOs != null && i.hasOwnProperty("serverOs") && (E.serverOs = i.serverOs), i.hasDisplay != null && i.hasOwnProperty("hasDisplay") && (E.hasDisplay = i.hasDisplay), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/EnvironmentInfo";
  }, o;
})();
$root.SessionStatus = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.runOnSave = !1, o.prototype.scriptIsRunning = !1, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.runOnSave != null && Object.hasOwnProperty.call(i, "runOnSave") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(i.runOnSave), i.scriptIsRunning != null && Object.hasOwnProperty.call(i, "scriptIsRunning") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(i.scriptIsRunning), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.SessionStatus();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.runOnSave = i.bool();
          break;
        }
        case 2: {
          t.scriptIsRunning = i.bool();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.SessionStatus) return i;
    let g = new $root.SessionStatus();
    return i.runOnSave != null && (g.runOnSave = !!i.runOnSave), i.scriptIsRunning != null && (g.scriptIsRunning = !!i.scriptIsRunning), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.runOnSave = !1, E.scriptIsRunning = !1), i.runOnSave != null && i.hasOwnProperty("runOnSave") && (E.runOnSave = i.runOnSave), i.scriptIsRunning != null && i.hasOwnProperty("scriptIsRunning") && (E.scriptIsRunning = i.scriptIsRunning), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/SessionStatus";
  }, o;
})();
$root.PageConfig = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.title = "", o.prototype.favicon = "", o.prototype.layout = 0, o.prototype.initialSidebarState = 0, o.prototype.menuItems = null, o.prototype.initialSidebarWidth = null;
  let i;
  return Object.defineProperty(o.prototype, "_initialSidebarWidth", { get: $util.oneOfGetter(i = ["initialSidebarWidth"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.title != null && Object.hasOwnProperty.call(g, "title") && E.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.title), g.favicon != null && Object.hasOwnProperty.call(g, "favicon") && E.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.favicon), g.layout != null && Object.hasOwnProperty.call(g, "layout") && E.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.layout), g.initialSidebarState != null && Object.hasOwnProperty.call(g, "initialSidebarState") && E.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.initialSidebarState), g.menuItems != null && Object.hasOwnProperty.call(g, "menuItems") && $root.PageConfig.MenuItems.encode(g.menuItems, E.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.initialSidebarWidth != null && Object.hasOwnProperty.call(g, "initialSidebarWidth") && $root.PageConfig.SidebarWidthConfig.encode(g.initialSidebarWidth, E.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.PageConfig();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.title = g.string();
          break;
        }
        case 2: {
          n.favicon = g.string();
          break;
        }
        case 3: {
          n.layout = g.int32();
          break;
        }
        case 4: {
          n.initialSidebarState = g.int32();
          break;
        }
        case 5: {
          n.menuItems = $root.PageConfig.MenuItems.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.PageConfig) return g;
    let E = new $root.PageConfig();
    switch (g.title != null && (E.title = String(g.title)), g.favicon != null && (E.favicon = String(g.favicon)), g.layout) {
      default:
        if (typeof g.layout == "number") {
          E.layout = g.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        E.layout = 0;
        break;
      case "WIDE":
      case 1:
        E.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        E.layout = 2;
        break;
    }
    switch (g.initialSidebarState) {
      default:
        if (typeof g.initialSidebarState == "number") {
          E.initialSidebarState = g.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        E.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        E.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        E.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        E.initialSidebarState = 3;
        break;
    }
    if (g.menuItems != null) {
      if (typeof g.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
      E.menuItems = $root.PageConfig.MenuItems.fromObject(g.menuItems);
    }
    if (g.initialSidebarWidth != null) {
      if (typeof g.initialSidebarWidth != "object") throw TypeError(".PageConfig.initialSidebarWidth: object expected");
      E.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.fromObject(g.initialSidebarWidth);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return E.defaults && (e.title = "", e.favicon = "", e.layout = E.enums === String ? "CENTERED" : 0, e.initialSidebarState = E.enums === String ? "AUTO" : 0, e.menuItems = null), g.title != null && g.hasOwnProperty("title") && (e.title = g.title), g.favicon != null && g.hasOwnProperty("favicon") && (e.favicon = g.favicon), g.layout != null && g.hasOwnProperty("layout") && (e.layout = E.enums === String ? $root.PageConfig.Layout[g.layout] === void 0 ? g.layout : $root.PageConfig.Layout[g.layout] : g.layout), g.initialSidebarState != null && g.hasOwnProperty("initialSidebarState") && (e.initialSidebarState = E.enums === String ? $root.PageConfig.SidebarState[g.initialSidebarState] === void 0 ? g.initialSidebarState : $root.PageConfig.SidebarState[g.initialSidebarState] : g.initialSidebarState), g.menuItems != null && g.hasOwnProperty("menuItems") && (e.menuItems = $root.PageConfig.MenuItems.toObject(g.menuItems, E)), g.initialSidebarWidth != null && g.hasOwnProperty("initialSidebarWidth") && (e.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.toObject(g.initialSidebarWidth, E), E.oneofs && (e._initialSidebarWidth = "initialSidebarWidth")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageConfig";
  }, o.MenuItems = (function() {
    function g(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    return g.prototype.getHelpUrl = "", g.prototype.hideGetHelp = !1, g.prototype.reportABugUrl = "", g.prototype.hideReportABug = !1, g.prototype.aboutSectionMd = "", g.prototype.clearAboutMd = !1, g.create = function(E) {
      return new g(E);
    }, g.encode = function(E, e) {
      return e || (e = $Writer.create()), E.getHelpUrl != null && Object.hasOwnProperty.call(E, "getHelpUrl") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(E.getHelpUrl), E.hideGetHelp != null && Object.hasOwnProperty.call(E, "hideGetHelp") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(E.hideGetHelp), E.reportABugUrl != null && Object.hasOwnProperty.call(E, "reportABugUrl") && e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(E.reportABugUrl), E.hideReportABug != null && Object.hasOwnProperty.call(E, "hideReportABug") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(E.hideReportABug), E.aboutSectionMd != null && Object.hasOwnProperty.call(E, "aboutSectionMd") && e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(E.aboutSectionMd), E.clearAboutMd != null && Object.hasOwnProperty.call(E, "clearAboutMd") && e.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(E.clearAboutMd), e;
    }, g.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.PageConfig.MenuItems();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.getHelpUrl = E.string();
            break;
          }
          case 2: {
            h.hideGetHelp = E.bool();
            break;
          }
          case 3: {
            h.reportABugUrl = E.string();
            break;
          }
          case 4: {
            h.hideReportABug = E.bool();
            break;
          }
          case 5: {
            h.aboutSectionMd = E.string();
            break;
          }
          case 6: {
            h.clearAboutMd = E.bool();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, g.fromObject = function(E) {
      if (E instanceof $root.PageConfig.MenuItems) return E;
      let e = new $root.PageConfig.MenuItems();
      return E.getHelpUrl != null && (e.getHelpUrl = String(E.getHelpUrl)), E.hideGetHelp != null && (e.hideGetHelp = !!E.hideGetHelp), E.reportABugUrl != null && (e.reportABugUrl = String(E.reportABugUrl)), E.hideReportABug != null && (e.hideReportABug = !!E.hideReportABug), E.aboutSectionMd != null && (e.aboutSectionMd = String(E.aboutSectionMd)), E.clearAboutMd != null && (e.clearAboutMd = !!E.clearAboutMd), e;
    }, g.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.getHelpUrl = "", t.hideGetHelp = !1, t.reportABugUrl = "", t.hideReportABug = !1, t.aboutSectionMd = "", t.clearAboutMd = !1), E.getHelpUrl != null && E.hasOwnProperty("getHelpUrl") && (t.getHelpUrl = E.getHelpUrl), E.hideGetHelp != null && E.hasOwnProperty("hideGetHelp") && (t.hideGetHelp = E.hideGetHelp), E.reportABugUrl != null && E.hasOwnProperty("reportABugUrl") && (t.reportABugUrl = E.reportABugUrl), E.hideReportABug != null && E.hasOwnProperty("hideReportABug") && (t.hideReportABug = E.hideReportABug), E.aboutSectionMd != null && E.hasOwnProperty("aboutSectionMd") && (t.aboutSectionMd = E.aboutSectionMd), E.clearAboutMd != null && E.hasOwnProperty("clearAboutMd") && (t.clearAboutMd = E.clearAboutMd), t;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/PageConfig.MenuItems";
    }, g;
  })(), o.Layout = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "CENTERED"] = 0, E[g[1] = "WIDE"] = 1, E[g[2] = "LAYOUT_UNSET"] = 2, E;
  })(), o.SidebarState = (function() {
    const g = {}, E = Object.create(g);
    return E[g[0] = "AUTO"] = 0, E[g[1] = "EXPANDED"] = 1, E[g[2] = "COLLAPSED"] = 2, E[g[3] = "SIDEBAR_UNSET"] = 3, E;
  })(), o.SidebarWidthConfig = (function() {
    function g(e) {
      if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
    }
    g.prototype.pixelWidth = null;
    let E;
    return Object.defineProperty(g.prototype, "widthSpec", { get: $util.oneOfGetter(E = ["pixelWidth"]), set: $util.oneOfSetter(E) }), g.create = function(e) {
      return new g(e);
    }, g.encode = function(e, t) {
      return t || (t = $Writer.create()), e.pixelWidth != null && Object.hasOwnProperty.call(e, "pixelWidth") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(e.pixelWidth), t;
    }, g.decode = function(e, t, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = t === void 0 ? e.len : e.pos + t, d = new $root.PageConfig.SidebarWidthConfig();
      for (; e.pos < h; ) {
        let k = e.uint32();
        if (k === n) break;
        k >>> 3 === 1 ? d.pixelWidth = e.uint32() : e.skipType(k & 7);
      }
      return d;
    }, g.fromObject = function(e) {
      if (e instanceof $root.PageConfig.SidebarWidthConfig) return e;
      let t = new $root.PageConfig.SidebarWidthConfig();
      return e.pixelWidth != null && (t.pixelWidth = e.pixelWidth >>> 0), t;
    }, g.toObject = function(e, t) {
      t || (t = {});
      let n = {};
      return e.pixelWidth != null && e.hasOwnProperty("pixelWidth") && (n.pixelWidth = e.pixelWidth, t.oneofs && (n.widthSpec = "pixelWidth")), n;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/PageConfig.SidebarWidthConfig";
    }, g;
  })(), o;
})();
$root.PageInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.queryString = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.queryString != null && Object.hasOwnProperty.call(i, "queryString") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.queryString), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.PageInfo();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.queryString = i.string() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.PageInfo) return i;
    let g = new $root.PageInfo();
    return i.queryString != null && (g.queryString = String(i.queryString)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.queryString = ""), i.queryString != null && i.hasOwnProperty("queryString") && (E.queryString = i.queryString), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/PageInfo";
  }, o;
})();
$root.PageProfile = (() => {
  function o(i) {
    if (this.commands = [], this.config = [], this.attributions = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.commands = $util.emptyArray, o.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.config = $util.emptyArray, o.prototype.uncaughtException = "", o.prototype.attributions = $util.emptyArray, o.prototype.os = "", o.prototype.timezone = "", o.prototype.headless = !1, o.prototype.isFragmentRun = !1, o.prototype.serverMode = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.commands != null && i.commands.length) for (let E = 0; E < i.commands.length; ++E) $root.Command.encode(i.commands[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (i.execTime != null && Object.hasOwnProperty.call(i, "execTime") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(i.execTime), i.prepTime != null && Object.hasOwnProperty.call(i, "prepTime") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int64(i.prepTime), i.config != null && i.config.length) for (let E = 0; E < i.config.length; ++E) g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(i.config[E]);
    if (i.uncaughtException != null && Object.hasOwnProperty.call(i, "uncaughtException") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.uncaughtException), i.attributions != null && i.attributions.length) for (let E = 0; E < i.attributions.length; ++E) g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.attributions[E]);
    return i.os != null && Object.hasOwnProperty.call(i, "os") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(i.os), i.timezone != null && Object.hasOwnProperty.call(i, "timezone") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(i.timezone), i.headless != null && Object.hasOwnProperty.call(i, "headless") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(i.headless), i.isFragmentRun != null && Object.hasOwnProperty.call(i, "isFragmentRun") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(i.isFragmentRun), i.serverMode != null && Object.hasOwnProperty.call(i, "serverMode") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(i.serverMode), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.PageProfile();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.commands && t.commands.length || (t.commands = []), t.commands.push($root.Command.decode(i, i.uint32()));
          break;
        }
        case 2: {
          t.execTime = i.int64();
          break;
        }
        case 3: {
          t.prepTime = i.int64();
          break;
        }
        case 5: {
          t.config && t.config.length || (t.config = []), t.config.push(i.string());
          break;
        }
        case 6: {
          t.uncaughtException = i.string();
          break;
        }
        case 7: {
          t.attributions && t.attributions.length || (t.attributions = []), t.attributions.push(i.string());
          break;
        }
        case 8: {
          t.os = i.string();
          break;
        }
        case 9: {
          t.timezone = i.string();
          break;
        }
        case 10: {
          t.headless = i.bool();
          break;
        }
        case 11: {
          t.isFragmentRun = i.bool();
          break;
        }
        case 12: {
          t.serverMode = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.PageProfile) return i;
    let g = new $root.PageProfile();
    if (i.commands) {
      if (!Array.isArray(i.commands)) throw TypeError(".PageProfile.commands: array expected");
      g.commands = [];
      for (let E = 0; E < i.commands.length; ++E) {
        if (typeof i.commands[E] != "object") throw TypeError(".PageProfile.commands: object expected");
        g.commands[E] = $root.Command.fromObject(i.commands[E]);
      }
    }
    if (i.execTime != null && ($util.Long ? (g.execTime = $util.Long.fromValue(i.execTime)).unsigned = !1 : typeof i.execTime == "string" ? g.execTime = parseInt(i.execTime, 10) : typeof i.execTime == "number" ? g.execTime = i.execTime : typeof i.execTime == "object" && (g.execTime = new $util.LongBits(i.execTime.low >>> 0, i.execTime.high >>> 0).toNumber())), i.prepTime != null && ($util.Long ? (g.prepTime = $util.Long.fromValue(i.prepTime)).unsigned = !1 : typeof i.prepTime == "string" ? g.prepTime = parseInt(i.prepTime, 10) : typeof i.prepTime == "number" ? g.prepTime = i.prepTime : typeof i.prepTime == "object" && (g.prepTime = new $util.LongBits(i.prepTime.low >>> 0, i.prepTime.high >>> 0).toNumber())), i.config) {
      if (!Array.isArray(i.config)) throw TypeError(".PageProfile.config: array expected");
      g.config = [];
      for (let E = 0; E < i.config.length; ++E) g.config[E] = String(i.config[E]);
    }
    if (i.uncaughtException != null && (g.uncaughtException = String(i.uncaughtException)), i.attributions) {
      if (!Array.isArray(i.attributions)) throw TypeError(".PageProfile.attributions: array expected");
      g.attributions = [];
      for (let E = 0; E < i.attributions.length; ++E) g.attributions[E] = String(i.attributions[E]);
    }
    return i.os != null && (g.os = String(i.os)), i.timezone != null && (g.timezone = String(i.timezone)), i.headless != null && (g.headless = !!i.headless), i.isFragmentRun != null && (g.isFragmentRun = !!i.isFragmentRun), i.serverMode != null && (g.serverMode = String(i.serverMode)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.commands = [], E.config = [], E.attributions = []), g.defaults) {
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.execTime = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.execTime = g.longs === String ? "0" : 0;
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.prepTime = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.prepTime = g.longs === String ? "0" : 0;
      E.uncaughtException = "", E.os = "", E.timezone = "", E.headless = !1, E.isFragmentRun = !1, E.serverMode = "";
    }
    if (i.commands && i.commands.length) {
      E.commands = [];
      for (let e = 0; e < i.commands.length; ++e) E.commands[e] = $root.Command.toObject(i.commands[e], g);
    }
    if (i.execTime != null && i.hasOwnProperty("execTime") && (typeof i.execTime == "number" ? E.execTime = g.longs === String ? String(i.execTime) : i.execTime : E.execTime = g.longs === String ? $util.Long.prototype.toString.call(i.execTime) : g.longs === Number ? new $util.LongBits(i.execTime.low >>> 0, i.execTime.high >>> 0).toNumber() : i.execTime), i.prepTime != null && i.hasOwnProperty("prepTime") && (typeof i.prepTime == "number" ? E.prepTime = g.longs === String ? String(i.prepTime) : i.prepTime : E.prepTime = g.longs === String ? $util.Long.prototype.toString.call(i.prepTime) : g.longs === Number ? new $util.LongBits(i.prepTime.low >>> 0, i.prepTime.high >>> 0).toNumber() : i.prepTime), i.config && i.config.length) {
      E.config = [];
      for (let e = 0; e < i.config.length; ++e) E.config[e] = i.config[e];
    }
    if (i.uncaughtException != null && i.hasOwnProperty("uncaughtException") && (E.uncaughtException = i.uncaughtException), i.attributions && i.attributions.length) {
      E.attributions = [];
      for (let e = 0; e < i.attributions.length; ++e) E.attributions[e] = i.attributions[e];
    }
    return i.os != null && i.hasOwnProperty("os") && (E.os = i.os), i.timezone != null && i.hasOwnProperty("timezone") && (E.timezone = i.timezone), i.headless != null && i.hasOwnProperty("headless") && (E.headless = i.headless), i.isFragmentRun != null && i.hasOwnProperty("isFragmentRun") && (E.isFragmentRun = i.isFragmentRun), i.serverMode != null && i.hasOwnProperty("serverMode") && (E.serverMode = i.serverMode), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/PageProfile";
  }, o;
})();
$root.Argument = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.k = "", o.prototype.t = "", o.prototype.m = "", o.prototype.p = 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.k != null && Object.hasOwnProperty.call(i, "k") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.k), i.t != null && Object.hasOwnProperty.call(i, "t") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.t), i.m != null && Object.hasOwnProperty.call(i, "m") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.m), i.p != null && Object.hasOwnProperty.call(i, "p") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(i.p), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Argument();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.k = i.string();
          break;
        }
        case 2: {
          t.t = i.string();
          break;
        }
        case 3: {
          t.m = i.string();
          break;
        }
        case 5: {
          t.p = i.int32();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Argument) return i;
    let g = new $root.Argument();
    return i.k != null && (g.k = String(i.k)), i.t != null && (g.t = String(i.t)), i.m != null && (g.m = String(i.m)), i.p != null && (g.p = i.p | 0), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.k = "", E.t = "", E.m = "", E.p = 0), i.k != null && i.hasOwnProperty("k") && (E.k = i.k), i.t != null && i.hasOwnProperty("t") && (E.t = i.t), i.m != null && i.hasOwnProperty("m") && (E.m = i.m), i.p != null && i.hasOwnProperty("p") && (E.p = i.p), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Argument";
  }, o;
})();
$root.Command = (() => {
  function o(i) {
    if (this.args = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.name = "", o.prototype.args = $util.emptyArray, o.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.name != null && Object.hasOwnProperty.call(i, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.name), i.args != null && i.args.length) for (let E = 0; E < i.args.length; ++E) $root.Argument.encode(i.args[E], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return i.time != null && Object.hasOwnProperty.call(i, "time") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int64(i.time), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.Command();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.name = i.string();
          break;
        }
        case 2: {
          t.args && t.args.length || (t.args = []), t.args.push($root.Argument.decode(i, i.uint32()));
          break;
        }
        case 4: {
          t.time = i.int64();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.Command) return i;
    let g = new $root.Command();
    if (i.name != null && (g.name = String(i.name)), i.args) {
      if (!Array.isArray(i.args)) throw TypeError(".Command.args: array expected");
      g.args = [];
      for (let E = 0; E < i.args.length; ++E) {
        if (typeof i.args[E] != "object") throw TypeError(".Command.args: object expected");
        g.args[E] = $root.Argument.fromObject(i.args[E]);
      }
    }
    return i.time != null && ($util.Long ? (g.time = $util.Long.fromValue(i.time)).unsigned = !1 : typeof i.time == "string" ? g.time = parseInt(i.time, 10) : typeof i.time == "number" ? g.time = i.time : typeof i.time == "object" && (g.time = new $util.LongBits(i.time.low >>> 0, i.time.high >>> 0).toNumber())), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.args = []), g.defaults) if (E.name = "", $util.Long) {
      let e = new $util.Long(0, 0, !1);
      E.time = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
    } else E.time = g.longs === String ? "0" : 0;
    if (i.name != null && i.hasOwnProperty("name") && (E.name = i.name), i.args && i.args.length) {
      E.args = [];
      for (let e = 0; e < i.args.length; ++e) E.args[e] = $root.Argument.toObject(i.args[e], g);
    }
    return i.time != null && i.hasOwnProperty("time") && (typeof i.time == "number" ? E.time = g.longs === String ? String(i.time) : i.time : E.time = g.longs === String ? $util.Long.prototype.toString.call(i.time) : g.longs === Number ? new $util.LongBits(i.time.low >>> 0, i.time.high >>> 0).toNumber() : i.time), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/Command";
  }, o;
})();
$root.PageNotFound = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.pageName = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.pageName != null && Object.hasOwnProperty.call(i, "pageName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.pageName), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.PageNotFound();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.pageName = i.string() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.PageNotFound) return i;
    let g = new $root.PageNotFound();
    return i.pageName != null && (g.pageName = String(i.pageName)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.pageName = ""), i.pageName != null && i.hasOwnProperty("pageName") && (E.pageName = i.pageName), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/PageNotFound";
  }, o;
})();
$root.PagesChanged = (() => {
  function o(i) {
    if (this.appPages = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.appPages = $util.emptyArray, o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.appPages != null && i.appPages.length) for (let E = 0; E < i.appPages.length; ++E) $root.AppPage.encode(i.appPages[E], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.PagesChanged();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? (t.appPages && t.appPages.length || (t.appPages = []), t.appPages.push($root.AppPage.decode(i, i.uint32()))) : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.PagesChanged) return i;
    let g = new $root.PagesChanged();
    if (i.appPages) {
      if (!Array.isArray(i.appPages)) throw TypeError(".PagesChanged.appPages: array expected");
      g.appPages = [];
      for (let E = 0; E < i.appPages.length; ++E) {
        if (typeof i.appPages[E] != "object") throw TypeError(".PagesChanged.appPages: object expected");
        g.appPages[E] = $root.AppPage.fromObject(i.appPages[E]);
      }
    }
    return g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.appPages = []), i.appPages && i.appPages.length) {
      E.appPages = [];
      for (let e = 0; e < i.appPages.length; ++e) E.appPages[e] = $root.AppPage.toObject(i.appPages[e], g);
    }
    return E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/PagesChanged";
  }, o;
})();
$root.ParentMessage = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.message = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.message != null && Object.hasOwnProperty.call(i, "message") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.message), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.ParentMessage();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      n >>> 3 === 1 ? t.message = i.string() : i.skipType(n & 7);
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.ParentMessage) return i;
    let g = new $root.ParentMessage();
    return i.message != null && (g.message = String(i.message)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.message = ""), i.message != null && i.hasOwnProperty("message") && (E.message = i.message), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/ParentMessage";
  }, o;
})();
$root.SessionEvent = (() => {
  function o(g) {
    if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
  }
  o.prototype.scriptChangedOnDisk = null, o.prototype.scriptWasManuallyStopped = null, o.prototype.scriptCompilationException = null;
  let i;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(i = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]), set: $util.oneOfSetter(i) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, E) {
    return E || (E = $Writer.create()), g.scriptChangedOnDisk != null && Object.hasOwnProperty.call(g, "scriptChangedOnDisk") && E.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.scriptChangedOnDisk), g.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(g, "scriptWasManuallyStopped") && E.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.scriptWasManuallyStopped), g.scriptCompilationException != null && Object.hasOwnProperty.call(g, "scriptCompilationException") && $root.Exception.encode(g.scriptCompilationException, E.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E;
  }, o.decode = function(g, E, e) {
    g instanceof $Reader || (g = $Reader.create(g));
    let t = E === void 0 ? g.len : g.pos + E, n = new $root.SessionEvent();
    for (; g.pos < t; ) {
      let h = g.uint32();
      if (h === e) break;
      switch (h >>> 3) {
        case 1: {
          n.scriptChangedOnDisk = g.bool();
          break;
        }
        case 2: {
          n.scriptWasManuallyStopped = g.bool();
          break;
        }
        case 3: {
          n.scriptCompilationException = $root.Exception.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root.SessionEvent) return g;
    let E = new $root.SessionEvent();
    if (g.scriptChangedOnDisk != null && (E.scriptChangedOnDisk = !!g.scriptChangedOnDisk), g.scriptWasManuallyStopped != null && (E.scriptWasManuallyStopped = !!g.scriptWasManuallyStopped), g.scriptCompilationException != null) {
      if (typeof g.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      E.scriptCompilationException = $root.Exception.fromObject(g.scriptCompilationException);
    }
    return E;
  }, o.toObject = function(g, E) {
    E || (E = {});
    let e = {};
    return g.scriptChangedOnDisk != null && g.hasOwnProperty("scriptChangedOnDisk") && (e.scriptChangedOnDisk = g.scriptChangedOnDisk, E.oneofs && (e.type = "scriptChangedOnDisk")), g.scriptWasManuallyStopped != null && g.hasOwnProperty("scriptWasManuallyStopped") && (e.scriptWasManuallyStopped = g.scriptWasManuallyStopped, E.oneofs && (e.type = "scriptWasManuallyStopped")), g.scriptCompilationException != null && g.hasOwnProperty("scriptCompilationException") && (e.scriptCompilationException = $root.Exception.toObject(g.scriptCompilationException, E), E.oneofs && (e.type = "scriptCompilationException")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SessionEvent";
  }, o;
})();
$root.MetricsEvent = (() => {
  function o(i) {
    if (this.commands = [], this.config = [], this.attributions = [], i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.event = "", o.prototype.anonymousId = "", o.prototype.machineIdV3 = "", o.prototype.machineIdV4 = "", o.prototype.reportHash = "", o.prototype.dev = !1, o.prototype.source = "", o.prototype.streamlitVersion = "", o.prototype.isHello = !1, o.prototype.appId = "", o.prototype.sessionId = "", o.prototype.pythonVersion = "", o.prototype.serverOs = "", o.prototype.hasDisplay = !1, o.prototype.isWebdriver = !1, o.prototype.hostedAt = "", o.prototype.owner = "", o.prototype.repo = "", o.prototype.branch = "", o.prototype.mainModule = "", o.prototype.creatorId = "", o.prototype.contextPageUrl = "", o.prototype.contextPageTitle = "", o.prototype.contextPagePath = "", o.prototype.contextPageReferrer = "", o.prototype.contextPageSearch = "", o.prototype.contextLocale = "", o.prototype.contextUserAgent = "", o.prototype.label = "", o.prototype.commands = $util.emptyArray, o.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.config = $util.emptyArray, o.prototype.uncaughtException = "", o.prototype.attributions = $util.emptyArray, o.prototype.os = "", o.prototype.timezone = "", o.prototype.headless = !1, o.prototype.isFragmentRun = !1, o.prototype.numPages = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.pageScriptHash = "", o.prototype.activeTheme = "", o.prototype.totalLoadTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.browserInfo = null, o.prototype.serverMode = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    if (g || (g = $Writer.create()), i.event != null && Object.hasOwnProperty.call(i, "event") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.event), i.anonymousId != null && Object.hasOwnProperty.call(i, "anonymousId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.anonymousId), i.machineIdV3 != null && Object.hasOwnProperty.call(i, "machineIdV3") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.machineIdV3), i.reportHash != null && Object.hasOwnProperty.call(i, "reportHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.reportHash), i.dev != null && Object.hasOwnProperty.call(i, "dev") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(i.dev), i.source != null && Object.hasOwnProperty.call(i, "source") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(i.source), i.streamlitVersion != null && Object.hasOwnProperty.call(i, "streamlitVersion") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(i.streamlitVersion), i.isHello != null && Object.hasOwnProperty.call(i, "isHello") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(i.isHello), i.hostedAt != null && Object.hasOwnProperty.call(i, "hostedAt") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(i.hostedAt), i.owner != null && Object.hasOwnProperty.call(i, "owner") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(i.owner), i.repo != null && Object.hasOwnProperty.call(i, "repo") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(i.repo), i.branch != null && Object.hasOwnProperty.call(i, "branch") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(i.branch), i.mainModule != null && Object.hasOwnProperty.call(i, "mainModule") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(i.mainModule), i.creatorId != null && Object.hasOwnProperty.call(i, "creatorId") && g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(i.creatorId), i.contextPageUrl != null && Object.hasOwnProperty.call(i, "contextPageUrl") && g.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(i.contextPageUrl), i.contextPageTitle != null && Object.hasOwnProperty.call(i, "contextPageTitle") && g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(i.contextPageTitle), i.contextPagePath != null && Object.hasOwnProperty.call(i, "contextPagePath") && g.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(i.contextPagePath), i.contextPageReferrer != null && Object.hasOwnProperty.call(i, "contextPageReferrer") && g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(i.contextPageReferrer), i.contextPageSearch != null && Object.hasOwnProperty.call(i, "contextPageSearch") && g.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(i.contextPageSearch), i.contextLocale != null && Object.hasOwnProperty.call(i, "contextLocale") && g.uint32(
      /* id 20, wireType 2 =*/
      162
    ).string(i.contextLocale), i.contextUserAgent != null && Object.hasOwnProperty.call(i, "contextUserAgent") && g.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(i.contextUserAgent), i.label != null && Object.hasOwnProperty.call(i, "label") && g.uint32(
      /* id 22, wireType 2 =*/
      178
    ).string(i.label), i.commands != null && i.commands.length) for (let E = 0; E < i.commands.length; ++E) $root.Command.encode(i.commands[E], g.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim();
    if (i.execTime != null && Object.hasOwnProperty.call(i, "execTime") && g.uint32(
      /* id 24, wireType 0 =*/
      192
    ).int64(i.execTime), i.prepTime != null && Object.hasOwnProperty.call(i, "prepTime") && g.uint32(
      /* id 25, wireType 0 =*/
      200
    ).int64(i.prepTime), i.config != null && i.config.length) for (let E = 0; E < i.config.length; ++E) g.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(i.config[E]);
    if (i.uncaughtException != null && Object.hasOwnProperty.call(i, "uncaughtException") && g.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(i.uncaughtException), i.attributions != null && i.attributions.length) for (let E = 0; E < i.attributions.length; ++E) g.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(i.attributions[E]);
    return i.os != null && Object.hasOwnProperty.call(i, "os") && g.uint32(
      /* id 29, wireType 2 =*/
      234
    ).string(i.os), i.timezone != null && Object.hasOwnProperty.call(i, "timezone") && g.uint32(
      /* id 30, wireType 2 =*/
      242
    ).string(i.timezone), i.headless != null && Object.hasOwnProperty.call(i, "headless") && g.uint32(
      /* id 31, wireType 0 =*/
      248
    ).bool(i.headless), i.isFragmentRun != null && Object.hasOwnProperty.call(i, "isFragmentRun") && g.uint32(
      /* id 32, wireType 0 =*/
      256
    ).bool(i.isFragmentRun), i.appId != null && Object.hasOwnProperty.call(i, "appId") && g.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(i.appId), i.numPages != null && Object.hasOwnProperty.call(i, "numPages") && g.uint32(
      /* id 34, wireType 0 =*/
      272
    ).int64(i.numPages), i.sessionId != null && Object.hasOwnProperty.call(i, "sessionId") && g.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(i.sessionId), i.pythonVersion != null && Object.hasOwnProperty.call(i, "pythonVersion") && g.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(i.pythonVersion), i.pageScriptHash != null && Object.hasOwnProperty.call(i, "pageScriptHash") && g.uint32(
      /* id 37, wireType 2 =*/
      298
    ).string(i.pageScriptHash), i.activeTheme != null && Object.hasOwnProperty.call(i, "activeTheme") && g.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(i.activeTheme), i.totalLoadTime != null && Object.hasOwnProperty.call(i, "totalLoadTime") && g.uint32(
      /* id 39, wireType 0 =*/
      312
    ).int64(i.totalLoadTime), i.browserInfo != null && Object.hasOwnProperty.call(i, "browserInfo") && $root.BrowserInfo.encode(i.browserInfo, g.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), i.machineIdV4 != null && Object.hasOwnProperty.call(i, "machineIdV4") && g.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(i.machineIdV4), i.serverOs != null && Object.hasOwnProperty.call(i, "serverOs") && g.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(i.serverOs), i.hasDisplay != null && Object.hasOwnProperty.call(i, "hasDisplay") && g.uint32(
      /* id 43, wireType 0 =*/
      344
    ).bool(i.hasDisplay), i.isWebdriver != null && Object.hasOwnProperty.call(i, "isWebdriver") && g.uint32(
      /* id 44, wireType 0 =*/
      352
    ).bool(i.isWebdriver), i.serverMode != null && Object.hasOwnProperty.call(i, "serverMode") && g.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(i.serverMode), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.MetricsEvent();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.event = i.string();
          break;
        }
        case 2: {
          t.anonymousId = i.string();
          break;
        }
        case 3: {
          t.machineIdV3 = i.string();
          break;
        }
        case 41: {
          t.machineIdV4 = i.string();
          break;
        }
        case 4: {
          t.reportHash = i.string();
          break;
        }
        case 5: {
          t.dev = i.bool();
          break;
        }
        case 6: {
          t.source = i.string();
          break;
        }
        case 7: {
          t.streamlitVersion = i.string();
          break;
        }
        case 8: {
          t.isHello = i.bool();
          break;
        }
        case 33: {
          t.appId = i.string();
          break;
        }
        case 35: {
          t.sessionId = i.string();
          break;
        }
        case 36: {
          t.pythonVersion = i.string();
          break;
        }
        case 42: {
          t.serverOs = i.string();
          break;
        }
        case 43: {
          t.hasDisplay = i.bool();
          break;
        }
        case 44: {
          t.isWebdriver = i.bool();
          break;
        }
        case 9: {
          t.hostedAt = i.string();
          break;
        }
        case 10: {
          t.owner = i.string();
          break;
        }
        case 11: {
          t.repo = i.string();
          break;
        }
        case 12: {
          t.branch = i.string();
          break;
        }
        case 13: {
          t.mainModule = i.string();
          break;
        }
        case 14: {
          t.creatorId = i.string();
          break;
        }
        case 15: {
          t.contextPageUrl = i.string();
          break;
        }
        case 16: {
          t.contextPageTitle = i.string();
          break;
        }
        case 17: {
          t.contextPagePath = i.string();
          break;
        }
        case 18: {
          t.contextPageReferrer = i.string();
          break;
        }
        case 19: {
          t.contextPageSearch = i.string();
          break;
        }
        case 20: {
          t.contextLocale = i.string();
          break;
        }
        case 21: {
          t.contextUserAgent = i.string();
          break;
        }
        case 22: {
          t.label = i.string();
          break;
        }
        case 23: {
          t.commands && t.commands.length || (t.commands = []), t.commands.push($root.Command.decode(i, i.uint32()));
          break;
        }
        case 24: {
          t.execTime = i.int64();
          break;
        }
        case 25: {
          t.prepTime = i.int64();
          break;
        }
        case 26: {
          t.config && t.config.length || (t.config = []), t.config.push(i.string());
          break;
        }
        case 27: {
          t.uncaughtException = i.string();
          break;
        }
        case 28: {
          t.attributions && t.attributions.length || (t.attributions = []), t.attributions.push(i.string());
          break;
        }
        case 29: {
          t.os = i.string();
          break;
        }
        case 30: {
          t.timezone = i.string();
          break;
        }
        case 31: {
          t.headless = i.bool();
          break;
        }
        case 32: {
          t.isFragmentRun = i.bool();
          break;
        }
        case 34: {
          t.numPages = i.int64();
          break;
        }
        case 37: {
          t.pageScriptHash = i.string();
          break;
        }
        case 38: {
          t.activeTheme = i.string();
          break;
        }
        case 39: {
          t.totalLoadTime = i.int64();
          break;
        }
        case 40: {
          t.browserInfo = $root.BrowserInfo.decode(i, i.uint32());
          break;
        }
        case 45: {
          t.serverMode = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.MetricsEvent) return i;
    let g = new $root.MetricsEvent();
    if (i.event != null && (g.event = String(i.event)), i.anonymousId != null && (g.anonymousId = String(i.anonymousId)), i.machineIdV3 != null && (g.machineIdV3 = String(i.machineIdV3)), i.machineIdV4 != null && (g.machineIdV4 = String(i.machineIdV4)), i.reportHash != null && (g.reportHash = String(i.reportHash)), i.dev != null && (g.dev = !!i.dev), i.source != null && (g.source = String(i.source)), i.streamlitVersion != null && (g.streamlitVersion = String(i.streamlitVersion)), i.isHello != null && (g.isHello = !!i.isHello), i.appId != null && (g.appId = String(i.appId)), i.sessionId != null && (g.sessionId = String(i.sessionId)), i.pythonVersion != null && (g.pythonVersion = String(i.pythonVersion)), i.serverOs != null && (g.serverOs = String(i.serverOs)), i.hasDisplay != null && (g.hasDisplay = !!i.hasDisplay), i.isWebdriver != null && (g.isWebdriver = !!i.isWebdriver), i.hostedAt != null && (g.hostedAt = String(i.hostedAt)), i.owner != null && (g.owner = String(i.owner)), i.repo != null && (g.repo = String(i.repo)), i.branch != null && (g.branch = String(i.branch)), i.mainModule != null && (g.mainModule = String(i.mainModule)), i.creatorId != null && (g.creatorId = String(i.creatorId)), i.contextPageUrl != null && (g.contextPageUrl = String(i.contextPageUrl)), i.contextPageTitle != null && (g.contextPageTitle = String(i.contextPageTitle)), i.contextPagePath != null && (g.contextPagePath = String(i.contextPagePath)), i.contextPageReferrer != null && (g.contextPageReferrer = String(i.contextPageReferrer)), i.contextPageSearch != null && (g.contextPageSearch = String(i.contextPageSearch)), i.contextLocale != null && (g.contextLocale = String(i.contextLocale)), i.contextUserAgent != null && (g.contextUserAgent = String(i.contextUserAgent)), i.label != null && (g.label = String(i.label)), i.commands) {
      if (!Array.isArray(i.commands)) throw TypeError(".MetricsEvent.commands: array expected");
      g.commands = [];
      for (let E = 0; E < i.commands.length; ++E) {
        if (typeof i.commands[E] != "object") throw TypeError(".MetricsEvent.commands: object expected");
        g.commands[E] = $root.Command.fromObject(i.commands[E]);
      }
    }
    if (i.execTime != null && ($util.Long ? (g.execTime = $util.Long.fromValue(i.execTime)).unsigned = !1 : typeof i.execTime == "string" ? g.execTime = parseInt(i.execTime, 10) : typeof i.execTime == "number" ? g.execTime = i.execTime : typeof i.execTime == "object" && (g.execTime = new $util.LongBits(i.execTime.low >>> 0, i.execTime.high >>> 0).toNumber())), i.prepTime != null && ($util.Long ? (g.prepTime = $util.Long.fromValue(i.prepTime)).unsigned = !1 : typeof i.prepTime == "string" ? g.prepTime = parseInt(i.prepTime, 10) : typeof i.prepTime == "number" ? g.prepTime = i.prepTime : typeof i.prepTime == "object" && (g.prepTime = new $util.LongBits(i.prepTime.low >>> 0, i.prepTime.high >>> 0).toNumber())), i.config) {
      if (!Array.isArray(i.config)) throw TypeError(".MetricsEvent.config: array expected");
      g.config = [];
      for (let E = 0; E < i.config.length; ++E) g.config[E] = String(i.config[E]);
    }
    if (i.uncaughtException != null && (g.uncaughtException = String(i.uncaughtException)), i.attributions) {
      if (!Array.isArray(i.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
      g.attributions = [];
      for (let E = 0; E < i.attributions.length; ++E) g.attributions[E] = String(i.attributions[E]);
    }
    if (i.os != null && (g.os = String(i.os)), i.timezone != null && (g.timezone = String(i.timezone)), i.headless != null && (g.headless = !!i.headless), i.isFragmentRun != null && (g.isFragmentRun = !!i.isFragmentRun), i.numPages != null && ($util.Long ? (g.numPages = $util.Long.fromValue(i.numPages)).unsigned = !1 : typeof i.numPages == "string" ? g.numPages = parseInt(i.numPages, 10) : typeof i.numPages == "number" ? g.numPages = i.numPages : typeof i.numPages == "object" && (g.numPages = new $util.LongBits(i.numPages.low >>> 0, i.numPages.high >>> 0).toNumber())), i.pageScriptHash != null && (g.pageScriptHash = String(i.pageScriptHash)), i.activeTheme != null && (g.activeTheme = String(i.activeTheme)), i.totalLoadTime != null && ($util.Long ? (g.totalLoadTime = $util.Long.fromValue(i.totalLoadTime)).unsigned = !1 : typeof i.totalLoadTime == "string" ? g.totalLoadTime = parseInt(i.totalLoadTime, 10) : typeof i.totalLoadTime == "number" ? g.totalLoadTime = i.totalLoadTime : typeof i.totalLoadTime == "object" && (g.totalLoadTime = new $util.LongBits(i.totalLoadTime.low >>> 0, i.totalLoadTime.high >>> 0).toNumber())), i.browserInfo != null) {
      if (typeof i.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
      g.browserInfo = $root.BrowserInfo.fromObject(i.browserInfo);
    }
    return i.serverMode != null && (g.serverMode = String(i.serverMode)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    if ((g.arrays || g.defaults) && (E.commands = [], E.config = [], E.attributions = []), g.defaults) {
      if (E.event = "", E.anonymousId = "", E.machineIdV3 = "", E.reportHash = "", E.dev = !1, E.source = "", E.streamlitVersion = "", E.isHello = !1, E.hostedAt = "", E.owner = "", E.repo = "", E.branch = "", E.mainModule = "", E.creatorId = "", E.contextPageUrl = "", E.contextPageTitle = "", E.contextPagePath = "", E.contextPageReferrer = "", E.contextPageSearch = "", E.contextLocale = "", E.contextUserAgent = "", E.label = "", $util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.execTime = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.execTime = g.longs === String ? "0" : 0;
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.prepTime = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.prepTime = g.longs === String ? "0" : 0;
      if (E.uncaughtException = "", E.os = "", E.timezone = "", E.headless = !1, E.isFragmentRun = !1, E.appId = "", $util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.numPages = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.numPages = g.longs === String ? "0" : 0;
      if (E.sessionId = "", E.pythonVersion = "", E.pageScriptHash = "", E.activeTheme = "", $util.Long) {
        let e = new $util.Long(0, 0, !1);
        E.totalLoadTime = g.longs === String ? e.toString() : g.longs === Number ? e.toNumber() : e;
      } else E.totalLoadTime = g.longs === String ? "0" : 0;
      E.browserInfo = null, E.machineIdV4 = "", E.serverOs = "", E.hasDisplay = !1, E.isWebdriver = !1, E.serverMode = "";
    }
    if (i.event != null && i.hasOwnProperty("event") && (E.event = i.event), i.anonymousId != null && i.hasOwnProperty("anonymousId") && (E.anonymousId = i.anonymousId), i.machineIdV3 != null && i.hasOwnProperty("machineIdV3") && (E.machineIdV3 = i.machineIdV3), i.reportHash != null && i.hasOwnProperty("reportHash") && (E.reportHash = i.reportHash), i.dev != null && i.hasOwnProperty("dev") && (E.dev = i.dev), i.source != null && i.hasOwnProperty("source") && (E.source = i.source), i.streamlitVersion != null && i.hasOwnProperty("streamlitVersion") && (E.streamlitVersion = i.streamlitVersion), i.isHello != null && i.hasOwnProperty("isHello") && (E.isHello = i.isHello), i.hostedAt != null && i.hasOwnProperty("hostedAt") && (E.hostedAt = i.hostedAt), i.owner != null && i.hasOwnProperty("owner") && (E.owner = i.owner), i.repo != null && i.hasOwnProperty("repo") && (E.repo = i.repo), i.branch != null && i.hasOwnProperty("branch") && (E.branch = i.branch), i.mainModule != null && i.hasOwnProperty("mainModule") && (E.mainModule = i.mainModule), i.creatorId != null && i.hasOwnProperty("creatorId") && (E.creatorId = i.creatorId), i.contextPageUrl != null && i.hasOwnProperty("contextPageUrl") && (E.contextPageUrl = i.contextPageUrl), i.contextPageTitle != null && i.hasOwnProperty("contextPageTitle") && (E.contextPageTitle = i.contextPageTitle), i.contextPagePath != null && i.hasOwnProperty("contextPagePath") && (E.contextPagePath = i.contextPagePath), i.contextPageReferrer != null && i.hasOwnProperty("contextPageReferrer") && (E.contextPageReferrer = i.contextPageReferrer), i.contextPageSearch != null && i.hasOwnProperty("contextPageSearch") && (E.contextPageSearch = i.contextPageSearch), i.contextLocale != null && i.hasOwnProperty("contextLocale") && (E.contextLocale = i.contextLocale), i.contextUserAgent != null && i.hasOwnProperty("contextUserAgent") && (E.contextUserAgent = i.contextUserAgent), i.label != null && i.hasOwnProperty("label") && (E.label = i.label), i.commands && i.commands.length) {
      E.commands = [];
      for (let e = 0; e < i.commands.length; ++e) E.commands[e] = $root.Command.toObject(i.commands[e], g);
    }
    if (i.execTime != null && i.hasOwnProperty("execTime") && (typeof i.execTime == "number" ? E.execTime = g.longs === String ? String(i.execTime) : i.execTime : E.execTime = g.longs === String ? $util.Long.prototype.toString.call(i.execTime) : g.longs === Number ? new $util.LongBits(i.execTime.low >>> 0, i.execTime.high >>> 0).toNumber() : i.execTime), i.prepTime != null && i.hasOwnProperty("prepTime") && (typeof i.prepTime == "number" ? E.prepTime = g.longs === String ? String(i.prepTime) : i.prepTime : E.prepTime = g.longs === String ? $util.Long.prototype.toString.call(i.prepTime) : g.longs === Number ? new $util.LongBits(i.prepTime.low >>> 0, i.prepTime.high >>> 0).toNumber() : i.prepTime), i.config && i.config.length) {
      E.config = [];
      for (let e = 0; e < i.config.length; ++e) E.config[e] = i.config[e];
    }
    if (i.uncaughtException != null && i.hasOwnProperty("uncaughtException") && (E.uncaughtException = i.uncaughtException), i.attributions && i.attributions.length) {
      E.attributions = [];
      for (let e = 0; e < i.attributions.length; ++e) E.attributions[e] = i.attributions[e];
    }
    return i.os != null && i.hasOwnProperty("os") && (E.os = i.os), i.timezone != null && i.hasOwnProperty("timezone") && (E.timezone = i.timezone), i.headless != null && i.hasOwnProperty("headless") && (E.headless = i.headless), i.isFragmentRun != null && i.hasOwnProperty("isFragmentRun") && (E.isFragmentRun = i.isFragmentRun), i.appId != null && i.hasOwnProperty("appId") && (E.appId = i.appId), i.numPages != null && i.hasOwnProperty("numPages") && (typeof i.numPages == "number" ? E.numPages = g.longs === String ? String(i.numPages) : i.numPages : E.numPages = g.longs === String ? $util.Long.prototype.toString.call(i.numPages) : g.longs === Number ? new $util.LongBits(i.numPages.low >>> 0, i.numPages.high >>> 0).toNumber() : i.numPages), i.sessionId != null && i.hasOwnProperty("sessionId") && (E.sessionId = i.sessionId), i.pythonVersion != null && i.hasOwnProperty("pythonVersion") && (E.pythonVersion = i.pythonVersion), i.pageScriptHash != null && i.hasOwnProperty("pageScriptHash") && (E.pageScriptHash = i.pageScriptHash), i.activeTheme != null && i.hasOwnProperty("activeTheme") && (E.activeTheme = i.activeTheme), i.totalLoadTime != null && i.hasOwnProperty("totalLoadTime") && (typeof i.totalLoadTime == "number" ? E.totalLoadTime = g.longs === String ? String(i.totalLoadTime) : i.totalLoadTime : E.totalLoadTime = g.longs === String ? $util.Long.prototype.toString.call(i.totalLoadTime) : g.longs === Number ? new $util.LongBits(i.totalLoadTime.low >>> 0, i.totalLoadTime.high >>> 0).toNumber() : i.totalLoadTime), i.browserInfo != null && i.hasOwnProperty("browserInfo") && (E.browserInfo = $root.BrowserInfo.toObject(i.browserInfo, g)), i.machineIdV4 != null && i.hasOwnProperty("machineIdV4") && (E.machineIdV4 = i.machineIdV4), i.serverOs != null && i.hasOwnProperty("serverOs") && (E.serverOs = i.serverOs), i.hasDisplay != null && i.hasOwnProperty("hasDisplay") && (E.hasDisplay = i.hasDisplay), i.isWebdriver != null && i.hasOwnProperty("isWebdriver") && (E.isWebdriver = i.isWebdriver), i.serverMode != null && i.hasOwnProperty("serverMode") && (E.serverMode = i.serverMode), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/MetricsEvent";
  }, o;
})();
$root.BrowserInfo = (() => {
  function o(i) {
    if (i) for (let g = Object.keys(i), E = 0; E < g.length; ++E) i[g[E]] != null && (this[g[E]] = i[g[E]]);
  }
  return o.prototype.browserName = "", o.prototype.browserVersion = "", o.prototype.deviceType = "", o.prototype.os = "", o.create = function(i) {
    return new o(i);
  }, o.encode = function(i, g) {
    return g || (g = $Writer.create()), i.browserName != null && Object.hasOwnProperty.call(i, "browserName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(i.browserName), i.browserVersion != null && Object.hasOwnProperty.call(i, "browserVersion") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(i.browserVersion), i.deviceType != null && Object.hasOwnProperty.call(i, "deviceType") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(i.deviceType), i.os != null && Object.hasOwnProperty.call(i, "os") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(i.os), g;
  }, o.decode = function(i, g, E) {
    i instanceof $Reader || (i = $Reader.create(i));
    let e = g === void 0 ? i.len : i.pos + g, t = new $root.BrowserInfo();
    for (; i.pos < e; ) {
      let n = i.uint32();
      if (n === E) break;
      switch (n >>> 3) {
        case 1: {
          t.browserName = i.string();
          break;
        }
        case 2: {
          t.browserVersion = i.string();
          break;
        }
        case 3: {
          t.deviceType = i.string();
          break;
        }
        case 4: {
          t.os = i.string();
          break;
        }
        default:
          i.skipType(n & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(i) {
    if (i instanceof $root.BrowserInfo) return i;
    let g = new $root.BrowserInfo();
    return i.browserName != null && (g.browserName = String(i.browserName)), i.browserVersion != null && (g.browserVersion = String(i.browserVersion)), i.deviceType != null && (g.deviceType = String(i.deviceType)), i.os != null && (g.os = String(i.os)), g;
  }, o.toObject = function(i, g) {
    g || (g = {});
    let E = {};
    return g.defaults && (E.browserName = "", E.browserVersion = "", E.deviceType = "", E.os = ""), i.browserName != null && i.hasOwnProperty("browserName") && (E.browserName = i.browserName), i.browserVersion != null && i.hasOwnProperty("browserVersion") && (E.browserVersion = i.browserVersion), i.deviceType != null && i.hasOwnProperty("deviceType") && (E.deviceType = i.deviceType), i.os != null && i.hasOwnProperty("os") && (E.os = i.os), E;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(i) {
    return i === void 0 && (i = "type.googleapis.com"), i + "/BrowserInfo";
  }, o;
})();
$root.openmetrics = (() => {
  const o = {};
  return o.MetricSet = (function() {
    function i(g) {
      if (this.metricFamilies = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.metricFamilies = $util.emptyArray, i.create = function(g) {
      return new i(g);
    }, i.encode = function(g, E) {
      if (E || (E = $Writer.create()), g.metricFamilies != null && g.metricFamilies.length) for (let e = 0; e < g.metricFamilies.length; ++e) $root.openmetrics.MetricFamily.encode(g.metricFamilies[e], E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return E;
    }, i.decode = function(g, E, e) {
      g instanceof $Reader || (g = $Reader.create(g));
      let t = E === void 0 ? g.len : g.pos + E, n = new $root.openmetrics.MetricSet();
      for (; g.pos < t; ) {
        let h = g.uint32();
        if (h === e) break;
        h >>> 3 === 1 ? (n.metricFamilies && n.metricFamilies.length || (n.metricFamilies = []), n.metricFamilies.push($root.openmetrics.MetricFamily.decode(g, g.uint32()))) : g.skipType(h & 7);
      }
      return n;
    }, i.fromObject = function(g) {
      if (g instanceof $root.openmetrics.MetricSet) return g;
      let E = new $root.openmetrics.MetricSet();
      if (g.metricFamilies) {
        if (!Array.isArray(g.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        E.metricFamilies = [];
        for (let e = 0; e < g.metricFamilies.length; ++e) {
          if (typeof g.metricFamilies[e] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          E.metricFamilies[e] = $root.openmetrics.MetricFamily.fromObject(g.metricFamilies[e]);
        }
      }
      return E;
    }, i.toObject = function(g, E) {
      E || (E = {});
      let e = {};
      if ((E.arrays || E.defaults) && (e.metricFamilies = []), g.metricFamilies && g.metricFamilies.length) {
        e.metricFamilies = [];
        for (let t = 0; t < g.metricFamilies.length; ++t) e.metricFamilies[t] = $root.openmetrics.MetricFamily.toObject(g.metricFamilies[t], E);
      }
      return e;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.MetricSet";
    }, i;
  })(), o.MetricFamily = (function() {
    function i(g) {
      if (this.metrics = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.name = "", i.prototype.type = 0, i.prototype.unit = "", i.prototype.help = "", i.prototype.metrics = $util.emptyArray, i.create = function(g) {
      return new i(g);
    }, i.encode = function(g, E) {
      if (E || (E = $Writer.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.name), g.type != null && Object.hasOwnProperty.call(g, "type") && E.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(g.type), g.unit != null && Object.hasOwnProperty.call(g, "unit") && E.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(g.unit), g.help != null && Object.hasOwnProperty.call(g, "help") && E.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(g.help), g.metrics != null && g.metrics.length) for (let e = 0; e < g.metrics.length; ++e) $root.Metric.encode(g.metrics[e], E.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return E;
    }, i.decode = function(g, E, e) {
      g instanceof $Reader || (g = $Reader.create(g));
      let t = E === void 0 ? g.len : g.pos + E, n = new $root.openmetrics.MetricFamily();
      for (; g.pos < t; ) {
        let h = g.uint32();
        if (h === e) break;
        switch (h >>> 3) {
          case 1: {
            n.name = g.string();
            break;
          }
          case 2: {
            n.type = g.int32();
            break;
          }
          case 3: {
            n.unit = g.string();
            break;
          }
          case 4: {
            n.help = g.string();
            break;
          }
          case 5: {
            n.metrics && n.metrics.length || (n.metrics = []), n.metrics.push($root.Metric.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, i.fromObject = function(g) {
      if (g instanceof $root.openmetrics.MetricFamily) return g;
      let E = new $root.openmetrics.MetricFamily();
      switch (g.name != null && (E.name = String(g.name)), g.type) {
        default:
          if (typeof g.type == "number") {
            E.type = g.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          E.type = 0;
          break;
        case "GAUGE":
        case 1:
          E.type = 1;
          break;
        case "COUNTER":
        case 2:
          E.type = 2;
          break;
        case "STATE_SET":
        case 3:
          E.type = 3;
          break;
        case "INFO":
        case 4:
          E.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          E.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          E.type = 6;
          break;
        case "SUMMARY":
        case 7:
          E.type = 7;
          break;
      }
      if (g.unit != null && (E.unit = String(g.unit)), g.help != null && (E.help = String(g.help)), g.metrics) {
        if (!Array.isArray(g.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        E.metrics = [];
        for (let e = 0; e < g.metrics.length; ++e) {
          if (typeof g.metrics[e] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          E.metrics[e] = $root.Metric.fromObject(g.metrics[e]);
        }
      }
      return E;
    }, i.toObject = function(g, E) {
      E || (E = {});
      let e = {};
      if ((E.arrays || E.defaults) && (e.metrics = []), E.defaults && (e.name = "", e.type = E.enums === String ? "UNKNOWN" : 0, e.unit = "", e.help = ""), g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.type != null && g.hasOwnProperty("type") && (e.type = E.enums === String ? $root.openmetrics.MetricType[g.type] === void 0 ? g.type : $root.openmetrics.MetricType[g.type] : g.type), g.unit != null && g.hasOwnProperty("unit") && (e.unit = g.unit), g.help != null && g.hasOwnProperty("help") && (e.help = g.help), g.metrics && g.metrics.length) {
        e.metrics = [];
        for (let t = 0; t < g.metrics.length; ++t) e.metrics[t] = $root.Metric.toObject(g.metrics[t], E);
      }
      return e;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.MetricFamily";
    }, i;
  })(), o.MetricType = (function() {
    const i = {}, g = Object.create(i);
    return g[i[0] = "UNKNOWN"] = 0, g[i[1] = "GAUGE"] = 1, g[i[2] = "COUNTER"] = 2, g[i[3] = "STATE_SET"] = 3, g[i[4] = "INFO"] = 4, g[i[5] = "HISTOGRAM"] = 5, g[i[6] = "GAUGE_HISTOGRAM"] = 6, g[i[7] = "SUMMARY"] = 7, g;
  })(), o.Metric = (function() {
    function i(g) {
      if (this.labels = [], this.metricPoints = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.labels = $util.emptyArray, i.prototype.metricPoints = $util.emptyArray, i.create = function(g) {
      return new i(g);
    }, i.encode = function(g, E) {
      if (E || (E = $Writer.create()), g.labels != null && g.labels.length) for (let e = 0; e < g.labels.length; ++e) $root.openmetrics.Label.encode(g.labels[e], E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      if (g.metricPoints != null && g.metricPoints.length) for (let e = 0; e < g.metricPoints.length; ++e) $root.openmetrics.MetricPoint.encode(g.metricPoints[e], E.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim();
      return E;
    }, i.decode = function(g, E, e) {
      g instanceof $Reader || (g = $Reader.create(g));
      let t = E === void 0 ? g.len : g.pos + E, n = new $root.openmetrics.Metric();
      for (; g.pos < t; ) {
        let h = g.uint32();
        if (h === e) break;
        switch (h >>> 3) {
          case 1: {
            n.labels && n.labels.length || (n.labels = []), n.labels.push($root.openmetrics.Label.decode(g, g.uint32()));
            break;
          }
          case 2: {
            n.metricPoints && n.metricPoints.length || (n.metricPoints = []), n.metricPoints.push($root.openmetrics.MetricPoint.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, i.fromObject = function(g) {
      if (g instanceof $root.openmetrics.Metric) return g;
      let E = new $root.openmetrics.Metric();
      if (g.labels) {
        if (!Array.isArray(g.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
        E.labels = [];
        for (let e = 0; e < g.labels.length; ++e) {
          if (typeof g.labels[e] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
          E.labels[e] = $root.openmetrics.Label.fromObject(g.labels[e]);
        }
      }
      if (g.metricPoints) {
        if (!Array.isArray(g.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        E.metricPoints = [];
        for (let e = 0; e < g.metricPoints.length; ++e) {
          if (typeof g.metricPoints[e] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          E.metricPoints[e] = $root.openmetrics.MetricPoint.fromObject(g.metricPoints[e]);
        }
      }
      return E;
    }, i.toObject = function(g, E) {
      E || (E = {});
      let e = {};
      if ((E.arrays || E.defaults) && (e.labels = [], e.metricPoints = []), g.labels && g.labels.length) {
        e.labels = [];
        for (let t = 0; t < g.labels.length; ++t) e.labels[t] = $root.openmetrics.Label.toObject(g.labels[t], E);
      }
      if (g.metricPoints && g.metricPoints.length) {
        e.metricPoints = [];
        for (let t = 0; t < g.metricPoints.length; ++t) e.metricPoints[t] = $root.openmetrics.MetricPoint.toObject(g.metricPoints[t], E);
      }
      return e;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Metric";
    }, i;
  })(), o.Label = (function() {
    function i(g) {
      if (g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.name = "", i.prototype.value = "", i.create = function(g) {
      return new i(g);
    }, i.encode = function(g, E) {
      return E || (E = $Writer.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.name), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(g.value), E;
    }, i.decode = function(g, E, e) {
      g instanceof $Reader || (g = $Reader.create(g));
      let t = E === void 0 ? g.len : g.pos + E, n = new $root.openmetrics.Label();
      for (; g.pos < t; ) {
        let h = g.uint32();
        if (h === e) break;
        switch (h >>> 3) {
          case 1: {
            n.name = g.string();
            break;
          }
          case 2: {
            n.value = g.string();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, i.fromObject = function(g) {
      if (g instanceof $root.openmetrics.Label) return g;
      let E = new $root.openmetrics.Label();
      return g.name != null && (E.name = String(g.name)), g.value != null && (E.value = String(g.value)), E;
    }, i.toObject = function(g, E) {
      E || (E = {});
      let e = {};
      return E.defaults && (e.name = "", e.value = ""), g.name != null && g.hasOwnProperty("name") && (e.name = g.name), g.value != null && g.hasOwnProperty("value") && (e.value = g.value), e;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Label";
    }, i;
  })(), o.MetricPoint = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.unknownValue = null, i.prototype.gaugeValue = null, i.prototype.counterValue = null, i.prototype.histogramValue = null, i.prototype.stateSetValue = null, i.prototype.infoValue = null, i.prototype.summaryValue = null, i.prototype.timestamp = null;
    let g;
    return Object.defineProperty(i.prototype, "value", { get: $util.oneOfGetter(g = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer.create()), E.unknownValue != null && Object.hasOwnProperty.call(E, "unknownValue") && $root.openmetrics.UnknownValue.encode(E.unknownValue, e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), E.gaugeValue != null && Object.hasOwnProperty.call(E, "gaugeValue") && $root.openmetrics.GaugeValue.encode(E.gaugeValue, e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), E.counterValue != null && Object.hasOwnProperty.call(E, "counterValue") && $root.openmetrics.CounterValue.encode(E.counterValue, e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), E.histogramValue != null && Object.hasOwnProperty.call(E, "histogramValue") && $root.openmetrics.HistogramValue.encode(E.histogramValue, e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), E.stateSetValue != null && Object.hasOwnProperty.call(E, "stateSetValue") && $root.openmetrics.StateSetValue.encode(E.stateSetValue, e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), E.infoValue != null && Object.hasOwnProperty.call(E, "infoValue") && $root.openmetrics.InfoValue.encode(E.infoValue, e.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), E.summaryValue != null && Object.hasOwnProperty.call(E, "summaryValue") && $root.openmetrics.SummaryValue.encode(E.summaryValue, e.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), E.timestamp != null && Object.hasOwnProperty.call(E, "timestamp") && $root.google.protobuf.Timestamp.encode(E.timestamp, e.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.openmetrics.MetricPoint();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.unknownValue = $root.openmetrics.UnknownValue.decode(E, E.uint32());
            break;
          }
          case 2: {
            h.gaugeValue = $root.openmetrics.GaugeValue.decode(E, E.uint32());
            break;
          }
          case 3: {
            h.counterValue = $root.openmetrics.CounterValue.decode(E, E.uint32());
            break;
          }
          case 4: {
            h.histogramValue = $root.openmetrics.HistogramValue.decode(E, E.uint32());
            break;
          }
          case 5: {
            h.stateSetValue = $root.openmetrics.StateSetValue.decode(E, E.uint32());
            break;
          }
          case 6: {
            h.infoValue = $root.openmetrics.InfoValue.decode(E, E.uint32());
            break;
          }
          case 7: {
            h.summaryValue = $root.openmetrics.SummaryValue.decode(E, E.uint32());
            break;
          }
          case 8: {
            h.timestamp = $root.google.protobuf.Timestamp.decode(E, E.uint32());
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.openmetrics.MetricPoint) return E;
      let e = new $root.openmetrics.MetricPoint();
      if (E.unknownValue != null) {
        if (typeof E.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        e.unknownValue = $root.openmetrics.UnknownValue.fromObject(E.unknownValue);
      }
      if (E.gaugeValue != null) {
        if (typeof E.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        e.gaugeValue = $root.openmetrics.GaugeValue.fromObject(E.gaugeValue);
      }
      if (E.counterValue != null) {
        if (typeof E.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        e.counterValue = $root.openmetrics.CounterValue.fromObject(E.counterValue);
      }
      if (E.histogramValue != null) {
        if (typeof E.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        e.histogramValue = $root.openmetrics.HistogramValue.fromObject(E.histogramValue);
      }
      if (E.stateSetValue != null) {
        if (typeof E.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        e.stateSetValue = $root.openmetrics.StateSetValue.fromObject(E.stateSetValue);
      }
      if (E.infoValue != null) {
        if (typeof E.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        e.infoValue = $root.openmetrics.InfoValue.fromObject(E.infoValue);
      }
      if (E.summaryValue != null) {
        if (typeof E.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        e.summaryValue = $root.openmetrics.SummaryValue.fromObject(E.summaryValue);
      }
      if (E.timestamp != null) {
        if (typeof E.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        e.timestamp = $root.google.protobuf.Timestamp.fromObject(E.timestamp);
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.timestamp = null), E.unknownValue != null && E.hasOwnProperty("unknownValue") && (t.unknownValue = $root.openmetrics.UnknownValue.toObject(E.unknownValue, e), e.oneofs && (t.value = "unknownValue")), E.gaugeValue != null && E.hasOwnProperty("gaugeValue") && (t.gaugeValue = $root.openmetrics.GaugeValue.toObject(E.gaugeValue, e), e.oneofs && (t.value = "gaugeValue")), E.counterValue != null && E.hasOwnProperty("counterValue") && (t.counterValue = $root.openmetrics.CounterValue.toObject(E.counterValue, e), e.oneofs && (t.value = "counterValue")), E.histogramValue != null && E.hasOwnProperty("histogramValue") && (t.histogramValue = $root.openmetrics.HistogramValue.toObject(E.histogramValue, e), e.oneofs && (t.value = "histogramValue")), E.stateSetValue != null && E.hasOwnProperty("stateSetValue") && (t.stateSetValue = $root.openmetrics.StateSetValue.toObject(E.stateSetValue, e), e.oneofs && (t.value = "stateSetValue")), E.infoValue != null && E.hasOwnProperty("infoValue") && (t.infoValue = $root.openmetrics.InfoValue.toObject(E.infoValue, e), e.oneofs && (t.value = "infoValue")), E.summaryValue != null && E.hasOwnProperty("summaryValue") && (t.summaryValue = $root.openmetrics.SummaryValue.toObject(E.summaryValue, e), e.oneofs && (t.value = "summaryValue")), E.timestamp != null && E.hasOwnProperty("timestamp") && (t.timestamp = $root.google.protobuf.Timestamp.toObject(E.timestamp, e)), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.MetricPoint";
    }, i;
  })(), o.UnknownValue = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null;
    let g;
    return Object.defineProperty(i.prototype, "value", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer.create()), E.doubleValue != null && Object.hasOwnProperty.call(E, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(E.doubleValue), E.intValue != null && Object.hasOwnProperty.call(E, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(E.intValue), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.openmetrics.UnknownValue();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = E.double();
            break;
          }
          case 2: {
            h.intValue = E.int64();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.openmetrics.UnknownValue) return E;
      let e = new $root.openmetrics.UnknownValue();
      return E.doubleValue != null && (e.doubleValue = Number(E.doubleValue)), E.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(E.intValue)).unsigned = !1 : typeof E.intValue == "string" ? e.intValue = parseInt(E.intValue, 10) : typeof E.intValue == "number" ? e.intValue = E.intValue : typeof E.intValue == "object" && (e.intValue = new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber())), e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return E.doubleValue != null && E.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(E.doubleValue) ? String(E.doubleValue) : E.doubleValue, e.oneofs && (t.value = "doubleValue")), E.intValue != null && E.hasOwnProperty("intValue") && (typeof E.intValue == "number" ? t.intValue = e.longs === String ? String(E.intValue) : E.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(E.intValue) : e.longs === Number ? new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber() : E.intValue, e.oneofs && (t.value = "intValue")), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.UnknownValue";
    }, i;
  })(), o.GaugeValue = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null;
    let g;
    return Object.defineProperty(i.prototype, "value", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer.create()), E.doubleValue != null && Object.hasOwnProperty.call(E, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(E.doubleValue), E.intValue != null && Object.hasOwnProperty.call(E, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(E.intValue), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.openmetrics.GaugeValue();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = E.double();
            break;
          }
          case 2: {
            h.intValue = E.int64();
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.openmetrics.GaugeValue) return E;
      let e = new $root.openmetrics.GaugeValue();
      return E.doubleValue != null && (e.doubleValue = Number(E.doubleValue)), E.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(E.intValue)).unsigned = !1 : typeof E.intValue == "string" ? e.intValue = parseInt(E.intValue, 10) : typeof E.intValue == "number" ? e.intValue = E.intValue : typeof E.intValue == "object" && (e.intValue = new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber())), e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return E.doubleValue != null && E.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(E.doubleValue) ? String(E.doubleValue) : E.doubleValue, e.oneofs && (t.value = "doubleValue")), E.intValue != null && E.hasOwnProperty("intValue") && (typeof E.intValue == "number" ? t.intValue = e.longs === String ? String(E.intValue) : E.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(E.intValue) : e.longs === Number ? new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber() : E.intValue, e.oneofs && (t.value = "intValue")), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.GaugeValue";
    }, i;
  })(), o.CounterValue = (function() {
    function i(E) {
      if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null, i.prototype.created = null, i.prototype.exemplar = null;
    let g;
    return Object.defineProperty(i.prototype, "total", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      return e || (e = $Writer.create()), E.doubleValue != null && Object.hasOwnProperty.call(E, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(E.doubleValue), E.intValue != null && Object.hasOwnProperty.call(E, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(E.intValue), E.created != null && Object.hasOwnProperty.call(E, "created") && $root.google.protobuf.Timestamp.encode(E.created, e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), E.exemplar != null && Object.hasOwnProperty.call(E, "exemplar") && $root.openmetrics.Exemplar.encode(E.exemplar, e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.openmetrics.CounterValue();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = E.double();
            break;
          }
          case 2: {
            h.intValue = E.uint64();
            break;
          }
          case 3: {
            h.created = $root.google.protobuf.Timestamp.decode(E, E.uint32());
            break;
          }
          case 4: {
            h.exemplar = $root.openmetrics.Exemplar.decode(E, E.uint32());
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.openmetrics.CounterValue) return E;
      let e = new $root.openmetrics.CounterValue();
      if (E.doubleValue != null && (e.doubleValue = Number(E.doubleValue)), E.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(E.intValue)).unsigned = !0 : typeof E.intValue == "string" ? e.intValue = parseInt(E.intValue, 10) : typeof E.intValue == "number" ? e.intValue = E.intValue : typeof E.intValue == "object" && (e.intValue = new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber(!0))), E.created != null) {
        if (typeof E.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
        e.created = $root.google.protobuf.Timestamp.fromObject(E.created);
      }
      if (E.exemplar != null) {
        if (typeof E.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        e.exemplar = $root.openmetrics.Exemplar.fromObject(E.exemplar);
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.created = null, t.exemplar = null), E.doubleValue != null && E.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(E.doubleValue) ? String(E.doubleValue) : E.doubleValue, e.oneofs && (t.total = "doubleValue")), E.intValue != null && E.hasOwnProperty("intValue") && (typeof E.intValue == "number" ? t.intValue = e.longs === String ? String(E.intValue) : E.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(E.intValue) : e.longs === Number ? new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber(!0) : E.intValue, e.oneofs && (t.total = "intValue")), E.created != null && E.hasOwnProperty("created") && (t.created = $root.google.protobuf.Timestamp.toObject(E.created, e)), E.exemplar != null && E.hasOwnProperty("exemplar") && (t.exemplar = $root.openmetrics.Exemplar.toObject(E.exemplar, e)), t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.CounterValue";
    }, i;
  })(), o.HistogramValue = (function() {
    function i(E) {
      if (this.buckets = [], E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null, i.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, i.prototype.created = null, i.prototype.buckets = $util.emptyArray;
    let g;
    return Object.defineProperty(i.prototype, "sum", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      if (e || (e = $Writer.create()), E.doubleValue != null && Object.hasOwnProperty.call(E, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(E.doubleValue), E.intValue != null && Object.hasOwnProperty.call(E, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(E.intValue), E.count != null && Object.hasOwnProperty.call(E, "count") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(E.count), E.created != null && Object.hasOwnProperty.call(E, "created") && $root.google.protobuf.Timestamp.encode(E.created, e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), E.buckets != null && E.buckets.length) for (let t = 0; t < E.buckets.length; ++t) $root.openmetrics.HistogramValue.Bucket.encode(E.buckets[t], e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.openmetrics.HistogramValue();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = E.double();
            break;
          }
          case 2: {
            h.intValue = E.int64();
            break;
          }
          case 3: {
            h.count = E.uint64();
            break;
          }
          case 4: {
            h.created = $root.google.protobuf.Timestamp.decode(E, E.uint32());
            break;
          }
          case 5: {
            h.buckets && h.buckets.length || (h.buckets = []), h.buckets.push($root.openmetrics.HistogramValue.Bucket.decode(E, E.uint32()));
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.openmetrics.HistogramValue) return E;
      let e = new $root.openmetrics.HistogramValue();
      if (E.doubleValue != null && (e.doubleValue = Number(E.doubleValue)), E.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(E.intValue)).unsigned = !1 : typeof E.intValue == "string" ? e.intValue = parseInt(E.intValue, 10) : typeof E.intValue == "number" ? e.intValue = E.intValue : typeof E.intValue == "object" && (e.intValue = new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber())), E.count != null && ($util.Long ? (e.count = $util.Long.fromValue(E.count)).unsigned = !0 : typeof E.count == "string" ? e.count = parseInt(E.count, 10) : typeof E.count == "number" ? e.count = E.count : typeof E.count == "object" && (e.count = new $util.LongBits(E.count.low >>> 0, E.count.high >>> 0).toNumber(!0))), E.created != null) {
        if (typeof E.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
        e.created = $root.google.protobuf.Timestamp.fromObject(E.created);
      }
      if (E.buckets) {
        if (!Array.isArray(E.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        e.buckets = [];
        for (let t = 0; t < E.buckets.length; ++t) {
          if (typeof E.buckets[t] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          e.buckets[t] = $root.openmetrics.HistogramValue.Bucket.fromObject(E.buckets[t]);
        }
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.buckets = []), e.defaults) {
        if ($util.Long) {
          let n = new $util.Long(0, 0, !0);
          t.count = e.longs === String ? n.toString() : e.longs === Number ? n.toNumber() : n;
        } else t.count = e.longs === String ? "0" : 0;
        t.created = null;
      }
      if (E.doubleValue != null && E.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(E.doubleValue) ? String(E.doubleValue) : E.doubleValue, e.oneofs && (t.sum = "doubleValue")), E.intValue != null && E.hasOwnProperty("intValue") && (typeof E.intValue == "number" ? t.intValue = e.longs === String ? String(E.intValue) : E.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(E.intValue) : e.longs === Number ? new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber() : E.intValue, e.oneofs && (t.sum = "intValue")), E.count != null && E.hasOwnProperty("count") && (typeof E.count == "number" ? t.count = e.longs === String ? String(E.count) : E.count : t.count = e.longs === String ? $util.Long.prototype.toString.call(E.count) : e.longs === Number ? new $util.LongBits(E.count.low >>> 0, E.count.high >>> 0).toNumber(!0) : E.count), E.created != null && E.hasOwnProperty("created") && (t.created = $root.google.protobuf.Timestamp.toObject(E.created, e)), E.buckets && E.buckets.length) {
        t.buckets = [];
        for (let n = 0; n < E.buckets.length; ++n) t.buckets[n] = $root.openmetrics.HistogramValue.Bucket.toObject(E.buckets[n], e);
      }
      return t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.HistogramValue";
    }, i.Bucket = (function() {
      function E(e) {
        if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
      }
      return E.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, E.prototype.upperBound = 0, E.prototype.exemplar = null, E.create = function(e) {
        return new E(e);
      }, E.encode = function(e, t) {
        return t || (t = $Writer.create()), e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(
          /* id 1, wireType 0 =*/
          8
        ).uint64(e.count), e.upperBound != null && Object.hasOwnProperty.call(e, "upperBound") && t.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(e.upperBound), e.exemplar != null && Object.hasOwnProperty.call(e, "exemplar") && $root.openmetrics.Exemplar.encode(e.exemplar, t.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim(), t;
      }, E.decode = function(e, t, n) {
        e instanceof $Reader || (e = $Reader.create(e));
        let h = t === void 0 ? e.len : e.pos + t, d = new $root.openmetrics.HistogramValue.Bucket();
        for (; e.pos < h; ) {
          let k = e.uint32();
          if (k === n) break;
          switch (k >>> 3) {
            case 1: {
              d.count = e.uint64();
              break;
            }
            case 2: {
              d.upperBound = e.double();
              break;
            }
            case 3: {
              d.exemplar = $root.openmetrics.Exemplar.decode(e, e.uint32());
              break;
            }
            default:
              e.skipType(k & 7);
              break;
          }
        }
        return d;
      }, E.fromObject = function(e) {
        if (e instanceof $root.openmetrics.HistogramValue.Bucket) return e;
        let t = new $root.openmetrics.HistogramValue.Bucket();
        if (e.count != null && ($util.Long ? (t.count = $util.Long.fromValue(e.count)).unsigned = !0 : typeof e.count == "string" ? t.count = parseInt(e.count, 10) : typeof e.count == "number" ? t.count = e.count : typeof e.count == "object" && (t.count = new $util.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.upperBound != null && (t.upperBound = Number(e.upperBound)), e.exemplar != null) {
          if (typeof e.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          t.exemplar = $root.openmetrics.Exemplar.fromObject(e.exemplar);
        }
        return t;
      }, E.toObject = function(e, t) {
        t || (t = {});
        let n = {};
        if (t.defaults) {
          if ($util.Long) {
            let h = new $util.Long(0, 0, !0);
            n.count = t.longs === String ? h.toString() : t.longs === Number ? h.toNumber() : h;
          } else n.count = t.longs === String ? "0" : 0;
          n.upperBound = 0, n.exemplar = null;
        }
        return e.count != null && e.hasOwnProperty("count") && (typeof e.count == "number" ? n.count = t.longs === String ? String(e.count) : e.count : n.count = t.longs === String ? $util.Long.prototype.toString.call(e.count) : t.longs === Number ? new $util.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.upperBound != null && e.hasOwnProperty("upperBound") && (n.upperBound = t.json && !isFinite(e.upperBound) ? String(e.upperBound) : e.upperBound), e.exemplar != null && e.hasOwnProperty("exemplar") && (n.exemplar = $root.openmetrics.Exemplar.toObject(e.exemplar, t)), n;
      }, E.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, E.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue.Bucket";
      }, E;
    })(), i;
  })(), o.Exemplar = (function() {
    function i(g) {
      if (this.label = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.value = 0, i.prototype.timestamp = null, i.prototype.label = $util.emptyArray, i.create = function(g) {
      return new i(g);
    }, i.encode = function(g, E) {
      if (E || (E = $Writer.create()), g.value != null && Object.hasOwnProperty.call(g, "value") && E.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(g.value), g.timestamp != null && Object.hasOwnProperty.call(g, "timestamp") && $root.google.protobuf.Timestamp.encode(g.timestamp, E.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), g.label != null && g.label.length) for (let e = 0; e < g.label.length; ++e) $root.openmetrics.Label.encode(g.label[e], E.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim();
      return E;
    }, i.decode = function(g, E, e) {
      g instanceof $Reader || (g = $Reader.create(g));
      let t = E === void 0 ? g.len : g.pos + E, n = new $root.openmetrics.Exemplar();
      for (; g.pos < t; ) {
        let h = g.uint32();
        if (h === e) break;
        switch (h >>> 3) {
          case 1: {
            n.value = g.double();
            break;
          }
          case 2: {
            n.timestamp = $root.google.protobuf.Timestamp.decode(g, g.uint32());
            break;
          }
          case 3: {
            n.label && n.label.length || (n.label = []), n.label.push($root.openmetrics.Label.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, i.fromObject = function(g) {
      if (g instanceof $root.openmetrics.Exemplar) return g;
      let E = new $root.openmetrics.Exemplar();
      if (g.value != null && (E.value = Number(g.value)), g.timestamp != null) {
        if (typeof g.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        E.timestamp = $root.google.protobuf.Timestamp.fromObject(g.timestamp);
      }
      if (g.label) {
        if (!Array.isArray(g.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
        E.label = [];
        for (let e = 0; e < g.label.length; ++e) {
          if (typeof g.label[e] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
          E.label[e] = $root.openmetrics.Label.fromObject(g.label[e]);
        }
      }
      return E;
    }, i.toObject = function(g, E) {
      E || (E = {});
      let e = {};
      if ((E.arrays || E.defaults) && (e.label = []), E.defaults && (e.value = 0, e.timestamp = null), g.value != null && g.hasOwnProperty("value") && (e.value = E.json && !isFinite(g.value) ? String(g.value) : g.value), g.timestamp != null && g.hasOwnProperty("timestamp") && (e.timestamp = $root.google.protobuf.Timestamp.toObject(g.timestamp, E)), g.label && g.label.length) {
        e.label = [];
        for (let t = 0; t < g.label.length; ++t) e.label[t] = $root.openmetrics.Label.toObject(g.label[t], E);
      }
      return e;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Exemplar";
    }, i;
  })(), o.StateSetValue = (function() {
    function i(g) {
      if (this.states = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.states = $util.emptyArray, i.create = function(g) {
      return new i(g);
    }, i.encode = function(g, E) {
      if (E || (E = $Writer.create()), g.states != null && g.states.length) for (let e = 0; e < g.states.length; ++e) $root.openmetrics.StateSetValue.State.encode(g.states[e], E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return E;
    }, i.decode = function(g, E, e) {
      g instanceof $Reader || (g = $Reader.create(g));
      let t = E === void 0 ? g.len : g.pos + E, n = new $root.openmetrics.StateSetValue();
      for (; g.pos < t; ) {
        let h = g.uint32();
        if (h === e) break;
        h >>> 3 === 1 ? (n.states && n.states.length || (n.states = []), n.states.push($root.openmetrics.StateSetValue.State.decode(g, g.uint32()))) : g.skipType(h & 7);
      }
      return n;
    }, i.fromObject = function(g) {
      if (g instanceof $root.openmetrics.StateSetValue) return g;
      let E = new $root.openmetrics.StateSetValue();
      if (g.states) {
        if (!Array.isArray(g.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
        E.states = [];
        for (let e = 0; e < g.states.length; ++e) {
          if (typeof g.states[e] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
          E.states[e] = $root.openmetrics.StateSetValue.State.fromObject(g.states[e]);
        }
      }
      return E;
    }, i.toObject = function(g, E) {
      E || (E = {});
      let e = {};
      if ((E.arrays || E.defaults) && (e.states = []), g.states && g.states.length) {
        e.states = [];
        for (let t = 0; t < g.states.length; ++t) e.states[t] = $root.openmetrics.StateSetValue.State.toObject(g.states[t], E);
      }
      return e;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.StateSetValue";
    }, i.State = (function() {
      function g(E) {
        if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
      }
      return g.prototype.enabled = !1, g.prototype.name = "", g.create = function(E) {
        return new g(E);
      }, g.encode = function(E, e) {
        return e || (e = $Writer.create()), E.enabled != null && Object.hasOwnProperty.call(E, "enabled") && e.uint32(
          /* id 1, wireType 0 =*/
          8
        ).bool(E.enabled), E.name != null && Object.hasOwnProperty.call(E, "name") && e.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(E.name), e;
      }, g.decode = function(E, e, t) {
        E instanceof $Reader || (E = $Reader.create(E));
        let n = e === void 0 ? E.len : E.pos + e, h = new $root.openmetrics.StateSetValue.State();
        for (; E.pos < n; ) {
          let d = E.uint32();
          if (d === t) break;
          switch (d >>> 3) {
            case 1: {
              h.enabled = E.bool();
              break;
            }
            case 2: {
              h.name = E.string();
              break;
            }
            default:
              E.skipType(d & 7);
              break;
          }
        }
        return h;
      }, g.fromObject = function(E) {
        if (E instanceof $root.openmetrics.StateSetValue.State) return E;
        let e = new $root.openmetrics.StateSetValue.State();
        return E.enabled != null && (e.enabled = !!E.enabled), E.name != null && (e.name = String(E.name)), e;
      }, g.toObject = function(E, e) {
        e || (e = {});
        let t = {};
        return e.defaults && (t.enabled = !1, t.name = ""), E.enabled != null && E.hasOwnProperty("enabled") && (t.enabled = E.enabled), E.name != null && E.hasOwnProperty("name") && (t.name = E.name), t;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, g.getTypeUrl = function(E) {
        return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.StateSetValue.State";
      }, g;
    })(), i;
  })(), o.InfoValue = (function() {
    function i(g) {
      if (this.info = [], g) for (let E = Object.keys(g), e = 0; e < E.length; ++e) g[E[e]] != null && (this[E[e]] = g[E[e]]);
    }
    return i.prototype.info = $util.emptyArray, i.create = function(g) {
      return new i(g);
    }, i.encode = function(g, E) {
      if (E || (E = $Writer.create()), g.info != null && g.info.length) for (let e = 0; e < g.info.length; ++e) $root.openmetrics.Label.encode(g.info[e], E.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return E;
    }, i.decode = function(g, E, e) {
      g instanceof $Reader || (g = $Reader.create(g));
      let t = E === void 0 ? g.len : g.pos + E, n = new $root.openmetrics.InfoValue();
      for (; g.pos < t; ) {
        let h = g.uint32();
        if (h === e) break;
        h >>> 3 === 1 ? (n.info && n.info.length || (n.info = []), n.info.push($root.openmetrics.Label.decode(g, g.uint32()))) : g.skipType(h & 7);
      }
      return n;
    }, i.fromObject = function(g) {
      if (g instanceof $root.openmetrics.InfoValue) return g;
      let E = new $root.openmetrics.InfoValue();
      if (g.info) {
        if (!Array.isArray(g.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
        E.info = [];
        for (let e = 0; e < g.info.length; ++e) {
          if (typeof g.info[e] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
          E.info[e] = $root.openmetrics.Label.fromObject(g.info[e]);
        }
      }
      return E;
    }, i.toObject = function(g, E) {
      E || (E = {});
      let e = {};
      if ((E.arrays || E.defaults) && (e.info = []), g.info && g.info.length) {
        e.info = [];
        for (let t = 0; t < g.info.length; ++t) e.info[t] = $root.openmetrics.Label.toObject(g.info[t], E);
      }
      return e;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.InfoValue";
    }, i;
  })(), o.SummaryValue = (function() {
    function i(E) {
      if (this.quantile = [], E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
    }
    i.prototype.doubleValue = null, i.prototype.intValue = null, i.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, i.prototype.created = null, i.prototype.quantile = $util.emptyArray;
    let g;
    return Object.defineProperty(i.prototype, "sum", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), i.create = function(E) {
      return new i(E);
    }, i.encode = function(E, e) {
      if (e || (e = $Writer.create()), E.doubleValue != null && Object.hasOwnProperty.call(E, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(E.doubleValue), E.intValue != null && Object.hasOwnProperty.call(E, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(E.intValue), E.count != null && Object.hasOwnProperty.call(E, "count") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(E.count), E.created != null && Object.hasOwnProperty.call(E, "created") && $root.google.protobuf.Timestamp.encode(E.created, e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), E.quantile != null && E.quantile.length) for (let t = 0; t < E.quantile.length; ++t) $root.openmetrics.SummaryValue.Quantile.encode(E.quantile[t], e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return e;
    }, i.decode = function(E, e, t) {
      E instanceof $Reader || (E = $Reader.create(E));
      let n = e === void 0 ? E.len : E.pos + e, h = new $root.openmetrics.SummaryValue();
      for (; E.pos < n; ) {
        let d = E.uint32();
        if (d === t) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = E.double();
            break;
          }
          case 2: {
            h.intValue = E.int64();
            break;
          }
          case 3: {
            h.count = E.uint64();
            break;
          }
          case 4: {
            h.created = $root.google.protobuf.Timestamp.decode(E, E.uint32());
            break;
          }
          case 5: {
            h.quantile && h.quantile.length || (h.quantile = []), h.quantile.push($root.openmetrics.SummaryValue.Quantile.decode(E, E.uint32()));
            break;
          }
          default:
            E.skipType(d & 7);
            break;
        }
      }
      return h;
    }, i.fromObject = function(E) {
      if (E instanceof $root.openmetrics.SummaryValue) return E;
      let e = new $root.openmetrics.SummaryValue();
      if (E.doubleValue != null && (e.doubleValue = Number(E.doubleValue)), E.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(E.intValue)).unsigned = !1 : typeof E.intValue == "string" ? e.intValue = parseInt(E.intValue, 10) : typeof E.intValue == "number" ? e.intValue = E.intValue : typeof E.intValue == "object" && (e.intValue = new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber())), E.count != null && ($util.Long ? (e.count = $util.Long.fromValue(E.count)).unsigned = !0 : typeof E.count == "string" ? e.count = parseInt(E.count, 10) : typeof E.count == "number" ? e.count = E.count : typeof E.count == "object" && (e.count = new $util.LongBits(E.count.low >>> 0, E.count.high >>> 0).toNumber(!0))), E.created != null) {
        if (typeof E.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
        e.created = $root.google.protobuf.Timestamp.fromObject(E.created);
      }
      if (E.quantile) {
        if (!Array.isArray(E.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        e.quantile = [];
        for (let t = 0; t < E.quantile.length; ++t) {
          if (typeof E.quantile[t] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          e.quantile[t] = $root.openmetrics.SummaryValue.Quantile.fromObject(E.quantile[t]);
        }
      }
      return e;
    }, i.toObject = function(E, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.quantile = []), e.defaults) {
        if ($util.Long) {
          let n = new $util.Long(0, 0, !0);
          t.count = e.longs === String ? n.toString() : e.longs === Number ? n.toNumber() : n;
        } else t.count = e.longs === String ? "0" : 0;
        t.created = null;
      }
      if (E.doubleValue != null && E.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(E.doubleValue) ? String(E.doubleValue) : E.doubleValue, e.oneofs && (t.sum = "doubleValue")), E.intValue != null && E.hasOwnProperty("intValue") && (typeof E.intValue == "number" ? t.intValue = e.longs === String ? String(E.intValue) : E.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(E.intValue) : e.longs === Number ? new $util.LongBits(E.intValue.low >>> 0, E.intValue.high >>> 0).toNumber() : E.intValue, e.oneofs && (t.sum = "intValue")), E.count != null && E.hasOwnProperty("count") && (typeof E.count == "number" ? t.count = e.longs === String ? String(E.count) : E.count : t.count = e.longs === String ? $util.Long.prototype.toString.call(E.count) : e.longs === Number ? new $util.LongBits(E.count.low >>> 0, E.count.high >>> 0).toNumber(!0) : E.count), E.created != null && E.hasOwnProperty("created") && (t.created = $root.google.protobuf.Timestamp.toObject(E.created, e)), E.quantile && E.quantile.length) {
        t.quantile = [];
        for (let n = 0; n < E.quantile.length; ++n) t.quantile[n] = $root.openmetrics.SummaryValue.Quantile.toObject(E.quantile[n], e);
      }
      return t;
    }, i.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, i.getTypeUrl = function(E) {
      return E === void 0 && (E = "type.googleapis.com"), E + "/openmetrics.SummaryValue";
    }, i.Quantile = (function() {
      function E(e) {
        if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && (this[t[n]] = e[t[n]]);
      }
      return E.prototype.quantile = 0, E.prototype.value = 0, E.create = function(e) {
        return new E(e);
      }, E.encode = function(e, t) {
        return t || (t = $Writer.create()), e.quantile != null && Object.hasOwnProperty.call(e, "quantile") && t.uint32(
          /* id 1, wireType 1 =*/
          9
        ).double(e.quantile), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(e.value), t;
      }, E.decode = function(e, t, n) {
        e instanceof $Reader || (e = $Reader.create(e));
        let h = t === void 0 ? e.len : e.pos + t, d = new $root.openmetrics.SummaryValue.Quantile();
        for (; e.pos < h; ) {
          let k = e.uint32();
          if (k === n) break;
          switch (k >>> 3) {
            case 1: {
              d.quantile = e.double();
              break;
            }
            case 2: {
              d.value = e.double();
              break;
            }
            default:
              e.skipType(k & 7);
              break;
          }
        }
        return d;
      }, E.fromObject = function(e) {
        if (e instanceof $root.openmetrics.SummaryValue.Quantile) return e;
        let t = new $root.openmetrics.SummaryValue.Quantile();
        return e.quantile != null && (t.quantile = Number(e.quantile)), e.value != null && (t.value = Number(e.value)), t;
      }, E.toObject = function(e, t) {
        t || (t = {});
        let n = {};
        return t.defaults && (n.quantile = 0, n.value = 0), e.quantile != null && e.hasOwnProperty("quantile") && (n.quantile = t.json && !isFinite(e.quantile) ? String(e.quantile) : e.quantile), e.value != null && e.hasOwnProperty("value") && (n.value = t.json && !isFinite(e.value) ? String(e.value) : e.value), n;
      }, E.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, E.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue.Quantile";
      }, E;
    })(), i;
  })(), o;
})();
$root.google = (() => {
  const o = {};
  return o.protobuf = (function() {
    const i = {};
    return i.Timestamp = (function() {
      function g(E) {
        if (E) for (let e = Object.keys(E), t = 0; t < e.length; ++t) E[e[t]] != null && (this[e[t]] = E[e[t]]);
      }
      return g.prototype.seconds = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, g.prototype.nanos = 0, g.create = function(E) {
        return new g(E);
      }, g.encode = function(E, e) {
        return e || (e = $Writer.create()), E.seconds != null && Object.hasOwnProperty.call(E, "seconds") && e.uint32(
          /* id 1, wireType 0 =*/
          8
        ).int64(E.seconds), E.nanos != null && Object.hasOwnProperty.call(E, "nanos") && e.uint32(
          /* id 2, wireType 0 =*/
          16
        ).int32(E.nanos), e;
      }, g.decode = function(E, e, t) {
        E instanceof $Reader || (E = $Reader.create(E));
        let n = e === void 0 ? E.len : E.pos + e, h = new $root.google.protobuf.Timestamp();
        for (; E.pos < n; ) {
          let d = E.uint32();
          if (d === t) break;
          switch (d >>> 3) {
            case 1: {
              h.seconds = E.int64();
              break;
            }
            case 2: {
              h.nanos = E.int32();
              break;
            }
            default:
              E.skipType(d & 7);
              break;
          }
        }
        return h;
      }, g.fromObject = function(E) {
        if (E instanceof $root.google.protobuf.Timestamp) return E;
        let e = new $root.google.protobuf.Timestamp();
        return E.seconds != null && ($util.Long ? (e.seconds = $util.Long.fromValue(E.seconds)).unsigned = !1 : typeof E.seconds == "string" ? e.seconds = parseInt(E.seconds, 10) : typeof E.seconds == "number" ? e.seconds = E.seconds : typeof E.seconds == "object" && (e.seconds = new $util.LongBits(E.seconds.low >>> 0, E.seconds.high >>> 0).toNumber())), E.nanos != null && (e.nanos = E.nanos | 0), e;
      }, g.toObject = function(E, e) {
        e || (e = {});
        let t = {};
        if (e.defaults) {
          if ($util.Long) {
            let n = new $util.Long(0, 0, !1);
            t.seconds = e.longs === String ? n.toString() : e.longs === Number ? n.toNumber() : n;
          } else t.seconds = e.longs === String ? "0" : 0;
          t.nanos = 0;
        }
        return E.seconds != null && E.hasOwnProperty("seconds") && (typeof E.seconds == "number" ? t.seconds = e.longs === String ? String(E.seconds) : E.seconds : t.seconds = e.longs === String ? $util.Long.prototype.toString.call(E.seconds) : e.longs === Number ? new $util.LongBits(E.seconds.low >>> 0, E.seconds.high >>> 0).toNumber() : E.seconds), E.nanos != null && E.hasOwnProperty("nanos") && (t.nanos = E.nanos), t;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, g.getTypeUrl = function(E) {
        return E === void 0 && (E = "type.googleapis.com"), E + "/google.protobuf.Timestamp";
      }, g;
    })(), i;
  })(), o;
})();
$root.RootContainer = (() => {
  const o = {}, i = Object.create(o);
  return i[o[0] = "MAIN"] = 0, i[o[1] = "SIDEBAR"] = 1, i[o[2] = "EVENT"] = 2, i[o[3] = "BOTTOM"] = 3, i;
})();
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let o, i;
  const g = new Promise((E, e) => {
    o = E, i = e;
  });
  return { resolve: o, reject: i, promise: g };
});
function l$1(o) {
  return typeof structuredClone == "function" ? structuredClone(o) : JSON.parse(JSON.stringify(o));
}
function c$1(o) {
  return Object.freeze(o), Array.isArray(o) ? o.forEach((i) => {
    i !== null && typeof i == "object" && !Object.isFrozen(i) && c$1(i);
  }) : Object.values(o).forEach((i) => {
    i !== null && typeof i == "object" && !Object.isFrozen(i) && c$1(i);
  }), o;
}
(() => {
  const o = window.__streamlit;
  if (!o) return;
  const i = l$1(o);
  return c$1(i);
})();
loglevelExports.getLogger("StaticConnection");
loglevelExports.getLogger("DoInitPings");
loglevelExports.getLogger("ForwardMessageCache");
loglevelExports.getLogger("WebsocketConnection");
loglevelExports.getLogger("ConnectionManager");
loglevelExports.getLogger("DefaultStreamlitEndpoints");
const LOG$a = loglevelExports$1.getLogger("ConnectionManager");
class ConnectionManager {
  props;
  connectionState = ConnectionState$1.INITIAL;
  constructor(i) {
    this.props = i, this.connect();
  }
  /**
   * Indicates whether we're connected to the server.
   */
  isConnected() {
    return this.connectionState === ConnectionState$1.CONNECTED;
  }
  /**
   * Return the BaseUriParts for the server we're connected to,
   * if we are connected to a server.
   */
  getBaseUriParts() {
    if (this.connectionState === ConnectionState$1.CONNECTED) {
      const i = new URL("https://stlite.invalid/");
      return i.pathname = this.props.kernel.basePath, i;
    }
  }
  sendMessage(i) {
    if (this.isConnected()) {
      const g = BackMsg.create(i), E = BackMsg.encode(g).finish();
      this.props.kernel.sendWebSocketMessage(E);
    } else
      LOG$a.error(`Cannot send message when server is disconnected: ${i}`);
  }
  /**
   * Increment the runCount on our message cache, and clear entries
   * whose age is greater than the max.
   */
  incrementMessageCacheRunCount(i, g) {
  }
  getCachedMessageHashes() {
    return [];
  }
  /**
   * Establish either a WebsocketConnection or StaticConnection
   * based on query params.
   */
  async connect() {
    const i = "_stcore/stream";
    try {
      this.props.kernel.onWebSocketMessage((g) => {
        if (typeof g == "string") {
          LOG$a.error("Unexpected payload type.");
          return;
        }
        this.handleMessage(g);
      }), await this.props.kernel.loaded, console.debug("The kernel has been loaded. Start connecting."), this.props.onHostConfigResp(this.props.kernel.hostConfigProperties), await this.props.kernel.connectWebSocket("/" + i), this.setConnectionState(ConnectionState$1.CONNECTED);
    } catch (g) {
      const E = g instanceof Error ? g : new Error(`${g}`);
      LOG$a.error(`Client Error: Websocket connection - ${E.message}`), this.props.sendClientError("Failed to establish websocket connection", E.message, "Connection Manager"), this.setConnectionState(ConnectionState$1.DISCONNECTED_FOREVER, E.message);
    }
  }
  disconnect() {
  }
  setConnectionState = (i, g) => {
    this.connectionState !== i && (this.connectionState = i, this.props.connectionStateChanged(i)), g && this.props.onConnectionError({
      message: g
    });
  };
  // Stlite: the following properties and methods are copied from WebsocketConnection.tsx
  /**
   * To guarantee packet transmission order, this is the index of the last
   * dispatched incoming message.
   */
  lastDispatchedMessageIndex = -1;
  /**
   * And this is the index of the next message we receive.
   */
  nextMessageIndex = 0;
  /**
   * This dictionary stores received messages that we haven't sent out yet
   * (because we're still decoding previous messages)
   */
  messageQueue = {};
  async handleMessage(i) {
    const g = this.nextMessageIndex;
    this.nextMessageIndex += 1;
    const E = new Uint8Array(i), e = ForwardMsg.decode(E);
    if (e.type === "refHash")
      throw new Error("Unexpected cache reference message.");
    for (this.messageQueue[g] = e; this.lastDispatchedMessageIndex + 1 in this.messageQueue; ) {
      const t = this.lastDispatchedMessageIndex + 1;
      this.props.onMessage(this.messageQueue[t]), delete this.messageQueue[t], this.lastDispatchedMessageIndex = t;
    }
  }
}
const MEDIA_ENDPOINT$1 = "/media";
function resolveStliteObjectUrl(o, i) {
  return o.sendHttpRequest({
    method: "GET",
    path: i,
    headers: {},
    body: ""
  }).then(({
    statusCode: g,
    headers: E,
    body: e
  }) => {
    if (g !== 200)
      throw new Error(`Failed to fetch media object: ${g}`);
    const t = E.get("Content-Type"), n = new Blob([e], t ? {
      type: t
    } : void 0);
    return URL.createObjectURL(n);
  });
}
function resolveStliteObjectUrlIfNeeded(o, i) {
  return i.startsWith(MEDIA_ENDPOINT$1) ? resolveStliteObjectUrl(o, i) : Promise.resolve(i);
}
function resolveLogo(o, i) {
  return Promise.all([resolveStliteObjectUrlIfNeeded(o, i.image), resolveStliteObjectUrlIfNeeded(o, i.iconImage)]).then(([g, E]) => ({
    ...i,
    image: g,
    iconImage: E
  }));
}
function useStliteResolvedLogo(o) {
  const i = useStliteKernel(), [g, E] = useState(null);
  return useEffect(() => {
    if (o == null)
      return;
    let e = !1;
    const t = [];
    return resolveLogo(i, o).then((n) => {
      e || (t.push(n.image), t.push(n.iconImage), E(n));
    }), () => {
      t.forEach((n) => {
        URL.revokeObjectURL(n);
      }), e = !0;
    };
  }, [i, o]), g;
}
function useStliteMediaObjectUrl(o) {
  const i = useStliteKernel(), [g, E] = useState(o);
  return useEffect(() => {
    if (i == null || !o.startsWith(MEDIA_ENDPOINT$1))
      return;
    let e = !1;
    const t = [];
    return resolveStliteObjectUrl(i, o).then((n) => {
      e || (t.push(n), E(n));
    }), () => {
      e = !0, t.forEach((n) => {
        URL.revokeObjectURL(n);
      });
    };
  }, [i, o]), g;
}
function useStliteMediaObjects(o) {
  const [i, g] = useState(o.filter((e) => e.url == null || !e.url.startsWith(MEDIA_ENDPOINT$1))), E = useStliteKernel();
  return useEffect(() => {
    if (E == null)
      return;
    let e = !1;
    const t = [], n = o.map((h) => h.url == null || !h.url.startsWith(MEDIA_ENDPOINT$1) ? h : resolveStliteObjectUrl(E, h.url).then((d) => e ? h : (t.push(d), {
      ...h,
      url: d
    })));
    return Promise.all(n).then((h) => {
      e || g(h);
    }), () => {
      e = !0, t.forEach((h) => {
        URL.revokeObjectURL(h);
      });
    };
  }, [E, o]), i;
}
function extractCustomComponentPath(o, i) {
  const g = new URL(i), E = new URL(o, "https://stlite.invalid/");
  if (g.hostname !== E.hostname)
    return null;
  const e = E.pathname.replace(/\/$/, ""), t = new RegExp(`^${e}(/.*?$)`), n = g.pathname.match(t);
  return n == null ? null : n[1] + g.search + g.hash;
}
function getParentPath(o) {
  const i = o.split("/").slice(0, -1).join("/");
  return i.startsWith("/") ? i : "/" + i;
}
function getRelativePath(o, i, g) {
  const E = getParentPath(i);
  if (!(g.host === o && g.pathname.startsWith(E)))
    return null;
  const t = g.pathname.slice(E.length);
  return t.startsWith("/") ? t.slice(1) : t;
}
var lib = {}, activitymonitor = {}, ArrayExt;
(function(o) {
  function i(eA, GA, cA = 0, tA = -1) {
    let aA = eA.length;
    if (aA === 0)
      return -1;
    cA < 0 ? cA = Math.max(0, cA + aA) : cA = Math.min(cA, aA - 1), tA < 0 ? tA = Math.max(0, tA + aA) : tA = Math.min(tA, aA - 1);
    let sA;
    tA < cA ? sA = tA + 1 + (aA - cA) : sA = tA - cA + 1;
    for (let DA = 0; DA < sA; ++DA) {
      let rA = (cA + DA) % aA;
      if (eA[rA] === GA)
        return rA;
    }
    return -1;
  }
  o.firstIndexOf = i;
  function g(eA, GA, cA = -1, tA = 0) {
    let aA = eA.length;
    if (aA === 0)
      return -1;
    cA < 0 ? cA = Math.max(0, cA + aA) : cA = Math.min(cA, aA - 1), tA < 0 ? tA = Math.max(0, tA + aA) : tA = Math.min(tA, aA - 1);
    let sA;
    cA < tA ? sA = cA + 1 + (aA - tA) : sA = cA - tA + 1;
    for (let DA = 0; DA < sA; ++DA) {
      let rA = (cA - DA + aA) % aA;
      if (eA[rA] === GA)
        return rA;
    }
    return -1;
  }
  o.lastIndexOf = g;
  function E(eA, GA, cA = 0, tA = -1) {
    let aA = eA.length;
    if (aA === 0)
      return -1;
    cA < 0 ? cA = Math.max(0, cA + aA) : cA = Math.min(cA, aA - 1), tA < 0 ? tA = Math.max(0, tA + aA) : tA = Math.min(tA, aA - 1);
    let sA;
    tA < cA ? sA = tA + 1 + (aA - cA) : sA = tA - cA + 1;
    for (let DA = 0; DA < sA; ++DA) {
      let rA = (cA + DA) % aA;
      if (GA(eA[rA], rA))
        return rA;
    }
    return -1;
  }
  o.findFirstIndex = E;
  function e(eA, GA, cA = -1, tA = 0) {
    let aA = eA.length;
    if (aA === 0)
      return -1;
    cA < 0 ? cA = Math.max(0, cA + aA) : cA = Math.min(cA, aA - 1), tA < 0 ? tA = Math.max(0, tA + aA) : tA = Math.min(tA, aA - 1);
    let sA;
    cA < tA ? sA = cA + 1 + (aA - tA) : sA = cA - tA + 1;
    for (let DA = 0; DA < sA; ++DA) {
      let rA = (cA - DA + aA) % aA;
      if (GA(eA[rA], rA))
        return rA;
    }
    return -1;
  }
  o.findLastIndex = e;
  function t(eA, GA, cA = 0, tA = -1) {
    let aA = E(eA, GA, cA, tA);
    return aA !== -1 ? eA[aA] : void 0;
  }
  o.findFirstValue = t;
  function n(eA, GA, cA = -1, tA = 0) {
    let aA = e(eA, GA, cA, tA);
    return aA !== -1 ? eA[aA] : void 0;
  }
  o.findLastValue = n;
  function h(eA, GA, cA, tA = 0, aA = -1) {
    let sA = eA.length;
    if (sA === 0)
      return 0;
    tA < 0 ? tA = Math.max(0, tA + sA) : tA = Math.min(tA, sA - 1), aA < 0 ? aA = Math.max(0, aA + sA) : aA = Math.min(aA, sA - 1);
    let DA = tA, rA = aA - tA + 1;
    for (; rA > 0; ) {
      let nA = rA >> 1, NA = DA + nA;
      cA(eA[NA], GA) < 0 ? (DA = NA + 1, rA -= nA + 1) : rA = nA;
    }
    return DA;
  }
  o.lowerBound = h;
  function d(eA, GA, cA, tA = 0, aA = -1) {
    let sA = eA.length;
    if (sA === 0)
      return 0;
    tA < 0 ? tA = Math.max(0, tA + sA) : tA = Math.min(tA, sA - 1), aA < 0 ? aA = Math.max(0, aA + sA) : aA = Math.min(aA, sA - 1);
    let DA = tA, rA = aA - tA + 1;
    for (; rA > 0; ) {
      let nA = rA >> 1, NA = DA + nA;
      cA(eA[NA], GA) > 0 ? rA = nA : (DA = NA + 1, rA -= nA + 1);
    }
    return DA;
  }
  o.upperBound = d;
  function k(eA, GA, cA) {
    if (eA === GA)
      return !0;
    if (eA.length !== GA.length)
      return !1;
    for (let tA = 0, aA = eA.length; tA < aA; ++tA)
      if (cA ? !cA(eA[tA], GA[tA]) : eA[tA] !== GA[tA])
        return !1;
    return !0;
  }
  o.shallowEqual = k;
  function p(eA, GA = {}) {
    let { start: cA, stop: tA, step: aA } = GA;
    if (aA === void 0 && (aA = 1), aA === 0)
      throw new Error("Slice `step` cannot be zero.");
    let sA = eA.length;
    cA === void 0 ? cA = aA < 0 ? sA - 1 : 0 : cA < 0 ? cA = Math.max(cA + sA, aA < 0 ? -1 : 0) : cA >= sA && (cA = aA < 0 ? sA - 1 : sA), tA === void 0 ? tA = aA < 0 ? -1 : sA : tA < 0 ? tA = Math.max(tA + sA, aA < 0 ? -1 : 0) : tA >= sA && (tA = aA < 0 ? sA - 1 : sA);
    let DA;
    aA < 0 && tA >= cA || aA > 0 && cA >= tA ? DA = 0 : aA < 0 ? DA = Math.floor((tA - cA + 1) / aA + 1) : DA = Math.floor((tA - cA - 1) / aA + 1);
    let rA = [];
    for (let nA = 0; nA < DA; ++nA)
      rA[nA] = eA[cA + nA * aA];
    return rA;
  }
  o.slice = p;
  function M(eA, GA, cA) {
    let tA = eA.length;
    if (tA <= 1 || (GA < 0 ? GA = Math.max(0, GA + tA) : GA = Math.min(GA, tA - 1), cA < 0 ? cA = Math.max(0, cA + tA) : cA = Math.min(cA, tA - 1), GA === cA))
      return;
    let aA = eA[GA], sA = GA < cA ? 1 : -1;
    for (let DA = GA; DA !== cA; DA += sA)
      eA[DA] = eA[DA + sA];
    eA[cA] = aA;
  }
  o.move = M;
  function H(eA, GA = 0, cA = -1) {
    let tA = eA.length;
    if (!(tA <= 1))
      for (GA < 0 ? GA = Math.max(0, GA + tA) : GA = Math.min(GA, tA - 1), cA < 0 ? cA = Math.max(0, cA + tA) : cA = Math.min(cA, tA - 1); GA < cA; ) {
        let aA = eA[GA], sA = eA[cA];
        eA[GA++] = sA, eA[cA--] = aA;
      }
  }
  o.reverse = H;
  function f(eA, GA, cA = 0, tA = -1) {
    let aA = eA.length;
    if (aA <= 1 || (cA < 0 ? cA = Math.max(0, cA + aA) : cA = Math.min(cA, aA - 1), tA < 0 ? tA = Math.max(0, tA + aA) : tA = Math.min(tA, aA - 1), cA >= tA))
      return;
    let sA = tA - cA + 1;
    if (GA > 0 ? GA = GA % sA : GA < 0 && (GA = (GA % sA + sA) % sA), GA === 0)
      return;
    let DA = cA + GA;
    H(eA, cA, DA - 1), H(eA, DA, tA), H(eA, cA, tA);
  }
  o.rotate = f;
  function AA(eA, GA, cA = 0, tA = -1) {
    let aA = eA.length;
    if (aA === 0)
      return;
    cA < 0 ? cA = Math.max(0, cA + aA) : cA = Math.min(cA, aA - 1), tA < 0 ? tA = Math.max(0, tA + aA) : tA = Math.min(tA, aA - 1);
    let sA;
    tA < cA ? sA = tA + 1 + (aA - cA) : sA = tA - cA + 1;
    for (let DA = 0; DA < sA; ++DA)
      eA[(cA + DA) % aA] = GA;
  }
  o.fill = AA;
  function gA(eA, GA, cA) {
    let tA = eA.length;
    GA < 0 ? GA = Math.max(0, GA + tA) : GA = Math.min(GA, tA);
    for (let aA = tA; aA > GA; --aA)
      eA[aA] = eA[aA - 1];
    eA[GA] = cA;
  }
  o.insert = gA;
  function IA(eA, GA) {
    let cA = eA.length;
    if (GA < 0 && (GA += cA), GA < 0 || GA >= cA)
      return;
    let tA = eA[GA];
    for (let aA = GA + 1; aA < cA; ++aA)
      eA[aA - 1] = eA[aA];
    return eA.length = cA - 1, tA;
  }
  o.removeAt = IA;
  function BA(eA, GA, cA = 0, tA = -1) {
    let aA = i(eA, GA, cA, tA);
    return aA !== -1 && IA(eA, aA), aA;
  }
  o.removeFirstOf = BA;
  function CA(eA, GA, cA = -1, tA = 0) {
    let aA = g(eA, GA, cA, tA);
    return aA !== -1 && IA(eA, aA), aA;
  }
  o.removeLastOf = CA;
  function QA(eA, GA, cA = 0, tA = -1) {
    let aA = eA.length;
    if (aA === 0)
      return 0;
    cA < 0 ? cA = Math.max(0, cA + aA) : cA = Math.min(cA, aA - 1), tA < 0 ? tA = Math.max(0, tA + aA) : tA = Math.min(tA, aA - 1);
    let sA = 0;
    for (let DA = 0; DA < aA; ++DA)
      cA <= tA && DA >= cA && DA <= tA && eA[DA] === GA || tA < cA && (DA <= tA || DA >= cA) && eA[DA] === GA ? sA++ : sA > 0 && (eA[DA - sA] = eA[DA]);
    return sA > 0 && (eA.length = aA - sA), sA;
  }
  o.removeAllOf = QA;
  function iA(eA, GA, cA = 0, tA = -1) {
    let aA, sA = E(eA, GA, cA, tA);
    return sA !== -1 && (aA = IA(eA, sA)), { index: sA, value: aA };
  }
  o.removeFirstWhere = iA;
  function EA(eA, GA, cA = -1, tA = 0) {
    let aA, sA = e(eA, GA, cA, tA);
    return sA !== -1 && (aA = IA(eA, sA)), { index: sA, value: aA };
  }
  o.removeLastWhere = EA;
  function oA(eA, GA, cA = 0, tA = -1) {
    let aA = eA.length;
    if (aA === 0)
      return 0;
    cA < 0 ? cA = Math.max(0, cA + aA) : cA = Math.min(cA, aA - 1), tA < 0 ? tA = Math.max(0, tA + aA) : tA = Math.min(tA, aA - 1);
    let sA = 0;
    for (let DA = 0; DA < aA; ++DA)
      cA <= tA && DA >= cA && DA <= tA && GA(eA[DA], DA) || tA < cA && (DA <= tA || DA >= cA) && GA(eA[DA], DA) ? sA++ : sA > 0 && (eA[DA - sA] = eA[DA]);
    return sA > 0 && (eA.length = aA - sA), sA;
  }
  o.removeAllWhere = oA;
})(ArrayExt || (ArrayExt = {}));
function* chain(...o) {
  for (const i of o)
    yield* i;
}
function* empty() {
}
function* enumerate(o, i = 0) {
  for (const g of o)
    yield [i++, g];
}
function* filter$1(o, i) {
  let g = 0;
  for (const E of o)
    i(E, g++) && (yield E);
}
function find(o, i) {
  let g = 0;
  for (const E of o)
    if (i(E, g++))
      return E;
}
function findIndex(o, i) {
  let g = 0;
  for (const E of o)
    if (i(E, g++))
      return g - 1;
  return -1;
}
function min(o, i) {
  let g;
  for (const E of o) {
    if (g === void 0) {
      g = E;
      continue;
    }
    i(E, g) < 0 && (g = E);
  }
  return g;
}
function max(o, i) {
  let g;
  for (const E of o) {
    if (g === void 0) {
      g = E;
      continue;
    }
    i(E, g) > 0 && (g = E);
  }
  return g;
}
function minmax(o, i) {
  let g = !0, E, e;
  for (const t of o)
    g ? (E = t, e = t, g = !1) : i(t, E) < 0 ? E = t : i(t, e) > 0 && (e = t);
  return g ? void 0 : [E, e];
}
function toArray$1(o) {
  return Array.from(o);
}
function toObject(o) {
  const i = {};
  for (const [g, E] of o)
    i[g] = E;
  return i;
}
function each(o, i) {
  let g = 0;
  for (const E of o)
    if (i(E, g++) === !1)
      return;
}
function every(o, i) {
  let g = 0;
  for (const E of o)
    if (i(E, g++) === !1)
      return !1;
  return !0;
}
function some(o, i) {
  let g = 0;
  for (const E of o)
    if (i(E, g++))
      return !0;
  return !1;
}
function* map(o, i) {
  let g = 0;
  for (const E of o)
    yield i(E, g++);
}
function* range(o, i, g) {
  i === void 0 ? (i = o, o = 0, g = 1) : g === void 0 && (g = 1);
  const E = Private$2.rangeLength(o, i, g);
  for (let e = 0; e < E; e++)
    yield o + g * e;
}
var Private$2;
(function(o) {
  function i(g, E, e) {
    return e === 0 ? 1 / 0 : g > E && e > 0 || g < E && e < 0 ? 0 : Math.ceil((E - g) / e);
  }
  o.rangeLength = i;
})(Private$2 || (Private$2 = {}));
function reduce(o, i, g) {
  const E = o[Symbol.iterator]();
  let e = 0, t = E.next();
  if (t.done && g === void 0)
    throw new TypeError("Reduce of empty iterable with no initial value.");
  if (t.done)
    return g;
  let n = E.next();
  if (n.done && g === void 0)
    return t.value;
  if (n.done)
    return i(g, t.value, e++);
  let h;
  g === void 0 ? h = i(t.value, n.value, e++) : h = i(i(g, t.value, e++), n.value, e++);
  let d;
  for (; !(d = E.next()).done; )
    h = i(h, d.value, e++);
  return h;
}
function* repeat(o, i) {
  for (; 0 < i--; )
    yield o;
}
function* once(o) {
  yield o;
}
function* retro(o) {
  if (typeof o.retro == "function")
    yield* o.retro();
  else
    for (let i = o.length - 1; i > -1; i--)
      yield o[i];
}
function topologicSort(o) {
  let i = [], g = /* @__PURE__ */ new Set(), E = /* @__PURE__ */ new Map();
  for (const n of o)
    e(n);
  for (const [n] of E)
    t(n);
  return i;
  function e(n) {
    let [h, d] = n, k = E.get(d);
    k ? k.push(h) : E.set(d, [h]);
  }
  function t(n) {
    if (g.has(n))
      return;
    g.add(n);
    let h = E.get(n);
    if (h)
      for (const d of h)
        t(d);
    i.push(n);
  }
}
function* stride(o, i) {
  let g = 0;
  for (const E of o)
    g++ % i === 0 && (yield E);
}
var StringExt;
(function(o) {
  function i(n, h, d = 0) {
    let k = new Array(h.length);
    for (let p = 0, M = d, H = h.length; p < H; ++p, ++M) {
      if (M = n.indexOf(h[p], M), M === -1)
        return null;
      k[p] = M;
    }
    return k;
  }
  o.findIndices = i;
  function g(n, h, d = 0) {
    let k = i(n, h, d);
    if (!k)
      return null;
    let p = 0;
    for (let M = 0, H = k.length; M < H; ++M) {
      let f = k[M] - d;
      p += f * f;
    }
    return { score: p, indices: k };
  }
  o.matchSumOfSquares = g;
  function E(n, h, d = 0) {
    let k = i(n, h, d);
    if (!k)
      return null;
    let p = 0, M = d - 1;
    for (let H = 0, f = k.length; H < f; ++H) {
      let AA = k[H];
      p += AA - M - 1, M = AA;
    }
    return { score: p, indices: k };
  }
  o.matchSumOfDeltas = E;
  function e(n, h, d) {
    let k = [], p = 0, M = 0, H = h.length;
    for (; p < H; ) {
      let f = h[p], AA = h[p];
      for (; ++p < H && h[p] === AA + 1; )
        AA++;
      M < f && k.push(n.slice(M, f)), f < AA + 1 && k.push(d(n.slice(f, AA + 1))), M = AA + 1;
    }
    return M < n.length && k.push(n.slice(M)), k;
  }
  o.highlight = e;
  function t(n, h) {
    return n < h ? -1 : n > h ? 1 : 0;
  }
  o.cmp = t;
})(StringExt || (StringExt = {}));
function* take(o, i) {
  if (i < 1)
    return;
  const g = o[Symbol.iterator]();
  let E;
  for (; 0 < i-- && !(E = g.next()).done; )
    yield E.value;
}
function* zip(...o) {
  const i = o.map((E) => E[Symbol.iterator]());
  let g = i.map((E) => E.next());
  for (; every(g, (E) => !E.done); g = i.map((E) => E.next()))
    yield g.map((E) => E.value);
}
const index_es6$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ArrayExt() {
    return ArrayExt;
  },
  get StringExt() {
    return StringExt;
  },
  chain,
  each,
  empty,
  enumerate,
  every,
  filter: filter$1,
  find,
  findIndex,
  map,
  max,
  min,
  minmax,
  once,
  range,
  reduce,
  repeat,
  retro,
  some,
  stride,
  take,
  toArray: toArray$1,
  toObject,
  topologicSort,
  zip
}, Symbol.toStringTag, { value: "Module" }));
var JSONExt;
(function(o) {
  o.emptyObject = Object.freeze({}), o.emptyArray = Object.freeze([]);
  function i(p) {
    return p === null || typeof p == "boolean" || typeof p == "number" || typeof p == "string";
  }
  o.isPrimitive = i;
  function g(p) {
    return Array.isArray(p);
  }
  o.isArray = g;
  function E(p) {
    return !i(p) && !g(p);
  }
  o.isObject = E;
  function e(p, M) {
    if (p === M)
      return !0;
    if (i(p) || i(M))
      return !1;
    let H = g(p), f = g(M);
    return H !== f ? !1 : H && f ? n(p, M) : h(p, M);
  }
  o.deepEqual = e;
  function t(p) {
    return i(p) ? p : g(p) ? d(p) : k(p);
  }
  o.deepCopy = t;
  function n(p, M) {
    if (p === M)
      return !0;
    if (p.length !== M.length)
      return !1;
    for (let H = 0, f = p.length; H < f; ++H)
      if (!e(p[H], M[H]))
        return !1;
    return !0;
  }
  function h(p, M) {
    if (p === M)
      return !0;
    for (let H in p)
      if (p[H] !== void 0 && !(H in M))
        return !1;
    for (let H in M)
      if (M[H] !== void 0 && !(H in p))
        return !1;
    for (let H in p) {
      let f = p[H], AA = M[H];
      if (!(f === void 0 && AA === void 0) && (f === void 0 || AA === void 0 || !e(f, AA)))
        return !1;
    }
    return !0;
  }
  function d(p) {
    let M = new Array(p.length);
    for (let H = 0, f = p.length; H < f; ++H)
      M[H] = t(p[H]);
    return M;
  }
  function k(p) {
    let M = {};
    for (let H in p) {
      let f = p[H];
      f !== void 0 && (M[H] = t(f));
    }
    return M;
  }
})(JSONExt || (JSONExt = {}));
var Private$1;
(function(o) {
  class i {
    constructor(h) {
      var d, k, p, M;
      this._activated = !1, this._promise = null, this._service = null, this.id = h.id, this.description = (d = h.description) !== null && d !== void 0 ? d : "", this.activate = h.activate, this.deactivate = (k = h.deactivate) !== null && k !== void 0 ? k : null, this.provides = (p = h.provides) !== null && p !== void 0 ? p : null, this.autoStart = (M = h.autoStart) !== null && M !== void 0 ? M : !1, this.requires = h.requires ? h.requires.slice() : [], this.optional = h.optional ? h.optional.slice() : [];
    }
    /**
     * Whether the plugin has been activated.
     */
    get activated() {
      return this._activated;
    }
    set activated(h) {
      this._activated = h;
    }
    /**
     * The resolved service for the plugin, or `null`.
     */
    get service() {
      return this._service;
    }
    set service(h) {
      this._service = h;
    }
    /**
     * The pending resolver promise, or `null`.
     */
    get promise() {
      return this._promise;
    }
    set promise(h) {
      this._promise = h;
    }
  }
  function g(n) {
    return new i(n);
  }
  o.createPluginData = g;
  function E(n, h, d) {
    const k = [...n.requires, ...n.optional], p = (H) => {
      if (H === n.provides)
        return !0;
      const f = d.get(H);
      if (!f)
        return !1;
      const AA = h.get(f), gA = [...AA.requires, ...AA.optional];
      return gA.length === 0 ? !1 : (M.push(f), gA.some(p) ? !0 : (M.pop(), !1));
    };
    if (!n.provides || k.length === 0)
      return;
    const M = [n.id];
    if (k.some(p))
      throw new ReferenceError(`Cycle detected: ${M.join(" -> ")}.`);
  }
  o.ensureNoCycle = E;
  function e(n, h, d) {
    const k = new Array(), p = (gA) => {
      const IA = h.get(gA), BA = [...IA.requires, ...IA.optional];
      k.push(...BA.reduce((CA, QA) => {
        const iA = d.get(QA);
        return iA && CA.push([gA, iA]), CA;
      }, []));
    };
    for (const gA of h.keys())
      p(gA);
    const M = k.filter((gA) => gA[1] === n);
    let H = 0;
    for (; M.length > H; ) {
      const gA = M.length, IA = new Set(M.map((BA) => BA[0]));
      for (const BA of IA)
        k.filter((CA) => CA[1] === BA).forEach((CA) => {
          M.includes(CA) || M.push(CA);
        });
      H = gA;
    }
    const f = topologicSort(M), AA = f.findIndex((gA) => gA === n);
    return AA === -1 ? [n] : f.slice(0, AA + 1);
  }
  o.findDependents = e;
  function t(n, h) {
    const d = /* @__PURE__ */ new Set();
    for (const k of n.keys())
      n.get(k).autoStart === !0 && d.add(k);
    if (h.startPlugins)
      for (const k of h.startPlugins)
        d.add(k);
    if (h.ignorePlugins)
      for (const k of h.ignorePlugins)
        d.delete(k);
    return Array.from(d);
  }
  o.collectStartupPlugins = t;
})(Private$1 || (Private$1 = {}));
let PromiseDelegate$1 = class {
  /**
   * Construct a new promise delegate.
   */
  constructor() {
    this.promise = new Promise((i, g) => {
      this._resolve = i, this._reject = g;
    });
  }
  /**
   * Resolve the wrapped promise with the given value.
   *
   * @param value - The value to use for resolving the promise.
   */
  resolve(i) {
    let g = this._resolve;
    g(i);
  }
  /**
   * Reject the wrapped promise with the given value.
   *
   * @reason - The reason for rejecting the promise.
   */
  reject(i) {
    let g = this._reject;
    g(i);
  }
};
function fallbackRandomValues(o) {
  let i = 0;
  for (let g = 0, E = o.length; g < E; ++g)
    g % 4 === 0 && (i = Math.random() * 4294967295 >>> 0), o[g] = i & 255, i >>>= 8;
}
var Random;
(function(o) {
  o.getRandomValues = (() => {
    const i = typeof window < "u" && (window.crypto || window.msCrypto) || null;
    return i && typeof i.getRandomValues == "function" ? function(E) {
      return i.getRandomValues(E);
    } : fallbackRandomValues;
  })();
})(Random || (Random = {}));
function uuid4Factory(o) {
  const i = new Uint8Array(16), g = new Array(256);
  for (let E = 0; E < 16; ++E)
    g[E] = "0" + E.toString(16);
  for (let E = 16; E < 256; ++E)
    g[E] = E.toString(16);
  return function() {
    return o(i), i[6] = 64 | i[6] & 15, i[8] = 128 | i[8] & 63, g[i[0]] + g[i[1]] + g[i[2]] + g[i[3]] + "-" + g[i[4]] + g[i[5]] + "-" + g[i[6]] + g[i[7]] + "-" + g[i[8]] + g[i[9]] + "-" + g[i[10]] + g[i[11]] + g[i[12]] + g[i[13]] + g[i[14]] + g[i[15]];
  };
}
var UUID;
(function(o) {
  o.uuid4 = uuid4Factory(Random.getRandomValues);
})(UUID || (UUID = {}));
let Signal$1 = class {
  /**
   * Construct a new signal.
   *
   * @param sender - The sender which owns the signal.
   */
  constructor(i) {
    this.sender = i;
  }
  /**
   * Connect a slot to the signal.
   *
   * @param slot - The slot to invoke when the signal is emitted.
   *
   * @param thisArg - The `this` context for the slot. If provided,
   *   this must be a non-primitive object.
   *
   * @returns `true` if the connection succeeds, `false` otherwise.
   */
  connect(i, g) {
    return Private.connect(this, i, g);
  }
  /**
   * Disconnect a slot from the signal.
   *
   * @param slot - The slot to disconnect from the signal.
   *
   * @param thisArg - The `this` context for the slot. If provided,
   *   this must be a non-primitive object.
   *
   * @returns `true` if the connection is removed, `false` otherwise.
   */
  disconnect(i, g) {
    return Private.disconnect(this, i, g);
  }
  /**
   * Emit the signal and invoke the connected slots.
   *
   * @param args - The args to pass to the connected slots.
   *
   * #### Notes
   * Slots are invoked synchronously in connection order.
   *
   * Exceptions thrown by connected slots will be caught and logged.
   */
  emit(i) {
    Private.emit(this, i);
  }
};
(function(o) {
  function i(d, k) {
    Private.disconnectBetween(d, k);
  }
  o.disconnectBetween = i;
  function g(d) {
    Private.disconnectSender(d);
  }
  o.disconnectSender = g;
  function E(d) {
    Private.disconnectReceiver(d);
  }
  o.disconnectReceiver = E;
  function e(d) {
    Private.disconnectAll(d);
  }
  o.disconnectAll = e;
  function t(d) {
    Private.disconnectAll(d);
  }
  o.clearData = t;
  function n() {
    return Private.exceptionHandler;
  }
  o.getExceptionHandler = n;
  function h(d) {
    let k = Private.exceptionHandler;
    return Private.exceptionHandler = d, k;
  }
  o.setExceptionHandler = h;
})(Signal$1 || (Signal$1 = {}));
class Stream extends Signal$1 {
  constructor() {
    super(...arguments), this._pending = new PromiseDelegate$1();
  }
  /**
   * Return an async iterator that yields every emission.
   */
  async *[Symbol.asyncIterator]() {
    let i = this._pending;
    for (; ; )
      try {
        const { args: g, next: E } = await i.promise;
        i = E, yield g;
      } catch {
        return;
      }
  }
  /**
   * Emit the signal, invoke the connected slots, and yield the emission.
   *
   * @param args - The args to pass to the connected slots.
   */
  emit(i) {
    const g = this._pending, E = this._pending = new PromiseDelegate$1();
    g.resolve({ args: i, next: E }), super.emit(i);
  }
  /**
   * Stop the stream's async iteration.
   */
  stop() {
    this._pending.promise.catch(() => {
    }), this._pending.reject("stop"), this._pending = new PromiseDelegate$1();
  }
}
var Private;
(function(o) {
  o.exceptionHandler = (CA) => {
    console.error(CA);
  };
  function i(CA, QA, iA) {
    iA = iA || void 0;
    let EA = d.get(CA.sender);
    if (EA || (EA = [], d.set(CA.sender, EA)), H(EA, CA, QA, iA))
      return !1;
    let oA = iA || QA, eA = k.get(oA);
    eA || (eA = [], k.set(oA, eA));
    let GA = { signal: CA, slot: QA, thisArg: iA };
    return EA.push(GA), eA.push(GA), !0;
  }
  o.connect = i;
  function g(CA, QA, iA) {
    iA = iA || void 0;
    let EA = d.get(CA.sender);
    if (!EA || EA.length === 0)
      return !1;
    let oA = H(EA, CA, QA, iA);
    if (!oA)
      return !1;
    let eA = iA || QA, GA = k.get(eA);
    return oA.signal = null, AA(EA), AA(GA), !0;
  }
  o.disconnect = g;
  function E(CA, QA) {
    let iA = d.get(CA);
    if (!iA || iA.length === 0)
      return;
    let EA = k.get(QA);
    if (!(!EA || EA.length === 0)) {
      for (const oA of EA)
        oA.signal && oA.signal.sender === CA && (oA.signal = null);
      AA(iA), AA(EA);
    }
  }
  o.disconnectBetween = E;
  function e(CA) {
    let QA = d.get(CA);
    if (!(!QA || QA.length === 0)) {
      for (const iA of QA) {
        if (!iA.signal)
          continue;
        let EA = iA.thisArg || iA.slot;
        iA.signal = null, AA(k.get(EA));
      }
      AA(QA);
    }
  }
  o.disconnectSender = e;
  function t(CA) {
    let QA = k.get(CA);
    if (!(!QA || QA.length === 0)) {
      for (const iA of QA) {
        if (!iA.signal)
          continue;
        let EA = iA.signal.sender;
        iA.signal = null, AA(d.get(EA));
      }
      AA(QA);
    }
  }
  o.disconnectReceiver = t;
  function n(CA) {
    e(CA), t(CA);
  }
  o.disconnectAll = n;
  function h(CA, QA) {
    let iA = d.get(CA.sender);
    if (!(!iA || iA.length === 0))
      for (let EA = 0, oA = iA.length; EA < oA; ++EA) {
        let eA = iA[EA];
        eA.signal === CA && f(eA, QA);
      }
  }
  o.emit = h;
  const d = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new Set(), M = typeof requestAnimationFrame == "function" ? requestAnimationFrame : setImmediate;
  function H(CA, QA, iA, EA) {
    return find(CA, (oA) => oA.signal === QA && oA.slot === iA && oA.thisArg === EA);
  }
  function f(CA, QA) {
    let { signal: iA, slot: EA, thisArg: oA } = CA;
    try {
      EA.call(oA, iA.sender, QA);
    } catch (eA) {
      o.exceptionHandler(eA);
    }
  }
  function AA(CA) {
    p.size === 0 && M(gA), p.add(CA);
  }
  function gA() {
    p.forEach(IA), p.clear();
  }
  function IA(CA) {
    ArrayExt.removeAllWhere(CA, BA);
  }
  function BA(CA) {
    return CA.signal === null;
  }
})(Private || (Private = {}));
const index_es6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get Signal() {
    return Signal$1;
  },
  Stream
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(index_es6);
var hasRequiredActivitymonitor;
function requireActivitymonitor() {
  if (hasRequiredActivitymonitor) return activitymonitor;
  hasRequiredActivitymonitor = 1, Object.defineProperty(activitymonitor, "__esModule", { value: !0 }), activitymonitor.ActivityMonitor = void 0;
  const o = require$$0$2;
  class i {
    /**
     * Construct a new activity monitor.
     */
    constructor(E) {
      this._timer = -1, this._timeout = -1, this._isDisposed = !1, this._activityStopped = new o.Signal(this), E.signal.connect(this._onSignalFired, this), this._timeout = E.timeout || 1e3;
    }
    /**
     * A signal emitted when activity has ceased.
     */
    get activityStopped() {
      return this._activityStopped;
    }
    /**
     * The timeout associated with the monitor, in milliseconds.
     */
    get timeout() {
      return this._timeout;
    }
    set timeout(E) {
      this._timeout = E;
    }
    /**
     * Test whether the monitor has been disposed.
     *
     * #### Notes
     * This is a read-only property.
     */
    get isDisposed() {
      return this._isDisposed;
    }
    /**
     * Dispose of the resources used by the activity monitor.
     */
    dispose() {
      this._isDisposed || (this._isDisposed = !0, o.Signal.clearData(this));
    }
    /**
     * A signal handler for the monitored signal.
     */
    _onSignalFired(E, e) {
      clearTimeout(this._timer), this._sender = E, this._args = e, this._timer = setTimeout(() => {
        this._activityStopped.emit({
          sender: this._sender,
          args: this._args
        });
      }, this._timeout);
    }
  }
  return activitymonitor.ActivityMonitor = i, activitymonitor;
}
var interfaces = {}, hasRequiredInterfaces;
function requireInterfaces() {
  return hasRequiredInterfaces || (hasRequiredInterfaces = 1, Object.defineProperty(interfaces, "__esModule", { value: !0 })), interfaces;
}
var lru = {}, hasRequiredLru;
function requireLru() {
  if (hasRequiredLru) return lru;
  hasRequiredLru = 1, Object.defineProperty(lru, "__esModule", { value: !0 }), lru.LruCache = void 0;
  const o = 128;
  class i {
    constructor(E = {}) {
      this._map = /* @__PURE__ */ new Map(), this._maxSize = E?.maxSize || o;
    }
    /**
     * Return the current size of the cache.
     */
    get size() {
      return this._map.size;
    }
    /**
     * Clear the values in the cache.
     */
    clear() {
      this._map.clear();
    }
    /**
     * Get a value (or null) from the cache, pushing the item to the front of the cache.
     */
    get(E) {
      const e = this._map.get(E) || null;
      return e != null && (this._map.delete(E), this._map.set(E, e)), e;
    }
    /**
     * Set a value in the cache, potentially evicting an old item.
     */
    set(E, e) {
      this._map.size >= this._maxSize && this._map.delete(this._map.keys().next().value), this._map.set(E, e);
    }
  }
  return lru.LruCache = i, lru;
}
var markdowncodeblocks = {}, hasRequiredMarkdowncodeblocks;
function requireMarkdowncodeblocks() {
  if (hasRequiredMarkdowncodeblocks) return markdowncodeblocks;
  hasRequiredMarkdowncodeblocks = 1, Object.defineProperty(markdowncodeblocks, "__esModule", { value: !0 }), markdowncodeblocks.MarkdownCodeBlocks = void 0;
  var o;
  return (function(i) {
    i.CODE_BLOCK_MARKER = "```";
    const g = [
      ".markdown",
      ".mdown",
      ".mkdn",
      ".md",
      ".mkd",
      ".mdwn",
      ".mdtxt",
      ".mdtext",
      ".text",
      ".txt",
      ".Rmd"
    ];
    class E {
      constructor(h) {
        this.startLine = h, this.code = "", this.endLine = -1;
      }
    }
    i.MarkdownCodeBlock = E;
    function e(n) {
      return g.indexOf(n) > -1;
    }
    i.isMarkdown = e;
    function t(n) {
      if (!n || n === "")
        return [];
      const h = n.split(`
`), d = [];
      let k = null;
      for (let p = 0; p < h.length; p++) {
        const M = h[p], H = M.indexOf(i.CODE_BLOCK_MARKER) === 0, f = k != null;
        if (!(!H && !f))
          if (f)
            k && (H ? (k.endLine = p - 1, d.push(k), k = null) : k.code += M + `
`);
          else {
            k = new E(p);
            const AA = M.indexOf(i.CODE_BLOCK_MARKER), gA = M.lastIndexOf(i.CODE_BLOCK_MARKER);
            AA !== gA && (k.code = M.substring(AA + i.CODE_BLOCK_MARKER.length, gA), k.endLine = p, d.push(k), k = null);
          }
      }
      return d;
    }
    i.findMarkdownCodeBlocks = t;
  })(o || (markdowncodeblocks.MarkdownCodeBlocks = o = {})), markdowncodeblocks;
}
var pageconfig = {}, dist$2 = { exports: {} };
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(index_es6$1);
var dist$1 = dist$2.exports, hasRequiredDist$1;
function requireDist$1() {
  return hasRequiredDist$1 || (hasRequiredDist$1 = 1, (function(o, i) {
    (function(g, E) {
      E(i, require$$0$1);
    })(dist$1, (function(g, E) {
      g.JSONExt = void 0, (function(M) {
        M.emptyObject = Object.freeze({}), M.emptyArray = Object.freeze([]);
        function H(EA) {
          return EA === null || typeof EA == "boolean" || typeof EA == "number" || typeof EA == "string";
        }
        M.isPrimitive = H;
        function f(EA) {
          return Array.isArray(EA);
        }
        M.isArray = f;
        function AA(EA) {
          return !H(EA) && !f(EA);
        }
        M.isObject = AA;
        function gA(EA, oA) {
          if (EA === oA)
            return !0;
          if (H(EA) || H(oA))
            return !1;
          let eA = f(EA), GA = f(oA);
          return eA !== GA ? !1 : eA && GA ? BA(EA, oA) : CA(EA, oA);
        }
        M.deepEqual = gA;
        function IA(EA) {
          return H(EA) ? EA : f(EA) ? QA(EA) : iA(EA);
        }
        M.deepCopy = IA;
        function BA(EA, oA) {
          if (EA === oA)
            return !0;
          if (EA.length !== oA.length)
            return !1;
          for (let eA = 0, GA = EA.length; eA < GA; ++eA)
            if (!gA(EA[eA], oA[eA]))
              return !1;
          return !0;
        }
        function CA(EA, oA) {
          if (EA === oA)
            return !0;
          for (let eA in EA)
            if (EA[eA] !== void 0 && !(eA in oA))
              return !1;
          for (let eA in oA)
            if (oA[eA] !== void 0 && !(eA in EA))
              return !1;
          for (let eA in EA) {
            let GA = EA[eA], cA = oA[eA];
            if (!(GA === void 0 && cA === void 0) && (GA === void 0 || cA === void 0 || !gA(GA, cA)))
              return !1;
          }
          return !0;
        }
        function QA(EA) {
          let oA = new Array(EA.length);
          for (let eA = 0, GA = EA.length; eA < GA; ++eA)
            oA[eA] = IA(EA[eA]);
          return oA;
        }
        function iA(EA) {
          let oA = {};
          for (let eA in EA) {
            let GA = EA[eA];
            GA !== void 0 && (oA[eA] = IA(GA));
          }
          return oA;
        }
      })(g.JSONExt || (g.JSONExt = {}));
      class e {
        constructor() {
          this._types = [], this._values = [];
        }
        /**
         * Get an array of the MIME types contained within the dataset.
         *
         * @returns A new array of the MIME types, in order of insertion.
         */
        types() {
          return this._types.slice();
        }
        /**
         * Test whether the dataset has an entry for the given type.
         *
         * @param mime - The MIME type of interest.
         *
         * @returns `true` if the dataset contains a value for the given
         *   MIME type, `false` otherwise.
         */
        hasData(H) {
          return this._types.indexOf(H) !== -1;
        }
        /**
         * Get the data value for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * @returns The value for the given MIME type, or `undefined` if
         *   the dataset does not contain a value for the type.
         */
        getData(H) {
          let f = this._types.indexOf(H);
          return f !== -1 ? this._values[f] : void 0;
        }
        /**
         * Set the data value for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * @param data - The data value for the given MIME type.
         *
         * #### Notes
         * This will overwrite any previous entry for the MIME type.
         */
        setData(H, f) {
          this.clearData(H), this._types.push(H), this._values.push(f);
        }
        /**
         * Remove the data entry for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * #### Notes
         * This is a no-op if there is no entry for the given MIME type.
         */
        clearData(H) {
          let f = this._types.indexOf(H);
          f !== -1 && (this._types.splice(f, 1), this._values.splice(f, 1));
        }
        /**
         * Remove all data entries from the dataset.
         */
        clear() {
          this._types.length = 0, this._values.length = 0;
        }
      }
      class t {
        constructor(H = {}) {
          this._application = null, this._validatePlugin = () => !0, this._plugins = /* @__PURE__ */ new Map(), this._services = /* @__PURE__ */ new Map(), H.validatePlugin && (console.info("Plugins may be rejected by the custom validation plugin method."), this._validatePlugin = H.validatePlugin);
        }
        /**
         * The application object.
         *
         * It will be provided as first argument to the
         * plugins activation and deactivation functions.
         *
         * It can only be set once.
         *
         * By default, it is `null`.
         */
        get application() {
          return this._application;
        }
        set application(H) {
          if (this._application !== null)
            throw Error("PluginRegistry.application is already set. It cannot be overridden.");
          this._application = H;
        }
        /**
         * The list of all the deferred plugins.
         */
        get deferredPlugins() {
          return Array.from(this._plugins).filter(([H, f]) => f.autoStart === "defer").map(([H, f]) => H);
        }
        /**
         * Get a plugin description.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns The plugin description.
         */
        getPluginDescription(H) {
          var f, AA;
          return (AA = (f = this._plugins.get(H)) === null || f === void 0 ? void 0 : f.description) !== null && AA !== void 0 ? AA : "";
        }
        /**
         * Test whether a plugin is registered with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns `true` if the plugin is registered, `false` otherwise.
         */
        hasPlugin(H) {
          return this._plugins.has(H);
        }
        /**
         * Test whether a plugin is activated with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns `true` if the plugin is activated, `false` otherwise.
         */
        isPluginActivated(H) {
          var f, AA;
          return (AA = (f = this._plugins.get(H)) === null || f === void 0 ? void 0 : f.activated) !== null && AA !== void 0 ? AA : !1;
        }
        /**
         * List the IDs of the plugins registered with the application.
         *
         * @returns A new array of the registered plugin IDs.
         */
        listPlugins() {
          return Array.from(this._plugins.keys());
        }
        /**
         * Register a plugin with the application.
         *
         * @param plugin - The plugin to register.
         *
         * #### Notes
         * An error will be thrown if a plugin with the same ID is already
         * registered, or if the plugin has a circular dependency.
         *
         * If the plugin provides a service which has already been provided
         * by another plugin, the new service will override the old service.
         */
        registerPlugin(H) {
          if (this._plugins.has(H.id))
            throw new TypeError(`Plugin '${H.id}' is already registered.`);
          if (!this._validatePlugin(H))
            throw new Error(`Plugin '${H.id}' is not valid.`);
          const f = n.createPluginData(H);
          n.ensureNoCycle(f, this._plugins, this._services), f.provides && this._services.set(f.provides, f.id), this._plugins.set(f.id, f);
        }
        /**
         * Register multiple plugins with the application.
         *
         * @param plugins - The plugins to register.
         *
         * #### Notes
         * This calls `registerPlugin()` for each of the given plugins.
         */
        registerPlugins(H) {
          for (const f of H)
            this.registerPlugin(f);
        }
        /**
         * Deregister a plugin with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @param force - Whether to deregister the plugin even if it is active.
         */
        deregisterPlugin(H, f) {
          const AA = this._plugins.get(H);
          if (AA) {
            if (AA.activated && !f)
              throw new Error(`Plugin '${H}' is still active.`);
            this._plugins.delete(H);
          }
        }
        /**
         * Activate the plugin with the given ID.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns A promise which resolves when the plugin is activated
         *   or rejects with an error if it cannot be activated.
         */
        async activatePlugin(H) {
          const f = this._plugins.get(H);
          if (!f)
            throw new ReferenceError(`Plugin '${H}' is not registered.`);
          if (f.activated)
            return;
          if (f.promise)
            return f.promise;
          const AA = f.requires.map((IA) => this.resolveRequiredService(IA)), gA = f.optional.map((IA) => this.resolveOptionalService(IA));
          return f.promise = Promise.all([...AA, ...gA]).then((IA) => f.activate.apply(void 0, [this.application, ...IA])).then((IA) => {
            f.service = IA, f.activated = !0, f.promise = null;
          }).catch((IA) => {
            throw f.promise = null, IA;
          }), f.promise;
        }
        /**
         * Activate all the deferred plugins.
         *
         * @returns A promise which will resolve when each plugin is activated
         * or rejects with an error if one cannot be activated.
         */
        async activatePlugins(H, f = {}) {
          switch (H) {
            case "defer": {
              const AA = this.deferredPlugins.filter((gA) => this._plugins.get(gA).autoStart).map((gA) => this.activatePlugin(gA));
              await Promise.all(AA);
              break;
            }
            case "startUp": {
              const gA = n.collectStartupPlugins(this._plugins, f).map(async (IA) => {
                try {
                  return await this.activatePlugin(IA);
                } catch (BA) {
                  console.error(`Plugin '${IA}' failed to activate.`, BA);
                }
              });
              await Promise.all(gA);
              break;
            }
          }
        }
        /**
         * Deactivate the plugin and its downstream dependents if and only if the
         * plugin and its dependents all support `deactivate`.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns A list of IDs of downstream plugins deactivated with this one.
         */
        async deactivatePlugin(H) {
          const f = this._plugins.get(H);
          if (!f)
            throw new ReferenceError(`Plugin '${H}' is not registered.`);
          if (!f.activated)
            return [];
          if (!f.deactivate)
            throw new TypeError(`Plugin '${H}'#deactivate() method missing`);
          const AA = n.findDependents(H, this._plugins, this._services), gA = AA.map((IA) => this._plugins.get(IA));
          for (const IA of gA)
            if (!IA.deactivate)
              throw new TypeError(`Plugin ${IA.id}#deactivate() method missing (depends on ${H})`);
          for (const IA of gA) {
            const BA = [...IA.requires, ...IA.optional].map((CA) => {
              const QA = this._services.get(CA);
              return QA ? this._plugins.get(QA).service : null;
            });
            await IA.deactivate(this.application, ...BA), IA.service = null, IA.activated = !1;
          }
          return AA.pop(), AA;
        }
        /**
         * Resolve a required service of a given type.
         *
         * @param token - The token for the service type of interest.
         *
         * @returns A promise which resolves to an instance of the requested
         *   service, or rejects with an error if it cannot be resolved.
         *
         * #### Notes
         * Services are singletons. The same instance will be returned each
         * time a given service token is resolved.
         *
         * If the plugin which provides the service has not been activated,
         * resolving the service will automatically activate the plugin.
         *
         * User code will not typically call this method directly. Instead,
         * the required services for the user's plugins will be resolved
         * automatically when the plugin is activated.
         */
        async resolveRequiredService(H) {
          const f = this._services.get(H);
          if (!f)
            throw new TypeError(`No provider for: ${H.name}.`);
          const AA = this._plugins.get(f);
          return AA.activated || await this.activatePlugin(f), AA.service;
        }
        /**
         * Resolve an optional service of a given type.
         *
         * @param token - The token for the service type of interest.
         *
         * @returns A promise which resolves to an instance of the requested
         *   service, or `null` if it cannot be resolved.
         *
         * #### Notes
         * Services are singletons. The same instance will be returned each
         * time a given service token is resolved.
         *
         * If the plugin which provides the service has not been activated,
         * resolving the service will automatically activate the plugin.
         *
         * User code will not typically call this method directly. Instead,
         * the optional services for the user's plugins will be resolved
         * automatically when the plugin is activated.
         */
        async resolveOptionalService(H) {
          const f = this._services.get(H);
          if (!f)
            return null;
          const AA = this._plugins.get(f);
          if (!AA.activated)
            try {
              await this.activatePlugin(f);
            } catch (gA) {
              return console.error(gA), null;
            }
          return AA.service;
        }
      }
      var n;
      (function(M) {
        class H {
          constructor(CA) {
            var QA, iA, EA, oA;
            this._activated = !1, this._promise = null, this._service = null, this.id = CA.id, this.description = (QA = CA.description) !== null && QA !== void 0 ? QA : "", this.activate = CA.activate, this.deactivate = (iA = CA.deactivate) !== null && iA !== void 0 ? iA : null, this.provides = (EA = CA.provides) !== null && EA !== void 0 ? EA : null, this.autoStart = (oA = CA.autoStart) !== null && oA !== void 0 ? oA : !1, this.requires = CA.requires ? CA.requires.slice() : [], this.optional = CA.optional ? CA.optional.slice() : [];
          }
          /**
           * Whether the plugin has been activated.
           */
          get activated() {
            return this._activated;
          }
          set activated(CA) {
            this._activated = CA;
          }
          /**
           * The resolved service for the plugin, or `null`.
           */
          get service() {
            return this._service;
          }
          set service(CA) {
            this._service = CA;
          }
          /**
           * The pending resolver promise, or `null`.
           */
          get promise() {
            return this._promise;
          }
          set promise(CA) {
            this._promise = CA;
          }
        }
        function f(BA) {
          return new H(BA);
        }
        M.createPluginData = f;
        function AA(BA, CA, QA) {
          const iA = [...BA.requires, ...BA.optional], EA = (eA) => {
            if (eA === BA.provides)
              return !0;
            const GA = QA.get(eA);
            if (!GA)
              return !1;
            const cA = CA.get(GA), tA = [...cA.requires, ...cA.optional];
            return tA.length === 0 ? !1 : (oA.push(GA), tA.some(EA) ? !0 : (oA.pop(), !1));
          };
          if (!BA.provides || iA.length === 0)
            return;
          const oA = [BA.id];
          if (iA.some(EA))
            throw new ReferenceError(`Cycle detected: ${oA.join(" -> ")}.`);
        }
        M.ensureNoCycle = AA;
        function gA(BA, CA, QA) {
          const iA = new Array(), EA = (tA) => {
            const aA = CA.get(tA), sA = [...aA.requires, ...aA.optional];
            iA.push(...sA.reduce((DA, rA) => {
              const nA = QA.get(rA);
              return nA && DA.push([tA, nA]), DA;
            }, []));
          };
          for (const tA of CA.keys())
            EA(tA);
          const oA = iA.filter((tA) => tA[1] === BA);
          let eA = 0;
          for (; oA.length > eA; ) {
            const tA = oA.length, aA = new Set(oA.map((sA) => sA[0]));
            for (const sA of aA)
              iA.filter((DA) => DA[1] === sA).forEach((DA) => {
                oA.includes(DA) || oA.push(DA);
              });
            eA = tA;
          }
          const GA = E.topologicSort(oA), cA = GA.findIndex((tA) => tA === BA);
          return cA === -1 ? [BA] : GA.slice(0, cA + 1);
        }
        M.findDependents = gA;
        function IA(BA, CA) {
          const QA = /* @__PURE__ */ new Set();
          for (const iA of BA.keys())
            BA.get(iA).autoStart === !0 && QA.add(iA);
          if (CA.startPlugins)
            for (const iA of CA.startPlugins)
              QA.add(iA);
          if (CA.ignorePlugins)
            for (const iA of CA.ignorePlugins)
              QA.delete(iA);
          return Array.from(QA);
        }
        M.collectStartupPlugins = IA;
      })(n || (n = {}));
      class h {
        /**
         * Construct a new promise delegate.
         */
        constructor() {
          this.promise = new Promise((H, f) => {
            this._resolve = H, this._reject = f;
          });
        }
        /**
         * Resolve the wrapped promise with the given value.
         *
         * @param value - The value to use for resolving the promise.
         */
        resolve(H) {
          let f = this._resolve;
          f(H);
        }
        /**
         * Reject the wrapped promise with the given value.
         *
         * @reason - The reason for rejecting the promise.
         */
        reject(H) {
          let f = this._reject;
          f(H);
        }
      }
      class d {
        /**
         * Construct a new token.
         *
         * @param name - A human readable name for the token.
         * @param description - Token purpose description for documentation.
         */
        constructor(H, f) {
          this.name = H, this.description = f ?? "", this._tokenStructuralPropertyT = null;
        }
      }
      function k(M) {
        let H = 0;
        for (let f = 0, AA = M.length; f < AA; ++f)
          f % 4 === 0 && (H = Math.random() * 4294967295 >>> 0), M[f] = H & 255, H >>>= 8;
      }
      g.Random = void 0, (function(M) {
        M.getRandomValues = (() => {
          const H = typeof window < "u" && (window.crypto || window.msCrypto) || null;
          return H && typeof H.getRandomValues == "function" ? function(AA) {
            return H.getRandomValues(AA);
          } : k;
        })();
      })(g.Random || (g.Random = {}));
      function p(M) {
        const H = new Uint8Array(16), f = new Array(256);
        for (let AA = 0; AA < 16; ++AA)
          f[AA] = "0" + AA.toString(16);
        for (let AA = 16; AA < 256; ++AA)
          f[AA] = AA.toString(16);
        return function() {
          return M(H), H[6] = 64 | H[6] & 15, H[8] = 128 | H[8] & 63, f[H[0]] + f[H[1]] + f[H[2]] + f[H[3]] + "-" + f[H[4]] + f[H[5]] + "-" + f[H[6]] + f[H[7]] + "-" + f[H[8]] + f[H[9]] + "-" + f[H[10]] + f[H[11]] + f[H[12]] + f[H[13]] + f[H[14]] + f[H[15]];
        };
      }
      g.UUID = void 0, (function(M) {
        M.uuid4 = p(g.Random.getRandomValues);
      })(g.UUID || (g.UUID = {})), g.MimeData = e, g.PluginRegistry = t, g.PromiseDelegate = h, g.Token = d;
    }));
  })(dist$2, dist$2.exports)), dist$2.exports;
}
var minimist, hasRequiredMinimist;
function requireMinimist() {
  if (hasRequiredMinimist) return minimist;
  hasRequiredMinimist = 1;
  function o(E, e) {
    var t = E;
    e.slice(0, -1).forEach(function(h) {
      t = t[h] || {};
    });
    var n = e[e.length - 1];
    return n in t;
  }
  function i(E) {
    return typeof E == "number" || /^0x[0-9a-f]+$/i.test(E) ? !0 : /^[-+]?(?:\d+(?:\.\d*)?|\.\d+)(e[-+]?\d+)?$/.test(E);
  }
  function g(E, e) {
    return e === "constructor" && typeof E[e] == "function" || e === "__proto__";
  }
  return minimist = function(E, e) {
    e || (e = {});
    var t = {
      bools: {},
      strings: {},
      unknownFn: null
    };
    typeof e.unknown == "function" && (t.unknownFn = e.unknown), typeof e.boolean == "boolean" && e.boolean ? t.allBools = !0 : [].concat(e.boolean).filter(Boolean).forEach(function(eA) {
      t.bools[eA] = !0;
    });
    var n = {};
    function h(eA) {
      return n[eA].some(function(GA) {
        return t.bools[GA];
      });
    }
    Object.keys(e.alias || {}).forEach(function(eA) {
      n[eA] = [].concat(e.alias[eA]), n[eA].forEach(function(GA) {
        n[GA] = [eA].concat(n[eA].filter(function(cA) {
          return GA !== cA;
        }));
      });
    }), [].concat(e.string).filter(Boolean).forEach(function(eA) {
      t.strings[eA] = !0, n[eA] && [].concat(n[eA]).forEach(function(GA) {
        t.strings[GA] = !0;
      });
    });
    var d = e.default || {}, k = { _: [] };
    function p(eA, GA) {
      return t.allBools && /^--[^=]+$/.test(GA) || t.strings[eA] || t.bools[eA] || n[eA];
    }
    function M(eA, GA, cA) {
      for (var tA = eA, aA = 0; aA < GA.length - 1; aA++) {
        var sA = GA[aA];
        if (g(tA, sA))
          return;
        tA[sA] === void 0 && (tA[sA] = {}), (tA[sA] === Object.prototype || tA[sA] === Number.prototype || tA[sA] === String.prototype) && (tA[sA] = {}), tA[sA] === Array.prototype && (tA[sA] = []), tA = tA[sA];
      }
      var DA = GA[GA.length - 1];
      g(tA, DA) || ((tA === Object.prototype || tA === Number.prototype || tA === String.prototype) && (tA = {}), tA === Array.prototype && (tA = []), tA[DA] === void 0 || t.bools[DA] || typeof tA[DA] == "boolean" ? tA[DA] = cA : Array.isArray(tA[DA]) ? tA[DA].push(cA) : tA[DA] = [tA[DA], cA]);
    }
    function H(eA, GA, cA) {
      if (!(cA && t.unknownFn && !p(eA, cA) && t.unknownFn(cA) === !1)) {
        var tA = !t.strings[eA] && i(GA) ? Number(GA) : GA;
        M(k, eA.split("."), tA), (n[eA] || []).forEach(function(aA) {
          M(k, aA.split("."), tA);
        });
      }
    }
    Object.keys(t.bools).forEach(function(eA) {
      H(eA, d[eA] === void 0 ? !1 : d[eA]);
    });
    var f = [];
    E.indexOf("--") !== -1 && (f = E.slice(E.indexOf("--") + 1), E = E.slice(0, E.indexOf("--")));
    for (var AA = 0; AA < E.length; AA++) {
      var gA = E[AA], IA, BA;
      if (/^--.+=/.test(gA)) {
        var CA = gA.match(/^--([^=]+)=([\s\S]*)$/);
        IA = CA[1];
        var QA = CA[2];
        t.bools[IA] && (QA = QA !== "false"), H(IA, QA, gA);
      } else if (/^--no-.+/.test(gA))
        IA = gA.match(/^--no-(.+)/)[1], H(IA, !1, gA);
      else if (/^--.+/.test(gA))
        IA = gA.match(/^--(.+)/)[1], BA = E[AA + 1], BA !== void 0 && !/^(-|--)[^-]/.test(BA) && !t.bools[IA] && !t.allBools && (!n[IA] || !h(IA)) ? (H(IA, BA, gA), AA += 1) : /^(true|false)$/.test(BA) ? (H(IA, BA === "true", gA), AA += 1) : H(IA, t.strings[IA] ? "" : !0, gA);
      else if (/^-[^-]+/.test(gA)) {
        for (var iA = gA.slice(1, -1).split(""), EA = !1, oA = 0; oA < iA.length; oA++) {
          if (BA = gA.slice(oA + 2), BA === "-") {
            H(iA[oA], BA, gA);
            continue;
          }
          if (/[A-Za-z]/.test(iA[oA]) && BA[0] === "=") {
            H(iA[oA], BA.slice(1), gA), EA = !0;
            break;
          }
          if (/[A-Za-z]/.test(iA[oA]) && /-?\d+(\.\d*)?(e-?\d+)?$/.test(BA)) {
            H(iA[oA], BA, gA), EA = !0;
            break;
          }
          if (iA[oA + 1] && iA[oA + 1].match(/\W/)) {
            H(iA[oA], gA.slice(oA + 2), gA), EA = !0;
            break;
          } else
            H(iA[oA], t.strings[iA[oA]] ? "" : !0, gA);
        }
        IA = gA.slice(-1)[0], !EA && IA !== "-" && (E[AA + 1] && !/^(-|--)[^-]/.test(E[AA + 1]) && !t.bools[IA] && (!n[IA] || !h(IA)) ? (H(IA, E[AA + 1], gA), AA += 1) : E[AA + 1] && /^(true|false)$/.test(E[AA + 1]) ? (H(IA, E[AA + 1] === "true", gA), AA += 1) : H(IA, t.strings[IA] ? "" : !0, gA));
      } else if ((!t.unknownFn || t.unknownFn(gA) !== !1) && k._.push(t.strings._ || !i(gA) ? gA : Number(gA)), e.stopEarly) {
        k._.push.apply(k._, E.slice(AA + 1));
        break;
      }
    }
    return Object.keys(d).forEach(function(eA) {
      o(k, eA.split(".")) || (M(k, eA.split("."), d[eA]), (n[eA] || []).forEach(function(GA) {
        M(k, GA.split("."), d[eA]);
      }));
    }), e["--"] ? k["--"] = f.slice() : f.forEach(function(eA) {
      k._.push(eA);
    }), k;
  }, minimist;
}
var url = {}, pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify) return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function o(e) {
    if (typeof e != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
  }
  function i(e, t) {
    for (var n = "", h = 0, d = -1, k = 0, p, M = 0; M <= e.length; ++M) {
      if (M < e.length)
        p = e.charCodeAt(M);
      else {
        if (p === 47)
          break;
        p = 47;
      }
      if (p === 47) {
        if (!(d === M - 1 || k === 1)) if (d !== M - 1 && k === 2) {
          if (n.length < 2 || h !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              var H = n.lastIndexOf("/");
              if (H !== n.length - 1) {
                H === -1 ? (n = "", h = 0) : (n = n.slice(0, H), h = n.length - 1 - n.lastIndexOf("/")), d = M, k = 0;
                continue;
              }
            } else if (n.length === 2 || n.length === 1) {
              n = "", h = 0, d = M, k = 0;
              continue;
            }
          }
          t && (n.length > 0 ? n += "/.." : n = "..", h = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(d + 1, M) : n = e.slice(d + 1, M), h = M - d - 1;
        d = M, k = 0;
      } else p === 46 && k !== -1 ? ++k : k = -1;
    }
    return n;
  }
  function g(e, t) {
    var n = t.dir || t.root, h = t.base || (t.name || "") + (t.ext || "");
    return n ? n === t.root ? n + h : n + e + h : h;
  }
  var E = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var t = "", n = !1, h, d = arguments.length - 1; d >= -1 && !n; d--) {
        var k;
        d >= 0 ? k = arguments[d] : (h === void 0 && (h = process.cwd()), k = h), o(k), k.length !== 0 && (t = k + "/" + t, n = k.charCodeAt(0) === 47);
      }
      return t = i(t, !n), n ? t.length > 0 ? "/" + t : "/" : t.length > 0 ? t : ".";
    },
    normalize: function(t) {
      if (o(t), t.length === 0) return ".";
      var n = t.charCodeAt(0) === 47, h = t.charCodeAt(t.length - 1) === 47;
      return t = i(t, !n), t.length === 0 && !n && (t = "."), t.length > 0 && h && (t += "/"), n ? "/" + t : t;
    },
    isAbsolute: function(t) {
      return o(t), t.length > 0 && t.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var t, n = 0; n < arguments.length; ++n) {
        var h = arguments[n];
        o(h), h.length > 0 && (t === void 0 ? t = h : t += "/" + h);
      }
      return t === void 0 ? "." : E.normalize(t);
    },
    relative: function(t, n) {
      if (o(t), o(n), t === n || (t = E.resolve(t), n = E.resolve(n), t === n)) return "";
      for (var h = 1; h < t.length && t.charCodeAt(h) === 47; ++h)
        ;
      for (var d = t.length, k = d - h, p = 1; p < n.length && n.charCodeAt(p) === 47; ++p)
        ;
      for (var M = n.length, H = M - p, f = k < H ? k : H, AA = -1, gA = 0; gA <= f; ++gA) {
        if (gA === f) {
          if (H > f) {
            if (n.charCodeAt(p + gA) === 47)
              return n.slice(p + gA + 1);
            if (gA === 0)
              return n.slice(p + gA);
          } else k > f && (t.charCodeAt(h + gA) === 47 ? AA = gA : gA === 0 && (AA = 0));
          break;
        }
        var IA = t.charCodeAt(h + gA), BA = n.charCodeAt(p + gA);
        if (IA !== BA)
          break;
        IA === 47 && (AA = gA);
      }
      var CA = "";
      for (gA = h + AA + 1; gA <= d; ++gA)
        (gA === d || t.charCodeAt(gA) === 47) && (CA.length === 0 ? CA += ".." : CA += "/..");
      return CA.length > 0 ? CA + n.slice(p + AA) : (p += AA, n.charCodeAt(p) === 47 && ++p, n.slice(p));
    },
    _makeLong: function(t) {
      return t;
    },
    dirname: function(t) {
      if (o(t), t.length === 0) return ".";
      for (var n = t.charCodeAt(0), h = n === 47, d = -1, k = !0, p = t.length - 1; p >= 1; --p)
        if (n = t.charCodeAt(p), n === 47) {
          if (!k) {
            d = p;
            break;
          }
        } else
          k = !1;
      return d === -1 ? h ? "/" : "." : h && d === 1 ? "//" : t.slice(0, d);
    },
    basename: function(t, n) {
      if (n !== void 0 && typeof n != "string") throw new TypeError('"ext" argument must be a string');
      o(t);
      var h = 0, d = -1, k = !0, p;
      if (n !== void 0 && n.length > 0 && n.length <= t.length) {
        if (n.length === t.length && n === t) return "";
        var M = n.length - 1, H = -1;
        for (p = t.length - 1; p >= 0; --p) {
          var f = t.charCodeAt(p);
          if (f === 47) {
            if (!k) {
              h = p + 1;
              break;
            }
          } else
            H === -1 && (k = !1, H = p + 1), M >= 0 && (f === n.charCodeAt(M) ? --M === -1 && (d = p) : (M = -1, d = H));
        }
        return h === d ? d = H : d === -1 && (d = t.length), t.slice(h, d);
      } else {
        for (p = t.length - 1; p >= 0; --p)
          if (t.charCodeAt(p) === 47) {
            if (!k) {
              h = p + 1;
              break;
            }
          } else d === -1 && (k = !1, d = p + 1);
        return d === -1 ? "" : t.slice(h, d);
      }
    },
    extname: function(t) {
      o(t);
      for (var n = -1, h = 0, d = -1, k = !0, p = 0, M = t.length - 1; M >= 0; --M) {
        var H = t.charCodeAt(M);
        if (H === 47) {
          if (!k) {
            h = M + 1;
            break;
          }
          continue;
        }
        d === -1 && (k = !1, d = M + 1), H === 46 ? n === -1 ? n = M : p !== 1 && (p = 1) : n !== -1 && (p = -1);
      }
      return n === -1 || d === -1 || // We saw a non-dot character immediately before the dot
      p === 0 || // The (right-most) trimmed path component is exactly '..'
      p === 1 && n === d - 1 && n === h + 1 ? "" : t.slice(n, d);
    },
    format: function(t) {
      if (t === null || typeof t != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof t);
      return g("/", t);
    },
    parse: function(t) {
      o(t);
      var n = { root: "", dir: "", base: "", ext: "", name: "" };
      if (t.length === 0) return n;
      var h = t.charCodeAt(0), d = h === 47, k;
      d ? (n.root = "/", k = 1) : k = 0;
      for (var p = -1, M = 0, H = -1, f = !0, AA = t.length - 1, gA = 0; AA >= k; --AA) {
        if (h = t.charCodeAt(AA), h === 47) {
          if (!f) {
            M = AA + 1;
            break;
          }
          continue;
        }
        H === -1 && (f = !1, H = AA + 1), h === 46 ? p === -1 ? p = AA : gA !== 1 && (gA = 1) : p !== -1 && (gA = -1);
      }
      return p === -1 || H === -1 || // We saw a non-dot character immediately before the dot
      gA === 0 || // The (right-most) trimmed path component is exactly '..'
      gA === 1 && p === H - 1 && p === M + 1 ? H !== -1 && (M === 0 && d ? n.base = n.name = t.slice(1, H) : n.base = n.name = t.slice(M, H)) : (M === 0 && d ? (n.name = t.slice(1, p), n.base = t.slice(1, H)) : (n.name = t.slice(M, p), n.base = t.slice(M, H)), n.ext = t.slice(p, H)), M > 0 ? n.dir = t.slice(0, M - 1) : d && (n.dir = "/"), n;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return E.posix = E, pathBrowserify = E, pathBrowserify;
}
var requiresPort, hasRequiredRequiresPort;
function requireRequiresPort() {
  return hasRequiredRequiresPort || (hasRequiredRequiresPort = 1, requiresPort = function(i, g) {
    if (g = g.split(":")[0], i = +i, !i) return !1;
    switch (g) {
      case "http":
      case "ws":
        return i !== 80;
      case "https":
      case "wss":
        return i !== 443;
      case "ftp":
        return i !== 21;
      case "gopher":
        return i !== 70;
      case "file":
        return !1;
    }
    return i !== 0;
  }), requiresPort;
}
var querystringify = {}, hasRequiredQuerystringify;
function requireQuerystringify() {
  if (hasRequiredQuerystringify) return querystringify;
  hasRequiredQuerystringify = 1;
  var o = Object.prototype.hasOwnProperty, i;
  function g(n) {
    try {
      return decodeURIComponent(n.replace(/\+/g, " "));
    } catch {
      return null;
    }
  }
  function E(n) {
    try {
      return encodeURIComponent(n);
    } catch {
      return null;
    }
  }
  function e(n) {
    for (var h = /([^=?#&]+)=?([^&]*)/g, d = {}, k; k = h.exec(n); ) {
      var p = g(k[1]), M = g(k[2]);
      p === null || M === null || p in d || (d[p] = M);
    }
    return d;
  }
  function t(n, h) {
    h = h || "";
    var d = [], k, p;
    typeof h != "string" && (h = "?");
    for (p in n)
      if (o.call(n, p)) {
        if (k = n[p], !k && (k === null || k === i || isNaN(k)) && (k = ""), p = E(p), k = E(k), p === null || k === null) continue;
        d.push(p + "=" + k);
      }
    return d.length ? h + d.join("&") : "";
  }
  return querystringify.stringify = t, querystringify.parse = e, querystringify;
}
var urlParse, hasRequiredUrlParse;
function requireUrlParse() {
  if (hasRequiredUrlParse) return urlParse;
  hasRequiredUrlParse = 1;
  var o = requireRequiresPort(), i = requireQuerystringify(), g = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, E = /[\n\r\t]/g, e = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, t = /:\d+$/, n = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, h = /^[a-zA-Z]:/;
  function d(CA) {
    return (CA || "").toString().replace(g, "");
  }
  var k = [
    ["#", "hash"],
    // Extract from the back.
    ["?", "query"],
    // Extract from the back.
    function(QA, iA) {
      return H(iA.protocol) ? QA.replace(/\\/g, "/") : QA;
    },
    ["/", "pathname"],
    // Extract from the back.
    ["@", "auth", 1],
    // Extract from the front.
    [NaN, "host", void 0, 1, 1],
    // Set left over value.
    [/:(\d*)$/, "port", void 0, 1],
    // RegExp the back.
    [NaN, "hostname", void 0, 1, 1]
    // Set left over.
  ], p = { hash: 1, query: 1 };
  function M(CA) {
    var QA;
    typeof window < "u" ? QA = window : typeof commonjsGlobal$1 < "u" ? QA = commonjsGlobal$1 : typeof self < "u" ? QA = self : QA = {};
    var iA = QA.location || {};
    CA = CA || iA;
    var EA = {}, oA = typeof CA, eA;
    if (CA.protocol === "blob:")
      EA = new gA(unescape(CA.pathname), {});
    else if (oA === "string") {
      EA = new gA(CA, {});
      for (eA in p) delete EA[eA];
    } else if (oA === "object") {
      for (eA in CA)
        eA in p || (EA[eA] = CA[eA]);
      EA.slashes === void 0 && (EA.slashes = e.test(CA.href));
    }
    return EA;
  }
  function H(CA) {
    return CA === "file:" || CA === "ftp:" || CA === "http:" || CA === "https:" || CA === "ws:" || CA === "wss:";
  }
  function f(CA, QA) {
    CA = d(CA), CA = CA.replace(E, ""), QA = QA || {};
    var iA = n.exec(CA), EA = iA[1] ? iA[1].toLowerCase() : "", oA = !!iA[2], eA = !!iA[3], GA = 0, cA;
    return oA ? eA ? (cA = iA[2] + iA[3] + iA[4], GA = iA[2].length + iA[3].length) : (cA = iA[2] + iA[4], GA = iA[2].length) : eA ? (cA = iA[3] + iA[4], GA = iA[3].length) : cA = iA[4], EA === "file:" ? GA >= 2 && (cA = cA.slice(2)) : H(EA) ? cA = iA[4] : EA ? oA && (cA = cA.slice(2)) : GA >= 2 && H(QA.protocol) && (cA = iA[4]), {
      protocol: EA,
      slashes: oA || H(EA),
      slashesCount: GA,
      rest: cA
    };
  }
  function AA(CA, QA) {
    if (CA === "") return QA;
    for (var iA = (QA || "/").split("/").slice(0, -1).concat(CA.split("/")), EA = iA.length, oA = iA[EA - 1], eA = !1, GA = 0; EA--; )
      iA[EA] === "." ? iA.splice(EA, 1) : iA[EA] === ".." ? (iA.splice(EA, 1), GA++) : GA && (EA === 0 && (eA = !0), iA.splice(EA, 1), GA--);
    return eA && iA.unshift(""), (oA === "." || oA === "..") && iA.push(""), iA.join("/");
  }
  function gA(CA, QA, iA) {
    if (CA = d(CA), CA = CA.replace(E, ""), !(this instanceof gA))
      return new gA(CA, QA, iA);
    var EA, oA, eA, GA, cA, tA, aA = k.slice(), sA = typeof QA, DA = this, rA = 0;
    for (sA !== "object" && sA !== "string" && (iA = QA, QA = null), iA && typeof iA != "function" && (iA = i.parse), QA = M(QA), oA = f(CA || "", QA), EA = !oA.protocol && !oA.slashes, DA.slashes = oA.slashes || EA && QA.slashes, DA.protocol = oA.protocol || QA.protocol || "", CA = oA.rest, (oA.protocol === "file:" && (oA.slashesCount !== 2 || h.test(CA)) || !oA.slashes && (oA.protocol || oA.slashesCount < 2 || !H(DA.protocol))) && (aA[3] = [/(.*)/, "pathname"]); rA < aA.length; rA++) {
      if (GA = aA[rA], typeof GA == "function") {
        CA = GA(CA, DA);
        continue;
      }
      eA = GA[0], tA = GA[1], eA !== eA ? DA[tA] = CA : typeof eA == "string" ? (cA = eA === "@" ? CA.lastIndexOf(eA) : CA.indexOf(eA), ~cA && (typeof GA[2] == "number" ? (DA[tA] = CA.slice(0, cA), CA = CA.slice(cA + GA[2])) : (DA[tA] = CA.slice(cA), CA = CA.slice(0, cA)))) : (cA = eA.exec(CA)) && (DA[tA] = cA[1], CA = CA.slice(0, cA.index)), DA[tA] = DA[tA] || EA && GA[3] && QA[tA] || "", GA[4] && (DA[tA] = DA[tA].toLowerCase());
    }
    iA && (DA.query = iA(DA.query)), EA && QA.slashes && DA.pathname.charAt(0) !== "/" && (DA.pathname !== "" || QA.pathname !== "") && (DA.pathname = AA(DA.pathname, QA.pathname)), DA.pathname.charAt(0) !== "/" && H(DA.protocol) && (DA.pathname = "/" + DA.pathname), o(DA.port, DA.protocol) || (DA.host = DA.hostname, DA.port = ""), DA.username = DA.password = "", DA.auth && (cA = DA.auth.indexOf(":"), ~cA ? (DA.username = DA.auth.slice(0, cA), DA.username = encodeURIComponent(decodeURIComponent(DA.username)), DA.password = DA.auth.slice(cA + 1), DA.password = encodeURIComponent(decodeURIComponent(DA.password))) : DA.username = encodeURIComponent(decodeURIComponent(DA.auth)), DA.auth = DA.password ? DA.username + ":" + DA.password : DA.username), DA.origin = DA.protocol !== "file:" && H(DA.protocol) && DA.host ? DA.protocol + "//" + DA.host : "null", DA.href = DA.toString();
  }
  function IA(CA, QA, iA) {
    var EA = this;
    switch (CA) {
      case "query":
        typeof QA == "string" && QA.length && (QA = (iA || i.parse)(QA)), EA[CA] = QA;
        break;
      case "port":
        EA[CA] = QA, o(QA, EA.protocol) ? QA && (EA.host = EA.hostname + ":" + QA) : (EA.host = EA.hostname, EA[CA] = "");
        break;
      case "hostname":
        EA[CA] = QA, EA.port && (QA += ":" + EA.port), EA.host = QA;
        break;
      case "host":
        EA[CA] = QA, t.test(QA) ? (QA = QA.split(":"), EA.port = QA.pop(), EA.hostname = QA.join(":")) : (EA.hostname = QA, EA.port = "");
        break;
      case "protocol":
        EA.protocol = QA.toLowerCase(), EA.slashes = !iA;
        break;
      case "pathname":
      case "hash":
        if (QA) {
          var oA = CA === "pathname" ? "/" : "#";
          EA[CA] = QA.charAt(0) !== oA ? oA + QA : QA;
        } else
          EA[CA] = QA;
        break;
      case "username":
      case "password":
        EA[CA] = encodeURIComponent(QA);
        break;
      case "auth":
        var eA = QA.indexOf(":");
        ~eA ? (EA.username = QA.slice(0, eA), EA.username = encodeURIComponent(decodeURIComponent(EA.username)), EA.password = QA.slice(eA + 1), EA.password = encodeURIComponent(decodeURIComponent(EA.password))) : EA.username = encodeURIComponent(decodeURIComponent(QA));
    }
    for (var GA = 0; GA < k.length; GA++) {
      var cA = k[GA];
      cA[4] && (EA[cA[1]] = EA[cA[1]].toLowerCase());
    }
    return EA.auth = EA.password ? EA.username + ":" + EA.password : EA.username, EA.origin = EA.protocol !== "file:" && H(EA.protocol) && EA.host ? EA.protocol + "//" + EA.host : "null", EA.href = EA.toString(), EA;
  }
  function BA(CA) {
    (!CA || typeof CA != "function") && (CA = i.stringify);
    var QA, iA = this, EA = iA.host, oA = iA.protocol;
    oA && oA.charAt(oA.length - 1) !== ":" && (oA += ":");
    var eA = oA + (iA.protocol && iA.slashes || H(iA.protocol) ? "//" : "");
    return iA.username ? (eA += iA.username, iA.password && (eA += ":" + iA.password), eA += "@") : iA.password ? (eA += ":" + iA.password, eA += "@") : iA.protocol !== "file:" && H(iA.protocol) && !EA && iA.pathname !== "/" && (eA += "@"), (EA[EA.length - 1] === ":" || t.test(iA.hostname) && !iA.port) && (EA += ":"), eA += EA + iA.pathname, QA = typeof iA.query == "object" ? CA(iA.query) : iA.query, QA && (eA += QA.charAt(0) !== "?" ? "?" + QA : QA), iA.hash && (eA += iA.hash), eA;
  }
  return gA.prototype = { set: IA, toString: BA }, gA.extractProtocol = f, gA.location = M, gA.trimLeft = d, gA.qs = i, urlParse = gA, urlParse;
}
var hasRequiredUrl;
function requireUrl() {
  if (hasRequiredUrl) return url;
  hasRequiredUrl = 1;
  var o = url && url.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(url, "__esModule", { value: !0 }), url.URLExt = void 0;
  const i = requirePathBrowserify(), g = o(requireUrlParse());
  var E;
  return (function(e) {
    function t(f) {
      if (typeof document < "u" && document) {
        const AA = document.createElement("a");
        return AA.href = f, AA;
      }
      return (0, g.default)(f);
    }
    e.parse = t;
    function n(f) {
      return (0, g.default)(f).hostname;
    }
    e.getHostName = n;
    function h(f) {
      return f && t(f).toString();
    }
    e.normalize = h;
    function d(...f) {
      let AA = (0, g.default)(f[0], {});
      const gA = AA.protocol === "" && AA.slashes;
      gA && (AA = (0, g.default)(f[0], "https:" + f[0]));
      const IA = `${gA ? "" : AA.protocol}${AA.slashes ? "//" : ""}${AA.auth}${AA.auth ? "@" : ""}${AA.host}`, BA = i.posix.join(`${IA && AA.pathname[0] !== "/" ? "/" : ""}${AA.pathname}`, ...f.slice(1));
      return `${IA}${BA === "." ? "" : BA}`;
    }
    e.join = d;
    function k(f) {
      return d(...f.split("/").map(encodeURIComponent));
    }
    e.encodeParts = k;
    function p(f) {
      const AA = Object.keys(f).filter((gA) => gA.length > 0);
      return AA.length ? "?" + AA.map((gA) => {
        const IA = encodeURIComponent(String(f[gA]));
        return gA + (IA ? "=" + IA : "");
      }).join("&") : "";
    }
    e.objectToQueryString = p;
    function M(f) {
      return f.replace(/^\?/, "").split("&").reduce((AA, gA) => {
        const [IA, BA] = gA.split("=");
        return IA.length > 0 && (AA[IA] = decodeURIComponent(BA || "")), AA;
      }, {});
    }
    e.queryStringToObject = M;
    function H(f, AA = !1) {
      const { protocol: gA } = t(f);
      return (!gA || f.toLowerCase().indexOf(gA) !== 0) && (AA ? f.indexOf("//") !== 0 : f.indexOf("/") !== 0);
    }
    e.isLocal = H;
  })(E || (url.URLExt = E = {})), url;
}
var hasRequiredPageconfig;
function requirePageconfig() {
  if (hasRequiredPageconfig) return pageconfig;
  hasRequiredPageconfig = 1;
  var __importDefault = pageconfig && pageconfig.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(pageconfig, "__esModule", { value: !0 }), pageconfig.PageConfig = void 0;
  const coreutils_1 = requireDist$1(), minimist_1 = __importDefault(requireMinimist()), url_1 = /* @__PURE__ */ requireUrl();
  var PageConfig;
  return (function(PageConfig) {
    function getOption(name) {
      if (configData)
        return configData[name] || getBodyData(name);
      configData = /* @__PURE__ */ Object.create(null);
      let found = !1;
      if (typeof document < "u" && document) {
        const o = document.getElementById("jupyter-config-data");
        o && (configData = JSON.parse(o.textContent || ""), found = !0);
      }
      if (!found && typeof process < "u" && process.argv)
        try {
          const cli = (0, minimist_1.default)(process.argv.slice(2)), path = requirePathBrowserify();
          let fullPath = "";
          "jupyter-config-data" in cli ? fullPath = path.resolve(cli["jupyter-config-data"]) : "JUPYTER_CONFIG_DATA" in process.env && (fullPath = path.resolve(process.env.JUPYTER_CONFIG_DATA)), fullPath && (configData = eval("require")(fullPath));
        } catch (o) {
          console.error(o);
        }
      if (!coreutils_1.JSONExt.isObject(configData))
        configData = /* @__PURE__ */ Object.create(null);
      else
        for (const o in configData)
          typeof configData[o] != "string" && (configData[o] = JSON.stringify(configData[o]));
      return configData[name] || getBodyData(name);
    }
    PageConfig.getOption = getOption;
    function setOption(o, i) {
      const g = getOption(o);
      return configData[o] = i, g;
    }
    PageConfig.setOption = setOption;
    function getBaseUrl() {
      return url_1.URLExt.normalize(getOption("baseUrl") || "/");
    }
    PageConfig.getBaseUrl = getBaseUrl;
    function getTreeUrl() {
      return url_1.URLExt.join(getBaseUrl(), getOption("treeUrl"));
    }
    PageConfig.getTreeUrl = getTreeUrl;
    function getShareUrl() {
      return url_1.URLExt.normalize(getOption("shareUrl") || getBaseUrl());
    }
    PageConfig.getShareUrl = getShareUrl;
    function getTreeShareUrl() {
      return url_1.URLExt.normalize(url_1.URLExt.join(getShareUrl(), getOption("treeUrl")));
    }
    PageConfig.getTreeShareUrl = getTreeShareUrl;
    function getUrl(o) {
      var i, g, E, e;
      let t = o.toShare ? getShareUrl() : getBaseUrl();
      const n = (i = o.mode) !== null && i !== void 0 ? i : getOption("mode"), h = (g = o.workspace) !== null && g !== void 0 ? g : getOption("workspace"), d = n === "single-document" ? "doc" : "lab";
      t = url_1.URLExt.join(t, d), h !== PageConfig.defaultWorkspace && (t = url_1.URLExt.join(t, "workspaces", encodeURIComponent((E = getOption("workspace")) !== null && E !== void 0 ? E : PageConfig.defaultWorkspace)));
      const k = (e = o.treePath) !== null && e !== void 0 ? e : getOption("treePath");
      return k && (t = url_1.URLExt.join(t, "tree", url_1.URLExt.encodeParts(k))), t;
    }
    PageConfig.getUrl = getUrl, PageConfig.defaultWorkspace = "default";
    function getWsUrl(o) {
      let i = getOption("wsUrl");
      if (!i) {
        if (o = o ? url_1.URLExt.normalize(o) : getBaseUrl(), o.indexOf("http") !== 0)
          return "";
        i = "ws" + o.slice(4);
      }
      return url_1.URLExt.normalize(i);
    }
    PageConfig.getWsUrl = getWsUrl;
    function getNBConvertURL({ path: o, format: i, download: g }) {
      const E = url_1.URLExt.encodeParts(o), e = url_1.URLExt.join(getBaseUrl(), "nbconvert", i, E);
      return g ? e + "?download=true" : e;
    }
    PageConfig.getNBConvertURL = getNBConvertURL;
    function getToken() {
      return getOption("token") || getBodyData("jupyterApiToken");
    }
    PageConfig.getToken = getToken;
    function getNotebookVersion() {
      const o = getOption("notebookVersion");
      return o === "" ? [0, 0, 0] : JSON.parse(o);
    }
    PageConfig.getNotebookVersion = getNotebookVersion;
    let configData = null;
    function getBodyData(o) {
      if (typeof document > "u" || !document.body)
        return "";
      const i = document.body.dataset[o];
      return typeof i > "u" ? "" : decodeURIComponent(i);
    }
    (function(o) {
      function i(e) {
        try {
          const t = getOption(e);
          if (t)
            return JSON.parse(t);
        } catch (t) {
          console.warn(`Unable to parse ${e}.`, t);
        }
        return [];
      }
      o.deferred = i("deferredExtensions"), o.disabled = i("disabledExtensions");
      function g(e) {
        const t = e.indexOf(":");
        let n = "";
        return t !== -1 && (n = e.slice(0, t)), o.deferred.some((h) => h === e || n && h === n);
      }
      o.isDeferred = g;
      function E(e) {
        const t = e.indexOf(":");
        let n = "";
        return t !== -1 && (n = e.slice(0, t)), o.disabled.some((h) => h === e || n && h === n);
      }
      o.isDisabled = E;
    })(PageConfig.Extension || (PageConfig.Extension = {}));
  })(PageConfig || (pageconfig.PageConfig = PageConfig = {})), pageconfig;
}
var path$1 = {}, hasRequiredPath$1;
function requirePath$1() {
  if (hasRequiredPath$1) return path$1;
  hasRequiredPath$1 = 1, Object.defineProperty(path$1, "__esModule", { value: !0 }), path$1.PathExt = void 0;
  const o = requirePathBrowserify();
  var i;
  return (function(g) {
    function E(...f) {
      const AA = o.posix.join(...f);
      return AA === "." ? "" : H(AA);
    }
    g.join = E;
    function e(...f) {
      const AA = o.posix.join(...f);
      return AA === "." ? "" : AA;
    }
    g.joinWithLeadingSlash = e;
    function t(f, AA) {
      return o.posix.basename(f, AA);
    }
    g.basename = t;
    function n(f) {
      const AA = H(o.posix.dirname(f));
      return AA === "." ? "" : AA;
    }
    g.dirname = n;
    function h(f) {
      return o.posix.extname(f);
    }
    g.extname = h;
    function d(f) {
      return f === "" ? "" : H(o.posix.normalize(f));
    }
    g.normalize = d;
    function k(...f) {
      return H(o.posix.resolve(...f));
    }
    g.resolve = k;
    function p(f, AA) {
      return H(o.posix.relative(f, AA));
    }
    g.relative = p;
    function M(f) {
      return f.length > 0 && f.indexOf(".") !== 0 && (f = `.${f}`), f;
    }
    g.normalizeExtension = M;
    function H(f) {
      return f.indexOf("/") === 0 && (f = f.slice(1)), f;
    }
    g.removeSlash = H;
  })(i || (path$1.PathExt = i = {})), path$1;
}
var signal = {}, hasRequiredSignal$1;
function requireSignal$1() {
  if (hasRequiredSignal$1) return signal;
  hasRequiredSignal$1 = 1, Object.defineProperty(signal, "__esModule", { value: !0 }), signal.signalToPromise = i;
  const o = requireDist$1();
  function i(g, E) {
    const e = new o.PromiseDelegate();
    function t() {
      g.disconnect(n);
    }
    function n(h, d) {
      t(), e.resolve([h, d]);
    }
    return g.connect(n), (E ?? 0) > 0 && setTimeout(() => {
      t(), e.reject(`Signal not emitted within ${E} ms.`);
    }, E), e.promise;
  }
  return signal;
}
var text = {}, hasRequiredText;
function requireText() {
  if (hasRequiredText) return text;
  hasRequiredText = 1, Object.defineProperty(text, "__esModule", { value: !0 }), text.Text = void 0;
  var o;
  return (function(i) {
    function E(h, d) {
      return h;
    }
    i.jsIndexToCharIndex = E;
    function e(h, d) {
      return h;
    }
    i.charIndexToJsIndex = e;
    function t(h, d = !1) {
      return h.replace(/^(\w)|[\s-_:]+(\w)/g, function(k, p, M) {
        return M ? M.toUpperCase() : d ? p.toUpperCase() : p.toLowerCase();
      });
    }
    i.camelCase = t;
    function n(h) {
      return (h || "").toLowerCase().split(" ").map((d) => d.charAt(0).toUpperCase() + d.slice(1)).join(" ");
    }
    i.titleCase = n;
  })(o || (text.Text = o = {})), text;
}
var time = {}, hasRequiredTime;
function requireTime() {
  if (hasRequiredTime) return time;
  hasRequiredTime = 1, Object.defineProperty(time, "__esModule", { value: !0 }), time.Time = void 0;
  const o = [
    { name: "years", milliseconds: 365 * 24 * 60 * 60 * 1e3 },
    { name: "months", milliseconds: 720 * 60 * 60 * 1e3 },
    { name: "days", milliseconds: 1440 * 60 * 1e3 },
    { name: "hours", milliseconds: 3600 * 1e3 },
    { name: "minutes", milliseconds: 60 * 1e3 },
    { name: "seconds", milliseconds: 1e3 }
  ];
  var i;
  return (function(g) {
    function E(t, n = "long") {
      const h = document.documentElement.lang || "en", d = new Intl.RelativeTimeFormat(h, {
        numeric: "auto",
        style: n
      }), k = new Date(t).getTime() - Date.now();
      for (let p of o) {
        const M = Math.ceil(k / p.milliseconds);
        if (M !== 0)
          return d.format(M, p.name);
      }
      return d.format(0, "seconds");
    }
    g.formatHuman = E;
    function e(t) {
      const n = document.documentElement.lang || "en";
      return new Intl.DateTimeFormat(n, {
        dateStyle: "short",
        timeStyle: "short"
      }).format(new Date(t));
    }
    g.format = e;
  })(i || (time.Time = i = {})), time;
}
var hasRequiredLib;
function requireLib() {
  return hasRequiredLib || (hasRequiredLib = 1, (function(o) {
    var i = lib && lib.__createBinding || (Object.create ? (function(E, e, t, n) {
      n === void 0 && (n = t);
      var h = Object.getOwnPropertyDescriptor(e, t);
      (!h || ("get" in h ? !e.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return e[t];
      } }), Object.defineProperty(E, n, h);
    }) : (function(E, e, t, n) {
      n === void 0 && (n = t), E[n] = e[t];
    })), g = lib && lib.__exportStar || function(E, e) {
      for (var t in E) t !== "default" && !Object.prototype.hasOwnProperty.call(e, t) && i(e, E, t);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), g(/* @__PURE__ */ requireActivitymonitor(), o), g(/* @__PURE__ */ requireInterfaces(), o), g(/* @__PURE__ */ requireLru(), o), g(/* @__PURE__ */ requireMarkdowncodeblocks(), o), g(/* @__PURE__ */ requirePageconfig(), o), g(/* @__PURE__ */ requirePath$1(), o), g(/* @__PURE__ */ requireSignal$1(), o), g(/* @__PURE__ */ requireText(), o), g(/* @__PURE__ */ requireTime(), o), g(/* @__PURE__ */ requireUrl(), o);
  })(lib)), lib;
}
var libExports = /* @__PURE__ */ requireLib();
function manipulateIFrameDocument(o, i, g) {
  const E = [], e = i.getElementsByTagName("script");
  for (const n of e) {
    if (n.src === "")
      continue;
    const h = getRelativePath(window.location.host, window.location.pathname, new URL(n.src));
    if (h == null)
      continue;
    const d = libExports.URLExt.join(g, h), k = o.sendHttpRequest({
      method: "GET",
      headers: {},
      path: d,
      body: ""
    }).then(({
      statusCode: p,
      headers: M,
      body: H
    }) => {
      if (p !== 200)
        return;
      const f = M.get("Content-Type");
      return new Blob([H], f ? {
        type: f
      } : void 0).text().then((gA) => {
        const IA = i.createElement("script");
        IA.text = gA, IA.type = "text/javascript", IA.setAttribute("data-stlite", ""), n.replaceWith(IA);
      });
    });
    E.push(k);
  }
  const t = i.querySelectorAll("link[rel=stylesheet]");
  for (const n of t) {
    const h = getRelativePath(window.location.host, window.location.pathname, new URL(n.href));
    if (h == null)
      continue;
    const d = libExports.URLExt.join(g, h), k = o.sendHttpRequest({
      method: "GET",
      headers: {},
      path: d,
      body: ""
    }).then(({
      statusCode: p,
      headers: M,
      body: H
    }) => {
      if (p !== 200)
        return;
      const f = M.get("Content-Type");
      return new Blob([H], f ? {
        type: f
      } : void 0).text().then((gA) => {
        const IA = i.createElement("style");
        IA.innerHTML = gA, IA.setAttribute("data-stlite", ""), n.replaceWith(IA);
      });
    });
    E.push(k);
  }
  return Promise.all(E).then();
}
const InnerIFrame = React__default.forwardRef(({
  src: o,
  IframeComponent: i,
  ...g
}, E) => {
  const e = useStliteKernel(), [t, n] = useState();
  useEffect(() => {
    if (e == null || !o.startsWith("/component"))
      return;
    let d = !1;
    return e.sendHttpRequest({
      method: "GET",
      path: o,
      headers: {},
      body: ""
    }).then(({
      statusCode: k,
      headers: p,
      body: M
    }) => {
      if (d || k !== 200)
        return;
      const H = p.get("Content-Type");
      new Blob([M], H ? {
        type: H
      } : void 0).text().then((AA) => {
        d || n(AA);
      });
    }), () => {
      d = !0;
    };
  }, [e, o]);
  const h = useCallback((d) => {
    const p = d.target.contentWindow?.document;
    if (p == null) {
      console.warn("document not found in iframe");
      return;
    }
    manipulateIFrameDocument(e, p, getParentPath(o));
  }, [e, o]);
  return jsxRuntimeExports.jsx(i, {
    ...g,
    srcDoc: t,
    onLoad: h,
    ref: E
  });
});
InnerIFrame.displayName = "InnerIFrame";
const CustomComponentIFrame = React__default.forwardRef((o, i) => {
  const g = useStliteKernel(), E = useMemo$1(() => extractCustomComponentPath(g.basePath, o.src), [g.basePath, o.src]);
  return E == null ? jsxRuntimeExports.jsx("iframe", {
    ...o,
    ref: i
  }) : jsxRuntimeExports.jsx(InnerIFrame, {
    ...o,
    src: E,
    ref: i
  });
});
CustomComponentIFrame.displayName = "StliteCustomComponentIFrame";
const LOG$9 = loglevelExports$1.getLogger("ComponentRegistry");
class ComponentRegistry {
  constructor(i) {
    this.msgListeners = /* @__PURE__ */ new Map(), this.registerListener = (g, E) => {
      this.msgListeners.has(g) && LOG$9.warn("MessageEventSource registered multiple times!", g), this.msgListeners.set(g, E);
    }, this.deregisterListener = (g) => {
      this.msgListeners.delete(g) || LOG$9.warn("Could not deregister unregistered MessageEventSource!");
    }, this.checkSourceUrlResponse = (g, E) => this.endpoints.checkSourceUrlResponse(g, "Custom Component", E), this.sendTimeoutError = (g, E) => {
      this.endpoints.sendClientErrorToHost("Custom Component", "Request Timeout", "Your app is having trouble loading the component.", g, E);
    }, this.getComponentURL = (g, E) => this.endpoints.buildComponentURL(g, E), this.getBidiComponentURL = (g, E) => this.endpoints.buildBidiComponentURL(g, E), this.onMessageEvent = (g) => {
      if (isNullOrUndefined(g.data) || !Object.hasOwn(g.data, "isStreamlitMessage"))
        return;
      if (isNullOrUndefined(g.source)) {
        LOG$9.warn("Received component message with no eventSource!", g.data);
        return;
      }
      const E = this.msgListeners.get(g.source);
      if (isNullOrUndefined(E) || typeof E != "function") {
        LOG$9.warn("Received component message for unregistered ComponentInstance!", g.data);
        return;
      }
      const {
        type: e
      } = g.data;
      if (isNullOrUndefined(e)) {
        LOG$9.warn("Received Streamlit message with no type!", g.data);
        return;
      }
      E(e, g.data);
    }, this.endpoints = i, window.addEventListener("message", this.onMessageEvent);
  }
}
const byteToHex = [];
for (let o = 0; o < 256; ++o)
  byteToHex.push((o + 256).toString(16).slice(1));
function unsafeStringify(o, i = 0) {
  return (byteToHex[o[i + 0]] + byteToHex[o[i + 1]] + byteToHex[o[i + 2]] + byteToHex[o[i + 3]] + "-" + byteToHex[o[i + 4]] + byteToHex[o[i + 5]] + "-" + byteToHex[o[i + 6]] + byteToHex[o[i + 7]] + "-" + byteToHex[o[i + 8]] + byteToHex[o[i + 9]] + "-" + byteToHex[o[i + 10]] + byteToHex[o[i + 11]] + byteToHex[o[i + 12]] + byteToHex[o[i + 13]] + byteToHex[o[i + 14]] + byteToHex[o[i + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function _v4(o, i, g) {
  o = o || {};
  const E = o.random ?? o.rng?.() ?? rng();
  if (E.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return E[6] = E[6] & 15 | 64, E[8] = E[8] & 63 | 128, unsafeStringify(E);
}
function v4(o, i, g) {
  return native.randomUUID && !o ? native.randomUUID() : _v4(o);
}
var __typeError = (o) => {
  throw TypeError(o);
}, __accessCheck = (o, i, g) => i.has(o) || __typeError("Cannot " + g), __privateGet = (o, i, g) => (__accessCheck(o, i, "read from private field"), g ? g.call(o) : i.get(o)), __privateAdd = (o, i, g) => i.has(o) ? __typeError("Cannot add the same private member more than once") : i instanceof WeakSet ? i.add(o) : i.set(o, g), __privateSet = (o, i, g, E) => (__accessCheck(o, i, "write to private field"), i.set(o, g), g), __privateMethod = (o, i, g) => (__accessCheck(o, i, "access private method"), g), MAX_CHUNK_SIZE = 65536;
function* chunk(o) {
  if (o.byteLength <= MAX_CHUNK_SIZE) {
    yield o;
    return;
  }
  let i = 0;
  for (; i < o.byteLength; ) {
    const g = Math.min(o.byteLength - i, MAX_CHUNK_SIZE), E = o.buffer.slice(i, i + g);
    i += E.byteLength, yield new Uint8Array(E);
  }
}
var alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
function createBoundary() {
  let o = 16, i = "";
  for (; o--; )
    i += alphabet[Math.random() * alphabet.length << 0];
  return i;
}
var escapeName = (o) => String(o).replace(/\r/g, "%0D").replace(/\n/g, "%0A").replace(/"/g, "%22"), isFunction = (o) => typeof o == "function", isReadableStreamFallback = (o) => !!o && typeof o == "object" && !Array.isArray(o) && isFunction(o.getReader), isAsyncIterable = (o) => isFunction(o[Symbol.asyncIterator]);
async function* readStream(o) {
  const i = o.getReader();
  for (; ; ) {
    const { done: g, value: E } = await i.read();
    if (g)
      break;
    yield E;
  }
}
async function* chunkStream(o) {
  for await (const i of o)
    yield* chunk(i);
}
var getStreamIterator = (o) => {
  if (isAsyncIterable(o))
    return chunkStream(o);
  if (isReadableStreamFallback(o))
    return chunkStream(readStream(o));
  throw new TypeError(
    "Unsupported data source: Expected either ReadableStream or async iterable."
  );
}, isFile = (o) => !!(o && typeof o == "object" && isFunction(o.constructor) && o[Symbol.toStringTag] === "File" && isFunction(o.stream) && o.name != null), isFormData = (o) => !!(o && isFunction(o.constructor) && o[Symbol.toStringTag] === "FormData" && isFunction(o.append) && isFunction(o.getAll) && isFunction(o.entries) && isFunction(o[Symbol.iterator])), getType = (o) => Object.prototype.toString.call(o).slice(8, -1).toLowerCase();
function isPlainObject(o) {
  if (getType(o) !== "object")
    return !1;
  const i = Object.getPrototypeOf(o);
  return i == null ? !0 : i.constructor?.toString?.() === Object.toString();
}
var normalizeValue = (o) => String(o).replace(/\r|\n/g, (i, g, E) => i === "\r" && E[g + 1] !== `
` || i === `
` && E[g - 1] !== "\r" ? `\r
` : i);
function getProperty(o, i) {
  if (typeof i == "string") {
    for (const [g, E] of Object.entries(o))
      if (i.toLowerCase() === g.toLowerCase())
        return E;
  }
}
var proxyHeaders = (o) => new Proxy(
  o,
  {
    get: (i, g) => getProperty(i, g),
    has: (i, g) => getProperty(i, g) !== void 0
  }
), defaultOptions = {
  enableAdditionalHeaders: !1
}, readonlyProp = { writable: !1, configurable: !1 }, _CRLF, _CRLF_BYTES, _CRLF_BYTES_LENGTH, _DASHES, _encoder, _footer, _form, _options, _FormDataEncoder_instances, getFieldHeader_fn, getContentLength_fn, FormDataEncoder = class {
  constructor(o, i, g) {
    if (__privateAdd(this, _FormDataEncoder_instances), __privateAdd(this, _CRLF, `\r
`), __privateAdd(this, _CRLF_BYTES), __privateAdd(this, _CRLF_BYTES_LENGTH), __privateAdd(this, _DASHES, "-".repeat(2)), __privateAdd(this, _encoder, new TextEncoder()), __privateAdd(this, _footer), __privateAdd(this, _form), __privateAdd(this, _options), !isFormData(o))
      throw new TypeError("Expected first argument to be a FormData instance.");
    let E;
    if (isPlainObject(i) ? g = i : E = i, E || (E = `form-data-encoder-${createBoundary()}`), typeof E != "string")
      throw new TypeError("Expected boundary argument to be a string.");
    if (g && !isPlainObject(g))
      throw new TypeError("Expected options argument to be an object.");
    __privateSet(this, _form, Array.from(o.entries())), __privateSet(this, _options, { ...defaultOptions, ...g }), __privateSet(this, _CRLF_BYTES, __privateGet(this, _encoder).encode(__privateGet(this, _CRLF))), __privateSet(this, _CRLF_BYTES_LENGTH, __privateGet(this, _CRLF_BYTES).byteLength), this.boundary = E, this.contentType = `multipart/form-data; boundary=${this.boundary}`, __privateSet(this, _footer, __privateGet(this, _encoder).encode(
      `${__privateGet(this, _DASHES)}${this.boundary}${__privateGet(this, _DASHES)}${__privateGet(this, _CRLF).repeat(2)}`
    ));
    const e = {
      "Content-Type": this.contentType
    }, t = __privateMethod(this, _FormDataEncoder_instances, getContentLength_fn).call(this);
    t && (this.contentLength = t, e["Content-Length"] = t), this.headers = proxyHeaders(Object.freeze(e)), Object.defineProperties(this, {
      boundary: readonlyProp,
      contentType: readonlyProp,
      contentLength: readonlyProp,
      headers: readonlyProp
    });
  }
  /**
   * Creates an iterator allowing to go through form-data parts (with metadata).
   * This method **will not** read the files and **will not** split values big into smaller chunks.
   *
   * Using this method, you can convert form-data content into Blob:
   *
   * @example
   *
   * ```ts
   * import {Readable} from "stream"
   *
   * import {FormDataEncoder} from "form-data-encoder"
   *
   * import {FormData} from "formdata-polyfill/esm-min.js"
   * import {fileFrom} from "fetch-blob/form.js"
   * import {File} from "fetch-blob/file.js"
   * import {Blob} from "fetch-blob"
   *
   * import fetch from "node-fetch"
   *
   * const form = new FormData()
   *
   * form.set("field", "Just a random string")
   * form.set("file", new File(["Using files is class amazing"]))
   * form.set("fileFromPath", await fileFrom("path/to/a/file.txt"))
   *
   * const encoder = new FormDataEncoder(form)
   *
   * const options = {
   *   method: "post",
   *   body: new Blob(encoder, {type: encoder.contentType})
   * }
   *
   * const response = await fetch("https://httpbin.org/post", options)
   *
   * console.log(await response.json())
   * ```
   */
  *values() {
    for (const [o, i] of __privateGet(this, _form)) {
      const g = isFile(i) ? i : __privateGet(this, _encoder).encode(normalizeValue(i));
      yield __privateMethod(this, _FormDataEncoder_instances, getFieldHeader_fn).call(this, o, g), yield g, yield __privateGet(this, _CRLF_BYTES);
    }
    yield __privateGet(this, _footer);
  }
  /**
   * Creates an async iterator allowing to perform the encoding by portions.
   * This method reads through files and splits big values into smaller pieces (65536 bytes per each).
   *
   * @example
   *
   * ```ts
   * import {Readable} from "stream"
   *
   * import {FormData, File, fileFromPath} from "formdata-node"
   * import {FormDataEncoder} from "form-data-encoder"
   *
   * import fetch from "node-fetch"
   *
   * const form = new FormData()
   *
   * form.set("field", "Just a random string")
   * form.set("file", new File(["Using files is class amazing"], "file.txt"))
   * form.set("fileFromPath", await fileFromPath("path/to/a/file.txt"))
   *
   * const encoder = new FormDataEncoder(form)
   *
   * const options = {
   *   method: "post",
   *   headers: encoder.headers,
   *   body: Readable.from(encoder.encode()) // or Readable.from(encoder)
   * }
   *
   * const response = await fetch("https://httpbin.org/post", options)
   *
   * console.log(await response.json())
   * ```
   */
  async *encode() {
    for (const o of this.values())
      isFile(o) ? yield* getStreamIterator(o.stream()) : yield* chunk(o);
  }
  /**
   * Creates an iterator allowing to read through the encoder data using for...of loops
   */
  [Symbol.iterator]() {
    return this.values();
  }
  /**
   * Creates an **async** iterator allowing to read through the encoder data using for-await...of loops
   */
  [Symbol.asyncIterator]() {
    return this.encode();
  }
};
_CRLF = /* @__PURE__ */ new WeakMap();
_CRLF_BYTES = /* @__PURE__ */ new WeakMap();
_CRLF_BYTES_LENGTH = /* @__PURE__ */ new WeakMap();
_DASHES = /* @__PURE__ */ new WeakMap();
_encoder = /* @__PURE__ */ new WeakMap();
_footer = /* @__PURE__ */ new WeakMap();
_form = /* @__PURE__ */ new WeakMap();
_options = /* @__PURE__ */ new WeakMap();
_FormDataEncoder_instances = /* @__PURE__ */ new WeakSet();
getFieldHeader_fn = function(o, i) {
  let g = "";
  if (g += `${__privateGet(this, _DASHES)}${this.boundary}${__privateGet(this, _CRLF)}`, g += `Content-Disposition: form-data; name="${escapeName(o)}"`, isFile(i) && (g += `; filename="${escapeName(i.name)}"${__privateGet(this, _CRLF)}`, g += `Content-Type: ${i.type || "application/octet-stream"}`), __privateGet(this, _options).enableAdditionalHeaders === !0) {
    const E = isFile(i) ? i.size : i.byteLength;
    E != null && !isNaN(E) && (g += `${__privateGet(this, _CRLF)}Content-Length: ${E}`);
  }
  return __privateGet(this, _encoder).encode(`${g}${__privateGet(this, _CRLF).repeat(2)}`);
};
getContentLength_fn = function() {
  let o = 0;
  for (const [i, g] of __privateGet(this, _form)) {
    const E = isFile(g) ? g : __privateGet(this, _encoder).encode(normalizeValue(g)), e = isFile(E) ? E.size : E.byteLength;
    if (e == null || isNaN(e))
      return;
    o += __privateMethod(this, _FormDataEncoder_instances, getFieldHeader_fn).call(this, i, E).byteLength, o += e, o += __privateGet(this, _CRLF_BYTES_LENGTH);
  }
  return String(o + __privateGet(this, _footer).byteLength);
};
const LOG$8 = loglevelExports$1.getLogger("FileUploadClient");
class FileUploadClient {
  constructor(i) {
    this.formsWithPendingRequests = /* @__PURE__ */ new Map(), this.pendingFileURLsRequests = /* @__PURE__ */ new Map(), this.sessionInfo = i.sessionInfo, this.endpoints = i.endpoints, this.pendingFormUploadsChanged = i.formsWithPendingRequestsChanged, this.requestFileURLs = i.requestFileURLs;
  }
  setKernel(i) {
    this.kernel = i;
  }
  /**
   * Upload a file to the given URL. It will be associated with this browser's
   * sessionID.
   *
   * @param widget: the FileUploader widget that's doing the upload.
   * @param fileUploadUrl: the URL to upload the file to.
   * @param file: the files to upload.
   * @param onUploadProgress: an optional function that will be called repeatedly with progress events during the upload.
   * @param signal: an optional AbortSignal that can be used to cancel the in-progress upload.
   *
   * @return a Promise<void> that resolves with a void promise when the upload is complete.
   */
  async uploadFile(i, g, E, e, t) {
    this.offsetPendingRequestCount(i.formId, 1);
    const n = new FormData();
    n.append(E.name, E);
    const h = new FormDataEncoder(n);
    return new Blob(h, {
      type: h.contentType
    }).arrayBuffer().then((k) => {
      if (this.kernel == null)
        throw new Error("Kernel not ready");
      return this.kernel.sendHttpRequest({
        method: "PUT",
        path: g,
        body: k,
        headers: {
          ...h.headers
        }
      }, t).then((p) => {
        if (Math.floor(p.statusCode / 100) !== 2)
          throw new Error(`Unexpected status code ${p.statusCode} when uploading file.`);
      }).finally(() => this.offsetPendingRequestCount(i.formId, -1));
    });
  }
  /**
   * Request that the file at the given URL is deleted.
   * @param fileUrl: the URL of the file to delete.
   */
  deleteFile(i) {
    if (this.kernel == null)
      throw new Error("Kernel not ready");
    return this.kernel.sendHttpRequest({
      method: "DELETE",
      path: i,
      body: "",
      headers: {}
    }).then((g) => {
      if (Math.floor(g.statusCode / 100) !== 2)
        throw new Error(`Unexpected status code ${g.statusCode} when uploading file.`);
    });
  }
  /**
   * Request that the app fetch URLs to upload/delete/get the given files. Once
   * this is done, the app should call this class' onFileURLsResponse to
   * signify completion.
   *
   * @param files: An array of files.
   *
   * @return a Promise<FileURLsResponse.IFileURLs[]> resolving to a list of
   * URLs for uploading and deleting the given files.
   */
  fetchFileURLs(i) {
    if (!this.requestFileURLs)
      return Promise.resolve([]);
    const g = Promise.withResolvers(), E = v4();
    return this.pendingFileURLsRequests.set(E, g), this.requestFileURLs(E, i), g.promise;
  }
  /**
   * Callback to be called by the app once the file URLs corresponding to a
   * call to this.requestFileURLs has been received.
   *
   * @param resp: the FileURLsResponse corresponding to a call to
   * this.requestFileURLs.
   */
  onFileURLsResponse(i) {
    const g = i.responseId, E = this.pendingFileURLsRequests.get(g);
    E ? (i.errorMsg ? E.reject(i.errorMsg) : E.resolve(i.fileUrls || []), this.pendingFileURLsRequests.delete(g)) : LOG$8.warn("fileURLsResponse received for nonexistent request, ignoring.");
  }
  getFormIdSet() {
    return new Set(this.formsWithPendingRequests.keys());
  }
  offsetPendingRequestCount(i, g) {
    if (g === 0 || !isValidFormId(i))
      return;
    const E = this.formsWithPendingRequests.get(i) ?? 0, e = E + g;
    if (e < 0)
      throw new Error(`Can't offset pendingRequestCount below 0 (formId=${i}, curCount=${E}, offset=${g})`);
    const t = this.getFormIdSet();
    e === 0 ? this.formsWithPendingRequests.delete(i) : this.formsWithPendingRequests.set(i, e);
    const n = this.getFormIdSet();
    isEqual$1(n, t) || this.pendingFormUploadsChanged(n);
  }
}
const measureScrollbarGutterSize = () => {
  const o = document.createElement("div");
  o.style.position = "absolute", o.style.top = "-9999px", o.style.left = "-9999px", o.style.visibility = "hidden", o.style.overflow = "scroll", o.style.width = "50px", o.style.height = "50px", document.body.appendChild(o);
  const i = document.createElement("div");
  i.style.width = "100%", i.style.height = "100%", o.appendChild(i);
  const g = o.offsetWidth - i.offsetWidth;
  return o.remove(), g;
}, useScrollbarGutterSize = () => {
  const o = window.devicePixelRatio;
  return useMemo$1(() => measureScrollbarGutterSize(), [o]);
}, HOST_COMM_VERSION = 1;
class HostCommunicationManager {
  constructor(i) {
    this.openHostCommunication = () => {
      window.addEventListener("message", this.receiveHostMessage), this.sendMessageToHost({
        type: "GUEST_READY",
        streamlitExecutionStartedAt: this.props.streamlitExecutionStartedAt,
        guestReadyAt: Date.now()
      });
    }, this.closeHostCommunication = () => {
      window.removeEventListener("message", this.receiveHostMessage);
    }, this.resetAuthToken = () => {
      this.deferredAuthToken = Promise.withResolvers();
    }, this.claimAuthToken = () => this.deferredAuthToken.promise, this.setAllowedOrigins = ({
      allowedOrigins: g,
      useExternalAuthToken: E
    }) => {
      E || this.deferredAuthToken.resolve(void 0), g?.length && (this.allowedOrigins = g, this.openHostCommunication());
    }, this.sendMessageToSameOriginHost = (g) => {
      window.parent.postMessage({
        stCommVersion: HOST_COMM_VERSION,
        ...g
      }, window.location.origin);
    }, this.sendMessageToHost = (g) => {
      window.parent.postMessage({
        stCommVersion: HOST_COMM_VERSION,
        ...g
      }, "*");
    }, this.receiveHostMessage = (g) => {
      const E = g.data;
      if (!(E.stCommVersion !== HOST_COMM_VERSION || !this.allowedOrigins.find((e) => isValidOrigin(e, g.origin)))) {
        if (E.type === "CLOSE_MODAL" && this.props.closeModal(), E.type === "STOP_SCRIPT" && this.props.stopScript(), E.type === "RERUN_SCRIPT" && this.props.rerunScript(), E.type === "CLEAR_CACHE" && this.props.clearCache(), E.type === "REQUEST_PAGE_CHANGE" && this.props.pageChanged(E.pageScriptHash), E.type === "SEND_APP_HEARTBEAT" && this.props.sendAppHeartbeat(), E.type === "SET_INPUTS_DISABLED" && this.props.setInputsDisabled(E.disabled), E.type === "SET_AUTH_TOKEN" && this.deferredAuthToken.resolve(E.authToken), E.type === "SET_FILE_UPLOAD_CLIENT_CONFIG") {
          const {
            prefix: e,
            headers: t
          } = E;
          this.props.fileUploadClientConfigChanged({
            prefix: e,
            headers: t
          });
        }
        E.type === "SET_IS_OWNER" && this.props.isOwnerChanged(E.isOwner), E.type === "SET_MENU_ITEMS" && this.props.hostMenuItemsChanged(E.items), E.type === "SET_METADATA" && this.props.deployedAppMetadataChanged(E.metadata), E.type === "SET_PAGE_LINK_BASE_URL" && this.props.pageLinkBaseUrlChanged(E.pageLinkBaseUrl), E.type === "SET_SIDEBAR_CHEVRON_DOWNSHIFT" && this.props.sidebarChevronDownshiftChanged(E.sidebarChevronDownshift), E.type === "SET_SIDEBAR_NAV_VISIBILITY" && this.props.hostHideSidebarNavChanged(E.hidden), E.type === "SET_TOOLBAR_ITEMS" && this.props.hostToolbarItemsChanged(E.items), E.type === "UPDATE_FROM_QUERY_PARAMS" && (this.props.queryParamsChanged(E.queryParams), this.props.sendRerunBackMsg()), E.type === "UPDATE_HASH" && (window.location.hash = E.hash), E.type === "SET_CUSTOM_THEME_CONFIG" && this.props.themeChanged(E.themeName, E.themeInfo), E.type === "RESTART_WEBSOCKET_CONNECTION" && this.props.restartWebsocketConnection(), E.type === "TERMINATE_WEBSOCKET_CONNECTION" && this.props.terminateWebsocketConnection();
      }
    }, this.props = i, this.allowedOrigins = [], this.deferredAuthToken = Promise.withResolvers();
  }
}
class SessionInfo {
  /** Return the current SessionInfo props. Throw an error if the props are undefined. */
  get current() {
    if (!this._current)
      throw new Error("Tried to use SessionInfo before it was initialized");
    return this._current;
  }
  /** Return the previous SessionInfo props. They may be undefined! */
  get last() {
    return this._last;
  }
  /**
   * Initialize `SessionInfo.current` with the given props and copy its
   * previous props to `SessionInfo.last`.
   */
  setCurrent(i) {
    this._last = notNullOrUndefined(this._current) ? {
      ...this._current
    } : void 0, this._current = notNullOrUndefined(i) ? {
      ...i
    } : void 0;
  }
  /** Marks `SessionInfo.current` as not connected and copy its previous props to `SessionInfo.last`. */
  disconnect() {
    this._current && this.setCurrent({
      ...this._current,
      isConnected: !1
    });
  }
  /** True if `SessionInfo.current` exists. */
  get isSet() {
    return notNullOrUndefined(this._current);
  }
  /** True if `SessionInfo.current` refers to a "streamlit hello" session. */
  get isHello() {
    return notNullOrUndefined(this._current) && this._current.isHello;
  }
  /** Create SessionInfo Props from the relevant bits of an initialize message. */
  static propsFromNewSessionMessage(i) {
    const g = i.initialize, E = i.config, e = g.userInfo, t = g.environmentInfo;
    return {
      appId: hashString(e.installationIdV3 + i.mainScriptPath),
      sessionId: g.sessionId,
      streamlitVersion: t.streamlitVersion,
      pythonVersion: t.pythonVersion,
      serverOS: t.serverOs,
      hasDisplay: t.hasDisplay,
      installationId: e.installationId,
      installationIdV3: e.installationIdV3,
      installationIdV4: e.installationIdV4,
      maxCachedMessageAge: E.maxCachedMessageAge,
      isHello: g.isHello,
      // We assume we are always connected because the message came directly from the server.
      isConnected: !0
    };
  }
}
const measure = (o, i, g) => performance.measure(o, i, g), mark = (o) => performance.mark(o);
class Timer {
  constructor() {
    this.duration = 0, this.startTime = 0, this.running = !1;
  }
  /** True if the timer is currently running */
  get isRunning() {
    return this.running;
  }
  /** Remaining time before timeout, or 0 if the timer is not running */
  get remainingTime() {
    if (!this.running)
      return 0;
    const i = Date.now() - this.startTime;
    return Math.max(this.duration - i, 0);
  }
  /**
   * Starts the Timer with the given callback.
   * If the Timer is already running, it will be canceled first.
   */
  setTimeout(i, g) {
    this.cancel(), this.startTime = Date.now(), this.duration = g, this.running = !0, this.timerHandle = window.setTimeout(() => {
      this.running = !1, i();
    }, g);
  }
  /** Cancels the Timer. If the Timer is not already running, this is a no-op. */
  cancel() {
    this.timerHandle !== void 0 && (window.clearTimeout(this.timerHandle), this.timerHandle = void 0, this.running = !1);
  }
}
var src = { exports: {} }, indexLight = { exports: {} }, types = {}, util = { exports: {} }, codegen_1, hasRequiredCodegen;
function requireCodegen() {
  if (hasRequiredCodegen) return codegen_1;
  hasRequiredCodegen = 1, codegen_1 = o;
  function o(i, g) {
    typeof i == "string" && (g = i, i = void 0);
    var E = [];
    function e(n) {
      if (typeof n != "string") {
        var h = t();
        if (o.verbose && console.log("codegen: " + h), h = "return " + h, n) {
          for (var d = Object.keys(n), k = new Array(d.length + 1), p = new Array(d.length), M = 0; M < d.length; )
            k[M] = d[M], p[M] = n[d[M++]];
          return k[M] = h, Function.apply(null, k).apply(null, p);
        }
        return Function(h)();
      }
      for (var H = new Array(arguments.length - 1), f = 0; f < H.length; )
        H[f] = arguments[++f];
      if (f = 0, n = n.replace(/%([%dfijs])/g, function(gA, IA) {
        var BA = H[f++];
        switch (IA) {
          case "d":
          case "f":
            return String(Number(BA));
          case "i":
            return String(Math.floor(BA));
          case "j":
            return JSON.stringify(BA);
          case "s":
            return String(BA);
        }
        return "%";
      }), f !== H.length)
        throw Error("parameter count mismatch");
      return E.push(n), e;
    }
    function t(n) {
      return "function " + (n || g || "") + "(" + (i && i.join(",") || "") + `){
  ` + E.join(`
  `) + `
}`;
    }
    return e.toString = t, e;
  }
  return o.verbose = !1, codegen_1;
}
var fetch_1, hasRequiredFetch;
function requireFetch() {
  if (hasRequiredFetch) return fetch_1;
  hasRequiredFetch = 1, fetch_1 = E;
  var o = requireAspromise$1(), i = requireInquire$1(), g = i("fs");
  function E(e, t, n) {
    return typeof t == "function" ? (n = t, t = {}) : t || (t = {}), n ? !t.xhr && g && g.readFile ? g.readFile(e, function(d, k) {
      return d && typeof XMLHttpRequest < "u" ? E.xhr(e, t, n) : d ? n(d) : n(null, t.binary ? k : k.toString("utf8"));
    }) : E.xhr(e, t, n) : o(E, this, e, t);
  }
  return E.xhr = function(t, n, h) {
    var d = new XMLHttpRequest();
    d.onreadystatechange = function() {
      if (d.readyState === 4) {
        if (d.status !== 0 && d.status !== 200)
          return h(Error("status " + d.status));
        if (n.binary) {
          var p = d.response;
          if (!p) {
            p = [];
            for (var M = 0; M < d.responseText.length; ++M)
              p.push(d.responseText.charCodeAt(M) & 255);
          }
          return h(null, typeof Uint8Array < "u" ? new Uint8Array(p) : p);
        }
        return h(null, d.responseText);
      }
    }, n.binary && ("overrideMimeType" in d && d.overrideMimeType("text/plain; charset=x-user-defined"), d.responseType = "arraybuffer"), d.open("GET", t), d.send();
  }, fetch_1;
}
var path = {}, hasRequiredPath;
function requirePath() {
  return hasRequiredPath || (hasRequiredPath = 1, (function(o) {
    var i = o, g = (
      /**
       * Tests if the specified path is absolute.
       * @param {string} path Path to test
       * @returns {boolean} `true` if path is absolute
       */
      i.isAbsolute = function(t) {
        return /^(?:\/|\w+:)/.test(t);
      }
    ), E = (
      /**
       * Normalizes the specified path.
       * @param {string} path Path to normalize
       * @returns {string} Normalized path
       */
      i.normalize = function(t) {
        t = t.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
        var n = t.split("/"), h = g(t), d = "";
        h && (d = n.shift() + "/");
        for (var k = 0; k < n.length; )
          n[k] === ".." ? k > 0 && n[k - 1] !== ".." ? n.splice(--k, 2) : h ? n.splice(k, 1) : ++k : n[k] === "." ? n.splice(k, 1) : ++k;
        return d + n.join("/");
      }
    );
    i.resolve = function(t, n, h) {
      return h || (n = E(n)), g(n) ? n : (h || (t = E(t)), (t = t.replace(/(?:\/|^)[^/]+$/, "")).length ? E(t + "/" + n) : n);
    };
  })(path)), path;
}
var namespace, hasRequiredNamespace;
function requireNamespace() {
  if (hasRequiredNamespace) return namespace;
  hasRequiredNamespace = 1, namespace = d;
  var o = requireObject();
  ((d.prototype = Object.create(o.prototype)).constructor = d).className = "Namespace";
  var i = requireField(), g = requireUtil(), E = requireOneof(), e, t, n;
  d.fromJSON = function(M, H) {
    return new d(M, H.options).addJSON(H.nested);
  };
  function h(p, M) {
    if (p && p.length) {
      for (var H = {}, f = 0; f < p.length; ++f)
        H[p[f].name] = p[f].toJSON(M);
      return H;
    }
  }
  d.arrayToJSON = h, d.isReservedId = function(M, H) {
    if (M) {
      for (var f = 0; f < M.length; ++f)
        if (typeof M[f] != "string" && M[f][0] <= H && M[f][1] > H)
          return !0;
    }
    return !1;
  }, d.isReservedName = function(M, H) {
    if (M) {
      for (var f = 0; f < M.length; ++f)
        if (M[f] === H)
          return !0;
    }
    return !1;
  };
  function d(p, M) {
    o.call(this, p, M), this.nested = void 0, this._nestedArray = null, this._lookupCache = {}, this._needsRecursiveFeatureResolution = !0, this._needsRecursiveResolve = !0;
  }
  function k(p) {
    p._nestedArray = null, p._lookupCache = {};
    for (var M = p; M = M.parent; )
      M._lookupCache = {};
    return p;
  }
  return Object.defineProperty(d.prototype, "nestedArray", {
    get: function() {
      return this._nestedArray || (this._nestedArray = g.toArray(this.nested));
    }
  }), d.prototype.toJSON = function(M) {
    return g.toObject([
      "options",
      this.options,
      "nested",
      h(this.nestedArray, M)
    ]);
  }, d.prototype.addJSON = function(M) {
    var H = this;
    if (M)
      for (var f = Object.keys(M), AA = 0, gA; AA < f.length; ++AA)
        gA = M[f[AA]], H.add(
          // most to least likely
          (gA.fields !== void 0 ? e.fromJSON : gA.values !== void 0 ? n.fromJSON : gA.methods !== void 0 ? t.fromJSON : gA.id !== void 0 ? i.fromJSON : d.fromJSON)(f[AA], gA)
        );
    return this;
  }, d.prototype.get = function(M) {
    return this.nested && this.nested[M] || null;
  }, d.prototype.getEnum = function(M) {
    if (this.nested && this.nested[M] instanceof n)
      return this.nested[M].values;
    throw Error("no such enum: " + M);
  }, d.prototype.add = function(M) {
    if (!(M instanceof i && M.extend !== void 0 || M instanceof e || M instanceof E || M instanceof n || M instanceof t || M instanceof d))
      throw TypeError("object must be a valid nested object");
    if (!this.nested)
      this.nested = {};
    else {
      var H = this.get(M.name);
      if (H)
        if (H instanceof d && M instanceof d && !(H instanceof e || H instanceof t)) {
          for (var f = H.nestedArray, AA = 0; AA < f.length; ++AA)
            M.add(f[AA]);
          this.remove(H), this.nested || (this.nested = {}), M.setOptions(H.options, !0);
        } else
          throw Error("duplicate name '" + M.name + "' in " + this);
    }
    this.nested[M.name] = M, this instanceof e || this instanceof t || this instanceof n || this instanceof i || M._edition || (M._edition = M._defaultEdition), this._needsRecursiveFeatureResolution = !0, this._needsRecursiveResolve = !0;
    for (var gA = this; gA = gA.parent; )
      gA._needsRecursiveFeatureResolution = !0, gA._needsRecursiveResolve = !0;
    return M.onAdd(this), k(this);
  }, d.prototype.remove = function(M) {
    if (!(M instanceof o))
      throw TypeError("object must be a ReflectionObject");
    if (M.parent !== this)
      throw Error(M + " is not a member of " + this);
    return delete this.nested[M.name], Object.keys(this.nested).length || (this.nested = void 0), M.onRemove(this), k(this);
  }, d.prototype.define = function(M, H) {
    if (g.isString(M))
      M = M.split(".");
    else if (!Array.isArray(M))
      throw TypeError("illegal path");
    if (M && M.length && M[0] === "")
      throw Error("path must be relative");
    for (var f = this; M.length > 0; ) {
      var AA = M.shift();
      if (f.nested && f.nested[AA]) {
        if (f = f.nested[AA], !(f instanceof d))
          throw Error("path conflicts with non-namespace objects");
      } else
        f.add(f = new d(AA));
    }
    return H && f.addJSON(H), f;
  }, d.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    this._resolveFeaturesRecursive(this._edition);
    var M = this.nestedArray, H = 0;
    for (this.resolve(); H < M.length; )
      M[H] instanceof d ? M[H++].resolveAll() : M[H++].resolve();
    return this._needsRecursiveResolve = !1, this;
  }, d.prototype._resolveFeaturesRecursive = function(M) {
    return this._needsRecursiveFeatureResolution ? (this._needsRecursiveFeatureResolution = !1, M = this._edition || M, o.prototype._resolveFeaturesRecursive.call(this, M), this.nestedArray.forEach((H) => {
      H._resolveFeaturesRecursive(M);
    }), this) : this;
  }, d.prototype.lookup = function(M, H, f) {
    if (typeof H == "boolean" ? (f = H, H = void 0) : H && !Array.isArray(H) && (H = [H]), g.isString(M) && M.length) {
      if (M === ".")
        return this.root;
      M = M.split(".");
    } else if (!M.length)
      return this;
    var AA = M.join(".");
    if (M[0] === "")
      return this.root.lookup(M.slice(1), H);
    var gA = this.root._fullyQualifiedObjects && this.root._fullyQualifiedObjects["." + AA];
    if (gA && (!H || H.indexOf(gA.constructor) > -1) || (gA = this._lookupImpl(M, AA), gA && (!H || H.indexOf(gA.constructor) > -1)))
      return gA;
    if (f)
      return null;
    for (var IA = this; IA.parent; ) {
      if (gA = IA.parent._lookupImpl(M, AA), gA && (!H || H.indexOf(gA.constructor) > -1))
        return gA;
      IA = IA.parent;
    }
    return null;
  }, d.prototype._lookupImpl = function(M, H) {
    if (Object.prototype.hasOwnProperty.call(this._lookupCache, H))
      return this._lookupCache[H];
    var f = this.get(M[0]), AA = null;
    if (f)
      M.length === 1 ? AA = f : f instanceof d && (M = M.slice(1), AA = f._lookupImpl(M, M.join(".")));
    else
      for (var gA = 0; gA < this.nestedArray.length; ++gA)
        this._nestedArray[gA] instanceof d && (f = this._nestedArray[gA]._lookupImpl(M, H)) && (AA = f);
    return this._lookupCache[H] = AA, AA;
  }, d.prototype.lookupType = function(M) {
    var H = this.lookup(M, [e]);
    if (!H)
      throw Error("no such type: " + M);
    return H;
  }, d.prototype.lookupEnum = function(M) {
    var H = this.lookup(M, [n]);
    if (!H)
      throw Error("no such Enum '" + M + "' in " + this);
    return H;
  }, d.prototype.lookupTypeOrEnum = function(M) {
    var H = this.lookup(M, [e, n]);
    if (!H)
      throw Error("no such Type or Enum '" + M + "' in " + this);
    return H;
  }, d.prototype.lookupService = function(M) {
    var H = this.lookup(M, [t]);
    if (!H)
      throw Error("no such Service '" + M + "' in " + this);
    return H;
  }, d._configure = function(p, M, H) {
    e = p, t = M, n = H;
  }, namespace;
}
var mapfield, hasRequiredMapfield;
function requireMapfield() {
  if (hasRequiredMapfield) return mapfield;
  hasRequiredMapfield = 1, mapfield = E;
  var o = requireField();
  ((E.prototype = Object.create(o.prototype)).constructor = E).className = "MapField";
  var i = requireTypes(), g = requireUtil();
  function E(e, t, n, h, d, k) {
    if (o.call(this, e, t, h, void 0, void 0, d, k), !g.isString(n))
      throw TypeError("keyType must be a string");
    this.keyType = n, this.resolvedKeyType = null, this.map = !0;
  }
  return E.fromJSON = function(t, n) {
    return new E(t, n.id, n.keyType, n.type, n.options, n.comment);
  }, E.prototype.toJSON = function(t) {
    var n = t ? !!t.keepComments : !1;
    return g.toObject([
      "keyType",
      this.keyType,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      n ? this.comment : void 0
    ]);
  }, E.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if (i.mapKey[this.keyType] === void 0)
      throw Error("invalid key type: " + this.keyType);
    return o.prototype.resolve.call(this);
  }, E.d = function(t, n, h) {
    return typeof h == "function" ? h = g.decorateType(h).name : h && typeof h == "object" && (h = g.decorateEnum(h).name), function(k, p) {
      g.decorateType(k.constructor).add(new E(p, t, n, h));
    };
  }, mapfield;
}
var method, hasRequiredMethod;
function requireMethod() {
  if (hasRequiredMethod) return method;
  hasRequiredMethod = 1, method = g;
  var o = requireObject();
  ((g.prototype = Object.create(o.prototype)).constructor = g).className = "Method";
  var i = requireUtil();
  function g(E, e, t, n, h, d, k, p, M) {
    if (i.isObject(h) ? (k = h, h = d = void 0) : i.isObject(d) && (k = d, d = void 0), !(e === void 0 || i.isString(e)))
      throw TypeError("type must be a string");
    if (!i.isString(t))
      throw TypeError("requestType must be a string");
    if (!i.isString(n))
      throw TypeError("responseType must be a string");
    o.call(this, E, k), this.type = e || "rpc", this.requestType = t, this.requestStream = h ? !0 : void 0, this.responseType = n, this.responseStream = d ? !0 : void 0, this.resolvedRequestType = null, this.resolvedResponseType = null, this.comment = p, this.parsedOptions = M;
  }
  return g.fromJSON = function(e, t) {
    return new g(e, t.type, t.requestType, t.responseType, t.requestStream, t.responseStream, t.options, t.comment, t.parsedOptions);
  }, g.prototype.toJSON = function(e) {
    var t = e ? !!e.keepComments : !1;
    return i.toObject([
      "type",
      this.type !== "rpc" && /* istanbul ignore next */
      this.type || void 0,
      "requestType",
      this.requestType,
      "requestStream",
      this.requestStream,
      "responseType",
      this.responseType,
      "responseStream",
      this.responseStream,
      "options",
      this.options,
      "comment",
      t ? this.comment : void 0,
      "parsedOptions",
      this.parsedOptions
    ]);
  }, g.prototype.resolve = function() {
    return this.resolved ? this : (this.resolvedRequestType = this.parent.lookupType(this.requestType), this.resolvedResponseType = this.parent.lookupType(this.responseType), o.prototype.resolve.call(this));
  }, method;
}
var service, hasRequiredService;
function requireService() {
  if (hasRequiredService) return service;
  hasRequiredService = 1, service = e;
  var o = requireNamespace();
  ((e.prototype = Object.create(o.prototype)).constructor = e).className = "Service";
  var i = requireMethod(), g = requireUtil(), E = requireRpc$1();
  function e(n, h) {
    o.call(this, n, h), this.methods = {}, this._methodsArray = null;
  }
  e.fromJSON = function(h, d) {
    var k = new e(h, d.options);
    if (d.methods)
      for (var p = Object.keys(d.methods), M = 0; M < p.length; ++M)
        k.add(i.fromJSON(p[M], d.methods[p[M]]));
    return d.nested && k.addJSON(d.nested), d.edition && (k._edition = d.edition), k.comment = d.comment, k._defaultEdition = "proto3", k;
  }, e.prototype.toJSON = function(h) {
    var d = o.prototype.toJSON.call(this, h), k = h ? !!h.keepComments : !1;
    return g.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      d && d.options || void 0,
      "methods",
      o.arrayToJSON(this.methodsArray, h) || /* istanbul ignore next */
      {},
      "nested",
      d && d.nested || void 0,
      "comment",
      k ? this.comment : void 0
    ]);
  }, Object.defineProperty(e.prototype, "methodsArray", {
    get: function() {
      return this._methodsArray || (this._methodsArray = g.toArray(this.methods));
    }
  });
  function t(n) {
    return n._methodsArray = null, n;
  }
  return e.prototype.get = function(h) {
    return this.methods[h] || o.prototype.get.call(this, h);
  }, e.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    o.prototype.resolve.call(this);
    for (var h = this.methodsArray, d = 0; d < h.length; ++d)
      h[d].resolve();
    return this;
  }, e.prototype._resolveFeaturesRecursive = function(h) {
    return this._needsRecursiveFeatureResolution ? (h = this._edition || h, o.prototype._resolveFeaturesRecursive.call(this, h), this.methodsArray.forEach((d) => {
      d._resolveFeaturesRecursive(h);
    }), this) : this;
  }, e.prototype.add = function(h) {
    if (this.get(h.name))
      throw Error("duplicate name '" + h.name + "' in " + this);
    return h instanceof i ? (this.methods[h.name] = h, h.parent = this, t(this)) : o.prototype.add.call(this, h);
  }, e.prototype.remove = function(h) {
    if (h instanceof i) {
      if (this.methods[h.name] !== h)
        throw Error(h + " is not a member of " + this);
      return delete this.methods[h.name], h.parent = null, t(this);
    }
    return o.prototype.remove.call(this, h);
  }, e.prototype.create = function(h, d, k) {
    for (var p = new E.Service(h, d, k), M = 0, H; M < /* initializes */
    this.methodsArray.length; ++M) {
      var f = g.lcFirst((H = this._methodsArray[M]).resolve().name).replace(/[^$\w_]/g, "");
      p[f] = g.codegen(["r", "c"], g.isReserved(f) ? f + "_" : f)("return this.rpcCall(m,q,s,r,c)")({
        m: H,
        q: H.resolvedRequestType.ctor,
        s: H.resolvedResponseType.ctor
      });
    }
    return p;
  }, service;
}
var message, hasRequiredMessage;
function requireMessage() {
  if (hasRequiredMessage) return message;
  hasRequiredMessage = 1, message = i;
  var o = requireMinimal$3();
  function i(g) {
    if (g)
      for (var E = Object.keys(g), e = 0; e < E.length; ++e)
        this[E[e]] = g[E[e]];
  }
  return i.create = function(E) {
    return this.$type.create(E);
  }, i.encode = function(E, e) {
    return this.$type.encode(E, e);
  }, i.encodeDelimited = function(E, e) {
    return this.$type.encodeDelimited(E, e);
  }, i.decode = function(E) {
    return this.$type.decode(E);
  }, i.decodeDelimited = function(E) {
    return this.$type.decodeDelimited(E);
  }, i.verify = function(E) {
    return this.$type.verify(E);
  }, i.fromObject = function(E) {
    return this.$type.fromObject(E);
  }, i.toObject = function(E, e) {
    return this.$type.toObject(E, e);
  }, i.prototype.toJSON = function() {
    return this.$type.toObject(this, o.toJSONOptions);
  }, message;
}
var decoder_1, hasRequiredDecoder;
function requireDecoder() {
  if (hasRequiredDecoder) return decoder_1;
  hasRequiredDecoder = 1, decoder_1 = e;
  var o = require_enum(), i = requireTypes(), g = requireUtil();
  function E(t) {
    return "missing required '" + t.name + "'";
  }
  function e(t) {
    for (var n = g.codegen(["r", "l", "e"], t.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (t.fieldsArray.filter(function(H) {
      return H.map;
    }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()")("if(t===e)")("break")("switch(t>>>3){"), h = 0; h < /* initializes */
    t.fieldsArray.length; ++h) {
      var d = t._fieldsArray[h].resolve(), k = d.resolvedType instanceof o ? "int32" : d.type, p = "m" + g.safeProp(d.name);
      n("case %i: {", d.id), d.map ? (n("if(%s===util.emptyObject)", p)("%s={}", p)("var c2 = r.uint32()+r.pos"), i.defaults[d.keyType] !== void 0 ? n("k=%j", i.defaults[d.keyType]) : n("k=null"), i.defaults[k] !== void 0 ? n("value=%j", i.defaults[k]) : n("value=null"), n("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", d.keyType)("case 2:"), i.basic[k] === void 0 ? n("value=types[%i].decode(r,r.uint32())", h) : n("value=r.%s()", k), n("break")("default:")("r.skipType(tag2&7)")("break")("}")("}"), i.long[d.keyType] !== void 0 ? n('%s[typeof k==="object"?util.longToHash(k):k]=value', p) : n("%s[k]=value", p)) : d.repeated ? (n("if(!(%s&&%s.length))", p, p)("%s=[]", p), i.packed[k] !== void 0 && n("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", p, k)("}else"), i.basic[k] === void 0 ? n(d.delimited ? "%s.push(types[%i].decode(r,undefined,((t&~7)|4)))" : "%s.push(types[%i].decode(r,r.uint32()))", p, h) : n("%s.push(r.%s())", p, k)) : i.basic[k] === void 0 ? n(d.delimited ? "%s=types[%i].decode(r,undefined,((t&~7)|4))" : "%s=types[%i].decode(r,r.uint32())", p, h) : n("%s=r.%s()", p, k), n("break")("}");
    }
    for (n("default:")("r.skipType(t&7)")("break")("}")("}"), h = 0; h < t._fieldsArray.length; ++h) {
      var M = t._fieldsArray[h];
      M.required && n("if(!m.hasOwnProperty(%j))", M.name)("throw util.ProtocolError(%j,{instance:m})", E(M));
    }
    return n("return m");
  }
  return decoder_1;
}
var verifier_1, hasRequiredVerifier;
function requireVerifier() {
  if (hasRequiredVerifier) return verifier_1;
  hasRequiredVerifier = 1, verifier_1 = t;
  var o = require_enum(), i = requireUtil();
  function g(n, h) {
    return n.name + ": " + h + (n.repeated && h !== "array" ? "[]" : n.map && h !== "object" ? "{k:" + n.keyType + "}" : "") + " expected";
  }
  function E(n, h, d, k) {
    if (h.resolvedType)
      if (h.resolvedType instanceof o) {
        n("switch(%s){", k)("default:")("return%j", g(h, "enum value"));
        for (var p = Object.keys(h.resolvedType.values), M = 0; M < p.length; ++M) n("case %i:", h.resolvedType.values[p[M]]);
        n("break")("}");
      } else
        n("{")("var e=types[%i].verify(%s);", d, k)("if(e)")("return%j+e", h.name + ".")("}");
    else
      switch (h.type) {
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
          n("if(!util.isInteger(%s))", k)("return%j", g(h, "integer"));
          break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
          n("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", k, k, k, k)("return%j", g(h, "integer|Long"));
          break;
        case "float":
        case "double":
          n('if(typeof %s!=="number")', k)("return%j", g(h, "number"));
          break;
        case "bool":
          n('if(typeof %s!=="boolean")', k)("return%j", g(h, "boolean"));
          break;
        case "string":
          n("if(!util.isString(%s))", k)("return%j", g(h, "string"));
          break;
        case "bytes":
          n('if(!(%s&&typeof %s.length==="number"||util.isString(%s)))', k, k, k)("return%j", g(h, "buffer"));
          break;
      }
    return n;
  }
  function e(n, h, d) {
    switch (h.keyType) {
      case "int32":
      case "uint32":
      case "sint32":
      case "fixed32":
      case "sfixed32":
        n("if(!util.key32Re.test(%s))", d)("return%j", g(h, "integer key"));
        break;
      case "int64":
      case "uint64":
      case "sint64":
      case "fixed64":
      case "sfixed64":
        n("if(!util.key64Re.test(%s))", d)("return%j", g(h, "integer|Long key"));
        break;
      case "bool":
        n("if(!util.key2Re.test(%s))", d)("return%j", g(h, "boolean key"));
        break;
    }
    return n;
  }
  function t(n) {
    var h = i.codegen(["m"], n.name + "$verify")('if(typeof m!=="object"||m===null)')("return%j", "object expected"), d = n.oneofsArray, k = {};
    d.length && h("var p={}");
    for (var p = 0; p < /* initializes */
    n.fieldsArray.length; ++p) {
      var M = n._fieldsArray[p].resolve(), H = "m" + i.safeProp(M.name);
      if (M.optional && h("if(%s!=null&&m.hasOwnProperty(%j)){", H, M.name), M.map)
        h("if(!util.isObject(%s))", H)("return%j", g(M, "object"))("var k=Object.keys(%s)", H)("for(var i=0;i<k.length;++i){"), e(h, M, "k[i]"), E(h, M, p, H + "[k[i]]")("}");
      else if (M.repeated)
        h("if(!Array.isArray(%s))", H)("return%j", g(M, "array"))("for(var i=0;i<%s.length;++i){", H), E(h, M, p, H + "[i]")("}");
      else {
        if (M.partOf) {
          var f = i.safeProp(M.partOf.name);
          k[M.partOf.name] === 1 && h("if(p%s===1)", f)("return%j", M.partOf.name + ": multiple values"), k[M.partOf.name] = 1, h("p%s=1", f);
        }
        E(h, M, p, H);
      }
      M.optional && h("}");
    }
    return h("return null");
  }
  return verifier_1;
}
var converter = {}, hasRequiredConverter;
function requireConverter() {
  return hasRequiredConverter || (hasRequiredConverter = 1, (function(o) {
    var i = o, g = require_enum(), E = requireUtil();
    function e(n, h, d, k) {
      var p = !1;
      if (h.resolvedType)
        if (h.resolvedType instanceof g) {
          n("switch(d%s){", k);
          for (var M = h.resolvedType.values, H = Object.keys(M), f = 0; f < H.length; ++f)
            M[H[f]] === h.typeDefault && !p && (n("default:")('if(typeof(d%s)==="number"){m%s=d%s;break}', k, k, k), h.repeated || n("break"), p = !0), n("case%j:", H[f])("case %i:", M[H[f]])("m%s=%j", k, M[H[f]])("break");
          n("}");
        } else n('if(typeof d%s!=="object")', k)("throw TypeError(%j)", h.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", k, d, k);
      else {
        var AA = !1;
        switch (h.type) {
          case "double":
          case "float":
            n("m%s=Number(d%s)", k, k);
            break;
          case "uint32":
          case "fixed32":
            n("m%s=d%s>>>0", k, k);
            break;
          case "int32":
          case "sint32":
          case "sfixed32":
            n("m%s=d%s|0", k, k);
            break;
          case "uint64":
            AA = !0;
          // eslint-disable-next-line no-fallthrough
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            n("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", k, k, AA)('else if(typeof d%s==="string")', k)("m%s=parseInt(d%s,10)", k, k)('else if(typeof d%s==="number")', k)("m%s=d%s", k, k)('else if(typeof d%s==="object")', k)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", k, k, k, AA ? "true" : "");
            break;
          case "bytes":
            n('if(typeof d%s==="string")', k)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", k, k, k)("else if(d%s.length >= 0)", k)("m%s=d%s", k, k);
            break;
          case "string":
            n("m%s=String(d%s)", k, k);
            break;
          case "bool":
            n("m%s=Boolean(d%s)", k, k);
            break;
        }
      }
      return n;
    }
    i.fromObject = function(h) {
      var d = h.fieldsArray, k = E.codegen(["d"], h.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
      if (!d.length) return k("return new this.ctor");
      k("var m=new this.ctor");
      for (var p = 0; p < d.length; ++p) {
        var M = d[p].resolve(), H = E.safeProp(M.name);
        M.map ? (k("if(d%s){", H)('if(typeof d%s!=="object")', H)("throw TypeError(%j)", M.fullName + ": object expected")("m%s={}", H)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", H), e(
          k,
          M,
          /* not sorted */
          p,
          H + "[ks[i]]"
        )("}")("}")) : M.repeated ? (k("if(d%s){", H)("if(!Array.isArray(d%s))", H)("throw TypeError(%j)", M.fullName + ": array expected")("m%s=[]", H)("for(var i=0;i<d%s.length;++i){", H), e(
          k,
          M,
          /* not sorted */
          p,
          H + "[i]"
        )("}")("}")) : (M.resolvedType instanceof g || k("if(d%s!=null){", H), e(
          k,
          M,
          /* not sorted */
          p,
          H
        ), M.resolvedType instanceof g || k("}"));
      }
      return k("return m");
    };
    function t(n, h, d, k) {
      if (h.resolvedType)
        h.resolvedType instanceof g ? n("d%s=o.enums===String?(types[%i].values[m%s]===undefined?m%s:types[%i].values[m%s]):m%s", k, d, k, k, d, k, k) : n("d%s=types[%i].toObject(m%s,o)", k, d, k);
      else {
        var p = !1;
        switch (h.type) {
          case "double":
          case "float":
            n("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", k, k, k, k);
            break;
          case "uint64":
            p = !0;
          // eslint-disable-next-line no-fallthrough
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            n('if(typeof m%s==="number")', k)("d%s=o.longs===String?String(m%s):m%s", k, k, k)("else")("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", k, k, k, k, p ? "true" : "", k);
            break;
          case "bytes":
            n("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", k, k, k, k, k);
            break;
          default:
            n("d%s=m%s", k, k);
            break;
        }
      }
      return n;
    }
    i.toObject = function(h) {
      var d = h.fieldsArray.slice().sort(E.compareFieldsById);
      if (!d.length)
        return E.codegen()("return {}");
      for (var k = E.codegen(["m", "o"], h.name + "$toObject")("if(!o)")("o={}")("var d={}"), p = [], M = [], H = [], f = 0; f < d.length; ++f)
        d[f].partOf || (d[f].resolve().repeated ? p : d[f].map ? M : H).push(d[f]);
      if (p.length) {
        for (k("if(o.arrays||o.defaults){"), f = 0; f < p.length; ++f) k("d%s=[]", E.safeProp(p[f].name));
        k("}");
      }
      if (M.length) {
        for (k("if(o.objects||o.defaults){"), f = 0; f < M.length; ++f) k("d%s={}", E.safeProp(M[f].name));
        k("}");
      }
      if (H.length) {
        for (k("if(o.defaults){"), f = 0; f < H.length; ++f) {
          var AA = H[f], gA = E.safeProp(AA.name);
          if (AA.resolvedType instanceof g) k("d%s=o.enums===String?%j:%j", gA, AA.resolvedType.valuesById[AA.typeDefault], AA.typeDefault);
          else if (AA.long) k("if(util.Long){")("var n=new util.Long(%i,%i,%j)", AA.typeDefault.low, AA.typeDefault.high, AA.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", gA)("}else")("d%s=o.longs===String?%j:%i", gA, AA.typeDefault.toString(), AA.typeDefault.toNumber());
          else if (AA.bytes) {
            var IA = "[" + Array.prototype.slice.call(AA.typeDefault).join(",") + "]";
            k("if(o.bytes===String)d%s=%j", gA, String.fromCharCode.apply(String, AA.typeDefault))("else{")("d%s=%s", gA, IA)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", gA, gA)("}");
          } else k("d%s=%j", gA, AA.typeDefault);
        }
        k("}");
      }
      var BA = !1;
      for (f = 0; f < d.length; ++f) {
        var AA = d[f], CA = h._fieldsArray.indexOf(AA), gA = E.safeProp(AA.name);
        AA.map ? (BA || (BA = !0, k("var ks2")), k("if(m%s&&(ks2=Object.keys(m%s)).length){", gA, gA)("d%s={}", gA)("for(var j=0;j<ks2.length;++j){"), t(
          k,
          AA,
          /* sorted */
          CA,
          gA + "[ks2[j]]"
        )("}")) : AA.repeated ? (k("if(m%s&&m%s.length){", gA, gA)("d%s=[]", gA)("for(var j=0;j<m%s.length;++j){", gA), t(
          k,
          AA,
          /* sorted */
          CA,
          gA + "[j]"
        )("}")) : (k("if(m%s!=null&&m.hasOwnProperty(%j)){", gA, AA.name), t(
          k,
          AA,
          /* sorted */
          CA,
          gA
        ), AA.partOf && k("if(o.oneofs)")("d%s=%j", E.safeProp(AA.partOf.name), AA.name)), k("}");
      }
      return k("return d");
    };
  })(converter)), converter;
}
var wrappers = {}, hasRequiredWrappers;
function requireWrappers() {
  return hasRequiredWrappers || (hasRequiredWrappers = 1, (function(o) {
    var i = o, g = requireMessage();
    i[".google.protobuf.Any"] = {
      fromObject: function(E) {
        if (E && E["@type"]) {
          var e = E["@type"].substring(E["@type"].lastIndexOf("/") + 1), t = this.lookup(e);
          if (t) {
            var n = E["@type"].charAt(0) === "." ? E["@type"].slice(1) : E["@type"];
            return n.indexOf("/") === -1 && (n = "/" + n), this.create({
              type_url: n,
              value: t.encode(t.fromObject(E)).finish()
            });
          }
        }
        return this.fromObject(E);
      },
      toObject: function(E, e) {
        var t = "type.googleapis.com/", n = "", h = "";
        if (e && e.json && E.type_url && E.value) {
          h = E.type_url.substring(E.type_url.lastIndexOf("/") + 1), n = E.type_url.substring(0, E.type_url.lastIndexOf("/") + 1);
          var d = this.lookup(h);
          d && (E = d.decode(E.value));
        }
        if (!(E instanceof this.ctor) && E instanceof g) {
          var k = E.$type.toObject(E, e), p = E.$type.fullName[0] === "." ? E.$type.fullName.slice(1) : E.$type.fullName;
          return n === "" && (n = t), h = n + p, k["@type"] = h, k;
        }
        return this.toObject(E, e);
      }
    };
  })(wrappers)), wrappers;
}
var type, hasRequiredType;
function requireType() {
  if (hasRequiredType) return type;
  hasRequiredType = 1, type = gA;
  var o = requireNamespace();
  ((gA.prototype = Object.create(o.prototype)).constructor = gA).className = "Type";
  var i = require_enum(), g = requireOneof(), E = requireField(), e = requireMapfield(), t = requireService(), n = requireMessage(), h = requireReader$1(), d = requireWriter$1(), k = requireUtil(), p = requireEncoder(), M = requireDecoder(), H = requireVerifier(), f = requireConverter(), AA = requireWrappers();
  function gA(BA, CA) {
    o.call(this, BA, CA), this.fields = {}, this.oneofs = void 0, this.extensions = void 0, this.reserved = void 0, this.group = void 0, this._fieldsById = null, this._fieldsArray = null, this._oneofsArray = null, this._ctor = null;
  }
  Object.defineProperties(gA.prototype, {
    /**
     * Message fields by id.
     * @name Type#fieldsById
     * @type {Object.<number,Field>}
     * @readonly
     */
    fieldsById: {
      get: function() {
        if (this._fieldsById)
          return this._fieldsById;
        this._fieldsById = {};
        for (var BA = Object.keys(this.fields), CA = 0; CA < BA.length; ++CA) {
          var QA = this.fields[BA[CA]], iA = QA.id;
          if (this._fieldsById[iA])
            throw Error("duplicate id " + iA + " in " + this);
          this._fieldsById[iA] = QA;
        }
        return this._fieldsById;
      }
    },
    /**
     * Fields of this message as an array for iteration.
     * @name Type#fieldsArray
     * @type {Field[]}
     * @readonly
     */
    fieldsArray: {
      get: function() {
        return this._fieldsArray || (this._fieldsArray = k.toArray(this.fields));
      }
    },
    /**
     * Oneofs of this message as an array for iteration.
     * @name Type#oneofsArray
     * @type {OneOf[]}
     * @readonly
     */
    oneofsArray: {
      get: function() {
        return this._oneofsArray || (this._oneofsArray = k.toArray(this.oneofs));
      }
    },
    /**
     * The registered constructor, if any registered, otherwise a generic constructor.
     * Assigning a function replaces the internal constructor. If the function does not extend {@link Message} yet, its prototype will be setup accordingly and static methods will be populated. If it already extends {@link Message}, it will just replace the internal constructor.
     * @name Type#ctor
     * @type {Constructor<{}>}
     */
    ctor: {
      get: function() {
        return this._ctor || (this.ctor = gA.generateConstructor(this)());
      },
      set: function(BA) {
        var CA = BA.prototype;
        CA instanceof n || ((BA.prototype = new n()).constructor = BA, k.merge(BA.prototype, CA)), BA.$type = BA.prototype.$type = this, k.merge(BA, n, !0), this._ctor = BA;
        for (var QA = 0; QA < /* initializes */
        this.fieldsArray.length; ++QA)
          this._fieldsArray[QA].resolve();
        var iA = {};
        for (QA = 0; QA < /* initializes */
        this.oneofsArray.length; ++QA)
          iA[this._oneofsArray[QA].resolve().name] = {
            get: k.oneOfGetter(this._oneofsArray[QA].oneof),
            set: k.oneOfSetter(this._oneofsArray[QA].oneof)
          };
        QA && Object.defineProperties(BA.prototype, iA);
      }
    }
  }), gA.generateConstructor = function(CA) {
    for (var QA = k.codegen(["p"], CA.name), iA = 0, EA; iA < CA.fieldsArray.length; ++iA)
      (EA = CA._fieldsArray[iA]).map ? QA("this%s={}", k.safeProp(EA.name)) : EA.repeated && QA("this%s=[]", k.safeProp(EA.name));
    return QA("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)")("this[ks[i]]=p[ks[i]]");
  };
  function IA(BA) {
    return BA._fieldsById = BA._fieldsArray = BA._oneofsArray = null, delete BA.encode, delete BA.decode, delete BA.verify, BA;
  }
  return gA.fromJSON = function(CA, QA) {
    var iA = new gA(CA, QA.options);
    iA.extensions = QA.extensions, iA.reserved = QA.reserved;
    for (var EA = Object.keys(QA.fields), oA = 0; oA < EA.length; ++oA)
      iA.add(
        (typeof QA.fields[EA[oA]].keyType < "u" ? e.fromJSON : E.fromJSON)(EA[oA], QA.fields[EA[oA]])
      );
    if (QA.oneofs)
      for (EA = Object.keys(QA.oneofs), oA = 0; oA < EA.length; ++oA)
        iA.add(g.fromJSON(EA[oA], QA.oneofs[EA[oA]]));
    if (QA.nested)
      for (EA = Object.keys(QA.nested), oA = 0; oA < EA.length; ++oA) {
        var eA = QA.nested[EA[oA]];
        iA.add(
          // most to least likely
          (eA.id !== void 0 ? E.fromJSON : eA.fields !== void 0 ? gA.fromJSON : eA.values !== void 0 ? i.fromJSON : eA.methods !== void 0 ? t.fromJSON : o.fromJSON)(EA[oA], eA)
        );
      }
    return QA.extensions && QA.extensions.length && (iA.extensions = QA.extensions), QA.reserved && QA.reserved.length && (iA.reserved = QA.reserved), QA.group && (iA.group = !0), QA.comment && (iA.comment = QA.comment), QA.edition && (iA._edition = QA.edition), iA._defaultEdition = "proto3", iA;
  }, gA.prototype.toJSON = function(CA) {
    var QA = o.prototype.toJSON.call(this, CA), iA = CA ? !!CA.keepComments : !1;
    return k.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      QA && QA.options || void 0,
      "oneofs",
      o.arrayToJSON(this.oneofsArray, CA),
      "fields",
      o.arrayToJSON(this.fieldsArray.filter(function(EA) {
        return !EA.declaringField;
      }), CA) || {},
      "extensions",
      this.extensions && this.extensions.length ? this.extensions : void 0,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "group",
      this.group || void 0,
      "nested",
      QA && QA.nested || void 0,
      "comment",
      iA ? this.comment : void 0
    ]);
  }, gA.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    o.prototype.resolveAll.call(this);
    var CA = this.oneofsArray;
    for (iA = 0; iA < CA.length; )
      CA[iA++].resolve();
    for (var QA = this.fieldsArray, iA = 0; iA < QA.length; )
      QA[iA++].resolve();
    return this;
  }, gA.prototype._resolveFeaturesRecursive = function(CA) {
    return this._needsRecursiveFeatureResolution ? (CA = this._edition || CA, o.prototype._resolveFeaturesRecursive.call(this, CA), this.oneofsArray.forEach((QA) => {
      QA._resolveFeatures(CA);
    }), this.fieldsArray.forEach((QA) => {
      QA._resolveFeatures(CA);
    }), this) : this;
  }, gA.prototype.get = function(CA) {
    return this.fields[CA] || this.oneofs && this.oneofs[CA] || this.nested && this.nested[CA] || null;
  }, gA.prototype.add = function(CA) {
    if (this.get(CA.name))
      throw Error("duplicate name '" + CA.name + "' in " + this);
    if (CA instanceof E && CA.extend === void 0) {
      if (this._fieldsById ? (
        /* istanbul ignore next */
        this._fieldsById[CA.id]
      ) : this.fieldsById[CA.id])
        throw Error("duplicate id " + CA.id + " in " + this);
      if (this.isReservedId(CA.id))
        throw Error("id " + CA.id + " is reserved in " + this);
      if (this.isReservedName(CA.name))
        throw Error("name '" + CA.name + "' is reserved in " + this);
      return CA.parent && CA.parent.remove(CA), this.fields[CA.name] = CA, CA.message = this, CA.onAdd(this), IA(this);
    }
    return CA instanceof g ? (this.oneofs || (this.oneofs = {}), this.oneofs[CA.name] = CA, CA.onAdd(this), IA(this)) : o.prototype.add.call(this, CA);
  }, gA.prototype.remove = function(CA) {
    if (CA instanceof E && CA.extend === void 0) {
      if (!this.fields || this.fields[CA.name] !== CA)
        throw Error(CA + " is not a member of " + this);
      return delete this.fields[CA.name], CA.parent = null, CA.onRemove(this), IA(this);
    }
    if (CA instanceof g) {
      if (!this.oneofs || this.oneofs[CA.name] !== CA)
        throw Error(CA + " is not a member of " + this);
      return delete this.oneofs[CA.name], CA.parent = null, CA.onRemove(this), IA(this);
    }
    return o.prototype.remove.call(this, CA);
  }, gA.prototype.isReservedId = function(CA) {
    return o.isReservedId(this.reserved, CA);
  }, gA.prototype.isReservedName = function(CA) {
    return o.isReservedName(this.reserved, CA);
  }, gA.prototype.create = function(CA) {
    return new this.ctor(CA);
  }, gA.prototype.setup = function() {
    for (var CA = this.fullName, QA = [], iA = 0; iA < /* initializes */
    this.fieldsArray.length; ++iA)
      QA.push(this._fieldsArray[iA].resolve().resolvedType);
    this.encode = p(this)({
      Writer: d,
      types: QA,
      util: k
    }), this.decode = M(this)({
      Reader: h,
      types: QA,
      util: k
    }), this.verify = H(this)({
      types: QA,
      util: k
    }), this.fromObject = f.fromObject(this)({
      types: QA,
      util: k
    }), this.toObject = f.toObject(this)({
      types: QA,
      util: k
    });
    var EA = AA[CA];
    if (EA) {
      var oA = Object.create(this);
      oA.fromObject = this.fromObject, this.fromObject = EA.fromObject.bind(oA), oA.toObject = this.toObject, this.toObject = EA.toObject.bind(oA);
    }
    return this;
  }, gA.prototype.encode = function(CA, QA) {
    return this.setup().encode(CA, QA);
  }, gA.prototype.encodeDelimited = function(CA, QA) {
    return this.encode(CA, QA && QA.len ? QA.fork() : QA).ldelim();
  }, gA.prototype.decode = function(CA, QA) {
    return this.setup().decode(CA, QA);
  }, gA.prototype.decodeDelimited = function(CA) {
    return CA instanceof h || (CA = h.create(CA)), this.decode(CA, CA.uint32());
  }, gA.prototype.verify = function(CA) {
    return this.setup().verify(CA);
  }, gA.prototype.fromObject = function(CA) {
    return this.setup().fromObject(CA);
  }, gA.prototype.toObject = function(CA, QA) {
    return this.setup().toObject(CA, QA);
  }, gA.d = function(CA) {
    return function(iA) {
      k.decorateType(iA, CA);
    };
  }, type;
}
var root, hasRequiredRoot;
function requireRoot() {
  if (hasRequiredRoot) return root;
  hasRequiredRoot = 1, root = d;
  var o = requireNamespace();
  ((d.prototype = Object.create(o.prototype)).constructor = d).className = "Root";
  var i = requireField(), g = require_enum(), E = requireOneof(), e = requireUtil(), t, n, h;
  function d(H) {
    o.call(this, "", H), this.deferred = [], this.files = [], this._edition = "proto2", this._fullyQualifiedObjects = {};
  }
  d.fromJSON = function(f, AA) {
    return AA || (AA = new d()), f.options && AA.setOptions(f.options), AA.addJSON(f.nested).resolveAll();
  }, d.prototype.resolvePath = e.path.resolve, d.prototype.fetch = e.fetch;
  function k() {
  }
  d.prototype.load = function H(f, AA, gA) {
    typeof AA == "function" && (gA = AA, AA = void 0);
    var IA = this;
    if (!gA)
      return e.asPromise(H, IA, f, AA);
    var BA = gA === k;
    function CA(cA, tA) {
      if (gA) {
        if (BA)
          throw cA;
        tA && tA.resolveAll();
        var aA = gA;
        gA = null, aA(cA, tA);
      }
    }
    function QA(cA) {
      var tA = cA.lastIndexOf("google/protobuf/");
      if (tA > -1) {
        var aA = cA.substring(tA);
        if (aA in h) return aA;
      }
      return null;
    }
    function iA(cA, tA) {
      try {
        if (e.isString(tA) && tA.charAt(0) === "{" && (tA = JSON.parse(tA)), !e.isString(tA))
          IA.setOptions(tA.options).addJSON(tA.nested);
        else {
          n.filename = cA;
          var aA = n(tA, IA, AA), sA, DA = 0;
          if (aA.imports)
            for (; DA < aA.imports.length; ++DA)
              (sA = QA(aA.imports[DA]) || IA.resolvePath(cA, aA.imports[DA])) && EA(sA);
          if (aA.weakImports)
            for (DA = 0; DA < aA.weakImports.length; ++DA)
              (sA = QA(aA.weakImports[DA]) || IA.resolvePath(cA, aA.weakImports[DA])) && EA(sA, !0);
        }
      } catch (rA) {
        CA(rA);
      }
      !BA && !oA && CA(null, IA);
    }
    function EA(cA, tA) {
      if (cA = QA(cA) || cA, !(IA.files.indexOf(cA) > -1)) {
        if (IA.files.push(cA), cA in h) {
          BA ? iA(cA, h[cA]) : (++oA, setTimeout(function() {
            --oA, iA(cA, h[cA]);
          }));
          return;
        }
        if (BA) {
          var aA;
          try {
            aA = e.fs.readFileSync(cA).toString("utf8");
          } catch (sA) {
            tA || CA(sA);
            return;
          }
          iA(cA, aA);
        } else
          ++oA, IA.fetch(cA, function(sA, DA) {
            if (--oA, !!gA) {
              if (sA) {
                tA ? oA || CA(null, IA) : CA(sA);
                return;
              }
              iA(cA, DA);
            }
          });
      }
    }
    var oA = 0;
    e.isString(f) && (f = [f]);
    for (var eA = 0, GA; eA < f.length; ++eA)
      (GA = IA.resolvePath("", f[eA])) && EA(GA);
    return BA ? (IA.resolveAll(), IA) : (oA || CA(null, IA), IA);
  }, d.prototype.loadSync = function(f, AA) {
    if (!e.isNode)
      throw Error("not supported");
    return this.load(f, AA, k);
  }, d.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    if (this.deferred.length)
      throw Error("unresolvable extensions: " + this.deferred.map(function(f) {
        return "'extend " + f.extend + "' in " + f.parent.fullName;
      }).join(", "));
    return o.prototype.resolveAll.call(this);
  };
  var p = /^[A-Z]/;
  function M(H, f) {
    var AA = f.parent.lookup(f.extend);
    if (AA) {
      var gA = new i(f.fullName, f.id, f.type, f.rule, void 0, f.options);
      return AA.get(gA.name) || (gA.declaringField = f, f.extensionField = gA, AA.add(gA)), !0;
    }
    return !1;
  }
  return d.prototype._handleAdd = function(f) {
    if (f instanceof i)
      /* an extension field (implies not part of a oneof) */
      f.extend !== void 0 && /* not already handled */
      !f.extensionField && (M(this, f) || this.deferred.push(f));
    else if (f instanceof g)
      p.test(f.name) && (f.parent[f.name] = f.values);
    else if (!(f instanceof E)) {
      if (f instanceof t)
        for (var AA = 0; AA < this.deferred.length; )
          M(this, this.deferred[AA]) ? this.deferred.splice(AA, 1) : ++AA;
      for (var gA = 0; gA < /* initializes */
      f.nestedArray.length; ++gA)
        this._handleAdd(f._nestedArray[gA]);
      p.test(f.name) && (f.parent[f.name] = f);
    }
    (f instanceof t || f instanceof g || f instanceof i) && (this._fullyQualifiedObjects[f.fullName] = f);
  }, d.prototype._handleRemove = function(f) {
    if (f instanceof i) {
      if (
        /* an extension field */
        f.extend !== void 0
      )
        if (
          /* already handled */
          f.extensionField
        )
          f.extensionField.parent.remove(f.extensionField), f.extensionField = null;
        else {
          var AA = this.deferred.indexOf(f);
          AA > -1 && this.deferred.splice(AA, 1);
        }
    } else if (f instanceof g)
      p.test(f.name) && delete f.parent[f.name];
    else if (f instanceof o) {
      for (var gA = 0; gA < /* initializes */
      f.nestedArray.length; ++gA)
        this._handleRemove(f._nestedArray[gA]);
      p.test(f.name) && delete f.parent[f.name];
    }
    delete this._fullyQualifiedObjects[f.fullName];
  }, d._configure = function(H, f, AA) {
    t = H, n = f, h = AA;
  }, root;
}
var hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util.exports;
  hasRequiredUtil = 1;
  var o = util.exports = requireMinimal$3(), i = requireRoots$1(), g, E;
  o.codegen = requireCodegen(), o.fetch = requireFetch(), o.path = requirePath(), o.fs = o.inquire("fs"), o.toArray = function(k) {
    if (k) {
      for (var p = Object.keys(k), M = new Array(p.length), H = 0; H < p.length; )
        M[H] = k[p[H++]];
      return M;
    }
    return [];
  }, o.toObject = function(k) {
    for (var p = {}, M = 0; M < k.length; ) {
      var H = k[M++], f = k[M++];
      f !== void 0 && (p[H] = f);
    }
    return p;
  };
  var e = /\\/g, t = /"/g;
  o.isReserved = function(k) {
    return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(k);
  }, o.safeProp = function(k) {
    return !/^[$\w_]+$/.test(k) || o.isReserved(k) ? '["' + k.replace(e, "\\\\").replace(t, '\\"') + '"]' : "." + k;
  }, o.ucFirst = function(k) {
    return k.charAt(0).toUpperCase() + k.substring(1);
  };
  var n = /_([a-z])/g;
  o.camelCase = function(k) {
    return k.substring(0, 1) + k.substring(1).replace(n, function(p, M) {
      return M.toUpperCase();
    });
  }, o.compareFieldsById = function(k, p) {
    return k.id - p.id;
  }, o.decorateType = function(k, p) {
    if (k.$type)
      return p && k.$type.name !== p && (o.decorateRoot.remove(k.$type), k.$type.name = p, o.decorateRoot.add(k.$type)), k.$type;
    g || (g = requireType());
    var M = new g(p || k.name);
    return o.decorateRoot.add(M), M.ctor = k, Object.defineProperty(k, "$type", { value: M, enumerable: !1 }), Object.defineProperty(k.prototype, "$type", { value: M, enumerable: !1 }), M;
  };
  var h = 0;
  return o.decorateEnum = function(k) {
    if (k.$type)
      return k.$type;
    E || (E = require_enum());
    var p = new E("Enum" + h++, k);
    return o.decorateRoot.add(p), Object.defineProperty(k, "$type", { value: p, enumerable: !1 }), p;
  }, o.setProperty = function(k, p, M, H) {
    function f(AA, gA, IA) {
      var BA = gA.shift();
      if (BA === "__proto__" || BA === "prototype")
        return AA;
      if (gA.length > 0)
        AA[BA] = f(AA[BA] || {}, gA, IA);
      else {
        var CA = AA[BA];
        if (CA && H)
          return AA;
        CA && (IA = [].concat(CA).concat(IA)), AA[BA] = IA;
      }
      return AA;
    }
    if (typeof k != "object")
      throw TypeError("dst must be an object");
    if (!p)
      throw TypeError("path must be specified");
    return p = p.split("."), f(k, p, M);
  }, Object.defineProperty(o, "decorateRoot", {
    get: function() {
      return i.decorated || (i.decorated = new (requireRoot())());
    }
  }), util.exports;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, (function(o) {
    var i = o, g = requireUtil(), E = [
      "double",
      // 0
      "float",
      // 1
      "int32",
      // 2
      "uint32",
      // 3
      "sint32",
      // 4
      "fixed32",
      // 5
      "sfixed32",
      // 6
      "int64",
      // 7
      "uint64",
      // 8
      "sint64",
      // 9
      "fixed64",
      // 10
      "sfixed64",
      // 11
      "bool",
      // 12
      "string",
      // 13
      "bytes"
      // 14
    ];
    function e(t, n) {
      var h = 0, d = {};
      for (n |= 0; h < t.length; ) d[E[h + n]] = t[h++];
      return d;
    }
    i.basic = e([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2,
      /* bytes    */
      2
    ]), i.defaults = e([
      /* double   */
      0,
      /* float    */
      0,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      0,
      /* sfixed32 */
      0,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      0,
      /* sfixed64 */
      0,
      /* bool     */
      !1,
      /* string   */
      "",
      /* bytes    */
      g.emptyArray,
      /* message  */
      null
    ]), i.long = e([
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1
    ], 7), i.mapKey = e([
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2
    ], 2), i.packed = e([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0
    ]);
  })(types)), types;
}
var field, hasRequiredField;
function requireField() {
  if (hasRequiredField) return field;
  hasRequiredField = 1, field = n;
  var o = requireObject();
  ((n.prototype = Object.create(o.prototype)).constructor = n).className = "Field";
  var i = require_enum(), g = requireTypes(), E = requireUtil(), e, t = /^required|optional|repeated$/;
  n.fromJSON = function(d, k) {
    var p = new n(d, k.id, k.type, k.rule, k.extend, k.options, k.comment);
    return k.edition && (p._edition = k.edition), p._defaultEdition = "proto3", p;
  };
  function n(h, d, k, p, M, H, f) {
    if (E.isObject(p) ? (f = M, H = p, p = M = void 0) : E.isObject(M) && (f = H, H = M, M = void 0), o.call(this, h, H), !E.isInteger(d) || d < 0)
      throw TypeError("id must be a non-negative integer");
    if (!E.isString(k))
      throw TypeError("type must be a string");
    if (p !== void 0 && !t.test(p = p.toString().toLowerCase()))
      throw TypeError("rule must be a string rule");
    if (M !== void 0 && !E.isString(M))
      throw TypeError("extend must be a string");
    p === "proto3_optional" && (p = "optional"), this.rule = p && p !== "optional" ? p : void 0, this.type = k, this.id = d, this.extend = M || void 0, this.repeated = p === "repeated", this.map = !1, this.message = null, this.partOf = null, this.typeDefault = null, this.defaultValue = null, this.long = E.Long ? g.long[k] !== void 0 : (
      /* istanbul ignore next */
      !1
    ), this.bytes = k === "bytes", this.resolvedType = null, this.extensionField = null, this.declaringField = null, this.comment = f;
  }
  return Object.defineProperty(n.prototype, "required", {
    get: function() {
      return this._features.field_presence === "LEGACY_REQUIRED";
    }
  }), Object.defineProperty(n.prototype, "optional", {
    get: function() {
      return !this.required;
    }
  }), Object.defineProperty(n.prototype, "delimited", {
    get: function() {
      return this.resolvedType instanceof e && this._features.message_encoding === "DELIMITED";
    }
  }), Object.defineProperty(n.prototype, "packed", {
    get: function() {
      return this._features.repeated_field_encoding === "PACKED";
    }
  }), Object.defineProperty(n.prototype, "hasPresence", {
    get: function() {
      return this.repeated || this.map ? !1 : this.partOf || // oneofs
      this.declaringField || this.extensionField || // extensions
      this._features.field_presence !== "IMPLICIT";
    }
  }), n.prototype.setOption = function(d, k, p) {
    return o.prototype.setOption.call(this, d, k, p);
  }, n.prototype.toJSON = function(d) {
    var k = d ? !!d.keepComments : !1;
    return E.toObject([
      "edition",
      this._editionToJSON(),
      "rule",
      this.rule !== "optional" && this.rule || void 0,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      k ? this.comment : void 0
    ]);
  }, n.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if ((this.typeDefault = g.defaults[this.type]) === void 0 ? (this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type), this.resolvedType instanceof e ? this.typeDefault = null : this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]) : this.options && this.options.proto3_optional && (this.typeDefault = null), this.options && this.options.default != null && (this.typeDefault = this.options.default, this.resolvedType instanceof i && typeof this.typeDefault == "string" && (this.typeDefault = this.resolvedType.values[this.typeDefault])), this.options && (this.options.packed !== void 0 && this.resolvedType && !(this.resolvedType instanceof i) && delete this.options.packed, Object.keys(this.options).length || (this.options = void 0)), this.long)
      this.typeDefault = E.Long.fromNumber(this.typeDefault, this.type.charAt(0) === "u"), Object.freeze && Object.freeze(this.typeDefault);
    else if (this.bytes && typeof this.typeDefault == "string") {
      var d;
      E.base64.test(this.typeDefault) ? E.base64.decode(this.typeDefault, d = E.newBuffer(E.base64.length(this.typeDefault)), 0) : E.utf8.write(this.typeDefault, d = E.newBuffer(E.utf8.length(this.typeDefault)), 0), this.typeDefault = d;
    }
    return this.map ? this.defaultValue = E.emptyObject : this.repeated ? this.defaultValue = E.emptyArray : this.defaultValue = this.typeDefault, this.parent instanceof e && (this.parent.ctor.prototype[this.name] = this.defaultValue), o.prototype.resolve.call(this);
  }, n.prototype._inferLegacyProtoFeatures = function(d) {
    if (d !== "proto2" && d !== "proto3")
      return {};
    var k = {};
    if (this.rule === "required" && (k.field_presence = "LEGACY_REQUIRED"), this.parent && g.defaults[this.type] === void 0) {
      var p = this.parent.get(this.type.split(".").pop());
      p && p instanceof e && p.group && (k.message_encoding = "DELIMITED");
    }
    return this.getOption("packed") === !0 ? k.repeated_field_encoding = "PACKED" : this.getOption("packed") === !1 && (k.repeated_field_encoding = "EXPANDED"), k;
  }, n.prototype._resolveFeatures = function(d) {
    return o.prototype._resolveFeatures.call(this, this._edition || d);
  }, n.d = function(d, k, p, M) {
    return typeof k == "function" ? k = E.decorateType(k).name : k && typeof k == "object" && (k = E.decorateEnum(k).name), function(f, AA) {
      E.decorateType(f.constructor).add(new n(AA, d, k, p, { default: M }));
    };
  }, n._configure = function(d) {
    e = d;
  }, field;
}
var oneof, hasRequiredOneof;
function requireOneof() {
  if (hasRequiredOneof) return oneof;
  hasRequiredOneof = 1, oneof = E;
  var o = requireObject();
  ((E.prototype = Object.create(o.prototype)).constructor = E).className = "OneOf";
  var i = requireField(), g = requireUtil();
  function E(t, n, h, d) {
    if (Array.isArray(n) || (h = n, n = void 0), o.call(this, t, h), !(n === void 0 || Array.isArray(n)))
      throw TypeError("fieldNames must be an Array");
    this.oneof = n || [], this.fieldsArray = [], this.comment = d;
  }
  E.fromJSON = function(n, h) {
    return new E(n, h.oneof, h.options, h.comment);
  }, E.prototype.toJSON = function(n) {
    var h = n ? !!n.keepComments : !1;
    return g.toObject([
      "options",
      this.options,
      "oneof",
      this.oneof,
      "comment",
      h ? this.comment : void 0
    ]);
  };
  function e(t) {
    if (t.parent)
      for (var n = 0; n < t.fieldsArray.length; ++n)
        t.fieldsArray[n].parent || t.parent.add(t.fieldsArray[n]);
  }
  return E.prototype.add = function(n) {
    if (!(n instanceof i))
      throw TypeError("field must be a Field");
    return n.parent && n.parent !== this.parent && n.parent.remove(n), this.oneof.push(n.name), this.fieldsArray.push(n), n.partOf = this, e(this), this;
  }, E.prototype.remove = function(n) {
    if (!(n instanceof i))
      throw TypeError("field must be a Field");
    var h = this.fieldsArray.indexOf(n);
    if (h < 0)
      throw Error(n + " is not a member of " + this);
    return this.fieldsArray.splice(h, 1), h = this.oneof.indexOf(n.name), h > -1 && this.oneof.splice(h, 1), n.partOf = null, this;
  }, E.prototype.onAdd = function(n) {
    o.prototype.onAdd.call(this, n);
    for (var h = this, d = 0; d < this.oneof.length; ++d) {
      var k = n.get(this.oneof[d]);
      k && !k.partOf && (k.partOf = h, h.fieldsArray.push(k));
    }
    e(this);
  }, E.prototype.onRemove = function(n) {
    for (var h = 0, d; h < this.fieldsArray.length; ++h)
      (d = this.fieldsArray[h]).parent && d.parent.remove(d);
    o.prototype.onRemove.call(this, n);
  }, Object.defineProperty(E.prototype, "isProto3Optional", {
    get: function() {
      if (this.fieldsArray == null || this.fieldsArray.length !== 1)
        return !1;
      var t = this.fieldsArray[0];
      return t.options != null && t.options.proto3_optional === !0;
    }
  }), E.d = function() {
    for (var n = new Array(arguments.length), h = 0; h < arguments.length; )
      n[h] = arguments[h++];
    return function(k, p) {
      g.decorateType(k.constructor).add(new E(p, n)), Object.defineProperty(k, p, {
        get: g.oneOfGetter(n),
        set: g.oneOfSetter(n)
      });
    };
  }, oneof;
}
var object, hasRequiredObject;
function requireObject() {
  if (hasRequiredObject) return object;
  hasRequiredObject = 1, object = h, h.className = "ReflectionObject";
  const o = requireOneof();
  var i = requireUtil(), g, E = { enum_type: "OPEN", field_presence: "EXPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY", enforce_naming_style: "STYLE2024", default_symbol_visibility: "EXPORT_TOP_LEVEL" }, e = { enum_type: "OPEN", field_presence: "EXPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY", enforce_naming_style: "STYLE_LEGACY", default_symbol_visibility: "EXPORT_ALL" }, t = { enum_type: "CLOSED", field_presence: "EXPLICIT", json_format: "LEGACY_BEST_EFFORT", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "EXPANDED", utf8_validation: "NONE", enforce_naming_style: "STYLE_LEGACY", default_symbol_visibility: "EXPORT_ALL" }, n = { enum_type: "OPEN", field_presence: "IMPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY", enforce_naming_style: "STYLE_LEGACY", default_symbol_visibility: "EXPORT_ALL" };
  function h(d, k) {
    if (!i.isString(d))
      throw TypeError("name must be a string");
    if (k && !i.isObject(k))
      throw TypeError("options must be an object");
    this.options = k, this.parsedOptions = null, this.name = d, this._edition = null, this._defaultEdition = "proto2", this._features = {}, this._featuresResolved = !1, this.parent = null, this.resolved = !1, this.comment = null, this.filename = null;
  }
  return Object.defineProperties(h.prototype, {
    /**
     * Reference to the root namespace.
     * @name ReflectionObject#root
     * @type {Root}
     * @readonly
     */
    root: {
      get: function() {
        for (var d = this; d.parent !== null; )
          d = d.parent;
        return d;
      }
    },
    /**
     * Full name including leading dot.
     * @name ReflectionObject#fullName
     * @type {string}
     * @readonly
     */
    fullName: {
      get: function() {
        for (var d = [this.name], k = this.parent; k; )
          d.unshift(k.name), k = k.parent;
        return d.join(".");
      }
    }
  }), h.prototype.toJSON = /* istanbul ignore next */
  function() {
    throw Error();
  }, h.prototype.onAdd = function(k) {
    this.parent && this.parent !== k && this.parent.remove(this), this.parent = k, this.resolved = !1;
    var p = k.root;
    p instanceof g && p._handleAdd(this);
  }, h.prototype.onRemove = function(k) {
    var p = k.root;
    p instanceof g && p._handleRemove(this), this.parent = null, this.resolved = !1;
  }, h.prototype.resolve = function() {
    return this.resolved ? this : (this.root instanceof g && (this.resolved = !0), this);
  }, h.prototype._resolveFeaturesRecursive = function(k) {
    return this._resolveFeatures(this._edition || k);
  }, h.prototype._resolveFeatures = function(k) {
    if (!this._featuresResolved) {
      var p = {};
      if (!k)
        throw new Error("Unknown edition for " + this.fullName);
      var M = Object.assign(
        this.options ? Object.assign({}, this.options.features) : {},
        this._inferLegacyProtoFeatures(k)
      );
      if (this._edition) {
        if (k === "proto2")
          p = Object.assign({}, t);
        else if (k === "proto3")
          p = Object.assign({}, n);
        else if (k === "2023")
          p = Object.assign({}, e);
        else if (k === "2024")
          p = Object.assign({}, E);
        else
          throw new Error("Unknown edition: " + k);
        this._features = Object.assign(p, M || {}), this._featuresResolved = !0;
        return;
      }
      if (this.partOf instanceof o) {
        var H = Object.assign({}, this.partOf._features);
        this._features = Object.assign(H, M || {});
      } else if (!this.declaringField) if (this.parent) {
        var f = Object.assign({}, this.parent._features);
        this._features = Object.assign(f, M || {});
      } else
        throw new Error("Unable to find a parent for " + this.fullName);
      this.extensionField && (this.extensionField._features = this._features), this._featuresResolved = !0;
    }
  }, h.prototype._inferLegacyProtoFeatures = function() {
    return {};
  }, h.prototype.getOption = function(k) {
    if (this.options)
      return this.options[k];
  }, h.prototype.setOption = function(k, p, M) {
    return this.options || (this.options = {}), /^features\./.test(k) ? i.setProperty(this.options, k, p, M) : (!M || this.options[k] === void 0) && (this.getOption(k) !== p && (this.resolved = !1), this.options[k] = p), this;
  }, h.prototype.setParsedOption = function(k, p, M) {
    this.parsedOptions || (this.parsedOptions = []);
    var H = this.parsedOptions;
    if (M) {
      var f = H.find(function(IA) {
        return Object.prototype.hasOwnProperty.call(IA, k);
      });
      if (f) {
        var AA = f[k];
        i.setProperty(AA, M, p);
      } else
        f = {}, f[k] = i.setProperty({}, M, p), H.push(f);
    } else {
      var gA = {};
      gA[k] = p, H.push(gA);
    }
    return this;
  }, h.prototype.setOptions = function(k, p) {
    if (k)
      for (var M = Object.keys(k), H = 0; H < M.length; ++H)
        this.setOption(M[H], k[M[H]], p);
    return this;
  }, h.prototype.toString = function() {
    var k = this.constructor.className, p = this.fullName;
    return p.length ? k + " " + p : k;
  }, h.prototype._editionToJSON = function() {
    if (!(!this._edition || this._edition === "proto3"))
      return this._edition;
  }, h._configure = function(d) {
    g = d;
  }, object;
}
var _enum, hasRequired_enum;
function require_enum() {
  if (hasRequired_enum) return _enum;
  hasRequired_enum = 1, _enum = E;
  var o = requireObject();
  ((E.prototype = Object.create(o.prototype)).constructor = E).className = "Enum";
  var i = requireNamespace(), g = requireUtil();
  function E(e, t, n, h, d, k) {
    if (o.call(this, e, n), t && typeof t != "object")
      throw TypeError("values must be an object");
    if (this.valuesById = {}, this.values = Object.create(this.valuesById), this.comment = h, this.comments = d || {}, this.valuesOptions = k, this._valuesFeatures = {}, this.reserved = void 0, t)
      for (var p = Object.keys(t), M = 0; M < p.length; ++M)
        typeof t[p[M]] == "number" && (this.valuesById[this.values[p[M]] = t[p[M]]] = p[M]);
  }
  return E.prototype._resolveFeatures = function(t) {
    return t = this._edition || t, o.prototype._resolveFeatures.call(this, t), Object.keys(this.values).forEach((n) => {
      var h = Object.assign({}, this._features);
      this._valuesFeatures[n] = Object.assign(h, this.valuesOptions && this.valuesOptions[n] && this.valuesOptions[n].features);
    }), this;
  }, E.fromJSON = function(t, n) {
    var h = new E(t, n.values, n.options, n.comment, n.comments);
    return h.reserved = n.reserved, n.edition && (h._edition = n.edition), h._defaultEdition = "proto3", h;
  }, E.prototype.toJSON = function(t) {
    var n = t ? !!t.keepComments : !1;
    return g.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      this.options,
      "valuesOptions",
      this.valuesOptions,
      "values",
      this.values,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "comment",
      n ? this.comment : void 0,
      "comments",
      n ? this.comments : void 0
    ]);
  }, E.prototype.add = function(t, n, h, d) {
    if (!g.isString(t))
      throw TypeError("name must be a string");
    if (!g.isInteger(n))
      throw TypeError("id must be an integer");
    if (this.values[t] !== void 0)
      throw Error("duplicate name '" + t + "' in " + this);
    if (this.isReservedId(n))
      throw Error("id " + n + " is reserved in " + this);
    if (this.isReservedName(t))
      throw Error("name '" + t + "' is reserved in " + this);
    if (this.valuesById[n] !== void 0) {
      if (!(this.options && this.options.allow_alias))
        throw Error("duplicate id " + n + " in " + this);
      this.values[t] = n;
    } else
      this.valuesById[this.values[t] = n] = t;
    return d && (this.valuesOptions === void 0 && (this.valuesOptions = {}), this.valuesOptions[t] = d || null), this.comments[t] = h || null, this;
  }, E.prototype.remove = function(t) {
    if (!g.isString(t))
      throw TypeError("name must be a string");
    var n = this.values[t];
    if (n == null)
      throw Error("name '" + t + "' does not exist in " + this);
    return delete this.valuesById[n], delete this.values[t], delete this.comments[t], this.valuesOptions && delete this.valuesOptions[t], this;
  }, E.prototype.isReservedId = function(t) {
    return i.isReservedId(this.reserved, t);
  }, E.prototype.isReservedName = function(t) {
    return i.isReservedName(this.reserved, t);
  }, _enum;
}
var encoder_1, hasRequiredEncoder;
function requireEncoder() {
  if (hasRequiredEncoder) return encoder_1;
  hasRequiredEncoder = 1, encoder_1 = e;
  var o = require_enum(), i = requireTypes(), g = requireUtil();
  function E(t, n, h, d) {
    return n.delimited ? t("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", h, d, (n.id << 3 | 3) >>> 0, (n.id << 3 | 4) >>> 0) : t("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", h, d, (n.id << 3 | 2) >>> 0);
  }
  function e(t) {
    for (var n = g.codegen(["m", "w"], t.name + "$encode")("if(!w)")("w=Writer.create()"), h, d, k = (
      /* initializes */
      t.fieldsArray.slice().sort(g.compareFieldsById)
    ), h = 0; h < k.length; ++h) {
      var p = k[h].resolve(), M = t._fieldsArray.indexOf(p), H = p.resolvedType instanceof o ? "int32" : p.type, f = i.basic[H];
      d = "m" + g.safeProp(p.name), p.map ? (n("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", d, p.name)("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", d)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (p.id << 3 | 2) >>> 0, 8 | i.mapKey[p.keyType], p.keyType), f === void 0 ? n("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", M, d) : n(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | f, H, d), n("}")("}")) : p.repeated ? (n("if(%s!=null&&%s.length){", d, d), p.packed && i.packed[H] !== void 0 ? n("w.uint32(%i).fork()", (p.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", d)("w.%s(%s[i])", H, d)("w.ldelim()") : (n("for(var i=0;i<%s.length;++i)", d), f === void 0 ? E(n, p, M, d + "[i]") : n("w.uint32(%i).%s(%s[i])", (p.id << 3 | f) >>> 0, H, d)), n("}")) : (p.optional && n("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", d, p.name), f === void 0 ? E(n, p, M, d) : n("w.uint32(%i).%s(%s)", (p.id << 3 | f) >>> 0, H, d));
    }
    return n("return w");
  }
  return encoder_1;
}
var hasRequiredIndexLight;
function requireIndexLight() {
  if (hasRequiredIndexLight) return indexLight.exports;
  hasRequiredIndexLight = 1;
  var o = indexLight.exports = requireIndexMinimal$1();
  o.build = "light";
  function i(E, e, t) {
    return typeof e == "function" ? (t = e, e = new o.Root()) : e || (e = new o.Root()), e.load(E, t);
  }
  o.load = i;
  function g(E, e) {
    return e || (e = new o.Root()), e.loadSync(E);
  }
  return o.loadSync = g, o.encoder = requireEncoder(), o.decoder = requireDecoder(), o.verifier = requireVerifier(), o.converter = requireConverter(), o.ReflectionObject = requireObject(), o.Namespace = requireNamespace(), o.Root = requireRoot(), o.Enum = require_enum(), o.Type = requireType(), o.Field = requireField(), o.OneOf = requireOneof(), o.MapField = requireMapfield(), o.Service = requireService(), o.Method = requireMethod(), o.Message = requireMessage(), o.wrappers = requireWrappers(), o.types = requireTypes(), o.util = requireUtil(), o.ReflectionObject._configure(o.Root), o.Namespace._configure(o.Type, o.Service, o.Enum), o.Root._configure(o.Type), o.Field._configure(o.Type), indexLight.exports;
}
var tokenize_1, hasRequiredTokenize;
function requireTokenize() {
  if (hasRequiredTokenize) return tokenize_1;
  hasRequiredTokenize = 1, tokenize_1 = p;
  var o = /[\s{}=;:[\],'"()<>]/g, i = /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g, g = /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g, E = /^ *[*/]+ */, e = /^\s*\*?\/*/, t = /\n/g, n = /\s/, h = /\\(.?)/g, d = {
    0: "\0",
    r: "\r",
    n: `
`,
    t: "	"
  };
  function k(M) {
    return M.replace(h, function(H, f) {
      switch (f) {
        case "\\":
        case "":
          return f;
        default:
          return d[f] || "";
      }
    });
  }
  p.unescape = k;
  function p(M, H) {
    M = M.toString();
    var f = 0, AA = M.length, gA = 1, IA = 0, BA = {}, CA = [], QA = null;
    function iA(nA) {
      return Error("illegal " + nA + " (line " + gA + ")");
    }
    function EA() {
      var nA = QA === "'" ? g : i;
      nA.lastIndex = f - 1;
      var NA = nA.exec(M);
      if (!NA)
        throw iA("string");
      return f = nA.lastIndex, aA(QA), QA = null, k(NA[1]);
    }
    function oA(nA) {
      return M.charAt(nA);
    }
    function eA(nA, NA, pA) {
      var mA = {
        type: M.charAt(nA++),
        lineEmpty: !1,
        leading: pA
      }, XA;
      H ? XA = 2 : XA = 3;
      var lA = nA - XA, kA;
      do
        if (--lA < 0 || (kA = M.charAt(lA)) === `
`) {
          mA.lineEmpty = !0;
          break;
        }
      while (kA === " " || kA === "	");
      for (var ZA = M.substring(nA, NA).split(t), wA = 0; wA < ZA.length; ++wA)
        ZA[wA] = ZA[wA].replace(H ? e : E, "").trim();
      mA.text = ZA.join(`
`).trim(), BA[gA] = mA, IA = gA;
    }
    function GA(nA) {
      var NA = cA(nA), pA = M.substring(nA, NA), mA = /^\s*\/\//.test(pA);
      return mA;
    }
    function cA(nA) {
      for (var NA = nA; NA < AA && oA(NA) !== `
`; )
        NA++;
      return NA;
    }
    function tA() {
      if (CA.length > 0)
        return CA.shift();
      if (QA)
        return EA();
      var nA, NA, pA, mA, XA, lA = f === 0;
      do {
        if (f === AA)
          return null;
        for (nA = !1; n.test(pA = oA(f)); )
          if (pA === `
` && (lA = !0, ++gA), ++f === AA)
            return null;
        if (oA(f) === "/") {
          if (++f === AA)
            throw iA("comment");
          if (oA(f) === "/")
            if (H) {
              if (mA = f, XA = !1, GA(f - 1)) {
                XA = !0;
                do
                  if (f = cA(f), f === AA || (f++, !lA))
                    break;
                while (GA(f));
              } else
                f = Math.min(AA, cA(f) + 1);
              XA && (eA(mA, f, lA), lA = !0), gA++, nA = !0;
            } else {
              for (XA = oA(mA = f + 1) === "/"; oA(++f) !== `
`; )
                if (f === AA)
                  return null;
              ++f, XA && (eA(mA, f - 1, lA), lA = !0), ++gA, nA = !0;
            }
          else if ((pA = oA(f)) === "*") {
            mA = f + 1, XA = H || oA(mA) === "*";
            do {
              if (pA === `
` && ++gA, ++f === AA)
                throw iA("comment");
              NA = pA, pA = oA(f);
            } while (NA !== "*" || pA !== "/");
            ++f, XA && (eA(mA, f - 2, lA), lA = !0), nA = !0;
          } else
            return "/";
        }
      } while (nA);
      var kA = f;
      o.lastIndex = 0;
      var ZA = o.test(oA(kA++));
      if (!ZA)
        for (; kA < AA && !o.test(oA(kA)); )
          ++kA;
      var wA = M.substring(f, f = kA);
      return (wA === '"' || wA === "'") && (QA = wA), wA;
    }
    function aA(nA) {
      CA.push(nA);
    }
    function sA() {
      if (!CA.length) {
        var nA = tA();
        if (nA === null)
          return null;
        aA(nA);
      }
      return CA[0];
    }
    function DA(nA, NA) {
      var pA = sA(), mA = pA === nA;
      if (mA)
        return tA(), !0;
      if (!NA)
        throw iA("token '" + pA + "', '" + nA + "' expected");
      return !1;
    }
    function rA(nA) {
      var NA = null, pA;
      return nA === void 0 ? (pA = BA[gA - 1], delete BA[gA - 1], pA && (H || pA.type === "*" || pA.lineEmpty) && (NA = pA.leading ? pA.text : null)) : (IA < nA && sA(), pA = BA[nA], delete BA[nA], pA && !pA.lineEmpty && (H || pA.type === "/") && (NA = pA.leading ? null : pA.text)), NA;
    }
    return Object.defineProperty({
      next: tA,
      peek: sA,
      push: aA,
      skip: DA,
      cmnt: rA
    }, "line", {
      get: function() {
        return gA;
      }
    });
  }
  return tokenize_1;
}
var parse_1, hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1, parse_1 = EA, EA.filename = null, EA.defaults = { keepCase: !1 };
  var o = requireTokenize(), i = requireRoot(), g = requireType(), E = requireField(), e = requireMapfield(), t = requireOneof(), n = require_enum(), h = requireService(), d = requireMethod(), k = requireObject(), p = requireTypes(), M = requireUtil(), H = /^[1-9][0-9]*$/, f = /^-?[1-9][0-9]*$/, AA = /^0[x][0-9a-fA-F]+$/, gA = /^-?0[x][0-9a-fA-F]+$/, IA = /^0[0-7]+$/, BA = /^-?0[0-7]+$/, CA = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/, QA = /^[a-zA-Z_][a-zA-Z_0-9]*$/, iA = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/;
  function EA(oA, eA, GA) {
    eA instanceof i || (GA = eA, eA = new i()), GA || (GA = EA.defaults);
    var cA = GA.preferTrailingComment || !1, tA = o(oA, GA.alternateCommentMode || !1), aA = tA.next, sA = tA.push, DA = tA.peek, rA = tA.skip, nA = tA.cmnt, NA = !0, pA, mA, XA, lA = "proto2", kA = eA, ZA = [], wA = {}, LA = GA.keepCase ? function(yA) {
      return yA;
    } : M.camelCase;
    function fA() {
      ZA.forEach((yA) => {
        yA._edition = lA, Object.keys(wA).forEach((FA) => {
          yA.getOption(FA) === void 0 && yA.setOption(FA, wA[FA], !0);
        });
      });
    }
    function dA(yA, FA, uA) {
      var JA = EA.filename;
      return uA || (EA.filename = null), Error("illegal " + (FA || "token") + " '" + yA + "' (" + (JA ? JA + ", " : "") + "line " + tA.line + ")");
    }
    function RA() {
      var yA = [], FA;
      do {
        if ((FA = aA()) !== '"' && FA !== "'")
          throw dA(FA);
        yA.push(aA()), rA(FA), FA = DA();
      } while (FA === '"' || FA === "'");
      return yA.join("");
    }
    function KA(yA) {
      var FA = aA();
      switch (FA) {
        case "'":
        case '"':
          return sA(FA), RA();
        case "true":
        case "TRUE":
          return !0;
        case "false":
        case "FALSE":
          return !1;
      }
      try {
        return MA(
          FA,
          /* insideTryCatch */
          !0
        );
      } catch {
        if (iA.test(FA))
          return FA;
        throw dA(FA, "value");
      }
    }
    function xA(yA, FA) {
      var uA, JA;
      do
        if (FA && ((uA = DA()) === '"' || uA === "'")) {
          var YA = RA();
          if (yA.push(YA), lA >= 2023)
            throw dA(YA, "id");
        } else
          try {
            yA.push([JA = OA(aA()), rA("to", !0) ? OA(aA()) : JA]);
          } catch (Qg) {
            if (FA && iA.test(uA) && lA >= 2023)
              yA.push(uA);
            else
              throw Qg;
          }
      while (rA(",", !0));
      var TA = { options: void 0 };
      TA.setOption = function(Qg, sg) {
        this.options === void 0 && (this.options = {}), this.options[Qg] = sg;
      }, $A(
        TA,
        function(sg) {
          if (sg === "option")
            Bg(TA, sg), rA(";");
          else
            throw dA(sg);
        },
        function() {
          zA(TA);
        }
      );
    }
    function MA(yA, FA) {
      var uA = 1;
      switch (yA.charAt(0) === "-" && (uA = -1, yA = yA.substring(1)), yA) {
        case "inf":
        case "INF":
        case "Inf":
          return uA * (1 / 0);
        case "nan":
        case "NAN":
        case "Nan":
        case "NaN":
          return NaN;
        case "0":
          return 0;
      }
      if (H.test(yA))
        return uA * parseInt(yA, 10);
      if (AA.test(yA))
        return uA * parseInt(yA, 16);
      if (IA.test(yA))
        return uA * parseInt(yA, 8);
      if (CA.test(yA))
        return uA * parseFloat(yA);
      throw dA(yA, "number", FA);
    }
    function OA(yA, FA) {
      switch (yA) {
        case "max":
        case "MAX":
        case "Max":
          return 536870911;
        case "0":
          return 0;
      }
      if (!FA && yA.charAt(0) === "-")
        throw dA(yA, "id");
      if (f.test(yA))
        return parseInt(yA, 10);
      if (gA.test(yA))
        return parseInt(yA, 16);
      if (BA.test(yA))
        return parseInt(yA, 8);
      throw dA(yA, "id");
    }
    function SA() {
      if (pA !== void 0)
        throw dA("package");
      if (pA = aA(), !iA.test(pA))
        throw dA(pA, "name");
      kA = kA.define(pA), rA(";");
    }
    function gg() {
      var yA = DA(), FA;
      switch (yA) {
        case "option":
          if (lA < "2024")
            throw dA("option");
          aA(), RA(), rA(";");
          return;
        case "weak":
          FA = XA || (XA = []), aA();
          break;
        case "public":
          aA();
        // eslint-disable-next-line no-fallthrough
        default:
          FA = mA || (mA = []);
          break;
      }
      yA = RA(), rA(";"), FA.push(yA);
    }
    function WA() {
      if (rA("="), lA = RA(), lA < 2023)
        throw dA(lA, "syntax");
      rA(";");
    }
    function eg() {
      if (rA("="), lA = RA(), !["2023", "2024"].includes(lA))
        throw dA(lA, "edition");
      rA(";");
    }
    function ig(yA, FA) {
      switch (FA) {
        case "option":
          return Bg(yA, FA), rA(";"), !0;
        case "message":
          return ag(yA, FA), !0;
        case "enum":
          return Gg(yA, FA), !0;
        case "export":
        case "local":
          return lA < "2024" || (FA = aA(), FA === "export" || FA === "local") || FA !== "message" && FA !== "enum" ? !1 : ig(yA, FA);
        case "service":
          return PA(yA, FA), !0;
        case "extend":
          return _A(yA, FA), !0;
      }
      return !1;
    }
    function $A(yA, FA, uA) {
      var JA = tA.line;
      if (yA && (typeof yA.comment != "string" && (yA.comment = nA()), yA.filename = EA.filename), rA("{", !0)) {
        for (var YA; (YA = aA()) !== "}"; )
          FA(YA);
        rA(";", !0);
      } else
        uA && uA(), rA(";"), yA && (typeof yA.comment != "string" || cA) && (yA.comment = nA(JA) || yA.comment);
    }
    function ag(yA, FA) {
      if (!QA.test(FA = aA()))
        throw dA(FA, "type name");
      var uA = new g(FA);
      $A(uA, function(YA) {
        if (!ig(uA, YA))
          switch (YA) {
            case "map":
              wg(uA);
              break;
            case "required":
              if (lA !== "proto2")
                throw dA(YA);
            /* eslint-disable no-fallthrough */
            case "repeated":
              Ig(uA, YA);
              break;
            case "optional":
              if (lA === "proto3")
                Ig(uA, "proto3_optional");
              else {
                if (lA !== "proto2")
                  throw dA(YA);
                Ig(uA, "optional");
              }
              break;
            case "oneof":
              hg(uA, YA);
              break;
            case "extensions":
              xA(uA.extensions || (uA.extensions = []));
              break;
            case "reserved":
              xA(uA.reserved || (uA.reserved = []), !0);
              break;
            default:
              if (lA === "proto2" || !iA.test(YA))
                throw dA(YA);
              sA(YA), Ig(uA, "optional");
              break;
          }
      }), yA.add(uA), yA === kA && ZA.push(uA);
    }
    function Ig(yA, FA, uA) {
      var JA = aA();
      if (JA === "group") {
        tg(yA, FA);
        return;
      }
      for (; JA.endsWith(".") || DA().startsWith("."); )
        JA += aA();
      if (!iA.test(JA))
        throw dA(JA, "type");
      var YA = aA();
      if (!QA.test(YA))
        throw dA(YA, "name");
      YA = LA(YA), rA("=");
      var TA = new E(YA, OA(aA()), JA, FA, uA);
      if ($A(TA, function(ng) {
        if (ng === "option")
          Bg(TA, ng), rA(";");
        else
          throw dA(ng);
      }, function() {
        zA(TA);
      }), FA === "proto3_optional") {
        var Qg = new t("_" + YA);
        TA.setOption("proto3_optional", !0), Qg.add(TA), yA.add(Qg);
      } else
        yA.add(TA);
      yA === kA && ZA.push(TA);
    }
    function tg(yA, FA) {
      if (lA >= 2023)
        throw dA("group");
      var uA = aA();
      if (!QA.test(uA))
        throw dA(uA, "name");
      var JA = M.lcFirst(uA);
      uA === JA && (uA = M.ucFirst(uA)), rA("=");
      var YA = OA(aA()), TA = new g(uA);
      TA.group = !0;
      var Qg = new E(JA, YA, uA, FA);
      Qg.filename = EA.filename, $A(TA, function(ng) {
        switch (ng) {
          case "option":
            Bg(TA, ng), rA(";");
            break;
          case "required":
          case "repeated":
            Ig(TA, ng);
            break;
          case "optional":
            lA === "proto3" ? Ig(TA, "proto3_optional") : Ig(TA, "optional");
            break;
          case "message":
            ag(TA, ng);
            break;
          case "enum":
            Gg(TA, ng);
            break;
          case "reserved":
            xA(TA.reserved || (TA.reserved = []), !0);
            break;
          case "export":
          case "local":
            if (lA < "2024")
              throw dA(ng);
            switch (ng = aA(), ng) {
              case "message":
                ag(TA, ng);
                break;
              case "enum":
                ag(TA, ng);
                break;
              default:
                throw dA(ng);
            }
            break;
          /* istanbul ignore next */
          default:
            throw dA(ng);
        }
      }), yA.add(TA).add(Qg);
    }
    function wg(yA) {
      rA("<");
      var FA = aA();
      if (p.mapKey[FA] === void 0)
        throw dA(FA, "type");
      rA(",");
      var uA = aA();
      if (!iA.test(uA))
        throw dA(uA, "type");
      rA(">");
      var JA = aA();
      if (!QA.test(JA))
        throw dA(JA, "name");
      rA("=");
      var YA = new e(LA(JA), OA(aA()), FA, uA);
      $A(YA, function(Qg) {
        if (Qg === "option")
          Bg(YA, Qg), rA(";");
        else
          throw dA(Qg);
      }, function() {
        zA(YA);
      }), yA.add(YA);
    }
    function hg(yA, FA) {
      if (!QA.test(FA = aA()))
        throw dA(FA, "name");
      var uA = new t(LA(FA));
      $A(uA, function(YA) {
        YA === "option" ? (Bg(uA, YA), rA(";")) : (sA(YA), Ig(uA, "optional"));
      }), yA.add(uA);
    }
    function Gg(yA, FA) {
      if (!QA.test(FA = aA()))
        throw dA(FA, "name");
      var uA = new n(FA);
      $A(uA, function(YA) {
        switch (YA) {
          case "option":
            Bg(uA, YA), rA(";");
            break;
          case "reserved":
            xA(uA.reserved || (uA.reserved = []), !0), uA.reserved === void 0 && (uA.reserved = []);
            break;
          default:
            Ng(uA, YA);
        }
      }), yA.add(uA), yA === kA && ZA.push(uA);
    }
    function Ng(yA, FA) {
      if (!QA.test(FA))
        throw dA(FA, "name");
      rA("=");
      var uA = OA(aA(), !0), JA = {
        options: void 0
      };
      JA.getOption = function(YA) {
        return this.options[YA];
      }, JA.setOption = function(YA, TA) {
        k.prototype.setOption.call(JA, YA, TA);
      }, JA.setParsedOption = function() {
      }, $A(JA, function(TA) {
        if (TA === "option")
          Bg(JA, TA), rA(";");
        else
          throw dA(TA);
      }, function() {
        zA(JA);
      }), yA.add(FA, uA, JA.comment, JA.parsedOptions || JA.options);
    }
    function Bg(yA, FA) {
      var uA, JA, YA = !0;
      for (FA === "option" && (FA = aA()); FA !== "="; ) {
        if (FA === "(") {
          var TA = aA();
          rA(")"), FA = "(" + TA + ")";
        }
        if (YA) {
          if (YA = !1, FA.includes(".") && !FA.includes("(")) {
            var Qg = FA.split(".");
            uA = Qg[0] + ".", FA = Qg[1];
            continue;
          }
          uA = FA;
        } else
          JA = JA ? JA += FA : FA;
        FA = aA();
      }
      var sg = JA ? uA.concat(JA) : uA, ng = bA(yA, sg);
      JA = JA && JA[0] === "." ? JA.slice(1) : JA, uA = uA && uA[uA.length - 1] === "." ? uA.slice(0, -1) : uA, vA(yA, uA, ng, JA);
    }
    function bA(yA, FA) {
      if (rA("{", !0)) {
        for (var uA = {}; !rA("}", !0); ) {
          if (!QA.test(VA = aA()))
            throw dA(VA, "name");
          if (VA === null)
            throw dA(VA, "end of input");
          var JA, YA = VA;
          if (rA(":", !0), DA() === "{")
            JA = bA(yA, FA + "." + VA);
          else if (DA() === "[") {
            JA = [];
            var TA;
            if (rA("[", !0)) {
              do
                TA = KA(), JA.push(TA);
              while (rA(",", !0));
              rA("]"), typeof TA < "u" && HA(yA, FA + "." + VA, TA);
            }
          } else
            JA = KA(), HA(yA, FA + "." + VA, JA);
          var Qg = uA[YA];
          Qg && (JA = [].concat(Qg).concat(JA)), uA[YA] = JA, rA(",", !0), rA(";", !0);
        }
        return uA;
      }
      var sg = KA();
      return HA(yA, FA, sg), sg;
    }
    function HA(yA, FA, uA) {
      if (kA === yA && /^features\./.test(FA)) {
        wA[FA] = uA;
        return;
      }
      yA.setOption && yA.setOption(FA, uA);
    }
    function vA(yA, FA, uA, JA) {
      yA.setParsedOption && yA.setParsedOption(FA, uA, JA);
    }
    function zA(yA) {
      if (rA("[", !0)) {
        do
          Bg(yA, "option");
        while (rA(",", !0));
        rA("]");
      }
      return yA;
    }
    function PA(yA, FA) {
      if (!QA.test(FA = aA()))
        throw dA(FA, "service name");
      var uA = new h(FA);
      $A(uA, function(YA) {
        if (!ig(uA, YA))
          if (YA === "rpc")
            qA(uA, YA);
          else
            throw dA(YA);
      }), yA.add(uA), yA === kA && ZA.push(uA);
    }
    function qA(yA, FA) {
      var uA = nA(), JA = FA;
      if (!QA.test(FA = aA()))
        throw dA(FA, "name");
      var YA = FA, TA, Qg, sg, ng;
      if (rA("("), rA("stream", !0) && (Qg = !0), !iA.test(FA = aA()) || (TA = FA, rA(")"), rA("returns"), rA("("), rA("stream", !0) && (ng = !0), !iA.test(FA = aA())))
        throw dA(FA);
      sg = FA, rA(")");
      var Yg = new d(YA, JA, TA, sg, Qg, ng);
      Yg.comment = uA, $A(Yg, function(pg) {
        if (pg === "option")
          Bg(Yg, pg), rA(";");
        else
          throw dA(pg);
      }), yA.add(Yg);
    }
    function _A(yA, FA) {
      if (!iA.test(FA = aA()))
        throw dA(FA, "reference");
      var uA = FA;
      $A(null, function(YA) {
        switch (YA) {
          case "required":
          case "repeated":
            Ig(yA, YA, uA);
            break;
          case "optional":
            lA === "proto3" ? Ig(yA, "proto3_optional", uA) : Ig(yA, "optional", uA);
            break;
          default:
            if (lA === "proto2" || !iA.test(YA))
              throw dA(YA);
            sA(YA), Ig(yA, "optional", uA);
            break;
        }
      });
    }
    for (var VA; (VA = aA()) !== null; )
      switch (VA) {
        case "package":
          if (!NA)
            throw dA(VA);
          SA();
          break;
        case "import":
          if (!NA)
            throw dA(VA);
          gg();
          break;
        case "syntax":
          if (!NA)
            throw dA(VA);
          WA();
          break;
        case "edition":
          if (!NA)
            throw dA(VA);
          eg();
          break;
        case "option":
          Bg(kA, VA), rA(";", !0);
          break;
        default:
          if (ig(kA, VA)) {
            NA = !1;
            continue;
          }
          throw dA(VA);
      }
    return fA(), EA.filename = null, {
      package: pA,
      imports: mA,
      weakImports: XA,
      root: eA
    };
  }
  return parse_1;
}
var common_1, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common_1;
  hasRequiredCommon = 1, common_1 = i;
  var o = /\/|\./;
  function i(E, e) {
    o.test(E) || (E = "google/protobuf/" + E + ".proto", e = { nested: { google: { nested: { protobuf: { nested: e } } } } }), i[E] = e;
  }
  i("any", {
    /**
     * Properties of a google.protobuf.Any message.
     * @interface IAny
     * @type {Object}
     * @property {string} [typeUrl]
     * @property {Uint8Array} [bytes]
     * @memberof common
     */
    Any: {
      fields: {
        type_url: {
          type: "string",
          id: 1
        },
        value: {
          type: "bytes",
          id: 2
        }
      }
    }
  });
  var g;
  return i("duration", {
    /**
     * Properties of a google.protobuf.Duration message.
     * @interface IDuration
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */
    Duration: g = {
      fields: {
        seconds: {
          type: "int64",
          id: 1
        },
        nanos: {
          type: "int32",
          id: 2
        }
      }
    }
  }), i("timestamp", {
    /**
     * Properties of a google.protobuf.Timestamp message.
     * @interface ITimestamp
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */
    Timestamp: g
  }), i("empty", {
    /**
     * Properties of a google.protobuf.Empty message.
     * @interface IEmpty
     * @memberof common
     */
    Empty: {
      fields: {}
    }
  }), i("struct", {
    /**
     * Properties of a google.protobuf.Struct message.
     * @interface IStruct
     * @type {Object}
     * @property {Object.<string,IValue>} [fields]
     * @memberof common
     */
    Struct: {
      fields: {
        fields: {
          keyType: "string",
          type: "Value",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Value message.
     * @interface IValue
     * @type {Object}
     * @property {string} [kind]
     * @property {0} [nullValue]
     * @property {number} [numberValue]
     * @property {string} [stringValue]
     * @property {boolean} [boolValue]
     * @property {IStruct} [structValue]
     * @property {IListValue} [listValue]
     * @memberof common
     */
    Value: {
      oneofs: {
        kind: {
          oneof: [
            "nullValue",
            "numberValue",
            "stringValue",
            "boolValue",
            "structValue",
            "listValue"
          ]
        }
      },
      fields: {
        nullValue: {
          type: "NullValue",
          id: 1
        },
        numberValue: {
          type: "double",
          id: 2
        },
        stringValue: {
          type: "string",
          id: 3
        },
        boolValue: {
          type: "bool",
          id: 4
        },
        structValue: {
          type: "Struct",
          id: 5
        },
        listValue: {
          type: "ListValue",
          id: 6
        }
      }
    },
    NullValue: {
      values: {
        NULL_VALUE: 0
      }
    },
    /**
     * Properties of a google.protobuf.ListValue message.
     * @interface IListValue
     * @type {Object}
     * @property {Array.<IValue>} [values]
     * @memberof common
     */
    ListValue: {
      fields: {
        values: {
          rule: "repeated",
          type: "Value",
          id: 1
        }
      }
    }
  }), i("wrappers", {
    /**
     * Properties of a google.protobuf.DoubleValue message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    DoubleValue: {
      fields: {
        value: {
          type: "double",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.FloatValue message.
     * @interface IFloatValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    FloatValue: {
      fields: {
        value: {
          type: "float",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Int64Value message.
     * @interface IInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */
    Int64Value: {
      fields: {
        value: {
          type: "int64",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.UInt64Value message.
     * @interface IUInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */
    UInt64Value: {
      fields: {
        value: {
          type: "uint64",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Int32Value message.
     * @interface IInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    Int32Value: {
      fields: {
        value: {
          type: "int32",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.UInt32Value message.
     * @interface IUInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    UInt32Value: {
      fields: {
        value: {
          type: "uint32",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.BoolValue message.
     * @interface IBoolValue
     * @type {Object}
     * @property {boolean} [value]
     * @memberof common
     */
    BoolValue: {
      fields: {
        value: {
          type: "bool",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.StringValue message.
     * @interface IStringValue
     * @type {Object}
     * @property {string} [value]
     * @memberof common
     */
    StringValue: {
      fields: {
        value: {
          type: "string",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.BytesValue message.
     * @interface IBytesValue
     * @type {Object}
     * @property {Uint8Array} [value]
     * @memberof common
     */
    BytesValue: {
      fields: {
        value: {
          type: "bytes",
          id: 1
        }
      }
    }
  }), i("field_mask", {
    /**
     * Properties of a google.protobuf.FieldMask message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    FieldMask: {
      fields: {
        paths: {
          rule: "repeated",
          type: "string",
          id: 1
        }
      }
    }
  }), i.get = function(e) {
    return i[e] || null;
  }, common_1;
}
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src.exports;
  hasRequiredSrc = 1;
  var o = src.exports = requireIndexLight();
  return o.build = "full", o.tokenize = requireTokenize(), o.parse = requireParse(), o.common = requireCommon(), o.Root._configure(o.Type, o.parse, o.common), src.exports;
}
var protobufjs, hasRequiredProtobufjs;
function requireProtobufjs() {
  return hasRequiredProtobufjs || (hasRequiredProtobufjs = 1, protobufjs = requireSrc()), protobufjs;
}
var protobufjsExports = requireProtobufjs(), dist = {}, Collector = {}, hasRequiredCollector;
function requireCollector() {
  if (hasRequiredCollector) return Collector;
  hasRequiredCollector = 1, Object.defineProperty(Collector, "__esModule", { value: !0 }), Collector.Collector = void 0;
  let o = class {
    /**
     * Create a new collector.
     *
     * @param signal The signal to emit.
     */
    constructor(g) {
      this.emit = (...E) => {
        g.emitCollecting(this, E);
      };
    }
  };
  return Collector.Collector = o, Collector;
}
var CollectorArray = {}, hasRequiredCollectorArray;
function requireCollectorArray() {
  if (hasRequiredCollectorArray) return CollectorArray;
  hasRequiredCollectorArray = 1, Object.defineProperty(CollectorArray, "__esModule", { value: !0 }), CollectorArray.CollectorArray = void 0;
  const o = requireCollector();
  let i = class extends o.Collector {
    constructor() {
      super(...arguments), this.result = [];
    }
    handleResult(E) {
      return this.result.push(E), !0;
    }
    /**
     * Get the list of results from the signal handlers.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result.length = 0;
    }
  };
  return CollectorArray.CollectorArray = i, CollectorArray;
}
var CollectorLast = {}, hasRequiredCollectorLast;
function requireCollectorLast() {
  if (hasRequiredCollectorLast) return CollectorLast;
  hasRequiredCollectorLast = 1, Object.defineProperty(CollectorLast, "__esModule", { value: !0 }), CollectorLast.CollectorLast = void 0;
  const o = requireCollector();
  let i = class extends o.Collector {
    handleResult(E) {
      return this.result = E, !0;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      delete this.result;
    }
  };
  return CollectorLast.CollectorLast = i, CollectorLast;
}
var CollectorUntil0 = {}, hasRequiredCollectorUntil0;
function requireCollectorUntil0() {
  if (hasRequiredCollectorUntil0) return CollectorUntil0;
  hasRequiredCollectorUntil0 = 1, Object.defineProperty(CollectorUntil0, "__esModule", { value: !0 }), CollectorUntil0.CollectorUntil0 = void 0;
  const o = requireCollector();
  let i = class extends o.Collector {
    constructor() {
      super(...arguments), this.result = !1;
    }
    handleResult(E) {
      return this.result = E, this.result;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result = !1;
    }
  };
  return CollectorUntil0.CollectorUntil0 = i, CollectorUntil0;
}
var CollectorWhile0 = {}, hasRequiredCollectorWhile0;
function requireCollectorWhile0() {
  if (hasRequiredCollectorWhile0) return CollectorWhile0;
  hasRequiredCollectorWhile0 = 1, Object.defineProperty(CollectorWhile0, "__esModule", { value: !0 }), CollectorWhile0.CollectorWhile0 = void 0;
  const o = requireCollector();
  let i = class extends o.Collector {
    constructor() {
      super(...arguments), this.result = !1;
    }
    handleResult(E) {
      return this.result = E, !this.result;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result = !1;
    }
  };
  return CollectorWhile0.CollectorWhile0 = i, CollectorWhile0;
}
var Signal = {}, SignalConnection = {}, hasRequiredSignalConnection;
function requireSignalConnection() {
  if (hasRequiredSignalConnection) return SignalConnection;
  hasRequiredSignalConnection = 1, Object.defineProperty(SignalConnection, "__esModule", { value: !0 }), SignalConnection.SignalConnectionImpl = void 0;
  class o {
    /**
     * @param link The actual link of the connection.
     */
    constructor(g) {
      this.link = g;
    }
    disconnect() {
      return this.link.unlink();
    }
    set enabled(g) {
      this.link.setEnabled(g);
    }
    get enabled() {
      return this.link.isEnabled();
    }
  }
  return SignalConnection.SignalConnectionImpl = o, SignalConnection;
}
var SignalLink = {}, hasRequiredSignalLink;
function requireSignalLink() {
  if (hasRequiredSignalLink) return SignalLink;
  hasRequiredSignalLink = 1, Object.defineProperty(SignalLink, "__esModule", { value: !0 }), SignalLink.SignalLink = void 0;
  let o = class DI {
    constructor(g, E, e) {
      this.enabled = !0, this.newLink = !1, this.prev = g ?? this, this.next = E ?? this, this.order = e.order, this.isPublic = e.isPublic, this.callback = e.callback, this.onUnlink = e.onUnlink;
    }
    isEnabled() {
      return this.enabled && !this.newLink;
    }
    setEnabled(g) {
      this.enabled = g;
    }
    unlink() {
      return this.callback ? (delete this.callback, this.next.prev = this.prev, this.prev.next = this.next, this.onUnlink(), !0) : !1;
    }
    insert(g) {
      const { order: E } = g;
      let e = this.prev;
      for (; e !== this && !(e.order <= E); )
        e = e.prev;
      const t = new DI(e, e.next, g);
      return e.next = t, t.next.prev = t, t;
    }
  };
  return SignalLink.SignalLink = o, SignalLink;
}
var hasRequiredSignal;
function requireSignal() {
  if (hasRequiredSignal) return Signal;
  hasRequiredSignal = 1, Object.defineProperty(Signal, "__esModule", { value: !0 }), Signal.Signal = void 0;
  const o = requireSignalConnection(), i = requireSignalLink(), g = { order: 0, isPublic: !0, onUnlink() {
  } };
  let E = class {
    constructor() {
      this.head = new i.SignalLink(null, null, g), this.hasNewLinks = !1, this.emitDepth = 0, this.connectionsCount = 0, this.onUnlink = () => {
        this.connectionsCount--;
      };
    }
    /**
     * @returns The number of connections on this signal.
     */
    getConnectionsCount() {
      return this.connectionsCount;
    }
    /**
     * @returns true if this signal has connections.
     */
    hasConnections() {
      return this.connectionsCount > 0;
    }
    /**
     * Subscribe to this signal.
     *
     * @param callback This callback will be run when emit() is called.
     * @param options Configure options for the connection
     */
    connect(t, { order: n = 0, isPublic: h = !0 } = {}) {
      this.connectionsCount++;
      const d = this.head.insert({ callback: t, order: n, isPublic: h, onUnlink: this.onUnlink });
      return this.emitDepth > 0 && (this.hasNewLinks = !0, d.newLink = !0), new o.SignalConnectionImpl(d);
    }
    /**
     * Unsubscribe from this signal with the original callback instance.
     * While you can use this method, the SignalConnection returned by connect() will not be updated!
     *
     * @param callback The callback you passed to connect().
     */
    disconnect(t) {
      for (let n = this.head.next; n !== this.head; n = n.next)
        if (n.callback === t)
          return n.unlink(), !0;
      return !1;
    }
    /**
     * Disconnect all handlers from this signal event.
     */
    disconnectAll() {
      let { next: t } = this.head;
      for (; t !== this.head; )
        t.isPublic && t.unlink(), t = t.next;
    }
    /**
     * Publish this signal event (call all handlers).
     */
    emit(...t) {
      this.emitDepth++;
      for (let n = this.head.next; n !== this.head; n = n.next)
        n.isEnabled() && n.callback && n.callback.apply(null, t);
      this.emitDepth--, this.unsetNewLink();
    }
    emitCollecting(t, n) {
      this.emitDepth++;
      for (let h = this.head.next; h !== this.head; h = h.next)
        if (h.isEnabled() && h.callback) {
          const d = h.callback.apply(null, n);
          if (!t.handleResult(d))
            break;
        }
      this.emitDepth--, this.unsetNewLink();
    }
    unsetNewLink() {
      if (this.hasNewLinks && this.emitDepth === 0) {
        for (let t = this.head.next; t !== this.head; t = t.next)
          t.newLink = !1;
        this.hasNewLinks = !1;
      }
    }
  };
  return Signal.Signal = E, Signal;
}
var SignalConnections = {}, hasRequiredSignalConnections;
function requireSignalConnections() {
  if (hasRequiredSignalConnections) return SignalConnections;
  hasRequiredSignalConnections = 1, Object.defineProperty(SignalConnections, "__esModule", { value: !0 }), SignalConnections.SignalConnections = void 0;
  let o = class {
    constructor() {
      this.list = [];
    }
    /**
     * Add a connection to the list.
     * @param connection
     */
    add(g) {
      this.list.push(g);
    }
    /**
     * Disconnect all connections in the list and empty the list.
     */
    disconnectAll() {
      for (const g of this.list)
        g.disconnect();
      this.list = [];
    }
    /**
     * @returns The number of connections in this list.
     */
    getCount() {
      return this.list.length;
    }
    /**
     * @returns true if this list is empty.
     */
    isEmpty() {
      return this.list.length === 0;
    }
  };
  return SignalConnections.SignalConnections = o, SignalConnections;
}
var hasRequiredDist;
function requireDist() {
  return hasRequiredDist || (hasRequiredDist = 1, (function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.SignalConnections = o.Signal = o.CollectorWhile0 = o.CollectorUntil0 = o.CollectorLast = o.CollectorArray = o.Collector = void 0;
    var i = requireCollector();
    Object.defineProperty(o, "Collector", { enumerable: !0, get: function() {
      return i.Collector;
    } });
    var g = requireCollectorArray();
    Object.defineProperty(o, "CollectorArray", { enumerable: !0, get: function() {
      return g.CollectorArray;
    } });
    var E = requireCollectorLast();
    Object.defineProperty(o, "CollectorLast", { enumerable: !0, get: function() {
      return E.CollectorLast;
    } });
    var e = requireCollectorUntil0();
    Object.defineProperty(o, "CollectorUntil0", { enumerable: !0, get: function() {
      return e.CollectorUntil0;
    } });
    var t = requireCollectorWhile0();
    Object.defineProperty(o, "CollectorWhile0", { enumerable: !0, get: function() {
      return t.CollectorWhile0;
    } });
    var n = requireSignal();
    Object.defineProperty(o, "Signal", { enumerable: !0, get: function() {
      return n.Signal;
    } });
    var h = requireSignalConnections();
    Object.defineProperty(o, "SignalConnections", { enumerable: !0, get: function() {
      return h.SignalConnections;
    } });
  })(dist)), dist;
}
var distExports = requireDist();
function createFormsData() {
  return {
    formsWithPendingChanges: /* @__PURE__ */ new Set(),
    formsWithUploads: /* @__PURE__ */ new Set(),
    submitButtons: /* @__PURE__ */ new Map()
  };
}
const LOG$7 = loglevelExports$1.getLogger("WidgetStateManager");
class WidgetStateDict {
  constructor() {
    this.widgetStates = /* @__PURE__ */ new Map();
  }
  /**
   * Create a new WidgetState proto for the widget with the given ID,
   * overwriting any that currently exists.
   */
  createState(i) {
    const g = new WidgetState({
      id: i
    });
    return this.widgetStates.set(i, g), g;
  }
  /** Return the WidgetState for the given widgetID if it exists. */
  getState(i) {
    return this.widgetStates.get(i);
  }
  /** Remove the WidgetState proto with the given id, if it exists. */
  deleteState(i) {
    this.widgetStates.delete(i);
  }
  /** Remove the state of widgets that are not contained in `activeIds`. */
  removeInactive(i) {
    this.widgetStates.forEach((g, E) => {
      i.has(E) || this.widgetStates.delete(E);
    });
  }
  /** Remove all widget states. */
  clear() {
    this.widgetStates.clear();
  }
  get isEmpty() {
    return this.widgetStates.size === 0;
  }
  createWidgetStatesMsg() {
    const i = new WidgetStates();
    return this.widgetStates.forEach((g) => i.widgets.push(g)), i;
  }
  /**
   * Copy the contents of another WidgetStateDict into this one, overwriting
   * any values with duplicate keys.
   */
  copyFrom(i) {
    i.widgetStates.forEach((g, E) => {
      this.widgetStates.set(E, g);
    });
  }
  /** Call a function for each value in the dict. */
  forEach(i) {
    this.widgetStates.forEach(i);
  }
}
class FormState {
  constructor() {
    this.widgetStates = new WidgetStateDict(), this.clearOnSubmit = !1, this.enterToSubmit = !0, this.formCleared = new distExports.Signal();
  }
  /** True if the form has a non-empty WidgetStateDict. */
  get hasPendingChanges() {
    return !this.widgetStates.isEmpty;
  }
}
class WidgetStateManager {
  constructor(i) {
    this.widgetStates = new WidgetStateDict(), this.forms = /* @__PURE__ */ new Map(), this.elementStates = /* @__PURE__ */ new Map(), this.pendingTriggerIds = /* @__PURE__ */ new Set(), this.triggerFlushResolvers = [], this.flushScheduled = !1, this.hasFragmentIdConflict = !1, this.props = i, this.formsData = createFormsData();
  }
  /**
   * Register a function that will be called when the given form is cleared.
   * Returns an object that can be used to de-register the listener.
   */
  addFormClearedListener(i, g) {
    return this.getOrCreateFormState(i).formCleared.connect(g);
  }
  /**
   * Register a Form, and assign its clearOnSubmit & enterToSubmit values.
   * The `Form` element calls this when it's first mounted.
   */
  setFormSubmitBehaviors(i, g, E = !0) {
    const e = this.getOrCreateFormState(i);
    e.clearOnSubmit = g, e.enterToSubmit = E;
  }
  /**
   * Commit pending changes for widgets that belong to the given form,
   * and send a rerunBackMsg to the server.
   */
  submitForm(i, g, E) {
    if (!isValidFormId(i))
      throw new Error(`invalid formID '${i}'`);
    const e = this.getOrCreateFormState(i), t = this.formsData.submitButtons.get(i);
    let n;
    E !== void 0 ? n = E : t !== void 0 && t.length > 0 && (n = t[0]), n && (this.createWidgetState(n, {
      fromUi: !0
    }).triggerValue = !0), this.widgetStates.copyFrom(e.widgetStates), e.widgetStates.clear(), this.sendUpdateWidgetsMessage(g), this.syncFormsWithPendingChanges(), n && this.deleteWidgetState(n.id), e.clearOnSubmit && e.formCleared.emit();
  }
  setChatInputValue(i, g, E, e) {
    this.createWidgetState(i, E).chatInputValue = new ChatInputValue(g), this.pendingTriggerIds.add(i.id), this.scheduleFlush(e);
  }
  /**
   * 1. Boolean trigger
   *    setTriggerValue(widgetInfo, { fromUi: true }, fragmentId)
   *
   * 2. Payload (JSON-encoded) trigger
   *    setTriggerValue(widgetInfo, { fromUi: true }, fragmentId, payload)
   *
   *    `payload` can be any JSON-serialisable value. For Bidi Component v2
   *    we always transport payloads via the protobuf `json_trigger_value`
   *    field as a JSON-stringified array of payload objects. Multiple calls
   *    within the same macrotask are batched into that array. If `payload`
   *    is omitted (or `undefined`) we fall back to the boolean
   *    `trigger_value=true` behaviour.
   */
  setTriggerValue(i, g, E, e) {
    let t = this.getWidgetState(i);
    if (t === void 0 && (t = this.createWidgetState(i, g)), e === void 0)
      t.triggerValue = !0;
    else {
      const n = e;
      try {
        if (isNullOrUndefined(t.jsonTriggerValue))
          t.jsonTriggerValue = JSON.stringify([n]);
        else {
          const h = t.jsonTriggerValue, d = JSON.parse(h), k = Array.isArray(d) ? d : [d];
          k.push(n), t.jsonTriggerValue = JSON.stringify(k);
        }
      } catch (h) {
        LOG$7.error("Failed to parse or stringify widgetState.jsonTriggerValue:", h), t.jsonTriggerValue = JSON.stringify([t.jsonTriggerValue, n]);
      }
    }
    return this.pendingTriggerIds.add(i.id), new Promise((n) => {
      this.triggerFlushResolvers.push(n), this.scheduleFlush(E);
    });
  }
  getBoolValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "boolValue")
      return g.boolValue;
  }
  setBoolValue(i, g, E, e) {
    this.createWidgetState(i, E).boolValue = g, this.onWidgetValueChanged(i.formId, E, e);
  }
  getIntValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "intValue")
      return requireNumberInt(g.intValue);
  }
  setIntValue(i, g, E, e) {
    this.createWidgetState(i, E).intValue = g, this.onWidgetValueChanged(i.formId, E, e);
  }
  getDoubleValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "doubleValue")
      return g.doubleValue;
  }
  setDoubleValue(i, g, E, e) {
    this.createWidgetState(i, E).doubleValue = g, this.onWidgetValueChanged(i.formId, E, e);
  }
  getStringValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "stringValue")
      return g.stringValue;
  }
  setStringValue(i, g, E, e) {
    this.createWidgetState(i, E).stringValue = g, this.onWidgetValueChanged(i.formId, E, e);
  }
  setStringArrayValue(i, g, E, e) {
    this.createWidgetState(i, E).stringArrayValue = new StringArray({
      data: g
    }), this.onWidgetValueChanged(i.formId, E, e);
  }
  getStringArrayValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "stringArrayValue" && notNullOrUndefined(g.stringArrayValue) && notNullOrUndefined(g.stringArrayValue.data))
      return g.stringArrayValue.data;
  }
  getDoubleArrayValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "doubleArrayValue" && notNullOrUndefined(g.doubleArrayValue) && notNullOrUndefined(g.doubleArrayValue.data))
      return g.doubleArrayValue.data;
  }
  setDoubleArrayValue(i, g, E, e) {
    this.createWidgetState(i, E).doubleArrayValue = new DoubleArray({
      data: g
    }), this.onWidgetValueChanged(i.formId, E, e);
  }
  getIntArrayValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "intArrayValue" && notNullOrUndefined(g.intArrayValue) && notNullOrUndefined(g.intArrayValue.data))
      return g.intArrayValue.data.map(requireNumberInt);
  }
  setIntArrayValue(i, g, E, e) {
    this.createWidgetState(i, E).intArrayValue = new SInt64Array({
      data: g
    }), this.onWidgetValueChanged(i.formId, E, e);
  }
  getJsonValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "jsonValue")
      return g.jsonValue;
  }
  setJsonValue(i, g, E, e) {
    this.createWidgetState(i, E).jsonValue = JSON.stringify(g), this.onWidgetValueChanged(i.formId, E, e);
  }
  setArrowValue(i, g, E, e) {
    this.createWidgetState(i, E).arrowValue = g, this.onWidgetValueChanged(i.formId, E, e);
  }
  getArrowValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "arrowValue" && notNullOrUndefined(g.arrowValue))
      return g.arrowValue;
  }
  setBytesValue(i, g, E, e) {
    this.createWidgetState(i, E).bytesValue = g, this.onWidgetValueChanged(i.formId, E, e);
  }
  getBytesValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "bytesValue")
      return g.bytesValue;
  }
  setFileUploaderStateValue(i, g, E, e) {
    this.createWidgetState(i, E).fileUploaderStateValue = g, this.onWidgetValueChanged(i.formId, E, e);
  }
  getFileUploaderStateValue(i) {
    const g = this.getWidgetState(i);
    if (notNullOrUndefined(g) && g.value === "fileUploaderStateValue")
      return g.fileUploaderStateValue;
  }
  /**
   * Perform housekeeping every time a widget value changes.
   * - If the widget does not belong to a form, and the value update came from
   *   a user action, send the "updateWidgets" message
   * - If the widget belongs to a form, dispatch the "pendingFormsChanged"
   *   callback if needed.
   *
   * Called by every "setValue" function.
   */
  onWidgetValueChanged(i, g, E) {
    isValidFormId(i) ? this.syncFormsWithPendingChanges() : g.fromUi && this.scheduleFlush(E);
  }
  /**
   * Update FormsData.formsWithPendingChanges with the current set of forms
   * that have pending changes. This is called after widget values are updated.
   */
  syncFormsWithPendingChanges() {
    const i = /* @__PURE__ */ new Set();
    this.forms.forEach((g, E) => {
      g.hasPendingChanges && i.add(E);
    }), this.updateFormsData((g) => {
      g.formsWithPendingChanges = i;
    });
  }
  sendUpdateWidgetsMessage(i, g = void 0) {
    this.props.sendRerunBackMsg(this.widgetStates.createWidgetStatesMsg(), i, void 0, g);
  }
  getActiveWidgetStates(i) {
    const g = new WidgetStates();
    return this.widgetStates.forEach((E) => {
      i.has(E.id) && g.widgets.push(E);
    }), g;
  }
  /**
   * Remove the state of widgets that are not contained in `activeIds`.
   * This is called when a script finishes running, so that we don't retain
   * data for widgets that have been removed from the app.
   */
  removeInactive(i) {
    this.widgetStates.removeInactive(i), this.forms.forEach((g) => g.widgetStates.removeInactive(i)), this.elementStates.forEach((g, E) => {
      i.has(E) || this.deleteElementState(E);
    });
  }
  /**
   * Create and return a new WidgetState proto for the given widget ID,
   * overwriting any that currently exists. If the widget belongs to a form,
   * the WidgetState will be created inside the form's WidgetStateDict.
   */
  createWidgetState(i, g) {
    return (isValidFormId(i.formId) && g.fromUi ? this.getOrCreateFormState(i.formId).widgetStates : this.widgetStates).createState(i.id);
  }
  /**
   * Get the WidgetState proto for the given widget ID, if it exists.
   */
  getWidgetState(i) {
    if (isValidFormId(i.formId)) {
      const g = this.forms.get(i.formId)?.widgetStates.getState(i.id);
      if (notNullOrUndefined(g))
        return g;
    }
    return this.widgetStates.getState(i.id);
  }
  /**
   * Remove the WidgetState proto with the given id, if it exists
   */
  deleteWidgetState(i) {
    this.widgetStates.deleteState(i);
  }
  /** Return the FormState for the given form. Create it if it doesn't exist. */
  getOrCreateFormState(i) {
    let g = this.forms.get(i);
    return notNullOrUndefined(g) || (g = new FormState(), this.forms.set(i, g)), g;
  }
  /** Store the IDs of all forms with in-progress uploads. */
  setFormsWithUploadsInProgress(i) {
    this.updateFormsData((g) => {
      g.formsWithUploads = i;
    });
  }
  /**
   * Helper function to determine whether a form allows enter to submit
   * for input elements (st.number_input, st.text_input, etc.)
   * If in form, checks form's enterToSubmit paramf first, otherwise default
   * behavior: Must have 1st submit button enabled to allow
   */
  allowFormEnterToSubmit(i) {
    if (!isValidFormId(i)) return !1;
    const g = this.forms.get(i);
    if (g && !g.enterToSubmit) return !1;
    const e = this.formsData.submitButtons.get(i)?.[0];
    return e ? !e.disabled : !1;
  }
  /**
   * Called by FormSubmitButton on creation. Add the SubmitButtonProto for
   * the given form and update FormsData.
   */
  addSubmitButton(i, g) {
    const E = this.formsData.submitButtons.get(i);
    if (E === void 0)
      this.setSubmitButtons(i, [g]);
    else {
      const e = Object.assign([], E);
      e.push(g), this.setSubmitButtons(i, e);
    }
  }
  /**
   * Called by FormSubmitButton on creation. Remove the SubmitButtonProto for
   * the given form, and update FormsData.
   */
  removeSubmitButton(i, g) {
    const E = this.formsData.submitButtons.get(i);
    if (E !== void 0) {
      const e = Object.assign([], E), t = e.indexOf(g, 0);
      t > -1 && e.splice(t, 1), this.setSubmitButtons(i, e);
    }
  }
  setSubmitButtons(i, g) {
    if (g.length < 0)
      throw new Error(`Bad submitButtons length ${g.length} (must be >= 0)`);
    this.updateFormsData((E) => {
      E.submitButtons.set(i, g);
    });
  }
  /**
   * Produce a new FormsData with the given recipe, and fire off the
   * formsDataChanged callback with that new data.
   */
  updateFormsData(i) {
    const g = produce(this.formsData, i);
    this.formsData !== g && (this.formsData = g, this.props.formsDataChanged(this.formsData));
  }
  /**
   * Get the element state value for the given element ID and key, if it exists.
   * This is a frontend-only state that is never sent to the server.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getElementState(i, g) {
    return this.elementStates.get(i)?.get(g);
  }
  /**
   * Sets the state of an element identified by its ID and its key.
   * This is a frontend-only state that is never sent to the server.
   * It can be used to store element state to restore the state
   * of an element in situations where an element is removed and re-added.
   *
   * @param {string} elementId - The unique identifier of the element.
   * @param {string} key - The key to set
   * @param {any} value - The value to set for the element's state.
   * @returns {void}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  setElementState(i, g, E) {
    this.elementStates.has(i) || this.elementStates.set(i, /* @__PURE__ */ new Map()), this.elementStates.get(i).set(g, E);
  }
  /**
   * Deletes the state associated with a specific element by ID. If a key is provided,
   * only the state corresponding to that key is removed. If no key is specified, all states
   * associated with the element ID are removed.
   */
  deleteElementState(i, g) {
    notNullOrUndefined(g) ? this.elementStates.get(i)?.delete(g) : this.elementStates.delete(i);
  }
  /**
   * Schedule a macrotask-level flush of pending widget updates (triggers and
   * regular value changes). Multiple calls within the same macrotask will be
   * coalesced into a single `updateWidgets` message.
   */
  scheduleFlush(i) {
    this.scheduledFragmentId === void 0 && (this.scheduledFragmentId = i), this.scheduledFragmentId !== void 0 && i !== void 0 && i !== this.scheduledFragmentId && !this.hasFragmentIdConflict && (LOG$7.warn("Unexpected state: Multiple different fragmentIds detected in a single batch of widget updates. Proceeding with flushing updates using fragmentId '%s' for this batch.", this.scheduledFragmentId), this.hasFragmentIdConflict = !0), !this.flushScheduled && (this.flushScheduled = !0, setTimeout(() => {
      this.sendUpdateWidgetsMessage(this.scheduledFragmentId), this.pendingTriggerIds.forEach((g) => this.deleteWidgetState(g)), this.pendingTriggerIds.clear(), this.triggerFlushResolvers.forEach((g) => g()), this.triggerFlushResolvers = [], this.flushScheduled = !1, this.scheduledFragmentId = void 0, this.hasFragmentIdConflict = !1;
    }, 0));
  }
}
function requireNumberInt(o) {
  if (typeof o == "number")
    return o;
  const i = protobufjsExports.util.LongBits.from(o).toNumber();
  if (Number.isSafeInteger(i))
    return i;
  throw new Error(
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions -- TODO: Fix this
    `value ${o} cannot be converted to number without a loss of precision!`
  );
}
class ReactHotkeys extends React__default.Component {
  constructor(i) {
    super(i), this.isKeyDown = !1, this.handle = void 0, this.onKeyDown = this.onKeyDown.bind(this), this.onKeyUp = this.onKeyUp.bind(this), this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this), this.handle = {};
  }
  componentDidMount() {
    var {
      filter: i,
      splitKey: g
    } = this.props;
    i && (hotkeys.filter = i), hotkeys.unbind(this.props.keyName), hotkeys(this.props.keyName, {
      splitKey: g
    }, this.onKeyDown), document && document.body.addEventListener("keyup", this.handleKeyUpEvent);
  }
  componentWillUnmount() {
    hotkeys.unbind(this.props.keyName), this.isKeyDown = !0, this.handle = {}, document && document.body.removeEventListener("keyup", this.handleKeyUpEvent);
  }
  onKeyUp(i, g) {
    var {
      onKeyUp: E,
      disabled: e
    } = this.props;
    !e && E && E(g.shortcut, i, g);
  }
  onKeyDown(i, g) {
    var {
      onKeyDown: E,
      allowRepeat: e,
      disabled: t
    } = this.props;
    this.isKeyDown && !e || (this.isKeyDown = !0, this.handle = g, !t && E && E(g.shortcut, i, g));
  }
  handleKeyUpEvent(i) {
    this.isKeyDown && (this.isKeyDown = !1, !(this.props.keyName && this.props.keyName.indexOf(this.handle.shortcut) < 0) && (this.onKeyUp(i, this.handle), this.handle = {}));
  }
  render() {
    return this.props.children || null;
  }
}
ReactHotkeys.defaultProps = {
  filter(o) {
    var i = o.target || o.srcElement, g = i.tagName;
    return !(i.isContentEditable || g === "INPUT" || g === "SELECT" || g === "TEXTAREA");
  }
};
ReactHotkeys.propTypes = {
  keyName: propTypesExports.string,
  filter: propTypesExports.func,
  onKeyDown: propTypesExports.func,
  onKeyUp: propTypesExports.func,
  disabled: propTypesExports.bool,
  splitKey: propTypesExports.string
};
function EventContainer({
  children: o
}) {
  const i = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ToasterContainer,
      {
        placement: PLACEMENT.topRight,
        autoHideDuration: 4 * 1e3,
        overrides: {
          Root: {
            style: {
              // Avoids blocking the header
              top: i.sizes.headerHeight,
              zIndex: i.zIndices.toast
            },
            props: {
              "data-testid": "stToastContainer",
              className: "stToastContainer"
            }
          }
        }
      }
    ),
    o
  ] });
}
const StyledLogoContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby6"
} : {
  target: "ezrtsby6",
  label: "StyledLogoContainer"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeader$2 = /* @__PURE__ */ createStyled("header", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby5"
} : {
  target: "ezrtsby5",
  label: "StyledHeader"
})(({
  theme: o,
  isTransparentBackground: i
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  display: "flex",
  alignItems: "center",
  height: o.sizes.headerHeight,
  minHeight: o.sizes.headerHeight,
  width: "100%",
  background: i ? "transparent" : o.colors.bgColor,
  outline: "none",
  zIndex: o.zIndices.header,
  pointerEvents: i ? "none" : "auto",
  fontSize: o.fontSizes.sm,
  "@media print": {
    position: "absolute",
    background: "transparent",
    // Hide all descendants by default
    "& *": {
      display: "none !important"
    },
    // Show the logo container and its parents/contents
    [`& ${StyledLogoContainer}, & ${StyledLogoContainer} *, & :has(${StyledLogoContainer})`]: {
      display: "flex !important"
    },
    [`& ${StyledLogoContainer} img`]: {
      display: "block !important"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderToolbar = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby4"
} : {
  target: "ezrtsby4",
  label: "StyledHeaderToolbar"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  width: "100%",
  padding: 0,
  pointerEvents: "auto",
  position: "relative",
  zIndex: o.zIndices.header
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledOpenSidebarButton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby3"
} : {
  target: "ezrtsby3",
  label: "StyledOpenSidebarButton"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: o.spacing.lg,
  "@media print": {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby2"
} : {
  target: "ezrtsby2",
  label: "StyledHeaderContent"
})(() => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  margin: 0,
  border: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderLeftSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby1"
} : {
  target: "ezrtsby1",
  label: "StyledHeaderLeftSection"
})(() => ({
  display: "flex",
  alignItems: "center",
  // Prevent the logo area from shrinking when TopNav's overflow container expands.
  // Without this, the logo would shrink due to its maxWidth: 100% style.
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderRightSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby0"
} : {
  target: "ezrtsby0",
  label: "StyledHeaderRightSection"
})(({
  theme: o
}) => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginLeft: "auto",
  height: "100%",
  minWidth: o.sizes.headerRightContentMaxWidth,
  marginRight: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Header = ({
  hasSidebar: o,
  isSidebarOpen: i,
  onToggleSidebar: g,
  navigation: E,
  rightContent: e,
  logoComponent: t,
  showToolbar: n
}) => {
  const {
    activeTheme: h
  } = useContext(ThemeContext), d = t && !i, k = o && !i, p = n && e, M = d || k || E || p;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$2, { className: "stAppHeader", "data-testid": "stHeader", isTransparentBackground: !M, children: M ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderToolbar, { className: "stAppToolbar", "data-testid": "stToolbar", theme: h.emotion, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderLeftSection, { children: [
      d ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLogoContainer, { children: t }) : null,
      k && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOpenSidebarButton, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, onClick: g, "data-testid": "stExpandSidebarButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "xl", iconValue: ":material/keyboard_double_arrow_right:", color: h.emotion.colors.fadedText60 }) }) })
    ] }),
    E,
    p ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderRightSection, { children: e }) : null
  ] }) }) : null });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$8() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const getSidebarHorizontalSpacing = (o, i) => `max(
    ${i}px,
    calc(${o.spacing.xl} - ${i}px)
  )`, StyledSidebar = /* @__PURE__ */ createStyled("section", process.env.NODE_ENV === "production" ? {
  target: "eczjsme10"
} : {
  target: "eczjsme10",
  label: "StyledSidebar"
})(({
  theme: o,
  isCollapsed: i,
  adjustTop: g,
  sidebarWidth: E,
  windowInnerWidth: e
}) => {
  const t = i ? 0 : Math.min(200, e), n = i ? 0 : Math.min(600, e * 0.9);
  return {
    position: "relative",
    // Nudge the sidebar by 2px so the header decoration doesn't go below it
    top: g ? o.sizes.headerDecorationHeight : o.spacing.none,
    backgroundColor: o.colors.bgColor,
    // Since the sidebar can have a different theme (+ background)
    // we need to explicitly set the font color and color scheme
    // here again so that it is inherited correctly by all sidebar elements:
    color: o.colors.bodyText,
    colorScheme: hasLightBackgroundColor(o) ? "light" : "dark",
    zIndex: o.zIndices.header + 1,
    minWidth: t,
    maxWidth: n,
    transform: i ? `translateX(-${E}px)` : "none",
    transition: "transform 300ms, min-width 300ms, max-width 300ms",
    "&:focus": {
      outline: "none"
    },
    [`@media (max-width: ${o.breakpoints.md})`]: {
      boxShadow: i ? "-2rem 0 2rem 2rem transparent" : o.shadows.sidebar
    },
    "@media print": {
      display: i ? "none" : "initial",
      // set to auto, otherwise the sidebar does not take up the whole page
      height: "auto !important",
      // set maxHeight to little bit less than 100%, otherwise the sidebar might start a mostly blank page
      maxHeight: "99%",
      // on Chrome, sth. adds a box-shadow in printing mode which looks weird
      boxShadow: "none"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarUserContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme9"
} : {
  target: "eczjsme9",
  label: "StyledSidebarUserContent"
})(({
  hasPageNavAbove: o,
  theme: i
}) => ({
  paddingTop: o ? i.spacing.twoXL : 0,
  paddingBottom: i.sizes.sidebarTopSpace
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme8"
} : {
  target: "eczjsme8",
  label: "StyledSidebarContent"
})(({
  theme: o,
  scrollbarGutterSize: i
}) => ({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "auto",
  /**
   * Ensure that space is reserved for scrollbars, even when they are not
   * visible. This is necessary to prevent layout shifts when the scrollbars
   * appear and disappear.
   *
   * We utilize both-edges so that things look visually centered and aligned.
   *
   * @see https://github.com/streamlit/streamlit/issues/10310
   */
  scrollbarGutter: "stable both-edges",
  paddingLeft: getSidebarHorizontalSpacing(o, i),
  paddingRight: getSidebarHorizontalSpacing(o, i)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), RESIZE_HANDLE_WIDTH = "8px", StyledResizeHandle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme7"
} : {
  target: "eczjsme7",
  label: "StyledResizeHandle"
})(({
  theme: o
}) => ({
  position: "absolute",
  width: RESIZE_HANDLE_WIDTH,
  height: "100%",
  cursor: "col-resize",
  zIndex: o.zIndices.sidebarMobile,
  backgroundImage: o.showSidebarBorder ? `linear-gradient(to right, transparent 20%, ${o.colors.borderColor} 28%, transparent 36%)` : "none",
  "&:hover": {
    backgroundImage: `linear-gradient(to right, transparent 20%, ${o.colors.borderColor} 28%, transparent 44%)`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarHeaderContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme6"
} : {
  target: "eczjsme6",
  label: "StyledSidebarHeaderContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: o.spacing.lg,
  height: o.sizes.headerHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLogoLink = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "eczjsme5"
} : {
  target: "eczjsme5",
  label: "StyledLogoLink"
})(process.env.NODE_ENV === "production" ? {
  name: "t02jc9",
  styles: "&:hover{opacity:0.7;}"
} : {
  name: "t02jc9",
  styles: "&:hover{opacity:0.7;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
}), StyledLogoButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "eczjsme4"
} : {
  target: "eczjsme4",
  label: "StyledLogoButton"
})(process.env.NODE_ENV === "production" ? {
  name: "l7ug5t",
  styles: "background:none;border:none;padding:0;cursor:pointer;&:hover{opacity:0.7;}"
} : {
  name: "l7ug5t",
  styles: "background:none;border:none;padding:0;cursor:pointer;&:hover{opacity:0.7;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
function translateLogoHeight(o, i) {
  return i === "small" ? o.sizes.smallLogoHeight : i === "large" ? o.sizes.largeLogoHeight : o.sizes.defaultLogoHeight;
}
const StyledLogo = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eczjsme3"
} : {
  target: "eczjsme3",
  label: "StyledLogo"
})(({
  theme: o,
  size: i
}) => ({
  height: translateLogoHeight(o, i),
  // Extra margin to align small logo with sidebar collapse arrow
  marginTop: i == "small" ? o.spacing.xs : o.spacing.twoXS,
  marginBottom: i == "small" ? o.spacing.xs : o.spacing.twoXS,
  marginLeft: o.spacing.none,
  zIndex: o.zIndices.header,
  objectFit: "contain",
  objectPosition: "left",
  verticalAlign: "middle",
  maxWidth: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIconLogo = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme2"
} : {
  target: "eczjsme2",
  label: "StyledIconLogo"
})(({
  theme: o,
  size: i
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  height: translateLogoHeight(o, i),
  marginTop: i == "small" ? o.spacing.xs : o.spacing.twoXS,
  marginBottom: i == "small" ? o.spacing.xs : o.spacing.twoXS,
  marginLeft: o.spacing.none,
  zIndex: o.zIndices.header,
  fontSize: translateLogoHeight(o, i),
  lineHeight: o.lineHeights.none,
  color: o.colors.bodyText
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNoLogoSpacer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme1"
} : {
  target: "eczjsme1",
  label: "StyledNoLogoSpacer"
})(({
  theme: o
}) => ({
  height: o.sizes.largeLogoHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCollapseSidebarButton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme0"
} : {
  target: "eczjsme0",
  label: "StyledCollapseSidebarButton"
})(({
  showSidebarCollapse: o,
  theme: i
}) => ({
  display: "inline",
  visibility: o ? "visible" : "hidden",
  marginLeft: i.spacing.sm,
  transition: "left 300ms",
  transitionDelay: "left 300ms",
  color: hasLightBackgroundColor(i) ? i.colors.fadedText60 : i.colors.bodyText,
  lineHeight: "0",
  "@media print": {
    // Always hide the collapse button on print:
    visibility: "hidden"
  },
  [`@media (max-width: ${i.breakpoints.sm})`]: {
    // Always show the collapse button on small screens:
    visibility: "visible"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), LOG$6 = loglevelExports$1.getLogger("LogoComponent"), LOGO_SIZE_TO_ICON_SIZE = {
  small: "lg",
  // 1.25rem
  medium: "xl",
  // 1.5rem
  large: "twoXL"
  // 1.8rem
}, LogoComponent = ({
  appLogo: o,
  endpoints: i,
  collapsed: g = !1,
  componentName: E = "Logo",
  dataTestId: e = "stLogo"
}) => {
  const {
    resourceCrossOriginMode: t
  } = useContext(LibConfigContext), {
    appPages: n,
    onPageChange: h,
    currentPageScriptHash: d
  } = useContext(NavigationContext), k = useMemo$1(() => n.find((EA) => EA.isDefault), [n]), p = n.length > 1, M = k?.pageScriptHash === d, H = useCallback(() => {
    k?.pageScriptHash && !M && h(k.pageScriptHash);
  }, [k, h, M]);
  if (o = useStliteResolvedLogo(o), !o)
    return null;
  const f = (EA) => {
    LOG$6.error(`Client Error: ${E} source error - ${EA}`), i.sendClientErrorToHost(E, "Logo source failed to load", "onerror triggered", EA);
  }, AA = g && o.iconImage ? o.iconImage : o.image, gA = g && o.iconImage ? o.iconImageType : o.imageType, IA = i.buildMediaURL(AA), BA = getCrossOriginAttribute(t, AA), CA = gA === Logo.ImageType.ICON || gA === Logo.ImageType.EMOJI, QA = LOGO_SIZE_TO_ICON_SIZE[o.size] || "xl", iA = CA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIconLogo, { size: o.size, className: "stLogo", "data-testid": e, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: AA, size: QA }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledLogo,
    {
      src: IA,
      size: o.size,
      alt: "Logo",
      className: "stLogo",
      "data-testid": e,
      onError: (EA) => f(IA),
      crossOrigin: BA
    }
  );
  return o.link ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledLogoLink,
    {
      href: o.link,
      target: "_blank",
      rel: "noreferrer",
      "data-testid": "stLogoLink",
      "aria-label": CA ? "App Logo" : void 0,
      children: iA
    }
  ) : p && k && !M ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLogoButton, { onClick: H, "data-testid": "stLogoLink", "aria-label": "Navigate to home page", children: iA }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: iA });
}, getNavTextColor = (o, i, g = !1, E) => {
  if (g)
    return o.colors.fadedText40;
  if (E)
    return o.colors.bodyText;
  const e = hasLightBackgroundColor(o);
  return i ? o.colors.bodyText : e ? transparentize(o.colors.bodyText, 0.2) : transparentize(o.colors.bodyText, 0.25);
}, StyledSidebarNavContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl920"
} : {
  target: "e10lwvl920",
  label: "StyledSidebarNavContainer"
})(({
  theme: o
}) => ({
  position: "relative",
  fontFamily: o.genericFonts.bodyFont
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavItems = /* @__PURE__ */ createStyled("ul", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl919"
} : {
  target: "e10lwvl919",
  label: "StyledSidebarNavItems"
})(({
  theme: o
}) => ({
  listStyle: "none",
  margin: o.spacing.none,
  paddingBottom: o.spacing.threeXS,
  paddingTop: o.spacing.none,
  paddingRight: o.spacing.none,
  paddingLeft: o.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl918"
} : {
  target: "e10lwvl918",
  label: "StyledSidebarNavLinkContainer"
})(({
  disabled: o
}) => ({
  display: "flex",
  flexDirection: "column",
  cursor: o ? "not-allowed" : "pointer"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl917"
} : {
  target: "e10lwvl917",
  label: "StyledSidebarNavIcon"
})(({
  theme: o,
  isActive: i
}) => ({
  display: "inline-flex",
  // Apply a different font weight to the icon if it is active
  // The icon is in a span element.
  span: {
    fontWeight: i ? o.fontWeights.bold : o.fontWeights.normal
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLinkListItem = /* @__PURE__ */ createStyled("li", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl916"
} : {
  target: "e10lwvl916",
  label: "StyledSidebarNavLinkListItem"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.threeXS,
  marginBottom: o.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLink = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl915"
} : {
  target: "e10lwvl915",
  label: "StyledSidebarNavLink"
})(({
  theme: o,
  isActive: i,
  disabled: g
}) => {
  const E = {
    textDecoration: "none",
    fontWeight: i ? o.fontWeights.bold : o.fontWeights.normal
  };
  return {
    ...E,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: o.spacing.sm,
    borderRadius: o.radii.default,
    paddingLeft: o.spacing.sm,
    paddingRight: o.spacing.sm,
    marginTop: o.spacing.threeXS,
    marginBottom: o.spacing.threeXS,
    lineHeight: o.lineHeights.menuItem,
    color: getNavTextColor(o, i),
    backgroundColor: i ? o.colors.darkenedBgMix25 : "transparent",
    ...g && {
      pointerEvents: "none"
    },
    "&:hover": {
      backgroundColor: o.colors.darkenedBgMix15
    },
    "&:active,&:visited,&:hover": {
      ...E
    },
    "&:focus": {
      outline: "none"
    },
    "&:focus-visible": {
      backgroundColor: o.colors.darkenedBgMix15
    },
    "@media print": {
      paddingLeft: o.spacing.none
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarLinkText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl914"
} : {
  target: "e10lwvl914",
  label: "StyledSidebarLinkText"
})(({
  isActive: o,
  theme: i,
  disabled: g,
  isTopNav: E,
  label: e
}) => ({
  color: getNavTextColor(i, o, g, E),
  fontSize: i.fontSizes.sm,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  display: "table-cell",
  /* Pseudo-element to reserve bold width */
  "&::after": {
    content: `"${e}"`,
    fontWeight: i.fontWeights.bold,
    visibility: "hidden",
    display: "block",
    width: "fit-content",
    height: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledChevronContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl913"
} : {
  target: "e10lwvl913",
  label: "StyledChevronContainer"
})(({
  isExpanded: o
}) => ({
  visibility: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transform: o ? "rotate(0deg)" : "rotate(-90deg)",
  transition: "transform 200ms ease",
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionHeaderText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl912"
} : {
  target: "e10lwvl912",
  label: "StyledNavSectionHeaderText"
})(() => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavSectionHeader = /* @__PURE__ */ createStyled("header", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl911"
} : {
  target: "e10lwvl911",
  label: "StyledSidebarNavSectionHeader"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.sm,
  fontWeight: o.fontWeights.semiBold,
  color: getNavTextColor(o, !1),
  lineHeight: o.lineHeights.small,
  paddingRight: o.spacing.sm,
  marginTop: o.spacing.sm,
  marginBottom: o.spacing.twoXS,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: o.spacing.sm,
  cursor: "pointer",
  userSelect: "none",
  "&:hover": {
    [`& > ${StyledChevronContainer}`]: {
      visibility: "visible"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9OYXZpZ2F0aW9uL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBNNkMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL05hdmlnYXRpb24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSBcImNvbG9yMmtcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuLyoqXG4gKiBSZXR1cm5zIHRoZSBjb2xvciBvZiB0aGUgdGV4dCBpbiB0aGUgc2lkZWJhciBuYXYuXG4gKlxuICogQHBhcmFtIHRoZW1lIFRoZSB0aGVtZSB0byB1c2UuXG4gKiBAcGFyYW0gaXNBY3RpdmUgV2hldGhlciB0aGUgbmF2IHRleHQgc2hvdWxkIHNob3cgYXMgYWN0aXZlLlxuICogQHJldHVybnMgVGhlIGNvbG9yIG9mIHRoZSB0ZXh0IGluIHRoZSBzaWRlYmFyIG5hdi5cbiAqL1xuZXhwb3J0IGNvbnN0IGdldE5hdlRleHRDb2xvciA9IChcbiAgdGhlbWU6IEVtb3Rpb25UaGVtZSxcbiAgaXNBY3RpdmU6IGJvb2xlYW4sXG4gIGRpc2FibGVkOiBib29sZWFuID0gZmFsc2UsXG4gIGlzVG9wTmF2PzogYm9vbGVhblxuKTogc3RyaW5nID0+IHtcbiAgaWYgKGRpc2FibGVkKSB7XG4gICAgcmV0dXJuIHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MFxuICB9XG5cbiAgaWYgKGlzVG9wTmF2KSB7XG4gICAgcmV0dXJuIHRoZW1lLmNvbG9ycy5ib2R5VGV4dFxuICB9XG5cbiAgY29uc3QgaXNMaWdodFRoZW1lID0gaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpXG5cbiAgaWYgKGlzQWN0aXZlKSB7XG4gICAgcmV0dXJuIHRoZW1lLmNvbG9ycy5ib2R5VGV4dFxuICB9XG4gIHJldHVybiBpc0xpZ2h0VGhlbWVcbiAgICA/IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5ib2R5VGV4dCwgMC4yKVxuICAgIDogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmJvZHlUZXh0LCAwLjI1KVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgZm9udEZhbWlseTogdGhlbWUuZ2VuZXJpY0ZvbnRzLmJvZHlGb250LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2SXRlbXMgPSBzdHlsZWQudWwoKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGxpc3RTdHlsZTogXCJub25lXCIsXG4gICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgcGFkZGluZ0JvdHRvbTogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAgIHBhZGRpbmdUb3A6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICB9XG59KVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJOYXZMaW5rQ29udGFpbmVyUHJvcHMge1xuICBkaXNhYmxlZDogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkxpbmtDb250YWluZXIgPVxuICBzdHlsZWQuZGl2PFN0eWxlZFNpZGViYXJOYXZMaW5rQ29udGFpbmVyUHJvcHM+KCh7IGRpc2FibGVkIH0pID0+ICh7XG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgICBjdXJzb3I6IGRpc2FibGVkID8gXCJub3QtYWxsb3dlZFwiIDogXCJwb2ludGVyXCIsXG4gIH0pKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJOYXZJY29uUHJvcHMge1xuICBpc0FjdGl2ZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkljb24gPSBzdHlsZWQuc3BhbjxTdHlsZWRTaWRlYmFyTmF2SWNvblByb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgICAgLy8gQXBwbHkgYSBkaWZmZXJlbnQgZm9udCB3ZWlnaHQgdG8gdGhlIGljb24gaWYgaXQgaXMgYWN0aXZlXG4gICAgICAvLyBUaGUgaWNvbiBpcyBpbiBhIHNwYW4gZWxlbWVudC5cbiAgICAgIHNwYW46IHtcbiAgICAgICAgZm9udFdlaWdodDogaXNBY3RpdmVcbiAgICAgICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgICAgICA6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2TGlua0xpc3RJdGVtID0gc3R5bGVkLmxpKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbn0pKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJOYXZMaW5rUHJvcHMge1xuICBpc0FjdGl2ZTogYm9vbGVhblxuICBkaXNhYmxlZDogYm9vbGVhblxuICBpc1RvcE5hdj86IGJvb2xlYW5cbiAgbGFiZWw/OiBzdHJpbmdcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZMaW5rID0gc3R5bGVkLmE8U3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcz4oXG4gICh7IHRoZW1lLCBpc0FjdGl2ZSwgZGlzYWJsZWQgfSkgPT4ge1xuICAgIGNvbnN0IGRlZmF1bHRQYWdlTGlua1N0eWxlcyA9IHtcbiAgICAgIHRleHREZWNvcmF0aW9uOiBcIm5vbmVcIixcbiAgICAgIGZvbnRXZWlnaHQ6IGlzQWN0aXZlID8gdGhlbWUuZm9udFdlaWdodHMuYm9sZCA6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICB9XG5cbiAgICByZXR1cm4ge1xuICAgICAgLi4uZGVmYXVsdFBhZ2VMaW5rU3R5bGVzLFxuICAgICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgICBmbGV4RGlyZWN0aW9uOiBcInJvd1wiLFxuICAgICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICAgIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxuXG4gICAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAgICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMubWVudUl0ZW0sXG5cbiAgICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGlzQWN0aXZlKSxcbiAgICAgIGJhY2tncm91bmRDb2xvcjogaXNBY3RpdmUgPyB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1IDogXCJ0cmFuc3BhcmVudFwiLFxuXG4gICAgICAuLi4oZGlzYWJsZWQgJiYge1xuICAgICAgICBwb2ludGVyRXZlbnRzOiBcIm5vbmVcIixcbiAgICAgIH0pLFxuXG4gICAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgICB9LFxuXG4gICAgICBcIiY6YWN0aXZlLCY6dmlzaXRlZCwmOmhvdmVyXCI6IHtcbiAgICAgICAgLi4uZGVmYXVsdFBhZ2VMaW5rU3R5bGVzLFxuICAgICAgfSxcblxuICAgICAgXCImOmZvY3VzXCI6IHtcbiAgICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICB9LFxuXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICAgIH0sXG5cbiAgICAgIFtgQG1lZGlhIHByaW50YF06IHtcbiAgICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTGlua1RleHQgPSBzdHlsZWQuc3BhbjxTdHlsZWRTaWRlYmFyTmF2TGlua1Byb3BzPihcbiAgKHsgaXNBY3RpdmUsIHRoZW1lLCBkaXNhYmxlZCwgaXNUb3BOYXYsIGxhYmVsIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgY29sb3I6IGdldE5hdlRleHRDb2xvcih0aGVtZSwgaXNBY3RpdmUsIGRpc2FibGVkLCBpc1RvcE5hdiksXG4gICAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBkaXNwbGF5OiBcInRhYmxlLWNlbGxcIixcbiAgICAgIC8qIFBzZXVkby1lbGVtZW50IHRvIHJlc2VydmUgYm9sZCB3aWR0aCAqL1xuICAgICAgXCImOjphZnRlclwiOiB7XG4gICAgICAgIGNvbnRlbnQ6IGBcIiR7bGFiZWx9XCJgIC8qIGR1cGxpY2F0ZSB0ZXh0ICovLFxuICAgICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkIC8qIGJvbGQgdmVyc2lvbiAqLyxcbiAgICAgICAgdmlzaWJpbGl0eTogXCJoaWRkZW5cIiAvKiBvY2N1cGllcyBzcGFjZSwgbm90IHZpc2libGUgKi8sXG4gICAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICAgICAgd2lkdGg6IFwiZml0LWNvbnRlbnRcIixcbiAgICAgICAgaGVpZ2h0OiAwLFxuICAgICAgfSxcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENoZXZyb25Db250YWluZXIgPSBzdHlsZWQuZGl2PHsgaXNFeHBhbmRlZDogYm9vbGVhbiB9PihcbiAgKHsgaXNFeHBhbmRlZCB9KSA9PiAoe1xuICAgIHZpc2liaWxpdHk6IFwiaGlkZGVuXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgICB0cmFuc2Zvcm06IGlzRXhwYW5kZWQgPyBcInJvdGF0ZSgwZGVnKVwiIDogXCJyb3RhdGUoLTkwZGVnKVwiLFxuICAgIHRyYW5zaXRpb246IFwidHJhbnNmb3JtIDIwMG1zIGVhc2VcIixcbiAgICBmbGV4U2hyaW5rOiAwLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTmF2U2VjdGlvbkhlYWRlclRleHQgPSBzdHlsZWQuc3BhbigoKSA9PiAoe1xuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gIG1pbldpZHRoOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2U2VjdGlvbkhlYWRlciA9IHN0eWxlZC5oZWFkZXI8e1xuICBpc0V4cGFuZGVkOiBib29sZWFuXG59PigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5zZW1pQm9sZCxcbiAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCBmYWxzZSksXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMuc21hbGwsXG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZmxleERpcmVjdGlvbjogXCJyb3dcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgIHVzZXJTZWxlY3Q6IFwibm9uZVwiLFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBbYCYgPiAke1N0eWxlZENoZXZyb25Db250YWluZXJ9YF06IHtcbiAgICAgICAgdmlzaWJpbGl0eTogXCJ2aXNpYmxlXCIsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRWaWV3QnV0dG9uID0gc3R5bGVkLmJ1dHRvbigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIHRydWUpLFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnRocmVlWFN9ICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXNcIjoge1xuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZTZXBhcmF0b3IgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmdUb3A6IHRoZW1lLnNwYWNpbmcubGcsXG4gIGJvcmRlckJvdHRvbTogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiJjpub3QoOmZpcnN0LWNoaWxkKVwiOiB7XG4gICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9LFxufSkpXG5cbi8vIFRvcE5hdiBzdHlsZWQgY29tcG9uZW50c1xuZXhwb3J0IGNvbnN0IFN0eWxlZE92ZXJmbG93Q29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBmbGV4U2hyaW5rOiAxLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG59KSlcblxuaW50ZXJmYWNlIFN0eWxlZE5hdlNlY3Rpb25Qcm9wcyB7XG4gIGlzT3BlbjogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTmF2U2VjdGlvbiA9IHN0eWxlZC5kaXY8U3R5bGVkTmF2U2VjdGlvblByb3BzPihcbiAgKHsgdGhlbWUsIGlzT3BlbiB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm1lbnVJdGVtLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgY29sb3I6IGdldE5hdlRleHRDb2xvcih0aGVtZSwgZmFsc2UsIGZhbHNlLCB0cnVlKSxcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgXCImOm5vdCg6Zmlyc3Qtb2YtdHlwZSlcIjoge1xuICAgICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICB9LFxuICAgIC4uLihpc09wZW4gPyB7IGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSB9IDoge30pLFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRvcE5hdkxpbmtDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICBcIiY6bm90KDpmaXJzdC1vZi10eXBlKVwiOiB7XG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgfSxcbn0pKVxuXG4vLyBUaGlzIGlzIHNwZWNpZmljYWxseSBmb3IgdXNlIGluIFRvcE5hdlNlY3Rpb24ncyBwb3BvdmVyIG1lbnVcbmV4cG9ydCBjb25zdCBTdHlsZWRUb3BOYXZTaWRlYmFyTmF2TGlua0NvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTmF2U2VjdGlvblRleHQgPSBzdHlsZWQuc3BhbigoKSA9PiAoe1xuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWN0aW9uTmFtZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcuc20sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBvcG92ZXJDb250ZW50ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAwYCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkSWNvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50d29YUyxcbn0pKVxuIl19 */"), StyledViewButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl910"
} : {
  target: "e10lwvl910",
  label: "StyledViewButton"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.sm,
  fontFamily: "inherit",
  lineHeight: o.lineHeights.base,
  color: getNavTextColor(o, !0),
  backgroundColor: o.colors.transparent,
  border: "none",
  borderRadius: o.radii.default,
  marginTop: o.spacing.twoXS,
  marginLeft: o.spacing.none,
  marginBottom: o.spacing.none,
  marginRight: o.spacing.none,
  padding: `${o.spacing.threeXS} ${o.spacing.sm}`,
  "&:hover, &:active, &:focus": {
    border: "none",
    outline: "none",
    boxShadow: "none"
  },
  "&:hover": {
    backgroundColor: o.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavSeparator = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl99"
} : {
  target: "e10lwvl99",
  label: "StyledSidebarNavSeparator"
})(({
  theme: o
}) => ({
  paddingTop: o.spacing.lg,
  borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl98"
} : {
  target: "e10lwvl98",
  label: "StyledNavSectionContainer"
})(({
  theme: o
}) => ({
  "&:not(:first-child)": {
    marginTop: o.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledOverflowContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl97"
} : {
  target: "e10lwvl97",
  label: "StyledOverflowContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  flexShrink: 1,
  overflow: "hidden",
  padding: `0 ${o.spacing.lg}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl96"
} : {
  target: "e10lwvl96",
  label: "StyledNavSection"
})(({
  theme: o,
  isOpen: i
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "relative",
  lineHeight: o.lineHeights.menuItem,
  fontSize: o.fontSizes.sm,
  padding: `0 ${o.spacing.sm}`,
  color: getNavTextColor(o, !1, !1, !0),
  borderRadius: o.radii.default,
  marginRight: o.spacing.twoXS,
  "&:not(:first-of-type)": {
    marginLeft: o.spacing.twoXS
  },
  ...i ? {
    backgroundColor: o.colors.darkenedBgMix25
  } : {},
  "&:hover": {
    backgroundColor: o.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTopNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl95"
} : {
  target: "e10lwvl95",
  label: "StyledTopNavLinkContainer"
})(({
  theme: o
}) => ({
  marginRight: o.spacing.twoXS,
  "&:not(:first-of-type)": {
    marginLeft: o.spacing.twoXS
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTopNavSidebarNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl94"
} : {
  target: "e10lwvl94",
  label: "StyledTopNavSidebarNavLinkContainer"
})(({
  theme: o
}) => ({
  margin: `${o.spacing.twoXS} ${o.spacing.sm}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl93"
} : {
  target: "e10lwvl93",
  label: "StyledNavSectionText"
})(() => ({
  whiteSpace: "nowrap"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSectionName = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl92"
} : {
  target: "e10lwvl92",
  label: "StyledSectionName"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.sm,
  marginTop: o.spacing.sm,
  marginBottom: o.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPopoverContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl91"
} : {
  target: "e10lwvl91",
  label: "StyledPopoverContent"
})(({
  theme: o
}) => ({
  padding: `${o.spacing.twoXS} 0`,
  fontSize: o.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIconContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl90"
} : {
  target: "e10lwvl90",
  label: "StyledIconContainer"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), NavSection = ({
  header: o = "",
  children: i,
  isExpanded: g,
  onToggle: E
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledNavSectionContainer, { children: [
  o && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavSectionHeader, { "data-testid": "stNavSectionHeader", onClick: E, isExpanded: g, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNavSectionHeaderText, { children: o }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledChevronContainer, { isExpanded: g, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: ":material/expand_more:", size: "lg" }) })
  ] }),
  g && i
] }), SidebarNavLink = ({
  isActive: o,
  pageUrl: i,
  icon: g,
  onClick: E,
  isTopNav: e,
  isInDropdown: t,
  children: n,
  widgetsDisabled: h
}) => {
  const d = useEmotionTheme(), k = h;
  let p;
  e && t ? p = "stTopNavDropdownLink" : e ? p = "stTopNavLink" : p = "stSidebarNavLink";
  const M = e ? "stTopNavLinkContainer" : "stSidebarNavLinkContainer";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavLinkContainer, { disabled: k, "data-testid": M, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavLink, { "data-testid": p, isActive: o, disabled: k, href: i, onClick: E, "aria-current": o ? "page" : void 0, children: [
    g?.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavIcon, { isActive: o, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "base", iconValue: g, color: !o && isMaterialIcon(g) ? (
      // Apply color with opacity on material icons
      // But we don't want to apply opacity on emoji icons
      d.colors.fadedText60
    ) : d.colors.bodyText }) }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarLinkText, { isActive: o, disabled: k, isTopNav: e, label: n, children: n })
  ] }) });
};
function shouldShowNavigation(o, i) {
  return o.length <= 1 ? !1 : (i.length === 0 || i.length > 1, !0);
}
function groupPagesBySection(o) {
  return groupBy(o, (i) => i.sectionHeader || "");
}
function hasNonEmptySections(o) {
  return Object.keys(o).some((i) => i !== "");
}
function processNavigationStructure(o) {
  if (!hasNonEmptySections(o))
    return {
      individualPages: Object.values(o).flat(),
      sections: {}
    };
  const g = o[""] || [], E = {};
  return Object.entries(o).forEach(([e, t]) => {
    e && e !== "" && e !== "undefined" && (E[e] = t);
  }), {
    individualPages: g,
    sections: E
  };
}
const COLLAPSE_THRESHOLD = 12, NUM_PAGES_TO_SHOW_WHEN_COLLAPSED = 10, LOG$5 = loglevelExports$1.getLogger("SidebarNav");
function NavLink({
  pageUrl: o,
  page: i,
  isActive: g,
  onClick: E,
  widgetsDisabled: e
}) {
  const t = i.pageName;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavLinkListItem, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { isActive: g, pageUrl: o, icon: i.icon, onClick: E, widgetsDisabled: e, children: t }) });
}
function generateNavSections(o, i, g, E, e, t) {
  const n = [];
  let h = t;
  return Object.entries(o).forEach(([d, k]) => {
    const p = [...k];
    let M = p;
    const H = E[d];
    if (i) {
      const f = NUM_PAGES_TO_SHOW_WHEN_COLLAPSED - h;
      f <= 0 ? M = [] : p.length > f && (M = p.slice(0, f));
    }
    H && (h += M.length), M.length > 0 && n.push(/* @__PURE__ */ jsxRuntimeExports.jsx(NavSection, { header: d, isExpanded: H, onToggle: () => e(d), children: M.map(g) }, d));
  }), {
    sections: n,
    updatedPageCount: h
  };
}
const SidebarNav = ({
  endpoints: o,
  collapseSidebar: i,
  hasSidebarElements: g,
  widgetsDisabled: E
}) => {
  const [e, t] = useState(!1), {
    expandSidebarNav: n
  } = useContext(SidebarConfigContext), {
    pageLinkBaseUrl: h,
    appPages: d,
    onPageChange: k,
    currentPageScriptHash: p
  } = useContext(NavigationContext), M = `stSidebarSectionsState-${h}`, [H, f] = useState(null), AA = useMemo$1(() => processNavigationStructure(groupPagesBySection(d)), [d]), gA = useMemo$1(() => {
    if (!(Object.keys(AA.sections).length > 0))
      return d.length;
    let GA = AA.individualPages.length;
    return Object.entries(AA.sections).forEach(([cA, tA]) => {
      H?.[cA] && (GA += tA.length);
    }), GA;
  }, [d.length, H, AA]);
  useEffect(() => {
    const eA = localStorageAvailable() && window.localStorage.getItem("sidebarNavState") === "expanded";
    !e && (n || eA) && t(!0);
  }, [e, n]), useEffect(() => {
    if (localStorageAvailable()) {
      const eA = window.localStorage.getItem(M);
      let GA = {};
      if (eA)
        try {
          GA = JSON.parse(eA);
        } catch (tA) {
          GA = {}, LOG$5.warn("Could not parse sidebar nav state from localStorage", tA);
        }
      const cA = Object.keys(AA.sections).reduce((tA, aA) => (tA[aA] = GA[aA] ?? !0, tA), {});
      f(cA);
    } else {
      const eA = Object.keys(AA.sections).reduce((GA, cA) => (GA[cA] = !0, GA), {});
      f(eA);
    }
  }, [AA.sections, M]), useEffect(() => {
    localStorageAvailable() && H && window.localStorage.setItem(M, JSON.stringify(H));
  }, [H, M]);
  const IA = useCallback((eA) => {
    f((GA) => GA ? {
      ...GA,
      [eA]: !GA[eA]
    } : null);
  }, []), BA = useCallback(() => {
    const eA = !e;
    localStorageAvailable() && (eA ? window.localStorage.setItem("sidebarNavState", "expanded") : window.localStorage.removeItem("sidebarNavState")), t(eA);
  }, [e]), CA = useCallback((eA, GA) => {
    const cA = o.buildAppPageURL(h, eA), tA = eA.pageScriptHash === p;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NavLink, { pageUrl: cA, page: eA, isActive: tA, onClick: (aA) => {
      aA.preventDefault(), k(eA.pageScriptHash), isMobile() && i();
    }, widgetsDisabled: E }, `${eA.pageName}-${GA}`);
  }, [i, p, o, k, h, E]);
  if (!H)
    return null;
  const QA = [], iA = g && gA > COLLAPSE_THRESHOLD && !n, EA = iA && !e;
  let oA = 0;
  if (AA.individualPages.length > 0) {
    const eA = EA ? AA.individualPages.slice(0, NUM_PAGES_TO_SHOW_WHEN_COLLAPSED) : AA.individualPages;
    QA.push(...eA.map(CA)), oA += eA.length;
  }
  if (Object.keys(AA.sections).length > 0) {
    const eA = generateNavSections(AA.sections, EA, CA, H, IA, oA);
    QA.push(...eA.sections);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavContainer, { "data-testid": "stSidebarNav", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavItems, { "data-testid": "stSidebarNavItems", children: QA }),
    iA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledViewButton, { onClick: BA, "data-testid": "stSidebarNavViewButton", children: e ? "View less" : `View ${gA - NUM_PAGES_TO_SHOW_WHEN_COLLAPSED} more` }),
    g && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavSeparator, { "data-testid": "stSidebarNavSeparator" })
  ] });
};
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g) ({}).hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$2.apply(null, arguments);
}
function _typeof$1(o) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof$1(o);
}
function toPrimitive$1(o, i) {
  if (_typeof$1(o) != "object" || !o) return o;
  var g = o[Symbol.toPrimitive];
  if (g !== void 0) {
    var E = g.call(o, i);
    if (_typeof$1(E) != "object") return E;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (i === "string" ? String : Number)(o);
}
function toPropertyKey$1(o) {
  var i = toPrimitive$1(o, "string");
  return _typeof$1(i) == "symbol" ? i : i + "";
}
function _defineProperty$2(o, i, g) {
  return (i = toPropertyKey$1(i)) in o ? Object.defineProperty(o, i, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[i] = g, o;
}
function ownKeys$3(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread2$1(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(g), !0).forEach(function(E) {
      _defineProperty$2(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$3(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _arrayWithHoles(o) {
  if (Array.isArray(o)) return o;
}
function _iterableToArrayLimit(o, i) {
  var g = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (g != null) {
    var E, e, t, n, h = [], d = !0, k = !1;
    try {
      if (t = (g = g.call(o)).next, i !== 0) for (; !(d = (E = t.call(g)).done) && (h.push(E.value), h.length !== i); d = !0) ;
    } catch (p) {
      k = !0, e = p;
    } finally {
      try {
        if (!d && g.return != null && (n = g.return(), Object(n) !== n)) return;
      } finally {
        if (k) throw e;
      }
    }
    return h;
  }
}
function _arrayLikeToArray(o, i) {
  (i == null || i > o.length) && (i = o.length);
  for (var g = 0, E = Array(i); g < i; g++) E[g] = o[g];
  return E;
}
function _unsupportedIterableToArray(o, i) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray(o, i);
    var g = {}.toString.call(o).slice(8, -1);
    return g === "Object" && o.constructor && (g = o.constructor.name), g === "Map" || g === "Set" ? Array.from(o) : g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g) ? _arrayLikeToArray(o, i) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray$1(o, i) {
  return _arrayWithHoles(o) || _iterableToArrayLimit(o, i) || _unsupportedIterableToArray(o, i) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose$1(o, i) {
  if (o == null) return {};
  var g = {};
  for (var E in o) if ({}.hasOwnProperty.call(o, E)) {
    if (i.indexOf(E) !== -1) continue;
    g[E] = o[E];
  }
  return g;
}
function _objectWithoutProperties$2(o, i) {
  if (o == null) return {};
  var g, E, e = _objectWithoutPropertiesLoose$1(o, i);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (E = 0; E < t.length; E++) g = t[E], i.indexOf(g) === -1 && {}.propertyIsEnumerable.call(o, g) && (e[g] = o[g]);
  }
  return e;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g) ({}).hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends$1.apply(null, arguments);
}
var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function isFragment(o) {
  return (
    // Base object type
    o && _typeof$g(o) === "object" && // React Element type
    (o.$$typeof === REACT_ELEMENT_TYPE_18 || o.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    o.type === REACT_FRAGMENT_TYPE
  );
}
function toArray(o) {
  var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = [];
  return React__default.Children.forEach(o, function(E) {
    E == null && !i.keepEmpty || (Array.isArray(E) ? g = g.concat(toArray(E)) : isFragment(E) && E.props ? g = g.concat(toArray(E.props.children, i)) : g.push(E));
  }), g;
}
var preWarningFns = [];
function warning(o, i) {
  if (process.env.NODE_ENV !== "production" && console !== void 0) {
    var g = preWarningFns.reduce(function(E, e) {
      return e(E ?? "", "warning");
    }, i);
    g && console.error("Warning: ".concat(g));
  }
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, _typeof(o);
}
function toPrimitive(o, i) {
  if (_typeof(o) != "object" || !o) return o;
  var g = o[Symbol.toPrimitive];
  if (g !== void 0) {
    var E = g.call(o, i);
    if (_typeof(E) != "object") return E;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (i === "string" ? String : Number)(o);
}
function toPropertyKey(o) {
  var i = toPrimitive(o, "string");
  return _typeof(i) == "symbol" ? i : i + "";
}
function _defineProperty$1(o, i, g) {
  return (i = toPropertyKey(i)) in o ? Object.defineProperty(o, i, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[i] = g, o;
}
function ownKeys$2(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread2(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(g), !0).forEach(function(E) {
      _defineProperty$1(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$2(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function isDOM(o) {
  return o instanceof HTMLElement || o instanceof SVGElement;
}
function getDOM(o) {
  return o && _typeof$g(o) === "object" && isDOM(o.nativeElement) ? o.nativeElement : isDOM(o) ? o : null;
}
function findDOMNode(o) {
  var i = getDOM(o);
  if (i)
    return i;
  if (o instanceof React__default.Component) {
    var g;
    return (g = ReactDOM.findDOMNode) === null || g === void 0 ? void 0 : g.call(ReactDOM, o);
  }
  return null;
}
var reactIs = { exports: {} }, reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var o = Symbol.for("react.element"), i = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), E = Symbol.for("react.strict_mode"), e = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), n = Symbol.for("react.context"), h = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), k = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), M = Symbol.for("react.memo"), H = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), AA;
  AA = Symbol.for("react.module.reference");
  function gA(IA) {
    if (typeof IA == "object" && IA !== null) {
      var BA = IA.$$typeof;
      switch (BA) {
        case o:
          switch (IA = IA.type, IA) {
            case g:
            case e:
            case E:
            case k:
            case p:
              return IA;
            default:
              switch (IA = IA && IA.$$typeof, IA) {
                case h:
                case n:
                case d:
                case H:
                case M:
                case t:
                  return IA;
                default:
                  return BA;
              }
          }
        case i:
          return BA;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = n, reactIs_production_min.ContextProvider = t, reactIs_production_min.Element = o, reactIs_production_min.ForwardRef = d, reactIs_production_min.Fragment = g, reactIs_production_min.Lazy = H, reactIs_production_min.Memo = M, reactIs_production_min.Portal = i, reactIs_production_min.Profiler = e, reactIs_production_min.StrictMode = E, reactIs_production_min.Suspense = k, reactIs_production_min.SuspenseList = p, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(IA) {
    return gA(IA) === n;
  }, reactIs_production_min.isContextProvider = function(IA) {
    return gA(IA) === t;
  }, reactIs_production_min.isElement = function(IA) {
    return typeof IA == "object" && IA !== null && IA.$$typeof === o;
  }, reactIs_production_min.isForwardRef = function(IA) {
    return gA(IA) === d;
  }, reactIs_production_min.isFragment = function(IA) {
    return gA(IA) === g;
  }, reactIs_production_min.isLazy = function(IA) {
    return gA(IA) === H;
  }, reactIs_production_min.isMemo = function(IA) {
    return gA(IA) === M;
  }, reactIs_production_min.isPortal = function(IA) {
    return gA(IA) === i;
  }, reactIs_production_min.isProfiler = function(IA) {
    return gA(IA) === e;
  }, reactIs_production_min.isStrictMode = function(IA) {
    return gA(IA) === E;
  }, reactIs_production_min.isSuspense = function(IA) {
    return gA(IA) === k;
  }, reactIs_production_min.isSuspenseList = function(IA) {
    return gA(IA) === p;
  }, reactIs_production_min.isValidElementType = function(IA) {
    return typeof IA == "string" || typeof IA == "function" || IA === g || IA === e || IA === E || IA === k || IA === p || IA === f || typeof IA == "object" && IA !== null && (IA.$$typeof === H || IA.$$typeof === M || IA.$$typeof === t || IA.$$typeof === n || IA.$$typeof === d || IA.$$typeof === AA || IA.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = gA, reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var o = Symbol.for("react.element"), i = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), E = Symbol.for("react.strict_mode"), e = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), n = Symbol.for("react.context"), h = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), k = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), M = Symbol.for("react.memo"), H = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), AA = !1, gA = !1, IA = !1, BA = !1, CA = !1, QA;
    QA = Symbol.for("react.module.reference");
    function iA(WA) {
      return !!(typeof WA == "string" || typeof WA == "function" || WA === g || WA === e || CA || WA === E || WA === k || WA === p || BA || WA === f || AA || gA || IA || typeof WA == "object" && WA !== null && (WA.$$typeof === H || WA.$$typeof === M || WA.$$typeof === t || WA.$$typeof === n || WA.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      WA.$$typeof === QA || WA.getModuleId !== void 0));
    }
    function EA(WA) {
      if (typeof WA == "object" && WA !== null) {
        var eg = WA.$$typeof;
        switch (eg) {
          case o:
            var ig = WA.type;
            switch (ig) {
              case g:
              case e:
              case E:
              case k:
              case p:
                return ig;
              default:
                var $A = ig && ig.$$typeof;
                switch ($A) {
                  case h:
                  case n:
                  case d:
                  case H:
                  case M:
                  case t:
                    return $A;
                  default:
                    return eg;
                }
            }
          case i:
            return eg;
        }
      }
    }
    var oA = n, eA = t, GA = o, cA = d, tA = g, aA = H, sA = M, DA = i, rA = e, nA = E, NA = k, pA = p, mA = !1, XA = !1;
    function lA(WA) {
      return mA || (mA = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function kA(WA) {
      return XA || (XA = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ZA(WA) {
      return EA(WA) === n;
    }
    function wA(WA) {
      return EA(WA) === t;
    }
    function LA(WA) {
      return typeof WA == "object" && WA !== null && WA.$$typeof === o;
    }
    function fA(WA) {
      return EA(WA) === d;
    }
    function dA(WA) {
      return EA(WA) === g;
    }
    function RA(WA) {
      return EA(WA) === H;
    }
    function KA(WA) {
      return EA(WA) === M;
    }
    function xA(WA) {
      return EA(WA) === i;
    }
    function MA(WA) {
      return EA(WA) === e;
    }
    function OA(WA) {
      return EA(WA) === E;
    }
    function SA(WA) {
      return EA(WA) === k;
    }
    function gg(WA) {
      return EA(WA) === p;
    }
    reactIs_development.ContextConsumer = oA, reactIs_development.ContextProvider = eA, reactIs_development.Element = GA, reactIs_development.ForwardRef = cA, reactIs_development.Fragment = tA, reactIs_development.Lazy = aA, reactIs_development.Memo = sA, reactIs_development.Portal = DA, reactIs_development.Profiler = rA, reactIs_development.StrictMode = nA, reactIs_development.Suspense = NA, reactIs_development.SuspenseList = pA, reactIs_development.isAsyncMode = lA, reactIs_development.isConcurrentMode = kA, reactIs_development.isContextConsumer = ZA, reactIs_development.isContextProvider = wA, reactIs_development.isElement = LA, reactIs_development.isForwardRef = fA, reactIs_development.isFragment = dA, reactIs_development.isLazy = RA, reactIs_development.isMemo = KA, reactIs_development.isPortal = xA, reactIs_development.isProfiler = MA, reactIs_development.isStrictMode = OA, reactIs_development.isSuspense = SA, reactIs_development.isSuspenseList = gg, reactIs_development.isValidElementType = iA, reactIs_development.typeOf = EA;
  })()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
var reactIsExports = requireReactIs();
function useMemo(o, i, g) {
  var E = React.useRef({});
  return (!("value" in E.current) || g(E.current.condition, i)) && (E.current.value = o(), E.current.condition = i), E.current.value;
}
var ReactMajorVersion = Number(version.split(".")[0]), fillRef = function o(i, g) {
  typeof i == "function" ? i(g) : _typeof$g(i) === "object" && i && "current" in i && (i.current = g);
}, composeRef = function o() {
  for (var i = arguments.length, g = new Array(i), E = 0; E < i; E++)
    g[E] = arguments[E];
  var e = g.filter(Boolean);
  return e.length <= 1 ? e[0] : function(t) {
    g.forEach(function(n) {
      fillRef(n, t);
    });
  };
}, useComposeRef = function o() {
  for (var i = arguments.length, g = new Array(i), E = 0; E < i; E++)
    g[E] = arguments[E];
  return useMemo(function() {
    return composeRef.apply(void 0, g);
  }, g, function(e, t) {
    return e.length !== t.length || e.every(function(n, h) {
      return n !== t[h];
    });
  });
}, supportRef = function o(i) {
  var g, E;
  if (!i)
    return !1;
  if (isReactElement(i) && ReactMajorVersion >= 19)
    return !0;
  var e = reactIsExports.isMemo(i) ? i.type.type : i.type;
  return !(typeof e == "function" && !((g = e.prototype) !== null && g !== void 0 && g.render) && e.$$typeof !== reactIsExports.ForwardRef || typeof i == "function" && !((E = i.prototype) !== null && E !== void 0 && E.render) && i.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(o) {
  return /* @__PURE__ */ isValidElement(o) && !isFragment(o);
}
var getNodeRef = function o(i) {
  if (i && isReactElement(i)) {
    var g = i;
    return g.props.propertyIsEnumerable("ref") ? g.props.ref : g.ref;
  }
  return null;
}, CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(o) {
  var i = o.children, g = o.onBatchResize, E = React.useRef(0), e = React.useRef([]), t = React.useContext(CollectionContext), n = React.useCallback(function(h, d, k) {
    E.current += 1;
    var p = E.current;
    e.current.push({
      size: h,
      element: d,
      data: k
    }), Promise.resolve().then(function() {
      p === E.current && (g?.(e.current), e.current = []);
    }), t?.(h, d, k);
  }, [g, t]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: n
  }, i);
}
var MapShim = (function() {
  if (typeof Map < "u")
    return Map;
  function o(i, g) {
    var E = -1;
    return i.some(function(e, t) {
      return e[0] === g ? (E = t, !0) : !1;
    }), E;
  }
  return (
    /** @class */
    (function() {
      function i() {
        this.__entries__ = [];
      }
      return Object.defineProperty(i.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), i.prototype.get = function(g) {
        var E = o(this.__entries__, g), e = this.__entries__[E];
        return e && e[1];
      }, i.prototype.set = function(g, E) {
        var e = o(this.__entries__, g);
        ~e ? this.__entries__[e][1] = E : this.__entries__.push([g, E]);
      }, i.prototype.delete = function(g) {
        var E = this.__entries__, e = o(E, g);
        ~e && E.splice(e, 1);
      }, i.prototype.has = function(g) {
        return !!~o(this.__entries__, g);
      }, i.prototype.clear = function() {
        this.__entries__.splice(0);
      }, i.prototype.forEach = function(g, E) {
        E === void 0 && (E = null);
        for (var e = 0, t = this.__entries__; e < t.length; e++) {
          var n = t[e];
          g.call(E, n[1], n[0]);
        }
      }, i;
    })()
  );
})(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1 = (function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
})(), requestAnimationFrame$1 = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(o) {
    return setTimeout(function() {
      return o(Date.now());
    }, 1e3 / 60);
  };
})(), trailingTimeout = 2;
function throttle(o, i) {
  var g = !1, E = !1, e = 0;
  function t() {
    g && (g = !1, o()), E && h();
  }
  function n() {
    requestAnimationFrame$1(t);
  }
  function h() {
    var d = Date.now();
    if (g) {
      if (d - e < trailingTimeout)
        return;
      E = !0;
    } else
      g = !0, E = !1, setTimeout(n, i);
    e = d;
  }
  return h;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  (function() {
    function o() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    return o.prototype.addObserver = function(i) {
      ~this.observers_.indexOf(i) || this.observers_.push(i), this.connected_ || this.connect_();
    }, o.prototype.removeObserver = function(i) {
      var g = this.observers_, E = g.indexOf(i);
      ~E && g.splice(E, 1), !g.length && this.connected_ && this.disconnect_();
    }, o.prototype.refresh = function() {
      var i = this.updateObservers_();
      i && this.refresh();
    }, o.prototype.updateObservers_ = function() {
      var i = this.observers_.filter(function(g) {
        return g.gatherActive(), g.hasActive();
      });
      return i.forEach(function(g) {
        return g.broadcastActive();
      }), i.length > 0;
    }, o.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, o.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, o.prototype.onTransitionEnd_ = function(i) {
      var g = i.propertyName, E = g === void 0 ? "" : g, e = transitionKeys.some(function(t) {
        return !!~E.indexOf(t);
      });
      e && this.refresh();
    }, o.getInstance = function() {
      return this.instance_ || (this.instance_ = new o()), this.instance_;
    }, o.instance_ = null, o;
  })()
), defineConfigurable = (function(o, i) {
  for (var g = 0, E = Object.keys(i); g < E.length; g++) {
    var e = E[g];
    Object.defineProperty(o, e, {
      value: i[e],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return o;
}), getWindowOf = (function(o) {
  var i = o && o.ownerDocument && o.ownerDocument.defaultView;
  return i || global$1;
}), emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(o) {
  return parseFloat(o) || 0;
}
function getBordersSize(o) {
  for (var i = [], g = 1; g < arguments.length; g++)
    i[g - 1] = arguments[g];
  return i.reduce(function(E, e) {
    var t = o["border-" + e + "-width"];
    return E + toFloat(t);
  }, 0);
}
function getPaddings(o) {
  for (var i = ["top", "right", "bottom", "left"], g = {}, E = 0, e = i; E < e.length; E++) {
    var t = e[E], n = o["padding-" + t];
    g[t] = toFloat(n);
  }
  return g;
}
function getSVGContentRect(o) {
  var i = o.getBBox();
  return createRectInit(0, 0, i.width, i.height);
}
function getHTMLElementContentRect(o) {
  var i = o.clientWidth, g = o.clientHeight;
  if (!i && !g)
    return emptyRect;
  var E = getWindowOf(o).getComputedStyle(o), e = getPaddings(E), t = e.left + e.right, n = e.top + e.bottom, h = toFloat(E.width), d = toFloat(E.height);
  if (E.boxSizing === "border-box" && (Math.round(h + t) !== i && (h -= getBordersSize(E, "left", "right") + t), Math.round(d + n) !== g && (d -= getBordersSize(E, "top", "bottom") + n)), !isDocumentElement(o)) {
    var k = Math.round(h + t) - i, p = Math.round(d + n) - g;
    Math.abs(k) !== 1 && (h -= k), Math.abs(p) !== 1 && (d -= p);
  }
  return createRectInit(e.left, e.top, h, d);
}
var isSVGGraphicsElement = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement < "u" ? function(o) {
    return o instanceof getWindowOf(o).SVGGraphicsElement;
  } : function(o) {
    return o instanceof getWindowOf(o).SVGElement && typeof o.getBBox == "function";
  };
})();
function isDocumentElement(o) {
  return o === getWindowOf(o).document.documentElement;
}
function getContentRect(o) {
  return isBrowser ? isSVGGraphicsElement(o) ? getSVGContentRect(o) : getHTMLElementContentRect(o) : emptyRect;
}
function createReadOnlyRect(o) {
  var i = o.x, g = o.y, E = o.width, e = o.height, t = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, n = Object.create(t.prototype);
  return defineConfigurable(n, {
    x: i,
    y: g,
    width: E,
    height: e,
    top: g,
    right: i + E,
    bottom: e + g,
    left: i
  }), n;
}
function createRectInit(o, i, g, E) {
  return { x: o, y: i, width: g, height: E };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function o(i) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = i;
    }
    return o.prototype.isActive = function() {
      var i = getContentRect(this.target);
      return this.contentRect_ = i, i.width !== this.broadcastWidth || i.height !== this.broadcastHeight;
    }, o.prototype.broadcastRect = function() {
      var i = this.contentRect_;
      return this.broadcastWidth = i.width, this.broadcastHeight = i.height, i;
    }, o;
  })()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function o(i, g) {
      var E = createReadOnlyRect(g);
      defineConfigurable(this, { target: i, contentRect: E });
    }
    return o;
  })()
), ResizeObserverSPI = (
  /** @class */
  (function() {
    function o(i, g, E) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof i != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = i, this.controller_ = g, this.callbackCtx_ = E;
    }
    return o.prototype.observe = function(i) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(i instanceof getWindowOf(i).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var g = this.observations_;
        g.has(i) || (g.set(i, new ResizeObservation(i)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, o.prototype.unobserve = function(i) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(i instanceof getWindowOf(i).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var g = this.observations_;
        g.has(i) && (g.delete(i), g.size || this.controller_.removeObserver(this));
      }
    }, o.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, o.prototype.gatherActive = function() {
      var i = this;
      this.clearActive(), this.observations_.forEach(function(g) {
        g.isActive() && i.activeObservations_.push(g);
      });
    }, o.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var i = this.callbackCtx_, g = this.activeObservations_.map(function(E) {
          return new ResizeObserverEntry(E.target, E.broadcastRect());
        });
        this.callback_.call(i, g, i), this.clearActive();
      }
    }, o.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, o.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, o;
  })()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function o(i) {
      if (!(this instanceof o))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var g = ResizeObserverController.getInstance(), E = new ResizeObserverSPI(i, g, this);
      observers.set(this, E);
    }
    return o;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(o) {
  ResizeObserver$2.prototype[o] = function() {
    var i;
    return (i = observers.get(this))[o].apply(i, arguments);
  };
});
var index = (function() {
  return typeof global$1.ResizeObserver < "u" ? global$1.ResizeObserver : ResizeObserver$2;
})(), elementListeners = /* @__PURE__ */ new Map();
function onResize(o) {
  o.forEach(function(i) {
    var g, E = i.target;
    (g = elementListeners.get(E)) === null || g === void 0 || g.forEach(function(e) {
      return e(E);
    });
  });
}
var resizeObserver = new index(onResize);
process.env.NODE_ENV;
process.env.NODE_ENV;
function observe(o, i) {
  elementListeners.has(o) || (elementListeners.set(o, /* @__PURE__ */ new Set()), resizeObserver.observe(o)), elementListeners.get(o).add(i);
}
function unobserve(o, i) {
  elementListeners.has(o) && (elementListeners.get(o).delete(i), elementListeners.get(o).size || (resizeObserver.unobserve(o), elementListeners.delete(o)));
}
function _classCallCheck(o, i) {
  if (!(o instanceof i)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(o, i) {
  for (var g = 0; g < i.length; g++) {
    var E = i[g];
    E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(o, toPropertyKey(E.key), E);
  }
}
function _createClass(o, i, g) {
  return i && _defineProperties(o.prototype, i), Object.defineProperty(o, "prototype", {
    writable: !1
  }), o;
}
function _setPrototypeOf(o, i) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, E) {
    return g.__proto__ = E, g;
  }, _setPrototypeOf(o, i);
}
function _inherits(o, i) {
  if (typeof i != "function" && i !== null) throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(i && i.prototype, {
    constructor: {
      value: o,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(o, "prototype", {
    writable: !1
  }), i && _setPrototypeOf(o, i);
}
function _getPrototypeOf(o) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, _getPrototypeOf(o);
}
function _isNativeReflectConstruct() {
  try {
    var o = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!o;
  })();
}
function _assertThisInitialized(o) {
  if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _possibleConstructorReturn(o, i) {
  if (i && (_typeof(i) == "object" || typeof i == "function")) return i;
  if (i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(o);
}
function _createSuper(o) {
  var i = _isNativeReflectConstruct();
  return function() {
    var g, E = _getPrototypeOf(o);
    if (i) {
      var e = _getPrototypeOf(this).constructor;
      g = Reflect.construct(E, arguments, e);
    } else g = E.apply(this, arguments);
    return _possibleConstructorReturn(this, g);
  };
}
var DomWrapper = /* @__PURE__ */ (function(o) {
  _inherits(g, o);
  var i = _createSuper(g);
  function g() {
    return _classCallCheck(this, g), i.apply(this, arguments);
  }
  return _createClass(g, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), g;
})(React.Component);
function SingleObserver(o, i) {
  var g = o.children, E = o.disabled, e = React.useRef(null), t = React.useRef(null), n = React.useContext(CollectionContext), h = typeof g == "function", d = h ? g(e) : g, k = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), p = !h && /* @__PURE__ */ React.isValidElement(d) && supportRef(d), M = p ? getNodeRef(d) : null, H = useComposeRef(M, e), f = function() {
    var BA;
    return findDOMNode(e.current) || // Support `nativeElement` format
    (e.current && _typeof(e.current) === "object" ? findDOMNode((BA = e.current) === null || BA === void 0 ? void 0 : BA.nativeElement) : null) || findDOMNode(t.current);
  };
  React.useImperativeHandle(i, function() {
    return f();
  });
  var AA = React.useRef(o);
  AA.current = o;
  var gA = React.useCallback(function(IA) {
    var BA = AA.current, CA = BA.onResize, QA = BA.data, iA = IA.getBoundingClientRect(), EA = iA.width, oA = iA.height, eA = IA.offsetWidth, GA = IA.offsetHeight, cA = Math.floor(EA), tA = Math.floor(oA);
    if (k.current.width !== cA || k.current.height !== tA || k.current.offsetWidth !== eA || k.current.offsetHeight !== GA) {
      var aA = {
        width: cA,
        height: tA,
        offsetWidth: eA,
        offsetHeight: GA
      };
      k.current = aA;
      var sA = eA === Math.round(EA) ? EA : eA, DA = GA === Math.round(oA) ? oA : GA, rA = _objectSpread2(_objectSpread2({}, aA), {}, {
        offsetWidth: sA,
        offsetHeight: DA
      });
      n?.(rA, IA, QA), CA && Promise.resolve().then(function() {
        CA(rA, IA);
      });
    }
  }, []);
  return React.useEffect(function() {
    var IA = f();
    return IA && !E && observe(IA, gA), function() {
      return unobserve(IA, gA);
    };
  }, [e.current, E]), /* @__PURE__ */ React.createElement(DomWrapper, {
    ref: t
  }, p ? /* @__PURE__ */ React.cloneElement(d, {
    ref: H
  }) : d);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
process.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(o, i) {
  var g = o.children, E = typeof g == "function" ? [g] : toArray(g);
  return process.env.NODE_ENV !== "production" && (E.length > 1 ? warning(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : E.length === 0 && warning(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), E.map(function(e, t) {
    var n = e?.key || "".concat(INTERNAL_PREFIX_KEY, "-").concat(t);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends$1({}, o, {
      key: n,
      ref: t === 0 ? i : void 0
    }), e);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
process.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
function canUseDom() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom() ? React.useLayoutEffect : React.useEffect, useLayoutEffect = function o(i, g) {
  var E = React.useRef(!0);
  useInternalLayoutEffect(function() {
    return i(E.current);
  }, g), useInternalLayoutEffect(function() {
    return E.current = !1, function() {
      E.current = !0;
    };
  }, []);
}, _excluded$4 = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED = void 0;
function InternalItem(o, i) {
  var g = o.prefixCls, E = o.invalidate, e = o.item, t = o.renderItem, n = o.responsive, h = o.responsiveDisabled, d = o.registerSize, k = o.itemKey, p = o.className, M = o.style, H = o.children, f = o.display, AA = o.order, gA = o.component, IA = gA === void 0 ? "div" : gA, BA = _objectWithoutProperties$2(o, _excluded$4), CA = n && !f;
  function QA(GA) {
    d(k, GA);
  }
  React.useEffect(function() {
    return function() {
      QA(null);
    };
  }, []);
  var iA = t && e !== UNDEFINED ? t(e, {
    index: AA
  }) : H, EA;
  E || (EA = {
    opacity: CA ? 0 : 1,
    height: CA ? 0 : UNDEFINED,
    overflowY: CA ? "hidden" : UNDEFINED,
    order: n ? AA : UNDEFINED,
    pointerEvents: CA ? "none" : UNDEFINED,
    position: CA ? "absolute" : UNDEFINED
  });
  var oA = {};
  CA && (oA["aria-hidden"] = !0);
  var eA = /* @__PURE__ */ React.createElement(IA, _extends$2({
    className: classNames(!E && g, p),
    style: _objectSpread2$1(_objectSpread2$1({}, EA), M)
  }, oA, BA, {
    ref: i
  }), iA);
  return n && (eA = /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(cA) {
      var tA = cA.offsetWidth;
      QA(tA);
    },
    disabled: h
  }, eA)), eA;
}
var Item = /* @__PURE__ */ React.forwardRef(InternalItem);
Item.displayName = "Item";
function useEvent(o) {
  var i = React.useRef();
  i.current = o;
  var g = React.useCallback(function() {
    for (var E, e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return (E = i.current) === null || E === void 0 ? void 0 : E.call.apply(E, [i].concat(t));
  }, []);
  return g;
}
var raf = function o(i) {
  return +setTimeout(i, 16);
}, caf = function o(i) {
  return clearTimeout(i);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf = function(i) {
  return window.requestAnimationFrame(i);
}, caf = function(i) {
  return window.cancelAnimationFrame(i);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(o) {
  rafIds.delete(o);
}
var wrapperRaf = function o(i) {
  var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var E = rafUUID;
  function e(t) {
    if (t === 0)
      cleanup(E), i();
    else {
      var n = raf(function() {
        e(t - 1);
      });
      rafIds.set(E, n);
    }
  }
  return e(g), E;
};
wrapperRaf.cancel = function(o) {
  var i = rafIds.get(o);
  return cleanup(o), caf(i);
};
process.env.NODE_ENV !== "production" && (wrapperRaf.ids = function() {
  return rafIds;
});
function channelUpdate(o) {
  if (typeof MessageChannel > "u")
    wrapperRaf(o);
  else {
    var i = new MessageChannel();
    i.port1.onmessage = function() {
      return o();
    }, i.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var o = React.useRef(null), i = function(E) {
    o.current || (o.current = [], channelUpdate(function() {
      unstable_batchedUpdates(function() {
        o.current.forEach(function(e) {
          e();
        }), o.current = null;
      });
    })), o.current.push(E);
  };
  return i;
}
function useEffectState(o, i) {
  var g = React.useState(i), E = _slicedToArray$1(g, 2), e = E[0], t = E[1], n = useEvent(function(h) {
    o(function() {
      t(h);
    });
  });
  return [e, n];
}
var OverflowContext = /* @__PURE__ */ React__default.createContext(null), _excluded$3 = ["component"], _excluded2$1 = ["className"], _excluded3 = ["className"], InternalRawItem = function o(i, g) {
  var E = React.useContext(OverflowContext);
  if (!E) {
    var e = i.component, t = e === void 0 ? "div" : e, n = _objectWithoutProperties$2(i, _excluded$3);
    return /* @__PURE__ */ React.createElement(t, _extends$2({}, n, {
      ref: g
    }));
  }
  var h = E.className, d = _objectWithoutProperties$2(E, _excluded2$1), k = i.className, p = _objectWithoutProperties$2(i, _excluded3);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item, _extends$2({
    ref: g,
    className: classNames(h, k)
  }, d, p)));
}, RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$2 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "prefix", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(o) {
  return "+ ".concat(o.length, " ...");
}
function Overflow(o, i) {
  var g = o.prefixCls, E = g === void 0 ? "rc-overflow" : g, e = o.data, t = e === void 0 ? [] : e, n = o.renderItem, h = o.renderRawItem, d = o.itemKey, k = o.itemWidth, p = k === void 0 ? 10 : k, M = o.ssr, H = o.style, f = o.className, AA = o.maxCount, gA = o.renderRest, IA = o.renderRawRest, BA = o.prefix, CA = o.suffix, QA = o.component, iA = QA === void 0 ? "div" : QA, EA = o.itemComponent, oA = o.onVisibleChange, eA = _objectWithoutProperties$2(o, _excluded$2), GA = M === "full", cA = useBatcher(), tA = useEffectState(cA, null), aA = _slicedToArray$1(tA, 2), sA = aA[0], DA = aA[1], rA = sA || 0, nA = useEffectState(cA, /* @__PURE__ */ new Map()), NA = _slicedToArray$1(nA, 2), pA = NA[0], mA = NA[1], XA = useEffectState(cA, 0), lA = _slicedToArray$1(XA, 2), kA = lA[0], ZA = lA[1], wA = useEffectState(cA, 0), LA = _slicedToArray$1(wA, 2), fA = LA[0], dA = LA[1], RA = useEffectState(cA, 0), KA = _slicedToArray$1(RA, 2), xA = KA[0], MA = KA[1], OA = useEffectState(cA, 0), SA = _slicedToArray$1(OA, 2), gg = SA[0], WA = SA[1], eg = useState(null), ig = _slicedToArray$1(eg, 2), $A = ig[0], ag = ig[1], Ig = useState(null), tg = _slicedToArray$1(Ig, 2), wg = tg[0], hg = tg[1], Gg = React.useMemo(function() {
    return wg === null && GA ? Number.MAX_SAFE_INTEGER : wg || 0;
  }, [wg, sA]), Ng = useState(!1), Bg = _slicedToArray$1(Ng, 2), bA = Bg[0], HA = Bg[1], vA = "".concat(E, "-item"), zA = Math.max(kA, fA), PA = AA === RESPONSIVE, qA = t.length && PA, _A = AA === INVALIDATE, VA = qA || typeof AA == "number" && t.length > AA, yA = useMemo$1(function() {
    var Cg = t;
    return qA ? sA === null && GA ? Cg = t : Cg = t.slice(0, Math.min(t.length, rA / p)) : typeof AA == "number" && (Cg = t.slice(0, AA)), Cg;
  }, [t, p, sA, AA, qA]), FA = useMemo$1(function() {
    return qA ? t.slice(Gg + 1) : t.slice(yA.length);
  }, [t, yA, qA, Gg]), uA = useCallback(function(Cg, cg) {
    var yg;
    return typeof d == "function" ? d(Cg) : (yg = d && Cg?.[d]) !== null && yg !== void 0 ? yg : cg;
  }, [d]), JA = useCallback(n || function(Cg) {
    return Cg;
  }, [n]);
  function YA(Cg, cg, yg) {
    wg === Cg && (cg === void 0 || cg === $A) || (hg(Cg), yg || (HA(Cg < t.length - 1), oA?.(Cg)), cg !== void 0 && ag(cg));
  }
  function TA(Cg, cg) {
    DA(cg.clientWidth);
  }
  function Qg(Cg, cg) {
    mA(function(yg) {
      var kg = new Map(yg);
      return cg === null ? kg.delete(Cg) : kg.set(Cg, cg), kg;
    });
  }
  function sg(Cg, cg) {
    dA(cg), ZA(fA);
  }
  function ng(Cg, cg) {
    MA(cg);
  }
  function Yg(Cg, cg) {
    WA(cg);
  }
  function Lg(Cg) {
    return pA.get(uA(yA[Cg], Cg));
  }
  useLayoutEffect(function() {
    if (rA && typeof zA == "number" && yA) {
      var Cg = xA + gg, cg = yA.length, yg = cg - 1;
      if (!cg) {
        YA(0, null);
        return;
      }
      for (var kg = 0; kg < cg; kg += 1) {
        var hA = Lg(kg);
        if (GA && (hA = hA || 0), hA === void 0) {
          YA(kg - 1, void 0, !0);
          break;
        }
        if (Cg += hA, // Only one means `totalWidth` is the final width
        yg === 0 && Cg <= rA || // Last two width will be the final width
        kg === yg - 1 && Cg + Lg(yg) <= rA) {
          YA(yg, null);
          break;
        } else if (Cg + zA > rA) {
          YA(kg - 1, Cg - hA - gg + fA);
          break;
        }
      }
      CA && Lg(0) + gg > rA && ag(null);
    }
  }, [rA, pA, fA, xA, gg, uA, yA]);
  var pg = bA && !!FA.length, II = {};
  $A !== null && qA && (II = {
    position: "absolute",
    left: $A,
    top: 0
  });
  var Jg = {
    prefixCls: vA,
    responsive: qA,
    component: EA,
    invalidate: _A
  }, CI = h ? function(Cg, cg) {
    var yg = uA(Cg, cg);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: yg,
      value: _objectSpread2$1(_objectSpread2$1({}, Jg), {}, {
        order: cg,
        item: Cg,
        itemKey: yg,
        registerSize: Qg,
        display: cg <= Gg
      })
    }, h(Cg, cg));
  } : function(Cg, cg) {
    var yg = uA(Cg, cg);
    return /* @__PURE__ */ React.createElement(Item, _extends$2({}, Jg, {
      order: cg,
      key: yg,
      item: Cg,
      renderItem: JA,
      itemKey: yg,
      registerSize: Qg,
      display: cg <= Gg
    }));
  }, BI = {
    order: pg ? Gg : Number.MAX_SAFE_INTEGER,
    className: "".concat(vA, "-rest"),
    registerSize: sg,
    display: pg
  }, qg = gA || defaultRenderRest, QI = IA ? /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, Jg), BI)
  }, IA(FA)) : /* @__PURE__ */ React.createElement(Item, _extends$2({}, Jg, BI), typeof qg == "function" ? qg(FA) : qg), vg = /* @__PURE__ */ React.createElement(iA, _extends$2({
    className: classNames(!_A && E, f),
    style: H,
    ref: i
  }, eA), BA && /* @__PURE__ */ React.createElement(Item, _extends$2({}, Jg, {
    responsive: PA,
    responsiveDisabled: !qA,
    order: -1,
    className: "".concat(vA, "-prefix"),
    registerSize: ng,
    display: !0
  }), BA), yA.map(CI), VA ? QI : null, CA && /* @__PURE__ */ React.createElement(Item, _extends$2({}, Jg, {
    responsive: PA,
    responsiveDisabled: !qA,
    order: Gg,
    className: "".concat(vA, "-suffix"),
    registerSize: Yg,
    display: !0,
    style: II
  }), CA));
  return PA ? /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: TA,
    disabled: !qA
  }, vg) : vg;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
function _objectWithoutProperties$1(o, i) {
  if (o == null) return {};
  var g, E, e = _objectWithoutPropertiesLoose$q(o, i);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (E = 0; E < t.length; E++) g = t[E], i.indexOf(g) === -1 && {}.propertyIsEnumerable.call(o, g) && (e[g] = o[g]);
  }
  return e;
}
var _excluded$1 = ["children", "iconAttrs", "iconVerticalAlign", "iconViewBox", "size", "title"];
function ownKeys$1(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread$1(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(g), !0).forEach(function(E) {
      _defineProperty$u(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys$1(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
var EmotionIconBaseBase = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = o.children, E = o.iconAttrs;
  o.iconVerticalAlign;
  var e = o.iconViewBox, t = o.size, n = o.title, h = _objectWithoutProperties$1(o, _excluded$1), d = _objectSpread$1(_objectSpread$1({
    viewBox: e,
    height: o.height !== void 0 ? o.height : t,
    width: o.width !== void 0 ? o.width : t,
    "aria-hidden": n == null ? "true" : void 0,
    focusable: "false",
    role: n != null ? "img" : void 0
  }, E), h);
  return /* @__PURE__ */ React.createElement("svg", _extends$C({}, d, {
    ref: i
  }), n && /* @__PURE__ */ React.createElement("title", {
    key: "icon-title"
  }, n), g);
}), EmotionIconBase = /* @__PURE__ */ createStyled(EmotionIconBaseBase, process.env.NODE_ENV === "production" ? {
  target: "ex0cdmw0"
} : {
  target: "ex0cdmw0",
  label: "EmotionIconBase"
})("display:inline-block;vertical-align:", function(o) {
  return o.iconVerticalAlign;
}, ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), AccessibilityNew = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  }));
});
AccessibilityNew.displayName = "AccessibilityNew";
var AccessibleForward = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: 18,
    cy: 4.54,
    r: 2
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v5h2v-5.5c0-1.1-.9-2-2-2z"
  }));
});
AccessibleForward.displayName = "AccessibleForward";
var DirectionsBike = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
  }));
});
DirectionsBike.displayName = "DirectionsBike";
var DirectionsRun = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
  }));
});
DirectionsRun.displayName = "DirectionsRun";
var KeyboardArrowDown = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  }));
});
KeyboardArrowDown.displayName = "KeyboardArrowDown";
var KeyboardArrowUp = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
  }));
});
KeyboardArrowUp.displayName = "KeyboardArrowUp";
var Pool = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: 16.5,
    cy: 5.5,
    r: 2.5
  }));
});
Pool.displayName = "Pool";
var Rowing = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
  }));
});
Rowing.displayName = "Rowing";
const TopNavSection = ({
  title: o,
  sections: i,
  handlePageChange: g,
  endpoints: E,
  pageLinkBaseUrl: e,
  currentPageScriptHash: t,
  hideChevron: n = !1,
  widgetsDisabled: h
}) => {
  const [d, k] = useState(!1), p = useEmotionTheme(), M = i.length > 1;
  return isNullOrUndefined(i) || i.length === 0 || i[0].length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover$2,
    {
      triggerType: TRIGGER_TYPE.click,
      placement: PLACEMENT$1.bottomLeft,
      content: () => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPopoverContent, { "data-testid": "stTopNavPopover", children: i.map((H, f) => {
        const AA = H[0].sectionHeader;
        return H.map((gA, IA) => {
          const BA = (QA) => (QA.preventDefault(), gA.pageScriptHash && g(gA.pageScriptHash), k(!1), !1), CA = String(gA.pageName || "");
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
            IA === 0 && M && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSectionName, { children: AA }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTopNavSidebarNavLinkContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { ...gA, icon: gA.icon || null, isTopNav: !0, isInDropdown: !0, isActive: t === gA.pageScriptHash, onClick: BA, pageUrl: E.buildAppPageURL(e, gA), widgetsDisabled: h, children: CA }) })
          ] }, `${gA.pageScriptHash}-${CA}`);
        });
      }) }),
      isOpen: d,
      onClickOutside: () => k(!1),
      onClick: () => d ? k(!1) : void 0,
      onEsc: () => k(!1),
      renderAll: !0,
      overrides: {
        Body: {
          style: () => ({
            marginTop: p.spacing.sm,
            marginRight: p.spacing.lg,
            marginBottom: p.spacing.lg,
            maxHeight: "70vh",
            minWidth: "8rem",
            overflow: "auto",
            maxWidth: `calc(${p.sizes.contentMaxWidth} - 2*${p.spacing.lg})`,
            borderTopLeftRadius: p.radii.xl,
            borderTopRightRadius: p.radii.xl,
            borderBottomRightRadius: p.radii.xl,
            borderBottomLeftRadius: p.radii.xl,
            borderLeftWidth: p.sizes.borderWidth,
            borderRightWidth: p.sizes.borderWidth,
            borderTopWidth: p.sizes.borderWidth,
            borderBottomWidth: p.sizes.borderWidth,
            borderLeftStyle: "solid",
            borderRightStyle: "solid",
            borderTopStyle: "solid",
            borderBottomStyle: "solid",
            borderLeftColor: p.colors.borderColor,
            borderRightColor: p.colors.borderColor,
            borderTopColor: p.colors.borderColor,
            borderBottomColor: p.colors.borderColor,
            boxShadow: p.shadows.popover,
            [`@media (max-width: ${p.breakpoints.sm})`]: {
              maxWidth: `calc(100% - ${p.spacing.threeXL})`
            }
          })
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledNavSection, { tabIndex: 0, onClick: () => k(!d), isOpen: d, "data-testid": "stTopNavSection", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNavSectionText, { children: o }),
        !n && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIconContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: d ? KeyboardArrowUp : KeyboardArrowDown, size: "lg" }) })
      ] }) })
    }
  );
}, TopNav = ({
  endpoints: o,
  widgetsDisabled: i
}) => {
  const {
    pageLinkBaseUrl: g,
    currentPageScriptHash: E,
    appPages: e,
    onPageChange: t
  } = useContext(NavigationContext), {
    data: n,
    itemKey: h
  } = useMemo$1(() => {
    const p = groupPagesBySection(e), M = processNavigationStructure(p);
    return {
      data: [...M.individualPages, ...Object.entries(M.sections).map(([AA, gA]) => gA)],
      itemKey: (AA) => Array.isArray(AA) ? AA[0]?.sectionHeader ?? "" : AA.pageScriptHash ?? ""
    };
  }, [e]), d = useCallback((p, M) => Array.isArray(p) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TopNavSection, { sections: [p], title: p[0].sectionHeader || "", handlePageChange: t, endpoints: o, pageLinkBaseUrl: g, currentPageScriptHash: E, widgetsDisabled: i }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTopNavLinkContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { isTopNav: !0, isInDropdown: !1, isActive: E === p.pageScriptHash, icon: p.icon, pageUrl: o.buildAppPageURL(g, p), onClick: (H) => {
    H.preventDefault(), p.pageScriptHash && t(p.pageScriptHash);
  }, widgetsDisabled: i, children: String(p.pageName) }) }), [t, o, g, E, i]), k = useCallback((p) => {
    if (isNullOrUndefined(p))
      return null;
    const H = `${p.flat().length} more`, f = p.map((AA) => Array.isArray(AA) ? AA : [AA]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TopNavSection, { hideChevron: !0, sections: f, title: H, handlePageChange: t, endpoints: o, pageLinkBaseUrl: g, currentPageScriptHash: E, widgetsDisabled: i });
  }, [t, o, g, E, i]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ForwardOverflow, { component: StyledOverflowContainer, itemKey: h, data: n, maxCount: "responsive", renderItem: d, renderRest: k });
};
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(o) {
    for (var i, g = 1, E = arguments.length; g < E; g++) {
      i = arguments[g];
      for (var e in i) Object.prototype.hasOwnProperty.call(i, e) && (o[e] = i[e]);
    }
    return o;
  }, __assign$1.apply(this, arguments);
}, rowSizeBase = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, colSizeBase = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, edgeBase = {
  width: "20px",
  height: "20px",
  position: "absolute",
  zIndex: 1
}, styles = {
  top: __assign$1(__assign$1({}, rowSizeBase), { top: "-5px" }),
  right: __assign$1(__assign$1({}, colSizeBase), { left: void 0, right: "-5px" }),
  bottom: __assign$1(__assign$1({}, rowSizeBase), { top: void 0, bottom: "-5px" }),
  left: __assign$1(__assign$1({}, colSizeBase), { left: "-5px" }),
  topRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, Resizer = memo(function(o) {
  var i = o.onResizeStart, g = o.direction, E = o.children, e = o.replaceStyles, t = o.className, n = useCallback(function(k) {
    i(k, g);
  }, [i, g]), h = useCallback(function(k) {
    i(k, g);
  }, [i, g]), d = useMemo$1(function() {
    return __assign$1(__assign$1({ position: "absolute", userSelect: "none" }, styles[g]), e ?? {});
  }, [e, g]);
  return jsxRuntimeExports.jsx("div", { className: t || void 0, style: d, onMouseDown: n, onTouchStart: h, children: E });
}), __extends = /* @__PURE__ */ (function() {
  var o = function(i, g) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, e) {
      E.__proto__ = e;
    } || function(E, e) {
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && (E[t] = e[t]);
    }, o(i, g);
  };
  return function(i, g) {
    if (typeof g != "function" && g !== null)
      throw new TypeError("Class extends value " + String(g) + " is not a constructor or null");
    o(i, g);
    function E() {
      this.constructor = i;
    }
    i.prototype = g === null ? Object.create(g) : (E.prototype = g.prototype, new E());
  };
})(), __assign = function() {
  return __assign = Object.assign || function(o) {
    for (var i, g = 1, E = arguments.length; g < E; g++) {
      i = arguments[g];
      for (var e in i) Object.prototype.hasOwnProperty.call(i, e) && (o[e] = i[e]);
    }
    return o;
  }, __assign.apply(this, arguments);
}, DEFAULT_SIZE = {
  width: "auto",
  height: "auto"
}, clamp = function(o, i, g) {
  return Math.max(Math.min(o, g), i);
}, snap = function(o, i, g) {
  var E = Math.round(o / i);
  return E * i + g * (E - 1);
}, hasDirection = function(o, i) {
  return new RegExp(o, "i").test(i);
}, isTouchEvent = function(o) {
  return !!(o.touches && o.touches.length);
}, isMouseEvent = function(o) {
  return !!((o.clientX || o.clientX === 0) && (o.clientY || o.clientY === 0));
}, findClosestSnap = function(o, i, g) {
  g === void 0 && (g = 0);
  var E = i.reduce(function(t, n, h) {
    return Math.abs(n - o) < Math.abs(i[t] - o) ? h : t;
  }, 0), e = Math.abs(i[E] - o);
  return g === 0 || e < g ? i[E] : o;
}, getStringSize = function(o) {
  return o = o.toString(), o === "auto" || o.endsWith("px") || o.endsWith("%") || o.endsWith("vh") || o.endsWith("vw") || o.endsWith("vmax") || o.endsWith("vmin") ? o : "".concat(o, "px");
}, getPixelSize = function(o, i, g, E) {
  if (o && typeof o == "string") {
    if (o.endsWith("px"))
      return Number(o.replace("px", ""));
    if (o.endsWith("%")) {
      var e = Number(o.replace("%", "")) / 100;
      return i * e;
    }
    if (o.endsWith("vw")) {
      var e = Number(o.replace("vw", "")) / 100;
      return g * e;
    }
    if (o.endsWith("vh")) {
      var e = Number(o.replace("vh", "")) / 100;
      return E * e;
    }
  }
  return o;
}, calculateNewMax = function(o, i, g, E, e, t, n) {
  return E = getPixelSize(E, o.width, i, g), e = getPixelSize(e, o.height, i, g), t = getPixelSize(t, o.width, i, g), n = getPixelSize(n, o.height, i, g), {
    maxWidth: typeof E > "u" ? void 0 : Number(E),
    maxHeight: typeof e > "u" ? void 0 : Number(e),
    minWidth: typeof t > "u" ? void 0 : Number(t),
    minHeight: typeof n > "u" ? void 0 : Number(n)
  };
}, normalizeToPair = function(o) {
  return Array.isArray(o) ? o : [o, o];
}, definedProps = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], baseClassName = "__resizable_base__", Resizable = (
  /** @class */
  (function(o) {
    __extends(i, o);
    function i(g) {
      var E, e, t, n, h = o.call(this, g) || this;
      return h.ratio = 1, h.resizable = null, h.parentLeft = 0, h.parentTop = 0, h.resizableLeft = 0, h.resizableRight = 0, h.resizableTop = 0, h.resizableBottom = 0, h.targetLeft = 0, h.targetTop = 0, h.delta = {
        width: 0,
        height: 0
      }, h.appendBase = function() {
        if (!h.resizable || !h.window)
          return null;
        var d = h.parentNode;
        if (!d)
          return null;
        var k = h.window.document.createElement("div");
        return k.style.width = "100%", k.style.height = "100%", k.style.position = "absolute", k.style.transform = "scale(0, 0)", k.style.left = "0", k.style.flex = "0 0 100%", k.classList ? k.classList.add(baseClassName) : k.className += baseClassName, d.appendChild(k), k;
      }, h.removeBase = function(d) {
        var k = h.parentNode;
        k && k.removeChild(d);
      }, h.state = {
        isResizing: !1,
        width: (e = (E = h.propsSize) === null || E === void 0 ? void 0 : E.width) !== null && e !== void 0 ? e : "auto",
        height: (n = (t = h.propsSize) === null || t === void 0 ? void 0 : t.height) !== null && n !== void 0 ? n : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, h.onResizeStart = h.onResizeStart.bind(h), h.onMouseMove = h.onMouseMove.bind(h), h.onMouseUp = h.onMouseUp.bind(h), h;
    }
    return Object.defineProperty(i.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(i.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(i.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(i.prototype, "size", {
      get: function() {
        var g = 0, E = 0;
        if (this.resizable && this.window) {
          var e = this.resizable.offsetWidth, t = this.resizable.offsetHeight, n = this.resizable.style.position;
          n !== "relative" && (this.resizable.style.position = "relative"), g = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : e, E = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : t, this.resizable.style.position = n;
        }
        return { width: g, height: E };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(i.prototype, "sizeStyle", {
      get: function() {
        var g = this, E = this.props.size, e = function(h) {
          var d;
          if (typeof g.state[h] > "u" || g.state[h] === "auto")
            return "auto";
          if (g.propsSize && g.propsSize[h] && (!((d = g.propsSize[h]) === null || d === void 0) && d.toString().endsWith("%"))) {
            if (g.state[h].toString().endsWith("%"))
              return g.state[h].toString();
            var k = g.getParentSize(), p = Number(g.state[h].toString().replace("px", "")), M = p / k[h] * 100;
            return "".concat(M, "%");
          }
          return getStringSize(g.state[h]);
        }, t = E && typeof E.width < "u" && !this.state.isResizing ? getStringSize(E.width) : e("width"), n = E && typeof E.height < "u" && !this.state.isResizing ? getStringSize(E.height) : e("height");
        return { width: t, height: n };
      },
      enumerable: !1,
      configurable: !0
    }), i.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var g = this.appendBase();
      if (!g)
        return { width: 0, height: 0 };
      var E = !1, e = this.parentNode.style.flexWrap;
      e !== "wrap" && (E = !0, this.parentNode.style.flexWrap = "wrap"), g.style.position = "relative", g.style.minWidth = "100%", g.style.minHeight = "100%";
      var t = {
        width: g.offsetWidth,
        height: g.offsetHeight
      };
      return E && (this.parentNode.style.flexWrap = e), this.removeBase(g), t;
    }, i.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, i.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, i.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var g = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: g.flexBasis !== "auto" ? g.flexBasis : void 0
        });
      }
    }, i.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, i.prototype.createSizeForCssProperty = function(g, E) {
      var e = this.propsSize && this.propsSize[E];
      return this.state[E] === "auto" && this.state.original[E] === g && (typeof e > "u" || e === "auto") ? "auto" : g;
    }, i.prototype.calculateNewMaxFromBoundary = function(g, E) {
      var e = this.props.boundsByDirection, t = this.state.direction, n = e && hasDirection("left", t), h = e && hasDirection("top", t), d, k;
      if (this.props.bounds === "parent") {
        var p = this.parentNode;
        p && (d = n ? this.resizableRight - this.parentLeft : p.offsetWidth + (this.parentLeft - this.resizableLeft), k = h ? this.resizableBottom - this.parentTop : p.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (d = n ? this.resizableRight : this.window.innerWidth - this.resizableLeft, k = h ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (d = n ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), k = h ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return d && Number.isFinite(d) && (g = g && g < d ? g : d), k && Number.isFinite(k) && (E = E && E < k ? E : k), { maxWidth: g, maxHeight: E };
    }, i.prototype.calculateNewSizeFromDirection = function(g, E) {
      var e = this.props.scale || 1, t = normalizeToPair(this.props.resizeRatio || 1), n = t[0], h = t[1], d = this.state, k = d.direction, p = d.original, M = this.props, H = M.lockAspectRatio, f = M.lockAspectRatioExtraHeight, AA = M.lockAspectRatioExtraWidth, gA = p.width, IA = p.height, BA = f || 0, CA = AA || 0;
      return hasDirection("right", k) && (gA = p.width + (g - p.x) * n / e, H && (IA = (gA - CA) / this.ratio + BA)), hasDirection("left", k) && (gA = p.width - (g - p.x) * n / e, H && (IA = (gA - CA) / this.ratio + BA)), hasDirection("bottom", k) && (IA = p.height + (E - p.y) * h / e, H && (gA = (IA - BA) * this.ratio + CA)), hasDirection("top", k) && (IA = p.height - (E - p.y) * h / e, H && (gA = (IA - BA) * this.ratio + CA)), { newWidth: gA, newHeight: IA };
    }, i.prototype.calculateNewSizeFromAspectRatio = function(g, E, e, t) {
      var n = this.props, h = n.lockAspectRatio, d = n.lockAspectRatioExtraHeight, k = n.lockAspectRatioExtraWidth, p = typeof t.width > "u" ? 10 : t.width, M = typeof e.width > "u" || e.width < 0 ? g : e.width, H = typeof t.height > "u" ? 10 : t.height, f = typeof e.height > "u" || e.height < 0 ? E : e.height, AA = d || 0, gA = k || 0;
      if (h) {
        var IA = (H - AA) * this.ratio + gA, BA = (f - AA) * this.ratio + gA, CA = (p - gA) / this.ratio + AA, QA = (M - gA) / this.ratio + AA, iA = Math.max(p, IA), EA = Math.min(M, BA), oA = Math.max(H, CA), eA = Math.min(f, QA);
        g = clamp(g, iA, EA), E = clamp(E, oA, eA);
      } else
        g = clamp(g, p, M), E = clamp(E, H, f);
      return { newWidth: g, newHeight: E };
    }, i.prototype.setBoundingClientRect = function() {
      var g = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var E = this.parentNode;
        if (E) {
          var e = E.getBoundingClientRect();
          this.parentLeft = e.left * g, this.parentTop = e.top * g;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var t = this.props.bounds.getBoundingClientRect();
        this.targetLeft = t.left * g, this.targetTop = t.top * g;
      }
      if (this.resizable) {
        var n = this.resizable.getBoundingClientRect(), h = n.left, d = n.top, k = n.right, p = n.bottom;
        this.resizableLeft = h * g, this.resizableRight = k * g, this.resizableTop = d * g, this.resizableBottom = p * g;
      }
    }, i.prototype.onResizeStart = function(g, E) {
      if (!(!this.resizable || !this.window)) {
        var e = 0, t = 0;
        if (g.nativeEvent && isMouseEvent(g.nativeEvent) ? (e = g.nativeEvent.clientX, t = g.nativeEvent.clientY) : g.nativeEvent && isTouchEvent(g.nativeEvent) && (e = g.nativeEvent.touches[0].clientX, t = g.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var n = this.props.onResizeStart(g, E, this.resizable);
          if (n === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var h, d = this.window.getComputedStyle(this.resizable);
        if (d.flexBasis !== "auto") {
          var k = this.parentNode;
          if (k) {
            var p = this.window.getComputedStyle(k).flexDirection;
            this.flexDir = p.startsWith("row") ? "row" : "column", h = d.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var M = {
          original: {
            x: e,
            y: t,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(g.target).cursor || "auto" }),
          direction: E,
          flexBasis: h
        };
        this.setState(M);
      }
    }, i.prototype.onMouseMove = function(g) {
      var E = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && isTouchEvent(g))
          try {
            g.preventDefault(), g.stopPropagation();
          } catch {
          }
        var e = this.props, t = e.maxWidth, n = e.maxHeight, h = e.minWidth, d = e.minHeight, k = isTouchEvent(g) ? g.touches[0].clientX : g.clientX, p = isTouchEvent(g) ? g.touches[0].clientY : g.clientY, M = this.state, H = M.direction, f = M.original, AA = M.width, gA = M.height, IA = this.getParentSize(), BA = calculateNewMax(IA, this.window.innerWidth, this.window.innerHeight, t, n, h, d);
        t = BA.maxWidth, n = BA.maxHeight, h = BA.minWidth, d = BA.minHeight;
        var CA = this.calculateNewSizeFromDirection(k, p), QA = CA.newHeight, iA = CA.newWidth, EA = this.calculateNewMaxFromBoundary(t, n);
        this.props.snap && this.props.snap.x && (iA = findClosestSnap(iA, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (QA = findClosestSnap(QA, this.props.snap.y, this.props.snapGap));
        var oA = this.calculateNewSizeFromAspectRatio(iA, QA, { width: EA.maxWidth, height: EA.maxHeight }, { width: h, height: d });
        if (iA = oA.newWidth, QA = oA.newHeight, this.props.grid) {
          var eA = snap(iA, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), GA = snap(QA, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), cA = this.props.snapGap || 0, tA = cA === 0 || Math.abs(eA - iA) <= cA ? eA : iA, aA = cA === 0 || Math.abs(GA - QA) <= cA ? GA : QA;
          iA = tA, QA = aA;
        }
        var sA = {
          width: iA - f.width,
          height: QA - f.height
        };
        if (this.delta = sA, AA && typeof AA == "string") {
          if (AA.endsWith("%")) {
            var DA = iA / IA.width * 100;
            iA = "".concat(DA, "%");
          } else if (AA.endsWith("vw")) {
            var rA = iA / this.window.innerWidth * 100;
            iA = "".concat(rA, "vw");
          } else if (AA.endsWith("vh")) {
            var nA = iA / this.window.innerHeight * 100;
            iA = "".concat(nA, "vh");
          }
        }
        if (gA && typeof gA == "string") {
          if (gA.endsWith("%")) {
            var DA = QA / IA.height * 100;
            QA = "".concat(DA, "%");
          } else if (gA.endsWith("vw")) {
            var rA = QA / this.window.innerWidth * 100;
            QA = "".concat(rA, "vw");
          } else if (gA.endsWith("vh")) {
            var nA = QA / this.window.innerHeight * 100;
            QA = "".concat(nA, "vh");
          }
        }
        var NA = {
          width: this.createSizeForCssProperty(iA, "width"),
          height: this.createSizeForCssProperty(QA, "height")
        };
        this.flexDir === "row" ? NA.flexBasis = NA.width : this.flexDir === "column" && (NA.flexBasis = NA.height);
        var pA = this.state.width !== NA.width, mA = this.state.height !== NA.height, XA = this.state.flexBasis !== NA.flexBasis, lA = pA || mA || XA;
        lA && flushSync(function() {
          E.setState(NA);
        }), this.props.onResize && lA && this.props.onResize(g, H, this.resizable, sA);
      }
    }, i.prototype.onMouseUp = function(g) {
      var E, e, t = this.state, n = t.isResizing, h = t.direction;
      t.original, !(!n || !this.resizable) && (this.props.onResizeStop && this.props.onResizeStop(g, h, this.resizable, this.delta), this.props.size && this.setState({ width: (E = this.props.size.width) !== null && E !== void 0 ? E : "auto", height: (e = this.props.size.height) !== null && e !== void 0 ? e : "auto" }), this.unbindEvents(), this.setState({
        isResizing: !1,
        backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: "auto" })
      }));
    }, i.prototype.updateSize = function(g) {
      var E, e;
      this.setState({ width: (E = g.width) !== null && E !== void 0 ? E : "auto", height: (e = g.height) !== null && e !== void 0 ? e : "auto" });
    }, i.prototype.renderResizer = function() {
      var g = this, E = this.props, e = E.enable, t = E.handleStyles, n = E.handleClasses, h = E.handleWrapperStyle, d = E.handleWrapperClass, k = E.handleComponent;
      if (!e)
        return null;
      var p = Object.keys(e).map(function(M) {
        return e[M] !== !1 ? jsxRuntimeExports.jsx(Resizer, { direction: M, onResizeStart: g.onResizeStart, replaceStyles: t && t[M], className: n && n[M], children: k && k[M] ? k[M] : null }, M) : null;
      });
      return jsxRuntimeExports.jsx("div", { className: d, style: h, children: p });
    }, i.prototype.render = function() {
      var g = this, E = Object.keys(this.props).reduce(function(n, h) {
        return definedProps.indexOf(h) !== -1 || (n[h] = g.props[h]), n;
      }, {}), e = __assign(__assign(__assign({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (e.flexBasis = this.state.flexBasis);
      var t = this.props.as || "div";
      return jsxRuntimeExports.jsxs(t, __assign({ style: e, className: this.props.className }, E, {
        // `ref` is after `extendsProps` to ensure this one wins over a version
        // passed in
        ref: function(n) {
          n && (g.resizable = n);
        },
        children: [this.state.isResizing && jsxRuntimeExports.jsx("div", { style: this.state.backgroundStyle }), this.props.children, this.renderResizer()]
      }));
    }, i.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, i;
  })(PureComponent)
);
const DEFAULT_WIDTH = "300";
function shouldCollapse(o, i, g) {
  switch (o) {
    case PageConfig.SidebarState.EXPANDED:
      return !1;
    case PageConfig.SidebarState.COLLAPSED:
      return !0;
    case PageConfig.SidebarState.AUTO:
    default:
      return g <= i;
  }
}
const getSidebarCollapsedKey = (o) => `stSidebarCollapsed-${o}`, getSavedSidebarState = (o) => {
  if (!localStorageAvailable())
    return null;
  const i = window.localStorage.getItem(getSidebarCollapsedKey(o));
  return i === null ? null : i === "true";
}, saveSidebarState = (o, i) => {
  localStorageAvailable() && window.localStorage.setItem(getSidebarCollapsedKey(o), i.toString());
};
function clampSidebarWidth(o) {
  return Number.isNaN(o) ? Number.parseInt(DEFAULT_WIDTH, 10) : Math.min(600, Math.max(200, o));
}
function calculateMaxBreakpoint(o) {
  return parseInt(o, 10) - 0.02;
}
const Sidebar = ({
  endpoints: o,
  children: i,
  hasElements: g,
  isCollapsed: E,
  onToggleCollapse: e,
  widgetsDisabled: t
}) => {
  const n = useEmotionTheme(), h = calculateMaxBreakpoint(n.breakpoints.md), {
    innerWidth: d
  } = useWindowDimensionsContext(), {
    appPages: k,
    navSections: p
  } = useContext(NavigationContext), {
    hideSidebarNav: M,
    appLogo: H,
    initialSidebarWidth: f,
    appRootRef: AA
  } = useContext(SidebarConfigContext), gA = useScrollbarGutterSize(), IA = useRef(null), BA = localStorageAvailable() ? window.localStorage.getItem("sidebarWidth") : void 0, [CA, QA] = useState(() => {
    const pA = (() => {
      if (BA) {
        const mA = Number.parseInt(BA, 10);
        return Number.isNaN(mA) ? null : clampSidebarWidth(mA).toString();
      }
      return null;
    })();
    return pA || (notNullOrUndefined(f) ? clampSidebarWidth(f).toString() : DEFAULT_WIDTH);
  }), [iA, EA] = useState(d ?? 1 / 0), [oA, eA] = useState(!1), GA = useCallback(() => {
    eA(!0);
  }, []), cA = useCallback(() => {
    eA(!1);
  }, []), tA = useCallback((NA) => {
    const mA = clampSidebarWidth(NA).toString();
    QA(mA), localStorageAvailable() && window.localStorage.setItem("sidebarWidth", mA);
  }, []), aA = useCallback((NA, pA, mA, XA) => {
    if (mA) {
      const lA = mA.clientWidth || mA.offsetWidth;
      tA(lA);
    }
  }, [tA]);
  useExecuteWhenChanged(() => {
    d < iA && d <= h && !E && e(!0, !1), EA(d);
  }, [d]), useEffect(() => {
    const NA = (pA) => {
      const mA = IA.current, XA = AA?.current, lA = pA.target;
      if (!mA || !lA)
        return;
      const kA = mA.contains(lA), ZA = XA?.contains(lA) ?? !1, wA = d <= h;
      !kA && ZA && wA && !E && e(!0);
    };
    return document.addEventListener("mousedown", NA), () => {
      document.removeEventListener("mousedown", NA);
    };
  }, [h, E, e, d, AA]);
  function sA() {
    const NA = notNullOrUndefined(f) ? clampSidebarWidth(f).toString() : DEFAULT_WIDTH;
    QA(NA), localStorageAvailable() && window.localStorage.setItem("sidebarWidth", NA);
  }
  const DA = useCallback(() => {
    e(!E);
  }, [E, e]), rA = () => H ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { appLogo: H, endpoints: o, collapsed: E, componentName: "Sidebar Logo", dataTestId: "stSidebarLogo" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNoLogoSpacer, { "data-testid": "stLogoSpacer" }), nA = shouldShowNavigation(k, p) && !M;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Resizable,
    {
      className: "stSidebar",
      "data-testid": "stSidebar",
      "aria-expanded": !E,
      enable: {
        top: !1,
        right: !0,
        bottom: !1,
        left: !1
      },
      handleStyles: {
        right: {
          width: RESIZE_HANDLE_WIDTH,
          right: "-6px"
        }
      },
      handleComponent: {
        right: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledResizeHandle, { onDoubleClick: sA })
      },
      size: {
        width: CA,
        height: "auto"
      },
      as: StyledSidebar,
      onResizeStop: aA,
      isCollapsed: E,
      sidebarWidth: CA,
      windowInnerWidth: d,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarContent, { "data-testid": "stSidebarContent", ref: IA, onMouseOver: GA, onMouseOut: cA, scrollbarGutterSize: gA, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarHeaderContainer, { "data-testid": "stSidebarHeader", children: [
          rA(),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCollapseSidebarButton, { showSidebarCollapse: oA, "data-testid": "stSidebarCollapseButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, onClick: DA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "xl", iconValue: ":material/keyboard_double_arrow_left:", color: n.colors.fadedText60 }) }) })
        ] }),
        nA && /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNav, { endpoints: o, collapseSidebar: DA, hasSidebarElements: g, widgetsDisabled: t }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarUserContent, { hasPageNavAbove: nA, "data-testid": "stSidebarUserContent", children: i })
      ] })
    }
  );
};
function SidebarWithProvider(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IsSidebarContext.Provider, { value: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Sidebar, { ...o }) });
}
const ThemedSidebar = ({
  children: o,
  ...i
}) => {
  const {
    activeTheme: g
  } = useContext(ThemeContext), E = createSidebarTheme(g);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: E.emotion, baseuiTheme: E.basewebTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarWithProvider, { ...i, children: o }) });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$7() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledAppViewContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi10"
} : {
  target: "ea3mdgi10",
  label: "StyledAppViewContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1yiq2ps",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;align-content:flex-start;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;@media print{overflow:visible;}"
} : {
  name: "1yiq2ps",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;align-content:flex-start;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;@media print{overflow:visible;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
}), StyledAppViewMain = /* @__PURE__ */ createStyled("section", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi9"
} : {
  target: "ea3mdgi9",
  label: "StyledAppViewMain"
})(({
  disableScrolling: o,
  theme: i
}) => ({
  display: "flex",
  flexDirection: "column",
  width: i.sizes.full,
  overflow: o ? "hidden" : "auto",
  alignItems: "center",
  height: "100dvh",
  "&:focus": {
    outline: "none"
  },
  // Added so sidebar overlays main app content on
  // smaller screen sizes, except when printing
  "@media not print": {
    [`@media (max-width: ${i.breakpoints.md})`]: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      height: "100dvh"
    }
  },
  "@media print": {
    // print multiple pages if app is scrollable in Safari
    overflow: "visible"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStickyBottomContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi8"
} : {
  target: "ea3mdgi8",
  label: "StyledStickyBottomContainer"
})(({
  theme: o
}) => ({
  position: "sticky",
  left: 0,
  bottom: 0,
  width: "100%",
  zIndex: o.zIndices.bottom,
  // move the bottom container to the end of pages in print-mode so that nothing
  // (e.g. a floating chat-input) overlays the actual app content
  "@media print": {
    position: "static"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledInnerBottomContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi7"
} : {
  target: "ea3mdgi7",
  label: "StyledInnerBottomContainer"
})(({
  theme: o
}) => ({
  position: "relative",
  bottom: 0,
  width: "100%",
  minWidth: "100%",
  backgroundColor: o.colors.bgColor,
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), applyWideModePadding = (o) => ({
  // Increase side padding, if layout = wide and the screen is wide enough
  // The calculation is used to make sure that wide mode always has the same or larger
  // content compared to centered mode.
  [`@media (min-width: calc(${o.sizes.contentMaxWidth} + 2 * (${o.sizes.wideSidePadding} - ${o.spacing.lg})))`]: {
    paddingLeft: o.sizes.wideSidePadding,
    paddingRight: o.sizes.wideSidePadding
  },
  minWidth: "auto",
  maxWidth: "initial"
}), StyledAppViewBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi6"
} : {
  target: "ea3mdgi6",
  label: "StyledAppViewBlockContainer"
})(({
  hasBottom: o,
  isWideMode: i,
  showPadding: g,
  hasHeader: E,
  showToolbar: e,
  hasTopNav: t,
  hasSidebar: n,
  embedded: h,
  theme: d
}) => {
  const k = "2.25rem";
  let p = k;
  h ? g || e ? p = "6rem" : (E || n) && (p = "4.5rem") : p = t ? "8rem" : "6rem";
  const M = g && !o ? "10rem" : d.spacing.lg;
  return {
    width: d.sizes.full,
    paddingLeft: d.spacing.lg,
    paddingRight: d.spacing.lg,
    paddingTop: p,
    paddingBottom: M,
    maxWidth: d.sizes.contentMaxWidth,
    ...i && applyWideModePadding(d),
    "@media print": {
      paddingTop: k
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi5"
} : {
  target: "ea3mdgi5",
  label: "StyledSidebarBlockContainer"
})(({
  theme: o
}) => ({
  width: o.sizes.full
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9BcHBWaWV3L3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1MMkMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL0FwcFZpZXcvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCwgeyBDU1NPYmplY3QgfSBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFwcFZpZXdDb250YWluZXIgPSBzdHlsZWQuZGl2KHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImZsZXgtc3RhcnRcIixcbiAgYWxpZ25JdGVtczogXCJzdHJldGNoXCIsXG4gIGFsaWduQ29udGVudDogXCJmbGV4LXN0YXJ0XCIsXG4gIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gIHRvcDogMCxcbiAgbGVmdDogMCxcbiAgcmlnaHQ6IDAsXG4gIGJvdHRvbTogMCxcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG5cbiAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgIC8vIHByaW50IG11bHRpcGxlIHBhZ2VzIGlmIGFwcCBpcyBzY3JvbGxhYmxlIGluIFNhZmFyaVxuICAgIG92ZXJmbG93OiBcInZpc2libGVcIixcbiAgfSxcbn0pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkQXBwVmlld01haW5Qcm9wcyB7XG4gIGlzRW1iZWRkZWQ6IGJvb2xlYW5cbiAgZGlzYWJsZVNjcm9sbGluZzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQXBwVmlld01haW4gPSBzdHlsZWQuc2VjdGlvbjxTdHlsZWRBcHBWaWV3TWFpblByb3BzPihcbiAgKHsgZGlzYWJsZVNjcm9sbGluZywgdGhlbWUgfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICAgIHdpZHRoOiB0aGVtZS5zaXplcy5mdWxsLFxuICAgIG92ZXJmbG93OiBkaXNhYmxlU2Nyb2xsaW5nID8gXCJoaWRkZW5cIiA6IFwiYXV0b1wiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgaGVpZ2h0OiBgMTAwZHZoYCxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgLy8gQWRkZWQgc28gc2lkZWJhciBvdmVybGF5cyBtYWluIGFwcCBjb250ZW50IG9uXG4gICAgLy8gc21hbGxlciBzY3JlZW4gc2l6ZXMsIGV4Y2VwdCB3aGVuIHByaW50aW5nXG4gICAgXCJAbWVkaWEgbm90IHByaW50XCI6IHtcbiAgICAgIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMubWR9KWBdOiB7XG4gICAgICAgIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gICAgICAgIHRvcDogMCxcbiAgICAgICAgbGVmdDogMCxcbiAgICAgICAgcmlnaHQ6IDAsXG4gICAgICAgIGJvdHRvbTogMCxcbiAgICAgICAgaGVpZ2h0OiBgMTAwZHZoYCxcbiAgICAgIH0sXG4gICAgfSxcblxuICAgIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICAgIC8vIHByaW50IG11bHRpcGxlIHBhZ2VzIGlmIGFwcCBpcyBzY3JvbGxhYmxlIGluIFNhZmFyaVxuICAgICAgb3ZlcmZsb3c6IFwidmlzaWJsZVwiLFxuICAgIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdGlja3lCb3R0b21Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInN0aWNreVwiLFxuICBsZWZ0OiAwLFxuICBib3R0b206IDAsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5ib3R0b20sXG5cbiAgLy8gbW92ZSB0aGUgYm90dG9tIGNvbnRhaW5lciB0byB0aGUgZW5kIG9mIHBhZ2VzIGluIHByaW50LW1vZGUgc28gdGhhdCBub3RoaW5nXG4gIC8vIChlLmcuIGEgZmxvYXRpbmcgY2hhdC1pbnB1dCkgb3ZlcmxheXMgdGhlIGFjdHVhbCBhcHAgY29udGVudFxuICBcIkBtZWRpYSBwcmludFwiOiB7XG4gICAgcG9zaXRpb246IFwic3RhdGljXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZElubmVyQm90dG9tQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICBib3R0b206IDAsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgbWluV2lkdGg6IFwiMTAwJVwiLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbn0pKVxuXG4vKipcbiAqIEFkZHMgdGhlIENTUyBxdWVyeSBmb3Igd2lkZSBtb2RlLlxuICovXG5jb25zdCBhcHBseVdpZGVNb2RlUGFkZGluZyA9ICh0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0ID0+IHtcbiAgcmV0dXJuIHtcbiAgICAvLyBJbmNyZWFzZSBzaWRlIHBhZGRpbmcsIGlmIGxheW91dCA9IHdpZGUgYW5kIHRoZSBzY3JlZW4gaXMgd2lkZSBlbm91Z2hcbiAgICAvLyBUaGUgY2FsY3VsYXRpb24gaXMgdXNlZCB0byBtYWtlIHN1cmUgdGhhdCB3aWRlIG1vZGUgYWx3YXlzIGhhcyB0aGUgc2FtZSBvciBsYXJnZXJcbiAgICAvLyBjb250ZW50IGNvbXBhcmVkIHRvIGNlbnRlcmVkIG1vZGUuXG4gICAgW2BAbWVkaWEgKG1pbi13aWR0aDogY2FsYygke3RoZW1lLnNpemVzLmNvbnRlbnRNYXhXaWR0aH0gKyAyICogKCR7dGhlbWUuc2l6ZXMud2lkZVNpZGVQYWRkaW5nfSAtICR7dGhlbWUuc3BhY2luZy5sZ30pKSlgXTpcbiAgICAgIHtcbiAgICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNpemVzLndpZGVTaWRlUGFkZGluZyxcbiAgICAgICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zaXplcy53aWRlU2lkZVBhZGRpbmcsXG4gICAgICB9LFxuICAgIG1pbldpZHRoOiBcImF1dG9cIixcbiAgICBtYXhXaWR0aDogXCJpbml0aWFsXCIsXG4gIH1cbn1cblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRBcHBWaWV3QmxvY2tDb250YWluZXJQcm9wcyB7XG4gIGlzV2lkZU1vZGU6IGJvb2xlYW5cbiAgaGFzQm90dG9tOiBib29sZWFuXG4gIHNob3dQYWRkaW5nOiBib29sZWFuXG4gIGhhc0hlYWRlcjogYm9vbGVhblxuICBzaG93VG9vbGJhcjogYm9vbGVhblxuICBoYXNUb3BOYXY6IGJvb2xlYW5cbiAgaGFzU2lkZWJhcjogYm9vbGVhblxuICBlbWJlZGRlZDogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQXBwVmlld0Jsb2NrQ29udGFpbmVyID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRBcHBWaWV3QmxvY2tDb250YWluZXJQcm9wcz4oXG4gICAgKHtcbiAgICAgIGhhc0JvdHRvbSxcbiAgICAgIGlzV2lkZU1vZGUsXG4gICAgICBzaG93UGFkZGluZyxcbiAgICAgIGhhc0hlYWRlcixcbiAgICAgIHNob3dUb29sYmFyLFxuICAgICAgaGFzVG9wTmF2LFxuICAgICAgaGFzU2lkZWJhcixcbiAgICAgIGVtYmVkZGVkLFxuICAgICAgdGhlbWUsXG4gICAgfSkgPT4ge1xuICAgICAgY29uc3QgbGl0dGxlUGFkZGluZyA9IFwiMi4yNXJlbVwiXG5cbiAgICAgIC8vIFRvcCBwYWRkaW5nIGxvZ2ljIHBlciBzcGVjaWZpY2F0aW9uOlxuICAgICAgbGV0IHRvcFBhZGRpbmcgPSBsaXR0bGVQYWRkaW5nIC8vIERlZmF1bHQ6IDIuMjVyZW1cblxuICAgICAgaWYgKCFlbWJlZGRlZCkge1xuICAgICAgICAvLyBOb24tZW1iZWRkZWQgYXBwcyBhbHdheXMgZ2V0IDZyZW0gb3IgOHJlbVxuICAgICAgICB0b3BQYWRkaW5nID0gaGFzVG9wTmF2ID8gXCI4cmVtXCIgOiBcIjZyZW1cIlxuICAgICAgfSBlbHNlIGlmIChzaG93UGFkZGluZyB8fCBzaG93VG9vbGJhcikge1xuICAgICAgICAvLyA2cmVtIGlmIGVtYmVkZGVkIHdpdGggc2hvd19wYWRkaW5nIG9yIHNob3dfdG9vbGJhclxuICAgICAgICB0b3BQYWRkaW5nID0gXCI2cmVtXCJcbiAgICAgIH0gZWxzZSBpZiAoaGFzSGVhZGVyIHx8IGhhc1NpZGViYXIpIHtcbiAgICAgICAgLy8gNC41cmVtIGlmIGVtYmVkZGVkIHdpdGggaGVhZGVyIGJ1dCBubyBwYWRkaW5nL3Rvb2xiYXJcbiAgICAgICAgdG9wUGFkZGluZyA9IFwiNC41cmVtXCJcbiAgICAgIH1cbiAgICAgIC8vIE90aGVyd2lzZSB1c2UgZGVmYXVsdDogMi4yNXJlbSBpZiBlbWJlZGRlZCB3aXRoIG5vIGhlYWRlciBhbmQgbm8gcGFkZGluZy90b29sYmFyXG5cbiAgICAgIGNvbnN0IGJvdHRvbUVtYmVkUGFkZGluZyA9XG4gICAgICAgIHNob3dQYWRkaW5nICYmICFoYXNCb3R0b20gPyBcIjEwcmVtXCIgOiB0aGVtZS5zcGFjaW5nLmxnXG5cbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiB0aGVtZS5zaXplcy5mdWxsLFxuICAgICAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxuICAgICAgICBwYWRkaW5nVG9wOiB0b3BQYWRkaW5nLFxuICAgICAgICBwYWRkaW5nQm90dG9tOiBib3R0b21FbWJlZFBhZGRpbmcsXG4gICAgICAgIG1heFdpZHRoOiB0aGVtZS5zaXplcy5jb250ZW50TWF4V2lkdGgsXG4gICAgICAgIC4uLihpc1dpZGVNb2RlICYmIGFwcGx5V2lkZU1vZGVQYWRkaW5nKHRoZW1lKSksXG4gICAgICAgIFtgQG1lZGlhIHByaW50YF06IHtcbiAgICAgICAgICBwYWRkaW5nVG9wOiBsaXR0bGVQYWRkaW5nLFxuICAgICAgICB9LFxuICAgICAgfVxuICAgIH1cbiAgKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckJsb2NrQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgd2lkdGg6IHRoZW1lLnNpemVzLmZ1bGwsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFdmVudEJsb2NrQ29udGFpbmVyID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwibm9uZVwiLFxufSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRCb3R0b21CbG9ja0NvbnRhaW5lclByb3BzIHtcbiAgaXNXaWRlTW9kZTogYm9vbGVhblxuICBzaG93UGFkZGluZzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQm90dG9tQmxvY2tDb250YWluZXIgPVxuICBzdHlsZWQuZGl2PFN0eWxlZEJvdHRvbUJsb2NrQ29udGFpbmVyUHJvcHM+KFxuICAgICh7IGlzV2lkZU1vZGUsIHNob3dQYWRkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ0JvdHRvbTogc2hvd1BhZGRpbmdcbiAgICAgICAgICA/IHRoZW1lLnNpemVzLmFwcERlZmF1bHRCb3R0b21QYWRkaW5nXG4gICAgICAgICAgOiB0aGVtZS5zcGFjaW5nLnRocmVlWEwsXG4gICAgICAgIG1heFdpZHRoOiB0aGVtZS5zaXplcy5jb250ZW50TWF4V2lkdGgsXG4gICAgICAgIC4uLihpc1dpZGVNb2RlICYmIGFwcGx5V2lkZU1vZGVQYWRkaW5nKHRoZW1lKSksXG4gICAgICAgIFtgQG1lZGlhIHByaW50YF06IHtcbiAgICAgICAgICBwYWRkaW5nVG9wOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICAgIH0sXG4gICAgICB9XG4gICAgfVxuICApXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBcHBWaWV3QmxvY2tTcGFjZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgICBmbGV4R3JvdzogMSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZElGcmFtZVJlc2l6ZXJBbmNob3IgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIGJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNYWluQ29udGVudCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2lkdGg6IHRoZW1lLnNpemVzLmZ1bGwsXG4gIG1pbldpZHRoOiAwLFxuICBoZWlnaHQ6IGAxMDBkdmhgLFxuXG4gIC8vIEFwcGx5IHJlbGF0aXZlIHBvc2l0aW9uaW5nIG9ubHkgb24gZGVza3RvcCB0byBmaXggaGVhZGVyIHBvc2l0aW9uaW5nIHdoZW4gc2lkZWJhciBvcGVucy5cbiAgLy8gT24gbW9iaWxlLCByZWxhdGl2ZSBwb3NpdGlvbmluZyBpcyBvbWl0dGVkIHRvIGFsbG93IHRoZSBzaWRlYmFyIHRvIHByb3Blcmx5IG92ZXJsYXlcbiAgLy8gdGhlIGFwcCBjb250ZW50IGZvciBzdC5uYXZpZ2F0aW9uKHBvc2l0aW9uPSd0b3AnKSBmdW5jdGlvbmFsaXR5ICgjMTEzNDkpLlxuICAvLyBXaXRob3V0IHRoaXMgY29uZGl0aW9uYWwgcG9zaXRpb25pbmcsIHRoZSBzaWRlYmFyIHdvdWxkIG92ZXJsYXAgdGhlIHRvcCBuYXZpZ2F0aW9uXG4gIC8vIHdoZW4gb3BlbmVkIG9uIGRlc2t0b3AgZGV2aWNlcy5cbiAgW2BAbWVkaWEgKG1pbi13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICB9LFxufSkpXG4iXX0= */"), StyledEventBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi4"
} : {
  target: "ea3mdgi4",
  label: "StyledEventBlockContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "eivff4",
  styles: "display:none/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
}), StyledBottomBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi3"
} : {
  target: "ea3mdgi3",
  label: "StyledBottomBlockContainer"
})(({
  isWideMode: o,
  showPadding: i,
  theme: g
}) => ({
  width: g.sizes.full,
  paddingLeft: g.spacing.lg,
  paddingRight: g.spacing.lg,
  paddingTop: g.spacing.lg,
  paddingBottom: i ? g.sizes.appDefaultBottomPadding : g.spacing.threeXL,
  maxWidth: g.sizes.contentMaxWidth,
  ...o && applyWideModePadding(g),
  "@media print": {
    paddingTop: g.spacing.none
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppViewBlockSpacer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi2"
} : {
  target: "ea3mdgi2",
  label: "StyledAppViewBlockSpacer"
})(({
  theme: o
}) => ({
  width: o.sizes.full,
  flexGrow: 1
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIFrameResizerAnchor = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi1"
} : {
  target: "ea3mdgi1",
  label: "StyledIFrameResizerAnchor"
})(({
  theme: o
}) => ({
  position: "relative",
  bottom: o.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMainContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi0"
} : {
  target: "ea3mdgi0",
  label: "StyledMainContent"
})(({
  theme: o
}) => ({
  width: o.sizes.full,
  minWidth: 0,
  height: "100dvh",
  // Apply relative positioning only on desktop to fix header positioning when sidebar opens.
  // On mobile, relative positioning is omitted to allow the sidebar to properly overlay
  // the app content for st.navigation(position='top') functionality (#11349).
  // Without this conditional positioning, the sidebar would overlap the top navigation
  // when opened on desktop devices.
  [`@media (min-width: ${o.breakpoints.md})`]: {
    position: "relative"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ScrollToBottomContainer(o) {
  const {
    className: i,
    tabIndex: g,
    children: E,
    isEmbedded: e,
    disableScrolling: t
  } = o, n = useScrollToBottom(!0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewMain, { tabIndex: g, className: i, isEmbedded: e, disableScrolling: t, ref: n, "data-testid": "stAppScrollToBottomContainer", children: E });
}
function AppView(o) {
  const {
    elements: i,
    widgetMgr: g,
    uploadClient: E,
    sendMessageToHost: e,
    endpoints: t,
    navigationPosition: n,
    topRightContent: h,
    wideMode: d,
    embedded: k,
    showPadding: p,
    disableScrolling: M,
    addScriptFinishedHandler: H,
    removeScriptFinishedHandler: f,
    widgetsDisabled: AA,
    showToolbar: gA,
    disableFullscreenMode: IA,
    componentRegistry: BA
  } = o;
  useEffect(() => {
    const xA = () => {
      e({
        type: "UPDATE_HASH",
        hash: window.location.hash
      });
    };
    return window.addEventListener("hashchange", xA, !1), () => window.removeEventListener("hashchange", xA, !1);
  }, [e]);
  const {
    activeTheme: CA
  } = useContext(ThemeContext), {
    appPages: QA,
    navSections: iA,
    pageLinkBaseUrl: EA
  } = useContext(NavigationContext), {
    initialSidebarState: oA,
    appLogo: eA,
    hideSidebarNav: GA
  } = useContext(SidebarConfigContext), {
    innerWidth: cA
  } = useWindowDimensionsContext(), tA = d ? "wide" : "narrow", aA = !i.sidebar.isEmpty, sA = !i.event.isEmpty, DA = !i.bottom.isEmpty, [rA, nA] = useState(!1), NA = cA > 0 && (aA || n === Navigation.Position.SIDEBAR && !GA && QA.length > 1 || rA);
  useEffect(() => {
    NA && GA && !rA && nA(!0);
  }, [NA, GA, rA]);
  const pA = useCallback(() => {
    !aA && rA && nA(!1);
  }, [aA, rA]);
  useEffect(() => (H(pA), () => {
    f(pA);
  }), [pA, H, f]);
  const mA = DA ? ScrollToBottomContainer : StyledAppViewMain, XA = (xA) => /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { node: xA, endpoints: t, widgetMgr: g, widgetsDisabled: AA, uploadClient: E, disableFullscreenMode: IA, componentRegistry: BA, height: "auto", isRoot: !0 }), [lA, kA] = useState(() => {
    const xA = getSavedSidebarState(EA);
    return xA !== null ? xA : shouldCollapse(oA, parseInt(CA.emotion.breakpoints.md, 10), cA);
  });
  useExecuteWhenChanged(() => {
    if (cA > 0 && NA) {
      const xA = getSavedSidebarState(EA);
      kA(xA !== null ? xA : shouldCollapse(oA, parseInt(CA.emotion.breakpoints.md, 10), cA));
    }
  }, [cA, NA, oA, CA.emotion.breakpoints.md, EA]);
  const ZA = useCallback((xA, MA = !0) => {
    kA(xA), MA && saveSidebarState(EA, xA);
  }, [EA]), wA = useCallback(() => {
    ZA(!lA, !0);
  }, [ZA, lA]), LA = eA ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { appLogo: eA, endpoints: t, collapsed: lA || !NA, componentName: "Header Logo", dataTestId: "stHeaderLogo" }) : null, fA = LA && (!NA || lA), dA = NA && lA, RA = n === Navigation.Position.TOP && shouldShowNavigation(QA, iA), KA = fA || dA || RA || gA;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppViewContainer, { className: "stAppViewContainer appview-container", "data-testid": "stAppViewContainer", "data-layout": tA, children: [
    NA && /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Sidebar", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedSidebar, { endpoints: t, hasElements: aA, isCollapsed: lA, onToggleCollapse: ZA, widgetsDisabled: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarBlockContainer, { children: XA(i.sidebar) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMainContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { hasSidebar: NA, isSidebarOpen: NA && !lA, onToggleSidebar: wA, navigation: n === Navigation.Position.TOP && shouldShowNavigation(QA, iA) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TopNav, { endpoints: t, widgetsDisabled: AA }) : null, rightContent: h, logoComponent: LA, showToolbar: gA }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(mA, { tabIndex: 0, isEmbedded: k, disableScrolling: M, className: "stMain", "data-testid": "stMain", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Main", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewBlockContainer, { className: "stMainBlockContainer block-container", "data-testid": "stMainBlockContainer", isWideMode: d, showPadding: p, hasBottom: DA, hasHeader: KA, hasSidebar: NA, showToolbar: gA, hasTopNav: RA, embedded: k, children: XA(i.main) }) }),
        !DA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIFrameResizerAnchor, { "data-testid": "stAppIframeResizerAnchor", "data-iframe-height": !0 }),
        DA && /* @__PURE__ */ jsxRuntimeExports.jsxs(Profiler, { id: "Bottom", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewBlockSpacer, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStickyBottomContainer, { className: "stBottom", "data-testid": "stBottom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInnerBottomContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBottomBlockContainer, { "data-testid": "stBottomBlockContainer", isWideMode: d, showPadding: p, children: XA(i.bottom) }) }) })
        ] })
      ] })
    ] }),
    sA && /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Event", children: /* @__PURE__ */ jsxRuntimeExports.jsx(EventContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEventBlockContainer, { className: "stEvent", "data-testid": "stEvent", children: XA(i.event) }) }) })
  ] });
}
const DeployButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e17vllj40"
} : {
  target: "e17vllj40",
  label: "DeployButtonContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  gap: o.spacing.sm,
  alignItems: "center",
  lineHeight: o.iconSizes.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9EZXBsb3lCdXR0b24vc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCcUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL0RlcGxveUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IERlcGxveUJ1dHRvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgbGluZUhlaWdodDogdGhlbWUuaWNvblNpemVzLm1kLFxufSkpXG4iXX0= */"), DeployButton = ({
  onClick: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stAppDeployButton", "data-testid": "stAppDeployButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_BUTTON, onClick: o, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DeployButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Deploy" }) }) }) });
var MoreVert = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
});
MoreVert.displayName = "MoreVert";
const BLOB_TYPE = "video/webm", LOG$4 = loglevelExports$1.getLogger("ScreenCastRecorder");
class ScreenCastRecorder {
  /** True if the current browser likely supports screencasts. */
  static isSupportedBrowser() {
    try {
      return notNullOrUndefined(navigator.mediaDevices) && notNullOrUndefined(navigator.mediaDevices.getUserMedia) && notNullOrUndefined(navigator.mediaDevices.getDisplayMedia) && MediaRecorder.isTypeSupported(BLOB_TYPE);
    } catch {
      return !1;
    }
  }
  constructor({
    recordAudio: i,
    onErrorOrStop: g
  }) {
    this.recordAudio = i, this.onErrorOrStopCallback = g, this.inputStream = null, this.recordedChunks = [], this.mediaRecorder = null;
  }
  /**
   * This asynchronous method will initialize the screen recording object asking
   * for permissions to the user which are needed to start recording.
   */
  async initialize() {
    let g = (await navigator.mediaDevices.getDisplayMedia({
      video: !0
    })).getTracks();
    if (this.recordAudio) {
      const E = await navigator.mediaDevices.getUserMedia({
        video: !1,
        audio: !0
      });
      g = g.concat(E.getAudioTracks());
    }
    this.recordedChunks = [], this.inputStream = new MediaStream(g), this.mediaRecorder = new MediaRecorder(this.inputStream, {
      mimeType: BLOB_TYPE
    }), this.mediaRecorder.ondataavailable = (E) => this.recordedChunks.push(E.data);
  }
  getState() {
    return this.mediaRecorder ? this.mediaRecorder.state : "inactive";
  }
  /**
   * This method will start the screen recording if the user has granted permissions
   * and the mediaRecorder has been initialized
   *
   * @returns {boolean}
   */
  start() {
    if (!this.mediaRecorder)
      return LOG$4.warn("ScreenCastRecorder.start: mediaRecorder is null"), !1;
    const i = (g) => {
      LOG$4.warn(`mediaRecorder.start threw an error: ${g}`);
    };
    this.mediaRecorder.onerror = (g) => {
      i(g), this.onErrorOrStopCallback();
    }, this.mediaRecorder.onstop = () => this.onErrorOrStopCallback();
    try {
      this.mediaRecorder.start();
    } catch (g) {
      return i(g), !1;
    }
    return !0;
  }
  /**
   * This method will stop recording and then return the generated Blob
   *
   * @returns {(Promise|undefined)}
   *  A Promise which will return the generated Blob
   *  Undefined if the MediaRecorder could not initialize
   */
  stop() {
    if (!this.mediaRecorder)
      return;
    let i;
    const g = new Promise((E) => {
      i = E;
    });
    return this.mediaRecorder.onstop = () => i(), this.mediaRecorder.stop(), this.inputStream && (this.inputStream.getTracks().forEach((E) => E.stop()), this.inputStream = null), g.then(() => this.buildOutputBlob());
  }
  buildOutputBlob() {
    return new Blob(this.recordedChunks, {
      type: BLOB_TYPE
    });
  }
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$6() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const recordingIndicatorPulse = (o) => keyframes`
0% {
  box-shadow: 0 0 ${o.spacing.twoXS} ${o.colors.redTextColor};
}
50% {
  box-shadow: 0 0 ${o.spacing.sm} ${o.spacing.twoXS} ${o.colors.redTextColor};
}
100% {
  box-shadow: 0 0 ${o.spacing.twoXS} ${o.colors.redTextColor};
}`, StyledRecordingIndicator = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq808"
} : {
  target: "e16jpq808",
  label: "StyledRecordingIndicator"
})(({
  theme: o
}) => ({
  position: "absolute",
  bottom: o.spacing.lg,
  right: o.spacing.sm,
  width: o.spacing.sm,
  height: o.spacing.sm,
  backgroundColor: o.colors.redTextColor,
  borderRadius: o.radii.full,
  boxShadow: `0 0 ${o.spacing.twoXS} ${o.colors.redTextColor}`,
  animation: `${recordingIndicatorPulse(o)} 2s linear infinite`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuDivider = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq807"
} : {
  target: "e16jpq807",
  label: "StyledMenuDivider"
})(({
  theme: o
}) => ({
  borderTop: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  margin: `${o.spacing.sm} ${o.spacing.none}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItemShortcut = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq806"
} : {
  target: "e16jpq806",
  label: "StyledMenuItemShortcut"
})(({
  isRecording: o,
  theme: i
}) => ({
  color: o ? i.colors.redTextColor : i.colors.fadedText60,
  fontSize: i.fontSizes.sm,
  marginTop: i.spacing.twoXS,
  fontVariant: "small-caps",
  textTransform: "uppercase"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItem = /* @__PURE__ */ createStyled("ul", process.env.NODE_ENV === "production" ? {
  target: "e16jpq805"
} : {
  target: "e16jpq805",
  label: "StyledMenuItem"
})(({
  isDisabled: o,
  isRecording: i,
  theme: g
}) => {
  const E = o ? {
    backgroundColor: g.colors.transparent,
    color: g.colors.fadedText60,
    cursor: "not-allowed"
  } : {
    "&:focus": {
      backgroundColor: g.colors.primary,
      color: g.colors.white
    }
  }, e = i && {
    color: g.colors.redTextColor,
    fontWeight: g.fontWeights.bold
  };
  return {
    display: "block",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: g.spacing.none,
    cursor: "pointer",
    ...e || {},
    ...E,
    "@media print": {
      display: "none !important"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCoreItem = /* @__PURE__ */ createStyled("li", process.env.NODE_ENV === "production" ? {
  target: "e16jpq804"
} : {
  target: "e16jpq804",
  label: "StyledCoreItem"
})(({
  isHighlighted: o,
  styleProps: i,
  theme: g
}) => {
  const E = o && {
    "&:hover": {
      backgroundColor: g.colors.darkenedBgMix15
    }
  }, e = i?.margin || 0, t = i?.padding || `${g.spacing.twoXS} ${g.spacing.twoXL}`, n = i?.backgroundColor || g.colors.bgColor, h = i?.fontSize || g.fontSizes.md;
  return {
    margin: e,
    padding: t,
    backgroundColor: n,
    fontSize: h,
    ...E || {},
    display: "block"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4RzhCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHsgS2V5ZnJhbWVzIH0gZnJvbSBcIkBlbW90aW9uL3NlcmlhbGl6ZVwiXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUgfSBmcm9tIFwiY29sb3Iya1wiXG5cbmltcG9ydCB7IEVtb3Rpb25UaGVtZSB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbmNvbnN0IHJlY29yZGluZ0luZGljYXRvclB1bHNlID0gKHRoZW1lOiBFbW90aW9uVGhlbWUpOiBLZXlmcmFtZXMgPT4ga2V5ZnJhbWVzYFxuMCUge1xuICBib3gtc2hhZG93OiAwIDAgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9O1xufVxuNTAlIHtcbiAgYm94LXNoYWRvdzogMCAwICR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9O1xufVxuMTAwJSB7XG4gIGJveC1zaGFkb3c6IDAgMCAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59YFxuXG5leHBvcnQgY29uc3QgU3R5bGVkUmVjb3JkaW5nSW5kaWNhdG9yID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICBib3R0b206IHRoZW1lLnNwYWNpbmcubGcsXG4gIHJpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogdGhlbWUuc3BhY2luZy5zbSxcbiAgaGVpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3IsXG4gIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgYm94U2hhZG93OiBgMCAwICR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yfWAsXG4gIGFuaW1hdGlvbjogYCR7cmVjb3JkaW5nSW5kaWNhdG9yUHVsc2UodGhlbWUpfSAycyBsaW5lYXIgaW5maW5pdGVgLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51RGl2aWRlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgYm9yZGVyVG9wOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgbWFyZ2luOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubm9uZX1gLFxufSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgSXRlbVByb3BzIHtcbiAgaXNEaXNhYmxlZDogYm9vbGVhblxuICBpc1JlY29yZGluZzogYm9vbGVhblxufVxuXG5leHBvcnQgaW50ZXJmYWNlIEl0ZW1TdHlsZVByb3BzIHtcbiAgaXNIaWdobGlnaHRlZDogYm9vbGVhblxuICBzdHlsZVByb3BzPzogUmVhY3QuQ1NTUHJvcGVydGllc1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVudUl0ZW1TaG9ydGN1dCA9IHN0eWxlZC5zcGFuPEl0ZW1Qcm9wcz4oXG4gICh7IGlzUmVjb3JkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGNvbG9yOiBpc1JlY29yZGluZ1xuICAgICAgICA/IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3JcbiAgICAgICAgOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgICAgZm9udFZhcmlhbnQ6IFwic21hbGwtY2Fwc1wiLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJ1cHBlcmNhc2VcIixcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVJdGVtID0gc3R5bGVkLnVsPEl0ZW1Qcm9wcz4oXG4gICh7IGlzRGlzYWJsZWQsIGlzUmVjb3JkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgY29uc3QgZGlzYWJsZWRTdHlsZXMgPSBpc0Rpc2FibGVkXG4gICAgICA/IHtcbiAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgICAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgICAgICB9XG4gICAgICA6IHtcbiAgICAgICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgICAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gICAgICAgICAgfSxcbiAgICAgICAgfVxuXG4gICAgY29uc3QgcmVjb3JkaW5nU3R5bGVzID0gaXNSZWNvcmRpbmcgJiYge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3IsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxuICAgIH1cblxuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICBmbGV4RGlyZWN0aW9uOiBcInJvd1wiLFxuICAgICAgYWxpZ25JdGVtczogXCJmbGV4LXN0YXJ0XCIsXG4gICAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgLi4uKHJlY29yZGluZ1N0eWxlcyB8fCB7fSksXG4gICAgICAuLi5kaXNhYmxlZFN0eWxlcyxcbiAgICAgIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICAgICAgZGlzcGxheTogXCJub25lICFpbXBvcnRhbnRcIixcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb3JlSXRlbSA9IHN0eWxlZC5saTxJdGVtU3R5bGVQcm9wcz4oXG4gICh7IGlzSGlnaGxpZ2h0ZWQsIHN0eWxlUHJvcHMsIHRoZW1lIH0pID0+IHtcbiAgICBjb25zdCBoaWdobGlnaHRlZFN0eWxlcyA9IGlzSGlnaGxpZ2h0ZWQgJiYge1xuICAgICAgXCImOmhvdmVyXCI6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgfSxcbiAgICB9XG5cbiAgICBjb25zdCBtYXJnaW4gPSBzdHlsZVByb3BzPy5tYXJnaW4gfHwgMFxuICAgIGNvbnN0IHBhZGRpbmcgPVxuICAgICAgc3R5bGVQcm9wcz8ucGFkZGluZyB8fCBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcudHdvWEx9YFxuICAgIGNvbnN0IGJhY2tncm91bmRDb2xvciA9IHN0eWxlUHJvcHM/LmJhY2tncm91bmRDb2xvciB8fCB0aGVtZS5jb2xvcnMuYmdDb2xvclxuICAgIGNvbnN0IGZvbnRTaXplID0gc3R5bGVQcm9wcz8uZm9udFNpemUgfHwgdGhlbWUuZm9udFNpemVzLm1kXG5cbiAgICByZXR1cm4ge1xuICAgICAgbWFyZ2luLFxuICAgICAgcGFkZGluZyxcbiAgICAgIGJhY2tncm91bmRDb2xvcixcbiAgICAgIGZvbnRTaXplLFxuICAgICAgLi4uKGhpZ2hsaWdodGVkU3R5bGVzIHx8IHt9KSxcbiAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERldkl0ZW0gPSBzdHlsZWQubGk8SXRlbVN0eWxlUHJvcHM+KFxuICAoeyBpc0hpZ2hsaWdodGVkLCBzdHlsZVByb3BzLCB0aGVtZSB9KSA9PiB7XG4gICAgY29uc3QgaGlnaGxpZ2h0ZWRTdHlsZXMgPSBpc0hpZ2hsaWdodGVkICYmIHtcbiAgICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICAgIC8vIFdoYXRldmVyIGNvbG9yIHdlIHVzZSBoZXJlIGFzIHRoZSBob3ZlciBzdGF0ZSwgd2Ugd2FudCB0byB0cmFuc3BhcmVudGl6ZSBpdFxuICAgICAgICAvLyB0byBpdHMgZnVsbCBleHRlbmQsIHNvIHlvdSBjYW4gc2VlIHRoZSB1bmRlcmx5aW5nIGNvbG9yIG9mIHRoZSBtZW51LlxuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsIDEpLFxuICAgICAgfSxcbiAgICB9XG4gICAgY29uc3QgbWFyZ2luID0gc3R5bGVQcm9wcz8ubWFyZ2luIHx8IDBcbiAgICBjb25zdCBwYWRkaW5nID1cbiAgICAgIHN0eWxlUHJvcHM/LnBhZGRpbmcgfHwgYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLnR3b1hMfWBcbiAgICBjb25zdCBiYWNrZ3JvdW5kQ29sb3IgPVxuICAgICAgc3R5bGVQcm9wcz8uYmFja2dyb3VuZENvbG9yIHx8IHRoZW1lLmNvbG9ycy5zZWNvbmRhcnlCZ1xuICAgIGNvbnN0IGZvbnRTaXplID0gc3R5bGVQcm9wcz8uZm9udFNpemUgfHwgdGhlbWUuZm9udFNpemVzLm1kXG4gICAgcmV0dXJuIHtcbiAgICAgIG1hcmdpbixcbiAgICAgIHBhZGRpbmcsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3IsXG4gICAgICBmb250U2l6ZSxcbiAgICAgIC4uLihoaWdobGlnaHRlZFN0eWxlcyB8fCB7fSksXG4gICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbUxhYmVsID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubWQsXG4gIGZsZXhHcm93OiAxLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51Q29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICAvLyBXZSBzdGFydCBieSBhZGRpbmcgYm9yZGVyIHJhZGl1cyB0byBhbGwgbWVudXNcbiAgdWw6IHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIH0sXG5cbiAgLy8gVGhpcyBzZWxlY3RzIHRoZSBzdGFuZGFyZCBtZW51IG9ubHkgaWYgdGhlcmUncyBhbm90aGVyIG1lbnUgYmVsb3cuXG4gIC8vIFdlIHVzZSB0aGlzIHRvIG92ZXJyaWRlIHRoZSBib3R0b20gYm9yZGVyIHJhZGl1cyBvbiB0aGUgbGFzdCBpdGVtIGlmIHRoZSBkZXZlbG9wZXIgb3B0aW9ucyBtZW51IGlzIHZpc2libGUuXG4gIFwiJiA+IHVsW3JvbGU9bGlzdGJveF06bm90KDpsYXN0LWNoaWxkKVwiOiB7XG4gICAgYm9yZGVyQm90dG9tTGVmdFJhZGl1czogMCxcbiAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogMCxcbiAgfSxcblxuICAvLyBUaGlzIHNlbGVjdHMgdGhlIGRldmVsb3BlciBvcHRpb25zIG1lbnUsIGlmIGl0IGV4aXN0cy5cbiAgLy8gV2UgdXNlIHRoaXMgdG8gb3ZlcnJpZGUgdGhlIHRvcCBib3JkZXIgcmFkaXVzLlxuICBcInVsW3JvbGU9bGlzdGJveF0gfiB1bFtyb2xlPWxpc3Rib3hdXCI6IHtcbiAgICBib3JkZXJUb3BMZWZ0UmFkaXVzOiAwLFxuICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiAwLFxuICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgYm9yZGVyVG9wOiBcIm5vbmVcIixcbiAgfSxcbiAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNYWluTWVudUNvbnRhaW5lciA9IHN0eWxlZC5zcGFuKHtcbiAgbGluZUhlaWdodDogXCJpbml0aWFsXCIsXG59KVxuIl19 */"), StyledDevItem = /* @__PURE__ */ createStyled("li", process.env.NODE_ENV === "production" ? {
  target: "e16jpq803"
} : {
  target: "e16jpq803",
  label: "StyledDevItem"
})(({
  isHighlighted: o,
  styleProps: i,
  theme: g
}) => {
  const E = o && {
    "&:hover": {
      // Whatever color we use here as the hover state, we want to transparentize it
      // to its full extend, so you can see the underlying color of the menu.
      backgroundColor: transparentize(g.colors.darkenedBgMix15, 1)
    }
  }, e = i?.margin || 0, t = i?.padding || `${g.spacing.twoXS} ${g.spacing.twoXL}`, n = i?.backgroundColor || g.colors.secondaryBg, h = i?.fontSize || g.fontSizes.md;
  return {
    margin: e,
    padding: t,
    backgroundColor: n,
    fontSize: h,
    ...E || {},
    display: "block"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItemLabel = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq802"
} : {
  target: "e16jpq802",
  label: "StyledMenuItemLabel"
})(({
  theme: o
}) => ({
  marginRight: o.spacing.md,
  flexGrow: 1
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq801"
} : {
  target: "e16jpq801",
  label: "StyledMenuContainer"
})(({
  theme: o
}) => ({
  // We start by adding border radius to all menus
  ul: {
    borderRadius: o.radii.default
  },
  // This selects the standard menu only if there's another menu below.
  // We use this to override the bottom border radius on the last item if the developer options menu is visible.
  "& > ul[role=listbox]:not(:last-child)": {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  // This selects the developer options menu, if it exists.
  // We use this to override the top border radius.
  "ul[role=listbox] ~ ul[role=listbox]": {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    boxShadow: "none",
    borderTop: "none"
  },
  "@media print": {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMainMenuContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq800"
} : {
  target: "e16jpq800",
  label: "StyledMainMenuContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "hwawmg",
  styles: "line-height:initial"
} : {
  name: "hwawmg",
  styles: "line-height:initial/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
}), SCREENCAST_LABEL = {
  COUNTDOWN: "Cancel screencast",
  RECORDING: "Stop recording"
}, getOpenInWindowCallback = (o) => () => {
  window.open(o, "_blank");
};
function buildMenuItemComponent(o, i) {
  const g = forwardRef(({
    item: E,
    "aria-selected": e,
    onClick: t,
    onMouseEnter: n,
    $disabled: h,
    $isHighlighted: d
  }, k) => {
    const {
      label: p,
      shortcut: M,
      hasDividerAbove: H,
      styleProps: f,
      noHighlight: AA,
      interactions: gA
    } = E, IA = {
      isDisabled: h,
      isRecording: !!E.stopRecordingIndicator
    }, BA = {
      isHighlighted: !AA && d,
      styleProps: f
    }, CA = gA || (h ? {} : {
      onClick: (QA) => {
        i.enqueue("menuClick", {
          label: p
        }), t(QA);
      },
      onMouseEnter: n
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      H && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuDivider, { "data-testid": "stMainMenuDivider" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItem, { ref: k, role: "option", "aria-selected": e, "aria-disabled": h, ...IA, ...CA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(o, { ...BA, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemLabel, { ...IA, children: p }),
        M && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemShortcut, { ...IA, children: M })
      ] }) })
    ] });
  });
  return g.displayName = "MenuItem", g;
}
const SubMenu = (o) => {
  const {
    colors: i,
    sizes: g,
    spacing: E
  } = useEmotionTheme(), e = o.isDevMenu ? StyledDevItem : StyledCoreItem;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulMenu, { items: o.menuItems, onItemSelect: ({
    item: t
  }) => {
    t.onClick(), o.closeMenu();
  }, overrides: {
    Option: buildMenuItemComponent(e, o.metricsMgr),
    List: {
      props: {
        "data-testid": "stMainMenuList"
      },
      style: {
        backgroundColor: "inherit",
        borderBottomRadius: 0,
        borderTopRadius: 0,
        borderLeftRadius: 0,
        borderRightRadius: 0,
        paddingBottom: E.sm,
        paddingTop: E.sm,
        ":focus": {
          outline: "none"
        },
        border: `${g.borderWidth} solid ${i.borderColor}`
      }
    }
  } });
};
function getDevMenuItems(o, i) {
  const g = [], E = [i.developerOptions, i.clearCache];
  let e = null;
  for (const t of E)
    t && (t !== i.DIVIDER && (e === i.DIVIDER ? g.push({
      ...t,
      hasDividerAbove: !0
    }) : g.push(t)), e = t);
  return notNullOrUndefined(e) && (e.styleProps = {
    margin: `0 0 -${o.spacing.sm} 0`,
    padding: `${o.spacing.twoXS} ${o.spacing.none} ${o.spacing.twoXS} ${o.spacing.twoXL}`
  }), g;
}
function getPreferredMenuOrder(o, i, g) {
  let E;
  if (o.toolbarMode == Config.ToolbarMode.MINIMAL) {
    for (E = [g.report, g.community, g.DIVIDER, ...i.length > 0 ? i : [g.DIVIDER], g.about], E = E.filter((e) => e); E.length > 0 && E[0] == g.DIVIDER; )
      E.shift();
    for (; E.length > 0 && E.at(E.length - 1) == g.DIVIDER; )
      E.pop();
    return E;
  }
  return [g.rerun, g.settings, g.DIVIDER, g.print, ...ScreenCastRecorder.isSupportedBrowser() ? [g.recordScreencast] : [], g.DIVIDER, g.report, g.community, ...i.length > 0 ? i : [g.DIVIDER], g.about];
}
function MainMenu(o) {
  const i = useEmotionTheme(), g = !o.isServerConnected, E = {
    DIVIDER: {
      isDivider: !0
    },
    rerun: {
      disabled: g,
      onClick: o.quickRerunCallback,
      label: "Rerun",
      shortcut: "r"
    },
    print: {
      onClick: o.printCallback,
      label: "Print"
    },
    recordScreencast: {
      onClick: o.screencastCallback,
      label: SCREENCAST_LABEL[o.screenCastState] || "Record a screencast",
      shortcut: SCREENCAST_LABEL[o.screenCastState] ? "esc" : "",
      stopRecordingIndicator: !!SCREENCAST_LABEL[o.screenCastState]
    },
    ...!o.menuItems?.hideGetHelp && o.menuItems?.getHelpUrl && {
      community: {
        onClick: getOpenInWindowCallback(o.menuItems?.getHelpUrl),
        label: "Get help"
      }
    },
    ...!o.menuItems?.hideReportABug && o.menuItems?.reportABugUrl && {
      report: {
        onClick: getOpenInWindowCallback(o.menuItems?.reportABugUrl),
        label: "Report a bug"
      }
    },
    settings: {
      onClick: o.settingsCallback,
      label: "Settings"
    },
    ...o.menuItems?.aboutSectionMd && {
      about: {
        onClick: o.aboutCallback,
        label: "About"
      }
    }
  }, e = {
    DIVIDER: {},
    developerOptions: {
      label: "Developer options",
      noHighlight: !0,
      interactions: {},
      styleProps: {
        fontSize: convertRemToPx(i.fontSizes.twoSm),
        margin: `-${i.spacing.sm} 0 0 0`,
        padding: `${i.spacing.twoXS} ${i.spacing.none} ${i.spacing.twoXS} ${i.spacing.twoXL}`,
        pointerEvents: "none"
      }
    },
    clearCache: {
      disabled: g,
      onClick: o.clearCacheCallback,
      label: "Clear cache",
      shortcut: "c"
    }
  }, t = o.hostMenuItems.map((p) => p.type === "separator" ? E.DIVIDER : p.key === "reportBug" && o.menuItems?.hideGetHelp || p.key === "about" && o.menuItems?.aboutSectionMd !== "" ? null : {
    onClick: () => o.sendMessageToHost({
      type: "MENU_ITEM_CALLBACK",
      key: p.key
    }),
    label: p.label
  }, []), n = getPreferredMenuOrder(o, t, E), h = [];
  let d = null;
  for (const p of n)
    p && (p !== E.DIVIDER && (d === E.DIVIDER ? h.push({
      ...p,
      hasDividerAbove: !0
    }) : h.push(p)), d = p);
  const k = o.developmentMode ? getDevMenuItems(i, e) : [];
  return h.length == 0 && k.length == 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulPopover, { focusLock: !0, placement: PLACEMENT$1.bottomRight, content: ({
    close: p
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMenuContainer, { children: [
    h.length != 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(SubMenu, { menuItems: h, closeMenu: p, isDevMenu: !1, metricsMgr: o.metricsMgr }),
    k.length != 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(SubMenu, { menuItems: k, closeMenu: p, isDevMenu: !0, metricsMgr: o.metricsMgr })
  ] }), overrides: {
    Body: {
      props: {
        "data-testid": "stMainMenuPopover",
        className: "stMainMenuPopover"
      }
    }
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMainMenuContainer, { id: "MainMenu", className: "stMainMenu", "data-testid": "stMainMenu", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: MoreVert, size: "lg" }) }),
    o.screenCastState === "RECORDING" && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledRecordingIndicator, {})
  ] }) });
}
const MainMenu$1 = memo(MainMenu);
function hasClass(o, i) {
  return o.classList ? !!i && o.classList.contains(i) : (" " + (o.className.baseVal || o.className) + " ").indexOf(" " + i + " ") !== -1;
}
function addClass(o, i) {
  o.classList ? o.classList.add(i) : hasClass(o, i) || (typeof o.className == "string" ? o.className = o.className + " " + i : o.setAttribute("class", (o.className && o.className.baseVal || "") + " " + i));
}
function replaceClassName(o, i) {
  return o.replace(new RegExp("(^|\\s)" + i + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(o, i) {
  o.classList ? o.classList.remove(i) : typeof o.className == "string" ? o.className = replaceClassName(o.className, i) : o.setAttribute("class", replaceClassName(o.className && o.className.baseVal || "", i));
}
const config = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null, classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function o(i) {
  return i.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ (function(o) {
  _inheritsLoose(i, o);
  function i(E, e) {
    var t;
    t = o.call(this, E, e) || this;
    var n = e, h = n && !n.isMounting ? E.enter : E.appear, d;
    return t.appearStatus = null, E.in ? h ? (d = EXITED, t.appearStatus = ENTERING) : d = ENTERED : E.unmountOnExit || E.mountOnEnter ? d = UNMOUNTED : d = EXITED, t.state = {
      status: d
    }, t.nextCallback = null, t;
  }
  i.getDerivedStateFromProps = function(e, t) {
    var n = e.in;
    return n && t.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var g = i.prototype;
  return g.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, g.componentDidUpdate = function(e) {
    var t = null;
    if (e !== this.props) {
      var n = this.state.status;
      this.props.in ? n !== ENTERING && n !== ENTERED && (t = ENTERING) : (n === ENTERING || n === ENTERED) && (t = EXITING);
    }
    this.updateStatus(!1, t);
  }, g.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, g.getTimeouts = function() {
    var e = this.props.timeout, t, n, h;
    return t = n = h = e, e != null && typeof e != "number" && (t = e.exit, n = e.enter, h = e.appear !== void 0 ? e.appear : n), {
      exit: t,
      enter: n,
      appear: h
    };
  }, g.updateStatus = function(e, t) {
    if (e === void 0 && (e = !1), t !== null)
      if (this.cancelNextCallback(), t === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var n = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          n && forceReflow(n);
        }
        this.performEnter(e);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, g.performEnter = function(e) {
    var t = this, n = this.props.enter, h = this.context ? this.context.isMounting : e, d = this.props.nodeRef ? [h] : [ReactDOM.findDOMNode(this), h], k = d[0], p = d[1], M = this.getTimeouts(), H = h ? M.appear : M.enter;
    if (!e && !n || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        t.props.onEntered(k);
      });
      return;
    }
    this.props.onEnter(k, p), this.safeSetState({
      status: ENTERING
    }, function() {
      t.props.onEntering(k, p), t.onTransitionEnd(H, function() {
        t.safeSetState({
          status: ENTERED
        }, function() {
          t.props.onEntered(k, p);
        });
      });
    });
  }, g.performExit = function() {
    var e = this, t = this.props.exit, n = this.getTimeouts(), h = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!t || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        e.props.onExited(h);
      });
      return;
    }
    this.props.onExit(h), this.safeSetState({
      status: EXITING
    }, function() {
      e.props.onExiting(h), e.onTransitionEnd(n.exit, function() {
        e.safeSetState({
          status: EXITED
        }, function() {
          e.props.onExited(h);
        });
      });
    });
  }, g.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, g.safeSetState = function(e, t) {
    t = this.setNextCallback(t), this.setState(e, t);
  }, g.setNextCallback = function(e) {
    var t = this, n = !0;
    return this.nextCallback = function(h) {
      n && (n = !1, t.nextCallback = null, e(h));
    }, this.nextCallback.cancel = function() {
      n = !1;
    }, this.nextCallback;
  }, g.onTransitionEnd = function(e, t) {
    this.setNextCallback(t);
    var n = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this), h = e == null && !this.props.addEndListener;
    if (!n || h) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var d = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback], k = d[0], p = d[1];
      this.props.addEndListener(k, p);
    }
    e != null && setTimeout(this.nextCallback, e);
  }, g.render = function() {
    var e = this.state.status;
    if (e === UNMOUNTED)
      return null;
    var t = this.props, n = t.children;
    t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef;
    var h = _objectWithoutPropertiesLoose$q(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof n == "function" ? n(e, h) : React__default.cloneElement(React__default.Children.only(n), h))
    );
  }, i;
})(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(o, i, g, E, e, t) {
      var n = o[i];
      return PropTypes.instanceOf(n && "ownerDocument" in n ? n.ownerDocument.defaultView.Element : Element)(o, i, g, E, e, t);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function o(i) {
    var g = timeoutsShape;
    i.addEndListener || (g = g.isRequired);
    for (var E = arguments.length, e = new Array(E > 1 ? E - 1 : 0), t = 1; t < E; t++)
      e[t - 1] = arguments[t];
    return g.apply(void 0, [i].concat(e));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _addClass = function o(i, g) {
  return i && g && g.split(" ").forEach(function(E) {
    return addClass(i, E);
  });
}, removeClass = function o(i, g) {
  return i && g && g.split(" ").forEach(function(E) {
    return removeClass$1(i, E);
  });
}, CSSTransition = /* @__PURE__ */ (function(o) {
  _inheritsLoose(i, o);
  function i() {
    for (var E, e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return E = o.call.apply(o, [this].concat(t)) || this, E.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, E.onEnter = function(h, d) {
      var k = E.resolveArguments(h, d), p = k[0], M = k[1];
      E.removeClasses(p, "exit"), E.addClass(p, M ? "appear" : "enter", "base"), E.props.onEnter && E.props.onEnter(h, d);
    }, E.onEntering = function(h, d) {
      var k = E.resolveArguments(h, d), p = k[0], M = k[1], H = M ? "appear" : "enter";
      E.addClass(p, H, "active"), E.props.onEntering && E.props.onEntering(h, d);
    }, E.onEntered = function(h, d) {
      var k = E.resolveArguments(h, d), p = k[0], M = k[1], H = M ? "appear" : "enter";
      E.removeClasses(p, H), E.addClass(p, H, "done"), E.props.onEntered && E.props.onEntered(h, d);
    }, E.onExit = function(h) {
      var d = E.resolveArguments(h), k = d[0];
      E.removeClasses(k, "appear"), E.removeClasses(k, "enter"), E.addClass(k, "exit", "base"), E.props.onExit && E.props.onExit(h);
    }, E.onExiting = function(h) {
      var d = E.resolveArguments(h), k = d[0];
      E.addClass(k, "exit", "active"), E.props.onExiting && E.props.onExiting(h);
    }, E.onExited = function(h) {
      var d = E.resolveArguments(h), k = d[0];
      E.removeClasses(k, "exit"), E.addClass(k, "exit", "done"), E.props.onExited && E.props.onExited(h);
    }, E.resolveArguments = function(h, d) {
      return E.props.nodeRef ? [E.props.nodeRef.current, h] : [h, d];
    }, E.getClassNames = function(h) {
      var d = E.props.classNames, k = typeof d == "string", p = k && d ? d + "-" : "", M = k ? "" + p + h : d[h], H = k ? M + "-active" : d[h + "Active"], f = k ? M + "-done" : d[h + "Done"];
      return {
        baseClassName: M,
        activeClassName: H,
        doneClassName: f
      };
    }, E;
  }
  var g = i.prototype;
  return g.addClass = function(e, t, n) {
    var h = this.getClassNames(t)[n + "ClassName"], d = this.getClassNames("enter"), k = d.doneClassName;
    t === "appear" && n === "done" && k && (h += " " + k), n === "active" && e && forceReflow(e), h && (this.appliedClasses[t][n] = h, _addClass(e, h));
  }, g.removeClasses = function(e, t) {
    var n = this.appliedClasses[t], h = n.base, d = n.active, k = n.done;
    this.appliedClasses[t] = {}, h && removeClass(e, h), d && removeClass(e, d), k && removeClass(e, k);
  }, g.render = function() {
    var e = this.props;
    e.classNames;
    var t = _objectWithoutPropertiesLoose$q(e, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition, _extends$C({}, t, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, i;
})(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$C({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var ConnectionState = /* @__PURE__ */ ((o) => (o.CONNECTED = "CONNECTED", o.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", o.INITIAL = "INITIAL", o.PINGING_SERVER = "PINGING_SERVER", o.CONNECTING = "CONNECTING", o.STATIC_CONNECTING = "STATIC_CONNECTING", o.STATIC_CONNECTED = "STATIC_CONNECTED", o))(ConnectionState || {});
const IS_DEV_ENV = !1;
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let o, i;
  const g = new Promise((E, e) => {
    o = E, i = e;
  });
  return {
    resolve: o,
    reject: i,
    promise: g
  };
});
function A(o) {
  const i = document.cookie.match(`\\b${o}=([^;]*)\\b`);
  return i ? i[1] : void 0;
}
function S(o) {
  return Array.isArray(o) && o.length > 0 && o.every((i) => typeof i == "string" && i.trim().length > 0);
}
function l(o) {
  return typeof structuredClone == "function" ? structuredClone(o) : JSON.parse(JSON.stringify(o));
}
function c(o) {
  return Object.freeze(o), Array.isArray(o) ? o.forEach((i) => {
    i !== null && typeof i == "object" && !Object.isFrozen(i) && c(i);
  }) : Object.values(o).forEach((i) => {
    i !== null && typeof i == "object" && !Object.isFrozen(i) && c(i);
  }), o;
}
const r$1 = (() => {
  const o = window.__streamlit;
  if (!o) return;
  const i = l(o);
  return c(i);
})(), N$1 = {
  get BACKEND_BASE_URL() {
    return r$1?.BACKEND_BASE_URL;
  },
  get DOWNLOAD_ASSETS_BASE_URL() {
    return r$1?.DOWNLOAD_ASSETS_BASE_URL;
  },
  get HOST_CONFIG() {
    return r$1?.HOST_CONFIG;
  }
};
function L$1(o) {
  return o != null;
}
const _ = /\/+$/, u = /^\/+/;
function a({
  hostname: o,
  port: i,
  pathname: g,
  protocol: E
}, e) {
  const t = s(g, e);
  return `${E}//${o}${i ? `:${i}` : ""}/${t}`;
}
function s(o, i) {
  return o = o.replace(_, "").replace(u, ""), i = i.replace(_, "").replace(u, ""), o.length === 0 ? i : `${o}/${i}`;
}
loglevelExports$1.getLogger("StaticConnection");
const FINAL_SLASH_RE = /\/+$/, INITIAL_SLASH_RE = /^\/+/;
function isHostConfigBypassEnabled() {
  const o = N$1.HOST_CONFIG;
  if (!o)
    return !1;
  const {
    allowedOrigins: i,
    useExternalAuthToken: g
  } = o, E = !!N$1.BACKEND_BASE_URL, e = S(i);
  return E && e && typeof g == "boolean";
}
function parseUriIntoBaseParts(o) {
  const i = new URL(window.location.href === "about:blank" ? "" : window.location.href);
  return i.pathname = i.pathname.replace(FINAL_SLASH_RE, "").replace(INITIAL_SLASH_RE, ""), i;
}
loglevelExports$1.getLogger("DoInitPings");
loglevelExports$1.getLogger("ForwardMessageCache");
loglevelExports$1.getLogger("WebsocketConnection");
loglevelExports$1.getLogger("ConnectionManager");
const LOG$3 = loglevelExports$1.getLogger("DefaultStreamlitEndpoints"), MEDIA_ENDPOINT = "/media", UPLOAD_FILE_ENDPOINT = "/_stcore/upload_file", COMPONENT_ENDPOINT_BASE = "/component", BIDI_COMPONENT_ENDPOINT_BASE = "/_stcore/bidi-components";
class DefaultStreamlitEndpoints {
  constructor(i) {
    this.getServerUri = i.getServerUri, this.csrfEnabled = i.csrfEnabled, this.sendClientError = i.sendClientError, this.staticConfigUrl = null;
  }
  setStaticConfigUrl(i) {
    this.staticConfigUrl = i;
  }
  sendClientErrorToHost(i, g, E, e, t) {
    this.sendClientError(i, g, E, e, t);
  }
  /**
   * Check the source of a component for successful response (for those without onerror event)
   * If the response is not ok, or fetch otherwise fails, send an error to the host.
   */
  async checkSourceUrlResponse(i, g, E) {
    const e = E ? `${g} ${E}` : g;
    try {
      const t = await fetch(i);
      t.ok || (LOG$3.error(`Client Error: ${e} source error - ${t.status}`), this.sendClientErrorToHost(g, t.status, t.statusText, i, E));
    } catch (t) {
      const n = t instanceof Error ? t.message : "Unknown Error";
      LOG$3.error(`Client Error: ${e} fetch error - ${n}`), this.sendClientErrorToHost(g, "Error fetching source", n, i, E);
    }
  }
  buildComponentURL(i, g) {
    return a(this.requireServerUri(), `${COMPONENT_ENDPOINT_BASE}/${i}/${g}`);
  }
  buildBidiComponentURL(i, g) {
    return a(this.requireServerUri(), `${BIDI_COMPONENT_ENDPOINT_BASE}/${i}/${g}`);
  }
  setFileUploadClientConfig({
    prefix: i,
    headers: g
  }) {
    this.fileUploadClientConfig = {
      prefix: i,
      headers: g
    };
  }
  /**
   * If we are using a static connection, return S3 URL for that file. Otherwise, return null.
   */
  buildStaticUrl(i) {
    const E = new URLSearchParams(document.location.search).get("staticAppId");
    return `${this.staticConfigUrl}/${E}${i}`;
  }
  /**
   * Construct a URL for a media file. If the `staticConfigUrl` is set, we have a static app
   * and will serve media from S3. If the url is relative and starts with  "/media",
   * assume it's being served from Streamlit and construct it appropriately.
   * Otherwise leave it alone.
   */
  buildMediaURL(i) {
    return this.staticConfigUrl && i.startsWith(MEDIA_ENDPOINT) ? this.buildStaticUrl(i) : i.startsWith(MEDIA_ENDPOINT) ? a(this.requireServerUri(), i) : i;
  }
  /**
   * Construct a URL for a download file.
   * @param url a relative or absolute URL. If `url` is absolute, it will be
   * returned unchanged. Otherwise, the return value will be a URL for fetching
   * the media file from the connected Streamlit instance. The target server can
   * be changed by setting StreamlitConfig.DOWNLOAD_ASSETS_BASE_URL.
   */
  buildDownloadUrl(i) {
    if (!i.startsWith(MEDIA_ENDPOINT))
      return i;
    const g = N$1.DOWNLOAD_ASSETS_BASE_URL;
    return a(g ? parseUriIntoBaseParts() : this.requireServerUri(), i);
  }
  /**
   * Construct a URL for uploading a file. If the `fileUploadClientConfig`
   * exists, we build URL by prefixing URL with prefix from the config,
   * otherwise if the `fileUploadClientConfig` is not present, if URL is
   * relative and starts with "/_stcore/upload_file", assume we're uploading
   * the file to the Streamlit Tornado server and construct the URL
   * appropriately. Otherwise, we're probably uploading the file to some
   * external service, so we leave the URL alone.
   */
  buildFileUploadURL(i) {
    return this.fileUploadClientConfig ? s(this.fileUploadClientConfig.prefix, i) : i.startsWith(UPLOAD_FILE_ENDPOINT) ? a(this.requireServerUri(), i) : i;
  }
  /** Construct a URL for an app page in a multi-page app. */
  buildAppPageURL(i, g) {
    const E = g.urlPathname, e = g.isDefault ? "" : E;
    if (typeof i == "string" && i.length > 0)
      return `${i}/${e}`;
    const {
      port: t,
      protocol: n
    } = window.location, {
      pathname: h,
      hostname: d
    } = this.requireServerUri(), k = t ? `:${t}` : "", p = h === "/" ? "/" : `${h}/`;
    return `${n}//${d}${k}${p}${e}`;
  }
  async uploadFileUploaderFile(i, g, E, e, t) {
    const n = new FormData(), {
      name: h,
      webkitRelativePath: d
    } = g, k = d || h;
    n.append(h, g, k);
    const p = this.getAdditionalHeaders(), M = this.buildFileUploadURL(i);
    try {
      await this.csrfRequest(M, {
        signal: t,
        method: "PUT",
        data: n,
        responseType: "text",
        headers: p,
        onUploadProgress: e
      });
    } catch (H) {
      LOG$3.error(`Client Error: File uploader error on file upload - ${H}`);
      const f = H instanceof Error ? H.message : "Unknown Error";
      throw this.sendClientErrorToHost("File Uploader", "Error uploading file", f, M), H;
    }
  }
  getAdditionalHeaders() {
    let i = {};
    return this.fileUploadClientConfig && (i = {
      ...i,
      ...this.fileUploadClientConfig.headers
    }), i;
  }
  /**
   * Send an HTTP DELETE request to the given URL.
   */
  async deleteFileAtURL(i, g) {
    const E = this.getAdditionalHeaders(), e = this.buildFileUploadURL(i);
    try {
      await this.csrfRequest(e, {
        method: "DELETE",
        data: {
          sessionId: g
        },
        headers: E
      });
    } catch (t) {
      LOG$3.error(`Client Error: File uploader error on file delete - ${t}`);
      const n = t instanceof Error ? t.message : "Unknown Error";
      throw this.sendClientErrorToHost("File Uploader", "Error deleting file", n, e), t;
    }
  }
  /**
   * Fetch the server URI. If our server is disconnected, default to the most
   * recent cached value of the URI. If we're disconnected and have no cached
   * value, throw an Error.
   */
  requireServerUri() {
    const i = this.getServerUri();
    if (L$1(i))
      return this.cachedServerUri = i, i;
    if (L$1(this.cachedServerUri))
      return this.cachedServerUri;
    throw new Error("not connected to a server!");
  }
  /**
   * Wrapper around axios.request to update the request config with
   * CSRF headers if client has CSRF protection enabled.
   * Uses dynamic import to load axios only when needed (file upload/delete operations).
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  async csrfRequest(i, g) {
    if (g.url = i, this.csrfEnabled) {
      const e = A("_streamlit_xsrf");
      L$1(e) && (g.headers = {
        "X-Xsrftoken": e,
        ...g.headers || {}
      }, g.withCredentials = !0);
    }
    const {
      default: E
    } = await import("./index-BwXCTp7d.js");
    return E.request(g);
  }
}
var Ellipses = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0 3v2h2V3H0zm3 0v2h2V3H3zm3 0v2h2V3H6z"
  }));
});
Ellipses.displayName = "Ellipses";
var Warning = /* @__PURE__ */ React.forwardRef(function(o, i) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, o, {
    ref: i
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M3.09 0c-.06 0-.1.04-.13.09L.02 6.9c-.02.05-.03.13-.03.19v.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-.81c0-.05-.01-.14-.03-.19L4.01.09A.142.142 0 003.88 0h-.81zM3 3h1v2H3V3zm0 3h1v1H3V6z"
  }));
});
Warning.displayName = "Warning";
const CONNECTING_LABEL = "Connecting", CONNECTING_TOOLTIP_TEXT = "Connecting to Streamlit server", CONNECTING_STATIC_TOOLTIP_TEXT = "Connecting to static app", ERROR_LABEL = "Error", ERROR_TOOLTIP_TEXT = "Unable to connect to Streamlit server";
function getConnectionStateUI(o) {
  switch (o) {
    case ConnectionState.INITIAL:
    case ConnectionState.PINGING_SERVER:
    case ConnectionState.CONNECTING:
      return {
        icon: Ellipses,
        label: CONNECTING_LABEL,
        tooltip: CONNECTING_TOOLTIP_TEXT
      };
    case ConnectionState.CONNECTED:
      return;
    case ConnectionState.STATIC_CONNECTING:
      return {
        icon: Ellipses,
        label: CONNECTING_LABEL,
        tooltip: CONNECTING_STATIC_TOOLTIP_TEXT
      };
    case ConnectionState.STATIC_CONNECTED:
      return;
    case ConnectionState.DISCONNECTED_FOREVER:
    default:
      return {
        icon: Warning,
        label: ERROR_LABEL,
        tooltip: ERROR_TOOLTIP_TEXT
      };
  }
}
const newYearsRunning = "data:image/gif;base64,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";
function _EMOTION_STRINGIFIED_CSS_ERROR__$5() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledConnectionStatus = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib67"
} : {
  target: "en6cib67",
  label: "StyledConnectionStatus"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: o.colors.gray60
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledConnectionStatusLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "en6cib66"
} : {
  target: "en6cib66",
  label: "StyledConnectionStatusLabel"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.sm,
  color: o.colors.gray60,
  textTransform: "uppercase",
  marginTop: o.spacing.none,
  marginRight: o.spacing.lg,
  marginBottom: o.spacing.none,
  marginLeft: o.spacing.sm,
  whiteSpace: "nowrap",
  maxWidth: o.sizes.appStatusMaxWidth,
  lineHeight: o.lineHeights.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdGF0dXNXaWRnZXQvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0IyQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvU3RhdHVzV2lkZ2V0L3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbi8qXG4gIFwiQ29ubmVjdGlvblN0YXR1c1wiIHN0eWxlcyBhcmUgdXNlZCBmb3IgZGlzcGxheWluZ1xuICB0aGUgc3RhdHVzIG9mIG91ciBjb25uZWN0aW9uIHRvIHRoZSBzZXJ2ZXIgKGNvbm5lY3RlZCxcbiAgZGlzY29ubmVjdGVkLCBlcnJvciwgZXRjKS5cbiovXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb25uZWN0aW9uU3RhdHVzID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTYwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb25uZWN0aW9uU3RhdHVzTGFiZWwgPSBzdHlsZWQubGFiZWwoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIHRleHRUcmFuc2Zvcm06IFwidXBwZXJjYXNlXCIsXG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIG1heFdpZHRoOiB0aGVtZS5zaXplcy5hcHBTdGF0dXNNYXhXaWR0aCxcbiAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMubm9uZSxcbn0pKVxuXG4vKlxuICBcIkFwcFN0YXR1c1wiIHN0eWxlcyBhcmUgZm9yIGFwcC1yZWxhdGVkIHN0YXR1c2VzOlxuICB3aGV0aGVyIGl0J3MgcnVubmluZywgaWYgdGhlIHNvdXJjZSBmaWxlIGhhcyBjaGFuZ2VkIG9uIGRpc2ssXG4gIGV0Yy5cbiovXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBcHBTdGF0dXMgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZCxcbiAgbWFyZ2luOiBgMCAke3RoZW1lLnNwYWNpbmcuc219IDAgMGAsXG4gIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICBoZWlnaHQ6IHRoZW1lLnNpemVzLmFwcFJ1bm5pbmdNZW4sXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRBcHBTdGF0dXNMYWJlbFByb3BzIHtcbiAgaXNQcm9tcHQ6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFwcFN0YXR1c0xhYmVsID0gc3R5bGVkLmxhYmVsPFN0eWxlZEFwcFN0YXR1c0xhYmVsUHJvcHM+KFxuICAoeyBpc1Byb21wdCwgdGhlbWUgfSkgPT4gKHtcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIGNvbG9yOiBpc1Byb21wdCA/IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCA6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgdGV4dFRyYW5zZm9ybTogaXNQcm9tcHQgPyBcIm5vbmVcIiA6IFwidXBwZXJjYXNlXCIsXG4gICAgbWFyZ2luOiBgMCAwIDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuYXBwU3RhdHVzTWF4V2lkdGgsXG4gICAgYm9yZGVyUmFkaXVzOiBpc1Byb21wdCA/IHRoZW1lLnJhZGlpLm1kIDogdW5kZWZpbmVkLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQXBwQnV0dG9uQ29udGFpbmVyID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5tZCxcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbn0pKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZEFwcFJ1bm5pbmdJY29uUHJvcHMge1xuICBpc05ld1llYXJzOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBcHBSdW5uaW5nSWNvbiA9IHN0eWxlZC5kaXY8U3R5bGVkQXBwUnVubmluZ0ljb25Qcm9wcz4oXG4gICh7IGlzTmV3WWVhcnMsIHRoZW1lIH0pID0+IHtcbiAgICAvLyBOZXcgeWVhcnMgZ2lmIGhhcyB1bmlxdWUgc3R5bGluZyAtIHJlZ3VsYXIgcnVubmluZyBtYW4gdW5jaGFuZ2VkXG4gICAgcmV0dXJuIHtcbiAgICAgIHdpZHRoOiBpc05ld1llYXJzID8gXCIyLjJyZW1cIiA6IHRoZW1lLnNpemVzLmFwcFJ1bm5pbmdNZW4sXG4gICAgICBoZWlnaHQ6IGlzTmV3WWVhcnMgPyBcIjIuMnJlbVwiIDogdGhlbWUuc2l6ZXMuYXBwUnVubmluZ01lbixcbiAgICAgIG1hcmdpblJpZ2h0OiBgLSR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMC4zcyBlYXNlLWluLW91dFwiLFxuICAgICAgY3Vyc29yOiBcIndhaXRcIixcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YXR1c1dpZGdldCA9IHN0eWxlZC5kaXYoe1xuICBcIiYuU3RhdHVzV2lkZ2V0LWFwcGVhclwiOiB7XG4gICAgb3BhY2l0eTogMCxcbiAgfSxcblxuICBcIiYuU3RhdHVzV2lkZ2V0LWFwcGVhci1hY3RpdmVcIjoge1xuICAgIG9wYWNpdHk6IDEsXG4gICAgdHJhbnNpdGlvbjogXCJvcGFjaXR5IDIwMG1zIGVhc2Utb3V0XCIsXG4gIH0sXG5cbiAgXCImLlN0YXR1c1dpZGdldC1lbnRlclwiOiB7XG4gICAgb3BhY2l0eTogMCxcbiAgfSxcblxuICBcIiYuU3RhdHVzV2lkZ2V0LWVudGVyLWFjdGl2ZVwiOiB7XG4gICAgb3BhY2l0eTogMSxcbiAgICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMjAwbXMgZWFzZS1vdXRcIixcbiAgfSxcblxuICBcIiYuU3RhdHVzV2lkZ2V0LWV4aXRcIjoge1xuICAgIG9wYWNpdHk6IDEsXG4gIH0sXG5cbiAgXCImLlN0YXR1c1dpZGdldC1leGl0LWFjdGl2ZVwiOiB7XG4gICAgb3BhY2l0eTogMCxcbiAgICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMjAwbXMgZWFzZS1vdXRcIixcbiAgfSxcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaG9ydGN1dExhYmVsID0gc3R5bGVkLmRpdih7XG4gIFwiJjo6Zmlyc3QtbGV0dGVyXCI6IHtcbiAgICB0ZXh0RGVjb3JhdGlvbjogXCJ1bmRlcmxpbmVcIixcbiAgfSxcbn0pXG4iXX0= */"), StyledAppStatus = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib65"
} : {
  target: "en6cib65",
  label: "StyledAppStatus"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: o.radii.md,
  margin: `0 ${o.spacing.sm} 0 0`,
  paddingLeft: o.spacing.sm,
  height: o.sizes.appRunningMen
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppStatusLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "en6cib64"
} : {
  target: "en6cib64",
  label: "StyledAppStatusLabel"
})(({
  isPrompt: o,
  theme: i
}) => ({
  fontSize: i.fontSizes.sm,
  color: o ? i.colors.bodyText : i.colors.gray60,
  textTransform: o ? "none" : "uppercase",
  margin: `0 0 0 ${i.spacing.sm}`,
  whiteSpace: "nowrap",
  maxWidth: i.sizes.appStatusMaxWidth,
  borderRadius: o ? i.radii.md : void 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppButtonContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "en6cib63"
} : {
  target: "en6cib63",
  label: "StyledAppButtonContainer"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.md,
  whiteSpace: "nowrap",
  color: o.colors.bodyText
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppRunningIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib62"
} : {
  target: "en6cib62",
  label: "StyledAppRunningIcon"
})(({
  isNewYears: o,
  theme: i
}) => ({
  width: o ? "2.2rem" : i.sizes.appRunningMen,
  height: o ? "2.2rem" : i.sizes.appRunningMen,
  marginRight: `-${i.spacing.sm}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "opacity 0.3s ease-in-out",
  cursor: "wait"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStatusWidget = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib61"
} : {
  target: "en6cib61",
  label: "StyledStatusWidget"
})(process.env.NODE_ENV === "production" ? {
  name: "19or5k2",
  styles: "&.StatusWidget-appear{opacity:0;}&.StatusWidget-appear-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-enter{opacity:0;}&.StatusWidget-enter-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-exit{opacity:1;}&.StatusWidget-exit-active{opacity:0;transition:opacity 200ms ease-out;}"
} : {
  name: "19or5k2",
  styles: "&.StatusWidget-appear{opacity:0;}&.StatusWidget-appear-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-enter{opacity:0;}&.StatusWidget-enter-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-exit{opacity:1;}&.StatusWidget-exit-active{opacity:0;transition:opacity 200ms ease-out;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
}), StyledShortcutLabel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib60"
} : {
  target: "en6cib60",
  label: "StyledShortcutLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "jdyw56",
  styles: "&::first-letter{text-decoration:underline;}"
} : {
  name: "jdyw56",
  styles: "&::first-letter{text-decoration:underline;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
}), icons = [{
  component: AccessibleForward,
  name: "accessible-forward"
}, {
  component: AccessibilityNew,
  name: "accessibility-new"
}, {
  component: DirectionsBike,
  name: "directions-bike"
}, {
  component: DirectionsRun,
  name: "directions-run"
}, {
  component: Pool,
  name: "pool"
}, {
  component: Rowing,
  name: "rowing"
}], isNewYears = () => {
  const o = /* @__PURE__ */ new Date(), i = o.getMonth(), g = o.getDate();
  return i === 11 && g === 31 || i === 0 && g <= 6;
}, DEFAULT_SPEED = 200, IconRunning = () => {
  const [o, i] = useState(0), g = useEmotionTheme(), E = useMemo$1(() => isNewYears(), []);
  useEffect(() => {
    if (E) return;
    const n = setInterval(() => {
      i((h) => (h + 1) % icons.length);
    }, DEFAULT_SPEED);
    return () => clearInterval(n);
  }, [E]);
  const t = icons[o].component;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppRunningIcon, { isNewYears: E, "aria-label": "Running...", role: "img", "data-testid": "stStatusWidgetRunningIcon", children: E ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: newYearsRunning, alt: "New Year's Celebration", style: {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  }, "data-testid": "stStatusWidgetNewYearsIcon" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(t, { color: g.colors.fadedText60, "aria-hidden": "true", "data-testid": "stStatusWidgetRunningManIcon", style: {
    width: g.sizes.appRunningMen,
    height: g.sizes.appRunningMen
  } }) });
}, RUNNING_MAN_DISPLAY_DELAY_TIME_MS = 500, PromptButton = (o) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_BUTTON, disabled: o.disabled, containerWidth: !0, onClick: o.onClick, children: o.title }) }), StatusWidget = ({
  connectionState: o,
  scriptRunState: i,
  rerunScript: g,
  stopScript: E,
  allowRunOnSave: e,
  showScriptChangedActions: t
}) => {
  const [n, h] = useState(!1), d = useRef(null), k = useRef(null), p = useEmotionTheme(), M = () => {
    e && g(!0);
  }, H = (cA, tA) => {
    cA === "a" && !isKeyboardEventFromEditableTarget(tA) && M();
  }, f = o === ConnectionState.CONNECTED, AA = useCallback((cA) => {
    k.current !== null && k.current.setTimeout(() => {
      h(!0);
    }, cA);
  }, []), gA = () => {
    E();
  }, IA = () => {
    g(!1);
  };
  useEffect(() => {
    d.current === null && (d.current = new Timer()), k.current === null && (k.current = new Timer());
    const cA = d.current, tA = d.current;
    return () => {
      cA.cancel(), tA.cancel();
    };
  }, []), useEffect(() => {
    f && (i === ScriptRunState.RUNNING || i === ScriptRunState.RERUN_REQUESTED) && AA(RUNNING_MAN_DISPLAY_DELAY_TIME_MS), i === ScriptRunState.NOT_RUNNING && h(!1);
  }, [i, AA, f]);
  const BA = () => {
    const cA = i === ScriptRunState.STOP_REQUESTED;
    return n ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppStatus, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconRunning, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: cA ? "Stopping..." : "Stop", disabled: cA, onClick: gA })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  }, CA = () => {
    const cA = i === ScriptRunState.RERUN_REQUESTED;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ReactHotkeys, { keyName: "a", onKeyDown: H, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppStatus, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/info:", color: p.colors.fadedText60 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppStatusLabel, { isPrompt: !0, children: "File change." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledShortcutLabel, { children: "Rerun" }), disabled: cA, onClick: IA }),
      e && /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledShortcutLabel, { children: "Always rerun" }), disabled: cA, onClick: M })
    ] }) });
  }, QA = () => {
    const cA = getConnectionStateUI(o);
    return cA === void 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: cA.tooltip, placement: Placement.BOTTOM, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledConnectionStatus, { className: "stConnectionStatus", "data-testid": "stConnectionStatus", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { size: "sm", content: cA.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledConnectionStatusLabel, { children: cA.label })
    ] }) });
  }, iA = () => {
    if (f) {
      if (i === ScriptRunState.RUNNING || i === ScriptRunState.RERUN_REQUESTED)
        return BA();
      if (t)
        return CA();
    }
    return QA();
  }, EA = useRef(), oA = EA.current;
  if (EA.current = iA(), isNullOrUndefined(EA.current) && isNullOrUndefined(oA))
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  let eA, GA;
  return notNullOrUndefined(EA.current) ? (eA = !0, GA = EA.current) : (eA = !1, GA = oA), /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, { appear: !0, in: eA, timeout: 200, unmountOnExit: !0, classNames: "StatusWidget", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStatusWidget, { className: "stStatusWidget", "data-testid": "stStatusWidget", children: GA }, "StatusWidget") });
}, StreamlitContextProvider = ({
  // ViewStateContext
  isFullScreen: o,
  setFullScreen: i,
  // LibConfigContext
  locale: g,
  mapboxToken: E,
  enforceDownloadInNewTab: e,
  resourceCrossOriginMode: t,
  showErrorLinks: n,
  // NavigationContext
  pageLinkBaseUrl: h,
  currentPageScriptHash: d,
  onPageChange: k,
  navSections: p,
  appPages: M,
  // SidebarConfigContext
  initialSidebarState: H,
  initialSidebarWidth: f,
  appLogo: AA,
  sidebarChevronDownshift: gA,
  expandSidebarNav: IA,
  hideSidebarNav: BA,
  appRootRef: CA,
  // ThemeContext
  activeTheme: QA,
  setTheme: iA,
  availableThemes: EA,
  // ScriptRunContext
  scriptRunState: oA,
  scriptRunId: eA,
  fragmentIdsThisRun: GA,
  // FormsContext
  formsData: cA,
  // DownloadContext
  requestDeferredFile: tA,
  // Children passed through
  children: aA
}) => {
  const sA = useMemo$1(() => ({
    locale: g,
    mapboxToken: E,
    enforceDownloadInNewTab: e,
    resourceCrossOriginMode: t,
    showErrorLinks: n
  }), [g, E, e, t, n]), DA = useMemo$1(() => ({
    initialSidebarState: H,
    initialSidebarWidth: f,
    appLogo: AA,
    sidebarChevronDownshift: gA,
    expandSidebarNav: IA,
    hideSidebarNav: BA,
    appRootRef: CA
  }), [H, f, AA, gA, IA, BA, CA]), rA = useMemo$1(() => ({
    activeTheme: QA,
    setTheme: iA,
    availableThemes: EA
  }), [QA, iA, EA]), nA = useMemo$1(() => ({
    pageLinkBaseUrl: h,
    currentPageScriptHash: d,
    onPageChange: k,
    navSections: p,
    appPages: M
  }), [h, d, k, p, M]), NA = useMemo$1(() => ({
    isFullScreen: o,
    setFullScreen: i
  }), [o, i]), pA = useMemo$1(() => ({
    scriptRunState: oA,
    scriptRunId: eA,
    fragmentIdsThisRun: GA
  }), [oA, eA, GA]), mA = useMemo$1(() => ({
    formsData: cA
  }), [cA]), XA = useMemo$1(() => ({
    requestDeferredFile: tA
  }), [tA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LibConfigContext.Provider, { value: sA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarConfigContext.Provider, { value: DA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, { value: rA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavigationContext.Provider, { value: nA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DownloadContext.Provider, { value: XA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ViewStateContext.Provider, { value: NA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScriptRunContext.Provider, { value: pA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormsContext.Provider, { value: mA, children: aA }) }) }) }) }) }) }) });
}, StreamlitContextProvider$1 = memo(StreamlitContextProvider);
var DialogType = /* @__PURE__ */ ((o) => (o.ABOUT = "about", o.CLEAR_CACHE = "clearCache", o.CONNECTION_ERROR = "connectionError", o.SETTINGS = "settings", o.SCRIPT_COMPILE_ERROR = "scriptCompileError", o.THEME_CREATOR = "themeCreator", o.WARNING = "warning", o.DEPLOY_ERROR = "deployError", o.DEPLOY_DIALOG = "deployDialog", o))(DialogType || {}), LevelContext = /* @__PURE__ */ React.createContext(0);
function ownKeys(o, i) {
  var g = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var E = Object.getOwnPropertySymbols(o);
    i && (E = E.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), g.push.apply(g, E);
  }
  return g;
}
function _objectSpread(o) {
  for (var i = 1; i < arguments.length; i++) {
    var g = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(g), !0).forEach(function(E) {
      _defineProperty(o, E, g[E]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(g)) : ownKeys(Object(g)).forEach(function(E) {
      Object.defineProperty(o, E, Object.getOwnPropertyDescriptor(g, E));
    });
  }
  return o;
}
function _defineProperty(o, i, g) {
  return i in o ? Object.defineProperty(o, i, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : o[i] = g, o;
}
var Action = styled("div", function(o) {
  var i = o.$theme;
  return _objectSpread({}, i.typography.LabelMedium);
});
Action.displayName = "Action";
Action.displayName = "Action";
var Body = styled("div", function(o) {
  var i = o.$theme;
  return _objectSpread({
    marginBottom: i.sizing.scale600,
    color: i.colors.contentPrimary
  }, i.typography.ParagraphMedium);
});
Body.displayName = "Body";
Body.displayName = "Body";
var Contents = styled("div", function(o) {
  var i = o.$theme;
  return {
    marginLeft: i.sizing.scale600,
    marginTop: i.sizing.scale600,
    marginRight: i.sizing.scale600,
    marginBottom: i.sizing.scale600
  };
});
Contents.displayName = "Contents";
Contents.displayName = "Contents";
var HeaderImage = styled("img", function(o) {
  var i = o.$theme;
  return {
    borderTopLeftRadius: i.borders.surfaceBorderRadius,
    borderTopRightRadius: i.borders.surfaceBorderRadius,
    objectFit: "contain",
    maxWidth: "100%"
  };
});
HeaderImage.displayName = "HeaderImage";
HeaderImage.displayName = "HeaderImage";
var Root = styled("section", function(o) {
  var i = o.$theme;
  return {
    borderLeftWidth: "2px",
    borderTopWidth: "2px",
    borderRightWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftStyle: "solid",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftColor: i.colors.borderOpaque,
    borderRightColor: i.colors.borderOpaque,
    borderTopColor: i.colors.borderOpaque,
    borderBottomColor: i.colors.borderOpaque,
    borderTopLeftRadius: i.borders.radius400,
    borderTopRightRadius: i.borders.radius400,
    borderBottomLeftRadius: i.borders.radius400,
    borderBottomRightRadius: i.borders.radius400,
    backgroundColor: i.colors.backgroundPrimary,
    overflow: "hidden"
  };
});
Root.displayName = "Root";
Root.displayName = "Root";
var Thumbnail = styled("img", function(o) {
  var i = o.$theme;
  return _objectSpread(_objectSpread({
    float: "right",
    height: i.sizing.scale2400,
    width: i.sizing.scale2400,
    objectFit: "cover",
    borderTopLeftRadius: i.borders.surfaceBorderRadius,
    borderTopRightRadius: i.borders.surfaceBorderRadius,
    borderBottomLeftRadius: i.borders.surfaceBorderRadius,
    borderBottomRightRadius: i.borders.surfaceBorderRadius
  }, expandBorderStyles(i.borders.border200)), {}, {
    margin: "0 0 ".concat(i.sizing.scale500, " ").concat(i.sizing.scale500)
  });
});
Thumbnail.displayName = "Thumbnail";
Thumbnail.displayName = "Thumbnail";
var Title = styled("h1", function(o) {
  var i = o.$theme;
  return _objectSpread(_objectSpread({}, i.typography.HeadingSmall), {}, {
    color: i.colors.contentPrimary,
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: i.sizing.scale500,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0
  });
});
Title.displayName = "Title";
Title.displayName = "Title";
var _excluded = ["children"], _excluded2 = ["action", "children", "hasThumbnail", "headerImage", "thumbnail", "title", "overrides"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(o) {
    for (var i = 1; i < arguments.length; i++) {
      var g = arguments[i];
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && (o[E] = g[E]);
    }
    return o;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(o, i) {
  if (o == null) return {};
  var g = _objectWithoutPropertiesLoose(o, i), E, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      E = t[e], !(i.indexOf(E) >= 0) && Object.prototype.propertyIsEnumerable.call(o, E) && (g[E] = o[E]);
  }
  return g;
}
function _objectWithoutPropertiesLoose(o, i) {
  if (o == null) return {};
  var g = {}, E = Object.keys(o), e, t;
  for (t = 0; t < E.length; t++)
    e = E[t], !(i.indexOf(e) >= 0) && (g[e] = o[e]);
  return g;
}
function hasThumbnail(o) {
  return !!o.thumbnail;
}
var SemanticTitle = function o(i) {
  var g = i.children, E = _objectWithoutProperties(i, _excluded), e = ["", "h1", "h2", "h3", "h4", "h5", "h6"];
  return /* @__PURE__ */ React.createElement(LevelContext.Consumer, null, function(t) {
    return (
      // @ts-expect-error
      /* @__PURE__ */ React.createElement(Title, _extends({
        $as: e[t]
      }, E), g)
    );
  });
};
function Card(o) {
  var i = o.action, g = o.children, E = o.hasThumbnail, e = o.headerImage, t = o.thumbnail, n = o.title, h = o.overrides, d = _objectWithoutProperties(o, _excluded2), k = h.Action, p = h.Body, M = h.Contents, H = h.HeaderImage, f = h.Root, AA = h.Thumbnail, gA = h.Title, IA = getOverride(k) || Action, BA = getOverride(p) || Body, CA = getOverride(M) || Contents, QA = getOverride(H) || HeaderImage, iA = getOverride(f) || Root, EA = getOverride(AA) || Thumbnail, oA = getOverride(gA) || SemanticTitle, eA = typeof e == "string" ? {
    src: e
  } : e, GA = E(o);
  return /* @__PURE__ */ React.createElement(iA, _extends({
    "data-baseweb": "card"
  }, d, getOverrideProps(f)), e && /* @__PURE__ */ React.createElement(QA, _extends({}, eA, getOverrideProps(H))), /* @__PURE__ */ React.createElement(CA, getOverrideProps(M), t && /* @__PURE__ */ React.createElement(EA, _extends({
    src: t
  }, getOverrideProps(AA))), n && /* @__PURE__ */ React.createElement(oA, _extends({
    $hasThumbnail: GA
  }, getOverrideProps(gA)), n), /* @__PURE__ */ React.createElement(BA, getOverrideProps(p), g), i && /* @__PURE__ */ React.createElement(IA, getOverrideProps(k), i)));
}
Card.defaultProps = {
  action: null,
  children: null,
  hasThumbnail,
  overrides: {}
};
const StreamlitLogo = "data:image/svg+xml,%3csvg%20width='32'%20height='19'%20viewBox='0%200%2032%2019'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group%202'%3e%3cpath%20id='path3858'%20d='M15.998%2011.078L10.3882%208.04522L0.650371%202.78157C0.641482%202.77247%200.623705%202.77248%200.614816%202.77248C0.259259%202.59975%20-0.105186%202.96338%200.0281476%203.32702L4.98994%2016.2698L4.99083%2016.2725C4.99616%2016.2852%205.00061%2016.298%205.00594%2016.3107C5.2095%2016.7934%205.65394%2017.0916%206.1375%2017.2089C6.17839%2017.218%206.20764%2017.2262%206.25673%2017.2362C6.30559%2017.2473%206.37394%2017.2625%206.43261%2017.2671C6.44239%2017.268%206.45128%2017.268%206.46106%2017.2689H6.46817C6.47528%2017.2698%206.48239%2017.2698%206.4895%2017.2707H6.49928C6.5055%2017.2716%206.51261%2017.2716%206.51883%2017.2716H6.53039C6.5375%2017.2725%206.54461%2017.2725%206.55172%2017.2725C12.8348%2017.9731%2019.1763%2017.9731%2025.4593%2017.2725C25.5349%2017.2725%2025.6087%2017.2689%2025.6798%2017.2616C25.7029%2017.2589%2025.7251%2017.2562%2025.7473%2017.2534C25.75%2017.2525%2025.7536%2017.2525%2025.7562%2017.2516C25.7713%2017.2498%2025.7864%2017.2471%2025.8016%2017.2443C25.8238%2017.2416%2025.846%2017.2371%2025.8682%2017.2325C25.9127%2017.2225%2025.9329%2017.2152%2025.9932%2017.194C26.0535%2017.1729%2026.1536%2017.1358%2026.2163%2017.1049C26.279%2017.074%2026.3224%2017.0443%2026.3749%2017.0107C26.4398%2016.9689%2026.5015%2016.9261%2026.5641%2016.8781C26.5911%2016.8569%2026.6096%2016.8434%2026.6291%2016.8243L26.6184%2016.818L15.998%2011.078Z'%20fill='%23FF2B2B'/%3e%3cpath%20id='path5063'%20d='M31.3616%202.78158H31.3527L21.6113%208.04524L27.0265%2016.2935L31.9758%203.32704V3.30886C32.1003%202.92704%2031.7181%202.58158%2031.3616%202.78158Z'%20fill='%237D353B'/%3e%3cpath%20id='path5101'%20d='M16.5171%200.278788C16.2682%20-0.0930318%2015.726%20-0.0930318%2015.486%200.278788L10.3882%208.04518L15.998%2011.0779L26.6291%2016.8242C26.6959%2016.7574%2026.7494%2016.6922%2026.806%2016.6234C26.886%2016.5225%2026.9607%2016.4143%2027.0265%2016.2934L21.6113%208.04518L16.5171%200.278788Z'%20fill='%23BD4043'/%3e%3c/g%3e%3c/svg%3e", Rocket = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Frame'%3e%3cpath%20id='Vector'%20d='M5.95077%2010.7642L8.09076%2011.6685C8.34683%2011.157%208.61204%2010.6637%208.8864%2010.1887C9.16076%209.71374%209.46256%209.23875%209.79179%208.76376L8.25538%208.46232L5.95077%2010.7642ZM9.84666%2013.0387L12.9743%2016.1352C13.7426%2015.8429%2014.5656%2015.3954%2015.4436%2014.7925C16.3215%2014.1896%2017.1446%2013.5045%2017.9128%2012.7372C19.1931%2011.4584%2020.1946%2010.038%2020.917%208.47602C21.6395%206.91403%2021.955%205.47536%2021.8636%204.16C20.5466%204.06866%2019.1017%204.38379%2017.5287%205.10541C15.9557%205.82703%2014.529%206.82726%2013.2487%208.10608C12.4805%208.87337%2011.7946%209.69547%2011.191%2010.5724C10.5874%2011.4493%2010.1393%2012.2714%209.84666%2013.0387ZM14.7302%2011.2575C14.3096%2010.8373%2014.0992%2010.3212%2014.0992%209.70917C14.0992%209.09716%2014.3096%208.58107%2014.7302%208.16088C15.1509%207.7407%2015.6722%207.53061%2016.2941%207.53061C16.916%207.53061%2017.4373%207.7407%2017.8579%208.16088C18.2786%208.58107%2018.489%209.09716%2018.489%209.70917C18.489%2010.3212%2018.2786%2010.8373%2017.8579%2011.2575C17.4373%2011.6776%2016.916%2011.8877%2016.2941%2011.8877C15.6722%2011.8877%2015.1509%2011.6776%2014.7302%2011.2575ZM15.2515%2020.0539L17.5561%2017.752L17.2543%2016.2175C16.7788%2016.5463%2016.3032%2016.8432%2015.8277%2017.1081C15.3521%2017.373%2014.8583%2017.6333%2014.3461%2017.8891L15.2515%2020.0539ZM23.839%202.15956C24.1865%204.37009%2023.9716%206.52125%2023.1942%208.61304C22.4169%2010.7048%2021.0771%2012.7007%2019.1749%2014.6007L19.7236%2017.3136C19.7967%2017.679%2019.7784%2018.0352%2019.6687%2018.3823C19.559%2018.7294%2019.3761%2019.0309%2019.12%2019.2866L14.5108%2023.8904L12.2061%2018.4919L7.51461%2013.806L2.10974%2011.5041L6.69153%206.90033C6.9476%206.64457%207.25397%206.46188%207.61064%206.35227C7.9673%206.24265%208.32854%206.22438%208.69435%206.29746L11.4105%206.84553C13.3127%204.94556%2015.3064%203.6028%2017.3915%202.81724C19.4767%202.03168%2021.6258%201.81245%2023.839%202.15956ZM4.05769%2017.2862C4.69786%2016.6468%205.47978%2016.3225%206.40346%2016.3134C7.32713%2016.3042%208.10905%2016.6194%208.74922%2017.2588C9.38939%2017.8982%209.70491%2018.6792%209.69576%2019.6018C9.68662%2020.5243%209.36196%2021.3053%208.72179%2021.9448C8.26452%2022.4015%207.50089%2022.7943%206.43089%2023.1231C5.36089%2023.4519%203.88393%2023.7442%202%2024C2.25607%2022.1183%202.54872%2020.6431%202.87795%2019.5744C3.20718%2018.5056%203.60043%2017.7429%204.05769%2017.2862ZM5.62154%2018.8208C5.43863%2019.0035%205.25572%2019.3369%205.07282%2019.821C4.88991%2020.3051%204.76188%2020.7938%204.68872%2021.2871C5.18256%2021.214%205.67183%2021.0907%206.15653%2020.9171C6.64123%2020.7436%206.97504%2020.5655%207.15794%2020.3828C7.37743%2020.1635%207.49632%2019.8986%207.51461%2019.5881C7.5329%2019.2775%207.4323%2019.0126%207.21282%2018.7934C6.99333%2018.5741%206.72812%2018.4691%206.41718%2018.4782C6.10624%2018.4874%205.84102%2018.6015%205.62154%2018.8208Z'%20fill='%23A3A8B8'/%3e%3c/g%3e%3c/svg%3e", Snowflake = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Logo-solid'%3e%3cpath%20id='inside'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M13.5357%2012.1774L12.801%2012.912C12.7029%2013.0101%2012.5439%2013.0101%2012.4458%2012.912L11.7112%2012.1774C11.6131%2012.0794%2011.6131%2011.9203%2011.7112%2011.8223L12.4458%2011.0876C12.5439%2010.9894%2012.703%2010.9894%2012.8011%2011.0876L13.5357%2011.8222C13.6337%2011.9203%2013.6337%2012.0793%2013.5357%2012.1774ZM15.0724%2011.2524L13.3708%209.55073C12.9581%209.13804%2012.2889%209.13804%2011.8761%209.55073L10.1744%2011.2525C9.76154%2011.6653%209.76154%2012.3345%2010.1744%2012.7473L11.876%2014.4489C12.2887%2014.8616%2012.9579%2014.8616%2013.3707%2014.4489L15.0724%2012.7471C15.4852%2012.3343%2015.4852%2011.6651%2015.0724%2011.2524Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%206'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.79594%200C8.95801%200%208.2787%200.679312%208.2787%201.51724V4.65891L5.53731%203.07614C4.81165%202.65718%203.88372%202.9058%203.46476%203.63153C3.04579%204.35718%203.29441%205.28512%204.02007%205.70408L8.83304%208.48285C9.09497%208.69823%209.43036%208.82761%209.79594%208.82761C10.6339%208.82761%2011.3132%208.14829%2011.3132%207.31036V1.51724C11.3132%200.679312%2010.6339%200%209.79594%200Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%205'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.60315%2012.5758C8.61253%2012.553%208.62177%2012.5303%208.62997%2012.5071C8.63915%2012.4812%208.64722%2012.4552%208.65494%2012.429C8.66087%2012.4088%208.66673%2012.3888%208.67184%2012.3685C8.67887%2012.3405%208.6848%2012.3124%208.69018%2012.2841C8.69397%2012.2642%208.69756%2012.2443%208.7006%2012.2243C8.70473%2012.1967%208.70791%2012.1692%208.71046%2012.1414C8.71253%2012.1194%208.71425%2012.0975%208.71542%2012.0754C8.71666%2012.0503%208.71708%2012.0252%208.71708%2012C8.71708%2011.9748%208.71666%2011.9498%208.71542%2011.9246C8.71425%2011.9025%208.71253%2011.8805%208.71046%2011.8586C8.70791%2011.8309%208.70473%2011.8034%208.7006%2011.7756C8.69756%2011.7556%208.69397%2011.7358%208.69018%2011.7158C8.6848%2011.6876%208.67887%2011.6596%208.67184%2011.6315C8.66673%2011.6112%208.66087%2011.5912%208.65494%2011.5711C8.64722%2011.5449%208.63915%2011.5188%208.62997%2011.4929C8.62177%2011.4697%208.61253%2011.4469%208.60315%2011.4242C8.59418%2011.4023%208.58528%2011.3805%208.57522%2011.3589C8.56246%2011.3316%208.54825%2011.3049%208.53391%2011.2784C8.52722%2011.2661%208.52198%2011.2535%208.51501%2011.2414C8.51232%2011.2367%208.50901%2011.2325%208.50625%2011.2279C8.48956%2011.1996%208.47122%2011.1722%208.45259%2011.1449C8.44266%2011.1303%208.43308%2011.1152%208.42266%2011.1009C8.40466%2011.0765%208.38515%2011.0532%208.3657%2011.0298C8.35253%2011.014%208.3399%2010.9978%208.32625%2010.9826C8.30922%2010.9638%208.29087%2010.9462%208.27287%2010.9281C8.2548%2010.9101%208.23715%2010.8917%208.21839%2010.8747C8.20322%2010.8612%208.18701%2010.8485%208.17122%2010.8354C8.14777%2010.8158%208.12453%2010.7963%208.10004%2010.7784C8.08584%2010.7679%208.07073%2010.7583%208.05604%2010.7484C8.0288%2010.7298%208.00142%2010.7115%207.97308%2010.6947C7.96846%2010.6921%207.96432%2010.6887%207.95963%2010.6861L2.94265%207.78949C2.21693%207.37046%201.28899%207.61915%200.870026%208.3448C0.45106%209.07053%200.699681%209.99846%201.42541%2010.4174L4.16652%2012L1.42541%2013.5826C0.699681%2014.0016%200.45106%2014.9295%200.870026%2015.6552C1.28899%2016.3809%202.21693%2016.6295%202.94265%2016.2105L7.95963%2013.314C7.96432%2013.3112%207.96846%2013.308%207.97308%2013.3052C8.00142%2013.2885%208.0288%2013.2702%208.05604%2013.2516C8.07073%2013.2416%208.08584%2013.2321%208.10004%2013.2216C8.12453%2013.2036%208.14777%2013.1841%208.17122%2013.1646C8.18701%2013.1516%208.20322%2013.1389%208.21839%2013.1252C8.23708%2013.1083%208.2548%2013.0899%208.2728%2013.0719C8.29087%2013.0539%208.30922%2013.0361%208.32625%2013.0173C8.3399%2013.0023%208.35246%2012.986%208.36563%2012.9703C8.38515%2012.9469%208.40466%2012.9235%208.42266%2012.899C8.43308%2012.8848%208.4426%2012.8698%208.45253%2012.8551C8.47122%2012.8278%208.48956%2012.8004%208.50632%2012.7721C8.50908%2012.7674%208.51232%2012.7633%208.51501%2012.7586C8.52198%2012.7465%208.52722%2012.7339%208.53384%2012.7217C8.54825%2012.695%208.56246%2012.6684%208.57522%2012.641C8.58528%2012.6194%208.59418%2012.5976%208.60315%2012.5758Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%204'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.79594%2015.1724C9.43036%2015.1724%209.09504%2015.3017%208.83304%2015.5171L4.02007%2018.2958C3.29441%2018.7148%203.04579%2019.6427%203.46476%2020.3684C3.88372%2021.0941%204.81165%2021.3428%205.53731%2020.9238L8.2787%2019.3411V22.4827C8.2787%2023.3207%208.95801%2024%209.79594%2024C10.6339%2024%2011.3132%2023.3207%2011.3132%2022.4827V16.6896C11.3132%2015.8517%2010.6339%2015.1724%209.79594%2015.1724Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%203'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.2272%2018.2958L16.4142%2015.5171C16.1522%2015.3017%2015.8169%2015.1724%2015.4513%2015.1724C14.6134%2015.1724%2013.9341%2015.8517%2013.9341%2016.6896V22.4827C13.9341%2023.3207%2014.6134%2024%2015.4513%2024C16.2893%2024%2016.9686%2023.3207%2016.9686%2022.4827V19.3411L19.71%2020.9238C20.4356%2021.3428%2021.3636%2021.0941%2021.7826%2020.3684C22.2015%2019.6427%2021.9529%2018.7148%2021.2272%2018.2958Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%202'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M23.8219%2013.5826L21.0808%2012L23.8219%2010.4174C24.5476%209.99843%2024.7963%209.0705%2024.3773%208.34484C23.9584%207.61911%2023.0304%207.37049%2022.3047%207.78946L17.2877%2010.686C17.283%2010.6887%2017.2789%2010.692%2017.2743%2010.6947C17.2459%2010.7115%2017.2186%2010.7298%2017.1912%2010.7484C17.1766%2010.7584%2017.1615%2010.7679%2017.1473%2010.7784C17.1228%2010.7964%2017.0995%2010.8159%2017.0761%2010.8353C17.0603%2010.8484%2017.0441%2010.8611%2017.029%2010.8747C17.0101%2010.8917%2016.9926%2010.9101%2016.9745%2010.9282C16.9565%2010.9462%2016.9381%2010.9638%2016.921%2010.9826C16.9074%2010.9978%2016.8948%2011.014%2016.8817%2011.0297C16.8622%2011.0532%2016.8427%2011.0765%2016.8247%2011.101C16.8143%2011.1152%2016.8048%2011.1302%2016.7947%2011.1449C16.7761%2011.1722%2016.7578%2011.1995%2016.7411%2011.2279C16.7383%2011.2326%2016.735%2011.2366%2016.7323%2011.2414C16.7254%2011.2535%2016.7201%2011.2661%2016.7134%2011.2784C16.6991%2011.305%2016.6849%2011.3316%2016.6721%2011.359C16.6621%2011.3805%2016.6532%2011.4024%2016.6442%2011.4242C16.6348%2011.4469%2016.6256%2011.4697%2016.6174%2011.4928C16.6081%2011.5188%2016.6001%2011.5448%2016.5924%2011.5711C16.5865%2011.5911%2016.5806%2011.6112%2016.5756%2011.6315C16.5685%2011.6595%2016.5625%2011.6876%2016.5572%2011.7159C16.5534%2011.7358%2016.5498%2011.7557%2016.5468%2011.7757C16.5426%2011.8033%2016.5394%2011.8309%2016.5369%2011.8586C16.5348%2011.8805%2016.5331%2011.9025%2016.5319%2011.9246C16.5307%2011.9497%2016.5303%2011.9748%2016.5303%2012C16.5303%2012.0251%2016.5307%2012.0502%2016.5319%2012.0754C16.5331%2012.0975%2016.5348%2012.1194%2016.5369%2012.1415C16.5394%2012.1691%2016.5426%2012.1966%2016.5468%2012.2243C16.5498%2012.2444%2016.5534%2012.2642%2016.5572%2012.2841C16.5625%2012.3124%2016.5685%2012.3404%2016.5756%2012.3685C16.5806%2012.3888%2016.5865%2012.4088%2016.5924%2012.4289C16.6001%2012.4551%2016.6081%2012.4811%2016.6174%2012.5071C16.6256%2012.5303%2016.6348%2012.553%2016.6442%2012.5757C16.6532%2012.5976%2016.6621%2012.6194%2016.6721%2012.641C16.6849%2012.6684%2016.6991%2012.6951%2016.7135%2012.7217C16.7201%2012.7339%2016.7254%2012.7465%2016.7323%2012.7586C16.735%2012.7633%2016.7383%2012.7675%2016.741%2012.7721C16.7578%2012.8004%2016.7761%2012.8278%2016.7948%2012.8551C16.8048%2012.8697%2016.8143%2012.8849%2016.8247%2012.899C16.8427%2012.9235%2016.8622%2012.9469%2016.8818%2012.9703C16.8949%2012.986%2016.9074%2013.0022%2016.921%2013.0173C16.9381%2013.0361%2016.9565%2013.0538%2016.9746%2013.0719C16.9926%2013.0899%2017.0102%2013.1082%2017.029%2013.1252C17.0441%2013.1389%2017.0603%2013.1515%2017.0761%2013.1646C17.0995%2013.1842%2017.1228%2013.2037%2017.1473%2013.2216C17.1615%2013.2321%2017.1766%2013.2416%2017.1912%2013.2516C17.2186%2013.2702%2017.2459%2013.2885%2017.2743%2013.3053C17.2789%2013.308%2017.283%2013.3112%2017.2877%2013.314L22.3047%2016.2105C23.0304%2016.6295%2023.9584%2016.3809%2024.3773%2015.6552C24.7963%2014.9295%2024.5476%2014.0015%2023.8219%2013.5826Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%201'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.7826%203.63153C21.3636%202.90587%2020.4357%202.65718%2019.71%203.07614L16.9686%204.65891V1.51724C16.9686%200.679312%2016.2893%200%2015.4513%200C14.6134%200%2013.9341%200.679312%2013.9341%201.51724V7.31036C13.9341%208.14836%2014.6134%208.82761%2015.4513%208.82761C15.8169%208.82761%2016.1523%208.69823%2016.4142%208.48285L21.2272%205.70408C21.9529%205.28518%2022.2015%204.35718%2021.7826%203.63153Z'%20fill='%2329B5E8'/%3e%3c/g%3e%3c/svg%3e";
function DetachedHead() {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "This Git tree is in a detached HEAD state." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Please commit the latest changes and push to GitHub to continue." })
    ] })
  };
}
function ModuleIsNotAdded(o) {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: `
The app's main file \`${o}\` has
not been pushed to GitHub. Please add it to continue.
`, allowHTML: !1 })
  };
}
const DEPLOY_URL = "https://share.streamlit.io/deploy", STREAMLIT_CLOUD_URL = "https://streamlit.io/cloud", STREAMLIT_COMMUNITY_CLOUD_DOCS_URL = "https://share.streamlit.io/cloud-getting-started", STREAMLIT_DEPLOY_TUTORIAL_URL = "https://share.streamlit.io/deployment-tutorial", SNOWFLAKE_LEARN_MORE_URL = "https://share.streamlit.io/sis-about", SNOWFLAKE_TRIAL_URL = "https://share.streamlit.io/snowflake-trial";
function _EMOTION_STRINGIFIED_CSS_ERROR__$4() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledParagraph = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "epbg7au0"
} : {
  target: "epbg7au0",
  label: "StyledParagraph"
})(process.env.NODE_ENV === "production" ? {
  name: "1aujq9w",
  styles: "text-align:justify"
} : {
  name: "1aujq9w",
  styles: "text-align:justify/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RXJyb3JEaWFsb2dzL3N0eWxlZC1jb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQitCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RXJyb3JEaWFsb2dzL3N0eWxlZC1jb21wb25lbnRzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGFyYWdyYXBoID0gc3R5bGVkLnAoe1xuICB0ZXh0QWxpZ246IFwianVzdGlmeVwiLFxufSlcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
function NoRepositoryDetected() {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledParagraph, { children: [
      "The app’s code is not connected to a remote GitHub repository. To deploy on Streamlit Community Cloud, please put your code in a GitHub repository and publish the current branch. Read more in",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: STREAMLIT_COMMUNITY_CLOUD_DOCS_URL, rel: "noopener noreferrer", target: "_blank", children: "our documentation" }),
      "."
    ] })
  };
}
function DeployCard(o) {
  const {
    colors: i,
    spacing: g,
    radii: E,
    breakpoints: e,
    sizes: t
  } = useEmotionTheme(), {
    children: n
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { overrides: {
    Root: {
      style: {
        borderTopWidth: t.borderWidth,
        borderBottomWidth: t.borderWidth,
        borderLeftWidth: t.borderWidth,
        borderRightWidth: t.borderWidth,
        borderTopStyle: "solid",
        borderBottomStyle: "none",
        borderLeftStyle: "none",
        borderRightStyle: "solid",
        borderTopColor: i.borderColor,
        borderBottomColor: i.borderColor,
        borderLeftColor: i.borderColor,
        borderRightColor: i.borderColor,
        borderTopLeftRadius: "none",
        borderTopRightRadius: "none",
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none",
        ":last-child": {
          borderRightStyle: "none",
          borderBottomRightRadius: E.xl
        },
        ":first-child": {
          borderBottomLeftRadius: E.xl
        },
        [`@media (max-width: ${e.md})`]: {
          ":last-child": {
            borderBottomLeftRadius: E.xl
          }
        }
      }
    },
    Contents: {
      style: {
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        height: "100%"
      }
    },
    Body: {
      style: {
        padding: g.twoXL,
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        [`@media (max-width: ${e.md})`]: {
          padding: g.xl
        }
      }
    }
  }, children: n });
}
const Checkmark = "data:image/svg+xml,%3csvg%20width='12'%20height='9'%20viewBox='0%200%2012%209'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.00009%206.78L1.68676%204.46667C1.42676%204.20667%201.00676%204.20667%200.746758%204.46667C0.486758%204.72667%200.486758%205.14667%200.746758%205.40667L3.53342%208.19334C3.79342%208.45334%204.21342%208.45334%204.47342%208.19334L11.5268%201.14C11.7868%200.880005%2011.7868%200.460005%2011.5268%200.200005C11.2668%20-0.0599951%2010.8468%20-0.0599951%2010.5868%200.200005L4.00009%206.78Z'%20fill='%23808495'/%3e%3c/svg%3e", StyledHeader$1 = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve4"
} : {
  target: "e97l2ve4",
  label: "StyledHeader"
})(({
  theme: o
}) => ({
  // We do not want to change the font for this based on theme.
  fontFamily: o.fonts.sansSerif,
  fontWeight: o.fontWeights.bold,
  fontSize: o.fontSizes.lg,
  marginTop: o.spacing.twoXL,
  marginBottom: o.spacing.twoXS,
  [`@media (max-width: ${o.breakpoints.md})`]: {
    marginTop: o.spacing.md
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSubheader = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve3"
} : {
  target: "e97l2ve3",
  label: "StyledSubheader"
})(({
  theme: o
}) => ({
  // We do not want to change the font for this based on theme.
  fontFamily: o.fonts.sansSerif,
  fontWeight: o.fontWeights.normal,
  fontSize: o.fontSizes.md,
  marginTop: o.spacing.twoXS,
  marginBottom: o.spacing.md,
  [`@media (max-width: ${o.breakpoints.md})`]: {
    marginTop: o.spacing.md
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCardContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve2"
} : {
  target: "e97l2ve2",
  label: "StyledCardContainer"
})(({
  theme: o
}) => ({
  display: "grid",
  maxWidth: `calc(1.25 * ${o.sizes.contentMaxWidth})`,
  gridTemplateColumns: "1fr 1fr 1fr",
  gridGap: o.spacing.none,
  [`@media (max-width: ${o.breakpoints.md})`]: {
    gridTemplateColumns: "1fr"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElement = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve1"
} : {
  target: "e97l2ve1",
  label: "StyledElement"
})(({
  theme: o
}) => ({
  display: "inline-flex",
  marginTop: o.spacing.sm,
  "& > span": {
    // We do not want to change the font for this based on theme.
    fontFamily: o.fonts.sansSerif,
    fontWeight: o.fontWeights.normal,
    fontSize: o.fontSizes.md,
    marginLeft: o.spacing.twoXL,
    color: o.colors.gray70
  },
  "& > img": {
    position: "absolute",
    marginTop: o.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1RDZCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkSGVhZGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICAvLyBXZSBkbyBub3Qgd2FudCB0byBjaGFuZ2UgdGhlIGZvbnQgZm9yIHRoaXMgYmFzZWQgb24gdGhlbWUuXG4gIGZvbnRGYW1pbHk6IHRoZW1lLmZvbnRzLnNhbnNTZXJpZixcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuYm9sZCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5sZyxcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hMLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudHdvWFMsXG5cbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcubWQsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN1YmhlYWRlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgLy8gV2UgZG8gbm90IHdhbnQgdG8gY2hhbmdlIHRoZSBmb250IGZvciB0aGlzIGJhc2VkIG9uIHRoZW1lLlxuICBmb250RmFtaWx5OiB0aGVtZS5mb250cy5zYW5zU2VyaWYsXG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5tZCxcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubWQsXG5cbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcubWQsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENhcmRDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZ3JpZFwiLFxuICBtYXhXaWR0aDogYGNhbGMoMS4yNSAqICR7dGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRofSlgLFxuICBncmlkVGVtcGxhdGVDb2x1bW5zOiBcIjFmciAxZnIgMWZyXCIsXG4gIGdyaWRHYXA6IHRoZW1lLnNwYWNpbmcubm9uZSxcblxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLm1kfSlgXToge1xuICAgIGdyaWRUZW1wbGF0ZUNvbHVtbnM6IFwiMWZyXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnNtLFxuXG4gIFwiJiA+IHNwYW5cIjoge1xuICAgIC8vIFdlIGRvIG5vdCB3YW50IHRvIGNoYW5nZSB0aGUgZm9udCBmb3IgdGhpcyBiYXNlZCBvbiB0aGVtZS5cbiAgICBmb250RmFtaWx5OiB0aGVtZS5mb250cy5zYW5zU2VyaWYsXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMubWQsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50d29YTCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk3MCxcbiAgfSxcbiAgXCImID4gaW1nXCI6IHtcbiAgICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWN0aW9uc1dyYXBwZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcudGhyZWVYTCxcblxuICBcIiYgPiBidXR0b25cIjoge1xuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hMLFxuICB9LFxuXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMubWR9KWBdOiB7XG4gICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnhsLFxuICB9LFxufSkpXG4iXX0= */"), StyledActionsWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve0"
} : {
  target: "e97l2ve0",
  label: "StyledActionsWrapper"
})(({
  theme: o
}) => ({
  display: "flex",
  marginTop: o.spacing.threeXL,
  "& > button": {
    marginRight: o.spacing.twoXL
  },
  [`@media (max-width: ${o.breakpoints.md})`]: {
    marginTop: o.spacing.xl
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function DeployListElement(o) {
  const {
    children: i
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledElement, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Checkmark, alt: "Checkmark" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: i })
  ] });
}
function ModalBody({
  children: o
}) {
  const {
    colors: i,
    fontSizes: g,
    spacing: E
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$2, { style: {
    marginTop: E.none,
    marginLeft: E.none,
    marginRight: E.none,
    marginBottom: E.none,
    paddingTop: E.md,
    paddingRight: E.none,
    paddingBottom: E.none,
    paddingLeft: E.none,
    color: i.bodyText,
    fontSize: g.md,
    overflowY: "auto"
  }, children: o });
}
function DeployModal(o) {
  const {
    children: i,
    onClose: g
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, closeable: !0, onClose: g, size: "auto", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Deploy this app using..." }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: i })
  ] });
}
const {
  GitStates
} = GitInfo, openUrl = (o) => {
  window.open(o, "_blank");
}, getDeployAppUrl = (o) => {
  if (o) {
    const i = new URL(DEPLOY_URL);
    return i.searchParams.set("repository", o.repository ?? ""), i.searchParams.set("branch", o.branch ?? ""), i.searchParams.set("mainModule", o.module ?? ""), i.toString();
  }
  return STREAMLIT_CLOUD_URL;
};
function DeployDialog(o) {
  const {
    gitInfo: i,
    onClose: g,
    metricsMgr: E,
    showDeployError: e,
    isDeployErrorModalOpen: t
  } = o, n = useCallback(() => {
    if (E.enqueue("menuClick", {
      label: "deployButtonInDialog"
    }), !i) {
      const f = NoRepositoryDetected();
      e(f.title, f.body);
      return;
    }
    const {
      repository: h,
      branch: d,
      module: k,
      untrackedFiles: p,
      state: M
    } = i;
    if ((!h || !d || !k) && M === GitStates.DEFAULT) {
      const f = NoRepositoryDetected();
      e(f.title, f.body);
      return;
    }
    if (M === GitStates.HEAD_DETACHED) {
      const f = DetachedHead();
      e(f.title, f.body);
      return;
    }
    if (k && p?.includes(k)) {
      const f = ModuleIsNotAdded(k);
      e(f.title, f.body);
      return;
    }
    t && g(), openUrl(getDeployAppUrl(i));
  }, [E, i, t, e, g]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployModal, { onClose: g, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCardContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: StreamlitLogo, alt: "Streamlit Logo", "data-testid": "stDeployDialogCommunityCloudIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Streamlit Community Cloud" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For community, always free" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "For personal hobbies and learning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy unlimited public apps" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Explore and learn from Streamlit’s community and popular apps" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionsWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.PRIMARY, onClick: n, children: "Deploy now" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
          E.enqueue("menuClick", {
            label: "readMoreCommunityCloudInDeployDialog"
          }), openUrl(STREAMLIT_COMMUNITY_CLOUD_DOCS_URL);
        }, kind: BaseButtonKind.MINIMAL, children: "Learn more" })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Snowflake, alt: "Snowflake", "data-testid": "stDeployDialogSnowflakeDeploymentIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Snowflake" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For enterprise" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Enterprise-level security, support, and fully managed infrastructure" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy unlimited private apps with role-based sharing" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Integrate with Snowflake’s full data stack" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionsWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.SECONDARY, onClick: () => {
          E.enqueue("menuClick", {
            label: "startTrialInDeployDialog"
          }), openUrl(SNOWFLAKE_TRIAL_URL);
        }, children: "Start trial" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
          E.enqueue("menuClick", {
            label: "learnMoreSnowflakeInDeployDialog"
          }), openUrl(SNOWFLAKE_LEARN_MORE_URL);
        }, kind: BaseButtonKind.MINIMAL, children: "Learn more" })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 2
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Rocket, alt: "Rocket", "data-testid": "stDeployDialogCustomDeploymentIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Other platforms" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For custom deployment " }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy on your own hardware or cloud service" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Set up and maintain your own authentication, resources, and costs" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledActionsWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
        E.enqueue("menuClick", {
          label: "readMoreDeployTutorialInDeployDialog"
        }), openUrl(STREAMLIT_DEPLOY_TUTORIAL_URL);
      }, kind: BaseButtonKind.MINIMAL, children: "Learn more" }) }) })
    ] })
  ] }) });
}
const StyledDialogBody = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc8"
} : {
  target: "e1x90zqc8",
  label: "StyledDialogBody"
})(({
  theme: o
}) => ({
  display: "grid",
  gap: o.spacing.twoXL,
  gridTemplateColumns: "1fr 1fr",
  margin: 0,
  padding: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledFullRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc7"
} : {
  target: "e1x90zqc7",
  label: "StyledFullRow"
})(({
  theme: o
}) => ({
  gridColumnStart: 1,
  gridColumnEnd: -1,
  display: "grid",
  gap: o.spacing.xs
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeader = /* @__PURE__ */ createStyled("h2", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc6"
} : {
  target: "e1x90zqc6",
  label: "StyledHeader"
})(({
  theme: o
}) => ({
  paddingBottom: 0,
  paddingTop: 0,
  marginBottom: o.spacing.md,
  marginTop: "0",
  fontWeight: o.fontWeights.bold,
  fontSize: o.fontSizes.md,
  lineHeight: o.lineHeights.tight,
  color: o.colors.bodyText,
  display: "grid",
  gridAutoFlow: "row",
  gap: o.spacing.xs,
  // Override the default global style for a h2:first-of-type
  "&:first-of-type": {
    marginTop: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc5"
} : {
  target: "e1x90zqc5",
  label: "StyledLabel"
})(({
  theme: o
}) => ({
  paddingBottom: 0,
  paddingTop: 0,
  marginBottom: 0,
  marginTop: 0,
  lineHeight: o.lineHeights.tight,
  fontSize: o.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0QyQiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvU3RyZWFtbGl0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dCb2R5ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImdyaWRcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnR3b1hMLFxuICBncmlkVGVtcGxhdGVDb2x1bW5zOiBcIjFmciAxZnJcIixcbiAgbWFyZ2luOiAwLFxuICBwYWRkaW5nOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRGdWxsUm93ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBncmlkQ29sdW1uU3RhcnQ6IDEsXG4gIGdyaWRDb2x1bW5FbmQ6IC0xLFxuICBkaXNwbGF5OiBcImdyaWRcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXIgPSBzdHlsZWQuaDIoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcGFkZGluZ0JvdHRvbTogMCxcbiAgcGFkZGluZ1RvcDogMCxcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLm1kLFxuICBtYXJnaW5Ub3A6IFwiMFwiLFxuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLm1kLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgZGlzcGxheTogXCJncmlkXCIsXG4gIGdyaWRBdXRvRmxvdzogXCJyb3dcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuXG4gIC8vIE92ZXJyaWRlIHRoZSBkZWZhdWx0IGdsb2JhbCBzdHlsZSBmb3IgYSBoMjpmaXJzdC1vZi10eXBlXG4gIFwiJjpmaXJzdC1vZi10eXBlXCI6IHtcbiAgICBtYXJnaW5Ub3A6IDAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZExhYmVsID0gc3R5bGVkLmxhYmVsKCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmdCb3R0b206IDAsXG4gIHBhZGRpbmdUb3A6IDAsXG4gIG1hcmdpbkJvdHRvbTogMCxcbiAgbWFyZ2luVG9wOiAwLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkSHIgPSBzdHlsZWQuaHIoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcGFkZGluZzogMCxcbiAgbWFyZ2luQm90dG9tOiAwLFxuICBtYXJnaW5MZWZ0OiBgLSR7dGhlbWUuc3BhY2luZy54bH1gLFxuICBtYXJnaW5SaWdodDogYC0ke3RoZW1lLnNwYWNpbmcueGx9YCxcbiAgbWFyZ2luVG9wOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5tZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQ2hlY2tib3ggPSBzdHlsZWQuaW5wdXQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcueHMsXG4gIGFwcGVhcmFuY2U6IFwibm9uZVwiLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB3aWR0aDogdGhlbWUuZm9udFNpemVzLm1kLFxuICBoZWlnaHQ6IHRoZW1lLmZvbnRTaXplcy5tZCxcbiAgYm9yZGVyUmFkaXVzOiBgbWluKCR7dGhlbWUucmFkaWkubWR9LCAke3RoZW1lLnJhZGlpLm1heENoZWNrYm94fSlgLFxuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBwYWRkaW5nOiAwLFxuICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcblxuICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgb3V0bGluZTogYDJweCBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIH0sXG5cbiAgXCImOmNoZWNrZWRcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG5cbiAgICBcIiY6YWZ0ZXJcIjoge1xuICAgICAgY29udGVudDogJ1wi4pyTXCInLFxuICAgICAgZm9udEZhbWlseTogdGhlbWUuZm9udHMubW9ub3NwYWNlLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5tZCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5ub25lLFxuICAgIH0sXG4gIH0sXG5cbiAgXCImOmRpc2FibGVkXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERlcGxveUVycm9yQ29udGVudCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImID4gdWxcIjoge1xuICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLnR3b1hMLFxuICB9LFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWRFcnJvclRleHRQcm9wcyB7XG4gIGhhc0NvZGVCZWxvdzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRXJyb3JUZXh0ID0gc3R5bGVkLmRpdjxTdHlsZWRFcnJvclRleHRQcm9wcz4oXG4gICh7IHRoZW1lLCBoYXNDb2RlQmVsb3cgfSkgPT4gKHtcbiAgICAuLi4oaGFzQ29kZUJlbG93ICYmIHtcbiAgICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5sZyxcbiAgICB9KSxcbiAgfSlcbilcbiJdfQ== */");
process.env.NODE_ENV;
process.env.NODE_ENV;
const StyledCheckbox = /* @__PURE__ */ createStyled("input", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc2"
} : {
  target: "e1x90zqc2",
  label: "StyledCheckbox"
})(({
  theme: o
}) => ({
  marginRight: o.spacing.xs,
  appearance: "none",
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  width: o.fontSizes.md,
  height: o.fontSizes.md,
  borderRadius: `min(${o.radii.md}, ${o.radii.maxCheckbox})`,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  verticalAlign: "middle",
  overflow: "hidden",
  "&:focus-visible": {
    outline: `2px solid ${o.colors.primary}`
  },
  "&:checked": {
    backgroundColor: o.colors.primary,
    "&:after": {
      content: '"✓"',
      fontFamily: o.fonts.monospace,
      fontSize: o.fontSizes.md,
      color: o.colors.white,
      lineHeight: o.lineHeights.none
    }
  },
  "&:disabled": {
    backgroundColor: o.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDeployErrorContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc1"
} : {
  target: "e1x90zqc1",
  label: "StyledDeployErrorContent"
})(({
  theme: o
}) => ({
  "& > ul": {
    paddingLeft: o.spacing.twoXL
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorText = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc0"
} : {
  target: "e1x90zqc0",
  label: "StyledErrorText"
})(({
  theme: o,
  hasCodeBelow: i
}) => ({
  ...i && {
    marginBottom: o.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SettingsDialog = memo(function o({
  isServerConnected: i,
  onClose: g,
  onSave: E,
  settings: e,
  allowRunOnSave: t,
  animateModal: n,
  metricsMgr: h,
  sessionInfo: d
}) {
  const {
    activeTheme: k,
    availableThemes: p,
    setTheme: M
  } = useContext(ThemeContext), H = useRef(e), f = useRef(!0), [AA, gA] = useState({
    ...e
  }), IA = useCallback((iA, EA) => {
    gA((oA) => ({
      ...oA,
      [iA]: EA
    }));
  }, []);
  useEffect(() => {
    if (f.current) {
      f.current = !1;
      return;
    }
    H.current = AA, E(H.current);
  }, [E, AA]);
  const BA = useCallback((iA) => {
    IA(iA.target.name, iA.target.checked);
  }, [IA]), CA = useCallback((iA) => {
    let EA;
    iA && (EA = p.find((oA) => oA.name.startsWith("Custom Theme") ? oA.displayName === iA : oA.name === iA)), EA === void 0 && (EA = p[0]), h.enqueue("menuClick", {
      label: "changeTheme"
    }), M(EA);
  }, [M, h, p]), QA = useCallback(() => p.map((iA) => iA.displayName ?? iA.name), [p]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { animate: n, isOpen: !0, onClose: g, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Settings" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogBody, { children: [
      t && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Development" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCheckbox, { disabled: !i, type: "checkbox", name: "runOnSave", checked: AA.runOnSave && i, onChange: BA }),
          " ",
          "Run on save"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: "Automatically updates the app when the underlying code is updated.", allowHTML: !1, isCaption: !0 })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Appearance" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCheckbox, { type: "checkbox", name: "wideMode", checked: AA.wideMode, onChange: BA }),
          " ",
          "Wide mode"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: " Turn on to make this app occupy the entire width of the screen.", allowHTML: !1, isCaption: !0 })
      ] }),
      !!p.length && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabel, { children: "Choose app theme" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(UISelectbox, { options: QA(), disabled: k.name === CUSTOM_THEME_NAME, onChange: CA, value: k.displayName ?? k.name, placeholder: "", acceptNewOptions: !1 })
      ] }),
      d.isSet && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "stVersionInfo", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: `Made with Streamlit ${d.current.streamlitVersion}`, allowHTML: !1, isCaption: !0 }) })
    ] }) })
  ] });
});
function StreamlitDialog(o) {
  switch (o.type) {
    case DialogType.ABOUT:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AboutDialog, { ...o });
    case DialogType.CLEAR_CACHE:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ClearCacheDialog, { ...o });
    case DialogType.SETTINGS:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsDialog, { ...o });
    case DialogType.SCRIPT_COMPILE_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ScriptCompileErrorDialog, { ...o });
    case DialogType.WARNING:
    case DialogType.CONNECTION_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(WarningDialog, { ...o });
    case DialogType.DEPLOY_DIALOG:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployDialog, { ...o });
    case DialogType.DEPLOY_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployErrorDialog, { ...o });
    case void 0:
      return noDialog(o);
    default:
      return typeNotRecognizedDialog(o);
  }
}
function AboutDialog(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "About" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: o.aboutSectionMd && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: o.aboutSectionMd, allowHTML: !1 }) })
  ] });
}
function ClearCacheDialog(o) {
  const g = ["**Are you sure you want to clear the app's function caches?**", "This will remove all cached entries from functions using", "`@st.cache_data` and `@st.cache_resource`."].join(`  
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "stClearCacheDialog", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Clear caches" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: g, allowHTML: !1 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.GHOST, onClick: o.onClose, children: "Cancel" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { autoFocus: !0, kind: BaseButtonKind.SECONDARY, onClick: o.confirmCallback, children: "Clear caches" })
    ] })
  ] }) });
}
function ScriptCompileErrorDialog(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o.onClose, size: "auto", autoFocus: !1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Script execution error" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitErrorCodeBlock$1, { children: o.exception?.message ? o.exception.message : "No message" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: o.onClose, children: "Close" }) })
  ] });
}
function WarningDialog(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: o.title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: o.msg })
  ] });
}
function DeployErrorDialog({
  title: o,
  msg: i,
  onClose: g,
  onContinue: E,
  onTryAgain: e
}) {
  const t = () => {
    g(), E && E();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: g, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: o }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDeployErrorContent, { children: i }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.GHOST, onClick: e, children: "Try again" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: t, children: E ? "Continue anyway" : "Close" })
    ] })
  ] });
}
function noDialog({
  onClose: o
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !1, onClose: o });
}
function typeNotRecognizedDialog(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !0, onClose: o.onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: `Dialog type "${o.type}" not recognized.` }) });
}
function parseLinks(o) {
  const i = [];
  let g = 0, E = 0;
  const e = /\[([^\]]+)\]\(([^)]+)\)/g;
  let t;
  for (; (t = e.exec(o)) !== null; )
    t.index > g && i.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: o.substring(g, t.index) }, E++)), i.push(/* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: t[2], target: "_blank", rel: "noopener noreferrer", children: t[1] }, E++)), g = t.index + t[0].length;
  return g < o.length && i.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: o.substring(g) }, E++)), i;
}
function DialogErrorMessage({
  message: o,
  codeBlock: i
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledErrorText, { hasCodeBelow: !!i, children: parseLinks(o) }),
    i && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitErrorCodeBlock$1, { children: i })
  ] });
}
const DialogErrorMessage$1 = memo(DialogErrorMessage);
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledActionButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar2"
} : {
  target: "e3g6aar2",
  label: "StyledActionButtonContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  gap: o.spacing.sm,
  alignItems: "center",
  // line height should be the same as the icon size
  lineHeight: o.iconSizes.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledActionButtonIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar1"
} : {
  target: "e3g6aar1",
  label: "StyledActionButtonIcon"
})(({
  theme: o,
  icon: i
}) => ({
  background: `url("${i}") no-repeat center / contain`,
  width: o.iconSizes.base,
  height: o.iconSizes.base
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledToolbarActions = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar0"
} : {
  target: "e3g6aar0",
  label: "StyledToolbarActions"
})(process.env.NODE_ENV === "production" ? {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row"
} : {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
function ActionButton({
  label: o,
  icon: i,
  onClick: g
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stToolbarActionButton", "data-testid": "stToolbarActionButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: g, kind: BaseButtonKind.HEADER_BUTTON, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionButtonContainer, { children: [
    i && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledActionButtonIcon, { "data-testid": "stToolbarActionButtonIcon", icon: i }),
    o && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "data-testid": "stToolbarActionButtonLabel", children: o })
  ] }) }) });
}
function ToolbarActions({
  sendMessageToHost: o,
  hostToolbarItems: i,
  metricsMgr: g
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToolbarActions, { className: "stToolbarActions", "data-testid": "stToolbarActions", children: i.map(({
    key: E,
    label: e,
    icon: t
  }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton, { label: e, icon: t, onClick: () => {
    g.enqueue("menuClick", {
      label: E
    }), o({
      type: "TOOLBAR_ITEM_CALLBACK",
      key: E
    });
  } }, E)) });
}
const screencastCounterAnimation = keyframes`
0% {
  opacity: 0;
}
25% {
  opacity: 1;
}
100% {
  opacity: 0;
}`, StyledCountdown = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e7qru6u0"
} : {
  target: "e7qru6u0",
  label: "StyledCountdown"
})(({
  theme: o
}) => ({
  position: "fixed",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  top: 0,
  left: 0,
  width: o.sizes.full,
  height: o.sizes.full,
  fontSize: "40vh",
  color: o.colors.redTextColor,
  fontWeight: o.fontWeights.bold,
  opacity: "0.8",
  textShadow: `1px 1px 10px ${o.colors.grayTextColor}`,
  transition: "opacity 0.3s ease-in-out",
  animation: `${screencastCounterAnimation} 1s`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Countdown = ({
  countdown: o,
  endCallback: i
}) => {
  const [g, E] = useState(o), e = () => {
    const t = g - 1;
    t >= 0 && E(t), t === 0 && i();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCountdown, { "data-testid": "stCountdown", onAnimationEnd: e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: g }) }, `frame${g}`);
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledRecordAudioLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "emfz9mr1"
} : {
  target: "emfz9mr1",
  label: "StyledRecordAudioLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1NjcmVlbmNhc3REaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JzQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9TY3JlZW5jYXN0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRBdWRpb0xhYmVsID0gc3R5bGVkLmxhYmVsKHtcbiAgbWFyZ2luOiAwLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEluc3RydWN0aW9uID0gc3R5bGVkLnAoe1xuICBtYXJnaW46IDAsXG59KVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
}), StyledInstruction = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "emfz9mr0"
} : {
  target: "emfz9mr0",
  label: "StyledInstruction"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1NjcmVlbmNhc3REaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9TY3JlZW5jYXN0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRBdWRpb0xhYmVsID0gc3R5bGVkLmxhYmVsKHtcbiAgbWFyZ2luOiAwLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEluc3RydWN0aW9uID0gc3R5bGVkLnAoe1xuICBtYXJnaW46IDAsXG59KVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
}), ScreencastDialog = ({
  onClose: o,
  toggleRecordAudio: i,
  recordAudio: g,
  startRecording: E
}) => {
  const [e, t] = useState(g), n = useCallback((d) => {
    const {
      checked: k
    } = d.target;
    k !== e && (t(k), i());
  }, [e, i]), h = useCallback(() => {
    E(), o();
  }, [E, o]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Record a screencast" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "This will record a video with the contents of your screen, so you can easily share what you're seeing with others." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRecordAudioLabel, { "data-testid": "stScreencastAudioCheckbox", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", name: "recordAudio", "aria-label": "Also record audio", checked: e, onChange: n }),
        " ",
        "Also record audio"
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInstruction, { "data-testid": "stScreencastInstruction", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: "Press `Esc` any time to stop recording.", allowHTML: !1 }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: h, children: "Start recording!" }) })
  ] });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledScreenCastWarningDialog = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly2"
} : {
  target: "e16i1uly2",
  label: "StyledScreenCastWarningDialog"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
}), StyledUnsupportedScreenCastIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly1"
} : {
  target: "e16i1uly1",
  label: "StyledUnsupportedScreenCastIcon"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  justifyItems: "center",
  marginRight: o.spacing.twoXL,
  marginLeft: o.spacing.sm,
  fontSize: o.fontSizes.fourXL
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledUnsupportedScreenCastExplanation = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly0"
} : {
  target: "e16i1uly0",
  label: "StyledUnsupportedScreenCastExplanation"
})(({
  theme: o
}) => ({
  margin: o.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), UnsupportedBrowserDialog = ({
  onClose: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Record a screencast" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledScreenCastWarningDialog, { "data-testid": "stUnsupportedBrowserDialog", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledUnsupportedScreenCastIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "img", "aria-label": "Alien Monster", children: "👾" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledUnsupportedScreenCastExplanation, { children: "Due to limitations with some browsers, this feature is only supported on recent desktop versions of Chrome, Firefox, and Edge." })
  ] }) })
] }), UnsupportedBrowserDialog$1 = memo(UnsupportedBrowserDialog), StyledVideo = /* @__PURE__ */ createStyled("video", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r6"
} : {
  target: "ecutw1r6",
  label: "StyledVideo"
})(({
  theme: o
}) => ({
  width: o.sizes.full,
  borderRadius: o.radii.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDialogContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r5"
} : {
  target: "ecutw1r5",
  label: "StyledDialogContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  width: o.sizes.full
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r4"
} : {
  target: "ecutw1r4",
  label: "StyledRow"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "row",
  paddingTop: o.spacing.md,
  paddingBottom: o.spacing.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledFirstColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r3"
} : {
  target: "ecutw1r3",
  label: "StyledFirstColumn"
})(({
  theme: o
}) => ({
  paddingRight: o.spacing.lg,
  textAlign: "right",
  color: o.colors.grayTextColor,
  fontWeight: o.fontWeights.bold,
  width: "6em"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r2"
} : {
  target: "ecutw1r2",
  label: "StyledSecondColumn"
})(({
  theme: o
}) => ({
  flex: 1,
  paddingRight: o.spacing.lg,
  marginRight: "6em",
  [`@media (max-width: ${o.breakpoints.sm})`]: {
    marginRight: o.spacing.none
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledVideoFormatInstructions = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r1"
} : {
  target: "ecutw1r1",
  label: "StyledVideoFormatInstructions"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.sm,
  marginBottom: o.spacing.none,
  fontSize: o.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDownloadButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r0"
} : {
  target: "ecutw1r0",
  label: "StyledDownloadButtonContainer"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), VideoRecordedDialog = ({
  onClose: o,
  videoBlob: i,
  fileName: g
}) => {
  const E = URL.createObjectURL(i), e = () => {
    const t = document.createElement("a");
    t.setAttribute("href", E), t.setAttribute("download", `${g}.webm`), t.click(), o();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o, overrides: {
    Dialog: {
      style: {
        width: "80vw"
      }
    }
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Next steps" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogContainer, { "data-testid": "stVideoRecordedDialog", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 1" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Preview your video below:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledVideo, { src: E, controls: !0 })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 2" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDownloadButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.SECONDARY, onClick: e, children: "Save video to disk" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledVideoFormatInstructions, { children: [
            "This video is encoded in the",
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.webmproject.org/", children: "WebM format" }),
            ", which is only supported by newer video players. You can also play it by dragging the file directly into your browser."
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 3" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          "Share your video with the world on Twitter, LinkedIn, YouTube, or just plain email!",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "img", "aria-label": "Happy", children: "😀" })
        ] })
      ] })
    ] }) })
  ] });
}, LOG$2 = loglevelExports$1.getLogger("withScreencast");
function withScreencast(o) {
  const i = (g) => {
    const {
      testOverride: E
    } = g, e = useRef(null), [t, n] = useState("streamlit-screencast"), [h, d] = useState(!1), [k, p] = useState(void 0), [M, H] = useState(E || "OFF"), f = useCallback(() => {
      d((iA) => !iA);
    }, []), AA = useCallback(async () => {
      if (!(M === "OFF" || isNullOrUndefined(e.current))) {
        if (M === "COUNTDOWN") {
          H("OFF");
          return;
        }
        if (M === "RECORDING") {
          const iA = e.current;
          if (!iA || iA.getState() === "inactive")
            H("OFF");
          else {
            const EA = await iA.stop();
            p(EA), H("PREVIEW_FILE");
          }
        }
      }
    }, [M]), gA = useCallback(async () => {
      if (!ScreenCastRecorder.isSupportedBrowser()) {
        H("UNSUPPORTED");
        return;
      }
      e.current = new ScreenCastRecorder({
        recordAudio: h,
        onErrorOrStop: () => {
          AA().catch((iA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${iA}`));
        }
      });
      try {
        await e.current.initialize();
      } catch (iA) {
        LOG$2.warn(`ScreenCastRecorder.initialize error: ${iA}`), H("UNSUPPORTED");
        return;
      }
      H("COUNTDOWN");
    }, [h, AA]), IA = useCallback((iA) => {
      if (!ScreenCastRecorder.isSupportedBrowser()) {
        H("UNSUPPORTED");
        return;
      }
      if (M === "OFF") {
        n(iA), H("SETUP");
        return;
      }
      AA().catch((EA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${EA}`));
    }, [M, AA]), BA = useCallback(() => {
      if (isNullOrUndefined(e.current))
        throw new Error("Countdown finished but recorder is null");
      e.current.start() ? H("RECORDING") : AA().catch((EA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${EA}`));
    }, [AA]), CA = useCallback(() => {
      H("OFF");
    }, []), QA = {
      currentState: M,
      toggleRecordAudio: f,
      startRecording: IA,
      // triggers the setup/showDialog process
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      stopRecording: AA
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "withScreencast", "data-testid": "stScreencast", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(o, { ...g, screenCast: QA }),
      M === "UNSUPPORTED" && /* @__PURE__ */ jsxRuntimeExports.jsx(UnsupportedBrowserDialog$1, { onClose: CA }),
      M === "SETUP" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ScreencastDialog,
        {
          recordAudio: h,
          onClose: CA,
          startRecording: gA,
          toggleRecordAudio: f
        }
      ),
      M === "COUNTDOWN" && /* @__PURE__ */ jsxRuntimeExports.jsx(Countdown, { countdown: 3, endCallback: BA }),
      M === "PREVIEW_FILE" && k && /* @__PURE__ */ jsxRuntimeExports.jsx(VideoRecordedDialog, { onClose: CA, videoBlob: k, fileName: t })
    ] });
  };
  return i.displayName = `withScreencast(${o.displayName || o.name || "Component"})`, hoistNonReactStatics(i, o);
}
const useViewportSize = () => {
  const {
    activeTheme: o
  } = useContext(ThemeContext), {
    innerWidth: i
  } = useWindowDimensionsContext(), g = parseInt(o.emotion.breakpoints.md, 10);
  return {
    isMobile: i < g
  };
}, DEFAULT_METRICS_CONFIG = "https://data.streamlit.io/metrics.json", LOG$1 = loglevelExports$1.getLogger("MetricsManager");
class MetricsManager {
  constructor(i) {
    this.initialized = !1, this.actuallySendMetrics = !1, this.metricsUrl = void 0, this.sendMessageToHost = () => {
    }, this.anonymousId = "", this.pendingEvents = [], this.appHash = "Not initialized", this.metadata = {}, this.setAppHash = (g) => {
      this.appHash = g;
    }, this.setMetricsConfig = (g = "") => {
      this.metricsUrl = g;
    }, this.sessionInfo = i;
  }
  async initialize({
    gatherUsageStats: i,
    sendMessageToHost: g
  }) {
    this.sendMessageToHost = g, this.actuallySendMetrics = i && this.metricsUrl !== "off", this.getAnonymousId(), this.actuallySendMetrics && !this.metricsUrl && (await this.requestDefaultMetricsConfig(), this.metricsUrl || (LOG$1.error("Undefined metrics config - deactivating metrics tracking."), this.actuallySendMetrics = !1)), this.actuallySendMetrics && this.sendPendingEvents(), LOG$1.info("Gather usage stats: ", this.actuallySendMetrics), this.initialized = !0;
  }
  enqueue(i, g = {}) {
    if (!this.initialized || !this.sessionInfo.isSet) {
      this.pendingEvents.push([i, g]);
      return;
    }
    this.actuallySendMetrics && (this.pendingEvents.length && this.sendPendingEvents(), this.send(i, g));
  }
  setMetadata(i) {
    this.metadata = i;
  }
  // Fallback - Checks if cached in localStorage, otherwise fetches the config from a default URL
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  async requestDefaultMetricsConfig() {
    const i = localStorageAvailable();
    if (i) {
      const g = window.localStorage.getItem("stMetricsConfig");
      if (g) {
        this.metricsUrl = g;
        return;
      }
    }
    try {
      const g = await fetch(DEFAULT_METRICS_CONFIG, {
        signal: AbortSignal.timeout(5e3)
      });
      if (!g.ok)
        this.metricsUrl = void 0, LOG$1.error("Failed to fetch metrics config: ", g.status);
      else {
        const E = await g.json();
        this.metricsUrl = E.url ?? void 0, i && this.metricsUrl && window.localStorage.setItem("stMetricsConfig", this.metricsUrl);
      }
    } catch (g) {
      LOG$1.error("Failed to fetch metrics config:", g);
    }
  }
  // The schema of metrics events (including key names and value types) should
  // only be changed when requested by the data team. This is why `reportHash`
  // retains its old name.
  send(i, g = {}) {
    const E = this.buildEventProto(i, g);
    this.metricsUrl === "postMessage" ? this.postMessageEvent(i, E) : this.track(E);
  }
  sendPendingEvents() {
    this.pendingEvents.forEach(([i, g]) => {
      this.send(i, g);
    }), this.pendingEvents = [];
  }
  async track(i) {
    const g = new Request(this.metricsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(i.toJSON())
    });
    await fetch(g);
  }
  // Helper to send metrics events to host
  postMessageEvent(i, g) {
    this.sendMessageToHost({
      type: "METRICS_EVENT",
      eventName: i,
      data: g
    });
  }
  // Helper to build the event proto
  buildEventProto(i, g) {
    const E = new MetricsEvent({
      event: i,
      anonymousId: this.anonymousId,
      ...this.getHostTrackingData(),
      ...this.getInstallationData(),
      reportHash: this.appHash,
      dev: IS_DEV_ENV,
      source: "browser",
      streamlitVersion: this.sessionInfo.current.streamlitVersion,
      isHello: this.sessionInfo.isHello,
      appId: this.sessionInfo.current.appId,
      sessionId: this.sessionInfo.current.sessionId,
      pythonVersion: this.sessionInfo.current.pythonVersion,
      serverOs: this.sessionInfo.current.serverOS,
      hasDisplay: this.sessionInfo.current.hasDisplay,
      isWebdriver: isWebdriver(),
      ...this.getContextData()
    });
    if (i === "menuClick")
      E.label = g.label;
    else if (i === "pageProfile")
      return new MetricsEvent({
        ...E,
        ...g
      });
    return E;
  }
  // Get the installation IDs from the session
  getInstallationData() {
    return {
      machineIdV3: this.sessionInfo.current.installationIdV3,
      machineIdV4: this.sessionInfo.current.installationIdV4
    };
  }
  // Use the tracking data injected by the host of the app if included.
  getHostTrackingData() {
    return this.metadata ? pick$1(this.metadata, ["hostedAt", "owner", "repo", "branch", "mainModule", "creatorId"]) : {};
  }
  // Get context data for events
  getContextData() {
    return {
      contextPageUrl: window.location.href,
      contextPageTitle: document.title,
      contextPagePath: window.location.pathname,
      contextPageReferrer: document.referrer,
      contextPageSearch: window.location.search,
      contextLocale: window.navigator.language,
      contextUserAgent: window.navigator.userAgent
    };
  }
  /**
   * Get/Create user's anonymous ID
   * Checks if existing in cookie or localStorage, otherwise generates
   * a new UUID and stores it in both.
   */
  getAnonymousId() {
    if (!this.actuallySendMetrics) return;
    const i = "ajs_anonymous_id", g = localStorageAvailable(), E = getCookie(i), e = g ? window.localStorage.getItem(i) : null, t = /* @__PURE__ */ new Date();
    if (t.setFullYear((/* @__PURE__ */ new Date()).getFullYear() + 1), E)
      this.anonymousId = E, g && window.localStorage.setItem(i, E);
    else if (e) {
      try {
        this.anonymousId = JSON.parse(e);
      } catch {
        this.anonymousId = e;
      }
      setCookie(i, this.anonymousId, t);
    } else
      this.anonymousId = v4(), setCookie(i, this.anonymousId, t), g && window.localStorage.setItem(i, this.anonymousId);
  }
}
function isWebdriver() {
  return window.navigator?.webdriver ?? !1;
}
class SessionEventDispatcher {
  constructor() {
    this.onSessionEvent = new distExports.Signal();
  }
  /** Redispatches a ForwardMsg.SessionEvent via a signal. */
  handleSessionEventMsg(i) {
    this.onSessionEvent.emit(i);
  }
}
const StyledApp = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "erw9t6i0"
} : {
  target: "erw9t6i0",
  label: "StyledApp"
})(({
  theme: o
}) => {
  const i = hasLightBackgroundColor(o);
  return {
    position: "absolute",
    background: o.colors.bgColor,
    color: o.colors.bodyText,
    top: o.spacing.none,
    left: o.spacing.none,
    right: o.spacing.none,
    bottom: o.spacing.none,
    colorScheme: i ? "light" : "dark",
    overflow: "hidden",
    "@media print": {
      float: "none",
      height: o.sizes.full,
      position: "static",
      overflow: "visible"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function getBrowserInfo() {
  const i = new UAParser().getResult();
  return {
    browserName: i.browser.name || "Unknown",
    browserVersion: i.browser.version || "Unknown",
    /**
     * 'desktop' is not a valid value for device.type in ua-parser-js.
     * We default to 'desktop' if the value is not present.
     * Possible options from ua-parser-js are:
     * 'mobile', 'tablet', 'smarttv', 'wearable', 'embedded', 'console'
     */
    deviceType: i.device.type || "desktop",
    os: i.os.name || "Unknown"
  };
}
const showDevelopmentOptions = (o, i) => i == Config.ToolbarMode.DEVELOPER ? !0 : Config.ToolbarMode.VIEWER == i || Config.ToolbarMode.MINIMAL == i ? !1 : o || isLocalhost();
function getTitle(o) {
  return o || "Streamlit";
}
class AppNavigation {
  constructor(i, g, E, e) {
    this.hostCommunicationMgr = i, this.onUpdatePageUrl = g, this.onPageNotFound = E, this.onPageIconChange = e, this.isPageIconSet = !1, this.isPageTitleSet = !1, this.hasSetDefaultFavicon = !1, this.mainScriptHash = null, this.appPages = [], this.mainPage = null, this.hideSidebarNav = null;
  }
  handleNewSession(i) {
    return this.mainScriptHash !== i.mainScriptHash && (this.isPageTitleSet = !1, this.isPageIconSet = !1, this.hasSetDefaultFavicon = !1), this.mainScriptHash = i.mainScriptHash, this.hideSidebarNav === null && (this.hideSidebarNav = i.config?.hideSidebarNav ?? null), document.title = getTitle(""), [{
      // Set current page script hash to handle SPA case
      currentPageScriptHash: i.pageScriptHash,
      hideSidebarNav: this.hideSidebarNav ?? !1
    }, () => {
    }];
  }
  handleNavigation(i) {
    const {
      sections: g,
      position: E,
      appPages: e
    } = i;
    this.appPages = e, this.hideSidebarNav = E === Navigation.Position.HIDDEN;
    const t = i.pageScriptHash, n = e.find((k) => k.pageScriptHash === t), h = e.find((k) => k.isDefault);
    this.mainPage = h;
    const d = n.urlPathname;
    if (!this.isPageTitleSet) {
      const k = getTitle(n.pageName);
      document.title = k, this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_PAGE_TITLE",
        title: n.pageName ?? ""
      });
    }
    return !this.isPageIconSet && n.icon && this.onPageIconChange(n.icon), this.onUpdatePageUrl(h.urlPathname ?? "", d, n.isDefault ?? !1), [{
      appPages: e,
      navSections: g,
      hideSidebarNav: this.hideSidebarNav,
      expandSidebarNav: i.expanded,
      currentPageScriptHash: t
    }, () => {
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_APP_PAGES",
        appPages: e
      }), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_CURRENT_PAGE_NAME",
        // Make sure we don't send the official page name for the main page
        // This command is used to update the URL in the url bar, so the main page
        // should not have a page name in the URL.
        currentPageName: n.isDefault ? "" : d,
        currentPageScriptHash: t
      });
    }];
  }
  handlePageNotFound(i) {
    return this.onPageNotFound(i), [{
      currentPageScriptHash: this.mainScriptHash ?? ""
    }, () => {
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_CURRENT_PAGE_NAME",
        currentPageName: "",
        currentPageScriptHash: this.mainScriptHash ?? ""
      });
    }];
  }
  findPageByUrlPath(i) {
    return this.appPages.find((g) => (
      // The page name is embedded at the end of the URL path, and if not, we are in the main page.
      // See https://github.com/streamlit/streamlit/blob/1.19.0/frontend/src/App.tsx#L740
      i.endsWith("/" + g.urlPathname)
    )) ?? this.mainPage;
  }
  handlePageConfigChanged(i) {
    i.favicon && (this.isPageIconSet = !0), i.title && (this.isPageTitleSet = !0);
  }
  clearPageElements(i, g) {
    return i.filterMainScriptElements(g);
  }
}
function includeIfDefined(o) {
  return Object.entries(o).reduce((i, [g, E]) => (E !== void 0 && (i[g] = E), i), {});
}
function preferWindowValue(o, i) {
  return o ?? i;
}
function reconcileHostConfigValues(o, i) {
  if (!o)
    return i;
  const g = isValidAllowedOrigins(o.allowedOrigins) ? o.allowedOrigins : void 0;
  return {
    ...i,
    // AppConfig fields
    allowedOrigins: preferWindowValue(g, i.allowedOrigins),
    useExternalAuthToken: preferWindowValue(o.useExternalAuthToken, i.useExternalAuthToken),
    enableCustomParentMessages: preferWindowValue(o.enableCustomParentMessages, i.enableCustomParentMessages),
    blockErrorDialogs: preferWindowValue(o.blockErrorDialogs, i.blockErrorDialogs),
    // LibConfig fields
    mapboxToken: preferWindowValue(o.mapboxToken, i.mapboxToken),
    disableFullscreenMode: preferWindowValue(o.disableFullscreenMode, i.disableFullscreenMode),
    enforceDownloadInNewTab: preferWindowValue(o.enforceDownloadInNewTab, i.enforceDownloadInNewTab),
    resourceCrossOriginMode: preferWindowValue(o.resourceCrossOriginMode, i.resourceCrossOriginMode),
    // Deprecated field - preserve from endpoint (not overridable via window)
    // This is used as a fallback for resourceCrossOriginMode in App.tsx
    setAnonymousCrossOriginPropertyOnMediaElements: i.setAnonymousCrossOriginPropertyOnMediaElements,
    // MetricsConfig fields
    metricsUrl: preferWindowValue(o.metricsUrl, i.metricsUrl)
  };
}
const INITIAL_SCRIPT_RUN_ID = "<null>", LOG = loglevelExports$1.getLogger("App"), aI = class aI extends PureComponent {
  constructor(i) {
    super(i), this.sessionInfo = new SessionInfo(), this.metricsMgr = new MetricsManager(this.sessionInfo), this.sessionEventDispatcher = new SessionEventDispatcher(), this.embeddingId = generateUID$2(), this.appRootRef = createRef(), this.deferredFileListeners = /* @__PURE__ */ new Map(), this.isInitializingConnectionManager = !0, this.hasReceivedNewSession = !1, this.showDeployError = (g, E, e) => {
      const t = {
        type: DialogType.DEPLOY_ERROR,
        title: g,
        msg: E,
        onContinue: e,
        onClose: () => {
        },
        onTryAgain: this.sendLoadGitInfoBackMsg
      };
      this.openDialog(t);
    }, this.handleThemeMessage = (g, E) => {
      const [, e, t] = createPresetThemes(), n = isPresetTheme(this.props.theme.activeTheme);
      g === e.name && n ? this.props.theme.setTheme(e) : g === t.name && n ? this.props.theme.setTheme(t) : E && this.props.theme.setImportedTheme(E);
    }, this.handleConnectionStateChanged = (g) => {
      if (LOG.info(`Connection state changed from ${this.state.connectionState} to ${g}`), g === ConnectionState.CONNECTED) {
        LOG.info("Reconnected to server."), this.state.connectionErrorDismissed && this.setState({
          connectionErrorDismissed: !1
        });
        const E = this.state.scriptRunState === ScriptRunState.RUNNING, e = this.state.scriptRunState === ScriptRunState.RERUN_REQUESTED;
        !this.sessionInfo.last || E || e || // Script is using fragments (fragments in last run or
        // fragment auto-reruns configured):
        this.state.fragmentIdsThisRun.length > 0 || this.state.autoReruns.length > 0 ? (LOG.info("Requesting a script run."), this.widgetMgr.sendUpdateWidgetsMessage(void 0), this.setState({
          dialog: null
        })) : this.state.dialog?.type === DialogType.CONNECTION_ERROR && this.setState({
          dialog: null
        }), this.hostCommunicationMgr.sendMessageToHost({
          type: "WEBSOCKET_CONNECTED"
        });
      } else
        this.state.connectionState === ConnectionState.CONNECTED && this.hostCommunicationMgr.sendMessageToHost({
          type: "WEBSOCKET_DISCONNECTED",
          attemptingToReconnect: g !== ConnectionState.DISCONNECTED_FOREVER
        }), this.sessionInfo.isSet && this.sessionInfo.disconnect();
      this.isInitializingConnectionManager ? this.setState({
        connectionState: g
      }) : flushSync(() => {
        this.setState({
          connectionState: g
        });
      });
    }, this.handleGitInfoChanged = (g) => {
      this.setState({
        gitInfo: g
      });
    }, this.handleCustomParentMessage = (g) => {
      this.state.appConfig.enableCustomParentMessages ? this.hostCommunicationMgr.sendMessageToHost({
        type: "CUSTOM_PARENT_MESSAGE",
        message: g.message
      }) : LOG.error("Sending messages to the host is disabled in line with the platform policy.");
    }, this.handleMessage = (g) => {
      const E = (e, t, n) => {
        const h = e[t];
        if (h in n)
          return n[h](e[h]);
        throw new Error(`Cannot handle ${t} "${h}".`);
      };
      try {
        E(g, "type", {
          newSession: (e) => this.handleNewSession(e),
          sessionStatusChanged: (e) => this.handleSessionStatusChanged(e),
          sessionEvent: (e) => this.handleSessionEvent(e),
          delta: (e) => this.handleDeltaMsg(e, g.metadata),
          pageConfigChanged: (e) => this.handlePageConfigChanged(e),
          pageInfoChanged: (e) => this.handlePageInfoChanged(e),
          // Deprecated protobuf option as navigation will always inform us of pages
          pagesChanged: (e) => {
          },
          pageNotFound: (e) => this.handlePageNotFound(e),
          gitInfoChanged: (e) => this.handleGitInfoChanged(e),
          scriptFinished: (e) => this.handleScriptFinished(e),
          pageProfile: (e) => this.handlePageProfileMsg(e),
          autoRerun: (e) => this.handleAutoRerun(e),
          fileUrlsResponse: (e) => this.uploadClient.onFileURLsResponse(e),
          deferredFileResponse: (e) => this.handleDeferredFileResponse(e),
          parentMessage: (e) => this.handleCustomParentMessage(e),
          logo: (e) => this.handleLogo(e, g.metadata),
          navigation: (e) => this.handleNavigation(e),
          authRedirect: (e) => {
            isInChildFrame() ? this.hostCommunicationMgr.sendMessageToSameOriginHost({
              type: "REDIRECT_TO_URL",
              url: e.url
            }) : window.location.href = e.url;
          }
        });
      } catch (e) {
        const t = ensureError(e);
        LOG.error(t), this.showError("Bad message format", {
          message: t.message
        });
      }
    }, this.handleLogo = (g, E) => {
      this.setState((e) => ({
        elements: e.elements.appRootWithLogo(g, {
          // Pass the current page & run ID for cleanup
          activeScriptHash: E.activeScriptHash,
          scriptRunId: e.scriptRunId
        })
      }));
    }, this.handlePageConfigChanged = (g) => {
      const {
        title: E,
        favicon: e,
        layout: t,
        initialSidebarState: n,
        initialSidebarWidth: h,
        menuItems: d
      } = g;
      this.appNavigation.handlePageConfigChanged(g), E && (this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_PAGE_TITLE",
        title: E
      }), document.title = E), e && this.onPageIconChanged(e), t !== this.state.layout && t !== PageConfig.Layout.LAYOUT_UNSET && this.setState((p) => ({
        layout: t,
        userSettings: {
          ...p.userSettings,
          wideMode: t === PageConfig.Layout.WIDE
        }
      })), n !== this.state.initialSidebarState && n !== PageConfig.SidebarState.SIDEBAR_UNSET && this.setState(() => ({
        initialSidebarState: n
      }));
      const k = h?.pixelWidth !== void 0 ? h.pixelWidth : void 0;
      notNullOrUndefined(k) && k !== this.state.initialSidebarWidth && this.setState(() => ({
        initialSidebarWidth: k
      })), d && this.setState((p) => (d.clearAboutMd && (d.aboutSectionMd = ""), {
        menuItems: {
          ...p.menuItems,
          ...d
        }
      }));
    }, this.handlePageInfoChanged = (g) => {
      const {
        queryString: E
      } = g, e = document.location.pathname + (E ? `?${E}` : "");
      window.history.pushState({}, "", e), this.setState({
        queryParams: E
      }), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_QUERY_PARAM",
        queryParams: E ? `?${E}` : ""
      });
    }, this.onPageNotFound = (g) => {
      const E = g ? `You have requested page /${g}, but no corresponding file was found in the app's pages/ directory` : "The page that you have requested does not seem to exist";
      this.showError("Page not found", {
        message: `${E}. Running the app's main page.`
      });
    }, this.handlePageNotFound = (g) => {
      const {
        pageName: E
      } = g;
      this.maybeSetState(this.appNavigation.handlePageNotFound(E));
    }, this.onPageIconChanged = (g) => {
      handleFavicon(g, this.hostCommunicationMgr.sendMessageToHost, this.endpoints);
    }, this.handleNavigation = (g) => {
      this.setState({
        navigationPosition: g.position
      }), this.maybeSetState(this.appNavigation.handleNavigation(g));
    }, this.handlePageProfileMsg = (g) => {
      const E = PageProfile.toObject(g), e = getBrowserInfo();
      this.metricsMgr.enqueue("pageProfile", {
        ...E,
        isFragmentRun: !!E.isFragmentRun,
        numPages: this.state.appPages?.length,
        pageScriptHash: this.state.currentPageScriptHash,
        activeTheme: this.props.theme?.activeTheme?.name,
        totalLoadTime: Math.round((performance.now() - this.state.latestRunTime) * 1e3),
        browserInfo: e
      });
    }, this.handleAutoRerun = (g) => {
      const E = setInterval(() => {
        this.widgetMgr.sendUpdateWidgetsMessage(g.fragmentId, !0);
      }, g.interval * 1e3);
      this.setState((e) => ({
        autoReruns: [...e.autoReruns, E]
      }));
    }, this.handleSessionStatusChanged = (g) => {
      this.setState((E) => {
        let {
          scriptRunState: e
        } = E, {
          dialog: t
        } = E;
        return g.scriptIsRunning && E.scriptRunState !== ScriptRunState.STOP_REQUESTED ? (e = ScriptRunState.RUNNING, notNullOrUndefined(t) && t.type === DialogType.SCRIPT_COMPILE_ERROR && (t = void 0)) : !g.scriptIsRunning && E.scriptRunState !== ScriptRunState.RERUN_REQUESTED && E.scriptRunState !== ScriptRunState.COMPILATION_ERROR && (e = ScriptRunState.NOT_RUNNING), {
          userSettings: {
            ...E.userSettings,
            runOnSave: !!g.runOnSave
          },
          dialog: t,
          scriptRunState: e,
          // Reset scriptChangedOnDisk when script starts running
          scriptChangedOnDisk: g.scriptIsRunning ? !1 : E.scriptChangedOnDisk
        };
      });
    }, this.handleSessionEvent = (g) => {
      if (this.sessionEventDispatcher.handleSessionEventMsg(g), g.type === "scriptCompilationException") {
        this.setState({
          scriptRunState: ScriptRunState.COMPILATION_ERROR
        });
        const E = {
          type: DialogType.SCRIPT_COMPILE_ERROR,
          exception: g.scriptCompilationException,
          onClose: () => {
          }
        };
        this.maybeShowErrorDialog(E, g.scriptCompilationException?.message ?? "No message");
      } else g.type === "scriptChangedOnDisk" && this.setState({
        scriptChangedOnDisk: !0
      });
    }, this.maybeUpdatePageUrl = (g, E, e) => {
      const t = this.getBaseUriParts();
      if (t) {
        let n;
        StreamlitConfig.MAIN_PAGE_BASE_URL ? n = parseUriIntoBaseParts(StreamlitConfig.MAIN_PAGE_BASE_URL).pathname : n = t.pathname;
        const h = extractPageNameFromPathName(document.location.pathname, n);
        if ((h === "" ? g : h) !== E) {
          const k = e ? "" : E, p = this.state.queryParams || preserveEmbedQueryParams(), M = p ? `?${p}` : "", f = `${n === "/" ? "" : n}/${k}${M}`;
          if (window.location.protocol === "file:") {
            console.warn("Skipping history.pushState() due to file: protocol.");
            return;
          }
          const AA = f.endsWith("/") && f !== "/" ? f.slice(0, -1) : f;
          window.history.pushState({}, "", AA);
        }
      }
    }, this.handleNewSession = (g) => {
      const E = g.initialize;
      if (this.hasStreamlitVersionChanged(E)) {
        window.location.reload();
        return;
      }
      this.hasReceivedNewSession = !0, (!this.sessionInfo.isSet || !this.sessionInfo.current.isConnected) && this.handleInitialization(g);
      const {
        appHash: e,
        currentPageScriptHash: t
      } = this.state, {
        scriptRunId: n,
        name: h,
        mainScriptPath: d,
        fragmentIdsThisRun: k,
        pageScriptHash: p,
        mainScriptHash: M
      } = g;
      if (k.length)
        this.setState({
          fragmentIdsThisRun: k,
          latestRunTime: performance.now()
        });
      else {
        this.cleanupAutoReruns();
        const f = g.config, AA = g.customTheme;
        this.processThemeInput(AA), this.setState({
          allowRunOnSave: f.allowRunOnSave,
          hideTopBar: f.hideTopBar,
          toolbarMode: f.toolbarMode,
          showErrorLinks: f.showErrorLinks,
          latestRunTime: performance.now(),
          mainScriptHash: M,
          // If we're here, the fragmentIdsThisRun variable is always the
          // empty array.
          fragmentIdsThisRun: k
        }), this.maybeSetState(this.appNavigation.handleNewSession(g)), !this.appNavigation.hasSetDefaultFavicon && !this.appNavigation.isPageIconSet && (this.appNavigation.hasSetDefaultFavicon = !0, this.onPageIconChanged("./favicon.png"));
      }
      const H = hashString(this.sessionInfo.current.installationId + d);
      this.metricsMgr.setMetadata(this.state.deployedAppMetadata), this.metricsMgr.setAppHash(H), this.metricsMgr.enqueue("updateReport"), e === H && t === p ? this.setState((f) => ({
        // Clear the transient nodes before executing everything else.
        elements: f.elements.clearTransientNodes(k),
        scriptRunId: n
      })) : this.clearAppState(H, n, h, M);
    }, this.handleInitialization = (g) => {
      const E = g.initialize, e = g.config;
      this.sessionInfo.setCurrent(SessionInfo.propsFromNewSessionMessage(g)), this.metricsMgr.initialize({
        gatherUsageStats: e.gatherUsageStats,
        sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost
      }), this.handleSessionStatusChanged(E.sessionStatus);
    }, this.onHistoryChange = () => {
      const {
        currentPageScriptHash: g
      } = this.state, E = this.appNavigation.findPageByUrlPath(document.location.pathname), e = document.location.toString().includes("#"), t = E?.pageScriptHash === g;
      isNullOrUndefined(E) || e && t || this.onPageChange(E.pageScriptHash, void 0, !0);
    }, this.setAndSendTheme = (g) => {
      this.props.theme.setTheme(g), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_THEME_CONFIG",
        themeInfo: toExportedTheme(g.emotion)
      });
    }, this.createThemeHash = (g) => {
      if (!g)
        return "hash_for_undefined_custom_theme";
      const E = JSON.parse(JSON.stringify(g)), e = sortThemeInputKeys(E);
      return hashString(JSON.stringify(e));
    }, this.closeDialog = () => {
      this.state.dialog?.type === DialogType.CONNECTION_ERROR ? this.setState({
        dialog: void 0,
        connectionErrorDismissed: !0
      }) : this.setState({
        dialog: void 0
      });
    }, this.saveSettings = (g) => {
      const {
        runOnSave: E
      } = this.state.userSettings, {
        runOnSave: e
      } = g;
      if (this.setState({
        userSettings: g
      }), E !== e && this.isServerConnected()) {
        const t = new BackMsg({
          setRunOnSave: e
        });
        t.type = "setRunOnSave", this.sendBackMsg(t);
      }
    }, this.handleDeltaMsg = (g, E) => {
      this.setState((e) => ({
        elements: e.elements.applyDelta(e.scriptRunId, g, E)
      }));
    }, this.debugShutdownRuntime = () => {
      if (this.isServerConnected()) {
        const g = new BackMsg({
          debugShutdownRuntime: !0
        });
        g.type = "debugShutdownRuntime", this.sendBackMsg(g);
      }
    }, this.debugDisconnectWebsocket = () => {
      if (this.isServerConnected()) {
        const g = new BackMsg({
          debugDisconnectWebsocket: !0
        });
        g.type = "debugDisconnectWebsocket", this.sendBackMsg(g);
      }
    }, this.debugClearForwardMsgCache = () => {
      isLocalhost() && this.connectionManager?.websocketConnection?.cache.messages.clear();
    }, this.cleanupAutoReruns = () => {
      this.state.autoReruns.forEach((g) => {
        clearInterval(g);
      }), this.setState({
        autoReruns: []
      });
    }, this.rerunScript = (g = !1) => {
      if (this.closeDialog(), !this.isServerConnected()) {
        LOG.error("Cannot rerun script when disconnected from server.");
        return;
      }
      this.state.scriptRunState === ScriptRunState.RUNNING || this.state.scriptRunState === ScriptRunState.RERUN_REQUESTED || (this.setState({
        scriptRunState: ScriptRunState.RERUN_REQUESTED
      }), g === !0 && this.saveSettings({
        ...this.state.userSettings,
        runOnSave: !0
      }), this.widgetMgr.sendUpdateWidgetsMessage(void 0));
    }, this.sendLoadGitInfoBackMsg = () => {
      if (!this.isServerConnected()) {
        LOG.error("Cannot load git information when disconnected from server.");
        return;
      }
      this.sendBackMsg(new BackMsg({
        loadGitInfo: !0
      }));
    }, this.onPageChange = (g, E, e) => {
      const {
        elements: t,
        mainScriptHash: n
      } = this.state;
      this.cleanupAutoReruns();
      const h = this.appNavigation.clearPageElements(t, n), d = new Set(Array.from(h.getElements()).map((k) => getElementId(k)).filter(notUndefined));
      this.sendRerunBackMsg(this.widgetMgr.getActiveWidgetStates(d), void 0, g, void 0, E, e);
    }, this.isAppInReadyState = (g) => this.state.connectionState === ConnectionState.CONNECTED && this.state.scriptRunState === ScriptRunState.NOT_RUNNING && g.scriptRunState === ScriptRunState.RUNNING && g.connectionState === ConnectionState.CONNECTED, this.sendRerunBackMsg = (g, E, e, t, n, h) => {
      const d = this.getBaseUriParts();
      if (!d) {
        LOG.error("Cannot send rerun backMessage when disconnected from server.");
        return;
      }
      const {
        currentPageScriptHash: k
      } = this.state;
      let p = n ?? this.getQueryString(), M = "";
      const H = {
        timezone: getTimezone$1(),
        timezoneOffset: getTimezoneOffset(),
        locale: getLocaleLanguage(),
        url: getUrl(),
        isEmbedded: isEmbed(),
        colorScheme: this.getThemeColorScheme()
      };
      if (e) {
        if (e !== k && !h) {
          const AA = preserveEmbedQueryParams();
          p = getQueryString(n, AA), this.setState({
            queryParams: p
          }), this.hostCommunicationMgr.sendMessageToHost({
            type: "SET_QUERY_PARAM",
            queryParams: p
          });
        }
      } else if (k)
        e = k;
      else {
        let AA;
        StreamlitConfig.MAIN_PAGE_BASE_URL ? AA = parseUriIntoBaseParts(StreamlitConfig.MAIN_PAGE_BASE_URL).pathname : AA = d.pathname, M = extractPageNameFromPathName(document.location.pathname, AA), e = "";
      }
      const f = this.connectionManager?.getCachedMessageHashes() ?? [];
      this.sendBackMsg(new BackMsg({
        rerunScript: {
          queryString: p,
          widgetStates: g,
          pageScriptHash: e,
          pageName: M,
          fragmentId: E,
          isAutoRerun: t,
          cachedMessageHashes: f,
          contextInfo: H
        }
      })), this.hasReceivedNewSession = !1;
    }, this.stopScript = () => {
      if (!this.isServerConnected()) {
        LOG.error("Cannot stop app when disconnected from server.");
        return;
      }
      if (this.state.scriptRunState === ScriptRunState.NOT_RUNNING || this.state.scriptRunState === ScriptRunState.STOP_REQUESTED)
        return;
      const g = new BackMsg({
        stopScript: !0
      });
      g.type = "stopScript", this.sendBackMsg(g), this.setState({
        scriptRunState: ScriptRunState.STOP_REQUESTED
      });
    }, this.openClearCacheDialog = () => {
      if (this.isServerConnected()) {
        const g = {
          type: DialogType.CLEAR_CACHE,
          confirmCallback: this.clearCache,
          defaultAction: this.clearCache,
          onClose: () => {
          }
        };
        this.openDialog(g);
      } else
        LOG.error("Cannot clear cache: disconnected from server");
    }, this.openDeployDialog = () => {
      const g = {
        type: DialogType.DEPLOY_DIALOG,
        onClose: this.closeDialog,
        showDeployError: this.showDeployError,
        isDeployErrorModalOpen: this.state.dialog?.type === DialogType.DEPLOY_ERROR,
        metricsMgr: this.metricsMgr,
        gitInfo: this.state.gitInfo
      };
      this.openDialog(g);
    }, this.clearCache = () => {
      if (this.closeDialog(), this.isServerConnected()) {
        const g = new BackMsg({
          clearCache: !0
        });
        g.type = "clearCache", this.sendBackMsg(g);
      } else
        LOG.error("Cannot clear cache: disconnected from server");
    }, this.sendAppHeartbeat = () => {
      if (this.isServerConnected()) {
        const g = new BackMsg({
          appHeartbeat: !0
        });
        g.type = "appHeartbeat", this.sendBackMsg(g);
      } else
        LOG.error("Cannot send app heartbeat: disconnected from server");
    }, this.sendBackMsg = (g) => {
      this.connectionManager ? (LOG.info(g), this.connectionManager.sendMessage(g)) : LOG.error(`Not connected. Cannot send back message: ${g}`);
    }, this.handleConnectionError = (g) => {
      this.state.connectionErrorDismissed || this.showError("Connection error", g, DialogType.CONNECTION_ERROR);
    }, this.isServerConnected = () => this.connectionManager ? this.connectionManager.isConnected() : !1, this.settingsCallback = (g = !0) => {
      const E = {
        type: DialogType.SETTINGS,
        sessionInfo: this.sessionInfo,
        isServerConnected: this.isServerConnected(),
        settings: this.state.userSettings,
        allowRunOnSave: this.state.allowRunOnSave && showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode),
        onSave: this.saveSettings,
        onClose: () => {
        },
        animateModal: g,
        metricsMgr: this.metricsMgr
      };
      this.openDialog(E);
    }, this.aboutCallback = () => {
      const {
        menuItems: g
      } = this.state, E = {
        type: DialogType.ABOUT,
        onClose: this.closeDialog,
        aboutSectionMd: g?.aboutSectionMd
      };
      this.openDialog(E);
    }, this.printCallback = () => {
      const {
        scriptRunState: g
      } = this.state;
      if (g !== ScriptRunState.NOT_RUNNING) {
        setTimeout(this.printCallback, 500);
        return;
      }
      let E;
      try {
        const e = getIFrameEnclosingApp(this.embeddingId);
        e?.contentWindow ? E = e.contentWindow.window : E = window;
      } catch {
        E = window;
      } finally {
        E || (E = window), E.print();
      }
    }, this.screencastCallback = () => {
      const {
        scriptName: g
      } = this.state, {
        startRecording: E
      } = this.props.screenCast, e = getScreencastTimestamp();
      E(`streamlit-${g}-${e}`);
    }, this.handleFullScreen = (g) => {
      this.setState({
        isFullScreen: g
      });
    }, this.setLibConfig = (g) => {
      this.setState({
        libConfig: g
      });
    }, this.setAppConfig = (g) => {
      this.setState({
        appConfig: g
      });
    }, this.addScriptFinishedHandler = (g) => {
      this.setState((E, e) => ({
        scriptFinishedHandlers: E.scriptFinishedHandlers.concat(g)
      }));
    }, this.removeScriptFinishedHandler = (g) => {
      this.setState((E, e) => ({
        scriptFinishedHandlers: E.scriptFinishedHandlers.filter((t) => t !== g)
      }));
    }, this.getBaseUriParts = () => this.connectionManager ? this.connectionManager.getBaseUriParts() : void 0, this.getQueryString = () => {
      const {
        queryParams: g
      } = this.state, E = g && g.length > 0 ? g : document.location.search;
      return E.startsWith("?") ? E.substring(1) : E;
    }, this.getThemeColorScheme = () => {
      const {
        activeTheme: g
      } = this.props.theme;
      return hasLightBackgroundColor(g.emotion) ? "light" : "dark";
    }, this.isInCloudEnvironment = () => {
      const {
        hostMenuItems: g
      } = this.state;
      return g && g?.length > 0;
    }, this.showDeployButton = () => showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode) && !this.isInCloudEnvironment() && this.sessionInfo.isSet && !this.sessionInfo.isHello, this.deployButtonClicked = () => {
      this.metricsMgr.enqueue("menuClick", {
        label: "deployButtonInApp"
      }), this.sendLoadGitInfoBackMsg(), this.openDeployDialog();
    }, this.requestFileURLs = (g, E) => {
      const e = this.isServerConnected(), t = this.sessionInfo.isSet;
      if (e && t) {
        const n = new BackMsg({
          fileUrlsRequest: {
            requestId: g,
            fileNames: E.map((h) => h.name),
            sessionId: this.sessionInfo.current.sessionId
          }
        });
        n.type = "fileUrlsRequest", this.sendBackMsg(n);
      } else
        LOG.warn(`Cannot request file URLs (isServerConnected: ${e}, isSessionInfoSet: ${t})`), this.uploadClient.onFileURLsResponse({
          responseId: g,
          errorMsg: "Connection lost. Please wait for the app to reconnect, then try again."
        });
    }, this.requestDeferredFile = (g) => {
      const E = this.isServerConnected(), e = this.sessionInfo.isSet;
      if (!E || !e)
        return Promise.reject(new Error("Not connected to server or session not initialized"));
      const t = Promise.withResolvers(), n = this.deferredFileListeners.get(g) ?? /* @__PURE__ */ new Set(), h = (k) => {
        n.delete(h), t.resolve(k);
      };
      n.add(h), this.deferredFileListeners.set(g, n);
      const d = new BackMsg({
        deferredFileRequest: {
          fileId: g,
          sessionId: this.sessionInfo.current.sessionId
        }
      });
      return d.type = "deferredFileRequest", this.sendBackMsg(d), t.promise;
    }, this.handleDeferredFileResponse = (g) => {
      const E = this.deferredFileListeners.get(g.fileId);
      if (!(!E || E.size === 0)) {
        for (const e of Array.from(E))
          try {
            e(g);
          } catch {
          }
        this.deferredFileListeners.delete(g.fileId);
      }
    }, this.handleKeyDown = (g, E) => {
      if (!((g === "c" || g === "r") && isKeyboardEventFromEditableTarget(E)))
        switch (g) {
          case "c":
            showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode) && this.openClearCacheDialog();
            break;
          case "r":
            this.rerunScript();
            break;
        }
    }, this.handleKeyUp = (g) => {
      g === "esc" && this.props.screenCast.stopRecording();
    }, this.hasAppDefinedMenuItems = () => {
      const {
        menuItems: g
      } = this.state;
      return !!(g?.aboutSectionMd || g?.getHelpUrl && !g?.hideGetHelp || g?.reportABugUrl && !g?.hideReportABug);
    }, this.shouldShowToolbar = (g, E) => {
      const e = !isEmbed() || isToolbarDisplayed();
      let t;
      return this.state.toolbarMode === Config.ToolbarMode.MINIMAL ? t = g.length > 0 || E.length > 0 || this.hasAppDefinedMenuItems() : t = !0, e && t;
    }, ensureHotkeysFilterConfigured(), enablePatches(), enableMapSet(), this.state = {
      connectionState: ConnectionState.INITIAL,
      elements: AppRoot.empty("", !0),
      // Blank Main Script Hash for initial render
      isFullScreen: !1,
      scriptName: "",
      scriptRunId: INITIAL_SCRIPT_RUN_ID,
      appHash: null,
      scriptRunState: ScriptRunState.NOT_RUNNING,
      userSettings: {
        wideMode: !1,
        runOnSave: !1
      },
      connectionErrorDismissed: !1,
      layout: PageConfig.Layout.CENTERED,
      initialSidebarState: PageConfig.SidebarState.AUTO,
      initialSidebarWidth: void 0,
      menuItems: void 0,
      allowRunOnSave: !0,
      scriptFinishedHandlers: [],
      showErrorLinks: Config.ShowErrorLinks.SHOW_ERROR_LINKS_AUTO,
      // Initialize themeHash to empty string to ensure the first processThemeInput
      // call always processes the theme (whether null or custom theme from server).
      // This prevents the bug where a cached custom theme isn't cleared when the
      // server sends null, because null and undefined both hash to the same value.
      themeHash: "",
      gitInfo: null,
      formsData: createFormsData(),
      appPages: [],
      navSections: [],
      currentPageScriptHash: "",
      mainScriptHash: "",
      // We set hideTopBar to true by default because this information isn't
      // available on page load (we get it when the script begins to run), so
      // the user would see top bar elements for a few ms if this defaulted to
      // false. hideSidebarNav doesn't have this issue (app pages and the value
      // of the config option are received simultaneously), but we set it to
      // true as well for consistency.
      hideTopBar: !0,
      hideSidebarNav: !0,
      expandSidebarNav: !1,
      toolbarMode: Config.ToolbarMode.MINIMAL,
      latestRunTime: performance.now(),
      fragmentIdsThisRun: [],
      // Information sent from the host
      isOwner: !1,
      hostMenuItems: [],
      hostToolbarItems: [],
      hostHideSidebarNav: !1,
      sidebarChevronDownshift: 0,
      pageLinkBaseUrl: "",
      queryParams: "",
      deployedAppMetadata: {},
      libConfig: {},
      appConfig: {},
      autoReruns: [],
      inputsDisabled: !1,
      navigationPosition: Navigation.Position.SIDEBAR,
      scriptChangedOnDisk: !1
    }, this.connectionManager = null, this.widgetMgr = new WidgetStateManager({
      sendRerunBackMsg: this.sendRerunBackMsg,
      formsDataChanged: (g) => this.setState({
        formsData: g
      })
    }), this.hostCommunicationMgr = new HostCommunicationManager({
      streamlitExecutionStartedAt: i.streamlitExecutionStartedAt,
      sendRerunBackMsg: this.sendRerunBackMsg,
      closeModal: this.closeDialog,
      stopScript: this.stopScript,
      rerunScript: this.rerunScript,
      clearCache: this.clearCache,
      sendAppHeartbeat: this.sendAppHeartbeat,
      setInputsDisabled: (g) => {
        this.setState({
          inputsDisabled: g
        });
      },
      themeChanged: this.handleThemeMessage,
      pageChanged: (g) => this.onPageChange(g),
      isOwnerChanged: (g) => this.setState({
        isOwner: g
      }),
      fileUploadClientConfigChanged: (g) => {
        this.endpoints.setFileUploadClientConfig !== void 0 && this.endpoints.setFileUploadClientConfig(g);
      },
      hostMenuItemsChanged: (g) => {
        this.setState({
          hostMenuItems: g
        });
      },
      hostToolbarItemsChanged: (g) => {
        this.setState({
          hostToolbarItems: g
        });
      },
      hostHideSidebarNavChanged: (g) => {
        this.setState({
          hostHideSidebarNav: g
        });
      },
      sidebarChevronDownshiftChanged: (g) => {
        this.setState({
          sidebarChevronDownshift: g
        });
      },
      pageLinkBaseUrlChanged: (g) => {
        this.setState({
          pageLinkBaseUrl: g
        });
      },
      queryParamsChanged: (g) => {
        this.setState({
          queryParams: g
        });
      },
      deployedAppMetadataChanged: (g) => {
        this.setState({
          deployedAppMetadata: g
        });
      },
      restartWebsocketConnection: () => {
        this.connectionManager || (this.setState({
          scriptRunState: ScriptRunState.RERUN_REQUESTED
        }), this.initializeConnectionManager());
      },
      terminateWebsocketConnection: () => {
        this.connectionManager?.disconnect(), this.connectionManager = null;
      }
    }), this.endpoints = new DefaultStreamlitEndpoints({
      getServerUri: this.getBaseUriParts,
      csrfEnabled: !0,
      sendClientError: (g, E, e, t, n) => {
        this.hostCommunicationMgr.sendMessageToHost({
          type: "CLIENT_ERROR",
          component: g,
          error: E,
          message: e,
          source: t,
          customComponentName: n
        });
      }
    }), this.uploadClient = new FileUploadClient({
      sessionInfo: this.sessionInfo,
      endpoints: this.endpoints,
      // A form cannot be submitted if it contains a FileUploader widget
      // that's currently uploading. We write that state here, in response
      // to a FileUploadClient callback. The FormSubmitButton element
      // reads the state.
      formsWithPendingRequestsChanged: (g) => this.widgetMgr.setFormsWithUploadsInProgress(g),
      requestFileURLs: this.requestFileURLs
    }), this.componentRegistry = new ComponentRegistry(this.endpoints), this.appNavigation = new AppNavigation(this.hostCommunicationMgr, this.maybeUpdatePageUrl, this.onPageNotFound, this.onPageIconChanged), window.streamlitDebug = {
      clearForwardMsgCache: this.debugClearForwardMsgCache,
      disconnectWebsocket: this.debugDisconnectWebsocket,
      shutdownRuntime: this.debugShutdownRuntime
    };
  }
  applyInitialHostConfig() {
    if (!isHostConfigBypassEnabled())
      return;
    const i = StreamlitConfig.HOST_CONFIG, g = includeIfDefined({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      allowedOrigins: i.allowedOrigins,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      useExternalAuthToken: i.useExternalAuthToken,
      enableCustomParentMessages: i.enableCustomParentMessages,
      blockErrorDialogs: i.blockErrorDialogs
    });
    this.hostCommunicationMgr.setAllowedOrigins(g), this.setAppConfig(g);
    const E = includeIfDefined({
      mapboxToken: i.mapboxToken,
      disableFullscreenMode: i.disableFullscreenMode,
      enforceDownloadInNewTab: i.enforceDownloadInNewTab,
      resourceCrossOriginMode: i.resourceCrossOriginMode
    });
    Object.keys(E).length > 0 && this.setLibConfig(E), i.metricsUrl !== void 0 && this.metricsMgr.setMetricsConfig(i.metricsUrl);
  }
  initializeConnectionManager() {
    this.isInitializingConnectionManager = !0, this.applyInitialHostConfig();
    const i = this.context?.kernel;
    if (i == null)
      throw new Error("Kernel is not set in the context.");
    this.connectionManager = new ConnectionManager({
      kernel: i,
      getLastSessionId: () => this.sessionInfo.last?.sessionId,
      endpoints: this.endpoints,
      onMessage: this.handleMessage,
      onConnectionError: this.handleConnectionError,
      connectionStateChanged: this.handleConnectionStateChanged,
      claimHostAuthToken: this.hostCommunicationMgr.claimAuthToken,
      resetHostAuthToken: this.hostCommunicationMgr.resetAuthToken,
      sendClientError: (g, E, e) => {
        this.hostCommunicationMgr.sendMessageToHost({
          type: "CLIENT_ERROR",
          component: "Websocket Connection",
          error: g,
          message: E,
          source: e
        });
      },
      onHostConfigResp: (g) => {
        const E = reconcileHostConfigValues(StreamlitConfig.HOST_CONFIG, g), {
          allowedOrigins: e,
          useExternalAuthToken: t,
          disableFullscreenMode: n,
          enableCustomParentMessages: h,
          mapboxToken: d,
          enforceDownloadInNewTab: k,
          metricsUrl: p,
          blockErrorDialogs: M,
          setAnonymousCrossOriginPropertyOnMediaElements: H,
          resourceCrossOriginMode: f
        } = E, AA = {
          allowedOrigins: e,
          useExternalAuthToken: t,
          enableCustomParentMessages: h,
          blockErrorDialogs: M
        }, gA = {
          mapboxToken: d,
          disableFullscreenMode: n,
          enforceDownloadInNewTab: k,
          // Use resourceCrossOriginMode if provided, otherwise fall back to
          // deprecated setAnonymousCrossOriginPropertyOnMediaElements (if true, use "anonymous")
          resourceCrossOriginMode: f ?? (H ? "anonymous" : void 0)
        };
        this.metricsMgr.setMetricsConfig(p), this.hostCommunicationMgr.setAllowedOrigins(AA), this.setAppConfig(AA), this.setLibConfig(gA);
      }
    }), this.isInitializingConnectionManager = !1;
  }
  componentDidMount() {
    const i = this.context?.kernel;
    if (i == null)
      throw new Error("Kernel is not set in the context.");
    this.initializeConnectionManager(), mark(this.state.scriptRunState), this.hostCommunicationMgr.sendMessageToHost({
      type: "SCRIPT_RUN_STATE_CHANGED",
      scriptRunState: this.state.scriptRunState
    }), this.uploadClient.setKernel(i), isScrollingHidden() && document.body.classList.add("embedded"), isInChildFrame() && (window.iFrameResizer = {
      heightCalculationMethod: () => {
        const g = document.querySelectorAll("[data-iframe-height]"), E = Array.from(g).map((e) => (
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          Math.ceil(e.getBoundingClientRect().bottom)
        ));
        return Math.max(0, ...E);
      }
    }, import("./iframeResizer.contentWindow-ZIS7a60S.js").then((g) => g.i)), this.hostCommunicationMgr.sendMessageToHost({
      type: "SET_THEME_CONFIG",
      themeInfo: toExportedTheme(this.props.theme.activeTheme.emotion)
    }), this.metricsMgr.enqueue("viewReport"), window.addEventListener("popstate", this.onHistoryChange, !1);
  }
  componentDidUpdate(i, g) {
    if (window.prerenderReady === !1 && this.isAppInReadyState(g) && (window.prerenderReady = !0), this.state.scriptRunState !== g.scriptRunState) {
      if (mark(this.state.scriptRunState), this.state.scriptRunState === ScriptRunState.NOT_RUNNING)
        try {
          measure("script-run-cycle", ScriptRunState.RUNNING, ScriptRunState.NOT_RUNNING);
        } catch {
        }
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SCRIPT_RUN_STATE_CHANGED",
        scriptRunState: this.state.scriptRunState
      });
    }
  }
  componentWillUnmount() {
    this.connectionManager?.disconnect(), this.hostCommunicationMgr.closeHostCommunication(), window.removeEventListener("popstate", this.onHistoryChange, !1);
  }
  /**
   * Checks whether to show error dialog or send error info
   * to be handled by the host.
   */
  maybeShowErrorDialog(i, g) {
    const {
      blockErrorDialogs: E
    } = this.state.appConfig;
    E || this.openDialog(i);
    const t = i.type === DialogType.SCRIPT_COMPILE_ERROR ? i.type : i.title;
    this.hostCommunicationMgr.sendMessageToHost({
      type: "CLIENT_ERROR_DIALOG",
      error: t,
      message: g
    });
  }
  showError(i, g, E = DialogType.WARNING) {
    LOG.error(g.message);
    const e = {
      type: E,
      title: i,
      msg: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogErrorMessage$1, { message: g.message, codeBlock: g.codeBlock }),
      onClose: () => {
      }
    };
    this.maybeShowErrorDialog(e, g.message);
  }
  /**
   * Checks if the code version from the backend is different than the frontend
   */
  hasStreamlitVersionChanged(i) {
    let g;
    if (StreamlitConfig.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION === !0 ? g = PACKAGE_METADATA.version : this.sessionInfo.isSet && (g = this.sessionInfo.current.streamlitVersion), g) {
      const {
        environmentInfo: E
      } = i;
      if (notNullOrUndefined(E) && notNullOrUndefined(E.streamlitVersion))
        return g != E.streamlitVersion;
    }
    return !1;
  }
  maybeSetState(i) {
    if (i) {
      const [g, E] = i;
      this.setState(g, E);
    }
  }
  processThemeInput(i) {
    const g = this.createThemeHash(i);
    if (g === this.state.themeHash)
      return;
    this.setState({
      themeHash: g
    });
    const E = !isPresetTheme(this.props.theme.activeTheme);
    if (i) {
      const e = createCustomThemes(i);
      this.props.theme.addThemes(e, {
        keepPresetThemes: !1
      });
      const t = getPreferredTheme(e);
      if (t)
        this.setAndSendTheme(t);
      else if (e.length > 1) {
        const n = e.findIndex((h) => h.name === CUSTOM_THEME_AUTO_NAME);
        this.setAndSendTheme(e[n]);
      } else
        this.setAndSendTheme(e[0]);
    } else if (this.props.theme.addThemes([]), E) {
      const t = getPreferredTheme([lightTheme, darkTheme]);
      t ? this.setAndSendTheme(t) : this.setAndSendTheme(createAutoTheme());
    }
    (i?.fontFaces && i.fontFaces.length > 0 || i?.fontSources && i.fontSources.length > 0) && this.props.theme.setFonts(i);
  }
  /**
   * Handler for ForwardMsg.scriptFinished messages
   * @param status the ScriptFinishedStatus that the script finished with
   */
  handleScriptFinished(i) {
    (i === ForwardMsg.ScriptFinishedStatus.FINISHED_SUCCESSFULLY || i === ForwardMsg.ScriptFinishedStatus.FINISHED_EARLY_FOR_RERUN || i === ForwardMsg.ScriptFinishedStatus.FINISHED_FRAGMENT_RUN_SUCCESSFULLY) && (Promise.resolve().then(() => {
      this.state.scriptFinishedHandlers.forEach((g) => g());
    }), (i === ForwardMsg.ScriptFinishedStatus.FINISHED_SUCCESSFULLY || i === ForwardMsg.ScriptFinishedStatus.FINISHED_FRAGMENT_RUN_SUCCESSFULLY) && this.setState(({
      scriptRunId: g,
      fragmentIdsThisRun: E,
      elements: e
    }) => ({
      // Apply any pending elements that haven't been applied.
      elements: e.clearStaleNodes(g, E)
    }), () => {
      const g = new Set(
        // TODO: Update to match React best practices
        // eslint-disable-next-line @eslint-react/no-access-state-in-setstate
        Array.from(this.state.elements.getElements()).map((E) => getElementId(E)).filter(notUndefined)
      );
      this.widgetMgr.removeInactive(g);
    }), this.connectionManager !== null && i !== ForwardMsg.ScriptFinishedStatus.FINISHED_EARLY_FOR_RERUN && this.sessionInfo.isSet && // We only increment the message cache run count if we have received
    // a NewSession message after the latest rerun request. This is done
    // to ignore finished messages from previous script runs, which would
    // cause issues with deleting cached messages that are needed for the
    // current script run.
    this.hasReceivedNewSession && this.connectionManager.incrementMessageCacheRunCount(this.sessionInfo.current.maxCachedMessageAge, this.state.fragmentIdsThisRun));
  }
  /*
   * Clear all elements from the state.
   */
  clearAppState(i, g, E, e) {
    this.setState((t) => {
      const n = this.appNavigation.clearPageElements(t.elements, e);
      return {
        scriptRunId: g,
        scriptName: E,
        appHash: i,
        elements: n
      };
    }, () => {
      const t = new Set(
        // TODO: Update to match React best practices
        // eslint-disable-next-line @eslint-react/no-access-state-in-setstate
        Array.from(this.state.elements.getElements()).map((n) => getElementId(n)).filter(notUndefined)
      );
      this.widgetMgr.removeInactive(t);
    });
  }
  /**
   * Opens a dialog with the specified state.
   */
  openDialog(i) {
    this.setState({
      dialog: i
    });
  }
  render() {
    const {
      allowRunOnSave: i,
      connectionState: g,
      dialog: E,
      elements: e,
      initialSidebarState: t,
      menuItems: n,
      isFullScreen: h,
      scriptRunId: d,
      scriptRunState: k,
      userSettings: p,
      hideTopBar: M,
      hideSidebarNav: H,
      expandSidebarNav: f,
      currentPageScriptHash: AA,
      hostHideSidebarNav: gA,
      pageLinkBaseUrl: IA,
      sidebarChevronDownshift: BA,
      hostMenuItems: CA,
      hostToolbarItems: QA,
      libConfig: iA,
      inputsDisabled: EA,
      appPages: oA,
      navSections: eA,
      navigationPosition: GA,
      scriptChangedOnDisk: cA
    } = this.state, tA = this.props.isMobileViewport ? Navigation.Position.SIDEBAR : GA, aA = showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode), sA = classNames("stApp", getEmbeddingIdClassName(this.embeddingId), {
      "streamlit-embedded": isEmbed(),
      "streamlit-wide": p.wideMode
    }), DA = E ? StreamlitDialog({
      ...E,
      onClose: this.closeDialog
    }) : null, rA = this.shouldShowToolbar(CA, QA), nA = !isEmbed() || isPaddingDisplayed(), NA = isScrollingHidden();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      StreamlitContextProvider$1,
      {
        initialSidebarState: t,
        initialSidebarWidth: this.state.initialSidebarWidth,
        appRootRef: this.appRootRef,
        pageLinkBaseUrl: IA,
        currentPageScriptHash: AA,
        onPageChange: this.onPageChange,
        navSections: eA,
        appPages: oA,
        appLogo: e.logo,
        sidebarChevronDownshift: BA,
        expandSidebarNav: f,
        hideSidebarNav: H || gA || tA === Navigation.Position.TOP,
        isFullScreen: h,
        setFullScreen: this.handleFullScreen,
        activeTheme: this.props.theme.activeTheme,
        setTheme: this.setAndSendTheme,
        availableThemes: this.props.theme.availableThemes,
        fragmentIdsThisRun: this.state.fragmentIdsThisRun,
        locale: window.navigator.language,
        formsData: this.state.formsData,
        scriptRunState: k,
        scriptRunId: d,
        mapboxToken: iA.mapboxToken,
        enforceDownloadInNewTab: iA.enforceDownloadInNewTab,
        resourceCrossOriginMode: iA.resourceCrossOriginMode,
        showErrorLinks: this.state.showErrorLinks,
        requestDeferredFile: this.requestDeferredFile,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReactHotkeys, { keyName: "r,c,esc", onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledApp, { ref: this.appRootRef, className: sA, "data-testid": "stApp", "data-test-script-state": d == INITIAL_SCRIPT_RUN_ID ? "initial" : k, "data-test-connection-state": g, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(AppView, { endpoints: this.endpoints, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, elements: e, widgetMgr: this.widgetMgr, uploadClient: this.uploadClient, navigationPosition: tA, wideMode: p.wideMode, embedded: isEmbed(), showPadding: nA, disableScrolling: NA, addScriptFinishedHandler: this.addScriptFinishedHandler, removeScriptFinishedHandler: this.removeScriptFinishedHandler, widgetsDisabled: EA || g !== ConnectionState.CONNECTED, showToolbar: rA, disableFullscreenMode: iA.disableFullscreenMode, componentRegistry: this.componentRegistry, topRightContent: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            !M && /* @__PURE__ */ jsxRuntimeExports.jsx(StatusWidget, { connectionState: g, scriptRunState: k, rerunScript: this.rerunScript, stopScript: this.stopScript, allowRunOnSave: i, showScriptChangedActions: cA }),
            !M && /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarActions, { hostToolbarItems: QA, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, metricsMgr: this.metricsMgr }),
            this.showDeployButton() && !cA && /* @__PURE__ */ jsxRuntimeExports.jsx(DeployButton, { onClick: this.deployButtonClicked }),
            !M && /* @__PURE__ */ jsxRuntimeExports.jsx(MainMenu$1, { isServerConnected: this.isServerConnected(), quickRerunCallback: this.rerunScript, clearCacheCallback: this.openClearCacheDialog, settingsCallback: this.settingsCallback, aboutCallback: this.aboutCallback, printCallback: this.printCallback, screencastCallback: this.screencastCallback, screenCastState: this.props.screenCast.currentState, hostMenuItems: CA, developmentMode: aA, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, menuItems: n, metricsMgr: this.metricsMgr, toolbarMode: this.state.toolbarMode })
          ] }) }),
          DA
        ] }) })
      }
    );
  }
};
aI.contextType = StliteKernelContext;
let App = aI;
const AppWithScreenCast = withScreencast(App), AppWrapper = (o) => {
  const {
    isMobile: i
  } = useViewportSize();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AppWithScreenCast, { ...o, isMobileViewport: i });
}, getSystemCustomTheme = (o) => o.find((i) => i.name === (getSystemThemePreference() === "dark" ? CUSTOM_THEME_DARK_NAME : CUSTOM_THEME_LIGHT_NAME)), createAutoCustomTheme = (o) => ({
  ...o,
  name: CUSTOM_THEME_AUTO_NAME,
  displayName: AUTO_THEME_NAME
});
function useThemeManager() {
  const o = getDefaultTheme(), [i, g] = useState(o), [E, e] = useState(o.themeInput?.fontFaces ?? []), [t, n] = useState(null), [h, d] = useState(() => [...createPresetThemes(), ...isPresetTheme(o) ? [] : [o]]), k = useRef(h);
  useEffect(() => {
    k.current = h;
  }, [h]);
  const p = useCallback((IA, BA = {}) => {
    const {
      keepPresetThemes: CA = !0
    } = BA, QA = [...CA ? createPresetThemes() : [], ...IA];
    k.current = QA, d(QA);
  }, []), M = useCallback((IA, BA = {}) => {
    const {
      persist: CA = !0
    } = BA;
    g((QA) => IA !== QA ? (CA && setCachedThemeSelection(IA), IA) : QA);
  }, []), H = useCallback((IA) => {
    if (IA.name === AUTO_THEME_NAME) {
      M(getHostSpecifiedTheme());
      return;
    }
    if (IA.name === CUSTOM_THEME_AUTO_NAME) {
      const BA = getSystemCustomTheme(k.current);
      if (BA) {
        M(createAutoCustomTheme(BA));
        return;
      }
    }
    M(IA);
  }, [M]), f = useCallback(() => {
    const IA = getHostSpecifiedTheme();
    i.name === AUTO_THEME_NAME && M(IA, {
      persist: !1
    });
    const BA = h.filter((QA) => QA.name !== AUTO_THEME_NAME), CA = BA.some((QA) => QA.name === CUSTOM_THEME_AUTO_NAME);
    if (CA && i.name === CUSTOM_THEME_AUTO_NAME) {
      const QA = getSystemCustomTheme(BA);
      QA && M(createAutoCustomTheme(QA), {
        persist: !1
      });
    }
    d(CA ? BA : [createAutoTheme(), ...BA]);
  }, [i.name, h, M]), AA = useCallback((IA) => {
    IA.fontFaces && e(IA.fontFaces);
    const BA = [...IA.fontSources || [], ...IA.sidebar?.fontSources || []], CA = {};
    BA.forEach((QA) => {
      QA.sourceUrl && QA.configName && (CA[QA.configName] = QA.sourceUrl);
    }), n(Object.keys(CA).length > 0 ? CA : null);
  }, []), gA = useCallback((IA) => {
    AA(IA);
    const BA = new CustomThemeConfig(IA), CA = createTheme(CUSTOM_THEME_NAME, BA);
    H(CA);
  }, [AA, H]);
  return useEffect(() => {
    const IA = window.matchMedia("(prefers-color-scheme: dark)");
    return IA.addEventListener("change", f), window.addEventListener("afterprint", f), () => {
      window.removeEventListener("afterprint", f), IA.removeEventListener("change", f);
    };
  }, [f]), [{
    setTheme: H,
    activeTheme: i,
    addThemes: p,
    availableThemes: h,
    setFonts: AA,
    setImportedTheme: gA
  }, E, t];
}
const appStyles = (o) => /* @__PURE__ */ css("font-size:", o.fontSizes.baseFontSize, "px;*,*::before,*::after{box-sizing:border-box;}margin:0;font-family:", o.genericFonts.bodyFont, ";font-weight:", o.fontWeights.normal, ";line-height:", o.lineHeights.base, ";color:", o.colors.bodyText, ";background-color:", o.colors.bgColor, ";-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:", transparentize(o.colors.black, 1), ';-webkit-font-smoothing:auto;[tabindex="-1"]:focus:not(:focus-visible){outline:0!important;}p,ol,ul,dl{margin:0 0 1rem 0;padding:0;font-size:1rem;font-weight:', o.fontWeights.normal, ';}ol ol,ul ul,ol ul,ul ol{margin-bottom:0;}a:not([href]):not([class]){&,&:hover{color:inherit;text-decoration:none;}}img,svg{vertical-align:middle;}input,button,select,optgroup,textarea{margin:0;font-family:inherit;line-height:inherit;font-size:inherit;}button,input{overflow:visible;}button,[role="button"]{&:not(:disabled){cursor:pointer;}}button,[type="button"],[type="reset"],[type="submit"]{-webkit-appearance:button;}[hidden]{display:none!important;}@supports (scrollbar-color: transparent transparent){*{scrollbar-width:thin;scrollbar-color:transparent transparent;}*:hover{scrollbar-color:', o.colors.fadedText40, " transparent;}}@supports not (scrollbar-color: transparent transparent){::-webkit-scrollbar{background:transparent;border-radius:", o.radii.full, ";height:6px;width:6px;}::-webkit-scrollbar:active{background:", o.colors.fadedText10, ";}:hover::-webkit-scrollbar-thumb:vertical,:hover::-webkit-scrollbar-thumb:horizontal{background:", o.colors.fadedText40, ";border-radius:", o.radii.full, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:appStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const documentStyles = process.env.NODE_ENV === "production" ? {
  name: "cqykvy",
  styles: "html,body{height:100%;margin:0;}@media print{html{height:100%;print-color-adjust:exact;-webkit-print-color-adjust:exact;}}"
} : {
  name: "vld0b3-documentStyles",
  styles: "html,body{height:100%;margin:0;}@media print{html{height:100%;print-color-adjust:exact;-webkit-print-color-adjust:exact;}};label:documentStyles;/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvcGFja2FnZXMvcmVhY3Qvc3JjL2RvY3VtZW50U3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3BhY2thZ2VzL3JlYWN0L3NyYy9kb2N1bWVudFN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgZG9jdW1lbnRTdHlsZXMgPSBjc3NgXG4gIGh0bWwsXG4gIGJvZHkge1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBtYXJnaW46IDA7XG4gIH1cblxuICBAbWVkaWEgcHJpbnQge1xuICAgIGh0bWwge1xuICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgLyogbWFrZSBiYWNrZ3JvdW5kLWNvbG9ycyBhcHBlYXIgYnkgZGVmYXVsdCAoZS5nLiB0aGUgc2lkZWJhciBiYWNrZ3JvdW5kLFxuICAgICAgICogd2lkZ2V0IGJhY2tncm91bmQsIG11bHRpLXNlbGVjdCBlbGVtZW50IGJhY2tncm91bmQsIC4uLikgKi9cbiAgICAgIHByaW50LWNvbG9yLWFkanVzdDogZXhhY3Q7XG4gICAgICAtd2Via2l0LXByaW50LWNvbG9yLWFkanVzdDogZXhhY3Q7XG4gICAgfVxuICB9XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}, ALPHABET = "abcdefghijklmnopqrstuvwxyz";
let idCounter = 0;
function randomChars(o) {
  const {
    crypto: i
  } = globalThis;
  if (i?.getRandomValues) {
    const g = new Uint32Array(o);
    return i.getRandomValues(g), Array.from(g, (E) => ALPHABET[E % ALPHABET.length]).join("");
  }
  return Array.from({
    length: o
  }, () => ALPHABET[Math.floor(Math.random() * ALPHABET.length)]).join("");
}
function toAlphabeticString(o) {
  if (o === 0) return "a";
  const i = [];
  let g = o;
  for (; g > 0; )
    i.unshift(ALPHABET[g % ALPHABET.length]), g = Math.floor(g / ALPHABET.length);
  return i.join("");
}
function generateUniqueId(o = 8) {
  if (o <= 0) return "";
  const i = toAlphabeticString(idCounter++), g = toAlphabeticString(Date.now()), E = `${i}${g}${randomChars(o)}`;
  return E.length >= o ? E.slice(0, o) : `${E}${randomChars(o - E.length)}`;
}
function useUniqueId(o = 8) {
  return useMemo$1(() => generateUniqueId(o), [o]);
}
function RootStyleProvider(o) {
  const {
    children: i,
    theme: g,
    styleNonce: E,
    disableDocumentStyles: e
  } = o, t = useUniqueId(), n = useMemo$1(() => createCache({
    key: `st-${t}`,
    ...E && {
      nonce: E
    }
  }), [t, E]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseProvider,
    {
      theme: g.basewebTheme,
      zIndex: g.emotion.zIndices.popup,
      overrides: {
        // BaseUI's LayersManager renders portal content (popovers, modals,
        // tooltips) into a LayersContainer that is a sibling of the app
        // content, not a descendant. In standard Streamlit, text styles
        // (font-family, font-size, etc.) are set on `body` so portals
        // inherit them. In stlite, these styles are scoped to the
        // stlite-root div (via appStyles) to avoid polluting the host page,
        // so the LayersContainer needs them explicitly.
        // Keep these in sync with the inheritable text styles in appStyles.ts.
        LayersContainer: {
          style: {
            fontFamily: g.emotion.genericFonts.bodyFont,
            fontSize: `${g.emotion.fontSizes.baseFontSize}px`,
            fontWeight: g.emotion.fontWeights.normal,
            lineHeight: g.emotion.lineHeights.base,
            color: g.emotion.colors.bodyText
          }
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CacheProvider, { value: n, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider$2, { theme: g.emotion, children: [
        !e && /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: documentStyles }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ClassNames, { children: ({
          css: h,
          cx: d
        }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: d(h(
          // "appStyles" contains the styles that are applied to the app root.
          // In the original Streamlit, these were "globalStyles" applied to the body,
          // but in Stlite they are scoped to this root element to allow embedding.
          appStyles(g.emotion)
        ), "stlite-root"), children: i }) })
      ] }) })
    }
  );
}
const ThemedApp = ({
  styleNonce: o,
  streamlitExecutionStartedAt: i,
  disableDocumentStyles: g
}) => {
  const [E, e, t] = useThemeManager(), {
    activeTheme: n
  } = E;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootStyleProvider, { theme: n, styleNonce: o, disableDocumentStyles: g, children: /* @__PURE__ */ jsxRuntimeExports.jsx(WindowDimensionsProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalProvider, { children: [
    e.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(FontFaceDeclaration, { fontFaces: e }),
    t && /* @__PURE__ */ jsxRuntimeExports.jsx(FontSources, { fontSources: t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppWrapper, { theme: E, streamlitExecutionStartedAt: i })
  ] }) }) });
};
class SequentialIDGenerator {
  constructor(i = "") {
    this.prefix = i, this.count = 0, this.offset = 374, this.msb = 1295, this.power = 2;
  }
  next() {
    const i = this.increment().toString(36);
    return this.prefix ? `${this.prefix}${i}` : i;
  }
  increment() {
    const i = this.count + this.offset;
    return i === this.msb && (this.offset += (this.msb + 1) * 9, this.msb = Math.pow(36, ++this.power) - 1), this.count++, i;
  }
}
const minMaxWidth = /(!?\(\s*min(-device-)?-width).+\(\s*max(-device)?-width/i, minWidth = /\(\s*min(-device)?-width/i, maxMinWidth = /(!?\(\s*max(-device)?-width).+\(\s*min(-device)?-width/i, maxWidth = /\(\s*max(-device)?-width/i, isMinWidth = _testQuery(minMaxWidth, maxMinWidth, minWidth), isMaxWidth = _testQuery(maxMinWidth, minMaxWidth, maxWidth), minMaxHeight = /(!?\(\s*min(-device)?-height).+\(\s*max(-device)?-height/i, minHeight = /\(\s*min(-device)?-height/i, maxMinHeight = /(!?\(\s*max(-device)?-height).+\(\s*min(-device)?-height/i, maxHeight = /\(\s*max(-device)?-height/i, isMinHeight = _testQuery(minMaxHeight, maxMinHeight, minHeight), isMaxHeight = _testQuery(maxMinHeight, minMaxHeight, maxHeight), isPrint = /print/i, isPrintOnly = /^print$/i, maxValue = Number.MAX_VALUE;
function _getQueryLength(o) {
  const i = /(-?\d*\.?\d+)(ch|em|ex|px|rem)/.exec(o);
  if (i === null)
    return maxValue;
  let g = i[1];
  switch (i[2]) {
    case "ch":
      g = parseFloat(g) * 8.8984375;
      break;
    case "em":
    case "rem":
      g = parseFloat(g) * 16;
      break;
    case "ex":
      g = parseFloat(g) * 8.296875;
      break;
    case "px":
      g = parseFloat(g);
      break;
  }
  return +g;
}
function _testQuery(o, i, g) {
  return function(E) {
    return o.test(E) ? !0 : i.test(E) ? !1 : g.test(E);
  };
}
function _testIsPrint(o, i) {
  const g = isPrint.test(o), E = isPrintOnly.test(o), e = isPrint.test(i), t = isPrintOnly.test(i);
  return g && e ? !E && t ? 1 : E && !t ? -1 : o.localeCompare(i) : g ? 1 : e ? -1 : null;
}
function sortCSSmq(o, i) {
  if (o === "")
    return -1;
  if (i === "")
    return 1;
  const g = _testIsPrint(o, i);
  if (g !== null)
    return g;
  const E = isMinWidth(o) || isMinHeight(o), e = isMaxWidth(o) || isMaxHeight(o), t = isMinWidth(i) || isMinHeight(i), n = isMaxWidth(i) || isMaxHeight(i);
  if (E && n)
    return -1;
  if (e && t)
    return 1;
  const h = _getQueryLength(o), d = _getQueryLength(i);
  return h === maxValue && d === maxValue ? o.localeCompare(i) : h === maxValue ? 1 : d === maxValue ? -1 : h > d ? e ? -1 : 1 : h < d ? e ? 1 : -1 : o.localeCompare(i);
}
class MultiCache {
  constructor(i, g, E) {
    this.idGenerator = i, this.onNewCache = g, this.onNewValue = E, this.sortedCacheKeys = [], this.caches = {};
  }
  getCache(i) {
    if (!this.caches[i]) {
      const g = new Cache(this.idGenerator, this.onNewValue);
      g.key = i, this.sortedCacheKeys.push(i), this.sortedCacheKeys.sort(sortCSSmq);
      const E = this.sortedCacheKeys.indexOf(i), e = E < this.sortedCacheKeys.length - 1 ? this.sortedCacheKeys[E + 1] : void 0;
      this.caches[i] = g, this.onNewCache(i, g, e);
    }
    return this.caches[i];
  }
  getSortedCacheKeys() {
    return this.sortedCacheKeys;
  }
}
class Cache {
  constructor(i, g) {
    this.cache = {}, this.idGenerator = i, this.onNewValue = g;
  }
  addValue(i, g) {
    const E = this.cache[i];
    if (E)
      return E;
    const e = this.idGenerator.next();
    return this.cache[i] = e, this.onNewValue(this, e, g), e;
  }
}
const uppercasePattern$1 = /[A-Z]/g, msPattern$1 = /^ms-/, cache$1 = {};
function hyphenateStyleName$2(o) {
  return o in cache$1 ? cache$1[o] : cache$1[o] = o.replace(uppercasePattern$1, "-$&").toLowerCase().replace(msPattern$1, "-ms-");
}
const shorthandMap = {
  // CSS 2.1: https://www.w3.org/TR/CSS2/propidx.html
  "list-style": ["list-style-type", "list-style-position", "list-style-image"],
  margin: ["margin-top", "margin-right", "margin-bottom", "margin-left"],
  outline: ["outline-width", "outline-style", "outline-color"],
  padding: ["padding-top", "padding-right", "padding-bottom", "padding-left"],
  // CSS Backgrounds and Borders Module Level 3: https://www.w3.org/TR/css3-background/
  background: ["background-image", "background-position", "background-size", "background-repeat", "background-origin", "background-clip", "background-attachment", "background-color"],
  border: ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width", "border-width", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-style", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-color"],
  "border-color": ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"],
  "border-style": ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"],
  "border-width": ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"],
  "border-top": ["border-top-width", "border-top-style", "border-top-color"],
  "border-right": ["border-right-width", "border-right-style", "border-right-color"],
  "border-bottom": ["border-bottom-width", "border-bottom-style", "border-bottom-color"],
  "border-left": ["border-left-width", "border-left-style", "border-left-color"],
  "border-radius": ["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"],
  "border-image": ["border-image-source", "border-image-slice", "border-image-width", "border-image-outset", "border-image-repeat"],
  // CSS Fonts Module Level 3: https://www.w3.org/TR/css3-fonts/
  font: ["font-style", "font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian", "font-variant", "font-weight", "font-stretch", "font-size", "line-height", "font-family"],
  "font-variant": ["font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian"],
  // CSS Flexible Box Layout Module Level 1: https://www.w3.org/TR/css3-flexbox-1/
  flex: ["flex-grow", "flex-shrink", "flex-basis"],
  "flex-flow": ["flex-direction", "flex-wrap"],
  // CSS Grid Layout Module Level 1: https://www.w3.org/TR/css-grid-1/
  grid: ["grid-template-rows", "grid-template-columns", "grid-template-areas", "grid-auto-rows", "grid-auto-columns", "grid-auto-flow"],
  "grid-template": ["grid-template-rows", "grid-template-columns", "grid-template-areas"],
  "grid-row": ["grid-row-start", "grid-row-end"],
  "grid-column": ["grid-column-start", "grid-column-end"],
  "grid-area": ["grid-row-start", "grid-column-start", "grid-row-end", "grid-column-end"],
  "grid-gap": ["grid-row-gap", "grid-column-gap"],
  // CSS Masking Module Level 1: https://www.w3.org/TR/css-masking/
  mask: ["mask-image", "mask-mode", "mask-position", "mask-size", "mask-repeat", "mask-origin", "mask-clip"],
  "mask-border": ["mask-border-source", "mask-border-slice", "mask-border-width", "mask-border-outset", "mask-border-repeat", "mask-border-mode"],
  // CSS Multi-column Layout Module: https://www.w3.org/TR/css3-multicol/
  columns: ["column-width", "column-count"],
  "column-rule": ["column-rule-width", "column-rule-style", "column-rule-color"],
  // CSS Scroll Snap Module Level 1: https://www.w3.org/TR/css-scroll-snap-1/
  "scroll-padding": ["scroll-padding-top", "scroll-padding-right", "scroll-padding-bottom", "scroll-padding-left"],
  "scroll-padding-block": ["scroll-padding-block-start", "scroll-padding-block-end"],
  "scroll-padding-inline": ["scroll-padding-inline-start", "scroll-padding-inline-end"],
  "scroll-snap-margin": ["scroll-snap-margin-top", "scroll-snap-margin-right", "scroll-snap-margin-bottom", "scroll-snap-margin-left"],
  "scroll-snap-margin-block": ["scroll-snap-margin-block-start", "scroll-snap-margin-block-end"],
  "scroll-snap-margin-inline": ["scroll-snap-margin-inline-start", "scroll-snap-margin-inline-end"],
  // CSS Speech Module: https://www.w3.org/TR/css3-speech/
  cue: ["cue-before", "cue-after"],
  pause: ["pause-before", "pause-after"],
  rest: ["rest-before", "rest-after"],
  // CSS Text Decoration Module Level 3: https://www.w3.org/TR/css-text-decor-3/
  "text-decoration": ["text-decoration-line", "text-decoration-style", "text-decoration-color"],
  "text-emphasis": ["text-emphasis-style", "text-emphasis-color"],
  // CSS Animations (WD): https://www.w3.org/TR/css3-animations
  animation: ["animation-name", "animation-duration", "animation-timing-function", "animation-delay", "animation-iteration-count", "animation-direction", "animation-fill-mode", "animation-play-state"],
  // CSS Transitions (WD): https://www.w3.org/TR/css3-transitions/
  transition: ["transition-property", "transition-duration", "transition-timing-function", "transition-delay"]
};
function validateNoMixedHand(o) {
  const i = Object.keys(o).reduce((E, e) => (E[hyphenateStyleName$2(e)] = e, E), {}), g = [];
  for (const E in i)
    if (E in shorthandMap) {
      for (const e of shorthandMap[E])
        if (e in i) {
          const t = i[e], n = i[E];
          g.push({
            shorthand: {
              property: n,
              value: o[n]
            },
            longhand: {
              property: t,
              value: o[t]
            }
          });
        }
    }
  return g;
}
function capitalizeString(o) {
  return o.charAt(0).toUpperCase() + o.slice(1);
}
function prefixProperty(o, i, g) {
  if (o.hasOwnProperty(i)) {
    for (var E = {}, e = o[i], t = capitalizeString(i), n = Object.keys(g), h = 0; h < n.length; h++) {
      var d = n[h];
      if (d === i)
        for (var k = 0; k < e.length; k++)
          E[e[k] + t] = g[i];
      E[d] = g[d];
    }
    return E;
  }
  return g;
}
function prefixValue$1(o, i, g, E, e) {
  for (var t = 0, n = o.length; t < n; ++t) {
    var h = o[t](i, g, E, e);
    if (h)
      return h;
  }
}
function addIfNew(o, i) {
  o.indexOf(i) === -1 && o.push(i);
}
function addNewValuesOnly(o, i) {
  if (Array.isArray(i))
    for (var g = 0, E = i.length; g < E; ++g)
      addIfNew(o, i[g]);
  else
    addIfNew(o, i);
}
function isObject(o) {
  return o instanceof Object && !Array.isArray(o);
}
function createPrefixer(o) {
  var i = o.prefixMap, g = o.plugins;
  return function E(e) {
    for (var t in e) {
      var n = e[t];
      if (isObject(n))
        e[t] = E(n);
      else if (Array.isArray(n)) {
        for (var h = [], d = 0, k = n.length; d < k; ++d) {
          var p = prefixValue$1(g, t, n[d], e, i);
          addNewValuesOnly(h, p || n[d]);
        }
        h.length > 0 && (e[t] = h);
      } else {
        var M = prefixValue$1(g, t, n, e, i);
        M && (e[t] = M), e = prefixProperty(i, t, e);
      }
    }
    return e;
  };
}
var w = ["Webkit"], m = ["Moz"], ms = ["ms"], wm = ["Webkit", "Moz"], wms = ["Webkit", "ms"], wmms = ["Webkit", "Moz", "ms"];
const data = {
  prefixMap: { appearance: wm, textEmphasisPosition: w, textEmphasis: w, textEmphasisStyle: w, textEmphasisColor: w, boxDecorationBreak: w, maskImage: w, maskMode: w, maskRepeat: w, maskPosition: w, maskClip: w, maskOrigin: w, maskSize: w, maskComposite: w, mask: w, maskBorderSource: w, maskBorderMode: w, maskBorderSlice: w, maskBorderWidth: w, maskBorderOutset: w, maskBorderRepeat: w, maskBorder: w, maskType: w, textDecorationStyle: w, textDecorationSkip: w, textDecorationLine: w, textDecorationColor: w, userSelect: wmms, backdropFilter: w, fontKerning: w, scrollSnapType: wms, scrollSnapPointsX: wms, scrollSnapPointsY: wms, scrollSnapDestination: wms, scrollSnapCoordinate: wms, clipPath: w, shapeImageThreshold: w, shapeImageMargin: w, shapeImageOutside: w, filter: w, hyphens: wms, flowInto: wms, flowFrom: wms, breakBefore: wms, breakAfter: wms, breakInside: wms, regionFragment: wms, writingMode: wms, textOrientation: w, tabSize: m, fontFeatureSettings: w, columnCount: w, columnFill: w, columnGap: w, columnRule: w, columnRuleColor: w, columnRuleStyle: w, columnRuleWidth: w, columns: w, columnSpan: w, columnWidth: w, wrapFlow: ms, wrapThrough: ms, wrapMargin: ms, textSizeAdjust: wms }
};
function backgroundClip(o, i) {
  if (typeof i == "string" && i === "text")
    return ["-webkit-text", "text"];
}
var prefixes$5 = ["-webkit-", "-moz-", ""], values$3 = {
  "zoom-in": !0,
  "zoom-out": !0,
  grab: !0,
  grabbing: !0
};
function cursor(o, i) {
  if (o === "cursor" && values$3.hasOwnProperty(i))
    return prefixes$5.map(function(g) {
      return g + i;
    });
}
var isPrefixedValue$1 = { exports: {} }, hasRequiredIsPrefixedValue;
function requireIsPrefixedValue() {
  return hasRequiredIsPrefixedValue || (hasRequiredIsPrefixedValue = 1, (function(o, i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = E;
    var g = /-webkit-|-moz-|-ms-/;
    function E(e) {
      return typeof e == "string" && g.test(e);
    }
    o.exports = i.default;
  })(isPrefixedValue$1, isPrefixedValue$1.exports)), isPrefixedValue$1.exports;
}
var isPrefixedValueExports = requireIsPrefixedValue();
const isPrefixedValue = /* @__PURE__ */ getDefaultExportFromCjs(isPrefixedValueExports);
var prefixes$4 = ["-webkit-", ""];
function crossFade(o, i) {
  if (typeof i == "string" && !isPrefixedValue(i) && i.indexOf("cross-fade(") > -1)
    return prefixes$4.map(function(g) {
      return i.replace(/cross-fade\(/g, g + "cross-fade(");
    });
}
var prefixes$3 = ["-webkit-", ""];
function filter(o, i) {
  if (typeof i == "string" && !isPrefixedValue(i) && i.indexOf("filter(") > -1)
    return prefixes$3.map(function(g) {
      return i.replace(/filter\(/g, g + "filter(");
    });
}
var values$2 = {
  flex: ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex", "flex"],
  "inline-flex": ["-webkit-inline-box", "-moz-inline-box", "-ms-inline-flexbox", "-webkit-inline-flex", "inline-flex"]
};
function flex(o, i) {
  if (o === "display" && values$2.hasOwnProperty(i))
    return values$2[i];
}
var alternativeValues = {
  "space-around": "justify",
  "space-between": "justify",
  "flex-start": "start",
  "flex-end": "end",
  "wrap-reverse": "multiple",
  wrap: "multiple"
}, alternativeProps$1 = {
  alignItems: "WebkitBoxAlign",
  justifyContent: "WebkitBoxPack",
  flexWrap: "WebkitBoxLines",
  flexGrow: "WebkitBoxFlex"
};
function flexboxOld(o, i, g) {
  o === "flexDirection" && typeof i == "string" && (i.indexOf("column") > -1 ? g.WebkitBoxOrient = "vertical" : g.WebkitBoxOrient = "horizontal", i.indexOf("reverse") > -1 ? g.WebkitBoxDirection = "reverse" : g.WebkitBoxDirection = "normal"), alternativeProps$1.hasOwnProperty(o) && (g[alternativeProps$1[o]] = alternativeValues[i] || i);
}
var prefixes$2 = ["-webkit-", "-moz-", ""], values$1 = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
function gradient(o, i) {
  if (typeof i == "string" && !isPrefixedValue(i) && values$1.test(i))
    return prefixes$2.map(function(g) {
      return i.replace(values$1, function(E) {
        return g + E;
      });
    });
}
var _slicedToArray = /* @__PURE__ */ (function() {
  function o(i, g) {
    var E = [], e = !0, t = !1, n = void 0;
    try {
      for (var h = i[Symbol.iterator](), d; !(e = (d = h.next()).done) && (E.push(d.value), !(g && E.length === g)); e = !0)
        ;
    } catch (k) {
      t = !0, n = k;
    } finally {
      try {
        !e && h.return && h.return();
      } finally {
        if (t) throw n;
      }
    }
    return E;
  }
  return function(i, g) {
    if (Array.isArray(i))
      return i;
    if (Symbol.iterator in Object(i))
      return o(i, g);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
})();
function isSimplePositionValue(o) {
  return typeof o == "number" && !isNaN(o);
}
function isComplexSpanValue(o) {
  return typeof o == "string" && o.includes("/");
}
var alignmentValues = ["center", "end", "start", "stretch"], displayValues = {
  "inline-grid": ["-ms-inline-grid", "inline-grid"],
  grid: ["-ms-grid", "grid"]
}, propertyConverters = {
  alignSelf: function o(i, g) {
    alignmentValues.indexOf(i) > -1 && (g.msGridRowAlign = i);
  },
  gridColumn: function o(i, g) {
    if (isSimplePositionValue(i))
      g.msGridColumn = i;
    else if (isComplexSpanValue(i)) {
      var E = i.split("/"), e = _slicedToArray(E, 2), t = e[0], n = e[1];
      propertyConverters.gridColumnStart(+t, g);
      var h = n.split(/ ?span /), d = _slicedToArray(h, 2), k = d[0], p = d[1];
      k === "" ? propertyConverters.gridColumnEnd(+t + +p, g) : propertyConverters.gridColumnEnd(+n, g);
    } else
      propertyConverters.gridColumnStart(i, g);
  },
  gridColumnEnd: function o(i, g) {
    var E = g.msGridColumn;
    isSimplePositionValue(i) && isSimplePositionValue(E) && (g.msGridColumnSpan = i - E);
  },
  gridColumnStart: function o(i, g) {
    isSimplePositionValue(i) && (g.msGridColumn = i);
  },
  gridRow: function o(i, g) {
    if (isSimplePositionValue(i))
      g.msGridRow = i;
    else if (isComplexSpanValue(i)) {
      var E = i.split("/"), e = _slicedToArray(E, 2), t = e[0], n = e[1];
      propertyConverters.gridRowStart(+t, g);
      var h = n.split(/ ?span /), d = _slicedToArray(h, 2), k = d[0], p = d[1];
      k === "" ? propertyConverters.gridRowEnd(+t + +p, g) : propertyConverters.gridRowEnd(+n, g);
    } else
      propertyConverters.gridRowStart(i, g);
  },
  gridRowEnd: function o(i, g) {
    var E = g.msGridRow;
    isSimplePositionValue(i) && isSimplePositionValue(E) && (g.msGridRowSpan = i - E);
  },
  gridRowStart: function o(i, g) {
    isSimplePositionValue(i) && (g.msGridRow = i);
  },
  gridTemplateColumns: function o(i, g) {
    g.msGridColumns = i;
  },
  gridTemplateRows: function o(i, g) {
    g.msGridRows = i;
  },
  justifySelf: function o(i, g) {
    alignmentValues.indexOf(i) > -1 && (g.msGridColumnAlign = i);
  }
};
function grid(o, i, g) {
  if (o === "display" && i in displayValues)
    return displayValues[i];
  if (o in propertyConverters) {
    var E = propertyConverters[o];
    E(i, g);
  }
}
var prefixes$1 = ["-webkit-", ""];
function imageSet(o, i) {
  if (typeof i == "string" && !isPrefixedValue(i) && i.indexOf("image-set(") > -1)
    return prefixes$1.map(function(g) {
      return i.replace(/image-set\(/g, g + "image-set(");
    });
}
var alternativeProps = {
  marginBlockStart: ["WebkitMarginBefore"],
  marginBlockEnd: ["WebkitMarginAfter"],
  marginInlineStart: ["WebkitMarginStart", "MozMarginStart"],
  marginInlineEnd: ["WebkitMarginEnd", "MozMarginEnd"],
  paddingBlockStart: ["WebkitPaddingBefore"],
  paddingBlockEnd: ["WebkitPaddingAfter"],
  paddingInlineStart: ["WebkitPaddingStart", "MozPaddingStart"],
  paddingInlineEnd: ["WebkitPaddingEnd", "MozPaddingEnd"],
  borderBlockStart: ["WebkitBorderBefore"],
  borderBlockStartColor: ["WebkitBorderBeforeColor"],
  borderBlockStartStyle: ["WebkitBorderBeforeStyle"],
  borderBlockStartWidth: ["WebkitBorderBeforeWidth"],
  borderBlockEnd: ["WebkitBorderAfter"],
  borderBlockEndColor: ["WebkitBorderAfterColor"],
  borderBlockEndStyle: ["WebkitBorderAfterStyle"],
  borderBlockEndWidth: ["WebkitBorderAfterWidth"],
  borderInlineStart: ["WebkitBorderStart", "MozBorderStart"],
  borderInlineStartColor: ["WebkitBorderStartColor", "MozBorderStartColor"],
  borderInlineStartStyle: ["WebkitBorderStartStyle", "MozBorderStartStyle"],
  borderInlineStartWidth: ["WebkitBorderStartWidth", "MozBorderStartWidth"],
  borderInlineEnd: ["WebkitBorderEnd", "MozBorderEnd"],
  borderInlineEndColor: ["WebkitBorderEndColor", "MozBorderEndColor"],
  borderInlineEndStyle: ["WebkitBorderEndStyle", "MozBorderEndStyle"],
  borderInlineEndWidth: ["WebkitBorderEndWidth", "MozBorderEndWidth"]
};
function logical(o, i, g) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, o))
    for (var E = alternativeProps[o], e = 0, t = E.length; e < t; ++e)
      g[E[e]] = i;
}
function position(o, i) {
  if (o === "position" && i === "sticky")
    return ["-webkit-sticky", "sticky"];
}
var prefixes = ["-webkit-", "-moz-", ""], properties$1 = {
  maxHeight: !0,
  maxWidth: !0,
  width: !0,
  height: !0,
  columnWidth: !0,
  minWidth: !0,
  minHeight: !0
}, values = {
  "min-content": !0,
  "max-content": !0,
  "fill-available": !0,
  "fit-content": !0,
  "contain-floats": !0
};
function sizing(o, i) {
  if (properties$1.hasOwnProperty(o) && values.hasOwnProperty(i))
    return prefixes.map(function(g) {
      return g + i;
    });
}
var hyphenateProperty$1 = { exports: {} }, uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
function toHyphenLower(o) {
  return "-" + o.toLowerCase();
}
function hyphenateStyleName(o) {
  if (cache.hasOwnProperty(o))
    return cache[o];
  var i = o.replace(uppercasePattern, toHyphenLower);
  return cache[o] = msPattern.test(i) ? "-" + i : i;
}
const hyphenateStyleName$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hyphenateStyleName
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(hyphenateStyleName$1);
var hasRequiredHyphenateProperty;
function requireHyphenateProperty() {
  return hasRequiredHyphenateProperty || (hasRequiredHyphenateProperty = 1, (function(o, i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = t;
    var g = require$$0, E = e(g);
    function e(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function t(n) {
      return (0, E.default)(n);
    }
    o.exports = i.default;
  })(hyphenateProperty$1, hyphenateProperty$1.exports)), hyphenateProperty$1.exports;
}
var hyphenatePropertyExports = requireHyphenateProperty();
const hyphenateProperty = /* @__PURE__ */ getDefaultExportFromCjs(hyphenatePropertyExports);
var properties = {
  transition: !0,
  transitionProperty: !0,
  WebkitTransition: !0,
  WebkitTransitionProperty: !0,
  MozTransition: !0,
  MozTransitionProperty: !0
}, prefixMapping = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-"
};
function prefixValue(o, i) {
  if (isPrefixedValue(o))
    return o;
  for (var g = o.split(/,(?![^()]*(?:\([^()]*\))?\))/g), E = 0, e = g.length; E < e; ++E) {
    var t = g[E], n = [t];
    for (var h in i) {
      var d = hyphenateProperty(h);
      if (t.indexOf(d) > -1 && d !== "order")
        for (var k = i[h], p = 0, M = k.length; p < M; ++p)
          n.unshift(t.replace(d, prefixMapping[k[p]] + d));
    }
    g[E] = n.join(",");
  }
  return g.join(",");
}
function transition(o, i, g, E) {
  if (typeof i == "string" && properties.hasOwnProperty(o)) {
    var e = prefixValue(i, E), t = e.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function(h) {
      return !/-moz-|-ms-/.test(h);
    }).join(",");
    if (o.indexOf("Webkit") > -1)
      return t;
    var n = e.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function(h) {
      return !/-webkit-|-ms-/.test(h);
    }).join(",");
    return o.indexOf("Moz") > -1 ? n : (g["Webkit" + capitalizeString(o)] = t, g["Moz" + capitalizeString(o)] = n, e);
  }
}
var plugins = [backgroundClip, crossFade, cursor, filter, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition, flex], prefix = createPrefixer({
  prefixMap: data.prefixMap,
  plugins
});
function injectStylePrefixed(o, i, g, E) {
  const e = o.getCache(g);
  let t = "";
  for (const n in i) {
    const h = i[n];
    if (h != null)
      if (typeof h != "object") {
        process.env.NODE_ENV !== "production" && validateValueType(h, n);
        const d = `${hyphenateStyleName$2(n)}:${h}`, k = `${E}${d}`, p = e.cache[k];
        if (p !== void 0) {
          t += " " + p;
          continue;
        } else {
          let M = "";
          const H = prefix({
            [n]: h
          });
          for (const AA in H) {
            const gA = H[AA], IA = typeof gA;
            if (IA === "string" || IA === "number") {
              const BA = `${hyphenateStyleName$2(AA)}:${gA}`;
              BA !== d && (M += `${BA};`);
            } else if (Array.isArray(gA)) {
              const BA = hyphenateStyleName$2(AA);
              for (let CA = 0; CA < gA.length; CA++) {
                const QA = `${BA}:${gA[CA]}`;
                QA !== d && (M += `${QA};`);
              }
            }
          }
          M += d;
          const f = e.addValue(k, {
            pseudo: E,
            block: M
          });
          t += " " + f;
        }
      } else
        n[0] === ":" ? t += " " + injectStylePrefixed(o, h, g, E + n) : n.substring(0, 6) === "@media" && (t += " " + injectStylePrefixed(o, h, n.substr(7), E));
  }
  if (process.env.NODE_ENV !== "production") {
    const n = validateNoMixedHand(i);
    n.length && n.forEach(({
      shorthand: h,
      longhand: d
    }) => {
      const k = JSON.stringify({
        [h.property]: h.value
      }), p = JSON.stringify({
        [d.property]: d.value
      });
      console.warn(`Styles \`${k}\` and \`${p}\` in object yielding class "${t.slice(1)}" may result in unexpected behavior. Mixing shorthand and longhand properties within the same style object is unsupported with atomic rendering.`);
    });
  }
  return t.slice(1);
}
function validateValueType(o, i) {
  if (o === null || Array.isArray(o) || typeof o != "number" && typeof o != "string")
    throw new Error(`Unsupported style value: ${JSON.stringify(o)} used in property ${JSON.stringify(i)}`);
}
const validAnimationState = /^(from|to|\+?(\d*\.)?\d+%)(\s*,\s*(from|to|\+?(\d*\.)?\d+%))*$/;
function validateKeyframesObject(o) {
  let i = !0;
  for (const g in o) {
    const E = o[g];
    validAnimationState.test(g) || (i = !1, console.warn(`Warning: property "${g}" in keyframes object ${JSON.stringify(o)} is not a valid. Must be "from", "to", or a percentage.`)), typeof E != "object" && (i = !1, console.warn(`Warning: value for "${g}" property in keyframes object ${JSON.stringify(o)} must be an object. Instead it was a ${typeof E}.`)), i || console.warn('Warning: object used as value for "animationName" style is invalid:', o);
  }
}
function atomicSelector(o, i) {
  let g = `.${o}`;
  return i && (g += i), g;
}
function keyframesToBlock(o) {
  process.env.NODE_ENV !== "production" && validateKeyframesObject(o), process.env.NODE_ENV !== "production" && typeof Object.getPrototypeOf(o) < "u" && Object.getPrototypeOf(o) !== Object.getPrototypeOf({}) && console.warn("Only plain objects should be used as animation values. Unexpectedly recieved:", o);
  let i = "";
  for (const g in o)
    i += `${g}{${declarationsToBlock(o[g])}}`;
  return i;
}
function declarationsToBlock(o) {
  let i = "";
  for (const g in o) {
    const E = o[g];
    (typeof E == "string" || typeof E == "number") && (i += `${hyphenateStyleName$2(g)}:${E};`);
  }
  return i.slice(0, -1);
}
function keyframesBlockToRule(o, i) {
  return `@keyframes ${o}{${i}}`;
}
function fontFaceBlockToRule(o, i) {
  return `@font-face{font-family:${o};${i}}`;
}
function styleBlockToRule(o, i) {
  return `${o}{${i}}`;
}
const insertRuleIntoDevtools = (o, i) => {
  const g = o.substring(1, o.indexOf(":") !== -1 ? o.indexOf(":") : o.length), E = {};
  for (const e of i.split(";"))
    e.trim() !== "" && !window.__STYLETRON_DEVTOOLS__.atomicMap[g] && (E[e.substring(0, e.indexOf(":"))] = e.substring(e.indexOf(":") + 1, e.length));
  window.__STYLETRON_DEVTOOLS__.atomicMap[g] = E;
}, hydrateDevtoolsRule = (o) => {
  const i = o.substring(0, 3), g = o.substring(4, o.length - 1);
  insertRuleIntoDevtools(i, g);
}, STYLES_HYDRATOR = /\.([^{:]+)(:[^{]+)?{(?:[^}]*;)?([^}]*?)}/g, KEYFRAMES_HYRDATOR = /@keyframes ([^{]+){((?:(?:from|to|(?:\d+\.?\d*%))\{(?:[^}])*})*)}/g, FONT_FACE_HYDRATOR = /@font-face\{font-family:([^;]+);([^}]*)\}/g;
function hydrateStyles(o, i, g) {
  let E;
  for (; E = i.exec(g); ) {
    const [, e, t, n] = E;
    process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && hydrateDevtoolsRule(E[0]);
    const h = t ? `${t}${n}` : n;
    o.cache[h] = e, o.idGenerator.increment();
  }
}
function hydrate(o, i, g) {
  let E;
  for (; E = i.exec(g); ) {
    const [, e, t] = E;
    process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && hydrateDevtoolsRule(E[0]), o.cache[t] = e, o.idGenerator.increment();
  }
}
class StyletronClient {
  constructor(i = {}) {
    this.styleElements = {};
    const g = new SequentialIDGenerator(i.prefix), E = (e, t, n) => {
      const {
        pseudo: h,
        block: d
      } = n, k = this.styleElements[e.key].sheet, p = atomicSelector(t, h), M = styleBlockToRule(p, d);
      try {
        k.insertRule(M, k.cssRules.length), process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && insertRuleIntoDevtools(p, d);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${M}". Perhaps this has invalid or un-prefixed properties?`);
      }
    };
    if (this.styleCache = new MultiCache(g, (e, t, n) => {
      const h = document.createElement("style");
      if (h.media = e, n === void 0)
        this.container.appendChild(h);
      else {
        const d = findSheetIndexWithMedia(this.container.children, n);
        this.container.insertBefore(h, this.container.children[d]);
      }
      this.styleElements[e] = h;
    }, E), this.keyframesCache = new Cache(new SequentialIDGenerator(i.prefix), (e, t, n) => {
      this.styleCache.getCache("");
      const h = this.styleElements[""].sheet, d = keyframesBlockToRule(t, keyframesToBlock(n));
      try {
        h.insertRule(d, h.cssRules.length);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${d}". Perhaps this has invalid or un-prefixed properties?`);
      }
    }), this.fontFaceCache = new Cache(new SequentialIDGenerator(i.prefix), (e, t, n) => {
      this.styleCache.getCache("");
      const h = this.styleElements[""].sheet, d = fontFaceBlockToRule(t, declarationsToBlock(n));
      try {
        h.insertRule(d, h.cssRules.length);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${d}". Perhaps this has invalid or un-prefixed properties?`);
      }
    }), i.container && (this.container = i.container), i.hydrate && i.hydrate.length > 0) {
      if (!this.container) {
        const e = i.hydrate[0].parentElement;
        e != null && (this.container = e);
      }
      for (let e = 0; e < i.hydrate.length; e++) {
        const t = i.hydrate[e], n = t.getAttribute("data-hydrate");
        if (n === "font-face") {
          hydrate(this.fontFaceCache, FONT_FACE_HYDRATOR, t.textContent);
          continue;
        }
        if (n === "keyframes") {
          hydrate(this.keyframesCache, KEYFRAMES_HYRDATOR, t.textContent);
          continue;
        }
        const h = t.media ? t.media : "";
        this.styleElements[h] = t;
        const d = new Cache(g, E);
        d.key = h, hydrateStyles(d, STYLES_HYDRATOR, t.textContent), this.styleCache.sortedCacheKeys.push(h), this.styleCache.caches[h] = d;
      }
    }
    if (!this.container) {
      if (document.head === null)
        throw new Error("No container provided and `document.head` was null");
      this.container = document.head;
    }
  }
  renderStyle(i) {
    return injectStylePrefixed(this.styleCache, i, "", "");
  }
  renderFontFace(i) {
    const g = declarationsToBlock(i);
    return this.fontFaceCache.addValue(g, i);
  }
  renderKeyframes(i) {
    const g = keyframesToBlock(i);
    return this.keyframesCache.addValue(g, i);
  }
}
function findSheetIndexWithMedia(o, i) {
  let g = 0;
  for (; g < o.length; g++) {
    const E = o[g];
    if (E.tagName === "STYLE" && E.media === i)
      return g;
  }
  return -1;
}
const engine = new StyletronClient({
  prefix: "st-"
});
process.env.NODE_ENV === "development" && log.setLevel(log.levels.DEBUG);
const streamlitExecutionStartedAt = Date.now();
function StliteApp(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StliteKernelProvider, { kernel: o.kernel, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Provider$1, { value: engine, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedApp, { styleNonce: o.styleNonce, streamlitExecutionStartedAt, disableDocumentStyles: o.disableDocumentStyles }) }) });
}
function r(o) {
  var i, g, E = "";
  if (typeof o == "string" || typeof o == "number") E += o;
  else if (typeof o == "object") if (Array.isArray(o)) {
    var e = o.length;
    for (i = 0; i < e; i++) o[i] && (g = r(o[i])) && (E && (E += " "), E += g);
  } else for (g in o) o[g] && (E && (E += " "), E += g);
  return E;
}
function clsx() {
  for (var o, i, g = 0, E = "", e = arguments.length; g < e; g++) (o = arguments[g]) && (i = r(o)) && (E && (E += " "), E += i);
  return E;
}
function Mt(o) {
  if (typeof document > "u") return;
  let i = document.head || document.getElementsByTagName("head")[0], g = document.createElement("style");
  g.type = "text/css", i.firstChild ? i.insertBefore(g, i.firstChild) : i.appendChild(g), g.styleSheet ? g.styleSheet.cssText = o : g.appendChild(document.createTextNode(o));
}
Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var L = (o) => typeof o == "number" && !isNaN(o), N = (o) => typeof o == "string", P = (o) => typeof o == "function", mt = (o) => N(o) || L(o), B = (o) => N(o) || P(o) ? o : null, pt = (o, i) => o === !1 || L(o) && o > 0 ? o : i, z = (o) => isValidElement(o) || N(o) || P(o) || L(o);
function Z(o, i, g = 300) {
  let { scrollHeight: E, style: e } = o;
  requestAnimationFrame(() => {
    e.minHeight = "initial", e.height = E + "px", e.transition = `all ${g}ms`, requestAnimationFrame(() => {
      e.height = "0", e.padding = "0", e.margin = "0", setTimeout(i, g);
    });
  });
}
function $({ enter: o, exit: i, appendPosition: g = !1, collapse: E = !0, collapseDuration: e = 300 }) {
  return function({ children: t, position: n, preventExitTransition: h, done: d, nodeRef: k, isIn: p, playToast: M }) {
    let H = g ? `${o}--${n}` : o, f = g ? `${i}--${n}` : i, AA = useRef(0);
    return useLayoutEffect$1(() => {
      let gA = k.current, IA = H.split(" "), BA = (CA) => {
        CA.target === k.current && (M(), gA.removeEventListener("animationend", BA), gA.removeEventListener("animationcancel", BA), AA.current === 0 && CA.type !== "animationcancel" && gA.classList.remove(...IA));
      };
      gA.classList.add(...IA), gA.addEventListener("animationend", BA), gA.addEventListener("animationcancel", BA);
    }, []), useEffect(() => {
      let gA = k.current, IA = () => {
        gA.removeEventListener("animationend", IA), E ? Z(gA, d, e) : d();
      };
      p || (h ? IA() : (AA.current = 1, gA.className += ` ${f}`, gA.addEventListener("animationend", IA)));
    }, [p]), React__default.createElement(React__default.Fragment, null, t);
  };
}
function J(o, i) {
  return { content: tt(o.content, o.props), containerId: o.props.containerId, id: o.props.toastId, theme: o.props.theme, type: o.props.type, data: o.props.data || {}, isLoading: o.props.isLoading, icon: o.props.icon, reason: o.removalReason, status: i };
}
function tt(o, i, g = !1) {
  return isValidElement(o) && !N(o.type) ? cloneElement(o, { closeToast: i.closeToast, toastProps: i, data: i.data, isPaused: g }) : P(o) ? o({ closeToast: i.closeToast, toastProps: i, data: i.data, isPaused: g }) : o;
}
function yt({ closeToast: o, theme: i, ariaLabel: g = "close" }) {
  return React__default.createElement("button", { className: `Toastify__close-button Toastify__close-button--${i}`, type: "button", onClick: (E) => {
    E.stopPropagation(), o(!0);
  }, "aria-label": g }, React__default.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, React__default.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function gt({ delay: o, isRunning: i, closeToast: g, type: E = "default", hide: e, className: t, controlledProgress: n, progress: h, rtl: d, isIn: k, theme: p }) {
  let M = e || n && h === 0, H = { animationDuration: `${o}ms`, animationPlayState: i ? "running" : "paused" };
  n && (H.transform = `scaleX(${h})`);
  let f = clsx("Toastify__progress-bar", n ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${p}`, `Toastify__progress-bar--${E}`, { "Toastify__progress-bar--rtl": d }), AA = P(t) ? t({ rtl: d, type: E, defaultClassName: f }) : clsx(f, t), gA = { [n && h >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: n && h < 1 ? null : () => {
    k && g();
  } };
  return React__default.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": M }, React__default.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${p} Toastify__progress-bar--${E}` }), React__default.createElement("div", { role: "progressbar", "aria-hidden": M ? "true" : "false", "aria-label": "notification timer", className: AA, style: H, ...gA }));
}
var Xt = 1, at = () => `${Xt++}`;
function _t(o, i, g) {
  let E = 1, e = 0, t = [], n = [], h = i, d = /* @__PURE__ */ new Map(), k = /* @__PURE__ */ new Set(), p = (CA) => (k.add(CA), () => k.delete(CA)), M = () => {
    n = Array.from(d.values()), k.forEach((CA) => CA());
  }, H = ({ containerId: CA, toastId: QA, updateId: iA }) => {
    let EA = CA ? CA !== o : o !== 1, oA = d.has(QA) && iA == null;
    return EA || oA;
  }, f = (CA, QA) => {
    d.forEach((iA) => {
      var EA;
      (QA == null || QA === iA.props.toastId) && ((EA = iA.toggle) == null || EA.call(iA, CA));
    });
  }, AA = (CA) => {
    var QA, iA;
    (iA = (QA = CA.props) == null ? void 0 : QA.onClose) == null || iA.call(QA, CA.removalReason), CA.isActive = !1;
  }, gA = (CA) => {
    if (CA == null) d.forEach(AA);
    else {
      let QA = d.get(CA);
      QA && AA(QA);
    }
    M();
  }, IA = () => {
    e -= t.length, t = [];
  }, BA = (CA) => {
    var QA, iA;
    let { toastId: EA, updateId: oA } = CA.props, eA = oA == null;
    CA.staleId && d.delete(CA.staleId), CA.isActive = !0, d.set(EA, CA), M(), g(J(CA, eA ? "added" : "updated")), eA && ((iA = (QA = CA.props).onOpen) == null || iA.call(QA));
  };
  return { id: o, props: h, observe: p, toggle: f, removeToast: gA, toasts: d, clearQueue: IA, buildToast: (CA, QA) => {
    if (H(QA)) return;
    let { toastId: iA, updateId: EA, data: oA, staleId: eA, delay: GA } = QA, cA = EA == null;
    cA && e++;
    let tA = { ...h, style: h.toastStyle, key: E++, ...Object.fromEntries(Object.entries(QA).filter(([sA, DA]) => DA != null)), toastId: iA, updateId: EA, data: oA, isIn: !1, className: B(QA.className || h.toastClassName), progressClassName: B(QA.progressClassName || h.progressClassName), autoClose: QA.isLoading ? !1 : pt(QA.autoClose, h.autoClose), closeToast(sA) {
      d.get(iA).removalReason = sA, gA(iA);
    }, deleteToast() {
      let sA = d.get(iA);
      if (sA != null) {
        if (g(J(sA, "removed")), d.delete(iA), e--, e < 0 && (e = 0), t.length > 0) {
          BA(t.shift());
          return;
        }
        M();
      }
    } };
    tA.closeButton = h.closeButton, QA.closeButton === !1 || z(QA.closeButton) ? tA.closeButton = QA.closeButton : QA.closeButton === !0 && (tA.closeButton = z(h.closeButton) ? h.closeButton : !0);
    let aA = { content: CA, props: tA, staleId: eA };
    h.limit && h.limit > 0 && e > h.limit && cA ? t.push(aA) : L(GA) ? setTimeout(() => {
      BA(aA);
    }, GA) : BA(aA);
  }, setProps(CA) {
    h = CA;
  }, setToggle: (CA, QA) => {
    let iA = d.get(CA);
    iA && (iA.toggle = QA);
  }, isToastActive: (CA) => {
    var QA;
    return (QA = d.get(CA)) == null ? void 0 : QA.isActive;
  }, getSnapshot: () => n };
}
var I = /* @__PURE__ */ new Map(), F = [], st = /* @__PURE__ */ new Set(), Vt = (o) => st.forEach((i) => i(o)), bt = () => I.size > 0;
function Qt() {
  F.forEach((o) => nt(o.content, o.options)), F = [];
}
var vt = (o, { containerId: i }) => {
  var g;
  return (g = I.get(i || 1)) == null ? void 0 : g.toasts.get(o);
};
function X(o, i) {
  var g;
  if (i) return !!((g = I.get(i)) != null && g.isToastActive(o));
  let E = !1;
  return I.forEach((e) => {
    e.isToastActive(o) && (E = !0);
  }), E;
}
function ht(o) {
  if (!bt()) {
    F = F.filter((i) => o != null && i.options.toastId !== o);
    return;
  }
  if (o == null || mt(o)) I.forEach((i) => {
    i.removeToast(o);
  });
  else if (o && ("containerId" in o || "id" in o)) {
    let i = I.get(o.containerId);
    i ? i.removeToast(o.id) : I.forEach((g) => {
      g.removeToast(o.id);
    });
  }
}
var Ct = (o = {}) => {
  I.forEach((i) => {
    i.props.limit && (!o.containerId || i.id === o.containerId) && i.clearQueue();
  });
};
function nt(o, i) {
  z(o) && (bt() || F.push({ content: o, options: i }), I.forEach((g) => {
    g.buildToast(o, i);
  }));
}
function xt(o) {
  var i;
  (i = I.get(o.containerId || 1)) == null || i.setToggle(o.id, o.fn);
}
function rt(o, i) {
  I.forEach((g) => {
    (i == null || !(i != null && i.containerId) || i?.containerId === g.id) && g.toggle(o, i?.id);
  });
}
function Et(o) {
  let i = o.containerId || 1;
  return { subscribe(g) {
    let E = _t(i, o, Vt);
    I.set(i, E);
    let e = E.observe(g);
    return Qt(), () => {
      e(), I.delete(i);
    };
  }, setProps(g) {
    var E;
    (E = I.get(i)) == null || E.setProps(g);
  }, getSnapshot() {
    var g;
    return (g = I.get(i)) == null ? void 0 : g.getSnapshot();
  } };
}
function Pt(o) {
  return st.add(o), () => {
    st.delete(o);
  };
}
function Wt(o) {
  return o && (N(o.toastId) || L(o.toastId)) ? o.toastId : at();
}
function U(o, i) {
  return nt(o, i), i.toastId;
}
function V(o, i) {
  return { ...i, type: i && i.type || o, toastId: Wt(i) };
}
function Q(o) {
  return (i, g) => U(i, V(o, g));
}
function y(o, i) {
  return U(o, V("default", i));
}
y.loading = (o, i) => U(o, V("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...i }));
function Gt(o, { pending: i, error: g, success: E }, e) {
  let t;
  i && (t = N(i) ? y.loading(i, e) : y.loading(i.render, { ...e, ...i }));
  let n = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, h = (k, p, M) => {
    if (p == null) {
      y.dismiss(t);
      return;
    }
    let H = { type: k, ...n, ...e, data: M }, f = N(p) ? { render: p } : p;
    return t ? y.update(t, { ...H, ...f }) : y(f.render, { ...H, ...f }), M;
  }, d = P(o) ? o() : o;
  return d.then((k) => h("success", E, k)).catch((k) => h("error", g, k)), d;
}
y.promise = Gt;
y.success = Q("success");
y.info = Q("info");
y.error = Q("error");
y.warning = Q("warning");
y.warn = y.warning;
y.dark = (o, i) => U(o, V("default", { theme: "dark", ...i }));
function qt(o) {
  ht(o);
}
y.dismiss = qt;
y.clearWaitingQueue = Ct;
y.isActive = X;
y.update = (o, i = {}) => {
  let g = vt(o, i);
  if (g) {
    let { props: E, content: e } = g, t = { delay: 100, ...E, ...i, toastId: i.toastId || o, updateId: at() };
    t.toastId !== o && (t.staleId = o);
    let n = t.render || e;
    delete t.render, U(n, t);
  }
};
y.done = (o) => {
  y.update(o, { progress: 1 });
};
y.onChange = Pt;
y.play = (o) => rt(!0, o);
y.pause = (o) => rt(!1, o);
function It(o) {
  var i;
  let { subscribe: g, getSnapshot: E, setProps: e } = useRef(Et(o)).current;
  e(o);
  let t = (i = useSyncExternalStore(g, E, E)) == null ? void 0 : i.slice();
  function n(h) {
    if (!t) return [];
    let d = /* @__PURE__ */ new Map();
    return o.newestOnTop && t.reverse(), t.forEach((k) => {
      let { position: p } = k.props;
      d.has(p) || d.set(p, []), d.get(p).push(k);
    }), Array.from(d, (k) => h(k[0], k[1]));
  }
  return { getToastToRender: n, isToastActive: X, count: t?.length };
}
function At(o) {
  let [i, g] = useState(!1), [E, e] = useState(!1), t = useRef(null), n = useRef({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: h, pauseOnHover: d, closeToast: k, onClick: p, closeOnClick: M } = o;
  xt({ id: o.toastId, containerId: o.containerId, fn: g }), useEffect(() => {
    if (o.pauseOnFocusLoss) return H(), () => {
      f();
    };
  }, [o.pauseOnFocusLoss]);
  function H() {
    document.hasFocus() || BA(), window.addEventListener("focus", IA), window.addEventListener("blur", BA);
  }
  function f() {
    window.removeEventListener("focus", IA), window.removeEventListener("blur", BA);
  }
  function AA(eA) {
    if (o.draggable === !0 || o.draggable === eA.pointerType) {
      CA();
      let GA = t.current;
      n.canCloseOnClick = !0, n.canDrag = !0, GA.style.transition = "none", o.draggableDirection === "x" ? (n.start = eA.clientX, n.removalDistance = GA.offsetWidth * (o.draggablePercent / 100)) : (n.start = eA.clientY, n.removalDistance = GA.offsetHeight * (o.draggablePercent === 80 ? o.draggablePercent * 1.5 : o.draggablePercent) / 100);
    }
  }
  function gA(eA) {
    let { top: GA, bottom: cA, left: tA, right: aA } = t.current.getBoundingClientRect();
    eA.nativeEvent.type !== "touchend" && o.pauseOnHover && eA.clientX >= tA && eA.clientX <= aA && eA.clientY >= GA && eA.clientY <= cA ? BA() : IA();
  }
  function IA() {
    g(!0);
  }
  function BA() {
    g(!1);
  }
  function CA() {
    n.didMove = !1, document.addEventListener("pointermove", iA), document.addEventListener("pointerup", EA);
  }
  function QA() {
    document.removeEventListener("pointermove", iA), document.removeEventListener("pointerup", EA);
  }
  function iA(eA) {
    let GA = t.current;
    if (n.canDrag && GA) {
      n.didMove = !0, i && BA(), o.draggableDirection === "x" ? n.delta = eA.clientX - n.start : n.delta = eA.clientY - n.start, n.start !== eA.clientX && (n.canCloseOnClick = !1);
      let cA = o.draggableDirection === "x" ? `${n.delta}px, var(--y)` : `0, calc(${n.delta}px + var(--y))`;
      GA.style.transform = `translate3d(${cA},0)`, GA.style.opacity = `${1 - Math.abs(n.delta / n.removalDistance)}`;
    }
  }
  function EA() {
    QA();
    let eA = t.current;
    if (n.canDrag && n.didMove && eA) {
      if (n.canDrag = !1, Math.abs(n.delta) > n.removalDistance) {
        e(!0), o.closeToast(!0), o.collapseAll();
        return;
      }
      eA.style.transition = "transform 0.2s, opacity 0.2s", eA.style.removeProperty("transform"), eA.style.removeProperty("opacity");
    }
  }
  let oA = { onPointerDown: AA, onPointerUp: gA };
  return h && d && (oA.onMouseEnter = BA, o.stacked || (oA.onMouseLeave = IA)), M && (oA.onClick = (eA) => {
    p && p(eA), n.canCloseOnClick && k(!0);
  }), { playToast: IA, pauseToast: BA, isRunning: i, preventExitTransition: E, toastRef: t, eventHandlers: oA };
}
var Ot = typeof window < "u" ? useLayoutEffect$1 : useEffect, G = ({ theme: o, type: i, isLoading: g, ...E }) => React__default.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: o === "colored" ? "currentColor" : `var(--toastify-icon-color-${i})`, ...E });
function ao(o) {
  return React__default.createElement(G, { ...o }, React__default.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}
function so(o) {
  return React__default.createElement(G, { ...o }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}
function no(o) {
  return React__default.createElement(G, { ...o }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}
function ro(o) {
  return React__default.createElement(G, { ...o }, React__default.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}
function io() {
  return React__default.createElement("div", { className: "Toastify__spinner" });
}
var W = { info: so, warning: ao, success: no, error: ro, spinner: io }, lo = (o) => o in W;
function Nt({ theme: o, type: i, isLoading: g, icon: E }) {
  let e = null, t = { theme: o, type: i };
  return E === !1 || (P(E) ? e = E({ ...t, isLoading: g }) : isValidElement(E) ? e = cloneElement(E, t) : g ? e = W.spinner() : lo(i) && (e = W[i](t))), e;
}
var wt = (o) => {
  let { isRunning: i, preventExitTransition: g, toastRef: E, eventHandlers: e, playToast: t } = At(o), { closeButton: n, children: h, autoClose: d, onClick: k, type: p, hideProgressBar: M, closeToast: H, transition: f, position: AA, className: gA, style: IA, progressClassName: BA, updateId: CA, role: QA, progress: iA, rtl: EA, toastId: oA, deleteToast: eA, isIn: GA, isLoading: cA, closeOnClick: tA, theme: aA, ariaLabel: sA } = o, DA = clsx("Toastify__toast", `Toastify__toast-theme--${aA}`, `Toastify__toast--${p}`, { "Toastify__toast--rtl": EA }, { "Toastify__toast--close-on-click": tA }), rA = P(gA) ? gA({ rtl: EA, position: AA, type: p, defaultClassName: DA }) : clsx(DA, gA), nA = Nt(o), NA = !!iA || !d, pA = { closeToast: H, type: p, theme: aA }, mA = null;
  return n === !1 || (P(n) ? mA = n(pA) : isValidElement(n) ? mA = cloneElement(n, pA) : mA = yt(pA)), React__default.createElement(f, { isIn: GA, done: eA, position: AA, preventExitTransition: g, nodeRef: E, playToast: t }, React__default.createElement("div", { id: oA, tabIndex: 0, onClick: k, "data-in": GA, className: rA, ...e, style: IA, ref: E, ...GA && { role: QA, "aria-label": sA } }, nA != null && React__default.createElement("div", { className: clsx("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !cA }) }, nA), tt(h, o, !i), mA, !o.customProgressBar && React__default.createElement(gt, { ...CA && !NA ? { key: `p-${CA}` } : {}, rtl: EA, theme: aA, delay: d, isRunning: i, isIn: GA, closeToast: H, hide: M, type: p, className: BA, controlledProgress: NA, progress: iA || 0 })));
}, K = (o, i = !1) => ({ enter: `Toastify--animate Toastify__${o}-enter`, exit: `Toastify--animate Toastify__${o}-exit`, appendPosition: i }), lt = $(K("bounce", !0)), mo = $(K("slide", !0)), _o = { position: "top-right", transition: lt, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light", "aria-label": "Notifications Alt+T", hotKeys: (o) => o.altKey && o.code === "KeyT" };
function Lt(o) {
  let i = { ..._o, ...o }, g = o.stacked, [E, e] = useState(!0), t = useRef(null), { getToastToRender: n, isToastActive: h, count: d } = It(i), { className: k, style: p, rtl: M, containerId: H, hotKeys: f } = i;
  function AA(IA) {
    let BA = clsx("Toastify__toast-container", `Toastify__toast-container--${IA}`, { "Toastify__toast-container--rtl": M });
    return P(k) ? k({ position: IA, rtl: M, defaultClassName: BA }) : clsx(BA, B(k));
  }
  function gA() {
    g && (e(!0), y.play());
  }
  return Ot(() => {
    var IA;
    if (g) {
      let BA = t.current.querySelectorAll('[data-in="true"]'), CA = 12, QA = (IA = i.position) == null ? void 0 : IA.includes("top"), iA = 0, EA = 0;
      Array.from(BA).reverse().forEach((oA, eA) => {
        let GA = oA;
        GA.classList.add("Toastify__toast--stacked"), eA > 0 && (GA.dataset.collapsed = `${E}`), GA.dataset.pos || (GA.dataset.pos = QA ? "top" : "bot");
        let cA = iA * (E ? 0.2 : 1) + (E ? 0 : CA * eA);
        GA.style.setProperty("--y", `${QA ? cA : cA * -1}px`), GA.style.setProperty("--g", `${CA}`), GA.style.setProperty("--s", `${1 - (E ? EA : 0)}`), iA += GA.offsetHeight, EA += 0.025;
      });
    }
  }, [E, d, g]), useEffect(() => {
    function IA(BA) {
      var CA;
      let QA = t.current;
      f(BA) && ((CA = QA.querySelector('[tabIndex="0"]')) == null || CA.focus(), e(!1), y.pause()), BA.key === "Escape" && (document.activeElement === QA || QA != null && QA.contains(document.activeElement)) && (e(!0), y.play());
    }
    return document.addEventListener("keydown", IA), () => {
      document.removeEventListener("keydown", IA);
    };
  }, [f]), React__default.createElement("section", { ref: t, className: "Toastify", id: H, onMouseEnter: () => {
    g && (e(!1), y.pause());
  }, onMouseLeave: gA, "aria-live": "polite", "aria-atomic": "false", "aria-relevant": "additions text", "aria-label": i["aria-label"] }, n((IA, BA) => {
    let CA = BA.length ? { ...p } : { ...p, pointerEvents: "none" };
    return React__default.createElement("div", { tabIndex: -1, className: AA(IA), "data-stacked": g, style: CA, key: `c-${IA}` }, BA.map(({ content: QA, props: iA }) => React__default.createElement(wt, { ...iA, stacked: g, collapseAll: gA, isIn: h(iA.toastId, iA.containerId), key: `t-${iA.key}` }, QA)));
  }));
}
function ErrorToastContent(o) {
  const i = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
    width: "100%",
    padding: 0
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: i.message }),
    i.error && /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { style: {
      width: "100%",
      padding: 0,
      overflow: "scroll",
      maxHeight: 300
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("code", { style: {
      padding: "16px"
    }, children: i.error.message }) })
  ] });
}
function stliteStyledPromiseToast(o, i, g) {
  const E = i.error;
  return y.promise(o, {
    pending: i.pending,
    success: i.success,
    error: typeof E == "string" ? {
      render({
        data: e
      }) {
        return e ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorToastContent, { message: E, error: e }) : E;
      },
      autoClose: !1,
      closeOnClick: !1
    } : E
  }, {
    hideProgressBar: !0,
    position: "bottom-right",
    ...g
  });
}
function makeToastKernelEventListeners(o) {
  let i = null;
  const g = [];
  return {
    onLoadProgress: (f) => {
      const AA = y(f.detail, {
        position: "bottom-right",
        transition: mo,
        isLoading: !0,
        hideProgressBar: !0,
        closeButton: !1,
        containerId: o
      });
      g.push(AA), i && y.update(i, {
        isLoading: !1,
        autoClose: 3e3
      }), i = AA;
    },
    onLoadFinished: () => {
      g.forEach((f) => y.dismiss(f));
    },
    onLoadError: (f) => {
      y(/* @__PURE__ */ jsxRuntimeExports.jsx(ErrorToastContent, { message: "Error during booting up", error: f.detail }), {
        position: "bottom-right",
        type: "error",
        autoClose: !1,
        closeOnClick: !1,
        containerId: o
      });
    },
    onModuleAutoLoad: (f) => {
      const {
        promise: AA
      } = f.detail;
      stliteStyledPromiseToast(AA, {
        success: {
          render({
            data: gA
          }) {
            return `Auto-loaded${gA ? ": " + gA.map((IA) => IA.name).join(", ") : " packages"}`;
          }
        },
        error: "Failed to auto-load packages",
        pending: "Auto-loading packages"
      }, {
        containerId: o
      });
    },
    onInstall: (f) => {
      const {
        requirements: AA,
        promise: gA
      } = f.detail;
      stliteStyledPromiseToast(gA, {
        pending: "Installing",
        success: `Successfully installed: ${AA.join(", ")}`,
        error: `Failed to install: ${AA.join(", ")}`
      }, {
        containerId: o
      });
    },
    onWriteFile: (f) => {
      const {
        path: AA,
        promise: gA
      } = f.detail;
      stliteStyledPromiseToast(gA, {
        error: `Failed to write file: ${AA}`
      }, {
        containerId: o
      });
    },
    onRenameFile: (f) => {
      const {
        oldPath: AA,
        newPath: gA,
        promise: IA
      } = f.detail;
      stliteStyledPromiseToast(IA, {
        error: `Failed to rename file from ${AA} to ${gA}`
      }, {
        containerId: o
      });
    },
    onUnlink: (f) => {
      const {
        path: AA,
        promise: gA
      } = f.detail;
      stliteStyledPromiseToast(gA, {
        error: `Failed to unlink: ${AA}`
      }, {
        containerId: o
      });
    },
    onReadFile: (f) => {
      const {
        path: AA,
        promise: gA
      } = f.detail;
      stliteStyledPromiseToast(gA, {
        error: `Failed to read file: ${AA}`
      }, {
        containerId: o
      });
    },
    onReboot: (f) => {
      const {
        promise: AA
      } = f.detail;
      stliteStyledPromiseToast(AA, {
        pending: "Rebooting",
        success: "Successfully rebooted",
        error: "Failed to reboot"
      }, {
        containerId: o
      });
    }
  };
}
function isDarkTheme() {
  const o = getDefaultTheme().name;
  return o === AUTO_THEME_NAME ? window.matchMedia("(prefers-color-scheme: dark)").matches : o === darkTheme.name;
}
function ToastContainer({
  toastContainerId: o
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Lt, { containerId: o, style: {
    zIndex: 999999,
    position: "absolute",
    overflow: "hidden"
  }, theme: isDarkTheme() ? "dark" : "light" });
}
function StliteAppWithToast(o) {
  const {
    kernel: i,
    disableProgressToasts: g,
    disableErrorToasts: E,
    disableModuleAutoLoadToasts: e
  } = o, t = useId(), {
    onLoadProgress: n,
    onLoadFinished: h,
    onLoadError: d,
    onModuleAutoLoad: k,
    onInstall: p,
    onWriteFile: M,
    onRenameFile: H,
    onUnlink: f,
    onReadFile: AA,
    onReboot: gA
  } = useMemo$1(() => makeToastKernelEventListeners(t), [t]);
  return useEffect(() => {
    if (!g)
      return i.addEventListener("loadProgress", n), i.addEventListener("loadFinished", h), () => {
        i.removeEventListener("loadProgress", n), i.removeEventListener("loadFinished", h);
      };
  }, [i, g, n, h]), useEffect(() => {
    if (!E)
      return i.addEventListener("loadError", d), () => {
        i.removeEventListener("loadError", d);
      };
  }, [i, E, d]), useEffect(() => {
    if (!e)
      return i.addEventListener("moduleAutoLoad", k), () => {
        i.removeEventListener("moduleAutoLoad", k);
      };
  }, [i, e, k]), useEffect(() => (i.addEventListener("install", p), i.addEventListener("writeFile", M), i.addEventListener("renameFile", H), i.addEventListener("unlink", f), i.addEventListener("readFile", AA), i.addEventListener("reboot", gA), () => {
    i.removeEventListener("install", p), i.removeEventListener("writeFile", M), i.removeEventListener("renameFile", H), i.removeEventListener("unlink", f), i.removeEventListener("readFile", AA), i.removeEventListener("reboot", gA);
  }), [i, p, M, H, f, AA, gA]), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StliteApp, { kernel: i, styleNonce: o.styleNonce, disableDocumentStyles: o.disableDocumentStyles }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ToastContainer, { toastContainerId: t })
  ] });
}
class PromiseDelegate {
  promise;
  resolveInternal;
  rejectInternal;
  constructor() {
    this.promise = new Promise((i, g) => {
      this.resolveInternal = i, this.rejectInternal = g;
    });
  }
  resolve(i) {
    this.resolveInternal(i);
  }
  reject(i) {
    this.rejectInternal(i);
  }
}
const workerBlobUrlCache = /* @__PURE__ */ new Map();
function getWorkerBlobUrl(o, i = !1) {
  const g = o.toString(), E = `${i ? "module" : "classic"}:${g}`, e = workerBlobUrlCache.get(E);
  if (e)
    return console.debug(`Using a cached worker blob URL for ${g}`), e;
  const t = i ? `import "${g}";` : `importScripts("${g}");`, n = new Blob([t], {
    type: i ? "text/javascript;type=module" : "text/javascript"
  }), h = URL.createObjectURL(n);
  return workerBlobUrlCache.set(E, h), h;
}
function isOpaqueOrigin() {
  return window.location.protocol === "file:" || window.location.origin === "null";
}
function isSameOrigin(o) {
  return isOpaqueOrigin() ? !1 : o.origin === window.location.origin;
}
function createWorker(o, i, g) {
  return i ? isOpaqueOrigin() ? (console.warn("SharedWorker is not supported on opaque origins (e.g. file:// protocol). Falling back to a regular Worker."), new Worker(o, g)) : typeof window.SharedWorker < "u" ? (console.debug("Using SharedWorker. Visit chrome://inspect/#workers (Chrome) or about:debugging#/runtime/this-firefox (Firefox) to see the console output of the worker."), new SharedWorker(o, g)) : (console.warn("SharedWorker is not supported in this browser. Falling back to a regular Worker."), new Worker(o, g)) : new Worker(o, g);
}
class CrossOriginWorkerMaker {
  worker;
  constructor(i, {
    shared: g,
    ...E
  }) {
    if (isSameOrigin(i))
      console.debug(`Loading a worker script from the same origin: ${i}`), this.worker = createWorker(i, g, E);
    else {
      console.debug(`Loading a worker script via blob URL wrapper: ${i.protocol === "data:" ? "data: URL" : i}`);
      const t = getWorkerBlobUrl(i, E.type === "module");
      this.worker = createWorker(t, g, E);
    }
  }
}
const LEADING_AND_TRAILING_SLASH_RE = new RegExp("^\\/+|(?<!\\/)\\/+$", "g");
function normalizeBasePath(o) {
  return o.replace(LEADING_AND_TRAILING_SLASH_RE, "");
}
function isPyodideConvertiblePrimitive(o) {
  return typeof o == "string" || typeof o == "number" || typeof o == "boolean" || o === null || o === void 0;
}
function isStreamlitConfig(o) {
  return typeof o == "object" && o != null && Object.entries(o).every(([i, g]) => typeof i == "string" && isPyodideConvertiblePrimitive(g));
}
function assertStreamlitConfig(o) {
  if (!isStreamlitConfig(o))
    throw new Error(`Invalid streamlitConfig: ${o}`);
}
const validateEnvKey = (o) => /^[A-Za-z_][A-Za-z0-9_]*$/.test(o);
function isSharedWorker(o) {
  return typeof window.SharedWorker < "u" && o instanceof SharedWorker;
}
class StliteKernel extends EventTarget {
  /**
   * Made public for advanced use cases as an unstable API.
   * You can use it but there is no stability guarantee for future releases.
   */
  _worker;
  _isDisposed = !1;
  _postMessageTarget;
  _loaded = new PromiseDelegate();
  _workerInitData;
  basePath;
  // TODO: Move this prop to outside this class. This is not a member of the kernel business logic, but just a globally referred value.
  hostConfigProperties;
  // Will be passed to ConnectionManager to call `onHostConfigResp` from it.
  addEventListener(i, g, E) {
    super.addEventListener(i, g, E);
  }
  removeEventListener(i, g, E) {
    super.removeEventListener(i, g, E);
  }
  dispatchEvent(i) {
    return super.dispatchEvent(i);
  }
  constructor(i) {
    if (super(), this.basePath = normalizeBasePath(i.basePath ?? window.location.pathname), this.hostConfigProperties = i.hostConfigProperties ?? {}, i.worker)
      this._worker = i.worker;
    else {
      const g = new CrossOriginWorkerMaker(new URL(
        /* @vite-ignore */
        "" + new URL("assets/worker-DAN7Os1o.js", import.meta.url).href,
        import.meta.url
      ), {
        /* @vite-ignore */
        // To avoid the Vite error: "[vite:worker-import-meta-url] Vite is unable to parse the worker options as the value is not static.To ignore this error, please use /* @vite-ignore */ in the worker options."
        type: i.workerType,
        shared: i.sharedWorker ?? !1
      });
      this._worker = g.worker;
    }
    isSharedWorker(this._worker) ? (this._worker.port.start(), this._postMessageTarget = this._worker.port) : this._postMessageTarget = this._worker, this._postMessageTarget.onmessage = (g) => {
      this._processWorkerMessage(g.data, g.ports[0]);
    }, i.streamlitConfig != null && assertStreamlitConfig(i.streamlitConfig), this._workerInitData = {
      entrypoint: i.entrypoint,
      files: i.files,
      archives: i.archives,
      requirements: i.requirements,
      prebuiltPackageNames: i.prebuiltPackageNames,
      pyodideUrl: i.pyodideUrl,
      wheels: i.wheelUrls,
      streamlitConfig: i.streamlitConfig,
      idbfsMountpoints: i.idbfsMountpoints,
      moduleAutoLoad: i.moduleAutoLoad ?? !1,
      env: i.env,
      languageServer: i.languageServer ?? !1
    };
  }
  get loaded() {
    return this._loaded.promise;
  }
  connectWebSocket(i) {
    return this._asyncPostMessage({
      type: "websocket:connect",
      data: {
        path: i
      }
    }).then();
  }
  sendWebSocketMessage(i) {
    return this._asyncPostMessage({
      type: "websocket:send",
      data: {
        payload: i
      }
    }).then();
  }
  handleWebSocketMessage = null;
  onWebSocketMessage(i) {
    this.handleWebSocketMessage = i;
  }
  sendHttpRequest(i, g) {
    return this._asyncPostMessage({
      type: "http:request",
      data: {
        request: i
      }
    }, "http:response", g).then((E) => ({
      ...E.response,
      headers: new Headers(Object.fromEntries(E.response.headers))
    }));
  }
  async writeFile(i, g, E) {
    await this.loaded;
    const e = this._asyncPostMessage({
      type: "file:write",
      data: {
        path: i,
        data: g,
        opts: E
      }
    });
    this.dispatchEvent(new CustomEvent("writeFile", {
      detail: {
        path: i,
        promise: e
      }
    })), await e;
  }
  async renameFile(i, g) {
    await this.loaded;
    const E = this._asyncPostMessage({
      type: "file:rename",
      data: {
        oldPath: i,
        newPath: g
      }
    });
    this.dispatchEvent(new CustomEvent("renameFile", {
      detail: {
        oldPath: i,
        newPath: g,
        promise: E
      }
    })), await E;
  }
  async readFile(i, g) {
    await this.loaded;
    const E = this._asyncPostMessage({
      type: "file:read",
      data: {
        path: i,
        opts: g
      }
    }, "reply:file:read").then((e) => e.content);
    return this.dispatchEvent(new CustomEvent("readFile", {
      detail: {
        path: i,
        promise: E
      }
    })), E;
  }
  async unlink(i) {
    await this.loaded, await this._asyncPostMessage({
      type: "file:unlink",
      data: {
        path: i
      }
    });
  }
  async install(i, g) {
    await this.loaded;
    const E = this._asyncPostMessage({
      type: "install",
      data: {
        requirements: i,
        options: g
      }
    });
    this.dispatchEvent(new CustomEvent("install", {
      detail: {
        requirements: i,
        promise: E
      }
    })), await E;
  }
  async addMockPackage(i, g, E, e) {
    await this.loaded, await this._asyncPostMessage({
      type: "add_mock_package",
      data: {
        name: i,
        version: g,
        modules: E,
        persistent: e
      }
    });
  }
  async setEnv(i) {
    Object.keys(i).forEach((g) => {
      if (!validateEnvKey(g))
        throw new Error(`Invalid environment variable name: "${g}"`);
    }), await this.loaded, await this._asyncPostMessage({
      type: "setEnv",
      data: {
        env: i
      }
    });
  }
  async getCodeCompletion(i, g) {
    if (!this._workerInitData.languageServer)
      throw new Error("Language server not loaded, please set languageServer=true to use this method");
    return await this.loaded, this._asyncPostMessage({
      type: "code_completion",
      data: {
        code: i,
        line: g.line,
        column: g.column
      }
    }, "reply:code_completion").then((E) => E.codeCompletions);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async runPython(i) {
    return await this.loaded, this.loaded.then(() => this._asyncPostMessage({
      type: "run_python",
      data: {
        code: i
      }
    }, "reply:run_python")).then((g) => g.result);
  }
  /**
   * Reboot the Streamlit server.
   * Note that we also need to refresh (rerender) the frontend app after calling this method
   * to reflect the changes on the user-facing side.
   */
  async reboot(i) {
    await this.loaded, await this._asyncPostMessage({
      type: "reboot",
      data: {
        entrypoint: i
      }
    });
  }
  _asyncPostMessage(i, g, E) {
    let e = "reply", t;
    return typeof g == "string" ? (e = g, t = E) : g && (t = g), t && t.aborted ? Promise.reject(new DOMException("Aborted", "AbortError")) : new Promise((n, h) => {
      const d = new MessageChannel(), k = () => {
        d.port1.close(), h(new DOMException("Aborted", "AbortError"));
      };
      t && t.addEventListener("abort", k, {
        once: !0
      }), d.port1.onmessage = (p) => {
        t && t.removeEventListener("abort", k), d.port1.close();
        const M = p.data;
        if (M.error)
          h(M.error);
        else {
          if (M.type !== e)
            throw new Error(`Unexpected reply type "${M.type}"`);
          n(M.data);
        }
      }, this._postMessageTarget.postMessage(i, [d.port2]);
    });
  }
  /**
   * Process a message coming from the pyodide web worker.
   *
   * @param msg The worker message to process.
   */
  _processWorkerMessage(i, g) {
    switch (i.type) {
      case "event:envSetup": {
        this._postMessageTarget.postMessage({
          type: "initData",
          data: this._workerInitData
        });
        break;
      }
      case "event:loadProgress": {
        this.dispatchEvent(new CustomEvent("loadProgress", {
          detail: i.data.message
        }));
        break;
      }
      case "event:loadError": {
        this.dispatchEvent(new CustomEvent("loadError", {
          detail: i.data.error
        }));
        break;
      }
      case "event:loadFinished": {
        this._loaded.resolve(), this.dispatchEvent(new Event("loadFinished"));
        break;
      }
      case "websocket:message": {
        const {
          payload: E
        } = i.data;
        this.handleWebSocketMessage?.(E);
        break;
      }
      case "event:moduleAutoLoad": {
        if (g == null)
          throw new Error("Port is required for moduleAutoLoad event");
        const E = new Promise((e, t) => {
          g.onmessage = (n) => {
            const h = n.data;
            h.type === "moduleAutoLoad:success" ? e(h.data.loadedPackages) : t(h.error), g.close();
          };
        });
        this.dispatchEvent(new CustomEvent("moduleAutoLoad", {
          detail: {
            packagesToLoad: i.data.packagesToLoad,
            promise: E
          }
        }));
        break;
      }
    }
  }
  /**
   * Return whether the kernel is disposed.
   */
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Dispose the kernel.
   */
  dispose() {
    this.isDisposed || (isSharedWorker(this._worker) ? this._worker.port.close() : this._worker.terminate(), this._isDisposed = !0);
  }
}
function createKernel(o) {
  return new StliteKernel({
    ...o,
    workerType: o.workerType ?? "module"
    // Default value is "module" because Vite loads the worker scripts as ES modules without bundling at dev time, so we need to specify the type as "module" for the "import" statements in the worker script to work.
  });
}
function useKernel(o) {
  const [i, g] = useState(null);
  return useEffect(() => {
    const E = createKernel(o);
    return g(E), () => {
      E.dispose();
    };
  }, []), i;
}
export {
  keyframes as $,
  ADJOINED as A,
  BaseButtonKind as B,
  Checkbox$1 as C,
  DynamicButtonLabel as D,
  EmotionIconBase as E,
  toString$3 as F,
  findAndReplace as G,
  Arrow$2 as H,
  range$1 as I,
  isNumericType as J,
  DataFrameCellType as K,
  useStliteMediaObjectUrl as L,
  useCrossOriginAttribute as M,
  loglevelExports$1 as N,
  useStliteMediaObjects as O,
  Placement as P,
  useRequiredContext as Q,
  NavigationContext as R,
  StreamlitConfig as S,
  TooltipIcon as T,
  UISelectbox as U,
  DynamicIcon as V,
  toaster as W,
  AlertElement$1 as X,
  Kind as Y,
  Video$1 as Z,
  _extends$C as _,
  Box as a,
  StyledValueContainer as a$,
  StyledWidgetInstructions as a0,
  isFromMac as a1,
  FormsContext as a2,
  StyledFormSubmitContent as a3,
  Form$1 as a4,
  isInForm as a5,
  convertRemToPx as a6,
  WidgetLabel as a7,
  WidgetLabelHelpIcon as a8,
  isMaterialIcon as a9,
  html$2 as aA,
  svg as aB,
  useCopyToClipboard as aC,
  Popover$2 as aD,
  ACCESSIBILITY_TYPE as aE,
  ensureError as aF,
  ErrorElement as aG,
  hexToRgb as aH,
  withWrapper as aI,
  blend as aJ,
  Metric$1 as aK,
  transparentize as aL,
  StyledWidgetLabel as aM,
  Global as aN,
  getCrossOriginAttribute as aO,
  ViewStateContext as aP,
  useWindowDimensionsContext as aQ,
  LocaleContext as aR,
  shouldWidthStretch as aS,
  ButtonGroup$1 as aT,
  StyledButtonGroup as aU,
  LabelVisibilityMessage as aV,
  SetCache as aW,
  cacheHas as aX,
  baseRest as aY,
  isArrayLikeObject as aZ,
  useSelectCommon as a_,
  getBorderColor as aa,
  TextInput$1 as ab,
  getDefaultExportFromCjs as ac,
  darken as ad,
  PortalContext as ae,
  LibConfigContext as af,
  classNames as ag,
  styled as ah,
  isFocusVisible as ai,
  getOverride as aj,
  getOverrideProps as ak,
  mergeOverrides as al,
  CUSTOM_INPUT_TYPE as am,
  ChevronDown$1 as an,
  PLACEMENT$1 as ao,
  Tooltip$1 as ap,
  Icon$2 as aq,
  IsSidebarContext as ar,
  useStliteKernel as as,
  DownloadContext as at,
  StyledErrorMessage as au,
  LabelVisibilityOptions as av,
  find$1 as aw,
  parse$1 as ax,
  parse$2 as ay,
  normalize$1 as az,
  BaseButtonTooltip as b,
  util_vector_ as b$,
  Select as b0,
  VirtualDropdown as b1,
  TYPE as b2,
  NumberInput$1 as b3,
  useStyletron as b4,
  mergeOverride as b5,
  toObjectOverride as b6,
  Icon$1 as b7,
  DeleteAlt$1 as b8,
  forkBlur as b9,
  merge$1 as bA,
  getIncreasingGreen as bB,
  getDecreasingRed as bC,
  getBlue80 as bD,
  getGray30 as bE,
  getGray70 as bF,
  getGray90 as bG,
  keysToSnakeCase as bH,
  PlotlyChart$1 as bI,
  themeColors as bJ,
  isMobile as bK,
  UploadedFileInfo as bL,
  FileUploaderState as bM,
  ThemeContext$1 as bN,
  useExecuteWhenChanged as bO,
  arrayComparator as bP,
  pick$1 as bQ,
  Slider$1 as bR,
  zip$1 as bS,
  baseSlice as bT,
  baseToString as bU,
  trimmedEndIndex as bV,
  util_bn_ as bW,
  util_int_ as bX,
  util_bit_ as bY,
  util_math_ as bZ,
  util_buffer_ as b_,
  forkFocus as ba,
  addCssUnit as bb,
  convert as bc,
  visitParents as bd,
  SKIP as be,
  isDatetimeType as bf,
  isDateType as bg,
  getTimezone as bh,
  debounce$2 as bi,
  isEqual$1 as bj,
  shouldHeightStretch as bk,
  toPropertyKey$2 as bl,
  _setPrototypeOf$e as bm,
  _typeof$g as bn,
  _assertThisInitialized$1 as bo,
  toExportedTheme as bp,
  ArrowDataframe as bq,
  useTimeout as br,
  Skeleton as bs,
  Skeleton$1 as bt,
  CustomComponentIFrame as bu,
  ComponentRegistry as bv,
  __awaiter as bw,
  PropTypes as bx,
  isFromWindows as by,
  requirePropTypes as bz,
  BaseButton as c,
  DECLARATION as c$,
  util_pretty_ as c0,
  util_interval_ as c1,
  compareTypes as c2,
  compareFields as c3,
  compareSchemas as c4,
  getAugmentedNamespace as c5,
  isStringType as c6,
  isTimeType as c7,
  isPeriodType as c8,
  isIntervalType as c9,
  pointEnd as cA,
  structuredClone$1 as cB,
  commonjsGlobal$1 as cC,
  _defineProperty$u as cD,
  filterOptions as cE,
  isArrayLike as cF,
  isArray$1 as cG,
  isBuffer as cH,
  isTypedArray as cI,
  isArguments as cJ,
  getTag as cK,
  isPrototype as cL,
  baseKeys as cM,
  requireClassnames as cN,
  Vector as cO,
  getLuminance as cP,
  _objectWithoutProperties$1 as cQ,
  stringify$2 as cR,
  rulesheet as cS,
  COMMENT as cT,
  middleware as cU,
  RULESET as cV,
  combine as cW,
  KEYFRAMES as cX,
  serialize$2 as cY,
  copy as cZ,
  replace$1 as c_,
  isDurationType as ca,
  isDecimalType as cb,
  isFloatType as cc,
  isObjectType as cd,
  isListType as ce,
  TimeUnit as cf,
  Struct as cg,
  ThemeProvider$1 as ch,
  createThemedStyled as ci,
  createThemedUseStyletron as cj,
  createThemedWithStyle as ck,
  expandBorderStyles as cl,
  withStyle as cm,
  requireReactIs$1 as cn,
  tableFromIPC as co,
  assertNever as cp,
  v4 as cq,
  AcceptFileValue as cr,
  chatInputAcceptFileProtoValueToEnum as cs,
  requireBrowser as ct,
  UIDConsumer as cu,
  StatefulMenu as cv,
  ok as cw,
  stringify$1 as cx,
  stringify as cy,
  pointStart as cz,
  BaseButtonSize as d,
  dealloc as d0,
  alloc as d1,
  hash$1 as d2,
  charat as d3,
  WEBKIT as d4,
  MS as d5,
  strlen as d6,
  indexof as d7,
  MOZ as d8,
  match as d9,
  mergeWith as dA,
  lighten as dB,
  mix$1 as dC,
  TRIGGER_TYPE as dD,
  StyledTooltipContentWrapper as dE,
  FlexContext as dF,
  useScrollbarGutterSize as dG,
  Resizable as dH,
  StatefulPopover as dI,
  parseEntities as dJ,
  StyledCodeBlock as dK,
  StyledPre as dL,
  StyledCopyButtonContainer as dM,
  CopyButton$1 as dN,
  propTypesExports as dO,
  index as dP,
  parseToRgba as dQ,
  DeckGlJsonChart$1 as dR,
  StliteApp as dS,
  StliteAppWithToast as dT,
  createKernel as dU,
  useKernel as dV,
  next as da,
  token as db,
  from as dc,
  peek$1 as dd,
  delimit as de,
  slice as df,
  position$3 as dg,
  compile as dh,
  getRegisteredStyles as di,
  serializeStyles as dj,
  registerStyles as dk,
  insertStyles as dl,
  parseIconPackEntry as dm,
  genericFonts as dn,
  getMarkdownBgColors as dp,
  isUnsignedIntegerType as dq,
  isIntegerType as dr,
  isBooleanType as ds,
  Field as dt,
  Null as du,
  isRangeIndexType as dv,
  isEmptyType as dw,
  isBytesType as dx,
  isCategoricalType as dy,
  fontSizes as dz,
  isNullOrUndefined as e,
  StyledWidgetLabelHelpInline as f,
  getHelpTooltipAriaLabel as g,
  hoistNonReactStatics as h,
  isValidFormId as i,
  jsxRuntimeExports as j,
  useCalculatedDimensions as k,
  useEmotionTheme as l,
  hasLightBackgroundColor as m,
  notNullOrUndefined as n,
  StyledCheckbox$1 as o,
  StyledContent as p,
  labelVisibilityProtoValueToEnum as q,
  StreamlitMarkdown$1 as r,
  streamlit as s,
  getOverrides as t,
  useRegisterShortcut as u,
  SIZE$1 as v,
  ENHANCER_POSITION as w,
  createStyled as x,
  isPropValid as y,
  StyledDropdownListItem as z
};
//# sourceMappingURL=index-CPTOd3M-.js.map
